webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(1);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _common = __webpack_require__(4);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _components = __webpack_require__(253);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _app = __webpack_require__(705);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(25);
	
	__webpack_require__(276);
	
	__webpack_require__(712);
	
	__webpack_require__(483);
	
	__webpack_require__(714);
	
	__webpack_require__(716);
	
	__webpack_require__(717);
	
	__webpack_require__(496);
	
	__webpack_require__(718);
	
	__webpack_require__(719);
	
	__webpack_require__(720);
	
	__webpack_require__(721);
	
	__webpack_require__(485);
	
	__webpack_require__(722);
	
	var _services = __webpack_require__(723);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _filters = __webpack_require__(733);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _directives = __webpack_require__(734);
	
	var _directives2 = _interopRequireDefault(_directives);
	
	var _angulartics = __webpack_require__(735);
	
	var _angulartics2 = _interopRequireDefault(_angulartics);
	
	var _angularticsGoogleAnalytics = __webpack_require__(737);
	
	var _angularticsGoogleAnalytics2 = _interopRequireDefault(_angularticsGoogleAnalytics);
	
	var _configFile = __webpack_require__(29);
	
	var _configFile2 = _interopRequireDefault(_configFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module("app", [_angularUiRouter2.default, "angulartics", _angularticsGoogleAnalytics2.default, "datetime", "ngStorage", "ngCookies", "ngAnimate", "ngImageCompress", "ngSanitize", "localytics.directives", "ngFileUpload", "siyfion.sfTypeahead", "angular-screenshot", "ngMap", "infinite-scroll", "ngProgress", "base64", "ngCsv", "file-model", _common2.default.name, _components2.default.name, _services2.default.name, _filters2.default.name, _directives2.default.name, "myApp.config"]).config(function ($locationProvider, $httpProvider, $stateProvider, $injector, waf_silent_challenge_js_sdk_enabled) {
	  "ngInject";
	
	  $httpProvider.interceptors.push(function ($q) {
	    return {
	      request: function request(config) {
	        if (config.method === "PUT") {
	          if (config.url.indexOf("/events/") > -1) {
	            config.data.subEvents = undefined;
	            config.data.startTimeFormatted = undefined;
	            config.data.endTimeFormatted = undefined;
	            config.data.eventTypeId = undefined;
	            config.data.eventTypeName = undefined;
	            config.data.companyId = undefined;
	            config.data.companyName = undefined;
	            config.data.companyDescription = undefined;
	            config.data.companyIndustryTypeName = undefined;
	            config.data.cost = undefined;
	            config.data.numberOfOpenings = undefined;
	            config.data.totalNumberOfJobbles = undefined;
	            config.data.totalNumberOfApplications = undefined;
	            config.data.numberOfApprovedApplications = undefined;
	            config.data.numberOfPendingApplications = undefined;
	            config.data.numberOfRejectedApplications = undefined;
	            config.data.numberOfSubEvents = undefined;
	            config.data.payPerHourRounded = undefined;
	          } else if (config.url.indexOf("/subevents/") > -1) {
	            config.data.eventId = undefined;
	            config.data.eventName = undefined;
	            config.data.eventTypeName = undefined;
	            config.data.startTime = undefined;
	            config.data.endTime = undefined;
	            config.data.nonDuplicatedJobbles = undefined;
	            config.data.applications = undefined;
	            config.data.numberOfOpenings = undefined;
	            config.data.totalNumberOfJobbles = undefined;
	            config.data.totalNumberOfApplications = undefined;
	            config.data.numberOfApprovedApplications = undefined;
	            config.data.numberOfPendingApplications = undefined;
	            config.data.numberOfRejectedApplications = undefined;
	          } else if (config.url.indexOf("/users/") > -1) {
	            if (config.data.company) {
	              config.data.company.files = undefined;
	            }
	            config.data.files = undefined;
	            config.data.roles = undefined;
	          }
	        }
	
	        return config;
	      },
	
	      response: function response(_response) {
	        if (_response.status === 401) {
	          console.log("do we get a 401?");
	          console.dir(401);
	          window.location = "/signin";
	        }
	        return _response;
	      }
	    };
	  });
	
	  if (window.origin) {
	    if (window.origin.indexOf("dev2.int") > -1 || window.origin.indexOf("localhost") > -1) {} else {
	      $httpProvider.defaults.withCredentials = true;
	    }
	  } else if (window.location.origin) {
	    if (window.location.origin.indexOf("dev2.int") > -1 || window.location.origin.indexOf("localhost") > -1) {} else {
	      $httpProvider.defaults.withCredentials = true;
	    }
	  }
	
	  $httpProvider.interceptors.push(function ($q) {
	    return {
	      request: function request(_request) {
	        if (!waf_silent_challenge_js_sdk_enabled) {
	          return _request;
	        }
	
	        return window.AwsWafIntegration.getToken().then(function (token) {
	          _request.headers['x-aws-waf-token'] = token;
	          return _request;
	        }).catch(function (error) {
	          return _request;
	        });
	      },
	      response: function response(_response2) {
	        return _response2;
	      }
	    };
	  });
	
	  //@see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	  // #how-to-configure-your-server-to-work-with-html5mode
	  $locationProvider.html5Mode(true).hashPrefix("!");
	}).run(function ($rootScope, $state) {
	  "ngInject";
	
	  $rootScope.$on("$stateChangeSuccess", function (event, toState, toParams, fromState, fromParams) {
	    var title = $state.current.title ? " - " + $state.current.title : "";
	    document.title = "Jobble" + title;
	  });
	}).component("app", _app2.default);

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navbar = __webpack_require__(5);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _hero = __webpack_require__(13);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _user = __webpack_require__(19);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _jobblefooter = __webpack_require__(21);
	
	var _jobblefooter2 = _interopRequireDefault(_jobblefooter);
	
	var _jobbleheader = __webpack_require__(33);
	
	var _jobbleheader2 = _interopRequireDefault(_jobbleheader);
	
	var _eventaddopenings = __webpack_require__(39);
	
	var _eventaddopenings2 = _interopRequireDefault(_eventaddopenings);
	
	var _eventsidebar = __webpack_require__(45);
	
	var _eventsidebar2 = _interopRequireDefault(_eventsidebar);
	
	var _eventdropdownsidebar = __webpack_require__(52);
	
	var _eventdropdownsidebar2 = _interopRequireDefault(_eventdropdownsidebar);
	
	var _adminsidebar = __webpack_require__(58);
	
	var _adminsidebar2 = _interopRequireDefault(_adminsidebar);
	
	var _eventtab = __webpack_require__(64);
	
	var _eventtab2 = _interopRequireDefault(_eventtab);
	
	var _loader = __webpack_require__(70);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _jobsdropdown = __webpack_require__(76);
	
	var _jobsdropdown2 = _interopRequireDefault(_jobsdropdown);
	
	var _pbjobsdropdown = __webpack_require__(82);
	
	var _pbjobsdropdown2 = _interopRequireDefault(_pbjobsdropdown);
	
	var _pjjobsdropdown = __webpack_require__(86);
	
	var _pjjobsdropdown2 = _interopRequireDefault(_pjjobsdropdown);
	
	var _track = __webpack_require__(90);
	
	var _track2 = _interopRequireDefault(_track);
	
	var _sorry = __webpack_require__(96);
	
	var _sorry2 = _interopRequireDefault(_sorry);
	
	var _verification = __webpack_require__(102);
	
	var _verification2 = _interopRequireDefault(_verification);
	
	var _jobblerprofile = __webpack_require__(108);
	
	var _jobblerprofile2 = _interopRequireDefault(_jobblerprofile);
	
	var _eventdialog = __webpack_require__(116);
	
	var _eventdialog2 = _interopRequireDefault(_eventdialog);
	
	var _paymentdialog = __webpack_require__(122);
	
	var _paymentdialog2 = _interopRequireDefault(_paymentdialog);
	
	var _questionnaire = __webpack_require__(131);
	
	var _questionnaire2 = _interopRequireDefault(_questionnaire);
	
	var _globalalert = __webpack_require__(137);
	
	var _globalalert2 = _interopRequireDefault(_globalalert);
	
	var _jobcontact = __webpack_require__(143);
	
	var _jobcontact2 = _interopRequireDefault(_jobcontact);
	
	var _googleplaces = __webpack_require__(149);
	
	var _googleplaces2 = _interopRequireDefault(_googleplaces);
	
	var _jobdetailssignup = __webpack_require__(155);
	
	var _jobdetailssignup2 = _interopRequireDefault(_jobdetailssignup);
	
	var _globalmodal = __webpack_require__(162);
	
	var _globalmodal2 = _interopRequireDefault(_globalmodal);
	
	var _applyProfileModal = __webpack_require__(168);
	
	var _applyProfileModal2 = _interopRequireDefault(_applyProfileModal);
	
	var _sendmessage = __webpack_require__(174);
	
	var _sendmessage2 = _interopRequireDefault(_sendmessage);
	
	var _messaginggallery = __webpack_require__(180);
	
	var _messaginggallery2 = _interopRequireDefault(_messaginggallery);
	
	var _jobsearch = __webpack_require__(186);
	
	var _jobsearch2 = _interopRequireDefault(_jobsearch);
	
	var _postingdropdown = __webpack_require__(192);
	
	var _postingdropdown2 = _interopRequireDefault(_postingdropdown);
	
	var _pbpostingdropdown = __webpack_require__(198);
	
	var _pbpostingdropdown2 = _interopRequireDefault(_pbpostingdropdown);
	
	var _pjpostingdropdown = __webpack_require__(202);
	
	var _pjpostingdropdown2 = _interopRequireDefault(_pjpostingdropdown);
	
	var _leftnavigation = __webpack_require__(206);
	
	var _leftnavigation2 = _interopRequireDefault(_leftnavigation);
	
	var _etamap = __webpack_require__(212);
	
	var _etamap2 = _interopRequireDefault(_etamap);
	
	var _branchioshare = __webpack_require__(218);
	
	var _branchioshare2 = _interopRequireDefault(_branchioshare);
	
	var _pbheader = __webpack_require__(224);
	
	var _pbheader2 = _interopRequireDefault(_pbheader);
	
	var _pjheader = __webpack_require__(230);
	
	var _pjheader2 = _interopRequireDefault(_pjheader);
	
	var _jobdescription = __webpack_require__(236);
	
	var _jobdescription2 = _interopRequireDefault(_jobdescription);
	
	var _jobsearchcard = __webpack_require__(242);
	
	var _jobsearchcard2 = _interopRequireDefault(_jobsearchcard);
	
	var _pajtooltip = __webpack_require__(248);
	
	var _pajtooltip2 = _interopRequireDefault(_pajtooltip);
	
	__webpack_require__(252);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonModule = _angular2.default.module("app.common", [_navbar2.default.name, _hero2.default.name, _user2.default.name, _jobblefooter2.default.name, _googleplaces2.default.name, _jobsdropdown2.default.name, _pbjobsdropdown2.default.name, _pjjobsdropdown2.default.name, _jobbleheader2.default.name, _eventaddopenings2.default.name, _eventsidebar2.default.name, _postingdropdown2.default.name, _pbpostingdropdown2.default.name, _pjpostingdropdown2.default.name, _leftnavigation2.default.name, _jobdetailssignup2.default.name, _verification2.default.name, _eventdropdownsidebar2.default.name, _adminsidebar2.default.name, _eventtab2.default.name, _branchioshare2.default.name, _jobcontact2.default.name, _jobsearch2.default.name, _sendmessage2.default.name, _track2.default.name, _sorry2.default.name, _loader2.default.name, _jobblerprofile2.default.name, _applyProfileModal2.default.name, _eventdialog2.default.name, _paymentdialog2.default.name, _questionnaire2.default.name, _globalalert2.default.name, _globalmodal2.default.name, _messaginggallery2.default.name, _etamap2.default.name, _pbheader2.default.name, _pjheader2.default.name, _jobdescription2.default.name, _jobsearchcard2.default.name, _pajtooltip2.default.name]);
	
	exports.default = commonModule;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _navbar = __webpack_require__(6);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarModule = _angular2.default.module("navbar", [_angularUiRouter2.default]).component("navbar", _navbar2.default);
	
	exports.default = navbarModule;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _navbar = __webpack_require__(7);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _navbar3 = __webpack_require__(8);
	
	var _navbar4 = _interopRequireDefault(_navbar3);
	
	__webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _navbar2.default,
	  controller: _navbar4.default,
	  controllerAs: "vm"
	};
	
	exports.default = navbarComponent;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = "<nav class=\"navbar\">\n  <div class=\"logo\">\n    <h1><a ui-sref=\"home\">{{ vm.name }}</a></h1>\n  </div>\n  <div class=\"nav-links\">\n    <span><a ui-sref=\"about\">about</a></span>\n  </div>\n</nav>\n"

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavbarController = function NavbarController() {
	  _classCallCheck(this, NavbarController);
	
	  this.name = "navbar";
	};
	
	exports.default = NavbarController;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(10);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./navbar.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./navbar.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%}.navbar{height:6.5rem;background-color:#0277bd;padding:1rem}.navbar .logo,.navbar .nav-links{display:inline-block}.navbar .logo{color:#f5f5f5;margin-right:50%}.navbar .nav-links span{color:#f5f5f5;font-size:1.6rem}", ""]);
	
	// exports


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _hero = __webpack_require__(14);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var heroModule = _angular2.default.module("hero", [_angularUiRouter2.default]).component("hero", _hero2.default);
	
	exports.default = heroModule;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hero = __webpack_require__(15);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _hero3 = __webpack_require__(16);
	
	var _hero4 = _interopRequireDefault(_hero3);
	
	__webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var heroComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _hero2.default,
	  controller: _hero4.default,
	  controllerAs: "vm"
	};
	
	exports.default = heroComponent;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"hero\">\n  <h1>This is the NG6 starter</h1>\n  <h3>You can find me inside {{ vm.name }}.html</h3>\n</section>\n"

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HeroController = function HeroController() {
	  _classCallCheck(this, HeroController);
	
	  this.name = "hero";
	};
	
	exports.default = HeroController;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(18);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./hero.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./hero.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%}.hero{background-color:#263238;height:50rem;padding:3rem}.hero *{color:#f5f5f5}", ""]);
	
	// exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _user = __webpack_require__(20);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userModule = _angular2.default.module("user", []).factory("User", _user2.default);
	
	exports.default = userModule;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UserFactory = function UserFactory() {
	  var user = {};
	
	  var getUser = function getUser() {
	    return user;
	  };
	
	  var isSignedIn = function isSignedIn() {
	    return user.isSignedIn;
	  };
	
	  return { getUser: getUser, isSignedIn: isSignedIn };
	};
	
	exports.default = UserFactory;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _jobblefooter = __webpack_require__(22);
	
	var _jobblefooter2 = _interopRequireDefault(_jobblefooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobblefooterModule = _angular2.default.module("jobblefooter", [_angularUiRouter2.default]).component("jobblefooter", _jobblefooter2.default);
	
	exports.default = jobblefooterModule;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobblefooter = __webpack_require__(23);
	
	var _jobblefooter2 = _interopRequireDefault(_jobblefooter);
	
	var _jobblefooter3 = __webpack_require__(24);
	
	var _jobblefooter4 = _interopRequireDefault(_jobblefooter3);
	
	__webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobblefooterComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _jobblefooter2.default,
	  controller: _jobblefooter4.default,
	  controllerAs: "vm"
	};
	
	exports.default = jobblefooterComponent;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = "<footer class=\"footer-section\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n        <div class=\"copyright text-center\">&copy; 2024 Jobble. All Rights Reserved</div>\n      </div>\n    </div>\n  </div>\n</footer>\n"

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _messagingv = __webpack_require__(30);
	
	var _messagingv2 = _interopRequireDefault(_messagingv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobblefooterController = function JobblefooterController($http, $localStorage, $state, AuthService, SecurityService, Messagingv2Service, $rootScope, $location, TrackingService, $timeout) {
	  _classCallCheck(this, JobblefooterController);
	
	  this.name = "jobblefooter";
	
	  this.$http = $http;
	  this.$localStorage = $localStorage;
	  this.$state = $state;
	  this.$auth = AuthService;
	  this.$rootScope = $rootScope;
	  this.$tracking = TrackingService;
	  this.$security = SecurityService;
	  this.$messagingv2 = Messagingv2Service;
	  this.currentUser = this.$auth.getUserData();
	  this.$location = $location;
	  this.loadLocalLytics = false;
	  this.$timeout = $timeout;
	  this.counter = 0;
	
	  var _this = this;
	
	  if (!_this.$rootScope.localytics) {
	    if (!_this.loadLocalLytics) {
	      _this.$timeout(function () {
	        _this.loadLocalLytics = true;
	        _this.$rootScope.localytics = true;
	      });
	    }
	  }
	};
	
	JobblefooterController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "messagingv2", "$rootScope", "$location", "tracking", "$timeout"];
	
	exports.default = JobblefooterController;

/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuthService = function () {
	  function AuthService($http, $localStorage, $state, $stateParams, SecurityService, $q, EnvService, $rootScope, $timeout, $location, $cookies) {
	    var _this2 = this;
	
	    _classCallCheck(this, AuthService);
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$stateParams = $stateParams;
	    this.$env = EnvService;
	    this.$q = $q;
	    this.$location = $location;
	    this.$cookies = $cookies;
	    this.recover_email = "";
	    this.billingUrl = "jbl/v1/validate?format=json&fields=billingTutorialTracking";
	    this.validatePayInfo = "jbl/v1/validate?format=json&fields=company.undeletedPaymentInfos.id,authorities,acceptedBackgroundCheck,homeContactInfo.isMobilePhoneVerified,company.autoAcceptLimitTimeMark,billingTutorialTracking,company.autoAccept,company.autoManage,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.billingContactInfo.email,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.payByInvoice,company.sendInvoice,company.defaultPlan.requiresSubscription,company.enableSubscription";
	    this.fullValidateUrlWeb = "jbl/v1/validate?format=json&fields=username,dateBirth,ssn,authorities,acceptedBackgroundCheck,homeContactInfo.isMobilePhoneVerified,video1,brands,company.autoAcceptLimitTimeMark,billingTutorialTracking,id,smsChatNotificationOn,profilePictureUri,company.billingContactInfo.email,company.payByInvoice,company.sendInvoice,company.enableSubscription,company.invoiceMarkup,company.industryType.id,emailChatNotificationOn,firstName,dateCreated,lastName,access_token,company.name,company.legalCompanyName,company.ein,company.numberOfLocations,company.id,company.autoAccept,company.autoManage,company.payPerConnect,homeContactInfo.streetLine1,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.phoneMobile,company.defaultPlan.requiresSubscription,homeContactInfo.isMobilePhoneVerified,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.dateCreated,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,company.postingTypesAllowed,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.description,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.companyLogoOtherUriFree,company.companyLogoUriFree,company.companyLogoUri,company.totalNumberOfCircles,company.totalNumberOfCloseEvents,company.totalNumberOfDraftEvents,company.totalNumberOfPublishedEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.circleOfConnectedJobblers.id,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.partnernumberOfCompletedJobbles,numberOfApplications,numberOfApprovedApplications,numberOfPendingApplications,numberOfQuittedApplications,numberOfWithdrawnApplications,numberOfRejectedApplications,acceptedWebAgreement,acceptedMobileAgreement,acceptedPrivacyPolicy,acceptedCookiePolicy";
	    this.fullValidateUrl = "jbl/v1/validate?format=json&conf=web";
	    this.signInUrlLazy = "jbl/v1/login?format=json&fields=username,dateBirth,homeContactInfo.isMobilePhoneVerified,authorities,acceptedBackgroundCheck,ssn,bio,company.autoAcceptLimitTimeMark,billingTutorialTracking,notifPref.jobbleTypes,video1,brands,id,smsChatNotificationOn,profilePictureUri,company.billingContactInfo.email,company.autoAccept,company.autoManage,company.payByInvoice,company.sendInvoice,company.enableSubscription,company.invoiceMarkup,company.industryType.id,emailChatNotificationOn,firstName,dateCreated,lastName,access_token,company.name,company.legalCompanyName,company.ein,company.numberOfLocations,company.id,company.payPerConnect,homeContactInfo.streetLine1,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,company.defaultPlan.requiresSubscription,homeContactInfo.phoneMobile,homeContactInfo.isMobilePhoneVerified,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.dateCreated,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,company.postingTypesAllowed,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.description,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.companyLogoUri,company.totalNumberOfCircles,company.totalNumberOfCloseEvents,company.totalNumberOfDraftEvents,company.totalNumberOfPublishedEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.circleOfConnectedJobblers.id,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.partnernumberOfCompletedJobbles,numberOfApplications,numberOfApprovedApplications,numberOfPendingApplications,numberOfQuittedApplications,numberOfWithdrawnApplications,numberOfRejectedApplications,acceptedWebAgreement,acceptedMobileAgreement,acceptedPrivacyPolicy,acceptedCookiePolicy";
	    this.validateUrl = "jbl/v1/validate?format=json&fields=username,dateBirth,homeContactInfo.isMobilePhoneVerified,authorities,acceptedBackgroundCheck,company.autoAcceptLimitTimeMark,billingTutorialTracking,video1,isVerified,ssn,brands,id,smsChatNotificationOn,company.billingContactInfo.email,company.payByInvoice,company.sendInvoice,company.enableSubscription,company.autoAccept,company.autoManage,company.invoiceMarkup,profilePictureUri,emailChatNotificationOn,firstName,dateCreated,lastName,access_token,company.name,company.legalCompanyName,company.ein,company.numberOfLocations,company.id,company.payPerConnect,homeContactInfo.streetLine1,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.phoneMobile,company.defaultPlan.requiresSubscription,homeContactInfo.isMobilePhoneVerified,company.companyLogoOtherUriFree,company.companyLogoUriFree,company.companyLogoUri,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.dateCreated,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,company.postingTypesAllowed,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.description,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.totalNumberOfCircles,company.totalNumberOfCloseEvents,company.totalNumberOfDraftEvents,company.totalNumberOfPublishedEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.industryType.name,company.industryType.id,company.circleOfConnectedJobblers.id,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.partner,company.rds_company,numberOfCompletedJobbles,numberOfApplications,numberOfApprovedApplications,numberOfPendingApplications,numberOfQuittedApplications,numberOfWithdrawnApplications,numberOfRejectedApplications,acceptedWebAgreement,acceptedMobileAgreement,acceptedPrivacyPolicy,acceptedCookiePolicy";
	    this.signInUrl = "jbl/v1/login?format=json&fields=username,dateBirth,homeContactInfo.isMobilePhoneVerified,authorities,acceptedBackgroundCheck,company.autoAcceptLimitTimeMark,ssn,billingTutorialTracking,video1,brands,id,smsChatNotificationOn,profilePictureUri,company.billingContactInfo.email,company.payByInvoice,company.sendInvoice,company.enableSubscription,company.invoiceMarkup,company.industryType.id,emailChatNotificationOn,firstName,dateCreated,lastName,access_token,company.name,company.legalCompanyName,company.ein,company.numberOfLocations,company.autoAccept,company.autoManage,company.id,company.payPerConnect,homeContactInfo.streetLine1,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.phoneMobile,homeContactInfo.isMobilePhoneVerified,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.dateCreated,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,company.postingTypesAllowed,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.description,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.companyLogoOtherUriFree,company.companyLogoUriFree,company.companyLogoUri,company.totalNumberOfCircles,company.totalNumberOfCloseEvents,company.totalNumberOfDraftEvents,company.totalNumberOfPublishedEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.circleOfConnectedJobblers.id,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.partnernumberOfCompletedJobbles,numberOfApplications,numberOfApprovedApplications,numberOfPendingApplications,numberOfQuittedApplications,numberOfWithdrawnApplications,numberOfRejectedApplications,acceptedWebAgreement,acceptedMobileAgreement,acceptedPrivacyPolicy,acceptedCookiePolicy";
	    this.getCompanyPlanUrl = "jbl/v1/validate?format=json&fields=username,dateBirth,homeContactInfo.isMobilePhoneVerified,authorities,acceptedBackgroundCheck,company.autoAcceptLimitTimeMark,billingTutorialTracking,company.billingContactInfo.email,company.sendInvoice,company.enableSubscription,company.payByInvoice,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.description,company.autoAccept,company.autoManage,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct";
	    this.validate_from_marketing_site_url = "jbl/v1/validate?format=json&fields=username,isVerified,homeContactInfo.isMobilePhoneVerified,authorities,acceptedBackgroundCheck,company.autoAcceptLimitTimeMark,billingTutorialTracking,company.isVerified,id,email,company.id,company.payByInvoice,company.sendInvoice,company.defaultPlan.requiresSubscription,company.billingContactInfo.email,company.enableSubscription,company.invoiceMarkup,company.defaultPlan.id,company.autoAccept,company.autoManage,company.undeletedPaymentInfos,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.name,company.legalCompanyName,company.ein,company.numberOfLocations";
	    this.loginUrlWithValidate = "jbl/v1/validate?format=json&fields=username,email,id,company.id,company.isVerified,authorities,isVerified,billingTutorialTracking,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.defaultPlan.companyFeePct,company.billingContactInfo.email,company.defaultPlan.requiresSubscription,company.undeletedPaymentInfos.bankName,homeContactInfo.streetLine1,homeContactInfo.isMobilePhoneVerified,homeContactInfo.streetLine2,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.isMobileVerified,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.mainContactInfo.city,company.ein,company.mainContactInfo.state,company.mainContactInfo.zipCode,company.description,company.autoAccept,company.autoManage,company.enableSubscription,company.payByInvoice,company.sendInvoice,company.name,company.legalCompanyName,bgCheckStatus,company.undeletedPaymentInfos.stripeId,acceptedBackgroundCheck";
	    this.companyVerificationUrl = "jbl/v1/validate?format=json&fields=username,email,id,company.id,company.isVerified,authorities,isVerified,billingTutorialTracking,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.defaultPlan.companyFeePct,company.billingContactInfo.email,company.defaultPlan.requiresSubscription,company.undeletedPaymentInfos.bankName,homeContactInfo.streetLine1,homeContactInfo.isMobilePhoneVerified,homeContactInfo.streetLine2,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.isMobileVerified,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.mainContactInfo.city,company.ein,company.mainContactInfo.state,company.mainContactInfo.zipCode,company.description,company.autoAccept,company.autoManage,company.enableSubscription,company.payByInvoice,company.sendInvoice,company.name,company.legalCompanyName,bgCheckStatus,company.undeletedPaymentInfos.stripeId,company.companyLogoUriFree,company.companyLogoUri";
	    this.$rootScope = $rootScope;
	    this.event_types = [];
	
	    this.USER_UPDATE_TRIGGER = "RecentUserUpdated";
	    this.USER_UPDATE_TRIGGER_TRIMMED = "RecentUserUpdatedTrimmed";
	
	    if (this.isLoggedIn()) {
	      if (this.$localStorage.logged_user && this.$localStorage.logged_user.company && this.$localStorage.logged_user.company.id) {
	        this.validateUserByTokenWeb(this.getAccessToken()).then(function (response) {
	          //console.log("Validate Response");
	          //console.dir(response);
	          _this2.setMostRecentUser(response.data);
	          _this2.emitMostRecentUser();
	        }).catch(function (error) {
	          _this2.logout();
	          //console.log("VALDIATE ERRRORRR");
	          //console.dir(error);
	        });
	      } else {
	        this.validateUserByToken(this.getAccessToken()).then(function (response) {
	          //console.log("Validate Response");
	          //console.dir(response);
	          _this2.setMostRecentUser(response.data);
	          _this2.emitMostRecentUser();
	        }).catch(function (error) {
	          _this2.logout();
	          //console.log("VALDIATE ERRRORRR");
	          //console.dir(error);
	        });
	      }
	    }
	  }
	
	  _createClass(AuthService, [{
	    key: "emitMostRecentUser",
	    value: function emitMostRecentUser() {
	      var _this3 = this;
	
	      this.$timeout(function () {
	        _this3.$rootScope.$emit(_this3.USER_UPDATE_TRIGGER, _this3.getUserData());
	        _this3.$rootScope.$emit(_this3.USER_UPDATE_TRIGGER_TRIMMED, _this3.getUserData());
	      });
	    }
	  }, {
	    key: "logout",
	    value: function logout() {
	      var _this4 = this;
	
	      this.signOut().then(function (response) {
	        _this4.clearLoggedFields();
	        _this4.$location.path("/jobs");
	        window.location.reload();
	      }).catch(function (err) {
	        _this4.clearLoggedFields();
	        _this4.$location.path("/jobs");
	        window.location.reload();
	      });
	    }
	  }, {
	    key: "logoutOnboarding",
	    value: function logoutOnboarding() {
	      var _this5 = this;
	
	      this.signOut().then(function (response) {
	        _this5.clearLoggedFields();
	        //this.$location.path("/signin");
	        window.location.reload();
	      }).catch(function (err) {
	        _this5.clearLoggedFields();
	        //this.$location.path("/signin");
	        window.location.reload();
	      });
	    }
	  }, {
	    key: "clearLoggedFields",
	    value: function clearLoggedFields() {
	      this.$localStorage.logged_user = null;
	      this.$rootScope.channels = null;
	      this.$rootScope.companyLogoUri = null;
	      this.$rootScope.inboxLink = null;
	      this.$rootScope.channelsHaveLoaded = null;
	      this.$rootScope.teams = null;
	      this.$rootScope.teamsSimple = null;
	      this.$rootScope.globalParams = null;
	      this.$rootScope.imgFromProfilePage = null;
	      this.$rootScope.jobbleTypes = null;
	      this.$rootScope.jobs = null;
	      this.$rootScope.jobsSeenOnce = null;
	      this.$rootScope.boardParameters = null;
	    }
	  }, {
	    key: "isLoggedIn",
	    value: function isLoggedIn() {
	      var loggedIn = true;
	
	      var logged_user = this.$localStorage.logged_user;
	
	      if (this.$security.isUndefinedOrNull(logged_user)) {
	        console.warn("There is no logged in user in local storage.");
	        loggedIn = false;
	        return loggedIn;
	      }
	
	      if (this.$security.isUndefinedOrNull(logged_user.username)) {
	        console.warn("The logged in user in local storage is missing an username.");
	        loggedIn = false;
	      }
	
	      if (this.$security.isUndefinedOrNull(logged_user.email)) {
	        console.warn("The logged in user in local storage is missing an email.");
	        loggedIn = false;
	      }
	
	      if (this.$security.isUndefinedOrNull(logged_user.access_token)) {
	        console.warn("The logged in user in local storage is missing an access token.");
	        loggedIn = false;
	      }
	      return loggedIn;
	    }
	  }, {
	    key: "signOut",
	    value: function signOut() {
	      var _this = this;
	
	      //_this.$localStorage.removeItem('logged_user');
	      localStorage.removeItem("logged_user");
	
	      return this.$http.post(_this.$env.getAPIEndPoint() + "jbl/v1/logout", {}, { headers: { Authorization: "Bearer " + _this.getAccessToken() } });
	    }
	  }, {
	    key: "signIn",
	    value: function signIn() {}
	  }, {
	    key: "signUp",
	    value: function signUp() {}
	  }, {
	    key: "reloadCurrentMobileUser",
	    value: function reloadCurrentMobileUser() {
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&fields=isVerified",
	        headers: {
	          Authorization: "Bearer " + this.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getCompanyPlan",
	    value: function getCompanyPlan() {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + _this.getCompanyPlanUrl,
	        headers: { Authorization: "Bearer " + _this.getAccessToken() },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "grab_company_logo",
	    value: function grab_company_logo(token) {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&fields=company.companyLogoUriFree,company.companyLogoUri,company.fileCOMPANY_LOGO1IMG_75x75",
	        headers: {
	          Authorization: "Bearer " + _this.getAccessToken()
	        },
	        data: {}
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "setMostRecentUser",
	    value: function setMostRecentUser(user) {
	      this.$localStorage.logged_user = user;
	    }
	  }, {
	    key: "setRecentCompanyData",
	    value: function setRecentCompanyData(company) {
	      if (this.$localStorage.logged_user && this.$localStorage.logged_user.company && company) {
	        this.$localStorage.logged_user.company.description = company.description;
	        this.$localStorage.logged_user.company.name = company.name;
	        this.$localStorage.logged_user.company.ein = company.ein;
	        this.$localStorage.logged_user.company.legalCompanyName = company.legalCompanyName;
	        this.$localStorage.logged_user.company.numberOfLocations = company.numberOfLocations;
	        this.$localStorage.logged_user.company.mainContactInfo.city = company.mainContactInfo.city;
	        this.$localStorage.logged_user.company.mainContactInfo.phoneMobile = company.mainContactInfo.phoneMobile;
	        this.$localStorage.logged_user.company.mainContactInfo.state = company.mainContactInfo.state;
	        this.$localStorage.logged_user.company.mainContactInfo.streetLine1 = company.mainContactInfo.streetLine1;
	        this.$localStorage.logged_user.company.mainContactInfo.zipCode = company.mainContactInfo.zipCode;
	      }
	    }
	  }, {
	    key: "refreshCurrentUserBilling",
	    value: function refreshCurrentUserBilling() {
	      var _this6 = this;
	
	      console.log("refreshCurrentUserBilling");
	      console.dir(this.billingUrl);
	      return new Promise(function (resolve, reject) {
	        var req = {
	          method: "GET",
	          url: _this6.$env.getAPIEndPoint() + _this6.billingUrl,
	          headers: { Authorization: "Bearer " + _this6.getAccessToken() },
	          data: {}
	        };
	
	        _this6.$http(req).then(function (response) {
	          if (response.status === 200) {
	            //this.setMostRecentUser(response.data);
	            //this.emitMostRecentUser();
	            console.log("new user", response);
	            resolve(_this6.getUserData());
	          } else {
	            console.log("error reloading the current user");
	            reject();
	          }
	        });
	      });
	    }
	  }, {
	    key: "refreshCurrentUserDashboard",
	    value: function refreshCurrentUserDashboard() {
	      var _this7 = this;
	
	      return new Promise(function (resolve, reject) {
	        var req = {
	          method: "GET",
	          url: _this7.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&fields=company.totalNumberOfPublishedEvents,company.totalNumberOfDraftEvents,company.totalNumberOfCloseEvents,company.totalNumberOfEvents,company.totalNumberOfNonCloseEvents",
	          headers: { Authorization: "Bearer " + _this7.getAccessToken() },
	          data: {}
	        };
	
	        _this7.$http(req).then(function (response) {
	          if (response.status === 200) {
	            //this.setMostRecentUser(response.data);
	            //this.emitMostRecentUser();
	            console.log("new user event data", response);
	            resolve(response.data);
	          } else {
	            console.log("error reloading the current user");
	            reject();
	          }
	        });
	      });
	    }
	  }, {
	    key: "refreshCurrentUser",
	    value: function refreshCurrentUser() {
	      var _this8 = this;
	
	      return new Promise(function (resolve, reject) {
	        var req = {
	          method: "GET",
	          url: _this8.$env.getAPIEndPoint() + _this8.fullValidateUrlWeb,
	          headers: { Authorization: "Bearer " + _this8.getAccessToken() },
	          data: {}
	        };
	
	        _this8.$http(req).then(function (response) {
	          if (response.status === 200) {
	            _this8.setMostRecentUser(response.data);
	            _this8.emitMostRecentUser();
	            console.log("new user", response);
	            resolve(_this8.getUserData());
	          } else {
	            console.log("error reloading the current user");
	            reject();
	          }
	        });
	      });
	    }
	  }, {
	    key: "reloadCurrentUser",
	    value: function reloadCurrentUser() {
	      var _this9 = this;
	
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + this.fullValidateUrlWeb,
	        headers: { Authorization: "Bearer " + this.getAccessToken() },
	        data: {}
	      };
	
	      this.$http(req).then(function (response) {
	        if (response.status === 200) {
	          _this9.setMostRecentUser(response.data);
	          return response.data;
	          //return this.$localStorage.logged_user;
	        } else {
	          console.log("error reloading the current user");
	        }
	      });
	    }
	  }, {
	    key: "validateUserByTokenWeb",
	    value: function validateUserByTokenWeb(token) {
	      token = token.trim();
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + this.fullValidateUrlWeb,
	        headers: { Authorization: "Bearer " + token },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "validateCompanyByTokenWeb",
	    value: function validateCompanyByTokenWeb(token) {
	      token = token.trim();
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + this.companyVerificationUrl,
	        headers: { Authorization: "Bearer " + token },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "validateUserByToken",
	    value: function validateUserByToken(token) {
	      token = token.trim();
	
	      console.log("whenzzzz");
	
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + this.fullValidateUrl,
	        headers: { Authorization: "Bearer " + token },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "validate_from_marketing_site",
	    value: function validate_from_marketing_site(token) {
	      var _this = this;
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + _this.validate_from_marketing_site_url,
	        headers: { Authorization: "Bearer " + token },
	        data: {}
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "reloadNewPostingType",
	    value: function reloadNewPostingType() {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&fields=company.payPerConnect",
	        headers: {
	          Authorization: "Bearer " + _this.getAccessToken()
	        },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "submitRecoverLink",
	    value: function submitRecoverLink(email) {
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "forgot_password.json",
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getRecoverEmail",
	    value: function getRecoverEmail() {
	      return this.recover_email;
	    }
	  }, {
	    key: "setRecoverEmail",
	    value: function setRecoverEmail(recover_email) {
	      this.recover_email = recover_email;
	    }
	  }, {
	    key: "getEventTypes",
	    value: function getEventTypes() {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/event-types?conf=web&format=json&max=100&q=%7B%7D";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getJobbleTypes",
	    value: function getJobbleTypes(max) {
	      if (!max) {
	        var max = 100;
	      }
	      var url = this.$env.getAPIEndPoint() + "public/jobble-types?format=json&max=" + max + "&displayOrder=asc&fields=id,name,displayOrder";
	      var req = { method: "GET", url: url, headers: {}, data: {} };
	      return this.$http(req);
	    }
	  }, {
	    key: "getAccessToken",
	    value: function getAccessToken() {
	      if (this.$localStorage.logged_user) {
	        return this.$localStorage.logged_user.access_token;
	      }
	    }
	  }, {
	    key: "getUserData",
	    value: function getUserData() {
	      return this.$localStorage.logged_user;
	    }
	  }, {
	    key: "getAllJobbles",
	    value: function getAllJobbles(maxCount) {
	      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/jobbles?format=json&conf=web&isPublished=true&isPayed=false&isReserved=false&excludeChainAndPoolDupe=true&sort=dateCreated&order=desc&excludeStartTimePassed=false&max=" + maxCount.toString() + "&offset=" + offset.toString();
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { authorization: "Bearer " + this.getAccessToken() },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getTransactions",
	    value: function getTransactions(startDate, endDate) {
	      var intervalType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "1d";
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/stats/payment?statType=sum-amountCompany&format=json&isDeleted=false&startDate=" + startDate + "&endDate=" + endDate + "&interval=" + intervalType;
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getEvents",
	    value: function getEvents(startDate, endDate) {
	      var intervalType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "1d";
	      var isClosed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/stats/event?format=json&isDeleted=false&startDate=" + startDate + "&endDate=" + endDate + "&interval=" + intervalType;
	      if (isClosed) {
	        url += "&isClosed=true";
	      }
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getApplicants",
	    value: function getApplicants(startDate, endDate) {
	      var intervalType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "1d";
	
	      // var url = 'https://dev.int.jobbleapp.com/jobbleapi/jbl/v1/stats/application?isDeleted=false&format=json&startDate=2016-05-23T00:00:00-04:00&endDate=2016-05-29T23:59:59-04:00&interval=1d';
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/stats/application?format=json&isDeleted=false&startDate=" + startDate + "&endDate=" + endDate + "&interval=" + intervalType;
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getOpenings",
	    value: function getOpenings(startDate, endDate) {
	      var intervalType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "1d";
	
	      // var url = 'https://dev.int.jobbleapp.com/jobbleapi/jbl/v1/stats/jobble?isDeleted=false&format=json&startDate=2016-05-23T00:00:00-04:00&endDate=2016-05-29T23:59:59-04:00&interval=1d';
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/stats/jobble?format=json&isDeleted=false&startDate=" + startDate + "&endDate=" + endDate + "&interval=" + intervalType;
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getHires",
	    value: function getHires(startDate, endDate) {
	      var intervalType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "1d";
	
	      // var url = 'https://dev.int.jobbleapp.com/jobbleapi/jbl/v1/stats/application?applicationStatus=1&format=json&startDate=2016-05-23T00:00:00-04:00&endDate=2016-05-29T23:59:59-04:00&interval=1d&isDeleted=false';
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/stats/application?applicationStatus=1&format=json&isDeleted=false&startDate=" + startDate + "&endDate=" + endDate + "&interval=" + intervalType;
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getPlans",
	    value: function getPlans() {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/plans?format=json&conf=web&max=100";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "lazyLoginExists",
	    value: function lazyLoginExists(user) {
	      var _this = this;
	      //fields=username,dateBirth,ssn,video1,brands,id,smsChatNotificationOn,profilePictureUri,company.industryType.id,emailChatNotificationOn,firstName,dateCreated,lastName,access_token,company.name,company.legalCompanyName,company.ein,company.numberOfLocations,company.id,company.payPerConnect,homeContactInfo.streetLine1,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.dateCreated,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,company.postingTypesAllowed,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.description,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.companyLogoUri,company.totalNumberOfCircles,company.totalNumberOfCloseEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.circleOfConnectedJobblers.id,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.partnernumberOfCompletedJobbles,numberOfApplications,numberOfApprovedApplications,numberOfPendingApplications,numberOfQuittedApplications,numberOfWithdrawnApplications,numberOfRejectedApplications
	      //fields=username,id,smsChatNotificationOn,emailChatNotificationOn,firstName,lastName,access_token,company.name,company.legalCompanyName,company.ein,company.numberOfLocations,company.id,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.jobblerFeePct,company.defaultPlan.name,company.defaultPlan.companyFeePct,company.companyLogoUri,company.paymentInfos.cardBrand,company.paymentInfos.validated,company.paymentInfos.cardExpirationMonth,company.paymentInfos.cardExpirationYear,company.paymentInfos.cardToken,company.paymentInfos.last4,company.paymentInfos.bankName,company.paymentInfos.stripeId,company.paymentInfos.nickname,company.totalNumberOfCircles,company.totalNumberOfCloseEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.circleOfConnectedJobblers.id,company.partner
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/login?format=json&fields=username,dateBirth,ssn,video1,brands,id,smsChatNotificationOn,profilePictureUri,company.industryType.id,emailChatNotificationOn,firstName,dateCreated,lastName,access_token,company.name,company.legalCompanyName,company.ein,company.numberOfLocations,company.id,company.payPerConnect,homeContactInfo.streetLine1,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.dateCreated,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,company.postingTypesAllowed,company.sendInvoice,company.enableSubscription,company.payByInvoice,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.description,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.companyLogoUri,company.totalNumberOfCircles,company.totalNumberOfCloseEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.circleOfConnectedJobblers.id,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.partnernumberOfCompletedJobbles,numberOfApplications,numberOfApprovedApplications,numberOfPendingApplications,numberOfQuittedApplications,numberOfWithdrawnApplications,numberOfRejectedApplications",
	        data: {
	          username: user.emailLogin,
	          password: user.passwordLogin
	        }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getUserByEmail",
	    value: function getUserByEmail(email) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/users/get?format=json&verbosity=5",
	        headers: { authorization: "Bearer " + this.getAccessToken() },
	        data: { email: email }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "lazySignin",
	    value: function lazySignin(user) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + _this.signInUrl,
	        data: {
	          username: user.email,
	          password: user.password
	        }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "lazyReg",
	    value: function lazyReg(user, marketingParamsSubgStr) {
	      var _this = this;
	
	      var urlReq = null;
	
	      if (marketingParamsSubgStr) {
	        urlReq = _this.$env.getAPIEndPoint() + "register/register?format=json&conf=web" + marketingParamsSubgStr;
	      } else {
	        urlReq = _this.$env.getAPIEndPoint() + "register/register?format=json&conf=web";
	      }
	
	      var req = {};
	
	      if (user.Company) {
	        req = {
	          method: "POST",
	          url: urlReq,
	          data: {
	            company: {
	              defaultPlan: 1,
	              mainContactInfo: {
	                phoneMobile: user.phoneMobile
	              },
	              name: user.companyName
	            },
	            firstName: user.firstName,
	            lastName: user.lastName,
	            username: user.email,
	            password: user.password,
	            termsOfService: true,
	            acceptedWebAgreement: true,
	            homeContactInfo: {
	              phoneMobile: user.phoneMobile
	            }
	          }
	        };
	      } else {}
	      return this.$http(req);
	    }
	  }, {
	    key: "getRatings",
	    value: function getRatings(offset, id) {
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + id + "/ratings/received?format=json&conf=web&sort=dateCreated&order=desc&max=5&offset=" + offset,
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getChatUploadUrl",
	    value: function getChatUploadUrl(id, fileType) {
	      var url = "";
	      try {
	        if (id) {
	          url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + id + "/files?format=json&fileType=" + fileType + "&replace=true";
	        } else {
	          url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + this.$localStorage.logged_user.companyId + "/files?format=json&fileType=" + fileType + "&replace=true";
	        }
	      } finally {
	        return url;
	      }
	    }
	  }, {
	    key: "getUploadUrl",
	    value: function getUploadUrl(id, file) {
	      var url = "";
	      try {
	        if (id) {
	          if (file.type === "image/png" || file.type === "image/jpg" || file.type === "image/jpeg") {
	            url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + id + "/files?format=json&fileType=9&replace=true";
	          } else {
	            url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + id + "/files?format=json&fileType=7&replace=true";
	          }
	        } else {
	          if (file.type === "image/png" || file.type === "image/jpg" || file.type === "image/jpeg") {
	            url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + this.$localStorage.logged_user.companyId + "/files?format=json&fileType=9&replace=true";
	          } else {
	            url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + this.$localStorage.logged_user.companyId + "/files?format=json&fileType=7&replace=true";
	          }
	        }
	      } finally {
	        return url;
	      }
	    }
	  }, {
	    key: "getMapsKey",
	    value: function getMapsKey() {
	      var _this = this;
	      console.log("what is the env");
	      console.dir(_this.$env);
	    }
	  }, {
	    key: "populateCardImage",
	    value: function populateCardImage(info) {
	      if (info.cardBrand === "American Express") {
	        info.image = "fa fa-cc-amex";
	      }
	      if (info.cardBrand === "Visa") {
	        info.image = "fa fa-cc-visa";
	      }
	      if (info.cardBrand === "Discover") {
	        info.image = "fa fa-cc-discover";
	      }
	      if (info.cardBrand === "MasterCard") {
	        info.image = "fa fa-cc-mastercard";
	      }
	
	      if (info.bankName) {
	        info.image = "fas fa-university";
	      }
	
	      return info.image;
	    }
	  }, {
	    key: "formatPaymentMethods",
	    value: function formatPaymentMethods(paymentMethods) {
	      var _this = this;
	
	      var methods = [];
	
	      console.log("formatPaymentMethods");
	      console.dir(paymentMethods);
	
	      try {
	        paymentMethods.forEach(function (paymentMethod) {
	          paymentMethod.isChecked = false;
	
	          if (paymentMethod.bankName) {
	            if (paymentMethod.validated) {
	              paymentMethod.displayName = paymentMethod.bankName;
	              paymentMethod.displayExpires = "--";
	              paymentMethod.displayLast4 = paymentMethod.last4;
	              paymentMethod.displayNickName = "--";
	              paymentMethod.payType = "bank";
	              paymentMethod.stripeId = paymentMethod.stripeId;
	              paymentMethod.image = _this.populateCardImage(paymentMethod);
	              methods.push(paymentMethod);
	            }
	          } else {
	            paymentMethod.displayName = paymentMethod.cardBrand;
	            paymentMethod.displayLast4 = paymentMethod.last4;
	            paymentMethod.displayExpires = paymentMethod.cardExpirationDate;
	            paymentMethod.stripeId = paymentMethod.stripeId;
	            paymentMethod.displayNickName = paymentMethod.nickname ? paymentMethod.nickname : "--";
	            paymentMethod.payType = "card";
	            paymentMethod.image = _this.populateCardImage(paymentMethod);
	            methods.push(paymentMethod);
	          }
	        });
	      } finally {
	        console.log("methods");
	        console.dir(methods);
	        return methods;
	      }
	    }
	  }, {
	    key: "selectPaymentMethod",
	    value: function selectPaymentMethod(paymenMethods, paymentMethod) {
	      var _this = this;
	
	      try {
	        var paymentMethodFiltered = paymenMethods.filter(function (p) {
	          return p.isChecked === true;
	        });
	      } finally {
	        if (paymentMethodFiltered && paymentMethodFiltered.length > 0) {
	          paymentMethodFiltered[0].isChecked = false;
	        }
	
	        paymentMethod.isChecked = true;
	
	        return paymenMethods;
	      }
	    }
	  }, {
	    key: "deleteCard",
	    value: function deleteCard(id) {
	      var req = {
	        method: "DELETE",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/companies/" + this.$localStorage.logged_user.company.id + "/payment-infos/" + id + "?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getHubspotToken",
	    value: function getHubspotToken() {
	      var cookies = this.$cookies.getAll() || {};
	
	      return cookies.hubspotutk || null;
	    }
	  }, {
	    key: "registerJobblerInHubspot",
	    value: function registerJobblerInHubspot(user) {
	      var xhr = new XMLHttpRequest();
	      var url = "https://api.hsforms.com/submissions/v3/integration/submit/421423/7a14e805-a099-47a1-b2c1-c65615ad7041";
	
	      var data = {
	        submittedAt: Date.now(),
	        fields: [{
	          name: "email",
	          value: user.email
	        }],
	        context: {
	          hutk: this.getHubspotToken(),
	          pageUri: window.location.href,
	          pageName: ""
	        }
	      };
	
	      var final_data = JSON.stringify(data);
	
	      xhr.open("POST", url);
	
	      xhr.setRequestHeader("Content-Type", "application/json");
	
	      xhr.onreadystatechange = function () {
	        if (xhr.readyState == 4 && xhr.status == 200) {
	          console.log(xhr.responseText);
	        } else if (xhr.readyState == 4 && xhr.status == 400) {
	          console.log(xhr.responseText);
	        } else if (xhr.readyState == 4 && xhr.status == 403) {
	          console.log(xhr.responseText);
	        } else if (xhr.readyState == 4 && xhr.status == 404) {
	          console.log(xhr.responseText);
	        }
	      };
	
	      xhr.send(final_data);
	    }
	  }, {
	    key: "registerCompanyInHubspot",
	    value: function registerCompanyInHubspot(user) {
	      var xhr = new XMLHttpRequest();
	      var url = "https://api.hsforms.com/submissions/v3/integration/submit/421423/8235df8f-a6e5-4150-81fd-10176648e0ce";
	
	      var data = {
	        submittedAt: Date.now(),
	        fields: [{
	          name: "email",
	          value: user.email
	        }],
	        context: {
	          hutk: this.getHubspotToken(),
	          pageUri: window.location.href,
	          pageName: ""
	        }
	      };
	
	      var final_data = JSON.stringify(data);
	
	      xhr.open("POST", url);
	
	      xhr.setRequestHeader("Content-Type", "application/json");
	
	      xhr.onreadystatechange = function () {
	        if (xhr.readyState == 4 && xhr.status == 200) {
	          console.log(xhr.responseText);
	        } else if (xhr.readyState == 4 && xhr.status == 400) {
	          console.log(xhr.responseText);
	        } else if (xhr.readyState == 4 && xhr.status == 403) {
	          console.log(xhr.responseText);
	        } else if (xhr.readyState == 4 && xhr.status == 404) {
	          console.log(xhr.responseText);
	        }
	      };
	
	      xhr.send(final_data);
	    }
	  }, {
	    key: "registerMobileUser",
	    value: function registerMobileUser(user, ref) {
	      try {
	        this.registerJobblerInHubspot(user);
	      } catch (e) {
	        console.error("Hubspot registration error:", e);
	      }
	
	      ref = ref || window.location.origin + "/jobs";
	
	      var data = {
	        username: user.email,
	        password: user.password,
	        acceptedWebAgreement: true,
	        acceptedPrivacyPolicy: true,
	        acceptedCookiePolicy: true
	      };
	
	      if (user.first_name) data.firstName = user.first_name;
	
	      if (user.last_name) data.lastName = user.last_name;
	
	      if (user.zip_code) data.homeContactInfo = { zipCode: user.zip_code };
	
	      if (user.isBenjaminUser) {
	        data.isBenjaminUser = true;
	      }
	
	      if (user.notifPref) {
	        data.notifPref = user.notifPref;
	      }
	
	      var url = this.$env.getAPIEndPoint() + "register/register?format=json&conf=web&ref=" + ref;
	
	      var searchParams = this.$location.$$search || {};
	
	      if (searchParams.utm_source) url += "&jsrc=" + searchParams.utm_source;
	
	      if (searchParams.utm_campaign) url += "&jcam=" + searchParams.utm_campaign;
	
	      var req = {
	        method: "POST",
	        url: url,
	        data: data
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "lazyLoginMobileUser",
	    value: function lazyLoginMobileUser(user) {
	      var _this = this;
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + _this.signInUrlLazy,
	        data: { username: user.email, password: user.password }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "isAdmin",
	    value: function isAdmin() {
	      var _this = this;
	
	      var isAdmin = null;
	
	      if (_this.$localStorage.logged_user.username.indexOf("jobble.com") !== -1 || _this.$localStorage.logged_user.username.indexOf("jobbleapp.com") !== -1) {
	        isAdmin = true;
	      }
	
	      return isAdmin;
	    }
	  }, {
	    key: "hasCompletedPaymentInformation",
	    value: function hasCompletedPaymentInformation() {
	      var user = this.getUserData();
	
	      var complete = {
	        completed: false,
	        address_complete: false,
	        payment_added: false
	        // ein_complete: false
	      };
	
	      if (!user) {
	        return complete;
	      }
	
	      if (user.company && user.company.mainContactInfo) {
	        complete.address_complete = user.company.mainContactInfo.streetLine1 && user.company.mainContactInfo.city && user.company.mainContactInfo.state && user.company.mainContactInfo.zipCode;
	      }
	
	      // if (user.company) {
	      //     complete.ein_complete = !!(user.company.ein);
	      // }
	
	      if (user.company && user.company.undeletedPaymentInfos) {
	        complete.payment_added = user.company.undeletedPaymentInfos.length >= 1;
	      }
	
	      complete.completed = complete.payment_added; //&& complete.ein_complete complete.address_complete &&;
	
	      return complete;
	    }
	  }, {
	    key: "handlePaymentInfos",
	    value: function handlePaymentInfos(user, params, skip) {
	      var _this = this;
	
	      user.company.paymentInfos = null;
	      user.company.paymentInfos = user.company.undeletedPaymentInfos;
	      _this.$localStorage.logged_user = user;
	      //dashboardType: "es", action: "login"
	
	      _this.$timeout(function () {
	        $("body").removeClass();
	        if (!skip) {
	          _this.$state.go("jobsdashboard", { filter: "published" });
	          //_this.pullCompanyUserInfo();
	        }
	      }, 100);
	    }
	  }, {
	    key: "pullCompanyUserInfo",
	    value: function pullCompanyUserInfo() {
	      var _this10 = this;
	
	      this.validateUserByTokenWebTrimmed(this.getAccessToken()).then(function (response) {
	        _this10.setMostRecentUser(response.data);
	        _this10.emitMostRecentUser();
	        _this10.$rootScope.$emit("SetProfilePicture", response.data);
	        //emit new user to the app?
	      }).catch(function (error) {
	        _this10.logout();
	      });
	    }
	  }, {
	    key: "validateUserByTokenWebTrimmed",
	    value: function validateUserByTokenWebTrimmed(token) {
	      token = token.trim();
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + this.loginUrlWithValidate,
	        headers: { Authorization: "Bearer " + token },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "changePlans",
	    value: function changePlans(plan_id) {
	      var _this = this;
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/bulk-subscription?format=json",
	        headers: {
	          "Content-Type": undefined,
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        data: {
	          companiesAndPlans: [{
	            company: _this.$localStorage.logged_user.company.id,
	            plan: plan_id
	          }]
	        }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "job_details_register",
	    value: function job_details_register(user) {
	      var _this = this;
	      var url = null;
	      console.log("what is the user right before");
	      console.dir(user);
	      url = _this.$env.getAPIEndPoint() + "register/register?format=json&fields=id,username,email,firstName,lastName";
	      var req = {
	        method: "POST",
	        url: url,
	        data: {
	          firstName: user.first_name,
	          lastName: user.last_name,
	          username: user.email,
	          email: user.email,
	          password: user.password,
	          termsOfService: true,
	          acceptedWebAgreement: true,
	          homeContactInfo: {
	            phoneMobile: user.phone
	          }
	        }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "job_details_login",
	    value: function job_details_login(user) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + _this.signInUrlLazy,
	        data: {
	          username: user.email,
	          password: user.password
	        }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "fancyLoad",
	    value: function fancyLoad(cls, lng) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $(cls).slice(0, lng).each(function (i, row) {
	          setTimeout(function () {
	            $(row).fadeIn(1000);
	          }, 100 * i);
	        });
	      });
	    }
	  }, {
	    key: "getCompanyPayInfo",
	    value: function getCompanyPayInfo() {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + _this.validatePayInfo,
	        headers: {
	          Authorization: "Bearer " + _this.getAccessToken()
	        },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }]);
	
	  return AuthService;
	}();
	
	exports.default = AuthService;
	
	
	AuthService.$inject = ["$http", "$localStorage", "$state", "$stateParams", "security", "$q", "env", "$rootScope", "$timeout", "$location", "$cookies"];

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SecurityService = function () {
	  function SecurityService($http, $localStorage, $state, EnvService, $rootScope, $httpParamSerializerJQLike) {
	    _classCallCheck(this, SecurityService);
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	    this.$env = EnvService;
	    this.$rootScope = $rootScope;
	    this.createRecipientUrl = "jbl/v1/stripe/create-recipient-stripe-account?format=json&conf=web&typeAccount=individual";
	    this.current_event = null;
	  }
	
	  _createClass(SecurityService, [{
	    key: "redirect",
	    value: function redirect(state) {
	      url = url || "/";
	      this.$state.go(state);
	    }
	  }, {
	    key: "isUndefinedOrNull",
	    value: function isUndefinedOrNull(val) {
	      return _angular2.default.isUndefined(val) || val === null || val === "";
	    }
	  }, {
	    key: "isThisEventLive",
	    value: function isThisEventLive(shiftsArray) {
	      var retObj = {};
	
	      console.log("what is shifts array");
	      console.dir(shiftsArray);
	
	      retObj.checkInTime = null;
	      retObj.checkOutTime = null;
	      retObj.checkInLat = null;
	      retObj.checkInLng = null;
	      retObj.checkOutLat = null;
	      retObj.contactInfo = null;
	      retObj.checkOutLng = null;
	      retObj.eventIsLive = false;
	
	      shiftsArray.sort(function (a, b) {
	        return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
	      });
	
	      shiftsArray.forEach(function (s, i) {
	        retObj.contactInfo = s.contactInfo;
	        var index = i + 1;
	        var st = moment(s.timeInterval.startTime).subtract(15, "minutes");
	        var et;
	        if (index === shiftsArray.length) {
	          var indexLast = index - 1;
	          et = moment(shiftsArray[indexLast].timeInterval.endTime).add(8000, "hours");
	        } else {
	          et = moment(shiftsArray[index].timeInterval.startTime).subtract(15, "minutes");
	        }
	        if (moment().isAfter(st) && moment().isBefore(et)) {
	          retObj.shiftId = s.id;
	
	          retObj.eventIsLive = true;
	
	          if (s.checkInTime !== null) {
	            retObj.checkInTime = s.checkInTime;
	            if (s.checkInCoord) {
	              retObj.checkInLat = s.checkInCoord.lat;
	              retObj.checkInLng = s.checkInCoord.lng;
	            }
	          }
	
	          if (s.checkOutTime !== null) {
	            console.log("what is this before it breaks");
	            console.dir(s);
	
	            retObj.checkOutTime = s.checkOutTime;
	            if (s.checkOutCoord) {
	              retObj.checkOutLat = s.checkOutCoord.lat;
	              retObj.checkOutLng = s.checkOutCoord.lng;
	            }
	          }
	        }
	        /*
	              if (i === 0) {
	                  if (moment().isAfter(st)) {
	                      retObj.eventIsLive = true;
	                  }
	              }
	              */
	      });
	
	      return retObj;
	    }
	  }, {
	    key: "getJobblersPicture",
	    value: function getJobblersPicture(size, jobbler) {
	      var correctPicture = "";
	      if (!this.isUndefinedOrNull(jobbler.picture1s)) {
	        try {
	          var pic1found = false;
	          jobbler.picture1s.forEach(function (pic) {
	            if (pic.indexOf(size) > -1) {
	              correctPicture = pic;
	              pic1found = true;
	            }
	          });
	        } finally {
	          if (pic1found === false) {
	            if (!this.isUndefinedOrNull(jobbler.picture1)) {
	              correctPicture = jobbler.picture1;
	            } else {
	              correctPicture = jobbler.profilePictureUri;
	            }
	          }
	        }
	      } else {
	        if (!this.isUndefinedOrNull(jobbler.picture1)) {
	          correctPicture = jobbler.picture1;
	        } else {
	          correctPicture = jobbler.profilePictureUri;
	        }
	      }
	
	      return correctPicture;
	    }
	  }, {
	    key: "calculateTheTime",
	    value: function calculateTheTime(minutes) {
	      var timeObj = {};
	      var minutesDivided = minutes / 60;
	      var minutesStr = minutesDivided.toString();
	      var index = minutesStr.indexOf(".");
	      var length = minutesStr.length;
	      var finalStr = minutesStr.substring(index, length);
	      var hourStr = minutesStr.substring(0, index);
	      var backToFloat = parseFloat(finalStr);
	      var minutesTimes = backToFloat * 60;
	      timeObj.hours = parseInt(hourStr, 10);
	      timeObj.minutes = minutesTimes;
	      return timeObj;
	    }
	  }, {
	    key: "hireJobblerAfterConnection",
	    value: function hireJobblerAfterConnection(jobblesAndApplicants) {
	      var _this = this;
	
	      var hireJobblersData = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-accept?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {
	          jobblesAndApplicants: jobblesAndApplicants
	        }
	      };
	
	      return _this.$http(hireJobblersData);
	    }
	  }, {
	    key: "getUser",
	    value: function getUser(id) {
	      var _this = this;
	
	      var user = {
	        method: "GET",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/users/" + id,
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return _this.$http(user);
	    }
	  }, {
	    key: "getApplicationInfoTrimmedv2",
	    value: function getApplicationInfoTrimmedv2(application) {
	      var _this = this;
	
	      var picparam = "";
	
	      picparam = "applicant.picture1s";
	
	      var user = {
	        method: "GET",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/applications/" + application.id + "?format=json&fields=id,applicant.firstName,applicant.nickname,applicant.lastName,applicant.bio,applicant.averageRatingReceived,applicant.profilePictureUri,applicant.profilePictureUriFree,applicant.numberOfCompletedJobbles,applicant.id,applicant.email,applicant.honorsAndAwards,applicant.homeContactInfo.phoneMobile,applicant.homeContactInfo.streetLine1,applicant.homeContactInfo.zipCode,applicant.homeContactInfo.city,applicant.homeContactInfo.state",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return _this.$http(user);
	    }
	  }, {
	    key: "getApplicationInfoTrimmed",
	    value: function getApplicationInfoTrimmed(application) {
	      var _this = this;
	
	      var picparam = "";
	
	      picparam = "applicant.picture1s";
	
	      var user = {
	        method: "GET",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/applications/" + application.id + "?format=json&fields=id,applicant.firstName,applicant.nickname,applicant.education,applicant.resumeLink,applicant.lastName,jobble.id,jobble.event.id,applicant.dateBirth,spiel,applicant.bio,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_160x160,applicant.filePROFILE_IMAGE1IMG_600x600,applicant.filePROFILE_IMAGE2IMG_600x600,applicant.filePROFILE_IMAGE3IMG_600x600,applicant.filePROFILE_IMAGE4IMG_600x600,applicant.filePROFILE_IMAGE5IMG_600x600,applicant.filePROFILE_IMAGE6IMG_600x600,applicant.numberOfCompletedJobbles,applicant.brands,applicant.certifications,applicant.id,jobbler.applicant.education,applicant.gender,jobble.id,jobble.isSourcingPost,applicant.shirtSize,applicant.twitter,applicant.facebook,applicant.profilePictureUri,applicant.instagram,applicant.googlePlus,applicant.linkdedIn,applicant.email,surveyResponses,applicant.hasDriverLicense,applicant.isVeteran,applicant.hasCar,applicant.primaryLangues,applicant.primaryLanguage,applicant.otherLanguages,applicant.honorsAndAwards,applicant.workTypes,applicant.homeContactInfo.phoneMobile,applicant.homeContactInfo.streetLine1,applicant.homeContactInfo.zipCode,applicant.homeContactInfo.city,applicant.homeContactInfo.state",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return _this.$http(user);
	    }
	  }, {
	    key: "getJobblerData",
	    value: function getJobblerData(jobbler, type, action, photoUrl, index, pendingApplicantsLength, acceptedApplicantsLength, rawApplication) {
	      console.log("getting jobbler data");
	      console.dir(jobbler);
	      console.dir(rawApplication);
	
	      var _this = this;
	
	      var data = {};
	
	      if (type === "default") {
	        if (_this.$localStorage.logged_user.username.indexOf("jobble.com") !== -1 || _this.$localStorage.logged_user.username.indexOf("jobbleapp.com") !== -1) {
	          data.name = jobbler.applicant.firstName + " " + jobbler.applicant.lastName;
	        } else {
	          data.name = jobbler.applicant.firstName + " " + jobbler.applicant.lastName.substring(0, 1) + ".";
	        }
	
	        if (jobbler.nickname) {
	          data.nickname = jobbler.nickname;
	        }
	
	        if (index + 1 === pendingApplicantsLength) {
	          data.showLink = false;
	        } else {
	          data.showLink = true;
	        }
	
	        if (index === 0) {
	          data.showLinkPrevious = false;
	        } else {
	          data.showLinkPrevious = true;
	        }
	      }
	
	      if (type === "hired") {
	        data.isHired = true;
	        data.name = jobbler.applicant.firstName + " " + jobbler.applicant.lastName;
	        if (index + 1 === acceptedApplicantsLength) {
	          data.showLink = false;
	        } else {
	          data.showLink = true;
	        }
	
	        if (index === 0) {
	          data.showLinkPrevious = false;
	        } else {
	          data.showLinkPrevious = true;
	        }
	      }
	
	      data.firstName = jobbler.applicant.firstName;
	      data.lastName = jobbler.applicant.lastName;
	      data.pics = [];
	      data.applicationId = jobbler.id;
	      data.age = moment().diff(moment(jobbler.applicant.dateBirth), "years");
	
	      if (isNaN(data.age)) {
	        data.age = null;
	      }
	
	      data.whyMe = jobbler.spiel;
	      data.bio = jobbler.applicant.bio;
	      data.average = Math.ceil(jobbler.applicant.averageRatingReceived);
	
	      if (data.average === 0) {
	        data.average = 1;
	      }
	
	      data.completed = jobbler.applicant.numberOfCompletedJobbles;
	      data.brands = jobbler.applicant.brands;
	      data.certs = jobbler.applicant.certifications;
	      data.jobblerId = jobbler.applicant.id;
	      data.education = jobbler.applicant.education;
	      data.gender = jobbler.applicant.gender;
	      //data.jobbleId = jobbler.jobble.id;
	      //data.isSourcingPost = jobbler.jobble.isSourcingPost;
	      data.shirtSize = jobbler.applicant.shirtSize;
	      data.twitter = jobbler.applicant.twitter;
	      data.facebook = jobbler.applicant.facebook;
	      data.fallBackPicture = jobbler.applicant.profilePictureUri;
	      data.instagram = jobbler.applicant.instagram;
	      data.googlePlus = jobbler.applicant.googlePlus;
	      data.linkedIn = jobbler.applicant.linkdedIn;
	      data.email = jobbler.applicant.email;
	      data.modalType = type;
	      //data.surveyQuestions = jobbler.surveyResponses;
	      data.applicationStatus = rawApplication.applicationStatus;
	
	      if (jobbler.applicant.hasDriverLicense) {
	        data.hasDriverLicense = "Yes";
	      } else {
	        if (jobbler.applicant.hasDriverLicense === null) {
	          data.hasDriverLicense = "Not provided.";
	        } else {
	          data.hasDriverLicense = "No";
	        }
	      }
	      if (jobbler.applicant.isVeteran) {
	        data.isVeteran = "Yes";
	      } else {
	        if (jobbler.applicant.isVeteran === null) {
	          data.isVeteran = "Not provided.";
	        } else {
	          data.isVeteran = "No";
	        }
	      }
	
	      if (jobbler.applicant.hasCar) {
	        data.hasCar = "Yes";
	      } else {
	        if (jobbler.applicant.hasCar === null) {
	          data.hasCar = "Not provided.";
	        } else {
	          data.hasCar = "No";
	        }
	      }
	
	      if (rawApplication.whyWasJobblerRemovedFromJob) {
	        data.whyWasJobblerRemovedFromJob = rawApplication.whyWasJobblerRemovedFromJob;
	      }
	
	      data.primaryLanguage = jobbler.applicant.primaryLanguage;
	      data.otherLanguages = jobbler.applicant.otherLanguages;
	      data.honorsAndAwards = jobbler.applicant.honorsAndAwards;
	      data.workTypes = jobbler.applicant.workTypes;
	      data.resume = jobbler.applicant.resumeLink;
	      data.photo = jobbler.applicant.filePROFILE_IMAGE1IMG_160x160;
	
	      if (jobbler.applicant.homeContactInfo) {
	        if (jobbler.applicant.homeContactInfo.phoneMobile) {
	          var numStr = jobbler.applicant.homeContactInfo.phoneMobile.toString();
	          numStr = numStr.replace(/[^A-Za-z0-9]/g, "");
	          if (numStr.length > 10) {
	            numStr = numStr.substring(1, 11);
	          }
	          var re = /\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})/g;
	          var subst = "$1-$2-$3";
	          var result = numStr.replace(re, subst);
	          data.number = result;
	          data.numberOrig = jobbler.applicant.homeContactInfo.phoneMobile;
	        }
	
	        data.street = jobbler.applicant.homeContactInfo.streetLine1;
	
	        if (jobbler.applicant.homeContactInfo.city) {
	          data.location = jobbler.applicant.homeContactInfo.city + " " + jobbler.applicant.homeContactInfo.state + ", " + jobbler.applicant.homeContactInfo.zipCode;
	        } else {
	          data.location = "N/A";
	        }
	      }
	
	      if (jobbler.applicant.filePROFILE_IMAGE1IMG_600x600) {
	        data.pics.push(jobbler.applicant.filePROFILE_IMAGE1IMG_600x600);
	      }
	
	      if (jobbler.applicant.filePROFILE_IMAGE2IMG_600x600) {
	        data.pics.push(jobbler.applicant.filePROFILE_IMAGE2IMG_600x600);
	      }
	
	      if (jobbler.applicant.filePROFILE_IMAGE3IMG_600x600) {
	        data.pics.push(jobbler.applicant.filePROFILE_IMAGE3IMG_600x600);
	      }
	
	      if (jobbler.applicant.filePROFILE_IMAGE4IMG_600x600) {
	        data.pics.push(jobbler.applicant.filePROFILE_IMAGE4IMG_600x600);
	      }
	
	      if (jobbler.applicant.filePROFILE_IMAGE5IMG_600x600) {
	        data.pics.push(jobbler.applicant.filePROFILE_IMAGE5IMG_600x600);
	      }
	
	      if (jobbler.applicant.filePROFILE_IMAGE6IMG_600x600) {
	        data.pics.push(jobbler.applicant.filePROFILE_IMAGE6IMG_600x600);
	      }
	
	      return data;
	    }
	  }, {
	    key: "getRatings",
	    value: function getRatings(id, offset) {
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + id + "/ratings/received?format=json&conf=web&sort=dateCreated&order=desc&max=5&offset=" + offset,
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getEventShiftTimezoneInfo",
	    value: function getEventShiftTimezoneInfo(shift) {
	      var zipCode = shift.contactInfo.zipCode;
	
	      if (!this.isUndefinedOrNull(zipCode) && zipCode.length > 5) {
	        zipCode = zipCode.substring(0, 5);
	      }
	
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "public/places?format=json&conf=web&withTz=true&countryIsoCode=US&zipCode=" + zipCode,
	        headers: {},
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "displayTimeWithZone",
	    value: function displayTimeWithZone(time, time_zone_id) {
	      var _this = this;
	
	      return moment(time).tz(time_zone_id).format("hh:mm A");
	    }
	  }, {
	    key: "getTimesFromZone",
	    value: function getTimesFromZone(applications, roster_page) {
	      var _this = this;
	
	      var tempTimeArray = [];
	
	      var tempTimeObj = null;
	
	      if (roster_page) {
	        try {
	          applications.forEach(function (application) {
	            tempTimeObj = {};
	
	            if (application.currentShift.managerCheckInTime) {
	              tempTimeObj.start_time = moment(application.currentShift.managerCheckInTime).tz(application.currentShift.contactInfo.place.timeZoneId).format("hh:mm A");
	            }
	
	            if (application.currentShift.managerCheckOutTime) {
	              tempTimeObj.end_time = moment(application.currentShift.managerCheckOutTime).tz(application.currentShift.contactInfo.place.timeZoneId).format("hh:mm A");
	            }
	
	            application.currentShift.checkInAndOutForDisplay = tempTimeObj;
	          });
	        } finally {
	          return applications;
	        }
	      } else {
	        try {
	          applications.forEach(function (application) {
	            tempTimeObj = {};
	
	            if (application.currentShift.checkInTime) {
	              tempTimeObj.start_time = moment(application.currentShift.checkInTime).tz(application.currentShift.contactInfo.place.timeZoneId).format("hh:mm A");
	            }
	
	            if (application.currentShift.checkOutTime) {
	              tempTimeObj.end_time = moment(application.currentShift.checkOutTime).tz(application.currentShift.contactInfo.place.timeZoneId).format("hh:mm A");
	            }
	
	            application.currentShift.checkInAndOutForDisplay = tempTimeObj;
	          });
	        } finally {
	          return applications;
	        }
	      }
	    }
	  }, {
	    key: "getTimesFromZoneAllShifts",
	    value: function getTimesFromZoneAllShifts(applications) {
	      var _this = this;
	
	      var tempTimeArray = [];
	
	      var tempTimeObj = null;
	
	      try {
	        applications.forEach(function (application) {
	          application.jobble.shifts.forEach(function (shift) {
	            console.log("each shift");
	            console.dir(shift);
	          });
	
	          /*
	          tempTimeObj = {};
	          	if (application.currentShift.checkInTime) {
	          tempTimeObj.start_time = moment(application.currentShift.checkInTime).tz(application.currentShift.contactInfo.place.timeZoneId).format("hh:mm A");
	          	}
	          	if (application.currentShift.checkOutTime) {
	          tempTimeObj.end_time = moment(application.currentShift.checkOutTime).tz(application.currentShift.contactInfo.place.timeZoneId).format("hh:mm A");
	          }
	          	application.currentShift.checkInAndOutForDisplay = tempTimeObj;
	          */
	        });
	      } finally {
	        return applications;
	      }
	    }
	  }, {
	    key: "getClientDate",
	    value: function getClientDate(serverUTCTime) {
	      var date = new Date(serverUTCTime);
	      return moment(date).format("MMM DD, YYYY");
	    }
	  }, {
	    key: "transferConnectionFee",
	    value: function transferConnectionFee(cardToken) {
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/charge-customer?format=json&amount=2500&note=Connection",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "bulkConnect",
	    value: function bulkConnect(paymentInfo, jobbler) {
	      //{"username":"elie.fossi2@gmail.com", "application":2, "freeOfCharge":true}
	
	      if (paymentInfo.bankName) {
	        var req = {
	          method: "POST",
	          url: this.$env.getAPIEndPoint() + "jbl/v1/companies/bulk-connect?format=json&amount=2500&custUsername=" + this.$localStorage.logged_user.username + "&note=Connection2",
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	          },
	          data: {
	            usersAndApplications: [{
	              username: jobbler.email,
	              application: jobbler.applicationId
	            }],
	            bank: paymentInfo.stripeId,
	            note: "Connection"
	          }
	        };
	      } else {
	        var req = {
	          method: "POST",
	          url: this.$env.getAPIEndPoint() + "jbl/v1/companies/bulk-connect?format=json&amount=2500&custUsername=" + this.$localStorage.logged_user.username + "&note=Connection2",
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	          },
	          data: {
	            usersAndApplications: [{
	              username: jobbler.email,
	              application: jobbler.applicationId
	            }],
	            card: paymentInfo.cardToken,
	            note: "Connection"
	          }
	        };
	      }
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getUserLatestWorkHistory",
	    value: function getUserLatestWorkHistory(userId) {
	      var _this = this;
	
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + userId + "/history";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getInvoice",
	    value: function getInvoice(invoiceId, eventId) {
	      var _this = this;
	
	      var url = null;
	
	      if (eventId) {
	        url = _this.$env.getAPIEndPoint() + "jbl/v1/payments?format=json&max=100&eventId=" + eventId + "&fields=dateCreated,id,event.id,notePayer,detailTransactionCompany,payedUser.firstName,payedUser.lastName,jobble.id,jobble.payPerHour,amount,amountCompany,jobble.actualMinutesWorked,jobble.jobbleDuration,confirmation,payingUser.id,payingUser.firstName,payingUser.lastName,payingCompany.name";
	      } else {
	        url = _this.$env.getAPIEndPoint() + "jbl/v1/payments/" + invoiceId + "?format=json&max=1&fields=dateCreated,id,event.id,notePayer,detailTransactionCompany,payedUser.firstName,payedUser.lastName,jobble.id,jobble.payPerHour,amount,amountCompany,jobble.actualMinutesWorked,jobble.jobbleDuration,confirmation,payingUser.id,payingUser.firstName,payingUser.lastName,payingCompany.name";
	      }
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "sendMicroDeposit",
	    value: function sendMicroDeposit(a1, a2, bank_token, setupId) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/validate-bank-account?format=json&conf=web&bankAccount=" + bank_token,
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: { amount1: a1, amount2: a2 }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "putActualMinutesWorked",
	    value: function putActualMinutesWorked(jobbleId, minutes, rev) {
	      var _this = this;
	
	      var req = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobbleId + "?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {
	          actualMinutesWorked: minutes,
	          actualRevenue: rev
	        }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "putPayPerHourUpdateForDelivery",
	    value: function putPayPerHourUpdateForDelivery(jobble_id, amount) {
	      var _this = this;
	
	      var data = {};
	      data.payPerHour = amount;
	      var req = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobble_id + "?format=json&conf=web&fields=id,payPerHour",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: data
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "putActualMinutesWorkedTrimmed",
	    value: function putActualMinutesWorkedTrimmed(jobbleId, minutes, rev) {
	      var _this = this;
	      var data = {};
	      data.actualMinutesWorked = minutes;
	      var req = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobbleId + "?format=json&conf=web&fields=id,actualMinutesWorked,actualRevenue",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: data
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "putActualMinutesWorkedForShift",
	    value: function putActualMinutesWorkedForShift(shiftId, minutes) {
	      var _this = this;
	
	      var req = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + shiftId + "?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {
	          actualMinutesWorked: minutes
	        }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "putActualMinutesWorkedForShiftTrimmed",
	    value: function putActualMinutesWorkedForShiftTrimmed(shiftId, minutes) {
	      var _this = this;
	
	      var req = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + shiftId + "?format=json&conf=web&fields=id,actualMinutesWorked",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {
	          actualMinutesWorked: minutes
	        }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "markJobblerAsNoShow",
	    value: function markJobblerAsNoShow(data) {
	      var _this = this;
	
	      var req = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + data.jobbleId + "?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: { noShow: true }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "markJobblerAsNoShowTrimmed",
	    value: function markJobblerAsNoShowTrimmed(data) {
	      var _this = this;
	
	      var req = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + data.jobble.id + "?format=json&fields=id",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: { noShow: true }
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "markJobblerAsPaidByShiftTrimmed",
	    value: function markJobblerAsPaidByShiftTrimmed(data) {
	      var _this = this;
	
	      var req = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + data.jobble.id + "?format=json&fields=id,makeAdditionalPayment,actualMinutesWorked,jobbleDurationInMinutes,actualRevenue,costOfJobble",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: { makeAdditionalPayment: true }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "markJobblerAsPaidByShiftTrimmedCancel",
	    value: function markJobblerAsPaidByShiftTrimmedCancel(data) {
	      var _this = this;
	
	      var req = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + data.jobble.id + "?format=json&fields=id,makeAdditionalPayment,actualMinutesWorked,jobbleDurationInMinutes,actualRevenue,costOfJobble",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: { makeAdditionalPayment: false }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "markJobblerAsNoShowCancel",
	    value: function markJobblerAsNoShowCancel(data) {
	      var _this = this;
	
	      console.log("what is the data in cancel?");
	      console.dir(data);
	
	      var req = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + data.jobble.id + "?format=json&conf=web&fields=id,jobbleDurationInMinutes,actualRevenue,startTime,endTime,shifts.id,shifts.paymentStats",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: { noShow: null }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getConnections",
	    value: function getConnections(id, offset) {
	      var _this = this;
	
	      if (!offset) {
	        offset = 0;
	      }
	
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/circles/" + id + "/users?format=json&conf=web&sort=email&order=asc&max=100&offset=" + offset;
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getJobbler",
	    value: function getJobbler(id, offset) {
	      var _this = this;
	
	      if (!offset) {
	        offset = 0;
	      }
	
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + id + "/?format=json&conf=web";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getJobblerStars",
	    value: function getJobblerStars(jobbler) {
	      var _this = this;
	
	      var rating = "";
	      if (jobbler.averageRatingReceived) {
	        if (Math.round(jobbler.averageRatingReceived) === 0) {
	          rating = "one";
	        }
	        if (Math.round(jobbler.averageRatingReceived) === 1) {
	          rating = "one";
	        }
	        if (Math.round(jobbler.averageRatingReceived) === 2) {
	          rating = "two";
	        }
	        if (Math.round(jobbler.averageRatingReceived) === 3) {
	          rating = "three";
	        }
	        if (Math.round(jobbler.averageRatingReceived) === 4) {
	          rating = "four";
	        }
	        if (Math.round(jobbler.averageRatingReceived) === 5) {
	          rating = "five";
	        }
	      } else {
	        rating = "five";
	      }
	      return rating;
	    }
	  }, {
	    key: "getToken",
	    value: function getToken(data) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: "https://api.stripe.com/v1/tokens",
	        headers: {
	          "Content-Type": "application/x-www-form-urlencoded",
	          Authorization: "Bearer " + _this.$env.EnvironmentConfig.stripeKey
	        },
	        data: _this.$httpParamSerializerJQLike(data)
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "saveRecipient",
	    value: function saveRecipient(data) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/create-recipient-stripe-account?format=json&conf=web&typeAccount=individual",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        data: {
	          paymentMethod: data.paymentMethod,
	          stripeToken: data.stripeToken,
	          username: data.username,
	          country: data.country,
	          currency: data.currency
	        }
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "detectDevice",
	    value: function detectDevice() {
	      var _this = this;
	
	      var data = {};
	      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
	        if (/iPhone/.test(navigator.userAgent)) {
	          data.mobile_device_type = "iPhone";
	          data.user_agent = navigator.userAgent;
	        } else if (/Android/.test(navigator.userAgent)) {
	          data.mobile_device_type = "Android";
	          data.user_agent = navigator.userAgent;
	        } else if (/iPad/.test(navigator.userAgent)) {
	          data.mobile_device_type = "iPad";
	          data.user_agent = navigator.userAgent;
	        } else if (/Blackberry/.test(navigator.userAgent)) {
	          data.mobile_device_type = "Blackberry";
	          data.user_agent = navigator.userAgent;
	        } else {
	          data.mobile_device_type = "Other";
	          data.user_agent = navigator.userAgent;
	        }
	      } else {
	        data.mobile_device_type = "Desktop";
	        data.user_agent = navigator.userAgent;
	      }
	      return data;
	    }
	  }, {
	    key: "getReferenceQuestions",
	    value: function getReferenceQuestions() {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: _this.$env.getAPIEndPoint() + "public/userReferences/questions?config=web&format=json",
	        headers: {
	          "Content-Type": "application/json"
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getReferenceDataFromAPI",
	    value: function getReferenceDataFromAPI(rid) {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: _this.$env.getAPIEndPoint() + "public/userReferences/references/" + rid + "?config=web&format=json",
	        headers: {
	          "Content-Type": "application/json"
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "findQuestionId",
	    value: function findQuestionId(searchString, questions) {
	
	      var questionIndex = questions.findIndex(function (element) {
	        return element.name.includes(searchString);
	      });
	
	      return questions[questionIndex].id;
	    }
	  }, {
	    key: "saveReferenceQuestion",
	    value: function saveReferenceQuestion(d) {
	
	      var _this = this;
	
	      console.log("saveReferenceQuestion");
	      console.dir(d);
	
	      var payload = {
	        answers: [{
	          answer: d.answer,
	          questionId: d.questionId
	        }]
	      };
	
	      if (d.status === "COMPLETED") {
	        payload.answers[0].status = "COMPLETED";
	      }
	
	      var data = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "/public/userReferences/references/" + d.userReferenceId + "/responses?config=web&format=json",
	        headers: {
	          "Content-Type": "application/json"
	        },
	        data: payload
	      };
	
	      return _this.$http(data);
	    }
	  }]);
	
	  return SecurityService;
	}();
	
	exports.default = SecurityService;
	
	
	SecurityService.$inject = ["$http", "$localStorage", "$state", "env", "$rootScope", "$httpParamSerializerJQLike"];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _configFile = __webpack_require__(29);
	
	var _configFile2 = _interopRequireDefault(_configFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EnvService = function () {
	  function EnvService($http, $localStorage, $state, $q, EnvironmentConfig) {
	    _classCallCheck(this, EnvService);
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$q = $q;
	    this.EnvironmentConfig = EnvironmentConfig;
	  }
	
	  _createClass(EnvService, [{
	    key: "getEnv",
	    value: function getEnv() {
	      if (this.EnvironmentConfig.api && this.EnvironmentConfig.api.indexOf("api-eb.int.jobbleapp.com") !== -1) return "prod";
	      return "dev";
	    }
	  }, {
	    key: "getAPIEndPoint",
	    value: function getAPIEndPoint() {
	      return this.EnvironmentConfig.api;
	    }
	  }, {
	    key: "getJobsAPIEndPoint",
	    value: function getJobsAPIEndPoint() {
	      return this.EnvironmentConfig.jobs_api;
	    }
	  }, {
	    key: "getElasticSearchEventsAPIEndPoint",
	    value: function getElasticSearchEventsAPIEndPoint() {
	      return this.EnvironmentConfig.elasticSearchJobsAPI;
	    }
	  }, {
	    key: "getStripeKey",
	    value: function getStripeKey() {
	      return this.EnvironmentConfig.stripeKey;
	    }
	  }, {
	    key: "getTransActionFee",
	    value: function getTransActionFee() {
	      return 0.05;
	    }
	  }, {
	    key: "getPubNubSubKey",
	    value: function getPubNubSubKey() {
	      return this.EnvironmentConfig.pubnubSubKey;
	    }
	  }, {
	    key: "getPubNubPubKey",
	    value: function getPubNubPubKey() {
	      return this.EnvironmentConfig.pubnubPubKey;
	    }
	  }, {
	    key: "getMapsKey",
	    value: function getMapsKey() {
	      return this.EnvironmentConfig.mapsKey;
	    }
	  }, {
	    key: "getGTMKey",
	    value: function getGTMKey() {
	      return this.EnvironmentConfig.gtmKey;
	    }
	  }]);
	
	  return EnvService;
	}();
	
	exports.default = EnvService;
	
	
	EnvService.$inject = ["$http", "$localStorage", "$state", "$q", "EnvironmentConfig"];

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	// import auth from './auth';
	
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Messagingv2Service = function () {
	  function Messagingv2Service($http, $localStorage, $state, $q, SecurityService, AuthService, EnvService, $rootScope, $timeout) {
	    _classCallCheck(this, Messagingv2Service);
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$q = $q;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$env = EnvService;
	    this.$rootScope = $rootScope;
	    this.$timeout = $timeout;
	    this.PubNub = null;
	    this.unsortedChannelList = [];
	    this.matchCounter = 0;
	    this.nestedChannelList = [];
	    this.arrayOfImageUrlsForGallery = [];
	    this.$rootScope.paginationMessages = [];
	    this.$rootScope.allChannelNames = [];
	    this.controlChannelVal = null;
	    this.totalAmountOfMissedMessages = 0;
	    this.handleLastMessageDataCounter = 0;
	    this.currentChannel = null;
	    this.isNewChannel = false;
	    this.message_data = null;
	    this.indexOfArg = null;
	    this.$rootScope.allChannelIds = [];
	    this.cacheOfSubbedChannels = [];
	    this.someOneWasJustHired = false;
	    this.channels_in_queue = [];
	    this.pause_channel_loading = false;
	    this.$rootScope.channels = null;
	    this.defaultChannelsSize = 20;
	    var _this = this;
	
	    _this.JobblerIsBeingHiredListener = _this.$rootScope.$on("JobblerIsBeingHired", function ($event, params) {
	      _this.someOneWasJustHired = true;
	    });
	    _this.AddChannelToListListener = _this.$rootScope.$on("AddChannelToList", function ($event, params) {
	      _this.addThisChannelToOurListOfChannels(params);
	    });
	    _this.$rootScope.$on("$destroy", _this.JobblerIsBeingHiredListener);
	    _this.$rootScope.$on("$destroy", _this.AddChannelToListListener);
	  }
	
	  _createClass(Messagingv2Service, [{
	    key: "getChannels",
	    value: function getChannels(max) {
	      if (this.$localStorage) {
	        var maxparam = 1;
	        if (max) {
	          maxparam = max;
	        }
	        var url = this.$env.getAPIEndPoint() + "jbl/v1/users/" + this.$localStorage.logged_user.id + "/channels?format=json&max=" + maxparam + "&fields=company.name,channelUser.connected,channelUser.timeToken1,description,event.id,event.isSourcingPost,event.contactInfo.city,event.contactInfo.state,event.contactInfo.streetLine1,event.contactInfo.zipCode,event.name,event.startTime,event.endTime,event.subEvents.deduppedJobbles.shifts.timeInterval,eventId,eventName,eventStartTime,id,isDefault,name";
	        var req = {
	          method: "GET",
	          url: url,
	          headers: {
	            authorization: "Bearer " + this.$auth.getAccessToken()
	          },
	          data: {}
	        };
	        return this.$http(req);
	      }
	    }
	  }, {
	    key: "getChannelsv1",
	    value: function getChannelsv1(offsetparam, max) {
	      if (this.$localStorage) {
	        var maxparam = this.defaultChannelsSize;
	        if (max) {
	          maxparam = max;
	        }
	        var url = this.$env.getAPIEndPoint() + "jbl/v1/users/" + this.$localStorage.logged_user.id + "/listChannels?format=json&companyId=" + this.$localStorage.logged_user.company.id + "&max=" + maxparam + "&offset=" + offsetparam + "&sortBy=dateCreated&order=desc";
	        var req = {
	          method: "GET",
	          url: url,
	          headers: {
	            authorization: "Bearer " + this.$auth.getAccessToken()
	          },
	          data: {}
	        };
	        return this.$http(req);
	      }
	    }
	  }, {
	    key: "init",
	    value: function init(channels, is_new_chat_with_jobbler) {
	      console.log("we are initiated..");
	
	      var c = null;
	
	      if (is_new_chat_with_jobbler) {
	        this.is_new_chat_with_jobbler = true;
	      }
	
	      if (channels.channels) {
	        c = channels.channels;
	      } else {
	        c = channels;
	      }
	      this.subscribeToAllChannels(c);
	      this.originalListOfChannels = c;
	
	      console.log("this.originalListOfChannels");
	      console.dir(this.originalListOfChannels);
	
	      this.makeUniqueListOfEvents(c);
	    }
	  }, {
	    key: "initv1",
	    value: function initv1(channelsResp, event) {
	      var _this = this;
	
	      _this.event = event;
	
	      var resp = {};
	
	      resp.channels = channelsResp.data;
	
	      console.log("initv1");
	      console.dir(resp);
	      console.dir(_this.event);
	
	      if (resp.channels) {
	        if (resp.channels.length > 0) {
	          _this.init(resp, _this.PubNub);
	        } else {
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("channelsHaveBeenLoaded", {});
	          });
	        }
	      }
	    }
	  }, {
	    key: "getChannelTrimmed",
	    value: function getChannelTrimmed(id) {
	      if (this.$localStorage) {
	        var url = this.$env.getAPIEndPoint() + "jbl/v1/users/" + this.$localStorage.logged_user.id + "/channels/" + id + "?format=json&conf=web&sort=lastUpdated&max=100&fields=users.id,users.firstName,users.lastName,users.companyPhone,users.username,users.picture1s,users.emailChatNotificationOn,smsChatNotificationOn,users.personalMobilePhone";
	        var req = {
	          method: "GET",
	          url: url,
	          headers: {
	            authorization: "Bearer " + this.$auth.getAccessToken()
	          },
	          data: {}
	        };
	        return this.$http(req);
	      }
	    }
	  }, {
	    key: "makeUniqueListOfEvents",
	    value: function makeUniqueListOfEvents(channels) {
	      var _this = this;
	      var uniqueEventIdArray = [];
	      if (!_this.originalListOfChannels) {
	        _this.originalListOfChannels = channels;
	      }
	      try {
	        channels.forEach(function (channel) {
	          _this.$rootScope.allChannelNames.push(channel.name);
	          _this.$rootScope.allChannelIds.push(channel.id);
	          var eventIdObj = {};
	          channel.selected = false;
	          eventIdObj.channelArrayHolder = [];
	          channel.event = {};
	          channel.channelUser = {};
	          channel.channelUser.timeToken1 = channel.channelUserTt1 ? channel.channelUserTt1 : +new Date(channel.startTime) * 10000;
	          channel.channelUser.connected = channel.channelUserConnected;
	
	          eventIdObj.timeZoneId = channel.contactInfo[0].timeZoneId;
	
	          var userTimeZoneName = moment.tz.guess();
	          var now = moment.tz(userTimeZoneName);
	          var nowThere = moment.tz(eventIdObj.timeZoneId);
	          var timeInSeconds = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
	          var startTimeAsMoment = moment(channel.startTime);
	          var endTimeAsMoment = moment(channel.endTime);
	
	          channel.startTime = startTimeAsMoment.subtract(timeInSeconds, "seconds").format();
	          channel.endTime = endTimeAsMoment.subtract(timeInSeconds, "seconds").format();
	
	          channel.event.startTime = channel.startTime;
	          channel.event.endTime = channel.endTime;
	          channel.event.contactInfo = {};
	          if (channel.contactInfo) {
	            channel.event.contactInfo.streetLine1 = channel.contactInfo[0].streetLine1;
	            channel.event.contactInfo.city = channel.contactInfo[0].city;
	            channel.event.contactInfo.state = channel.contactInfo[0].state;
	            channel.event.contactInfo.zipCode = channel.contactInfo[0].zipCode;
	            channel.event.contactInfo.timeZoneId = channel.contactInfo[0].timeZoneId;
	          }
	          eventIdObj.eventId = parseInt(channel.eventId, 10);
	          channel.event.startTime = channel.startTime;
	          channel.event.endTime = channel.endTime;
	
	          /*
	                  var nowThere = moment.tz(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].contactInfo.timeZoneId);
	                  var timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
	                  var startTimeAsMoment = moment(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.startTime);
	                  var endTimeAsMoment = moment(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.endTime);
	                  _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.startTime = startTimeAsMoment.subtract(timeInSec, 'seconds').format();
	                  _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.endTime = endTimeAsMoment.subtract(timeInSec, 'seconds').format();
	                  */
	
	          eventIdObj.eventStartTime = channel.startTime;
	          eventIdObj.eventLocation = channel.event.contactInfo.streetLine1 + " " + channel.event.contactInfo.city + ", " + channel.event.contactInfo.state + " " + channel.event.contactInfo.zipCode;
	          eventIdObj.eventName = channel.eventName;
	          eventIdObj.isSourcingPost = channel.event.isSourcingPost;
	          eventIdObj.timeIntervals = [];
	          var timeIntervalsData = {
	            startTime: channel.startTime,
	            endTime: channel.endTime
	          };
	          eventIdObj.timeIntervals.push(timeIntervalsData);
	          uniqueEventIdArray.push(eventIdObj);
	        });
	      } catch (err) {
	        console.log("messaging error");
	        console.dir(err);
	      } finally {
	        uniqueEventIdArray = _.uniqBy(uniqueEventIdArray, "eventId");
	
	        var listOfChannels = _this.originalListOfChannels.slice(0);
	        _this.nestChannelsWithinEvent(uniqueEventIdArray, listOfChannels);
	      }
	    }
	  }, {
	    key: "nestChannelsWithinEvent",
	    value: function nestChannelsWithinEvent(uniqueEventIdArray, originalListOfChannels) {
	      var originalListOfChannelsHolder = originalListOfChannels;
	      var tempList = originalListOfChannelsHolder;
	      var matchCounter = 0;
	      var _this = this;
	      var validChannels = [];
	      var validChannelNames = [];
	      var validChannelTokens = [];
	
	      try {
	        uniqueEventIdArray.forEach(function (ua) {
	          ua.newMessageCounter = 0;
	          tempList.forEach(function (channel, i) {
	            if (channel.eventId === ua.eventId && channel.channelUser.timeToken1) {
	              matchCounter = matchCounter + 1;
	              ua.channelArrayHolder.push(channel);
	              channel.hasHome = true;
	              validChannels.push(channel);
	            }
	          });
	        });
	      } finally {
	        this.matchCounter = matchCounter;
	        this.channelsNestedWithinEvents = uniqueEventIdArray;
	      }
	
	      validChannels.forEach(function (channel, x) {
	        if (x < 100) {
	          validChannelNames.push(channel.name);
	          validChannelTokens.push(channel.channelUser.timeToken1);
	        }
	      });
	
	      _this.PubNub.messageCounts({
	        channels: validChannelNames,
	        channelTimetokens: validChannelTokens
	      }, function (status, results) {
	        if (results) {
	          validChannels.forEach(function (channel) {
	            _this.setMissedMessageData(channel, parseInt(results.channels[channel.name], 10));
	          });
	        } else {
	          console.log("error in the result");
	        }
	      });
	    }
	  }, {
	    key: "setMissedMessageData",
	    value: function setMissedMessageData(channel, missedMessageCount) {
	      var _this = this;
	      channel.missedMessagesCount = missedMessageCount;
	      if (channel.missedMessagesCount > 0) {
	        channel.hasNewMessage = "new-message-highlight-new";
	        channel.hasNewMessageContainer = "new-message-highlight-new-container";
	        channel.hasNewMessageInbox = "new-message-highlight-new-container-inbox";
	        _this.totalAmountOfMissedMessages = _this.totalAmountOfMissedMessages + channel.missedMessagesCount;
	      }
	      channel.newMessageCounter = channel.missedMessagesCount;
	      _this.$timeout(function () {
	        _this.getLastMessage(channel);
	      });
	    }
	  }, {
	    key: "getLastMessage",
	    value: function getLastMessage(channel, isnew) {
	      var _this = this;
	      channel.lastMessage = {
	        channel: channel.name,
	        pubnub: this.PubNub,
	        callback: doNext
	      };
	      PubNubLib.getLastMessage(channel.lastMessage);
	
	      function doNext(response) {
	        channel.lastMessageData = response;
	        _this.handleLastMessageData(channel, isnew);
	      }
	    }
	  }, {
	    key: "handleLastMessageData",
	    value: function handleLastMessageData(channel, isnew) {
	      var _this = this;
	
	      this.handleLastMessageDataCounter = this.handleLastMessageDataCounter + 1;
	
	      if (!_this.$security.isUndefinedOrNull(channel.lastMessageData)) {
	        if (!_this.$security.isUndefinedOrNull(channel.lastMessageData.response)) {
	          channel.lastMessageData.response.message = channel.lastMessageData.response.entry;
	          channel.lastMessageData.response.timeTokenFormatted = new Date(channel.lastMessageData.response.timetoken / 1e4);
	          channel.lastMessageData.response.timeTokenFormattedFull = moment(new Date(channel.lastMessageData.response.timetoken / 1e4)).format();
	
	          var tokenToMoment = moment(channel.lastMessageData.response.timeTokenFormatted);
	          var diffBetweenNowAndThen = moment().diff(tokenToMoment, "days");
	
	          if (diffBetweenNowAndThen === 0) {
	            channel.lastMessageData.response.timeTokenFormatted = tokenToMoment.format("hh:mm a");
	          }
	
	          if (diffBetweenNowAndThen === 1) {
	            channel.lastMessageData.response.timeTokenFormatted = "Yesterday";
	          }
	
	          if (diffBetweenNowAndThen < 7 && diffBetweenNowAndThen !== 1 && diffBetweenNowAndThen !== 0) {
	            channel.lastMessageData.response.timeTokenFormatted = tokenToMoment.format("ddd, hh:mm a");
	          }
	
	          if (diffBetweenNowAndThen > 6 && diffBetweenNowAndThen !== 1 && diffBetweenNowAndThen !== 0) {
	            channel.lastMessageData.response.timeTokenFormatted = tokenToMoment.format("MMM DD");
	          }
	        } else {
	          channel.lastMessageData.response = {
	            message: {
	              messagePayload: {
	                message: "No messages"
	              }
	            }
	          };
	          channel.lastMessageData.response.timeTokenFormatted = "---";
	          channel.lastMessageData.response.noMessagesClass = "no-messages-class-inbox";
	        }
	      }
	
	      if (this.originalListOfChannels) {
	        if (this.originalListOfChannels.length === 0) {
	          _this.placeNewChannelInList(channel);
	        } else {
	          var counterOffset = _this.$rootScope.messagesOffsetparam ? _this.$rootScope.messagesOffsetparam : 0;
	          if (this.handleLastMessageDataCounter === this.matchCounter + counterOffset) {
	            _this.$timeout(function () {
	              if (isnew) {
	                _this.placeNewChannelInList(channel);
	              } else {
	                _this.addUpMissedMessages();
	              }
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: "trimEventName",
	    value: function trimEventName(event) {
	      if (event.eventName.length > 96) {
	        event.eventNameSubStr = event.eventName.substring(0, 96);
	        event.eventNameSubStr = event.eventNameSubStr + "...";
	      }
	    }
	  }, {
	    key: "addUpMissedMessages",
	    value: function addUpMissedMessages() {
	      var _this = this;
	      var arrayOfChannelsWithMissedMessages = [];
	      var arrayOfChannelsWithoutMissedMessages = [];
	      try {
	        _this.channelsNestedWithinEvents.forEach(function (ua) {
	          ua.show = false;
	          _this.trimEventName(ua);
	          ua.channelArrayHolder.forEach(function (channel) {
	            if (channel.missedMessagesCount > 0) {
	              arrayOfChannelsWithMissedMessages.push(ua);
	              ua.hasAtleastOneMissedMessage = true;
	            }
	            ua.newMessageCounter = ua.newMessageCounter + channel.missedMessagesCount;
	            if (ua.channelArrayHolder[ua.channelArrayHolder.length - 1] && !ua.hasAtleastOneMissedMessage) {
	              ua.hasAtleastOneMissedMessage = false;
	              arrayOfChannelsWithoutMissedMessages.push(ua);
	            }
	          });
	        });
	      } finally {
	        _this.channelsNestedWithinEvents.sort(firstBy(function (v1, v2) {
	          return v2.newMessageCounter - v1.newMessageCounter;
	        }));
	        _this.$timeout(function () {
	          _this.$rootScope.channels = _this.channelsNestedWithinEvents;
	          _this.$rootScope.channels.totalMessagesMissed = _this.totalAmountOfMissedMessages;
	          _this.$rootScope.channelsHaveLoaded = true;
	          _this.$rootScope.$emit("channelsHaveBeenLoaded", {});
	        });
	      }
	    }
	  }, {
	    key: "toastMessage",
	    value: function toastMessage(m, channel) {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("ToastMessage", {
	          m: m,
	          channel: channel
	        });
	      });
	    }
	  }, {
	    key: "deleteChannels",
	    value: function deleteChannels(arrayOfChannelIdToDelete) {
	      var _this = this;
	      arrayOfChannelIdToDelete.user = _this.$localStorage.logged_user.id;
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/channels/bulk-delete?format=json&conf=web&verbosity=1";
	      var req = {
	        method: "POST",
	        url: url,
	        headers: {
	          authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: arrayOfChannelIdToDelete
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "createOrReturnChannelTrimmed",
	    value: function createOrReturnChannelTrimmed(users, isGenerate, message_data) {
	      if (message_data) {
	        this.message_data = message_data;
	      }
	
	      if (!users.chat_name) {
	        users.allCompanyUsers = true;
	      } else {
	        users.allCompanyUsers = false;
	      }
	      if (isGenerate) {
	        var arrayObj = {
	          event: users.event,
	          is_default: true
	        };
	        users.events = [];
	        users.events.push(arrayObj);
	      }
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/channels/add-users-to-channel?format=json&conf=web&verbosity=5";
	      var req = {
	        method: "POST",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: users
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "handleSubTo",
	    value: function handleSubTo(channel, x, issub, isGroupChat) {
	      var _this = this;
	
	      if (_this.$rootScope.allChannelNames.indexOf(channel) > -1) {
	        console.log("it already exists");
	      } else {
	        _this.findChannel(channel, x, issub, isGroupChat);
	      }
	    }
	  }, {
	    key: "findChannel",
	    value: function findChannel(channel, m, issub, isGroupChat) {
	      var _this = this;
	
	      if (_this.someOneWasJustHired === true) {
	        //_this.someOneWasJustHired=false;
	      } else {
	        if (_this.$rootScope.allChannelNames) {
	          if (_this.$rootScope.allChannelNames.indexOf(channel) > -1) {
	            try {
	              _this.indexOfArg = _this.$rootScope.allChannelNames.indexOf(channel);
	            } finally {
	              if (!issub) {
	                _this.handleIncomingMessageForExistingChannel(m, issub);
	              }
	            }
	          } else {
	            _this.loadChannels(channel, issub, isGroupChat);
	          }
	        } else {
	          _this.loadChannels(channel, issub);
	        }
	      }
	    }
	  }, {
	    key: "loadChannels",
	    value: function loadChannels(channel, issub, isGroupChat) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        if (_this.pause_channel_loading !== true) {
	          _this.pause_channel_loading = true;
	          _this.getChannels(1).then(function (response) {
	            if (response.data.channels.length > 0) {
	              if (response.data.channels[0].name === channel) {
	                var data = {};
	                if (_this.$rootScope.allChannelNames.indexOf(channel) === -1) {
	                  _this.$rootScope.allChannelNames.push(name);
	                }
	                data.response = response;
	                data.channel = channel;
	                data.issub = issub;
	                data.isGroupChat = isGroupChat;
	                _this.addThisChannelToOurListOfChannels(data);
	                if (!issub) {
	                  var isnew = true;
	                  _this.matchCounter = _this.matchCounter + 1;
	                  _this.getLastMessage(response.data.channels[0], isnew);
	                  _this.storeTimeTokenForChannel(response.data.channels[0]);
	                }
	
	                _this.pause_channel_loading = false;
	              } else {}
	            } else {}
	          }, function (error) {
	            console.log(error);
	          });
	        }
	      }, 2000);
	    }
	  }, {
	    key: "initPubnub",
	    value: function initPubnub() {
	      var _this = this;
	
	      /*
	          _this.PubNub = new PubNub({
	              subscribeKey: _this.$env.getPubNubSubKey(),
	              publishKey: _this.$env.getPubNubPubKey(),
	              uuid: _this.$localStorage.logged_user.id,
	              ssl: true,
	          });
	           _this.PubNub.addListener({
	              message: function (message) {
	                  if (_.has(message.message, "UNSUB-TO")) {
	                      let unsubChannel = message["UNSUB-TO"];
	                      _this.stripChannelFromGlobalList(message.message, unsubChannel);
	                  } else {
	                      if (_.has(message.message, "SUB-TO")) {
	                          let subChannelToAdd = message.message["SUB-TO"];
	                          let issub = true;
	                          let isGroupChat = false;
	                          if (message.message.channelDesc === "Group Chat") {
	                              isGroupChat = true;
	                          }
	                          _this.handleSubTo(subChannelToAdd, null, issub, isGroupChat);
	                      } else {
	                          if (_this.$rootScope.activeChannel === message.channel) {
	                              _this.formatMessageAndPushToChat(message.message, message.channel);
	                          } else {
	                              if (_this.isNewChannel) {
	                                  _this.addNewChannelToList(_this.currentChannel, message.message.messagePayload.message);
	                                  _this.isCurrentUser(message.message.messagePayload, _this.currentChannel);
	                              } else {
	                                  _this.findChannel(message.channel, message.message, false);
	                              }
	                              if (message.message.messagePayload.userId !== _this.$localStorage.logged_user.id) {
	                                  _this.toastMessage(message.message, message.channel);
	                              }
	                          }
	                      }
	                  }
	              },
	              presence: function (presence) {
	                  _this.updateUserPresence(presence);
	              },
	              status: function (status) {
	                  console.log(status);
	              },
	          });
	           if (_this.$localStorage.logged_user.controlChannel) {
	              _this.controlChannelVal = _this.$localStorage.logged_user.controlChannel;
	          } else {
	              _this.controlChannelVal = _this.$localStorage.logged_user.email.replace(/\./g, "");
	          }
	           _this.PubNub.channelGroups.addChannels(
	              {
	                  channels: [_this.controlChannelVal],
	                  channelGroup: _this.controlChannelVal,
	              },
	              function (status, response) {
	                  if (status.statusCode === 200) {
	                      console.log("subscribe only if status is ok");
	                      _this.PubNub.subscribe({
	                          channelGroups: [_this.controlChannelVal],
	                          withPresence: true,
	                          triggerEvents: ["message", "presence", "status"],
	                      });
	                  }
	              }
	          );
	           */
	    }
	  }, {
	    key: "addThisChannelToOurListOfChannels",
	    value: function addThisChannelToOurListOfChannels(info) {
	      var _this = this;
	    }
	  }, {
	    key: "PubNubAddChannelToGroup",
	    value: function PubNubAddChannelToGroup(channel) {
	      var _this = this;
	      _this.PubNub.channelGroups.addChannels({
	        channelGroup: _this.controlChannelVal,
	        channels: [channel]
	      }, function (status, response) {
	        console.log("PubNubAddChannelToGroup status, response");
	        console.log(status, response);
	      });
	    }
	  }, {
	    key: "addNewChannelToList",
	    value: function addNewChannelToList(channel, message) {
	      var _this = this;
	      var now = moment().format("hh:mm a");
	
	      _this.PubNub.time().then(function (time) {
	        var timeTokenVal = time.timetoken;
	        channel.lastMessage = {
	          callback: doNext,
	          channel: channel.name,
	          pubnub: _this.PubNub
	        };
	        channel.lastMessageData = {
	          channel: channel.name,
	          error: false,
	          response: {
	            timeTokenFormatted: now,
	            timetoken: timeTokenVal,
	            message: {
	              messagePayload: {
	                message: message,
	                userId: _this.$localStorage.logged_user.id,
	                username: "Manager"
	              },
	              pn_apns: null,
	              pn_gcm: null
	            }
	          }
	        };
	        channel.hasHome = true;
	        channel.missedMessagesCount = 0;
	        channel.newMessageCounter = 0;
	        channel.selected = false;
	
	        function doNext() {
	          _this.handleLastMessageData(channel);
	        }
	
	        _this.setMissedMessagesData(channel);
	      });
	    }
	  }, {
	    key: "setMissedMessagesData",
	    value: function setMissedMessagesData(channel) {
	      var _this = this;
	      channel.missedMessagesData = {
	        callback: doNext,
	        channel: channel.name,
	        pubnub: _this.PubNub,
	        timeToken: null
	      };
	
	      function doNext(response) {
	        _this.setMissedMessageData(channel, response);
	      }
	
	      _this.placeNewChannelInList(channel);
	    }
	  }, {
	    key: "placeNewChannelInList",
	    value: function placeNewChannelInList(channel) {
	      var _this = this;
	      if (!_this.$rootScope.channels) {
	        var eventIdObj = {};
	        channel.selected = false;
	        eventIdObj.channelArrayHolder = [];
	        eventIdObj.eventId = parseInt(channel.eventId, 10);
	        eventIdObj.eventStartTime = channel.eventStartTime;
	        eventIdObj.eventName = channel.eventName;
	        eventIdObj.channelArrayHolder.push(channel);
	        _this.$timeout(function () {
	          _this.$rootScope.allChannelNames = [];
	          _this.$rootScope.allChannelNames.push(channel.name);
	          _this.$rootScope.channels = [];
	          _this.$rootScope.channels.push(eventIdObj);
	          _this.$rootScope.channelsHaveLoaded = true;
	          _this.$rootScope.$emit("channelsHaveBeenLoaded", {});
	        });
	      } else {
	        var found = false;
	        try {
	          for (var i = 0; i < _this.$rootScope.channels.length; i++) {
	            if (_this.$rootScope.channels[i].eventId === channel.eventId) {
	              _this.$rootScope.channels[i].channelArrayHolder.unshift(channel);
	              found = true;
	              break;
	            }
	          }
	        } finally {
	          if (!found) {
	            _this.createNewParentEvent(channel);
	          }
	          _this.isNewChannel = false;
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("SetChannels", {
	              channel: channel.name
	            });
	            _this.$rootScope.$emit("StopLoader", {});
	          });
	        }
	      }
	    }
	  }, {
	    key: "createNewParentEvent",
	    value: function createNewParentEvent(channel) {
	      var _this = this;
	      var eventIdObj = {};
	      channel.selected = false;
	      eventIdObj.channelArrayHolder = [];
	      eventIdObj.eventId = parseInt(channel.eventId, 10);
	      if (channel.eventStartTime) {
	        eventIdObj.eventStartTime = channel.eventStartTime;
	      } else {
	        eventIdObj.eventStartTime = channel.event.startTime;
	      }
	      if (channel.eventName) {
	        eventIdObj.eventName = channel.eventName;
	      } else {
	        eventIdObj.eventName = channel.event.name;
	      }
	      if (!channel.eventLocation) {
	        eventIdObj.eventLocation = channel.event.contactInfo.streetLine1 + " " + channel.event.contactInfo.city + ", " + channel.event.contactInfo.state + " " + channel.event.contactInfo.zipCode;
	      }
	      if (!eventIdObj.timeIntervals) {
	        eventIdObj.timeIntervals = [];
	        var timeIntervalsData = {
	          startTime: channel.startTime,
	          endTime: channel.endTime
	        };
	        eventIdObj.timeIntervals.push(timeIntervalsData);
	      }
	      if (_angular2.default.isUndefined(eventIdObj.newMessageCounter)) {
	        eventIdObj.newMessageCounter = 0;
	      }
	      eventIdObj.channelArrayHolder.push(channel);
	      _this.$timeout(function () {
	        _this.$rootScope.allChannelNames = [];
	        _this.$rootScope.allChannelNames.push(channel.name);
	        _this.$rootScope.allChannelIds.push(channel.id);
	        _this.$rootScope.channels.unshift(eventIdObj);
	      });
	    }
	  }, {
	    key: "publishMessage",
	    value: function publishMessage(messageToPublish, encodedUrl, fileURL, userForMessage, blocksPayload, eventId, channel, isNewChannel, channelNameArg, indexOfArg, channelId) {
	      var _this = this;
	
	      messageToPublish = messageToPublish.trim();
	
	      _this.pause_channel_loading = false;
	      var channelName = null;
	      var pdfURL = null;
	
	      if (fileURL) {
	        if (fileURL.toLowerCase().includes(".pdf?")) {
	          pdfURL = fileURL;
	        }
	      }
	
	      _this.isNewChannel = isNewChannel;
	      if (channel) {
	        _this.currentChannel = channel;
	        channelName = channel.name;
	      } else {
	        channelName = channelNameArg;
	      }
	      if (indexOfArg) {
	        _this.indexOfArg = indexOfArg;
	      }
	
	      var messageHolder = {};
	      var messageWrapper = {};
	
	      messageWrapper.username = this.$localStorage.logged_user.firstName + " " + this.$localStorage.logged_user.lastName;
	      messageWrapper.message = messageToPublish;
	      messageWrapper.eventId = eventId;
	      messageWrapper.channelId = channelId;
	      messageWrapper.companyName = this.$localStorage.logged_user.company.name;
	      messageWrapper.userId = this.$localStorage.logged_user.id;
	      messageWrapper.image = encodedUrl;
	      messageWrapper.imageURL = pdfURL ? null : fileURL;
	      messageWrapper.pdfURL = pdfURL;
	      messageWrapper.timetoken = moment().format("hh:mm a");
	      messageHolder.message = messageWrapper;
	
	      var formattedMessage = {
	        pn_apns: {
	          aps: {
	            alert: messageToPublish,
	            badge: 1
	          },
	          source: "pubnub"
	        },
	        pn_gcm: {
	          data: {
	            payload: {
	              android: {
	                title: "Jobble QA Message",
	                alert: messageToPublish,
	                sound: "default",
	                vibrate: true
	              },
	              source: "pubnub"
	            }
	          }
	        },
	        messagePayload: {
	          userId: this.$localStorage.logged_user.id,
	          manager: this.$localStorage.logged_user.firstName,
	          username: this.$localStorage.logged_user.firstName + " " + this.$localStorage.logged_user.lastName,
	          message: messageToPublish,
	          channelId: channelId,
	          authToken: this.$localStorage.logged_user.access_token,
	          eventId: eventId,
	          companyName: this.$localStorage.logged_user.company.name,
	          image: encodedUrl,
	          imageURL: pdfURL ? null : fileURL,
	          pdfURL: pdfURL
	        },
	        blocksPayload: blocksPayload
	      };
	
	      if (encodeURIComponent(channelName + JSON.stringify(formattedMessage)).length + 100 > 32000) {
	        alert("unfortunately the message size it too large. Please shorten and send again.");
	      } else {
	        _this.PubNub.publish({
	          channel: channelName,
	          message: formattedMessage
	        }, function (status, response) {});
	      }
	    }
	  }, {
	    key: "generateBlockList",
	    value: function generateBlockList(jobblers) {
	      var _this = this;
	      var recipientsArray = [];
	      var blocksPayload = {
	        senderUserOrigin: "web"
	      };
	
	      try {
	        jobblers.forEach(function (jobbler) {
	          var recipientsObj = {};
	          if (!jobbler.username) {
	            jobbler.username = jobbler.email;
	          }
	          if (!jobbler.personalPhoneMobile && !jobbler.homeContactInfo) {
	            jobbler.personalPhoneMobile = jobbler.numberOrig;
	          }
	
	          if (jobbler.username !== _this.$localStorage.logged_user.email) {
	            recipientsObj.email = jobbler.username;
	            recipientsObj.firstName = jobbler.firstName;
	            recipientsObj.lastName = jobbler.lastName;
	            recipientsObj.userOrigin = "web";
	            recipientsObj.emailChatNotificationOn = jobbler.emailChatNotificationOn;
	            recipientsObj.smsChatNotificationOn = jobbler.smsChatNotificationOn;
	            if (jobbler.personalMobilePhone) {
	              recipientsObj.personalMobilePhone = jobbler.personalPhoneMobile;
	            }
	            if (jobbler.homeContactInfo) {
	              recipientsObj.personalMobilePhone = jobbler.homeContactInfo.phoneMobile;
	            }
	            recipientsObj.companyPhone = jobbler.companyPhone;
	            recipientsArray.push(recipientsObj);
	          }
	        });
	      } finally {
	        blocksPayload.recipients = recipientsArray;
	        return blocksPayload;
	      }
	    }
	  }, {
	    key: "getPubNubTime",
	    value: function getPubNubTime(channel, findChannelInScopeList) {
	      var _this = this;
	      if (findChannelInScopeList) {
	        var t;
	        try {
	          for (var i = 0; i < _this.unsortedChannelList.length; i++) {
	            if (_this.unsortedChannelList[i].name === channel) {
	              t = _this.unsortedChannelList[i];
	              break;
	            }
	          }
	        } finally {
	          if (t) {
	            _this.PubNub.time().then(function (time) {
	              t.timeTokenOfLastMessageSeenByUser = time.timetoken;
	              _this.storeTimeTokenForChannel(t);
	            });
	          }
	        }
	      } else {
	        _this.PubNub.time().then(function (time) {
	          channel.timeTokenOfLastMessageSeenByUser = time.timetoken;
	          _this.storeTimeTokenForChannel(channel);
	        });
	      }
	    }
	  }, {
	    key: "storeTimeTokenForChannel",
	    value: function storeTimeTokenForChannel(channel) {
	      var _this = this;
	      var chArray = [];
	
	      if (channel) {
	        _this.PubNub.time().then(function (time) {
	          channel.timeTokenOfLastMessageSeenByUser = time.timetoken;
	          var chObj = {
	            ch: channel.id,
	            tt1: channel.timeTokenOfLastMessageSeenByUser
	          };
	          chArray.push(chObj);
	          var channelsAndTimeTokens = { channelsAndTimeTokens: chArray };
	          var url = _this.$env.getAPIEndPoint() + "jbl/v1/channels/save-time-tokens?format=json&conf=web";
	          var req = {
	            method: "POST",
	            url: url,
	            headers: {
	              authorization: "Bearer " + _this.$auth.getAccessToken()
	            },
	            data: channelsAndTimeTokens
	          };
	          return _this.$http(req).then(function (response) {
	            console.log(response);
	          });
	        });
	      }
	    }
	  }, {
	    key: "handleIncomingMessageForExistingChannel",
	    value: function handleIncomingMessageForExistingChannel(messagePayload, issub) {
	      var _this = this;
	      if (!issub) {
	        var channel;
	        try {
	          channel = _this.originalListOfChannels[_this.indexOfArg];
	        } finally {
	          if (messagePayload.messagePayload.userId === this.$localStorage.logged_user.id) {
	            _this.storeTimeTokenForChannel(channel);
	          }
	          _this.updateLastMessage(channel, messagePayload);
	        }
	      }
	    }
	  }, {
	    key: "updateLastMessage",
	    value: function updateLastMessage(channel, message) {
	      var _this = this;
	      if (channel) {
	        channel.missedMessagesCount = channel.missedMessagesCount + 1;
	      }
	      if (_this.$rootScope.channels) {
	        _this.$rootScope.channels.totalMessagesMissed = _this.$rootScope.channels.totalMessagesMissed + 1;
	      }
	      if (channel.lastMessageData.response) {
	        channel.lastMessageData.response.message.messagePayload = message.messagePayload;
	        channel.lastMessageData.response.timetoken = null;
	        channel.lastMessageData.response.timeTokenFormatted = moment().format("hh:mm a");
	        channel.lastMessageData.response.timeTokenFormattedFull = moment().format();
	      }
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetChannels", {
	          channel: channel
	        });
	      });
	    }
	  }, {
	    key: "isCurrentUser",
	    value: function isCurrentUser(message, channel) {
	      var _this = this;
	      if (message.userId === _this.$localStorage.logged_user.id) {
	        _this.storeTimeTokenForChannel(channel);
	      }
	    }
	  }, {
	    key: "updateUserPresence",
	    value: function updateUserPresence(presence) {
	      var _this = this;
	      if (presence.channel === _this.$rootScope.activeChannel) {
	        _this.$rootScope.$emit("UpdatePresence", {
	          channel: presence.channel,
	          action: presence.action,
	          uuid: presence.uuid
	        });
	      }
	    }
	  }, {
	    key: "getChatHistory",
	    value: function getChatHistory(channel, timeToken) {
	      var _this = this;
	      _this.PubNub.history({
	        start: timeToken,
	        channel: channel,
	        stringifiedTimeToken: true,
	        reverse: false,
	        count: 100
	      }, function (status, response) {
	        console.log("getChatHistory status response");
	        console.log(status, response);
	
	        if (response.messages.length === 0) {
	          return;
	        }
	        _this.$rootScope.paginationMessages = response.messages;
	        Array.prototype.push.apply(_this.$rootScope.paginationMessages, _this.$rootScope.activeMessages);
	        _this.$rootScope.activeMessages = _this.$rootScope.paginationMessages;
	
	        var startTimeToken = response.startTimeToken;
	        if (_this.$rootScope.activeMessages !== "undefined" && _this.$rootScope.activeMessages.length > 0) {
	          _this.$rootScope.startToken = startTimeToken;
	        }
	
	        try {
	          _this.$rootScope.activeMessages.forEach(function (msg) {
	            msg.message = msg.entry;
	            msg.timetokenFormatted = moment(new Date(msg.timetoken / 1e4)).format("MM/DD/YY hh:mm a");
	            if (msg.message.messagePayload.imageURL) {
	              _this.arrayOfImageUrlsForGallery.push(msg.message.messagePayload.imageURL);
	            }
	          });
	        } finally {
	          _this.$timeout(function () {
	            _this.$rootScope.photos = _this.arrayOfImageUrlsForGallery;
	          });
	        }
	      });
	    }
	  }, {
	    key: "collectJobblersForPresence",
	    value: function collectJobblersForPresence(jobblers) {
	      var _this = this;
	      if (jobblers) {
	        if (jobblers.length > 0 && !_this.$security.isUndefinedOrNull(jobblers)) {
	          try {
	            for (var i = 0; i < jobblers.length; i++) {
	              var temp = null;
	              if (jobblers[i].username) {
	                temp = jobblers[i].username.replace(/\./g, "");
	              } else {
	                temp = jobblers[i].applicant.username.replace(/\./g, "");
	              }
	
	              if (_this.$rootScope.arrayOfUniqueOnlineUsers) {
	                for (var x = 0; x < _this.$rootScope.arrayOfUniqueOnlineUsers.length; x++) {
	                  if (_this.$rootScope.arrayOfUniqueOnlineUsers[x].uuid === temp) {
	                    jobblers[i].isConnected = true;
	                  }
	                }
	              }
	            }
	          } finally {
	            console.log("finally running");
	          }
	        }
	      }
	    }
	  }, {
	    key: "subtractMissedMessagesFromGlobalBadge",
	    value: function subtractMissedMessagesFromGlobalBadge(channel, event) {
	      var _this = this;
	      channel.hasNewMessage = undefined;
	      channel.hasNewMessageContainer = undefined;
	      channel.hasNewMessageInbox = undefined;
	
	      event.newMessageCounter = event.newMessageCounter - channel.missedMessagesCount;
	      channel.newMessageCounter = event.newMessageCounter - channel.missedMessagesCount;
	      _this.$rootScope.channels.totalMessagesMissed = _this.$rootScope.channels.totalMessagesMissed - channel.missedMessagesCount;
	      channel.missedMessagesCount = 0;
	    }
	  }, {
	    key: "formatMessageAndPushToChat",
	    value: function formatMessageAndPushToChat(message, channel) {
	      var _this = this;
	      var messagePayload = {};
	      messagePayload.username = message.messagePayload.username;
	      messagePayload.image = message.messagePayload.image;
	      messagePayload.imageURL = message.messagePayload.imageURL;
	      messagePayload.pdfURL = message.messagePayload.pdfURL;
	      messagePayload.message = message.messagePayload.message;
	      messagePayload.userId = message.messagePayload.userId;
	      messagePayload.userProfileImage = message.messagePayload.userProfileImage;
	      messagePayload.timetoken = moment().format("hh:mm a");
	      var messagePayloadTwo = {
	        messagePayload: messagePayload
	      };
	      var messagePayLoadHolder = {
	        message: messagePayloadTwo
	      };
	
	      _this.$timeout(function () {
	        try {
	          if (_this.$security.isUndefinedOrNull(_this.$rootScope.activeMessages)) {
	            _this.$rootScope.activeMessages = [];
	            _this.$rootScope.activeMessages.push(messagePayLoadHolder);
	          } else {
	            _this.$rootScope.activeMessages.push(messagePayLoadHolder);
	          }
	        } finally {
	          if (messagePayLoadHolder.message.messagePayload.imageURL) {
	            _this.$rootScope.photos.push(messagePayLoadHolder.message.messagePayload.imageURL);
	          }
	          _this.$rootScope.$emit("UpdateLastMessage", {
	            channel: channel,
	            message: messagePayload
	          });
	        }
	      });
	    }
	  }, {
	    key: "setHandleLastMessageDataCounter",
	    value: function setHandleLastMessageDataCounter(x) {
	      var _this = this;
	      _this.handleLastMessageDataCounter = x;
	    }
	  }, {
	    key: "setTotalAmountOfMissedMessages",
	    value: function setTotalAmountOfMissedMessages(x) {
	      var _this = this;
	      _this.totalAmountOfMissedMessages = x;
	    }
	  }, {
	    key: "stripChannelFromGlobalList",
	    value: function stripChannelFromGlobalList(data, channelName) {
	      var _this = this;
	      var events = _this.$rootScope.channels;
	      var channelToUnsubTo = channelName;
	      events.forEach(function (event, index) {
	        var channels = event.channelArrayHolder;
	        var matchedChannelIndex = channels.findIndex(function (i) {
	          return i.name === channelToUnsubTo;
	        });
	        if (matchedChannelIndex > -1) {
	          _this.stripParentLevelEvent(channels[matchedChannelIndex], events[index]);
	          channels.splice(matchedChannelIndex, 1);
	        }
	      });
	    }
	  }, {
	    key: "handleChannelSub",
	    value: function handleChannelSub(channel) {
	      var _this = this;
	      var channel_array = [];
	      channel_array.push(channel);
	      console.log("handleChannelSub");
	      console.log("handleChannelSub");
	      console.log("handleChannelSub");
	      console.log("handleChannelSub");
	
	      //_this.subscribeToAllChannels(channel_array);
	    }
	  }, {
	    key: "subscribeToAllChannels",
	    value: function subscribeToAllChannels(channels) {
	      var _this = this;
	      var channelNames = [];
	      channels.forEach(function (channel) {
	        channelNames.push(channel.name);
	      });
	      _this.PubNub.channelGroups.addChannels({
	        channelGroup: _this.controlChannelVal,
	        channels: channelNames
	      }, function (status, response) {
	        console.log("subscribeToAllChannels status, response");
	        console.log(status, response);
	      });
	    }
	  }, {
	    key: "stripParentLevelEvent",
	    value: function stripParentLevelEvent(channel, parentLevelEvent) {
	      var _this = this;
	      if (parentLevelEvent.channelArrayHolder.length === 1) {
	        var eventIdToSplice = parentLevelEvent.id;
	        var matchedEventIndex = _this.$rootScope.channels.findIndex(function (i) {
	          return i.id === eventIdToSplice;
	        });
	        _this.$rootScope.channels.splice(matchedEventIndex, 1);
	      }
	    }
	  }, {
	    key: "getChannel",
	    value: function getChannel(id) {
	      if (this.$localStorage) {
	        var url = this.$env.getAPIEndPoint() + "jbl/v1/users/" + this.$localStorage.logged_user.id + "/channels/" + id + "?format=json&conf=web&sort=lastUpdated&max=100&connected=true&verbosity=5";
	        var req = {
	          method: "GET",
	          url: url,
	          headers: {
	            authorization: "Bearer " + this.$auth.getAccessToken()
	          },
	          data: {}
	        };
	        return this.$http(req);
	      }
	    }
	  }, {
	    key: "getApplication",
	    value: function getApplication(applicationId) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/applications/" + applicationId + "/?format=json&conf=web";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "removeUserFromChannel",
	    value: function removeUserFromChannel(data) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/channels/rmv-users-from-channel?format=json&conf=web";
	      var req = {
	        method: "POST",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: data
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "pause_channel_loading_func",
	    value: function pause_channel_loading_func(ch) {
	      var _this = this;
	      console.log("pause_channel_loading_func");
	      _this.pause_channel_loading = true;
	      _this.channels_in_queue.push(ch);
	
	      console.log("what are the channels in the queue...");
	      console.dir(_this.channels_in_queue);
	    }
	  }]);
	
	  return Messagingv2Service;
	}();
	
	exports.default = Messagingv2Service;
	
	
	Messagingv2Service.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "env", "$rootScope", "$timeout"];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(32);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobblefooter.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobblefooter.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".jobblefooter{color:red}", ""]);
	
	// exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _jobbleheader = __webpack_require__(34);
	
	var _jobbleheader2 = _interopRequireDefault(_jobbleheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobbleheaderModule = _angular2.default.module("jobbleheader-old", [_angularUiRouter2.default]).component("jobbleheader-old", _jobbleheader2.default);
	
	exports.default = jobbleheaderModule;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobbleheader = __webpack_require__(35);
	
	var _jobbleheader2 = _interopRequireDefault(_jobbleheader);
	
	var _jobbleheader3 = __webpack_require__(36);
	
	var _jobbleheader4 = _interopRequireDefault(_jobbleheader3);
	
	__webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobbleheaderComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _jobbleheader2.default,
	  controller: _jobbleheader4.default,
	  controllerAs: "vm"
	};
	
	exports.default = jobbleheaderComponent;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"mobile-menu-wrap\">\n  <!--mobile-menu-closed-->\n  <a href=\"#\" class=\"navbar-close\" ng-click=\"vm.closeSideBar()\">\n    <div class=\"icon-bar-box\">\n      <span class=\"icon-bar\"></span>\n      <span class=\"icon-bar\"></span>\n    </div>\n  </a>\n  <!--mobile-menu-closed-->\n  <!--mobile-nav-->\n  <div class=\"mobile-nav mobile-nav-company\" ng-if=\"!vm.isJobSeeker\">\n    <ul>\n      <li><a href=\"/post-a-shift/walkthrough\">Post Job</a></li>\n      <li><a href=\"/events\">Jobs</a></li>\n      <li><a href=\"/events-history\">History</a></li>\n      <li><a href=\"/teams\">Teams</a></li>\n      <li><a href=\"/inbox\">Messages</a></li>\n      <li><a href=\"\" ng-click=\"vm.signOut()\">Logout</a></li>\n    </ul>\n  </div>\n\n  <div class=\"mobile-nav mobile-nav-jobbler\" ng-if=\"vm.isJobSeeker\">\n    <ul>\n      <li><a href=\"/jobs\">Jobble Board</a></li>\n      <li>\n        <a href=\"/jobbler/{{vm.currentUser.id}}\" ng-if=\"vm.currentUser\">Profile</a>\n      </li>\n      <li>\n        <a href=\"/signin\" ng-if=\"!vm.currentUser\">Login</a>\n      </li>\n      <li>\n        <a href=\"#\" ng-click=\"vm.signOut()\" ng-if=\"vm.currentUser\">Log out</a>\n      </li>\n    </ul>\n  </div>\n  <!--mobile-nav-->\n</div>\n\n<header class=\"header-section clearfix\" ng-if=\"!vm.isJobSeeker\">\n  <div class=\"noti-message\" ng-if=\"vm.showNoti\">\n    <div class=\"noti-message-left\" ng-click=\"vm.closeNoti(1)\">x</div>\n    <div class=\"noti-message-right\">Message sent</div>\n  </div>\n\n  <div class=\"noti-message\" style=\"width: 15%\" ng-if=\"vm.showAuto\">\n    <div class=\"noti-message-left\" ng-click=\"vm.closeAutoSave()\">x</div>\n    <div class=\"noti-message-right\">Saving Progress...</div>\n  </div>\n\n  <div class=\"logo pull-left\">\n    <!--logo-->\n    <div class=\"logo\">\n      <a href=\"/events\"> <img src=\"app/vendor/images/logo-red.png\" alt=\"Jobble Biz\" title=\"Jobble Biz\" /></a>\n    </div>\n    <!--logo-->\n  </div>\n\n  <div class=\"header-right pull-right\">\n    <button class=\"navbar-toggle menu-toggle\" type=\"button\" ng-click=\"vm.slideToggle()\">\n      <span class=\"sr-only\">Toggle navigation</span>\n      <span class=\"icon-bar\"></span>\n      <span class=\"icon-bar\"></span>\n      <span class=\"icon-bar\"></span>\n    </button>\n\n    <div class=\"user-login dropdown pull-right\">\n      <a href=\"#\" class=\"user-avatar dropdown-toggle\" id=\"dropdownMenu1\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\">\n        <img\n          ng-if=\"!$root.imgFromProfilePage\"\n          ng-src=\"{{ vm.currentUser.company.companyLogoUri ? vm.currentUser.company.companyLogoUri : '/app/vendor/images/user-more.png' }}\"\n          id=\"header-image-right\"\n        />\n        <img ng-if=\"$root.imgFromProfilePage\" ng-src=\"{{ $root.imgFromProfilePage }}\" alt=\"\" id=\"header-image-right\" />\n      </a>\n\n      <ul class=\"dropdown-menu dropdown\" aria-labelledby=\"dropdownMenu1\">\n        <li>\n          <a href=\"/account-profile\" ng-click=\"vm.reportHeaderDropDownClick(1)\">Account</a>\n        </li>\n        <li>\n          <a href=\"/direct-pay\" ng-click=\"vm.reportHeaderDropDownClick(2)\">Direct Pay</a>\n        </li>\n        <li>\n          <a href=\"https://jobble.com/help/business\" ng-click=\"vm.reportHeaderDropDownClick(3)\" target=\"_blank\" rel=\"noopener\">Help Center</a>\n        </li>\n        <li>\n          <a href=\"\" ng-click=\"vm.signOut()\" ng-click=\"vm.reportHeaderDropDownClick(4)\">Log Out</a>\n        </li>\n      </ul>\n    </div>\n\n    <nav class=\"main-menu pull-right\" style=\"position: relative\">\n      <ul>\n        <li class=\"selected\">\n          <a href=\"#\" ng-click=\"vm.showPostScrollFunc()\" ng-focus=\"vm.showPostFocus()\" ng-blur=\"vm.showPostBlur()\">\n            <i class=\"fa fa-folder-o\" aria-hidden=\"true\"></i> Post Job\n          </a>\n          <postingdropdown></postingdropdown>\n        </li>\n        <li>\n          <a href=\"#\" ng-click=\"vm.showJobScroll()\" ng-focus=\"vm.jobDropDownFocus()\" ng-blur=\"vm.jobDropDownBlur()\">\n            <i class=\"fa fa-list-ul\" aria-hidden=\"true\"></i> Jobs\n          </a>\n          <jobsdropdown></jobsdropdown>\n        </li>\n        <li>\n          <a href=\"/invoices\">\n            <i class=\"fa fa-wpforms\" aria-hidden=\"true\"></i>\n            Receipts\n          </a>\n        </li>\n        <li>\n          <a href=\"/teams\"> <i class=\"fa fa-users\" aria-hidden=\"true\"></i> Teams </a>\n        </li>\n        <li>\n          <a ng-click=\"vm.inboxLink()\">\n            <i class=\"fa fa-comments-o\" ng-if=\"$root.channelsHaveLoaded\" aria-hidden=\"true\"></i>\n            <img src=\"/app/vendor/images/spinner.gif\" style=\"width: 15px; margin-top: 6px; z-index: 7000\" ; ng-if=\"!$root.channelsHaveLoaded\" />\n            Messages\n            <span\n              class=\"number-box\"\n              style=\"font-size: 12px; float: right; margin: 0px 0px 0px 12px; padding: 0px 0px 3px 0px\"\n              ng-if=\"$root.channelsHaveLoaded && $root.channels.totalMessagesMissed > 0\"\n              >{{ $root.channels.totalMessagesMissed }}</span\n            >\n          </a>\n        </li>\n      </ul>\n    </nav>\n  </div>\n</header>\n\n<header class=\"header-section clearfix\" ng-if=\"vm.isJobSeeker\">\n  <div ng-class=\"{'noti-message-application-error':vm.appError,'noti-message-application-success':!vm.appError}\" ng-if=\"vm.applicationText\">\n    <div class=\"noti-message-left\" ng-click=\"vm.closeNotiApp()\">x</div>\n    <div class=\"noti-message-right\">{{ vm.applicationText }}</div>\n    <div class=\"noti-message-full\">\n      <a href=\"#\" ng-click=\"vm.moreInfoModal()\">Click here for more information</a>\n    </div>\n  </div>\n\n  <div class=\"logo pull-left\">\n    <!--logo-->\n    <div class=\"logo\">\n      <a href=\"/jobs\">\n        <img src=\"app/vendor/images/logo-red.png\" alt=\"Jobble Biz\" title=\"Jobble Biz\" />\n      </a>\n    </div>\n\n    <!--logo-->\n  </div>\n\n  <div class=\"cta-header-link\">\n    <input type=\"text\" class=\"form-control form-input\" style=\"width: 250px\" placeholder=\"Search job title or keyboard\" />\n  </div>\n\n  <div class=\"header-right pull-right\">\n    <button class=\"navbar-toggle\" type=\"button\" ng-click=\"vm.slideToggle()\">\n      <span class=\"sr-only\">Toggle navigation</span>\n      <span class=\"icon-bar\"></span>\n      <span class=\"icon-bar\"></span>\n      <span class=\"icon-bar\"></span>\n    </button>\n\n    <div class=\"user-login dropdown pull-right\">\n      <a href=\"#\" class=\"user-avatar dropdown-toggle\" id=\"dropdownMenu1\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\">\n        <img\n          ng-if=\"!$root.imgFromProfilePage\"\n          ng-src=\"{{ vm.currentUser.profilePictureUri ? vm.currentUser.profilePictureUri : '/app/vendor/images/user-more.png' }}\"\n          id=\"header-image-right\"\n        />\n\n        <img ng-if=\"$root.imgFromProfilePage\" ng-src=\"{{$root.imgFromProfilePage}}\" alt=\"\" id=\"header-image-right\" />\n      </a>\n      <ul class=\"dropdown-menu dropdown\" aria-labelledby=\"dropdownMenu1\" ng-if=\"!vm.currentUser\">\n        <li><a href=\"/signup/jobbler\">Register</a></li>\n        <li><a href=\"/signin\">Login</a></li>\n      </ul>\n\n      <ul class=\"dropdown-menu dropdown\" aria-labelledby=\"dropdownMenu1\" ng-if=\"vm.currentUser\">\n        <li>\n          <a href=\"/jobbler/{{vm.currentUser.id}}\" ng-if=\"vm.currentUser\">Profile</a>\n        </li>\n        <li><a href=\"\" ng-click=\"vm.signOut()\">Logout</a></li>\n      </ul>\n    </div>\n\n    <nav class=\"main-menu pull-right\">\n      <ul>\n        <li>\n          <a href=\"/jobs\"> <i class=\"fa fa-list-ul\" aria-hidden=\"true\"></i> Jobble Board </a>\n        </li>\n        <li>\n          <a href=\"#\" ng-click=\"vm.funnelToMobileApp(1)\" data-toggle=\"modal\" data-target=\"#funnel-user-to-app\" class=\"blur\">\n            <i class=\"fa fa-wpforms\" aria-hidden=\"true\"></i>\n            Applications\n          </a>\n        </li>\n        <li>\n          <a href=\"#\" ng-click=\"vm.funnelToMobileApp(2)\" data-toggle=\"modal\" data-target=\"#funnel-user-to-app\" class=\"blur\">\n            <i class=\"fa fa-comments-o\" aria-hidden=\"true\"></i>\n            Messages\n          </a>\n        </li>\n        <li>\n          <a href=\"#\" ng-click=\"vm.funnelToMobileApp(3)\" data-toggle=\"modal\" data-target=\"#funnel-user-to-app\" class=\"blur\">\n            <i class=\"fa fa-folder-o\" aria-hidden=\"true\"></i> My Jobs\n          </a>\n        </li>\n        <li>\n          <a href=\"#\" ng-click=\"vm.funnelToMobileApp(4)\" data-toggle=\"modal\" data-target=\"#funnel-user-to-app\" class=\"blur\">\n            <i class=\"fa fa-money\" aria-hidden=\"true\"></i> Payments\n          </a>\n        </li>\n      </ul>\n    </nav>\n  </div>\n</header>\n\n<div class=\"modal fade\" id=\"funnel-user-to-app\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header popup-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\"></i>\n            </button>\n\n            <img style=\"width: 47px\" src=\"/app/vendor/images/clock-with-shadow.png\" />\n\n            <h3 class=\"modal-title\" style=\"border-bottom: 1px solid #eee; padding-bottom: 15px\">Feature not available</h3>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                <p>This feature is currently not available.</p>\n                <p>\n                  We are working hard to get this feature on our web app. Please check back later or download our mobile app to access all of our\n                  features.\n                </p>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12\" style=\"padding-bottom: 20px\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                  <a href=\"https://itunes.apple.com/us/app/jobble/id961838757?mt=8\" target=\"_blank\" rel=\"noopener\">\n                    <img src=\"/app/vendor/images/App_Store.png\" />\n                  </a>\n                </div>\n                <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                  <a href=\"https://play.google.com/store/apps/details?id=com.jobble.jobble&hl=en\" target=\"_blank\" rel=\"noopener\">\n                    <img src=\"/app/vendor/images/Google_Play.png\" />\n                  </a>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"finishing-steps\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content next-steps-image\">\n          <div class=\"modal-header popup-header\">\n            <h3 class=\"modal-title\"></h3>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                <img src=\"/app/vendor/images/flow.png\" />\n                <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                  <i class=\"fa fa-times-circle\"></i>\n                </button>\n                <a href=\"#\" ng-click=\"vm.send_to_basic_profile()\" class=\"funnel-link\">Finish your basic profile</a>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _messagingv = __webpack_require__(30);
	
	var _messagingv2 = _interopRequireDefault(_messagingv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobbleheaderController = function () {
	  function JobbleheaderController($http, $localStorage, $state, AuthService, SecurityService, TrackingService, $rootScope, $scope, $location, $timeout, $window, $companies, Messagingv2Service, EventsService) {
	    _classCallCheck(this, JobbleheaderController);
	
	    this.name = "jobbleheader";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$rootScope = $rootScope;
	    this.$security = SecurityService;
	    this.$window = $window;
	    this.$timeout = $timeout;
	    this.$events = EventsService;
	    this.$scope = $scope;
	    this.showJobsDropDown = false;
	    this.$tracking = TrackingService;
	    this.$messagingv2 = Messagingv2Service;
	    this.$companies = $companies;
	    console.log("what is local storage at this pooint");
	    console.dir(this.$localStorage);
	    //this.currentUser = this.$localStorage.logged_user;
	    this.currentUser = this.$auth.getUserData();
	    this.showPostScroll = false;
	    this.showNoti = false;
	    this.$location = $location;
	    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
	    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;
	    this.adminCheck();
	
	    var _this = this;
	
	    $rootScope.$watch("$routeChangeStart", function () {
	      _this.setActiveClass();
	      if (!_this.$state.$current.url.sourcePath.includes("messages")) {
	        _this.$rootScope.activeMessages = [];
	        _this.$rootScope.activeChannel = undefined;
	      }
	    });
	
	    if (!this.$rootScope.googleHasLoaded) {
	      this.$rootScope.googleHasLoaded = true;
	    }
	
	    _this.showNotiListener = _this.$rootScope.$on("ShowNoti", function ($event, params) {
	      _this.showNoti = true;
	      _this.$timeout(function () {
	        _this.showNoti = false;
	      }, 2000);
	    });
	
	    _this.updateCurrentUserListener = _this.$rootScope.$on("UpdateCurrentUser", function (event, params) {
	      _this.updateCurrentUser(params);
	    });
	
	    _this.autoSaveListener = _this.$rootScope.$on("AutoSave", function (event, params) {
	      _this.showAuto = true;
	      _this.autoSaveEventAsDraft(params);
	    });
	
	    _this.autoSaveListenerTrigger = _this.$rootScope.$on("AutoSaveTrigger", function (event, params) {
	      if (params.pop === "on") {
	        _this.showAuto = true;
	      } else {
	        _this.showAuto = false;
	      }
	    });
	
	    _this.channelsHaveBeenLoadedListener = _this.$rootScope.$on("channelsHaveBeenLoaded", function ($event, params) {
	      _this.$timeout(function () {
	        _this.$rootScope.channelsHaveLoaded = true;
	      });
	    });
	
	    _this.SetProfilePictureListener = _this.$rootScope.$on("SetProfilePictureCompany", function ($event, params) {
	      _this.currentUser.company.companyLogoUri = params.picture;
	    });
	
	    _this.ToastMessageListener = _this.$rootScope.$on("ToastMessage", function ($event, params) {
	      _this.toastMessage(params);
	    });
	
	    _this.SetNewUserForJobBoardHeaderListener = _this.$rootScope.$on("SetNewUserForJobBoardHeader", function ($event, params) {
	      _this.$timeout(function () {
	        _this.currentUser = params.user;
	        _this.$localStorage.logged_user = params.user;
	      });
	    });
	
	    _this.SetApplyConfirmationListener = _this.$rootScope.$on("SetApplyConfirmation", function ($event, data) {
	      _this.setApplicationStatus(data.params, data.user_not_verified);
	    });
	
	    _this.SignUserOutListener = _this.$rootScope.$on("SignUserOutHeader", function (event, params) {
	      console.log("_this.SignUserOutHeader");
	      _this.signOut();
	    });
	
	    _this.SetEventsToScrollerListener = _this.$rootScope.$on("SetEventsToScroller", function (event, params) {
	      _this.setToDirective(params);
	    });
	
	    _this.GetLogoListener = _this.$rootScope.$on("GetLogo", function (event, params) {
	      _this.get_logo(params);
	    });
	
	    _this.$scope.$on("$destroy", _this.GetLogoListener);
	    _this.$scope.$on("$destroy", _this.SetEventsToScrollerListener);
	    _this.$scope.$on("$destroy", _this.SetApplyConfirmationListener);
	    _this.$scope.$on("$destroy", _this.SetNewUserForJobBoardHeaderListener);
	    _this.$scope.$on("$destroy", _this.showNotiListener);
	    _this.$scope.$on("$destroy", _this.autoSaveListener);
	    _this.$scope.$on("$destroy", _this.autoSaveListenerTrigger);
	    _this.$scope.$on("$destroy", _this.channelsHaveBeenLoadedListener);
	    _this.$scope.$on("$destroy", _this.SetProfilePictureListener);
	    _this.$scope.$on("$destroy", _this.ToastMessageListener);
	    _this.$scope.$on("$destroy", _this.updateCurrentUserListener);
	    _this.$scope.$on("$destroy", _this.SignUserOutListener);
	
	    if (!this.$security.isUndefinedOrNull(this.currentUser)) {
	      if (this.currentUser.company && this.currentUser.company.id) {
	        if (this.$security.isUndefinedOrNull(this.$rootScope.messagingHasBeenInitiated)) {
	          _this.$timeout(function () {
	            _this.$rootScope.messagingHasBeenInitiated = true;
	            _this.$rootScope.channelsHaveLoaded = false;
	            _this.$messagingv2.initPubnub();
	            _this.remain_loading_count = 0;
	            _this.$messagingv2.getChannelsv1(0).then(function (response) {
	              _this.$messagingv2.initv1(response.data);
	            }, function (data) {
	              _this.jobble_types = [];
	              _this.remain_loading_count--;
	              if (data.status === 401) {
	                _this.$state.go("signin");
	              } else {
	                _this.$timeout(function () {
	                  //jQuery('#show-application-alert').trigger('click');
	                }, 100);
	              }
	            });
	          });
	        }
	
	        if (this.$security.isUndefinedOrNull(this.currentUser.company.companyLogoUri) && this.$security.isUndefinedOrNull(this.$rootScope.companyLogoUri)) {
	          this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
	          var u = this.currentUser;
	          this.get_logo(u, "do_not_reload");
	        } else {
	          if (this.currentUser.company.companyLogoUri) {
	            this.$rootScope.companyLogoUri = this.currentUser.company.companyLogoUri;
	            this.currentUser.companyProfilePictureUrl = this.currentUser.company.companyLogoUri;
	            this.get_logo(this.currentUser);
	          }
	        }
	        this.isJobSeeker = false;
	        _this.setTeamsToSession();
	        _this.setJobbleTypesToSession();
	      } else {
	        this.isJobSeeker = true;
	        this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
	      }
	    } else {
	      this.$rootScope.channelsHaveLoaded = true;
	      this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
	      _this.initUnregisteredUser();
	    }
	  }
	
	  _createClass(JobbleheaderController, [{
	    key: "slideToggle",
	    value: function slideToggle() {
	      var _this = this;
	      if (_this.isJobSeeker) {
	        _this.$timeout(function () {
	          $(".mobile-menu-wrap").show();
	        });
	      } else {
	        _this.$timeout(function () {
	          $(".mobile-menu-wrap").show();
	        });
	      }
	    }
	  }, {
	    key: "closeSideBar",
	    value: function closeSideBar() {
	      var _this = this;
	      _this.$timeout(function () {
	        $(".mobile-menu-wrap").hide();
	      });
	    }
	  }, {
	    key: "get_logo",
	    value: function get_logo(user, msg) {
	      var _this = this;
	
	      if (_this.currentUser) {
	        _this.updateCurrentUser();
	      }
	
	      _this.$auth.grab_company_logo(user.access_token).then(function (response) {
	        var logo = response.data.company.companyLogoUriFree;
	        _this.set_logo_to_header(logo);
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetLogoToEventsPage", logo);
	        });
	      }, function (error) {});
	    }
	  }, {
	    key: "set_logo_to_header",
	    value: function set_logo_to_header(logo) {
	      var _this = this;
	      _this.$timeout(function () {
	        if (_this.currentUser) {
	          _this.currentUser.company.companyLogoUri = logo;
	          _this.$rootScope.companyLogoUri = logo;
	          _this.currentUser.companyProfilePictureUrl = logo;
	        }
	      }, 300);
	    }
	  }, {
	    key: "updateCurrentUser",
	    value: function updateCurrentUser(params) {
	      var _this = this;
	      if (params) {
	        _this.$timeout(function () {
	          _this.currentUser = params.user;
	          _this.$localStorage.logged_user = params.user;
	          if (_this.$rootScope.channels) {
	            _this.$rootScope.channelsHaveLoaded = true;
	          }
	          if (_this.currentUser.company && _this.currentUser.company.id) {
	            _this.isJobSeeker = false;
	          } else {
	            _this.isJobSeeker = true;
	          }
	        }, 300);
	      }
	    }
	  }, {
	    key: "signOut",
	    value: function signOut() {
	      var _this = this;
	      this.$auth.signOut().then(function (response) {
	        _this.$timeout(function () {
	          _this.$tracking.reportUserLogout(_this.$localStorage.logged_user);
	          _this.$localStorage.logged_user = null;
	          _this.$rootScope.channels = undefined;
	          _this.$rootScope.companyLogoUri = undefined;
	          _this.$rootScope.inboxLink = undefined;
	          _this.$rootScope.channelsHaveLoaded = undefined;
	          _this.$rootScope.teams = undefined;
	          _this.$rootScope.teamsSimple = undefined;
	          _this.$rootScope.globalParams = undefined;
	          _this.$rootScope.imgFromProfilePage = undefined;
	          _this.$rootScope.jobbleTypes = undefined;
	          _this.$rootScope.jobs = undefined;
	          _this.$rootScope.jobsSeenOnce = undefined;
	          _this.$rootScope.boardParameters = null;
	          _this.$messagingv2.setHandleLastMessageDataCounter(0);
	          _this.$messagingv2.setTotalAmountOfMissedMessages(0);
	
	          _this.$state.go("signin");
	        });
	      });
	    }
	  }, {
	    key: "goToSomeChat",
	    value: function goToSomeChat(event) {
	      var _this = this;
	      var missedMessagesFound = false;
	      var channelToGoToInURL = undefined;
	      try {
	        for (var i = 0; i < event.channelArrayHolder.length; i++) {
	          if (event.channelArrayHolder[i].missedMessagesCount > 0) {
	            missedMessagesFound = true;
	            channelToGoToInURL = event.channelArrayHolder[i].name;
	            break;
	          }
	        }
	      } finally {
	        if (missedMessagesFound) {
	          this.$location.path("/messages/event/" + event.eventId).search({ c: channelToGoToInURL });
	        } else {
	          this.$location.path("/messages/event/" + event.eventId);
	        }
	      }
	    }
	  }, {
	    key: "inboxLink",
	    value: function inboxLink() {
	      var _this = this;
	      if (_this.$rootScope.channelsHaveLoaded && !_this.$rootScope.channels) {
	        alert("This account has no active messages. If you think there are active messages please refresh the page.");
	      } else {
	        _this.$timeout(function () {
	          _this.$state.go("inbox");
	        });
	      }
	    }
	  }, {
	    key: "toastMessage",
	    value: function toastMessage(params) {
	      var _this = this;
	      var msg = params.m.messagePayload.message;
	      if (msg.length > 75) {
	        msg = msg.substring(0, 99);
	        msg = msg + " ...";
	      }
	      _this.notMsg = msg;
	      _this.notUser = params.m.messagePayload.username;
	      _this.notImage = params.m.messagePayload.userProfileImage;
	      _this.notChan = params.channel;
	      _this.notEventId = params.m.messagePayload.eventId;
	      _this.$timeout(function () {
	        jQuery("#notification-tab").show("fast");
	      });
	    }
	  }, {
	    key: "closeNotification",
	    value: function closeNotification(eventId, channel) {
	      var _this = this;
	      _this.$timeout(function () {
	        jQuery("#notification-tab").hide("fast");
	      });
	    }
	  }, {
	    key: "goToChat",
	    value: function goToChat(eventId, channel) {
	      var _this = this;
	      if (eventId) {
	        _this.$location.path("/messages/event/" + eventId).search({ c: channel });
	      } else {
	        return;
	      }
	    }
	  }, {
	    key: "setJobbleTypesToSession",
	    value: function setJobbleTypesToSession() {
	      var _this = this;
	      if (!_this.$rootScope.jobble_types) {
	        _this.loadJobbleTypes();
	      }
	    }
	  }, {
	    key: "loadJobbleTypes",
	    value: function loadJobbleTypes() {
	      var _this = this;
	
	      _this.$auth.getJobbleTypes().then(function (data) {
	        _this.$rootScope.jobble_types = data.data;
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetJobbleTypes", {
	            jobbleTypes: data.data
	          });
	        });
	      }, function (data) {
	        _this.jobbleTypes = [];
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "setTeamsToSession",
	    value: function setTeamsToSession() {
	      var _this = this;
	    }
	  }, {
	    key: "loadTeams",
	    value: function loadTeams() {
	      var _this = this;
	      var teamsSimple = [];
	      var teams = [];
	      _this.$companies.getTeamsTrim().then(function (data) {
	        try {
	          data.data.forEach(function (team, index) {
	            _this.setAvatarImageToUsersOfTeam(team);
	            team.firstLoadUsersCount = Math.min(team.users.length, 6);
	            if (team.firstLoadUsersCount == 6) {
	              team.firstLoadUsersCount = 5;
	            }
	            teams.push(team);
	            var teamsObj = {};
	            teamsObj.name = team.name;
	            teamsObj.id = team.id;
	            teamsSimple.push(teamsObj);
	          });
	        } finally {
	          _this.$timeout(function () {
	            _this.$rootScope.teams = teams;
	            _this.$rootScope.teamsSimple = teamsSimple;
	            _this.$rootScope.$emit("TeamsHaveLoaded", {
	              teams: teams
	            });
	          });
	        }
	      }, function (data) {
	        _this.$rootScope.teams = [];
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "setAvatarImageToUsersOfTeam",
	    value: function setAvatarImageToUsersOfTeam(team) {
	      var _this = this;
	      if (team.users) {
	        team.users.forEach(function (userProfile) {
	          if (!_this.$security.isUndefinedOrNull(userProfile.picture1s)) {
	            userProfile.picture1s.forEach(function (pic) {
	              if (pic.indexOf("75x75") > -1) {
	                userProfile.pictureAvatarUrl = pic;
	              }
	              if (pic.indexOf("160x160") > -1) {
	                userProfile.pictureAvatarUrlBig = pic;
	              }
	            });
	          }
	          if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
	            userProfile.pictureAvatarUrl = userProfile.pictureAvatarUrlBig;
	          }
	          if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
	            userProfile.pictureAvatarUrl = "/app/vendor/images/defaultimg.jpeg";
	          }
	        });
	      }
	    }
	  }, {
	    key: "closeNoti",
	    value: function closeNoti(x) {
	      var _this = this;
	      _this.showNoti = false;
	      if (x === 2) {
	        _this.$timeout(function () {
	          jQuery(".modal-backdrop").remove();
	          jQuery("body").removeClass("modal-open");
	        });
	      }
	    }
	  }, {
	    key: "closeAutoSave",
	    value: function closeAutoSave(x) {
	      var _this = this;
	      _this.showAuto = false;
	    }
	  }, {
	    key: "autoSaveEventAsDraft",
	    value: function autoSaveEventAsDraft(params) {
	      var _this = this;
	      if (params.update) {
	        _this.$timeout(function () {
	          _this.showAuto = false;
	        }, 2000);
	      } else {
	        if (!params.questions) {
	          params.questions = [];
	          var p = {
	            question: "Are you a good fit?",
	            questionType: 1,
	            name: "Question 1"
	          };
	          params.questions.push(p);
	        }
	        _this.$events.saveDraft(params).then(function (response) {
	          if (response.data.status === "error") {
	            _this.$timeout(function () {
	              _this.showAuto = false;
	            });
	            if (response.data.message.indexOf("Data too long for column 'dress_code'") > -1) {
	              alert("The Dress Code on page 1 is too long. Please go back and shorten.");
	            } else {
	              alert("There was an issue please contact an admin.");
	            }
	            return;
	          }
	          _this.$timeout(function () {
	            _this.showAuto = false;
	            _this.$rootScope.$emit("SetEventIdForDrafting", {
	              draftData: response
	            });
	          }, 2000);
	        }, function (error) {
	          console.log("we are in error");
	          console.dir(error);
	        });
	      }
	    }
	  }, {
	    key: "logOnboardingTracking",
	    value: function logOnboardingTracking(event) {
	      var _this = this;
	      _this.$tracking.reportOboardingScreenOne(event);
	    }
	  }, {
	    key: "setActiveClass",
	    value: function setActiveClass() {
	      var _this = this;
	      if (_this.$state.current.url.indexOf("/events") > -1) {
	        _this.$timeout(function () {
	          jQuery(".pull-right ul li:nth-child(2)").addClass("active");
	        });
	      }
	      if (_this.$state.current.url.indexOf("/transactionhistory") > -1) {
	        _this.$timeout(function () {
	          jQuery(".pull-right ul li:nth-child(3)").addClass("active");
	        });
	      }
	      if (_this.$state.current.url.indexOf("/teams") > -1) {
	        _this.$timeout(function () {
	          jQuery(".pull-right ul li:nth-child(4)").addClass("active");
	        });
	      }
	      if (_this.$state.current.url.indexOf("/inbox") > -1) {
	        _this.$timeout(function () {
	          jQuery(".pull-right ul li:nth-child(5)").addClass("active");
	        });
	      }
	    }
	  }, {
	    key: "initUnregisteredUser",
	    value: function initUnregisteredUser() {
	      var _this = this;
	      _this.isJobSeeker = true;
	    }
	  }, {
	    key: "funnelToMobileApp",
	    value: function funnelToMobileApp(x) {
	      var _this = this;
	      var button = null;
	      switch (x) {
	        case 1:
	          _this.text = "hi";
	          button = "Applications";
	          break;
	        case 2:
	          _this.text = "hi";
	          button = "Messages";
	          break;
	        case 3:
	          _this.text = "hi";
	          button = "Jobs";
	          break;
	        case 4:
	          _this.text = "hi";
	          button = "Payments";
	          break;
	      }
	      _this.trackingHeader(button);
	    }
	  }, {
	    key: "moreInfoModal",
	    value: function moreInfoModal() {
	      var _this = this;
	      if (_this.appError) {
	        _this.$timeout(function () {
	          $(".noti-message-application-error").hide("fast");
	        });
	      } else {
	        _this.$timeout(function () {
	          $(".noti-message-application-success").hide("fast");
	        });
	      }
	      _this.$timeout(function () {
	        $("#more-application-info").modal();
	      }, 500);
	    }
	  }, {
	    key: "setApplicationStatus",
	    value: function setApplicationStatus(data, user_not_verified) {
	      var _this = this;
	      if (data.data.status === "error") {
	        if (data.data.message === "Applicant already applied for jobble in the pool") {
	          _this.applicationText = "You already applied to this job. Please pick another.";
	        } else {
	          _this.applicationText = "There was an issue with your application. Please try again later.";
	        }
	        _this.appError = true;
	      } else {
	        _this.applicationText = "Success! Check your application status on our mobile app.";
	        _this.appError = false;
	      }
	      if (user_not_verified) {
	        _this.$timeout(function () {
	          $("#finishing-steps").modal();
	        }, 300);
	      }
	      _this.$timeout(function () {
	        _this.applicationText = null;
	      }, 10000);
	    }
	  }, {
	    key: "closeNotiApp",
	    value: function closeNotiApp() {
	      var _this = this;
	      _this.applicationText = null;
	    }
	  }, {
	    key: "trackingHeader",
	    value: function trackingHeader(button) {
	      var _this = this;
	      var data = {};
	      if (!_this.currentUser) {
	        data.username = "Unregistered";
	      } else {
	        data.username = _this.currentUser.username;
	      }
	      data.button = button;
	      _this.$tracking.reportHeaderClicks(button);
	    }
	  }, {
	    key: "goToProfile",
	    value: function goToProfile() {
	      var _this = this;
	    }
	  }, {
	    key: "goToEvents",
	    value: function goToEvents() {
	      var _this = this;
	      _this.$state.go("events");
	    }
	  }, {
	    key: "showPostBlur",
	    value: function showPostBlur() {
	      var _this = this;
	      _this.$timeout(function () {
	        $(".hidden-drop-down-post-types").hide("slide", { direction: "up" }, 100);
	        _this.showPostScroll = false;
	      }, 300);
	    }
	  }, {
	    key: "showPostScrollFunc",
	    value: function showPostScrollFunc() {
	      var _this = this;
	      var dropdown = _this.currentUser.company.postingTypesAllowed;
	      if (dropdown === 0) {
	        if (_this.showPostScroll === false) {
	          _this.$timeout(function () {
	            _this.showPostScroll = true;
	            $(".hidden-drop-down-post-types").show("slide", { direction: "up" }, 100);
	          });
	        } else {
	          _this.$timeout(function () {
	            _this.showPostScroll = false;
	            $(".hidden-drop-down-post-types").hide("slide", { direction: "up" }, 100);
	          });
	        }
	      } else {
	        _this.$state.go("postevent");
	      }
	    }
	  }, {
	    key: "showJobScroll",
	    value: function showJobScroll() {
	      var _this = this;
	      var showList = null;
	
	      if (_this.showJobsDropDown === false) {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("ListEventsForScroll", {});
	          _this.showJobsDropDown = true;
	          $(".hidden-drop-down").show("slide", { direction: "up" }, 100);
	        });
	      } else {
	        _this.$timeout(function () {
	          _this.showJobsDropDown = false;
	          $(".hidden-drop-down").hide("slide", { direction: "up" }, 100);
	        });
	      }
	    }
	  }, {
	    key: "showDropDownList",
	    value: function showDropDownList() {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("ListEventsForScroll", {});
	        $(".hidden-drop-down").show("fast");
	      });
	      _this.showJobsDropDown = true;
	    }
	  }, {
	    key: "setToDirective",
	    value: function setToDirective(params) {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetEventsToJobsScroll", { params: params });
	      });
	    }
	  }, {
	    key: "jobDropDownBlur",
	    value: function jobDropDownBlur() {
	      var _this = this;
	      _this.$timeout(function () {
	        $(".hidden-drop-down").hide("slide", { direction: "up" }, 100);
	        _this.showJobsDropDown = false;
	      }, 300);
	    }
	  }, {
	    key: "jobDropDownFocus",
	    value: function jobDropDownFocus() {
	      var _this = this;
	    }
	  }, {
	    key: "jobDropDownHover",
	    value: function jobDropDownHover() {
	      var _this = this;
	      _this.showJobScroll();
	    }
	  }, {
	    key: "jobDropDownLeave",
	    value: function jobDropDownLeave() {
	      var _this = this;
	      _this.showJobScroll();
	    }
	  }, {
	    key: "reportHeaderDropDownClick",
	    value: function reportHeaderDropDownClick(link) {
	      var _this = this;
	      var data = {};
	      if (_this.currentUser) {
	        data.user = _this.currentUser.email;
	      } else {
	        data.user = "Unregistered";
	      }
	      switch (link) {
	        case 1:
	          data.button = "Account";
	          return;
	        case 2:
	          data.button = "Direct Pay";
	          return;
	        case 3:
	          data.button = "Help Center";
	          return;
	        case 4:
	          data.button = "Logout";
	          return;
	      }
	      _this.$tracking.reportHeaderMenuInteraction(data);
	    }
	  }, {
	    key: "send_to_basic_profile",
	    value: function send_to_basic_profile() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("#finishing-steps").modal("toggle");
	      });
	      _this.$timeout(function () {
	        _this.$state.go("jobbler", {});
	      }, 300);
	    }
	  }, {
	    key: "checkAccountType",
	    value: function checkAccountType() {
	      var _this = this;
	      var cid = _this.currentUser.company.id;
	      if (cid) {
	        if (_this.currentUser.company.industryType) {
	          var industry_type_id = _this.currentUser.company.industryType.id;
	          if (industry_type_id) {
	            _this.currentUser.company.industry = "Delivery";
	          } else {
	            console.log("we do not have an industry type");
	          }
	        }
	      }
	    }
	  }, {
	    key: "rotate",
	    value: function rotate() {
	      var _this = this;
	      _this.$timeout(function () {
	        $(".main-menu ul li a i").toggleClass("down");
	      });
	    }
	  }, {
	    key: "redirectUser",
	    value: function redirectUser() {
	      var _this = this;
	    }
	  }]);
	
	  return JobbleheaderController;
	}();
	
	JobbleheaderController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "tracking", "$rootScope", "$scope", "$location", "$timeout", "$window", "companies", "messagingv2", "events"];
	
	exports.default = JobbleheaderController;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(38);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobbleheader.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobbleheader.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".jobbleheader{color:red}", ""]);
	
	// exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _eventaddopenings = __webpack_require__(40);
	
	var _eventaddopenings2 = _interopRequireDefault(_eventaddopenings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventaddopeningsModule = _angular2.default.module("eventaddopenings", [_angularUiRouter2.default]).component("eventaddopenings", _eventaddopenings2.default);
	
	exports.default = eventaddopeningsModule;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventaddopenings = __webpack_require__(41);
	
	var _eventaddopenings2 = _interopRequireDefault(_eventaddopenings);
	
	var _eventaddopenings3 = __webpack_require__(42);
	
	var _eventaddopenings4 = _interopRequireDefault(_eventaddopenings3);
	
	__webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventaddopeningsComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _eventaddopenings2.default,
	  controller: _eventaddopenings4.default,
	  controllerAs: "vm"
	};
	
	exports.default = eventaddopeningsComponent;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal fade\" id=\"modal-add-openings\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <span aria-hidden=\"true\">&times;</span>\n            </button>\n            <strong>Add Openings to</strong>\n            <h4 class=\"modal-title\">XYZ Event</h4>\n          </div>\n          <div class=\"modal-body\">\n            <form>\n              <label>Select the number of openings you would like to add</label>\n              <select>\n                <option value=\"1\">1</option>\n                <option value=\"2\">2</option>\n                <option value=\"3\">3</option>\n                <option value=\"4\">4</option>\n              </select>\n            </form>\n            <a class=\"btn\" href=\"#\">Add Openings</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"modal-del-event\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <span aria-hidden=\"true\">&times;</span>\n            </button>\n            <strong\n              >XYZ Event will be permanently deleted. <br />\n              Are you sure?</strong\n            >\n          </div>\n          <div class=\"modal-body\">\n            <a class=\"btn\" href=\"event1-original.html\">Keep event</a>\n            <a class=\"btn\" href=\"#\">Delete event</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventaddopeningsController = function EventaddopeningsController() {
	  _classCallCheck(this, EventaddopeningsController);
	
	  this.name = "eventaddopenings";
	};
	
	exports.default = EventaddopeningsController;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(44);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventaddopenings.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventaddopenings.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".eventaddopenings{color:red}", ""]);
	
	// exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _eventsidebar = __webpack_require__(46);
	
	var _eventsidebar2 = _interopRequireDefault(_eventsidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventsidebarModule = _angular2.default.module("eventsidebar", [_angularUiRouter2.default]).component("eventsidebar", _eventsidebar2.default);
	
	exports.default = eventsidebarModule;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventsidebar = __webpack_require__(47);
	
	var _eventsidebar2 = _interopRequireDefault(_eventsidebar);
	
	var _eventsidebar3 = __webpack_require__(48);
	
	var _eventsidebar4 = _interopRequireDefault(_eventsidebar3);
	
	__webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventsidebarComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _eventsidebar2.default,
	  controller: _eventsidebar4.default,
	  controllerAs: "vm"
	};
	
	exports.default = eventsidebarComponent;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"jobs-complete-sidebar\">\n  <aside ng-if=\"vm.isReadyToShow\">\n    <ul>\n      <!--\n        \t<li>\n        \t\t<a ng-href=\"event/{{vm.eventId}}/overview\">Overview</a>\n        \t</li>\n            <li ng-if=\"vm.isTheEventOpen && !vm.event.isSourcingPost\">\n            \t<a ng-href=\"event/{{vm.eventId}}/review\">Review &amp; Hire Jobblers</a>\n            </li>\n            <li ng-if=\"vm.isTheEventOpen && vm.event.isSourcingPost\">\n            \t<a ng-href=\"event/{{vm.eventId}}/review\">Review Candidates</a>\n            </li>\n            <li>\n            \t<a ng-href=\"\" ng-click=\"vm.inboxLink()\">Message</a>\n            </li>\n\n            <li ng-if=\"vm.isTheEventOpen && !vm.event.isSourcingPost\">\n            \t<a href=\"#modal-add-openings\" data-toggle=\"modal\" ng-click=\"vm.setEvent()\">Add/Remove Openings</a>\n            </li>\n            -->\n      <li>\n        <a ng-href=\"event/{{vm.eventId}}/review\">Manage Roster</a>\n      </li>\n      <li>\n        <a ng-href=\"event/{{vm.eventId}}/edit\">Edit Details</a>\n      </li>\n      <li>\n        <a ng-href=\"/post-a-shift/walkthrough?cid={{vm.eventId}}\">Clone</a>\n      </li>\n      <!--\n            <li ng-if=\"vm.isTheEventOpen && !vm.event.isSourcingPost\">\n            \t<a ng-href=\"event/{{vm.eventId}}/live\">Live</a>\n            </li>\n\n            <!--\n            <li ng-if=\"vm.isTheEventOpen && vm.event.isSourcingPost\">\n            \t<a ng-href=\"event/{{vm.eventId}}/complete\">Make payment</a>\n            </li>\n            -->\n      <!--\n   \t\t\t<li ng-if=\"vm.isTheEventOpen && !vm.event.isSourcingPost\">\n   \t\t\t\t<a ng-href=\"event/{{vm.eventId}}/complete\">Make Payment</a>\n   \t\t\t</li>\n            -->\n\n      <!--\n    \t\t<li ng-if=\"!vm.isTheEventOpen\">\n    \t\t\t<a ng-href=\"event/{{vm.eventId}}/complete\">Recap</a>\n    \t\t</li>\n    \t\t<li ng-if=\"!vm.isTheEventOpen\">\n    \t\t\t<a\n    \t\t\t\tng-href=\"invoice/{{vm.event.firstInvoices[0].id}}?eventId={{vm.eventId}}\"\n    \t\t\t\ttarget=\"_blank\">\n    \t\t\t\tInvoice\n    \t\t\t</a>\n    \t\t</li>\n    \t\t<li ng-if=\"vm.isTheEventOpen\">\n    \t\t\t<a href=\"#modal-del-event\" data-toggle=\"modal\">Delete</a>\n    \t\t</li>\n            <li>\n                <a \n                    href=\"event/{{vm.eventId}}/payshifts\">\n                    Pay By Shift\n                </a>\n            </li>\n            -->\n    </ul>\n  </aside>\n</div>\n\n<div class=\"modal fade\" id=\"modal-add-opening\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n            </button>\n            <h3 class=\"modal-title\">Add or Remove Openings</h3>\n            <p>This job currently has <span>0</span> openings left</p>\n          </div>\n          <div class=\"modal-body popup-body text-center\">\n            <form action=\"jobs-overview.html\">\n              <div class=\"select-opening\">\n                <span>I would like to</span>\n                <div class=\"select-box\">\n                  <select class=\"form-control form-input\">\n                    <option>Add</option>\n                    <option>Remove</option>\n                  </select>\n                </div>\n                <div class=\"select-box\">\n                  <select class=\"form-control form-input\">\n                    <option>1</option>\n                    <option>2</option>\n                    <option>3</option>\n                    <option>4</option>\n                    <option>5</option>\n                    <option>6</option>\n                  </select>\n                </div>\n                <span>Opening</span>\n              </div>\n              <input type=\"submit\" class=\"btn btn-success button\" value=\"Make Change\" />\n            </form>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"modal-del-job\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n            </button>\n            <h3 class=\"modal-title\">\n              Are you sure you want to <br />\n              cancel this job?\n            </h3>\n          </div>\n          <div class=\"modal-body popup-body text-center\">\n            <a href=\"\" class=\"btn btn-success button\" ng-click=\"vm.keepEvent()\">Keep Job</a>\n            <a href=\"\" class=\"btn btn-danger button\" ng-click=\"vm.deleteEvent()\">Delete Job</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<a href=\"#modal-save-event-confirm-modal\" data-toggle=\"modal\" id=\"modal-save-event-confirm\"></a>\n<div\n  class=\"modal fade\"\n  id=\"modal-save-event-confirm-modal\"\n  tabindex=\"-1\"\n  role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\"\n  data-backdrop=\"static\"\n>\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n            </button>\n\n            <strong>Your job has been successfully updated</strong>\n          </div>\n\n          <div class=\"modal-body popup-body\">\n            <a class=\"btn button btn-success\" href=\"#\" data-dismiss=\"modal\" style=\"margin: 0px\">OK</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<a href=\"#modal-add-review-jobbler\" id=\"modal-add-review-jobbler-click\" data-toggle=\"modal\"></a>\n"

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventsidebarController = function () {
	  function EventsidebarController($http, $state, $stateParams, AuthService, EventsService, SecurityService, $rootScope, $scope, $timeout, $location) {
	    _classCallCheck(this, EventsidebarController);
	
	    this.name = "eventsidebar";
	    this.$http = $http;
	    this.$auth = AuthService;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$location = $location;
	    this.$timeout = $timeout;
	    this.$stateParams = $stateParams;
	    this.$events = EventsService;
	    this.$security = SecurityService;
	    this.currentUser = this.$auth.getUserData();
	    this.$rootScope = $rootScope;
	    this.isTheEventOpen = true;
	    this.event = {};
	    this.eventId = this.$stateParams.eventId;
	
	    var _this = this;
	
	    _this.SetEventToEventSidebarListener = _this.$rootScope.$on("SetEventToEventSidebar", function ($event, params) {
	      _this.event = params.event;
	
	      console.log("params");
	      console.dir(params);
	
	      if (_this.event.isClosed === true || _this.event.isCancelled === true || _this.event.isCompleted === true) {
	        _this.isTheEventOpen = false;
	        _this.isReadyToShow = true;
	      } else {
	        _this.isTheEventOpen = true;
	        _this.isReadyToShow = true;
	      }
	    });
	
	    console.log("check current user sidebar");
	    console.dir(_this.currentUser);
	    _this.checkAdmin();
	    _this.$scope.$on("$destroy", _this.SetEventToEventSidebarListener);
	  }
	
	  _createClass(EventsidebarController, [{
	    key: "setEvent",
	    value: function setEvent() {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetEventToEventDialog", {
	          event: _this.event
	        });
	      });
	    }
	  }, {
	    key: "checkAdmin",
	    value: function checkAdmin() {
	      var _this = this;
	
	      if (_this.currentUser) {
	        _this.admin = _this.$auth.isAdmin();
	
	        console.log("what is this admin");
	        console.dir(_this.admin);
	      }
	    }
	  }, {
	    key: "inboxLink",
	    value: function inboxLink() {
	      var _this = this;
	      if (_this.$rootScope.channelsHaveLoaded && !_this.$rootScope.channels) {
	        alert("This account has no active messages. If you think there are active messages please refresh the page.");
	      } else {
	        _this.$timeout(function () {
	          //_this.$state.go('inbox');
	          _this.$location.path("/messages/event/" + _this.event.id);
	        });
	      }
	    }
	  }]);
	
	  return EventsidebarController;
	}();
	
	EventsidebarController.$inject = ["$http", "$state", "$stateParams", "auth", "events", "security", "$rootScope", "$scope", "$timeout", "$location"];
	
	exports.default = EventsidebarController;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GRACE_PERIOD = 1000 * 60 * 60 * 24 * 3;
	
	var EventsService = function () {
	  function EventsService($http, $localStorage, $state, $q, SecurityService, AuthService, EnvService, TrackingService, $timeout) {
	    _classCallCheck(this, EventsService);
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$q = $q;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$env = EnvService;
	    this.$tracking = TrackingService;
	    this.current_event = null;
	    this.currentEventId = null;
	    this.$timeout = $timeout;
	
	    this.development_env = this.$env.getEnv();
	    console.log("this.development_env", this.development_env);
	  }
	
	  _createClass(EventsService, [{
	    key: "get_history",
	    value: function get_history(params) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + params.companyId + "/listInvoices?format=json&isClosed=" + params.isClosed + "&max=" + params.max + "&offset=" + params.offset + "&order=" + params.order + "&sort=" + params.sort + "&isCancelled=false";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { authorization: "Bearer " + this.$auth.getAccessToken() },
	        async: false,
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "get_event",
	    value: function get_event() {
	      return this.current_event;
	    }
	  }, {
	    key: "set_event",
	    value: function set_event(event) {
	      this.current_event = event;
	    }
	  }, {
	    key: "getEventById",
	    value: function getEventById(event_id) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?conf=web&format=json&max=1&order=desc&sort=lastUpdated&verbosity=5";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getPendingApplications",
	    value: function getPendingApplications(subEventId) {
	      var maxCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + subEventId + "/applications?format=json&conf=web&status=3&max=" + maxCount.toString() + "&offset=" + offset + "&fields=id,applicant.firstName,applicant.lastName,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,jobble.id,applicant.id,applicant.homeContactInfo.city,applicant.homeContactInfo.phoneMobile,applicant.homeContactInfo.state";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getAcceptedApplications",
	    value: function getAcceptedApplications(subEventId) {
	      var maxCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
	      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + subEventId + "/applications?format=json&verbosity=4&conf=web&max=" + maxCount + "&status=1&offset=" + offset + "&fields=id,applicant.firstName,applicant.lastName,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,applicant.username,jobble.id,applicant.id";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "notifyJobblers",
	    value: function notifyJobblers(info) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/notify-pool?format=json",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          id: info.id,
	          visibility: info.visibility
	        }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "notifyBusinessOfInterestedReference",
	    value: function notifyBusinessOfInterestedReference(rid) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "public/userReferences/references/" + rid + "/follow-up",
	        headers: {
	          "Content-Type": "application/json"
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "createEvent",
	    value: function createEvent(eventObj) {
	      console.log("in create event");
	      console.dir(eventObj);
	      var jobbleForDB = {
	        name: eventObj.name,
	        payPerHour: parseInt(eventObj.hourly_rate * 100),
	        description: eventObj.jobble_details,
	        dressCode: eventObj.dress_code,
	        jobbleType: eventObj.jobble_type,
	        isPublished: true,
	        manager: eventObj.manager,
	        subEvent: {
	          name: eventObj.name,
	          contactInfo: eventObj.timeIntervalsArray[0].contactInfo,
	          event: {
	            name: eventObj.name,
	            description: eventObj.jobble_details,
	            eventType: 1,
	            timeToHire: eventObj.timeToHire,
	            company: this.$auth.getUserData().company.id,
	            surveyQuestions: eventObj.questions
	          }
	        },
	
	        shifts: []
	      };
	
	      if (eventObj.orderNumber) {
	        jobbleForDB.subEvent.event.orderNumber = eventObj.orderNumber;
	      }
	
	      if (eventObj.typeOfJobPosting === "source" || eventObj.isSourcingPost === true) {
	        jobbleForDB.subEvent.event.isSourcingPost = true;
	        if (eventObj.isClone === true) {
	          jobbleForDB.subEvent.event.isPublished = true;
	          jobbleForDB.subEvent.event.surveyQuestions.forEach(function (q) {
	            q.editing = false;
	          });
	        }
	      } else {
	        jobbleForDB.subEvent.event.isSourcingPost = false;
	      }
	
	      for (var i = 0; i < eventObj.timeIntervalsArray.length; i++) {
	        var shift = {
	          timeInterval: {
	            startTime: eventObj.timeIntervalsArray[i].startDateAndTimeForDB,
	            endTime: eventObj.timeIntervalsArray[i].endDateAndTimeForDB
	          },
	          contactInfo: eventObj.timeIntervalsArray[i].contactInfo
	        };
	
	        console.log("ktrack33");
	        console.dir(shift);
	        jobbleForDB.shifts.push(shift);
	      }
	
	      if (eventObj.postIsPrivate && eventObj.cloudsForJobblePost.length === 0) {} else {
	        var savingSingleJobbleToDB = {};
	        if (eventObj.postIsPrivate) {
	          console.log("were in this bracket.............1");
	          /*
	          addToCircle : {
	          forCircleOnly : false,
	          circles :  eventObj.cloudsForJobblePost
	          }
	          */
	          savingSingleJobbleToDB = {
	            method: "POST",
	            url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/create-pool?format=json&conf=web&verbosity=3&numberPosition=" + eventObj.openings + "&fields=id,subEvent.id,subEvent.event.id",
	            headers: {
	              "Content-Type": "application/json",
	              Authorization: "Bearer " + this.$auth.getAccessToken()
	            },
	            data: {
	              jobble: jobbleForDB
	            }
	          };
	        } else {
	          if (eventObj.cloudsForJobblePost.length === 0) {
	            console.log("were in this bracket.............2");
	            savingSingleJobbleToDB = {
	              method: "POST",
	              url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/create-pool?format=json&conf=web&verbosity=1&numberPosition=" + eventObj.openings + "&fields=id,subEvent.id,subEvent.event.id",
	              headers: {
	                "Content-Type": "application/json",
	                Authorization: "Bearer " + this.$auth.getAccessToken()
	              },
	              data: {
	                jobble: jobbleForDB
	              }
	            };
	          } else {
	            /*
	            addToCircle : {
	            forCircleOnly : false,
	            circles :  eventObj.cloudsForJobblePost
	            }
	            */
	            console.log("were in this bracket.............3");
	
	            savingSingleJobbleToDB = {
	              method: "POST",
	              url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/create-pool?format=json&conf=web&verbosity=3&numberPosition=" + eventObj.openings + "&fields=id,subEvent.id,subEvent.event.id",
	              headers: {
	                "Content-Type": "application/json",
	                Authorization: "Bearer " + this.$auth.getAccessToken()
	              },
	              data: {
	                jobble: jobbleForDB
	              }
	            };
	          }
	        }
	      }
	
	      return this.$http(savingSingleJobbleToDB);
	    }
	  }, {
	    key: "setCurrentEventId",
	    value: function setCurrentEventId(eventId) {
	      this.currentEventId = eventId;
	    }
	  }, {
	    key: "getCurrentEventId",
	    value: function getCurrentEventId() {
	      return this.currentEventId;
	    }
	  }, {
	    key: "trackNoShow",
	    value: function trackNoShow(application, event) {
	      var _this = this;
	      var jobbleTypeName = event.subEvents[0].deduppedJobbles[0].jobbleType.name;
	      _this.$tracking.reportNoShows(application, jobbleTypeName);
	    }
	  }, {
	    key: "trackShifts",
	    value: function trackShifts(applications, event, user) {
	      var _this = this;
	    }
	  }, {
	    key: "trackEventCompletion",
	    value: function trackEventCompletion(applications, event, total, user) {
	      var _this = this;
	      var data = {};
	      _this.trackShifts(applications, event, user);
	      data.jobbleTypeName = event.subEvents[0].deduppedJobbles[0].jobbleType.name;
	      data.payPerHourInCents = event.subEvents[0].deduppedJobbles[0].payPerHour;
	      data.totalMoney = total;
	      data.revenueLost = 0;
	      data.noShowCount = 0;
	      data.removedFromPaymentCount = 0;
	      data.hiredJobblersCount = applications.length;
	      data.totalNumberOfOpenings = event.numberOfOpenings + data.hiredJobblersCount;
	      data.openingsLeft = event.numberOfOpenings;
	      data.user = user.email;
	      data.companyName = event.company.name;
	      data.companyId = event.company.id;
	      if (data.user.indexOf("jobble.com") !== -1 || data.user.indexOf("jobbleapp.com") !== -1) {
	        data.isJobbleAdmin = true;
	      } else {
	        data.isJobbleAdmin = false;
	      }
	      data.fillRatePercentageBeforeNoShows = Math.round(data.hiredJobblersCount / data.totalNumberOfOpenings * 100);
	      try {
	        applications.forEach(function (application) {
	          if (application.jobble.noShow) {
	            _this.trackNoShow(application, event);
	            if (application.jobble.actualRevenue) {
	              data.revenueLost = data.revenueLost + application.jobble.actualRevenue;
	            } else {
	              data.revenueLost = data.revenueLost + application.jobble.costOfJobble;
	            }
	            data.noShowCount++;
	          } else {
	            if (application.strikeOutClass) {
	              data.removedFromPaymentCount++;
	            }
	          }
	        });
	      } finally {
	        data.revenueLostRounded = (data.revenueLost / 100).toFixed(2);
	        data.fillRatePercentageAfterNoShows = Math.round((data.hiredJobblersCount - data.noShowCount) / data.totalNumberOfOpenings * 100);
	        data.potentialGMV = (parseFloat(data.totalMoney) + parseFloat(data.revenueLostRounded)).toFixed(2);
	        _this.$timeout(function () {
	          data.potentialGMV = data.potentialGMV.toString();
	          data.revenueLostRounded = data.revenueLostRounded.toString();
	          data.totalMoney = data.totalMoney.toString();
	          console.log("reporting job pay out");
	          _this.$tracking.reportJobPayOut(data);
	        }, 1000);
	      }
	    }
	  }, {
	    key: "payJobblersAndCloseEvent",
	    value: function payJobblersAndCloseEvent(applications, subeventId, cardToken, eventId, payType, delivery, user) {
	      var transferArray = [];
	      var responseForController = null;
	
	      try {
	        applications.forEach(function (application) {
	          if (application.isCheckedForAction) {
	            if (!application.paymentToshiftHasBeenMade || application.paymentToshiftHasBeenMade === false) {
	              if (application.jobble.noShow !== true && application.strikeOutClass !== "strike-out-jobbler") {
	                if (delivery) {
	                  var transferObj = {
	                    recipient: application.applicant.username,
	                    amount: application.jobble.payPerHour,
	                    jobble: application.jobble.id,
	                    note: "Jobble Web App payment"
	                  };
	                  transferArray.push(transferObj);
	                } else {
	                  if (application.jobble.actualMinutesWorked !== 0 || application.jobble.no_show_cancelled === true) {
	                    if (application.jobble.actualMinutesWorked && application.jobble.actualMinutesWorked !== 0) {
	                      var totalCostForJobble = Math.round(application.jobble.actualMinutesWorked * application.jobble.payPerHour / 60);
	                      var _transferObj = {
	                        recipient: application.applicant.username,
	                        amount: totalCostForJobble,
	                        jobble: application.jobble.id,
	                        note: "Jobble Web App payment"
	                      };
	                      transferArray.push(_transferObj);
	                    } else {
	                      var totalCostForJobbleNotEdited = Math.round(application.jobble.jobbleDurationInMinutes * application.jobble.payPerHour / 60);
	                      var _transferObj2 = {
	                        recipient: application.applicant.username,
	                        amount: totalCostForJobbleNotEdited,
	                        jobble: application.jobble.id,
	                        note: "Jobble Web App payment"
	                      };
	                      transferArray.push(_transferObj2);
	                    }
	                  } else {
	                    console.log("jobble actual minutes are 0...");
	                    console.dir(application);
	                  }
	                }
	              }
	            }
	          } else {
	            console.log("user not checked.");
	          }
	          console.log("--------------------------application in events.js---------------------------------");
	        });
	      } catch (err) {
	        console.log("some error in the loop");
	        console.dir(err);
	      } finally {
	        var eventIdForClosure = eventId.toString();
	
	        var payTheJobblers = null;
	
	        if (user.company.payByInvoice === true) {
	          payTheJobblers = {
	            method: "POST",
	            url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
	            headers: {
	              "Content-Type": "application/json",
	              Authorization: "Bearer " + this.$auth.getAccessToken()
	            },
	            data: {
	              transfers: transferArray
	            }
	          };
	        } else {
	          if (payType === "bank") {
	            payTheJobblers = {
	              method: "POST",
	              url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
	              headers: {
	                "Content-Type": "application/json",
	                Authorization: "Bearer " + this.$auth.getAccessToken()
	              },
	              data: {
	                transfers: transferArray,
	                bank: cardToken
	              }
	            };
	          } else {
	            payTheJobblers = {
	              method: "POST",
	              url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
	              headers: {
	                "Content-Type": "application/json",
	                Authorization: "Bearer " + this.$auth.getAccessToken()
	              },
	              data: {
	                transfers: transferArray,
	                card: cardToken
	              }
	            };
	          }
	        }
	      }
	
	      return this.$http(payTheJobblers);
	    }
	  }, {
	    key: "closeEvent",
	    value: function closeEvent(eventId) {
	      var _this = this;
	
	      var data = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/events/close-event?format=json",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	
	        data: { events: [eventId] }
	      };
	
	      return this.$http(data);
	    }
	  }, {
	    key: "getLatLngOfAddress",
	    value: function getLatLngOfAddress(shift) {
	      console.log("give me the address");
	      console.dir(shift);
	    }
	  }, {
	    key: "checkJobblerInOrOut",
	    value: function checkJobblerInOrOut(data, type) {
	      var url;
	
	      if (type === 1) {
	        url = "jbl/v1/jobbles/bulk-checkin?format=json";
	      } else {
	        url = "jbl/v1/jobbles/bulk-checkout?format=json";
	      }
	
	      var checkInJobblers = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + url,
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: data
	      };
	
	      return this.$http(checkInJobblers);
	    }
	  }, {
	    key: "getEventByIdTrimmedMessaging",
	    value: function getEventByIdTrimmedMessaging(event_id) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&fields=id,isChannelDeleted,autoAccept,autoManage,startTime,name,contactInfo.state,contactInfo.city,contactInfo.streetLine1,contactInfo.zipCode,subEvents.id,subEvents.deduppedJobbles.manager.id,subEvents.deduppedJobbles.shifts.timeInterval.id,subEvents.deduppedJobbles.shifts.timeInterval.startTime,subEvents.deduppedJobbles.shifts.timeInterval.startDateFormatted,subEvents.deduppedJobbles.shifts.timeInterval.endTime,subEvents.deduppedJobbles.shifts.timeInterval.endTimeFormattedLoc,subEvents.deduppedJobbles.shifts.timeInterval.startTimeFormattedLoc,subEvents.deduppedJobbles.shifts.contactInfo.place.timeZoneId";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getEventByIdTrimmedComplete",
	    value: function getEventByIdTrimmedComplete(event_id, x) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&fields=id,name,isSourcingPost,numberOfOpenings,orderNumber,endTime,subEvents.deduppedJobbles.payPerHour,subEvents.deduppedJobbles.jobbleType.fileJOBBLE_TYPE_FILE01IMG_800x800,subEvents.deduppedJobbles.jobbleType.picture1,firstInvoices,subEvents.deduppedJobbles.jobbleType.name,isClosed,isCancelled,isCompleted,subEvents.id,company.id,company.name,contactInfo.city,contactInfo.state,contactInfo.streetLine1,contactInfo.zipCode";
	
	      if (x === 1) {
	        url = url + ",surveyQuestions.id,surveyQuestions.name,surveyQuestions.question,surveyQuestions.questionType";
	      }
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getEventByIdTrimmedv2",
	    value: function getEventByIdTrimmedv2(event_id, x) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/events/details/" + event_id;
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getEventByIdTrimmedCreation",
	    value: function getEventByIdTrimmedCreation(event_id, x) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&fields=id,startTime,isLongTerm,weeks,dateCreated,autoAccept,autoManage,arrivalInstructions,onsiteManagerName,onsiteManagerNumber,originalOpenings,endTime,isClosed,isCompleted,isCancelled,name,description,totalNumberOfJobbles,numberOfOpenings,subEvents.description,subEvents.deduppedJobbles.description,subEvents.unpaidBreak,subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.name,subEvents.deduppedJobbles.startTimeFormattedLoc,subEvents.deduppedJobbles.endTimeFormattedLoc,subEvents.deduppedJobbles.jobbleType.name,eventManager,subEvents.deduppedJobbles.jobbleType.id,subEvents.deduppedJobbles.forCircleOnly,subEvents.deduppedJobbles.manager.id,subEvents.deduppedJobbles.dropoffContactInfo,subEvents.deduppedJobbles.shifts.overnight,subEvents.deduppedJobbles.shifts.contactInfo.place.rawOffset,subEvents.deduppedJobbles.manager.firstName,subEvents.deduppedJobbles.manager.lastName,subEvents.deduppedJobbles.manager.email,subEvents.deduppedJobbles.manager.homeContactInfo.phoneMobile,subEvents.deduppedJobbles.dressCode,subEvents.deduppedJobbles.shifts.id,subEvents.deduppedJobbles.shifts.shiftPosition,subEvents.deduppedJobbles.shifts.padding,subEvents.deduppedJobbles.shifts.location,subEvents.deduppedJobbles.shifts.timeInterval.id,subEvents.deduppedJobbles.shifts.timeInterval.endTimeFormattedLoc,subEvents.deduppedJobbles.shifts.timeInterval.startTimeFormattedLoc,subEvents.deduppedJobbles.shifts.timeInterval.startTime,subEvents.deduppedJobbles.shifts.timeInterval.startDateFormatted,subEvents.deduppedJobbles.shifts.overnight,subEvents.deduppedJobbles.shifts.timeInterval.endTime,subEvents.deduppedJobbles.shifts.contactInfo.city,subEvents.deduppedJobbles.shifts.contactInfo.lat,subEvents.deduppedJobbles.shifts.contactInfo.lng,subEvents.deduppedJobbles.shifts.contactInfo.place.timeZoneId,subEvents.deduppedJobbles.shifts.contactInfo.timeZoneName,subEvents.deduppedJobbles.shifts.contactInfo.state,subEvents.deduppedJobbles.isPublished,subEvents.deduppedJobbles.shifts.contactInfo.zipCode,subEvents.deduppedJobbles.shifts.contactInfo.id,subEvents.deduppedJobbles.shifts.contactInfo.streetLine1,subEvents.deduppedJobbles.shifts.unpaidBreak,subEvents.deduppedJobbles.payPerHour,subEvents.deduppedJobbles.jobblerRate,subEvents.deduppedJobbles.jobbleDurationInMinutes,subEvents.id,subEvents.deduppedJobbles.circles.name,subEvents.deduppedJobbles.currentLocation.lat,subEvents.deduppedJobbles.currentLocation.lng,subEvents.deduppedJobbles.currentLocation.lastUpdateFront,subEvents.deduppedJobbles.jobblePoolId";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getEventByIdTrimmed",
	    value: function getEventByIdTrimmed(event_id, x) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&fields=id,startTime,isLongTerm,weeks,dateCreated,autoAccept,autoManage,arrivalInstructions,onsiteManagerName,onsiteManagerNumber,isChannelDeleted,originalOpenings,endTime,isOrder,orderNumber,isSourcingPost,isClosed,isCompleted,isCancelled,name,description,totalNumberOfJobbles,numberOfApprovedApplications,numberOfOpenings,subEvents.description,subEvents.deduppedJobbles.description,subEvents.deduppedJobbles.pickupTime,subEvents.deduppedJobbles.dropoffTime,subEvents.deduppedJobbles.dropoffAddress,subEvents.deduppedJobbles.pickupAddress,subEvents.unpaidBreak,subEvents.deduppedJobbles.pickupLocation,subEvents.deduppedJobbles.dropoffLocation,subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.name,subEvents.deduppedJobbles.startTimeFormattedLoc,subEvents.deduppedJobbles.endTimeFormattedLoc,subEvents.deduppedJobbles.jobbleType.name,eventManager,subEvents.deduppedJobbles.jobbleType.picture1,subEvents.deduppedJobbles.jobbleType.picture1,subEvents.deduppedJobbles.jobbleType.id,subEvents.deduppedJobbles.forCircleOnly,subEvents.deduppedJobbles.manager.id,subEvents.deduppedJobbles.dropoffContactInfo,subEvents.deduppedJobbles.pickupContactInfo,subEvents.deduppedJobbles.shifts.deliveryContactInfo,subEvents.deduppedJobbles.shifts.overnight,subEvents.deduppedJobbles.shifts.contactInfo.place.rawOffset,subEvents.deduppedJobbles.manager.firstName,subEvents.deduppedJobbles.manager.lastName,subEvents.deduppedJobbles.manager.email,subEvents.deduppedJobbles.manager.homeContactInfo.phoneMobile,subEvents.deduppedJobbles.dressCode,subEvents.deduppedJobbles.shifts.id,subEvents.deduppedJobbles.shifts.shiftPosition,subEvents.deduppedJobbles.shifts.description,subEvents.deduppedJobbles.shifts.padding,subEvents.deduppedJobbles.shifts.location,subEvents.deduppedJobbles.shifts.timeInterval.id,subEvents.deduppedJobbles.shifts.timeInterval.endTimeFormattedLoc,subEvents.deduppedJobbles.shifts.timeInterval.startTimeFormattedLoc,subEvents.deduppedJobbles.shifts.timeInterval.startTime,subEvents.deduppedJobbles.shifts.timeInterval.startDateFormatted,subEvents.deduppedJobbles.shifts.overnight,subEvents.deduppedJobbles.shifts.timeInterval.endTime,subEvents.deduppedJobbles.shifts.contactInfo.city,subEvents.deduppedJobbles.shifts.contactInfo.lat,subEvents.deduppedJobbles.shifts.contactInfo.lng,subEvents.deduppedJobbles.shifts.contactInfo.place.timeZoneId,subEvents.deduppedJobbles.shifts.contactInfo.timeZoneName,subEvents.deduppedJobbles.shifts.contactInfo.state,subEvents.deduppedJobbles.isPublished,subEvents.deduppedJobbles.shifts.contactInfo.zipCode,subEvents.deduppedJobbles.shifts.contactInfo.id,subEvents.deduppedJobbles.shifts.contactInfo.streetLine1,subEvents.deduppedJobbles.shifts.unpaidBreak,subEvents.deduppedJobbles.payPerHour,subEvents.deduppedJobbles.jobblerRate,subEvents.deduppedJobbles.jobbleDurationInMinutes,subEvents.id,subEvents.deduppedJobbles.circles.name,numberOfPendingApplications,subEvents.deduppedJobbles.shifts.pickupEta,subEvents.deduppedJobbles.shifts.dropoffEta,subEvents.deduppedJobbles.currentLocation.lat,subEvents.deduppedJobbles.currentLocation.lng,subEvents.deduppedJobbles.currentLocation.lastUpdateFront,subEvents.deduppedJobbles.jobblePoolId,numberOfRejectedApplications,numberOfQuitApplications,numberOfWithdrawnApplications,surveyQuestions.id,surveyQuestions.name,surveyQuestions.question,surveyQuestions.questionType,surveyQuestions.displayOrder";
	
	      if (x === 1) {
	        url = url + ",surveyQuestions.id,surveyQuestions.name,surveyQuestions.question,surveyQuestions.questionType,surveyQuestions.displayOrder";
	      }
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getEventByIdWithFields",
	    value: function getEventByIdWithFields(event_id, fields) {
	      //var url = this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&fields=" + fields;
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/eventsNew/" + event_id;
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getEventCompanyDescription",
	    value: function getEventCompanyDescription() {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&conf=web&fields=company.description&aclProcess=false&marshal=false",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "saveEventCompanyDescription",
	    value: function saveEventCompanyDescription(description) {
	      var req = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + this.$auth.getUserData().id + "?format=json&fields=company.description&aclProcess=false&marshal=false",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          company: {
	            description: description
	          }
	        }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getEventByIdTrimmedLive",
	    value: function getEventByIdTrimmedLive(event_id) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&fields=id,isClosed,isCancelled,isCompleted,numberOfApprovedApplications,startTime,endTime,subEvents.id,name,contactInfo.state,contactInfo.city,contactInfo.streetLine1,contactInfo.zipCode,subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.shifts.id,subEvents.deduppedJobbles.shifts.timeInterval.startTime,subEvents.deduppedJobbles.shifts.timeInterval.endTime,subEvents.deduppedJobbles.shifts.checkInTime,subEvents.deduppedJobbles.shifts.checkOutTime";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getEventByIdTrimmedRoster",
	    value: function getEventByIdTrimmedRoster(event_id) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&fields=id,isClosed,isCancelled,numberOfApprovedApplications,isSourcingPost,isCompleted,startTime,subEvents.id,name,contactInfo.state,contactInfo.city,contactInfo.streetLine1,contactInfo.zipCode,subEvents.deduppedJobbles.payPerHour,subEvents.deduppedJobbles.shifts.id,subEvents.deduppedJobbles.shifts.position,subEvents.deduppedJobbles.shifts.timeInterval.startTime,subEvents.deduppedJobbles.jobbleType.fileJOBBLE_TYPE_FILE01IMG_800x800,subEvents.deduppedJobbles.jobbleType.picture1,subEvents.deduppedJobbles.shifts.timeInterval.endTime,subEvents.deduppedJobbles.shifts.contactInfo.state,subEvents.deduppedJobbles.shifts.callToAction,subEvents.deduppedJobbles.shifts.contactInfo.city,subEvents.deduppedJobbles.jobbleType.name,subEvents.deduppedJobbles.shifts.contactInfo.zipCode,subEvents.deduppedJobbles.shifts.contactInfo.place.timeZoneId,subEvents.deduppedJobbles.shifts.contactInfo.streetLine";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getEventByIdTrimmedTimesheet",
	    value: function getEventByIdTrimmedTimesheet(event_id) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&fields=id,startTime,subEvents.id,name,subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.shifts.timeInterval.startTime,subEvents.deduppedJobbles.shifts.timeInterval.startDateFormatted,subEvents.deduppedJobbles.shifts.timeInterval.endTime,subEvents.deduppedJobbles.shifts.contactInfo.city,subEvents.deduppedJobbles.shifts.contactInfo.place.timeZoneId,subEvents.deduppedJobbles.shifts.id,subEvents.deduppedJobbles.shifts.contactInfo.timeZoneName,subEvents.deduppedJobbles.shifts.contactInfo.state,subEvents.deduppedJobbles.shifts.contactInfo.zipCode,subEvents.deduppedJobbles.shifts.contactInfo.streetLine1,subEvents.deduppedJobbles.shifts.checkInTime,subEvents.deduppedJobbles.shifts.checkOutTime";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getEventByIdTrimmedInvoice",
	    value: function getEventByIdTrimmedInvoice(event_id, x) {
	      console.log("getEventByIdTrimmedInvoice");
	      console.dir(event_id);
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&fields=id,startTime,endTime,subEvents.deduppedJobbles.jobbleDurationInMinutes";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getAcceptedApplicationsTrimmedMessaging",
	    value: function getAcceptedApplicationsTrimmedMessaging(subEventId) {
	      var maxCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
	      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      // var url = this.$env.getAPIEndPoint() + 'jbl/v1/subevents/' + subEventId + '/applications?format=json&conf=web&max=5&status=1';
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + subEventId + "/applications?format=json&max=" + maxCount + "&status=1&fields=id,applicant.firstName,jobble.id,applicant.emailChatNotificationOn,applicant.smsChatNotificationOn,applicant.lastName,applicant.filePROFILE_IMAGE1IMG_75x75,applicant.id,applicant.email";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getAcceptedApplicationsTrimmed",
	    value: function getAcceptedApplicationsTrimmed(subEventId) {
	      var maxCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
	      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      // var url = this.$env.getAPIEndPoint() + 'jbl/v1/subevents/' + subEventId + '/applications?format=json&conf=web&max=5&status=1';
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + subEventId + "/applications?format=json&max=" + maxCount + "&status=1&fields=id,applicant.firstName,applicant.lastName,applicant.averageRatingReceived,applicant.picture1s,applicant.id";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getAcceptedApplicationsTrimmedRoster",
	    value: function getAcceptedApplicationsTrimmedRoster(subEventId, max) {
	      // var url = this.$env.getAPIEndPoint() + 'jbl/v1/subevents/' + subEventId + '/applications?format=json&conf=web&max=5&status=1';
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + subEventId + "/applications?format=json&offset=0&max=100&status=1&fields=id,dateCreated,applicant.firstName,applicant.lastName,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,applicant.email,applicant.id,applicant.homeContactInfo.phoneMobile,jobble.id,jobble.shifts.id,jobble.shifts.shiftPosition,jobble.shifts.managerCheckInTime,jobble.shifts.managerCheckOutTime,jobble.shifts.autoCheckInCoord.dateCreated,jobble.shifts.autoCheckOutCoord.dateCreated,jobble.shifts.checkInTime,jobble.shifts.checkOutTime,jobble.shifts.timeInterval.startTime,jobble.shifts.timeInterval.endTime,jobble.shifts.contactInfo.place.timeZoneId,jobble.shifts.contactInfo.place.rawOffset,jobble.shifts.confirmationResponse,jobble.shifts.confirmationSource,jobble.shifts.confirmationNote,jobble.shifts.confirmationDateTime";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getAcceptedApplicationsRosterManagement",
	    value: function getAcceptedApplicationsRosterManagement(subEventId, max) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + subEventId + "/applications?format=json&offset=0&max=100&status=1&fields=id,dateCreated,applicant.id,jobble.id,jobble.shifts.id,jobble.shifts.shiftPosition,jobble.shifts.managerCheckInTime,jobble.shifts.managerCheckOutTime,jobble.shifts.autoCheckInCoord.dateCreated,jobble.shifts.autoCheckOutCoord.dateCreated,jobble.shifts.autoCheckInCoord.lat,jobble.shifts.autoCheckInCoord.lng,jobble.shifts.autoCheckOutCoord.lat,jobble.shifts.autoCheckOutCoord.lng,jobble.shifts.checkOutCoord.lat,jobble.shifts.checkOutCoord.lng,jobble.shifts.checkInCoord.lat,jobble.shifts.checkInCoord.lng,jobble.shifts.checkInTime,jobble.shifts.checkOutTime,jobble.shifts.confirmationResponse,jobble.shifts.confirmationSource,jobble.shifts.confirmationNote,jobble.shifts.jobblerNote,jobble.shifts.confirmationDateTime,jobble.shifts.actualMinutesWorked,jobble.shifts.noShow,jobble.shifts.paymentStats,jobble.shifts.timeInterval.startTime,jobble.shifts.timeInterval.endTime";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getShiftInformationComplete",
	    value: function getShiftInformationComplete(subEventId, application) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + subEventId + "/applications/" + application.id + "?format=json&fields=jobble.shifts.id,jobble.shifts.paymentStats,jobble.shifts.checkInCoord.lat,jobble.shifts.checkInCoord.lng,jobble.shifts.checkOutCoord.lat,jobble.shifts.checkOutCoord.lng,jobble.shifts.checkInTime,jobble.shifts.checkOutTime,jobble.shifts.noShow,jobble.shifts.contactInfo.place.timeZoneId,jobble.shifts.contactInfo.place.timeZoneName,jobble.shifts.contactInfo.city,jobble.shifts.contactInfo.state,jobble.shifts.contactInfo.zipCode,jobble.shifts.contactInfo.streetLine1,jobble.shifts.actualMinutesWorked,jobble.shifts.timeInterval.id,jobble.shifts.timeInterval.endTime,jobble.shifts.timeInterval.startTime,jobble.shifts.jobblerNote,jobble.shifts.autoCheckInCoord.dateCreated,jobble.shifts.autoCheckInCoord.lat,jobble.shifts.autoCheckInCoord.lng,jobble.shifts.autoCheckOutCoord.dateCreated,jobble.shifts.autoCheckOutCoord.lat,jobble.shifts.autoCheckOutCoord.lng";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getAcceptedApplicationsTrimmedComplete",
	    value: function getAcceptedApplicationsTrimmedComplete(subEventId, maxCount, offset) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + subEventId + "/applications?format=json&max=" + maxCount + "&offset=" + offset + "&status=1&fields=applicant.username,jobble.subEvents.id,applicant.email,jobble.id,jobble.makeAdditionalPayment,jobble.startTime,jobble.endTime,id,applicant.firstName,applicant.lastName,applicant.age,applicant.gender,applicant.dateBirth,applicant.averageRatingReceived,applicant.id,applicant.homeContactInfo.phoneMobile,jobble.actualMinutesWorked,jobble.noShow,jobble.jobbleDuration,jobble.jobbleDurationInMinutes,jobble.actualRevenue,jobble.jobblePoolId,jobble.payPerHour,jobble.costOfJobble,rating.id,rating.value,rating.rate,jobble.paymentStats,jobble.shifts.jobblerNote,jobble.shifts.id,jobble.shifts.paymentStats,jobble.shifts.timeInterval.startTime,jobble.shifts.timeInterval.endTime,jobble.shifts.checkInTime,jobble.shifts.checkOutTime,jobble.shifts.autoCheckInCoord,jobble.shifts.autoCheckOutCoord,applicant.filePROFILE_IMAGE1IMG_75x75,applicant.undeletedPaymentInfos.id";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getAcceptedApplicationsTrimmedCompleteTracking",
	    value: function getAcceptedApplicationsTrimmedCompleteTracking(subEventId) {
	      var maxCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
	      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + subEventId + "/applications?format=json&max=" + maxCount + "&status=1&fields=applicant.username,applicant.email,jobble.id,applicant.id,jobble.noShow,jobble.shifts.jobblerNote,jobble.shifts.autoCheckInCoord.dateCreated,jobble.shifts.autoCheckInCoord.lat,jobble.shifts.autoCheckInCoord.lng,jobble.shifts.id,jobble.shifts.autoCheckOutCoord.dateCreated,jobble.shifts.autoCheckOutCoord.lat,jobble.shifts.autoCheckOutCoord.lng,jobble.shifts.checkInTime,jobble.shifts.checkOutTime,jobble.shifts.checkOutCoord.lat,jobble.shifts.checkOutCoord.lng,jobble.shifts.checkInCoord.lat,jobble.shifts.checkInCoord.lng,jobble.shifts.checkOutTime,jobble.shifts.checkOutCoord.lat,jobble.shifts.timeInterval.startTime,jobble.shifts.contactInfo.city,jobble.shifts.contactInfo.state,jobble.shifts.contactInfo.streetLine1,jobble.shifts.contactInfo.zipCode,jobble.shifts.noShow";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getAcceptedApplicationsTrimmedLive",
	    value: function getAcceptedApplicationsTrimmedLive(subEventId) {
	      var maxCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
	      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + subEventId + "/applications?format=json&max=" + maxCount + "&status=1&fields=applicant.username,jobble.subEvents.id,applicant.email,jobble.id,jobble.startTime,jobble.endTime,id,applicant.firstName,applicant.lastName,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,applicant.id,applicant.homeContactInfo.phoneMobile,jobble.actualMinutesWorked,jobble.noShow,jobble.jobbleDuration,jobble.jobbleDurationInMinutes,jobble.actualRevenue,jobble.payPerHour,jobble.costOfJobble,rating.id,rating.value,rating.rate,jobble.paymentStats,jobble.shifts.timeInterval.startTime,jobble.shifts.timeInterval.endTime,jobble.shifts.checkInTime,jobble.shifts.checkOutTime,jobble.shifts.checkOutCoord.lat,jobble.shifts.checkOutCoord.lng,jobble.shifts.checkInCoord.lat,jobble.shifts.checkInCoord.lng";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "checkForOverlaps",
	    value: function checkForOverlaps(data) {
	      /*{jobblesAndUsers: [{jobbleId:48354725,userId:168,appId:5915},{jobbleId:48354726,userId:170,appId:5917}]}*/
	
	      var userId = data[0].userId;
	      var jobbleId = data[0].jobbleId;
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/users/" + userId + "/jobbles/" + jobbleId + "/checkOverlap?format=json";
	
	      var req = {
	        method: "PUT",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: { jobblesAndUsers: data }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getAcceptedApplicationsTrimmedReview",
	    value: function getAcceptedApplicationsTrimmedReview(subEventId, maxCount, offset) {
	      if (!offset) {
	        offset = 0;
	      }
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + subEventId + "/applications?format=json&max=" + maxCount + "&offset=" + offset + "&status=1&fields=id,applicationStatus.id,applicationStatus.name,hasOverlap,applicant.firstName,applicant.lastName,applicant.filePROFILE_IMAGE1IMG_75x75,applicant.averageRatingReceived,applicant.isVerified,applicant.username,applicant.homeContactInfo.city,applicant.homeContactInfo.state,applicant.id,jobble.id,applicant.homeContactInfo.phoneMobile,applicant.numberOfCompletedJobbles,jobble.jobblePool.id,applicant.undeletedPaymentInfos.id";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getPendingApplicationsTrimmedReview",
	    value: function getPendingApplicationsTrimmedReview(subEventId, maxCount, offset) {
	      if (!offset) {
	        offset = 0;
	      }
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + subEventId + "/applications?format=json&max=" + maxCount + "&offset=" + offset + "&status=3&isApplicantVerified=true&conf=web&fields=id,applicationStatus.id,applicationStatus.name,applicant.firstName,hasOverlap,applicant.lastName,applicant.isDeleted,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,jobble.id,applicant.id,applicant.homeContactInfo.city,applicant.homeContactInfo.state,applicant.homeContactInfo.phoneMobile,applicant.isVerified,applicant.username,applicant.numberOfCompletedJobbles,applicant.undeletedPaymentInfos.id";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getAllApplicants",
	    value: function getAllApplicants(jpid, max, offset, sort, order, multiSearch) {
	      if (!offset) {
	        offset = 0;
	      }
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/applications/list-all?format=json&jpid=" + jpid + "&max=" + max + "&offset=" + offset + "&conf=web";
	
	      if (sort) {
	        url += "&sort=" + sort;
	      }
	
	      if (order) {
	        url += "&order=" + order;
	      }
	
	      if (multiSearch) {
	        url += "&multiSearch=" + encodeURIComponent(multiSearch);
	      }
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getPendingApplicationsTrimmedReview2",
	    value: function getPendingApplicationsTrimmedReview2(jpid, max, offset) {
	      if (!offset) {
	        offset = 0;
	      }
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/applications/list-all?format=json&jpid=" + jpid + "&max=" + max + "&offset=" + offset + "&conf=web";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getRejectingApplicationsTrimmedReview",
	    value: function getRejectingApplicationsTrimmedReview(jpid, max, offset) {
	      if (!max) {
	        max = 10;
	      }
	      if (!offset) {
	        offset = 0;
	      }
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/applications/list-rejects?format=json&jpid=" + jpid + "&max=" + max + "&offset=" + offset + "&conf=web";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getQuitedApplicationsTrimmedReview",
	    value: function getQuitedApplicationsTrimmedReview(jpid, max, offset) {
	      if (!max) {
	        max = 10;
	      }
	      if (!offset) {
	        offset = 0;
	      }
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/applications/list-quitted?format=json&jpid=" + jpid + "&max=" + max + "&offset=" + offset + "&conf=web";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getWithdrawnApplicationsTrimmedReview",
	    value: function getWithdrawnApplicationsTrimmedReview(jpid, max, offset) {
	      if (!max) {
	        max = 10;
	      }
	      if (!offset) {
	        offset = 0;
	      }
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/applications/list-withdrawn?format=json&jpid=" + jpid + "&max=" + max + "&offset=" + offset + "&conf=web";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "removeOpeningsToEvent",
	    value: function removeOpeningsToEvent(data, event, x) {
	      var _this = this;
	
	      var removeOpeningsData = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + data.draftData.data.jobblePool.jobbles[0].id + "/rm-positions?format=json&conf=web&numberOfPositions=" + x,
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return _this.$http(removeOpeningsData);
	    }
	  }, {
	    key: "cloneEventv3",
	    value: function cloneEventv3(eventId) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/events/" + eventId + "/clone",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "addOpeningsToEvent",
	    value: function addOpeningsToEvent(data, event, x) {
	      var _this = this;
	      console.log("removeOpeningsToEvent");
	      console.dir(data);
	      console.dir(event);
	      console.dir(x);
	      var addOpeningsData = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + data.draftData.data.jobblePool.jobbles[0].id + "/add-positions?format=json&conf=web&numberOfPositions=" + x,
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return _this.$http(addOpeningsData);
	    }
	  }, {
	    key: "roundPay",
	    value: function roundPay(pay) {
	      return Math.round(parseFloat(pay * 100));
	    }
	  }, {
	    key: "saveDraft",
	    value: function saveDraft(params) {
	      var _this = this;
	      var eventObj = params.event;
	      var is_sourcing_post = false;
	      if (eventObj.typeOfJobPosting === "source") {
	        is_sourcing_post = true;
	      }
	      var pay = _this.roundPay(eventObj.hourly_rate);
	      var jobbleForDB = {
	        name: eventObj.name,
	        payPerHour: pay,
	        description: eventObj.jobble_details,
	        dressCode: eventObj.dress_code ? eventObj.dress_code : "Casual",
	        jobbleType: eventObj.jobble_type,
	        isPublished: false,
	        manager: eventObj.manager,
	        subEvent: {
	          name: eventObj.name,
	          contactInfo: eventObj.timeIntervalsArray[0].contactInfo,
	          event: {
	            name: eventObj.name,
	            description: eventObj.jobble_details,
	            eventType: 1,
	            isPublished: false,
	            timeToHire: eventObj.timeToHire,
	            company: this.$auth.getUserData().company.id,
	            isSourcingPost: is_sourcing_post
	          }
	        },
	        shifts: []
	      };
	      if (eventObj.typeOfJobPosting === "source") {
	        jobbleForDB.subEvent.event.isSourcingPost = true;
	      } else {
	        jobbleForDB.subEvent.event.isSourcingPost = false;
	      }
	      try {
	        for (var i = 0; i < eventObj.timeIntervalsArray.length; i++) {
	          var shift = {
	            timeInterval: {
	              startTime: eventObj.timeIntervalsArray[i].startDateAndTimeForDB,
	              endTime: eventObj.timeIntervalsArray[i].endDateAndTimeForDB
	            },
	            contactInfo: eventObj.timeIntervalsArray[i].contactInfo
	          };
	          jobbleForDB.shifts.push(shift);
	        }
	      } finally {
	        var saveDraftObj = {
	          method: "POST",
	          url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/create-pool?format=json&conf=web&verbosity=3&numberPosition=" + eventObj.openings,
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + this.$auth.getAccessToken()
	          },
	          data: {
	            jobble: jobbleForDB
	          }
	        };
	        return this.$http(saveDraftObj);
	      }
	    }
	  }, {
	    key: "saveDraftv2",
	    value: function saveDraftv2(event, cloneId) {
	      var eventObj = event;
	
	      console.log("saveDraftv2");
	      console.dir(eventObj);
	
	      var is_sourcing_post = eventObj.typeOfJobPosting === "source";
	      var pay = this.roundPay(eventObj.hourly_rate);
	      var company = this.$auth.getUserData() ? this.$auth.getUserData().company : {};
	
	      var jobbleForDB = {
	        name: eventObj.name,
	        payPerHour: pay,
	        description: eventObj.jobble_details,
	        dressCode: eventObj.dress_code ? eventObj.dress_code : null,
	        jobbleType: eventObj.jobble_type,
	        arrivalInstructions: eventObj.arrival_instructions,
	        onsiteManagerName: eventObj.onsite_manager_name,
	        onsiteManagerNumber: eventObj.onsite_manager_number,
	        isLongTerm: eventObj.is_long_term,
	        weeks: eventObj.weeks,
	        isPublished: false,
	        manager: eventObj.manager,
	        subEvent: {
	          name: eventObj.name,
	          contactInfo: eventObj.timeIntervalsArray[0].contactInfo,
	          event: {
	            name: eventObj.name,
	            description: eventObj.jobble_details,
	            eventType: 1,
	            isPublished: false,
	            timeToHire: eventObj.timeToHire,
	            company: company.id,
	            isW2: event.isW2,
	            isSourcingPost: is_sourcing_post,
	            arrivalInstructions: eventObj.arrival_instructions,
	            onsiteManagerName: eventObj.onsite_manager_name,
	            onsiteManagerNumber: eventObj.onsite_manager_number,
	            isLongTerm: eventObj.is_long_term,
	            weeks: eventObj.weeks
	          }
	        },
	        shifts: []
	      };
	
	      if (cloneId) {
	        jobbleForDB.subEvent.event.cloneOf = cloneId;
	      }
	
	      jobbleForDB.subEvent.event.isSourcingPost = is_sourcing_post;
	
	      var saveDraftObj = void 0;
	
	      try {
	        eventObj.timeIntervalsArray.map(function (timeInterval) {
	          var shift = {
	            timeInterval: {
	              startTime: timeInterval.startDateAndTimeForDB,
	              endTime: timeInterval.endDateAndTimeForDB
	            },
	            contactInfo: timeInterval.contactInfo,
	            overnight: timeInterval.overnight,
	            unpaidBreak: timeInterval.unpaidBreak
	          };
	          jobbleForDB.shifts.push(shift);
	        });
	      } finally {
	        console.log("jobbleForDB");
	        console.dir(jobbleForDB);
	
	        saveDraftObj = {
	          method: "POST",
	          url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/create-pool?format=json&conf=web&verbosity=3&numberPosition=" + eventObj.openings,
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + this.$auth.getAccessToken()
	          },
	          data: {
	            jobble: jobbleForDB
	          }
	        };
	      }
	
	      return this.$http(saveDraftObj);
	    }
	  }, {
	    key: "addShiftRequirement",
	    value: function addShiftRequirement(eventId, id, position) {
	      var data = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/event/" + eventId + "/requirement?format=json",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          requirements: [{
	            id: id,
	            position: position
	          }]
	        }
	      };
	
	      return this.$http(data);
	    }
	  }, {
	    key: "addShiftRequirements",
	    value: function addShiftRequirements(eventId, requirements) {
	      var data = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/event/" + eventId + "/requirement?format=json",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          requirements: requirements
	        }
	      };
	
	      return this.$http(data);
	    }
	  }, {
	    key: "removeShiftRequirement",
	    value: function removeShiftRequirement(eventId, id) {
	      console.log("removeShiftRequirement");
	      console.dir(eventId);
	      console.dir(id);
	      var data = {
	        method: "DELETE",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/event/" + eventId + "/requirement?format=json",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          requirementId: id
	        }
	      };
	
	      return this.$http(data);
	    }
	  }, {
	    key: "getAllShiftRequirements",
	    value: function getAllShiftRequirements() {
	      var data = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/requirement?format=json",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        }
	      };
	
	      return this.$http(data);
	    }
	  }, {
	    key: "getShiftRequirements",
	    value: function getShiftRequirements(eventId) {
	      var data = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/event/" + eventId + "/requirement?format=json",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        }
	      };
	
	      return this.$http(data);
	    }
	  }, {
	    key: "deleteShift",
	    value: function deleteShift(shift) {
	      var _this = this;
	
	      //console.log("deleteShift");
	      //console.dir(shift);
	
	      var req = {
	        method: "DELETE",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/bulk-shifts?format=json&sendSlackNotification=false",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          id: shift.id
	        }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "bulkDeleteShifts",
	    value: function bulkDeleteShifts(shiftIds) {
	      var _this = this;
	
	      console.log("bulkDeleteShifts");
	      console.dir(shiftIds);
	
	      var req = {
	        method: "DELETE",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/bulk-shifts/bulk-delete?format=json&sendSlackNotification=false",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: { ids: shiftIds }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "updateExistingShift",
	    value: function updateExistingShift(shift, isChecked) {
	      var _this = this;
	
	      console.log("updateNewShiftForExistingEvent");
	      console.dir(shift);
	
	      var sendNotification = null;
	
	      if (isChecked === true) {
	        sendNotification = false;
	      } else {
	        sendNotification = true;
	      }
	
	      var req = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/bulk-shifts?format=json&sendNotification=" + sendNotification,
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: shift
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "createNewShiftForExistingEventBulk",
	    value: function createNewShiftForExistingEventBulk(payload) {
	      var _this = this;
	
	      var data = payload;
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/shifts/bulk-shifts/bulk-create?format=json&sendSlackNotification=false",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: data
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "createNewShiftForExistingEvent",
	    value: function createNewShiftForExistingEvent(jobbleId, shifts, event, shift) {
	      var _this = this;
	
	      console.log("createNewShiftForExistingEvent");
	      console.dir(shift);
	      console.dir(jobbleId);
	      console.dir(event);
	
	      var data = {
	        jobbleId: jobbleId,
	        contactInfo: {
	          city: shift.contactInfo.city,
	          state: shift.contactInfo.state,
	          streetLine1: shift.contactInfo.streetLine1,
	          streetLine2: null,
	          zipCode: shift.contactInfo.zipCode,
	          lat: shift.contactInfo.lat,
	          lng: shift.contactInfo.lng
	        },
	        timeInterval: {
	          startTime: shift.timeInterval.startTime,
	          endTime: shift.timeInterval.endTime
	        },
	        overnight: shift.overnight
	      };
	
	      if (shift.unpaidBreak && shift.unpaidBreak > 0) {
	        data.unpaidBreak = shift.unpaidBreak;
	      }
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/shifts/bulk-shifts?format=json&sendSlackNotification=false",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: data
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "updateExistingDraft",
	    value: function updateExistingDraft(jobbleId, shifts, event) {
	      var _this = this;
	
	      console.log("updateExistingDraft");
	      console.dir(jobbleId);
	      console.dir(shifts);
	
	      var id = null;
	
	      if (jobbleId) {
	        id = jobbleId;
	      } else {
	        id = event.jid;
	      }
	
	      var jobbleShiftsData = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + id + "/bulk-update?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          jobble: {
	            shifts: shifts
	          }
	        }
	      };
	
	      return _this.$http(jobbleShiftsData);
	    }
	
	    //_this.updateJobblePoolData();
	    //_this.updateSubEventData();
	
	  }, {
	    key: "editOpenings",
	    value: function editOpenings() {
	      var _this = this;
	
	      var addOpeningsData = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + _this.event.subEvents[0].deduppedJobbles[0].id + "/add-positions?format=json&conf=web&numberOfPositions=" + (_this.event.numberOfOpenings - _this.event.numberOfOpeningsOrigin),
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      _this.$http(addOpeningsData).then(function (response) {
	        if (response.data.status !== "error") {
	          _this.updateSubEventData();
	        }
	      }, function (response) {
	        console.log(response.data);
	      });
	    }
	  }, {
	    key: "updateEventData",
	    value: function updateEventData(jobblePool, event) {
	      var _this = this;
	
	      var eventData = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + jobblePool.eventId + "?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          name: event.name,
	          eventType: 1,
	          description: event.jobble_details
	        }
	      };
	
	      return _this.$http(eventData);
	    }
	  }, {
	    key: "extendJob",
	    value: function extendJob(payload) {
	      var _this = this;
	
	      console.log("extendJob");
	      console.dir(payload);
	
	      var payload = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + payload.jobbleIdExtend + "/extend",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          weeks: payload.weeks
	        }
	      };
	
	      return _this.$http(payload);
	    }
	  }, {
	    key: "setJobSchedule",
	    value: function setJobSchedule(jobbleId, weeks) {
	      var _this = this;
	
	      var payload = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobbleId + "/schedule",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          weeks: weeks
	        }
	      };
	
	      return _this.$http(payload);
	    }
	  }, {
	    key: "updateAutoHire",
	    value: function updateAutoHire(event, payload) {
	      var _this = this;
	
	      var eventData = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + event.id + "?format=json&conf=web&fields=id,autoAccept,autoManage",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: payload
	      };
	
	      return _this.$http(eventData);
	    }
	  }, {
	    key: "reverseReject",
	    value: function reverseReject(id) {
	      var _this = this;
	      var data = {
	        method: "GET",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/applications/reverseReject/" + id + "?format=json&fields=id,applicationStatus.id,applicationStatus.name,applicant.firstName,applicant.lastName,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,jobble.id,applicant.id,applicant.homeContactInfo.city,applicant.homeContactInfo.state,applicant.username,applicant.numberOfCompletedJobbles",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: { applicationId: id }
	      };
	
	      return _this.$http(data);
	    }
	  }, {
	    key: "updateJobblePoolData",
	    value: function updateJobblePoolData(jobblePool, event) {
	      console.log("updateJobblePoolData");
	      console.dir(jobblePool);
	      console.dir(event);
	
	      var _this = this;
	
	      var jobblePoolData = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobblePool.jobbles[0].id + "/bulk-update?format=json",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          jobble: {
	            jobbleType: event.jobble_type,
	            description: event.jobble_details,
	            payPerHour: event.hourly_rate * 100,
	            dressCode: event.dress_code
	          }
	        }
	      };
	
	      return _this.$http(jobblePoolData);
	    }
	  }, {
	    key: "saveQuestionsToEvent",
	    value: function saveQuestionsToEvent(eid, questions, event) {
	      var _this = this;
	
	      console.log("saveQuestionsToEvent");
	      console.dir(eid);
	      console.dir(questions);
	      console.dir(event);
	
	      var eventData = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + eid + "?format=json&conf=web&fields=id,isPublished",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          surveyQuestions: questions,
	          name: event.name,
	          eventType: 1,
	          description: event.jobble_details
	        }
	      };
	
	      return _this.$http(eventData);
	    }
	  }, {
	    key: "saveEventPayRate",
	    value: function saveEventPayRate(jobble_id, pay) {
	      pay = parseFloat(pay);
	
	      var jobblePoolData = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobble_id + "/bulk-update?format=json&sendSlackNotification=false&creationProcess=true",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          jobble: {
	            payPerHour: pay * 100,
	            isPublished: true,
	            creationProcess: true
	          }
	        }
	      };
	
	      return this.$http(jobblePoolData);
	    }
	  }, {
	    key: "saveEventHiringManager",
	    value: function saveEventHiringManager(jobble_id, hiring_manager) {
	      var jobblePoolData = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobble_id + "/bulk-update?format=json&sendSlackNotification=false",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          jobble: {
	            manager: hiring_manager
	          }
	        }
	      };
	
	      return this.$http(jobblePoolData);
	    }
	  }, {
	    key: "saveEventPositionType",
	    value: function saveEventPositionType(jobble_id, position_type) {
	      console.log("jobble_id");
	      console.dir(jobble_id);
	      console.dir(position_type);
	
	      var jobblePoolData = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobble_id + "/bulk-update?format=json&sendSlackNotification=false",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          jobble: {
	            jobbleType: position_type
	          }
	        }
	      };
	
	      return this.$http(jobblePoolData);
	    }
	  }, {
	    key: "saveEventName",
	    value: function saveEventName(event_id, name) {
	      var eventData = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&conf=web&fields=id,isPublished&aclProcess=false&marshal=false",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          name: name
	        }
	      };
	
	      return this.$http(eventData);
	    }
	  }, {
	    key: "saveW2Status",
	    value: function saveW2Status(event) {
	      console.log("saveW2Status");
	      console.dir(event);
	
	      var eventData = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/events/" + event.id + "?format=json&conf=web&fields=id,isPublished&aclProcess=false&marshal=false",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          isW2: event.is_w2
	        }
	      };
	
	      return this.$http(eventData);
	    }
	  }, {
	    key: "saveEventLongTermShortTerm",
	    value: function saveEventLongTermShortTerm(event_id, isLongTerm) {
	      var data = {
	        isLongTerm: isLongTerm
	      };
	
	      if (!isLongTerm) {
	        data.weeks = null;
	      }
	
	      console.log("saveEventLongTermShortTerm");
	      console.dir(data);
	
	      var jobblePoolData = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: data
	      };
	
	      return this.$http(jobblePoolData);
	    }
	  }, {
	    key: "saveEventLongTermWeeks",
	    value: function saveEventLongTermWeeks(event_id, weeks) {
	      console.log("saveEventLongTermWeeks");
	      console.dir(event_id);
	      console.dir(weeks);
	
	      if (!weeks || angular.isUndefined(weeks) || weeks === "undefined" || weeks === 0 || weeks === "0") {
	        console.log("setting default weeks");
	        weeks = "11";
	      }
	
	      console.log("weeks right before request");
	      console.dir(weeks);
	
	      var jobblePoolData = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&conf=web&aclProcess=false&marshal=false",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          weeks: weeks
	        }
	      };
	
	      return this.$http(jobblePoolData);
	    }
	  }, {
	    key: "saveEventArrivalInstructions",
	    value: function saveEventArrivalInstructions(event_id, arrivalInstructions, onsiteManagerName, onsiteManagerNumber) {
	      var jobblePoolData = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          arrivalInstructions: arrivalInstructions,
	          onsiteManagerName: onsiteManagerName,
	          onsiteManagerNumber: onsiteManagerNumber
	        }
	      };
	
	      return this.$http(jobblePoolData);
	    }
	  }, {
	    key: "saveEventDescription",
	    value: function saveEventDescription(event_id, description) {
	      var jobblePoolData = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/events/" + event_id + "?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          description: description
	        }
	      };
	
	      return this.$http(jobblePoolData);
	    }
	  }, {
	    key: "saveEventDescriptionToJobbles",
	    value: function saveEventDescriptionToJobbles(jobble_id, description) {
	      var jobblePoolData = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobble_id + "/bulk-update?format=json&sendSlackNotification=false",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          jobble: {
	            description: description
	          }
	        }
	      };
	
	      return this.$http(jobblePoolData);
	    }
	  }, {
	    key: "saveEventDressCode",
	    value: function saveEventDressCode(jobble_id, dress_code) {
	      var jobblePoolData = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobble_id + "/bulk-update?format=json&sendSlackNotification=false",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          jobble: {
	            dressCode: dress_code
	          }
	        }
	      };
	
	      return this.$http(jobblePoolData);
	    }
	  }, {
	    key: "validateWorflowShift",
	    value: function validateWorflowShift(shift, generator) {
	      if (!shift || !shift.startDate || !shift.startTime || !shift.endDate || !shift.endTime) {
	        return false;
	      }
	      var startDate = new Date(shift.startDate + " " + shift.startTime);
	      var endDate = new Date(shift.endDate + " " + shift.endTime);
	      if (startDate.getTime() - new Date().getTime() <= 0) {
	        console.error("Start date in the past");
	        return false;
	      }
	      if (this.development_env !== "dev" && startDate.getTime() - new Date().getTime() <= GRACE_PERIOD) {
	        console.error("Start date is less than 3 days from now");
	        return false;
	      }
	      if (endDate.getTime() - startDate.getTime() <= 0) {
	        console.error("End date after start date");
	        return false;
	      }
	      if (endDate.getTime() - startDate.getTime() > 1000 * 60 * 60 * 24 && !generator) {
	        console.error("Shift is longer than 24 hours");
	        return false;
	      }
	      if (this.development_env !== "dev" && endDate.getTime() - startDate.getTime() < 1000 * 60 * 60 * 6) {
	        console.error("Shift is shorter than 6 hours");
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: "validateLongTermGenerator",
	    value: function validateLongTermGenerator(shift) {
	      console.log("this.development_env", this.development_env);
	
	      if (!shift || !shift.startDate || !shift.startTime || !shift.endTime) {
	        return false;
	      }
	
	      var startDate = new Date(shift.startDate + " " + shift.startTime);
	      var endDate = new Date(shift.startDate + " " + shift.endTime);
	
	      if (endDate.getTime() - startDate.getTime() <= 0) {
	        endDate = new Date(endDate.getTime() + 1000 * 60 * 60 * 24);
	      }
	
	      var shiftLength = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60);
	
	      if (startDate.getTime() - new Date().getTime() <= 0) {
	        console.error("Start date in the past");
	        return false;
	      }
	
	      if (startDate.getTime() - new Date().getTime() <= GRACE_PERIOD) {
	        console.error("Start date is less than 3 days from now");
	        return false;
	      }
	
	      if (!shift.daysOfWeek || !shift.daysOfWeek.length || shift.daysOfWeek.length < 3) {
	        console.error("Less than 3 days in the week");
	        return false;
	      }
	
	      if (this.development_env !== "dev" && shiftLength < 6) {
	        console.error("Less than 6 hours in the shift");
	        return false;
	      }
	
	      // if (endDate.getTime() - startDate.getTime() <= 0) {
	      //     console.error("End date after start date");
	      //     return false;
	      // }
	
	      // if (endDate.getTime() - startDate.getTime() > 1000 * 60 * 60 * 24 && !generator) {
	      //     console.error("Shift is longer than 24 hours");
	      //     return false;
	      // }
	
	      return true;
	    }
	  }, {
	    key: "validateWorflowShiftsNonOverlapping",
	    value: function validateWorflowShiftsNonOverlapping(shifts) {
	      if (!shifts || !shifts.length) return false;
	
	      if (shifts.length === 1) return true;
	
	      var mappedShifts = shifts.map(function (shift) {
	        return {
	          startDate: new Date(shift.startDate + " " + shift.startTime),
	          endDate: new Date(shift.endDate + " " + shift.endTime)
	        };
	      });
	
	      mappedShifts = mappedShifts.sort(function (a, b) {
	        return a.startDate.getTime() - b.startDate.getTime();
	      });
	
	      var overLapping = false;
	
	      mappedShifts.forEach(function (shift, i) {
	        if (i === 0) return;
	
	        var prevShift = mappedShifts[i - 1];
	
	        if (shift.startDate.getTime() < prevShift.endDate.getTime()) overLapping = true;
	      });
	
	      return !overLapping;
	    }
	  }, {
	    key: "bulkUpdateJob",
	    value: function bulkUpdateJob(jid, eventObj) {
	      var _this = this;
	
	      var jobbleForDB = {
	        name: eventObj.name,
	        payPerHour: parseInt(eventObj.hourly_rate * 100),
	        description: eventObj.jobble_details,
	        dressCode: eventObj.dress_code,
	        jobbleType: eventObj.jobble_type,
	        isPublished: true,
	        subEvent: {
	          name: eventObj.name,
	          contactInfo: eventObj.timeIntervalsArray[0].contactInfo,
	          event: {
	            name: eventObj.name,
	            description: eventObj.jobble_details,
	            eventType: 1,
	            isPublished: false,
	            timeToHire: eventObj.timeToHire,
	            company: this.$auth.getUserData().company.id,
	            isSourcingPost: null
	          }
	        },
	
	        shifts: []
	      };
	
	      if (eventObj.typeOfJobPosting === "source") {
	        jobbleForDB.subEvent.event.isSourcingPost = true;
	      } else {
	        jobbleForDB.subEvent.event.isSourcingPost = false;
	      }
	
	      console.log("eventObj.cloudsForJobblePost");
	      console.dir(eventObj.cloudsForJobblePost);
	
	      try {
	        for (var i = 0; i < eventObj.timeIntervalsArray.length; i++) {
	          var shift = {
	            timeInterval: {
	              startTime: eventObj.timeIntervalsArray[i].startDateAndTimeForDB,
	              endTime: eventObj.timeIntervalsArray[i].endDateAndTimeForDB
	            },
	            contactInfo: eventObj.timeIntervalsArray[i].contactInfo
	          };
	          jobbleForDB.shifts.push(shift);
	        }
	      } finally {
	        var jobblePoolData = {
	          method: "PUT",
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jid + "/bulk-update?format=json&fields=id",
	          headers: {
	            "Content-Type": "application/json;charset=UTF-8",
	            Authorization: "Bearer " + _this.$auth.getAccessToken()
	          },
	          data: { jobble: jobbleForDB }
	        };
	
	        return _this.$http(jobblePoolData);
	      }
	    }
	  }, {
	    key: "markJobAsPublished",
	    value: function markJobAsPublished(jobblePool, event, questions, ids) {
	      var _this = this;
	      console.log("markJobAsPublished");
	      console.dir(jobblePool);
	      console.dir(event);
	      var id = null;
	      if (jobblePool.eventId) {
	        id = jobblePool.eventId;
	      } else {
	        id = jobblePool.data.id;
	      }
	      var eventData = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + id + "?format=json&conf=web&fields=id,isPublished",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          surveyQuestions: questions,
	          isCancelled: false,
	          isCompleted: false
	        }
	      };
	      return _this.$http(eventData);
	    }
	  }, {
	    key: "markJobblesAsPublished",
	    value: function markJobblesAsPublished(jobblePool, event, status) {
	      var id = null;
	
	      var _this = this;
	
	      if (jobblePool.jobbles) {
	        id = jobblePool.jobbles[0].id;
	      } else if (jobblePool.data) {
	        id = jobblePool.data.subEvents[0].deduppedJobbles[0].id;
	      } else {
	        id = jobblePool;
	      }
	      console.log("markJobblesAsPublished");
	      console.dir(status);
	      console.dir(angular.isUndefined(status));
	
	      if (status === true) {
	        console.log("do nothing");
	      } else if (angular.isUndefined(status) || status === null) {
	        console.log("are we undefined?");
	        console.dir(status);
	        status = true;
	      } else {
	        status = false;
	      }
	
	      console.log("what is the status");
	      console.dir(status);
	
	      var jobblePoolData = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + id + "/bulk-update?format=json&fields=id,isPublished",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          jobble: {
	            isPublished: status
	          }
	        }
	      };
	
	      return _this.$http(jobblePoolData);
	    }
	  }, {
	    key: "publishEvent",
	    value: function publishEvent(jobble_id, status) {
	      var jobblePoolData = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobble_id + "/bulk-update?format=json&fields=id,isPublished&creationProcess=true",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          jobble: {
	            isPublished: status,
	            creationProcess: true
	          }
	        }
	      };
	
	      return this.$http(jobblePoolData);
	    }
	  }, {
	    key: "pushTeamsOntoEvent",
	    value: function pushTeamsOntoEvent(event, ids, isCreation, new_load) {
	      var _this = this;
	
	      if (new_load) {
	        var eventPostedToTeamsData = {
	          method: "POST",
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/circles/push-jobbles-to-circles?format=json&conf=web",
	          headers: {
	            "Content-Type": "application/json;charset=UTF-8",
	            Authorization: "Bearer " + _this.$auth.getAccessToken()
	          },
	          data: {
	            event: event,
	            circles: ids,
	            forCircleOnly: true
	          }
	        };
	      } else {
	        if (isCreation) {
	          var eventPostedToTeamsData = {
	            method: "POST",
	            url: _this.$env.getAPIEndPoint() + "jbl/v1/circles/push-jobbles-to-circles?format=json&conf=web",
	            headers: {
	              "Content-Type": "application/json;charset=UTF-8",
	              Authorization: "Bearer " + _this.$auth.getAccessToken()
	            },
	            data: {
	              event: event.eventId,
	              subEvent: event.subEventsId,
	              jobbles: [event.jobbles[0].id],
	              circles: ids,
	              forCircleOnly: true
	            }
	          };
	        } else {
	          var eventPostedToTeamsData = {
	            method: "POST",
	            url: _this.$env.getAPIEndPoint() + "jbl/v1/circles/push-jobbles-to-circles?format=json&conf=web",
	            headers: {
	              "Content-Type": "application/json;charset=UTF-8",
	              Authorization: "Bearer " + _this.$auth.getAccessToken()
	            },
	            data: {
	              event: event.id,
	              subEvent: event.subEvents[0].id,
	              jobbles: [event.subEvents[0].deduppedJobbles[0].id],
	              circles: ids,
	              forCircleOnly: true
	            }
	          };
	        }
	      }
	
	      return _this.$http(eventPostedToTeamsData);
	    }
	  }, {
	    key: "saveQuestionsDuringCreation",
	    value: function saveQuestionsDuringCreation(questions) {
	      var _this = this;
	    }
	  }, {
	    key: "getShiftRoster",
	    value: function getShiftRoster(shiftId) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + shiftId + "?format=json&fields=contactInfo.lat,contactInfo.lng,contactInfo.state,contactInfo.streetLine1,contactInfo.city,contactInfo.zipCode,timeInterval.startTime,timeInterval.endTime,contactInfo.place.timeZoneId";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getShift",
	    value: function getShift(shiftId) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + shiftId + "?format=json&fields=contactInfo.state,contactInfo.streetLine1,contactInfo.city,contactInfo.zipCode,timeInterval.startTime,timeInterval.endTime";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getAcceptedApplicationsTrimmedRecordTimes",
	    value: function getAcceptedApplicationsTrimmedRecordTimes(subEventId) {
	      var maxCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
	      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + subEventId + "/applications?format=json&max=" + maxCount + "&status=1&fields=id,applicant.firstName,applicant.lastName,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,applicant.email,applicant.id,applicant.homeContactInfo.phoneMobile,jobble.shifts.id,jobble.shifts.checkInCoord,jobble.shifts.checkOutCoord,jobble.shifts.checkInTime,jobble.shifts.checkOutTime,jobble.shifts.noShow,jobble.shifts.timeInterval.startTime,jobble.shifts.timeInterval.endTime";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "updateShiftCheckInTime",
	    value: function updateShiftCheckInTime(date, application) {
	      var _this = this;
	
	      var data = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + application.currentShift.id + "/?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: { managerCheckInTime: date }
	      };
	
	      return _this.$http(data);
	    }
	  }, {
	    key: "updateShiftCheckOutTime",
	    value: function updateShiftCheckOutTime(date, application) {
	      var _this = this;
	      var data = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + application.currentShift.id + "/?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: { managerCheckOutTime: date }
	      };
	      return _this.$http(data);
	    }
	  }, {
	    key: "connect",
	    value: function connect(usersAndApplications) {
	      var card = this.$localStorage.logged_user.company.paymentInfos[0].cardToken;
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/companies/bulk-connect?format=json&amount=0&custUsername=" + this.$localStorage.logged_user.username + "&note=Connection",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {
	          usersAndApplications: usersAndApplications,
	          card: card
	        }
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "rateOrReview",
	    value: function rateOrReview(ratingsArray) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/ratings/upsert?format=json&conf=web&fields=rate",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: { ratings: ratingsArray }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "reOpenEvent",
	    value: function reOpenEvent(id) {
	      var _this = this;
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/events/" + id + "?conf=web&format=json&fields=id";
	
	      var req = {
	        method: "PUT",
	        url: url,
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	
	        data: {
	          isClosed: false,
	          isCompleted: false
	        }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "updateQuestion",
	    value: function updateQuestion(data) {
	      var _this = this;
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/events/" + data.event_id + "?format=json&conf=web";
	      var req = {
	        method: "PUT",
	        url: url,
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        data: { surveyQuestions: data.questions }
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "updatePostType",
	    value: function updatePostType(data) {
	      var _this = this;
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/events/" + data.event_id + "?format=json&conf=web&fields=id,isSourcingPost";
	      var req = {
	        method: "PUT",
	        url: url,
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	
	        data: data
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "deleteSurveyQuestions",
	    value: function deleteSurveyQuestions(payload) {
	      var _this = this;
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/events/delete-questions?format=json";
	      var req = {
	        method: "POST",
	        url: url,
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        data: payload
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "editEventOpenings",
	    value: function editEventOpenings(jobble_id, delta) {
	      var addOpeningsData = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobble_id + "/" + (delta >= 0 ? "add" : "rm") + "-positions?format=json&fields=id&conf=web&creationProcess=true&sendSlackNotification=false&numberOfPositions=" + Math.abs(delta),
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(addOpeningsData);
	    }
	
	    /** creating orders **/
	
	  }, {
	    key: "create_jobble_pool",
	    value: function create_jobble_pool(order, jts) {
	      var _this = this;
	      var jobbleForDB = _this.create_jobble_for_db(order);
	      var data = {};
	      console.log("order right before posting");
	      console.dir(order.teams_for_order);
	      if (order.teams_for_order.length > 0) {
	        data.forCircleOnly = true;
	        data.circles = order.teams_for_order;
	        data.jobble = jobbleForDB;
	      } else {
	        data.jobble = jobbleForDB;
	      }
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/create-pool?format=json&verbosity=1&numberPosition=" + order.openings,
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: data
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "format_addresses",
	    value: function format_addresses(order) {
	      var _this = this;
	      var address_for_mobile = { pickup: null, dropoff: null };
	      address_for_mobile.pickup = order.pickup.contactInfo.streetLine1 + ", " + order.pickup.contactInfo.city + ", " + order.pickup.contactInfo.state;
	      address_for_mobile.dropoff = order.dropoff.contactInfo.streetLine1 + ", " + order.dropoff.contactInfo.city + ", " + order.dropoff.contactInfo.state;
	      return address_for_mobile;
	    }
	  }, {
	    key: "format_dates",
	    value: function format_dates(order) {
	      var _this = this;
	      var dates_formatted = {};
	      var ptz = null;
	      var dtz = null;
	      if (order.is_clone) {
	        ptz = order.pickup.contactInfo.place.timeZoneId;
	        dtz = order.dropoff.contactInfo.place.timeZoneId;
	      } else {
	        ptz = order.pickup.time_zone_id;
	        dtz = order.dropoff.time_zone_id;
	      }
	      dates_formatted.pickup = moment(order.pickup.timeInterval.startTime).format("ddd MMM DD HH:mm zz YYYY");
	      dates_formatted.dropoff = moment(order.dropoff.timeInterval.startTime).format("ddd MMM DD HH:mm zz YYYY");
	      var nowTherePickup = null;
	      var nowThereDropOff = null;
	      var timeInSecPickup = null;
	      var timeInSecDropoff = null;
	      var pickupOffset = null;
	      var dropoffOffset = null;
	      var day_light_savings = moment(order.pickup.timeInterval.startTime).isDST();
	
	      var zone = moment.tz.zone(moment.tz.guess());
	      var userTimeZoneName = moment.tz.guess();
	      var now = moment.tz(userTimeZoneName);
	      var user_offset = -zone.offsets[zone.offsets.length - 1];
	      nowTherePickup = moment.tz(order.pickup.time_zone);
	      nowThereDropOff = moment.tz(order.dropoff.time_zone);
	      timeInSecPickup = (parseInt(now.utcOffset(), 10) - parseInt(nowTherePickup.utcOffset())) * 60;
	      timeInSecDropoff = (parseInt(now.utcOffset(), 10) - parseInt(nowThereDropOff.utcOffset())) * 60;
	      pickupOffset = order.pickup.raw_offset / 60000;
	      dropoffOffset = order.dropoff.raw_offset / 60000;
	      dates_formatted.pickup_fixed = moment(order.pickup.timeInterval.startTime).add(user_offset - pickupOffset, "minutes").format("ddd MMM DD HH:mm zz YYYY");
	      dates_formatted.pickup_fixed_db = moment(order.pickup.timeInterval.startTime).add(user_offset - pickupOffset, "minutes").format();
	      dates_formatted.pickup_fixed_end_db = moment(order.pickup.timeInterval.endTime).add(user_offset - pickupOffset, "minutes").format();
	      dates_formatted.dropoff_fixed = moment(order.dropoff.timeInterval.startTime).add(user_offset - dropoffOffset, "minutes").format("ddd MMM DD HH:mm zz YYYY");
	      dates_formatted.dropoff_fixed_db = moment(order.dropoff.timeInterval.startTime).add(user_offset - dropoffOffset, "minutes").format();
	      dates_formatted.dropoff_fixed_end_db = moment(order.dropoff.timeInterval.endTime).add(user_offset - dropoffOffset, "minutes").format();
	      if (order.pickup.time_zone_id === "America/Phoenix" && day_light_savings === true) {
	        dates_formatted.pickup_fixed = moment(dates_formatted.pickup_fixed_db).add(1, "hours").tz(order.pickup.time_zone_id).format("ddd MMM DD HH:mm zz YYYY");
	        dates_formatted.pickup_fixed_db = moment(dates_formatted.pickup_fixed_db).add(1, "hours").format();
	        dates_formatted.pickup_fixed_end_db = moment(dates_formatted.pickup_fixed_end_db).add(1, "hours").format();
	        dates_formatted.dropoff_fixed = moment(dates_formatted.dropoff_fixed_db).add(1, "hours").tz(order.dropoff.time_zone_id).format("ddd MMM DD HH:mm zz YYYY");
	        dates_formatted.dropoff_fixed_db = moment(dates_formatted.dropoff_fixed_db).add(1, "hours").format();
	        dates_formatted.dropoff_fixed_end_db = moment(dates_formatted.dropoff_fixed_end_db).add(1, "hours").format();
	      }
	      var s = moment(dates_formatted.pickup_fixed_db);
	      var e = moment(dates_formatted.dropoff_fixed_db);
	      var ss = moment(order.pickup.timeInterval.startTime);
	      var ee = moment(order.dropoff.timeInterval.startTime);
	      var pst = s.diff(ss, "minutes");
	      var dst = e.diff(ee, "minutes");
	
	      if (pst > 0) {
	        dates_formatted.pickup_fixed = moment(dates_formatted.pickup_fixed).subtract(pst, "minutes").format("ddd MMM DD HH:mm zz YYYY");
	        dates_formatted.dropoff_fixed = moment(dates_formatted.dropoff_fixed).subtract(dst, "minutes").format("ddd MMM DD HH:mm zz YYYY");
	      } else {
	        dates_formatted.pickup_fixed = moment(dates_formatted.pickup_fixed).subtract(pst, "minutes").format("ddd MMM DD HH:mm zz YYYY");
	        dates_formatted.dropoff_fixed = moment(dates_formatted.dropoff_fixed).subtract(dst, "minutes").format("ddd MMM DD HH:mm zz YYYY");
	      }
	
	      return dates_formatted;
	    }
	  }, {
	    key: "push_to_teams",
	    value: function push_to_teams(jobble_pool, order) {
	      var _this = this;
	      var data = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/circles/push-jobbles-to-circles?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          event: jobble_pool.eventId,
	          subEvent: jobble_pool.subEventsId,
	          jobbles: [jobble_pool.jobbles[0].id],
	          circles: order.teams_for_order,
	          forCircleOnly: true
	        }
	      };
	
	      return _this.$http(data);
	    }
	  }, {
	    key: "create_jobble_for_db",
	    value: function create_jobble_for_db(order, jts) {
	      var _this = this;
	      var dates = _this.format_dates(order);
	      var addresses = _this.format_addresses(order);
	      var jt = null;
	      if (order.jobble_type_id_for_backend) {
	        jt = order.jobble_type_id_for_backend;
	      } else {
	        jt = 44;
	      }
	      var company_id = _this.$auth.getUserData().company.id;
	      var survey_questions = [{
	        question: "Why are you a good fit?",
	        questionType: 1,
	        editing: false,
	        name: "Question 1"
	      }];
	      if (!order.number) {
	        order.number = _this.generate_code();
	      }
	      order.pickup.timeInterval.startTime = dates.pickup_fixed_db;
	      order.pickup.timeInterval.endTime = dates.pickup_fixed_end_db;
	      order.dropoff.timeInterval.startTime = dates.dropoff_fixed_db;
	      order.dropoff.timeInterval.endTime = dates.dropoff_fixed_end_db;
	
	      var jobbleForDB = {
	        name: order.name,
	        payPerHour: order.payment_formatted,
	        description: order.description,
	        dressCode: "--",
	        jobbleType: jt,
	        isPublished: false,
	        pickupLocation: order.pickup.location,
	        dropoffLocation: order.dropoff.location,
	        pickupAddress: addresses.pickup,
	        dropoffAddress: addresses.dropoff,
	        pickupTime: dates.pickup_fixed,
	        dropoffTime: dates.dropoff_fixed,
	        pickupContactInfo: order.pickup.contact,
	        dropoffContactInfo: order.dropoff.contact,
	        //deliveryContactInfo: order.hiring_manager,
	        subEvent: {
	          name: order.name,
	          contactInfo: order.pickup.contactInfo,
	          event: {
	            name: order.name,
	            description: order.description,
	            eventType: 1,
	            company: company_id,
	            surveyQuestions: survey_questions,
	            orderNumber: order.number,
	            isOrder: true
	          }
	        },
	        shifts: [{
	          timeInterval: order.pickup.timeInterval,
	          contactInfo: order.pickup.contactInfo,
	          location: order.pickup.location,
	          description: order.pickup.instructions,
	          padding: order.pickup.padding,
	          deliveryContactInfo: order.pickup.contact
	        }, {
	          timeInterval: order.dropoff.timeInterval,
	          contactInfo: order.dropoff.contactInfo,
	          location: order.dropoff.location,
	          description: order.dropoff.instructions,
	          padding: order.dropoff.padding,
	          deliveryContactInfo: order.dropoff.contact
	        }]
	      };
	      return jobbleForDB;
	    }
	  }, {
	    key: "mark_order_as_published",
	    value: function mark_order_as_published(jobble_pool) {
	      var id = null;
	      if (jobble_pool.jobbles) {
	        id = jobble_pool.jobbles[0].id;
	      }
	      var _this = this;
	      var jobblePoolData = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + id + "/bulk-update?format=json&fields=id,isPublished",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          jobble: {
	            isPublished: true
	          }
	        }
	      };
	      return _this.$http(jobblePoolData);
	    }
	  }, {
	    key: "updateEventInfoForOrder",
	    value: function updateEventInfoForOrder(data) {
	      var _this = this;
	      var event_data = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + data.id + "?format=json&conf=web&fields=id",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          name: data.name,
	          description: data.description
	        }
	      };
	
	      return _this.$http(event_data);
	    }
	  }, {
	    key: "updateSubEventInfoForOrder",
	    value: function updateSubEventInfoForOrder(data) {
	      var _this = this;
	      var event_data = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + data.id + "?format=json&conf=web&fields=id",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          name: data.name,
	          description: data.description
	        }
	      };
	      return _this.$http(event_data);
	    }
	  }, {
	    key: "updateJobbleInfoForOrder",
	    value: function updateJobbleInfoForOrder(data) {
	      var _this = this;
	      var jobble_data = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + data.id + "/bulk-update?format=json&fields=id",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          jobble: {
	            description: data.description,
	            payPerHour: data.pay * 100,
	            pickupContactInfo: data.pickup_contact,
	            dropoffContactInfo: data.dropoff_contact
	          }
	        }
	      };
	
	      return _this.$http(jobble_data);
	    }
	  }, {
	    key: "generate_code",
	    value: function generate_code() {
	      var _this = this;
	      var code = "JBLO-" + _this.$localStorage.logged_user.company.id + "-" + moment().format("SSSS");
	      return code;
	    }
	  }, {
	    key: "getShiftsInSamePosition",
	    value: function getShiftsInSamePosition(shiftId) {
	      var _this = this;
	
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + shiftId + "/shiftInformationToPay?format=json";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "load_eta_data",
	    value: function load_eta_data(event, jobble) {
	      var _this = this;
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobble + "?format=json&fields=id,pickupLocation,dropoffLocation,pickupAddress,dropoffAddress,pickupTime,dropoffTime,deliveryContactInfo,pickupContactInfo,dropoffContactInfo,startTimeFormattedLoc,endTimeFormattedLoc,currentLocation,currentLocation.lat,currentLocation.lng,currentLocation.lastUpdateFront,shifts.id,shifts.pickupEta,shifts.dropoffEta,shifts.timeInterval.startTime,shifts.location,shifts.timeInterval.endTime,shifts.contactInfo.id,shifts.contactInfo.streetLine1,shifts.contactInfo.place.timeZoneId,shifts.contactInfo.city,shifts.contactInfo.state,shifts.contactInfo.zipCode,shifts.checkInTime,shifts.checkOutTime,shifts.contactInfo.place.timeZoneName";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        }
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "promote_event",
	    value: function promote_event(id) {
	      var _this = this;
	
	      var data = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/promote-pool",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          id: id
	        }
	      };
	
	      return _this.$http(data);
	    }
	  }, {
	    key: "updateActualMinutesWorkedForShift",
	    value: function updateActualMinutesWorkedForShift(id, minutes) {
	      var _this = this;
	
	      var req = {
	        method: "PUT",
	
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + id + "?format=json&conf=web&fields=id",
	
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	
	        data: {
	          actualMinutesWorked: minutes
	        }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "adjustTimeZone",
	    value: function adjustTimeZone(zipCode) {
	      var _this2 = this;
	
	      return new Promise(function (resolve) {
	        var mockShift = {
	          contactInfo: {
	            zipCode: zipCode
	          }
	        };
	
	        _this2.$security.getEventShiftTimezoneInfo(mockShift).then(function (response) {
	          console.log("getEventShiftTimezoneInfo");
	          console.dir(response);
	          var zone = moment.tz.zone(moment.tz.guess());
	          console.log("manager zone");
	          console.dir(zone);
	          var browserTimeZone = moment.tz.guess();
	          var eventMangerOffsets = -zone.offsets[zone.offsets.length - 1];
	          console.dir(eventMangerOffsets);
	          var eventOffsets = response.data[0].rawOffset / 60000;
	          var state = response.data[0].statePostalCode;
	          var timeZone = response.data[0].timeZoneId;
	
	          var timeZoneDifference = eventMangerOffsets - eventOffsets;
	
	          return resolve({ timeZone: timeZone, timeZoneDifference: timeZoneDifference, state: state, browserTimeZone: browserTimeZone });
	        });
	      });
	    }
	  }, {
	    key: "adjustTimeZones",
	    value: function adjustTimeZones(shift, timeZone, timeZoneDifference, state, remove) {
	
	      if (remove) {
	        timeZoneDifference = timeZoneDifference * -1;
	      }
	
	      var userTimeZoneName = moment.tz.guess();
	      var jobDST = moment().tz(timeZone).isDST();
	      var browserUserDST = moment().tz(userTimeZoneName).isDST();
	
	      timeZoneDifference = 0;
	
	      if (browserUserDST != jobDST && state != "AZ" && state != "HI") {
	        timeZoneDifference = timeZoneDifference + 60;
	      }
	
	      console.log("timeZoneDifference------------------");
	      console.dir(timeZoneDifference);
	
	      console.log("log before saving state date");
	      console.dir(shift);
	
	      shift.startDateAndTimeForDB = moment.tz(shift.startDate + " " + shift.startTime, "M/D/YYYY h:mm a", timeZone);
	      shift.endDateAndTimeForDB = moment.tz(shift.endDate + " " + shift.endTime, "M/D/YYYY h:mm a", timeZone);
	
	      //shift.startDateAndTimeForDB = moment(`${shift.startDate} ${shift.startTime}`).add(timeZoneDifference, "minutes").format();
	      //shift.endDateAndTimeForDB = moment(`${shift.endDate} ${shift.endTime}`).add(timeZoneDifference, "minutes").format();
	
	      var startTime = shift.startDateAndTimeForDB.format();
	      var endTime = shift.endDateAndTimeForDB.format();
	
	      //console.log("adjustTimeZones");
	      //console.dir(startTime);
	      //console.dir(endTime);
	
	      return {
	        startTime: startTime,
	        endTime: endTime
	      };
	    }
	  }, {
	    key: "markUserAsNowShowForShift",
	    value: function markUserAsNowShowForShift(id, value) {
	      var req = {
	        method: "PUT",
	
	        url: this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + id + "?format=json&conf=web&fields=id",
	
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	
	        data: {
	          noShow: value,
	          actualMinutesWorked: 0
	        }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "markUserAsNowShowForShiftNew",
	    value: function markUserAsNowShowForShiftNew(id, value) {
	      var data = {
	        noShow: value
	      };
	
	      if (value) {
	        data.actualMinutesWorked = 0;
	      }
	
	      var req = {
	        method: "PUT",
	
	        url: this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + id + "?format=json&conf=web&fields=id",
	
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	
	        data: data
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "payUsersByShift",
	    value: function payUsersByShift(data) {
	      var _this = this;
	
	      console.log("paying users");
	      console.dir(data);
	
	      var req = {
	        method: "POST",
	
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
	
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	
	        data: data
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "bulkUnpublish",
	    value: function bulkUnpublish(data) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-unpublish?format=json",
	
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	
	        data: { events: data }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "bulkPublish",
	    value: function bulkPublish(data) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-publish?format=json",
	
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	
	        data: { events: data }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "bulkCloseEvent",
	    value: function bulkCloseEvent(data) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/events/close-event?format=json",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: { events: data }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "bulkArchive",
	    value: function bulkArchive(data) {
	      var _this = this;
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-archive?format=json",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          events: data
	        }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "bulkRestore",
	    value: function bulkRestore(data) {
	      var _this = this;
	      console.log("bulkRestore data");
	      console.dir(data);
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-restore?format=json",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          events: data
	        }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "bulkReopen",
	    value: function bulkReopen(data) {
	      var _this = this;
	      console.log("bulkReopen data");
	      console.dir(data);
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/events/reopen-event?format=json",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {
	          events: data
	        }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getOpenings",
	    value: function getOpenings(eventId) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/events/" + eventId + "?format=json&fields=id,numberOfOpenings,openings";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getElasticSearchJobs",
	    value: function getElasticSearchJobs(data) {
	      console.log("getElasticSearchJobs");
	      console.dir(data);
	
	      var url = this.$env.getElasticSearchEventsAPIEndPoint() + "ondemand/jobs/";
	
	      if (!data) {
	        data = {};
	        data.offset = 10;
	        url = "?limit=10&offset=0";
	      } else {
	        url = url + "?";
	        url = url + "limit=" + data.limit + "&offset=" + data.offset;
	
	        if (data.isPublished) {
	          url = url + "&isPublished=" + data.isPublished;
	        }
	
	        if (data.isCancelled) {
	          url = url + "&isCancelled=" + data.isCancelled;
	        }
	
	        if (data.isDraft) {
	          url = url + "&isDraft=" + data.isDraft;
	        }
	
	        if (data.isComplited) {
	          url = url + "&isCompleted=" + data.isComplited;
	        }
	
	        if (data.isCompleted) {
	          url = url + "&isComplited=" + data.isCompleted;
	        }
	
	        if (data.search) {
	          url = url + "&search=" + data.search;
	        }
	
	        if (data.name) {
	          url = url + "&name=" + data.name;
	        }
	
	        if (data.eventId) {
	          url = url + "&eventId=" + data.eventId;
	        }
	
	        if (data.jobbleType) {
	          url = url + "&jobbleType=" + data.jobbleType;
	        }
	
	        if (data.direction) {
	          url = url + "&direction=" + data.direction;
	        }
	
	        if (data.sort) {
	          url = url + "&sort=" + data.sort;
	        }
	      }
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "dayLightSavingsCalculation",
	    value: function dayLightSavingsCalculation(dateCreated, shift, returnType, fromHTML) {
	      var result = void 0;
	      var isDSTstartTime = moment(shift.timeInterval.startTime).isDST();
	      var isDSTendTime = moment(shift.timeInterval.endTime).isDST();
	      var isDSTDateCreated = moment(dateCreated).isDST();
	      var isDSTNow = moment().isDST();
	      var timeZone = shift.contactInfo.place.timeZoneId;
	
	      if (returnType === "startTime") {
	        if (isDSTDateCreated && isDSTNow && !isDSTstartTime) {
	          shift.startTimeFormattedWithDSTAdjustment = moment(shift.startTimeFullFormat).add(1, "hours").tz(timeZone).format("h:mmA");
	          result = shift.startTimeFormattedWithDSTAdjustment;
	        } else {
	          result = shift.startTimeFormatted;
	        }
	      } else if (returnType === "endTime") {
	        if (isDSTDateCreated && isDSTNow && !isDSTendTime) {
	          shift.endTimeFormattedWithDSTAdjustment = moment(shift.endTimeFullFormat).add(1, "hours").tz(timeZone).format("h:mmA");
	          result = shift.endTimeFormattedWithDSTAdjustment;
	        } else {
	          result = shift.endTimeFormatted;
	        }
	      } else if (returnType === "startDate") {
	        result = shift.startDateFormatted;
	      }
	
	      return result;
	    }
	  }]);
	
	  return EventsService;
	}();
	
	exports.default = EventsService;
	
	
	EventsService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "env", "tracking", "$timeout"];

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(51);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventsidebar.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventsidebar.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".eventsidebar{color:red}", ""]);
	
	// exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _eventdropdownsidebar = __webpack_require__(53);
	
	var _eventdropdownsidebar2 = _interopRequireDefault(_eventdropdownsidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventdropdownsidebarModule = _angular2.default.module("eventdropdownsidebar", [_angularUiRouter2.default]).component("eventdropdownsidebar", _eventdropdownsidebar2.default);
	
	exports.default = eventdropdownsidebarModule;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventdropdownsidebar = __webpack_require__(54);
	
	var _eventdropdownsidebar2 = _interopRequireDefault(_eventdropdownsidebar);
	
	var _eventdropdownsidebar3 = __webpack_require__(55);
	
	var _eventdropdownsidebar4 = _interopRequireDefault(_eventdropdownsidebar3);
	
	__webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventdropdownsidebarComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _eventdropdownsidebar2.default,
	  controller: _eventdropdownsidebar4.default,
	  controllerAs: "vm"
	};
	
	exports.default = eventdropdownsidebarComponent;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports = "<a href=\"#\" class=\"btn dropdown-toggle pro-btn\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">Actions</a>\n<ul class=\"dropdown-menu\">\n  <li><a href=\"/event-overview\">Overview</a></li>\n  <li><a href=\"/event-review-applicants\">Review &amp; Hire Applicants</a></li>\n  <li><a ng-href=\"messages/event/{{vm.eventId}}\">Message</a></li>\n  <li><a href=\"#modal-add-openings\" data-toggle=\"modal\">Add Openings</a></li>\n  <li><a href=\"/event-edit-details\">View and Edit Details</a></li>\n  <li><a href=\"/event-live\">Live</a></li>\n  <li><a href=\"/event-complete\">Complete Event</a></li>\n  <li><a href=\"#modal-del-event\" data-toggle=\"modal\">Cancel Event</a></li>\n</ul>\n"

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventdropdownsidebarController = function EventdropdownsidebarController() {
	  _classCallCheck(this, EventdropdownsidebarController);
	
	  this.name = "eventdropdownsidebar";
	};
	
	exports.default = EventdropdownsidebarController;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(57);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventdropdownsidebar.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventdropdownsidebar.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".eventdropdownsidebar{color:red}", ""]);
	
	// exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _adminsidebar = __webpack_require__(59);
	
	var _adminsidebar2 = _interopRequireDefault(_adminsidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminsidebarModule = _angular2.default.module("adminsidebar", [_angularUiRouter2.default]).component("adminsidebar", _adminsidebar2.default);
	
	exports.default = adminsidebarModule;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _adminsidebar = __webpack_require__(60);
	
	var _adminsidebar2 = _interopRequireDefault(_adminsidebar);
	
	var _adminsidebar3 = __webpack_require__(61);
	
	var _adminsidebar4 = _interopRequireDefault(_adminsidebar3);
	
	__webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminsidebarComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _adminsidebar2.default,
	  controller: _adminsidebar4.default,
	  controllerAs: "vm"
	};
	
	exports.default = adminsidebarComponent;

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	module.exports = "<nav class=\"sidebar-nav\">\n  <ul>\n    <li>\n      <a href=\"/admin-dash\"> <img src=\"/app/vendor/images/board-icon.png\" alt=\"\" /> Board</a>\n    </li>\n    <li>\n      <a href=\"/admin-transactions\">\n        <img src=\"/app/vendor/images/transactions-icon.png\" alt=\"\" />\n        Transactions</a\n      >\n    </li>\n    <li>\n      <a href=\"/admin-events\">\n        <img src=\"/app/vendor/images/events-icon.png\" alt=\"\" />\n        Events</a\n      >\n    </li>\n    <li>\n      <a href=\"/admin-applicants\">\n        <img src=\"/app/vendor/images/applicants-icon.png\" alt=\"\" />\n        Applicants</a\n      >\n    </li>\n    <li>\n      <a href=\"/admin-openings\">\n        <img src=\"/app/vendor/images/openings-icon.png\" alt=\"\" />\n        Openings</a\n      >\n    </li>\n    <li>\n      <a href=\"/admin-hires\"> <img src=\"/app/vendor/images/hires-icon.png\" alt=\"\" /> Hires</a>\n    </li>\n    <li>\n      <a href=\"/admin-withdrawals\">\n        <img src=\"/app/vendor/images/withdrawals-icon.png\" alt=\"\" />\n        Withdrawals</a\n      >\n    </li>\n  </ul>\n</nav>\n"

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminsidebarController = function AdminsidebarController() {
	  _classCallCheck(this, AdminsidebarController);
	
	  this.name = "adminsidebar";
	};
	
	exports.default = AdminsidebarController;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(63);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./adminsidebar.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./adminsidebar.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".adminsidebar{color:red}", ""]);
	
	// exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _eventtab = __webpack_require__(65);
	
	var _eventtab2 = _interopRequireDefault(_eventtab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventtabModule = _angular2.default.module("eventtab", [_angularUiRouter2.default]).component("eventtab", _eventtab2.default);
	
	exports.default = eventtabModule;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventtab = __webpack_require__(66);
	
	var _eventtab2 = _interopRequireDefault(_eventtab);
	
	var _eventtab3 = __webpack_require__(67);
	
	var _eventtab4 = _interopRequireDefault(_eventtab3);
	
	__webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventtabComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _eventtab2.default,
	  controller: _eventtab4.default,
	  controllerAs: "vm"
	};
	
	exports.default = eventtabComponent;

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"event-tab\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <div class=\"full-width\">\n          <div class=\"event-bar\">\n            <div class=\"event-left\" ng-click=\"vm.goto_post_event_detail()\"></div>\n            <div class=\"event-middle\" ng-click=\"vm.goto_post_job_detail1()\"></div>\n            <div class=\"event-right\" ng-click=\"vm.goto_post_job_review()\"></div>\n          </div>\n          <div class=\"clearfix\">\n            <div class=\"event-options pull-left\">\n              <a href=\"/post-event-detail\">EVENT DETAILS</a>\n            </div>\n            <div class=\"event-options pull-left\">\n              <a href=\"/post-job-detail1\">JOB DETAILS</a>\n            </div>\n            <div class=\"event-options pull-left\">\n              <a href=\"/post-job-review\">REVIEW AND POST</a>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n"

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventtabController = function () {
	  function EventtabController($http, $localStorage, $state) {
	    _classCallCheck(this, EventtabController);
	
	    this.name = "eventtab";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	  }
	
	  _createClass(EventtabController, [{
	    key: "goto_post_event_detail",
	    value: function goto_post_event_detail() {
	      this.$state.go("posteventdetail");
	    }
	  }, {
	    key: "goto_post_job_detail1",
	    value: function goto_post_job_detail1() {
	      this.$state.go("postjobdetail1");
	    }
	  }, {
	    key: "goto_post_job_review",
	    value: function goto_post_job_review() {
	      this.$state.go("postjobreview");
	    }
	  }]);
	
	  return EventtabController;
	}();
	
	EventtabController.$inject = ["$http", "$localStorage", "$state"];
	
	exports.default = EventtabController;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(69);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventtab.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventtab.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".eventtab{color:red}", ""]);
	
	// exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _loader = __webpack_require__(71);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loaderModule = _angular2.default.module("loader", [_angularUiRouter2.default]).component("loader", _loader2.default);
	
	exports.default = loaderModule;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loader = __webpack_require__(72);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _loader3 = __webpack_require__(73);
	
	var _loader4 = _interopRequireDefault(_loader3);
	
	__webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loaderComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _loader2.default,
	  controller: _loader4.default,
	  controllerAs: "vm"
	};
	
	exports.default = loaderComponent;

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"loadingdiv\" ng-if=\"!vm.$rootScope.loadingWalkThrough.status\">\n  <div class=\"loader-container-redesign\">\n    <div class=\"row\">\n      <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n        <div class=\"top-loader\">\n          <img src=\"/app/vendor/images/spinner-loading.gif\" />\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n        <div class=\"middle-loader\" ng-show=\"vm.params.type==15\">\n          <p>Welcome Jobble: connecting you with flexible work…</p>\n        </div>\n        <div class=\"middle-loader\" ng-hide=\"vm.params.type==15\">\n          <p>Loading...</p>\n          <ul>\n            <li ng-repeat=\"step in vm.steps track by $index\">Step {{$index + 1}} of {{ vm.total }} : {{step}}</li>\n          </ul>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoaderController = function () {
	  function LoaderController($rootScope, $scope) {
	    _classCallCheck(this, LoaderController);
	
	    this.name = "loader";
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.steps = [];
	    this.loadingJobs = "Loading jobs...";
	    this.applyingAttributes = "Applying attributes...";
	    this.loadingJobDetails = "Loading job details...";
	    this.loadingApplicants = "Loading applicants...";
	    this.loadingPendingApplicants = "Loading pending applicants...";
	    this.loadingAcceptedApplicants = "Loading accepted applicants...";
	    this.loadingRoster = "Loading roster...";
	    this.liveLoader = "Setting jobblers to map...";
	    this.liveLoaderJob = "Locating job on map...";
	    this.postJobLoader = "Posting job to board..";
	    this.jobsBoardEntryLoader = "Welcome to Jobble: connecting you with flexible work...";
	    this.savingShiftsLoader = "Saving shifts...";
	    this.cloningLoader = "Cloning job...";
	    this.jobbleTypesLoader = "Loading job types...";
	    this.adLoader = "Loading uber application...";
	
	    var _this = this;
	
	    _this.setLoaderDialogListener = _this.$rootScope.$on("SetLoaderDialog", function (event, params) {
	      _this.handleLoader(params);
	      _this.params = params;
	      if (params.type === 0) {
	        _this.steps = [];
	      }
	    });
	
	    _this.$scope.$on("$destroy", _this.setLoaderDialogListener);
	  }
	
	  _createClass(LoaderController, [{
	    key: "handleLoader",
	    value: function handleLoader(status) {
	      var _this = this;
	      _this.total = status.total;
	      switch (status.type) {
	        case 0:
	        //_this.steps = [];
	        case 1:
	          _this.steps.push(_this.loadingJobs);
	          break;
	        case 2:
	          _this.steps.push(_this.applyingAttributes);
	          break;
	        case 3:
	          _this.steps.push(_this.loadingJobDetails);
	          break;
	        case 4:
	          _this.steps.push(_this.loadingApplicants);
	          break;
	        case 5:
	          _this.steps.push(_this.loadingAcceptedApplicants);
	          break;
	        case 6:
	          _this.steps.push(_this.loadingPendingApplicants);
	          break;
	        case 7:
	          _this.steps.push(_this.loadingRoster);
	          break;
	        case 8:
	          _this.steps.push(_this.liveLoader);
	          break;
	        case 9:
	          _this.steps.push(_this.liveLoaderJob);
	          break;
	        case 10:
	          _this.steps.push(_this.postJobLoader);
	          break;
	        case 11:
	          _this.steps.push(_this.savingShiftsLoader);
	          break;
	        case 12:
	          _this.steps.push(_this.cloningLoader);
	          break;
	        case 13:
	          _this.steps.push(_this.jobbleTypesLoader);
	          break;
	        case 14:
	          _this.steps.push(_this.adLoader);
	          break;
	        case 15:
	          console.log("we are in case 15");
	          _this.steps.push(_this.jobsBoardEntryLoader);
	          break;
	      }
	    }
	  }]);
	
	  return LoaderController;
	}();
	
	LoaderController.$inject = ["$rootScope", "$scope"];
	exports.default = LoaderController;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(75);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./loader.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./loader.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".loader{color:red}", ""]);
	
	// exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _jobsdropdown = __webpack_require__(77);
	
	var _jobsdropdown2 = _interopRequireDefault(_jobsdropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobsdropdownModule = _angular2.default.module("jobsdropdown", [_angularUiRouter2.default]).component("jobsdropdown", _jobsdropdown2.default);
	
	exports.default = jobsdropdownModule;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobsdropdown = __webpack_require__(78);
	
	var _jobsdropdown2 = _interopRequireDefault(_jobsdropdown);
	
	var _jobsdropdown3 = __webpack_require__(79);
	
	var _jobsdropdown4 = _interopRequireDefault(_jobsdropdown3);
	
	__webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobsdropdownComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _jobsdropdown2.default,
	  controller: _jobsdropdown4.default,
	  controllerAs: "vm"
	};
	
	exports.default = jobsdropdownComponent;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"hidden-drop-down\" id=\"small-list-links\">\n  <ul>\n    <li ng-click=\"vm.goToJobs()\" class=\"nowrap\">\n      <!--href=\"/events\"-->\n      <a href=\"\">Jobs</a>\n    </li>\n    <li ng-repeat=\"event in vm.events\" class=\"nowrap\" ng-click=\"vm.goToJobOverview(event)\">\n      <a> {{event.name}} </a>\n    </li>\n  </ul>\n  <!-- href=\"/event/{{event.id}}/overview\" -->\n</div>\n"

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobsdropdownController = function () {
	  function JobsdropdownController($rootScope, $scope, $state, $localStorage, $location) {
	    _classCallCheck(this, JobsdropdownController);
	
	    this.name = "jobsdropdown";
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$location = $location;
	    this.$localStorage = $localStorage;
	    this.$scope = $scope;
	
	    var _this = this;
	
	    _this.SetEventsToJobsScrollListener = _this.$rootScope.$on("SetEventsToJobsScroll", function (event, params) {
	      if (!_this.events) {
	        _this.events = _this.$localStorage.events;
	      }
	    });
	
	    _this.ListEventsForScrollListener = _this.$rootScope.$on("ListEventsForScroll", function (event, params) {
	      _this.events = _this.$localStorage.events;
	    });
	
	    _this.SetHoverDataListener = _this.$rootScope.$on("SetHoverData", function (event, params) {});
	
	    _this.$scope.$on("$destroy", _this.SetHoverDataListener);
	    _this.$scope.$on("$destroy", _this.SetEventsToJobsScrollListener);
	    _this.$scope.$on("$destroy", _this.ListEventsForScrollListener);
	
	    _this.setEventsInDropDown();
	  }
	
	  _createClass(JobsdropdownController, [{
	    key: "goToJobs",
	    value: function goToJobs() {
	      var _this = this;
	      _this.$state.go("jobsdashboard");
	    }
	  }, {
	    key: "goToJobOverview",
	    value: function goToJobOverview(event) {
	      var _this = this;
	      console.log("go to job lets look at start time...");
	      console.dir(event);
	      if (event.status === "Payment Pending") {
	        _this.$location.path("/event/" + event.id + "/complete");
	      } else if (event.status === "Published") {
	        _this.$location.path("/event/" + event.id + "/review");
	      } else {
	        _this.$location.path("/event/" + event.id + "/overview");
	      }
	      //_this.$location.path( "/event/" + event.id + "/overview");
	    }
	  }, {
	    key: "showJobScroll",
	    value: function showJobScroll() {
	      var _this = this;
	      if (_this.showJobsDropDown === false) {
	        _this.$timeout(function () {
	          _this.events = _this.$localStorage.events;
	          _this.showJobsDropDown = true;
	          $(".hidden-drop-down").show("fast");
	        }, 300);
	      } else {
	        _this.$timeout(function () {
	          _this.showJobsDropDown = false;
	          $(".hidden-drop-down").hide("fast");
	        }, 300);
	      }
	    }
	  }, {
	    key: "setEventsInDropDown",
	    value: function setEventsInDropDown() {
	      var _this = this;
	    }
	  }]);
	
	  return JobsdropdownController;
	}();
	
	JobsdropdownController.$inject = ["$rootScope", "$scope", "$state", "$localStorage", "$location"];
	
	exports.default = JobsdropdownController;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(81);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./jobsdropdown.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./jobsdropdown.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pbjobsdropdown = __webpack_require__(83);
	
	var _pbjobsdropdown2 = _interopRequireDefault(_pbjobsdropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobsdropdownModule = _angular2.default.module("pbjobsdropdown", [_angularUiRouter2.default]).component("pbjobsdropdown", _pbjobsdropdown2.default);
	
	exports.default = jobsdropdownModule;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pbjobsdropdown = __webpack_require__(84);
	
	var _pbjobsdropdown2 = _interopRequireDefault(_pbjobsdropdown);
	
	var _pbjobsdropdown3 = __webpack_require__(85);
	
	var _pbjobsdropdown4 = _interopRequireDefault(_pbjobsdropdown3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pbjobsdropdownComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _pbjobsdropdown2.default,
	  controller: _pbjobsdropdown4.default,
	  controllerAs: "vm"
	};
	
	exports.default = pbjobsdropdownComponent;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"hidden-drop-down\" id=\"small-list-links\">\n  <ul>\n    <li ng-click=\"vm.goToJobs()\" class=\"nowrap\">\n      <a href=\"\">Jobs</a>\n    </li>\n    <li ng-repeat=\"event in vm.events\" class=\"nowrap\" ng-click=\"vm.goToJobOverview(event)\">\n      <a> {{event.name}} </a>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PbjobsdropdownController = function () {
	  function PbjobsdropdownController($rootScope, $scope, $state, $localStorage, $location) {
	    _classCallCheck(this, PbjobsdropdownController);
	
	    this.name = "pbjobsdropdown";
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$location = $location;
	    this.$localStorage = $localStorage;
	    this.$scope = $scope;
	
	    var _this = this;
	
	    _this.SetEventsToJobsScrollListener = _this.$rootScope.$on("SetEventsToJobsScroll", function (event, params) {
	      if (!_this.events) {
	        _this.events = _this.$localStorage.events;
	      }
	    });
	
	    _this.ListEventsForScrollListener = _this.$rootScope.$on("ListEventsForScroll", function (event, params) {
	      _this.events = _this.$localStorage.events;
	    });
	
	    _this.SetHoverDataListener = _this.$rootScope.$on("SetHoverData", function (event, params) {});
	
	    _this.$scope.$on("$destroy", _this.SetEventsToJobsScrollListener);
	    _this.$scope.$on("$destroy", _this.ListEventsForScrollListener);
	    _this.setEventsInDropDown();
	  }
	
	  _createClass(PbjobsdropdownController, [{
	    key: "goToJobs",
	    value: function goToJobs() {
	      var _this = this;
	      _this.$state.go("jobsdashboard");
	    }
	  }, {
	    key: "goToJobOverview",
	    value: function goToJobOverview(event) {
	      var _this = this;
	      _this.$location.path("/event/" + event.id + "/review");
	    }
	  }, {
	    key: "showJobScroll",
	    value: function showJobScroll() {
	      var _this = this;
	      if (_this.showJobsDropDown === false) {
	        _this.$timeout(function () {
	          _this.events = _this.$localStorage.events;
	          _this.showJobsDropDown = true;
	          $(".hidden-drop-down").show("fast");
	        }, 300);
	      } else {
	        _this.$timeout(function () {
	          _this.showJobsDropDown = false;
	          $(".hidden-drop-down").hide("fast");
	        }, 300);
	      }
	    }
	  }, {
	    key: "setEventsInDropDown",
	    value: function setEventsInDropDown() {
	      var _this = this;
	    }
	  }]);
	
	  return PbjobsdropdownController;
	}();
	
	PbjobsdropdownController.$inject = ["$rootScope", "$scope", "$state", "$localStorage", "$location"];
	
	exports.default = PbjobsdropdownController;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pjjobsdropdown = __webpack_require__(87);
	
	var _pjjobsdropdown2 = _interopRequireDefault(_pjjobsdropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobsdropdownModule = _angular2.default.module("pjjobsdropdown", [_angularUiRouter2.default]).component("pjjobsdropdown", _pjjobsdropdown2.default);
	
	exports.default = jobsdropdownModule;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pjjobsdropdown = __webpack_require__(88);
	
	var _pjjobsdropdown2 = _interopRequireDefault(_pjjobsdropdown);
	
	var _pjjobsdropdown3 = __webpack_require__(89);
	
	var _pjjobsdropdown4 = _interopRequireDefault(_pjjobsdropdown3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pjjobsdropdownComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _pjjobsdropdown2.default,
	  controller: _pjjobsdropdown4.default,
	  controllerAs: "vm"
	};
	
	exports.default = pjjobsdropdownComponent;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"hidden-drop-down\" id=\"small-list-links\">\n  <ul>\n    <li ng-click=\"vm.goToJobs()\" class=\"nowrap\">\n      <!--href=\"/events\"-->\n      <a href=\"\">Jobs</a>\n    </li>\n    <li ng-repeat=\"event in vm.events\" class=\"nowrap\" ng-click=\"vm.goToJobOverview(event)\">\n      <a> {{event.name}} </a>\n    </li>\n  </ul>\n  <!-- href=\"/event/{{event.id}}/overview\" -->\n</div>\n"

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PjjobsdropdownController = function () {
	  function PjjobsdropdownController($rootScope, $scope, $state, $localStorage, $location) {
	    _classCallCheck(this, PjjobsdropdownController);
	
	    this.name = "pjjobsdropdown";
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$location = $location;
	    this.$localStorage = $localStorage;
	    this.$scope = $scope;
	
	    var _this = this;
	
	    _this.SetEventsToJobsScrollListener = _this.$rootScope.$on("SetEventsToJobsScroll", function (event, params) {
	      if (!_this.events) {
	        _this.events = _this.$localStorage.events;
	      }
	    });
	
	    _this.ListEventsForScrollListener = _this.$rootScope.$on("ListEventsForScroll", function (event, params) {
	      _this.events = _this.$localStorage.events;
	    });
	
	    _this.SetHoverDataListener = _this.$rootScope.$on("SetHoverData", function (event, params) {});
	
	    _this.$scope.$on("$destroy", _this.SetEventsToJobsScrollListener);
	    _this.$scope.$on("$destroy", _this.ListEventsForScrollListener);
	
	    _this.setEventsInDropDown();
	  }
	
	  _createClass(PjjobsdropdownController, [{
	    key: "goToJobs",
	    value: function goToJobs() {
	      var _this = this;
	      _this.$state.go("jobsdashboard");
	    }
	  }, {
	    key: "goToJobOverview",
	    value: function goToJobOverview(event) {
	      var _this = this;
	      _this.$location.path("/event/" + event.id + "/overview");
	    }
	  }, {
	    key: "showJobScroll",
	    value: function showJobScroll() {
	      var _this = this;
	      if (_this.showJobsDropDown === false) {
	        _this.$timeout(function () {
	          _this.events = _this.$localStorage.events;
	          _this.showJobsDropDown = true;
	          $(".hidden-drop-down").show("fast");
	        }, 300);
	      } else {
	        _this.$timeout(function () {
	          _this.showJobsDropDown = false;
	          $(".hidden-drop-down").hide("fast");
	        }, 300);
	      }
	    }
	  }, {
	    key: "setEventsInDropDown",
	    value: function setEventsInDropDown() {
	      var _this = this;
	    }
	  }]);
	
	  return PjjobsdropdownController;
	}();
	
	PjjobsdropdownController.$inject = ["$rootScope", "$scope", "$state", "$localStorage", "$location"];
	
	exports.default = PjjobsdropdownController;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _track = __webpack_require__(91);
	
	var _track2 = _interopRequireDefault(_track);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trackModule = _angular2.default.module("track", [_angularUiRouter2.default]).component("track", _track2.default);
	
	exports.default = trackModule;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _track = __webpack_require__(92);
	
	var _track2 = _interopRequireDefault(_track);
	
	var _track3 = __webpack_require__(93);
	
	var _track4 = _interopRequireDefault(_track3);
	
	__webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trackComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _track2.default,
	  controller: _track4.default,
	  controllerAs: "vm"
	};
	
	exports.default = trackComponent;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	module.exports = "<div loadtrack></div>\n<div loadscript></div>\n"

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TrackController = function TrackController($rootScope, AuthService, TrackingService, $timeout) {
	  _classCallCheck(this, TrackController);
	
	  this.name = "track";
	  this.$rootScope = $rootScope;
	  this.$auth = AuthService;
	  this.$tracking = TrackingService;
	  this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
	  this.$timeout = $timeout;
	  this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?key=" + this.googleMapKey + "&libraries=places&language=en";
	};
	
	TrackController.$inject = ["$rootScope", "auth", "tracking", "$timeout"];
	
	exports.default = TrackController;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(95);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./track.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./track.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".loader{color:red}", ""]);
	
	// exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _sorry = __webpack_require__(97);
	
	var _sorry2 = _interopRequireDefault(_sorry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sorryModule = _angular2.default.module("sorry", [_angularUiRouter2.default]).component("sorry", _sorry2.default);
	
	exports.default = sorryModule;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sorry = __webpack_require__(98);
	
	var _sorry2 = _interopRequireDefault(_sorry);
	
	var _sorry3 = __webpack_require__(99);
	
	var _sorry4 = _interopRequireDefault(_sorry3);
	
	__webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sorryComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _sorry2.default,
	  controller: _sorry4.default,
	  controllerAs: "vm"
	};
	
	exports.default = sorryComponent;

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	module.exports = "<h1>Sowwy</h1>\n"

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SorryController = function SorryController($rootScope, AuthService, $timeout) {
	  _classCallCheck(this, SorryController);
	
	  this.name = "sorry";
	  this.$rootScope = $rootScope;
	  this.$auth = AuthService;
	  this.$timeout = $timeout;
	};
	
	SorryController.$inject = ["$rootScope", "auth", "$timeout"];
	
	exports.default = SorryController;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(101);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _verification = __webpack_require__(103);
	
	var _verification2 = _interopRequireDefault(_verification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var verificationModule = _angular2.default.module("verification", [_angularUiRouter2.default]).component("verification", _verification2.default);
	
	exports.default = verificationModule;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _verification = __webpack_require__(104);
	
	var _verification2 = _interopRequireDefault(_verification);
	
	var _verification3 = __webpack_require__(105);
	
	var _verification4 = _interopRequireDefault(_verification3);
	
	__webpack_require__(106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var verificationComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _verification2.default,
	  controller: _verification4.default,
	  controllerAs: "vm"
	};
	
	exports.default = verificationComponent;

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal fade\" id=\"resume-upload-modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header popup-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\"></i>\n            </button>\n            <h3 class=\"modal-title\">Upload a Resume</h3>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                <p>Uploading a resume allows the hiring manager to get better understanding of your strengths.</p>\n                <p>For best results we recommend uploading a PDF file. A screen show of your resume will also work.</p>\n                <!--  ng-show=\"vm.isPdf && vm.resumeLink\" -->\n                <!--\n          \t\t\t<object data=\"{{vm.resumeLink}}\"></object>\n          \t\t\t-->\n                <a href=\"{{vm.resumeLink}}\" ng-hide=\"vm.isPdf && vm.resumeLink\" target=\"_blank\">\n                  <img src=\"/app/vendor/images/pdf.png\" alt=\"Download PDF\" />\n                </a>\n                <!--\n          \t\t\t<img src=\"{{vm.resumeLink}}\" style=\"width:100px;\" ng-hide=\"vm.isPdf && vm.resumeLink\"/>\n          \t\t\t-->\n                <a href=\"#\" ng-click=\"vm.selectResume()\" class=\"upload-resume-button\"> {{vm.resumeText}} </a>\n                <input class=\"resume-input\" type=\"file\" name=\"resume\" />\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer\" style=\"text-align: center\">\n            <a class=\"btn button btn-success\" data-dismiss=\"modal\">Close</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"more-application-info\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header popup-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\"></i>\n            </button>\n            <h3 class=\"modal-title\">Download our Mobile Application</h3>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                <p>\n                  Currently, we do not support applications on the web. We are working hard to get this feature on our web app. Please download our\n                  mobile app to access all of our features.\n                </p>\n              </div>\n              <div class=\"col-lg-6 col-md-12 col-sm-12\">\n                <a href=\"https://itunes.apple.com/us/app/jobble/id961838757?mt=8\" target=\"_blank\" rel=\"noopener\">\n                  <img src=\"/app/vendor/images/App_Store.png\" style=\"width: 200px\" />\n                </a>\n              </div>\n              <div class=\"col-lg-6 col-md-12 col-sm-12\">\n                <a href=\"https://play.google.com/store/apps/details?id=com.jobble.jobble&hl=en\" target=\"_blank\" rel=\"noopener\">\n                  <img src=\"/app/vendor/images/Google_Play.png\" style=\"width: 200px\" />\n                </a>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer\" style=\"text-align: center\">\n            <a class=\"btn button btn-success\" data-dismiss=\"modal\">OK</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"user-not-verified\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header popup-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\"></i>\n            </button>\n            <h3 class=\"modal-title\">Please Confirm Your Email Address</h3>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                <p>In order to apply to this job, you will first need to confirm your email by clicking on the link in the email we sent to:</p>\n                <p style=\"text-align: center; font-size: 17px\">\n                  <strong>{{vm.user.email}}</strong>\n                </p>\n                <p>Didn't get the confirmation email? Please check the spam folder.</p>\n                <p>\n                  If it's not there we can\n                  <a href=\"#\" ng-click=\"vm.resendEmail()\">send you another</a>.\n\n                  <!--  ng-show=\"vm.profile_updated_successfully\" -->\n                </p>\n\n                <div class=\"account-profile-success-save jobbler-profile-message\" style=\"margin-top: 15px\" ng-show=\"vm.success\">\n                  <span> The confirmation email is on the way! Please click on the link in the email to confirm your email address. </span>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer\" style=\"text-align: center\">\n            <a class=\"btn button btn-success\" ng-click=\"vm.checkVerificationStatus()\">OK</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"need-basic-information-data\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header popup-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\"></i>\n            </button>\n            <h3 class=\"modal-title\">Complete Basic Profile</h3>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12\" style=\"text-align: center\">\n                <p>\n                  Please\n                  <span class=\"important-info\">complete the Basic section</span>\n                  of your profile and\n                  <span class=\"important-info\">provide a picture of yourself in the Gallery</span>.\n                </p>\n                <p>Even better, complete 100% of your profile and you will greatly increase your chance of getting hired!</p>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer\" style=\"text-align: center\">\n            <a class=\"btn button btn-success\" href=\"#\" ng-click=\"vm.closeVerificationModal()\">Go To Basic Profile</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VerificationController = function () {
	  function VerificationController($scope, $state, $rootScope, AuthService, $timeout, ProfileService, $localStorage) {
	    _classCallCheck(this, VerificationController);
	
	    this.name = "verification";
	    this.$rootScope = $rootScope;
	    this.$profile = ProfileService;
	    this.$auth = AuthService;
	    this.$state = $state;
	    this.$localStorage = $localStorage;
	    this.$scope = $scope;
	    this.currentUser = this.$auth.getUserData();
	    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
	    this.$timeout = $timeout;
	    this.is_clickable = true;
	    var _this = this;
	
	    _this.SetResumeDataListener = _this.$rootScope.$on("SetResumeData", function ($event, params) {
	      _this.determineResumeType(params.user.resumeLink);
	    });
	
	    _this.SetDataForVerificationListener = _this.$rootScope.$on("SetDataForVerification", function ($event, params) {
	      console.log("SetDataForVerificationListener");
	      console.dir(params);
	      _this.currentUser = params.user;
	      _this.user = params.user;
	      _this.job = params.job;
	      _this.success = false;
	      _this.error = false;
	    });
	
	    _this.$scope.$on("$destroy", _this.SetDataForVerificationListener);
	    _this.$scope.$on("$destroy", _this.SetResumeDataListener);
	  }
	
	  _createClass(VerificationController, [{
	    key: "resendEmail",
	    value: function resendEmail() {
	      var _this = this;
	
	      console.log("resend email");
	      console.dir(_this.user);
	      console.dir(_this.currentUser);
	      var user = null;
	      if (_this.user) {
	        user = _this.user;
	      } else {
	        user = _this.currentUser;
	      }
	      _this.setLoader();
	      _this.$profile.resendEmail(user).then(function (response) {
	        console.log("response");
	        console.dir(response);
	        _this.unSetLoader();
	        _this.success = true;
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	        _this.error = true;
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "closeVerificationModal",
	    value: function closeVerificationModal() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("#need-basic-information-data").modal("toggle");
	      });
	
	      var job = _this.job;
	
	      _this.$timeout(function () {
	        _this.$state.go("jobbler", { job: job, check_user: true });
	      }, 300);
	    }
	  }, {
	    key: "checkVerificationStatus",
	    value: function checkVerificationStatus() {
	      var _this = this;
	      _this.setLoader();
	      _this.$profile.checkValidationStatus().then(function (response) {
	        _this.unSetLoader();
	        if (response.data.isVerified === false) {
	          _this.$timeout(function () {
	            $("#user-not-verified").modal("toggle");
	          });
	
	          //do something
	          /*
	          _this.$timeout(function(){
	          _this.$rootScope.$emit("UserHasConfirmedTheirEmail",{});
	          });
	          */
	        } else {
	          _this.currentUser.isVerified = true;
	          _this.$timeout(function () {
	            //$("#user-not-verified").modal("toggle");
	            _this.$rootScope.$emit("UserHasConfirmedTheirEmail", {});
	          });
	        }
	      }, function (error) {
	        _this.unSetLoader();
	        alert("There was an error verifying your account. Please try again.");
	      });
	    }
	  }, {
	    key: "selectResume",
	    value: function selectResume() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("#resume-upload-modal .resume-input").trigger("click");
	        $("#resume-upload-modal .resume-input").change(function (event) {
	          if (_this.is_clickable) {
	            _this.uploadResume(event);
	          }
	        });
	      });
	    }
	  }, {
	    key: "uploadResume",
	    value: function uploadResume() {
	      var _this = this;
	      _this.is_clickable = false;
	      _this.$timeout(function () {
	        var file = $("#resume-upload-modal .resume-input")[0].files[0];
	        var fd = new FormData();
	        fd.append("file", file);
	        _this.setLoader();
	        _this.$profile.uploadResume(fd).then(function (response) {
	          _this.is_clickable = true;
	          _this.determineResumeType(response.data.mainFile.url);
	          _this.unSetLoader();
	          _this.$localStorage.logged_user.resumeLink = response.data.mainFile.url;
	        }, function (error) {
	          _this.unSetLoader();
	          _this.is_clickable = true;
	          alert("There was an issue uploading your resume. Please try another file.");
	        });
	      });
	    }
	  }, {
	    key: "determineResumeType",
	    value: function determineResumeType(link) {
	      var _this = this;
	      if (link) {
	        _this.resumeText = "Change Resume";
	        if (link.indexOf(".pdf?") > -1) {
	          _this.isPdf = true;
	        } else {
	          _this.isPdf = false;
	        }
	        _this.resumeLink = link;
	      } else {
	        _this.resumeText = "Upload Resume";
	      }
	    }
	  }]);
	
	  return VerificationController;
	}();
	
	VerificationController.$inject = ["$scope", "$state", "$rootScope", "auth", "$timeout", "profile", "$localStorage"];
	
	exports.default = VerificationController;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(107);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./verification.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./verification.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _jobblerprofile = __webpack_require__(109);
	
	var _jobblerprofile2 = _interopRequireDefault(_jobblerprofile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobblerprofileModule = _angular2.default.module("jobblerprofile", [_angularUiRouter2.default]).component("jobblerprofile", _jobblerprofile2.default);
	
	exports.default = jobblerprofileModule;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobblerprofile = __webpack_require__(110);
	
	var _jobblerprofile2 = _interopRequireDefault(_jobblerprofile);
	
	var _jobblerprofile3 = __webpack_require__(111);
	
	var _jobblerprofile4 = _interopRequireDefault(_jobblerprofile3);
	
	__webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobblerprofileComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _jobblerprofile2.default,
	  controller: _jobblerprofile4.default,
	  controllerAs: "vm"
	};
	
	exports.default = jobblerprofileComponent;

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"modal fade jobble-modal\"\n  id=\"modal-view-jobble\"\n  tabindex=\"-1\"\n  role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\"\n  data-backdrop=\"static\"\n>\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div\n            style=\"\n              position: absolute;\n              left: 0;\n              top: 0;\n              height: 6px;\n              width: 100%;\n              margin-bottom: 16px;\n              border-radius: 6px 6px 0 0;\n              background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n            \"\n          ></div>\n          <div class=\"modal-header\">\n            <button\n              type=\"button\"\n              class=\"close popup-close\"\n              data-dismiss=\"modal\"\n              aria-label=\"Close\"\n              ng-click=\"vm.clearData()\"\n              style=\"margin-right: 10px; margin-top: 4px\"\n            >\n              <i class=\"fas fa-times\" aria-hidden=\"true\"></i>\n            </button>\n            <h4>\n              <img  ng-if=\"vm.cachedData.bgCheckStatus == 'Passed'\" \n                    src=\"/app/vendor/images/gold-badge-2.png\" \n                    class=\"bg-check-status-image\"\n                    style=\"width: 23px;margin-top:6px;\"\n                    data-toggle=\"tooltip\"\n                    ng-attr-title=\"Background Check: Passed\"\n                    data-placement=\"bottom\"\n                  />\n              {{vm.cachedData.applicant.applicantFirstName}} {{vm.cachedData.applicant.applicantLastName}}\n            </h4>\n            <hr />\n          </div>\n          <div class=\"modal-body jobber-profile-info\" style=\"font-weight: 500\">\n            <div class=\"row\">\n              <div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\" style=\"padding-left: 0px; padding-right: 0px\">\n                <div class=\"profile-wrapper-left\">\n                  <img\n                    src=\"{{vm.jobblerData.fallBackPicture ? vm.jobblerData.fallBackPicture : '/app/vendor/images/user-more.png' }}\"\n                    id=\"jobbler-profile-picture-modal\"\n                    style=\"box-shadow: 1.7px 3.4px 3.4px hsl(0deg 0% 0% / 0.45)\"\n                    ng-show=\"vm.jobblerData\"\n                  />\n                </div>\n                <div>\n                  <p align=\"center\" ng-if=\"vm.moreThanOneTeam == true\">\n                    <a class=\"add-to-team-button\" ng-click=\"vm.triggerTeamModal(vm.cachedData)\">\n                      <i class=\"fas fa-plus-circle\"></i> Add user to team\n                    </a>\n                  </p>\n                </div>\n              </div>\n              <div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-7\" style=\"padding-left: 0px; padding-right: 14px\">\n                <div class=\"profile-wrapper-right\">\n                  <ul>\n                    <li>\n                      <i class=\"fas fa-envelope\"></i>\n                      {{vm.cachedData.applicantEmail}}\n                    </li>\n                    <li>\n                      <i class=\"fas fa-address-book\"></i>\n                      {{vm.cachedData.applicant.applicantHomeContactInfo.city}}, {{vm.cachedData.applicant.applicantHomeContactInfo.state}}\n                    </li>\n                    <li>\n                      <i class=\"fas fa-mobile-alt\"></i>\n                      {{vm.cachedData.applicant.applicantHomeContactInfo.phoneMobile}}\n                    </li>\n                    <li ng-if=\"vm.cachedData.numberOfCompletedJobbles > 0 && vm.cachedData.numberOfCompletedJobbles == 1\">\n                      <i class=\"fas fa-briefcase\"></i>\n                      {{vm.cachedData.numberOfCompletedJobbles}} job completed all time\n                    </li>\n                    <li ng-if=\"vm.cachedData.numberOfCompletedJobbles > 0 && vm.cachedData.numberOfCompletedJobbles > 1\">\n                      <i class=\"fas fa-briefcase\"></i>\n                      {{vm.cachedData.numberOfCompletedJobbles}} jobs completed all time\n                    </li>\n                  </ul>\n                </div>\n              </div>\n              <div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-7\" style=\"padding-left: 0px; padding-right: 14px\">\n                <div ng-if=\"vm.workHistory && vm.workHistory.length > 0\">\n                  <p class=\"jobbler-profile-history-list-header\">Recent Work History</p>\n                  <ul>\n                    <li class=\"jobbler-profile-history-list\" ng-repeat=\"history in vm.workHistory track by $index\">\n                      <!--\n                                            <i class=\"fas fa-chevron-circle-right\" style=\"color:#62c046;font-size:10px;\"></i>\n                                            -->\n                      {{history}}\n                    </li>\n                  </ul>\n                </div>\n              </div>\n            </div>\n            <div class=\"row\" style=\"padding-top: 15px\">\n              <div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\" style=\"padding-left: 5px; padding-right: 0px; text-align: center\"></div>\n              <div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-7\" style=\"padding-left: 0px; padding-right: 14px\"></div>\n            </div>\n          </div>\n          <!--\n                    <div class=\"modal-footer\" style=\"font-weight: 500\">\n                    </div>\n                    -->\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<script type=\"text/javascript\">\n  $(window).on(\"load\", function () {\n    // The slider being synced must be initialized first\n\n    $(\".thumb-slider\").flexslider({\n      animation: \"slide\",\n\n      controlNav: false,\n\n      animationLoop: false,\n\n      slideshow: false,\n\n      itemWidth: 250,\n\n      itemMargin: 4,\n\n      asNavFor: \".large-slider\",\n    });\n\n    $(\".large-slider\").flexslider({\n      animation: \"slide\",\n\n      controlNav: false,\n\n      directionNav: false,\n\n      animationLoop: false,\n\n      slideshow: false,\n\n      sync: \".thumb-slider\",\n    });\n  });\n\n  $(document).ready(function () {\n    $(\".carousel\").carousel({\n      interval: false,\n    });\n  });\n</script>\n\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n<messaginggallery ng-if=\"vm.showGalleryVar\"></messaginggallery>\n\n<div class=\"modal fade\" id=\"modal-confirm-jobbler\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"> </i>\n            </button>\n            <h3 class=\"modal-title\">Shift Confirmations</h3>\n            <p>Use the below table to view or edit this users shift confirmation data.</p>\n          </div>\n          <div class=\"modal-body popup-body text-center\">\n            <div class=\"confirmations-holder\">\n              <table class=\"table\">\n                <thead>\n                  <tr>\n                    <!--<th>ID</th>-->\n                    <th>Address</th>\n                    <th>Start Time</th>\n                    <th>Timestamp</th>\n                    <th>Source</th>\n                    <!--\n                                    <th>Response</th>\n                                    -->\n\n                    <th>Note</th>\n                    <th></th>\n                    <th></th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr\n                    ng-repeat=\"shift in vm.shifts_for_confirm track by $index\"\n                    ng-class=\"{'confirmed-shift' : shift.confirmationResponse ==  true, 'un-confirmed-shift' : shift.confirmationResponse ==  false}\"\n                  >\n                    <!--<td>{{shift.id}}</td>-->\n                    <td>\n                      {{$index + 1}}. {{shift.contactInfo.streetLine1}} {{shift.contactInfo.city}}, {{shift.contactInfo.state}}\n                      {{shift.contactInfo.zipCode}}\n                    </td>\n\n                    <td>{{shift.startTimeFormatted}}</td>\n                    <td>{{shift.confirmationDateTimeFormatted}}</td>\n                    <td>{{shift.confirmationSource}}</td>\n                    <!--\n                                    <td>{{shift.confirmationResponseDisplay}}</td>\n                                    -->\n                    <td>\n                      {{shift.confirmationNote ? shift.confirmationNote : '--' }}\n                      <a href=\"\" ng-click=\"vm.editConfirmation(shift,null,true)\" ng-if=\"shift.confirmationResponse == true\"> Edit </a>\n                    </td>\n\n                    <td ng-if=\"shift.confirmationResponse == null || shift.confirmationResponse == false\">\n                      <a href=\"\" ng-click=\"vm.confirmShift(shift)\"> Confirm </a>\n                    </td>\n\n                    <td ng-if=\"shift.confirmationResponse == true\">\n                      <span class=\"confirmed-checked\">\n                        Confirmed\n                        <i class=\"fa fa-check\"></i>\n                      </span>\n                    </td>\n\n                    <td>\n                      <a href=\"\" ng-click=\"vm.unConfirmShift(shift)\" ng-if=\"shift.confirmationResponse == true || shift.confirmationResponse == null\">\n                        Decline\n                      </a>\n                      <span ng-if=\"shift.confirmationResponse == false\" class=\"un-confirmed-checked\">\n                        Declined\n                        <i class=\"fa fa-check\"></i>\n                      </span>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"modal-confirm-jobbler-note\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"> </i>\n            </button>\n            <h3 class=\"modal-title\">Confirm User For Shift</h3>\n          </div>\n          <div class=\"modal-body popup-body text-center\">\n            <p>Leave A Note</p>\n\n            <form class=\"confirm-jobbler-form\" ng-submit=\"vm.sendConfirmationData()\">\n              <textarea ng-model=\"vm.confirmationNote\" maxlength=\"75\"></textarea>\n              <input type=\"submit\" value=\"Confirm\" class=\"button btn-success\" />\n            </form>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div\n  class=\"modal fade\"\n  id=\"modal-un-confirm-jobbler-note\"\n  tabindex=\"-1\"\n  role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\"\n  data-backdrop=\"static\"\n>\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"> </i>\n            </button>\n            <h3 class=\"modal-title\">Decline Confirmation</h3>\n          </div>\n          <div class=\"modal-body popup-body text-center\">\n            <p>Leave A Note</p>\n\n            <form class=\"confirm-jobbler-form\" ng-submit=\"vm.sendConfirmationData(2)\">\n              <textarea ng-model=\"vm.confirmationNote\" maxlength=\"75\"></textarea>\n              <input type=\"submit\" value=\"Decline\" class=\"button btn-success\" />\n            </form>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"modal-add-user-to-team\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n            </button>\n            <h3 class=\"modal-title\">Add User To Team</h3>\n          </div>\n          <div class=\"modal-body popup-body text-center\">\n            <p>Choose a team to add the user too.</p>\n            <form style=\"width: 100%\">\n              <div class=\"form-section clearfix\">\n                <div class=\"select-box\">\n                  <!--\n                                    <select\n                                        chosen\n                                        class=\"form-control form-input\"\n                                        style=\"width:100%;\"\n                                        placeholder-text=\"'Select Teams'\"\n                                        ng-model=\"vm.id_array_for_backend\"\n                                        ng-options=\"team.id as team.name for team in vm.teams\"\n                                        ng-change=\"vm.teamsChanged()\">\n                                        <option value=\"\"></option>\n                                    </select>\n                                    -->\n                </div>\n                <div class=\"select-box\">\n                  <select\n                    class=\"form-control form-input\"\n                    style=\"width: 100%\"\n                    ng-model=\"vm.placeholder\"\n                    ng-options=\"team.id as team.name for team in vm.options.values\"\n                    ng-change=\"vm.teamsChanged()\"\n                  ></select>\n                </div>\n              </div>\n\n              <p ng-if=\"vm.successAddingToTeam == true\" id=\"success-text-modal\">Added to Team</p>\n              <p ng-if=\"vm.successAddingToTeam == false\" id=\"danger-text-modal\">Failed to Add to Team</p>\n            </form>\n            <!--\n                        <a class=\"btn btn-danger\" ng-click=\"vm.confirmRemoveJobbler(vm.applicantStatus)\" style=\"margin-top:10px;\">Remove</a>\n                        -->\n          </div>\n          <div class=\"modal-footer text-center\" style=\"text-align: center\">\n            <!--<a class=\"btn btn-danger button\" style=\"margin-top:10px;\" data-dismiss=\"modal\">Cancel</a>-->\n\n            <a class=\"btn btn-success button\" style=\"margin-top: 10px\" ng-click=\"vm.addUserToTeam()\" ng-disabled=\"vm.disable_team_button\"\n              >Add To Team</a\n            >\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _common = __webpack_require__(112);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _profile = __webpack_require__(113);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobblerprofileController = function () {
	  function JobblerprofileController($http, $localStorage, $state, AuthService, EventsService, JobsService, $stateParams, SecurityService, ProfilesService, CommonService, $rootScope, $location, $timeout, $companies, Messagingv2Service, $scope) {
	    _classCallCheck(this, JobblerprofileController);
	
	    this.name = "jobblerprofile";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$companies = $companies;
	    this.$events = EventsService;
	    this.$stateParams = $stateParams;
	    this.$security = SecurityService;
	    this.$messagingv2 = Messagingv2Service;
	    this.$common = CommonService;
	    this.$rootScope = $rootScope;
	    this.$location = $location;
	    this.showGalleryVar = false;
	    this.sendingMessage = false;
	    this.$timeout = $timeout;
	    this.$profiles = ProfilesService;
	    this.pages = 0;
	    this.$scope = $scope;
	    this.$jobs = JobsService;
	    this.isTeamsPage = false;
	    this.divWidth = "width:750px;";
	    this.currentPageNumber = 1;
	    this.currentUser = this.$localStorage.logged_user;
	    this.remain_loading_count = 0;
	    this.teamsArr = "Select a team";
	
	    var _this = this;
	
	    _this.teams = _this.$rootScope.teams;
	
	    if (_this.currentUser.company) {
	      _this.paymentInfos = _this.currentUser.company.paymentInfos;
	    }
	
	    _this.CloseGalleryReviewListener = _this.$rootScope.$on("CloseGalleryReview", function ($event, params) {
	      _this.showGallery();
	    });
	
	    _this.GetJobblerDataFromServiceListener = _this.$rootScope.$on("GetJobblerDataFromService", function ($rootscope, params) {
	      _this.jobblerData = null;
	      if (_this.$location.$$path === "/teams") {
	        _this.isTeamsPage = true;
	      }
	      if (params.type === "hired" || params.jobblerData.modalType === "hired") {
	        _this.doNotShowHiredButton = true;
	      } else {
	        _this.doNotShowHiredButton = false;
	      }
	      if (params.application) {
	        _this.applicationForAccept = params.application;
	      }
	      _this.getJobblerData(params.jobblerData, params.messaging);
	      _this.event = params.event;
	      _this.sendingMessage = false;
	    });
	
	    _this.GetJobblerDataCachedListener = _this.$rootScope.$on("GetJobblerDataCached", function ($rootscope, params) {
	      _this.cachedData = null;
	      _this.jobblerData = null;
	      _this.cachedData = params.application;
	      console.log("_this.cachedData");
	      console.dir(_this.cachedData);
	      _this.setToggleMenu();
	      _this.getTeamsInfo();
	    });
	
	    _this.SetShiftToModalListener = _this.$rootScope.$on("SetShiftToModal", function ($rootScope, data) {
	      _this.jobblerData = data.applicant;
	
	      if (data.isEdit) {
	        _this.editConfirmation(data.currentShift, data.applicant.id);
	      } else {
	        _this.confirmShift(data.currentShift, data.applicant.id);
	      }
	    });
	
	    _this.ShowProfileListener = _this.$rootScope.$on("ShowProfile", function () {
	      _this.sendingMessage = false;
	    });
	
	    _this.CollectCardsForConnectListener = _this.$rootScope.$on("CollectCardsForConnect", function ($rootscope, event) {
	      _this.showCompleteMessage = undefined;
	      _this.showLoader = undefined;
	      _this.successfulPayment = undefined;
	      _this.successfulPaymentCheckMark = undefined;
	      _this.text = undefined;
	      _this.generateCardsArray();
	    });
	
	    _this.UpdatedCreditCardConnectionListener = _this.$rootScope.$on("UpdatedCreditCardConnection", function ($rootscope, event) {
	      _this.currentUser = _this.$auth.getUserData();
	      _this.paymentInfos = _this.currentUser.company.paymentInfos;
	      _this.generateCardsArray();
	      _this.displayConnectionScreen();
	    });
	
	    _this.SetShiftsToModalListener = _this.$rootScope.$on("SetShiftsToModal", function ($rootscope, data) {
	      _this.jobblerData = data.app.applicant;
	      _this.jobblerData.jobblerId = data.app.applicant.id;
	      _this.shifts_for_confirm = data.shifts;
	    });
	
	    _this.$scope.$on("$destroy", _this.SetShiftsToModalListener);
	    _this.$scope.$on("$destroy", _this.SetShiftToModalListener);
	    _this.$scope.$on("$destroy", _this.CloseGalleryReviewListener);
	    _this.$scope.$on("$destroy", _this.GetJobblerDataFromServiceListener);
	    _this.$scope.$on("$destroy", _this.ShowProfileListener);
	    _this.$scope.$on("$destroy", _this.CollectCardsForConnectListener);
	    _this.$scope.$on("$destroy", _this.UpdatedCreditCardConnectionListener);
	    _this.$scope.$on("$destroy", _this.GetJobblerDataCachedListener);
	
	    this.jobblerData = this.$common.getJobblerData();
	
	    _this.$scope.$on("$locationChangeStart", function (event, next, current) {
	      var answer = "";
	      if (next.indexOf("/review") > -1 && next.indexOf("id=") < 1) {
	        _this.closeModal();
	      } else if (next.indexOf("/overview") > -1 && next.indexOf("id=") < 1) {
	        _this.closeModal();
	      }
	    });
	  }
	
	  _createClass(JobblerprofileController, [{
	    key: "closeModal",
	    value: function closeModal() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("#modal-view-jobble .public-profile-content .close-out-button button.close").trigger("click");
	      });
	    }
	  }, {
	    key: "clearUser",
	    value: function clearUser() {
	      this.jobblerData = {};
	    }
	  }, {
	    key: "getJobblerData",
	    value: function getJobblerData(jd, toMsg) {
	      var _this = this;
	
	      console.log("getJobblerData");
	      console.dir(jd);
	
	      if (_this.isTeamsPage) {
	        _this.jobblerData = jd;
	        _this.$security.getUser(_this.jobblerData.jobblerId).then(function (response) {
	          console.log("get user response");
	          console.dir(response);
	        });
	      } else {
	        _this.$timeout(function () {
	          _this.jobblerData = jd;
	          _this.determineImageDimensions();
	          _this.fancyLoadProfile();
	          _this.getUserWorkHistory(jd.jobblerId);
	        });
	      }
	    }
	  }, {
	    key: "fancyLoadProfile",
	    value: function fancyLoadProfile() {
	      this.$timeout(function () {
	        $("#modal-view-jobble .modal-body.jobber-profile-info").slideDown(300);
	      }, 400);
	    }
	  }, {
	    key: "getUserWorkHistory",
	    value: function getUserWorkHistory(userId) {
	      var _this2 = this;
	
	      this.setLoader();
	      this.$security.getUserLatestWorkHistory(userId).then(function (response) {
	        if (response.data.success === "false") {
	          console.error("No work history permissions.");
	          _this2.unSetLoader();
	        } else {
	          _this2.formatWorkHistory(response.data);
	        }
	      }, function (error) {
	        alert("There was an error retrieving users work history. Please contact support.");
	        _this2.unSetLoader();
	      });
	    }
	  }, {
	    key: "setToggleMenu",
	    value: function setToggleMenu() {
	      this.$timeout(function () {
	        $(".bg-check-status-image").tooltip({});
	      }, 1000);
	    }
	  }, {
	    key: "formatWorkHistory",
	    value: function formatWorkHistory(histories) {
	      var workHistory = [];
	
	      histories.data.forEach(function (history) {
	        console.log("each history");
	        console.dir(history);
	        var shiftCount = void 0;
	        if (history.totalNumberOfPaidShifts >= 2) {
	          shiftCount = "s";
	        } else {
	          shiftCount = "";
	        }
	
	        var date = moment(history.latestPaidShiftDate).format("YYYY");
	        var entry = history.totalNumberOfPaidShifts + " " + history.latestJobbleType + " shift" + shiftCount + " for " + history.companyName + " in " + date;
	        workHistory.push(entry);
	      });
	
	      this.workHistory = workHistory;
	      this.unSetLoader();
	    }
	  }, {
	    key: "figurePagintion",
	    value: function figurePagintion(totalRatings) {
	      var _this = this;
	
	      var pageArray = [];
	      var numberOfRatings = Math.ceil(totalRatings / 5);
	
	      if (numberOfRatings > 0) {
	        for (var i = 0; i < numberOfRatings; i++) {
	          pageArray.push(i + 1);
	          _this.pages = pageArray;
	        }
	      } else {
	        _this.pages = [];
	      }
	    }
	  }, {
	    key: "showGallery",
	    value: function showGallery() {
	      var _this = this;
	
	      if (_this.jobblerData) {
	        if (_this.showGalleryVar) {
	          _this.showGalleryVar = false;
	          _this.$timeout(function () {
	            jQuery("#modal-view-jobble").modal();
	          }, 300);
	        } else {
	          _this.$timeout(function () {
	            jQuery("#modal-view-jobble").modal("toggle");
	          }, 200);
	          _this.$timeout(function () {
	            jQuery("#modal-view-jobble").modal();
	            _this.showGalleryVar = true;
	          }, 1000);
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("CollectPhotos", {
	              dataprof: _this.jobblerData.pics
	            });
	          }, 1400);
	        }
	      }
	    }
	  }, {
	    key: "next",
	    value: function next() {
	      for (var i = 0; i < this.jobblerData.pics.length; i++) {
	        if (this.jobblerData.pics[i] === this.jobblerData.currentPicture) {
	          if (i === this.jobblerData.pics.length - 1) {
	            this.jobblerData.currentPicture = this.jobblerData.pics[0];
	          } else {
	            this.jobblerData.currentPicture = this.jobblerData.pics[i + 1];
	          }
	          break;
	        }
	      }
	    }
	  }, {
	    key: "back",
	    value: function back() {
	      for (var i = 0; i < this.jobblerData.pics.length; i++) {
	        if (this.jobblerData.pics[i] === this.jobblerData.currentPicture) {
	          if (i === 0) {
	            this.jobblerData.currentPicture = this.jobblerData.pics[this.jobblerData.pics.length - 1];
	          } else {
	            this.jobblerData.currentPicture = this.jobblerData.pics[i - 1];
	          }
	          break;
	        }
	      }
	    }
	  }, {
	    key: "triggerConfirmationModal",
	    value: function triggerConfirmationModal(application) {
	      var _this = this;
	
	      _this.setLoader();
	
	      _this.getJobblesAndShifts(application);
	
	      _this.$timeout(function () {
	        $("#modal-view-jobble").modal("toggle");
	      });
	
	      _this.$timeout(function () {
	        $("#modal-confirm-jobbler").modal();
	      }, 300);
	
	      _this.$timeout(function () {
	        $("#modal-confirm-jobbler").modal();
	      }, 1000);
	    }
	  }, {
	    key: "getJobblesAndShifts",
	    value: function getJobblesAndShifts(app) {
	      var _this = this;
	
	      _this.$jobs.getJobbleWithShifts(app.jobbleId).then(function (response) {
	        _this.format_time_zones(response.data.shifts);
	
	        _this.unSetLoader();
	      }, function (error) {
	        console.log("in error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "format_time_zones",
	    value: function format_time_zones(shifts) {
	      var _this = this;
	
	      try {
	        shifts.forEach(function (shift) {
	          shift.startTimeFormatted = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("MM/DD/YYYY hh:mm A");
	          shift.endTimeFormatted = moment(shift.timeInterval.endTime).tz(shift.contactInfo.place.timeZoneId).format("MM/DD/YYYY hh:mm A");
	          if (shift.confirmationDateTime) {
	            shift.confirmationDateTimeFormatted = moment(shift.confirmationDateTime).tz(shift.contactInfo.place.timeZoneId).format("MM/DD/YYYY hh:mm A");
	          }
	          if (shift.confirmationResponse === true) {
	            shift.confirmationResponseDisplay = "Yes";
	          } else {
	            shift.confirmationResponseDisplay = "No";
	          }
	        });
	      } catch (err) {} finally {
	        shifts.sort(function (a, b) {
	          return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
	        });
	
	        _this.shifts_for_confirm = shifts;
	      }
	    }
	  }, {
	    key: "unConfirmShift",
	    value: function unConfirmShift(shift, id) {
	      var _this = this;
	
	      _this.confirmationNote = null;
	
	      if (id) {
	        shift.userId = id;
	      } else {
	        shift.userId = _this.jobblerData.jobblerId;
	      }
	
	      _this.shift_confirm = shift;
	
	      if (id) {
	        _this.$timeout(function () {
	          $("#modal-confirm-jobbler-note").modal();
	        });
	      } else {
	        _this.$timeout(function () {
	          $("#modal-confirm-jobbler").modal("toggle");
	        });
	        _this.$timeout(function () {
	          $("#modal-un-confirm-jobbler-note").modal();
	        }, 300);
	      }
	    }
	  }, {
	    key: "confirmShift",
	    value: function confirmShift(shift, id) {
	      var _this = this;
	
	      _this.confirmationNote = null;
	
	      if (id) {
	        shift.userId = id;
	      } else {
	        shift.userId = _this.jobblerData.jobblerId;
	      }
	
	      _this.shift_confirm = shift;
	
	      if (id) {
	        _this.$timeout(function () {
	          $("#modal-confirm-jobbler-note").modal();
	        });
	      } else {
	        _this.$timeout(function () {
	          $("#modal-confirm-jobbler").modal("toggle");
	        });
	        _this.$timeout(function () {
	          $("#modal-confirm-jobbler-note").modal();
	        }, 300);
	      }
	    }
	  }, {
	    key: "clearData",
	    value: function clearData() {
	      var _this3 = this;
	
	      this.$timeout(function () {
	        $("#modal-view-jobble .modal-body.jobber-profile-info").hide();
	        _this3.jobblerData = undefined;
	        _this3.cachedData = undefined;
	        _this3.workHistory = undefined;
	      }, 200);
	    }
	  }, {
	    key: "sendConfirmationData",
	    value: function sendConfirmationData(type) {
	      var _this = this;
	
	      var shift = _this.shift_confirm;
	      var user_to_update = _this.jobblerData;
	
	      shift.note = _this.confirmationNote;
	
	      console.log("what is the shift");
	      console.dir(shift);
	
	      if (!shift.jobbler) {
	        console.log("do we come here");
	        shift.userId = _this.jobblerData.jobblerId;
	      }
	
	      if (type === 2) {
	        _this.$jobs.updateShiftWithUnConfirmationData(shift).then(function (response) {
	          var timestamp = response.data.timestamp;
	
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("UpdateRosterPageWithConfirmationData", {
	              user_to_update: user_to_update,
	              shift: shift,
	              timestamp: timestamp,
	              type: type
	            });
	          });
	
	          _this.$timeout(function () {
	            $("#modal-un-confirm-jobbler-note").modal("toggle");
	            _this.unSetLoader();
	          }, 300);
	        }, function (error) {
	          alert("Error");
	          console.log("in error");
	          console.dir(error);
	        });
	      } else {
	        _this.$jobs.updateShiftWithConfirmationData(shift).then(function (response) {
	          console.log("response");
	          console.dir(response);
	          var timestamp = response.data.timestamp;
	
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("UpdateRosterPageWithConfirmationData", {
	              user_to_update: user_to_update,
	              shift: shift,
	              timestamp: timestamp
	            });
	          });
	
	          _this.$timeout(function () {
	            $("#modal-confirm-jobbler-note").modal("toggle");
	            _this.unSetLoader();
	          }, 300);
	        }, function (error) {
	          alert("Error");
	          console.log("in error");
	          console.dir(error);
	        });
	      }
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "triggerTeamModal",
	    value: function triggerTeamModal(user) {
	      var _this = this;
	
	      _this.successAddingToTeam = null;
	
	      _this.$timeout(function () {
	        $("#modal-view-jobble").modal("toggle");
	      });
	
	      _this.disable_team_button = true;
	      _this.placeholder = 0;
	
	      _this.options = {
	        values: []
	      };
	
	      _this.$companies.getTeamsUltraTrim().then(function (response) {
	        var teams = [];
	
	        var placeholder = { id: 0, name: "Select Team" };
	
	        teams.push(placeholder);
	        teams = teams.concat(response.data);
	
	        _this.options.values = teams;
	
	        _this.$timeout(function () {
	          $("#modal-add-user-to-team").modal();
	        }, 200);
	      }, function (error) {
	        console.log("in teams error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "getTeamsInfo",
	    value: function getTeamsInfo() {
	      var _this = this;
	
	      _this.moreThanOneTeam = false;
	
	      _this.$companies.getTeamsUltraTrim().then(function (response) {
	        console.log("response from teams count");
	        console.dir(response);
	        if (response.data.length > 0) {
	          _this.moreThanOneTeam = true;
	        }
	      }, function (error) {
	        console.log("in teams error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "setTeamsForModal",
	    value: function setTeamsForModal(teams) {
	      var _this = this;
	
	      console.log("set teams for modal");
	      console.dir(teams);
	      //_this.id_arry_for_backend.push()
	    }
	  }, {
	    key: "teamsChanged",
	    value: function teamsChanged() {
	      var _this = this;
	
	      console.log("teams changed");
	      console.dir(_this.placeholder);
	
	      if (_this.placeholder !== 0) {
	        _this.disable_team_button = false;
	      }
	    }
	  }, {
	    key: "addUserToTeam",
	    value: function addUserToTeam() {
	      var _this = this;
	
	      var id = _this.placeholder;
	      var email = _this.jobblerData.email;
	
	      _this.disable_team_button = true;
	
	      _this.$companies.updateCloudWithNewUser(id, email).then(function (response) {
	        _this.$timeout(function () {
	          console.log("what is the result");
	          console.dir(response.data.result);
	
	          if (response.data.status === "OK") {
	            console.log("in the true");
	            _this.successAddingToTeam = true;
	          } else {
	            console.log("in the false");
	            _this.successAddingToTeam = false;
	          }
	
	          _this.disable_team_button = false;
	        }, 300);
	
	        _this.$timeout(function () {
	          _this.successAddingToTeam = null;
	          $("#modal-add-user-to-team").modal("toggle");
	        }, 4000);
	      }, function (error) {});
	    }
	  }, {
	    key: "confirmAdd",
	    value: function confirmAdd() {
	      var _this = this;
	      _this.remain_loading_count--;
	
	      _this.$companies.updateCloudWithNewUser(_this.teamsArr.id, _this.jobblerData.email).then(function (data) {
	        _this.$timeout(function () {
	          jQuery("#modal-add-user-to-team-modal .modal-header button.close").trigger("click");
	        }, 200);
	
	        _this.$timeout(function () {
	          jQuery("#modal-add-user-to-team-confirm").trigger("click");
	          _this.remain_loading_count++;
	        }, 2000);
	      });
	    }
	  }, {
	    key: "addTeamToList",
	    value: function addTeamToList(team) {
	      var _this = this;
	    }
	  }, {
	    key: "messageJobbler",
	    value: function messageJobbler(jobbler) {
	      var _this = this;
	
	      _this.sendingMessage = true;
	      var scp = _this.$scope;
	      var msg = _this.$messagingv2;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetJobblerForMessage", {
	          jobbler: jobbler,
	          event: _this.event,
	          s: scp,
	          m: msg
	        });
	      });
	    }
	  }, {
	    key: "paginateRatings",
	    value: function paginateRatings(page) {
	      var _this = this;
	      _this.currentPageNumber = page;
	      var offset = page * 5 - 5;
	      var id = _this.jobblerData.jobblerId;
	      _this.$auth.getRatings(offset, id).then(function (response) {
	        if (response.statusText === "OK" || response.status === 200) {
	          var ratings = response.data.ratings;
	          if (ratings.length > 0) {
	            _this.handle_ratings(ratings);
	          }
	        } else {
	          alert("There was an error loading the ratings for this user. Please contact support.");
	        }
	      });
	    }
	  }, {
	    key: "handle_ratings",
	    value: function handle_ratings(ratings) {
	      var _this = this;
	      try {
	        ratings.forEach(function (rating) {
	          rating.lastUpdatedLocalTime = _this.getClientDate(rating.lastUpdated);
	        });
	      } finally {
	        _this.$timeout(function () {
	          _this.jobblerData.ratings = ratings;
	        });
	      }
	    }
	  }, {
	    key: "getClientDate",
	    value: function getClientDate(serverUTCTime) {
	      var date = new Date(serverUTCTime);
	      //return moment(date).format("MMM DD, YYYY");
	      return moment(date).format("LLLL");
	    }
	  }, {
	    key: "connectJobbler",
	    value: function connectJobbler(applicant) {
	      var _this = this;
	
	      if (_this.paymentInfos.length == 0) {
	        _this.$timeout(function () {
	          jQuery("#modal-view-jobble .modal-header button.close").trigger("click");
	        });
	
	        _this.$timeout(function () {
	          jQuery("#link-modal-add-card").trigger("click");
	        }, 300);
	
	        return;
	      }
	
	      _this.$timeout(function () {
	        jQuery("#modal-view-jobble .modal-header button.close").trigger("click");
	      });
	
	      _this.$timeout(function () {
	        jQuery("#modal-connect-jobbler-click").trigger("click");
	        //_this.testy = "true";
	        //_this.cardHasNotBeenSelectedForConnect = true;
	      }, 350);
	
	      //_this.creditCardsForCompany = _this.currentUser.company.paymentInfos;
	
	      _this.generateCardsArray();
	    }
	  }, {
	    key: "generateCardsArray",
	    value: function generateCardsArray() {
	      var _this = this;
	
	      var credCardArray = [];
	      var last4Array = [];
	      console.log("in generate");
	      console.dir(_this.paymentInfos);
	      console.dir(_this.$rootScope);
	
	      try {
	        _this.paymentInfos.forEach(function (card) {
	          if (card.bankName && card.validated) {
	            card.last4edited = "******-" + card.last4;
	            last4Array.push(card.last4edited);
	          } else {
	            card.last4edited = "****-****-****-" + card.last4;
	            last4Array.push(card.last4edited);
	          }
	        });
	      } finally {
	        last4Array.unshift("Payment method");
	
	        if (_this.$rootScope.defaultCard) {
	          _this.creditCardsForCompany = {
	            value: _this.$rootScope.defaultCard.last4edited,
	            values: last4Array
	          };
	        } else {
	          _this.creditCardsForCompany = {
	            value: "Payment method",
	            values: last4Array
	          };
	        }
	
	        console.log("_this.creditCardsForCompany");
	        console.dir(_this.creditCardsForCompany);
	      }
	    }
	  }, {
	    key: "connectJobblerConfirm",
	    value: function connectJobblerConfirm(valid) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        _this.showLoader = true;
	        jQuery("#modal-connect-jobbler .important-modal-text").hide("slow");
	      });
	
	      try {
	        if (!_this.$rootScope.defaultCard || _this.creditCardsForCompany.value !== _this.$rootScope.defaultCard.last4edited) {
	          for (var i = 0; i < _this.paymentInfos.length; i++) {
	            if (_this.paymentInfos[i].last4edited === _this.creditCardsForCompany.value) {
	              _this.$rootScope.defaultCard = _this.paymentInfos[i];
	            }
	          }
	        }
	      } finally {
	        _this.$security.bulkConnect(_this.$rootScope.defaultCard, _this.jobblerData).then(function (response) {
	          console.log("response...");
	          console.dir(response);
	
	          var errorFound = false;
	
	          try {
	            for (var i = 0; i < response.data.length; i++) {
	              console.log("*********************************************each response");
	              console.dir(response.data);
	              if (response.data[i].status === "error") {
	                alert("There was an error while trying to make a connection: " + response.data[i].message);
	                errorFound = true;
	              }
	            }
	          } finally {
	            if (response.statusText === "OK" && !errorFound) {
	              if (response.data[0].status === "error") {
	                alert("this jobbler is already booked for time frame");
	              } else {
	                _this.$rootScope.$broadcast("AdjustApplicantsAfterConnection", {
	                  acceptedJobbler: _this.jobblerData
	                });
	
	                _this.$timeout(function () {
	                  _this.successfulPayment = true;
	                  jQuery("#modal-connect-jobbler .image-to-hide").hide("slow");
	                }, 2000);
	
	                _this.$timeout(function () {
	                  _this.successfulPaymentCheckMark = true;
	                }, 2500);
	              }
	            } else {
	              _this.$timeout(function () {
	                jQuery("#modal-connect-jobbler-click").trigger("click");
	              }, 300);
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: "rejectJobbler",
	    value: function rejectJobbler(jobbler) {
	      var _this = this;
	      console.log("rejectJobbler");
	      console.dir(this.jobblerData);
	      var data = {};
	      data.jobbler = _this.jobblerData;
	      data.status = 2;
	      //in eventreview applicants ... rootScope call this function
	      //confirmRemoveJobbler
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("RejectFromProfileScreen", data);
	      });
	    }
	  }, {
	    key: "hireJobblers",
	    value: function hireJobblers(jobbler) {
	      var _this = this;
	
	      console.log("who is the jobbler");
	      console.dir(jobbler);
	
	      var jobblesAndApplicants = [];
	      var jobbleObjForApplication = {};
	
	      jobbleObjForApplication.applicant = jobbler.jobblerId;
	      jobbleObjForApplication.jobble = jobbler.jobbleId;
	      jobbleObjForApplication.index = 0;
	      jobblesAndApplicants.push(jobbleObjForApplication);
	
	      _this.$security.hireJobblerAfterConnection(jobblesAndApplicants).then(function (response) {
	        console.log("response from bulk accepted");
	        console.dir(response);
	
	        if (response.data[0].status === "error") {
	          alert("Error connecting with this jobbler. Please contact admin for support.");
	          return;
	        }
	
	        _this.$rootScope.$broadcast("AdjustApplicantsAfterConnection", {
	          acceptedJobbler: jobbler
	        });
	      }, function (response) {
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "hireJobbler",
	    value: function hireJobbler() {
	      var _this = this;
	      console.log("hire jobbler");
	      console.dir(_this.jobblerData);
	      console.dir(_this.applicationForAccept);
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("HireJobblerFromProfile", {
	          application: _this.applicationForAccept
	        });
	      });
	    }
	  }, {
	    key: "sendMessageForConnection",
	    value: function sendMessageForConnection(text) {
	      var _this = this;
	      var usersObj = {};
	      usersObj.users = _this.currentUser.email + ", " + _this.jobblerData.email;
	      usersObj.event = _this.$stateParams.eventId;
	      _this.$timeout(function () {
	        jQuery("#modal-connect-jobbler .fade-in-loader").hide("slow");
	      });
	      _this.$timeout(function () {
	        jQuery("#modal-connect-jobbler .image-to-hide").show("slow");
	      }, 400);
	      _this.$messagingv2.createOrReturnChannelTrimmed(usersObj).then(function (response) {
	        var channelWeWant = response.data.result[0].channelName;
	        _this.findChannel(channelWeWant, text);
	      });
	    }
	  }, {
	    key: "findChannel",
	    value: function findChannel(channel, text) {
	      console.log("text?");
	      console.dir(text);
	      var _this = this;
	      if (_this.$rootScope.allChannelNames) {
	        if (_this.$rootScope.allChannelNames.indexOf(channel) > -1) {
	          console.log("we found the channel.....zzzzzzzzzzzzzzzzzzzzzzzzzzzz");
	
	          var jobblerArray = [];
	          jobblerArray.push(_this.jobbler);
	          _this.blockedList = _this.$messagingv2.generateBlockList(jobblerArray);
	          var isNewChannel = false;
	          var indexOf = _this.$rootScope.allChannelNames.indexOf(channel);
	          _this.$messagingv2.publishMessage(text, null, null, null, _this.blockedList, _this.event.id, null, isNewChannel, channel, indexOf);
	
	          /*
	          _this.$rootScope.channels[i].channelArrayHolder[x].isActive = 'active';
	          _this.$rootScope.activeChannel = _this.$rootScope.channels[i].channelArrayHolder[x].name;
	          channelThatWasFound = _this.$rootScope.channels[i].channelArrayHolder[x];
	          */
	          //console.log('...................the channel was found........................');
	          //channelWasFound = true;
	          _this.remain_loading_count = 0;
	        } else {
	          _this.loadChannelsNew(channel, text);
	        }
	      } else {
	        _this.loadChannelsNew(channel, text);
	      }
	    }
	  }, {
	    key: "loadChannelsNew",
	    value: function loadChannelsNew(channel, text) {
	      console.log("loadChannelsNew");
	      console.dir(text);
	
	      var _this = this;
	
	      console.log("might not need to call load channels because its already being done for channels that dont exist");
	      console.dir(channel);
	
	      var usersloop = function usersloop(value) {
	        _this.$timeout(function () {
	          if (value > 0) {
	            _this.$messagingv2.getChannels(1).then(function (response) {
	              console.log("-------------these need to match response from load channels-----------------------------------");
	              console.dir(response);
	              console.dir(response.data.channels[0].name);
	              console.dir(channel);
	              if (response.data.channels[0].name === channel) {
	                console.log("we have a match....heres the channel lets add it to the list of channels we already have");
	                console.dir(response.data.channels[0]);
	                console.dir(_this.message);
	                console.log("text");
	                console.dir(text);
	                var jobblerArray = [];
	                jobblerArray.push(_this.jobbler);
	                _this.blockedList = _this.$messagingv2.generateBlockList(jobblerArray);
	                console.log("block list?");
	                console.dir(_this.blockList);
	                var isNewChannel = true;
	                var indexOf = null;
	                var t = "null";
	                if (text) {
	                  t = text;
	                } else {
	                  t = _this.message;
	                }
	
	                _this.$timeout(function () {
	                  _this.$messagingv2.publishMessage(t, null, null, null, _this.blockedList, _this.eventId, response.data.channels[0], isNewChannel, response.data.channels[0].name, indexOf);
	                  jQuery("#modal-connect-jobbler .image-to-hide").hide("slow");
	                }, 1000);
	
	                _this.$timeout(function () {
	                  _this.showCompleteMessage = true;
	                }, 1500);
	              } else {
	                usersloop(value - 1);
	              }
	            }, function (error) {
	              console.log("in error in send message");
	            });
	          } else {
	            console.log("at the end...");
	          }
	        }, 1000);
	      };
	
	      usersloop(5);
	    }
	  }, {
	    key: "displayConnectionScreen",
	    value: function displayConnectionScreen() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        jQuery("#modal-connect-jobbler-click").trigger("click");
	      }, 600);
	    }
	  }, {
	    key: "addAnotherCard",
	    value: function addAnotherCard() {
	      var _this = this;
	
	      console.log("what is the jobbler data at this point");
	      console.dir(_this.jobblerData);
	
	      _this.$timeout(function () {
	        jQuery("#modal-connect-jobbler .modal-header button.close").trigger("click");
	      });
	
	      _this.$timeout(function () {
	        jQuery("#link-modal-add-card").trigger("click");
	      }, 300);
	    }
	  }, {
	    key: "closeConnectionWindow",
	    value: function closeConnectionWindow() {
	      console.log("closeConnectionWindow");
	
	      var _this = this;
	
	      //_this.jobblerData = undefined;
	      _this.showCompleteMessage = undefined;
	      _this.showLoader = undefined;
	      _this.successfulPayment = undefined;
	      _this.successfulPaymentCheckMark = undefined;
	      _this.text = undefined;
	    }
	  }, {
	    key: "goToInbox",
	    value: function goToInbox() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        jQuery("#modal-connect-jobbler .modal-header button.close").trigger("click");
	      });
	
	      _this.$timeout(function () {
	        _this.$state.go("inbox");
	      }, 300);
	    }
	  }, {
	    key: "cardChanging",
	    value: function cardChanging() {
	      console.log("cardChanging");
	      console.dir(this.creditCardsForCompany.value);
	    }
	  }, {
	    key: "previousProfile",
	    value: function previousProfile() {
	      var _this = this;
	      console.log("previous profile");
	      console.dir(_this.jobblerData);
	
	      _this.jobblerData.direction = "previous";
	
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("PaginateApplications", {
	          data: _this.jobblerData
	        });
	      });
	    }
	  }, {
	    key: "nextProfile",
	    value: function nextProfile() {
	      var _this = this;
	
	      _this.jobblerData.direction = "next";
	
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("PaginateApplications", {
	          data: _this.jobblerData
	        });
	      });
	    }
	  }, {
	    key: "setMessagingBox",
	    value: function setMessagingBox() {
	      var _this = this;
	      console.log("setMessagingBox");
	      _this.messageJobbler(_this.jobblerData);
	    }
	  }, {
	    key: "editConfirmation",
	    value: function editConfirmation(shift, user, closeShiftModal) {
	      var _this = this;
	
	      console.log("editConfirmation");
	      console.dir(shift);
	      console.dir(user);
	
	      if (closeShiftModal) {
	        _this.$timeout(function () {
	          $("#modal-confirm-jobbler").modal("toggle");
	        });
	      }
	
	      shift.userId = _this.jobblerData.jobblerId;
	      _this.shift_confirm = shift;
	
	      var user_to_update = _this.jobblerData;
	
	      _this.$timeout(function () {
	        $("#modal-confirm-jobbler-note").modal();
	      }, 300);
	
	      _this.$jobs.getShift(shift.id).then(function (response) {
	        console.log("response");
	        console.dir(response);
	        _this.confirmationNote = response.data.confirmationNote;
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "determineImageDimensions",
	    value: function determineImageDimensions() {
	      var _this4 = this;
	
	      var myImg = void 0;
	      var imageClassForDisplay = void 0;
	      this.$timeout(function () {
	        myImg = document.querySelector("#jobbler-profile-picture-modal");
	
	        if (myImg) {
	          imageClassForDisplay = _this4.$profiles.dimensionsCalc(myImg.clientHeight, myImg.clientWidth);
	
	          if (imageClassForDisplay === "remove-class") {
	            $("#jobbler-profile-picture-modal").removeClass("default");
	            $("#jobbler-profile-picture-modal").removeClass("default-long");
	          } else {
	            $("#jobbler-profile-picture-modal").addClass(imageClassForDisplay);
	          }
	        }
	      });
	    }
	  }]);
	
	  return JobblerprofileController;
	}();
	
	JobblerprofileController.$inject = ["$http", "$localStorage", "$state", "auth", "events", "jobs", "$stateParams", "security", "profile", "common", "$rootScope", "$location", "$timeout", "companies", "messagingv2", "$scope"];
	
	exports.default = JobblerprofileController;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CommonService = function () {
	  function CommonService($http, $localStorage, $state, $q, SecurityService, AuthService, $timeout, env) {
	    _classCallCheck(this, CommonService);
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$q = $q;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.galleryPictures = [];
	    this.$timeout = $timeout;
	    this.$env = env;
	
	    this.jobblerData = null;
	  }
	
	  _createClass(CommonService, [{
	    key: "displayDetails",
	    value: function displayDetails(applicant, type, action) {
	      var jobblerData = {};
	
	      if (action === "open") {
	        jobblerData = this.$security.getJobblerData(applicant, type);
	
	        this.galleryPictures = jobblerData.pics;
	        jobblerData.currentPicture = this.galleryPictures[0];
	        jobblerData.currentIndex = 0;
	        this.jobblerModal = true;
	        this.jobblerData = jobblerData;
	      } else {
	        this.jobblerData = null;
	        this.fullScreenGallery = false;
	        this.jobblerModal = false;
	      }
	    }
	  }, {
	    key: "getJobblerData",
	    value: function getJobblerData() {
	      return this.jobblerData;
	    }
	  }, {
	    key: "differenceInHours",
	    value: function differenceInHours(start, end) {
	      var totalMinutes = moment(end).diff(moment(start), "minutes");
	
	      var ret = "";
	
	      if (start === null || end === null) {
	        ret = "--";
	      } else {
	        ret = Math.floor(totalMinutes / 60);
	      }
	
	      return ret;
	    }
	  }, {
	    key: "differenceInMinutes",
	    value: function differenceInMinutes(start, end) {
	      var totalMinutes = moment(end).diff(moment(start), "minutes");
	
	      var ret = "";
	
	      if (start === null || end === null) {
	        ret = "--";
	      } else {
	        ret = totalMinutes % 60;
	      }
	
	      return ret;
	    }
	  }, {
	    key: "checkSystem",
	    value: function checkSystem() {
	      var _this = this;
	
	      return new Promise(function (resolve) {
	        var req = {
	          method: "GET",
	          url: _this.$env.getAPIEndPoint() + "public/jobble-types?format=json&max=1&displayOrder=asc&fields=id",
	          data: {},
	          withCredentials: false
	        };
	
	        _this.$http(req).then(function (data) {
	
	          console.log("response from system check");
	          console.dir(data);
	
	          if (data.status === 500) {
	            return resolve({
	              systemUp: false
	            });
	          }
	
	          if (data.status === 202) {
	            return resolve({
	              systemUp: true
	            });
	          }
	
	          if (data && data.data && data.data.length) {
	            resolve({
	              systemUp: true
	            });
	          } else {
	            resolve({
	              systemUp: false
	            });
	          }
	        }).catch(function (err) {
	          console.error("API Error in from system check. Error:", err);
	          resolve({
	            systemUp: false
	          });
	        });
	      });
	    }
	  }]);
	
	  return CommonService;
	}();
	
	exports.default = CommonService;
	
	
	CommonService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "$timeout", "env"];

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProfileService = function () {
	  function ProfileService($http, $localStorage, $state, $q, $timeout, SecurityService, AuthService, EnvService) {
	    var _STATUS_MAP;
	
	    _classCallCheck(this, ProfileService);
	
	    this.COMPLETE_PROFILE = 1;
	    this.VERIFY_PHONE = 2;
	    this.INPUT_PHONE_NUMBER = 3;
	    this.LOCATION = 4;
	    this.WORK_ELIGIBILITY = 5;
	    this.BG_CONSENT = 6;
	    this.PROFILE_PICTURE = 7;
	    this.PAYMENTS = 8;
	
	    //this.BG_CONSENT = 8;
	    //this.PROFILE_PICTURE = 6;
	    //this.PAYMENTS = 7;
	
	    this.APPLY_ELIGIBLE = 11;
	    this.FULL_ELIGIBLE = 12;
	
	    this.STATUS_MAP = (_STATUS_MAP = {}, _defineProperty(_STATUS_MAP, this.COMPLETE_PROFILE, "complete your profile"), _defineProperty(_STATUS_MAP, this.VERIFY_PHONE, "verify your phone number"), _defineProperty(_STATUS_MAP, this.INPUT_PHONE_NUMBER, "input phone number"), _defineProperty(_STATUS_MAP, this.LOCATION, "location"), _defineProperty(_STATUS_MAP, this.WORK_ELIGIBILITY, "work eligibility"), _defineProperty(_STATUS_MAP, this.BG_CONSENT, "background consent"), _defineProperty(_STATUS_MAP, this.PROFILE_PICTURE, "profile picture"), _defineProperty(_STATUS_MAP, this.PAYMENTS, "payments"), _STATUS_MAP);
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$q = $q;
	    this.$env = EnvService;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.default_jobbler_image = "/app/vendor/images/defaultimg.jpeg";
	    this.default_cover_photo = "/app/vendor/images/default-cover-photo.jpg";
	    this.validateUrlAll = "jbl/v1/validate?format=json&verbosity=5";
	    this.resendEmailUrl = "register/resend-verification-email?format=json&conf=web";
	    this.checkStatusUrl = "jbl/v1/validate?format=json&fields=id,username,isVerified";
	    this.validateUrl = "jbl/v1/validate?format=json&fields=username,dateBirth,bio,video1,nickname,ssn,id,smsChatNotificationOn,filePROFILE_IMAGE1IMG_160x160,profilePictureUri,emailChatNotificationOn,firstName,dateCreated,lastName,access_token,company.name,company.id,company.payPerConnect,homeContactInfo.streetLine1,homeContactInfo.streetLine2,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.dateCreated,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.companyLogoUri,company.totalNumberOfCircles,company.totalNumberOfCloseEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.circleOfConnectedJobblers.id,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.partner,company.rds_company,notifPref.jobbleTypes,acceptedWebAgreement,acceptedMobileAgreement,acceptedPrivacyPolicy,acceptedCookiePolicy";
	    this.createRecipientUrl = "jbl/v1/stripe/create-recipient-stripe-account?format=json&conf=web&typeAccount=individual";
	    this.imageUrl = "jbl/v1/validate?format=json&fields=username,picture1,picture2,filePROFILE_IMAGE1IMG_160x160,resumeLink,resumeLink2";
	    if (this.$localStorage.logged_user) {
	      this.resumeUrl = "jbl/v1/users/" + this.$localStorage.logged_user.id + "/files?format=json&conf=web&fileType=PROFILE_RESUME1&replace=true";
	    }
	  }
	
	  _createClass(ProfileService, [{
	    key: "getMultiMediaData",
	    value: function getMultiMediaData() {
	      var _this = this;
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&verbosity=5";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "checkValidationStatus",
	    value: function checkValidationStatus() {
	      var _this = this;
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + _this.checkStatusUrl,
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "getProfilePicture",
	    value: function getProfilePicture(token) {
	      var _this = this;
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + _this.imageUrl,
	        headers: { Authorization: "Bearer " + token },
	        data: {}
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "validateUserByToken",
	    value: function validateUserByToken(token) {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + _this.validateUrl,
	        headers: {
	          Authorization: "Bearer " + token
	        },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "sendSMSCode",
	    value: function sendSMSCode() {
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/verifications",
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "validateSMSCode",
	    value: function validateSMSCode(code) {
	      var req = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/verifications/" + code,
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getMultiMediaDataWithFormats",
	    value: function getMultiMediaDataWithFormats() {
	      var _this = this;
	
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&fields=id,access_token,picture1,picture1s,picture2,filePROFILE_IMAGE1IMG_160x160,filePROFILE_IMAGE2IMG_160x160,filePROFILE_IMAGE3IMG_160x160,filePROFILE_IMAGE4IMG_160x160,filePROFILE_IMAGE5IMG_160x160,filePROFILE_IMAGE6IMG_160x160";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "getJobblerPictures",
	    value: function getJobblerPictures(user, is_edit, current_model) {
	      var _this = this;
	      var picture_data = {};
	      picture_data.picture_array_160x160 = [];
	      console.log("what is the edit data in the get jobbler pictures");
	      console.dir(is_edit);
	      if (is_edit) {
	        console.log("in the edit part of the thing");
	        console.dir(current_model);
	        var picture_array = current_model.picture_data.picture_array_160x160;
	        try {
	          for (var i = 0; i < picture_array.length; i++) {
	            if (picture_array[i].id === is_edit.id) {
	              console.log("we have a match");
	              picture_array[i].url = is_edit.pic_url;
	              break;
	            }
	          }
	        } catch (err) {
	          console.log("error in the editing of photo");
	          console.dir(err);
	        } finally {
	          console.log("in the finally for replace");
	          console.dir(picture_array);
	          current_model.picture_data.picture_array_160x160 = [];
	          current_model.picture_data.picture_array_160x160 = picture_array;
	          console.log("what are we returning?");
	          console.dir(current_model);
	          return current_model;
	        }
	      } else {
	        try {
	          if (user.filePROFILE_IMAGE1IMG_160x160) {
	            var picture_160x160_1 = {
	              id: 1,
	              url: user.filePROFILE_IMAGE1IMG_160x160
	            };
	            //picture_data.picture_array_160x160.push(picture_160x160_1);
	            picture_data.main_picture = user.picture1;
	          } else {
	            //picture_data.main_picture=_this.default_jobbler_image;
	          }
	          if (user.filePROFILE_IMAGE2IMG_160x160) {
	            var picture_160x160_2 = {
	              id: 2,
	              url: user.filePROFILE_IMAGE2IMG_160x160
	            };
	            if (user.picture2) {
	              picture_data.cover_picture = user.picture2;
	            } else {
	              picture_data.cover_picture = user.filePROFILE_IMAGE2IMG_160x160;
	            }
	            if (!picture_data.main_picture) {
	              //picture_data.main_picture=user.filePROFILE_IMAGE2IMG_160x160;
	            }
	          } else {
	              //picture_data.main_picture=_this.default_jobbler_image;
	            }
	          if (user.filePROFILE_IMAGE3IMG_160x160) {
	            var picture_160x160_3 = {
	              id: 3,
	              url: user.filePROFILE_IMAGE3IMG_160x160
	            };
	            picture_data.picture_array_160x160.push(picture_160x160_3);
	          } else {
	            //picture_data.main_picture=_this.default_jobbler_image;
	          }
	          if (user.filePROFILE_IMAGE4IMG_160x160) {
	            var picture_160x160_4 = {
	              id: 4,
	              url: user.filePROFILE_IMAGE4IMG_160x160
	            };
	            picture_data.picture_array_160x160.push(picture_160x160_4);
	
	            /*if (!picture_data.main_picture){
	            picture_data.main_picture=user.filePROFILE_IMAGE4IMG_160x160;
	            }*/
	          } else {
	              //picture_data.main_picture=_this.default_jobbler_image;
	            }
	          if (user.filePROFILE_IMAGE5IMG_160x160) {
	            var picture_160x160_5 = {
	              id: 5,
	              url: user.filePROFILE_IMAGE5IMG_160x160
	            };
	            picture_data.picture_array_160x160.push(picture_160x160_5);
	          } else {
	            //picture_data.main_picture=_this.default_jobbler_image;
	          }
	          if (user.filePROFILE_IMAGE6IMG_160x160) {
	            var picture_160x160_6 = {
	              id: 6,
	              url: user.filePROFILE_IMAGE6IMG_160x160
	            };
	            picture_data.picture_array_160x160.push(picture_160x160_6);
	            if (!picture_data.main_picture) {
	              //picture_data.main_picture=user.filePROFILE_IMAGE6IMG_160x160;
	            }
	          } else {
	              //picture_data.main_picture=_this.default_jobbler_image;
	            }
	        } catch (err) {
	          alert("error parsing pictures");
	        } finally {
	          console.log("in the finally with picture data");
	          console.dir(picture_data);
	          if (!picture_data.main_picture) {
	            picture_data.main_picture = _this.default_jobbler_image;
	          }
	          if (!picture_data.cover_picture) {
	            picture_data.cover_picture = _this.default_cover_photo;
	          }
	          return picture_data;
	        }
	      }
	    }
	  }, {
	    key: "uploadProfilePicture",
	    value: function uploadProfilePicture(picture) {
	      return this.uploadPicture(picture, "PROFILE_IMAGE1");
	    }
	  }, {
	    key: "uploadProfileVideo",
	    value: function uploadProfileVideo(picture) {
	      return this.uploadPicture(picture, "PROFILE_VIDEO1");
	    }
	  }, {
	    key: "uploadCoverPicture",
	    value: function uploadCoverPicture(picture) {
	      return this.uploadPicture(picture, "PROFILE_IMAGE2");
	    }
	  }, {
	    key: "uploadPictures",
	    value: function uploadPictures(picture, number) {
	      console.log("Is this getting called multiple times???");
	      console.dir(number);
	      return this.uploadPicture(picture, "PROFILE_IMAGE" + number);
	    }
	  }, {
	    key: "uploadPicture",
	    value: function uploadPicture(picture, fileType) {
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + this.$localStorage.logged_user.id + "/files?format=json&conf=web&fileType=" + fileType + "&replace=true",
	        headers: {
	          Authorization: "Bearer " + this.$auth.getAccessToken(),
	          "Content-type": undefined
	        },
	        transformRequest: _angular2.default.identity,
	        data: picture
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "deletePicture",
	    value: function deletePicture(fileType) {
	      console.log("deletePicture");
	      console.dir(fileType);
	      var req = {
	        method: "DELETE",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + this.$localStorage.logged_user.id + "/file-types/" + fileType + "?format=json&conf=web",
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "saveUser",
	    value: function saveUser(user) {
	      if (user.preferredName) {
	        user.nickname = user.preferredName;
	      }
	
	      var logged_user = this.$localStorage.logged_user || {};
	
	      var req = {
	        method: "PUT",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + logged_user.access_token
	        },
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + logged_user.id + "?format=json&fields=id",
	        data: user
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "saveUserBasic",
	    value: function saveUserBasic(user) {
	
	      var logged_user = this.$localStorage.logged_user || {};
	
	      var req = {
	        method: "PUT",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + logged_user.access_token
	        },
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + logged_user.id + "/updateMinimalFields",
	        data: user
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getLatestTutorial",
	    value: function getLatestTutorial() {
	      var _this = this;
	
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&fields=id,billingTutorialTracking";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getPaymentInfo",
	    value: function getPaymentInfo() {
	      var _this = this;
	
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&fields=id,access_token,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.setupIntentId,company.undeletedPaymentInfos.lastUpdated,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	      return _this.$http(req);
	    }
	
	    /*
	      getPaymentInfo() {
	          var _this = this;
	           let url =
	              _this.$env.getAPIEndPoint() +
	              "jbl/v1/validate?format=json&fields=id,access_token,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.lastUpdated,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname";
	          let req = {
	              method: "GET",
	              url: url,
	              headers: {Authorization: "Bearer " + this.$auth.getAccessToken()},
	              data: {},
	          };
	          return _this.$http(req);
	      }*/
	
	  }, {
	    key: "updatePrefJobbleTypes",
	    value: function updatePrefJobbleTypes(jobble_types_array) {
	      var _this = this;
	      var jt_ids = { notifPref: { jobbleTypes: jobble_types_array } };
	      var req = {
	        method: "PUT",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=id,notifPref.jobbleTypes",
	        data: jt_ids
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "uploadResume",
	    value: function uploadResume(file) {
	      var _this = this;
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + _this.resumeUrl,
	        headers: {
	          Authorization: "Bearer " + _this.$auth.getAccessToken(),
	          "Content-type": undefined
	        },
	        transformRequest: _angular2.default.identity,
	        data: file
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "getSocialLinks",
	    value: function getSocialLinks() {
	      var _this = this;
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&fields=id,access_token,instagram,facebook,linkdedIn,googlePlus,twitter";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "updateSocialLinks",
	    value: function updateSocialLinks(data) {
	      var _this = this;
	      var req = {
	        method: "PUT",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=id,access_token,instagram,facebook,linkdedIn,googlePlus,twitter",
	        data: {
	          facebook: data.facebook,
	          linkdedIn: data.linkedin,
	          twitter: data.twitter,
	          instagram: data.instagram,
	          googlePlus: data.google
	        }
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "isEmail",
	    value: function isEmail(val) {
	      return (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val)
	      );
	    }
	  }, {
	    key: "isPhone",
	    value: function isPhone(val) {
	      return (/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(val)
	      );
	    }
	  }, {
	    key: "userConsent",
	    value: function userConsent(copy) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/consents?consentAccepted=true&receiveCopy=" + copy,
	        headers: {
	          Authorization: "Bearer " + this.$auth.getAccessToken(),
	          "Content-type": "application/json"
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "resendEmail",
	    value: function resendEmail(user) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + _this.resendEmailUrl,
	        headers: {
	          Authorization: "Bearer " + this.$auth.getAccessToken(),
	          "Content-type": "application/json"
	        },
	        data: { email: user.email }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getUserProfileEligibility",
	    value: function getUserProfileEligibility(user) {
	      if (this.getUserProfileScreen(user) >= this.PROFILE_PICTURE) return this.APPLY_ELIGIBLE;
	
	      return 0;
	    }
	  }, {
	    key: "getMostRecentUser",
	    value: function getMostRecentUser() {
	      var _this2 = this;
	
	      return new Promise(function (resolve, reject) {
	        resolve(_this2.$auth.getUserData());
	      });
	    }
	  }, {
	    key: "getUserProfileScreen",
	    value: function getUserProfileScreen(user, profileStatus) {
	      /*(/^(?!219-09-9999|078-05-1120)(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/)
	          (/^(?!219099999|078051120)(?!666|000|9\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/)*/
	      var simpleSsn = /^\d{9}$/;
	      var ssnPattern = /^(?!219099999|078051120)(?!666|000|9\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/;
	      var phonePattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
	      var zipPattern = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
	
	      this.currentUser = user || this.currentUser;
	
	      if (!user) return 0;
	
	      if (!user.firstName || !user.lastName || !user.homeContactInfo) return this.COMPLETE_PROFILE;
	
	      if (!user.homeContactInfo.phoneMobile || !phonePattern.test(user.homeContactInfo.phoneMobile)) return this.VERIFY_PHONE;
	
	      if (!user.homeContactInfo.isMobilePhoneVerified || user.homeContactInfo.isMobilePhoneVerified === false) return this.INPUT_PHONE_NUMBER;
	
	      if (!user.homeContactInfo || !user.homeContactInfo.streetLine1 || !user.homeContactInfo.zipCode || !zipPattern.test(user.homeContactInfo.zipCode) || !user.homeContactInfo.city || !user.homeContactInfo.state || user.homeContactInfo.state === "--") return this.LOCATION;
	
	      console.log("what is the user here");
	      console.dir(user);
	      console.dir(simpleSsn.test(user.ssn));
	      console.dir(profileStatus);
	
	      if (user) {
	        if (user.ssn) {
	          if (user.ssn.includes("xxxxx")) {
	            if (!user.acceptedBackgroundCheck || user.acceptedBackgroundCheck === false) {
	              return this.BG_CONSENT;
	            } else {
	              this.PROFILE_PICTURE;
	            }
	          } else {
	            if (!user.ssn || !simpleSsn.test(user.ssn) || !user.dateBirth || !this.validateDateBirth(user.dateBirth)) return this.WORK_ELIGIBILITY;
	          }
	        } else {
	          return this.WORK_ELIGIBILITY;
	        }
	      }
	
	      if (!user.acceptedBackgroundCheck || user.acceptedBackgroundCheck === false) return this.BG_CONSENT;
	
	      return this.PROFILE_PICTURE;
	    }
	  }, {
	    key: "getUserProfileStatus",
	    value: function getUserProfileStatus(user) {
	      var ssnPattern = /^(?!219099999|078051120)(?!666|000|9\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/;
	      var phonePattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
	      var zipPattern = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
	
	      if (!user) return 0;
	
	      if (!user.firstName || !user.lastName || !user.homeContactInfo || !user.homeContactInfo.phoneMobile || !phonePattern.test(user.homeContactInfo.phoneMobile) || !user.ssn || !ssnPattern.test(user.ssn) || !user.dateBirth || !this.validateDateBirth(user.dateBirth)) return 1;
	
	      if (!user.homeContactInfo || !user.homeContactInfo.streetLine1 || !user.homeContactInfo.zipCode || !zipPattern.test(user.homeContactInfo.zipCode) || !user.homeContactInfo.city || !user.homeContactInfo.state || user.homeContactInfo.state === "--") return 2;
	
	      if (!user.bio) return 3;
	
	      if (!user.profilePictureUri) return 4;
	
	      if (!user.notifPref || !user.notifPref.jobbleTypes || user.notifPref.jobbleTypes.length === 0) return 5;
	
	      return 6;
	    }
	  }, {
	    key: "validateProfile",
	    value: function validateProfile(user, field, errors) {
	      errors = errors || {};
	
	      if (field === "firstName") {
	        errors["firstName"] = !user.firstName;
	      }
	      if (field === "lastName") {
	        errors["lastName"] = !user.lastName;
	      }
	      if (field === "phoneMobile") {
	        if (user.homeContactInfo.phoneMobile.length === 1 && user.homeContactInfo.phoneMobile === "1") {
	          user.homeContactInfo.phoneMobile = "";
	        }
	        var phonePattern = /^(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/;
	        //const phonePattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
	        //const phonePattern = /^[2-9]{2}[0-9]{8}$/;
	        errors["phoneMobile"] = !(user.homeContactInfo.phoneMobile && phonePattern.test(user.homeContactInfo.phoneMobile));
	      }
	      if (field === "ssn") {
	        var simpleSsn = /^\d{9}$/;
	        //const ssnPattern = /^(?!219099999|078051120)(?!666|000|9\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/;
	        errors["ssn"] = !(user.ssn && simpleSsn.test(user.ssn));
	      }
	      if (field === "dateBirth") {
	        errors["dateBirth"] = !this.validateDateBirth(user.dateBirth);
	      }
	      if (field === "streetLine1") {
	        errors["streetLine1"] = !user.homeContactInfo.streetLine1;
	      }
	      if (field === "zipCode") {
	        var zipPattern = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
	        errors["zipCode"] = !(user.homeContactInfo.zipCode && zipPattern.test(user.homeContactInfo.zipCode));
	      }
	      if (field === "city") {
	        errors["city"] = !user.homeContactInfo.city;
	      }
	      if (field === "state") {
	        errors["state"] = !(user.homeContactInfo.state && user.homeContactInfo.state !== "--");
	      }
	      if (field === "bio") {
	        errors["bio"] = !user.bio;
	      }
	
	      return errors;
	    }
	  }, {
	    key: "dimensionsCalc",
	    value: function dimensionsCalc(height, width) {
	
	      var result = void 0;
	      var div = void 0;
	
	      if (width > height) {
	        result = "default";
	        div = height / width;
	        console.log("div");
	        console.dir(div);
	      } else if (height > width) {
	        result = "default-long";
	        div = height / width;
	        console.log("div");
	        console.dir(div);
	        if (div > 1.5) {
	          result = "remove-class";
	        }
	      } else if (width === height) {
	        result = "default";
	      }
	
	      return result;
	    }
	  }, {
	    key: "validateDateBirth",
	    value: function validateDateBirth(dateBirth) {
	      if (!dateBirth) return false;
	
	      var birthDate = dateBirth;
	
	      if (!(birthDate instanceof Date)) {
	        birthDate = new Date(birthDate.replace("Z", ""));
	      }
	
	      var age = this.getAge(birthDate);
	
	      return age >= 18 && age < 122;
	    }
	  }, {
	    key: "getAge",
	    value: function getAge(birthDate) {
	      var today = new Date();
	      var age = today.getFullYear() - birthDate.getFullYear();
	      var m = today.getMonth() - birthDate.getMonth();
	      if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
	        age--;
	      }
	      return age;
	    }
	  }, {
	    key: "extractFields",
	    value: function extractFields(user, fields) {
	      var homeContactInfoFields = ["streetLine1", "zipCode", "city", "state", "phoneMobile"];
	
	      if (!fields || !user || fields.length === 0) return {};
	
	      var model = {};
	
	      fields.forEach(function (field) {
	        if (homeContactInfoFields.indexOf(field) !== -1) {
	          model.homeContactInfo = model.homeContactInfo || {};
	          model.homeContactInfo[field] = user && user.homeContactInfo ? user.homeContactInfo[field] : null;
	        } else {
	          model[field] = user[field];
	        }
	      });
	
	      return model;
	    }
	  }, {
	    key: "updatePassword",
	    value: function updatePassword(payload, userId) {
	      console.log("updatePassword");
	      console.dir(payload);
	      console.dir(userId);
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + userId + "/changePassword",
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: payload
	      };
	      return this.$http(req);
	    }
	  }]);
	
	  return ProfileService;
	}();
	
	exports.default = ProfileService;
	
	
	ProfileService.$inject = ["$http", "$localStorage", "$state", "$q", "$timeout", "security", "auth", "env"];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(115);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobblerprofile.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobblerprofile.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".jobblerprofile{color:red}", ""]);
	
	// exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _eventdialog = __webpack_require__(117);
	
	var _eventdialog2 = _interopRequireDefault(_eventdialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventdialogModule = _angular2.default.module("eventdialog", [_angularUiRouter2.default]).component("eventdialog", _eventdialog2.default);
	
	exports.default = eventdialogModule;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventdialog = __webpack_require__(118);
	
	var _eventdialog2 = _interopRequireDefault(_eventdialog);
	
	var _eventdialog3 = __webpack_require__(119);
	
	var _eventdialog4 = _interopRequireDefault(_eventdialog3);
	
	__webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventdialogComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _eventdialog2.default,
	  controller: _eventdialog4.default,
	  controllerAs: "vm"
	};
	
	exports.default = eventdialogComponent;

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal fade\" id=\"modal-add-openings\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\" style=\"width: 100%; padding: 24px; border: none; max-width: 536px; margin: auto\">\n          <div class=\"modal-header popup-header text-center\" style=\"text-align: left; padding: 0\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i style=\"color: #5e666d; font-size: 18px\" class=\"fas fa-times\" aria-hidden=\"true\"></i>\n            </button>\n\n            <h3 class=\"modal-title\" style=\"font-size: 18px; font-family: 'Poppins', sans-serif; font-weight: bold\">Add or remove openings</h3>\n          </div>\n          <div\n            class=\"modal-body popup-body text-center\"\n            style=\"\n              text-align: left;\n              font-family: Poppins, sans-serif;\n              font-size: 14px;\n              font-weight: 500;\n              letter-spacing: 0;\n              line-height: 21px;\n              padding: 24px 0;\n              padding-bottom: 0;\n            \"\n          >\n            <div>\n              Enter the amount of openings you’d like to add or remove from this job. Please note–changes to number of openings will be reflected\n              across all shifts.\n              <span ng-if=\"vm.currentOpeningsAmount != 1\">This job currently has {{ vm.currentOpeningsAmount }} openings left</span\n              ><span ng-if=\"vm.currentOpeningsAmount == 1\">This job currently has {{ vm.currentOpeningsAmount }} opening left</span>\n            </div>\n\n            <form style=\"margin-top: 32px\">\n              <div class=\"select-opening\">\n                <span style=\"margin: 0; padding: 0\">I would like to:</span>\n                <div class=\"select-box\" style=\"width: fit-content; margin: 0; padding: 0\">\n                  <select\n                    class=\"form-control form-input\"\n                    ng-model=\"vm.actions\"\n                    style=\"width: 186px; height: 40px; margin-left: 8px\"\n                    ng-options=\"actions for actions in vm.openingsListActions\"\n                  ></select>\n                </div>\n                <div class=\"select-box\" style=\"width: fit-content; margin: 0; padding: 0\">\n                  <select\n                    class=\"form-control form-input\"\n                    ng-model=\"vm.openings\"\n                    ng-options=\"openings for openings in vm.openingsList\"\n                    style=\"width: 75px; height: 40px\"\n                    ng-change=\"vm.openingsUpdate()\"\n                  ></select>\n                </div>\n\n                <span>opening(s)</span>\n              </div>\n\n              <a\n                class=\"btn btn-success button\"\n                href=\"\"\n                ng-click=\"vm.addOpenings()\"\n                style=\"\n                  margin-top: 100px;\n                  padding: 0;\n                  height: 40px;\n                  width: 100%;\n                  border-radius: 6px;\n                  background: linear-gradient(270deg, #62c046 0%, #5bad7b 48.24%, #5498b4 100%);\n                  font-family: Poppins, sans-serif;\n                  font-size: 14px;\n                  font-weight: bold;\n                  letter-spacing: 0;\n                  line-height: 40px;\n                  text-align: center;\n                \"\n              >\n                Save changes\n              </a>\n            </form>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"modal-verify-email-redesign\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n            </button>\n            <h4 class=\"modal-title\">Verify e-mail address</h4>\n          </div>\n\n          <div class=\"modal-body popup-body text-center\">\n            <p>Please verify your email address by clicking the link we sent to your inbox.</p>\n            <p>Once verified, your job posting will be published to the Jobble board where our Jobble community will be able to see it.</p>\n          </div>\n\n          <div class=\"modal-footer text-center\">\n            <div class=\"row\" style=\"text-align: center\">\n              <a class=\"btn btn-success modal-buttons-new\" ng-click=\"vm.checkVerificationStatus()\" style=\"border-radius: none\"\n                >I have verified my email address</a\n              >\n              <div class=\"alert-box alert\" ng-show=\"vm.verificationError\" style=\"font-size: 13px; margin-top: 15px\">{{ vm.verificationError }}</div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"modal-del-event\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n            </button>\n            <h3 class=\"modal-title\">\n              Are you sure you want to <br />\n              cancel this job?\n            </h3>\n          </div>\n          <div class=\"modal-body popup-body text-center\">\n            <a href=\"\" class=\"btn btn-success button\" ng-click=\"vm.keepEvent()\">Keep Job</a>\n            <a href=\"\" class=\"btn btn-danger button\" ng-click=\"vm.deleteEvent()\">Delete Job</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"modal-publish-event\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n            <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n          </button>\n          <div class=\"modal-header popup-header text-center\">\n            <strong ng-show=\"!vm.publish_status\">Are you sure you want to unpublish this job?</strong>\n            <strong ng-show=\"vm.publish_status\">Are you sure you want to publish this job?</strong>\n          </div>\n          <div class=\"modal-body popup-body text-center\">\n            <p ng-if=\"vm.publish_message\">\n              You are attempting to publish a sourcing post as an \"Invoice\" customer. By publishing this job you will be charged $50.00 USD.\n            </p>\n            <a class=\"btn btn-danger button\" href=\"\" data-dismiss=\"modal\"> Cancel </a>\n            <a class=\"btn btn-success button\" href=\"\" ng-click=\"vm.publishJob()\">\n              <span ng-show=\"!vm.publish_status\">Publish job</span>\n              <span ng-show=\"vm.publish_status\">Unpublish job</span>\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventdialogController = function () {
	  function EventdialogController($http, $localStorage, $state, AuthService, $rootScope, $scope, SecurityService, EventsService, EnvService, $timeout, TrackingService) {
	    _classCallCheck(this, EventdialogController);
	
	    this.name = "eventdialog";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$rootScope = $rootScope;
	    this.$security = SecurityService;
	    this.$events = EventsService;
	    this.$scope = $scope;
	    this.$env = EnvService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.currentUser = this.$auth.getUserData();
	    this.event = {};
	    this.openingsList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30];
	    this.openingsListActions = ["Add", "Remove"];
	    this.actions = "Add";
	    this.multiopenings = null;
	    this.openings = 1;
	    this.remain_loading_count = 0;
	    this.publish_status = null;
	    var _this = this;
	
	    _this.SetEventToEventDialogListener = _this.$rootScope.$on("SetEventToEventDialog", function ($event, params) {
	      console.log("SetEventToEventDialogListener");
	      console.dir(params);
	      _this.event = params.event;
	      _this.currentOpeningsAmount = params.event.numberOfOpenings;
	    });
	
	    _this.SetPublishTypeListener = _this.$rootScope.$on("SetPublishType", function ($event, params) {
	      _this.publish_status = params.status;
	      _this.publish_message = params.message;
	    });
	
	    _this.$scope.$on("$destroy", _this.SetPublishTypeListener);
	    _this.$scope.$on("$destroy", _this.SetEventToEventDialogListener);
	  }
	
	  _createClass(EventdialogController, [{
	    key: "openingsUpdate",
	    value: function openingsUpdate() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        if (_this.openings > 1) {
	          _this.multiopenings = "s";
	        } else {
	          _this.multiopenings = null;
	        }
	      });
	    }
	  }, {
	    key: "keepEvent",
	    value: function keepEvent() {
	      var _this = this;
	      _this.$timeout(function () {
	        jQuery("#modal-del-event").modal("toggle");
	      });
	    }
	  }, {
	    key: "deleteEvent",
	    value: function deleteEvent() {
	      var _this = this;
	
	      var deleteEventData = {
	        method: "DELETE",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + _this.event.id + "?format=json",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.currentUser.access_token
	        },
	        data: {}
	      };
	
	      _this.$timeout(function () {
	        jQuery("#modal-del-event").modal("toggle");
	        _this.remain_loading_count++;
	      });
	
	      _this.$http(deleteEventData).then(function (response) {
	        _this.remain_loading_count--;
	
	        _this.$tracking.reportJobCancellation(_this.event, _this.currentUser);
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SuccessToDeleteEvent", {
	            event: _this.event.id
	          });
	          _this.$auth.reloadCurrentUser();
	        }, 100);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	      });
	    }
	  }, {
	    key: "addOpenings",
	    value: function addOpenings() {
	      var _this = this;
	
	      if (_this.$security.isUndefinedOrNull(_this.event.subEvents)) {
	        _this.remain_loading_count++;
	        _this.$events.getEventById(_this.event.id).then(function (data) {
	          _this.remain_loading_count--;
	          if (data.data === "error") {
	            return;
	          }
	          _this.event = data.data;
	          _this.jobbleOpeningsUpdate();
	        }, function (data) {});
	      } else {
	        _this.jobbleOpeningsUpdate();
	      }
	    }
	  }, {
	    key: "jobbleOpeningsUpdate",
	    value: function jobbleOpeningsUpdate() {
	      var _this = this;
	
	      var openings = _this.openings;
	
	      var totalJobOpenings = _this.event.numberOfApprovedApplications + _this.event.numberOfOpenings;
	
	      if (_this.actions === "Remove" && openings > _this.event.numberOfOpenings) {
	        alert("Please reduce the number of openings you are trying to remove. You are attempting to remove " + _this.event.numberOfOpenings + " opening(s).");
	        return;
	      }
	
	      if (_this.actions === "Add") {
	        var addOpeningsData = {
	          method: "POST",
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + _this.event.subEvents[0].deduppedJobbles[0].id + "/add-positions?format=json&conf=web&numberOfPositions=" + _this.openings,
	          headers: {
	            "Content-Type": "application/json;charset=UTF-8",
	            Authorization: "Bearer " + _this.currentUser.access_token
	          },
	          data: {}
	        };
	      } else {
	        var addOpeningsData = {
	          method: "POST",
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + _this.event.subEvents[0].deduppedJobbles[0].id + "/rm-positions?format=json&conf=web&numberOfPositions=" + _this.openings,
	          headers: {
	            "Content-Type": "application/json;charset=UTF-8",
	            Authorization: "Bearer " + _this.currentUser.access_token
	          },
	          data: {}
	        };
	      }
	
	      _this.remain_loading_count++;
	
	      _this.$http(addOpeningsData).then(function (response) {
	        _this.remain_loading_count--;
	
	        _this.$timeout(function () {
	          $("#modal-add-openings .modal-header button.close").trigger("click");
	          _this.actions = "Add";
	          _this.multiopenings = null;
	          _this.openings = 1;
	        });
	
	        if (response.data.status !== "error") {
	          _this.event = response.data;
	          _this.$rootScope.$emit("SetEventToEventPages", {
	            event: _this.event,
	            openings: openings,
	            action: _this.actions
	          });
	        } else if (response.data.status === "error") {
	          _this.$timeout(function () {
	            alert(response.data.message) + ". Please contact support if having further issues.";
	          }, 300);
	        }
	      }, function (error) {
	        _this.remain_loading_count--;
	
	        _this.$timeout(function () {
	          $("#modal-add-openings .modal-header button.close").trigger("click");
	          _this.actions = "Add";
	          _this.multiopenings = null;
	          _this.openings = 1;
	        });
	
	        _this.$timeout(function () {
	          alert("There was error performing this action. Please refresh and try again.");
	        }, 400);
	      });
	    }
	  }, {
	    key: "checkVerificationStatus",
	    value: function checkVerificationStatus() {
	      var _this = this;
	
	      _this.remain_loading_count--;
	
	      _this.$auth.reloadCurrentUser();
	
	      _this.$timeout(function () {
	        _this.currentUser = _this.$auth.getUserData();
	      }, 1500);
	    }
	  }, {
	    key: "publishJob",
	    value: function publishJob() {
	      var _this = this;
	      var id = _this.event.subEvents[0].deduppedJobbles[0].id;
	      console.log("publish job");
	      console.dir(_this.publish_status);
	      var status = _this.publish_status;
	
	      if (status === false) {
	        status = true;
	      } else {
	        status = false;
	      }
	      _this.setLoader();
	      _this.$events.markJobblesAsPublished(id, _this.event, status).then(function (response) {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SuccessPublishEvent", {
	            event: _this.event,
	            status: status,
	            message: _this.publish_message
	          });
	        });
	      }, function (error) {
	        console.log("what was the error");
	        console.dir(error);
	        _this.unSetLoader();
	        _this.$timeout(function () {
	          alert("error publishing event : " + error.statusText);
	        });
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }]);
	
	  return EventdialogController;
	}();
	
	EventdialogController.$inject = ["$http", "$localStorage", "$state", "auth", "$rootScope", "$scope", "security", "events", "env", "$timeout", "tracking"];
	
	exports.default = EventdialogController;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(121);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventdialog.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventdialog.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".eventdialog{color:red}", ""]);
	
	// exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _paymentdialog = __webpack_require__(123);
	
	var _paymentdialog2 = _interopRequireDefault(_paymentdialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentdialogModule = _angular2.default.module("paymentdialog", [_angularUiRouter2.default, "cleave.js"]).component("paymentdialog", _paymentdialog2.default);
	
	exports.default = paymentdialogModule;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paymentdialog = __webpack_require__(124);
	
	var _paymentdialog2 = _interopRequireDefault(_paymentdialog);
	
	var _paymentdialog3 = __webpack_require__(125);
	
	var _paymentdialog4 = _interopRequireDefault(_paymentdialog3);
	
	__webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentdialogComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _paymentdialog2.default,
	  controller: _paymentdialog4.default,
	  controllerAs: "vm"
	};
	
	exports.default = paymentdialogComponent;

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports = "<a href=\"#modal-pick-card\" data-toggle=\"modal\" ng-hide=\"true\" id=\"link-modal-pick-card\"> </a>\n<div class=\"modal fade\" id=\"modal-pick-card\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header popup-header text-center\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times-circle\"></i>\n                        </button>\n                        <h3 class=\"modal-title\">Select a Card</h3>\n                    </div>\n                    <div class=\"modal-body\">\n                        <form class=\"clearfix\" ng-submit=\"vm.payForPostSubmit()\">\n                            <div class=\"job-table table-responsive respons-job\"\n                                 style=\"padding-left: 55px; padding-right: 55px\">\n                                <label style=\"margin: 18px 0 5px; color: #3b3f43; font-weight: 400; font-family: 'montserratregular'\"\n                                >Select a payment method</label\n                                >\n\n                                <table class=\"table\" style=\"color: #000\" ;>\n                                    <thead>\n                                    <tr>\n                                        <th></th>\n                                        <th style=\"text-align: center\">Name</th>\n                                        <th style=\"text-align: center\">Card Number</th>\n                                        <th style=\"text-align: center\">Nickname</th>\n                                    </tr>\n                                    </thead>\n                                    <tbody>\n                                    <tr\n                                            ng-repeat=\"paymentMethod in vm.paymentMethodsFormatted\"\n                                            ng-class=\"{ 'payment-method-selected' : paymentMethod.isChecked }\"\n                                    >\n                                        <td>\n                                            <input\n                                                    type=\"checkbox\"\n                                                    ng-checked=\"paymentMethod.isChecked\"\n                                                    ng-click=\"vm.selectPaymentMethod(paymentMethod)\"\n                                            />\n                                        </td>\n                                        <td>{{ paymentMethod.displayName }}</td>\n                                        <td>{{ paymentMethod.displayLast4 }}</td>\n                                        <td>{{ paymentMethod.displayNickName }}</td>\n                                    </tr>\n                                    </tbody>\n                                </table>\n                            </div>\n\n                            <input type=\"submit\" value=\"Use Card\" ng-disabled=\"vm.noPayInfo\"\n                                   class=\"btn button btn-success\"/>\n                        </form>\n                        <div class=\"row\" style=\"text-align: center; margin-top: 15px\">\n                            <a href=\"\" ng-click=\"vm.addCardFromPostingModal()\" style=\"text-decoration: underline\">Add\n                                new card</a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!-- /.modal-content -->\n    </div>\n    <!-- /.modal-dialog -->\n</div>\n\n<div class=\"modal fade\" id=\"explain-mirco-deposits\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header popup-header text-center\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times-circle\"></i>\n                        </button>\n                        <h3 class=\"modal-title\">Micro Deposits</h3>\n                    </div>\n                    <div class=\"modal-body\" style=\"text-align: left\">\n                        <p>\n                            You have just successfully created a bank account for ACH payments on Jobble. However, there\n                            is still one more step you\n                            need to take in order to send payments through the platform. Within the next 1-2 business\n                            days we will make a small Micro\n                            Deposit into your bank account. You will need to get those two micro deposits and verify\n                            them by clicking on the \"verify\"\n                            link on Payment Information page. Once those two amounts have been verified, you will be\n                            ready to send money.\n                        </p>\n                    </div>\n                    .\n                    <div class=\"modal-footer\" style=\"text-align: center\">\n                        <a class=\"btn button btn-success\" href=\"#\" data-dismiss=\"modal\">Continue</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!-- /.modal-content -->\n    </div>\n    <!-- /.modal-dialog -->\n</div>\n\n<a href=\"#modal-add-card\" data-toggle=\"modal\" ng-hide=\"true\" id=\"link-modal-add-card\"> </a>\n<div class=\"modal fade\" id=\"modal-add-card\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup payment-cards\" style=\"width: 456px;\">\n                <div class=\"modal-content account-modal-content\">\n                    <div class=\"modal-gradient-bar\"></div>\n                    <div class=\"modal-header popup-header text-center\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times\"></i>\n                        </button>\n\n                        <div class=\"modal-title\" ng-show=\"vm.saving_jobbler\">Add a debit card</div>\n                        <div class=\"modal-title\" ng-show=\"!vm.saving_jobbler\">Add a credit card</div>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"jobble-tip\" style=\"margin-bottom: 0px; display: none\"\n                             ng-if=\"!vm.payForPost && !vm.jobbler_params\">\n                            <h5>JOBBLE TIP</h5>\n                            <p>\n                                Before you can accept any Jobblers you must first put a credit card on file. This\n                                ensures that your selected Jobblers\n                                are paid quickly!\n                            </p>\n                        </div>\n\n                        <div>\n                            <div>\n                                <div class=\"input-label\">Name on Card</div>\n                                <input\n                                        name=\"\"\n                                        type=\"text\"\n                                        placeholder=\"John Doe\"\n                                        class=\"form-control form-input\"\n                                        ng-model=\"vm.credit_card_name\"\n                                        ng-change=\"vm.handleCreditCardNameChange()\"\n                                        ng-style=\"vm.validation.credit_card_name.style\"\n                                />\n                            </div>\n\n                            <div>\n                                <div class=\"input-label\">Street Address</div>\n                                <input\n                                        name=\"\"\n                                        type=\"text\"\n                                        placeholder=\"123, Main St.\"\n                                        ng-model=\"vm.street\"\n                                        class=\"form-control form-input\"\n                                        ng-change=\"vm.handleStreetChange()\"\n                                        ng-style=\"vm.validation.street.style\"\n                                />\n                            </div>\n\n\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1; padding-right: 32px\">\n                                    <div class=\"input-label\">City</div>\n                                    <input\n                                            name=\"\"\n                                            type=\"text\"\n                                            placeholder=\"Boston\"\n                                            ng-model=\"vm.city\"\n                                            class=\"form-control form-input\"\n                                            ng-change=\"vm.handleCityChange()\"\n                                            ng-style=\"vm.validation.city.style\"\n                                    />\n                                </div>\n                                <div style=\"flex: 1\">\n                                    <div class=\"input-label\">State</div>\n                                    <select\n                                            ng-model=\"vm.state\"\n                                            ng-options=\"state for state in vm.stateList\"\n                                            class=\"form-control form-input\"\n                                            ng-change=\"vm.handleStateChange()\"\n                                            ng-style=\"vm.validation.state.style\"\n                                    ></select>\n                                </div>\n                            </div>\n\n                            <div>\n                                <div class=\"input-label\">Zip code</div>\n                                <input\n                                        name=\"\"\n                                        type=\"text\"\n                                        placeholder=\"01234\"\n                                        ng-model=\"vm.zipCode\"\n                                        class=\"form-control form-input\"\n                                        ng-change=\"vm.handleZipCodeChange()\"\n                                        ng-style=\"vm.validation.zipCode.style\"\n                                />\n                            </div>\n\n                            <div>\n                                <div class=\"input-label\">Card Number</div>\n                                <input\n                                        name=\"\"\n                                        type=\"text\"\n                                        placeholder=\"**** **** **** ****\"\n                                        class=\"form-control form-input\"\n                                        ng-model=\"vm.displayCardNumber\"\n                                        cleave=\"vm.cardNumberFormatting\"\n                                        ng-style=\"vm.validation.cardNumber.style\"\n                                />\n                            </div>\n\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1; display: flex; padding-right: 32px;\">\n                                    <div style=\"flex: 1; padding-right: 16px\">\n                                        <div class=\"input-label\">Exp. Month</div>\n                                        <select\n                                                class=\"form-control form-input\"\n                                                ng-model=\"vm.expMonths.value\"\n                                                ng-options=\"type for type in vm.expMonths.values\"\n                                                ng-change=\"vm.handleExpirationDateChange()\"\n                                                ng-style=\"vm.validation.expDate.style\"></select>\n                                    </div>\n                                    <div style=\"flex: 1\">\n                                        <div class=\"input-label\">Exp. Year</div>\n                                        <select\n                                                class=\"form-control form-input\"\n                                                ng-model=\"vm.expYears.value\"\n                                                ng-options=\"type for type in vm.expYears.values\"\n                                                ng-change=\"vm.handleExpirationDateChange()\"\n                                                ng-style=\"vm.validation.expDate.style\"></select>\n                                    </div>\n\n                                </div>\n                                <div style=\"flex: 1\">\n                                    <div class=\"input-label\">Security code</div>\n                                    <input\n                                            name=\"\"\n                                            type=\"password\"\n                                            placeholder=\"XXX\"\n                                            ng-model=\"vm.cvc\"\n                                            class=\"form-control form-input\"\n                                            ng-change=\"vm.handleCVCChange()\"\n                                            ng-style=\"vm.validation.cvc.style\"\n                                    />\n                                </div>\n                            </div>\n\n                            <!--\n                            <div class=\"row\" ng-if=\"vm.currentUser.company.billingContactInfo.email && vm.currentUser.company.id\">\n                                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                    <div class=\"input-label\">Billing Contact Email (for invoices)</div>\n                                    <p>{{ vm.currentUser.company.billingContactInfo.email }}</p>\n                                </div>\n                            </div>\n                            -->\n\n                            <div class=\"row\" ng-if=\"vm.currentUser.company.id\">\n                                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                    <div class=\"input-label\">Billing Contact Email</div>\n                                    <span class=\"billing-email-error\" ng-if=\"vm.billingEmailErrorText\">{{vm.billingEmailErrorText}}</span>\n                                    <input type=\"email\"\n                                           ng-model=\"vm.billingEmail\"\n                                           ng-change=\"vm.validateBillingEmailInput(vm.billingEmail)\"\n                                           placeholder=\"xyz@jobble.com\"\n                                           class=\"form-control form-input\"\n                                           ng-class=\"{'billing-email-error' : vm.billingEmailError }\"/>\n                                </div>\n                            </div>\n\n                            <div class=\"row\" style=\"display: none\">\n                                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                    <label>Card Nickname (optional)</label>\n                                    <input type=\"text\" ng-model=\"vm.nickname\" placeholder=\"Kevins card\"\n                                           class=\"form-control form-input\"/>\n                                </div>\n                            </div>\n\n                            <div class=\"account-gradient-button\" style=\"width: 100%; text-align: center\"\n                                 ng-click=\"vm.createCard()\">Save Card\n                            </div>\n\n                            <div>\n                                <div ng-show=\"vm.validateCardError\" class=\"alert-box\"\n                                     style=\"margin-bottom: 16px; margin-top: 16px\">\n                                    {{vm.validateCardErrorMessage}} <span\n                                        ng-class=\"{hidden: !(vm.validation.expDate && vm.validation.expDate.message && vm.validation.expDate.message.length)}\">{{vm.validation.expDate.message}}</span>\n                                </div>\n                            </div>\n                            </form>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!-- /.modal-content -->\n    </div>\n    <!-- /.modal-dialog -->\n</div>\n\n\n<div class=\"modal fade\" id=\"modal-add-account\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\" style=\"width: 456px;\">\n                <div class=\"modal-content account-modal-content\">\n                    <div class=\"modal-gradient-bar\"></div>\n\n                    <div class=\"modal-header popup-header text-center\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times\"></i>\n                        </button>\n                        <div class=\"modal-title\">Link bank account</div>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"jobble-tip\" style=\"display: none\"\n                             ng-if=\"!vm.setWarningForCustomer && !vm.jobbler_params\">\n                            <h5>JOBBLE TIP</h5>\n                            <p>\n                                Before you can accept any Jobblers you must first put a payment method on file. This\n                                ensures that your selected\n                                Jobblers are paid quickly!\n                            </p>\n                        </div>\n\n                        <div class=\"jobble-tip\" ng-if=\"vm.setWarningForCustomer\"\n                             style=\"text-align: left; display: none\">\n                            <p>Add your name, account number, and routing number in the form below.</p>\n\n                            <p style=\"margin-bottom: 0px\">Deposits within 7 business days / No processing fee</p>\n                            <!--\n                            <h5 style=\"margin-bottom:2px;\">2. Find micro-deposits</h5>\n                            <p style=\"margin-bottom: 10px;\">Check your bank account for two micro deposits.</p>\n                            <h5 style=\"margin-bottom:2px;\">2. Enter micro-deposits</h5>\n                            <p style=\"margin-bottom: 10px;\">Click the verify button to enter the micro deposits</p>\n                            -->\n                        </div>\n\n                        <div>\n                            <div ng-show=\"vm.validateCardError\" class=\"alert-box\" style=\"margin-top: 10px\">\n                                {{vm.validateCardErrorMessage}}\n                            </div>\n\n                            <div ng-show=\"vm.bankTokenError\" class=\"alert-box\" style=\"margin-top: 10px\">\n                                {{vm.bankTokenError}}\n                            </div>\n\n                            <div>\n                                <div class=\"input-label\">Account holder name</div>\n                                <input\n                                        name=\"\"\n                                        type=\"text\"\n                                        placeholder=\"Jobble Inc.\"\n                                        ng-model=\"vm.accountHolderName\"\n                                        ng-change=\"vm.bankDataChanging()\"\n                                        class=\"form-control form-input\"\n                                />\n                            </div>\n\n                            <div>\n                                <div class=\"input-label\">Account Number</div>\n                                <input\n                                        name=\"\"\n                                        type=\"text\"\n                                        placeholder=\"000123456789\"\n                                        ng-model=\"vm.accountNumber\"\n                                        ng-change=\"vm.bankDataChanging()\"\n                                        class=\"form-control form-input\"\n                                />\n                            </div>\n\n                            <div>\n                                <div class=\"input-label\">Routing Number</div>\n                                <input\n                                        name=\"\"\n                                        type=\"text\"\n                                        placeholder=\"110000000\"\n                                        ng-model=\"vm.routingNumber\"\n                                        ng-change=\"vm.bankDataChanging()\"\n                                        class=\"form-control form-input\"\n                                />\n                            </div>\n\n                            <div class=\"row\"\n                                 ng-if=\"vm.currentUser.company.id\">\n                                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                    <div class=\"input-label\">Billing Contact Email</div>\n                                    <span class=\"billing-email-error\" ng-if=\"vm.billingEmailErrorText\">{{vm.billingEmailErrorText}}</span>\n                                    <input type=\"email\"\n                                           ng-model=\"vm.billingEmail\"\n                                           placeholder=\"xyz@jobble.com\"\n                                           ng-change=\"vm.validateBillingEmailInput(vm.billingEmail)\"\n                                           class=\"form-control form-input\"\n                                           ng-class=\"{'billing-email-error' : vm.billingEmailError }\"/>\n                                </div>\n                            </div>\n\n                            <button class=\"account-gradient-button\"\n                                    ng-class=\"{'disabled': vm.isSaveBankAccountDisabled}\"\n                                    style=\"width: 100%; text-align: center\"\n                                    ng-click=\"vm.createBankAccount()\" ng-disabled=\"vm.isSaveBankAccountDisabled\">\n                                Save bank account\n                            </button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!-- /.modal-content -->\n    </div>\n    <!-- /.modal-dialog -->\n</div>\n\n<div class=\"modal fade\" id=\"modal-add-ach\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <span aria-hidden=\"true\">&times;</span>\n                        </button>\n                        <h4 class=\"modal-title\">Add an ACH</h4>\n                    </div>\n                    <div class=\"modal-body\">\n                        <p>\n                            <strong\n                            >Before you can accept jobblers to your first jobble you must first set your ACH payment\n                                details. This ensures that\n                                your selected jobblers are paid quickly.</strong\n                            >\n                        </p>\n                        <form action=\"#\" method=\"post\" class=\"clearfix\">\n                            <div class=\"cardinput-col\">\n                                <label>account number</label>\n                                <input name=\"\" type=\"text\" placeholder=\"123409876511\"/>\n                            </div>\n                            <div class=\"cardinput-col last\">\n                                <label>Routing number</label>\n                                <input name=\"\" type=\"text\" placeholder=\"122105155\"/>\n                            </div>\n                            <p>\n                                <strong>A text that explains the verification process goes here.</strong>\n                            </p>\n                            <input type=\"submit\" value=\"Submit\"/>\n                        </form>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!-- /.modal-content -->\n    </div>\n    <!-- /.modal-dialog -->\n</div>\n\n<div class=\"modal fade\" id=\"modal-acc-verify\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <span aria-hidden=\"true\">&times;</span>\n                        </button>\n                        <h4 class=\"modal-title\">Verify Your Account</h4>\n                    </div>\n                    <div class=\"modal-body\">\n                        <p>\n                            <strong>Look at your bank account and report the two amounts Jobble transferred to\n                                you.</strong>\n                        </p>\n                        <form action=\"#\" method=\"post\" class=\"clearfix\">\n                            <div class=\"cardinput-col\">\n                                <label>Transfer Amount #1</label>\n                                <input name=\"\" type=\"text\" placeholder=\"$\"/>\n                            </div>\n                            <div class=\"cardinput-col last\">\n                                <label>Transfer Amount #2</label>\n                                <input name=\"\" type=\"text\" placeholder=\"$\"/>\n                            </div>\n                            <input type=\"submit\" value=\"Verify\"/>\n                        </form>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!-- /.modal-content -->\n    </div>\n    <!-- /.modal-dialog -->\n</div>\n\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n\n<div class=\"modal fade\" id=\"modal-del-card\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\" style=\"width: 456px;\">\n                <div class=\"modal-content account-modal-content\">\n                    <div class=\"modal-gradient-bar\"></div>\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n                        </button>\n                        <div class=\"modal-title\">Delete Card</div>\n                        <div class=\"modal-text\"> Are you sure you want to delete this credit card?</div>\n                    </div>\n\n                    <div class=\"modal-body\">\n                        <div style=\"display: flex\">\n                            <div style=\"flex: 1; padding-right: 8px\">\n                                <div class=\"account-outline-button\" style=\"text-align: center; width: 100%\"\n                                     ng-click=\"vm.cancelCardRemove()\">No\n                                </div>\n                            </div>\n                            <div style=\"flex: 1\">\n                                <div class=\"account-gradient-button\" style=\"text-align: center; width: 100%\"\n                                     ng-click=\"vm.removeCard()\">Yes\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal fade\" id=\"modal-del-bank\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\" style=\"width: 456px;\">\n                <div class=\"modal-content account-modal-content\">\n                    <div class=\"modal-gradient-bar\"></div>\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n                        </button>\n\n                        <div class=\"modal-title\">Delete Bank Account</div>\n                        <div class=\"modal-text\"> Are you sure you want to delete this bank account?</div>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div style=\"display: flex\">\n                            <div style=\"flex: 1; padding-right: 8px\">\n                                <div class=\"account-outline-button\" style=\"text-align: center; width: 100%\"\n                                     ng-click=\"vm.cancelCardRemove()\">No\n                                </div>\n                            </div>\n                            <div style=\"flex: 1\">\n                                <div class=\"account-gradient-button\" style=\"text-align: center; width: 100%\"\n                                     ng-click=\"vm.removeBank()\" ng-disabled=\"vm.removingBank\">Yes\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal fade\" id=\"minimum-card\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\" style=\"width: 400px;\">\n                <div class=\"modal-content account-modal-content\">\n                    <div class=\"modal-gradient-bar\"></div>\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n                        </button>\n                        <div class=\"modal-title\">Payment Information Required</div>\n                        <div class=\"modal-text\">You must have at least one payment method on file. Please add another\n                            payment method before deleting this one.\n                        </div>\n                    </div>\n\n                    <div class=\"modal-body\">\n                        <div style=\"display: flex\">\n                            <div style=\"flex: 1; padding-right: 8px\">\n                                <div class=\"account-outline-button\" style=\"text-align: center; width: 100%\"\n                                     ng-click=\"vm.closeMinimumModal()\">Dismiss\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal fade\" id=\"missing-payment-info\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\" style=\"width: 400px;\">\n                <div class=\"modal-content account-modal-content\">\n                    <div class=\"modal-gradient-bar\"></div>\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n                        </button>\n                        <div class=\"modal-title\">Payment Information Required</div>\n                        <div class=\"modal-text\">Your job has been created but has not been published. In order to have\n                            your job published to our job board you must add a payment method to your account. Click\n                            below to add this information.\n                        </div>\n                    </div>\n\n                    <div class=\"modal-body\">\n                        <div style=\"display: flex\">\n                            <div style=\"flex: 1; padding-right: 8px\">\n                                <div class=\"account-gradient-button\" style=\"text-align: center; width: 100%\"\n                                     ng-click=\"vm.goToSettings()\">{{vm.getSettingsCTA()}}\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal fade\" id=\"is-not-verified\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\" style=\"width: 400px;\">\n                <div class=\"modal-content account-modal-content\">\n                    <div class=\"modal-gradient-bar\"></div>\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n                        </button>\n                        <div class=\"modal-title\">Verification Required</div>\n                        <div class=\"modal-text\">Your job has been created but has not been published. In order to have\n                            your job published to our job board your company needs to be verified. Click below to\n                            complete your profile.\n                        </div>\n                    </div>\n\n                    <div class=\"modal-body\">\n                        <div style=\"display: flex\">\n                            <div style=\"flex: 1; padding-right: 8px\">\n                                <div class=\"account-gradient-button\" style=\"text-align: center; width: 100%\"\n                                     ng-click=\"vm.goToSettings()\">Account Profile\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal fade\" id=\"modal-verify-bank\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\" style=\"width: 456px;\">\n                <div class=\"modal-content account-modal-content\">\n                    <div class=\"modal-gradient-bar\"></div>\n                    <div class=\"modal-header text-center\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n                        </button>\n\n                        <div class=\"modal-title\">Verify Bank Account</div>\n                        <div class=\"modal-text\">\n                            After 1-2 business days, Jobble will send two small deposits to this bank account.<br/>\n                            <br/>\n                            <!--\n                            <img src=\"/app/vendor/images/jobble-micro-deposits.png\" />\n                            -->\n                            To verify this account, please confirm the amounts of these deposits.<br/>\n                            <br/>\n                            <span style=\"color: #f00\">Please be aware the decimal is not required. For example, a deposit of $0.84 should be entered as \"84\"</span>\n                        </div>\n\n                    </div>\n                    <div class=\"modal-body\">\n                        <div\n                                ng-show=\"vm.validateBankError\"\n                                class=\"notify-error notify\"\n                                style=\"\n                                background-color: rgb(204, 3, 3);\n                                color: #fff;\n                                background-color: rgb(204, 3, 3);\n                                border-radius: 0;\n                                margin: 10px 0;\n                                padding: 8px 16px;\n                            \"\n                        >\n                            <p style=\"color: #fff; padding-top: 8px\">{{vm.validateBankErrorMessage}}</p>\n                        </div>\n\n                        <div style=\"display: flex\">\n                            <div style=\"flex: 1; padding-right: 32px\">\n                                <div class=\"input-label\">First deposit</div>\n                                <input type=\"text\" placeholder=\"32\" class=\"form-control form-input\"\n                                       ng-model=\"vm.amount1\" step=\"1\" ng-change=\"vm.formatMicroDeposit(1,vm.amount1)\"/>\n                            </div>\n                            <div style=\"flex: 1\">\n                                <div class=\"input-label\">Second deposit</div>\n                                <input type=\"text\" placeholder=\"45\" class=\"form-control form-input\"\n                                       ng-model=\"vm.amount2\" step=\"1\" ng-change=\"vm.formatMicroDeposit(2,vm.amount2)\"/>\n                            </div>\n                        </div>\n                        <button class=\"account-gradient-button\" ng-class=\"{'disabled': !vm.amount1 || !vm.amount2}\"\n                                ng-disabled=\"!vm.amount1 || !vm.amount2\" style=\"width: 100%; text-align: center\"\n                                ng-click=\"vm.verifyBankAccount()\">Verify\n                        </button>\n\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal fade\" id=\"modal-del-acc\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <span aria-hidden=\"true\">&times;</span>\n                        </button>\n                        <strong\n                        >This will be permanently delete your ACH account.\n                            <br/>\n                            Are you sure?</strong\n                        >\n                    </div>\n                    <div class=\"modal-body\">\n                        <a class=\"btn\" href=\"#\">Confirm</a>\n                        <a class=\"btn\" href=\"account-profile.html\">No</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal fade\" id=\"explain-payment-info\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <span aria-hidden=\"true\">&times;</span>\n                        </button>\n                        <h3 class=\"modal-title\">Payment Method Confirmation</h3>\n                    </div>\n                    <div class=\"modal-body\">\n                        <p>\n                            {{vm.explaination_text}}\n                            <a href=\"https://intercom.help/jobble/en/articles/2065572-is-direct-deposit-the-only-option\"\n                               target=\"_blank\">here</a>.\n                        </p>\n                    </div>\n                    <div class=\"modal-footer text-center\" style=\"text-align: center\">\n                        <a class=\"btn button btn-success\" href=\"\" data-dismiss=\"modal\">Sounds good</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _creditCard = __webpack_require__(126);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PaymentdialogController = function () {
	  function PaymentdialogController($http, $localStorage, $location, $state, AuthService, $httpParamSerializerJQLike, SecurityService, CompanyService, $rootScope, $scope, $timeout, EnvService, validation, $window) {
	    var _this2 = this;
	
	    _classCallCheck(this, PaymentdialogController);
	
	    this.name = "paymentdialog";
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	    this.$security = SecurityService;
	    this.$companies = CompanyService;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.$location = $location;
	    this.$env = EnvService;
	    this.$window = $window;
	    this.currentUser = this.$auth.getUserData();
	    this.cardNumber = "";
	    this.displayCardNumber = "";
	    this.expDate = "";
	    this.cvc = "";
	    this.noPayInfo = true;
	    this.street = "";
	    this.city = "";
	    this.removingBank = false;
	    this.state = "--";
	    this.zipCode = "";
	    this.countries = ["USA"];
	    this.bankTypes = ["Company", "Individual"];
	    this.validateCardError = false;
	    this.validateCardErrorMessage = "";
	    this.isSaveBankAccountDisabled = true;
	    this.isCreditCardDisabled = false;
	    this.newBankAccount = {
	      bank_account: {
	        country: "us",
	        currency: "usd",
	        account_holder_name: null,
	        account_holder_type: "company",
	        routing_number: null,
	        account_number: null
	      }
	    };
	
	    this.remain_loading_count = 0;
	
	    if (this.currentUser && this.currentUser.company) {
	      if (!this.currentUser.company.paymentInfos && this.currentUser.company.undeletedPaymentInfos) {
	        this.currentUser.company.paymentInfos = this.currentUser.company.undeletedPaymentInfos;
	        this.$localStorage.logged_user.company.paymentInfos = this.currentUser.company.undeletedPaymentInfos;
	      }
	    }
	
	    if (this.currentUser && this.currentUser.company && this.currentUser.company.undeletedPaymentInfos) {
	      this.paymentOptionsCounts = this.currentUser.company.undeletedPaymentInfos.length;
	      this.paymentInfos = this.currentUser.company.undeletedPaymentInfos;
	    } else {
	      this.paymentOptionsCounts = 0;
	    }
	
	    var _this = this;
	
	    this.cardsArray = [];
	    this.banksArray = [];
	
	    if (this.currentUser) {
	      this.organizePaymentInfo();
	      this.billingEmail = this.currentUser.company.billingContactInfo.email;
	    }
	
	    var thisYear = new Date().getFullYear();
	    var allYears = [thisYear.toString()];
	
	    for (var i = 1; i < 15; i++) {
	      allYears.push((thisYear + i).toString());
	    }
	    //thisMonth = thisMonth + 1;
	    this.stateList = ["--", "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"];
	
	    this.expYears = { value: thisYear.toString(), values: allYears };
	    //this.expMonths = { "value" : thisMonth.toString(), "values" : monthsForDropDrown };
	    this.expMonths = {
	      value: "01",
	      values: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
	    };
	
	    this.SetCreditCardListener = this.$rootScope.$on("SetCreditCard", function ($event, params) {
	      _this.selectedCreditCard = _this.cardsArray[params.index];
	      _this.selectedCreditCardIndex = params.index;
	    });
	
	    this.SetBankAccountListener = this.$rootScope.$on("SetBankAccount", function ($event, params) {
	      if (params.selectedBank) {
	        _this.selectedBankAccount = params.selectedBank;
	        _this.$timeout(function () {
	          $("#modal-verify-bank").modal();
	        });
	      } else {
	        if (params.banks) {
	          _this.selectedBankAccount = params.banks[params.index];
	        } else {
	          _this.selectedBankAccount = _this.banksArray[params.index];
	        }
	      }
	
	      _this.selectedBankAccountIndex = params.index;
	
	      if (params.banks && params.banks.length > 0) {
	        params.banks.forEach(function (bank) {
	          if (bank.id === _this.selectedBankAccount.id) {
	            if (bank.setupIntentId) {
	              _this.selectedBankAccount.setupIntentId = bank.setupIntentId;
	            }
	          }
	        });
	      }
	    });
	
	    this.SetPayForPostDataListener = this.$rootScope.$on("SetPayForPostData", function ($event, params) {
	      _this.event_for_pay = params.event;
	
	      if (params.cards) {
	        _this.listCards();
	        _this.payForPost = true;
	      } else {
	        _this.payForPost = true;
	      }
	    });
	
	    this.SetWarningForRDSCustomerListener = this.$rootScope.$on("SetWarningForRDSCustomer", function ($event, params) {
	      _this.setPopupForRDS();
	    });
	
	    this.ClearPayInfoListener = this.$rootScope.$on("ClearPayInfo", function ($event, params) {
	      _this.clearPayInfo();
	      _this.setFocusOnForm();
	      _this.state = "--";
	      console.log("validator");
	      console.dir(_this.$validation);
	      _this.$validation.Errors = {};
	    });
	
	    this.SettingBankForJobblerListener = this.$rootScope.$on("SettingBankForJobbler", function ($event, params) {
	      _this.jobbler_params = params;
	      _this.saving_jobbler = true;
	      _this.isSaveBankAccountDisabled = false;
	      _this.isCreditCardDisabled = false;
	    });
	
	    _this.$scope.$on("$destroy", _this.SettingBankForJobblerListener);
	    _this.$scope.$on("$destroy", _this.ClearPayInfoListener);
	    _this.$scope.$on("$destroy", _this.SetWarningForRDSCustomerListener);
	    _this.$scope.$on("$destroy", _this.SetPayForPostDataListener);
	    _this.$scope.$on("$destroy", _this.SetCreditCardListener);
	    _this.$scope.$on("$destroy", _this.SetBankAccountListener);
	
	    this.$validation = validation;
	    this.validation = {};
	
	    // Prevent validation before the user starts typing
	    this.canValidate = false;
	    this.$timeout(function () {
	      return _this2.canValidate = true;
	    }, 1000);
	
	    this.cardNumberFormatting = {
	      creditCard: true,
	      delimiter: "-",
	      onValueChanged: function onValueChanged(e) {
	        _this2.cardNumber = e.target.rawValue.trim();
	        _this2.handleCardNumberChange();
	      }
	    };
	  }
	
	  _createClass(PaymentdialogController, [{
	    key: "loopThroughPaymentInfo",
	    value: function loopThroughPaymentInfo() {
	      var _this = this;
	
	      _this.setLoader();
	
	      var cardLoop = function cardLoop(value) {
	        _this.$timeout(function () {
	          if (value > 0) {
	            _this.currentUser = _this.$auth.validateUserByTokenWeb(_this.currentUser.access_token).then(function (r) {
	              _this.$localStorage.logged_user = r.data;
	              _this.currentUser = r.data;
	              _this.currentUser.company.paymentInfos = _this.currentUser.company.undeletedPaymentInfos;
	              if (_this.currentUser.company.paymentInfos.length === _this.paymentOptionsCounts + 1) {
	                _this.unSetLoader();
	                _this.remain_loading_count = 0;
	                //jQuery("#modal-add-account .modal-header button.close").trigger("click");
	                _this.$timeout(function () {
	                  _this.paymentOptionsCounts = _this.paymentOptionsCounts + 1;
	                  _this.reloadBankAccounts();
	                  return;
	                }, 100);
	              } else {
	                cardLoop(value - 1);
	              }
	            });
	          } else {
	            _this.remain_loading_count = 0;
	            _this.unSetLoader();
	            jQuery("#modal-add-account .modal-header button.close").trigger("click");
	            _this.$timeout(function () {
	              alert("Please give the system a moment to update your payment information. Please check back in a couple minutes.");
	              return;
	            }, 300);
	          }
	        }, 1000);
	      };
	      cardLoop(3);
	    }
	
	    //stripeFcaId
	
	  }, {
	    key: "saveCustomerToJobbleAPI",
	    value: function saveCustomerToJobbleAPI(response) {
	      var _this = this;
	      _this.setLoader();
	
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/save-customer?format=json&conf=web&isBankToken=true",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.currentUser.access_token
	        },
	        data: {
	          username: _this.currentUser.username,
	          stripeToken: response.data.id
	        }
	      };
	
	      //_this.remain_loading_count++;
	      _this.$http(req).then(function (res) {
	        if (res.data.status !== "error") {
	          _this.$timeout(function () {
	            jQuery("#modal-add-account .modal-header button.close").trigger("click");
	          });
	          _this.routingNumber = undefined;
	          _this.accountNumber = undefined;
	          _this.accountHolderName = undefined;
	          _this.isSaveBankAccountDisabled = true;
	          _this.loopThroughPaymentInfo();
	        } else {
	          _this.validateCardError = true;
	          _this.validateCardErrorMessage = res.data.message;
	          _this.isSaveBankAccountDisabled = false;
	        }
	        _this.unSetLoader();
	      }, function (res) {
	        _this.validateCardError = true;
	        _this.validateCardErrorMessage = res.datas.message;
	        _this.isSaveBankAccountDisabled = false;
	        _this.unSetLoader();
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetRegisterCardStatus", {
	            status: 2
	          });
	        });
	        //_this.remain_loading_count--;
	      });
	    }
	  }, {
	    key: "createBankAccount",
	    value: function createBankAccount() {
	      var _this = this;
	
	      _this.setLoader();
	      _this.isSaveBankAccountDisabled = true;
	      _this.newBankAccount.bank_account.account_holder_name = _this.accountHolderName;
	      _this.newBankAccount.bank_account.routing_number = _this.routingNumber;
	      _this.newBankAccount.bank_account.account_number = _this.accountNumber;
	
	      if (_this.saving_jobbler) {
	        _this.createRecipient();
	        return;
	      }
	
	      var billingValidate = void 0;
	
	      if (!this.billingEmail) {
	        _this.unSetLoader();
	        _this.isSaveBankAccountDisabled = false;
	        alert("A contact email is required for saving payment information. This email is used for sending invoices and also as a point of contact for our operations team.");
	        return;
	      } else {
	        billingValidate = this.validateBillingContactEmail();
	        if (billingValidate.error === true) {
	          _this.unSetLoader();
	          _this.isSaveBankAccountDisabled = false;
	          alert(billingValidate.errorText);
	          return;
	        }
	      }
	
	      var req = {
	        method: "POST",
	        url: "https://api.stripe.com/v1/tokens",
	        headers: {
	          "Content-Type": "application/x-www-form-urlencoded",
	          Authorization: "Bearer " + _this.$env.EnvironmentConfig.stripeKey
	        },
	        data: this.$httpParamSerializerJQLike(_this.newBankAccount)
	      };
	
	      this.$http(req).then(function (response) {
	        _this.$timeout(function () {
	          _this.saveCustomerToJobbleAPI(response);
	        }, 1000);
	        _this.validateCardError = false;
	        _this.unSetLoader();
	        //_this.remain_loading_count--;
	      }, function (res) {
	        _this.validateCardError = true;
	        _this.validateCardErrorMessage = res.data.error.message;
	        _this.unSetLoader();
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetRegisterCardStatus", {
	            status: 2
	          });
	        });
	      });
	    }
	  }, {
	    key: "validateBillingContactEmail",
	    value: function validateBillingContactEmail() {
	      var result = {};
	
	      var EMAILREGEX = /^([!#$%&*+-\/=?^`'|{}~\w_.]{1,64}?)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	      if (this.billingEmail.indexOf("@") !== -1) {
	        if (!EMAILREGEX.test(this.billingEmail)) {
	          this.billingEmailError = true;
	          this.billingEmailErrorText = "The email you have entered is not properly formatted";
	        } else if (this.billingEmail.indexOf("jobble.com") !== -1 || this.billingEmail.indexOf("jobbleapp.com") !== -1) {
	          this.billingEmailError = true;
	          this.billingEmailErrorText = "The domain of the billing contact email cannot contain jobble.com or jobbleapp.com";
	          result.error = true;
	          result.errorText = "The domain of the billing contact email cannot contain jobble.com or jobbleapp.com";
	        } else {
	          result.error = false;
	          this.billingEmailError = false;
	          this.billingEmailErrorText = null;
	        }
	      }
	
	      return result;
	    }
	  }, {
	    key: "validateBillingEmailInput",
	    value: function validateBillingEmailInput(e) {
	      this.billingEmailErrorText = null;
	
	      var result = {};
	
	      var EMAILREGEX = /^([!#$%&*+-\/=?^`'|{}~\w_.]{1,64}?)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	      if (this.billingEmail) {
	        if (this.billingEmail.indexOf("@") !== -1) {
	          if (!EMAILREGEX.test(this.billingEmail)) {
	            this.billingEmailError = true;
	            this.billingEmailErrorText = "The email you have entered is not properly formatted";
	          } else if (this.billingEmail.indexOf("jobble.com") !== -1 || this.billingEmail.indexOf("jobbleapp.com") !== -1) {
	            this.billingEmailError = true;
	            this.billingEmailErrorText = "The domain of the billing contact email cannot contain jobble.com or jobbleapp.com";
	            result.error = true;
	            result.errorText = "The domain of the billing contact email cannot contain jobble.com or jobbleapp.com";
	          } else {
	            result.error = false;
	            this.billingEmailError = false;
	            this.billingEmailErrorText = null;
	          }
	        }
	      }
	
	      return result;
	    }
	  }, {
	    key: "bankDataChanging",
	    value: function bankDataChanging() {
	      var _this = this;
	
	      if (!_angular2.default.isUndefined(_this.accountHolderName) && !_angular2.default.isUndefined(_this.routingNumber) && !_angular2.default.isUndefined(_this.accountNumber)) {
	        if (/^\w{1,17}$/.test(_this.accountNumber) && _this.routingNumber.length === 9) {
	          _this.isSaveBankAccountDisabled = false;
	        } else {
	          _this.isSaveBankAccountDisabled = true;
	        }
	      }
	    }
	  }, {
	    key: "createRecipient",
	    value: function createRecipient() {
	      var _this = this;
	      //_this.setLoader();
	      var data = _this.jobbler_params.data;
	      var pl = null;
	      _this.bankTokenError = null;
	      if (data.type === "card") {
	        pl = {
	          card: {
	            number: _this.cardNumber,
	            exp_month: _this.expMonths.value,
	            exp_year: _this.expYears.value,
	            cvc: _this.cvc,
	            address_line1: _this.street,
	            address_city: _this.city,
	            address_state: _this.state,
	            address_zip: _this.zipCode,
	            currency: "usd"
	          }
	        };
	      } else {
	        pl = {
	          bank_account: {
	            country: "us",
	            currency: "usd",
	            account_holder_name: _this.accountHolderName,
	            account_holder_type: "individual",
	            routing_number: _this.routingNumber,
	            account_number: _this.accountNumber
	          }
	        };
	      }
	
	      _this.$security.getToken(pl).then(function (response) {
	        console.log("in response from get token");
	        console.dir(response);
	        _this.saveRecipient(response.data, pl, data.type);
	      }, function (error) {
	        console.log("in error");
	        console.dir(error);
	        _this.handleRecipientError(error);
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "handleRecipientError",
	    value: function handleRecipientError(response) {
	      var _this = this;
	      if (response.data.error) {
	        _this.bankTokenError = response.data.error.message;
	      } else {
	        _this.bankTokenError = "There was an issue saving your payment information. Please contact an administrator.";
	      }
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "saveRecipient",
	    value: function saveRecipient(data, payment_info, type) {
	      var _this = this;
	      var pl = {};
	
	      if (type === "card") {
	        pl.username = _this.currentUser.username;
	        pl.stripeToken = data.id;
	        pl.paymentMethod = "card";
	        pl.country = "us";
	        pl.currency = "usd";
	      } else {
	        pl.username = _this.currentUser.username;
	        pl.stripeToken = data.id;
	        pl.paymentMethod = "bank_account";
	      }
	
	      _this.$security.saveRecipient(pl).then(function (response) {
	        var data = {};
	
	        if (response.data.status === "error") {
	          console.error(response);
	          data.response = response;
	          data.error = true;
	          _this.unSetLoader();
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("GetNewPaymentInfo", { data: data });
	          });
	        } else {
	          data.response = response.data;
	          _this.unSetLoader();
	          if (type == "card") {
	            data.card = true;
	          } else {
	            data.card = false;
	          }
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("GetNewPaymentInfo", { data: data });
	          });
	          _this.displayInformativeModal(type, response);
	        }
	      }, function (error) {
	        console.log("in error for saving recipient");
	        console.dir(error);
	        _this.unSetLoader();
	        alert("There was a fatal error. Please contact an administrator.");
	      });
	    }
	  }, {
	    key: "displayInformativeModal",
	    value: function displayInformativeModal(type, resp) {
	      var _this = this;
	      console.log("display modal");
	      console.dir(type);
	      console.dir(_this.currentUser);
	      console.dir(resp);
	      _this.$timeout(function () {
	        _this.unSetLoader();
	      }, 2000);
	      var text = null;
	      //https://intercom.help/jobble/en/articles/2065572-is-direct-deposit-the-only-option
	      if (type == "bank") {
	        text = "We have added your bank account as your primary method for receiving funds. Please learn more about the different types of payment methods ";
	      } else {
	        text = "We have added your debit card as your primary method for receiving funds. Please learn more about the different types of payment methods ";
	      }
	      _this.explaination_text = text;
	      _this.$timeout(function () {
	        $("#explain-payment-info").modal();
	      }, 2000);
	    }
	  }, {
	    key: "validateField",
	    value: function validateField(field, value, validateMethod, constructErrorMessage) {
	      var _this3 = this;
	
	      constructErrorMessage = constructErrorMessage ? constructErrorMessage : function () {
	        return "";
	      };
	
	      var _validateMethod = validateMethod(value),
	          isValid = _validateMethod.isValid,
	          errors = _validateMethod.errors;
	
	      if (this.canValidate) this.$timeout(function () {
	        _this3.validation[field] = {
	          valid: isValid,
	          style: { borderColor: isValid ? "green" : "red" },
	          message: constructErrorMessage(errors)
	        };
	      });
	
	      //console.log(field, this.validation);
	      this.isCreditCardDisabled = !isValid;
	
	      if (isValid) {
	        this.validateCardErrorMessage = "";
	        this.validateCardError = false;
	      }
	
	      return isValid;
	    }
	  }, {
	    key: "handleGenericChange",
	    value: function handleGenericChange(name, value) {
	      var CommonValidator = this.$validation.CommonValidator;
	
	
	      var validationMethod = function validationMethod(v) {
	        return {
	          isValid: CommonValidator.exists(v),
	          errors: CommonValidator.exists(v)
	        };
	      };
	
	      return this.validateField(name, value, validationMethod);
	    }
	  }, {
	    key: "handleCreditCardNameChange",
	    value: function handleCreditCardNameChange() {
	      return this.handleGenericChange("credit_card_name", this.credit_card_name);
	    }
	  }, {
	    key: "handleStreetChange",
	    value: function handleStreetChange() {
	      return this.handleGenericChange("street", this.street);
	    }
	  }, {
	    key: "handleCityChange",
	    value: function handleCityChange() {
	      return this.handleGenericChange("city", this.city);
	    }
	  }, {
	    key: "handleStateChange",
	    value: function handleStateChange() {
	      var CreditCardValidator = this.$validation.CreditCardValidator;
	
	      return this.validateField("state", this.state, CreditCardValidator.validateState);
	    }
	  }, {
	    key: "handleZipCodeChange",
	    value: function handleZipCodeChange() {
	      var CreditCardValidator = this.$validation.CreditCardValidator;
	
	      return this.validateField("zipCode", this.zipCode, CreditCardValidator.validateZipCode);
	    }
	  }, {
	    key: "handleCVCChange",
	    value: function handleCVCChange() {
	      var CreditCardValidator = this.$validation.CreditCardValidator;
	
	      return this.validateField("cvc", this.cvc, CreditCardValidator.validateCVC);
	    }
	  }, {
	    key: "handleCardNumberChange",
	    value: function handleCardNumberChange() {
	      var CreditCardValidator = this.$validation.CreditCardValidator;
	
	      return this.validateField("cardNumber", this.cardNumber, CreditCardValidator.validateCardNumber);
	    }
	  }, {
	    key: "handleExpirationDateChange",
	    value: function handleExpirationDateChange() {
	      var CreditCardValidator = this.$validation.CreditCardValidator;
	
	      var date = [this.expMonths.value, this.expYears.value];
	
	      var validationMethod = function validationMethod(date) {
	        var month = date ? date[0] : date;
	        var year = date ? date[1] : date;
	        return CreditCardValidator.validateExpDate(month, year);
	      };
	
	      return this.validateField("expDate", date, validationMethod, CreditCardValidator.constructErrorMessage);
	    }
	  }, {
	    key: "validateCard",
	    value: function validateCard() {
	      var valid = true;
	
	      this.validateCardErrorMessage = "";
	      this.validateCardError = false;
	
	      var validCreditCardName = this.handleCreditCardNameChange();
	      var validStreet = this.handleStreetChange();
	      var validCity = this.handleCityChange();
	      var validState = this.handleStateChange();
	      var validZipCode = this.handleZipCodeChange();
	      var validCardNumber = this.handleCardNumberChange();
	      var validCVC = this.handleCVCChange();
	      var validExpirationDate = this.handleExpirationDateChange();
	
	      if (!validCreditCardName || !validStreet || !validCity || !validState || !validZipCode || !validCardNumber || !validCVC || !validExpirationDate) valid = false;
	
	      if (!validCreditCardName) {
	        this.validateCardError = true;
	        this.validateCardErrorMessage = "Please provide the name associated with this credit card.";
	      }
	
	      if (!validStreet) {
	        this.validateCardError = true;
	        this.validateCardErrorMessage = "Please provide a street address.";
	      }
	
	      if (!validCity) {
	        this.validateCardError = true;
	        this.validateCardErrorMessage = "Please provide a city.";
	      }
	
	      if (!validState) {
	        this.validateCardError = true;
	        this.validateCardErrorMessage = "Please provide a state.";
	      }
	
	      if (!validZipCode) {
	        this.validateCardError = true;
	        this.validateCardErrorMessage = "Please provide a zipcode.";
	      }
	
	      if (!validCardNumber) {
	        this.validateCardError = true;
	        this.validateCardErrorMessage = "Invalid card number.";
	      }
	
	      if (!validCVC) {
	        this.validateCardError = true;
	        this.validateCardErrorMessage = "Invalid cvc code.";
	      }
	
	      if (!validExpirationDate) {
	        this.validateCardError = true;
	        this.validateCardErrorMessage = "Invalid expiration date.";
	      }
	
	      this.isCreditCardDisabled = !valid;
	
	      return valid;
	    }
	  }, {
	    key: "createCard",
	    value: function createCard() {
	      var _this = this;
	
	      _this.isCreditCardDisabled = true;
	
	      if (!this.validateCard()) {
	        return console.error("Invalid card. Not creating card");
	      }
	
	      if (_this.saving_jobbler) {
	        _this.createRecipient();
	        return;
	      }
	
	      var creditCardCount = _this.currentUser.company.undeletedPaymentInfos.length;
	
	      var charge_on_creation = false;
	
	      if (_this.$location.$$url === "/events#modal-publish-event" || _this.$location.$$url === "/events") {
	        charge_on_creation = true;
	      }
	
	      var billingValidate = void 0;
	
	      if (!this.billingEmail) {
	        alert("A contact email is required for saving payment information. This email is used for sending invoices and also as a point of contact for our operations team.");
	        return;
	      } else {
	        billingValidate = this.validateBillingContactEmail();
	        console.log("billingValidate");
	        console.dir(billingValidate);
	        if (billingValidate.error === true) {
	          alert(billingValidate.errorText);
	          return;
	        }
	      }
	
	      var myData = {
	        card: {
	          number: this.cardNumber,
	          exp_month: this.expMonths.value,
	          exp_year: this.expYears.value,
	          cvc: this.cvc,
	          address_line1: this.street,
	          address_city: this.city,
	          address_state: this.state,
	          address_zip: this.zipCode,
	          name: this.credit_card_name
	        }
	      };
	      var req = {
	        method: "POST",
	        url: "https://api.stripe.com/v1/tokens",
	        headers: {
	          "Content-Type": "application/x-www-form-urlencoded",
	          Authorization: "Bearer " + _this.$env.EnvironmentConfig.stripeKey
	        },
	        data: this.$httpParamSerializerJQLike(myData)
	      };
	
	      this.remain_loading_count++;
	
	      this.$http(req).then(function (response) {
	        _this.remain_loading_count--;
	
	        req = {
	          method: "POST",
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/save-customer?format=json&conf=web",
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + _this.currentUser.access_token
	          },
	          data: {
	            username: _this.currentUser.username,
	            stripeToken: response.data.id,
	            nickname: _this.nickname
	          }
	        };
	
	        _this.remain_loading_count++;
	
	        var new_token_id = null;
	        if (response.data.card) {
	          new_token_id = response.data.card.id;
	        } else {
	          new_token_id = response.data.bank.id;
	        }
	
	        console.log("what is the new token");
	        console.dir(new_token_id);
	        console.dir(charge_on_creation);
	        console.dir(_this.payForPost);
	
	        _this.$http(req).then(function (res) {
	          if (res.data.status !== "error") {
	            _this.cardNumber = "";
	            _this.expMonths.value = "";
	            _this.expYears.value = "";
	            _this.nickname = "";
	            _this.cvc = "";
	            _this.street = _this.city = _this.state = _this.zipCode = "";
	            var cardLoop = function cardLoop(value) {
	              _this.$timeout(function () {
	                if (value > 0) {
	                  _this.currentUser = _this.$auth.validateUserByTokenWeb(_this.currentUser.access_token).then(function (r) {
	                    r.data.company.paymentInfos = r.data.company.undeletedPaymentInfos;
	                    _this.$localStorage.logged_user = r.data;
	                    _this.currentUser = r.data;
	                    var result = _this.currentUser.company.undeletedPaymentInfos.find(function (o) {
	                      return o.stripeId === new_token_id;
	                    });
	                    if (result) {
	                      _this.$timeout(function () {
	                        _this.remain_loading_count = 0;
	                        _this.addUsersBillingContact();
	                        jQuery("#modal-add-card .modal-header button.close").trigger("click");
	                      }, 300);
	                      _this.$timeout(function () {
	                        if (_this.payForPost && !charge_on_creation) {
	                          _this.$rootScope.$emit("ShowPostModalCC", {
	                            user: _this.currentUser,
	                            new_card: result
	                          });
	                        } else if (_this.payForPost && charge_on_creation) {
	                          _this.$rootScope.$emit("ChargeCreditCardForPost", {
	                            user: _this.currentUser,
	                            new_card: result,
	                            event: _this.event_for_pay
	                          });
	                        } else {
	                          jQuery("#modal-save-profile-confirm").trigger("click");
	                          if (_this.$rootScope.isSourcingJobForPayment) {
	                            _this.$rootScope.$emit("UpdatedCreditCardConnection", {});
	                          }
	                        }
	                        _this.$rootScope.$emit("UpdatedCreditCardConnectionCompletePage", {});
	                        _this.$rootScope.$emit("UpdatedCreditCard", {
	                          user: _this.currentUser
	                        });
	                        _this.$rootScope.$emit("SetRegisterCardStatus", {
	                          status: 1
	                        });
	                        _this.isCreditCardDisabled = false;
	                        return;
	                      }, 800);
	                    } else {
	                      cardLoop(value - 1);
	                    }
	                  });
	                } else {
	                  _this.isCreditCardDisabled = false;
	                  return;
	                }
	              }, 1000);
	            };
	            cardLoop(10);
	          } else {
	            _this.isCreditCardDisabled = false;
	            _this.validateCardError = true;
	            _this.validateCardErrorMessage = res.data.message;
	            _this.remain_loading_count--;
	          }
	        }, function (res) {
	          _this.validateCardError = true;
	          _this.isCreditCardDisabled = false;
	          _this.validateCardErrorMessage = "Error while registering a credit card.";
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("SetRegisterCardStatus", {
	              status: 2
	            });
	            _this.remain_loading_count--;
	          });
	        });
	      }, function (response) {
	        _this.remain_loading_count--;
	        _this.isCreditCardDisabled = false;
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetRegisterCardStatus", {
	            status: 2
	          });
	          _this.validateCardError = true;
	          _this.validateCardErrorMessage = response.data.error.message;
	        });
	      });
	    }
	  }, {
	    key: "cancelCardRemove",
	    value: function cancelCardRemove() {
	      jQuery("#modal-del-card .modal-header button.close").trigger("click");
	    }
	  }, {
	    key: "getSettingsCTA",
	    value: function getSettingsCTA() {
	      var completed = this.$auth.hasCompletedPaymentInformation();
	
	      if (!completed.payment_added) {
	        return "Add Payment Information";
	      } else {
	        return "Link Payment Information";
	      }
	      /*
	          else if (!completed.ein_complete) {
	              return "Add Company EIN";
	          } else {
	              return "Add Company Address";
	          }
	           */
	    }
	  }, {
	    key: "closeMinimumModal",
	    value: function closeMinimumModal() {
	      $("#minimum-card").modal("hide");
	    }
	  }, {
	    key: "goToSettings",
	    value: function goToSettings() {
	      var _this4 = this;
	
	      var completed = this.$auth.hasCompletedPaymentInformation();
	
	      this.$timeout(function () {
	        $("#missing-payment-info").modal("hide");
	        $("#is-not-verified").modal("hide");
	      });
	
	      this.$timeout(function () {
	        if (!completed.payment_added) {
	          _this4.$location.path("/account-profile/" + _this4.currentUser.company.id + "/payment-information");
	        } else {
	          _this4.$location.path("/account-profile");
	        }
	      }, 200);
	    }
	  }, {
	    key: "removeCard",
	    value: function removeCard() {
	      var _this = this;
	
	      _this.remain_loading_count++;
	
	      var creditCardCount = _this.currentUser.company.undeletedPaymentInfos.length;
	
	      _this.$timeout(function () {
	        jQuery("#modal-del-card .modal-header button.close").trigger("click");
	      }, 300);
	
	      _this.$auth.deleteCard(_this.selectedCreditCard.id).then(function (response) {
	        console.log("response");
	        console.dir(response);
	
	        var cardLoop = function cardLoop(value) {
	          _this.$timeout(function () {
	            if (value > 0) {
	              _this.currentUser = _this.$auth.validateUserByTokenWeb(_this.currentUser.access_token).then(function (r) {
	                r.data.company.paymentInfos = r.data.company.undeletedPaymentInfos;
	                _this.$localStorage.logged_user = r.data;
	                _this.currentUser = r.data;
	
	                console.log("after deletion these need to be equal");
	
	                console.dir(_this.currentUser.company.paymentInfos.length);
	                console.dir(_this.paymentOptionsCounts - 1);
	
	                if (_this.currentUser.company.paymentInfos.length === creditCardCount - 1) {
	                  _this.$timeout(function () {
	                    _this.paymentOptionsCounts = _this.paymentOptionsCounts - 1;
	                    _this.$rootScope.$emit("UpdatedCreditCardConnection", {});
	                    _this.$rootScope.$emit("UpdatedCreditCard", {
	                      user: _this.currentUser
	                    });
	                    _this.$rootScope.$emit("SetRegisterCardStatus", {
	                      status: 1
	                    });
	                    jQuery("#modal-save-profile-confirm-modal").modal();
	
	                    return;
	                  }, 100);
	
	                  _this.$timeout(function () {
	                    _this.remain_loading_count = 0;
	                  }, 400);
	                } else {
	                  cardLoop(value - 1);
	                }
	              });
	            } else {
	              return;
	            }
	          }, 1000);
	        };
	
	        cardLoop(10);
	      }, function (response) {
	        //_this.$rootScope.$emit("SetLoaderDialog", { type : 0, total : 1 });
	
	        _this.remain_loading_count = 0;
	        _this.$timeout(function () {
	          alert("error saving card");
	        }, 300);
	      });
	    }
	  }, {
	    key: "removeBank",
	    value: function removeBank() {
	      var _this = this;
	
	      if (_this.removingBank === true) {
	        return;
	      }
	      _this.removingBank = true;
	      $(".account-gradient-button").addClass("disabled");
	
	      console.log("_this.selectedBankAccount");
	      console.dir(_this.selectedBankAccount);
	
	      var req = {
	        method: "DELETE",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.currentUser.id + "/payment-infos/" + _this.selectedBankAccount.id + "?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.currentUser.access_token
	        }
	      };
	      this.$http(req).then(function (response) {
	        _this.loopThroughAccountsAfterDeletion();
	      }, function (response) {
	        _this.removingBank = false;
	      });
	    }
	  }, {
	    key: "organizePaymentInfo",
	    value: function organizePaymentInfo() {
	      var _this = this;
	
	      if (_this.paymentInfos && _this.paymentInfos.length > 0) {
	        try {
	          _this.paymentInfos.forEach(function (paymentInfo) {
	            if (paymentInfo.bankName) {
	              _this.banksArray.push(paymentInfo);
	            } else {
	              _this.cardsArray.push(paymentInfo);
	            }
	          });
	        } finally {
	          _this.cardsArray.forEach(function (paymentInfo) {
	            paymentInfo.cardExpirationDate = moment().month(parseInt(paymentInfo.cardExpirationMonth)).format("MM") + "/" + paymentInfo.cardExpirationYear;
	          });
	        }
	      }
	    }
	  }, {
	    key: "loopThroughAccountsAfterDeletion",
	    value: function loopThroughAccountsAfterDeletion() {
	      var _this = this;
	
	      _this.setLoader();
	
	      console.log("loopThroughAccountsAfterDeletion");
	      console.dir(_this.paymentOptionsCounts);
	      console.dir(_this.currentUser.company.undeletedPaymentInfos);
	      console.dir(_this.currentUser.company.undeletedPaymentInfos.length);
	      console.dir(_this.banksArray.length);
	      this.$timeout(function () {
	        _this.$rootScope.$emit("UpdatedBankAccounts", { bankToRemove: _this.selectedBankAccount });
	      });
	
	      this.$timeout(function () {
	        $("#modal-del-bank .modal-header button.close").trigger("click");
	      }, 3500);
	
	      this.$timeout(function () {
	        $(".account-gradient-button").removeClass("disabled");
	        _this.removingBank = false;
	        _this.unSetLoader();
	      }, 4000);
	
	      /*
	          var cardLoop = function (value) {
	              console.log("Card looping Value.....");
	              console.dir(value);
	              console.dir(_this.paymentOptionsCounts);
	              console.dir(_this.currentUser.company.undeletedPaymentInfos.length);
	              console.dir(_this.banksArray.length);
	              _this.$timeout(function () {
	                  if (value > 0) {
	                      _this.currentUser = _this.$auth.validateUserByTokenWeb(_this.currentUser.access_token).then(function (r) {
	                          _this.$localStorage.logged_user = r.data;
	                          _this.currentUser = r.data;
	                          if (_this.currentUser.company.undeletedPaymentInfos.length === _this.paymentOptionsCounts - 1) {
	                              _this.remain_loading_count = 0;
	                              _this.$timeout(function () {
	                                  $(".account-gradient-button").removeClass("disabled");
	                                  $("#modal-del-bank .modal-header button.close").trigger("click");
	                                  _this.$rootScope.$emit("UpdatedBankAccounts", {"banks": _this.currentUser.company.undeletedPaymentInfos});
	                                  _this.paymentOptionsCounts = _this.paymentOptionsCounts - 1;
	                                  _this.reloadBankAccounts();
	                                  _this.removingBank = false;
	                                  _this.unSetLoader();
	                                  return;
	                              }, 100);
	                          } else {
	                              cardLoop(value - 1);
	                          }
	                      });
	                  } else {
	                      _this.unSetLoader();
	                      return;
	                  }
	              }, 1000);
	          };
	          cardLoop(10);
	           */
	    }
	  }, {
	    key: "reloadBankAccounts",
	    value: function reloadBankAccounts() {
	      var _this = this;
	
	      console.log("reloadBankAccounts");
	      console.dir(_this.currentUser);
	
	      _this.setLoader();
	
	      var partner = _this.currentUser.company.partner;
	
	      if (partner) {
	        _this.displayModalExplainingMicroDep();
	      }
	
	      _this.banksArray = [];
	
	      _this.$timeout(function () {
	        _this.currentUser = _this.$auth.getUserData();
	        _this.paymentInfos = _this.currentUser.company.undeletedPaymentInfos;
	        _this.organizeBankAccounts();
	        _this.addUsersBillingContact();
	      }, 100);
	
	      _this.$timeout(function () {
	        _this.unSetLoader();
	      }, 1000);
	    }
	  }, {
	    key: "organizeBankAccounts",
	    value: function organizeBankAccounts() {
	      var _this = this;
	
	      console.log("organizeBankAccounts");
	      console.dir(_this.paymentInfos);
	      console.dir(_this.banksArray);
	
	      try {
	        if (_this.paymentInfos) {
	          _this.paymentInfos.forEach(function (paymentInfo) {
	            if (paymentInfo.bankName) {
	              _this.banksArray.push(paymentInfo);
	            }
	          });
	        }
	      } finally {
	        var banks = _this.banksArray;
	        console.log("banks...");
	        console.dir(banks);
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("UpdatedBankAccounts", { banks: banks });
	        });
	      }
	    }
	  }, {
	    key: "sendMicroDeposit",
	    value: function sendMicroDeposit() {
	      var _this = this;
	
	      _this.$security.sendMicroDeposit().then(function (response) {
	        console.log("response");
	        console.dir(response);
	      });
	    }
	  }, {
	    key: "getMostRecentUser",
	    value: function getMostRecentUser() {
	      var _this5 = this;
	
	      return new Promise(function (resolve, reject) {
	        resolve(_this5.$auth.getUserData());
	      });
	    }
	  }, {
	    key: "refreshCurrentUser",
	    value: function refreshCurrentUser() {
	      var _this6 = this;
	
	      this.$auth.refreshCurrentUser().then(function (user) {
	        _this6.getMostRecentUser().then(function (user) {
	          _this6.$timeout(function () {
	            _this6.currentUser = user || _this6.currentUser;
	          });
	        });
	      });
	    }
	  }, {
	    key: "formatMicroDeposit",
	    value: function formatMicroDeposit(microDepositType, microDeposit) {
	      console.log("formatMicroDeposit");
	      console.dir(microDepositType);
	      console.dir(microDeposit);
	      console.dir(typeof microDeposit === "undefined" ? "undefined" : _typeof(microDeposit));
	      console.dir(microDeposit.indexOf("."));
	
	      var dotIndex = 0;
	
	      if (microDeposit.indexOf(".") > -1) {
	        if (microDepositType === 1) {
	          this.amount1 = microDeposit.replace(/\./g, "");
	          if (this.amount1.length >= 3) {
	            this.amount1 = this.amount1.substring(0, 2);
	          }
	        } else {
	          this.amount2 = microDeposit.replace(/\./g, "");
	          if (this.amount2.length >= 3) {
	            this.amount2 = this.amount1.substring(0, 2);
	          }
	        }
	      } else {
	        if (microDepositType === 1) {
	          if (microDeposit.length >= 3) {
	            this.amount1 = microDeposit.substring(0, 2);
	          }
	        } else {
	          if (microDeposit.length >= 3) {
	            this.amount2 = microDeposit.substring(0, 2);
	          }
	        }
	      }
	    }
	  }, {
	    key: "verifyBankAccount",
	    value: function verifyBankAccount() {
	      var _this = this;
	
	      _this.remain_loading_count = 1;
	
	      var parsedAmount1 = parseInt(this.amount1, 10);
	      var parsedAmount2 = parseInt(this.amount2, 10);
	
	      console.log("_this.selectedBankAccount");
	      console.dir(_this.selectedBankAccount);
	
	      var stripeId = void 0;
	      var setupId = void 0;
	
	      if (_this.selectedBankAccount.setupIntent) {
	        setupId = _this.selectedBankAccount.setupIntent;
	      } else if (_this.selectedBankAccount.setupIntentId) {
	        setupId = _this.selectedBankAccount.setupIntentId;
	      }
	
	      if (_this.selectedBankAccount.paymentMethodId) {
	        stripeId = _this.selectedBankAccount.paymentMethodId;
	      } else {
	        stripeId = _this.selectedBankAccount.stripeId;
	      }
	
	      if (!stripeId) {
	        alert("There was a problem finding your bank token. Please contact support");
	        _this.remain_loading_count = 0;
	        return;
	      }
	
	      _this.$companies.updateIntentWithMicroDeposits(parsedAmount1, parsedAmount2, stripeId, setupId).then(function (response) {
	        _this.remain_loading_count--;
	        if (response.data.status === "error") {
	          _this.validateBankError = true;
	          _this.validateBankErrorMessage = response.data.message;
	        } else {
	          _this.validateBankError = false;
	          _this.selectedBankAccount.validated = true;
	          _this.$timeout(function () {
	            jQuery("#modal-verify-bank .modal-header button.close").trigger("click");
	            _this.amount1 = null;
	            _this.amount2 = null;
	            _this.selectedBankAccount = null;
	            _this.refreshCurrentUser();
	            //_this.reloadBankAccounts();
	          }, 100);
	        }
	      }, function (response) {
	        _this.$timeout(function () {
	          jQuery("#modal-verify-bank .modal-header button.close").trigger("click");
	          _this.remain_loading_count--;
	          _this.amount1 = null;
	          _this.amount2 = null;
	          _this.selectedBankAccount = null;
	        }, 100);
	      });
	    }
	  }, {
	    key: "listCards",
	    value: function listCards() {
	      var _this = this;
	      _this.formatPaymentInfoForPage();
	    }
	  }, {
	    key: "formatPaymentInfoForPage",
	    value: function formatPaymentInfoForPage() {
	      var _this = this;
	      _this.paymentMethodsFormatted = _this.$auth.formatPaymentMethods(_this.currentUser.company.paymentInfos);
	    }
	  }, {
	    key: "payForPostSubmit",
	    value: function payForPostSubmit() {
	      var _this = this;
	
	      var e = _this.event_for_pay;
	      if (_this.selectedPaymentMethod) {
	        console.log("location checking");
	        console.dir(_this.$location);
	        console.dir(_this.$state);
	        console.dir(_this.$stateParams);
	        if (_this.$location.$$url === "/events#modal-publish-event" || _this.$location.$$url === "/events") {
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("CloseCreditCardModalEvents", {
	              card: _this.selectedPaymentMethod,
	              event: e,
	              status: true
	            });
	          });
	        } else {
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("CloseCreditCardModal", {
	              card: _this.selectedPaymentMethod
	            });
	          });
	        }
	      } else {
	        alert("Select a payment method");
	      }
	    }
	  }, {
	    key: "selectPaymentMethod",
	    value: function selectPaymentMethod(paymentMethod) {
	      var _this = this;
	      if (!_this.selectedPaymentMethod) {
	        _this.selectedPaymentMethod = paymentMethod;
	        _this.noPayInfo = false;
	        return;
	      }
	      if (paymentMethod.id === _this.selectedPaymentMethod.id) {
	        _this.selectedPaymentMethod = null;
	        _this.noPayInfo = true;
	        return;
	      }
	      try {
	        _this.paymentMethodsFormatted.forEach(function (info) {
	          info.isChecked = undefined;
	        });
	      } finally {
	        _this.selectedPaymentMethod = paymentMethod;
	        _this.selectedPaymentMethod.isChecked = true;
	        _this.noPayInfo = false;
	      }
	    }
	  }, {
	    key: "addCardFromPostingModal",
	    value: function addCardFromPostingModal() {
	      var _this = this;
	      _this.selectedPaymentMethod = null;
	      console.log("addCardFromPostingModal");
	      _this.$timeout(function () {
	        $("#modal-pick-card .modal-header button.close").trigger("click");
	      }, 200);
	      _this.$timeout(function () {
	        _this.payForPost = true;
	        jQuery("#link-modal-add-card").trigger("click");
	      }, 500);
	    }
	  }, {
	    key: "setPopupForRDS",
	    value: function setPopupForRDS() {
	      var _this = this;
	      _this.setWarningForCustomer = true;
	      _this.$timeout(function () {
	        $("#modal-add-account").modal();
	      });
	    }
	  }, {
	    key: "displayModalExplainingMicroDep",
	    value: function displayModalExplainingMicroDep() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("#explain-mirco-deposits").modal();
	      }, 1000);
	    }
	  }, {
	    key: "clearPayInfo",
	    value: function clearPayInfo() {
	      var _this = this;
	
	      //card data
	      _this.cardNumber = "";
	      _this.expMonths.value = "";
	      _this.expYears.value = "";
	      _this.nickname = "";
	      _this.cvc = "";
	      _this.street = _this.city = _this.state = _this.zipCode = "";
	
	      //bank data
	      _this.accountHolderName = "";
	      _this.routingNumber = "";
	      _this.accountNumber = "";
	      _this.validateCardErrorMessage = null;
	      _this.validateCardError = null;
	    }
	  }, {
	    key: "addUsersBillingContact",
	    value: function addUsersBillingContact() {
	      var _this7 = this;
	
	      var data = {};
	
	      data.company = {};
	      data.company.billingContactInfo = {};
	      data.company.billingContactInfo.email = this.billingEmail;
	
	      this.$timeout(function () {
	        _this7.$companies.updateCompanyBillingEmail(data).then(function (response) {
	          _this7.$auth.reloadCurrentUser();
	        }, function (error) {
	          console.log("transfer error, error:", error);
	          // alert("Error : " + error);
	          alert("There was an error updating the billing contact. Please try again.");
	        });
	      }, 200);
	    }
	  }, {
	    key: "setFocusOnForm",
	    value: function setFocusOnForm() {
	      this.$timeout(function () {
	        $("#modal-add-card .modal-body input:first").focus();
	      }, 500);
	    }
	  }]);
	
	  return PaymentdialogController;
	}();
	
	PaymentdialogController.$inject = ["$http", "$localStorage", "$location", "$state", "auth", "$httpParamSerializerJQLike", "security", "companies", "$rootScope", "$scope", "$timeout", "env", "validation", "$window"];
	
	exports.default = PaymentdialogController;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CREDIT_CARD_MESSAGES = exports.CREDIT_CARD_ERRORS = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _stateList = __webpack_require__(127);
	
	var _stateList2 = _interopRequireDefault(_stateList);
	
	var _common = __webpack_require__(128);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Define Error Prefix
	var CREDIT_PREFIX = 3000;
	
	// Define Error Codes
	var MISSING_NAME = CREDIT_PREFIX + 1;
	var MISSING_ADDRESS = CREDIT_PREFIX + 2;
	var MISSING_CITY = CREDIT_PREFIX + 3;
	var MISSING_STATE = CREDIT_PREFIX + 4;
	var INVALID_STATE = CREDIT_PREFIX + 5;
	var MISSING_ZIP_CODE = CREDIT_PREFIX + 6;
	var INVALID_ZIP_CODE = CREDIT_PREFIX + 7;
	var MISSING_CARD_NUMBER = CREDIT_PREFIX + 8;
	var INVALID_CARD_NUMBER = CREDIT_PREFIX + 9;
	var MISSING_CVC = CREDIT_PREFIX + 10;
	var INVALID_CVC = CREDIT_PREFIX + 11;
	var MISSING_MONTH = CREDIT_PREFIX + 12;
	var INVALID_MONTH = CREDIT_PREFIX + 13;
	var MISSING_YEAR = CREDIT_PREFIX + 14;
	var INVALID_YEAR = CREDIT_PREFIX + 15;
	var INVALID_EXPIRATION_DATE = CREDIT_PREFIX + 16;
	
	// Public Error Codes
	var CREDIT_CARD_ERRORS = exports.CREDIT_CARD_ERRORS = {
	  MISSING_NAME: MISSING_NAME,
	  MISSING_ADDRESS: MISSING_ADDRESS,
	  MISSING_CITY: MISSING_CITY,
	  MISSING_STATE: MISSING_STATE,
	  INVALID_STATE: INVALID_STATE,
	  MISSING_ZIP_CODE: MISSING_ZIP_CODE,
	  INVALID_ZIP_CODE: INVALID_ZIP_CODE,
	  MISSING_CARD_NUMBER: MISSING_CARD_NUMBER,
	  INVALID_CARD_NUMBER: INVALID_CARD_NUMBER,
	  MISSING_CVC: MISSING_CVC,
	  INVALID_CVC: INVALID_CVC,
	  MISSING_MONTH: MISSING_MONTH,
	  INVALID_MONTH: INVALID_MONTH,
	  MISSING_YEAR: MISSING_YEAR,
	  INVALID_YEAR: INVALID_YEAR,
	  INVALID_EXPIRATION_DATE: INVALID_EXPIRATION_DATE
	};
	
	// Corresponding Error Messages
	var CREDIT_CARD_MESSAGES = exports.CREDIT_CARD_MESSAGES = _defineProperty({}, INVALID_EXPIRATION_DATE, "Expiration date has passed.");
	
	var CreditCardValidator = function () {
	  function CreditCardValidator() {
	    _classCallCheck(this, CreditCardValidator);
	  }
	
	  _createClass(CreditCardValidator, null, [{
	    key: "validateState",
	    value: function validateState(state) {
	      var errors = [];
	
	      if (_common2.default.doesNotExist(state)) errors.push(MISSING_STATE);
	
	      if (_stateList2.default.indexOf(state) === -1) errors.push(INVALID_STATE);
	
	      return {
	        isValid: !errors.length,
	        errors: errors
	      };
	    }
	  }, {
	    key: "validateZipCode",
	    value: function validateZipCode(zipCode) {
	      var errors = [];
	
	      if (_common2.default.doesNotExist(zipCode)) errors.push(MISSING_ZIP_CODE);
	
	      if (!ZIP_CODE_REGEX.test(zipCode)) errors.push(INVALID_ZIP_CODE);
	
	      return {
	        isValid: !errors.length,
	        errors: errors
	      };
	    }
	  }, {
	    key: "validateCardNumber",
	    value: function validateCardNumber(cardNumber) {
	      cardNumber = cardNumber ? cardNumber.replace(/[ -]/g, "") : cardNumber;
	
	      var errors = [];
	
	      if (_common2.default.doesNotExist(cardNumber)) errors.push(MISSING_CARD_NUMBER);
	
	      if (!CARD_NUMBER_REGEX.test(cardNumber)) errors.push(INVALID_CARD_NUMBER);
	
	      return {
	        isValid: !errors.length,
	        errors: errors
	      };
	    }
	  }, {
	    key: "validateExpMonth",
	    value: function validateExpMonth(month) {
	      var errors = [];
	
	      month = month ? parseFloat(month) : month;
	
	      if (_common2.default.doesNotExist(month)) errors.push(MISSING_MONTH);
	
	      if (month > 12 || month % 1 !== 0) errors.push(INVALID_MONTH);
	
	      return {
	        isValid: !errors.length,
	        errors: errors
	      };
	    }
	  }, {
	    key: "validateExpYear",
	    value: function validateExpYear(year) {
	      var errors = [];
	
	      year = year ? parseFloat(year) : year;
	      var thisYear = new Date().getFullYear();
	
	      if (_common2.default.doesNotExist(year)) errors.push(MISSING_YEAR);
	
	      if (year < thisYear || year % 1 !== 0) errors.push(INVALID_YEAR);
	
	      return {
	        isValid: !errors.length,
	        errors: errors
	      };
	    }
	  }, {
	    key: "validateExpDate",
	    value: function validateExpDate(month, year) {
	      var errors = [];
	
	      month = month ? parseFloat(month) : 0;
	      year = year ? parseFloat(year) : 0;
	      var totalMonths = month + year * 12;
	
	      var thisYear = new Date().getFullYear();
	      var thisMonth = new Date().getMonth() + 1;
	
	      var thisTotalMonths = thisMonth + thisYear * 12;
	
	      var monthValidation = this.validateExpMonth(month);
	      var yearValidation = this.validateExpYear(year);
	
	      if (!monthValidation.isValid) errors.push.apply(errors, _toConsumableArray(monthValidation.errors));
	
	      if (!yearValidation.isValid) errors.push.apply(errors, _toConsumableArray(yearValidation.errors));
	
	      if (totalMonths < thisTotalMonths || !yearValidation.isValid || !monthValidation.isValid) errors.push(INVALID_EXPIRATION_DATE);
	
	      return {
	        isValid: !errors.length,
	        errors: errors
	      };
	    }
	  }, {
	    key: "validateCVC",
	    value: function validateCVC(cvc) {
	      var errors = [];
	
	      if (_common2.default.doesNotExist(cvc)) errors.push(MISSING_CVC);
	
	      if (!CVC_REGEX.test(cvc)) errors.push(INVALID_CVC);
	
	      return {
	        isValid: !errors.length,
	        errors: errors
	      };
	    }
	  }, {
	    key: "constructErrorMessage",
	    value: function constructErrorMessage(errors) {
	      var message = [];
	
	      errors.forEach(function (error) {
	        message.push(CREDIT_CARD_MESSAGES[error]);
	      });
	
	      return message.join(" ");
	    }
	  }]);
	
	  return CreditCardValidator;
	}();
	
	exports.default = CreditCardValidator;
	
	
	var ZIP_CODE_REGEX = /^\d{5}(?:[-\s]\d{4})?$/;
	// Visa | Mastercard | Discover | AMEX | Diners | JCB
	var CARD_NUMBER_REGEX = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])?[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
	var CVC_REGEX = /^[0-9]{3,4}$/;

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var STATE_LIST = ["AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"];
	
	exports.default = STATE_LIST;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.COMMON_ERROR_MESSAGES = exports.COMMON_ERRORS = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _COMMON_ERROR_MESSAGE;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Define Error Prefix
	var COMMON_PREFIX = 3000;
	
	// Define Error Codes
	var MISSING_FIRST_NAME = COMMON_PREFIX + 1;
	var MISSING_LAST_NAME = COMMON_PREFIX + 2;
	var MISSING_COMPANY_NAME = COMMON_PREFIX + 3;
	
	// Public Error Codes
	var COMMON_ERRORS = exports.COMMON_ERRORS = {
	  MISSING_FIRST_NAME: MISSING_FIRST_NAME,
	  MISSING_LAST_NAME: MISSING_LAST_NAME,
	  MISSING_COMPANY_NAME: MISSING_COMPANY_NAME
	};
	
	// Corresponding Error Messages
	var COMMON_ERROR_MESSAGES = exports.COMMON_ERROR_MESSAGES = (_COMMON_ERROR_MESSAGE = {}, _defineProperty(_COMMON_ERROR_MESSAGE, MISSING_FIRST_NAME, "First name is required."), _defineProperty(_COMMON_ERROR_MESSAGE, MISSING_LAST_NAME, "Last name is required."), _defineProperty(_COMMON_ERROR_MESSAGE, MISSING_COMPANY_NAME, "Company name is required."), _COMMON_ERROR_MESSAGE);
	
	var CommonValidator = function () {
	  function CommonValidator() {
	    _classCallCheck(this, CommonValidator);
	  }
	
	  _createClass(CommonValidator, null, [{
	    key: "exists",
	    value: function exists(value) {
	      return !(_angular2.default.isUndefined(value) || value === null || value === "");
	    }
	  }, {
	    key: "doesNotExist",
	    value: function doesNotExist(value) {
	      return !this.exists(value);
	    }
	  }, {
	    key: "constructErrorMessage",
	    value: function constructErrorMessage(errors) {
	      var message = [];
	
	      errors.forEach(function (error) {
	        message.push(COMMON_ERROR_MESSAGES[error]);
	      });
	
	      return message.join(" ");
	    }
	  }]);
	
	  return CommonValidator;
	}();
	
	exports.default = CommonValidator;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(130);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./paymentdialog.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./paymentdialog.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".paymentdialog{color:red}", ""]);
	
	// exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _questionnaire = __webpack_require__(132);
	
	var _questionnaire2 = _interopRequireDefault(_questionnaire);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var questionnaireModule = _angular2.default.module("questionnaire", [_angularUiRouter2.default]).component("questionnaire", _questionnaire2.default);
	
	exports.default = questionnaireModule;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _questionnaire = __webpack_require__(133);
	
	var _questionnaire2 = _interopRequireDefault(_questionnaire);
	
	var _questionnaire3 = __webpack_require__(134);
	
	var _questionnaire4 = _interopRequireDefault(_questionnaire3);
	
	__webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var questionnaireComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _questionnaire2.default,
	  controller: _questionnaire4.default,
	  controllerAs: "vm"
	};
	
	exports.default = questionnaireComponent;

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\" ng-if=\"!vm.eventId\">\n  <!--------------------- Process Description Start --------------------->\n  <form action=\"\" method=\"post\">\n    <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12 process-description-outer\">\n      <div class=\"process-description\">\n        <div class=\"row\">\n          <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n            <div class=\"title-section\">\n              <h3>Questionnaire ( {{vm.questions.length}}/10 )</h3>\n              <p ng-if=\"!vm.event.isSourcingPost\">Create up to 10 pre-screening questions to easily qualify Jobbler applicants</p>\n              <p ng-if=\"vm.event.isSourcingPost\">Create up to 10 pre-screening questions to easily qualify Jobbler applicants</p>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\" style=\"margin-bottom: 100px\">\n          <div class=\"form-complete clearfix\" ng-repeat=\"q in vm.questions track  by $index\">\n            <div class=\"col-lg-10 col-md-10 col-sm-10 col-xs-12\" ng-if=\"!q.editing\">\n              <div class=\"heading-outer\">\n                <span class=\"heading\">Question</span>\n                {{ q.question }}\n              </div>\n            </div>\n            <div class=\"col-lg-10 col-md-10 col-sm-10 col-xs-12\" ng-if=\"q.editing\">\n              <div class=\"heading-outer\">\n                <span class=\"heading\">Question</span>\n                <textarea\n                  ng-model=\"vm.questionForEdit\"\n                  rows=\"3\"\n                  style=\"width: 100%; border: 1px solid #eee\"\n                  ng-change=\"vm.questionChecking()\"\n                ></textarea>\n              </div>\n            </div>\n            <div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-12 pull-right\" ng-if=\"!q.editing\">\n              <div class=\"heading-outer last-box\" ng-if=\"!$first\">\n                <span class=\"heading\">Action</span>\n                <a href=\"#\" ng-click=\"vm.removeQuestion(q, $index)\" style=\"margin: 0px 4px 0 0px\">\n                  <i class=\"fa fa-trash\"></i>\n                </a>\n                <a href=\"#\" ng-click=\"vm.editQuestion(q)\" style=\"margin: 0px 4px 0 0px\">\n                  <i class=\"fa fa-pencil-square-o\"></i>\n                </a>\n              </div>\n            </div>\n\n            <div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-12 pull-right\" ng-if=\"q.editing\">\n              <div class=\"heading-outer last-box\">\n                <span class=\"heading\">Action</span>\n                <a href=\"#\" class=\"save-question-real\" ng-click=\"vm.saveQuestionAfterEdit(q)\">Save</a>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"form-details form-section clearfix\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n              <label>Add a question</label>\n\n              <div class=\"question-textbox\">\n                <textarea\n                  ng-model=\"vm.questionForList\"\n                  rows=\"4\"\n                  style=\"width: 100%\"\n                  ng-change=\"vm.questionChecking()\"\n                  class=\"edit-job-form-text-edit\"\n                ></textarea>\n                <!--\n\t\t\t                 \tinput class=\"form-control form-input\" placeholder=\"\" type=\"text\">\n\t\t\t                 -->\n                <a href=\"\" class=\"add-btn-plus\" ng-click=\"vm.addQuestionToList()\"> <i class=\"fa fa-plus\"></i> Add </a>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-if=\"vm.postType\">\n          <div class=\"leftbtn\">\n            <input\n              type=\"button\"\n              value=\"Back: Shifts\"\n              class=\"btn button btn-default no-margin-for-button\"\n              ng-click=\"vm.goBackAndSetQuestions()\"\n              ng-if=\"vm.postType !== 'source'\"\n            />\n            <input\n              type=\"button\"\n              value=\"Back: Location\"\n              class=\"btn button btn-default no-margin-for-button\"\n              ng-click=\"vm.goBackAndSetQuestions()\"\n              ng-if=\"vm.postType == 'source'\"\n            />\n          </div>\n          <div class=\"rightbtn\">\n            <input type=\"button\" value=\"Next: Review & Post\" class=\"btn button btn-success no-margin-for-button\" ng-click=\"vm.sendToStepSeven()\" />\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <!--------------------- Process Status Start --------------------->\n\n    <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\">\n      <div class=\"process-status\">\n        <img class=\"creation-img-sml\" src=\"/app/vendor/images/connect.png\" ng-if=\"vm.postType == 'source'\" />\n        <img class=\"creation-img-sml\" src=\"/app/vendor/images/ondemand.png\" ng-if=\"vm.postType == 'regular'\" />\n\n        <h3>Questionnaire</h3>\n        <p>\n          Need help? Check out our list of\n          <a href=\"http://jobble.com/100-questions-job-posting/\" target=\"_blank\">100 helpful application questions.</a>\n        </p>\n      </div>\n    </div>\n  </form>\n</div>\n\n<div class=\"process-description-edit\" ng-if=\"vm.eventId\">\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"job-table team-jobbler-list table-responsive\">\n        <form ng-submit=\"vm.deleteSelectedQuestions()\" class=\"delete-questions-form\">\n          <input type=\"submit\" value=\"Delete\" ng-disabled=\"vm.deletion_model.is_disabled\" />\n        </form>\n\n        <table class=\"table tabler-bordered line-item-table-jobblers table-responsive\">\n          <thead>\n            <tr>\n              <th style=\"width: 40px\">#</th>\n              <th>Question</th>\n              <th style=\"width: 43px\"></th>\n              <th style=\"width: 43px\"></th>\n            </tr>\n          </thead>\n          <tbody class=\"question-listing\">\n            <tr ng-repeat=\"q in vm.questions track  by $index\">\n              <td>{{$index+1}}</td>\n              <td ng-hide=\"q.editing\">{{q.question}}</td>\n              <td ng-show=\"q.editing\">\n                <textarea ng-model=\"vm.questionForEdit\" rows=\"3\" class=\"questions-text\"></textarea>\n                <a href=\"#\" class=\"questions-save-button disabled\" ng-click=\"vm.saveQuestionAfterEdit(q, true)\">Save</a>\n              </td>\n              <td>\n                <a href=\"#\" ng-click=\"vm.cancelEditQuestion(q, $index)\" ng-show=\"q.editing\">\n                  <i class=\"fa fa-times\"></i>\n                </a>\n                <a href=\"#\" ng-click=\"vm.editQuestion(q, $index)\" ng-hide=\"q.editing\">\n                  <i class=\"fa fa-pencil-square-o\"></i>\n                </a>\n              </td>\n              <td>\n                <input type=\"checkbox\" ng-checked=\"q.selected\" ng-click=\"vm.addOrRemoveFromDeletionArray(q,index)\" />\n              </td>\n            </tr>\n          </tbody>\n        </table>\n\n        <form ng-submit=\"vm.deleteSelectedQuestions()\" class=\"delete-questions-form\">\n          <input type=\"submit\" value=\"Delete\" ng-disabled=\"vm.deletion_model.is_disabled\" />\n        </form>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"form-details form-section clearfix\">\n      <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n        <label>Add a question</label>\n        <div class=\"question-textbox\">\n          <textarea ng-model=\"vm.questionForList\" rows=\"4\" ng-change=\"vm.questionChecking()\" class=\"edit-job-form-text-edit\"></textarea>\n\n          <a href=\"\" class=\"add-btn-plus\" ng-click=\"vm.addQuestionToList()\"> <i class=\"fa fa-plus\"></i> Add </a>\n        </div>\n      </div>\n    </div>\n    <!--\n        <div class=\"add-btn\">\n            <a href=\"#\" class=\"btn-default\">Add another question</a>\n        </div>\n        -->\n  </div>\n</div>\n\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QuestionnaireController = function () {
	  function QuestionnaireController($http, $localStorage, $location, $state, $stateParams, AuthService, EventsService, $httpParamSerializerJQLike, SecurityService, $rootScope, $timeout, EnvService, $scope) {
	    _classCallCheck(this, QuestionnaireController);
	
	    this.name = "questionnaire";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$events = EventsService;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	    this.$security = SecurityService;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$timeout = $timeout;
	    this.showQuestionsForms = false;
	    this.questionForList = "";
	    this.deletionArray = [];
	    this.$location = $location;
	    this.$env = EnvService;
	    this.remain_loading_count = 0;
	    this.questions = [{
	      question: "Why are you a good fit?",
	      questionType: 1,
	      editing: false
	    }];
	    this.currentUser = this.$auth.getUserData();
	    this.setDeletionUI();
	
	    var _this = this;
	
	    console.log("************QUESTIONNAIRE");
	    console.log("************QUESTIONNAIRE");
	    console.log("************QUESTIONNAIRE");
	    console.dir(_this.$rootScope.$$listenerCount);
	
	    _this.setJobTypeListener = _this.$rootScope.$on("setJobType", function ($event, params) {
	      _this.postType = params.postType;
	      console.log("what is the post Type?");
	      console.dir(_this.postType);
	    });
	
	    _this.checkQuestionsListener = _this.$rootScope.$on("checkQuestions", function ($event, params) {
	      if (params.clone) {
	        try {
	          params.questions.sort(function (a, b) {
	            return a.id - b.id;
	          });
	        } finally {
	          _this.setQuestionsForCloningProcess(params.questions);
	        }
	      } else {
	        _this.questions = params.questions;
	      }
	      if (params.postType) {
	        _this.postType = params.postType;
	      }
	    });
	
	    _this.triggerQuestionsGetterListener = _this.$rootScope.$on("triggerQuestionsGetter", function ($event) {
	      _this.triggerQuestionsGetter();
	    });
	
	    _this.checkQuestionsEditListener = _this.$rootScope.$on("checkQuestionsEdit", function ($event, params) {
	      _this.remain_loading_count = 1;
	      _this.questions = [];
	      _this.event = params.event;
	
	      console.log("_this.event");
	      console.dir(_this.event);
	
	      _this.event.surveyQuestions.sort(function (a, b) {
	        var order = null;
	
	        console.log("a.displayOrder");
	        console.dir(a.displayOrder);
	
	        if (a.displayOrder) {
	          order = a.displayOrder - b.displayOrder;
	        } else {
	          order = a.id - b.id;
	        }
	
	        return order;
	      });
	      _this.questions = _this.event.surveyQuestions;
	
	      _this.$timeout(function () {
	        _this.remain_loading_count = 0;
	      }, 300);
	    });
	
	    _this.$scope.$on("$destroy", _this.setJobTypeListener);
	    _this.$scope.$on("$destroy", _this.checkQuestionsListener);
	    _this.$scope.$on("$destroy", _this.triggerQuestionsGetterListener);
	    _this.$scope.$on("$destroy", _this.checkQuestionsEditListener);
	
	    _this.eventId = this.$stateParams.eventId;
	  }
	
	  _createClass(QuestionnaireController, [{
	    key: "createQuestion",
	    value: function createQuestion() {
	      var _this = this;
	
	      _this.showQuestionsForm = true;
	    }
	  }, {
	    key: "addQuestionToList",
	    value: function addQuestionToList() {
	      var _this = this;
	
	      console.log("what is the question to be saved");
	      console.dir(_this.questionForList);
	
	      if (_this.questionForList) {
	        var validation = _this.validateQuestion();
	
	        console.log("whats the valid say");
	        console.dir(validation);
	
	        if (_this.errorMax) {
	          console.log("too long...");
	        } else {
	          var qo = {
	            question: _this.questionForList,
	            questionType: { id: 1, name: "Text", description: null },
	            editing: false
	          };
	
	          _this.questions.push(qo);
	
	          if (this.$stateParams.eventId) {
	            _this.remain_loading_count = 1;
	            _this.saveNewQuestionToDB();
	          } else {
	            _this.questionForList = "";
	          }
	
	          if (validation.status) {
	            console.log("in error");
	          } else {}
	        }
	      }
	    }
	  }, {
	    key: "questionChecking",
	    value: function questionChecking() {
	      var _this = this;
	
	      if (_this.questionForList.length >= 241) {
	        _this.errorMax = true;
	        _this.errorMaxMsg = "Your question cannot be longer than 240 characters.";
	        _this.errorMaxMsgDisabled = true;
	        _this.questionForList = _this.questionForList.substring(0, 240);
	      } else {
	        _this.errorMax = false;
	        _this.errorMaxMsg = null;
	        _this.errorMaxMsgDisabled = false;
	      }
	    }
	  }, {
	    key: "validateQuestion",
	    value: function validateQuestion() {
	      var _this = this;
	
	      var returnobj = {};
	
	      try {
	        if (_this.questions.length > 10) {
	          _this.error = true;
	          _this.errormsg = "You have already asked your max amount of questions (three).";
	          returnobj.status = true;
	          returnobj.error = "You have already asked your max amount of questions (three).";
	        } else {
	          returnobj.status = false;
	          _this.error = false;
	          _this.errormsg = null;
	        }
	      } finally {
	        return returnobj;
	      }
	    }
	  }, {
	    key: "saveNewQuestionToDB",
	    value: function saveNewQuestionToDB() {
	      console.log("saveNewQuestionToDB");
	
	      var _this = this;
	
	      console.log("lets replace the questions");
	      console.dir(_this.questions);
	      console.dir(_this.event);
	      console.dir(_this.questionForList);
	      console.dir(_this.questionForEdit);
	
	      var ques = _this.questionForList;
	
	      _this.$timeout(function () {
	        _this.questionForList = "";
	      });
	
	      try {
	        var quesObjSave = {};
	        for (var i = 0; i < _this.questions.length; i++) {
	          //delete _this.questions[i].id;
	          if (!_this.questions[i].questionType) {
	            console.log("no quesiton type");
	            quesObjSave.questionType = 1;
	            quesObjSave.name = "Question " + (i + 1);
	            quesObjSave.question = _this.questions[i].question;
	            _this.questions.splice(i, 1);
	            _this.questions.push(quesObjSave);
	            break;
	          }
	        }
	      } finally {
	        var eventData = {
	          method: "PUT",
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + _this.$stateParams.eventId + "?format=json&conf=web",
	          headers: {
	            "Content-Type": "application/json;charset=UTF-8",
	            Authorization: "Bearer " + _this.currentUser.access_token
	          },
	          data: {
	            surveyQuestions: _this.questions
	          }
	        };
	
	        _this.$http(eventData).then(function (response) {
	          console.log("?");
	          console.dir(response);
	          if (response.data.status !== "error") {
	            console.log("success");
	            _this.remain_loading_count = 0;
	          } else {
	            console.log("error saving questions");
	            _this.remain_loading_count = 0;
	            alert("Error saving your new question. Please contact support");
	          }
	        }, function (response) {
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	        });
	      }
	
	      /*
	      if (_this.isEditExistingQuestion) {
	      var questionData = {
	        method: 'PUT',
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/survey-questions/" + _this.quesObjForSave.id + "?format=json&conf=web",
	        headers: {
	      	  'Content-Type': 'application/json;charset=UTF-8',
	      	  'Authorization': 'Bearer ' + _this.currentUser.access_token
	        },
	        data : {
	      	  question : ques
	        }
	      };
	       _this.$http(questionData).then(function(response) {
	        console.log('response from back end');
	       console.dir(response);
	        if (response.data.status !== 'error') {
	        } else {
	        }
	       }, function(response) {
	       _this.$timeout(function() {
	        jQuery('#show-application-alert').trigger('click');
	       }, 100);
	       })
	      } else {
	       console.log('pretty sure we come down to this else');
	      try {
	       var quesObjSave = {};
	       for (var i = 0; i < _this.questions.length; i++) {
	        if (!_this.questions[i].questionType) {
	      	  console.log('no quesiton type');
	      	  quesObjSave.questionType = 1;
	      	  quesObjSave.name = "Question " + (i + 1);
	      	  quesObjSave.question = _this.questions[i];
	      	  _this.questions.splice(i, 1);
	      	  _this.questions.push(quesObjSave);
	      	  break;
	        }
	       }
	       } finally{
	       var eventData = {
	      	  method: 'PUT',
	      	  url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + _this.$stateParams.eventId + "?format=json&conf=web",
	      	  headers: {
	      		  'Content-Type': 'application/json;charset=UTF-8',
	      		  'Authorization': 'Bearer ' + _this.currentUser.access_token
	      	  },
	      	  data : {
	      		  surveyQuestions : _this.questions
	      	  }
	       };
	        _this.$http(eventData).then(function(response) {
	      	  if (response.data.status !== 'error') {
	      	  } else {
	      	  }
	        }, function(response) {
	        _this.$timeout(function() {
	      	  jQuery('#show-application-alert').trigger('click');
	        }, 100);
	        })
	      }
	      }*/
	    }
	  }, {
	    key: "deleteQuestion",
	    value: function deleteQuestion(question, index) {
	      console.log("editQuestion");
	      console.dir(question);
	      console.dir(index);
	      var _this = this;
	
	      question.deleting = true;
	    }
	  }, {
	    key: "editQuestion",
	    value: function editQuestion(question, index) {
	      var _this = this;
	
	      console.log("_this.isEditExistingQuestion");
	      console.dir(_this.isEditExistingQuestion);
	      if (_this.isEditExistingQuestion === true) {
	        console.log("its true...");
	        return;
	      }
	
	      question.editing = true;
	      _this.isEditExistingQuestion = true;
	
	      console.log("editQuestion");
	      console.dir(_this.$stateParams.eventId);
	
	      if (_this.$stateParams.eventId) {
	        _this.questionForEdit = question.question;
	        _this.quesObjForSave = question;
	      } else {
	        _this.questionForEdit = question.question;
	        console.log("what is the question?");
	        console.dir(_this.questionForEdit);
	      }
	    }
	  }, {
	    key: "cancelEditQuestion",
	    value: function cancelEditQuestion(question, index) {
	      var _this = this;
	      question.editing = false;
	      /*
	      _this.isEditExistingQuestion=true;
	      if (_this.$stateParams.eventId){
	      //_this.questionForEdit=question.question;
	      //_this.quesObjForSave=question;
	      }else{
	      //_this.questionForEdit=question.question;
	      console.log('what is the question?');
	      console.dir(_this.questionForEdit);
	      }
	      */
	    }
	  }, {
	    key: "removeQuestion",
	    value: function removeQuestion(question, index) {
	      console.log("removeQuestion");
	
	      var _this = this;
	
	      var lenQues = this.questions.length;
	
	      if (lenQues > 1) {
	        this.questions.splice(index, 1);
	      }
	
	      if (this.$stateParams.eventId) {
	        _this.remain_loading_count = 1;
	        _this.saveNewQuestionToDB();
	      }
	    }
	  }, {
	    key: "goBackAndSetQuestions",
	    value: function goBackAndSetQuestions() {
	      var _this = this;
	      try {
	        _this.questions.forEach(function (q) {
	          q.editing = false;
	        });
	      } finally {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetQuestionsToEvent", {
	            questions: _this.questions,
	            type: "back"
	          });
	        });
	      }
	    }
	  }, {
	    key: "triggerQuestionsGetter",
	    value: function triggerQuestionsGetter() {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("QuestionsTrigger", {
	          questions: _this.questions
	        });
	      });
	    }
	  }, {
	    key: "sendToStepSeven",
	    value: function sendToStepSeven() {
	      var _this = this;
	      try {
	        _this.questions.forEach(function (q, i) {
	          q.name = "Question " + (i + 1);
	          q.editing = false;
	        });
	      } finally {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetQuestionsToEvent", {
	            questions: _this.questions,
	            type: "forward",
	            currentUser: _this.currentUser
	          });
	        });
	      }
	    }
	  }, {
	    key: "checkQuestions",
	    value: function checkQuestions(params) {
	      var _this = this;
	
	      console.log("checkQuestions");
	      console.dir(params);
	      console.dir(_this.questions);
	      console.dir(params.questions);
	
	      _this.$timeout(function () {
	        console.log("scope apply");
	        console.dir(_this.$scope);
	        _this.$scope.$apply(function () {
	          _this.questionsNew = params.questions;
	        });
	      });
	    }
	  }, {
	    key: "saveQuestionAfterEdit",
	    value: function saveQuestionAfterEdit(questionObj, is_edit, is_delete) {
	      var _this = this;
	      console.log("what is the question rn?");
	      console.dir(questionObj);
	      console.dir(_this.questionForEdit);
	      console.dir(_this.$location.$$url);
	      if (_this.$location.$$url.indexOf("/post-event") > -1) {
	        console.log("were on the creation flow");
	        _this.isEditExistingQuestion = false;
	      } else {
	        console.log("questionObj.id");
	        console.dir(questionObj.id);
	        console.dir(is_edit);
	
	        if (questionObj.id && is_edit) {
	          _this.updateQuestion(questionObj);
	        } else if (is_delete) {
	          _this.deleteQuestionConfirm(questionObj);
	        }
	      }
	      questionObj.question = _this.questionForEdit;
	      questionObj.editing = false;
	      _this.questionForEdit = "";
	    }
	  }, {
	    key: "setQuestionsForCloningProcess",
	    value: function setQuestionsForCloningProcess(questions) {
	      var _this = this;
	
	      console.log("setQuestionsForCloningProcess");
	      console.dir(questions);
	      var q = [];
	      try {
	        questions.forEach(function (ques) {
	          var qo = {};
	          qo.name = ques.name;
	          qo.question = ques.question;
	          qo.questionType = 1;
	          q.push(qo);
	        });
	      } finally {
	        _this.questions = q;
	        console.log("new final questions");
	        console.dir(q);
	      }
	    }
	  }, {
	    key: "showQuestionInput",
	    value: function showQuestionInput() {
	      var _this = this;
	      if (_this.inputQuestion) {
	        _this.inputQuestion = false;
	      } else {
	        _this.inputQuestion = true;
	      }
	    }
	  }, {
	    key: "updateQuestion",
	    value: function updateQuestion(q) {
	      var _this = this;
	      console.log("update question");
	      console.dir(q);
	      var data = {};
	      data.event_id = _this.$stateParams.eventId;
	      data.questions = _this.questions;
	      _this.setLoader();
	      _this.$events.updateQuestion(data).then(function (response) {
	        console.log("in response");
	        console.dir(response);
	        _this.isEditExistingQuestion = false;
	        _this.unSetLoader();
	      }, function (error) {
	        console.log("in error");
	        console.dir(error);
	        _this.isEditExistingQuestion = false;
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "deleteQuestionConfirm",
	    value: function deleteQuestionConfirm(q) {
	      var _this = this;
	      console.log("find this question");
	      console.dir(q);
	      console.dir(_this.questions);
	      var questions = _this.questions;
	      /*
	      _this.questions.filter(function(p) {
	       return !p.channelArrayHolder.some(function(v) {
	        if (v.selected && !v.dontShow) {
	        v.dontShow = true;
	        channelsForDeletion.push(v.id);
	       }
	       });
	      });
	      */
	
	      var pos = questions.map(function (e) {
	        return e.deleting;
	      }).indexOf(true);
	      console.log("what is the index");
	      console.dir(pos);
	      questions.splice(pos, 1);
	      var data = {};
	      data.event_id = _this.$stateParams.eventId;
	      data.questions = questions;
	      _this.$events.updateQuestion(data).then(function (response) {
	        console.log("in delete response");
	        console.dir(response);
	      }, function (error) {
	        console.log("in error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "addOrRemoveFromDeletionArray",
	    value: function addOrRemoveFromDeletionArray(question, index) {
	      var _this = this;
	      var idx = _this.deletionArray.indexOf(question.id);
	      if (idx < 0) {
	        _this.deletionArray.push(question.id);
	      } else {
	        _this.deletionArray.splice(idx, 1);
	      }
	      console.log("length of delition array");
	      console.dir(_this.deletionArray);
	      console.dir(_this.deletionArray.length);
	      var compared = _this.questions.length - _this.deletionArray.length;
	      if (_this.deletionArray.length > 0 && compared >= 1) {
	        console.log("first bracket");
	        _this.deletion_model.is_disabled = false;
	      } else {
	        console.log("second bracket");
	        _this.deletion_model.is_disabled = true;
	      }
	    }
	  }, {
	    key: "deleteSelectedQuestions",
	    value: function deleteSelectedQuestions() {
	      var _this = this;
	      var payload = {};
	      payload.event_id = parseInt(_this.$stateParams.eventId, 10);
	      payload.question_ids = _this.deletionArray;
	      _this.setLoader();
	      _this.$events.deleteSurveyQuestions(payload).then(function (response) {
	        _this.stripQuestionsFromUI(payload);
	      }, function (error) {
	        alert("Error deleting questions. Please try again");
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "stripQuestionsFromUI",
	    value: function stripQuestionsFromUI(payload) {
	      var _this = this;
	      console.log("----------------------start process----------------------");
	      try {
	        payload.question_ids.forEach(function (id, index) {
	          var finder = _this.questions.findIndex(function (o) {
	            return o.id === id;
	          });
	          console.log("questions");
	          console.dir(finder);
	          console.dir(_this.questions);
	          _this.questions.splice(finder, 1);
	        });
	      } catch (err) {
	        console.log("error splicing");
	      }
	      console.log("what are the questions");
	      console.dir(_this.questions);
	      _this.unSetLoader();
	      _this.uncheckAllQuestions();
	    }
	  }, {
	    key: "uncheckAllQuestions",
	    value: function uncheckAllQuestions() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        _this.questions.forEach(function (q) {
	          q.selected = false;
	        });
	        _this.deletionArray = [];
	        _this.deletion_model.is_disabled = false;
	        _this.$scope.$apply();
	      });
	
	      _this.$timeout(function () {
	        _this.questions.forEach(function (q) {
	          console.log("each question");
	          console.dir(q.selected);
	        });
	      }, 500);
	    }
	  }, {
	    key: "setDeletionUI",
	    value: function setDeletionUI() {
	      var _this = this;
	      var deletion_model = { is_disabled: true };
	      _this.deletion_model = deletion_model;
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }]);
	
	  return QuestionnaireController;
	}();
	
	QuestionnaireController.$inject = ["$http", "$localStorage", "$location", "$state", "$stateParams", "auth", "events", "$httpParamSerializerJQLike", "security", "$rootScope", "$timeout", "env", "$scope"];
	
	exports.default = QuestionnaireController;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(136);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./questionnaire.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./questionnaire.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _globalalert = __webpack_require__(138);
	
	var _globalalert2 = _interopRequireDefault(_globalalert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalalertModule = _angular2.default.module("globalalert", [_angularUiRouter2.default]).component("globalalert", _globalalert2.default);
	
	exports.default = globalalertModule;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _globalalert = __webpack_require__(139);
	
	var _globalalert2 = _interopRequireDefault(_globalalert);
	
	var _globalalert3 = __webpack_require__(140);
	
	var _globalalert4 = _interopRequireDefault(_globalalert3);
	
	__webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalalertComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _globalalert2.default,
	  controller: _globalalert4.default,
	  controllerAs: "vm"
	};
	
	exports.default = globalalertComponent;

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	module.exports = "<a href=\"#application-alert\" data-toggle=\"modal\" id=\"show-application-alert\"></a>\n<div class=\"modal fade\" id=\"application-alert\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\" style=\"background-color: #355c24\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <span aria-hidden=\"true\">&times;</span>\n            </button>\n            <strong style=\"font-size: 27px\">The system is currently down, please try again later.</strong>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GlobalalertController = function GlobalalertController() {
	  _classCallCheck(this, GlobalalertController);
	
	  this.name = "globalalert";
	};
	
	exports.default = GlobalalertController;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(142);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./globalalert.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./globalalert.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".globalalert{color:red}", ""]);
	
	// exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _jobcontact = __webpack_require__(144);
	
	var _jobcontact2 = _interopRequireDefault(_jobcontact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobcontactModule = _angular2.default.module("jobcontact", [_angularUiRouter2.default]).component("jobcontact", _jobcontact2.default);
	
	exports.default = jobcontactModule;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobcontact = __webpack_require__(145);
	
	var _jobcontact2 = _interopRequireDefault(_jobcontact);
	
	var _jobcontact3 = __webpack_require__(146);
	
	var _jobcontact4 = _interopRequireDefault(_jobcontact3);
	
	__webpack_require__(147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobcontactComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _jobcontact2.default,
	  controller: _jobcontact4.default,
	  controllerAs: "vm"
	};
	
	exports.default = jobcontactComponent;

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"select-box\">\n  <select\n    chosen\n    style=\"width: 100%\"\n    placeholder-text=\"'Choose On-Site Manager'\"\n    ng-model=\"vm.id_for_backend\"\n    ng-options=\"contact.id as contact.str for contact in vm.contact_options.values\"\n    ng-change=\"vm.managerChanged()\"\n  >\n    <option value=\"\"></option>\n  </select>\n</div>\n"

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobcontactController = function () {
	  function JobcontactController($http, $localStorage, $state, AuthService, $rootScope, $scope, SecurityService, EventsService, EnvService, $timeout, TrackingService, CompaniesService) {
	    _classCallCheck(this, JobcontactController);
	
	    this.name = "jobcontact";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$rootScope = $rootScope;
	    this.$security = SecurityService;
	    this.$events = EventsService;
	    this.$companies = CompaniesService;
	    this.$scope = $scope;
	    this.$env = EnvService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.currentUser = this.$auth.getUserData();
	    //this.hiring_manager = 2106;
	    this.remain_loading_count = 0;
	
	    var _this = this;
	
	    if (!_this.$state.params.eventId && _this.currentUser) {
	      _this.getCompanyUsers();
	    }
	
	    _this.SetManagerForEditPageListener = _this.$rootScope.$on("SetManagerForEditPage", function ($event, data) {
	      console.log("SetManagerForEditPageListener");
	      console.dir(data);
	      var manager = data.id;
	      _this.on_edit_page = true;
	      _this.getCompanyUsers(manager);
	    });
	
	    _this.SetManagerFromBackListener = _this.$rootScope.$on("SetManagerFromBack", function ($event, data) {
	      var manager = data.id;
	      _this.getCompanyUsers(manager);
	    });
	
	    _this.$scope.$on("$destroy", _this.SetManagerForEditPageListener);
	    _this.$scope.$on("$destroy", _this.SetManagerFromBackListener);
	  }
	
	  _createClass(JobcontactController, [{
	    key: "getCompanyUsers",
	    value: function getCompanyUsers(manager) {
	      var _this = this;
	      _this.$companies.getCompanyUsers().then(function (response) {
	        _this.constructOptions(response.data, manager);
	      }, function (error) {});
	    }
	  }, {
	    key: "constructOptions",
	    value: function constructOptions(users, manager) {
	      var _this = this;
	
	      var user_array = [];
	
	      if (manager) {
	        _this.id_for_backend = manager;
	      }
	
	      users.forEach(function (user) {
	        var user_map = {};
	
	        if (user.homeContactInfo.phoneMobile) {
	          user_map.firstName = user.firstName;
	          user_map.lastName = user.firstName;
	          user_map.phone = user.homeContactInfo.phoneMobile;
	          user_map.id = user.id;
	          user_map.str = user.firstName + " " + user.lastName;
	          user_map.email = user.email;
	          user_array.push(user_map);
	        } else {
	          user.homeContactInfo.phoneMobile = "--";
	          user_map.firstName = user.firstName;
	          user_map.lastName = user.firstName;
	          user_map.phone = user.homeContactInfo.phoneMobile;
	          user_map.id = user.id;
	          user_map.str = user.firstName + " " + user.lastName;
	          user_map.email = user.email;
	          user_array.push(user_map);
	        }
	      });
	
	      _this.contact_options = { values: user_array };
	
	      console.log("contact_options");
	      console.dir(_this.contact_options);
	    }
	  }, {
	    key: "managerChanged",
	    value: function managerChanged() {
	      var _this = this;
	
	      if (_this.on_edit_page) {
	        _this.$rootScope.$broadcast("SetOnSiteManagerEdit", {
	          data: _this.id_for_backend
	        });
	      } else {
	        _this.$rootScope.$broadcast("SetOnSiteManager", {
	          data: _this.id_for_backend
	        });
	      }
	    }
	  }, {
	    key: "setManagerForEditPage",
	    value: function setManagerForEditPage(user) {
	      var _this = this;
	
	      var user_map_selected = {};
	      var user_map_selected_array = [];
	      var user_array = [];
	
	      user_map_selected.firstName = user.firstName;
	      user_map_selected.lastName = user.firstName;
	      user_map_selected.phone = user.homeContactInfo.phoneMobile;
	      user_map_selected.id = user.id;
	      user_map_selected.str = user.firstName + " " + user.lastName;
	      user_map_selected.email = user.email;
	      user_map_selected_array.push(user_map_selected);
	
	      _this.users.forEach(function (user) {
	        var user_map = {};
	        if (user.homeContactInfo.phoneMobile) {
	          user_map.firstName = user.firstName;
	          user_map.lastName = user.firstName;
	          user_map.phone = user.homeContactInfo.phoneMobile;
	          user_map.id = user.id;
	          user_map.str = user.firstName + " " + user.lastName;
	          user_map.email = user.email;
	          user_array.push(user_map);
	        }
	      });
	      _this.users_array_final = user_array;
	      _this.selected_user = user_map_selected_array;
	    }
	  }]);
	
	  return JobcontactController;
	}();
	
	JobcontactController.$inject = ["$http", "$localStorage", "$state", "auth", "$rootScope", "$scope", "security", "events", "env", "$timeout", "tracking", "companies"];
	
	exports.default = JobcontactController;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(148);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobcontact.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobcontact.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _googleplaces = __webpack_require__(150);
	
	var _googleplaces2 = _interopRequireDefault(_googleplaces);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var googleplacesModule = _angular2.default.module("googleplaces", [_angularUiRouter2.default]).component("googleplaces", _googleplaces2.default);
	
	exports.default = googleplacesModule;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _googleplaces = __webpack_require__(151);
	
	var _googleplaces2 = _interopRequireDefault(_googleplaces);
	
	var _googleplaces3 = __webpack_require__(152);
	
	var _googleplaces4 = _interopRequireDefault(_googleplaces3);
	
	__webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var googleplacesComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _googleplaces2.default,
	  controller: _googleplaces4.default,
	  controllerAs: "vm"
	};
	
	exports.default = googleplacesComponent;

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.validate_address()\" class=\"order-creation-first-page\">\n  <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n    <label>Address* <span class=\"order-error-text\" ng-show=\"vm.address_ui.error\">- {{vm.address_ui.error_msg}}</span></label>\n    <input\n      type=\"text\"\n      class=\"form-control form-input\"\n      placeholder=\"100 Main Street Boston MA\"\n      ng-model=\"vm.address\"\n      ng-change=\"vm.address_change()\"\n      ng-class=\"{'order-error':vm.address_ui.error}\"\n      googleplace\n    />\n  </div>\n</form>\n"

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _messagingv = __webpack_require__(30);
	
	var _messagingv2 = _interopRequireDefault(_messagingv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GoogleplacesController = function () {
	  function GoogleplacesController($http, $scope, $localStorage, $state, AuthService, SecurityService, Messagingv2Service, $rootScope, $location, TrackingService, $timeout) {
	    _classCallCheck(this, GoogleplacesController);
	
	    this.name = "googleplaces";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$tracking = TrackingService;
	    this.$security = SecurityService;
	    this.$messagingv2 = Messagingv2Service;
	    this.currentUser = this.$auth.getUserData();
	    this.$location = $location;
	    this.$timeout = $timeout;
	    this.address_ui = {
	      is_error: true,
	      is_error_message: null
	    };
	    this.address = null;
	
	    var _this = this;
	
	    _this.SetAddressErrorPickupListener = _this.$rootScope.$on("SetAddressErrorPickup", function ($event, params) {
	      _this.set_address_error_pickup(params.page);
	    });
	
	    _this.SetAddressErrorListener = _this.$rootScope.$on("SetAddressError", function ($event, params) {
	      _this.set_address_error(params.page);
	    });
	
	    _this.SetDropOffAddressCloneListener = _this.$rootScope.$on("SetDropOffAddressClone", function ($event, params) {
	      console.log("params drop off");
	      console.dir(params);
	      _this.$timeout(function () {
	        _this.address = params;
	      }, 300);
	    });
	
	    _this.SetPickUpAddressCloneListener = _this.$rootScope.$on("SetPickUpAddressClone", function ($event, params) {
	      _this.address = params;
	    });
	
	    _this.$scope.$on("$destroy", _this.SetAddressErrorListener);
	    _this.$scope.$on("$destroy", _this.SetAddressErrorPickupListener);
	    _this.$scope.$on("$destroy", _this.SetDropOffAddressCloneListener);
	    _this.$scope.$on("$destroy", _this.SetPickUpAddressCloneListener);
	  }
	
	  _createClass(GoogleplacesController, [{
	    key: "set_address_error_pickup",
	    value: function set_address_error_pickup() {
	      var _this = this;
	      _this.address_ui.error = true;
	      _this.address_ui.error_msg = "A pickup address is required.";
	    }
	  }, {
	    key: "set_address_error",
	    value: function set_address_error(page) {
	      var _this = this;
	      _this.address_ui.error = true;
	      _this.address_ui.error_msg = "A dropoff address is required.";
	    }
	  }, {
	    key: "address_change",
	    value: function address_change() {
	      var _this = this;
	      if (_typeof(_this.address) === "object") {
	        _this.address_ui.error = false;
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetAddress", {
	            address: _this.address
	          });
	        });
	      }
	    }
	  }, {
	    key: "pickup_address_selected",
	    value: function pickup_address_selected() {
	      var _this = this;
	      console.log(".pickup_address_selected()");
	      console.dir(_this.address);
	    }
	  }, {
	    key: "validate_address",
	    value: function validate_address() {
	      var _this = this;
	    }
	  }, {
	    key: "address_clicked",
	    value: function address_clicked() {
	      var _this = this;
	    }
	  }]);
	
	  return GoogleplacesController;
	}();
	
	GoogleplacesController.$inject = ["$http", "$scope", "$localStorage", "$state", "auth", "security", "messagingv2", "$rootScope", "$location", "tracking", "$timeout"];
	
	exports.default = GoogleplacesController;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(154);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./googleplaces.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./googleplaces.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _jobdetailssignup = __webpack_require__(156);
	
	var _jobdetailssignup2 = _interopRequireDefault(_jobdetailssignup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobdetailssignupModule = _angular2.default.module("jobdetailssignup", [_angularUiRouter2.default]).component("jobdetailssignup", _jobdetailssignup2.default);
	
	exports.default = jobdetailssignupModule;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobdetailssignup = __webpack_require__(157);
	
	var _jobdetailssignup2 = _interopRequireDefault(_jobdetailssignup);
	
	var _jobdetailssignup3 = __webpack_require__(158);
	
	var _jobdetailssignup4 = _interopRequireDefault(_jobdetailssignup3);
	
	__webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobdetailssignupComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _jobdetailssignup2.default,
	  controller: _jobdetailssignup4.default,
	  controllerAs: "vm"
	};
	
	exports.default = jobdetailssignupComponent;

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"jobbler-signup-jobdetails\">\n  <p class=\"jobbler-signup-details-header\"><strong>Apply Now</strong></p>\n  <p class=\"all-fields-req\">*All fields required</p>\n  <form ng-submit=\"vm.sign_up()\">\n    <label class=\"field\">First name*</label>\n    <input class=\"form-control form-input\" required type=\"text\" ng-model=\"vm.user.first_name\" />\n    <label class=\"field\">Last name*</label>\n    <input class=\"form-control form-input\" required type=\"text\" ng-model=\"vm.user.last_name\" />\n    <label class=\"field\">Email*</label>\n    <input class=\"form-control form-input\" required type=\"email\" ng-model=\"vm.user.email\" />\n    <label class=\"field\">Phone number*</label>\n    <input class=\"form-control form-input\" required type=\"text\" ng-model=\"vm.user.phone\" />\n    <label class=\"field\">Password*</label>\n    <input class=\"form-control form-input\" required type=\"password\" ng-model=\"vm.user.password\" />\n    <input type=\"submit\" value=\"Quick Apply\" class=\"button btn-success\" />\n  </form>\n</div>\n"

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _iterable = __webpack_require__(159);
	
	var _iterable2 = _interopRequireDefault(_iterable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobdetailssignupController = function () {
	  function JobdetailssignupController($http, $localStorage, $location, $state, AuthService, $rootScope, $scope, SecurityService, EventsService, EnvService, $timeout, TrackingService, JobService, CompaniesService, IterableService) {
	    _classCallCheck(this, JobdetailssignupController);
	
	    this.name = "jobdetailssignup";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$rootScope = $rootScope;
	    this.$location = $location;
	    this.$security = SecurityService;
	    this.$events = EventsService;
	    this.$iterable = IterableService;
	    this.$jobs = JobService;
	    this.$companies = CompaniesService;
	    this.$scope = $scope;
	    this.$env = EnvService;
	    this.jobs = [];
	    this.looking_for_more = false;
	    this.$timeout = $timeout;
	    this.distance_to_scroll = 0.2;
	    this.$tracking = TrackingService;
	    this.currentUser = this.$auth.getUserData();
	    this.loading_initial_jobs = true;
	    this.remain_loading_count = 0;
	    this.ad_origin = this.$location.$$search.src;
	
	    this.user = {
	      first_name: null,
	      last_name: null,
	      email: null,
	      password: null,
	      phone: null
	    };
	
	    var _this = this;
	
	    _this.SetJobForQuickSignUpListener = _this.$rootScope.$on("SetJobForQuickSignUp", function ($event, params) {
	      console.log("SetJobForQuickSignUpListener");
	      console.dir(params);
	      _this.jobble = params;
	    });
	
	    _this.$scope.$on("$destroy", _this.SetJobForQuickSignUpListener);
	  }
	
	  _createClass(JobdetailssignupController, [{
	    key: "sign_up",
	    value: function sign_up() {
	      var _this = this;
	      console.log("sign up");
	      console.dir(_this.user);
	      _this.setLoader();
	      _this.$auth.job_details_register(_this.user).then(function (response) {
	        console.log("response from registration");
	        console.dir(response);
	        if (response.data.status === "error") {
	          _this.handleError(response.data.message);
	          _this.unSetLoader();
	          return;
	        }
	        if (response.status === 200) {
	          _this.$timeout(function () {
	            _this.login();
	            _this.track_regi();
	          }, 1000);
	        } else {
	          alert("Error1");
	        }
	      }, function (error) {
	        console.log("issue registering a user");
	        console.dir(error);
	        alert("Error2");
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "handleError",
	    value: function handleError(error) {
	      var _this = this;
	      if (error.indexOf("Duplicate entry") > -1) {
	        alert("Error: This email already exists in our system.");
	      } else {
	        alert("Error: " + response.data.message);
	      }
	    }
	  }, {
	    key: "login",
	    value: function login() {
	      var _this = this;
	      console.log("logging in...");
	      console.dir(_this.user);
	      _this.$auth.job_details_login(_this.user).then(function (response) {
	        console.log("response from login");
	        console.dir(response);
	        if (response.status === 200) {
	          _this.$timeout(function () {
	            _this.reload_user(response.data);
	          }, 500);
	        } else {
	          alert("Error3");
	        }
	        _this.$timeout(function () {
	          _this.unSetLoader();
	        }, 500);
	      }, function (error) {
	        alert("Error4");
	        _this.$timeout(function () {
	          _this.unSetLoader();
	        }, 500);
	      });
	    }
	  }, {
	    key: "track_regi",
	    value: function track_regi() {
	      var _this = this;
	      var user = _this.user;
	      user.ad_origin = null;
	      if (_this.ad_origin) {
	        user.ad_origin = _this.ad_origin;
	      } else {
	        user.ad_origin = "None";
	      }
	      _this.$tracking.reportQuickRegister(user);
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "reload_user",
	    value: function reload_user(user) {
	      var _this = this;
	      _this.$localStorage.logged_user = user;
	      _this.currentUser = user;
	      var job = _this.jobble;
	      var data = _this.$iterable.set_data(null, job, user, "view");
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetCurrentUserToJobDetails", user);
	        _this.$rootScope.$emit("SetNewUserForJobBoardHeader", {
	          user: _this.currentUser
	        });
	        _this.track_jobble_view(data);
	      });
	    }
	  }, {
	    key: "track_jobble_view",
	    value: function track_jobble_view(data) {
	      var _this = this;
	      _this.$iterable.track_jobble_view(data).then(function (response) {
	        console.log("iterable response");
	        console.dir(response);
	      }, function (error) {
	        console.log("iterable error");
	        console.dir(error);
	      });
	    }
	  }]);
	
	  return JobdetailssignupController;
	}();
	
	JobdetailssignupController.$inject = ["$http", "$localStorage", "$location", "$state", "auth", "$rootScope", "$scope", "security", "events", "env", "$timeout", "tracking", "jobs", "companies", "iterable"];
	
	exports.default = JobdetailssignupController;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IterableService = function () {
	  function IterableService($http, $localStorage, $state, $q, SecurityService, AuthService, EnvService, $rootScope, $timeout) {
	    _classCallCheck(this, IterableService);
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$q = $q;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$env = EnvService;
	    this.$rootScope = $rootScope;
	    this.$timeout = $timeout;
	  }
	
	  _createClass(IterableService, [{
	    key: "set_data",
	    value: function set_data(board_params, job, user, type) {
	      var _this = this;
	
	      var jobName = null;
	
	      if (type === "apply") {
	        jobName = "Web App Job Apply";
	      } else {
	        jobName = "Web App Tracking";
	      }
	
	      var data = {};
	
	      data.email = user.email;
	      data.eventName = jobName;
	      data.createdAt = moment(job.dateCreated).unix();
	      data.dataFields = {};
	      data.dataFields.jobble_id = job.id;
	      data.dataFields.jobble_type_id = job.jobbleType.id;
	      data.dataFields.jobble_type_name = job.jobbleType.name;
	
	      return data;
	    }
	  }, {
	    key: "track_jobble_view",
	    value: function track_jobble_view(data) {
	      var _this = this;
	
	      var key = _this.$env.EnvironmentConfig.iterable_api_key;
	      var req = {
	        method: "POST",
	        url: "https://api.iterable.com:443/api/events/track?api_key=" + key,
	        data: data
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "track_jobble_apply",
	    value: function track_jobble_apply(data) {
	      var _this = this;
	
	      var key = _this.$env.EnvironmentConfig.iterable_api_key;
	
	      var req = {
	        method: "POST",
	        url: "https://api.iterable.com:443/api/events/track?api_key=" + key,
	        data: data
	      };
	
	      return _this.$http(req);
	    }
	  }]);
	
	  return IterableService;
	}();
	
	exports.default = IterableService;
	
	
	IterableService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "env", "$rootScope", "$timeout"];

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(161);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobdetailssignup.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobdetailssignup.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _globalmodal = __webpack_require__(163);
	
	var _globalmodal2 = _interopRequireDefault(_globalmodal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalmodalModule = _angular2.default.module("globalmodal", [_angularUiRouter2.default]).component("globalmodal", _globalmodal2.default);
	
	exports.default = globalmodalModule;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _globalmodal = __webpack_require__(164);
	
	var _globalmodal2 = _interopRequireDefault(_globalmodal);
	
	var _globalmodal3 = __webpack_require__(165);
	
	var _globalmodal4 = _interopRequireDefault(_globalmodal3);
	
	__webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalmodalComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _globalmodal2.default,
	  controller: _globalmodal4.default,
	  controllerAs: "vm"
	};
	
	exports.default = globalmodalComponent;

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	module.exports = "<a href=\"#application-global-modal\" data-toggle=\"modal\" id=\"show-application-global-modal\"></a>\n\n<div class=\"modal fade\" id=\"application-global-modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <!-- style=\"max-width:583px;\"  style=\"width:510px;\" -->\n        <div class=\"modal-content popup-content\" ng-if=\"$root.globalModalType.type == 4\">\n          <div class=\"modal-header popup-header text-center\">\n            <!--\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n\t\t\t\t<i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n\t\t\t</button>\n\t\t\t-->\n\n            <h4 class=\"modal-title\">Verify e-mail address</h4>\n          </div>\n          <div class=\"modal-body popup-body text-center\">\n            <p>Before this job can be published, you need to verify your email address by clicking the link we sent to your inbox.</p>\n            <p>Once you have clicked that link, your job posting will be published automatically.</p>\n          </div>\n          <div class=\"modal-footer text-center\">\n            <div class=\"row\" style=\"text-align: center\">\n              <a class=\"btn btn-success modal-buttons-new\" ng-click=\"vm.checkVerificationStatus()\" style=\"border-radius: none\"\n                >I have verified my email address</a\n              >\n              <div class=\"alert-box alert\" ng-show=\"vm.verificationError\">{{ vm.verificationError }}</div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-content\" ng-if=\"vm.type == 2\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" style=\"opacity: 0\">\n              <span aria-hidden=\"true\" style=\"opacity: 0\">&times;</span>\n            </button>\n\n            <h4 class=\"modal-title\">Almost done...</h4>\n          </div>\n          <div class=\"modal-body\">\n            <p>Please upload a company logo before you post to our board</p>\n            <img ng-src=\"{{ vm.currentUser.companyProfilePictureUrl }}\" class=\"lazy-reg-image-preview\" />\n            <button\n              class=\"lazy-reg-upload-button\"\n              type=\"file\"\n              ngf-select=\"vm.uploadFiles($file, $invalidFiles)\"\n              accept=\"image/*\"\n              ngf-max-height=\"2000\"\n              ngf-max-size=\"1MB\"\n            >\n              Select File\n            </button>\n\n            <div class=\"clearfix\">\n              <a ng-if=\"vm.showContinueButton\" class=\"btn\" style=\"margin: 0\" data-toggle=\"modal\">Finish</a>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-content\" ng-if=\"$root.globalModalType.type == 1\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <span aria-hidden=\"true\">&times;</span>\n            </button>\n            <h4 class=\"modal-title\">Success!</h4>\n          </div>\n          <div class=\"modal-body\">\n            <p>\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad\n              minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Lorem ipsum dolor sit amet, consectetur\n              adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation\n              ullamco laboris nisi ut aliquip ex ea commodo consequat.\n            </p>\n            <!-- <img src=\"/app/vendor/images/green_check_mark.png\" class=\"lazy-reg-image-check\" /> -->\n            <div class=\"clearfix\" style=\"margin-top: 20px\">\n              <a class=\"btn\" style=\"margin: 0\" data-dismiss=\"modal\" ng-click=\"vm.proceedToOtherModal()\">Continue</a>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-content\" ng-if=\"$root.globalModalType.type == 5\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <span aria-hidden=\"true\">&times;</span>\n            </button>\n            <h4 class=\"modal-title\">Success</h4>\n          </div>\n          <div class=\"modal-body\">\n            <p>The jobblers shift has been updated with the correct checkin/checkout information</p>\n            <!-- <img src=\"/app/vendor/images/green_check_mark.png\" class=\"lazy-reg-image-check\" /> -->\n            <div class=\"clearfix\" style=\"margin-top: 20px\">\n              <a class=\"btn\" style=\"margin: 0\" data-dismiss=\"modal\">Continue</a>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"modal-content\" ng-if=\"vm.type == 3\">\n          <div class=\"modal-header\">\n            <!--<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>-->\n            <h4 class=\"modal-title\" ng-if=\"vm.isLazyUser\">SIGN-UP</h4>\n            <h4 class=\"modal-title\" ng-if=\"!vm.isLazyUser\">Login</h4>\n          </div>\n          <div class=\"modal-body\" ng-if=\"vm.isLazyUser\">\n            <p>\n              Already have an account?\n              <a href=\"\" style=\"color: #b7b7b7\" ng-click=\"vm.showSignInScreen()\">Login here</a>\n            </p>\n\n            <div class=\"global-response-error\" ng-if=\"vm.errorMessage.status\">{{ vm.errorMessage.message }}</div>\n\n            <form ng-submit=\"vm.registerNewLazyUser()\" id=\"regiForm-resp\">\n              <div class=\"row\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                  <label>First name</label>\n                  <input type=\"text\" placeholder=\"\" ng-model=\"vm.newUserObj.firstName\" required class=\"form-control form-input\" />\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                  <label>Last name</label>\n                  <input type=\"text\" placeholder=\"\" ng-model=\"vm.newUserObj.lastName\" required class=\"form-control form-input\" />\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                  <label>Company name</label>\n                  <input type=\"text\" placeholder=\"The Boston Globe\" ng-model=\"vm.newUserObj.companyName\" required class=\"form-control form-input\" />\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                  <label>Username / email</label>\n                  <input type=\"email\" placeholder=\"kevin@xyz.com\" ng-model=\"vm.newUserObj.email\" required class=\"form-control form-input\" />\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                  <label>Phone</label>\n                  <input\n                    type=\"text\"\n                    placeholder=\"5555555555\"\n                    ng-model=\"vm.newUserObj.phoneMobile\"\n                    required\n                    ng-change=\"vm.phoneChange()\"\n                    class=\"form-control form-input {{ vm.phone_class }}\"\n                  />\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                  <label>Password</label>\n                  <input type=\"password\" ng-model=\"vm.newUserObj.password\" required class=\"form-control form-input\" />\n                </div>\n              </div>\n              <div class=\"row\" style=\"margin-bottom: 20px; margin-top: 12px\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                  <div class=\"check-policy\">\n                    <input type=\"checkbox\" value=\"1\" id=\"yes\" ng-model=\"vm.check_policy\" tabindex=\"5\" />\n                    <label for=\"yes\">\n                      I agree with Jobble\n                      <a class=\"policy\" href=\"\" ng-click=\"vm.displayTOSModal = true;\"> Terms of Service, Privacy Policy and Cookie Policy </a>\n                    </label>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                  <input type=\"submit\" value=\"Register\" class=\"btn button btn-success\" />\n                </div>\n              </div>\n            </form>\n\n            <!--\n            <a data-toggle=\"modal\" class=\"btn odd\" ng-click=\"vm.registerNewLazyUser()\" style=\"background:#65b849;margin-bottom:15px;\">Register</a>\n            -->\n          </div>\n          <div class=\"modal-body\" ng-if=\"!vm.isLazyUser\">\n            <!--<p style=\"color:#494949;\">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>-->\n            <form ng-submit=\"vm.lazyLogin()\">\n              <div class=\"row\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                  <label>Username / email</label>\n                  <input type=\"email\" placeholder=\"kevin@xyz.com\" ng-model=\"vm.newUserObj.emailLogin\" required class=\"form-control form-input\" />\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                  <label>Password</label>\n                  <input type=\"password\" ng-model=\"vm.newUserObj.passwordLogin\" required class=\"form-control form-input\" />\n                </div>\n              </div>\n              <div class=\"row\" style=\"margin-top: 20px\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                  <input type=\"submit\" value=\"Login\" class=\"btn button btn-success\" />\n                </div>\n              </div>\n            </form>\n\n            <p>\n              Do not have an account?\n              <a href=\"\" style=\"color: #b7b7b7\" ng-click=\"vm.showSignInScreen()\">Register here</a>\n            </p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n\n<div ng-if=\"vm.displayTOSModal\" style=\"position: fixed; top: 0; width: 100%; background: rgba(0, 0, 0, 0.45); z-index: 99999\">\n  <div\n    id=\"myModal\"\n    style=\"top: 20px; display: block; visibility: visible; max-height: 600px; overflow-y: scroll; overflow-x: hidden\"\n    class=\"reveal-modal medium\"\n    data-reveal=\"\"\n    aria-labelledby=\"modalTitle\"\n    aria-hidden=\"true\"\n    role=\"dialog\"\n  >\n    <h2>Jobble Terms of Service</h2>\n    <p>Last updated: 03/1/2016</p>\n    <p>\n      These Terms of Service govern the use of the services offered by Jobble, Inc. (the \"Company\") at the Company's website (jobbleapp.com the\n      \"Site\") or mobile applications. Such services, the Site and mobile applications together are hereinafter collectively referred to as the\n      \"Service.\" Your use of the Service constitutes your acceptance of and agreement to all of the terms and conditions in these Terms of Service,\n      the Privacy Policy (the \"Privacy Policy\") available here and your representation that you are 18 years of age or older. If you object to\n      anything in these Terms of Service or the Privacy Policy, you are not permitted to use the Service. The Privacy Policy is incorporated by\n      reference into these Terms of Service and these Terms of Service and the Privacy Policy together are hereinafter referred to as this\n      \"Agreement.\"\n    </p>\n    <p>These Terms of Service include, but are not limited to, the following:</p>\n    <p>Your agreement that the Service is provided \"as is\" and without warranty.</p>\n    <p>\n      Your agreement that, for a period of one year following the completion of an Assignment, a Client may not solicit the services of a Provider who\n      has performed such Assignment for such Client other than by means of the Service.\n    </p>\n    <p>Your agreement that the Company has no liability regarding the Service.</p>\n    <p>Your consent to release the Company from liability based on claims between Users and generally.</p>\n    <p>\n      Your agreement to indemnify the Company from claims due to your use or inability to use the Service or content submitted from your account to\n      the Service.\n    </p>\n    <p>Your consent that either party has the right to compel arbitration.</p>\n    <p>Your consent that no claims can be adjudicated on a class basis.</p>\n    <p>Service Connects Providers and Clients</p>\n    <p>\n      The Service is a communications platform which enables the connection between Clients and Providers. Clients are individuals and/or businesses\n      seeking to obtain event and/or work assignments (\"Assignments\") from Providers and are therefore clients of Providers, and Providers are\n      individuals and/or businesses seeking to perform Assignments (\"Providers\") for Clients. Clients and Providers together are hereinafter referred\n      to as \"Users.\"\n    </p>\n    <p>Service Only Provides a Venue</p>\n    <p>\n      The Service is a platform for enabling connections between Users for the fulfillment of Assignments, but Company is not responsible for the\n      performance of Users, nor does it have control over the quality, timing, legality, failure to provide, or any other aspect whatsoever of\n      Assignments, nor of the integrity, responsibility or any of the actions or omissions whatsoever of any Users. Company does not have control over\n      the quality, timing or legality of Assignments delivered by Providers. Company makes no representations about the suitability, reliability,\n      timeliness, or accuracy of the Assignments requested and provided by Users identified through the Service whether in public, private, or offline\n      interactions.\n    </p>\n    <p>User Vetting</p>\n    <p>\n      Clients and Providers may be subject to an extensive vetting process before they can register and during their use of the Service, including but\n      not limited to a verification of identity and a comprehensive criminal background check, at the Country, State and local level, using third\n      party services as appropriate. Users hereby give consent to Company to conduct background checks as often as required in compliance with federal\n      and state laws and the Fair Credit Reporting Act.\n    </p>\n    <p>\n      Although Company may perform background checks of Users, as outlined above, Company cannot confirm that each User is who they claim to be and\n      therefore, Company cannot and does not assume any responsibility for the accuracy or reliability identity or background check information or any\n      information provided through the Service.\n    </p>\n    <p>\n      When interacting with other Users, you should exercise caution and common sense to protect your personal safety and property, just as you would\n      when interacting with other persons whom you don't know. NEITHER COMPANY NOR ITS AFFILIATES OR LICENSORS IS RESPONSIBLE FOR THE CONDUCT, WHETHER\n      ONLINE OR OFFLINE, OF ANY USER OF THE SERVICE AND YOU HEREBY RELEASE THE COMPANY AND ITS AFFILIATES OR LICENSORS FROM ANY LIABILITY RELATED\n      THERETO. COMPANY AND ITS AFFILIATES AND LICENSORS WILL NOT BE LIABLE FOR ANY CLAIM, INJURY OR DAMAGE ARISING IN CONNECTION WITH YOUR USE OF THE\n      SERVICE.\n    </p>\n    <p>Billing and Payment</p>\n    <p>\n      Users of the Service contract for Assignments directly with other Users. Company will not be a party to any contracts for Assignments or\n      services.\n    </p>\n    <p>\n      Users of the Service will be required to provide their credit card or bank account details to Company and the Payment Service Provider retained\n      by Company (the \"PSP\").\n    </p>\n    <p>\n      Clients will be responsible for paying the invoice for each Assignment (the \"Invoice\"), which will include the pricing terms of the Assignment\n      agreed with and provided by a Provider (\"Assignment Payment\"), any out of pocket expenses agreed with and submitted by a Provider in connection\n      with the Assignment, any tip or gratuity, if applicable, and the fee the Company assesses for the Service, based on the Assignment Payment\n      amount.\n    </p>\n    <p>\n      Providers may be required to register with the PSP, agree to Terms of Service of the PSP and go through a vetting process at the request of the\n      PSP to set up their account with the PSP. Terms of Service between Providers and the PSP retained by Company are available here (the \"PSP\n      Agreement\"). By accepting these Terms of Use, each Provider agrees that they have downloaded or printed, and reviewed and agreed to the PSP\n      Agreement. Please note that the Company is not a party to the PSP Agreement and that you, the PSP and any other parties listed in the PSP\n      Agreement (currently, Stripe) are the parties to the PSP Agreement and that the Company has no obligations or liability to any Provider under\n      the PSP Agreement.\n    </p>\n    <p>\n      Within 24 hours after Client receives confirmation through the Service or via email that an Assignment has been completed, Client authorizes\n      Company to provide Client's payment details to the PSP for processing of Assignment Payment, out of pocket expenses owed to Provider, any tip or\n      gratuity, if applicable, and any fees owed to Company for the use of the Service. You may be charged a cancellation fee through the PSP if you\n      book an\n    </p>\n    <p>Assignment, but cancel it before it is completed, as set forth in the Assignment pricing terms.</p>\n    <p>\n      Company reserves the right, in its sole discretion (but not the obligation), to (i) place on hold any Assignment Payment and out of pocket\n      expenses, or (ii) refund, provide credits or arrange for the PSP to do so.\n    </p>\n    <p>Assignment Payment and fees must be paid through the Service.</p>\n    <p>\n      Users of the Service will be liable for any taxes (including VAT, if applicable) required to be paid on the Services provided under the\n      Agreement (other than taxes on the Company's income).\n    </p>\n    <p>Non-Solicitation</p>\n    <p>\n      In consideration of Jobble's expense in providing the Service, each Client agrees for the one year period immediately following the completion\n      of an Assignment by a Provider, Client shall not, directly or indirectly, for itself, or on behalf of any other person, corporation, consulting\n      agency, staffing company or any other firm or other entity, whether as principal, agent, employee, stockholder, partner, member, officer,\n      director, sole proprietor, or otherwise, solicit, participate in or promote the solicitation of, or hire such Provider without the written\n      permission from Jobble. If Provider fails to comply with these terms, Client will pay Jobble liquidated damages equal to $2,000 for each\n      applicable Provider. Client shall inform Jobble of the hiring of any such Provider within ten (10) days of such hiring and shall make payment of\n      the applicable liquidated damages within thirty (30) days of such hiring.\n    </p>\n    <p>Release</p>\n    <p>\n      The Service is only a venue for connecting Users. Because Company is not involved in the actual contact between Users or in the completion of\n      the Assignment, in the event that you have a dispute with one or more Users, you release Company (and our officers, directors, agents,\n      investors, subsidiaries, and employees) from any and all claims, demands, or damages (actual or consequential) of every kind and nature, known\n      and unknown, suspected and unsuspected, disclosed and undisclosed, arising out of or in any way connected with such disputes.\n    </p>\n    <p>Company expressly disclaims any liability that may arise between Users of its Service.</p>\n    <p>Public Areas; Acceptable Use</p>\n    <p>\n      The Service may contain profiles, email systems, blogs, message boards, applications, job postings, chat areas, news groups, forums, communities\n      and/or other message or communication facilities (\"Public Areas\") that allow Users to communicate with other Users. You may only use such\n      community areas to send and receive messages and material that are relevant and proper to the applicable forum.\n    </p>\n    <p>Without limitation, while using the Service, you may not:</p>\n    <p>\n      Defame, abuse, harass, stalk, threaten or otherwise violate the legal rights (such as, but not limited to, rights of privacy and publicity) of\n      others, including Company staff.\n    </p>\n    <p>\n      Publish, post, upload, distribute or disseminate any profane, defamatory, infringing, obscene or unlawful topic, name, material or information.\n    </p>\n    <p>\n      Use the Service for any purpose, including, but not limited to posting or completing an Assignment, in violation of local, state, national, or\n      international law.\n    </p>\n    <p>\n      Upload files that contain software or other material that violates the intellectual property rights (or rights of privacy or publicity) of any\n      third party.\n    </p>\n    <p>\n      Upload files that contain viruses, Trojan horses, corrupted files, or any other similar software that may damage the operation of another's\n      computer.\n    </p>\n    <p>Post or upload any content to which you have not obtained any necessary rights or permissions to use accordingly.</p>\n    <p>\n      Advertise or offer to sell any goods or services for any commercial purpose through the Service that are not relevant to the services offered\n      through the Service.\n    </p>\n    <p>Conduct or forward surveys, contests, pyramid schemes, or chain letters.</p>\n    <p>Impersonate another person or a User or allow any other person or entity to use your identification to post or view comments.</p>\n    <p>Post the same Assignment repeatedly (\"Spamming\"). Spamming is strictly prohibited.</p>\n    <p>Download any file posted by another User that a User knows, or reasonably should know, cannot be legally distributed through the Service.</p>\n    <p>Restrict or inhibit any other User from using and enjoying the Public Areas.</p>\n    <p>Imply or state that any statements you make are endorsed by Company, without the prior written consent of Company.</p>\n    <p>Use a robot, spider, manual and/or automatic processes or devices to data-mine, data-crawl, scrape or index the Service in any manner.</p>\n    <p>Hack or interfere with the Service, its servers or any connected networks.</p>\n    <p>Adapt, alter, license, sublicense or translate the Service for your own personal or commercial use.</p>\n    <p>Remove or alter, visually or otherwise, any copyrights, trademarks or proprietary marks and rights owned by Company.</p>\n    <p>\n      Upload content that is offensive and/or harmful, including, but not limited to, content that advocates, endorses, condones or promotes racism,\n      bigotry, hatred or physical harm of any kind against any individual or group of individuals.\n    </p>\n    <p>\n      Upload content that provides materials or access to materials that exploit people under the age of 18 in an abusive, violent or sexual manner.\n    </p>\n    <p>\n      Use the Service to solicit for any other business, website or service, or otherwise contact Users for employment, contracting or any purpose not\n      related to use of the Service as set forth herein.\n    </p>\n    <p>Use the Service to collect usernames and or/email addresses of Users by electronic or other means.</p>\n    <p>Register under different usernames or identities, after your account has been suspended or terminated.</p>\n    <p>\n      You understand that all submissions made to Public Areas will be public and that you will be publicly identified by your name or login\n      identification when communicating in Public Areas, and Company will not be responsible for the action of any Users with respect to any\n      information or materials posted in Public Areas.\n    </p>\n    <p>Termination and Suspension</p>\n    <p>\n      Company may terminate or suspend your right to use the Service at any time for any or no reason by providing you with written or email notice of\n      such termination, and termination will be effective immediately upon delivery of such notice.\n    </p>\n    <p>\n      Without limitation, Company may terminate or suspend your right to use the Service if you breach any term of this Agreement or any policy of\n      Company posted through the Service from time to time, or if Company otherwise finds that you have engaged in inappropriate and/or offensive\n      behavior. If Company terminates or suspends your right to use the Service for any of these reasons, you will not be entitled to any refund of\n      unused balance in your account. If Company terminates or suspends your account for any reason, you are prohibited from registering and creating\n      a new account under your name, a fake or borrowed name, or the name of any third party, even if you may be acting on behalf of the third party.\n      In addition to terminating or suspending your account, Company reserves the right to take appropriate legal action, including without limitation\n      pursuing civil, criminal, and injunctive redress.\n    </p>\n    <p>Even after your right to use the Service is terminated or suspended, this Agreement will remain enforceable against you.</p>\n    <p>\n      You may terminate this Agreement at any time by ceasing all use of the Service. All sections which by their nature should survive the expiration\n      or termination of this Agreement shall continue in full force and effect subsequent to and notwithstanding the expiration or termination of this\n      Agreement.\n    </p>\n    <p>Account, Password, Security and Mobile Phone Use</p>\n    <p>\n      You must register with Company and create an account to use the Service. You are the sole authorized user of your account. You are responsible\n      for maintaining the confidentiality of any password and account number provided by you or Company for accessing the Service. You are solely and\n      fully responsible for all activities that occur under your password or account. Company has no control over the use of any User's account and\n      expressly disclaims any liability derived therefrom. Should you suspect that any unauthorized party may be using your password or account or you\n      suspect any other breach of security, you will contact Company immediately.\n    </p>\n    <p>\n      By providing your mobile phone number and using the Service, you hereby affirmatively consent to our use of your mobile phone number for calls\n      and texts in order to perform and improve upon the Service. Company will not assess any charges for calls or texts, but standard message charges\n      or other charges from your wireless carrier may apply. You may opt-out of receiving text messages from us by modifying your account settings on\n      the Site or Company's mobile application, or by emailing support@jobble.com.\n    </p>\n    <p>Your Information and Likeness</p>\n    <p>\n      \"Your Information\" is defined as any information and materials you provide to Company or other Users in connection with your registration for\n      and use of the Service, including without limitation that posted or transmitted for use in Public Areas. You are solely responsible for Your\n      Information, and we act merely as a passive conduit for your online distribution and publication of Your Information. The information and\n      materials described in this Section, as provided by each User, is collectively referred to herein as \"User Generated Content.\" You hereby\n      represent and warrant to Company that Your Information (a) will not be false, inaccurate, incomplete or misleading; (b) will not be fraudulent\n      or involve the sale of counterfeit or stolen items; (c) will not infringe any third party's copyright, patent, trademark, trade secret or other\n      proprietary right or rights of publicity or privacy; (d) will not violate any law, statute, ordinance, or regulation (including without\n      limitation those governing export control, consumer protection, unfair competition, anti-discrimination or false advertising); (e) will not be\n      defamatory, libelous, unlawfully threatening, or unlawfully harassing; (f) will not be obscene or contain child pornography or be harmful to\n      minors; (g) will not contain any viruses, Trojan Horses, worms, time bombs, cancelbots or other computer programming routines that are intended\n      to damage, detrimentally interfere with, surreptitiously intercept or expropriate any system, data or personal information; and (h) will not\n      create liability for Company or cause Company to lose (in whole or in part) the services of its ISPs or other partners or suppliers.\n    </p>\n    <p>\n      The Service hosts User Generated Content relating to reviews of specific Providers. Such reviews are opinions and not the opinion of Company,\n      have not been verified or approved by Company and each Client should undertake their own research to be satisfied that a specific Provider is\n      the right person for an Assignment. You agree that Company is not liable for any User Generated Content.\n    </p>\n    <p>\n      You hereby grant Company a non-exclusive, worldwide, perpetual, irrevocable, royalty-free, sublicensable (through multiple tiers) right to\n      exercise all copyright, publicity rights, and any other rights you have in Your Information, in any media now known or not currently known in\n      order to perform and improve upon the Service.\n    </p>\n    <p>\n      Each Provider who provides to the Company any videotape, film, record, photograph, voice, or all related instrumental, musical, or other sound\n      effects, in exchange for the right to use the Service, hereby irrevocably grants to the Company the non-exclusive, fully-paid, royalty-free,\n      transferable, sublicensable, worldwide, unrestricted, and perpetual right to:\n    </p>\n    <p>\n      Use any videotape, film, record or photograph that such Provider provides to the Company, and use, reproduce, modify, or creative derivatives of\n      such Provider picture, silhouette and other reproductions of their physical likeness (as the same may appear in any still camera photograph\n      and/or motion picture film or video) (collectively the \"Physical Likeness\"), in and in connection with the exhibition, distribution, display,\n      performance, transmission, broadcasting on any and all media, including, without limitation, the internet, of any videos or images of such\n      Provider in connection with the Service.\n    </p>\n    <p>\n      Reproduce in all media any recordings of such Provider's voice, and all related instrumental, musical, or other sound effects (collectively, the\n      \"Voice\"), made in connection with the Service.\n    </p>\n    <p>\n      Use, and permit to be used, such Provider's Physical Likeness and Voice in the advertising, marketing, and/or publicizing of the Service in any\n      media.\n    </p>\n    <p>Use, and permit to be used, such Provider's name and identity in connection with the Service.</p>\n    <p>\n      Each Provider hereby waives all rights and releases the Company from, and shall neither sue nor bring any proceeding against any such parties\n      for, any claim or cause of action, whether now known or unknown, for defamation, invasion of right to privacy, publicity or personality or any\n      similar matter, or based upon or relating to the use and exploitation of such Provider's identity, likeness or voice in connection with the\n      Service.\n    </p>\n    <p>\n      Each Provider acknowledges that the Company shall not owe any financial or other remuneration for using the recordings provided hereunder by\n      such Provider, either for initial or subsequent transmission or playback, and further acknowledges that the Company is not responsible for any\n      expense or liability incurred as a result of such Provider's recordings or participation in any recordings, including any loss of such recording\n      data.\n    </p>\n    <p>Links to Other Websites</p>\n    <p>\n      Links (such as hyperlinks) from the Service to other sites on the Web do not constitute the endorsement by Company of those sites or their\n      content. Such links are provided as an information service, for reference and convenience only. Company does not control any such sites, and is\n      not responsible for their content. The existence of links on the Service to such websites (including without limitation external websites that\n      are framed by the Company Service as well as any advertisements displayed in connection therewith) does not mean that Company endorses any of\n      the material on such websites, or has any association with their operators. It is your responsibility to evaluate the content and usefulness of\n      the information obtained from other sites.\n    </p>\n    <p>\n      The use of any website controlled, owned or operated by third parties is governed by the terms and conditions of use and privacy policies for\n      those websites, and not by Company's Terms of Service or Privacy Policy. You access such third-party websites at your own risk. Company\n      expressly disclaims any liability arising in connection with your use and/or viewing of any websites or other material associated with links\n      that may appear on the Service. You hereby agree to hold Company harmless from any liability that may result from the use of links that may\n      appear on the Service.\n    </p>\n    <p>\n      As part of the functionality of the Service, you may link your account with online accounts you may have with third party service providers\n      (each such account, a \"Third Party Account\") by either: (i) providing your Third Party Account login information through the Service; or (ii)\n      allowing Company to access your Third Party Account, as is permitted under the applicable terms and conditions that govern your use of each\n      Third Party Account. You represent that you are entitled to disclose your Third Party Account login information to Company and/or grant Company\n      access to your Third Party Account (including, but not limited to, for use for the purposes described herein), without breach by you of any of\n      the terms and conditions that govern your use of the applicable Third Party Account and without obligating Company to pay any fees or making\n      Company subject to any usage limitations imposed by such third party service providers. By granting Company access to any Third Party Accounts,\n      you understand that (i) Company may access, make available and store (if applicable) any content that you have provided to and stored in your\n      Third Party Account (the \"SNS Content\") so that it is available on and through the Service via your account, including without limitation any\n      friend lists, and (ii) Company may submit and receive additional information to your Third Party Account to the extent you are notified when you\n      link your account with the Third Party Account. Unless otherwise specified in these Terms of Service, all SNS Content, if any, shall be\n      considered to be User Generated Content for all purposes of these Terms of Service. Depending on the Third Party Accounts you choose and subject\n      to the privacy settings that you have set in such Third Party Accounts, personally identifiable information that you post to your Third Party\n      Accounts may be available on and through your account on the Service. Please note that if a Third Party Account or associated service becomes\n      unavailable or Company's access to such Third Party Account is terminated by the third party service provider, then SNS Content may no longer be\n      available on and through the Service. You will have the ability to disable the connection between your account on the Service and your Third\n      Party Accounts at any time. PLEASE NOTE THAT YOUR RELATIONSHIP WITH THE THIRD PARTY SERVICE PROVIDERS ASSOCIATED WITH YOUR THIRD PARTY ACCOUNTS\n      IS GOVERNED SOLELY BY YOUR AGREEMENT(S) WITH SUCH THIRD PARTY SERVICE PROVIDERS. Company makes no effort to review any SNS Content for any\n      purpose, including but not limited to, for accuracy, legality or non-infringement, and Company is not responsible for any SNS Content. You\n      acknowledge and agree that Company may access your e-mail address book associated with a Third Party Account and your contacts list stored on\n      your mobile device or tablet computer solely for the purposes of identifying and informing you of those contacts who have also registered to use\n      the Service. At your request made via e-mail to support@jobble.com, Company will deactivate the connection between the Service and your Third\n      Party Account and delete any information stored on Company's servers that was obtained through such Third Party Account, except the username and\n      profile picture that become associated with your account.\n    </p>\n    <p>Worker Classification and Withholdings</p>\n    <p>\n      Each User assumes all liability for proper classification of such User's workers as independent contractors or employees based on applicable\n      legal guidelines.\n    </p>\n    <p>\n      Users do not have authority to enter into written or oral - whether implied or express - contracts on behalf of Company. Each User acknowledges\n      that Company does not, in any way, supervise, direct, or control a Provider's work or Assignments performed in any manner. Company does not set\n      a Provider's work hours or location of work. Company will not provide any equipment, labor or materials needed for a particular Assignment.\n    </p>\n    <p>\n      The Service is not an employment service and Company does not serve as an employer of any User. As such, Company will not be liable for any tax\n      or withholding, including but not limited to unemployment insurance, employer's liability, social security or payroll withholding tax in\n      connection with your use of Users' services.\n    </p>\n    <p>\n      You agree to indemnify, hold harmless and defend Company from any and all claims that a Provider was misclassified as an independent contractor,\n      any liabilities arising from a determination by a court, arbitrator, government agency or other body that a Provider was misclassified as an\n      employee (including, but not limited to, taxes, penalties, interest and attorney's fees), any claim that Company was an employer or joint\n      employer of a Provider, as well as claims under any employment-related laws, such as those relating to employment termination, employment\n      discrimination, harassment or retaliation, as well as any claims for overtime pay, sick leave, holiday or vacation pay, retirement benefits,\n      worker's compensation benefits, unemployment benefits, or any other employee benefits.\n    </p>\n    <p>Intellectual Property Rights</p>\n    <p>\n      All text, graphics, editorial content, data, formatting, graphs, designs, HTML, look and feel, photographs, music, sounds, images, software,\n      videos, designs, typefaces and other content (collectively \"Proprietary Material\") that Users see or read through the Service is owned by\n      Company, excluding User Generated Content that Company has the right to use. Proprietary Material is protected in all forms, media and\n      technologies now known or hereinafter developed. Company owns all Proprietary Material, as well as the coordination, selection, arrangement and\n      enhancement of such Proprietary Materials as a Collective Work under the United States Copyright Act, as amended. The Proprietary Material is\n      protected by the domestic and international laws of copyright, patents, and other proprietary rights and laws. Users may not copy, download,\n      use, redesign, reconfigure, or retransmit anything from the Service without Company's express prior written consent and, if applicable, the\n      holder of the rights to the User Generated Content. Any use of such Proprietary Material, other than as permitted therein, is expressly\n      prohibited without the prior permission of Company and, if applicable, the holder of the rights to the User Generated Content.\n    </p>\n    <p>\n      The service marks and trademarks of Company, including without limitation Company and the Company logos are service marks owned by Company. Any\n      other trademarks, service marks, logos and/or trade names appearing via the Service are the property of their respective owners. You may not\n      copy or use any of these marks, logos or trade names without the express prior written consent of the owner.\n    </p>\n    <p>Copyright Complaints and Copyright Agent</p>\n    <p>\n      Company respects the intellectual property of others, and expects Users to do the same. If you believe, in good faith, that any materials\n      provided on or in connection with the Service infringe upon your copyright or other intellectual property right, please send the following\n      information to Company's Copyright Agent at: Jobble, Inc., 745 Atlantic Ave, Boston, MA 02111 or support@jobble.com:\n    </p>\n    <p>\n      A description of the copyrighted work that you claim has been infringed, including the URL (Internet address) or other specific location on the\n      Service where the material you claim is infringed is located. Include enough information to allow Company to locate the material, and explain\n      why you think an infringement has taken place;\n    </p>\n    <p>\n      A description of the location where the original or an authorized copy of the copyrighted work exists -- for example, the URL (Internet address)\n      where it is posted or the name of the book in which it has been published;\n    </p>\n    <p>Your address, telephone number, and e-mail address;</p>\n    <p>A statement by you that you have a good faith belief that the disputed use is not authorized by the copyright owner, its agent, or the law;</p>\n    <p>\n      A statement by you, made under penalty of perjury, that the information in your notice is accurate, and that you are the copyright owner or\n      authorized to act on the copyright owner's behalf; and\n    </p>\n    <p>\n      An electronic or physical signature of the owner of the copyright or the person authorized to act on behalf of the owner of the copyright\n      interest.\n    </p>\n    <p>Confidential Information</p>\n    <p>\n      You acknowledge that Confidential Information (as hereinafter defined) is a valuable, special and unique asset of Company and agree that you\n      will not disclose, transfer, use (or seek to induce others to disclose, transfer or use) any Confidential Information for any purpose other than\n      disclosure to your authorized employees and agents who are bound to maintain the confidentiality of Confidential Information. You shall promptly\n      notify Company in writing of any circumstances which may constitute unauthorized disclosure, transfer, or use of Confidential Information. You\n      shall use best efforts to protect Confidential Information from unauthorized disclosure, transfer or use. You shall return all originals and any\n      copies of any and all materials containing Confidential Information to Company upon termination of this Agreement for any reason whatsoever. The\n      term \"Confidential Information\" shall mean any and all of Company's trade secrets, confidential and proprietary information and all other\n      information and data of Company that is not generally known to the public or other third parties who could derive value, economic or otherwise,\n      from its use or disclosure. Confidential Information shall be deemed to include technical data, know-how, research, product plans, products,\n      services, customers, markets, software, developments, inventions, processes, formulas, technology, designs, drawings, engineering, hardware\n      configuration information, marketing, finances or other business information disclosed directly or indirectly in writing, orally or by drawings\n      or observation.\n    </p>\n    <p>Disclaimer of Warranties</p>\n    <p>USE OF THE SERVICE IS ENTIRELY AT YOUR OWN RISK.</p>\n    <p>\n      THE SERVICE IS PROVIDED ON AN \"AS IS\" BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, WARRANTIES\n      OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. COMPANY MAKES NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR\n      COMPLETENESS OF THE CONTENT PROVIDED THROUGH THE SERVICE OR THE CONTENT OF ANY SITES LINKED TO THE SERVICE AND ASSUMES NO LIABILITY OR\n      RESPONSIBILITY FOR ANY (I) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT, (II) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER,\n      RESULTING FROM YOUR ACCESS TO AND USE OF THE SERVICE, (III) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL\n      INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN. COMPANY DOES NOT WARRANT, ENDORSE, GUARANTEE OR ASSUME RESPONSIBILITY FOR ANY SERVICE\n      ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SERVICE OR ANY HYPERLINKED WEBSITE OR FEATURED IN ANY BANNER OR OTHER ADVERTISING AND COMPANY\n      WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND THIRD-PARTY PROVIDERS OF PRODUCTS OR\n      SERVICES, OTHER THAN AS PROVIDED HEREIN. AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE\n      YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.\n    </p>\n    <p>\n      WITHOUT LIMITING THE FOREGOING, NEITHER COMPANY NOR ITS AFFILIATES OR LICENSORS WARRANT THAT ACCESS TO THE SERVICE WILL BE UNINTERRUPTED OR THAT\n      THE SERVICE WILL BE ERROR-FREE; NOR DO THEY MAKE ANY WARRANTY AS TO THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SERVICE, OR AS TO THE\n      TIMELINESS, ACCURACY, RELIABILITY, COMPLETENESS OR CONTENT OF ANY ASSIGNMENT OR SERVICE, INFORMATION OR MATERIALS PROVIDED THROUGH OR IN\n      CONNECTION WITH THE USE OF THE SERVICE.\n    </p>\n    <p>NEITHER COMPANY NOR ITS AFFILIATES OR LICENSORS IS RESPONSIBLE FOR THE CONDUCT, WHETHER ONLINE OR OFFLINE, OF ANY USER.</p>\n    <p>\n      NEITHER COMPANY NOR ITS AFFILIATES OR LICENSORS WARRANT THAT THE SERVICE IS FREE FROM VIRUSES, WORMS, TROJAN HORSES, OR OTHER HARMFUL\n      COMPONENTS.\n    </p>\n    <p>\n      COMPANY AND ITS AFFILIATES AND LICENSORS CANNOT AND DO NOT GUARANTEE THAT ANY PERSONAL INFORMATION SUPPLIED BY YOU WILL NOT BE MISAPPROPRIATED,\n      INTERCEPTED, DELETED, DESTROYED OR USED BY OTHERS.\n    </p>\n    <p>\n      IN ADDITION, NOTWITHSTANDING ANY FEATURE A CLIENT MAY USE TO EXPEDITE JOBBLE SELECTION, EACH CLIENT IS RESPONSIBLE FOR SELECTING ITS PROVIDER\n      AND NEGOTIATING TERMS OF WORK AND COMPANY DOES NOT WARRANT ANY GOODS OR SERVICES PURCHASED BY A CLIENT AND DOES NOT RECOMMEND ANY PARTICULAR\n      PROVIDER. COMPANY DOES NOT PROVIDE ANY WARRANTIES OR GUARANTEES REGARDING ANY PROVIDER'S PROFESSIONAL ACCREDITATION, REGISTRATION OR LICENCE.\n    </p>\n    <p>No Liability</p>\n    <p>\n      YOU ACKNOWLEDGE AND AGREE THAT COMPANY IS ONLY WILLING TO PROVIDE THE SERVICE IF YOU AGREE TO CERTAIN LIMITATIONS OF OUR LIABLITY TO YOU AND\n      THIRD PARTIES. THEREFORE, YOU AGREE NOT TO HOLD COMPANY, ITS AFFILIATES, ITS LICENSORS, ITS PARTNERS IN PROMOTIONS, SWEEPSTAKES OR CONTESTS, OR\n      ANY OF SUCH PARTIES' AGENTS, EMPLOYEES, OFFICERS, DIRECTORS, CORPORATE PARTNERS, OR PARTICIPANTS LIABLE FOR ANY DAMAGE, SUITS, CLAIMS, AND/OR\n      CONTROVERSIES (COLLECTIVELY, \"LIABILITIES\") THAT HAVE ARISEN OR MAY ARISE, WHETHER KNOWN OR UNKNOWN, RELATING TO YOUR OR ANY OTHER PARTY'S USE\n      OF OR INABILITY TO USE THE SERVICE, INCLUDING WITHOUT LIMITATION ANY LIABILITIES ARISING IN CONNECTION WITH THE CONDUCT, ACT OR OMISSION OF ANY\n      USER (INCLUDING WITHOUT LIMITATION STALKING, HARASSMENT THAT IS SEXUAL OR OTHERWISE, ACTS OF PHYSICAL VIOLENCE, AND DESTRUCTION OF PERSONAL\n      PROPERTY), ANY DISPUTE WITH ANY USER, ANY INSTRUCTION, ADVICE, ACT, OR SERVICE PROVIDED BY COMPANY OR ITS AFFILIATES OR LICENSORS AND ANY\n      DESTRUCTION OF YOUR INFORMATION, OTHER THAN PURSUANT TO THE PROTECTION PLEDGE TERMS.\n    </p>\n    <p>\n      UNDER NO CIRCUMSTANCES WILL COMPANY, ITS AFFILIATES, ITS LICENSORS, OR ANY OF SUCH PARTIES' AGENTS, EMPLOYEES, OFFICERS, DIRECTORS, CORPORATE\n      PARTNERS, OR PARTICIPANTS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL OR EXEMPLARY DAMAGES ARISING IN CONNECTION WITH\n      YOUR USE OF OR INABILITY TO USE THE SERVICES, EVEN IF ADVISED OF THE POSSIBILITY OF THE SAME. SOME STATES DO NOT ALLOW THE EXCLUSION OR\n      LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU.\n    </p>\n    <p>COMPANY DOES NOT ACCEPT ANY LIABILITY WITH RESPECT TO THE QUALITY OR FITNESS OF ANY WORK PERFORMED VIA THE SERVICE.</p>\n    <p>\n      IF, NOTWITHSTANDING THE FOREGOING EXCLUSIONS, IT IS DETERMINED THAT COMPANY OR ITS PARTNERS IN PROMOTIONS, SWEEPSTAKES OR CONTESTS, AFFILIATES,\n      ITS LICENSORS, OR ANY OF SUCH PARTIES' AGENTS, EMPLOYEES, OFFICERS, DIRECTORS, CORPORATE PARTNERS, OR PARTICIPANTS IS LIABLE FOR DAMAGES IN\n      EXCESS OF THE PROTECTION PLEDGE TERMS, IN NO EVENT WILL THE AGGREGATE LIABILITY, WHETHER ARISING IN CONTRACT, TORT, STRICT LIABILITY OR\n      OTHERWISE, EXCEED THE TOTAL FEES PAID BY YOU TO COMPANY DURING THE SIX (6) MONTHS PRIOR TO THE TIME SUCH CLAIM AROSE.\n    </p>\n    <p>Indemnification</p>\n    <p>\n      You hereby agree to indemnify, defend, and hold harmless Company, its directors, officers, employees, agents, licensors, attorneys, independent\n      contractors, providers, subsidiaries, and affiliates from and against any and all claim, loss, expense or demand of liability, including\n      attorneys' fees and costs incurred, in connection with (i) your use or inability to use the Service, or (ii) any content submitted by you or\n      using your account to the Service, including, but not limited to the extent such content may infringe on the intellectual rights of a third\n      party or otherwise be illegal or unlawful. Company reserves the right, at its own expense, to assume the exclusive defense and control of any\n      matter otherwise subject to your indemnification. You will not, in any event, settle any claim or matter without the written consent of Company.\n    </p>\n    <p>Dispute Resolution</p>\n    <p>\n      INFORMAL NEGOTIATIONS. To expedite resolution and reduce the cost of any dispute, controversy or claim related to this Agreement (\"Dispute\"),\n      you and Company agree to first attempt to negotiate any Dispute (except those Disputes expressly excluded below) informally for at least thirty\n      (30) days before initiating any arbitration or court proceeding. Such informal negotiations will commence upon written notice. Your address for\n      such notices is your billing address, with an email copy to the email address you have provided to Company. Company's address for such notices\n      is Jobble, Inc., 745 Atlantic Avenue, Boston, MA 02111 Attention: Legal.\n    </p>\n    <p>\n      BINDING ARBITRATION. If you and Company are unable to resolve a Dispute through informal negotiations, all claims arising from use of the\n      Service (except those Disputes expressly excluded below) finally and exclusively resolved by binding arbitration. Any election to arbitrate by\n      one party will be final and binding on the other. YOU UNDERSTAND THAT IF EITHER PARTY ELECTS TO ARBITRATE, NEITHER PARTY WILL HAVE THE RIGHT TO\n      SUE IN COURT OR HAVE A JURY TRIAL. The arbitration will be commenced and conducted under the Commercial Arbitration Rules (the \"AAA Rules\") of\n      the American Arbitration Association (\"AAA\") and, where appropriate, the AAA's Supplementary Procedures for Consumer Related Disputes (\"AAA\n      Consumer Rules\"), both of which are available at the AAA website www.adr.org. Your arbitration fees and your share of arbitrator compensation\n      will be governed by the AAA Rules (and, where appropriate, limited by the AAA Consumer Rules). The arbitration may be conducted in person,\n      through the submission of documents, by phone or online. The arbitrator will make a decision in writing, but need not provide a statement of\n      reasons unless requested by a party. The arbitrator must follow applicable law, and any award may be challenged if the arbitrator fails to do\n      so. Except as otherwise provided in this Agreement, you and Company may litigate in court to compel arbitration, stay proceeding pending\n      arbitration, or to confirm, modify, vacate or enter judgment on the award entered by the arbitrator.\n    </p>\n    <p>\n      EXCEPTIONS TO ALTERNATIVE DISPUTE RESOLUTION. Each party retains the right to bring an individual action in small claims court or to seek\n      injunctive or other equitable relief on an individual basis in a federal or state court in Boston, Massachusetts with respect to any dispute\n      related to the actual or threatened infringement, misappropriation or violation of a party's intellectual property or proprietary rights.\n    </p>\n    <p>\n      WAIVER OF RIGHT TO BE A PLAINTIFF OR CLASS MEMBER IN A PURPORTED CLASS ACTION OR REPRESENTATIVE PROCEEDING. You and Company agree that any\n      arbitration will be limited to the Dispute between Company and you individually. YOU ACKNOLWEDGE AND AGREE THAT YOU AND COMPANY ARE EACH WAIVING\n      THE RIGHT TO PARTICIPATE AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS ACTION OR REPRESENTATIVE PROCEEDING. Further, unless both you and\n      Company otherwise agree, the arbitrator may not consolidate more than one person's claims, and may not otherwise preside over any form of any\n      class or representative proceeding. If this specific paragraph is held unenforceable, then the entirety of this \"Dispute Resolution\" Section\n      will be deemed null and void.\n    </p>\n    <p>\n      LOCATION OF ARBITRATION. Arbitration will take place in Boston, Massachusetts. You and Company agree that for any Dispute not subject to\n      arbitration (other than claims proceeding in any small claims court), or where no election to arbitrate has been made, the Massachusetts state\n      and Federal courts located in Boston, Massachusetts have exclusive jurisdiction and you and Company agree to submit to the personal jurisdiction\n      of such courts.\n    </p>\n    <p>Governing Law</p>\n    <p>\n      You and Company agree that, other than as set forth under the subsection entitled \"Waiver Of Right To Be A Plaintiff Or Class Member In A\n      Purported Class Action Or Representative Proceeding\" above, if any portion of the section entitled \"Dispute Resolution\" is found illegal or\n      unenforceable, that portion will be severed and the remainder of the section will be given full force and effect. Notwithstanding the foregoing,\n      if the subsection entitled \"Exceptions to Alternative Dispute Resolution\" above is found to be illegal or unenforceable, neither you nor Company\n      will elect to arbitrate any Dispute falling within that portion of that subsection that is found to be illegal or unenforceable and such Dispute\n      will be decided by a court of competent jurisdiction within Boston, Massachusetts, and you and Company agree to submit to the personal\n      jurisdiction of that court.\n    </p>\n    <p>\n      Except as expressly provided otherwise, this Agreement will be is governed by, and will be construed under, the laws of the Commonwealth of\n      Massachusetts, without regard to choice of law principles.\n    </p>\n    <p>Special Promotions</p>\n    <p>\n      Company may from time to time provide certain promotional opportunities, sweepstakes and contests to Users. All such promotions will be run at\n      the sole discretion of Company, and can be activated, modified or removed at any time by Company without advance notification and the liability\n      of any of Company's partners pursuant to such promotional opportunities, sweepstakes and contests shall be limited pursuant to the terms of\n      these Terms of Service.\n    </p>\n    <p>No Agency</p>\n    <p>No agency, partnership, joint venture, employer-employee or franchiser-franchisee relationship is intended or created by this Agreement.</p>\n    <p>General Provisions</p>\n    <p>\n      Failure by Company to enforce any provision(s) of this Agreement will not be construed as a waiver of any provision or right. The provisions of\n      this Agreement will be governed by and construed in accordance with the laws of the Commonwealth of Massachusetts, without regard to its\n      conflict of laws rules. This Agreement constitutes the entire agreement between you and Company with respect to its subject matter. If any\n      provision of this Agreement is found to be invalid or unenforceable, the remaining provisions will be enforced to the fullest extent possible,\n      and the remaining provisions will remain in full force and effect. This Agreement will inure to the benefit of Company, its successors and\n      assigns.\n    </p>\n    <p>Changes to this Agreement and the Service</p>\n    <p>\n      Company reserves the right, at its sole and absolute discretion, to change, modify, add to, supplement or delete any of the terms and conditions\n      of this Agreement (including the Privacy Policy) and review, improve, modify or discontinue, temporarily or permanently, the Service or any\n      content or information through the Service at any time, effective with or without prior notice and without any liability to Company. Company\n      will endeavor to notify you of these changes by email, but will not be liable for any failure to do so. If any future changes to this Agreement\n      are unacceptable to you or cause you to no longer be in compliance with this Agreement, you must terminate, and immediately stop using, the\n      Service. Your continued use of the Service following any revision to this Agreement constitutes your complete and irrevocable acceptance of any\n      and all such changes. Company may change, modify, suspend, or discontinue any aspect of the Service at any time without notice or liability.\n      Company may also impose limits on certain features or restrict your access to parts or all of the Service without notice or liability.\n    </p>\n    <button class=\"btn btn-default\" ng-click=\"vm.closeTerms()\" style=\"width: 100%\">Close</button>\n\n    <a class=\"close-reveal-modal\" ng-click=\"vm.closeTerms()\" aria-label=\"Close\">×</a>\n  </div>\n  <div style=\"display: block\" class=\"reveal-modal-bg\"></div>\n</div>\n"

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GlobalmodalController = function () {
	  function GlobalmodalController($http, $state, $stateParams, $scope, AuthService, EventsService, SecurityService, $rootScope, $localStorage, ngProgressFactory, $timeout, $cookies, TrackingService) {
	    _classCallCheck(this, GlobalmodalController);
	
	    this.name = "globalmodal";
	    this.$http = $http;
	    this.$auth = AuthService;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$progress = ngProgressFactory.createInstance();
	    this.$events = EventsService;
	    this.$localStorage = $localStorage;
	    this.$scope = $scope;
	    this.$security = SecurityService;
	    this.$cookies = $cookies;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.currentUser = this.$auth.getUserData();
	    this.remain_loading_count = 0;
	    this.isLazyUser = true;
	    this.errorMessage = { status: false, message: null };
	    this.newUserObj = { email: null, password: null, password2: null };
	    this.showContinueButton = false;
	    this.$tracking = TrackingService;
	    this.check_policy = false;
	    this.displayTOSModal = false;
	    this.phone_class = "";
	    var _this = this;
	
	    console.log("global modal");
	    console.dir(_this.currentUser);
	
	    _this.SetRegistrationLazyListener = _this.$rootScope.$on("SetRegistrationLazy", function ($event, params) {
	      console.log("what are the params SetRegistrationLazyListener");
	      console.dir(params);
	      _this.type = params.type;
	      _this.destroySetRegistrationLazyListener();
	    });
	
	    if (this.currentUser) {
	      if (this.$security.isUndefinedOrNull(this.currentUser.company) || this.$security.isUndefinedOrNull(this.currentUser.company.companyLogoUri)) {
	        this.currentUser.companyProfilePictureUrl = "/app/vendor/images/user-more.png";
	      } else {
	        this.currentUser.companyProfilePictureUrl = this.currentUser.company.companyLogoUri;
	      }
	    }
	
	    _this.$scope.$on("$destroy", _this.SetRegistrationLazyListener);
	  }
	
	  _createClass(GlobalmodalController, [{
	    key: "proceedToOtherModal",
	    value: function proceedToOtherModal() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        _this.$rootScope.globalModalType = { type: 1, name: "test" };
	        jQuery("#show-application-global-modal").trigger("click");
	      }, 1000);
	    }
	
	    /*
	    destroySetRegistrationLazyListener(){
	    var _this=this;
	    console.log('destroySetRegistrationLazyListener.....');
	    console.dir(_this);
	    console.dir(_this.SetRegistrationLazyListener);
	    _this.$scope.$on('$destroy', _this.SetRegistrationLazyListener);
	    }
	    */
	
	  }, {
	    key: "uploadFiles",
	    value: function uploadFiles(file, errors) {
	      var _this = this;
	      var fd = new FormData();
	      fd.append("file", file);
	
	      if (errors.length > 0) {
	        alert("There is an issue with that image. Please choose a different one.");
	        _this.$timeout(function () {
	          _this.$progress.complete();
	        });
	        return;
	      }
	
	      if (file) {
	        _this.$progress.start();
	
	        var uploadUrlCompany = _this.$auth.getUploadUrl(_this.currentUser.company.id, file);
	
	        _this.$http.post(uploadUrlCompany, fd, {
	          transformRequest: _angular2.default.identity,
	          headers: {
	            "Content-Type": undefined,
	            Authorization: "Bearer " + _this.currentUser.access_token
	          }
	        }).then(function (response) {
	          var callback = response.data;
	
	          _this.$timeout(function () {
	            jQuery("#application-global-modal .modal-header button.close").trigger("click");
	            _this.currentUser.company.companyLogoUri = callback.mainFile.url;
	            _this.$rootScope.companyLogoUri = callback.mainFile.url;
	            _this.$rootScope.imgFromProfilePage = callback.mainFile.url;
	            _this.currentUser.companyProfilePictureUrl = _this.currentUser.company.companyLogoUri;
	            _this.$progress.complete();
	            _this.$auth.reloadCurrentUser();
	            _this.$rootScope.$emit("PostEventFromModal", {});
	          }, 100);
	
	          _this.$timeout(function () {
	            $("#ngProgress-container").remove();
	          }, 300);
	        }, function (error) {
	          console.log("error");
	          console.dir(error);
	
	          _this.$timeout(function () {
	            jQuery("#application-global-modal .modal-header button.close").trigger("click");
	            _this.$progress.complete();
	          }, 100);
	        });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate() {
	      var _this = this;
	
	      if (!_this.check_policy) {
	        _this.errorMessage.status = true;
	        _this.errorMessage.message = "Please agree with Jobble Terms.";
	        return;
	      } else {
	        _this.errorMessage.status = false;
	      }
	
	      if (this.phone_class === "error-with-phone") {
	        _this.errorMessage.status = true;
	        _this.errorMessage.message = "Please enter a 10 digit phone number";
	      } else {
	        _this.errorMessage.status = false;
	      }
	    }
	  }, {
	    key: "phoneChange",
	    value: function phoneChange() {
	      var _this = this;
	      console.log("changing phone");
	      console.dir(_this.newUserObj.phoneMobile);
	      console.dir(_this.phone_class);
	      //if (_this.phone_number)
	      if (_this.newUserObj.phoneMobile) {
	        var isPhoneNumber = _this.isPhone(_this.newUserObj.phoneMobile);
	
	        if (!isPhoneNumber) {
	          _this.phone_class = "error-with-phone";
	        } else {
	          _this.phone_class = "";
	        }
	      }
	    }
	  }, {
	    key: "isPhone",
	    value: function isPhone(val) {
	      return (/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(val)
	      );
	    }
	  }, {
	    key: "lazyLogin",
	    value: function lazyLogin() {
	      var _this = this;
	      _this.remain_loading_count++;
	
	      console.log("lazy login??");
	
	      _this.$auth.lazyLoginExists(_this.newUserObj).then(function (data) {
	        console.log("after sign in");
	        console.dir(data);
	
	        if (data.statusText == "OK") {
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("UpdateCurrentUser", { user: data.data });
	            _this.currentUser = data.data;
	          }, 500);
	
	          _this.$timeout(function () {
	            jQuery("#show-application-global-modal").trigger("click");
	            _this.$rootScope.$emit("PostEventFromModal", {});
	          }, 2000);
	        } else {
	          alert("error: " + data.statusText);
	        }
	      }, function (data) {
	        _this.$timeout(function () {
	          _this.remain_loading_count++;
	          jQuery("#show-application-alert").trigger("click");
	          alert("there was an error :" + data);
	        }, 100);
	      });
	    }
	  }, {
	    key: "signInWithNewLazyReg",
	    value: function signInWithNewLazyReg() {
	      var _this = this;
	
	      _this.$auth.lazySignin(_this.newUserObj).then(function (data) {
	        _this.$timeout(function () {
	          _this.remain_loading_count++;
	        }, 500);
	        if (data.statusText == "OK") {
	          _this.$timeout(function () {
	            jQuery("#show-application-global-modal").trigger("click");
	            _this.type = null;
	            _this.currentUser = data.data;
	            _this.$rootScope.$emit("UpdateCurrentUser", { user: data.data });
	            console.log("new current user!");
	            console.dir(_this.currentUser);
	            _this.$tracking.reportUserRegistration(data.data);
	
	            if (_this.currentUser.username.indexOf("jobble.com") === -1 || _this.currentUser.username.indexOf("jobbleapp.com") === -1) {
	              _this.$tracking.reportLazyRegDuringPost(data.data);
	              _this.$tracking.reportLazySignInDuringPost(data.data);
	            }
	          }, 500);
	          _this.$timeout(function () {
	            _this.$rootScope.globalModalType = { type: 2 };
	            jQuery("#show-application-global-modal").trigger("click");
	            _this.step = 3;
	          }, 1500);
	        } else {
	          alert("error: " + data.statusText);
	        }
	      }, function (data) {
	        _this.$timeout(function () {
	          _this.remain_loading_count++;
	          jQuery("#show-application-alert").trigger("click");
	          alert("there was an error :" + data);
	        }, 100);
	      });
	    }
	  }, {
	    key: "checkVerificationStatus",
	    value: function checkVerificationStatus() {
	      var _this = this;
	
	      console.log("checkVerificationStatus2.....");
	
	      _this.remain_loading_count--;
	      _this.$auth.reloadCurrentUser();
	
	      _this.$timeout(function () {
	        _this.currentUser = _this.$auth.getUserData();
	      }, 1500);
	
	      _this.$timeout(function () {
	        if (_this.currentUser.isVerified) {
	          _this.remain_loading_count++;
	          _this.$rootScope.$emit("UpdateEventsToPublished", {});
	          jQuery("#show-application-global-modal").trigger("click");
	        } else {
	          console.log("do i go here");
	          _this.remain_loading_count++;
	          //alert('Verification still pending: Please try again.');
	          _this.verificationError = "Your email confirmation has yet to be confirmed. Please find the email titled 'Please Verify Your Email Address' and click the confirmation link inside.";
	        }
	      }, 2000);
	    }
	  }, {
	    key: "parsePhone",
	    value: function parsePhone(phoneNum) {
	      var phoneNumber = "1" + phoneNum;
	      return phoneNumber.replace(/\D/g, "");
	    }
	  }, {
	    key: "registerNewLazyUser",
	    value: function registerNewLazyUser() {
	      var _this = this;
	
	      _this.remain_loading_count--;
	      _this.validate();
	
	      if (_this.errorMessage.status === true) {
	        _this.remain_loading_count++;
	        return;
	      }
	
	      var cookies = _this.$cookies.getAll();
	
	      var marketingParams = null;
	
	      if (cookies.hubspotutk) {
	        marketingParams = "&hubspotutk=" + cookies.hubspotutk;
	      }
	
	      _this.newUserObj.phoneMobile = _this.parsePhone(_this.newUserObj.phoneMobile);
	
	      _this.$auth.lazyReg(_this.newUserObj, marketingParams).then(function (data) {
	        console.log("response from registering 3");
	        console.dir(data);
	        if (data.data.status == "OK") {
	          _this.signInWithNewLazyReg();
	        } else {
	          _this.$timeout(function () {
	            _this.errorMessage.status = true;
	            if (data.data.errors) {
	              _this.errorMessage.message = data.data.errors.message;
	            } else {
	              if (data.data.message.indexOf("Duplicate entry") > -1) {
	                _this.errorMessage.message = "This username already exists. Please try another.";
	              } else {
	                _this.errorMessage.message = "There was an error with your registration from the server. Please contact corey@jobbleapp.com";
	              }
	            }
	          });
	          _this.$timeout(function () {
	            _this.remain_loading_count++;
	          });
	        }
	      }, function (data) {
	        _this.$timeout(function () {
	          _this.remain_loading_count++;
	          console.log("what is the data");
	          console.dir(data);
	          jQuery("#show-application-alert").trigger("click");
	          alert("there was an error2 :" + data);
	        }, 100);
	      });
	    }
	  }, {
	    key: "showSignInScreen",
	    value: function showSignInScreen() {
	      var _this = this;
	
	      if (_this.isLazyUser) {
	        _this.isLazyUser = false;
	      } else {
	        _this.isLazyUser = true;
	      }
	    }
	  }, {
	    key: "closeTerms",
	    value: function closeTerms() {
	      this.displayTOSModal = false;
	    }
	  }]);
	
	  return GlobalmodalController;
	}();
	
	GlobalmodalController.$inject = ["$http", "$state", "$stateParams", "$scope", "auth", "events", "security", "$rootScope", "$localStorage", "ngProgressFactory", "$timeout", "$cookies", "tracking"];
	
	exports.default = GlobalmodalController;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(167);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./globalmodal.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./globalmodal.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".globalalert{color:red}", ""]);
	
	// exports


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _applyProfileModal = __webpack_require__(169);
	
	var _applyProfileModal2 = _interopRequireDefault(_applyProfileModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var applyPopupModule = _angular2.default.module("applyProfileModal", [_angularUiRouter2.default]).component("applyProfileModal", _applyProfileModal2.default);
	
	exports.default = applyPopupModule;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _applyProfileModal = __webpack_require__(170);
	
	var _applyProfileModal2 = _interopRequireDefault(_applyProfileModal);
	
	var _applyProfileModal3 = __webpack_require__(171);
	
	var _applyProfileModal4 = _interopRequireDefault(_applyProfileModal3);
	
	__webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var applyProfileModalComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _applyProfileModal2.default,
	  controller: _applyProfileModal4.default,
	  controllerAs: "vm"
	};
	
	exports.default = applyProfileModalComponent;

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	module.exports = "<a href=\"#\" data-toggle=\"modal\" data-target=\"#apply-profile-modal\" id=\"apply-profile-modal-click\"></a>\n\n<div class=\"apply-profile-modal\">\n    <divapplyToJobble\n            class=\"modal\"\n            id=\"apply-profile-modal\"\n            tabindex=\"-1\"\n            role=\"dialog\"\n            ng-class=\"{'modal-fixed': vm.mobile_UI.mobile_device_type=='iPhone'}\"\n            style=\"position:fixed;\"\n            data-keyboard=\"false\" data-backdrop=\"static\">\n        >\n\n        <div\n                class=\"modal-dialog modal-m regi-form-board partner\"\n                role=\"document\"\n                ng-if=\"vm.jobble && vm.jobble.is_partner_post\">\n            <div class=\"modal-gradient-banner\"></div>\n\n            <div class=\"modal-content\">\n                <div class=\"modal-fixed-bar\">\n                    <div class=\"save-exit\" ng-click=\"vm.exit()\">\n                        <i class=\"fas fa-times\"></i>\n                    </div>\n                </div>\n                <div class=\"modal-content-container\">\n                    <div>\n                        <h3>Sign up for Job Alerts and be the first to know about flexible work in your area</h3>\n                    </div>\n                    <div>\n                        <label>Email</label>\n                        <input\n                                type=\"email\"\n                                class=\"\"\n                                placeholder=\"Email Address\"\n                                name=\"email\"\n                                ng-model=\"vm.partnerEmail\"\n                                required\n                                autofocus\n                        />\n                    </div>\n\n                    <div>\n                        <div class=\"continue-button\"\n                             ng-disabled=\"vm.buttonDisabled\"\n                             ng-click=\"vm.partnerRegister()\"\n                        >\n                            Continue to {{vm.jobble.companyName}}\n                        </div>\n                    </div>\n\n                    <div class=\"terms-and-service\">\n                        By signing up, you are agreeing with the <a class=\"policy\"\n                                                                    href=\"https://jobble.com/terms-of-service/\"\n                                                                    target=\"_blank\">Jobble Terms and Conditions\n                    </a>, <a href=\"https://kb.jobble.com/privacy/\" target=\"_blank\">Privacy Policy</a>, and\n                        <a class=\"policy\" href=\"https://stripe.com/connect-account/legal\" target=\"_blank\">\n                            Stripe Connected Account Agreement.\n                        </a>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n\n        <div\n                class=\"modal-dialog modal-m regi-form-board sign-in-modal\"\n                role=\"document\" ng-if=\"!(vm.jobble && vm.jobble.is_partner_post) && vm.noUser && vm.loggingIn\">\n            <div class=\"modal-gradient-banner\"></div>\n            <div class=\"modal-content\">\n                <div class=\"modal-fixed-bar\">\n                    <div class=\"save-exit\" ng-click=\"vm.exit()\">\n                        <i class=\"fas fa-times\"></i>\n                    </div>\n                </div>\n\n                <div class=\"modal-content-container\">\n\n                    <div>\n                        <h3>Sign In</h3>\n                        <p>Become a Jobbler and apply to thousands of flexible jobs in your area</p>\n                    </div>\n                    <div>\n                        <div>\n                            <div class=\"input-container\">\n                                <i class=\"far fa-envelope\"></i>\n                                <input type=\"email\" placeholder=\"Email address\"\n                                       name=\"email\" ng-model=\"vm.user.email\" required/>\n                            </div>\n                            <div class=\"input-container\">\n                                <i class=\"fas fa-key\"></i>\n                                <input type=\"password\" placeholder=\"Password\" name=\"password\"\n                                       ng-model=\"vm.user.password\" required/>\n                            </div>\n                        </div>\n\n                        <div style=\"display: none;\">\n                            <div style=\"display:flex; margin-top: 10px\">\n                                <div style=\"flex:0 0 15px; padding-top: 2px;\">\n                                    <input style=\"border: 1px solid #767676;  box-shadow: none;height: 15px;\"\n                                           type=\"checkbox\"/>\n                                </div>\n                                <div style=\"flex:1; padding-left: 4px; margin-top: 0; padding-top: 4.5px; text-align: left\"\n                                     class=\"login-text\">Do Not Sell My Info\n                                </div>\n\n                            </div>\n                        </div>\n\n                        <div>\n                            <div class=\"continue-button\"\n                                 ng-disabled=\"vm.buttonDisabled\"\n                                 ng-click=\"vm.signin(true)\"\n                            >\n                                <span ng-if=\"vm.buttonDisabled\"><i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i></span>\n                                <span ng-if=\"!vm.buttonDisabled\">Sign In</span>\n                            </div>\n                        </div>\n\n                        <div class=\"error-text\" ng-show=\"vm.signinError\">\n                            <i class=\"fas fa-exclamation-circle\"></i> {{vm.signinError}}\n                        </div>\n\n                        <div>\n                            <a href=\"/recover\" target=\"_blank\">\n                                <div class=\"forgot-password-text\">Forgot Password?</div>\n                            </a>\n                        </div>\n\n                        <div>\n                            <div\n                                    ng-click=\"vm.showRegistrationModal()\"\n                                    class=\"sign-up-text\">Don't have an account? <span>Sign up</span>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n\n\n            </div>\n        </div>\n\n        <div\n                class=\"modal-dialog modal-m regi-form-board sign-in\"\n                role=\"document\"\n                ng-if=\"!(vm.jobble && vm.jobble.is_partner_post) && vm.noUser && !vm.loggingIn\">\n            <div class=\"modal-gradient-banner\"></div>\n            <div class=\"modal-content\">\n\n                <div class=\"modal-fixed-bar\">\n                    <div class=\"save-exit\" ng-click=\"vm.exit()\">\n                        <i class=\"fas fa-times\"></i>\n                    </div>\n                </div>\n\n                <div class=\"modal-content-container\" ng-if=\"vm.confirmEmailBool==true\">\n\n                    <h3>Confirm email</h3>\n                    <p>This is the email address associated with your account. If this address is correct, no action is\n                        required. If the address is incorrect, please enter the correct address.</p>\n\n                    <form ng-submit=\"vm.sendConfirmedEmail()\">\n                        <label>Email</label>\n                        <input\n                                type=\"email\"\n                                class=\"\"\n                                placeholder=\"Email address\"\n                                name=\"email\"\n                                ng-model=\"vm.signOnEmail\"\n                                ng-change=\"vm.validator.email(vm.signOnEmail, vm)\"\n                                ng-style=\"vm.validation.email.style\"\n                                required\n                                autofocus\n                        />\n                        <div\n                                class=\"input-error-text\"\n                                ng-show=\"vm.validation.email.message\">\n                            <i class=\"fas fa-exclamation-circle\"></i>\n                            Please enter a valid email\n                        </div>\n                        <input\n                                type=\"submit\"\n                                value=\"Continue with this email\"\n                                class=\"company-name-signon\"\n                        />\n                    </form>\n\n                </div>\n\n                <div class=\"modal-content-container\" ng-if=\"!vm.confirmEmailBool\">\n                    <div>\n                        <h3>Create an Account</h3>\n                        <p>Become a Jobbler and apply to thousands of flexible jobs in your area.</p>\n                    </div>\n                    <div ng-if=\"vm.userNeedsToSignIn==false\">\n                        <div class=\"sign-on-holder\" style=\"margin-top:15px;\">\n                            <div class=\"third-party-wrapper\">\n                                <div id=\"g-signin2\" data-onsuccess=\"onSignIn\">\n\n                                </div>\n                            </div>\n\n                            <div class=\"third-party-wrapper\" id=\"fbloginonboard\">\n                                <!--\n                                <fb:login-button \n                                  scope=\"email\"\n                                  onlogin=\"window.fbOnLogin()\"\n                                  data-width=\"274\" \n                                  data-size=\"large\" \n                                  data-button-type=\"continue_with\" \n                                  data-layout=\"default\" \n                                  data-auto-logout-link=\"false\" \n                                  data-use-continue-as=\"false\">\n                                </fb:login-button>\n                                -->\n                            </div>\n\n                            <div class=\"third-party-wrapper\">\n                                <div\n                                        id=\"appleid-signin\"\n                                        data-mode=\"center-align\"\n                                        data-type=\"continue\"\n                                        data-color=\"black\"\n                                        data-border=\"true\"\n                                        data-border-radius=\"15\"\n                                        data-width=\"274\"\n                                        data-height=\"40\"\n                                        data-logo-size=\"small\"\n                                        data-logo-position=\"16\"\n                                        data-label-position=\"50\">\n\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"line-holder\">\n                            <div class=\"left-line\"></div>\n\n                            <span>OR</span>\n\n                            <div class=\"right-line\"></div>\n                        </div>\n\n                    </div>\n\n                    <div>\n                        <div class=\"\">\n                            <div class=\"input-container\">\n                                <i class=\"far fa-envelope\"></i>\n                                <input\n                                        class=\"\"\n                                        placeholder=\"Email address\"\n                                        name=\"email\"\n                                        ng-model=\"vm.user.email\"\n                                        required\n                                        autofocus\n                                />\n                            </div>\n                            <div class=\"input-container\">\n                                <i class=\"fas fa-key\"></i>\n                                <input\n                                        type=\"password\"\n                                        class=\"\"\n                                        placeholder=\"Password\"\n                                        name=\"password\"\n                                        ng-model=\"vm.user.password\"\n                                        required\n                                />\n                            </div>\n                        </div>\n\n                        <div style=\"display: none;\">\n                            <div style=\"display:flex; margin-top: 10px\">\n                                <div style=\"flex:0 0 15px; padding-top: 2px;\">\n                                    <input style=\"border: 1px solid #767676;  box-shadow: none;height: 15px;\"\n                                           type=\"checkbox\"/>\n                                </div>\n                                <div style=\"display: none; flex:1; padding-left: 4px; margin-top: 0; padding-top: 4.5px; text-align: left\"\n                                     class=\"login-text\">Do Not Sell My Info\n                                </div>\n\n                            </div>\n                        </div>\n\n                        <div>\n                            <div class=\"continue-button\"\n                                 ng-disabled=\"vm.buttonDisabled\"\n                                 ng-click=\"vm.register()\"\n                            >\n                                <span ng-if=\"vm.buttonDisabled\"><i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i></span>\n                                <span ng-if=\"!vm.buttonDisabled\">Sign up</span>\n                            </div>\n                        </div>\n\n                        <div class=\"error-text\" ng-show=\"vm.errorTextRegi\">\n                            <i class=\"fas fa-exclamation-circle\"></i> {{vm.errorTextRegi}}\n                        </div>\n\n                    </div>\n\n                    <div class=\"login-text\">\n                        <div ng-click=\"vm.showLogin()\">Already have an account? <span>Sign in</span></div>\n                    </div>\n\n                    <div class=\"terms-and-service\">\n                        By signing up, you are agreeing with the <a class=\"policy\"\n                                                                    href=\"https://jobble.com/terms-of-service/\"\n                                                                    target=\"_blank\">Jobble Terms and Conditions\n                    </a>, <a href=\"https://kb.jobble.com/privacy/\" target=\"_blank\">Privacy Policy</a>, and\n                        <a class=\"policy\" href=\"https://stripe.com/connect-account/legal\" target=\"_blank\">\n                            Stripe Connected Account Agreement.\n                        </a>\n                    </div>\n\n                </div>\n\n            </div>\n        </div>\n\n        <div class=\"modal-dialog modal-m profile\" role=\"document\"\n             ng-if=\"!(vm.jobble && vm.jobble.is_partner_post) && vm.currentUser && (!vm.userReady || !(vm.paymentReady || vm.paymentSkipped))\">\n            <div class=\"modal-gradient-banner\"></div>\n\n            <div class=\"modal-content\">\n                <div class=\"modal-fixed-bar\">\n                    <div class=\"progress-dot-container\">\n                        <div class=\"progress-dot\" ng-click=\"vm.setProfilePage(vm.$profile.COMPLETE_PROFILE)\"\n                             ng-class=\"{'current-dot': vm.userProfileStatus === vm.$profile.COMPLETE_PROFILE}\"></div>\n                        <div\n                                class=\"progress-dot\"\n                                ng-click=\"vm.setProfilePage(vm.$profile.VERIFY_PHONE)\"\n                                ng-class=\"{'current-dot': vm.userProfileStatus === vm.$profile.VERIFY_PHONE || vm.userProfileStatus === vm.$profile.INPUT_PHONE_NUMBER}\"></div>\n                        <div class=\"progress-dot\" ng-click=\"vm.setProfilePage(vm.$profile.LOCATION)\"\n                             ng-class=\"{'current-dot': vm.userProfileStatus === vm.$profile.LOCATION}\"></div>\n                        <div class=\"progress-dot\" ng-click=\"vm.setProfilePage(vm.$profile.WORK_ELIGIBILITY)\"\n                             ng-class=\"{'current-dot': vm.userProfileStatus === vm.$profile.WORK_ELIGIBILITY}\"></div>\n                        <div class=\"progress-dot\" ng-click=\"vm.setProfilePage(vm.$profile.BG_CONSENT)\"\n                             ng-class=\"{'current-dot': vm.userProfileStatus === vm.$profile.BG_CONSENT}\"></div>\n                        <div class=\"progress-dot\" ng-click=\"vm.setProfilePage(vm.$profile.PROFILE_PICTURE)\"\n                             ng-class=\"{'current-dot': vm.userProfileStatus === vm.$profile.PROFILE_PICTURE}\"></div>\n                        <div class=\"progress-dot\" ng-click=\"vm.setProfilePage(vm.$profile.PAYMENTS)\"\n                             ng-class=\"{'current-dot': vm.userProfileStatus === vm.$profile.PAYMENTS}\"></div>\n                    </div>\n                    <div class=\"save-exit\" ng-click=\"vm.saveAndExit()\">\n                        <span>Save & Exit</span>\n                        <i class=\"fas fa-times\"></i>\n                    </div>\n                </div>\n                <div class=\"modal-profile-content\">\n                    <div ng-if=\"vm.userProfileStatus === vm.$profile.COMPLETE_PROFILE\">\n                        <div>\n                            <h3>Complete your profile</h3>\n                            <p>Please complete a one-time profile setup so that we may submit your profile to hiring\n                                managers. This only takes a few minutes.</p>\n                        </div>\n                        <div>\n                            <h4>Personal Details</h4>\n                        </div>\n                        <div>\n                            <label>Preferred name / Nickname (optional)</label>\n                            <input ng-model=\"vm.ui_user_model.nickname\"\n                                   ng-change=\"vm.formChange('nickname', vm.$profile.COMPLETE_PROFILE)\"\n                                   ng-class=\"{'input-error': vm.errors['firstName']}\"/>\n                            <label>Legal first name</label>\n                            <input ng-model=\"vm.ui_user_model.firstName\"\n                                   ng-change=\"vm.formChange('firstName', vm.$profile.COMPLETE_PROFILE)\"\n                                   ng-class=\"{'input-error': vm.errors['firstName']}\"/>\n                            <div class=\"input-error-text\" ng-show=\"vm.errors['firstName']\"><i\n                                    class=\"fas fa-exclamation-circle\"></i> Please enter a valid first name\n                            </div>\n                            <label>Legal last name</label>\n                            <input ng-model=\"vm.ui_user_model.lastName\"\n                                   ng-change=\"vm.formChange('lastName', vm.$profile.COMPLETE_PROFILE)\"\n                                   ng-class=\"{'input-error': vm.errors['lastName']}\"/>\n                            <div class=\"input-error-text\" ng-show=\"vm.errors['lastName']\"><i\n                                    class=\"fas fa-exclamation-circle\"></i> Please enter a valid last name\n                            </div>\n\n                            <!--\n                            <label>Mobile phone number</label>\n                            <input ng-model=\"vm.ui_user_model.homeContactInfo.phoneMobile\" ng-change=\"vm.formChange('phoneMobile', vm.$profile.COMPLETE_PROFILE)\" ng-class=\"{'input-error': vm.errors['phoneMobile']}\"/>\n                            <div class=\"input-error-text\" ng-show=\"vm.errors['phoneMobile']\"><i class=\"fas fa-exclamation-circle\"></i> Please enter a valid phone number</div>\n                            -->\n                        </div>\n                        <div ng-if=\"!vm.savingProfile\" class=\"continue-button\"\n                             ng-click=\"vm.submitAndSaveUser(vm.$profile.COMPLETE_PROFILE)\">\n                            Save And Continue\n                        </div>\n                        <div ng-if=\"vm.savingProfile\" class=\"continue-button\" style=\"opacity: 0.5; cursor: wait\">\n                            Saving <i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i>\n                        </div>\n                    </div>\n\n\n                    <div ng-if=\"vm.userProfileStatus === vm.$profile.VERIFY_PHONE\">\n                        <div>\n                            <h3>Verify your mobile number</h3>\n                            <p>To ensure your success on the Jobble platform please provide your mobile number. We will\n                                send you a verification link that will be required to proceed.</p>\n                        </div>\n                        <div>\n                            <label>10 digit Mobile phone number (do not include 1)</label>\n                            <input ng-model=\"vm.ui_user_model.homeContactInfo.phoneMobile\"\n                                   ng-change=\"vm.formChange('phoneMobile', vm.$profile.VERIFY_PHONE)\"\n                                   ng-class=\"{'input-error': vm.errors['phoneMobile']}\"/>\n                            <div class=\"input-error-text\" ng-show=\"vm.errors['phoneMobile']\"><i\n                                    class=\"fas fa-exclamation-circle\"></i> Please enter a valid phone number\n                            </div>\n                        </div>\n                        <div class=\"terms-and-service sms-policy-signing\">\n                            <input \n                                type=\"checkbox\"\n                                ng-model=\"vm.smsAgreementVal\" \n                                ng-click=\"vm.smsAgreement(vm.smsAgreementVal)\"\n                            />\n                            By checking this box and providing your phone number, you expressly consent \n                            to receive automated marketing text messages, emails, calls, and prerecorded \n                            messages from Jobble, Inc., its affiliates, and <a \n                            class=\"policy\"\n                            href=\"https://jobble.com/marketing-partners/\"\n                            target=\"_blank\"> marketing partners</a>, even if \n                            your number is listed on a Do Not Call Registry. Message frequency varies. Consent \n                            is not required to make a purchase or use Jobble services. Msg & data rates \n                            may apply. Text STOP to unsubscribe or HELP for help. By consenting, you also \n                            agree to <a \n                            class=\"policy\"\n                            href=\"https://jobble.com/sms-terms-and-conditions/\"\n                            target=\"_blank\">Jobble’s SMS Policy</a>, <a \n                            class=\"policy\"\n                            href=\"https://jobble.com/terms-of-service/\"\n                            target=\"_blank\">Terms of Service</a>, and <a \n                            class=\"policy\"\n                            href=\"https://jobble.com/privacy-policy/\"\n                            target=\"_blank\">Privacy Policy</a>.                            \n                        </div>\n                        <div\n                                ng-if=\"!vm.savingProfile\"\n                                class=\"continue-button\"\n                                ng-click=\"vm.submitAndSaveUser(vm.$profile.VERIFY_PHONE)\">\n                            Save And Continue\n                        </div>\n                        <div ng-if=\"vm.savingProfile\" class=\"continue-button\" style=\"opacity: 0.5; cursor: wait\">\n                            Saving <i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i>\n                        </div>\n                    </div>\n\n\n                    <div ng-if=\"vm.userProfileStatus === vm.$profile.INPUT_PHONE_NUMBER\">\n                        <div>\n                            <h3>Let us know it’s you</h3>\n                            <p>We just sent a 6 digit verification code to\n                                {{vm.ui_user_model.homeContactInfo.phoneMobile}}. Please enter this code below to ensure\n                                we have the correct mobile number:</p>\n                            <div class=\"sms-code-container\">\n                                <input\n                                        class=\"\"\n                                        id=\"sms-code-1\"\n                                        ng-model=\"vm.smsCode_1\"\n                                        ng-change=\"vm.codeEntered(1)\"\n                                        ng-keydown=\"vm.smsCodeBackSpace($event,1)\"\n                                        required\n                                        autofocus\n                                        maxlength=\"1\"\n                                />\n                                <input\n                                        class=\"\"\n                                        id=\"sms-code-2\"\n                                        ng-model=\"vm.smsCode_2\"\n                                        ng-change=\"vm.codeEntered(2)\"\n                                        ng-keydown=\"vm.smsCodeBackSpace($event,2)\"\n                                        required\n                                        autofocus\n                                        maxlength=\"1\"\n                                />\n                                <input\n                                        class=\"\"\n                                        id=\"sms-code-3\"\n                                        ng-model=\"vm.smsCode_3\"\n                                        ng-change=\"vm.codeEntered(3)\"\n                                        ng-keydown=\"vm.smsCodeBackSpace($event,3)\"\n                                        required\n                                        autofocus\n                                        maxlength=\"1\"\n                                />\n                                <input\n                                        class=\"\"\n                                        id=\"sms-code-4\"\n                                        ng-model=\"vm.smsCode_4\"\n                                        ng-change=\"vm.codeEntered(4)\"\n                                        ng-keydown=\"vm.smsCodeBackSpace($event,4)\"\n                                        required\n                                        autofocus\n                                        maxlength=\"1\"\n                                />\n                                <input\n                                        class=\"\"\n                                        id=\"sms-code-5\"\n                                        ng-model=\"vm.smsCode_5\"\n                                        ng-change=\"vm.codeEntered(5)\"\n                                        ng-keydown=\"vm.smsCodeBackSpace($event,5)\"\n                                        required\n                                        autofocus\n                                        maxlength=\"1\"\n                                />\n                                <input\n                                        class=\"\"\n                                        id=\"sms-code-6\"\n                                        ng-model=\"vm.smsCode_6\"\n                                        ng-change=\"vm.codeEntered(6)\"\n                                        ng-keydown=\"vm.smsCodeBackSpace($event,6)\"\n                                        required\n                                        autofocus\n                                        maxlength=\"1\"\n                                />\n                            </div>\n                        </div>\n                        <!--\n                        <div>\n                            <div>\n                                <div class=\"continue-button\" ng-click=\"vm.validateSMSCode()\">\n                                    Send mobile app link\n                                </div>\n                            </div>\n                        </div>\n                        -->\n                        <div ng-if=\"vm.smsVerificationError\">\n                            <div class=\"error-text\">\n                                <i class=\"fas fa-exclamation-circle\"></i> {{ vm.smsVerificationErrorText }}\n                            </div>\n                        </div>\n                        <div class=\"terms-and-service\" style=\"border: none; margin-top: 0;\">\n                            Didn't receive a code? <span ng-click=\"vm.backToPhoneVerification()\"\n                                                         style=\"cursor: pointer; color: #62C046\">Try again</span>\n                        </div>\n\n                    </div>\n\n\n                    <div ng-if=\"vm.userProfileStatus === vm.$profile.LOCATION\">\n                        <div>\n                            <h3>Location</h3>\n                        </div>\n                        <div>\n                            <label>Street Address</label>\n                            <input ng-model=\"vm.ui_user_model.homeContactInfo.streetLine1\"\n                                   ng-change=\"vm.formChange('streetLine1', vm.$profile.LOCATION)\"\n                                   ng-class=\"{'input-error': vm.errors['streetLine1']}\"/>\n                            <div class=\"input-error-text\" ng-show=\"vm.errors['streetLine1']\"><i\n                                    class=\"fas fa-exclamation-circle\"></i> Please enter a valid street address\n                            </div>\n                            <label>City</label>\n                            <input ng-model=\"vm.ui_user_model.homeContactInfo.city\"\n                                   ng-change=\"vm.formChange('city', vm.$profile.LOCATION)\"\n                                   ng-class=\"{'input-error': vm.errors['city']}\"/>\n                            <div class=\"input-error-text\" ng-show=\"vm.errors['city']\"><i\n                                    class=\"fas fa-exclamation-circle\"></i> Please enter a valid city\n                            </div>\n                            <label>State</label>\n                            <select\n                                    ng-model=\"vm.ui_user_model.homeContactInfo.state\"\n                                    ng-options=\"state for state in vm.states.values\"\n                                    ng-change=\"vm.formChange('state', vm.$profile.LOCATION)\"\n                                    ng-class=\"{'select-error': vm.errors['state']}\"\n                            >\n                            </select>\n                            <div class=\"input-error-text\" ng-show=\"vm.errors['state']\"><i\n                                    class=\"fas fa-exclamation-circle\"></i> Please enter a valid state\n                            </div>\n                            <label>Zip Code</label>\n                            <input ng-model=\"vm.ui_user_model.homeContactInfo.zipCode\"\n                                   ng-change=\"vm.formChange('zipCode', vm.$profile.LOCATION)\"\n                                   ng-class=\"{'input-error': vm.errors['zipCode']}\"/>\n                            <div class=\"input-error-text\" ng-show=\"vm.errors['zipCode']\"><i\n                                    class=\"fas fa-exclamation-circle\"></i> Please enter a valid zip code\n                            </div>\n                        </div>\n                        <div ng-if=\"!vm.savingProfile\" class=\"continue-button\"\n                             ng-click=\"vm.submitAndSaveUser(vm.$profile.LOCATION)\">\n                            Save And Continue\n                        </div>\n                        <div ng-if=\"vm.savingProfile\" class=\"continue-button\" style=\"opacity: 0.5; cursor: wait\">\n                            Saving <i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i>\n                        </div>\n                    </div>\n\n                    <div ng-if=\"vm.userProfileStatus === vm.$profile.WORK_ELIGIBILITY\">\n                        <div>\n                            <h3>Work eligibility</h3>\n                            <p>The following information will be used to verify your identity, confirm work\n                                authorization, and complete a background check to protect you and our hiring\n                                companies.</p>\n                            <p>This step is required to work any job labeled \"Jobble Gig.\"\n                                Once a hiring company extends an offer, we will perform a background check. This will\n                                remain valid for one year. Learn more <a\n                                        style=\"color: #62C046; font-weight: 600\" target=\"_blank\"\n                                        href=\"https://intercom.help/jobble/en/articles/4153956-why-do-i-need-to-provide-my-social-security-number\">here</a>.\n                            </p>\n                        </div>\n                        <div>\n                            <label>SSN <span style=\"font-size: 12px;color: #5E666D;margin-left: 8px;\"\n                                             data-toggle=\"tooltip\" data-placement=\"bottom\"\n                                             title=\"A Social Security Number or Individual Taxpayer Identification Number is required to work.\"><i\n                                    class=\"fas fa-info-circle\"></i></span></label>\n                            <input ng-model=\"vm.ui_user_model.ssn\"\n                                   ng-change=\"vm.formChange('ssn', vm.$profile.WORK_ELIGIBILITY)\"\n                                   ng-class=\"{'input-error': vm.errors['ssn']}\"/>\n                            <div class=\"input-error-text\" ng-show=\"vm.errors['ssn']\"><i\n                                    class=\"fas fa-exclamation-circle\"></i> 9 digit SSN required\n                            </div>\n                            <label>Re-enter SSN</label>\n                            <input ng-model=\"vm.ui_user_model.ssn_confirm\"\n                                   ng-change=\"vm.formChange('ssn_confirm', vm.$profile.WORK_ELIGIBILITY)\"\n                                   ng-class=\"{'input-error': vm.errors['ssn_confirm']}\"/>\n                            <div class=\"input-error-text\" ng-show=\"vm.errors['ssn_confirm']\"><i\n                                    class=\"fas fa-exclamation-circle\"></i> SSN must match\n                            </div>\n                            <label>Date of birth <span style=\"font-size: 12px;color: #5E666D;margin-left: 8px;\"\n                                                       data-toggle=\"tooltip\" data-placement=\"bottom\"\n                                                       title=\"You must be at least 18 years old or the age of legal majority in your jurisdiction.\"><i\n                                    class=\"fas fa-info-circle\"></i></span></label>\n                            <input id=\"datepicker\" ng-model=\"vm.ui_user_model.dateBirth\"\n                                   ng-change=\"vm.formChange('dateBirth', vm.$profile.WORK_ELIGIBILITY)\"\n                                   ng-class=\"{'input-error': vm.errors['dateBirth']}\"/>\n                            <div class=\"input-error-text\" ng-show=\"vm.errors['dateBirth']\"><i\n                                    class=\"fas fa-exclamation-circle\"></i> Please enter a valid date of birth. You must\n                                be over 18.\n                            </div>\n                            <div class=\"input-error-text\" ng-show=\"vm.dupeSSN == true\"><i\n                                    class=\"fas fa-exclamation-circle\"></i> The SSN you attempted to enter already\n                                exists in our system. Please try again.\n                            </div>\n                        </div>\n                        <div ng-if=\"!vm.savingProfile\" class=\"continue-button\"\n                             ng-click=\"vm.submitAndSaveUser(vm.$profile.WORK_ELIGIBILITY)\">\n                            Save And Continue\n                        </div>\n                        <div ng-if=\"vm.savingProfile\" class=\"continue-button\" style=\"opacity: 0.5; cursor: wait\">\n                            Saving <i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i>\n                        </div>\n                    </div>\n\n                    <div ng-if=\"vm.userProfileStatus === vm.$profile.BG_CONSENT\">\n                        <div>\n                            <h3>Work eligibility</h3>\n                            <p>The following information will be used to verify your identity, confirm work\n                                authorization, and complete a background check to protect you and our hiring\n                                companies.</p>\n                            <p>This step is required to work any job labeled \"Jobble Gig.\"\n                                Once a hiring company extends an offer, we will perform a background check. This will\n                                remain valid for one year.</p>\n                            <object data=\"https://jobble.com/work-authorization/\"\n                                    width=\"400\"\n                                    height=\"300\"\n                                    type=\"text/html\">\n                            </object>\n\n                            <div class=\"row\">\n                                <div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-1\">\n                                    <input class=\"consent-button\"\n                                           type=\"checkbox\" ng-model=\"vm.bgConsent\"\n                                           ng-checked=\"vm.consentToBgCheck(vm.bgConsent)\"/>\n                                </div>\n                                <div class=\"col-lg-11 col-md-11 col-sm-11 col-xs-11\">\n                                    <span>I would like to receive a free copy of the report obtained by Jobble Inc., from\n                                        Sterling</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div>\n                            <div ng-if=\"vm.savingProfile\" class=\"continue-button\"\n                                 style=\"opacity: 0.5; cursor: wait\">\n                                Saving <i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i>\n                            </div>\n                            <div ng-if=\"!vm.savingProfile\" class=\"continue-button\"\n                                 ng-click=\"vm.consentForm(vm.$profile.BG_CONSENT)\">\n                                I Agree\n                            </div>\n                        </div>\n                    </div>\n\n\n                    <div ng-if=\"vm.userProfileStatus === vm.$profile.PROFILE_PICTURE\">\n                        <div>\n                            <h3>Profile picture</h3>\n                            <p>Please upload one high quality, front-facing photo of yourself so that hiring managers\n                                can recognize you</p>\n                        </div>\n\n                        <div class=\"upload-btn-wrapper\">\n                            <button class=\"btn\">Choose file</button>\n                            <input id=\"profile-photo-upload\" type=\"file\" accept=\"image/*\"\n                                   onchange=\"angular.element(this).scope().vm.uploadProfilePhoto()\" name=\"myfile\"/>\n                        </div>\n\n                        <div>\n                            <div class=\"profile-image-container\"\n                                 style=\"background-image: url({{($root.imgFromProfilePage || vm.ui_user_model.profilePictureUri)}})\">\n                                <!--                                <img ng-if=\"!$root.imgFromProfilePage && vm.ui_user_model.profilePictureUri\" src=\"{{vm.ui_user_model.profilePictureUri}}\"/>-->\n                                <!--                                <img ng-if=\"$root.imgFromProfilePage\" src=\"{{$root.imgFromProfilePage }}\"/>-->\n                                <i ng-if=\"vm.uploadingProfile\" class=\"fas fa-spin fa-spinner fa-1x fa-fw\"></i>\n                            </div>\n                        </div>\n                        <div class=\"continue-button\" ng-click=\"vm.canUserApplyToShiftBasedJobs()\">\n                            Save And Continue\n                        </div>\n                    </div>\n                    <div ng-if=\"vm.userProfileStatus === vm.$profile.PAYMENTS\">\n                        <div>\n                            <h3>Payments</h3>\n                            <p>In order to receive payments from Jobble, you must link either a debit card or bank\n                                account to. your profile.</p>\n                        </div>\n\n                        <div>\n                            <div ng-repeat=\"bank in vm.banks track by $index\" class=\"payment-card-container\">\n                                <div>Bank Account</div>\n                                <div class=\"card-number\">**** **** **** {{bank.last4}}</div>\n                            </div>\n                            <div ng-repeat=\"card in vm.cards track by $index\" class=\"payment-card-container\">\n                                <div>Debit Card</div>\n                                <div class=\"card-number\">**** **** **** {{card.last4}}</div>\n                            </div>\n                        </div>\n\n                        <div style=\"margin-top: 16px\" ng-if=\"true\">\n                            <div>\n                                <select ng-model=\"vm.cardType\">\n                                    <option value=\"bank\">Link bank account</option>\n                                    <option value=\"card\">Link debit card</option>\n                                </select>\n                            </div>\n                            <div ng-if=\"vm.cardType === 'bank'\">\n                                <label>Account Holder Name</label>\n                                <input ng-model=\"vm.accountHolderName\"/>\n                                <label>Routing Number</label>\n                                <input ng-model=\"vm.routingNumber\"/>\n                                <label>Account Number</label>\n                                <input ng-model=\"vm.accountNumber\"/>\n                                <div class=\"error-text\" ng-show=\"vm.bankTokenError\">\n                                    <i class=\"fas fa-exclamation-circle\"></i> {{vm.bankTokenError}}\n                                </div>\n                                <div class=\"save-transactions\">Safe transactions through <img\n                                        src=\"/app/vendor/images/stripe-logo.png\" alt=\"Stripe Logo\"></div>\n                                <div class=\"skip-for-now\" ng-click=\"vm.skipPayment()\">Skip for now</div>\n\n                                <div class=\"continue-button\" ng-click=\"vm.addBankAccount()\">Finish and Apply</div>\n                            </div>\n                            <div ng-if=\"vm.cardType === 'card'\">\n                                <div class=\"row\">\n                                    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                        <label>Card Nickname (optional)</label>\n                                        <input\n                                                type=\"text\"\n                                                ng-model=\"vm.nickname\"\n                                        />\n                                    </div>\n                                </div>\n\n                                <div class=\"row\">\n                                    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                        <label>Name on Card</label>\n                                        <input\n                                                name=\"\"\n                                                type=\"text\"\n                                                ng-model=\"vm.credit_card_name\"\n                                        />\n                                    </div>\n                                </div>\n\n                                <div class=\"row\">\n                                    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                        <label>Street Address</label>\n                                        <input\n                                                name=\"\"\n                                                type=\"text\"\n                                                ng-model=\"vm.street\"\n                                        />\n                                    </div>\n                                </div>\n\n                                <div class=\"row\">\n\n                                    <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\">\n                                        <label>City</label>\n                                        <input\n                                                name=\"\"\n                                                type=\"text\"\n                                                ng-model=\"vm.city\"\n                                        />\n                                    </div>\n\n                                    <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12\" style=\"text-align:left;\">\n                                        <label>State</label>\n                                        <select\n                                                ng-model=\"vm.state\"\n                                                ng-options=\"state for state in vm.stateList\"\n                                        >\n                                        </select>\n                                    </div>\n\n                                    <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12\">\n                                        <label>Zipcode</label>\n                                        <input\n                                                name=\"\"\n                                                type=\"text\"\n                                                ng-model=\"vm.zipCode\"\n                                                maxlength=\"5\"\n                                        />\n                                    </div>\n\n                                </div>\n\n                                <div class=\"row\">\n                                    <div class=\"col-lg-9 col-md-9 col-sm-9 col-xs-12\">\n                                        <label>Card Number</label>\n                                        <input\n                                                name=\"\"\n                                                type=\"text\"\n                                                class=\"form-control form-input\"\n                                                ng-model=\"vm.displayCardNumber\"\n                                                cleave=\"vm.cardNumberFormatting\"\n                                        />\n                                    </div>\n                                    <div class=\"col-lg-3 col-md-2 col-sm-3 col-xs-12\">\n                                        <label>CVC</label>\n                                        <input\n                                                name=\"\"\n                                                type=\"password\"\n                                                maxlength=\"4\"\n                                                ng-model=\"vm.cvc\"\n                                        />\n                                    </div>\n                                </div>\n\n                                <div class=\"row\">\n                                    <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12\" style=\"text-align:left;\">\n                                        <label>Exp. Month</label>\n                                        <select\n                                                class=\"form-control form-input\"\n                                                ng-model=\"vm.expMonths.value\"\n                                                ng-options=\"type for type in vm.expMonths.values\"\n                                        />\n                                    </div>\n                                    <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12\" style=\"text-align:left;\">\n                                        <label>Exp. Year</label>\n                                        <select\n                                                class=\"form-control form-input\"\n                                                ng-model=\"vm.expYears.value\"\n                                                ng-options=\"type for type in vm.expYears.values\"\n                                        />\n                                    </div>\n                                </div>\n\n                                <div class=\"error-text\" ng-show=\"vm.cardTokenError\">\n                                    <i class=\"fas fa-exclamation-circle\"></i> {{vm.cardTokenError}}\n                                </div>\n                                <div class=\"save-transactions\">Safe transactions through <img\n                                        src=\"/app/vendor/images/stripe-logo.png\" alt=\"Stripe Logo\"></div>\n                                <div class=\"skip-for-now\" ng-click=\"vm.skipPayment()\">Skip for now</div>\n\n                                <div>\n                                    <div class=\"continue-button\" ng-click=\"vm.addCreditCard()\">Finish and Apply</div>\n                                </div>\n                            </div>\n                        </div>\n\n                    </div>\n                </div>\n\n            </div>\n\n        </div>\n\n        <div\n                class=\"modal-dialog modal-m questions\"\n                role=\"document\"\n                ng-if=\"!(vm.jobble && vm.jobble.is_partner_post) && vm.currentUser && !vm.applicationComplete && vm.userReady && (vm.paymentReady || vm.paymentSkipped)\">\n            <div class=\"modal-gradient-banner\"></div>\n            <div class=\"modal-content\">\n                <div class=\"modal-fixed-bar\">\n                    <div class=\"save-exit\" ng-click=\"vm.exit()\">\n                        <i class=\"fas fa-times\"></i>\n                    </div>\n                </div>\n\n                <div class=\"modal-question-content\" ng-if=\"vm.showReqs !== true\">\n                    <div class=\"\">\n                        <h3>Complete your application</h3>\n                        <p>Please review the job details below and submit your application.</p>\n                    </div>\n\n                    <div class=\"job-header-container\">\n                        <div class=\"job-header-logo\">\n                            <div\n                                    style=\"background-image: url({{vm.jobble.companyLogo}})\"\n                            ></div>\n                        </div>\n                        <div class=\"job-header-details\">\n                            <div\n                                    class=\"job-header-title\"\n                            >\n                                {{ (vm.jobble.title) ? (vm.jobble.title) : ( (vm.jobble.subEvent.event.name) ?\n                                (vm.jobble.subEvent.event.name) : ('N/A') ) }}\n                            </div>\n                            <div class=\"job-header-company\">{{ vm.jobble.companyName }}</div>\n                            <div class=\"job-header-location\">\n                                <span ng-if=\"!vm.jobble.is_partner_post && !vm.jobble.jobbleType.name == 'Remote Job'\">\n                                    {{ vm.jobble.subEvent.contactInfo.city }}, {{ vm.jobble.subEvent.contactInfo.state }}\n                                </span>\n                                <span ng-if=\"!vm.jobble.is_partner_post && vm.jobble.jobbleType.name == 'Remote Job'\">\n                                    Remote Job\n                                </span>\n                                <span ng-if=\"vm.jobble.is_partner_post\">{{ vm.jobble.city }}, {{ vm.jobble.state }}</span>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"job-details-box-container\" ng-if=\"!vm.jobble.is_partner_post\">\n                        <div class=\"row\">\n                            <div class=\"col col-sm-6\">\n                                <div class=\"details-pay-row\">\n                                    <div class=\"row-icon\">\n                                        <i class=\"fas fa-dollar-sign\"></i>\n                                    </div>\n                                    <div class=\"row-information\">\n                                        <span ng-if=\"vm.jobble.jobblerRate !== 0\">\n                                            EST. TOTAL PAY - $ {{vm.estimatedTotalPayables / 100 | number : 2}}\n                                            <br/>\n                                            <!--<span ng-if=\"vm.jobble.numberofDays === 0\">or ${{vm.jobble.jobblerRate /100 * vm.jobble.rawDuration | number : 2}} total estimated pay</span>-->\n                                        </span>\n                                        <span style=\"font-size:10px;\">\n                                            ( ${{ vm.jobble.jobblerRate / 100 | number : 2 }}/hr : {{ vm.totalPayableHours }} total payable hours )\n                                        </span>\n\n                                        <span ng-if=\"vm.jobble.jobblerRate == 0\">TBD</span>\n                                    </div>\n                                </div>\n                                <div class=\"details-day-type-row\">\n                                    <div class=\"row-icon\">\n                                        <i class=\"fa fa-briefcase\"></i>\n                                    </div>\n                                    <div class=\"row-information\">\n                                        <span ng-if=\"vm.jobble.numberofDays > 0\">Multi-Day</span><span\n                                            ng-if=\"vm.jobble.numberofDays === 0\">Single-Day</span> job\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"col col-sm-6\">\n                                <div ng-if=\"vm.jobble.numberofDays === 0\">\n                                    <div class=\"details-pay-row\">\n                                        <div class=\"row-icon\">\n                                            <i class=\"fas fa-calendar\"></i>\n                                        </div>\n                                        <div class=\"row-information\">\n                                            {{ vm.jobble.jobbleFullTimeFrame }}\n                                        </div>\n                                    </div>\n                                    <div class=\"details-pay-row\">\n                                        <div class=\"row-icon\">\n                                            <i class=\"far fa-clock\"></i>\n                                        </div>\n                                        <div class=\"row-information\">\n                                            <div>{{vm.jobble.jobbleHours}}</div>\n                                            <div>({{vm.jobble.jobbleDuration}})</div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div ng-if=\"vm.jobble.numberofDays > 0\">\n                                    <div class=\"details-pay-row\">\n                                        <div class=\"row-icon\">\n                                            <i class=\"fas fa-calendar\"></i>\n                                        </div>\n                                        <div class=\"row-information\">\n                                            {{ vm.jobble.jobbleFullTimeFrame }}\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div>\n                        <!--\n                        <div class=\"loading-questions\" style=\"text-align:center;\"\n                             ng-if=\"!vm.questionsLoaded && !vm.applicationComplete\">\n                            Loading Questions . . .\n                        </div>\n\n                        <div class=\"row\" style=\"text-align:center;\" ng-if=\"vm.applicationComplete\">\n                            <div>\n                                {{vm.applicationText}}\n                            </div>\n                            <div class=\"continue-button\" ng-click=\"vm.exit()\">\n                                Close\n                            </div>\n                        </div>\n\n                        \n                        <div ng-if=\"vm.questionsLoaded\">\n                            <div ng-repeat=\"question in vm.questions track by $index\">\n                                <p class=\"questions-question\">{{ $index+1 }}. {{ question.question }} </p>\n                                <textarea class=\"form-control form-input question-text\"\n                                          ng-class=\"{'error': question.error}\" rows=\"4\" ng-model=\"question.answer\"\n                                          ng-change=\"vm.onQuestionChange(question)\" maxlength=\"500\"\n                                          required></textarea>\n\n                                <div class=\"character-limit\">{{question.answer ? question.answer.length : 0}}/500</div>\n                                <div ng-show=\"question.error\">\n                                    <div class=\"question error-text\">\n                                        <i class=\"fas fa-exclamation-circle\"></i> {{ question.errorText }}\n                                    </div>\n                                </div>\n                            </div>\n                            -->\n                        <div ng-if=\"vm.questionsLoaded\">\n                            <div class=\"continue-button\" ng-click=\"vm.setRequirements()\">\n                                View Job Requirements\n                            </div>\n                        </div>\n\n                        <div ng-show=\"vm.errorText\">\n                            <div class=\"error-text\">\n                                <i class=\"fas fa-exclamation-circle\"></i> {{ vm.errorText }}\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n\n\n                <!-- BEGIN REQUIREMENTS -->\n                <div class=\"modal-question-content\" ng-if=\"vm.showReqs==true\">\n\n                    <div class=\"\">\n                        <h3>Shift Requirements <i class=\"fas fa-exclamation-circle\" ng-click=\"vm.showReqInfo()\"></i>\n                        </h3>\n                        <p class=\"requirements\" ng-if=\"!vm.displayReqInfo\">\n                            Please check off that you meet each of the\n                            following shift requirements from {{vm.jobble.companyName}}\n                            for the {{vm.jobble.jobbleType.name}} position.\n                        </p>\n\n                        <p class=\"requirements info\" ng-if=\"vm.displayReqInfo\">\n                            If you do not meet all of the requirements, you are\n                            considered ineligible to work this shift. <a href=\"#\">Learn more.</a>\n                        </p>\n                    </div>\n\n                    <div class=\"loading-questions\" style=\"text-align:center;\"\n                         ng-if=\"!vm.reqsLoaded && !vm.applicationComplete\">\n                        Loading Requirements . . .\n                    </div>\n\n                    <div class=\"row\" style=\"text-align:center;\" ng-if=\"vm.applicationComplete\">\n                        <div>\n                            {{vm.applicationText}}\n                        </div>\n                        <div class=\"continue-button\" ng-click=\"vm.exit()\">\n                            Close\n                        </div>\n                    </div>\n\n                    <div ng-if=\"vm.reqsLoaded\">\n\n                        <table class=\"requirements-listing\">\n                            <tbody>\n                            <tr ng-repeat=\"req in vm.requirements track by $index\">\n                                <td>\n                                    <input\n                                            type=\"checkbox\"\n                                            ng-click=\"vm.checkReq(req)\"\n                                            ng-check=\"req.isChecked\"\n                                    />\n                                </td>\n                                <td>\n                                        <span class=\"req-desc\" ng-class=\"{ 'req-checked' : req.isChecked }\">\n                                            {{ req.name }}\n                                        </span>\n                                </td>\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n\n                    <div ng-show=\"vm.showReqError\">\n                        <div class=\"error-text\">\n                            <i class=\"fas fa-exclamation-circle\"></i> {{ vm.showReqError }}\n                        </div>\n                    </div>\n\n                    <div class=\"continue-button\" ng-click=\"vm.applyNew()\">\n                        Save And Continue\n                    </div>\n\n                </div>\n\n            </div>\n\n        </div>\n\n        <div\n                class=\"modal-dialog modal-m questions success-modal\"\n                role=\"document\"\n                ng-if=\"!(vm.jobble && vm.jobble.is_partner_post) && vm.currentUser && vm.applicationComplete && !vm.verifyingSMS && vm.userReady && (vm.paymentReady || vm.paymentSkipped)\">\n            <div class=\"modal-gradient-banner\"></div>\n            <div class=\"modal-content\">\n                <div class=\"modal-fixed-bar\">\n                    <div class=\"save-exit\" ng-click=\"vm.exit()\">\n                        <i class=\"fas fa-times\"></i>\n                    </div>\n                </div>\n\n                <div class=\"modal-question-content\">\n                    <div ng-if=\"!vm.applicationError\">\n\n                        <div style=\"margin-bottom:20px;\">\n                            <h3>You're almost there!</h3>\n                            <p style=\"margin-top: 16px\">\n                                You've successfully filled out your application, but it's not submitted yet.\n                                To finalize your application, please complete the following steps if you haven't\n                                already:\n                                <br/>\n                                <br/>\n                                <span style=\"color: #62C046\"><i class=\"fas fa-check-square\"></i></span> Verify Your\n                                Email<br/>\n                                <span style=\"color: #62C046\"><i class=\"fas fa-check-square\"></i></span> Download the\n                                Mobile App<br/>\n                                <span style=\"color: #62C046\"><i class=\"fas fa-check-square\"></i></span> Sign\n                                in<br/><br/>\n                                Once the above steps have been completed, your application will be submitted!\n                            </p>\n                        </div>\n\n\n                        <div class=\"line-holder\">\n                            <div class=\"left-line\" style=\"float: none; width: 100%\"></div>\n                        </div>\n\n                        <h3 style=\"text-align: center; margin-top: 20px; line-height: 27px;margin-bottom: 30px;\">\n                            Download the Jobble app below!</h3>\n\n\n                        <div style=\"text-align: center\">\n                            <img src=\"/app/vendor/images/jcta.png\" width=\"100\" style=\"max-width: 270px\"/>\n                        </div>\n\n                        <!--\n                        <a target=\"_blank\" href=\"https://link.jobble.com/downloadapp\">\n                            <div class=\"learn-more-button\" style=\"margin-top: 0px;\">\n                                Learn More\n                            </div>\n                        </a>\n                        -->\n\n                        <!--\n                        <div class=\"indi-success-holder\">\n                            <h4>New! Get paid faster with indi <br/>for Jobblers.</h4>\n                            <img src=\"app/vendor/images/app_card_image.png\" />\n                            <h4 class=\"get-started\">GET STARTED <i class=\"fas fa-angle-double-right\"></i></h4>\n                        </div>\n                        -->\n\n\n                    </div>\n                    <div ng-if=\"vm.applicationError\">\n                        <div class=\"\">\n                            <h3>Application Error</h3>\n                            <p>\n                                {{vm.applicationText}}\n                            </p>\n                        </div>\n                        <div>\n                            <div class=\"continue-button\" ng-click=\"vm.exit()\">\n                                Close\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n\n            </div>\n\n        </div>\n\n    </divapplyToJobble>\n\n</div>\n\n</div>\n\n\n<div class=\"modal fade\" id=\"explain-payment-info-new\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <button\n                                type=\"button\"\n                                class=\"close\"\n                                data-dismiss=\"modal\"\n                                aria-label=\"Close\">\n                            <span aria-hidden=\"true\">&times;</span></button>\n                        <h3 class=\"modal-title\">Payment Method Confirmation</h3>\n                    </div>\n                    <div class=\"modal-body\">\n                        <p>{{vm.explaination_text}}\n                            <a\n                                    href=\"https://intercom.help/jobble/en/articles/2065572-is-direct-deposit-the-only-option\"\n                                    target=\"_blank\">here</a>.\n                        </p>\n                    </div>\n                    <div class=\"modal-footer text-center\" style=\"text-align:center;\">\n                        <a class=\"btn button btn-success\" href=\"\" data-dismiss=\"modal\">Sounds good</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//'phoneMobile',
	var COMPLETE_PROFILE_FIELDS = ["firstName", "lastName", "nickname"];
	var VERIFY_PHONE_FIELDS = ["phoneMobile"];
	var LOCATION_FIELDS = ["streetLine1", "zipCode", "city", "state"];
	var WORK_ELIGIBILITY_FIELDS = ["ssn", "dateBirth"];
	var EMAILREGEX = /^([!#$%&*+-\/=?^`'|{}~\w_.]{1,64}?)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	var ApplyProfileModalController = function () {
	  function ApplyProfileModalController($http, $localStorage, $state, AuthService, SecurityService, SignonService, SignupValidator, TrackingService, $rootScope, $scope, $location, $timeout, $window, $companies, Messagingv2Service, EventsService, JobsService, SocialService, IterableService, ProfileService, $env, validation) {
	    var _this2 = this;
	
	    _classCallCheck(this, ApplyProfileModalController);
	
	    this.name = "applyprofilemodal";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$rootScope = $rootScope;
	    this.$security = SecurityService;
	    this.$window = $window;
	    this.$location = $location;
	    this.payload = {};
	    this.$signon = SignonService;
	    this.$social = SocialService;
	    this.$iterable = IterableService;
	    this.$timeout = $timeout;
	    this.validator = SignupValidator;
	    this.validation = {};
	    this.$jobs = JobsService;
	    this.uber_forward = false;
	    this.setVerificationNoti = false;
	    this.$events = EventsService;
	    this.currentUser = this.$auth.getUserData();
	    this.$scope = $scope;
	    this.$tracking = TrackingService;
	    this.$messagingv2 = Messagingv2Service;
	    this.$companies = $companies;
	    this.$profile = ProfileService;
	    this.applicationIsSending = false;
	    this.$env = $env;
	    this.showReqs = false;
	    this.mobile_UI = {};
	    this.buttonDisabled = false;
	    this.smsAgreementVal = false;
	    this.userNeedsToSignIn = false;
	    this.canValidate = false;
	    this.$timeout(function () {
	      return _this2.canValidate = true;
	    }, 1000);
	    this.applicationDisabled = false;
	    this.pref_jobble_types = [];
	    this.user = {
	      first_name: null,
	      last_name: null,
	      email: null,
	      zip_code: null,
	      password: null
	    };
	    this.errors = {};
	
	    console.log("profile location", this.$profile.LOCATION, this.$profile.STATUS_MAP[this.$profile.LOCATION]);
	
	    this.ui_user_model = {
	      nickname: null,
	      firstName: null,
	      lastName: null,
	      homeContactInfo: {
	        phoneMobile: null,
	        streetLine1: null,
	        zipCode: null,
	        city: null,
	        state: null
	      },
	      ssn: null,
	      dateBirth: null
	    };
	
	    this.SetApplyProfileJobListener = this.$rootScope.$on("SetApplyProfileJob", function ($event, params) {
	      _this2.$timeout(function () {
	        _this2.showReqs = false;
	        _this2.jobble = params.job;
	        _this2.isSaveBankAccountDisabled = false;
	        if (_this2.jobble.partnerPostContent === null) {
	          _this2.jobble.is_partner_post = false;
	        } else {
	          _this2.jobble.is_partner_post = true;
	        }
	      });
	    });
	
	    this.SetApplicationQuestionsListener = this.$rootScope.$on("SetApplicationQuestions", function ($event, params) {
	      if (params.forward) {
	        _this2.uber_forward = true;
	        _this2.jobble = params.data;
	      }
	
	      if (params.user_just_registered) {
	        _this2.just_registered = true;
	      }
	      if (params.from_regi) {
	        _this2.currentUser = params.from_regi;
	      }
	      if (params.data.partnerPostContent) {
	        _this2.is_partner_post = true;
	      }
	      _this2.errorText = null;
	      _this2.questions = [];
	      _this2.questionsLoaded = false;
	
	      if (_this2.currentUser) {
	        if (_this2.is_partner_post === true) {
	          _this2.sendUserToPartnerPost();
	          return;
	        }
	        _this2.setSurveyQuestionsForJob(params);
	        if (!_this2.currentUser.isVerified && !params.from_regi) {
	          var dontShowWarning = true;
	          _this2.userVerified = false;
	          _this2.verify(dontShowWarning);
	          _this2.setVerificationNoti = true;
	        } else {
	          _this2.userVerified = true;
	          _this2.setVerificationNoti = false;
	        }
	      } else {
	        _this2.noUser = true;
	        _this2.jobble = params.data;
	        _this2.button_type = params.button_type;
	        _this2.loadSignOnButtons();
	      }
	    });
	
	    this.ClearApplicationQuestionsListener = this.$rootScope.$on("ClearApplicationQuestions", function ($event, params) {
	      _this2.clearQuestions();
	    });
	
	    this.UserUpdateTriggerListener = this.$rootScope.$on(this.$auth.USER_UPDATE_TRIGGER, function ($event, user) {
	      _this2.currentUser = user;
	      _this2.$timeout(function () {
	        _this2.canUserApplyToShiftBasedJobs(true);
	      });
	    });
	
	    this.SetNewUserForJobBoardListener = this.$rootScope.$on("SetNewUserForJobBoard", function ($event, params) {
	      _this2.currentUser = params.user;
	      _this2.$timeout(function () {
	        _this2.getMostRecentUser();
	      });
	    });
	
	    this.SetDataForVerificationListener = this.$rootScope.$on("SetDataForVerification", function ($event, params) {
	      _this2.canUserApplyToShiftBasedJobs();
	    });
	
	    this.$scope.$on("$destroy", this.SetApplyProfileJobListener);
	    this.$scope.$on("$destroy", this.SetDataForVerificationListener);
	    this.$scope.$on("$destroy", this.SetNewUserForJobBoardListener);
	    this.$scope.$on("$destroy", this.ClearApplicationQuestionsListener);
	    this.$scope.$on("$destroy", this.SetApplicationQuestionsListener);
	    this.$scope.$on("$destroy", this.UserUpdateTriggerListener);
	
	    this.states = {
	      values: ["--", "AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"]
	    };
	
	    this.partnerEmail = this.$localStorage.partnerEmail;
	
	    this.getJobbleTypes().then(function () {
	      if (_this2.currentUser) {
	        _this2.$timeout(function () {
	          _this2.canUserApplyToShiftBasedJobs();
	        });
	      }
	    });
	
	    this.paymentReady = false;
	
	    if (this.currentUser) {
	      this.getPaymentInfo().then(function (response) {
	        _this2.handlePaymentResponse(response.data);
	      });
	    }
	
	    this.cardType = "bank";
	
	    var thisYear = new Date().getFullYear();
	    var allYears = [thisYear.toString()];
	
	    for (var i = 1; i < 15; i++) {
	      allYears.push((thisYear + i).toString());
	    }
	    this.stateList = ["AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"];
	    this.expYears = { value: thisYear.toString(), values: allYears };
	    this.expMonths = {
	      value: "01",
	      values: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
	    };
	
	    this.GetNewPaymentInfoListener = this.$rootScope.$on("GetNewPaymentInfo", function ($event, params) {
	      if (params.data.error) {
	        _this2.handleError(params.data.response);
	      } else {
	        _this2.getPaymentInfo(params, true).then(function (response) {
	          _this2.handlePaymentResponse(response.data, true, params);
	        });
	      }
	    });
	
	    this.$scope.$on("$destroy", this.GetNewPaymentInfoListener);
	
	    this.cardNumberFormatting = {
	      creditCard: true,
	      delimiter: "-",
	      onValueChanged: function onValueChanged(e) {
	        _this2.cardNumber = e.target.rawValue.trim();
	      }
	    };
	
	    window.fbOnLogin = function () {
	      return _this2.fbSuccessfulLogin();
	    };
	
	    window.document.addEventListener("AppleIDSignInOnSuccess", function (data) {
	      _this2.handleAppleSignin(data.detail);
	      //handle successful response
	    });
	
	    window.document.addEventListener("AppleIDSignInOnFailure", function (error) {
	      console.error(error);
	      //handle successful response
	    });
	
	    FB.init({
	      appId: "1097626717272010",
	      autoLogAppEvents: true,
	      xfbml: true,
	      version: "v10.0"
	    });
	
	    this.$timeout(function () {
	      var target = document.querySelector("div.sms-code-container");
	
	      if (target) {
	        target.addEventListener("paste", function (event) {
	          var copyCode = (event.clipboardData || window.clipboardData).getData("text");
	          copyCode = copyCode.trim();
	          if (copyCode.length === 6) {
	            _this2.smsCode_1 = copyCode.charAt(0);
	            _this2.smsCode_2 = copyCode.charAt(1);
	            _this2.smsCode_3 = copyCode.charAt(2);
	            _this2.smsCode_4 = copyCode.charAt(3);
	            _this2.smsCode_5 = copyCode.charAt(4);
	            _this2.smsCode_6 = copyCode.charAt(5);
	            for (var _i = 0; _i <= 5; _i++) {
	              document.getElementById("sms-code-" + (_i + 1)).value = copyCode.charAt(_i);
	            }
	            _this2.codeEntered(6);
	          }
	          event.preventDefault();
	        });
	      }
	    }, 1000);
	  }
	
	  _createClass(ApplyProfileModalController, [{
	    key: "handleError",
	    value: function handleError(error) {
	      var message = error.data.message;
	      alert(message);
	    }
	  }, {
	    key: "getPaymentInfo",
	    value: function getPaymentInfo(data, payment_info_just_created) {
	      var _this3 = this;
	
	      return new Promise(function (resolve, reject) {
	        _this3.$profile.getPaymentInfo().then(function (response) {
	          resolve(response);
	        }, function (error) {
	          reject(error);
	        });
	      });
	    }
	  }, {
	    key: "skipPayment",
	    value: function skipPayment() {
	      var _this4 = this;
	
	      this.$timeout(function () {
	        _this4.paymentSkipped = true;
	      });
	    }
	  }, {
	    key: "handlePaymentResponse",
	    value: function handlePaymentResponse(payment_infos, payment_info_just_created, data) {
	      var _this5 = this;
	
	      this.banks = [];
	      this.cards = [];
	      if (payment_infos && payment_infos.undeletedPaymentInfos && payment_infos.undeletedPaymentInfos.length > 0) {
	        this.$timeout(function () {
	          _this5.paymentReady = true;
	        });
	
	        var pay_infos_array = payment_infos.undeletedPaymentInfos;
	        try {
	          try {
	            var sorted_array = pay_infos_array.sort(function (a, b) {
	              return new Date(b.lastUpdated).getTime() - new Date(a.lastUpdated).getTime();
	            });
	          } finally {
	            sorted_array.forEach(function (payment_info, index) {
	              if (index === 0) {
	                if (payment_info.bankName) {
	                  _this5.banks.push(payment_info);
	                } else {
	                  _this5.cards.push(payment_info);
	                }
	              }
	            });
	          }
	        } catch (err) {} finally {}
	      } else {}
	    }
	  }, {
	    key: "toggleAddPayment",
	    value: function toggleAddPayment() {
	      var _this6 = this;
	
	      if (!this.addingPayment && (this.banks.length || this.cards.length)) {
	        var c = confirm("If you save a new payment method, then it will replace your existing " + (this.banks.length ? "bank account" : "debit card") + ".");
	        if (!c) return;
	      }
	
	      this.$timeout(function () {
	        _this6.addingPayment = !_this6.addingPayment;
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "validDate",
	    value: function validDate(month, year) {
	      var today = new Date();
	      return parseFloat(month) / 12 + parseFloat(year) >= today.getFullYear() + (today.getMonth() + 1) / 12;
	    }
	  }, {
	    key: "addCreditCard",
	    value: function addCreditCard() {
	      if (!this.cardNumber || !this.cvc || !this.street || !this.city || !this.state || !this.zipCode || !this.expMonths || !this.expMonths.value || !this.expYears || !this.expYears.value) {
	        this.cardTokenError = "All fields are required";
	        return console.error("Missing fields");
	      }
	
	      // if (!this.validDate(this.expMonths.value, this.expYears.value))
	      //     return console.error("Expired card");
	      if (this.isSaveCreditCardDisabled === true) {
	        return;
	      }
	      var data = {};
	
	      data.type = "card";
	      data.is_replace = !!(this.cards && this.cards.length);
	      data.jobbler = this.currentUser;
	
	      this.setLoader();
	      this.isSaveCreditCardDisabled = true;
	      this.createRecipient(data);
	    }
	  }, {
	    key: "addBankAccount",
	    value: function addBankAccount() {
	      var bank_name = this.accountHolderName;
	      var bank_routing = this.routingNumber;
	      var bank_account = this.accountNumber;
	
	      if (this.isSaveBankAccountDisabled === true) {
	        return;
	      }
	
	      if (!bank_name || !bank_routing || !bank_account) {
	        this.bankTokenError = "All fields are required";
	        return console.error("Missing fields");
	      }
	
	      var data = {};
	
	      data.type = "bank";
	      data.is_replace = !!(this.banks && this.banks.length);
	      data.jobbler = this.currentUser;
	
	      this.setLoader();
	      this.isSaveBankAccountDisabled = true;
	      this.createRecipient(data);
	    }
	  }, {
	    key: "createRecipient",
	    value: function createRecipient(data) {
	      var _this7 = this;
	
	      var pl = null;
	
	      this.bankTokenError = null;
	      if (data.type === "card") {
	        pl = {
	          card: {
	            number: this.cardNumber,
	            exp_month: this.expMonths.value,
	            exp_year: this.expYears.value,
	            cvc: this.cvc,
	            address_line1: this.street,
	            address_city: this.city,
	            address_state: this.state,
	            address_zip: this.zipCode,
	            currency: "usd"
	          }
	        };
	      } else {
	        pl = {
	          bank_account: {
	            country: "us",
	            currency: "usd",
	            account_holder_name: this.accountHolderName,
	            account_holder_type: "individual",
	            routing_number: this.routingNumber,
	            account_number: this.accountNumber
	          }
	        };
	      }
	
	      this.$security.getToken(pl).then(function (response) {
	        _this7.saveRecipient(response.data, pl, data.type);
	      }, function (error) {
	        _this7.handleRecipientError(error, data.type);
	        _this7.unSetLoader();
	      });
	    }
	  }, {
	    key: "handleRecipientError",
	    value: function handleRecipientError(response, type) {
	      var error = response.data.error ? response.data.error.message : "There was an issue saving your payment information. Please contact an administrator.";
	
	      if (type === "card") this.cardTokenError = error;else this.bankTokenError = error;
	    }
	  }, {
	    key: "saveRecipient",
	    value: function saveRecipient(data, payment_info, type) {
	      var _this8 = this;
	
	      var pl = {};
	
	      if (type === "card") {
	        pl.username = this.currentUser.username;
	        pl.stripeToken = data.id;
	        pl.paymentMethod = "card";
	        pl.country = "us";
	        pl.currency = "usd";
	      } else {
	        pl.username = this.currentUser.username;
	        pl.stripeToken = data.id;
	        pl.paymentMethod = "bank_account";
	      }
	
	      this.$security.saveRecipient(pl).then(function (response) {
	        var data = {};
	
	        if (response.data.status === "error") {
	          console.error(response);
	          data.response = response;
	          data.error = true;
	          _this8.unSetLoader();
	          _this8.$timeout(function () {
	            _this8.$rootScope.$emit("GetNewPaymentInfo", { data: data });
	          });
	        } else {
	          data.response = response.data;
	          _this8.unSetLoader();
	
	          _this8.$tracking.reportSubmitProfileStep("job board", _this8.$profile.STATUS_MAP[_this8.$profile.PAYMENTS]);
	
	          data.card = type === "card";
	
	          _this8.$timeout(function () {
	            _this8.$rootScope.$emit("GetNewPaymentInfo", { data: data });
	          });
	
	          _this8.displayInformativeModal(type, response);
	        }
	
	        _this8.$timeout(function () {
	          _this8.isSaveBankAccountDisabled = false;
	        }, 1000);
	      }, function (error) {
	        _this8.unSetLoader();
	        alert("There was a fatal error. Please contact an administrator.");
	        _this8.$timeout(function () {
	          _this8.isSaveBankAccountDisabled = false;
	        }, 1000);
	      });
	    }
	  }, {
	    key: "displayInformativeModal",
	    value: function displayInformativeModal(type, resp) {
	      var _this9 = this;
	
	      this.$timeout(function () {
	        _this9.unSetLoader();
	      });
	      var text = null;
	      //https://intercom.help/jobble/en/articles/2065572-is-direct-deposit-the-only-option
	
	      /*
	          if (type === "bank") {
	              text = "We have added your bank account as your primary method for receiving funds. Please learn more about the different types of payment methods ";
	          } else {
	              text = "We have added your debit card as your primary method for receiving funds. Please learn more about the different types of payment methods ";
	          }
	          this.explaination_text = text;
	          this.$timeout(() => {
	              this.$timeout(() => {
	                  this.addingPayment = false
	              });
	              $("#explain-payment-info-new").modal();
	          });
	          */
	    }
	  }, {
	    key: "getMostRecentUser",
	    value: function getMostRecentUser() {
	      var _this10 = this;
	
	      return new Promise(function (resolve, reject) {
	        resolve(_this10.$auth.getUserData());
	      });
	    }
	  }, {
	    key: "canUserApplyToShiftBasedJobs",
	    value: function canUserApplyToShiftBasedJobs(skipQuestions) {
	      var _this11 = this;
	
	      return new Promise(function (resolve) {
	        _this11.getMostRecentUser().then(function (user) {
	          _this11.$timeout(function () {
	            console.log("this.userProfileStatus");
	            console.dir(_this11.userProfileStatus);
	
	            _this11.currentUser = user || _this11.currentUser;
	            _this11.$rootScope.$emit("SetNewUserForJobBoard", {
	              user: _this11.currentUser
	            });
	
	            _this11.ui_user_model = _.cloneDeep(_this11.currentUser);
	
	            _this11.ui_user_model.dateBirth = _this11.ui_user_model.dateBirth ? _this11.convertDateToString(_this11.ui_user_model.dateBirth) : null;
	            _this11.userVerified = _this11.currentUser.isVerified;
	
	            if (_this11.userProfileStatus === _this11.$profile.INPUT_PHONE_NUMBER) {
	              _this11.processUser();
	            }
	
	            _this11.userProfileStatus = _this11.$profile.getUserProfileScreen(_this11.currentUser, _this11.userProfileStatus);
	
	            console.log("this.userProfileStatus");
	            console.dir(_this11.userProfileStatus);
	
	            _this11.userReady = _this11.$profile.getUserProfileEligibility(_this11.currentUser) === _this11.$profile.APPLY_ELIGIBLE;
	
	            var jobble_types = _this11.currentUser.notifPref ? _this11.currentUser.notifPref.jobbleTypes : [];
	
	            if (_this11.jobble_types && jobble_types) {
	              jobble_types.forEach(function (j) {
	                var jt = _this11.jobble_types.find(function (o) {
	                  return o.id === j.id;
	                });
	                if (!jt) return;
	                jt.selected = true;
	                _this11.pref_jobble_types.push(jt.id);
	              });
	            }
	
	            if (_this11.userProfileStatus === _this11.$profile.WORK_ELIGIBILITY) {
	              _this11.$timeout(function () {
	                $(function () {
	                  $('[data-toggle="tooltip"]').tooltip();
	                  $("#datepicker").datepicker({
	                    changeMonth: true,
	                    changeYear: true,
	                    minDate: "-100Y",
	                    maxDate: "-18Y",
	                    yearRange: "-100:-18"
	                  });
	                });
	              }, 500);
	            }
	
	            resolve();
	
	            if (_this11.userReady) {
	              _this11.skipPayment();
	            }
	
	            if (_this11.currentUser && _this11.jobble && !skipQuestions) {
	              if (_this11.jobble.id === _this11.last_questions_loaded_id && _this11.questions && _this11.questions.length) return;
	
	              _this11.setSurveyQuestionsForJob({ data: _this11.jobble });
	            }
	          });
	        });
	      });
	    }
	  }, {
	    key: "consentToBgCheck",
	    value: function consentToBgCheck(consent) {
	      if (!angular.isUndefined(consent)) {
	        console.log("consentToBgCheck");
	        console.dir(consent);
	      }
	    }
	  }, {
	    key: "setProfilePage",
	    value: function setProfilePage(page) {
	      var _this12 = this;
	
	      if (page > this.$profile.getUserProfileScreen(this.currentUser)) return;
	
	      this.$timeout(function () {
	        _this12.userProfileStatus = page;
	
	        if (page === _this12.$profile.WORK_ELIGIBILITY) {
	          _this12.$timeout(function () {
	            $(function () {
	              $('[data-toggle="tooltip"]').tooltip();
	              $("#datepicker").datepicker({
	                changeMonth: true,
	                changeYear: true,
	                minDate: "-100Y",
	                maxDate: "-18Y",
	                yearRange: "-100:-18"
	              });
	            });
	          }, 500);
	        }
	      });
	    }
	  }, {
	    key: "uploadProfilePhoto",
	    value: function uploadProfilePhoto() {
	      var _this13 = this;
	
	      this.$timeout(function () {
	        _this13.uploadingProfile = true;
	      });
	
	      var file = $("#profile-photo-upload")[0].files[0];
	      var fd = new FormData();
	      fd.append("file", file);
	
	      this.$profile.uploadProfilePicture(fd).then(function (res) {
	        if (res.status === 200) {
	          if (res.data.status === "error") {
	            _this13.$timeout(function () {
	              _this13.uploadingProfile = false;
	            });
	            _this13.$timeout(function () {
	              alert("There was an issue uploading your profile picture. Please try another photo.");
	            }, 300);
	          } else {
	            _this13.getPhotos(true);
	            _this13.$tracking.reportSubmitProfileStep("job board", _this13.$profile.STATUS_MAP[_this13.$profile.PROFILE_PICTURE]);
	          }
	        }
	      });
	    }
	  }, {
	    key: "getPhotos",
	    value: function getPhotos(is_profile_picture, init, is_cover_photo, is_edit) {
	      var _this14 = this;
	
	      this.$profile.getMultiMediaDataWithFormats().then(function (response) {
	        _this14.setMultiMediaData(response.data, is_profile_picture, init, is_cover_photo, is_edit);
	      }, function (error) {
	        alert("Error grabbing multimedia");
	      });
	    }
	  }, {
	    key: "setMultiMediaData",
	    value: function setMultiMediaData(user, is_profile_picture, init, is_cover_photo, is_edit) {
	      var _this15 = this;
	
	      var data_model = {};
	      data_model.picture_data = this.$profile.getJobblerPictures(user, is_edit, this.model);
	      this.model = data_model;
	
	      var left_rail_data = {};
	
	      left_rail_data.image = this.model.picture_data.main_picture;
	      left_rail_data.image_only = true;
	      left_rail_data.first_name = this.currentUser.firstName;
	      left_rail_data.last_name = this.currentUser.lastName;
	      this.$timeout(function () {
	        _this15.$timeout(function () {
	          _this15.uploadingProfile = false;
	        });
	        _this15.$rootScope.imgFromProfilePage = _this15.model.picture_data.main_picture;
	        _this15.$rootScope.$emit("SetProfileImageForJobbler", {
	          user: left_rail_data
	        });
	
	        _this15.$auth.refreshCurrentUser().then(function () {
	          _this15.getMostRecentUser(function (user) {
	            _this15.$timeout(function () {
	              _this15.currentUser = user || _this15.currentUser;
	              _this15.ui_user_model = _.cloneDeep(_this15.currentUser);
	
	              _this15.ui_user_model.dateBirth = new Date(_this15.ui_user_model.dateBirth ? _this15.convertDateToString(_this15.ui_user_model.dateBirth) : "01/01/1940");
	            });
	          });
	        });
	      });
	    }
	  }, {
	    key: "clearQuestions",
	    value: function clearQuestions() {
	      this.questions = [];
	      this.questionsLoaded = false;
	    }
	  }, {
	    key: "getJobbleTypes",
	    value: function getJobbleTypes() {
	      var _this16 = this;
	
	      var newFilters = ["Logistics", "Retail", "Warehouse", "Light Industrial", "Cashier", "Delivery", "Driver", "Stocking", "Facility Staff", "Restaurant", "Hospitality", "Housekeeping", "Landscaper", "Agriculture", "Caregiving", "Security", "Customer Service", "Event Staff"];
	
	      return new Promise(function (resolve) {
	        _this16.$auth.getJobbleTypes(200).then(function (data) {
	          _this16.jobbleTypes = data.data;
	
	          if (data.data) {
	            _this16.jobbleTypes = data.data.filter(function (type) {
	              return newFilters.indexOf(type.name) !== -1;
	            });
	
	            _this16.jobbleTypes = _this16.jobbleTypes.sort(function (a, b) {
	              return newFilters.indexOf(a.name) - newFilters.indexOf(b.name);
	            });
	          }
	
	          _this16.$timeout(function () {
	            _this16.jobble_types = _this16.jobbleTypes;
	            _this16.$rootScope.jobble_types = _this16.jobbleTypes;
	            resolve();
	          });
	        });
	      });
	    }
	  }, {
	    key: "changePrefJobbleTypes",
	    value: function changePrefJobbleTypes(type, index) {
	      try {
	        if (this.pref_jobble_types.indexOf(type.id) > -1) {
	          var i = this.pref_jobble_types.indexOf(type.id);
	          if (this.pref_jobble_types.length > 1) {
	            type.selected = false;
	            this.pref_jobble_types.splice(i, 1);
	          } else {
	            alert("You need atleast one preferred jobble type");
	          }
	        } else {
	          this.pref_jobble_types.push(type.id);
	          type.selected = true;
	        }
	      } catch (err) {}
	    }
	  }, {
	    key: "togglePreferences",
	    value: function togglePreferences() {
	      this.expandPreferences = !this.expandPreferences;
	    }
	  }, {
	    key: "convertDateToString",
	    value: function convertDateToString(indate) {
	      var date = new Date(indate);
	      var year = date.getFullYear();
	      var month = date.getMonth() + 1;
	      var day = date.getDate() + 1;
	      return ((month + "").length === 1 ? "0" + month : month) + "/" + ((day + "").length === 1 ? "0" + day : day) + "/" + year;
	    }
	  }, {
	    key: "mapFields",
	    value: function mapFields(inmodel) {
	      try {
	        var model = JSON.parse(JSON.stringify(inmodel));
	
	        if (model.dateBirth) {
	          var date = new Date(model.dateBirth);
	          var year = date.getFullYear();
	          var month = date.getMonth() + 1;
	          var day = date.getDate();
	          model.dateBirth = year + "-" + ((month + "").length === 1 ? "0" + month : month) + "-" + ((day + "").length === 1 ? "0" + day : day) + "T00:00:00Z";
	        }
	
	        model.isVerified = undefined;
	
	        return model;
	      } catch (e) {
	        return inmodel;
	      }
	    }
	  }, {
	    key: "saveAndExit",
	    value: function saveAndExit() {
	      var _this17 = this;
	
	      var model = this.mapFields(this.ui_user_model);
	
	      if (this.userProfileStatus > this.$profile.WORK_ELIGIBILITY) return this.exit();
	
	      var payload = {};
	
	      if (this.userProfileStatus === this.$profile.COMPLETE_PROFILE) {
	        payload = this.$profile.extractFields(model, COMPLETE_PROFILE_FIELDS);
	      }
	      if (this.userProfileStatus === this.$profile.LOCATION) {
	        payload = this.$profile.extractFields(model, LOCATION_FIELDS);
	      }
	      if (this.userProfileStatus === this.$profile.WORK_ELIGIBILITY) {
	        payload = this.$profile.extractFields(model, WORK_ELIGIBILITY_FIELDS);
	      }
	
	      this.$profile.saveUser(payload).then(function (response) {
	        _this17.$auth.refreshCurrentUser();
	        _this17.exit();
	      }).catch(function (err) {
	        _this17.$auth.refreshCurrentUser();
	        console.error(err);
	        _this17.exit();
	      });
	    }
	  }, {
	    key: "exit",
	    value: function exit() {
	      var _this18 = this;
	
	      this.$timeout(function () {
	        $("#apply-profile-modal").modal("hide");
	        _this18.applicationComplete = false;
	        _this18.applicationError = false;
	        _this18.applicationText = "";
	        _this18.verifyingSMS = false;
	        _this18.errors = {};
	      });
	    }
	  }, {
	    key: "sendSMSLink",
	    value: function sendSMSLink() {
	      var _this19 = this;
	
	      if (this.currentUser.homeContactInfo.phoneMobile !== this.ui_user_model.homeContactInfo.phoneMobile) {
	        this.$timeout(function () {
	          _this19.verifyingSMS = true;
	          _this19.smsVerified = false;
	        });
	
	        var model = this.mapFields(this.ui_user_model);
	        var payload = this.$profile.extractFields(model, ["phoneMobile"]);
	
	        this.$profile.saveUser(payload).then(function (response) {
	          _this19.$auth.refreshCurrentUser().then(function (user) {
	            _this19.getMostRecentUser().then(function (user) {
	              _this19.$timeout(function () {
	                _this19.currentUser = user || _this19.currentUser;
	
	                _this19.ui_user_model = _.cloneDeep(_this19.currentUser);
	                _this19.ui_user_model.dateBirth = new Date(_this19.ui_user_model.dateBirth ? _this19.ui_user_model.dateBirth.replace("Z", "") : "01/01/1940");
	
	                _this19.processUser();
	              });
	            });
	          });
	        });
	      } else {
	        this.$timeout(function () {
	          _this19.verifyingSMS = true;
	        });
	        this.processUser();
	      }
	    }
	  }, {
	    key: "processUser",
	    value: function processUser() {
	      var _this20 = this;
	
	      this.setLoader();
	
	      console.log("processUser");
	      console.dir(this.currentUser);
	      console.dir(this.currentUser.homeContactInfo);
	
	      if (this.currentUser.homeContactInfo.isMobilePhoneVerified) {
	        console.error("This user is already verified.");
	        this.$timeout(function () {
	          _this20.smsVerified = true;
	          _this20.sendAppLink();
	        });
	      } else {
	        this.$timeout(function () {
	          _this20.smsVerified = false;
	        });
	
	        this.$timeout(function () {
	          _this20.$profile.sendSMSCode().then(function (response) {
	            _this20.unSetLoader();
	            //this.canUserApplyToShiftBasedJobs(true);
	          }).catch(function (err) {
	            _this20.unSetLoader();
	          });
	        }, 2000);
	      }
	    }
	  }, {
	    key: "sendAppLink",
	    value: function sendAppLink(exit) {
	      var _this21 = this;
	
	      return new Promise(function (resolve) {
	        var req = {
	          method: "POST",
	          data: {
	            body: "You are a Jobbler now! download the app to enhance your Jobble experience! Download: https://link.jobble.com/download-app"
	          },
	          url: _this21.$env.getAPIEndPoint() + "jbl/v1/sms",
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + _this21.$localStorage.logged_user.access_token
	          }
	        };
	
	        _this21.$http(req).then(function (response) {
	          _this21.$tracking.reportMobileLinkSent("job board", _this21.currentUser.email);
	          resolve();
	          _this21.unSetLoader();
	          if (exit) {
	            _this21.exit();
	          }
	        }).catch(function (err) {
	          console.error("SMS Error", err);
	          _this21.unSetLoader();
	          if (exit) {
	            _this21.exit();
	          }
	          resolve();
	        });
	      });
	    }
	  }, {
	    key: "codeEntered",
	    value: function codeEntered(num) {
	      if (num <= 5 && this["smsCode_" + num]) {
	        var el = document.getElementById("sms-code-" + (num + 1));
	        el.focus();
	        el.select();
	      }
	
	      var code = "" + this.smsCode_1 + this.smsCode_2 + this.smsCode_3 + this.smsCode_4 + this.smsCode_5 + this.smsCode_6;
	
	      if (code.length === 6) {
	        this.validateSMSCode();
	      }
	    }
	  }, {
	    key: "resendAppLink",
	    value: function resendAppLink() {
	      var _this22 = this;
	
	      this.$timeout(function () {
	        _this22.smsLinkSending = true;
	        _this22.smsLinkSennt = false;
	      });
	      this.sendAppLink().then(function () {
	        _this22.$timeout(function () {
	          _this22.smsLinkSending = false;
	          _this22.smsLinkSennt = true;
	        });
	      });
	    }
	  }, {
	    key: "validateSMSCode",
	    value: function validateSMSCode() {
	      var _this23 = this;
	
	      var code = "" + this.smsCode_1 + this.smsCode_2 + this.smsCode_3 + this.smsCode_4 + this.smsCode_5 + this.smsCode_6;
	
	      this.setLoader();
	
	      this.$profile.validateSMSCode(code).then(function (response) {
	        _this23.$timeout(function () {
	          _this23.smsVerified = true;
	          _this23.submitAndSaveUser(_this23.$profile.INPUT_PHONE_NUMBER);
	          _this23.canUserApplyToShiftBasedJobs(true);
	          _this23.sendAppLink();
	          _this23.$tracking.reportSMSVerified("job board", _this23.currentUser.email);
	          _this23.bootIntercom();
	          _this23.unSetLoader();
	        });
	      }).catch(function (err) {
	        _this23.$timeout(function () {
	          _this23.smsVerificationError = true;
	          _this23.smsVerificationErrorText = "Code invalid or expired";
	          _this23.unSetLoader();
	        }, 1000);
	      });
	    }
	  }, {
	    key: "consentForm",
	    value: function consentForm(page) {
	      this.savingProfile = true;
	      if (this.bgConsent !== true) {
	        this.consentToBgCheckAPI(false, page);
	      } else {
	        this.consentToBgCheckAPI(true, page);
	      }
	    }
	  }, {
	    key: "submitAndSaveUser",
	    value: function submitAndSaveUser(page) {
	      var _this24 = this;
	
	      var model = this.mapFields(this.ui_user_model);
	
	      var payload = model;
	
	      console.log("submitAndSaveUser");
	      console.dir(page);
	      console.dir(this.currentUser);
	      console.dir(payload);
	      console.dir(this.$profile);
	
	      if (page) {
	        var pageValid = true;
	
	        if (page === this.$profile.COMPLETE_PROFILE) {
	          pageValid = this.isValidMultiple(COMPLETE_PROFILE_FIELDS);
	          payload = this.$profile.extractFields(model, COMPLETE_PROFILE_FIELDS);
	        }
	
	        if (page === this.$profile.VERIFY_PHONE) {
	          pageValid = this.isValidMultiple(VERIFY_PHONE_FIELDS);
	          payload = this.$profile.extractFields(model, VERIFY_PHONE_FIELDS);
	          this.clearInputNumbers();
	        }
	
	        if (page === this.$profile.INPUT_PHONE_NUMBER) {
	          payload.homeContactInfo.isMobilePhoneVerified = true;
	        }
	
	        if (page === this.$profile.LOCATION) {
	          pageValid = this.isValidMultiple(LOCATION_FIELDS);
	          payload = this.$profile.extractFields(model, LOCATION_FIELDS);
	        }
	
	        if (page === this.$profile.WORK_ELIGIBILITY) {
	          pageValid = this.isValidMultiple(WORK_ELIGIBILITY_FIELDS);
	          payload = this.$profile.extractFields(model, WORK_ELIGIBILITY_FIELDS);
	
	          console.log("pageValid");
	          console.dir(pageValid);
	          if (this.ui_user_model.ssn !== this.ui_user_model.ssn_confirm) {
	            pageValid = false;
	            this.errors["ssn_confirm"] = true;
	          } else {
	            this.errors["ssn_confirm"] = false;
	          }
	        }
	
	        if (page === this.$profile.BG_CONSENT) {
	          payload.acceptedBackgroundCheck = true;
	        }
	
	        if (!pageValid) return;
	      }
	
	      this.savingProfile = true;
	      this.dupeSSN = false;
	
	      var _this = this;
	
	      console.log("payload to server : user");
	      console.dir(payload);
	      if (page === 6) {
	        delete payload.ssn;
	      }
	
	      console.log("payload to server : user - after delete");
	      console.dir(payload);
	
	      this.$profile.saveUser(payload).then(function (response) {
	        if (page) _this24.$tracking.reportSubmitProfileStep("job board", _this24.$profile.STATUS_MAP[page]);
	
	        _this24.$timeout(function () {
	          _this24.$auth.refreshCurrentUser().then(function (user) {
	            _this24.savingProfile = false;
	            if (response.data.status === "error") {
	              _this24.dupeSSN = true;
	              alert(response.data.message);
	            } else {
	              _this24.canUserApplyToShiftBasedJobs(true);
	            }
	          });
	        }, 1000);
	      }, function (error) {
	        console.log("saveUser error : " + error);
	        console.dir(error);
	        _this.unSetLoader();
	        _this.savingProfile = false;
	
	        if (error.data.code === 2205) {
	          alert("There was an error with your SSN. Please enter a different SSN.");
	        } else if (error.data.code === 2602) {
	          alert("You have reached the limit of SSN attempts for today. Please try again in 24 hours.");
	        } else if (error.data.code === 2600) {
	          alert("SSN to validation can not be empty and must be 9 digits long.");
	        } else if (error.data.code === 2601) {
	          alert("This is a duplicate SSN found in our system. Please contact support.");
	        } else if (error.data.code === 2603) {
	          alert("Our SSN validation service is down. Please try again later.");
	        } else if (error.data.code === 2207) {
	          alert("TIN and Name combination matches IRS EIN records.");
	        } else if (error.data.code === 2208) {
	          alert("TIN and Name combination matches IRS SSN and EIN records.");
	        } else if (error.data.code === 2202) {
	          alert("TIN entered is not currently issued.");
	        } else if (error.data.code === 3200) {
	          alert("This phone number has invalid format. Please enter a 10 digit phone number.");
	        } else if (error.data.code === 3201) {
	          alert("This phone number already exists. Please login with your existing account.");
	        } else {
	          alert("Please contact support.");
	        }
	      });
	    }
	  }, {
	    key: "consentToBgCheckAPI",
	    value: function consentToBgCheckAPI(copy, page) {
	      var _this25 = this;
	
	      this.$profile.userConsent(copy).then(function (response) {
	        _this25.$timeout(function () {
	          _this25.submitAndSaveUser(page);
	        }, 3000);
	      }, function (error) {
	        var _this26 = this;
	
	        this.$timeout(function () {
	          _this26.submitAndSaveUser(page);
	        }, 3000);
	      });
	    }
	  }, {
	    key: "clearInputNumbers",
	    value: function clearInputNumbers() {
	      this.smsCode_1 = "";
	      this.smsCode_2 = "";
	      this.smsCode_3 = "";
	      this.smsCode_4 = "";
	      this.smsCode_5 = "";
	      this.smsCode_6 = "";
	      this.smsVerificationError = null;
	    }
	  }, {
	    key: "sendUserToPartnerPost",
	    value: function sendUserToPartnerPost() {
	      this.$jobs.setPartnersPostsInteraction(this.jobble).then(function (res) {}, function (err) {});
	      var url = this.jobble.url || this.jobble.partnerPostContent.url || this.jobble.partnerPostContent.cm_url || "/jobs";
	      this.$window.open(url);
	      $("#apply-profile-modal").modal("hide");
	    }
	  }, {
	    key: "validateUserRegistration",
	    value: function validateUserRegistration() {
	      var validObject = {};
	
	      if (!this.user.email || !EMAILREGEX.test(this.user.email)) {
	        validObject.success = false;
	        validObject.error = "Please provide valid email.";
	      } else if (!this.user.password || this.user.password.length < 8) {
	        validObject.success = false;
	        validObject.error = "Please provide a password longer than 7 characters.";
	      } else {
	        validObject.success = true;
	      }
	      return validObject;
	    }
	  }, {
	    key: "partnerRegister",
	    value: function partnerRegister() {
	      var _this27 = this;
	
	      this.sendUserToPartnerPost();
	      if (this.partnerEmail) {
	        this.$localStorage.partnerEmail = this.partnerEmail;
	        this.$auth.registerMobileUser({
	          email: this.partnerEmail,
	          isBenjaminUser: true
	        }).then(function (response) {
	          _this27.$tracking.reportSubmitEmailAlert("job board", _this27.partnerEmail, _this27.jobble);
	        }).catch(function (err) {});
	      }
	    }
	  }, {
	    key: "register",
	    value: function register() {
	      var _this28 = this;
	
	      this.buttonDisabled = true;
	      this.errorTextRegi = false;
	      var validated = this.validateUserRegistration();
	
	      if (this.jobble && this.jobble.jobbleType && this.jobble.jobbleType.id && this.user) {
	        this.user["notifPref"] = {
	          jobbleTypes: [this.jobble.jobbleType.id]
	        };
	      }
	
	      if (!validated.success) {
	        this.errorTextRegi = validated.error;
	        this.buttonDisabled = false;
	        return;
	      }
	
	      var ref = this.jobble ? window.location.origin + "/job/" + this.jobble.id + "?o=1" : window.location.origin + "/jobs";
	
	      if (this.user && this.user.email) {
	        var _hsq = window._hsq || [];
	        window._hsq = _hsq;
	        _hsq.push(["setPath", "/jobs"]);
	        _hsq.push(["identify", { email: this.user.email }]);
	        _hsq.push(["trackPageView"]);
	      }
	
	      this.$auth.registerMobileUser(this.user, ref).then(function (response) {
	        if (response.data.status === "OK") {
	          _this28.$timeout(function () {
	            _this28.initFB(response);
	            _this28.signin(false, true);
	          }, 300);
	          _this28.$tracking.reportSubmitRegistration("job board", _this28.user.email);
	        } else {
	          _this28.$timeout(function () {
	            _this28.buttonDisabled = false;
	            if (response.data.message.indexOf("Duplicate entry") > -1) {
	              _this28.errorTextRegi = "This email already exists. Please try another.";
	            } else {
	              _this28.errorTextRegi = response.data.message;
	            }
	          }, 10);
	        }
	      }, function (error) {
	        alert("Error registering. Please contact support");
	      });
	    }
	  }, {
	    key: "initFB",
	    value: function initFB(response, isLogin) {
	      this.$social.initFB();
	      if (isLogin) {
	        this.fbTrackLogin(response);
	      } else {
	        this.fbTrackRegistration(response);
	      }
	    }
	  }, {
	    key: "fbTrackLogin",
	    value: function fbTrackLogin(response) {
	      var data = {
	        userId: response.data.id,
	        userName: response.data.email,
	        userEmail: response.data.email
	      };
	      this.$social.fbTrackLogin(data);
	    }
	  }, {
	    key: "fbTrackRegistration",
	    value: function fbTrackRegistration(response) {
	      var data = {
	        userId: response.data.userId,
	        userName: this.user.email,
	        userEmail: this.user.email
	      };
	      this.$social.fbTrackRegistration(data);
	    }
	  }, {
	    key: "signin",
	    value: function signin(is_direct_signin, is_registration) {
	      var _this29 = this;
	
	      this.signinError = false;
	
	      if (is_direct_signin) {
	        this.buttonDisabled = true;
	      }
	
	      this.$auth.lazyLoginMobileUser(this.user).then(function (response) {
	        _this29.noUser = false;
	
	        _this29.$timeout(function () {
	          _this29.userVerified = response.data.isVerified;
	          _this29.currentUser = response.data;
	          _this29.$auth.setMostRecentUser(response.data);
	          _this29.$auth.emitMostRecentUser();
	
	          if (is_registration) {
	            _this29.detectDevice(response.data, "register");
	          } else {
	            _this29.detectDevice(response.data, "signin");
	          }
	          _this29.buttonDisabled = false;
	          _this29.$rootScope.$emit("SetNewUserForJobBoard", {
	            user: _this29.currentUser
	          });
	          _this29.$rootScope.$emit("SetNewUserForJobBoardHeader", {
	            user: _this29.currentUser
	          });
	
	          _this29.canUserApplyToShiftBasedJobs();
	
	          _this29.$tracking.reportJobblerSignUpModal(response.data);
	          _this29.initFB(response, true);
	          if (_this29.payload.data) {
	            _this29.connect();
	          }
	        }, 10);
	      }, function (error) {
	        _this29.userVerified = false;
	        _this29.buttonDisabled = false;
	        _this29.signinError = "Login failed. Please check your credentials and try again.";
	      });
	    }
	  }, {
	    key: "connect",
	    value: function connect() {
	      var _this = this;
	
	      var data = {};
	
	      data.type = this.payload.data.connectedAccountType;
	      data.token = this.payload.data.connectedAccountToken;
	
	      _this.$signon.connect(data, this.currentUser).then(function (response) {}, function (error) {});
	    }
	  }, {
	    key: "resendEmail",
	    value: function resendEmail() {
	      var _this30 = this;
	
	      this.emailSending = true;
	
	      this.$profile.resendEmail(this.currentUser).then(function (response) {
	        _this30.$timeout(function () {
	          _this30.emailSending = false;
	          _this30.emailSent = true;
	        });
	        _this30.emailSent = true;
	      }, function (error) {
	        var _this31 = this;
	
	        this.$timeout(function () {
	          _this31.emailSending = false;
	          _this31.emailSent = false;
	        });
	      });
	    }
	  }, {
	    key: "smsAgreement",
	    value: function smsAgreement(agreed) {
	      var _this32 = this;
	
	      var user = { tcpaConsent: agreed };
	      this.setLoader();
	      this.$profile.saveUserBasic(user).then(function (response) {
	        _this32.unSetLoader();
	      }, function (error) {
	        _this32.unSetLoader();
	      });
	    }
	  }, {
	    key: "setSurveyQuestionsForJob",
	    value: function setSurveyQuestionsForJob(job) {
	      var _this33 = this;
	
	      this.questionsLoaded = false;
	      this.showReqs = false;
	
	      if (job) {
	        this.jobble = job.data;
	      }
	
	      this.$jobs.getSurveyQuestions(this.jobble.id, this.currentUser).then(function (response) {
	        _this33.last_questions_loaded_id = _this33.jobble.id;
	
	        if (response.data.subEvent.event.surveyQuestions.length > 1) {
	          _this33.last_questions_loaded_id = _this33.sortQuestions(response.data.subEvent.event.surveyQuestions).then(function (questions) {
	            _this33.setQuest(questions);
	          });
	        } else if (response.data.subEvent.event.surveyQuestions.length === 1) {
	          _this33.setQuest(response.data.subEvent.event.surveyQuestions);
	        } else {
	          var standardQuestion = {};
	          standardQuestion.question = "Can you make all the shifts?";
	          standardQuestion.isStandard = true;
	          var questionsArray = [];
	          questionsArray.push(standardQuestion);
	          _this33.setQuest(questionsArray);
	        }
	      }, function (error) {
	        _this33.questionsLoaded = false;
	      });
	    }
	  }, {
	    key: "sortQuestions",
	    value: function sortQuestions(questions) {
	      return new Promise(function (resolve) {
	        if (!questions[0].displayOrder) {
	          try {
	            questions.forEach(function (question) {
	              var questionNameArray = question.name.split(" ");
	              question.position = questionNameArray[1];
	              question.position = parseInt(question.position, 10);
	            });
	          } finally {
	            questions.sort(function (a, b) {
	              return a.position - b.position;
	            });
	          }
	        } else {
	          questions.sort(function (a, b) {
	            return a.displayOrder - b.displayOrder;
	          });
	        }
	
	        resolve(questions);
	      });
	    }
	  }, {
	    key: "setQuest",
	    value: function setQuest(questions) {
	      var _this34 = this;
	
	      var shifts = this.jobble.shifts;
	
	      this.$timeout(function () {
	        _this34.questions = questions;
	        console.log("this.questions");
	        console.dir(_this34.questions);
	        _this34.questionsLoaded = true;
	        _this34.buttonDisabled = false;
	        _this34.applicationComplete = false;
	        _this34.applicationError = false;
	        _this34.applicationText = "";
	        _this34.verifyingSMS = false;
	        _this34.smsLinkSending = false;
	        _this34.smsLinkSennt = false;
	
	        var totalHours = 0;
	        var totalMinutes = 0;
	
	        shifts.forEach(function (shift) {
	          totalHours = shift.payableHours + totalHours;
	          totalMinutes = shift.payableMins + totalMinutes;
	        });
	
	        totalHours = totalHours + totalMinutes / 60;
	        _this34.totalPayableHours = totalHours;
	        _this34.estimatedTotalPayables = _this34.jobble.jobblerRate * _this34.totalPayableHours;
	      });
	    }
	  }, {
	    key: "backToPhoneVerification",
	    value: function backToPhoneVerification() {
	      var _this35 = this;
	
	      this.$timeout(function () {
	        _this35.userProfileStatus = _this35.$profile.VERIFY_PHONE;
	      });
	    }
	  }, {
	    key: "backToSuccess",
	    value: function backToSuccess() {
	      var _this36 = this;
	
	      this.$timeout(function () {
	        _this36.verifyingSMS = false;
	      });
	    }
	  }, {
	    key: "onQuestionChange",
	    value: function onQuestionChange(q) {
	      q.error = false;
	      q.errorText = "";
	      this.errorText = "";
	    }
	  }, {
	    key: "setRequirements",
	    value: function setRequirements() {
	      var complete = true;
	
	      if (this.applicationIsSending === true) {
	        return;
	      }
	
	      this.setLoader();
	
	      this.applicationIsSending = true;
	
	      console.log("set req");
	      console.dir(this.questions);
	
	      this.questions = this.questions.map(function (q) {
	        if (!q.answer) {
	          complete = false;
	          q.errorText = "Required Question";
	          q.error = true;
	        }
	        return q;
	      });
	      /*
	      if (!complete) {
	        this.errorText = "Please complete all questions.";
	        this.unSetLoader();
	        this.applicationIsSending = false;
	        return;
	      }
	      */
	
	      this.errorText = null;
	      var user_not_verified = false;
	
	      if (!this.currentUser.isVerified || this.currentUser.isVerified === false) {
	        user_not_verified = true;
	      }
	
	      this.getRequirements(user_not_verified);
	    }
	  }, {
	    key: "getRequirements",
	    value: function getRequirements(user_not_verified) {
	
	      console.log("getRequirements");
	      console.dir(user_not_verified);
	
	      var _this = this;
	
	      var data = {};
	
	      if (_this.jobble.subEvent) {
	        data.eventId = _this.jobble.subEvent.event.id;
	      } else {
	        data.eventId = _this.jobble.eventId;
	      }
	
	      _this.$jobs.getRequirements(data).then(function (response) {
	        console.log("repsonse from requirements");
	        console.dir(response);
	        _this.handleRequirements(response.data, user_not_verified);
	
	        _this.$timeout(function () {
	          _this.unSetLoader();
	        }, 300);
	      }, function (error) {
	        _this.$timeout(function () {
	          _this.reqsLoaded = true;
	          _this.unSetLoader();
	        }, 300);
	      });
	    }
	  }, {
	    key: "handleRequirements",
	    value: function handleRequirements(data, user_not_verified) {
	      var _this = this;
	
	      var requirements = null;
	
	      if (data.length > 0) {
	        _this.showReqs = true;
	        requirements = data.sort(function (a, b) {
	          return a.position - b.position;
	        });
	
	        _this.requirements = requirements;
	        _this.reqsLoaded = true;
	      } else {
	        _this.applyNew(user_not_verified);
	      }
	    }
	  }, {
	    key: "checkReq",
	    value: function checkReq(req) {
	      if (req.isChecked === true) {
	        req.isChecked = false;
	      } else {
	        req.isChecked = true;
	      }
	    }
	  }, {
	    key: "validateReqs",
	    value: function validateReqs() {
	      var result = true;
	
	      try {
	        this.requirements.forEach(function (r) {
	          if (r.isChecked !== true) {
	            result = false;
	          }
	        });
	      } catch (error) {} finally {}
	
	      return result;
	    }
	  }, {
	    key: "showReqInfo",
	    value: function showReqInfo() {
	      this.displayReqInfo = true;
	    }
	  }, {
	    key: "applyNew",
	    value: function applyNew(user_not_verified) {
	      var _this37 = this;
	
	      if (this.applicationDisabled === true) {
	        return;
	      } else {
	        this.applicationDisabled = true;
	      }
	
	      if (this.requirements) {
	        if (this.requirements.length > 0) {
	          var reqVal = this.validateReqs();
	
	          if (reqVal === false) {
	            this.showReqError = "Please select each requirement";
	            this.applicationDisabled = false;
	            return;
	          } else {
	            this.showReqError = null;
	          }
	        }
	      }
	
	      this.setLoader();
	
	      if (user_not_verified === true || this.currentUser.isVerified === false) {
	        this.unSetLoader();
	        alert("Please verify your email before finishing application.");
	        return;
	      }
	
	      this.$jobs.applyToJob(this.questions, this.jobble.id, user_not_verified, this.currentUser).then(function (response) {
	        _this37.handleResponse(response);
	        _this37.applicationIsSending = false;
	
	        if (response.data.status !== "error") {
	          var user = _this37.currentUser;
	          _this37.$tracking.reportSubmitApplication("job board", _this37.jobble);
	          _this37.detectDevice(user);
	          if (user) {
	            var job = _this37.jobble;
	            var data = _this37.$iterable.set_data(null, job, user, "apply");
	            _this37.track_jobble_apply(data);
	          }
	        }
	      }, function (error) {
	        console.error(error);
	        _this37.unSetLoader();
	        alert("in error when applying");
	      }).catch(function (err) {
	        console.error(err);
	        _this37.unSetLoader();
	        alert("in error when applying");
	      });
	
	      this.$timeout(function () {
	        _this37.applicationDisabled = false;
	        _this37.unSetLoader();
	      }, 500);
	    }
	  }, {
	    key: "handleResponse",
	    value: function handleResponse(response) {
	      var _this38 = this;
	
	      this.$timeout(function () {
	        _this38.applicationComplete = true;
	        console.log("handleResponse");
	        console.dir(response);
	        if (response.data.status === "error") {
	          if (response.data.message === "Applicant already applied for jobble in the pool") {
	            _this38.applicationText = "You already applied to this job. Please pick another.";
	          } else if (response.data.message === "Sorry, you've already been booked to work a different jobble on this time frame.") {
	            _this38.applicationText = "Sorry, you've already been booked to work a different job on this time frame.";
	          } else if (response.data.message === "The mobile app needs to be downloaded.") {
	            _this38.applicationText = "Sorry, you must download the mobile app to finish your application.";
	          } else {
	            _this38.applicationText = "There was an issue with your application. Please try again later.";
	          }
	          _this38.applicationError = true;
	        } else {
	          _this38.applicationText = "Success! Check your application status on our mobile app.";
	          _this38.applicationError = false;
	        }
	      }, 300);
	    }
	  }, {
	    key: "track_jobble_apply",
	    value: function track_jobble_apply(data) {
	      this.$iterable.track_jobble_apply(data).then(function (response) {}, function (error) {});
	    }
	  }, {
	    key: "verify",
	    value: function verify(dontShowWarning) {
	      var _this39 = this;
	
	      var _this = this;
	      this.isVerifying = true;
	      this.$auth.reloadCurrentMobileUser().then(function (response) {
	        _this39.$timeout(function () {
	          if (!response.data.isVerified) {
	            _this39.isVerifying = false;
	            if (!dontShowWarning) {
	              _this39.errorText = "The verification link in your email has not been clicked.";
	              _this39.error = true;
	              _this39.$timeout(function () {
	                _this39.error = false;
	                _this39.errorText = undefined;
	              }, 3000);
	            } else {}
	          } else {
	            _this39.setSurveyQuestionsForJob();
	            _this39.$timeout(function () {
	              _this39.isVerifying = false;
	              _this39.userVerified = true;
	              _this39.currentUser.isVerified = true;
	              _this39.setVerificationNoti = false;
	              _this39.$rootScope.$emit("SetNewUserForJobBoard", {
	                user: _this.currentUser
	              });
	              _this39.$localStorage.logged_user.isVerified = true;
	            }, 2500);
	          }
	        }, 1000);
	      }, function (error) {
	        alert("Error validating user");
	      });
	    }
	  }, {
	    key: "showLogin",
	    value: function showLogin() {
	      var _this40 = this;
	
	      this.$timeout(function () {
	        _this40.loggingIn = true;
	      });
	    }
	  }, {
	    key: "showRegistrationModal",
	    value: function showRegistrationModal() {
	      var _this41 = this;
	
	      this.$timeout(function () {
	        _this41.loggingIn = false;
	      });
	    }
	  }, {
	    key: "detectDevice",
	    value: function detectDevice(user, page) {
	      var tracking_data = {};
	      tracking_data.email = user.email;
	
	      var device_info = this.$security.detectDevice();
	      tracking_data.mobile_device_type = device_info.mobile_device_type;
	      tracking_data.user_agent = device_info.user_agent;
	
	      if (page === "register") {
	        this.$tracking.reportMobileRegisterFromModal(tracking_data);
	      } else if (page === "signin") {
	        this.$tracking.reportMobileSigninFromModal(tracking_data);
	      } else {
	        this.$tracking.reportMobileApplication(tracking_data);
	      }
	    }
	  }, {
	    key: "formChange",
	    value: function formChange(field, page) {
	      var _this42 = this;
	
	      this.errors = this.errors || {};
	
	      this.$timeout(function () {
	        _this42.errors = _this42.$profile.validateProfile(_this42.ui_user_model, field, _this42.errors);
	      });
	    }
	  }, {
	    key: "isValidMultiple",
	    value: function isValidMultiple(fields) {
	      var _this43 = this;
	
	      var valid = true;
	
	      fields.forEach(function (field) {
	        _this43.errors = _this43.$profile.validateProfile(_this43.ui_user_model, field, _this43.errors);
	        if (_this43.errors[field]) valid = false;
	      });
	
	      return valid;
	    }
	  }, {
	    key: "openTab",
	    value: function openTab(site) {
	      if (site === "google") {
	        this.$window.open("https://play.google.com/store/apps/details?id=com.jobble.jobble&hl=en_US&gl=US", "_blank");
	        this.$tracking.reportMobileDownload("job board", this.currentUser.email, "google");
	      } else if (site === "apple") {
	        this.$window.open("https://apps.apple.com/us/app/jobble/id961838757", "_blank");
	        this.$tracking.reportMobileDownload("job board", this.currentUser.email, "apple");
	      }
	
	      this.exit();
	    }
	  }, {
	    key: "loadSignOnButtons",
	    value: function loadSignOnButtons(error) {
	      var _this44 = this;
	
	      this.setLoader();
	      this.renderGoogle();
	      this.renderFacebook();
	      this.renderApple();
	
	      this.$timeout(function () {
	        _this44.unSetLoader();
	      }, 1300);
	
	      if (error) {
	        this.$timeout(function () {
	          alert("Please select the correct login provider. " + error);
	        }, 2000);
	      }
	    }
	  }, {
	    key: "renderApple",
	    value: function renderApple() {
	      var _this45 = this;
	
	      this.$timeout(function () {
	        AppleID.auth.init({
	          clientId: _this45.$env.EnvironmentConfig.thirdPartySignon.apple,
	          redirectURI: _this45.$env.EnvironmentConfig.thirdPartySignon.appleRedirectUrl,
	          scope: "name email",
	          usePopup: true //or false defaults to false
	        });
	      }, 1000);
	    }
	  }, {
	    key: "renderGoogle",
	    value: function renderGoogle() {
	      var data = {};
	      var dataForLogin = {};
	
	      var _this = this;
	
	      this.$timeout(function () {
	        gapi.load("auth2", function () {
	          // Loads the auth2 component of gapi
	
	          gapi.auth2.init({
	            // initialize the auth2 using your credentials
	            client_id: _this.$env.EnvironmentConfig.thirdPartySignon.google
	          }).then(function onInit() {
	            // on complete of init
	
	            gapi.signin2.render("g-signin2", {
	              scope: "profile email",
	              width: 274,
	              height: 40,
	              longtitle: true,
	              theme: "dark",
	              onsuccess: function onsuccess(googleUser) {
	                // This executes when a user successfully authorizes you to their data by clicking the button and selecting their account.
	                var profile = googleUser.getBasicProfile();
	
	                dataForLogin.connectedAccountType = "GOOGLE";
	                data.connectedAccountType = "GOOGLE";
	                data.username = profile.getEmail();
	                data.firstName = profile.getGivenName();
	                data.lastName = profile.getFamilyName();
	
	                if (googleUser.tc) {
	                  dataForLogin.connectedAccountToken = googleUser.tc.id_token;
	                  data.connectedAccountToken = googleUser.tc.id_token;
	                } else if (googleUser.uc) {
	                  dataForLogin.connectedAccountToken = googleUser.uc.id_token;
	                  data.connectedAccountToken = googleUser.uc.id_token;
	                } else if (googleUser.qc) {
	                  dataForLogin.connectedAccountToken = googleUser.qc.id_token;
	                  data.connectedAccountToken = googleUser.qc.id_token;
	                }
	
	                _this.login(data, dataForLogin);
	              }
	            });
	          });
	        });
	      }, 300);
	    }
	  }, {
	    key: "renderFacebook",
	    value: function renderFacebook() {
	      var Cbuild1 = null;
	
	      this.$timeout(function () {
	        Cbuild1 = document.getElementById("fbloginonboard");
	        Cbuild1.innerHTML = "<fb:login-button scope='email' onlogin='window.fbOnLogin()' data-width='274' data-size='large' data-button-type='continue_with' data-layout='default' data-auto-logout-link='false' data-use-continue-as='false'></fb:login-button>";
	        FB.XFBML.parse(Cbuild1);
	      }, 500);
	    }
	  }, {
	    key: "handleAppleSignin",
	    value: function handleAppleSignin(response) {
	      var data = {};
	      var dataForLogin = {};
	
	      if (response.user) {
	        data.username = response.user.email;
	        data.firstName = response.user.name.firstName;
	        data.lastName = response.user.name.lastName;
	        data.connectedAccountType = "APPLE";
	        data.connectedAccountToken = response.authorization.id_token;
	
	        dataForLogin.connectedAccountType = "APPLE";
	        dataForLogin.connectedAccountToken = response.authorization.id_token;
	
	        this.registerThirdParty(data, dataForLogin, "apple");
	      } else {
	        alert("No email was returned from apple");
	      }
	    }
	  }, {
	    key: "setValidation",
	    value: function setValidation(_ref) {
	      var _this46 = this;
	
	      var field = _ref.field,
	          valid = _ref.valid,
	          message = _ref.message;
	
	      if (this.canValidate) {
	        this.$timeout(function () {
	          _this46.validation[field] = {
	            valid: valid,
	            style: { borderColor: valid ? "green" : "red" },
	            message: message
	          };
	        });
	      }
	    }
	  }, {
	    key: "confirmEmail",
	    value: function confirmEmail(data, dataForLogin, needEmailConfirmation) {
	      var _this47 = this;
	
	      if (needEmailConfirmation === true) {
	        this.payload.needEmailConfirmation = true;
	        this.payload.data = data;
	        this.payload.dataForLogin = dataForLogin;
	      }
	
	      this.$timeout(function () {
	        _this47.confirmEmailBool = true;
	        _this47.signOnEmail = data.username;
	      });
	    }
	  }, {
	    key: "sendConfirmedEmail",
	    value: function sendConfirmedEmail() {
	      this.payload.data.username = this.signOnEmail;
	
	      var data = this.payload.data;
	      var dataForLogin = this.payload.dataForLogin;
	
	      this.registerThirdParty(data, dataForLogin, false);
	    }
	  }, {
	    key: "registerThirdParty",
	    value: function registerThirdParty(data, dataForLogin, needEmailConfirmation) {
	      var _this = this;
	
	      var handleAppleScreen = false;
	
	      if (this.registering === true) {
	        console.log("are we here?");
	        return;
	      }
	
	      if (needEmailConfirmation === true) {
	        _this.confirmEmail(data, dataForLogin, needEmailConfirmation);
	        return;
	      }
	
	      if (needEmailConfirmation === "apple") {
	        handleAppleScreen = true;
	        dataForLogin.handleAppleScreen = handleAppleScreen;
	        dataForLogin.appleUsername = data.username;
	      }
	
	      this.registering = true;
	      this.setLoader();
	
	      _this.$signon.register(data, dataForLogin).then(function (response) {
	        if (response.data.message.indexOf("Duplicate entry") > -1) {
	          _this.sendUserToSignIn(data, dataForLogin);
	        } else if (response.data.message.indexOf("The email provided is already connected") > -1) {
	          _this.confirmEmailBool = false;
	          _this.loadSignOnButtons(response.data.message);
	        } else if (response.data.message === "The registration email was successfully sent") {
	          _this.$timeout(function () {
	            _this.registering = false;
	            _this.login(data, dataForLogin);
	          }, 500);
	        } else {}
	      }, function (error) {
	        _this.registering = false;
	        alert("There was an error with your registration. Please try again later.");
	      });
	    }
	  }, {
	    key: "login",
	    value: function login(data, dataForLogin) {
	      var _this = this;
	
	      _this.$signon.login(data, dataForLogin).then(function (response) {
	        console.log("what is the response");
	        console.dir(response);
	        if (response.data.access_token) {
	          _this.userVerified = response.data.isVerified;
	          _this.currentUser = response.data;
	          _this.$auth.setMostRecentUser(response.data);
	          _this.$auth.emitMostRecentUser();
	          response.data.type = dataForLogin.connectedAccountType;
	          _this.$tracking.reportJobblerSignUpThirdPartyOnboarding(response.data);
	          _this.sendUser(response, dataForLogin);
	          _this.unSetLoader();
	        }
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	        if (error.status === 401) {
	          _this.unSetLoader();
	          _this.registerThirdParty(data, dataForLogin, true);
	        } else {
	          _this.unSetLoader();
	        }
	      });
	    }
	  }, {
	    key: "sendUserToSignIn",
	    value: function sendUserToSignIn(data, dataForLogin) {
	      this.userNeedsToSignIn = true;
	      this.noUser = true;
	      this.loggingIn = true;
	      this.confirmEmailBool = false;
	      this.payload.data = data;
	      this.user.email = data.username;
	      this.payload.dataForLogin = dataForLogin;
	      this.signinError = "The email " + data.username + " already exists. Please login by entering your password to connect your Jobble account to third party service.";
	    }
	  }, {
	    key: "sendUser",
	    value: function sendUser(response, dataForLogin) {
	      var user = {};
	
	      if (response.data.company) {
	        this.$state.go("events");
	        return;
	      }
	
	      user = response.data;
	
	      this.$localStorage.logged_user = response.data;
	      this.currentUser = response.data;
	      this.currentUser.homeContactInfo = {};
	      this.noUser = false;
	
	      if (this.currentUser.isVerified !== true) {
	        this.confirmEmailBool = true;
	      } else {
	        this.canUserApplyToShiftBasedJobs();
	      }
	
	      this.$timeout(function () {
	        if (dataForLogin.handleAppleScreen === true) {
	          alert("Account created using " + dataForLogin.appleUsername + ". If you would like Jobble to send important messages to a different email address you can change it in your profile.");
	        }
	      }, 300);
	    }
	  }, {
	    key: "fbSuccessfulLogin",
	    value: function fbSuccessfulLogin() {
	      var data = {};
	      var dataForLogin = {};
	
	      var _this = this;
	
	      FB.getLoginStatus(function (response) {
	        var fbResponse = response;
	
	        if (response.status === "connected") {
	          _this.setLoader();
	
	          FB.api("/me?fields=name,email,first_name,last_name", function (response) {
	            _this.unSetLoader();
	            if (!response.email) {
	              _this.handleFaceBookNoEmail(response, fbResponse);
	            } else {
	              if (fbResponse.authResponse.accessToken) {
	                dataForLogin.connectedAccountType = "FACEBOOK";
	                dataForLogin.connectedAccountToken = fbResponse.authResponse.accessToken;
	                data.username = response.email;
	                data.firstName = response.first_name;
	                data.lastName = response.last_name;
	                data.connectedAccountType = "FACEBOOK";
	                data.connectedAccountToken = fbResponse.authResponse.accessToken;
	                _this.login(data, dataForLogin);
	              }
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: "bootIntercom",
	    value: function bootIntercom() {
	      console.log("boot intercom");
	      console.dir(this.window);
	      console.dir(this.$window);
	
	      if (this.currentUser) {
	        this.$window.Intercom("boot", {
	          app_id: "och30e8r",
	          email: this.currentUser.email,
	          user_id: this.currentUser.id,
	          created_at: 1234567890
	        });
	      }
	    }
	  }, {
	    key: "smsCodeBackSpace",
	    value: function smsCodeBackSpace(event, inputSequence) {
	      if (event.keyCode === 8) {
	        if (inputSequence !== 1) {
	          var activeValue = $(".apply-profile-modal .modal-content .sms-code-container input#sms-code-" + inputSequence).val();
	          if (activeValue === "") {
	            this.$timeout(function () {
	              $(".apply-profile-modal .modal-content .sms-code-container input#sms-code-" + (inputSequence - 1)).focus();
	            });
	          }
	        }
	      }
	    }
	  }]);
	
	  return ApplyProfileModalController;
	}();
	
	ApplyProfileModalController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "signon", "signup.validator", "tracking", "$rootScope", "$scope", "$location", "$timeout", "$window", "companies", "messagingv2", "events", "jobs", "social", "iterable", "profile", "env", "validation"];
	
	exports.default = ApplyProfileModalController;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(173);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".apply-profile-modal .modal{background:rgba(0,0,0,.38)}.apply-profile-modal .modal-dialog{width:324px;margin-top:100px}.apply-profile-modal .modal-gradient-banner{height:6px;width:100%;border-radius:6px 6px 0 0;background:linear-gradient(116.57deg,#62c046,#5498b4)}.apply-profile-modal .modal-dialog.profile{width:457px}.apply-profile-modal .modal-dialog.questions{width:515px}.apply-profile-modal .modal-dialog.questions.sms{width:324px}.apply-profile-modal .modal-content{border-radius:0 0 6px 6px;border:1px solid #fff;border-top:none;padding:24px}.apply-profile-modal .profile .modal-content{padding-top:18px}@media only screen and (max-width:768px){.apply-profile-modal .modal{background:#fff}.apply-profile-modal .modal-content{box-shadow:none}.apply-profile-modal .modal-dialog::-webkit-scrollbar,.apply-profile-modal .modal::-webkit-scrollbar{width:0!important}.apply-profile-modal .modal-content .modal-profile-content::-webkit-scrollbar,.apply-profile-modal .modal-content::-webkit-scrollbar{width:0!important}.apply-profile-modal .modal-gradient-banner{display:none}.apply-profile-modal .modal-dialog,.apply-profile-modal .modal-dialog.profile,.apply-profile-modal .modal-dialog.questions,.apply-profile-modal .modal-dialog.questions.sms{width:100%;min-height:100%;margin:0}.apply-profile-modal .modal-dialog.questions.sms{text-align:center}.apply-profile-modal .modal-content{height:100%;border:none;padding:16px}.apply-profile-modal .modal-content .modal-profile-content{padding-top:92px;padding-bottom:60px;height:calc(100vh - 40px);overflow:scroll}.apply-profile-modal .modal-content .modal-content-container,.apply-profile-modal .modal-content .modal-question-content{padding-top:76px}.apply-profile-modal .modal-content .modal-question-content{padding-bottom:40px}}.apply-profile-modal .modal-content .modal-fixed-bar{position:relative;height:24px}.apply-profile-modal .sign-in-modal .modal-content .modal-fixed-bar,.apply-profile-modal .sign-in .modal-content .modal-fixed-bar,.apply-profile-modal .success-modal .modal-content .modal-fixed-bar{position:absolute;right:16px;top:22px}.apply-profile-modal .modal-content .progress-dot-container{text-align:center;position:absolute;top:-8px;left:0;right:0}.apply-profile-modal .modal-content .progress-dot-container .progress-dot{height:8px;width:8px;border:1px solid #adbcc2;background-color:#e2e3e2;border-radius:100%;display:inline-block;cursor:pointer}.apply-profile-modal .modal-content .progress-dot-container .progress-dot.current-dot{background:#62c046}@media only screen and (max-width:768px){.apply-profile-modal .modal-content .modal-fixed-bar{background:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.1);height:52px;width:100%;position:absolute;left:0;top:auto;right:auto}.apply-profile-modal .modal-content .progress-dot-container{top:60px}}.apply-profile-modal .modal-content .save-exit{color:#6a7178;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;line-height:18px;position:absolute;right:0;top:0;cursor:pointer}.apply-profile-modal .modal-content .save-exit i{color:#929799;font-size:14px;line-height:14px;display:none}.apply-profile-modal .modal-content.verify{text-align:center}.apply-profile-modal .modal-content.verify .terms-and-service{text-align:center;color:#62c046}.apply-profile-modal .modal-content.verify .verify-image-container{width:144px;margin:auto;margin-top:14px}.apply-profile-modal .modal-content.verify .verify-image-container img{width:100%}.apply-profile-modal .modal-content.verify .modal-fixed-bar{display:none}.apply-profile-modal .modal-dialog.partner .save-exit i,.apply-profile-modal .modal-dialog.questions .save-exit i,.apply-profile-modal .modal-dialog.sign-in-modal .save-exit i,.apply-profile-modal .modal-dialog.sign-in .save-exit i{display:block}@media only screen and (max-width:768px){.apply-profile-modal .modal-content.verify .modal-fixed-bar{display:block}.apply-profile-modal .modal-content .save-exit{left:0;padding-left:16px;right:auto;top:0;padding-top:10px;width:50px;height:50px;cursor:pointer}.apply-profile-modal .modal-content .save-exit span{display:none}.apply-profile-modal .modal-content .save-exit i{display:block}}.apply-profile-modal .tooltip{opacity:1}.apply-profile-modal .tooltip>.tooltip-inner{border-radius:6px;background:#5e666d;color:#fff;font-family:Poppins,sans-serif;font-size:12px;font-weight:500;letter-spacing:0;line-height:16px;text-align:left;padding:16px;min-width:288px}.apply-profile-modal .modal-content h3{margin:0;font-family:Poppins,sans-serif;font-size:18px;font-weight:700;line-height:20px}.apply-profile-modal .modal-content h4{margin:0;margin-top:16px;font-family:Poppins;font-size:14px;font-weight:600}.apply-profile-modal .modal-content p{margin:8px 0 0;color:#33373a;font-family:Poppins,sans-serif;font-size:14px;line-height:21px}.apply-profile-modal .modal-content label{color:#33373a;font-family:Poppins,sans-serif;font-size:14px;line-height:21px;font-weight:400;margin-top:16px}.apply-profile-modal .input-container{position:relative}.apply-profile-modal .input-container i{position:absolute;left:16px;top:12px;font-size:16px;color:#adbcc2}.apply-profile-modal .modal-content input,.apply-profile-modal .modal-content select{box-shadow:0 2px 4px 0 rgba(0,0,0,.1);height:40px;display:block;width:100%;border:1px solid #767676;border-radius:2px;background-color:#fff;padding:0 16px}.apply-profile-modal .input-container input{padding-left:42px;margin-top:16px;border:1px solid #adbcc2;box-shadow:none}.apply-profile-modal ::-webkit-input-placeholder{color:#adbcc2;opacity:1}.apply-profile-modal :-moz-placeholder,.apply-profile-modal ::-moz-placeholder{color:#adbcc2;opacity:1}.apply-profile-modal :-ms-input-placeholder,.apply-profile-modal ::-ms-input-placeholder{color:#adbcc2;opacity:1}.apply-profile-modal :placeholder-shown{color:#adbcc2;opacity:1}.apply-profile-modal .modal-content textarea{height:156px;border:1px solid #767676;border-radius:2px;background-color:#fff;color:#33373a;font-family:Poppins,sans-serif;font-size:14px;padding:16px;line-height:21px;margin-top:8px;width:100%}.apply-profile-modal .modal-content .character-limit{text-align:right;color:#33373a;font-family:Poppins,sans-serif;font-size:12px;letter-spacing:0;line-height:18px;margin-top:8px}.apply-profile-modal .modal-content .continue-button{font-size:14px;line-height:40px;height:40px;width:100%;background-color:#62c046;margin-top:16px}.apply-profile-modal .modal-content .continue-button,.apply-profile-modal .modal-content .learn-more-button{color:#fff;font-family:Poppins,sans-serif;font-weight:700;border-radius:6px;text-align:center;cursor:pointer}.apply-profile-modal .modal-content .learn-more-button{width:177px;margin:auto;height:50px;background:linear-gradient(225deg,#5498b4,#62c046);line-height:50px;font-size:17px}@media only screen and (max-width:768px){.apply-profile-modal .modal-content .continue-button{position:fixed;bottom:0;left:0;border-radius:0}}.apply-profile-modal .modal-profile-content .upload-btn-wrapper{position:relative;overflow:hidden;display:inline-block;cursor:pointer}.apply-profile-modal .modal-profile-content .btn{height:34px;width:111px;border-radius:6px;background-color:#62c046;color:#fff;font-family:Poppins,sans-serif;font-size:14px;font-weight:600;line-height:34px;text-align:center;padding:0;cursor:pointer}.apply-profile-modal .modal-profile-content .upload-btn-wrapper input[type=file]{font-size:100px;position:absolute;left:0;top:0;opacity:0;cursor:pointer}.apply-profile-modal .modal-profile-content .profile-image-container{display:block;margin:auto;margin-top:16px;height:128px;width:128px;border:1px solid #adbcc2;background-color:#f7f7f7;border-radius:100%;position:relative;background-size:cover;background-position:50% 50%;background-repeat:no-repeat}.apply-profile-modal .modal-profile-content .profile-image-container img{width:100%;height:100%;border-radius:100%}.apply-profile-modal .modal-profile-content .profile-image-container i{position:absolute;left:0;right:0;margin:auto;font-size:24px;line-height:128px;color:#62c046}.apply-profile-modal .modal-profile-content .pill-container{margin-top:16px;height:94px;overflow:hidden}.apply-profile-modal .modal-profile-content .pill-container.expanded{height:fit-content;overflow:visible}.apply-profile-modal .modal-profile-content .pill-load-more{margin-top:16px;color:#62c046;font-family:Poppins,sans-serif;font-size:12px;font-weight:700;letter-spacing:0;line-height:11px;cursor:pointer}.apply-profile-modal .modal-profile-content .pill{display:inline-block;color:#5e666d;height:25px;padding:0 10px;line-height:24px;border:1px solid #5e666d;border-radius:13.5px;font-size:11px;font-family:Poppins,sans-serif;font-weight:500;margin-right:8px;cursor:pointer;margin-bottom:8px;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.apply-profile-modal .modal-profile-content .selected-pill{background:#5e666d;color:#fff}.apply-profile-modal .modal-dialog .terms-and-service{border-top:1px solid #adbcc2;margin-top:16px;padding-top:16px}.apply-profile-modal .modal-dialog .login-text{margin-top:24px}.apply-profile-modal .modal-dialog .forgot-password-text{margin-top:16px}.apply-profile-modal .modal-dialog .sign-up-text{padding-top:16px;margin-top:16px;border-top:1px solid #adbcc2}.apply-profile-modal .modal-dialog .email-verify-text,.apply-profile-modal .modal-dialog .forgot-password-text,.apply-profile-modal .modal-dialog .login-text,.apply-profile-modal .modal-dialog .sign-up-text,.apply-profile-modal .modal-dialog .terms-and-service{font-family:Poppins,sans-serif;font-size:12px;font-weight:600;line-height:18px;text-align:center}.apply-profile-modal .modal-dialog .email-verify-text,.apply-profile-modal .modal-dialog .forgot-password-text,.apply-profile-modal .modal-dialog .login-text span,.apply-profile-modal .modal-dialog .sign-up-text span,.apply-profile-modal .modal-dialog .terms-and-service a{color:#62c046;cursor:pointer}.apply-profile-modal .job-header-container{display:flex;flex-direction:row;margin-top:16px;padding-top:16px;border-top:1px solid #adbcc2}.apply-profile-modal .job-header-logo{flex:0 0 54px;height:54px;margin-right:16px;border:1px solid #adbcc2;border-radius:2px;overflow:hidden}.apply-profile-modal .job-header-logo div{padding-right:0;background-size:cover;background-position:50% 50%;background-repeat:no-repeat;height:100%;width:100%}.apply-profile-modal .job-header-details{flex:1}.apply-profile-modal .job-header-title{color:#33373a;font-family:Poppins,sans-serif;font-size:14px;font-weight:600;line-height:21px;text-decoration:underline}.apply-profile-modal .job-header-company,.apply-profile-modal .job-header-location{color:#33373a;font-family:Poppins,sans-serif;font-size:11px;letter-spacing:.3px;line-height:11px;margin-top:8px}.apply-profile-modal .job-header-company{text-transform:uppercase;letter-spacing:.33px;font-weight:500}.apply-profile-modal .job-details-box-container{padding:16px;background:#f7f7f7;color:#5e666d;border:1px solid #adbcc2;border-radius:6px;margin-top:16px}.apply-profile-modal .job-details-box-container .details-day-type-row,.apply-profile-modal .job-details-box-container .details-pay-row{display:flex;margin-bottom:16px}.apply-profile-modal .job-details-box-container .col .details-pay-row:last-child{margin-bottom:0}.apply-profile-modal .job-details-box-container .row-icon{flex:0 0 30px;font-size:18px;line-height:18px}.apply-profile-modal .job-details-box-container .row-information{flex:1;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;letter-spacing:.3px;line-height:18px;text-transform:uppercase}.apply-profile-modal .skip-for-now{color:#5e666d;font-family:Poppins,sans-serif;font-size:14px;font-weight:600;letter-spacing:0;line-height:21px;margin-top:24px;margin-bottom:16px;text-align:center;cursor:pointer}.apply-profile-modal .loading-questions{font-family:Poppins,sans-serif;font-size:12px;font-weight:600;letter-spacing:.3px;line-height:18px;text-transform:uppercase;margin-top:16px}.apply-profile-modal .question-text.error{border:1px solid #d8000c}.apply-profile-modal .error-text,.apply-profile-modal .input-error-text{color:#d8000c;font-family:Poppins,sans-serif;margin-top:16px;font-size:11px;letter-spacing:0;line-height:14px}.apply-profile-modal .input-error-text{margin-top:8px}.apply-profile-modal .error-text.question{margin-top:-12px}.apply-profile-modal .modal-content input.input-error,.apply-profile-modal .modal-content select.select-error,.apply-profile-modal .modal-content textarea.input-error{border-color:#d8000c}.apply-profile-modal .modal-content .success-image-container{margin-top:24px;display:flex;margin-bottom:26px;padding:0 35px 0 42px}.success-image-container .phone-container{flex:0 0 167px}.success-image-container .phone-container img{width:100%}.success-image-container .right-side-container{flex:1;padding-left:28px;padding-top:83px;color:#5e666d;font-family:Poppins,sans-serif;font-size:18px;font-weight:600;letter-spacing:0;line-height:27px}.success-image-container .right-side-container img{margin-bottom:16px;width:32px}.sms-code-container{display:flex;justify-content:space-between;margin-top:24px;margin-bottom:100px}.apply-profile-modal .modal-content .sms-code-container input{width:32px;border:none;border-bottom:2px solid #868c8e;background:none;box-shadow:none;color:#62c046;font-family:Poppins,sans-serif;font-size:24px;font-weight:700;letter-spacing:0;line-height:24px;text-align:center;padding:0}.sms-success-container{width:fit-content;margin:24px auto auto;text-align:center}.apply-profile-modal .modal-dialog .terms-and-service.sms-policy-signing{text-align:left;font-size:12px}.apply-profile-modal .modal-content input[type=checkbox]{display:inline;height:auto;width:auto;margin-right:5px}.sms-success-container img{width:163px;margin:auto}.indi-success-holder{width:112.8%;background:linear-gradient(116.57deg,#5498b4,#393c92);margin-left:-25px;padding-bottom:65px}.apply-profile-modal .modal-content .indi-success-holder h4{color:#fff;font-family:Poppins,sans-serif;font-weight:900;font-size:18px;text-align:center;padding-top:24px}.apply-profile-modal .modal-content .indi-success-holder h4.get-started{text-decoration:underline;margin-top:0;padding-top:0;font-size:20px}.indi-success-holder img{margin:0 auto}.mobile-app-links{border:1px solid #5e666d;border-radius:6px;width:100%;padding-top:15px;padding-bottom:15px;padding-left:15px;color:#33373a;font-family:Poppins;font-size:14px;font-weight:900;margin-bottom:15px}.mobile-app-links i{font-size:16px;font-weight:200;margin-right:35px}.line-holder{width:100%;text-align:center}.line-holder span{color:#33373a;font-size:16px;font-family:Poppins,sans-serif;font-weight:900}.line-holder .left-line{float:left}.line-holder .left-line,.line-holder .right-line{border-top:1px solid #adbcc2;width:40%;margin-top:11px}.line-holder .right-line{float:right}.mobile-app-links:hover{cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _sendmessage = __webpack_require__(175);
	
	var _sendmessage2 = _interopRequireDefault(_sendmessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sendmessageModule = _angular2.default.module("sendmessage", [_angularUiRouter2.default]).component("sendmessage", _sendmessage2.default);
	
	exports.default = sendmessageModule;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sendmessage = __webpack_require__(176);
	
	var _sendmessage2 = _interopRequireDefault(_sendmessage);
	
	var _sendmessage3 = __webpack_require__(177);
	
	var _sendmessage4 = _interopRequireDefault(_sendmessage3);
	
	__webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sendmessageComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _sendmessage2.default,
	  controller: _sendmessage4.default,
	  controllerAs: "vm"
	};
	
	exports.default = sendmessageComponent;

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"applicant-send-message hidden-message-box\" id=\"scroll-here\">\n  <form ng-submit=\"vm.sendMessageToJobbler()\" name=\"sending-message-popup\" class=\"inline-messaging-text\">\n    <span aria-hidden=\"true\" ng-click=\"vm.closeAndClearMessage()\" style=\"float: left\">\n      <i class=\"fa fa-times-circle clickable-link\" aria-hidden=\"true\" ng-click=\"vm.closeAndClearMessageBox()\"></i>\n    </span>\n\n    <p>Message jobbler</p>\n\n    <textarea rows=\"6\" ng-model=\"vm.message\" ng-change=\"vm.messageChecking()\" autofocus></textarea>\n    <input type=\"submit\" value=\"Send\" class=\"btn button btn-success\" ng-disabled=\"vm.disabled\" />\n  </form>\n</div>\n"

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SendmessageController = function () {
	  function SendmessageController($http, $state, $stateParams, $location, $interval, AuthService, EventsService, SecurityService, $rootScope, $localStorage, ngProgressFactory, $timeout, $cookies, MessagingService, Messagingv2Service, $scope, $anchorScroll) {
	    _classCallCheck(this, SendmessageController);
	
	    this.name = "sendmessage";
	    this.$http = $http;
	    this.$auth = AuthService;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$progress = ngProgressFactory.createInstance();
	    this.$events = EventsService;
	    this.$localStorage = $localStorage;
	    this.$interval = $interval;
	    this.$scope = $scope;
	    this.$security = SecurityService;
	    this.$cookies = $cookies;
	    this.$messaging = MessagingService;
	    this.$location = $location;
	    this.$messagingv2 = Messagingv2Service;
	    this.$timeout = $timeout;
	    this.$anchor = $anchorScroll;
	    this.reqCounter = 0;
	    this.$rootScope = $rootScope;
	    this.currentUser = this.$auth.getUserData();
	    this.disabled = true;
	    this.remain_loading_count = 0;
	    this.isLazyUser = true;
	    this.errorMessage = { status: false, message: null };
	    this.newUserObj = { email: null, password: null, password2: null };
	    this.showContinueButton = false;
	    this.check_policy = false;
	    this.displayTOSModal = false;
	    this.phone_class = "";
	
	    var _this = this;
	
	    _this.SetJobblerForMessageListener = _this.$rootScope.$on("SetJobblerForMessage", function ($event, params) {
	      _this.jobbler = params.jobbler;
	      _this.eventId = params.event.id;
	      _this.jobblerEmail = params.jobbler.email;
	      _this.message = null;
	      _this.setHeightOfPage();
	      _this.destoryFunc(params.s);
	      _this.$messagingv2 = params.m;
	    });
	  }
	
	  _createClass(SendmessageController, [{
	    key: "destoryFunc",
	    value: function destoryFunc(scp) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        scp.$on("$destroy", _this.SetJobblerForMessageListener);
	      }, 300);
	    }
	  }, {
	    key: "sendMessageToJobbler",
	    value: function sendMessageToJobbler() {
	      var _this = this;
	      var users = _this.constructUsersObject();
	
	      var msg = _this.message;
	
	      _this.createOrReturnChannel(users, msg);
	      _this.$timeout(function () {
	        jQuery(".applicant-send-message").hide("slow");
	      });
	      _this.$timeout(function () {
	        _this.$rootScope.$broadcast("ShowProfile", {});
	      }, 500);
	      _this.$timeout(function () {
	        _this.$rootScope.$broadcast("ShowNoti", {});
	      }, 1000);
	    }
	  }, {
	    key: "messageChecking",
	    value: function messageChecking() {
	      var _this = this;
	
	      if (_this.message.length > 0) {
	        _this.disabled = false;
	      } else {
	        _this.disabled = true;
	      }
	    }
	  }, {
	    key: "constructUsersObject",
	    value: function constructUsersObject() {
	      var _this = this;
	      var usersObj = {};
	      usersObj.users = _this.currentUser.username + "," + _this.jobblerEmail;
	      usersObj.event = _this.eventId;
	      return usersObj;
	    }
	  }, {
	    key: "createOrReturnChannel",
	    value: function createOrReturnChannel(users, msg) {
	      var _this = this;
	
	      var jobblerArray = [];
	      var isNewChannel = true;
	
	      jobblerArray.push(_this.jobbler);
	      _this.blockedList = _this.$messagingv2.generateBlockList(jobblerArray);
	
	      var message_data = {
	        p1: _this.message,
	        p2: null,
	        p3: null,
	        p4: null,
	        p5: _this.blockedList,
	        p6: _this.eventId,
	        p7: null,
	        p8: isNewChannel,
	        p9: null,
	        p10: null,
	        p11: null
	      };
	
	      _this.$messagingv2.createOrReturnChannelTrimmed(users, null, message_data).then(function (response) {
	        console.log("response");
	        console.dir(response.data.result[0].channelName);
	        //_this.findChannel(response.data.result[0].channelName);
	      }, function (error) {
	        console.log("in error");
	      });
	    }
	  }, {
	    key: "findChannel",
	    value: function findChannel(channel) {
	      var _this = this;
	
	      console.log("looking for channels");
	      console.dir(_this.$rootScope.allChannelNames);
	    }
	  }, {
	    key: "getChannelsReq",
	    value: function getChannelsReq(channel) {
	      var _this = this;
	      console.log("getChannelsReq");
	      console.dir(channel);
	      _this.$timeout(function () {
	        _this.$messagingv2.getChannels(1).then(function (response) {
	          if (response.data.channels.length > 0) {
	            if (response.data.channels[0].name === channel) {
	              var jobblerArray = [];
	              jobblerArray.push(_this.jobbler);
	              _this.blockedList = _this.$messagingv2.generateBlockList(jobblerArray);
	              var isNewChannel = true;
	              var indexOf = null;
	              _this.$messagingv2.publishMessage(_this.message, null, null, null, _this.blockedList, _this.eventId, response.data.channels[0], isNewChannel, response.data.channels[0].name, indexOf);
	              var new_chat_with_jobbler = true;
	            } else {
	              _this.loadChannels(channel);
	            }
	          } else {
	            _this.loadChannels(channel);
	          }
	        }, function (error) {
	          console.log("in error in send message");
	        });
	      }, 3000);
	    }
	  }, {
	    key: "loadChannels",
	    value: function loadChannels(channel) {
	      var _this = this;
	      _this.getChannelsReq(channel);
	    }
	  }, {
	    key: "closeAndClearMessageBox",
	    value: function closeAndClearMessageBox() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $(".applicant-send-message.hidden-message-box").hide("fast");
	      });
	
	      _this.$timeout(function () {
	        _this.message = null;
	      }, 200);
	    }
	  }, {
	    key: "setHeightOfPage",
	    value: function setHeightOfPage() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $(".applicant-send-message.hidden-message-box").show("slow");
	      }, 200);
	    }
	  }]);
	
	  return SendmessageController;
	}();
	
	SendmessageController.$inject = ["$http", "$state", "$stateParams", "$location", "$interval", "auth", "events", "security", "$rootScope", "$localStorage", "ngProgressFactory", "$timeout", "$cookies", "messagingv2", "$scope", "$anchorScroll"];
	
	exports.default = SendmessageController;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(179);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./sendmessage.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./sendmessage.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".globalalert{color:red}", ""]);
	
	// exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _messaginggallery = __webpack_require__(181);
	
	var _messaginggallery2 = _interopRequireDefault(_messaginggallery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messaginggalleryModule = _angular2.default.module("messaginggallery", [_angularUiRouter2.default]).component("messaginggallery", _messaginggallery2.default);
	
	exports.default = messaginggalleryModule;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _messaginggallery = __webpack_require__(182);
	
	var _messaginggallery2 = _interopRequireDefault(_messaginggallery);
	
	var _messaginggallery3 = __webpack_require__(183);
	
	var _messaginggallery4 = _interopRequireDefault(_messaginggallery3);
	
	__webpack_require__(184);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messaginggalleryComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _messaginggallery2.default,
	  controller: _messaginggallery4.default,
	  controllerAs: "vm"
	};
	
	exports.default = messaginggalleryComponent;

/***/ }),
/* 182 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"messaging-gallery\" ng-esc=\"vm.close()\" tabindex=\"0\" ng-keydown=\"vm.key($event)\">\n  <div class=\"messaging-gallery-header\">\n    <a href=\"\" ng-click=\"vm.close()\">x</a>\n  </div>\n\n  <!--\n\tng-prev=\"vm.previous(vm.mainPhotoUrl)\" \n\tng-next=\"vm.next(vm.mainPhotoUrl)\"\n\tng-keydown=\"vm.previous(vm.mainPhotoUrl)\"\n\t-->\n\n  <div class=\"main-photo\">\n    <a href=\"\" ng-click=\"vm.previous(vm.mainPhotoUrl)\" ng-if=\"$root.photos.length > 1 || vm.photos.length > 1\">&#8249;</a>\n    <img src=\"{{ vm.mainPhotoUrl }}\" ng-show=\"vm.mainPhotoUrl\" />\n    <a href=\"\" ng-click=\"vm.next(vm.mainPhotoUrl)\" ng-if=\"$root.photos.length > 1  || vm.photos.length > 1\">&#8250;</a>\n  </div>\n</div>\n\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MessaginggalleryController = function () {
	  function MessaginggalleryController($http, $state, $stateParams, AuthService, EventsService, SecurityService, $rootScope, $scope, $localStorage, ngProgressFactory, $timeout, $location) {
	    _classCallCheck(this, MessaginggalleryController);
	
	    this.name = "messaginggallery";
	    this.$http = $http;
	    this.$auth = AuthService;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$progress = ngProgressFactory.createInstance();
	    this.$events = EventsService;
	    this.$localStorage = $localStorage;
	    this.$security = SecurityService;
	    this.$location = $location;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.currentUser = this.$auth.getUserData();
	    this.remain_loading_count = 0;
	
	    this.isLazyUser = true;
	    this.errorMessage = { status: false, message: null };
	    this.newUserObj = { email: null, password: null, password2: null };
	    this.showContinueButton = false;
	    this.check_policy = false;
	    this.displayTOSModal = false;
	    var _this = this;
	
	    _this.CollectPhotosListener = _this.$rootScope.$on("CollectPhotos", function ($event, params) {
	      console.log("does this get called?");
	      console.dir(params);
	      if (params.dataprof) {
	        _this.mainPhotoUrl = params.dataprof[0];
	        _this.photos = params.dataprof;
	        _this.isProfilePage = true;
	      } else {
	        _this.mainPhotoUrl = params.data.imageURL;
	      }
	    });
	
	    _this.$scope.$on("$destroy", _this.CollectPhotosListener);
	    _this.$timeout(function () {
	      jQuery("#messaging-gallery").focus();
	    }, 300);
	  }
	
	  _createClass(MessaginggalleryController, [{
	    key: "next",
	    value: function next(data) {
	      if (this.isProfilePage) {
	        for (var i = 0; i < this.photos.length; i++) {
	          if (this.photos[i] === this.mainPhotoUrl) {
	            var next = i + 1;
	            if (next === this.photos.length) {
	              next = 0;
	            }
	            this.mainPhotoUrl = this.photos[next];
	            break;
	          }
	        }
	      } else {
	        for (var i = 0; i < this.$rootScope.photos.length; i++) {
	          if (this.$rootScope.photos[i] === this.mainPhotoUrl) {
	            var next = i + 1;
	            if (next === this.$rootScope.photos.length) {
	              next = 0;
	            }
	            this.mainPhotoUrl = this.$rootScope.photos[next];
	            break;
	          }
	        }
	      }
	    }
	  }, {
	    key: "previous",
	    value: function previous(data) {
	      if (this.isProfilePage) {
	        for (var i = 0; i < this.photos.length; i++) {
	          if (this.photos[i] === this.mainPhotoUrl) {
	            if (i === 0) {
	              next = this.photos.length - 1;
	            } else {
	              var next = i - 1;
	            }
	
	            this.mainPhotoUrl = this.photos[next];
	            break;
	          }
	        }
	      } else {
	        for (var i = 0; i < this.$rootScope.photos.length; i++) {
	          if (this.$rootScope.photos[i] === this.mainPhotoUrl) {
	            if (i === 0) {
	              next = this.$rootScope.photos.length - 1;
	            } else {
	              var next = i - 1;
	            }
	
	            this.mainPhotoUrl = this.$rootScope.photos[next];
	            break;
	          }
	        }
	      }
	    }
	  }, {
	    key: "closeGallery",
	    value: function closeGallery() {}
	  }, {
	    key: "close",
	    value: function close() {
	      var _this = this;
	      if (_this.$location.$$path.indexOf("review") > -1 || _this.$location.$$path.indexOf("overview") > -1) {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("CloseGalleryReview", {});
	        });
	      } else {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("CloseGallery", {});
	        });
	      }
	    }
	  }, {
	    key: "key",
	    value: function key($event) {
	      var _this = this;
	
	      console.log($event.keyCode);
	
	      if ($event.keyCode == 39) {
	        _this.next(_this.mainPhotoUrl);
	      }
	      if ($event.keyCode == 37) {
	        _this.previous(_this.mainPhotoUrl);
	      }
	    }
	  }]);
	
	  return MessaginggalleryController;
	}();
	
	MessaginggalleryController.$inject = ["$http", "$state", "$stateParams", "auth", "events", "security", "$rootScope", "$scope", "$localStorage", "ngProgressFactory", "$timeout", "$location"];
	
	exports.default = MessaginggalleryController;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(185);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./messaginggallery.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./messaginggallery.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _jobsearch = __webpack_require__(187);
	
	var _jobsearch2 = _interopRequireDefault(_jobsearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobsearchModule = _angular2.default.module("jobsearch", [_angularUiRouter2.default]).component("jobsearch", _jobsearch2.default);
	
	exports.default = jobsearchModule;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobsearch = __webpack_require__(188);
	
	var _jobsearch2 = _interopRequireDefault(_jobsearch);
	
	var _jobsearch3 = __webpack_require__(189);
	
	var _jobsearch4 = _interopRequireDefault(_jobsearch3);
	
	__webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobsearchComponent = {
	  restrict: "E",
	  bindings: {
	    setJobbleTypes: "<"
	  },
	  template: _jobsearch2.default,
	  controller: _jobsearch4.default,
	  controllerAs: "vm"
	};
	
	exports.default = jobsearchComponent;

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"job-search\">\n  <div class=\"categories-container\">\n    <div class=\"category\" ng-click=\"vm.setState(1)\">\n      CATEGORY\n      <div class=\"select-indicator\" ng-if=\"vm.state === 1\"></div>\n    </div>\n    <div class=\"category\" ng-click=\"vm.setState(2)\">\n      COMPANY\n      <div class=\"select-indicator\" ng-if=\"vm.state === 2\"></div>\n    </div>\n    <div class=\"category\" ng-click=\"vm.setState(3)\">\n      LOCATION\n      <div class=\"select-indicator\" ng-if=\"vm.state === 3\"></div>\n    </div>\n    <div class=\"jobble-tip-super-container\">\n      <a\n        href=\"https://info.jobble.com/workplace-safety-guidelines-infographic\"\n        target=\"_blank\"\n        ng-click=\"vm.$tracking.reportClickCovidBanner('job board')\"\n      >\n        <div class=\"jobble-tip-container\"><i class=\"fas fa-exclamation-triangle\"></i> COVID-19 Workplace Health & Safety Guidelines</div>\n      </a>\n    </div>\n  </div>\n\n  <div class=\"mobile-filter-toggle\" ng-click=\"vm.toggleMobileFilters()\" ng-style=\"vm.expandedMobileStyles.toggle\">\n    <div class=\"\">\n      <div class=\"filter-toggler\">\n        <i class=\"fas fa-sliders-h\"></i> Filters {{vm.selectedJobbleTypes.length ? \"(\" + vm.selectedJobbleTypes.length + \")\" : \"\"}}\n      </div>\n    </div>\n  </div>\n\n  <div class=\"mobile-overall\" ng-style=\"vm.expandedMobileStyles.overall\">\n    <div class=\"mobile-overall-header\">\n      <div class=\"back-chevron\" ng-click=\"vm.toggleMobileFilters()\">\n        <i class=\"fas fa-chevron-left\"></i>\n      </div>\n      <div class=\"header-title\">Filters</div>\n      <div class=\"header-clear\" ng-click=\"vm.clearFilters(); vm.clearCompanies(); vm.clearLocations()\">Clear</div>\n    </div>\n    <div class=\"mobile-holder\">\n      <div class=\"filter-toggle-container\" ng-style=\"vm.expandedFilterStylesMany[1].container\" ng-class=\"{'desktop-hidden': vm.state !== 1}\">\n        <div class=\"mobile-category\">CATEGORY</div>\n        <div class=\"filter-toggle clear-toggle\" ng-click=\"vm.clearFilters()\"><i class=\"fas fa-times\"></i> Clear ({{vm.selectedFilters.length}})</div>\n        <div id=\"category-filter-holder\" class=\"filter-toggles\" ng-style=\"vm.expandedFilterStylesMany[1].toggles\">\n          <div\n            class=\"filter-toggle\"\n            ng-repeat=\"filter in vm.dynamicFilters track by $index\"\n            ng-style=\"vm.expandedFilterStylesMany[1].toggle\"\n            ng-class=\"{'selected': vm.selectedFilters.indexOf(filter) !== -1 }\"\n            ng-click=\"vm.toggleTag(filter);\"\n          >\n            {{ filter }}\n          </div>\n        </div>\n        <div\n          class=\"filter-toggle more-toggle\"\n          ng-if=\"vm.showCategoryMore\"\n          ng-click=\"vm.toggleFilter(1)\"\n          ng-style=\"vm.expandedFilterStylesMany[1].more\"\n        >\n          {{vm.expandedFilters[1] ? \"Less\" : \"More\"}} Filters\n        </div>\n      </div>\n      <div class=\"mobile-border\"></div>\n      <div class=\"filter-toggle-container\" ng-style=\"vm.expandedFilterStylesMany[2].container\" ng-class=\"{'desktop-hidden': vm.state !== 2}\">\n        <div class=\"mobile-category\">COMPANY</div>\n        <div class=\"filter-toggle clear-toggle\" ng-click=\"vm.clearCompanies()\">\n          <i class=\"fas fa-times\"></i> Clear ({{vm.selectedCompanies.length}})\n        </div>\n        <div id=\"company-filter-holder\" class=\"filter-toggles\" ng-style=\"vm.expandedFilterStylesMany[2].toggles\">\n          <div\n            class=\"filter-toggle\"\n            ng-if=\"vm.companies && vm.companies.length\"\n            ng-repeat=\"company in vm.companies track by $index\"\n            ng-style=\"vm.expandedFilterStylesMany[2].toggle\"\n            ng-class=\"{'selected': vm.selectedCompanies.indexOf(company) !== -1 }\"\n            ng-click=\"vm.toggleCompany(company);\"\n          >\n            {{ company }}\n          </div>\n          <div class=\"no-filter-message\" ng-if=\"!vm.companies || !vm.companies.length\">No filters available</div>\n        </div>\n        <div\n          class=\"filter-toggle more-toggle\"\n          ng-if=\"vm.showCompanyMore\"\n          ng-click=\"vm.toggleFilter(2)\"\n          ng-style=\"vm.expandedFilterStylesMany[2].more\"\n        >\n          {{vm.expandedFilters[2] ? \"Less\" : \"More\"}} Filters\n        </div>\n      </div>\n      <div class=\"mobile-border\"></div>\n      <div class=\"filter-toggle-container\" ng-style=\"vm.expandedFilterStylesMany[3].container\" ng-class=\"{'desktop-hidden': vm.state !== 3}\">\n        <div class=\"mobile-category\">LOCATION</div>\n        <div class=\"filter-toggle clear-toggle\" ng-click=\"vm.clearLocations()\">\n          <i class=\"fas fa-times\"></i> Clear ({{vm.selectedLocations.length}})\n        </div>\n        <div class=\"filter-toggles\" ng-style=\"vm.expandedFilterStylesMany[3].toggles\">\n          <div class=\"location-container\">\n            <div class=\"radius-container\">\n              <div class=\"toggle-label\">Radius:</div>\n              <div class=\"sort-select-container\">\n                <select ng-model=\"vm.radius\" ng-change=\"vm.setRadius()\">\n                  <option value=\"10\">10 mi</option>\n                  <option value=\"25\">25 mi</option>\n                  <option value=\"50\">50 mi</option>\n                  <option value=\"75\">75 mi</option>\n                  <option value=\"100\">100 mi</option>\n                </select>\n                <i class=\"fas fa-chevron-down\"></i>\n              </div>\n            </div>\n            <div id=\"location-filter-holder\" class=\"location-toggle-container\">\n              <div class=\"toggle-label\">Locations:</div>\n              <div\n                class=\"filter-toggle\"\n                ng-repeat=\"location in vm.locations track by $index\"\n                ng-style=\"vm.expandedFilterStylesMany[3].toggle\"\n                ng-class=\"{'selected': vm.selectedLocations.indexOf(location) !== -1 }\"\n                ng-click=\"vm.toggleLocation(location);\"\n              >\n                {{ location }}\n              </div>\n              <div class=\"no-filter-message\" ng-if=\"!vm.locations || !vm.locations.length\">No filters available</div>\n            </div>\n          </div>\n        </div>\n        <div\n          class=\"filter-toggle more-toggle\"\n          ng-if=\"vm.showLocationMore\"\n          ng-click=\"vm.toggleFilter(3)\"\n          ng-style=\"vm.expandedFilterStylesMany[3].more\"\n        >\n          {{vm.expandedFilters[3] ? \"Less\" : \"More\"}} Filters\n        </div>\n      </div>\n    </div>\n    <div class=\"mobile-overall-footer\">\n      <div ng-click=\"vm.toggleMobileFilters()\">Apply Filters</div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobsearchController = function () {
	  function JobsearchController($http, $localStorage, $state, AuthService, SecurityService, TrackingService, $rootScope, $scope, $location, $timeout, $window, $companies, Messagingv2Service, EventsService) {
	    var _this = this;
	
	    _classCallCheck(this, JobsearchController);
	
	    this.name = "jobsearch";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$rootScope = $rootScope;
	    this.$security = SecurityService;
	    this.$window = $window;
	    this.$timeout = $timeout;
	    this.$events = EventsService;
	    this.currentUser = this.$auth.getUserData();
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$tracking = TrackingService;
	    this.$location = $location;
	    this.$messagingv2 = Messagingv2Service;
	    this.$companies = $companies;
	
	    this.expandedFilter = false;
	    this.expandedFilterStyles = {};
	    this.expandedFilters = {};
	    this.expandedFilterStylesMany = {
	      1: {},
	      2: {},
	      3: {}
	    };
	    this.expandedMobile = false;
	    this.expandedMobileStyles = {};
	    this.selectedFilters = [];
	    this.selectedJobbleTypes = [];
	    this.selectedCompanies = [];
	    this.companies = [];
	    this.selectedLocations = [];
	    this.locations = [];
	    this.radius = "25";
	    this.state = 1;
	
	    this.dynamicFilters = [];
	
	    this.showCategoryMore = false;
	    this.showCompanyMore = false;
	    this.showLocationMore = false;
	
	    this.SetJobSearchCompaniesListener = this.$rootScope.$on("SetJobSearchCompanies", function ($event, params) {
	      _this.$timeout(function () {
	        _this.companies = params;
	
	        _this.calculateMoreOrLessToggle();
	
	        if (_this.selectedCompanies.length) {
	          _this.selectedCompanies = _this.selectedCompanies.filter(function (value) {
	            return params.indexOf(value) !== -1;
	          });
	
	          _this.$rootScope.$emit("SetCompanyFilters", _this.selectedCompanies);
	        }
	      });
	    });
	
	    this.SetJobSearchLocationsListener = this.$rootScope.$on("SetJobSearchLocations", function ($event, params) {
	      _this.$timeout(function () {
	        _this.locations = params;
	
	        _this.calculateMoreOrLessToggle();
	
	        if (_this.selectedLocations.length) {
	          _this.selectedLocations = _this.selectedLocations.filter(function (value) {
	            return params.indexOf(value) !== -1;
	          });
	
	          _this.$rootScope.$emit("SetLocationFilters", _this.selectedLocations);
	        }
	      });
	    });
	
	    this.DynamicSuggestedFiltersListender = this.$rootScope.$on("DynamicSuggestedFilters", function ($event, params) {
	      _this.$timeout(function () {
	        console.log("New filters", params);
	
	        var sameList = _.isEqual(_.sortBy(_this.dynamicFilters), _.sortBy(params));
	
	        console.log("Same filters?:", sameList);
	
	        if (sameList) return console.log("Skipping filter update");
	
	        _this.dynamicFilters = params;
	        if (_this.dynamicFilters && _this.dynamicFilters.length) {
	          _this.dynamicFilters = _this.dynamicFilters.map(function (f) {
	            return f.toLowerCase();
	          });
	
	          _this.selectedFilters.forEach(function (filter) {
	            filter = filter.toLowerCase();
	            console.log(filter);
	
	            if (_this.dynamicFilters.indexOf(filter) === -1) {
	              console.log(_this.dynamicFilters);
	              _this.selectedFilters = _this.selectedFilters.filter(function (value, index, arr) {
	                return value.toLowerCase() !== filter;
	              });
	            }
	          });
	
	          console.log(_this.selectedFilters);
	
	          _this.$timeout(function () {
	            _this.calculateMoreOrLessToggle();
	          });
	        }
	      });
	    });
	
	    this.$scope.$on("$destroy", this.SetJobSearchCompaniesListener);
	    this.$scope.$on("$destroy", this.SetJobSearchLocationsListener);
	    this.$scope.$on("$destroy", this.DynamicSuggestedFiltersListender);
	  }
	
	  _createClass(JobsearchController, [{
	    key: "setState",
	    value: function setState(state) {
	      var _this2 = this;
	
	      this.$timeout(function () {
	        _this2.state = state;
	        _this2.$timeout(function () {
	          _this2.calculateMoreOrLessToggle();
	        });
	      });
	    }
	  }, {
	    key: "toggleFilter",
	    value: function toggleFilter(num) {
	      this.expandedFilters = this.expandedFilters || {};
	      this.expandedFilterStylesMany = this.expandedFilterStylesMany || {};
	
	      this.expandedFilters[num] = !this.expandedFilters[num];
	
	      if (this.expandedFilters[num]) {
	        this.expandedFilterStylesMany[num] = {
	          container: {
	            height: "auto",
	            paddingBottom: "25px"
	          },
	          toggles: {
	            height: "auto"
	          },
	          toggle: {
	            marginBottom: "9px"
	          },
	          more: {
	            top: "auto",
	            bottom: "34px"
	          }
	        };
	      } else {
	        this.expandedFilterStylesMany[num] = {};
	      }
	    }
	  }, {
	    key: "toggleLocation",
	    value: function toggleLocation(location) {
	      if (this.selectedLocations.indexOf(location) !== -1) {
	        this.selectedLocations = this.selectedLocations.filter(function (value, index, arr) {
	          return value !== location;
	        });
	      } else {
	        this.selectedLocations.push(location);
	        this.$tracking.reportClickLocationFilter("job board", location);
	      }
	
	      this.$rootScope.$emit("SetLocationFilters", this.selectedLocations);
	    }
	  }, {
	    key: "toggleCompany",
	    value: function toggleCompany(company) {
	      if (this.selectedCompanies.indexOf(company) !== -1) {
	        this.selectedCompanies = this.selectedCompanies.filter(function (value, index, arr) {
	          return value !== company;
	        });
	      } else {
	        this.selectedCompanies.push(company);
	        this.$tracking.reportClickCompanyFilter("job board", company);
	      }
	
	      this.$rootScope.$emit("SetCompanyFilters", this.selectedCompanies);
	    }
	  }, {
	    key: "toggleTag",
	    value: function toggleTag(tag) {
	      if (this.selectedFilters.indexOf(tag) !== -1) {
	        this.selectedFilters = this.selectedFilters.filter(function (value, index, arr) {
	          return value !== tag;
	        });
	      } else {
	        this.selectedFilters.push(tag);
	
	        this.$tracking.reportJobsBoardNavBarFilterClick({
	          secondary_name: tag
	        });
	        this.$tracking.reportClickCategoryFilter("job board", tag);
	      }
	
	      this.setJobbleTypes(this.selectedFilters, 1, 1);
	    }
	  }, {
	    key: "clearFilters",
	    value: function clearFilters() {
	      if (this.selectedFilters.length === 0) return;
	      this.selectedFilters = [];
	      this.selectedJobbleTypes = [];
	      this.setJobbleTypes(this.selectedFilters, 1, 1);
	    }
	  }, {
	    key: "clearCompanies",
	    value: function clearCompanies() {
	      if (this.selectedCompanies.length === 0) return;
	
	      this.selectedCompanies = [];
	      this.$rootScope.$emit("SetCompanyFilters", this.selectedCompanies);
	    }
	  }, {
	    key: "clearLocations",
	    value: function clearLocations() {
	      if (this.selectedLocations.length === 0) return;
	
	      this.selectedLocations = [];
	      this.$rootScope.$emit("SetLocationFilters", this.selectedLocations);
	    }
	  }, {
	    key: "setRadius",
	    value: function setRadius() {
	      console.warn(this.radius);
	      this.$rootScope.$emit("SetSearchRadius", this.radius);
	    }
	  }, {
	    key: "toggleMobileFilters",
	    value: function toggleMobileFilters() {
	      this.expandedMobile = !this.expandedMobile;
	
	      if (this.expandedMobile) {
	        this.calculateMoreOrLessToggle();
	        this.expandedMobileStyles = {
	          toggle: {
	            display: "none"
	          },
	          overall: {
	            display: "block"
	          }
	        };
	
	        document.body.style.position = "fixed";
	        document.body.style.top = "-" + window.scrollY + "px";
	        document.body.style.webkitOverflowScrolling = "auto";
	      } else {
	        this.expandedMobileStyles = {};
	        this.expandedFilterStyles = {};
	        this.expandedFilter = false;
	        document.body.style.position = "";
	        document.body.style.top = "";
	        document.body.style.webkitOverflowScrolling = "";
	      }
	    }
	  }, {
	    key: "calculateMoreOrLessToggle",
	    value: function calculateMoreOrLessToggle() {
	      var _this3 = this;
	
	      var categoryFilterContainer = document.getElementById("category-filter-holder");
	      var companyFilterContainer = document.getElementById("company-filter-holder");
	      var locationFilterContainer = document.getElementById("location-filter-holder");
	
	      this.$timeout(function () {
	        if (categoryFilterContainer && categoryFilterContainer.scrollHeight) {
	          _this3.showCategoryMore = categoryFilterContainer.scrollHeight > 700 ? categoryFilterContainer.scrollHeight > 50 : categoryFilterContainer.scrollHeight > 100;
	        }
	
	        if (companyFilterContainer && companyFilterContainer.scrollHeight) {
	          _this3.showCompanyMore = companyFilterContainer.scrollHeight > 700 ? companyFilterContainer.scrollHeight > 50 : companyFilterContainer.scrollHeight > 100;
	        }
	
	        if (locationFilterContainer && locationFilterContainer.scrollHeight) {
	          _this3.showLocationMore = locationFilterContainer.scrollHeight > 700 ? locationFilterContainer.scrollHeight > 50 : locationFilterContainer.scrollHeight > 100;
	        }
	      });
	    }
	  }]);
	
	  return JobsearchController;
	}();
	
	JobsearchController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "tracking", "$rootScope", "$scope", "$location", "$timeout", "$window", "companies", "messagingv2", "events"];
	
	exports.default = JobsearchController;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(191);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".job-search{background:#fff}.job-search .mobile-filter-toggle,.job-search .mobile-overall-footer,.job-search .mobile-overall-header{display:none}.job-search .jobble-tip-super-container{border-radius:6px;background:linear-gradient(116.57deg,#ff8609,#d8000c);padding:2px;height:29px;position:absolute;right:24px;cursor:pointer;margin-top:6px}.job-search .jobble-tip-container{background:#fff;border-radius:4px;padding:0 6px;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;width:fit-content;height:25px;line-height:25px;color:#5e666d;letter-spacing:0}.job-search .jobble-tip-container i{margin-right:5px}@media only screen and (max-width:768px){.job-search .jobble-tip-super-container{display:none}.job-search .mobile-overall{position:fixed;height:100%;width:100%;z-index:9999999;background:#f7f7f7;top:0;display:none;overflow:hidden;padding-bottom:40px}.job-search .mobile-holder{overflow:scroll;height:100%;padding-bottom:200px}.job-search .mobile-overall-header{height:52px;line-height:52px;padding:0 16px;text-align:center;display:flex;background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.1);font-family:Poppins,sans-serif}.job-search .mobile-overall-header .back-chevron{flex:1;text-align:left}.job-search .mobile-overall-header .header-title{flex:1;text-align:center;color:#5e666d;font-size:14px;font-weight:500;letter-spacing:.3px;text-transform:uppercase}.job-search .mobile-overall-header .header-clear{flex:1;text-align:right;color:#62c046;font-size:12px;font-weight:700}.job-search .mobile-overall-footer{display:block;position:fixed;bottom:0;width:100%;height:40px;background:#62c046;color:#fff;font-family:Poppins,sans-serif;font-size:16px;letter-spacing:.3px;font-weight:500;text-align:center;line-height:40px}.job-search .mobile-filter-toggle{display:block;height:42px;border-bottom:1px solid #adbcc2;background:#f7f7f7;padding:8px 16px;overflow:hidden}}.job-search .categories-container{display:flex;padding:0 25px;border-bottom:1px solid #adbcc2;border-top:1px solid #adbcc2;position:relative}@media only screen and (max-width:768px){.job-search .categories-container{display:none}}.job-search .categories-container .category{color:#5e666d;height:40px;line-height:47px;position:relative;font-size:12px;font-family:Poppins,sans-serif;font-weight:600;letter-spacing:.3px;padding:0 8px;text-align:center;cursor:pointer;margin-right:16px}.job-search .mobile-category{display:none}@media only screen and (max-width:768px){.job-search .mobile-category{color:#5e666d;height:40px;font-size:14px;font-family:Poppins,sans-serif;font-weight:500;line-height:21px;text-decoration:underline;display:block}}.job-search .categories-container .category .select-indicator{height:4px;position:absolute;bottom:0;left:0;background:#62c046;border-radius:2px 2px 0 0;width:100%}.job-search .filter-toggle-container{position:relative;padding:15px 135px 19px 113px;border-bottom:1px solid #adbcc2;box-shadow:0 2px 5px 0 rgba(0,0,0,.2);height:54px;overflow:hidden}.job-search .desktop-hidden{display:none}@media only screen and (max-width:768px){.job-search .desktop-hidden{display:block}.job-search .filter-toggle-container{padding:24px 16px;height:200px;box-shadow:none;border-bottom:none}.filter-toggles{height:94px;overflow:hidden}.mobile-border{height:1px;width:auto;background:#adbcc2;margin:0 16px}}.job-search .filter-toggler{color:#5e666d;border:1px solid #5e666d;border-radius:13.5px;font-size:11px;font-family:Poppins,sans-serif;font-weight:500;cursor:pointer;width:max-content;padding:0 8px;text-align:center;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.job-search .filter-toggle-container .filter-toggle{border:1px solid #5e666d;border-radius:13.5px}.job-search .filter-toggle-container .filter-toggle,.job-search .filter-toggle-container .no-filter-message{text-transform:capitalize;display:inline-block;color:#5e666d;height:25px;padding:0 10px;line-height:24px;font-size:11px;font-family:Poppins,sans-serif;font-weight:500;margin-right:8px;cursor:pointer;margin-bottom:20px;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.job-search .filter-toggle-container .no-filter-message{border-radius:13.5px}@media only screen and (max-width:768px){.job-search .filter-toggle-container .filter-toggle{margin-bottom:9px}}.job-search .filter-toggle-container .filter-toggle.selected{background:#5e666d;color:#fff}.job-search .filter-toggle-container .filter-toggle:hover{background:#adbcc2}.job-search .filter-toggle-container .more-toggle{position:absolute;margin:0;top:16px;right:25px;border-color:#62c046;background:#62c046;color:#fff;font-weight:700}.job-search .filter-toggle-container .clear-toggle:hover,.job-search .filter-toggle-container .filter-toggle.selected:hover{background:#5e666d}.job-search .filter-toggle-container .more-toggle:hover{background:#62c046}@media only screen and (max-width:768px){.job-search .filter-toggle-container .more-toggle,.job-search .filter-toggle-container .more-toggle:hover{top:auto;bottom:0!important;background:none;border:none;color:#62c046;right:16px;padding:0;font-family:Poppins,sans-serif;font-size:12px;font-weight:700;line-height:11px}}.job-search .filter-toggle-container .clear-toggle{position:absolute;top:16px;margin:0;left:25px;background:#5e666d;color:#fff;width:80px;padding-right:0}@media only screen and (max-width:768px){.job-search .filter-toggle-container .clear-toggle{display:none}}.job-search .location-container{display:flex;flex-direction:row}.job-search .sort-select-container{display:inline-block;position:relative}.job-search .sort-select-container i{color:#6a7178;position:absolute;right:8px;top:9px;font-size:12px;pointer-events:none}.job-search .radius-container{flex:0 0 142px;margin-left:32px}.job-search .radius-container select{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0 8px;cursor:pointer;box-sizing:border-box;height:24px;width:64px;border:1px solid #5e666d;border-radius:13.5px;color:#5e666d;font-family:Poppins,sans-serif;font-size:11px;font-weight:500;line-height:24px}.job-search .location-toggle-container{flex:1}.job-search .toggle-label{display:inline-block;font-family:Poppins,sans-serif;font-size:11px;font-weight:500;line-height:17px;margin-right:8px}@media only screen and (max-width:768px){.job-search .location-container{flex-direction:column}.job-search .radius-container{flex:1;margin-bottom:11px;margin-left:0}}", ""]);
	
	// exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _postingdropdown = __webpack_require__(193);
	
	var _postingdropdown2 = _interopRequireDefault(_postingdropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postingdropdownModule = _angular2.default.module("postingdropdown", [_angularUiRouter2.default]).component("postingdropdown", _postingdropdown2.default);
	
	exports.default = postingdropdownModule;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _postingdropdown = __webpack_require__(194);
	
	var _postingdropdown2 = _interopRequireDefault(_postingdropdown);
	
	var _postingdropdown3 = __webpack_require__(195);
	
	var _postingdropdown4 = _interopRequireDefault(_postingdropdown3);
	
	__webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postingdropdownComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _postingdropdown2.default,
	  controller: _postingdropdown4.default,
	  controllerAs: "vm"
	};
	
	exports.default = postingdropdownComponent;

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"hidden-drop-down-post-types\" id=\"small-list-links-pt\">\n  <ul>\n    <li class=\"nowrap\" ng-click=\"vm.go_to_post_event()\" ng-show=\"vm.pt==0 || vm.pt==1 || vm.pt==2 || vm.pt ==6\">\n      <a href=\"#\"> On-Demand </a>\n    </li>\n    <li class=\"nowrap\" ng-click=\"vm.go_to_post_order()\" ng-show=\"vm.pt==0 || vm.pt==4 || vm.pt==5 || vm.pt==6\">\n      <a href=\"#\"> Delivery </a>\n    </li>\n    <!--\n        <li class=\"nowrap\" ng-click=\"vm.go_to_sourcing()\" ng-show=\"vm.pt==0 || vm.pt==1 || vm.pt==3 || vm.pt==5\">\n            <a href=\"#\">\n                Pay-Per-Post\n            </a>\n        </li>\n        -->\n  </ul>\n  <!-- href=\"/event/{{event.id}}/overview\" -->\n</div>\n"

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PostingdropdownController = function () {
	  function PostingdropdownController($rootScope, $scope, $state, $localStorage, $location, $timeout, AuthService) {
	    _classCallCheck(this, PostingdropdownController);
	
	    this.name = "postingdropdown";
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$location = $location;
	    this.$auth = AuthService;
	    this.$localStorage = $localStorage;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.currentUser = this.$auth.getUserData();
	    this.pt = this.currentUser.company.postingTypesAllowed;
	
	    var _this = this;
	
	    _this.SetNewPostTypesToHeaderLsitener = _this.$rootScope.$on("SetNewPostTypesToHeader", function (event, params) {
	      _this.show_hide_posting_types(params);
	    });
	
	    _this.$scope.$on("$destroy", _this.SetNewPostTypesToHeaderLsitener);
	    _this.setting_posting_types();
	  }
	
	  _createClass(PostingdropdownController, [{
	    key: "setting_posting_types",
	    value: function setting_posting_types() {
	      var _this = this;
	      if (!_this.currentUser.company.postingTypesAllowed) {
	        _this.pt = 0;
	      } else {
	        _this.pt = _this.currentUser.company.postingTypesAllowed;
	      }
	    }
	  }, {
	    key: "go_to_post_event",
	    value: function go_to_post_event() {
	      var _this = this;
	      var page = _this.check_page(2);
	      console.log("go_to_post_event");
	      console.log(page);
	
	      if (page.result === false) {
	        _this.$timeout(function () {
	          _this.$state.go("postevent", { pt: "ondemand" });
	        });
	      } else {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetPostingTypeChange", page);
	        });
	      }
	    }
	  }, {
	    key: "go_to_post_order",
	    value: function go_to_post_order() {
	      var _this = this;
	      var page = _this.check_page(1);
	      if (page.result === false) {
	        _this.$state.go("postorder");
	      }
	    }
	  }, {
	    key: "go_to_sourcing",
	    value: function go_to_sourcing() {
	      var _this = this;
	      var page = _this.check_page(3);
	      if (page.result === false) {
	        _this.$state.go("postevent", { pt: "sourcing" });
	      } else {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetPostingTypeChange", page);
	        });
	      }
	    }
	  }, {
	    key: "check_page",
	    value: function check_page(x) {
	      var _this = this;
	      var url = _this.$location.$$url;
	      var output = {};
	      output.result = null;
	      if (url === "/post-event" && x === 3) {
	        output.result = true;
	        output.posting_type_set = "sourcing";
	      } else if (url === "/post-event" && x === 2) {
	        output.result = true;
	        output.posting_type_set = "ondemand";
	      } else if (url === "/post-event" && x === 1) {
	        output.result = false;
	        output.posting_type_set = "postorder";
	      } else {
	        output.result = false;
	        output.type = x;
	      }
	      return output;
	    }
	  }, {
	    key: "show_hide_posting_types",
	    value: function show_hide_posting_types(params) {
	      var _this = this;
	      _this.pt = params;
	    }
	  }]);
	
	  return PostingdropdownController;
	}();
	
	PostingdropdownController.$inject = ["$rootScope", "$scope", "$state", "$localStorage", "$location", "$timeout", "auth"];
	
	exports.default = PostingdropdownController;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(197);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./postingdropdown.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./postingdropdown.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pbpostingdropdown = __webpack_require__(199);
	
	var _pbpostingdropdown2 = _interopRequireDefault(_pbpostingdropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postingdropdownModule = _angular2.default.module("pbpostingdropdown", [_angularUiRouter2.default]).component("pbpostingdropdown", _pbpostingdropdown2.default);
	
	exports.default = postingdropdownModule;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pbpostingdropdown = __webpack_require__(200);
	
	var _pbpostingdropdown2 = _interopRequireDefault(_pbpostingdropdown);
	
	var _pbpostingdropdown3 = __webpack_require__(201);
	
	var _pbpostingdropdown4 = _interopRequireDefault(_pbpostingdropdown3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pbpostingdropdownComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _pbpostingdropdown2.default,
	  controller: _pbpostingdropdown4.default,
	  controllerAs: "vm"
	};
	
	exports.default = pbpostingdropdownComponent;

/***/ }),
/* 200 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"hidden-drop-down-post-types\" id=\"small-list-links-pt\">\n  <ul>\n    <li class=\"nowrap\" ng-click=\"vm.go_to_post_event()\" ng-show=\"vm.pt==0 || vm.pt==1 || vm.pt==2 || vm.pt ==6\">\n      <a href=\"#\"> On-Demand </a>\n    </li>\n    <li class=\"nowrap\" ng-click=\"vm.go_to_post_order()\" ng-show=\"vm.pt==0 || vm.pt==4 || vm.pt==5 || vm.pt==6\">\n      <a href=\"#\"> Delivery </a>\n    </li>\n    <!--\n        <li class=\"nowrap\" ng-click=\"vm.go_to_sourcing()\" ng-show=\"vm.pt==0 || vm.pt==1 || vm.pt==3 || vm.pt==5\">\n            <a href=\"#\">\n                Pay-Per-Post\n            </a>\n        </li>\n        -->\n  </ul>\n  <!-- href=\"/event/{{event.id}}/overview\" -->\n</div>\n"

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PbpostingdropdownController = function () {
	  function PbpostingdropdownController($rootScope, $scope, $state, $localStorage, $location, $timeout, AuthService) {
	    _classCallCheck(this, PbpostingdropdownController);
	
	    this.name = "pbpostingdropdown";
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$location = $location;
	    this.$auth = AuthService;
	    this.$localStorage = $localStorage;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.currentUser = this.$auth.getUserData();
	    this.pt = this.currentUser.company.postingTypesAllowed;
	
	    var _this = this;
	
	    _this.SetNewPostTypesToHeaderLsitener = _this.$rootScope.$on("SetNewPostTypesToHeader", function (event, params) {
	      _this.show_hide_posting_types(params);
	    });
	    _this.$scope.$on("$destroy", _this.SetNewPostTypesToHeaderLsitener);
	    _this.setting_posting_types();
	  }
	
	  _createClass(PbpostingdropdownController, [{
	    key: "setting_posting_types",
	    value: function setting_posting_types() {
	      var _this = this;
	      if (!_this.currentUser.company.postingTypesAllowed) {
	        _this.pt = 0;
	      } else {
	        _this.pt = _this.currentUser.company.postingTypesAllowed;
	      }
	    }
	  }, {
	    key: "go_to_post_event",
	    value: function go_to_post_event() {
	      var _this = this;
	      var page = _this.check_page(2);
	      console.log("go_to_post_event");
	      console.log(page);
	
	      if (page.result === false) {
	        _this.$timeout(function () {
	          _this.$state.go("postevent", { pt: "ondemand" });
	        });
	      } else {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetPostingTypeChange", page);
	        });
	      }
	    }
	  }, {
	    key: "go_to_post_order",
	    value: function go_to_post_order() {
	      var _this = this;
	      var page = _this.check_page(1);
	      if (page.result === false) {
	        _this.$state.go("postorder");
	      }
	    }
	  }, {
	    key: "go_to_sourcing",
	    value: function go_to_sourcing() {
	      var _this = this;
	      var page = _this.check_page(3);
	      if (page.result === false) {
	        _this.$state.go("postevent", { pt: "sourcing" });
	      } else {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetPostingTypeChange", page);
	        });
	      }
	    }
	  }, {
	    key: "check_page",
	    value: function check_page(x) {
	      var _this = this;
	      var url = _this.$location.$$url;
	      var output = {};
	      output.result = null;
	      if (url === "/post-event" && x === 3) {
	        output.result = true;
	        output.posting_type_set = "sourcing";
	      } else if (url === "/post-event" && x === 2) {
	        output.result = true;
	        output.posting_type_set = "ondemand";
	      } else if (url === "/post-event" && x === 1) {
	        output.result = false;
	        output.posting_type_set = "postorder";
	      } else {
	        output.result = false;
	        output.type = x;
	      }
	      return output;
	    }
	  }, {
	    key: "show_hide_posting_types",
	    value: function show_hide_posting_types(params) {
	      var _this = this;
	      _this.pt = params;
	    }
	  }]);
	
	  return PbpostingdropdownController;
	}();
	
	PbpostingdropdownController.$inject = ["$rootScope", "$scope", "$state", "$localStorage", "$location", "$timeout", "auth"];
	
	exports.default = PbpostingdropdownController;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pjpostingdropdown = __webpack_require__(203);
	
	var _pjpostingdropdown2 = _interopRequireDefault(_pjpostingdropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postingdropdownModule = _angular2.default.module("pjpostingdropdown", [_angularUiRouter2.default]).component("pjpostingdropdown", _pjpostingdropdown2.default);
	
	exports.default = postingdropdownModule;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pjpostingdropdown = __webpack_require__(204);
	
	var _pjpostingdropdown2 = _interopRequireDefault(_pjpostingdropdown);
	
	var _pjpostingdropdown3 = __webpack_require__(205);
	
	var _pjpostingdropdown4 = _interopRequireDefault(_pjpostingdropdown3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pjpostingdropdownComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _pjpostingdropdown2.default,
	  controller: _pjpostingdropdown4.default,
	  controllerAs: "vm"
	};
	
	exports.default = pjpostingdropdownComponent;

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"hidden-drop-down-post-types\" id=\"small-list-links-pt\">\n  <ul>\n    <li class=\"nowrap\" ng-click=\"vm.go_to_post_event()\" ng-show=\"vm.pt==0 || vm.pt==1 || vm.pt==2 || vm.pt ==6\">\n      <a href=\"#\"> On-Demand </a>\n    </li>\n    <li class=\"nowrap\" ng-click=\"vm.go_to_post_order()\" ng-show=\"vm.pt==0 || vm.pt==4 || vm.pt==5 || vm.pt==6\">\n      <a href=\"#\"> Delivery </a>\n    </li>\n    <!--\n        <li class=\"nowrap\" ng-click=\"vm.go_to_sourcing()\" ng-show=\"vm.pt==0 || vm.pt==1 || vm.pt==3 || vm.pt==5\">\n            <a href=\"#\">\n                Pay-Per-Post\n            </a>\n        </li>\n        -->\n  </ul>\n  <!-- href=\"/event/{{event.id}}/overview\" -->\n</div>\n"

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PjpostingdropdownController = function () {
	  function PjpostingdropdownController($rootScope, $scope, $state, $localStorage, $location, $timeout, AuthService) {
	    _classCallCheck(this, PjpostingdropdownController);
	
	    this.name = "pjpostingdropdown";
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$location = $location;
	    this.$auth = AuthService;
	    this.$localStorage = $localStorage;
	    this.$scope = $scope;
	    this.$timeout = $timeout;
	    this.currentUser = this.$auth.getUserData();
	    this.pt = this.currentUser.company.postingTypesAllowed;
	
	    var _this = this;
	
	    _this.SetNewPostTypesToHeaderLsitener = _this.$rootScope.$on("SetNewPostTypesToHeader", function (event, params) {
	      _this.show_hide_posting_types(params);
	    });
	    _this.$scope.$on("$destroy", _this.SetNewPostTypesToHeaderLsitener);
	    _this.setting_posting_types();
	  }
	
	  _createClass(PjpostingdropdownController, [{
	    key: "setting_posting_types",
	    value: function setting_posting_types() {
	      var _this = this;
	      if (!_this.currentUser.company.postingTypesAllowed) {
	        _this.pt = 0;
	      } else {
	        _this.pt = _this.currentUser.company.postingTypesAllowed;
	      }
	    }
	  }, {
	    key: "go_to_post_event",
	    value: function go_to_post_event() {
	      var _this = this;
	      var page = _this.check_page(2);
	      console.log("go_to_post_event");
	      console.log(page);
	
	      if (page.result === false) {
	        _this.$timeout(function () {
	          _this.$state.go("postevent", { pt: "ondemand" });
	        });
	      } else {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetPostingTypeChange", page);
	        });
	      }
	    }
	  }, {
	    key: "go_to_post_order",
	    value: function go_to_post_order() {
	      var _this = this;
	      var page = _this.check_page(1);
	      if (page.result === false) {
	        _this.$state.go("postorder");
	      }
	    }
	  }, {
	    key: "go_to_sourcing",
	    value: function go_to_sourcing() {
	      var _this = this;
	      var page = _this.check_page(3);
	      if (page.result === false) {
	        _this.$state.go("postevent", { pt: "sourcing" });
	      } else {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetPostingTypeChange", page);
	        });
	      }
	    }
	  }, {
	    key: "check_page",
	    value: function check_page(x) {
	      var _this = this;
	      var url = _this.$location.$$url;
	      var output = {};
	      output.result = null;
	      if (url === "/post-event" && x === 3) {
	        output.result = true;
	        output.posting_type_set = "sourcing";
	      } else if (url === "/post-event" && x === 2) {
	        output.result = true;
	        output.posting_type_set = "ondemand";
	      } else if (url === "/post-event" && x === 1) {
	        output.result = false;
	        output.posting_type_set = "postorder";
	      } else {
	        output.result = false;
	        output.type = x;
	      }
	      return output;
	    }
	  }, {
	    key: "show_hide_posting_types",
	    value: function show_hide_posting_types(params) {
	      var _this = this;
	      _this.pt = params;
	    }
	  }]);
	
	  return PjpostingdropdownController;
	}();
	
	PjpostingdropdownController.$inject = ["$rootScope", "$scope", "$state", "$localStorage", "$location", "$timeout", "auth"];
	
	exports.default = PjpostingdropdownController;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _leftnavigation = __webpack_require__(207);
	
	var _leftnavigation2 = _interopRequireDefault(_leftnavigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var leftnavigationModule = _angular2.default.module("leftnavigation", [_angularUiRouter2.default]).component("leftnavigation", _leftnavigation2.default);
	
	exports.default = leftnavigationModule;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _leftnavigation = __webpack_require__(208);
	
	var _leftnavigation2 = _interopRequireDefault(_leftnavigation);
	
	var _leftnavigation3 = __webpack_require__(209);
	
	var _leftnavigation4 = _interopRequireDefault(_leftnavigation3);
	
	__webpack_require__(210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var leftnavigationComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _leftnavigation2.default,
	  controller: _leftnavigation4.default,
	  controllerAs: "vm"
	};
	
	exports.default = leftnavigationComponent;

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"jobble-side-bar-nav\">\n  <ul>\n    <li class=\"active\" ng-click=\"vm.switchTabs(1)\"><i class=\"fa fa-list-ul\" aria-hidden=\"true\"></i> Jobs</li>\n    <li ng-click=\"vm.switchTabs(2)\"><i class=\"fa fa-folder-o\" aria-hidden=\"true\"></i> Post job</li>\n    <li ng-click=\"vm.switchTabs(3)\"><i class=\"fas fa-file-invoice-dollar\"></i> Receipts</li>\n    <li ng-click=\"vm.switchTabs(4)\">\n      <i class=\"fa fa-comments-o\" aria-hidden=\"true\"></i> Messages\n      <span class=\"number-box left-nav\" ng-if=\"$root.channelsHaveLoaded && $root.channels.totalMessagesMissed > 0\">55</span>\n    </li>\n    <li ng-click=\"vm.switchTabs(5)\"><i class=\"fa fa-users\" aria-hidden=\"true\"></i> Teams</li>\n  </ul>\n</div>\n\n<!--\n<div id=\"jobble-side-bar-nav\">\n    <ul>\n        <li class=\"active\" ng-click=\"vm.switchTabs(1)\">\n            <i class=\"fa fa-list-ul\" aria-hidden=\"true\"></i> Jobs\n        </li>\n\n        <li ng-click=\"vm.switchTabs(2)\">\n            <i class=\"fa fa-folder-o\" aria-hidden=\"true\"></i> Post job\n        </li>\n\n        <li ng-click=\"vm.switchTabs(3)\">\n            <i class=\"fas fa-file-invoice-dollar\" ></i> Receipts\n        </li>\n        <li ng-click=\"vm.switchTabs(4)\">\n            <i class=\"fa fa-comments-o\" aria-hidden=\"true\"></i> Messages <span class=\"number-box left-nav\" ng-if=\"$root.channelsHaveLoaded && $root.channels.totalMessagesMissed > 0\" >55</span>\n        </li>\n        <li ng-click=\"vm.switchTabs(5)\">\n            <i class=\"fa fa-users\" aria-hidden=\"true\"></i> Teams\n        </li>\n    </ul>\n</div>\n-->\n"

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LeftnavigationController = function () {
	  function LeftnavigationController($http, $state, $stateParams, AuthService, EventsService, SecurityService, $rootScope, $scope, $timeout, $location) {
	    _classCallCheck(this, LeftnavigationController);
	
	    this.name = "leftnavigation";
	    this.$auth = AuthService;
	    this.$http = $http;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$location = $location;
	    this.$timeout = $timeout;
	    this.$stateParams = $stateParams;
	    this.$events = EventsService;
	    this.$security = SecurityService;
	    this.currentUser = this.$auth.getUserData();
	    this.$rootScope = $rootScope;
	
	    //this.heightOfModal  = this.$window.innerHeight - 73;
	
	    var _this = this;
	
	    //this.decideActiveTab();
	  }
	
	  _createClass(LeftnavigationController, [{
	    key: "switchTabs",
	    value: function switchTabs(index) {
	      this.$timeout(function () {
	        $("#jobble-side-bar-nav ul li.active").removeClass("active");
	        $("#jobble-side-bar-nav ul li:nth-child(" + index + ")").addClass("active");
	      });
	
	      this.initLoader(index);
	    }
	  }, {
	    key: "decideActiveTab",
	    value: function decideActiveTab() {
	      if (this.$location.$$url === "/jobs-dashboard") {
	        this.switchTabs(1);
	      } else if (this.$location.$$url === "/receipts") {
	        this.switchTabs(3);
	      } else if (this.$location.$$url === "/teams") {
	        this.switchTabs(5);
	      } else if (this.$location.$$url === "/inbox") {
	        this.switchTabs(4);
	      }
	    }
	  }, {
	    key: "initLoader",
	    value: function initLoader(index) {
	      var _this2 = this;
	
	      if (index === 1) {
	        if (this.$location.$$url === "/jobs-dashboard") {
	          return;
	        }
	      }
	
	      this.$timeout(function () {
	        _this2.$rootScope.$emit("InitJobsDashboardLoader", {});
	      });
	
	      this.setLoader();
	      this.sendUser(index);
	    }
	  }, {
	    key: "sendUser",
	    value: function sendUser(index) {
	      if (index === 5) {
	        this.$state.go("teams");
	      } else if (index === 3) {
	        this.$state.go("transactionhistory");
	      } else if (index === 1) {
	        this.$state.go("jobsdashboard");
	      } else if (index === 4) {
	        this.$state.go("inbox");
	      } else if (index === 2) {
	        this.$state.go("postashiftwalkthrough");
	      }
	
	      this.unSetLoader();
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }]);
	
	  return LeftnavigationController;
	}();
	
	LeftnavigationController.$inject = ["$http", "$state", "$stateParams", "auth", "events", "security", "$rootScope", "$scope", "$timeout", "$location"];
	
	exports.default = LeftnavigationController;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(211);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./leftnavigation.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./leftnavigation.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _etamap = __webpack_require__(213);
	
	var _etamap2 = _interopRequireDefault(_etamap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var etamapModule = _angular2.default.module("etamap", [_angularUiRouter2.default]).component("etamap", _etamap2.default);
	
	exports.default = etamapModule;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _etamap = __webpack_require__(214);
	
	var _etamap2 = _interopRequireDefault(_etamap);
	
	var _etamap3 = __webpack_require__(215);
	
	var _etamap4 = _interopRequireDefault(_etamap3);
	
	__webpack_require__(216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var etamapComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _etamap2.default,
	  controller: _etamap4.default,
	  controllerAs: "vm"
	};
	
	exports.default = etamapComponent;

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	module.exports = ""

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _iterable = __webpack_require__(159);
	
	var _iterable2 = _interopRequireDefault(_iterable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EtamapController = function () {
	  function EtamapController($http, $localStorage, $state, AuthService, SecurityService, TrackingService, $rootScope, $scope, $location, $timeout, $window, $companies, Messagingv2Service, EventsService, JobsService, SocialService, IterableService) {
	    _classCallCheck(this, EtamapController);
	
	    this.name = "etamap";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$rootScope = $rootScope;
	    this.$security = SecurityService;
	    this.$window = $window;
	    this.$location = $location;
	    this.$social = SocialService;
	    this.$iterable = IterableService;
	    this.$timeout = $timeout;
	    this.$jobs = JobsService;
	    this.setVerificationNoti = false;
	    this.$events = EventsService;
	    this.currentUser = this.$auth.getUserData();
	    this.$scope = $scope;
	    this.$tracking = TrackingService;
	    this.$messagingv2 = Messagingv2Service;
	    this.$companies = $companies;
	
	    var _this = this;
	
	    _this.LoadETADataListener = _this.$rootScope.$on("LoadETAData", function ($event, params) {
	      console.log("---------------------LoadETADataLoad---------------------");
	      console.log("---------------------LoadETADataLoad---------------------");
	      console.log("---------------------LoadETADataLoad---------------------");
	      _this.load_eta_data("HELLO");
	      console.dir(params);
	
	      _this.event_id = params.event.id;
	      _this.index = params.ind;
	
	      /*
	      _this.load_eta_data(params.event, params.jobble);
	      */
	    });
	
	    _this.$scope.$on("$destroy", _this.LoadETADataListener);
	  }
	
	  _createClass(EtamapController, [{
	    key: "load_eta_data",
	    value: function load_eta_data(msg) {
	      var _this = this;
	      console.dir(msg);
	      /*
	      console.log("load_eta_data");
	      console.dir(event_id);
	      console.dir(jobble_id);
	      _this.$events.load_eta_data(event_id,jobble_id).then(function(response){
	      console.log("response");
	      console.dir(response);
	      _this.handle_eta_response(response);
	      },function(error){
	      console.log("in error");
	      console.dir(response);
	      });
	      */
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      var _this = this;
	      console.log("close");
	      console.dir(_this.event_id);
	      console.dir(_this.index);
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("CloseEtaModal", {
	          eid: _this.event_id,
	          index: _this.index
	        });
	      });
	    }
	  }, {
	    key: "handle_eta_response",
	    value: function handle_eta_response(data) {
	      var _this = this;
	      console.log("data");
	      console.dir(data);
	    }
	  }]);
	
	  return EtamapController;
	}();
	
	EtamapController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "tracking", "$rootScope", "$scope", "$location", "$timeout", "$window", "companies", "messagingv2", "events", "jobs", "social", "iterable"];
	
	exports.default = EtamapController;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(217);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./etamap.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./etamap.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _branchioshare = __webpack_require__(219);
	
	var _branchioshare2 = _interopRequireDefault(_branchioshare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var branchioshareModule = _angular2.default.module("branchioshare", [_angularUiRouter2.default]).component("branchioshare", _branchioshare2.default);
	
	exports.default = branchioshareModule;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _branchioshare = __webpack_require__(220);
	
	var _branchioshare2 = _interopRequireDefault(_branchioshare);
	
	var _branchioshare3 = __webpack_require__(221);
	
	var _branchioshare4 = _interopRequireDefault(_branchioshare3);
	
	__webpack_require__(222);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var branchioshareComponent = {
	  restrict: "E",
	  bindings: {
	    jobble: "="
	  },
	  template: _branchioshare2.default,
	  controller: _branchioshare4.default,
	  controllerAs: "vm"
	};
	
	exports.default = branchioshareComponent;

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	module.exports = "<!--<div>\n  <div ng-if=\"vm.sharing\">\n    <input id=\"myInput\" type=\"text\" value={{vm.link}} readonly/>\n    <button ng-click=\"vm.copy()\">Copy</button>\n\n    <a target=\"_blank\"\n       href={{vm.twitterLink}}>\n      Tweet\n    </a>\n\n    <a target=\"_blank\"\n       href={{vm.facebookLink}}>\n      Facebook\n    </a>\n\n    <a target=\"_blank\"\n       href={{vm.linkedInLink}}>\n      Linkedin\n    </a>\n  </div>\n</div>-->\n<!--data-toggle=\"modal\" data-target=\"#branchModal\"-->\n<div class=\"branch-button\">\n  <div ng-click=\"vm.share()\"><i class=\"far fa-share-square\"></i> Share</div>\n</div>\n\n<!-- Modal -->\n<div class=\"modal fade branch-modal\" id=\"branchModal-{{vm.num}}\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"branchModalTitle\" aria-hidden=\"true\" data-backdrop=\"static\">\n  <div class=\"modal-dialog modal-dialog-centered\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"share-container\">\n        <div class=\"close-button\" data-dismiss=\"modal\" aria-label=\"Close\">\n          <i class=\"fas fa-times\"></i>\n        </div>\n        <div class=\"back-button\" data-dismiss=\"modal\" aria-label=\"Close\">\n          <i class=\"fas fa-chevron-left\"></i>\n        </div>\n        <div class=\"share-title\">Share this job</div>\n        <!--\n        <div class=\"share-sub-title\">{{vm.jobble.subEvent.event.name}}</div>\n        -->\n      </div>\n      <div class=\"icons-container\">\n        <a class=\"social-media-container\" ng-click=\"vm.open(vm.facebookLink)\">\n          <div class=\"social-logo\">\n            <i class=\"fab fa-facebook-square\"></i>\n          </div>\n          <div class=\"social-name\">Facebook</div>\n        </a>\n        <a class=\"social-media-container\" ng-click=\"vm.open(vm.twitterLink)\">\n          <div class=\"social-logo\">\n            <i class=\"fab fa-twitter-square\"></i>\n          </div>\n          <div class=\"social-name\">Twitter</div>\n        </a>\n        <a class=\"social-media-container\" ng-click=\"vm.open(vm.linkedInLink)\">\n          <div class=\"social-logo\">\n            <i class=\"fab fa-linkedin-square\"></i>\n          </div>\n          <div class=\"social-name\">Linkedin</div>\n        </a>\n        <div class=\"social-media-container\" ng-click=\"vm.copy()\">\n          <div class=\"social-logo\">\n            <i class=\"fas fa-copy\"></i>\n          </div>\n          <div id=\"copy-link-{{vm.num}}\" class=\"social-name\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Copied\">Copy Link</div>\n        </div>\n      </div>\n      <input id=\"copyInput-{{vm.num}}\" type=\"text\" value=\"{{vm.link}}\" readonly style=\"opacity: 0\" />\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BranchioshareController = function () {
	  function BranchioshareController($timeout, $branchio) {
	    _classCallCheck(this, BranchioshareController);
	
	    this.name = "branchioshare";
	
	    this.$timeout = $timeout;
	    this.$branchio = $branchio;
	  }
	
	  _createClass(BranchioshareController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.num = Math.random();
	
	      $(document.getElementById("copy-link-" + this.num)).tooltip({
	        container: "body",
	        trigger: "manual"
	      });
	
	      $(document.getElementById("branchModal-" + this.num)).on("hide.bs.modal", function (e) {
	        $(document.getElementById("copy-link-" + this.num)).tooltip("hide");
	      });
	
	      console.log("what is the job");
	      console.dir(this.jobble);
	    }
	  }, {
	    key: "share",
	    value: function share() {
	      var _this = this;
	
	      $(document.getElementById("branchModal-" + this.num)).modal("toggle");
	
	      console.log("lets take a look at the job");
	      console.dir(this.jobble);
	
	      var jobbleId = this.jobble.id;
	      var title = this.jobble.title;
	      var company = this.jobble.companyName;
	      var url = "";
	
	      console.log(jobbleId, title, company);
	
	      if (this.jobble.partnerPostContent) {
	        url = this.jobble.partnerPostContent.url;
	      }
	
	      this.$branchio.createLinks(jobbleId, title, company, url).then(function (links) {
	        console.log("receieved many link here:", links);
	        _this.$timeout(function () {
	          _this.link = links.email;
	          _this.twitterLink = "https://twitter.com/intent/tweet?text=Check out this job! " + links.twitter;
	          _this.facebookLink = "https://www.facebook.com/sharer/sharer.php?u=" + links.facebook;
	          // eslint-disable-next-line max-len
	          _this.linkedInLink = "https://www.linkedin.com/shareArticle?mini=true&url=" + links.linkedin + "&title=&summary=Check out this job!&source=";
	        });
	      });
	    }
	  }, {
	    key: "open",
	    value: function open(link) {
	      link = link || "https://jobble.com";
	      window.open(link, "_blank", "location=yes,height=570,width=520,scrollbars=yes,status=yes");
	    }
	  }, {
	    key: "copy",
	    value: function copy() {
	      var _this2 = this;
	
	      console.log("copy");
	
	      var copyText = document.getElementById("copyInput-" + this.num);
	
	      copyText.select();
	      copyText.setSelectionRange(0, 99999);
	
	      document.execCommand("copy");
	
	      if (window.getSelection) {
	        window.getSelection().removeAllRanges();
	      } else if (document.selection) {
	        document.selection.empty();
	      }
	
	      $(document.getElementById("copy-link-" + this.num)).tooltip("show");
	      setTimeout(function () {
	        $(document.getElementById("copy-link-" + _this2.num)).tooltip("hide");
	      }, 750);
	    }
	  }]);
	
	  return BranchioshareController;
	}();
	
	BranchioshareController.$inject = ["$timeout", "branchio"];
	
	exports.default = BranchioshareController;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(223);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".branch-button{cursor:pointer;border:1px solid #5e666d;border-radius:6px;height:34px;line-height:34px;width:82px;text-align:center;font-size:14px;font-family:Poppins,sans-serif;font-weight:600}.branch-button:hover{background-color:#5e666d;color:#fff}.branch-button i{font-size:16px}.branch-modal{z-index:9999}.branch-modal .modal-dialog{width:296px;margin-top:30vh}@media only screen and (max-width:768px){.branch-modal .modal-dialog{width:100%;margin:0;height:100%}.branch-button{display:block}}.branch-modal .modal-content{border-radius:2px;border:1px solid #adbcc2;border-top:8px solid #6ed053;padding:7px 24px;border-radius:5px}@media only screen and (max-width:768px){.branch-modal .modal-content{height:100%;border:none;padding:0}.branch-modal .icons-container{padding:0 16px}}.branch-modal .share-container{position:relative;text-align:center;height:33px;border-bottom:1px solid #adbcc2}.branch-modal .share-container .share-title{color:#5e666d;font-family:Poppins,sans-serif;font-size:20px;font-weight:500;letter-spacing:.3px;text-transform:uppercase}@media only screen and (max-width:768px){.branch-modal .share-container{height:52px;background:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.1)}.branch-modal .share-container .share-title{line-height:52px}}.branch-modal .close-button{cursor:pointer;position:absolute;top:0;left:-15px;font-size:14px}.branch-modal .back-button{cursor:pointer;position:absolute;top:19px;left:16px;font-size:14px;display:none}@media only screen and (max-width:768px){.branch-modal .close-button{display:none}.branch-modal .back-button{display:block}}.branch-modal .social-media-container{display:flex;margin-top:16px;cursor:pointer;color:#5e666d;border:1px solid #eee;border-radius:5px;padding-left:10px;padding-top:5px;padding-bottom:5px}.branch-modal .social-media-container:hover{background-color:#eee}.branch-modal .social-logo{flex:0 0 24px;font-size:14px}.branch-modal .social-name{color:#5e666d;font-family:Poppins,sans-serif;font-size:14px}", ""]);
	
	// exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pbheader = __webpack_require__(225);
	
	var _pbheader2 = _interopRequireDefault(_pbheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pbheaderModule = _angular2.default.module("jobbleheader", [_angularUiRouter2.default]).component("jobbleheader", _pbheader2.default);
	
	exports.default = pbheaderModule;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pbheader = __webpack_require__(226);
	
	var _pbheader2 = _interopRequireDefault(_pbheader);
	
	var _pbheader3 = __webpack_require__(227);
	
	var _pbheader4 = _interopRequireDefault(_pbheader3);
	
	__webpack_require__(228);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pbheaderComponent = {
	  restrict: "E",
	  bindings: {
	    jobble: "=",
	    onboarding: "="
	  },
	  template: _pbheader2.default,
	  controller: _pbheader4.default,
	  controllerAs: "vm"
	};
	
	exports.default = pbheaderComponent;

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pb-nav-height\"></div>\n\n<div class=\"mobile-menu-wrap pb-nav-mobile\">\n\n    <!--mobile-menu-closed-->\n    <a href=\"#\" class=\"navbar-close\" ng-click=\"vm.closeSideBar()\">\n        <div class=\"icon-bar-box\">\n            <span class=\"icon-bar\"></span>\n            <span class=\"icon-bar\"></span>\n        </div>\n    </a>\n    <!--mobile-menu-closed-->\n\n    <!--mobile-nav-->\n    <div class=\"mobile-nav mobile-nav-company\" ng-if=\"!vm.isJobSeeker\">\n        <ul>\n            <li><a href=\"/account-profile\">Account</a></li>\n            <li><a href=\"/events\">Jobs</a></li>\n            <li><a href=\"/teams\">Teams</a></li>\n            <li><a href=\"\" ng-click=\"vm.signOut()\">Logout</a></li>\n        </ul>\n    </div>\n\n    <div class=\"mobile-nav mobile-nav-jobbler\" ng-if=\"vm.isJobSeeker\">\n        <ul>\n            <li><a href=\"/jobs\">Jobble Board</a></li>\n            <li><a href=\"/jobbler/{{vm.currentUser.id}}\" ng-if=\"vm.currentUser\">Profile</a></li>\n            <li>\n                <a href=\"/signin\" ng-if=\"!vm.currentUser\">Login</a>\n            </li>\n            <!--<li><a href=\"#\" ng-click=\"vm.goToProfile()\" ng-if=\"vm.currentUser\">Profile</a></li>-->\n            <li><a href=\"#\" ng-click=\"vm.signOut()\" ng-if=\"vm.currentUser\">Log out</a></li>\n        </ul>\n    </div>\n    <!--mobile-nav-->\n</div>\n\n<header class=\"header-section clearfix pb-nav\" ng-if=\"!vm.isJobSeeker\">\n\n    <div class=\"noti-message\" ng-if=\"vm.showNoti\">\n        <div class=\"noti-message-left\" ng-click=\"vm.closeNoti(1)\">\n            x\n        </div>\n        <div class=\"noti-message-right\">\n            Message sent\n        </div>\n    </div>\n\n    <div class=\"noti-message\" style=\"width: 15%;\" ng-if=\"vm.showAuto\">\n        <div class=\"noti-message-left\" ng-click=\"vm.closeAutoSave()\">\n            x\n        </div>\n        <div class=\"noti-message-right\">\n            Saving Progress...\n        </div>\n    </div>\n\n    <div class=\"logo pull-left\">\n\n        <div class=\"logo\" ng-if=\"!vm.onboarding\">\n            <a href=\"/jobs-dashboard?filter=published\">\n                <img src=\"app/vendor/images/jobble-logo-300-dpi.png\" alt=\"Jobble Biz\" title=\"Jobble Biz\"></a>\n        </div>\n        <div class=\"logo\" ng-if=\"vm.onboarding\">\n            <a href=\"/company/onboarding/1\">\n                <img src=\"app/vendor/images/jobble-logo-300-dpi.png\" alt=\"Jobble Biz\" title=\"Jobble Biz\"></a>\n        </div>\n\n    </div>\n\n    <div class=\"company-name-header\" ng-if=\"!vm.onboarding && vm.currentUser\">\n        {{ vm.currentUser.company.name }} \n        <!--<span ng-if=\"vm.currentUser.isAdmin\"> - {{ vm.currentUser.username }}</span>-->\n    </div>\n\n    <div class=\"header-right pull-right\" ng-if=\"!vm.onboarding && !vm.hideMobileNav\" style=\"margin-right: 50px;\">\n\n        <button class=\"navbar-toggle menu-toggle\" type=\"button\" ng-click=\"vm.slideToggle()\">\n            <span class=\"sr-only\">Toggle navigation</span>\n            <span class=\"icon-bar\"></span>\n            <span class=\"icon-bar\"></span>\n            <span class=\"icon-bar\"></span>\n        </button>\n\n        <div class=\"user-login dropdown pull-right new-dropdown\">\n            <a href=\"#\"\n               class=\"user-avatar dropdown-toggle no-border\"\n               data-toggle=\"dropdown\"\n               aria-haspopup=\"true\"\n               aria-expanded=\"true\">\n                <i class=\"fas fa-bars menu-drop-down-cog\" style=\"color:#33373A;\"></i>\n            </a>\n            <!--\n            <a href=\"#\"\n               class=\"user-avatar dropdown-toggle\"\n               id=\"dropdownMenu1\"\n               data-toggle=\"dropdown\"\n               aria-haspopup=\"true\"\n               aria-expanded=\"true\"\n               style=\"background-image: url({{($root.imgFromProfilePage || (vm.currentUser.company.companyLogoUri ? vm.currentUser.company.companyLogoUri : '/app/vendor/images/user-more.png'))}})\">\n            </a>\n            -->\n            <ul id=\"main-jobble-header\" class=\"dropdown-menu dropdown header-transition\"\n                aria-labelledby=\"dropdownMenu1\">\n                <li>\n                    <a href=\"/account-profile\" ng-click=\"vm.reportHeaderDropDownClick(1)\">Account</a>\n                </li>\n                <li>\n                    <a href=\"/direct-pay\" ng-click=\"vm.reportHeaderDropDownClick(2)\">Direct Pay</a>\n                </li>\n                <li>\n                    <a href=\"https://jobble.com/help/business\"\n                       ng-click=\"vm.reportHeaderDropDownClick(3)\"\n                       target=\"_blank\" rel=\"noopener\">Help Center</a>\n                </li>\n                <li>\n                    <a style=\"margin-bottom: 0px\" href=\"\" ng-click=\"vm.signOut(true); vm.reportHeaderDropDownClick(4)\">\n                        Log Out</a>\n                </li>\n            </ul>\n\n        </div>\n\n\n        <nav class=\"main-menu pull-right\" style=\"position:relative;margin: 3px 10px 3px 0;\">\n            <ul>\n\n                <li>\n                    <a href=\"#\"\n                       ng-click=\"vm.showJobScroll()\"\n                       ng-focus=\"vm.jobDropDownFocus()\"\n                       ng-blur=\"vm.jobDropDownBlur()\">\n                        <i class=\"fa fa-list-ul\" aria-hidden=\"true\"></i> Jobs\n                    </a>\n                    <pbjobsdropdown></pbjobsdropdown>\n                </li>\n                <li ng-click=\"vm.determineBillingPage()\">\n                    <a href=\"\">\n                        <i class=\"fa fa-wpforms\" aria-hidden=\"true\"></i> Billing\n                    </a>\n                </li>\n                <li style=\"border-right: 1px solid #5E666D;padding-right: 20px;\">\n                    <a href=\"/teams\">\n                        <i class=\"fa fa-users\" aria-hidden=\"true\"></i> Teams\n                    </a>\n                </li>\n                <li ng-click=\"vm.sendToPostAJob()\">\n                    <button class=\"post-a-job-button\">\n                        Post a job\n                    </button>\n                </li>\n\n            </ul>\n        </nav>\n\n    </div>\n\n\n</header>\n\n\n<header class=\"header-section clearfix pb-nav\" ng-if=\"vm.isJobSeeker\">\n\n    <div\n            ng-class=\"{'noti-message-application-error':vm.appError,'noti-message-application-success':!vm.appError}\"\n            ng-if=\"vm.applicationText\">\n        <div class=\"noti-message-left\" ng-click=\"vm.closeNotiApp()\">x</div>\n        <div class=\"noti-message-right\">{{ vm.applicationText }}</div>\n        <div class=\"noti-message-full\">\n            <a href=\"#\" ng-click=\"vm.moreInfoModal()\">Click here for more information</a>\n        </div>\n        <!--\n        <div class=\"noti-message-full\">\n            <a href=\"#\" ng-click=\"vm.moreInfoModal()\">Finish basic profile</a>\n        </div>\n        -->\n    </div>\n\n    <div class=\"logo pull-left\">\n        <!--logo-->\n        <div class=\"logo mobile\">\n            <a ng-click=\"vm.determineWhereToGo()\" href=\"#\">\n                <img\n                        src=\"app/vendor/images/jobble-mobile-logo-300-dpi.png\"\n                        alt=\"Jobble Logo\"\n                        title=\"Jobble Logo\"\n                />\n            </a>\n        </div>\n        <!--logo-->\n        <!--logo-->\n        <div class=\"logo desktop\">\n            <a ng-click=\"vm.determineWhereToGo()\" href=\"#\">\n                <img\n                        src=\"app/vendor/images/jobble-logo-300-dpi.png\"\n                        alt=\"Jobble Logo\"\n                        title=\"Jobble Logo\"/>\n            </a>\n            </a>\n        </div>\n        <!--logo-->\n    </div>\n\n\n    <div class=\"pull-left\">\n        <div class=\"job-search-container\">\n            <div class=\"job-search-term-container\">\n                <input class=\"desktop-search\" ng-model=\"vm.searchTerm\" ng-keyup=\"vm.submitOnEnter($event)\"\n                       placeholder=\"Search job title or keyword\"/>\n                <input class=\"mobile-search\" ng-model=\"vm.searchTerm\" ng-keyup=\"vm.submitOnEnter($event)\"\n                       placeholder=\"Search job\"/>\n                <i class=\"fas fa-search\"></i>\n            </div>\n            <div class=\"zip-code-container\">\n                <i class=\"fas fa-map-marker-alt\"></i>\n                <input ng-model=\"vm.location\"\n                       id=\"location-search\"\n                       placeholder=\"Enter a location\"/>\n            </div>\n            <div class=\"button-container\">\n                <button ng-click=\"vm.querySearch()\" class=\"button\">\n                    <i class=\"fas fa-search\"></i>\n                </button>\n            </div>\n        </div>\n        <div class=\"job-search-container mobile\">\n            <div style=\"display: flex\">\n                <div class=\"job-search-term-container\">\n                    <input class=\"mobile-search\" placeholder=\"Job title or company\" value=\"{{vm.searchTerm}}\"\n                           ng-click=\"vm.toggleMobile()\"/>\n                    <i class=\"fas fa-search\"></i>\n                </div>\n                <div class=\"button-container\">\n                    <button ng-click=\"vm.querySearch()\" class=\"button\">\n                        <i class=\"fas fa-search\"></i>\n                    </button>\n                </div>\n            </div>\n            <div class=\"mobile-location-search\" ng-class=\"{'show': vm.showMobileModal}\">\n                <div style=\"display: flex\">\n                    <div class=\"input-container term-container\">\n                        <input placeholder=\"Job title or company\" ng-model=\"vm.searchTerm\"\n                               ng-keyup=\"vm.submitOnEnter($event, true)\" id=\"mobile-term\"/>\n                        <i class=\"fas fa-chevron-left\" ng-click=\"vm.toggleMobile()\"></i>\n                    </div>\n                    <div class=\"button-container\">\n                        <button ng-click=\"vm.querySearch(); vm.toggleMobile()\" class=\"button\">\n                            <i class=\"fas fa-search\"></i>\n                        </button>\n                    </div>\n                </div>\n                <div class=\"input-container\">\n                    <i class=\"fas fa-map-marker-alt\"></i>\n                    <input ng-model=\"vm.location\"\n                           id=\"mobile-location-search\"\n                           placeholder=\"Enter a location\"/>\n                </div>\n            </div>\n\n        </div>\n    </div>\n\n\n    <div class=\"header-right pull-right\">\n\n        <button class=\"navbar-toggle\" type=\"button\" ng-if=\"!vm.hideMobileNav\" ng-click=\"vm.slideToggle()\">\n            <span class=\"sr-only\">Toggle navigation</span>\n            <span class=\"icon-bar\"></span>\n            <span class=\"icon-bar\"></span>\n            <span class=\"icon-bar\"></span>\n        </button>\n\n        <div ng-if=\"vm.currentUser && !vm.onboarding\" class=\"user-login dropdown pull-right\">\n\n            <a\n                    href=\"#\"\n                    class=\"user-avatar dropdown-toggle\"\n                    id=\"dropdownMenu1\"\n                    data-toggle=\"dropdown\"\n                    aria-haspopup=\"true\"\n                    aria-expanded=\"true\"\n                    style=\"background-image: url({{($root.imgFromProfilePage || (vm.currentUser.profilePictureUri ? vm.currentUser.profilePictureUri : '/app/vendor/images/user-more.png'))}})\"/>\n            </a>\n\n            <ul class=\"dropdown-menu dropdown\" aria-labelledby=\"dropdownMenu1\" ng-if=\"!vm.currentUser\">\n                <li><a href=\"/signup/jobbler\">Register</a></li>\n                <li><a style=\"margin-bottom: 0px\" href=\"/signin\">Login</a></li>\n            </ul>\n            <ul class=\"dropdown-menu dropdown\" aria-labelledby=\"dropdownMenu1\" ng-if=\"vm.currentUser\">\n                <li><a href=\"/jobbler/{{vm.currentUser.id}}\" ng-if=\"vm.currentUser\">Profile <i\n                        class=\"fas fa-angle-double-right\"></i></a></li>\n                <li><a href=\"https://jobble.com/help/jobbler/\" target=\"_blank\"\n                       ng-if=\"vm.currentUser\">Resource Center <i class=\"fas fa-angle-double-right\"></i></a></li>\n                <li><a href=\"https://apps.apple.com/us/app/jobble/id961838757\" target=\"_blank\" ng-if=\"vm.currentUser\">Get\n                    the app <i class=\"fas fa-angle-double-right\"></i></a></li>\n                <li><a style=\"margin-bottom: 0px\" href=\"\" ng-click=\"vm.signOut()\">Log out</a></li>\n            </ul>\n\n        </div>\n\n        <nav class=\"main-menu pull-right\" ng-if=\"!vm.onboarding\">\n            <ul>\n\n                <li ng-hide=\"!vm.currentUser\">\n\n                </li>\n\n                <li ng-hide=\"vm.currentUser\">\n                    <a\n                            href=\"/signup/company\"\n                            ng-click=\"vm.changePage('business')\">Post A Job</a>\n                </li>\n\n                <li ng-hide=\"vm.currentUser\">\n                    <a\n                            href=\"/signon?accountType=jobbler\"\n                            ng-click=\"vm.changePage('jobbler')\">Jobbler Sign Up</a>\n                </li>\n\n                <li\n                        ng-hide=\"vm.currentUser || vm.$state.current.name == 'signin'\"\n                        ng-click=\"vm.showLoginOptions()\">\n                    <a href=\"\">Sign in</a>\n                </li>\n\n\n            </ul>\n        </nav>\n\n        <div\n                class=\"sign-in-header\"\n                ng-blur=\"vm.menuBlur()\"\n                tabindex=\"-1\">\n            <ul>\n                <li ng-click=\"vm.sendUserToSignIn('jobbler')\">JOBBLER SIGN IN</li>\n                <li ng-click=\"vm.sendUserToSignIn('business')\">BUSINESS SIGN IN</li>\n            </ul>\n        </div>\n\n\n    </div>\n\n</header>\n\n<div class=\"modal fade\" id=\"funnel-user-to-app\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header popup-header\">\n\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times-circle\"></i>\n                        </button>\n\n                        <img style=\"width: 47px;\" src=\"/app/vendor/images/clock-with-shadow.png\"/>\n\n                        <h3 class=\"modal-title\" style=\"border-bottom: 1px solid #eee;padding-bottom:15px;\">\n                            Feature not available\n                        </h3>\n\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"row\">\n                            <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                                <p>This feature is currently not available.</p>\n                                <p>We are working hard to get this feature on our web app. Please check back later or\n                                    download\n                                    our mobile app to access all of our features.</p>\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col-lg-12 col-md-12 col-sm-12\" style=\"padding-bottom:20px;\">\n                                <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                                    <a href=\"https://itunes.apple.com/us/app/jobble/id961838757?mt=8\" target=\"_blank\"\n                                       rel=\"noopener\">\n                                        <img src=\"/app/vendor/images/App_Store.png\"/>\n                                    </a>\n                                </div>\n                                <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                                    <a href=\"https://play.google.com/store/apps/details?id=com.jobble.jobble&hl=en\"\n                                       target=\"_blank\" rel=\"noopener\">\n                                        <img src=\"/app/vendor/images/Google_Play.png\"/>\n                                    </a>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal fade\" id=\"finishing-steps\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content next-steps-image\">\n                    <div class=\"modal-header popup-header\">\n                        <h3 class=\"modal-title\"></h3>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"row\">\n                            <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                                <img src=\"/app/vendor/images/flow.png\"/>\n                                <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                                    <i class=\"fa fa-times-circle\"></i>\n                                </button>\n                                <a href=\"#\" ng-click=\"vm.send_to_basic_profile()\" class=\"funnel-link\">Finish your basic\n                                    profile</a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n<div\n        class=\"modal fade\"\n        id=\"agree-to-terms\"\n        tabindex=\"-1\"\n        role=\"dialog\"\n        aria-labelledby=\"modal-add-projectLabel\"\n        data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-gradient-banner\"></div>\n                <div class=\"modal-content next-steps-image\">\n                    <div class=\"modal-header popup-header\">\n                        <h3 class=\"modal-title\">\n                            Jobble Terms of Service\n                        </h3>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"row\">\n                            <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                                <p>\n                                    We’ve updated our <a class=\"policy\" href=\"https://jobble.com/terms-of-service/\"\n                                                         target=\"_blank\">Terms of Service</a>, <a class=\"policy\"\n                                                                                                  href=\"https://kb.jobble.com/privacy/\"\n                                                                                                  target=\"_blank\">Privacy\n                                    Policy</a>, and <a class=\"policy\" href=\"https://stripe.com/connect-account/legal\"\n                                                       target=\"_blank\">Stripe Connected Account Agreement</a>. Please\n                                    take a moment to review. To continue using our services, you need to accept these\n                                    updates.</p>\n                                <div>\n                                    <div ng-click=\"vm.userAcceptsTOS(true,null)\" class=\"accept-button\">\n                                        Accept\n\n                                    </div>\n                                </div>\n                                <div style=\"margin-top: 10px;\">\n                                    <a ng-click=\"vm.userAcceptsTOS(false,null)\" href=\"\">\n                                        Decline\n                                    </a>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div\n        class=\"modal fade\"\n        id=\"opt-out\"\n        tabindex=\"-1\"\n        role=\"dialog\"\n        aria-labelledby=\"modal-add-projectLabel\"\n        data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content next-steps-image\">\n                    <div class=\"modal-header popup-header\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times-circle\"></i>\n                        </button>\n\n                        <h3 class=\"modal-title\">Opt Out of Privacy Policy</h3>\n\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"row\">\n\n                            <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                                <p>Please fill out this form to opt out</p>\n\n                                <form class=\"form-section\" style=\"text-align:left;\" ng-submit=\"vm.optOut()\">\n                                    <label>First name</label>\n                                    <input type=\"text\" class=\"form-control form-input\"/>\n                                    <label>Last name</label>\n                                    <input type=\"text\" class=\"form-control form-input\"/>\n                                    <label>Email</label>\n                                    <input type=\"email\" class=\"form-control form-input\" ng-model=\"vm.tosEmail\"/>\n                                    <input type=\"submit\" value=\"Submit\" class=\"btn btn-success\"/>\n                                </form>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div\n        class=\"modal fade\"\n        id=\"opt-in\"\n        tabindex=\"-1\"\n        role=\"dialog\"\n        aria-labelledby=\"modal-add-projectLabel\"\n        data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content next-steps-image\">\n                    <div class=\"modal-header popup-header\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times-circle\"></i>\n                        </button>\n\n                        <h3 class=\"modal-title\">Opt in of Privacy Policy</h3>\n\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"row\">\n\n                            <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                                <p>Please fill out this form to opt in</p>\n\n                                <form class=\"form-section\" style=\"text-align:left;\" ng-submit=\"vm.optIn()\">\n                                    <label>First name</label>\n                                    <input type=\"text\" class=\"form-control form-input\"/>\n                                    <label>Last name</label>\n                                    <input type=\"text\" class=\"form-control form-input\"/>\n                                    <label>Email</label>\n                                    <input type=\"email\" class=\"form-control form-input\"/>\n                                    <input type=\"submit\" value=\"Submit\" class=\"btn btn-success\"/>\n                                </form>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<track/>"

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _messagingv = __webpack_require__(30);
	
	var _messagingv2 = _interopRequireDefault(_messagingv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PbheaderController = function () {
	  function PbheaderController($http, $localStorage, $state, AuthService, SecurityService, TrackingService, $rootScope, $scope, $location, $timeout, $window, $companies, Messagingv2Service, ProfileService, EventsService, $interval) {
	    var _this2 = this;
	
	    _classCallCheck(this, PbheaderController);
	
	    this.name = "pbheader";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$rootScope = $rootScope;
	    this.$security = SecurityService;
	    this.$window = $window;
	    this.$timeout = $timeout;
	    this.$events = EventsService;
	    this.$profile = ProfileService;
	    this.$scope = $scope;
	    this.showJobsDropDown = false;
	    this.$tracking = TrackingService;
	    this.$messagingv2 = Messagingv2Service;
	    this.onboarding = false;
	    this.$companies = $companies;
	    this.currentUser = this.$auth.getUserData();
	    this.showPostScroll = false;
	    this.$rootScope.channelsHaveLoaded = true;
	    this.showNoti = false;
	    this.$location = $location;
	    this.$interval = $interval;
	    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
	    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;
	
	    var _this = this;
	
	    $rootScope.$watch("$routeChangeStart", function () {
	      _this.setActiveClass();
	
	      if (_this.$state.current.name !== "jobsdashboard" && _this.$state.current.name !== "transactionhistory" && _this.$state.current.name !== "teams" && _this.$state.current.name !== "inbox" && _this.$state.current.name !== "eventreviewapplicants") {
	        _this.$timeout(function () {
	          $(".main-menu ul").show();
	        });
	      }
	
	      var state_name = _this.$state.current.name;
	      if (state_name === "signin" || state_name === "recoverpassword" || state_name === "signon" || state_name === "accounttype") {
	        _this.$timeout(function () {
	          _this.hideMobileNav = true;
	        });
	      } else {
	        _this.$timeout(function () {
	          _this.hideMobileNav = false;
	        });
	      }
	    });
	
	    if (!this.$rootScope.googleHasLoaded) {
	      this.$rootScope.googleHasLoaded = true;
	    }
	
	    _this.showNotiListener = _this.$rootScope.$on("ShowNoti", function ($event, params) {
	      _this.showNoti = true;
	      _this.$timeout(function () {
	        _this.showNoti = false;
	      }, 2000);
	    });
	
	    _this.updateCurrentUserListener = _this.$rootScope.$on("UpdateCurrentUser", function (event, params) {
	      _this.updateCurrentUser(params);
	    });
	
	    _this.autoSaveListener = _this.$rootScope.$on("AutoSave", function (event, params) {
	      _this.showAuto = true;
	      _this.autoSaveEventAsDraft(params);
	    });
	
	    _this.autoSaveListenerTrigger = _this.$rootScope.$on("AutoSaveTrigger", function (event, params) {
	      if (params.pop === "on") {
	        _this.showAuto = true;
	      } else {
	        _this.showAuto = false;
	      }
	    });
	
	    _this.channelsHaveBeenLoadedListener = _this.$rootScope.$on("channelsHaveBeenLoaded", function ($event, params) {
	      _this.$timeout(function () {
	        _this.$rootScope.channelsHaveLoaded = true;
	      });
	    });
	
	    _this.SetProfilePictureListener = _this.$rootScope.$on("SetProfilePicture", function ($event, params) {
	      _this.get_logo(params);
	    });
	
	    _this.RecentUserUpdatedListener = _this.$rootScope.$on("RecentUserUpdated", function ($event, params) {
	      _this.$timeout(function () {
	        _this.currentUser = params;
	      });
	    });
	
	    _this.ToastMessageListener = _this.$rootScope.$on("ToastMessage", function ($event, params) {
	      _this.toastMessage(params);
	    });
	
	    this.JobSearchQueryParamsListener = _this.$rootScope.$on("JobSearchQueryParams", function ($event, params) {
	
	      var desktopInput = document.getElementById("location-search");
	      var mobileInput = document.getElementById("mobile-location-search");
	
	      if (params && params.zipcode && (params.zipcode !== _this2.zipCode || desktopInput.value === "" || desktopInput.value == params.zipcode)) {
	        _this2.setZipCode(params.zipcode).then(function () {
	          _this2.awaitForGoogleToLoad().then(function () {
	            _this2.geocoder = new window.google.maps.Geocoder();
	
	            _this2.geocoder.geocode({ address: "" + params.zipcode }, function (results, status) {
	              if (status === "OK" && results && results.length) {
	                var address = results[0].address_components;
	
	                var city = "";
	                var state = "";
	                var county = "";
	
	                address.forEach(function (a) {
	                  if (a.types.indexOf("locality") !== -1) {
	                    city = a.long_name;
	                  }
	                  if (a.types.indexOf("country") !== -1) {
	                    county = a.long_name;
	                  }
	                  if (a.types.indexOf("administrative_area_level_1") !== -1) {
	                    state = a.short_name;
	                  }
	                });
	
	                console.log("Syncing data in nav bar", city, state, county);
	
	                desktopInput.value = city + ", " + state + ", USA";
	                mobileInput.value = city + ", " + state + ", USA";
	                _this2.setCityStateParams(city, state);
	              }
	            });
	          });
	        });
	      } else {
	        _this2.unSetLoader();
	      }
	
	      if (params && params.search) {
	        _this2.setSearchTerm(params.search);
	      }
	    });
	
	    _this.SetNewUserForJobBoardHeaderListener = _this.$rootScope.$on("SetNewUserForJobBoardHeader", function ($event, params) {
	      _this.$timeout(function () {
	        _this.currentUser = params.user;
	        _this.$localStorage.logged_user = params.user;
	      });
	    });
	
	    _this.SetApplyConfirmationListener = _this.$rootScope.$on("SetApplyConfirmation", function ($event, data) {
	      _this.setApplicationStatus(data.params, data.user_not_verified);
	    });
	
	    _this.SignUserOutOnboardingListener = _this.$rootScope.$on("SignUserOnboardingOut", function (event, params) {
	      _this.signOutOnBoarding();
	    });
	
	    _this.SignUserOutListener = _this.$rootScope.$on("SignUserOut", function (event, params) {
	      _this.signOut();
	    });
	
	    _this.SetEventsToScrollerListener = _this.$rootScope.$on("SetEventsToScroller", function (event, params) {
	      _this.setToDirective(params);
	    });
	
	    _this.GetLogoListener = _this.$rootScope.$on("GetLogo", function (event, params) {
	      _this.get_logo(params);
	    });
	
	    _this.checkForVerifiedBankAccountListener = _this.$rootScope.$on("checkForVerifiedBankAccount", function ($event, company) {
	      _this.checkForVerifiedBankAccount(company.undeletedPaymentInfos);
	    });
	
	    _this.$scope.$on("$destroy", _this.checkForVerifiedBankAccountListener);
	    _this.$scope.$on("$destroy", _this.GetLogoListener);
	    _this.$scope.$on("$destroy", _this.RecentUserUpdatedListener);
	    _this.$scope.$on("$destroy", _this.SetEventsToScrollerListener);
	    _this.$scope.$on("$destroy", _this.SetApplyConfirmationListener);
	    _this.$scope.$on("$destroy", _this.SetNewUserForJobBoardHeaderListener);
	    _this.$scope.$on("$destroy", _this.showNotiListener);
	    _this.$scope.$on("$destroy", _this.autoSaveListener);
	    _this.$scope.$on("$destroy", _this.autoSaveListenerTrigger);
	    _this.$scope.$on("$destroy", _this.channelsHaveBeenLoadedListener);
	    _this.$scope.$on("$destroy", _this.SetProfilePictureListener);
	    _this.$scope.$on("$destroy", _this.ToastMessageListener);
	    _this.$scope.$on("$destroy", _this.JobSearchQueryParamsListener);
	    _this.$scope.$on("$destroy", _this.updateCurrentUserListener);
	    _this.$scope.$on("$destroy", _this.SignUserOutListener);
	
	    if (!this.$security.isUndefinedOrNull(this.currentUser)) {
	      if (this.currentUser.company && this.currentUser.company.id) {
	        if (this.$security.isUndefinedOrNull(this.currentUser.company.companyLogoUri) && this.$security.isUndefinedOrNull(this.$rootScope.companyLogoUri)) {
	          this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
	          this.get_logo(this.currentUser);
	        } else {
	          if (this.currentUser.company.companyLogoUri) {
	            this.$rootScope.companyLogoUri = this.currentUser.company.companyLogoUri;
	            this.currentUser.companyProfilePictureUrl = this.currentUser.company.companyLogoUri;
	            //this.get_logo(this.currentUser);
	          }
	        }
	
	        _this.isJobSeeker = false;
	        _this.setTeamsToSession();
	        _this.setJobbleTypesToSession();
	      } else {
	        this.checkAgreementStatus(this.currentUser);
	        this.isJobSeeker = true;
	        this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
	      }
	    } else {
	      this.$rootScope.channelsHaveLoaded = true;
	      this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
	      _this.initUnregisteredUser();
	    }
	  }
	
	  _createClass(PbheaderController, [{
	    key: "setCityStateParams",
	    value: function setCityStateParams(city, state) {
	      this.$location.search("loc", city + "," + state);
	      this.$rootScope.$emit("CityStateSearch", { city: city, state: state });
	    }
	  }, {
	    key: "toggleMobile",
	    value: function toggleMobile() {
	      this.showMobileModal = !this.showMobileModal;
	      this.$timeout(function () {
	        var mobileInput = document.getElementById("mobile-term");
	        if (mobileInput) mobileInput.focus();
	      }, 10);
	    }
	  }, {
	    key: "$onInit",
	    value: function $onInit() {
	      var _this3 = this;
	
	      this.$timeout(function () {
	        _this3.zipCode = _this3.$localStorage.pb_zipCode;
	        _this3.setZipCode(_this3.zipCode);
	      });
	
	      this.awaitForGoogleToLoad().then(function () {
	        _this3.geocoder = new window.google.maps.Geocoder();
	
	        var desktopInput = document.getElementById("location-search");
	
	        var desktopAutocomplete = new google.maps.places.Autocomplete(desktopInput, {
	          types: ["(cities)"],
	          region: "US",
	          componentRestrictions: { country: "us" }
	        });
	
	        google.maps.event.addListener(desktopAutocomplete, "place_changed", function () {
	          return _this3.autoCompleteListener(desktopAutocomplete);
	        });
	
	        var mobileInput = document.getElementById("mobile-location-search");
	
	        var mobileAutocomplete = new google.maps.places.Autocomplete(mobileInput, {
	          types: ["(cities)"],
	          region: "US",
	          componentRestrictions: { country: "us" }
	        });
	
	        google.maps.event.addListener(mobileAutocomplete, "place_changed", function () {
	          return _this3.autoCompleteListener(mobileAutocomplete);
	        });
	      });
	    }
	  }, {
	    key: "autoCompleteListener",
	    value: function autoCompleteListener(autocomplete) {
	      var _this4 = this;
	
	      console.time("zip code extraction");
	
	      if (this.showMobileModal) {
	        this.$timeout(function () {
	          _this4.showMobileModal = false;
	        });
	      }
	
	      var place = autocomplete.getPlace();
	
	      var address = place.address_components;
	
	      if (!address) return;
	
	      var city = "";
	      var state = "";
	      var county = "";
	
	      address.forEach(function (a) {
	        if (a.types.indexOf("locality") !== -1) {
	          city = a.long_name;
	        }
	        if (a.types.indexOf("country") !== -1) {
	          county = a.long_name;
	        }
	        if (a.types.indexOf("administrative_area_level_1") !== -1) {
	          state = a.short_name;
	        }
	      });
	
	      console.log("Setting new place", city, state, county);
	      this.setCityStateParams(city, state);
	
	      this.geocoder.geocode({ address: city + ", " + state }, function (results, status) {
	        if (status === "OK") {
	          var location = results[0].geometry.location;
	
	          var coords = {
	            lat: location.lat(),
	            lng: location.lng()
	          };
	
	          _this4.geocoder.geocode({ latLng: coords }, function (results, status) {
	            var zipCode = "";
	            if (status === "OK") {
	              if (results[0]) {
	                for (var j = 0; j < results[0].address_components.length; j++) {
	                  if (results[0].address_components[j].types[0] == "postal_code") {
	                    zipCode = results[0].address_components[j].short_name;
	                  }
	                }
	              }
	              if ((!zipCode || zipCode === "") && results[1]) {
	                for (var j = 0; j < results[1].address_components.length; j++) {
	                  if (results[1].address_components[j].types[0] == "postal_code") {
	                    zipCode = results[1].address_components[j].short_name;
	                  }
	                }
	              }
	
	              console.log("New Zip Code", zipCode);
	
	              _this4.setZipCode(zipCode).then(function () {
	                _this4.querySearch();
	              });
	
	              console.timeEnd("zip code extraction");
	            } else {}
	          }, function (error) {});
	        } else {
	          console.error(status);
	        }
	      });
	    }
	  }, {
	    key: "awaitForGoogleToLoad",
	    value: function awaitForGoogleToLoad() {
	      var _this5 = this;
	
	      var count = 0;
	
	      return new Promise(function (resolve, reject) {
	        //if (!angular.isUndefined(window.google)) return resolve();
	        var id = Math.floor(Math.random() * 100000);
	        _this5.goggleLoaders = _this5.goggleLoaders || {};
	        _this5.goggleLoaders[id] = _this5.$interval(function () {
	          count = count + 1;
	          console.warn("Trying to load google", count);
	          if (!_angular2.default.isUndefined(window.google) || count > 5) {
	            resolve();
	            _this5.$interval.cancel(_this5.goggleLoaders[id]);
	            _this5.goggleLoaders[id] = undefined;
	          }
	        }, 500);
	      });
	    }
	  }, {
	    key: "setZipCode",
	    value: function setZipCode(zipCode) {
	      var _this6 = this;
	
	      return new Promise(function (resolve) {
	        _this6.$timeout(function () {
	          _this6.zipCode = zipCode;
	          _this6.$localStorage.pb_zipCode = zipCode;
	          window.jobble_zip_code = zipCode;
	          resolve();
	        });
	      });
	    }
	  }, {
	    key: "submitOnEnter",
	    value: function submitOnEnter(e, mobile) {
	      if (e.keyCode === 13) {
	        this.querySearch();
	        if (mobile) this.toggleMobile();
	      }
	    }
	  }, {
	    key: "setSearchTerm",
	    value: function setSearchTerm(search) {
	      var _this7 = this;
	
	      return new Promise(function (resolve) {
	        _this7.$timeout(function () {
	          _this7.searchTerm = search;
	          _this7.$localStorage.pb_searchTerm = search;
	        });
	
	        resolve();
	      });
	    }
	  }, {
	    key: "querySearch",
	    value: function querySearch() {
	      var _this8 = this;
	
	      var search_data = {};
	
	      var input = document.getElementById("location-search");
	      var mobileInput = document.getElementById("mobile-location-search");
	
	      var zipCodePattern = /^\d{5}$|^\d{5}-\d{4}$/;
	
	      if (input.value && zipCodePattern.test(input.value)) {
	        this.zipCode = input.value;
	      }
	
	      if (mobileInput.value && zipCodePattern.test(mobileInput.value)) {
	        this.zipCode = mobileInput.value;
	      }
	
	      search_data.zip_code = this.zipCode;
	      search_data.type = "text_search";
	      search_data.value = this.searchTerm;
	
	      if (!search_data.zip_code) {
	        search_data.zip_code = "02116";
	      }
	
	      var tracking_data = {};
	      tracking_data.type = "Job";
	
	      this.currentUser = this.$auth.getUserData();
	
	      if (this.currentUser) {
	        tracking_data.user = this.currentUser.email;
	      } else {
	        tracking_data.user = "Not Logged In";
	      }
	
	      var currentpath = window.location.pathname || "";
	
	      this.$localStorage.pb_searchTerm = this.searchTerm;
	      this.$localStorage.pb_zipCode = this.zipCode;
	
	      if (currentpath.indexOf("jobs") !== -1) {
	        var parcel = {
	          zipcode: search_data.zip_code,
	          type: search_data.type,
	          query: search_data.value
	        };
	        this.$rootScope.$emit("SendSearchParcel", parcel);
	        this.$tracking.reportSubmitSearch("job board", search_data.value, search_data.zip_code);
	      } else {
	        this.$location.path("/jobs").search({
	          t: search_data.type,
	          z: search_data.zip_code,
	          q: search_data.value
	        });
	        this.$tracking.reportSubmitSearch("general", search_data.value, search_data.zip_code);
	      }
	
	      console.log("currentstate", this.$state.current.name);
	
	      if (this.$state.current.name === "jobdetails") {
	        tracking_data.page = "Job Details";
	        this.$tracking.reportJobSearch(tracking_data);
	      } else {
	        this.$timeout(function () {
	          tracking_data.page = "Job Listings";
	          _this8.$tracking.reportJobSearch(tracking_data);
	        });
	      }
	    }
	  }, {
	    key: "slideToggle",
	    value: function slideToggle() {
	      var _this = this;
	      if (_this.isJobSeeker) {
	        _this.$timeout(function () {
	          $(".mobile-menu-wrap").show();
	        });
	      } else {
	        _this.$timeout(function () {
	          $(".mobile-menu-wrap").show();
	        });
	      }
	    }
	  }, {
	    key: "closeSideBar",
	    value: function closeSideBar() {
	      var _this = this;
	      _this.$timeout(function () {
	        $(".mobile-menu-wrap").hide();
	      });
	    }
	  }, {
	    key: "get_logo",
	    value: function get_logo(user) {
	      var _this = this;
	    }
	  }, {
	    key: "set_logo_to_header",
	    value: function set_logo_to_header(logo) {
	      if (!this.currentUser) {
	        this.currentUser = this.$auth.getUserData();
	        if (this.currentUser) {
	          this.currentUser.company.companyLogoUri = logo;
	          this.$rootScope.companyLogoUri = logo;
	          this.currentUser.companyProfilePictureUrl = logo;
	          console.dir(this.currentUser);
	        }
	      } else {
	        this.currentUser.company.companyLogoUri = logo;
	        this.$rootScope.companyLogoUri = logo;
	        this.currentUser.companyProfilePictureUrl = logo;
	        console.dir(this.currentUser);
	      }
	    }
	  }, {
	    key: "updateCurrentUser",
	    value: function updateCurrentUser(params) {
	      var _this = this;
	      if (params) {
	        _this.$timeout(function () {
	          _this.currentUser = params.user;
	          _this.$localStorage.logged_user = params.user;
	          if (_this.$rootScope.channels) {
	            _this.$rootScope.channelsHaveLoaded = true;
	          }
	          if (_this.currentUser.company && _this.currentUser.company.id) {
	            _this.isJobSeeker = false;
	          } else {
	            _this.isJobSeeker = true;
	          }
	        }, 300);
	      }
	    }
	  }, {
	    key: "checkForThirdPartyAndSignOut",
	    value: function checkForThirdPartyAndSignOut(manager) {
	      var _this9 = this;
	
	      var FB = window.FB;
	      var thirdPartyConnection = false;
	
	      var FB = window.FB;
	
	      if (gapi) {
	        if (gapi.auth2) {
	          var auth2 = gapi.auth2.getAuthInstance();
	          auth2.disconnect();
	          auth2.signOut().then(function () {
	            console.log("User signed out of google.");
	            thirdPartyConnection = true;
	          });
	        }
	      }
	
	      if (FB) {
	        FB.getLoginStatus(function (response) {
	          if (response.status === "connected") {
	            FB.logout(function (response) {
	              thirdPartyConnection = true;
	            });
	          }
	        });
	      }
	
	      if (thirdPartyConnection === true) {
	        this.$timeout(function () {
	          _this9.$location.path("/signon");
	        }, 20);
	      } else {
	        this.$timeout(function () {
	          _this9.$location.path(manager ? "/signin" : "/signin");
	        }, 20);
	      }
	    }
	  }, {
	    key: "signOutOnBoarding",
	    value: function signOutOnBoarding() {
	      var _this = this;
	
	      _this.$auth.signOut().then(function (response) {
	        _this.$timeout(function () {
	          _this.$localStorage.logged_user = null;
	          _this.$rootScope.companyLogoUri = null;
	          _this.currentUser.company.companyLogoUri = null;
	          _this.$rootScope.imgFromProfilePage = null;
	          //_this.onboarding = true;
	          _this.currentUser = undefined;
	        });
	      });
	    }
	  }, {
	    key: "signOut",
	    value: function signOut(manager) {
	      var _this = this;
	      _this.$auth.signOut().then(function (response) {
	        _this.$timeout(function () {
	          _this.$tracking.reportUserLogout(_this.$localStorage.logged_user);
	          _this.$localStorage.logged_user = undefined;
	          _this.$rootScope.channels = undefined;
	          _this.$rootScope.companyLogoUri = undefined;
	          _this.$rootScope.inboxLink = undefined;
	          _this.$rootScope.channelsHaveLoaded = undefined;
	          _this.$rootScope.teams = undefined;
	          _this.currentUser.company.companyLogoUri = undefined;
	          _this.$rootScope.teamsSimple = undefined;
	          _this.$rootScope.globalParams = undefined;
	          _this.$rootScope.imgFromProfilePage = undefined;
	          _this.$rootScope.jobbleTypes = undefined;
	          _this.$rootScope.jobs = undefined;
	          _this.$rootScope.jobsSeenOnce = undefined;
	          _this.$rootScope.boardParameters = null;
	          _this.$messagingv2.setHandleLastMessageDataCounter(0);
	          _this.$messagingv2.setTotalAmountOfMissedMessages(0);
	          _this.$location.$$search = null;
	          //_this.$location.$$search.filter = null;
	          _this.checkForThirdPartyAndSignOut(manager);
	        });
	      });
	    }
	  }, {
	    key: "goToSomeChat",
	    value: function goToSomeChat(event) {
	      var _this = this;
	    }
	  }, {
	    key: "inboxLink",
	    value: function inboxLink() {
	      var _this = this;
	    }
	  }, {
	    key: "closeNotification",
	    value: function closeNotification(eventId, channel) {
	      var _this = this;
	      _this.$timeout(function () {
	        jQuery("#notification-tab").hide("fast");
	      });
	    }
	  }, {
	    key: "setJobbleTypesToSession",
	    value: function setJobbleTypesToSession() {
	      var _this = this;
	
	      if (!_this.$rootScope.jobble_types) {
	        _this.loadJobbleTypes();
	      }
	    }
	  }, {
	    key: "loadJobbleTypes",
	    value: function loadJobbleTypes() {
	      var _this = this;
	      _this.$auth.getJobbleTypes().then(function (data) {
	        _this.$rootScope.jobble_types = data.data;
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetJobbleTypes", {
	            jobbleTypes: data.data
	          });
	        });
	      }, function (data) {
	        _this.jobbleTypes = [];
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "setTeamsToSession",
	    value: function setTeamsToSession() {
	      var _this = this;
	    }
	  }, {
	    key: "loadTeams",
	    value: function loadTeams() {
	      var _this = this;
	      var teamsSimple = [];
	      var teams = [];
	      _this.$companies.getTeamsTrim().then(function (data) {
	        try {
	          data.data.forEach(function (team, index) {
	            _this.setAvatarImageToUsersOfTeam(team);
	            team.firstLoadUsersCount = Math.min(team.users.length, 6);
	            if (team.firstLoadUsersCount == 6) {
	              team.firstLoadUsersCount = 5;
	            }
	
	            teams.push(team);
	            var teamsObj = {};
	            teamsObj.name = team.name;
	            teamsObj.id = team.id;
	            teamsSimple.push(teamsObj);
	          });
	        } finally {
	          _this.$timeout(function () {
	            _this.$rootScope.teams = teams;
	            _this.$rootScope.teamsSimple = teamsSimple;
	            _this.$rootScope.$emit("TeamsHaveLoaded", {
	              teams: teams
	            });
	          });
	        }
	      }, function (data) {
	        _this.$rootScope.teams = [];
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "setAvatarImageToUsersOfTeam",
	    value: function setAvatarImageToUsersOfTeam(team) {
	      var _this = this;
	      if (team.users) {
	        team.users.forEach(function (userProfile) {
	          if (!_this.$security.isUndefinedOrNull(userProfile.picture1s)) {
	            userProfile.picture1s.forEach(function (pic) {
	              if (pic.indexOf("75x75") > -1) {
	                userProfile.pictureAvatarUrl = pic;
	              }
	              if (pic.indexOf("160x160") > -1) {
	                userProfile.pictureAvatarUrlBig = pic;
	              }
	            });
	          }
	
	          if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
	            userProfile.pictureAvatarUrl = userProfile.pictureAvatarUrlBig;
	          }
	
	          if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
	            userProfile.pictureAvatarUrl = "/app/vendor/images/defaultimg.jpeg";
	          }
	        });
	      }
	    }
	  }, {
	    key: "closeNoti",
	    value: function closeNoti(x) {
	      var _this = this;
	      _this.showNoti = false;
	      if (x === 2) {
	        _this.$timeout(function () {
	          jQuery(".modal-backdrop").remove();
	          jQuery("body").removeClass("modal-open");
	        });
	      }
	    }
	  }, {
	    key: "closeAutoSave",
	    value: function closeAutoSave(x) {
	      var _this = this;
	      _this.showAuto = false;
	    }
	  }, {
	    key: "autoSaveEventAsDraft",
	    value: function autoSaveEventAsDraft(params) {
	      var _this = this;
	      if (params.update) {
	        _this.$timeout(function () {
	          _this.showAuto = false;
	        }, 2000);
	      } else {
	        if (!params.questions) {
	          params.questions = [];
	          var p = {
	            question: "Are you a good fit?",
	            questionType: 1,
	            name: "Question 1"
	          };
	          params.questions.push(p);
	        }
	        _this.$events.saveDraft(params).then(function (response) {
	          if (response.data.status === "error") {
	            _this.$timeout(function () {
	              _this.showAuto = false;
	            });
	            if (response.data.message.indexOf("Data too long for column 'dress_code'") > -1) {
	              alert("The Dress Code on page 1 is too long. Please go back and shorten.");
	            } else {
	              alert("There was an issue please contact an admin.");
	            }
	            return;
	          }
	          _this.$timeout(function () {
	            _this.showAuto = false;
	            _this.$rootScope.$emit("SetEventIdForDrafting", {
	              draftData: response
	            });
	          }, 2000);
	        }, function (error) {});
	      }
	    }
	  }, {
	    key: "logOnboardingTracking",
	    value: function logOnboardingTracking(event) {
	      var _this = this;
	      _this.$tracking.reportOboardingScreenOne(event);
	    }
	  }, {
	    key: "setActiveClass",
	    value: function setActiveClass() {
	      var _this = this;
	
	      if (_this.$state.current.url.indexOf("/jobs-dashboard") > -1) {
	        _this.$timeout(function () {
	          jQuery(".pull-right ul li:nth-child(1)").addClass("active");
	        });
	      }
	      if (_this.$state.current.url.indexOf("/transactionhistory") > -1) {
	        _this.$timeout(function () {
	          jQuery(".pull-right ul li:nth-child(2)").addClass("active");
	        });
	      }
	      if (_this.$state.current.url.indexOf("/billing") > -1) {
	        _this.$timeout(function () {
	          jQuery(".pull-right ul li:nth-child(2)").addClass("active");
	        });
	      }
	      if (_this.$state.current.url.indexOf("/teams") > -1) {
	        _this.$timeout(function () {
	          jQuery(".pull-right ul li:nth-child(3)").addClass("active");
	        });
	      }
	    }
	  }, {
	    key: "initUnregisteredUser",
	    value: function initUnregisteredUser() {
	      var _this = this;
	      _this.isJobSeeker = true;
	    }
	  }, {
	    key: "funnelToMobileApp",
	    value: function funnelToMobileApp(x) {
	      var _this = this;
	      var button = null;
	      switch (x) {
	        case 1:
	          _this.text = "hi";
	          button = "Applications";
	          break;
	        case 2:
	          _this.text = "hi";
	          button = "Messages";
	          break;
	        case 3:
	          _this.text = "hi";
	          button = "Jobs";
	          break;
	        case 4:
	          _this.text = "hi";
	          button = "Payments";
	          break;
	      }
	      _this.trackingHeader(button);
	    }
	  }, {
	    key: "moreInfoModal",
	    value: function moreInfoModal() {
	      var _this = this;
	      if (_this.appError) {
	        _this.$timeout(function () {
	          $(".noti-message-application-error").hide("fast");
	        });
	      } else {
	        _this.$timeout(function () {
	          $(".noti-message-application-success").hide("fast");
	        });
	      }
	      _this.$timeout(function () {
	        $("#more-application-info").modal();
	      }, 500);
	    }
	  }, {
	    key: "setApplicationStatus",
	    value: function setApplicationStatus(data, user_not_verified) {
	      var _this = this;
	      if (data.data.status === "error") {
	        if (data.data.message === "Applicant already applied for jobble in the pool") {
	          _this.applicationText = "You already applied to this job. Please pick another.";
	        } else {
	          _this.applicationText = "There was an issue with your application. Please try again later.";
	        }
	        _this.appError = true;
	      } else {
	        _this.applicationText = "Success! Check your application status on our mobile app.";
	        _this.appError = false;
	      }
	      if (user_not_verified) {
	        _this.$timeout(function () {
	          $("#finishing-steps").modal();
	        }, 300);
	      }
	      _this.$timeout(function () {
	        _this.applicationText = null;
	      }, 10000);
	    }
	  }, {
	    key: "closeNotiApp",
	    value: function closeNotiApp() {
	      var _this = this;
	      _this.applicationText = null;
	    }
	  }, {
	    key: "trackingHeader",
	    value: function trackingHeader(button) {
	      var _this = this;
	      var data = {};
	      if (!_this.currentUser) {
	        data.username = "Unregistered";
	      } else {
	        data.username = _this.currentUser.username;
	      }
	      data.button = button;
	      _this.$tracking.reportHeaderClicks(button);
	    }
	  }, {
	    key: "goToProfile",
	    value: function goToProfile() {
	      var _this = this;
	    }
	  }, {
	    key: "goToEvents",
	    value: function goToEvents() {
	      var _this = this;
	      _this.$state.go("events");
	    }
	  }, {
	    key: "showPostBlur",
	    value: function showPostBlur() {
	      var _this = this;
	      _this.$timeout(function () {
	        $(".hidden-drop-down-post-types").hide("slide", { direction: "up" }, 100);
	        _this.showPostScroll = false;
	      }, 300);
	    }
	  }, {
	    key: "showPostScrollFunc",
	    value: function showPostScrollFunc() {
	      var _this = this;
	      var dropdown = _this.currentUser.company.postingTypesAllowed;
	      if (dropdown === 0) {
	        if (_this.showPostScroll === false) {
	          _this.$timeout(function () {
	            _this.showPostScroll = true;
	            $(".hidden-drop-down-post-types").show("slide", { direction: "up" }, 100);
	          });
	        } else {
	          _this.$timeout(function () {
	            _this.showPostScroll = false;
	            $(".hidden-drop-down-post-types").hide("slide", { direction: "up" }, 100);
	          });
	        }
	      } else {
	        // _this.$state.go("postashiftwalkthrough");
	        // this.$location.path('/post-a-shift/walkthrough');
	        window.location.href = "/post-a-shift/walkthrough";
	      }
	    }
	  }, {
	    key: "showJobScroll",
	    value: function showJobScroll() {
	      var _this = this;
	      var showList = null;
	      console.log("_this.$localStorage.events");
	      console.dir(_this.$localStorage.events);
	
	      if (_this.showJobsDropDown === false) {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("ListEventsForScroll", {});
	          _this.showJobsDropDown = true;
	          $(".hidden-drop-down").show("slide", { direction: "up" }, 300);
	          //$(".hidden-drop-down").animate({width: 'toggle'}, 300);
	        });
	      } else {
	        _this.$timeout(function () {
	          _this.showJobsDropDown = false;
	          $(".hidden-drop-down").hide("slide", { direction: "up" }, 100);
	          //$(".hidden-drop-down").animate({width: 'toggle'}, 300);
	        });
	      }
	    }
	  }, {
	    key: "showDropDownList",
	    value: function showDropDownList() {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("ListEventsForScroll", {});
	        $(".hidden-drop-down").show("fast");
	      });
	      _this.showJobsDropDown = true;
	    }
	  }, {
	    key: "setToDirective",
	    value: function setToDirective(params) {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetEventsToJobsScroll", { params: params });
	      });
	    }
	  }, {
	    key: "jobDropDownBlur",
	    value: function jobDropDownBlur() {
	      var _this = this;
	      _this.$timeout(function () {
	        $(".hidden-drop-down").hide("slide", { direction: "up" }, 100);
	        _this.showJobsDropDown = false;
	      }, 300);
	    }
	  }, {
	    key: "jobDropDownFocus",
	    value: function jobDropDownFocus() {
	      var _this = this;
	    }
	  }, {
	    key: "jobDropDownHover",
	    value: function jobDropDownHover() {
	      var _this = this;
	      _this.showJobScroll();
	    }
	  }, {
	    key: "jobDropDownLeave",
	    value: function jobDropDownLeave() {
	      var _this = this;
	      _this.showJobScroll();
	    }
	  }, {
	    key: "reportHeaderDropDownClick",
	    value: function reportHeaderDropDownClick(link) {
	      var _this = this;
	      var data = {};
	      if (_this.currentUser) {
	        data.user = _this.currentUser.email;
	      } else {
	        data.user = "Unregistered";
	      }
	      switch (link) {
	        case 1:
	          data.button = "Account";
	          return;
	        case 2:
	          data.button = "Direct Pay";
	          return;
	        case 3:
	          data.button = "Help Center";
	          return;
	        case 4:
	          data.button = "Logout";
	          return;
	      }
	      _this.$tracking.reportHeaderMenuInteraction(data);
	    }
	  }, {
	    key: "send_to_basic_profile",
	    value: function send_to_basic_profile() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("#finishing-steps").modal("toggle");
	      });
	      _this.$timeout(function () {
	        _this.$state.go("jobbler", {});
	      }, 300);
	    }
	  }, {
	    key: "checkAccountType",
	    value: function checkAccountType() {
	      var _this = this;
	      var cid = _this.currentUser.company.id;
	      if (cid) {
	        if (_this.currentUser.company.industryType) {
	          var industry_type_id = _this.currentUser.company.industryType.id;
	          if (industry_type_id) {
	            _this.currentUser.company.industry = "Delivery";
	          } else {
	            console.log("we do not have an industry type");
	          }
	        }
	      }
	    }
	  }, {
	    key: "rotate",
	    value: function rotate() {
	      var _this = this;
	      _this.$timeout(function () {
	        $(".main-menu ul li a i").toggleClass("down");
	      });
	    }
	  }, {
	    key: "checkAgreementStatus",
	    value: function checkAgreementStatus(user) {
	      if (this.$state.current.name !== "signon") {
	        if (user.acceptedCookiePolicy === null || user.acceptedPrivacyPolicy === null) {
	          this.$timeout(function () {
	            $("#agree-to-terms").modal({
	              backdrop: "static",
	              keyboard: false
	            });
	          });
	        } else if (user.acceptedCookiePolicy === null) {
	          this.$timeout(function () {
	            $("#agree-to-terms").modal({
	              backdrop: "static",
	              keyboard: false
	            });
	          });
	        }
	      }
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "getUpdatedUser",
	    value: function getUpdatedUser() {
	      var _this10 = this;
	
	      this.$auth.refreshCurrentUser().then(function () {
	        _this10.$timeout(function () {
	          _this10.currentUser = _this10.$auth.getUserData();
	        });
	      });
	    }
	  }, {
	    key: "userAcceptsTOS",
	    value: function userAcceptsTOS(result, closeForm) {
	      var _this11 = this;
	
	      var _this = this;
	
	      _this.setLoader();
	
	      var payload = {};
	
	      payload.acceptedPrivacyPolicy = result;
	      payload.acceptedCookiePolicy = result;
	
	      _this.$profile.saveUser(payload).then(function (response) {
	        _this.unSetLoader();
	
	        if (closeForm) {
	          if (result === false) {
	            _this.$timeout(function () {
	              $("#opt-out").modal("toggle");
	            });
	          } else {
	            _this.$timeout(function () {
	              $("#opt-in").modal("toggle");
	            });
	          }
	
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("UpdatePrefenceUI", result);
	          });
	        } else {
	          _this.$timeout(function () {
	            $("#agree-to-terms").modal("toggle");
	          });
	        }
	
	        _this.getUpdatedUser();
	      }, function (error) {
	        _this11.unSetLoader();
	
	        if (closeForm) {
	          if (result === false) {
	            _this.$timeout(function () {
	              $("#opt-out").modal("toggle");
	            });
	          } else {
	            _this.$timeout(function () {
	              $("#out-in").modal("toggle");
	            });
	          }
	        } else {
	          _this.$timeout(function () {
	            $("#agree-to-terms").modal("toggle");
	          });
	        }
	      });
	    }
	  }, {
	    key: "userDeclinesTOS",
	    value: function userDeclinesTOS() {}
	  }, {
	    key: "validateTOS",
	    value: function validateTOS() {
	      var _this = this;
	
	      var result = false;
	
	      if (_this.currentUser.email === _this.tosEmail) {
	        result = true;
	      }
	
	      return result;
	    }
	  }, {
	    key: "optOut",
	    value: function optOut() {
	      var _this = this;
	
	      var validate = _this.validateTOS();
	
	      if (validate) {
	        _this.userAcceptsTOS(false, true);
	      } else {
	        alert("Please provide your correct email.");
	      }
	    }
	  }, {
	    key: "optIn",
	    value: function optIn() {
	      var _this = this;
	
	      var validate = _this.validateTOS();
	
	      if (validate) {
	        _this.userAcceptsTOS(true, true);
	      } else {
	        alert("Please provide your correct email.");
	      }
	    }
	  }, {
	    key: "determineWhereToGo",
	    value: function determineWhereToGo() {
	      if (this.currentUser) {
	        if (this.currentUser.company === null) {
	          this.$state.go("jobs");
	        } else {
	          this.$state.go("jobs-dashboard");
	        }
	      } else {
	        this.$state.go("signin");
	      }
	    }
	  }, {
	    key: "changePage",
	    value: function changePage(page) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetSignOnPage", page);
	      });
	    }
	  }, {
	    key: "showLoginOptions",
	    value: function showLoginOptions() {
	      this.$timeout(function () {
	        $(".pb-nav.header-section .sign-in-header").show("slide", { direction: "up" }, 100);
	      });
	
	      this.$timeout(function () {
	        $(".pb-nav.header-section .sign-in-header").focus();
	      }, 100);
	    }
	  }, {
	    key: "sendUserToSignIn",
	    value: function sendUserToSignIn(type) {
	      this.$timeout(function () {
	        $(".pb-nav.header-section .sign-in-header").hide();
	      });
	
	      if (this.$state.current.name === "signon") {
	        this.$location.url("/signin");
	        return;
	      }
	
	      if (type === "jobbler") {
	        this.$location.url("/signon?accountType=jobbler&action=signin");
	      } else {
	        // Remove 3rd party option for companies
	        // this.$location.url("/signon?accountType=business&action=signin");
	        this.$location.url("/signin");
	      }
	    }
	  }, {
	    key: "sendToPostAJob",
	    value: function sendToPostAJob() {
	      this.$state.go("postashiftwalkthrough");
	    }
	  }, {
	    key: "menuBlur",
	    value: function menuBlur() {
	      this.$timeout(function () {
	        $(".pb-nav.header-section .sign-in-header").hide();
	      });
	    }
	  }, {
	    key: "determineBillingPage",
	    value: function determineBillingPage() {
	      var _this = this;
	
	      _this.setLoader();
	
	      _this.$auth.getCompanyPlan().then(function (response) {
	        _this.unSetLoader();
	
	        var isAdmin = _this.$auth.isAdmin();
	        var enableSubscription = response.data.company.enableSubscription;
	
	        if (enableSubscription === true && isAdmin === true) {
	          _this.$state.go("billing");
	        } else {
	          _this.$state.go("billing");
	          //_this.$state.go("transactionhistory");
	        }
	      }, function (error) {
	        _this.unSetLoader();
	      });
	    }
	  }]);
	
	  return PbheaderController;
	}();
	
	PbheaderController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "tracking", "$rootScope", "$scope", "$location", "$timeout", "$window", "companies", "messagingv2", "profile", "events", "$interval"];
	
	exports.default = PbheaderController;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(229);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".pb-nav{padding:14px 24px;position:fixed;top:0;z-index:1000;width:100%}.pb-nav,.pb-nav-height{height:78px}.pb-nav .logo img{height:50px}.pb-nav .logo.mobile{display:none}@media only screen and (max-width:768px){.pb-nav .logo.mobile{display:inherit;width:48px}}@media only screen and (max-width:768px){.pb-nav .job-search-container .job-search-term-container i,.pb-nav .logo.desktop{display:none}}.pb-nav.header-section .sign-in-header{position:absolute;display:none;right:0;width:156px;height:110px;top:82px;border-top:.5px solid #ddd}.pb-nav.header-section .sign-in-header:focus{outline:none}button.post-a-job-button{font-size:14px;font-weight:900;letter-spacing:0;color:#fff;text-transform:uppercase;padding:7px 20px 10px;border-radius:5px;border:none;font-family:Poppins;background:linear-gradient(270deg,#74cf59,#5498b4)}button.post-a-job-button:hover{background:#74cf59;box-shadow:inset 0 30px 60px -12px rgba(50,50,93,.25),inset 0 18px 36px -18px rgba(0,0,0,.3)}.pb-nav.header-section .sign-in-header:after,.pb-nav.header-section .sign-in-header:before{content:\"\";position:absolute;bottom:100%;right:40px;border:11px solid transparent;border-bottom-color:#ddd}.pb-nav.header-section .sign-in-header:after{right:41px;border:10px solid transparent;border-bottom-color:#fff}.pb-nav.header-section .sign-in-header ul li{padding-left:24px;padding-top:9px;padding-bottom:10px;color:#5e666d;font-family:Poppins;font-size:12px;font-weight:600;letter-spacing:0;line-height:32px;background-color:#fff}.pb-nav.header-section .sign-in-header ul li:hover{cursor:pointer;background-color:#e3ebef;color:#33373a}.pb-nav.header-section .sign-in-header ul li:first-child{border-top-left-radius:0;border-top-right-radius:0;border-left:.5px solid #ddd;border-right:.5px solid #ddd;border-bottom:.5px solid #ddd;box-shadow:0 25px 50px 0 rgba(78,81,144,.07)}.pb-nav.header-section .sign-in-header ul li:last-child{border-bottom-left-radius:6px;border-bottom-right-radius:6px;border-left:.5px solid #ddd;border-right:.5px solid #ddd;border-bottom:.5px solid #ddd;box-shadow:0 25px 50px 0 rgba(78,81,144,.07)}.pb-nav.header-section .sign-in-header ul li:active{font-weight:700;border:1px solid #5e666d}.pb-nav .main-menu ul li a{display:block;text-decoration:none;text-transform:uppercase;letter-spacing:.5px;transition:none;color:#5e666d;font-family:Poppins,sans-serif;font-size:14px;font-weight:600;line-height:18px;margin-top:4px}.pb-nav .job-search-container{margin-top:8px;height:34px;display:flex;width:521px;margin-left:32px}.pb-nav .job-search-container.mobile{display:none}@media only screen and (max-width:768px){.pb-nav .job-search-container{width:300px;margin-left:0;display:none}.pb-nav .job-search-container.mobile{display:block}}@media only screen and (max-width:414px){.pb-nav .job-search-container{width:280px}}@media only screen and (max-width:375px){.pb-nav .job-search-container{width:245px}}@media only screen and (max-width:320px){.pb-nav .job-search-container{width:216px}}.pb-nav .job-search-container .job-search-term-container{flex:1;position:relative}.pb-nav .job-search-container .zip-code-container{flex:0 0 201px;position:relative}.pb-nav .job-search-container .button-container{flex:0 0 34px}.pb-nav .job-search-container input{height:100%;width:100%;padding-left:43px;border:1px solid #adbcc2;color:#767676;font-family:Poppins,sans-serif;font-size:12px;letter-spacing:0}.pb-nav .job-search-container .job-search-term-container input{border-radius:6px 0 0 6px;box-shadow:0 2px 4px #00000020;padding-left:46px}.pb-nav .job-search-container .job-search-term-container input:focus,.pb-nav .job-search-container .zip-code-container input:focus{border:2px solid #adbcc2}.pb-nav .job-search-container .job-search-term-container i{position:absolute;left:16px;height:14px;top:10px;color:#5e666d}.pb-nav .job-search-container .job-search-term-container .mobile-search{display:none}@media only screen and (max-width:768px){.pb-nav .job-search-container .job-search-term-container .desktop-search{display:none}.pb-nav .job-search-container .job-search-term-container input{padding-left:10px}.pb-nav .job-search-container .job-search-term-container .mobile-search{display:block}}.pb-nav .job-search-container .zip-code-container input{border-left:none;border-right:none;padding-left:44px;box-shadow:0 2px 4px #00000020}.pb-nav .job-search-container .zip-code-container i{position:absolute;left:16px;height:14px;top:10px;color:#5e666d}@media only screen and (max-width:768px){.pb-nav .job-search-container input{padding-left:16px}.pb-nav .job-search-container .job-search-term-container o{display:none}}@media only screen and (max-width:768px){.pb-nav .job-search-container .zip-code-container{flex:1}.pb-nav .job-search-container .zip-code-container input{padding-left:10px}.pb-nav .job-search-container .zip-code-container i{display:none}}.pb-nav .job-search-container button{width:100%;height:100%;background:#5e666d;box-shadow:0 2px 4px #00000020;border-radius:0 6px 6px 0;padding:8px}.pb-nav .job-search-container input::-webkit-input-placeholder,.pb-nav .job-search-container input:focus::-webkit-input-placeholder{color:#adbcc2}.pb-nav .navbar-toggle .icon-bar{background-color:#5e666d}.pb-nav-mobile.mobile-menu-wrap{z-index:1001}.user-avatar.dropdown-toggle.no-border{border:none}.pb-nav .user-avatar{padding-right:0;background-size:cover;background-position:50% 50%;background-repeat:no-repeat;border-radius:100%;height:42px!important;width:42px!important;border:1px solid #62c046;margin-top:0!important}.pb-nav .user-avatar i{color:#5e666d;font-size:20px;position:absolute;top:9px;left:11px}.header-right.pull-right .user-login.dropdown.pull-right.new-dropdown{padding-top:4px}.user-login.dropdown.pull-right.new-dropdown:hover{border-bottom:2px solid #74cf59;cursor:pointer}.pb-nav .user-avatar i:hover{pointer:cursor}.pb-nav .user-login .dropdown{width:205px;border:1px solid #adbcc2;border-radius:6px;background-color:#fff;box-shadow:0 2px 5px 0 rgba(0,0,0,.2);margin:9px 0;padding:24px;right:-24px;-webkit-transition:all 3s cubic-bezier(0,0,.2,1) 0s}.pb-nav .profile-img{border-radius:100%;height:42px!important;width:42px!important;border:1px solid #62c046;margin-top:0!important}.pb-nav .user-login .dropdown li a{background-color:#fff;color:#5e666d;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;letter-spacing:.1px;line-height:18px;padding-top:5px;padding-bottom:5px}.pb-nav .user-login .dropdown li a:hover{border-bottom:2px solid #74cf59;padding-bottom:3px}.pb-nav .user-login .dropdown li a i{float:right;line-height:18px}.pb-nav .user-login .dropdown:after{display:none;-webkit-transition:all 3s cubic-bezier(0,0,.2,1) 0s}.pb-nav .user-avatar:after{display:none}.pb-nav .header-right{height:100%;position:relative}.pac-container:after{background-image:none!important;height:0}.pb-nav .mobile-location-search{height:100vh;position:fixed;width:100vw;top:0;left:0;z-index:1000;padding:16px;background:#fff;display:none}.pb-nav .mobile-location-search.show{display:block}.pb-nav .mobile-location-search .input-container{position:relative}.pb-nav .mobile-location-search input{height:34px;line-height:24px;width:100%;padding-left:46px;border:1px solid #adbcc2;border-radius:6px;color:#3b3f43;font-family:Poppins,sans-serif;font-size:14px;letter-spacing:0;margin-bottom:16px;box-shadow:inset 0 0 4px 0 rgba(0,0,0,.1)}.pb-nav .mobile-location-search .input-container i{position:absolute;left:0;padding-left:16px;height:34px;top:0;padding-top:8px;width:46px;color:#767c84;font-size:18px;letter-spacing:0;line-height:18px}.pb-nav .mobile-location-search .term-container{flex:1}.pb-nav .mobile-location-search .term-container input{border-radius:6px 0 0 6px;border-right:none}.pb-nav .mobile-location-search button{width:100%;height:34px;background:#5e666d;border-radius:0 6px 6px 0;padding:8px;box-shadow:inset 0 0 4px 0 rgba(0,0,0,.1)}@media only screen and (max-width:991px) and (min-width:768px){.main-menu{display:block;background:none;z-index:999;width:fit-content;position:relative;float:right;left:auto;top:auto;border-bottom:none}}@media only screen and (max-width:995px) and (min-width:768px){.pb-nav .job-search-container{width:450px}}@media only screen and (max-width:920px) and (min-width:768px){.pb-nav .job-search-container{width:370px}.pb-nav .job-search-container .job-search-term-container input,.pb-nav .job-search-container .zip-code-container input{padding-left:25px}.pb-nav .job-search-container .job-search-term-container i,.pb-nav .job-search-container .zip-code-container i{left:7px}.pb-nav .job-search-container .zip-code-container{flex:0 0 140px}}@media only screen and (max-width:840px) and (min-width:768px){.pb-nav .job-search-container{width:293px}}", ""]);
	
	// exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pjheader = __webpack_require__(231);
	
	var _pjheader2 = _interopRequireDefault(_pjheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pbheaderModule = _angular2.default.module("pjheader", [_angularUiRouter2.default]).component("pjheader", _pjheader2.default);
	
	exports.default = pbheaderModule;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pjheader = __webpack_require__(232);
	
	var _pjheader2 = _interopRequireDefault(_pjheader);
	
	var _pjheader3 = __webpack_require__(233);
	
	var _pjheader4 = _interopRequireDefault(_pjheader3);
	
	__webpack_require__(234);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pjheaderComponent = {
	  restrict: "E",
	  bindings: {
	    jobble: "=",
	    event: "="
	  },
	  template: _pjheader2.default,
	  controller: _pjheader4.default,
	  controllerAs: "vm"
	};
	
	exports.default = pjheaderComponent;

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pb-nav-height\"></div>\n\n<div class=\"mobile-menu-wrap pb-nav-mobile\">\n\n    <!--mobile-menu-closed-->\n    <a href=\"#\" class=\"navbar-close\" ng-click=\"vm.closeSideBar()\">\n        <div class=\"icon-bar-box\">\n            <span class=\"icon-bar\"></span>\n            <span class=\"icon-bar\"></span>\n        </div>\n    </a>\n    <!--mobile-menu-closed-->\n\n    <!--mobile-nav-->\n    <div class=\"mobile-nav mobile-nav-company\" ng-if=\"!vm.isJobSeeker\">\n        <ul>\n            <li><a href=\"/post-a-shift/walkthrough\">Post Job</a></li>\n            <li><a href=\"/events\">Jobs</a></li>\n            <li><a href=\"/events-history\">History</a></li>\n            <li><a href=\"/teams\">Teams</a></li>\n            <li><a href=\"/inbox\">Messages</a></li>\n            <li><a href=\"\" ng-click=\"vm.signOut()\">Logout</a></li>\n        </ul>\n    </div>\n\n    <div class=\"mobile-nav mobile-nav-jobbler\" ng-if=\"vm.isJobSeeker\">\n        <ul>\n            <li><a href=\"/jobs\">Jobble Board</a></li>\n            <li><a href=\"/jobbler/{{vm.currentUser.id}}\" ng-if=\"vm.currentUser\">Profile</a></li>\n            <li>\n                <a href=\"/signin\" ng-if=\"!vm.currentUser\">Login</a>\n            </li>\n            <!--<li><a href=\"#\" ng-click=\"vm.goToProfile()\" ng-if=\"vm.currentUser\">Profile</a></li>-->\n            <li><a href=\"#\" ng-click=\"vm.signOut()\" ng-if=\"vm.currentUser\">Log out</a></li>\n        </ul>\n    </div>\n    <!--mobile-nav-->\n</div>\n\n<header class=\"header-section clearfix pb-nav\" ng-if=\"!vm.isJobSeeker\">\n\n    <div class=\"noti-message\" ng-if=\"vm.showNoti\">\n        <div class=\"noti-message-left\" ng-click=\"vm.closeNoti(1)\">\n            x\n        </div>\n        <div class=\"noti-message-right\">\n            Message sent\n        </div>\n    </div>\n\n    <div class=\"noti-message\" style=\"width: 15%;\" ng-if=\"vm.showAuto\">\n        <div class=\"noti-message-left\" ng-click=\"vm.closeAutoSave()\">\n            x\n        </div>\n        <div class=\"noti-message-right\">\n            Saving Progress...\n        </div>\n    </div>\n\n    <div class=\"logo pull-left\">\n        <!--logo-->\n        <div class=\"logo\">\n            <a href=\"/jobs-dashboard\">\n                <img src=\"app/vendor/images/jobble-logo-300-dpi.png\" alt=\"Jobble Biz\" title=\"Jobble Biz\"></a>\n        </div>\n\n        <!--logo-->\n    </div>\n\n    <div class=\"header-right pull-right\">\n\n        <button class=\"navbar-toggle menu-toggle\" type=\"button\" ng-click=\"vm.slideToggle()\">\n            <span class=\"sr-only\">Toggle navigation</span>\n            <span class=\"icon-bar\"></span>\n            <span class=\"icon-bar\"></span>\n            <span class=\"icon-bar\"></span>\n        </button>\n\n        <div class=\"user-login dropdown pull-right new-dropdown\">\n\n            <a href=\"#\"\n               class=\"user-avatar dropdown-toggle no-border\"\n               data-toggle=\"dropdown\"\n               aria-haspopup=\"true\"\n               aria-expanded=\"true\">\n                <i class=\"fas fa-bars menu-drop-down-cog\" style=\"color:#33373A;\"></i>\n            </a>\n\n            <ul class=\"dropdown-menu dropdown\" aria-labelledby=\"dropdownMenu1\">\n                <li><a href=\"/account-profile\" ng-click=\"vm.reportHeaderDropDownClick(1)\">Account</a></li>\n                <li><a href=\"/direct-pay\" ng-click=\"vm.reportHeaderDropDownClick(2)\">Direct Pay</a></li>\n                <li><a href=\"https://jobble.com/help/business\"\n                       ng-click=\"vm.reportHeaderDropDownClick(3)\" target=\"_blank\" rel=\"noopener\">Help Center</a></li>\n                <!--<li><a ng-if=\"vm.currentUser.adminRole\" href=\"/admin-dash\" ng-click=\"vm.reportHeaderDropDownClick4)\">Log Out</a></li>-->\n                <li><a style=\"margin-bottom: 0px\" href=\"\" ng-click=\"vm.signOut(true); vm.reportHeaderDropDownClick(4)\">Log\n                    Out</a></li>\n            </ul>\n\n        </div>\n\n\n        <nav class=\"main-menu pull-right\" style=\"position:relative;\">\n            <ul>\n                <!--\n                <li class=\"selected\" ng-if=\"vm.currentUser.isAdmin\">\n                    <a href=\"#\"\n                       ng-click=\"vm.go_to_bulk_upload_jobs_page(); vm.$tracking.reportPostAJobClick('bulk upload');\"\n                       class=\"save-and-exit-button\"\n                       style=\"color: white;background: black;border: black 2px solid;\"\n                    >\n                        Bulk Upload Jobs\n                    </a>\n                </li>\n                -->\n                <li class=\"selected\">\n                    <a href=\"#\"\n                       ng-click=\"vm.saveAndExit(); vm.$tracking.reportPostAJobClick('save & exit');\"\n\n                       ng-class=\"vm.validateEvent()\"\n                       class=\"save-and-exit-button\"\n                    >\n                        Save & exit\n                    </a>\n                </li>\n            </ul>\n        </nav>\n\n    </div>\n\n\n</header>\n\n\n<header class=\"header-section clearfix pb-nav\" ng-if=\"vm.isJobSeeker\">\n\n    <div\n            ng-class=\"{'noti-message-application-error':vm.appError,'noti-message-application-success':!vm.appError}\"\n            ng-if=\"vm.applicationText\">\n        <div class=\"noti-message-left\" ng-click=\"vm.closeNotiApp()\">x</div>\n        <div class=\"noti-message-right\">{{ vm.applicationText }}</div>\n        <div class=\"noti-message-full\">\n            <a href=\"#\" ng-click=\"vm.moreInfoModal()\">Click here for more information</a>\n        </div>\n        <!--\n        <div class=\"noti-message-full\">\n            <a href=\"#\" ng-click=\"vm.moreInfoModal()\">Finish basic profile</a>\n        </div>\n        -->\n    </div>\n\n    <div class=\"logo pull-left\">\n        <!--logo-->\n        <div class=\"logo mobile\">\n            <a>\n                <img src=\"app/vendor/images/jobble-mobile-logo-300-dpi.png\" alt=\"Jobble Logo\" title=\"Jobble Logo\">\n            </a>\n        </div>\n        <!--logo-->\n        <!--logo-->\n        <div class=\"logo desktop\">\n            <a ng-click=\"vm.determineWhereToGo()\">\n                <img src=\"app/vendor/images/jobble-logo-300-dpi.png\" alt=\"Jobble Logo\" title=\"Jobble Logo\"></a>\n            </a>\n        </div>\n        <!--logo-->\n    </div>\n\n    <div class=\"pull-left\">\n        <div class=\"job-search-container\">\n            <div class=\"job-search-term-container\">\n                <input class=\"desktop-search\" ng-model=\"vm.searchTerm\" ng-keyup=\"vm.submitOnEnter($event)\"\n                       placeholder=\"Search job title or keyword\"/>\n                <input class=\"mobile-search\" ng-model=\"vm.searchTerm\" ng-keyup=\"vm.submitOnEnter($event)\"\n                       placeholder=\"Search job\"/>\n                <i class=\"fas fa-search\"></i>\n            </div>\n            <div class=\"zip-code-container\">\n                <i class=\"fas fa-map-marker-alt\"></i>\n                <input ng-model=\"vm.location\"\n                       id=\"location-search\"\n                       placeholder=\"Enter a location\"/>\n            </div>\n            <div class=\"button-container\">\n                <button ng-click=\"vm.querySearch()\" class=\"button\">\n                    <i class=\"fas fa-search\"></i>\n                </button>\n            </div>\n        </div>\n        <div class=\"job-search-container mobile\">\n            <div style=\"display: flex\">\n                <div class=\"job-search-term-container\">\n                    <input class=\"mobile-search\" placeholder=\"Job title or company\" value=\"{{vm.searchTerm}}\"\n                           ng-click=\"vm.toggleMobile()\"/>\n                    <i class=\"fas fa-search\"></i>\n                </div>\n                <div class=\"button-container\">\n                    <button ng-click=\"vm.querySearch()\" class=\"button\">\n                        <i class=\"fas fa-search\"></i>\n                    </button>\n                </div>\n            </div>\n            <div class=\"mobile-location-search\" ng-class=\"{'show': vm.showMobileModal}\">\n                <div style=\"display: flex\">\n                    <div class=\"input-container term-container\">\n                        <input placeholder=\"Job title or company\" ng-model=\"vm.searchTerm\"\n                               ng-keyup=\"vm.submitOnEnter($event, true)\" id=\"mobile-term\"/>\n                        <i class=\"fas fa-chevron-left\" ng-click=\"vm.toggleMobile()\"></i>\n                    </div>\n                    <div class=\"button-container\">\n                        <button ng-click=\"vm.querySearch(); vm.toggleMobile()\" class=\"button\">\n                            <i class=\"fas fa-search\"></i>\n                        </button>\n                    </div>\n                </div>\n                <div class=\"input-container\">\n                    <i class=\"fas fa-map-marker-alt\"></i>\n                    <input ng-model=\"vm.location\"\n                           id=\"mobile-location-search\"\n                           placeholder=\"Enter a location\"/>\n                </div>\n            </div>\n\n        </div>\n    </div>\n\n    <div class=\"header-right pull-right\">\n\n        <button class=\"navbar-toggle\" type=\"button\" ng-click=\"vm.slideToggle()\">\n            <span class=\"sr-only\">Toggle navigation</span>\n            <span class=\"icon-bar\"></span>\n            <span class=\"icon-bar\"></span>\n            <span class=\"icon-bar\"></span>\n        </button>\n\n        <div ng-if=\"vm.currentUser\" class=\"user-login dropdown pull-right\">\n\n            <a\n                    href=\"#\"\n                    class=\"user-avatar dropdown-toggle\"\n                    id=\"dropdownMenu1\"\n                    data-toggle=\"dropdown\"\n                    aria-haspopup=\"true\"\n                    aria-expanded=\"true\"\n                    style=\"background-image: url({{($root.imgFromProfilePage || (vm.currentUser.profilePictureUri ? vm.currentUser.profilePictureUri : '/app/vendor/images/user-more.png'))}})\"/>\n            </a>\n            <ul class=\"dropdown-menu dropdown\" aria-labelledby=\"dropdownMenu1\" ng-if=\"!vm.currentUser\">\n                <li><a href=\"/signup/jobbler\">Register</a></li>\n                <li><a style=\"margin-bottom: 0px\" href=\"/signin\">Login</a></li>\n            </ul>\n            <ul class=\"dropdown-menu dropdown\" aria-labelledby=\"dropdownMenu1\" ng-if=\"vm.currentUser\">\n                <li><a href=\"/jobbler/{{vm.currentUser.id}}\" ng-if=\"vm.currentUser\">Profile <i\n                        class=\"fas fa-angle-double-right\"></i></a></li>\n                <li><a href=\"https://jobble.com/help/jobbler/\" target=\"_blank\"\n                       ng-if=\"vm.currentUser\">Resource Center <i class=\"fas fa-angle-double-right\"></i></a></li>\n                <li><a href=\"https://apps.apple.com/us/app/jobble/id961838757\" target=\"_blank\" ng-if=\"vm.currentUser\">Get\n                    the app <i class=\"fas fa-angle-double-right\"></i></a></li>\n                <li><a style=\"margin-bottom: 0px\" href=\"\" ng-click=\"vm.signOut()\">Log out</a></li>\n            </ul>\n\n        </div>\n\n        <nav class=\"main-menu pull-right\">\n            <ul>\n\n                <li ng-hide=\"!vm.currentUser\">\n                    <!--<a href=\"/jobs\">\n                        &lt;!&ndash;<i class=\"fa fa-list-ul\" aria-hidden=\"true\"></i> &ndash;&gt;\n                        Jobble Board\n                    </a>-->\n                </li>\n\n                <li ng-hide=\"vm.currentUser\">\n                    <a href=\"/signup/company\">b</a>\n                </li>\n\n                <li ng-hide=\"vm.currentUser\">\n                    <a href=\"/signup/jobbler\">Jobbler Sign Up</a>\n                </li>\n                <li ng-hide=\"vm.currentUser\">\n                    <a href=\"/signin\">Log in</a>\n                </li>\n\n\n            </ul>\n        </nav>\n\n    </div>\n\n</header>\n\n<div class=\"modal fade\" id=\"funnel-user-to-app\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header popup-header\">\n\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times-circle\"></i>\n                        </button>\n\n                        <img style=\"width: 47px;\" src=\"/app/vendor/images/clock-with-shadow.png\"/>\n\n                        <h3 class=\"modal-title\" style=\"border-bottom: 1px solid #eee;padding-bottom:15px;\">\n                            Feature not available\n                        </h3>\n\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"row\">\n                            <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                                <p>This feature is currently not available.</p>\n                                <p>We are working hard to get this feature on our web app. Please check back later or\n                                    download\n                                    our mobile app to access all of our features.</p>\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col-lg-12 col-md-12 col-sm-12\" style=\"padding-bottom:20px;\">\n                                <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                                    <a href=\"https://itunes.apple.com/us/app/jobble/id961838757?mt=8\" target=\"_blank\"\n                                       rel=\"noopener\">\n                                        <img src=\"/app/vendor/images/App_Store.png\"/>\n                                    </a>\n                                </div>\n                                <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                                    <a href=\"https://play.google.com/store/apps/details?id=com.jobble.jobble&hl=en\"\n                                       target=\"_blank\" rel=\"noopener\">\n                                        <img src=\"/app/vendor/images/Google_Play.png\"/>\n                                    </a>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal fade\" id=\"finishing-steps\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content next-steps-image\">\n                    <div class=\"modal-header popup-header\">\n                        <h3 class=\"modal-title\"></h3>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"row\">\n                            <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                                <img src=\"/app/vendor/images/flow.png\"/>\n                                <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                                    <i class=\"fa fa-times-circle\"></i>\n                                </button>\n                                <a href=\"#\" ng-click=\"vm.send_to_basic_profile()\" class=\"funnel-link\">Finish your basic\n                                    profile</a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n<div\n        class=\"modal fade\"\n        id=\"agree-to-terms\"\n        tabindex=\"-1\"\n        role=\"dialog\"\n        aria-labelledby=\"modal-add-projectLabel\"\n        data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content next-steps-image\">\n                    <div class=\"modal-header popup-header\">\n                        <h3 class=\"modal-title\">Jobble Terms of Service</h3>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"row\">\n                            <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                                <p>\n                                    We’ve updated our <a class=\"policy\" href=\"https://jobble.com/terms-of-service/\"\n                                                         target=\"_blank\">Terms of Service</a>, <a class=\"policy\"\n                                                                                                  href=\"https://kb.jobble.com/privacy/\"\n                                                                                                  target=\"_blank\">Privacy\n                                    Policy</a>, and <a class=\"policy\" href=\"https://stripe.com/connect-account/legal\"\n                                                       target=\"_blank\">Stripe Connected Account Agreement</a>. Please\n                                    take a moment to review. To continue using our services, you need to accept these\n                                    updates.</p>\n                                <div>\n                                    <a class=\"btn button btn-success\" ng-click=\"vm.userAcceptsTOS(true,null)\">\n                                        Accept\n                                    </a>\n                                </div>\n                                <div style=\"margin-top: 10px;\">\n                                    <a ng-click=\"vm.userAcceptsTOS(false,null)\" href=\"\">\n                                        Decline\n                                    </a>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div\n        class=\"modal fade\"\n        id=\"opt-out\"\n        tabindex=\"-1\"\n        role=\"dialog\"\n        aria-labelledby=\"modal-add-projectLabel\"\n        data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content next-steps-image\">\n                    <div class=\"modal-header popup-header\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times-circle\"></i>\n                        </button>\n\n                        <h3 class=\"modal-title\">Opt Out of Privacy Policy</h3>\n\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"row\">\n\n                            <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                                <p>Please fill out this form to opt out</p>\n\n                                <form class=\"form-section\" style=\"text-align:left;\" ng-submit=\"vm.optOut()\">\n                                    <label>First name</label>\n                                    <input type=\"text\" class=\"form-control form-input\"/>\n                                    <label>Last name</label>\n                                    <input type=\"text\" class=\"form-control form-input\"/>\n                                    <label>Email</label>\n                                    <input type=\"email\" class=\"form-control form-input\" ng-model=\"vm.tosEmail\"/>\n                                    <input type=\"submit\" value=\"Submit\" class=\"btn btn-success\"/>\n                                </form>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div\n        class=\"modal fade\"\n        id=\"opt-in\"\n        tabindex=\"-1\"\n        role=\"dialog\"\n        aria-labelledby=\"modal-add-projectLabel\"\n        data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content next-steps-image\">\n                    <div class=\"modal-header popup-header\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times-circle\"></i>\n                        </button>\n\n                        <h3 class=\"modal-title\">Opt in of Privacy Policy</h3>\n\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"row\">\n\n                            <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                                <p>Please fill out this form to opt in</p>\n\n                                <form class=\"form-section\" style=\"text-align:left;\" ng-submit=\"vm.optIn()\">\n                                    <label>First name</label>\n                                    <input type=\"text\" class=\"form-control form-input\"/>\n                                    <label>Last name</label>\n                                    <input type=\"text\" class=\"form-control form-input\"/>\n                                    <label>Email</label>\n                                    <input type=\"email\" class=\"form-control form-input\"/>\n                                    <input type=\"submit\" value=\"Submit\" class=\"btn btn-success\"/>\n                                </form>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<track/>"

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _messagingv = __webpack_require__(30);
	
	var _messagingv2 = _interopRequireDefault(_messagingv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PjheaderController = function () {
	  function PjheaderController($http, $localStorage, $state, AuthService, SecurityService, TrackingService, $rootScope, $scope, $location, $timeout, $window, $companies, Messagingv2Service, ProfileService, EventsService, $interval) {
	    var _this2 = this;
	
	    _classCallCheck(this, PjheaderController);
	
	    this.name = "pjheader";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$rootScope = $rootScope;
	    this.$security = SecurityService;
	    this.$window = $window;
	    this.$timeout = $timeout;
	    this.$events = EventsService;
	    this.$profile = ProfileService;
	    this.$scope = $scope;
	    this.showJobsDropDown = false;
	    this.$tracking = TrackingService;
	    this.$messagingv2 = Messagingv2Service;
	    this.$companies = $companies;
	    this.currentUser = this.$auth.getUserData();
	    this.showPostScroll = false;
	    this.showNoti = false;
	    this.$location = $location;
	    this.$interval = $interval;
	    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
	    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;
	
	    var _this = this;
	
	    $rootScope.$watch("$routeChangeStart", function () {
	      _this.setActiveClass();
	      if (!_this.$state.$current.url.sourcePath.includes("messages")) {
	        _this.$rootScope.activeMessages = [];
	        _this.$rootScope.activeChannel = undefined;
	      }
	    });
	
	    if (!this.$rootScope.googleHasLoaded) {
	      this.$rootScope.googleHasLoaded = true;
	    }
	
	    _this.showNotiListener = _this.$rootScope.$on("ShowNoti", function ($event, params) {
	      _this.showNoti = true;
	      _this.$timeout(function () {
	        _this.showNoti = false;
	      }, 2000);
	    });
	
	    _this.updateCurrentUserListener = _this.$rootScope.$on("UpdateCurrentUser", function (event, params) {
	      _this.updateCurrentUser(params);
	    });
	
	    _this.autoSaveListener = _this.$rootScope.$on("AutoSave", function (event, params) {
	      _this.showAuto = true;
	      _this.autoSaveEventAsDraft(params);
	    });
	
	    _this.autoSaveListenerTrigger = _this.$rootScope.$on("AutoSaveTrigger", function (event, params) {
	      if (params.pop === "on") {
	        _this.showAuto = true;
	      } else {
	        _this.showAuto = false;
	      }
	    });
	
	    _this.channelsHaveBeenLoadedListener = _this.$rootScope.$on("channelsHaveBeenLoaded", function ($event, params) {});
	
	    _this.SetProfilePicturePajListener = _this.$rootScope.$on("SetProfilePicturePaj", function ($event, params) {
	      console.log("SetProfilePictureListenerPaj");
	      console.dir(params);
	      console.dir(_this.currentUser);
	      _this.currentUser.company.companyLogoUri = params.picture;
	    });
	
	    _this.ToastMessageListener = _this.$rootScope.$on("ToastMessage", function ($event, params) {
	      _this.toastMessage(params);
	    });
	
	    this.JobSearchQueryParamsListener = _this.$rootScope.$on("JobSearchQueryParams", function ($event, params) {
	      console.log("New params in header", params);
	
	      var desktopInput = document.getElementById("location-search");
	      var mobileInput = document.getElementById("mobile-location-search");
	
	      if (params && params.zipcode && (params.zipcode !== _this2.zipCode || desktopInput.value === "" || desktopInput.value == params.zipcode)) {
	        _this2.setZipCode(params.zipcode).then(function () {
	          _this2.awaitForGoogleToLoad().then(function () {
	            _this2.geocoder = new window.google.maps.Geocoder();
	
	            _this2.geocoder.geocode({ address: "" + params.zipcode }, function (results, status) {
	              if (status === "OK" && results && results.length) {
	                var address = results[0].address_components;
	
	                var city = "";
	                var state = "";
	                var county = "";
	
	                address.forEach(function (a) {
	                  if (a.types.indexOf("locality") !== -1) {
	                    city = a.long_name;
	                  }
	                  if (a.types.indexOf("country") !== -1) {
	                    county = a.long_name;
	                  }
	                  if (a.types.indexOf("administrative_area_level_1") !== -1) {
	                    state = a.short_name;
	                  }
	                });
	
	                console.log("Syncing data in nav bar", city, state, county);
	
	                desktopInput.value = city + ", " + state + ", USA";
	                mobileInput.value = city + ", " + state + ", USA";
	                _this2.setCityStateParams(city, state);
	              }
	            });
	          });
	        });
	      }
	      if (params && params.search) {
	        _this2.setSearchTerm(params.search);
	      }
	    });
	
	    _this.SetNewUserForJobBoardHeaderListener = _this.$rootScope.$on("SetNewUserForJobBoardHeader", function ($event, params) {
	      _this.$timeout(function () {
	        _this.currentUser = params.user;
	        _this.$localStorage.logged_user = params.user;
	      });
	    });
	
	    _this.SetApplyConfirmationListener = _this.$rootScope.$on("SetApplyConfirmation", function ($event, data) {
	      _this.setApplicationStatus(data.params, data.user_not_verified);
	    });
	
	    _this.SignUserOutListener = _this.$rootScope.$on("SignUserOut", function (event, params) {
	      _this.signOut();
	    });
	
	    _this.SetEventsToScrollerListener = _this.$rootScope.$on("SetEventsToScroller", function (event, params) {
	      _this.setToDirective(params);
	    });
	
	    _this.GetLogoListener = _this.$rootScope.$on("GetLogo", function (event, params) {
	      _this.get_logo(params);
	    });
	
	    _this.$scope.$on("$destroy", _this.GetLogoListener);
	    _this.$scope.$on("$destroy", _this.SetEventsToScrollerListener);
	    _this.$scope.$on("$destroy", _this.SetApplyConfirmationListener);
	    _this.$scope.$on("$destroy", _this.SetNewUserForJobBoardHeaderListener);
	    _this.$scope.$on("$destroy", _this.showNotiListener);
	    _this.$scope.$on("$destroy", _this.autoSaveListener);
	    _this.$scope.$on("$destroy", _this.autoSaveListenerTrigger);
	    _this.$scope.$on("$destroy", _this.channelsHaveBeenLoadedListener);
	    _this.$scope.$on("$destroy", _this.SetProfilePicturePajListener);
	    _this.$scope.$on("$destroy", _this.ToastMessageListener);
	    _this.$scope.$on("$destroy", _this.JobSearchQueryParamsListener);
	    _this.$scope.$on("$destroy", _this.updateCurrentUserListener);
	    _this.$scope.$on("$destroy", _this.SignUserOutListener);
	
	    var cycle = function cycle(res, count, max) {
	      return new Promise(function (resolve, reject) {
	        _this2.$messagingv2.getChannelsv1(res.length).then(function (response) {
	          if (response && response.data && response.data.length && count <= max) {
	            cycle([].concat(_toConsumableArray(res), _toConsumableArray(response.data)), count + 1, max).then(function (total) {
	              console.log("TOTAL", total);
	              resolve(total);
	            }).catch(function (err) {
	              reject(err);
	            });
	          } else {
	            console.error("NO MORE", count, max);
	            resolve(res);
	          }
	        }, function (data) {
	          reject(data);
	        });
	      });
	    };
	
	    if (!this.$security.isUndefinedOrNull(this.currentUser)) {
	      if (this.currentUser.company && this.currentUser.company.id) {
	        if (this.$security.isUndefinedOrNull(this.currentUser.company.companyLogoUri) && this.$security.isUndefinedOrNull(this.$rootScope.companyLogoUri)) {
	          this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
	          console.log("not here...11");
	          this.get_logo(this.currentUser);
	        } else {
	          if (this.currentUser.company.companyLogoUri) {
	            console.log("not here 2");
	            this.$rootScope.companyLogoUri = this.currentUser.company.companyLogoUri;
	            this.currentUser.companyProfilePictureUrl = this.currentUser.company.companyLogoUri;
	            this.get_logo(this.currentUser);
	          }
	        }
	
	        _this.isJobSeeker = false;
	        _this.setTeamsToSession();
	        _this.setJobbleTypesToSession();
	      } else {
	        this.checkAgreementStatus(this.currentUser);
	        this.isJobSeeker = true;
	        this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
	      }
	    } else {
	      console.log("here...");
	      this.$rootScope.channelsHaveLoaded = true;
	      this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
	      _this.initUnregisteredUser();
	    }
	  }
	
	  _createClass(PjheaderController, [{
	    key: "setCityStateParams",
	    value: function setCityStateParams(city, state) {
	      this.$location.search("loc", city + "," + state);
	      this.$rootScope.$emit("CityStateSearch", { city: city, state: state });
	    }
	  }, {
	    key: "toggleMobile",
	    value: function toggleMobile() {
	      this.showMobileModal = !this.showMobileModal;
	      this.$timeout(function () {
	        var mobileInput = document.getElementById("mobile-term");
	        if (mobileInput) mobileInput.focus();
	      }, 10);
	    }
	  }, {
	    key: "$onInit",
	    value: function $onInit() {
	      var _this3 = this;
	
	      this.$timeout(function () {
	        _this3.zipCode = _this3.$localStorage.pb_zipCode;
	        _this3.setZipCode(_this3.zipCode);
	      });
	
	      this.awaitForGoogleToLoad().then(function () {
	        _this3.geocoder = new window.google.maps.Geocoder();
	
	        var desktopInput = document.getElementById("location-search");
	
	        var desktopAutocomplete = new google.maps.places.Autocomplete(desktopInput, {
	          types: ["(cities)"],
	          region: "US",
	          componentRestrictions: { country: "us" }
	        });
	
	        google.maps.event.addListener(desktopAutocomplete, "place_changed", function () {
	          return _this3.autoCompleteListener(desktopAutocomplete);
	        });
	
	        var mobileInput = document.getElementById("mobile-location-search");
	
	        var mobileAutocomplete = new google.maps.places.Autocomplete(mobileInput, {
	          types: ["(cities)"],
	          region: "US",
	          componentRestrictions: { country: "us" }
	        });
	
	        google.maps.event.addListener(mobileAutocomplete, "place_changed", function () {
	          return _this3.autoCompleteListener(mobileAutocomplete);
	        });
	      });
	    }
	  }, {
	    key: "autoCompleteListener",
	    value: function autoCompleteListener(autocomplete) {
	      var _this4 = this;
	
	      console.time("zip code extraction");
	
	      if (this.showMobileModal) {
	        this.$timeout(function () {
	          _this4.showMobileModal = false;
	        });
	      }
	
	      var place = autocomplete.getPlace();
	
	      var address = place.address_components;
	
	      if (!address) return;
	
	      var city = "";
	      var state = "";
	      var county = "";
	
	      address.forEach(function (a) {
	        if (a.types.indexOf("locality") !== -1) {
	          city = a.long_name;
	        }
	        if (a.types.indexOf("country") !== -1) {
	          county = a.long_name;
	        }
	        if (a.types.indexOf("administrative_area_level_1") !== -1) {
	          state = a.short_name;
	        }
	      });
	
	      console.log("Setting new place", city, state, county);
	      this.setCityStateParams(city, state);
	
	      this.geocoder.geocode({ address: city + ", " + state }, function (results, status) {
	        if (status === "OK") {
	          var location = results[0].geometry.location;
	
	          var coords = {
	            lat: location.lat(),
	            lng: location.lng()
	          };
	
	          _this4.geocoder.geocode({ latLng: coords }, function (results, status) {
	            var zipCode = "";
	            if (status === "OK") {
	              if (results[0]) {
	                for (var j = 0; j < results[0].address_components.length; j++) {
	                  if (results[0].address_components[j].types[0] == "postal_code") {
	                    zipCode = results[0].address_components[j].short_name;
	                  }
	                }
	              }
	              if ((!zipCode || zipCode === "") && results[1]) {
	                for (var j = 0; j < results[1].address_components.length; j++) {
	                  if (results[1].address_components[j].types[0] == "postal_code") {
	                    zipCode = results[1].address_components[j].short_name;
	                  }
	                }
	              }
	
	              console.log("New Zip Code", zipCode);
	
	              _this4.setZipCode(zipCode).then(function () {
	                _this4.querySearch();
	              });
	
	              console.timeEnd("zip code extraction");
	            } else {}
	          }, function (error) {});
	        } else {
	          console.error(status);
	        }
	      });
	    }
	  }, {
	    key: "awaitForGoogleToLoad",
	    value: function awaitForGoogleToLoad() {
	      var _this5 = this;
	
	      var count = 0;
	      return new Promise(function (resolve, reject) {
	        if (!_angular2.default.isUndefined(window.google)) return resolve();
	
	        var id = Math.floor(Math.random() * 100000);
	        _this5.goggleLoaders = _this5.goggleLoaders || {};
	        _this5.goggleLoaders[id] = _this5.$interval(function () {
	          count = count + 1;
	          console.warn("Trying to load google", count);
	          if (!_angular2.default.isUndefined(window.google) || count > 5) {
	            resolve();
	            _this5.$interval.cancel(_this5.goggleLoaders[id]);
	            _this5.goggleLoaders[id] = undefined;
	          }
	        }, 500);
	      });
	    }
	  }, {
	    key: "setZipCode",
	    value: function setZipCode(zipCode) {
	      var _this6 = this;
	
	      return new Promise(function (resolve) {
	        _this6.$timeout(function () {
	          _this6.zipCode = zipCode;
	          _this6.$localStorage.pb_zipCode = zipCode;
	          window.jobble_zip_code = zipCode;
	          resolve();
	        });
	      });
	    }
	  }, {
	    key: "submitOnEnter",
	    value: function submitOnEnter(e, mobile) {
	      if (e.keyCode === 13) {
	        this.querySearch();
	        if (mobile) this.toggleMobile();
	      }
	    }
	  }, {
	    key: "setSearchTerm",
	    value: function setSearchTerm(search) {
	      var _this7 = this;
	
	      return new Promise(function (resolve) {
	        _this7.$timeout(function () {
	          _this7.searchTerm = search;
	          _this7.$localStorage.pb_searchTerm = search;
	        });
	
	        resolve();
	      });
	    }
	  }, {
	    key: "querySearch",
	    value: function querySearch() {
	      var _this8 = this;
	
	      var search_data = {};
	
	      var input = document.getElementById("location-search");
	      var mobileInput = document.getElementById("mobile-location-search");
	
	      var zipCodePattern = /^\d{5}$|^\d{5}-\d{4}$/;
	
	      if (input.value && zipCodePattern.test(input.value)) {
	        this.zipCode = input.value;
	      }
	
	      if (mobileInput.value && zipCodePattern.test(mobileInput.value)) {
	        this.zipCode = mobileInput.value;
	      }
	
	      search_data.zip_code = this.zipCode;
	      search_data.type = "text_search";
	      search_data.value = this.searchTerm;
	
	      console.log("search data");
	      console.dir(search_data);
	
	      var tracking_data = {};
	      tracking_data.type = "Job";
	
	      this.currentUser = this.$auth.getUserData();
	
	      if (this.currentUser) {
	        tracking_data.user = this.currentUser.email;
	      } else {
	        tracking_data.user = "Not Logged In";
	      }
	
	      var currentpath = window.location.pathname || "";
	
	      this.$localStorage.pb_searchTerm = this.searchTerm;
	      this.$localStorage.pb_zipCode = this.zipCode;
	
	      if (currentpath.indexOf("jobs") !== -1) {
	        var parcel = {
	          zipcode: search_data.zip_code,
	          type: search_data.type,
	          query: search_data.value
	        };
	        this.$rootScope.$emit("SendSearchParcel", parcel);
	        this.$tracking.reportSubmitSearch("job board", search_data.value, search_data.zip_code);
	      } else {
	        this.$location.path("/jobs").search({
	          t: search_data.type,
	          z: search_data.zip_code,
	          q: search_data.value
	        });
	        this.$tracking.reportSubmitSearch("general", search_data.value, search_data.zip_code);
	      }
	
	      console.log("currentstate", this.$state.current.name);
	
	      if (this.$state.current.name === "jobdetails") {
	        tracking_data.page = "Job Details";
	        this.$tracking.reportJobSearch(tracking_data);
	      } else {
	        this.$timeout(function () {
	          tracking_data.page = "Job Listings";
	          _this8.$tracking.reportJobSearch(tracking_data);
	        });
	      }
	    }
	  }, {
	    key: "slideToggle",
	    value: function slideToggle() {
	      var _this = this;
	      if (_this.isJobSeeker) {
	        _this.$timeout(function () {
	          $(".mobile-menu-wrap").show();
	        });
	      } else {
	        _this.$timeout(function () {
	          $(".mobile-menu-wrap").show();
	        });
	      }
	    }
	  }, {
	    key: "closeSideBar",
	    value: function closeSideBar() {
	      var _this = this;
	      _this.$timeout(function () {
	        $(".mobile-menu-wrap").hide();
	      });
	    }
	  }, {
	    key: "get_logo",
	    value: function get_logo(user) {
	      var _this = this;
	
	      console.log("get_logo 2");
	      console.dir(_this.currentUser);
	
	      if (_this.currentUser) {
	        _this.updateCurrentUser();
	      }
	      _this.$auth.grab_company_logo(user.access_token).then(function (response) {
	        console.log("logo resposne");
	        console.dir(response);
	        var logo = response.data.company.companyLogoUri;
	        _this.set_logo_to_header(logo);
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetLogoToEventsPage", logo);
	        });
	      }, function (error) {
	        console.log("grabbing logo error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "set_logo_to_header",
	    value: function set_logo_to_header(logo) {
	      var _this = this;
	      _this.$timeout(function () {
	        if (_this.currentUser) {
	          _this.currentUser.company.companyLogoUri = logo;
	          _this.$rootScope.companyLogoUri = logo;
	          _this.currentUser.companyProfilePictureUrl = logo;
	        }
	      }, 300);
	    }
	  }, {
	    key: "updateCurrentUser",
	    value: function updateCurrentUser(params) {
	      var _this = this;
	      if (params) {
	        _this.$timeout(function () {
	          _this.currentUser = params.user;
	          _this.$localStorage.logged_user = params.user;
	          if (_this.$rootScope.channels) {
	            _this.$rootScope.channelsHaveLoaded = true;
	          }
	          if (_this.currentUser.company && _this.currentUser.company.id) {
	            _this.isJobSeeker = false;
	          } else {
	            _this.isJobSeeker = true;
	          }
	        }, 300);
	      }
	    }
	  }, {
	    key: "signOut",
	    value: function signOut(manager) {
	      var _this = this;
	      this.$auth.signOut().then(function (response) {
	        _this.$timeout(function () {
	          _this.$tracking.reportUserLogout(_this.$localStorage.logged_user);
	          _this.$localStorage.logged_user = undefined;
	          _this.$rootScope.channels = undefined;
	          _this.$rootScope.companyLogoUri = undefined;
	          _this.$rootScope.inboxLink = undefined;
	          _this.$rootScope.channelsHaveLoaded = undefined;
	          _this.$rootScope.teams = undefined;
	          _this.$rootScope.teamsSimple = undefined;
	          _this.$rootScope.globalParams = undefined;
	          _this.$rootScope.imgFromProfilePage = undefined;
	          _this.$rootScope.jobbleTypes = undefined;
	          _this.$rootScope.jobs = undefined;
	          _this.$rootScope.jobsSeenOnce = undefined;
	          _this.$rootScope.boardParameters = null;
	          _this.$messagingv2.setHandleLastMessageDataCounter(0);
	          _this.$messagingv2.setTotalAmountOfMissedMessages(0);
	
	          _this.$timeout(function () {
	            console.log("LOCAL");
	            console.dir(JSON.stringify(localStorage, null, 4));
	            _this.$location.path(manager ? "/signin" : "/signin");
	          }, 20);
	        });
	      });
	    }
	  }, {
	    key: "goToSomeChat",
	    value: function goToSomeChat(event) {
	      var _this = this;
	      var missedMessagesFound = false;
	      var channelToGoToInURL = undefined;
	      try {
	        for (var i = 0; i < event.channelArrayHolder.length; i++) {
	          if (event.channelArrayHolder[i].missedMessagesCount > 0) {
	            missedMessagesFound = true;
	            channelToGoToInURL = event.channelArrayHolder[i].name;
	            break;
	          }
	        }
	      } finally {
	        if (missedMessagesFound) {
	          this.$location.path("/messages/event/" + event.eventId).search({ c: channelToGoToInURL });
	        } else {
	          this.$location.path("/messages/event/" + event.eventId);
	        }
	      }
	    }
	  }, {
	    key: "inboxLink",
	    value: function inboxLink() {
	      var _this = this;
	      if (_this.$rootScope.channelsHaveLoaded && !_this.$rootScope.channels) {
	        alert("This account has no active messages. If you think there are active messages please refresh the page.");
	      } else {
	        _this.$timeout(function () {
	          _this.$state.go("inbox");
	        });
	      }
	    }
	  }, {
	    key: "toastMessage",
	    value: function toastMessage(params) {
	      var _this = this;
	      var msg = params.m.messagePayload.message;
	      if (msg.length > 75) {
	        msg = msg.substring(0, 99);
	        msg = msg + " ...";
	      }
	      _this.notMsg = msg;
	      _this.notUser = params.m.messagePayload.username;
	      _this.notImage = params.m.messagePayload.userProfileImage;
	      _this.notChan = params.channel;
	      _this.notEventId = params.m.messagePayload.eventId;
	      _this.$timeout(function () {
	        jQuery("#notification-tab").show("fast");
	      });
	    }
	  }, {
	    key: "closeNotification",
	    value: function closeNotification(eventId, channel) {
	      var _this = this;
	      _this.$timeout(function () {
	        jQuery("#notification-tab").hide("fast");
	      });
	    }
	  }, {
	    key: "goToChat",
	    value: function goToChat(eventId, channel) {
	      var _this = this;
	      if (eventId) {
	        _this.$location.path("/messages/event/" + eventId).search({ c: channel });
	      } else {
	        return;
	      }
	    }
	  }, {
	    key: "setJobbleTypesToSession",
	    value: function setJobbleTypesToSession() {
	      var _this = this;
	      if (!_this.$rootScope.jobble_types) {
	        _this.loadJobbleTypes();
	      }
	    }
	  }, {
	    key: "loadJobbleTypes",
	    value: function loadJobbleTypes() {
	      var _this = this;
	      console.log("loadJobbleTypes 2");
	      _this.$auth.getJobbleTypes().then(function (data) {
	        _this.$rootScope.jobble_types = data.data;
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetJobbleTypes", {
	            jobbleTypes: data.data
	          });
	        });
	      }, function (data) {
	        _this.jobbleTypes = [];
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "setTeamsToSession",
	    value: function setTeamsToSession() {
	      var _this = this;
	    }
	  }, {
	    key: "loadTeams",
	    value: function loadTeams() {
	      var _this = this;
	      var teamsSimple = [];
	      var teams = [];
	      _this.$companies.getTeamsTrim().then(function (data) {
	        try {
	          data.data.forEach(function (team, index) {
	            _this.setAvatarImageToUsersOfTeam(team);
	            team.firstLoadUsersCount = Math.min(team.users.length, 6);
	            if (team.firstLoadUsersCount == 6) {
	              team.firstLoadUsersCount = 5;
	            }
	
	            teams.push(team);
	            var teamsObj = {};
	            teamsObj.name = team.name;
	            teamsObj.id = team.id;
	            teamsSimple.push(teamsObj);
	          });
	        } finally {
	          _this.$timeout(function () {
	            _this.$rootScope.teams = teams;
	            _this.$rootScope.teamsSimple = teamsSimple;
	            _this.$rootScope.$emit("TeamsHaveLoaded", {
	              teams: teams
	            });
	          });
	        }
	      }, function (data) {
	        _this.$rootScope.teams = [];
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "setAvatarImageToUsersOfTeam",
	    value: function setAvatarImageToUsersOfTeam(team) {
	      var _this = this;
	      if (team.users) {
	        team.users.forEach(function (userProfile) {
	          if (!_this.$security.isUndefinedOrNull(userProfile.picture1s)) {
	            userProfile.picture1s.forEach(function (pic) {
	              if (pic.indexOf("75x75") > -1) {
	                userProfile.pictureAvatarUrl = pic;
	              }
	              if (pic.indexOf("160x160") > -1) {
	                userProfile.pictureAvatarUrlBig = pic;
	              }
	            });
	          }
	
	          if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
	            userProfile.pictureAvatarUrl = userProfile.pictureAvatarUrlBig;
	          }
	
	          if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
	            userProfile.pictureAvatarUrl = "/app/vendor/images/defaultimg.jpeg";
	          }
	        });
	      }
	    }
	  }, {
	    key: "closeNoti",
	    value: function closeNoti(x) {
	      var _this = this;
	      _this.showNoti = false;
	      if (x === 2) {
	        _this.$timeout(function () {
	          jQuery(".modal-backdrop").remove();
	          jQuery("body").removeClass("modal-open");
	        });
	      }
	    }
	  }, {
	    key: "closeAutoSave",
	    value: function closeAutoSave(x) {
	      var _this = this;
	      _this.showAuto = false;
	    }
	  }, {
	    key: "autoSaveEventAsDraft",
	    value: function autoSaveEventAsDraft(params) {
	      var _this = this;
	      if (params.update) {
	        _this.$timeout(function () {
	          _this.showAuto = false;
	        }, 2000);
	      } else {
	        if (!params.questions) {
	          params.questions = [];
	          var p = {
	            question: "Are you a good fit?",
	            questionType: 1,
	            name: "Question 1"
	          };
	          params.questions.push(p);
	        }
	        _this.$events.saveDraft(params).then(function (response) {
	          if (response.data.status === "error") {
	            _this.$timeout(function () {
	              _this.showAuto = false;
	            });
	            if (response.data.message.indexOf("Data too long for column 'dress_code'") > -1) {
	              alert("The Dress Code on page 1 is too long. Please go back and shorten.");
	            } else {
	              alert("There was an issue please contact an admin.");
	            }
	            return;
	          }
	          _this.$timeout(function () {
	            _this.showAuto = false;
	            _this.$rootScope.$emit("SetEventIdForDrafting", {
	              draftData: response
	            });
	          }, 2000);
	        }, function (error) {
	          console.log("we are in error");
	          console.dir(error);
	        });
	      }
	    }
	  }, {
	    key: "logOnboardingTracking",
	    value: function logOnboardingTracking(event) {
	      var _this = this;
	      _this.$tracking.reportOboardingScreenOne(event);
	    }
	  }, {
	    key: "setActiveClass",
	    value: function setActiveClass() {
	      var _this = this;
	      if (_this.$state.current.url.indexOf("/events") > -1) {
	        _this.$timeout(function () {
	          jQuery(".pull-right ul li:nth-child(2)").addClass("active");
	        });
	      }
	      if (_this.$state.current.url.indexOf("/transactionhistory") > -1) {
	        _this.$timeout(function () {
	          jQuery(".pull-right ul li:nth-child(3)").addClass("active");
	        });
	      }
	      if (_this.$state.current.url.indexOf("/teams") > -1) {
	        _this.$timeout(function () {
	          jQuery(".pull-right ul li:nth-child(4)").addClass("active");
	        });
	      }
	      if (_this.$state.current.url.indexOf("/inbox") > -1) {
	        _this.$timeout(function () {
	          jQuery(".pull-right ul li:nth-child(5)").addClass("active");
	        });
	      }
	    }
	  }, {
	    key: "initUnregisteredUser",
	    value: function initUnregisteredUser() {
	      var _this = this;
	      _this.isJobSeeker = true;
	    }
	  }, {
	    key: "funnelToMobileApp",
	    value: function funnelToMobileApp(x) {
	      var _this = this;
	      var button = null;
	      switch (x) {
	        case 1:
	          _this.text = "hi";
	          button = "Applications";
	          break;
	        case 2:
	          _this.text = "hi";
	          button = "Messages";
	          break;
	        case 3:
	          _this.text = "hi";
	          button = "Jobs";
	          break;
	        case 4:
	          _this.text = "hi";
	          button = "Payments";
	          break;
	      }
	      _this.trackingHeader(button);
	    }
	  }, {
	    key: "moreInfoModal",
	    value: function moreInfoModal() {
	      var _this = this;
	      if (_this.appError) {
	        _this.$timeout(function () {
	          $(".noti-message-application-error").hide("fast");
	        });
	      } else {
	        _this.$timeout(function () {
	          $(".noti-message-application-success").hide("fast");
	        });
	      }
	      _this.$timeout(function () {
	        $("#more-application-info").modal();
	      }, 500);
	    }
	  }, {
	    key: "setApplicationStatus",
	    value: function setApplicationStatus(data, user_not_verified) {
	      var _this = this;
	      if (data.data.status === "error") {
	        if (data.data.message === "Applicant already applied for jobble in the pool") {
	          _this.applicationText = "You already applied to this job. Please pick another.";
	        } else {
	          _this.applicationText = "There was an issue with your application. Please try again later.";
	        }
	        _this.appError = true;
	      } else {
	        _this.applicationText = "Success! Check your application status on our mobile app.";
	        _this.appError = false;
	      }
	      if (user_not_verified) {
	        _this.$timeout(function () {
	          $("#finishing-steps").modal();
	        }, 300);
	      }
	      _this.$timeout(function () {
	        _this.applicationText = null;
	      }, 10000);
	    }
	  }, {
	    key: "closeNotiApp",
	    value: function closeNotiApp() {
	      var _this = this;
	      _this.applicationText = null;
	    }
	  }, {
	    key: "trackingHeader",
	    value: function trackingHeader(button) {
	      var _this = this;
	      var data = {};
	      if (!_this.currentUser) {
	        data.username = "Unregistered";
	      } else {
	        data.username = _this.currentUser.username;
	      }
	      data.button = button;
	      _this.$tracking.reportHeaderClicks(button);
	    }
	  }, {
	    key: "goToProfile",
	    value: function goToProfile() {
	      var _this = this;
	    }
	  }, {
	    key: "goToEvents",
	    value: function goToEvents() {
	      var _this = this;
	      _this.$state.go("events");
	    }
	  }, {
	    key: "showPostBlur",
	    value: function showPostBlur() {
	      var _this = this;
	      _this.$timeout(function () {
	        $(".hidden-drop-down-post-types").hide("slide", { direction: "up" }, 100);
	        _this.showPostScroll = false;
	      }, 300);
	    }
	  }, {
	    key: "validateEvent",
	    value: function validateEvent() {
	      var shiftsValids = this.validateShifts();
	      return { disabled: !shiftsValids || !this.event.contactInfo };
	    }
	  }, {
	    key: "validateShifts",
	    value: function validateShifts() {
	      var _this9 = this;
	
	      var allValid = true;
	
	      if (!this.event || !this.event.shifts || !this.event.shifts.length) {
	        allValid = false;
	        return allValid;
	      }
	
	      this.event.shifts.forEach(function (shift) {
	        var valid = _this9.$events.validateWorflowShift(shift);
	        if (!valid) allValid = false;
	
	        return valid;
	      });
	
	      if (allValid) {
	        if (!this.$events.validateWorflowShiftsNonOverlapping(this.event.shifts)) {
	          allValid = false;
	        }
	      }
	
	      return allValid;
	    }
	  }, {
	    key: "saveAndExit",
	    value: function saveAndExit() {
	      var _this10 = this;
	
	      console.log("saveAndExit");
	      this.$timeout(function () {
	        _this10.$rootScope.$emit("PostAJobSaveAndExit", {});
	        _this10.$rootScope.$emit("channelsHaveBeenLoaded", {});
	        _this10.$state.go("jobsdashboard");
	      });
	    }
	  }, {
	    key: "showJobScroll",
	    value: function showJobScroll() {
	      var _this = this;
	      var showList = null;
	      console.log("_this.$localStorage.events");
	      console.dir(_this.$localStorage.events);
	
	      if (_this.showJobsDropDown === false) {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("ListEventsForScroll", {});
	          _this.showJobsDropDown = true;
	          $(".hidden-drop-down").show("slide", { direction: "up" }, 100);
	        });
	      } else {
	        _this.$timeout(function () {
	          _this.showJobsDropDown = false;
	          $(".hidden-drop-down").hide("slide", { direction: "up" }, 100);
	        });
	      }
	    }
	  }, {
	    key: "showDropDownList",
	    value: function showDropDownList() {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("ListEventsForScroll", {});
	        $(".hidden-drop-down").show("fast");
	      });
	      _this.showJobsDropDown = true;
	    }
	  }, {
	    key: "setToDirective",
	    value: function setToDirective(params) {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetEventsToJobsScroll", { params: params });
	      });
	    }
	  }, {
	    key: "jobDropDownBlur",
	    value: function jobDropDownBlur() {
	      var _this = this;
	      _this.$timeout(function () {
	        $(".hidden-drop-down").hide("slide", { direction: "up" }, 100);
	        _this.showJobsDropDown = false;
	      }, 300);
	    }
	  }, {
	    key: "jobDropDownFocus",
	    value: function jobDropDownFocus() {
	      var _this = this;
	    }
	  }, {
	    key: "jobDropDownHover",
	    value: function jobDropDownHover() {
	      var _this = this;
	      _this.showJobScroll();
	    }
	  }, {
	    key: "jobDropDownLeave",
	    value: function jobDropDownLeave() {
	      var _this = this;
	      _this.showJobScroll();
	    }
	  }, {
	    key: "reportHeaderDropDownClick",
	    value: function reportHeaderDropDownClick(link) {
	      var _this = this;
	      var data = {};
	      if (_this.currentUser) {
	        data.user = _this.currentUser.email;
	      } else {
	        data.user = "Unregistered";
	      }
	      switch (link) {
	        case 1:
	          data.button = "Account";
	          return;
	        case 2:
	          data.button = "Direct Pay";
	          return;
	        case 3:
	          data.button = "Help Center";
	          return;
	        case 4:
	          data.button = "Logout";
	          return;
	      }
	      _this.$tracking.reportHeaderMenuInteraction(data);
	    }
	  }, {
	    key: "go_to_bulk_upload_jobs_page",
	    value: function go_to_bulk_upload_jobs_page() {
	      this.$state.go("postjobbulk");
	    }
	  }, {
	    key: "send_to_basic_profile",
	    value: function send_to_basic_profile() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("#finishing-steps").modal("toggle");
	      });
	      _this.$timeout(function () {
	        _this.$state.go("jobbler", {});
	      }, 300);
	    }
	  }, {
	    key: "checkAccountType",
	    value: function checkAccountType() {
	      var _this = this;
	      var cid = _this.currentUser.company.id;
	      if (cid) {
	        if (_this.currentUser.company.industryType) {
	          var industry_type_id = _this.currentUser.company.industryType.id;
	          if (industry_type_id) {
	            _this.currentUser.company.industry = "Delivery";
	          } else {
	            console.log("we do not have an industry type");
	          }
	        }
	      }
	    }
	  }, {
	    key: "rotate",
	    value: function rotate() {
	      var _this = this;
	      _this.$timeout(function () {
	        $(".main-menu ul li a i").toggleClass("down");
	      });
	    }
	  }, {
	    key: "checkAgreementStatus",
	    value: function checkAgreementStatus(user) {
	      console.log("checkAgreementStatus");
	      console.dir(user);
	
	      if (user.acceptedCookiePolicy === null || user.acceptedPrivacyPolicy === null) {
	        this.$timeout(function () {
	          $("#agree-to-terms").modal({
	            backdrop: "static",
	            keyboard: false
	          });
	        });
	      } else if (user.acceptedCookiePolicy === null) {
	        this.$timeout(function () {
	          $("#agree-to-terms").modal({
	            backdrop: "static",
	            keyboard: false
	          });
	        });
	      }
	
	      /*
	        */
	
	      /*
	       this.$profile.saveUser(payload).then(function(){
	        }.);
	       */
	
	      /*
	       this.$timeout(() => {
	        $("#agree-to-terms").modal({backdrop: 'static', keyboard: false});
	       });
	       */
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "userAcceptsTOS",
	    value: function userAcceptsTOS(result, closeForm) {
	      var _this11 = this;
	
	      var _this = this;
	
	      _this.setLoader();
	
	      var payload = {};
	
	      //payload.acceptedWebAgreement = result;
	      //payload.acceptedMobileAgreement = result;
	
	      console.log("what is result");
	      console.dir(result);
	
	      payload.acceptedPrivacyPolicy = result;
	      payload.acceptedCookiePolicy = result;
	
	      console.log("saving user...");
	      console.dir(payload);
	
	      _this.$profile.saveUser(payload).then(function (response) {
	        _this.unSetLoader();
	
	        console.log("what is response.");
	        console.dir(response);
	        console.dir(closeForm);
	        console.dir(result);
	
	        if (closeForm) {
	          if (result === false) {
	            _this.$timeout(function () {
	              $("#opt-out").modal("toggle");
	            });
	          } else {
	            _this.$timeout(function () {
	              $("#opt-in").modal("toggle");
	            });
	          }
	
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("UpdatePrefenceUI", result);
	          });
	        } else {
	          _this.$timeout(function () {
	            $("#agree-to-terms").modal("toggle");
	          });
	        }
	
	        _this.currentUser = _this.$auth.reloadCurrentUser();
	
	        console.log("_this.currentUser now");
	        console.dir(_this.currentUser);
	      }, function (error) {
	        _this11.unSetLoader();
	
	        if (closeForm) {
	          if (result === false) {
	            _this.$timeout(function () {
	              $("#opt-out").modal("toggle");
	            });
	          } else {
	            _this.$timeout(function () {
	              $("#out-in").modal("toggle");
	            });
	          }
	        } else {
	          _this.$timeout(function () {
	            $("#agree-to-terms").modal("toggle");
	          });
	        }
	      });
	    }
	  }, {
	    key: "userDeclinesTOS",
	    value: function userDeclinesTOS() {
	      console.log("userDeclinesTOS");
	    }
	  }, {
	    key: "validateTOS",
	    value: function validateTOS() {
	      var _this = this;
	
	      var result = false;
	
	      console.log("validateTOS");
	      console.dir(_this.currentUser.email);
	      console.dir(_this.tosEmail);
	
	      if (_this.currentUser.email === _this.tosEmail) {
	        result = true;
	      }
	
	      return result;
	    }
	  }, {
	    key: "optOut",
	    value: function optOut() {
	      var _this = this;
	
	      var validate = _this.validateTOS();
	
	      if (validate) {
	        _this.userAcceptsTOS(false, true);
	      } else {
	        alert("Please provide your correct email.");
	      }
	    }
	  }, {
	    key: "optIn",
	    value: function optIn() {
	      var _this = this;
	
	      var validate = _this.validateTOS();
	
	      if (validate) {
	        _this.userAcceptsTOS(true, true);
	      } else {
	        alert("Please provide your correct email.");
	      }
	    }
	  }]);
	
	  return PjheaderController;
	}();
	
	PjheaderController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "tracking", "$rootScope", "$scope", "$location", "$timeout", "$window", "companies", "messagingv2", "profile", "events", "$interval"];
	
	exports.default = PjheaderController;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(235);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".pb-nav{padding:14px 24px;position:fixed;top:0;z-index:1000;width:100%}.pb-nav,.pb-nav-height{height:78px}.pb-nav .logo img{height:50px}.pb-nav .logo.mobile{display:none}@media only screen and (max-width:768px){.pb-nav .logo.mobile{display:inherit;width:48px}}@media only screen and (max-width:768px){.pb-nav .job-search-container .job-search-term-container i,.pb-nav .logo.desktop{display:none}}.pb-nav.header-section{padding:14px 24px;height:78px;box-shadow:0 2px 5px 0 rgba(0,0,0,.2)}.pb-nav .main-menu ul li a{display:block;text-decoration:none;text-transform:uppercase;letter-spacing:.5px;transition:none;color:#5e666d;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;line-height:18px;margin-top:4px}.pb-nav .job-search-container{margin-top:8px;height:34px;display:flex;width:521px;margin-left:32px}.pb-nav .job-search-container.mobile{display:none}@media only screen and (max-width:768px){.pb-nav .job-search-container{width:300px;margin-left:0;display:none}.pb-nav .job-search-container.mobile{display:block}}@media only screen and (max-width:414px){.pb-nav .job-search-container{width:280px}}@media only screen and (max-width:375px){.pb-nav .job-search-container{width:245px}}@media only screen and (max-width:320px){.pb-nav .job-search-container{width:216px}}.pb-nav .job-search-container .job-search-term-container{flex:1;position:relative}.pb-nav .job-search-container .zip-code-container{flex:0 0 201px;position:relative}.pb-nav .job-search-container .button-container{flex:0 0 34px}.pb-nav .job-search-container input{height:100%;width:100%;padding-left:43px;border:1px solid #adbcc2;color:#767676;font-family:Poppins,sans-serif;font-size:12px;letter-spacing:0}.pb-nav .job-search-container .job-search-term-container input{border-radius:6px 0 0 6px;box-shadow:0 2px 4px #00000020;padding-left:46px}.pb-nav .job-search-container .job-search-term-container i{position:absolute;left:16px;height:14px;top:10px;color:#5e666d}.pb-nav .job-search-container .job-search-term-container .mobile-search{display:none}@media only screen and (max-width:768px){.pb-nav .job-search-container .job-search-term-container .desktop-search{display:none}.pb-nav .job-search-container .job-search-term-container input{padding-left:10px}.pb-nav .job-search-container .job-search-term-container .mobile-search{display:block}}.pb-nav .job-search-container .zip-code-container input{border-left:none;border-right:none;padding-left:44px;box-shadow:0 2px 4px #00000020}.pb-nav .job-search-container .zip-code-container i{position:absolute;left:16px;height:14px;top:10px;color:#5e666d}@media only screen and (max-width:768px){.pb-nav .job-search-container input{padding-left:16px}.pb-nav .job-search-container .job-search-term-container o{display:none}}@media only screen and (max-width:768px){.pb-nav .job-search-container .zip-code-container{flex:1}.pb-nav .job-search-container .zip-code-container input{padding-left:10px}.pb-nav .job-search-container .zip-code-container i{display:none}}.pb-nav .job-search-container button{width:100%;height:100%;background:#5e666d;box-shadow:0 2px 4px #00000020;border-radius:0 6px 6px 0;padding:8px}.pb-nav .job-search-container input::-webkit-input-placeholder,.pb-nav .job-search-container input:focus::-webkit-input-placeholder{color:#adbcc2}.pb-nav .navbar-toggle .icon-bar{background-color:#5e666d}.pb-nav-mobile.mobile-menu-wrap{z-index:1001}.pb-nav .user-avatar{padding-right:0;background-size:cover;background-position:50% 50%;background-repeat:no-repeat;border-radius:100%;height:42px!important;width:42px!important;border:1px solid #62c046;margin-top:0!important}.pb-nav .user-login .dropdown{width:205px;border:1px solid #adbcc2;border-radius:6px;background-color:#fff;box-shadow:0 2px 5px 0 rgba(0,0,0,.2);margin:9px 0;padding:24px;right:-24px}.pb-nav .profile-img{border-radius:100%;height:42px!important;width:42px!important;border:1px solid #62c046;margin-top:0!important}.pb-nav .user-login .dropdown li a{background-color:#fff;color:#5e666d;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;letter-spacing:.1px;line-height:18px}.pb-nav .user-login .dropdown li a i{float:right;line-height:18px}.pb-nav .user-avatar:after,.pb-nav .user-login .dropdown:after{display:none}.pb-nav .header-right{height:100%}.pac-container:after{background-image:none!important;height:0}.pb-nav .mobile-location-search{height:100vh;position:fixed;width:100vw;top:0;left:0;z-index:1000;padding:16px;background:#fff;display:none}.pb-nav .mobile-location-search.show{display:block}.pb-nav .mobile-location-search .input-container{position:relative}.pb-nav .mobile-location-search input{height:34px;line-height:24px;width:100%;padding-left:46px;border:1px solid #adbcc2;border-radius:6px;color:#3b3f43;font-family:Poppins,sans-serif;font-size:14px;letter-spacing:0;margin-bottom:16px;box-shadow:inset 0 0 4px 0 rgba(0,0,0,.1)}.pb-nav .mobile-location-search .input-container i{position:absolute;left:0;padding-left:16px;height:34px;top:0;padding-top:8px;width:46px;color:#767c84;font-size:18px;letter-spacing:0;line-height:18px}.pb-nav .mobile-location-search .term-container{flex:1}.pb-nav .mobile-location-search .term-container input{border-radius:6px 0 0 6px;border-right:none}.pb-nav .mobile-location-search button{width:100%;height:34px;background:#5e666d;border-radius:0 6px 6px 0;padding:8px;box-shadow:inset 0 0 4px 0 rgba(0,0,0,.1)}@media only screen and (max-width:991px) and (min-width:768px){.main-menu{display:block;background:none;z-index:999;width:fit-content;position:relative;float:right;left:auto;top:auto;border-bottom:none}}@media only screen and (max-width:995px) and (min-width:768px){.pb-nav .job-search-container{width:450px}}@media only screen and (max-width:920px) and (min-width:768px){.pb-nav .job-search-container{width:370px}.pb-nav .job-search-container .job-search-term-container input,.pb-nav .job-search-container .zip-code-container input{padding-left:25px}.pb-nav .job-search-container .job-search-term-container i,.pb-nav .job-search-container .zip-code-container i{left:7px}.pb-nav .job-search-container .zip-code-container{flex:0 0 140px}}@media only screen and (max-width:840px) and (min-width:768px){.pb-nav .job-search-container{width:293px}}.pb-nav .main-menu ul li a.save-and-exit-button{margin-top:0;background:#fff;color:#000;border:2px solid #5e666d;border-radius:6px}.pb-nav .save-and-exit-button.disabled{opacity:.35;pointer-events:none}", ""]);
	
	// exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _jobdescription = __webpack_require__(237);
	
	var _jobdescription2 = _interopRequireDefault(_jobdescription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobdescriptionModule = _angular2.default.module("jobdescription", [_angularUiRouter2.default]).component("jobdescription", _jobdescription2.default);
	
	exports.default = jobdescriptionModule;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobdescription = __webpack_require__(238);
	
	var _jobdescription2 = _interopRequireDefault(_jobdescription);
	
	var _jobdescription3 = __webpack_require__(239);
	
	var _jobdescription4 = _interopRequireDefault(_jobdescription3);
	
	__webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobdescriptionComponent = {
	  restrict: "E",
	  bindings: {
	    jobble: "<",
	    setJobForBackButton: "<",
	    applyToJobble: "<",
	    trackApplyToJobFromBoard: "<"
	  },
	  template: _jobdescription2.default,
	  controller: _jobdescription4.default,
	  controllerAs: "vm"
	};
	
	exports.default = jobdescriptionComponent;

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"selected-job-container\" ng-if=\"vm.jobble\">\n  <div class=\"job-header-container\">\n    <div class=\"job-header-logo\">\n      <div style=\"background-image: url({{vm.jobble.companyLogo}})\"></div>\n    </div>\n    <div class=\"job-header-details\">\n      <div class=\"job-header-title\" name=\"job-label-{{$index}}\">\n        {{ (vm.jobble.title) ? (vm.jobble.title) : ( (vm.jobble.subEvent.event.name) ? (vm.jobble.subEvent.event.name) : ('N/A') ) }}\n      </div>\n\n      <div class=\"job-header-company\">{{ vm.jobble.companyName }}</div>\n      <div class=\"job-header-location\">\n        <span ng-if=\"!vm.jobble.is_partner_post && !vm.jobble.jobbleType.name == 'Remote Job'\">\n          {{ vm.jobble.subEvent.contactInfo.city }}, {{ vm.jobble.subEvent.contactInfo.state }}\n        </span>\n        <span ng-if=\"!vm.jobble.is_partner_post && vm.jobble.jobbleType.name == 'Remote Job'\"> Remote Job </span>\n\n        <span ng-if=\"vm.jobble.is_partner_post\">{{ vm.jobble.city }}, {{ vm.jobble.state }}</span>\n      </div>\n      <div class=\"partner-badge\" ng-if=\"vm.jobble.is_partner_post\">\n        <span>Jobble Partner</span>\n      </div>\n      <div class=\"job-header-type\" ng-if=\"vm.jobble.is_partner_post\">\n        <span><i class=\"fa fa-briefcase\"></i>Part-time</span>\n      </div>\n      <div class=\"sharing-row\">\n        <div class=\"branch-share\">\n          <branchioshare jobble=\"vm.jobble\" />\n        </div>\n\n        <div ng-if=\"vm.jobble.applicationStatus == null\">\n          <div class=\"apply-button\" ng-click=\"vm.trackApplyToJobFromBoard(vm.jobble)\" ng-if=\"vm.jobble.is_partner_post && vm.currentUser\">\n            <a href=\"{{ vm.jobble.url }}\" target=\"_blank\"> Apply <span>Now</span> </a>\n          </div>\n          <div\n            class=\"apply-button\"\n            ng-click=\"vm.applyToJobble(vm.jobble)\"\n            ng-if=\"((vm.jobble.is_partner_post && !vm.currentUser) || (!vm.jobble.is_partner_post && vm.currentUser) || (!vm.jobble.is_partner_post && !vm.currentUser))\"\n          >\n            <a href=\"#\"> Apply </a>\n          </div>\n        </div>\n        <div ng-if=\"vm.jobble.applicationStatus != null\">\n          <div class=\"apply-button already-applied\">\n            <a href=\"#\" ng-click=\"vm.alreadyApplied()\">\n              <i class=\"fas fa-check\"></i>\n              Applied\n            </a>\n          </div>\n        </div>\n      </div>\n      <div>\n        <div class=\"job-time\">\n          <span>{{vm.jobble.applyTimeFrame}}</span>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"job-details-box-container\" ng-if=\"!vm.jobble.is_partner_post\">\n    <div class=\"row\">\n      <div class=\"col col-sm-6\">\n        <div class=\"details-pay-row\">\n          <div class=\"row-icon\">\n            <i class=\"fas fa-dollar-sign\"></i>\n          </div>\n          <div class=\"row-information\">\n            <span ng-if=\"vm.jobble.jobblerRate !== 0\">\n              EST. TOTAL PAY - $ {{vm.estimatedTotalPayables / 100 | number : 2}}\n              <br />\n              ( ${{ vm.jobble.jobblerRate / 100 | number : 2 }}/hr : {{ vm.totalPayableHours }} total payable hours )\n            </span>\n            <!--\n                            <span ng-if=\"vm.jobble.numberofDays === 0\">or ${{vm.jobble.jobblerRate /100 * vm.jobble.rawDuration | number : 2}} total estimated pay</span>\n                            -->\n            <span ng-if=\"vm.jobble.jobblerRate == 0\">TBD</span>\n          </div>\n        </div>\n        <div class=\"details-day-type-row\">\n          <div class=\"row-icon\">\n            <i class=\"fa fa-briefcase\"></i>\n          </div>\n          <div class=\"row-information\">\n            <span ng-if=\"vm.jobble.numberofDays > 0\">Multi-Day</span><span ng-if=\"vm.jobble.numberofDays === 0\">Single-Day</span>\n            job\n          </div>\n        </div>\n      </div>\n      <div class=\"col col-sm-6\">\n        <div ng-if=\"vm.jobble.numberofDays === 0\">\n          <div class=\"details-pay-row\">\n            <div class=\"row-icon\">\n              <i class=\"fas fa-calendar\"></i>\n            </div>\n            <div class=\"row-information\">{{ vm.jobble.jobbleFullTimeFrame }}</div>\n          </div>\n          <div class=\"details-pay-row\">\n            <div class=\"row-icon\">\n              <i class=\"far fa-clock\"></i>\n            </div>\n            <div class=\"row-information\">\n              <div>{{vm.jobble.jobbleHours}}</div>\n              <div>({{vm.jobble.jobbleDuration}})</div>\n            </div>\n          </div>\n        </div>\n        <div ng-if=\"vm.jobble.numberofDays > 0 && (!vm.shifts || vm.shifts.length === 0)\">\n          <div class=\"details-pay-row\">\n            <div class=\"row-icon\">\n              <i class=\"fas fa-calendar\"></i>\n            </div>\n            <div class=\"row-information\">{{ vm.jobble.jobbleFullTimeFrame }}</div>\n          </div>\n        </div>\n\n        <div>\n          <div ng-if=\"!(!vm.shifts || vm.shifts.length === 0)\" class=\"details-pay-row\" ng-repeat=\"s in vm.shifts\">\n            <div style=\"display: flex; flex: 1\">\n              <div style=\"display: flex; flex: 0 0 66px\">\n                <div class=\"row-icon\">\n                  <i class=\"fas fa-calendar\"></i>\n                </div>\n                <div class=\"row-information\"><span style=\"text-decoration: underline\">{{s.dayOfWeek}}</span><br />{{s.date}}</div>\n              </div>\n              <div style=\"display: flex; flex: 1; margin-left: 12px\">\n                <div class=\"row-icon\">\n                  <i class=\"far fa-clock\"></i>\n                </div>\n                <div class=\"row-information\" style=\"\">\n                  <span style=\"text-decoration: underline\"> {{ s.startTime }}-{{ s.endTime }}</span>\n                  <br />\n\n                  <span ng-if=\"s.unpaidBreak == 0 || s.unpaidBreak == null\"> ({{ s.duration }})<br /> </span>\n\n                  <span ng-if=\"s.unpaidBreak != null && s.unpaidBreak > 0\" style=\"font-size: 10px\">\n                    (includes {{s.unpaidBreak}} min unpaid break)\n                  </span>\n\n                  <br />\n\n                  <span ng-if=\"s.overnight\" class=\"overnight-flag\">Overnight</span>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"description-container\" ng-class=\"{'on-demand': !vm.jobble.is_partner_post, 'expanded': vm.expanded || !vm.long_description}\">\n    <div class=\"description-header\">About this job</div>\n    <div class=\"description-text\">\n      <div ng-if=\"vm.jobble.is_partner_post && vm.jobble.job_details_no_html\">{{ vm.jobble.job_details_no_html }}</div>\n\n      <div ng-if=\"vm.jobble.is_partner_post && !vm.jobble.job_details_no_html\">\n        <div ng-bind-html=\"vm.jobble.job_parsed_html\"></div>\n      </div>\n\n      <div style=\"white-space: pre-line\" ng-if=\"!vm.jobble.is_partner_post\">{{ vm.jobble.description }}</div>\n\n      <div class=\"description-header\" style=\"margin-top: 16px\" ng-if=\"vm.jobble.dressCode\">Suggested Attire</div>\n      <div class=\"description-text\" ng-if=\"vm.jobble.dressCode\">{{vm.jobble.dressCode}}</div>\n\n      <div class=\"description-read-more\" ng-click=\"vm.toggleDescription()\" ng-if=\"vm.long_description\">\n        Read {{vm.expanded ? \"Less\" : \"More\"}}\n        <!--                <i ng-if=\"vm.expanded\" class=\"fas fa-sort-up\"></i><i ng-if=\"!vm.expanded\" class=\"fas fa-sort-down\"></i>-->\n      </div>\n\n      <div ng-if=\"vm.companyDescription && vm.companyName\">\n        <div class=\"description-header\" style=\"margin-top: 16px\">About {{vm.companyName}}</div>\n        <div class=\"description-text\">{{vm.companyDescription}}</div>\n        <div class=\"description-read-more\" ng-click=\"vm.toggleCompanyDescription()\" ng-if=\"vm.long_company_description\">\n          Read {{vm.expanded_company ? \"Less\" : \"More\"}}\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"map-container\" ng-class=\"{'on-demand': !vm.jobble.is_partner_post}\" ng-if=\"vm.jobble.jobbleType.name != 'Remote Job'\">\n    <div class=\"map-title\">Location & Getting There</div>\n    <div class=\"address\"><i class=\"fa fa-map-marker\"></i><span>{{vm.address}}</span></div>\n    <div id=\"map\" class=\"map-google\" />\n    <div class=\"direction-time-container\">\n      <div class=\"direction-time\" ng-if=\"vm.carDistance\">\n        <span><i class=\"fas fa-car\"></i>{{vm.carDistance}}</span>\n      </div>\n      <div class=\"direction-time\" ng-if=\"vm.transitDistance\">\n        <span><i class=\"fas fa-bus\"></i>{{vm.transitDistance}}</span>\n      </div>\n      <div class=\"direction-time\" ng-if=\"vm.walkDistance\">\n        <span><i class=\"fas fa-walking\"></i>{{vm.walkDistance}}</span>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobdescriptionController = function () {
	  function JobdescriptionController($timeout, $interval, AuthService, tracking, JobService) {
	    var _this = this;
	
	    _classCallCheck(this, JobdescriptionController);
	
	    this.name = "jobdescription";
	
	    this.$timeout = $timeout;
	    this.$interval = $interval;
	    this.$tracking = tracking;
	    this.$auth = AuthService;
	    this.currentUser = this.$auth.getUserData();
	    this.$jobs = JobService;
	    this.expanded = false;
	
	    this.awaitForGoogleToLoad().then(function () {
	      _this.geocoder = new window.google.maps.Geocoder();
	      _this.directionsService = new google.maps.DirectionsService();
	      _this.directionsRenderer = new google.maps.DirectionsRenderer({
	        suppressMarkers: true
	      });
	    });
	  }
	
	  _createClass(JobdescriptionController, [{
	    key: "toggleDescription",
	    value: function toggleDescription() {
	      var _this2 = this;
	
	      this.$timeout(function () {
	        _this2.expanded = !_this2.expanded;
	      });
	    }
	  }, {
	    key: "toggleCompanyDescription",
	    value: function toggleCompanyDescription() {
	      var _this3 = this;
	
	      this.$timeout(function () {
	        _this3.expanded_company = !_this3.expanded_company;
	      });
	    }
	  }, {
	    key: "$onChanges",
	    value: function $onChanges() {
	      var _this4 = this;
	
	      if (this.jobble) {
	        this.$tracking.reportViewJob("job board", this.jobble);
	
	        // TODO: Replace by sending company description in the API
	        this.companyDescription = "";
	        this.companyName = "";
	        var correctDesc = void 0;
	
	        this.$jobs.getJobCompanyDesc(this.jobble.id).then(function (data) {
	          var jobble = data.data;
	          correctDesc = data.data.description;
	          if (jobble && jobble.subEvent && jobble.subEvent.event && jobble.subEvent.event.company) {
	            var company_description = jobble.subEvent.event.company.description;
	
	            _this4.companyDescription = company_description;
	            _this4.companyName = jobble.subEvent.event.company.name;
	            _this4.jobble.companyLogo = jobble.subEvent.event.company.fileCOMPANY_LOGO1IMG_160x160;
	
	            var length_test = company_description ? company_description.replace(/\W/g, "") : "";
	
	            _this4.$timeout(function () {
	              _this4.long_company_description = length_test.length > 600;
	            });
	
	            _this4.$timeout(function () {
	              _this4.jobble.description = correctDesc;
	            }, 200);
	          }
	        });
	
	        var descr = !this.jobble.is_partner_post ? this.jobble.description : this.jobble.job_details_no_html || this.jobble.job_parsed_html;
	        descr = descr ? descr.replace(/\W/g, "") : "";
	
	        this.$timeout(function () {
	          _this4.long_description = descr.length > 600;
	          var panel = document.getElementsByClassName("job-panel-selected")[0];
	          if (panel) panel.scrollTop = 0;
	          _this4.shifts = [];
	        });
	
	        console.log("SINGLE JOB", this.jobble);
	
	        var job = this.$jobs.processJob(this.jobble).job;
	
	        this.jobble.dressCode = job.dressCode;
	
	        this.$timeout(function () {
	          _this4.shifts = job && job.shifts ? job.shifts : [];
	
	          if (_this4.shifts.length) {
	            _this4.shifts = _this4.shifts.sort(function (a, b) {
	              return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
	            });
	
	            _this4.shifts = _this4.shifts.map(function (s) {
	              var start = new Date(moment(s.timeInterval.startTime).format());
	              var end = new Date(moment(s.timeInterval.endTime).format());
	
	              var startMoment = moment(start);
	              var endMoment = moment(end);
	
	              /*
	                          if (startMoment.isDST() === false && moment().isDST() === true) {
	                              startMoment.add(1, "hours");
	                              endMoment.add(1, "hours");
	                          } else if (startMoment.isDST() === true && moment().isDST() === false) {
	                              startMoment.subtract(1, "hours");
	                              endMoment.subtract(1, "hours");
	                          }
	                           */
	
	              var timeZone = s.contactInfo.place.timeZoneId;
	              //let timeZone = "America/New_York";
	              var startDay = startMoment.tz(timeZone).format("M/DD");
	
	              var diffTime = endMoment.tz(timeZone).diff(startMoment.tz(timeZone));
	              var durTime = moment.duration(diffTime);
	
	              var durHours = durTime.hours();
	              var durMin = durTime.minutes();
	
	              var unpaidBreaks = s.unpaidBreak;
	
	              var durationInMinutes = durHours * 60 + durMin;
	              var payableMinutes = durationInMinutes - unpaidBreaks;
	
	              s.payableHours = Math.floor(payableMinutes / 60);
	              s.payableMins = payableMinutes % 60;
	
	              var duration = "" + (durHours ? durHours + " HR" : "") + (durHours > 1 ? "S" : "") + (durMin && durMin ? " " : "") + (durMin ? durMin + "MIN" : "");
	
	              return {
	                dayOfWeek: startMoment.tz(timeZone).format("ddd"),
	                date: startDay,
	                startTime: startMoment.tz(timeZone).format("h:mmA"),
	                endTime: endMoment.tz(timeZone).format("h:mmA"),
	                duration: duration,
	                overnight: s.overnight,
	                payableHours: s.payableHours,
	                payableMins: s.payableMins,
	                unpaidBreak: unpaidBreaks
	              };
	            });
	
	            _this4.setTotalHoursToJob(_this4.shifts);
	          }
	        });
	        //});
	
	        console.log("PROCESSING MAP");
	
	        this.$timeout(function () {
	          _this4.carDistance = null;
	          _this4.walkDistance = null;
	          _this4.transitDistance = null;
	          _this4.expanded = false;
	        });
	
	        this.awaitForGoogleToLoad().then(function () {
	          _this4.geocoder = new window.google.maps.Geocoder();
	          _this4.directionsService = new google.maps.DirectionsService();
	          _this4.directionsRenderer = new google.maps.DirectionsRenderer({
	            suppressMarkers: true
	          });
	          _this4.loadMap();
	
	          var address = void 0;
	          if (!_this4.jobble.is_partner_post) {
	            var contactInfo = null;
	
	            if (_this4.jobble.contactInfo) {
	              contactInfo = _this4.jobble.contactInfo;
	            } else {
	              contactInfo = _this4.jobble.subEvent.contactInfo;
	            }
	
	            if (contactInfo.zipcode) {
	              address = contactInfo.streetLine1 + ", " + contactInfo.city + ", " + contactInfo.state + " " + contactInfo.zipcode;
	            } else {
	              address = contactInfo.streetLine1 + ", " + contactInfo.city + ", " + contactInfo.state;
	            }
	          } else {
	            address = _this4.jobble.city + ", " + _this4.jobble.state;
	          }
	
	          _this4.$timeout(function () {
	            _this4.address = address;
	          });
	
	          _this4.geocoder.geocode({ address: address }, function (results, status) {
	            if (status == "OK") {
	              // if (this.map) {
	              //     this.map.setCenter(results[0].geometry.location);
	              //
	              //     const marker = new google.maps.Marker({
	              //         map: this.map,
	              //         position: results[0].geometry.location
	              //     });
	              //
	              //     this.showCurrentLocation(results[0].geometry.location);
	              // }
	              if (_this4.maps && _this4.maps.length) {
	                _this4.maps.forEach(function (map) {
	                  map.setCenter(results[0].geometry.location);
	
	                  var marker = new google.maps.Marker({
	                    map: map,
	                    position: results[0].geometry.location
	                  });
	
	                  _this4.showCurrentLocation(results[0].geometry.location, map);
	                });
	              }
	            } else {
	              console.log("ERROR WITH GEOCODER :" + status);
	              //alert('Geocode was not successful for the following reason: ' + status);
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: "showCurrentLocation",
	    value: function showCurrentLocation(destination, map) {
	      var _this5 = this;
	
	      if (navigator.geolocation) {
	        if (this.pos) return this.showLocation(this.pos, destination, map);
	
	        navigator.geolocation.getCurrentPosition(function (position) {
	          var pos = {
	            lat: position.coords.latitude,
	            lng: position.coords.longitude
	          };
	
	          _this5.showLocation(pos, destination, map);
	        }, function () {});
	      } else {
	        // Browser doesn't support Geolocation
	        console.warn("No locator");
	      }
	    }
	  }, {
	    key: "showLocation",
	    value: function showLocation(pos, destination, map) {
	      var _this6 = this;
	
	      this.pos = pos;
	
	      var marker = new google.maps.Marker({
	        map: map,
	        position: pos,
	        icon: "http://www.robotwoods.com/dev/misc/bluecircle.png"
	      });
	
	      this.directionsRenderer.setMap(map);
	
	      var carRoute = {
	        origin: pos,
	        destination: destination,
	        travelMode: "DRIVING"
	      };
	
	      var walkRoute = {
	        origin: pos,
	        destination: destination,
	        travelMode: "WALKING"
	      };
	
	      var transitRoute = {
	        origin: pos,
	        destination: destination,
	        travelMode: "TRANSIT"
	      };
	
	      this.directionsService.route(carRoute, function (response, status) {
	        if (status !== "OK") {} else {
	          _this6.directionsRenderer.setDirections(response);
	          var directionsData = response.routes[0].legs[0];
	          if (!directionsData) {} else {
	            _this6.$timeout(function () {
	              _this6.carDistance = directionsData.duration.text.replace("min", "minute");
	            });
	          }
	        }
	      });
	
	      this.directionsService.route(walkRoute, function (response, status) {
	        if (status !== "OK") {} else {
	          var directionsData = response.routes[0].legs[0];
	          if (!directionsData) {
	            _this6.$timeout(function () {
	              _this6.walkDistance = null;
	            });
	          } else {
	            _this6.$timeout(function () {
	              _this6.walkDistance = directionsData.duration.text.replace("min", "minute");
	            });
	          }
	        }
	      });
	
	      this.directionsService.route(transitRoute, function (response, status) {
	        if (status !== "OK") {} else {
	          var directionsData = response.routes[0].legs[0];
	          if (!directionsData) {
	            _this6.$timeout(function () {
	              _this6.transitDistance = null;
	            });
	          } else {
	            _this6.$timeout(function () {
	              _this6.transitDistance = directionsData.duration.text.replace("min", "minute");
	            });
	          }
	        }
	      });
	    }
	  }, {
	    key: "alreadyApplied",
	    value: function alreadyApplied() {
	      alert("You have already applied to this job!");
	    }
	  }, {
	    key: "loadMap",
	    value: function loadMap() {
	      var _this7 = this;
	
	      var latlng = new google.maps.LatLng(-34.397, 150.644);
	      var mapOptions = {
	        zoom: 13,
	        center: latlng,
	        gestureHandling: "cooperative"
	      };
	
	      // this.map = new google.maps.Map(document.getElementById('map'), mapOptions);
	      this.maps = [];
	
	      Array.from(document.getElementsByClassName("map-google")).forEach(function (map, index, array) {
	        _this7.maps.push(new google.maps.Map(map, mapOptions));
	      });
	    }
	  }, {
	    key: "awaitForGoogleToLoad",
	    value: function awaitForGoogleToLoad() {
	      var _this8 = this;
	
	      var count = 0;
	      return new Promise(function (resolve, reject) {
	        if (!_angular2.default.isUndefined(window.google)) return resolve();
	
	        var id = Math.floor(Math.random() * 100000);
	
	        _this8.goggleLoaders = _this8.goggleLoaders || {};
	
	        _this8.goggleLoaders[id] = _this8.$interval(function () {
	          count = count = 1;
	          console.warn("Trying to load google", count);
	          console.log(_this8.goggleLoaders);
	          if (!_angular2.default.isUndefined(window.google) || count > 5) {
	            resolve();
	            _this8.$interval.cancel(_this8.goggleLoaders[id]);
	            _this8.goggleLoaders[id] = undefined;
	          }
	        }, 500);
	      });
	    }
	  }, {
	    key: "setCurrentUser",
	    value: function setCurrentUser() {
	      this.currentUser = this.$auth.getUserData();
	    }
	  }, {
	    key: "setTotalHoursToJob",
	    value: function setTotalHoursToJob(shifts) {
	      this.setCurrentUser();
	
	      var totalHours = 0;
	      var totalMinutes = 0;
	
	      shifts.forEach(function (shift) {
	        totalHours = shift.payableHours + totalHours;
	        totalMinutes = shift.payableMins + totalMinutes;
	      });
	
	      totalHours = totalHours + totalMinutes / 60;
	      this.totalPayableHours = totalHours;
	      this.estimatedTotalPayables = this.jobble.payPerHour * this.totalPayableHours;
	    }
	  }]);
	
	  return JobdescriptionController;
	}();
	
	JobdescriptionController.$inject = ["$timeout", "$interval", "auth", "tracking", "jobs"];
	
	exports.default = JobdescriptionController;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(241);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".selected-job-container{background:#fff;border-radius:6px;overflow-wrap:break-word;border:1px solid #adbcc2;box-shadow:0 2px 4px 0 rgba(0,0,0,.2);max-width:524px}@media only screen and (max-width:768px){.selected-job-container{padding:0;border-radius:0;border:none;max-width:none}}.selected-job-container .job-header-container{display:flex;flex-direction:row;margin-top:32px;margin-bottom:23px;padding:0 32px}.selected-job-container .job-header-logo{flex:0 0 110px;height:110px;margin-right:16px;border:1px solid #adbcc2;border-radius:2px;overflow:hidden}.selected-job-container .job-header-logo div{padding-right:0;background-size:cover;background-position:50% 50%;background-repeat:no-repeat;height:100%;width:100%}.selected-job-container .job-header-details{flex:1}.selected-job-container .job-header-title{color:#33373a;font-family:Poppins,sans-serif;font-size:16px;font-weight:600;line-height:25px;text-decoration:underline}.selected-job-container .job-header-company,.selected-job-container .job-header-location,.selected-job-container .job-header-type{color:#33373a;font-family:Poppins,sans-serif;font-size:11px;letter-spacing:.3px;line-height:11px;margin-top:8px}.selected-job-container .job-header-company{text-transform:uppercase;letter-spacing:.33px;font-weight:500}.selected-job-container .job-header-type{font-weight:500;letter-spacing:.3px;line-height:16px;height:16px}.selected-job-container .job-header-type i{font-size:16px;margin-right:8px}.selected-job-container .partner-badge{color:#fff;font-family:Poppins,sans-serif;font-size:10px;font-weight:500;line-height:10px;margin-top:16px}.selected-job-container .partner-badge span{background-color:#5498b4;border-radius:4px;padding:0 4px}.selected-job-container .sharing-row{display:flex;margin-top:16px}.selected-job-container .branch-share{margin-right:8px}.selected-job-container .apply-button{height:34px;width:74px;border-radius:6px;background-color:#62c046;color:#fff;font-family:Poppins,sans-serif;font-size:14px;font-weight:600;line-height:34px;text-align:center;cursor:pointer}.selected-job-container .apply-button a{color:#fff}.selected-job-container .apply-button a span{display:none}@media only screen and (max-width:768px){.selected-job-container .apply-button{position:fixed;text-align:center;bottom:0;width:100%;left:0;border-radius:0;height:40px}.selected-job-container .apply-button a{display:block}.selected-job-container .apply-button a span{display:inline-block}}.job-time{display:none}.selected-job-container .job-details-box-container{padding:24px 32px;padding-bottom:8px;background:#f7f7f7;color:#5e666d;border-top:1px solid #adbcc2}.selected-job-container .job-details-box-container .details-day-type-row,.selected-job-container .job-details-box-container .details-pay-row{display:flex;margin-bottom:16px}.selected-job-container .job-details-box-container .row-icon{flex:0 0 30px;font-size:18px;line-height:18px}.selected-job-container .job-details-box-container .row-information{flex:1;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;letter-spacing:.3px;line-height:18px;text-transform:uppercase}.selected-job-container .description-container{padding:24px 32px;border-top:1px solid #adbcc2;border-bottom:1px solid #adbcc2;background:#f7f7f7;font-size:12px;line-height:20px;position:relative;font-family:Poppins,sans-serif;height:252px}.selected-job-container .description-container.on-demand{background:#fff}.selected-job-container .description-header{color:#33373a;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;margin-bottom:16px;letter-spacing:.3px;line-height:18px;text-transform:uppercase}.selected-job-container .description-text{height:120px;overflow:hidden;position:relative;margin-bottom:16px}.selected-job-container .description-container.expanded{height:auto}.selected-job-container .expanded .description-text{height:auto;padding-bottom:20px}.selected-job-container .description-read-more{position:absolute;height:42px;bottom:0;left:0;background:linear-gradient(0deg,#f7f7f7,hsla(0,0%,100%,.66));width:100%;box-sizing:content-box;text-align:center;color:#33373a;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;line-height:58px;cursor:pointer}.selected-job-container .description-read-more i{font-size:14px;margin-left:8px}.selected-job-container .expanded .description-read-more{background:none}.map-container{padding:24px 32px}.map-container.on-demand{background:#f7f7f7}.map-container .map-title{font-weight:600;text-transform:uppercase}.map-container .address,.map-container .map-title{color:#33373a;font-family:Poppins,sans-serif;font-size:12px;margin-bottom:16px;letter-spacing:.3px;line-height:18px}.map-container .address{font-weight:500}.map-container .address i{font-size:18px;line-height:18px;margin-right:10px}.map-container #map{height:184px}.map-container .direction-time-container{display:flex;margin-top:16px}.direction-time-container .direction-time{margin-right:24px;color:#5e666d;font-family:Poppins,sans-serif;font-size:12px;font-weight:500;line-height:18px}.direction-time-container .direction-time i{margin-right:8px}", ""]);
	
	// exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _jobsearchcard = __webpack_require__(243);
	
	var _jobsearchcard2 = _interopRequireDefault(_jobsearchcard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobsearchcardModule = _angular2.default.module("jobsearchcard", [_angularUiRouter2.default]).component("jobsearchcard", _jobsearchcard2.default);
	
	exports.default = jobsearchcardModule;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobsearchcard = __webpack_require__(244);
	
	var _jobsearchcard2 = _interopRequireDefault(_jobsearchcard);
	
	var _jobsearchcard3 = __webpack_require__(245);
	
	var _jobsearchcard4 = _interopRequireDefault(_jobsearchcard3);
	
	__webpack_require__(246);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobsearchcardComponent = {
	  restrict: "E",
	  bindings: {
	    jobble: "=",
	    selectedJobble: "="
	  },
	  template: _jobsearchcard2.default,
	  controller: _jobsearchcard4.default,
	  controllerAs: "vm"
	};
	
	exports.default = jobsearchcardComponent;

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"job-search-card\" ng-class=\"vm.selectedJobble && vm.selectedJobble.id === vm.jobble.id ? 'selected' : ''\">\n  <div>\n    <div class=\"search-card-header\">\n      <div class=\"search-card-logo-container\">\n        <div style=\"background-image: url({{vm.jobble.companyLogo}})\"></div>\n      </div>\n      <div class=\"search-card-header-info-container\">\n        <div>\n          <span class=\"job-title\"\n            >{{ (vm.jobble.title) ? (vm.jobble.title) : ( (vm.jobble.subEvent.event.name) ? (vm.jobble.subEvent.event.name) : ('N/A') ) }}</span\n          >\n        </div>\n        <div>\n          <div class=\"company-location\">\n            {{ vm.jobble.companyName }}\n            <span class=\"location\" ng-if=\"vm.jobble.is_partner_post\">\n              <i class=\"fas fa-map-marker-alt\"></i> {{ vm.jobble.city }}, {{ vm.jobble.state }}\n            </span>\n\n            <span class=\"location\" ng-if=\"!vm.jobble.is_partner_post && vm.jobble.jobbleType.name != 'Remote Job'\">\n              <i class=\"fas fa-map-marker-alt\"></i> {{ vm.jobble.contactInfo.city }}, {{ vm.jobble.contactInfo.state }}\n            </span>\n            <span class=\"location\" ng-if=\"!vm.jobble.is_partner_post && vm.jobble.jobbleType.name == 'Remote Job'\">\n              <i class=\"fas fa-map-marker-alt\"></i> Remote Job\n            </span>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"search-card-time-container\">\n      <div class=\"search-card-type\">\n        <div>\n          <div ng-if=\"!vm.jobble.is_partner_post\">\n            <i class=\"fa fa-briefcase\"></i>\n            <span ng-if=\"vm.jobble.numberofDays > 0\">Multi-Day </span><span ng-if=\"vm.jobble.numberofDays === 0\">Single-Day</span>\n            job\n          </div>\n        </div>\n        <div>\n          <div ng-if=\"vm.jobble.is_partner_post\"><i class=\"fa fa-briefcase\"></i> Part-Time</div>\n        </div>\n      </div>\n      <div class=\"search-card-time\">\n        <div>\n          <div ng-if=\"vm.jobble.companyName !== 'Uber'\">\n            <div ng-if=\"!vm.jobble.is_partner_post\"><i class=\"fas fa-calendar\"></i> {{ vm.jobble.jobbleTimeFrame }}</div>\n            <div ng-if=\"!vm.jobble.is_partner_post  && vm.jobble.overnight==true\"><i class=\"fas fa-moon\"></i> Overnight</div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div>\n      <div>\n        <span class=\"jobble-rate\" ng-if=\"vm.jobble.jobblerRate !== 0 && !vm.jobble.is_partner_post\"\n          ><i class=\"fas fa-dollar-sign\"></i> {{ vm.jobble.estimatedTotalPayables / 100 | number : 2 }} (estimated total pay)</span\n        >\n        <span class=\"jobble-rate\" ng-if=\"vm.jobble.jobblerRate == 0 && !vm.jobble.is_partner_post\"><i class=\"fas fa-dollar-sign\"></i> TBD</span>\n      </div>\n    </div>\n\n    <div class=\"search-card-footer\">\n      <div class=\"partner-badge\" ng-if=\"vm.jobble.is_partner_post\">\n        <span>Jobble Partner</span>\n      </div>\n      <div class=\"days-ago\">\n        <div>Posted {{vm.jobble.daysAgoPostedText}}</div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobsearchcardController = function () {
	  function JobsearchcardController($timeout) {
	    _classCallCheck(this, JobsearchcardController);
	
	    this.name = "jobsearchcard";
	
	    this.$timeout = $timeout;
	  }
	
	  _createClass(JobsearchcardController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.$timeout(function () {
	        _this.$timeout(function () {
	          $(".app-status-icon").tooltip({});
	        }, 200);
	      });
	    }
	  }]);
	
	  return JobsearchcardController;
	}();
	
	JobsearchcardController.$inject = ["$timeout"];
	
	exports.default = JobsearchcardController;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(247);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".job-search-card{background:#fff;box-sizing:border-box;padding:16px;min-height:143px;font-size:12px;color:#5e666d;font-family:Poppins,sans-serif;font-weight:500;border:1px solid #adbcc2;border-bottom:none;cursor:pointer}.application-status-pending{border-radius:4px;padding:0 5px;text-transform:uppercase;position:absolute;right:0;z-index:1000}.application-status-pending i{font-size:15px;color:orange}.last-card .job-search-card{border-radius:0 0 6px 6px;border-bottom:1px solid #adbcc2}.first-card .job-search-card{border-radius:6px 6px 0 0}.last-card.first-card .job-search-card{border-radius:6px}.job-search-card.selected{border-color:#000;border-bottom:1px solid #000}@media only screen and (max-width:768px){.job-search-card.selected{border:none;border-bottom:1px solid #adbcc2}}.job-search-card .search-card-header{display:flex}.job-search-card .search-card-header .search-card-logo-container{flex:0 0 40px;height:40px;margin-right:8px;border:1px solid #adbcc2;border-radius:2px}.job-search-card .search-card-header .search-card-logo-container div{padding-right:0;background-size:cover;background-position:50% 50%;background-repeat:no-repeat;height:100%;width:100%}.job-search-card .job-title{color:#33373a;font-family:Poppins,sans-serif;font-size:14px;text-decoration:underline;font-weight:600;line-height:21px;cursor:pointer}.job-search-card .company-location{color:#33373a;font-family:Poppins,sans-serif;font-size:11px;font-weight:500;letter-spacing:.3px;line-height:11px;margin-top:4px;margin-bottom:18px;text-transform:uppercase}.job-search-card .company-location .location{margin-left:8px;text-transform:none}.job-search-card .search-card-time-container{display:block}.job-search-card .search-card-time-container .search-card-type{display:inline-block;margin-right:16px}.job-search-card .search-card-time-container .search-card-time{display:inline-block}.job-search-card .search-card-footer{display:flex;margin-top:16px}.job-search-card .partner-badge{flex:1;color:#fff;font-family:Poppins,sans-serif;font-size:10px;font-weight:500;line-height:10px}.job-search-card .partner-badge span{background-color:#5498b4;border-radius:4px;padding:0 4px}.job-search-card .days-ago{flex:1;text-align:right;color:#5e666d;font-family:Poppins,sans-serif;font-size:10px;font-weight:500;line-height:11px}.jobble-rate{margin-right:16px}", ""]);
	
	// exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pajtooltip = __webpack_require__(249);
	
	var _pajtooltip2 = _interopRequireDefault(_pajtooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pajtooltipModule = _angular2.default.module("pajtooltip", [_angularUiRouter2.default]).component("pajtooltip", _pajtooltip2.default);
	
	exports.default = pajtooltipModule;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pajtooltip = __webpack_require__(250);
	
	var _pajtooltip2 = _interopRequireDefault(_pajtooltip);
	
	var _pajtooltip3 = __webpack_require__(251);
	
	var _pajtooltip4 = _interopRequireDefault(_pajtooltip3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pajtooltipComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _pajtooltip2.default,
	  controller: _pajtooltip4.default,
	  controllerAs: "vm"
	};
	
	exports.default = pajtooltipComponent;

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	module.exports = "<i\n  data-toggle=\"tooltip\"\n  ng-attr-title=\"Click for more information\"\n  data-placement=\"bottom\"\n  style=\"color: #62c046; margin-right: 5px\"\n  ng-click=\"vm.scrollToToolTip()\"\n  class=\"paj-tooltip far fa-lightbulb\"\n/>\n"

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _messagingv = __webpack_require__(30);
	
	var _messagingv2 = _interopRequireDefault(_messagingv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PajtooltipController = function () {
	  function PajtooltipController($http, $localStorage, $state, AuthService, SecurityService, Messagingv2Service, $rootScope, $location, TrackingService, $timeout) {
	    var _this = this;
	
	    _classCallCheck(this, PajtooltipController);
	
	    this.name = "jobblefooter";
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$rootScope = $rootScope;
	    this.$tracking = TrackingService;
	    this.$security = SecurityService;
	    this.$messagingv2 = Messagingv2Service;
	    this.currentUser = this.$auth.getUserData();
	    this.$location = $location;
	    this.loadLocalLytics = false;
	    this.$timeout = $timeout;
	    this.counter = 0;
	
	    this.$timeout(function () {
	      _this.enableToolTips();
	    }, 250);
	  }
	
	  _createClass(PajtooltipController, [{
	    key: "enableToolTips",
	    value: function enableToolTips() {
	      this.$timeout(function () {
	        $(".paj-tooltip").tooltip({}); //.tooltip('dispose');
	      }, 200);
	    }
	  }, {
	    key: "scrollToToolTip",
	    value: function scrollToToolTip() {
	      try {
	        $("#paj-main-scroll").animate({ scrollTop: 999 }, 400);
	        // document.getElementById("paj-main-scroll").scrollTop = 9999;
	      } catch (e) {}
	    }
	  }]);
	
	  return PajtooltipController;
	}();
	
	PajtooltipController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "messagingv2", "$rootScope", "$location", "tracking", "$timeout"];
	
	exports.default = PajtooltipController;

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	(function () {
	  "use strict";
	
	  function hasProperty(obj, prop) {
	    return Object.prototype.hasOwnProperty.call(obj, prop);
	  }
	
	  function lastItemOf(arr) {
	    return arr[arr.length - 1];
	  }
	
	  // push only the items not included in the array
	  function pushUnique(arr) {
	    for (var _len = arguments.length, items = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      items[_key - 1] = arguments[_key];
	    }
	
	    items.forEach(function (item) {
	      if (arr.includes(item)) {
	        return;
	      }
	      arr.push(item);
	    });
	    return arr;
	  }
	
	  function stringToArray(str, separator) {
	    // convert empty string to an empty array
	    return str ? str.split(separator) : [];
	  }
	
	  function isInRange(testVal, min, max) {
	    var minOK = min === undefined || testVal >= min;
	    var maxOK = max === undefined || testVal <= max;
	    return minOK && maxOK;
	  }
	
	  function limitToRange(val, min, max) {
	    if (val < min) {
	      return min;
	    }
	    if (val > max) {
	      return max;
	    }
	    return val;
	  }
	
	  function createTagRepeat(tagName, repeat) {
	    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	    var html = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
	
	    var openTagSrc = Object.keys(attributes).reduce(function (src, attr) {
	      var val = attributes[attr];
	      if (typeof val === "function") {
	        val = val(index);
	      }
	      return src + " " + attr + "=\"" + val + "\"";
	    }, tagName);
	    html += "<" + openTagSrc + "></" + tagName + ">";
	
	    var next = index + 1;
	    return next < repeat ? createTagRepeat(tagName, repeat, attributes, next, html) : html;
	  }
	
	  // Remove the spacing surrounding tags for HTML parser not to create text nodes
	  // before/after elements
	  function optimizeTemplateHTML(html) {
	    return html.replace(/>\s+/g, ">").replace(/\s+</, "<");
	  }
	
	  function stripTime(timeValue) {
	    return new Date(timeValue).setHours(0, 0, 0, 0);
	  }
	
	  function today() {
	    return new Date().setHours(0, 0, 0, 0);
	  }
	
	  // Get the time value of the start of given date or year, month and day
	  function dateValue() {
	    switch (arguments.length) {
	      case 0:
	        return today();
	      case 1:
	        return stripTime(arguments.length <= 0 ? undefined : arguments[0]);
	    }
	
	    // use setFullYear() to keep 2-digit year from being mapped to 1900-1999
	    var newDate = new Date(0);
	    newDate.setFullYear.apply(newDate, arguments);
	    return newDate.setHours(0, 0, 0, 0);
	  }
	
	  function addDays(date, amount) {
	    var newDate = new Date(date);
	    return newDate.setDate(newDate.getDate() + amount);
	  }
	
	  function addWeeks(date, amount) {
	    return addDays(date, amount * 7);
	  }
	
	  function addMonths(date, amount) {
	    // If the day of the date is not in the new month, the last day of the new
	    // month will be returned. e.g. Jan 31 + 1 month → Feb 28 (not Mar 03)
	    var newDate = new Date(date);
	    var monthsToSet = newDate.getMonth() + amount;
	    var expectedMonth = monthsToSet % 12;
	    if (expectedMonth < 0) {
	      expectedMonth += 12;
	    }
	
	    var time = newDate.setMonth(monthsToSet);
	    return newDate.getMonth() !== expectedMonth ? newDate.setDate(0) : time;
	  }
	
	  function addYears(date, amount) {
	    // If the date is Feb 29 and the new year is not a leap year, Feb 28 of the
	    // new year will be returned.
	    var newDate = new Date(date);
	    var expectedMonth = newDate.getMonth();
	    var time = newDate.setFullYear(newDate.getFullYear() + amount);
	    return expectedMonth === 1 && newDate.getMonth() === 2 ? newDate.setDate(0) : time;
	  }
	
	  // Calculate the distance bettwen 2 days of the week
	  function dayDiff(day, from) {
	    return (day - from + 7) % 7;
	  }
	
	  // Get the date of the specified day of the week of given base date
	  function dayOfTheWeekOf(baseDate, dayOfWeek) {
	    var weekStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	    var baseDay = new Date(baseDate).getDay();
	    return addDays(baseDate, dayDiff(dayOfWeek, weekStart) - dayDiff(baseDay, weekStart));
	  }
	
	  // Get the ISO week of a date
	  function getWeek(date) {
	    // start of ISO week is Monday
	    var thuOfTheWeek = dayOfTheWeekOf(date, 4, 1);
	    // 1st week == the week where the 4th of January is in
	    var firstThu = dayOfTheWeekOf(new Date(thuOfTheWeek).setMonth(0, 4), 4, 1);
	    return Math.round((thuOfTheWeek - firstThu) / 604800000) + 1;
	  }
	
	  // Get the start year of the period of years that includes given date
	  // years: length of the year period
	  function startOfYearPeriod(date, years) {
	    /* @see https://en.wikipedia.org/wiki/Year_zero#ISO_8601 */
	    var year = new Date(date).getFullYear();
	    return Math.floor(year / years) * years;
	  }
	
	  // pattern for format parts
	  var reFormatTokens = /dd?|DD?|mm?|MM?|yy?(?:yy)?/;
	  // pattern for non date parts
	  var reNonDateParts = /[\s!-/:-@[-`{-~年月日]+/;
	  // cache for persed formats
	  var knownFormats = {};
	  // parse funtions for date parts
	  var parseFns = {
	    y: function y(date, year) {
	      return new Date(date).setFullYear(parseInt(year, 10));
	    },
	
	    M: undefined, // placeholder to maintain the key order
	    m: function m(date, month, locale) {
	      var newDate = new Date(date);
	      var monthIndex = parseInt(month, 10) - 1;
	
	      if (isNaN(monthIndex)) {
	        if (!month) {
	          return NaN;
	        }
	
	        var monthName = month.toLowerCase();
	        var compareNames = function compareNames(name) {
	          return name.toLowerCase().startsWith(monthName);
	        };
	        // compare with both short and full names because some locales have periods
	        // in the short names (not equal to the first X letters of the full names)
	        monthIndex = locale.monthsShort.findIndex(compareNames);
	        if (monthIndex < 0) {
	          monthIndex = locale.months.findIndex(compareNames);
	        }
	        return monthIndex < 0 ? NaN : newDate.setMonth(monthIndex);
	      }
	
	      newDate.setMonth(monthIndex);
	      return newDate.getMonth() !== normalizeMonth(monthIndex) ? newDate.setDate(0) : newDate.getTime();
	    },
	    d: function d(date, day) {
	      return new Date(date).setDate(parseInt(day, 10));
	    }
	  };
	  parseFns.M = parseFns.m; // make "M" an alias of "m"
	  // format functions for date parts
	  var formatFns = {
	    d: function d(date) {
	      return date.getDate();
	    },
	    dd: function dd(date) {
	      return padZero(date.getDate(), 2);
	    },
	    D: function D(date, locale) {
	      return locale.daysShort[date.getDay()];
	    },
	    DD: function DD(date, locale) {
	      return locale.days[date.getDay()];
	    },
	    m: function m(date) {
	      return date.getMonth() + 1;
	    },
	    mm: function mm(date) {
	      return padZero(date.getMonth() + 1, 2);
	    },
	    M: function M(date, locale) {
	      return locale.monthsShort[date.getMonth()];
	    },
	    MM: function MM(date, locale) {
	      return locale.months[date.getMonth()];
	    },
	    y: function y(date) {
	      return date.getFullYear();
	    },
	    yy: function yy(date) {
	      return padZero(date.getFullYear(), 2).slice(-2);
	    },
	    yyyy: function yyyy(date) {
	      return padZero(date.getFullYear(), 4);
	    }
	  };
	
	  // get month index in normal range (0 - 11) from any number
	  function normalizeMonth(monthIndex) {
	    return monthIndex > -1 ? monthIndex % 12 : normalizeMonth(monthIndex + 12);
	  }
	
	  function padZero(num, length) {
	    return num.toString().padStart(length, "0");
	  }
	
	  function parseFormatString(format) {
	    if (typeof format !== "string") {
	      throw new Error("Invalid date format.");
	    }
	    if (format in knownFormats) {
	      return knownFormats[format];
	    }
	
	    // sprit the format string into parts and seprators
	    var separators = format.split(reFormatTokens);
	    var parts = format.match(new RegExp(reFormatTokens, "g"));
	    if (separators.length === 0 || !parts) {
	      throw new Error("Invalid date format.");
	    }
	
	    // collect format functions used in the format
	    var partFormatters = parts.map(function (token) {
	      return formatFns[token];
	    });
	
	    // collect parse functions used in the format
	    // iterate over parseFns' keys in order to keep the order of the keys.
	    var partParsers = Object.keys(parseFns).reduce(function (parsers, key) {
	      var token = parts.find(function (part) {
	        return part[0] === key;
	      });
	      if (!token) {
	        return parsers;
	      }
	      parsers[key] = parseFns[key];
	      return parsers;
	    }, {});
	    var partParserKeys = Object.keys(partParsers);
	
	    return knownFormats[format] = {
	      parser: function parser(dateStr, locale) {
	        var dateParts = dateStr.split(reNonDateParts).reduce(function (dtParts, part, index) {
	          if (part.length > 0 && parts[index]) {
	            var token = parts[index][0];
	            if (parseFns[token] !== undefined) {
	              dtParts[token] = part;
	            }
	          }
	          return dtParts;
	        }, {});
	
	        // iterate over partParsers' keys so that the parsing is made in the oder
	        // of year, month and day to prevent the day parser from correcting last
	        // day of month wrongly
	        return partParserKeys.reduce(function (origDate, key) {
	          var newDate = partParsers[key](origDate, dateParts[key], locale);
	          // ingnore the part failed to parse
	          return isNaN(newDate) ? origDate : newDate;
	        }, today());
	      },
	      formatter: function formatter(date, locale) {
	        var dateStr = partFormatters.reduce(function (str, fn, index) {
	          return str += "" + separators[index] + fn(date, locale);
	        }, "");
	        // separators' length is always parts' length + 1,
	        return dateStr += lastItemOf(separators);
	      }
	    };
	  }
	
	  function _parseDate(dateStr, format, locale) {
	    if (dateStr instanceof Date || typeof dateStr === "number") {
	      var date = stripTime(dateStr);
	      return isNaN(date) ? undefined : date;
	    }
	    if (!dateStr) {
	      return undefined;
	    }
	    if (dateStr === "today") {
	      return today();
	    }
	
	    if (format && format.toValue) {
	      var _date = format.toValue(dateStr, format, locale);
	      return isNaN(_date) ? undefined : stripTime(_date);
	    }
	
	    return parseFormatString(format).parser(dateStr, locale);
	  }
	
	  function _formatDate(date, format, locale) {
	    if (isNaN(date) || !date && date !== 0) {
	      return "";
	    }
	
	    var dateObj = typeof date === "number" ? new Date(date) : date;
	
	    if (format.toDisplay) {
	      return format.toDisplay(dateObj, format, locale);
	    }
	
	    return parseFormatString(format).formatter(dateObj, locale);
	  }
	
	  var listenerRegistry = new WeakMap();
	  var _EventTarget$prototyp = EventTarget.prototype,
	      addEventListener = _EventTarget$prototyp.addEventListener,
	      removeEventListener = _EventTarget$prototyp.removeEventListener;
	
	  // Register event listeners to a key object
	  // listeners: array of listener definitions;
	  //   - each definition must be a flat array of event target and the arguments
	  //     used to call addEventListener() on the target
	
	  function registerListeners(keyObj, listeners) {
	    var registered = listenerRegistry.get(keyObj);
	    if (!registered) {
	      registered = [];
	      listenerRegistry.set(keyObj, registered);
	    }
	    listeners.forEach(function (listener) {
	      addEventListener.call.apply(addEventListener, _toConsumableArray(listener));
	      registered.push(listener);
	    });
	  }
	
	  function unregisterListeners(keyObj) {
	    var listeners = listenerRegistry.get(keyObj);
	    if (!listeners) {
	      return;
	    }
	    listeners.forEach(function (listener) {
	      removeEventListener.call.apply(removeEventListener, _toConsumableArray(listener));
	    });
	    listenerRegistry.delete(keyObj);
	  }
	
	  // Event.composedPath() polyfill for Edge
	  // based on https://gist.github.com/kleinfreund/e9787d73776c0e3750dcfcdc89f100ec
	  if (!Event.prototype.composedPath) {
	    var getComposedPath = function getComposedPath(node) {
	      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      path.push(node);
	
	      var parent = void 0;
	      if (node.parentNode) {
	        parent = node.parentNode;
	      } else if (node.host) {
	        // ShadowRoot
	        parent = node.host;
	      } else if (node.defaultView) {
	        // Document
	        parent = node.defaultView;
	      }
	      return parent ? getComposedPath(parent, path) : path;
	    };
	
	    Event.prototype.composedPath = function () {
	      return getComposedPath(this.target);
	    };
	  }
	
	  function findFromPath(path, criteria, currentTarget) {
	    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	    var el = path[index];
	    if (criteria(el)) {
	      return el;
	    } else if (el === currentTarget || !el.parentElement) {
	      // stop when reaching currentTarget or <html>
	      return;
	    }
	    return findFromPath(path, criteria, currentTarget, index + 1);
	  }
	
	  // Search for the actual target of a delegated event
	  function findElementInEventPath(ev, selector) {
	    var criteria = typeof selector === "function" ? selector : function (el) {
	      return el.matches(selector);
	    };
	    return findFromPath(ev.composedPath(), criteria, ev.currentTarget);
	  }
	
	  // default locales
	  var locales = {
	    en: {
	      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	      daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	      daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
	      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	      monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
	      today: "Today",
	      clear: "Clear",
	      titleFormat: "MM y"
	    }
	  };
	
	  // config options updatable by setOptions() and their default values
	  var defaultOptions = {
	    autohide: false,
	    beforeShowDay: null,
	    beforeShowDecade: null,
	    beforeShowMonth: null,
	    beforeShowYear: null,
	    calendarWeeks: false,
	    clearBtn: false,
	    dateDelimiter: ",",
	    datesDisabled: [],
	    daysOfWeekDisabled: [],
	    daysOfWeekHighlighted: [],
	    defaultViewDate: undefined, // placeholder, defaults to today() by the program
	    disableTouchKeyboard: false,
	    format: "mm/dd/yyyy",
	    language: "en",
	    maxDate: null,
	    maxNumberOfDates: 1,
	    maxView: 3,
	    minDate: null,
	    nextArrow: '<i class="fas fa-chevron-right"></i>',
	    orientation: "auto",
	    prevArrow: '<i class="fas fa-chevron-left"></i>',
	    showDaysOfWeek: true,
	    showOnFocus: true,
	    startView: 0,
	    title: "",
	    todayBtn: false,
	    todayBtnMode: 0,
	    todayHighlight: false,
	    weekStart: 0
	  };
	
	  var range = document.createRange();
	
	  function parseHTML(html) {
	    return range.createContextualFragment(html);
	  }
	
	  function hideElement(el) {
	    if (el.style.display === "none") {
	      return;
	    }
	    // back up the existing display setting in data-style-display
	    if (el.style.display) {
	      el.dataset.styleDisplay = el.style.display;
	    }
	    el.style.display = "none";
	  }
	
	  function showElement(el) {
	    if (el.style.display !== "none") {
	      return;
	    }
	    if (el.dataset.styleDisplay) {
	      // restore backed-up dispay property
	      el.style.display = el.dataset.styleDisplay;
	      delete el.dataset.styleDisplay;
	    } else {
	      el.style.display = "";
	    }
	  }
	
	  function emptyChildNodes(el) {
	    if (el.firstChild) {
	      el.removeChild(el.firstChild);
	      emptyChildNodes(el);
	    }
	  }
	
	  function replaceChildNodes(el, newChildNodes) {
	    emptyChildNodes(el);
	    if (newChildNodes instanceof DocumentFragment) {
	      el.appendChild(newChildNodes);
	    } else if (typeof newChildNodes === "string") {
	      el.appendChild(parseHTML(newChildNodes));
	    } else if (typeof newChildNodes.forEach === "function") {
	      newChildNodes.forEach(function (node) {
	        el.appendChild(node);
	      });
	    }
	  }
	
	  var defaultLang = defaultOptions.language,
	      defaultFormat = defaultOptions.format,
	      defaultWeekStart = defaultOptions.weekStart;
	
	  // Reducer function to filter out invalid day-of-week from the input
	
	  function sanitizeDOW(dow, day) {
	    return dow.length < 6 && day >= 0 && day < 7 ? pushUnique(dow, day) : dow;
	  }
	
	  function calcEndOfWeek(startOfWeek) {
	    return (startOfWeek + 6) % 7;
	  }
	
	  // validate input date. if invalid, fallback to the original value
	  function validateDate(value, format, locale, origValue) {
	    var date = _parseDate(value, format, locale);
	    return date !== undefined ? date : origValue;
	  }
	
	  // Validate viewId. if invalid, fallback to the original value
	  function validateViewId(value, origValue) {
	    var viewId = parseInt(value, 10);
	    return viewId >= 0 && viewId < 4 ? viewId : origValue;
	  }
	
	  // Create Datepicker configuration to set
	  function processOptions(options, datepicker) {
	    var inOpts = Object.assign({}, options);
	    var config = {};
	    var locales = datepicker.constructor.locales;
	
	    var _ref = datepicker.config || {},
	        format = _ref.format,
	        language = _ref.language,
	        locale = _ref.locale,
	        maxDate = _ref.maxDate,
	        maxView = _ref.maxView,
	        minDate = _ref.minDate,
	        startView = _ref.startView,
	        weekStart = _ref.weekStart;
	
	    if (inOpts.language) {
	      var lang = void 0;
	      if (inOpts.language !== language) {
	        if (locales[inOpts.language]) {
	          lang = inOpts.language;
	        } else {
	          // Check if langauge + region tag can fallback to the one without
	          // region (e.g. fr-CA → fr)
	          lang = inOpts.language.split("-")[0];
	          if (locales[lang] === undefined) {
	            lang = false;
	          }
	        }
	      }
	      delete inOpts.language;
	      if (lang) {
	        language = config.language = lang;
	
	        // update locale as well when updating language
	        var origLocale = locale || locales[defaultLang];
	        // use default language's properties for the fallback
	        locale = Object.assign({
	          format: defaultFormat,
	          weekStart: defaultWeekStart
	        }, locales[defaultLang]);
	        if (language !== defaultLang) {
	          Object.assign(locale, locales[language]);
	        }
	        config.locale = locale;
	        // if format and/or weekStart are the same as old locale's defaults,
	        // update them to new locale's defaults
	        if (format === origLocale.format) {
	          format = config.format = locale.format;
	        }
	        if (weekStart === origLocale.weekStart) {
	          weekStart = config.weekStart = locale.weekStart;
	          config.weekEnd = calcEndOfWeek(locale.weekStart);
	        }
	      }
	    }
	
	    if (inOpts.format) {
	      var hasToDisplay = typeof inOpts.format.toDisplay === "function";
	      var hasToValue = typeof inOpts.format.toValue === "function";
	      var validFormatString = reFormatTokens.test(inOpts.format);
	      if (hasToDisplay && hasToValue || validFormatString) {
	        format = config.format = inOpts.format;
	      }
	      delete inOpts.format;
	    }
	
	    //*** dates ***//
	    // while min and maxDate for "no limit" in the options are better to be null
	    // (especially when updating), the ones in the config have to be undefined
	    // because null is treated as 0 (= unix epoch) when comparing with time value
	    var minDt = minDate;
	    var maxDt = maxDate;
	    if (inOpts.minDate !== undefined) {
	      minDt = inOpts.minDate === null ? dateValue(0, 0, 1) // set 0000-01-01 to prevent negative values for year
	      : validateDate(inOpts.minDate, format, locale, minDt);
	      delete inOpts.minDate;
	    }
	    if (inOpts.maxDate !== undefined) {
	      maxDt = inOpts.maxDate === null ? undefined : validateDate(inOpts.maxDate, format, locale, maxDt);
	      delete inOpts.maxDate;
	    }
	    if (maxDt < minDt) {
	      minDate = config.minDate = maxDt;
	      maxDate = config.maxDate = minDt;
	    } else {
	      if (minDate !== minDt) {
	        minDate = config.minDate = minDt;
	      }
	      if (maxDate !== maxDt) {
	        maxDate = config.maxDate = maxDt;
	      }
	    }
	
	    if (inOpts.datesDisabled) {
	      config.datesDisabled = inOpts.datesDisabled.reduce(function (dates, dt) {
	        var date = _parseDate(dt, format, locale);
	        return date !== undefined ? pushUnique(dates, date) : dates;
	      }, []);
	      delete inOpts.datesDisabled;
	    }
	    if (inOpts.defaultViewDate !== undefined) {
	      var viewDate = _parseDate(inOpts.defaultViewDate, format, locale);
	      if (viewDate !== undefined) {
	        config.defaultViewDate = viewDate;
	      }
	      delete inOpts.defaultViewDate;
	    }
	
	    //*** days of week ***//
	    if (inOpts.weekStart !== undefined) {
	      var wkStart = Number(inOpts.weekStart) % 7;
	      if (!isNaN(wkStart)) {
	        weekStart = config.weekStart = wkStart;
	        config.weekEnd = calcEndOfWeek(wkStart);
	      }
	      delete inOpts.weekStart;
	    }
	    if (inOpts.daysOfWeekDisabled) {
	      config.daysOfWeekDisabled = inOpts.daysOfWeekDisabled.reduce(sanitizeDOW, []);
	      delete inOpts.daysOfWeekDisabled;
	    }
	    if (inOpts.daysOfWeekHighlighted) {
	      config.daysOfWeekHighlighted = inOpts.daysOfWeekHighlighted.reduce(sanitizeDOW, []);
	      delete inOpts.daysOfWeekHighlighted;
	    }
	
	    //*** multi date ***//
	    if (inOpts.maxNumberOfDates !== undefined) {
	      var maxNumberOfDates = parseInt(inOpts.maxNumberOfDates, 10);
	      if (maxNumberOfDates >= 0) {
	        config.maxNumberOfDates = maxNumberOfDates;
	        config.multidate = maxNumberOfDates !== 1;
	      }
	      delete inOpts.maxNumberOfDates;
	    }
	    if (inOpts.dateDelimiter) {
	      config.dateDelimiter = String(inOpts.dateDelimiter);
	      delete inOpts.dateDelimiter;
	    }
	
	    //*** view mode ***//
	    var newMaxView = maxView;
	    if (inOpts.maxView !== undefined) {
	      newMaxView = validateViewId(inOpts.maxView, maxView);
	      delete inOpts.maxView;
	    }
	    if (newMaxView !== maxView) {
	      maxView = config.maxView = newMaxView;
	    }
	
	    var newStartView = startView;
	    if (inOpts.startView !== undefined) {
	      newStartView = validateViewId(inOpts.startView, newStartView);
	      delete inOpts.startView;
	    }
	    // ensure start view < max
	    newStartView = maxView < newStartView ? maxView : newStartView;
	    if (newStartView !== startView) {
	      config.startView = newStartView;
	    }
	
	    //*** template ***//
	    if (inOpts.prevArrow) {
	      var prevArrow = parseHTML(inOpts.prevArrow);
	      if (prevArrow.childNodes.length > 0) {
	        config.prevArrow = prevArrow.childNodes;
	      }
	      delete inOpts.prevArrow;
	    }
	    if (inOpts.nextArrow) {
	      var nextArrow = parseHTML(inOpts.nextArrow);
	      if (nextArrow.childNodes.length > 0) {
	        config.nextArrow = nextArrow.childNodes;
	      }
	      delete inOpts.nextArrow;
	    }
	
	    //*** misc ***//
	    if (inOpts.disableTouchKeyboard !== undefined) {
	      config.disableTouchKeyboard = "ontouchstart" in document && !!inOpts.disableTouchKeyboard;
	      delete inOpts.disableTouchKeyboard;
	    }
	    if (inOpts.orientation) {
	      var orientation = inOpts.orientation.toLowerCase().split(/\s+/g);
	      config.orientation = {
	        x: orientation.find(function (x) {
	          return x === "left" || x === "right";
	        }) || "auto",
	        y: orientation.find(function (y) {
	          return y === "top" || y === "bottom";
	        }) || "auto"
	      };
	      delete inOpts.orientation;
	    }
	    if (inOpts.todayBtnMode !== undefined) {
	      switch (inOpts.todayBtnMode) {
	        case 0:
	        case 1:
	          config.todayBtnMode = inOpts.todayBtnMode;
	      }
	      delete inOpts.todayBtnMode;
	    }
	
	    //*** copy the rest ***//
	    Object.keys(inOpts).forEach(function (key) {
	      if (inOpts[key] !== undefined && hasProperty(defaultOptions, key)) {
	        config[key] = inOpts[key];
	      }
	    });
	
	    return config;
	  }
	
	  var pickerTemplate = optimizeTemplateHTML("<div class=\"datepicker\">\n  <div class=\"datepicker-picker\">\n    <div class=\"datepicker-header\">\n      <div class=\"datepicker-title\"></div>\n      <div class=\"datepicker-controls\">\n        <button class=\"%buttonClass% prev-btn\"></button>\n        <button class=\"%buttonClass% view-switch\"></button>\n        <button class=\"%buttonClass% next-btn\"></button>\n      </div>\n    </div>\n    <div class=\"datepicker-main\"></div>\n    <div class=\"datepicker-footer\">\n      <div class=\"datepicker-controls\">\n        <button class=\"%buttonClass% today-btn\"></button>\n        <button class=\"%buttonClass% clear-btn\"></button>\n      </div>\n    </div>\n  </div>\n</div>");
	
	  var daysTemplate = optimizeTemplateHTML("<div class=\"days\">\n  <div class=\"days-of-week\">" + createTagRepeat("span", 7, {
	    class: "dow"
	  }) + "</div>\n  <div class=\"datepicker-grid\">" + createTagRepeat("span", 42) + "</div>\n</div>");
	
	  var calendarWeeksTemplate = optimizeTemplateHTML("<div class=\"calendar-weeks\">\n  <div class=\"days-of-week\"><span class=\"dow\"></span></div>\n  <div class=\"weeks\">" + createTagRepeat("span", 6, { class: "week" }) + "</div>\n</div>");
	
	  // Base class of the view classes
	
	  var View = function () {
	    function View(picker, config) {
	      _classCallCheck(this, View);
	
	      Object.assign(this, config, {
	        picker: picker,
	        element: parseHTML("<div class=\"datepicker-view\"></div>").firstChild,
	        selected: []
	      });
	      this.init(this.picker.datepicker.config);
	    }
	
	    _createClass(View, [{
	      key: "init",
	      value: function init(options) {
	        this.setOptions(options);
	        this.updateFocus();
	        this.updateSelection();
	      }
	
	      // Execute beforeShow() callback and apply the result to the element
	      // args:
	      // - current - current value on the iteration on view rendering
	      // - timeValue - time value of the date to pass to beforeShow()
	
	    }, {
	      key: "performBeforeHook",
	      value: function performBeforeHook(el, current, timeValue) {
	        var result = this.beforeShow(new Date(timeValue));
	        switch (typeof result === "undefined" ? "undefined" : _typeof(result)) {
	          case "boolean":
	            result = { enabled: result };
	            break;
	          case "string":
	            result = { classes: result };
	        }
	
	        if (result) {
	          if (result.enabled === false) {
	            el.classList.add("disabled");
	            pushUnique(this.disabled, current);
	          }
	          if (result.classes) {
	            var _el$classList;
	
	            var extraClasses = result.classes.split(/\s+/);
	            (_el$classList = el.classList).add.apply(_el$classList, _toConsumableArray(extraClasses));
	            if (extraClasses.includes("disabled")) {
	              pushUnique(this.disabled, current);
	            }
	          }
	          if (result.content) {
	            replaceChildNodes(el, result.content);
	          }
	        }
	      }
	    }]);
	
	    return View;
	  }();
	
	  var DaysView = function (_View) {
	    _inherits(DaysView, _View);
	
	    function DaysView(picker) {
	      _classCallCheck(this, DaysView);
	
	      return _possibleConstructorReturn(this, (DaysView.__proto__ || Object.getPrototypeOf(DaysView)).call(this, picker, {
	        id: 0,
	        name: "days",
	        cellClass: "day"
	      }));
	    }
	
	    _createClass(DaysView, [{
	      key: "init",
	      value: function init(options) {
	        var onConstruction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        if (onConstruction) {
	          var inner = parseHTML(daysTemplate).firstChild;
	          this.dow = inner.firstChild;
	          this.grid = inner.lastChild;
	          this.element.appendChild(inner);
	        }
	        _get(DaysView.prototype.__proto__ || Object.getPrototypeOf(DaysView.prototype), "init", this).call(this, options);
	      }
	    }, {
	      key: "setOptions",
	      value: function setOptions(options) {
	        var _this2 = this;
	
	        var updateDOW = void 0;
	
	        if (hasProperty(options, "minDate")) {
	          this.minDate = options.minDate;
	        }
	        if (hasProperty(options, "maxDate")) {
	          this.maxDate = options.maxDate;
	        }
	        if (options.datesDisabled) {
	          this.datesDisabled = options.datesDisabled;
	        }
	        if (options.daysOfWeekDisabled) {
	          this.daysOfWeekDisabled = options.daysOfWeekDisabled;
	          updateDOW = true;
	        }
	        if (options.daysOfWeekHighlighted) {
	          this.daysOfWeekHighlighted = options.daysOfWeekHighlighted;
	        }
	        if (options.todayHighlight !== undefined) {
	          this.todayHighlight = options.todayHighlight;
	        }
	        if (options.weekStart !== undefined) {
	          this.weekStart = options.weekStart;
	          this.weekEnd = options.weekEnd;
	          updateDOW = true;
	        }
	        if (options.locale) {
	          var locale = this.locale = options.locale;
	          this.dayNames = locale.daysMin;
	          this.switchLabelFormat = locale.titleFormat;
	          this.switchLabel = _formatDate(this.picker.viewDate, locale.titleFormat, locale);
	          updateDOW = true;
	        }
	        if (options.beforeShowDay !== undefined) {
	          this.beforeShow = typeof options.beforeShowDay === "function" ? options.beforeShowDay : undefined;
	        }
	
	        if (options.calendarWeeks !== undefined) {
	          if (options.calendarWeeks && !this.calendarWeeks) {
	            var weeksElem = parseHTML(calendarWeeksTemplate).firstChild;
	            this.calendarWeeks = {
	              element: weeksElem,
	              dow: weeksElem.firstChild,
	              weeks: weeksElem.lastChild
	            };
	            this.element.insertBefore(weeksElem, this.element.firstChild);
	          } else if (this.calendarWeeks && !options.calendarWeeks) {
	            this.element.removeChild(this.calendarWeeks.element);
	            this.calendarWeeks = null;
	          }
	        }
	        if (options.showDaysOfWeek !== undefined) {
	          if (options.showDaysOfWeek) {
	            showElement(this.dow);
	            if (this.calendarWeeks) {
	              showElement(this.calendarWeeks.dow);
	            }
	          } else {
	            hideElement(this.dow);
	            if (this.calendarWeeks) {
	              hideElement(this.calendarWeeks.dow);
	            }
	          }
	        }
	
	        // update days-of-week when locale, daysOfweekDisabled or weekStart is changed
	        if (updateDOW) {
	          Array.from(this.dow.children).forEach(function (el, index) {
	            var dow = (_this2.weekStart + index) % 7;
	            el.textContent = _this2.dayNames[dow];
	            el.className = _this2.daysOfWeekDisabled.includes(dow) ? "dow disabled" : "dow";
	          });
	        }
	      }
	
	      // Apply update on the focused date to view's settings
	
	    }, {
	      key: "updateFocus",
	      value: function updateFocus() {
	        var viewDate = new Date(this.picker.viewDate);
	        var viewYear = viewDate.getFullYear();
	        var viewMonth = viewDate.getMonth();
	        var firstOfMonth = dateValue(viewYear, viewMonth, 1);
	        var start = dayOfTheWeekOf(firstOfMonth, this.weekStart, this.weekStart);
	
	        this.first = firstOfMonth;
	        this.last = dateValue(viewYear, viewMonth + 1, 0);
	        this.start = start;
	
	        this.switchLabel = _formatDate(viewDate, this.switchLabelFormat, this.locale);
	        this.focused = this.picker.viewDate;
	      }
	
	      // Apply update on the selected dates to view's settings
	
	    }, {
	      key: "updateSelection",
	      value: function updateSelection() {
	        var _picker$datepicker = this.picker.datepicker,
	            dates = _picker$datepicker.dates,
	            range = _picker$datepicker.range;
	
	        this.selected = dates;
	        this.range = range;
	      }
	
	      // Update the entire view UI
	
	    }, {
	      key: "render",
	      value: function render() {
	        var _this3 = this;
	
	        // update today marker on ever render
	        this.today = this.todayHighlight ? today() : undefined;
	        // refresh disabled dates on every render in order to clear the ones added
	        // by beforeShow hook at previous render
	        this.disabled = [].concat(_toConsumableArray(this.datesDisabled));
	
	        this.picker.setViewSwitchLabel(this.switchLabel);
	        this.picker.setPrevBtnDisabled(this.first <= this.minDate);
	        this.picker.setNextBtnDisabled(this.last >= this.maxDate);
	
	        if (this.calendarWeeks) {
	          // start of the UTC week (Monday) of the 1st of the month
	          var startOfWeek = dayOfTheWeekOf(this.first, 1, 1);
	          Array.from(this.calendarWeeks.weeks.children).forEach(function (el, index) {
	            el.textContent = getWeek(addWeeks(startOfWeek, index));
	          });
	        }
	        Array.from(this.grid.children).forEach(function (el, index) {
	          var classList = el.classList;
	          var current = addDays(_this3.start, index);
	          var date = new Date(current);
	          var day = date.getDay();
	
	          el.className = "datepicker-cell " + _this3.cellClass;
	          el.dataset.date = current;
	          el.textContent = date.getDate();
	
	          if (current < _this3.first) {
	            classList.add("prev");
	          } else if (current > _this3.last) {
	            classList.add("next");
	          }
	          if (_this3.today === current) {
	            classList.add("today");
	          }
	          if (current < _this3.minDate || current > _this3.maxDate || _this3.disabled.includes(current)) {
	            classList.add("disabled");
	          }
	          if (_this3.daysOfWeekDisabled.includes(day)) {
	            classList.add("disabled");
	            pushUnique(_this3.disabled, current);
	          }
	          if (_this3.daysOfWeekHighlighted.includes(day)) {
	            classList.add("highlighted");
	          }
	          if (_this3.range) {
	            var _range = _slicedToArray(_this3.range, 2),
	                rangeStart = _range[0],
	                rangeEnd = _range[1];
	
	            if (current > rangeStart && current < rangeEnd) {
	              classList.add("range");
	            }
	            if (current === rangeStart) {
	              classList.add("range-start");
	            }
	            if (current === rangeEnd) {
	              classList.add("range-end");
	            }
	          }
	          if (_this3.selected.includes(current)) {
	            classList.add("selected");
	          }
	          if (current === _this3.focused) {
	            classList.add("focused");
	          }
	
	          if (_this3.beforeShow) {
	            _this3.performBeforeHook(el, current, current);
	          }
	        });
	      }
	
	      // Update the view UI by applying the changes of selected and focused items
	
	    }, {
	      key: "refresh",
	      value: function refresh() {
	        var _this4 = this;
	
	        var _ref2 = this.range || [],
	            _ref3 = _slicedToArray(_ref2, 2),
	            rangeStart = _ref3[0],
	            rangeEnd = _ref3[1];
	
	        this.grid.querySelectorAll(".range, .range-start, .range-end, .selected, .focused").forEach(function (el) {
	          el.classList.remove("range", "range-start", "range-end", "selected", "focused");
	        });
	        Array.from(this.grid.children).forEach(function (el) {
	          var current = Number(el.dataset.date);
	          var classList = el.classList;
	          if (current > rangeStart && current < rangeEnd) {
	            classList.add("range");
	          }
	          if (current === rangeStart) {
	            classList.add("range-start");
	          }
	          if (current === rangeEnd) {
	            classList.add("range-end");
	          }
	          if (_this4.selected.includes(current)) {
	            classList.add("selected");
	          }
	          if (current === _this4.focused) {
	            classList.add("focused");
	          }
	        });
	      }
	
	      // Update the view UI by applying the change of focused item
	
	    }, {
	      key: "refreshFocus",
	      value: function refreshFocus() {
	        var index = Math.round((this.focused - this.start) / 86400000);
	        this.grid.querySelectorAll(".focused").forEach(function (el) {
	          el.classList.remove("focused");
	        });
	        this.grid.children[index].classList.add("focused");
	      }
	    }]);
	
	    return DaysView;
	  }(View);
	
	  var MonthsView = function (_View2) {
	    _inherits(MonthsView, _View2);
	
	    function MonthsView(picker) {
	      _classCallCheck(this, MonthsView);
	
	      return _possibleConstructorReturn(this, (MonthsView.__proto__ || Object.getPrototypeOf(MonthsView)).call(this, picker, {
	        id: 1,
	        name: "months",
	        cellClass: "month"
	      }));
	    }
	
	    _createClass(MonthsView, [{
	      key: "init",
	      value: function init(options) {
	        var onConstruction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        if (onConstruction) {
	          this.grid = this.element;
	          this.element.classList.add("months", "datepicker-grid");
	          this.grid.appendChild(parseHTML(createTagRepeat("span", 12, {
	            "data-month": function dataMonth(ix) {
	              return ix;
	            }
	          })));
	        }
	        _get(MonthsView.prototype.__proto__ || Object.getPrototypeOf(MonthsView.prototype), "init", this).call(this, options);
	      }
	    }, {
	      key: "setOptions",
	      value: function setOptions(options) {
	        if (options.locale) {
	          this.monthNames = options.locale.monthsShort;
	        }
	        if (hasProperty(options, "minDate")) {
	          if (options.minDate === undefined) {
	            this.minYear = this.minMonth = this.minDate = undefined;
	          } else {
	            var minDateObj = new Date(options.minDate);
	            this.minYear = minDateObj.getFullYear();
	            this.minMonth = minDateObj.getMonth();
	            this.minDate = minDateObj.setDate(1);
	          }
	        }
	        if (hasProperty(options, "maxDate")) {
	          if (options.maxDate === undefined) {
	            this.maxYear = this.maxMonth = this.maxDate = undefined;
	          } else {
	            var maxDateObj = new Date(options.maxDate);
	            this.maxYear = maxDateObj.getFullYear();
	            this.maxMonth = maxDateObj.getMonth();
	            this.maxDate = dateValue(this.maxYear, this.maxMonth + 1, 0);
	          }
	        }
	        if (options.beforeShowMonth !== undefined) {
	          this.beforeShow = typeof options.beforeShowMonth === "function" ? options.beforeShowMonth : undefined;
	        }
	      }
	
	      // Update view's settings to reflect the viewDate set on the picker
	
	    }, {
	      key: "updateFocus",
	      value: function updateFocus() {
	        var viewDate = new Date(this.picker.viewDate);
	        this.year = viewDate.getFullYear();
	        this.switchLabel = this.year;
	        this.focused = viewDate.getMonth();
	      }
	
	      // Update view's settings to reflect the selected dates
	
	    }, {
	      key: "updateSelection",
	      value: function updateSelection() {
	        this.selected = this.picker.datepicker.dates.reduce(function (selected, timeValue) {
	          var date = new Date(timeValue);
	          var year = date.getFullYear();
	          var month = date.getMonth();
	          if (selected[year] === undefined) {
	            selected[year] = [month];
	          } else {
	            pushUnique(selected[year], month);
	          }
	          return selected;
	        }, {});
	      }
	
	      // Update the entire view UI
	
	    }, {
	      key: "render",
	      value: function render() {
	        var _this6 = this;
	
	        // refresh disabled months on every render in order to clear the ones added
	        // by beforeShow hook at previous render
	        this.disabled = [];
	
	        this.picker.setViewSwitchLabel(this.switchLabel);
	        this.picker.setPrevBtnDisabled(this.year <= this.minYear);
	        this.picker.setNextBtnDisabled(this.year >= this.maxYear);
	
	        var selected = this.selected[this.year] || [];
	        var yrOutOfRange = this.year < this.minYear || this.year > this.maxYear;
	        var isMinYear = this.year === this.minYear;
	        var isMaxYear = this.year === this.maxYear;
	        Array.from(this.grid.children).forEach(function (el, index) {
	          var classList = el.classList;
	
	          el.className = "datepicker-cell " + _this6.cellClass;
	          // reset text on every render to clear the custom content set
	          // by beforeShow hook at previous render
	          el.textContent = _this6.monthNames[index];
	
	          if (yrOutOfRange || isMinYear && index < _this6.minMonth || isMaxYear && index > _this6.maxMonth) {
	            classList.add("disabled");
	          }
	          if (selected.includes(index)) {
	            classList.add("selected");
	          }
	          if (index === _this6.focused) {
	            classList.add("focused");
	          }
	
	          if (_this6.beforeShow) {
	            _this6.performBeforeHook(el, index, dateValue(_this6.year, index, 1));
	          }
	        });
	      }
	
	      // Update the view UI by applying the changes of selected and focused items
	
	    }, {
	      key: "refresh",
	      value: function refresh() {
	        var _this7 = this;
	
	        var selected = this.selected[this.year] || [];
	        this.grid.querySelectorAll(".selected, .focused").forEach(function (el) {
	          el.classList.remove("selected", "focused");
	        });
	        Array.from(this.grid.children).forEach(function (el, index) {
	          var classList = el.classList;
	          if (selected.includes(index)) {
	            classList.add("selected");
	          }
	          if (index === _this7.focused) {
	            classList.add("focused");
	          }
	        });
	      }
	
	      // Update the view UI by applying the change of focused item
	
	    }, {
	      key: "refreshFocus",
	      value: function refreshFocus() {
	        this.grid.querySelectorAll(".focused").forEach(function (el) {
	          el.classList.remove("focused");
	        });
	        this.grid.children[this.focused].classList.add("focused");
	      }
	    }]);
	
	    return MonthsView;
	  }(View);
	
	  function toTitleCase(word) {
	    return [].concat(_toConsumableArray(word)).reduce(function (str, ch, ix) {
	      return str += ix ? ch : ch.toUpperCase();
	    }, "");
	  }
	
	  // Class representing the years and decades view elements
	
	  var YearsView = function (_View3) {
	    _inherits(YearsView, _View3);
	
	    function YearsView(picker, config) {
	      _classCallCheck(this, YearsView);
	
	      return _possibleConstructorReturn(this, (YearsView.__proto__ || Object.getPrototypeOf(YearsView)).call(this, picker, config));
	    }
	
	    _createClass(YearsView, [{
	      key: "init",
	      value: function init(options) {
	        var onConstruction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        if (onConstruction) {
	          this.navStep = this.step * 10;
	          this.beforeShowOption = "beforeShow" + toTitleCase(this.cellClass);
	          this.grid = this.element;
	          this.element.classList.add(this.name, "datepicker-grid");
	          this.grid.appendChild(parseHTML(createTagRepeat("span", 12)));
	        }
	        _get(YearsView.prototype.__proto__ || Object.getPrototypeOf(YearsView.prototype), "init", this).call(this, options);
	      }
	    }, {
	      key: "setOptions",
	      value: function setOptions(options) {
	        if (hasProperty(options, "minDate")) {
	          if (options.minDate === undefined) {
	            this.minYear = this.minDate = undefined;
	          } else {
	            this.minYear = startOfYearPeriod(options.minDate, this.step);
	            this.minDate = dateValue(this.minYear, 0, 1);
	          }
	        }
	        if (hasProperty(options, "maxDate")) {
	          if (options.maxDate === undefined) {
	            this.maxYear = this.maxDate = undefined;
	          } else {
	            this.maxYear = startOfYearPeriod(options.maxDate, this.step);
	            this.maxDate = dateValue(this.maxYear, 11, 31);
	          }
	        }
	        if (options[this.beforeShowOption] !== undefined) {
	          var beforeShow = options[this.beforeShowOption];
	          this.beforeShow = typeof beforeShow === "function" ? beforeShow : undefined;
	        }
	      }
	
	      // Update view's settings to reflect the viewDate set on the picker
	
	    }, {
	      key: "updateFocus",
	      value: function updateFocus() {
	        var viewDate = new Date(this.picker.viewDate);
	        var first = startOfYearPeriod(viewDate, this.navStep);
	        var last = first + 9 * this.step;
	
	        this.first = first;
	        this.last = last;
	        this.start = first - this.step;
	        this.switchLabel = first + "-" + last;
	        this.focused = startOfYearPeriod(viewDate, this.step);
	      }
	
	      // Update view's settings to reflect the selected dates
	
	    }, {
	      key: "updateSelection",
	      value: function updateSelection() {
	        var _this9 = this;
	
	        this.selected = this.picker.datepicker.dates.reduce(function (years, timeValue) {
	          return pushUnique(years, startOfYearPeriod(timeValue, _this9.step));
	        }, []);
	      }
	
	      // Update the entire view UI
	
	    }, {
	      key: "render",
	      value: function render() {
	        var _this10 = this;
	
	        // refresh disabled years on every render in order to clear the ones added
	        // by beforeShow hook at previous render
	        this.disabled = [];
	
	        this.picker.setViewSwitchLabel(this.switchLabel);
	        this.picker.setPrevBtnDisabled(this.first <= this.minYear);
	        this.picker.setNextBtnDisabled(this.last >= this.maxYear);
	
	        Array.from(this.grid.children).forEach(function (el, index) {
	          var classList = el.classList;
	          var current = _this10.start + index * _this10.step;
	
	          el.className = "datepicker-cell " + _this10.cellClass;
	          el.textContent = el.dataset.year = current;
	
	          if (index === 0) {
	            classList.add("prev");
	          } else if (index === 11) {
	            classList.add("next");
	          }
	          if (current < _this10.minYear || current > _this10.maxYear) {
	            classList.add("disabled");
	          }
	          if (_this10.selected.includes(current)) {
	            classList.add("selected");
	          }
	          if (current === _this10.focused) {
	            classList.add("focused");
	          }
	
	          if (_this10.beforeShow) {
	            _this10.performBeforeHook(el, current, dateValue(current, 0, 1));
	          }
	        });
	      }
	
	      // Update the view UI by applying the changes of selected and focused items
	
	    }, {
	      key: "refresh",
	      value: function refresh() {
	        var _this11 = this;
	
	        this.grid.querySelectorAll(".selected, .focused").forEach(function (el) {
	          el.classList.remove("selected", "focused");
	        });
	        Array.from(this.grid.children).forEach(function (el) {
	          var current = Number(el.textContent);
	          var classList = el.classList;
	          if (_this11.selected.includes(current)) {
	            classList.add("selected");
	          }
	          if (current === _this11.focused) {
	            classList.add("focused");
	          }
	        });
	      }
	
	      // Update the view UI by applying the change of focused item
	
	    }, {
	      key: "refreshFocus",
	      value: function refreshFocus() {
	        var index = Math.round((this.focused - this.start) / this.step);
	        this.grid.querySelectorAll(".focused").forEach(function (el) {
	          el.classList.remove("focused");
	        });
	        this.grid.children[index].classList.add("focused");
	      }
	    }]);
	
	    return YearsView;
	  }(View);
	
	  function triggerDatepickerEvent(datepicker, type) {
	    var detail = {
	      date: datepicker.getDate(),
	      viewDate: new Date(datepicker.picker.viewDate),
	      viewId: datepicker.picker.currentView.id,
	      datepicker: datepicker
	    };
	    datepicker.element.dispatchEvent(new CustomEvent(type, { detail: detail }));
	  }
	
	  // direction: -1 (to previous), 1 (to next)
	  function goToPrevOrNext(datepicker, direction) {
	    var _datepicker$config = datepicker.config,
	        minDate = _datepicker$config.minDate,
	        maxDate = _datepicker$config.maxDate;
	    var _datepicker$picker = datepicker.picker,
	        currentView = _datepicker$picker.currentView,
	        viewDate = _datepicker$picker.viewDate;
	
	    var newViewDate = void 0;
	    switch (currentView.id) {
	      case 0:
	        newViewDate = addMonths(viewDate, direction);
	        break;
	      case 1:
	        newViewDate = addYears(viewDate, direction);
	        break;
	      default:
	        newViewDate = addYears(viewDate, direction * currentView.navStep);
	    }
	    newViewDate = limitToRange(newViewDate, minDate, maxDate);
	    datepicker.picker.changeFocus(newViewDate).render();
	  }
	
	  function switchView(datepicker) {
	    var viewId = datepicker.picker.currentView.id;
	    if (viewId === datepicker.config.maxView) {
	      return;
	    }
	    datepicker.picker.changeView(viewId + 1).render();
	  }
	
	  function goToSelectedMonthOrYear(datepicker, selection) {
	    var picker = datepicker.picker;
	    var viewDate = new Date(picker.viewDate);
	    var viewId = picker.currentView.id;
	    var newDate = viewId === 1 ? addMonths(viewDate, selection - viewDate.getMonth()) : addYears(viewDate, selection - viewDate.getFullYear());
	
	    picker.changeFocus(newDate).changeView(viewId - 1).render();
	  }
	
	  function onClickTodayBtn(datepicker) {
	    var picker = datepicker.picker;
	    var currentDate = today();
	    if (datepicker.config.todayBtnMode === 1) {
	      if (datepicker.config.autohide) {
	        datepicker.setDate(currentDate);
	        return;
	      }
	      datepicker.setDate(currentDate, { render: false });
	      picker.update();
	    }
	    if (picker.viewDate !== currentDate) {
	      picker.changeFocus(currentDate);
	    }
	    picker.changeView(0).render();
	  }
	
	  function onClickClearBtn(datepicker) {
	    datepicker.setDate({ clear: true });
	  }
	
	  function onClickViewSwitch(datepicker) {
	    switchView(datepicker);
	  }
	
	  function onClickPrevBtn(datepicker) {
	    goToPrevOrNext(datepicker, -1);
	  }
	
	  function onClickNextBtn(datepicker) {
	    goToPrevOrNext(datepicker, 1);
	  }
	
	  // For the picker's main block to delegete the events from `datepicker-cell`s
	  function onClickView(datepicker, ev) {
	    var target = findElementInEventPath(ev, ".datepicker-cell");
	    if (!target || target.classList.contains("disabled")) {
	      return;
	    }
	
	    switch (datepicker.picker.currentView.id) {
	      case 0:
	        datepicker.setDate(Number(target.dataset.date));
	        break;
	      case 1:
	        goToSelectedMonthOrYear(datepicker, Number(target.dataset.month));
	        break;
	      default:
	        goToSelectedMonthOrYear(datepicker, Number(target.dataset.year));
	    }
	  }
	
	  function onClickPicker(datepicker, ev) {
	    ev.preventDefault();
	    ev.stopPropagation();
	
	    // check if the picker is active in order to prevent the picker from being
	    // re-shown after auto-hide when showOnFocus: true
	    // it's caused by bubbled event from cells/buttons, but the bubbling cannot
	    // be disabled because it's needed to keep the focus on the input element
	    if (!datepicker.inline && datepicker.picker.active && !datepicker.config.disableTouchKeyboard) {
	      datepicker.inputField.focus();
	    }
	  }
	
	  function processPickerOptions(picker, options) {
	    if (options.title !== undefined) {
	      if (options.title) {
	        picker.controls.title.textContent = options.title;
	        showElement(picker.controls.title);
	      } else {
	        picker.controls.title.textContent = "";
	        hideElement(picker.controls.title);
	      }
	    }
	    if (options.prevArrow) {
	      var prevBtn = picker.controls.prevBtn;
	      emptyChildNodes(prevBtn);
	      options.prevArrow.forEach(function (node) {
	        prevBtn.appendChild(node.cloneNode(true));
	      });
	    }
	    if (options.nextArrow) {
	      var nextBtn = picker.controls.nextBtn;
	      emptyChildNodes(nextBtn);
	      options.nextArrow.forEach(function (node) {
	        nextBtn.appendChild(node.cloneNode(true));
	      });
	    }
	    if (options.locale) {
	      picker.controls.todayBtn.textContent = options.locale.today;
	      picker.controls.clearBtn.textContent = options.locale.clear;
	    }
	    if (options.todayBtn !== undefined) {
	      if (options.todayBtn) {
	        showElement(picker.controls.todayBtn);
	      } else {
	        hideElement(picker.controls.todayBtn);
	      }
	    }
	    if (hasProperty(options, "minDate") || hasProperty(options, "maxDate")) {
	      var _picker$datepicker$co = picker.datepicker.config,
	          minDate = _picker$datepicker$co.minDate,
	          maxDate = _picker$datepicker$co.maxDate;
	
	      picker.controls.todayBtn.disabled = !isInRange(today(), minDate, maxDate);
	    }
	    if (options.clearBtn !== undefined) {
	      if (options.clearBtn) {
	        showElement(picker.controls.clearBtn);
	      } else {
	        hideElement(picker.controls.clearBtn);
	      }
	    }
	  }
	
	  // Compute view date to reset, which will be...
	  // - the last item of the selected dates or defaultViewDate if no selection
	  // - limitted to minDate or maxDate if it exceeds the range
	  function computeResetViewDate(datepicker) {
	    var dates = datepicker.dates,
	        config = datepicker.config;
	
	    var viewDate = dates.length > 0 ? lastItemOf(dates) : config.defaultViewDate;
	    return limitToRange(viewDate, config.minDate, config.maxDate);
	  }
	
	  // Change current view's view date
	  function setViewDate(picker, newDate) {
	    var oldViewDate = new Date(picker.viewDate);
	    var newViewDate = new Date(newDate);
	    var _picker$currentView = picker.currentView,
	        id = _picker$currentView.id,
	        year = _picker$currentView.year,
	        first = _picker$currentView.first,
	        last = _picker$currentView.last;
	
	    var viewYear = newViewDate.getFullYear();
	
	    picker.viewDate = newDate;
	    if (viewYear !== oldViewDate.getFullYear()) {
	      triggerDatepickerEvent(picker.datepicker, "changeYear");
	    }
	    if (newViewDate.getMonth() !== oldViewDate.getMonth()) {
	      triggerDatepickerEvent(picker.datepicker, "changeMonth");
	    }
	
	    // return whether the new date is in different period on time from the one
	    // displayed in the current view
	    // when true, the view needs to be re-rendered on the next UI refresh.
	    switch (id) {
	      case 0:
	        return newDate < first || newDate > last;
	      case 1:
	        return viewYear !== year;
	      default:
	        return viewYear < first || viewYear > last;
	    }
	  }
	
	  function getTextDirection(el) {
	    return window.getComputedStyle(el).direction;
	  }
	
	  // Class representing the picker UI
	
	  var Picker = function () {
	    function Picker(datepicker) {
	      _classCallCheck(this, Picker);
	
	      this.datepicker = datepicker;
	
	      var template = pickerTemplate.replace(/%buttonClass%/g, datepicker.config.buttonClass);
	      var element = this.element = parseHTML(template).firstChild;
	
	      var _element$firstChild$c = _slicedToArray(element.firstChild.children, 3),
	          header = _element$firstChild$c[0],
	          main = _element$firstChild$c[1],
	          footer = _element$firstChild$c[2];
	
	      var title = header.firstElementChild;
	
	      var _header$lastElementCh = _slicedToArray(header.lastElementChild.children, 3),
	          prevBtn = _header$lastElementCh[0],
	          viewSwitch = _header$lastElementCh[1],
	          nextBtn = _header$lastElementCh[2];
	
	      var _footer$firstChild$ch = _slicedToArray(footer.firstChild.children, 2),
	          todayBtn = _footer$firstChild$ch[0],
	          clearBtn = _footer$firstChild$ch[1];
	
	      var controls = {
	        title: title,
	        prevBtn: prevBtn,
	        viewSwitch: viewSwitch,
	        nextBtn: nextBtn,
	        todayBtn: todayBtn,
	        clearBtn: clearBtn
	      };
	      this.main = main;
	      this.controls = controls;
	
	      var elementClass = datepicker.inline ? "inline" : "dropdown";
	      element.classList.add("datepicker-" + elementClass);
	
	      processPickerOptions(this, datepicker.config);
	      this.viewDate = computeResetViewDate(datepicker);
	
	      // set up event listeners
	      registerListeners(datepicker, [[element, "click", onClickPicker.bind(null, datepicker)], [main, "click", onClickView.bind(null, datepicker)], [controls.viewSwitch, "click", onClickViewSwitch.bind(null, datepicker)], [controls.prevBtn, "click", onClickPrevBtn.bind(null, datepicker)], [controls.nextBtn, "click", onClickNextBtn.bind(null, datepicker)], [controls.todayBtn, "click", onClickTodayBtn.bind(null, datepicker)], [controls.clearBtn, "click", onClickClearBtn.bind(null, datepicker)]]);
	
	      // set up views
	      this.views = [new DaysView(this), new MonthsView(this), new YearsView(this, {
	        id: 2,
	        name: "years",
	        cellClass: "year",
	        step: 1
	      }), new YearsView(this, {
	        id: 3,
	        name: "decades",
	        cellClass: "decade",
	        step: 10
	      })];
	      this.currentView = this.views[datepicker.config.startView];
	
	      this.currentView.render();
	      this.main.appendChild(this.currentView.element);
	      datepicker.config.container.appendChild(this.element);
	    }
	
	    _createClass(Picker, [{
	      key: "setOptions",
	      value: function setOptions(options) {
	        processPickerOptions(this, options);
	        this.views.forEach(function (view) {
	          view.init(options, false);
	        });
	        this.currentView.render();
	      }
	    }, {
	      key: "detach",
	      value: function detach() {
	        this.datepicker.config.container.removeChild(this.element);
	      }
	    }, {
	      key: "show",
	      value: function show() {
	        if (this.active) {
	          return;
	        }
	        this.element.classList.add("active");
	        this.active = true;
	
	        var datepicker = this.datepicker;
	        if (!datepicker.inline) {
	          // ensure picker's direction matches input's
	          var inputDirection = getTextDirection(datepicker.inputField);
	          if (inputDirection !== getTextDirection(datepicker.config.container)) {
	            this.element.dir = inputDirection;
	          } else if (this.element.dir) {
	            this.element.removeAttribute("dir");
	          }
	
	          this.place();
	          if (datepicker.config.disableTouchKeyboard) {
	            datepicker.inputField.blur();
	          }
	        }
	        triggerDatepickerEvent(datepicker, "show");
	      }
	    }, {
	      key: "hide",
	      value: function hide() {
	        if (!this.active) {
	          return;
	        }
	        this.datepicker.exitEditMode();
	        this.element.classList.remove("active");
	        this.active = false;
	        triggerDatepickerEvent(this.datepicker, "hide");
	      }
	    }, {
	      key: "place",
	      value: function place() {
	        var _element = this.element,
	            classList = _element.classList,
	            style = _element.style;
	        var _datepicker = this.datepicker,
	            config = _datepicker.config,
	            inputField = _datepicker.inputField;
	
	        var container = config.container;
	
	        var _element$getBoundingC = this.element.getBoundingClientRect(),
	            calendarWidth = _element$getBoundingC.width,
	            calendarHeight = _element$getBoundingC.height;
	
	        var _container$getBoundin = container.getBoundingClientRect(),
	            containerLeft = _container$getBoundin.left,
	            containerTop = _container$getBoundin.top,
	            containerWidth = _container$getBoundin.width;
	
	        var _inputField$getBoundi = inputField.getBoundingClientRect(),
	            inputLeft = _inputField$getBoundi.left,
	            inputTop = _inputField$getBoundi.top,
	            inputWidth = _inputField$getBoundi.width,
	            inputHeight = _inputField$getBoundi.height;
	
	        var _config$orientation = config.orientation,
	            orientX = _config$orientation.x,
	            orientY = _config$orientation.y;
	
	        var scrollTop = void 0;
	        var left = void 0;
	        var top = void 0;
	
	        if (container === document.body) {
	          scrollTop = window.scrollY;
	          left = inputLeft + window.scrollX;
	          top = inputTop + scrollTop;
	        } else {
	          scrollTop = container.scrollTop;
	          left = inputLeft - containerLeft;
	          top = inputTop - containerTop + scrollTop;
	        }
	
	        if (orientX === "auto") {
	          if (left < 0) {
	            // align to the left and move into visible area if input's left edge < window's
	            orientX = "left";
	            left = 10;
	          } else if (left + calendarWidth > containerWidth) {
	            // align to the right if canlendar's right edge > container's
	            orientX = "right";
	          } else {
	            orientX = getTextDirection(inputField) === "rtl" ? "right" : "left";
	          }
	        }
	        if (orientX === "right") {
	          left -= calendarWidth - inputWidth;
	        }
	
	        if (orientY === "auto") {
	          orientY = top - calendarHeight < scrollTop ? "bottom" : "top";
	        }
	        if (orientY === "top") {
	          top -= calendarHeight;
	        } else {
	          top += inputHeight;
	        }
	
	        classList.remove("datepicker-orient-top", "datepicker-orient-bottom", "datepicker-orient-right", "datepicker-orient-left");
	        classList.add("datepicker-orient-" + orientY, "datepicker-orient-" + orientX);
	
	        style.top = top ? top + "px" : top;
	        style.left = left ? left + "px" : left;
	      }
	    }, {
	      key: "setViewSwitchLabel",
	      value: function setViewSwitchLabel(labelText) {
	        this.controls.viewSwitch.textContent = labelText;
	      }
	    }, {
	      key: "setPrevBtnDisabled",
	      value: function setPrevBtnDisabled(disabled) {
	        this.controls.prevBtn.disabled = disabled;
	      }
	    }, {
	      key: "setNextBtnDisabled",
	      value: function setNextBtnDisabled(disabled) {
	        this.controls.nextBtn.disabled = disabled;
	      }
	    }, {
	      key: "changeView",
	      value: function changeView(viewId) {
	        var oldView = this.currentView;
	        var newView = this.views[viewId];
	        if (newView.id !== oldView.id) {
	          this.currentView = newView;
	          this._renderMethod = "render";
	          triggerDatepickerEvent(this.datepicker, "changeView");
	          this.main.replaceChild(newView.element, oldView.element);
	        }
	        return this;
	      }
	
	      // Change the focused date (view date)
	
	    }, {
	      key: "changeFocus",
	      value: function changeFocus(newViewDate) {
	        this._renderMethod = setViewDate(this, newViewDate) ? "render" : "refreshFocus";
	        this.views.forEach(function (view) {
	          view.updateFocus();
	        });
	        return this;
	      }
	
	      // Apply the change of the selected dates
	
	    }, {
	      key: "update",
	      value: function update() {
	        var newViewDate = computeResetViewDate(this.datepicker);
	        this._renderMethod = setViewDate(this, newViewDate) ? "render" : "refresh";
	        this.views.forEach(function (view) {
	          view.updateFocus();
	          view.updateSelection();
	        });
	        return this;
	      }
	
	      // Refresh the picker UI
	
	    }, {
	      key: "render",
	      value: function render() {
	        var renderMethod = this._renderMethod || "render";
	        delete this._renderMethod;
	
	        this.currentView[renderMethod]();
	      }
	    }]);
	
	    return Picker;
	  }();
	
	  // Find the closest date that doesn't meet the condition for unavailable date
	  // Returns undefined if no available date is found
	  // addFn: function to calculate the next date
	  //   - args: time value, amount
	  // increase: amount to pass to addFn
	  // testFn: function to test the unavailablity of the date
	  //   - args: time value; retun: true if unavailable
	
	
	  function findNextAvailableOne(date, addFn, increase, testFn, min, max) {
	    if (!isInRange(date, min, max)) {
	      return;
	    }
	    if (testFn(date)) {
	      var newDate = addFn(date, increase);
	      return findNextAvailableOne(newDate, addFn, increase, testFn, min, max);
	    }
	    return date;
	  }
	
	  // direction: -1 (left/up), 1 (right/down)
	  // vertical: true for up/down, false for left/right
	  function moveByArrowKey(datepicker, ev, direction, vertical) {
	    var currentView = datepicker.picker.currentView;
	    var step = currentView.step || 1;
	    var viewDate = datepicker.picker.viewDate;
	    var addFn = void 0;
	    var testFn = void 0;
	    switch (currentView.id) {
	      case 0:
	        if (vertical) {
	          viewDate = addDays(viewDate, direction * 7);
	        } else if (ev.ctrlKey || ev.metaKey) {
	          viewDate = addYears(viewDate, direction);
	        } else {
	          viewDate = addDays(viewDate, direction);
	        }
	        addFn = addDays;
	        testFn = function testFn(date) {
	          return currentView.disabled.includes(date);
	        };
	        break;
	      case 1:
	        viewDate = addMonths(viewDate, vertical ? direction * 4 : direction);
	        addFn = addMonths;
	        testFn = function testFn(date) {
	          var dt = new Date(date);
	          var year = currentView.year,
	              disabled = currentView.disabled;
	
	          return dt.getFullYear() === year && disabled.includes(dt.getMonth());
	        };
	        break;
	      default:
	        viewDate = addYears(viewDate, direction * (vertical ? 4 : 1) * step);
	        addFn = addYears;
	        testFn = function testFn(date) {
	          return currentView.disabled.includes(startOfYearPeriod(date, step));
	        };
	    }
	    viewDate = findNextAvailableOne(viewDate, addFn, direction < 0 ? -step : step, testFn, currentView.minDate, currentView.maxDate);
	    if (viewDate !== undefined) {
	      datepicker.picker.changeFocus(viewDate).render();
	    }
	  }
	
	  function onKeydown(datepicker, ev) {
	    if (ev.key === "Tab") {
	      datepicker.refresh("input");
	      datepicker.hide();
	      return;
	    }
	
	    var viewId = datepicker.picker.currentView.id;
	    if (!datepicker.picker.active) {
	      switch (ev.key) {
	        case "ArrowDown":
	        case "Escape":
	          datepicker.picker.show();
	          break;
	        case "Enter":
	          datepicker.update();
	          break;
	        default:
	          return;
	      }
	    } else if (datepicker.editMode) {
	      switch (ev.key) {
	        case "Escape":
	          datepicker.exitEditMode();
	          break;
	        case "Enter":
	          datepicker.exitEditMode({
	            update: true,
	            autohide: datepicker.config.autohide
	          });
	          break;
	        default:
	          return;
	      }
	    } else {
	      switch (ev.key) {
	        case "Escape":
	          if (ev.shiftKey) {
	            datepicker.enterEditMode();
	          } else {
	            datepicker.picker.hide();
	          }
	          break;
	        case "ArrowLeft":
	          if (ev.ctrlKey || ev.metaKey) {
	            goToPrevOrNext(datepicker, -1);
	          } else {
	            moveByArrowKey(datepicker, ev, -1, false);
	          }
	          break;
	        case "ArrowRight":
	          if (ev.ctrlKey || ev.metaKey) {
	            goToPrevOrNext(datepicker, 1);
	          } else {
	            moveByArrowKey(datepicker, ev, 1, false);
	          }
	          break;
	        case "ArrowUp":
	          if (ev.ctrlKey || ev.metaKey) {
	            switchView(datepicker);
	          } else {
	            moveByArrowKey(datepicker, ev, -1, true);
	          }
	          break;
	        case "ArrowDown":
	          moveByArrowKey(datepicker, ev, 1, true);
	          break;
	        case "Enter":
	          if (viewId === 0) {
	            datepicker.setDate(datepicker.picker.viewDate);
	          } else {
	            datepicker.picker.changeView(viewId - 1).render();
	          }
	          break;
	        case "Backspace":
	        case "Delete":
	          datepicker.enterEditMode();
	          return;
	        default:
	          if (ev.key.length === 1 && !ev.ctrlKey && !ev.metaKey) {
	            datepicker.enterEditMode();
	          }
	          return;
	      }
	    }
	    ev.preventDefault();
	    ev.stopPropagation();
	  }
	
	  function onFocus(datepicker) {
	    if (datepicker.config.showOnFocus) {
	      datepicker.show();
	    }
	  }
	
	  // for the prevention for entering edit mode while getting focus on click
	  function onMousedown(datepicker, ev) {
	    var el = ev.target;
	    if (datepicker.picker.active) {
	      el._clicking = setTimeout(function () {
	        delete el._clicking;
	      }, 2000);
	    }
	  }
	
	  function onClickInput(datepicker, ev) {
	    var el = ev.target;
	    if (!el._clicking) {
	      return;
	    }
	    clearTimeout(el._clicking);
	    delete el._clicking;
	
	    datepicker.enterEditMode();
	  }
	
	  function onPaste(datepicker, ev) {
	    if (ev.clipboardData.types.includes("text/plain")) {
	      datepicker.enterEditMode();
	    }
	  }
	
	  // for the `document` to delegate the events from outside the picker/input field
	  function onClickOutside(datepicker, ev) {
	    var element = datepicker.element;
	    var pickerElem = datepicker.picker.element;
	
	    if (findElementInEventPath(ev, function (el) {
	      return el === element || el === pickerElem;
	    })) {
	      return;
	    }
	    datepicker.refresh("input");
	    datepicker.hide();
	  }
	
	  function stringifyDates(dates, config) {
	    return dates.map(function (dt) {
	      return _formatDate(dt, config.format, config.locale);
	    }).join(config.dateDelimiter);
	  }
	
	  // parse input dates and create an array of time values for selection
	  // returns undefined if there are no valid dates in inputDates
	  // when origDates (current selection) is passed, the function works to mix
	  // the input dates into the current selection
	  function processInputDates(inputDates, config) {
	    var origDates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	    if (inputDates.length === 0) {
	      // empty input is considered valid unless origiDates is passed
	      return origDates ? undefined : [];
	    }
	
	    var newDates = inputDates.reduce(function (dates, dt) {
	      var date = _parseDate(dt, config.format, config.locale);
	      if (date !== undefined && isInRange(date, config.minDate, config.maxDate) && !dates.includes(date) && !config.datesDisabled.includes(date) && !config.daysOfWeekDisabled.includes(new Date(date).getDay())) {
	        dates.push(date);
	      }
	      return dates;
	    }, []);
	    if (newDates.length === 0) {
	      return;
	    }
	    if (origDates && config.multidate) {
	      // get the synmetric difference between origDates and newDates
	      newDates = newDates.reduce(function (dates, date) {
	        if (!origDates.includes(date)) {
	          dates.push(date);
	        }
	        return dates;
	      }, origDates.filter(function (date) {
	        return !newDates.includes(date);
	      }));
	    }
	    // do length check always because user can input multiple dates regardless of the mode
	    return config.maxNumberOfDates && newDates.length > config.maxNumberOfDates ? newDates.slice(config.maxNumberOfDates * -1) : newDates;
	  }
	
	  /**
	   * Class representing a date picker
	   */
	
	  var Datepicker = function () {
	    /**
	     * Create a date picker
	     * @param  {Element} element - element to bind a date picker
	     * @param  {Object} [options] - config options
	     * @param  {DateRangePicker} [rangepicker] - DateRangePicker instance the
	     * date picker belongs to. Use this only when creating date picker as a part
	     * of date range picker
	     */
	    function Datepicker(element) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var rangepicker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	      _classCallCheck(this, Datepicker);
	
	      element.datepicker = this;
	      this.element = element;
	
	      // set up config
	      var config = this.config = Object.assign({
	        buttonClass: options.buttonClass && String(options.buttonClass) || "button",
	        container: document.body,
	        defaultViewDate: today(),
	        maxDate: undefined,
	        minDate: undefined
	      }, processOptions(defaultOptions, this));
	      this._options = options;
	      Object.assign(config, processOptions(options, this));
	
	      // configure by type
	      var inline = this.inline = element.tagName !== "INPUT";
	      var inputField = void 0;
	      var initialDates = void 0;
	
	      if (inline) {
	        config.container = element;
	        initialDates = stringToArray(element.dataset.date, config.dateDelimiter);
	        delete element.dataset.date;
	      } else {
	        var container = options.container ? document.querySelector(options.container) : null;
	        if (container) {
	          config.container = container;
	        }
	        inputField = this.inputField = element;
	        inputField.classList.add("datepicker-input");
	        initialDates = stringToArray(inputField.value, config.dateDelimiter);
	      }
	      // set initial value
	      this.dates = processInputDates(initialDates, config) || [];
	
	      if (rangepicker && rangepicker.constructor.name === "DateRangePicker") {
	        this.rangepicker = rangepicker;
	        // add getter for range
	        Object.defineProperty(this, "range", {
	          get: function get() {
	            return this.rangepicker.dates;
	          }
	        });
	      }
	
	      var picker = this.picker = new Picker(this);
	
	      if (inline) {
	        this.show();
	      } else {
	        // set up event listeners in other modes
	        var onMousedownDocument = onClickOutside.bind(null, this);
	        var listeners = [[inputField, "keydown", onKeydown.bind(null, this)], [inputField, "focus", onFocus.bind(null, this)], [inputField, "mousedown", onMousedown.bind(null, this)], [inputField, "click", onClickInput.bind(null, this)], [inputField, "paste", onPaste.bind(null, this)], [document, "mousedown", onMousedownDocument], [document, "touchstart", onMousedownDocument], [window, "resize", picker.place.bind(picker)]];
	        registerListeners(this, listeners);
	      }
	    }
	
	    /**
	     * Format Date object or time value in given format and language
	     * @param  {Date|Number} date - date or time value to format
	     * @param  {String|Object} format - format string or object that contains
	     * toDisplay() custom formatter, whose signature is
	     * - args:
	     *   - date: {Date} - Date instance of the date passed to the method
	     *   - format: {Object} - the format object passed to the method
	     *   - locale: {Object} - locale for the language specified by `lang`
	     * - return:
	     *     {String} formatted date
	     * @param  {String} [lang=en] - language code for the locale to use
	     * @return {String} formatted date
	     */
	
	
	    _createClass(Datepicker, [{
	      key: "setOptions",
	
	
	      /**
	       * Set new values to the config options
	       * @param {Object} options - config options to update
	       */
	      value: function setOptions(options) {
	        var picker = this.picker;
	        var newOptions = processOptions(options, this);
	        Object.assign(this._options, options);
	        Object.assign(this.config, newOptions);
	        picker.setOptions(newOptions);
	
	        var currentViewId = picker.currentView.id;
	        if (newOptions.maxView < currentViewId) {
	          picker.changeView(newOptions.maxView);
	        } else if (newOptions.startView !== undefined && !picker.active && newOptions.startView !== currentViewId) {
	          picker.changeView(newOptions.startView);
	        }
	
	        this.refresh();
	      }
	
	      /**
	       * Show the picker element
	       */
	
	    }, {
	      key: "show",
	      value: function show() {
	        if (this.inputField && this.inputField.disabled) {
	          return;
	        }
	        this.picker.show();
	      }
	
	      /**
	       * Hide the picker element
	       * Not avilable on inline picker
	       */
	
	    }, {
	      key: "hide",
	      value: function hide() {
	        if (this.inline) {
	          return;
	        }
	        this.picker.hide();
	        this.picker.update().changeView(this.config.startView).render();
	      }
	
	      /**
	       * Destroy the Datepicker instance
	       * @return {Detepicker} - the instance destroyed
	       */
	
	    }, {
	      key: "destroy",
	      value: function destroy() {
	        this.hide();
	        unregisterListeners(this);
	        this.picker.detach();
	        if (!this.inline) {
	          this.inputField.classList.remove("datepicker-input");
	        }
	        delete this.element.datepicker;
	        return this;
	      }
	
	      /**
	       * Get the selected date(s)
	       *
	       * The method returns a Date object of selected date by default, and returns
	       * an array of selected dates in multidate mode. If format string is passed,
	       * it returns date string(s) formatted in given format.
	       *
	       * @param  {String} [format] - Format string to stringify the date(s)
	       * @return {Date|String|Date[]|String[]} - selected date(s), or if none is
	       * selected, empty array in multidate mode and untitled in sigledate mode
	       */
	
	    }, {
	      key: "getDate",
	      value: function getDate() {
	        var _this12 = this;
	
	        var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	
	        var callback = format ? function (date) {
	          return _formatDate(date, format, _this12.config.locale);
	        } : function (date) {
	          return new Date(date);
	        };
	
	        if (this.config.multidate) {
	          return this.dates.map(callback);
	        }
	        if (this.dates.length > 0) {
	          return callback(this.dates[0]);
	        }
	      }
	
	      /**
	       * Set selected date(s)
	       *
	       * In multidate mode, you can pass multiple dates as a series of arguments
	       * or an array. (Since each date is parsed individually, the type of the
	       * dates doesn't have to be the same.)
	       * The given dates are used to toggle the select status of each date. The
	       * number of selected dates is kept from exceeding the length set to
	       * maxNumberOfDates.
	       *
	       * With clear: true option, the method can be used to clear the selection
	       * and to replace the selection instead of toggling in multidate mode.
	       * If the option is passed with no date arguments or an empty dates array,
	       * it works as "clear" (clear the selection then set nothing), and if the
	       * option is passed with new dates to select, it works as "replace" (clear
	       * the selection then set the given dates)
	       *
	       * When render: false option is used, the method omits re-rendering the
	       * picker element. In this case, you need to call refresh() method later in
	       * order for the picker element to reflect the changes. The input field is
	       * refreshed always regardless of this option.
	       *
	       * When invalid (unparsable, repeated, disabled or out-of-range) dates are
	       * passed, the method ignores them and applies only valid ones. In the case
	       * that all the given dates are invalid, which is distiguished from passing
	       * no dates, the method considers it as an error and leaves the selection
	       * untouched.
	       *
	       * @param {...(Date|Number|String)|Array} [dates] - Date strings, Date
	       * objects, time values or mix of those for new selection
	       * @param {Object} [options] - function options
	       * - clear: {boolean} - Whether to clear the existing selection
	       *     defualt: false
	       * - render: {boolean} - Whether to re-render the picker element
	       *     default: true
	       * - autohide: {boolean} - Whether to hide the picker element after re-render
	       *     Ignored when used with render: false
	       *     default: config.autohide
	       */
	
	    }, {
	      key: "setDate",
	      value: function setDate() {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }
	
	        var dates = [].concat(args);
	        var opts = {
	          clear: false,
	          render: true,
	          autohide: this.config.autohide
	        };
	        var lastArg = lastItemOf(args);
	        if ((typeof lastArg === "undefined" ? "undefined" : _typeof(lastArg)) === "object" && !Array.isArray(lastArg) && !(lastArg instanceof Date)) {
	          Object.assign(opts, dates.pop());
	        }
	
	        var inputDates = Array.isArray(dates[0]) ? dates[0] : dates;
	        var origDates = opts.clear ? undefined : this.dates;
	        var newDates = processInputDates(inputDates, this.config, origDates);
	        if (!newDates) {
	          return;
	        }
	        if (newDates.toString() !== this.dates.toString()) {
	          this.dates = newDates;
	          if (opts.render) {
	            this.picker.update();
	            this.refresh();
	          } else {
	            this.refresh("input");
	          }
	          triggerDatepickerEvent(this, "changeDate");
	        } else {
	          this.refresh("input");
	        }
	        if (opts.render && opts.autohide) {
	          this.hide();
	        }
	      }
	
	      /**
	       * Update the selected date(s) with input field's value
	       * Not avilable on inline picker
	       *
	       * The input field will be refreshed with properly formatted date string.
	       *
	       * @param  {Object} [options] - function options
	       * - autohide: {boolean} - whether to hide the picker element after refresh
	       *     default: false
	       */
	
	    }, {
	      key: "update",
	      value: function update() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	
	        if (this.inline) {
	          return;
	        }
	
	        var opts = Object.assign({ autohide: false }, options);
	        var inputDates = stringToArray(this.inputField.value, this.config.dateDelimiter);
	        var newDates = processInputDates(inputDates, this.config);
	        if (!newDates) {
	          return;
	        }
	        if (newDates.toString() !== this.dates.toString()) {
	          this.dates = newDates;
	          this.picker.update();
	          this.refresh();
	          triggerDatepickerEvent(this, "changeDate");
	        } else {
	          this.refresh("input");
	        }
	        if (opts.autohide) {
	          this.hide();
	        }
	      }
	
	      /**
	       * Refresh the picker element and the associated input field
	       * @param {String} [target] - target item when refreshing one item only
	       * 'picker' or 'input'
	       */
	
	    }, {
	      key: "refresh",
	      value: function refresh() {
	        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	
	        if (target !== "input") {
	          this.picker.render();
	        }
	        if (!this.inline && target !== "picker") {
	          this.inputField.value = stringifyDates(this.dates, this.config);
	        }
	      }
	
	      /**
	       * Enter edit mode
	       * Not avilable on inline picker or when the picker element is hidden
	       */
	
	    }, {
	      key: "enterEditMode",
	      value: function enterEditMode() {
	        if (this.inline || !this.picker.active || this.editMode) {
	          return;
	        }
	        this.editMode = true;
	        this.inputField.classList.add("in-edit");
	      }
	
	      /**
	       * Exit from edit mode
	       * Not avilable on inline picker
	       * @param  {Object} [options] - function options
	       * - update: {boolean} - whether to call update() after exiting
	       *     If false, input field is revert to the existing selection
	       *     default: false
	       */
	
	    }, {
	      key: "exitEditMode",
	      value: function exitEditMode() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	
	        if (this.inline || !this.editMode) {
	          return;
	        }
	        var opts = Object.assign({ update: false }, options);
	        delete this.editMode;
	        this.inputField.classList.remove("in-edit");
	        if (opts.update) {
	          this.update(opts);
	        } else {
	          this.inputField.value = stringifyDates(this.dates, this.config);
	        }
	      }
	    }, {
	      key: "active",
	
	
	      /**
	       * @type {Boolean} - Whether the picker element is shown. `true` whne shown
	       */
	      get: function get() {
	        return !!(this.picker && this.picker.active);
	      }
	    }], [{
	      key: "formatDate",
	      value: function formatDate(date, format, lang) {
	        return _formatDate(date, format, lang && locales[lang] || locales.en);
	      }
	
	      /**
	       * Pasre date string
	       * @param  {String|Date|Number} dateStr - date string, Date object or time
	       * value to parse
	       * @param  {String|Object} format - format string or object that contains
	       * toValue() custom parser, whose signature is
	       * - args:
	       *   - dateStr: {String|Date|Number} - the dateStr passed to the method
	       *   - format: {Object} - the format object passed to the method
	       *   - locale: {Object} - locale for the language specified by `lang`
	       * - return:
	       *     {Date|Number} parsed date or its time value
	       * @param  {String} [lang=en] - language code for the locale to use
	       * @return {Number} time value of parsed date
	       */
	
	    }, {
	      key: "parseDate",
	      value: function parseDate(dateStr, format, lang) {
	        return _parseDate(dateStr, format, lang && locales[lang] || locales.en);
	      }
	
	      /**
	       * @type {Object} - Installed locales in `[languageCode]: localeObject` format
	       * en`:_English (US)_ is pre-installed.
	       */
	
	    }, {
	      key: "locales",
	      get: function get() {
	        return locales;
	      }
	    }]);
	
	    return Datepicker;
	  }();
	
	  // filter out the config options inapproprite to pass to Datepicker
	
	
	  function filterOptions(options) {
	    var newOpts = Object.assign({}, options);
	
	    delete newOpts.inputs;
	    delete newOpts.allowOneSidedRange;
	    delete newOpts.maxNumberOfDates; // to ensure each datepicker handles a single date
	
	    return newOpts;
	  }
	
	  function setupDatepicker(rangepicker, changeDateListener, el, options) {
	    registerListeners(rangepicker, [[el, "changeDate", changeDateListener]]);
	    return new Datepicker(el, options, rangepicker);
	  }
	
	  function onChangeDate(rangepicker, ev) {
	    // to prevent both datepickers trigger the other side's update each other
	    if (rangepicker.updating) {
	      return;
	    }
	    rangepicker.updating = true;
	
	    var target = ev.target;
	    if (target.datepicker === undefined) {
	      return;
	    }
	
	    var datepickers = rangepicker.datepickers;
	    var setDateOptions = { render: false };
	    var changedSide = rangepicker.inputs.indexOf(target);
	    var otherSide = changedSide === 0 ? 1 : 0;
	    var changedDate = datepickers[changedSide].dates[0];
	    var otherDate = datepickers[otherSide].dates[0];
	
	    if (changedDate !== undefined && otherDate !== undefined) {
	      // if the start of the range > the end, swap them
	      if (changedSide === 0 && changedDate > otherDate) {
	        datepickers[0].setDate(otherDate, setDateOptions);
	        datepickers[1].setDate(changedDate, setDateOptions);
	      } else if (changedSide === 1 && changedDate < otherDate) {
	        datepickers[0].setDate(changedDate, setDateOptions);
	        datepickers[1].setDate(otherDate, setDateOptions);
	      }
	    } else if (!rangepicker.allowOneSidedRange) {
	      // to prevent the range from becoming one-sided, copy changed side's
	      // selection (no matter if it's empty) to the other side
	      if (changedDate !== undefined || otherDate !== undefined) {
	        setDateOptions.clear = true;
	        datepickers[otherSide].setDate(datepickers[changedSide].dates, setDateOptions);
	      }
	    }
	    datepickers[0].picker.update().render();
	    datepickers[1].picker.update().render();
	    delete rangepicker.updating;
	  }
	
	  /**
	   * Class representing a date range picker
	   */
	
	  var DateRangePicker = function () {
	    /**
	     * Create a date range picker
	     * @param  {Element} element - element to bind a date range picker
	     * @param  {Object} [options] - config options
	     */
	    function DateRangePicker(element) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      _classCallCheck(this, DateRangePicker);
	
	      var inputs = Array.isArray(options.inputs) ? options.inputs : Array.from(element.querySelectorAll("input"));
	      if (inputs.length < 2) {
	        return;
	      }
	
	      element.rangepicker = this;
	      this.element = element;
	      this.inputs = inputs.slice(0, 2);
	      this.allowOneSidedRange = !!options.allowOneSidedRange;
	
	      var changeDateListener = onChangeDate.bind(null, this);
	      var cleanOptions = filterOptions(options);
	      this.datepickers = [setupDatepicker(this, changeDateListener, this.inputs[0], cleanOptions), setupDatepicker(this, changeDateListener, this.inputs[1], cleanOptions)];
	      // normalize the range if inital dates are given
	      if (this.dates[0] !== undefined) {
	        onChangeDate(this, { target: this.inputs[0] });
	      } else if (this.dates[1] !== undefined) {
	        onChangeDate(this, { target: this.inputs[1] });
	      }
	    }
	
	    /**
	     * @type {Array} - selected date of the linked date pickers
	     */
	
	
	    _createClass(DateRangePicker, [{
	      key: "setOptions",
	
	
	      /**
	       * Set new values to the config options
	       * @param {Object} options - config options to update
	       */
	      value: function setOptions(options) {
	        this.allowOneSidedRange = !!options.allowOneSidedRange;
	
	        var cleanOptions = filterOptions(options);
	        this.datepickers[0].setOptions(cleanOptions);
	        this.datepickers[1].setOptions(cleanOptions);
	      }
	
	      /**
	       * Destroy the DateRangePicker instance
	       * @return {DateRangePicker} - the instance destroyed
	       */
	
	    }, {
	      key: "destroy",
	      value: function destroy() {
	        this.datepickers[0].destroy();
	        this.datepickers[1].destroy();
	        unregisterListeners(this);
	        delete this.element.rangepicker;
	      }
	
	      /**
	       * Get the start and end dates of the date range
	       *
	       * The method returns Date objects by default. If format string is passed,
	       * it returns date strings formatted in given format.
	       * The result array always contains 2 items (start date/end date) and
	       * undifined is used for unselected side. (e.g. If none is selected,
	       * the result will be [undifined, undifined]. If only the end date is set
	       * when allowOneSidedRange config option is true, [undifined, endDate] will
	       * be returned.)
	       *
	       * @param  {String} [format] - Format string to stringify the dates
	       * @return {Array} - Start and end dates
	       */
	
	    }, {
	      key: "getDates",
	      value: function getDates() {
	        var _this13 = this;
	
	        var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	
	        var callback = format ? function (date) {
	          return _formatDate(date, format, _this13.datepickers[0].config.locale);
	        } : function (date) {
	          return new Date(date);
	        };
	
	        return this.dates.map(function (date) {
	          return date === undefined ? date : callback(date);
	        });
	      }
	    }, {
	      key: "dates",
	      get: function get() {
	        if (this.datepickers) {
	          return [this.datepickers[0].dates[0], this.datepickers[1].dates[0]];
	        }
	      }
	    }]);
	
	    return DateRangePicker;
	  }();
	
	  window.Datepicker = Datepicker;
	  window.DateRangePicker = DateRangePicker;
	})();

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _home = __webpack_require__(254);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _about = __webpack_require__(260);
	
	var _about2 = _interopRequireDefault(_about);
	
	var _accounttype = __webpack_require__(266);
	
	var _accounttype2 = _interopRequireDefault(_accounttype);
	
	var _signin = __webpack_require__(272);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _signon = __webpack_require__(280);
	
	var _signon2 = _interopRequireDefault(_signon);
	
	var _signup = __webpack_require__(286);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _postashiftwalkthrough = __webpack_require__(305);
	
	var _postashiftwalkthrough2 = _interopRequireDefault(_postashiftwalkthrough);
	
	var _references = __webpack_require__(358);
	
	var _references2 = _interopRequireDefault(_references);
	
	var _events = __webpack_require__(389);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _recoverpassword = __webpack_require__(396);
	
	var _recoverpassword2 = _interopRequireDefault(_recoverpassword);
	
	var _recoverpasswordsuccess = __webpack_require__(402);
	
	var _recoverpasswordsuccess2 = _interopRequireDefault(_recoverpasswordsuccess);
	
	var _onboarding = __webpack_require__(408);
	
	var _onboarding2 = _interopRequireDefault(_onboarding);
	
	var _onboarding3 = __webpack_require__(414);
	
	var _onboarding4 = _interopRequireDefault(_onboarding3);
	
	var _onboarding5 = __webpack_require__(420);
	
	var _onboarding6 = _interopRequireDefault(_onboarding5);
	
	var _eventoverview = __webpack_require__(426);
	
	var _eventoverview2 = _interopRequireDefault(_eventoverview);
	
	var _inbox = __webpack_require__(432);
	
	var _inbox2 = _interopRequireDefault(_inbox);
	
	var _billing = __webpack_require__(440);
	
	var _billing2 = _interopRequireDefault(_billing);
	
	var _transactionhistory = __webpack_require__(446);
	
	var _transactionhistory2 = _interopRequireDefault(_transactionhistory);
	
	var _eventeditdetails = __webpack_require__(452);
	
	var _eventeditdetails2 = _interopRequireDefault(_eventeditdetails);
	
	var _eventreviewapplicants = __webpack_require__(458);
	
	var _eventreviewapplicants2 = _interopRequireDefault(_eventreviewapplicants);
	
	var _rejectedapplicants = __webpack_require__(465);
	
	var _rejectedapplicants2 = _interopRequireDefault(_rejectedapplicants);
	
	var _messaging = __webpack_require__(471);
	
	var _messaging2 = _interopRequireDefault(_messaging);
	
	var _eventroster = __webpack_require__(479);
	
	var _eventroster2 = _interopRequireDefault(_eventroster);
	
	var _jobsdashboard = __webpack_require__(488);
	
	var _jobsdashboard2 = _interopRequireDefault(_jobsdashboard);
	
	var _eventlive = __webpack_require__(492);
	
	var _eventlive2 = _interopRequireDefault(_eventlive);
	
	var _eventcomplete = __webpack_require__(500);
	
	var _eventcomplete2 = _interopRequireDefault(_eventcomplete);
	
	var _eventshistory = __webpack_require__(506);
	
	var _eventshistory2 = _interopRequireDefault(_eventshistory);
	
	var _invoice = __webpack_require__(512);
	
	var _invoice2 = _interopRequireDefault(_invoice);
	
	var _jobbler = __webpack_require__(518);
	
	var _jobbler2 = _interopRequireDefault(_jobbler);
	
	var _ordersmasterlist = __webpack_require__(526);
	
	var _ordersmasterlist2 = _interopRequireDefault(_ordersmasterlist);
	
	var _basicprofile = __webpack_require__(533);
	
	var _basicprofile2 = _interopRequireDefault(_basicprofile);
	
	var _preferences = __webpack_require__(541);
	
	var _preferences2 = _interopRequireDefault(_preferences);
	
	var _banking = __webpack_require__(547);
	
	var _banking2 = _interopRequireDefault(_banking);
	
	var _teams = __webpack_require__(553);
	
	var _teams2 = _interopRequireDefault(_teams);
	
	var _teamdetails = __webpack_require__(559);
	
	var _teamdetails2 = _interopRequireDefault(_teamdetails);
	
	var _connections = __webpack_require__(566);
	
	var _connections2 = _interopRequireDefault(_connections);
	
	var _uber = __webpack_require__(572);
	
	var _uber2 = _interopRequireDefault(_uber);
	
	var _ubercampaign = __webpack_require__(578);
	
	var _ubercampaign2 = _interopRequireDefault(_ubercampaign);
	
	var _profiles = __webpack_require__(584);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	var _jobs = __webpack_require__(590);
	
	var _jobs2 = _interopRequireDefault(_jobs);
	
	var _postevent = __webpack_require__(599);
	
	var _postevent2 = _interopRequireDefault(_postevent);
	
	var _postjobbulk = __webpack_require__(605);
	
	var _postjobbulk2 = _interopRequireDefault(_postjobbulk);
	
	var _postorder = __webpack_require__(611);
	
	var _postorder2 = _interopRequireDefault(_postorder);
	
	var _posttypes = __webpack_require__(617);
	
	var _posttypes2 = _interopRequireDefault(_posttypes);
	
	var _charges = __webpack_require__(623);
	
	var _charges2 = _interopRequireDefault(_charges);
	
	var _transfers = __webpack_require__(629);
	
	var _transfers2 = _interopRequireDefault(_transfers);
	
	var _accountprofile = __webpack_require__(635);
	
	var _accountprofile2 = _interopRequireDefault(_accountprofile);
	
	var _directpay = __webpack_require__(643);
	
	var _directpay2 = _interopRequireDefault(_directpay);
	
	var _payshifts = __webpack_require__(651);
	
	var _payshifts2 = _interopRequireDefault(_payshifts);
	
	var _admindash = __webpack_require__(655);
	
	var _admindash2 = _interopRequireDefault(_admindash);
	
	var _admintransactions = __webpack_require__(661);
	
	var _admintransactions2 = _interopRequireDefault(_admintransactions);
	
	var _adminevents = __webpack_require__(667);
	
	var _adminevents2 = _interopRequireDefault(_adminevents);
	
	var _adminapplicants = __webpack_require__(673);
	
	var _adminapplicants2 = _interopRequireDefault(_adminapplicants);
	
	var _adminopenings = __webpack_require__(679);
	
	var _adminopenings2 = _interopRequireDefault(_adminopenings);
	
	var _adminhires = __webpack_require__(685);
	
	var _adminhires2 = _interopRequireDefault(_adminhires);
	
	var _adminwithdrawals = __webpack_require__(691);
	
	var _adminwithdrawals2 = _interopRequireDefault(_adminwithdrawals);
	
	var _jobdetails = __webpack_require__(697);
	
	var _jobdetails2 = _interopRequireDefault(_jobdetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentModule = _angular2.default.module("app.components", [_home2.default.name, _about2.default.name, _accounttype2.default.name, _signin2.default.name, _invoice2.default.name, _signup2.default.name, _signon2.default.name, _jobsdashboard2.default.name, _postashiftwalkthrough2.default.name, _references2.default.name, _payshifts2.default.name, _recoverpassword2.default.name, _rejectedapplicants2.default.name, _basicprofile2.default.name, _preferences2.default.name, _postjobbulk2.default.name, _billing2.default.name, _banking2.default.name, _posttypes2.default.name, _charges2.default.name, _transfers2.default.name, _recoverpasswordsuccess2.default.name, _events2.default.name, _onboarding2.default.name, _uber2.default.name, _ubercampaign2.default.name, _jobbler2.default.name, _onboarding4.default.name, _jobs2.default.name, _teamdetails2.default.name, _onboarding6.default.name, _ordersmasterlist2.default.name, _eventoverview2.default.name, _inbox2.default.name, _transactionhistory2.default.name, _eventeditdetails2.default.name, _eventreviewapplicants2.default.name, _messaging2.default.name, _eventroster2.default.name, _eventlive2.default.name, _eventcomplete2.default.name, _jobdetails2.default.name, _eventshistory2.default.name, _teams2.default.name, _connections2.default.name, _profiles2.default.name, _postevent2.default.name, _postorder2.default.name, _accountprofile2.default.name, _directpay2.default.name, _admindash2.default.name, _admintransactions2.default.name, _adminevents2.default.name, _adminapplicants2.default.name, _adminopenings2.default.name, _adminhires2.default.name, _adminwithdrawals2.default.name]);
	
	exports.default = componentModule;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _home = __webpack_require__(255);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homeModule = _angular2.default.module("home", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  // $urlRouterProvider.otherwise('/');
	
	  $stateProvider.state("home", {
	    url: "/home",
	    template: "<home></home>"
	  });
	}).component("home", _home2.default);
	
	exports.default = homeModule;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _home = __webpack_require__(256);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _home3 = __webpack_require__(257);
	
	var _home4 = _interopRequireDefault(_home3);
	
	__webpack_require__(258);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homeComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _home2.default,
	  controller: _home4.default,
	  controllerAs: "vm"
	};
	
	exports.default = homeComponent;

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	module.exports = "<navbar></navbar>\n<header>\n  <hero></hero>\n</header>\n<main>\n  <div>\n    <h1>Found in {{ vm.name }}.html</h1>\n  </div>\n</main>\n"

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HomeController = function HomeController() {
	  _classCallCheck(this, HomeController);
	
	  this.name = "home";
	};
	
	exports.default = HomeController;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(259);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./home.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./home.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".home{color:red}", ""]);
	
	// exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _about = __webpack_require__(261);
	
	var _about2 = _interopRequireDefault(_about);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var aboutModule = _angular2.default.module("about", [_angularUiRouter2.default]).config(function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("about", {
	    url: "/welcome",
	    template: "<about></about>"
	  });
	}).component("about", _about2.default);
	
	exports.default = aboutModule;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _about = __webpack_require__(262);
	
	var _about2 = _interopRequireDefault(_about);
	
	var _about3 = __webpack_require__(263);
	
	var _about4 = _interopRequireDefault(_about3);
	
	__webpack_require__(264);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var aboutComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _about2.default,
	  controller: _about4.default,
	  controllerAs: "vm"
	};
	
	exports.default = aboutComponent;

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	module.exports = "<style>\n  h1.welcome-text {\n    font-family: Poppins;\n    text-align: center;\n    padding-top: 60px;\n  }\n</style>\n\n<jobbleheader></jobbleheader>\n\n<div style=\"min-height: 100vh\">\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <h1 class=\"welcome-text\">Thank you for verifying your email address!</h1>\n    </div>\n  </div>\n  <div class=\"row\" style=\"text-align: center\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <img src=\"app/vendor/images/welcome-check.png\" style=\"width: 10%\" />\n    </div>\n  </div>\n</div>\n\n<jobblefooter></jobblefooter>\n"

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AboutController = function AboutController() {
	  _classCallCheck(this, AboutController);
	
	  this.name = "about";
	};
	
	exports.default = AboutController;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(265);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./about.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./about.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".about{color:red}", ""]);
	
	// exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _accounttype = __webpack_require__(267);
	
	var _accounttype2 = _interopRequireDefault(_accounttype);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accounttypeModule = _angular2.default.module("accounttype", [_angularUiRouter2.default]).config(function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("accounttype", {
	    url: "/choose-account-type",
	    template: "<accounttype></accounttype>",
	    title: "Choose account type"
	  });
	}).component("accounttype", _accounttype2.default);
	
	exports.default = accounttypeModule;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _accounttype = __webpack_require__(268);
	
	var _accounttype2 = _interopRequireDefault(_accounttype);
	
	var _accounttype3 = __webpack_require__(269);
	
	var _accounttype4 = _interopRequireDefault(_accounttype3);
	
	__webpack_require__(270);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accounttypeComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _accounttype2.default,
	  controller: _accounttype4.default,
	  controllerAs: "vm"
	};
	
	exports.default = accounttypeComponent;

/***/ }),
/* 268 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<div class=\"account-type-wrapper\">\n  <div class=\"account-type-header\">\n    <h2>I want to...</h2>\n  </div>\n\n  <div class=\"account-type-body\">\n    <div class=\"row\">\n      <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n        <div class=\"account-type-business\">\n          <img src=\"app/vendor/images/account-type-business.png\" />\n        </div>\n      </div>\n      <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n        <div class=\"account-type-jobblers\">\n          <img src=\"app/vendor/images/account-type-jobblers.png\" />\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n        <div class=\"hire-jobblers-wrapper\">\n          <a href=\"/signup/company\" class=\"account-type-button\"> HIRE JOBBLERS </a>\n        </div>\n      </div>\n      <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n        <div class=\"find-work-wrapper\">\n          <a href=\"/signon?accountType=jobbler\" class=\"account-type-button\"> FIND WORK </a>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AccounttypeController = function AccounttypeController($http, $localStorage, $state, AuthService, SecurityService, $timeout) {
	  _classCallCheck(this, AccounttypeController);
	
	  this.name = "accounttype";
	  $localStorage.activeStateName = "accounttype";
	
	  this.$http = $http;
	  this.$localStorage = $localStorage;
	  this.$state = $state;
	  this.$auth = AuthService;
	  this.$security = SecurityService;
	  this.$timeout = $timeout;
	  this.pages = [];
	  this.currentUser = this.$auth.getUserData();
	
	  var _this = this;
	};
	
	AccounttypeController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "$timeout"];
	
	exports.default = AccounttypeController;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(271);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./accounttype.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./accounttype.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".account-type-wrapper{width:100%;margin:0 auto}.account-type-wrapper .account-type-header{text-align:center;padding-top:70px;margin-bottom:80px}.account-type-wrapper .account-type-header h2{color:#33373a;font-family:Poppins;font-size:22px;font-weight:600;letter-spacing:0;line-height:32px}.account-type-body{display:block;padding-left:15px;padding-right:15px;padding-bottom:200px}.account-type-body .account-type-wrapper{margin:0 auto}.account-type-body .account-type-business{padding-right:50px}.account-type-body .account-type-business img{float:right}.account-type-body .account-type-jobblers{padding-left:50px}.hire-jobblers-wrapper{padding-top:30px;padding-bottom:100px;padding-right:50px}.find-work-wrapper{padding-top:30px;padding-bottom:100px;padding-left:50px}.find-work-wrapper a{float:left}.hire-jobblers-wrapper a{float:right}a.account-type-button{text-align:center;border:2px solid #eee;padding:12px 28px;color:#33373a;font-family:Poppins;font-size:17px;font-weight:600;letter-spacing:0;line-height:21px;width:190px;border-image:linear-gradient(90deg,#62c046,#5498b4) 2;transition:.5s}a.account-type-button:hover{border:1px solid #74cf59;background-color:#74cf59;color:#fff}@media screen and (max-width:996px){.account-type-body .account-type-business img{width:25%;margin-right:40px}.account-type-body .account-type-jobblers img{width:25%;margin-left:52px}}@media screen and (max-width:500px){.account-type-body .account-type-business img,.account-type-body .account-type-jobblers img{display:none}.hire-jobblers-wrapper{padding-right:0}.find-work-wrapper{padding-left:0}}", ""]);
	
	// exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _signin = __webpack_require__(273);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var signinModule = _angular2.default.module("signin", [_angularUiRouter2.default, "ngStorage"]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("signin", {
	    url: "/signin",
	    template: "<signin></signin>",
	    title: "Sign in",
	    params: {
	      onRefresh: null,
	      job_posting_type: null,
	      job_title: null,
	      jobble_type: null,
	      pay_rate: null,
	      pay_rate_jblr: null,
	      dress_code: null,
	      job_description: null,
	      hourly_rate: null,
	      t: null,
	      preserve: null,
	      date_time: null,
	      instructions: null,
	      location: null,
	      street_line_1: null,
	      signindata: null,
	      signUpEmail: null
	    }
	  });
	}).component("signin", _signin2.default);
	
	exports.default = signinModule;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _signin = __webpack_require__(274);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _signin3 = __webpack_require__(275);
	
	var _signin4 = _interopRequireDefault(_signin3);
	
	__webpack_require__(278);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var signinComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _signin2.default,
	  controller: _signin4.default,
	  controllerAs: "vm"
	};
	
	exports.default = signinComponent;

/***/ }),
/* 274 */
/***/ (function(module, exports) {

	module.exports = "s<style>\n  .login-area {\n    background: url(/app/vendor/images/login-bg2.png) no-repeat 0 0;\n    background-size: cover;\n    min-height: 916px;\n  }\n\n  .login-wrap {\n    max-width: 785px;\n    margin: 0 auto;\n    padding: 75px 0 0;\n  }\n\n  .login-wrap h2 {\n    color: #ffffff;\n    text-transform: uppercase;\n    font-size: 22px;\n    font-weight: 700;\n    line-height: normal;\n    margin: 0 0 33px;\n    text-align: center;\n  }\n\n  .login-container {\n    background-color: #ffffff;\n  }\n\n  .login-container form {\n    margin: 0;\n  }\n\n  .login-content {\n    max-width: 384px;\n    margin: 0 auto 9px;\n    padding: 75px 0 85px;\n  }\n\n  .login-content label {\n    display: block;\n    color: #3b3f43;\n    margin: 0 0 8px;\n    font-size: 15px;\n    font-weight: 300;\n  }\n\n  .login-content input[type=\"text\"],\n  .login-content input[type=\"password\"],\n  .login-content input[type=\"email\"] {\n    display: block;\n    border: 1px solid #c3cdd1;\n    background: #fff;\n    width: 100%;\n    padding: 10px 10px 10px 35px;\n    caret-color: #494949;\n    margin: 0 0 15px;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    -ms-appearance: none;\n  }\n\n  .login-content input[type=\"text\"]:focus {\n    border: 1px solid #74cf59;\n  }\n\n  .login-content input[type=\"password\"]:focus {\n    border: 1px solid #74cf59;\n  }\n\n  .login-content input[type=\"email\"]:focus {\n    border: 1px solid #74cf59;\n  }\n\n  .loader-holder {\n    position: absolute;\n    right: 29px;\n    top: 17px;\n  }\n\n  .loader-holder i {\n    color: #fff;\n    z-index: 100;\n  }\n\n  .login-content input[type=\"text\"]:focus,\n  .login-content input[type=\"password\"]:focus,\n  .login-content input[type=\"email\"]:focus,\n  .login-content input[type=\"email\"]:focus {\n    outline: 0;\n  }\n\n  .input-submit {\n    overflow: hidden;\n    margin: 15px 0px 12px;\n    padding-left: 15px;\n    padding-right: 15px;\n    position: relative;\n  }\n\n  .login-content a.f-pass {\n    color: #2c3a40;\n    font-size: 14px;\n    font-weight: 300;\n    display: block;\n  }\n\n  .login-content input[type=\"submit\"] {\n    width: 100%;\n    display: block;\n    font-weight: 700;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    -ms-appearance: none;\n  }\n\n  .login-content input[type=\"submit\"]:disabled {\n    background-color: #74cf59;\n  }\n\n  .signup-area-xs {\n    display: none;\n  }\n\n  .signup-area,\n  .signup-area-xs {\n    border: 1px solid #ffffff;\n    padding: 19px 22px;\n    overflow: hidden;\n    margin: 0 0 40px;\n  }\n\n  .signup-area span,\n  .signup-area-xs span {\n    color: #ffffff;\n    font-size: 16px;\n    font-weight: 300;\n    line-height: 40px;\n  }\n\n  .signup-area .btn.btn-default,\n  .signup-area-xs .btn.btn-default {\n    font-weight: 700;\n    width: 190px;\n  }\n\n  .login-meta {\n    text-align: center;\n    color: #ffffff;\n    font-size: 14px;\n    font-weight: 300;\n  }\n\n  .login-meta a {\n    color: #ffffff;\n  }\n\n  .input-bg {\n    position: relative;\n  }\n\n  .input-bg::before {\n    font-family: \"FontAwesome\";\n    font-size: 17px;\n    left: 12px;\n    position: absolute;\n    top: 10px;\n    color: #3b3f43;\n  }\n\n  .btn-default:hover,\n  .btn-default:focus,\n  .btn-default.active {\n    background-color: #5e666d;\n    color: #fff;\n    border-color: #5e666d;\n  }\n\n  .btn.btn-inverse:hover,\n  .button.hollow:focus {\n    border-color: #5e666d;\n    color: #5e666d;\n  }\n\n  .input-bg.name:before {\n    content: \"\\f007\";\n  }\n\n  .input-bg.password:before {\n    content: \"\\f023\";\n  }\n\n  .btn-default {\n    background-color: #74cf59;\n    color: #fff;\n    border-color: #74cf59;\n  }\n\n  .btn {\n    padding: 9px 20px;\n    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n    border-radius: 2px;\n    transition: all 0.25s ease-in-out;\n  }\n\n  .btn.btn-inverse {\n    border: 1px solid #b7c0c5;\n    color: #5e666d;\n    font-size: 14px;\n  }\n\n  @media only screen and (max-width: 1024px) {\n    .login-wrap {\n      max-width: 700px;\n    }\n  }\n\n  @media only screen and (max-width: 979px) {\n    .login-wrap {\n      max-width: 600px;\n    }\n\n    .signup-area {\n      display: none;\n    }\n\n    .signup-area-xs {\n      text-align: center;\n      display: block;\n    }\n\n    .signup-area-xs .btn {\n      margin-top: 10px;\n    }\n  }\n\n  @media only screen and (max-width: 767px) {\n    .login-area {\n      padding: 0 20px;\n    }\n    .login-wrap {\n      max-width: none;\n    }\n    .login-content {\n      padding: 60px;\n      max-width: none;\n    }\n  }\n\n  @media only screen and (max-width: 639px) {\n    .input-submit {\n      margin: 25px 0 0;\n    }\n    .login-content a.f-pass {\n      float: none !important;\n      margin: 0 0 20px;\n      text-align: center;\n    }\n    .login-content a.f-pass br {\n      display: none;\n    }\n    .login-content input[type=\"submit\"] {\n      margin: 0 auto;\n      display: block;\n      float: none !important;\n    }\n  }\n\n  @media only screen and (max-width: 479px) {\n    .login-content {\n      padding: 25px;\n    }\n\n    .signup-area span {\n      display: block;\n      font-size: 14px;\n      line-height: normal;\n      margin: 0 0 15px;\n      text-align: center;\n    }\n    .signup-area .btn.btn-default {\n      display: block;\n      float: none !important;\n      margin: 0 auto;\n    }\n  }\n\n  /* Alert */\n  .alert {\n    margin-top: 10px;\n    padding: 20px;\n    background-color: #f44336; /* Red */\n    color: white;\n    margin-bottom: 15px;\n  }\n\n  /* The close button */\n  .closebtn {\n    margin-left: 15px;\n    color: white;\n    font-weight: bold;\n    float: right;\n    font-size: 22px;\n    line-height: 20px;\n    cursor: pointer;\n    transition: 0.3s;\n  }\n\n  /* When moving the mouse over the close button */\n  .closebtn:hover {\n    color: black;\n  }\n\n  .header-top {\n    padding: 10px 20px;\n    background-color: #fff;\n  }\n\n  .top-right {\n    margin: 5px 0px;\n  }\n\n  .top-menu {\n    float: right;\n    margin: 10px 30px 6px 0px;\n  }\n\n  .top-menu ul {\n    padding: 0px;\n    margin: 0px;\n    list-style: none;\n  }\n\n  .top-menu li {\n    display: block;\n    float: left;\n    margin: 0px 12px;\n  }\n\n  .login-container.radius-adjust {\n    border-radius: 5px;\n  }\n\n  .login-container .preserve-message {\n    padding: 10px 30px 10px 30px;\n    margin-bottom: 20px;\n    background-color: #f00;\n    border-radius: 5px;\n    opacity: 0.5;\n  }\n\n  .login-container .preserve-message a {\n    color: #fff;\n    text-decoration: underline;\n  }\n\n  .login-container .preserve-message p {\n    color: #fff;\n  }\n\n  .login-container .preserve-message h3 {\n    color: #fff;\n    padding-top: 0px;\n    margin-top: 0px;\n  }\n\n  .top-menu li a {\n    display: inline-block;\n    color: #5e666d;\n    font-size: 17px;\n    font-weight: 300;\n    padding-bottom: 3px;\n    border-bottom: 2px solid transparent;\n  }\n\n  .top-menu li a:hover {\n    border-bottom-color: #74cf59;\n  }\n\n  .top-menu li.active a {\n    border-bottom-color: #74cf59;\n    font-weight: 700;\n  }\n\n  .navbar-toggle .icon-bar {\n    background-color: #74cf59;\n  }\n\n  .header-login-btn {\n    margin-top: 7px;\n  }\n\n  .header-login-btn a {\n    width: 105px;\n    margin-left: 6px;\n    font-weight: 700;\n  }\n\n  @media (max-width: 991px) {\n    .top-menu li a {\n      font-size: 14px;\n    }\n    .header-login-btn a {\n      padding: 9px;\n      width: auto;\n    }\n  }\n\n  @media (max-width: 767px) {\n    .top-menu li {\n      float: none;\n    }\n    .top-menu li a {\n      display: block;\n      margin-bottom: 5px;\n    }\n    .header-login-btn a {\n      width: 90px;\n    }\n  }\n\n  @media (max-width: 406px) {\n    .header-login-btn {\n      margin: 0;\n    }\n    .header-login-btn a {\n      margin-top: 20px;\n      width: 130px;\n    }\n  }\n</style>\n\n<jobbleheader></jobbleheader>\n\n<div class=\"sign-up-page\">\n  <div class=\"modal-dialog modal-m regi-form-board sign-in\">\n    <div class=\"modal-gradient-banner\"></div>\n    <div class=\"modal-content\">\n      <div class=\"modal-content-container\">\n        <div>\n          <h3>Log in</h3>\n          <p></p>\n        </div>\n        <div>\n          <div class=\"\">\n            <div class=\"input-container\">\n              <i class=\"fas fa-envelope\"></i>\n              <input\n                type=\"email\"\n                class=\"\"\n                placeholder=\"Email address\"\n                name=\"email\"\n                ng-model=\"vm.email\"\n                ng-change=\"vm.handleEmailChange()\"\n                ng-style=\"vm.validation.email.style\"\n                ng-keyup=\"vm.submitOnEnter($event)\"\n                required\n                autofocus\n              />\n            </div>\n            <div class=\"input-container\">\n              <i class=\"fas fa-key\"></i>\n              <input\n                type=\"password\"\n                class=\"\"\n                placeholder=\"Password\"\n                ng-change=\"vm.validateEmailAndPassword()\"\n                name=\"password\"\n                ng-model=\"vm.password\"\n                ng-keyup=\"vm.submitOnEnter($event)\"\n                required\n              />\n            </div>\n          </div>\n\n          <div>\n            <div class=\"continue-button sign-in-page-button\" ng-class=\"{'sign-in-button-disabled' : vm.signInDisabled}\" ng-click=\"vm.signIn()\">\n              <span ng-if=\"vm.logging_in\"><i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i></span>\n              <span ng-if=\"!vm.logging_in\">Sign in</span>\n            </div>\n          </div>\n\n          <div class=\"error-text\" ng-show=\"vm.result.status == 'error'\">\n            <i class=\"fas fa-exclamation-circle\"></i>\n            {{vm.result.message}}\n          </div>\n        </div>\n\n        <div class=\"login-text\">\n          <div>\n            <a href=\"/recover-password\"><span>Forgot password?</span></a>\n          </div>\n        </div>\n\n        <div class=\"terms-and-service\">\n          Don't have an account?\n          <a class=\"policy\" href=\"/choose-account-type\"> Sign up</a>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<globalalert></globalalert>\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	__webpack_require__(276);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SigninController = function () {
	  function SigninController($http, $localStorage, $state, $location, $window, $stateParams, AuthService, SignonService, EnvService, $timeout, SecurityService, $rootScope, $scope, TrackingService, $cookies, $social, validation) {
	    _classCallCheck(this, SigninController);
	
	    this.name = "signin";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$window = $window;
	    this.$location = $location;
	    this.$timeout = $timeout;
	    this.$signon = SignonService;
	    this.$security = SecurityService;
	    this.$rootScope = $rootScope;
	    this.$social = $social;
	    this.$tracking = TrackingService;
	    this.$scope = $scope;
	    this.posting_data = {};
	    this.errors = [];
	    this.signInDisabled = true;
	    this.email = "";
	    this.$cookies = $cookies;
	    this.$stateParams = $stateParams;
	    this.preserve_posting_data = false;
	    this.password = "";
	    this.is_home_footer = true;
	    this.logging_in = false;
	    this.signInUrl = "jbl/v1/login?format=json&fields=username,email,id,company.id,company.isVerified,authorities,isVerified,billingTutorialTracking,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.defaultPlan.companyFeePct,company.billingContactInfo.email,company.defaultPlan.requiresSubscription,company.undeletedPaymentInfos.bankName,homeContactInfo.streetLine1,homeContactInfo.isMobilePhoneVerified,homeContactInfo.streetLine2,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.isMobileVerified,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.mainContactInfo.city,company.ein,company.mainContactInfo.state,company.mainContactInfo.zipCode,company.description,company.autoAccept,company.autoManage,company.enableSubscription,company.payByInvoice,company.sendInvoice,company.name,company.legalCompanyName,bgCheckStatus,company.undeletedPaymentInfos.stripeId,acceptedBackgroundCheck";
	    this.loginUrlWithValidate = "jbl/v1/validate?format=json&fields=username,email,id,company.id,company.isVerified,authorities,isVerified,billingTutorialTracking,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.defaultPlan.companyFeePct,company.billingContactInfo.email,company.defaultPlan.requiresSubscription,company.undeletedPaymentInfos.bankName,homeContactInfo.streetLine1,homeContactInfo.isMobilePhoneVerified,homeContactInfo.streetLine2,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.isMobileVerified,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.mainContactInfo.city,company.ein,company.mainContactInfo.state,company.mainContactInfo.zipCode,company.description,company.autoAccept,company.autoManage,company.enableSubscription,company.payByInvoice,company.sendInvoice,company.name,company.legalCompanyName,bgCheckStatus,company.undeletedPaymentInfos.stripeId,acceptedBackgroundCheck";
	    //"jbl/v1/login?format=json&fields=username,id,company.id,company.isVerified,isVerified,billingTutorialTracking,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName";
	    //"jbl/v1/login?format=json&fields=username,dateBirth,ssn,isVerified,video1,brands,id,notifPref.jobbleTypes,smsChatNotificationOn,profilePictureUri,company.industryType.id,billingTutorialTracking,emailChatNotificationOn,firstName,dateCreated,lastName,access_token,company.name,company.id,company.payPerConnect,company.sendInvoice,company.autoAcceptLimitTimeMark,company.defaultPlan.requiresSubscription,company.billingContactInfo.email,company.enableSubscription,company.payByInvoice,company.invoiceMarkup,bio,homeContactInfo.streetLine1,homeContactInfo.isMobilePhoneVerified,homeContactInfo.streetLine2,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.dateCreated,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.totalNumberOfCircles,company.autoAccept,company.totalNumberOfCloseEvents,company.totalNumberOfDraftEvents,company.totalNumberOfPublishedEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.circleOfConnectedJobblers.id,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.postingTypesAllowed,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.partnernumberOfCompletedJobbles,numberOfApplications,numberOfApprovedApplications,numberOfPendingApplications,numberOfQuittedApplications,numberOfWithdrawnApplications,numberOfRejectedApplications,acceptedWebAgreement,acceptedMobileAgreement,acceptedPrivacyPolicy,acceptedCookiePolicy"
	    this.currentUser = this.$auth.getUserData();
	    this.result = { status: "", message: "" };
	    this.remain_loading_count = 0;
	    this.jqueryCleanUp();
	    this.$rootScope.channels = undefined;
	    this.$rootScope.activeMessages = undefined;
	    this.$rootScope.activeChannel = undefined;
	    this.$rootScope.arrayOfUniqueOnlineUsers = undefined;
	    this.$rootScope.lengthOfChannelsCreated = undefined;
	    this.$rootScope.messagingHasBeenInitiated = undefined;
	    this.initFB();
	    this.set_focus();
	    this.parse_params(this.$stateParams);
	    //$location.search('key', null)
	    this.$validation = validation;
	    this.validation = {
	      email: {}
	    };
	
	    this.checkThirdPartyParams();
	    this.focusOnEmail();
	  }
	
	  _createClass(SigninController, [{
	    key: "parse_params",
	    value: function parse_params(params) {
	      var _this = this;
	      if (params.onRefresh === true) {
	        this.$timeout(function () {
	          window.location.reload();
	          return;
	        }, 1300);
	      }
	      if (params.preserve === true) {
	        _this.preserve_posting_data = true;
	        _this.posting_data = params;
	      }
	      var urlParams = this.$location.$$search;
	      if (urlParams) {
	        var email = urlParams.companySignInEmail;
	        if (email) {
	          var emailEncoded = encodeURI(email);
	          var emailDecoded = decodeURIComponent(emailEncoded.replace("%20", "+"));
	          _this.email = emailDecoded;
	          _this.password = _this.$env.EnvironmentConfig.registeredUserPassword;
	          if (_this.$auth.isLoggedIn()) {
	            _this.$auth.signOut();
	            _this.$timeout(function () {
	              _this.signIn();
	            }, 1000);
	          } else {
	            _this.setLoader();
	            _this.signIn();
	          }
	        }
	      }
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "validateField",
	    value: function validateField(field, value, validateMethod, constructError) {
	      var _this2 = this;
	
	      var _validateMethod = validateMethod(value),
	          isValid = _validateMethod.isValid,
	          errors = _validateMethod.errors;
	
	      this.$timeout(function () {
	        _this2.validation[field] = {
	          valid: isValid,
	          style: { borderColor: isValid ? "#74cf59" : "red" },
	          message: constructError(errors)
	        };
	      });
	
	      return isValid;
	    }
	  }, {
	    key: "submitOnEnter",
	    value: function submitOnEnter(e) {
	      if (e.keyCode === 13) {
	        this.signIn();
	      }
	    }
	  }, {
	    key: "handleEmailChange",
	    value: function handleEmailChange() {
	      var EmailValidator = this.$validation.EmailValidator;
	
	      return this.validateField("email", this.email, EmailValidator.validateEmail, EmailValidator.constructErrorMessage);
	    }
	  }, {
	    key: "go_to_signup",
	    value: function go_to_signup(link) {
	      var _this = this;
	      var d = _this.posting_data;
	      if (link === 2) {
	        _this.$state.go("signup");
	      } else {
	        _this.$state.go("signup-company", d);
	      }
	    }
	  }, {
	    key: "signIn",
	    value: function signIn() {
	      var _this3 = this;
	
	      if (this.signInDisabled === true) {
	        return;
	      }
	
	      this.$timeout(function () {
	        _this3.logging_in = true;
	      });
	      var _this = this;
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + _this.signInUrl,
	        data: {
	          username: this.email,
	          password: this.password
	        }
	      };
	      this.$http(req).then(function (data) {
	        _this.result.status = data.data.status;
	        var user = {};
	        if (data.data.company.id) {
	          if (data.data.status == "error" || !data.data.company) {
	            _this.result.status = "error";
	            _this.result.message = "Login failed. Please check your credentials and try again.";
	            return;
	          }
	          _this.$tracking.reportUserLogin(data.data);
	          data.data.companyId = data.data.company.id;
	          _this.$localStorage.logged_user = data.data;
	          user = data.data;
	          _this.$stateParams.t = user.access_token;
	          _this.$rootScope.jobbleTypes = _this.$env.EnvironmentConfig.jobble_types;
	          if (_this.connectUser !== true) {
	            _this.$auth.handlePaymentInfos(user, _this.$stateParams);
	          } else {
	            _this.checkThirdParty(user, "business");
	          }
	          _this.logging_in = false;
	        } else {
	          _this.$localStorage.logged_user = data.data;
	          _this.removeBodyClass();
	          var u = data.data;
	
	          _this.fbTrackLogin(u);
	          _this.$rootScope.jobbleTypes = _this.$env.EnvironmentConfig.jobble_types;
	          if (_this.connectUser !== true) {
	            _this.$state.go("jobs");
	          } else {
	            _this.checkThirdParty(u, "jobbler");
	          }
	          _this.logging_in = false;
	          _this.unSetLoader();
	        }
	      }, function (error) {
	        console.log("down here?");
	        console.dir(error);
	        _this.$timeout(function () {
	          _this.logging_in = false;
	        });
	        if (error.status === 401) {
	          if (error.data === "") {
	            _this.result.status = "error";
	            _this.result.message = "Login failed. Please check your credentials and try again.";
	          } else if (error.data.message = "User is disabled") {
	            _this.result.status = "error";
	            _this.result.message = "Account Suspended. If you feel this has been done by mistake please contact support.";
	          } else {
	            _this.result.status = "error";
	            _this.result.message = "Login failed. Please check your credentials and try again.";
	          }
	        } else {
	          _this.result.status = "error";
	          _this.result.message = "Login failed. Please check your credentials and try again.";
	        }
	      });
	    }
	  }, {
	    key: "fbTrackLogin",
	    value: function fbTrackLogin(user) {
	      var _this = this;
	      var data = {};
	      data.userId = user.id;
	      data.userName = user.email;
	      data.userEmail = user.email;
	      _this.$social.fbTrackLogin(data);
	    }
	  }, {
	    key: "initFB",
	    value: function initFB() {
	      var _this = this;
	      _this.$social.initFB();
	    }
	  }, {
	    key: "logOnboardingTracking",
	    value: function logOnboardingTracking() {
	      var _this = this;
	      _this.$tracking.reportPostJobClick();
	    }
	  }, {
	    key: "removeBodyClass",
	    value: function removeBodyClass() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("body").removeClass();
	      });
	    }
	  }, {
	    key: "jqueryCleanUp",
	    value: function jqueryCleanUp() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("#ngProgress-container").remove();
	      }, 100);
	    }
	  }, {
	    key: "set_focus",
	    value: function set_focus() {
	      var _this = this;
	      _this.$timeout(function () {
	        $(".login-wrap .login-container .login-content form .input-bg.name input").focus();
	      }, 500);
	    }
	  }, {
	    key: "checkThirdPartyParams",
	    value: function checkThirdPartyParams() {
	      if (this.$stateParams.signindata !== null) {
	        this.result.status = "error";
	        this.result.message = "The email " + this.$stateParams.signindata.data.username + " already exists. Please login by entering your password to connect your Jobble with third party service.";
	        this.email = this.$stateParams.signindata.data.username;
	        this.connectUser = true;
	      }
	    }
	  }, {
	    key: "checkThirdParty",
	    value: function checkThirdParty(user, type) {
	      if (this.connectUser === true) {
	        this.connect(user, type);
	      }
	    }
	  }, {
	    key: "connect",
	    value: function connect(user, type) {
	      var _this = this;
	
	      var data = {};
	      var type = type;
	      var user = user;
	
	      data.type = this.$stateParams.signindata.data.connectedAccountType;
	      data.token = this.$stateParams.signindata.data.connectedAccountToken;
	
	      _this.$signon.connect(data, user).then(function (response) {
	        if (type === "jobbler") {
	          _this.$state.go("jobs");
	        } else {
	          _this.$auth.handlePaymentInfos(user, _this.$stateParams);
	        }
	      }, function (error) {
	        _this.$state.go("jobs");
	      });
	    }
	  }, {
	    key: "focusOnEmail",
	    value: function focusOnEmail() {
	      this.$timeout(function () {
	        $('.sign-up-page .input-container input[type="email"]').focus();
	      }, 300);
	    }
	  }, {
	    key: "validateEmailAndPassword",
	    value: function validateEmailAndPassword() {
	      if (this.password.length > 3) {
	        this.signInDisabled = false;
	      }
	    }
	  }]);
	
	  return SigninController;
	}();
	
	SigninController.$inject = ["$http", "$localStorage", "$state", "$location", "$window", "$stateParams", "auth", "signon", "env", "$timeout", "security", "$rootScope", "$scope", "tracking", "$cookies", "social", "validation"];
	
	exports.default = SigninController;

/***/ }),
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(279);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./signin.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./signin.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "signin footer{background:none}", ""]);
	
	// exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _signon = __webpack_require__(281);
	
	var _signon2 = _interopRequireDefault(_signon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var signonModule = _angular2.default.module("signon", [_angularUiRouter2.default, "ngStorage"]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("signon", {
	    url: "/signon",
	    template: "<signon></signon>",
	    title: "Sign up",
	    params: {
	      signindata: null
	    }
	  });
	}).component("signon", _signon2.default);
	
	exports.default = signonModule;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _signon = __webpack_require__(282);
	
	var _signon2 = _interopRequireDefault(_signon);
	
	var _signon3 = __webpack_require__(283);
	
	var _signon4 = _interopRequireDefault(_signon3);
	
	__webpack_require__(284);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var signonComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _signon2.default,
	  controller: _signon4.default,
	  controllerAs: "vm"
	};
	
	exports.default = signonComponent;

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<div class=\"sign-up-page signon\">\n\n    <!--\n    <script>\n      window.fbAsyncInit = function() {\n        FB.init({\n          appId            : '1097626717272010',\n          autoLogAppEvents : true,\n          xfbml            : true,\n          version          : 'v10.0'\n        });\n      };\n    </script>\n    -->\n    \n\t<div class=\"modal-dialog modal-m regi-form-board sign-in signon-modal\">\n\t\t\n        <div class=\"modal-gradient-banner\"></div>\n\t\t\n        <div class=\"modal-content\">\n            <div \n                class=\"modal-content-container\" \n                ng-if=\"vm.uiView.accountType.business==true && vm.uiView.step == 0\">\n\n                <div class=\"signon-header\">\n                    <h3>Company name</h3>\n                    <p>Please enter the name of your company</p>\n                </div>\n\n                <form ng-submit=\"vm.saveCompanyName()\">\n\n                    <input \n                        type=\"text\" \n                        ng-model=\"vm.uiView.companyName\" \n                        class=\"\"\n                    />\n\n                    <input \n                        type=\"submit\" \n                        value=\"Continue\" \n                        class=\"company-name-signon\" \n                    />\n\n                </form>\n\n            </div>\n\n\n\n\t\t\t<div \n                class=\"modal-content-container\" \n                ng-if=\"((vm.uiView.accountType.jobbler==true && vm.uiView.step == 1) || (vm.uiView.accountType.business==true && vm.uiView.step == 1))\">\n\n\t\t\t\t<div class=\"signon-header\">\n\t\t\t\t\t<h3>{{vm.actionHeader}}</h3>\n\n\t\t\t\t\t<p ng-if=\"!vm.verificationError && vm.uiView.accountType.jobbler==true\">\n                        Please select from one these three providers for one click sign on.\n                    </p>\n\n                    <p ng-if=\"!vm.verificationError && vm.uiView.accountType.jobbler!=true\">\n                        Please continue with your company email to sign up for a business account.\n                    </p>\n\n                    <p ng-if=\"vm.verificationError\" style=\"color: #D8000C;\">\n                        <i class=\"fas fa-exclamation-circle\"></i> {{ vm.verificationError }}\n                    </p>\n\t\t\t\t</div>\n\n\n\t\t\t\t<div \n                    class=\"third-party-wrapper\">\n                    <div \n                        id=\"g-signin2\" \n                        data-onsuccess=\"onSignIn\"\n                        ng-click=\"vm.googleSignIn()\"\n                        ng-show=\"vm.uiView.accountType.jobbler==true\"\n                    >\n\n                    </div>\n                </div>\n\n                <div \n                    class=\"third-party-wrapper\" \n                    id=\"fbloginbutton\"\n                    ng-show=\"vm.uiView.accountType.jobbler==true\">\n\n                </div>\n\n                <div \n                    class=\"third-party-wrapper\" \n                    ng-show=\"vm.uiView.accountType.jobbler==true\">\n\n                    <div\n                      id=\"appleid-signin\"\n                      data-mode=\"center-align\"\n                      data-type=\"continue\"\n                      data-color=\"black\"\n                      data-border=\"true\"\n                      data-border-radius=\"15\"\n                      data-width=\"328\"\n                      data-height=\"40\"\n                      data-logo-size=\"small\"\n                      data-logo-position=\"16\"\n                      data-label-position=\"50\"\n                    ></div>\n\n                    <!--\n                    <div \n                        id=\"appleid-signin\" \n                        data-color=\"white\" \n                        data-border=\"true\" \n                        data-type=\"sign in\"\n                        data-mode=\"left-align\"\n                        data-border=\"false\"\n                        data-border-radius=\"15\"\n                        data-width=\"328px\";\n                        data-height=\"43px\"\n                        data-logo-size=\"large\"\n                        data-logo-position=\"15\"\n                        data-label-position=\"40\">\n                    </div>\n                    -->\n                </div>\n\t\t\t\t\n\t\t\t\t<div class=\"line-holder\" ng-show=\"vm.uiView.accountType.jobbler==true\">\n                    <div class=\"left-line\"></div>\n\n                    <span>OR</span>\n\n                    <div class=\"right-line\"></div>\n                </div>\n\n                <div \n                    class=\"mobile-app-links\" \n                    ng-click=\"vm.signin()\"\n                    style=\"margin-top: 25px;\">\n                    <i class=\"far fa-envelope\"></i> Continue with Email and Password\n                </div>\n\n                <div class=\"terms-and-service\" ng-if=\"vm.uiView.accountType.jobbler==true\">\n                    By logging in, you are agreeing with the <a class=\"policy\" href=\"https://jobble.com/terms-of-service/\" target=\"_blank\">Jobble Terms and Conditions\n                </a> and <a href=\"https://kb.jobble.com/privacy/\" target=\"_blank\">Privacy Policy</a>\n                </div>\n\t\t\t\t<div class=\"terms-and-service\" ng-if=\"!vm.uiView.accountType.jobbler==true\">\n                    By logging in, you are agreeing with the <a class=\"policy\" href=\"https://jobble.com/terms-of-service/\" target=\"_blank\">Jobble Terms of Service\n                </a> and <a href=\"https://kb.jobble.com/privacy/\" target=\"_blank\">Privacy Policy</a>\n\t\t\t\t</div>\n\n\n\t\t\t</div>\n\n            <div \n                ng-if=\"vm.uiView.step == 4\">\n\n                <div class=\"signon-header\">\n                    <h3>Confirm email</h3>\n                    <p>This is the email address associated with your account. If this address is correct, no action is required. If the address is incorrect, please enter the correct address.</p>\n                </div>\n                <!--ng-change=\"vm.formChange('phoneMobile', vm.$profile.VERIFY_PHONE) ng-keyup=\"vm.submitOnEnter($event)\"-->\n                <form ng-submit=\"vm.sendConfirmedEmail()\">\n                    <label>Email</label>\n                    <input \n                        type=\"email\"\n                        class=\"\"\n                        placeholder=\"Email address\"\n                        name=\"email\"\n                        ng-model=\"vm.uiView.email\"\n                        ng-change=\"vm.validator.email(vm.uiView.email, vm)\"\n                        ng-style=\"vm.validation.email.style\"\n                        required\n                        autofocus\n                    />\n                    <div \n                    class=\"input-error-text\" \n                    ng-show=\"vm.validation.email.message\">\n                        <i class=\"fas fa-exclamation-circle\"></i> \n                        Please enter a valid email\n                    </div>\n                    <input \n                        type=\"submit\" \n                        value=\"Continue with this email\" \n                        class=\"company-name-signon\" \n                    />\n                </form>\n            </div>\n\n            <div \n                ng-if=\"vm.uiView.step == 2\">\n\n                <div class=\"signon-header\">\n                    <h3>Verify mobile phone number</h3>\n                    <p>To ensure your success on the Jobble platform please provide your mobile number. We will send you a verification link that will \n                    be required to proceed.</p>\n                </div>\n\n                <form ng-submit=\"vm.saveUserNumber()\">\n                    <label>Mobile phone number</label>\n                    <input \n                        type=\"text\"\n                        class=\"\"\n                        ng-model=\"vm.currentUser.homeContactInfo.phoneMobile\" \n                        ng-change=\"vm.validator.phone(vm.currentUser.homeContactInfo.phoneMobile, vm)\"\n                        ng-style=\"vm.validation.phone.style\"\n                        autofocus \n                    />\n                    <div \n                       class=\"input-error-text\" \n                       ng-show=\"vm.validation.phone.message\">\n                       <i class=\"fas fa-exclamation-circle\"></i> \n                        Please enter a valid phone number\n                    </div>\n                    <input \n                        type=\"submit\" \n                        value=\"Save and Continue\" \n                        class=\"company-name-signon\" \n                    />\n                </form>\n            </div>\n\n            <div \n                ng-if=\"vm.uiView.step == 3\">\n\n                <div class=\"signon-header\">\n                    <h3>Let us know its you</h3>\n                    <p>We just sent a 6 digit verification code to {{vm.currentUser.homeContactInfo.phoneMobile}}. Please enter this code below to ensure we have the correct mobile number:</p>\n                </div>\n\n                <div class=\"sms-code-container\">\n                    <input\n                        class=\"\"\n                        id=\"sms-code-1\"\n                        ng-model=\"vm.smsCode_1\"\n                        ng-change=\"vm.codeEntered(1)\"\n                        ng-keydown=\"vm.smsCodeBackSpace($event,1)\"\n                        required\n                        autofocus\n                        maxlength=\"1\"\n                    />\n                    <input\n                        class=\"\"\n                        id=\"sms-code-2\"\n                        ng-model=\"vm.smsCode_2\"\n                        ng-change=\"vm.codeEntered(2)\"\n                        ng-keydown=\"vm.smsCodeBackSpace($event,2)\"\n                        required\n                        autofocus\n                        maxlength=\"1\"\n                    />\n                    <input\n                        class=\"\"\n                        id=\"sms-code-3\"\n                        ng-model=\"vm.smsCode_3\"\n                        ng-change=\"vm.codeEntered(3)\"\n                        ng-keydown=\"vm.smsCodeBackSpace($event,3)\"\n                        required\n                        autofocus\n                        maxlength=\"1\"\n                    />\n                    <input\n                        class=\"\"\n                        id=\"sms-code-4\"\n                        ng-model=\"vm.smsCode_4\"\n                        ng-change=\"vm.codeEntered(4)\"\n                        ng-keydown=\"vm.smsCodeBackSpace($event,4)\"\n                        required\n                        autofocus\n                        maxlength=\"1\"\n                    />\n                    <input\n                        class=\"\"\n                        id=\"sms-code-5\"\n                        ng-model=\"vm.smsCode_5\"\n                        ng-change=\"vm.codeEntered(5)\"\n                        ng-keydown=\"vm.smsCodeBackSpace($event,5)\" \n                        required\n                        autofocus\n                        maxlength=\"1\"\n                    />\n                    <input\n                        class=\"\"\n                        id=\"sms-code-6\"\n                        ng-model=\"vm.smsCode_6\"\n                        ng-change=\"vm.codeEntered(6)\"\n                        ng-keydown=\"vm.smsCodeBackSpace($event,6)\"\n                        required\n                        autofocus\n                        maxlength=\"1\"\n                    />\n                </div>\n\n                <div class=\"terms-and-service\" style=\"border: none; margin-top: 0;\">\n                    Didn't receive a code? <span ng-click=\"vm.backToPhoneVerification()\" style=\"cursor: pointer; color: #62C046\">Try again</span>\n                </div>\n                <div ng-if=\"vm.smsVerificationError\">\n                    <div class=\"error-text\">\n                        <i class=\"fas fa-exclamation-circle\"></i> {{ vm.smsVerificationErrorText }}\n                    </div>\n                </div>\n\n            </div>\n\n            <div \n                ng-if=\"vm.uiView.step == 5\">\n\n                <div class=\"signon-header\" style=\"text-align:center\">\n                    <h3 style=\"text-align:left\">Check your email</h3>\n                    <p style=\"text-align:left\">We sent a confirmation link to {{vm.currentUser.email}}. It will expire shortly, so click it soon.</p>\n                    <img src=\"/app/vendor/images/confirmemail.png\" />\n                </div>\n\n                <div>\n                    <form ng-submit=\"vm.userIsReady()\">\n                        <input \n                            type=\"submit\" \n                            value=\"Continue to jobs\" \n                            class=\"company-name-signon\" \n                        />\n                    </form>\n                </div>\n\n            </div>\n\n        </div>\n\n\t\t</div>\n\t</div>\n</div>\n<div style=\"height:200px;\">\n</div>\n"

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	__webpack_require__(276);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignonController = function () {
	  function SignonController($http, $localStorage, $state, $location, $window, SignupValidator, $stateParams, ProfileService, AuthService, EnvService, SignonService, $timeout, SecurityService, $rootScope, $scope, TrackingService, $cookies, $social, validation) {
	    var _this2 = this;
	
	    _classCallCheck(this, SignonController);
	
	    this.name = "signon";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$profile = ProfileService;
	    this.$window = $window;
	    this.$location = $location;
	    this.$signon = SignonService;
	    this.$timeout = $timeout;
	    this.$security = SecurityService;
	    this.$rootScope = $rootScope;
	    this.$social = $social;
	    this.$tracking = TrackingService;
	    this.payload = {};
	    this.$scope = $scope;
	    this.$cookies = $cookies;
	    this.$stateParams = $stateParams;
	    this.validator = SignupValidator;
	    this.validation = {};
	    this.currentUser = this.$auth.getUserData();
	    this.canValidate = false;
	    this.$timeout(function () {
	      return _this2.canValidate = true;
	    }, 1000);
	    this.uiView = {
	      accountType: {
	        business: null,
	        jobbler: null
	      },
	      companyName: null,
	      step: 1,
	      email: null
	    };
	
	    this.determineUserType();
	
	    window.fbOnLogin = function () {
	      return _this2.fbSuccessfulLogin();
	    };
	
	    window.document.addEventListener("AppleIDSignInOnSuccess", function (data) {
	      _this2.handleAppleSignin(data.detail);
	    });
	
	    window.document.addEventListener("AppleIDSignInOnFailure", function (error) {});
	
	    var FB = window.FB;
	
	    if (FB) {
	      FB.init({
	        appId: "1097626717272010",
	        autoLogAppEvents: true,
	        xfbml: true,
	        version: "v10.0"
	      });
	
	      FB.Event.subscribe("xfbml.render", this.faceBookRendered());
	    }
	
	    var _this = this;
	
	    _this.SetSignOnPage = _this.$rootScope.$on("SetSignOnPage", function (event, params) {
	      _this.$timeout(function () {
	        if (params === "jobbler") {
	          _this.uiView.accountType.business = false;
	          _this.uiView.accountType.jobbler = true;
	        } else {
	          _this.uiView.accountType.business = true;
	          _this.uiView.accountType.jobbler = false;
	        }
	      });
	    });
	
	    _this.$scope.$on("$destroy", _this.SetSignOnPage);
	
	    this.canValidate = false;
	    this.$timeout(function () {
	      return _this2.canValidate = true;
	    }, 1000);
	
	    this.$timeout(function () {
	      var target = document.querySelector("div.sms-code-container");
	      target.addEventListener("paste", function (event) {
	        var copyCode = (event.clipboardData || window.clipboardData).getData("text");
	        copyCode = copyCode.trim();
	        if (copyCode.length === 6) {
	          _this2.smsCode_1 = copyCode.charAt(0);
	          _this2.smsCode_2 = copyCode.charAt(1);
	          _this2.smsCode_3 = copyCode.charAt(2);
	          _this2.smsCode_4 = copyCode.charAt(3);
	          _this2.smsCode_5 = copyCode.charAt(4);
	          _this2.smsCode_6 = copyCode.charAt(5);
	          for (var i = 0; i <= 5; i++) {
	            document.getElementById("sms-code-" + (i + 1)).value = copyCode.charAt(i);
	          }
	          _this2.codeEntered(6);
	        }
	        event.preventDefault();
	      });
	    }, 1000);
	  }
	
	  _createClass(SignonController, [{
	    key: "signin",
	    value: function signin() {
	      var urlParam = this.$location.$$search.accountType;
	      var action = this.$location.$$search.action;
	
	      if (urlParam === "business") {
	        this.$location.url("/signup/company");
	      } else {
	        if (action === "signin") {
	          this.$location.url("/signin");
	        } else {
	          this.$location.url("/signup/jobbler");
	        }
	      }
	    }
	  }, {
	    key: "googleSignIn",
	    value: function googleSignIn() {
	      var data = {};
	      var dataForLogin = {};
	
	      var _this = this;
	    }
	  }, {
	    key: "renderGoogle",
	    value: function renderGoogle() {
	      var data = {};
	      var dataForLogin = {};
	
	      var _this = this;
	
	      this.$timeout(function () {
	        gapi.load("auth2", function () {
	          // Loads the auth2 component of gapi
	
	          gapi.auth2.init({
	            // initialize the auth2 using your credentials
	            client_id: _this.$env.EnvironmentConfig.thirdPartySignon.google
	          }).then(function onInit() {
	            // on complete of init
	
	            gapi.signin2.render("g-signin2", {
	              scope: "profile email",
	              width: 328,
	              height: 40,
	              longtitle: true,
	              theme: "dark",
	
	              onsuccess: function onsuccess(googleUser) {
	                // This executes when a user successfully authorizes you to their data by clicking the button and selecting their account.
	
	                var profile = googleUser.getBasicProfile();
	                var id_token = null;
	
	                console.log("Google profile:", profile);
	
	                try {
	                  console.log("Google profile ID: " + profile.getId());
	                  var authResponse = googleUser.getAuthResponse();
	                  console.log("Google authResponse:", authResponse);
	                  id_token = authResponse.id_token;
	                  console.log("Google authResponse id_token:", id_token);
	                } catch (e) {
	                  console.error("Google authResponse error:", e);
	                }
	
	                dataForLogin.connectedAccountType = "GOOGLE";
	                data.connectedAccountType = "GOOGLE";
	                data.username = profile.getEmail();
	                data.firstName = profile.getGivenName();
	                data.lastName = profile.getFamilyName();
	
	                if (googleUser.tc) {
	                  dataForLogin.connectedAccountToken = googleUser.tc.id_token;
	                  data.connectedAccountToken = googleUser.tc.id_token;
	                } else if (googleUser.uc) {
	                  dataForLogin.connectedAccountToken = googleUser.uc.id_token;
	                  data.connectedAccountToken = googleUser.uc.id_token;
	                } else if (googleUser.qc) {
	                  dataForLogin.connectedAccountToken = googleUser.qc.id_token;
	                  data.connectedAccountToken = googleUser.qc.id_token;
	                }
	
	                if (id_token) {
	                  dataForLogin.connectedAccountToken = id_token;
	                  data.connectedAccountToken = id_token;
	                }
	
	                if (_this.uiView.accountType.business === true) {
	                  var company = {};
	                  company.name = _this.uiView.companyName;
	                  company.defaultPlan = 31;
	                  data.company = company;
	                }
	
	                console.log("Data:", data);
	                console.log("dataForLogin:", dataForLogin);
	
	                _this.login(data, dataForLogin);
	              }
	            });
	          });
	        });
	      }, 1000);
	    }
	  }, {
	    key: "setValidation",
	    value: function setValidation(_ref) {
	      var _this3 = this;
	
	      var field = _ref.field,
	          valid = _ref.valid,
	          message = _ref.message;
	
	      if (this.canValidate) this.$timeout(function () {
	        _this3.validation[field] = {
	          valid: valid,
	          style: { borderColor: valid ? "green" : "red" },
	          message: message
	        };
	      });
	    }
	  }, {
	    key: "register",
	    value: function register(data, dataForLogin, needEmailConfirmation) {
	      var _this = this;
	
	      var handleAppleScreen = false;
	
	      if (_this.uiView.accountType.business === true) {
	        console.log("check name");
	        console.dir(data);
	        if (data.company.name === null) {
	          _this.setCompanyPage(data, dataForLogin, true);
	          return;
	        }
	      }
	
	      if (needEmailConfirmation === true) {
	        _this.confirmEmail(data, dataForLogin, needEmailConfirmation);
	        return;
	      }
	
	      if (needEmailConfirmation === "apple") {
	        handleAppleScreen = true;
	        dataForLogin.handleAppleScreen = handleAppleScreen;
	        dataForLogin.appleUsername = data.username;
	      }
	
	      _this.setLoader();
	
	      _this.$signon.register(data, dataForLogin).then(function (response) {
	        if (response.data.message.indexOf("Duplicate entry") > -1) {
	          _this.sendUserToSignIn(data, dataForLogin);
	        } else if (response.data.message.indexOf("The email provided is already connected") > -1) {
	          _this.uiView.step = 1;
	          _this.loadSignOnButtons(response.data.message);
	        } else if (response.data.message === "The registration email was successfully sent") {
	          _this.$timeout(function () {
	            _this.login(data, dataForLogin);
	          }, 500);
	        } else {}
	
	        _this.unSetLoader();
	        _this.sendingConfirmaionEmail = false;
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "login",
	    value: function login(data, dataForLogin) {
	      console.log("login");
	      console.dir(data);
	      console.dir(dataForLogin);
	
	      var _this = this;
	
	      _this.setLoader();
	
	      _this.$signon.login(data, dataForLogin).then(function (response) {
	        console.log("what is the response");
	        console.dir(response);
	        console.log("after login dataForLogin");
	        console.dir(dataForLogin);
	        _this.unSetLoader();
	
	        if (response.data.access_token) {
	          _this.sendUser(response, dataForLogin);
	        }
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	        _this.unSetLoader();
	        if (error.status === 401) {
	          _this.register(data, dataForLogin, true);
	        }
	      });
	    }
	  }, {
	    key: "sendUser",
	    value: function sendUser(response, dataForLogin) {
	      var user = {};
	
	      if (response.data.company) {
	        if (response.data.status == "error" || !response.data.company) {
	          console.log("what is the error");
	          console.dir(response);
	          _this.result.status = "error";
	          _this.result.message = "Login failed. Please check your credentials and try again.";
	          return;
	        }
	
	        //this.$tracking.reportUserLogin(data.data);
	        response.data.companyId = response.data.company.id;
	        user = response.data;
	        this.$localStorage.logged_user = response.data;
	        this.currentUser = response.data;
	        this.$stateParams.t = user.access_token;
	        this.$rootScope.jobbleTypes = this.$env.EnvironmentConfig.jobble_types;
	        this.$auth.handlePaymentInfos(user, this.$stateParams, true);
	        this.$state.go("postashiftwalkthrough");
	        //this.uiView.step = 2;
	      } else {
	        user = response.data;
	        this.$localStorage.logged_user = response.data;
	        this.currentUser = response.data;
	        this.removeBodyClass();
	        //this.fbTrackLogin(u);
	        this.$rootScope.jobbleTypes = this.$env.EnvironmentConfig.jobble_types;
	        //this.currentUser.homeContactInfo = {};
	        console.log("this is the user at this point");
	        console.dir(this.currentUser);
	        console.dir(_.isEmpty(this.currentUser.homeContactInfo));
	        if (dataForLogin.handleAppleScreen === true) {
	          alert("Account created using " + dataForLogin.appleUsername + ". If you would like Jobble to send important messages to a different email address you can change it in your profile.");
	        }
	
	        user.type = dataForLogin.connectedAccountType;
	        this.$tracking.reportJobblerSignUpThirdParty(user);
	
	        if (_.isEmpty(this.currentUser.homeContactInfo) === true) {
	          this.uiView.step = 2;
	        } else if (this.currentUser.isVerified !== true) {
	          this.uiView.step = 5;
	          //this.$state.go('jobs');
	        } else {
	          this.$state.go("jobs");
	        }
	      }
	    }
	  }, {
	    key: "getMostRecentUser",
	    value: function getMostRecentUser() {
	      var _this4 = this;
	
	      return new Promise(function (resolve, reject) {
	        resolve(_this4.$auth.getUserData());
	      });
	    }
	  }, {
	    key: "saveUserNumber",
	    value: function saveUserNumber() {
	      var _this5 = this;
	
	      //let num = this.uiView.userNumber;
	      //this.currentUser.homeContactInfo.phoneMobile = num;
	      if (this.savingUserNumber === true) {
	        return;
	      }
	
	      this.savingUserNumber = true;
	      this.setLoader();
	      //this.$profile.saveUser(this.currentUser)
	      this.$profile.saveUser(this.currentUser).then(function (response) {
	        console.log("what is the response after saving...");
	        console.dir(response);
	        _this5.$auth.refreshCurrentUser().then(function (user) {
	          _this5.getMostRecentUser().then(function (user) {
	            _this5.$timeout(function () {
	              _this5.currentUser = user || _this5.currentUser;
	              _this5.unSetLoader();
	              _this5.savingUserNumber = false;
	              _this5.sendSMSCode();
	              console.log("what is the current user now");
	              console.dir(_this5.currentUser);
	            });
	          });
	        });
	      }).catch(function (err) {
	        _this5.unSetLoader();
	        _this5.savingUserNumber = false;
	        _this5.$auth.refreshCurrentUser();
	        console.error(err);
	      });
	    }
	  }, {
	    key: "sendSMSCode",
	    value: function sendSMSCode() {
	      var _this6 = this;
	
	      this.setLoader();
	
	      this.$profile.sendSMSCode().then(function (response) {
	        console.log("SMS Code Response");
	        console.dir(response);
	        _this6.unSetLoader();
	        _this6.uiView.step = 3;
	        //this.canUserApplyToShiftBasedJobs(true);
	      }).catch(function (err) {
	        console.error("SMS Code Error", err);
	        _this6.unSetLoader();
	      });
	    }
	  }, {
	    key: "codeEntered",
	    value: function codeEntered(num) {
	      if (num <= 5 && this["smsCode_" + num]) {
	        var el = document.getElementById("sms-code-" + (num + 1));
	        el.focus();
	        el.select();
	      }
	
	      var code = "" + this.smsCode_1 + this.smsCode_2 + this.smsCode_3 + this.smsCode_4 + this.smsCode_5 + this.smsCode_6;
	
	      if (code.length === 6) {
	        console.log("send request");
	        this.validateSMSCode();
	      }
	    }
	  }, {
	    key: "validateSMSCode",
	    value: function validateSMSCode() {
	      var _this7 = this;
	
	      var code = "" + this.smsCode_1 + this.smsCode_2 + this.smsCode_3 + this.smsCode_4 + this.smsCode_5 + this.smsCode_6;
	
	      this.setLoader();
	
	      this.$profile.validateSMSCode(code).then(function (response) {
	        _this7.$timeout(function () {
	          _this7.smsVerified = true;
	          _this7.sendAppLink();
	          //this.$tracking.reportSMSVerified("job board", this.currentUser.email);
	          _this7.$tracking.reportSMSVerified("third party - standard", _this7.currentUser.email);
	          _this7.unSetLoader();
	        });
	      }).catch(function (err) {
	        console.error("SMS Validation error", err);
	        _this7.$timeout(function () {
	          _this7.smsVerificationError = true;
	          _this7.smsVerificationErrorText = "Code invalid or expired";
	          _this7.unSetLoader();
	        }, 1000);
	      });
	    }
	  }, {
	    key: "backToPhoneVerification",
	    value: function backToPhoneVerification() {
	      this.uiView.step = 2;
	    }
	  }, {
	    key: "sendAppLink",
	    value: function sendAppLink() {
	      var _this8 = this;
	
	      return new Promise(function (resolve) {
	        var req = {
	          method: "POST",
	          data: {
	            body: "You are a Jobbler now! download the app to enhance your Jobble experience! Download: https://link.jobble.com/download-app"
	          },
	          url: _this8.$env.getAPIEndPoint() + "jbl/v1/sms",
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + _this8.$localStorage.logged_user.access_token
	          }
	        };
	
	        _this8.$http(req).then(function (response) {
	          console.log("SMS Response", response);
	          resolve();
	          _this8.unSetLoader();
	          _this8.checkUsersVerificationStatus();
	        }).catch(function (err) {
	          console.error("SMS Error", err);
	          _this8.unSetLoader();
	          _this8.checkUsersVerificationStatus();
	          resolve();
	        });
	      });
	    }
	  }, {
	    key: "checkUsersVerificationStatus",
	    value: function checkUsersVerificationStatus() {
	      console.log("checkUsersVerificationStatus");
	      console.dir(this.currentUser);
	
	      if (this.currentUser.isVerified === true) {
	        this.$state.go("jobs");
	      } else {
	        this.uiView.step = 5;
	      }
	    }
	  }, {
	    key: "userIsReady",
	    value: function userIsReady() {
	      this.setLoader();
	      this.$state.go("jobs");
	    }
	  }, {
	    key: "sendUserToSignIn",
	    value: function sendUserToSignIn(data, dataForLogin) {
	      console.log("sendUserToSignin");
	      this.$state.go("signin", { signindata: { data: data, dataForLogin: dataForLogin } });
	    }
	  }, {
	    key: "renderFacebook",
	    value: function renderFacebook() {
	      console.log("renderFacebook....");
	      console.dir(FB);
	    }
	  }, {
	    key: "checkFBLoginState",
	    value: function checkFBLoginState() {
	      console.log("checkFBLoginState");
	    }
	  }, {
	    key: "fbSuccessfulLogin",
	    value: function fbSuccessfulLogin() {
	      console.log("fbSuccessfulLogin");
	      console.dir(FB);
	
	      var data = {};
	      var dataForLogin = {};
	
	      var _this = this;
	
	      FB.getLoginStatus(function (response) {
	        console.log("getting facebook login status 2");
	        console.dir(response);
	
	        var fbResponse = response;
	
	        if (response.status === "connected") {
	          _this.setLoader();
	
	          FB.api("/me?fields=name,email,first_name,last_name", function (response) {
	            console.log("what is response from me");
	            console.dir(response);
	            _this.unSetLoader();
	            if (!response.email) {
	              _this.handleFaceBookNoEmail(response, fbResponse);
	            } else {
	              if (fbResponse.authResponse.accessToken) {
	                dataForLogin.connectedAccountType = "FACEBOOK";
	                dataForLogin.connectedAccountToken = fbResponse.authResponse.accessToken;
	                data.username = response.email;
	                data.firstName = response.first_name;
	                data.lastName = response.last_name;
	                data.connectedAccountType = "FACEBOOK";
	                data.connectedAccountToken = fbResponse.authResponse.accessToken;
	                _this.login(data, dataForLogin);
	              }
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: "handleFaceBookNoEmail",
	    value: function handleFaceBookNoEmail(response, fbResponse) {
	      console.log("handleFaceBookNoEmail");
	    }
	  }, {
	    key: "renderApple",
	    value: function renderApple() {
	      var _this9 = this;
	
	      this.$timeout(function () {
	        AppleID.auth.init({
	          clientId: _this9.$env.EnvironmentConfig.thirdPartySignon.apple,
	          redirectURI: _this9.$env.EnvironmentConfig.thirdPartySignon.appleRedirectUrl,
	          scope: "name email",
	          usePopup: true //or false defaults to false
	        });
	      }, 1000);
	    }
	  }, {
	    key: "loadSignOnButtons",
	    value: function loadSignOnButtons(error) {
	      var _this10 = this;
	
	      console.log("loadSignOnButtons");
	
	      this.setLoader();
	
	      if (this.uiView.accountType.business === true) {
	        this.renderGoogle();
	      } else {
	        this.renderGoogle();
	        this.renderFacebook();
	        this.renderApple();
	      }
	
	      if (error) {
	        this.$timeout(function () {
	          alert("Please select the correct login provider. " + error);
	        }, 2000);
	      }
	
	      this.$timeout(function () {
	        _this10.unSetLoader();
	      }, 1300);
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "removeBodyClass",
	    value: function removeBodyClass() {
	      this.$timeout(function () {
	        $("body").removeClass();
	      });
	    }
	  }, {
	    key: "handleAppleSignin",
	    value: function handleAppleSignin(response) {
	      console.log("handleAppleSignin");
	      console.dir(response);
	
	      var data = {};
	      var dataForLogin = {};
	
	      if (response.user) {
	        data.username = response.user.email;
	        data.firstName = response.user.name.firstName;
	        data.lastName = response.user.name.lastName;
	        data.connectedAccountType = "APPLE";
	        data.connectedAccountToken = response.authorization.id_token;
	        dataForLogin.connectedAccountType = "APPLE";
	        dataForLogin.connectedAccountToken = response.authorization.id_token;
	
	        this.register(data, dataForLogin, "apple");
	      } else {
	        alert("No email was returned from apple");
	      }
	    }
	  }, {
	    key: "determineUserType",
	    value: function determineUserType() {
	      var _this11 = this;
	
	      var urlParam = this.$location.$$search.accountType;
	      var actionParam = this.$location.$$search.action;
	
	      console.log("what is the userparams");
	      console.dir(urlParam);
	
	      if (urlParam === "business") {
	        this.uiView.accountType.jobbler = false;
	        this.uiView.accountType.business = true;
	
	        this.$timeout(function () {
	          _this11.loadSignOnButtons();
	        }, 300);
	      } else if (urlParam === "jobbler") {
	        this.uiView.accountType.jobbler = true;
	        this.uiView.accountType.business = false;
	
	        this.$timeout(function () {
	          _this11.loadSignOnButtons();
	        }, 300);
	      } else {
	        this.uiView.accountType.jobbler = true;
	        this.uiView.accountType.business = false;
	
	        this.$timeout(function () {
	          _this11.loadSignOnButtons();
	        }, 300);
	      }
	
	      console.log("look at state params here");
	      console.dir(this.$stateParams);
	
	      if (actionParam === "signin") {
	        this.actionHeader = "Sign in";
	      } else {
	        this.actionHeader = "Sign up";
	      }
	
	      if (this.$stateParams.signindata) {
	        this.displayVerificationMessage(this.$stateParams.signindata.signOnData.data.username);
	      }
	    }
	  }, {
	    key: "formChange",
	    value: function formChange(field, page) {
	      var _this12 = this;
	
	      this.errors = this.errors || {};
	      console.log("formChange");
	      console.dir(field);
	      console.dir(page);
	      this.$timeout(function () {
	        _this12.errors = _this12.$profile.validateProfile(_this12.currentUser, field, _this12.errors);
	      });
	    }
	  }, {
	    key: "displayVerificationMessage",
	    value: function displayVerificationMessage(email) {
	      this.verificationError = "A verification email was just sent to " + email + ". Please click the link in that email for verification and then attempt to your third party sign on again.";
	      this.sendVerificationEmail(email);
	    }
	  }, {
	    key: "sendVerificationEmail",
	    value: function sendVerificationEmail(email) {
	      var _this = this;
	      var user = {};
	
	      user.email = email;
	
	      _this.$profile.resendEmail(user).then(function (response) {
	        console.log("resent email");
	        console.dir(response);
	      }, function (error) {
	        console.log("error resending email verification");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "confirmEmail",
	    value: function confirmEmail(data, dataForLogin, needEmailConfirmation) {
	      var _this13 = this;
	
	      if (needEmailConfirmation === true) {
	        this.payload.needEmailConfirmation = true;
	        this.payload.data = data;
	        this.payload.dataForLogin = dataForLogin;
	      }
	
	      this.$timeout(function () {
	        _this13.uiView.step = 4;
	        _this13.uiView.email = data.username;
	      });
	    }
	  }, {
	    key: "sendConfirmedEmail",
	    value: function sendConfirmedEmail() {
	      console.log("sendConfirmedEmail");
	      console.dir(this.uiView.email);
	      console.dir(this.payload);
	
	      if (this.sendingConfirmaionEmail === true) {
	        return;
	      }
	
	      this.sendingConfirmaionEmail = true;
	
	      this.payload.data.username = this.uiView.email;
	
	      var data = this.payload.data;
	      var dataForLogin = this.payload.dataForLogin;
	
	      this.register(data, dataForLogin, false);
	    }
	  }, {
	    key: "setCompanyPage",
	    value: function setCompanyPage(data, dataForLogin, needEmailConfirmation) {
	      this.payload.data = data;
	      this.payload.dataForLogin = dataForLogin;
	      this.payload.needEmailConfirmation = needEmailConfirmation;
	      this.uiView.step = 0;
	    }
	  }, {
	    key: "saveCompanyName",
	    value: function saveCompanyName() {
	      var _this14 = this;
	
	      console.log("saveCompanyName");
	      console.dir(this.uiView);
	      console.dir(this.payload);
	      this.setLoader();
	
	      var data = this.payload.data;
	      var dataForLogin = this.payload.dataForLogin;
	
	      data.company.name = this.uiView.companyName;
	      data.company.mainContactInfo = {};
	      data.company.mainContactInfo.phoneMobile = "2222222222";
	      this.$timeout(function () {
	        _this14.unSetLoader();
	        _this14.confirmEmail(data, dataForLogin, true);
	      }, 1000);
	    }
	  }, {
	    key: "faceBookRendered",
	    value: function faceBookRendered() {
	      var Cbuild1 = null;
	
	      this.$timeout(function () {
	        Cbuild1 = document.getElementById("fbloginbutton");
	        Cbuild1.innerHTML = "<fb:login-button scope='email' onlogin='window.fbOnLogin()' data-width='328' data-size='large' data-button-type='continue_with' data-layout='default' data-auto-logout-link='false' data-use-continue-as='false'></fb:login-button>";
	      }, 1500);
	
	      this.$timeout(function () {
	        FB.XFBML.parse();
	      }, 2000);
	    }
	  }, {
	    key: "smsCodeBackSpace",
	    value: function smsCodeBackSpace(event, inputSequence) {
	      if (event.keyCode === 8) {
	        if (inputSequence !== 1) {
	          var activeValue = $(".apply-profile-modal .modal-content .sms-code-container input#sms-code-" + inputSequence).val();
	          if (activeValue === "") {
	            this.$timeout(function () {
	              $(".apply-profile-modal .modal-content .sms-code-container input#sms-code-" + (inputSequence - 1)).focus();
	            });
	          }
	        }
	      }
	    }
	  }]);
	
	  return SignonController;
	}();
	
	SignonController.$inject = ["$http", "$localStorage", "$state", "$location", "$window", "signup.validator", "$stateParams", "profile", "auth", "env", "signon", "$timeout", "security", "$rootScope", "$scope", "tracking", "$cookies", "social", "validation"];
	
	exports.default = SignonController;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(285);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./signon.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./signon.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".sign-up-page .signon{margin-bottom:200px}.sign-up-page .modal-dialog.signon-modal{width:378px}.sign-up-page .modal-dialog.signon-modal .signon-header{margin-bottom:20px}.sign-up-page .modal-dialog.signon-modal .mobile-app-links i{margin-right:16px}.sign-up-page .modal-dialog.signon-modal .terms-and-service{border-top:none}.third-party-wrapper{margin-bottom:15px}.sign-up-page.signon form{width:100%}.sign-up-page.signon form .company-name-signon{color:#fff;font-family:Poppins,sans-serif;font-size:14px;font-weight:700;line-height:40px;height:40px;width:100%;border-radius:6px;border:none;background-color:#62c046;text-align:center;margin-top:16px;cursor:pointer}.sign-up-page.signon .sms-code-container input{width:32px;border:none;border-bottom:2px solid #868c8e;background:none;box-shadow:none;color:#62c046;font-family:Poppins,sans-serif;font-size:24px;font-weight:700;letter-spacing:0;line-height:24px;text-align:center;padding:0}", ""]);
	
	// exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _signup = __webpack_require__(287);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _companySignup = __webpack_require__(293);
	
	var _companySignup2 = _interopRequireDefault(_companySignup);
	
	var _companyOnboarding = __webpack_require__(295);
	
	var _companyOnboarding2 = _interopRequireDefault(_companyOnboarding);
	
	var _jobblerSignup = __webpack_require__(297);
	
	var _jobblerSignup2 = _interopRequireDefault(_jobblerSignup);
	
	var _signup3 = __webpack_require__(299);
	
	var _signup4 = _interopRequireDefault(_signup3);
	
	var _routing = __webpack_require__(300);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _format = __webpack_require__(301);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _tracking = __webpack_require__(302);
	
	var _tracking2 = _interopRequireDefault(_tracking);
	
	var _register = __webpack_require__(303);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _common = __webpack_require__(304);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var signupModule = _angular2.default.module("signup", [_angularUiRouter2.default, "cleave.js"]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("signup", {
	    url: "/signup",
	    template: "<signup></signup>",
	    title: "Sign up"
	  }).state("signup-company", {
	    url: "/signup/company",
	    title: "Sign up Company",
	    params: {
	      job_posting_type: null,
	      job_title: null,
	      jobble_type: null,
	      pay_rate: null,
	      pay_rate_jblr: null,
	      dress_code: null,
	      job_description: null,
	      hourly_rate: null,
	      preserve: null,
	      t: null,
	      isOnsiteManager: null,
	      date_time: null,
	      instructions: null,
	      location: null,
	      street_line_1: null
	    },
	
	    template: "<company-signup></company-signup>"
	  }).state("signup-onboarding", {
	    url: "/company/onboarding",
	    title: "Company Onboarding",
	    params: {
	      job_posting_type: null,
	      job_title: null,
	      jobble_type: null,
	      pay_rate: null,
	      pay_rate_jblr: null,
	      dress_code: null,
	      job_description: null,
	      hourly_rate: null,
	      preserve: null,
	      t: null,
	      date_time: null,
	      instructions: null,
	      location: null,
	      street_line_1: null
	    },
	
	    template: "<company-onboarding></company-onboarding>"
	  }).state("company-onboarding-1", {
	    url: "/company/onboarding/1",
	    title: "Company Onboarding - Step 1",
	    params: {},
	    template: "<company-onboarding></company-onboarding>"
	  }).state("company-onboarding-2", {
	    url: "/company/onboarding/2?manager",
	    title: "Company Onboarding - Step 2",
	    params: {
	      isOnsiteManager: null
	    },
	    template: "<company-onboarding></company-onboarding>"
	  }).state("company-onboarding-3", {
	    url: "/company/onboarding/3",
	    title: "Company Onboarding - Step 3",
	    params: {},
	    template: "<company-onboarding></company-onboarding>"
	  }).state("company-onboarding-4", {
	    url: "/company/onboarding/4",
	    title: "Company Onboarding - Step 4",
	    params: {},
	    template: "<company-onboarding></company-onboarding>"
	  }).state("signup-jobbler", {
	    url: "/signup/jobbler",
	    template: "<jobbler-signup></jobbler-signup>",
	    title: "Sign up Jobbler"
	  });
	}).service("signup.validator", _signup4.default).service("signup.routing", _routing2.default).service("signup.formatting", _format2.default).service("signup.tracking", _tracking2.default).service("signup.register", _register2.default).service("signup.common", _common2.default).component("signup", _signup2.default).component("companySignup", _companySignup2.default).component("companyOnboarding", _companyOnboarding2.default).component("jobblerSignup", _jobblerSignup2.default);
	
	exports.default = signupModule;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _signup = __webpack_require__(288);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	var _signup3 = __webpack_require__(289);
	
	var _signup4 = _interopRequireDefault(_signup3);
	
	__webpack_require__(291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var signupComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _signup2.default,
	  controller: _signup4.default,
	  controllerAs: "vm"
	};
	
	exports.default = signupComponent;

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<section class=\"login-area\" style=\"min-height: 1200px\">\n  <div class=\"login-wrap\">\n    <div class=\"login-container\">\n      <div class=\"login-content signup-center\">\n        <div class=\"row\">\n          <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n            <h3>I am looking to...</h3>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n            <a href=\"/signup/company\" class=\"btn btn-success button\">Post jobs</a>\n          </div>\n\n          <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n            <a href=\"/signup/jobbler\" class=\"btn btn-success button\">Apply to jobs</a>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"login-footer\">\n      <div class=\"signup-area\">\n        <span>\n          <a href=\"/signin\" style=\"color: #fff; text-decoration: underline\">I'm already a Jobble user</a>\n        </span>\n      </div>\n    </div>\n  </div>\n</section>\n\n<jobblefooter></jobblefooter>\n<globalalert></globalalert>\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n\n<a href=\"#verification-modal\" data-toggle=\"modal\" id=\"link-verification-modal\"></a>\n<div class=\"modal fade\" id=\"verification-modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n            </button>\n            <h3 class=\"modal-title\">Thank you</h3>\n          </div>\n\n          <div class=\"modal-body popup-body text-center\">\n            <p>{{vm.message}}</p>\n            <button class=\"btn btn-default\" ng-click=\"vm.gotoSignIn()\">Get Started</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _tracking = __webpack_require__(290);
	
	var _tracking2 = _interopRequireDefault(_tracking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignupController = function () {
	  function SignupController($http, $rootScope, $localStorage, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, $httpParamSerializerJQLike, TrackingService, SocialService, validation, ngProgressFactory, SignupValidator, SignupRouting, SignupFormatting, SignupTracking, SignupRegister, SignupCommon, ProfileService, CompanyService, $location) {
	    var _this2 = this;
	
	    _classCallCheck(this, SignupController);
	
	    this.name = "signup";
	
	    this.$http = $http;
	    this.$rootScope = $rootScope;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$progress = ngProgressFactory.createInstance();
	    this.$timeout = $timeout;
	    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
	    this.$tracking = TrackingService;
	    this.$social = SocialService;
	    this.$validation = validation;
	    this.routing = SignupRouting;
	    this.format = SignupFormatting;
	    this.tracking = SignupTracking;
	    this.register = SignupRegister;
	    this.smsAgreementVal = false;
	    this.common = SignupCommon;
	    this.$profile = ProfileService;
	    this.$companies = CompanyService;
	    this.step = 1;
	    this.onboarding_step = 1;
	    this.check_policy = false;
	    this.remain_loading_count = 0;
	    this.onboarding_card_state = "1";
	    this.phone_class = "";
	    this.result = { status: "", message: "" };
	    this.$location = $location;
	    this.isOnSiteManager = null;
	
	    this.checkForOnSiteManagerInvite();
	
	    if (this.$state && this.$state.current && this.$state.current.name) {
	      if (this.$state.current.name.indexOf("1") !== -1) {
	        this.onboarding_step = 1;
	      }
	      if (this.$state.current.name.indexOf("2") !== -1) {
	        this.onboarding_step = 2;
	      }
	      if (this.$state.current.name.indexOf("3") !== -1) {
	        this.onboarding_step = 3;
	      }
	      if (this.$state.current.name.indexOf("4") !== -1) {
	        this.onboarding_step = 3;
	      }
	    }
	
	    this.first_name = "";
	    this.last_name = "";
	    this.phone_number = "";
	    this.display_phone_number = "";
	
	    this.company_name = "";
	    this.zip_code = "";
	    this.password = "";
	
	    this.city = "";
	    this.state = "";
	    this.email = "";
	    this.posting_data = {};
	    this.displayTOSModal = false;
	    this.$location = $location;
	    this.userInvited = false;
	    this.userInvitedToken = "";
	    this.message = "An email verification has been sent! Please click the link in that email to finish your registration.";
	
	    this.states = {
	      values: ["--", "AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"]
	    };
	
	    this.cardNumberFormatting = {
	      creditCard: true,
	      delimiter: "-",
	      onValueChanged: function onValueChanged(e) {
	        _this2.cardNumber = e.target.rawValue.trim();
	      }
	    };
	
	    var thisYear = new Date().getFullYear();
	    var allYears = [thisYear.toString()];
	
	    for (var i = 1; i < 15; i++) {
	      allYears.push((thisYear + i).toString());
	    }
	
	    this.expYears = { value: thisYear.toString(), values: allYears };
	    //this.expMonths = { "value" : thisMonth.toString(), "values" : monthsForDropDrown };
	    this.expMonths = {
	      value: "01",
	      values: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
	    };
	
	    // Tracking
	    this.posting_data = this.$stateParams;
	    this.tracking.initFB();
	    this.page = this.routing.routePage();
	
	    // Validation variables
	    this.validation = {};
	    this.validator = SignupValidator;
	    this.phoneFormatting = this.format.phoneFormatting(this);
	    this.phoneFormattingOnboarding = this.format.phoneFormattingOnboarding(this);
	
	    // Prevent validation before the user starts typing
	    this.canValidate = false;
	    this.$timeout(function () {
	      return _this2.canValidate = true;
	    }, 1000);
	
	    this.common.removeBodyClass();
	
	    this.onboarding_data = {
	      first_name: "34",
	      last_name: "23",
	      phone_number: 23,
	      display_phone_number: "12323"
	    };
	
	    this.locationOptions = [{ label: "1", value: 1 }, { label: "2", value: 2 }, { label: "3", value: 3 }, { label: "4", value: 4 }, { label: "5", value: 5 }, { label: "6", value: 6 }, { label: "7", value: 7 }, { label: "8", value: 8 }, { label: "9", value: 9 }, { label: "10+", value: 10 }];
	
	    this.setInviteUserData();
	    this.setOnboardingFields();
	
	    this.$timeout(function () {
	      $(".sign-up-page .input-container input:first").focus();
	    }, 300);
	  }
	
	  _createClass(SignupController, [{
	    key: "setInviteUserData",
	    value: function setInviteUserData() {
	      var _this3 = this;
	
	      var _this = this;
	
	      if (_this.$location) {
	        _this.userInvitedToken = _this.$location.search().token;
	
	        if (_this.userInvitedToken) {
	          var req = {
	            method: "GET",
	            url: _this.$env.getAPIEndPoint() + "register/invite-user?action=inviteUserInfo&token=" + _this.userInvitedToken,
	            headers: {
	              "Content-Type": "application/json"
	            }
	          };
	          _this.$http(req).then(function (data) {
	            if (data.data) {
	              _this.userInvited = true;
	              _this.company_name = data.data.invitedByCompanyDescription;
	              _this.email = data.data.inviteeEmail;
	              localStorage.lastUserInviteeEmail = data.data.inviteeEmail;
	
	              var phone = data.data.invitedByCompanyPhoneNumber;
	
	              if (!phone) {
	                _this.display_phone_number = phone;
	              } else {
	                //_this.display_phone_number = _this.formatPhoneNumber(phone);
	                if (phone.length == 11) {
	                  phone = phone.slice(1);
	                }
	                _this.display_phone_number = "111" + phone;
	              }
	
	              _this.compareCurrentUser(data.data);
	            }
	          }).catch(function (err) {
	            _this3.handleInviteUserError(err);
	          });
	          return;
	        }
	      }
	    }
	  }, {
	    key: "handleInviteUserError",
	    value: function handleInviteUserError(err) {
	      if (err.data.message === "This token is invalid") {
	        this.result.status = "error";
	        this.result.message = "The link in the invitation email you received has either expired or been canceled. Kindly review your inbox for a more recent invitation.";
	      } else {
	        this.result.status = "error";
	        this.result.message = err.data.message;
	      }
	    }
	  }, {
	    key: "compareCurrentUser",
	    value: function compareCurrentUser(invitedUser) {
	      if (this.currentUser) {
	        if (invitedUser.inviteeEmail !== this.currentUser.email) {
	          this.$auth.logoutOnboarding();
	        }
	      }
	    }
	  }, {
	    key: "formatPhoneNumber",
	    value: function formatPhoneNumber(phoneNumberString) {
	      var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
	
	      var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
	
	      if (match) {
	        return "+1 (" + match[1] + ") " + match[2] + "-" + match[3];
	      }
	
	      return null;
	    }
	  }, {
	    key: "setOnboardingFields",
	    value: function setOnboardingFields() {
	      var _this4 = this;
	
	      var user = this.$auth.getUserData();
	
	      this.currentUser = user;
	
	      if (user) {
	        this.$timeout(function () {
	          _this4.already_registered = true;
	          var phone = user.homeContactInfo && user.firstName ? user.homeContactInfo.phoneMobile : "";
	          var company = user.company ? user.company : {};
	          var companyContactInfo = company.mainContactInfo ? company.mainContactInfo : {};
	
	          console.log("user.company", company);
	          _this4.company_name = company.name;
	          _this4.email = user.username;
	          //this.password = "P@ssw0rd1!";
	          _this4.phone_number = companyContactInfo.phoneMobile || "";
	
	          if (localStorage.lastUserInviteeEmail === user.username) {
	            _this4.userInvited = true;
	          }
	
	          if (companyContactInfo.phoneMobile && companyContactInfo.phoneMobile.length && companyContactInfo.phoneMobile[0] === "1") {
	            _this4.display_phone_number = "+1 " + companyContactInfo.phoneMobile.slice(1);
	          } else {
	            _this4.display_phone_number = "+1 " + companyContactInfo.phoneMobile;
	          }
	
	          _this4.onboarding_data = {
	            first_name: user.firstName,
	            last_name: user.lastName,
	            display_phone_number: phone,
	            phone_number: phone,
	            legal_company_name: company.legalCompanyName,
	            ein: company.ein,
	            number_of_locations: (company.numberOfLocations || 0).toString(),
	            company_name: company.name,
	            company_street_address: companyContactInfo.streetLine1,
	            company_city: companyContactInfo.city,
	            company_state: companyContactInfo.state,
	            company_zip_code: companyContactInfo.zipCode,
	            userInvited: user.userInvited
	          };
	
	          _this4.validatePersonalDetails();
	          _this4.validateCompanyDetails();
	          _this4.validateBankDetails();
	          _this4.validateCardDetails();
	        });
	      }
	    }
	  }, {
	    key: "setValidation",
	    value: function setValidation(_ref) {
	      var _this5 = this;
	
	      var field = _ref.field,
	          valid = _ref.valid,
	          message = _ref.message;
	
	      if (this.canValidate) this.$timeout(function () {
	        _this5.validation[field] = {
	          valid: valid,
	          style: { borderColor: valid ? "green" : "red" },
	          message: message
	        };
	      });
	      this.validation;
	    }
	  }, {
	    key: "gotoSignIn",
	    value: function gotoSignIn() {
	      var _this6 = this;
	
	      this.common.closeVerificationModal();
	      this.$timeout(function () {
	        _this6.$localStorage.logged_user = _this6.currentUser;
	        _this6.routing.routeSignInPage(_this6.posting_data, _this6.currentUser);
	      }, 400);
	    }
	  }, {
	    key: "bankDataChanging",
	    value: function bankDataChanging() {
	      this.validateBankDetails();
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "validateCard",
	    value: function validateCard() {
	      var valid = true;
	
	      this.validateCardErrorMessage = "";
	      this.validateCardError = false;
	
	      return true;
	
	      var validCreditCardName = this.handleCreditCardNameChange();
	      var validStreet = this.handleStreetChange();
	      var validCity = this.handleCityChange();
	      var validState = this.handleStateChange();
	      var validZipCode = this.handleZipCodeChange();
	      var validCardNumber = this.handleCardNumberChange();
	      var validCVC = this.handleCVCChange();
	      var validExpirationDate = this.handleExpirationDateChange();
	
	      if (!validCreditCardName || !validStreet || !validCity || !validState || !validZipCode || !validCardNumber || !validCVC || !validExpirationDate) valid = false;
	
	      if (!validCreditCardName) {
	        this.validateCardError = true;
	        this.validateCardErrorMessage = "Please provide the name associated with this credit card.";
	      }
	
	      if (!validStreet) {
	        this.validateCardError = true;
	        this.validateCardErrorMessage = "Please provide a street address.";
	      }
	
	      if (!validCity) {
	        this.validateCardError = true;
	        this.validateCardErrorMessage = "Please provide a city.";
	      }
	
	      if (!validState) {
	        this.validateCardError = true;
	        this.validateCardErrorMessage = "Please provide a state.";
	      }
	
	      if (!validZipCode) {
	        this.validateCardError = true;
	        this.validateCardErrorMessage = "Please provide a zipcode.";
	      }
	
	      if (!validCardNumber) {
	        this.validateCardError = true;
	        this.validateCardErrorMessage = "Invalid card number.";
	      }
	
	      if (!validCVC) {
	        this.validateCardError = true;
	        this.validateCardErrorMessage = "Invalid cvc code.";
	      }
	
	      if (!validExpirationDate) {
	        this.validateCardError = true;
	        this.validateCardErrorMessage = "Invalid expiration date.";
	      }
	
	      this.isCreditCardDisabled = !valid;
	
	      return valid;
	    }
	  }, {
	    key: "createCard",
	    value: function createCard() {
	      var _this7 = this;
	
	      this.isCreditCardDisabled = true;
	
	      if (!this.validateCard()) {
	        return console.error("Invalid card. Not creating card");
	      }
	
	      var charge_on_creation = false;
	
	      var myData = {
	        card: {
	          number: this.cardNumber,
	          exp_month: this.expMonths.value,
	          exp_year: this.expYears.value,
	          cvc: this.cvc,
	          address_line1: this.street,
	          address_city: this.city,
	          address_state: this.state,
	          address_zip: this.zipCode,
	          name: this.credit_card_name
	        }
	      };
	
	      var req = {
	        method: "POST",
	        url: "https://api.stripe.com/v1/tokens",
	        headers: {
	          "Content-Type": "application/x-www-form-urlencoded",
	          Authorization: "Bearer " + this.$env.EnvironmentConfig.stripeKey
	        },
	        data: this.$httpParamSerializerJQLike(myData)
	      };
	
	      // this.remain_loading_count++;
	
	      this.$http(req).then(function (response) {
	        // this.remain_loading_count--;
	
	        req = {
	          method: "POST",
	          url: _this7.$env.getAPIEndPoint() + "jbl/v1/stripe/save-customer?format=json&conf=web",
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + _this7.currentUser.access_token
	          },
	          data: {
	            username: _this7.currentUser.username,
	            stripeToken: response.data.id,
	            nickname: _this7.nickname
	          }
	        };
	
	        // this.remain_loading_count++;
	
	        var new_token_id = null;
	        if (response.data.card) {
	          new_token_id = response.data.card.id;
	        } else {
	          new_token_id = response.data.bank.id;
	        }
	
	        _this7.$http(req).then(function (res) {
	          if (res.data.status !== "error") {
	            _this7.cardNumber = "";
	            _this7.expMonths.value = "";
	            _this7.expYears.value = "";
	            _this7.nickname = "";
	            _this7.cvc = "";
	            _this7.street = _this7.city = _this7.state = _this7.zipCode = "";
	            var cardLoop = function cardLoop(value) {
	              _this7.$timeout(function () {
	                if (value > 0) {
	                  _this7.currentUser = _this7.$auth.validateUserByTokenWeb(_this7.currentUser.access_token).then(function (r) {
	                    r.data.company.paymentInfos = r.data.company.undeletedPaymentInfos;
	                    _this7.$localStorage.logged_user = r.data;
	                    _this7.currentUser = r.data;
	                    var result = _this7.currentUser.company.undeletedPaymentInfos.find(function (o) {
	                      return o.stripeId === new_token_id;
	                    });
	                    if (result) {
	                      _this7.$timeout(function () {
	                        // this.remain_loading_count = 0;
	                      }, 300);
	
	                      _this7.$timeout(function () {
	                        if (_this7.payForPost && !charge_on_creation) {
	                          _this7.$rootScope.$emit("ShowPostModalCC", {
	                            user: _this7.currentUser,
	                            new_card: result
	                          });
	                        } else if (_this7.payForPost && charge_on_creation) {
	                          _this7.$rootScope.$emit("ChargeCreditCardForPost", {
	                            user: _this7.currentUser,
	                            new_card: result,
	                            event: _this7.event_for_pay
	                          });
	                        } else {
	                          if (_this7.$rootScope.isSourcingJobForPayment) {
	                            _this7.$rootScope.$emit("UpdatedCreditCardConnection", {});
	                          }
	                        }
	                        _this7.$rootScope.$emit("UpdatedCreditCardConnectionCompletePage", {});
	                        _this7.$rootScope.$emit("UpdatedCreditCard", {
	                          user: _this7.currentUser
	                        });
	                        _this7.$rootScope.$emit("SetRegisterCardStatus", {
	                          status: 1
	                        });
	                        _this7.isCreditCardDisabled = false;
	                      }, 800);
	                    } else {
	                      cardLoop(value - 1);
	                    }
	                  });
	                } else {
	                  _this7.isCreditCardDisabled = false;
	                }
	              }, 1000);
	            };
	            cardLoop(10);
	          } else {
	            _this7.isCreditCardDisabled = false;
	            _this7.validateCardError = true;
	            _this7.validateCardErrorMessage = res.data.message;
	            // this.remain_loading_count--;
	          }
	        }, function (res) {
	          _this7.validateCardError = true;
	          _this7.isCreditCardDisabled = false;
	          _this7.validateCardErrorMessage = "Error while registering a credit card.";
	          _this7.$timeout(function () {
	            _this7.$rootScope.$emit("SetRegisterCardStatus", {
	              status: 2
	            });
	            // this.remain_loading_count--;
	          });
	        });
	      }, function (response) {
	        // this.remain_loading_count--;
	        _this7.isCreditCardDisabled = false;
	        _this7.$timeout(function () {
	          _this7.$rootScope.$emit("SetRegisterCardStatus", {
	            status: 2
	          });
	          _this7.validateCardError = true;
	          _this7.validateCardErrorMessage = response.data.error.message;
	        });
	      });
	    }
	  }, {
	    key: "createBankAccount",
	    value: function createBankAccount() {
	      var _this8 = this;
	
	      console.log("createBankAccount", this.isSaveBankAccountDisabled);
	      this.setLoader();
	      this.isSaveBankAccountDisabled = true;
	
	      this.newBankAccount = {
	        bank_account: {
	          country: "us",
	          currency: "usd",
	          account_holder_name: null,
	          account_holder_type: "company",
	          routing_number: null,
	          account_number: null
	        }
	      };
	
	      this.newBankAccount.bank_account.account_holder_name = this.accountHolderName;
	      this.newBankAccount.bank_account.routing_number = this.routingNumber;
	      this.newBankAccount.bank_account.account_number = this.accountNumber;
	
	      console.log("what is the new bank account");
	      console.dir(this.newBankAccount);
	
	      var req = {
	        method: "POST",
	        url: "https://api.stripe.com/v1/tokens",
	        headers: {
	          "Content-Type": "application/x-www-form-urlencoded",
	          Authorization: "Bearer " + this.$env.EnvironmentConfig.stripeKey
	        },
	        data: this.$httpParamSerializerJQLike(this.newBankAccount)
	      };
	
	      this.$http(req).then(function (response) {
	        console.log("-----------here is the tokens response...");
	        console.dir(response);
	        _this8.$timeout(function () {
	          _this8.saveCustomerToJobbleAPI(response);
	        }, 1000);
	
	        _this8.validateCardError = false;
	        _this8.unSetLoader();
	      }, function (res) {
	        console.log("error here?");
	        console.dir(res);
	        _this8.validateCardError = true;
	        _this8.validateCardErrorMessage = res.data.error.message;
	        _this8.unSetLoader();
	        _this8.$timeout(function () {
	          _this8.$rootScope.$emit("SetRegisterCardStatus", {
	            status: 2
	          });
	        });
	      });
	    }
	  }, {
	    key: "saveCustomerToJobbleAPI",
	    value: function saveCustomerToJobbleAPI(response) {
	      var _this9 = this;
	
	      this.setLoader();
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/save-customer?format=json&conf=web&isBankToken=true",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.currentUser.access_token
	        },
	        data: {
	          username: this.currentUser.username,
	          stripeToken: response.data.id
	        }
	      };
	
	      this.$http(req).then(function (res) {
	        if (res.data.status !== "error") {
	          _this9.routingNumber = undefined;
	          _this9.accountNumber = undefined;
	          _this9.accountHolderName = undefined;
	          _this9.isSaveBankAccountDisabled = false;
	
	          _this9.loopThroughPaymentInfo();
	
	          console.log("this is the last thing we see.");
	        } else {
	          _this9.validateCardError = true;
	          _this9.validateCardErrorMessage = res.data.message;
	          _this9.isSaveBankAccountDisabled = false;
	        }
	        _this9.unSetLoader();
	      }, function (res) {
	        _this9.validateCardError = true;
	        _this9.validateCardErrorMessage = res.data.message;
	        _this9.isSaveBankAccountDisabled = false;
	        _this9.unSetLoader();
	        _this9.$timeout(function () {
	          _this9.$rootScope.$emit("SetRegisterCardStatus", {
	            status: 2
	          });
	        });
	      });
	    }
	  }, {
	    key: "smsAgreement",
	    value: function smsAgreement(agreed) {
	      var _this10 = this;
	
	      var user = { tcpaConsent: agreed };
	      this.setLoader();
	      this.$profile.saveUserBasic(user).then(function (response) {
	        _this10.unSetLoader();
	      }, function (error) {
	        _this10.unSetLoader();
	      });
	    }
	  }, {
	    key: "loopThroughPaymentInfo",
	    value: function loopThroughPaymentInfo() {
	      var _this11 = this;
	
	      var cardLoop = function cardLoop(value) {
	        _this11.$timeout(function () {
	          if (value > 0) {
	            _this11.currentUser = _this11.$auth.validateUserByTokenWeb(_this11.currentUser.access_token).then(function (r) {
	              console.log("Do we make it this far 3");
	              _this11.$localStorage.logged_user = r.data;
	              _this11.currentUser = r.data;
	              _this11.currentUser.company.paymentInfos = _this11.currentUser.company.undeletedPaymentInfos;
	              if (_this11.currentUser.company.paymentInfos.length === _this11.paymentOptionsCounts + 1) {
	                console.log("Do we make it this far 4");
	                _this11.remain_loading_count = 0;
	                _this11.$timeout(function () {
	                  _this11.paymentOptionsCounts = _this11.paymentOptionsCounts + 1;
	                  _this11.$rootScope.$emit("UpdatedBankAccounts", {});
	                  _this11.reloadBankAccounts();
	                }, 100);
	              } else {
	                cardLoop(value - 1);
	              }
	            });
	          } else {
	            _this11.remain_loading_count = 0;
	
	            _this11.$timeout(function () {
	              // alert("Please give the system a moment to update your payment information. Please check back in a couple minutes.");
	            }, 300);
	          }
	        }, 1000);
	      };
	      cardLoop(3);
	    }
	  }, {
	    key: "reloadBankAccounts",
	    value: function reloadBankAccounts() {
	      var _this12 = this;
	
	      var partner = this.currentUser.company.partner;
	
	      if (partner) {
	        //this.displayModalExplainingMicroDep();
	      }
	
	      this.banksArray = [];
	
	      this.$timeout(function () {
	        _this12.currentUser = _this12.$auth.getUserData();
	        _this12.paymentInfos = _this12.currentUser.company.paymentInfos;
	        _this12.organizeBankAccounts();
	      }, 100);
	    }
	  }, {
	    key: "organizeBankAccounts",
	    value: function organizeBankAccounts() {
	      var _this13 = this;
	
	      this.paymentInfos.forEach(function (paymentInfo) {
	        if (paymentInfo.bankName) {
	          _this13.banksArray.push(paymentInfo);
	        }
	      });
	    }
	  }, {
	    key: "setNextStep",
	    value: function setNextStep() {
	      var user = this.$auth.getUserData();
	      console.log("setNextStep");
	      console.dir(this.onboarding_step);
	      if (this.onboarding_step === 3 && !this.userInvited) {
	        this.$state.go("postashiftwalkthrough");
	      } else if (this.onboarding_step === 4 || this.userInvited) {
	        if (user.company.totalNumberOfEvents > 0) {
	          this.$state.go("jobsdashboard");
	        } else {
	          this.$state.go("postashiftwalkthrough");
	        }
	      } else if (this.onboarding_step < 4) {
	        if (this.currentUser.company.isVerified) {
	          this.$state.go("jobsdashboard");
	        } else {
	          var new_step = void 0;
	          if (this.onboarding_step === 2) {
	            new_step = 3;
	          } else {
	            new_step = this.onboarding_step + 1;
	          }
	          console.log("we are going to this step");
	          console.dir(new_step);
	          this.$state.go("company-onboarding-" + new_step);
	        }
	      }
	      this.enableToolTips();
	    }
	  }, {
	    key: "saveUserInformation",
	    value: function saveUserInformation() {
	      var _this14 = this;
	
	      this.setLoader();
	
	      var payload = {
	        firstName: this.onboarding_data.first_name,
	        lastName: this.onboarding_data.last_name,
	        homeContactInfo: {
	          phoneMobile: this.onboarding_data.phone_number
	        }
	      };
	
	      this.$profile.saveUserBasic(payload).then(function (response) {
	        _this14.$auth.refreshCurrentUser().then(function (user) {
	          console.log("Save response", response);
	          _this14.unSetLoader();
	        });
	      });
	    }
	  }, {
	    key: "saveUserInformationThenTriggerCode",
	    value: function saveUserInformationThenTriggerCode() {
	      var _this15 = this;
	
	      this.validPersonalDetails = false;
	      this.setLoader();
	
	      var payload = {
	        firstName: this.onboarding_data.first_name,
	        lastName: this.onboarding_data.last_name,
	        homeContactInfo: {
	          phoneMobile: this.onboarding_data.phone_number
	        }
	      };
	
	      this.$profile.saveUserBasic(payload).then(function (response) {
	        _this15.$auth.refreshCurrentUser().then(function (user) {
	          console.log("Save response", response);
	          _this15.$timeout(function () {
	            _this15.unSetLoader();
	            _this15.validPersonalDetails = true;
	            _this15.triggerSMSCode(response, user);
	          }, 1000);
	        }).catch(function (err) {
	          _this15.unSetLoader();
	          _this15.validPersonalDetails = true;
	          alert("Error saving user information.");
	        });
	      }).catch(function (error) {
	        _this15.unSetLoader();
	        _this15.validPersonalDetails = true;
	        alert("Error saving user information.");
	      });
	    }
	  }, {
	    key: "updateCompanyInformation",
	    value: function updateCompanyInformation() {
	      var _this16 = this;
	
	      this.$timeout(function () {
	        // this.savingCompanyInformation = true;
	      });
	
	      var payload = {
	        company_name: this.company_name,
	        company_phone: this.phone_number
	      };
	
	      this.$companies.saveCompanyProfileInformation(payload).then(function (response) {
	        _this16.$timeout(function () {
	          // this.savingCompanyInformation = false;
	          // this.setNextStep();
	        });
	
	        _this16.$auth.refreshCurrentUser().then(function (user) {
	          console.log("Save company response", response);
	        });
	      }).catch(function (error) {
	        _this16.$auth.refreshCurrentUser().then(function (user) {
	          _this16.$timeout(function () {
	            // this.savingCompanyInformation = false;
	          });
	
	          console.log("Save company error", error);
	        });
	      });
	    }
	  }, {
	    key: "saveCompanyInformation",
	    value: function saveCompanyInformation() {
	      var _this17 = this;
	
	      this.$timeout(function () {
	        _this17.savingCompanyInformation = true;
	        _this17.invalidZipCode = false;
	      });
	
	      var payload = {
	        company_name: this.onboarding_data.company_name,
	        company_street_address: this.onboarding_data.company_street_address,
	        company_city: this.onboarding_data.company_city,
	        company_state: this.onboarding_data.company_state,
	        company_zip_code: this.onboarding_data.company_zip_code,
	        // ein: this.onboarding_data.ein,
	        number_of_locations: this.onboarding_data.number_of_locations,
	        legal_company_name: this.onboarding_data.legal_company_name
	      };
	
	      this.$companies.saveCompanyProfileInformation(payload).then(function (response) {
	        _this17.$timeout(function () {
	          _this17.savingCompanyInformation = false;
	          _this17.setNextStep();
	        });
	
	        _this17.$auth.refreshCurrentUser().then(function (user) {
	          console.log("Save company response", response);
	        });
	      }).catch(function (error) {
	        _this17.$auth.refreshCurrentUser().then(function (user) {
	          _this17.$timeout(function () {
	            _this17.savingCompanyInformation = false;
	            _this17.invalidZipCode = true;
	          });
	
	          console.log("Save company error", error);
	          if (error && error.data && error.data.message && error.data.message.toLowerCase().indexOf("zip code") !== -1) {
	            console.error("Invalid zip code");
	            _this17.$timeout(function () {
	              _this17.invalidZipCode = true;
	            });
	          }
	        });
	      });
	    }
	  }, {
	    key: "uploadFilesNew",
	    value: function uploadFilesNew(file, errors) {
	      var _this18 = this;
	
	      var fd = new FormData();
	
	      this.setLoader();
	
	      fd.append("file", file);
	
	      if (errors.length > 0) {
	        this.unSetLoader();
	        alert("There is an issue with that image. Please choose a different one.");
	        return;
	      }
	
	      if (file) {
	        //console.log('the file actually is something');
	
	        this.currentUser = this.$auth.getUserData();
	
	        var uploadUrlCompany = this.$auth.getUploadUrl(this.currentUser.company.id, file);
	
	        this.uploadingImage = true;
	        this.$http.post(uploadUrlCompany, fd, {
	          transformRequest: _angular2.default.identity,
	          headers: {
	            "Content-Type": undefined,
	            Authorization: "Bearer " + this.currentUser.access_token
	          }
	        }).then(function (response) {
	          var callback = response.data;
	
	          _this18.$timeout(function () {
	            _this18.uploadingImage = false;
	
	            _this18.currentUser.company.companyLogoUri = callback.mainFile.url;
	            _this18.$rootScope.companyLogoUri = callback.mainFile.url;
	            _this18.$rootScope.imgFromProfilePage = callback.mainFile.url;
	            //this.determineImageDimensions(callback.mainFile.url);
	            _this18.currentUser.companyProfilePictureUrl = _this18.currentUser.company.companyLogoUri;
	            _this18.$auth.reloadCurrentUser();
	            _this18.unSetLoader();
	            _this18.$rootScope.$emit("SetProfilePicture", {
	              picture: callback.mainFile.url
	            });
	          }, 100);
	        }, function (error) {
	          _this18.unSetLoader();
	          _this18.$timeout(function () {
	            _this18.uploadingImage = false;
	            jQuery("#application-global-modal .modal-header button.close").trigger("click");
	          }, 100);
	
	          _this18.$timeout(function () {
	            alert("There is an issue with that image. Please choose a different one.");
	          }, 1000);
	        });
	      }
	    }
	  }, {
	    key: "determineImageDimensions",
	    value: function determineImageDimensions(url) {
	      console.log("determineImageDimensions");
	      console.dir(url);
	
	      var myImg = document.querySelector("#img-logo-company");
	
	      console.log("myImg");
	      console.dir(myImg);
	
	      var imageClassForDisplay = this.$profile.dimensionsCalc(myImg.clientHeight, myImg.clientWidth);
	
	      this.$timeout(function () {
	        $("#img-logo-company").addClass(imageClassForDisplay);
	      });
	    }
	  }, {
	    key: "validatePersonalDetails",
	    value: function validatePersonalDetails() {
	      this.validPersonalDetails = true;
	
	      if (!this.onboarding_data.first_name || !this.onboarding_data.last_name || !this.onboarding_data.phone_number || !this.onboarding_data.phone_number.length || this.onboarding_data.phone_number.length < 10) {
	        this.validPersonalDetails = false;
	      }
	    }
	  }, {
	    key: "enableToolTips",
	    value: function enableToolTips() {
	      this.$timeout(function () {
	        $(".onboarding-tool-tip").tooltip({}).tooltip("fixTitle");
	      }, 200);
	    }
	  }, {
	    key: "validateCompanyDetails",
	    value: function validateCompanyDetails() {
	      this.enableToolTips();
	
	      this.validCompanyDetails = true;
	
	      var ssnPattern = /^[0-9]{3}\-?[0-9]{2}\-?[0-9]{4}$/;
	      var zipCodePattern = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
	
	      if (!this.onboarding_data.company_name || !this.onboarding_data.company_street_address ||
	      // !this.onboarding_data.ein || !(ssnPattern.test(this.onboarding_data.ein)) ||
	      !this.onboarding_data.legal_company_name || !this.onboarding_data.number_of_locations || !this.onboarding_data.company_city || !this.onboarding_data.company_state || !this.onboarding_data.company_zip_code || !zipCodePattern.test(this.onboarding_data.company_zip_code)) {
	        this.validCompanyDetails = false;
	      }
	    }
	  }, {
	    key: "validateBankDetails",
	    value: function validateBankDetails() {
	      this.validBankDetails = true;
	
	      if (!this.accountHolderName || !this.accountNumber || !this.routingNumber) {
	        this.validBankDetails = false;
	      }
	
	      if (!_angular2.default.isUndefined(this.accountHolderName) && !_angular2.default.isUndefined(this.routingNumber) && !_angular2.default.isUndefined(this.accountNumber)) {
	        if (!(/^\w{1,17}$/.test(this.accountNumber) && this.routingNumber.length === 9)) {
	          this.validBankDetails = false;
	        }
	      }
	    }
	  }, {
	    key: "validateCardDetails",
	    value: function validateCardDetails() {
	      this.validCardDetails = true;
	
	      if (!this.credit_card_name || !this.street || !this.city || !this.state || !this.zipCode || !this.cardNumber || !this.expYears.value || !this.expMonths.value || !this.cvc) {
	        this.validCardDetails = false;
	      }
	    }
	  }, {
	    key: "signup",
	    value: function signup() {
	      var _this19 = this;
	
	      console.log("signup");
	
	      if (this.buttonDisabled === true) {
	        return;
	      }
	
	      var vm = this;
	      var validated = this.validator.validate(vm);
	      if (!validated) return console.error("One of the sign up fields is invalid. Not processing signing up.");
	
	      if (this.$auth.getUserData()) {
	        console.warn("Company already created; submitting edit and skipping to onboarding");
	        this.updateCompanyInformation();
	
	        if (this.userInvited) {
	          this.$state.go("company-onboarding-2");
	        } else {
	          this.$state.go("company-onboarding-1");
	        }
	
	        return;
	      }
	
	      var user = this.register.formatUserObject(vm);
	      console.log("user here");
	      console.dir(user);
	
	      this.buttonDisabled = true;
	
	      this.$progress.start();
	
	      this.register.companySignup(user).then(function (_ref2) {
	        var success = _ref2.success,
	            registerStatus = _ref2.registerStatus,
	            errorMessage = _ref2.errorMessage,
	            user = _ref2.user;
	
	        _this19.handleSignup({
	          success: success,
	          registerStatus: registerStatus,
	          errorMessage: errorMessage,
	          user: user
	        });
	      });
	    }
	  }, {
	    key: "capitalizeFirstLetter",
	    value: function capitalizeFirstLetter(value, type) {
	      if (value) {
	        if (type === "firstName") {
	          if (value.length === 2) {
	            this.onboarding_data.first_name = value.charAt(0).toUpperCase() + value.slice(1);
	          }
	        } else if (type === "lastName") {
	          this.onboarding_data.last_name = value.charAt(0).toUpperCase() + value.slice(1);
	        }
	      }
	    }
	  }, {
	    key: "handleSignup",
	    value: function handleSignup(_ref3) {
	      var _this20 = this;
	
	      var success = _ref3.success,
	          registerStatus = _ref3.registerStatus,
	          errorMessage = _ref3.errorMessage,
	          user = _ref3.user;
	
	      //console.log("Handling sign up. Remaining count:", this.remain_loading_count);
	
	      if (success) {
	        var email = user.email,
	            password = user.password;
	
	
	        this.$timeout(function () {
	          _this20.register.loginUser({ emailLogin: email, passwordLogin: password }).then(function (_ref4) {
	            var success = _ref4.success,
	                user = _ref4.user,
	                error = _ref4.error;
	
	            _this20.buttonDisabled = false;
	            _this20.remain_loading_count--;
	            _this20.handleLogin({ success: success, user: user, error: error });
	            _this20.$progress.complete();
	            _this20.$tracking.reportGlobalSubmit("sign up - submit - new company sign up");
	          });
	        }, 5000);
	      } else {
	        this.buttonDisabled = false;
	
	        if (registerStatus === "500") {
	          this.$progress.complete();
	          this.$timeout(function () {
	            $("#show-application-alert").trigger("click");
	          });
	        }
	
	        this.$timeout(function () {
	          _this20.remain_loading_count = 0;
	          _this20.$progress.complete();
	          _this20.result.status = "error";
	          _this20.result.message = errorMessage;
	          console.log("Error shown. remaining count:", _this20.remain_loading_count);
	        });
	      }
	    }
	  }, {
	    key: "submitOnEnter",
	    value: function submitOnEnter(e) {
	      if (e.keyCode === 13) {
	        this.signupJobbler();
	      }
	    }
	  }, {
	    key: "submitOnEnterCompany",
	    value: function submitOnEnterCompany(e) {
	      if (e.keyCode === 13) {
	        this.signup();
	      }
	    }
	  }, {
	    key: "signupJobbler",
	    value: function signupJobbler() {
	      var _this21 = this;
	
	      var validated = this.validator.validateJobbler(this);
	
	      if (!validated) return console.error("One of the sign up fields is invalid. Not processing signing up.");
	
	      this.buttonDisabled = true;
	      this.common.setLoader();
	
	      var user = this.register.formatJobblerObject(this);
	
	      if (user && user.email) {
	        var _hsq = window._hsq || [];
	        window._hsq = _hsq;
	        _hsq.push(["setPath", "/signup/jobbler"]);
	        _hsq.push(["identify", { email: user.email }]);
	        _hsq.push(["trackPageView"]);
	        console.log("Hubspot logs", _hsq);
	      }
	
	      this.$auth.registerMobileUser(user).then(function (response) {
	        _this21.handleJobblerSignUp(response);
	      }, function (error) {
	        _this21.buttonDisabled = false;
	        window.toastr.error("<i class=\"fas fa-times\" style='margin-right: 8px'></i>Error registering. Please contact support.");
	      });
	    }
	  }, {
	    key: "handleJobblerSignUp",
	    value: function handleJobblerSignUp(response) {
	      this.buttonDisabled = false;
	
	      if (response.data.status === "error") {
	        if (response.data.message.indexOf("Duplicate entry") > -1) {
	          window.toastr.error("<i class=\"fas fa-times\" style='margin-right: 8px'></i>Username already exist try another email");
	        } else {
	          window.toastr.error("<i class=\"fas fa-times\" style='margin-right: 8px'></i>There was an error please try again");
	        }
	        this.common.unSetLoader();
	        return;
	      }
	      if (response.data.status === "OK") {
	        var user = this.register.formatJobblerObject(this);
	
	        this.$tracking.reportJobblerSignUp(user);
	        this.tracking.fbTrackRegistration(response, user);
	        this.signinJobbler();
	      }
	    }
	  }, {
	    key: "signinJobbler",
	    value: function signinJobbler() {
	      var _this22 = this;
	
	      var user = this.register.formatJobblerObject(this);
	
	      this.$auth.lazyLoginMobileUser(user).then(function (response) {
	        _this22.handleJobblerSignin(response);
	      }, function (error) {
	        alert("Error registering. Please contact support");
	      });
	    }
	  }, {
	    key: "handleJobblerSignin",
	    value: function handleJobblerSignin(response) {
	      this.$localStorage.logged_user = response.data;
	      this.currentUser = this.$auth.getUserData();
	
	      var user = this.$auth.getUserData();
	
	      this.common.unSetLoader();
	      this.step = 2;
	    }
	  }, {
	    key: "sendUserToJobs",
	    value: function sendUserToJobs() {
	      var _this23 = this;
	
	      this.$timeout(function () {
	        $("body").removeClass();
	      });
	
	      this.$timeout(function () {
	        _this23.$state.go("jobs");
	      }, 300);
	    }
	  }, {
	    key: "handleLogin",
	    value: function handleLogin(_ref5) {
	      var _this24 = this;
	
	      var success = _ref5.success,
	          user = _ref5.user,
	          error = _ref5.error;
	
	      this.buttonDisabled = false;
	
	      if (success) {
	        this.buttonDisabled = false;
	        this.currentUser = user;
	        user.userInvited = this.userInvited;
	        this.$auth.setMostRecentUser(user);
	        if (user.company.totalNumberOfEvents > 0 && !this.userInvited) {
	          this.$state.go("jobsdashboard");
	        } else {
	          if (this.userInvited) {
	            if (this.isOnSiteManager === true) {
	              this.$state.transitionTo("company-onboarding-2", { manager: true });
	            } else {
	              this.$state.go("company-onboarding-2");
	            }
	          } else {
	            this.$state.go("company-onboarding-1");
	          }
	        }
	      } else {
	        this.$timeout(function () {
	          console.log("here we end up");
	          console.dir(error);
	          _this24.remain_loading_count = 0;
	          if (error.status === 401) {} else {
	            alert("Oh no! It looks like there was an error creating your account!" + " Please try submitting your registration information again, and" + " if this issue persists, please contact success@jobble.com for additional support.");
	          }
	        });
	      }
	    }
	  }, {
	    key: "checkForOnSiteManagerInvite",
	    value: function checkForOnSiteManagerInvite() {
	      if (this.$state.current.name === "signup-company") {
	        if (this.$location.$$search.isOnsiteManager) {
	          this.isOnSiteManager = true;
	        } else {
	          this.isOnSiteManager = false;
	        }
	      }
	
	      if (this.$state.current.name === "company-onboarding-2") {
	        if (this.$stateParams.manager) {
	          this.isOnSiteManager = true;
	        }
	      }
	    }
	  }, {
	    key: "exitPhoneVerification",
	    value: function exitPhoneVerification() {
	      this.$timeout(function () {
	        $("#verify-company-user-onboarding").modal("toggle");
	      });
	    }
	  }, {
	    key: "isLetter",
	    value: function isLetter(char) {
	      var c = char.toString().toUpperCase();
	
	      return c.toUpperCase().match("[A-ZÀ-ÚÄ-Ü]+") !== null;
	    }
	  }, {
	    key: "triggerSMSCode",
	    value: function triggerSMSCode(response, user) {
	      var _this25 = this;
	
	      console.log("triggerSMSCode");
	      console.dir(response);
	      console.dir(user);
	
	      this.$timeout(function () {
	        _this25.$profile.sendSMSCode().then(function (response) {
	          _this25.$timeout(function () {
	            _this25.unSetLoader();
	            _this25.displaySMSModal();
	          });
	        }).catch(function (err) {
	          _this25.$timeout(function () {
	            _this25.unSetLoader();
	          }, 300);
	          _this25.$timeout(function () {
	            alert("There was an error sending SMS code please try again later.");
	          }, 500);
	        });
	      }, 100);
	    }
	  }, {
	    key: "displaySMSModal",
	    value: function displaySMSModal() {
	      var _this26 = this;
	
	      this.$timeout(function () {
	        _this26.numberToVerify = _this26.onboarding_data.phone_number;
	        $("#verify-company-user-onboarding").modal();
	      });
	
	      this.$timeout(function () {
	        $(".apply-profile-modal .modal-content .sms-code-container input:first").focus();
	      }, 500);
	    }
	  }, {
	    key: "codeEntered",
	    value: function codeEntered(num) {
	      var isLetter = this.isLetter(this["smsCode_" + num]);
	
	      if (isLetter === true) {
	        this["smsCode_" + num] = null;
	        return;
	      }
	
	      if (num <= 5 && this["smsCode_" + num]) {
	        var el = document.getElementById("sms-code-" + (num + 1));
	        el.focus();
	        el.select();
	      }
	
	      var code = "" + this.smsCode_1 + this.smsCode_2 + this.smsCode_3 + this.smsCode_4 + this.smsCode_5 + this.smsCode_6;
	
	      if (code.length === 6) {
	        this.validateSMSCode();
	      }
	    }
	  }, {
	    key: "smsCodeBackSpace",
	    value: function smsCodeBackSpace(event, inputSequence) {
	      if (event.keyCode === 8) {
	        if (inputSequence !== 1) {
	          var activeValue = $(".apply-profile-modal .modal-content .sms-code-container input#sms-code-" + inputSequence).val();
	          if (activeValue === "") {
	            this.$timeout(function () {
	              $(".apply-profile-modal .modal-content .sms-code-container input#sms-code-" + (inputSequence - 1)).focus();
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: "clearInputNumbers",
	    value: function clearInputNumbers() {
	      this.smsCode_1 = "";
	      this.smsCode_2 = "";
	      this.smsCode_3 = "";
	      this.smsCode_4 = "";
	      this.smsCode_5 = "";
	      this.smsCode_6 = "";
	      this.smsVerificationError = null;
	    }
	  }, {
	    key: "validateSMSCode",
	    value: function validateSMSCode() {
	      var _this27 = this;
	
	      var code = "" + this.smsCode_1 + this.smsCode_2 + this.smsCode_3 + this.smsCode_4 + this.smsCode_5 + this.smsCode_6;
	
	      this.setLoader();
	
	      this.$profile.validateSMSCode(code).then(function (response) {
	        _this27.$timeout(function () {
	          _this27.smsVerified = true;
	          _this27.submitAndSaveUser();
	          _this27.unSetLoader();
	        });
	      }).catch(function (err) {
	        _this27.$timeout(function () {
	          _this27.smsVerificationError = true;
	          _this27.smsVerificationErrorText = "Code invalid or expired";
	          _this27.unSetLoader();
	        }, 1000);
	
	        _this27.$timeout(function () {
	          alert("Verification code invalid or expired");
	        }, 2000);
	      });
	    }
	  }, {
	    key: "submitAndSaveUser",
	    value: function submitAndSaveUser() {
	      var _this28 = this;
	
	      console.log("submitAndSaveUser");
	      this.$timeout(function () {
	        $("#verify-company-user-onboarding").modal("toggle");
	      });
	
	      this.$timeout(function () {
	        _this28.setNextStep();
	      }, 300);
	
	      //this.saveUserInformation();
	
	      /*
	          const model = this.mapFields(this.ui_user_model);
	           let payload = model;
	           console.log("submitAndSaveUser");
	          console.dir(page);
	          console.dir(this.currentUser);
	          console.dir(payload);
	           if (page) {
	              let pageValid = true;
	               if (page === this.$profile.VERIFY_PHONE) {
	                  pageValid = this.isValidMultiple(VERIFY_PHONE_FIELDS);
	                  payload = this.$profile.extractFields(model, VERIFY_PHONE_FIELDS);
	                  this.clearInputNumbers();
	              }
	               if (page === this.$profile.INPUT_PHONE_NUMBER) {
	                  payload.homeContactInfo.isMobilePhoneVerified = true;
	              }
	               if (!pageValid) return;
	          }
	           this.savingProfile = true;
	           this.$profile.saveUser(payload).then((response) => {
	              if (page) this.$tracking.reportSubmitProfileStep("job board", this.$profile.STATUS_MAP[page]);
	               this.$timeout(() => {
	                  this.$auth.refreshCurrentUser().then((user) => {
	                      this.savingProfile = false;
	                      this.canUserApplyToShiftBasedJobs();
	                  });
	              }, 1000);
	          });
	           */
	    }
	  }]);
	
	  return SignupController;
	}();
	
	SignupController.$inject = ["$http", "$rootScope", "$localStorage", "$state", "$stateParams", "auth", "env", "security", "$timeout", "$httpParamSerializerJQLike", "tracking", "social", "validation", "ngProgressFactory", "signup.validator", "signup.routing", "signup.formatting", "signup.tracking", "signup.register", "signup.common", "profile", "companies", "$location"];
	
	exports.default = SignupController;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TrackingService = function () {
	  function TrackingService($http, $localStorage, $state, $q, SecurityService, AuthService, EnvService, $rootScope, $timeout, $analytics) {
	    _classCallCheck(this, TrackingService);
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$q = $q;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$env = EnvService;
	    this.$rootScope = $rootScope;
	    this.$timeout = $timeout;
	    this.PubNub = null;
	    this.unsortedChannelList = [];
	    this.nestedChannelList = [];
	    this.arrayOfImageUrlsForGallery = [];
	    this.controlChannelVal = null;
	    this.$analytics = $analytics;
	    this.gaKey = this.$auth.$env.EnvironmentConfig.gaKey;
	
	    //console.log("GA KEY:", this.gaKey);
	    window.ga("create", this.gaKey, "auto");
	  }
	
	  _createClass(TrackingService, [{
	    key: "reportUserLogin",
	    value: function reportUserLogin(user) {
	      this.reportGlobalSubmit("Localytics Logged In", {
	        email: user.email
	      });
	    }
	  }, {
	    key: "reportUserRegistration",
	    value: function reportUserRegistration(user) {
	      this.reportGlobalSubmit("Localytics Registered", {
	        firstName: user.firstName,
	        lastName: user.lastName,
	        fullName: user.firstName + " " + user.lastName,
	        emailAddress: user.email
	      });
	    }
	  }, {
	    key: "reportUserLogout",
	    value: function reportUserLogout() {
	      this.reportGlobalSubmit("Localytics Logged Out", {});
	    }
	  }, {
	    key: "reportJobCancellation",
	    value: function reportJobCancellation(job, user) {
	      this.reportGlobalSubmit("Cancel Job", {
	        "Business ID": user.company.id,
	        "Business Name": user.company.name,
	        "Number Of Accepted Applicants": job.numberOfApprovedApplications,
	        "Number Of Pending Applicants": job.numberOfPendingApplications
	      });
	    }
	  }, {
	    key: "reportApplicationAcceptance",
	    value: function reportApplicationAcceptance(job, user, acceptedApplcations) {
	      this.reportGlobalSubmit("Hire Jobbler", {
	        Email: user.email,
	        "Business ID": user.company.id,
	        "Business Name": user.company.name,
	        "Jobble ID": job.subEvents[0].deduppedJobbles[0].id,
	        "Jobble Name": job.name,
	        "Number Of Applications Accepted": acceptedApplcations.length
	      });
	    }
	  }, {
	    key: "reportJobPost",
	    value: function reportJobPost(job, jobbleTypes, user) {
	      var _this2 = this;
	
	      var _this = this;
	
	      var jobbleTypeName = _this.getJobbleTypeName(job.jobble_type, jobbleTypes);
	      var rateBucket = _this.getRateRange(job.hourly_rate);
	      var rateInCents = job.hourly_rate * 100;
	      var jobPostType = _this.getPostingType(job);
	      var daysUntil = _this.getDaysTil(job);
	      var hoursTil = _this.getHoursTil(job);
	      var visibilityType = _this.getVisibilityType(job);
	      var isVerifiedUser = _this.getVerifiedUser(user);
	
	      _this.$timeout(function () {
	        _this2.reportGlobalSubmit("Post Job", {
	          "Jobble Type": jobbleTypeName,
	          "Posting Type": jobPostType,
	          "Rate Bucket": rateBucket,
	          "Rate in Cents": rateInCents,
	          "Number Of Openings": job.openings,
	          "Number Of Questions": job.questions.length,
	          "Visibility Type": visibilityType,
	          "Number Of Shifts": job.timeIntervalsArray.length,
	          "Business ID": user.company.id,
	          "Business Name": user.company.name,
	          "Job Name": job.name,
	          "Days Until": daysUntil,
	          "Hours Until": hoursTil,
	          City: job.timeIntervalsArray[0].contactInfo.city,
	          State: job.timeIntervalsArray[0].contactInfo.state,
	          Zipcode: job.timeIntervalsArray[0].contactInfo.zipCode,
	          "Verification Reminder Display": isVerifiedUser
	        });
	      }, 2000);
	    }
	  }, {
	    key: "getVerifiedUser",
	    value: function getVerifiedUser(user) {
	      var isVerified = null;
	
	      if (user.isVerified) {
	        isVerified = "TRUE";
	      } else {
	        isVerified = "FALSE";
	      }
	
	      return isVerified;
	    }
	  }, {
	    key: "getVisibilityType",
	    value: function getVisibilityType(job) {
	      var visibility = null;
	
	      if (job.cloudsForJobblePost.length > 0 && job.postIsPrivate) {
	        visibility = "Exclusive";
	      }
	
	      if (job.cloudsForJobblePost.length > 0 && !job.postIsPrivate) {
	        visibility = "Preferred";
	      }
	
	      if (job.cloudsForJobblePost.length === 0) {
	        visibility = "Public";
	      }
	
	      return visibility;
	    }
	  }, {
	    key: "getDaysTil",
	    value: function getDaysTil(job) {
	      return moment(job.timeIntervalsArray[0].startDateAndTimeForDB).diff(moment(), "days");
	    }
	  }, {
	    key: "getHoursTil",
	    value: function getHoursTil(job) {
	      return moment(job.timeIntervalsArray[0].startDateAndTimeForDB).diff(moment(), "hours");
	    }
	  }, {
	    key: "getPostingType",
	    value: function getPostingType(job) {
	      var type = null;
	
	      if (job.typeOfJobPosting === "source") {
	        type = "Connect";
	      } else {
	        type = "On-Demand";
	      }
	
	      return type;
	    }
	  }, {
	    key: "getJobbleTypeName",
	    value: function getJobbleTypeName(id, jobbleTypes) {
	      for (var i = 0; i < jobbleTypes.length; i++) {
	        if (jobbleTypes[i].id === id) {
	          return jobbleTypes[i].name;
	        }
	      }
	    }
	  }, {
	    key: "getRateRange",
	    value: function getRateRange(rate) {
	      switch (Math.floor(rate)) {
	        case 0:
	        case 1:
	        case 2:
	          return "$0-$2";
	        case 3:
	        case 4:
	        case 5:
	          return "$3-$5";
	        case 6:
	        case 7:
	        case 8:
	          return "$6-$8";
	        case 9:
	        case 10:
	        case 11:
	          return "$9-$11";
	        case 12:
	        case 13:
	        case 14:
	          return "$12-$14";
	        case 15:
	        case 16:
	        case 17:
	          return "$15-$17";
	        case 18:
	        case 19:
	        case 20:
	          return "$18-$20";
	        case 21:
	        case 22:
	        case 23:
	          return "$21-$23";
	        case 24:
	        case 25:
	        case 26:
	          return "$24-$26";
	        case 27:
	        case 28:
	        case 29:
	          return "$27-$29";
	        case 30:
	        case 31:
	        case 32:
	          return "$30-$32";
	        case 33:
	        case 34:
	        case 35:
	          return "$33-$35";
	        case 36:
	        case 37:
	        case 38:
	          return "$36-$38";
	        case 39:
	        case 40:
	        case 41:
	          return "$39-$41";
	
	        default:
	          return "Over $41";
	      }
	    }
	  }, {
	    key: "reportPostJobClick",
	    value: function reportPostJobClick() {
	      this.reportGlobalClick("Post Job Button From Sign In", {});
	    }
	  }, {
	    key: "reportMarketingRegistration",
	    value: function reportMarketingRegistration(user) {
	      this.reportGlobalSubmit("Marketing Registration", {
	        Email: user.email
	      });
	    }
	  }, {
	    key: "reportMarketingSignIn",
	    value: function reportMarketingSignIn(user) {
	      this.reportGlobalSubmit("Marketing Logged In", {
	        Email: user.email
	      });
	    }
	  }, {
	    key: "reportLazyRegDuringPost",
	    value: function reportLazyRegDuringPost(user) {
	      this.reportGlobalSubmit("Lazy Registration", {
	        Email: user.email
	      });
	    }
	  }, {
	    key: "reportLazySignInDuringPost",
	    value: function reportLazySignInDuringPost(user) {
	      this.reportGlobalSubmit("Lazy Logged In", {
	        Email: user.email
	      });
	    }
	  }, {
	    key: "reportOboardingScreenOne",
	    value: function reportOboardingScreenOne(step) {
	      if (step === 1) {
	        this.reportGlobalClick("Onboarding 1 Skip", {});
	      } else {
	        this.reportGlobalClick("Onboarding 1 Next Button", {});
	      }
	    }
	  }, {
	    key: "reportOboardingScreenTwo",
	    value: function reportOboardingScreenTwo(step) {
	      if (step === 1) {
	        this.reportGlobalClick("Onboarding 2 Skip", {});
	      } else {
	        this.reportGlobalClick("Onboarding 2 Next Button", {});
	      }
	    }
	  }, {
	    key: "reportJobTypeSelectionOnDemand",
	    value: function reportJobTypeSelectionOnDemand() {
	      this.reportGlobalClick("On Demand Job Selection", {});
	    }
	  }, {
	    key: "reportJobTypeSelectionSourcing",
	    value: function reportJobTypeSelectionSourcing() {
	      this.reportGlobalClick("Connect Job Selection", {});
	    }
	  }, {
	    key: "reportJobBoardLoad",
	    value: function reportJobBoardLoad(data) {
	      this.reportGlobalSubmit("Jobbler Web Board", {
	        Username: data.username,
	        Zipcode: data.zipcode,
	        "Place ID": data.placeRef
	      });
	    }
	  }, {
	    key: "reportViewJobFromJobBoard",
	    value: function reportViewJobFromJobBoard(data) {
	      this.reportGlobalView("View Job From Web Board", {
	        Username: data.username
	      });
	    }
	  }, {
	    key: "reportApplyToJobFromBoard",
	    value: function reportApplyToJobFromBoard(data) {
	      this.reportGlobalSubmit("Apply From Web Board", {
	        Username: data.username
	      });
	    }
	  }, {
	    key: "reportHeaderClicks",
	    value: function reportHeaderClicks(data) {
	      this.reportGlobalClick("Job Web Board Header Clicks", {
	        Username: data.username,
	        Button: data.button
	      });
	    }
	  }, {
	    key: "reportNoShows",
	    value: function reportNoShows(applications, event) {
	      var _this = this;
	      var company_name = event.company.name;
	      var company_id = event.company.id;
	      var event_id = event.id;
	      var jobble_type = event.subEvents[0].deduppedJobbles[0].jobbleType.name;
	      var state = event.contactInfo.state;
	      var city = event.contactInfo.city;
	      var zip_code = event.contactInfo.zipCode;
	      var pay_per_hour = applications[0].jobble.payPerHour;
	      var no_show_count = 0;
	      var no_show_count_male = 0;
	      var no_show_count_female = 0;
	      var no_show_count_other = 0;
	      var no_show_no_pay_info = 0;
	      var left_note_count = 0;
	      var total_hires_count = applications.length;
	      try {
	        applications.forEach(function (application) {
	          if (application.jobble.noShow === true) {
	            no_show_count = no_show_count + 1;
	            if (application.applicant.gender === "Male") {
	              no_show_count_male = no_show_count_male + 1;
	            } else if (application.applicant.gender === "Female") {
	              no_show_count_female = no_show_count_female + 1;
	            } else {
	              no_show_count_other = no_show_count_other + 1;
	            }
	            if (application.noteCount > 0) {
	              left_note_count = left_note_count + 1;
	            }
	            if (application.applicant.undeletedPaymentInfos.length === 0) {
	              no_show_no_pay_info = no_show_no_pay_info + 1;
	            }
	          }
	        });
	      } finally {
	        this.reportGlobalSubmit("No Shows On Job Closure", {
	          "Business Name": company_name,
	          "Business ID": company_id,
	          "Event ID": event_id,
	          City: city,
	          State: state,
	          Zipcode: zip_code,
	          "Job Type": jobble_type,
	          "Pay Per Hour": pay_per_hour,
	          "Total Hires": total_hires_count,
	          "No Shows": no_show_count,
	          "No Shows Male": no_show_count_male,
	          "No Shows Female": no_show_count_female,
	          "No Shows Other": no_show_count_other,
	          "No Show Left Note": left_note_count,
	          "No Show No Pay Info": no_show_no_pay_info
	        });
	      }
	    }
	  }, {
	    key: "reportJobbleBoardFailedJson",
	    value: function reportJobbleBoardFailedJson(data) {
	      this.reportGlobalSubmit("Jobble Boad Failure", {
	        Zipcode: data.zipcode,
	        Radius: data.geoFenceRadius,
	        Offset: data.offset
	      });
	    }
	  }, {
	    key: "handleShiftData",
	    value: function handleShiftData(application, shift) {
	      var _this = this;
	      var data = {};
	      data.jobbleId = application.jobble.id;
	      data.username = application.applicant.username;
	      data.shiftId = shift.id;
	      data.street = shift.contactInfo.streetLine1;
	      data.city = shift.contactInfo.city;
	      data.state = shift.contactInfo.state;
	      data.zipCode = shift.contactInfo.zipCode;
	      data.shiftStartTime = moment(shift.timeInterval.startTime).format("ddd MMM DD YYYY hh:mm:ss A");
	      data.autoCheckinCoords = shift.autoCheckInCoord.lat ? "lat: " + shift.autoCheckInCoord.lat + ", lng: " + shift.autoCheckInCoord.lng : null;
	      data.autoCheckinTimestamp = shift.autoCheckOutCoord.dateCreated ? moment(shift.autoCheckOutCoord.dateCreated).format("ddd MMM DD YYYY hh:mm:ss A") : null;
	      data.autoCheckoutCoords = shift.autoCheckOutCoord.lat ? "lat: " + shift.autoCheckOutCoord.lat + ", lng: " + shift.autoCheckOutCoord.lng : null;
	      data.autoCheckoutTimestamp = shift.autoCheckOutCoord.dateCreated ? moment(shift.autoCheckOutCoord.dateCreated).format("ddd MMM DD YYYY hh:mm:ss A") : null;
	      data.manualCheckinCoords = shift.checkInCoord.lat ? "lat: " + shift.checkInCoord.lat + ", lng: " + shift.checkInCoord.lng : null;
	      data.manualCheckinTimestamp = shift.checkInTime ? moment(shift.checkInTime).format("ddd MMM DD YYYY hh:mm:ss A") : null;
	      data.manualCheckoutCoords = shift.checkOutCoord.lat ? "lat: " + shift.checkOutCoord.lat + ", lng: " + shift.checkOutCoord.lng : null;
	      data.manualCheckoutTimestamp = shift.checkOutTime ? moment(shift.checkOutTime).format("ddd MMM DD YYYY hh:mm:ss A") : null;
	      if (shift.checkInTime) {
	        data.checkinDelta = _this.diffTimes(shift.timeInterval.startTime, shift.checkInTime);
	      } else {
	        data.checkinDelta = null;
	      }
	      if (shift.checkOutTime) {
	        data.checkoutDelta = _this.diffTimes(shift.timeInterval.startTime, shift.checkOutTime);
	      } else {
	        data.checkoutDelta = null;
	      }
	      _this.reportShiftData(data);
	    }
	  }, {
	    key: "reportShiftData",
	    value: function reportShiftData(data) {
	      this.reportGlobalSubmit("Shift Information", {
	        "Jobble Id": data.jobbleId,
	        Username: data.username,
	        "Shift Id": data.shiftId,
	        Street: data.street,
	        City: data.city,
	        State: data.state,
	        "Zip Code": data.zipCode,
	        "Shift Start Time": data.shiftStartTime,
	        "Checkin Delta": data.checkinDelta,
	        "Checkout Delta": data.checkoutDelta,
	        "Auto Checkin Coords": data.autoCheckinCoords,
	        "Auto Checkout Coords": data.autoCheckoutCoords,
	        "Manual Checkin Coords": data.manualCheckinCoords,
	        "Manual Checkout Coords": data.manualCheckoutCoords,
	        "Auto Checkin Timestamp": data.autoCheckinTimestamp,
	        "Auto Checkout Timestamp": data.autoCheckoutTimestamp,
	        "Manual Checkin Timestamp": data.manualCheckinTimestamp,
	        "Manual Checkout Timestamp": data.manualCheckoutTimestamp
	      });
	    }
	  }, {
	    key: "diffTimes",
	    value: function diffTimes(time1, time2) {
	      var timeDiff = null;
	      var diffText = "";
	      timeDiff = moment(time1).diff(moment(time2), "minutes");
	      if (moment(time2).isAfter(moment(time1))) {
	        diffText = timeDiff + " minutes late ";
	      } else {
	        diffText = timeDiff + " minutes early ";
	      }
	      return diffText;
	    }
	  }, {
	    key: "reportJobblerSignUp",
	    value: function reportJobblerSignUp(data) {
	      this.reportGlobalSubmit("sign up - submit - new jobbler sign up", {
	        Username: data.username,
	        Email: data.email
	      });
	    }
	  }, {
	    key: "reportJobblerSignUpModal",
	    value: function reportJobblerSignUpModal(data) {
	      this.reportGlobalSubmit("Jobbler Sign Up Modal", {
	        Username: data.username,
	        Email: data.email
	      });
	    }
	  }, {
	    key: "reportJobblerSignUpThirdParty",
	    value: function reportJobblerSignUpThirdParty(data) {
	      this.reportGlobalSubmit("Jobbler Sign Up Third Party Standard", {
	        Username: data.username,
	        Email: data.email,
	        Type: data.type
	      });
	    }
	  }, {
	    key: "reportJobblerSignUpThirdPartyOnboarding",
	    value: function reportJobblerSignUpThirdPartyOnboarding(data) {
	      this.reportGlobalSubmit("Jobbler Sign Up Third Party Onboarding", {
	        Username: data.username,
	        Email: data.email,
	        Type: data.type
	      });
	    }
	  }, {
	    key: "reportJobsBoardNavBarFilterClick",
	    value: function reportJobsBoardNavBarFilterClick(data) {
	      this.reportGlobalClick("Job Board Nav Filter", {
	        JobbleType: data.secondary_name
	      });
	    }
	  }, {
	    key: "reportJobPayOut",
	    value: function reportJobPayOut(data) {
	      this.reportGlobalSubmit("Job Pay Outs", {
	        Email: data.user,
	        "Business ID": data.companyId,
	        "Business Name": data.companyName,
	        "Jobble Inc User": data.isJobbleAdmin,
	        "Fill Rate Percentage After No Shows": data.fillRatePercentageAfterNoShows,
	        "Fill Rate Percentage Before No Shows": data.fillRatePercentageBeforeNoShows,
	        "Hired Jobblers": data.hiredJobblersCount,
	        "Jobble Type": data.jobbleTypeName,
	        "Number Of No Shows": data.noShowCount,
	        "Remaining Openings": data.openingsLeft,
	        "Rate In Cents": data.payPerHourInCents,
	        "Potential GMV": data.potentialGMV,
	        "Actual GMV": data.totalMoney,
	        "Number Of Jobblers Removed From Payment": data.removedFromPaymentCount,
	        "Lost GMV": data.revenueLostRounded,
	        "Total Number Of Openings": data.totalNumberOfOpenings
	      });
	    }
	  }, {
	    key: "reportMobileApplication",
	    value: function reportMobileApplication(data) {
	      this.reportGlobalSubmit("Device Info on Apply", {
	        Email: data.email,
	        Device: data.mobile_device_type,
	        "User Agent": data.user_agent
	      });
	    }
	  }, {
	    key: "reportMobileRegisterFromModal",
	    value: function reportMobileRegisterFromModal(data) {
	      this.reportGlobalSubmit("Device Info on Register Modal", {
	        Email: data.email,
	        Device: data.mobile_device_type,
	        "User Agent": data.user_agent
	      });
	    }
	  }, {
	    key: "reportMobileSigninFromModal",
	    value: function reportMobileSigninFromModal(data) {
	      this.reportGlobalSubmit("Device Info on Signin Modal", {
	        Email: data.email,
	        Device: data.mobile_device_type,
	        "User Agent": data.user_agent
	      });
	    }
	  }, {
	    key: "reportHeaderMenuInteraction",
	    value: function reportHeaderMenuInteraction(data) {
	      this.reportGlobalClick("Drop Down Menu Interaction", {
	        Email: data.user,
	        Button: data.button
	      });
	    }
	  }, {
	    key: "reportJobSearch",
	    value: function reportJobSearch(data) {
	      this.reportGlobalSubmit("Job Search", {
	        Email: data.user,
	        "Search Type": data.type,
	        "Page Searched From": data.page
	      });
	    }
	  }, {
	    key: "reportQuickRegister",
	    value: function reportQuickRegister(data) {
	      this.reportGlobalSubmit("Quick Register", {
	        Email: data.email,
	        Phone: data.phone,
	        Name: data.first_name + " " + data.last_name,
	        Origin: data.ad_origin
	      });
	    }
	  }, {
	    key: "reportGlobalView",
	    value: function reportGlobalView(eventName, data) {
	      eventName = "web app - " + eventName;
	
	      data = data || {};
	
	      this.currentUser = this.$auth.getUserData();
	
	      if (this.currentUser) {
	        data["Email"] = this.currentUser.username;
	      }
	
	      console.log("track:", eventName);
	
	      try {
	        this.$analytics.eventTrack(eventName, { action: "view" });
	      } catch (e) {
	        console.error("Error tracking:", e);
	      }
	    }
	  }, {
	    key: "reportGlobalSubmit",
	    value: function reportGlobalSubmit(eventName, data) {
	      eventName = "web app - " + eventName;
	
	      data = data || {};
	
	      this.currentUser = this.$auth.getUserData();
	
	      if (this.currentUser) {
	        data["Email"] = this.currentUser.username;
	      }
	
	      console.log("track:", eventName);
	
	      try {
	        this.$analytics.eventTrack(eventName, { action: "submit" });
	      } catch (e) {
	        console.error("Error tracking:", e);
	      }
	    }
	  }, {
	    key: "reportGlobalClick",
	    value: function reportGlobalClick(eventName, data) {
	      eventName = "web app - " + eventName;
	
	      data = data || {};
	
	      this.currentUser = this.$auth.getUserData();
	
	      if (this.currentUser) {
	        data["Email"] = this.currentUser.username;
	      }
	
	      console.log("track:", eventName);
	
	      try {
	        this.$analytics.eventTrack(eventName, { action: "click" });
	      } catch (e) {
	        console.error("Error tracking:", e);
	      }
	    }
	  }, {
	    key: "reportClickCategoryFilter",
	    value: function reportClickCategoryFilter(page, filter) {
	      var eventName = page + " - click - category filter";
	      this.reportGlobalClick(eventName, {
	        Filter: filter
	      });
	    }
	  }, {
	    key: "reportClickCompanyFilter",
	    value: function reportClickCompanyFilter(page, filter) {
	      var eventName = page + " - click - company filter";
	      this.reportGlobalClick(eventName, {
	        Filter: filter
	      });
	    }
	  }, {
	    key: "reportClickLocationFilter",
	    value: function reportClickLocationFilter(page, filter) {
	      var eventName = page + " - click - location filter";
	      this.reportGlobalClick(eventName, {
	        Filter: filter
	      });
	    }
	  }, {
	    key: "reportClickCovidBanner",
	    value: function reportClickCovidBanner(page) {
	      var eventName = page + " - click - covid banner";
	      this.reportGlobalClick(eventName, {});
	    }
	  }, {
	    key: "reportClickJobSort",
	    value: function reportClickJobSort(page, sort) {
	      var eventName = page + " - click - sort";
	
	      if (sort === "payPerHour") {
	        sort = "Pay (high to low)";
	      } else if (sort === "startTime") {
	        sort = "Job Date";
	      } else if (sort === "dateCreated") {
	        sort = "Date Posted";
	      } else {
	        sort = "Relevance";
	      }
	
	      this.reportGlobalClick(eventName, {
	        Sort: sort ? sort.toLowerCase() : sort
	      });
	    }
	  }, {
	    key: "reportSubmitSearch",
	    value: function reportSubmitSearch(page, query, zipcode) {
	      var eventName = page + " - submit - search query";
	      this.reportGlobalSubmit(eventName, {
	        Query: query,
	        "Zip Code": zipcode
	      });
	    }
	  }, {
	    key: "reportViewJob",
	    value: function reportViewJob(page, job) {
	      if (!job) return;
	
	      var zipCode = null;
	
	      if (job.isPartnerPost === true) {
	        zipCode = job.partnerPostContent.zip;
	      } else {
	        if (job.contactInfo) {
	          zipCode = job.contactInfo.zipCode;
	        } else {
	          zipCode = job.subEvent.contactInfo.zipCode;
	        }
	      }
	
	      var eventName = page + " - view - job";
	      this.reportGlobalView(eventName, {
	        "Jobble Id": job.id,
	        "Zip Code": zipCode,
	        "Job Category": job.jobbleType.name,
	        "Job Title": job.eventName ? job.eventName : job.name ? job.name : "N/A",
	        "Job Type": job.is_partner_post ? "Partner Job" : "Platform Job"
	      });
	    }
	  }, {
	    key: "reportSubmitEmailAlert",
	    value: function reportSubmitEmailAlert(page, email, job) {
	      if (!job) return;
	
	      var eventName = page + " - submit - job alert sign up";
	      this.reportGlobalSubmit(eventName, {
	        Email: email,
	        "Jobble Id": job.id,
	        "Job Category": job.jobbleType.name,
	        "Zip Code": job.subEvent.contactInfo.zipCode,
	        "Job Title": job.eventName ? job.eventName : job.subEvent.event.name ? job.subEvent.event.name : "N/A",
	        "Job Type": job.is_partner_post ? "Partner Job" : "Platform Job"
	      });
	    }
	  }, {
	    key: "reportSubmitRegistration",
	    value: function reportSubmitRegistration(page, email) {
	      if (!email) return;
	
	      var eventName = page + " - submit - sign up";
	      this.reportGlobalSubmit(eventName, {
	        Email: email
	      });
	    }
	  }, {
	    key: "reportMobileLinkSent",
	    value: function reportMobileLinkSent(page, email) {
	      if (!email) return;
	
	      var eventName = page + " - submit - mobile link sent";
	      this.reportGlobalSubmit(eventName, {
	        Email: email
	      });
	    }
	  }, {
	    key: "reportMobileDownload",
	    value: function reportMobileDownload(page, email, type) {
	      if (!email) return;
	
	      var eventName = page + " - submit - mobile download - " + type;
	      this.reportGlobalSubmit(eventName, {
	        Email: email
	      });
	    }
	  }, {
	    key: "reportSMSVerified",
	    value: function reportSMSVerified(page, email) {
	      if (!email) return;
	
	      var eventName = page + " - submit - sms verified";
	      this.reportGlobalSubmit(eventName, {
	        Email: email
	      });
	    }
	  }, {
	    key: "reportSubmitApplication",
	    value: function reportSubmitApplication(page, job) {
	      if (!job) return;
	
	      console.log("reportSubmitApplication");
	      console.dir(job);
	      console.dir(page);
	      var zipCode = null;
	      var jobName = null;
	
	      if (job.title) {
	        jobName = job.title;
	      } else if (job.eventName) {
	        jobName = job.eventName;
	      } else {
	        jobName = job.subEvent.event.name;
	      }
	
	      if (job.contactInfo) {
	        zipCode = job.contactInfo.zipCode;
	      } else {
	        zipCode = job.subEvent.contactInfo.zipCode;
	      }
	
	      var eventName = page + " - submit - job application";
	      this.reportGlobalSubmit(eventName, {
	        "Jobble Id": job.id,
	        "Job Category": job.jobbleType.name,
	        "Zip Code": zipCode,
	        "Job Title": jobName,
	        "Job Type": job.is_partner_post ? "Partner Job" : "Platform Job"
	      });
	    }
	  }, {
	    key: "reportSubmitProfileStep",
	    value: function reportSubmitProfileStep(page, step) {
	      if (!step) return;
	
	      var eventName = page + " - submit - profile step - " + step;
	      this.reportGlobalSubmit(eventName, {});
	    }
	  }, {
	    key: "reportPostAJobSubmitStep",
	    value: function reportPostAJobSubmitStep(step) {
	      if (!step) return;
	
	      var eventName = "post a job - submit - " + step;
	      this.reportGlobalSubmit(eventName, {});
	    }
	  }, {
	    key: "reportPostAJobClick",
	    value: function reportPostAJobClick(name) {
	      if (!name) return;
	
	      var eventName = "post a job - click - " + name;
	      this.reportGlobalClick(eventName, {});
	    }
	  }, {
	    key: "reportRosterPageClick",
	    value: function reportRosterPageClick(name) {
	      if (!name) return;
	
	      var eventName = "roster page - click - " + name;
	      this.reportGlobalClick(eventName, {});
	    }
	  }, {
	    key: "reportRosterPageSubmit",
	    value: function reportRosterPageSubmit(name) {
	      if (!name) return;
	
	      var eventName = "roster page - submit - " + name;
	      this.reportGlobalSubmit(eventName, {});
	    }
	  }, {
	    key: "reportRosterPageView",
	    value: function reportRosterPageView(name) {
	      if (!name) return;
	
	      var eventName = "roster page - view - " + name;
	      this.reportGlobalView(eventName, {});
	    }
	  }]);
	
	  return TrackingService;
	}();
	
	exports.default = TrackingService;
	
	
	TrackingService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "env", "$rootScope", "$timeout", "$analytics"];

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(292);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./common.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./common.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".login-area{background:url(/app/vendor/images/login-bg2.png) no-repeat 0 0;background-size:cover;min-height:916px}.login-wrap{max-width:785px;margin:0 auto;padding:75px 0 0}.login-wrap h2{color:#fff;text-transform:uppercase;font-size:22px;font-weight:700;line-height:normal;margin:0 0 33px;text-align:center}.login-container{background-color:#fff}.login-container form{margin:0}.login-content{max-width:384px;margin:0 auto 9px;padding:75px 0 85px}.login-content label{display:block;color:#3b3f43;margin:0 0 8px;font-size:15px;font-weight:300}.login-content input[type=email],.login-content input[type=password],.login-content input[type=text]{display:block;border:1px solid #c3cdd1;background:#fff;width:100%;padding:10px 10px 10px 35px;margin:0 0 15px;appearance:none;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;caret-color:#494949}.login-content input[type=email]:focus,.login-content input[type=password]:focus,.login-content input[type=text]:focus{outline:0}.input-submit{overflow:hidden;margin:40px 0 0}.login-content a.f-pass{color:#2c3a40;font-size:14px;font-weight:300;display:block}.login-content input[type=submit]{width:190px;display:block;font-weight:700;appearance:none;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none}.signup-area{border:1px solid #fff;padding:19px 22px;overflow:hidden;margin:0 0 40px}.signup-area span{color:#fff;font-size:16px;font-weight:300;line-height:40px}.signup-area .btn.btn-default{font-weight:700;width:190px}.login-meta{text-align:center;color:#fff;font-size:14px;font-weight:300}.login-meta a{color:#fff}.input-bg{position:relative}.input-bg:before{font-family:FontAwesome;font-size:17px;left:14px;position:absolute;top:10px;color:#3b3f43}.input-bg.name:before{content:\"\\F007\"}.input-bg.password:before{content:\"\\F023\"}.input-bg.mail:before{content:\"\\F0E0\";left:12px}.input-bg.company:before{content:\"\\F0F7\";left:12px}.input-bg.phone:before{content:\"\\F095\";left:12px}.input-submit.signup{margin:20px 0 0}.input-submit.signup input[type=submit]{width:100%}.header-top{padding:10px 20px;background-color:#fff}.top-right{margin:5px 0}.btn-default.active,.btn-default:focus,.btn-default:hover{background-color:#5e666d;color:#fff;border-color:#5e666d}.btn.btn-inverse:hover,.button.hollow:focus{border-color:#5e666d;color:#5e666d}.btn-default{background-color:#74cf59;color:#fff;border-color:#74cf59}.btn{padding:9px 20px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;border-radius:2px;transition:all .25s ease-in-out}.btn.btn-inverse{border:1px solid #b7c0c5;color:#5e666d;font-size:14px}.top-menu{float:right;margin:10px 30px 6px 0}.top-menu ul{padding:0;margin:0;list-style:none}.top-menu li{display:block;float:left;margin:0 12px}.top-menu li a{display:inline-block;color:#5e666d;font-size:17px;font-weight:300;padding-bottom:3px;border-bottom:2px solid transparent}.top-menu li.active a,.top-menu li a:hover{border-bottom-color:#74cf59}.top-menu li.active a{font-weight:700}.navbar-toggle .icon-bar{background-color:#74cf59}.header-login-btn{margin-top:7px}.header-login-btn a{width:105px;margin-left:6px;font-weight:700}@media (max-width:991px){.top-menu{margin-right:15px}.top-menu li a{font-size:14px}.header-login-btn a{padding:9px;width:auto}.top-menu{margin-right:0}}.btn{margin-top:10px;padding:13px 20px}.sign-up-page .modal-dialog .terms-and-service.sms-policy-signing{text-align:left;font-size:12px}.sign-up-page .modal-content input[type=checkbox]{display:inline;height:auto;width:auto;margin-right:5px}.signup-center{text-align:center}@media (max-width:767px){.navbar-toggle{margin-right:0}.header-top{z-index:130;position:relative}.top-menu{background:#f8fcff;left:0;margin:0;position:absolute;top:100%;width:100%;padding:15px 10px 0;border-top:1px solid #eee;display:none}.top-menu,.top-menu li{float:none}.top-menu li a{display:block;margin-bottom:5px}.navbar-toggle{position:absolute;top:0;right:5px}.header-login-btn{margin-left:20px;margin-right:40px}.header-login-btn a{width:90px}}@media (max-width:406px){.header-login-btn{margin:0}.header-login-btn a{margin-top:20px;width:130px}}@media only screen and (max-width:1024px){.login-wrap{max-width:700px}}@media only screen and (max-width:979px){.login-wrap{max-width:600px}}@media only screen and (max-width:767px){.login-area{padding:0 20px}.login-wrap{max-width:none}.login-content{padding:60px;max-width:none}}@media only screen and (max-width:639px){.input-submit{margin:25px 0 0}.login-content a.f-pass{float:none!important;margin:0 0 20px;text-align:center}.login-content a.f-pass br{display:none}.login-content input[type=submit]{margin:0 auto;display:block;float:none!important}}@media only screen and (max-width:479px){.login-content{padding:25px}.signup-area span{display:block;font-size:14px;line-height:normal;margin:0 0 20px;text-align:center}.signup-area .btn.btn-default{display:block;float:none!important;margin:0 auto}}.error-invalid-mail{color:red}.error-invalid-mail,.signUp-strength-pass{float:right}.weak-password-strength{color:red}.good-password-strength{color:orange}.strong-password-strength{color:#6495ed}.veryStrong-password-strength{color:#32cd32}.password-info-strength{color:#a9a9a9}.sign-up-page .modal-dialog{width:324px;margin:125px auto auto;box-shadow:0 2px 4px 0 rgba(0,0,0,.2)}.sign-up-page.company-sign-up{padding-bottom:100px}.company-sign-up input .disabled,.company-sign-up input[disabled]{opacity:.5;cursor:not-allowed}.sign-up-page.company-sign-up .modal-dialog{max-width:456px;width:90%;margin-top:32px}@media only screen and (max-width:768px){.sign-up-page .modal-dialog{margin-top:50px}}.sign-up-page .modal-gradient-banner{height:6px;width:100%;border-radius:6px 6px 0 0;background:linear-gradient(116.57deg,#62c046,#5498b4)}.sign-up-page .modal-content{border-radius:0 0 6px 6px;border:1px solid #fff;border-top:none;padding:24px;box-shadow:none}.sign-up-page .modal-content h3{margin:0;font-family:Poppins,sans-serif;font-size:18px;font-weight:700;line-height:20px}.sign-up-page .modal-content p{margin:8px 0 0}.sign-up-page .modal-content label,.sign-up-page .modal-content p{color:#33373a;font-family:Poppins,sans-serif;font-size:14px;line-height:21px}.sign-up-page .modal-content label{font-weight:400;margin-top:16px}.sign-up-page .input-container{position:relative}.sign-up-page .input-container i{position:absolute;left:16px;top:12px;font-size:16px;color:#adbcc2}.sign-up-page .modal-content input,.sign-up-page .modal-content select{box-shadow:0 2px 4px 0 rgba(0,0,0,.1);height:40px;display:block;width:100%;border:1px solid #767676;border-radius:2px;background-color:#fff;padding:0 16px}.sign-up-page .input-container input{padding-left:42px;margin-top:16px;border:1px solid #adbcc2;box-shadow:none}.company-sign-up .input-container input{margin-top:8px}.company-sign-up .input-sub-label{font-size:12px;line-height:14px;color:#a9a9a9}.company-sign-up .input-label{margin-top:8px;font-family:Poppins;font-weight:800;line-height:20px}.sign-up-page .input-container input:focus,.sign-up-page .modal-content input:focus{border:2px solid #adbcc2}.sign-up-page ::-webkit-input-placeholder{color:#adbcc2;opacity:1}.sign-up-page :-moz-placeholder,.sign-up-page ::-moz-placeholder{color:#adbcc2;opacity:1}.sign-up-page :-ms-input-placeholder,.sign-up-page ::-ms-input-placeholder{color:#adbcc2;opacity:1}.sign-up-page :placeholder-shown{color:#adbcc2;opacity:1}.sign-up-page .modal-content .continue-button.sign-in-page-button{color:#fff;font-family:Poppins,sans-serif;font-size:14px;font-weight:700;line-height:40px;height:40px;width:100%;border-radius:6px;background:linear-gradient(270deg,#74cf59,#5498b4);text-align:center;margin-top:16px;cursor:pointer}.sign-up-page .modal-content .continue-button.sign-in-page-button.sign-in-button-disabled{opacity:.5}.sign-up-page .modal-content .continue-button.sign-in-page-button:hover{background:#74cf59;box-shadow:inset 0 30px 60px -12px rgba(50,50,93,.25),inset 0 18px 36px -18px rgba(0,0,0,.3)}.sign-up-page .modal-content .continue-button.sign-in-page-button.sign-in-button-disabled:hover{background:linear-gradient(270deg,#74cf59,#5498b4);box-shadow:none;cursor:default}.sign-up-page .modal-content .continue-button{color:#fff;font-family:Poppins,sans-serif;font-size:14px;font-weight:700;line-height:40px;height:40px;width:100%;border-radius:6px;background-color:#62c046;text-align:center;margin-top:16px;cursor:pointer}.sign-up-page .modal-dialog .terms-and-service{border-top:1px solid #adbcc2;margin-top:16px;padding-top:16px}.sign-up-page .modal-dialog .forgot-password-text,.sign-up-page .modal-dialog .login-text{margin-top:16px}.sign-up-page .modal-dialog .sign-up-text{padding-top:16px;margin-top:16px;border-top:1px solid #adbcc2}.sign-up-page .modal-dialog .forgot-password-text,.sign-up-page .modal-dialog .login-text,.sign-up-page .modal-dialog .sign-up-text,.sign-up-page .modal-dialog .terms-and-service{font-family:Poppins,sans-serif;font-size:12px;font-weight:600;line-height:18px;text-align:center}.sign-up-page .modal-dialog .forgot-password-text,.sign-up-page .modal-dialog .login-text span,.sign-up-page .modal-dialog .sign-up-text span,.sign-up-page .modal-dialog .terms-and-service a{color:#62c046;cursor:pointer}.sign-up-page .error-text,.sign-up-page .input-error-text{color:#d8000c;font-family:Poppins,sans-serif;margin-top:16px;font-size:11px;letter-spacing:0;line-height:14px}.sign-up-page .input-error-text{margin-top:8px}.no-border{border:0!important;outline:0!important}", ""]);
	
	// exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _companySignup = __webpack_require__(294);
	
	var _companySignup2 = _interopRequireDefault(_companySignup);
	
	var _signup = __webpack_require__(289);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	__webpack_require__(291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var companySignupComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _companySignup2.default,
	  controller: _signup2.default,
	  controllerAs: "vm"
	};
	
	exports.default = companySignupComponent;

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<div class=\"sign-up-page company-sign-up\">\n  <div class=\"modal-dialog modal-m regi-form-board sign-in\">\n    <div class=\"modal-gradient-banner\"></div>\n    <div class=\"modal-content\" style=\"padding-top: 10px\">\n      <div class=\"modal-content-container\">\n        <div \n          class=\"step-header\" \n          ng-if=\"vm.userInvited\" \n          ng-show=\"!vm.onboarding_data.userInvited\">\n            STEP 1 of {{vm.userInvited ? \"2\" : \"3\"}}\n        </div>\n        <div style=\"text-align: center\">\n          <h3>Create an account</h3>\n        </div>\n        <div>\n          <div class=\"sms-wrapper\">\n            <div class=\"input-label\">Company Name</div>\n            <div class=\"input-sub-label\">\n              The company name must be unique. To sign up for an existing company, you must be sent an invite from the account owner.\n            </div>\n\n            <div class=\"input-container\">\n              <i class=\"far fa-building\"></i>\n              <input\n                type=\"text\"\n                placeholder=\"Company Name\"\n                name=\"company name\"\n                ng-model=\"vm.company_name\"\n                ng-change=\"vm.validator.companyName(vm.company_name, vm)\"\n                ng-style=\"vm.validation.company_name.style\"\n                ng-keyup=\"vm.submitOnEnterCompany($event)\"\n                ng-disabled=\"vm.userInvited\"\n                ng-class=\"{ 'no-border' : vm.userInvited }\"\n                required\n                id=\"first-sms-box\"\n                autofocus\n              />\n            </div>\n            <div class=\"error-text\" ng-show=\"vm.validation.company_name.message\">\n              <i class=\"fas fa-exclamation-circle\"></i>\n              {{vm.validation.company_name.message}}\n            </div>\n\n            <div class=\"input-label\">Company Phone Number</div>\n            <div class=\"input-sub-label\">Please enter a valid 10-digit number for the company</div>\n\n            <div class=\"input-container\" ng-show=\"!(vm.userInvited && !vm.display_phone_number)\">\n              <i class=\"fas fa-phone\"></i>\n              <input\n                type=\"text\"\n                placeholder=\"Number\"\n                name=\"phone no\"\n                ng-model=\"vm.display_phone_number\"\n                ng-style=\"vm.validation.phone.style\"\n                cleave=\"vm.phoneFormatting\"\n                ng-keyup=\"vm.submitOnEnterCompany($event)\"\n                ng-disabled=\"vm.userInvited\"\n                ng-class=\"{ 'no-border' : vm.userInvited }\"\n                required\n                autofocus\n              />\n            </div>\n            <div class=\"error-text\" ng-show=\"vm.validation.phone.message\">\n              <i class=\"fas fa-exclamation-circle\"></i>\n              {{vm.validation.phone.message}}\n            </div>\n\n            <div class=\"input-label\">Email</div>\n            <div class=\"input-sub-label\">Please use a unique email from your company domain</div>\n\n            <div class=\"input-container\">\n              <i class=\"far fa-envelope\"></i>\n              <input\n                type=\"email\"\n                placeholder=\"Email\"\n                name=\"email\"\n                ng-model=\"vm.email\"\n                ng-change=\"vm.validator.email(vm.email, vm)\"\n                ng-style=\"vm.validation.email.style\"\n                ng-keyup=\"vm.submitOnEnterCompany($event)\"\n                ng-disabled=\"vm.userInvited || vm.already_registered\"\n                ng-class=\"{ 'no-border' : vm.userInvited, 'disabled' : vm.already_registered }\"\n                required\n                autofocus\n              />\n            </div>\n            <div class=\"input-error-text\" ng-show=\"vm.validation.email.message\">\n              <i class=\"fas fa-exclamation-circle\"></i> Please enter a valid email\n            </div>\n\n            <div class=\"input-label\">Password</div>\n            <div class=\"input-sub-label\">Must include 8 characters and at least one number</div>\n\n            <div class=\"input-container\">\n              <i class=\"fas fa-key\"></i>\n              <input\n                type=\"password\"\n                placeholder=\"Password\"\n                name=\"password\"\n                ng-model=\"vm.password\"\n                ng-change=\"vm.validator.password(vm.password, vm)\"\n                ng-style=\"vm.validation.password.style\"\n                ng-keyup=\"vm.submitOnEnterCompany($event)\"\n                ng-disabled=\"vm.already_registered\"\n                ng-class=\"{'disabled' : vm.already_registered }\"\n                required\n              />\n            </div>\n            <div class=\"input-error-text\" ng-show=\"vm.validation.password.message\">\n              <i class=\"fas fa-exclamation-circle\"></i>\n              {{vm.validation.password.message}}\n            </div>\n          </div>\n\n          <div>\n            <div class=\"continue-button\" ng-disabled=\"vm.buttonDisabled\" ng-click=\"vm.signup()\">\n              <span ng-if=\"vm.buttonDisabled\"><i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i></span>\n              <span ng-if=\"!vm.buttonDisabled\">{{vm.already_registered ? \"Next\" : \"Sign up\"}}</span>\n            </div>\n          </div>\n\n          <div class=\"error-text\" ng-show=\"vm.result.status=='error'\">\n            <i class=\"fas fa-exclamation-circle\"></i>\n            {{vm.result.message}}\n          </div>\n        </div>\n\n        <div class=\"login-text\">\n          <div>\n            Already have an account?\n            <a href=\"/signin\"><span>Sign in</span></a>\n          </div>\n        </div>\n        <!--\n        <div class=\"terms-and-service\">\n          By signing up, you are agreeing with\n          <a class=\"policy\" href=\"https://jobble.com/terms-of-service/\" target=\"_blank\"> Jobble Terms of Service</a>,\n          <a class=\"policy\" href=\"https://kb.jobble.com/privacy/\" target=\"_blank\"> Privacy Policy</a>, and\n          <a class=\"policy\" href=\"https://stripe.com/connect-account/legal\" target=\"_blank\"> Stripe Connected Account Agreement. </a>\n          Please take a moment to review.\n        </div>\n        -->\n      </div>\n    </div>\n  </div>\n</div>\n\n<globalalert></globalalert>\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n\n<a href=\"#verification-modal\" data-toggle=\"modal\" id=\"link-verification-modal\"></a>\n<div class=\"modal fade\" id=\"verification-modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n            </button>\n            <h3 class=\"modal-title\">Thank you</h3>\n          </div>\n\n          <div class=\"modal-body popup-body text-center\">\n            <p>{{vm.message}}</p>\n            <button class=\"btn btn-default\" ng-click=\"vm.gotoSignIn()\">Get Started</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _companyOnboarding = __webpack_require__(296);
	
	var _companyOnboarding2 = _interopRequireDefault(_companyOnboarding);
	
	var _signup = __webpack_require__(289);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	__webpack_require__(291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var companyOnboardingComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _companyOnboarding2.default,
	  controller: _signup2.default,
	  controllerAs: "vm"
	};
	
	exports.default = companyOnboardingComponent;

/***/ }),
/* 296 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader onboarding=\"true\"></jobbleheader>\n\n<style>\n  .company-logo.default {\n    height: 150px;\n  }\n\n  .company-logo.default-long {\n    height: 350px;\n    width: 175px;\n  }\n</style>\n\n<div class=\"sign-up-page company-sign-up company-onboarding-page\">\n  <div class=\"modal-dialog modal-m regi-form-board sign-in\">\n    <div class=\"modal-gradient-banner\"></div>\n    <div class=\"modal-content\" style=\"padding-top: 10px\">\n      <div class=\"modal-content-container\">\n        <div class=\"step-header\">STEP {{vm.userInvited ? 2 : vm.onboarding_step }} of {{vm.userInvited ? \"2\" : \"3\"}}</div>\n        <div style=\"text-align: center\">\n          <h3>Finish Setting Up Your Account</h3>\n        </div>\n        <div>\n          <div ng-if=\"vm.onboarding_step  === 1\">\n            <div class=\"onboarding-header\">Company information</div>\n            <div>\n              <div class=\"input-label\">Legal company name</div>\n              <div class=\"input-sub-label\" style=\"margin-top: -8px; margin-bottom: 8px\">\n                Please enter the legal company name as it would appear on your tax documents\n              </div>\n\n              <input\n                type=\"text\"\n                placeholder=\"Legal Company Name\"\n                name=\"company name\"\n                ng-model=\"vm.onboarding_data.legal_company_name\"\n                ng-change=\"vm.validateCompanyDetails()\"\n                required\n                autofocus\n              />\n\n              <div class=\"input-label\">Display name</div>\n\n              <div class=\"input-sub-label\" style=\"margin-top: -8px; margin-bottom: 8px\">\n                This is the company name that will appear on your job postings. If you are a Multi-Location company, then please add the location to\n                the end of the display name\n              </div>\n\n              <input\n                type=\"text\"\n                placeholder=\"Display Name\"\n                ng-model=\"vm.onboarding_data.company_name\"\n                ng-change=\"vm.validateCompanyDetails()\"\n                required\n                autofocus\n              />\n              <div class=\"onboarding-header\" style=\"margin-bottom: 4px\">Company Address</div>\n              <div class=\"input-sub-label\" style=\"margin-top: -4px; margin-bottom: 8px\">Please enter the address for the company</div>\n\n              <div class=\"input-label\">Primary street address</div>\n              <input\n                type=\"text\"\n                placeholder=\"Address\"\n                ng-model=\"vm.onboarding_data.company_street_address\"\n                ng-change=\"vm.validateCompanyDetails()\"\n                required\n                autofocus\n              />\n\n              <div style=\"display: flex\">\n                <div style=\"flex: 1; padding-right: 32px\">\n                  <div class=\"input-label\">City</div>\n                  <input\n                    type=\"text\"\n                    placeholder=\"City\"\n                    ng-model=\"vm.onboarding_data.company_city\"\n                    ng-change=\"vm.validateCompanyDetails()\"\n                    required\n                    autofocus\n                  />\n                </div>\n                <div style=\"flex: 1; padding-right: 32px\">\n                  <div class=\"input-label\">State</div>\n                  <select\n                    ng-model=\"vm.onboarding_data.company_state\"\n                    ng-change=\"vm.validateCompanyDetails()\"\n                    ng-options=\"state for state in vm.states.values\"\n                    ng-class=\"{'select-error': vm.errors['state']}\"\n                  ></select>\n                </div>\n                <div style=\"flex: 1\">\n                  <div class=\"input-label\">Zip Code</div>\n                  <input\n                    type=\"text\"\n                    placeholder=\"Zip Code\"\n                    ng-model=\"vm.onboarding_data.company_zip_code\"\n                    ng-change=\"vm.validateCompanyDetails()\"\n                    required\n                    autofocus\n                    maxlength=\"5\"\n                  />\n                </div>\n              </div>\n              <div style=\"display: none\" class=\"input-label\">\n                EIN (employer identification number)\n                <i\n                  data-toggle=\"tooltip\"\n                  ng-attr-title=\"Jobble uses your EIN, or employer identification number, to verify your company\"\n                  data-placement=\"bottom\"\n                  class=\"fas fa-question-circle onboarding-tool-tip\"\n                ></i>\n              </div>\n              <input\n                type=\"text\"\n                placeholder=\"EIN\"\n                ng-model=\"vm.onboarding_data.ein\"\n                ng-change=\"vm.validateCompanyDetails()\"\n                style=\"display: none\"\n                required\n                autofocus\n              />\n              <div class=\"input-label\">Number of locations:</div>\n              <div class=\"input-sub-label\" style=\"margin-top: -8px; margin-bottom: 8px\">\n                Please select the number of locations that will be managed from this account\n              </div>\n\n              <select type=\"text\" placeholder=\"Locations\" ng-model=\"vm.onboarding_data.number_of_locations\" ng-change=\"vm.validateCompanyDetails()\">\n                <option value=\"{{o.value}}\" ng-repeat=\"o in vm.locationOptions\">{{o.label}}</option>\n              </select>\n            </div>\n\n            <div ng-if=\"vm.invalidZipCode\" class=\"input-label\">\n              <span style=\"color: red\">Invalid Zip Code</span>\n            </div>\n\n            <div>\n              <button\n                class=\"continue-button gradient-button\"\n                ng-class=\"{'disabled': !vm.validCompanyDetails || vm.savingCompanyInformation}\"\n                ng-disabled=\"!vm.validCompanyDetails || vm.savingCompanyInformation\"\n                ng-click=\"vm.saveCompanyInformation();\"\n              >\n                <span ng-if=\"!vm.savingCompanyInformation\">Next</span>\n                <span ng-if=\"vm.savingCompanyInformation\"><i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i></span>\n              </button>\n            </div>\n          </div>\n\n          <div ng-if=\"vm.onboarding_step === 2\">\n            <div class=\"onboarding-header\">Personal Information</div>\n            <div>\n              <div class=\"input-label\">First Name</div>\n              <input\n                placeholder=\"First name\"\n                name=\"fname\"\n                ng-model=\"vm.onboarding_data.first_name\"\n                ng-change=\"vm.validatePersonalDetails();vm.capitalizeFirstLetter(vm.onboarding_data.first_name, 'firstName');\"\n                required\n                autofocus\n              />\n              <div class=\"input-label\" style=\"margin-top: 20px\">Last Name</div>\n              <input\n                type=\"text\"\n                placeholder=\"Last name\"\n                name=\"lname\"\n                ng-model=\"vm.onboarding_data.last_name\"\n                ng-change=\"vm.validatePersonalDetails();vm.capitalizeFirstLetter(vm.onboarding_data.last_name, 'lastName');\"\n                required\n                autofocus\n              />\n\n              <div class=\"input-label\" style=\"margin-top: 20px\">\n                Personal Phone Number\n                <span ng-if=\"vm.isOnSiteManager\" class=\"verification-hint-text\">*Requires SMS verification</span>\n              </div>\n              <div class=\"input-sub-label\" ng-if=\"!vm.isOnSiteManager\" style=\"margin-top: -8px; margin-bottom: 15px; line-height: 20px\">\n                Please enter your personal 10-digit number\n              </div>\n              <div class=\"input-sub-label\" ng-if=\"vm.isOnSiteManager\" style=\"margin-top: -8px; margin-bottom: 15px; line-height: 20px\">\n                Please provide your personal 10-digit number - we will then send you a 6 digit verification code to enter\n              </div>\n              <input\n                type=\"text\"\n                placeholder=\"Personal Phone Number\"\n                name=\"phone no\"\n                ng-model=\"vm.onboarding_data.phone_number\"\n                ng-change=\"vm.validatePersonalDetails()\"\n                cleave=\"vm.phoneFormatting\"\n                required\n                autofocus\n              />\n            </div>\n\n            <div class=\"terms-and-service sms-policy-signing\">\n              <input \n                  type=\"checkbox\"\n                  ng-model=\"vm.smsAgreementVal\" \n                  ng-click=\"vm.smsAgreement(vm.smsAgreementVal)\"\n              />\n              By checking this box and providing your phone number, you expressly consent \n              to receive automated marketing text messages, emails, calls, and prerecorded \n              messages from Jobble, Inc., its affiliates, and <a \n              class=\"policy\"\n              href=\"https://jobble.com/marketing-partners/\"\n              target=\"_blank\"> marketing partners</a>, even if \n              your number is listed on a Do Not Call Registry. Message frequency varies. Consent \n              is not required to make a purchase or use Jobble services. Msg & data rates \n              may apply. Text STOP to unsubscribe or HELP for help. By consenting, you also \n              agree to <a \n              class=\"policy\"\n              href=\"https://jobble.com/sms-terms-and-conditions/\"\n              target=\"_blank\">Jobble’s SMS Policy</a>, <a \n              class=\"policy\"\n              href=\"https://jobble.com/terms-of-service/\"\n              target=\"_blank\">Terms of Service</a>, and <a \n              class=\"policy\"\n              href=\"https://jobble.com/privacy-policy/\"\n              target=\"_blank\">Privacy Policy</a>.                            \n            </div>\n            \n            <div>\n              <button\n                class=\"continue-button gradient-button\"\n                ng-if=\"!vm.isOnSiteManager\"\n                ng-class=\"{'disabled': !vm.validPersonalDetails}\"\n                ng-disabled=\"!vm.validPersonalDetails\"\n                ng-click=\"vm.setNextStep(); vm.saveUserInformation()\"\n              >\n                <span>Continue</span>\n              </button>\n              <button\n                class=\"continue-button gradient-button\"\n                ng-if=\"vm.isOnSiteManager\"\n                ng-class=\"{'disabled': !vm.validPersonalDetails}\"\n                ng-disabled=\"!vm.validPersonalDetails\"\n                ng-click=\"vm.saveUserInformationThenTriggerCode();\"\n              >\n                <span>Verify Phone Number & Finish</span>\n              </button>\n            </div>\n          </div>\n          <!--\n          <div ng-if=\"vm.onboarding_step  === 3\">\n            <div class=\"onboarding-header\">Billing</div>\n            <div>\n              In order to send payments to Jobblers, you must create a preferred payment method for your account. You won’t be charged until after\n              Jobblers' have finished working their first shift.\n              <br />\n              <br />\n            </div>\n            <div>\n              <div ng-if=\"vm.onboarding_card_state === '1'\">\n                <div>\n                  <div class=\"input-label\">Name on Card</div>\n                  <input\n                    name=\"\"\n                    type=\"text\"\n                    placeholder=\"John Doe\"\n                    class=\"form-control form-input\"\n                    ng-model=\"vm.credit_card_name\"\n                    ng-change=\"vm.validateCardDetails()\"\n                    ng-style=\"vm.validation.credit_card_name.style\"\n                  />\n                </div>\n\n                <div>\n                  <div class=\"input-label\">Street Address</div>\n                  <input\n                    name=\"\"\n                    type=\"text\"\n                    placeholder=\"123, Main St.\"\n                    ng-model=\"vm.street\"\n                    class=\"form-control form-input\"\n                    ng-change=\"vm.validateCardDetails()\"\n                    ng-style=\"vm.validation.street.style\"\n                  />\n                </div>\n\n                <div style=\"display: flex\">\n                  <div style=\"flex: 1; padding-right: 32px\">\n                    <div class=\"input-label\">City</div>\n                    <input\n                      name=\"\"\n                      type=\"text\"\n                      placeholder=\"Boston\"\n                      ng-model=\"vm.city\"\n                      class=\"form-control form-input\"\n                      ng-change=\"vm.validateCardDetails()\"\n                      ng-style=\"vm.validation.city.style\"\n                    />\n                  </div>\n                  <div style=\"flex: 1\">\n                    <div class=\"input-label\">State</div>\n                    <select\n                      ng-model=\"vm.state\"\n                      ng-options=\"state for state in vm.states.values\"\n                      class=\"form-control form-input\"\n                      ng-change=\"vm.validateCardDetails()\"\n                      ng-style=\"vm.validation.state.style\"\n                    ></select>\n                  </div>\n                </div>\n\n                <div>\n                  <div class=\"input-label\">Zip code</div>\n                  <input\n                    name=\"\"\n                    type=\"text\"\n                    placeholder=\"01234\"\n                    ng-model=\"vm.zipCode\"\n                    class=\"form-control form-input\"\n                    ng-change=\"vm.validateCardDetails()\"\n                    ng-style=\"vm.validation.zipCode.style\"\n                  />\n                </div>\n\n                <div>\n                  <div class=\"input-label\">Card Number</div>\n                  <input\n                    name=\"\"\n                    type=\"text\"\n                    placeholder=\"**** **** **** ****\"\n                    class=\"form-control form-input\"\n                    ng-model=\"vm.displayCardNumber\"\n                    cleave=\"vm.cardNumberFormatting\"\n                    ng-change=\"vm.validateCardDetails()\"\n                    ng-style=\"vm.validation.cardNumber.style\"\n                  />\n                </div>\n\n                <div style=\"display: flex\">\n                  <div style=\"flex: 1; display: flex; padding-right: 32px\">\n                    <div style=\"flex: 1; padding-right: 16px\">\n                      <div class=\"input-label\">Exp. Month</div>\n                      <select\n                        class=\"form-control form-input\"\n                        ng-model=\"vm.expMonths.value\"\n                        ng-options=\"type for type in vm.expMonths.values\"\n                        ng-change=\"vm.validateCardDetails()\"\n                        ng-style=\"vm.validation.expDate.style\"\n                      ></select>\n                    </div>\n                    <div style=\"flex: 1\">\n                      <div class=\"input-label\">Exp. Year</div>\n                      <select\n                        class=\"form-control form-input\"\n                        ng-model=\"vm.expYears.value\"\n                        ng-options=\"type for type in vm.expYears.values\"\n                        ng-change=\"vm.validateCardDetails()\"\n                        ng-style=\"vm.validation.expDate.style\"\n                      ></select>\n                    </div>\n                  </div>\n                  <div style=\"flex: 1\">\n                    <div class=\"input-label\">Security code</div>\n                    <input\n                      name=\"\"\n                      type=\"password\"\n                      placeholder=\"XXX\"\n                      ng-model=\"vm.cvc\"\n                      class=\"form-control form-input\"\n                      ng-change=\"vm.handleCVCChange(); vm.validateCardDetails()\"\n                      ng-style=\"vm.validation.cvc.style\"\n                    />\n                  </div>\n                </div>\n\n                <div class=\"row\" style=\"display: none\">\n                  <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    <label>Card Nickname (optional)</label>\n                    <input type=\"text\" ng-model=\"vm.nickname\" placeholder=\"Kevins card\" class=\"form-control form-input\" />\n                  </div>\n                </div>\n\n                <div class=\"save-transactions\">\n                  Safe transactions through\n                  <img src=\"/app/vendor/images/stripe-logo.png\" alt=\"Stripe Logo\" />\n                </div>\n\n                <div>\n                  <button\n                    class=\"continue-button gradient-button\"\n                    ng-disabled=\"!vm.validCardDetails\"\n                    ng-class=\"{'disabled': !vm.validCardDetails}\"\n                    ng-click=\"vm.setNextStep(); vm.createCard();\"\n                  >\n                    <span>Save and continue</span>\n                  </button>\n                </div>\n              </div>\n              <div ng-if=\"vm.onboarding_card_state === '2'\">\n                <div>\n                  <div class=\"input-label\">Account holder name</div>\n                  <input\n                    name=\"\"\n                    type=\"text\"\n                    placeholder=\"Jobble Inc.\"\n                    ng-model=\"vm.accountHolderName\"\n                    ng-change=\"vm.validateBankDetails()\"\n                    class=\"form-control form-input\"\n                  />\n                </div>\n\n                <div>\n                  <div class=\"input-label\">Account Number</div>\n                  <input\n                    name=\"\"\n                    type=\"text\"\n                    placeholder=\"000123456789\"\n                    ng-model=\"vm.accountNumber\"\n                    ng-change=\"vm.validateBankDetails()\"\n                    class=\"form-control form-input\"\n                  />\n                </div>\n\n                <div>\n                  <div class=\"input-label\">Routing Number</div>\n                  <input\n                    name=\"\"\n                    type=\"text\"\n                    placeholder=\"110000000\"\n                    ng-model=\"vm.routingNumber\"\n                    ng-change=\"vm.validateBankDetails()\"\n                    class=\"form-control form-input\"\n                  />\n                </div>\n\n                <div class=\"save-transactions\">\n                  Safe transactions through\n                  <img src=\"/app/vendor/images/stripe-logo.png\" alt=\"Stripe Logo\" />\n                </div>\n                <div>\n                  <button\n                    class=\"continue-button gradient-button\"\n                    ng-class=\"{'disabled': !vm.validBankDetails}\"\n                    ng-disabled=\"!vm.validBankDetails\"\n                    ng-click=\"vm.setNextStep(); vm.createBankAccount();\"\n                  >\n                    <span>Save and continue</span>\n                  </button>\n                </div>\n              </div>\n            </div>\n\n            <div ng-if=\"vm.onboarding_step >= 3\">\n              <div ng-click=\"vm.setNextStep()\" class=\"skip-for-now\">Skip for now</div>\n            </div>\n          </div>\n          -->\n\n          <div ng-if=\"vm.onboarding_step  === 3\">\n            <div class=\"onboarding-header\">Company logo</div>\n            <div>\n              Please upload an image of your company logo, which will appear with your job postings. Accepted file formats include jpeg & png, max\n              size 20 MB\n            </div>\n\n            <div>\n              <div\n                class=\"company-logo\"\n                style=\"min-height: 50px;margin-top: 15px;height: 75px;line-height: 72px;text-align: center;background-repeat: no-repeat;font-size: 20px; border-radius: 6px; background-image: url({{( $root.companyLogoUri ? $root.companyLogoUri : '/app/vendor/images/user-more.png' )}}); background: {{vm.uploadingImage ? 'none' : null}}\"\n              >\n                <span ng-if=\"vm.uploadingImage\"><i class=\"fa fa-spinner fa-spin fa-1x fa-fw\"></i></span>\n              </div>\n              <!--\n                            <img src=\"{{vm.$rootScope.imgFromProfilePage}}\" id=\"img-logo-company\"\n                                 style=\"display:none;\"/>\n                                -->\n            </div>\n            <div>\n              <div>\n                <a\n                  href=\"\"\n                  type=\"file\"\n                  ngf-select=\"vm.uploadFilesNew($file, $invalidFiles)\"\n                  accept=\"image/*\"\n                  ngf-max-height=\"2000\"\n                  ngf-max-size=\"20MB\"\n                >\n                  <div class=\"choose-file\">Choose File</div>\n                </a>\n              </div>\n            </div>\n            <div>\n              <div class=\"continue-button gradient-button\" ng-disabled=\"vm.buttonDisabled\" ng-click=\"vm.setNextStep()\">\n                <span ng-if=\"vm.buttonDisabled\"><i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i></span>\n                <span ng-if=\"!vm.buttonDisabled\">Finish</span>\n              </div>\n            </div>\n\n            <div ng-if=\"vm.onboarding_step >= 3\">\n              <div ng-click=\"vm.setNextStep()\" class=\"skip-for-now\">Skip for now</div>\n            </div>\n          </div>\n\n          <div class=\"error-text\" ng-show=\"vm.result.status=='error'\">\n            <i class=\"fas fa-exclamation-circle\"></i>\n            {{vm.result.message}}\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<globalalert></globalalert>\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n\n<a href=\"#verification-modal\" data-toggle=\"modal\" id=\"link-verification-modal\"></a>\n<div class=\"modal fade\" id=\"verification-modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n            </button>\n            <h3 class=\"modal-title\">Thank you</h3>\n          </div>\n\n          <div class=\"modal-body popup-body text-center\">\n            <p>{{vm.message}}</p>\n            <button class=\"btn btn-default\" ng-click=\"vm.gotoSignIn()\">Get Started</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"confirm-roster-download apply-profile-modal\">\n  <div class=\"modal fade\" id=\"verify-company-user-onboarding\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" data-backdrop=\"static\">\n    <div class=\"modal-dialog modal-m regi-form-board partner\" role=\"document\">\n      <div class=\"modal-gradient-banner\"></div>\n      <div class=\"modal-content\">\n        <div class=\"modal-fixed-bar\"></div>\n        <div class=\"save-exit\" ng-click=\"vm.exitPhoneVerification()\" style=\"margin-top: 15px; margin-right: 30px\">\n          <i class=\"fas fa-times\"></i>\n        </div>\n        <div class=\"modal-content-container\">\n          <div>\n            <h3>Let us know its you</h3>\n            <p>\n              We have sent a 6 digit verification code to {{vm.numberToVerify}}. Sometimes due to heavy volume this code could take up to two minutes\n              to arrive.\n            </p>\n            <p>Please enter this code below to ensure we have the correct mobile number saved:</p>\n          </div>\n          <div>\n            <div class=\"sms-code-container\">\n              <input\n                class=\"\"\n                id=\"sms-code-1\"\n                ng-model=\"vm.smsCode_1\"\n                ng-change=\"vm.codeEntered(1)\"\n                ng-keydown=\"vm.smsCodeBackSpace($event,1)\"\n                required\n                autofocus\n                maxlength=\"1\"\n              />\n              <input\n                class=\"\"\n                id=\"sms-code-2\"\n                ng-model=\"vm.smsCode_2\"\n                ng-change=\"vm.codeEntered(2)\"\n                ng-keydown=\"vm.smsCodeBackSpace($event,2)\"\n                required\n                autofocus\n                maxlength=\"1\"\n              />\n              <input\n                class=\"\"\n                id=\"sms-code-3\"\n                ng-model=\"vm.smsCode_3\"\n                ng-change=\"vm.codeEntered(3)\"\n                ng-keydown=\"vm.smsCodeBackSpace($event,3)\"\n                required\n                autofocus\n                maxlength=\"1\"\n              />\n              <input\n                class=\"\"\n                id=\"sms-code-4\"\n                ng-model=\"vm.smsCode_4\"\n                ng-change=\"vm.codeEntered(4)\"\n                ng-keydown=\"vm.smsCodeBackSpace($event,4)\"\n                required\n                autofocus\n                maxlength=\"1\"\n              />\n              <input\n                class=\"\"\n                id=\"sms-code-5\"\n                ng-model=\"vm.smsCode_5\"\n                ng-change=\"vm.codeEntered(5)\"\n                ng-keydown=\"vm.smsCodeBackSpace($event,5)\"\n                required\n                autofocus\n                maxlength=\"1\"\n              />\n              <input\n                class=\"\"\n                id=\"sms-code-6\"\n                ng-model=\"vm.smsCode_6\"\n                ng-change=\"vm.codeEntered(6)\"\n                ng-keydown=\"vm.smsCodeBackSpace($event,6)\"\n                required\n                autofocus\n                maxlength=\"1\"\n              />\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobblerSignup = __webpack_require__(298);
	
	var _jobblerSignup2 = _interopRequireDefault(_jobblerSignup);
	
	var _signup = __webpack_require__(289);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	__webpack_require__(291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobblerSignupComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _jobblerSignup2.default,
	  controller: _signup2.default,
	  controllerAs: "vm"
	};
	
	exports.default = jobblerSignupComponent;

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<div class=\"sign-up-page\">\n  <div class=\"modal-dialog modal-m regi-form-board sign-in\">\n    <div class=\"modal-gradient-banner\"></div>\n    <div class=\"modal-content\">\n      <div class=\"modal-content-container\" ng-if=\"vm.step == 1\">\n        <div>\n          <h3>Create an Account</h3>\n          <p>Become a Jobbler and apply to thousands of flexible jobs in your area</p>\n        </div>\n        <div>\n          <div class=\"\">\n            <div class=\"input-container\">\n              <i class=\"far fa-envelope\"></i>\n              <input\n                type=\"email\"\n                class=\"\"\n                placeholder=\"Email address\"\n                name=\"email\"\n                ng-model=\"vm.email\"\n                ng-change=\"vm.validator.email(vm.email, vm)\"\n                ng-style=\"vm.validation.email.style\"\n                ng-keyup=\"vm.submitOnEnter($event)\"\n                required\n                autofocus\n              />\n            </div>\n            <div class=\"input-error-text\" ng-show=\"vm.validation.email.message\">\n              <i class=\"fas fa-exclamation-circle\"></i> Please enter a valid email\n            </div>\n            <div class=\"input-container\">\n              <i class=\"fas fa-key\"></i>\n              <input\n                type=\"password\"\n                class=\"\"\n                placeholder=\"Password\"\n                name=\"password\"\n                ng-model=\"vm.password\"\n                ng-change=\"vm.validator.password(vm.password, vm)\"\n                ng-style=\"vm.validation.password.style\"\n                ng-keyup=\"vm.submitOnEnter($event)\"\n                required\n              />\n            </div>\n            <div class=\"input-error-text\" ng-show=\"vm.validation.password.message\">\n              <i class=\"fas fa-exclamation-circle\"></i>\n              {{vm.validation.password.message}}\n            </div>\n            <div style=\"display: none\">\n              <div style=\"display: flex; margin-top: 10px\">\n                <div style=\"flex: 0 0 15px; padding-top: 2px\">\n                  <input style=\"border: 1px solid #767676; box-shadow: none; height: 15px\" type=\"checkbox\" />\n                </div>\n                <div style=\"display: none; flex: 1; padding-left: 4px; margin-top: 0; padding-top: 4.5px; text-align: left\" class=\"login-text\">\n                  Do Not Sell My Info\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div>\n            <div class=\"continue-button\" ng-disabled=\"vm.buttonDisabled\" ng-click=\"vm.signupJobbler()\">\n              <span ng-if=\"vm.buttonDisabled\"><i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i></span>\n              <span ng-if=\"!vm.buttonDisabled\">Sign up</span>\n            </div>\n          </div>\n\n          <div class=\"error-text\" ng-show=\"vm.errorTextRegi\">\n            <i class=\"fas fa-exclamation-circle\"></i>\n            {{vm.errorTextRegi}}\n          </div>\n        </div>\n\n        <div class=\"login-text\">\n          <div>\n            Already have an account?\n            <a href=\"/signin\"><span>Sign in</span></a>\n          </div>\n        </div>\n\n        <div class=\"terms-and-service\">\n          By signing up, you are agreeing with\n          <a class=\"policy\" href=\"https://jobble.com/terms-of-service/\" target=\"_blank\"> Jobble Terms of Service</a>,\n          <a class=\"policy\" href=\"https://kb.jobble.com/privacy/\" target=\"_blank\"> Privacy Policy</a>, and\n          <a class=\"policy\" href=\"https://stripe.com/connect-account/legal\" target=\"_blank\"> Stripe Connected Account Agreement. </a>\n          Please take a moment to review.\n        </div>\n      </div>\n\n      <div class=\"modal-content-container\" ng-if=\"vm.step == 2\">\n        <div class=\"signon-header\" style=\"text-align: center\">\n          <h3 style=\"text-align: left\">Check your email</h3>\n          <p style=\"text-align: left\">We sent a confirmation link to {{vm.currentUser.email}}. It will expire shortly, so click it soon.</p>\n          <img src=\"/app/vendor/images/confirmemail.png\" />\n        </div>\n\n        <div>\n          <form ng-submit=\"vm.sendUserToJobs()\">\n            <input\n              type=\"submit\"\n              value=\"Continue to jobs\"\n              class=\"company-name-signon\"\n              style=\"\n                color: #fff;\n                font-family: Poppins, sans-serif;\n                font-size: 14px;\n                font-weight: 700;\n                line-height: 40px;\n                height: 40px;\n                width: 100%;\n                border-radius: 6px;\n                background-color: #62c046;\n                text-align: center;\n                margin-top: 16px;\n                cursor: pointer;\n              \"\n            />\n          </form>\n        </div>\n        <!--\n        <div class=\"terms-and-service sms-policy-signing\">\n          <input \n              type=\"checkbox\"\n              ng-model=\"vm.smsAgreementVal\" \n              ng-click=\"vm.smsAgreement(vm.smsAgreementVal)\"\n          />\n          By checking this box and providing your phone number, you expressly consent \n          to receive automated marketing text messages, emails, calls, and prerecorded \n          messages from Jobble, Inc., its affiliates, and <a \n          class=\"policy\"\n          href=\"https://jobble.com/marketing-partners/\"\n          target=\"_blank\"> marketing partners</a>, even if \n          your number is listed on a Do Not Call Registry. Message frequency varies. Consent \n          is not required to make a purchase or use Jobble services. Msg & data rates \n          may apply. Text STOP to unsubscribe or HELP for help. By consenting, you also \n          agree to <a \n          class=\"policy\"\n          href=\"https://jobble.com/sms-terms-and-conditions/\"\n          target=\"_blank\">Jobble’s SMS Policy</a>, <a \n          class=\"policy\"\n          href=\"https://jobble.com/terms-of-service/\"\n          target=\"_blank\">Terms of Service</a>, and <a \n          class=\"policy\"\n          href=\"https://jobble.com/privacy-policy/\"\n          target=\"_blank\">Privacy Policy</a>.                            \n        </div>\n        -->\n      </div>\n    </div>\n  </div>\n</div>\n\n<globalalert></globalalert>\n\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n\n<a href=\"#verification-modal\" data-toggle=\"modal\" id=\"link-verification-modal\"></a>\n<div class=\"modal fade\" id=\"verification-modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n            </button>\n            <h3 class=\"modal-title\">Thank you</h3>\n          </div>\n\n          <div class=\"modal-body popup-body text-center\">\n            <p>{{vm.message}}</p>\n            <button class=\"btn btn-default\" ng-click=\"vm.gotoSignIn()\">Get Started</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignupValidate = function () {
	  function SignupValidate($validation) {
	    _classCallCheck(this, SignupValidate);
	
	    this.$validation = $validation;
	  }
	
	  _createClass(SignupValidate, [{
	    key: "validate",
	    value: function validate(vm) {
	      var valid = true;
	
	      var validator = this;
	
	      vm.result.status = "";
	      vm.result.message = "";
	
	      var validFirstName = validator.firstName(vm.first_name, vm);
	      var validLastName = validator.lastName(vm.last_name, vm);
	      var validCompanyName = validator.companyName(vm.company_name, vm);
	      var validEmail = validator.email(vm.email, vm);
	      var validPhone = validator.phone(vm.phone_number, vm);
	      var validPassword = validator.password(vm.password, vm);
	
	      if (!validCompanyName || !validEmail || !validPhone || !validPassword) {
	        valid = false;
	        vm.result.status = "error";
	      }
	
	      // if (!vm.check_policy) {
	      //     valid = false;
	      //     vm.result.status  = "error";
	      //     vm.result.message = "Please agree with Jobble Terms.";
	      // }
	
	      return valid;
	    }
	  }, {
	    key: "validateJobbler",
	    value: function validateJobbler(vm) {
	      var valid = true;
	
	      var validator = this;
	
	      vm.result.status = "";
	      vm.result.message = "";
	
	      var validEmail = validator.email(vm.email, vm);
	      var validPassword = validator.password(vm.password, vm);
	
	      if (!validEmail || !validPassword) {
	        valid = false;
	        vm.result.status = "error";
	      }
	
	      return valid;
	    }
	  }, {
	    key: "validateField",
	    value: function validateField(field, value, validateMethod, constructError, vm) {
	      var _validateMethod = validateMethod(value),
	          isValid = _validateMethod.isValid,
	          errors = _validateMethod.errors;
	
	      if (vm && vm.setValidation) vm.setValidation({
	        field: field,
	        valid: isValid,
	        message: constructError(errors)
	      });
	
	      return isValid;
	    }
	  }, {
	    key: "handleGenericChange",
	    value: function handleGenericChange(name, value, errorCode, vm) {
	      var CommonValidator = this.$validation.CommonValidator;
	
	      return this.validateField(name, value, function (v) {
	        return {
	          isValid: CommonValidator.exists(v),
	          errors: CommonValidator.exists(v)
	        };
	      }, function (valid) {
	        return !valid ? CommonValidator.constructErrorMessage([errorCode]) : "";
	      }, vm);
	    }
	  }, {
	    key: "firstName",
	    value: function firstName(first_name, vm) {
	      var COMMON_ERRORS = this.$validation.Errors.COMMON_ERRORS;
	
	      return this.handleGenericChange("first_name", first_name, COMMON_ERRORS.MISSING_FIRST_NAME, vm);
	    }
	  }, {
	    key: "lastName",
	    value: function lastName(last_name, vm) {
	      var COMMON_ERRORS = this.$validation.Errors.COMMON_ERRORS;
	
	      return this.handleGenericChange("last_name", last_name, COMMON_ERRORS.MISSING_LAST_NAME, vm);
	    }
	  }, {
	    key: "companyName",
	    value: function companyName(company_name, vm) {
	      var COMMON_ERRORS = this.$validation.Errors.COMMON_ERRORS;
	
	      return this.handleGenericChange("company_name", company_name, COMMON_ERRORS.MISSING_COMPANY_NAME, vm);
	    }
	  }, {
	    key: "phone",
	    value: function phone(phone_number, vm) {
	      var PhoneValidator = this.$validation.PhoneValidator;
	
	      if (vm.userInvited && !phone_number) {
	        return true;
	      }
	      return this.validateField("phone", phone_number, PhoneValidator.validatePhone, PhoneValidator.constructErrorMessage, vm);
	    }
	  }, {
	    key: "zip_code",
	    value: function zip_code(_zip_code, vm) {
	      var ZipValidator = this.$validation.ZipValidator;
	
	      return this.validateField("zip_code", _zip_code, ZipValidator.validateZip, ZipValidator.constructErrorMessage, vm);
	    }
	  }, {
	    key: "email",
	    value: function email(_email, vm) {
	      var EmailValidator = this.$validation.EmailValidator;
	
	      return this.validateField("email", _email, EmailValidator.validateEmail, EmailValidator.constructErrorMessage, vm);
	    }
	  }, {
	    key: "password",
	    value: function password(_password, vm) {
	      var PasswordValidator = this.$validation.PasswordValidator;
	
	      return this.validateField("password", _password, PasswordValidator.validatePassword, PasswordValidator.constructErrorMessage, vm);
	    }
	  }]);
	
	  return SignupValidate;
	}();
	
	SignupValidate.$inject = ["validation"];
	
	exports.default = SignupValidate;

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignupRouting = function () {
	  function SignupRouting($timeout, $state, $location) {
	    _classCallCheck(this, SignupRouting);
	
	    this.$timeout = $timeout;
	    this.$state = $state;
	    this.$location = $location;
	  }
	
	  _createClass(SignupRouting, [{
	    key: "routeSignInPage",
	    value: function routeSignInPage(posting_data, currentUser) {
	      if (posting_data.preserve === true) {
	        posting_data.t = currentUser.access_token;
	
	        if (posting_data.job_posting_type === "delivery") {
	          console.log("SERV: Routing to post order");
	          this.go_to_postorder(posting_data);
	        } else {
	          console.log("SERV: Routing to post event");
	          this.go_to_postevent(posting_data);
	        }
	      } else {
	        console.log("SERV: Routing to onboarding");
	        this.go_to_onboarding();
	      }
	    }
	  }, {
	    key: "go_to_onboarding",
	    value: function go_to_onboarding() {
	      this.$state.go("onboarding1");
	    }
	  }, {
	    key: "go_to_postorder",
	    value: function go_to_postorder(posting_data) {
	      var _this = this;
	
	      this.$timeout(function () {
	        _this.$state.go("postorder", posting_data);
	      }, 300);
	    }
	  }, {
	    key: "go_to_postevent",
	    value: function go_to_postevent(posting_data) {
	      var _this2 = this;
	
	      this.$timeout(function () {
	        _this2.$state.go("postevent", posting_data);
	      }, 300);
	    }
	  }, {
	    key: "routePage",
	    value: function routePage() {
	      if (this.$location.$$path.indexOf("company") > -1) {
	        return 1;
	      }
	      if (this.$location.$$path.indexOf("jobbler") > -1) {
	        return 2;
	      }
	
	      return 3;
	    }
	  }]);
	
	  return SignupRouting;
	}();
	
	SignupRouting.$inject = ["$timeout", "$state", "$location"];
	
	exports.default = SignupRouting;

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignupFormatting = function () {
	  function SignupFormatting($timeout) {
	    _classCallCheck(this, SignupFormatting);
	
	    this.$timeout = $timeout;
	  }
	
	  _createClass(SignupFormatting, [{
	    key: "parsePhone",
	    value: function parsePhone(phoneNum) {
	      phoneNum = phoneNum.replace("+1", "").trim();
	      var phoneNumber = "1" + phoneNum;
	      return phoneNumber.replace(/\D/g, "");
	    }
	  }, {
	    key: "phoneFormatting",
	    value: function phoneFormatting(vm) {
	      return {
	        prefix: "+1 ",
	        phone: true,
	        phoneRegionCode: "us",
	        delimiter: "-",
	        rawValueTrimPrefix: true,
	        onValueChanged: function onValueChanged(e) {
	          vm.phone_number = e.target.rawValue.trim();
	
	          // Prevent formatting error from starting number with 1
	          if (vm.phone_number.length === 1 && [1, "1"].indexOf(vm.phone_number) !== -1) {
	            vm.$timeout(function () {
	              vm.phone_number = "";
	              vm.display_phone_number = "";
	            });
	          }
	
	          vm.validator.phone(vm.phone_number, vm);
	        }
	      };
	    }
	  }, {
	    key: "phoneFormattingOnboarding",
	    value: function phoneFormattingOnboarding(vm) {
	      return {
	        prefix: "+1 ",
	        phone: true,
	        phoneRegionCode: "us",
	        delimiter: "-",
	        rawValueTrimPrefix: true,
	        onValueChanged: function onValueChanged(e) {
	          vm.onboarding_data.phone_number = e.target.rawValue.trim();
	
	          // Prevent formatting error from starting number with 1
	          if (vm.onboarding_data.phone_number.length === 1 && [1, "1"].indexOf(vm.onboarding_data.phone_number) !== -1) {
	            vm.$timeout(function () {
	              vm.onboarding_data.phone_number = "";
	              vm.onboarding_data.display_phone_number = "";
	            });
	          }
	        }
	      };
	    }
	  }]);
	
	  return SignupFormatting;
	}();
	
	SignupFormatting.$inject = ["$timeout"];
	
	exports.default = SignupFormatting;

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignupTracking = function () {
	  function SignupTracking($cookies, $location, $social) {
	    _classCallCheck(this, SignupTracking);
	
	    this.$cookies = $cookies;
	    this.$location = $location;
	    this.$social = $social;
	  }
	
	  _createClass(SignupTracking, [{
	    key: "makeMarketingString",
	    value: function makeMarketingString() {
	      var marketingParams = [""];
	
	      var cookies = this.$cookies.getAll();
	
	      if (cookies.hubspotutk) {
	        marketingParams.push("hubspotutk=" + cookies.hubspotutk);
	      }
	
	      var params = ["utm_campaign", "utm_medium", "utm_source", "utm_term", "utm_content"];
	      var queryParams = this.$location.$$search || {};
	
	      params.forEach(function (param) {
	        if (queryParams[param]) {
	          marketingParams.push(param + "=" + queryParams[param]);
	        }
	      });
	
	      return marketingParams.join("&");
	    }
	  }, {
	    key: "fbTrackRegistration",
	    value: function fbTrackRegistration(response, user) {
	      var data = {};
	      data.userId = response.data.userId;
	      data.userName = user.email;
	      data.userEmail = user.email;
	      this.$social.fbTrackRegistration(data);
	    }
	  }, {
	    key: "initFB",
	    value: function initFB() {
	      var index = this.$location.$$path.indexOf("/signup/jobbler");
	      if (index > -1) {
	        this.$social.initFB();
	      }
	    }
	  }]);
	
	  return SignupTracking;
	}();
	
	SignupTracking.$inject = ["$cookies", "$location", "social"];
	
	exports.default = SignupTracking;

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignupRegister = function () {
	  function SignupRegister($env, $auth, $timeout, $rootScope, $tracking, tracking, SignUpFormatting, $http) {
	    _classCallCheck(this, SignupRegister);
	
	    this.$env = $env;
	    this.$auth = $auth;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.$tracking = $tracking;
	    this.tracking = tracking;
	    this.format = SignUpFormatting;
	    this.$http = $http;
	  }
	
	  _createClass(SignupRegister, [{
	    key: "constructReq",
	    value: function constructReq(user, marketingParamsSubgStr) {
	      var _ref = user || {},
	          phone_number = _ref.phone_number,
	          company_name = _ref.company_name,
	          first_name = _ref.first_name,
	          last_name = _ref.last_name,
	          email = _ref.email,
	          password = _ref.password,
	          check_policy = _ref.check_policy,
	          userInvitedToken = _ref.userInvitedToken;
	
	      // API Request Body
	
	
	      console.log("constructReq");
	      console.dir(user);
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "register/register?format=json&conf=web" + marketingParamsSubgStr,
	        data: {
	          company: {
	            defaultPlan: 31,
	            mainContactInfo: {
	              phoneMobile: phone_number
	            },
	            name: company_name
	            //"partner" : "DelivLog"
	          },
	          // firstName: first_name,
	          // lastName: last_name,
	          username: email,
	          password: password,
	          termsOfService: check_policy,
	          acceptedWebAgreement: true,
	          acceptedPrivacyAgreement: true,
	          acceptedCookieAgreement: true,
	          token: userInvitedToken ? userInvitedToken : ""
	        }
	      };
	
	      return req;
	    }
	  }, {
	    key: "formatUserObject",
	    value: function formatUserObject(vm) {
	      var _ref2 = vm || {},
	          phone_number = _ref2.phone_number,
	          company_name = _ref2.company_name,
	          first_name = _ref2.first_name,
	          last_name = _ref2.last_name,
	          email = _ref2.email,
	          password = _ref2.password,
	          check_policy = _ref2.check_policy,
	          userInvitedToken = _ref2.userInvitedToken;
	
	      phone_number = this.format.parsePhone(phone_number);
	
	      return {
	        phone_number: phone_number,
	        company_name: company_name,
	        first_name: first_name,
	        last_name: last_name,
	        email: email,
	        password: password,
	        check_policy: check_policy,
	        userInvitedToken: userInvitedToken
	      };
	    }
	  }, {
	    key: "formatJobblerObject",
	    value: function formatJobblerObject(vm) {
	      var _ref3 = vm || {},
	          first_name = _ref3.first_name,
	          last_name = _ref3.last_name,
	          zip_code = _ref3.zip_code,
	          email = _ref3.email,
	          password = _ref3.password,
	          check_policy = _ref3.check_policy;
	
	      zip_code = zip_code ? zip_code.replace(/\D/g, "") : zip_code;
	
	      return {
	        first_name: first_name,
	        last_name: last_name,
	        zip_code: zip_code,
	        email: email,
	        password: password,
	        check_policy: check_policy
	      };
	    }
	  }, {
	    key: "loginUser",
	    value: function loginUser(user) {
	      var _this = this;
	
	      return new Promise(function (resolve) {
	        _this.$auth.lazyLoginExists(user).then(function (data) {
	          var currentUser = data.data;
	          var loginStatus = parseInt(data.status);
	
	          if (loginStatus === 200) {
	            _this.$timeout(function () {
	              _this.$rootScope.$emit("UpdateCurrentUser", {
	                user: currentUser
	              });
	              _this.$tracking.reportUserRegistration(currentUser);
	
	              resolve({ success: true, user: currentUser });
	            }, 500);
	          } else {
	            var errorMessage = data.statusText;
	            resolve({ success: false, error: errorMessage });
	          }
	        }, function (data) {
	          var errorMessage = data;
	          resolve({ success: false, error: errorMessage });
	        });
	      });
	    }
	  }, {
	    key: "companySignup",
	    value: function companySignup(user) {
	      var _this2 = this;
	
	      try {
	        this.$auth.registerCompanyInHubspot(user);
	      } catch (e) {
	        console.error("Hubspot registration error:", e);
	      }
	
	      var marketingParamsSubgStr = this.tracking.makeMarketingString();
	
	      var req = this.constructReq(user, marketingParamsSubgStr);
	
	      var registerStatus = "";
	      var errorMessage = "";
	      var success = true;
	
	      console.log("what is req");
	      console.dir(req);
	
	      return new Promise(function (resolve) {
	        // NOTE: Making the /register request
	        _this2.$http(req).then(function (data) {
	          registerStatus = data.data.status;
	
	          if (registerStatus === "OK") {
	            console.log("API SIGN UP:", success, registerStatus, errorMessage, user);
	            return resolve({
	              success: success,
	              registerStatus: registerStatus,
	              errorMessage: errorMessage,
	              user: user
	            });
	          } else {
	            errorMessage = data.data.message;
	            success = false;
	
	            if (errorMessage.indexOf("Duplicate entry") > -1) {
	              errorMessage = "This email has already been registered in our system. Please try another or contact support.";
	            }
	
	            console.error("API SIGN UP:", success, registerStatus, errorMessage, user);
	            return resolve({
	              success: success,
	              registerStatus: registerStatus,
	              errorMessage: errorMessage,
	              user: user
	            });
	          }
	        }, function (error) {
	          if (error.data && error.data.message) {
	            success = false;
	            registerStatus = error.status;
	            errorMessage = error.data.message;
	          } else {
	            success = false;
	            registerStatus = "500";
	            errorMessage = "Application Error";
	          }
	
	          console.error("API SIGN UP:", success, registerStatus, errorMessage, user);
	          return resolve({
	            success: success,
	            registerStatus: registerStatus,
	            errorMessage: errorMessage,
	            user: user
	          });
	        });
	      });
	    }
	  }]);
	
	  return SignupRegister;
	}();
	
	SignupRegister.$inject = ["env", "auth", "$timeout", "$rootScope", "tracking", "signup.tracking", "signup.formatting", "$http"];
	
	exports.default = SignupRegister;

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignupCommon = function () {
	  function SignupCommon($timeout) {
	    _classCallCheck(this, SignupCommon);
	
	    this.$timeout = $timeout;
	  }
	
	  _createClass(SignupCommon, [{
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      console.log("We have UNSET the loader in the common service");
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "showTOS",
	    value: function showTOS() {
	      this.$timeout(function () {
	        $("#terms-of-service").modal();
	      });
	    }
	  }, {
	    key: "closeTerms",
	    value: function closeTerms() {
	      this.$timeout(function () {
	        $("#terms-of-service").modal("toggle");
	      });
	    }
	  }, {
	    key: "removeBodyClass",
	    value: function removeBodyClass() {
	      this.$timeout(function () {
	        // $('body').removeClass().addClass('signup-bg');
	      });
	    }
	  }, {
	    key: "closeVerificationModal",
	    value: function closeVerificationModal() {
	      var _this = this;
	
	      this.$timeout(function () {
	        $("#verification-modal .modal-header button.close").trigger("click");
	        $(".modal-backdrop").remove();
	        _this.removeBodyClass();
	      }, 10);
	
	      this.$timeout(function () {
	        // $('body').removeClass('signup-bg');
	      }, 200);
	    }
	  }]);
	
	  return SignupCommon;
	}();
	
	SignupCommon.$inject = ["$timeout"];
	
	exports.default = SignupCommon;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _postashiftwalkthrough = __webpack_require__(306);
	
	var _postashiftwalkthrough2 = _interopRequireDefault(_postashiftwalkthrough);
	
	var _location = __webpack_require__(312);
	
	var _location2 = _interopRequireDefault(_location);
	
	var _dateandtime = __webpack_require__(315);
	
	var _dateandtime2 = _interopRequireDefault(_dateandtime);
	
	var _positiontype = __webpack_require__(322);
	
	var _positiontype2 = _interopRequireDefault(_positiontype);
	
	var _openings = __webpack_require__(325);
	
	var _openings2 = _interopRequireDefault(_openings);
	
	var _shifttitle = __webpack_require__(328);
	
	var _shifttitle2 = _interopRequireDefault(_shifttitle);
	
	var _shiftdescription = __webpack_require__(331);
	
	var _shiftdescription2 = _interopRequireDefault(_shiftdescription);
	
	var _suggestedattire = __webpack_require__(334);
	
	var _suggestedattire2 = _interopRequireDefault(_suggestedattire);
	
	var _arrivalinstructions = __webpack_require__(337);
	
	var _arrivalinstructions2 = _interopRequireDefault(_arrivalinstructions);
	
	var _companyinfo = __webpack_require__(340);
	
	var _companyinfo2 = _interopRequireDefault(_companyinfo);
	
	var _questions = __webpack_require__(343);
	
	var _questions2 = _interopRequireDefault(_questions);
	
	var _requirements = __webpack_require__(346);
	
	var _requirements2 = _interopRequireDefault(_requirements);
	
	var _hiringmanager = __webpack_require__(349);
	
	var _hiringmanager2 = _interopRequireDefault(_hiringmanager);
	
	var _payrate = __webpack_require__(352);
	
	var _payrate2 = _interopRequireDefault(_payrate);
	
	var _preview = __webpack_require__(355);
	
	var _preview2 = _interopRequireDefault(_preview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postashiftwalkthroughModule = _angular2.default.module("postashiftwalkthrough", [_angularUiRouter2.default, "cleave.js"]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("postashiftwalkthrough", {
	    url: "/post-a-shift/walkthrough?cid&eid",
	    template: "<postashiftwalkthrough></postashiftwalkthrough>",
	    title: "Post a Job",
	    params: {
	      job: null,
	      cid: null,
	      eid: null
	    }
	  });
	}).component("postashiftwalkthrough", _postashiftwalkthrough2.default).component("location", _location2.default).component("positiontype", _positiontype2.default).component("openings", _openings2.default).component("dateandtime", _dateandtime2.default).component("shifttitle", _shifttitle2.default).component("shiftdescription", _shiftdescription2.default).component("suggestedattire", _suggestedattire2.default).component("arrivalinstructions", _arrivalinstructions2.default).component("companyinfo", _companyinfo2.default).component("questions", _questions2.default).component("requirements", _requirements2.default).component("hiringmanager", _hiringmanager2.default).component("payrate", _payrate2.default).component("preview", _preview2.default);
	
	exports.default = postashiftwalkthroughModule;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _postashiftwalkthrough = __webpack_require__(307);
	
	var _postashiftwalkthrough2 = _interopRequireDefault(_postashiftwalkthrough);
	
	var _postashiftwalkthrough3 = __webpack_require__(308);
	
	var _postashiftwalkthrough4 = _interopRequireDefault(_postashiftwalkthrough3);
	
	__webpack_require__(310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postashiftwalkthroughComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _postashiftwalkthrough2.default,
	  controller: _postashiftwalkthrough4.default,
	  controllerAs: "vm"
	};
	
	exports.default = postashiftwalkthroughComponent;

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"post-a-shift-container\">\n  <div class=\"nav-container\">\n    <pjheader event=\"vm.event\"></pjheader>\n  </div>\n  <div class=\"walkthrough-container\">\n    <div class=\"side-panel-container\">\n      <div class=\"side-panel-sub-container\">\n        <div class=\"side-panel-title\">Post a Job</div>\n\n        <div class=\"side-panel-group\">\n          <div class=\"side-panel-group-title\" ng-click=\"vm.toggleSideBarGroup(1); vm.$tracking.reportPostAJobClick('side bar - job details');\">\n            Job details<i ng-if=\"!vm.group1State\" class=\"fas fa-caret-right\"></i><i ng-if=\"vm.group1State\" class=\"fas fa-caret-down\"></i>\n          </div>\n          <div ng-if=\"vm.group1State\">\n            <div\n              class=\"side-panel-group-option\"\n              ng-if=\"!vm.event.remote_job\"\n              ng-click=\"vm.allowed.position_type ? vm.setWalkthroughState(vm.walkthroughStates.POSITION) : null; vm.$tracking.reportPostAJobClick('side bar - job type')\"\n              ng-class=\"{'selected-option': vm.walkthroughState === vm.walkthroughStates.POSITION, 'not-allowed': !vm.allowed.position_type}\"\n            >\n              Job type<i ng-if=\"vm.valid.position_type\" class=\"fas fa-check\"></i>\n            </div>\n            <div\n              class=\"side-panel-group-option\"\n              ng-click=\"vm.allowed.location ? vm.setWalkthroughState(vm.walkthroughStates.LOCATION) : null; vm.$tracking.reportPostAJobClick('side bar - location')\"\n              ng-class=\"{'selected-option': vm.walkthroughState === vm.walkthroughStates.LOCATION, 'not-allowed': !vm.allowed.location}\"\n            >\n              Location<i ng-if=\"vm.valid.location\" class=\"fas fa-check\"></i>\n            </div>\n            <div\n              class=\"side-panel-group-option\"\n              ng-click=\"vm.allowed.shifts ? vm.setWalkthroughState(vm.walkthroughStates.DATEANDTIME) : null; vm.$tracking.reportPostAJobClick('side bar - date & time')\"\n              ng-class=\"{'selected-option': vm.walkthroughState === vm.walkthroughStates.DATEANDTIME, 'not-allowed': !vm.allowed.shifts}\"\n            >\n              Date & time<i ng-if=\"vm.valid.shifts\" class=\"fas fa-check\"></i>\n            </div>\n            <div\n              class=\"side-panel-group-option\"\n              ng-click=\"vm.allowed.openings ? vm.setWalkthroughState(vm.walkthroughStates.OPENINGS) : null; vm.$tracking.reportPostAJobClick('side bar - openings')\"\n              ng-class=\"{'selected-option': vm.walkthroughState === vm.walkthroughStates.OPENINGS, 'not-allowed': !vm.allowed.openings}\"\n            >\n              Openings<i ng-if=\"vm.valid.openings\" class=\"fas fa-check\"></i>\n            </div>\n            <div\n              class=\"side-panel-group-option\"\n              ng-click=\"vm.allowed.shift_title ? vm.setWalkthroughState(vm.walkthroughStates.SHIFT_TITLE) : null; vm.$tracking.reportPostAJobClick('side bar - job title')\"\n              ng-class=\"{'selected-option': vm.walkthroughState === vm.walkthroughStates.SHIFT_TITLE, 'not-allowed': !vm.allowed.shift_title}\"\n            >\n              Job Title<i ng-if=\"vm.valid.shift_title\" class=\"fas fa-check\"></i>\n            </div>\n            <div\n              class=\"side-panel-group-option\"\n              ng-click=\"vm.allowed.company_info ? vm.setWalkthroughState(vm.walkthroughStates.COMPANY_INFO) : null; vm.$tracking.reportPostAJobClick('side bar - company info')\"\n              ng-class=\"{'selected-option': vm.walkthroughState === vm.walkthroughStates.COMPANY_INFO, 'not-allowed': !vm.allowed.company_info}\"\n            >\n              Company info<i ng-if=\"vm.valid.company_info\" class=\"fas fa-check\"></i>\n            </div>\n            <div\n              class=\"side-panel-group-option\"\n              ng-click=\"vm.allowed.shift_description ? vm.setWalkthroughState(vm.walkthroughStates.SHIFT_DESCRIPTION) : null; vm.$tracking.reportPostAJobClick('side bar - job description')\"\n              ng-class=\"{'selected-option': vm.walkthroughState === vm.walkthroughStates.SHIFT_DESCRIPTION, 'not-allowed': !vm.allowed.shift_description}\"\n            >\n              Job Description<i ng-if=\"vm.valid.shift_description\" class=\"fas fa-check\"></i>\n            </div>\n            <div\n              class=\"side-panel-group-option\"\n              ng-click=\"vm.allowed.arrival_instructions ? vm.setWalkthroughState(vm.walkthroughStates.ARRIVAL_INSTRUCTIONS) : null; vm.$tracking.reportPostAJobClick('side bar - onsite info')\"\n              ng-class=\"{'selected-option': vm.walkthroughState === vm.walkthroughStates.ARRIVAL_INSTRUCTIONS, 'not-allowed': !vm.allowed.arrival_instructions}\"\n            >\n              Onsite Info<i ng-if=\"vm.valid.arrival_instructions\" class=\"fas fa-check\"></i>\n            </div>\n            <div\n              class=\"side-panel-group-option\"\n              ng-click=\"vm.allowed.dress_code ? vm.setWalkthroughState(vm.walkthroughStates.SUGGESTED_ATTIRE) : null; vm.$tracking.reportPostAJobClick('side bar - suggested attire')\"\n              ng-class=\"{'selected-option': vm.walkthroughState === vm.walkthroughStates.SUGGESTED_ATTIRE, 'not-allowed': !vm.allowed.dress_code}\"\n            >\n              Suggested Attire<i ng-if=\"vm.valid.dress_code\" class=\"fas fa-check\"></i>\n            </div>\n          </div>\n        </div>\n        <!--                <div class=\"side-panel-group\">-->\n        <!--                    <div-->\n        <!--                        class=\"side-panel-group-title\"-->\n        <!--                        ng-click=\"vm.toggleSideBarGroup(2); vm.$tracking.reportPostAJobClick('side bar - post editor')\"-->\n        <!--                    >-->\n        <!--                        Post Editor<i ng-if=\"!vm.group2State\" class=\"fas fa-caret-right\"></i><i ng-if=\"vm.group2State\" class=\"fas fa-caret-down\"></i>-->\n        <!--                    </div>-->\n        <!--                    <div ng-if=\"vm.group2State\">-->\n\n        <!--                    </div>-->\n        <!--                </div>-->\n        <div class=\"side-panel-group\">\n          <div class=\"side-panel-group-title\" ng-click=\"vm.toggleSideBarGroup(3); vm.$tracking.reportPostAJobClick('side bar - screening tools')\">\n            Screening tools<i ng-if=\"!vm.group3State\" class=\"fas fa-caret-right\"></i><i ng-if=\"vm.group3State\" class=\"fas fa-caret-down\"></i>\n          </div>\n          <div ng-if=\"vm.group3State\">\n            <div\n              class=\"side-panel-group-option\"\n              ng-click=\"vm.allowed.requirements ? vm.setWalkthroughState(vm.walkthroughStates.REQUIREMENTS) : null; vm.$tracking.reportPostAJobClick('side bar - requirements')\"\n              ng-class=\"{'selected-option': vm.walkthroughState === vm.walkthroughStates.REQUIREMENTS, 'not-allowed': !vm.allowed.requirements}\"\n            >\n              Requirements<i ng-if=\"vm.valid.requirements\" class=\"fas fa-check\"></i>\n            </div>\n            <!--                        <div-->\n            <!--                            class=\"side-panel-group-option\"-->\n            <!--                            ng-click=\"vm.allowed.questions ? vm.setWalkthroughState(vm.walkthroughStates.QUESTIONS) : null; vm.$tracking.reportPostAJobClick('side bar - questions')\"-->\n            <!--                            ng-class=\"{'selected-option': vm.walkthroughState === vm.walkthroughStates.QUESTIONS, 'not-allowed': !vm.allowed.questions}\"-->\n            <!--                        >-->\n            <!--                            Questionnaire<i ng-if=\"vm.valid.questions\" class=\"fas fa-check\"></i>-->\n            <!--                        </div>-->\n          </div>\n        </div>\n        <div class=\"side-panel-group\">\n          <div\n            class=\"side-panel-group-title\"\n            ng-click=\"vm.allowed.hiring_manager ? vm.setWalkthroughState(vm.walkthroughStates.HIRE) : null; vm.$tracking.reportPostAJobClick('side bar - hiring manager')\"\n            ng-class=\"{'selected-option': vm.walkthroughState === vm.walkthroughStates.HIRE, 'not-allowed': !vm.allowed.hiring_manager}\"\n          >\n            Hiring Manager<i ng-if=\"vm.valid.hiring_manager\" style=\"color: #62c046\" class=\"fas fa-check\"></i>\n          </div>\n        </div>\n        <!--\n                <div class=\"side-panel-group\">\n                    <div class=\"side-panel-group-title\">Teams<istyle=\"color: #62C046;\" class=\"fas fa-check\"></i></div>\n                </div>\n                -->\n        <div class=\"side-panel-group\">\n          <div\n            class=\"side-panel-group-title\"\n            ng-click=\"vm.allowed.hourly_rate ? vm.setWalkthroughState(vm.walkthroughStates.PAY) : null; vm.$tracking.reportPostAJobClick('side bar - pay rate')\"\n            ng-class=\"{'selected-option': vm.walkthroughState === vm.walkthroughStates.PAY, 'not-allowed': !vm.allowed.hourly_rate}\"\n          >\n            Pay rate<i ng-if=\"vm.valid.hourly_rate\" style=\"color: #62c046\" class=\"fas fa-check\"></i>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"main-body-container\" id=\"paj-main-scroll\">\n      <div class=\"main-body-sub-container\">\n        <location ng-if=\"vm.walkthroughState === vm.walkthroughStates.LOCATION\" event=\"vm.event\" />\n        <positiontype ng-if=\"vm.walkthroughState === vm.walkthroughStates.POSITION\" event=\"vm.event\" />\n        <openings ng-if=\"vm.walkthroughState === vm.walkthroughStates.OPENINGS\" event=\"vm.event\" />\n        <shiftdescription ng-if=\"vm.walkthroughState === vm.walkthroughStates.SHIFT_DESCRIPTION\" event=\"vm.event\" />\n        <suggestedattire ng-if=\"vm.walkthroughState === vm.walkthroughStates.SUGGESTED_ATTIRE\" event=\"vm.event\" />\n        <arrivalinstructions ng-if=\"vm.walkthroughState === vm.walkthroughStates.ARRIVAL_INSTRUCTIONS\" event=\"vm.event\" />\n        <dateandtime ng-if=\"vm.walkthroughState === vm.walkthroughStates.DATEANDTIME\" event=\"vm.event\" />\n        <companyinfo ng-if=\"vm.walkthroughState === vm.walkthroughStates.COMPANY_INFO\" event=\"vm.event\" />\n        <shifttitle ng-if=\"vm.walkthroughState === vm.walkthroughStates.SHIFT_TITLE\" event=\"vm.event\" />\n        <requirements ng-if=\"vm.walkthroughState === vm.walkthroughStates.REQUIREMENTS\" event=\"vm.event\" />\n        <!--                <questions ng-if=\"vm.walkthroughState === vm.walkthroughStates.QUESTIONS\" event=\"vm.event\" />-->\n        <hiringmanager ng-if=\"vm.walkthroughState === vm.walkthroughStates.HIRE\" event=\"vm.event\" />\n        <!--\n                <teams ng-if=\"vm.walkthroughState === vm.walkthroughStates.TEAMS\" event=\"vm.event\"/>\n                -->\n        <payrate ng-if=\"vm.walkthroughState === vm.walkthroughStates.PAY\" event=\"vm.event\" />\n      </div>\n      <div style=\"border-top: 1px solid #7a848d; margin-top: 106px; padding-bottom: 200px\">\n        <div class=\"main-body-sub-container\" style=\"padding-top: 48px\">\n          <div class=\"\">\n            <div\n              class=\"\"\n              ng-if=\"vm.walkthroughState !== vm.walkthroughStates.PREVIEW && vm.walkthroughState !== vm.walkthroughStates.HIRE && vm.walkthroughState !== vm.walkthroughStates.ARRIVAL_INSTRUCTIONS && vm.walkthroughState !== vm.walkthroughStates.SUGGESTED_ATTIRE\"\n            >\n              <div class=\"tooltip-container\">\n                <div class=\"tooltip-icon\">\n                  <i class=\"far fa-lightbulb\"></i>\n                </div>\n                <div class=\"tooltip-sub-container\">\n                  <div ng-if=\"vm.walkthroughState === vm.walkthroughStates.LOCATION\">\n                    You may enter one location per job; if you have openings in different locations, please contact sales or post another job later. \n                    <br /><br />\n                    If there is a specific meeting place or your location requires more direction / information, you will be able to add arrival\n                    instructions in a later step. This information will only be made available to hired Jobblers.\n                  </div>\n                  <div ng-if=\"vm.walkthroughState === vm.walkthroughStates.POSITION\">\n                    Jobblers can filter by position type when searching for openings. It is important to select the right category so that all\n                    interested Jobblers see and apply to your post.\n                  </div>\n                  <div ng-if=\"vm.walkthroughState === vm.walkthroughStates.OPENINGS\">\n                    You may add or remove openings after you post a job. We recommend posting for your ideal team size. Our team will use this info to\n                    help support you in getting the applicants you need.<br /><br />\n                    When a company is new to the platform, over-hiring may be necessary in order to mitigate potential no-shows or quits. You are only\n                    required to pay Jobblers who show up and work.\n                  </div>\n                  <div ng-if=\"vm.walkthroughState === vm.walkthroughStates.SHIFT_DESCRIPTION\">\n                    The job description should let the Jobbler know about the work they will be performing and the environment they will be working\n                    in. Make sure to include an overview of the tasks and responsibilities, what skills are required or beneficial, as well as any\n                    required experience.<br /><br />\n                    If there are any details about the job that are important, please make sure to note them here.<br />\n                    Examples Include:<br />\n                    Parking or public transportation availability<br />\n                    Recommended supplies to bring<br />\n                    Availability of onsite personal / meal storage (breakroom, lockers, etc.)<br />\n                    Ongoing work potential<br /><br />\n                    It is important to have the right detail in your job description but to not overwhelm the reader. Lists are a great way to break\n                    out important information.\n                  </div>\n                  <div ng-if=\"vm.walkthroughState === vm.walkthroughStates.DATEANDTIME\">\n                    Jobblers are looking for multi day jobs. We see the best community engagement with recurring jobs that are more than 4 days a week\n                    with at least 6 hour shifts.\n                  </div>\n                  <div ng-if=\"vm.walkthroughState === vm.walkthroughStates.COMPANY_INFO\">\n                    Providing your mission or key values can help attract the best applicants for your job.<br /><br />\n                    Tip: add a description of what the position's impact is on your company. For example, a driver position for a food service company\n                    could say, \"Your role in delivering our product to our clients helps us support our mission of connecting families with fresh\n                    food.\"\n                  </div>\n                  <div ng-if=\"vm.walkthroughState === vm.walkthroughStates.SHIFT_TITLE\">\n                    The job title is the first thing that a Jobbler will see. It is important to be straight forward in describing the post but it is\n                    also your chance to catch our community’s attention. We advise using key words to catch a scrolling applicants’ attention.\n                  </div>\n                  <div ng-if=\"vm.walkthroughState === vm.walkthroughStates.REQUIREMENTS\">\n                    Use requirements to emphasize what workers will experience on the job. Requirements should only be things that would prohibit you\n                    from hiring an applicant if they are unable to meet them.\n                  </div>\n                  <!--                                    <div ng-if=\"vm.walkthroughState === vm.walkthroughStates.QUESTIONS\">-->\n                  <!--                                        Use the questionnaire to get more information about candidates.<br /><br />-->\n                  <!--                                        Responses are a great way to filter through applicants. Ask questions that apply to your specific post.-->\n                  <!--                                        Character questions can also be a great addition to learn more about potential hires.<br /><br />-->\n                  <!--                                        Jobblers respond best to questions with short answers. Let them know how much detail you are looking for.-->\n                  <!--                                    </div>-->\n                  <div ng-if=\"vm.walkthroughState === vm.walkthroughStates.PAY\">\n                    We recommend at least a $15 starting rate to be competitive on the platform as well as to benefit our community.<br /><br />\n                    Jobble is an Open Marketplace and posts with the best rates / times / locations receive the most traffic. You can increase the\n                    rate after a job is posted to incentivize applicants. Raising the rate has a big impact on Jobbler interest.\n                  </div>\n                  <div ng-if=\"vm.walkthroughState === vm.walkthroughStates.PREVIEW\"></div>\n                  <div></div>\n                </div>\n              </div>\n              <div class=\"video-container\" ng-if=\"vm.walkthroughState === vm.walkthroughStates.REQUIREMENTS\">\n                <img ng-if=\"vm.walkthroughState === vm.walkthroughStates.REQUIREMENTS\" src=\"/app/vendor/images/paj-img-phone.png\" height=\"100%\" />\n                <div style=\"margin-top: 16px; font-size: 12px; font-style: italic\">Requirements in the application process</div>\n              </div>\n            </div>\n            <div class=\"\" ng-if=\"vm.walkthroughState == vm.walkthroughStates.PREVIEW\">\n              <div\n                style=\"\n                  font-size: 12px;\n                  font-weight: 600;\n                  letter-spacing: 0.4px;\n                  padding: 16px;\n                  margin: auto;\n                  margin-top: 32px;\n                  width: 100%;\n                  max-width: 276px;\n                  border-radius: 6px;\n                  border: 1px solid #979797;\n                  box-shadow: 0 25px 50px 0 rgba(78, 81, 144, 0.07);\n                \"\n              >\n                <div style=\"font-size: 16px\"><i style=\"margin-right: 8px\" class=\"fas fa-receipt\"></i>Estimated cost summary</div>\n                <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\"></div>\n                <div style=\"\">\n                  <div style=\"display: flex; margin-bottom: 8px\">\n                    <div style=\"flex: 1\">HOURLY RATE</div>\n                    <div style=\"flex: 0 0 30px; text-align: right\">${{vm.event.hourly_rate || \"00\" | number : 2}}</div>\n                  </div>\n                  <div style=\"display: flex; margin-bottom: 8px\">\n                    <div style=\"flex: 1\">{{vm.platform_rate || \"00\"}}% PLATFORM FEE</div>\n                    <div style=\"flex: 0 0 30px; text-align: right\">${{vm.platform_fee || \"00\" | number : 2}}</div>\n                  </div>\n                </div>\n                <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\"></div>\n                <div>\n                  <div style=\"display: flex; margin-bottom: 8px\">\n                    <div style=\"flex: 1\">BILL RATE</div>\n                    <div style=\"flex: 0 0 30px; text-align: right\">${{vm.platform_cost || \"00\" | number : 2}}</div>\n                  </div>\n                  <div style=\"display: flex; margin-bottom: 8px\">\n                    <div style=\"flex: 1\">TOTAL HOURS</div>\n                    <div style=\"flex: 0 0 30px; text-align: right\">{{vm.total_hours || \"00\" | number : 2}}</div>\n                  </div>\n                  <div style=\"display: flex; margin-bottom: 8px\">\n                    <div style=\"flex: 1\">OPENINGS</div>\n                    <div style=\"flex: 0 0 30px; text-align: right\">{{vm.event.openings || \"0\"}}</div>\n                  </div>\n                </div>\n                <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\"></div>\n                <div>\n                  <div style=\"display: flex; margin-bottom: 8px\">\n                    <div style=\"flex: 1\">TOTAL ESTIMATED COST</div>\n                    <div style=\"flex: 0 0 30px; text-align: right\">${{vm.estimated_cost || \"00\" | number : 2}}</div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"video-tutorial-container\">\n      <div class=\"video-tutorial-sub-container\" style=\"max-width: 524px\">\n        <div class=\"video-tutorial-sub-container-title\">Post Preview</div>\n        <div>\n          <preview state=\"vm.walkthroughState\" event=\"vm.event\" />\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"confirm-roster-download\">\n  <div class=\"modal fade\" id=\"cloning-loading-event-data\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" data-backdrop=\"static\">\n    <div class=\"modal-dialog modal-m regi-form-board partner\" role=\"document\">\n      <div class=\"modal-gradient-banner\"></div>\n      <div class=\"modal-content\">\n        <div class=\"modal-fixed-bar\"></div>\n        <div class=\"modal-content-container\">\n          <div>\n            <h3>\n              <i style=\"color: #62c046\" class=\"fas fa-spin fa-spinner fa-1x fa-fw\"></i> Please wait while we locate and clone your previous job...\n            </h3>\n            <p>Please allow our system a few seconds to gather the necessary information that is required for the cloning process.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(309);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GRACE_PERIOD = 1000 * 60 * 60 * 24 * 3;
	
	var PostAShiftWalkThroughController = function () {
	  function PostAShiftWalkThroughController($localStorage, $scope, $rootScope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events, ngProgressFactory, $location, companies) {
	    var _this = this;
	
	    _classCallCheck(this, PostAShiftWalkThroughController);
	
	    this.name = "postashiftwalkthrough";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$localStorage = $localStorage;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$progress = ngProgressFactory.createInstance();
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	    this.$location = $location;
	    this.$companies = companies;
	
	    this.getJobbleTypes().then(function (types) {
	      _this.warehouse_jobble_type = _this.findWarehouseJobType(types);
	      _this.$rootScope.warehouse_jobble_type = _this.warehouse_jobble_type;
	
	      _this.remote_jobble_type = _this.findRemoteJobType(types);
	      _this.$rootScope.remote_jobble_type = _this.remote_jobble_type;
	
	      _this.event_jobble_type = _this.findEventJobType(types);
	      _this.$rootScope.event_jobble_type = _this.event_jobble_type;
	
	      console.log("WE HAVE SET REMOTE TYPE");
	    });
	
	    this.group1State = true;
	    this.group2State = true;
	    this.group3State = true;
	    this.currentUser = this.$auth.getUserData();
	
	    this.walkthroughStates = _variables.WALKTHROUGH_STATES;
	    this.walkthroughState = this.walkthroughStates.POSITION;
	    //this.walkthroughState = this.walkthroughStates.DATEANDTIME;
	    //this.walkthroughState = this.walkthroughStates.PAY;
	
	    this.$rootScope.$emit(_variables.TRIGGER_NEXT_EVENT_NAME, {
	      walkthroughState: this.walkthroughState
	    });
	
	    this.GoNextListener = this.$rootScope.$on(_variables.TRIGGER_NEXT_EVENT_NAME, function ($event, params) {
	      _this.handleGoNext(params.walkthroughState);
	    });
	
	    this.UpdateListener = this.$rootScope.$on(_variables.UPDATE_WORKFLOW_EVENT_NAME, function ($event, params) {
	      _this.setValidStates();
	    });
	
	    this.LockLeftPanelListener = this.$rootScope.$on("LockLeftPanel", function ($event, params) {
	      _this.disableAllowedLinks();
	    });
	
	    this.UnLockLeftPanelListener = this.$rootScope.$on("UnLockLeftPanel", function ($event, params) {
	      _this.enableAllowedLinks();
	    });
	
	    this.SendToDateTimeListener = this.$rootScope.$on("SendToDateTime", function ($event, params) {
	      if (_this.event.is_long_term) {
	        console.log("Done syncing with the API after event cloning in PAJ Controller", _this.event);
	        _this.$timeout(function () {
	          _this.setWalkthroughState(_variables.WALKTHROUGH_STATES.DATEANDTIME);
	        }, 100);
	      } else {
	        _this.$timeout(function () {
	          _this.setWalkthroughState(_variables.WALKTHROUGH_STATES.DATEANDTIME);
	        }, 100);
	      }
	    });
	
	    this.$scope.$on("$destroy", this.SendToDateTimeListener);
	    this.$scope.$on("$destroy", this.UnLockLeftPanelListener);
	    this.$scope.$on("$destroy", this.LockLeftPanelListener);
	    this.$scope.$on("$destroy", this.GoNextListener);
	    this.$scope.$on("$destroy", this.UpdateListener);
	
	    this.event = {
	      location: {},
	      shifts: [this.getNewShiftObject()],
	      openings: null,
	      position_type: null,
	      shift_title: null,
	      company_info: null,
	      shift_description: null,
	      hiring_manager: this.$auth.getUserData().id,
	      requirements: [],
	      questions: [],
	      hourly_rate: null,
	      is_w2: null,
	      dress_code: null,
	      company_name: this.$auth.getUserData().company.name,
	      company_img: this.$auth.getUserData().company.companyLogoUriFree || "/app/vendor/images/events_placeholder_jobble.png",
	      remote_job: false,
	      is_long_term: true,
	      numberOfWeeksToScheduleJob: "11"
	    };
	
	    this.valid = {
	      openings: false
	    };
	    this.allowed = {
	      openings: false
	    };
	
	    this.development_env = this.$env.getEnv();
	    console.log("this.development_env", this.development_env);
	  }
	
	  _createClass(PostAShiftWalkThroughController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this2 = this;
	
	      localStorage.savingDescription = false;
	      localStorage.savingQuestions = false;
	
	      this.setCompanyLogo();
	
	      this.getJobbleTypes().then(function (types) {
	        _this2.warehouse_jobble_type = _this2.findWarehouseJobType(types);
	        _this2.$rootScope.warehouse_jobble_type = _this2.warehouse_jobble_type;
	
	        _this2.remote_jobble_type = _this2.findRemoteJobType(types);
	        _this2.$rootScope.remote_jobble_type = _this2.remote_jobble_type;
	
	        _this2.event_jobble_type = _this2.findEventJobType(types);
	        _this2.$rootScope.event_jobble_type = _this2.event_jobble_type;
	      });
	
	      if (!this.$location || !this.$timeout) return console.error("Fatal error: The post a job flow was not initialized correctly.");
	
	      if (this.$location.$$search.eid) {
	        this.$timeout(function () {
	          _this2.event.id = _this2.$location.$$search.eid;
	          _this2.syncEventWithApi(_this2.event.id, false);
	        });
	      }
	
	      if (this.$location.$$search.cid) {
	        this.$timeout(function () {
	          var clonedFrom = _this2.$location.$$search.cid;
	          _this2.event.clonedFrom = parseFloat(clonedFrom);
	          _this2.cloneEventv3(clonedFrom);
	          //
	          //this.syncEventWithApi(clonedFrom, true);
	        });
	      }
	
	      this.setValidStates();
	
	      this.getCompanyUsers();
	      //this.setAutoHireToggle();
	    }
	  }, {
	    key: "setCompanyLogo",
	    value: function setCompanyLogo() {
	      console.log("setCompanyLogo");
	      console.dir(this.currentUser);
	    }
	  }, {
	    key: "setAutoHireToggle",
	    value: function setAutoHireToggle() {
	      //check to see if company has auto hire on
	      this.$timeout(function () {
	        $(".switch").trigger("click");
	      });
	    }
	  }, {
	    key: "cloneEventv3",
	    value: function cloneEventv3(eventId) {
	      var _this3 = this;
	
	      this.$events.cloneEventv3(eventId).then(function (response) {
	        console.log("cloned event v3");
	        console.dir(response);
	        _this3.syncEventWithApi(response.data.eventId, false);
	      }, function (error) {
	        console.log("error from cloning endpoint");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "getCompanyDesc",
	    value: function getCompanyDesc(eventId) {
	      var _this4 = this;
	
	      this.$events.getEventCompanyDescription().then(function (data) {
	        _this4.event.company_info = data.data.company.description;
	        _this4.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	        //this.setValidStates();
	      });
	    }
	  }, {
	    key: "getReq",
	    value: function getReq(eventId) {
	      var _this5 = this;
	
	      this.$events.getShiftRequirements(eventId).then(function (data) {
	        _this5.event.requirements = data.data;
	        _this5.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	        //this.setValidStates();
	      });
	    }
	  }, {
	    key: "syncEventWithApi",
	    value: function syncEventWithApi(eventId, isClone) {
	      var _this6 = this;
	
	      if (!eventId) return console.warn("Trying to sync event without an event id");
	
	      this.setLoader();
	      this.disableAllowedLinks();
	      this.getCompanyDesc(eventId);
	      this.getReq(eventId);
	
	      this.$events.getEventByIdWithFields(eventId, 1).then(function (data) {
	        var event = data.data;
	        _this6.$timeout(function () {
	          _this6.updateEventFromApi(event, isClone);
	          _this6.enableAllowedLinks();
	        }, 200);
	      });
	    }
	  }, {
	    key: "enableAllowedLinks",
	    value: function enableAllowedLinks() {
	      console.log("enableAllowedLinks");
	      console.dir(this.allowed);
	    }
	  }, {
	    key: "disableAllowedLinks",
	    value: function disableAllowedLinks() {
	      console.log("disableAllowedLinks");
	      console.dir(this.allowed);
	      this.$timeout(function () {
	        $(".post-a-shift-container .main-next-button").addClass("disabled");
	      });
	      //allowed {"openings":true,"position_type":true,"location":true,"shifts":-71.05228,"shift_title":true,"company_info":true,"shift_description":true,"arrival_instructions":true,"dress_code":true,"requirements":true,"hiring_manager":true,"hourly_rate":true}
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "updateEventFromApi",
	    value: function updateEventFromApi(event, isClone) {
	      var deduppedJobble = event.subEvents[0].deduppedJobbles[0];
	      this.event.openings = event.numberOfOpenings;
	      this.event.position_type = deduppedJobble.jobbleType.id + "";
	      if (this.$rootScope.remote_jobble_type) {
	        this.event.remote_job = deduppedJobble.jobbleType.id === this.$rootScope.remote_jobble_type.id;
	      } else {
	        //this.event.remote_job = deduppedJobble.jobbleType.id === this.$rootScope.remote_jobble_type.id;
	      }
	      this.event.dress_code = deduppedJobble.dressCode;
	      this.event.arrival_instructions = event.arrivalInstructions;
	      this.event.deduppedJobbleId = event.subEvents[0].deduppedJobbles[0].id;
	      this.event.onsite_manager_name = event.onsiteManagerName;
	      this.event.onsite_manager_number = event.onsiteManagerNumber;
	      this.event.is_long_term = event.isLongTerm;
	      this.event.numberOfWeeksToScheduleJob = event.weeks + "";
	      this.event.shift_title = event.name;
	      this.event.is_w2 = event.isW2;
	      this.eraseDefaultName();
	      this.event.shift_description = event.description;
	      this.event.questions = event.surveyQuestions;
	      this.event.hiring_manager = deduppedJobble.manager.id;
	      this.event.back_end_loaded = true;
	      this.event.id = event.id;
	
	      console.log(this.$rootScope.remote_jobble_type, this.event);
	
	      if (this.$rootScope.warehouse_jobble_type && this.$rootScope.warehouse_jobble_type.id) {
	        if (this.$rootScope.warehouse_jobble_type.id + "" === this.event.position_type + "") {
	          //this.event.is_long_term = true;
	          //this.event.forced_long_term = true;
	        }
	      }
	
	      if (this.$rootScope.event_jobble_type && this.$rootScope.event_jobble_type.id) {
	        if (this.$rootScope.event_jobble_type.id + "" === this.event.position_type + "") {
	          this.event.is_long_term = false;
	          this.event.forced_one_time = true;
	        }
	      }
	
	      var currentUser = this.$auth.getUserData();
	      var rate = currentUser.company.defaultPlan.jobblerFeePct;
	      var payPerHour = deduppedJobble.payPerHour;
	      var epi = 0.00001;
	
	      var p = 100 - rate * 100;
	      payPerHour = payPerHour * p / 100 / 100;
	
	      this.event.hourly_rate = Math.round((payPerHour + epi) * 100) / 100;
	
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	
	      this.calculateCosts();
	      this.processShiftsFromApi(deduppedJobble, isClone);
	      //this.setValidStates();
	
	      this.unSetLoader();
	    }
	  }, {
	    key: "calculateCosts",
	    value: function calculateCosts() {
	      var _this7 = this;
	
	      if (!this.event) return;
	
	      var currentUser = this.$auth.getUserData();
	      var rate = currentUser.company.defaultPlan.jobblerFeePct;
	
	      var pay = parseFloat(this.event.hourly_rate);
	      var epi = 0.00001;
	      var cost = Math.round((pay + epi) * 100 * (1 + rate)) / 100;
	
	      this.$timeout(function () {
	        _this7.platform_cost = cost;
	        _this7.platform_rate = Math.round(100 * (rate + epi) * 100) / 100;
	        _this7.platform_fee = Math.round((cost - pay) * 100) / 100;
	      });
	
	      if (this.event.shifts && this.event.shifts.length) {
	        var hours = 0;
	
	        this.event.shifts.forEach(function (shift) {
	          if (!shift) return;
	
	          var startDate = new Date(shift.startDate + " " + shift.startTime);
	          var endDate = new Date(shift.endDate + " " + shift.endTime);
	
	          hours += (endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60;
	        });
	
	        this.$timeout(function () {
	          _this7.total_hours = hours;
	          _this7.estimated_cost = Math.round((cost + epi) * 100 * hours * parseFloat(_this7.event.openings)) / 100;
	        });
	      }
	    }
	  }, {
	    key: "go_to_bulk_upload_jobs_page",
	    value: function go_to_bulk_upload_jobs_page() {
	      this.$state.go("postjobbulk");
	    }
	  }, {
	    key: "eraseDefaultName",
	    value: function eraseDefaultName() {
	      if (this.event && this.event.shift_title === "DEFAULT_EVENT_TITLE") {
	        this.event.shift_title = "";
	      }
	    }
	  }, {
	    key: "getCloneShiftOffset",
	    value: function getCloneShiftOffset(shifts) {
	      if (!shifts || !shifts.length) return 1;
	
	      var earliestShift = null;
	      var earliestShiftTime = null;
	
	      shifts.map(function (shift) {
	        var startTime = moment(shift.timeInterval.startTime);
	        var startTimeValue = startTime.valueOf();
	
	        if (!earliestShiftTime) {
	          earliestShiftTime = startTimeValue;
	          earliestShift = shift;
	        } else {
	          if (startTimeValue < earliestShiftTime) {
	            earliestShiftTime = startTimeValue;
	            earliestShift = shift;
	          }
	        }
	      });
	
	      var today = moment();
	      var shiftDate = moment(earliestShift.timeInterval.startTime);
	
	      var diff = moment.duration(today.diff(shiftDate));
	
	      var offset = Math.abs(Math.ceil(diff.asWeeks()));
	
	      console.log("preoffset", offset, shiftDate, today);
	
	      if (shiftDate.valueOf() > today.valueOf() || offset === 0) offset = 1;
	
	      return offset;
	    }
	  }, {
	    key: "processShiftsFromApi",
	    value: function processShiftsFromApi(deduppedJobble, isClone) {
	      var _this8 = this;
	
	      var offset = 1;
	
	      if (isClone) {
	        offset = this.getCloneShiftOffset(deduppedJobble.shifts);
	        console.log("Cloning Offset", offset);
	      }
	
	      var shifts = deduppedJobble.shifts.map(function (shift) {
	        _this8.event.contactInfo = shift.contactInfo;
	
	        var startTime = moment(shift.timeInterval.startTime);
	        var endTime = moment(shift.timeInterval.endTime);
	
	        if (isClone) {
	          startTime = startTime.add(offset, "weeks");
	          endTime = endTime.add(offset, "weeks");
	        }
	
	        var newShift = {
	          id: shift.id,
	          startDate: startTime.format("MM/DD/YYYY"),
	          endDate: endTime.format("MM/DD/YYYY"),
	          startTime: startTime.format("h:mm a").toUpperCase(),
	          endTime: endTime.format("h:mm a").toUpperCase(),
	          overnight: shift.overnight,
	          contactInfo: shift.contactInfo,
	          unpaidBreak: shift.unpaidBreak,
	          hasUnpaidBreak: shift.unpaidBreak > 0
	        };
	
	        console.log("New Shift", newShift);
	
	        if (isClone) {
	          delete newShift.id;
	        }
	
	        return newShift;
	      });
	
	      console.log("These are the shifts", shifts);
	
	      shifts = shifts.sort(function (a, b) {
	        return new Date(a.startDate + " " + a.startTime).getTime() - new Date(b.startDate + " " + b.startTime).getTime();
	      });
	
	      this.$events.adjustTimeZone(this.event.contactInfo.zipCode).then(function (_ref) {
	        var timeZone = _ref.timeZone,
	            timeZoneDifference = _ref.timeZoneDifference;
	
	        _this8.$timeout(function () {
	          _this8.event.shifts = shifts.map(function (shift) {
	            var _$events$adjustTimeZo = _this8.$events.adjustTimeZones(shift, timeZone, timeZoneDifference, true),
	                startTime = _$events$adjustTimeZo.startTime,
	                endTime = _$events$adjustTimeZo.endTime;
	
	            startTime = moment(startTime);
	            endTime = moment(endTime);
	
	            var newShift = {
	              id: shift.id,
	              startDate: startTime.format("MM/DD/YYYY"),
	              endDate: endTime.format("MM/DD/YYYY"),
	              startTime: startTime.format("h:mm a").toUpperCase(),
	              endTime: endTime.format("h:mm a").toUpperCase(),
	              overnight: shift.overnight,
	              contactInfo: shift.contactInfo,
	              unpaidBreak: shift.unpaidBreak,
	              hasUnpaidBreak: shift.unpaidBreak > 0
	            };
	
	            if (isClone) {
	              delete newShift.id;
	            }
	
	            return newShift;
	          });
	
	          _this8.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	
	          if (isClone) {
	            _this8.cloneNewEvent(_this8.event.shifts);
	          } else {
	            _this8.$rootScope.$emit("PostAJobGlobalApiSync", { event: _this8.event });
	            _this8.unSetLoader();
	            _this8.setValidStates(true);
	            /*
	                      this.$timeout(() => {
	                          this.$rootScope.$emit("PostAJobGlobalApiSyncLongTerm", {event: this.event});
	                      }, 500);
	                      */
	          }
	        });
	      });
	    }
	  }, {
	    key: "cloneNewEvent",
	    value: function cloneNewEvent(shifts) {
	      var _this9 = this;
	
	      console.log("cloneNewEvent");
	      console.dir(this.event);
	
	      this.setLoader();
	      this.$events.adjustTimeZone(this.event.contactInfo.zipCode).then(function (_ref2) {
	        var timeZone = _ref2.timeZone,
	            timeZoneDifference = _ref2.timeZoneDifference;
	
	        var timeIntervalsArray = shifts.map(function (shift) {
	          var _$events$adjustTimeZo2 = _this9.$events.adjustTimeZones(shift, timeZone, timeZoneDifference, false),
	              startTime = _$events$adjustTimeZo2.startTime,
	              endTime = _$events$adjustTimeZo2.endTime;
	
	          console.log("contactInfo", JSON.stringify(_this9.event.contactInfo));
	
	          var contactInfo = JSON.parse(JSON.stringify(_this9.event.contactInfo));
	          delete contactInfo["id"];
	
	          return {
	            contactInfo: contactInfo,
	            startDateAndTimeForDB: startTime,
	            endDateAndTimeForDB: endTime,
	            overnight: shift.overnight,
	            unpaidBreak: shift.unpaidBreak,
	            hasUnpaidBreak: shift.unpaidBreak > 0
	          };
	        });
	
	        var warehouse_jobble_type = _this9.$rootScope.warehouse_jobble_type || {};
	
	        var currentUser = _this9.$auth.getUserData();
	        var rate = currentUser.company.defaultPlan.jobblerFeePct;
	        var epi = 0.00001;
	
	        var p = 100 - rate * 100;
	        var x = parseFloat(_this9.event.hourly_rate) * 100;
	        var z = x / p;
	
	        var payPerHour = Math.round((z + epi) * 100) / 100;
	
	        if (_this9.event.numberOfWeeksToScheduleJob === "null") {
	          _this9.event.numberOfWeeksToScheduleJob = null;
	        }
	
	        var event = {
	          name: _this9.event.shift_title || "DEFAULT_EVENT_TITLE",
	          openings: _this9.event.openings || 10,
	          typeOfJobPosting: "regular",
	          dress_code: _this9.event.dress_code || _variables.DRESS_CODE_DEFAULT,
	          arrival_instructions: _this9.event.arrival_instructions,
	          onsite_manager_name: _this9.event.onsite_manager_name,
	          onsite_manager_number: _this9.event.onsite_manager_number,
	          isW2: _this9.event.is_w2,
	          timeIntervalsArray: timeIntervalsArray,
	          jobble_type: parseFloat(_this9.event.position_type) || warehouse_jobble_type.id || 8,
	          manager: _this9.event.hiring_manager,
	          jobble_details: _this9.event.shift_description,
	          hourly_rate: payPerHour,
	          is_long_term: _this9.event.is_long_term,
	          weeks: _this9.event.numberOfWeeksToScheduleJob
	        };
	
	        _this9.$timeout(function () {
	          _this9.generatingShift = true;
	        });
	
	        console.log("clone event payload in PAJ Controller:", event);
	
	        _this9.$events.saveDraftv2(event, _this9.event.clonedFrom).then(function (data) {
	          _this9.$timeout(function () {
	            _this9.generatingShift = false;
	          });
	
	          console.log("Created new event from clone in PAJ Controller:", data);
	
	          _this9.$tracking.reportPostAJobSubmitStep("clone event");
	          _this9.$tracking.reportPostAJobSubmitStep("date & time");
	
	          _this9.event.id = data.data.jobblePool.eventId;
	
	          //TODO: adding the eventId to the url essentially is reloading the page. Why?
	
	          _this9.$state.transitionTo("postashiftwalkthrough", { eid: _this9.event.id }, { notify: false });
	          //this.$location.search("eid", this.event.id);
	          _this9.$location.search("cid", null);
	
	          // if (this.event.questions && this.event.questions.length) {
	          //     const data = {
	          //         event_id: this.event.id,
	          //         questions: this.event.questions,
	          //     };
	          //
	          //     this.$events
	          //         .updateQuestion(data)
	          //         .then((data) => {
	          //             console.log("Saved questions for clone:", data);
	          //         })
	          //         .catch((err) => {
	          //             console.error("Error savings questions for clone:", data);
	          //         });
	          // }
	
	          if (_this9.event.requirements && _this9.event.requirements.length) {
	            _this9.$events.addShiftRequirements(_this9.event.id, _this9.event.requirements).then(function (data) {
	              console.log("Saved requirements for clone:", data);
	            });
	          }
	
	          _this9.calculateCosts();
	          //kkkkkkkk
	          if (_this9.event.is_long_term) {
	            _this9.updateLongTermWeeks(_this9.event.numberOfWeeksToScheduleJob).then(function () {
	              console.log("Done syncing with the API after event cloning in PAJ Controller", _this9.event);
	              _this9.$timeout(function () {
	                _this9.setWalkthroughState(_variables.WALKTHROUGH_STATES.DATEANDTIME);
	              }, 100);
	              _this9.$timeout(function () {
	                _this9.$rootScope.$emit("PostAJobGlobalApiSyncLongTerm", { event: _this9.event });
	              }, 1000);
	            }).catch(function (e) {
	              _this9.$timeout(function () {
	                _this9.setWalkthroughState(_variables.WALKTHROUGH_STATES.DATEANDTIME);
	              }, 1000);
	            });
	          } else {
	            _this9.$timeout(function () {
	              _this9.setWalkthroughState(_variables.WALKTHROUGH_STATES.DATEANDTIME);
	            }, 100);
	            _this9.$timeout(function () {
	              _this9.$rootScope.$emit("PostAJobGlobalApiSyncSingleJob", { event: _this9.event });
	            }, 500);
	          }
	        }).catch(function (err) {
	          console.error("Error creating new event from clone:", err);
	        });
	      });
	    }
	  }, {
	    key: "updateLongTermWeeks",
	    value: function updateLongTermWeeks(weeks) {
	      var _this10 = this;
	
	      console.log("updateLongTermWeeks in PAJ Controller");
	      console.dir(weeks);
	
	      return new Promise(function (resolve) {
	        _this10.$timeout(function () {
	          _this10.event.numberOfWeeksToScheduleJob = weeks;
	          _this10.$rootScope.$emit("SetNewWeeksOnChange", _this10.event);
	          if (_this10.event.id) {
	            _this10.$events.saveEventLongTermWeeks(_this10.event.id, weeks).then(function (data) {
	              console.log("Updated long term event weeks in PAJ Controller:", data);
	              resolve();
	            }).catch(function (e) {
	              console.error(e);
	              resolve();
	            });
	          } else {
	            resolve();
	          }
	        });
	      });
	    }
	  }, {
	    key: "setValidStates",
	    value: function setValidStates(setNext) {
	      if (!this.event) return null;
	
	      console.log("setValidStates");
	      console.dir(setNext);
	      //console.log("allowed", JSON.stringify(this.allowed));
	
	      console.log("this.event", this.event, this.event.position_type, !!this.event.position_type);
	
	      var lastValid = void 0;
	
	      this.allowed.position_type = true;
	      this.valid.position_type = !!this.event.position_type;
	      lastValid = _variables.WALKTHROUGH_STATES.POSITION;
	
	      this.allowed.location = this.allowed.position_type && this.valid.position_type;
	      this.valid.location = this.event.contactInfo && this.event.contactInfo.lat && this.event.contactInfo.lng || this.event.remote_job;
	      lastValid = this.valid.location && this.allowed.location ? _variables.WALKTHROUGH_STATES.LOCATION : lastValid;
	
	      this.allowed.shifts = this.allowed.location && this.valid.location;
	      this.valid.shifts = this.validateShifts();
	      lastValid = this.valid.shifts && this.allowed.shifts ? _variables.WALKTHROUGH_STATES.DATEANDTIME : lastValid;
	
	      this.allowed.openings = this.allowed.shifts && this.valid.shifts;
	      this.valid.openings = this.validateOpenings();
	      lastValid = this.valid.openings && this.allowed.openings ? _variables.WALKTHROUGH_STATES.OPENINGS : lastValid;
	
	      this.allowed.shift_title = this.allowed.openings && this.valid.openings;
	      this.valid.shift_title = !!this.event.shift_title;
	      lastValid = this.valid.shift_title && this.allowed.shift_title ? _variables.WALKTHROUGH_STATES.SHIFT_TITLE : lastValid;
	
	      this.allowed.company_info = this.allowed.shift_title && this.valid.shift_title;
	      this.valid.company_info = !!this.event.company_info;
	      lastValid = this.valid.company_info && this.allowed.company_info ? _variables.WALKTHROUGH_STATES.COMPANY_INFO : lastValid;
	
	      this.allowed.shift_description = this.allowed.company_info && this.valid.company_info;
	      this.valid.shift_description = this.validateDescription();
	      lastValid = this.valid.shift_description && this.allowed.shift_description ? _variables.WALKTHROUGH_STATES.SHIFT_DESCRIPTION : lastValid;
	
	      this.allowed.arrival_instructions = this.allowed.shift_description && this.valid.shift_description;
	      this.valid.arrival_instructions = this.validateArrivalInstructions();
	      lastValid = this.valid.arrival_instructions && this.allowed.arrival_instructions ? _variables.WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS : lastValid;
	
	      this.allowed.dress_code = this.allowed.arrival_instructions && this.valid.arrival_instructions;
	      this.valid.dress_code = this.validateDressCode();
	      lastValid = this.valid.dress_code && this.allowed.dress_code ? _variables.WALKTHROUGH_STATES.SUGGESTED_ATTIRE : lastValid;
	
	      this.allowed.requirements = this.allowed.dress_code && this.valid.dress_code;
	      this.valid.requirements = this.event.requirements && this.event.requirements.length;
	      lastValid = this.valid.requirements && this.allowed.requirements ? _variables.WALKTHROUGH_STATES.REQUIREMENTS : lastValid;
	
	      // this.allowed.questions = this.allowed.dress_code && this.valid.dress_code;
	      // this.valid.questions = this.event.questions && this.event.questions.length;
	      // lastValid = this.valid.questions && this.allowed.questions ? WALKTHROUGH_STATES.QUESTIONS : lastValid;
	
	      // this.allowed.hiring_manager = this.allowed.questions && this.valid.questions;
	      this.allowed.hiring_manager = this.allowed.dress_code && this.valid.dress_code;
	      this.valid.hiring_manager = this.allowed.hiring_manager && !!this.event.hiring_manager;
	      lastValid = this.valid.hiring_manager && this.allowed.hiring_manager ? _variables.WALKTHROUGH_STATES.HIRE : lastValid;
	
	      this.allowed.hourly_rate = this.allowed.hiring_manager && this.valid.hiring_manager;
	      this.valid.hourly_rate = !!this.event.hourly_rate && this.event.hourly_rate >= 7.25;
	      lastValid = this.valid.hourly_rate && this.allowed.hourly_rate ? _variables.WALKTHROUGH_STATES.PAY : lastValid;
	
	      this.calculateCosts();
	
	      console.log("this.allowed");
	      console.dir(this.allowed);
	      console.dir(lastValid);
	
	      if (setNext) {
	        this.handleGoNext(lastValid);
	      }
	    }
	  }, {
	    key: "toggleSideBarGroup",
	    value: function toggleSideBarGroup(index) {
	      if (index === 1) this.group1State = !this.group1State;else if (index === 2) this.group2State = !this.group2State;else if (index === 3) this.group3State = !this.group3State;
	    }
	  }, {
	    key: "getJobbleTypes",
	    value: function getJobbleTypes() {
	      var _this11 = this;
	
	      return new Promise(function (resolve) {
	        _this11.$auth.getJobbleTypes().then(function (data) {
	          _this11.$timeout(function () {
	            _this11.jobble_types = data.data;
	            _this11.$rootScope.jobble_types = data.data;
	            resolve(data.data);
	          });
	        });
	      });
	    }
	  }, {
	    key: "getCompanyUsers",
	    value: function getCompanyUsers() {
	      var _this12 = this;
	
	      this.$companies.getCompanyUsers().then(function (response) {
	        _this12.constructOptions(response.data);
	      }, function (error) {});
	    }
	  }, {
	    key: "constructOptions",
	    value: function constructOptions(users) {
	      var user_array = [];
	
	      users.forEach(function (user) {
	        var user_map = {};
	
	        if (user.homeContactInfo.phoneMobile) {
	          user_map.firstName = user.firstName;
	          user_map.lastName = user.firstName;
	          user_map.phone = user.homeContactInfo.phoneMobile;
	          user_map.id = user.id;
	          user_map.str = user.firstName + " " + user.lastName;
	          user_map.email = user.email;
	          user_array.push(user_map);
	        } else {
	          user.homeContactInfo.phoneMobile = "--";
	          user_map.firstName = user.firstName;
	          user_map.lastName = user.firstName;
	          user_map.phone = user.homeContactInfo.phoneMobile;
	          user_map.id = user.id;
	          user_map.str = user.firstName + " " + user.lastName;
	          user_map.email = user.email;
	          user_array.push(user_map);
	        }
	      });
	
	      this.$rootScope.hiring_managers = user_array;
	    }
	  }, {
	    key: "findWarehouseJobType",
	    value: function findWarehouseJobType(types) {
	      var type = null;
	
	      if (!types || !types.length) return type;
	
	      types.forEach(function (t) {
	        var name = t.name.toLowerCase();
	        if (name.indexOf("warehouse") !== -1) type = t;
	      });
	
	      return type;
	    }
	  }, {
	    key: "findRemoteJobType",
	    value: function findRemoteJobType(types) {
	      var type = null;
	
	      if (!types || !types.length) return type;
	
	      types.forEach(function (t) {
	        var name = t.name.toLowerCase();
	        if (name.indexOf("remote") !== -1) type = t;
	      });
	
	      return type;
	    }
	  }, {
	    key: "findEventJobType",
	    value: function findEventJobType(types) {
	      var type = null;
	
	      if (!types || !types.length) return type;
	
	      types.forEach(function (t) {
	        var name = t.name.toLowerCase();
	        if (name.indexOf("event") !== -1) type = t;
	      });
	
	      return type;
	    }
	  }, {
	    key: "handleGoNext",
	    value: function handleGoNext(prevState) {
	      //this.setValidStates();
	
	      var nextState = prevState;
	
	      switch (prevState) {
	        case _variables.WALKTHROUGH_STATES.POSITION:
	          nextState = _variables.WALKTHROUGH_STATES.LOCATION;
	          break;
	        case _variables.WALKTHROUGH_STATES.LOCATION:
	          nextState = _variables.WALKTHROUGH_STATES.DATEANDTIME;
	          break;
	        case _variables.WALKTHROUGH_STATES.DATEANDTIME:
	          nextState = _variables.WALKTHROUGH_STATES.OPENINGS;
	          break;
	        case _variables.WALKTHROUGH_STATES.OPENINGS:
	          nextState = _variables.WALKTHROUGH_STATES.SHIFT_TITLE;
	          break;
	        case _variables.WALKTHROUGH_STATES.SHIFT_TITLE:
	          nextState = _variables.WALKTHROUGH_STATES.COMPANY_INFO;
	          break;
	        case _variables.WALKTHROUGH_STATES.COMPANY_INFO:
	          nextState = _variables.WALKTHROUGH_STATES.SHIFT_DESCRIPTION;
	          break;
	        case _variables.WALKTHROUGH_STATES.SHIFT_DESCRIPTION:
	          nextState = _variables.WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;
	          break;
	        case _variables.WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS:
	          nextState = _variables.WALKTHROUGH_STATES.SUGGESTED_ATTIRE;
	          break;
	        case _variables.WALKTHROUGH_STATES.SUGGESTED_ATTIRE:
	          nextState = _variables.WALKTHROUGH_STATES.REQUIREMENTS;
	          break;
	        case _variables.WALKTHROUGH_STATES.REQUIREMENTS:
	          nextState = _variables.WALKTHROUGH_STATES.HIRE;
	          break;
	        // case WALKTHROUGH_STATES.QUESTIONS:
	        //     nextState = WALKTHROUGH_STATES.HIRE;
	        //     break;
	        case _variables.WALKTHROUGH_STATES.HIRE:
	          nextState = _variables.WALKTHROUGH_STATES.PAY;
	          break;
	      }
	
	      this.setWalkthroughState(nextState);
	    }
	  }, {
	    key: "setWalkthroughState",
	    value: function setWalkthroughState(state) {
	      var _this13 = this;
	
	      console.log("setWalkthroughState");
	      console.dir(state);
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	      this.$timeout(function () {
	        _this13.walkthroughState = state;
	        if (state === 20) {}
	        if (state === 1) {
	          _this13.$rootScope.$emit("DoNotTriggerModal", {});
	        }
	        document.getElementById("paj-main-scroll").scrollTop = 0;
	      });
	    }
	  }, {
	    key: "getNewShiftObject",
	    value: function getNewShiftObject() {
	      return null;
	
	      return {
	        startDate: null, //"08/21/2020",
	        endDate: null, //"08/21/2020",
	        startTime: null, //"8:00",
	        endTime: null, //"21:00",
	        overnight: false
	      };
	    }
	  }, {
	    key: "validateOpenings",
	    value: function validateOpenings() {
	      if (!this.event || !this.event.openings) return false;
	
	      return this.event.openings <= 1000 && this.event.openings > 0;
	    }
	  }, {
	    key: "validateDescription",
	    value: function validateDescription() {
	      if (!this.event || !this.event.shift_description) return false;
	
	      return this.event.shift_description.length <= 1000;
	    }
	  }, {
	    key: "validateArrivalInstructions",
	    value: function validateArrivalInstructions() {
	      if (!this.event || !this.event.arrival_instructions) return false;
	      if (!this.event.onsite_manager_number) return false;
	      if (!this.event.onsite_manager_name) return false;
	
	      return this.event.arrival_instructions.length <= 500;
	    }
	  }, {
	    key: "validateDressCode",
	    value: function validateDressCode() {
	      if (!this.event || !this.event.dress_code) return false;
	
	      return this.event.dress_code.length <= 500;
	    }
	  }, {
	    key: "validateShifts",
	    value: function validateShifts() {
	      var _this14 = this;
	
	      var allValid = true;
	      if (!this.event || !this.event.shifts || !this.event.shifts.length) {
	        allValid = false;
	        return allValid;
	      }
	
	      this.event.shifts.forEach(function (shift) {
	        var valid = _this14.$events.validateWorflowShift(shift);
	
	        if (shift && shift.startDate) {
	          var startDate = new Date(shift.startDate + " " + shift.startTime);
	          if (_this14.development_env !== "dev" && startDate.getTime() - new Date().getTime() <= GRACE_PERIOD) {
	            console.error("Start date is less than 3 days from now");
	            valid = false;
	          }
	        }
	
	        if (!valid) allValid = false;
	
	        return valid;
	      });
	
	      if (allValid) {
	        if (!this.$events.validateWorflowShiftsNonOverlapping(this.event.shifts)) {
	          allValid = false;
	        }
	      }
	
	      return allValid;
	    }
	  }]);
	
	  return PostAShiftWalkThroughController;
	}();
	
	PostAShiftWalkThroughController.$inject = ["$localStorage", "$scope", "$rootScope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events", "ngProgressFactory", "$location", "companies"];
	
	exports.default = PostAShiftWalkThroughController;

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var WALKTHROUGH_STATES = exports.WALKTHROUGH_STATES = {
	  POSITION: 1,
	  OPENINGS: 2,
	  DATEANDTIME: 3,
	  LOCATION: 4,
	  SHIFT_TITLE: 9,
	  SHIFT_DESCRIPTION: 10,
	  ARRIVAL_INSTRUCTIONS: 19,
	  SUGGESTED_ATTIRE: 20,
	  COMPANY_INFO: 11,
	  QUESTIONS: 12,
	  REQUIREMENTS: 13,
	  HIRE: 14,
	  PAY: 15,
	  PREVIEW: 16
	};
	
	var SCHEDULING_INTERVALS = exports.SCHEDULING_INTERVALS = ["1 Week", "2 Weeks", "3 Weeks", "4 Weeks", "5 Weeks", "6 Weeks", "7 Weeks", "8 Weeks", "9 Weeks", "10 Weeks"];
	
	var TRIGGER_NEXT_EVENT_NAME = exports.TRIGGER_NEXT_EVENT_NAME = "20300402302";
	
	var UPDATE_WORKFLOW_EVENT_NAME = exports.UPDATE_WORKFLOW_EVENT_NAME = "2030023434302";
	
	var DRESS_CODE_DEFAULT = exports.DRESS_CODE_DEFAULT = "We recommend wearing clothing without logos. Wear something that is durable that you feel comfortable in when performing manual labor. Close toed shoes are appropriate.";
	
	var CUSTOM_LOCATIONS = exports.CUSTOM_LOCATIONS = {
	  features: [{
	    type: "Feature",
	    place_name: "2 Freedom Court, Durham, North Carolina 27703, United States",
	    properties: {
	      title: "2 Freedom Court, Durham, North Carolina 27703, United States"
	    },
	    geometry: {
	      coordinates: [-78.8441952, 35.9099926],
	      type: "Point"
	    },
	    address: "2",
	    text: "Freedom Court",
	    context: [{
	      id: "postcode",
	      text: "27703"
	    }, {
	      id: "place",
	      text: "Durham"
	    }, {
	      id: "region",
	      text: "North Carolina"
	    }]
	  }, {
	    type: "Feature",
	    place_name: "Forest Service Rd 711, Topton, NC 28781, USA",
	    properties: {
	      title: "Forest Service Rd 711, Topton, NC 28781, USA"
	    },
	    geometry: {
	      coordinates: [-83.5999282, 35.1954888],
	      type: "Point"
	    },
	    address: "711",
	    text: "Forest Service Rd",
	    context: [{
	      id: "postcode",
	      text: "28781"
	    }, {
	      id: "place",
	      text: "Topton"
	    }, {
	      id: "region",
	      text: "North Carolina"
	    }]
	  }, {
	    type: "Feature",
	    place_name: "1828 W Ferdinand Street, Chicago, Illinois 60622, United States",
	    properties: {
	      title: "1828 W Ferdinand Street, Chicago, Illinois 60622, United States"
	    },
	    geometry: {
	      coordinates: [-87.6728924, 41.8905761],
	      type: "Point"
	    },
	    address: "1828",
	    text: "W Ferdinand Street",
	    context: [{
	      id: "postcode",
	      text: "60622"
	    }, {
	      id: "place",
	      text: "Chicago"
	    }, {
	      id: "region",
	      text: "Illinois"
	    }]
	  }, {
	    type: "Feature",
	    place_name: "1 Ranchland Substation, Cisco, TX 76437, United States",
	    properties: {
	      title: "1 Ranchland Substation, Cisco, TX 76437, United States"
	    },
	    geometry: {
	      coordinates: [-99.1640619, 32.3068369],
	      type: "Point"
	    },
	    address: "1",
	    text: "Ranchland Substation",
	    context: [{
	      id: "postcode",
	      text: "76437"
	    }, {
	      id: "place",
	      text: "Cisco"
	    }, {
	      id: "region",
	      text: "Texas"
	    }]
	  }, {
	    type: "Feature",
	    place_name: "21460 Austell Pond Dr, Porter, TX 77365, United States",
	    properties: {
	      title: "21460 Austell Pond Dr, Porter, TX 77365, United States"
	    },
	    geometry: {
	      coordinates: [-95.262806, 30.103458],
	      type: "Point"
	    },
	    address: "21460",
	    text: "Austell Pond Dr",
	    context: [{
	      id: "postcode",
	      text: "77365"
	    }, {
	      id: "place",
	      text: "Porter"
	    }, {
	      id: "region",
	      text: "Texas"
	    }]
	  }, {
	    type: "Feature",
	    place_name: "2041 Northwest 12th Avenue Miami, Florida 33127, United States",
	    properties: {
	      title: "2041 Northwest 12th Avenue Miami, Florida 33127, United States"
	    },
	    geometry: {
	      coordinates: [-80.21453, 25.79586],
	      type: "Point"
	    },
	    address: "2041",
	    text: "Northwest 12th Avenue",
	    context: [{
	      id: "postcode",
	      text: "33127"
	    }, {
	      id: "place",
	      text: "Miami"
	    }, {
	      id: "region",
	      text: "Florida"
	    }]
	  }, {
	    type: "Feature",
	    place_name: "1016 Madison Square, Madison, TN 37115, United States",
	    properties: {
	      title: "1016 Madison Square, Madison, TN 37115, United States"
	    },
	    geometry: {
	      coordinates: [-86.7157287, 36.2553709],
	      type: "Point"
	    },
	    address: "1016",
	    text: "Madison Square",
	    context: [{
	      id: "postcode",
	      text: "37115"
	    }, {
	      id: "place",
	      text: "Madison"
	    }, {
	      id: "region",
	      text: "Tennessee"
	    }]
	  }, {
	    type: "Feature",
	    place_name: "2 Freedom Ct Durham, NC 27703, United States",
	    properties: {
	      title: "2 Freedom Ct Durham, NC 27703, United States"
	    },
	    geometry: {
	      coordinates: [-78.8441952, 35.9099926],
	      type: "Point"
	    },
	    address: "2",
	    text: "Freedom Ct",
	    context: [{
	      id: "postcode",
	      text: "27703"
	    }, {
	      id: "place",
	      text: "Durham"
	    }, {
	      id: "region",
	      text: "North Carolina"
	    }]
	  }, {
	    type: "Feature",
	    place_name: "3700 Havana St, Denver, CO 80239, United States",
	    properties: {
	      title: "3700 Havana St, Denver, CO 80239, United States"
	    },
	    geometry: {
	      coordinates: [-104.8644976, 39.7702094],
	      type: "Point"
	    },
	    address: "3700",
	    text: "Havana St",
	    context: [{
	      id: "postcode",
	      text: "80239"
	    }, {
	      id: "place",
	      text: "Denver"
	    }, {
	      id: "region",
	      text: "Colorado"
	    }]
	  }, {
	    type: "Feature",
	    place_name: "2100 Foxhall Rd NW Washington DC 20007",
	    properties: {
	      title: "2100 Foxhall Rd NW Washington DC 20007"
	    },
	    geometry: {
	      coordinates: [-77.03, 38.89],
	      type: "Point"
	    },
	    address: "2100",
	    text: "Foxhall Rd",
	    context: [{
	      id: "postcode",
	      text: "20007"
	    }, {
	      id: "place",
	      text: "Washington"
	    }, {
	      id: "region",
	      text: "DC"
	    }]
	  }],
	  type: "FeatureCollection"
	};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(311);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".post-a-shift-container{height:100vh;display:flex;width:100vw;background:none;overflow:hidden;flex-direction:column;font-family:Poppins,sans-serif;color:#33373a;letter-spacing:0}.post-a-shift-container .nav-container{flex:0 0 74px;background:#fff}.post-a-shift-container .walkthrough-container{flex:1;display:flex;height:100%;overflow:hidden}.post-a-shift-container .side-panel-container{flex:0 0 278px;background:#d0dbe0;overflow-y:scroll}.post-a-shift-container .main-body-container{flex:1;background:#fff;overflow-y:scroll;padding-bottom:0}.post-a-shift-container .main-body-container::-webkit-scrollbar,.post-a-shift-container .side-panel-container::-webkit-scrollbar{width:0!important;background:transparent}.post-a-shift-container .add-another-shift{font-size:16px;font-weight:600;cursor:pointer}.post-a-shift-container .add-another-shift.disabled{opacity:.25;pointer-events:none}.post-a-shift-container .main-body-container .main-body-sub-container{width:100%;max-width:408px;margin:auto;padding-top:122px}.post-a-shift-container .video-tutorial-container{flex:1;background:#f7f7f7;overflow-y:scroll}.post-a-shift-container .side-panel-sub-container{padding:30px 21px}.post-a-shift-container .side-panel-title{font-size:24px;font-weight:600;margin-bottom:40px}.post-a-shift-container .side-panel-group-title{font-size:16px;font-weight:600;margin-bottom:24px;cursor:pointer}.post-a-shift-container .side-panel-group-title i{font-size:16px;margin-left:8px;cursor:pointer}.post-a-shift-container .side-panel-group-option{font-size:16px;font-weight:500;margin-bottom:16px;padding-left:20px;cursor:pointer}.post-a-shift-container .side-panel-group-option.selected-option{font-weight:700}.post-a-shift-container .side-panel-group-option.not-allowed,.post-a-shift-container .side-panel-group-title.not-allowed{color:grey;cursor:not-allowed}.post-a-shift-container .side-panel-group-option i{color:#62c046;margin-left:8px}.post-a-shift-container .main-title{font-size:48px;font-weight:600;margin-bottom:46.12px}.post-a-shift-container .main-text{font-size:14px;margin-bottom:16px}.post-a-shift-container .main-sub-title{font-size:16px;font-weight:600;letter-spacing:1px;margin-bottom:16px;text-transform:capitalize}.post-a-shift-container .sub-title{font-size:16px;font-weight:600;margin-bottom:8px}.post-a-shift-container .main-label{font-size:14px;font-weight:500;margin-bottom:8px}.jobs-complete-container .main-icon-select-container,.jobs-complete-container .main-select-container,.post-a-shift-container .main-icon-select-container,.post-a-shift-container .main-select-container,.profile-edits-container .main-icon-select-container,.profile-edits-container .main-select-container{position:relative}.post-a-shift-container input[type=checkbox]{height:16px;width:16px;color:#62c046;font-size:16px;letter-spacing:0;line-height:16px;border:1px solid #62c046;border-radius:4px;background-color:#e3ebef;position:absolute;top:0;left:0;margin-top:0}.post-a-shift-container .checkbox-container{color:#33373a;font-size:14px;font-weight:600;position:relative;height:16px;line-height:16px;padding-left:24px;margin-top:30px}.jobs-complete-container .main-icon-select,.jobs-complete-container .main-input .profile-edits-container .main-select,.jobs-complete-container .main-select,.post-a-shift-container .main-icon-select,.post-a-shift-container .main-input,.post-a-shift-container .main-select,.profile-edits-container .main-icon-select,.profile-edits-container .main-input{box-shadow:0 2px 4px 0 rgba(0,0,0,.1);box-sizing:border-box;height:40px;width:100%;border:1px solid #33373a;border-radius:2px;background-color:#fff;padding-left:24px;-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer}.jobs-complete-container .main-input,.post-a-shift-container .main-input,.profile-edits-container .main-input{cursor:auto}.post-a-shift-container .main-icon-select{padding-left:46px}.jobs-complete-container .main-icon-select-container i.down-icon,.jobs-complete-container .main-icon-select-container i.main-icon,.jobs-complete-container .main-select-container i,.post-a-shift-container .main-icon-select-container i.down-icon,.post-a-shift-container .main-icon-select-container i.main-icon,.post-a-shift-container .main-select-container i,.profile-edits-container .main-icon-select-container i.down-icon,.profile-edits-container .main-icon-select-container i.main-icon,.profile-edits-container .main-select-container i{color:#6a7178;position:absolute;right:26.5px;top:14px;font-size:12px;pointer-events:none}.post-a-shift-container .main-icon-select-container i.main-icon{left:16px;right:auto}.post-a-shift-container .main-text-area-container textarea{box-shadow:0 2px 4px 0 rgba(0,0,0,.1);width:100%;height:156px;border:1px solid #767676;border-radius:2px;background-color:#fff;font-size:14px;padding:16px;line-height:21px}.post-a-shift-container .main-text-area-length{text-align:right;font-size:12px;line-height:18px;margin-top:8px}.post-a-shift-container .main-next-button{height:50px;line-height:50px;border-radius:6px;background:linear-gradient(270deg,#62c046,#5498b4);color:#fff;font-size:17px;font-weight:700;text-align:center;cursor:pointer;margin-top:32px}.post-a-shift-container .main-next-button.disabled{pointer-events:none;background:linear-gradient(270deg,#bbe9ad,#b0ddee)}.post-a-shift-container .video-tutorial-sub-container{padding:70px 0;width:100%;max-width:456px;margin:auto}.post-a-shift-container .video-tutorial-sub-container .video-tutorial-sub-container-title{text-align:center;margin-bottom:24px;font-size:16px;font-weight:500;letter-spacing:.4px;text-transform:uppercase}.post-a-shift-container .video-container{width:100%;max-width:456px;overflow:hidden;text-align:center}.post-a-shift-container .tooltip-container{border-radius:6px;background:linear-gradient(116.57deg,#62c046,#5498b4);box-shadow:0 25px 50px 0 rgba(78,81,144,.07);padding:2px;height:fit-content;min-height:143px;width:100%;max-width:424px;margin:auto;margin-bottom:32px;position:relative}.post-a-shift-container .tooltip-container .tooltip-icon{position:absolute;left:28px;top:25px;font-size:24px}.post-a-shift-container .tooltip-sub-container{background-color:#fff;height:100%;width:100%;border-radius:6px;padding:23px 57px;font-size:14px;font-weight:500;line-height:24px}.post-a-shift-container .overnight-flag,.selected-job-container .overnight-flag{border:2px solid #393c92;display:inline-block;padding:0 3px;border-radius:4px;color:#393c92;font-size:10px;margin-top:6px;text-transform:none}.jobs-complete-container .main-input-container input:focus,.post-a-shift-container .main-input-container input:focus,.profile-edits-container .main-input-container input:focus{border-image-slice:1;border-image-source:linear-gradient(270deg,#62c046,#5498b4)}.jobs-complete-container .main-input-container,.post-a-shift-container .main-input-container,.profile-edits-container .main-input-container{position:relative}.jobs-complete-container .main-input-container i,.post-a-shift-container .main-input-container i,.profile-edits-container .main-input-container i{position:absolute;right:16px;top:13px;cursor:pointer}.post-a-shift-container .main-input-container textarea::placeholder,.post-a-shift-container .main-input-container textarea:placeholder-shown{color:#bfc1c3!important}.post-a-shift-container :placeholder-shown{color:#bfc1c3!important}.post-a-shift-container ::placeholder{color:#bfc1c3!important}.jobs-complete-container .question-input-container,.post-a-shift-container .question-input-container,.profile-edits-container .question-input-container{margin-top:16px}.requirements-container .question-input-container{margin-top:8px}.jobs-complete-container .main-input.question-input,.post-a-shift-container .main-input.question-input,.profile-edits-container .main-input.question-input{background:#f7f7f7;border-color:#33373a;height:fit-content;padding:7px 24px;word-wrap:break-word;overflow-wrap:break-word}.jobs-complete-container .question-input:hover,.post-a-shift-container .question-input:hover,.profile-edits-container .question-input:hover{border-image-slice:1;border-image-source:linear-gradient(270deg,#62c046,#5498b4);cursor:pointer}.jobs-complete-container .question-input-container i,.post-a-shift-container .question-input-container i,.profile-edits-container .question-input-container i{display:none}.jobs-complete-container .question-input-container:hover i,.post-a-shift-container .question-input-container:hover i,.post-a-shift-container .requirements-container .question-input-container i,.profile-edits-container .question-input-container:hover i{display:initial;cursor:pointer}.post-a-shift-container .main-datepicker.disabled{background:#80808045;pointer-events:none}.post-a-shift-container .main-input-container.pay-input input{padding-left:46px}.post-a-shift-container .main-input-container.pay-input input::-webkit-input-placeholder{color:#7a848d;opacity:.5}.post-a-shift-container .main-input-container.pay-input input::-moz-placeholder{color:#7a848d;opacity:.5}.post-a-shift-container .main-input-container.pay-input input:-ms-input-placeholder{color:#7a848d;opacity:.5}.post-a-shift-container .main-input-container.pay-input input:-moz-placeholder{color:#7a848d;opacity:.5}.post-a-shift-container .main-input-container.pay-input i{right:auto;left:16px;top:13px;cursor:none}.job-scheduler{position:relative;margin-top:15px}.job-scheduler select{padding-left:7px;height:35px;width:100px;box-shadow:0 2px 4px 0 rgb(0 0 0/10%);box-sizing:border-box;border:1px solid #33373a;border-radius:2px;background-color:#fff;-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer}::-webkit-input-placeholder{color:#33373a;opacity:1}:-moz-placeholder,::-moz-placeholder{color:#33373a;opacity:1}:-ms-input-placeholder{color:#33373a;opacity:1}::-ms-input-placeholder{opacity:1}:placeholder-shown{color:#33373a;opacity:1}.post-a-shift-container .mapboxgl-ctrl-geocoder{width:100%;height:40px;max-width:100%}.post-a-shift-container .mapboxgl-ctrl-geocoder--icon{top:10px}.post-a-shift-container .mapboxgl-ctrl-geocoder--input{height:40px}.post-a-shift-container input::-webkit-inner-spin-button,.post-a-shift-container input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.post-a-shift-container input[type=number]{-moz-appearance:textfield}.datepicker{font-family:Poppins,sans-serif;color:#33373a}.datepicker-picker{padding:20px 15px;padding-bottom:5px;padding-top:5px;border:1px solid #5e666d;border-radius:10px}.datepicker-controls button{background:#fff;color:#33373a;font-size:12px}.datepicker .days{flex:1}.datepicker .datepicker-grid{width:100%}.datepicker-view .dow{height:inherit;line-height:inherit;font-size:12px;font-weight:400}.datepicker-cell,.datepicker-view .week{height:inherit;line-height:inherit;font-size:12px;font-weight:500}.datepicker-cell.range-end:not(.selected),.datepicker-cell.range-start:not(.selected){background-color:#5e666d;color:#fff}.datepicker-cell.range{background-color:#adbcc2}.datepicker-cell.selected,.datepicker-cell.selected:hover{background-color:#5e666d;color:#fff;font-weight:500}.datepicker-cell.disabled{color:#adbcc2;opacity:.5}.datepicker-cell.next:not(.disabled),.datepicker-cell.prev:not(.disabled){color:#adbcc2}.datepicker-cell,.datepicker-view .dow,.datepicker-view .week{height:30px}.switch-holder{float:right}.switch{position:relative;display:inline-block;width:60px;height:34px}.switch input{opacity:0;width:0;height:0}.slider{cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc}.slider,.slider:before{position:absolute;transition:.4s}.slider:before{content:\"\";height:26px;width:26px;left:4px;bottom:4px;background-color:#fff}input:checked+.slider{background-color:#2196f3}input:focus+.slider{box-shadow:0 0 1px #2196f3}input:checked+.slider:before{transform:translateX(26px)}.slider.round{border-radius:34px}.slider.round:before{border-radius:50%}.day-of-week-icon{flex:0 0 50px;border-radius:50px;height:50px;background:none;border:1px solid #000;margin-right:10px;line-height:50px;text-align:center;font-size:15px;cursor:pointer}.day-of-week-icon.selected{background:#000;color:#fff;font-weight:600}.day-of-week-icon:hover{background:rgba(0,0,0,.2);font-weight:600}.day-of-week-icon.selected:hover{background:rgba(0,0,0,.8)}.short-term-long-term-button{font-family:Poppins,sans-serif;font-size:14px;font-weight:600;letter-spacing:.4px;height:50px;line-height:50px;padding:0 16px;text-align:center;width:fit-content;border-radius:6px;border:2px solid #62c046;text-transform:uppercase;color:rgba(0,0,0,.6);display:inline-block;cursor:pointer}.short-term-long-term-button.selected{background:#62c046;color:#fff;text-decoration:underline}.requirements-box{padding:8px;border:1px dashed #000;margin:16px 0;background:#f7f7f7;border-radius:4px}.requirements-box-label{text-align:center;margin-bottom:8px;font-size:14px;font-weight:500;letter-spacing:.4px;text-transform:uppercase}.post-a-shift-container .requirements-container .question-input,.profile-edits-container .question-input{background:#fff}.post-a-shift-container .requirements-container .question-input:hover{cursor:auto}.requirements-box-options{overflow:scroll}.requirements-box-no-option{background:hsla(0,0%,100%,.2);border:1px dashed rgba(1,1,1,.2);border-radius:4px;text-align:center;padding:8px}.requirements-box-options::-webkit-scrollbar{width:0;background:transparent}.profile-edits-container .main-input.question-input{background:#fff;padding:7px 16px}.profile-edits-container .main-input.question-input a{float:right}#cloning-loading-event-data{-webkit-animation:pop-in .5s;-moz-animation:pop-in .5s;-ms-animation:pop-in .5s}#cloning-loading-event-data .modal-dialog{width:445px;height:300px;margin-top:260px}#job-creation-loader{-webkit-animation:pop-in .5s;-moz-animation:pop-in .5s;-ms-animation:pop-in .5s}#job-creation-loader .modal-dialog{width:445px;height:300px;margin-top:260px}#job-creation-error{margin-top:20px;color:#fff;border-radius:5px;background-color:red;padding:10px;font-weight:500}", ""]);
	
	// exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _location = __webpack_require__(313);
	
	var _location2 = _interopRequireDefault(_location);
	
	var _location3 = __webpack_require__(314);
	
	var _location4 = _interopRequireDefault(_location3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var locationComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _location2.default,
	  controller: _location4.default,
	  controllerAs: "vm"
	};
	
	exports.default = locationComponent;

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <div class=\"main-title\" style=\"white-space: nowrap\">Location <span ng-if=\"vm.forced_remote_job\">(remote)</span></div>\n  <div ng-if=\"!vm.forced_remote_job\" class=\"main-text\">\n    <pajtooltip />Please enter the address of the job location where Jobblers should report for each shift:\n  </div>\n  <div ng-if=\"vm.forced_remote_job\" class=\"main-text\">\n    <span style=\"font-weight: 600\">This is a remote job.<br /><br /></span>The location of remote jobs cannot be edited. If this job takes place\n    in-person, please delete this job and create a new job post to add a location.\n  </div>\n  <div ng-if=\"!vm.forced_remote_job\" id=\"geocoder\" class=\"geocoder\"></div>\n\n  <div\n    ng-if=\"!vm.forced_remote_job && !vm.hide_remote_job\"\n    style=\"position: relative; margin-top: 16px; font-weight: 600; padding-left: 23px; line-height: 16px; font-size: 14px\"\n  >\n    <!--\n        <input type=\"checkbox\" ng-model=\"vm.event.remote_job\" ng-change=\"vm.updateRemoteJob()\" />\n        Remote Job\n        -->\n  </div>\n\n  <div ng-if=\"!vm.forced_remote_job\" style=\"height: 300px; width: 100%; max-width: 300px; margin: auto; margin-top: 20px\" id=\"map\"></div>\n  <div\n    class=\"main-next-button\"\n    ng-class=\"{'disabled': (!vm.event.contactInfo || !vm.event.contactInfo.zipCode) && !vm.event.remote_job}\"\n    ng-click=\"vm.goNext()\"\n  >\n    Next\n  </div>\n</div>\n"

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(309);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LocationController = function () {
	  function LocationController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    var _this = this;
	
	    _classCallCheck(this, LocationController);
	
	    this.name = "location";
	    this.walkthroughState = _variables.WALKTHROUGH_STATES.LOCATION;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	
	    this.forced_remote_job = false;
	
	    if (!this.$auth.isAdmin()) this.hide_remote_job = true;
	
	    this.PostAJobGlobalApiSyncListener = this.$rootScope.$on("PostAJobGlobalApiSync", function ($event, params) {
	      _this.syncApi();
	    });
	
	    this.$scope.$on("$destroy", this.PostAJobGlobalApiSyncListener);
	  }
	
	  _createClass(LocationController, [{
	    key: "syncApi",
	    value: function syncApi() {
	      var _this2 = this;
	
	      this.determineRemoteState();
	
	      if (this.event && this.event.contactInfo && this.event.contactInfo.streetLine1) {
	        if (this.event.remote_job) return console.warn("Ignoring remote job api sync");
	
	        this.$timeout(function () {
	          _this2.geocoder.query(_this2.event.contactInfo.streetLine1 + " " + _this2.event.contactInfo.city);
	        });
	      }
	    }
	  }, {
	    key: "determineRemoteState",
	    value: function determineRemoteState() {
	      console.log(this.event);
	
	      if ((this.event && this.event.shifts && this.event.shifts.length && this.event.shifts[0] && this.event.shifts[0].id || this.event && this.event.clonedFrom) && this.event.remote_job) {
	        this.forced_remote_job = true;
	      } else {
	        this.forced_remote_job = false;
	      }
	
	      if ((this.event && this.event.shifts && this.event.shifts.length && this.event.shifts[0] && this.event.shifts[0].id || this.event && this.event.clonedFrom) && !this.event.remote_job) {
	        this.hide_remote_job = true;
	      }
	
	      console.log("this.forced_remote_job:", this.forced_remote_job);
	    }
	  }, {
	    key: "updateShift",
	    value: function updateShift(shift, contactInfo) {
	      if (!shift.id) {
	        return console.warn("Trying to update shift without an ID");
	      }
	
	      if (shift.contactInfo.lat === contactInfo.lat && shift.contactInfo.lng === contactInfo.lng) return console.warn("Needless shift update: (", contactInfo.lat, ",", contactInfo.lng, ")");
	
	      var tempShift = {
	        id: shift.id,
	        contactInfo: contactInfo
	      };
	
	      this.$events.updateExistingShift(tempShift, true).then(function (data) {
	        console.log("Updated shift:", data);
	      }, function (err) {});
	    }
	  }, {
	    key: "$onInit",
	    value: function $onInit() {
	      var _this3 = this;
	
	      mapboxgl.accessToken = this.$env.EnvironmentConfig.mapbox;
	
	      this.determineRemoteState();
	
	      this.$timeout(function () {
	        var map = new mapboxgl.Map({
	          container: "map",
	          style: "mapbox://styles/mapbox/streets-v11",
	          center: [-71.1103692, 42.3145186],
	          zoom: 8
	        });
	
	        _this3.map = map;
	
	        var geocoder = new MapboxGeocoder({
	          accessToken: mapboxgl.accessToken,
	          mapboxgl: mapboxgl,
	          countries: "us",
	          localGeocoder: _this3.forwardGeocoder.bind(_this3),
	          types: "address",
	          filter: function filter(item) {
	            return item.address;
	          }
	        });
	
	        geocoder.on("result", function (data) {
	
	          if (_this3.event.remote_job) return console.warn("Ignoring remote job update");
	
	          var location = data.result;
	
	          var contactInfo = {
	            lng: location.center[0],
	            lat: location.center[1],
	            streetLine1: location.address + " " + location.text,
	            city: "",
	            state: "",
	            zipCode: ""
	          };
	
	          location.context.forEach(function (c) {
	            if (c.id.indexOf("postcode") !== -1) {
	              contactInfo.zipCode = c.text;
	            }
	            if (c.id.indexOf("place") !== -1) {
	              contactInfo.city = c.text;
	            }
	            if (c.id.indexOf("region") !== -1) {
	              contactInfo.state = _this3.convertState(c.text);
	            }
	          });
	
	          _this3.$timeout(function () {
	            _this3.event.contactInfo = contactInfo;
	            _this3.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	          });
	
	          if (_this3.event.id) {
	            _this3.event.shifts.map(function (shift) {
	              _this3.updateShift(shift, contactInfo);
	            });
	          }
	
	          console.log("what is event in location");
	          console.dir(_this3.event);
	        });
	
	        geocoder.on("clear", function (data) {
	          if (_this3.event.remote_job) return console.warn("Ignoring remote job clear");
	
	          var contactInfo = null;
	
	          _this3.$timeout(function () {
	            _this3.event.contactInfo = contactInfo;
	            _this3.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	          });
	        });
	
	        document.getElementById("geocoder").appendChild(geocoder.onAdd(map));
	
	        _this3.geocoder = geocoder;
	
	        if (_this3.event && _this3.event.contactInfo && _this3.event.contactInfo.streetLine1) {
	          if (_this3.event.remote_job) return console.warn("Ignoring remote job init query");
	
	          _this3.$timeout(function () {
	            console.log("contactInfo", _this3.event.contactInfo);
	            geocoder.query(_this3.event.contactInfo.streetLine1 + " " + _this3.event.contactInfo.city);
	          });
	        }
	
	        if (_this3.event.remote_job) {
	          geocoder.setInput("Anywhere, USA");
	          map.flyTo({
	            center: [-87.6500523, 41.850033],
	            zoom: 1,
	            speed: 3
	          });
	
	          var inputs = document.querySelectorAll("input.mapboxgl-ctrl-geocoder--input");
	          inputs.forEach(function (input) {
	            return input.disabled = true;
	          });
	        }
	      });
	    }
	  }, {
	    key: "forwardGeocoder",
	    value: function forwardGeocoder(query) {
	      console.log("forwardGeocoder query", query);
	      var matchingFeatures = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = _variables.CUSTOM_LOCATIONS.features[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var feature = _step.value;
	
	          if (feature.properties.title.toLowerCase().includes(query.toLowerCase()) || feature.properties.title.toLowerCase().replace(",", "").includes(query.toLowerCase())) {
	            console.log("Custom Property Match:", feature.properties.title);
	            feature["center"] = feature.geometry.coordinates;
	            feature["place_type"] = ["address"];
	            matchingFeatures.push(feature);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return matchingFeatures;
	    }
	  }, {
	    key: "updateRemoteJob",
	    value: function updateRemoteJob() {
	      if (this.event.remote_job) {
	        this.geocoder.setInput("Anywhere, USA");
	        this.map.flyTo({
	          center: [-87.6500523, 41.850033],
	          zoom: 1,
	          speed: 3
	        });
	
	        this.event.contactInfo = null;
	
	        var inputs = document.querySelectorAll("input.mapboxgl-ctrl-geocoder--input");
	        inputs.forEach(function (input) {
	          return input.disabled = true;
	        });
	      } else {
	        this.geocoder.setInput("");
	
	        var _inputs = document.querySelectorAll("input.mapboxgl-ctrl-geocoder--input");
	        _inputs.forEach(function (input) {
	          return input.disabled = false;
	        });
	      }
	
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	    }
	  }, {
	    key: "convertState",
	    value: function convertState(state) {
	      var STATES = {
	        Alabama: "AL",
	        Alaska: "AK",
	        "American Samoa": "AS",
	        Arizona: "AZ",
	        Arkansas: "AR",
	        California: "CA",
	        Colorado: "CO",
	        Connecticut: "CT",
	        Delaware: "DE",
	        "District Of Columbia": "DC",
	        "Federated States Of Micronesia": "FM",
	        Florida: "FL",
	        Georgia: "GA",
	        Guam: "GU",
	        Hawaii: "HI",
	        Idaho: "ID",
	        Illinois: "IL",
	        Indiana: "IN",
	        Iowa: "IA",
	        Kansas: "KS",
	        Kentucky: "KY",
	        Louisiana: "LA",
	        Maine: "ME",
	        "Marshall Islands": "MH",
	        Maryland: "MD",
	        Massachusetts: "MA",
	        Michigan: "MI",
	        Minnesota: "MN",
	        Mississippi: "MS",
	        Missouri: "MO",
	        Montana: "MT",
	        Nebraska: "NE",
	        Nevada: "NV",
	        "New Hampshire": "NH",
	        "New Jersey": "NJ",
	        "New Mexico": "NM",
	        "New York": "NY",
	        "North Carolina": "NC",
	        "North Dakota": "ND",
	        "Northern Mariana Islands": "MP",
	        Ohio: "OH",
	        Oklahoma: "OK",
	        Oregon: "OR",
	        Palau: "PW",
	        Pennsylvania: "PA",
	        "Puerto Rico": "PR",
	        "Rhode Island": "RI",
	        "South Carolina": "SC",
	        "South Dakota": "SD",
	        Tennessee: "TN",
	        Texas: "TX",
	        Utah: "UT",
	        Vermont: "VT",
	        "Virgin Islands": "VI",
	        Virginia: "VA",
	        Washington: "WA",
	        "West Virginia": "WV",
	        Wisconsin: "WI",
	        Wyoming: "WY"
	      };
	
	      return STATES[state];
	    }
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      this.$tracking.reportPostAJobSubmitStep("location");
	      this.$rootScope.$emit(_variables.TRIGGER_NEXT_EVENT_NAME, {
	        walkthroughState: this.walkthroughState
	      });
	    }
	  }]);
	
	  return LocationController;
	}();
	
	LocationController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = LocationController;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dateandtime = __webpack_require__(316);
	
	var _dateandtime2 = _interopRequireDefault(_dateandtime);
	
	var _dateandtime3 = __webpack_require__(317);
	
	var _dateandtime4 = _interopRequireDefault(_dateandtime3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateandtimeComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _dateandtime2.default,
	  controller: _dateandtime4.default,
	  controllerAs: "vm"
	};
	
	exports.default = dateandtimeComponent;

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <div class=\"main-title\">Date & Time</div>\n  <div class=\"main-text\">\n    <pajtooltip/>\n    Schedule your one time or recurring job below. If posting for more than 4 weeks, contact your account representative\n    for assistance. One-time jobs\n    can not be be posted for longer than one week. <br/><br/>\n    <span>Based on the current date, you’ll likely see the most engagement if your start date is between {{vm.startPost}} - {{vm.endPost}}.</span>\n  </div>\n\n  <div style=\"margin: 32px 0\">\n    <div\n      class=\"short-term-long-term-button\"\n      ng-click=\"vm.updateShortTermLongTerm(false)\"\n      style=\"border-radius: 6px 0 0 6px; opacity: {{vm.event.forced_long_term ? 0.2 : 1}}\"\n      ng-class=\"{'selected': !vm.event.is_long_term}\"\n    >\n      One-Time\n    </div>\n    <div\n      class=\"short-term-long-term-button\"\n      style=\"margin-left: -5px;border-radius: 0 6px 6px 0; opacity: {{vm.event.forced_one_time ? 0.2 : 1}}\"\n      ng-click=\"vm.updateShortTermLongTerm(true)\"\n      ng-class=\"{'selected': vm.event.is_long_term}\"\n    >\n      Recurring\n    </div>\n  </div>\n\n  <div style=\"margin-bottom: 100px\" ng-if=\"vm.event.is_long_term\">\n    <div style=\"margin-bottom: 32px\" id=\"date-selection\">\n      <div style=\"display: flex; margin-bottom: 16px\">\n        <div style=\"flex: 1; margin-right: 32px\">\n          <div class=\"main-label\">Start date:</div>\n          <div class=\"main-icon-select-container\">\n            <i class=\"fas fa-calendar main-icon\"></i>\n            <input\n              name=\"start-date\"\n              id=\"start-date\"\n              ng-model=\"vm.shiftLongTermGenerator.startDate\"\n              ng-change=\"vm.changeStartDate(); vm.validateLongTermShiftGenerator(); vm.generateLongTermShifts(true, true)\"\n              class=\"main-icon-select main-datepicker\"\n            />\n          </div>\n        </div>\n        <div style=\"flex: 1\">\n          <div class=\"main-label\">Number of weeks:</div>\n          <div class=\"main-icon-select-container\">\n            <i class=\"fas fa-calendar main-icon\"></i>\n            <select\n              class=\"main-icon-select\"\n              ng-model=\"vm.event.numberOfWeeksToScheduleJob\"\n              ng-change=\"vm.updateLongTermWeeks(vm.event.numberOfWeeksToScheduleJob); vm.validateLongTermShiftGenerator();\"\n            >\n              <option ng-repeat=\"week in vm.WEEKS_AVAILABLE\" value=\"{{week}}\">{{week + 1}}</option>\n            </select>\n            <i class=\"fas fa-caret-down down-icon\"></i>\n          </div>\n        </div>\n      </div>\n\n      <div style=\"display: flex; margin: 15px 0\">\n        <div\n          ng-repeat=\"day in vm.DAYS_OF_WEEK_OBJECTS\"\n          class=\"day-of-week-icon\"\n          ng-class=\"{'selected': vm.shiftLongTermGenerator.daysOfWeek.indexOf(day.value) !== -1}\"\n          ng-click=\"vm.toggleDayOfWeek(day.value);\"\n        >\n          {{day.label}}\n        </div>\n      </div>\n\n      <div style=\"display: flex\">\n        <div style=\"flex: 1; margin-right: 20px\">\n          <div class=\"main-label\">Start time:</div>\n          <div class=\"main-icon-select-container\" ng-if=\"false\">\n            <i class=\"far fa-clock main-icon\"></i>\n            <select\n              class=\"main-icon-select\"\n              style=\"padding-left: 34px\"\n              ng-model=\"vm.shiftLongTermGenerator.startTime\"\n              ng-change=\"vm.updateShiftGeneratorTime();vm.validateLongTermShiftGenerator()\"\n            >\n              <option ng-repeat=\"time in vm.times\" value=\"{{time.formatted}}\">{{time.formatted}}</option>\n            </select>\n            <i class=\"fas fa-caret-down down-icon\"></i>\n          </div>\n          <div style=\"display: flex\">\n            <div style=\"flex: 1; margin-right: 2px\">\n              <div class=\"main-icon-select-container\">\n                <select\n                  class=\"main-icon-select\"\n                  style=\"padding-left: 0px; text-align: center\"\n                  ng-model=\"vm.shiftLongTermGenerator.startTimeHour\"\n                  ng-change=\"vm.updateShiftGeneratorTime();vm.validateLongTermShiftGenerator()\"\n                >\n                  <option ng-repeat=\"hour in vm.HOURS\" value=\"{{hour}}\">{{hour}}</option>\n                </select>\n              </div>\n            </div>\n            <div style=\"flex: 1; margin-right: 2px\">\n              <div class=\"main-icon-select-container\">\n                <select\n                  class=\"main-icon-select\"\n                  style=\"padding-left: 0px; text-align: center\"\n                  ng-model=\"vm.shiftLongTermGenerator.startTimeMinute\"\n                  ng-change=\"vm.updateShiftGeneratorTime();vm.validateLongTermShiftGenerator()\"\n                >\n                  <option ng-repeat=\"minute in vm.MINUTES\" value=\"{{minute}}\">{{minute}}</option>\n                </select>\n              </div>\n            </div>\n            <div style=\"flex: 1\">\n              <div class=\"main-icon-select-container\">\n                <select\n                  class=\"main-icon-select\"\n                  style=\"padding-left: 0px; text-align: center\"\n                  ng-model=\"vm.shiftLongTermGenerator.startTimeAM\"\n                  ng-change=\"vm.updateShiftGeneratorTime(); vm.validateLongTermShiftGenerator()\"\n                >\n                  <option ng-repeat=\"am in ['AM', 'PM']\" value=\"{{am}}\">{{am}}</option>\n                </select>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div style=\"flex: 1; margin-right: 20px\">\n          <div class=\"main-label\">End time:</div>\n          <div class=\"main-icon-select-container\" ng-if=\"false\">\n            <i class=\"far fa-clock main-icon\"></i>\n            <select\n              class=\"main-icon-select\"\n              style=\"padding-left: 34px\"\n              ng-model=\"vm.shiftLongTermGenerator.endTime\"\n              ng-change=\"vm.validateLongTermShiftGenerator()\"\n            >\n              <option ng-repeat=\"time in vm.times\" value=\"{{time.formatted}}\">{{time.formatted}}</option>\n            </select>\n            <i class=\"fas fa-caret-down down-icon\"></i>\n          </div>\n          <div style=\"display: flex\">\n            <div style=\"flex: 1; margin-right: 2px\">\n              <div class=\"main-icon-select-container\">\n                <select\n                  class=\"main-icon-select\"\n                  style=\"padding-left: 0px; text-align: center\"\n                  ng-model=\"vm.shiftLongTermGenerator.endTimeHour\"\n                  ng-change=\"vm.updateShiftGeneratorTime();vm.validateLongTermShiftGenerator()\"\n                >\n                  <option ng-repeat=\"hour in vm.HOURS\" value=\"{{hour}}\">{{hour}}</option>\n                </select>\n              </div>\n            </div>\n            <div style=\"flex: 1; margin-right: 2px\">\n              <div class=\"main-icon-select-container\">\n                <select\n                  class=\"main-icon-select\"\n                  style=\"padding-left: 0px; text-align: center\"\n                  ng-model=\"vm.shiftLongTermGenerator.endTimeMinute\"\n                  ng-change=\"vm.updateShiftGeneratorTime();vm.validateLongTermShiftGenerator()\"\n                >\n                  <option ng-repeat=\"minute in vm.MINUTES\" value=\"{{minute}}\">{{minute}}</option>\n                </select>\n              </div>\n            </div>\n            <div style=\"flex: 1\">\n              <div class=\"main-icon-select-container\">\n                <select\n                  class=\"main-icon-select\"\n                  style=\"padding-left: 0px; text-align: center\"\n                  ng-model=\"vm.shiftLongTermGenerator.endTimeAM\"\n                  ng-change=\"vm.updateShiftGeneratorTime();vm.validateLongTermShiftGenerator()\"\n                >\n                  <option ng-repeat=\"am in ['AM', 'PM']\" value=\"{{am}}\">{{am}}</option>\n                </select>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div style=\"flex: 1\">\n          <div class=\"main-label\">Unpaid break:</div>\n          <div class=\"main-icon-select-container\">\n            <i class=\"far fa-clock main-icon\"></i>\n            <select\n              class=\"main-icon-select\"\n              style=\"padding-left: 34px\"\n              ng-change=\"vm.updateShiftGenerator(vm.shiftLongTermGenerator); vm.validateLongTermShiftGenerator();\"\n              ng-model=\"vm.shiftLongTermGenerator.unpaidBreak\"\n            >\n              <option ng-value=\"0\">0 min</option>\n              <option ng-value=\"15\">15 min</option>\n              <option ng-value=\"30\">30 min</option>\n              <option ng-value=\"45\">45 min</option>\n              <option ng-value=\"60\">60 min</option>\n            </select>\n            <i class=\"fas fa-caret-down down-icon\"></i>\n          </div>\n        </div>\n      </div>\n      <div style=\"display: none\">\n        <div style=\"flex: 1\">\n          <div class=\"checkbox-container\">\n            <input type=\"checkbox\" ng-model=\"vm.shiftLongTermGenerator.overnight\"\n                   ng-change=\"vm.$tracking.reportPostAJobClick('overnight flag');\"/>\n            Overnight shift\n          </div>\n        </div>\n      </div>\n      <div style=\"display: none\">\n        <div style=\"flex: 1\">\n          <div class=\"checkbox-container\" style=\"height: 35px; line-height: 35px; margin-top: 20px\">\n            <input\n              style=\"top: 10px\"\n              type=\"checkbox\"\n              ng-model=\"vm.shiftLongTermGenerator.hasUnpaidBreak\"\n              ng-change=\"vm.changedUnpaidShift(vm.shiftLongTermGenerator);vm.$tracking.reportPostAJobClick('unpaid break checkbox');\"\n            />\n            Includes\n            <div class=\"main-icon-select-container\"\n                 style=\"height: 35px; display: inline-block; width: 75px; font-size: 13px\">\n              <select\n                ng-change=\"vm.updateShiftGenerator(vm.shiftLongTermGenerator); vm.validateLongTermShiftGenerator();\"\n                ng-model=\"vm.shiftLongTermGenerator.unpaidBreak\"\n                class=\"main-icon-select\"\n                style=\"padding-left: 7px; height: 35px\"\n              >\n                <option ng-value=\"0\" disabled>0 min</option>\n                <option ng-value=\"15\">15 min</option>\n                <option ng-value=\"30\">30 min</option>\n                <option ng-value=\"45\">45 min</option>\n                <option ng-value=\"60\">60 min</option>\n              </select>\n              <i class=\"fas fa-caret-down down-icon\" style=\"right: 7px\"></i>\n            </div>\n            unpaid break\n          </div>\n        </div>\n      </div>\n      <div id=\"job-creation-error\" ng-if=\"vm.shiftLongTermGenerator.errors && vm.shiftLongTermGenerator.errors.length\">\n        Error: {{vm.shiftLongTermGenerator.errors}}\n      </div>\n    </div>\n\n    <div ng-if=\"vm.generatingLongTermShifts || vm.loadingSync\" class=\"main-next-button\"\n         style=\"opacity: 0.5; cursor: wait\">\n      {{vm.event.shifts && vm.event.shifts.length ? \"Updating\" : \"Saving\"}} <i\n      class=\"fas fa-spin fa-spinner fa-1x fa-fw\"></i>\n    </div>\n    <div\n      ng-if=\"!vm.generatingLongTermShifts && !vm.loadingSync\"\n      class=\"main-next-button\"\n      ng-class=\"{'disabled': !vm.generatorLongTermShiftValid, 'disabled': vm.loadingSync, 'disabled': !vm.shiftLongTermGenerator.startDate}\"\n      ng-click=\"vm.generateLongTermShifts()\"\n    >\n      {{vm.event.id ? \"Continue\" : \"Create shifts\"}}\n      <!--\n            <span ng-if=\"!vm.event.id\">Create</span>\n            <span ng-if=\"vm.event.id\">Update and continue</span>\n            -->\n    </div>\n  </div>\n\n  <div style=\"margin-bottom: 100px\" ng-if=\"vm.showGenerator && !vm.event.is_long_term\">\n    <div style=\"margin-bottom: 32px\" id=\"range-selection\">\n      <div style=\"display: flex; margin-bottom: 16px\">\n        <div style=\"flex: 1; margin-right: 32px\">\n          <div class=\"main-label\">Shift date(s):</div>\n          <div class=\"main-icon-select-container\">\n            <i class=\"fas fa-calendar main-icon\"></i>\n            <input\n              name=\"range-start\"\n              id=\"range-start\"\n              ng-model=\"vm.shiftGenerator.startDate\"\n              ng-change=\"vm.validateShiftGenerator()\"\n              class=\"main-icon-select\"\n            />\n          </div>\n        </div>\n        <div style=\"flex: 1\">\n          <div class=\"main-label\" style=\"color: #7a848d\">End date:</div>\n          <div class=\"main-icon-select-container\">\n            <i class=\"fas fa-calendar main-icon\"></i>\n            <input\n              name=\"range-end\"\n              id=\"range-end\"\n              class=\"main-icon-select\"\n              ng-model=\"vm.shiftGenerator.endDate\"\n              ng-change=\"vm.validateShiftGenerator()\"\n            />\n          </div>\n        </div>\n      </div>\n      <div style=\"display: flex\">\n        <div style=\"flex: 1; margin-right: 32px\">\n          <div class=\"main-label\">Start time:</div>\n          <div class=\"main-icon-select-container\">\n            <i class=\"far fa-clock main-icon\"></i>\n            <select class=\"main-icon-select\" ng-model=\"vm.shiftGenerator.startTime\"\n                    ng-change=\"vm.validateShiftGenerator()\">\n              <option ng-repeat=\"time in vm.times\" value=\"{{time.formatted}}\">{{time.formatted}}</option>\n            </select>\n            <i class=\"fas fa-caret-down down-icon\"></i>\n          </div>\n        </div>\n        <div style=\"flex: 1\">\n          <div class=\"main-label\">End time:</div>\n          <div class=\"main-icon-select-container\">\n            <i class=\"far fa-clock main-icon\"></i>\n            <select class=\"main-icon-select\" ng-model=\"vm.shiftGenerator.endTime\"\n                    ng-change=\"vm.validateShiftGenerator()\">\n              <option ng-repeat=\"time in vm.times\" value=\"{{time.formatted}}\">{{time.formatted}}</option>\n            </select>\n            <i class=\"fas fa-caret-down down-icon\"></i>\n          </div>\n        </div>\n      </div>\n      <div style=\"display: flex\">\n        <div style=\"flex: 1\">\n          <div class=\"checkbox-container\">\n            <input type=\"checkbox\" ng-model=\"vm.shiftGenerator.overnight\"\n                   ng-change=\"vm.$tracking.reportPostAJobClick('overnight flag');\"/>\n            Overnight shift\n          </div>\n        </div>\n      </div>\n      <div style=\"display: flex\">\n        <div style=\"flex: 1\">\n          <div class=\"checkbox-container\" style=\"height: 35px; line-height: 35px; margin-top: 20px\">\n            <input\n              style=\"top: 10px\"\n              type=\"checkbox\"\n              ng-model=\"vm.shiftGenerator.hasUnpaidBreak\"\n              ng-change=\"vm.changedUnpaidShift(vm.shiftGenerator);vm.$tracking.reportPostAJobClick('unpaid break checkbox');\"\n            />\n            Includes\n            <div class=\"main-icon-select-container\"\n                 style=\"height: 35px; display: inline-block; width: 75px; font-size: 13px\">\n              <select\n                ng-change=\"vm.updateShiftGenerator(vm.shiftGenerator); vm.validateShiftGenerator();\"\n                ng-model=\"vm.shiftGenerator.unpaidBreak\"\n                class=\"main-icon-select\"\n                style=\"padding-left: 7px; height: 35px\"\n              >\n                <option ng-value=\"0\" disabled>0 min</option>\n                <option ng-value=\"15\">15 min</option>\n                <option ng-value=\"30\">30 min</option>\n                <option ng-value=\"45\">45 min</option>\n                <option ng-value=\"60\">60 min</option>\n              </select>\n              <i class=\"fas fa-caret-down down-icon\" style=\"right: 7px\"></i>\n            </div>\n            unpaid break\n          </div>\n        </div>\n      </div>\n      <div style=\"margin-top: 8px; color: red\" ng-if=\"vm.shiftGenerator.errors && vm.shiftGenerator.errors.length\">\n        Error: {{vm.shiftGenerator.errors}}\n      </div>\n    </div>\n\n    <div ng-if=\"vm.generatingShift\" class=\"main-next-button\" style=\"opacity: 0.5; cursor: wait\">\n      Saving <i class=\"fas fa-spin fa-spinner fa-1x fa-fw\"></i>\n    </div>\n    <div ng-if=\"!vm.generatingShift\" class=\"main-next-button\" ng-class=\"{'disabled': !vm.generatorShiftValid}\"\n         ng-click=\"vm.generateShifts()\">\n      Next\n    </div>\n  </div>\n\n  <div ng-if=\"!vm.showGenerator && !vm.event.is_long_term\">\n    <div ng-if=\"vm.showReplacementGenerator\" style=\"margin-bottom: 100px\">\n      <div style=\"margin-bottom: 32px\" id=\"range-selection\">\n        <div style=\"display: flex; margin-bottom: 16px\">\n          <div style=\"flex: 1; margin-right: 32px\">\n            <div class=\"main-label\">Start Date:</div>\n            <div class=\"main-icon-select-container\">\n              <i class=\"fas fa-calendar main-icon\"></i>\n              <input\n                name=\"range-start\"\n                id=\"range-start\"\n                ng-model=\"vm.shiftGenerator.startDate\"\n                ng-change=\"vm.validateShiftGenerator()\"\n                class=\"main-icon-select\"\n              />\n            </div>\n          </div>\n          <div style=\"flex: 1\">\n            <div class=\"main-label\" style=\"color: #7a848d\">End Date:</div>\n            <div class=\"main-icon-select-container\">\n              <i class=\"fas fa-calendar main-icon\"></i>\n              <input\n                name=\"range-end\"\n                id=\"range-end\"\n                class=\"main-icon-select\"\n                ng-model=\"vm.shiftGenerator.endDate\"\n                ng-change=\"vm.validateShiftGenerator()\"\n              />\n            </div>\n          </div>\n        </div>\n        <div style=\"display: flex\">\n          <div style=\"flex: 1; margin-right: 32px\">\n            <div class=\"main-label\">Start time:</div>\n            <div class=\"main-icon-select-container\">\n              <i class=\"far fa-clock main-icon\"></i>\n              <select class=\"main-icon-select\" ng-model=\"vm.shiftGenerator.startTime\"\n                      ng-change=\"vm.validateShiftGenerator()\">\n                <option ng-repeat=\"time in vm.times\" value=\"{{time.formatted}}\">{{time.formatted}}</option>\n              </select>\n              <i class=\"fas fa-caret-down down-icon\"></i>\n            </div>\n          </div>\n          <div style=\"flex: 1\">\n            <div class=\"main-label\">End time:</div>\n            <div class=\"main-icon-select-container\">\n              <i class=\"far fa-clock main-icon\"></i>\n              <select class=\"main-icon-select\" ng-model=\"vm.shiftGenerator.endTime\"\n                      ng-change=\"vm.validateShiftGenerator()\">\n                <option ng-repeat=\"time in vm.times\" value=\"{{time.formatted}}\">{{time.formatted}}</option>\n              </select>\n              <i class=\"fas fa-caret-down down-icon\"></i>\n            </div>\n          </div>\n        </div>\n        <div style=\"display: flex\">\n          <div style=\"flex: 1\">\n            <div class=\"checkbox-container\">\n              <input type=\"checkbox\" ng-model=\"vm.shiftGenerator.overnight\"\n                     ng-change=\"vm.$tracking.reportPostAJobClick('overnight flag');\"/>\n              Overnight shift\n            </div>\n          </div>\n        </div>\n        <div style=\"display: flex\">\n          <div style=\"flex: 1\">\n            <div class=\"checkbox-container\" style=\"height: 35px; line-height: 35px; margin-top: 20px\">\n              <input\n                style=\"top: 10px\"\n                type=\"checkbox\"\n                ng-model=\"vm.shiftGenerator.hasUnpaidBreak\"\n                ng-change=\"vm.changedUnpaidShift(vm.shiftGenerator);vm.$tracking.reportPostAJobClick('unpaid break checkbox');\"\n              />\n              Includes\n              <div class=\"main-icon-select-container\"\n                   style=\"height: 35px; display: inline-block; width: 75px; font-size: 13px\">\n                <select\n                  ng-change=\"vm.updateShiftGenerator(vm.shiftGenerator); vm.validateShiftGenerator();\"\n                  ng-model=\"vm.shiftGenerator.unpaidBreak\"\n                  class=\"main-icon-select\"\n                  style=\"padding-left: 7px; height: 35px\"\n                >\n                  <option ng-value=\"0\" disabled>0 min</option>\n                  <option ng-value=\"15\">15 min</option>\n                  <option ng-value=\"30\">30 min</option>\n                  <option ng-value=\"45\">45 min</option>\n                  <option ng-value=\"60\">60 min</option>\n                </select>\n                <i class=\"fas fa-caret-down down-icon\" style=\"right: 7px\"></i>\n              </div>\n              unpaid break\n            </div>\n          </div>\n        </div>\n\n        <div style=\"margin-top: 8px; color: red\" ng-if=\"vm.shiftGenerator.errors && vm.shiftGenerator.errors.length\">\n          Error: {{vm.shiftGenerator.errors}}\n        </div>\n      </div>\n\n      <div ng-if=\"vm.replacingShifts\" class=\"main-next-button\" style=\"opacity: 0.5; cursor: wait\">\n        Saving <i class=\"fas fa-spin fa-spinner fa-1x fa-fw\"></i>\n      </div>\n      <div ng-if=\"!vm.replacingShifts\" class=\"main-next-button\" ng-class=\"{'disabled': !vm.generatorShiftValid}\"\n           ng-click=\"vm.generateShifts(true)\">\n        Next\n      </div>\n    </div>\n\n    <div ng-if=\"!vm.showReplacementGenerator\">\n      <div class=\"main-label\"\n           style=\"text-align: right; font-weight: 500; font-size: 16px; margin-bottom: 19px; margin-top: 32px\">\n        <span\n          style=\"cursor: pointer; color: #62c046\"\n          ng-click=\"vm.displayReplacementGenerator(); vm.$tracking.reportPostAJobClick('clear all shifts');\"\n        >Clear all shifts</span\n        >\n      </div>\n\n      <div>\n        <div ng-repeat=\"shift in vm.event.shifts track by $index\" style=\"margin-bottom: 32px\">\n          <div class=\"main-sub-title\">SHIFT {{$index + 1}}</div>\n          <div style=\"display: flex; margin-bottom: 16px\">\n            <div style=\"flex: 1; margin-right: 32px\">\n              <div class=\"main-label\">Start date:</div>\n              <div class=\"main-icon-select-container\">\n                <i class=\"fas fa-calendar main-icon\"></i>\n                <input\n                  ng-change=\"vm.syncEndDate(shift);vm.validateShifts();vm.updateShift(shift, true, 1);\"\n                  ng-class=\"{'disabled': true}\"\n                  ng-model=\"shift.startDate\"\n                  class=\"main-datepicker main-icon-select\"\n                />\n              </div>\n            </div>\n            <div style=\"flex: 1\">\n              <div class=\"main-label\">End date:</div>\n              <div class=\"main-icon-select-container\">\n                <i class=\"fas fa-calendar main-icon\"></i>\n                <input\n                  ng-change=\"vm.validateShifts();vm.updateShift(shift, true, 2);\"\n                  ng-model=\"shift.endDate\"\n                  ng-class=\"{'disabled': true}\"\n                  class=\"main-datepicker main-icon-select\"\n                />\n              </div>\n            </div>\n          </div>\n          <div style=\"display: flex\">\n            <div style=\"flex: 1; margin-right: 32px\">\n              <div class=\"main-label\">Start time:</div>\n              <div class=\"main-icon-select-container\">\n                <i class=\"far fa-clock main-icon\"></i>\n                <select ng-change=\"vm.validateShifts();vm.updateShift(shift, true, 3);\" ng-model=\"shift.startTime\"\n                        class=\"main-icon-select\">\n                  <option ng-repeat=\"time in vm.times\" value=\"{{time.formatted}}\">{{time.formatted}}</option>\n                </select>\n                <i class=\"fas fa-caret-down down-icon\"></i>\n              </div>\n            </div>\n            <div style=\"flex: 1\">\n              <div class=\"main-label\">End time:</div>\n              <div class=\"main-icon-select-container\">\n                <i class=\"far fa-clock main-icon\"></i>\n\n                <select ng-change=\"vm.validateShifts();vm.updateShift(shift, true, 4);\" ng-model=\"shift.endTime\"\n                        class=\"main-icon-select\">\n                  <!--\n                                    <option\n                                            ng-if=\"!shift.possibleEndTimes || shift.overnight\"\n                                            ng-repeat=\"time in vm.times\"\n                                            value=\"{{time.formatted}}\"\n                                    >\n                                        {{time.formatted}}\n                                    </option>\n                                    -->\n                  <!--\n                                    <option\n                                            ng-if=\"shift.possibleEndTimes && !shift.overnight\"\n                                            ng-repeat=\"time in shift.possibleEndTimes\"\n                                            value=\"{{time.formatted}}\"\n                                            ng-if=\"!shift.possibleEndTimes || shift.overnight\"\n                                    >-->\n                  <option ng-repeat=\"time in vm.times\" value=\"{{time.formatted}}\">{{time.formatted}}</option>\n                </select>\n                <i class=\"fas fa-caret-down down-icon\"></i>\n              </div>\n            </div>\n          </div>\n          <div style=\"display: flex\">\n            <div style=\"flex: 1\">\n              <div class=\"checkbox-container\">\n                <input\n                  type=\"checkbox\"\n                  ng-model=\"shift.overnight\"\n                  ng-change=\"vm.$tracking.reportPostAJobClick('overnight flag'); vm.syncEndDate(shift); vm.validateShifts();vm.updateShift(shift, true, 5);\"\n                />\n                Overnight shift\n              </div>\n            </div>\n            <div style=\"flex: 0 0 50px\">\n              <div style=\"float: right; cursor: pointer; margin-top: 24px\">\n                <i\n                  ng-if=\"vm.event.shifts.length > 1\"\n                  class=\"fas fa-trash-alt\"\n                  ng-click=\"vm.removeShift($index, shift); vm.validateShifts(); vm.$tracking.reportPostAJobClick('delete shift');\"\n                ></i>\n              </div>\n            </div>\n          </div>\n          <div style=\"display: flex\">\n            <div style=\"flex: 1\">\n              <div class=\"checkbox-container\" style=\"height: 35px; line-height: 35px; margin-top: 20px\">\n                <input\n                  style=\"top: 10px\"\n                  type=\"checkbox\"\n                  ng-model=\"shift.hasUnpaidBreak\"\n                  ng-change=\"vm.changedUnpaidShift(shift); vm.$tracking.reportPostAJobClick('unpaid break checkbox');\"\n                />\n                Includes\n\n                <div class=\"main-icon-select-container\"\n                     style=\"height: 35px; display: inline-block; width: 75px; font-size: 13px\">\n                  <select\n                    ng-change=\"vm.validateShifts();vm.updateShift(shift, true, 6);\"\n                    ng-model=\"shift.unpaidBreak\"\n                    class=\"main-icon-select\"\n                    style=\"padding-left: 7px; height: 35px\"\n                  >\n                    <option ng-value=\"0\" disabled>0 min</option>\n                    <option ng-value=\"15\">15 min</option>\n                    <option ng-value=\"30\">30 min</option>\n                    <option ng-value=\"45\">45 min</option>\n                    <option ng-value=\"60\">60 min</option>\n                  </select>\n                  <i class=\"fas fa-caret-down down-icon\" style=\"right: 7px\"></i>\n                </div>\n                unpaid break\n              </div>\n            </div>\n          </div>\n\n          <div style=\"flex;\" ng-if=\"false && ((vm.event.shifts.length == ($index + 1)) && vm.hide_remote_job != true)\">\n            <div class=\"job-scheduler\">\n              I would like this job scheduled for\n              <select\n                class=\"main-icon-select\"\n                style=\"padding-left: 7px; height: 35px; font-weight: 600; width: 100px; position: relative\"\n                ng-model=\"vm.numberOfWeeksToScheduleJob\"\n                ng-options=\"timeInterval for timeInterval in vm.timeIntervals\"\n                ng-change=\"vm.updateSchedule()\"\n              ></select>\n              <i\n                class=\"fas fa-caret-down down-icon\"\n                style=\"right: 95px; color: #6a7178; position: absolute; top: 14px; font-size: 12px; pointer-events: none\"\n              ></i>\n            </div>\n          </div>\n\n          <div style=\"margin-top: 8px; color: red\" ng-if=\"shift.errors && shift.errors.length\">Error: {{shift.errors}}\n          </div>\n        </div>\n\n        <div class=\"add-another-shift\" ng-click=\"vm.addNewShift()\" ng-class=\"{'disabled': !vm.allShiftsValid}\">+ Add\n          Another Shift\n        </div>\n      </div>\n    </div>\n  </div>\n  <div ng-if=\"!vm.showGenerator && !vm.showReplacementGenerator && !vm.event.is_long_term\">\n    <div ng-if=\"vm.savingStep\" class=\"main-next-button\" style=\"opacity: 0.5; cursor: wait\">\n      Saving <i class=\"fas fa-spin fa-spinner fa-1x fa-fw\"></i>\n    </div>\n    <div ng-if=\"!vm.savingStep\" class=\"main-next-button\" ng-class=\"{'disabled': !vm.allShiftsValid}\"\n         ng-click=\"vm.goNext()\">Next\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _async = __webpack_require__(318);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _variables = __webpack_require__(309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DAYS_OF_WEEK = {
	  MONDAY: 1,
	  TUESDAY: 2,
	  WEDNESDAY: 3,
	  THURSDAY: 4,
	  FRIDAY: 5,
	  SATURDAY: 6,
	  SUNDAY: 0
	};
	
	var GRACE_PERIOD = 1000 * 60 * 60 * 24 * 3;
	
	var DAYS_OF_WEEK_OBJECTS = [{
	  value: DAYS_OF_WEEK.SUNDAY,
	  label: "Sun"
	}, {
	  value: DAYS_OF_WEEK.MONDAY,
	  label: "Mon"
	}, {
	  value: DAYS_OF_WEEK.TUESDAY,
	  label: "Tue"
	}, {
	  value: DAYS_OF_WEEK.WEDNESDAY,
	  label: "Wed"
	}, {
	  value: DAYS_OF_WEEK.THURSDAY,
	  label: "Thu"
	}, {
	  value: DAYS_OF_WEEK.FRIDAY,
	  label: "Fri"
	}, {
	  value: DAYS_OF_WEEK.SATURDAY,
	  label: "Sat"
	}];
	
	var HOURS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
	var MINUTES = ["00", "15", "30", "45"];
	
	var DateandtimeController = function () {
	  function DateandtimeController($localStorage, $rootScope, $state, $stateParams, AuthService, EnvService, SecurityService, ngProgressFactory, $timeout, TrackingService, events, $location, $scope) {
	    var _this = this;
	
	    _classCallCheck(this, DateandtimeController);
	
	    this.name = "dateandtime";
	    this.walkthroughState = _variables.WALKTHROUGH_STATES.DATEANDTIME;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$progress = ngProgressFactory.createInstance();
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	    this.$location = $location;
	    this.$scope = $scope;
	    this.hide_remote_job = false;
	
	    this.$timeout(function () {
	      return _this.activateDatePickers();
	    }, 500);
	
	    this.API_FIELDS = "isLongTerm,weeks,subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.jobbleType.name, subEvents.deduppedJobbles.jobbleType.id,subEvents.deduppedJobbles.shifts.id,subEvents.deduppedJobbles.shifts.timeInterval.startTime,subEvents.deduppedJobbles.shifts.timeInterval.endTime,subEvents.deduppedJobbles.shifts.unpaidBreak,subEvents.deduppedJobbles.shifts.overnight,subEvents.deduppedJobbles.shifts.contactInfo.id,subEvents.deduppedJobbles.shifts.contactInfo.streetLine1,subEvents.deduppedJobbles.shifts.contactInfo.place.timeZoneId,subEvents.deduppedJobbles.shifts.contactInfo.city,subEvents.deduppedJobbles.shifts.contactInfo.lat,subEvents.deduppedJobbles.shifts.contactInfo.lng,subEvents.deduppedJobbles.shifts.contactInfo.state,subEvents.deduppedJobbles.shifts.contactInfo.zipCode";
	
	    this.times = this.generateTimes(0);
	    this.timeIntervals = _variables.SCHEDULING_INTERVALS;
	
	    var timeMap = {};
	    this.times.map(function (time) {
	      timeMap[time.formatted] = time.raw;
	    });
	
	    this.timeMap = timeMap;
	    this.numberOfWeeksToScheduleJob = "1 Week";
	    if (!this.$auth.isAdmin()) this.hide_remote_job = true;
	
	    this.$timeout(function () {
	      _this.shiftGenerator = _this.getNewShiftObject();
	      _this.shiftLongTermGenerator = _this.getNewLongTermShiftObject();
	      _this.validateShiftGenerator();
	    });
	
	    this.DAYS_OF_WEEK = DAYS_OF_WEEK;
	    this.DAYS_OF_WEEK_OBJECTS = DAYS_OF_WEEK_OBJECTS;
	    this.HOURS = HOURS;
	    this.MINUTES = MINUTES;
	    this.WEEKS_AVAILABLE = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36];
	
	    this.development_env = this.$env.getEnv();
	
	    this.PostAJobGlobalApiSyncLongTermListener = this.$rootScope.$on("PostAJobGlobalApiSyncLongTerm", function ($event, params) {
	      var event = params.event;
	
	      if (event) {
	        _this.$timeout(function () {
	          console.log("RRRRRR1");
	          //console.dir("removing button disable....");
	          $("#cloning-loading-event-data").modal("toggle");
	          $(".modal-backdrop").remove();
	          //this.$rootScope.postingLoadingStatus = 0;
	        }, 1500);
	      }
	    });
	
	    this.$scope.$on("$destroy", this.PostAJobGlobalApiSyncSingleJobListener);
	
	    this.PostAJobGlobalApiSyncSingleJobListener = this.$rootScope.$on("PostAJobGlobalApiSyncSingleJob", function ($event, params) {
	      var event = params.event;
	
	      if (event) {
	        _this.$timeout(function () {
	          //console.dir("removing button disable....");
	          console.log("RRRRRRRRR2");
	          $("#cloning-loading-event-data").modal("toggle");
	          $(".modal-backdrop").remove();
	          //this.$rootScope.postingLoadingStatus = 0;
	        }, 1500);
	      }
	    });
	
	    this.$scope.$on("$destroy", this.PostAJobGlobalApiSyncLongTermListener);
	    this.$scope.$on("$destroy", this.PostAJobGlobalApiSyncSingleJobListener);
	  }
	
	  _createClass(DateandtimeController, [{
	    key: "getNewShiftObject",
	    value: function getNewShiftObject() {
	      console.log("getNewShiftObjectgetNewShiftObjectgetNewShiftObjectgetNewShiftObjectgetNewShiftObjectgetNewShiftObjectgetNewShiftObject");
	      return {
	        startDate: null, //"08/21/2020",
	        endDate: null, //"08/21/2020",
	        startTime: "9:00 AM", //"8:00",
	        endTime: "5:00 PM", //"21:00",
	        startTimeHour: "9",
	        startTimeMinute: "00",
	        startTimeAM: "AM",
	        endTimeHour: "5",
	        endTimeMinute: "00",
	        endTimeAM: "PM",
	        overnight: false,
	        unpaidBreak: 0,
	        hasUnpaidBreak: false
	      };
	    }
	  }, {
	    key: "getNewLongTermShiftObject",
	    value: function getNewLongTermShiftObject() {
	      var shift = this.getNewShiftObject();
	      shift["weeks"] = "4";
	      shift["daysOfWeek"] = [1, 2, 3, 4, 5];
	      shift["unpaidBreak"] = 0;
	      return shift;
	    }
	  }, {
	    key: "toggleDayOfWeek",
	    value: function toggleDayOfWeek(day, force_add) {
	      var _this2 = this;
	
	      console.log("toggleDayOfWeek");
	      console.dir(day);
	      console.dir(force_add);
	      this.$timeout(function () {
	        if (_this2.shiftLongTermGenerator && _this2.shiftLongTermGenerator.daysOfWeek) {
	          var index = _this2.shiftLongTermGenerator.daysOfWeek.indexOf(day);
	          if (index !== -1 && !force_add) {
	            _this2.shiftLongTermGenerator.daysOfWeek.splice(index, 1);
	          } else {
	            _this2.shiftLongTermGenerator.daysOfWeek.push(day);
	          }
	
	          _this2.shiftLongTermGenerator.daysOfWeek = _.uniq(_this2.shiftLongTermGenerator.daysOfWeek);
	        }
	        _this2.validateLongTermShiftGenerator();
	      });
	    }
	  }, {
	    key: "generateTimes",
	    value: function generateTimes(tt, offset) {
	      // FROM THE INTERNET - eke, sept 12 2020
	      var x = 15; //minutes interval
	      var times = []; // time array
	      var ap = ["AM", "PM"]; // AM-PM
	
	      if (offset) tt = tt + x;
	
	      for (var i = 0; tt < 24 * 60; i++) {
	        var hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
	        var mm = tt % 60; // getting minutes of the hour in 0-55 format
	
	        times[i] = {
	          formatted: ("" + (hh === 12 || hh === 0 ? 12 : hh % 12)).slice(-2) + ":" + ("0" + mm).slice(-2) + " " + ap[Math.floor(hh / 12)],
	          raw: tt
	        };
	
	        tt = tt + x;
	      }
	      // END FROM THE INTERNET
	
	      return times;
	    }
	  }, {
	    key: "$onInit",
	    value: function $onInit() {
	      var _this3 = this;
	
	      //console.log("Init the date and time object");
	      console.log("$onInit");
	      var date = new Date();
	
	      var start = moment(new Date(date.setDate(date.getDate() + 6)));
	      var end = moment(new Date(date.setDate(date.getDate() + 11)));
	
	      this.startPost = start.format("MM/DD");
	      this.endPost = end.format("MM/DD");
	
	      this.validateShifts();
	
	      this.showGenerator = true;
	
	      if (this.event && this.event.shifts && this.event.shifts.length && this.event.shifts[0] !== null) {
	        this.showGenerator = false;
	        //console.log("These are the shifts:", this.event.shifts);
	        this.updateLongTermGenerator(this.event.shifts);
	      }
	
	      if (this.event && this.event.id) {
	        if (this.event && this.event.id && this.event.is_long_term) {
	          this.setLoader();
	          if (this.event.numberOfWeeksToScheduleJob && parseFloat(this.event.numberOfWeeksToScheduleJob)) {
	            //console.warn("We need to verify the value was saved in the API correctly");
	            this.updateLongTermWeeks(this.event.numberOfWeeksToScheduleJob, true).then(function () {
	              _this3.$timeout(function () {
	                _this3.syncWithApi();
	              }, 500);
	            }).catch(function () {
	              _this3.syncWithApi();
	            });
	          } else {
	            this.syncWithApi();
	          }
	        } else {
	          this.syncWithApi();
	        }
	      }
	    }
	  }, {
	    key: "updateLongTermGenerator",
	    value: function updateLongTermGenerator(shifts) {
	      var _this4 = this;
	
	      //console.log("PROCESSES SHIFTS:", shifts, this.shiftLongTermGenerator);
	      console.log("updateLongTermGeneratorupdateLongTermGeneratorupdateLongTermGeneratorupdateLongTermGenerator");
	      console.log("updateLongTermGeneratorupdateLongTermGeneratorupdateLongTermGeneratorupdateLongTermGeneratorupdateLongTermGenerator");
	      console.dir(shifts);
	
	      if (!this.shiftLongTermGenerator) this.shiftLongTermGenerator = this.getNewLongTermShiftObject();
	
	      if (shifts && shifts.length) {
	        this.$timeout(function () {
	          _this4.shiftLongTermGenerator.daysOfWeek = [];
	
	          try {
	            shifts.forEach(function (shift, i) {
	              var dayOfWeek = new Date(shift.startDate).getDay();
	              //console.log(shift.startDate, dayOfWeek);
	              _this4.shiftLongTermGenerator.daysOfWeek.push(dayOfWeek);
	              console.log("shiftLongTermGenerator shift");
	              console.dir(shift);
	              if (i === 0) {
	                _this4.shiftLongTermGenerator.startDate = shift.startDate;
	                _this4.shiftLongTermGenerator.startTime = shift.startTime;
	                _this4.shiftLongTermGenerator.startTimeHour = shift.startTimeHour;
	                _this4.shiftLongTermGenerator.startTimeMinute = shift.startTimeMinute;
	                _this4.shiftLongTermGenerator.startTimeAM = shift.startTimeAM;
	                _this4.shiftLongTermGenerator.endTime = shift.endTime;
	                _this4.shiftLongTermGenerator.endTimeHour = shift.endTimeHour;
	                _this4.shiftLongTermGenerator.endTimeMinute = shift.endTimeMinute;
	                _this4.shiftLongTermGenerator.endTimeAM = shift.endTimeAM;
	                _this4.shiftLongTermGenerator.overnight = shift.overnight;
	                _this4.shiftLongTermGenerator.unpaidBreak = shift.unpaidBreak;
	                _this4.shiftLongTermGenerator.hasUnpaidBreak = shift.hasUnpaidBreak;
	              }
	            });
	          } catch (err) {
	            console.log("error sifting through shifts");
	            console.dir(err);
	          } finally {
	            _this4.shiftLongTermGenerator.daysOfWeek = _.uniq(_this4.shiftLongTermGenerator.daysOfWeek);
	            _this4.validateLongTermShiftGenerator();
	          }
	        });
	      }
	    }
	  }, {
	    key: "processShifts",
	    value: function processShifts(shifts) {
	      var _this5 = this;
	
	      return shifts.map(function (shift) {
	        var startTime = moment(shift.timeInterval.startTime);
	        var endTime = moment(shift.timeInterval.endTime);
	        var startTimeFormatted = startTime.format("h:mm a").toUpperCase();
	
	        var tt = _this5.timeMap[startTimeFormatted];
	
	        return {
	          id: shift.id,
	          startDate: startTime.format("MM/DD/YYYY"),
	          endDate: endTime.format("MM/DD/YYYY"),
	          startTime: startTimeFormatted,
	          endTime: endTime.format("h:mm a").toUpperCase(),
	          overnight: shift.overnight,
	          contactInfo: shift.contactInfo,
	          possibleEndTimes: _this5.generateTimes(tt, true),
	          unpaidBreak: shift.unpaidBreak,
	          hasUnpaidBreak: shift.unpaidBreak > 0
	        };
	      });
	    }
	  }, {
	    key: "activateDatePickers",
	    value: function activateDatePickers() {
	      var _this6 = this;
	
	      this.validateShifts();
	
	      $(".main-datepicker").datepicker({
	        changeMonth: true,
	        changeYear: true,
	        minDate: "-0D",
	        maxDate: "+1Y",
	        yearRange: "0:+1"
	      });
	
	      var elem = document.getElementById("range-selection");
	
	      if (elem) {
	        this.datepicker = new DateRangePicker(elem, {
	          minDate: new Date()
	        });
	      }
	
	      var input = document.querySelector('input[name="range-start"]');
	      if (input) {
	        input.addEventListener("changeDate", function () {
	          var rangeStart = document.getElementById("range-start");
	          _this6.shiftGenerator.startDate = rangeStart.value;
	          var rangeEnd = document.getElementById("range-end");
	          _this6.shiftGenerator.endDate = rangeEnd.value;
	          _this6.validateShiftGenerator();
	        });
	      }
	      var input2 = document.querySelector('input[name="range-end"]');
	      if (input2) {
	        input2.addEventListener("changeDate", function () {
	          var rangeStart = document.getElementById("range-start");
	          _this6.shiftGenerator.startDate = rangeStart.value;
	          var rangeEnd = document.getElementById("range-end");
	          _this6.shiftGenerator.endDate = rangeEnd.value;
	          _this6.validateShiftGenerator();
	        });
	      }
	
	      var input3 = document.querySelector('input[name="start-date"]');
	      if (input3) {
	        input3.addEventListener("changeDate", function () {
	          var startDate = document.getElementById("start-date");
	          _this6.shiftLongTermGenerator.startDate = startDate.value;
	          _this6.validateLongTermShiftGenerator();
	        });
	      }
	    }
	  }, {
	    key: "changeStartDate",
	    value: function changeStartDate() {
	      console.log("NEW START DATE:", this.shiftLongTermGenerator.startDate);
	      var date = new Date(this.shiftLongTermGenerator.startDate);
	      this.toggleDayOfWeek(date.getDay(), true);
	    }
	  }, {
	    key: "generateLongTermShifts",
	    value: function generateLongTermShifts(replace, doNotMoveOn) {
	      var _this7 = this;
	
	      console.log("generateLongTermShifts");
	      console.dir(doNotMoveOn);
	      console.dir(replace);
	      //console.log("GENERATING LONG TERM SHIFTS");
	      //console.log(this.shiftLongTermGenerator);
	      var startDate = moment(this.shiftLongTermGenerator.startDate).format("MM/DD/YYYY");
	      console.log("there is not start date");
	      console.dir(startDate);
	      if (startDate === "Invalid date" || !startDate) {
	        this.unSetLoader();
	        alert("Please select a valid start date from the date picker before proceeding.");
	        return;
	      }
	
	      this.setLoader();
	      this.loadingSync = true;
	      var DATES = [];
	
	      var dayOfWeek = new Date(startDate).getDay();
	
	      //console.log(startDate, new Date(startDate).getDay());
	
	      this.shiftLongTermGenerator.daysOfWeek.forEach(function (day) {
	        var offset = 0;
	        if (day < dayOfWeek) {
	          offset = day + 7 - dayOfWeek;
	          //console.log(day, offset);
	        } else {
	          offset = day - dayOfWeek;
	          //console.log(day, offset);
	        }
	
	        var startDateDay = new Date(startDate);
	        var date = new Date(startDateDay.setDate(startDateDay.getDate() + offset));
	        date = moment(date).format("MM/DD/YYYY");
	        DATES.push(date);
	        //console.log(startDate, date);
	      });
	
	      DATES = DATES.sort(function (a, b) {
	        var timeA = new Date(a).getTime();
	        var timeB = new Date(b).getTime();
	        return timeA - timeB;
	      });
	      //console.log("DATES", DATES);
	
	      DATES = DATES.map(function (d) {
	        var date = _this7.getNewShiftObject();
	
	        date.overnight = _this7.shiftLongTermGenerator.overnight;
	        date.unpaidBreak = _this7.shiftLongTermGenerator.unpaidBreak && parseFloat(_this7.shiftLongTermGenerator.unpaidBreak) ? parseFloat(_this7.shiftLongTermGenerator.unpaidBreak) : 0;
	        date.startTime = _this7.shiftLongTermGenerator.startTime;
	        date.endTime = _this7.shiftLongTermGenerator.endTime;
	        date.startDate = d;
	        date.endDate = d;
	
	        var shiftStartTime = new Date(date.startDate + " " + date.startTime);
	        var shiftEndTime = new Date(date.startDate + " " + date.endTime);
	
	        if (shiftStartTime.getTime() > shiftEndTime.getTime()) {
	          date.overnight = true;
	        }
	
	        if (date.overnight) {
	          var day = new Date(date.startDate);
	          var newdate = new Date(day.setDate(day.getDate() + 1));
	          date.endDate = moment(newdate).format("MM/DD/YYYY");
	        }
	
	        return date;
	      });
	
	      //console.log("unpaidBreak DATES", DATES);
	      console.log("WE SHOULD NOT SEE THE EVENT ID HERE");
	      console.dir(this.event);
	      console.dir("what is replace");
	      console.dir(replace);
	
	      //check to see if shifts already exist with IDS .. if they do,
	      // that means we need to replace them with the new information otherwise proceed
	
	      if (this.event.id && this.event.shifts && this.event.shifts.length > 0) {
	        console.log("this.event.shifts[0].id");
	        console.dir(this.event.shifts[0].id);
	        if (this.event.shifts[0].id) {
	          var numberOfWeeksValid = this.validateNumberOfWeeks();
	          if (numberOfWeeksValid === false) {
	            this.event.numberOfWeeksToScheduleJob = "3";
	          } else {
	            this.event.numberOfWeeksToScheduleJob = this.event.numberOfWeeksToScheduleJob;
	          }
	          this.replaceShifts(this.event.shifts, DATES, replace, doNotMoveOn);
	          return;
	        }
	      }
	
	      this.event.shifts = DATES;
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	      this.validateShifts();
	
	      if (this.event.clonedFrom) {
	        this.cloneNewEvent(DATES, doNotMoveOn);
	      } else {
	        if (this.event.remote_job) {
	          this.createNewRemoteEvent(DATES);
	        } else {
	          console.log("create new event!");
	          this.createNewEvent(DATES, doNotMoveOn);
	        }
	      }
	    }
	  }, {
	    key: "validateNumberOfWeeks",
	    value: function validateNumberOfWeeks() {
	      var results = null;
	
	      if (this.event.numberOfWeeksToScheduleJob) {
	        if (this.event.numberOfWeeksToScheduleJob === "null") {
	          results = false;
	        } else if (this.event.numberOfWeeksToScheduleJob === null) {
	          results = false;
	        } else {
	          if (parseFloat(this.event.numberOfWeeksToScheduleJob) < 1) {
	            results = false;
	          } else {
	            results = true;
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return results;
	    }
	  }, {
	    key: "generateShifts",
	    value: function generateShifts(replace) {
	      var _this8 = this;
	
	      var dates = this.datepicker.getDates();
	
	      var start = dates[0];
	      var end = dates[1];
	
	      var startDate = moment(start).format("MM/DD/YYYY");
	      var endDate = moment(end).format("MM/DD/YYYY");
	
	      var DATES = [startDate];
	
	      var newDate = startDate;
	
	      while (new Date(newDate).getTime() < new Date(endDate).getTime()) {
	        var day = new Date(newDate);
	        var date = new Date(day.setDate(day.getDate() + 1));
	        date = moment(date).format("MM/DD/YYYY");
	        DATES.push(date);
	        newDate = date;
	        //console.log(newDate, endDate);
	        //console.log(new Date(newDate).getTime(), new Date(endDate).getTime());
	      }
	
	      //console.log("DATES", DATES);
	
	      DATES = DATES.map(function (d) {
	        var date = _this8.getNewShiftObject();
	
	        date.overnight = _this8.shiftGenerator.overnight;
	        date.unpaidBreak = _this8.shiftGenerator.unpaidBreak;
	        date.startTime = _this8.shiftGenerator.startTime;
	        date.endTime = _this8.shiftGenerator.endTime;
	        date.startDate = d;
	        date.endDate = d;
	
	        var shiftStartTime = new Date(date.startDate + " " + date.startTime);
	        var shiftEndTime = new Date(date.startDate + " " + date.endTime);
	
	        if (shiftStartTime.getTime() > shiftEndTime.getTime()) {
	          date.overnight = true;
	        }
	
	        if (date.overnight) {
	          var _day = new Date(date.startDate);
	          var newdate = new Date(_day.setDate(_day.getDate() + 1));
	          date.endDate = moment(newdate).format("MM/DD/YYYY");
	        }
	
	        return date;
	      });
	
	      //console.log("unpaidBreak DATES", DATES);
	
	      if (replace && this.event.id && this.event.shifts) {
	        this.replaceShifts(this.event.shifts, DATES);
	        return;
	      }
	
	      this.event.shifts = DATES;
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	      this.validateShifts();
	
	      if (this.event.clonedFrom) {
	        this.cloneNewEvent(DATES);
	      } else {
	        if (this.event.remote_job) {
	          this.createNewRemoteEvent(DATES);
	        } else {
	          this.createNewEvent(DATES);
	        }
	      }
	    }
	  }, {
	    key: "addNewShift",
	    value: function addNewShift() {
	      var _this9 = this;
	
	      var lastShift = JSON.parse(JSON.stringify(this.event.shifts[this.event.shifts.length - 1]));
	
	      if (lastShift.startDate) {
	        var date = new Date(lastShift.startDate);
	        lastShift.startDate = new Date(date.setDate(date.getDate() + 1));
	        lastShift.startDate = moment(lastShift.startDate).format("MM/DD/YYYY");
	      }
	
	      if (lastShift.endDate) {
	        var _date = new Date(lastShift.endDate);
	        lastShift.endDate = new Date(_date.setDate(_date.getDate() + 1));
	        lastShift.endDate = moment(lastShift.endDate).format("MM/DD/YYYY");
	      }
	
	      lastShift.id = null;
	
	      this.event.shifts.push(lastShift);
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	
	      this.validateShifts();
	
	      this.$events.adjustTimeZone(this.event.contactInfo.zipCode).then(function (_ref) {
	        var timeZone = _ref.timeZone,
	            timeZoneDifference = _ref.timeZoneDifference;
	
	        var _$events$adjustTimeZo = _this9.$events.adjustTimeZones(lastShift, timeZone, timeZoneDifference, false),
	            startTime = _$events$adjustTimeZo.startTime,
	            endTime = _$events$adjustTimeZo.endTime;
	
	        lastShift.timeInterval = {
	          startTime: startTime,
	          endTime: endTime
	        };
	
	        _this9.$events.createNewShiftForExistingEvent(_this9.jobble_id, null, null, lastShift).then(function (data) {
	          //console.log("Created new shift:", data);
	          _this9.$tracking.reportPostAJobClick("add another shift");
	          _this9.syncWithApi();
	        });
	      });
	
	      this.$timeout(function () {
	        return _this9.activateDatePickers();
	      }, 500);
	    }
	  }, {
	    key: "removeShift",
	    value: function removeShift(index, shift) {
	      if (!this.event || !this.event.shifts || !this.event.shifts.length) return;
	
	      if (this.event.shifts.length === 1) return;
	
	      this.event.shifts.splice(index, 1);
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	
	      this.validateShifts();
	
	      this.$events.deleteShift(shift).then(function (data) {
	        //console.log("Removed shift:", data);
	      });
	    }
	  }, {
	    key: "syncEndDate",
	    value: function syncEndDate(shift) {
	      //console.log("Syncing end date");
	
	      if (shift.overnight) {
	        var date = new Date(shift.startDate);
	        shift.endDate = new Date(date.setDate(date.getDate() + 1));
	        shift.endDate = moment(shift.endDate).format("MM/DD/YYYY");
	        console.log("updateShift 1");
	        this.updateShift(shift);
	      } else {
	        shift.endDate = shift.startDate;
	      }
	    }
	  }, {
	    key: "getShiftErrors",
	    value: function getShiftErrors(shift, generator) {
	      if (!shift || !shift.startDate || !shift.startTime || !shift.endDate || !shift.endTime) {
	        return null; //"All fields are required.";
	      }
	
	      var errors = [];
	
	      var startDate = new Date(shift.startDate + " " + shift.startTime);
	      var endDate = new Date(shift.endDate + " " + shift.endTime);
	
	      if (startDate.getTime() - new Date().getTime() <= 0) {
	        errors.push("the start time of this shift is in the past - please pick a start time that is later than the current time.");
	      }
	
	      if (endDate.getTime() - startDate.getTime() <= 0) {
	        errors.push("please pick an end time that is later than the start time.");
	      } else if (generator && shift.startTime === shift.endTime) {
	        errors.push("please pick an end time that is later than the start time.");
	      }
	
	      /*
	          if (this.development_env !== "dev" && (startDate.getTime() - new Date().getTime() <= GRACE_PERIOD)) {
	              errors.push("There must be at least 3 days before the start of the first shift.");
	          }
	          */
	
	      if (endDate.getTime() - startDate.getTime() > 1000 * 60 * 60 * 24 && !generator) {
	        errors.push("please pick a shift length less than 24 hours.");
	      }
	
	      if (this.development_env !== "dev" && endDate.getTime() - startDate.getTime() < 1000 * 60 * 60 * 6) {
	        errors.push("shifts must be a minimum of 6 hours long.");
	      }
	
	      return errors.join(" ");
	    }
	  }, {
	    key: "getLongTermShiftErrors",
	    value: function getLongTermShiftErrors(shift, generator) {
	      if (!shift || !shift.startDate || !shift.startTime || !shift.endTime) {
	        return null; //"All fields are required.";
	      }
	
	      var errors = [];
	
	      var startDate = new Date(shift.startDate + " " + shift.startTime);
	      var endDate = new Date(shift.startDate + " " + shift.endTime);
	
	      if (endDate.getTime() - startDate.getTime() <= 0) {
	        endDate = new Date(endDate.getTime() + 1000 * 60 * 60 * 24);
	      }
	
	      var shiftLength = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60);
	
	      if (startDate.getTime() - new Date().getTime() <= 0) {
	        errors.push("The start time of this shift is in the past - please pick a start time that is later than the current time.");
	      }
	
	      /*
	          if ((startDate.getTime() - new Date().getTime() <= GRACE_PERIOD)) {
	              errors.push("There must be at least 3 days before the start of the first shift.");
	          }
	          */
	
	      if (!shift.daysOfWeek || !shift.daysOfWeek.length || shift.daysOfWeek.length < 3) {
	        errors.push("There must be at least 3 shifts in a recurring job.");
	      }
	      if (this.development_env !== "dev" && shiftLength < 6) {
	        errors.push("Each shift must be a minimum of 6 hours long.");
	      }
	
	      // if (endDate.getTime() - startDate.getTime() <= 0) {
	      //     errors.push("please pick an end time that is later than the start time.");
	      // } else if (generator && shift.startTime === shift.endTime) {
	      //     errors.push("please pick an end time that is later than the start time.");
	      // }
	      //
	      // if (endDate.getTime() - startDate.getTime() > 1000 * 60 * 60 * 24 && !generator) {
	      //     errors.push("please pick a shift length less than 24 hours.");
	      // }
	
	      return errors.join(" ");
	    }
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      console.log("goNextKKK");
	      console.dir(this.event);
	      console.dir(_variables.TRIGGER_NEXT_EVENT_NAME);
	      console.dir(this.walkthroughState);
	      this.$rootScope.$emit(_variables.TRIGGER_NEXT_EVENT_NAME, {
	        walkthroughState: this.walkthroughState
	      });
	    }
	  }, {
	    key: "updateShiftGeneratorTime",
	    value: function updateShiftGeneratorTime() {
	      this.shiftLongTermGenerator.startTime = this.shiftLongTermGenerator.startTimeHour + ":" + this.shiftLongTermGenerator.startTimeMinute + " " + this.shiftLongTermGenerator.startTimeAM;
	
	      this.shiftLongTermGenerator.endTime = this.shiftLongTermGenerator.endTimeHour + ":" + this.shiftLongTermGenerator.endTimeMinute + " " + this.shiftLongTermGenerator.endTimeAM;
	    }
	  }, {
	    key: "validateShiftGenerator",
	    value: function validateShiftGenerator() {
	      var _this10 = this;
	
	      this.generatorShiftValid = true;
	
	      if (!this.shiftGenerator) {
	        this.generatorShiftValid = false;
	        this.$timeout(function () {
	          _this10.unSetLoader();
	        });
	        return false;
	      }
	
	      var valid = this.$events.validateWorflowShift(this.shiftGenerator, true);
	
	      if (this.shiftGenerator.startTime === this.shiftGenerator.endTime) valid = false;
	
	      this.$timeout(function () {
	        _this10.shiftGenerator.errors = _this10.getShiftErrors(_this10.shiftGenerator, true);
	        _this10.generatorShiftValid = valid;
	      });
	
	      return valid;
	    }
	  }, {
	    key: "validateLongTermShiftGenerator",
	    value: function validateLongTermShiftGenerator() {
	      var _this11 = this;
	
	      console.log("validateLongTermShiftGenerator");
	      this.generatorLongTermShiftValid = true;
	
	      //let valid = true;
	
	      if (!this.shiftLongTermGenerator) {
	        this.generatorLongTermShiftValid = false;
	        return false;
	      }
	
	      var valid = this.$events.validateLongTermGenerator(this.shiftLongTermGenerator, true);
	
	      if (this.shiftLongTermGenerator.startTime === this.shiftLongTermGenerator.endTime) valid = false;
	
	      //console.log(this.shiftLongTermGenerator);
	      if (!this.shiftLongTermGenerator.daysOfWeek || !this.shiftLongTermGenerator.daysOfWeek.length) {
	        valid = false;
	      }
	
	      if (!this.event.numberOfWeeksToScheduleJob) valid = false;
	
	      this.$timeout(function () {
	        _this11.shiftLongTermGenerator.errors = _this11.getLongTermShiftErrors(_this11.shiftLongTermGenerator, true);
	        _this11.generatorLongTermShiftValid = valid;
	        _this11.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	      });
	
	      return valid;
	    }
	  }, {
	    key: "determineWhereToGo",
	    value: function determineWhereToGo(doNotMoveOn) {
	      var _this12 = this;
	
	      var goNext = void 0;
	      this.hideReplacementGenerator();
	      this.$tracking.reportPostAJobSubmitStep("replace date & time");
	
	      console.log("determineWhereToGo");
	      console.dir(doNotMoveOn);
	
	      if (doNotMoveOn && doNotMoveOn === true) {
	        goNext = false;
	      } else {
	        goNext = true;
	      }
	
	      this.$timeout(function () {
	        _this12.shiftGenerator = _this12.getNewShiftObject();
	      }, 200);
	
	      this.$timeout(function () {
	        _this12.syncWithApi(goNext);
	      }, 1000);
	    }
	  }, {
	    key: "deleteExistingShifts",
	    value: function deleteExistingShifts(originalShifts, doNotMoveOn) {
	      var _this13 = this;
	
	      console.log("deleteExistingShifts");
	      console.dir(originalShifts);
	
	      var shiftIds = [];
	
	      if (this.event.shifts) {
	        try {
	          originalShifts.forEach(function (shift, i) {
	            shiftIds.push(shift.id);
	          });
	        } catch (err) {
	          console.log("error deleting shifts");
	          console.dir(err);
	        } finally {
	          console.log("shift ids for deletion");
	          console.dir(shiftIds);
	          this.$timeout(function () {
	            _this13.$events.bulkDeleteShifts(shiftIds).then(function (response) {
	              console.log("response from bulk delete");
	              console.dir(response);
	              _this13.determineWhereToGo(doNotMoveOn);
	            }).catch(function (err) {
	              console.log("error with bulk delete");
	              console.dir(err);
	            });
	          }, 2000);
	        }
	      }
	    }
	  }, {
	    key: "formatPayload",
	    value: function formatPayload(timeIntervalsArray) {
	      var _this14 = this;
	
	      var shiftArray = [];
	
	      try {
	        timeIntervalsArray.forEach(function (shift, i) {
	          var s = {
	            jobbleId: _this14.jobble_id,
	            contactInfo: {
	              city: shift.contactInfo.city,
	              state: shift.contactInfo.state,
	              streetLine1: shift.contactInfo.streetLine1,
	              streetLine2: null,
	              zipCode: shift.contactInfo.zipCode,
	              lat: shift.contactInfo.lat,
	              lng: shift.contactInfo.lng
	            },
	            timeInterval: {
	              startTime: shift.startDateAndTimeForDB,
	              endTime: shift.endDateAndTimeForDB
	            },
	            overnight: shift.overnight
	          };
	
	          if (shift.unpaidBreak && shift.unpaidBreak > 0) {
	            s.unpaidBreak = shift.unpaidBreak;
	          }
	
	          shiftArray.push(s);
	        });
	      } catch (err) {
	        console.log("error formatting shifts");
	        console.dir(err);
	        return err;
	      } finally {
	        console.log("paylaod for creation");
	        console.dir(shiftArray);
	        return shiftArray;
	      }
	    }
	  }, {
	    key: "replaceShifts",
	    value: function replaceShifts(originalShifts, newShifts, replace, doNotMoveOn) {
	      var _this15 = this;
	
	      this.$timeout(function () {
	        _this15.replacingShifts = true;
	        _this15.generatingLongTermShifts = true;
	      });
	
	      console.log("replaceShifts");
	      console.dir(originalShifts);
	      console.dir(newShifts);
	      console.dir(replace);
	      console.dir(this.event);
	      console.dir(this.jobble_id);
	
	      //const firstShift = originalShifts[0];
	      //originalShifts.splice(0, 1);
	
	      this.$events.adjustTimeZone(this.event.contactInfo.zipCode).then(function (_ref2) {
	        var timeZone = _ref2.timeZone,
	            timeZoneDifference = _ref2.timeZoneDifference;
	
	        var timeIntervalsArray = newShifts.map(function (shift) {
	          var _$events$adjustTimeZo2 = _this15.$events.adjustTimeZones(shift, timeZone, timeZoneDifference, false),
	              startTime = _$events$adjustTimeZo2.startTime,
	              endTime = _$events$adjustTimeZo2.endTime;
	
	          return {
	            contactInfo: _this15.event.contactInfo,
	            startDateAndTimeForDB: startTime,
	            endDateAndTimeForDB: endTime,
	            overnight: shift.overnight,
	            unpaidBreak: shift.unpaidBreak && parseFloat(shift.unpaidBreak) ? parseFloat(shift.unpaidBreak) : 0
	          };
	        });
	
	        console.log("what is the times interval array now");
	        console.dir(timeIntervalsArray);
	
	        var payload = _this15.formatPayload(timeIntervalsArray);
	
	        console.log("payload ready");
	        console.dir(payload);
	        console.dir(JSON.stringify(payload, null, 4));
	        _this15.$events.createNewShiftForExistingEventBulk(payload).then(function (response) {
	          console.log("Created new shifts:");
	          console.dir(response);
	          _this15.deleteExistingShifts(originalShifts, doNotMoveOn);
	        }).catch(function (err) {
	          console.error(err);
	          console.dir(err);
	        });
	      });
	    }
	  }, {
	    key: "displayReplacementGenerator",
	    value: function displayReplacementGenerator() {
	      var _this16 = this;
	
	      this.$timeout(function () {
	        _this16.showReplacementGenerator = true;
	      });
	      this.$timeout(function () {
	        _this16.shiftGenerator = _this16.getNewShiftObject();
	        _this16.validateShiftGenerator();
	      });
	      this.$timeout(function () {
	        _this16.activateDatePickers();
	        //this.deleteExistingShifts();
	      }, 500);
	    }
	  }, {
	    key: "hideReplacementGenerator",
	    value: function hideReplacementGenerator() {
	      var _this17 = this;
	
	      this.$timeout(function () {
	        _this17.showReplacementGenerator = false;
	      });
	    }
	  }, {
	    key: "validateShifts",
	    value: function validateShifts() {
	      var _this18 = this;
	
	      this.allShiftsValid = true;
	
	      if (!this.event || !this.event.shifts || !this.event.shifts.length) {
	        this.allShiftsValid = false;
	        return false;
	      }
	
	      this.validShifts = this.event.shifts.map(function (shift) {
	        var valid = _this18.$events.validateWorflowShift(shift);
	
	        if (!valid) _this18.allShiftsValid = false;
	
	        return valid;
	      });
	
	      var overlapping = false;
	
	      if (this.allShiftsValid) {
	        if (!this.$events.validateWorflowShiftsNonOverlapping(this.event.shifts)) {
	          this.allShiftsValid = false;
	          overlapping = true;
	        }
	      }
	
	      this.event.shifts = this.event.shifts.map(function (shift) {
	        if (!shift) return shift;
	
	        shift.errors = _this18.getShiftErrors(shift);
	        if (overlapping) {
	          shift.errors = "please select a start & end time that does not overlap with the other shifts in this job posting. " + shift.errors;
	          shift.errors = shift.errors.trim();
	        }
	
	        return shift;
	      });
	    }
	  }, {
	    key: "cloneNewEvent",
	    value: function cloneNewEvent(shifts) {
	      var _this19 = this;
	
	      console.log("cloneNewEvent");
	      console.dir(this.event);
	
	      this.$events.adjustTimeZone(this.event.contactInfo.zipCode).then(function (_ref3) {
	        var timeZone = _ref3.timeZone,
	            timeZoneDifference = _ref3.timeZoneDifference;
	
	        var timeIntervalsArray = shifts.map(function (shift) {
	          var _$events$adjustTimeZo3 = _this19.$events.adjustTimeZones(shift, timeZone, timeZoneDifference, false),
	              startTime = _$events$adjustTimeZo3.startTime,
	              endTime = _$events$adjustTimeZo3.endTime;
	
	          return {
	            contactInfo: _this19.event.contactInfo,
	            startDateAndTimeForDB: startTime,
	            endDateAndTimeForDB: endTime,
	            overnight: shift.overnight,
	            unpaidBreak: shift.unpaidBreak && parseFloat(shift.unpaidBreak) ? parseFloat(shift.unpaidBreak) : 0
	          };
	        });
	
	        var warehouse_jobble_type = _this19.$rootScope.warehouse_jobble_type || {};
	
	        var currentUser = _this19.$auth.getUserData();
	        var rate = currentUser.company.defaultPlan.jobblerFeePct;
	        var epi = 0.00001;
	
	        var p = 100 - rate * 100;
	        var x = parseFloat(_this19.event.hourly_rate) * 100;
	        var z = x / p;
	
	        var payPerHour = Math.round((z + epi) * 100) / 100;
	
	        console.log("payPerHour");
	        console.dir(payPerHour);
	
	        var event = {
	          name: _this19.event.shift_title || "DEFAULT_EVENT_TITLE_CLONED",
	          openings: _this19.event.openings || 10,
	          typeOfJobPosting: "regular",
	          dress_code: _this19.event.dress_code || _variables.DRESS_CODE_DEFAULT,
	          timeIntervalsArray: timeIntervalsArray,
	          isW2: _this19.event.is_w2,
	          jobble_type: parseFloat(_this19.event.position_type) || warehouse_jobble_type.id || 8,
	          manager: _this19.event.hiring_manager,
	          jobble_details: _this19.event.shift_description,
	          is_long_term: _this19.event.is_long_term,
	          weeks: _this19.event.numberOfWeeksToScheduleJob,
	          hourly_rate: payPerHour
	        };
	
	        _this19.$timeout(function () {
	          _this19.generatingShift = true;
	        });
	
	        _this19.$events.saveDraftv2(event, _this19.event.clonedFrom).then(function (data) {
	          _this19.$timeout(function () {
	            _this19.generatingShift = false;
	          });
	          _this19.showGenerator = false;
	
	          _this19.$timeout(function () {
	            _this19.shiftGenerator = _this19.getNewShiftObject();
	            _this19.validateShiftGenerator();
	          });
	
	          //console.log("Created new event from clone:", data);
	
	          _this19.$tracking.reportPostAJobSubmitStep("clone event");
	          _this19.$tracking.reportPostAJobSubmitStep("date & time");
	
	          _this19.event.id = data.data.jobblePool.eventId;
	          _this19.$state.transitionTo("postashiftwalkthrough", { eid: _this19.event.id }, { notify: false });
	          //this.$location.search("eid", this.event.id);
	          _this19.$location.search("cid", null);
	          _this19.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	
	          if (_this19.event.questions && _this19.event.questions.length) {
	            var _data = {
	              event_id: _this19.event.id,
	              questions: _this19.event.questions
	            };
	
	            _this19.$events.updateQuestion(_data).then(function (data) {
	              //console.log("Saved questions for clone:", data);
	            }).catch(function (err) {
	              //console.error("Error savings questions for clone:", data);
	            });
	          }
	
	          if (_this19.event.requirements && _this19.event.requirements.length) {
	            _this19.$events.addShiftRequirements(_this19.event.id, _this19.event.requirements).then(function (data) {
	              //console.log("Saved requirements for clone:", data);
	            });
	          }
	
	          if (_this19.event.is_long_term) {
	            var numberOfWeeksValid = _this19.validateNumberOfWeeks();
	
	            if (numberOfWeeksValid === false) {
	              _this19.event.numberOfWeeksToScheduleJob = "3";
	            } else {
	              _this19.event.numberOfWeeksToScheduleJob = data.data.weeks + "";
	            }
	
	            _this19.updateLongTermWeeks(_this19.event.numberOfWeeksToScheduleJob).then(function () {
	              //console.log("Done syncing with the API after event creation", this.event);
	              _this19.goNext();
	              _this19.$timeout(function () {
	                _this19.generatingLongTermShifts = false;
	              }, 2000);
	            }).catch(function (e) {
	              _this19.goNext();
	              _this19.$timeout(function () {
	                _this19.generatingLongTermShifts = false;
	              }, 2000);
	            });
	          } else {
	            _this19.syncWithApi();
	            _this19.$timeout(function () {
	              _this19.generatingLongTermShifts = false;
	            }, 2000);
	          }
	        }).catch(function (err) {
	          //console.error("Error creating new event from clone:", err);
	        });
	      });
	    }
	  }, {
	    key: "createNewEvent",
	    value: function createNewEvent(shifts, doNotMoveOn) {
	      var _this20 = this;
	
	      this.$events.adjustTimeZone(this.event.contactInfo.zipCode).then(function (_ref4) {
	        var timeZone = _ref4.timeZone,
	            timeZoneDifference = _ref4.timeZoneDifference,
	            state = _ref4.state;
	
	        var timeIntervalsArray = shifts.map(function (shift) {
	
	          console.log("shift before on creation");
	          console.dir(shift);
	
	          var _$events$adjustTimeZo4 = _this20.$events.adjustTimeZones(shift, timeZone, timeZoneDifference, state, false),
	              startTime = _$events$adjustTimeZo4.startTime,
	              endTime = _$events$adjustTimeZo4.endTime;
	
	          return {
	            contactInfo: _this20.event.contactInfo,
	            startDateAndTimeForDB: startTime,
	            endDateAndTimeForDB: endTime,
	            overnight: shift.overnight,
	            unpaidBreak: shift.unpaidBreak && parseFloat(shift.unpaidBreak) ? parseFloat(shift.unpaidBreak) : 0
	          };
	        });
	
	        var warehouse_jobble_type = _this20.$rootScope.warehouse_jobble_type || {};
	
	        var event = {
	          name: "DEFAULT_EVENT_TITLE",
	          dress_code: _variables.DRESS_CODE_DEFAULT,
	          openings: 10,
	          isW2: _this20.event.is_w2,
	          typeOfJobPosting: "regular",
	          timeIntervalsArray: timeIntervalsArray,
	          jobble_type: _this20.event.position_type && _this20.event.position_type !== "null" ? _this20.event.position_type : warehouse_jobble_type.id || 8,
	          manager: _this20.event.hiring_manager,
	          is_long_term: _this20.event.is_long_term
	        };
	
	        if (_this20.event.is_long_term) {
	          event.weeks = _this20.event.numberOfWeeksToScheduleJob;
	        }
	
	        _this20.$timeout(function () {
	          _this20.generatingShift = true;
	          _this20.generatingLongTermShifts = true;
	        });
	
	        _this20.$events.saveDraftv2(event).then(function (data) {
	          console.log("createNewEvent Response");
	          console.dir(data);
	
	          _this20.$timeout(function () {
	            _this20.generatingShift = false;
	            _this20.generatingLongTermShifts = false;
	          });
	
	          _this20.showGenerator = false;
	          _this20.$timeout(function () {
	            _this20.shiftGenerator = _this20.getNewShiftObject();
	            _this20.validateShiftGenerator();
	          });
	          _this20.event.id = data.data.jobblePool.eventId;
	          _this20.jobble_id = data.data.jobblePool.jobbles[0].id;
	          _this20.event.back_end_loaded = true;
	          _this20.$state.transitionTo("postashiftwalkthrough", { eid: _this20.event.id }, { notify: false });
	          _this20.$tracking.reportPostAJobSubmitStep("date & time");
	
	          if (doNotMoveOn === true) {
	            _this20.syncWithApi(false);
	          } else {
	            _this20.syncWithApi();
	            _this20.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	          }
	
	          if (_this20.event.is_long_term) {
	            //this.event.numberOfWeeksToScheduleJob = event.weeks;
	            var numberOfWeeksValid = _this20.validateNumberOfWeeks();
	
	            if (numberOfWeeksValid === false) {
	              _this20.event.numberOfWeeksToScheduleJob = "3";
	            } else {
	              _this20.event.numberOfWeeksToScheduleJob = data.data.weeks + "";
	            }
	
	            _this20.updateLongTermWeeks(_this20.event.numberOfWeeksToScheduleJob, true).then(function () {
	              if (doNotMoveOn === true) {} else {
	                _this20.$timeout(function () {
	                  _this20.goNext();
	                }, 1000);
	              }
	            }).catch(function (e) {
	              if (doNotMoveOn === true) {} else {
	                _this20.$timeout(function () {
	                  _this20.goNext();
	                }, 1000);
	              }
	            });
	          } else {
	            //this.syncWithApi();
	            _this20.$timeout(function () {
	              _this20.generatingLongTermShifts = false;
	            }, 500);
	          }
	        }).catch(function (err) {
	          //console.error("Error creating new event:", err);
	          //TODO alert("Error creating an event, please try again.");
	        });
	      });
	    }
	  }, {
	    key: "syncWithApi",
	    value: function syncWithApi(goNext) {
	      var _this21 = this;
	
	      //console.log("sync with API is being called");
	
	      this.loadingSync = true;
	      this.setLoader();
	      this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then(function (data) {
	        console.log("sync with API is done", data.data);
	        //console.log("DATA BEFORE THE API SYNC:", JSON.stringify(this.event, null, 4));
	        _this21.jobble_id = data.data.subEvents[0].deduppedJobbles[0].id;
	        _this21.event.is_long_term = data.data.isLongTerm;
	
	        if (_this21.event.is_long_term === true) {
	          var numberOfWeeksValid = _this21.validateNumberOfWeeks();
	
	          console.log("numberOfWeeksValid");
	          console.dir(numberOfWeeksValid);
	
	          if (numberOfWeeksValid === false) {
	            data.data.weeks = "11";
	            _this21.event.numberOfWeeksToScheduleJob = "11";
	          } else {
	            _this21.event.numberOfWeeksToScheduleJob = data.data.weeks + "";
	          }
	        }
	
	        var jobbleType = data.data.subEvents[0].deduppedJobbles[0].jobbleType;
	        _this21.event.position_type = jobbleType.id + "";
	
	        var update_is_long_term = false;
	        var is_long_term_value = null;
	
	        if (_this21.$rootScope.warehouse_jobble_type && _this21.$rootScope.warehouse_jobble_type.id) {
	          if (_this21.$rootScope.warehouse_jobble_type.id + "" === _this21.event.position_type + "") {
	            //console.log("Picked Warehouse Job Type");
	
	            //this.event.forced_long_term = true;
	
	            if (!_this21.event.is_long_term) {
	              //update_is_long_term = true;
	              //is_long_term_value = true;
	            }
	          }
	        }
	
	        if (_this21.$rootScope.event_jobble_type && _this21.$rootScope.event_jobble_type.id) {
	          if (_this21.$rootScope.event_jobble_type.id + "" === _this21.event.position_type + "") {
	            //console.log("Picked Event Staff Job Type");
	            _this21.event.forced_one_time = true;
	
	            if (_this21.event.is_long_term) {
	              //update_is_long_term = true;
	              //is_long_term_value = false;
	            }
	          }
	        }
	
	        //console.log("update_is_long_term", update_is_long_term, is_long_term_value);
	        var shifts = _this21.processShifts(data.data.subEvents[0].deduppedJobbles[0].shifts);
	
	        shifts = shifts.sort(function (a, b) {
	          return new Date(a.startDate + " " + a.startTime).getTime() - new Date(b.startDate + " " + b.startTime).getTime();
	        });
	
	        //console.log("DATA AFTER THE API SYNC:", JSON.stringify(this.event, null, 4));
	
	        //console.log("shifts after processing");
	        //console.dir(shifts);
	        //console.dir(this.event);
	
	        _this21.$events.adjustTimeZone(_this21.event.contactInfo.zipCode).then(function (_ref5) {
	          var timeZone = _ref5.timeZone,
	              timeZoneDifference = _ref5.timeZoneDifference,
	              state = _ref5.state,
	              browserTimeZone = _ref5.browserTimeZone;
	
	          _this21.$timeout(function () {
	            //console.log("This was before there was a change");
	
	            try {
	              _this21.event.shifts = shifts.map(function (shift) {
	
	                var remove = void 0;
	                if (timeZone === "America/Phoenix") {
	                  remove = false;
	                } else {
	                  remove = false;
	                }
	
	                var _$events$adjustTimeZo5 = _this21.$events.adjustTimeZones(shift, timeZone, timeZoneDifference, state, true),
	                    startTime = _$events$adjustTimeZo5.startTime,
	                    endTime = _$events$adjustTimeZo5.endTime;
	
	                startTime = new Date(startTime);
	                endTime = new Date(endTime);
	
	                startTime = moment(startTime).tz(timeZone);
	                endTime = moment(endTime).tz(timeZone);
	
	                var start = new Date(shift.startDate + " " + shift.startTime);
	                var end = new Date(shift.endDate + " " + shift.endTime);
	                var startMoment = moment(start).tz(shift.contactInfo.timeZoneId);
	                var endMoment = moment(end).tz(shift.contactInfo.timeZoneId);
	
	                return {
	                  id: shift.id,
	                  startDate: startMoment.format("MM/DD/YYYY"),
	                  endDate: endMoment.format("MM/DD/YYYY"),
	                  startTime: startMoment.format("h:mm a").toUpperCase(),
	                  startTimeHour: startMoment.format("h").toUpperCase(),
	                  startTimeMinute: startMoment.format("mm").toUpperCase(),
	                  startTimeAM: startMoment.format("a").toUpperCase(),
	                  endTime: endMoment.format("h:mm a").toUpperCase(),
	                  endTimeHour: endMoment.format("h").toUpperCase(),
	                  endTimeMinute: endMoment.format("mm").toUpperCase(),
	                  endTimeAM: endMoment.format("a").toUpperCase(),
	                  overnight: shift.overnight,
	                  contactInfo: shift.contactInfo,
	                  possibleEndTimes: shift.possibleEndTimes,
	                  unpaidBreak: shift.unpaidBreak,
	                  hasUnpaidBreak: shift.unpaidBreak > 0
	                };
	              });
	            } finally {
	              console.log("this.event.shifts");
	              console.dir(_this21.event.shifts);
	              _this21.updateLongTermGenerator(_this21.event.shifts, goNext);
	              //this.$scope.$apply();
	            }
	
	            if (goNext !== false) {
	              _this21.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	            }
	
	            //this.validateShifts();
	
	            _this21.$timeout(function () {
	              _this21.loadingSync = false;
	            }, 800);
	
	            _this21.$timeout(function () {
	              _this21.unSetLoader();
	            }, 1000);
	
	            console.log("update_is_long_term");
	            console.dir(update_is_long_term);
	
	            if (update_is_long_term) {
	              _this21.updateLongTermGenerator(_this21.event.shifts);
	
	              _this21.$timeout(function () {
	                _this21.event.is_long_term = is_long_term_value;
	
	                _this21.$timeout(function () {
	                  _this21.activateDatePickers();
	                }, 300);
	
	                if (is_long_term_value && _this21.event.shifts && _this21.event.shifts.length && _this21.event.id) {
	                  _this21.$timeout(function () {
	                    _this21.generatingLongTermShifts = true;
	                  });
	                  _this21.$events.saveEventLongTermShortTerm(_this21.event.id, is_long_term_value).then(function (data) {
	                    //console.log("Updated short/long term event:", data);
	                    _this21.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	                    _this21.generateLongTermShifts(true);
	                  });
	                } else {
	                  if (_this21.event.id) {
	                    _this21.$events.saveEventLongTermShortTerm(_this21.event.id, is_long_term_value).then(function (data) {
	                      //console.log("Updated short/long term event:", data);
	                      _this21.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	                    });
	                  }
	                }
	              });
	            } else {
	              if (goNext === true) {
	                _this21.goNext();
	              } else {
	                _this21.generatingLongTermShifts = false;
	                _this21.loadingSync = false;
	                _this21.removeLoadingBar();
	              }
	            }
	          });
	        });
	      });
	    }
	  }, {
	    key: "removeLoadingBar",
	    value: function removeLoadingBar() {
	      var _this22 = this;
	
	      this.$timeout(function () {
	        if (_this22.$rootScope && _this22.$rootScope.progress) {
	          _this22.$rootScope.progress.complete();
	        }
	      }, 800);
	    }
	  }, {
	    key: "createNewRemoteEvent",
	    value: function createNewRemoteEvent(shifts) {
	      var _this23 = this;
	
	      //console.log("Creating new remote job");
	
	      // Maine Time Zone: 04743
	      this.$events.adjustTimeZone("04743").then(function (_ref6) {
	        var timeZone = _ref6.timeZone,
	            timeZoneDifference = _ref6.timeZoneDifference;
	
	        var timeIntervalsArray = shifts.map(function (shift) {
	          var _$events$adjustTimeZo6 = _this23.$events.adjustTimeZones(shift, timeZone, timeZoneDifference, false),
	              startTime = _$events$adjustTimeZo6.startTime,
	              endTime = _$events$adjustTimeZo6.endTime;
	
	          return {
	            contactInfo: _this23.event.contactInfo,
	            startDateAndTimeForDB: startTime,
	            endDateAndTimeForDB: endTime,
	            overnight: shift.overnight,
	            unpaidBreak: shift.unpaidBreak && parseFloat(shift.unpaidBreak) ? parseFloat(shift.unpaidBreak) : 0
	          };
	        });
	
	        var remote_jobble_type = _this23.$rootScope.remote_jobble_type || {};
	
	        var event = {
	          name: "DEFAULT_REMOTE_TITLE",
	          dress_code: _variables.DRESS_CODE_DEFAULT,
	          openings: 10,
	          typeOfJobPosting: "regular",
	          timeIntervalsArray: timeIntervalsArray,
	          jobble_type: remote_jobble_type.id || 92,
	          manager: _this23.event.hiring_manager,
	          is_long_term: _this23.event.is_long_term
	        };
	
	        if (_this23.event.is_long_term) {
	          event.weeks = _this23.event.numberOfWeeksToScheduleJob;
	        }
	
	        _this23.$timeout(function () {
	          _this23.generatingShift = true;
	          _this23.generatingLongTermShifts = true;
	        });
	
	        _this23.$events.saveDraftv2(event).then(function (data) {
	          _this23.$timeout(function () {
	            _this23.generatingShift = false;
	          });
	          _this23.showGenerator = false;
	
	          _this23.$timeout(function () {
	            _this23.shiftGenerator = _this23.getNewShiftObject();
	            _this23.validateShiftGenerator();
	          });
	
	          //console.log("Created new event:", data);
	
	          _this23.event.id = data.data.jobblePool.eventId;
	          _this23.event.contactInfo = data.data.jobblePool.jobbles[0].location;
	          _this23.$state.transitionTo("postashiftwalkthrough", { eid: _this23.event.id }, { notify: false });
	          //this.$location.search("eid", this.event.id);
	          _this23.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	
	          _this23.$tracking.reportPostAJobSubmitStep("date & time");
	
	          if (_this23.event.is_long_term) {
	            _this23.updateLongTermWeeks(_this23.event.numberOfWeeksToScheduleJob).then(function () {
	              //console.log("Done syncing with the API after event creation", this.event);
	              _this23.goNext();
	              _this23.$timeout(function () {
	                _this23.generatingLongTermShifts = false;
	              }, 2000);
	            }).catch(function (e) {
	              _this23.goNext();
	              _this23.$timeout(function () {
	                _this23.generatingLongTermShifts = false;
	              }, 2000);
	            });
	          } else {
	            _this23.syncWithApi();
	            _this23.$timeout(function () {
	              _this23.generatingLongTermShifts = false;
	            }, 2000);
	          }
	        }).catch(function (err) {
	          //console.error("Error creating new event:", err);
	          //TODO alert("Error creating an event, please try again.");
	        });
	      });
	    }
	  }, {
	    key: "changedUnpaidShift",
	    value: function changedUnpaidShift(shift, dontUpdate) {
	      if (!shift.hasUnpaidBreak) {
	        shift.unpaidBreak = 0;
	        if (!dontUpdate) {
	          console.log("updateShift 2");
	          this.updateShift(shift);
	        }
	      } else {
	        shift.unpaidBreak = 30;
	        if (!dontUpdate) {
	          console.log("updateShift 3");
	          this.updateShift(shift);
	        }
	      }
	    }
	  }, {
	    key: "updateShiftGenerator",
	    value: function updateShiftGenerator(shift) {
	      this.$timeout(function () {
	        if (shift.unpaidBreak > 0) {
	          shift.hasUnpaidBreak = true;
	        } else {
	          shift.hasUnpaidBreak = false;
	        }
	      });
	    }
	  }, {
	    key: "updateShift",
	    value: function updateShift(shift, fromHTML, loc) {
	      var _this24 = this;
	
	      var tt = this.timeMap[shift.startTime];
	      shift.possibleEndTimes = this.generateTimes(tt, true);
	
	      if (fromHTML) {
	        console.log("Triggered from ng-change update:", loc);
	      }
	
	      if (shift.unpaidBreak > 0) {
	        shift.hasUnpaidBreak = true;
	      }
	
	      if (!shift.id) {
	        console.warn("Trying to update shift without an ID");
	        return;
	      }
	
	      if (!this.$events.validateWorflowShift(shift)) {
	        console.warn("Skipping sending invalid shift to API");
	        return;
	      }
	
	      if (!this.$events.validateWorflowShiftsNonOverlapping(this.event.shifts)) {
	        console.warn("Skipping sending invalid overlapping shift to API");
	        return;
	      }
	
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	
	      this.$timeout(function () {
	        _this24.savingStep = true;
	      });
	
	      this.$events.adjustTimeZone(this.event.contactInfo.zipCode).then(function (_ref7) {
	        var timeZone = _ref7.timeZone,
	            timeZoneDifference = _ref7.timeZoneDifference;
	
	        var _$events$adjustTimeZo7 = _this24.$events.adjustTimeZones(shift, timeZone, timeZoneDifference, false),
	            startTime = _$events$adjustTimeZo7.startTime,
	            endTime = _$events$adjustTimeZo7.endTime;
	
	        var tempShift = {
	          id: shift.id,
	          overnight: shift.overnight,
	          unpaidBreak: shift.unpaidBreak,
	          timeInterval: {
	            startTime: startTime,
	            endTime: endTime
	          }
	        };
	
	        _this24.$events.updateExistingShift(tempShift, true).then(function (data) {
	          _this24.$timeout(function () {
	            _this24.savingStep = false;
	          });
	          //console.log("Updated shift:", data);
	        }, function (err) {});
	      });
	    }
	  }, {
	    key: "updateSchedule",
	    value: function updateSchedule() {
	      var weeks = this.numberOfWeeksToScheduleJob;
	      var scheduledWeeks = null;
	
	      if (weeks === "1 Week") {
	        scheduledWeeks = 0;
	      } else if (weeks === "2 Weeks") {
	        scheduledWeeks = 1;
	      } else if (weeks === "3 Weeks") {
	        scheduledWeeks = 2;
	      } else if (weeks === "4 Weeks") {
	        scheduledWeeks = 3;
	      } else if (weeks === "5 Weeks") {
	        scheduledWeeks = 4;
	      } else if (weeks === "6 Weeks") {
	        scheduledWeeks = 5;
	      } else if (weeks === "7 Weeks") {
	        scheduledWeeks = 6;
	      } else if (weeks === "8 Weeks") {
	        scheduledWeeks = 7;
	      } else if (weeks === "9 Weeks") {
	        scheduledWeeks = 8;
	      } else if (weeks === "10 Weeks") {
	        scheduledWeeks = 9;
	      }
	
	      this.event.numberOfWeeksToScheduleJob = scheduledWeeks;
	    }
	  }, {
	    key: "updateShortTermLongTerm",
	    value: function updateShortTermLongTerm(is_long_term) {
	      var _this25 = this;
	
	      //console.log("updateShortTermLongTerm");
	      //console.dir(is_long_term);
	
	      if (this.event.forced_long_term || this.event.forced_one_time) {
	        if (this.event.forced_long_term) {
	          return alert("Warehouse jobs can only be posted as recurring jobs");
	        }
	        if (this.event.forced_one_time) {
	          return alert("Event jobs can only be posted as one-time jobs");
	        }
	      }
	
	      if (this.event.shifts && this.event.shifts.length && this.event.id) {
	        var confirmed = confirm("Are you sure you want to switch the post type?" + " This may delete previous shifts you've created!");
	
	        if (!confirmed) {
	          return;
	        } else {
	          this.updateIsLongTerm();
	        }
	      }
	
	      this.$timeout(function () {
	        _this25.event.is_long_term = is_long_term;
	        _this25.$timeout(function () {
	          return _this25.activateDatePickers();
	        }, 250);
	        if (is_long_term && _this25.event.shifts && _this25.event.shifts.length && _this25.event.id) {
	          _this25.$timeout(function () {
	            _this25.generatingLongTermShifts = true;
	          });
	          _this25.$events.saveEventLongTermShortTerm(_this25.event.id, is_long_term).then(function (data) {
	            //console.log("Updated short/long term event:", data);
	            _this25.generateLongTermShifts(true);
	            _this25.syncWithApi(false);
	          });
	        } else {
	          if (_this25.event.id) {
	            _this25.$events.saveEventLongTermShortTerm(_this25.event.id, is_long_term).then(function (data) {
	              //console.log("Updated short/long term event:", data);
	              _this25.syncWithApi(false);
	            });
	            _this25.clearLongTermWeek();
	          }
	        }
	      });
	    }
	  }, {
	    key: "clearLongTermWeek",
	    value: function clearLongTermWeek(weeks) {
	      var _this26 = this;
	
	      //console.log("clearLongTermWeek");
	      this.$timeout(function () {
	        if (_this26.event.id) {
	          _this26.$events.saveEventLongTermWeeks(_this26.event.id, null).then(function (data) {});
	        }
	      });
	    }
	  }, {
	    key: "updateIsLongTerm",
	    value: function updateIsLongTerm() {}
	  }, {
	    key: "updateLongTermWeeks",
	    value: function updateLongTermWeeks(weeks, skip) {
	      var _this27 = this;
	
	      console.log("updateLongTermWeeks -- date and time controller");
	      console.dir(weeks);
	      console.dir(skip);
	      this.setLoader();
	      this.loadingSync = true;
	
	      if (angular.isUndefined(weeks) || weeks === "undefined" || weeks === 0 || weeks === "0") {
	        console.log("we have no weeks...do nothing");
	        //this.syncWithApi();
	        this.$timeout(function () {
	          console.log("check after timeout...");
	          console.dir(_this27.event);
	          var newWeeks = _this27.event.numberOfWeeksToScheduleJob;
	          console.log("weeks after timeout");
	          console.dir(newWeeks);
	          if (angular.isUndefined(weeks) || weeks === "undefined") {
	            console.log("not detecting weeks");
	            _this27.$timeout(function () {
	              _this27.generatingLongTermShifts = false;
	            }, 2000);
	
	            if (!skip) {
	              _this27.$timeout(function () {
	                _this27.syncWithApi(true);
	              }, 1000);
	            } else {
	              _this27.unSetLoader();
	              _this27.loadingSync = false;
	            }
	          } else {
	            return new Promise(function (resolve) {
	              _this27.$timeout(function () {
	                console.log("resolving..");
	                console.dir(resolve);
	                _this27.event.numberOfWeeksToScheduleJob = newWeeks;
	                //this.$rootScope.$emit("SetNewWeeksOnChange", this.event);
	                if (_this27.event.id) {
	                  _this27.generatingLongTermShifts = true;
	                  _this27.$events.saveEventLongTermWeeks(_this27.event.id, newWeeks).then(function (data) {
	                    _this27.$timeout(function () {
	                      _this27.generatingLongTermShifts = false;
	                    }, 1000);
	                    console.log("Updated long term event weeks:", data);
	                    console.log("skip : " + skip);
	                    //zzzzzz
	                    resolve();
	                    if (!skip) {
	                      _this27.$timeout(function () {
	                        _this27.syncWithApi();
	                      }, 1000);
	                    } else {
	                      _this27.unSetLoader();
	                      _this27.loadingSync = false;
	                    }
	                  }).catch(function (e) {
	                    //console.error(e);
	                    resolve();
	                  });
	                } else {
	                  _this27.unSetLoader();
	                  _this27.loadingSync = false;
	                  resolve();
	                }
	              });
	            });
	          }
	        }, 2000);
	      } else {
	        return new Promise(function (resolve) {
	          _this27.$timeout(function () {
	            _this27.event.numberOfWeeksToScheduleJob = weeks;
	            //this.$rootScope.$emit("SetNewWeeksOnChange", this.event);
	            if (_this27.event.id) {
	              _this27.generatingLongTermShifts = true;
	              _this27.$events.saveEventLongTermWeeks(_this27.event.id, weeks).then(function (data) {
	                _this27.$timeout(function () {
	                  _this27.generatingLongTermShifts = false;
	                }, 2000);
	                console.log("Updated long term event weeks:", data);
	                console.log("skip : " + skip);
	                resolve();
	                if (!skip) {
	                  _this27.$timeout(function () {
	                    _this27.syncWithApi();
	                  }, 1000);
	                } else {
	                  _this27.unSetLoader();
	                  _this27.loadingSync = false;
	                }
	              }).catch(function (e) {
	                //console.error(e);
	                resolve();
	              });
	            } else {
	              _this27.unSetLoader();
	              _this27.loadingSync = false;
	              resolve();
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: "setScheduleForJob",
	    value: function setScheduleForJob() {
	      var _this28 = this;
	
	      var weeks = this.event.numberOfWeeksToScheduleJob;
	
	      this.$events.setJobSchedule(this.jobble_id, weeks).then(function (r) {
	        //console.log("Updated job schedule:", r);
	        _this28.$timeout(function () {
	          _this28.$rootScope.$emit("JobHasBeenScheduled", _this28.event);
	        });
	      }, function (error) {
	        //console.error(error);
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }]);
	
	  return DateandtimeController;
	}();
	
	DateandtimeController.$inject = ["$localStorage", "$rootScope", "$state", "$stateParams", "auth", "env", "security", "ngProgressFactory", "$timeout", "tracking", "events", "$location", "$scope"];
	
	exports.default = DateandtimeController;

/***/ }),
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _positiontype = __webpack_require__(323);
	
	var _positiontype2 = _interopRequireDefault(_positiontype);
	
	var _positiontype3 = __webpack_require__(324);
	
	var _positiontype4 = _interopRequireDefault(_positiontype3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var positiontypeComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _positiontype2.default,
	  controller: _positiontype4.default,
	  controllerAs: "vm"
	};
	
	exports.default = positiontypeComponent;

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <div class=\"main-title\">Job Type</div>\n  <div class=\"main-text\">\n    <pajtooltip />\n    Please select a job type for this job:\n  </div>\n  <div class=\"main-select-container\">\n    <select ng-change=\"vm.updatePositionType()\" ng-model=\"vm.event.position_type\" class=\"main-select\">\n      <option ng-repeat=\"o in vm.jobble_types\" value=\"{{o.id}}\">{{o.name}}</option>\n    </select>\n    <i class=\"fas fa-caret-down\"></i>\n  </div>\n\n  <div ng-if=\"vm.savingStep\" class=\"main-next-button\" style=\"opacity: 0.5; cursor: wait\">\n    Saving <i class=\"fas fa-spin fa-spinner fa-1x fa-fw\"></i>\n  </div>\n  <div\n    ng-if=\"!vm.savingStep\"\n    class=\"main-next-button\"\n    ng-class=\"{'disabled': !vm.event.position_type || vm.waitForEventToLoad}\"\n    ng-click=\"vm.goNext()\"\n  >\n    Next\n  </div>\n</div>\n"

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(309);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PositiontypeController = function () {
	  function PositiontypeController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, $location, TrackingService, ngProgressFactory, events) {
	    var _this = this;
	
	    _classCallCheck(this, PositiontypeController);
	
	    this.name = "positiontype";
	    this.walkthroughState = _variables.WALKTHROUGH_STATES.POSITION;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$stateParams = $stateParams;
	    this.$location = $location;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$progress = ngProgressFactory.createInstance();
	    this.waitForEventToLoad = true;
	    this.$tracking = TrackingService;
	    this.$events = events;
	    this.jobble_types = this.$rootScope.jobble_types;
	
	    this.API_FIELDS = "subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.jobbleType.name, subEvents.deduppedJobbles.jobbleType.id";
	
	    this.PostAJobGlobalApiSyncListener = this.$rootScope.$on("PostAJobGlobalApiSync", function ($event, params) {
	      var event = params.event;
	      if (event) {
	        _this.$timeout(function () {
	          _this.waitForEventToLoad = false;
	          $("#cloning-loading-event-data").modal("toggle");
	          $(".modal-backdrop").remove();
	        }, 2000);
	      }
	    });
	
	    this.TriggerLoadingModalListener = this.$rootScope.$on("TriggerLoadingModal", function ($event, params) {
	      _this.$timeout(function () {
	        $("#cloning-loading-event-data").modal();
	      }, 350);
	    });
	
	    this.DoNotTriggerModalListener = this.$rootScope.$on("DoNotTriggerModal", function ($event, params) {
	      _this.event.back_end_loaded = true;
	    });
	
	    this.$scope.$on("$destroy", this.DoNotTriggerModalListener);
	    this.$scope.$on("$destroy", this.PostAJobGlobalApiSyncListener);
	    this.$scope.$on("$destroy", this.TriggerLoadingModalListener);
	  }
	
	  _createClass(PositiontypeController, [{
	    key: "$onInit",
	    value: function $onInit() {
	
	      this.setLoader();
	
	      if (this.$location.$$search.cid) {
	        this.isClone = true;
	      }
	
	      if ((this.$location.$$search.cid || this.$location.$$search.eid) && !this.event.back_end_loaded) {
	        this.waitForEventToLoad = true;
	        this.showLoadingModal();
	      } else {
	        this.waitForEventToLoad = false;
	      }
	
	      if (this.event.position_type) {
	        this.event.position_type = this.event.position_type + "";
	      }
	
	      if (this.event && this.event.id) {
	        this.syncWithApi();
	      }
	
	      this.getJobbleTypes();
	    }
	  }, {
	    key: "setWarehouseDefault",
	    value: function setWarehouseDefault() {
	      var _this2 = this;
	
	      if (!this.isClone) {
	        if (!this.$rootScope.warehouse_jobble_type) {
	          this.$rootScope.warehouse_jobble_type = this.findWarehouseJobType(this.jobble_types);
	        }
	
	        this.$timeout(function () {
	          if (!_this2.event.position_type || !_this2.event.position_type.length) {
	            if (_this2.$rootScope.warehouse_jobble_type && _this2.$rootScope.warehouse_jobble_type.id) {
	              _this2.event.position_type = _this2.$rootScope.warehouse_jobble_type.id + "";
	              _this2.updatePositionType();
	            }
	          }
	        });
	      }
	
	      this.$timeout(function () {
	        _this2.stripOutW2();
	        _this2.unSetLoader();
	      }, 1000);
	    }
	  }, {
	    key: "stripOutW2",
	    value: function stripOutW2() {
	      if (this.$auth.isAdmin() === true) {
	        console.log("we have an admin, leave w2 jobble type");
	      } else {
	        this.jobble_types.pop();
	      }
	
	      //TODO: strip out the undefined one
	    }
	  }, {
	    key: "showLoadingModal",
	    value: function showLoadingModal() {
	      this.$timeout(function () {
	        $("#cloning-loading-event-data").modal();
	      }, 350);
	    }
	  }, {
	    key: "findWarehouseJobType",
	    value: function findWarehouseJobType(types) {
	      var type = null;
	
	      if (!types || !types.length) return type;
	
	      types.forEach(function (t) {
	        var name = t.name.toLowerCase();
	        if (name.indexOf("warehouse") !== -1) type = t;
	      });
	
	      return type;
	    }
	  }, {
	    key: "syncWithApi",
	    value: function syncWithApi() {
	      var _this3 = this;
	
	      this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then(function (data) {
	        _this3.jobble_id = data.data.subEvents[0].deduppedJobbles[0].id;
	        var jobbleType = data.data.subEvents[0].deduppedJobbles[0].jobbleType;
	        _this3.event.position_type = jobbleType.id + "";
	      });
	    }
	  }, {
	    key: "getJobbleTypes",
	    value: function getJobbleTypes() {
	      var _this4 = this;
	
	      if (this.$rootScope.jobble_types) {
	        this.$timeout(function () {
	          _this4.jobble_types = _this4.$rootScope.jobble_types;
	          if (!(_this4.event && _this4.event.id)) {
	            _this4.setWarehouseDefault();
	          } else {
	            _this4.stripOutW2();
	          }
	        }, 1000);
	      } else {
	        this.$auth.getJobbleTypes().then(function (data) {
	          console.log("getting jobble types");
	          console.dir(data.data);
	          _this4.$timeout(function () {
	            _this4.jobble_types = data.data;
	            _this4.$rootScope.jobble_types = data.data;
	            if (!(_this4.event && _this4.event.id)) {
	              _this4.setWarehouseDefault();
	            } else {
	              _this4.stripOutW2();
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "setW2status",
	    value: function setW2status(isW2) {
	      if (isW2 !== true) {
	        this.event.is_w2 = false;
	      } else {
	        this.event.is_w2 = true;
	      }
	    }
	  }, {
	    key: "updatePositionType",
	    value: function updatePositionType() {
	      var _this5 = this;
	
	      console.log("updating position type");
	      console.dir(this.event.position_type);
	
	      if (this.event.position_type === "95") {
	        this.setW2status(true);
	      } else {
	        this.setW2status(false);
	      }
	
	      this.event.forced_long_term = false;
	      this.event.forced_one_time = false;
	
	      if (this.$rootScope.warehouse_jobble_type && this.$rootScope.warehouse_jobble_type.id) {
	        if (this.$rootScope.warehouse_jobble_type.id + "" === this.event.position_type + "") {
	          console.log("Picked Warehouse Job Type");
	          //this.event.forced_long_term = true;
	
	          if (!this.event.is_long_term) {
	            //this.event.is_long_term = false;
	            this.event.shifts = [];
	
	            console.log("UPDATE_WORKFLOW_EVENT_NAME");
	            console.dir(_variables.UPDATE_WORKFLOW_EVENT_NAME);
	
	            this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	          }
	        }
	      }
	
	      if (this.$rootScope.event_jobble_type && this.$rootScope.event_jobble_type.id) {
	        if (this.$rootScope.event_jobble_type.id + "" === this.event.position_type + "") {
	          console.log("Picked Event Staff Job Type");
	          this.event.forced_one_time = true;
	
	          if (this.event.is_long_term) {
	            this.event.is_long_term = false;
	            this.event.shifts = [];
	
	            this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	          }
	        }
	      }
	
	      if (this.event && this.event.id) {
	        this.$timeout(function () {
	          _this5.savingStep = true;
	        });
	
	        this.$timeout(function () {
	          var jid = void 0;
	
	          if (_this5.event.deduppedJobbleId) {
	            jid = _this5.event.deduppedJobbleId;
	          } else if (_this5.jobble_id) {
	            jid = _this5.jobble_id;
	          }
	          if (jid) {
	            _this5.$events.saveEventPositionType(_this5.jobble_id, _this5.event.position_type).then(function (data) {
	              _this5.updateEventW2Status(_this5.event);
	              _this5.$timeout(function () {
	                _this5.savingStep = false;
	              });
	              console.log("Saved position type:", data);
	            });
	          } else {
	            console.warn("no jobble id, do not update jobble type");
	          }
	        }, 1000);
	      }
	    }
	  }, {
	    key: "updateEventW2Status",
	    value: function updateEventW2Status(event) {
	      this.$events.saveW2Status(this.event).then(function (data) {
	        console.log("Saved w2 status:", data);
	      });
	    }
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      this.$tracking.reportPostAJobSubmitStep("job type");
	      this.$rootScope.$emit(_variables.TRIGGER_NEXT_EVENT_NAME, {
	        walkthroughState: this.walkthroughState
	      });
	    }
	  }]);
	
	  return PositiontypeController;
	}();
	
	PositiontypeController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "$location", "tracking", "ngProgressFactory", "events"];
	
	exports.default = PositiontypeController;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _openings = __webpack_require__(326);
	
	var _openings2 = _interopRequireDefault(_openings);
	
	var _openings3 = __webpack_require__(327);
	
	var _openings4 = _interopRequireDefault(_openings3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openingsComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _openings2.default,
	  controller: _openings4.default,
	  controllerAs: "vm"
	};
	
	exports.default = openingsComponent;

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <div class=\"main-title\">Openings</div>\n  <div class=\"main-text\"><pajtooltip />How many positions are you looking to hire for? Post a job with your ideal team size in mind.</div>\n  <div class=\"main-input-container\">\n    <input placeholder=\"Enter number of openings\" ng-change=\"vm.validate()\" type=\"number\" class=\"main-input\" ng-model=\"vm.event.openings\" min=\"1\" />\n  </div>\n  <div ng-if=\"vm.savingStep\" class=\"main-next-button\" style=\"opacity: 0.5; cursor: wait\">\n    Saving <i class=\"fas fa-spin fa-spinner fa-1x fa-fw\"></i>\n  </div>\n  <div ng-if=\"!vm.savingStep\" class=\"main-next-button\" ng-class=\"{'disabled': !vm.valid_openings}\" ng-click=\"vm.goNext()\">Next</div>\n  <!--\n    <div ng-if=\"!vm.savingStep && vm.hasSavedOpenings\" class=\"main-next-button\" ng-class=\"{'disabled': !vm.valid_openings}\" ng-click=\"vm.goNextNew()\">Next</div>\n    -->\n</div>\n"

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(309);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OpeningsController = function () {
	  function OpeningsController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    var _this = this;
	
	    _classCallCheck(this, OpeningsController);
	
	    this.name = "openings";
	    this.walkthroughState = _variables.WALKTHROUGH_STATES.OPENINGS;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	
	    this.API_FIELDS = "subEvents.deduppedJobbles.id,numberOfOpenings";
	
	    this.PostAJobSaveAndExitListener = this.$rootScope.$on("PostAJobSaveAndExit", function ($event, params) {
	      _this.saveOpenings();
	    });
	
	    this.$scope.$on("$destroy", this.PostAJobSaveAndExitListener);
	
	    this.valid_openings = this.validateOpenings();
	    this.hasSavedOpenings = false;
	  }
	
	  _createClass(OpeningsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.setLoader();
	      this.setOriginalOpenings(this.event.openings);
	      this.syncWithApi();
	      this.validate();
	    }
	  }, {
	    key: "setOriginalOpenings",
	    value: function setOriginalOpenings(openings) {
	      this.originalOpenings = openings;
	    }
	  }, {
	    key: "validate",
	    value: function validate() {
	      this.event.openings = parseInt(this.event.openings);
	      this.valid_openings = this.validateOpenings();
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	    }
	  }, {
	    key: "validateOpenings",
	    value: function validateOpenings() {
	      if (!this.event || !this.event.openings) return false;
	
	      return this.event.openings <= 100 && this.event.openings > 0;
	    }
	  }, {
	    key: "syncWithApi",
	    value: function syncWithApi() {
	      var _this2 = this;
	
	      this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then(function (data) {
	        console.log("here we are syncing...");
	        console.dir(data);
	
	        _this2.jobble_id = data.data.subEvents[0].deduppedJobbles[0].id;
	        _this2.event.openings = data.data.numberOfOpenings;
	        _this2.setOriginalOpenings(data.data.numberOfOpenings);
	        _this2.validate();
	        _this2.$timeout(function () {
	          _this2.unSetLoader();
	        }, 300);
	      });
	    }
	  }, {
	    key: "saveOpenings",
	    value: function saveOpenings() {
	      var _this3 = this;
	
	      this.$timeout(function () {
	        _this3.savingStep = true;
	      });
	      return new Promise(function (resolve) {
	        var delta = _this3.event.openings - _this3.originalOpenings;
	        _this3.setOriginalOpenings(_this3.event.openings);
	
	        if (delta === 0) return resolve(null);
	
	        _this3.$events.editEventOpenings(_this3.jobble_id, delta).then(function (data) {
	          console.log("Saved openings:", data);
	          resolve(null);
	        });
	      });
	    }
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      var _this4 = this;
	
	      this.setLoader();
	      this.saveOpenings().then(function () {
	        _this4.$timeout(function () {
	          _this4.unSetLoader();
	          _this4.savingStep = false;
	          _this4.hasSavedOpenings = true;
	          _this4.goNextNew();
	        }, 5000);
	      });
	    }
	  }, {
	    key: "goNextNew",
	    value: function goNextNew() {
	      this.$rootScope.$emit(_variables.TRIGGER_NEXT_EVENT_NAME, {
	        walkthroughState: this.walkthroughState
	      });
	      this.$tracking.reportPostAJobSubmitStep("openings");
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }]);
	
	  return OpeningsController;
	}();
	
	OpeningsController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = OpeningsController;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _shifttitle = __webpack_require__(329);
	
	var _shifttitle2 = _interopRequireDefault(_shifttitle);
	
	var _shifttitle3 = __webpack_require__(330);
	
	var _shifttitle4 = _interopRequireDefault(_shifttitle3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shifttitleComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _shifttitle2.default,
	  controller: _shifttitle4.default,
	  controllerAs: "vm"
	};
	
	exports.default = shifttitleComponent;

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	module.exports = "<div>\n    <div class=\"main-title\">Job title</div>\n    <div class=\"main-text\"><pajtooltip/>What is the position title you are hiring for? This will be the first thing our community sees when they are looking for jobs. </div>\n    <div class=\"main-input-container\">\n        <input id=\"job-post-job-title\" class=\"main-input\" ng-change=\"vm.validate()\" ng-model=\"vm.event.shift_title\" maxlength=\"500\" rows=\"4\"></input>\n    </div>\n    <div class=\"main-next-button\" ng-class=\"{'disabled': !vm.event.shift_title}\" ng-click=\"vm.goNext()\">Next</div>\n</div>"

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(309);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ShifttitleController = function () {
	  function ShifttitleController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    var _this = this;
	
	    _classCallCheck(this, ShifttitleController);
	
	    this.name = "shifttitle";
	    this.walkthroughState = _variables.WALKTHROUGH_STATES.SHIFT_TITLE;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	    this.autoFocus = false;
	
	    this.API_FIELDS = "name";
	
	    this.PostAJobSaveAndExitListener = this.$rootScope.$on("PostAJobSaveAndExit", function ($event, params) {
	      _this.saveTitle();
	    });
	
	    this.LockLeftPanelListener = this.$rootScope.$on("LockLeftPanel", function ($event, params) {
	      _this.disableAllowedLinks();
	    });
	
	    this.UnLockLeftPanelListener = this.$rootScope.$on("UnLockLeftPanel", function ($event, params) {
	      _this.enableAllowedLinks();
	    });
	
	    this.$scope.$on("$destroy", this.PostAJobSaveAndExitListener);
	    this.$scope.$on("$destroy", this.LockLeftPanelListener);
	    this.$scope.$on("$destroy", this.UnLockLeftPanelListener);
	  }
	
	  _createClass(ShifttitleController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.eraseDefaultName();
	      this.syncWithApi();
	      this.blurElement();
	    }
	  }, {
	    key: "blurElement",
	    value: function blurElement() {
	      var _this2 = this;
	
	      this.$timeout(function () {
	        $(document.activeElement).blur();
	        _this2.focusEle();
	      }, 100);
	    }
	  }, {
	    key: "focusEle",
	    value: function focusEle() {
	      this.$timeout(function () {
	        var el = document.getElementById("job-post-job-title");
	        el.focus();
	      }, 100);
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "enableAllowedLinks",
	    value: function enableAllowedLinks() {
	      this.$timeout(function () {
	        $(".post-a-shift-container .main-next-button").removeClass("disabled");
	      });
	    }
	  }, {
	    key: "disableAllowedLinks",
	    value: function disableAllowedLinks() {
	      console.log("disableAllowedLinks");
	      //allowed {"openings":true,"position_type":true,"location":true,"shifts":-71.05228,"shift_title":true,"company_info":true,"shift_description":true,"arrival_instructions":true,"dress_code":true,"requirements":true,"hiring_manager":true,"hourly_rate":true}
	    }
	  }, {
	    key: "syncWithApi",
	    value: function syncWithApi() {
	      var _this3 = this;
	
	      //this.setLoader();
	      this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then(function (data) {
	        _this3.event.shift_title = data.data.name;
	        _this3.eraseDefaultName();
	        //this.unSetLoader();
	      });
	    }
	  }, {
	    key: "eraseDefaultName",
	    value: function eraseDefaultName() {
	      if (this.event && this.event.shift_title === "DEFAULT_EVENT_TITLE") {
	        this.event.shift_title = "";
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate() {
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	    }
	  }, {
	    key: "saveTitle",
	    value: function saveTitle() {
	      var _this4 = this;
	
	      this.$events.saveEventName(this.event.id, this.event.shift_title).then(function (data) {
	        _this4.$tracking.reportPostAJobSubmitStep("job title");
	        console.log("Saved shift title:", data);
	      });
	    }
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      this.saveTitle();
	      this.$rootScope.$emit(_variables.TRIGGER_NEXT_EVENT_NAME, {
	        walkthroughState: this.walkthroughState
	      });
	    }
	  }]);
	
	  return ShifttitleController;
	}();
	
	ShifttitleController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = ShifttitleController;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _shiftdescription = __webpack_require__(332);
	
	var _shiftdescription2 = _interopRequireDefault(_shiftdescription);
	
	var _shiftdescription3 = __webpack_require__(333);
	
	var _shiftdescription4 = _interopRequireDefault(_shiftdescription3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shiftdescriptionComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _shiftdescription2.default,
	  controller: _shiftdescription4.default,
	  controllerAs: "vm"
	};
	
	exports.default = shiftdescriptionComponent;

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <div class=\"main-title\">Job Description</div>\n  <div class=\"main-text\"><pajtooltip />Please enter a detailed description of this job:</div>\n  <div class=\"main-text-area-container\">\n    <textarea id=\"job-post-job-desc\" ng-change=\"vm.validate()\" ng-model=\"vm.event.shift_description\" maxlength=\"1000\" rows=\"4\"></textarea>\n  </div>\n  <div class=\"main-text-area-length\">\n    {{vm.event.shift_description && vm.event.shift_description.length ? vm.event.shift_description.length : 0 }}/1000\n  </div>\n  <div style=\"margin-top: 8px; color: red\" ng-if=\"vm.event.shift_description && vm.event.shift_description.length > 1000\">\n    Error: please enter a shift description under 1000 characters.\n  </div>\n  <div\n    class=\"main-next-button\"\n    ng-class=\"{'disabled': !vm.event.shift_description || vm.event.shift_description.length > 1000 }\"\n    ng-click=\"vm.goNext()\"\n  >\n    Next\n  </div>\n</div>\n"

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(309);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ShiftdescriptionController = function () {
	  function ShiftdescriptionController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    var _this = this;
	
	    _classCallCheck(this, ShiftdescriptionController);
	
	    this.name = "shiftdescription";
	    this.walkthroughState = _variables.WALKTHROUGH_STATES.SHIFT_DESCRIPTION;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	
	    this.API_FIELDS = "subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.description,description";
	
	    this.PostAJobSaveAndExitListener = this.$rootScope.$on("PostAJobSaveAndExit", function ($event, params) {
	      _this.saveDescription();
	    });
	
	    this.$scope.$on("$destroy", this.PostAJobSaveAndExitListener);
	
	    console.log("Initialize Shift", localStorage.savingDescription);
	  }
	
	  _createClass(ShiftdescriptionController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.syncWithApi();
	      this.blurElement();
	    }
	  }, {
	    key: "blurElement",
	    value: function blurElement() {
	      var _this2 = this;
	
	      this.$timeout(function () {
	        $(document.activeElement).blur();
	        _this2.focusEle();
	      }, 100);
	    }
	  }, {
	    key: "focusEle",
	    value: function focusEle() {
	      this.$timeout(function () {
	        var el = document.getElementById("job-post-job-desc");
	        el.focus();
	        //el.select();
	      }, 300);
	    }
	  }, {
	    key: "syncWithApi",
	    value: function syncWithApi() {
	      var _this3 = this;
	
	      this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then(function (data) {
	        _this3.jobble_id = data.data.subEvents[0].deduppedJobbles[0].id;
	        if (!(localStorage.savingDescription && JSON.parse(localStorage.savingDescription))) {
	          console.log("Updating Shift Description");
	          _this3.event.shift_description = data.data.description;
	        } else {
	          console.warn("Skipping update to Shift Description");
	        }
	      });
	    }
	  }, {
	    key: "saveDescription",
	    value: function saveDescription() {
	      var _this4 = this;
	
	      localStorage.savingDescription = true;
	
	      this.$events.saveEventDescription(this.event.id, this.event.shift_description).then(function (data) {
	        _this4.$tracking.reportPostAJobSubmitStep("job description");
	        console.log("Saved shift description to event:", data);
	
	        localStorage.savingDescription = false;
	
	        _this4.$timeout(function () {
	          _this4.syncWithApi();
	        }, 500);
	
	        _this4.$events.saveEventDescriptionToJobbles(_this4.jobble_id, _this4.event.shift_description).then(function (data) {
	          console.log("Saved shift description to jobble:", data);
	        });
	      });
	    }
	  }, {
	    key: "validate",
	    value: function validate() {
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	    }
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      this.saveDescription();
	      this.$rootScope.$emit(_variables.TRIGGER_NEXT_EVENT_NAME, {
	        walkthroughState: this.walkthroughState
	      });
	    }
	  }]);
	
	  return ShiftdescriptionController;
	}();
	
	ShiftdescriptionController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = ShiftdescriptionController;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _suggestedattire = __webpack_require__(335);
	
	var _suggestedattire2 = _interopRequireDefault(_suggestedattire);
	
	var _suggestedattire3 = __webpack_require__(336);
	
	var _suggestedattire4 = _interopRequireDefault(_suggestedattire3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var suggestedattireComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _suggestedattire2.default,
	  controller: _suggestedattire4.default,
	  controllerAs: "vm"
	};
	
	exports.default = suggestedattireComponent;

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <div class=\"main-title\">Suggested Attire</div>\n  <div class=\"main-text\">\n    Please enter a detailed description of what Jobblers should be expected to wear in order to comfortably perform the duties associated with this\n    job:\n  </div>\n  <div class=\"main-text-area-container\">\n    <textarea id=\"job-post-job-sa\" ng-change=\"vm.validate()\" ng-model=\"vm.event.dress_code\" maxlength=\"500\" rows=\"4\"></textarea>\n  </div>\n  <div class=\"main-text-area-length\">{{vm.event.dress_code && vm.event.dress_code.length ? vm.event.dress_code.length : 0 }}/500</div>\n  <div style=\"margin-top: 8px; color: red\" ng-if=\"vm.event.dress_code && vm.event.dress_code.length > 500\">\n    Error: please enter a suggested attire under 500 characters.\n  </div>\n  <div\n    class=\"main-next-button\"\n    ng-class=\"{'disabled': !vm.event.dress_code || vm.event.dress_code.length > 500  || vm.arrivalInstructionsSaved == false }\"\n    ng-click=\"vm.goNext()\"\n  >\n    Next\n  </div>\n</div>\n"

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(309);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SuggestedattireController = function () {
	  function SuggestedattireController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    var _this = this;
	
	    _classCallCheck(this, SuggestedattireController);
	
	    this.name = "suggestedattire";
	    this.walkthroughState = _variables.WALKTHROUGH_STATES.SUGGESTED_ATTIRE;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	    this.arrivalInstructionsSaved = false;
	
	    this.API_FIELDS = "subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.dressCode";
	
	    this.PostAJobSaveAndExitListener = this.$rootScope.$on("PostAJobSaveAndExit", function ($event, params) {
	      _this.saveDressCode();
	    });
	
	    this.ArrivalInstructionsSavedListener = this.$rootScope.$on("ArrivalInstructionsSaved", function ($event, params) {
	      _this.arrivalInstructionsSaved = false;
	      _this.undisableSaveButton();
	      _this.setLoader();
	    });
	
	    this.$scope.$on("$destroy", this.ArrivalInstructionsSavedListener);
	    this.$scope.$on("$destroy", this.PostAJobSaveAndExitListener);
	  }
	
	  _createClass(SuggestedattireController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.syncWithApi();
	      this.blurElement();
	    }
	  }, {
	    key: "blurElement",
	    value: function blurElement() {
	      var _this2 = this;
	
	      this.$timeout(function () {
	        $(document.activeElement).blur();
	        _this2.focusEle();
	      }, 100);
	    }
	  }, {
	    key: "focusEle",
	    value: function focusEle() {
	      this.$timeout(function () {
	        var el = document.getElementById("job-post-job-sa");
	        el.focus();
	      }, 100);
	    }
	  }, {
	    key: "syncWithApi",
	    value: function syncWithApi() {
	      var _this3 = this;
	
	      this.setLoader();
	      this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then(function (data) {
	        _this3.jobble_id = data.data.subEvents[0].deduppedJobbles[0].id;
	        _this3.event.dress_code = data.data.subEvents[0].deduppedJobbles[0].dressCode;
	        _this3.$timeout(function () {
	          _this3.arrivalInstructionsSaved = true;
	          _this3.unSetLoader();
	        }, 1000);
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "undisableSaveButton",
	    value: function undisableSaveButton() {
	      var _this4 = this;
	
	      console.log("undisableSaveButtonundisableSaveButton");
	      this.$timeout(function () {
	        _this4.arrivalInstructionsSaved = true;
	        _this4.unSetLoader();
	      }, 500);
	    }
	  }, {
	    key: "saveDressCode",
	    value: function saveDressCode() {
	      var _this5 = this;
	
	      this.$events.saveEventDressCode(this.jobble_id, this.event.dress_code).then(function (data) {
	        _this5.$tracking.reportPostAJobSubmitStep("suggested attire");
	        console.log("Saved suggested attire to event:", data);
	      });
	    }
	  }, {
	    key: "validate",
	    value: function validate() {
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	    }
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      this.saveDressCode();
	      this.$rootScope.$emit(_variables.TRIGGER_NEXT_EVENT_NAME, {
	        walkthroughState: this.walkthroughState
	      });
	    }
	  }]);
	
	  return SuggestedattireController;
	}();
	
	SuggestedattireController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = SuggestedattireController;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _arrivalinstructions = __webpack_require__(338);
	
	var _arrivalinstructions2 = _interopRequireDefault(_arrivalinstructions);
	
	var _arrivalinstructions3 = __webpack_require__(339);
	
	var _arrivalinstructions4 = _interopRequireDefault(_arrivalinstructions3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrivalinstructionsComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _arrivalinstructions2.default,
	  controller: _arrivalinstructions4.default,
	  controllerAs: "vm"
	};
	
	exports.default = arrivalinstructionsComponent;

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <div class=\"main-title\">Onsite Info</div>\n  <div class=\"sub-title\">Arrival Instructions</div>\n  <div class=\"main-text\">\n    Provide a detailed description for hired Jobblers with information on how to access the job site. Helpful information includes parking details,\n    details on where to check in, site specific information, etc.\n  </div>\n  <div class=\"main-text-area-container\">\n    <textarea\n      id=\"job-post-job-arrival\"\n      ng-change=\"vm.validate()\"\n      ng-model=\"vm.event.arrival_instructions\"\n      maxlength=\"500\"\n      rows=\"4\"\n      placeholder=\"The lot on 3rd street is paid parking. When you arrive, enter through the blue door and check in with Joe.\"\n    ></textarea>\n  </div>\n  <div class=\"main-text-area-length\">\n    {{vm.event.arrival_instructions && vm.event.arrival_instructions.length ? vm.event.arrival_instructions.length : 0 }}/500\n  </div>\n  <div style=\"margin-top: 8px; color: red\" ng-if=\"vm.event.arrival_instructions && vm.event.arrival_instructions.length > 500\">\n    Error: please enter a arrival instruction description under 500 characters.\n  </div>\n  <div class=\"sub-title\">Onsite Manager Contact Info</div>\n\n  <div class=\"main-text\">Provide an onsite point of contact for hired Jobblers.</div>\n  <div class=\"main-input-container\">\n    <input placeholder=\"Name\" class=\"main-input\" ng-change=\"vm.validate()\" ng-model=\"vm.event.onsite_manager_name\" maxlength=\"500\" rows=\"4\" />\n  </div>\n  <div class=\"main-input-container\" style=\"margin-top: 8px\">\n    <input\n      placeholder=\"Phone Number\"\n      class=\"main-input\"\n      ng-change=\"vm.validate()\"\n      ng-model=\"vm.event.onsite_manager_number\"\n      maxlength=\"500\"\n      rows=\"4\"\n    />\n  </div>\n  <div\n    class=\"main-next-button\"\n    ng-class=\"{'disabled': !vm.event.onsite_manager_name || !vm.event.onsite_manager_number || !vm.event.arrival_instructions || vm.event.arrival_instructions.length > 500 }\"\n    ng-click=\"vm.goNext()\"\n  >\n    Next\n  </div>\n</div>\n"

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(309);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArrivalinstructionsController = function () {
	  function ArrivalinstructionsController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    var _this = this;
	
	    _classCallCheck(this, ArrivalinstructionsController);
	
	    this.name = "arrivalinstructions";
	    this.walkthroughState = _variables.WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	
	    this.API_FIELDS = "arrivalInstructions,onsiteManagerName,onsiteManagerNumber";
	
	    this.PostAJobSaveAndExitListener = this.$rootScope.$on("PostAJobSaveAndExit", function ($event, params) {
	      _this.saveArrivalInstructions();
	    });
	
	    this.$scope.$on("$destroy", this.PostAJobSaveAndExitListener);
	
	    console.log("Initialize Shift", localStorage.savingInstructions);
	  }
	
	  _createClass(ArrivalinstructionsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.syncWithApi();
	      this.blurElement();
	    }
	  }, {
	    key: "blurElement",
	    value: function blurElement() {
	      var _this2 = this;
	
	      this.$timeout(function () {
	        $(document.activeElement).blur();
	        _this2.focusEle();
	      }, 300);
	    }
	  }, {
	    key: "focusEle",
	    value: function focusEle() {
	      this.$timeout(function () {
	        var el = document.getElementById("job-post-job-arrival");
	        el.focus();
	        //el.select();
	      }, 300);
	    }
	  }, {
	    key: "syncWithApi",
	    value: function syncWithApi() {
	      var _this3 = this;
	
	      this.setLoader();
	      this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then(function (data) {
	        if (!(localStorage.savingInstructions && JSON.parse(localStorage.savingInstructions))) {
	          console.log("Updating Shift Description");
	          _this3.event.arrival_instructions = data.data.arrivalInstructions;
	          _this3.event.onsite_manager_name = data.data.onsiteManagerName;
	          _this3.event.onsite_manager_number = data.data.onsiteManagerNumber;
	        } else {
	          console.warn("Skipping update to Shift Description");
	        }
	        _this3.unSetLoader();
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "saveArrivalInstructions",
	    value: function saveArrivalInstructions() {
	      var _this4 = this;
	
	      localStorage.savingInstructions = true;
	      console.log("starting saving arrival instruct");
	      this.setLoader();
	      this.$events.saveEventArrivalInstructions(this.event.id, this.event.arrival_instructions, this.event.onsite_manager_name, this.event.onsite_manager_number).then(function (data) {
	        _this4.$tracking.reportPostAJobSubmitStep("onsite info");
	        console.log("Saved onsite info to event:", data);
	        localStorage.savingInstructions = false;
	        console.log("ending saving arrival instruct");
	        _this4.unSetLoader();
	        //this.$rootScope.$emit("ArrivalInstructionsSaved",{});
	        _this4.$rootScope.$emit(_variables.TRIGGER_NEXT_EVENT_NAME, {
	          walkthroughState: _this4.walkthroughState
	        });
	        /*
	            this.$timeout(() => {
	                this.syncWithApi();
	            }, 500);
	             */
	      });
	    }
	  }, {
	    key: "validate",
	    value: function validate() {
	      this.event.onsite_manager_number = this.event.onsite_manager_number ? this.event.onsite_manager_number.replace(/\D/g, "") : this.event.onsite_manager_number;
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	    }
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      this.saveArrivalInstructions();
	    }
	  }]);
	
	  return ArrivalinstructionsController;
	}();
	
	ArrivalinstructionsController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = ArrivalinstructionsController;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _companyinfo = __webpack_require__(341);
	
	var _companyinfo2 = _interopRequireDefault(_companyinfo);
	
	var _companyinfo3 = __webpack_require__(342);
	
	var _companyinfo4 = _interopRequireDefault(_companyinfo3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var companyinfoComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _companyinfo2.default,
	  controller: _companyinfo4.default,
	  controllerAs: "vm"
	};
	
	exports.default = companyinfoComponent;

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <div class=\"main-title\">Company info</div>\n  <div class=\"main-text\"><pajtooltip />Provide a short introduction to your company:</div>\n  <div class=\"main-text-area-container\">\n    <textarea id=\"job-post-company-desc\" ng-model=\"vm.event.company_info\" ng-change=\"vm.validate()\" maxlength=\"500\" rows=\"4\"></textarea>\n  </div>\n  <div class=\"main-text-area-length\">{{vm.event.company_info && vm.event.company_info.length ? vm.event.company_info.length : 0 }}/500</div>\n  <div class=\"main-next-button\" ng-class=\"{'disabled': !vm.event.company_info || vm.holdUser == true}\" ng-click=\"vm.goNext()\">Next</div>\n</div>\n"

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(309);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CompanyinfoController = function () {
	  function CompanyinfoController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    var _this = this;
	
	    _classCallCheck(this, CompanyinfoController);
	
	    this.name = "companyinfo";
	    this.walkthroughState = _variables.WALKTHROUGH_STATES.COMPANY_INFO;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	
	    this.PostAJobSaveAndExitListener = this.$rootScope.$on("PostAJobSaveAndExit", function ($event, params) {
	      _this.saveDescription();
	    });
	
	    this.$scope.$on("$destroy", this.PostAJobSaveAndExitListener);
	  }
	
	  _createClass(CompanyinfoController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.syncWithApi();
	      this.blurElement();
	    }
	  }, {
	    key: "blurElement",
	    value: function blurElement() {
	      var _this2 = this;
	
	      this.$timeout(function () {
	        $(document.activeElement).blur();
	        _this2.focusEle();
	      }, 100);
	    }
	  }, {
	    key: "focusEle",
	    value: function focusEle() {
	      this.$timeout(function () {
	        var el = document.getElementById("job-post-company-desc");
	        el.focus();
	      }, 100);
	    }
	  }, {
	    key: "syncWithApi",
	    value: function syncWithApi() {
	      var _this3 = this;
	
	      this.holdUser = true;
	      this.setLoader();
	      this.$events.getEventCompanyDescription().then(function (data) {
	        _this3.event.company_info = data.data.company.description;
	        _this3.$timeout(function () {
	          _this3.holdUser = false;
	          _this3.unSetLoader();
	          _this3.removeLoadingBar();
	        }, 2000);
	      });
	    }
	  }, {
	    key: "removeLoadingBar",
	    value: function removeLoadingBar() {
	      var _this4 = this;
	
	      this.$timeout(function () {
	        if (_this4.$rootScope && _this4.$rootScope.progress) {
	          _this4.$rootScope.progress.complete();
	        }
	      }, 800);
	    }
	  }, {
	    key: "validate",
	    value: function validate() {
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	    }
	  }, {
	    key: "saveDescription",
	    value: function saveDescription() {
	      var _this5 = this;
	
	      this.$events.saveEventCompanyDescription(this.event.company_info).then(function (data) {
	        _this5.$tracking.reportPostAJobSubmitStep("company info");
	        console.log("Saved company info:", data);
	      });
	    }
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      if (this.holdUser === true) {
	        return;
	      }
	      this.saveDescription();
	      this.$rootScope.$emit(_variables.TRIGGER_NEXT_EVENT_NAME, {
	        walkthroughState: this.walkthroughState
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }]);
	
	  return CompanyinfoController;
	}();
	
	CompanyinfoController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = CompanyinfoController;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _questions = __webpack_require__(344);
	
	var _questions2 = _interopRequireDefault(_questions);
	
	var _questions3 = __webpack_require__(345);
	
	var _questions4 = _interopRequireDefault(_questions3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var questionsComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _questions2.default,
	  controller: _questions4.default,
	  controllerAs: "vm"
	};
	
	exports.default = questionsComponent;

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"question-container\">\n  <div class=\"main-title\">Questionnaire</div>\n  <div class=\"main-text\">\n    <pajtooltip />Choose a maximum of 5 questions that applicants will be required to answer when applying to this job.<br /><br />\n\n    Questions must follow guidelines for equal opportunity employers and should not ask about an applicant’s race, color, religion, sex, sexual\n    orientation, gender identity, national origin, veteran or disability status.\n  </div>\n  <div class=\"main-select-container\" style=\"margin-bottom: 16px\">\n    <select\n      style=\"padding-right: 40px; overflow: hidden; text-overflow: ellipsis\"\n      ng-model=\"vm.newQuesiton\"\n      ng-change=\"vm.addQuestion(vm.newQuesiton)\"\n      class=\"main-select\"\n    >\n      <option disabled value=\"\" selected>Select a question</option>\n      <option value=\"{{q}}\" ng-repeat=\"q in vm.QUESTIONS\">{{q}}</option>\n      <option value=\"CUSTOM\" selected>Custom</option>\n    </select>\n    <i class=\"fas fa-caret-down\"></i>\n  </div>\n  <div class=\"main-input-container\" ng-if=\"vm.showCustom\">\n    <input placeholder=\"Type a custom question\" class=\"main-input\" style=\"padding-right: 40px\" ng-model=\"vm.question\" maxlength=\"250\" />\n    <i class=\"fas fa-plus\" style=\"color: #74cf59\" ng-click=\"vm.addQuestion(vm.question, true)\"></i>\n  </div>\n  <div class=\"main-text-area-length\" ng-if=\"vm.showCustom\">{{vm.question && vm.question.length ? vm.question.length : 0 }}/250</div>\n  <div ng-repeat=\"question in vm.event.questions track by $index\">\n    <div class=\"main-input-container question-input-container\">\n      <div class=\"main-input question-input\" maxlength=\"500\" ng-disabled=\"true\">{{question.question}}</div>\n      <i class=\"fas fa-trash-alt\" ng-click=\"vm.removeQuestion($index, question); vm.$tracking.reportPostAJobClick('delete question');\"></i>\n    </div>\n  </div>\n  <div class=\"main-next-button\" ng-class=\"{'disabled': !vm.event.questions || !vm.event.questions.length}\" ng-click=\"vm.goNext()\">Next</div>\n</div>\n"

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(309);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QuestionsController = function () {
	  function QuestionsController($localStorage, $rootScope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    _classCallCheck(this, QuestionsController);
	
	    this.name = "questions";
	    this.walkthroughState = _variables.WALKTHROUGH_STATES.QUESTIONS;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	
	    this.API_FIELDS = "surveyQuestions.id,surveyQuestions.name,surveyQuestions.question,surveyQuestions.questionType";
	
	    this.ALL_QUESTIONS = ["Can you make all of the shifts?", "Do you have relevant work experience?", "Are you looking for permanent employment?", "Are you flexible to work extended hours?", "Have you worked for this company before?", "Have you worked for similar companies; which ones?"];
	
	    this.QUESTIONS = ["Can you make all of the shifts?", "Do you have relevant work experience?", "Are you looking for permanent employment?", "Are you flexible to work extended hours?", "Have you worked for this company before?", "Have you worked for similar companies; which ones?"];
	
	    console.log("Initialize Questions", localStorage.savingQuestions);
	  }
	
	  _createClass(QuestionsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.filterQuestions();
	
	      this.syncWithApi();
	    }
	  }, {
	    key: "syncWithApi",
	    value: function syncWithApi() {
	      var _this = this;
	
	      this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then(function (data) {
	        if (!(localStorage.savingQuestions && JSON.parse(localStorage.savingQuestions))) {
	          console.log("Updating Questions");
	
	          _this.event.questions = data.data.surveyQuestions;
	          _this.event.questions = _this.event.questions.sort(function (a, b) {
	            return a.id - b.id;
	          });
	          _this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	          _this.filterQuestions();
	        } else {
	          console.warn("Skipping Question Update");
	        }
	      }).catch(function (err) {
	        console.error("Failed to LOAD questions from API:", err);
	      });
	    }
	  }, {
	    key: "filterQuestions",
	    value: function filterQuestions() {
	      if (!this.event.questions) return;
	
	      var questions = this.event.questions.map(function (q) {
	        return q.question;
	      });
	
	      this.QUESTIONS = _.difference(this.ALL_QUESTIONS, questions);
	    }
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      if (this.showCustom) {
	        this.addQuestion(this.question, true);
	      }
	
	      this.$rootScope.$emit(_variables.TRIGGER_NEXT_EVENT_NAME, {
	        walkthroughState: this.walkthroughState
	      });
	    }
	  }, {
	    key: "addQuestion",
	    value: function addQuestion(q, custom) {
	      var _this2 = this;
	
	      if (!q || !q.length) return;
	
	      if (q === "CUSTOM") {
	        this.newQuesiton = null;
	        this.showCustom = true;
	        return;
	      }
	
	      if (custom) {
	        this.showCustom = false;
	      }
	
	      if (this.event.questions.length >= 5) {
	        this.newQuesiton = null;
	        this.$tracking.reportPostAJobSubmitStep("more than 5 questions");
	        return alert("You can only have a maximum of 5 questions.");
	      }
	
	      var qo = {
	        question: q,
	        questionType: { id: 1, name: "Text", description: null },
	        editing: false
	      };
	
	      this.event.questions.push(qo);
	
	      this.filterQuestions();
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	
	      var data = {
	        event_id: this.event.id,
	        questions: this.event.questions
	      };
	
	      localStorage.savingQuestions = true;
	
	      this.$events.updateQuestion(data).then(function (data) {
	        localStorage.savingQuestions = false;
	
	        _this2.$tracking.reportPostAJobSubmitStep("questions");
	
	        if (custom) {
	          _this2.$tracking.reportPostAJobSubmitStep("custom question");
	        } else {
	          _this2.$tracking.reportPostAJobSubmitStep("predefined question");
	        }
	
	        console.log("Saved questions:", data);
	        _this2.$timeout(function () {
	          _this2.syncWithApi();
	        }, 500);
	      }).catch(function (err) {
	        console.error("Failed to SAVE questions to API:", err);
	      });
	
	      this.question = "";
	    }
	  }, {
	    key: "removeQuestion",
	    value: function removeQuestion(index, question) {
	      var _this3 = this;
	
	      var payload = {
	        event_id: this.event.id,
	        question_ids: [question.id]
	      };
	
	      localStorage.savingQuestions = true;
	
	      this.$events.deleteSurveyQuestions(payload).then(function (data) {
	        localStorage.savingQuestions = false;
	        console.log("Deleted question:", data);
	        _this3.syncWithApi();
	      }).catch(function (err) {
	        console.error("Failed to DELETE questions to API:", err);
	      });
	
	      this.event.questions.splice(index, 1);
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, {});
	      this.filterQuestions();
	    }
	  }]);
	
	  return QuestionsController;
	}();
	
	QuestionsController.$inject = ["$localStorage", "$rootScope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = QuestionsController;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _requirements = __webpack_require__(347);
	
	var _requirements2 = _interopRequireDefault(_requirements);
	
	var _requirements3 = __webpack_require__(348);
	
	var _requirements4 = _interopRequireDefault(_requirements3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requirementsComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _requirements2.default,
	  controller: _requirements4.default,
	  controllerAs: "vm"
	};
	
	exports.default = requirementsComponent;

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"question-container requirements-container\">\n  <div class=\"main-title\">Requirements</div>\n  <!--    <div class=\"main-text\" style=\"margin-top: -16px; margin-bottom: 8px\"><i>Optional step</i></div>-->\n\n  <div class=\"requirements-box\">\n    <div class=\"requirements-box-label\">Selected Requirements</div>\n\n    <div ng-if=\"!vm.event.requirements || vm.event.requirements.length < 1\" class=\"requirements-box-no-option\">\n      <div style=\"font-weight: 500\"><pajtooltip /> Optional Step</div>\n      Select requirements below to add to your posting\n    </div>\n    <div ng-repeat=\"question in vm.event.requirements track by $index\">\n      <div class=\"main-input-container question-input-container\">\n        <div\n          style=\"padding-right: 40px; overflow: hidden; text-overflow: ellipsis\"\n          class=\"main-input question-input\"\n          ng-model=\"question.name\"\n          maxlength=\"500\"\n          ng-disabled=\"true\"\n        >\n          {{question.name}}\n        </div>\n        <i class=\"fas fa-trash-alt\" ng-click=\"vm.removeRequirement($index, question); vm.$tracking.reportPostAJobClick('delete requirement');\"></i>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"requirements-box\" style=\"margin-top: 32px\">\n    <div class=\"requirements-box-label\">Select Requirements Below</div>\n\n    <div class=\"main-input-container\" style=\"margin-bottom: 4px\">\n      <input placeholder=\"Filter requirements \" class=\"main-input\" ng-change=\"vm.filterRequirements();\" ng-model=\"vm.requirements_filter\" />\n    </div>\n\n    <div class=\"requirements-box-options\">\n      <div ng-repeat=\"r in vm.PHYSICAL_REQUIREMENTS track by $index\">\n        <div class=\"main-input-container question-input-container\" ng-click=\"vm.addRequirement(r);\">\n          <div\n            style=\"padding-right: 40px; overflow: hidden; text-overflow: ellipsis; cursor: pointer\"\n            class=\"main-input question-input\"\n            ng-model=\"question.name\"\n            maxlength=\"500\"\n            ng-disabled=\"true\"\n          >\n            {{r.name}}\n          </div>\n          <i class=\"fas fa-plus\"></i>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <!--    <div class=\"main-select-container\">-->\n  <!--        <select-->\n  <!--            style=\"padding-right: 40px; overflow: hidden; text-overflow: ellipsis\"-->\n  <!--            ng-model=\"vm.newRequirement\"-->\n  <!--            ng-change=\"vm.addRequirement(vm.newRequirement)\"-->\n  <!--            class=\"main-select\"-->\n  <!--        >-->\n  <!--            <option disabled value=\"\" selected>Requirements</option>-->\n  <!--            <option value=\"{{r}}\" ng-repeat=\"r in vm.PHYSICAL_REQUIREMENTS\">{{r.name}}</option>-->\n  <!--        </select>-->\n  <!--        <i class=\"fas fa-caret-down\"></i>-->\n  <!--    </div>-->\n\n  <!--    <div class=\"main-input-container\" style=\"margin-top: 16px\">-->\n  <!--        <input class=\"main-input\" ng-model=\"vm.question\" maxlength=\"500\"/>-->\n  <!--        <i class=\"fas fa-plus\" style=\"color: #74cf59;\" ng-click=\"vm.addRequirement(vm.question)\"></i>-->\n  <!--    </div>-->\n  <div class=\"main-next-button\" ng-click=\"vm.goNext()\">{{vm.event.requirements && vm.event.requirements.length ? 'Next' : 'Skip'}}</div>\n</div>\n"

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(309);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RequirementsController = function () {
	  function RequirementsController($localStorage, $rootScope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    _classCallCheck(this, RequirementsController);
	
	    this.name = "requirements";
	    this.walkthroughState = _variables.WALKTHROUGH_STATES.REQUIREMENTS;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	
	    this.ALL_PHYSICAL_REQUIREMENTS = [];
	    this.PHYSICAL_REQUIREMENTS = [];
	
	    this.requirements_filter = "";
	  }
	
	  _createClass(RequirementsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	
	      this.requirements_filter = "";
	
	      this.$events.getAllShiftRequirements().then(function (s) {
	        _this.ALL_PHYSICAL_REQUIREMENTS = s.data;
	        _this.PHYSICAL_REQUIREMENTS = s.data;
	        _this.filterRequirements();
	      });
	
	      this.$events.getShiftRequirements(this.event.id).then(function (s) {
	        _this.event.requirements = s.data;
	        _this.filterRequirements();
	      });
	    }
	  }, {
	    key: "filterRequirements",
	    value: function filterRequirements() {
	      var _this2 = this;
	
	      if (!this.ALL_PHYSICAL_REQUIREMENTS || !this.ALL_PHYSICAL_REQUIREMENTS.length || !this.event.requirements) return;
	
	      this.PHYSICAL_REQUIREMENTS = _.differenceBy(this.ALL_PHYSICAL_REQUIREMENTS, this.event.requirements, "id");
	      this.PHYSICAL_REQUIREMENTS = _.filter(this.PHYSICAL_REQUIREMENTS, function (r) {
	        if (!r || !r.name) return false;
	        return (r.name || "").toLowerCase().indexOf((_this2.requirements_filter || "").toLowerCase()) !== -1;
	      });
	    }
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      this.$rootScope.$emit(_variables.TRIGGER_NEXT_EVENT_NAME, {
	        walkthroughState: this.walkthroughState
	      });
	    }
	  }, {
	    key: "addRequirement",
	    value: function addRequirement(q) {
	      var _this3 = this;
	
	      console.log(q);
	      if (!q) return;
	
	      if (this.event.requirements.length >= 5) {
	        this.newRequirement = null;
	        this.$tracking.reportPostAJobSubmitStep("more than 5 requirements");
	        return alert("You can only have a maximum of 5 requirements.");
	      }
	
	      try {
	        if ((typeof q === "undefined" ? "undefined" : _typeof(q)) !== "object") q = JSON.parse(q);
	      } catch (e) {
	        return console.error(e);
	      }
	
	      this.event.requirements.push(q);
	      this.newRequirement = null;
	      this.requirements_filter = "";
	
	      this.filterRequirements();
	
	      this.$events.addShiftRequirement(this.event.id, q.id, this.event.requirements.length).then(function (e) {
	        _this3.$tracking.reportPostAJobSubmitStep("requirements");
	        console.log("Added shift requirement:", e);
	      });
	    }
	  }, {
	    key: "removeRequirement",
	    value: function removeRequirement(index, requirement) {
	      this.event.requirements.splice(index, 1);
	
	      this.filterRequirements();
	
	      this.$events.removeShiftRequirement(this.event.id, requirement.id).then(function (e) {
	        console.log("Removed shift requirement:", e);
	      });
	    }
	  }]);
	
	  return RequirementsController;
	}();
	
	RequirementsController.$inject = ["$localStorage", "$rootScope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = RequirementsController;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hiringmanager = __webpack_require__(350);
	
	var _hiringmanager2 = _interopRequireDefault(_hiringmanager);
	
	var _hiringmanager3 = __webpack_require__(351);
	
	var _hiringmanager4 = _interopRequireDefault(_hiringmanager3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hiringmanagerComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _hiringmanager2.default,
	  controller: _hiringmanager4.default,
	  controllerAs: "vm"
	};
	
	exports.default = hiringmanagerComponent;

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <div class=\"main-title\">Hiring manager</div>\n  <div class=\"main-text\">Designate a hiring manager for this job; the hiring manager will serve as the main point of contact for the job.</div>\n  <div class=\"main-select-container\">\n    <select ng-change=\"vm.updateHiringManager()\" ng-model=\"vm.event.hiring_manager\" class=\"main-select\">\n      <option ng-repeat=\"m in vm.managers\" value=\"{{m.id}}\">{{m.str}}</option>\n    </select>\n    <i class=\"fas fa-caret-down\"></i>\n  </div>\n\n  <div ng-if=\"vm.savingStep\" class=\"main-next-button\" style=\"opacity: 0.5; cursor: wait\">\n    Saving <i class=\"fas fa-spin fa-spinner fa-1x fa-fw\"></i>\n  </div>\n  <div ng-if=\"!vm.savingStep\" class=\"main-next-button\" ng-class=\"{'disabled': !vm.event.hiring_manager}\" ng-click=\"vm.goNext()\">Next</div>\n</div>\n"

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(309);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HiringmanagerController = function () {
	  function HiringmanagerController($localStorage, $rootScope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events, companies) {
	    _classCallCheck(this, HiringmanagerController);
	
	    this.name = "hiringmanager";
	    this.walkthroughState = _variables.WALKTHROUGH_STATES.HIRE;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	    this.$companies = companies;
	
	    this.API_FIELDS = "subEvents.deduppedJobbles.id, subEvents.deduppedJobbles.manager.id";
	
	    this.managers = this.$rootScope.hiring_managers;
	  }
	
	  _createClass(HiringmanagerController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.event.hiring_manager = this.event.hiring_manager + "";
	      this.syncWithApi();
	      this.getCompanyUsers();
	    }
	  }, {
	    key: "syncWithApi",
	    value: function syncWithApi() {
	      var _this = this;
	
	      this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then(function (data) {
	        _this.jobble_id = data.data.subEvents[0].deduppedJobbles[0].id;
	        var manager = data.data.subEvents[0].deduppedJobbles[0].manager.id;
	        _this.event.hiring_manager = manager + "";
	      });
	    }
	  }, {
	    key: "getCompanyUsers",
	    value: function getCompanyUsers(manager) {
	      var _this2 = this;
	
	      this.$companies.getCompanyUsers().then(function (response) {
	        _this2.constructOptions(response.data, manager);
	      }, function (error) {});
	    }
	  }, {
	    key: "constructOptions",
	    value: function constructOptions(users) {
	      var user_array = [];
	
	      users.forEach(function (user) {
	        var user_map = {};
	
	        if (user.homeContactInfo.phoneMobile) {
	          user_map.firstName = user.firstName;
	          user_map.lastName = user.firstName;
	          user_map.phone = user.homeContactInfo.phoneMobile;
	          user_map.id = user.id;
	          user_map.str = user.firstName + " " + user.lastName;
	          user_map.email = user.email;
	          user_array.push(user_map);
	        } else {
	          user.homeContactInfo.phoneMobile = "--";
	          user_map.firstName = user.firstName;
	          user_map.lastName = user.firstName;
	          user_map.phone = user.homeContactInfo.phoneMobile;
	          user_map.id = user.id;
	          user_map.str = user.firstName + " " + user.lastName;
	          user_map.email = user.email;
	          user_array.push(user_map);
	        }
	      });
	
	      this.managers = user_array;
	    }
	  }, {
	    key: "updateHiringManager",
	    value: function updateHiringManager() {
	      var _this3 = this;
	
	      this.$timeout(function () {
	        _this3.savingStep = true;
	      });
	
	      this.$events.saveEventHiringManager(this.jobble_id, this.event.hiring_manager).then(function (data) {
	        _this3.$timeout(function () {
	          _this3.savingStep = false;
	        });
	        console.log("Saved hiring manager:", data);
	      });
	    }
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      this.$tracking.reportPostAJobSubmitStep("hiring manager");
	      this.$rootScope.$emit(_variables.TRIGGER_NEXT_EVENT_NAME, {
	        walkthroughState: this.walkthroughState
	      });
	    }
	  }]);
	
	  return HiringmanagerController;
	}();
	
	HiringmanagerController.$inject = ["$localStorage", "$rootScope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events", "companies"];
	
	exports.default = HiringmanagerController;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _payrate = __webpack_require__(353);
	
	var _payrate2 = _interopRequireDefault(_payrate);
	
	var _payrate3 = __webpack_require__(354);
	
	var _payrate4 = _interopRequireDefault(_payrate3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var payrateComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _payrate2.default,
	  controller: _payrate4.default,
	  controllerAs: "vm"
	};
	
	exports.default = payrateComponent;

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <div class=\"main-title\">Pay rate</div>\n  <div class=\"main-text\">\n    <pajtooltip />\n    Based on the position type selected for this shift, we recommend a minimum rate of $20.\n  </div>\n  <div class=\"main-input-container pay-input\">\n    <i class=\"fas fa-dollar-sign\"></i>\n    <input\n      class=\"main-input noscroll\"\n      type=\"number\"\n      placeholder=\"20 (recommended)\"\n      ng-change=\"vm.validate(); vm.calculateCosts('input')\"\n      ng-model=\"vm.event.hourly_rate\"\n      min=\"12\"\n      ma=\"50\"\n      ng-if=\"vm.event.is_w2 != true\"\n      scroll\n    />\n    <input\n      class=\"main-input\"\n      type=\"number\"\n      placeholder=\"20 (recommended)\"\n      ng-change=\"vm.validate($event); vm.calculateCosts('input')\"\n      ng-model=\"vm.event.hourly_rate\"\n      min=\"12\"\n      max=\"70\"\n      ng-if=\"vm.event.is_w2 == true\"\n      scroll\n    />\n  </div>\n\n  <div style=\"margin-top: 8px; color: red\" ng-if=\"(!vm.event.hourly_rate || vm.event.hourly_rate < 12) && vm.pay_edited && vm.event.is_w2 != true\">\n    Jobblers must be paid a minimum of $12/hour\n  </div>\n\n  <div style=\"margin-top: 8px; color: red\" ng-if=\"(!vm.event.hourly_rate || vm.event.hourly_rate < 12) && vm.pay_edited && vm.event.is_w2 == true\">\n    Jobblers must be paid a minimum of $12/hour\n  </div>\n  <div\n    style=\"\n      font-size: 12px;\n      font-weight: 600;\n      letter-spacing: 0.4px;\n      padding: 16px;\n      margin: auto;\n      margin-top: 32px;\n      width: 100%;\n      max-width: 276px;\n      border-radius: 6px;\n      border: 1px solid #979797;\n      box-shadow: 0 25px 50px 0 rgba(78, 81, 144, 0.07);\n    \"\n  >\n    <div style=\"font-size: 16px\"><i style=\"margin-right: 8px\" class=\"fas fa-receipt\"></i>Estimated cost summary</div>\n    <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\"></div>\n    <div style=\"\">\n      <div style=\"display: flex; margin-bottom: 8px\">\n        <div style=\"flex: 1\">HOURLY RATE</div>\n        <div style=\"flex: 0 0 30px; text-align: right\">${{vm.event.hourly_rate || \"00\" | number : 2}}</div>\n      </div>\n      <div style=\"display: flex; margin-bottom: 8px\">\n        <div style=\"flex: 1\">TOTAL PAID HOURS</div>\n        <div style=\"flex: 0 0 30px; text-align: right\">{{vm.total_hours || \"00\" | number : 2}}</div>\n      </div>\n      <div style=\"display: flex; margin-bottom: 8px\">\n        <div style=\"flex: 1\">OPENINGS</div>\n        <div style=\"flex: 0 0 30px; text-align: right\">{{vm.event.openings || \"0\"}}</div>\n      </div>\n    </div>\n    <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\"></div>\n    <div>\n      <div style=\"display: flex; margin-bottom: 8px\">\n        <div style=\"flex: 1\">JOBBLER PAYMENTS</div>\n        <div style=\"flex: 0 0 30px; text-align: right\">${{vm.jobbler_payments || \"00\" | number : 2}}</div>\n      </div>\n      <div style=\"display: flex; margin-bottom: 8px\">\n        <div style=\"flex: 1\"><em>+ PLATFORM FEE</em></div>\n        <div style=\"flex: 0 0 30px; text-align: right\">${{vm.platform_fee_cost || \"00\" | number : 2}}</div>\n      </div>\n    </div>\n    <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\"></div>\n    <div>\n      <div style=\"display: flex; margin-bottom: 8px\">\n        <div style=\"flex: 1\">ESTIMATED <span ng-if=\"vm.event.is_long_term\">WEEKLY </span>COST</div>\n        <div style=\"flex: 0 0 30px; text-align: right\">${{vm.estimated_cost || \"00\" | number : 2}}</div>\n      </div>\n      <div style=\"display: flex; margin-bottom: 8px\" ng-if=\"vm.event.is_long_term\">\n        <div style=\"flex: 1\">WEEKS</div>\n        <div style=\"flex: 0 0 30px; text-align: right\">{{vm.total_weeks || \"0\"}}</div>\n      </div>\n      <div style=\"display: flex; margin-bottom: 8px\" ng-if=\"vm.event.is_long_term\">\n        <div style=\"flex: 1\">ESTIMATED <span>TOTAL</span> COST</div>\n        <div style=\"flex: 0 0 30px; text-align: right\">${{vm.estimated_total_cost || \"00\" | number : 2}}</div>\n      </div>\n    </div>\n  </div>\n\n  <div>\n    <div class=\"event-team-selection-box\" ng-if=\"$root.teamsSimple.length > 0\">\n      <h4><i class=\"fas fa-users\"></i>Select teams</h4>\n      <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\"></div>\n      <!--\n            <p>ONLY SELECTED TEAMS FROM BELOW WILL BE ABLE TO SEE AND APPLY THIS JOB</p>\n            -->\n      <select\n        chosen\n        multiple\n        style=\"width: 95%\"\n        placeholder-text-multiple=\"'Choose teams'\"\n        ng-model=\"vm.event.cloudsForJobblePost\"\n        ng-options=\"team.id as team.name for team in $root.teamsSimple\"\n      >\n        <option value=\"\"></option>\n      </select>\n    </div>\n  </div>\n\n  <div ng-if=\"vm.savingStep\" class=\"main-next-button\" style=\"opacity: 0.5; cursor: wait\">\n    Saving <i class=\"fas fa-spin fa-spinner fa-1x fa-fw\"></i>\n  </div>\n  <div\n    ng-if=\"!vm.savingStep\"\n    class=\"main-next-button\"\n    ng-class=\"{'disabled': !vm.event.hourly_rate || vm.event.hourly_rate < 7.25}\"\n    ng-click=\"vm.goNext()\"\n  >\n    Create job posting\n  </div>\n</div>\n<paymentdialog></paymentdialog>\n\n<div class=\"confirm-roster-download\">\n  <div class=\"modal fade\" id=\"job-creation-loader\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\" data-backdrop=\"static\">\n    <div class=\"modal-dialog modal-m regi-form-board partner\" role=\"document\">\n      <div class=\"modal-gradient-banner\"></div>\n      <div class=\"modal-content\">\n        <div class=\"modal-fixed-bar\"></div>\n        <div class=\"modal-content-container\">\n          <div>\n            <h3><i style=\"color: #62c046\" class=\"fas fa-spin fa-spinner fa-1x fa-fw\"></i> Thank you for posting a new job!</h3>\n            <p>Please allow our system a few seconds to publish your job and notify the relevant Jobblers!</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(309);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PayrateController = function () {
	  function PayrateController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, $location, TrackingService, events, companies) {
	    var _this = this;
	
	    _classCallCheck(this, PayrateController);
	
	    this.name = "payrate";
	    this.walkthroughState = _variables.WALKTHROUGH_STATES.PAY;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$location = $location;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	    this.$companies = companies;
	    this.calculatingCostsForFirstTime = 0;
	
	    this.API_FIELDS = "isLongTerm,weeks,subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.payPerHour,subEvents.deduppedJobbles.jobblePoolId";
	
	    this.rate = 15;
	
	    this.PostAJobSaveAndExitListener = this.$rootScope.$on("PostAJobSaveAndExit", function ($event, params) {
	      _this.savePay();
	    });
	
	    this.WorkflowUpdateListener = this.$rootScope.$on(_variables.UPDATE_WORKFLOW_EVENT_NAME, function ($event, params) {
	      if (params && params.from_pay) return;
	      _this.savePay();
	    });
	
	    this.$scope.$on("$destroy", this.PostAJobSaveAndExitListener);
	    this.$scope.$on("$destroy", this.WorkflowUpdateListener);
	  }
	
	  _createClass(PayrateController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this2 = this;
	
	      this.setLoader();
	      /*
	      this.$timeout(() => {
	        if (!this.event.hourly_rate) {
	          this.event.hourly_rate = 20;
	        }
	      });
	      */
	
	      this.$timeout(function () {
	        /*
	        if (!this.event.hourly_rate) {
	          this.event.hourly_rate = 20;
	        }
	         */
	
	        console.log("payrate - onInit");
	        console.dir(_this2.event);
	
	        var complete = _this2.$auth.hasCompletedPaymentInformation();
	
	        _this2.calculateCosts("input");
	        var currentUser = _this2.$auth.getUserData();
	
	        var rate = currentUser.company.defaultPlan.companyFeePct;
	        var autoAccept = currentUser.company.autoAccept;
	        var autoManage = currentUser.company.autoManage;
	
	        _this2.$timeout(function () {
	          _this2.rate = rate;
	          _this2.autoAccept = autoAccept;
	          _this2.autoManage = autoManage;
	        });
	
	        _this2.syncWithApi();
	        _this2.loadTeams();
	      }, 1000);
	    }
	  }, {
	    key: "$onChanges",
	    value: function $onChanges() {
	      this.calculateCosts();
	    }
	  }, {
	    key: "syncWithApi",
	    value: function syncWithApi() {
	      var _this3 = this;
	
	      this.disableAllowedLinks();
	
	      if (this.$location.$$search.cid) {
	        this.$location.search("cid", null);
	        this.$state.transitionTo("postashiftwalkthrough", { eid: this.event.id }, { notify: false });
	        this.$rootScope.$emit("SendToDateTime", {});
	      }
	
	      this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then(function (data) {
	        _this3.jobble_id = data.data.subEvents[0].deduppedJobbles[0].id;
	        _this3.jobble_pool_id = data.data.subEvents[0].deduppedJobbles[0].jobblePoolId;
	
	        console.log("syncWithApi paycontroller", data.data);
	
	        _this3.event.is_long_term = data.data.isLongTerm;
	        _this3.event.numberOfWeeksToScheduleJob = data.data.weeks + "";
	
	        var currentUser = _this3.$auth.getUserData();
	        var rate = currentUser.company.defaultPlan.companyFeePct;
	        var payPerHour = data.data.subEvents[0].deduppedJobbles[0].payPerHour;
	
	        var epi = 0.00001;
	
	        var p = 100 - rate * 100;
	        payPerHour = payPerHour * p / 100 / 100;
	
	        if (!_this3.$location.$$search.eid) {
	          _this3.event.hourly_rate = Math.round((payPerHour + epi) * 100) / 100;
	        }
	
	        if (!_this3.event.hourly_rate) {
	          _this3.event.hourly_rate = 20;
	        }
	
	        _this3.calculateCosts();
	        _this3.validate();
	        _this3.enableAllowedLinks();
	
	        _this3.$timeout(function () {
	          _this3.unSetLoader();
	        }, 300);
	      });
	    }
	  }, {
	    key: "enableAllowedLinks",
	    value: function enableAllowedLinks() {
	      console.log("enableAllowedLinks - pay rate");
	      console.dir(this.allowed);
	    }
	  }, {
	    key: "disableAllowedLinks",
	    value: function disableAllowedLinks() {
	      console.log("disableAllowedLinks - pay rate");
	      console.dir(this.allowed);
	      //allowed {"openings":true,"position_type":true,"location":true,"shifts":-71.05228,"shift_title":true,"company_info":true,"shift_description":true,"arrival_instructions":true,"dress_code":true,"requirements":true,"hiring_manager":true,"hourly_rate":true}
	    }
	  }, {
	    key: "savePay",
	    value: function savePay() {
	      var _this4 = this;
	
	      this.$timeout(function () {
	        _this4.$rootScope.$emit("LockLeftPanel", {});
	      });
	
	      this.setLoader();
	
	      return new Promise(function (resolve) {
	        var currentUser = _this4.$auth.getUserData();
	        var rate = currentUser.company.defaultPlan.companyFeePct;
	        var epi = 0.00001;
	
	        var cost = parseFloat(_this4.event.hourly_rate);
	
	        if (cost < 12) {
	          console.warn("pay rate is too low");
	        }
	
	        var costPlusMarkUp = Math.round(cost * (1 + rate));
	
	        if (!_this4.jobble_id) return resolve();
	
	        _this4.$timeout(function () {
	          _this4.$events.saveEventPayRate(_this4.jobble_id, cost).then(function (data) {
	            console.log("Saved pay:", data);
	            _this4.$rootScope.$emit("UnLockLeftPanel", {});
	            _this4.unSetLoader();
	            resolve();
	          });
	        }, 1000);
	      });
	    }
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      var _this5 = this;
	
	      console.log("job post jobble id", this.jobble_id);
	
	      if (!this.jobble_id) {
	        alert("There was an error saving your data. Please refresh the page to reload the job.");
	        return;
	      }
	
	      var user = this.$auth.getUserData();
	
	      var invoiceCustomer = null;
	
	      if (user.company.enableSubscription === true && user.company.sendInvoice === true || user.company.payByInvoice === true) {
	        invoiceCustomer = true;
	      } else {
	        invoiceCustomer = false;
	      }
	
	      var completedPaymentInformation = this.$auth.hasCompletedPaymentInformation();
	
	      this.triggerLoadingModal();
	
	      if (!completedPaymentInformation.completed && invoiceCustomer === false) {
	        this.$timeout(function () {
	          _this5.savingStep = true;
	          _this5.setLoader();
	        });
	
	        var team_ids = this.event.cloudsForJobblePost;
	        console.log("Exclusive team IDs:", team_ids);
	
	        this.savePay().then(function () {
	          _this5.$tracking.reportPostAJobSubmitStep("pay rate");
	          _this5.$timeout(function () {
	            _this5.$events.publishEvent(_this5.jobble_id, true).then(function (data) {
	              _this5.$timeout(function () {
	                _this5.savingStep = false;
	              });
	
	              _this5.setAutomationForJob();
	            }).catch(function (err) {
	              _this5.$timeout(function () {
	                _this5.savingStep = false;
	                _this5.closeLoadingModal();
	              });
	
	              console.error(err);
	
	              alert("There was an error publishing your job while attempting to publish the job.\n\nError:\n" + JSON.stringify(err, null, 2));
	            });
	          }, 2000);
	        }).catch(function (err) {
	          _this5.$timeout(function () {
	            _this5.savingStep = false;
	            _this5.closeLoadingModal();
	          });
	          console.error(err);
	          alert("There was an error publishing your job while attempting to save the pay rate.\n\nError:\n" + JSON.stringify(err, null, 2));
	        });
	      } else {
	        this.$timeout(function () {
	          _this5.savingStep = true;
	          _this5.setLoader();
	        });
	
	        var _team_ids = this.event.cloudsForJobblePost;
	        console.log("Exclusive team IDs:", _team_ids);
	
	        this.savePay().then(function () {
	          _this5.$tracking.reportPostAJobSubmitStep("pay rate");
	
	          if (_team_ids && _team_ids.length) {
	            _this5.$timeout(function () {
	              _this5.$events.pushTeamsOntoEvent(_this5.event.id, _team_ids, null, true).then(function (response) {
	                console.log("pushTeamsOntoEvent resp");
	                console.dir(response);
	                _this5.$timeout(function () {
	                  _this5.$events.publishEvent(_this5.jobble_id, true).then(function (data) {
	                    console.log("Published exclusive event:", data);
	                    _this5.$tracking.reportPostAJobSubmitStep("publish job");
	                    _this5.$tracking.reportPostAJobSubmitStep("publish exclusive job");
	                    _this5.$timeout(function () {
	                      _this5.setAutomationForJob();
	                    }, 1500);
	                  }).catch(function (err) {
	                    _this5.$timeout(function () {
	                      _this5.savingStep = false;
	                      _this5.closeLoadingModal();
	                    });
	                    console.error(err);
	                    alert("There was an error publishing your job while attempting to publish the job.\n\nError:\n" + JSON.stringify(err, null, 2));
	                  });
	                }, 3000);
	              }).catch(function (err) {
	                _this5.$timeout(function () {
	                  _this5.savingStep = false;
	                  _this5.closeLoadingModal();
	                });
	                console.error(err);
	                alert("There was an error publishing your job while attempting to add the team.\n\nError:\n" + JSON.stringify(err, null, 2));
	              });
	            }, 1500);
	          } else {
	            _this5.$timeout(function () {
	              _this5.$events.publishEvent(_this5.jobble_id, true).then(function (data) {
	                _this5.$tracking.reportPostAJobSubmitStep("publish job");
	                console.log("Published event:", data);
	
	                _this5.$tracking.reportPostAJobSubmitStep("publish public job");
	
	                if (_this5.event.is_long_term && _this5.event.numberOfWeeksToScheduleJob && parseFloat(_this5.event.numberOfWeeksToScheduleJob) > 0) {
	                  //this.setScheduleForJob();
	                }
	
	                _this5.$timeout(function () {
	                  //this.savingStep = false;
	                  _this5.setAutomationForJob();
	                }, 1500);
	              }).catch(function (err) {
	                _this5.$timeout(function () {
	                  _this5.savingStep = false;
	                  _this5.closeLoadingModal();
	                });
	                console.error(err);
	                alert("There was an error publishing your job while attempting to publish the job.\n\nError:\n" + JSON.stringify(err, null, 2));
	              });
	            }, 2000);
	          }
	        }).catch(function (err) {
	          _this5.$timeout(function () {
	            _this5.savingStep = false;
	            _this5.closeLoadingModal();
	          });
	          console.error(err);
	          alert("There was an error publishing your job while attempting to save the pay rate.\n\nError:\n" + JSON.stringify(err, null, 2));
	        });
	      }
	    }
	  }, {
	    key: "closeLoadingModal",
	    value: function closeLoadingModal() {
	      console.log("closeLoadingModal");
	      this.$timeout(function () {
	        $("#job-creation-loader").modal("toggle");
	      });
	    }
	  }, {
	    key: "triggerLoadingModal",
	    value: function triggerLoadingModal() {
	      console.log("triggerLoadingModal");
	      this.$timeout(function () {
	        $("#job-creation-loader").modal();
	      });
	    }
	  }, {
	    key: "setSchedule",
	    value: function setSchedule() {
	      var _this6 = this;
	
	      if (this.event.is_long_term && this.event.numberOfWeeksToScheduleJob && parseFloat(this.event.numberOfWeeksToScheduleJob) > 0) {
	        this.setScheduleForJob();
	      } else {
	        this.$timeout(function () {
	          _this6.closeLoadingModal();
	        }, 3500);
	
	        this.$timeout(function () {
	          _this6.$state.go("jobsdashboard");
	        }, 4000);
	        return;
	      }
	    }
	  }, {
	    key: "setScheduleForJob",
	    value: function setScheduleForJob() {
	      var _this7 = this;
	
	      var weeks = this.event.numberOfWeeksToScheduleJob;
	      weeks = parseFloat(weeks);
	
	      this.$events.setJobSchedule(this.jobble_id, weeks).then(function (r) {
	        console.log("Updated job schedule:", r);
	
	        _this7.$timeout(function () {
	          _this7.closeLoadingModal();
	        }, 1000);
	
	        _this7.$timeout(function () {
	          _this7.$rootScope.$emit("JobHasBeenScheduled", _this7.event);
	          _this7.unSetLoader();
	          _this7.savingStep = false;
	          _this7.$state.go("jobsdashboard", { longTerm: "true" });
	        }, 2500);
	      }, function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: "setAutomationForJob",
	    value: function setAutomationForJob() {
	      var _this8 = this;
	
	      this.notifyJobblers();
	      this.$timeout(function () {
	        _this8.setSchedule();
	      }, 1000);
	    }
	  }, {
	    key: "notifyJobblers",
	    value: function notifyJobblers() {
	      var teams_ids = this.event.cloudsForJobblePost;
	      var payload = void 0;
	
	      if (teams_ids && teams_ids.length > 0) {
	        payload = {
	          id: this.jobble_pool_id,
	          visibility: "EXCLUSIVE"
	        };
	      } else {
	        payload = {
	          id: this.jobble_pool_id,
	          visibility: "PUBLIC"
	        };
	      }
	
	      if (!this.event.remote_job) {
	        this.$events.notifyJobblers(payload).then(function (data) {
	          console.log("Notified event:", data);
	        }).catch(function (err) {
	          console.error(err);
	        });
	      }
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "validate",
	    value: function validate() {
	      //console.dir(e.keyCode);
	
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, { from_pay: true });
	
	      if (!this.event || this.event.hourly_rate === undefined) return;
	
	      var t = this.event.hourly_rate + "";
	
	      this.event.hourly_rate = t.indexOf(".") >= 0 ? t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3) : t;
	      this.event.hourly_rate = parseFloat(this.event.hourly_rate);
	
	      this.$rootScope.$emit(_variables.UPDATE_WORKFLOW_EVENT_NAME, { from_pay: true });
	
	      //this.unSetLoader();
	    }
	  }, {
	    key: "loadTeams",
	    value: function loadTeams() {
	      var _this9 = this;
	
	      var teamsSimple = [];
	      var teams = [];
	      this.$companies.getTeamsTrim().then(function (data) {
	        try {
	          data.data.forEach(function (team, index) {
	            team.firstLoadUsersCount = Math.min(team.users.length, 6);
	
	            if (team.firstLoadUsersCount === 6) {
	              team.firstLoadUsersCount = 5;
	            }
	
	            teams.push(team);
	
	            var teamsObj = {};
	            teamsObj.name = team.name;
	            teamsObj.id = team.id;
	
	            teamsSimple.push(teamsObj);
	          });
	        } finally {
	          _this9.$timeout(function () {
	            _this9.$rootScope.teams = teams;
	            _this9.$rootScope.teamsSimple = teamsSimple;
	            _this9.$rootScope.$emit("TeamsHaveLoaded", {
	              teams: teams
	            });
	          });
	        }
	      }, function (data) {
	        _this9.$rootScope.teams = [];
	      });
	    }
	  }, {
	    key: "calculateCosts",
	    value: function calculateCosts() {
	      if (!this.event) return;
	      if (!this.event.hourly_rate) return;
	
	      var currentUser = this.$auth.getUserData();
	      var rate = currentUser.company.defaultPlan.companyFeePct;
	      var jobblerFeePct = currentUser.company.defaultPlan.companyFeePct;
	      var pay = parseFloat(this.event.hourly_rate);
	      var markUpCost = pay * (1 + rate) - pay;
	      var epi = 0.00001;
	
	      var cost = pay + markUpCost;
	      var costRounded = pay + markUpCost;
	
	      var companyPayRate = currentUser.company.defaultPlan.companyFeePct;
	      companyPayRate = Math.round(companyPayRate * 100) / 100;
	
	      if (this.event.shifts && this.event.shifts.length) {
	        var hours = 0;
	
	        this.event.shifts.forEach(function (shift) {
	          if (!shift) return;
	
	          var startDate = new Date(shift.startDate + " " + shift.startTime);
	          var endDate = new Date(shift.endDate + " " + shift.endTime);
	
	          hours += (endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60 - (shift.unpaidBreak ? shift.unpaidBreak : 0) / 60;
	        });
	
	        this.total_hours = hours;
	        this.estimated_cost = Math.round((cost + epi) * 100 * hours * parseFloat(this.event.openings)) / 100;
	
	        if (this.event.is_long_term && this.event.numberOfWeeksToScheduleJob && parseFloat(this.event.numberOfWeeksToScheduleJob) > 0) {
	          this.estimated_total_cost = this.estimated_cost * (parseFloat(this.event.numberOfWeeksToScheduleJob) + 1);
	          this.total_weeks = parseFloat(this.event.numberOfWeeksToScheduleJob) + 1;
	        }
	
	        this.platform_fee_cost = this.estimated_cost - Math.round((pay + epi) * 100 * hours * parseFloat(this.event.openings)) / 100;
	        this.jobbler_payments = this.estimated_cost - this.platform_fee_cost;
	
	        console.log(this.jobbler_payments, this.estimated_cost, this.estimated_total_cost, cost + epi);
	      }
	    }
	  }]);
	
	  return PayrateController;
	}();
	
	PayrateController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "$location", "tracking", "events", "companies"];
	
	exports.default = PayrateController;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _preview = __webpack_require__(356);
	
	var _preview2 = _interopRequireDefault(_preview);
	
	var _preview3 = __webpack_require__(357);
	
	var _preview4 = _interopRequireDefault(_preview3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var previewComponent = {
	  restrict: "E",
	  bindings: {
	    event: "=",
	    state: "="
	  },
	  template: _preview2.default,
	  controller: _preview4.default,
	  controllerAs: "vm"
	};
	
	exports.default = previewComponent;

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <div class=\"selected-job-container\">\n    <div class=\"job-header-container\">\n      <div class=\"job-header-logo\" style=\"height: 56px; flex: 0 0 56px\">\n        <div style=\"background-image: url({{vm.event.company_img}})\"></div>\n      </div>\n      <div class=\"job-header-details\">\n        <div class=\"job-header-title\">\n          <span ng-style=\"{'background-color': vm.state === vm.walkthroughStates.SHIFT_TITLE ? '#FFF5B6' : null}\"\n            >{{vm.event.shift_title || \"Your Job Title\"}}</span\n          >\n        </div>\n        <div class=\"job-header-company\">{{vm.event.company_name}}</div>\n        <div ng-if=\"!vm.event.remote_job\" class=\"job-header-location\">\n          <span ng-style=\"{'background-color': vm.state === vm.walkthroughStates.LOCATION ? '#FFF5B6' : null}\"\n            >{{vm.event.contactInfo.city || \"Anywhere\"}}, {{vm.event.contactInfo.state || \"USA\"}}</span\n          >\n        </div>\n        <div ng-if=\"vm.event.remote_job\" class=\"job-header-location\">\n          <span ng-style=\"{'background-color': vm.state === vm.walkthroughStates.LOCATION ? '#FFF5B6' : null}\">{{\"Anywhere\"}}, {{\"USA\"}}</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"job-details-box-container\">\n      <div class=\"row\">\n        <div class=\"col col-sm-6\">\n          <div class=\"details-pay-row\">\n            <div class=\"row-icon\">\n              <span ng-style=\"{'background-color': vm.state === vm.walkthroughStates.PAY ? '#FFF5B6' : null}\"\n                ><i class=\"fas fa-dollar-sign\"></i\n              ></span>\n            </div>\n            <div class=\"row-information\">\n              <span ng-if=\"vm.event.hourly_rate\">${{vm.event.hourly_rate}}/hr <span>or ${{vm.estimated_cost | number : 2}} per jobbler</span></span>\n            </div>\n          </div>\n          <div class=\"details-day-type-row\">\n            <div class=\"row-icon\">\n              <i class=\"fa fa-briefcase\"></i>\n            </div>\n            <div class=\"row-information\" ng-if=\"vm.allShiftsValid\">\n              <span ng-if=\"vm.event.shifts.length > 1\">Multi-Day</span><span ng-if=\"vm.event.shifts.length <= 1\">Single-Day</span>\n              job\n            </div>\n          </div>\n          <!-- && vm.event.numberOfWeeksToScheduleJob != '1' -->\n          <div class=\"details-day-type-row\" ng-if=\"vm.event.is_long_term == true && vm.event.id && vm.weeks\">\n            <div class=\"row-icon\">\n              <i class=\"fa fa-recycle\" title=\"Recurring Job\"></i>\n            </div>\n            <div class=\"row-information\">\n              <span>{{ vm.weeks }} Week Recurring Job</span>\n            </div>\n          </div>\n        </div>\n        <div class=\"col col-sm-6\">\n          <div ng-if=\"vm.event.shifts.length === 1\">\n            <div class=\"details-pay-row\">\n              <div class=\"row-icon\">\n                <span ng-style=\"{'background-color': vm.state === vm.walkthroughStates.DATEANDTIME ? '#FFF5B6' : null}\"\n                  ><i class=\"fas fa-calendar\"></i\n                ></span>\n              </div>\n              <div class=\"row-information\">{{ vm.jobbleFullTimeFrame }}</div>\n            </div>\n            <div class=\"details-pay-row\">\n              <div class=\"row-icon\">\n                <span ng-style=\"{'background-color': vm.state === vm.walkthroughStates.DATEANDTIME ? '#FFF5B6' : null}\"\n                  ><i class=\"far fa-clock\"></i\n                ></span>\n              </div>\n              <div class=\"row-information\">\n                <div>{{vm.jobbleHours}}</div>\n                <div ng-if=\"vm.unpaidBreak && vm.unpaidBreak > 0\" style=\"font-weight: 400; text-transform: none\">\n                  (includes {{vm.unpaidBreak}} M unpaid break)\n                </div>\n                <div ng-if=\"vm.jobbleOvernight\" class=\"overnight-flag\">Overnight shift</div>\n              </div>\n            </div>\n          </div>\n          <div ng-if=\"vm.event.shifts.length > 1\">\n            <div class=\"details-pay-row\" ng-repeat=\"s in vm.shifts\">\n              <div style=\"display: flex; flex: 1\">\n                <div style=\"display: flex; flex: 0 0 66px\">\n                  <div class=\"row-icon\">\n                    <span ng-style=\"{'background-color': vm.state === vm.walkthroughStates.DATEANDTIME ? '#FFF5B6' : null}\"\n                      ><i class=\"fas fa-calendar\"></i\n                    ></span>\n                  </div>\n                  <div class=\"row-information\"><span style=\"text-decoration: underline\">{{s.dayOfWeek}}</span><br />{{s.date}}</div>\n                </div>\n                <div style=\"display: flex; flex: 1; margin-left: 12px\">\n                  <div class=\"row-icon\">\n                    <span ng-style=\"{'background-color': vm.state === vm.walkthroughStates.DATEANDTIME ? '#FFF5B6' : null}\"\n                      ><i class=\"far fa-clock\"></i\n                    ></span>\n                  </div>\n                  <div class=\"row-information\" style=\"\">\n                    <span style=\"text-decoration: underline\">{{ s.startTime }}-{{ s.endTime }}</span><br />\n                    <div ng-if=\"s.unpaidBreak && s.unpaidBreak > 0\" style=\"font-weight: 400; text-transform: none\">\n                      (includes {{s.unpaidBreak}} M unpaid break)\n                    </div>\n                    <div ng-if=\"s.overnight\" class=\"overnight-flag\">Overnight</div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div style=\"height: fit-content\" class=\"description-container on-demand\">\n      <div class=\"description-header\">\n        <span ng-style=\"{'background-color': vm.state === vm.walkthroughStates.SHIFT_DESCRIPTION ? '#FFF5B6' : null}\">About this job</span>\n      </div>\n      <div class=\"description-text\" style=\"height: fit-content\">\n        <div style=\"white-space: pre-line\">{{vm.event.shift_description}}</div>\n      </div>\n      <div class=\"description-header\">\n        <span ng-style=\"{'background-color': vm.state === vm.walkthroughStates.ARRIVAL_INSTRUCTIONS ? '#FFF5B6' : null}\">Arrival Instructions</span>\n      </div>\n      <div class=\"description-text\" style=\"height: fit-content\">\n        <div style=\"white-space: pre-line\">{{vm.event.arrival_instructions}}</div>\n      </div>\n      <div class=\"description-header\">\n        <span ng-style=\"{'background-color': vm.state === vm.walkthroughStates.ARRIVAL_INSTRUCTIONS ? '#FFF5B6' : null}\"\n          >Onsite Manager Contact Info</span\n        >\n      </div>\n      <div class=\"description-text\" style=\"height: fit-content\">\n        <div style=\"white-space: pre-line\">\n          {{vm.event.onsite_manager_name}}<span ng-if=\"vm.event.onsite_manager_number\"> <{{vm.event.onsite_manager_number}}></span>\n        </div>\n      </div>\n      <div class=\"description-header\">\n        <span ng-style=\"{'background-color': vm.state === vm.walkthroughStates.SUGGESTED_ATTIRE ? '#FFF5B6' : null}\">Suggested attire</span>\n      </div>\n      <div class=\"description-text\" style=\"height: fit-content\">\n        <div style=\"white-space: pre-line\">{{vm.event.dress_code}}</div>\n      </div>\n      <div class=\"description-header\" style=\"margin-top: 24px\">\n        <span ng-style=\"{'background-color': vm.state === vm.walkthroughStates.COMPANY_INFO ? '#FFF5B6' : null}\"\n          >About {{vm.event.company_name}}</span\n        >\n      </div>\n      <div class=\"description-text\" style=\"height: fit-content\">\n        <div style=\"white-space: pre-line\">{{ vm.event.company_info }}</div>\n      </div>\n    </div>\n\n    <div class=\"map-container\" ng-class=\"{'on-demand': !vm.jobble.is_partner_post}\">\n      <div class=\"map-title\">\n        <span ng-style=\"{'background-color': vm.state === vm.walkthroughStates.LOCATION ? '#FFF5B6' : null}\"\n          >Location <span ng-if=\"!vm.event.remote_job\">& Getting There</span></span\n        >\n      </div>\n      <div ng-if=\"!vm.event.remote_job\" class=\"address\">\n        <i class=\"fa fa-map-marker\"></i\n        ><span ng-if=\"vm.event.contactInfo && vm.event.contactInfo.streetLine1\"\n          >{{vm.event.contactInfo.streetLine1}}, {{vm.event.contactInfo.city}}, {{vm.event.contactInfo.state}}, {{vm.event.contactInfo.zipCode}}</span\n        >\n      </div>\n      <div ng-if=\"vm.event.remote_job\" class=\"address\"><i class=\"fa fa-map-marker\"></i><span>Anywhere, USA</span></div>\n      <div ng-if=\"!vm.event.remote_job\" id=\"preview-map\" style=\"height: 184px; width: 100%\"></div>\n      <div ng-if=\"!vm.event.remote_job\" class=\"direction-time-container\">\n        <div class=\"direction-time\" ng-if=\"vm.carDistance\">\n          <span><i class=\"fas fa-car\"></i>{{vm.carDistance}}</span>\n        </div>\n        <div class=\"direction-time\" ng-if=\"vm.transitDistance\">\n          <span><i class=\"fas fa-bus\"></i>{{vm.transitDistance}}</span>\n        </div>\n        <div class=\"direction-time\" ng-if=\"vm.walkDistance\">\n          <span><i class=\"fas fa-walking\"></i>{{vm.walkDistance}}</span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(309);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PreviewController = function () {
	  function PreviewController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    var _this = this;
	
	    _classCallCheck(this, PreviewController);
	
	    this.name = "preview";
	    this.walkthroughState = _variables.WALKTHROUGH_STATES.PREVIEW;
	    this.walkthroughStates = _variables.WALKTHROUGH_STATES;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    //this.w2_options = ["Yes", "No"];
	    this.$events = events;
	
	    this.API_FIELDS = "subEvents.deduppedJobbles.id";
	
	    this.SetNewWeeksOnChangeListener = this.$rootScope.$on("SetNewWeeksOnChange", function ($event, params) {
	      if (_this.event) {
	        if (_this.event.is_long_term === true) {
	          _this.setWeeks();
	        }
	      }
	    });
	
	    this.UpdateListener = this.$rootScope.$on(_variables.UPDATE_WORKFLOW_EVENT_NAME, function ($event, params) {
	      console.log("ttttttttttt1");
	      console.dir(_this.event);
	
	      if (_this.event) {
	        _this.initMap();
	        _this.calculateTotalWage();
	        if (_this.event.is_long_term === true) {
	          _this.setWeeks();
	        }
	
	        if (_this.event.shifts) {
	          _this.processShifts();
	        }
	      }
	    });
	
	    this.$scope.$on("$destroy", this.UpdateListener);
	    this.$scope.$on("$destroy", this.SetNewWeeksOnChangeListener);
	  }
	
	  _createClass(PreviewController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      console.log("inititaing preview controller");
	      console.dir(this.event);
	
	      if (this.event) {
	        this.syncWithApi();
	
	        this.initMap();
	        this.calculateTotalWage();
	
	        if (this.event.is_long_term === true) {
	          this.setWeeks();
	        }
	
	        if (this.event.shifts) {
	          this.processShifts();
	        }
	      }
	    }
	  }, {
	    key: "$onChanges",
	    value: function $onChanges() {
	      if (this.event) {
	        this.initMap();
	        this.calculateTotalWage();
	
	        if (this.event.shifts) {
	          this.processShifts();
	        }
	      }
	    }
	  }, {
	    key: "setWeeks",
	    value: function setWeeks() {
	      var weeksInt = parseInt(this.event.numberOfWeeksToScheduleJob);
	      console.log("do we have NaN");
	      console.dir(isNaN(weeksInt));
	      if (isNaN(weeksInt)) {
	        this.weeks = null;
	      } else {
	        this.weeks = weeksInt + 1;
	      }
	    }
	  }, {
	    key: "calculateTotalWage",
	    value: function calculateTotalWage() {
	      var _this2 = this;
	
	      if (!this.event) return;
	
	      var currentUser = this.$auth.getUserData();
	      var rate = currentUser.company.defaultPlan.jobblerFeePct;
	
	      var pay = parseFloat(this.event.hourly_rate);
	      var epi = 0.00001;
	
	      if (this.event.shifts && this.event.shifts.length) {
	        var hours = 0;
	
	        this.event.shifts.forEach(function (shift) {
	          if (!shift) return;
	
	          var startDate = new Date(shift.startDate + " " + shift.startTime);
	          var endDate = new Date(shift.endDate + " " + shift.endTime);
	
	          hours += (endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60;
	        });
	
	        this.$timeout(function () {
	          _this2.total_hours = hours;
	          _this2.estimated_cost = Math.round((pay + epi) * 100 * hours) / 100;
	        });
	      }
	    }
	  }, {
	    key: "initMap",
	    value: function initMap() {
	      if (!this.event || !this.event.contactInfo) return;
	
	      mapboxgl.accessToken = this.$env.EnvironmentConfig.mapbox;
	
	      var lat = this.event.contactInfo.lat;
	      var lng = this.event.contactInfo.lng;
	
	      if (!this.lastLat || this.lastLat !== lat) {
	        this.lastLat = lat;
	
	        var map = new mapboxgl.Map({
	          container: "preview-map",
	          style: "mapbox://styles/mapbox/streets-v11",
	          center: [lng, lat],
	          zoom: 13
	        });
	
	        var marker = new mapboxgl.Marker().setLngLat([lng, lat]).addTo(map);
	      }
	    }
	  }, {
	    key: "syncWithApi",
	    value: function syncWithApi() {
	      var _this3 = this;
	
	      this.$timeout(function () {
	        if (!_this3.event || !_this3.event.id) {
	          console.log("WE DONT HAVE EVENT ID DO NOT SYNC");
	        } else {
	          console.log("GET JOBBLE ID");
	          _this3.$events.getEventByIdWithFields(_this3.event.id, _this3.API_FIELDS).then(function (data) {
	            console.log("lets look at the response");
	            console.dir(data);
	            _this3.jobble_id = data.data.subEvents[0].deduppedJobbles[0].id;
	            console.log("what is the jobble id");
	            console.dir(_this3.jobble_id);
	          });
	        }
	      }, 1000);
	    }
	  }, {
	    key: "processShifts",
	    value: function processShifts() {
	      this.allShiftsValid = this.validateShifts();
	
	      if (this.event.shifts.length === 1) {
	        var shift = this.event.shifts[0];
	
	        var valid = this.$events.validateWorflowShift(shift);
	
	        if (!valid) return;
	
	        var startMoment = moment(shift.startDate + " " + shift.startTime);
	        var endMoment = moment(shift.endDate + " " + shift.endTime);
	
	        var startTime = startMoment.format("ddd, MMM DD h:mmA");
	        var endTime = endMoment.format("ddd, MMM DD h:mmA");
	
	        var ret = shift.overnight ? startTime + " - " + endTime : startTime;
	
	        var time = startMoment.format("h:mmA") + " - " + endMoment.format("h:mmA");
	
	        var diffTime = endMoment.diff(startMoment);
	        var durTime = moment.duration(diffTime);
	
	        var durDays = durTime.days();
	        var durHours = 24 * durDays + durTime.hours();
	        var durMin = durTime.minutes();
	
	        var duration = "" + (durHours ? durHours + " HR" : "") + (durHours > 1 ? "S" : "") + (durMin && durMin ? " " : "") + (durMin ? durMin + "MIN" : "");
	        var rawDuration = durHours + durMin / 60;
	
	        this.jobbleFullTimeFrame = ret;
	        this.jobbleHours = time;
	        this.jobbleDuration = duration;
	        this.jobbleOvernight = shift.overnight;
	        this.unpaidBreak = shift.unpaidBreak;
	      } else {
	        this.shifts = this.event.shifts.sort(function (a, b) {
	          return new Date(a.startDate + " " + a.startTime).getTime() - new Date(a.startDate + " " + a.startTime).getTime();
	        });
	
	        this.shifts = this.shifts.map(function (shift) {
	          var start = new Date(shift.startDate + " " + shift.startTime);
	          var end = new Date(shift.endDate + " " + shift.endTime);
	
	          console.log("EACH SHIFT KKKK");
	          console.dir(shift);
	
	          var startMoment = moment(start);
	          var endMoment = moment(end);
	
	          var startDay = startMoment.format("M/DD");
	
	          var diffTime = endMoment.diff(startMoment);
	          var durTime = moment.duration(diffTime);
	
	          var durDays = durTime.days();
	          var durHours = 24 * durDays + durTime.hours();
	          var durMin = durTime.minutes();
	
	          var duration = "" + (durHours ? durHours + " HR" : "") + (durHours > 1 ? "S" : "") + (durMin && durMin ? " " : "") + (durMin ? durMin + "MIN" : "");
	
	          console.log("shift data each shift");
	          console.dir(shift);
	
	          return {
	            dayOfWeek: startMoment.format("ddd"),
	            date: startDay,
	            startTime: startMoment.format("h:mmA"),
	            endTime: endMoment.format("h:mmA"),
	            duration: duration,
	            overnight: shift.overnight,
	            unpaidBreak: shift.unpaidBreak
	          };
	        });
	      }
	    }
	  }, {
	    key: "validateShifts",
	    value: function validateShifts() {
	      var _this4 = this;
	
	      var allValid = true;
	      if (!this.event || !this.event.shifts || !this.event.shifts.length) {
	        allValid = false;
	        return allValid;
	      }
	
	      this.event.shifts.forEach(function (shift) {
	        var valid = _this4.$events.validateWorflowShift(shift);
	        if (!valid) allValid = false;
	
	        return valid;
	      });
	
	      if (allValid) {
	        if (!this.$events.validateWorflowShiftsNonOverlapping(this.event.shifts)) {
	          allValid = false;
	        }
	      }
	
	      return allValid;
	    }
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      var _this5 = this;
	
	      this.$timeout(function () {
	        _this5.savingStep = true;
	      });
	
	      this.$events.publishEvent(this.jobble_id, true).then(function (data) {
	        _this5.$timeout(function () {
	          _this5.savingStep = false;
	        });
	        console.log("Published event:", data);
	        _this5.$state.go("jobs-dashboard");
	      });
	    }
	  }]);
	
	  return PreviewController;
	}();
	
	PreviewController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = PreviewController;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _references = __webpack_require__(359);
	
	var _references2 = _interopRequireDefault(_references);
	
	var _welcomescreen = __webpack_require__(365);
	
	var _welcomescreen2 = _interopRequireDefault(_welcomescreen);
	
	var _questionone = __webpack_require__(368);
	
	var _questionone2 = _interopRequireDefault(_questionone);
	
	var _questiontwo = __webpack_require__(371);
	
	var _questiontwo2 = _interopRequireDefault(_questiontwo);
	
	var _questionthree = __webpack_require__(374);
	
	var _questionthree2 = _interopRequireDefault(_questionthree);
	
	var _questionfour = __webpack_require__(377);
	
	var _questionfour2 = _interopRequireDefault(_questionfour);
	
	var _questionfive = __webpack_require__(380);
	
	var _questionfive2 = _interopRequireDefault(_questionfive);
	
	var _questionsix = __webpack_require__(383);
	
	var _questionsix2 = _interopRequireDefault(_questionsix);
	
	var _confirmation = __webpack_require__(386);
	
	var _confirmation2 = _interopRequireDefault(_confirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var referencesModule = _angular2.default.module("references", [_angularUiRouter2.default, "cleave.js"]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("references?rid", {
	    url: "/references",
	    template: "<references></references>",
	    title: "Post a Job",
	    params: {
	      rid: null
	    }
	  }).state("references-welcome-screen", {
	    url: "/references/welcome?rid",
	    template: "<references></references>",
	    title: "Welcome",
	    params: {
	      rid: null
	    }
	  }).state("references-question-one", {
	    url: "/references/question-one?rid",
	    template: "<references></references>",
	    title: "Question 1",
	    params: {
	      rid: null
	    }
	  }).state("references-question-two", {
	    url: "/references/question-two?rid",
	    template: "<references></references>",
	    title: "Question 2",
	    params: {
	      rid: null
	    }
	  }).state("references-question-three", {
	    url: "/references/question-three?rid",
	    template: "<references></references>",
	    title: "Question 3",
	    params: {
	      rid: null
	    }
	  }).state("references-question-four", {
	    url: "/references/question-four?rid",
	    template: "<references></references>",
	    title: "Question 4",
	    params: {
	      rid: null
	    }
	  }).state("references-question-five", {
	    url: "/references/question-five?rid",
	    template: "<references></references>",
	    title: "Question 5",
	    params: {
	      rid: null
	    }
	  }).state("references-question-six", {
	    url: "/references/question-six?rid",
	    template: "<references></references>",
	    title: "Question 6",
	    params: {
	      rid: null
	    }
	  }).state("confirmation", {
	    url: "/references/confirmation?rid",
	    template: "<references></references>",
	    title: "Confirmation",
	    params: {
	      rid: null
	    }
	  });
	}).component("references", _references2.default).component("welcomescreen", _welcomescreen2.default).component("questionone", _questionone2.default).component("questiontwo", _questiontwo2.default).component("questionthree", _questionthree2.default).component("questionfour", _questionfour2.default).component("questionfive", _questionfive2.default).component("questionsix", _questionsix2.default).component("confirmation", _confirmation2.default);
	
	exports.default = referencesModule;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _references = __webpack_require__(360);
	
	var _references2 = _interopRequireDefault(_references);
	
	var _references3 = __webpack_require__(361);
	
	var _references4 = _interopRequireDefault(_references3);
	
	__webpack_require__(363);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var referencesComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _references2.default,
	  controller: _references4.default,
	  controllerAs: "vm"
	};
	
	exports.default = referencesComponent;

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"jobs-complete-container reference-container\">\n  <div class=\"container\">\n    <welcomescreen ng-if=\"vm.referenceScreen == vm.referenceScreens.WELCOME_SCREEN\" event=\"vm.sessionData\"></welcomescreen>\n    <questionone ng-if=\"vm.referenceScreen == vm.referenceScreens.QUESTION_ONE\" event=\"vm.sessionData\"></questionone>\n    <questiontwo ng-if=\"vm.referenceScreen == vm.referenceScreens.QUESTION_TWO\" event=\"vm.sessionData\"></questiontwo>\n    <questionthree ng-if=\"vm.referenceScreen == vm.referenceScreens.QUESTION_THREE\" event=\"vm.sessionData\"></questionthree>\n    <questionfour ng-if=\"vm.referenceScreen == vm.referenceScreens.QUESTION_FOUR\" event=\"vm.sessionData\"></questionfour>\n    <questionfive ng-if=\"vm.referenceScreen == vm.referenceScreens.QUESTION_FIVE\" event=\"vm.sessionData\"></questionfive>\n    <questionsix ng-if=\"vm.referenceScreen == vm.referenceScreens.QUESTION_SIX\" event=\"vm.sessionData\"></questionsix>\n    <confirmation ng-if=\"vm.referenceScreen == vm.referenceScreens.CONFIRMATION\" event=\"vm.sessionData\"></confirmation>\n\n    <div class=\"row\" ng-if=\"vm.referenceScreen != vm.referenceScreens.WELCOME_SCREEN && vm.referenceScreen != vm.referenceScreens.CONFIRMATION\">\n      <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n        <div class=\"reference-progress-bar-wrapper\">\n          <p class=\"progress-bar-text\" ng-if=\"vm.event.referenceType=='PROFESSIONAL'\">Question {{vm.referenceScreen}} of 6</p>\n          <p class=\"progress-bar-text\" ng-if=\"vm.event.referenceType=='PERSONAL'\">Question {{vm.referenceScreen}} of 5</p>\n          <div class=\"progress-bar\">\n            <div\n              ng-class=\"{'first-screen' : vm.referenceScreen == vm.referenceScreens.WELCOME_SCREEN,\n                                 'second-screen' : vm.referenceScreen == vm.referenceScreens.QUESTION_ONE,\n                                 'third-screen' : vm.referenceScreen == vm.referenceScreens.QUESTION_TWO,\n                                 'fourth-screen' : vm.referenceScreen == vm.referenceScreens.QUESTION_THREE,\n                                 'fifth-screen' : vm.referenceScreen == vm.referenceScreens.QUESTION_FOUR,\n                                 'sixth-screen' : vm.referenceScreen == vm.referenceScreens.QUESTION_FIVE,\n                                 'seventh-screen' : vm.referenceScreen == vm.referenceScreens.QUESTION_SIX}\"\n            ></div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<jobblefooter></jobblefooter>\n"

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(362);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReferencesController = function () {
	  function ReferencesController($localStorage, $scope, $rootScope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events, ngProgressFactory, $location, companies) {
	    var _this = this;
	
	    _classCallCheck(this, ReferencesController);
	
	    this.name = "references";
	
	    this.$localStorage = $localStorage;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$progress = ngProgressFactory.createInstance();
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	    this.$location = $location;
	    this.$companies = companies;
	    this.referenceScreens = _variables.REFERENCE_SCREENS;
	    this.sessionData = {};
	
	    this.GoNextListener = this.$rootScope.$on("SendToNextReferenceScreen", function ($event, params) {
	      _this.handleGoNext(params.referenceScreen);
	    });
	
	    this.$scope.$on("$destroy", this.GoNextListener);
	  }
	
	  _createClass(ReferencesController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      //TODO: Check for user token and if detected, log user out
	      this.getQuestionsFromAPI();
	      this.getReferenceDataFromAPI(this.$location.$$search.rid);
	      this.parseUrlForPage(this.$location);
	    }
	  }, {
	    key: "parseUrlForPage",
	    value: function parseUrlForPage(location) {
	      if (location.$$path === "/references/question-one") {
	        this.referenceScreen = this.referenceScreens.QUESTION_ONE;
	      } else if (location.$$path === "/references/question-two") {
	        this.referenceScreen = this.referenceScreens.QUESTION_TWO;
	      } else if (location.$$path === "/references/question-three") {
	        this.referenceScreen = this.referenceScreens.QUESTION_THREE;
	      } else if (location.$$path === "/references/question-four") {
	        this.referenceScreen = this.referenceScreens.QUESTION_FOUR;
	      } else if (location.$$path === "/references/question-five") {
	        this.referenceScreen = this.referenceScreens.QUESTION_FIVE;
	      } else if (location.$$path === "/references/question-six") {
	        this.referenceScreen = this.referenceScreens.QUESTION_SIX;
	      } else if (location.$$path === "/references/confirmation") {
	        this.referenceScreen = this.referenceScreens.CONFIRMATION;
	      } else {
	        this.referenceScreen = this.referenceScreens.WELCOME_SCREEN;
	      }
	    }
	  }, {
	    key: "handleGoNext",
	    value: function handleGoNext(prevState) {
	
	      var nextState = prevState;
	
	      console.log("handleGoNext");
	      console.dir(prevState);
	      console.dir(this.event);
	      console.dir(_variables.REFERENCE_SCREENS);
	
	      switch (prevState) {
	        case _variables.REFERENCE_SCREENS.WELCOME_SCREEN:
	          nextState = _variables.REFERENCE_SCREENS.QUESTION_ONE;
	          this.$state.transitionTo("references-question-one", { rid: this.sessionData.rid }, { notify: false });
	          break;
	        case _variables.REFERENCE_SCREENS.QUESTION_ONE:
	          nextState = _variables.REFERENCE_SCREENS.QUESTION_TWO;
	          this.$state.transitionTo("references-question-two", { rid: this.sessionData.rid }, { notify: false });
	          break;
	        case _variables.REFERENCE_SCREENS.QUESTION_TWO:
	          nextState = _variables.REFERENCE_SCREENS.QUESTION_THREE;
	          this.$state.transitionTo("references-question-three", { rid: this.sessionData.rid }, { notify: false });
	          break;
	        case _variables.REFERENCE_SCREENS.QUESTION_THREE:
	          nextState = _variables.REFERENCE_SCREENS.QUESTION_FOUR;
	          this.$state.transitionTo("references-question-four", { rid: this.sessionData.rid }, { notify: false });
	          break;
	        case _variables.REFERENCE_SCREENS.QUESTION_FOUR:
	          nextState = _variables.REFERENCE_SCREENS.QUESTION_FIVE;
	          this.$state.transitionTo("references-question-five", { rid: this.sessionData.rid }, { notify: false });
	          break;
	        case _variables.REFERENCE_SCREENS.QUESTION_FIVE:
	          nextState = _variables.REFERENCE_SCREENS.QUESTION_SIX;
	          this.$state.transitionTo("references-question-six", { rid: this.sessionData.rid }, { notify: false });
	          break;
	        case _variables.REFERENCE_SCREENS.QUESTION_SIX:
	          nextState = _variables.REFERENCE_SCREENS.CONFIRMATION;
	          this.$state.transitionTo("confirmation", { rid: this.sessionData.rid }, { notify: false });
	        case _variables.REFERENCE_SCREENS.CONFIRMATION:
	          nextState = _variables.REFERENCE_SCREENS.QUESTION_SIX;
	          this.$state.transitionTo("references-question-six", { rid: this.sessionData.rid }, { notify: false });
	          break;
	        case _variables.REFERENCE_SCREENS.POSTCONFIRMATION:
	          nextState = _variables.REFERENCE_SCREENS.CONFIRMATION;
	          this.$state.transitionTo("confirmation", { rid: this.sessionData.rid }, { notify: false });
	          break;
	      }
	
	      this.setWalkthroughState(nextState);
	    }
	  }, {
	    key: "setWalkthroughState",
	    value: function setWalkthroughState(state) {
	      var _this2 = this;
	
	      this.$timeout(function () {
	        _this2.referenceScreen = state;
	      });
	    }
	  }, {
	    key: "getQuestionsFromAPI",
	    value: function getQuestionsFromAPI() {
	      var _this3 = this;
	
	      this.$security.getReferenceQuestions().then(function (response) {
	        _this3.sessionData.questions = response.data;
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	        alert("error getting questions");
	      });
	    }
	  }, {
	    key: "getReferenceDataFromAPI",
	    value: function getReferenceDataFromAPI(rid) {
	      var _this4 = this;
	
	      if (!rid) {
	        console.error("No reference ID provided");
	        return;
	      }
	
	      this.setLoader();
	      this.$security.getReferenceDataFromAPI(rid).then(function (response) {
	        _this4.setSessionData(response.data);
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	        alert("error getting reference id");
	        _this4.unSetLoader();
	      });
	    }
	  }, {
	    key: "setSessionData",
	    value: function setSessionData(data) {
	      try {
	        this.sessionData.rid = data.userReference.userReferenceId;
	        this.sessionData.referenceType = data.userReference.referenceType;
	        this.sessionData.jobblerFullName = data.jobblerName;
	        this.sessionData.userData = {};
	        this.sessionData.userData.firstName = data.userReference.firstName;
	        this.sessionData.userData.lastName = data.userReference.lastName;
	        this.sessionData.companyName = data.userReference.company;
	      } catch (e) {
	        //alert("error loading reference ID");
	      } finally {
	        this.unSetLoader();
	      }
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }]);
	
	  return ReferencesController;
	}();
	
	ReferencesController.$inject = ["$localStorage", "$scope", "$rootScope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events", "ngProgressFactory", "$location", "companies"];
	
	exports.default = ReferencesController;

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REFERENCE_SCREENS = exports.REFERENCE_SCREENS = {
	  WELCOME_SCREEN: 0,
	  QUESTION_ONE: 1,
	  QUESTION_TWO: 2,
	  QUESTION_THREE: 3,
	  QUESTION_FOUR: 4,
	  QUESTION_FIVE: 5,
	  QUESTION_SIX: 6,
	  CONFIRMATION: 7,
	  POSTCONFIRMATION: 8
	};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(364);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".jobs-complete-container.reference-container{height:100vh;padding-top:135px;background-color:#3a3a3c;font-family:Poppins;color:#fff;padding-bottom:25px}.jobs-complete-container.reference-container .container{padding-left:25px;padding-right:25px;min-width:280px;max-width:540px;min-height:350px}.jobs-complete-container.reference-container .container .content-wrapper{min-height:245px}.jobs-complete-container.reference-container .container .reference-question-wrapper{background-color:#444348;border-radius:6px;padding:12px 15px;margin-bottom:10px;min-height:74px}.jobs-complete-container.reference-container .container .reference-question-wrapper.extra-padding{padding-top:24px}.jobs-complete-container.reference-container h1{font-family:Poppins;color:#fff;text-align:center;padding:0;font-size:18px;line-height:25px;margin-bottom:0}.jobs-complete-container.reference-container p.reference-text{font-weight:600;text-align:center}.jobs-complete-container.reference-container p.reference-text.small{margin-bottom:20px;margin-top:11px;font-size:12px}.jobs-complete-container.reference-container p.progress-bar-text{font-weight:600;text-align:center}.reference-progress-bar-wrapper{margin-top:40px}button.reference-button{margin:0 auto;background:linear-gradient(270deg,#74cf59,#5498b4);color:#fff;font-family:Poppins;font-weight:800;border:none;width:150px;font-size:16px;border-radius:6px;padding-top:10px;padding-bottom:10px}.jobs-complete-container.reference-container .container form{padding:20px;padding-top:15px}.jobs-complete-container.reference-container .container form input[type=submit]{margin:0 auto;display:block;background:linear-gradient(270deg,#74cf59,#5498b4);color:#fff;font-family:Poppins;font-weight:800;border:none;width:150px;font-size:16px;border-radius:6px;padding-top:10px;padding-bottom:10px;margin-top:20px}.jobs-complete-container.reference-container .container form input[type=radio]:hover,.jobs-complete-container.reference-container .container form label:hover{cursor:pointer}.jobs-complete-container.reference-container .container form input[type=submit]:disabled{opacity:.5}button.reference-button:hover{cursor:pointer;box-shadow:4px 8px 8px hsl(0deg 0% 0%/.38)}button.reference-button:disabled{opacity:.5;cursor:default;box-shadow:none}.reference-button-wrapper{text-align:center;padding-top:50px}.reference-button-wrapper.less{padding-top:20px}.reference-progress-bar-wrapper .progress-bar{width:100%;height:24px;background-color:#eee;border-radius:2px;padding-top:1px}.reference-progress-bar-wrapper .progress-bar .first-screen{background-color:#74cf59;width:0;border-radius:2px;height:22px;border-top-left-radius:2px;border-bottom-left-radius:2px}.reference-progress-bar-wrapper .progress-bar .second-screen{background-color:green;width:5%;border-radius:2px;height:22px;border-top-left-radius:2px;border-bottom-left-radius:2px}.reference-progress-bar-wrapper .progress-bar .third-screen{background-color:green;width:16.6%;border-radius:2px;height:22px;border-top-left-radius:2px;border-bottom-left-radius:2px}.reference-progress-bar-wrapper .progress-bar .fourth-screen{background-color:green;width:33%;border-radius:2px;height:22px;border-top-left-radius:2px;border-bottom-left-radius:2px}.reference-progress-bar-wrapper .progress-bar .fifth-screen{background-color:green;width:55%;border-radius:2px;height:22px;border-top-left-radius:2px;border-bottom-left-radius:2px}.reference-progress-bar-wrapper .progress-bar .sixth-screen{background-color:green;width:76%;border-radius:2px;height:22px;border-top-left-radius:2px;border-bottom-left-radius:2px}.reference-progress-bar-wrapper .progress-bar .seventh-screen{background-color:green;width:100%;border-radius:2px;height:22px;border-top-left-radius:2px;border-bottom-left-radius:2px}.rating-wrapper{width:100%}.rating-wrapper ul{list-style-type:none;margin-top:10px}.rating-wrapper ul li{display:inline-block;width:19.2%;background-color:#fff;color:#000;text-align:center;font-weight:800;border-radius:3px;padding-top:10px;padding-bottom:10px}.rating-wrapper ul li:hover{cursor:pointer;background-color:#757272}.rating-wrapper ul li.active{background-color:#757272}.jobs-complete-container.reference-container .container form.final-comments{padding-left:0;padding-right:0}.jobs-complete-container.reference-container .container form.final-comments textarea{border-radius:6px;width:100%;color:#000}@media only screen and (max-width:360px){.jobs-complete-container.reference-container .container{padding-left:5px;padding-right:5px}}@media only screen and (max-width:398px){.rating-wrapper ul li{width:19%}}@media only screen and (max-width:292px){.rating-wrapper ul li{width:18.9%}}@media only screen and (max-width:470px){.copyright{margin-top:0}}", ""]);
	
	// exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _welcomescreen = __webpack_require__(366);
	
	var _welcomescreen2 = _interopRequireDefault(_welcomescreen);
	
	var _welcomescreen3 = __webpack_require__(367);
	
	var _welcomescreen4 = _interopRequireDefault(_welcomescreen3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var welcomescreenComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _welcomescreen2.default,
	  controller: _welcomescreen4.default,
	  controllerAs: "vm"
	};
	
	exports.default = welcomescreenComponent;

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"reference-question-wrapper\">\n        <h1>{{vm.event.userData.firstName}} thank you for being a reference for {{vm.event.jobblerFullName}}</h1>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <p class=\"reference-text\" ng-if=\"vm.event.referenceType=='PROFESSIONAL'\">\n        This survey takes on average 3 minutes and will help us deliver better quality workers to buinesses like you.\n      </p>\n      <p class=\"reference-text\" ng-if=\"vm.event.referenceType=='PERSONAL'\">\n      This survey takes an average of 3 minutes and will help us make better hiring decisions for workers like {{vm.event.jobblerFullName}}\n      </p>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"reference-button-wrapper\">\n        <button class=\"reference-button\" ng-click=\"vm.goNext()\">Start</button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(362);
	
	var _variables2 = __webpack_require__(309);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WelcomescreenController = function () {
	  function WelcomescreenController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    _classCallCheck(this, WelcomescreenController);
	
	    this.name = "welcomescreen";
	    //this.walkthroughState = WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	    this.referenceScreens = _variables.REFERENCE_SCREENS;
	  }
	
	  _createClass(WelcomescreenController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      console.log("welcome screen");
	      console.dir(this);
	    }
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      var _this = this;
	
	      this.$timeout(function () {
	        _this.$rootScope.$emit("SendToNextReferenceScreen", {
	          referenceScreen: _this.referenceScreens.WELCOME_SCREEN
	        });
	      });
	    }
	  }]);
	
	  return WelcomescreenController;
	}();
	
	WelcomescreenController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = WelcomescreenController;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _questionone = __webpack_require__(369);
	
	var _questionone2 = _interopRequireDefault(_questionone);
	
	var _questionone3 = __webpack_require__(370);
	
	var _questionone4 = _interopRequireDefault(_questionone3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var questiononeComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _questionone2.default,
	  controller: _questionone4.default,
	  controllerAs: "vm"
	};
	
	exports.default = questiononeComponent;

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"reference-question-wrapper extra-padding\" ng-if=\"vm.event.referenceType=='PROFESSIONAL'\">\n        <h1>Did {{vm.event.jobblerFullName}} work with you at {{vm.event.companyName}}?</h1>\n      </div>\n      <div class=\"reference-question-wrapper extra-padding\" ng-if=\"vm.event.referenceType=='PERSONAL'\">\n        <h1>If you were hiring for a job, would you hire {{vm.event.jobblerFullName}}?</h1>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <form ng-submit=\"vm.saveAnswer()\">\n        <fieldset>\n          <div>\n            <input type=\"radio\" id=\"yes\" name=\"yesno\" ng-click=\"vm.selectionSelected('Yes')\" />\n            <label for=\"yes\">Yes</label>\n          </div>\n          <div>\n            <input type=\"radio\" id=\"no\" name=\"yesno\" ng-click=\"vm.selectionSelected('No')\" />\n            <label for=\"no\">No</label>\n          </div>\n        </fieldset>\n        <!--disabled=\"true\"-->\n        <input type=\"submit\" value=\"Next\" ng-disabled=\"vm.disableButton\" />\n      </form>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(362);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QuestiononeController = function () {
	  function QuestiononeController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    _classCallCheck(this, QuestiononeController);
	
	    this.name = "questionone";
	    //this.walkthroughState = WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	    this.answer = null;
	    this.disableButton = true;
	    this.referenceScreens = _variables.REFERENCE_SCREENS;
	  }
	
	  _createClass(QuestiononeController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      console.log("init question one");
	      console.dir(this.event);
	    }
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      var _this = this;
	
	      this.$timeout(function () {
	        _this.$rootScope.$emit("SendToNextReferenceScreen", {
	          referenceScreen: _this.referenceScreens.QUESTION_ONE
	        });
	      });
	    }
	  }, {
	    key: "saveAnswer",
	    value: function saveAnswer() {
	      var _this2 = this;
	
	      var data = {};
	
	      this.setLoader();
	      data.questionId = this.determineReferenceTypeAndReturnProoperQuestionId();
	      data.answer = this.answer;
	      data.userReferenceId = this.event.rid;
	
	      this.$security.saveReferenceQuestion(data).then(function (response) {
	        _this2.unSetLoader();
	        _this2.goNext();
	      }, function (error) {
	        _this2.unSetLoader();
	        alert("error saving answer");
	      });
	    }
	  }, {
	    key: "selectionSelected",
	    value: function selectionSelected(answer) {
	      this.disableButton = false;
	      this.answer = answer;
	    }
	  }, {
	    key: "determineReferenceTypeAndReturnProoperQuestionId",
	    value: function determineReferenceTypeAndReturnProoperQuestionId() {
	
	      var result = void 0;
	
	      if (this.event.referenceType === "PROFESSIONAL") {
	        result = this.$security.findQuestionId("work as a", this.event.questions);
	      } else {
	        result = this.$security.findQuestionId("Would you hire this ##JobblerName## for a##ListedJobTitle## role", this.event.questions);
	      }
	
	      return result;
	    }
	  }, {
	    key: "disableNextButton",
	    value: function disableNextButton() {
	      if (!this.answer) {
	        this.disableButton = true;
	      } else {
	        this.disableButton = false;
	      }
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }]);
	
	  return QuestiononeController;
	}();
	
	QuestiononeController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = QuestiononeController;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _questiontwo = __webpack_require__(372);
	
	var _questiontwo2 = _interopRequireDefault(_questiontwo);
	
	var _questiontwo3 = __webpack_require__(373);
	
	var _questiontwo4 = _interopRequireDefault(_questiontwo3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var questiontwoComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _questiontwo2.default,
	  controller: _questiontwo4.default,
	  controllerAs: "vm"
	};
	
	exports.default = questiontwoComponent;

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"reference-question-wrapper extra-padding\" ng-if=\"vm.event.referenceType=='PROFESSIONAL'\">\n        <h1>Did {{vm.event.jobblerFullName}} consistently arrive on time and complete their shifts?</h1>\n      </div>\n      <div class=\"reference-question-wrapper extra-padding\" ng-if=\"vm.event.referenceType=='PERSONAL'\">\n        <h1>How would you rate {{vm.event.jobblerFullName}}'s reliability?</h1>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"rating-wrapper\">\n        <ul>\n          <li ng-click=\"vm.setActiveElement('1')\">1</li>\n          <li ng-click=\"vm.setActiveElement('2')\">2</li>\n          <li ng-click=\"vm.setActiveElement('3')\">3</li>\n          <li ng-click=\"vm.setActiveElement('4')\">4</li>\n          <li ng-click=\"vm.setActiveElement('5')\">5</li>\n        </ul>\n      </div>\n    </div>\n    <!--\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding-top:20px;\">\n      <i class=\"fas fa-frown\" style=\"font-size:30px;padding-left:0px;\"></i>\n      <i class=\"fas fa-smile-beam\" style=\"font-size:30px;float:right;padding-right:2px;\"></i>\n    </div>\n  -->\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"reference-button-wrapper\">\n        <button class=\"reference-button\" ng-click=\"vm.saveAnswer()\" ng-disabled=\"vm.disableButton\">Next</button>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(362);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QuestiontwoController = function () {
	  function QuestiontwoController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    _classCallCheck(this, QuestiontwoController);
	
	    this.name = "questiontwo";
	    //this.walkthroughState = WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	    this.disableButton = true;
	    this.referenceScreens = _variables.REFERENCE_SCREENS;
	  }
	
	  _createClass(QuestiontwoController, [{
	    key: "$onInit",
	    value: function $onInit() {}
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      var _this = this;
	
	      if (this.disableButton) {
	        return;
	      }
	
	      this.$timeout(function () {
	        _this.$rootScope.$emit("SendToNextReferenceScreen", {
	          referenceScreen: _this.referenceScreens.QUESTION_TWO
	        });
	      });
	    }
	  }, {
	    key: "setActiveElement",
	    value: function setActiveElement(eleNum) {
	      this.answer = eleNum;
	
	      var activeEl = ".rating-wrapper ul li.active";
	      var el = ".rating-wrapper ul li:nth-child(" + eleNum + ")";
	
	      if ($(activeEl).length >= 1) {
	        this.$timeout(function () {
	          $(activeEl).removeClass("active");
	        });
	      }
	
	      this.$timeout(function () {
	        $(el).addClass("active");
	      });
	
	      this.disableButton = false;
	    }
	  }, {
	    key: "saveAnswer",
	    value: function saveAnswer() {
	      var _this2 = this;
	
	      var data = {};
	
	      this.setLoader();
	      data.questionId = this.determineReferenceTypeAndReturnProoperQuestionId();
	      data.answer = this.answer;
	      data.userReferenceId = this.event.rid;
	
	      this.$security.saveReferenceQuestion(data).then(function (response) {
	        _this2.unSetLoader();
	        _this2.goNext();
	      }, function (error) {
	        _this2.unSetLoader();
	        alert("error saving answer");
	      });
	    }
	  }, {
	    key: "determineReferenceTypeAndReturnProoperQuestionId",
	    value: function determineReferenceTypeAndReturnProoperQuestionId() {
	
	      var result = void 0;
	
	      if (this.event.referenceType === "PROFESSIONAL") {
	        result = this.$security.findQuestionId("consistently arrive on time and complete their shifts", this.event.questions);
	      } else {
	        result = this.$security.findQuestionId("Rate ##JobblerName##’s reliability", this.event.questions);
	      }
	
	      return result;
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }]);
	
	  return QuestiontwoController;
	}();
	
	QuestiontwoController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = QuestiontwoController;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _questionthree = __webpack_require__(375);
	
	var _questionthree2 = _interopRequireDefault(_questionthree);
	
	var _questionthree3 = __webpack_require__(376);
	
	var _questionthree4 = _interopRequireDefault(_questionthree3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var questionthreeComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _questionthree2.default,
	  controller: _questionthree4.default,
	  controllerAs: "vm"
	};
	
	exports.default = questionthreeComponent;

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"reference-question-wrapper extra-padding\">\n        <h1>How would you rate {{vm.event.jobblerFullName}}'s work ethic?</h1>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"rating-wrapper\">\n        <ul>\n          <li ng-click=\"vm.setActiveElement('1')\">1</li>\n          <li ng-click=\"vm.setActiveElement('2')\">2</li>\n          <li ng-click=\"vm.setActiveElement('3')\">3</li>\n          <li ng-click=\"vm.setActiveElement('4')\">4</li>\n          <li ng-click=\"vm.setActiveElement('5')\">5</li>\n        </ul>\n      </div>\n    </div>\n    <!--\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding-top:20px;\"></div>\n      <i class=\"fas fa-frown\" style=\"font-size:30px;padding-left:13px;\"></i>\n      <i class=\"fas fa-smile-beam\" style=\"font-size:30px;float:right;padding-right:20px;\"></i>\n    </div>\n  -->\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"reference-button-wrapper\">\n        <button class=\"reference-button\" ng-click=\"vm.saveAnswer()\" ng-disabled=\"vm.disableButton\">Next</button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(362);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QuestionthreeController = function () {
	  function QuestionthreeController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    _classCallCheck(this, QuestionthreeController);
	
	    this.name = "questionthree";
	    //this.walkthroughState = WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	    this.referenceScreens = _variables.REFERENCE_SCREENS;
	    this.disableButton = true;
	  }
	
	  _createClass(QuestionthreeController, [{
	    key: "$onInit",
	    value: function $onInit() {}
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      var _this = this;
	
	      if (this.disableButton) {
	        return;
	      }
	
	      this.$timeout(function () {
	        _this.$rootScope.$emit("SendToNextReferenceScreen", {
	          referenceScreen: _this.referenceScreens.QUESTION_THREE
	        });
	      });
	    }
	  }, {
	    key: "setActiveElement",
	    value: function setActiveElement(eleNum) {
	      this.answer = eleNum;
	
	      var activeEl = ".rating-wrapper ul li.active";
	      var el = ".rating-wrapper ul li:nth-child(" + eleNum + ")";
	
	      if ($(activeEl).length >= 1) {
	        this.$timeout(function () {
	          $(activeEl).removeClass("active");
	        });
	      }
	
	      this.$timeout(function () {
	        $(el).addClass("active");
	      });
	
	      this.disableButton = false;
	    }
	  }, {
	    key: "saveAnswer",
	    value: function saveAnswer() {
	      var _this2 = this;
	
	      var data = {};
	
	      this.setLoader();
	      data.question = this.event.questions[6].name;
	      data.questionId = 7;
	      data.questionType = "NUMBER";
	      data.answer = this.answer;
	      data.userReferenceId = this.event.rid;
	
	      this.$security.saveReferenceQuestion(data).then(function (response) {
	        _this2.unSetLoader();
	        _this2.goNext();
	      }, function (error) {
	        _this2.unSetLoader();
	        alert("error saving answer");
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }]);
	
	  return QuestionthreeController;
	}();
	
	QuestionthreeController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = QuestionthreeController;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _questionfour = __webpack_require__(378);
	
	var _questionfour2 = _interopRequireDefault(_questionfour);
	
	var _questionfour3 = __webpack_require__(379);
	
	var _questionfour4 = _interopRequireDefault(_questionfour3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var questionfourComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _questionfour2.default,
	  controller: _questionfour4.default,
	  controllerAs: "vm"
	};
	
	exports.default = questionfourComponent;

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"reference-question-wrapper extra-padding\" ng-if=\"vm.event.referenceType=='PROFESSIONAL'\">\n        <h1>How would you rate {{vm.event.jobblerFullName}}'s reliability?</h1>\n      </div>\n      <div class=\"reference-question-wrapper\" ng-if=\"vm.event.referenceType=='PERSONAL'\">\n        <h1>How would you rate {{vm.event.jobblerFullName}}'s timeliness?</h1>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"rating-wrapper\">\n        <ul>\n          <li ng-click=\"vm.setActiveElement(1)\">1</li>\n          <li ng-click=\"vm.setActiveElement(2)\">2</li>\n          <li ng-click=\"vm.setActiveElement(3)\">3</li>\n          <li ng-click=\"vm.setActiveElement(4)\">4</li>\n          <li ng-click=\"vm.setActiveElement(5)\">5</li>\n        </ul>\n      </div>\n    </div>\n    <!--\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding-top:20px;\"></div>\n      <i class=\"fas fa-frown\" style=\"font-size:30px;padding-left:0px;\"></i>\n      <i class=\"fas fa-smile-beam\" style=\"font-size:30px;float:right;padding-right:2px;\"></i>\n    </div>\n  -->\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"reference-button-wrapper\">\n        <button class=\"reference-button\" ng-click=\"vm.saveAnswer()\" ng-disabled=\"vm.disableButton\">Next</button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(362);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QuestionfourController = function () {
	  function QuestionfourController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    _classCallCheck(this, QuestionfourController);
	
	    this.name = "questionfour";
	    //this.walkthroughState = WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	    this.referenceScreens = _variables.REFERENCE_SCREENS;
	    this.disableButton = true;
	  }
	
	  _createClass(QuestionfourController, [{
	    key: "$onInit",
	    value: function $onInit() {}
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      var _this = this;
	
	      this.$timeout(function () {
	        _this.$rootScope.$emit("SendToNextReferenceScreen", {
	          referenceScreen: _this.referenceScreens.QUESTION_FOUR
	        });
	      });
	    }
	  }, {
	    key: "setActiveElement",
	    value: function setActiveElement(eleNum) {
	      this.answer = eleNum;
	
	      var activeEl = ".rating-wrapper ul li.active";
	      var el = ".rating-wrapper ul li:nth-child(" + eleNum + ")";
	
	      if ($(activeEl).length >= 1) {
	        this.$timeout(function () {
	          $(activeEl).removeClass("active");
	        });
	      }
	
	      this.$timeout(function () {
	        $(el).addClass("active");
	      });
	
	      this.disableButton = false;
	    }
	  }, {
	    key: "saveAnswer",
	    value: function saveAnswer() {
	      var _this2 = this;
	
	      var data = {};
	
	      this.setLoader();
	      data.questionId = this.determineReferenceTypeAndReturnProoperQuestionId();
	      data.answer = this.answer;
	      data.userReferenceId = this.event.rid;
	
	      this.$security.saveReferenceQuestion(data).then(function (response) {
	        _this2.unSetLoader();
	        _this2.goNext();
	      }, function (error) {
	        _this2.unSetLoader();
	        alert("error saving answer");
	      });
	    }
	  }, {
	    key: "determineReferenceTypeAndReturnProoperQuestionId",
	    value: function determineReferenceTypeAndReturnProoperQuestionId() {
	
	      var result = void 0;
	
	      if (this.event.referenceType === "PROFESSIONAL") {
	        result = this.$security.findQuestionId("Rate their reliability, 5 being you think they are extremely reliable", this.event.questions);
	      } else {
	        result = this.$security.findQuestionId("timeliness", this.event.questions);
	      }
	
	      return result;
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }]);
	
	  return QuestionfourController;
	}();
	
	QuestionfourController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = QuestionfourController;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _questionfive = __webpack_require__(381);
	
	var _questionfive2 = _interopRequireDefault(_questionfive);
	
	var _questionfive3 = __webpack_require__(382);
	
	var _questionfive4 = _interopRequireDefault(_questionfive3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var questionfiveComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _questionfive2.default,
	  controller: _questionfive4.default,
	  controllerAs: "vm"
	};
	
	exports.default = questionfiveComponent;

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"reference-question-wrapper\" ng-if=\"vm.event.referenceType=='PROFESSIONAL'\">\n        <h1>Did {{vm.event.jobblerFullName}} quickly and easily pick up assigned tasks?</h1>\n      </div>\n      <div class=\"reference-question-wrapper\" ng-if=\"vm.event.referenceType=='PERSONAL'\">\n        <h1>Do you have any additional comments about {{vm.event.jobblerFullName}}?</h1>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\" ng-if=\"vm.event.referenceType=='PROFESSIONAL'\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"rating-wrapper\">\n        <ul>\n          <li ng-click=\"vm.setActiveElement(1)\">1</li>\n          <li ng-click=\"vm.setActiveElement(2)\">2</li>\n          <li ng-click=\"vm.setActiveElement(3)\">3</li>\n          <li ng-click=\"vm.setActiveElement(4)\">4</li>\n          <li ng-click=\"vm.setActiveElement(5)\">5</li>\n        </ul>\n      </div>\n    </div>\n    <!--\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding-top:20px;\"></div>\n      <i class=\"fas fa-frown\" style=\"font-size:30px;padding-left:0px;\"></i>\n      <i class=\"fas fa-smile-beam\" style=\"font-size:30px;float:right;padding-right:2px;\"></i>\n    </div>\n  -->\n  </div>\n  <div class=\"row\" ng-if=\"vm.event.referenceType=='PERSONAL'\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <form class=\"final-comments\">\n        <textarea autofocus rows=\"4\" ng-model=\"vm.answer\"></textarea>\n      </form>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-if=\"vm.event.referenceType=='PERSONAL'\">\n      <div class=\"reference-button-wrapper less\">\n        <button class=\"reference-button\" ng-change=\"vm.commentEntered()\" ng-click=\"vm.saveAnswer()\" ng-disabled=\"vm.disableButton\">Next</button>\n      </div>\n    </div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-if=\"vm.event.referenceType=='PROFESSIONAL'\">\n      <div class=\"reference-button-wrapper\">\n        <button class=\"reference-button\" ng-change=\"vm.commentEntered()\" ng-click=\"vm.saveAnswer()\" ng-disabled=\"vm.disableButton\">Next</button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(362);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QuestionfiveController = function () {
	  function QuestionfiveController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    _classCallCheck(this, QuestionfiveController);
	
	    this.name = "questionfive";
	    //this.walkthroughState = WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	    this.referenceScreens = _variables.REFERENCE_SCREENS;
	    this.disableButton = true;
	  }
	
	  _createClass(QuestionfiveController, [{
	    key: "$onInit",
	    value: function $onInit() {}
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      var _this = this;
	
	      if (this.event.referenceType === "PERSONAL") {
	        this.$timeout(function () {
	          _this.$rootScope.$emit("SendToNextReferenceScreen", {
	            referenceScreen: _this.referenceScreens.POSTCONFIRMATION
	          });
	        });
	      } else {
	        this.$timeout(function () {
	          _this.$rootScope.$emit("SendToNextReferenceScreen", {
	            referenceScreen: _this.referenceScreens.CONFIRMATION
	          });
	        });
	      }
	    }
	  }, {
	    key: "setActiveElement",
	    value: function setActiveElement(eleNum) {
	      this.answer = eleNum;
	
	      var activeEl = ".rating-wrapper ul li.active";
	      var el = ".rating-wrapper ul li:nth-child(" + eleNum + ")";
	
	      if ($(activeEl).length >= 1) {
	        this.$timeout(function () {
	          $(activeEl).removeClass("active");
	        });
	      }
	
	      this.$timeout(function () {
	        $(el).addClass("active");
	      });
	
	      this.disableButton = false;
	    }
	  }, {
	    key: "commentEntered",
	    value: function commentEntered() {
	      this.disableButton = false;
	    }
	  }, {
	    key: "saveAnswer",
	    value: function saveAnswer() {
	      var _this2 = this;
	
	      var data = {};
	
	      this.setLoader();
	      data.questionId = this.determineReferenceTypeAndReturnProoperQuestionId();
	      data.answer = this.answer;
	      data.userReferenceId = this.event.rid;
	      if (this.event.referenceType === "PERSONAL") {
	        data.status = "COMPLETED";
	      }
	
	      this.$security.saveReferenceQuestion(data).then(function (response) {
	        _this2.unSetLoader();
	        _this2.goNext();
	      }, function (error) {
	        _this2.unSetLoader();
	        alert("error saving answer");
	      });
	    }
	  }, {
	    key: "determineReferenceTypeAndReturnProoperQuestionId",
	    value: function determineReferenceTypeAndReturnProoperQuestionId() {
	
	      var result = void 0;
	
	      if (this.event.referenceType === "PROFESSIONAL") {
	        //result = this.$security.findQuestionId("Would you trust", this.event.questions);
	        result = this.$security.findQuestionId("assigned tasks", this.event.questions);
	      } else {
	        result = this.$security.findQuestionId("Do you have any other additional comments about ##JobblerName##?", this.event.questions);
	      }
	
	      return result;
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }]);
	
	  return QuestionfiveController;
	}();
	
	QuestionfiveController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = QuestionfiveController;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _questionsix = __webpack_require__(384);
	
	var _questionsix2 = _interopRequireDefault(_questionsix);
	
	var _questionsix3 = __webpack_require__(385);
	
	var _questionsix4 = _interopRequireDefault(_questionsix3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var questionsixComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _questionsix2.default,
	  controller: _questionsix4.default,
	  controllerAs: "vm"
	};
	
	exports.default = questionsixComponent;

/***/ }),
/* 384 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"reference-question-wrapper\">\n        <h1>Thank you for your time. Do you have any additional comments about {{vm.event.jobblerFullName}}?</h1>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <form class=\"final-comments\">\n        <textarea autofocus rows=\"4\" ng-model=\"vm.answer\"></textarea>\n      </form>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"reference-button-wrapper less\">\n        <button class=\"reference-button\" ng-click=\"vm.saveAnswer()\">Finish</button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(362);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QuestionsixController = function () {
	  function QuestionsixController($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    _classCallCheck(this, QuestionsixController);
	
	    this.name = "questionsix";
	    //this.walkthroughState = WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;
	
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	    this.referenceScreens = _variables.REFERENCE_SCREENS;
	  }
	
	  _createClass(QuestionsixController, [{
	    key: "$onInit",
	    value: function $onInit() {}
	  }, {
	    key: "goNext",
	    value: function goNext() {
	      var _this = this;
	
	      this.$timeout(function () {
	        _this.$rootScope.$emit("SendToNextReferenceScreen", {
	          referenceScreen: _this.referenceScreens.POSTCONFIRMATION
	        });
	      });
	    }
	  }, {
	    key: "saveAnswer",
	    value: function saveAnswer() {
	      var _this2 = this;
	
	      var data = {};
	
	      this.setLoader();
	      data.questionId = 5;
	      data.answer = this.answer;
	      data.userReferenceId = this.event.rid;
	      data.status = "COMPLETED";
	
	      this.$security.saveReferenceQuestion(data).then(function (response) {
	        _this2.unSetLoader();
	        _this2.goNext();
	      }, function (error) {
	        _this2.unSetLoader();
	        alert("error saving answer");
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }]);
	
	  return QuestionsixController;
	}();
	
	QuestionsixController.$inject = ["$localStorage", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = QuestionsixController;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _confirmation = __webpack_require__(387);
	
	var _confirmation2 = _interopRequireDefault(_confirmation);
	
	var _confirmation3 = __webpack_require__(388);
	
	var _confirmation4 = _interopRequireDefault(_confirmation3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var confirmationComponent = {
	  restrict: "E",
	  bindings: {
	    event: "="
	  },
	  template: _confirmation2.default,
	  controller: _confirmation4.default,
	  controllerAs: "vm"
	};
	
	exports.default = confirmationComponent;

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"reference-question-wrapper extra-padding\" ng-if=\"vm.event.referenceType=='PROFESSIONAL'\">\n        <h1>Thank you for your time.</h1>\n      </div>\n      <div class=\"reference-question-wrapper extra-padding\" ng-if=\"vm.event.referenceType=='PERSONAL'\">\n        <h1>Thanks {{vm.event.userData.firstName}}.</h1>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <p class=\"reference-text small\" ng-if=\"vm.event.referenceType=='PROFESSIONAL'\">Jobble makes it easy for businesses to find the workers they need.</p>\n      <p class=\"reference-text small\" ng-if=\"vm.event.referenceType=='PERSONAL'\">\n        References like yours are important to Jobble so that we can provide a \n        quality workforce and a safe working environment for people like {{vm.event.jobblerFullName}}.\n      </p>\n    </div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"reference-question-wrapper\" ng-if=\"vm.event.referenceType=='PROFESSIONAL'\">\n        <h1>Would you be interested in learning more about Jobble for your staffing needs?</h1>\n      </div>\n      <div class=\"reference-question-wrapper extra-padding\" ng-if=\"vm.event.referenceType=='PERSONAL'\">\n        <h1 ng-if=\"vm.event.referenceType=='PERSONAL'\">Looking for work?</h1>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <div class=\"reference-button-wrapper less\" ng-if=\"vm.event.referenceType=='PROFESSIONAL'\">\n        <button class=\"reference-button\" ng-click=\"vm.goNext(vm.event.referenceType)\">Yes</button>\n      </div>\n      <div class=\"reference-button-wrapper less\" ng-if=\"vm.event.referenceType=='PERSONAL'\">\n        <button class=\"reference-button\" ng-click=\"vm.goNext(vm.event.referenceType)\">FIND WORK</button>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <p class=\"reference-text\" style=\"margin-top: 20px\" ng-if=\"vm.event.referenceType=='PROFESSIONAL'\">\n        Jobble can help you fill your temporary, temp-to-perm, and on-demand staffing needs by tapping in to our nationwide network of 5+\n        million trusted workers.\n      </p>\n      <p class=\"reference-text\" style=\"margin-top: 20px\" ng-if=\"vm.event.referenceType=='PERSONAL'\">\n        Jobble makes it easy for people like {{vm.event.jobblerFullName}} to find work that fits their schedule every day.\n      </p>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _variables = __webpack_require__(362);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ConfirmationController = function () {
	  function ConfirmationController($localStorage, $window, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
	    _classCallCheck(this, ConfirmationController);
	
	    this.name = "confirmation";
	    //this.walkthroughState = WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;
	    this.$localStorage = $localStorage;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$window = $window;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	    this.$tracking = TrackingService;
	    this.$events = events;
	    this.referenceScreens = _variables.REFERENCE_SCREENS;
	  }
	
	  _createClass(ConfirmationController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      console.log("init");
	      console.dir(this.event);
	      console.dir(this.sessionData);
	    }
	  }, {
	    key: "goNext",
	    value: function goNext(type) {
	      if (type === "PERSONAL") {
	        //TODO: figure out what to do
	        this.$window.open('https://link.jobble.com/KjBiGIAyINb', '_blank');
	      } else {
	        this.$window.open('https://meetings.hubspot.com/corey2/round-robin-to-sales?uuid=13de8d00-b084-4a64-8ae7-c36f3fb54a04', '_blank');
	        this.triggerSlackNotifcation();
	      }
	    }
	  }, {
	    key: "triggerSlackNotifcation",
	    value: function triggerSlackNotifcation() {
	
	      var rid = this.event.rid;
	
	      this.$events.notifyBusinessOfInterestedReference(rid).then(function (r) {
	        console.log("Notified sales team:", r);
	      }).catch(function (err) {
	        console.error(err);
	      });
	    }
	  }]);
	
	  return ConfirmationController;
	}();
	
	ConfirmationController.$inject = ["$localStorage", "$window", "$rootScope", "$scope", "$state", "$stateParams", "auth", "env", "security", "$timeout", "tracking", "events"];
	
	exports.default = ConfirmationController;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _events = __webpack_require__(390);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventsModule = _angular2.default.module("events", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise("/events");
	  $stateProvider.state("events", {
	    url: "/events?t&conf",
	    params: { postedEvent: null, flag: null, clearQuery: null },
	    template: "<events></events>"
	  });
	}).component("events", _events2.default);
	
	exports.default = eventsModule;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _events = __webpack_require__(391);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _events3 = __webpack_require__(392);
	
	var _events4 = _interopRequireDefault(_events3);
	
	__webpack_require__(394);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventsComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _events2.default,
	  controller: _events4.default,
	  controllerAs: "vm"
	};
	
	exports.default = eventsComponent;

/***/ }),
/* 391 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n<div id=\"wrapper\">\n  <section class=\"page-head\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n          <div class=\"page-meta\">\n            <strong>JOBS</strong> Use the 'actions' button on the right hand side of the page to edit your jobs, approve applicants, message and more\n          </div>\n          <div class=\"search-sec\">\n            <form>\n              <input type=\"search\" placeholder=\"\" class=\"search-field-top\" ng-model=\"vm.query\" />\n              <button type=\"submit\" class=\"search-btn\">\n                <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n              </button>\n            </form>\n          </div>\n        </div>\n      </div>\n    </div>\n  </section>\n  <section class=\"job-container\">\n    <a href=\"#modal-verify-email-redesign\" id=\"modal-verify-email-click-redesign\" data-toggle=\"modal\"></a>\n    <div class=\"container\">\n      <div ng-show=\"vm.logo_has_finished_loading\">\n        <!--\n        <div class=\"row\" ng-if=\"(vm.currentUser && (!vm.currentUser.company.companyLogoUriFree || !$root.imgFromProfilePage) && (!vm.currentUser.company.companyLogoUriFree))\">\n          <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n            <div class=\"alert-box alert\" style=\"text-align:center;\">\n              <a href=\"/account-profile\" style=\"color:#fff;\">\n              Looks like you're <span style=\"text-decoration:underline;\">missing a company logo</span>.\n              </a>\n            </div>\n          </div>\n        </div>\n        -->\n      </div>\n      <div class=\"row\" ng-if=\"!vm.currentUser.isVerified\" style=\"margin-bottom: 10px\">\n        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n          <div class=\"alert-box alert\" style=\"text-align: center\">\n            <a href=\"#\" data-toggle=\"modal\" data-target=\"#modal-verify-email-redesign\" style=\"color: #fff\">\n              Looks like you need to\n              <span style=\"text-decoration: underline\">confirm your email address</span>.\n            </a>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12 jobs-sidebar-complete\">\n          <div class=\"job-sidebar\">\n            <div>\n              <h3>Options</h3>\n              <p>\n                <span class=\"no-block\">DAY</span>\n                <span class=\"clear-day\" ng-click=\"vm.clearDate()\">Clear</span>\n              </p>\n              <input\n                type=\"text\"\n                class=\"form-control form-input\"\n                placeholder=\"Select\"\n                id=\"datepickerevents\"\n                name=\"date\"\n                ng-model=\"vm.startDate\"\n                ng-change=\"vm.startDateChange()\"\n              />\n            </div>\n            <p><span>Select</span></p>\n            <ul class=\"list-group list-job\">\n              <li class=\"list-group-item list-job-item job-active\">\n                <a href=\"#\" ng-click=\"vm.changeEventListing(1)\"\n                  >Open <span class=\"badge job-badge\">{{ vm.currentUser.company.totalNumberOfNonCloseEvents }}</span></a\n                >\n              </li>\n              <li class=\"list-group-item list-job-item\">\n                <a href=\"#\" ng-click=\"vm.changeEventListing(2)\"\n                  >Completed <span class=\"badge job-badge\">{{ vm.currentUser.company.totalNumberOfCloseEvents }}</span></a\n                >\n              </li>\n              <li class=\"list-group-item list-job-item\">\n                <a href=\"#\" ng-click=\"vm.changeEventListing(3)\"\n                  >Deleted\n                  <span class=\"badge job-badge\"\n                    >{{ vm.currentUser.company.totalNumberOfEvents - (vm.currentUser.company.totalNumberOfNonCloseEvents +\n                    vm.currentUser.company.totalNumberOfCloseEvents) }}</span\n                  ></a\n                >\n              </li>\n            </ul>\n            <p><span>Sort By</span></p>\n            <div class=\"select-box\">\n              <select\n                class=\"form-control form-input\"\n                ng-model=\"vm.selectedParam\"\n                ng-init=\"vm.selectedParam = vm.queryParams[vm.indexOfselectedParam].id\"\n                ng-options=\"option.id as option.name for option in vm.queryParams\"\n                ng-change=\"vm.queryChanged()\"\n              ></select>\n            </div>\n            <p><span>Results Size</span></p>\n            <div class=\"select-box\">\n              <select\n                class=\"form-control form-input\"\n                ng-model=\"vm.jobListResultSetLimit.value\"\n                ng-options=\"openings for openings in vm.jobListResultSetLimit.values\"\n                ng-change=\"vm.limitChanged()\"\n              ></select>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-md-9 col-sm-12 col-xs-12 jobs-page-complete\" ng-if=\"vm.view === 2\">\n          <div class=\"expand-table-icon\">\n            <i\n              class=\"fa fa-plus-square expand-full-screen\"\n              ng-if=\"vm.events.length > 0 && !vm.table_expanded\"\n              title=\"Expand Jobs Table\"\n              ng-click=\"vm.expandJobsTable()\"\n            >\n            </i>\n\n            <i\n              class=\"fa fa-minus-square expand-full-screen\"\n              ng-if=\"vm.events.length > 0 && vm.table_expanded\"\n              title=\"Expand Jobs Table\"\n              ng-click=\"vm.expandJobsTable()\"\n            >\n            </i>\n\n            <span ng-if=\"vm.events.length > 0\" class=\"expand-link\" ng-click=\"vm.expandJobsTable()\">Expand Jobs Table</span>\n          </div>\n\n          <div class=\"table-header-sticky\" ng-if=\"vm.events.length > 0\">\n            <table class=\"table\">\n              <thead>\n                <tr class=\"sticky-header\">\n                  <th>Job name</th>\n                  <th>Location</th>\n                  <th>Start Date</th>\n                  <th ng-if=\"!vm.table_expanded\">Apps</th>\n                  <th ng-if=\"vm.table_expanded\">Applications</th>\n                  <th>Accepted</th>\n                  <th></th>\n                </tr>\n              </thead>\n            </table>\n          </div>\n\n          <div class=\"job-content-wrapper-list\">\n            <div class=\"jobble-tip clearfix spacing-for-jobble-tip\" ng-if=\"vm.events.length == 0\">\n              <h5>Jobble Tip</h5>\n              <p>There are currently no {{ vm.pageStatus }} jobs for this account.</p>\n              <a href=\"/post-a-shift/walkthrough\" ng-click=\"vm.printRoster()\" class=\"btn btn-success button\">Post a job </a>\n            </div>\n\n            <div\n              class=\"job-content\"\n              infinite-scroll-immediate-check=\"false\"\n              infinite-scroll-parent=\"true\"\n              infinite-scroll=\"vm.scrollEvents()\"\n              infinite-scroll-disabled=\"vm.busy\"\n              infinite-scroll-use-document-bottom=\"false\"\n              infinite-scroll-distance=\".2\"\n              ng-if=\"vm.events.length > 0\"\n            >\n              <div class=\"job-table table-responsive respons-job\">\n                <table class=\"table\" style=\"width: 99%\">\n                  <!--\n                  <thead>\n                    <tr class=\"sticky-header\">\n                      <th style=\"width:270px;font-size:11px;\">Job name</th>\n                      <th style=\"width:238px;font-size:11px;\">Location</th>\n                      <th style=\"font-size:11px;\">Start Date</th>\n                      <th style=\"font-size:11px;\">Applicants</th>\n                      <th style=\"font-size:11px;\">Accepted</th>\n                      <th></th>\n                    </tr>\n                  </thead>\n                  -->\n                  <tbody>\n                    <tr\n                      ng-repeat=\"event in vm.events | filter: vm.query track by $index\"\n                      ng-class=\"{ 'company-not-verified' : event.companyIsNotVerified }\"\n                    >\n                      <td class=\"st-live eta-map-wrapper\" ng-click=\"vm.gotoEventOverview(event)\">\n                        <i\n                          class=\"fa fa-location-arrow eta-locator\"\n                          ng-show=\"event.display_eta\"\n                          ng-click=\"vm.toggle_eta(1,event,$index)\"\n                          title=\"Drivers Current Location and ETA\"\n                          ng-mouseenter=\"vm.toggle_eta_hover(1,event,$index)\"\n                          id=\"eta-locator-id-{{$index}}\"\n                        >\n                        </i>\n                        <div\n                          id=\"eta-target-{{$index}}\"\n                          class=\"eta-map-holder\"\n                          ng-blur=\"vm.blur_off_map($index,event)\"\n                          ng-esc=\"vm.close_eta_modal($index,event)\"\n                          tabindex=\"0\"\n                        >\n                          <div id=\"map-holder-for-shifts\">\n                            <i ng-click=\"vm.close_eta_modal($index,event)\" class=\"fa fa-times-circle close-maps\"></i>\n\n                            <div map-lazy-load=\"https://maps.google.com/maps/api/js\">\n                              <ng-map\n                                id=\"map-eta\"\n                                class=\"map-class-select\"\n                                center=\"{{vm.driver.current_loc.lat}},{{vm.driver.current_loc.lng}}\"\n                                zoom=\"12\"\n                                ng-click=\"vm.clicking_map(event,$index)\"\n                              >\n                                <marker\n                                  ng-repeat=\"pos in vm.positions\"\n                                  position=\"{{pos.position.lat()}}, {{pos.position.lng()}}\"\n                                  icon=\"{{pos.icon}}\"\n                                  title=\"{{pos.title}}\"\n                                  ng-if=\"pos.showMe\"\n                                >\n                                </marker>\n                              </ng-map>\n                            </div>\n                            <span class=\"delivery_info\"> {{vm.display_time}} </span>\n                            <table class=\"delivery-modal-details\">\n                              <thead>\n                                <tr>\n                                  <th ng-click=\"vm.refresh_map_data(event,$index)\">\n                                    <i class=\"fa fa-retweet\" title=\"Refresh Data\"></i>\n                                  </th>\n                                  <th>Scheduled Time</th>\n                                  <th>ETA</th>\n                                  <th>Checkin</th>\n                                </tr>\n                              </thead>\n                              <tbody>\n                                <tr>\n                                  <td>\n                                    <strong>Pickup</strong>\n                                  </td>\n                                  <td>{{vm.modal_data.pickup_shift.expected_arrival_time}}</td>\n                                  <td>{{vm.modal_data.pickup_shift.eta}}</td>\n                                  <td>{{vm.modal_data.pickup_shift.check_in_time}}</td>\n                                </tr>\n                                <tr>\n                                  <td>\n                                    <strong>Dropoff</strong>\n                                  </td>\n                                  <td>{{vm.modal_data.dropoff_shift.expected_arrival_time}}</td>\n                                  <td>{{vm.modal_data.dropoff_shift.eta}}</td>\n                                  <td>{{vm.modal_data.dropoff_shift.check_in_time}}</td>\n                                </tr>\n                              </tbody>\n                            </table>\n                          </div>\n                        </div>\n\n                        <!--<span ng-show=\"vm.currentUser.isAdmin\">[${event.id}]</span>-->\n                        <span ng-if=\"vm.admin\">[ {{event.id}} ]</span>\n                        {{event.name | limitTo:75}}\n                        <span class=\"{{event.listColor}}\">\n                          {{event.status}}\n                          <i ng-show=\"event.warningText\" class=\"fa fa-exclamation-triangle\" title=\"{{event.warningText}}\"> </i>\n                        </span>\n                      </td>\n                      <td ng-click=\"vm.gotoEventOverview(event)\" style=\"max-width: 260px\">{{ vm.getLocation(event) }}</td>\n                      <td ng-click=\"vm.gotoEventOverview(event)\">{{ vm.getEventDate(event.startTime,event.contactInfo.timeZoneId,event) }}</td>\n                      <td ng-click=\"vm.gotoEventOverview(event)\">{{event.numberOfPendingApplications}}</td>\n                      <td ng-click=\"vm.gotoEventOverview(event)\" style=\"text-align: center\" ng-if=\"!vm.admin\">\n                        {{ event.numberOfApprovedApplications }}\n                      </td>\n                      <td ng-click=\"vm.gotoEventOverview(event)\" style=\"text-align: center\" ng-if=\"vm.admin\">\n                        {{ event.numberOfApprovedApplications }}/{{ event.numberOfApprovedApplications + event.numberOfOpenings }}\n                      </td>\n                      <td class=\"dropdown\" style=\"overflow: inherit\">\n                        <i\n                          class=\"fa fa-exclamation-triangle verification-warning\"\n                          ng-if=\"event.companyIsNotVerified\"\n                          title=\"Your company is under review by Jobble\"\n                        >\n                        </i>\n                        <a\n                          href=\"#\"\n                          class=\"dropdown-toggle\"\n                          id=\"dropdownMenu-{{$index}}\"\n                          data-toggle=\"dropdown\"\n                          role=\"button\"\n                          aria-haspopup=\"true\"\n                          aria-expanded=\"false\"\n                          ng-click=\"vm.setEvent(event)\"\n                          ng-if=\"!event.companyIsNotVerified\"\n                        >\n                          <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\n                        </a>\n                        <ul class=\"dropdown-menu-table\" aria-labelledby=\"dropdownMenu-{{$index}}\" ng-if=\"vm.page == 'events'\">\n                          <li ng-if=\"!event.notpublished\">\n                            <a class=\"drop-down-links\" href=\"/event/{{event.id}}/overview\">Overview</a>\n                          </li>\n                          <li ng-if=\"!event.notpublished\">\n                            <a class=\"drop-down-links\" href=\"/event/{{event.id}}/review\" class=\"ng-scope\" ng-if=\"!event.isSourcingPost\"\n                              >Review &amp; Hire Applicants</a\n                            >\n                            <a class=\"drop-down-links\" href=\"/event/{{event.id}}/review\" class=\"ng-scope\" ng-if=\"event.isSourcingPost\"\n                              >Review Candidates</a\n                            >\n                          </li>\n                          <!-- /messages/event/{{event.id}} -->\n                          <li ng-if=\"!event.notpublished\">\n                            <a class=\"drop-down-links\" href=\"\" ng-click=\"vm.inboxLink(event.id)\">Message</a>\n                          </li>\n                          <li ng-if=\"!event.notpublished\">\n                            <a class=\"drop-down-links\" href=\"/event/{{event.id}}/roster\" ng-if=\"event.isSourcingPost\">Download Candidates</a>\n                            <a class=\"drop-down-links\" href=\"/event/{{event.id}}/roster\" ng-if=\"!event.isSourcingPost\">Roster</a>\n                          </li>\n                          <li ng-if=\"!event.notpublished\">\n                            <a class=\"drop-down-links\" href=\"/event/{{event.id}}/edit\">Edit Details</a>\n                          </li>\n                          <li ng-if=\"!event.notpublished\">\n                            <a class=\"drop-down-links\" href=\"/event/{{event.id}}/live\" ng-if=\"!event.isSourcingPost\">Live</a>\n                          </li>\n                          <li ng-if=\"!event.notpublished\">\n                            <a\n                              class=\"drop-down-links\"\n                              href=\"#modal-add-openings\"\n                              data-toggle=\"modal\"\n                              ng-click=\"vm.setEventOpenings(event)\"\n                              ng-if=\"!event.isSourcingPost\"\n                              >Add/Remove Openings</a\n                            >\n                          </li>\n                          <li ng-if=\"!event.notpublished\">\n                            <a ng-if=\"!event.orderNumber\" class=\"drop-down-links\" href=\"/post-a-shift/walkthrough?cid={{event.id}}\">Clone</a>\n                            <a ng-if=\"event.orderNumber\" class=\"drop-down-links\" href=\"/postorder?eid={{event.id}}\">Clone</a>\n                          </li>\n                          <li ng-if=\"!event.notpublished\">\n                            <a class=\"drop-down-links\" href=\"/event/{{event.id}}/complete\" ng-if=\"!event.isSourcingPost\"> Make Payment </a>\n                          </li>\n\n                          <li ng-if=\"!event.notpublished\">\n                            <a class=\"drop-down-links\" data-target=\"#modal-del-event\" data-toggle=\"modal\">Delete</a>\n                          </li>\n                          <!-- Draft Links -->\n                          <li ng-if=\"event.notpublished\">\n                            <a\n                              class=\"drop-down-links\"\n                              href=\"/post-a-shift/walkthrough?eid={{event.id}}&jid={{ event.subEvents[0].deduppedJobbles[0].id }}\"\n                            >\n                              Edit\n                            </a>\n                          </li>\n                          <!-- href=\"#modal-publish-event\" -->\n                          <li ng-if=\"!event.notpublished\">\n                            <a class=\"drop-down-links\" ng-click=\"vm.setPublishType(1,event)\"> Unpublish </a>\n                          </li>\n                          <li ng-if=\"event.notpublished\">\n                            <a class=\"drop-down-links\" ng-click=\"vm.setPublishType(2,event)\"> Publish </a>\n                          </li>\n                          <li ng-if=\"event.notpublished\">\n                            <a class=\"drop-down-links\" data-target=\"#modal-del-event\" data-toggle=\"modal\"> Delete </a>\n                          </li>\n                          <!--<li ng-if=\"!event.notpublished && event.status != 'Payment Pending' && vm.admin==true\">\n                                                        <a class=\"drop-down-links\" href=\"\" ng-click=\"vm.promoteJob(event)\"> Promote </a>\n                                                    </li>-->\n                          <li ng-if=\"!event.notpublished\">\n                            <a class=\"drop-down-links\" href=\"\" ng-click=\"vm.copyJobbleID(event)\"> Copy Job Link </a>\n                          </li>\n                          <li ng-if=\"!event.notpublished\">\n                            <a class=\"drop-down-links\" href=\"\" ng-click=\"vm.copyEventID(event)\"> Copy Event ID </a>\n                          </li>\n                          <li ng-if=\"!event.notpublished\">\n                            <a class=\"drop-down-links\" href=\"/event/{{event.id}}/payshifts\" ng-if=\"!event.isSourcingPost\"> Pay By Shift </a>\n                          </li>\n                        </ul>\n                        <ul\n                          class=\"dropdown-menu-table\"\n                          aria-labelledby=\"dropdownMenu-{{$index}}\"\n                          ng-if=\"vm.page == 'history' || vm.page === 'cancelled'\"\n                        >\n                          <li ng-if=\"event.firstInvoices[0].payment\">\n                            <a class=\"drop-down-links\" href=\"/invoice/{{event.firstInvoices[0].payment}}?eventId={{event.id}}\" target=\"_blank\">\n                              Invoice\n                            </a>\n                          </li>\n                          <li ng-if=\"event.firstInvoices[0].cdnUrl\">\n                            <a class=\"drop-down-links\" href=\"{{ event.firstInvoices[0].cdnUrl }}\" target=\"_blank\">Invoice PDF</a>\n                          </li>\n                          <li>\n                            <a class=\"drop-down-links\" href=\"/event/{{event.id}}/overview\">Overview</a>\n                          </li>\n                          <li>\n                            <a class=\"drop-down-links\" ng-click=\"vm.inboxLink(event.id)\" ng-hide=\"vm.page === 'cancelled'\">Message</a>\n                          </li>\n                          <li>\n                            <a class=\"drop-down-links\" href=\"/event/{{event.id}}/roster\">Roster</a>\n                          </li>\n                          <li>\n                            <a class=\"drop-down-links\" ng-if=\"!event.orderNumber\" href=\"/post-a-shift/walkthrough?cid={{event.id}}\">Clone</a>\n                          </li>\n                          <li>\n                            <a class=\"drop-down-links\" ng-if=\"event.orderNumber\" href=\"postorder?eid={{event.id}}\">Clone</a>\n                          </li>\n                          <li>\n                            <a class=\"drop-down-links\" href=\"/event/{{event.id}}/complete\">Recap</a>\n                          </li>\n                        </ul>\n                      </td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\" ng-if=\"vm.currentUser.company.totalNumberOfNonCloseEvents > 9\" ng-hide=\"vm.dates\">\n        <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"></div>\n        <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\">\n          <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n            <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"></div>\n            <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\">\n              <div class=\"load-more-loader\" style=\"height: 30px\">\n                <img src=\"/app/vendor/images/spinner-loading.gif\" ng-if=\"vm.busy\" />\n              </div>\n            </div>\n            <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\">\n              <div class=\"sorting-counter\" style=\"margin-top: 30px\" ng-if=\"vm.page == 'events'\">\n                {{vm.events.length}} / {{ vm.currentUser.company.totalNumberOfNonCloseEvents }}\n              </div>\n              <div class=\"sorting-counter\" style=\"margin-top: 30px\" ng-if=\"vm.page == 'history'\">\n                {{vm.events.length}} / {{ vm.currentUser.company.totalNumberOfCloseEvents }}\n              </div>\n              <div class=\"sorting-counter\" style=\"margin-top: 30px\" ng-if=\"vm.page == 'cancelled'\">\n                {{vm.events.length}} / {{ vm.currentUser.company.totalNumberOfEvents - (vm.currentUser.company.totalNumberOfNonCloseEvents +\n                vm.currentUser.company.totalNumberOfCloseEvents) }}\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n\n<jobblefooter></jobblefooter>\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n<globalmodal></globalmodal>\n<eventdialog></eventdialog>\n\n<!--\n<div \n\tclass=\"modal fade\" \n\tid=\"promote-job\" \n\ttabindex=\"-1\" \n\trole=\"dialog\" \n\taria-labelledby=\"modal-add-projectLabel\" \n\tdata-backdrop=\"static\">\n\t<div class=\"vertical-alignment-helper\">\n    \t<div class=\"modal-dialog vertical-align-center\">\n      \t\t<div class=\"modal-dialog popup\">\n        \t\t<div class=\"modal-content popup-content\">\n          \t\t\t<div class=\"modal-header popup-header\">\n          \t\t\t\t<button \n          \t\t\t\t\ttype=\"button\" \n          \t\t\t\t\tclass=\"close popup-close\" \n          \t\t\t\t\tdata-dismiss=\"modal\" \n          \t\t\t\t\taria-label=\"Close\">\n                    \t\t<i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n                    \t</button>\n            \t\t\t<strong>Are you sure you want to promote this job?</strong>\n          \t\t\t</div>\n\t          \t\t<div class=\"modal-body  popup-body text-center\">\n\t            \t\t<a \n\t            \t\t\tclass=\"btn btn-danger button solid-danger\" \n\t            \t\t\thref=\"\" \n\t            \t\t\tng-click=\"vm.closePromote()\">\n\t            \t\t\t\tCancel\n\t            \t\t</a>\n\t            \t\t<a \n\t            \t\t\tclass=\"btn btn-success button\" \n\t            \t\t\thref=\"\" \n\t            \t\t\tng-click=\"vm.confirmPromote()\">\n\t            \t\t\t\tYes\n\t            \t\t</a>\n\t          \t\t</div>\n        \t\t</div>\n      \t\t</div>\n    \t</div>\n  \t</div>\n</div>\n-->\n<paymentdialog></paymentdialog>\n"

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _events2 = __webpack_require__(49);
	
	var _events3 = _interopRequireDefault(_events2);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventsController = function () {
	  function EventsController($http, $localStorage, $state, AuthService, EventsService, CompaniesService, SecurityService, $rootScope, $timeout, $window, $location, $stateParams, ScrollService, EnvService, $scope, NgMap, branchio) {
	    _classCallCheck(this, EventsController);
	
	    this.name = "events";
	    $localStorage.activeStateName = "events";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$location = $location;
	    this.$events = EventsService;
	    this.$companies = CompaniesService;
	    this.$security = SecurityService;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$timeout = $timeout;
	    this.$scroll = ScrollService;
	    this.$stateParams = $stateParams;
	    this.$branchio = branchio;
	    this.page = "events";
	    this.isEzcaterAdmin = false;
	    this.logo_has_finished_loading = false;
	    this.$window = $window;
	    this.BreakException = {};
	    this.$maps = NgMap;
	    this.busy = false;
	    this.thereAreEvents = true;
	    this.sort = 0;
	    this.jobListResultSetLimit = { value: 10, values: [9, 18, 10, 50] };
	    this.nameSort = 0;
	    this.$env = EnvService;
	    this.events_for_payment = [];
	    this.events_for_closure = [];
	    this.events = [];
	    this.events_for_header = [];
	    this.view = 2;
	    this.gridViewClass = "btn button btn-grey";
	    this.listViewClass = "btn btn-success button";
	    this.pages = [];
	    this.query = "";
	    this.indexOfselectedParam = 0;
	    this.currentPageNumber = 1;
	    this.queryParams = [{ id: 0, name: "--Select--" }, { id: 1, name: "Start date : Oldest" }, { id: 2, name: "Start date : Newest" }, { id: 5, name: "A->Z" }, { id: 6, name: "Z->A" }];
	
	    this.remain_loading_count = 1;
	
	    var _this = this;
	
	    _this.checkToClearQuery(_this.$stateParams.clearQuery);
	    _this.isThisEzCaterAdmin();
	
	    if (!SecurityService.isUndefinedOrNull(_this.$stateParams.t)) {
	      _this.remain_loading_count++;
	      _this.$auth.validateUserByTokenWeb(_this.$stateParams.t).then(function (response) {
	        _this.remain_loading_count--;
	        //console.log("what is the response");
	        var user = response.data;
	        if (response.data.company.id) {
	          dataLayer.push({
	            "event category": "business signup",
	            "event action": "business validation success",
	            accountId: response.data.id,
	            event: "businessSignupEvent"
	          });
	          if (response.data.company.undeletedPaymentInfos.length === 0 && response.data.company.partner) {
	            _this.$state.go("accountprofile-payment-information", {
	              companyId: response.data.company.id,
	              validation: false
	            });
	            return;
	          }
	          _this.$localStorage.logged_user = response.data;
	          _this.currentUser = response.data;
	          _this.displayHistoryButton();
	          _this.handleSessionParams();
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("UpdateCurrentUser", {
	              user: user
	            });
	          });
	          _this.$timeout(function () {
	            _this.remain_loading_count--;
	            _this.$rootScope.$emit("GetLogo", user);
	          }, 150);
	
	          _this.$timeout(function () {
	            _this.$state.go("jobsdashboard");
	          }, 300);
	
	          //_this.loadEvents();
	        } else {
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("SetNewUserForJobBoardHeader", {
	              user: user
	            });
	          });
	          //_this.$state.go('jobs',{data: "new_user"});
	          _this.$timeout(function () {
	            _this.$state.go("jobsdashboard");
	          }, 300);
	        }
	      }, function (response) {
	        _this.remain_loading_count--;
	        $state.go("signin");
	      });
	    } else {
	      //console.log("AuthService.isLoggedIn");
	      //console.dir(AuthService.isLoggedIn());
	      console.log("EVENTS CONTROLLER");
	      console.log("EVENTS CONTROLLER");
	      console.log("EVENTS CONTROLLER");
	      console.log("EVENTS CONTROLLER");
	
	      if (!AuthService.isLoggedIn()) {
	        if (_this.$location.$$search.jobType) {
	          $state.go("postevent", {
	            jobType: _this.$location.$$search.jobType,
	            pay: _this.$location.$$search.pay,
	            openings: _this.$location.$$search.openings
	          });
	        } else {
	          $state.go("signin");
	        }
	        return;
	      }
	      _this.currentUser = _this.$auth.getUserData();
	      //console.log("_this.currentUser");
	      //console.dir(_this.currentUser);
	      if (_this.currentUser.company.id === null) {
	        _this.$state.go("jobs");
	        return;
	      }
	      //_this.checkUserVerifications();
	      _this.displayHistoryButton();
	      _this.handleSessionParams();
	      _this.setLogoBanner();
	      _this.loadEvents();
	      _this.$timeout(function () {
	        _this.$state.go("jobsdashboard");
	      }, 300);
	    }
	
	    _this.$timeout(function () {
	      jQuery("body").removeClass("modal-open");
	      $("#ngProgress-container").remove();
	    }, 300);
	
	    _this.$timeout(function () {
	      _this.$rootScope.$emit("UpdatedCreditCard", {});
	    });
	
	    _this.UpdateEventsToPublishedListener = _this.$rootScope.$on("UpdateEventsToPublished", function () {
	      _this.currentUser = _this.$auth.getUserData();
	      _this.$timeout(function () {
	        _this.loadEvents();
	      }, 1000);
	    });
	
	    _this.SuccessToDeleteEventListener = _this.$rootScope.$on("SuccessToDeleteEvent", function ($event, params) {
	      _this.removeTheDeletedEvent(params);
	    });
	
	    _this.SuccessPublishEventListener = _this.$rootScope.$on("SuccessPublishEvent", function ($event, params) {
	      console.log("SuccessPublishEventListener");
	      console.dir(params);
	      if (params.status === false) {
	        var data = {};
	        data.status = params.status;
	        data.event = params.event.id;
	        _this.markEventAsPublished(data);
	        //_this.closePublishModal();
	        //_this.unSetLoader()
	      } else if (params.message === true) {
	        console.log("we need to charge our invoice customer....");
	        params.card = null;
	        _this.closeModalAndCharge(params);
	      } else {
	        console.log("we are here...");
	        var _data = {};
	        _data.status = params.status;
	        _data.event = params.event.id;
	        _this.markEventAsPublished(_data);
	      }
	    });
	
	    _this.ChargeCreditCardForPostListener = _this.$rootScope.$on("ChargeCreditCardForPost", function ($event, params) {
	      console.log("ChargeCreditCardForPost");
	      console.dir(params);
	      var data = {};
	      data.invoice = false;
	      data.event = params.event;
	      data.status = true;
	      data.new_card = true;
	      data.card = params.new_card;
	      _this.closeModalAndCharge(data);
	    });
	
	    _this.CloseCreditCardModalEventsListener = _this.$rootScope.$on("CloseCreditCardModalEvents", function ($event, params) {
	      console.log("CloseCreditCardModalEvents");
	      console.dir(params);
	      _this.closeModalAndCharge(params);
	    });
	
	    _this.CloseEtaModalListener = _this.$rootScope.$on("CloseEtaModal", function ($event, params) {
	      _this.close_eta_modal(params);
	    });
	
	    _this.SetEventToEventPagesListener = _this.$rootScope.$on("SetEventToEventPages", function ($event, params) {
	      _this.events.forEach(function (event) {
	        if (event.id === params.event.id) {
	          event.cost = params.event.cost;
	          if (params.action === "Add") {
	            event.numberOfOpenings = params.event.numberOfOpenings + params.openings;
	          } else {
	            event.numberOfOpenings = params.event.numberOfOpenings - params.openings;
	          }
	          event.totalNumberOfJobbles = params.event.totalNumberOfJobbles;
	        }
	      });
	    });
	
	    _this.SetLogoToEventsPageListener = _this.$rootScope.$on("SetLogoToEventsPage", function ($event, params) {
	      _this.set_logo_for_events_banner(params);
	    });
	
	    _this.$scope.$on("$destroy", _this.CloseEtaModalListener);
	    _this.$scope.$on("$destroy", _this.ChargeCreditCardForPostListener);
	    _this.$scope.$on("$destroy", _this.CloseCreditCardModalEventsListener);
	    _this.$scope.$on("$destroy", _this.SetLogoToEventsPageListener);
	    _this.$scope.$on("$destroy", _this.SuccessPublishEventListener);
	    _this.$scope.$on("$destroy", _this.SetEventToEventPagesListener);
	    _this.$scope.$on("$destroy", _this.UpdateEventsToPublishedListener);
	    _this.$scope.$on("$destroy", _this.SuccessToDeleteEventListener);
	
	    _this.$timeout(function () {
	      $("jobbleheader .main-menu ul li:nth-child(2)").removeClass().addClass("active");
	    });
	  }
	
	  _createClass(EventsController, [{
	    key: "loadEvents",
	    value: function loadEvents(params) {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.remain_loading_count = 1;
	      }, 200);
	      //console.log("going to load eventts...");
	      //console.dir(_this.$rootScope.sessionParams);
	
	      if (_this.$rootScope.sessionParams) {
	        if (!_this.$rootScope.sessionParams.id) {
	          _this.selectedParam = 0;
	          _this.indexOfselectedParam = 0;
	        } else {
	          _this.selectedParam = _this.$rootScope.sessionParams.id;
	          _this.indexOfselectedParam = _this.$rootScope.sessionParams.id;
	        }
	        _this.jobListResultSetLimit.value = _this.$rootScope.sessionParams.maxParam;
	        params = _this.$rootScope.sessionParams;
	      } else {
	        _this.indexOfselectedParam = 0;
	        _this.selectedParam = 0;
	      }
	      var offsetParam = null,
	          maxParam = null,
	          page = null,
	          sort = null,
	          order = null,
	          isCompleted = null,
	          isCancelled = null,
	          dates = null;
	
	      //console.log("what are params right hehre");
	      //console.dir(params);
	      if (params) {
	        offsetParam = params.offsetParam, maxParam = params.maxParam, page = params.page, sort = params.sort, order = params.order, isCompleted = params.isCompleted, isCancelled = params.isCancelled, dates = params.dates;
	      } else {
	        _this.$rootScope.sessionParams = {};
	        _this.$rootScope.sessionParams.dates = _this.dates;
	        _this.$rootScope.sessionParams.maxParam = 10;
	        _this.$rootScope.sessionParams.offsetParam = 0;
	        _this.$rootScope.sessionParams.sort = "startTime";
	        _this.$rootScope.sessionParams.order = "asc";
	        _this.cachedParams = _this.$rootScope.sessionParams;
	        _this.$rootScope.sessionParams.page = "live";
	        offsetParam = 0, maxParam = 10, page = "live", sort = "startTime", order = "asc";
	      }
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetLoaderDialog", { type: 1, total: 2 });
	      });
	      _this.$companies.eventsForEventsPage(_this.currentUser.company.id, offsetParam, maxParam, page, sort, order, isCompleted, isCancelled, dates).then(function (data) {
	        _this.$timeout(function () {
	          _this.remain_loading_count = 0;
	        }, 1000);
	        _this.events = data.data;
	        if (_this.events.length > 0) {
	          _this.reconfigurePaginationPages();
	        }
	        if (_this.events.length > 0 && !_this.currentUser.isVerified) {
	          _this.$timeout(function () {
	            jQuery("#show-application-global-modal-new").trigger("click");
	          });
	        }
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetLoaderDialog", {
	            type: 2,
	            total: 2
	          });
	        });
	        try {
	          _this.events.forEach(function (event) {
	            //console.log("event here..");
	            //console.dir(event);
	            if (event.contactInfo[0]) {
	              event.contactInfo = event.contactInfo[0];
	            }
	            _this.addExtraAttributesToEvent(event);
	          });
	        } catch (err) {
	          //console.log("we have an error...");
	          //console.dir(err);
	          //_this.$state.go('signin');
	        } finally {
	          _this.checkAdmin();
	          _this.setDatePicker();
	          _this.$timeout(function () {
	            _this.remain_loading_count = 0;
	            _this.$rootScope.events = _this.events;
	            _this.$localStorage.events = _this.events;
	            _this.$timeout(function () {
	              _this.$rootScope.$emit("SetLoaderDialog", {
	                type: 0,
	                total: 2
	              });
	            });
	          }, 1000);
	        }
	      }, function (data) {
	        _this.events = [];
	        _this.remain_loading_count = 0;
	        if (data.status === 401) {
	          _this.$state.go("signin");
	        } else {
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	        }
	      });
	    }
	  }, {
	    key: "addExtraAttributesToEvent",
	    value: function addExtraAttributesToEvent(event) {
	      event.status = "Live";
	      var startTimeOfJob = null;
	      var endTimeOfJob = null;
	      var paymentPending = null;
	      var startTimeCheck = null;
	      var endTimeCheck = null;
	      startTimeOfJob = moment(event.startTime).format();
	      endTimeOfJob = moment(event.endTime).format();
	      startTimeCheck = moment().diff(startTimeOfJob, "minutes") >= -10;
	      endTimeCheck = moment().diff(endTimeOfJob, "minutes") <= 10;
	      paymentPending = moment().diff(endTimeOfJob, "minutes") >= 10;
	      this.setEventsToHeader(event);
	      if (event.orderNumber) {
	        this.getAcceptedApplicant(event);
	        if (event.subEvents[0].deduppedJobbles[0].lastUpdateFront) {
	          event.display_eta = true;
	        }
	      }
	      if (!this.currentUser.company.isVerified) {
	        event.companyIsNotVerified = true;
	        if (!event.subEvents[0].deduppedJobbles[0] || event.subEvents[0].deduppedJobbles[0].isPublished) {
	          event.status = "Company Under Review";
	          event.listColor = "event-listing-color-red";
	          return;
	        }
	      } else {
	        event.companyIsNotVerified = false;
	      }
	      if (!event.subEvents[0].deduppedJobbles[0]) {
	        return;
	      }
	      if (event.isCancelled) {
	        event.status = "Deleted";
	        event.listColor = "event-listing-color-black";
	        return;
	      }
	      if (event.isCompleted) {
	        event.status = "Completed";
	        event.listColor = "event-listing-color-black";
	        return;
	      }
	      if (!event.subEvents[0].deduppedJobbles[0].isPublished && !event.orderNumber) {
	        if (!this.currentUser.company.isVerified) {
	          event.status = "Pending Approval";
	          event.listColor = "event-listing-color-red";
	          event.notpublished = true;
	          return;
	        } else {
	          event.status = "Draft";
	          event.listColor = "event-listing-color-blue";
	          event.notpublished = true;
	          if (event.isCancelled) {
	            event.status = "Deleted";
	            event.listColor = "event-listing-color-black";
	            return;
	          }
	          return;
	        }
	      } else if (!event.subEvents[0].deduppedJobbles[0].isPublished && event.orderNumber && event.numberOfApprovedApplications === 1) {
	        if (event.hired_driver) {
	          event.status = "Filled - " + event.hired_driver;
	        } else {
	          event.status = "Published - Filled";
	        }
	        event.listColor = "event-listing-color-orange";
	        if (paymentPending === true) {
	          if (event.hired_driver) {
	            //console.log("coming right herelol");
	            event.status = "Payment Pending - " + event.hired_driver;
	          } else {
	            event.status = "Payment Pending";
	            _this.check_hired_numbers(event);
	          }
	          event.listColor = "event-listing-color-red";
	          return;
	        }
	        return;
	      } else if (!event.subEvents[0].deduppedJobbles[0].isPublished && event.orderNumber && event.numberOfApprovedApplications === 0) {
	        event.status = "Removed from board";
	        event.listColor = "event-listing-color-red";
	        return;
	      }
	      if (event.subEvents[0].deduppedJobbles[0].isPublished) {
	        if (event.isCompleted || event.isClosed) {
	          event.status = "Completed";
	          event.listColor = "event-listing-color-black";
	          return;
	        }
	        if (event.isCancelled) {
	          event.status = "Deleted";
	          event.listColor = "event-listing-color-black";
	          return;
	        }
	        if (startTimeCheck === true && endTimeCheck === true) {
	          event.status = "Live";
	          event.listColor = "event-listing-color-green";
	          return;
	        }
	        if (paymentPending === true) {
	          if (event.isSourcingPost) {
	            event.status = "Removed - 30 Days Expired";
	          } else {
	            event.status = "Payment Pending";
	          }
	          event.listColor = "event-listing-color-red";
	          return;
	        } else {
	          event.status = "Published";
	          event.listColor = "event-listing-color-orange";
	        }
	      }
	    }
	  }, {
	    key: "check_hired_numbers",
	    value: function check_hired_numbers(e) {
	      var _this = this;
	      if (e.numberOfApprovedApplications > 0) {} else {
	        _this.events_for_closure.push(e);
	      }
	    }
	  }, {
	    key: "getAcceptedApplicant",
	    value: function getAcceptedApplicant(event) {
	      var _this = this;
	      var accepted_applicants = [];
	      if (event.subEvents[0].deduppedJobbles.length > 0) {
	        var applications = event.subEvents[0].deduppedJobbles[0].applications;
	        try {
	          if (applications) {
	            applications.forEach(function (application) {
	              if (application) {
	                if (application.applicationStatusId) {
	                  if (application.applicationStatusId === 1) {
	                    accepted_applicants.push(application);
	                    var lastName = application.applicantLastName.substring(0, 1);
	                    event.hired_driver = application.applicantFirstName + " " + lastName + ".";
	                  } else if (application.applicationStatusId === 4) {
	                    if (!event.warningText) {
	                      event.warningText = application.applicantFirstName + " " + application.applicantLastName + "has quit the order.";
	                    }
	                  } else if (application.applicationStatusId === 2) {
	                    if (event.warningText === "") {
	                      event.warningText = application.applicantFirstName + " " + application.applicantLastName + "was rejected from order.";
	                    }
	                  }
	                }
	              }
	            });
	          }
	        } catch (err) {
	          //console.log("error with the applications");
	          //console.dir(err);
	        }
	      }
	    }
	  }, {
	    key: "getEventDate",
	    value: function getEventDate(raw_date, tz, event) {
	      var _this = this;
	      var date = new Date(raw_date);
	      var user_time_zone = moment.tz.guess();
	      var now = moment.tz(user_time_zone);
	      if (tz) {
	        var nowThere = moment.tz(tz);
	        var timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
	        var startTimeAsMoment = moment(event.startTime);
	        var st = event.startTime;
	        var tzid = tz;
	        return moment(date).tz(tz).format("MMM DD, YYYY h:mm a");
	      }
	    }
	  }, {
	    key: "clickMagnify",
	    value: function clickMagnify() {
	      var _this = this;
	      _this.$timeout(function () {
	        jQuery(".search-container").addClass("s-open");
	        jQuery(".search-container").find('input[type="search"]').focus();
	      });
	    }
	  }, {
	    key: "closeSearch",
	    value: function closeSearch() {
	      var _this = this;
	      _this.$timeout(function () {
	        jQuery(".search-container").removeClass("s-open");
	        _this.query = "";
	      });
	    }
	  }, {
	    key: "gotoEventOverview",
	    value: function gotoEventOverview(event) {
	      if (event.leave_page_prevent) {
	        return;
	      }
	
	      if (!event.companyIsNotVerified) {
	        this.$state.go("eventoverview", { eventId: event.id });
	      }
	    }
	  }, {
	    key: "setEvent",
	    value: function setEvent(event) {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetEventToEventDialog", { event: event });
	      });
	    }
	  }, {
	    key: "setEventOpenings",
	    value: function setEventOpenings(event) {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetEventToEventDialog", { event: event });
	      });
	    }
	  }, {
	    key: "getLocation",
	    value: function getLocation(event) {
	      var location = "";
	      //
	      // console.log("getLocation");
	      // console.dir(event);
	
	      if (event.contactInfo) {
	        location = event.contactInfo.streetLine1 + " " + event.contactInfo.city + " " + event.contactInfo.state + " " + event.contactInfo.zipCode;
	      } else {
	        location = event.contactInfo.streetLine1 + " " + event.contactInfo.city + " " + event.contactInfo.state + " " + event.contactInfo.zipCode;
	      }
	
	      /*
	      if (){
	      } else if (!this.$security.isUndefinedOrNull(event.firstLocation)) {
	      location = event.firstLocation.streetLine1;
	      if (event.firstLocation.city != null && event.firstLocation.city != '') {
	       location += ' ' + event.firstLocation.city;
	      }
	      if (event.firstLocation.state != null && event.firstLocation.state != '') {
	       location += ', ' + event.firstLocation.state;
	      }
	      } else {
	      if(!event.contactInfo){
	       //console.log("no contaacatinfo..");
	       //console.dir(event);
	      }else{
	       location = event.contactInfo.streetLine1 + " " + event.contactInfo.city + " " + event.contactInfo.state + " " + event.contactInfo.zipCode;
	      }
	      }
	      */
	      return location;
	    }
	  }, {
	    key: "calculatePagination",
	    value: function calculatePagination(params, scrolled) {
	      var totals = null;
	      var paginationNum = 0;
	      var divisibleBy = 0;
	      this.pages = [];
	      if (params) {
	        if (params.eventCount) {
	          if (scrolled) {
	            this.jobListResultSetLimit.value = params.eventCount;
	          } else {
	            paginationNum = params.eventCount;
	          }
	        }
	        if (params.page === "history") {
	          totals = this.currentUser.company.totalNumberOfCloseEvents;
	        } else {
	          if (params.page === "cancelled") {
	            totals = this.currentUser.company.totalNumberOfEvents - (this.currentUser.company.totalNumberOfNonCloseEvents + this.currentUser.company.totalNumberOfCloseEvents);
	          } else {
	            totals = this.currentUser.company.totalNumberOfNonCloseEvents;
	          }
	        }
	      } else {
	        totals = this.currentUser.company.totalNumberOfNonCloseEvents;
	        var params = {};
	        params.eventCount = this.jobListResultSetLimit.value;
	      }
	      if (this.$security.isUndefinedOrNull(this.currentUser.company)) {
	        this.pages.push(1);
	      } else {
	        if (params.eventCount) {
	          divisibleBy = params.eventCount;
	        } else {
	          divisibleBy = this.events.length;
	        }
	        var numberOfEvents = Math.ceil(totals / divisibleBy);
	        for (var i = 0; i < numberOfEvents; i++) {
	          this.pages.push(i + 1);
	        }
	      }
	    }
	  }, {
	    key: "paginate",
	    value: function paginate(pageNumber) {
	      if (pageNumber < 1 || pageNumber > this.pages.length) {
	        return;
	      }
	      this.currentPageNumber = pageNumber;
	      this.remain_loading_count = 1;
	      var companyId = this.currentUser.company.id;
	      this.cachedParams.offsetParam = pageNumber * this.events.length - this.events.length;
	      this.$rootScope.sessionParams.offsetParam = this.cachedParams.offsetParam;
	      this.loadEvents();
	    }
	  }, {
	    key: "startDateChange",
	    value: function startDateChange() {
	      var _this = this;
	      _this.events = [];
	      var tempDate = new Date(_this.startDate);
	      var startTime = null;
	      var endtime = null;
	      var startDateMoment = moment.utc(moment(tempDate).startOf("day").format()).format();
	      var endDateMoment = moment.utc(moment(tempDate).endOf("day").format()).format();
	      _this.dates = { start: startDateMoment, end: endDateMoment };
	      _this.$rootScope.sessionParams.dates = _this.dates;
	      _this.thereAreEvents = true;
	      _this.loadEvents();
	    }
	  }, {
	    key: "sortReq",
	    value: function sortReq(sortVal, orderVal) {
	      var _this = this;
	      var offsetParam = 0;
	      var maxParam = 10;
	      var page = "live";
	      this.$companies.eventsForEventsPage(_this.currentUser.company.id, offsetParam, maxParam, page, sortVal, orderVal).then(function (data) {
	        _this.events = data.data;
	        try {
	          _this.events.forEach(function (event) {
	            _this.addExtraAttributesToEvent(event);
	          });
	        } catch (err) {
	          //console.log("error in events loop");
	        } finally {
	          //_this.setEventsToHeader();
	        }
	        _this.remain_loading_count--;
	      }, function (data) {
	        _this.events = [];
	      });
	    }
	  }, {
	    key: "sortTable",
	    value: function sortTable(sortVal, type) {
	      var _this = this;
	      _this.remain_loading_count++;
	      if (type === "date") {
	        _this.nameSort = 0;
	        if (sortVal === "desc") {
	          _this.sort = 1;
	          _this.sortReq("startTime", "desc");
	        } else {
	          _this.sort = 2;
	          _this.sortReq("startTime", "asc");
	        }
	      } else {
	        _this.sort = 0;
	        if (sortVal === "desc") {
	          _this.nameSort = 1;
	          _this.sortReq("name", "desc");
	        } else {
	          _this.nameSort = 2;
	          _this.sortReq("name", "asc");
	        }
	      }
	    }
	  }, {
	    key: "changeView",
	    value: function changeView(view) {
	      var _this = this;
	      switch (view) {
	        case 1:
	          _this.view = 1;
	          _this.gridViewClass = "btn btn-success button";
	          _this.listViewClass = "btn button btn-grey";
	          break;
	        case 2:
	          _this.view = 2;
	          _this.gridViewClass = "btn button btn-grey";
	          _this.listViewClass = "btn btn-success button";
	          break;
	      }
	    }
	  }, {
	    key: "queryChanged",
	    value: function queryChanged() {
	      var _this = this;
	      var params = {};
	      params.isCancelled = null;
	      params.isCompleted = null;
	      if (_this.page === "history") {
	        params.isCancelled = false;
	        params.isCompleted = true;
	      }
	      if (_this.page === "cancelled") {
	        params.isCancelled = true;
	        params.isCompleted = false;
	      }
	      //console.log("what is the selected param");
	      //console.dir(_this.selectedParam);
	      switch (_this.selectedParam) {
	        case 0:
	
	        case 1:
	          params.offsetParam = 0, params.maxParam = _this.jobListResultSetLimit.value, params.page = _this.page, params.sort = "startTime", params.order = "asc", params.id = 1, params.dates = _this.dates;
	          _this.cachedParams = params;
	          _this.$rootScope.sessionParams = params;
	          _this.loadEvents(params);
	          break;
	        case 2:
	          params.offsetParam = 0, params.maxParam = _this.jobListResultSetLimit.value, params.page = _this.page, params.sort = "startTime", params.order = "desc", params.id = 2, params.dates = _this.dates;
	          _this.cachedParams = params;
	          _this.$rootScope.sessionParams = params;
	          _this.loadEvents(params);
	          break;
	        case 3:
	          params.offsetParam = 0, params.maxParam = _this.jobListResultSetLimit.value, params.page = _this.page, params.sort = "dateCreated", params.order = "desc", params.id = 3, params.dates = _this.dates;
	          _this.cachedParams = params;
	          _this.$rootScope.sessionParams = params;
	          _this.loadEvents(params);
	          break;
	        case 4:
	          params.offsetParam = 0, params.maxParam = _this.jobListResultSetLimit.value, params.page = _this.page, params.sort = "dateCreated", params.order = "asc", params.id = 4, params.dates = _this.dates;
	          _this.cachedParams = params;
	          _this.$rootScope.sessionParams = params;
	          _this.loadEvents(params);
	          break;
	        case 5:
	          params.offsetParam = 0, params.maxParam = _this.jobListResultSetLimit.value, params.page = _this.page, params.sort = "name", params.order = "asc", params.id = 5, params.dates = _this.dates;
	          _this.cachedParams = params;
	          _this.$rootScope.sessionParams = params;
	          _this.loadEvents(params);
	          break;
	        case 6:
	          params.offsetParam = 0, params.maxParam = _this.jobListResultSetLimit.value, params.page = _this.page, params.sort = "name", params.order = "desc", params.id = 6, params.dates = _this.dates;
	          _this.cachedParams = params;
	          _this.$rootScope.sessionParams = params;
	          _this.loadEvents(params);
	          break;
	        case 7:
	          params.offsetParam = 0, params.maxParam = 9, params.page = _this.page, params.sort = "startTime", params.order = "asc", params.dates = _this.dates;
	          _this.cachedParams = params;
	          _this.$rootScope.sessionParams = params;
	          //console.log("what are the params as we go into the 7th case");
	          //console.dir(params);
	          _this.loadEvents(params);
	          break;
	        case 8:
	          _this.jobListResultSetLimit.value = 9;
	          params.offsetParam = 0, params.maxParam = _this.jobListResultSetLimit.value, params.page = _this.page, params.sort = "startTime", params.order = "desc", params.id = 0, params.dates = _this.dates;
	          _this.cachedParams = params;
	          _this.$rootScope.sessionParams = params;
	          _this.loadEvents(params);
	          break;
	        case 9:
	          params.offsetParam = 0, params.maxParam = _this.jobListResultSetLimit.value, params.page = _this.page, params.sort = "lastUpdated", params.order = "desc", params.id = 0, params.dates = _this.dates;
	          _this.cachedParams = params;
	          _this.$rootScope.sessionParams = params;
	          _this.loadEvents(params);
	
	          break;
	      }
	    }
	  }, {
	    key: "changeEventListing",
	    value: function changeEventListing(x) {
	      var _this = this;
	
	      switch (x) {
	        case 1:
	          _this.page = "events";
	          _this.selectedParam = 7;
	          _this.pageStatus = "open";
	          _this.endOfList = _this.currentUser.company.totalNumberOfNonCloseEvents;
	          _this.queryChanged();
	          _this.$timeout(function () {
	            $(".job-container .job-sidebar .list-job li:nth-child(2)").removeClass("job-active");
	            $(".job-container .job-sidebar .list-job li:nth-child(3)").removeClass("job-active");
	            $(".job-container .job-sidebar .list-job li:nth-child(1)").addClass("job-active");
	          });
	          break;
	
	        case 2:
	          _this.page = "history";
	          _this.selectedParam = 8;
	          _this.queryChanged();
	          _this.pageStatus = "completed";
	          _this.endOfList = _this.currentUser.company.totalNumberOfCloseEvents;
	          _this.$timeout(function () {
	            $(".job-container .job-sidebar .list-job li:nth-child(1)").removeClass("job-active");
	            $(".job-container .job-sidebar .list-job li:nth-child(3)").removeClass("job-active");
	            $(".job-container .job-sidebar .list-job li:nth-child(2)").addClass("job-active");
	          });
	          break;
	
	        case 3:
	          _this.page = "cancelled";
	          _this.selectedParam = 9;
	          _this.jobListResultSetLimit.value = 9;
	          _this.queryChanged();
	          _this.pageStatus = "cancelled";
	          _this.endOfList = _this.currentUser.company.totalNumberOfEvents - (_this.currentUser.company.totalNumberOfNonCloseEvents + _this.currentUser.company.totalNumberOfCloseEvents);
	          _this.$timeout(function () {
	            $(".job-container .job-sidebar .list-job li:nth-child(1)").removeClass("job-active");
	            $(".job-container .job-sidebar .list-job li:nth-child(2)").removeClass("job-active");
	            $(".job-container .job-sidebar .list-job li:nth-child(3)").addClass("job-active");
	          });
	          break;
	      }
	    }
	  }, {
	    key: "scrollEvents",
	    value: function scrollEvents() {
	      var _this = this;
	
	      var sort = null;
	      var order = null;
	      var scrollMax = 9;
	      if (_this.$rootScope.sessionParams) {
	        scrollMax = _this.$rootScope.sessionParams.maxParam + 1;
	        sort = _this.$rootScope.sessionParams.sort;
	        order = _this.$rootScope.sessionParams.order;
	      }
	      if (!_this.endOfList) {
	        _this.endOfList = _this.currentUser.company.totalNumberOfNonCloseEvents;
	      }
	      if (_this.events.length !== _this.endOfList && _this.thereAreEvents) {
	        _this.busy = true;
	        _this.$scroll.loadMoreEvents(_this.currentUser.company.id, _this.events.length, 3, _this.$rootScope.sessionParams.page, _this.$rootScope.sessionParams.sort, _this.$rootScope.sessionParams.order, _this.$rootScope.sessionParams.isCancelled, _this.$rootScope.sessionParams.isCompleted, _this.$env, 1, _this.$rootScope.sessionParams.dates).then(function (response) {
	          var events = response.data;
	          if (events.length === 0) {
	            _this.thereAreEvents = false;
	          }
	          try {
	            if (event.status !== "error") {
	              if (events) {
	                events.forEach(function (event) {
	                  if (event.contactInfo[0]) {
	                    event.contactInfo = event.contactInfo[0];
	                  }
	                  _this.addExtraAttributesToEvent(event);
	                  _this.events.push(event);
	                });
	              }
	            } else {
	              //console.log("minor error?");
	            }
	          } catch (err) {
	            //console.log("error while paginating scroll");
	            //console.dir(err);
	          } finally {
	            _this.reconfigurePaginationPages();
	            _this.busy = false;
	          }
	        });
	      }
	    }
	  }, {
	    key: "setDatePicker",
	    value: function setDatePicker() {
	      var _this = this;
	
	      setTimeout(function () {
	        jQuery("#datepickerevents").datepicker({
	          showOn: "both",
	          buttonImage: "/app/vendor/images/calender.png",
	          buttonImageOnly: true,
	          buttonText: "Select date",
	          dateFormat: "M dd, yy"
	        });
	      }, 100);
	    }
	  }, {
	    key: "reconfigurePaginationPages",
	    value: function reconfigurePaginationPages() {
	      var _this = this;
	      var divisible = null;
	
	      _this.pages = [];
	
	      if (_this.page === "events" || !_this.page) {
	        divisible = this.currentUser.company.totalNumberOfNonCloseEvents;
	        _this.pageStatus = "open";
	      }
	
	      if (_this.page === "history") {
	        divisible = this.currentUser.company.totalNumberOfCloseEvents;
	        _this.pageStatus = "completed";
	      }
	
	      if (_this.page === "cancelled") {
	        divisible = this.currentUser.company.totalNumberOfEvents - (this.currentUser.company.totalNumberOfNonCloseEvents + this.currentUser.company.totalNumberOfCloseEvents);
	        _this.pageStatus = "cancelled";
	      }
	      var numberOfEvents = Math.ceil(divisible / _this.events.length);
	      for (var i = 0; i < numberOfEvents; i++) {
	        _this.pages.push(i + 1);
	      }
	    }
	  }, {
	    key: "limitChanged",
	    value: function limitChanged() {
	      var _this = this;
	      if (_this.$rootScope.sessionParams) {
	        _this.$rootScope.sessionParams.maxParam = _this.jobListResultSetLimit.value;
	      }
	      _this.loadEvents();
	    }
	  }, {
	    key: "checkVerificationStatus",
	    value: function checkVerificationStatus() {
	      var _this = this;
	      _this.remain_loading_count--;
	      _this.$auth.reloadCurrentUser();
	      _this.$timeout(function () {
	        _this.currentUser = _this.$auth.getUserData();
	      }, 1500);
	      _this.$timeout(function () {
	        if (_this.currentUser.isVerified) {
	          _this.remain_loading_count++;
	          _this.currentUser = _this.$auth.getUserData();
	          _this.loadEvents();
	          jQuery("#show-application-global-modal-new").trigger("click");
	        } else {
	          _this.remain_loading_count++;
	          _this.verificationError = "Your email confirmation has yet to be confirmed. Please find the email titled 'Please Verify Your Email Address' and click the confirmation link inside.";
	        }
	      }, 2000);
	    }
	  }, {
	    key: "displayHistoryButton",
	    value: function displayHistoryButton() {
	      var _this = this;
	      if (_this.currentUser) {
	        if (_this.currentUser.company.totalNumberOfCloseEvents > 0) {
	          _this.showHistoryButton = true;
	        }
	      }
	    }
	  }, {
	    key: "slideDownMenu",
	    value: function slideDownMenu(index) {
	      var _this = this;
	      var selector = "#dropdownMenuHidden-" + index;
	      _this.$timeout(function () {
	        jQuery(selector).show("fast");
	      });
	    }
	  }, {
	    key: "removeTheDeletedEvent",
	    value: function removeTheDeletedEvent(params) {
	      var _this = this;
	      if (_this.events.indexOf()) {
	        var o = _this.events.filter(function (obj) {
	          return obj.id !== params.event;
	        });
	        _this.$timeout(function () {
	          _this.events = o;
	        });
	      }
	      _this.currentUser.company.totalNumberOfNonCloseEvents = _this.currentUser.company.totalNumberOfNonCloseEvents - 1;
	    }
	  }, {
	    key: "markEventAsPublished",
	    value: function markEventAsPublished(params) {
	      var _this = this;
	      var events = _this.events;
	      var target = null;
	      try {
	        events.forEach(function (el) {
	          if (el.id === params.event) {
	            target = el;
	            throw _this.BreakException;
	          }
	        });
	      } catch (e) {
	        target.notpublished = false;
	        if (params.status === true) {
	          target.subEvents[0].deduppedJobbles[0].isPublished = true;
	        } else {
	          target.subEvents[0].deduppedJobbles[0].isPublished = false;
	        }
	        _this.addExtraAttributesToEvent(target);
	        if (params.do_not_close !== true) {
	          _this.closePublishModal();
	        }
	        _this.unSetLoader();
	      }
	    }
	  }, {
	    key: "setParamDateToDatePicker",
	    value: function setParamDateToDatePicker(start_date) {
	      var _this = this;
	      var date_temp = new Date(start_date);
	      _this.startDate = moment(date_temp).format("MMM DD, YYYY");
	    }
	  }, {
	    key: "handleSessionParams",
	    value: function handleSessionParams() {
	      var _this = this;
	      //console.log("handleSessionParams");
	      //console.dir(_this.$rootScope.sessionParams);
	      if (_this.$rootScope.sessionParams) {
	        if (_this.$rootScope.sessionParams.dates) {
	          _this.dates = _this.$rootScope.sessionParams.dates;
	          _this.setParamDateToDatePicker(_this.$rootScope.sessionParams.dates.start);
	        }
	        if (_this.$rootScope.sessionParams.isCompleted) {
	          _this.page = "history";
	          _this.$timeout(function () {
	            $(".job-container .job-sidebar .list-job li:nth-child(1)").removeClass("job-active");
	            $(".job-container .job-sidebar .list-job li:nth-child(3)").removeClass("job-active");
	            $(".job-container .job-sidebar .list-job li:nth-child(2)").addClass("job-active");
	          });
	        } else if (_this.$rootScope.sessionParams.isCancelled) {
	          _this.page = "cancelled";
	          _this.$timeout(function () {
	            $(".job-container .job-sidebar .list-job li:nth-child(1)").removeClass("job-active");
	            $(".job-container .job-sidebar .list-job li:nth-child(2)").removeClass("job-active");
	            $(".job-container .job-sidebar .list-job li:nth-child(3)").addClass("job-active");
	          });
	        } else {
	          _this.$timeout(function () {
	            $(".job-container .job-sidebar .list-job li:nth-child(2)").removeClass("job-active");
	            $(".job-container .job-sidebar .list-job li:nth-child(3)").removeClass("job-active");
	            $(".job-container .job-sidebar .list-job li:nth-child(1)").addClass("job-active");
	          });
	        }
	      }
	    }
	  }, {
	    key: "checkUserVerifications",
	    value: function checkUserVerifications() {
	      var _this = this;
	
	      if (!_this.$rootScope.globalModalType) {
	        _this.$rootScope.globalModalType = {};
	      }
	      _this.$timeout(function () {
	        _this.$rootScope.globalModalType.type = 4;
	      });
	      if (!_this.currentUser.isVerified) {
	        _this.$timeout(function () {
	          jQuery("#modal-verify-email-click-redesign").trigger("click");
	        }, 300);
	      } else if (!_this.currentUser.company.isVerified) {
	        _this.companyHasBeenVerified = false;
	        _this.$auth.validateUserByTokenWeb(_this.currentUser.access_token).then(function (response) {
	          if (response.data.company.isVerified) {
	            _this.$localStorage.logged_user = response.data;
	            _this.currentUser = response.data;
	            _this.events.forEach(function (event) {
	              _this.addExtraAttributesToEvent(event);
	            });
	          }
	        }, function (error) {
	          //console.log('error from validate');
	          //console.dir(error);
	        });
	      } else {
	        //console.log('are we verified down here?2');
	        _this.companyHasBeenVerified = true;
	      }
	    }
	  }, {
	    key: "setLogoBanner",
	    value: function setLogoBanner() {
	      var _this = this;
	      if (_this.currentUser) {
	        ////console.log('set logo banner');
	        ////console.dir(_this.currentUser.company.companyLogoUri);
	        ////console.dir(_this.$rootScope.imgFromProfilePage);
	      }
	    }
	  }, {
	    key: "validateCurrentUser",
	    value: function validateCurrentUser() {
	      var _this = this;
	      console.log("validateCurrentUservalidateCurrentUservalidateCurrentUservalidateCurrentUser");
	      console.dir(_this.currentUser);
	      _this.$auth.validateUserByTokenWeb(_this.currentUser.access_token).then(function (response) {
	        console.log("what is the response now...");
	        console.dir(response.data);
	        _this.currentUser = response.data;
	        _this.currentUser.company.paymentInfos = response.data.company.undeletedPaymentInfos;
	        _this.$localStorage.logged_user = _this.currentUser;
	      }, function (error) {});
	    }
	  }, {
	    key: "inboxLink",
	    value: function inboxLink(id) {
	      var _this = this;
	      if (_this.$rootScope.channelsHaveLoaded && !_this.$rootScope.channels) {
	        alert("This account has no active messages. If you think there are active messages please refresh the page.");
	      } else {
	        _this.$timeout(function () {
	          _this.$location.path("/messages/event/" + id);
	        });
	      }
	    }
	  }, {
	    key: "checkAdmin",
	    value: function checkAdmin() {
	      var _this = this;
	      if (_this.currentUser) {
	        _this.admin = _this.$auth.isAdmin();
	        //console.log("what is this admin");
	        //console.dir(_this.admin);
	      }
	    }
	  }, {
	    key: "isThisEzCaterAdmin",
	    value: function isThisEzCaterAdmin() {
	      var _this = this;
	      var isEzAdmin = null;
	      var user = _this.$auth.getUserData();
	      if (user) {
	        if (user.email.indexOf("jobbleapp.com") > -1 && user.email.indexOf("ezcater") > -1) {
	          _this.isEzcaterAdmin = true;
	        } else {
	          _this.isEzcaterAdmin = false;
	          _this.getCurrentDate();
	        }
	      }
	    }
	  }, {
	    key: "getCurrentDate",
	    value: function getCurrentDate() {
	      var _this = this;
	      _this.startDate = "";
	    }
	  }, {
	    key: "clearDate",
	    value: function clearDate() {
	      var _this = this;
	      _this.startDate = "";
	      _this.events = [];
	      _this.dates = {};
	      _this.$rootScope.sessionParams.dates = {};
	      _this.loadEvents();
	    }
	  }, {
	    key: "setEventsToHeader",
	    value: function setEventsToHeader(event) {
	      var _this = this;
	      _this.events_for_header.push(event);
	      if (_this.events_for_header.length === _this.events.length) {
	        var _events = _this.events_for_header;
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetEventsToScroller", {
	            events: _events
	          });
	        });
	      }
	    }
	  }, {
	    key: "set_logo_for_events_banner",
	    value: function set_logo_for_events_banner(logo_url) {
	      var _this = this;
	      if (_this.currentUser) {
	        _this.$timeout(function () {
	          _this.currentUser.company.companyLogoUri = logo_url;
	          _this.$rootScope.imgFromProfilePage = logo_url;
	          _this.currentUser.company.companyLogoUri = logo_url;
	          _this.logo_has_finished_loading = true;
	          _this.$rootScope.$emit("UpdateCurrentUser", {
	            user: _this.currentUser
	          });
	        });
	      }
	    }
	  }, {
	    key: "toggle_eta",
	    value: function toggle_eta(type, event, index) {
	      var _this = this;
	      var event_id = event.id;
	      var jobble_id = event.subEvents[0].deduppedJobbles[0].id;
	      if (type === 1) {
	        var selector = "#eta-locator-id-" + index + ".eta-locator";
	        _this.$timeout(function () {
	          $(selector).removeClass("rotate-up");
	          $(selector).addClass("rotate-down");
	          _this.display_eta_modal(event, index);
	          _this.set_focus_to_map(event, index);
	          _this.load_eta_data(event_id, jobble_id, index);
	        });
	      } else {}
	    }
	  }, {
	    key: "load_eta_data",
	    value: function load_eta_data(event_id, jobble_id, index) {
	      var _this = this;
	      _this.driver = {};
	      _this.positions = [];
	      _this.setLoader();
	      _this.$events.load_eta_data(event_id, jobble_id).then(function (response) {
	        _this.handle_eta_response(response.data, event_id, jobble_id, index);
	      }, function (error) {
	        alert("Error getting tracking information");
	      });
	    }
	  }, {
	    key: "handle_eta_response",
	    value: function handle_eta_response(data, event, jobble, index) {
	      var _this = this;
	      _this.driver.current_loc = {};
	      _this.driver.current_loc.lat = data.currentLocation.lat;
	      _this.driver.current_loc.lng = data.currentLocation.lng;
	      _this.init_eta_map(data, event, jobble, index);
	    }
	  }, {
	    key: "set_refresh_counter",
	    value: function set_refresh_counter(jobble) {
	      var _this = this;
	      var last_updated = jobble.currentLocation.lastUpdateFront;
	      var now = moment().format();
	      last_updated = moment(last_updated).format();
	      var diff = moment(now).diff(moment(last_updated), "seconds");
	      var minutes = Math.floor(diff / 60);
	      var seconds_left_over = diff % 60;
	      if (diff > 600) {
	        _this.display_time = "Tracking data has not been updated for " + minutes + " minutes";
	      } else {
	        _this.display_time = "Last updated " + minutes + " minute(s) and " + seconds_left_over + " seconds ago.";
	      }
	    }
	  }, {
	    key: "refresh_eta_modal",
	    value: function refresh_eta_modal(index, event) {
	      var _this = this;
	    }
	  }, {
	    key: "get_address",
	    value: function get_address(data) {
	      var _this = this;
	    }
	  }, {
	    key: "set_user_location",
	    value: function set_user_location(data, event, jobble, index) {
	      var _this = this;
	
	      var lat = data.currentLocation.lat;
	      var lng = data.currentLocation.lng;
	      var current_location = {};
	      var current_loc_latlng = { lat: lat, lng: lng };
	      var current_user_marker = "/app/vendor/images/car_gps.png";
	      var marker = new google.maps.Marker({
	        title: "Driver GPS",
	        icon: "/app/vendor/images/car_gps.png",
	        position: current_loc_latlng,
	        id: null,
	        showMe: true,
	        checkin: null
	      });
	      _this.positions.push(marker);
	      _this.set_center_of_map(marker);
	    }
	  }, {
	    key: "set_center_of_map",
	    value: function set_center_of_map(marker) {
	      var _this = this;
	      _this.$timeout(function () {
	        marker.setMap(_this.map);
	      }, 500);
	    }
	  }, {
	    key: "display_eta_modal",
	    value: function display_eta_modal(event, index) {
	      var _this = this;
	      var selector = "#eta-target-" + index + ".eta-map-holder";
	      _this.$timeout(function () {
	        $(selector).show("fast");
	      });
	    }
	  }, {
	    key: "set_focus_to_map",
	    value: function set_focus_to_map(event, index) {
	      var _this = this;
	      var selector = "#eta-target-" + index;
	      _this.$timeout(function () {
	        $(selector).focus();
	      }, 300);
	    }
	  }, {
	    key: "clicking_map",
	    value: function clicking_map(event, index) {
	      var _this = this;
	      var selector = "#eta-target-" + index;
	      _this.$timeout(function () {
	        $(selector).focus();
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "toggle_eta_hover",
	    value: function toggle_eta_hover(type, event, index) {
	      var _this = this;
	      event.leave_page_prevent = true;
	      /*
	      _this.$timeout(function(){
	      event.leave_page_prevent=false;
	      });
	      */
	    }
	  }, {
	    key: "toggle_eta_leave",
	    value: function toggle_eta_leave(type, event, index) {
	      var _this = this;
	      event.leave_page_prevent = false;
	    }
	  }, {
	    key: "init_eta_map",
	    value: function init_eta_map(data, event, jobble, index) {
	      var _this = this;
	      if (_this.map) {
	        //console.log("lets check the markers each map load");
	        //console.dir(_this.map.markers);
	        //console.dir(_this.map.markers.length);
	        //console.dir(_this.positions);
	      }
	      _this.$timeout(function () {
	        _this.$maps.getMap({ id: "map-eta" }).then(function (map) {
	          _this.map = map;
	          _this.set_user_location(data, event, jobble, index);
	          _this.set_pickup_and_dropoff(data, event, jobble, index);
	          /*
	          _this.map = map;
	          if (map.markers){
	          _this.clearMarkers();
	          }
	          */
	        }, function (error) {
	          //console.log("maps error");
	          //console.dir(error);
	        });
	      }, 500);
	    }
	  }, {
	    key: "set_pickup_and_dropoff",
	    value: function set_pickup_and_dropoff(data, event, jobble, index) {
	      var _this = this;
	      //console.log("set_pickup_and_dropoff");
	      //console.dir(data);
	      //console.dir(event);
	      //console.dir(jobble);
	      //console.dir(index);
	      var addresses = {};
	      var shifts = _this.sort_shifts(data.shifts);
	      var pickup_data = {};
	      pickup_data.street = shifts[0].contactInfo.streetLine1;
	      pickup_data.state = shifts[0].contactInfo.state;
	      pickup_data.city = shifts[0].contactInfo.city;
	      pickup_data.zipcode = shifts[0].contactInfo.zipCode;
	      addresses.pickup_address = pickup_data.street + ", " + pickup_data.city + ", " + pickup_data.state;
	      var dropoff_data = {};
	      dropoff_data.street = shifts[1].contactInfo.streetLine1;
	      dropoff_data.state = shifts[1].contactInfo.state;
	      dropoff_data.city = shifts[1].contactInfo.city;
	      dropoff_data.zipcode = shifts[1].contactInfo.zipCode;
	      addresses.dropoff_address = dropoff_data.street + ", " + dropoff_data.city + ", " + dropoff_data.state;
	      _this.set_pickup_location(addresses, data, index);
	      _this.set_dropoff_location(addresses, data, index, event);
	    }
	  }, {
	    key: "set_pickup_location",
	    value: function set_pickup_location(addresses, data, index) {
	      var _this = this;
	      //console.log("positions before pickup");
	      //console.dir(_this.positions);
	      _this.$timeout(function () {
	        _this.geocoder = new google.maps.Geocoder();
	        _this.geocoder.geocode({ address: addresses.pickup_address }, function (results, status) {
	          //console.log("pick up loc");
	          //console.dir(results[0].geometry.location.lat());
	          //console.dir(results[0].geometry.location.lng());
	          if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
	            var locmrker = {};
	            var location = results[0].geometry.location;
	            var lat_lng = {
	              lat: location.lat(),
	              lng: location.lng()
	            };
	            var marker = new google.maps.Marker({
	              title: "Pickup Location",
	              icon: "/app/vendor/images/resst.png",
	              position: lat_lng,
	              id: null,
	              showMe: true,
	              checkin: null
	            });
	            _this.positions.push(marker);
	          }
	        });
	        //console.log("positions after pick up");
	        //console.dir(_this.positions);
	      }, 400);
	    }
	  }, {
	    key: "set_dropoff_location",
	    value: function set_dropoff_location(addresses, data, index, event) {
	      var _this = this;
	      //console.log("set_dropoff_location");
	      //console.dir(addresses);
	      //console.dir(data);
	      //console.log("positions before drop off");
	      //console.dir(_this.positions);
	      _this.$timeout(function () {
	        _this.geocoder = new google.maps.Geocoder();
	        _this.geocoder.geocode({ address: addresses.dropoff_address }, function (results, status) {
	          //console.log("drop off loc");
	          //console.dir(results);
	          if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
	            //console.dir(results[0].geometry.location.lat());
	            //console.dir(results[0].geometry.location.lng());
	            var locmrker = {};
	            var location = results[0].geometry.location;
	            var lat_lng = {
	              lat: location.lat(),
	              lng: location.lng()
	            };
	            var marker = new google.maps.Marker({
	              title: "Dropoff Location",
	              icon: "/app/vendor/images/off.png",
	              position: lat_lng,
	              id: null,
	              showMe: true,
	              checkin: null
	            });
	            _this.positions.push(marker);
	          }
	        });
	        //console.log("positions after drop off");
	        //console.dir(_this.positions);
	        _this.clicking_map(event, index);
	      }, 800);
	      _this.format_table(addresses, data);
	    }
	  }, {
	    key: "format_table",
	    value: function format_table(addresses, data) {
	      var _this = this;
	      var modal_table_data = {};
	      modal_table_data.pickup_shift = {};
	      modal_table_data.dropoff_shift = {};
	      modal_table_data.pickup_shift.time_zone = data.shifts[0].contactInfo.place.timeZoneId;
	      modal_table_data.pickup_shift.time_zone_name = data.shifts[0].contactInfo.place.timeZoneName;
	      if (data.shifts[0].pickupEta) {
	        modal_table_data.pickup_shift.eta = moment(data.shifts[0].pickupEta).format("hh:mm A");
	      } else {
	        modal_table_data.pickup_shift.eta = "N/A";
	      }
	      //console.log("modal_table_data.pickup_shift.eta");
	      //console.dir(moment(data.shifts[0].pickupEta).format("hh:mm A"));
	      if (data.shifts[0].checkInTime) {
	        modal_table_data.pickup_shift.check_in_time = moment(data.shifts[0].checkInTime).format("hh:mm A");
	      } else {
	        modal_table_data.pickup_shift.check_in_time = "N/A";
	      }
	      if (data.shifts[0].checkOutTime) {
	        modal_table_data.pickup_shift.check_out_time = moment(data.shifts[0].checkOutTime).format("hh:mm A");
	      } else {
	        modal_table_data.pickup_shift.check_out_time = "N/A";
	      }
	      modal_table_data.pickup_shift.expected_arrival_time = moment(data.shifts[0].timeInterval.startTime).format("hh:mm A");
	      modal_table_data.pickup_shift.location = data.shifts[0].location;
	      modal_table_data.dropoff_shift.time_zone = data.shifts[1].contactInfo.place.timeZoneId;
	      modal_table_data.dropoff_shift.time_zone_name = data.shifts[1].contactInfo.place.timeZoneName;
	      if (data.shifts[1].dropoffEta) {
	        modal_table_data.dropoff_shift.eta = moment(data.shifts[1].dropoffEta).format("hh:mm A");
	      } else {
	        modal_table_data.dropoff_shift.eta = "N/A";
	      }
	
	      modal_table_data.dropoff_shift.expected_arrival_time = moment(data.shifts[1].timeInterval.startTime).format("hh:mm A");
	      if (data.shifts[1].checkInTime) {
	        modal_table_data.dropoff_shift.check_in_time = moment(data.shifts[1].checkInTime).format("hh:mm A");
	      } else {
	        modal_table_data.dropoff_shift.check_in_time = "N/A";
	      }
	      if (data.shifts[1].checkOutTime) {
	        modal_table_data.dropoff_shift.check_out_time = moment(data.shifts[1].checkOutTime).format("hh:mm A");
	      } else {
	        modal_table_data.dropoff_shift.check_out_time = "N/A";
	      }
	      modal_table_data.dropoff_shift.location = data.shifts[1].location;
	      _this.modal_data = modal_table_data;
	      _this.set_refresh_counter(data);
	      _this.unSetLoader();
	      //_this.pickup_shift=pickup_shift;
	      //let time_zone =
	    }
	  }, {
	    key: "sort_shifts",
	    value: function sort_shifts(shifts) {
	      var _this = this;
	      shifts.sort(function (a, b) {
	        return new Date(a.timeInterval.startTime) - new Date(b.timeInterval.startTime);
	      });
	      return shifts;
	    }
	  }, {
	    key: "blur_off_map",
	    value: function blur_off_map(index, event) {
	      var _this = this;
	      var selector = "#eta-target-" + index;
	      _this.$timeout(function () {
	        $(selector).focus();
	      }, 300);
	    }
	  }, {
	    key: "refresh_map_data",
	    value: function refresh_map_data(event, index) {
	      var _this = this;
	      var event_id = event.id;
	      var jobble_id = event.subEvents[0].deduppedJobbles[0].id;
	      _this.load_eta_data(event_id, jobble_id, index);
	    }
	  }, {
	    key: "close_eta_modal",
	    value: function close_eta_modal(index, event) {
	      var _this = this;
	
	      var selector = "#eta-target-" + index + ".eta-map-holder";
	      var selector2 = "#eta-locator-id-" + index + ".eta-locator";
	      _this.$timeout(function () {
	        $(selector).hide("fast");
	        $(selector2).removeClass("rotate-down");
	        $(selector2).addClass("rotate-up");
	        event.leave_page_prevent = false;
	      });
	    }
	  }, {
	    key: "copyJobbleID",
	    value: function copyJobbleID(event) {
	      var _this = this;
	      console.dir("copyJobbleID");
	      console.dir(event);
	
	      var origin = this.$branchio.getOrigin();
	
	      var text_to_share = origin + "/job/" + event.subEvents[0].deduppedJobbles[0].id;
	      // create temp element
	      var copyElement = document.createElement("span");
	      copyElement.appendChild(document.createTextNode(text_to_share));
	      copyElement.id = "tempCopyToClipboard";
	      _angular2.default.element(document.body.append(copyElement));
	      // select the text
	      var range = document.createRange();
	      range.selectNode(copyElement);
	      window.getSelection().removeAllRanges();
	      window.getSelection().addRange(range);
	      // copy & cleanup
	      document.execCommand("copy");
	      window.getSelection().removeAllRanges();
	      copyElement.remove();
	    }
	  }, {
	    key: "copyEventID",
	    value: function copyEventID(event) {
	      var _this = this;
	      console.log("copyEventID");
	      console.dir(event);
	      var text_to_share = event.id;
	      // create temp element
	      var copyElement = document.createElement("span");
	      copyElement.appendChild(document.createTextNode(text_to_share));
	      copyElement.id = "tempCopyToClipboard";
	      _angular2.default.element(document.body.append(copyElement));
	      // select the text
	      var range = document.createRange();
	      range.selectNode(copyElement);
	      window.getSelection().removeAllRanges();
	      window.getSelection().addRange(range);
	      // copy & cleanup
	      document.execCommand("copy");
	      window.getSelection().removeAllRanges();
	      copyElement.remove();
	    }
	  }, {
	    key: "setPublishType",
	    value: function setPublishType(type, event) {
	      var _this = this;
	
	      var publish_status = null;
	      var invoice = _this.currentUser.company.payByInvoice;
	
	      console.log("setPublishType");
	      console.dir(event);
	      console.dir(type);
	
	      if (event.isSourcingPost && type !== 1) {
	        //console.log("trying to publish aa sourcing posts....");
	        //console.dir(event);
	        if (invoice === true) {
	          /*
	           * If an invoice customer, display #modal-publish-event explaining that
	           * once published, they will be charged $50.00
	           */
	          console.log("we are in invoice");
	
	          if (type === 2) {
	            publish_status = false;
	          } else {
	            publish_status = true;
	          }
	
	          _this.$timeout(function () {
	            $("#modal-publish-event").modal();
	          }, 300);
	
	          console.log("publish_status");
	          console.dir(publish_status);
	
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("SetPublishType", {
	              status: publish_status,
	              message: true
	            });
	          });
	        } else {
	          /*
	           * Regular customer we need to
	           */
	
	          console.log("_this.currentUser.company");
	          console.dir(_this.currentUser.company);
	
	          if (_this.currentUser.company.undeletedPaymentInfos.length === 0) {
	            _this.$timeout(function () {
	              _this.$rootScope.$emit("SetPayForPostData", {
	                cards: false,
	                event: event
	              });
	              $("#modal-add-card").modal();
	            }, 1000);
	          } else {
	            _this.$timeout(function () {
	              _this.$rootScope.$emit("SetPayForPostData", {
	                cards: true,
	                event: event
	              });
	              $("#modal-pick-card").modal();
	            }, 1000);
	          }
	        }
	      } else {
	        console.log("we are down here...");
	
	        _this.$timeout(function () {
	          $("#modal-publish-event").modal("toggle");
	        }, 500);
	
	        if (type === 2) {
	          publish_status = false;
	        } else {
	          publish_status = true;
	        }
	
	        console.log("what is the status....");
	        console.dir(publish_status);
	
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetPublishType", {
	            status: publish_status
	          });
	        });
	      }
	    }
	  }, {
	    key: "promoteJob",
	    value: function promoteJob(event) {
	      var _this = this;
	      _this.promote_job = event;
	      _this.$timeout(function () {
	        $("#promote-job").modal();
	      });
	    }
	  }, {
	    key: "closePromoteModal",
	    value: function closePromoteModal() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("#promote-job").modal("toggle");
	      });
	    }
	  }, {
	    key: "confirmPromote",
	    value: function confirmPromote() {
	      var _this = this;
	
	      _this.setLoader();
	      _this.$events.promote_event(_this.promote_job.jobblePoolId).then(function (response) {
	        _this.unSetLoader();
	        if (response.data.status === "OK") {
	          _this.closePromoteModal();
	          _this.$timeout(function () {
	            alert("Your job was successfully promoted.");
	          }, 500);
	        } else {
	          _this.closePromoteModal();
	          _this.$timeout(function () {
	            alert(response.data.message);
	          }, 500);
	        }
	      }, function (error) {
	        _this.unSetLoader();
	        _this.closePromoteModal();
	        _this.$timeout(function () {
	          alert("There was an error promoting your job. Please contact customer support.");
	        }, 500);
	      });
	    }
	  }, {
	    key: "closePublishModal",
	    value: function closePublishModal() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("#modal-publish-event").modal("toggle");
	      }, 500);
	    }
	  }, {
	    key: "closePromote",
	    value: function closePromote() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("#promote-job").modal("toggle");
	      });
	    }
	  }, {
	    key: "closeModalAndCharge",
	    value: function closeModalAndCharge(params) {
	      var _this = this;
	      console.log("closeModalAndCharge");
	      console.dir(params);
	      console.dir(params.status);
	      var status = params.status;
	      var card = params.card;
	      var data = {};
	      var invoice = params.message;
	      if (invoice !== true) {
	        data.token = card.stripeId;
	      }
	      data.amount = 5000;
	      data.user = "accounting@jobble.com";
	      data.note = "Payment for job posting.";
	      _this.event = params.event;
	      _this.remain_loading_count = 1;
	      console.log("****what is the status****");
	      console.dir(status);
	      if (status) {
	        status = params.status;
	      }
	
	      _this.$companies.chargeForPost(data, invoice).then(function (response) {
	        _this.remain_loading_count = 0;
	        if (response.status === "error") {
	          alert("There was an issue with your payment method : " + response.message);
	        }
	        var id = params.event.subEvents[0].deduppedJobbles[0].id;
	        _this.$events.markJobblesAsPublished(id, _this.event, status).then(function (response) {
	          console.log("response from mark jobbles as publshed....");
	          console.dir(response);
	          console.dir(invoice);
	          if (invoice === true) {
	            _this.markEventAsPublished({
	              event: _this.event.id,
	              status: status
	            });
	            //_this.closePublishModal();
	            _this.remain_loading_count = 0;
	            _this.unSetLoader();
	          } else {
	            if (params.new_card === true) {
	              _this.markEventAsPublished({
	                event: params.event.id,
	                status: params.status,
	                do_not_close: true
	              });
	            } else {
	              _this.$timeout(function () {
	                $("#modal-pick-card").modal("toggle");
	              }, 300);
	              _this.$timeout(function () {
	                _this.markEventAsPublished({
	                  event: _this.event.id,
	                  status: status,
	                  do_not_close: true
	                });
	                _this.remain_loading_count = 0;
	              }, 600);
	            }
	          }
	        }, function (error) {
	          alert("error publishing event");
	        });
	      }, function (error) {
	        alert("There was an error charging your card. Please contact support");
	      });
	    }
	  }, {
	    key: "expandJobsTable",
	    value: function expandJobsTable() {
	      var _this = this;
	
	      console.log("expandJobsTable");
	      console.dir(_this.table_expanded);
	
	      if (!_this.table_expanded) {
	        _this.table_expanded = true;
	
	        console.log("do we have this...");
	        console.dir($(".jobs-sidebar-complete"));
	        console.dir($(".jobs-page-complete"));
	
	        _this.$timeout(function () {
	          $(".sticky-header").addClass("sticky-header-expanded-headers");
	          $(".job-content .job-table.table-responsive.respons-job table tbody tr").addClass("sticky-body-expanded-cells");
	          $(".jobs-sidebar-complete").addClass("jobs-sidebar-complete-hide");
	          $(".jobs-page-complete").addClass("jobs-page-complete-expanded");
	        }, 100);
	      } else {
	        _this.table_expanded = false;
	        _this.$timeout(function () {
	          $(".jobs-sidebar-complete").removeClass("jobs-sidebar-complete-hide");
	          $(".jobs-page-complete").removeClass("jobs-page-complete-expanded");
	        }, 100);
	      }
	    }
	  }, {
	    key: "checkToClearQuery",
	    value: function checkToClearQuery(clear) {
	      var _this = this;
	      if (clear) {
	        _this.$rootScope.sessionParams = null;
	      }
	    }
	  }]);
	
	  return EventsController;
	}();
	
	EventsController.$inject = ["$http", "$localStorage", "$state", "auth", "events", "companies", "security", "$rootScope", "$timeout", "$window", "$location", "$stateParams", "scroll", "env", "$scope", "NgMap", "branchio"];
	
	exports.default = EventsController;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CompaniesService = function () {
	  function CompaniesService($http, $localStorage, $state, SecurityService, AuthService, EnvService) {
	    _classCallCheck(this, CompaniesService);
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$security = SecurityService;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	  }
	
	  _createClass(CompaniesService, [{
	    key: "eventsForEventsPage",
	    value: function eventsForEventsPage(companyId, offsetParam, maxParam, page, sort, order, isCompleted, isCancelled, dates) {
	      if (this.$security.isUndefinedOrNull(sort)) {
	        sort = "lastUpdated";
	      }
	      if (this.$security.isUndefinedOrNull(order)) {
	        order = "desc";
	      }
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + companyId + "/listEvents?sort=" + sort + "&order=" + order + "&max=" + maxParam + "&offset=" + offsetParam + "&isCompleted=" + isCompleted + "&isCancelled=" + isCancelled;
	
	      if (_.isEmpty(dates) === false) {
	        url = url + "&startTime=" + dates.start + "&endTime=" + dates.end;
	      }
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getApplicationErrors",
	    value: function getApplicationErrors() {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/application-errors/list-all";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getEventPoolData",
	    value: function getEventPoolData(data) {
	      var url = this.$env.getElasticSearchEventsAPIEndPoint();
	
	      url = url + "ondemand/events?companyId=" + this.$localStorage.logged_user.company.id + "&eventPoolId=" + data.eventPoolId + "&offset=" + data.offset + "&direction=" + data.direction + "&sort=" + data.sort + "&max=" + data.max;
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getJobs",
	    value: function getJobs(data) {
	      var url = this.$env.getAPIEndPoint();
	
	      if (!data.offset) {
	        data.offset = 0;
	      }
	
	      if (!data.max) {
	        data.max = 10;
	      }
	
	      if (!data.sort) {
	        data.sort = "startTime";
	      }
	
	      if (!data.order) {
	        data.order = "asc";
	      }
	
	      if (!data.list) {
	        data.list = "published";
	      }
	
	      if (_.isEmpty(data.dates) === false) {
	        //do something
	      }
	
	      if (this.$localStorage.logged_user.company.isVerified === null || this.$localStorage.logged_user.company.isVerified === false) {
	        url = url + "jbl/v1/companies/" + data.companyId + "/listEvents?sort=startTime&order=asc&max=10&offset=0&isCompleted=null&isCancelled=null";
	      } else {
	        if (data.multiSearch) {
	          url = url + "jbl/v1/companies/" + data.companyId + "/listEvents?max=" + data.max + "&offset=" + data.offset + "&multiSearch=" + data.multiSearch;
	        } else {
	          url = url + "jbl/v1/companies/" + data.companyId + "/listEvents?sort=" + data.sort + "&order=" + data.order + "&max=" + data.max + "&offset=" + data.offset;
	        }
	
	        if (data.completedStatus === true) {
	          url = url + "&isCompleted=true";
	        }
	
	        if (data.cancelledStatus === true) {
	          url = url + "&isCancelled=true";
	        } else if (data.cancelledStatus === false) {
	          url = url + "&isCancelled=false";
	        }
	
	        if (data.isDraftStatus === true) {
	          url = url + "&isCancelled=false&isDraft=true";
	        }
	
	        if (data.completedStatus !== true && data.cancelledStatus !== true && data.isDraftStatus !== true) {
	          url = url + "&isCompleted=false&isCancelled=false&isDraft=false";
	        }
	      }
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	
	      return this.$http(req);
	      /*
	          let url = this.$env.getElasticSearchEventsAPIEndPoint();
	           if (!data.offset) {
	              data.offset = 0;
	          }
	           if (!data.max) {
	              data.max = 10;
	          }
	           if (!data.sort) {
	              data.sort = "startTime";
	          }
	           if (!data.order) {
	              data.order = "asc";
	          }
	           if (!data.list) {
	              data.list = "published";
	          }
	           if (_.isEmpty(data.dates) === false) {
	              //do something
	          }
	           if (this.$localStorage.logged_user.company.isVerified === null || this.$localStorage.logged_user.company.isVerified === false) {
	               url = url + "ondemand/events?sort=startTime&direction=desc&limit=10&offset=0&isCompleted=null&isCancelled=null";
	           } else {
	               if (data.multiSearch) {
	                  url = url + "ondemand/events?max=" + data.max + "&offset=" + data.offset + "&multiSearch=" + data.multiSearch;
	              } else {
	                  url = url + "ondemand/events?sort=" + data.sort + "&direction=" + data.order + "&limit=" + data.max + "&offset=" + data.offset;
	              }
	               if (data.completedStatus === true) {
	                  url = url + "&isCompleted=true";
	              }
	               if (data.cancelledStatus === true) {
	                  url = url + "&isCancelled=true";
	              } else if (data.cancelledStatus === false) {
	                  url = url + "&isCancelled=false";
	              }
	               if (data.isDraftStatus === true) {
	                  url = url + "&isCancelled=false&isDraft=true";
	              }
	               if (data.completedStatus !== true && data.cancelledStatus !== true && data.isDraftStatus !== true) {
	                  url = url + "&isCompleted=false&isCancelled=false&isDraft=false";
	              }
	           }
	           url = url + "&companyId=" + this.$localStorage.logged_user.company.id;
	           let req = {
	              method: "GET",
	              url: url,
	              headers: {authorization: "Bearer " + this.$auth.getAccessToken()},
	              data: {},
	          };
	           return this.$http(req);
	           */
	    }
	  }, {
	    key: "getTeamsUltraTrim",
	    value: function getTeamsUltraTrim() {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + this.$auth.getUserData().company.id + "/circles?format=json&fields=id,name";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getTeamsTrim",
	    value: function getTeamsTrim() {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + this.$auth.getUserData().company.id + "/listCircles?format=json&numberOfUsers=6&max=50&fields=id,name,numberOfUsers,users.id,users.lastName,users.firstName,users.filePROFILE_IMAGE1IMG_75x75";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getPendingInvitations",
	    value: function getPendingInvitations() {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + this.$auth.getUserData().company.id + "/companyUsers";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getTeams",
	    value: function getTeams() {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + this.$auth.getUserData().company.id + "/circles?format=json&conf=web&&numberOfUsers=6&verbosity=3&fields=id,name,users";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getTeamsSimple",
	    value: function getTeamsSimple(totalNumberOfTeams) {
	      if (!totalNumberOfTeams) {
	        totalNumberOfTeams = 100;
	      }
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + this.$auth.getUserData().company.id + "/circles?format=json&conf=web&fields=id,name&verbosity=1&max=" + totalNumberOfTeams;
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "paginateThroughTeams",
	    value: function paginateThroughTeams(companyId, offsetParam, maxParam, sort, order) {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + companyId + "/listCircles?format=json&offset=" + offsetParam + "&max=" + maxParam + "&sort=" + sort + "&order=" + order + "&conf=web&numberOfUsers=6&fields=id,name,numberOfUsers,users.id,users.lastName,users.firstName,users.filePROFILE_IMAGE1IMG_75x75";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "fileTypesReq",
	    value: function fileTypesReq() {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/file-types?conf=web&format=json&max=30";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getTeamsOnEventEditPage",
	    value: function getTeamsOnEventEditPage(maxCount) {
	      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + this.$auth.getUserData().company.id + "/circles?format=json&conf=web&max=" + maxCount.toString() + "&offset=" + offset.toString();
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }, {
	    key: "getDirectPaymentReceipts",
	    value: function getDirectPaymentReceipts(maxCount, fid) {
	      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + this.$auth.getUserData().company.id + "/files?format=json&conf=web&type=" + fid.toString() + "&max=" + maxCount.toString() + "&offset=" + offset.toString() + "&sort=dateCreated&order=desc";
	      var reqDirectPaymentReceipts = {
	        method: "GET",
	        url: url,
	        // url: "/app/vendor/api/get_payment_receipts.json",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(reqDirectPaymentReceipts);
	    }
	  }, {
	    key: "cancelPendingInvitation",
	    value: function cancelPendingInvitation(t) {
	      ///register/invite-user/cancel   and pass 'token' (invitation token) as param in the request json
	      var data = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "register/invite-user/cancel",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {
	          token: t
	        }
	      };
	
	      return this.$http(data);
	    }
	  }, {
	    key: "updateCloudWithNewUser",
	    value: function updateCloudWithNewUser(arr, email) {
	      var _this = this;
	
	      var updateCloud = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.$localStorage.logged_user.company.id + "/add-to-circle?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        data: {
	          users: email,
	          circle: arr
	        }
	      };
	
	      return _this.$http(updateCloud);
	    }
	  }, {
	    key: "saveCompanyProfileInformationNew",
	    value: function saveCompanyProfileInformationNew(payload) {
	      var req = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + this.$auth.getUserData().id + "/updateMinimalFields",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: payload
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "saveCompanyProfileInformation",
	    value: function saveCompanyProfileInformation(data) {
	      var req = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + this.$auth.getUserData().id + "?format=json&fields=company.name,company.legalCompanyName,company.ein,company.numberOfLocations,company.description,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.mainContactInfo.city,company.mainContactInfo.state,company.mainContactInfo.zipCode",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          company: {
	            description: data.company_bio,
	            name: data.company_name,
	            legalCompanyName: data.legal_company_name,
	            ein: data.ein,
	            numberOfLocations: data.number_of_locations,
	            mainContactInfo: {
	              phoneMobile: data.company_phone,
	              streetLine1: data.company_street_address,
	              city: data.company_city,
	              state: data.company_state,
	              zipCode: data.company_zip_code
	            }
	          }
	        }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "updateUser",
	    value: function updateUser(data) {
	      var _this = this;
	      var prop = data.prop;
	      var payload = {};
	
	      var req = {
	        method: "PUT",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        }
	      };
	
	      switch (prop) {
	        case 1:
	          req.data = { firstName: data.value };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=firstName";
	          break;
	        case 2:
	          req.data = { lastName: data.value };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=lastName";
	          break;
	        case 3:
	          req.data = { homeContactInfo: { phoneMobile: data.value } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.phoneMobile";
	          break;
	        case 4:
	          req.data = { homeContactInfo: { streetLine1: data.value } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.streetLine1";
	          break;
	        case 5:
	          req.data = { homeContactInfo: { city: data.value } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.city";
	          break;
	        case 6:
	          req.data = { homeContactInfo: { state: data.value } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.state";
	          break;
	        case 7:
	          req.data = { homeContactInfo: { zipCode: data.value } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.zipCode";
	          break;
	        case 8:
	          req.data = { company: { name: data.value } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=name";
	          break;
	        case 9:
	          req.data = {
	            company: { mainContactInfo: { firstName: data.value } }
	          };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.firstName";
	          break;
	        case 10:
	          req.data = {
	            company: { mainContactInfo: { lastName: data.value } }
	          };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.lastName";
	          break;
	        case 11:
	          req.data = {
	            company: { mainContactInfo: { phoneMobile: data.value } }
	          };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.phoneMobile";
	          break;
	        case 12:
	          req.data = {
	            company: { mainContactInfo: { streetLine1: data.value } }
	          };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.streetLine1";
	          break;
	        case 13:
	          req.data = {
	            company: { mainContactInfo: { city: data.value } }
	          };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.city";
	          break;
	        case 14:
	          req.data = {
	            company: { mainContactInfo: { state: data.value } }
	          };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.state";
	          break;
	        case 15:
	          req.data = {
	            company: { mainContactInfo: { zipCode: data.value } }
	          };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.zipCode";
	          break;
	      }
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getSettings",
	    value: function getSettings() {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&fields=acceptedPrivacyPolicy,company.autoPost,company.autoAccept,company.autoManage,emailChatNotificationOn,brands,smsChatNotificationOn,company.industryType.id,company.industryType.name,company.postingTypesAllowed,company.payByInvoice,company.invoiceMarkup",
	        headers: {
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "updateCompanyBillingEmail",
	    value: function updateCompanyBillingEmail(data) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/save-customer?format=json&conf=web&fields=id",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	
	        data: data
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "updateNotifications",
	    value: function updateNotifications(data) {
	      var _this = this;
	
	      var req = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?conf=web&format=json&fields=id",
	        headers: {
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	
	        data: data
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "updateCloudWithNewUser",
	    value: function updateCloudWithNewUser(arr, email) {
	      var _this = this;
	
	      var updateCloud = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.$localStorage.logged_user.company.id + "/add-to-circle?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        data: {
	          users: email,
	          circle: arr
	        }
	      };
	
	      return _this.$http(updateCloud);
	    }
	  }, {
	    key: "updateUser",
	    value: function updateUser(data) {
	      var _this = this;
	
	      var prop = data.prop;
	      var payload = {};
	
	      var req = {
	        method: "PUT",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        }
	      };
	
	      switch (prop) {
	        case 1:
	          req.data = { firstName: data.value };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=firstName";
	          break;
	        case 2:
	          req.data = { lastName: data.value };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=lastName";
	          break;
	        case 3:
	          req.data = { homeContactInfo: { phoneMobile: data.value } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.phoneMobile";
	          break;
	        case 4:
	          req.data = { homeContactInfo: { streetLine1: data.value } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.streetLine1";
	          break;
	        case 5:
	          req.data = { homeContactInfo: { city: data.value } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.city";
	          break;
	        case 6:
	          req.data = { homeContactInfo: { state: data.value } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.state";
	          break;
	        case 7:
	          req.data = { homeContactInfo: { zipCode: data.value } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=homeContactInfo.zipCode";
	          break;
	        case 8:
	          req.data = { company: { name: data.value } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=name";
	          break;
	        case 9:
	          req.data = { company: { mainContactInfo: { firstName: data.value } } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.firstName";
	          break;
	        case 10:
	          req.data = { company: { mainContactInfo: { lastName: data.value } } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.lastName";
	          break;
	        case 11:
	          req.data = { company: { mainContactInfo: { phoneMobile: data.value } } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.phoneMobile";
	          break;
	        case 12:
	          req.data = { company: { mainContactInfo: { streetLine1: data.value } } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.streetLine1";
	          break;
	        case 13:
	          req.data = { company: { mainContactInfo: { city: data.value } } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.city";
	          break;
	        case 14:
	          req.data = { company: { mainContactInfo: { state: data.value } } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.state";
	          break;
	        case 15:
	          req.data = { company: { mainContactInfo: { zipCode: data.value } } };
	          req.url = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?format=json&fields=company.mainContactInfo.zipCode";
	          break;
	      }
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getFcaKey",
	    value: function getFcaKey() {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/fca-session",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getIntentKey",
	    value: function getIntentKey(payload) {
	      var _this = this;
	
	      console.log("getIntentKey");
	      console.dir(payload);
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/setup-intent-session",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: payload
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "updateIntentKey",
	    value: function updateIntentKey(payload) {
	      var _this = this;
	
	      console.log("updateIntentKey");
	      console.dir(payload);
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/update-intent",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: payload
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "updateIntentWithMicroDeposits",
	    value: function updateIntentWithMicroDeposits(parsedAmount1, parsedAmount2, stripeId, setupId) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/update-intent-verify-microdeposit",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {
	          paymentMethodId: stripeId,
	          setupId: setupId,
	          amount1: parsedAmount1,
	          amount2: parsedAmount2
	        }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "loadUsers",
	    value: function loadUsers() {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.$localStorage.logged_user.company.id + "/users?format=json&conf=web&fields=id,dateCreated,firstName,lastName,homeContactInfo.phoneMobile,homeContactInfo.isMobilePhoneVerified,homeContactInfo.streetLine1,homeContactInfo.state,homeContactInfo.city,homeContactInfo.zipCode,emailChatNotificationOn,smsChatNotificationOn,username,email,authorities",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getSettings",
	    value: function getSettings() {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&fields=acceptedPrivacyPolicy,company.autoPost,company.autoAccept,company.autoManage,emailChatNotificationOn,brands,smsChatNotificationOn,company.industryType.id,company.industryType.name,company.postingTypesAllowed,company.payByInvoice,company.sendInvoice,company.enableSubscription,company.invoiceMarkup",
	        headers: { Authorization: "Bearer " + _this.$localStorage.logged_user.access_token },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "updateNotifications",
	    value: function updateNotifications(data) {
	      var _this = this;
	
	      var req = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?conf=web&format=json&fields=id",
	        headers: {
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	
	        data: data
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "updateInvoiceSettings",
	    value: function updateInvoiceSettings(company) {
	      var _this = this;
	
	      //let data = {};
	
	      console.log("companiesService: updateInvoiceSettings");
	      console.dir(company);
	
	      /*
	          if (d.enableSubscription !== null && !angular.isUndefined(d.enableSubscription)) {
	              console.log("here 1");
	              data = {company: {enableSubscription: d.enableSubscription}};
	          } else if (d.payByInvoice !== null && !angular.isUndefined(d.payByInvoice)) {
	              console.log("here 2");
	              data = {company: {payByInvoice: d.payByInvoice, invoiceMarkup: d.invoiceMarkup}};
	          } else if (d.sendInvoice !== null && !angular.isUndefined(d.sendInvoice)) {
	              console.log("here 3");
	              data = {company: {sendInvoice: d.sendInvoice}};
	          }
	          */
	
	      var req = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "?conf=web&format=json&fields=id,company.payByInvoice,company.invoiceMarkup,company.sendInvoice,company.enableSubscription",
	        headers: {
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        data: {
	          company: company
	        }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "updateCompanyAutoManage",
	    value: function updateCompanyAutoManage(payload) {
	      var _this = this;
	
	      var req = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.$localStorage.logged_user.company.id + "?conf=web&format=json&fields=id,autoManage",
	        headers: {
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	
	        data: payload
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "updateCompanyAutoAccept",
	    value: function updateCompanyAutoAccept(payload) {
	      var _this = this;
	
	      var req = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.$localStorage.logged_user.company.id + "?conf=web&format=json&fields=id,autoAccept,autoAcceptLimitTimeMark",
	        headers: {
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	
	        data: payload
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "update_post_type",
	    value: function update_post_type(data) {
	      var _this = this;
	
	      console.log("update_post_type");
	      console.dir(data);
	
	      var req = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.$localStorage.logged_user.company.id + "?conf=web&format=json&fields=id,postingTypesAllowed",
	        headers: {
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	
	        data: { postingTypesAllowed: data }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "storePreferredPostType",
	    value: function storePreferredPostType(type) {
	      var _this = this;
	
	      var req = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.$localStorage.logged_user.company.id + "?conf=web&format=json&fields=id",
	        headers: {
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	
	        data: { payPerConnect: type }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "chargeForPost",
	    value: function chargeForPost(data, invoice) {
	      var _this = this;
	
	      var account = _this.$env.EnvironmentConfig.jobbleAccounting;
	      var req = {};
	
	      if (invoice === true) {
	        req.transfers = [{ recipient: account, amount: data.amount, note: data.note }];
	      } else {
	        req.card = data.token;
	        req.transfers = [{ recipient: account, amount: data.amount, note: data.note }];
	      }
	
	      var reqPayJobbler = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        data: req
	      };
	
	      return _this.$http(reqPayJobbler);
	    }
	  }, {
	    key: "getCompanyUsers",
	    value: function getCompanyUsers() {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.$localStorage.logged_user.company.id + "/users?format=json&max=30&fields=id,firstName,lastName,homeContactInfo.phoneMobile,email",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "makePayment",
	    value: function makePayment(payload, user) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: payload
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "loadJobblersFromTeam",
	    value: function loadJobblersFromTeam(id, query) {
	      var _this = this;
	
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/circles/" + id + "/users?format=json&fields=id,isVerified,firstName,lastName,paymentInfos.id,paymentInfos.last4,lastName,email,ssn,dateBirth,homeContactInfo.city,homeContactInfo.state,homeContactInfo.streetLine1,homeContactInfo.phoneMobile,bio,filePROFILE_IMAGE1IMG_75x75&sort=firstName&order=asc&max=" + query.max + "&offset=" + query.offset;
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getTeamDetails",
	    value: function getTeamDetails(id) {
	      var _this = this;
	
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/circles/" + id + "?format=json&fields=id,name";
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "bulkPostJobs",
	    value: function bulkPostJobs(data) {
	      var _this = this;
	
	      var payload = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/create-pools",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	
	        data: data
	      };
	
	      return _this.$http(payload);
	    }
	  }, {
	    key: "deleteUserFromTeam",
	    value: function deleteUserFromTeam(data) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.$localStorage.logged_user.company.id + "/remove-from-circle?format=json&conf=web",
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken(), "Content-Type": "application/json" },
	        data: { circle: data.circle, users: data.users }
	      };
	      return _this.$http(req);
	    }
	  }, {
	    key: "getCharges",
	    value: function getCharges() {
	      var _this = this;
	
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/charges/";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "addToDNHList",
	    value: function addToDNHList(data) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/dnh",
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken(), "Content-Type": "application/json" },
	        data: { list: data }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getAvailableDNHList",
	    value: function getAvailableDNHList() {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/dnh/availableJobblers",
	        headers: { Authorization: "Bearer " + _this.$localStorage.logged_user.access_token },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getDoNotHireList",
	    value: function getDoNotHireList() {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/dnh",
	        headers: { Authorization: "Bearer " + _this.$localStorage.logged_user.access_token },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "removeDoNotHireList",
	    value: function removeDoNotHireList(data) {
	      var _this = this;
	
	      var req = {
	        method: "DELETE",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/dnh",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        data: data
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getPendingInvoices",
	    value: function getPendingInvoices(start, end) {
	      var _this = this;
	
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/payments/pending-invoice?period" + start + "&periodEnd=" + end;
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getInvoices",
	    value: function getInvoices(data) {
	      var _this = this;
	
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/invoices/list?offset=" + data.offset + "&max=" + data.max + "&sort=" + data.sort + "&order=" + data.order;
	
	      if (data.search) {
	        url = _this.$env.getAPIEndPoint() + "jbl/v1/invoices/list?download=true&offset=" + data.offset + "&max=" + data.max + "&search=" + data.search;
	      }
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getBill",
	    value: function getBill(data) {
	      var _this = this;
	
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/invoices/" + data.billId + "/details?download=true&offset=" + data.offset + "&max=" + data.max + "&sort=" + data.sort + "&order=" + data.order;
	
	      if (data.search) {
	        url = _this.$env.getAPIEndPoint() + "jbl/v1/invoices/" + data.billId + "/details?offset=" + data.offset + "&max=" + data.max + "&search=" + data.search;
	      }
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "createInAppNotifications",
	    value: function createInAppNotifications(data) {
	      var alerts = [];
	
	      try {
	        data.forEach(function (alert, index) {
	          if (index < 6) {
	            var formattedAlert = {};
	
	            formattedAlert.rawAlert = alert;
	            formattedAlert.name = alert.applicantUser.firstName + " " + alert.applicantUser.lastName;
	            formattedAlert.eventId = alert.event.id;
	            if (alert.errorCode === 111) {} else {
	              if (alert.errorCode === 101) {
	                formattedAlert.message = "The jobbler " + formattedAlert.name + " (" + alert.applicantUser.email + ") is not a verified user. They were not hired for job " + formattedAlert.eventId + ".";
	              } else if (alert.errorText.indexOf("Could not find a jobble") > -1 || alert.errorCode === 107) {
	                formattedAlert.message = "There were not enough openings to hire " + formattedAlert.name + " (" + alert.applicantUser.email + ") for job " + formattedAlert.eventId + ".";
	              } else if (alert.errorText.indexOf("is already booked for this time frame") > -1) {
	                formattedAlert.message = formattedAlert.name + " (" + alert.applicantUser.email + ") was already scheduled to work a job. He was not hired for job " + formattedAlert.eventId + ".";
	              } else if (alert.errorText.indexOf("has been suspended.") > -1 || alert.errorCode === 102) {
	                formattedAlert.message = formattedAlert.name + " (" + alert.applicantUser.email + ") has been suspended from our platform. He was not hired for job " + formattedAlert.eventId + ".";
	              } else if (alert.errorText.indexOf("specify the jobble") > -1 || alert.errorCode === 101) {
	                formattedAlert.message = formattedAlert.name + " (" + alert.applicantUser.email + ") did not have a Jobble assigned. He was not hired for job " + formattedAlert.eventId + ".";
	              } else if (alert.errorText.indexOf("Do Not Hire.") > -1 || alert.errorCode === 104) {
	                formattedAlert.message = formattedAlert.name + " (" + alert.applicantUser.email + ") was on a Do Not Hire list. He was not hired for job " + formattedAlert.eventId + ".";
	              } else if (alert.errorText.indexOf("No application") > -1 || alert.errorCode === 106) {
	                formattedAlert.message = formattedAlert.name + " (" + alert.applicantUser.email + ") did not have an application. He was not hired for job " + formattedAlert.eventId + ".";
	              } else if (alert.errorText.indexOf("Transactional") > -1 || alert.errorCode === 109) {
	                formattedAlert.message = formattedAlert.name + " (" + alert.applicantUser.email + ") has a transactional error during the hiring process. He was not hired for job " + formattedAlert.eventId + ".";
	              } else {
	                formattedAlert.message = "There was an issue hiring " + formattedAlert.name + " (" + alert.applicantUser.email + ") He was not hired for the job " + formattedAlert.eventId + ". Please contact support.";
	              }
	
	              formattedAlert.dateCreated = new Date(alert.dateCreated);
	              formattedAlert.dateCreatedFormatted = moment(formattedAlert.dateCreated).format("MM/DD/YY hh:mm:ss A");
	
	              alerts.push(formattedAlert);
	            }
	          }
	        });
	      } catch (err) {
	        console.log("error collecting alerts");
	        console.dir(err);
	      } finally {
	        console.log("alerts");
	        console.dir(alerts);
	
	        return alerts;
	      }
	    }
	  }, {
	    key: "achknowledgeApplicationError",
	    value: function achknowledgeApplicationError(id) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/application-errors/ack",
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken(), "Content-Type": "application/json" },
	        data: { applicationErrorId: id }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getUserRoles",
	    value: function getUserRoles() {
	      var url = this.$env.getAPIEndPoint() + "jbl/v1/users/groups";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: { Authorization: "Bearer " + this.$auth.getAccessToken() },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getAuth",
	    value: function getAuth() {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&fields=username,authorities",
	        headers: {
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "updateUserRoles",
	    value: function updateUserRoles(data) {
	      var _this = this;
	
	      var req = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + data.userId + "/groups",
	        headers: {
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	
	        data: { group: { id: data.groupId } }
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getNotificationPreferences",
	    value: function getNotificationPreferences() {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/userEmailPreferences",
	        headers: {
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "createOrUpdateNotificationPreferences",
	    value: function createOrUpdateNotificationPreferences(d) {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/userEmailPreferences",
	        headers: {
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	
	        data: d
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "updateNotificationPreferences",
	    value: function updateNotificationPreferences(d) {
	      var _this = this;
	
	      var req = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/userEmailPreferences",
	        headers: {
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	
	        data: d
	      };
	
	      return _this.$http(req);
	    }
	  }]);
	
	  return CompaniesService;
	}();
	
	exports.default = CompaniesService;
	
	
	CompaniesService.$inject = ["$http", "$localStorage", "$state", "security", "auth", "env"];

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(395);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./events.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./events.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "events #wrapper{min-height:calc(100% - 62px)}", ""]);
	
	// exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _recoverpassword = __webpack_require__(397);
	
	var _recoverpassword2 = _interopRequireDefault(_recoverpassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recoverpasswordModule = _angular2.default.module("recoverpassword", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("recoverpassword", {
	    url: "/recover-password",
	    template: "<recoverpassword></recoverpassword>",
	    title: "Recover Password"
	  });
	}).component("recoverpassword", _recoverpassword2.default);
	
	exports.default = recoverpasswordModule;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _recoverpassword = __webpack_require__(398);
	
	var _recoverpassword2 = _interopRequireDefault(_recoverpassword);
	
	var _recoverpassword3 = __webpack_require__(399);
	
	var _recoverpassword4 = _interopRequireDefault(_recoverpassword3);
	
	__webpack_require__(400);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recoverpasswordComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _recoverpassword2.default,
	  controller: _recoverpassword4.default,
	  controllerAs: "vm"
	};
	
	exports.default = recoverpasswordComponent;

/***/ }),
/* 398 */
/***/ (function(module, exports) {

	module.exports = "<style>\n  .login-area {\n    background: url(/app/vendor/images/login-bg2.png) no-repeat 0 0;\n    background-size: cover;\n    min-height: 916px;\n  }\n\n  .login-wrap {\n    max-width: 785px;\n    margin: 0 auto;\n    padding: 75px 0 0;\n  }\n\n  .login-wrap h2 {\n    color: #ffffff;\n    text-transform: uppercase;\n    font-size: 22px;\n    font-weight: 700;\n    line-height: normal;\n    margin: 0 0 33px;\n    text-align: center;\n    font-family: \"Poppins\";\n  }\n\n  .login-container.fp {\n    background-color: #ffffff;\n    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 20%);\n    border-radius: 6px 6px 6px 6px;\n  }\n\n  .login-container form {\n    margin: 0;\n  }\n\n  .login-content {\n    max-width: 384px;\n    margin: 0 auto 9px;\n    padding: 75px 0 85px;\n  }\n\n  .login-content label {\n    display: block;\n    color: #3b3f43;\n    margin: 0 0 8px;\n    font-size: 15px;\n    font-weight: 300;\n    font-family: \"Poppins\";\n  }\n\n  .login-content input[type=\"text\"],\n  .login-content input[type=\"password\"],\n  .login-content input[type=\"email\"] {\n    display: block;\n    border: 1px solid #adbcc2;\n    background: #fff;\n    width: 100%;\n    padding: 8px 10px 10px 35px;\n    caret-color: #494949;\n    margin: 0 0 15px;\n    appearance: none;\n    font-family: \"Poppins\";\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    -ms-appearance: none;\n  }\n\n  .login-content input[type=\"text\"]:focus,\n  .login-content input[type=\"password\"]:focus,\n  .login-content input[type=\"email\"]:focus,\n  .login-content input[type=\"email\"]:focus {\n    outline: 0;\n    border: 2px solid #adbcc2;\n  }\n\n  .input-submit {\n    overflow: hidden;\n    margin: 40px 0 0;\n  }\n\n  .login-content a.f-pass {\n    color: #2c3a40;\n    font-size: 14px;\n    font-weight: 300;\n    display: block;\n  }\n\n  .login-container.fp .modal-gradient-banner {\n    height: 6px;\n    width: 100%;\n    border-radius: 6px 6px 0 0;\n    background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n  }\n\n  .login-content.fp input[type=\"submit\"] {\n    width: 229px;\n    display: block;\n    color: #ffffff;\n    font-family: Poppins, sans-serif;\n    font-size: 14px;\n    font-weight: bold;\n    /* line-height: 40px; */\n    height: 40px;\n    border-radius: 6px;\n    background-color: #62c046;\n    text-align: center;\n    margin-top: 16px;\n    cursor: pointer;\n  }\n\n  .login-content.fp input[type=\"submit\"]:hover {\n    border: none;\n  }\n\n  .login-content.fp :placeholder-shown {\n    color: #adbcc2;\n    opacity: 1;\n  }\n\n  .signup-area {\n    border: 1px solid #ffffff;\n    padding: 19px 22px;\n    overflow: hidden;\n    margin: 0 0 40px;\n  }\n\n  .signup-area span {\n    color: #ffffff;\n    font-size: 16px;\n    font-weight: 300;\n    line-height: 40px;\n  }\n\n  .signup-area .btn.btn-default {\n    font-weight: 700;\n    width: 190px;\n  }\n\n  .login-meta {\n    text-align: center;\n    color: #ffffff;\n    font-size: 14px;\n    font-weight: 300;\n  }\n\n  .login-meta a {\n    color: #ffffff;\n  }\n\n  .input-bg {\n    position: relative;\n  }\n\n  .input-bg::before {\n    font-family: \"FontAwesome\";\n    font-size: 17px;\n    left: 12px;\n    position: absolute;\n    top: 10px;\n    color: #3b3f43;\n  }\n\n  .btn-default:hover,\n  .btn-default:focus,\n  .btn-default.active {\n    background-color: #5e666d;\n    color: #fff;\n    border-color: #5e666d;\n  }\n\n  .btn.btn-inverse:hover,\n  .button.hollow:focus {\n    border-color: #5e666d;\n    color: #5e666d;\n  }\n\n  .input-bg.name:before {\n    content: \"\\f007\";\n  }\n\n  .input-bg.password:before {\n    content: \"\\f023\";\n  }\n\n  .btn-default {\n    background-color: #74cf59;\n    color: #fff;\n    border-color: #74cf59;\n  }\n\n  .btn {\n    padding: 9px 20px;\n    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n    border-radius: 2px;\n    transition: all 0.25s ease-in-out;\n  }\n\n  .btn.btn-inverse {\n    border: 1px solid #b7c0c5;\n    color: #5e666d;\n    font-size: 14px;\n  }\n\n  @media only screen and (max-width: 1024px) {\n    .login-wrap {\n      max-width: 700px;\n    }\n  }\n\n  @media only screen and (max-width: 979px) {\n    .login-wrap {\n      max-width: 600px;\n    }\n  }\n\n  @media only screen and (max-width: 767px) {\n    .login-area {\n      padding: 0 20px;\n    }\n    .login-wrap {\n      max-width: none;\n    }\n    .login-content {\n      padding: 60px;\n      max-width: none;\n    }\n  }\n\n  @media only screen and (max-width: 639px) {\n    .input-submit {\n      margin: 25px 0 0;\n    }\n    .login-content a.f-pass {\n      float: none !important;\n      margin: 0 0 20px;\n      text-align: center;\n    }\n    .login-content a.f-pass br {\n      display: none;\n    }\n    .login-content input[type=\"submit\"] {\n      margin: 0 auto;\n      display: block;\n      float: none !important;\n    }\n  }\n\n  @media only screen and (max-width: 479px) {\n    .login-content {\n      padding: 25px;\n    }\n    .signup-area span {\n      display: block;\n      font-size: 14px;\n      line-height: normal;\n      margin: 0 0 15px;\n      text-align: center;\n    }\n    .signup-area .btn.btn-default {\n      display: block;\n      float: none !important;\n      margin: 0 auto;\n    }\n  }\n\n  /* Alert */\n  .alert {\n    margin-top: 10px;\n    padding: 20px;\n    background-color: #f44336; /* Red */\n    color: white;\n    margin-bottom: 15px;\n  }\n\n  /* The close button */\n  .closebtn {\n    margin-left: 15px;\n    color: white;\n    font-weight: bold;\n    float: right;\n    font-size: 22px;\n    line-height: 20px;\n    cursor: pointer;\n    transition: 0.3s;\n  }\n\n  /* When moving the mouse over the close button */\n  .closebtn:hover {\n    color: black;\n  }\n\n  .header-top {\n    padding: 10px 20px;\n    background-color: #fff;\n  }\n\n  .top-right {\n    margin: 5px 0px;\n  }\n\n  .top-menu {\n    float: right;\n    margin: 10px 30px 6px 0px;\n  }\n\n  .top-menu ul {\n    padding: 0px;\n    margin: 0px;\n    list-style: none;\n  }\n\n  .top-menu li {\n    display: block;\n    float: left;\n    margin: 0px 12px;\n  }\n\n  .top-menu li a {\n    display: inline-block;\n    color: #5e666d;\n    font-size: 17px;\n    font-weight: 300;\n    padding-bottom: 3px;\n    border-bottom: 2px solid transparent;\n  }\n\n  .top-menu li a:hover {\n    border-bottom-color: #74cf59;\n  }\n\n  .top-menu li.active a {\n    border-bottom-color: #74cf59;\n    font-weight: 700;\n  }\n\n  .navbar-toggle .icon-bar {\n    background-color: #74cf59;\n  }\n\n  .header-login-btn {\n    margin-top: 7px;\n  }\n\n  .header-login-btn a {\n    width: 105px;\n    margin-left: 6px;\n    font-weight: 700;\n  }\n\n  @media (max-width: 991px) {\n    .top-menu {\n      margin-right: 15px;\n    }\n    .top-menu li a {\n      font-size: 14px;\n    }\n    .header-login-btn a {\n      padding: 9px;\n      width: auto;\n    }\n    .top-menu {\n      margin-right: 0;\n    }\n  }\n\n  @media (max-width: 767px) {\n    .navbar-toggle {\n      margin-right: 0px;\n    }\n    .header-top {\n      z-index: 130;\n      position: relative;\n    }\n    .top-menu {\n      background: #f8fcff;\n      float: none;\n      left: 0;\n      margin: 0;\n      position: absolute;\n      top: 100%;\n      width: 100%;\n      padding: 15px 10px 0;\n      border-top: 1px solid #eeeeee;\n      display: none;\n    }\n    .top-menu li {\n      float: none;\n    }\n    .top-menu li a {\n      display: block;\n      margin-bottom: 5px;\n    }\n    .navbar-toggle {\n      position: absolute;\n      top: 12px;\n      right: 5px;\n    }\n    .header-login-btn {\n      margin-left: 20px;\n      margin-right: 40px;\n    }\n    .header-login-btn a {\n      width: 90px;\n    }\n  }\n\n  @media (max-width: 406px) {\n    .header-login-btn {\n      margin: 0;\n    }\n    .header-login-btn a {\n      margin-top: 20px;\n      width: 130px;\n    }\n  }\n</style>\n\n<jobbleheader></jobbleheader>\n\n<section class=\"login-area\">\n  <div class=\"login-wrap\">\n    <h2>Recover Password</h2>\n    <div class=\"login-container fp\">\n      <div class=\"modal-gradient-banner\"></div>\n      <div class=\"login-content fp\" >\n        <form ng-submit=\"vm.submitRecoverLink()\">\n          <div ng-show=\"vm.result.status == 'error'\" class=\"alert-box\">\n            <p>{{vm.result.message}}</p>\n          </div>\n\n          <label>Please enter the email you registered with. If it exists we will send you a link to reset your password. 1</label>\n          <div class=\"input-bg name\">\n            <input type=\"email\" placeholder=\"Email\" name=\"email\" class=\"mail-bg\" ng-model=\"vm.email\" autofocus required />\n          </div>\n\n          <div class=\"input-submit\">\n            <input type=\"submit\" class=\"btn btn-default\" style=\"margin: 0 auto\" value=\"Recover your password\" />\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n</section>\n<globalalert></globalalert>\n<jobblefooter></jobblefooter>\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RecoverpasswordController = function () {
	  function RecoverpasswordController($http, $localStorage, $state, AuthService, EnvService, $timeout) {
	    _classCallCheck(this, RecoverpasswordController);
	
	    this.name = "recoverpassword";
	    $localStorage.activeStateName = "events";
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$env = EnvService;
	    this.$timeout = $timeout;
	
	    this.email = "";
	    this.remain_loading_count = 0;
	
	    this.result = {
	      status: "",
	      message: ""
	    };
	
	    this.$timeout(function () {
	      $('.login-content.fp input[type="email"]').focus();
	    }, 300);
	  }
	
	  _createClass(RecoverpasswordController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this = this;
	    }
	  }, {
	    key: "submitRecoverLink",
	    value: function submitRecoverLink() {
	      var _this = this;
	
	      var email = encodeURIComponent(this.email);
	
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "register/forgotPassword?format=json&username=" + email,
	        data: {}
	      };
	
	      _this.remain_loading_count++;
	      this.$http(req).then(function (data) {
	        console.log(data);
	        _this.remain_loading_count--;
	        _this.result.status = data.data.status;
	        _this.result.message = data.data.message;
	        if (data.data.status == "error") {
	          return;
	        }
	        _this.$auth.setRecoverEmail(_this.email);
	        _this.$state.go("recoverpasswordsuccess");
	      }, function (data) {
	        console.log(data);
	        _this.remain_loading_count--;
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }]);
	
	  return RecoverpasswordController;
	}();
	
	RecoverpasswordController.$inject = ["$http", "$localStorage", "$state", "auth", "env", "$timeout"];
	
	exports.default = RecoverpasswordController;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(401);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./recoverpassword.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./recoverpassword.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "recoverpassword footer{background:none}", ""]);
	
	// exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _recoverpasswordsuccess = __webpack_require__(403);
	
	var _recoverpasswordsuccess2 = _interopRequireDefault(_recoverpasswordsuccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recoverpasswordsuccessModule = _angular2.default.module("recoverpasswordsuccess", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise("/signin");
	  $stateProvider.state("recoverpasswordsuccess", {
	    url: "/recover-password-success",
	    template: "<recoverpasswordsuccess></recoverpasswordsuccess>"
	  });
	}).component("recoverpasswordsuccess", _recoverpasswordsuccess2.default);
	
	exports.default = recoverpasswordsuccessModule;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _recoverpasswordsuccess = __webpack_require__(404);
	
	var _recoverpasswordsuccess2 = _interopRequireDefault(_recoverpasswordsuccess);
	
	var _recoverpasswordsuccess3 = __webpack_require__(405);
	
	var _recoverpasswordsuccess4 = _interopRequireDefault(_recoverpasswordsuccess3);
	
	__webpack_require__(406);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recoverpasswordsuccessComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _recoverpasswordsuccess2.default,
	  controller: _recoverpasswordsuccess4.default,
	  controllerAs: "vm"
	};
	
	exports.default = recoverpasswordsuccessComponent;

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	module.exports = "<style>\n  .login-area {\n    background: url(/app/vendor/images/login-bg2.png) no-repeat 0 0;\n    background-size: cover;\n    min-height: 916px;\n  }\n\n  .login-wrap {\n    max-width: 785px;\n    margin: 0 auto;\n    padding: 75px 0 0;\n  }\n\n  .login-wrap h2 {\n    color: #ffffff;\n    text-transform: uppercase;\n    font-size: 22px;\n    font-weight: 700;\n    line-height: normal;\n    margin: 0 0 33px;\n    text-align: center;\n  }\n\n  .login-container {\n    background-color: #ffffff;\n  }\n\n  .login-container form {\n    margin: 0;\n  }\n\n  .login-content {\n    max-width: 384px;\n    margin: 0 auto 9px;\n    padding: 75px 0 85px;\n  }\n\n  .login-content label {\n    display: block;\n    color: #3b3f43;\n    margin: 0 0 8px;\n    font-size: 15px;\n    font-weight: 300;\n  }\n\n  .login-content input[type=\"text\"],\n  .login-content input[type=\"password\"],\n  .login-content input[type=\"email\"] {\n    display: block;\n    border: 1px solid #c3cdd1;\n    background: #fff;\n    width: 100%;\n    padding: 10px 10px 10px 35px;\n    caret-color: #494949;\n    margin: 0 0 15px;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    -ms-appearance: none;\n  }\n\n  .login-content input[type=\"text\"]:focus,\n  .login-content input[type=\"password\"]:focus,\n  .login-content input[type=\"email\"]:focus,\n  .login-content input[type=\"email\"]:focus {\n    outline: 0;\n  }\n\n  .input-submit {\n    overflow: hidden;\n    margin: 40px 0 0;\n  }\n\n  .login-content a.f-pass {\n    color: #2c3a40;\n    font-size: 14px;\n    font-weight: 300;\n    display: block;\n  }\n\n  .login-content input[type=\"submit\"] {\n    width: 190px;\n    display: block;\n    font-weight: 700;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    -ms-appearance: none;\n  }\n\n  .signup-area {\n    border: 1px solid #ffffff;\n    padding: 19px 22px;\n    overflow: hidden;\n    margin: 0 0 40px;\n  }\n\n  .signup-area span {\n    color: #ffffff;\n    font-size: 16px;\n    font-weight: 300;\n    line-height: 40px;\n  }\n\n  .signup-area .btn.btn-default {\n    font-weight: 700;\n    width: 190px;\n  }\n\n  .login-meta {\n    text-align: center;\n    color: #ffffff;\n    font-size: 14px;\n    font-weight: 300;\n  }\n\n  .login-meta a {\n    color: #ffffff;\n  }\n\n  .input-bg {\n    position: relative;\n  }\n\n  .input-bg::before {\n    font-family: \"FontAwesome\";\n    font-size: 17px;\n    left: 12px;\n    position: absolute;\n    top: 10px;\n    color: #3b3f43;\n  }\n\n  .btn-default:hover,\n  .btn-default:focus,\n  .btn-default.active {\n    background-color: #5e666d;\n    color: #fff;\n    border-color: #5e666d;\n  }\n\n  .btn.btn-inverse:hover,\n  .button.hollow:focus {\n    border-color: #5e666d;\n    color: #5e666d;\n  }\n\n  .input-bg.name:before {\n    content: \"\\f007\";\n  }\n\n  .input-bg.password:before {\n    content: \"\\f023\";\n  }\n\n  .btn-default {\n    background-color: #74cf59;\n    color: #fff;\n    border-color: #74cf59;\n  }\n\n  .btn {\n    padding: 9px 20px;\n    font-family: \"montserratlight\", Helvetica Neue, Helvetica, Arial, sans-serif;\n    border-radius: 2px;\n    transition: all 0.25s ease-in-out;\n  }\n\n  .btn.btn-inverse {\n    border: 1px solid #b7c0c5;\n    color: #5e666d;\n    font-size: 14px;\n  }\n\n  @media only screen and (max-width: 1024px) {\n    .login-wrap {\n      max-width: 700px;\n    }\n  }\n\n  @media only screen and (max-width: 979px) {\n    .login-wrap {\n      max-width: 600px;\n    }\n  }\n\n  @media only screen and (max-width: 767px) {\n    .login-area {\n      padding: 0 20px;\n    }\n    .login-wrap {\n      max-width: none;\n    }\n    .login-content {\n      padding: 60px;\n      max-width: none;\n    }\n  }\n\n  @media only screen and (max-width: 639px) {\n    .input-submit {\n      margin: 25px 0 0;\n    }\n    .login-content a.f-pass {\n      float: none !important;\n      margin: 0 0 20px;\n      text-align: center;\n    }\n    .login-content a.f-pass br {\n      display: none;\n    }\n    .login-content input[type=\"submit\"] {\n      margin: 0 auto;\n      display: block;\n      float: none !important;\n    }\n  }\n\n  @media only screen and (max-width: 479px) {\n    .login-content {\n      padding: 25px;\n    }\n    .signup-area span {\n      display: block;\n      font-size: 14px;\n      line-height: normal;\n      margin: 0 0 15px;\n      text-align: center;\n    }\n    .signup-area .btn.btn-default {\n      display: block;\n      float: none !important;\n      margin: 0 auto;\n    }\n  }\n\n  /* Alert */\n  .alert {\n    margin-top: 10px;\n    padding: 20px;\n    background-color: #f44336; /* Red */\n    color: white;\n    margin-bottom: 15px;\n  }\n\n  /* The close button */\n  .closebtn {\n    margin-left: 15px;\n    color: white;\n    font-weight: bold;\n    float: right;\n    font-size: 22px;\n    line-height: 20px;\n    cursor: pointer;\n    transition: 0.3s;\n  }\n\n  /* When moving the mouse over the close button */\n  .closebtn:hover {\n    color: black;\n  }\n\n  .header-top {\n    padding: 10px 20px;\n    background-color: #fff;\n  }\n\n  .top-right {\n    margin: 5px 0px;\n  }\n\n  .top-menu {\n    float: right;\n    margin: 10px 30px 6px 0px;\n  }\n\n  .top-menu ul {\n    padding: 0px;\n    margin: 0px;\n    list-style: none;\n  }\n\n  .top-menu li {\n    display: block;\n    float: left;\n    margin: 0px 12px;\n  }\n\n  .top-menu li a {\n    display: inline-block;\n    color: #5e666d;\n    font-size: 17px;\n    font-weight: 300;\n    padding-bottom: 3px;\n    border-bottom: 2px solid transparent;\n  }\n\n  .top-menu li a:hover {\n    border-bottom-color: #74cf59;\n  }\n\n  .top-menu li.active a {\n    border-bottom-color: #74cf59;\n    font-weight: 700;\n  }\n\n  .navbar-toggle .icon-bar {\n    background-color: #74cf59;\n  }\n\n  .header-login-btn {\n    margin-top: 7px;\n  }\n\n  .header-login-btn a {\n    width: 105px;\n    margin-left: 6px;\n    font-weight: 700;\n  }\n\n  @media (max-width: 991px) {\n    .top-menu {\n      margin-right: 15px;\n    }\n    .top-menu li a {\n      font-size: 14px;\n    }\n    .header-login-btn a {\n      padding: 9px;\n      width: auto;\n    }\n    .top-menu {\n      margin-right: 0;\n    }\n  }\n\n  @media (max-width: 767px) {\n    .navbar-toggle {\n      margin-right: 0px;\n    }\n    .header-top {\n      z-index: 130;\n      position: relative;\n    }\n    .top-menu {\n      background: #f8fcff;\n      float: none;\n      left: 0;\n      margin: 0;\n      position: absolute;\n      top: 100%;\n      width: 100%;\n      padding: 15px 10px 0;\n      border-top: 1px solid #eeeeee;\n      display: none;\n    }\n    .top-menu li {\n      float: none;\n    }\n    .top-menu li a {\n      display: block;\n      margin-bottom: 5px;\n    }\n    .navbar-toggle {\n      position: absolute;\n      top: 12px;\n      right: 5px;\n    }\n    .header-login-btn {\n      margin-left: 20px;\n      margin-right: 40px;\n    }\n    .header-login-btn a {\n      width: 90px;\n    }\n  }\n\n  @media (max-width: 406px) {\n    .header-login-btn {\n      margin: 0;\n    }\n    .header-login-btn a {\n      margin-top: 20px;\n      width: 130px;\n    }\n  }\n</style>\n\n<jobbleheader></jobbleheader>\n\n<section class=\"login-area\">\n  <div class=\"login-wrap\">\n    <h2>Recover Password</h2>\n    <div class=\"login-container\">\n      <div class=\"login-content\">\n        <p>A recovery link has been sent to {{vm.recover_email}}. Didn't get it?</p>\n\n        <form ng-submit=\"vm.submitRecoverLink()\">\n          <div ng-show=\"vm.result.status == 'error'\" class=\"alert-box\">\n            <p>{{vm.result.message}}</p>\n          </div>\n\n          <div class=\"input-submit\">\n            <input type=\"submit\" class=\"btn btn-default\" style=\"margin: 0 auto\" value=\"Re-send email\" />\n          </div>\n        </form>\n      </div>\n    </div>\n\n    <!--\n        <div class=\"login-footer\">\n        \t<div class=\"signup-area\">\n        \t\n            \t<span>I'm a New User</span>\n            \t<a href=\"/onboarding1\" class=\"btn btn-default pull-right\" ng-click=\"vm.logOnboardingTracking()\">Post a job</a>\n            \t\n            </div>\n            \n            <div class=\"login-meta\">\n            \t<a target=\"true\" href=\"https://jobble.zendesk.com/hc/en-us/categories/202999788-Jobbler-Resources\">Looking to hire event help?</a>\n            </div>\n            \n        </div>\n        -->\n  </div>\n</section>\n\n<globalalert></globalalert>\n<jobblefooter></jobblefooter>\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n\n<!--\n<div id=\"wrapper\">\n  <div class=\"signup-box\">\n    <div class=\"signup-logo odd\">\n      <a href=\"#\"><img src=\"/app/vendor/images/signup-logo.png\" alt=\"\"></a>\n    </div>\n    <div class=\"form-space\">\n      <p>A recovery link has been sent to {{vm.recover_email}}</p>\n      <p><span>Didn’t get it?</span></p>\n      <form ng-submit=\"vm.submitRecoverLink()\" >\n        <input type=\"submit\" class=\"btn btn-nobg\" value=\"Re-send email\">\n      </form>\n      <div class=\"group-btn clearfix\">\n        <a href=\"/signup\">Create Account</a>\n        <a href=\"/signin\">Sign In</a>\n      </div>\n    </div>\n  </div>\n</div>\n<globalalert></globalalert>\n<jobblefooter></jobblefooter>\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n\n-->\n"

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RecoverpasswordsuccessController = function () {
	  function RecoverpasswordsuccessController($http, $localStorage, $state, AuthService, $timeout, EnvService) {
	    _classCallCheck(this, RecoverpasswordsuccessController);
	
	    this.name = "recoverpasswordsuccess";
	    $localStorage.activeStateName = "events";
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$timeout = $timeout;
	    this.$env = EnvService;
	
	    this.recover_email = this.$auth.getRecoverEmail();
	    this.message = "A recovery link has been sent to " + this.recover_email;
	    this.remain_loading_count = 0;
	
	    // $('body').removeClass().addClass('signup-bg');
	  }
	
	  _createClass(RecoverpasswordsuccessController, [{
	    key: "resendForgotEmail",
	    value: function resendForgotEmail() {
	      this.$state.go("recoverpassword");
	    }
	  }, {
	    key: "submitRecoverLink",
	    value: function submitRecoverLink() {
	      var _this = this;
	
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "register/forgotPassword?format=json&username=" + this.recover_email,
	        data: {}
	      };
	
	      _this.remain_loading_count++;
	      this.$http(req).then(function (data) {
	        console.log(data);
	        _this.remain_loading_count--;
	        _this.result.status = data.data.status;
	        _this.result.message = data.data.message;
	        if (data.data.status == "error") {
	          _this.message = "A recovery link has not been sent to " + _this.recover_email;
	          return;
	        }
	        _this.message = "A recovery link has been sent to " + _this.recover_email;
	      }, function (data) {
	        console.log(data);
	        _this.remain_loading_count--;
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }]);
	
	  return RecoverpasswordsuccessController;
	}();
	
	RecoverpasswordsuccessController.$inject = ["$http", "$localStorage", "$state", "auth", "$timeout", "env"];
	
	exports.default = RecoverpasswordsuccessController;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(407);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./recoverpasswordsuccess.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./recoverpasswordsuccess.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "recoverpasswordsuccess footer{background:none}", ""]);
	
	// exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _onboarding = __webpack_require__(409);
	
	var _onboarding2 = _interopRequireDefault(_onboarding);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onboarding1Module = _angular2.default.module("onboarding1", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("onboarding1", {
	    url: "/onboarding1",
	    template: "<onboarding1></onboarding1>"
	    //params: { FirstName : null, LastName : null, CompanyName : null, Phone : null, Email : null, Password : null }
	  });
	}).component("onboarding1", _onboarding2.default);
	
	exports.default = onboarding1Module;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _onboarding = __webpack_require__(410);
	
	var _onboarding2 = _interopRequireDefault(_onboarding);
	
	var _onboarding3 = __webpack_require__(411);
	
	var _onboarding4 = _interopRequireDefault(_onboarding3);
	
	__webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onboarding1Component = {
	  restrict: "E",
	  bindings: {},
	  template: _onboarding2.default,
	  controller: _onboarding4.default,
	  controllerAs: "vm"
	};
	
	exports.default = onboarding1Component;

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	module.exports = "<style>\n  .jobble-walkthrough {\n    background-color: #3b3f43;\n    height: 150vh;\n    text-align: center;\n    padding: 72px 0 30px 0;\n  }\n\n  .jobble-walkthrough h3 {\n    color: #ffffff;\n    font-size: 22px;\n    font-weight: 700;\n    margin: 0 0 16px 0;\n  }\n\n  .jobble-walkthrough h4 {\n    color: #ffffff;\n    font-family: Montserrat;\n    font-size: 20px;\n    font-weight: 300;\n  }\n\n  .jobble-figure-box {\n    border-radius: 22px;\n    background-color: #ffffff;\n    max-width: 800px;\n    margin: 40px auto 25px;\n    position: relative;\n  }\n\n  .jobble-stape {\n    background-color: #3b3f43;\n    position: absolute;\n    border-radius: 100%;\n    width: 80px;\n    height: 80px;\n    left: 50%;\n    top: -40px;\n    margin-left: -40px;\n    line-height: 80px;\n    color: #ffffff;\n    font-family: Montserrat;\n    font-size: 30px;\n    font-weight: 900;\n  }\n\n  .btn-default:hover,\n  .btn-default:focus,\n  .btn-default.active {\n    background-color: #5e666d;\n    color: #fff;\n    border-color: #5e666d;\n  }\n\n  .btn-default {\n    background-color: #74cf59;\n    color: #fff;\n    border-color: #74cf59;\n  }\n\n  .jobble-button-box {\n    text-align: center;\n    padding: 24px 0 0 0;\n  }\n  .jobble-button-box .btn {\n    margin: 0 5px;\n    min-width: 188px;\n  }\n  .btn-border {\n    border: #787c7f 1px solid;\n    color: #ffffff;\n    min-width: 188px;\n  }\n  .btn-border.btn:focus,\n  .btn-border.btn:hover {\n    border: #ffffff 1px solid;\n    color: #ffffff;\n  }\n  .left-align-btn {\n    text-align: left;\n    min-width: 188px;\n    color: #ffffff;\n    position: relative;\n  }\n\n  .left-align-btn:after {\n    /*background: url(../../assets/images/icon-right.png) no-repeat center center;*/\n    position: absolute;\n    content: \"\";\n    width: 13px;\n    height: 14px;\n    display: block;\n    right: 10px;\n    top: 13px;\n  }\n\n  @media (max-width: 480px) {\n    .jobble-stape {\n      font-size: 18px;\n      font-weight: 900;\n      height: 50px;\n      left: 50%;\n      line-height: 50px;\n      margin-left: -25px;\n      top: -25px;\n      width: 50px;\n    }\n\n    .jobble-button-box .btn {\n      padding: 6px 20px;\n    }\n\n    .jobble-button-box .btn {\n      min-width: 114px;\n    }\n\n    .left-align-btn::after {\n      top: 9px;\n    }\n    .jobble-walkthrough {\n      height: 100%;\n      padding-bottom: 150px;\n    }\n  }\n</style>\n\n<jobbleheader></jobbleheader>\n<div class=\"jobble-walkthrough\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-lg-12\">\n        <h3>Welcome to Jobble!</h3>\n        <h4>Manage all your positions, whether you're filling a shift, recruiting active job seekers or looking for delivery drivers.</h4>\n        <div class=\"jobble-button-box clearfix\">\n          <a href=\"/post-event?tut=1\" ng-click=\"vm.logOnboardingTracking(1)\" class=\"btn btn-border\">Skip</a>\n          <a href=\"/onboarding2\" ng-click=\"vm.logOnboardingTracking(2)\" class=\"btn btn-default left-align-btn\">Next</a>\n          <!-- ui-sref=\"app.tutorial.walkthrough2\" -->\n        </div>\n        <div class=\"jobble-figure-box\">\n          <div class=\"jobble-stape\">1</div>\n          <a href=\"#\">\n            <img src=\"/app/vendor/images/tutorial1new.png\" alt=\"\" />\n          </a>\n        </div>\n\n        <!--\n                <div class=\"jobble-button-box clearfix\">\n                \t<a href=\"/post-event?tut=1\" ng-click=\"vm.logOnboardingTracking(1)\" class=\"btn btn-border\">Skip</a>\n                    <a href=\"/onboarding2\" ng-click=\"vm.logOnboardingTracking(2)\" class=\"btn btn-default left-align-btn\">Next</a>\n                </div>\n                -->\n      </div>\n    </div>\n  </div>\n</div>\n<jobblefooter></jobblefooter>\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Onboarding1Controller = function () {
	  function Onboarding1Controller($http, $state, $scope, $stateParams, $location, $timeout, AuthService, $rootScope, $cookies, TrackingService) {
	    _classCallCheck(this, Onboarding1Controller);
	
	    this.name = "onboarding1";
	    this.$http = $http;
	    this.$state = $state;
	    this.$cookies = $cookies;
	    this.$stateParams = $stateParams;
	    this.$location = $location;
	    this.$scope = $scope;
	    this.$auth = AuthService;
	    this.$rootScope = $rootScope;
	    this.currentUser = this.$auth.getUserData();
	    this.$tracking = TrackingService;
	    this.$timeout = $timeout;
	    this.remain_loading_count = 0;
	    this.postType = undefined;
	    this.user = {
	      phoneMobile: null,
	      companyName: null,
	      firstName: null,
	      lastName: null,
	      username: null,
	      password: null
	    };
	    if (this.$location.$$search.type === "connect") {
	      this.postType = "source";
	      this.$rootScope.postTypeForOnoarding = "source";
	    }
	
	    var _this = this;
	
	    _this.$timeout(function () {
	      $("body").removeClass();
	    });
	
	    console.log("what is the post type ");
	    console.dir(_this.postType);
	    console.dir(this.$location.$$search.FirstName);
	    console.dir(this.$location.$$search.type);
	    console.log("this.currentUser");
	    console.dir(this.currentUser);
	
	    _this.updateCurrentUserListener = _this.$rootScope.$on("UpdateCurrentUser", function (event, params) {
	      _this.updateCurrentUser(params);
	    });
	
	    _this.$scope.$on("$destroy", _this.updateCurrentUserListener);
	
	    if (this.$location.$$search.FirstName) {
	      console.log("what is this shit");
	      console.dir(this.$location.$$search.Email);
	      this.user.phoneMobile = this.$location.$$search.Phone;
	      this.user.companyName = this.$location.$$search.CompanyName;
	      this.user.firstName = this.$location.$$search.FirstName;
	      this.user.lastName = this.$location.$$search.LastName;
	      this.user.username = decodeURIComponent(this.$location.$$search.Email);
	      this.user.email = decodeURIComponent(this.$location.$$search.Email);
	      this.user.password = this.$location.$$search.Password;
	      _this.$timeout(function () {
	        _this.$location.search("FirstName", null);
	        _this.$location.search("LastName", null);
	        _this.$location.search("CompanyName", null);
	        _this.$location.search("Email", null);
	        _this.$location.search("Password", null);
	        _this.$location.search("Phone", null);
	      }, 100);
	      _this.registerNewMarketingSiteUser();
	      //_this.remain_loading_count--;
	      _this.$timeout(function () {});
	    }
	  }
	
	  _createClass(Onboarding1Controller, [{
	    key: "signInWithNewMarketingSiteUser",
	    value: function signInWithNewMarketingSiteUser() {
	      var _this = this;
	      _this.$auth.lazySignin(_this.user).then(function (data) {
	        if (data.statusText == "OK") {
	          _this.$timeout(function () {
	            _this.currentUser = data.data;
	            console.log("here is what we are sending to tracking");
	            console.dir(data.data);
	            _this.$tracking.reportUserRegistration(data.data);
	            _this.$tracking.reportUserLogin(data.data);
	            _this.$tracking.reportMarketingRegistration(data.data);
	            _this.$tracking.reportMarketingSignIn(data.data);
	            _this.$rootScope.$emit("UpdateCurrentUser", {
	              user: data.data
	            });
	          }, 100);
	          _this.$timeout(function () {
	            //_this.remain_loading_count++;
	          }, 1100);
	        } else {
	          alert("error: " + data.statusText);
	        }
	      }, function (data) {
	        _this.$timeout(function () {
	          //_this.remain_loading_count++;
	          jQuery("#show-application-alert").trigger("click");
	          alert("there was an error :" + data);
	        }, 100);
	      });
	    }
	  }, {
	    key: "registerNewMarketingSiteUser",
	    value: function registerNewMarketingSiteUser() {
	      var _this = this;
	
	      console.log("what is the user");
	      console.dir(_this.user);
	
	      _this.$timeout(function () {
	        var cookies = _this.$cookies.getAll();
	
	        var hub = _this.$cookies.get("hubspotutk");
	
	        var marketingParams = "&";
	
	        if (cookies.hubspotutk) {
	          marketingParams = marketingParams + "hubspotutk=" + cookies.hubspotutk + "&";
	        }
	        if (_this.$location.$$search.utm_campaign) {
	          marketingParams = marketingParams + "utm_campaign=" + _this.$location.$$search.utm_campaign + "&";
	        }
	        if (_this.$location.$$search.utm_medium) {
	          marketingParams = marketingParams + "utm_medium=" + _this.$location.$$search.utm_medium + "&";
	        }
	        if (_this.$location.$$search.utm_source) {
	          marketingParams = marketingParams + "utm_source=" + _this.$location.$$search.utm_source + "&";
	        }
	        if (_this.$location.$$search.utm_term) {
	          marketingParams = marketingParams + "utm_term=" + _this.$location.$$search.utm_term + "&";
	        }
	        if (_this.$location.$$search.utm_content) {
	          marketingParams = marketingParams + "utm_content=" + _this.$location.$$search.utm_content + "&";
	        }
	
	        var marketingParamsSubgStr = marketingParams.substring(marketingParams.length - 1, marketingParams);
	
	        _this.$auth.lazyReg(_this.user, marketingParamsSubgStr).then(function (data) {
	          console.log("response from registering");
	          console.dir(data);
	          if (data.data.status == "OK") {
	            _this.signInWithNewMarketingSiteUser();
	          } else {
	            console.log("what is the data");
	            console.dir(data);
	            if (data.data.message.indexOf("Duplicate entry") > -1) {
	              alert("This username you attempte to sign up with already exists. Please try another after posting the job.");
	            } else {
	              alert("There was an error with your registration. Please continue posting.");
	            }
	            _this.$timeout(function () {
	              _this.remain_loading_count++;
	            });
	          }
	        }, function (data) {
	          _this.$timeout(function () {
	            _this.remain_loading_count++;
	            jQuery("#show-application-alert").trigger("click");
	            alert("there was an error :" + data);
	          }, 100);
	        });
	      }, 3000);
	    }
	  }, {
	    key: "updateCurrentUser",
	    value: function updateCurrentUser(params) {
	      console.log("in the controller");
	      console.dir(params);
	      var _this = this;
	      _this.$timeout(function () {
	        _this.currentUser = params.user;
	      }, 1000);
	    }
	  }, {
	    key: "logOnboardingTracking",
	    value: function logOnboardingTracking(event) {
	      var _this = this;
	      if (_this.currentUser) {
	        if (_this.currentUser.username.indexOf("jobble.com") === -1 || _this.currentUser.username.indexOf("jobbleapp.com") === -1) {
	          _this.$tracking.reportOboardingScreenOne(event);
	        }
	      } else {
	        _this.$tracking.reportOboardingScreenOne(event);
	      }
	    }
	  }]);
	
	  return Onboarding1Controller;
	}();
	
	Onboarding1Controller.$inject = ["$http", "$state", "$stateParams", "$location", "$timeout", "auth", "$rootScope", "$cookies", "tracking"];
	
	exports.default = Onboarding1Controller;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(413);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./onboarding1.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./onboarding1.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "onboarding1 #wrapper{min-height:calc(100% - 62px)}", ""]);
	
	// exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _onboarding = __webpack_require__(415);
	
	var _onboarding2 = _interopRequireDefault(_onboarding);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onboarding2Module = _angular2.default.module("onboarding2", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("onboarding2", {
	    url: "/onboarding2",
	    template: "<onboarding2></onboarding2>"
	  });
	}).component("onboarding2", _onboarding2.default);
	
	exports.default = onboarding2Module;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _onboarding = __webpack_require__(416);
	
	var _onboarding2 = _interopRequireDefault(_onboarding);
	
	var _onboarding3 = __webpack_require__(417);
	
	var _onboarding4 = _interopRequireDefault(_onboarding3);
	
	__webpack_require__(418);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onboarding2Component = {
	  restrict: "E",
	  bindings: {},
	  template: _onboarding2.default,
	  controller: _onboarding4.default,
	  controllerAs: "vm"
	};
	
	exports.default = onboarding2Component;

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	module.exports = "<style>\n  .jobble-walkthrough {\n    background-color: #3b3f43;\n    height: 150vh;\n    text-align: center;\n    padding: 72px 0 30px 0;\n  }\n\n  .jobble-walkthrough h3 {\n    color: #ffffff;\n    font-size: 22px;\n    font-weight: 700;\n    margin: 0 0 16px 0;\n  }\n\n  .jobble-walkthrough h4 {\n    color: #ffffff;\n    font-family: Montserrat;\n    font-size: 20px;\n    font-weight: 300;\n  }\n\n  .jobble-figure-box {\n    border-radius: 22px;\n    background-color: #ffffff;\n    max-width: 800px;\n    margin: 40px auto 25px;\n    position: relative;\n  }\n\n  .jobble-stape {\n    background-color: #3b3f43;\n    position: absolute;\n    border-radius: 100%;\n    width: 80px;\n    height: 80px;\n    left: 50%;\n    top: -40px;\n    margin-left: -40px;\n    line-height: 80px;\n    color: #ffffff;\n    font-family: Montserrat;\n    font-size: 30px;\n    font-weight: 900;\n  }\n\n  .btn-default:hover,\n  .btn-default:focus,\n  .btn-default.active {\n    background-color: #5e666d;\n    color: #fff;\n    border-color: #5e666d;\n  }\n\n  .btn-default {\n    background-color: #74cf59;\n    color: #fff;\n    border-color: #74cf59;\n  }\n\n  .jobble-button-box {\n    text-align: center;\n    padding: 24px 0 0 0;\n  }\n  .jobble-button-box .btn {\n    margin: 0 5px;\n    min-width: 188px;\n  }\n  .btn-border {\n    border: #787c7f 1px solid;\n    color: #ffffff;\n    min-width: 188px;\n  }\n  .btn-border.btn:focus,\n  .btn-border.btn:hover {\n    border: #ffffff 1px solid;\n    color: #ffffff;\n  }\n  .left-align-btn {\n    text-align: left;\n    min-width: 188px;\n    color: #ffffff;\n    position: relative;\n  }\n\n  .left-align-btn:after {\n    /*background: url(../../assets/images/icon-right.png) no-repeat center center;*/\n    position: absolute;\n    content: \"\";\n    width: 13px;\n    height: 14px;\n    display: block;\n    right: 10px;\n    top: 13px;\n  }\n\n  @media (max-width: 480px) {\n    .jobble-stape {\n      font-size: 18px;\n      font-weight: 900;\n      height: 50px;\n      left: 50%;\n      line-height: 50px;\n      margin-left: -25px;\n      top: -25px;\n      width: 50px;\n    }\n\n    .jobble-button-box .btn {\n      padding: 6px 20px;\n    }\n\n    .jobble-button-box .btn {\n      min-width: 114px;\n    }\n\n    .left-align-btn::after {\n      top: 9px;\n    }\n    .jobble-walkthrough {\n      height: 100%;\n      padding-bottom: 150px;\n    }\n  }\n</style>\n\n<jobbleheader></jobbleheader>\n\n<div class=\"jobble-walkthrough\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-lg-12\">\n        <h3>Welcome to Jobble!</h3>\n        <h4>Review, hire and engage with applicants all in one place!</h4>\n        <div class=\"jobble-button-box clearfix\">\n          <a href=\"/onboarding1\" class=\"btn btn-border\">Back</a>\n          <a href=\"/post-event?tut=1\" ng-click=\"vm.logOnboardingTracking(2)\" class=\"btn btn-default left-align-btn\">Next</a>\n        </div>\n        <div class=\"jobble-figure-box\">\n          <div class=\"jobble-stape\">2</div>\n          <a href=\"#\">\n            <!-- style=\"height:434px;\" -->\n            <img src=\"/app/vendor/images/tut-2.png\" alt=\"\" />\n          </a>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<jobblefooter></jobblefooter>\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Onboarding2Controller = function () {
	  function Onboarding2Controller($http, $state, $stateParams, $location, $timeout, AuthService, $rootScope, $cookies, TrackingService) {
	    _classCallCheck(this, Onboarding2Controller);
	
	    this.name = "onboarding2";
	    this.$http = $http;
	    this.$state = $state;
	    this.$cookies = $cookies;
	    this.$stateParams = $stateParams;
	    this.$location = $location;
	    this.$auth = AuthService;
	    this.$rootScope = $rootScope;
	    this.$timeout = $timeout;
	    this.currentUser = this.$auth.getUserData();
	    this.remain_loading_count = 0;
	    this.$tracking = TrackingService;
	
	    console.log("what is this shit");
	    console.dir(this.$rootScope.postTypeForOnoarding);
	
	    var _this = this;
	  }
	
	  _createClass(Onboarding2Controller, [{
	    key: "logOnboardingTracking",
	    value: function logOnboardingTracking(step) {
	      var _this = this;
	
	      if (_this.currentUser) {
	        if (_this.currentUser.username.indexOf("jobble.com") === -1 || _this.currentUser.username.indexOf("jobbleapp.com") === -1) {
	          _this.$tracking.reportOboardingScreenTwo(step);
	        }
	      } else {
	        _this.$tracking.reportOboardingScreenTwo(step);
	      }
	    }
	  }]);
	
	  return Onboarding2Controller;
	}();
	
	Onboarding2Controller.$inject = ["$http", "$state", "$stateParams", "$location", "$timeout", "auth", "$rootScope", "$cookies", "tracking"];
	
	exports.default = Onboarding2Controller;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(419);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./onboarding2.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./onboarding2.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "onboarding2 #wrapper{min-height:calc(100% - 62px)}", ""]);
	
	// exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _onboarding = __webpack_require__(421);
	
	var _onboarding2 = _interopRequireDefault(_onboarding);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onboarding3Module = _angular2.default.module("onboarding3", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("onboarding3", {
	    url: "/onboarding3",
	    template: "<onboarding3></onboarding3>"
	  });
	}).component("onboarding3", _onboarding2.default);
	
	exports.default = onboarding3Module;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _onboarding = __webpack_require__(422);
	
	var _onboarding2 = _interopRequireDefault(_onboarding);
	
	var _onboarding3 = __webpack_require__(423);
	
	var _onboarding4 = _interopRequireDefault(_onboarding3);
	
	__webpack_require__(424);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onboarding3Component = {
	  restrict: "E",
	  bindings: {},
	  template: _onboarding2.default,
	  controller: _onboarding4.default,
	  controllerAs: "vm"
	};
	
	exports.default = onboarding3Component;

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n<div id=\"wrapper\">\n  <section class=\"content upload-event\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <div class=\"full-width\">\n            <h1>What do I need to do?</h1>\n            <p>Posting your job is free, however there are a few quick steps required before you connect with our Jobbler network.</p>\n          </div>\n          <div\n            class=\"alert-box alert\"\n            ng-if=\"vm.isCompanyLogo == false && vm.uploadLogoStatus !== 1\"\n            style=\"width: 35%; margin: 0 auto; margin-bottom: 25px\"\n          >\n            <p style=\"margin: 0; padding: 0\">Please upload your company logo to continue.</p>\n          </div>\n          <div class=\"alert-box success\" ng-if=\"vm.uploadLogoStatus == 1\" style=\"width: 35%; margin: 0 auto; margin-bottom: 25px\">\n            <p style=\"margin: 0; padding: 0\">The company logo was successfully updated.</p>\n          </div>\n        </div>\n      </div>\n      <div class=\"row odd\" style=\"width: 530px; margin: 0 auto\">\n        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n          <div class=\"grid\">\n            <img\n              src=\"{{ $root.companyLogoUri ? $root.companyLogoUri : vm.currentUser.company.companyLogoUri  }}\"\n              ng-if=\"vm.uploadLogoStatus === 1 || vm.currentUser.company.companyLogoUri\"\n              alt=\"\"\n              style=\"width: 72px; height: 72px\"\n            />\n            <img\n              src=\"/app/vendor/images/post-icon-4.png\"\n              ng-if=\"vm.uploadLogoStatus === 0 && !vm.currentUser.company.companyLogoUri\"\n              alt=\"\"\n              style=\"cursor: pointer\"\n              ng-click=\"vm.openFileDialog()\"\n            />\n            <h4>Upload your company logo</h4>\n            <div class=\"alert-box alert\" style=\"background-color: #961106\" ng-if=\"vm.uploadLogoStatus == 2\">\n              <p style=\"margin: 0; padding: 0\">\n                The company logo was not successfully updated. {{vm.reason}}. Please choose an image that is a .jpg, .jpeg or .png\n              </p>\n            </div>\n            <p>Showcase your brand! Logos appear on every posting to help differentiate your company.</p>\n            <div class=\"clearfix\">\n              <a class=\"upload-btn\" href=\"\" ng-click=\"vm.openFileDialog()\" style=\"background-color: #888888\">Choose logo</a>\n              <input type=\"file\" file-model=\"vm.currentUser.companyPicture\" ng-show=\"false\" id=\"fileCompanyLogo\" />\n              <p ng-if=\"vm.currentUser.companyPicture\">\n                The name of your file is {{ vm.currentUser.companyPicture.name }} and the size is of {{ vm.currentUser.companyPicture.size }} bytes.\n              </p>\n              <button\n                style=\"display: block; border-radius: 5px; color: white; padding: 0 20px; width: 100%; height: 46px\"\n                class=\"btn\"\n                ng-if=\"vm.currentUser.companyPicture && vm.uploadLogoStatus !== 1\"\n                ng-click=\"vm.uploadCompanyProfile()\"\n              >\n                Upload\n              </button>\n            </div>\n          </div>\n        </div>\n        <!--\n        <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\">\n          <div class=\"grid\">\n            <img src=\"/app/vendor/images/post-icon-5.png\" alt=\"\">\n            <h4>Register a credit card</h4>\n            <div class=\"alert-box success\" ng-if=\"vm.registerCardStatus == 1\">\n              <p style=\"margin: 0; padding: 0;\">Credit card was successfully saved.</p>\n            </div>\n            <div class=\"alert-box alert\" ng-if=\"vm.registerCardStatus == 2\">\n              <p style=\"margin: 0; padding: 0;\">Credit card was not successfully saved.</p>\n            </div>\n            <p> <strong>This is not required.</strong> However, We will eventually need one on file when you begin to accept jobblers. You can get it out of the way now or wait to see your applicants after your post.\n            </p>\n            <div class=\"clearfix\"><a class=\"upload-btn\" href=\"#modal-add-card\" data-toggle=\"modal\">Register a credit card</a></div>\n          </div>\n        </div>\n        -->\n      </div>\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <div class=\"full-width\">\n            <a href=\"\" class=\"btn\" ng-click=\"vm.postEvent()\" ng-if=\"vm.uploadLogoStatus == 1\">Post your first job!</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n<jobblefooter></jobblefooter>\n<paymentdialog></paymentdialog>\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Onboarding3Controller = function () {
	  function Onboarding3Controller($http, $localStorage, $state, AuthService, CompaniesService, SecurityService, $timeout, $rootScope, EnvService) {
	    _classCallCheck(this, Onboarding3Controller);
	
	    this.name = "onboarding3";
	
	    /*
	    if (!AuthService.isLoggedIn()) {
	    $state.go('signin');
	    return;
	    };
	    */
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$auth = AuthService;
	    this.$companies = CompaniesService;
	    this.$security = SecurityService;
	    this.$rootScope = $rootScope;
	    this.$env = EnvService;
	    this.currentUser = this.$auth.getUserData();
	    this.remain_loading_count = 0;
	    // 0: nothing, 1: success to upload, 2: failed to upload
	    this.uploadLogoStatus = 0;
	
	    // 0: nothing, 1: success to register, 2: failed to register
	    this.registerCardStatus = 0;
	    this.isCompanyLogo = true;
	
	    var _this = this;
	    this.$rootScope.$on("SetRegisterCardStatus", function ($event, params) {
	      _this.registerCardStatus = params.status;
	      if (_this.registerCardStatus == 1) {
	        _this.$timeout(function () {
	          _this.$auth.reloadCurrentUser();
	        }, 100);
	      }
	    });
	    if (_this.currentUser) {
	      if (_this.currentUser.companyProfilePictureUrl) {
	        _this.currentUser.companyProfilePictureUrl = _this.currentUser.company.companyLogoUri;
	      }
	    } else {
	      this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
	    }
	  }
	
	  _createClass(Onboarding3Controller, [{
	    key: "openFileDialog",
	    value: function openFileDialog() {
	      jQuery("#fileCompanyLogo").trigger("click");
	    }
	  }, {
	    key: "uploadCompanyProfile",
	    value: function uploadCompanyProfile() {
	      var uploadUrlCompany = this.$env.getAPIEndPoint() + "jbl/v1/companies/" + this.currentUser.companyId + "/files?format=json&fileType=9&replace=true";
	      this.fileToUploadCompany(this.currentUser.companyPicture, uploadUrlCompany);
	    }
	  }, {
	    key: "fileToUploadCompany",
	    value: function fileToUploadCompany(file, uploadUrlCompany) {
	      var _this = this;
	      var fd = new FormData();
	      fd.append("file", file);
	      this.uploadLogoStatus = 0;
	      _this.remain_loading_count++;
	      _this.$http.post(uploadUrlCompany, fd, {
	        transformRequest: _angular2.default.identity,
	        headers: {
	          "Content-Type": undefined,
	          Authorization: "Bearer " + _this.currentUser.access_token
	        }
	      }).success(function (callback) {
	        console.log("what is the callback?");
	        console.dir(callback);
	        if (callback.status === "error") {
	          console.log("in error?");
	          _this.remain_loading_count--;
	          _this.reason = callback.message;
	          _this.uploadLogoStatus = 2;
	        } else {
	          _this.currentUser.company.companyLogoUri = callback.mainFile.url;
	          var photoLoop = function photoLoop(value) {
	            _this.$timeout(function () {
	              var reloadedUser = _this.$auth.reloadCurrentUser();
	
	              if (callback.mainFile.url === reloadedUser.$$state.value.company.companyLogoUri) {
	                _this.remain_loading_count--;
	                _this.uploadLogoStatus = 1;
	                _this.$localStorage.logged_user = reloadedUser.$$state.value;
	                _this.$rootScope.companyLogoUri = reloadedUser.$$state.value.company.companyLogoUri;
	                _this.currentUser.company.companyLogoUri = reloadedUser.$$state.value.company.companyLogoUri;
	              } else {
	                return photoLoop(value - 1);
	              }
	            }, 2000);
	          };
	          photoLoop(10);
	        }
	      }).error(function (callback) {
	        _this.remain_loading_count--;
	        _this.uploadLogoStatus = 2;
	        console.log("fail company logo upload");
	        console.dir(callback);
	      });
	    }
	  }, {
	    key: "postEvent",
	    value: function postEvent() {
	      var _this = this;
	      if (!this.$security.isUndefinedOrNull(this.currentUser.company) && this.$security.isUndefinedOrNull(this.currentUser.company.companyLogoUri)) {
	        this.isCompanyLogo = false;
	      } else {
	        this.$state.go("postevent");
	      }
	    }
	  }]);
	
	  return Onboarding3Controller;
	}();
	
	Onboarding3Controller.$inject = ["$http", "$localStorage", "$state", "auth", "companies", "security", "$timeout", "$rootScope", "env"];
	
	exports.default = Onboarding3Controller;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(425);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./onboarding3.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./onboarding3.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "onboarding3 #wrapper{min-height:calc(100% - 62px)}", ""]);
	
	// exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _eventoverview = __webpack_require__(427);
	
	var _eventoverview2 = _interopRequireDefault(_eventoverview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventoverviewModule = _angular2.default.module("eventoverview", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("eventoverview", {
	    url: "/event/:eventId/overview",
	    template: "<eventoverview></eventoverview>"
	  });
	}).component("eventoverview", _eventoverview2.default);
	
	exports.default = eventoverviewModule;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventoverview = __webpack_require__(428);
	
	var _eventoverview2 = _interopRequireDefault(_eventoverview);
	
	var _eventoverview3 = __webpack_require__(429);
	
	var _eventoverview4 = _interopRequireDefault(_eventoverview3);
	
	__webpack_require__(430);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventoverviewComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _eventoverview2.default,
	  controller: _eventoverview4.default,
	  controllerAs: "vm"
	};
	
	exports.default = eventoverviewComponent;

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<!------------------- Banner-Status --------------------->\n<div class=\"jobs-complete-banner\"></div>\n<!------------------- Banner-Status --------------------->\n\n<!--------------------- Container --------------------->\n<div class=\"jobs-complete-container\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\">\n        <div class=\"back-to-jobs\">\n          <a href=\"/jobs-dashboard\">Back to Jobs</a>\n        </div>\n        <!--Sidebar-->\n        <eventsidebar></eventsidebar>\n        <!--Sidebar-->\n      </div>\n\n      <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\">\n        <div class=\"jobs-overview-content\">\n          <div class=\"jobs-overview-content-inner\">\n            <div class=\"overview-image-large\">\n              <img\n                src=\"{{ vm.event.subEvents[0].deduppedJobbles[0].jobbleType.picture1 ? vm.event.subEvents[0].deduppedJobbles[0].jobbleType.picture1 : '/app/vendor/images/default-jobble-image.jpeg' }}\"\n                alt=\"Jobble Biz\"\n                title=\"Jobble Biz\"\n              />\n\n              <div class=\"jobs-overview-top-all\">\n                <nav class=\"jobs-overview-nav\"></nav>\n                <h1>{{vm.event.name}}</h1>\n              </div>\n            </div>\n            <div class=\"jobs-overview-box\" ng-show=\"vm.delivery\">\n              <img style=\"margin-top: 10px; width: 75px\" src=\"/app/vendor/images/exclusive.png\" ng-if=\"vm.isPrivate\" />\n              <label style=\"display: block; border-bottom: 1px solid #eee; padding-bottom: 3px\">Description</label>\n              <p>{{vm.event.description ? vm.event.description : \"--\" }}</p>\n              <label style=\"display: block; border-bottom: 1px solid #eee; padding-bottom: 3px\">Pick-up instructions</label>\n              <p>\n                {{vm.event.subEvents[0].deduppedJobbles[0].shifts[0].description?vm.event.subEvents[0].deduppedJobbles[0].shifts[0].description: \"--\"\n                }}\n              </p>\n              <label style=\"display: block; border-bottom: 1px solid #eee; padding-bottom: 3px\">Drop-off instructions</label>\n              <p>\n                {{vm.event.subEvents[0].deduppedJobbles[0].shifts[1].description?vm.event.subEvents[0].deduppedJobbles[0].shifts[1].description : \"--\"\n                }}\n              </p>\n            </div>\n\n            <div class=\"jobs-overview-box\" ng-hide=\"vm.delivery\">\n              <img style=\"margin-top: 10px; width: 75px\" src=\"/app/vendor/images/exclusive.png\" ng-if=\"vm.isPrivate\" />\n              <ul class=\"teams-list\" ng-if=\"vm.isPrivate\">\n                <li>\n                  <strong><u>Teams</u></strong>\n                </li>\n                <li ng-repeat=\"c in vm.circ_names\">{{c}}</li>\n              </ul>\n\n              <label style=\"display: block; border-bottom: 1px solid #eee; padding-bottom: 3px\">Description</label>\n              <p>{{vm.event.description }}</p>\n            </div>\n\n            <div class=\"jobs-overview-review\" ng-hide=\"vm.delivery\">\n              <span ng-if=\"!vm.event.isSourcingPost\">{{ vm.event.numberOfOpenings }}<small>Openings</small></span>\n              <span ng-if=\"!vm.event.isSourcingPost\">{{ vm.event.numberOfPendingApplications}}<small>Applications</small></span>\n              <span ng-if=\"vm.event.isSourcingPost\">{{ vm.event.numberOfPendingApplications}}<small>Under Review</small></span>\n              <span>{{ vm.event.numberOfApprovedApplications}}<small>Accepted</small></span>\n              <a class=\"btn button overview-review-btn-sourcing\" href=\"/event/{{ vm.event.id }}/roster\">Download Roster</a>\n            </div>\n\n            <div class=\"overview-review-table-box clearfix\" ng-if=\"!vm.event.isSourcingPost\" ng-show=\"vm.delivery\">\n              <div class=\"jobs-overview-table-left\">\n                <table class=\"table table-responsive jobs-overview-border-none\">\n                  <thead>\n                    <tr>\n                      <th></th>\n                      <th>DELIVERY COST</th>\n                      <th></th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                    <tr>\n                      <td class=\"\">Totals</td>\n                      <td class=\"overview-review-bold\">${{vm.event.subEvents[0].deduppedJobbles[0].payPerHour / 100 | number : 2}}</td>\n                      <td class=\"overview-review-bold\"></td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n\n              <div class=\"jobs-overview-table-right\">\n                <table class=\"table table-responsive jobs-overview-border-none\">\n                  <thead>\n                    <tr>\n                      <!--<th class=\"overview-review-th\" ng-if=\"!vm.event.isSourcingPost\">1DRESS CODE</th>-->\n                      <th class=\"overview-review-th\">Job Type</th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                    <tr>\n                      <!--<td ng-if=\"!vm.event.isSourcingPost\">{{ vm.event.subEvents[0].deduppedJobbles[0].dressCode ? vm.event.subEvents[0].deduppedJobbles[0].dressCode : '--' }}</td>-->\n                      <td>{{ vm.event.subEvents[0].deduppedJobbles[0].jobbleType.name }}</td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div>\n\n            <div class=\"overview-review-table-box clearfix\" ng-if=\"!vm.event.isSourcingPost\" ng-hide=\"vm.delivery\">\n              <div class=\"jobs-overview-table-left\">\n                <table class=\"table table-responsive jobs-overview-border-none\">\n                  <thead>\n                    <tr>\n                      <th></th>\n                      <th>YOU PAY</th>\n                      <th>JOBBLERS MAKE</th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                    <tr>\n                      <td>Hourly</td>\n                      <td>${{ vm.event.subEvents[0].deduppedJobbles[0].payPerHour / 100 | number : 2 }}/hr</td>\n                      <td>${{ vm.event.subEvents[0].deduppedJobbles[0].jobblerRate / 100 | number : 2 }}/hr</td>\n                    </tr>\n                  </tbody>\n                </table>\n\n                <table class=\"table table-responsive jobs-overview-border-none\">\n                  <thead>\n                    <tr>\n                      <th></th>\n                      <th>CURRENT COST</th>\n                      <th>POTENTIAL COST</th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                    <tr>\n                      <td class=\"\">Totals</td>\n                      <td class=\"overview-review-bold\">\n                        {{ vm.getCost(vm.event.totalNumberOfJobbles, vm.event.numberOfApprovedApplications,\n                        vm.event.subEvents[0].deduppedJobbles[0].payPerHour, vm.event.subEvents[0].deduppedJobbles[0].jobbleDurationInMinutes, 1) }}\n                      </td>\n                      <td class=\"overview-review-bold\">\n                        {{ vm.getCost(vm.event.totalNumberOfJobbles, vm.event.numberOfApprovedApplications,\n                        vm.event.subEvents[0].deduppedJobbles[0].payPerHour, vm.event.subEvents[0].deduppedJobbles[0].jobbleDurationInMinutes, 2) }}\n                      </td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n              <div class=\"jobs-overview-table-right\">\n                <table class=\"table table-responsive jobs-overview-border-none\">\n                  <thead>\n                    <tr>\n                      <!--<th class=\"overview-review-th\" ng-if=\"!vm.event.isSourcingPost\">1DRESS CODE</th>-->\n                      <th class=\"overview-review-th\">Job Type</th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                    <tr>\n                      <!--<td ng-if=\"!vm.event.isSourcingPost\">{{ vm.event.subEvents[0].deduppedJobbles[0].dressCode ? vm.event.subEvents[0].deduppedJobbles[0].dressCode : '--' }}</td>-->\n                      <td>{{ vm.event.subEvents[0].deduppedJobbles[0].jobbleType.name }}</td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div>\n\n            <div class=\"overview-review-table-box clearfix\" ng-if=\"vm.event.isSourcingPost\" ng-hide=\"vm.delivery\">\n              <div class=\"jobs-overview-table-left\">\n                <table class=\"table table-responsive jobs-overview-border-none\">\n                  <thead>\n                    <tr>\n                      <th></th>\n                      <th>YOU PAY</th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                    <tr>\n                      <td>Wage</td>\n                      <td ng-if=\"vm.event.subEvents[0].deduppedJobbles[0].payPerHour > 0\">\n                        ${{ vm.event.subEvents[0].deduppedJobbles[0].payPerHour / 100 | number : 2 }}/hr\n                      </td>\n                      <td ng-if=\"vm.event.subEvents[0].deduppedJobbles[0].payPerHour == 0\">N/A</td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n              <div class=\"jobs-overview-table-right\">\n                <table class=\"table table-responsive jobs-overview-border-none\">\n                  <thead>\n                    <tr>\n                      <th class=\"overview-review-th\">Job Type</th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                    <tr>\n                      <td>{{ vm.event.subEvents[0].deduppedJobbles[0].jobbleType.name }}</td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div>\n\n            <hr class=\"overview-review-hr\" ng-if=\"!vm.event.isSourcingPost\" ng-hide=\"vm.delivery\" />\n\n            <div class=\"overview-review-table-box clearfix\" ng-if=\"!vm.event.isSourcingPost\" ng-hide=\"vm.delivery\">\n              <table class=\"table table-responsive jobs-overview-border-none\">\n                <thead>\n                  <tr>\n                    <th class=\"overview-review-th\" ng-if=\"!vm.event.isSourcingPost\">DRESS CODE</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr>\n                    <td ng-if=\"!vm.event.isSourcingPost\">\n                      {{ vm.event.subEvents[0].deduppedJobbles[0].dressCode ? vm.event.subEvents[0].deduppedJobbles[0].dressCode : '--' }}\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n\n            <div class=\"overview-review-table-box clearfix\" ng-if=\"!vm.event.isSourcingPost && vm.manager.name\">\n              <table class=\"table table-responsive jobs-overview-border-none\">\n                <thead>\n                  <tr>\n                    <th class=\"overview-review-th\">HIRING MANAGER</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr>\n                    <td>\n                      {{vm.manager.name}}<br />\n                      {{vm.formatNumber(vm.manager.phone)}}<br />\n                      {{vm.manager.email}}\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n\n            <hr class=\"overview-review-hr\" />\n\n            <div class=\"overview-review-table-box clearfix\" ng-show=\"vm.delivery\">\n              <table class=\"table table-responsive jobs-overview-border-none\" ng-if=\"!vm.event.isSourcingPost\">\n                <thead>\n                  <tr>\n                    <th style=\"width: 505px\">Address</th>\n                    <th>Start date</th>\n                    <th>Start time</th>\n                    <th>Duration</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"shift in vm.event.subEvents[0].deduppedJobbles[0].shifts track by $index\">\n                    <td style=\"max-width: 59%\">{{ shift.location }} - {{ vm.getShiftLocation(shift) }}</td>\n                    <td>{{ shift.timeInterval.startDateFormatted }}</td>\n                    <td>{{ shift.timeInterval.startTimeFormatted }} {{ vm.displayTimeZone(shift.contactInfo.timeZoneName) }}</td>\n                    <td>{{ vm.getHoursAndMintuesFromStartToEnd(shift.timeInterval.startTime, shift.timeInterval.endTime) }}</td>\n                  </tr>\n                </tbody>\n              </table>\n\n              <table class=\"table table-responsive jobs-overview-border-none\" ng-if=\"vm.event.isSourcingPost\">\n                <thead>\n                  <tr>\n                    <th>Address</th>\n                    <th>Date Posted</th>\n                    <th></th>\n                    <th>Expires</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"shift in vm.event.subEvents[0].deduppedJobbles[0].shifts\">\n                    <td>{{ vm.getShiftLocation(shift) }}</td>\n                    <td>{{ shift.timeInterval.startDateFormatted }}</td>\n                    <td>\n                      <!-- {{ shift.timeInterval.startTimeFormatted }} {{ vm.displayTimeZone(shift.contactInfo.timeZoneName) }} -->\n                    </td>\n                    <td>in {{ vm.getExipryDate(shift.timeInterval.startTime, shift.timeInterval.endTime) }} days</td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n\n            <div class=\"overview-review-table-box clearfix\" ng-hide=\"vm.delivery\">\n              <table class=\"table table-responsive jobs-overview-border-none\" ng-if=\"!vm.event.isSourcingPost\">\n                <thead>\n                  <tr>\n                    <th>Address</th>\n                    <th>Start date</th>\n                    <th>Start time</th>\n                    <th>Duration</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"shift in vm.event.subEvents[0].deduppedJobbles[0].shifts\">\n                    <td>{{ vm.getShiftLocation(shift) }}</td>\n                    <td>{{ shift.timeInterval.startDateFormatted }}</td>\n                    <td>{{ shift.timeInterval.startTimeFormatted }} {{ vm.displayTimeZone(shift.contactInfo.timeZoneName) }}</td>\n                    <td>{{ vm.getHoursAndMintuesFromStartToEnd(shift.timeInterval.startTime, shift.timeInterval.endTime) }}</td>\n                  </tr>\n                </tbody>\n              </table>\n\n              <table class=\"table table-responsive jobs-overview-border-none\" ng-if=\"vm.event.isSourcingPost\">\n                <thead>\n                  <tr>\n                    <th>Address</th>\n                    <th>Date Posted</th>\n                    <th></th>\n                    <th>Expires</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"shift in vm.event.subEvents[0].deduppedJobbles[0].shifts\">\n                    <td>{{ vm.getShiftLocation(shift) }}</td>\n                    <td>{{ shift.timeInterval.startDateFormatted }}</td>\n                    <td>\n                      <!-- {{ shift.timeInterval.startTimeFormatted }} {{ vm.displayTimeZone(shift.contactInfo.timeZoneName) }} -->\n                    </td>\n                    <td>in {{ vm.getExipryDate(shift.timeInterval.startTime, shift.timeInterval.endTime) }} days</td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n\n            <hr class=\"overview-review-hr\" ng-if=\"vm.event.numberOfApprovedApplications > 0\" />\n\n            <div class=\"overview-review-table-box clearfix\" ng-if=\"vm.loading_applicants\" style=\"text-align: center\">\n              <i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i>\n              <p>Loading accepted applicants</p>\n            </div>\n\n            <div class=\"overview-review-table-box clearfix\">\n              <ul class=\"accepted-applicants-triple-list\">\n                <li ng-repeat=\"application in vm.acceptedApplicants track by $index\">\n                  <a\n                    ng-click=\"vm.displayDetails(application, 'hired', 'open', $index, true)\"\n                    href=\"\"\n                    data-toggle=\"modal\"\n                    data-target=\"#modal-view-jobble\"\n                  >\n                    <img\n                      src=\"{{ application.applicant.filePROFILE_IMAGE1IMG_75x75 ? application.applicant.filePROFILE_IMAGE1IMG_75x75 : '/app/vendor/images/defaultimg.jpeg' }}\"\n                    />\n                    {{application.applicant.lastName}}, {{application.applicant.firstName}}\n                  </a>\n                </li>\n              </ul>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<jobblefooter></jobblefooter>\n\n<jobblerprofile></jobblerprofile>\n<eventdialog></eventdialog>\n<globalalert></globalalert>\n\n<!--<loader ng-if=\"vm.remain_loading_count != 0\"></loader>-->s\n"

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventoverviewController = function () {
	  function EventoverviewController($http, $localStorage, $state, $stateParams, AuthService, EventsService, SecurityService, $rootScope, $scope, CommonService, EnvService, $timeout, $location) {
	    _classCallCheck(this, EventoverviewController);
	
	    this.name = "eventoverview";
	    $localStorage.activeStateName = "eventoverview";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$events = EventsService;
	    this.$stateParams = $stateParams;
	    this.$location = $location;
	    this.$security = SecurityService;
	    this.$rootScope = $rootScope;
	    this.$common = CommonService;
	    this.$env = EnvService;
	    this.$timeout = $timeout;
	    this.$scope = $scope;
	    this.isPrivate = false;
	    this.isPreferred = false;
	    this.remain_loading_count = 1;
	    this.event = {};
	    this.teamsPostedTo = [];
	    this.acceptedApplicants = [];
	    this.currentUser = this.$auth.getUserData();
	
	    var _this = this;
	
	    if (_this.currentUser.username.indexOf("jobble.com") !== -1 || _this.currentUser.username.indexOf("jobbleapp.com") !== -1) {
	      _this.currentUser.isAdmin = true;
	    }
	
	    _this.$timeout(function () {
	      _this.$rootScope.$emit("SetLoaderDialog", { type: 3, total: 1 });
	    });
	
	    this.$events.getEventByIdTrimmed(this.$stateParams.eventId).then(function (data) {
	      _this.event = data.data;
	      _this.setHiringManager(_this.event.subEvents[0].deduppedJobbles[0].manager);
	
	      if (_this.event.isSourcingPost) {
	        _this.checkPayWage();
	      }
	
	      if (_this.event.isSourcingPost) {
	        _this.postType = "source";
	      } else {
	        _this.postType = "regular";
	      }
	
	      var userTimeZoneName = moment.tz.guess();
	
	      var now = moment.tz(userTimeZoneName);
	
	      if (Object.keys(_this.event.subEvents[0].deduppedJobbles[0].circles).length !== 0) {
	        try {
	          if (_this.event.subEvents[0].deduppedJobbles[0].circles && _this.event.subEvents[0].deduppedJobbles[0].forCircleOnly) {
	            _this.isPrivate = true;
	          }
	
	          if (_this.event.subEvents[0].deduppedJobbles[0].circles && !_this.event.subEvents[0].deduppedJobbles[0].forCircleOnly) {
	            _this.isPreferred = true;
	          }
	        } finally {
	          if (_this.isPreferred || _this.isPrivate) {
	            _this.event.subEvents[0].deduppedJobbles[0].circles.forEach(function (team) {
	              _this.teamsPostedTo.push(team.name);
	            });
	          }
	        }
	      }
	
	      var minutes = _this.event.subEvents[0].deduppedJobbles[0].jobbleDuration * 60;
	      var minRounder = minutes % 60;
	
	      var hours = Math.floor(minutes / 60);
	      _this.event.subEvents[0].deduppedJobbles[0].hours = hours;
	      _this.event.subEvents[0].deduppedJobbles[0].minutes = minRounder;
	
	      var userTimeZoneName = moment.tz.guess();
	      var now = moment.tz(userTimeZoneName);
	
	      try {
	        for (var x = 0; x < _this.event.subEvents[0].deduppedJobbles[0].shifts.length; x++) {
	          _this.event.subEvents[0].deduppedJobbles[0].shifts[x].contactInfo.timeZoneId = _this.event.subEvents[0].deduppedJobbles[0].shifts[x].contactInfo.place.timeZoneId;
	          var nowThere = moment.tz(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].contactInfo.timeZoneId);
	          var timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
	          var startTimeAsMoment = moment(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.startTime);
	          var endTimeAsMoment = moment(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.endTime);
	          var st = _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.startTime;
	          var et = _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.endTime;
	          var tzid = _this.event.subEvents[0].deduppedJobbles[0].shifts[x].contactInfo.timeZoneId;
	          _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.startTime = startTimeAsMoment.subtract(timeInSec, "seconds").format();
	          _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.endTime = endTimeAsMoment.subtract(timeInSec, "seconds").format();
	          _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.startTimeFormatted = moment(moment.utc(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.startTime).toDate()).format("hh:mm A");
	          _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.startDateFormatted = moment(st).tz(tzid).format("MMM DD, YYYY");
	          _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.endTime = moment(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.endTime).tz(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].contactInfo.timeZoneId).format();
	        }
	      } finally {
	        _this.sortShiftsByStartTime();
	      }
	
	      if (_this.event.status === "error") {
	        return;
	      }
	
	      _this.getApplicants();
	
	      _this.$timeout(function () {
	        _this.remain_loading_count--;
	        _this.$rootScope.$emit("SetLoaderDialog", { type: 0 });
	        _this.$rootScope.$emit("SetEventToEventDialog", {
	          event: _this.event
	        });
	        _this.$rootScope.$emit("SetEventToEventSidebar", {
	          event: _this.event
	        });
	      }, 300);
	
	      _this.$timeout(function () {
	        $("eventsidebar .jobs-complete-sidebar li:nth-child(1)").removeClass().addClass("active");
	      }, 500);
	    }, function (data) {
	      _this.remain_loading_count--;
	
	      $state.go("events");
	    });
	
	    _this.SetEventToEventPagesListener = _this.$rootScope.$on("SetEventToEventPages", function ($event, params) {
	      if (_this.event.id === params.event.id) {
	        _this.event.cost = params.event.cost;
	        if (params.openings) {
	          if (params.action === "Add") {
	            _this.event.numberOfOpenings = _this.event.numberOfOpenings + params.openings;
	          } else {
	            _this.event.numberOfOpenings = _this.event.numberOfOpenings - params.openings;
	          }
	        }
	        _this.event.totalNumberOfJobbles = params.event.totalNumberOfJobbles;
	      }
	    });
	
	    _this.SuccessToDeleteEventListener = this.$rootScope.$on("SuccessToDeleteEvent", function () {
	      _this.$state.go("jobsdashboard");
	    });
	
	    _this.$scope.$on("$destroy", _this.SetEventToEventPagesListener);
	    _this.$scope.$on("$destroy", _this.SuccessToDeleteEventListener);
	  }
	
	  _createClass(EventoverviewController, [{
	    key: "getLocation",
	    value: function getLocation() {
	      if (this.$security.isUndefinedOrNull(this.event)) {
	        return "";
	      }
	      var location = this.event.firstLocation.streetLine1;
	      if (!this.$security.isUndefinedOrNull(this.event.firstLocation.city)) {
	        location += " " + this.event.firstLocation.city;
	      }
	      if (!this.$security.isUndefinedOrNull(this.event.firstLocation.state)) {
	        location += ", " + this.event.firstLocation.state;
	      }
	
	      if (!this.$security.isUndefinedOrNull(this.event.firstLocation.zipCode)) {
	        location += " " + this.event.firstLocation.zipCode;
	      }
	
	      return location;
	    }
	  }, {
	    key: "getShiftLocation",
	    value: function getShiftLocation(shift) {
	      if (this.$security.isUndefinedOrNull(shift.contactInfo)) {
	        return "";
	      }
	      var location = shift.contactInfo.streetLine1;
	      if (!this.$security.isUndefinedOrNull(shift.contactInfo.city)) {
	        location += " " + shift.contactInfo.city;
	      }
	      if (!this.$security.isUndefinedOrNull(shift.contactInfo.state)) {
	        location += ", " + shift.contactInfo.state;
	      }
	
	      if (!this.$security.isUndefinedOrNull(shift.contactInfo.zipCode)) {
	        location += " " + shift.contactInfo.zipCode;
	      }
	
	      return location;
	    }
	  }, {
	    key: "getCurrency",
	    value: function getCurrency(cents) {
	      console.log("what are the centers");
	      console.dir(cents);
	      //console.dir(numeral(cents / 100).format('$0,0.00'));
	      return numeral(cents / 100).format("$0,0.00");
	    }
	  }, {
	    key: "getEventDate",
	    value: function getEventDate(raw_date) {
	      var date = new Date(raw_date);
	      return moment(date).format("MMM DD, YYYY");
	    }
	  }, {
	    key: "getTimeWithTimezone",
	    value: function getTimeWithTimezone(utcTimeStr) {
	      return utcTimeStr;
	    }
	  }, {
	    key: "getDurationWithHoursAndMinutes",
	    value: function getDurationWithHoursAndMinutes(totalMinutes) {
	      var hours = Math.floor(totalMinutes / 60);
	      var minutes = totalMinutes % 60;
	      return hours + "h " + minutes + "min";
	    }
	  }, {
	    key: "displayTimeZone",
	    value: function displayTimeZone(tz) {
	      if (tz === "Eastern Standard Time") {
	        return "EST";
	      }
	      if (tz === "Central Standard Time") {
	        return "CST";
	      }
	      if (tz === "Mountain Standard Time") {
	        return "MST";
	      }
	      if (tz === "Pacific Standard Time") {
	        return "PST";
	      }
	      if (tz === "Alaska Standard Time") {
	        return "AST";
	      }
	      if (tz === "Hawaii Standard Time") {
	        return "HST";
	      }
	    }
	  }, {
	    key: "getDaysFromStartToEnd",
	    value: function getDaysFromStartToEnd(startTime, endTime) {
	      var startMomentTime = moment(startTime);
	      var endMomentTime = moment(endTime);
	      var durationDays = endMomentTime.diff(startMomentTime, "days");
	
	      return durationDays;
	    }
	  }, {
	    key: "getHoursAndMintuesFromStartToEnd",
	    value: function getHoursAndMintuesFromStartToEnd(startTime, endTime) {
	      var startMomentTime = moment(startTime);
	      var endMomentTime = moment(endTime);
	      var durationMinutes = endMomentTime.diff(startMomentTime, "minutes");
	
	      return this.getDurationWithHoursAndMinutes(durationMinutes);
	    }
	  }, {
	    key: "getRatingPicUrl",
	    value: function getRatingPicUrl(application) {
	      var rating = Math.round(application.applicant.averageRatingReceived);
	      var ratingUrl;
	
	      ratingUrl = "/app/vendor/images/rating-1.png";
	      return ratingUrl;
	    }
	  }, {
	    key: "displayDetails",
	    value: function displayDetails(application, type, action, index, isLink) {
	      var _this = this;
	
	      if (type === "default" || type === "hired") {
	        if (!application.direction && !isLink) {
	          _this.$timeout(function () {
	            jQuery("#modal-view-jobble-click").trigger("click");
	          });
	        }
	      }
	
	      _this.$security.getApplicationInfoTrimmed(application).then(function (response) {
	        var jobblerData = _this.$security.getJobblerData(response.data, type, action);
	
	        jobblerData.isOverview = true;
	
	        _this.$location.search("id", jobblerData.jobblerId);
	
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("GetJobblerDataFromService", {
	            event: _this.event,
	            jobblerData: jobblerData
	          });
	          jQuery("#modal-view-jobble").focus();
	        });
	      });
	    }
	  }, {
	    key: "getCost",
	    value: function getCost(totalNumberOfJobbles, acceptedApplicantsCount, payRate, durationInMinutes, status) {
	      /*
	      console.log('totalNumberOfJobbles');
	      console.dir(totalNumberOfJobbles);
	      console.dir(acceptedApplicantsCount);
	      console.dir(payRate);
	      console.dir(durationInMinutes);
	      */
	      var cost = 0;
	
	      if (status === 1) {
	        cost = acceptedApplicantsCount * payRate * durationInMinutes / 60;
	        //console.log('here is the cost...');
	        //console.dir(cost);
	      } else {
	        cost = totalNumberOfJobbles * payRate * durationInMinutes / 60;
	      }
	
	      return numeral(cost / 100).format("$0,0.00");
	    }
	  }, {
	    key: "setJobblerRating",
	    value: function setJobblerRating(acceptedApplication) {
	      var _this = this;
	
	      if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 0) {
	        acceptedApplication.applicant.displayRating = "one";
	      }
	      if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 1) {
	        acceptedApplication.applicant.displayRating = "one";
	      }
	      if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 2) {
	        acceptedApplication.applicant.displayRating = "two";
	      }
	      if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 3) {
	        acceptedApplication.applicant.displayRating = "three";
	      }
	      if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 4) {
	        acceptedApplication.applicant.displayRating = "four";
	      }
	      if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 5) {
	        acceptedApplication.applicant.displayRating = "five";
	      }
	
	      _this.noOneAcceptedYet = false;
	      _this.acceptedApplicants.push(acceptedApplication);
	    }
	  }, {
	    key: "sortShiftsByStartTime",
	    value: function sortShiftsByStartTime() {
	      var _this = this;
	      _this.event.subEvents[0].deduppedJobbles[0].shifts.sort(function (a, b) {
	        return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
	      });
	
	      _this.checkForDelivery();
	    }
	  }, {
	    key: "checkForDelivery",
	    value: function checkForDelivery() {
	      var _this = this;
	      if (_this.event.isOrder || _this.event.orderNumber) {
	        _this.delivery = true;
	      }
	
	      _this.gatherTeamNames();
	    }
	  }, {
	    key: "gatherTeamNames",
	    value: function gatherTeamNames() {
	      var _this = this;
	      console.log("gatherTeamNames");
	      console.dir(_this.event.subEvents[0].deduppedJobbles[0].circles);
	      var circle_names = [];
	      var circles = _this.event.subEvents[0].deduppedJobbles[0].circles;
	      if (circles) {
	        if (circles.length > 0) {
	          try {
	            circles.forEach(function (circ) {
	              circle_names.push(circ.name);
	            });
	          } finally {
	            _this.circ_names = circle_names;
	            console.log("circ_names");
	            console.dir(_this.circ_names);
	          }
	        }
	      }
	    }
	  }, {
	    key: "getExipryDate",
	    value: function getExipryDate(startTime, endTime) {
	      var _this = this;
	      return moment(endTime).diff(moment(startTime), "days");
	    }
	  }, {
	    key: "checkPayWage",
	    value: function checkPayWage() {
	      var _this = this;
	    }
	  }, {
	    key: "getApplicants",
	    value: function getApplicants(offset) {
	      var _this = this;
	      console.log("getApplicants");
	      console.log(offset);
	      if (!offset) {
	        _this.loading_applicants = true;
	        offset = 0;
	      }
	      _this.$events.getAcceptedApplicationsTrimmedReview(_this.event.subEvents[0].id, 10, offset).then(function (acceptedApplications) {
	        console.log("response length");
	        console.dir(acceptedApplications.data.length);
	        console.dir(acceptedApplications.data);
	        if (acceptedApplications.data.length !== 0) {
	          try {
	            acceptedApplications.data.forEach(function (acceptedApplication) {
	              acceptedApplication.renderPhotoThumb = acceptedApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
	              acceptedApplication.renderPhoto = acceptedApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
	              _this.setJobblerRating(acceptedApplication);
	            });
	          } catch (err) {
	            console.log("err");
	            console.dir(err);
	          } finally {
	            _this.fancyLoad(".overview-review-table-box .accepted-applicants-triple-list li", _this.acceptedApplicants.length);
	            if (acceptedApplications.data.length < 10) {
	              _this.loading_applicants = false;
	              _this.sortApplicantsByName();
	            } else {
	              _this.getApplicants(_this.acceptedApplicants.length);
	            }
	          }
	        } else {
	          _this.$timeout(function () {
	            _this.loading_applicants = false;
	          }, 1500);
	        }
	      }, function (data) {
	        _this.remain_loading_count--;
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "sortApplicantsByName",
	    value: function sortApplicantsByName() {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.acceptedApplicants.sort(function (a, b) {
	          if (a.applicant.lastName < b.applicant.lastName) return -1;
	          if (a.applicant.lastName > b.applicant.lastName) return 1;
	          return 0;
	        });
	      }, 500);
	    }
	  }, {
	    key: "fancyLoad",
	    value: function fancyLoad(cls, length) {
	      var _this = this;
	      _this.$auth.fancyLoad(cls, length);
	    }
	  }, {
	    key: "setHiringManager",
	    value: function setHiringManager(manager) {
	      var _this = this;
	      if (manager.id) {
	        var manager_data = {};
	        manager_data.name = manager.firstName + " " + manager.lastName;
	        manager_data.phone = manager.homeContactInfo.phoneMobile;
	        manager_data.email = manager.email;
	
	        _this.manager = manager_data;
	      }
	    }
	  }, {
	    key: "formatNumber",
	    value: function formatNumber(number_input) {
	      if (number_input) {
	        if (number_input.length > 10) {
	          var num = number_input.length - 10;
	          number_input = number_input.substring(num, number_input.length);
	        }
	        var number = ("" + number_input).replace(/\D/g, "");
	        var m = number.match(/^(\d{3})(\d{3})(\d{4})$/);
	
	        return !m ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
	      }
	    }
	  }]);
	
	  return EventoverviewController;
	}();
	
	EventoverviewController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "events", "security", "$rootScope", "$scope", "common", "env", "$timeout", "$location"];
	
	exports.default = EventoverviewController;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(431);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventoverview.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventoverview.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "eventoverview #wrapper{min-height:calc(100% - 62px)}", ""]);
	
	// exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _inbox = __webpack_require__(433);
	
	var _inbox2 = _interopRequireDefault(_inbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inboxModule = _angular2.default.module("inbox", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("messages", {
	    url: "/messages",
	    template: "<inbox></inbox>"
	  });
	}).component("inbox", _inbox2.default);
	
	exports.default = inboxModule;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inbox = __webpack_require__(434);
	
	var _inbox2 = _interopRequireDefault(_inbox);
	
	var _inbox3 = __webpack_require__(435);
	
	var _inbox4 = _interopRequireDefault(_inbox3);
	
	__webpack_require__(436);
	
	__webpack_require__(438);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inboxComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _inbox2.default,
	  controller: _inbox4.default,
	  controllerAs: "vm"
	};
	
	exports.default = inboxComponent;

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	module.exports = "<h1>Not Found</h1>\n"

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var InboxController = function InboxController($http, $localStorage, $state, $stateParams, AuthService, EventsService, CompaniesService, SecurityService, $rootScope, CommonService, EnvService, $timeout, $location, $scope, Messagingv2Service) {
	  _classCallCheck(this, InboxController);
	
	  this.name = "inbox";
	  $localStorage.activeStateName = "inbox";
	
	  if (!AuthService.isLoggedIn()) {
	    $state.go("signin");
	    return;
	  }
	
	  this.$http = $http;
	  this.$localStorage = $localStorage;
	  this.$state = $state;
	  this.$scope = $scope;
	  this.$auth = AuthService;
	  this.$companies = CompaniesService;
	  this.$events = EventsService;
	  this.$stateParams = $stateParams;
	  this.$location = $location;
	  this.$security = SecurityService;
	  this.$rootScope = $rootScope;
	  this.query = "";
	  this.$messagingv2 = Messagingv2Service;
	  this.$common = CommonService;
	  this.$env = EnvService;
	  this.$timeout = $timeout;
	  this.isPrivate = false;
	  this.isPreferred = false;
	  this.remain_loading_count = 1;
	  this.event = {};
	  this.teamsPostedTo = [];
	  this.acceptedApplicants = [];
	  this.currentUser = this.$auth.getUserData();
	  this.events = [];
	  this.arrayOfChannelsToDelete = [];
	  this.collection_of_channel_ids = [];
	  this.collection_of_channels = [];
	  this.collection_of_eles = [];
	  this.deletion_payload = { channels: [], events: [] };
	  this.$rootScope.messagesOffsetparam = 0;
	  this.incrementChannelsSize = 20;
	  this.busy = false;
	
	  var _this = this;
	};
	
	InboxController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "events", "companies", "security", "$rootScope", "common", "env", "$timeout", "$location", "$scope", "messagingv2"];
	
	exports.default = InboxController;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(437);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./inbox.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./inbox.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "eventoverview #wrapper{min-height:calc(100% - 62px)}", ""]);
	
	// exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(439);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".inbox-header{height:50px;z-index:99;padding:0;border-bottom:1px solid #adbcc2;box-shadow:0 2px 5px 0 rgba(0,0,0,.2)}.inbox-header .header-container{display:flex}.inbox-header .inbox-label{flex:0 0 75px;line-height:50px;text-transform:uppercase;letter-spacing:.5px;color:#5e666d;font-family:Poppins,sans-serif;font-size:12px;font-weight:600}.inbox-header .header-search-container{flex:1;height:34px;position:relative;margin-top:8px}.inbox-header .header-search-container input{border-radius:6px;box-shadow:0 2px 4px #00000020;padding-left:46px;height:100%;width:100%;max-width:500px;border:1px solid #adbcc2;color:#767676;font-family:Poppins,sans-serif;font-size:12px;letter-spacing:0}.inbox-header input:placeholder-shown{color:#adbcc2;opacity:1}.inbox-header .header-search-container i{position:absolute;left:16px;height:14px;top:10px;color:#5e666d}.inbox-header .delete-button-container{flex:0 0 125px;text-align:right}.inbox-container .delete-button-container button{text-transform:capitalize;color:#5e666d;height:25px;padding:0 10px;line-height:24px;font-size:11px;font-family:Poppins,sans-serif;font-weight:500;cursor:pointer;border-radius:13.5px;border-color:#5e666d;margin-top:12.5px;border-width:1px}.inbox-container .delete-button-container button.disabled:hover{cursor:default}.inbox-container .delete-button-container button.active{background:red;border-color:red;color:#fff;font-weight:600}.inbox-container .event-count{color:#33373a;font-family:Poppins,sans-serif;font-size:11px;font-weight:500;line-height:17px;margin:16px 0;padding-left:5px}.inbox-container .messenger-page{margin-bottom:8px;border-radius:6px;min-height:75px}.inbox-container .event-name{color:#33373a;font-family:Poppins;font-size:14px;letter-spacing:0;line-height:21px}.inbox-container .event-info-container{color:#33373a;font-family:Poppins,sans-serif;font-size:11px;font-weight:500;letter-spacing:.3px;line-height:11px;margin-bottom:8px}.inbox-container .event-info-container i{width:15px}.inbox-container .view-messages{color:#33373a;font-size:12px;cursor:pointer}.inbox-container .new-message-pill,.inbox-container .view-messages{font-family:Poppins,sans-serif;font-weight:500;letter-spacing:.3px;line-height:11px;margin-bottom:8px}.inbox-container .new-message-pill{color:#fff;background:red;border-radius:13.5px;font-size:11px;padding:0 10px}.jobs-dashboard-container.inbox-container .rightouter-box.messenger-outer .jobs-dashboard-container-header-actions ul{display:none}.jobs-dashboard-container.inbox-container .rightouter-box.messenger-outer .jobs-dashboard-container-header-actions ul:hover{cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _billing = __webpack_require__(441);
	
	var _billing2 = _interopRequireDefault(_billing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var billingModule = _angular2.default.module("billing", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("billing", {
	    url: "/billing",
	    template: "<billing></billing>",
	    title: "Billing",
	    params: {}
	  }).state("bill", {
	    url: "/billing/:billId",
	    template: "<billing></billing>",
	    title: "Billing",
	    params: {
	      payPeriodStartDate: null
	    }
	  });
	}).component("billing", _billing2.default);
	
	exports.default = billingModule;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _billing = __webpack_require__(442);
	
	var _billing2 = _interopRequireDefault(_billing);
	
	var _billing3 = __webpack_require__(443);
	
	var _billing4 = _interopRequireDefault(_billing3);
	
	__webpack_require__(444);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var billingComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _billing2.default,
	  controller: _billing4.default,
	  controllerAs: "vm"
	};
	
	exports.default = billingComponent;

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n<leftnavigation></leftnavigation>\n\n<div class=\"jobs-dashboard-container\" ng-if=\"vm.showUsers==true\">\n    <div class=\"jobs-dashboard-container-header\" style=\"position: relative;\">\n\n        <div class=\"jobble-bread-crumbs\">\n            <span>\n                <a href=\"/billing\">BILLING</a> < <a href=\"/billing/{{vm.sortingParametersBill.billId}}\" target=\"_blank\">INVOICE #{{vm.sortingParametersBill.billId}}</a>\n            </span>\n        </div>\n\n        <h5 class=\"dates-of-invoice\">\n            <span>\n                {{vm.payPeriodBeginning}} <i class=\"fas fa-arrow-alt-circle-right\"></i> {{vm.payPeriodEnding}}\n            </span>\n        </h5>\n\n        <h1 class=\"jobs-header billing\">\n            Invoice #{{vm.sortingParametersBill.billId}} - {{vm.total}}\n        </h1>\n\n        <div class=\"invoice-search-tools bill\" style=\"position:relative;\">\n\n            <form\n                    ng-submit=\"vm.billSearchSubmit()\">\n                <input\n                        type=\"text\"\n                        class=\"jobs-dashboard-search\"\n                        placeholder=\"Search by jobbler name, job title or location\"\n                        ng-model=\"vm.billSearch\"\n                        ng-change=\"vm.billingSearchChange()\"\n                />\n                <i class=\"fas fa-search search-icon\"></i>\n            </form>\n\n            <div id=\"tutorial-modal\" class=\"tutorial-6\">\n                <div class=\"tutorial-1-triangle\"></div>\n                Search for specific payments within an invoice by entering a Jobbler’s name, the related job title or\n                shift location.\n                <div class=\"divider\"></div>\n                <span class=\"tutorial-buttons tutorial-exit\">\n                    <a href=\"#\" ng-click=\"vm.exitTutorial(7)\">EXIT</a>\n                </span>\n                <span class=\"tutorial-buttons tutorial-next\">\n                    <a href=\"#\" ng-click=\"vm.continueTutorial(7)\">NEXT</a>\n                </span>\n            </div>\n        </div>\n\n        <div style=\"position:relative;float:right;\">\n            <button\n                    ng-csv=\"vm.csv\"\n                    csv-header=\"vm.getHeaderBills()\"\n                    filename=\"{{vm.billCsvName}}\"\n                    field-separator=\",\"\n                    decimal-separator=\".\"\n                    class=\"export\">\n                <i class=\"fas fa-download\"></i> Export\n            </button>\n\n            <div id=\"tutorial-modal\" class=\"tutorial-7\">\n                <div class=\"tutorial-7-triangle\"></div>\n                Click here to export the invoice you’re viewing as a CSV file.\n                <div class=\"divider\"></div>\n                <span class=\"tutorial-buttons tutorial-exit\">\n                    <a href=\"#\" ng-click=\"vm.exitTutorial(8)\">EXIT</a>\n                </span>\n                <span class=\"tutorial-buttons tutorial-next\">\n                    <a href=\"#\" ng-click=\"vm.continueTutorial(8)\">NEXT</a>\n                </span>\n            </div>\n        </div>\n    </div>\n\n    <div\n            class=\"jobs-dashboard-jobs-listing\" style=\"padding-left:11px;\">\n\n        <table\n                class=\"jobs-dashboard-jobs-table invoices bill\">\n            <thead>\n            <tr>\n                <th ng-click=\"vm.sortTableBill('payDate')\">\n                    Pay Date\n                    <i class=\"fas fa-sort\" ng-if=\"vm.sortingStatusBilling.payDate.default == true\"></i>\n                    <i class=\"fas fa-sort-down\" ng-if=\"vm.sortingStatusBilling.payDate.desc == true\"></i>\n                    <i class=\"fas fa-sort-up\" ng-if=\"vm.sortingStatusBilling.payDate.asc == true\"></i>\n                </th>\n\n                <th ng-click=\"vm.sortTableBill('jobbler')\">\n                    Jobbler\n                    <i class=\"fas fa-sort\" ng-if=\"vm.sortingStatusBilling.jobblerNameSortStatus.default == true\"></i>\n                    <i class=\"fas fa-sort-down\" ng-if=\"vm.sortingStatusBilling.jobblerNameSortStatus.desc == true\"></i>\n                    <i class=\"fas fa-sort-up\" ng-if=\"vm.sortingStatusBilling.jobblerNameSortStatus.asc == true\"></i>\n                </th>\n                <th ng-click=\"vm.sortTableBill('rate')\">\n                    Rate\n                    <i class=\"fas fa-sort\" ng-if=\"vm.sortingStatusBilling.rateSortStatus.default == true\"></i>\n                    <i class=\"fas fa-sort-down\" ng-if=\"vm.sortingStatusBilling.rateSortStatus.desc == true\"></i>\n                    <i class=\"fas fa-sort-up\" ng-if=\"vm.sortingStatusBilling.rateSortStatus.asc == true\"></i>\n                </th>\n                <th ng-click=\"vm.sortTableBill('hours')\">\n                    Hours\n                    <i class=\"fas fa-sort\" ng-if=\"vm.sortingStatusBilling.hoursSortStatus.default == true\"></i>\n                    <i class=\"fas fa-sort-down\" ng-if=\"vm.sortingStatusBilling.hoursSortStatus.desc == true\"></i>\n                    <i class=\"fas fa-sort-up\" ng-if=\"vm.sortingStatusBilling.hoursSortStatus.asc == true\"></i>\n                </th>\n                <th ng-click=\"vm.sortTableBill('jobblerPaid')\">\n                    Jobbler Paid\n                    <i class=\"fas fa-sort\" ng-if=\"vm.sortingStatusBilling.jobblerPaidSortStatus.default == true\"></i>\n                    <i class=\"fas fa-sort-down\" ng-if=\"vm.sortingStatusBilling.jobblerPaidSortStatus.desc == true\"></i>\n                    <i class=\"fas fa-sort-up\" ng-if=\"vm.sortingStatusBilling.jobblerPaidSortStatus.asc == true\"></i>\n                </th>\n                <th ng-click=\"vm.sortTableBill('platformFee')\">\n                    Platform fee\n                    <i class=\"fas fa-sort\" ng-if=\"vm.sortingStatusBilling.platformFeeSortStatus.default == true\"></i>\n                    <i class=\"fas fa-sort-down\" ng-if=\"vm.sortingStatusBilling.platformFeeSortStatus.desc == true\"></i>\n                    <i class=\"fas fa-sort-up\" ng-if=\"vm.sortingStatusBilling.platformFeeSortStatus.asc == true\"></i>\n                </th>\n                <th ng-click=\"vm.sortTableBill('totalCharge')\">\n                    Total Charge\n                    <i class=\"fas fa-sort\" ng-if=\"vm.sortingStatusBilling.totalChargeSortStatus.default == true\"></i>\n                    <i class=\"fas fa-sort-down\" ng-if=\"vm.sortingStatusBilling.totalChargeSortStatus.desc == true\"></i>\n                    <i class=\"fas fa-sort-up\" ng-if=\"vm.sortingStatusBilling.totalChargeSortStatus.asc == true\"></i>\n                </th>\n                <th ng-click=\"vm.sortTableBill('eventId')\">\n                    Shift Date\n                    <i class=\"fas fa-sort\" ng-if=\"vm.sortingStatusBilling.eventIdSortStatus.default == true\"></i>\n                    <i class=\"fas fa-sort-down\" ng-if=\"vm.sortingStatusBilling.eventIdSortStatus.desc == true\"></i>\n                    <i class=\"fas fa-sort-up\" ng-if=\"vm.sortingStatusBilling.eventIdSortStatus.asc == true\"></i>\n                </th>\n                <th ng-click=\"vm.sortTable('payment')\" style=\"width:135px\">\n                    Memo\n                </th>\n            </tr>\n            </thead>\n\n            <tbody ng-if=\"vm.billsViewList.length == 0 && vm.uiViews.is_loading==true\" class=\"not-real-jobs-body\">\n            <tr ng-repeat=\"fakeInvoice in vm.fakeInvoices\" class=\"fake-jobs\">\n                <td colspan=\"10\"></td>\n            </tr>\n            </tbody>\n\n            <tbody>\n            <tr ng-repeat=\"bill in vm.billsViewList track by $index\">\n                <td>{{bill.paymentDate}}</td>\n                <td>\n                    {{bill.name}}\n                </td>\n                <td style=\"position:relative;\">\n                    ${{bill.isAdditionalPayment ? \"--\" : bill.rate}}/hr\n                    <!--\n                    <span ng-if=\"bill.isAdditionalPayment == false\">\n                        ${{bill.rate}}/hr\n                    </span>\n                    <span ng-if=\"bill.isAdditionalPayment == true\">\n                        $--/hr\n                    </span>\n                    -->\n                    <div id=\"tutorial-modal\" class=\"tutorial-5\" ng-if=\"$index == 0\">\n                        <div class=\"tutorial-1-triangle\"></div>\n                        Take a closer look at your weekly billing activity, including details about shift payments and\n                        direct payments to Jobblers, in the invoice details view.\n                        <div class=\"divider\"></div>\n                        <span class=\"tutorial-buttons tutorial-exit\">\n                            <a href=\"#\" ng-click=\"vm.exitTutorial(6)\">EXIT</a>\n                        </span>\n                        <span class=\"tutorial-buttons tutorial-next\">\n                            <a href=\"#\" ng-click=\"vm.continueTutorial(6)\">NEXT</a>\n                        </span>\n                    </div>\n                </td>\n                <td>{{bill.isAdditionalPayment ? \"Additional Payment\" : bill.hours}}</td>\n                <!--\n                <td ng-if=\"bill.isAdditionalPayment == false\">{{bill.hours}}</td>\n                <td ng-if=\"bill.isAdditionalPayment == true\">Additional Payment</td>\n                -->\n                <td>{{bill.amountBeforeSecurityFee ? bill.amountBeforeSecurityFee : bill.jobblerPaid}}</td>\n                <td>{{bill.platformFee}}</td>\n                <td>{{bill.totalCharge}}</td>\n                <td style=\"position:relative;\">\n                    <div id=\"tutorial-modal\" class=\"tutorial-8\" ng-if=\"$index == 0\">\n                        <div class=\"tutorial-4-triangle\"></div>\n                        Hover or click on the info icon next to the shift date that appears on shift payments to see the\n                        event ID, location and job title\n                        <div class=\"divider\"></div>\n                        <span class=\"tutorial-buttons tutorial-exit\">\n                            <a href=\"#\" ng-click=\"vm.exitTutorial(8)\">EXIT</a>\n                        </span>\n                        <!--\n                        <span class=\"tutorial-buttons tutorial-next\">\n                            <a href=\"#\" ng-click=\"vm.continueTutorial(8)\">NEXT</a>\n                        </span>\n                        -->\n                    </div>\n                    {{bill.shiftDate}}\n                    <i class=\"invoice-tool-tip fas fa-exclamation-circle\"\n                       data-toggle=\"tooltip\"\n                       ng-attr-title=\"{{bill.tooltip}}\"\n                       data-placement=\"right\"\n                       data-html=\"true\"\n                       ng-if=\"bill.shiftDate\"></i>\n                </td>\n                <td style=\"font-size:14px;\">{{bill.memo}}</td>\n            </tr>\n            </tbody>\n        </table>\n\n        <div class=\"no-jobs-available\" ng-if=\"vm.jobs.length == 0 && vm.uiViews.is_loading==false\">\n            No jobs in the result set, Please try another search.\n        </div>\n    </div>\n</div>\n\n\n<div class=\"jobs-dashboard-container\" ng-if=\"vm.showUsers==false\">\n    <div class=\"jobs-dashboard-container-header\">\n        <h1 class=\"jobs-header\">Billing</h1>\n        <div style=\"padding-left:3px;position:relative;\">\n            <div id=\"tutorial-modal\" class=\"tutorial-1\">\n                <div class=\"tutorial-1-triangle\"></div>\n                Search for invoices using a known ID number.\n                <div class=\"divider\"></div>\n                <span class=\"tutorial-buttons tutorial-exit\">\n                    <a href=\"#\" ng-click=\"vm.exitTutorial(1)\">EXIT</a>\n                </span>\n                <span class=\"tutorial-buttons tutorial-next\">\n                    <a href=\"#\" ng-click=\"vm.continueTutorial(1)\">NEXT</a>\n                </span>\n            </div>\n        </div>\n        <div class=\"invoice-search-tools\" style=\"position:relative;\">\n            <form\n                    ng-submit=\"vm.invoiceSearchSubmit()\"\n                    ng-if=\"vm.invoiceViewList.length > 0 && vm.uiViews.is_loading==false\">\n                <input\n                        type=\"text\"\n                        class=\"jobs-dashboard-search\"\n                        placeholder=\"Search by invoice number\"\n                        ng-model=\"vm.billingSearch\"\n                        ng-change=\"vm.billingSearchChange()\"\n                />\n                <i class=\"fas fa-search search-icon\"></i>\n            </form>\n            <div id=\"tutorial-modal\" class=\"tutorial-3\">\n                <div class=\"tutorial-1-triangle\"></div>\n                You can also search by invoice number to narrow your results.\n                <div class=\"divider\"></div>\n                <span class=\"tutorial-buttons tutorial-exit\">\n                    <a href=\"#\" ng-click=\"vm.exitTutorial(3)\">EXIT</a>\n                </span>\n                <span class=\"tutorial-buttons tutorial-next\">\n                    <a href=\"#\" ng-click=\"vm.continueTutorial(3)\">NEXT</a>\n                </span>\n            </div>\n        </div>\n    </div>\n\n    <div\n            class=\"jobs-dashboard-jobs-listing\" style=\"padding-left:11px;\">\n\n        <div class=\"no-jobs-available\" ng-if=\"vm.invoiceViewList.length === 0 && vm.uiViews.is_loading==false\"\n             style=\"margin-top: 15px\">\n            NO INVOICES HAVE BEEN CREATED YET\n        </div>\n\n        <table\n                class=\"jobs-dashboard-jobs-table invoices\"\n                ng-if=\"vm.invoiceViewList.length > 0 && vm.uiViews.is_loading==false\">\n            <thead>\n            <tr>\n                <th ng-click=\"vm.sortTable('invoiceId')\">\n                    Invoice #\n                    <i class=\"fas fa-sort\" ng-if=\"vm.sortingStatus.invoiceIdSortStatus.default == true\"></i>\n                    <i class=\"fas fa-sort-down\" ng-if=\"vm.sortingStatus.invoiceIdSortStatus.desc == true\"></i>\n                    <i class=\"fas fa-sort-up\" ng-if=\"vm.sortingStatus.invoiceIdSortStatus.asc == true\"></i>\n                </th>\n                <th ng-click=\"vm.sortTable('amount')\" style=\"width:200px;\">\n                    Amount\n                    <i class=\"fas fa-sort\" ng-if=\"vm.sortingStatus.amountSortStatus.default == true\"></i>\n                    <i class=\"fas fa-sort-down\" ng-if=\"vm.sortingStatus.amountSortStatus.desc == true\"></i>\n                    <i class=\"fas fa-sort-up\" ng-if=\"vm.sortingStatus.amountSortStatus.asc == true\"></i>\n                </th>\n                <th ng-click=\"vm.sortTable('date')\">\n                    Billing Period\n                    <i class=\"fas fa-sort\" ng-if=\"vm.sortingStatus.invoiceDateSortStatus.default == true\"></i>\n                    <i class=\"fas fa-sort-down\" ng-if=\"vm.sortingStatus.invoiceDateSortStatus.desc == true\"></i>\n                    <i class=\"fas fa-sort-up\" ng-if=\"vm.sortingStatus.invoiceDateSortStatus.asc == true\"></i>\n                </th>\n                <th>\n                    Date Processed\n                </th>\n                <th>\n                    Payment Method\n                </th>\n                <th style=\"width:160px;\">Status</th>\n                <th></th>\n\n            </tr>\n            </thead>\n\n            <tbody ng-if=\"vm.invoiceViewList.length == 0 && vm.uiViews.is_loading==true\" class=\"not-real-jobs-body\">\n            <tr ng-repeat=\"fakeInvoice in vm.fakeInvoices\" class=\"fake-jobs\">\n                <td colspan=\"10\"></td>\n            </tr>\n            </tbody>\n\n            <tbody>\n            <tr>\n                <td>Pending</td>\n                <td>{{vm.pendingBill.total}}</td>\n                <td>{{vm.pendingBill.start}} - {{vm.pendingBill.end}}</td>\n                <td>PENDING</td>\n                <td>PENDING</td>\n                <td>PENDING</td>\n                <td></td>\n            </tr>\n\n            <tr ng-repeat=\"invoice in vm.invoiceViewList track by $index\">\n                <td style=\"width:145px;position:relative;\">\n                    <a ng-href=\"/billing/{{invoice.id}}?startDate={{invoice.periodStartRaw}}&endDate={{invoice.periodEndRaw}}\"\n                       target=\"_blank\">\n                        {{invoice.id}}\n                    </a>\n                    <div id=\"tutorial-modal\" class=\"tutorial-2\" ng-if=\"$index == 0\">\n                        <div class=\"tutorial-1-triangle\"></div>\n                        Billing is a weekly recap of the charges you have incurred from Sunday through Monday, starting\n                        with the current week. Invoices are automatically generated on Tuesday of each week.\n                        <div class=\"divider\"></div>\n                        <span class=\"tutorial-buttons tutorial-exit\">\n                            <a href=\"#\" ng-click=\"vm.exitTutorial(2)\">EXIT</a>\n                        </span>\n                        <span class=\"tutorial-buttons tutorial-next\">\n                            <a href=\"#\" ng-click=\"vm.continueTutorial(2)\">NEXT</a>\n                        </span>\n                    </div>\n                </td>\n                <td>{{invoice.amount}}</td>\n                <td>{{invoice.periodStart}} - {{invoice.periodEnd}}</td>\n                <td>{{invoice.invoiceDateRaw}}</td>\n                <td>{{invoice.paymentMethod ? invoice.paymentMethod : \"--\"}}</td>\n                <td class=\"{{invoice.statusClass}}\">{{invoice.status ? invoice.status : \"--\"}}</td>\n                <td style=\"position:relative;\">\n                    <i\n                            class=\"fas fa-ellipsis-h\"\n                            ng-click=\"vm.toggleActionMenu(invoice,$index)\">\n                    </i>\n                    <div\n                            class=\"action-menu\"\n                            ng-blur=\"vm.closeActionMenu(invoice,$index)\"\n                            tabindex=\"{{$index}}\">\n                        <ul>\n                            <li>\n                                <a ng-href=\"/billing/{{invoice.id}}?startDate={{invoice.periodStartRaw}}&endDate={{invoice.periodEndRaw}}\"\n                                   target=\"_blank\">\n                                    <i class=\"fas fa-eye\"></i>\n                                    View details\n                                </a>\n                            </li>\n                            <li ng-csv=\"vm.exportbill(invoice)\"\n                                lazy-load=\"true\"\n                                csv-header=\"vm.getHeaderBills()\"\n                                filename=\"Jobble_Invoice_{{invoice.periodStart}}-{{invoice.periodEnd}}.csv\"\n                                field-separator=\",\"\n                                decimal-separator=\".\"\n                                class=\"export\">\n                                <a href=\"\" title=\"Export to CSV\">\n                                    <i class=\"fas fa-download\"></i>\n                                    Export\n                                </a>\n                            </li>\n                        </ul>\n                    </div>\n                    <div id=\"tutorial-modal\" class=\"tutorial-4\" ng-if=\"$index == 0\">\n                        <div class=\"tutorial-4-triangle\"></div>\n                        Click the elipsis icon to view the details of each invoice. You can also do this by clicking the\n                        invoice number.\n                        <div class=\"divider\"></div>\n                        <span class=\"tutorial-buttons tutorial-exit\">\n                            <a href=\"#\" ng-click=\"vm.exitTutorial(4)\">EXIT</a>\n                        </span>\n                        <span class=\"tutorial-buttons tutorial-next\">\n                            <a\n                                    ng-href=\"/billing/{{invoice.id}}?startDate={{invoice.periodStartRaw}}&endDate={{invoice.periodEndRaw}}\"\n                                    ng-click=\"vm.continueTutorial(4)\"\n                                    target=\"_blank\">\n                                NEXT\n                            </a>\n                        </span>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n\n        <div class=\"no-jobs-available\" ng-if=\"vm.jobs.length == 0 && vm.uiViews.is_loading==false\">\n            No jobs in the result set, Please try another search.\n        </div>\n    </div>\n\n</div>\n\n\n</div>\n<jobblefooter></jobblefooter>\n<globalalert></globalalert>\n\n\n"

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var fakeInvoices = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25];
	var sortingStatus = {
	  invoiceIdSortStatus: {
	    default: true,
	    asc: false,
	    desc: false
	  },
	  amountSortStatus: {
	    default: true,
	    asc: false,
	    desc: false
	  },
	  invoiceDateSortStatus: {
	    default: false,
	    asc: false,
	    desc: true
	  },
	  paymentMethodSortStatus: {
	    default: true,
	    asc: false,
	    desc: false
	  }
	};
	
	var sortingStatusBilling = {
	  payDate: {
	    default: false,
	    asc: true,
	    desc: false
	  },
	  jobblerNameSortStatus: {
	    default: true,
	    asc: false,
	    desc: false
	  },
	  hoursSortStatus: {
	    default: true,
	    asc: false,
	    desc: false
	  },
	  rateSortStatus: {
	    default: true,
	    asc: false,
	    desc: false
	  },
	  jobblerPaidSortStatus: {
	    default: true,
	    asc: false,
	    desc: false
	  },
	  platformFeeSortStatus: {
	    default: true,
	    asc: false,
	    desc: false
	  },
	  totalChargeSortStatus: {
	    default: true,
	    asc: false,
	    desc: false
	  },
	  eventIdSortStatus: {
	    default: true,
	    asc: false,
	    desc: false
	  }
	};
	
	var BillingController = function () {
	  function BillingController($http, $localStorage, $state, $stateParams, AuthService, CompaniesService, SecurityService, ProfileService, $timeout, $rootScope, EnvService, ngProgressFactory, $scope, $location) {
	    _classCallCheck(this, BillingController);
	
	    this.name = "accountprofile";
	
	    $localStorage.activeStateName = "accountprofile";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$scope = $scope;
	    this.$auth = AuthService;
	    this.$companies = CompaniesService;
	    this.$security = SecurityService;
	    this.$profile = ProfileService;
	    this.$progress = ngProgressFactory.createInstance();
	    this.$rootScope = $rootScope;
	    this.$location = $location;
	    this.$env = EnvService;
	    this.currentUser = this.$auth.getUserData();
	    this.fakeInvoices = fakeInvoices;
	    this.sortingStatus = sortingStatus;
	    this.sortingStatusBilling = sortingStatusBilling;
	    this.$stateParams = $stateParams;
	    this.doWeHaveAtLeastOneInvoice = false;
	
	    this.sortingParameters = {
	      offset: 0,
	      sort: "invoiceDate",
	      order: "desc",
	      max: 30,
	      search: null,
	      start: null,
	      end: null
	    };
	
	    this.sortingParametersBill = {
	      offset: 0,
	      sort: "payment_date_created",
	      order: "asc",
	      max: 30,
	      search: null,
	      start: null,
	      end: null
	    };
	
	    this.uiViews = { is_loading: true, all_checked: false, one_checked_invoice: false };
	    this.invoiceViewList = [];
	    var _this = this;
	    this.init();
	  }
	
	  _createClass(BillingController, [{
	    key: "init",
	    value: function init() {
	      var billId = this.$state.params.billId;
	
	      if (billId) {
	        this.showUsers = true;
	        this.sortingParametersBill.billId = billId;
	        //this.getUsersLatestTutorialData(this.currentUser);
	        this.formatInvoiceStartDate(this.$location.$$search);
	        this.getBill(null, true);
	      } else {
	        this.showUsers = false;
	        this.getUsersLatestTutorialData(this.currentUser);
	        this.getPendingInvoices();
	        this.getInvoices();
	        //this.initTutorial(this.currentUser);
	      }
	    }
	  }, {
	    key: "initTutorial",
	    value: function initTutorial(user) {
	      var _this2 = this;
	
	      console.log("init tutorial");
	      console.dir(this.doWeHaveAtLeastOneInvoice);
	
	      if (this.doWeHaveAtLeastOneInvoice === false) {
	        return;
	      } else {
	        this.doWeHaveAtLeastOneInvoice = false;
	      }
	
	      this.$profile.getLatestTutorial().then(function (response) {
	        if (response.data.billingTutorialTracking === false || response.data.billingTutorialTracking === null) {
	          _this2.$timeout(function () {
	            $("#tutorial-modal.tutorial-1").addClass("show-tutorial");
	            _this2.doWeHaveAtLeastOneInvoice = false;
	          });
	        }
	      }, function (error) {
	        alert("Error loading users payment information : " + error.status);
	      });
	    }
	  }, {
	    key: "formatInvoiceStartDate",
	    value: function formatInvoiceStartDate(dateObj) {
	      this.payPeriodBeginning = moment(new Date(dateObj.startDate)).format("MM/DD/YYYY");
	      this.payPeriodEnding = moment(new Date(dateObj.endDate)).format("MM/DD/YYYY");
	      this.billCsvName = "Jobble_Invoice_" + this.payPeriodBeginning + "-" + this.payPeriodEnding + ".csv";
	    }
	  }, {
	    key: "getBill",
	    value: function getBill(params, totalUp, forBillingPage) {
	      var _this3 = this;
	
	      console.log("getBill");
	      console.dir(params);
	      console.dir(this.sortingParametersBill);
	      console.dir(forBillingPage);
	
	      this.start();
	
	      var data = null;
	
	      if (params) {
	        data = params;
	      } else {
	        data = this.sortingParametersBill;
	      }
	
	      this.$companies.getBill(data).then(function (response) {
	        _this3.formatBills(response, response.data, totalUp, forBillingPage);
	      }, function (error) {
	        alert("Error : " + error);
	        _this3.finish();
	      });
	    }
	  }, {
	    key: "getInvoices",
	    value: function getInvoices(params) {
	      var _this4 = this;
	
	      this.start();
	
	      var data = null;
	
	      if (params) {
	        data = params;
	      } else {
	        data = this.sortingParameters;
	      }
	
	      this.$companies.getInvoices(data).then(function (response) {
	        console.log("response");
	        console.dir(response);
	
	        if (response && response.data && response.data.invoices.length > 0) {
	          _this4.doWeHaveAtLeastOneInvoice = true;
	          _this4.initTutorial(_this4.currentUser);
	        }
	
	        _this4.totalNumberOfInvoices = response.data.totalRegisters;
	
	        if (_this4.totalNumberOfInvoices === 0) {
	          _this4.finish();
	        } else {
	          _this4.formatInvoices(response, response.data);
	        }
	      }, function (error) {
	        alert("Error : " + error);
	        _this4.finish();
	      });
	    }
	  }, {
	    key: "getPendingInvoices",
	    value: function getPendingInvoices() {
	      var _this5 = this;
	
	      //this.start();
	      var startDate = this.getBeginningOfWeek();
	      var endDate = this.getEndOfWeek();
	
	      console.log("pending invoice params");
	      console.dir(startDate);
	      console.dir(endDate);
	
	      this.$companies.getPendingInvoices(startDate, endDate).then(function (response) {
	        console.log("pending invoices response");
	        console.dir(response);
	        _this5.formatPendingInvoice(response, startDate, endDate);
	      }, function (error) {
	        alert("Error : " + error);
	      });
	    }
	  }, {
	    key: "formatPendingInvoice",
	    value: function formatPendingInvoice(response, start, end) {
	      console.log("formatPendingInvoice");
	      console.dir(response);
	      var today = moment();
	
	      if (response && response.data && response.data.length > 0) {
	        this.doWeHaveAtLeastOneInvoice = true;
	        this.initTutorial(this.currentUser);
	      }
	
	      var totalAmountToBeCharged = this.calculateAmountOfPendingCharges(response);
	
	      var pendingBill = {
	        start: today.startOf("week").add(1, "days").format("MM/DD/YYYY"),
	        end: today.endOf("week").format("MM/DD/YYYY"),
	        total: totalAmountToBeCharged
	      };
	
	      this.pendingBill = pendingBill;
	    }
	  }, {
	    key: "calculateAmountOfPendingCharges",
	    value: function calculateAmountOfPendingCharges(response) {
	      console.log("calculateAmountOfPendingCharges");
	      console.dir(response);
	
	      var payments = response.data.pendingInvoicePayments;
	      var total = 0;
	
	      try {
	        payments.forEach(function (payment) {
	          total = total + payment.totalCharge;
	        });
	      } catch (err) {
	        console.log("problem with the invoices :" + err);
	      } finally {
	        console.log("total payments");
	        console.dir(total);
	        total = total.toFixed(2);
	        total = numeral(total).format("$0,0.00");
	        return total;
	      }
	    }
	  }, {
	    key: "getBeginningOfWeek",
	    value: function getBeginningOfWeek() {
	      var today = moment();
	      var beginning = today.startOf("week").format("YYYY-MM-DD");
	
	      return beginning;
	    }
	  }, {
	    key: "getEndOfWeek",
	    value: function getEndOfWeek() {
	      var today = moment();
	      var end = today.endOf("week").format("YYYY-MM-DD");
	
	      return end;
	    }
	  }, {
	    key: "formatRate",
	    value: function formatRate(rate) {
	      var r = null;
	
	      if (rate === "N/A") {
	        r = "--";
	      } else {
	        r = rate;
	      }
	
	      return r;
	    }
	  }, {
	    key: "enableToolTips",
	    value: function enableToolTips() {
	      this.$timeout(function () {
	        console.log("enableToolTips");
	        console.dir($(".invoice-tool-tip"));
	
	        $(".history-tool-tip").tooltip({});
	        $(".invoice-tool-tip").tooltip({});
	      }, 1000);
	    }
	  }, {
	    key: "formatBills",
	    value: function formatBills(response, data, totalUp, forBillingPage) {
	      var bills = data.invoiceDetails;
	
	      this.billsViewList = [];
	
	      if (totalUp) {
	        this.total = 0;
	      }
	
	      try {
	        for (var index = 0; index < bills.length; index++) {
	          var bill = bills[index];
	          var billView = {};
	
	          console.log("each bill");
	          console.dir(bill);
	
	          billView.eventId = bill.eventId;
	          billView.shiftDate = this.formatShiftStartDate(bill);
	          billView.paymentDate = this.formatPaymentDate(bill.payment_date_created);
	          billView.name = bill.jobblerName;
	          billView.rate = this.formatRate(bill.rate);
	          billView.hours = bill.hours;
	          billView.isAdditionalPayment = bill.is_additional_payment;
	          billView.jobblerPaid = this.formatInvoiceAmount(bill.jobblerPaid);
	          billView.platformFee = this.formatInvoiceAmount(bill.platformFee);
	          billView.totalCharge = this.formatInvoiceAmount(bill.totalCharge);
	          billView.tooltip = this.formatToolTip(bill);
	          billView.memo = bill.memo;
	
	          this.billsViewList.push(billView);
	
	          if (totalUp === true) {
	            this.totalAllCharges(bill.totalCharge);
	          }
	        }
	      } catch (err) {
	        console.log("Error formatting bills :", err);
	      } finally {
	        this.finish();
	        this.enableToolTips();
	        this.prepBillsForCSV(this.billsViewList, forBillingPage);
	        if (totalUp === true) {
	          this.formatTotal();
	        }
	      }
	    }
	  }, {
	    key: "activateDatePicker",
	    value: function activateDatePicker() {
	      var elem = document.getElementById("range-selection-2");
	
	      if (!elem) return;
	
	      this.datepicker = new DateRangePicker(elem, {
	        minDate: new Date()
	      });
	    }
	  }, {
	    key: "formatShiftStartDate",
	    value: function formatShiftStartDate(bill) {
	      var shiftDate = bill.shiftStartDate;
	      var dateObject = new Date(shiftDate);
	      var momentDateFormatted = moment(dateObject).format("MM-DD-YYYY");
	      if (bill.shiftStartDate) {
	        return momentDateFormatted;
	      } else {
	        return "N/A";
	      }
	    }
	  }, {
	    key: "formatPaymentDate",
	    value: function formatPaymentDate(date) {
	      var dateObject = new Date(date);
	      var momentDateFormatted = moment(dateObject).format("MM-DD-YYYY");
	
	      return momentDateFormatted;
	    }
	  }, {
	    key: "formatToolTip",
	    value: function formatToolTip(bill) {
	      var shiftDate = bill.shiftStartDate;
	      var dateObject = new Date(shiftDate);
	      var momentDateFormatted = moment(dateObject).format("MM-DD-YYYY");
	      var toolTipFormatted = "<strong>Event ID:</strong> " + bill.eventId + "<br/> <strong>Location:</strong> " + bill.location + "<br/> <strong>Title:</strong> " + bill.title;
	
	      return toolTipFormatted;
	    }
	  }, {
	    key: "prepBillsForCSV",
	    value: function prepBillsForCSV(bills, forBillingPage) {
	
	      var _this = this;
	
	      var csv = [];
	
	      _this.csv = [];
	
	      try {
	        bills.forEach(function (bill, i) {
	          var csvObj = {
	            pay_date: bill.paymentDate,
	            name: bill.name,
	            rate: bill.rate,
	            hours: bill.hours,
	            jobbler_paid: bill.jobblerPaid,
	            platformFee: bill.platformFee,
	            total_charge: bill.totalCharge,
	            shift_date: bill.shiftDate,
	            event_id: bill.eventId,
	            memo: bill.memo
	          };
	
	          csv.push(csvObj);
	        });
	      } catch (err) {} finally {
	        this.setAccountLevelDetails(csv);
	        _this.csv = csv;
	        return csv;
	      }
	    }
	  }, {
	    key: "setAccountLevelDetails",
	    value: function setAccountLevelDetails(csv) {
	      var cvsAddition = [];
	      var blankSpace = {};
	      var accountInfo = {
	        account: "Account",
	        value: this.currentUser.company.name
	      };
	
	      var accountId = {
	        account: "Account ID",
	        value: this.currentUser.company.id
	      };
	
	      var invoiceData = {
	        invoice: "Invoice #",
	        value: this.sortingParametersBill.billId
	      };
	
	      var dateRangeData = {
	        date: "Date Range",
	        value: this.payPeriodBeginning + " - " + this.payPeriodEnding
	      };
	
	      csv.push(blankSpace);
	      csv.push(accountInfo);
	      csv.push(accountId);
	      csv.push(invoiceData);
	      csv.push(dateRangeData);
	
	      this.csv = csv;
	    }
	  }, {
	    key: "getHeaderBills",
	    value: function getHeaderBills() {
	      return ["Pay Date", "Jobbler", "Rate", "Hours", "Jobbler Paid", "Platform Fee", "Total Charge", "Shift Date", "Event ID", "Memo"];
	    }
	  }, {
	    key: "formatTotal",
	    value: function formatTotal() {
	      var _this6 = this;
	
	      this.$timeout(function () {
	        _this6.total = _this6.total / 100;
	        _this6.total = _this6.formatInvoiceAmount(_this6.total);
	      }, 600);
	    }
	  }, {
	    key: "formatInvoices",
	    value: function formatInvoices(formatInvoicesResponse, data) {
	      var invoices = data.invoices;
	
	      this.invoiceViewList = [];
	
	      try {
	        for (var index = 0; index < invoices.length; index++) {
	          var invoice = invoices[index];
	          var invoiceView = {};
	
	          invoiceView.id = invoice.invoiceId;
	          invoiceView.amount = this.formatInvoiceAmount(invoice.amount / 100);
	          invoiceView.periodStartRaw = invoice.period_start;
	          invoiceView.periodEndRaw = invoice.period_end;
	          invoiceView.invoiceDateRaw = this.formatInvoiceDateProcessed(invoice.invoiceDate);
	          invoiceView.paymentMethod = invoice.paymentMethod;
	          invoiceView.status = invoice.status;
	          invoiceView.statusClass = this.formatStatusClass(invoice.status);
	          invoiceView.isChecked = false;
	          var billingPeriod = this.formateInvoiceDate(invoice.invoiceDate, invoice, index);
	          invoiceView.periodStart = billingPeriod.startPeriod;
	          invoiceView.periodEnd = billingPeriod.endPeriod;
	
	          if (index === 0) {
	            invoiceView.invoiceDateForView = invoiceView.invoiceDateForView + " (current)";
	          }
	
	          this.invoiceViewList.push(invoiceView);
	        }
	      } catch (err) {
	        console.error("issue with the invoices");
	        console.dir(err);
	      } finally {
	        this.activateDatePicker();
	        this.enableToolTips();
	        this.finish();
	      }
	    }
	  }, {
	    key: "totalAllCharges",
	    value: function totalAllCharges(charge) {
	      var _this7 = this;
	
	      var div = charge * 100;
	      this.$timeout(function () {
	        _this7.total = _this7.total + div;
	      }, 500);
	    }
	  }, {
	    key: "formatInvoiceAmount",
	    value: function formatInvoiceAmount(amount) {
	      return numeral(amount).format("$0,0.00");
	    }
	  }, {
	    key: "formatInvoiceDateProcessed",
	    value: function formatInvoiceDateProcessed(date) {
	      return moment(date).format("MM/DD/YYYY");
	    }
	  }, {
	    key: "formatStatusClass",
	    value: function formatStatusClass(status) {
	      var result = "";
	
	      if (status === "PAID") {
	        result = "paid";
	      } else {
	        result = "";
	      }
	
	      return result;
	    }
	  }, {
	    key: "formateInvoiceDate",
	    value: function formateInvoiceDate(date, invoice, index) {
	      var dateObj = {};
	
	      var startDate = new Date(invoice.period_start);
	      var endDate = new Date(invoice.period_end);
	      dateObj.startPeriod = moment(startDate).add(1, "days").format("MM/DD/YYYY");
	      dateObj.endPeriod = moment(endDate).format("MM/DD/YYYY");
	
	      return dateObj;
	    }
	  }, {
	    key: "finish",
	    value: function finish() {
	      this.uiViews.is_loading = false;
	      this.unSetLoader();
	      this.fancyLoad();
	    }
	  }, {
	    key: "goToBillingDetails",
	    value: function goToBillingDetails(invoice, index) {}
	  }, {
	    key: "toggleActionMenu",
	    value: function toggleActionMenu(invoice, index) {
	      var i = index + 2;
	
	      this.$timeout(function () {
	        $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices tbody tr:nth-child(" + i + ") td:last-child .action-menu").slideToggle({ duration: 100 });
	      });
	
	      this.$timeout(function () {
	        $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices tbody tr:nth-child(" + i + ") td").addClass("row-focus");
	      }, 150);
	
	      this.$timeout(function () {
	        $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices tbody tr:nth-child(" + i + ") td:last-child .action-menu").focus();
	      }, 300);
	    }
	  }, {
	    key: "closeActionMenu",
	    value: function closeActionMenu(invoice, index) {
	      var i = index + 1;
	
	      this.$timeout(function () {
	        $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices tbody tr:nth-child(" + i + ") td:last-child .action-menu").hide();
	        $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices tbody tr:nth-child(" + i + ") td").removeClass("row-focus");
	      }, 150);
	    }
	  }, {
	    key: "sortTableBill",
	    value: function sortTableBill(field) {
	      var params = {
	        offset: 0,
	        sort: "payDate",
	        order: "asc",
	        max: 30,
	        search: null,
	        start: null,
	        end: null,
	        billId: this.$state.params.billId
	      };
	
	      if (field === "payDate") {
	        if (this.sortingStatusBilling.payDate.default === true) {
	          this.sortingStatusBilling.payDate.default = false;
	          this.sortingStatusBilling.payDate.asc = true;
	          this.sortingStatusBilling.payDate.desc = false;
	
	          this.sortingStatusBilling.jobblerNameSortStatus.default = true;
	          this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerNameSortStatus.desc = false;
	
	          this.sortingStatusBilling.rateSortStatus.default = true;
	          this.sortingStatusBilling.rateSortStatus.asc = false;
	          this.sortingStatusBilling.rateSortStatus.desc = false;
	
	          this.sortingStatusBilling.hoursSortStatus.default = true;
	          this.sortingStatusBilling.hoursSortStatus.asc = false;
	          this.sortingStatusBilling.hoursSortStatus.desc = false;
	
	          this.sortingStatusBilling.jobblerPaidSortStatus.default = true;
	          this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;
	
	          this.sortingStatusBilling.platformFeeSortStatus.default = true;
	          this.sortingStatusBilling.platformFeeSortStatus.asc = false;
	          this.sortingStatusBilling.platformFeeSortStatus.desc = false;
	
	          this.sortingStatusBilling.totalChargeSortStatus.default = true;
	          this.sortingStatusBilling.totalChargeSortStatus.asc = false;
	          this.sortingStatusBilling.totalChargeSortStatus.desc = false;
	
	          this.sortingStatusBilling.eventIdSortStatus.default = true;
	          this.sortingStatusBilling.eventIdSortStatus.asc = false;
	          this.sortingStatusBilling.eventIdSortStatus.desc = false;
	
	          params.sort = "payment_date_created";
	          params.order = "asc";
	
	          this.getBill(params);
	        } else if (this.sortingStatusBilling.payDate.desc === true) {
	          this.sortingStatusBilling.payDate.default = false;
	          this.sortingStatusBilling.payDate.asc = true;
	          this.sortingStatusBilling.payDate.desc = false;
	
	          params.sort = "payment_date_created";
	          params.order = "asc";
	
	          this.getBill(params);
	        } else if (this.sortingStatusBilling.payDate.asc === true) {
	          this.sortingStatusBilling.payDate.default = false;
	          this.sortingStatusBilling.payDate.asc = false;
	          this.sortingStatusBilling.payDate.desc = true;
	
	          params.sort = "payment_date_created";
	          params.order = "desc";
	
	          this.getBill(params);
	        }
	      } else if (field === "jobbler") {
	        if (this.sortingStatusBilling.jobblerNameSortStatus.default === true) {
	          this.sortingStatusBilling.payDate.default = true;
	          this.sortingStatusBilling.payDate.asc = false;
	          this.sortingStatusBilling.payDate.desc = false;
	
	          this.sortingStatusBilling.jobblerNameSortStatus.default = false;
	          this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerNameSortStatus.desc = true;
	
	          this.sortingStatusBilling.rateSortStatus.default = true;
	          this.sortingStatusBilling.rateSortStatus.asc = false;
	          this.sortingStatusBilling.rateSortStatus.desc = false;
	
	          this.sortingStatusBilling.hoursSortStatus.default = true;
	          this.sortingStatusBilling.hoursSortStatus.asc = false;
	          this.sortingStatusBilling.hoursSortStatus.desc = false;
	
	          this.sortingStatusBilling.jobblerPaidSortStatus.default = true;
	          this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;
	
	          this.sortingStatusBilling.platformFeeSortStatus.default = true;
	          this.sortingStatusBilling.platformFeeSortStatus.asc = false;
	          this.sortingStatusBilling.platformFeeSortStatus.desc = false;
	
	          this.sortingStatusBilling.totalChargeSortStatus.default = true;
	          this.sortingStatusBilling.totalChargeSortStatus.asc = false;
	          this.sortingStatusBilling.totalChargeSortStatus.desc = false;
	
	          this.sortingStatusBilling.eventIdSortStatus.default = true;
	          this.sortingStatusBilling.eventIdSortStatus.asc = false;
	          this.sortingStatusBilling.eventIdSortStatus.desc = false;
	
	          params.sort = "jobblerName";
	          params.order = "desc";
	
	          this.getBill(params);
	        } else if (this.sortingStatusBilling.jobblerNameSortStatus.desc === true) {
	          this.sortingStatusBilling.jobblerNameSortStatus.default = false;
	          this.sortingStatusBilling.jobblerNameSortStatus.asc = true;
	          this.sortingStatusBilling.jobblerNameSortStatus.desc = false;
	
	          params.sort = "jobblerName";
	          params.order = "asc";
	
	          this.getBill(params);
	        } else if (this.sortingStatusBilling.jobblerNameSortStatus.asc === true) {
	          this.sortingStatusBilling.jobblerNameSortStatus.default = true;
	          this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerNameSortStatus.desc = false;
	
	          this.sortingStatusBilling.eventIdSortStatus.default = false;
	          this.sortingStatusBilling.eventIdSortStatus.desc = true;
	
	          params.sort = "payment_date_created";
	          params.order = "desc";
	
	          this.getBill(params);
	        }
	      } else if (field === "rate") {
	        if (this.sortingStatusBilling.rateSortStatus.default === true) {
	          this.sortingStatusBilling.payDate.default = true;
	          this.sortingStatusBilling.payDate.asc = false;
	          this.sortingStatusBilling.payDate.desc = false;
	
	          this.sortingStatusBilling.jobblerNameSortStatus.default = true;
	          this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerNameSortStatus.desc = false;
	
	          this.sortingStatusBilling.rateSortStatus.default = false;
	          this.sortingStatusBilling.rateSortStatus.asc = false;
	          this.sortingStatusBilling.rateSortStatus.desc = true;
	
	          this.sortingStatusBilling.hoursSortStatus.default = true;
	          this.sortingStatusBilling.hoursSortStatus.asc = false;
	          this.sortingStatusBilling.hoursSortStatus.desc = false;
	
	          this.sortingStatusBilling.jobblerPaidSortStatus.default = true;
	          this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;
	
	          this.sortingStatusBilling.platformFeeSortStatus.default = true;
	          this.sortingStatusBilling.platformFeeSortStatus.asc = false;
	          this.sortingStatusBilling.platformFeeSortStatus.desc = false;
	
	          this.sortingStatusBilling.totalChargeSortStatus.default = true;
	          this.sortingStatusBilling.totalChargeSortStatus.asc = false;
	          this.sortingStatusBilling.totalChargeSortStatus.desc = false;
	
	          this.sortingStatusBilling.eventIdSortStatus.default = true;
	          this.sortingStatusBilling.eventIdSortStatus.asc = false;
	          this.sortingStatusBilling.eventIdSortStatus.desc = false;
	
	          params.sort = "rate";
	          params.order = "desc";
	
	          this.getBill(params);
	        } else if (this.sortingStatusBilling.rateSortStatus.desc === true) {
	          this.sortingStatusBilling.rateSortStatus.default = false;
	          this.sortingStatusBilling.rateSortStatus.asc = true;
	          this.sortingStatusBilling.rateSortStatus.desc = false;
	
	          params.sort = "rate";
	          params.order = "asc";
	
	          this.getBill(params);
	        } else if (this.sortingStatusBilling.rateSortStatus.asc === true) {
	          this.sortingStatusBilling.rateSortStatus.default = true;
	          this.sortingStatusBilling.rateSortStatus.asc = false;
	          this.sortingStatusBilling.rateSortStatus.desc = false;
	
	          this.sortingStatusBilling.eventIdSortStatus.default = false;
	          this.sortingStatusBilling.eventIdSortStatus.desc = true;
	
	          params.sort = "payment_date_created";
	          params.order = "desc";
	
	          this.getBill(params);
	        }
	      } else if (field === "hours") {
	        if (this.sortingStatusBilling.hoursSortStatus.default === true) {
	          this.sortingStatusBilling.payDate.default = true;
	          this.sortingStatusBilling.payDate.asc = false;
	          this.sortingStatusBilling.payDate.desc = false;
	
	          this.sortingStatusBilling.jobblerNameSortStatus.default = true;
	          this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerNameSortStatus.desc = false;
	
	          this.sortingStatusBilling.rateSortStatus.default = true;
	          this.sortingStatusBilling.rateSortStatus.asc = false;
	          this.sortingStatusBilling.rateSortStatus.desc = false;
	
	          this.sortingStatusBilling.hoursSortStatus.default = false;
	          this.sortingStatusBilling.hoursSortStatus.asc = false;
	          this.sortingStatusBilling.hoursSortStatus.desc = true;
	
	          this.sortingStatusBilling.jobblerPaidSortStatus.default = true;
	          this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;
	
	          this.sortingStatusBilling.platformFeeSortStatus.default = true;
	          this.sortingStatusBilling.platformFeeSortStatus.asc = false;
	          this.sortingStatusBilling.platformFeeSortStatus.desc = false;
	
	          this.sortingStatusBilling.totalChargeSortStatus.default = true;
	          this.sortingStatusBilling.totalChargeSortStatus.asc = false;
	          this.sortingStatusBilling.totalChargeSortStatus.desc = false;
	
	          this.sortingStatusBilling.eventIdSortStatus.default = true;
	          this.sortingStatusBilling.eventIdSortStatus.asc = false;
	          this.sortingStatusBilling.eventIdSortStatus.desc = false;
	
	          params.sort = "hours";
	          params.order = "desc";
	
	          this.getBill(params);
	        } else if (this.sortingStatusBilling.hoursSortStatus.desc === true) {
	          this.sortingStatusBilling.hoursSortStatus.default = false;
	          this.sortingStatusBilling.hoursSortStatus.asc = true;
	          this.sortingStatusBilling.hoursSortStatus.desc = false;
	
	          params.sort = "hours";
	          params.order = "asc";
	
	          this.getBill(params);
	        } else if (this.sortingStatusBilling.hoursSortStatus.asc === true) {
	          this.sortingStatusBilling.hoursSortStatus.default = true;
	          this.sortingStatusBilling.hoursSortStatus.asc = false;
	          this.sortingStatusBilling.hoursSortStatus.desc = false;
	
	          this.sortingStatusBilling.eventIdSortStatus.default = false;
	          this.sortingStatusBilling.eventIdSortStatus.desc = true;
	
	          params.sort = "payment_date_created";
	          params.order = "desc";
	
	          this.getBill(params);
	        }
	      } else if (field === "jobblerPaid") {
	        if (this.sortingStatusBilling.jobblerPaidSortStatus.default === true) {
	          this.sortingStatusBilling.payDate.default = true;
	          this.sortingStatusBilling.payDate.asc = false;
	          this.sortingStatusBilling.payDate.desc = false;
	
	          this.sortingStatusBilling.jobblerNameSortStatus.default = true;
	          this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerNameSortStatus.desc = false;
	
	          this.sortingStatusBilling.rateSortStatus.default = true;
	          this.sortingStatusBilling.rateSortStatus.asc = false;
	          this.sortingStatusBilling.rateSortStatus.desc = false;
	
	          this.sortingStatusBilling.hoursSortStatus.default = true;
	          this.sortingStatusBilling.hoursSortStatus.asc = false;
	          this.sortingStatusBilling.hoursSortStatus.desc = false;
	
	          this.sortingStatusBilling.jobblerPaidSortStatus.default = false;
	          this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerPaidSortStatus.desc = true;
	
	          this.sortingStatusBilling.platformFeeSortStatus.default = true;
	          this.sortingStatusBilling.platformFeeSortStatus.asc = false;
	          this.sortingStatusBilling.platformFeeSortStatus.desc = false;
	
	          this.sortingStatusBilling.totalChargeSortStatus.default = true;
	          this.sortingStatusBilling.totalChargeSortStatus.asc = false;
	          this.sortingStatusBilling.totalChargeSortStatus.desc = false;
	
	          this.sortingStatusBilling.eventIdSortStatus.default = true;
	          this.sortingStatusBilling.eventIdSortStatus.asc = false;
	          this.sortingStatusBilling.eventIdSortStatus.desc = false;
	
	          params.sort = "jobblerPaid";
	          params.order = "desc";
	
	          this.getBill(params);
	        } else if (this.sortingStatusBilling.jobblerPaidSortStatus.desc === true) {
	          this.sortingStatusBilling.jobblerPaidSortStatus.default = false;
	          this.sortingStatusBilling.jobblerPaidSortStatus.asc = true;
	          this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;
	
	          params.sort = "jobblerPaid";
	          params.order = "asc";
	
	          this.getBill(params);
	        } else if (this.sortingStatusBilling.jobblerPaidSortStatus.asc === true) {
	          this.sortingStatusBilling.jobblerPaidSortStatus.default = true;
	          this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;
	
	          this.sortingStatusBilling.eventIdSortStatus.default = false;
	          this.sortingStatusBilling.eventIdSortStatus.desc = true;
	
	          params.sort = "payment_date_created";
	          params.order = "desc";
	
	          this.getBill(params);
	        }
	      } else if (field === "platformFee") {
	        if (this.sortingStatusBilling.platformFeeSortStatus.default === true) {
	          this.sortingStatusBilling.payDate.default = true;
	          this.sortingStatusBilling.payDate.asc = false;
	          this.sortingStatusBilling.payDate.desc = false;
	
	          this.sortingStatusBilling.jobblerNameSortStatus.default = true;
	          this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerNameSortStatus.desc = false;
	
	          this.sortingStatusBilling.rateSortStatus.default = true;
	          this.sortingStatusBilling.rateSortStatus.asc = false;
	          this.sortingStatusBilling.rateSortStatus.desc = false;
	
	          this.sortingStatusBilling.hoursSortStatus.default = true;
	          this.sortingStatusBilling.hoursSortStatus.asc = false;
	          this.sortingStatusBilling.hoursSortStatus.desc = false;
	
	          this.sortingStatusBilling.jobblerPaidSortStatus.default = true;
	          this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;
	
	          this.sortingStatusBilling.platformFeeSortStatus.default = false;
	          this.sortingStatusBilling.platformFeeSortStatus.asc = false;
	          this.sortingStatusBilling.platformFeeSortStatus.desc = true;
	
	          this.sortingStatusBilling.totalChargeSortStatus.default = true;
	          this.sortingStatusBilling.totalChargeSortStatus.asc = false;
	          this.sortingStatusBilling.totalChargeSortStatus.desc = false;
	
	          this.sortingStatusBilling.eventIdSortStatus.default = true;
	          this.sortingStatusBilling.eventIdSortStatus.asc = false;
	          this.sortingStatusBilling.eventIdSortStatus.desc = false;
	
	          params.sort = "platformFee";
	          params.order = "desc";
	
	          this.getBill(params);
	        } else if (this.sortingStatusBilling.platformFeeSortStatus.desc === true) {
	          this.sortingStatusBilling.platformFeeSortStatus.default = false;
	          this.sortingStatusBilling.platformFeeSortStatus.asc = true;
	          this.sortingStatusBilling.platformFeeSortStatus.desc = false;
	
	          params.sort = "platformFee";
	          params.order = "asc";
	
	          this.getBill(params);
	        } else if (this.sortingStatusBilling.platformFeeSortStatus.asc === true) {
	          this.sortingStatusBilling.platformFeeSortStatus.default = true;
	          this.sortingStatusBilling.platformFeeSortStatus.asc = false;
	          this.sortingStatusBilling.platformFeeSortStatus.desc = false;
	
	          this.sortingStatusBilling.eventIdSortStatus.default = false;
	          this.sortingStatusBilling.eventIdSortStatus.desc = true;
	
	          params.sort = "payment_date_created";
	          params.order = "desc";
	
	          this.getBill(params);
	        }
	      } else if (field === "totalCharge") {
	        if (this.sortingStatusBilling.totalChargeSortStatus.default === true) {
	          this.sortingStatusBilling.payDate.default = true;
	          this.sortingStatusBilling.payDate.asc = false;
	          this.sortingStatusBilling.payDate.desc = false;
	
	          this.sortingStatusBilling.jobblerNameSortStatus.default = true;
	          this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerNameSortStatus.desc = false;
	
	          this.sortingStatusBilling.rateSortStatus.default = true;
	          this.sortingStatusBilling.rateSortStatus.asc = false;
	          this.sortingStatusBilling.rateSortStatus.desc = false;
	
	          this.sortingStatusBilling.hoursSortStatus.default = true;
	          this.sortingStatusBilling.hoursSortStatus.asc = false;
	          this.sortingStatusBilling.hoursSortStatus.desc = false;
	
	          this.sortingStatusBilling.jobblerPaidSortStatus.default = true;
	          this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;
	
	          this.sortingStatusBilling.platformFeeSortStatus.default = true;
	          this.sortingStatusBilling.platformFeeSortStatus.asc = false;
	          this.sortingStatusBilling.platformFeeSortStatus.desc = false;
	
	          this.sortingStatusBilling.totalChargeSortStatus.default = false;
	          this.sortingStatusBilling.totalChargeSortStatus.asc = false;
	          this.sortingStatusBilling.totalChargeSortStatus.desc = true;
	
	          this.sortingStatusBilling.eventIdSortStatus.default = true;
	          this.sortingStatusBilling.eventIdSortStatus.asc = false;
	          this.sortingStatusBilling.eventIdSortStatus.desc = false;
	
	          params.sort = "totalCharge";
	          params.order = "desc";
	
	          this.getBill(params);
	        } else if (this.sortingStatusBilling.totalChargeSortStatus.desc === true) {
	          this.sortingStatusBilling.totalChargeSortStatus.default = false;
	          this.sortingStatusBilling.totalChargeSortStatus.asc = true;
	          this.sortingStatusBilling.totalChargeSortStatus.desc = false;
	
	          params.sort = "totalCharge";
	          params.order = "asc";
	
	          this.getBill(params);
	        } else if (this.sortingStatusBilling.totalChargeSortStatus.asc === true) {
	          this.sortingStatusBilling.totalChargeSortStatus.default = true;
	          this.sortingStatusBilling.totalChargeSortStatus.asc = false;
	          this.sortingStatusBilling.totalChargeSortStatus.desc = false;
	
	          this.sortingStatusBilling.eventIdSortStatus.default = false;
	          this.sortingStatusBilling.eventIdSortStatus.desc = true;
	
	          params.sort = "payment_date_created";
	          params.order = "desc";
	
	          this.getBill(params);
	        }
	      } else if (field === "eventId") {
	        if (this.sortingStatusBilling.eventIdSortStatus.default === true) {
	          this.sortingStatusBilling.payDate.default = true;
	          this.sortingStatusBilling.payDate.asc = false;
	          this.sortingStatusBilling.payDate.desc = false;
	
	          this.sortingStatusBilling.jobblerNameSortStatus.default = true;
	          this.sortingStatusBilling.jobblerNameSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerNameSortStatus.desc = false;
	
	          this.sortingStatusBilling.rateSortStatus.default = true;
	          this.sortingStatusBilling.rateSortStatus.asc = false;
	          this.sortingStatusBilling.rateSortStatus.desc = false;
	
	          this.sortingStatusBilling.hoursSortStatus.default = true;
	          this.sortingStatusBilling.hoursSortStatus.asc = false;
	          this.sortingStatusBilling.hoursSortStatus.desc = false;
	
	          this.sortingStatusBilling.jobblerPaidSortStatus.default = true;
	          this.sortingStatusBilling.jobblerPaidSortStatus.asc = false;
	          this.sortingStatusBilling.jobblerPaidSortStatus.desc = false;
	
	          this.sortingStatusBilling.platformFeeSortStatus.default = true;
	          this.sortingStatusBilling.platformFeeSortStatus.asc = false;
	          this.sortingStatusBilling.platformFeeSortStatus.desc = false;
	
	          this.sortingStatusBilling.totalChargeSortStatus.default = true;
	          this.sortingStatusBilling.totalChargeSortStatus.asc = false;
	          this.sortingStatusBilling.totalChargeSortStatus.desc = false;
	
	          this.sortingStatusBilling.eventIdSortStatus.default = false;
	          this.sortingStatusBilling.eventIdSortStatus.asc = false;
	          this.sortingStatusBilling.eventIdSortStatus.desc = true;
	
	          params.sort = "shiftStartDate";
	          params.order = "desc";
	
	          this.getBill(params);
	        } else if (this.sortingStatusBilling.eventIdSortStatus.desc === true) {
	          this.sortingStatusBilling.eventIdSortStatus.default = false;
	          this.sortingStatusBilling.eventIdSortStatus.asc = true;
	          this.sortingStatusBilling.eventIdSortStatus.desc = false;
	
	          params.sort = "shiftStartDate";
	          params.order = "asc";
	
	          this.getBill(params);
	        } else if (this.sortingStatusBilling.eventIdSortStatus.asc === true) {
	          this.sortingStatusBilling.eventIdSortStatus.default = true;
	          this.sortingStatusBilling.eventIdSortStatus.asc = false;
	          this.sortingStatusBilling.eventIdSortStatus.desc = false;
	
	          params.sort = "payment_date_created";
	          params.order = "desc";
	
	          this.getBill(params);
	        }
	      }
	    }
	  }, {
	    key: "sortTable",
	    value: function sortTable(field) {
	      var params = { offset: 0, sort: "invoiceDate", order: "desc", max: 30, search: null, start: null, end: null };
	
	      if (field === "invoiceId") {
	        if (this.sortingStatus.invoiceIdSortStatus.default === true) {
	          this.sortingStatus.invoiceIdSortStatus.default = false;
	          this.sortingStatus.invoiceIdSortStatus.asc = false;
	          this.sortingStatus.invoiceIdSortStatus.desc = true;
	
	          this.sortingStatus.amountSortStatus.default = true;
	          this.sortingStatus.amountSortStatus.asc = false;
	          this.sortingStatus.amountSortStatus.desc = false;
	
	          this.sortingStatus.invoiceDateSortStatus.default = true;
	          this.sortingStatus.invoiceDateSortStatus.asc = false;
	          this.sortingStatus.invoiceDateSortStatus.desc = false;
	
	          this.sortingStatus.paymentMethodSortStatus.default = true;
	          this.sortingStatus.paymentMethodSortStatus.asc = false;
	          this.sortingStatus.paymentMethodSortStatus.desc = false;
	
	          params.sort = "invoiceId";
	          params.order = "desc";
	
	          this.getInvoices(params);
	        } else if (this.sortingStatus.invoiceIdSortStatus.desc === true) {
	          this.sortingStatus.invoiceIdSortStatus.default = false;
	          this.sortingStatus.invoiceIdSortStatus.asc = true;
	          this.sortingStatus.invoiceIdSortStatus.desc = false;
	
	          params.sort = "invoiceId";
	          params.order = "asc";
	
	          this.getInvoices(params);
	        } else if (this.sortingStatus.invoiceIdSortStatus.asc === true) {
	          this.sortingStatus.invoiceIdSortStatus.default = true;
	          this.sortingStatus.invoiceIdSortStatus.asc = false;
	          this.sortingStatus.invoiceIdSortStatus.desc = false;
	
	          params.sort = "invoiceDate";
	          params.order = "desc";
	
	          this.getInvoices(params);
	        }
	      } else if (field === "amount") {
	        if (this.sortingStatus.amountSortStatus.default === true) {
	          this.sortingStatus.invoiceIdSortStatus.default = true;
	          this.sortingStatus.invoiceIdSortStatus.asc = false;
	          this.sortingStatus.invoiceIdSortStatus.desc = false;
	
	          this.sortingStatus.amountSortStatus.default = false;
	          this.sortingStatus.amountSortStatus.asc = false;
	          this.sortingStatus.amountSortStatus.desc = true;
	
	          this.sortingStatus.invoiceDateSortStatus.default = true;
	          this.sortingStatus.invoiceDateSortStatus.asc = false;
	          this.sortingStatus.invoiceDateSortStatus.desc = false;
	
	          this.sortingStatus.paymentMethodSortStatus.default = true;
	          this.sortingStatus.paymentMethodSortStatus.asc = false;
	          this.sortingStatus.paymentMethodSortStatus.desc = false;
	
	          params.sort = "amount";
	          params.order = "desc";
	
	          this.getInvoices(params);
	        } else if (this.sortingStatus.amountSortStatus.desc === true) {
	          this.sortingStatus.amountSortStatus.default = false;
	          this.sortingStatus.amountSortStatus.asc = true;
	          this.sortingStatus.amountSortStatus.desc = false;
	
	          params.sort = "amount";
	          params.order = "asc";
	
	          this.getInvoices(params);
	        } else if (this.sortingStatus.amountSortStatus.asc === true) {
	          this.sortingStatus.amountSortStatus.default = true;
	          this.sortingStatus.amountSortStatus.asc = false;
	          this.sortingStatus.amountSortStatus.desc = false;
	
	          params.sort = "invoiceDate";
	          params.order = "desc";
	
	          this.getInvoices(params);
	        }
	      } else if (field === "date") {
	        if (this.sortingStatus.invoiceDateSortStatus.default === true) {
	          this.sortingStatus.invoiceIdSortStatus.default = true;
	          this.sortingStatus.invoiceIdSortStatus.asc = false;
	          this.sortingStatus.invoiceIdSortStatus.desc = false;
	
	          this.sortingStatus.amountSortStatus.default = true;
	          this.sortingStatus.amountSortStatus.asc = false;
	          this.sortingStatus.amountSortStatus.desc = false;
	
	          this.sortingStatus.invoiceDateSortStatus.default = false;
	          this.sortingStatus.invoiceDateSortStatus.asc = false;
	          this.sortingStatus.invoiceDateSortStatus.desc = true;
	
	          this.sortingStatus.paymentMethodSortStatus.default = true;
	          this.sortingStatus.paymentMethodSortStatus.asc = false;
	          this.sortingStatus.paymentMethodSortStatus.desc = false;
	
	          params.sort = "invoiceDate";
	          params.order = "desc";
	
	          this.getInvoices(params);
	        } else if (this.sortingStatus.invoiceDateSortStatus.desc === true) {
	          this.sortingStatus.invoiceDateSortStatus.default = false;
	          this.sortingStatus.invoiceDateSortStatus.asc = true;
	          this.sortingStatus.invoiceDateSortStatus.desc = false;
	
	          params.sort = "invoiceDate";
	          params.order = "asc";
	
	          this.getInvoices(params);
	        } else if (this.sortingStatus.invoiceDateSortStatus.asc === true) {
	          this.sortingStatus.invoiceDateSortStatus.default = true;
	          this.sortingStatus.invoiceDateSortStatus.asc = false;
	          this.sortingStatus.invoiceDateSortStatus.desc = false;
	
	          params.sort = "invoiceDate";
	          params.order = "desc";
	
	          this.getInvoices(params);
	        }
	      } else if (field === "payment") {
	        if (this.sortingStatus.paymentMethodSortStatus.default === true) {
	          this.sortingStatus.invoiceIdSortStatus.default = true;
	          this.sortingStatus.invoiceIdSortStatus.asc = false;
	          this.sortingStatus.invoiceIdSortStatus.desc = false;
	
	          this.sortingStatus.amountSortStatus.default = true;
	          this.sortingStatus.amountSortStatus.asc = false;
	          this.sortingStatus.amountSortStatus.desc = false;
	
	          this.sortingStatus.invoiceDateSortStatus.default = true;
	          this.sortingStatus.invoiceDateSortStatus.asc = false;
	          this.sortingStatus.invoiceDateSortStatus.desc = false;
	
	          this.sortingStatus.paymentMethodSortStatus.default = false;
	          this.sortingStatus.paymentMethodSortStatus.asc = false;
	          this.sortingStatus.paymentMethodSortStatus.desc = true;
	
	          this.getInvoices();
	        } else if (this.sortingStatus.paymentMethodSortStatus.desc === true) {
	          this.sortingStatus.paymentMethodSortStatus.default = false;
	          this.sortingStatus.paymentMethodSortStatus.asc = true;
	          this.sortingStatus.paymentMethodSortStatus.desc = false;
	
	          this.getInvoices();
	        } else if (this.sortingStatus.paymentMethodSortStatus.asc === true) {
	          this.sortingStatus.paymentMethodSortStatus.default = true;
	          this.sortingStatus.paymentMethodSortStatus.asc = false;
	          this.sortingStatus.paymentMethodSortStatus.desc = false;
	
	          this.getInvoices();
	        }
	      }
	    }
	  }, {
	    key: "checkAll",
	    value: function checkAll() {
	      if (this.uiViews.all_checked === false) {
	        this.uiViews.all_checked = true;
	        this.checkOrUncheckAll(true);
	      } else {
	        this.uiViews.all_checked = false;
	        this.checkOrUncheckAll(false);
	      }
	
	      this.checkForAtleastOneCheckedInvoice();
	    }
	  }, {
	    key: "checkOrUncheckAll",
	    value: function checkOrUncheckAll(checked) {
	      this.invoiceViewList.forEach(function (invoice) {
	        invoice.isChecked = checked;
	      });
	    }
	  }, {
	    key: "checkForAtleastOneCheckedInvoice",
	    value: function checkForAtleastOneCheckedInvoice() {
	      var _this = this;
	
	      _this.invoiceViewList.forEach(function (invoice) {
	        if (invoice.isChecked !== true) {
	          _this.uiViews.one_checked_invoice = false;
	        }
	      });
	
	      _this.invoiceViewList.forEach(function (invoice) {
	        if (invoice.isChecked === true) {
	          _this.uiViews.one_checked_invoice = true;
	        }
	      });
	    }
	  }, {
	    key: "start",
	    value: function start() {
	      this.setLoader();
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "invoiceSearchSubmit",
	    value: function invoiceSearchSubmit() {
	      var params = {
	        offset: 0,
	        sort: "invoiceDate",
	        order: "desc",
	        max: 30,
	        search: this.billingSearch,
	        start: null,
	        end: null
	      };
	
	      this.getInvoices(params);
	    }
	  }, {
	    key: "goToBill",
	    value: function goToBill(id, bill) {
	      //this.billDate = bill.invoiceDateForView;
	      //this.$state.go("bill", {"billId" : id});
	    }
	  }, {
	    key: "billSearchSubmit",
	    value: function billSearchSubmit() {
	      var params = {
	        offset: 0,
	        sort: "eventId",
	        order: "desc",
	        max: 30,
	        search: this.billSearch,
	        start: null,
	        end: null,
	        billId: this.$state.params.billId
	      };
	
	      this.getBill(params);
	    }
	  }, {
	    key: "fancyLoad",
	    value: function fancyLoad() {
	      /*
	      this.$timeout(() => {
	        $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table tbody tr").hide();
	      });
	      */
	
	      this.$timeout(function () {
	        $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table tbody tr").each(function (index) {
	          $(this).delay(index * 10).show(50);
	        });
	      }, 200);
	    }
	  }, {
	    key: "exitTutorial",
	    value: function exitTutorial(step) {
	      if (step === 1) {
	        this.$timeout(function () {
	          $("#tutorial-modal.tutorial-1").addClass("exit-tutorial");
	        });
	      } else if (step === 2) {
	        this.$timeout(function () {
	          $("#tutorial-modal.tutorial-2").addClass("exit-tutorial");
	        });
	      } else if (step === 3) {
	        this.$timeout(function () {
	          $("#tutorial-modal.tutorial-3").addClass("exit-tutorial");
	        });
	      } else if (step === 4) {
	        this.$timeout(function () {
	          $("#tutorial-modal.tutorial-4").addClass("exit-tutorial");
	        });
	      } else if (step === 5) {
	        this.$timeout(function () {
	          $("#tutorial-modal.tutorial-5").removeClass("show-tutorial");
	          $("#tutorial-modal.tutorial-5").addClass("exit-tutorial");
	        });
	      } else if (step === 6) {
	        this.$timeout(function () {
	          $("#tutorial-modal.tutorial-5").removeClass("show-tutorial");
	          $("#tutorial-modal.tutorial-5").addClass("exit-tutorial");
	        });
	      } else if (step === 7) {
	        this.$timeout(function () {
	          $("#tutorial-modal.tutorial-6").removeClass("show-tutorial");
	          $("#tutorial-modal.tutorial-6").addClass("exit-tutorial");
	        });
	      } else if (step === 8) {
	        this.$timeout(function () {
	          $("#tutorial-modal.tutorial-8").removeClass("show-tutorial");
	          $("#tutorial-modal.tutorial-8").addClass("exit-tutorial");
	        });
	      }
	
	      this.updateTutorialTracking(true);
	    }
	  }, {
	    key: "updateTutorialTracking",
	    value: function updateTutorialTracking(stopTutorial) {
	      var _this8 = this;
	
	      var userBillingInfo = { billingTutorialTracking: stopTutorial };
	
	      this.$profile.saveUser(userBillingInfo).then(function (response) {
	        _this8.$timeout(function () {
	          _this8.getUsersLatestTutorialData(_this8.currentUser, userBillingInfo);
	        }, 1000);
	      }, function (error) {
	        console.log("in error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "getUsersLatestTutorialData",
	    value: function getUsersLatestTutorialData(user, userBillingInfo) {
	      var _this9 = this;
	
	      this.$auth.refreshCurrentUserBilling().then(function (response) {
	        if (response.billingTutorialTracking === true || userBillingInfo && userBillingInfo.billingTutorialTracking === true) {} else {
	          _this9.continueTutorial(5, null);
	        }
	      }, function (error) {
	        console.log("in error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "continueTutorial",
	    value: function continueTutorial(step, invoice) {
	      var _this10 = this;
	
	      console.log("continueTutorial");
	      console.dir(step);
	
	      if (step === 1) {
	        this.$timeout(function () {
	          $("#tutorial-modal.tutorial-1").addClass("exit-tutorial");
	          $("#tutorial-modal.tutorial-2").addClass("show-tutorial");
	        });
	      } else if (step === 2) {
	        this.$timeout(function () {
	          $("#tutorial-modal.tutorial-2").addClass("exit-tutorial");
	          $("#tutorial-modal.tutorial-3").addClass("show-tutorial");
	        });
	      } else if (step === 3) {
	        this.$timeout(function () {
	          $("#tutorial-modal.tutorial-3").addClass("exit-tutorial");
	          $("#tutorial-modal.tutorial-4").addClass("show-tutorial");
	        });
	      } else if (step === 4) {
	        this.$timeout(function () {
	          $("#tutorial-modal.tutorial-4").addClass("exit-tutorial");
	        });
	      } else if (step === 5) {
	        this.$timeout(function () {
	          $("#tutorial-modal.tutorial-5").addClass("show-tutorial");
	        });
	      } else if (step === 6) {
	        this.$timeout(function () {
	          $("#tutorial-modal.tutorial-5").removeClass("show-tutorial");
	          $("#tutorial-modal.tutorial-5").addClass("exit-tutorial");
	          $("#tutorial-modal.tutorial-6").addClass("show-tutorial");
	        });
	      } else if (step === 7) {
	        this.$timeout(function () {
	          $("#tutorial-modal.tutorial-6").removeClass("show-tutorial");
	          $("#tutorial-modal.tutorial-6").addClass("exit-tutorial");
	          $("#tutorial-modal.tutorial-7").addClass("show-tutorial");
	        });
	      } else if (step === 8) {
	        this.$timeout(function () {
	          $("#tutorial-modal.tutorial-7").removeClass("show-tutorial");
	          $("#tutorial-modal.tutorial-7").addClass("exit-tutorial");
	          $("#tutorial-modal.tutorial-8").addClass("show-tutorial");
	          _this10.updateTutorialTracking(true);
	        });
	      }
	    }
	  }, {
	    key: "exportbill",
	    value: function exportbill(invoice) {
	      var _this11 = this;
	
	      console.log("export bill");
	      console.dir(invoice);
	
	      this.csv = null;
	      this.billCsvName = null;
	      var dateObj = {};
	      dateObj.startDate = invoice.periodStartRaw;
	      dateObj.endDate = invoice.periodEndRaw;
	
	      this.formatInvoiceStartDate(dateObj);
	
	      if (invoice) {
	        var data = {
	          billId: invoice.id,
	          end: null,
	          max: 100,
	          offset: 0,
	          order: "asc",
	          search: null,
	          sort: "payment_date_created",
	          start: null
	        };
	
	        return new Promise(function (resolve, reject) {
	          _this11.$companies.getBill(data).then(function (response) {
	            console.log("what is resolved..");
	            console.dir(response);
	
	            var bills = response.data.invoiceDetails;
	            var formattedBills = [];
	
	            try {
	              for (var index = 0; index < bills.length; index++) {
	                var bill = bills[index];
	                var billView = {};
	
	                billView.eventId = bill.eventId;
	                billView.shiftDate = _this11.formatShiftStartDate(bill);
	                billView.paymentDate = _this11.formatPaymentDate(bill.payment_date_created);
	                billView.name = bill.jobblerName;
	                billView.rate = _this11.formatRate(bill.rate);
	                billView.hours = bill.hours;
	                billView.jobblerPaid = _this11.formatInvoiceAmount(bill.jobblerPaid);
	                billView.platformFee = _this11.formatInvoiceAmount(bill.platformFee);
	                billView.totalCharge = _this11.formatInvoiceAmount(bill.totalCharge);
	                billView.tooltip = _this11.formatToolTip(bill);
	                billView.memo = bill.memo;
	
	                formattedBills.push(billView);
	              }
	            } catch (err) {
	              console.log("Error formatting bills :", err);
	            } finally {
	              _this11.finish();
	              var csv = [];
	
	              try {
	                formattedBills.forEach(function (bill, i) {
	                  var csvObj = {
	                    pay_date: bill.paymentDate,
	                    name: bill.name,
	                    rate: bill.rate,
	                    hours: bill.hours,
	                    jobbler_paid: bill.jobblerPaid,
	                    platformFee: bill.platformFee,
	                    total_charge: bill.totalCharge,
	                    shift_date: bill.shiftDate,
	                    event_id: bill.eventId,
	                    memo: bill.memo
	                  };
	                  csv.push(csvObj);
	                });
	              } catch (err) {} finally {
	                _this11.setAccountLevelDetails(csv);
	                console.log("do we have csv");
	                console.dir(csv);
	
	                resolve(csv);
	              }
	            }
	          }, function (error) {
	            console.error(error);
	            reject();
	          });
	        });
	      }
	    }
	  }]);
	
	  return BillingController;
	}();
	
	BillingController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "companies", "security", "profile", "$timeout", "$rootScope", "env", "ngProgressFactory", "$scope", "$location"];
	
	exports.default = BillingController;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(445);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices{padding-top:15px}.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices thead th:nth-child(3):hover,.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices thead th:nth-child(4):hover{cursor:pointer}.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices tbody tr{height:58px}.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices tbody tr td:first-child a{color:#5498b4;font-weight:900;text-decoration:underline}.jobs-dashboard-container .jobs-dashboard-jobs-listing table.invoices thead th:first-child{width:200px}.jobs-dashboard-container .jobs-dashboard-jobs-listing table.invoices thead th:nth-child(2){padding-left:6px}.jobs-dashboard-container .jobs-dashboard-container-header h1.jobs-header.billing{width:100%}.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices.bill thead th:first-child{width:150px}.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices.bill thead th:nth-child(2){width:205px}.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices.bill thead th:nth-child(3){width:100px}.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices.bill thead th:nth-child(4),.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices.bill thead th:nth-child(5),.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices.bill thead th:nth-child(6),.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices.bill thead th:nth-child(7){width:150px}.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices.bill thead th:nth-child(8){width:120px}.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices.bill thead th{width:200px}.invoice-search-tools{width:312px;margin-right:5px;position:relative;margin-bottom:-15px;margin-top:15px}h5.dates-of-invoice{color:#33373a;margin-bottom:13px;font-family:Poppins,sans-serif;font-weight:700;padding-left:0;font-size:15px}h5.dates-of-invoice span{background-color:#33373a;color:#fff;padding:5px 10px;border-radius:5px}.invoice-search-tools.bill{width:365px}button.export i{margin-right:7px}button.export{box-sizing:border-box;height:46px;width:125px;border:2px solid #5e666d;border-radius:6px;position:absolute;right:8px;bottom:-15px;color:#33373a}button.export,button.export:hover{font-family:Poppins;font-size:14px;font-weight:600}button.export:hover{color:#fff;background-color:#33373a}.invoice-search-tools form input[type=text]{width:88%;cursor:text;box-shadow:0 2px 4px 0 rgb(0 0 0/10%);box-sizing:border-box;height:40px;width:100%;border:1px solid #dfe5e8;border-radius:5px;background-color:#fff;padding-left:40px;-webkit-appearance:none;-moz-appearance:none;appearance:none}.prior-billing-history{color:#5498b4;font-family:Poppins;font-size:12px;font-weight:700;letter-spacing:.26px;line-height:18px;text-decoration:underline}.prior-billing-history:hover{color:#5498b4;text-decoration:none}.invoice-search-tools form input[type=text]::placeholder{color:#8697a8}.invoice-search-tools i.search-icon{color:#8697a8;position:absolute;top:14px;font-size:15px;left:14px;pointer-events:none}#tutorial-modal{position:absolute;width:236px;border-radius:6px;background-color:#5e666d;box-shadow:0 25px 50px 0 rgb(78 81 144/7%);padding:10px;color:#fff;z-index:100;font-family:Poppins;font-size:12px}#tutorial-modal.tutorial-1{left:334px;top:-26px;display:none}#tutorial-modal.tutorial-2{left:91px;top:-16px;display:none}#tutorial-modal.tutorial-3{right:-264px;top:-25px;display:none}#tutorial-modal.tutorial-4{top:-17px;left:-255px;display:none}#tutorial-modal.tutorial-5{top:-17px;left:-37px;display:none}#tutorial-modal.tutorial-6{left:387px;top:-28px;display:none}#tutorial-modal.tutorial-7{left:-387px;top:-56px;display:none}#tutorial-modal.tutorial-8{left:-249px;top:-17px;display:none}#tutorial-modal .divider{width:100%;margin:0 auto;margin-top:10px;margin-bottom:10px;border:1px solid silver}#tutorial-modal .tutorial-1-triangle{position:absolute;z-index:200;width:0;height:0;border-top:8px solid transparent;border-right:16px solid #5e666d;border-bottom:8px solid transparent;top:39px;left:-16px}#tutorial-modal .tutorial-4-triangle,#tutorial-modal .tutorial-7-triangle{position:absolute;z-index:200;width:0;height:0;border-top:8px solid transparent;border-left:16px solid #5e666d;border-bottom:8px solid transparent;top:39px;right:-15px}#tutorial-modal.tutorial-1.exit-tutorial,#tutorial-modal.tutorial-2.exit-tutorial,#tutorial-modal.tutorial-3.exit-tutorial,#tutorial-modal.tutorial-4.exit-tutorial{display:none}#tutorial-modal.show-tutorial{display:block}table.jobs-dashboard-jobs-table tbody tr td.paid{color:#74cf59;font-weight:800}#tutorial-modal .tutorial-buttons a{color:#fff}#tutorial-modal .tutorial-buttons a:hover{color:#bddab4}#tutorial-modal .tutorial-buttons{text-decoration:underline}#tutorial-modal .tutorial-buttons.tutorial-next{float:right}table.jobs-dashboard-jobs-table.invoices tbody tr td:last-child .action-menu ul li{color:#5e666d;font-weight:600}table.jobs-dashboard-jobs-table.invoices tbody tr td:last-child .action-menu ul li a{padding-left:16px}table.jobs-dashboard-jobs-table.invoices tbody tr td:last-child .action-menu ul li:hover,table.jobs-dashboard-jobs-table.invoices tbody tr td:last-child .action-menu ul li a:hover{background-color:#e3ebef}table.jobs-dashboard-jobs-table.invoices tbody tr td:last-child .action-menu{width:200px;left:-143px;top:59px}@media screen and (max-width:1550px){.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices.bill thead th:nth-child(4){width:90px}}@media screen and (max-width:1200px){.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices.bill tbody tr td:last-child,.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices.bill thead th:last-child{display:none}}@media screen and (max-width:1100px){.jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table.invoices.bill thead th:nth-child(2){width:150px}}", ""]);
	
	// exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _transactionhistory = __webpack_require__(447);
	
	var _transactionhistory2 = _interopRequireDefault(_transactionhistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transactionhistoryModule = _angular2.default.module("transactionhistory", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("transactionhistory", {
	    url: "/receipts",
	    template: "<transactionhistory></transactionhistory>",
	    title: "Receipts"
	  });
	}).component("transactionhistory", _transactionhistory2.default);
	
	exports.default = transactionhistoryModule;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _transactionhistory = __webpack_require__(448);
	
	var _transactionhistory2 = _interopRequireDefault(_transactionhistory);
	
	var _transactionhistory3 = __webpack_require__(449);
	
	var _transactionhistory4 = _interopRequireDefault(_transactionhistory3);
	
	__webpack_require__(450);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transactionhistoryComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _transactionhistory2.default,
	  controller: _transactionhistory4.default,
	  controllerAs: "vm"
	};
	
	exports.default = transactionhistoryComponent;

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<leftnavigation></leftnavigation>\n\n<div class=\"jobs-dashboard-container\">\n  <div class=\"jobs-dashboard-container-header\">\n    <h1 class=\"jobs-header\">Receipts</h1>\n  </div>\n\n  <div>\n    <table class=\"jobble-table receipts\">\n      <thead>\n        <tr>\n          <th>Charge Date</th>\n          <th>Name</th>\n          <th>Username</th>\n          <th>Details</th>\n          <th>Charge</th>\n          <th>Receipt</th>\n        </tr>\n      </thead>\n      <tbody ng-if=\"vm.receipts.length == 0 && vm.uiViews.is_loading==true\" class=\"not-real-jobs-body\">\n        <tr ng-repeat=\"fakeReceipt in vm.fakeReceipts\" class=\"fake-jobs\">\n          <td colspan=\"10\"></td>\n        </tr>\n      </tbody>\n      <tbody ng-if=\"vm.receipts.length > 0 && vm.uiViews.is_loading==false\">\n        <tr ng-repeat=\"receipt in vm.receipts\">\n          <td>{{receipt.paymentDate}}</td>\n          <td>{{receipt.firstName}} {{receipt.lastName}}</td>\n          <td>{{receipt.email}}</td>\n          <td>\n            {{receipt.customNoteShort}}...&nbsp;&nbsp;\n            <label>\n              <span style=\"font-size: 12px; color: #5e666d\" data-toggle=\"tooltip\" data-placement=\"bottom\" title=\"{{receipt.customNote}}\">\n                <i class=\"fas fa-info-circle\"></i>\n              </span>\n            </label>\n          </td>\n          <td>{{receipt.charge}}</td>\n          <td>\n            <a href=\"{{receipt.url}}\" target=\"_blank\">View Receipt</a>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n\n    <div class=\"no-jobs-available\" ng-if=\"vm.receipts.length == 0 && vm.uiViews.is_loading==false\">\n      Receipts are generated once payments have been made.\n    </div>\n  </div>\n\n  <div class=\"jobs-dashboard-footer\" ng-show=\"vm.receipts.length > 0\">\n    <a class=\"pagination-for-jobs\" href=\"\" ng-click=\"vm.paginateReceipts()\" ng-class=\"{'pagination-disabled' : vm.checkForMoreReceipts() }\">\n      SHOW MORE <i class=\"fas fa-chevron-down\"></i>\n    </a>\n  </div>\n</div>\n\n<jobblefooter></jobblefooter>\n<jobblerprofile></jobblerprofile>\n\n<globalalert></globalalert>\n"

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TransactionhistoryController = function () {
	  function TransactionhistoryController($http, $localStorage, $state, $stateParams, AuthService, EventsService, CompaniesService, SecurityService, $rootScope, CommonService, EnvService, $timeout) {
	    _classCallCheck(this, TransactionhistoryController);
	
	    $localStorage.activeStateName = "invoices";
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	    this.name = "transactionhistory";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$companies = CompaniesService;
	    this.$events = EventsService;
	    this.$stateParams = $stateParams;
	    this.$security = SecurityService;
	    this.$rootScope = $rootScope;
	    this.currentPageNumber = 1;
	    this.$common = CommonService;
	    this.fakeReceipts = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25];
	    this.$env = EnvService;
	    this.$timeout = $timeout;
	    this.isPrivate = false;
	    this.isPreferred = false;
	    this.uiViews = {};
	    this.uiViews.is_loading = true;
	    this.receipts = [];
	    this.remain_loading_count = 1;
	    this.event = {};
	    this.teamsPostedTo = [];
	    this.acceptedApplicants = [];
	    this.currentUser = this.$auth.getUserData();
	    this.fileTypeId = null;
	    this.events = [];
	    var _this = this;
	
	    //_this.getClosedJobs();
	    _this.getCompanyPFDFileType();
	
	    _this.$timeout(function () {
	      $("jobbleheader .main-menu ul li:nth-child(3)").removeClass().addClass("active");
	    }, 300);
	  }
	
	  _createClass(TransactionhistoryController, [{
	    key: "formatPaymentCost",
	    value: function formatPaymentCost(receipts) {
	      var _this = this;
	      receipts.forEach(function (receipt, index) {
	        if (receipt.payment) {
	          receipt.adjustedAmount = receipt.payment[0].amount * (1 + _this.currentUser.company.defaultPlan.companyFeePct) / 100;
	        } else {
	          receipts.splice(index, 1);
	        }
	      });
	    }
	  }, {
	    key: "formatRecDate",
	    value: function formatRecDate(date) {
	      return moment(date).format("MM/DD/YY");
	    }
	  }, {
	    key: "paginate",
	    value: function paginate(offset) {
	      var _this = this;
	      _this.remain_loading_count++;
	      var params = {};
	      params.isClosed = "true";
	      params.companyId = _this.currentUser.company.id;
	      params.max = 20;
	      params.sort = "dateCreated";
	      params.order = "desc";
	      if (offset < 1 || offset > _this.pages.length) {
	        return;
	      }
	      _this.currentPageNumber = offset;
	      if (offset !== 0) {
	        offset = offset * 20 - 20;
	      }
	      params.offset = offset;
	      _this.getClosedJobs(params);
	    }
	  }, {
	    key: "getClosedJobs",
	    value: function getClosedJobs(data) {
	      console.log("getClosedJobs");
	      var _this = this;
	
	      var params = {};
	      if (!data) {
	        params.companyId = _this.currentUser.company.id;
	        params.isClosed = "true";
	        params.max = 20;
	        params.sort = "dateCreated";
	        params.order = "desc";
	      } else {
	        params = data;
	      }
	      _this.setLoader();
	
	      _this.$events.get_history(params).then(function (response) {
	        _this.remain_loading_count--;
	        _this.events = response.data;
	        _this.unSetLoader();
	        _this.setPages();
	      }, function (error) {
	        _this.remain_loading_count--;
	      });
	      params.offset = 0;
	    }
	  }, {
	    key: "setPages",
	    value: function setPages() {
	      var _this = this;
	
	      if (_this.currentUser.company.totalNumberOfCloseEvents) {
	        var pageArray = [];
	
	        for (var i = 0; i < Math.ceil(_this.currentUser.company.totalNumberOfCloseEvents / 20); i++) {
	          pageArray.push(i + 1);
	          _this.pages = pageArray;
	        }
	      }
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "initializeToolTip",
	    value: function initializeToolTip() {
	      this.$timeout(function () {
	        $(function () {
	          $('[data-toggle="tooltip"]').tooltip();
	        });
	      }, 500);
	    }
	  }, {
	    key: "constructCustomNote",
	    value: function constructCustomNote(note) {
	      var secondCustomNote = null;
	      var index = note.indexOf("event:");
	      console.log("each index");
	      console.dir(index);
	
	      if (index === -1) {
	        console.log("wat is index1");
	        secondCustomNote = note;
	      } else {
	        console.log("wat is index2");
	        index = index + 7;
	        console.dir(index);
	        var customNote = note.substring(index, note.length);
	        console.dir(customNote);
	        var secondIndex = customNote.indexOf("at the event:");
	
	        if (secondIndex !== -1) {
	          secondIndex = secondIndex - 2;
	          console.log("what is second index");
	          console.dir(secondIndex);
	          secondCustomNote = customNote.substring(0, secondIndex);
	        } else {
	          secondCustomNote = customNote;
	        }
	      }
	
	      console.log("what is custom note");
	      console.dir(secondCustomNote);
	
	      return secondCustomNote;
	    }
	  }, {
	    key: "processReceipts",
	    value: function processReceipts(receipts) {
	      var _this = this;
	
	      try {
	        receipts.forEach(function (r) {
	          console.log("each receipt");
	          console.dir(r.payedUser[0].email);
	          console.dir(r.payment[0].detailTransactionCompany);
	
	          r.paymentDate = moment(r.dateCreated).format("MM/DD/YYYY");
	          r.email = r.payedUser[0].email;
	          r.firstName = r.payedUser[0].firstName;
	          r.lastName = r.payedUser[0].lastName;
	          r.customNote = _this.constructCustomNote(r.payment[0].detailTransactionCompany);
	          if (r.customNote.length > 68) {
	            r.customNoteShort = r.customNote.substring(0, 68);
	          } else {
	            r.customNoteShort = r.customNote;
	          }
	          r.note = r.payment[0].detailTransactionCompany.substring(0, 90);
	          r.noteLong = r.payment[0].detailTransactionCompany;
	          r.charge = numeral(r.payment[0].amountCompany / 100).format("$0,0.00");
	          r.url = r.url;
	          _this.receipts.push(r);
	        });
	      } catch (err) {
	        console.error(err);
	      } finally {
	        console.log("in the finally");
	        console.dir(receipts);
	        console.dir(this.receipts);
	        //this.receipts = receipts;
	        //this.receipts.concat(receipts);
	        _this.initializeToolTip();
	        _this.unSetLoader();
	        _this.uiViews.is_loading = false;
	      }
	    }
	  }, {
	    key: "paginateReceipts",
	    value: function paginateReceipts() {
	      console.log("paginateReceipts");
	      if (this.currentUser.company.totalNumberOfInvoiceFiles === this.receipts.length) {
	        return;
	      }
	
	      this.getReceipts(15, this.fileTypeId, this.receipts.length);
	    }
	  }, {
	    key: "getReceipts",
	    value: function getReceipts(max, fileTypeId, offset) {
	      var _this2 = this;
	
	      console.log("getReceipts");
	      this.setLoader();
	
	      this.$companies.getDirectPaymentReceipts(max, fileTypeId, offset).then(function (response) {
	        console.log("receipts response");
	        console.dir(response);
	        if (response.data) {
	          _this2.processReceipts(response.data);
	        } else {
	          alert("Issue generating receipts");
	        }
	      }).catch(function (err) {
	        console.error("Error retrieving file types", err);
	      });
	    }
	  }, {
	    key: "getCompanyPFDFileType",
	    value: function getCompanyPFDFileType() {
	      var _this3 = this;
	
	      var fileTypeId = null;
	      this.uiViews.is_loading = true;
	      this.$companies.fileTypesReq().then(function (response) {
	        try {
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].name === "COMPANY_INVOICE_PDF") {
	              fileTypeId = response.data[i].id;
	              _this3.fileTypeId = fileTypeId;
	            }
	          }
	        } catch (err) {
	          _this3.uiViews.is_loading = false;
	          alert("Error getting file type: " + err);
	        } finally {
	          if (fileTypeId) {
	            _this3.getReceipts(15, fileTypeId, 0);
	          } else {
	            _this3.uiViews.is_loading = false;
	          }
	        }
	      }).catch(function (err) {
	        console.error("Error retrieving file types: ", err);
	      });
	    }
	  }, {
	    key: "checkForMoreReceipts",
	    value: function checkForMoreReceipts() {
	      var res = null;
	
	      if (this.currentUser.company.totalNumberOfInvoiceFiles === this.receipts.length) {
	        res = true;
	      } else {
	        res = false;
	      }
	
	      return res;
	    }
	  }]);
	
	  return TransactionhistoryController;
	}();
	
	TransactionhistoryController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "events", "companies", "security", "$rootScope", "common", "env", "$timeout"];
	
	exports.default = TransactionhistoryController;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(451);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./transactionhistory.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./transactionhistory.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "table.jobble-table.receipts th:first-child,table.jobble-table.receipts th:nth-child(2){min-width:200px}table.jobble-table.receipts th:nth-child(3){min-width:150px}table.jobble-table.receipts tr td:nth-child(4){font-size:14px}table.jobble-table.receipts th:nth-child(5){min-width:100px}table.jobble-table.receipts th:nth-child(6){min-width:130px}table.jobble-table.receipts tr td:nth-child(6) a{font-size:14px}table.jobble-table.receipts tbody.not-real-jobs-body tr.fake-jobs td{background:linear-gradient(270deg,#f3f3f2,#e2e3e2);background-position:0;animation-timing-function:ease-in-out;background-size:200%;animation:myfirst 1s;-moz-animation:myfirst 1s infinite;-webkit-animation:myfirst 1s infinite;height:53px}", ""]);
	
	// exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _eventeditdetails = __webpack_require__(453);
	
	var _eventeditdetails2 = _interopRequireDefault(_eventeditdetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventeditdetailsModule = _angular2.default.module("eventeditdetails", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("eventeditdetails", {
	    // url: '/event-edit-details',
	    url: "/event/:eventId/edit",
	    template: "<eventeditdetails></eventeditdetails>",
	    title: "Edit Job"
	  });
	}).component("eventeditdetails", _eventeditdetails2.default);
	
	exports.default = eventeditdetailsModule;
	
	/*.state('eventeditdetails', {
	url: '/event/:eventId/edit/shifts',
	template: '<accountprofile></accountprofile>'

	})
	.state('eventeditdetails', {
	url: '/event/:eventId/edit/questions',
	template: '<accountprofile></accountprofile>'

	})*/

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventeditdetails = __webpack_require__(454);
	
	var _eventeditdetails2 = _interopRequireDefault(_eventeditdetails);
	
	var _eventeditdetails3 = __webpack_require__(455);
	
	var _eventeditdetails4 = _interopRequireDefault(_eventeditdetails3);
	
	__webpack_require__(456);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventeditdetailsComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _eventeditdetails2.default,
	  controller: _eventeditdetails4.default,
	  controllerAs: "vm"
	};
	
	exports.default = eventeditdetailsComponent;

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<!--------------------- Container --------------------->\n<div class=\"profile-edits-container\">\n  <div style=\"padding-left: 100px\">\n    <div class=\"jobble-bread-crumbs\">\n      <span><a href=\"/jobs-dashboard\">Jobs</a></span>\n      <span><i class=\"fas fa-chevron-left\"></i></span>\n      <span><a ng-href=\"/event/{{vm.event.id}}/review\">{{vm.event.name}}</a></span>\n    </div>\n  </div>\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\">\n        <!--Sidebar-->\n        <div class=\"account-profile-sidebar\">\n          <aside>\n            <ul>\n              <li\n                ng-repeat=\"option in vm.navOptions\"\n                ng-class=\"{'selected-sidebar': option.isActive}\"\n                ng-click=\"vm.navigateEditEventPage(option.type)\"\n              >\n                <a href=\"\" ng-click=\"\"> <i class=\"fas fa-{{ option.icon }}\"></i>{{ option.value }} </a>\n              </li>\n            </ul>\n          </aside>\n        </div>\n        <!--Sidebar-->\n      </div>\n\n      <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n        <div>\n          <div class=\"jobs-complete-content\" style=\"border-radius: 6px; padding: 24px; min-height: 100vh; width: 770px; min-width: 700px\">\n            <div\n              class=\"account-profile-container clearfix\"\n              ng-if=\"vm.activeTab == 'edit-questions'\"\n              ng-class=\"{'reduce-padding' : vm.activeTab == 'edit-questions' }\"\n              style=\"border: 0px; padding: 0px\"\n            >\n              <questionnaire></questionnaire>\n            </div>\n            <div\n              class=\"account-profile-container clearfix\"\n              style=\"padding: 0px; border: none\"\n              ng-if=\"vm.activeTab == 'edit-requirements'\"\n              style=\"border: 0px\"\n            >\n              <div>\n                <div class=\"text-header\">Edit Requirements</div>\n\n                <div>\n                  <div class=\"select-box\">\n                    <select\n                      chosen\n                      placeholder-text-single=\"'+Add requirement'\"\n                      ng-model=\"vm.newRequirement\"\n                      ng-change=\"vm.addRequirement(vm.newRequirement)\"\n                      class=\"form-control form-input\"\n                      style=\"width: 100%\"\n                      ng-options=\"pr as pr.name for pr in vm.PHYSICAL_REQUIREMENTS\"\n                    ></select>\n                  </div>\n                </div>\n                <div>\n                  <div>\n                    <div ng-repeat=\"question in vm.event_requirements track by $index\">\n                      <div class=\"main-input-container question-input-container\">\n                        <div\n                          style=\"overflow: hidden; text-overflow: ellipsis\"\n                          class=\"main-input question-input\"\n                          ng-model=\"question.name\"\n                          maxlength=\"1000\"\n                          ng-disabled=\"true\"\n                        >\n                          {{question.name}}\n                          <a href=\"#\" class=\"jobs-review-hire-option fa fa-trash\" ng-click=\"vm.removeRequirement($index, question);\"></a>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"account-profile-container clearfix\" ng-if=\"vm.activeTab == 'edit-job'\" style=\"padding: 0px; border: 0px\">\n              <form>\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 process-description-outer\" style=\"padding-left: 0px; padding-right: 0px\">\n                  <div class=\"process-description-edit\">\n                    <div class=\"text-header\">\n                      {{vm.event.name}}\n                      <label\n                        ng-show=\"vm.autoHireStatus\"\n                        class=\"auto-hire-tag\"\n                        ng-class=\"{'auto-hire-off' : vm.autoHireStatus == 'Off'}\"\n                        ng-if=\"vm.currentUser.isAdmin == true\"\n                      >\n                        Smart Hire : {{vm.autoHireStatus}}\n                      </label>\n                    </div>\n                    <div class=\"row\">\n                      <div class=\"form-section-edit clearfix\">\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                          <div class=\"input-label\">Post Title</div>\n                          <input\n                            type=\"text\"\n                            class=\"form-control form-input\"\n                            placeholder=\"My cool job\"\n                            ng-model=\"vm.event.name\"\n                            ng-change=\"vm.changedEventData()\"\n                          />\n                        </div>\n                        <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" ng-hide=\"vm.delivery\">\n                          <div class=\"input-label\" ng-hide=\"vm.delivery\">Hourly Rate</div>\n                          <div class=\"input-label\" ng-show=\"vm.delivery\">Payment</div>\n                          <div class=\"input-rate\">\n                            <input\n                              type=\"text\"\n                              class=\"form-control form-input\"\n                              placeholder=\"20\"\n                              ng-model=\"vm.event.payPerHour\"\n                              ng-change=\"vm.changedJobbleDataPay(1)\"\n                              min=\"{{ vm.tempPay }}\"\n                              step=\"0.01\"\n                            />\n                          </div>\n                        </div>\n                        <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" ng-hide=\"vm.delivery\"></div>\n                        <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                          <div class=\"input-label\">Jobbler Makes</div>\n                          <div class=\"input-rate\">\n                            <input\n                              type=\"text\"\n                              class=\"form-control form-input\"\n                              placeholder=\"20\"\n                              ng-model=\"vm.event.payPerHourAdj\"\n                              ng-change=\"vm.changedJobbleDataPay(2)\"\n                              min=\"{{ vm.tempPay }}\"\n                              step=\"0.01\"\n                            />\n                          </div>\n                        </div>\n                        <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" ng-if=\"!vm.event.isSourcingPost\" ng-hide=\"vm.delivery\">\n                          <!--\n                                                    <div class=\"input-label\">Number of Openings</div>\n                                                    -->\n                          <div class=\"input-label\"></div>\n                          <!--\n                                                    <input\n                                                            type=\"number\"\n                                                            placeholder=\"1\"\n                                                            ng-model=\"vm.event.numberOfOpenings\"\n                                                            required\n                                                            ng-change=\"vm.changedEventData(false,true)\"\n                                                            class=\"form-control form-input\"\n                                                    />\n                                                    -->\n                        </div>\n                        <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                          <div class=\"input-label\">Job Type</div>\n                          <p ng-if=\"vm.event.subEvents[0].deduppedJobbles[0].jobbleType.name == 'Remote Job'\">Remote Job</p>\n                          <div class=\"select-box\" ng-if=\"vm.event.subEvents[0].deduppedJobbles[0].jobbleType.name != 'Remote Job'\">\n                            <select\n                              class=\"form-control form-input\"\n                              ng-model=\"vm.event.subEvents[0].deduppedJobbles[0].jobbleType.id\"\n                              ng-options=\"jobbleType.id as jobbleType.name for jobbleType in vm.jobbleTypes\"\n                              ng-change=\"vm.changedJobbleData()\"\n                            ></select>\n                          </div>\n                        </div>\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-hide=\"vm.delivery\">\n                          <div class=\"input-label\">Hiring Manager</div>\n                          <jobcontact></jobcontact>\n                        </div>\n\n                        <!--<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-if=\"(vm.currentUser.isAdmin == true && ((vm.event.autoAccept==true) || (vm.currentUser.company.autoAccept == true)))\">\n                                                    <div class=\"input-label\">\n                                                        Auto Hire\n                                                    </div>\n                                                    <div>\n                                                        <input\n                                                                type=\"checkbox\"\n                                                                ng-checked=\"vm.setAutoHire\"\n                                                                class=\"autohire\"\n                                                                ng-click=\"vm.toggleAutoHire()\"\n                                                        />\n                                                    </div>\n                                                </div>-->\n\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-if=\"!vm.event.isSourcingPost && vm.delivery===false\">\n                          <div class=\"input-label\">Dress Code (Optional)</div>\n                          <textarea\n                            ng-model=\"vm.event.subEvents[0].deduppedJobbles[0].dressCode\"\n                            ng-change=\"vm.changedJobbleData()\"\n                            class=\"form-control massege-style\"\n                            id=\"dress-code-edit\"\n                            rows=\"3\"\n                            maxlength=\"255\"\n                            placeholder=\"Write dress code here\"\n                          ></textarea>\n                          <div style=\"text-align: right\" class=\"main-text-area-length\">\n                            {{vm.event.subEvents[0].deduppedJobbles[0].dressCode ? vm.event.subEvents[0].deduppedJobbles[0].dressCode.length : 0\n                            }}/255\n                          </div>\n                        </div>\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-show=\"vm.delivery\">\n                          <div class=\"input-label\">Pickup Instructions</div>\n                          <textarea\n                            class=\"form-control massege-style delivery\"\n                            rows=\"3\"\n                            placeholder=\"Write detailed job description here\"\n                            ng-model=\"vm.order.pickup.instructions\"\n                            ng-change=\"vm.deliveryDataChanged(2)\"\n                          ></textarea>\n                        </div>\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-show=\"vm.delivery\">\n                          <div class=\"input-label\">Pickup Contact</div>\n                          <input\n                            type=\"text\"\n                            class=\"form-control form-input\"\n                            placeholder=\"Jane Doe (555-555-5555)\"\n                            ng-model=\"vm.order.pickup.contact\"\n                            ng-change=\"vm.deliveryDataChanged(4)\"\n                          />\n                        </div>\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-show=\"vm.delivery\">\n                          <div class=\"input-label\">Dropoff Instructions</div>\n                          <textarea\n                            class=\"form-control massege-style delivery\"\n                            rows=\"3\"\n                            placeholder=\"Write detailed job description here\"\n                            ng-model=\"vm.order.dropoff.instructions\"\n                            ng-change=\"vm.deliveryDataChanged(3)\"\n                          ></textarea>\n                        </div>\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-show=\"vm.delivery\">\n                          <div class=\"input-label\">Dropoff Contact</div>\n                          <input\n                            type=\"text\"\n                            class=\"form-control form-input\"\n                            placeholder=\"Jane Doe (555-555-5555)\"\n                            ng-model=\"vm.order.dropoff.contact\"\n                            ng-change=\"vm.deliveryDataChanged(5)\"\n                          />\n                        </div>\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                          <div class=\"input-label\" ng-hide=\"vm.delivery\">Job Description</div>\n                          <div class=\"input-label\" ng-show=\"vm.delivery\">General Instructions</div>\n                          <textarea\n                            class=\"form-control massege-style\"\n                            maxlength=\"1000\"\n                            rows=\"4\"\n                            placeholder=\"Write detailed job description here\"\n                            ng-model=\"vm.event.description\"\n                            ng-change=\"vm.changedEventData(true)\"\n                          ></textarea>\n                          <div style=\"text-align: right\" class=\"main-text-area-length\">\n                            {{vm.event.description && vm.event.description.length ? vm.event.description.length : 0 }}/1000\n                          </div>\n                        </div>\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                          <div class=\"input-label\">Onsite Arrival Instructions</div>\n                          <textarea\n                            class=\"form-control massege-style\"\n                            maxlength=\"1000\"\n                            rows=\"4\"\n                            placeholder=\"The lot on 3rd street is paid parking. When you arrive, enter through the blue door and check in with Joe.\"\n                            ng-model=\"vm.event.arrivalInstructions\"\n                            ng-change=\"vm.changedEventData(true)\"\n                          ></textarea>\n                          <div style=\"text-align: right\" class=\"main-text-area-length\">\n                            {{vm.event.arrivalInstructions && vm.event.arrivalInstructions.length ? vm.event.arrivalInstructions.length : 0 }}/500\n                          </div>\n                        </div>\n                        <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" ng-hide=\"vm.delivery\">\n                          <div class=\"input-label\">Onsite Manager Name</div>\n                          <input\n                            type=\"text\"\n                            class=\"form-control form-input\"\n                            placeholder=\"Name\"\n                            ng-model=\"vm.event.onsiteManagerName\"\n                            ng-change=\"vm.changedEventData(true)\"\n                          />\n                        </div>\n                        <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" ng-hide=\"vm.delivery\"></div>\n                        <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                          <div class=\"input-label\">Onsite Manager Phone Number</div>\n                          <input\n                            class=\"form-control form-input\"\n                            placeholder=\"Phone Number\"\n                            ng-model=\"vm.event.onsiteManagerNumber\"\n                            ng-change=\"vm.changedEventData(true)\"\n                          />\n                        </div>\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                          <div class=\"alert-box alert\" ng-show=\"vm.isEventUpdateValidateError\">{{vm.errorMessage}}</div>\n                          <button\n                            ng-hide=\"vm.delivery\"\n                            type=\"button\"\n                            class=\"account-gradient-button\"\n                            ng-click=\"vm.saveEventUpdate()\"\n                            ng-disabled=\"!vm.event.changedEventData && !vm.event.changedJobbleData\"\n                            style=\"margin-bottom: -10px; margin-top: 20px\"\n                            ng-class=\"{ 'blur-button' : !vm.event.changedEventData && !vm.event.changedJobbleData }\"\n                          >\n                            Save\n                          </button>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </form>\n            </div>\n\n            <div class=\"account-profile-container pad clearfix\" ng-if=\"vm.activeTab == 'edit-shifts'\" style=\"border: 0px; padding: 0px\">\n              <div class=\"text-header\">Edit Shifts</div>\n              <form style=\"margin-top: 20px; padding-left: 15px; padding-right: 15px\">\n                <div\n                  class=\"alert-box alert\"\n                  ng-show=\"vm.isEventUpdateValidateError\"\n                  style=\"margin-right: -5px; margin-bottom: 0px; margin-left: -5px\"\n                >\n                  {{vm.errorMessage}}\n                </div>\n                <div class=\"row\" ng-if=\"true || !vm.event.isLongTerm\">\n                  <div style=\"margin-bottom: 32px; font-weight: 600\" ng-if=\"vm.event.isLongTerm\">\n                    Please note that this job is a recurring job that has been scheduled to run for {{vm.shiftLongTermGenerator.weeks}} additional\n                    week(s). The shift changes made below will be specific to this week and <em>will not</em> be reflected in future week shifts.\n                  </div>\n                  <div\n                    class=\"form-details form-section clearfix\"\n                    ng-repeat=\"shift in vm.shifts track by $index\"\n                    ng-class=\"{'err' : shift.has_time_error == true}\"\n                    style=\"margin-left: 0px; margin-right: 0px;style\"\n                  >\n                    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                      <button class=\"btn btn-danger delete-shift-button\">\n                        <i\n                          ng-click=\"vm.selectedShiftToDelete(shift,$index)\"\n                          ng-if=\"vm.shifts.length > 1\"\n                          class=\"far fa-trash-alt delete-shift-button\"\n                          title=\"Delete shift\"\n                        ></i>\n                      </button>\n\n                      <label>Address</label>\n                      <p ng-if=\"vm.event.subEvents[0].deduppedJobbles[0].jobbleType.name == 'Remote Job'\">\n                        This is a remote job. There is no address.\n                      </p>\n                      <input\n                        type=\"text\"\n                        class=\"form-control form-input\"\n                        placeholder=\"Enter shift address here\"\n                        ng-model=\"shift.address\"\n                        ng-change=\"vm.shiftChanged(shift, $index, true)\"\n                        style=\"z-index: 0\"\n                        googleplace\n                        ng-if=\"vm.event.subEvents[0].deduppedJobbles[0].jobbleType.name != 'Remote Job'\"\n                      />\n                    </div>\n                    <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12\" style=\"position: relative\">\n                      <label>Start date</label>\n                      <!-- class=\"form-control form-input\" -->\n                      <input\n                        type=\"text\"\n                        placeholder=\"Select\"\n                        id=\"datepicker-{{$index}}\"\n                        placeholder=\"Select\"\n                        ng-model=\"shift.startDateFormatted\"\n                        style=\"border: 1px solid #adbcc2; line-height: 40px; background-color: #fff; padding-left: 13px; z-index: 0\"\n                        ng-change=\"vm.shiftChanged(shift, $index)\"\n                      />\n                    </div>\n                    <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12\">\n                      <label>Start time</label>\n                      <input\n                        type=\"text\"\n                        placeholder=\"Select\"\n                        class=\"timepicker\"\n                        ng-model=\"shift.startTimeFormatted\"\n                        id=\"timepicker-{{$index}}\"\n                        style=\"border: 1px solid #adbcc2; line-height: 40px; background-color: #fff; padding-left: 13px\"\n                        ng-change=\"vm.shiftChanged(shift, $index)\"\n                      />\n                    </div>\n                    <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\">\n                      <label ng-hide=\"vm.delivery\">Shift duration [hours / minutes]</label>\n                      <div class=\"row\" ng-hide=\"vm.delivery\">\n                        <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                          <div class=\"select-box\">\n                            <select\n                              class=\"form-control form-input\"\n                              ng-model=\"shift.hours\"\n                              ng-options=\"hours for hours in vm.hoursList\"\n                              ng-change=\"vm.shiftChanged(shift, $index)\"\n                            ></select>\n                          </div>\n                        </div>\n                        <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                          <div class=\"select-box\">\n                            <select\n                              class=\"form-control form-input\"\n                              ng-model=\"shift.minutes\"\n                              ng-options=\"minutes for minutes in vm.minutesList\"\n                              ng-change=\"vm.shiftChanged(shift, $index)\"\n                            ></select>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                      <label>Unpaid break (minutes)</label>\n                      <select\n                        style=\"width: 165px; min-width: 100px; z-index: 0\"\n                        class=\"form-control form-input\"\n                        ng-model=\"shift.unpaidBreak\"\n                        ng-options=\"unpaid for unpaid in vm.unpaidBreakList\"\n                        ng-change=\"vm.shiftChanged(shift, $index)\"\n                      ></select>\n                    </div>\n                    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                      <div>\n                        <div style=\"margin-top: 16px\" class=\"checkbox-container\">\n                          <div style=\"position: relative\">\n                            <input\n                              type=\"checkbox\"\n                              ng-model=\"shift.overnight\"\n                              ng-change=\"vm.shiftChanged(shift, $index)\"\n                              style=\"position: absolute; left: 0px; top: 0px\"\n                            />\n                            <span style=\"margin-left: 22px\"> Overnight shift </span>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-if=\"shift.has_been_changed\">\n                      <a href=\"#\" class=\"btn btn-danger cancel-shift-button\" ng-click=\"vm.cancelShiftEdit(shift)\"> Cancel </a>\n                      <a href=\"#\" class=\"btn btn-success save-shift-button\" ng-click=\"vm.saveShiftEdit(shift,$index)\"> Save Changes </a>\n\n                      <div class=\"notifcation-check-box-holder\">\n                        <span>\n                          Do not send notification for this change\n                          <input type=\"checkbox\" ng-checked=\"shift.isChecked\" ng-click=\"vm.checkShift(shift)\" />\n                        </span>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"add-btn\" ng-hide=\"vm.shiftIsBeingEdited == true\">\n                    <a href=\"\" ng-click=\"vm.addShift()\" class=\"btn-default\" ng-hide=\"vm.delivery\">Add Another Shift</a>\n                  </div>\n                </div>\n                <div\n                  ng-if=\"false && vm.event.isLongTerm\"\n                  style=\"display: block; width: initial; overflow: initial; height: initial\"\n                  class=\"post-a-shift-container\"\n                >\n                  <div style=\"margin-bottom: 32px; font-weight: 600\">\n                    Recurring jobs can not be edited after they have been published. Please contact Jobble Support if you would like to edit this job.\n                  </div>\n                  <div style=\"margin-bottom: 32px\" id=\"date-selection\">\n                    <div style=\"display: flex; margin-bottom: 16px\">\n                      <div style=\"flex: 1; margin-right: 32px\">\n                        <div class=\"main-label\">Start date:</div>\n                        <div class=\"main-icon-select-container\">\n                          <i class=\"fas fa-calendar main-icon\"></i>\n                          <input\n                            name=\"start-date\"\n                            disabled\n                            id=\"start-date\"\n                            ng-model=\"vm.shiftLongTermGenerator.startDate\"\n                            class=\"main-icon-select main-datepicker\"\n                          />\n                        </div>\n                      </div>\n                      <div style=\"flex: 1\">\n                        <div class=\"main-label\">Number of weeks:</div>\n                        <div class=\"main-icon-select-container\">\n                          <i class=\"fas fa-calendar main-icon\"></i>\n                          <select disabled class=\"main-icon-select\" ng-model=\"vm.shiftLongTermGenerator.weeks\">\n                            <option ng-repeat=\"week in vm.WEEKS_AVAILABLE\" value=\"{{week}}\">{{week + 1}}</option>\n                          </select>\n                          <i class=\"fas fa-caret-down down-icon\"></i>\n                        </div>\n                      </div>\n                    </div>\n\n                    <div style=\"display: flex; margin: 15px 0\">\n                      <div\n                        ng-repeat=\"day in vm.DAYS_OF_WEEK_OBJECTS\"\n                        class=\"day-of-week-icon\"\n                        ng-class=\"{'selected': vm.shiftLongTermGenerator.daysOfWeek.indexOf(day.value) !== -1}\"\n                      >\n                        {{day.label}}\n                      </div>\n                    </div>\n\n                    <div style=\"display: flex\">\n                      <div style=\"flex: 1; margin-right: 32px\">\n                        <div class=\"main-label\">Start time:</div>\n                        <div class=\"main-icon-select-container\">\n                          <i class=\"far fa-clock main-icon\"></i>\n                          <input disabled class=\"main-icon-select\" ng-model=\"vm.shiftLongTermGenerator.startTime\" />\n                          <i class=\"fas fa-caret-down down-icon\"></i>\n                        </div>\n                      </div>\n                      <div style=\"flex: 1\">\n                        <div class=\"main-label\">End time:</div>\n                        <div class=\"main-icon-select-container\">\n                          <i class=\"far fa-clock main-icon\"></i>\n                          <input disabled class=\"main-icon-select\" ng-model=\"vm.shiftLongTermGenerator.endTime\" />\n                          <i class=\"fas fa-caret-down down-icon\"></i>\n                        </div>\n                      </div>\n                    </div>\n                    <div style=\"display: flex\">\n                      <div style=\"flex: 1\">\n                        <div class=\"checkbox-container\">\n                          <input type=\"checkbox\" disabled ng-model=\"vm.shiftLongTermGenerator.overnight\" />\n                          Overnight shift\n                        </div>\n                      </div>\n                    </div>\n                    <div style=\"display: flex\">\n                      <div style=\"flex: 1\">\n                        <div class=\"checkbox-container\" style=\"height: 35px; line-height: 35px; margin-top: 20px\">\n                          <input style=\"top: 10px\" type=\"checkbox\" disabled ng-model=\"vm.shiftLongTermGenerator.hasUnpaidBreak\" />\n                          Includes\n                          <div class=\"main-icon-select-container\" style=\"height: 35px; display: inline-block; width: 75px; font-size: 13px\">\n                            <select\n                              ng-model=\"vm.shiftLongTermGenerator.unpaidBreak\"\n                              class=\"main-icon-select\"\n                              style=\"padding-left: 7px; height: 35px\"\n                              disabled\n                            >\n                              <option ng-value=\"0\" disabled>0 min</option>\n                              <option ng-value=\"15\">15 min</option>\n                              <option ng-value=\"30\">30 min</option>\n                              <option ng-value=\"45\">45 min</option>\n                              <option ng-value=\"60\">60 min</option>\n                            </select>\n                            <i class=\"fas fa-caret-down down-icon\" style=\"right: 7px\"></i>\n                          </div>\n                          unpaid break\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </form>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<jobblefooter></jobblefooter>\n<eventdialog></eventdialog>\n<globalalert></globalalert>\n\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n\n<a href=\"#push-team-modal-confirm\" data-toggle=\"modal\" id=\"push-team-modal\"></a>\n<div class=\"modal fade\" id=\"push-team-modal-confirm\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <span aria-hidden=\"true\">&times;</span>\n            </button>\n            <strong>Please confirm your changes.</strong>\n          </div>\n          <div class=\"modal-body\">\n            <a\n              class=\"btn\"\n              href=\"\"\n              data-dismiss=\"modal\"\n              style=\"margin: 0px; background-color: #67b747\"\n              ng-click=\"vm.updateEventPostedToTeams(vm.isPrivateJob)\"\n              >Confirm</a\n            >\n            <a class=\"btn\" href=\"\" data-dismiss=\"modal\" style=\"background-color: #961106\">Cancel</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"delete-shift-confirm\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <h4>Delete Shift</h4>\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <span aria-hidden=\"true\">&times;</span>\n            </button>\n          </div>\n          <div class=\"modal-body\">\n            <p>Are you sure you want to delete this shift?</p>\n            <a class=\"btn btn-danger\" href=\"\" data-dismiss=\"modal\"> Cancel </a>\n            <a class=\"btn btn-success\" href=\"\" data-dismiss=\"modal\" ng-click=\"vm.deleteShift()\"> Confirm </a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div\n  class=\"modal fade\"\n  id=\"modal-confirm-data-propagation\"\n  tabindex=\"-1\"\n  role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\"\n  data-backdrop=\"static\"\n>\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\" style=\"width: 456px\">\n        <div class=\"modal-content account-modal-content\">\n          <div class=\"modal-gradient-bar\"></div>\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times\"></i>\n            </button>\n            <div class=\"modal-title\">Editing Recurring Jobs</div>\n          </div>\n          <div class=\"modal-body\">\n            <p>\n              The job you are editing is a recurring job. Would you like to carry these changes over to all weeks that have not yet been published?\n            </p>\n\n            <div class=\"account-gradient-button\" style=\"width: 100%; text-align: center\" data-dismiss=\"modal\" ng-click=\"vm.editAllWeeks()\">\n              Yes, carry changes\n            </div>\n\n            <button class=\"btn btn-secondary\" style=\"width: 100%; text-align: center\" data-dismiss=\"modal\" ng-click=\"vm.editOneWeek()\">\n              No, edit this week only\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div\n  class=\"modal fade\"\n  id=\"modal-confirm-data-propagation-wait\"\n  tabindex=\"-1\"\n  role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\"\n  data-backdrop=\"static\"\n>\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\" style=\"width: 456px\">\n        <div class=\"modal-content account-modal-content\">\n          <div class=\"modal-gradient-bar\"></div>\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times\"></i>\n            </button>\n            <div class=\"modal-title\">Save Processing</div>\n          </div>\n          <div class=\"modal-body\">\n            <p>Please allow our system a couple minutes to propagate the changes that have been made. Thank you.</p>\n\n            <div class=\"account-gradient-button\" style=\"width: 100%; text-align: center\" data-dismiss=\"modal\">Close</div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _common = __webpack_require__(112);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _variables = __webpack_require__(309);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DAYS_OF_WEEK = {
	  MONDAY: 1,
	  TUESDAY: 2,
	  WEDNESDAY: 3,
	  THURSDAY: 4,
	  FRIDAY: 5,
	  SATURDAY: 6,
	  SUNDAY: 0
	};
	
	var DAYS_OF_WEEK_OBJECTS = [{
	  value: DAYS_OF_WEEK.SUNDAY,
	  label: "Sun"
	}, {
	  value: DAYS_OF_WEEK.MONDAY,
	  label: "Mon"
	}, {
	  value: DAYS_OF_WEEK.TUESDAY,
	  label: "Tue"
	}, {
	  value: DAYS_OF_WEEK.WEDNESDAY,
	  label: "Wed"
	}, {
	  value: DAYS_OF_WEEK.THURSDAY,
	  label: "Thu"
	}, {
	  value: DAYS_OF_WEEK.FRIDAY,
	  label: "Fri"
	}, {
	  value: DAYS_OF_WEEK.SATURDAY,
	  label: "Sat"
	}];
	
	var EventeditdetailsController = function () {
	  function EventeditdetailsController($http, $localStorage, $state, $stateParams, AuthService, EventsService, SecurityService, $rootScope, CommonService, CompaniesService, EnvService, $timeout, $scope) {
	    var _this2 = this;
	
	    _classCallCheck(this, EventeditdetailsController);
	
	    this.name = "eventeditdetails";
	    $localStorage.activeStateName = "events";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$events = EventsService;
	    this.$stateParams = $stateParams;
	    this.$security = SecurityService;
	    this.$rootScope = $rootScope;
	    this.$common = CommonService;
	    this.$companies = CompaniesService;
	    this.$env = EnvService;
	    this.$timeout = $timeout;
	    this.payBeforeChange = null;
	    this.shiftsHolder = [];
	    this.shiftsToBeDeleted = [];
	    this.activeTab = "edit-job";
	    this.currentUser = this.$auth.getUserData();
	    this.event = {};
	    this.$scope = $scope;
	    this.shiftsEdited = false;
	    this.teams = [];
	    this.eventTypes = [];
	    this.jobbleTypes = [];
	    this.isEventUpdateValidateError = false;
	    this.updateStatus = 0;
	    this.errorMessage = "";
	    this.openingsList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	    this.hoursList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
	    this.WEEKS_AVAILABLE = this.$auth.isAdmin() ? [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] : [3, 4, 5];
	    this.minutesList = [];
	    this.unpaidBreakList = [];
	    this.jobbles = [];
	    this.tempPay = 0;
	    this.shiftIsBeingEdited = false;
	    this.additionalDays = 0;
	    this.tempOpenings = 0;
	    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
	    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;
	
	    for (var i = 0; i <= 60; i++) {
	      if (i % 15 === 0) {
	        this.minutesList.push(i);
	        this.unpaidBreakList.push(i);
	      }
	    }
	
	    this.remain_loading_count = 1;
	    this.setLoader();
	
	    var _this = this;
	
	    _this.showTimeToHire();
	
	    _this.$timeout(function () {
	      _this.$rootScope.$emit("SetLoaderDialog", { type: 3, total: 1 });
	    });
	
	    this.$events.getShiftRequirements(this.$stateParams.eventId).then(function (data) {
	      _this2.event_requirements = data.data;
	    });
	
	    this.$events.getEventByIdWithFields(this.$stateParams.eventId, 1).then(function (data) {
	      _this.event = data.data;
	      _this.getUpdatedData();
	
	      if (_this.event.numberOfApprovedApplications > 0) {
	        _this.tempPay = (_this.event.subEvents[0].deduppedJobbles[0].payPerHour / 100).toFixed(2);
	      } else {
	        _this.tempPay = 11;
	      }
	
	      _this.isPrivateJob = _this.event.subEvents[0].deduppedJobbles[0].forCircleOnly;
	      _this.tempOpenings = _this.event.numberOfOpenings;
	
	      var userTimeZoneName = moment.tz.guess();
	      var now = moment.tz(userTimeZoneName);
	
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetEventToEventSidebar", {
	          event: _this.event
	        });
	      });
	
	      if (_this.event.surveyQuestions) {
	        _this.event.surveyQuestions.sort(function (a, b) {
	          var order = null;
	
	          if (a.displayOrder) {
	            order = a.displayOrder - b.displayOrder;
	          } else {
	            order = a.id - b.id;
	          }
	
	          return order;
	        });
	      }
	
	      if (_this.event.status === "error") {
	        return;
	      }
	
	      _this.event.numberOfOpenings = _this.event.numberOfOpenings + _this.event.numberOfApprovedApplications;
	      _this.event.numberOfOpeningsOrigin = _this.event.numberOfOpenings;
	
	      var companyFeePct = _this.currentUser.company.defaultPlan.companyFeePct;
	      _this.event.payPerHour = _this.event.subEvents[0].deduppedJobbles[0].payPerHour / 100;
	      _this.event.payPerHourAdj = _this.event.payPerHour;
	      var costPlusMarkUp = Math.round(parseFloat(_this.event.payPerHourAdj) * 100 * (1 + companyFeePct));
	
	      _this.event.payPerHour = costPlusMarkUp / 100;
	      _this.event.changedEventData = false;
	      _this.event.changedJobbleData = false;
	      _this.event.weeks = _this.event.weeks ? _this.event.weeks + "" : _this.event.weeks;
	
	      var shifts = _this.event.subEvents[0].deduppedJobbles[0].shifts;
	
	      try {
	        for (var x = 0; x < shifts.length; x++) {
	          var start = new Date(moment(shifts[x].timeInterval.startTime).format());
	          var end = new Date(moment(shifts[x].timeInterval.endTime).format());
	          var startMoment = moment(start);
	          var endMoment = moment(end);
	          var timeZone = shifts[x].contactInfo.place.timeZoneId;
	
	          shifts[x].startDateFormatted = startMoment.tz(timeZone).format("MMM DD, YYYY");
	          shifts[x].startDateFormattedNew = startMoment.tz(timeZone).format("M/D/YYYY");
	          shifts[x].endDateFormattedNew = endMoment.tz(timeZone).format("M/D/YYYY");
	          shifts[x].startTimeFormatted = startMoment.tz(timeZone).format("h:mmA");
	          shifts[x].isChangedAddress = false;
	          shifts[x].buttonState = "hide-button";
	          _this.showDateAndTimeUI(x);
	        }
	      } catch (err) {
	        console.log("what is the error");
	        console.dir(err);
	      } finally {
	        _this.sortShiftsInOrder(shifts, _this.event);
	
	        _this.$events.getAllShiftRequirements().then(function (s) {
	          _this.ALL_PHYSICAL_REQUIREMENTS = s.data;
	          _this.PHYSICAL_REQUIREMENTS = s.data;
	          _this.filterRequirements();
	        });
	
	        if (_this.event.isSourcingPost) {
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("SetLoaderDialog", {
	              type: 0
	            });
	            $("eventsidebar .jobs-complete-sidebar li:nth-child(5)").removeClass().addClass("active");
	          }, 300);
	        } else {
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("SetLoaderDialog", {
	              type: 0
	            });
	            //_this.shifts = shifts;
	            //_this.event.subEvents[0].deduppedJobbles[0].shifts = shifts;
	            $("eventsidebar .jobs-complete-sidebar li:nth-child(2)").removeClass().addClass("active");
	          }, 300);
	        }
	      }
	
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetEventToEventDialog", {
	          event: _this.event
	        });
	        _this.remain_loading_count--;
	      });
	    }, function (data) {
	      _this.remain_loading_count--;
	      _this.unSetLoader();
	      $state.go("jobsdashboard");
	    });
	
	    _this.jobbleTypes = _this.$rootScope.jobble_types;
	
	    _this.SetEventToEventPagesListener = _this.$rootScope.$on("SetEventToEventPages", function ($event, params) {
	      if (_this.event.id === params.event.id) {
	        _this.event.cost = params.event.cost;
	        _this.event.numberOfOpenings = params.event.numberOfOpenings;
	        _this.event.totalNumberOfJobbles = params.event.totalNumberOfJobbles;
	      }
	    });
	
	    _this.SetOnSiteManagerEditListener = _this.$rootScope.$on("SetOnSiteManagerEdit", function ($event, params) {
	      _this.manager_id_for_edit = params.data;
	      _this.event.changedJobbleData = true;
	    });
	
	    _this.SetJobbleTypesListener = _this.$rootScope.$on("SetJobbleTypes", function ($event, params) {
	      _this.jobbleTypes = params.jobbleTypes;
	    });
	
	    _this.SuccessToDeleteEventListener = _this.$rootScope.$on("SuccessToDeleteEvent", function ($event, params) {
	      _this.$state.go("jobsdashboard");
	    });
	
	    _this.$scope.$on("$destroy", _this.SuccessToDeleteEventListener);
	    _this.$scope.$on("$destroy", _this.SetJobbleTypesListener);
	    _this.$scope.$on("$destroy", _this.SetOnSiteManagerEditListener);
	    _this.$scope.$on("$destroy", _this.SetEventToEventPagesListener);
	
	    this.shiftLongTermGenerator = this.getNewLongTermShiftObject();
	
	    this.DAYS_OF_WEEK = DAYS_OF_WEEK;
	    this.DAYS_OF_WEEK_OBJECTS = DAYS_OF_WEEK_OBJECTS;
	  }
	
	  _createClass(EventeditdetailsController, [{
	    key: "getNewShiftObject",
	    value: function getNewShiftObject() {
	      return {
	        startDate: null, //"08/21/2020",
	        endDate: null, //"08/21/2020",
	        startTime: null, //"8:00",
	        endTime: null, //"21:00",
	        overnight: false,
	        unpaidBreak: 0,
	        hasUnpaidBreak: false
	      };
	    }
	  }, {
	    key: "getNewLongTermShiftObject",
	    value: function getNewLongTermShiftObject() {
	      var shift = this.getNewShiftObject();
	      shift["weeks"] = "4";
	      shift["daysOfWeek"] = [];
	      return shift;
	    }
	  }, {
	    key: "processShifts",
	    value: function processShifts(shifts) {
	      return shifts.map(function (shift) {
	        var startTime = moment(shift.timeInterval.startTime);
	        var endTime = moment(shift.timeInterval.endTime);
	        var startTimeFormatted = startTime.format("h:mm a").toUpperCase();
	
	        return {
	          id: shift.id,
	          startDate: startTime.format("MM/DD/YYYY"),
	          endDate: endTime.format("MM/DD/YYYY"),
	          startTime: startTimeFormatted,
	          endTime: endTime.format("h:mm a").toUpperCase(),
	          overnight: shift.overnight,
	          contactInfo: shift.contactInfo,
	          possibleEndTimes: [],
	          unpaidBreak: shift.unpaidBreak,
	          hasUnpaidBreak: shift.unpaidBreak > 0
	        };
	      });
	    }
	  }, {
	    key: "updateLongTermGenerator",
	    value: function updateLongTermGenerator(raw_shifts, event) {
	      var _this3 = this;
	
	      var shifts = this.processShifts(raw_shifts);
	
	      if (!this.shiftLongTermGenerator) this.shiftLongTermGenerator = this.getNewLongTermShiftObject();
	
	      if (shifts && shifts.length) {
	        this.$timeout(function () {
	          _this3.shiftLongTermGenerator.daysOfWeek = [];
	          shifts.forEach(function (shift, i) {
	            var dayOfWeek = new Date(shift.startDate).getDay();
	            _this3.shiftLongTermGenerator.daysOfWeek.push(dayOfWeek);
	
	            if (i === 0) {
	              _this3.shiftLongTermGenerator.startDate = shift.startDate;
	              _this3.shiftLongTermGenerator.startTime = shift.startTime;
	              _this3.shiftLongTermGenerator.endTime = shift.endTime;
	              _this3.shiftLongTermGenerator.overnight = shift.overnight;
	              _this3.shiftLongTermGenerator.unpaidBreak = shift.unpaidBreak;
	              _this3.shiftLongTermGenerator.hasUnpaidBreak = shift.hasUnpaidBreak;
	              _this3.shiftLongTermGenerator.weeks = event.weeks;
	            }
	          });
	
	          _this3.shiftLongTermGenerator.daysOfWeek = _.uniq(_this3.shiftLongTermGenerator.daysOfWeek);
	        });
	      }
	    }
	  }, {
	    key: "filterRequirements",
	    value: function filterRequirements() {
	      if (!this.ALL_PHYSICAL_REQUIREMENTS || !this.ALL_PHYSICAL_REQUIREMENTS.length || !this.event_requirements) return;
	
	      this.PHYSICAL_REQUIREMENTS = _.differenceBy(this.ALL_PHYSICAL_REQUIREMENTS, this.event_requirements, "id");
	    }
	  }, {
	    key: "removeRequirement",
	    value: function removeRequirement(index, requirement) {
	      var _this4 = this;
	
	      this.setLoader();
	      this.event_requirements.splice(index, 1);
	      this.filterRequirements();
	      this.$events.removeShiftRequirement(this.$stateParams.eventId, requirement.id).then(function (e) {
	        _this4.displaySuccessBanner();
	        _this4.unSetLoader();
	        console.log("Removed shift requirement:", e);
	      });
	    }
	  }, {
	    key: "checkForExistingRequirement",
	    value: function checkForExistingRequirement(selectedReq) {
	      var result = void 0;
	
	      result = _.find(this.event_requirements, function (obj) {
	        if (obj.id === selectedReq) {
	          return true;
	        }
	      });
	
	      return result;
	    }
	  }, {
	    key: "addRequirement",
	    value: function addRequirement(q) {
	      var _this5 = this;
	
	      if (!q) {
	        //alert("Select a different requirement.");
	        return;
	      }
	
	      if (this.event_requirements.length >= 5) {
	        this.newRequirement = null;
	        alert("You can only have a maximum of 5 requirements.");
	        return;
	      }
	
	      var doesExist = this.checkForExistingRequirement(q);
	
	      if (doesExist === true) {
	        this.newRequirement = null;
	        alert("This requirement already exists.");
	        return;
	      }
	
	      this.setLoader();
	      this.event_requirements.push(q);
	      this.newRequirement = null;
	      this.filterRequirements();
	
	      this.$events.addShiftRequirement(this.$stateParams.eventId, q.id, this.event_requirements.length).then(function (e) {
	        _this5.unSetLoader();
	        _this5.displaySuccessBanner();
	      });
	    }
	  }, {
	    key: "showTimeToHire",
	    value: function showTimeToHire() {
	      setTimeout(function () {
	        jQuery("#datepicker").datepicker({
	          showOn: "both",
	          buttonImage: "/app/vendor/images/calender.png",
	          buttonImageOnly: true,
	          buttonText: "Select date",
	          dateFormat: "M dd, yy"
	        });
	      }, 100);
	    }
	  }, {
	    key: "showDateAndTimeUI",
	    value: function showDateAndTimeUI(index) {
	      // for date and time picker UI
	      setTimeout(function () {
	        jQuery("#datepicker-" + index.toString()).datepicker({
	          showOn: "both",
	          buttonImage: "/app/vendor/images/calender.png",
	          buttonImageOnly: true,
	          buttonText: "Select date",
	          dateFormat: "M dd, yy"
	        });
	        jQuery("input.timepicker").timepicker({
	          step: 15,
	          timeFormat: "h:i A"
	        });
	        jQuery("input.timepicker").on("showTimepicker", function () {
	          // //console.log("show");
	          jQuery(".ui-timepicker-wrapper").css("width", $(this).width() + 10 + "px");
	        });
	      }, 100);
	    }
	  }, {
	    key: "changePostedAllJobblers",
	    value: function changePostedAllJobblers() {
	      var _this = this;
	      if (this.event.postedAllJobblers) {
	        _this.teams.forEach(function (team) {
	          team.postedEvent = true;
	        });
	      } else {
	        _this.teams.forEach(function (team) {
	          team.postedEvent = false;
	        });
	      }
	    }
	  }, {
	    key: "changePostedToTeam",
	    value: function changePostedToTeam(selectedTeam) {
	      var _this = this;
	    }
	  }, {
	    key: "changePrivate",
	    value: function changePrivate() {
	      var _this = this;
	
	      if (!_this.isPrivateJob) {
	        _this.$timeout(function () {
	          _this.$rootScope.$apply(function () {
	            _this.isPrivateJob = false;
	          });
	        });
	      } else {
	        _this.$timeout(function () {
	          _this.$rootScope.$apply(function () {
	            _this.isPrivateJob = true;
	          });
	        });
	      }
	    }
	  }, {
	    key: "changedEventData",
	    value: function changedEventData() {
	      var changedJobbleData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var openingsChanging = arguments[1];
	
	      this.event.onsiteManagerNumber = this.event.onsiteManagerNumber ? this.event.onsiteManagerNumber.replace(/\D/g, "") : this.event.onsiteManagerNumber;
	
	      this.event.changedEventData = true;
	      this.event.changedJobbleData = changedJobbleData;
	
	      if (this.event.numberOfOpenings <= 0) {
	        this.event.numberOfOpenings = 1;
	        alert("The number of openings cannot be below 1");
	        return;
	      }
	
	      if (this.delivery) {
	        this.deliveryDataChanged();
	      }
	    }
	  }, {
	    key: "changedJobbleDataPay",
	    value: function changedJobbleDataPay(type) {
	      var _this = this;
	      var is_admin = null;
	      if (_this.currentUser.username.indexOf("jobble.com") > -1 || _this.currentUser.username.indexOf("jobbleapp.com") > -1) {
	        is_admin = true;
	      } else {
	        is_admin = false;
	      }
	      if (is_admin) {
	        _this.event.changedJobbleData = true;
	      } else {
	        if (moment().isAfter(moment(_this.event.startTime)) || _this.event.numberOfApprovedApplications > 0) {
	          alert("Error: You cannot edit the hourly rate after a job has started or after an applicant has been hired.");
	        } else {
	          _this.event.changedJobbleData = true;
	        }
	      }
	      if (_this.delivery) {
	        _this.deliveryDataChanged();
	      }
	      if (type === 1) {
	        _this.calcNumbers();
	      } else {
	        _this.calcNumbersAdj();
	      }
	    }
	  }, {
	    key: "calcNumbers",
	    value: function calcNumbers() {
	      var _this = this;
	
	      var companyFeePct = _this.currentUser.company.defaultPlan.companyFeePct;
	
	      if (isNaN(_this.event.payPerHourAdj)) {
	        _this.event.payPerHourAdj = "";
	        _this.event.payPerHourAdj = (parseFloat(_this.event.event.payPerHour) * (1 - _this.currentUser.company.defaultPlan.jobblerFeePct)).toFixed(2);
	      } else {
	        var costLessMarkUp = parseFloat(_this.event.payPerHour) / (1 + companyFeePct);
	
	        _this.event.payPerHourAdj = Math.round(costLessMarkUp * 100) / 100;
	
	        if (isNaN(_this.event.payPerHourAdj)) {
	          _this.event.payPerHourAdj = "";
	        }
	      }
	    }
	  }, {
	    key: "calcNumbersAdj",
	    value: function calcNumbersAdj() {
	      var _this = this;
	
	      var companyFeePct = _this.currentUser.company.defaultPlan.companyFeePct;
	
	      if (isNaN(_this.event.payPerHour)) {
	        _this.event.payPerHour = "";
	      } else {
	        var costPlusMarkUp = Math.round(parseFloat(_this.event.payPerHourAdj) * 100 * (1 + companyFeePct));
	        _this.event.payPerHour = (costPlusMarkUp / 100).toFixed(2);
	        //20 = (x * 100) * (1 + companyFeePct);
	        //20 = (100x) * 1.39
	
	        if (isNaN(_this.event.payPerHour)) {
	          _this.event.payPerHour = "";
	        }
	      }
	    }
	  }, {
	    key: "changedJobbleData",
	    value: function changedJobbleData() {
	      var _this = this;
	
	      _this.event.changedJobbleData = true;
	
	      if (moment().isAfter(moment(_this.event.startTime)) && _this.postType === "regular") {} else {}
	    }
	  }, {
	    key: "addShift",
	    value: function addShift() {
	      var _this = this;
	
	      var newShift = null;
	      var lastShift = _this.shifts[_this.shifts.length - 1];
	
	      newShift = jQuery.extend(true, {}, lastShift);
	      newShift.jobbleId = _this.event.subEvents[0].deduppedJobbles[0].id;
	      newShift.id = null;
	
	      newShift.googleCoords = {};
	      newShift.googleCoords.lat = newShift.contactInfo.lat;
	      newShift.googleCoords.lng = newShift.contactInfo.lng;
	
	      _this.shifts.push(newShift);
	      _this.showDateAndTimeUI(_this.shifts.length - 1);
	    }
	  }, {
	    key: "removeShift",
	    value: function removeShift(index) {
	      var shiftCount = this.event.subEvents[0].deduppedJobbles[0].shifts.length;
	
	      if (shiftCount > 1) {
	        this.event.subEvents[0].deduppedJobbles[0].shifts.splice(index, 1);
	        this.shiftsEdited = true;
	      } else {
	        alert("You cannot delete your last shift.");
	      }
	    }
	  }, {
	    key: "setWindowScrollTop",
	    value: function setWindowScrollTop() {
	      var _this = this;
	    }
	  }, {
	    key: "saveEventUpdate",
	    value: function saveEventUpdate() {
	      var _this = this;
	      var status = this.validateEventForm();
	
	      this.updateStatus = 0;
	
	      if (status.status) {
	        this.isEventUpdateValidateError = false;
	        this.updateStatus = 1;
	
	        if (_this.event.isLongTerm) {
	          _this.triggerConfirmationModal();
	          return;
	        }
	
	        this.updateEventData();
	        _this.$timeout(function () {
	          _this.setWindowScrollTop();
	        }, 100);
	      } else {
	        this.isEventUpdateValidateError = true;
	        this.updateStatus = 2;
	        this.errorMessage = status.message;
	        this.setWindowScrollTop();
	      }
	    }
	  }, {
	    key: "triggerConfirmationModal",
	    value: function triggerConfirmationModal() {
	      this.$timeout(function () {
	        $("#modal-confirm-data-propagation").modal();
	      });
	    }
	  }, {
	    key: "editAllWeeks",
	    value: function editAllWeeks() {
	      this.updateEventData(true);
	    }
	  }, {
	    key: "editOneWeek",
	    value: function editOneWeek() {
	      this.updateEventData();
	    }
	  }, {
	    key: "validateEventForm",
	    value: function validateEventForm() {
	      var retObj = {};
	
	      retObj.status = true;
	
	      var jobblerRate = parseFloat(this.event.payPerHourAdj);
	
	      if (this.$security.isUndefinedOrNull(this.event.name)) {
	        retObj.status = false;
	        retObj.message = "Please provide a name for your job before continuing.";
	        return retObj;
	      }
	
	      if (this.$security.isUndefinedOrNull(this.event.description)) {
	        retObj.status = false;
	        retObj.message = "Please provide some job details for your job before continuing.";
	        return retObj;
	      }
	
	      if (this.$security.isUndefinedOrNull(this.event.payPerHour) && this.postType === "regular") {
	        retObj.status = false;
	        retObj.message = "Please provide an hourly rate for your job before continuing.";
	        return retObj;
	      }
	
	      if (jobblerRate < 12.0) {
	        retObj.status = false;
	        retObj.message = "The Jobblers' pay rate cannot be less than $12.00.";
	      }
	
	      return retObj;
	    }
	  }, {
	    key: "alert_user",
	    value: function alert_user(err, shift_number) {
	      var _this = this;
	      _this.$timeout(function () {
	        alert(err);
	      }, 300);
	    }
	  }, {
	    key: "compareShiftsToEachOther",
	    value: function compareShiftsToEachOther(shifts) {
	      var shiftsForCompare = shifts;
	      var r = {};
	
	      r.status = false;
	
	      var _this = this;
	
	      try {
	        shifts.sort(function (a, b) {
	          return new Date(a.startDateAndTimeForDB).getTime() - new Date(b.startDateAndTimeForDB).getTime();
	        });
	      } finally {
	        try {
	          shifts.forEach(function (shift, i) {
	            var indexPlusOne = i + 1;
	            if (i + 1 < shifts.length) {
	              var shiftEndTime = shift.endDateAndTimeMomentObj;
	              var startTimeOfNextShift = shiftsForCompare[indexPlusOne].startDateAndTimeMomentObj;
	              if (startTimeOfNextShift.isBefore(shiftEndTime)) {
	                r.status = true;
	                r.message = "You have selected overlapping shifts. Please fix before proceeding.";
	                return r;
	              }
	            }
	          });
	        } finally {
	          return r;
	        }
	      }
	    }
	  }, {
	    key: "updateStartTimeModel",
	    value: function updateStartTimeModel(index, shift) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        var startTime = jQuery("#timepicker-" + index.toString()).val();
	        if (startTime != undefined && startTime != null) {
	          shift.startTime = startTime;
	        }
	      });
	    }
	  }, {
	    key: "updateEventData",
	    value: function updateEventData(editAllWeeks) {
	      var _this = this;
	
	      var payload = {
	        name: _this.event.name,
	        eventType: _this.event.eventTypeId,
	        arrivalInstructions: _this.event.arrivalInstructions,
	        onsiteManagerName: _this.event.onsiteManagerName,
	        onsiteManagerNumber: _this.event.onsiteManagerNumber,
	        description: _this.cleanJobDescription(_this.event.description)
	      };
	
	      if (editAllWeeks) {
	        payload.updateScheduled = true;
	      }
	
	      var eventData = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + _this.event.id + "?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.currentUser.access_token
	        },
	        data: payload
	      };
	
	      if (this.event.changedEventData) {
	        _this.remain_loading_count++;
	        _this.$http(eventData).then(function (response) {
	          _this.remain_loading_count--;
	          _this.updateOpenings(editAllWeeks);
	
	          if (editAllWeeks && !_this.event.changedJobbleData) {
	            _this.showWaitForPropagationMessage();
	          }
	        }, function (response) {
	          _this.remain_loading_count--;
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	        });
	      } else {
	        _this.updateJobblePoolData(editAllWeeks);
	      }
	    }
	  }, {
	    key: "updateOpenings",
	    value: function updateOpenings(editAllWeeks) {
	      var _this = this;
	      var data = {};
	
	      if (_this.event.numberOfOpenings > _this.event.numberOfOpeningsOrigin) {
	        data = {
	          method: "POST",
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + _this.event.subEvents[0].deduppedJobbles[0].id + "/add-positions?format=json&conf=web&numberOfPositions=" + (_this.event.numberOfOpenings - _this.event.numberOfOpeningsOrigin),
	          headers: {
	            "Content-Type": "application/json;charset=UTF-8",
	            Authorization: "Bearer " + _this.currentUser.access_token
	          },
	          data: {}
	        };
	        _this.updateOpeningsReq(data);
	      } else if (_this.event.numberOfOpenings < _this.event.numberOfOpeningsOrigin) {
	        data = {
	          method: "POST",
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + _this.event.subEvents[0].deduppedJobbles[0].id + "/rm-positions?format=json&conf=web&numberOfPositions=" + (_this.event.numberOfOpeningsOrigin - _this.event.numberOfOpenings),
	          headers: {
	            "Content-Type": "application/json;charset=UTF-8",
	            Authorization: "Bearer " + _this.currentUser.access_token
	          },
	          data: {}
	        };
	        _this.updateOpeningsReq(data);
	      } else {
	        _this.updateSubEventData(editAllWeeks);
	      }
	    }
	  }, {
	    key: "updateOpeningsReq",
	    value: function updateOpeningsReq(data) {
	      var _this = this;
	      _this.remain_loading_count++;
	
	      _this.$http(data).then(function (response) {
	        _this.remain_loading_count--;
	        if (response.data.status !== "error") {
	          _this.updateSubEventData();
	        }
	      }, function (response) {
	        _this.remain_loading_count--;
	      });
	    }
	  }, {
	    key: "updateJobblePoolData",
	    value: function updateJobblePoolData(editAllWeeks) {
	      var _this = this;
	
	      var pay = Math.round(_this.event.payPerHourAdj * 100);
	
	      var payload = {
	        jobble: {
	          jobbleType: _this.event.subEvents[0].deduppedJobbles[0].jobbleType.id,
	          description: _this.cleanJobDescription(_this.event.description),
	          payPerHour: pay,
	          dressCode: _this.event.subEvents[0].deduppedJobbles[0].dressCode,
	          manager: _this.manager_id_for_edit,
	          subEvent: {
	            event: {
	              onsiteManagerName: _this.event.onsiteManagerName,
	              onsiteManagerNumber: _this.event.onsiteManagerNumber
	            }
	          }
	        }
	      };
	
	      if (editAllWeeks) {
	        payload.updateScheduled = true;
	      }
	
	      var jobblePoolData = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + _this.event.subEvents[0].deduppedJobbles[0].id + "/bulk-update?format=json",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.currentUser.access_token
	        },
	        data: payload
	      };
	
	      if (_this.event.changedJobbleData) {
	        _this.remain_loading_count++;
	        _this.$http(jobblePoolData).then(function (response) {
	          _this.remain_loading_count--;
	          _this.event.changedJobbleData = false;
	          if (editAllWeeks) {
	            _this.showWaitForPropagationMessage();
	          }
	          _this.$timeout(function () {
	            jQuery("#modal-save-event-confirm").trigger("click");
	          }, 100);
	          //_this.	();
	        }, function (response) {
	          _this.remain_loading_count--;
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	        });
	      } else {
	        //_this.updateJobbleShiftsData();
	      }
	    }
	  }, {
	    key: "showWaitForPropagationMessage",
	    value: function showWaitForPropagationMessage() {
	      console.log("showWaitForPropagationMessage");
	      this.$timeout(function () {
	        jQuery("#modal-confirm-data-propagation-wait").modal();
	      }, 100);
	    }
	  }, {
	    key: "createNewShiftInExistingJob",
	    value: function createNewShiftInExistingJob(shift) {
	      var _this = this;
	
	      var tempShift = {
	        jobbleId: shift.jobbleId,
	        contactInfo: {
	          city: shift.contactInfo.city,
	          state: shift.contactInfo.state,
	          streetLine1: shift.contactInfo.streetLine1,
	          zipCode: shift.contactInfo.zipCode,
	          lat: shift.contactInfo.lat,
	          lng: shift.contactInfo.lng
	        },
	        timeInterval: {
	          startTime: shift.timeInterval.startTime,
	          endTime: shift.timeInterval.endTime
	        },
	        overnight: shift.overnight,
	        description: shift.description,
	        location: shift.location,
	        deliveryContactInfo: shift.deliveryContactInfo
	      };
	
	      _this.$events.createNewShiftForExistingEvent(shift.jobbleId, null, null, shift).then(function (response) {
	        _this.setShiftIdToShift(shift, response);
	        _this.unSetLoader();
	        _this.displaySuccessBanner();
	      }, function (error) {
	        _this.unSetLoader();
	        console.log("createNewShiftForExistingEvent - error");
	        console.dir(error);
	        if (error.data.code === 1007) {
	          alert("You have reached the maximum number of shifts at 15. Please create a new job if more shifts are required.");
	        } else {
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	        }
	      });
	    }
	  }, {
	    key: "setShiftIdToShift",
	    value: function setShiftIdToShift(shift, response) {
	      var _this = this;
	
	      shift.id = response.data.shiftId;
	      shift.jobbleId = null;
	    }
	  }, {
	    key: "displaySuccessBanner",
	    value: function displaySuccessBanner() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $(".jobs-complete-banner .alert-success-header").show("slide", { direction: "up" }, 100);
	      }, 400);
	
	      _this.$timeout(function () {
	        _this.hideSuccessBanner();
	      }, 1500);
	    }
	  }, {
	    key: "hideSuccessBanner",
	    value: function hideSuccessBanner() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $(".jobs-complete-banner .alert-success-header").hide("slide", { direction: "up" }, 100);
	      });
	    }
	  }, {
	    key: "updateEventPostedToTeams",
	    value: function updateEventPostedToTeams(isPriv) {
	      var _this = this;
	
	      var ids = [];
	
	      try {
	        for (var i = 0; i < _this.teams.length; i++) {
	          if (_this.teams[i].isSelected) {
	            ids.push(_this.teams[i].id);
	          }
	        }
	      } finally {
	        var eventPostedToTeamsData = {
	          method: "POST",
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/circles/push-jobbles-to-circles?format=json&conf=web",
	          headers: {
	            "Content-Type": "application/json;charset=UTF-8",
	            Authorization: "Bearer " + _this.currentUser.access_token
	          },
	          data: {
	            event: _this.event.id,
	            subEvent: _this.event.subEvents[0].id,
	            jobbles: [_this.event.subEvents[0].deduppedJobbles[0].id],
	            circles: ids,
	            forCircleOnly: isPriv
	          }
	        };
	        _this.remain_loading_count++;
	        _this.$http(eventPostedToTeamsData).then(function (response) {
	          _this.remain_loading_count--;
	          //console.log(response.data);
	        }, function (response) {
	          _this.remain_loading_count--;
	          //console.log(response.data);
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	        });
	      }
	    }
	  }, {
	    key: "navigateEditEventPage",
	    value: function navigateEditEventPage(type) {
	      var _this = this;
	      _this.navOptions.forEach(function (option) {
	        if (option.type === type) {
	          option.isActive = "active";
	        } else {
	          option.isActive = "";
	        }
	      });
	      if (type === "edit-job") {
	        _this.activeTab = "edit-job";
	        _this.setHiringManager(_this.event);
	      }
	      if (type === "push-teams") {
	        _this.activeTab = "push-teams";
	      }
	      if (type === "edit-questions") {
	        _this.activeTab = "edit-questions";
	        _this.questions = _this.event.surveyQuestions;
	        _this.$timeout(function () {
	          _this.$rootScope.$apply(function () {
	            _this.$rootScope.$broadcast("checkQuestionsEdit", {
	              questions: _this.questions,
	              event: _this.event
	            });
	          });
	        }, 100);
	      }
	
	      if (type === "edit-requirements") {
	        _this.activeTab = "edit-requirements";
	      }
	
	      if (type === "edit-shifts") {
	        _this.activeTab = "edit-shifts";
	        _this.event.subEvents[0].deduppedJobbles[0].shifts.forEach(function (shift, index) {
	          shift.address = shift.contactInfo.streetLine1 + " " + shift.contactInfo.city + " " + shift.contactInfo.state + " " + shift.contactInfo.zipCode;
	          // shift.startDate = moment.utc(shift.timeInterval.startTime).toDate();
	          shift.startDate = moment(moment.utc(shift.timeInterval.startTime).toDate()).format("MMM DD, YYYY");
	          shift.startTime = moment(moment.utc(shift.timeInterval.startTime).toDate()).format("hh:mm A");
	          shift.totalMinutes = parseInt(moment.utc(shift.timeInterval.endTime).diff(moment.utc(shift.timeInterval.startTime)) / 60000);
	          shift.minutes = shift.totalMinutes % 60;
	
	          shift.hours = parseInt((shift.totalMinutes - shift.minutes) / 60);
	          shift.isChangedAddress = false;
	          _this.showDateAndTimeUI(index);
	        });
	      }
	    }
	  }, {
	    key: "confirmJobEdit",
	    value: function confirmJobEdit() {
	      this.$timeout(function () {
	        jQuery("#modal-save-event-confirm .modal-header button.close").trigger("click");
	      }, 100);
	    }
	  }, {
	    key: "saveUpdatedTeams",
	    value: function saveUpdatedTeams() {
	      var _this = this;
	      var circles = [];
	      _this.teams.forEach(function (team) {
	        if (team.isSelected) {
	          circles.push(team.id);
	        }
	      });
	
	      _this.$timeout(function () {
	        jQuery("#push-team-modal-confirm").modal();
	        _this.circles = circles;
	      }, 100);
	    }
	  }, {
	    key: "timeToHireChange",
	    value: function timeToHireChange() {
	      var _this = this;
	
	      if (moment(_this.event.timeToHireFormatted).isBefore(moment())) {
	        alert("Please select a date in the future to hire.");
	        _this.event.timeToHireFormatted = moment(_this.event.timeToHire).format("MMM DD, YYYY");
	      } else {
	        _this.event.timeToHire = moment(_this.event.timeToHireFormatted).format();
	        _this.event.changedEventData = true;
	      }
	    }
	  }, {
	    key: "sortShiftsInOrder",
	    value: function sortShiftsInOrder(shifts, event) {
	      var _this = this;
	      try {
	        shifts.sort(function (a, b) {
	          return new Date(a.timeInterval.startTime) - new Date(b.timeInterval.startTime);
	        });
	      } finally {
	        var shiftsHolder = [];
	
	        shiftsHolder.push(shifts);
	        _this.shiftsHolder = shiftsHolder;
	
	        _this.updateLongTermGenerator(shifts, event);
	
	        _this.$timeout(function () {
	          _this.shifts = shifts;
	          _this.shifts.forEach(function (shift) {
	            shift.totalMinutes = parseInt(moment.utc(shift.timeInterval.endTime).diff(moment.utc(shift.timeInterval.startTime)) / 60000);
	            shift.minutes = shift.totalMinutes % 60;
	          });
	        });
	
	        _this.check_for_delivery();
	      }
	    }
	  }, {
	    key: "check_for_delivery",
	    value: function check_for_delivery() {
	      var _this = this;
	      if (_this.event.isOrder) {
	        _this.delivery = true;
	        _this.setFields();
	      } else {
	        _this.delivery = false;
	      }
	
	      _this.setNavBar();
	    }
	  }, {
	    key: "setFields",
	    value: function setFields() {
	      var _this = this;
	      _this.order = {
	        contact: _this.event.subEvents[0].deduppedJobbles[0].deliveryContactInfo,
	        pickup: {
	          instructions: _this.event.subEvents[0].deduppedJobbles[0].shifts[0].description,
	          contact: _this.event.subEvents[0].deduppedJobbles[0].pickupContactInfo
	        },
	        dropoff: {
	          instructions: _this.event.subEvents[0].deduppedJobbles[0].shifts[1].description,
	          contact: _this.event.subEvents[0].deduppedJobbles[0].dropoffContactInfo
	        }
	      };
	
	      _this.remain_loading_count = 0;
	    }
	  }, {
	    key: "validateJobbleShifts",
	    value: function validateJobbleShifts(s, index) {
	      var _this = this;
	
	      var retObj = {};
	      var shift;
	
	      retObj.status = true;
	
	      var shiftsToSave = [];
	
	      shiftsToSave.push(s);
	
	      for (var i = 0; i < shiftsToSave.length; i++) {
	        shift = shiftsToSave[i];
	
	        var shifthold = shift;
	
	        if (this.postType === "regular") {
	          _this.updateStartTimeModel(index, shift);
	          if (this.$security.isUndefinedOrNull(shift.startDate)) {
	            retObj.status = false;
	            retObj.message = "Please provide the date of the shift #" + (i + 1).toString();
	            return retObj;
	          }
	          if (this.$security.isUndefinedOrNull(shift.startTime)) {
	            retObj.status = false;
	            retObj.message = "Please provide the time of the shift #" + (i + 1).toString();
	            return retObj;
	          }
	          if (shift.hours == 0 && shift.minutes == 0) {
	            retObj.status = false;
	            retObj.message = "Please provide the duration of the shift #" + (i + 1).toString();
	            return retObj;
	          }
	        }
	
	        if (shift.isChangedAddress) {
	          try {
	            shift.contactInfo = {};
	            shift.googleCoords = {};
	            shift.googleCoords.lat = shift.address.lat;
	            shift.googleCoords.lng = shift.address.lng;
	
	            if (shift.address.adr_address.indexOf("span") > -1) {
	              var addressSplit = shift.address.adr_address.split(",");
	
	              addressSplit.forEach(function (part, index) {
	                //console.log("splitting...");
	                //console.dir(part);
	
	                if (part.indexOf("street-address") > -1) {
	                  var streetArray = /<span[^>]*>(.*?)<\/span>/.exec(part);
	                  shift.contactInfo.streetLine1 = streetArray[1];
	                }
	                if (part.indexOf("locality") > -1) {
	                  var cityArray = /<span[^>]*>(.*?)<\/span>/.exec(part);
	                  shift.contactInfo.city = cityArray[1];
	                }
	                if (part.indexOf("region") > -1) {
	                  var regionAndZipArray = part.split("> <");
	
	                  regionAndZipArray.forEach(function (p) {
	                    if (p.indexOf("region") > -1) {
	                      var stateArray = /\s<span[^>]*>(.*?)<\/span/.exec(p);
	                      shift.contactInfo.state = stateArray[1];
	                    }
	                    if (p.indexOf("postal-code") > -1) {
	                      var zipArray = /span[^>]*>(.*?)<\/span>/.exec(p);
	                      shift.contactInfo.zipCode = zipArray[1];
	                    }
	                  });
	                }
	
	                if (index + 1 === addressSplit.length) {
	                  shift.address = shift.contactInfo.streetLine1 + " " + shift.contactInfo.city + " " + shift.contactInfo.state + " " + shift.contactInfo.zipCode;
	                  shift.isChangedAddress = false;
	                }
	              });
	            }
	          } catch (err) {
	            retObj.status = false;
	            retObj.message = "Please provide the correct address of the shift" + (i + 1).toString();
	
	            return retObj;
	          }
	        }
	
	        if (this.$security.isUndefinedOrNull(shift.contactInfo)) {
	          retObj.status = false;
	          retObj.message = "Please make sure to select an address of the shift" + (i + 1).toString() + " from the drop down before proceeding. Please do not copy and paste.";
	          return retObj;
	        } else if (this.$security.isUndefinedOrNull(shift.contactInfo.city) || this.$security.isUndefinedOrNull(shift.contactInfo.streetLine1) || this.$security.isUndefinedOrNull(shift.contactInfo.state) || this.$security.isUndefinedOrNull(shift.contactInfo.zipCode)) {
	          retObj.status = false;
	          retObj.message = "Please return a more specific address of the shift" + (i + 1).toString() + ". For best results use a street address. (100 Main St. Boston, MA).";
	          return retObj;
	        }
	
	        if (this.postType === "regular") {
	          var tempEndDate = moment(shift.startDate + " " + shift.startTime).add(shift.hours, "hours");
	          shift.endDateAndTimeMomentObj = moment(tempEndDate).add(shift.minutes, "minutes");
	          shift.durationInMinutes = shift.endDateAndTimeMomentObj.diff(moment(shift.startDate + " " + shift.startTime), "minutes");
	          shift.durationInHours = parseFloat((shift.durationInMinutes / 60).toFixed(2));
	          shift.startDateAndTimeMomentObj = moment(shift.startDate + " " + shift.startTime);
	          console.log("shift.startDateAndTimeMomentObj");
	          console.dir(shift.startDateAndTimeMomentObj);
	          shift.startDateAndTimeForDB = shift.startDateAndTimeMomentObj.format();
	          console.dir(shift.startDateAndTimeForDB);
	          shift.endDateAndTimeForDB = shift.endDateAndTimeMomentObj.format();
	          shift.startTime = moment(shift.startDateAndTimeForDB).format("hh:mm A");
	          shift.endTime = moment(shift.endDateAndTimeForDB).format("hh:mm A");
	        } else {
	          shift.timeInterval.endTime = moment(shift.timeInterval.endTime).add(this.additionalDays, "days").format();
	        }
	
	        if (this.postType === "regular") {
	          if (i === 1 && _this.delivery) {
	            var st2 = _this.event.subEvents[0].deduppedJobbles[0].shifts[i].startDateAndTimeForDB;
	            var st = _this.event.subEvents[0].deduppedJobbles[0].shifts[i - 1].startDateAndTimeForDB;
	            if (moment(st2).isBefore(moment(st))) {
	              retObj.status = false;
	              retObj.message = "The drop-off time must be after the pick-up time.";
	              return retObj;
	            }
	          }
	        }
	
	        if (this.$security.isUndefinedOrNull(shift.contactInfo)) {
	          retObj.status = false;
	          retObj.message = "Please make sure to select an address from the drop down before proceeding. Please do not copy and paste.";
	          return retObj;
	        } else {
	          if (this.$security.isUndefinedOrNull(shift.contactInfo.city) || this.$security.isUndefinedOrNull(shift.contactInfo.streetLine1) || this.$security.isUndefinedOrNull(shift.contactInfo.state) || this.$security.isUndefinedOrNull(shift.contactInfo.zipCode)) {
	            retObj.status = false;
	            retObj.message = "Please return a more specific address. For best results use a street address. (100 Main St. Boston, MA).";
	            return retObj;
	          }
	        }
	
	        if (this.postType === "regular") {
	          shift.timeInterval.startTime = shift.startDateAndTimeForDB;
	          shift.timeInterval.endTime = shift.endDateAndTimeForDB;
	        }
	
	        if (this.postType === "source") {
	          //console.log('what is this after the adding');
	          //console.dir(shift);
	        }
	      }
	
	      return retObj;
	    }
	  }, {
	    key: "shiftChanged",
	    value: function shiftChanged(shift, index, isAddress) {
	
	      var _this = this;
	
	      console.log("shiftChanged");
	      console.dir(isAddress);
	
	      shift.has_been_changed = true;
	      _this.shiftIsBeingEdited = true;
	
	      if (!_this.shiftsEdited) {
	        _this.shiftsEdited = true;
	      }
	
	      shift.startTime = shift.startTimeFormatted;
	      shift.startDate = shift.startDateFormatted;
	
	      if (isAddress) {
	        shift.isChangedAddress = true;
	        if (_typeof(shift.address) === "object") {
	          _this.showSaveButton(shift, index);
	        }
	      } else {
	        _this.showSaveButton(shift, index);
	      }
	    }
	  }, {
	    key: "showSaveButton",
	    value: function showSaveButton(shift, index) {
	      var _this = this;
	
	      shift.shift_has_been_changed = true;
	    }
	  }, {
	    key: "checkShift",
	    value: function checkShift(shift) {
	      var _this = this;
	
	      if (shift.isChecked) {
	        shift.isChecked = false;
	      } else {
	        shift.isChecked = true;
	      }
	    }
	  }, {
	    key: "saveShiftEdit",
	    value: function saveShiftEdit(shift, index) {
	      var _this = this;
	
	      _this.setLoader();
	
	      shift.has_been_changed = false;
	      var status = this.validateJobbleShifts(shift, index);
	      console.log("saveShiftEdit");
	      console.dir(shift);
	      console.dir(index);
	      console.log("status");
	      console.dir(status);
	
	      if (status.status) {
	        console.log("this.postType");
	        console.dir(this.postType);
	
	        if (this.postType === "regular") {
	          var errorWithShifts = _this.compareShiftsToEachOther(_this.event.subEvents[0].deduppedJobbles[0].shifts);
	          if (!errorWithShifts.status) {
	            _this.isEventUpdateValidateError = false;
	            _this.updateStatus = 1;
	            _this.updateJobbleShiftsData(shift);
	          } else {
	            _this.isEventUpdateValidateError = true;
	            _this.updateStatus = 2;
	            _this.errorMessage = errorWithShifts.message;
	            _this.setWindowScrollTop();
	            _this.shiftIsBeingEdited = false;
	            _this.unSetLoader();
	          }
	        } else {
	          _this.isEventUpdateValidateError = false;
	          _this.updateStatus = 1;
	          _this.updateJobbleShiftsData();
	          _this.shiftIsBeingEdited = false;
	        }
	      } else {
	        this.unSetLoader();
	        this.shiftIsBeingEdited = false;
	        this.isEventUpdateValidateError = true;
	        this.updateStatus = 2;
	        this.errorMessage = status.message;
	        this.setWindowScrollTop();
	      }
	    }
	  }, {
	    key: "updateJobbleShiftsData",
	    value: function updateJobbleShiftsData(s) {
	      var _this = this;
	      var shifts = [];
	      var shiftsHolder = [];
	      var shiftCount = _this.event.subEvents[0].deduppedJobbles[0].shifts.length;
	      var processedShiftCount = 0;
	
	      shiftsHolder.push(s);
	
	      _this.$timeout(function () {
	        _this.shiftIsBeingEdited = false;
	      }, 1000);
	
	      shiftsHolder.forEach(function (shift, index) {
	        _this.$security.getEventShiftTimezoneInfo(shift).then(function (response) {
	          processedShiftCount++;
	
	          if (_this.postType === "regular") {
	
	            var zone = moment.tz.zone(moment.tz.guess());
	            var eventMangerOffsets = -zone.offsets[zone.offsets.length - 1];
	            var eventOffsets = response.data[0].rawOffset / 60000;
	
	            var tz = response.data[0].timeZoneId;
	            var td = new Date(shift.startDate);
	            var tt = new Date(shift.startTime);
	
	            var tempEndDate = moment(shift.startDate + " " + shift.startTime).add(shift.hours, "hours");
	
	            shift.endDateAndTimeMomentObj = moment(tempEndDate).add(shift.minutes, "minutes");
	            shift.endTime = shift.endDateAndTimeMomentObj.format("h:mm a");
	            console.log("check end time");
	            console.dir(shift);
	            console.dir(shift.endTime);
	            shift.durationInMinutes = shift.endDateAndTimeMomentObj.diff(moment(shift.startDate + " " + shift.startTime), "minutes");
	            shift.durationInHours = parseFloat((shift.durationInMinutes / 60).toFixed(2));
	            shift.startDateAndTimeMomentObj = moment(shift.startDate + " " + shift.startTime);
	
	            shift.startDateFormattedNew = shift.startDateAndTimeMomentObj.tz(tz).format("M/D/YYYY");
	            shift.endDateFormattedNew = shift.endDateAndTimeMomentObj.tz(tz).format("M/D/YYYY");
	
	            shift.startDateAndTimeForDB = moment.tz(shift.startDateFormattedNew + " " + shift.startTime, "M/D/YYYY h:mm a", tz);
	            shift.endDateAndTimeForDB = moment.tz(shift.endDateFormattedNew + " " + shift.endTime, "M/D/YYYY h:mm a", tz);
	
	            shift.timeInterval.startTime = shift.startDateAndTimeForDB.format();
	            shift.timeInterval.endTime = shift.endDateAndTimeForDB.format();
	
	            if (shift.googleCoords) {
	              shift.contactInfo.lat = shift.googleCoords.lat;
	              shift.contactInfo.lng = shift.googleCoords.lng;
	            }
	          }
	
	          if (shift.jobbleId) {
	            _this.createNewShiftInExistingJob(shift);
	            return;
	          }
	
	          var tempShift = {
	            id: shift.id,
	            contactInfo: {
	              city: shift.contactInfo.city,
	              state: shift.contactInfo.state,
	              streetLine1: shift.contactInfo.streetLine1,
	              zipCode: shift.contactInfo.zipCode,
	              lat: shift.contactInfo.lat,
	              lng: shift.contactInfo.lng
	            },
	            timeInterval: {
	              startTime: shift.timeInterval.startTime,
	              endTime: shift.timeInterval.endTime
	            },
	            overnight: shift.overnight,
	            unpaidBreak: shift.unpaidBreak
	          };
	
	          shifts.push(tempShift);
	
	          _this.$events.updateExistingShift(tempShift, s.isChecked).then(function (response) {
	            _this.unSetLoader();
	            _this.shiftIsBeingEdited = false;
	            _this.displaySuccessBanner();
	          }, function (error) {
	            _this.unSetLoader();
	            _this.shiftIsBeingEdited = false;
	            _this.handleSavingShiftError(error);
	          });
	        }, function (response) {
	          _this.remain_loading_count--;
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	          return;
	        });
	      });
	    }
	  }, {
	    key: "handleSavingShiftError",
	    value: function handleSavingShiftError(error) {
	      var _this = this;
	      if (error.data.code === 1008) {
	        alert("There are overlapping shifts. Please adjust the shift times and try again.");
	      } else {
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      }
	    }
	  }, {
	    key: "updateShiftUsingBulkShift",
	    value: function updateShiftUsingBulkShift(shift) {
	      var _this = this;
	    }
	  }, {
	    key: "setHiringManager",
	    value: function setHiringManager(event) {
	      var _this = this;
	
	      var m = event.subEvents[0].deduppedJobbles[0].manager;
	
	      if (m) {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetManagerForEditPage", m);
	        });
	      }
	    }
	  }, {
	    key: "setNavBar",
	    value: function setNavBar() {
	      var _this = this;
	      if (_this.delivery) {
	        _this.postType = "regular";
	        _this.navOptions = [{
	          type: "edit-job",
	          isActive: "active",
	          value: "Edit Delivery"
	        }, { type: "edit-shifts", isActive: "", value: "Edit Locations" }];
	      } else {
	        if (_this.event.isSourcingPost) {
	          _this.postType = "source";
	          _this.navOptions = [{ type: "edit-job", isActive: "active", value: "Edit job" }];
	        } else {
	          _this.postType = "regular";
	          _this.navOptions = [{ type: "edit-job", isActive: "active", value: "Edit job" }, { type: "edit-shifts", isActive: "", value: "Edit shifts" }, {
	            type: "edit-requirements",
	            isActive: "",
	            value: "Edit Requirements"
	          }];
	        }
	      }
	    }
	  }, {
	    key: "cleanJobDescription",
	    value: function cleanJobDescription(str) {
	      if (str) {
	        var updatedDescription = str.replace(/\\|`/g, "");
	        return updatedDescription;
	      }
	    }
	  }, {
	    key: "deliveryDataChanged",
	    value: function deliveryDataChanged() {
	      var _this = this;
	      _this.event.changedDeliveryData = true;
	    }
	  }, {
	    key: "saveDeliveryToSubevent",
	    value: function saveDeliveryToSubevent(data) {
	      var _this = this;
	      var event = {};
	      event.name = _this.event.name;
	      event.description = _this.cleanJobDescription(_this.event.description);
	      event.id = _this.event.subEvents[0].id;
	      _this.$events.updateSubEventInfoForOrder(event).then(function (response) {
	        _this.saveDeliveryToJobble();
	      }, function (error) {
	        alert("Error saving event.");
	      });
	    }
	  }, {
	    key: "saveDeliveryToJobble",
	    value: function saveDeliveryToJobble() {
	      var _this = this;
	      var jobble = {};
	      jobble.pay = _this.event.payPerHour;
	      jobble.pickup_contact = _this.order.pickup.contact;
	      jobble.dropoff_contact = _this.order.dropoff.contact;
	      jobble.description = _this.cleanJobDescription(_this.event.description);
	      jobble.id = _this.event.subEvents[0].deduppedJobbles[0].id;
	      _this.$events.updateJobbleInfoForOrder(jobble).then(function (response) {
	        _this.$timeout(function () {
	          _this.updateJobbleShiftsData();
	
	          //_this.saveShiftEdit();
	        }, 500);
	      }, function (error) {
	        alert("Error during bulk update.");
	      });
	    }
	  }, {
	    key: "updateSubEventData",
	    value: function updateSubEventData(editAllWeeks) {
	      var _this = this;
	
	      var payload = {
	        name: _this.event.name,
	        eventType: _this.event.eventTypeId,
	        description: _this.cleanJobDescription(_this.event.description)
	      };
	
	      if (editAllWeeks) {
	        payload.updateScheduled = true;
	      }
	
	      var subEventData = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/subevents/" + _this.event.subEvents[0].id + "?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.currentUser.access_token
	        },
	        data: payload
	      };
	      _this.remain_loading_count++;
	      _this.$http(subEventData).then(function (response) {
	        _this.remain_loading_count--;
	        _this.event.changedEventData = false;
	        _this.updateJobblePoolData(editAllWeeks);
	      }, function (response) {
	        _this.remain_loading_count--;
	        //console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      }, 300);
	    }
	  }, {
	    key: "setNavBar",
	    value: function setNavBar() {
	      var _this = this;
	      if (_this.delivery) {
	        _this.postType = "regular";
	        _this.navOptions = [{ type: "edit-job", isActive: "active", value: "Edit Delivery", icon: "shipping-fast" }, { type: "edit-shifts", isActive: "", value: "Edit Locations", icon: "map-marker" }];
	      } else {
	        if (_this.event.isSourcingPost) {
	          _this.postType = "source";
	          _this.navOptions = [{ type: "edit-job", isActive: "active", value: "Edit job", icon: "tasks" }];
	        } else {
	          _this.postType = "regular";
	          _this.navOptions = [{ type: "edit-job", isActive: "active", value: "Edit job", icon: "tasks" }, { type: "edit-shifts", isActive: "", value: "Edit shifts", icon: "clock-o" },
	          // {type: "edit-questions", isActive: "", value: "Edit questions", icon: "question"},
	          { type: "edit-requirements", isActive: "", value: "Edit requirements", icon: "asterisk" }];
	        }
	      }
	    }
	  }, {
	    key: "deliveryDataChanged",
	    value: function deliveryDataChanged() {
	      var _this = this;
	      _this.event.changedDeliveryData = true;
	    }
	  }, {
	    key: "saveDeliveryUpdate",
	    value: function saveDeliveryUpdate() {
	      var _this = this;
	      var event = {};
	      event.name = _this.event.name;
	      event.description = _this.cleanJobDescription(_this.event.description);
	      event.id = _this.event.id;
	      _this.setLoader();
	      _this.$events.updateEventInfoForOrder(event).then(function (response) {
	        _this.saveDeliveryToSubevent();
	      }, function (error) {
	        alert("Error saving event.");
	      });
	    }
	  }, {
	    key: "saveDeliveryToSubevent",
	    value: function saveDeliveryToSubevent(data) {
	      var _this = this;
	      var event = {};
	      event.name = _this.event.name;
	      event.description = _this.cleanJobDescription(_this.event.description);
	      event.id = _this.event.subEvents[0].id;
	      _this.$events.updateSubEventInfoForOrder(event).then(function (response) {
	        _this.saveDeliveryToJobble();
	      }, function (error) {
	        alert("Error saving event.");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      }, 300);
	    }
	  }, {
	    key: "shiftHasBeenChecked",
	    value: function shiftHasBeenChecked(shift, index) {
	      var _this = this;
	      //console.log("shiftHasBeenChecked");
	      //console.dir(shift);
	      if (shift.selected) {
	        shift.selected = false;
	        _this.removeShiftFromSelection(shift, index);
	      } else {
	        shift.selected = true;
	        _this.shiftsToBeDeleted.push(shift);
	      }
	    }
	  }, {
	    key: "deleteShift",
	    value: function deleteShift() {
	      var _this = this;
	
	      _this.setLoader();
	
	      _this.$events.deleteShift(_this.shiftToBeDeleted).then(function (response) {
	        _this.displaySuccessBanner();
	        _this.unSetLoader();
	        _this.closeDeleteModal();
	      }, function (error) {
	        _this.unSetLoader();
	        _this.closeDeleteModal();
	        _this.$timeout(function () {
	          alert("Something went wrong deleting a shift. Please contact admin : " + error.data.message);
	        }, 300);
	      });
	    }
	  }, {
	    key: "closeDeleteModal",
	    value: function closeDeleteModal() {
	      var _this = this;
	      _this.shifts.splice(_this.shiftToBeDeletedIndex, 1);
	    }
	  }, {
	    key: "selectedShiftToDelete",
	    value: function selectedShiftToDelete(shift, index) {
	      var _this = this;
	      _this.shiftToBeDeleted = shift;
	      _this.shiftToBeDeletedIndex = index;
	      if (shift.id) {
	        _this.$timeout(function () {
	          $("#delete-shift-confirm").modal();
	        });
	      } else {
	        _this.shifts.splice(_this.shiftToBeDeletedIndex, 1);
	      }
	    }
	  }, {
	    key: "removeShiftFromSelection",
	    value: function removeShiftFromSelection(shift, index) {
	      var _this = this;
	
	      if (_this.shiftsToBeDeleted.length > 0) {
	        var x = _this.shiftsToBeDeleted.findIndex(function (obj) {
	          return obj.id == shift.id;
	        });
	
	        _this.shiftsToBeDeleted.splice(index, 1);
	      }
	    }
	  }, {
	    key: "deleteSelectedShifts",
	    value: function deleteSelectedShifts() {
	      var _this = this;
	
	      var shifts = [];
	
	      try {
	        _this.shifts.forEach(function (s) {
	          if (s.selected === true) {} else {
	            shifts.push(s);
	          }
	        });
	      } catch (err) {
	        //console.log("looping error");
	        //console.dir(err);
	      } finally {
	        _this.shifts = shifts;
	        _this.event.subEvents[0].deduppedJobbles[0].shifts = shifts;
	
	        _this.saveShiftEdit();
	      }
	    }
	  }, {
	    key: "shiftHasBeenClicked",
	    value: function shiftHasBeenClicked(shift) {
	      var _this = this;
	    }
	  }, {
	    key: "setShiftForDelete",
	    value: function setShiftForDelete(shift) {
	      var _this = this;
	    }
	  }, {
	    key: "cancelShiftEdit",
	    value: function cancelShiftEdit(shift) {
	      var _this = this;
	
	      shift.has_been_changed = false;
	      _this.shiftIsBeingEdited = false;
	    }
	  }, {
	    key: "setAutoAccept",
	    value: function setAutoAccept(event) {
	      if (event.autoAccept === true) {
	        this.setAutoHire = true;
	        this.autoHireStatus = "On";
	      } else {
	        this.setAutoHire = false;
	        this.autoHireStatus = "Off";
	      }
	    }
	  }, {
	    key: "setAutoManage",
	    value: function setAutoManage(event) {
	      if (event.autoManage === true) {
	        this.setAutoManage = true;
	      } else {
	        this.setAutoManage = false;
	      }
	    }
	  }, {
	    key: "toggleAutoHire",
	    value: function toggleAutoHire() {
	      var _this6 = this;
	
	      this.setLoader();
	
	      var payload = {};
	      var checked = this.setAutoHire;
	
	      if (checked === true) {
	        payload.autoAccept = false;
	        this.setAutoHire = false;
	      } else {
	        payload.autoAccept = true;
	        this.setAutoHire = true;
	      }
	
	      this.$events.updateAutoHire(this.event, payload).then(function (response) {
	        _this6.$timeout(function () {
	          _this6.unSetLoader();
	          _this6.handleAutoHireResponse(checked);
	        }, 500);
	      }, function (error) {
	        _this6.$timeout(function () {
	          _this6.unSetLoader();
	          _this6.handleAutoHireError();
	        }, 500);
	      });
	    }
	  }, {
	    key: "toggleAutoManage",
	    value: function toggleAutoManage() {
	      var _this7 = this;
	
	      this.setLoader();
	
	      var payload = {};
	      var checked = this.setAutoManage;
	
	      if (checked === true) {
	        payload.autoManage = false;
	        this.setAutoManage = false;
	      } else {
	        payload.autoManage = true;
	        this.setAutoManage = true;
	      }
	
	      this.$events.updateAutoHire(this.event, payload).then(function (response) {
	        _this7.$timeout(function () {
	          _this7.unSetLoader();
	          _this7.handleAutoManageResponse(checked);
	        }, 500);
	      }, function (error) {
	        _this7.$timeout(function () {
	          _this7.unSetLoader();
	          _this7.handleAutoManageError();
	        }, 500);
	      });
	    }
	  }, {
	    key: "getUpdatedData",
	    value: function getUpdatedData() {
	      var _this = this;
	
	      _this.setAutoAccept(_this.event);
	      _this.setAutoManage(_this.event);
	      _this.setHiringManager(_this.event);
	      _this.checkForAdmin();
	
	      _this.$timeout(function () {
	        _this.unSetLoader();
	      }, 2000);
	
	      /*
	          _this.$auth.refreshCurrentUser().then(
	              function (response) {
	                  _this.currentUser = response;
	              },
	              function (error) {
	                  _this.unSetLoader();
	              }
	          );
	           */
	    }
	  }, {
	    key: "handleAutoManageResponse",
	    value: function handleAutoManageResponse(checked) {
	      if (this.setAutoManage === true) {
	        alert("Your job has successfully turned Auto Manage on.");
	      } else {
	        alert("Your job has turned Auto Manage off.");
	      }
	    }
	  }, {
	    key: "handleAutoHireResponse",
	    value: function handleAutoHireResponse(checked) {
	      if (this.setAutoHire === true) {
	        alert("Your job has successfully turned Auto Hire on.");
	      } else {
	        alert("Your job has turned Auto Hire off.");
	      }
	    }
	  }, {
	    key: "handleAutoHireError",
	    value: function handleAutoHireError() {
	      alert("There was an issue updating the jobs Auto Hiring process. Please contact support.");
	    }
	  }, {
	    key: "checkForAdmin",
	    value: function checkForAdmin() {
	      var _this = this;
	
	      if (_this.currentUser.username.indexOf("jobble.com") > -1 || _this.currentUser.username.indexOf("jobbleapp.com") > -1) {
	        _this.currentUser.isAdmin = true;
	      } else {
	        _this.currentUser.isAdmin = false;
	      }
	    }
	  }]);
	
	  return EventeditdetailsController;
	}();
	
	EventeditdetailsController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "events", "security", "$rootScope", "common", "companies", "env", "$timeout", "$scope"];
	
	exports.default = EventeditdetailsController;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(457);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventeditdetails.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventeditdetails.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "eventeditdetails #wrapper{min-height:calc(100% - 62px)}", ""]);
	
	// exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _eventreviewapplicants = __webpack_require__(459);
	
	var _eventreviewapplicants2 = _interopRequireDefault(_eventreviewapplicants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventreviewapplicantsModule = _angular2.default.module("eventreviewapplicants", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("eventreviewapplicants", {
	    url: "/event/:eventId/review?userId",
	    template: "<eventreviewapplicants></eventreviewapplicants>",
	    title: "Manage Roster",
	    params: {
	      userId: null
	    }
	  });
	}).component("eventreviewapplicants", _eventreviewapplicants2.default);
	
	exports.default = eventreviewapplicantsModule;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventreviewapplicants = __webpack_require__(460);
	
	var _eventreviewapplicants2 = _interopRequireDefault(_eventreviewapplicants);
	
	var _eventreviewapplicants3 = __webpack_require__(461);
	
	var _eventreviewapplicants4 = _interopRequireDefault(_eventreviewapplicants3);
	
	__webpack_require__(463);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventreviewapplicantsComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _eventreviewapplicants2.default,
	  controller: _eventreviewapplicants4.default,
	  controllerAs: "vm"
	};
	
	exports.default = eventreviewapplicantsComponent;

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<leftnavigation></leftnavigation>\n\n<jobblerprofile></jobblerprofile>\n\n<div class=\"jobble-page-container jobble-roster-page\" style=\"padding: 24px 95px; margin-left: 30px; padding-left: 10px\">\n  <div class=\"jobble-bread-crumbs\">\n    <span><a href=\"/jobs-dashboard\">All Jobs</a></span><span><i class=\"fas fa-chevron-left\"></i></span><span><a\n        href=\"/event/{{vm.event.id}}/edit\">{{vm.event.name || \"Loading . . .\"}}</a></span><span><i\n        class=\"fas fa-chevron-left\"></i></span><span>Roster</span>\n  </div>\n\n  <div style=\"display: flex\">\n    <div style=\"flex: 1\">\n      <h1>Roster - {{vm.event.name || \"Loading . . .\"}}</h1>\n      <h1></h1>\n    </div>\n    <div style=\"flex: 0 0 275px; display: none\">\n      <a href=\"#modal-add-openings\" data-toggle=\"modal\" ng-click=\"vm.setEventOpenings()\">\n        <div class=\"add-remove-openings-button\"><i class=\"fas fa-user-plus\"></i>Add/Remove Openings</div>\n      </a>\n    </div>\n  </div>\n\n  <div class=\"jobble-table-header search-csv-wrapper\">\n    <div class=\"jobs-dashboard-search\" style=\"float: left; margin-left: 6px\">\n      <form ng-submit=\"vm.reloadApplicants(true); vm.$tracking.reportRosterPageSubmit('search');\">\n        <input type=\"text\" class=\"jobs-dashboard-search\" placeholder=\"Search by name, email, or phone\"\n          ng-model=\"vm.jobQuery\" />\n        <i class=\"fas fa-search search-icon\"></i>\n      </form>\n    </div>\n\n    <div class=\"jobs-dashboard-clear-search\" ng-click=\"vm.clearSearch()\" style=\"float: left\"\n      ng-show=\"vm.jobQuery.length\">\n      <div>\n        <i class=\"fas fa-times clear-search\"> </i>\n      </div>\n    </div>\n\n    <div class=\"jobs-csv-holder\" style=\"float: left\">\n      <i class=\"fas fa-file-export\" ng-csv=\"vm.csv\" csv-header=\"vm.getHeader()\" filename=\"{{ vm.csvName }}\"\n        field-separator=\",\" decimal-separator=\".\" ng-click=\"vm.$tracking.reportRosterPageClick('download csv');\"\n        title=\"Download Roster Table to CSV\" ng-if=\"vm.tabFilter == 1\">\n      </i>\n    </div>\n  </div>\n\n  <div style=\"margin-top: 20px;min-width: 400px;\" class=\"tabbed-header-wrapper\">\n    <ul class=\"tabbed-header\">\n      <li ng-class=\"{'active': vm.tabFilter === 1, 'disabled':vm.statusNumbers[1] === 0}\" ng-click=\"vm.setTabFilter(1)\">\n        Hired\n      </li>\n      <li ng-class=\"{'active': vm.tabFilter === 2, 'disabled':vm.statusNumbers[2] === 0}\" ng-click=\"vm.setTabFilter(2)\">\n        Pending\n      </li>\n      <li ng-class=\"{'active': vm.tabFilter === 3, 'disabled':vm.statusNumbers[3] === 0}\" ng-click=\"vm.setTabFilter(3)\">\n        Applied\n      </li>\n      <li ng-class=\"{'active': vm.tabFilter === 4, 'disabled':vm.statusNumbers[4] === 0}\" ng-click=\"vm.setTabFilter(4)\">\n        Removed\n      </li>\n    </ul>\n  </div>\n\n  <div style=\"margin-top: 15px; height: 40px\" class=\"jobble-table-header\"\n    ng-if=\"vm.tabFilter === 1 && (vm.event.numberOfOpenings + (vm.hiredApplicants ? vm.hiredApplicants.length : 0)) !== 0\">\n    <div class=\"job-status-container\" style=\"width: 490px\">\n      <div class=\"dropdown show filters\">\n        <!-- timeZone change here -->\n        <a class=\"btn btn-secondary dropdown-toggle\" href=\"#\" role=\"button\" id=\"dropdownMenuLink\" data-toggle=\"dropdown\"\n          aria-haspopup=\"true\" aria-expanded=\"false\">\n          {{vm.singleShiftView ? vm.singleShiftViewFormatted : \"\"}}\n          <i class=\"fas fa-chevron-down\"></i>\n        </a>\n\n        <div class=\"dropdown-menu\" aria-labelledby=\"dropdownMenuLink\">\n          <a ng-repeat=\"shift in vm.shiftOptions track by $index\" class=\"dropdown-item\" href=\"#\"\n            ng-click=\"vm.setSingleShiftView(shift, $index)\">\n            Shift {{$index + 1}}: {{shift.shiftDateFormatted}} {{shift.shiftStartTimeLoc }} -> {{shift.shiftEndTimeLoc}}\n            {{shift.shiftTZ}}\n            {{shift.shiftEnded ? \" (ended)\" : \"\"}}{{shift.shiftLive ? \" (live)\" : \"\"}}\n          </a>\n        </div>\n      </div>\n    </div>\n\n    <div ng-if=\"!vm.singleShiftViewShift.shiftEnded\" class=\"job-status-container\"\n      style=\"width: 203px; line-height: 40px; font-weight: 500; font-family: 'Poppins', sans-serif\">\n      {{(vm.confirmationNumbers[vm.singleShiftViewShiftPosition] || 0)}} Confirmed\n      Jobbler{{(vm.confirmationNumbers[vm.singleShiftViewShiftPosition]\n      || 0) > 1 ? \"s\" : \"\"}}\n    </div>\n\n    <div class=\"job-status-container\" style=\"width: 203px\" ng-if=\"vm.singleShiftViewShift.shiftEnded\">\n      <div ng-click=\"vm.openMakeShiftPayment()\" class=\"dropdown show filters\"\n        style=\"text-align: center; background: linear-gradient(270deg, #62C046 0%, #5498B4 100%); opacity: {{vm.readyToPay.length && !vm.weHaveOneCheckedJob ? 1 : 0.5}}; transition: all 0.5s\">\n        <a class=\"btn btn-secondary dropdown-toggle\" type=\"button\" aria-haspopup=\"true\" aria-expanded=\"true\"\n          style=\"color: white; text-transform: uppercase\" ng-if=\"!vm.event.isW2\">\n          <span ng-if=\"!vm.allUsersHaveBeenPaidForThisShift\"> Make Shift Payment </span>\n          <span ng-if=\"vm.allUsersHaveBeenPaidForThisShift == true\"> All Users Are Paid </span>\n        </a>\n        <a class=\"btn btn-secondary dropdown-toggle\" type=\"button\" aria-haspopup=\"true\" aria-expanded=\"true\"\n          style=\"color: white; text-transform: uppercase; width: 70%\" ng-if=\"vm.event.isW2\">\n          View Time Card\n        </a>\n      </div>\n    </div>\n\n    <!--<div class=\"job-status-container\" style=\"width: 223px;\">\n            <div ng-click=\"vm.openMakeShiftPayment()\" class=\"dropdown show filters\"\n                 ng-if=\"vm.singleShiftViewShift.shiftEnded\"\n                 style=\"text-align: center; background: linear-gradient(270deg, #62C046 0%, #5498B4 100%); opacity: 0.5; transition: all 0.5s\">\n                <a class=\"btn btn-secondary dropdown-toggle\" type=\"button\"\n                   aria-haspopup=\"true\" aria-expanded=\"true\" style=\"color: white; text-transform: uppercase;\">\n                    Mark Job As Complete</a>\n            </div>\n        </div>\n-->\n    <div class=\"job-status-container\" style=\"width: 250px\" ng-if=\"false\">\n      <div class=\"dropdown show filters\">\n        <a class=\"btn btn-secondary dropdown-toggle\" type=\"button\" id=\"dropdownMenu1\" data-toggle=\"dropdown\"\n          aria-haspopup=\"true\" aria-expanded=\"true\">\n          {{vm.confirmationFilterText}} 2\n          <i class=\"fas fa-chevron-down\"></i>\n        </a>\n        <ul class=\"dropdown-menu checkbox-menu allow-focus\" aria-labelledby=\"dropdownMenu1\">\n          <li class=\"dropdown-item\">\n            <label>\n              <input ng-click=\"vm.setAll()\" ng-model=\"vm.confirmationFilters.all\" type=\"checkbox\" />\n              ALL\n            </label>\n          </li>\n\n          <li>\n            <label>\n              <input ng-click=\"vm.checkConfirmationFilters()\" ng-model=\"vm.confirmationFilters.confirmed\"\n                type=\"checkbox\" />\n              CONFIRMED\n            </label>\n          </li>\n\n          <li>\n            <label>\n              <input ng-click=\"vm.checkConfirmationFilters()\" ng-model=\"vm.confirmationFilters.declined\"\n                type=\"checkbox\" />\n              DECLINED\n            </label>\n          </li>\n\n          <li>\n            <label>\n              <input ng-click=\"vm.checkConfirmationFilters()\" ng-model=\"vm.confirmationFilters.no_response\"\n                type=\"checkbox\" />\n              NO RESPONSE\n            </label>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n\n  <div\n    ng-if=\"false && vm.tabFilter === 1 && (vm.event.numberOfOpenings + (vm.hiredApplicants ? vm.hiredApplicants.length : 0)) !== 0\"\n    class=\"openings-bar-holder\">\n    <div class=\"openings-bar-text\">\n      {{(vm.hiredApplicants.length || 0) / (vm.event.numberOfOpenings + vm.hiredApplicants.length) * 100 | number:0}}%\n      FILLED ––\n      {{vm.hiredApplicants.length || 0}} / {{vm.event.numberOfOpenings + vm.hiredApplicants.length}} OPENINGS\n    </div>\n    <div class=\"openings-bar\"\n      style=\"width: {{(vm.hiredApplicants.length || 0) / (vm.event.numberOfOpenings + vm.hiredApplicants.length) * 100}}%;\">\n    </div>\n  </div>\n\n  <div\n    ng-if=\"false && !vm.singleShiftViewShift.shiftEnded && vm.tabFilter === 1 && (vm.event.numberOfOpenings + (vm.hiredApplicants ? vm.hiredApplicants.length : 0)) !== 0\"\n    class=\"openings-bar-holder\">\n    <div class=\"openings-bar-text\">\n      {{(vm.confirmationNumbers[vm.singleShiftViewShiftPosition] || 0) / (vm.hiredApplicants.length) * 100 | number:0}}%\n      CONFIRMED ––\n      {{vm.confirmationNumbers[vm.singleShiftViewShiftPosition] || 0}} / {{vm.hiredApplicants.length}} HIRED JOBBLERS\n    </div>\n    <div class=\"openings-bar\"\n      style=\"width: {{(vm.confirmationNumbers[vm.singleShiftViewShiftPosition] || 0) / (vm.hiredApplicants.length) * 100}}%;\">\n    </div>\n  </div>\n\n  <div class=\"jobble-table-header\">\n    <div ng-if=\"vm.tabFilter === 1\" class=\"jobs-dashboard-actions-list-container\" style=\"margin-top: 6px\">\n      <ul class=\"jobs-dashboard-actions-list\" ng-class=\"{ 'job-has-been-checked' : vm.weHaveOneCheckedJob }\">\n        <li ng-if=\"false && !vm.singleShiftViewShift.shiftEnded\" ng-click=\"vm.bulkCheckInOrOutJobblers(false)\">\n          <i class=\"fas fa-calendar-check\"></i> Check in\n        </li>\n        <li ng-if=\"false && !vm.singleShiftViewShift.shiftEnded\" ng-click=\"vm.bulkCheckInOrOutJobblers(true)\">\n          <i class=\"fas fa-calendar-times\"></i> Check out\n        </li>\n        <li ng-if=\"!vm.singleShiftViewShift.shiftEnded\" ng-click=\"vm.bulkRejectApplicants()\"><i\n            class=\"fas fa-minus-square\"></i> Reject\n        </li>\n        <li ng-if=\"vm.singleShiftViewShift.shiftEnded\" ng-click=\"vm.bulkChangeShiftNoShowValue(true);\">\n          <i class=\"fas fa-calendar-check\"></i> Mark as No Show\n        </li>\n        <li ng-if=\"vm.singleShiftViewShift.shiftEnded\" ng-click=\"vm.bulkChangeShiftNoShowValue(false);\">\n          <i class=\"fas fa-calendar-times\"></i> Unmark as No Show\n        </li>\n      </ul>\n    </div>\n\n    <div ng-if=\"vm.tabFilter !== 1\" class=\"jobs-dashboard-actions-list-container\" style=\"margin-top: 14px\">\n      <ul class=\"jobs-dashboard-actions-list\" ng-class=\"{ 'job-has-been-checked' : vm.weHaveOneCheckedJob }\">\n        <li ng-click=\"vm.bulkHireApplicants()\" ng-if=\"vm.tabFilter !== 2\"><i class=\"fas fa-upload\"></i> Hire</li>\n        <li ng-click=\"vm.bulkRejectApplicants()\"><i class=\"fas fa-minus-square\"></i> Reject</li>\n      </ul>\n    </div>\n  </div>\n\n  <div style=\"width: 100%; height: 1px; position: relative\"\n    ng-if=\"vm.singleShiftViewShift.shiftStarted && vm.tabFilter === 1\">\n    <div ng-click=\"vm.toggleMap()\" class=\"map-button-roster\">\n      <div class=\"add-remove-openings-button\">\n        <i ng-if=\"vm.showMap\" class=\"fas fa-times\"></i><i ng-if=\"!vm.showMap\" class=\"fas fa-plus\"></i>Map View\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"vm.tabFilter !== 1\">\n    <table class=\"jobble-table\" ng-mouseenter=\"vm.displayBulkActionItems(true)\" style=\"min-width: 1036px\"\n      ng-mouseleave=\"vm.displayBulkActionItems(false)\">\n      <thead>\n        <tr>\n          <th>\n            <input type=\"checkbox\" ng-checked=\"vm.ui.allChecked\" ng-click=\"vm.checkAll(false)\" />\n          </th>\n          <th style=\"cursor: pointer; min-width: 200px\"\n            ng-click=\"vm.setSortOrder('lastName'); vm.$tracking.reportRosterPageSubmit('sort order'); vm.$tracking.reportRosterPageSubmit('sort order - applicant');\">\n            Applicant\n            <i class=\"fas fa-sort\" ng-if=\"vm.sortField !== 'lastName'\"></i>\n            <i class=\"fas fa-sort-down\" ng-if=\"vm.sortField === 'lastName' && vm.sortOrder === 'desc'\"></i>\n            <i class=\"fas fa-sort-up\" ng-if=\"vm.sortField === 'lastName' && vm.sortOrder === 'asc'\"></i>\n          </th>\n          <th style=\"cursor: pointer; min-width: 135px\"\n            ng-click=\"vm.setSortOrder('phoneMobile'); vm.$tracking.reportRosterPageSubmit('sort order'); vm.$tracking.reportRosterPageSubmit('sort order - phone');\">\n            Phone\n            <i class=\"fas fa-sort\" ng-if=\"vm.sortField !== 'phoneMobile'\"></i>\n            <i class=\"fas fa-sort-down\" ng-if=\"vm.sortField === 'phoneMobile' && vm.sortOrder === 'desc'\"></i>\n            <i class=\"fas fa-sort-up\" ng-if=\"vm.sortField === 'phoneMobile' && vm.sortOrder === 'asc'\"></i>\n          </th>\n          <th style=\"cursor: pointer\"\n            ng-click=\"vm.setSortOrder('email');  vm.$tracking.reportRosterPageSubmit('sort order'); vm.$tracking.reportRosterPageSubmit('sort order - email');\">\n            Email\n            <i class=\"fas fa-sort\" ng-if=\"vm.sortField !== 'email'\"></i>\n            <i class=\"fas fa-sort-down\" ng-if=\"vm.sortField === 'email' && vm.sortOrder === 'desc'\"></i>\n            <i class=\"fas fa-sort-up\" ng-if=\"vm.sortField === 'email' && vm.sortOrder === 'asc'\"></i>\n          </th>\n          <th style=\"cursor: pointer\"\n            ng-click=\"vm.setSortOrder('numberOfCompletedJobbles'); vm.$tracking.reportRosterPageSubmit('sort order'); vm.$tracking.reportRosterPageSubmit('sort order - jobbles');\"\n            ng-if=\"vm.tabFilter != 2 && vm.tabFilter != 4\">\n            Jobbles\n            <i class=\"fas fa-sort\" ng-if=\"vm.sortField !== 'numberOfCompletedJobbles'\"></i>\n            <i class=\"fas fa-sort-down\"\n              ng-if=\"vm.sortField === 'numberOfCompletedJobbles' && vm.sortOrder === 'desc'\"></i>\n            <i class=\"fas fa-sort-up\" ng-if=\"vm.sortField === 'numberOfCompletedJobbles' && vm.sortOrder === 'asc'\"></i>\n          </th>\n          <th style=\"cursor: pointer\"\n            ng-click=\"vm.setSortOrder('averageRatingReceived'); vm.$tracking.reportRosterPageSubmit('sort order'); vm.$tracking.reportRosterPageSubmit('sort order - rating');\"\n            ng-if=\"vm.tabFilter != 2 && vm.tabFilter != 4\">\n            Rating\n            <i class=\"fas fa-sort\" ng-if=\"vm.sortField !== 'averageRatingReceived'\"></i>\n            <i class=\"fas fa-sort-down\" ng-if=\"vm.sortField === 'averageRatingReceived' && vm.sortOrder === 'desc'\"></i>\n            <i class=\"fas fa-sort-up\" ng-if=\"vm.sortField === 'averageRatingReceived' && vm.sortOrder === 'asc'\"></i>\n          </th>\n          <th style=\"cursor: pointer\" ng-if=\"vm.tabFilter == 2 || vm.tabFilter == 4\" class=\"pending-status\">\n            Status\n            <!--\n                  <i class=\"fas fa-sort\"></i>\n                  <i class=\"fas fa-sort-down\"\n                     ng-if=\"vm.sortField === 'averageRatingReceived' && vm.sortOrder === 'desc'\"></i>\n                  <i class=\"fas fa-sort-up\"\n                     ng-if=\"vm.sortField === 'averageRatingReceived' && vm.sortOrder === 'asc'\"></i>\n                     -->\n          </th>\n          <th></th>\n        </tr>\n      </thead>\n      <tbody\n        ng-if=\"(!vm.allApplicants || !vm.allApplicants.length) && (!vm.lastJobQuery || vm.lastJobQuery.length === 0) && !vm.allApplicantsDoneLoading\"\n        class=\"table-loading-row\">\n        <tr ng-repeat=\"fakeApplicant in vm.fakeApplicants\" class=\"fake-jobs\">\n          <td colspan=\"10\"></td>\n        </tr>\n      </tbody>\n      <tbody ng-if=\"vm.allApplicants && vm.allApplicants.length\">\n        <tr ng-repeat=\"applicant in vm.allApplicants | filter: statusFilter track by $index \"\n          ng-class=\"{ 'highlighted' : applicant.isChecked, 'payment-pending' : applicant.status == 'Payment Pending', 'live-job' :  applicant.status == 'Live' }\">\n          <td>\n            <input type=\"checkbox\" ng-checked=\"applicant.isChecked\" ng-click=\"vm.checkApplicant(applicant)\" />\n          </td>\n          <td class=\"link\"\n            ng-style=\"{'color': applicant.hasOverlappingJob ? (applicant.hasOverlappingJobAndHired ? '#F22613' : '#FF5809') : null}\"\n            ng-click=\"applicant.hasOverlappingJob ? vm.showOverlappingJobbles(applicant) : vm.displayDetails(applicant, 'default', 'open', $index, true)\">\n            <!--\n                  <i class=\"fas fa-question-circle application-reason\"\n                     style=\"color: #000;font-weight: 500;text-decoration: none;\"\n                     data-toggle=\"tooltip\"\n                     ng-attr-title=\"{{vm.returnToolTipAdv(applicant)}}\"\n                     data-placement=\"bottom\"\n                     ng   -if=\"(applicant.applicationErrors.length > 0 && vm.currentUser.isAdmin && applicant.applicationStatus != 3 && applicant.applicationStatus != null)\">\n                  </i>\n                  -->\n\n            {{applicant.applicantLastName}}, {{applicant.applicantFirstName}}\n\n            <span style=\"margin-left: 8px\" ng-style=\"{'display': applicant.hasOverlappingJob ? null : 'none'}\">\n              <i class=\"fas fa-exclamation-triangle overlapp-msg\"\n                title=\"This user has either been hired or applied for an overlapping job. Please click for details.\"\n                data-toggle=\"tooltip\"\n                ng-attr-title=\"This user has either been hired or applied for an overlapping job. Please click for details.\"></i>\n            </span>\n          </td>\n          <td>\n            {{applicant.applicantHomeContactInfo.phoneMobile ? applicant.applicantHomeContactInfo.phoneMobile : '---'}}\n          </td>\n          <td class=\"link\" ng-click=\"vm.displayDetails(applicant, 'default', 'open', $index, true)\">\n            {{applicant.applicantEmail }}\n          </td>\n          <td ng-if=\"vm.tabFilter != 2 && vm.tabFilter != 4\">\n            {{applicant.numberOfCompletedJobbles === 0 ? \"0 - new \" : applicant.numberOfCompletedJobbles}}\n          </td>\n          <td ng-if=\"vm.tabFilter != 2 && vm.tabFilter != 4\">\n            {{applicant.numberOfCompletedJobbles === 0 ? \"n/a\" : applicant.displayRating + \"/5\"}}\n          </td>\n          <td ng-if=\"vm.tabFilter == 2 || vm.tabFilter == 4\" col-span=\"2\">\n            {{applicant.applicationStatusRoster.value ? applicant.applicationStatusRoster.value : \"--\" }}\n            <span ng-if=\"vm.currentUser.isAdmin == true && vm.tabFilter == 4 && applicant.humanReadableQuitReason\">\n              <i class=\"fas fa-info-circle quit-reason\" data-toggle=\"tooltip\"\n                ng-attr-title=\"{{applicant.humanReadableQuitReason}}\" data-placement=\"bottom\"></i>\n            </span>\n          </td>\n          <td>\n            <i class=\"fas fa-ellipsis-h\" ng-click=\"vm.toggleActionMenu(applicant,$index,1)\"> </i>\n\n            <div class=\"action-menu\" ng-blur=\"vm.closeActionMenu($index)\" tabindex=\"{{$index}}\">\n              <ul>\n                <li\n                  ng-if=\"!applicant.applicationStatus || applicant.applicationStatus === 3 || applicant.applicationStatus === 2\"\n                  ng-hide=\"applicant.applicationStatus == 1\">\n                  <a href=\"#\" ng-click=\"vm.hireJobblersNew([applicant])\">\n                    <i class=\"fas fa-upload\"></i>\n                    Hire\n                  </a>\n                </li>\n                <li\n                  ng-if=\"!applicant.applicationStatus || applicant.applicationStatus === 3 || applicant.applicationStatus === 1\">\n                  <a href=\"#\" ng-click=\"vm.rejectJobblersNew([applicant])\">\n                    <i class=\"fas fa-minus-square\"></i>\n                    Reject\n                  </a>\n                </li>\n\n                <!--\n              <li\n                ng-if=\"true || !applicant.applicationStatus || applicant.applicationStatus === 3 || applicant.applicationStatus === 2\"\n                ng-hide=\"applicant.applicationStatus == 1\"\n              >\n                <a href=\"#\" ng-click=\"vm.enterCheckInOutTime(applicant, 2, $index, false)\">\n                  <i class=\"fas fa-upload\"></i>\n                  View Shifts\n                </a>\n              </li>-->\n\n                <li ng-if=\"applicant.hasOverlappingJob\">\n                  <a href=\"#\" ng-click=\"vm.showOverlappingJobbles(applicant)\"\n                    ng-style=\"{'color': applicant.hasOverlappingJob ? (applicant.hasOverlappingJobAndHired ? '#F22613' : '#FF5809') : null}\">\n                    <i class=\"fas fa-exclamation-triangle\"></i>\n                    View Overlapping Jobbles\n                  </a>\n                </li>\n              </ul>\n            </div>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n\n    <div\n      ng-if=\"(!vm.allApplicants || !vm.allApplicants.length) && (!vm.lastJobQuery || vm.lastJobQuery.length === 0) && vm.allApplicantsDoneLoading\"\n      class=\"table-loading-row\">\n      <div style=\"text-align: center; font-family: Poppins, sans-serif; font-weight: 600\">\n        <div style=\"margin-top: 40px; font-size: 24px\">Oops –– there’s nobody here yet!</div>\n        <div style=\"margin-top: 24px; font-size: 16px\">Applicants will appear here once they’ve applied.</div>\n        <img style=\"width: 100%; max-width: 74px; margin-top: 24px\" src=\"/app/vendor/images/favicon_gradient.png\"\n          alt=\"Jobble Logo\" />\n      </div>\n    </div>\n    <div ng-if=\"(!vm.allApplicants || !vm.allApplicants.length) && !(!vm.lastJobQuery || vm.lastJobQuery.length === 0)\"\n      class=\"table-loading-row\">\n      <div style=\"text-align: center; font-family: Poppins, sans-serif; font-weight: 600\">\n        <div style=\"margin-top: 40px; font-size: 24px\">No applicants found</div>\n        <div style=\"margin-top: 24px; font-size: 16px\">\n          There are no applicants in your roster who match your search criteria.<br />Try modifying your criteria and\n          search again.\n        </div>\n        <img style=\"width: 100%; max-width: 74px; margin-top: 24px\" src=\"/app/vendor/images/favicon_gradient.png\"\n          alt=\"Jobble Logo\" />\n      </div>\n    </div>\n  </div>\n\n  <div ng-if=\"vm.tabFilter === 1\" style=\"display: flex; min-height: 500px; width: 100%; min-width: 1075px\">\n    <div style=\"flex: 5; overflow: scroll\">\n      <div ng-if=\"vm.tabFilter === 1\">\n        <table class=\"jobble-table\" ng-mouseenter=\"vm.displayBulkActionItems(true)\"\n          ng-mouseleave=\"vm.displayBulkActionItems(false)\" style=\"min-width: 780px\">\n          <thead>\n            <tr>\n              <th>\n                <input type=\"checkbox\" ng-checked=\"vm.ui.allChecked\" ng-click=\"vm.checkAll(true)\" />\n              </th>\n              <th style=\"cursor: pointer; min-width: 200px\"\n                ng-click=\"vm.setSortOrder('lastName'); vm.$tracking.reportRosterPageSubmit('sort order'); vm.$tracking.reportRosterPageSubmit('sort order - applicant');\">\n                Applicant\n                <i class=\"fas fa-sort\" ng-if=\"vm.sortField !== 'lastName'\"></i>\n                <i class=\"fas fa-sort-down\" ng-if=\"vm.sortField === 'lastName' && vm.sortOrder === 'desc'\"></i>\n                <i class=\"fas fa-sort-up\" ng-if=\"vm.sortField === 'lastName' && vm.sortOrder === 'asc'\"></i>\n              </th>\n              <!--ng-if=\"!vm.showMap\"-->\n              <th style=\"cursor: pointer; min-width: 135px\"\n                ng-class=\"{'hide-on-tablet': vm.singleShiftViewShift.shiftEnded}\"\n                ng-click=\"vm.setSortOrder('phoneMobile'); vm.$tracking.reportRosterPageSubmit('sort order'); vm.$tracking.reportRosterPageSubmit('sort order - phone');\">\n                Phone\n                <i class=\"fas fa-sort\" ng-if=\"vm.sortField !== 'phoneMobile'\"></i>\n                <i class=\"fas fa-sort-down\" ng-if=\"vm.sortField === 'phoneMobile' && vm.sortOrder === 'desc'\"></i>\n                <i class=\"fas fa-sort-up\" ng-if=\"vm.sortField === 'phoneMobile' && vm.sortOrder === 'asc'\"></i>\n              </th>\n              <!--class=\"hide-on-tablet\"-->\n              <th style=\"cursor: pointer; width: 300px\" ng-if=\"!vm.showMap\"\n                ng-click=\"vm.setSortOrder('email'); vm.$tracking.reportRosterPageSubmit('sort order'); vm.$tracking.reportRosterPageSubmit('sort order - email');\">\n                Email\n                <i class=\"fas fa-sort\" ng-if=\"vm.sortField !== 'email'\"></i>\n                <i class=\"fas fa-sort-down\" ng-if=\"vm.sortField === 'email' && vm.sortOrder === 'desc'\"></i>\n                <i class=\"fas fa-sort-up\" ng-if=\"vm.sortField === 'email' && vm.sortOrder === 'asc'\"></i>\n              </th>\n              <!--\n                      <th\n                              class=\"hide-on-tablet\"\n                              style=\"cursor: pointer\"\n                              ng-if=\"!vm.showMap && !vm.singleShiftViewShift.shiftEnded\"\n                              ng-click=\"vm.setSortOrder('confirmation'); vm.$tracking.reportRosterPageSubmit('sort order'); vm.$tracking.reportRosterPageSubmit('sort order - confirmation');\"\n                      >\n                          Status\n                          <i class=\"fas fa-sort\" ng-if=\"vm.sortField !== 'confirmation'\"></i>\n                          <i class=\"fas fa-sort-down\"\n                             ng-if=\"vm.sortField === 'confirmation' && vm.sortOrder === 'desc'\"></i>\n                          <i class=\"fas fa-sort-up\"\n                             ng-if=\"vm.sortField === 'confirmation' && vm.sortOrder === 'asc'\"></i>\n                      </th>\n                      -->\n              <!--class=\"show-on-tablet\"-->\n              <th ng-if=\"!vm.singleShiftViewShift.shiftEnded\" style=\"min-width: 133px\"\n                ng-click=\"vm.$tracking.reportRosterPageSubmit('sort order'); vm.$tracking.reportRosterPageSubmit('sort order - confirmation');\">\n                Status\n                <!--\n                           <i class=\"fas fa-sort\" ng-if=\"vm.sortField !== 'confirmation'\"></i>\n                           <i class=\"fas fa-sort-down\"\n                              ng-if=\"vm.sortField === 'confirmation' && vm.sortOrder === 'desc'\"></i>\n                           <i class=\"fas fa-sort-up\"\n                              ng-if=\"vm.sortField === 'confirmation' && vm.sortOrder === 'asc'\"></i>\n                              -->\n              </th>\n              <!--ng-class=\"{'hide-on-tablet': vm.showMap}\"-->\n              <th style=\"cursor: pointer; width: 125px\"\n                ng-click=\"vm.setSortOrder('check-in'); vm.$tracking.reportRosterPageSubmit('sort order'); vm.$tracking.reportRosterPageSubmit('sort order - check-in');\"\n                ng-if=\"vm.singleShiftViewShift.shiftEnded || vm.singleShiftViewShift.shiftLive\">\n                Check in\n                <i class=\"fas fa-sort\" ng-if=\"vm.sortField !== 'check-in'\"></i>\n                <i class=\"fas fa-sort-down\" ng-if=\"vm.sortField === 'check-in' && vm.sortOrder === 'desc'\"></i>\n                <i class=\"fas fa-sort-up\" ng-if=\"vm.sortField === 'check-in' && vm.sortOrder === 'asc'\"></i>\n              </th>\n              <!--ng-class=\"{'hide-on-tablet': vm.showMap}\"-->\n              <th ng-if=\"vm.singleShiftViewShift.shiftEnded || vm.singleShiftViewShift.shiftLive\"\n                style=\"cursor: pointer; width: 160px\"\n                ng-click=\"vm.setSortOrder('check-out'); vm.$tracking.reportRosterPageSubmit('sort order'); vm.$tracking.reportRosterPageSubmit('sort order - check-out');\">\n                Check out\n                <i class=\"fas fa-sort\" ng-if=\"vm.sortField !== 'check-out'\"></i>\n                <i class=\"fas fa-sort-down\" ng-if=\"vm.sortField === 'check-out' && vm.sortOrder === 'desc'\"></i>\n                <i class=\"fas fa-sort-up\" ng-if=\"vm.sortField === 'check-out' && vm.sortOrder === 'asc'\"></i>\n              </th>\n              <!--vm.setSortOrder('status-number');-->\n              <th ng-if=\"vm.singleShiftViewShift.shiftEnded\" style=\"min-width: 160px; width: 160px\"\n                ng-click=\"vm.$tracking.reportRosterPageSubmit('sort order'); vm.$tracking.reportRosterPageSubmit('sort order - status');\">\n                Status\n                <!--\n                          <i class=\"fas fa-sort\" ng-if=\"vm.sortField !== 'status-number'\"></i>\n                          <i class=\"fas fa-sort-down\"\n                             ng-if=\"vm.sortField === 'status-number' && vm.sortOrder === 'desc'\"></i>\n                          <i class=\"fas fa-sort-up\"\n                             ng-if=\"vm.sortField === 'status-number' && vm.sortOrder === 'asc'\"></i>\n                             -->\n              </th>\n              <th style=\"width: 100px\"></th>\n            </tr>\n          </thead>\n          <tbody ng-if=\"vm.hiredApplicants && vm.hiredApplicants.length\">\n            <tr ng-repeat=\"applicant in vm.hiredApplicants | filter: confirmationStatusFilter track by $index \"\n              ng-class=\"{ 'highlighted' : applicant.isChecked,\n                     'payment-pending' : applicant.status == 'Payment Pending',\n                     'live-job' :  applicant.status == 'Live',\n                     'confirmation-green' : vm.singleShiftViewShift.shiftEnded && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber === 1,\n                     'confirmation-red' : vm.singleShiftViewShift.shiftEnded && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber === 2,\n                     'confirmation-red' : ((vm.singleShiftViewShift.shiftEnded && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber === 3) || (vm.singleShiftViewShift.shiftEnded && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber === 2)),\n                     'no-show' : vm.singleShiftViewShift.shiftEnded && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber === 5\n                     }\">\n              <td>\n                <input type=\"checkbox\" ng-checked=\"applicant.isChecked\" ng-click=\"vm.checkApplicant(applicant)\" />\n              </td>\n              <td class=\"link\" ng-click=\"vm.displayDetails(applicant, 'default', 'open', $index, true)\"\n                title=\"{{applicant.applicantLastName}}, {{applicant.applicantFirstName}} \"\n                style=\"width: 300px;position:relative;\">\n                <span ng-if=\"applicant.bgCheckStatus == 'Passed'\" class=\"bg-check-status-update\">\n                  <i class=\"fas fa-check-square bg-check-status\" data-toggle=\"tooltip\"\n                    ng-attr-title=\"Background Check: Passed\" data-placement=\"bottom\"></i>\n                </span>\n\n                <span ng-if=\"applicant.bgCheckStatus == 'Pending' && vm.currentUser.isAdmin == true\"\n                  class=\"bg-check-status-update\">\n                  <i class=\"fas fa-clock bg-check-status bg-check-status\" data-toggle=\"tooltip\"\n                    ng-attr-title=\"Background Check: Pending\" data-placement=\"bottom\"></i>\n                </span>\n                <span ng-if=\"applicant.bgCheckStatus == 'Not required' && vm.currentUser.isAdmin == true\"\n                  class=\"bg-check-status-update\">\n                  <i class=\"fa fa-handshake bg-check-status\" data-toggle=\"tooltip\"\n                    ng-attr-title=\"Background Check: Not Required\" data-placement=\"bottom\"></i>\n                </span>\n                <span ng-if=\"applicant.bgCheckStatus == 'Failed' && vm.currentUser.isAdmin == true\"\n                  class=\"bg-check-status-update\">\n                  <i class=\"fa fa-times-circle bg-check-status\" data-toggle=\"tooltip\"\n                    ng-attr-title=\"Background Check: Failed\" data-placement=\"bottom\"></i>\n                </span>\n                {{applicant.applicantLastName}}, {{applicant.applicantFirstName}}\n                <!--({{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].groupNumber}})-->\n              </td>\n              <!--ng-class=\"{'hide-on-tablet': vm.singleShiftViewShift.shiftEnded}\"-->\n              <td ng-class=\"{'hide-on-tablet': vm.singleShiftViewShift.shiftEnded}\">\n                {{applicant.applicantHomeContactInfo.phoneMobile ? applicant.applicantHomeContactInfo.phoneMobile :\n                '---'}}\n              </td>\n              <!--hide-on-tablet-->\n              <td class=\"link\" style=\"width: 300px\" ng-if=\"!vm.showMap\"\n                ng-click=\"vm.displayDetails(applicant, 'default', 'open', $index, true)\">\n                {{applicant.applicantEmail }}\n              </td>\n              <td ng-if=\"!vm.singleShiftViewShift.shiftEnded\">\n                <span ng-if=\"vm.loadingShiftConfirmationDataByShift[vm.singleShiftViewId]\"><i\n                    class=\"fa fa-sync jobble-spin-1-5\"></i></span>\n                <span ng-click=\"vm.enterCheckInOutTime(applicant, 1, $index)\"\n                  style=\"cursor: pointer; font-weight: bold; text-decoration: underline\"\n                  ng-if=\"!vm.loadingShiftConfirmationDataByShift[vm.singleShiftViewId]\">{{vm.displayStatusText(vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId])}}<i\n                    style=\"margin-left: 8px; cursor: pointer\"\n                    ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].jobblerNote\"\n                    class=\"far fa-sticky-note\"></i></span>\n              </td>\n              <!--ng-class=\"{'hide-on-tablet': vm.showMap}\"-->\n              <td ng-if=\"vm.singleShiftViewShift.shiftEnded || vm.singleShiftViewShift.shiftLive\"\n                class=\"check-in-out-time\"\n                style=\"cursor: pointer; font-weight: bold; text-decoration: underline; width: 110px\"\n                ng-click=\"vm.enterCheckInOutTime(applicant, 1, $index)\">\n                <span ng-if=\"vm.loadingShiftConfirmationDataByShift[vm.singleShiftViewId]\"><i\n                    class=\"fa fa-sync jobble-spin-1-5\"></i></span>\n                <div class=\"hide-on-tablet\" style=\"position: relative\"\n                  ng-if=\"!vm.loadingShiftConfirmationDataByShift[vm.singleShiftViewId]\">\n                  <span\n                    ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInTimeOnly && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].manualCheckInTimeOnly\">\n                    {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInTimeOnly\n                    || \"---\"}}\n                  </span>\n                  <span\n                    ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].manualCheckInTimeOnly\">\n                    <i data-toggle=\"tooltip\"\n                      ng-attr-title=\"The Jobbler revised their check-in time when submitting their time card.\"\n                      data-placement=\"bottom\" class=\"fas fa-stopwatch link-tool-tip\" />\n                    {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].manualCheckInTimeOnly\n                    || \"---\"}}\n                    <!--\n                    {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].TZ}}\n                    -->\n                  </span>\n                  <span\n                    ng-if=\"!vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInTimeOnly && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].manualCheckInTimeOnly\">\n                    ---\n                  </span>\n                  <i data-toggle=\"tooltip\" ng-attr-title=\"Missing location data\" data-placement=\"bottom\"\n                    ng-if=\"false && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInTime && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInCoord.lat\"\n                    class=\"fas fa-exclamation-triangle link-tool-tip\"></i><i class=\"fas fa-eye\"></i>\n                </div>\n                <div\n                  ng-class=\"{'link': vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInTime}\"\n                  class=\"show-on-tablet\" style=\"position: relative\"\n                  ng-if=\"!vm.loadingShiftConfirmationDataByShift[vm.singleShiftViewId]\">\n                  <span\n                    ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInTimeOnly && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].manualCheckInTimeOnly\">\n                    {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInTimeOnly\n                    || \"---\"}}\n                  </span>\n                  <span\n                    ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].manualCheckInTimeOnly\">\n                    <i data-toggle=\"tooltip\"\n                      ng-attr-title=\"The Jobbler revised their check-in time when submitting their time card.\"\n                      data-placement=\"bottom\" class=\"fas fa-stopwatch link-tool-tip\" />\n                    {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].manualCheckInTimeOnly\n                    || \"---\"}}\n                  </span>\n                  <span\n                    ng-if=\"!vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInTimeOnly && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].manualCheckInTimeOnly\">\n                    ---\n                  </span>\n                  <i data-toggle=\"tooltip\" ng-attr-title=\"Missing location data\" data-placement=\"bottom\"\n                    ng-if=\"false && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInTime && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInCoord.lat\"\n                    class=\"fas fa-exclamation-triangle link-tool-tip\"></i>\n                </div>\n              </td>\n              <!--ng-class=\"{'hide-on-tablet': vm.showMap}\"-->\n              <td ng-if=\"vm.singleShiftViewShift.shiftEnded || vm.singleShiftViewShift.shiftLive\"\n                class=\"check-in-out-time\"\n                style=\"cursor: pointer; font-weight: bold; text-decoration: underline; width: 110px\"\n                ng-click=\"vm.enterCheckInOutTime(applicant, 2, $index)\">\n                <span ng-if=\"vm.loadingShiftConfirmationDataByShift[vm.singleShiftViewId]\"><i\n                    class=\"fa fa-sync jobble-spin-1-5\"></i></span>\n                <div class=\"hide-on-tablet\" style=\"position: relative\"\n                  ng-if=\"!vm.loadingShiftConfirmationDataByShift[vm.singleShiftViewId]\">\n                  <span\n                    ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutTimeOnly && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].manualCheckOutTimeOnly\">\n                    {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutTimeOnly\n                    || \"---\"}}\n                  </span>\n                  <span\n                    ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].manualCheckOutTimeOnly\">\n                    <i data-toggle=\"tooltip\"\n                      ng-attr-title=\"The Jobbler revised their check-out time when submitting their time card.\"\n                      data-placement=\"bottom\" class=\"fas fa-stopwatch link-tool-tip\" />\n                    {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].manualCheckOutTimeOnly\n                    || \"---\"}}\n                  </span>\n                  <span\n                    ng-if=\"!vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutTimeOnly && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].manualCheckOutTimeOnly\">\n                    ---\n                  </span>\n                  <i data-toggle=\"tooltip\" ng-attr-title=\"Missing location data\" data-placement=\"bottom\"\n                    ng-if=\"false && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutTime && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutCoord.lat\"\n                    class=\"fas fa-exclamation-triangle link-tool-tip\"></i><i class=\"fas fa-eye\"></i>\n                </div>\n                <div\n                  ng-class=\"{'link': vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutTime}\"\n                  class=\"show-on-tablet\" style=\"position: relative\"\n                  ng-if=\"!vm.loadingShiftConfirmationDataByShift[vm.singleShiftViewId]\">\n                  <span\n                    ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutTimeOnly && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].manualCheckOutTimeOnly\">\n                    {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutTimeOnly\n                    || \"---\"}}\n                  </span>\n                  <span\n                    ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].manualCheckOutTimeOnly\">\n                    <i data-toggle=\"tooltip\"\n                      ng-attr-title=\"The Jobbler revised their check-out time when submitting their time card.\"\n                      data-placement=\"bottom\" class=\"fas fa-stopwatch link-tool-tip\" />\n                    {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].manualCheckOutTimeOnly\n                    || \"---\"}}\n                  </span>\n                  <span\n                    ng-if=\"!vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutTimeOnly && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].manualCheckOutTimeOnly\">\n                    ---\n                  </span>\n                  <i data-toggle=\"tooltip\" ng-attr-title=\"Missing location data\" data-placement=\"bottom\"\n                    ng-if=\"false && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutTime && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutCoord.lat\"\n                    class=\"fas fa-exclamation-triangle link-tool-tip\"></i>\n                </div>\n              </td>\n              <td style=\"font-weight: bold\" ng-if=\"vm.singleShiftViewShift.shiftEnded\">\n                <span class=\"payment-tool-tip\" data-toggle=\"tooltip\" style=\"cursor: pointer; color: #74cf59\"\n                  ng-attr-title=\"{{vm.returnToolTip(vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].tooltip)}}\"\n                  ng-click=\"vm.goToReceipts()\" data-placement=\"bottom\"\n                  ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber === 4\">{{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].status\n                  || \"---\"}}\n                  <span\n                    ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].status != 'No show, Paid'\">\n                    {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInHours}}\n                  </span><span\n                    ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].status != 'No show, Paid'\"\n                    style=\"margin-left: 1px; margin-right: 1px\">H</span>\n                  <span\n                    ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].status != 'No show, Paid'\">\n                    {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInMinutes}}\n                  </span>\n                  <span\n                    ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].status != 'No show, Paid'\"\n                    style=\"margin-left: 1px\">M</span></span>\n                <span\n                  ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber !== 4\">{{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].status\n                  || \"---\"}}</span>\n              </td>\n              <td>\n                <i class=\"fas fa-ellipsis-h\" ng-click=\"vm.toggleActionMenu(applicant,$index,2)\"> </i>\n\n                <div class=\"action-menu\" ng-blur=\"vm.closeActionMenu($index)\" tabindex=\"{{$index}}\">\n                  <ul>\n                    <ul>\n                      <!--\n                                      <li ng-if=\"!vm.singleShiftViewShift.shiftEnded\">\n                                          <a href=\"#\" ng-click=\"vm.checkInOrOutJobblers([applicant], false)\">\n                                              <i class=\"fas fa-upload\"></i>\n                                              Check In\n                                          </a>\n                                      </li>\n                                      --->\n                      <li\n                        ng-if=\"!vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].noShow\">\n                        <a href=\"#\"\n                          ng-click=\"vm.changeShiftNoShowValue(vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId], true)\">\n                          <i class=\"fas fa-upload\"></i>\n                          Mark As No Show\n                        </a>\n                      </li>\n                      <li\n                        ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].noShow\">\n                        <a href=\"#\"\n                          ng-click=\"vm.changeShiftNoShowValue(vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId], false)\">\n                          <i class=\"fas fa-upload\"></i>\n                          Unmark As No Show\n                        </a>\n                      </li>\n                      <li\n                        ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber === 4\">\n                        <a href=\"#\" ng-click=\"vm.openMakeAdditionalPayment(applicant)\">\n                          <i class=\"fas fa-upload\"></i>\n                          Make Additional Payment\n                        </a>\n                      </li>\n                      <!--\n                                      <li ng-if=\"!vm.singleShiftViewShift.shiftEnded\">\n                                          <a href=\"#\" ng-click=\"vm.checkInOrOutJobblers([applicant], true)\">\n                                              <i class=\"fas fa-minus-square\"></i>\n                                              Check Out\n                                          </a>\n                                      </li>\n                                      -->\n                      <!--\n                                      <li>\n                                          <a target=\"_blank\" href=\"/messages/event/{{vm.event.id}}\">\n                                              <i class=\"fas fa-envelope-open-text\"></i>\n                                              Message\n                                          </a>\n                                      </li>\n                                      -->\n                      <li ng-if=\"false\">\n                        <a target=\"_blank\"\n                          href=\"/event/{{vm.event.id}}/payshifts?shiftPosition={{vm.singleShiftViewShiftPosition}}&shiftId={{vm.singleShiftViewId}}\">\n                          <i class=\"fas fa-comment-dollar\"></i>\n                          Make payment\n                        </a>\n                      </li>\n                      <li\n                        ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber !== 4\">\n                        <a href=\"#\" ng-click=\"vm.rejectJobblersNew([applicant])\">\n                          <i class=\"fas fa-minus-square\"></i>\n                          Reject\n                        </a>\n                      </li>\n                    </ul>\n                  </ul>\n                </div>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n\n        <!--\n                Problem is we add users to readyToPay array even if they have not confirmed. They are marked as Needs Review.\n                Next status available to mark them as is noShow == true. Well, they are not a no show and they are also not a Needs Review\n                So we need a new status, perhaps, No Action Taken Yet\n\n                No Action Taken Yet = No confirmation data, and also > 4 hours before start time of shift.\n                -->\n\n        <!--\n                <div ng-if=\"vm.readyToPay.length == 0 && vm.hasShowMoreApplicants\"\n                     style=\"text-align: center; margin-bottom: 20px\">\n                    <div style=\"margin-top: 40px; font-size: 24px\">Oops –– there’s nobody here yet!</div>\n                    <div style=\"margin-top: 24px; font-size: 16px\">\n                        Jobblers will appear here once they've confirmed for the shift\n                    </div>\n                    <img style=\"width: 100%; max-width: 74px; margin-top: 24px\"\n                         src=\"/app/vendor/images/favicon_gradient.png\" alt=\"Jobble Logo\"/>\n                </div>\n                -->\n\n        <div ng-if=\"vm.hasShowMoreApplicants\" ng-click=\"vm.toggleShowUnconfirmed()\" style=\"text-align: center\">\n          <div style=\"width: 285px; display: inline-block; padding: 0 10px; cursor: pointer; border: 1px solid black\"\n            class=\"add-remove-openings-button\">\n            {{vm.showUnconfirmedApplicants ? 'Hide' : 'Show'}} Unconfirmed Jobblers\n            <i class=\"fas fa-caret-{{vm.showUnconfirmedApplicants ? 'up' : 'down'}}\"></i>\n          </div>\n        </div>\n\n        <table class=\"jobble-table\" ng-mouseenter=\"vm.displayBulkActionItems(true)\"\n          ng-mouseleave=\"vm.displayBulkActionItems(false)\"\n          ng-if=\"vm.hasShowMoreApplicants && vm.showUnconfirmedApplicants\">\n          <tbody ng-if=\"vm.hiredApplicants && vm.hiredApplicants.length\">\n            <tr\n              ng-repeat=\"applicant in vm.hiredApplicants | filter: confirmationStatusFilterUnPrioritized track by $index \"\n              ng-class=\"{ 'highlighted' : applicant.isChecked,\n                     'payment-pending' : applicant.status == 'Payment Pending',\n                     'live-job' :  applicant.status == 'Live',\n                     'confirmation-green' : vm.singleShiftViewShift.shiftEnded && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber === 1,\n                     'confirmation-red' : vm.singleShiftViewShift.shiftEnded && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber === 2,\n                     'no-confirm' : applicant.confirmationResponse == null,\n                     'confirmation-red' : ((vm.singleShiftViewShift.shiftEnded && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber === 3) || (vm.singleShiftViewShift.shiftEnded && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber === 2)),\n                     'no-show' : vm.singleShiftViewShift.shiftEnded && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber === 5\n                     }\">\n              <td>\n                <input type=\"checkbox\" ng-checked=\"applicant.isChecked\" ng-click=\"vm.checkApplicant(applicant)\" />\n              </td>\n              <td class=\"link\" style=\"min-width: 200px\"\n                ng-click=\"vm.displayDetails(applicant, 'default', 'open', $index, true)\"\n                title=\"{{applicant.applicantLastName}}, {{applicant.applicantFirstName}} \">\n                <span ng-if=\"applicant.bgCheckStatus == 'Passed' && vm.currentUser.isAdmin == true\"\n                  class=\"bg-check-status-update\">\n                  <i class=\"fas fa-check-square bg-check-status\" data-toggle=\"tooltip\"\n                    ng-attr-title=\"Background Check: Passed\" data-placement=\"bottom\"></i>\n                </span>\n                <span ng-if=\"applicant.bgCheckStatus == 'Pending' && vm.currentUser.isAdmin == true\"\n                  class=\"bg-check-status-update\">\n                  <!--fas fa-clock bg-check-status-->\n                  <!--<i class=\"fas fa-exclamation-triangle\"></i>-->\n                  <!--<i class=\"fas fa-user-times\"></i>-->\n                  <i class=\"fas fa-clock bg-check-status bg-check-status\" data-toggle=\"tooltip\"\n                    ng-attr-title=\"Background Check: Pending\" data-placement=\"bottom\"></i>\n                </span>\n                <span ng-if=\"applicant.bgCheckStatus == 'Not required' && vm.currentUser.isAdmin == true\"\n                  class=\"bg-check-status-update\">\n                  <i class=\"fa fa-handshake bg-check-status\" data-toggle=\"tooltip\"\n                    ng-attr-title=\"Background Check: Not Required\" data-placement=\"bottom\"></i>\n                </span>\n                <span ng-if=\"applicant.bgCheckStatus == 'Failed' && vm.currentUser.isAdmin == true\"\n                  class=\"bg-check-status-update\">\n                  <i class=\"fa fa-times-circle bg-check-status\" data-toggle=\"tooltip\"\n                    ng-attr-title=\"Background Check: Failed\" data-placement=\"bottom\"></i>\n                </span>\n                {{applicant.applicantLastName}}, {{applicant.applicantFirstName}}\n              </td>\n              <td ng-class=\"{'hide-on-tablet': vm.singleShiftViewShift.shiftEnded}\" style=\"width: 300px\">\n                {{applicant.applicantHomeContactInfo.phoneMobile ? applicant.applicantHomeContactInfo.phoneMobile :\n                '---'}}\n              </td>\n              <!--hide-on-tablet-->\n              <td class=\"link\" style=\"width: 300px\" ng-if=\"!vm.showMap\"\n                ng-click=\"vm.displayDetails(applicant, 'default', 'open', $index, true)\">\n                {{applicant.applicantEmail }}\n              </td>\n              <td ng-if=\"vm.singleShiftViewShift.shiftEnded\" class=\"check-in-out-time\"\n                style=\"cursor: pointer; font-weight: bold; text-decoration: underline; width: 125px\"\n                ng-click=\"vm.enterCheckInOutTime(applicant, 1, $index)\">\n                <span ng-if=\"vm.loadingShiftConfirmationDataByShift[vm.singleShiftViewId]\"><i\n                    class=\"fa fa-sync jobble-spin-1-5\"></i></span>\n                <div class=\"hide-on-tablet\" ng-if=\"!vm.loadingShiftConfirmationDataByShift[vm.singleShiftViewId]\">\n                  {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInTimeOnly ||\n                  \"---\"}}<i data-toggle=\"tooltip\" ng-attr-title=\"Missing location data\" data-placement=\"bottom\"\n                    ng-if=\"false && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInTime && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInCoord.lat\"\n                    class=\"fas fa-exclamation-triangle link-tool-tip\"></i><i class=\"fas fa-eye\"></i>\n                </div>\n                <div\n                  ng-class=\"{'link': vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInTime}\"\n                  class=\"show-on-tablet\" ng-if=\"!vm.loadingShiftConfirmationDataByShift[vm.singleShiftViewId]\">\n                  {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInTimeOnly ||\n                  \"---\"}}<i data-toggle=\"tooltip\" ng-attr-title=\"Missing location data\" data-placement=\"bottom\"\n                    ng-if=\"false && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInTime && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkInCoord.lat\"\n                    class=\"fas fa-exclamation-triangle link-tool-tip\"></i>\n                </div>\n              </td>\n              <!--ng-class=\"{'hide-on-tablet': vm.showMap}\"-->\n              <td ng-if=\"vm.singleShiftViewShift.shiftEnded\" class=\"check-in-out-time\"\n                style=\"cursor: pointer; font-weight: bold; text-decoration: underline; width: 160px\"\n                ng-click=\"vm.enterCheckInOutTime(applicant, 2, $index)\">\n                <span ng-if=\"vm.loadingShiftConfirmationDataByShift[vm.singleShiftViewId]\"><i\n                    class=\"fa fa-sync jobble-spin-1-5\"></i></span>\n                <div class=\"hide-on-tablet\" ng-if=\"!vm.loadingShiftConfirmationDataByShift[vm.singleShiftViewId]\">\n                  {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutTimeOnly ||\n                  \"---\"}}\n                  <i data-toggle=\"tooltip\" ng-attr-title=\"Missing location data\" data-placement=\"bottom\"\n                    ng-if=\"false && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutTime && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutCoord.lat\"\n                    class=\"fas fa-exclamation-triangle link-tool-tip\"></i><i class=\"fas fa-eye\"></i>\n                </div>\n                <div\n                  ng-class=\"{'link': vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutTime}\"\n                  class=\"show-on-tablet\" ng-if=\"!vm.loadingShiftConfirmationDataByShift[vm.singleShiftViewId]\">\n                  {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutTimeOnly ||\n                  \"---\"}}<i data-toggle=\"tooltip\" ng-attr-title=\"Missing location data\" data-placement=\"bottom\"\n                    ng-if=\"false && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutTime && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].checkOutCoord.lat\"\n                    class=\"fas fa-exclamation-triangle link-tool-tip\"></i>\n                </div>\n              </td>\n              <td ng-click=\"vm.displayDetails(applicant, 'default', 'open', $index, true)\"\n                style=\"min-width: 160px; width: 160px\">\n                <span style=\"cursor: pointer; font-weight: bold; text-decoration: underline\"\n                  ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber !== 4\">{{vm.displayStatusText(vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId])}}\n                  <!-- {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].shiftId}}-->\n                </span>\n              </td>\n\n              <td style=\"font-weight: bold\" ng-if=\"vm.singleShiftViewShift.shiftEnded\">\n                <span class=\"payment-tool-tip\" data-toggle=\"tooltip\" style=\"cursor: pointer\"\n                  ng-attr-title=\"{{vm.returnToolTip(vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].tooltip)}}\"\n                  ng-click=\"vm.goToReceipts()\" data-placement=\"bottom\"\n                  ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber === 4\">{{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].status\n                  || \"---\"}}\n                  {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInHours}}<span\n                    style=\"margin-left: 1px; margin-right: 1px\">H</span>\n                  {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInMinutes}}<span\n                    style=\"margin-left: 1px\">M</span></span>\n                <span\n                  ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber !== 4\"></span>\n              </td>\n              <td style=\"width: 100px\">\n                <i class=\"fas fa-ellipsis-h\" ng-click=\"vm.toggleActionMenu(applicant,$index,3)\"> </i>\n\n                <div class=\"action-menu\" ng-blur=\"vm.closeActionMenu($index)\" tabindex=\"{{$index}}\">\n                  <ul>\n                    <ul>\n                      <li ng-if=\"!vm.singleShiftViewShift.shiftEnded\">\n                        <a href=\"#\" ng-click=\"vm.checkInOrOutJobblers([applicant], false)\">\n                          <i class=\"fas fa-upload\"></i>\n                          Check In\n                        </a>\n                      </li>\n                      <li\n                        ng-if=\"!vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].noShow\">\n                        <a href=\"#\"\n                          ng-click=\"vm.changeShiftNoShowValue(vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId], true)\">\n                          <i class=\"fas fa-upload\"></i>\n                          Mark As No Show\n                        </a>\n                      </li>\n                      <li\n                        ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].noShow\">\n                        <a href=\"#\"\n                          ng-click=\"vm.changeShiftNoShowValue(vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId], false)\">\n                          <i class=\"fas fa-upload\"></i>\n                          Unmark As No Show\n                        </a>\n                      </li>\n                      <li\n                        ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber === 4\">\n                        <a href=\"#\" ng-click=\"vm.openMakeAdditionalPayment(applicant)\">\n                          <i class=\"fas fa-upload\"></i>\n                          Make Additional Payment\n                        </a>\n                      </li>\n                      <li ng-if=\"!vm.singleShiftViewShift.shiftEnded\">\n                        <a href=\"#\" ng-click=\"vm.checkInOrOutJobblers([applicant], true)\">\n                          <i class=\"fas fa-minus-square\"></i>\n                          Check Out\n                        </a>\n                      </li>\n                      <!--\n                                      <li>\n                                          <a target=\"_blank\" href=\"/messages/event/{{vm.event.id}}\">\n                                              <i class=\"fas fa-envelope-open-text\"></i>\n                                              Message\n                                          </a>\n                                      </li>\n                                      -->\n                      <li ng-if=\"false\">\n                        <a target=\"_blank\"\n                          href=\"/event/{{vm.event.id}}/payshifts?shiftPosition={{vm.singleShiftViewShiftPosition}}&shiftId={{vm.singleShiftViewId}}\">\n                          <i class=\"fas fa-comment-dollar\"></i>\n                          Make payment\n                        </a>\n                      </li>\n                      <li\n                        ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber !== 4\">\n                        <a href=\"#\" ng-click=\"vm.rejectJobblersNew([applicant])\">\n                          <i class=\"fas fa-minus-square\"></i>\n                          Reject\n                        </a>\n                      </li>\n                    </ul>\n                  </ul>\n                </div>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n\n        <div\n          ng-if=\"(!vm.hiredApplicants || !vm.hiredApplicants.length) && (!vm.lastJobQuery || vm.lastJobQuery.length === 0)\">\n          <div style=\"text-align: center; font-family: Poppins, sans-serif; font-weight: 600\">\n            <div ng-if=\"vm.initialLoadingApplicants\">\n              <div style=\"margin-top: 40px; font-size: 24px\">Loading Jobblers . . .</div>\n              <img style=\"width: 100%; max-width: 74px; margin-top: 24px\" src=\"/app/vendor/images/favicon_gradient.png\"\n                alt=\"Jobble Logo\" />\n            </div>\n            <div ng-if=\"!vm.initialLoadingApplicants\">\n              <div style=\"margin-top: 40px; font-size: 24px\">Oops –– there’s nobody here yet!</div>\n              <div style=\"margin-top: 24px; font-size: 16px\">Applicants will appear here once they've applied and you’ve\n                hired them.\n              </div>\n              <img style=\"width: 100%; max-width: 74px; margin-top: 24px\" src=\"/app/vendor/images/favicon_gradient.png\"\n                alt=\"Jobble Logo\" />\n            </div>\n          </div>\n        </div>\n\n        <div\n          ng-if=\"(!vm.hiredApplicants || !vm.hiredApplicants.length) && !(!vm.lastJobQuery || vm.lastJobQuery.length === 0)\"\n          class=\"table-loading-row\">\n          <div style=\"text-align: center; font-family: Poppins, sans-serif; font-weight: 600\">\n            <div style=\"margin-top: 40px; font-size: 24px\">No applicants found</div>\n            <div style=\"margin-top: 24px; font-size: 16px\">\n              There are no applicants in your roster who match your search criteria.<br />Try modifying your criteria\n              and\n              search again.\n            </div>\n            <img style=\"width: 100%; max-width: 74px; margin-top: 24px\" src=\"/app/vendor/images/favicon_gradient.png\"\n              alt=\"Jobble Logo\" />\n          </div>\n        </div>\n      </div>\n    </div>\n    <div style=\"flex: 2; padding-left: 32px\" ng-if=\"vm.showMap && vm.singleShiftViewShift.shiftStarted \">\n      <div style=\"position: relative\" class=\"map-holder-checkin-2\">\n        <div id=\"mapbox-2\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<eventdialog></eventdialog>\n<paymentdialog></paymentdialog>\n<jobblefooter></jobblefooter>\n\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n\n<div class=\"modal fade\" id=\"modal-hire-jobbler\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n  data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\" style=\"padding-left: 25px; padding-right: 25px\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n            </button>\n\n            <h3 class=\"modal-title\" ng-if=\"vm.approvedApplicants.length == 1\">Confirm Hire</h3>\n            <h3 class=\"modal-title\" ng-if=\"vm.approvedApplicants.length > 1\">Confirm Hires</h3>\n\n            <div class=\"scroll-vertical-contain\">\n              <table>\n                <tbody>\n                  <tr ng-repeat=\"application in vm.approvedApplicants track by $index\">\n                    <td>\n                      <img\n                        src=\"{{ application.applicant.filePROFILE_IMAGE1IMG_75x75 ? application.applicant.filePROFILE_IMAGE1IMG_75x75 : '/app/vendor/images/defaultimg.jpeg' }}\" />\n                    </td>\n                    <td>{{ application.applicant.firstName }} {{ application.applicant.lastName }}</td>\n                    <td>\n                      <i class=\"fa fa-star\" ng-if=\"application.applicant.displayRating > 0\" aria-hidden=\"true\"></i>\n                      <i class=\"fa fa-star\" ng-if=\"application.applicant.displayRating > 1\" aria-hidden=\"true\"></i>\n                      <i class=\"fa fa-star\" ng-if=\"application.applicant.displayRating > 2\" aria-hidden=\"true\"></i>\n                      <i class=\"fa fa-star\" ng-if=\"application.applicant.displayRating > 3\" aria-hidden=\"true\"></i>\n                      <i class=\"fa fa-star\" ng-if=\"application.applicant.displayRating > 4\" aria-hidden=\"true\"></i>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n          <div class=\"modal-body popup-body text-center\">\n            <div class=\"alert-box alert\" ng-if=\"vm.hireJobblerResult.status === 'error'\">\n              {{vm.hireJobblerResult.message}}\n            </div>\n\n            <p ng-if=\"!vm.event.isSourcingPost\">\n              Once hired, all jobbler(s) will receive email, text message and jobble chat notifications of the change in\n              their application status.\n            </p>\n            <p ng-if=\"vm.event.isSourcingPost\">Once marked as interested, all jobbler(s) will receive email, SMS and\n              jobble chat notifications.</p>\n\n            <a class=\"btn btn-success button\" ng-click=\"vm.hireJobblers()\" ng-if=\"!vm.event.isSourcingPost\">Hire\n              Jobblers</a>\n            <a class=\"btn btn-success button\" ng-click=\"vm.hireJobblers()\" ng-if=\"vm.event.isSourcingPost\"\n              style=\"margin-top: 20px\">Mark as Interested</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<a style=\"display: none\" href=\"#modal-fire-jobbler-new\" id=\"modal-fire-link-clicker\" data-toggle=\"modal\"></a>\n<div class=\"modal fade\" id=\"modal-fire-jobbler-new\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n  data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n            </button>\n            <h3 class=\"modal-title\">\n              Are you sure you want to remove {{ vm.applicationForReject.applicant.firstName }}\n              {{vm.applicationForReject.applicant.lastName |\n              limitTo: 1 }}?\n            </h3>\n          </div>\n          <div class=\"modal-body popup-body text-center\">\n            <p>If you change your mind later, you can always re-hire.</p>\n            <a class=\"btn btn-danger\" ng-click=\"vm.confirmRemoveJobbler(vm.applicantStatus)\"\n              style=\"margin-top: 10px\">Remove</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"reached-openings-limit\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n  data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n            </button>\n            <h3 class=\"modal-title\">This Job Has No Room</h3>\n          </div>\n          <div class=\"modal-body popup-body text-center\">\n            <p>You will need to add openings to this job if you want to hire more jobblers</p>\n\n            <a class=\"btn btn-success button\" ng-click=\"vm.triggerOpeningsModal()\" style=\"margin-top: 10px\"> Add More\n              Openings </a>\n            <!--\n                        <a class=\"btn btn-danger\" ng-click=\"vm.confirmRemoveJobbler(vm.applicantStatus)\" style=\"margin-top:10px;\">Remove</a>\n                        -->\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<a href=\"#modal-view-jobble\" id=\"modal-view-jobble-click\" data-toggle=\"modal\" style=\"display: none\"></a>\n<!--<a href=\"#dynamicpage\" id=\"modal-post-event-link\" data-toggle=\"modal\" ng-hide=\"true\"></a>-->\n\n<div class=\"modal fade jobble-modal\" id=\"modal-check-user-in-link\" tabindex=\"-1\" role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\" style=\"width: 650px\">\n        <div class=\"modal-content popup-content\">\n          <div style=\"\n              position: absolute;\n              left: 0;\n              top: 0;\n              height: 6px;\n              width: 100%;\n              margin-bottom: 16px;\n              border-radius: 6px 6px 0 0;\n              background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n            \"></div>\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fas fa-times\" aria-hidden=\"true\"></i>\n            </button>\n            <h4 class=\"modal-title\">Check-in/out times</h4>\n          </div>\n          <div class=\"modal-body\">\n            <div style=\"margin-bottom: 16px\">\n              {{ vm.selectedjobbler.applicantFirstName }} {{vm.selectedjobbler.applicantLastName }} -- {{vm.event.name}}\n            </div>\n\n            <div style=\"padding: 0 24px\">\n              <div style=\"margin-bottom: 0px\">\n                <div\n                  style=\"display: flex; font-weight: 600; font-size: 15px; margin-bottom: 8px; text-transform: uppercase\">\n                  <div style=\"flex: 1\">Shift Date</div>\n                  <div style=\"flex: 1\">Check-in</div>\n                  <div style=\"flex: 1\">Check-out</div>\n                  <div style=\"flex: 0.75\">Status</div>\n                </div>\n              </div>\n            </div>\n            <div style=\"border: 1px solid #979797; border-radius: 6px; padding: 0 24px\">\n              <!-- table to update - kkkkkk -->\n              <div style=\"margin-bottom: 0px\" ng-repeat=\"shift in vm.shiftOptions track by $index\">\n                <div\n                  style=\"display: flex; height: 50px; line-height: 50px; cursor: pointer; font-weight: 500; font-size: 13px; color: {{vm.modalSingleShiftViewId === shift.id ? '#62C046' : null}}\"\n                  ng-click=\"vm.setModalSingleShiftView(shift, $index)\">\n                  <div style=\"flex: 1\">{{shift.shiftDateFormatted}}</div>\n\n                  <div style=\"flex: 1\">\n                    <div class=\"check-in-out-time\" style=\"position: relative\"\n                      ng-if=\"vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].manualCheckInTimeOnly\">\n                      {{vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].manualCheckInTimeOnly\n                      || \"-\"}}\n                      <i data-toggle=\"tooltip\"\n                        ng-attr-title=\"The Jobbler revised their check-in time when submitting their time card.\"\n                        data-placement=\"bottom\" class=\"fas fa-stopwatch link-tool-tip time-card check-in-out-modal\"></i>\n                    </div>\n\n                    <div class=\"check-in-out-time\"\n                      ng-if=\"vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].checkInTimeOnly && !vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].manualCheckInTimeOnly\">\n                      {{vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].checkInTimeOnly ||\n                      \"-\"}}\n                    </div>\n\n                    <div class=\"check-in-out-time\"\n                      ng-if=\"!vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].checkInTimeOnly && !vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].manualCheckInTimeOnly\">\n                      ---\n                    </div>\n                  </div>\n                  <div style=\"flex: 1\">\n                    <div class=\"check-in-out-time\" style=\"position: relative\"\n                      ng-if=\"vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].manualCheckOutTimeOnly\">\n                      {{vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].manualCheckOutTimeOnly\n                      || \"---\"}}\n                      <i data-toggle=\"tooltip\"\n                        ng-attr-title=\"The Jobbler revised their check-out time when submitting their time card.\"\n                        data-placement=\"bottom\" class=\"fas fa-stopwatch link-tool-tip time-card check-in-out-modal\"></i>\n                    </div>\n\n                    <div class=\"check-in-out-time\"\n                      ng-if=\"vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].checkOutTimeOnly && !vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].manualCheckOutTimeOnly\">\n                      {{vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].checkOutTimeOnly\n                      || \"---\"}}\n                    </div>\n\n                    <div class=\"check-in-out-time\"\n                      ng-if=\"!vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].checkOutTimeOnly && !vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].manualCheckOutTimeOnly\">\n                      ---\n                    </div>\n                  </div>\n\n                  <div style=\"flex: 0.75\">\n                    <span class=\"payment-tool-tip\" data-toggle=\"tooltip\" style=\"cursor: pointer\"\n                      ng-attr-title=\"{{vm.returnToolTip(vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].tooltip)}}\"\n                      ng-click=\"vm.goToReceipts()\" data-placement=\"bottom\"\n                      ng-if=\"vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].statusNumber === 4\">\n                      {{vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].status || \"---\"}}\n                      {{vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].timeInterval.timeInHours}}<span\n                        style=\"margin-left: 1px; margin-right: 1px\">H</span>\n                      {{vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].timeInterval.timeInMinutes}}<span\n                        style=\"margin-left: 1px\">M</span>\n                    </span>\n                    <span\n                      ng-if=\"vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].statusNumber !== 4\">\n                      {{vm.shiftConfirmationData[shift.shiftPosition][vm.selectedjobbler.applicantId].status || \"---\"}}\n                    </span>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <h4 style=\"margin-top: 16px\" class=\"modal-title\">Check-in/out locations</h4>\n\n            <!--                        <div class=\"jobble-table-header\">-->\n            <!--                            <div class=\"job-status-container\">-->\n            <!--                                <div-->\n            <!--                                        class=\"dropdown show filters\">-->\n            <!--                                    <a-->\n            <!--                                            class=\"btn btn-secondary dropdown-toggle\"-->\n            <!--                                            href=\"#\"-->\n            <!--                                            role=\"button\"-->\n            <!--                                            id=\"dropdownMenuLink-2\"-->\n            <!--                                            data-toggle=\"dropdown\"-->\n            <!--                                            aria-haspopup=\"true\"-->\n            <!--                                            aria-expanded=\"false\">-->\n            <!--                                        {{ vm.modalSingleShiftViewFormatted }}-->\n            <!--                                        <i class=\"fas fa-chevron-down\"></i>-->\n            <!--                                    </a>-->\n\n            <!--                                    <div-->\n            <!--                                            class=\"dropdown-menu\"-->\n            <!--                                            aria-labelledby=\"dropdownMenuLink-2\">-->\n            <!--                                        <a ng-repeat=\"shift in vm.shiftOptions track by $index\" class=\"dropdown-item\" href=\"#\"-->\n            <!--                                           ng-click=\"vm.setModalSingleShiftView(shift, $index)\">-->\n            <!--                                            Shift {{$index + 1}}: {{shift.shiftDateFormatted}}-->\n            <!--                                        </a>-->\n            <!--                                    </div>-->\n\n            <!--                                </div>-->\n\n            <!--                            </div>-->\n            <!--                        </div>-->\n\n            <div style=\"margin-bottom: 8px\">Shift Note: {{vm.selectedjobbler.jobblerNote || \"N/A\"}}</div>\n\n            <div class=\"map-google\"\n              style=\"position: relative; padding: 0; height: 244px; width: 100%; margin-top: 16px; border-radius: 6px; border: 1px solid #adbcc2\">\n              <div style=\"position: absolute; top: 0; bottom: 0; width: 100%; height: 100%\" id=\"check-in-out-map\"></div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade jobble-modal\" id=\"modal-overlapping\" tabindex=\"-1\" role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\" style=\"width: 750px\">\n        <div class=\"modal-content popup-content\">\n          <div style=\"\n              position: absolute;\n              left: 0;\n              top: 0;\n              height: 6px;\n              width: 120%;\n              margin-bottom: 16px;\n              border-radius: 6px 6px 0 0;\n              background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n            \"></div>\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fas fa-times\" aria-hidden=\"true\"></i>\n            </button>\n            <h4 class=\"modal-title\">\n              Overlapping Jobbles - {{ vm.selectedjobblerOverlapping.applicantFirstName }}\n              {{vm.selectedjobblerOverlapping.applicantLastName }}\n            </h4>\n          </div>\n          <div class=\"modal-body\" style=\"font-weight: 500\">\n            <div style=\"margin-bottom: 24px; line-height: 21px\">\n              This jobbler has applied to multiple jobbles that have conflicting shifts. See below to view which jobbles\n              they applied to and their\n              respective application statuses\n            </div>\n            <div style=\"padding: 0 24px\">\n              <div style=\"margin-bottom: 0px\">\n                <div\n                  style=\"display: flex; font-weight: 500; font-size: 15px; margin-bottom: 8px; text-transform: uppercase\">\n                  <div style=\"flex: 1\">Event Id</div>\n                  <div style=\"flex: 2\">Event Name</div>\n                  <div style=\"flex: 1\">Status</div>\n                </div>\n              </div>\n            </div>\n            <div style=\"border: 1px solid #979797; border-radius: 6px; padding: 0 24px\">\n              <div style=\"margin-bottom: 0px\" ng-repeat=\"jobble in vm.selectedjobblerOverlapping.conflictingJobbles\">\n                <div style=\"display: flex; height: 50px; line-height: 50px; font-weight: 500; font-size: 13px\">\n                  <div style=\"flex: 1\">{{jobble.eventId}}</div>\n                  <div style=\"flex: 2\">{{jobble.eventName}}</div>\n                  <div style=\"flex: 1\">\n                    {{jobble.applicationStatus ? (jobble.applicationStatus === 1 ? \"Hired\" : \"Pending\") : \"Pending\"}}\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade jobble-modal\" id=\"modal-shift-payment\" tabindex=\"-1\" role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content payment-screen\">\n          <div style=\"\n              position: absolute;\n              left: 0;\n              top: 0;\n              height: 6px;\n              width: 100%;\n              margin-bottom: 16px;\n              border-radius: 6px 6px 0 0;\n              background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n            \"></div>\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fas fa-times\" aria-hidden=\"true\"></i>\n            </button>\n            <h4 class=\"modal-title\" ng-if=\"vm.event.isW2 != true\"\n              style=\"padding-top: 13px; font-size: 22px; margin-bottom: 0px\">\n              Make a shift payment for {{vm.singleShiftViewShift.shiftDateFormattedTitle}} shift\n            </h4>\n            <h4 class=\"modal-title\" ng-if=\"vm.event.isW2 == true\">View / Edit time card</h4>\n          </div>\n          <div class=\"modal-body payment-modal-body\" style=\"font-weight: 500\">\n            <div>\n              <h5 style=\"color: #3b3f43; font-family: Poppins, sans-serif\">\n                Shift duration: <span style=\"font-weight: bold\">{{vm.singleShiftViewShift.duration}}</span>\n              </h5>\n            </div>\n            <div style=\"line-height: 21px\">\n              Review and edit the hours of your hired Jobblers in the table below.\n              <span ng-if=\"!vm.invoice\">Then select your desired payment method.</span><br /><br />\n            </div>\n            <div ng-if=\"false && vm.readyToPay.length\" style=\"margin-top: 16px; margin-bottom: 16px;\n                        font-size: 14px;\n                        cursor: {{vm.atLeastOneReadyToPayChecked ? 'pointer' : 'inherit'}};\n                        font-weight: 600;\n                        transition: all 0.5s;\n                        opacity: {{vm.atLeastOneReadyToPayChecked ? 1 : 0.5}}\">\n              <i class=\"fas fa-calendar-times\"></i> Remove from payment\n            </div>\n\n            <div style=\"padding: 0 16px; padding-left: 8px\">\n              <div style=\"margin-bottom: 0px\" class=\"paid-users-header\">\n                <div\n                  style=\"display: flex; font-weight: 500; font-size: 15px; margin-bottom: 8px; text-transform: uppercase\">\n                  <div style=\"flex: 0 0 20px\"></div>\n                  <div style=\"flex: 1\" class=\"shorten-on-phone\">Applicant</div>\n                  <div style=\"flex: 0.85\">\n                    Hours\n                    <span ng-if=\"vm.readyToPay[0].applicant.shiftData.unpaidBreak > 0\" style=\"font-size:10px;\">\n                      (Minus {{vm.readyToPay[0].applicant.shiftData.unpaidBreak}} min. unpaid break)\n                    </span>\n                  </div>\n                  <!--\n                                    <div style=\"flex: 0.85\">Submitted</div>\n                                    -->\n                  <div style=\"flex: 0.45\" class=\"hide-on-phone\">$/HR</div>\n                  <div style=\"flex: 0.45\">Amount</div>\n                </div>\n              </div>\n            </div>\n            <div \n                  style=\"min-height: 250px;\"\n                  ng-if=\"vm.readyToPay.length\" \n                  class=\"payment-table-users-to-pay\"\n                  ng-class=\"{ 'payment-height-2' : vm.readyToPay.length > 5,  'payment-height-3' : vm.readyToPay.length > 7}\">\n              <div style=\"margin-bottom: 0px\" ng-repeat=\"applicant in vm.readyToPay track by $index\"\n                ng-click=\"vm.onClickUpdateHours(applicant.applicantId);\">\n                <div ng-if=\"applicant.bgCheckStatus != 'Pending'\"\n                  style=\"display: flex; height: 50px; line-height: 50px; font-weight: 500; font-size: 13px; padding: 0 8px; border-bottom: {{$index === vm.readyToPay.length - 1 ? 'none' : '1px solid rgba(151,151,151,0.5)'}}\">\n                  <div style=\"flex: 0 0 20px; cursor: pointer\" ng-click=\"vm.removeFromPayment(applicant)\">\n                    <i class=\"fas fa-times-circle remove-from-p-list\" data-toggle=\"tooltip\"\n                      ng-attr-title=\"Remove from payment list\" data-placement=\"right\"></i>\n                  </div>\n                  <div style=\"flex: 1\" class=\"shorten-on-phone\">\n                    {{applicant.applicantLastName}}<span class=\"hide-on-phone\">, {{applicant.applicantFirstName}}</span>\n                    <i data-toggle=\"tooltip\" ng-attr-title=\"Missing check-in/out data\" data-placement=\"bottom\"\n                      ng-if=\"!vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInMinutes && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInHours\"\n                      style=\"color: #f22613; float: right; line-height: 50px; margin-right: 8px\"\n                      class=\"link-tool-tip fas fa-exclamation-triangle\"></i>\n                  </div>\n                  <div\n                    style=\"flex: 0.85; color: {{(!vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInMinutes && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInHours) ? '#F22613' : null}}\">\n                    <div class=\"payment-time-edit\"\n                      ng-click=\"vm.setEditing(vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId], 1); vm.$tracking.reportRosterPageClick('payment - edit hours');\"\n                      ng-if=\"!vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].isEditingHours\"\n                      style=\"display: inline-block; color: {{(!vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInMinutes && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInHours) ? null : null}}\">\n                      {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInHours}}\n                    </div>\n                    <div\n                      ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].isEditingHours\"\n                      style=\"display: inline-block; text-decoration: underline\">\n                      <input class=\"hours-edit-1 noscroll\" style=\"height: 100%; width: 50px; color: black\" type=\"number\"\n                        min=\"0\" step=\"1\"\n                        ng-blur=\"vm.blurTimeEdit(true, vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId], 1)\"\n                        ng-click=\"$event.stopPropagation();vm.setFocusOnInput(1);\"\n                        ng-enter=\"vm.blurHoursUpdated(vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId])\"\n                        ng-change=\"vm.calculateTotalPaymentOnEdit()\"\n                        ng-model=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInHours\"\n                        onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" title=\"Whole Numbers Only\"\n                        scroll />\n                    </div>\n                    <span\n                      ng-click=\"vm.setEditing(vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId], 2); vm.$tracking.reportRosterPageClick('payment - edit hours');\">H</span>\n                    <div class=\"payment-time-edit\"\n                      ng-click=\"vm.setEditing(vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId], 3); vm.$tracking.reportRosterPageClick('payment - edit hours');\"\n                      ng-if=\"!vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].isEditingMinutes\"\n                      style=\"display: inline-block; color: {{(!vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInMinutes && !vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInHours) ? null : null}}\">\n                      {{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInMinutes}}\n                    </div>\n                    <div\n                      ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].isEditingMinutes\"\n                      style=\"display: inline-block\">\n                      <input style=\"height: 100%; width: 50px; color: black\" class=\"hours-edit-2 noscroll\" type=\"number\"\n                        min=\"0\" step=\"1\"\n                        ng-blur=\"vm.blurTimeEdit(true, vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId], 2)\"\n                        ng-click=\"$event.stopPropagation();vm.setFocusOnInput(2);\"\n                        ng-enter=\"vm.blurHoursUpdated(vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId])\"\n                        ng-change=\"vm.calculateTotalPaymentOnEdit()\"\n                        ng-model=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInMinutes\"\n                        onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" title=\"Whole Numbers Only\"\n                        scroll />\n                    </div>\n                    <span\n                      ng-click=\"vm.setEditing(vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId], 4); vm.$tracking.reportRosterPageClick('payment - edit hours');\">M</span><i\n                      style=\"color: #33373a; cursor: pointer; font-size: 14px; margin-left: 7px\"\n                      ng-if=\"!vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].isEditingMinutes\"\n                      ng-click=\"vm.setEditing(vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId], 5); vm.$tracking.reportRosterPageClick('payment - edit hours');\"\n                      class=\"fas fa-pen\"></i><i\n                      style=\"color: #62c046; cursor: pointer; font-size: 14px; margin-left: 7px\"\n                      ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].isEditingMinutes\"\n                      ng-click=\"vm.blurHoursUpdated(vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId]); vm.$tracking.reportRosterPageSubmit('payment - edit hours');\"\n                      class=\"fas fa-check\"></i>\n                  </div>\n                  <!--\n                                    <div style=\"flex: 0.85;\">3 H 45 M</div>\n                                    -->\n                  <div style=\"flex: 0.45\" class=\"hide-on-phone\">\n                    ${{vm.event.subEvents[0].deduppedJobbles[0].jobblerRate / 100 | number: 2}}\n                  </div>\n                  <div\n                    style=\"flex: 0.45; color: {{ vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].paymentJobbler < 0.5 ? '#F22613' : null}}\">\n                    ${{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].paymentJobbler\n                    || 0 | number: 2}}\n                    <i data-toggle=\"tooltip\" ng-attr-title=\"Payment amount must be at least $0.50\"\n                      data-placement=\"bottom\"\n                      ng-if=\"vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].paymentJobbler < 0.5\"\n                      style=\"color: #f22613; line-height: 50px; margin-left: 4px\"\n                      class=\"link-tool-tip fas fa-exclamation-triangle\"></i>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div ng-if=\"!vm.readyToPay.length\"\n              style=\"margin-top: 24px; margin-bottom: 8px; font-size: 14px; text-align: center\">\n              No Jobblers have been selected to pay\n            </div>\n\n            <div ng-if=\"!vm.invoice\" style=\"margin: 16px 0px\">Payment Method</div>\n\n            <div ng-if=\"!vm.invoice\" ng-repeat=\"info in vm.paymentInfos\"\n              style=\"display: flex; font-size: 14px; margin-bottom: 8px; border-radius: 6px; padding: 12px 10px; border: 1px solid #979797\">\n              <div style=\"flex: 0 0 25px\">\n                <input type=\"checkbox\" ng-click=\"vm.setCardToPayment(info)\" ng-model=\"info.isChecked\" />\n              </div>\n              <div style=\"flex: 0.75\">{{info.nickname ? info.nickname : \"--\"}}</div>\n              <div style=\"flex: 0.75\" ng-if=\"info.bankName == null\">Exp.\n                {{info.cardExpirationMonth}}/{{info.cardExpirationYear}}\n              </div>\n              <div style=\"flex: 1\">xxxx xxxx xxxx {{info.last4}}</div>\n              <div style=\"flex: 0 0 60px; text-align: right\">\n                <i class=\"{{ info.image }}\" style=\"font-size: 24px\"></i>\n              </div>\n            </div>\n\n            <div ng-if=\"!vm.invoice\" ng-repeat=\"info in vm.unverifedPaymentInfos\"\n              style=\"display: flex; opacity: 0.5; font-size: 14px; border-radius: 6px; padding: 12px 10px; border: 1px solid #979797\">\n              <div style=\"flex: 0 0 25px\"></div>\n              <div style=\"flex: 1\">\n                {{info.nickname ? info.nickname : info.cardBrand}}\n                <i data-toggle=\"tooltip\" ng-attr-title=\"This payment method is unverified\" data-placement=\"bottom\"\n                  style=\"color: #f22613\" class=\"fas fa-exclamation-triangle link-tool-tip\"></i>\n              </div>\n              <div style=\"flex: 1\" ng-if=\"info.bankName == null\">\n                {{info.cardExpirationMonth}}/{{info.cardExpirationYear}}\n              </div>\n              <div style=\"flex: 1\">xxxx xxxx xxxx {{info.last4}}</div>\n              <div style=\"flex: 0 0 60px; text-align: right\">\n                <i class=\"{{ info.image }}\" style=\"font-size: 24px\"></i>\n              </div>\n            </div>\n\n            <div ng-if=\"!vm.invoice\" style=\"margin-top: 16px\">\n              <a href=\"/account-profile/719373/payment-information\" target=\"_blank\"\n                style=\"color: black; text-decoration: underline; font-size: 12px\">Add another payment method</a>\n            </div>\n\n            <div\n              style=\"margin-top: 24px; font-size: 12px; border-radius: 6px; padding: 14px 24px; padding-bottom: 24px; border: 1px solid #979797\">\n              <div style=\"display: flex\">\n                <div style=\"font-size: 16px; font-weight: 600; margin-left: -9px; flex: 0 0 26px\">\n                  <i class=\"fas fa-receipt\"></i>\n                </div>\n                <div style=\"font-size: 16px; font-weight: 600; flex: 1\">Payment summary</div>\n              </div>\n\n              <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\" />\n\n              <div style=\"display: flex\">\n                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600\">Jobbler payments\n                </div>\n\n                <div style=\"flex: 1; text-align: right\">${{vm.totalPaymentAmountJobbler || 0 | number: 2}}</div>\n              </div>\n\n              <div style=\"display: flex\">\n                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600; margin-top: 8px\">\n                  + Platform fee\n                  <span style=\"display: none\">({{ (vm.totalPaymentAmount - vm.totalPaymentAmountJobbler) /\n                    vm.totalPaymentAmountJobbler * 100 | number: 2\n                    }}%)</span>\n                </div>\n\n                <div style=\"flex: 1; text-align: right; margin-top: 8px\">\n                  ${{(vm.totalPaymentAmount - vm.totalPaymentAmountJobbler) || 0 | number: 2}}\n                </div>\n              </div>\n\n              <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\" />\n\n              <div style=\"display: flex\">\n                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600\">Total billed to your\n                  account\n                </div>\n                <div style=\"flex: 1; text-align: right; font-weight: 600\">${{vm.totalPaymentAmount || 0 | number: 2}}\n                </div>\n              </div>\n            </div>\n          </div>\n          <div>\n            <div ng-if=\"vm.event.isW2 != true\"\n              style=\"text-align: center; cursor: {{vm.allHaveHours && !vm.submittingPayment && !vm.updatingHoursWorked && vm.readyToPay.length && ((!vm.invoice && vm.selectedCard ) || (vm.invoice)) ? 'pointer' : null }};\n                        line-height: 40px; color: white; font-weight: 600; font-size: 14px; border-radius: 6px;\n                        background: linear-gradient(270deg, #62C046 0%, #5498B4 100%); opacity: {{vm.allHaveHours && !vm.updatingHoursWorked && !vm.submittingPayment && vm.readyToPay.length && ((!vm.invoice && vm.selectedCard ) || (vm.invoice)) ? 1 : 0.5}}; transition: all 0.5s; height: 40px; width: 100%; margin-top: 24px\"\n              ng-click=\"vm.sendPayment()\">\n              <span ng-if=\"vm.submittingPayment\">Submitting payment <i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i></span>\n              <span id=\"pay-anchor\" ng-if=\"!vm.submittingPayment\">Submit payment</span>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade jobble-modal\" id=\"modal-rejection-shift-payment\" tabindex=\"-1\" role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div style=\"\n              position: absolute;\n              left: 0;\n              top: 0;\n              height: 6px;\n              width: 100%;\n              margin-bottom: 16px;\n              border-radius: 6px 6px 0 0;\n              background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n            \"></div>\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fas fa-times\" aria-hidden=\"true\"></i>\n            </button>\n            <h4 class=\"modal-title\">Make shift payments before rejecting jobblers</h4>\n          </div>\n          <div class=\"modal-body payment-modal-body\" style=\"font-weight: 500\">\n            <div style=\"margin-bottom: 24px; line-height: 21px\">\n              Before you can reject these jobblers, please review and edit hours in the table below<span\n                ng-if=\"!vm.invoice\">, select your desired payment method</span>, then select “Submit payment”. Invoices\n              are available to review in the “Receipts” tab. Once these jobblers\n              have been paid, you will be\n              taken to a confirmation screen to confirm their rejection from future shifts.\n              <br />\n            </div>\n\n            <div style=\"margin-top: 30px\"\n              ng-repeat=\"shiftPosition in vm.paymentContingenciesShiftPositions track by $index\">\n              <span style=\"font-weight: bold\">{{vm.convertedShiftsMap[shiftPosition].shiftDateFormatted}}:\n                {{vm.convertedShiftsMap[shiftPosition].duration}}</span>\n              <div style=\"margin-top: 10px; padding: 0 16px; padding-left: 8px\">\n                <div style=\"margin-bottom: 0px\">\n                  <div\n                    style=\"display: flex; font-weight: 500; font-size: 15px; margin-bottom: 8px; text-transform: uppercase\">\n                    <div style=\"flex: 0 0 20px; display: none\"></div>\n                    <div style=\"flex: 1\">Applicant</div>\n                    <div style=\"flex: 0.85\">Hours</div>\n                    <div style=\"flex: 0.45\">$/HR</div>\n                    <div style=\"flex: 0.45\">Amount</div>\n                  </div>\n                </div>\n              </div>\n\n              <div ng-if=\"vm.paymentContingenciesMap[shiftPosition].length\"\n                style=\"border: 1px solid #979797; border-radius: 6px; max-height: 200px; overflow-y: scroll\">\n                <div style=\"margin-bottom: 0px\"\n                  ng-repeat=\"applicant in vm.paymentContingenciesMap[shiftPosition] track by $index\"\n                  ng-click=\"vm.onClickUpdateHours(applicant.applicantId);\">\n                  <div\n                    style=\"display: flex; height: 50px; line-height: 50px; font-weight: 500; font-size: 13px; padding: 0 8px; border-bottom: {{$index === vm.readyToPay.length - 1 ? 'none' : '1px solid rgba(151,151,151,0.5)'}}\">\n                    <div style=\"flex: 0 0 20px; cursor: pointer; display: none\"\n                      ng-click=\"vm.removeFromPayment(applicant)\">\n                      <i class=\"fas fa-times-circle remove-from-p-list\" data-toggle=\"tooltip\"\n                        ng-attr-title=\"Remove from payment list\" data-placement=\"right\"></i>\n                    </div>\n                    <!--                                    <div>return; vm.displayDetails(applicant, 'default', 'open',applicant.originalIndex , true)</div>-->\n                    <div style=\"flex: 1\">\n                      {{applicant.applicantLastName}}, {{applicant.applicantFirstName}}\n                      <i data-toggle=\"tooltip\" ng-attr-title=\"Missing check-in/out data\" data-placement=\"bottom\"\n                        ng-if=\"!vm.shiftConfirmationData[shiftPosition][applicant.applicantId].timeInterval.timeInMinutes && !vm.shiftConfirmationData[shiftPosition][applicant.applicantId].timeInterval.timeInHours\"\n                        style=\"color: #f22613; float: right; line-height: 50px; margin-right: 8px\"\n                        class=\"link-tool-tip fas fa-exclamation-triangle\"></i>\n                    </div>\n                    <div\n                      style=\"flex: 0.85; color: {{(!vm.shiftConfirmationData[shiftPosition][applicant.applicantId].timeInterval.timeInMinutes && !vm.shiftConfirmationData[shiftPosition][applicant.applicantId].timeInterval.timeInHours) ? '#F22613' : null}}\">\n                      <div class=\"payment-time-edit\"\n                        ng-click=\"vm.setEditing(vm.shiftConfirmationData[shiftPosition][applicant.applicantId], 6); vm.$tracking.reportRosterPageClick('payment - edit hours');\"\n                        ng-if=\"!vm.shiftConfirmationData[shiftPosition][applicant.applicantId].isEditingHours\"\n                        style=\"display: inline-block; color: {{(!vm.shiftConfirmationData[shiftPosition][applicant.applicantId].timeInterval.timeInMinutes && !vm.shiftConfirmationData[shiftPosition][applicant.applicantId].timeInterval.timeInHours) ? null : null}}\">\n                        {{vm.shiftConfirmationData[shiftPosition][applicant.applicantId].timeInterval.timeInHours}}\n                      </div>\n                      <div ng-if=\"vm.shiftConfirmationData[shiftPosition][applicant.applicantId].isEditingHours\"\n                        style=\"display: inline-block; text-decoration: underline\">\n                        <!-- add blur focus logic -->\n                        <input style=\"height: 100%; width: 50px; color: black\" class=\"hours-edit-3 no scroll\"\n                          type=\"number\" min=\"0\" step=\"1\"\n                          ng-blur=\"vm.blurTimeEdit(true, vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId], 3)\"\n                          ng-click=\"$event.stopPropagation();vm.setFocusOnInput(3);\"\n                          ng-enter=\"vm.blurHoursUpdated(vm.shiftConfirmationData[shiftPosition][applicant.applicantId])\"\n                          ng-change=\"vm.calculateTotalPaymentOnRejectionEdit()\"\n                          ng-model=\"vm.shiftConfirmationData[shiftPosition][applicant.applicantId].timeInterval.timeInHours\"\n                          onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" title=\"Whole Numbers Only\"\n                          scroll />\n                      </div>\n                      <span\n                        ng-click=\"vm.setEditing(vm.shiftConfirmationData[shiftPosition][applicant.applicantId], 7); vm.$tracking.reportRosterPageClick('payment - edit hours');\">H</span>\n                      <div class=\"payment-time-edit\"\n                        ng-click=\"vm.setEditing(vm.shiftConfirmationData[shiftPosition][applicant.applicantId], 8); vm.$tracking.reportRosterPageClick('payment - edit hours');\"\n                        ng-if=\"!vm.shiftConfirmationData[shiftPosition][applicant.applicantId].isEditingMinutes\"\n                        style=\"display: inline-block; color: {{(!vm.shiftConfirmationData[shiftPosition][applicant.applicantId].timeInterval.timeInMinutes && !vm.shiftConfirmationData[shiftPosition][applicant.applicantId].timeInterval.timeInHours) ? null : null}}\">\n                        {{vm.shiftConfirmationData[shiftPosition][applicant.applicantId].timeInterval.timeInMinutes}}\n                      </div>\n                      <div ng-if=\"vm.shiftConfirmationData[shiftPosition][applicant.applicantId].isEditingMinutes\"\n                        style=\"display: inline-block\">\n                        <input style=\"height: 100%; width: 50px; color: black\" type=\"number\" min=\"0\" step=\"1\"\n                          class=\"hours-edit-4 noscroll\"\n                          ng-blur=\"vm.blurTimeEdit(true, vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId], 3)\"\n                          ng-click=\"$event.stopPropagation();vm.setFocusOnInput(4);\"\n                          ng-enter=\"vm.blurHoursUpdated(vm.shiftConfirmationData[shiftPosition][applicant.applicantId])\"\n                          ng-change=\"vm.calculateTotalPaymentOnRejectionEdit()\"\n                          ng-model=\"vm.shiftConfirmationData[shiftPosition][applicant.applicantId].timeInterval.timeInMinutes\"\n                          onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" title=\"Whole Numbers Only\"\n                          scroll />\n                      </div>\n                      <span\n                        ng-click=\"vm.setEditing(vm.shiftConfirmationData[shiftPosition][applicant.applicantId], 9); vm.$tracking.reportRosterPageClick('payment - edit hours');\">M</span><i\n                        style=\"color: #33373a; cursor: pointer; font-size: 14px; margin-left: 7px\"\n                        ng-if=\"!vm.shiftConfirmationData[shiftPosition][applicant.applicantId].isEditingMinutes\"\n                        ng-click=\"vm.setEditing(vm.shiftConfirmationData[shiftPosition][applicant.applicantId], 10); vm.$tracking.reportRosterPageClick('payment - edit hours');\"\n                        class=\"fas fa-pen\"></i><i\n                        style=\"color: #62c046; cursor: pointer; font-size: 14px; margin-left: 7px\"\n                        ng-if=\"vm.shiftConfirmationData[shiftPosition][applicant.applicantId].isEditingMinutes\"\n                        ng-click=\"vm.blurHoursUpdated(vm.shiftConfirmationData[shiftPosition][applicant.applicantId]); vm.$tracking.reportRosterPageSubmit('payment - edit hours');\"\n                        class=\"fas fa-check\"></i>\n                    </div>\n                    <div style=\"flex: 0.45\">\n                      ${{vm.event.subEvents[0].deduppedJobbles[0].jobblerRate / 100 | number: 2}}\n                    </div>\n                    <div\n                      style=\"flex: 0.45; color: {{ vm.shiftConfirmationData[shiftPosition][applicant.applicantId].paymentJobbler < 0.5 ? '#F22613' : null}}\">\n                      ${{vm.shiftConfirmationData[shiftPosition][applicant.applicantId].paymentJobbler || 0 | number:\n                      2}}\n                      <i data-toggle=\"tooltip\" ng-attr-title=\"Payment amount must be at least $0.50\"\n                        data-placement=\"bottom\"\n                        ng-if=\"vm.shiftConfirmationData[shiftPosition][applicant.applicantId].paymentJobbler < 0.5\"\n                        style=\"color: #f22613; line-height: 50px; margin-left: 4px\"\n                        class=\"link-tool-tip fas fa-exclamation-triangle\"></i>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div ng-if=\"!vm.invoice\" style=\"margin: 16px 0px\">Payment Method</div>\n\n            <div ng-if=\"!vm.invoice\" ng-repeat=\"info in vm.paymentInfos\"\n              style=\"display: flex; font-size: 14px; margin-bottom: 8px; border-radius: 6px; padding: 12px 10px; border: 1px solid #979797\">\n              <div style=\"flex: 0 0 25px\">\n                <input type=\"checkbox\" ng-click=\"vm.setCardToPayment(info)\" ng-model=\"info.isChecked\" />\n              </div>\n              <div style=\"flex: 0.75\">{{info.nickname ? info.nickname : \"--\"}}</div>\n              <div style=\"flex: 0.75\" ng-if=\"info.bankName == null\">Exp.\n                {{info.cardExpirationMonth}}/{{info.cardExpirationYear}}\n              </div>\n              <div style=\"flex: 1\">xxxx xxxx xxxx {{info.last4}}</div>\n              <div style=\"flex: 0 0 60px; text-align: right\">\n                <i class=\"{{ info.image }}\" style=\"font-size: 24px\"></i>\n              </div>\n            </div>\n\n            <div ng-if=\"!vm.invoice\" ng-repeat=\"info in vm.unverifedPaymentInfos\"\n              style=\"display: flex; opacity: 0.5; font-size: 14px; border-radius: 6px; padding: 12px 10px; border: 1px solid #979797\">\n              <div style=\"flex: 0 0 25px\"></div>\n              <div style=\"flex: 1\">\n                {{info.nickname ? info.nickname : info.cardBrand}}\n                <i data-toggle=\"tooltip\" ng-attr-title=\"This payment method is unverified\" data-placement=\"bottom\"\n                  style=\"color: #f22613\" class=\"fas fa-exclamation-triangle link-tool-tip\"></i>\n              </div>\n              <div style=\"flex: 1\" ng-if=\"info.bankName == null\">\n                {{info.cardExpirationMonth}}/{{info.cardExpirationYear}}\n              </div>\n              <div style=\"flex: 1\">xxxx xxxx xxxx {{info.last4}}</div>\n              <div style=\"flex: 0 0 60px; text-align: right\">\n                <i class=\"{{ info.image }}\" style=\"font-size: 24px\"></i>\n              </div>\n            </div>\n\n            <div ng-if=\"!vm.invoice\" style=\"margin-top: 16px\">\n              <a href=\"/account-profile/719373/payment-information\" target=\"_blank\"\n                style=\"color: black; text-decoration: underline; font-size: 12px\">Add another payment method</a>\n            </div>\n\n            <div\n              style=\"margin-top: 24px; font-size: 12px; border-radius: 6px; padding: 14px 24px; padding-bottom: 24px; border: 1px solid #979797\">\n              <div style=\"display: flex\">\n                <div style=\"font-size: 16px; font-weight: 600; margin-left: -9px; flex: 0 0 26px\">\n                  <i class=\"fas fa-receipt\"></i>\n                </div>\n                <div style=\"font-size: 16px; font-weight: 600; flex: 1\">Payment summary</div>\n              </div>\n\n              <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\" />\n\n              <div style=\"display: flex\">\n                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600\">Jobbler payments\n                </div>\n\n                <div style=\"flex: 1; text-align: right\">${{vm.totalRejectionPaymentAmountJobbler || 0 | number:2}}</div>\n              </div>\n\n              <div style=\"display: flex\">\n                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600; margin-top: 8px\">\n                  + Platform fee\n                  <span style=\"display: none\">({{ (vm.totalRejectionPaymentAmount -\n                    vm.totalRejectionPaymentAmountJobbler) / vm.totalRejectionPaymentAmountJobbler * 100 |\n                    number: 2}}%)</span>\n                </div>\n\n                <div style=\"flex: 1; text-align: right; margin-top: 8px\">\n                  ${{(vm.totalRejectionPaymentAmount - vm.totalRejectionPaymentAmountJobbler) || 0 | number: 2}}\n                </div>\n              </div>\n\n              <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\" />\n\n              <div style=\"display: flex\">\n                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600\">Total billed to your\n                  account\n                </div>\n                <div style=\"flex: 1; text-align: right; font-weight: 600\">\n                  ${{vm.totalRejectionPaymentAmount || 0 | number: 2}}\n                </div>\n              </div>\n            </div>\n\n            <div\n              style=\"text-align: center; cursor: {{vm.allRejectionsHaveHours && !vm.submittingPayment && ((!vm.invoice && vm.selectedCard ) || (vm.invoice)) ? 'pointer' : null }};\n                        line-height: 40px; color: white; font-weight: 600; font-size: 14px; border-radius: 6px;\n                        background: linear-gradient(270deg, #62C046 0%, #5498B4 100%); opacity: {{vm.allRejectionsHaveHours && !vm.submittingPayment && ((!vm.invoice && vm.selectedCard ) || (vm.invoice)) ? 1 : 0.5}}; transition: all 0.5s; height: 40px; width: 100%; margin-top: 24px\"\n              ng-click=\"vm.sendRejectionPayment()\">\n              <span ng-if=\"vm.submittingPayment\">Submitting payment <i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i></span>\n              <span ng-if=\"!vm.submittingPayment\">Submit payment</span>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade jobble-modal\" id=\"modal-rejection-confirm\" tabindex=\"-1\" role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div style=\"\n              position: absolute;\n              left: 0;\n              top: 0;\n              height: 6px;\n              width: 100%;\n              margin-bottom: 16px;\n              border-radius: 6px 6px 0 0;\n              background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n            \"></div>\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fas fa-times\" aria-hidden=\"true\"></i>\n            </button>\n            <h4 class=\"modal-title\">Confirm Rejection</h4>\n          </div>\n          <div class=\"modal-body payment-modal-body\" style=\"font-weight: 500\">\n            <div style=\"margin-bottom: 24px; line-height: 21px\">\n              Review the table below to confirm the jobblers you'd like to reject.\n              <br />\n            </div>\n\n            <div style=\"margin-top: 15px\">\n              <div style=\"margin-top: 10px; padding: 0 16px; padding-left: 8px\">\n                <div style=\"margin-bottom: 0px\">\n                  <div\n                    style=\"display: flex; font-weight: 500; font-size: 15px; margin-bottom: 8px; text-transform: uppercase\">\n                    <div style=\"flex: 1\">Jobbler</div>\n                  </div>\n                </div>\n              </div>\n\n              <div ng-if=\"vm.rejectionApplicants.length\"\n                style=\"border: 1px solid #979797; border-radius: 6px; max-height: 200px; overflow-y: scroll\">\n                <div style=\"margin-bottom: 0px\" ng-repeat=\"applicant in vm.rejectionApplicants track by $index\">\n                  <div\n                    style=\"display: flex; height: 50px; line-height: 50px; font-weight: 500; font-size: 13px; padding: 0 8px; border-bottom: {{$index === vm.rejectionApplicants.length - 1 ? 'none' : '1px solid rgba(151,151,151,0.5)'}}\">\n                    <div style=\"flex: 1\">{{applicant.applicantLastName}}, {{applicant.applicantFirstName}}</div>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div style=\"\n                text-align: center;\n                cursor: pointer;\n                line-height: 40px;\n                color: white;\n                font-weight: 600;\n                font-size: 14px;\n                border-radius: 6px;\n                background: linear-gradient(270deg, #62c046 0%, #5498b4 100%);\n                transition: all 0.5s;\n                height: 40px;\n                width: 100%;\n                margin-top: 24px;\n              \" ng-click=\"vm.submitModalRejection()\">\n              <span>Reject Jobblers</span>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade jobble-modal\" id=\"modal-additional-payment\" tabindex=\"-1\" role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div style=\"\n              position: absolute;\n              left: 0;\n              top: 0;\n              height: 6px;\n              width: 100%;\n              margin-bottom: 16px;\n              border-radius: 6px 6px 0 0;\n              background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n            \"></div>\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fas fa-times\" aria-hidden=\"true\"></i>\n            </button>\n            <h4 class=\"modal-title\">Make an additional payment</h4>\n          </div>\n          <div class=\"modal-body payment-modal-body\" style=\"font-weight: 500\">\n            <div style=\"margin-bottom: 24px; line-height: 21px\">\n              Enter the amount you’d like to pay the selected Jobbler<span ng-if=\"!vm.invoice\"> and select your\n                preferred payment method</span>.\n            </div>\n\n            <div style=\"margin-bottom: 8px; line-height: 21px\">Payment amount (per recipient):</div>\n\n            <div\n              style=\"display: flex; border: 1px solid #33373a; border-radius: 6px; height: 40px; line-height: 40px; margin-bottom: 16px\">\n              <div style=\"flex: 0 0 40px; padding-left: 16px; font-size: 14px\">\n                <i class=\"fas fa-dollar-sign\"></i>\n              </div>\n              <div style=\"flex: 1\">\n                <input type=\"number\" ng-change=\"vm.calculateAdditionalPaymentAmount()\"\n                  ng-model=\"vm.additionalPaymentAmountJobbler\" style=\"height: 90%; width: 95%; border: none\" />\n              </div>\n            </div>\n\n            <div style=\"margin-bottom: 8px; line-height: 21px\">Recipient name(s):</div>\n\n            <!--                        <div style=\"padding: 0 16px; padding-left: 8px\">-->\n            <!--                            <div style=\"margin-bottom: 0px\">-->\n            <!--                                <div style=\"display: flex; font-weight: 500; font-size: 15px; margin-bottom: 8px; text-transform: uppercase\">-->\n            <!--                                    <div style=\"flex: 0 0 20px\"></div>-->\n            <!--                                    <div style=\"flex: 2\">Applicant</div>-->\n            <!--                                    <div style=\"flex: 1\">Hours</div>-->\n            <!--                                </div>-->\n            <!--                            </div>-->\n            <!--                        </div>-->\n            <div ng-if=\"vm.readyToAdditionalPay.length\"\n              style=\"border: 1px solid #979797; border-radius: 6px; max-height: 200px; overflow-y: scroll\">\n              <div style=\"margin-bottom: 0px\" ng-repeat=\"applicant in vm.readyToAdditionalPay track by $index\">\n                <div\n                  style=\"display: flex; height: 50px; line-height: 50px; font-weight: 500; font-size: 13px; padding: 0 8px; border-bottom: {{$index === vm.readyToAdditionalPay.length - 1 ? 'none' : '1px solid rgba(151,151,151,0.5)'}}\">\n                  <div style=\"flex: 0 0 20px\">\n                    <input type=\"checkbox\" ng-model=\"applicant.isReadyToAdditionalPayChecked\"\n                      ng-change=\"vm.verifyAtLeastOneReadyToAdditionalPayChecked(); vm.calculateAdditionalPaymentAmount()\" />\n                  </div>\n                  <!--                                    <div>return; vm.displayDetails(applicant, 'default', 'open',applicant.originalIndex , true)</div>-->\n                  <div style=\"flex: 2\">\n                    {{applicant.applicantLastName}}, {{applicant.applicantFirstName}}\n                    <i data-toggle=\"tooltip\"\n                      ng-attr-title=\"{{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].status}}\"\n                      data-placement=\"bottom\" style=\"color: #f22613\"\n                      ng-if=\"false && vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].statusNumber !== 1\"\n                      class=\"fas fa-exclamation-triangle link-tool-tip\"></i>\n                  </div>\n                  <!--                                    <div style=\"flex: 1\">-->\n                  <!--                                        <div style=\"display: inline-block;\">{{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInHours}}</div>-->\n                  <!--                                        H-->\n                  <!--                                        <div style=\"display: inline-block;\">{{vm.shiftConfirmationData[vm.singleShiftViewShiftPosition][applicant.applicantId].timeInterval.timeInMinutes}}</div>-->\n                  <!--                                        M-->\n                  <!--                                    </div>-->\n                </div>\n              </div>\n            </div>\n\n            <div ng-if=\"!vm.invoice\" style=\"margin: 16px 0px\">\n              Jobbler(s) selected:\n              <span ng-if=\"!vm.atLeastOneReadyToAdditionalPayChecked\">N/A</span>\n              <div style=\"display: inline-block\"\n                ng-repeat=\"applicant in vm.readyToAdditionalPaySelected track by $index\"\n                ng-if=\"applicant.isReadyToAdditionalPayChecked\">\n                <span ng-if=\"$index !== 0\">, </span>{{applicant.applicantFirstName}} {{applicant.applicantLastName}}\n              </div>\n            </div>\n\n            <div style=\"margin-bottom: 8px; margin-top: 8px; line-height: 21px\">Payment memo:</div>\n\n            <div\n              style=\"display: flex; border: 1px solid #33373a; border-radius: 6px; height: 40px; line-height: 40px; margin-bottom: 16px\">\n              <div style=\"flex: 0 0 40px; padding-left: 16px; font-size: 14px\">\n                <i class=\"fas fa-info-circle\"></i>\n              </div>\n              <div style=\"flex: 1\">\n                <input ng-model=\"vm.additionalPaymentMemo\" placeholder=\"Enter Payment Memo\"\n                  style=\"height: 90%; width: 95%; border: none\" />\n              </div>\n            </div>\n\n            <div ng-if=\"!vm.invoice\" style=\"margin: 16px 0px\">Payment Method</div>\n\n            <div ng-if=\"!vm.invoice\" ng-repeat=\"info in vm.paymentInfos\"\n              style=\"display: flex; font-size: 14px; margin-bottom: 8px; border-radius: 6px; padding: 12px 10px; border: 1px solid #979797\">\n              <div style=\"flex: 0 0 25px\">\n                <input type=\"checkbox\" ng-click=\"vm.setCardToPayment(info)\" ng-model=\"info.isChecked\" />\n              </div>\n              <div style=\"flex: 0.75\">{{info.nickname ? info.nickname : \"--\"}}</div>\n              <div style=\"flex: 0.75\" ng-if=\"info.bankName == null\">Exp.\n                {{info.cardExpirationMonth}}/{{info.cardExpirationYear}}\n              </div>\n              <div style=\"flex: 1\">xxxx xxxx xxxx {{info.last4}}</div>\n              <div style=\"flex: 0 0 60px; text-align: right\">\n                <i class=\"{{ info.image }}\" style=\"font-size: 24px\"></i>\n              </div>\n            </div>\n\n            <div ng-if=\"!vm.invoice\" ng-repeat=\"info in vm.unverifedPaymentInfos\"\n              style=\"display: flex; opacity: 0.5; font-size: 14px; border-radius: 6px; padding: 12px 10px; border: 1px solid #979797\">\n              <div style=\"flex: 0 0 25px\"></div>\n              <div style=\"flex: 1\">\n                {{info.nickname ? info.nickname : info.cardBrand}}\n                <i data-toggle=\"tooltip\" ng-attr-title=\"This payment method is unverified\" data-placement=\"bottom\"\n                  style=\"color: #f22613\" class=\"fas fa-exclamation-triangle link-tool-tip\"></i>\n              </div>\n              <div style=\"flex: 1\" ng-if=\"info.bankName == null\">\n                {{info.cardExpirationMonth}}/{{info.cardExpirationYear}}\n              </div>\n              <div style=\"flex: 1\">xxxx xxxx xxxx {{info.last4}}</div>\n              <div style=\"flex: 0 0 60px; text-align: right\">\n                <i class=\"{{ info.image }}\" style=\"font-size: 24px\"></i>\n              </div>\n            </div>\n\n            <div ng-if=\"!vm.invoice\" style=\"margin-top: 16px\">\n              <a href=\"/account-profile/719373/payment-information\" target=\"_blank\"\n                style=\"color: black; text-decoration: underline; font-size: 12px\">Add another payment method</a>\n            </div>\n\n            <div\n              style=\"margin-top: 24px; font-size: 12px; border-radius: 6px; padding: 14px 24px; padding-bottom: 24px; border: 1px solid #979797\">\n              <div style=\"display: flex\">\n                <div style=\"font-size: 16px; font-weight: 600; margin-left: -9px; flex: 0 0 26px\">\n                  <i class=\"fas fa-receipt\"></i>\n                </div>\n                <div style=\"font-size: 16px; font-weight: 600; flex: 1\">Payment summary</div>\n              </div>\n\n              <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\" />\n\n              <div style=\"display: flex\">\n                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600\">Jobbler payments\n                </div>\n\n                <div style=\"flex: 1; text-align: right\">${{vm.totalAdditionalPaymentAmountJobbler || 0 | number: 2}}\n                </div>\n              </div>\n\n              <div style=\"display: flex\">\n                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600; margin-top: 8px\">\n                  + Platform fee\n                  <span style=\"display: none\">({{ (vm.totalPaymentAmount - vm.totalPaymentAmountJobbler) /\n                    vm.totalPaymentAmountJobbler * 100 | number: 2\n                    }}%)</span>\n                </div>\n\n                <div style=\"flex: 1; text-align: right; margin-top: 8px\">\n                  ${{ (vm.totalAdditionalPaymentAmount - vm.totalAdditionalPaymentAmountJobbler) || 0 | number: 2}}\n                </div>\n              </div>\n\n              <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\" />\n\n              <div style=\"display: flex\">\n                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600\">Total billed to your\n                  account\n                </div>\n                <div style=\"flex: 1; text-align: right; font-weight: 600\">\n                  ${{vm.totalAdditionalPaymentAmount || 0 | number: 2}}\n                </div>\n              </div>\n            </div>\n\n            <div\n              style=\"text-align: center; cursor: {{!vm.submittingAdditionalPayment && (vm.additionalPaymentAmountJobbler > 0.5) && vm.atLeastOneReadyToAdditionalPayChecked && ((!vm.invoice && vm.selectedCard ) || (vm.invoice)) ? 'pointer' : null}};\n                        line-height: 40px; color: white; font-weight: 600; font-size: 14px; border-radius: 6px;\n                        background: linear-gradient(270deg, #62C046 0%, #5498B4 100%); opacity: {{!vm.submittingAdditionalPayment && (vm.additionalPaymentAmountJobbler > 0.5) && vm.atLeastOneReadyToAdditionalPayChecked && ((!vm.invoice && vm.selectedCard ) || (vm.invoice)) ? 1 : 0.5}}; transition: all 0.5s; height: 40px; width: 100%; margin-top: 24px\"\n              ng-click=\"vm.sendAdditionalPayment()\">\n              Submit payment\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade jobble-modal\" id=\"modal-shift-payment-done\" tabindex=\"-1\" role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div style=\"\n              position: absolute;\n              left: 0;\n              top: 0;\n              height: 6px;\n              width: 100%;\n              margin-bottom: 16px;\n              border-radius: 6px 6px 0 0;\n              background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n            \"></div>\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fas fa-times\" aria-hidden=\"true\"></i>\n            </button>\n            <h4 class=\"modal-title\" ng-if=\"!vm.paymentError\">Your payment has been submitted</h4>\n            <h4 class=\"modal-title\" ng-if=\"vm.paymentError\" style=\"color: red\">There was an error submitting your\n              payment</h4>\n          </div>\n          <div class=\"modal-body\" style=\"font-weight: 500\">\n            <div ng-if=\"!vm.paymentError\" style=\"margin-bottom: 24px; line-height: 21px\">\n              <span style=\"font-weight: bold\">{{vm.transferArray.length}} Jobbler{{vm.transferArray.length > 1 ? \"s\n                were\" : \" was\"}} paid successfully. Please allow our system a\n                few minutes to finish processing these payments.</span>\n            </div>\n\n            <div ng-if=\"vm.paymentError\" style=\"margin-bottom: 24px; line-height: 21px; color: red\">\n              There was an error submitting your payment. Please try again.<br /><br />Error: {{vm.paymentErrorText}}\n            </div>\n\n            <div style=\"display: flex\">\n              <div style=\"flex: 1; padding-right: 8px\" ng-if=\"!vm.paymentError\">\n                <div ng-click=\"vm.closeDoneModal(true)\">\n                  <div ng-click=\"vm.closeDoneModal()\" style=\"\n                      text-align: center;\n                      cursor: pointer;\n                      line-height: 40px;\n                      color: black;\n                      border: 1px solid black;\n                      font-weight: 600;\n                      font-size: 14px;\n                      border-radius: 6px;\n                      background: white;\n                      transition: all 0.5s;\n                      height: 40px;\n                      width: 100%;\n                      margin-top: 24px;\n                    \">\n                    View receipts\n                  </div>\n                </div>\n              </div>\n              <div style=\"flex: 1\">\n                <div style=\"\n                    text-align: center;\n                    cursor: pointer;\n                    line-height: 40px;\n                    color: white;\n                    font-weight: 600;\n                    font-size: 14px;\n                    border-radius: 6px;\n                    background: linear-gradient(270deg, #62c046 0%, #5498b4 100%);\n                    transition: all 0.5s;\n                    height: 40px;\n                    width: 100%;\n                    margin-top: 24px;\n                  \" ng-click=\"vm.closeDoneModal()\">\n                  Go back to roster\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade jobble-modal\" id=\"modal-congrats-hire\" tabindex=\"-1\" role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\" style=\"width: 600px; margin: auto\">\n          <div style=\"\n              position: absolute;\n              left: 0;\n              top: 0;\n              height: 6px;\n              width: 100%;\n              margin-bottom: 16px;\n              border-radius: 6px 6px 0 0;\n              background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n            \"></div>\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\"\n              ng-click=\"vm.reloadRosterPage();\">\n              <i class=\"fas fa-times\" aria-hidden=\"true\"></i>\n            </button>\n            <h4 class=\"modal-title\">{{vm.hireMessage}}</h4>\n          </div>\n          <div class=\"modal-body\" style=\"font-weight: 500\">\n            <div style=\"margin-bottom: 16px; line-height: 21px\">\n              <p>Please give our system a moment to hire this user.</p>\n              <br />\n              <p>All hired Jobblers will now receive communications instructing them on their next steps. This includes\n                but is not limited to:</p>\n              <ul class=\"hiring-confirm\">\n                <li>Confirming their attendance to each shift.</li>\n                <li>Checking in for each shift on their mobile app upon arrival.</li>\n                <li>Checking out for each shift on their mobile app upon departure.</li>\n                <li>Providing proper payment method on their mobile app to ensure timely payment.</li>\n              </ul>\n            </div>\n\n            <div style=\"display: flex\">\n              <div style=\"flex: 1; padding-right: 8px\">\n                <div>\n                  <div ng-click=\"vm.closeCongratsMessage()\" style=\"\n                      text-align: center;\n                      cursor: pointer;\n                      line-height: 40px;\n                      color: black;\n                      border: 1px solid black;\n                      font-weight: 600;\n                      font-size: 14px;\n                      border-radius: 6px;\n                      background: white;\n                      transition: all 0.5s;\n                      height: 40px;\n                      width: 100%;\n                      margin-top: 0px;\n                    \">\n                    Go Back To Jobs Dashboard\n                  </div>\n                </div>\n              </div>\n              <!--\n                            <div style=\"flex: 1\">\n                                <div\n                                        style=\"\n                                        text-align: center;\n                                        cursor: pointer;\n                                        line-height: 40px;\n                                        color: white;\n                                        font-weight: 600;\n                                        font-size: 14px;\n                                        border-radius: 6px;\n                                        background: linear-gradient(270deg, #62c046 0%, #5498b4 100%);\n                                        transition: all 0.5s;\n                                        height: 40px;\n                                        width: 100%;\n                                        margin-top: 0px;\"\n                                        ng-click=\"vm.sendToHires()\">\n                                    Go to Hires\n                                </div>\n                            </div>\n                            -->\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade jobble-modal\" id=\"modal-remove-from-payment\" tabindex=\"-1\" role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\" style=\"width: 440px; margin: auto\">\n          <div style=\"\n              position: absolute;\n              left: 0;\n              top: 0;\n              height: 6px;\n              width: 100%;\n              margin-bottom: 16px;\n              border-radius: 6px 6px 0 0;\n              background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n            \"></div>\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fas fa-times\" aria-hidden=\"true\"></i>\n            </button>\n            <h4 class=\"modal-title\">Remove from payment</h4>\n          </div>\n          <div class=\"modal-body\" style=\"font-weight: 500\">\n            <div style=\"margin-bottom: 16px; line-height: 21px\">\n              Are you sure you want to remove\n              <span style=\"font-weight: bold\">{{vm.applicantToRemoveFromPayment.applicantFirstName}}\n                {{vm.applicantToRemoveFromPayment.applicantLastName}}</span>\n              from this payment? Note - you may still pay this Jobbler later.\n            </div>\n\n            <div style=\"display: flex\">\n              <div style=\"flex: 1; padding-right: 8px\">\n                <div ng-click=\"vm.closeRemoveFromPayment()\">\n                  <div ng-click=\"vm.closeRemoveFromPayment()\" style=\"\n                      text-align: center;\n                      cursor: pointer;\n                      line-height: 40px;\n                      color: black;\n                      border: 1px solid black;\n                      font-weight: 600;\n                      font-size: 14px;\n                      border-radius: 6px;\n                      background: white;\n                      transition: all 0.5s;\n                      height: 40px;\n                      width: 100%;\n                      margin-top: 0px;\n                    \">\n                    Cancel\n                  </div>\n                </div>\n              </div>\n              <div style=\"flex: 1\">\n                <div style=\"\n                    text-align: center;\n                    cursor: pointer;\n                    line-height: 40px;\n                    color: white;\n                    font-weight: 600;\n                    font-size: 14px;\n                    border-radius: 6px;\n                    background: linear-gradient(270deg, #62c046 0%, #5498b4 100%);\n                    transition: all 0.5s;\n                    height: 40px;\n                    width: 100%;\n                    margin-top: 0px;\n                  \" ng-click=\"vm.removeFromPaymentConfirmed()\">\n                  Remove\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade jobble-modal\" id=\"modal-additional-payment-done\" tabindex=\"-1\" role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div style=\"\n              position: absolute;\n              left: 0;\n              top: 0;\n              height: 6px;\n              width: 100%;\n              margin-bottom: 16px;\n              border-radius: 6px 6px 0 0;\n              background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n            \"></div>\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fas fa-times\" aria-hidden=\"true\"></i>\n            </button>\n            <h4 class=\"modal-title\">Your payment has been submitted</h4>\n          </div>\n          <div class=\"modal-body\" style=\"font-weight: 500\">\n            <div style=\"margin-bottom: 24px; line-height: 21px\">\n              <span style=\"font-weight: bold\">{{vm.readyToAdditionalPaySelected.length}}\n                Jobbler{{vm.readyToAdditionalPaySelected.length > 1 ? \"s were\" : \" was\"}} paid\n                successfully. To view your payments, visit the receipts tab.</span>\n            </div>\n\n            <div style=\"display: flex\">\n              <div style=\"flex: 1; padding-right: 8px\">\n                <div ng-click=\"vm.closeDoneAdditionalModal(true)\">\n                  <div style=\"\n                      text-align: center;\n                      cursor: pointer;\n                      line-height: 40px;\n                      color: black;\n                      border: 1px solid black;\n                      font-weight: 600;\n                      font-size: 14px;\n                      border-radius: 6px;\n                      background: white;\n                      transition: all 0.5s;\n                      height: 40px;\n                      width: 100%;\n                      margin-top: 24px;\n                    \">\n                    View receipts\n                  </div>\n                </div>\n              </div>\n              <div style=\"flex: 1\">\n                <div style=\"\n                    text-align: center;\n                    cursor: pointer;\n                    line-height: 40px;\n                    color: white;\n                    font-weight: 600;\n                    font-size: 14px;\n                    border-radius: 6px;\n                    background: linear-gradient(270deg, #62c046 0%, #5498b4 100%);\n                    transition: all 0.5s;\n                    height: 40px;\n                    width: 100%;\n                    margin-top: 24px;\n                  \" ng-click=\"vm.closeDoneAdditionalModal()\">\n                  Go back to roster\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _common = __webpack_require__(112);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _scroll = __webpack_require__(462);
	
	var _scroll2 = _interopRequireDefault(_scroll);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _messagingv = __webpack_require__(30);
	
	var _messagingv2 = _interopRequireDefault(_messagingv);
	
	var _async = __webpack_require__(318);
	
	var _async2 = _interopRequireDefault(_async);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var METER_RADIUS = 1000;
	var METER_THRESHOLD = 500;
	var RED_ICON = "url(/app/vendor/images/check-out-icon-2.png)";
	var GREEN_ICON = "url(/app/vendor/images/check-in-icon-2.png)";
	var CIRCLE_COLOR = "#62C046";
	var CIRCLE_OPACITY = 0.35;
	var QUIT_REASONS = [{ name: "DECLINED_ALL_SHIFTS", description: "Declined all shifts." }, { name: "OTHER_WORK_HIGHER_PAY", description: "Found other work with higher pay elsewhere." }, { name: "OTHER_WORK_CLOSER_TO_HOME", description: "Found other work closer to home." }, { name: "OTHER_WORK_PREFERRED_WORKING_HOURS", description: "Found other work with more preferred working hours." }, { name: "OTHER_WORK_MORE_INTERESTING_TASKS", description: "Found other work with more interesting tasks." }, { name: "OTHER_WORK_OTHER_REASON_NOT_LISTED_HERE", description: "Found other work." }, { name: "SOMETHING_CAME_UP_CHANGE_IN_SCHEDULE", description: "Something came up - change in schedule." }, { name: "SOMETHING_CAME_UP_EMERGENCY", description: "Something came up - emergency." }, { name: "SOMETHING_CAME_UP_TRANSPORTATION_ISSUES", description: "Transportation issues." }, { name: "SOMETHING_CAME_UP_NO_LONGER_MEET_REQUIREMENTS", description: "No longer meets job requirements." }, { name: "SOMETHING_CAME_UP_OTHER_REASON_NOT_LISTED_HERE", description: "Something came up." }, { name: "BAD_FIT_TOO_CHALLENGING", description: "Work was a bad fit - too challenging." }, { name: "BAD_FIT_TOO_FAR", description: "Work was a bad fit - job site too far." }, { name: "BAD_FIT_PAY_RATE_TOO_LOW", description: "Work was a bad fit - pay rate was too low." }, { name: "BAD_FIT_UNSUPPORTIVE_WORK_ENVIRONMENT", description: "Unsupportive work enviornment." }, { name: "BAD_FIT_OTHER_REASON_NOT_LISTED_HERE", description: "Bad fit." }];
	
	var EventreviewapplicantsController = function () {
	  function EventreviewapplicantsController($http, $localStorage, $state, AuthService, EventsService, $stateParams, SecurityService, CommonService, ScrollService, $rootScope, $scope, $window, EnvService, $timeout, Messagingv2Service, TrackingService, $anchorScroll, $location) {
	    var _this2 = this;
	
	    _classCallCheck(this, EventreviewapplicantsController);
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	    $localStorage.activeStateName = "events";
	    this.name = "eventreviewapplicants";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$events = EventsService;
	    this.$stateParams = $stateParams;
	    this.$security = SecurityService;
	    this.$common = CommonService;
	    this.$scroll = ScrollService;
	    this.$window = $window;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$messagingv2 = Messagingv2Service;
	    this.$anchor = $anchorScroll;
	    this.$env = EnvService;
	    this.$location = $location;
	    this.$timeout = $timeout;
	    this.showAppWarning = false;
	    this.currentUser = this.$auth.getUserData();
	    this.applicationForReject = null;
	    this.currentPageNumber = 1;
	    this.busy = true;
	    this.busyAccepted = true;
	    this.updatingHoursWorkedBackend = false;
	    this.$tracking = TrackingService;
	    this.useBottom = false;
	    this.remain_loading_count = 0;
	    this.event = {};
	    this.isThereRoomForHire = null;
	    this.acceptedApplicantsDoneLoading = false;
	    this.pendingApplicantsDoneLoading = false;
	    this.allApplicantsDoneLoading = false;
	    this.getUserTimeZone();
	    this.rejectedApplicantsDoneLoading = false;
	    this.pendingApplicants = [];
	    this.acceptedApplicants = [];
	    this.approvedApplicants = [];
	    this.readyToPay = [];
	    this.selectedApplicant = {};
	    this.hireJobblerResult = {};
	    this.removeJobblerResult = {};
	    this.selectedHireApplicant = 0;
	    this.paymentInfos = this.currentUser.company.paymentInfos;
	    this.fakeApplicants = [1, 2, 3, 4, 5];
	    this.singleShiftView = false;
	    this.singleShiftViewId = null;
	    this.singleShiftViewShift = null;
	    this.singleShiftViewFormatted = null;
	    this.sortOrder = "asc";
	    this.sortField = "lastName";
	    this.jobQuery = "";
	    this.lastJobQuery = "";
	    this.csvName = "Roster " + moment().format("MMMM Do YYYY") + ".csv";
	
	    this.additionalPaymentAmount = 0;
	    this.additionalPaymentAmountJobbler = 0;
	
	    this.showMap = false;
	
	    this.ui = {
	      allChecked: false
	    };
	
	    this.confirmationFilters = {
	      all: true,
	      confirmed: false,
	      declined: false,
	      no_response: false
	    };
	
	    this.confirmationFilterText = "ALL";
	
	    this.loadingShiftConfirmationDataByShift = {};
	
	    this.confirmationNumbers = {};
	    this.convertedShiftsMap = {};
	
	    this.paymentContingenciesMap = {};
	    this.paymentContingenciesShiftPositions = [];
	
	    this.statusNumbers = {
	      1: 0,
	      2: 0,
	      3: 0,
	      4: 0,
	      5: 0,
	      6: 0,
	      7: 0
	    };
	
	    this.editCheckInTimes = {};
	    this.editCheckOutTimes = {};
	
	    this.tabFilter = 1;
	
	    var _this = this;
	
	    $scope.statusFilter = function (item) {
	      return item.applicationStatusRoster.id === _this.tabFilter;
	    };
	
	    $scope.confirmationStatusFilter = function (applicant) {
	      var confirmationResponseExists = false;
	      var confirmationResponse = false;
	      var groupNumber = 2;
	
	      if (_this.shiftConfirmationData && _this.shiftConfirmationData[_this.singleShiftViewShiftPosition] && _this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId]) {
	        //console.log("lets look at the confirmation data");
	        //console.dir(_this.shiftConfirmationData[_this.singleShiftViewShiftPosition]);
	        //console.dir(_this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId]);
	        //console.dir(_this.shiftConfirmationData);
	
	        confirmationResponseExists = _this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId].confirmationResponseExists;
	        confirmationResponse = _this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId].confirmationResponse;
	        groupNumber = _this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId].groupNumber;
	        applicant.groupNumber = groupNumber;
	        applicant.confirmationResponse = confirmationResponse;
	        applicant.confirmationResponseExists = confirmationResponseExists;
	      }
	
	      if (groupNumber !== 1) return false;
	
	      if (_this.confirmationFilters.all) return true;
	
	      if (_this.confirmationFilters.confirmed && confirmationResponseExists && confirmationResponse) return true;
	
	      if (_this.confirmationFilters.declined && confirmationResponseExists && !confirmationResponse) return true;
	
	      if (_this.confirmationFilters.no_response && !confirmationResponseExists) return true;
	
	      return false;
	    };
	
	    $scope.confirmationStatusFilterUnPrioritized = function (applicant) {
	      var confirmationResponseExists = false;
	      var confirmationResponse = false;
	      var groupNumber = 2;
	
	      if (_this.shiftConfirmationData && _this.shiftConfirmationData[_this.singleShiftViewShiftPosition] && _this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId]) {
	        confirmationResponseExists = _this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId].confirmationResponseExists;
	        confirmationResponse = _this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId].confirmationResponse;
	        groupNumber = _this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId].groupNumber;
	      }
	
	      //console.log("groupNumber", groupNumber);
	      if (groupNumber === 1) {
	        return false;
	      }
	
	      if (_this.confirmationFilters.all) return true;
	
	      if (_this.confirmationFilters.confirmed && confirmationResponseExists && confirmationResponse) return true;
	
	      if (_this.confirmationFilters.declined && confirmationResponseExists && !confirmationResponse) return true;
	
	      if (_this.confirmationFilters.no_response && !confirmationResponseExists) return true;
	
	      return false;
	    };
	
	    if (_this.currentUser.username.indexOf("jobble.com") !== -1 || _this.currentUser.username.indexOf("jobbleapp.com") !== -1) {
	      this.currentUser.isAdmin = true;
	    }
	
	    this.initialLoadingApplicants = true;
	
	    this.setLoader();
	    this.$events.getEventByIdTrimmedv2(this.$stateParams.eventId).then(function (data) {
	      //_this.unSetLoader();
	      _this.event = data.data;
	      _this.csvName = "Roster - " + _this.event.name + " - " + moment().format("MMMM Do YYYY") + ".csv";
	
	      console.log("event", _this.event.name);
	
	      var pageArray = [];
	      var pageArrayAccepted = [];
	      _this.setTableHeaders();
	      _this.isSourcingPost = _this.event.isSourcingPost;
	      _this.$timeout(function () {
	        $("eventsidebar .jobs-complete-sidebar li:nth-child(2)").removeClass().addClass("active");
	      }, 500);
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetEventToEventSidebar", {
	          event: _this.event
	        });
	      });
	      var numberOfPendingApplications = Math.ceil(_this.event.numberOfPendingApplications / 12);
	      for (var i = 0; i < numberOfPendingApplications; i++) {
	        pageArray.push(i + 1);
	        _this.pages = pageArray;
	      }
	      var numberOfApprovedApplications = Math.ceil(_this.event.numberOfApprovedApplications / 10);
	      for (var i = 0; i < numberOfApprovedApplications; i++) {
	        pageArrayAccepted.push(i + 1);
	        _this.acceptedPages = pageArrayAccepted;
	      }
	      if (_this.event.status === "error") {
	        return;
	      }
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetEventToEventDialog", {
	          event: _this.event
	        });
	      });
	
	      var jobblePoolId = _this.event.subEvents[0].deduppedJobbles[0].jobblePoolId;
	      var subEventId = _this.event.subEvents[0].id;
	      var eventResp = data.data;
	      _this2.loadAllApplicants(jobblePoolId, true, eventResp, subEventId);
	      _this2.checkEventOpenings(data.data.id);
	      //this.loadShiftConfirmationData(subEventId);
	      return console.error("testing this stop");
	    }, function (data) {
	      console.log("we have an error loading the event");
	      console.dir(data);
	      alert("Critical error loading job roster - please contact support.");
	      //$state.go("events");
	    });
	
	    _this.SetEventToEventPagesListener = _this.$rootScope.$on("SetEventToEventPages", function ($event, params) {
	      if (_this.event.id === params.event.id) {
	        _this.event.cost = params.event.cost;
	        var remaining_openings = 0;
	        if (params.action === "Remove") {
	          remaining_openings = params.event.numberOfOpenings - params.openings;
	          if (remaining_openings < 0) {
	            _this.event.numberOfOpenings = 0;
	          } else {
	            _this.event.numberOfOpenings = remaining_openings;
	          }
	        } else {
	          _this.event.numberOfOpenings = params.event.numberOfOpenings + params.openings;
	        }
	        _this.event.totalNumberOfJobbles = params.event.totalNumberOfJobbles;
	      }
	    });
	
	    _this.RejectFromProfileScreenListener = _this.$rootScope.$on("RejectFromProfileScreen", function ($event, params) {
	      _this.confirmRemoveJobbler(params.status, params.jobbler);
	    });
	
	    _this.SuccessToDeleteEventListener = _this.$rootScope.$on("SuccessToDeleteEvent", function () {
	      _this.$state.go("jobsdashboard");
	    });
	
	    _this.PaginateApplicationsListener = _this.$rootScope.$on("PaginateApplications", function ($event, params) {
	      _this.handleProfilePagination(params);
	    });
	
	    _this.UpdatedCreditCardListener = _this.$rootScope.$on("UpdatedCreditCard", function ($event, params) {
	      _this.currentUser.company.paymentInfos = params.user.company.paymentInfos;
	      _this.paymentInfos = params.user.company.paymentInfos;
	    });
	
	    _this.HireJobblerFromProfileListener = _this.$rootScope.$on("HireJobblerFromProfile", function ($event, params) {
	      var arg = {};
	      arg.action = "close";
	      params.application.isHireSelected = true;
	      _this.approvedApplicants = [];
	      _this.approvedApplicants.push(params.application);
	      _this.hireJobblers(arg);
	    });
	
	    _this.SetApplicationToPendingListener = _this.$rootScope.$on("SetApplicationToPending", function ($event, app) {
	      _this.mapRejectedApplicantToPendingApplicants(app);
	    });
	
	    _this.$scope.$on("$destroy", _this.HireJobblerFromProfileListener);
	    _this.$scope.$on("$destroy", _this.RejectFromProfileScreenListener);
	    _this.$scope.$on("$destroy", _this.SetApplicationToPendingListener);
	    _this.$scope.$on("$destroy", _this.HireJobblerFromPorfileListener);
	    _this.$scope.$on("$destroy", _this.SetEventToEventPagesListener);
	    _this.$scope.$on("$destroy", _this.SuccessToDeleteEventListener);
	    //_this.$scope.$on('$destroy', _this.channelsHaveBeenLoadedListener);
	    _this.$scope.$on("$destroy", _this.PaginateApplicationsListener);
	    _this.$scope.$on("$destroy", _this.UpdatedCreditCardListener);
	
	    this.organizePaymentOptions(this.currentUser);
	  }
	
	  _createClass(EventreviewapplicantsController, [{
	    key: "onClickUpdateHours",
	    value: function onClickUpdateHours(applicantId) {
	      var shiftData = this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicantId];
	      if (shiftData.isEditingMinutes) {
	        this.blurHoursUpdated(shiftData);
	        this.$tracking.reportRosterPageSubmit("payment - edit hours");
	      }
	    }
	  }, {
	    key: "toggleShowUnconfirmed",
	    value: function toggleShowUnconfirmed() {
	      this.showUnconfirmedApplicants = !this.showUnconfirmedApplicants;
	    }
	  }, {
	    key: "processShifts",
	    value: function processShifts(event) {
	      var _this3 = this;
	
	      if (!event || !event.subEvents || !event.subEvents.length || !event.subEvents[0].deduppedJobbles || !event.subEvents[0].deduppedJobbles.length) return console.error("Error processing shifts from event");
	
	      var jobble = event.subEvents[0].deduppedJobbles[0];
	
	      if (!jobble || !jobble.shifts || !jobble.shifts.length) return console.error("Error processing shifts from jobble or shifts array is empty");
	
	      var shifts = jobble.shifts;
	      var convertedShifts = this.convertShifts(shifts);
	
	      this.convertedShiftsMap = {};
	      if (convertedShifts && convertedShifts.length) {
	        convertedShifts.forEach(function (convertedShift) {
	          _this3.convertedShiftsMap[convertedShift.shiftPosition] = convertedShift;
	        });
	      }
	
	      convertedShifts = convertedShifts.sort(function (a, b) {
	        return new Date(a.startDate + " " + a.startTime).getTime() - new Date(b.startDate + " " + b.startTime).getTime();
	      });
	
	      console.log("convertedShifts:", convertedShifts);
	
	      this.shiftOptions = convertedShifts;
	
	      if (!this.singleShiftViewShift) {
	        this.setSingleShiftView(convertedShifts[0], 0);
	      }
	
	      convertedShifts.forEach(function (shift) {
	        _this3.$timeout(function () {
	          _this3.loadSingleShiftConfirmationData(shift.id, shift.shiftPosition, shift);
	        });
	      });
	
	      /*
	      this.$timeout(() => {
	        console.log("is this the last thing i see");
	        this.unSetLoader();
	      }, 6000);
	      */
	    }
	  }, {
	    key: "toggleMap",
	    value: function toggleMap() {
	      var _this4 = this;
	
	      this.showMap = !this.showMap;
	
	      this.$timeout(function () {
	        _this4.initializeMap();
	      });
	    }
	  }, {
	    key: "calculateConfirmationNumber",
	    value: function calculateConfirmationNumber() {
	      var confirmationCounter = 0;
	    }
	  }, {
	    key: "setConfirmationNumbers",
	    value: function setConfirmationNumbers() {
	      var _this5 = this;
	
	      if (!this.shiftOptions || !this.shiftConfirmationData || !this.hiredApplicants) return;
	
	      this.confirmationNumbers = {};
	      try {
	        this.shiftOptions.map(function (shift) {
	          _this5.confirmationNumbers[shift.shiftPosition] = 0;
	          _this5.hiredApplicants.map(function (applicant) {
	            if (applicant.bgCheckStatus === "Pending") {
	              return;
	            }
	            if (!_this5.shiftConfirmationData[shift.shiftPosition] || !_this5.shiftConfirmationData[shift.shiftPosition][applicant.applicantId]) return;
	
	            if (!_this5.shiftConfirmationData[shift.shiftPosition][applicant.applicantId].confirmationResponseExists) return;
	
	            if (_this5.shiftConfirmationData[shift.shiftPosition][applicant.applicantId].confirmationResponse) {
	              _this5.confirmationNumbers[shift.shiftPosition] += 1;
	            }
	          });
	        });
	      } finally {
	        //console.log("in the finally");
	        //console.dir(this.confirmationNumbers);
	      }
	    }
	  }, {
	    key: "setSingleShiftView",
	    value: function setSingleShiftView(shift, index) {
	      var _this6 = this;
	
	      this.singleShiftView = true;
	
	      this.singleShiftViewId = shift.id;
	      this.singleShiftViewShift = shift;
	      this.singleShiftViewShiftPosition = shift.shiftPosition;
	      this.singleShiftViewOriginalIndex = index;
	      //timeZone change here
	      this.singleShiftViewFormatted = "Shift " + (index + 1) + ": " + shift.shiftDateFormatted + " " + shift.shiftStartTimeLoc + " -> " + shift.shiftEndTimeLoc + " " + shift.shiftTZ + " " + (shift.shiftEnded ? " (ended)" : "") + (shift.shiftLive ? " (live)" : "");
	
	      console.log("this.singleShiftViewFormatted");
	      console.dir(this.singleShiftViewFormatted);
	
	      //this.loadShiftConfirmationData(shift.id);
	      this.checkOrUncheckAll(false);
	      this.calculateConfirmationNumber();
	      this.ui.allChecked = false;
	
	      this.$tracking.reportRosterPageClick("single shift view");
	
	      this.reSortHired();
	
	      this.$timeout(function () {
	        _this6.initializeMap();
	        _this6.processWhoCanBePaid();
	      }, 1300);
	
	      if (!shift.shiftStarted) {
	        this.showMap = false;
	      } else {
	        this.showMap = true;
	      }
	      this.prepareAllApplicantsCSV(this.allApplicants);
	
	      //this.setFakeLoader(750);
	
	      this.enableToolTips();
	    }
	  }, {
	    key: "setFakeLoader",
	    value: function setFakeLoader(time) {
	      var _this7 = this;
	
	      this.setLoader();
	
	      this.$timeout(function () {
	        _this7.unSetLoader();
	      }, time);
	    }
	  }, {
	    key: "setAll",
	    value: function setAll() {
	      var _this8 = this;
	
	      this.$timeout(function () {
	        _this8.confirmationFilters = {
	          all: true,
	          confirmed: false,
	          declined: false,
	          no_response: false
	        };
	
	        _this8.confirmationFilterText = "ALL";
	      }, 10);
	    }
	  }, {
	    key: "checkConfirmationFilters",
	    value: function checkConfirmationFilters() {
	      var _this9 = this;
	
	      this.$timeout(function () {
	        if (!_this9.confirmationFilters) return;
	
	        if (_this9.confirmationFilters.confirmed && _this9.confirmationFilters.declined && _this9.confirmationFilters.no_response) {
	          _this9.$timeout(function () {
	            _this9.confirmationFilters = {
	              all: true,
	              confirmed: false,
	              declined: false,
	              no_response: false
	            };
	            _this9.confirmationFilterText = "ALL";
	          }, 1);
	        }
	
	        if (!(_this9.confirmationFilters.confirmed && _this9.confirmationFilters.declined && _this9.confirmationFilters.no_response) && (_this9.confirmationFilters.confirmed || _this9.confirmationFilters.declined || _this9.confirmationFilters.no_response)) {
	          console.log("Seetting all to false!");
	
	          _this9.$timeout(function () {
	            _this9.confirmationFilters.all = false;
	          }, 1);
	
	          _this9.confirmationFilterText = "";
	
	          if (_this9.confirmationFilters.confirmed) {
	            _this9.confirmationFilterText = "CONFIRMED";
	
	            if (_this9.confirmationFilters.declined) {
	              _this9.confirmationFilterText = "CONFIRMED, DECLINED";
	            } else if (_this9.confirmationFilters.no_response) {
	              _this9.confirmationFilterText = "CONFIRMED, NO RESPONSE";
	            }
	          } else if (_this9.confirmationFilters.declined) {
	            _this9.confirmationFilterText = "DECLINED";
	
	            if (_this9.confirmationFilters.no_response) {
	              _this9.confirmationFilterText = "DECLINED, NO RESPONSE";
	            }
	          } else if (_this9.confirmationFilters.no_response) {
	            _this9.confirmationFilterText = "NO RESPONSE";
	          }
	        }
	
	        if (!_this9.confirmationFilters.confirmed && !_this9.confirmationFilters.declined && !_this9.confirmationFilters.no_response) {
	          _this9.$timeout(function () {
	            _this9.confirmationFilters = {
	              all: true,
	              confirmed: false,
	              declined: false,
	              no_response: false
	            };
	            _this9.confirmationFilterText = "ALL";
	          }, 1);
	        }
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "setAllShiftsView",
	    value: function setAllShiftsView() {
	      this.singleShiftView = false;
	
	      this.singleShiftViewId = null;
	      this.singleShiftViewShift = null;
	      this.singleShiftViewShiftPosition = null;
	      this.singleShiftViewFormatted = null;
	      this.checkOrUncheckAll(false);
	      this.ui.allChecked = false;
	
	      this.$tracking.reportRosterPageClick("all shifts view");
	
	      this.setFakeLoader(750);
	    }
	  }, {
	    key: "slideToPayment",
	    value: function slideToPayment() {}
	  }, {
	    key: "convertShifts",
	    value: function convertShifts(shifts) {
	      return shifts.map(function (shift) {
	        var timeZone = shift.contactInfo.place.timeZoneId;
	        var startTime = moment(shift.timeInterval.startTime);
	        var endTime = moment(shift.timeInterval.endTime);
	        var startTimeFormatted = startTime.format("h:mm a").toUpperCase();
	        var shiftDateFormatted = startTime.format("MMM DD YYYY").toUpperCase();
	        var shiftDateFormattedTitle = startTime.format("MMMM Do");
	        var shiftStartTimeLoc = startTime.tz(timeZone).format("hh:mm a");
	        var shiftEndTimeLoc = endTime.tz(timeZone).format("hh:mm a");
	
	        var shiftTZ = endTime.tz(timeZone).zoneAbbr();
	
	        var shiftEnded = endTime - moment() < 0;
	        var shiftStarted = startTime - moment() < 0;
	        var shiftLive = shiftStarted && !shiftEnded;
	
	        var diffTime = endTime.diff(startTime);
	        var durTime = moment.duration(diffTime);
	
	        var durDays = durTime.days();
	        var durHours = 24 * durDays + durTime.hours();
	        var durMin = durTime.minutes();
	
	        var duration = "" + (durHours ? durHours + " hour" : "") + (durHours > 1 ? "s" : "") + (durMin && durMin ? " " : "") + (durMin ? durMin + " minutes" : "");
	
	        return {
	          id: shift.id,
	          startDate: startTime.format("MM/DD/YYYY"),
	          endDate: endTime.format("MM/DD/YYYY"),
	          startTime: startTimeFormatted,
	          shiftStartTimeLoc: shiftStartTimeLoc,
	          shiftEndTimeLoc: shiftEndTimeLoc,
	          shiftDateFormatted: shiftDateFormatted,
	          endTime: endTime.format("h:mm a").toUpperCase(),
	          contactInfo: shift.contactInfo,
	          shiftPosition: shift.shiftPosition,
	          shiftEnded: shiftEnded,
	          shiftStarted: shiftStarted,
	          shiftDateFormattedTitle: shiftDateFormattedTitle,
	          shiftLive: shiftLive,
	          shiftTZ: shiftTZ,
	          unpaidBreak: shift.unpaidBreak,
	          duration: duration
	        };
	      });
	    }
	  }, {
	    key: "getHeader",
	    value: function getHeader() {
	      return ["Last Name", "First Name", "Phone", "Email", "Status", "Start Date", "End Date", "Check in", "Check out", "Final Time Worked"];
	    }
	  }, {
	    key: "prepareAllApplicantsCSV",
	    value: function prepareAllApplicantsCSV(applicants) {
	      var _this10 = this;
	
	      if (!applicants) {
	        return false;
	      }
	      applicants.sort(function (a, b) {
	        if (a.humanReadableStatus == b.humanReadableStatus) {
	          return 0;
	        }
	        return a.humanReadableStatus > b.humanReadableStatus ? 1 : -1;
	      });
	      var csv = [];
	      this.csv = [];
	
	      try {
	        applicants.forEach(function (applicant, i) {
	          if (applicant.humanReadableStatus === "Hired") {
	            var shift = void 0;
	            if (_this10.shiftConfirmationData && _this10.shiftConfirmationData[_this10.singleShiftViewShiftPosition] && _this10.shiftConfirmationData[_this10.singleShiftViewShiftPosition][applicant.applicantId]) {
	              shift = _this10.shiftConfirmationData[_this10.singleShiftViewShiftPosition][applicant.applicantId];
	            }
	
	            if (!shift) {
	              return;
	            }
	
	            var finalTimeWorked = void 0;
	            var now = moment();
	            var shiftEndTimeMoment = moment(shift.timeInterval.endTime);
	            var differenceBetweenNowAndEndTime = now.diff(shiftEndTimeMoment, "mintues");
	
	            if (differenceBetweenNowAndEndTime >= 0 || shift.actualMinutesWorked) {
	              finalTimeWorked = shift && shift.actualMinutesWorked ? shift.timeInterval.timeInHours + " hours " + shift.timeInterval.timeInMinutes + " minutes" : _this10.singleShiftViewShift.duration;
	            } else {
	              finalTimeWorked = "--";
	            }
	
	            finalTimeWorked = "--";
	
	            var csvObj = {
	              lastName: "" + applicant.applicantLastName,
	              firstName: " " + applicant.applicantFirstName,
	              phone: applicant.applicantHomeContactInfo.phoneMobile,
	              email: applicant.applicantEmail,
	              status: applicant.humanReadableStatus,
	              startDate: _this10.singleShiftViewShift.startDate + " " + _this10.singleShiftViewShift.startTime,
	              endDate: _this10.singleShiftViewShift.endDate + " " + _this10.singleShiftViewShift.endTime,
	              checkIn: shift && shift.checkInTimeOnly ? shift.checkInTimeOnly : "",
	              checkOut: shift && shift.checkOutTimeOnly ? shift.checkOutTimeOnly : "",
	              duration: finalTimeWorked
	            };
	            csv.push(csvObj);
	          }
	        });
	      } catch (err) {
	        console.log("error processing csv");
	        console.dir(err);
	      } finally {
	        this.csv = csv;
	        //this.unSetLoader();
	      }
	    }
	  }, {
	    key: "setStatus",
	    value: function setStatus(status) {
	      if (!status || status === 3) return "Pending";
	
	      if (status === 1) return "Hired";
	
	      if (status === 2) return "Rejected";
	
	      if (status === 4) return "Quit";
	
	      if (status === 5) return "Withdrawn";
	
	      if (status === 6) return "Abandoned";
	
	      if (status === 7) return "Canceled";
	    }
	  }, {
	    key: "clearSearch",
	    value: function clearSearch() {
	      this.jobQuery = "";
	      this.$tracking.reportRosterPageClick("clear search");
	      this.reloadApplicants();
	    }
	  }, {
	    key: "reloadApplicants",
	    value: function reloadApplicants(loading) {
	      var jobblePoolId = this.event.subEvents[0].deduppedJobbles[0].jobblePoolId;
	      this.loadAllApplicants(jobblePoolId, loading);
	    }
	  }, {
	    key: "setSortOrder",
	    value: function setSortOrder(sort) {
	      if (sort === "confirmation") {
	        return;
	      }
	
	      this.sortOrder = sort === this.sortField ? this.sortOrder === "desc" ? "asc" : "desc" : "asc";
	      this.sortField = sort;
	
	      this.reloadApplicants(true);
	    }
	  }, {
	    key: "initializeMap",
	    value: function initializeMap() {
	      var _this11 = this;
	
	      this.reSortHired(true, true);
	
	      this.enableToolTips();
	
	      var mapBoxKey = this.$env.EnvironmentConfig.mapbox;
	      mapboxgl.accessToken = mapBoxKey;
	
	      var shift = this.singleShiftViewShift;
	
	      console.log("single shift view", shift);
	
	      var zip = shift.contactInfo.zipCode;
	      var street = shift.contactInfo.streetLine1;
	      var city = shift.contactInfo.city;
	      var state = shift.contactInfo.state;
	
	      var location = street + " " + city + ", " + state + " " + zip;
	
	      var mapboxClient = mapboxSdk({ accessToken: mapboxgl.accessToken });
	
	      mapboxClient.geocoding.forwardGeocode({
	        query: location,
	        autocomplete: false,
	        limit: 1
	      }).send().then(function (response) {
	        if (response && response.body && response.body.features && response.body.features.length) {
	          var feature = response.body.features[0];
	
	          var map = new mapboxgl.Map({
	            container: "mapbox-2",
	            style: "mapbox://styles/mapbox/streets-v11",
	            center: feature.center,
	            zoom: 10
	          });
	
	          map.on("load", function () {
	            map.addSource("source_circle_500", {
	              type: "geojson",
	              data: {
	                type: "FeatureCollection",
	                features: [{
	                  type: "Feature",
	                  geometry: {
	                    type: "Point",
	                    coordinates: feature.center
	                  }
	                }]
	              }
	            });
	
	            var metersToPixelsAtMaxZoom = function metersToPixelsAtMaxZoom(meters, latitude) {
	              return meters / 0.075 / Math.cos(latitude * Math.PI / 180);
	            };
	
	            map.addLayer({
	              id: "circle500",
	              type: "circle",
	              source: "source_circle_500",
	              paint: {
	                "circle-radius": {
	                  stops: [[0, 0], [20, metersToPixelsAtMaxZoom(METER_RADIUS, feature.center[1])]],
	                  base: 2
	                },
	                "circle-color": CIRCLE_COLOR,
	                "circle-opacity": CIRCLE_OPACITY
	              }
	            });
	          });
	
	          var options = {};
	
	          options.color = "#62C046";
	          options.scale = 1.5;
	          options.anchor = "center";
	
	          var popUpText2 = "<div>" + street + "</div><div>" + city + ", " + state + " " + zip + "</div>";
	
	          new mapboxgl.Marker(options).setLngLat(feature.center).setPopup(new mapboxgl.Popup().setHTML(popUpText2)).addTo(map);
	
	          _this11.map = map;
	
	          _this11.hiredApplicants.map(function (applicant) {
	            if (!_this11.shiftConfirmationData || !_this11.shiftConfirmationData[_this11.singleShiftViewShiftPosition] || !_this11.shiftConfirmationData[_this11.singleShiftViewShiftPosition]) return console.warn("Confirmation Data not loaded for shift");
	
	            var confirmationData = _this11.shiftConfirmationData[_this11.singleShiftViewShiftPosition];
	
	            if (!confirmationData[applicant.applicantId]) return console.warn("Confirmation Data not loaded for applicant");
	
	            var applicantConfirmationData = confirmationData[applicant.applicantId];
	
	            if (applicantConfirmationData.checkInCoord && applicantConfirmationData.checkInCoord.lng && applicantConfirmationData.checkInCoord.lat && applicantConfirmationData.checkOutCoord && applicantConfirmationData.checkOutCoord.lng && applicantConfirmationData.checkOutCoord.lat && _this11.getDistanceFromLatLonInM(applicantConfirmationData.checkInCoord.lat, applicantConfirmationData.checkInCoord.lng, applicantConfirmationData.checkOutCoord.lat, applicantConfirmationData.checkOutCoord.lng) < METER_THRESHOLD) {
	              console.log("THESE ARE CLOSE ENOUGH~");
	
	              var _options = {};
	
	              var el = document.createElement("div");
	
	              var dist = _this11.getDistanceFromLatLonInM(applicantConfirmationData.checkInCoord.lat, applicantConfirmationData.checkInCoord.lng, feature.center[1], feature.center[0]);
	              console.log("check in coordinate dist", dist);
	
	              el.className = "marker";
	              el.style.backgroundImage = dist > METER_RADIUS ? RED_ICON : GREEN_ICON;
	              el.style.width = "35px";
	              el.style.height = "53px"; // 1.53
	              el.style.backgroundSize = "100%";
	              el.style.backgroundRepeat = "no-repeat";
	
	              var note = applicantConfirmationData.jobblerNote || "--";
	
	              _options.color = "#000";
	
	              var popUpText = "<div>" + "<div>" + applicant.applicantFirstName + " " + applicant.applicantLastName + "</div>" + "</div>" + "<div class='note-holder'>Check-in: " + applicantConfirmationData.checkInTimeOnly + "</div>" + "<div class='note-holder'>Check-out: " + applicantConfirmationData.checkOutTimeOnly + "</div>" + "<div>Note: " + note + "</div>";
	
	              var currentMarker = new mapboxgl.Marker(el).setLngLat([applicantConfirmationData.checkInCoord.lng, applicantConfirmationData.checkInCoord.lat]).setPopup(new mapboxgl.Popup().setHTML(popUpText)).addTo(_this11.map);
	            } else {
	              if (applicantConfirmationData.checkInCoord && applicantConfirmationData.checkInCoord.lng && applicantConfirmationData.checkInCoord.lat) {
	                var _options2 = {};
	
	                var _el = document.createElement("div");
	
	                var _dist = _this11.getDistanceFromLatLonInM(applicantConfirmationData.checkInCoord.lat, applicantConfirmationData.checkInCoord.lng, feature.center[1], feature.center[0]);
	                console.log("check in coordinate dist", _dist);
	
	                _el.className = "marker";
	                _el.style.backgroundImage = _dist > METER_RADIUS ? RED_ICON : GREEN_ICON;
	                _el.style.width = "35px";
	                _el.style.height = "53px"; // 1.53
	                _el.style.backgroundSize = "100%";
	                _el.style.backgroundRepeat = "no-repeat";
	
	                var _note = applicantConfirmationData.jobblerNote || "--";
	
	                _options2.color = "#000";
	
	                var _popUpText = "<div><div>" + applicant.applicantFirstName + " " + applicant.applicantLastName + "</div></div><div class='note-holder'>Check-in: " + applicantConfirmationData.checkInTimeOnly + "</div><div>Note: " + _note + "</div>";
	                var _currentMarker = new mapboxgl.Marker(_el).setLngLat([applicantConfirmationData.checkInCoord.lng, applicantConfirmationData.checkInCoord.lat]).setPopup(new mapboxgl.Popup().setHTML(_popUpText)).addTo(_this11.map);
	              }
	
	              if (applicantConfirmationData.checkOutCoord && applicantConfirmationData.checkOutCoord.lng && applicantConfirmationData.checkOutCoord.lat) {
	                var _options3 = {};
	
	                var _el2 = document.createElement("div");
	
	                var _dist2 = _this11.getDistanceFromLatLonInM(applicantConfirmationData.checkOutCoord.lat, applicantConfirmationData.checkOutCoord.lng, feature.center[1], feature.center[0]);
	                console.log("check in coordinate dist", _dist2);
	
	                _el2.className = "marker";
	                _el2.style.backgroundImage = _dist2 > METER_RADIUS ? RED_ICON : GREEN_ICON;
	                _el2.style.width = "35px";
	                _el2.style.height = "53px"; // 1.53
	                _el2.style.backgroundSize = "100%";
	                _el2.style.backgroundRepeat = "no-repeat";
	
	                var _note2 = applicantConfirmationData.jobblerNote || "--";
	
	                _options3.color = "#000";
	
	                var _popUpText2 = "<div><div>" + applicant.applicantFirstName + " " + applicant.applicantLastName + "</div></div><div class='note-holder'>Check-out: " + applicantConfirmationData.checkOutTimeOnly + "</div><div>Note: " + _note2 + "</div>";
	                var _currentMarker2 = new mapboxgl.Marker(_el2).setLngLat([applicantConfirmationData.checkOutCoord.lng, applicantConfirmationData.checkOutCoord.lat]).setPopup(new mapboxgl.Popup().setHTML(_popUpText2)).addTo(_this11.map);
	              }
	            }
	          });
	        } else {
	          alert("There was an error finding the location of the job.");
	        }
	        _this11.$timeout(function () {
	          //this.unSetLoader();
	        }, 1000);
	      });
	    }
	  }, {
	    key: "getDistanceFromLatLonInM",
	    value: function getDistanceFromLatLonInM(lat1, lon1, lat2, lon2) {
	      var deg2rad = function deg2rad(deg) {
	        return deg * (Math.PI / 180);
	      };
	
	      var R = 6371; // Radius of the earth in km
	      var dLat = deg2rad(lat2 - lat1); // deg2rad below
	      var dLon = deg2rad(lon2 - lon1);
	      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
	      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	      var d = R * c; // Distance in km
	      return d * 1000;
	    }
	  }, {
	    key: "loadMap",
	    value: function loadMap(lat, lng, shift, contactInfo, applicant, init) {
	      var mapBoxKey = this.$env.EnvironmentConfig.mapbox;
	      mapboxgl.accessToken = mapBoxKey;
	
	      var feature = {
	        center: [lng, lat]
	      };
	
	      var map = this.checkinoutmap;
	
	      if (init) {
	        map = new mapboxgl.Map({
	          container: "check-in-out-map",
	          style: "mapbox://styles/mapbox/streets-v11",
	          center: feature.center,
	          zoom: 10
	        });
	
	        map.on("load", function () {
	          map.resize();
	
	          map.addSource("source_circle_500", {
	            type: "geojson",
	            data: {
	              type: "FeatureCollection",
	              features: [{
	                type: "Feature",
	                geometry: {
	                  type: "Point",
	                  coordinates: feature.center
	                }
	              }]
	            }
	          });
	
	          var metersToPixelsAtMaxZoom = function metersToPixelsAtMaxZoom(meters, latitude) {
	            return meters / 0.075 / Math.cos(latitude * Math.PI / 180);
	          };
	
	          map.addLayer({
	            id: "circle500",
	            type: "circle",
	            source: "source_circle_500",
	            paint: {
	              "circle-radius": {
	                stops: [[0, 0], [20, metersToPixelsAtMaxZoom(METER_RADIUS, feature.center[1])]],
	                base: 2
	              },
	              "circle-color": CIRCLE_COLOR,
	              "circle-opacity": CIRCLE_OPACITY
	            }
	          });
	        });
	
	        this.checkinoutmap = map;
	      }
	
	      console.log("shift for map", shift);
	
	      shift.contactInfo = shift.contactInfo || contactInfo || {};
	
	      var zip = shift.contactInfo.zipCode || "";
	      var street = shift.contactInfo.streetLine1 || "";
	      var city = shift.contactInfo.city || "";
	      var state = shift.contactInfo.state || "";
	
	      var popUpText2 = "<div>" + street + "</div><div>" + city + ", " + state + " " + zip + "</div>";
	
	      if (this.currentModalLocationMarker && this.currentModalLocationMarker.remove) {
	        this.currentModalLocationMarker.remove();
	      }
	
	      if (this.currentModalCheckinMarker && this.currentModalCheckinMarker.remove) {
	        this.currentModalCheckinMarker.remove();
	      }
	
	      if (this.currentModalCheckoutMarker && this.currentModalCheckoutMarker.remove) {
	        this.currentModalCheckoutMarker.remove();
	      }
	
	      if (!(shift.checkInCoord && shift.checkInCoord.lng) && !(shift.checkOutCoord && shift.checkOutCoord.lng)) {
	        var options = {};
	
	        var el = document.createElement("div");
	
	        el.className = "marker";
	        el.style.backgroundImage = "url(/app/vendor/images/no-location-icon.png)";
	        el.style.width = "35px";
	        el.style.height = "53px"; // 1.53
	        el.style.backgroundSize = "100%";
	        el.style.backgroundRepeat = "no-repeat";
	
	        var note = shift.jobblerNote || "--";
	
	        options.color = "#000";
	
	        var popUpText = "<div>Missing Location Data</div><div>" + street + "</div><div>" + city + ", " + state + " " + zip + "</div>";
	
	        this.currentModalLocationMarker = new mapboxgl.Marker(el).setLngLat(feature.center).setPopup(new mapboxgl.Popup().setHTML(popUpText)).addTo(map);
	      } else {
	        var _options4 = {};
	
	        _options4.color = "#62C046";
	        _options4.scale = 1.5;
	        _options4.anchor = "center";
	
	        this.currentModalLocationMarker = new mapboxgl.Marker(_options4).setLngLat(feature.center).setPopup(new mapboxgl.Popup().setHTML(popUpText2)).addTo(map);
	      }
	
	      if (shift.checkInCoord && shift.checkInCoord.lng && shift.checkInCoord.lat && shift.checkOutCoord && shift.checkOutCoord.lng && shift.checkOutCoord.lat && this.getDistanceFromLatLonInM(shift.checkInCoord.lat, shift.checkInCoord.lng, shift.checkOutCoord.lat, shift.checkOutCoord.lng) < METER_THRESHOLD) {
	        console.log("THESE ARE CLOSE ENOUGH~");
	
	        var _options5 = {};
	
	        var _el3 = document.createElement("div");
	
	        var dist = this.getDistanceFromLatLonInM(shift.checkInCoord.lat, shift.checkInCoord.lng, feature.center[1], feature.center[0]);
	        console.log("check in coordinate dist", dist);
	
	        _el3.className = "marker";
	        _el3.style.backgroundImage = dist > METER_RADIUS ? RED_ICON : GREEN_ICON;
	        _el3.style.width = "35px";
	        _el3.style.height = "53px"; // 1.53
	        _el3.style.backgroundSize = "100%";
	        _el3.style.backgroundRepeat = "no-repeat";
	
	        var _note3 = shift.jobblerNote || "--";
	
	        _options5.color = "#000";
	
	        var _popUpText3 = "<div>" + "<div>" + applicant.applicantFirstName + " " + applicant.applicantLastName + "</div>" + "</div>" + "<div class='note-holder'>Check-in: " + shift.checkInTimeOnly + "</div>" + "<div class='note-holder'>Check-out: " + shift.checkOutTimeOnly + "</div>" + "<div>Note: " + _note3 + "</div>";
	
	        this.currentModalCheckinMarker = new mapboxgl.Marker(_el3).setLngLat([shift.checkInCoord.lng, shift.checkInCoord.lat]).setPopup(new mapboxgl.Popup().setHTML(_popUpText3)).addTo(map);
	      } else {
	        if (shift.checkInCoord && shift.checkInCoord.lng && shift.checkInCoord.lat) {
	          var _options6 = {};
	
	          var _el4 = document.createElement("div");
	
	          var _dist3 = this.getDistanceFromLatLonInM(shift.checkInCoord.lat, shift.checkInCoord.lng, feature.center[1], feature.center[0]);
	          console.log("check in coordinate dist", _dist3);
	
	          _el4.className = "marker";
	          _el4.style.backgroundImage = _dist3 > METER_RADIUS ? RED_ICON : GREEN_ICON;
	          _el4.style.width = "35px";
	          _el4.style.height = "53px"; // 1.53
	          _el4.style.backgroundSize = "100%";
	          _el4.style.backgroundRepeat = "no-repeat";
	
	          var _note4 = shift.jobblerNote || "--";
	
	          _options6.color = "#000";
	
	          var _popUpText4 = "<div><div>" + applicant.applicantFirstName + " " + applicant.applicantLastName + "</div></div><div class='note-holder'>Check-in: " + shift.checkInTimeOnly + "</div><div>Note: " + _note4 + "</div>";
	
	          this.currentModalCheckinMarker = new mapboxgl.Marker(_el4).setLngLat([shift.checkInCoord.lng, shift.checkInCoord.lat]).setPopup(new mapboxgl.Popup().setHTML(_popUpText4)).addTo(map);
	        }
	
	        if (shift.checkOutCoord && shift.checkOutCoord.lng && shift.checkOutCoord.lat) {
	          var _options7 = {};
	
	          var _el5 = document.createElement("div");
	
	          var _dist4 = this.getDistanceFromLatLonInM(shift.checkOutCoord.lat, shift.checkOutCoord.lng, feature.center[1], feature.center[0]);
	          console.log("check in coordinate dist", _dist4);
	
	          _el5.className = "marker";
	          _el5.style.backgroundImage = _dist4 > METER_RADIUS ? RED_ICON : GREEN_ICON;
	          _el5.style.width = "35px";
	          _el5.style.height = "53px"; // 1.53
	          _el5.style.backgroundSize = "100%";
	          _el5.style.backgroundRepeat = "no-repeat";
	
	          var _note5 = shift.jobblerNote || "--";
	
	          _options7.color = "#000";
	
	          var _popUpText5 = "<div><div>" + applicant.applicantFirstName + " " + applicant.applicantLastName + "</div></div><div class='note-holder'>Check-out: " + shift.checkOutTimeOnly + "</div><div>Note: " + _note5 + "</div>";
	
	          this.currentModalCheckoutMarker = new mapboxgl.Marker(_el5).setLngLat([shift.checkOutCoord.lng, shift.checkOutCoord.lat]).setPopup(new mapboxgl.Popup().setHTML(_popUpText5)).addTo(map);
	        }
	      }
	    }
	  }, {
	    key: "setApplicantStatus",
	    value: function setApplicantStatus(shift, shiftPaid, checkInTime, checkOutTime, confirmationResponse) {
	      //console.log("setApplicantStatus shift:", shift);
	      //console.log("setApplicantStatus shift:", shiftPaid, checkInTime, checkOutTime, confirmationResponse);
	      var status = "";
	      var statusNumber = 0;
	      var groupNumber = 0;
	      var paymentScore = shift.paymentScore;
	      //console.log("PAYMENT SCORE: " + paymentScore);
	      if (paymentScore != null) {
	        if (shiftPaid) {
	          status = "Paid";
	          if (shift.noShow) {
	            status = "No show, Paid";
	          }
	          statusNumber = 4;
	          groupNumber = 1;
	        } else if (shift.noShow) {
	          status = "No Show";
	          statusNumber = 5;
	          groupNumber = 2;
	        } else if (shift.actualMinutesWorked > 0) {
	          status = "Ready to pay";
	          statusNumber = 1;
	          groupNumber = 1;
	        } else if (paymentScore >= 0 && paymentScore <= 2) {
	          status = "Needs Review";
	          statusNumber = 2;
	          groupNumber = 2;
	        } else if (paymentScore >= 3 && paymentScore <= 5) {
	          status = "Needs Review";
	          statusNumber = 2;
	          groupNumber = 2;
	        } else if (paymentScore > 5) {
	          status = "Ready to Pay";
	          statusNumber = 1;
	          groupNumber = 1;
	        }
	      } else {
	        //console.log("IN THE ELSE :");
	        //console.dir(shift);
	        if (shiftPaid) {
	          status = "Paid";
	          statusNumber = 4;
	          groupNumber = 1;
	        } else if (shift.noShow) {
	          status = "No Show";
	          statusNumber = 5;
	          groupNumber = 2;
	        } else if (checkInTime && checkOutTime || shift.actualMinutesWorked > 0) {
	          status = "Ready to pay";
	          statusNumber = 1;
	          groupNumber = 1;
	        } else if (checkInTime || checkOutTime) {
	          //status = "No check-" + (checkInTime ? "out" : "in")
	          status = "Needs review";
	          statusNumber = 2;
	          groupNumber = 2;
	        } else {
	          status = "Needs review";
	          statusNumber = 3;
	          groupNumber = 2;
	        }
	      }
	
	      if (confirmationResponse) {
	        groupNumber = 1;
	      }
	
	      return { status: status, statusNumber: statusNumber, groupNumber: groupNumber };
	    }
	  }, {
	    key: "loadSingleShiftConfirmationData",
	    value: function loadSingleShiftConfirmationData(shiftId, shiftPosition, overallShift) {
	      var _this12 = this;
	
	      console.log("loadSingleShiftConfirmationData");
	      //console.dir(shiftId);
	      //console.dir(overallShift);
	
	      this.$timeout(function () {
	        _this12.loadingShiftConfirmationDataByShift[shiftId] = true;
	      });
	      this.setLoader();
	      this.$events.getShiftsInSamePosition(shiftId).then(function (data) {
	        console.log("getShiftsInSamePosition");
	        console.dir(data);
	
	        _this12.$timeout(function () {
	          _this12.loadingShiftConfirmationDataByShift[shiftId] = false;
	        });
	
	        var applicationData = data.data;
	
	        //console.log("applicationData");
	        //console.dir(applicationData);
	
	        var payPerHourJobbler = _this12.event.subEvents[0].deduppedJobbles[0].jobblerRate;
	        //const payPerHour = this.event.subEvents[0].deduppedJobbles[0].payPerHour;
	        //const payPerHour = payPerHourJobbler / (1 - this.currentUser.company.defaultPlan.jobblerFeePct);
	        var payPerHour = payPerHourJobbler * (1 + _this12.currentUser.company.defaultPlan.companyFeePct);
	
	        applicationData.forEach(function (shift) {
	          var applicant = shift.applicant;
	
	
	          if (!applicant) return;
	
	          var applicantId = applicant.id;
	
	          //console.log(shiftId, shiftPosition, applicantId);
	
	          //console.log("real shift id", shiftId, shift.id);
	
	          //console.log("shift id info--");
	          //console.dir(shift.id);
	          //console.dir(shift.checkInTime);
	
	          var confirmationResponse = shift.confirmationResponse || null;
	          var confirmationResponseExists = shift.confirmationResponse !== null;
	          var jobblerNote = shift.jobblerNote;
	          var checkInTime = shift.checkInTime || null;
	          var checkOutTime = shift.checkOutTime || null;
	          var checkInTimeOnly = null;
	          var checkOutTimeOnly = null;
	          var manualCheckInTime = shift.manualCheckInTime || null;
	          var manualCheckOutTime = shift.manualCheckOutTime || null;
	          var manualCheckInTimeOnly = null;
	          var manualCheckOutTimeOnly = null;
	
	          var shiftPaid = !!(shift.paymentStats && shift.paymentStats.amountRecievedByJobber);
	
	          var checkInTimeMoment = void 0;
	          var checkOutTimeMoment = void 0;
	          var manualCheckInTimeMoment = void 0;
	          var manualCheckOutTimeMoment = void 0;
	          var payment = void 0;
	          var paymentJobbler = void 0;
	          var paymentJobblerNoFee = void 0;
	          var hoursRounded = null;
	          var momentET = null;
	          var momentST = null;
	          var totalMinutes = null;
	          var minutesMod = null;
	          var jobblerScheduleManagementStatus = void 0;
	          var timeZone = shift.contactInfo.place.timeZoneId;
	
	          shift.TZ = moment.tz(timeZone).zoneAbbr();
	
	          if (checkInTime) {
	
	            checkInTimeMoment = moment.tz(checkInTime, timeZone);
	            checkInTimeMoment = checkInTimeMoment.seconds() < 30 ? checkInTimeMoment.startOf('minute') : checkInTimeMoment.startOf('minute').add(1, 'minute');
	            //checkInTimeMoment = moment(checkInTime);
	            checkInTime = checkInTimeMoment.format("MMM DD, h:mm a").toUpperCase();
	            checkInTimeOnly = checkInTimeMoment.format("h:mm A");
	            //let checkInTimeMomentNew = this.formatCheckInTime(checkInTime, shift.timeInterval.startTime, shift);
	            //checkInTime = checkInTimeMomentNew.format("MMM DD, h:mm a").toUpperCase();
	            //checkInTimeOnly = checkInTimeMomentNew.format("h:mm A");
	          }
	
	          if (checkOutTime) {
	            checkOutTimeMoment = moment.tz(checkOutTime, timeZone);
	            checkOutTimeMoment = checkOutTimeMoment.seconds() < 30 ? checkOutTimeMoment.startOf('minute') : checkOutTimeMoment.startOf('minute').add(1, 'minute');
	            checkOutTime = checkOutTimeMoment.format("MMM DD, h:mm a").toUpperCase();
	            checkOutTimeOnly = checkOutTimeMoment.format("h:mm A");
	            //let checkOutTimeMomentNew = this.formatCheckOutTime(checkOutTime, shift);
	            //checkOutTime = checkOutTimeMomentNew.format("MMM DD, h:mm a").toUpperCase();
	            //checkOutTimeOnly = checkOutTimeMomentNew.format("h:mm A");
	          }
	
	          if (manualCheckInTime) {
	            manualCheckInTimeMoment = moment.tz(manualCheckInTime, timeZone);
	            manualCheckInTimeMoment = manualCheckInTimeMoment.seconds() < 30 ? manualCheckInTimeMoment.startOf('minute') : manualCheckInTimeMoment.startOf('minute').add(1, 'minute');
	            manualCheckInTime = manualCheckInTimeMoment.format("MMM DD, h:mm a").toUpperCase();
	            manualCheckInTimeOnly = manualCheckInTimeMoment.format("h:mm A");
	          }
	
	          if (manualCheckOutTime) {
	            manualCheckOutTimeMoment = moment.tz(manualCheckOutTime, timeZone);
	            manualCheckOutTimeMoment = manualCheckOutTimeMoment.seconds() < 30 ? manualCheckOutTimeMoment.startOf('minute') : manualCheckOutTimeMoment.startOf('minute').add(1, 'minute');
	            manualCheckOutTime = manualCheckOutTimeMoment.format("MMM DD, h:mm a").toUpperCase();
	            manualCheckOutTimeOnly = manualCheckOutTimeMoment.format("h:mm A");
	          }
	
	          var _setApplicantStatus = _this12.setApplicantStatus(shift, shiftPaid, checkInTime, checkOutTime, confirmationResponse),
	              status = _setApplicantStatus.status,
	              statusNumber = _setApplicantStatus.statusNumber,
	              groupNumber = _setApplicantStatus.groupNumber;
	
	          /*
	           * We look for:
	           * 1. Manager edited hours first
	           * 2. Jobbler manual check out second
	           * 3. Default checkin and out values 3rd
	           * 4. Lastly default to 0 total hours to prompt editing
	           */
	
	          if (shift.actualMinutesWorked !== null) {
	            totalMinutes = shift.actualMinutesWorked;
	            shift.totalMinutes = totalMinutes;
	          } else if (shift.manualCheckOutTime !== null) {
	
	            momentET = manualCheckOutTimeMoment;
	
	            if (shift.manualCheckInTime !== null) {
	              momentST = manualCheckInTimeMoment;
	            } else if (shift.checkInTime !== null) {
	              momentST = checkInTimeMoment;
	            } else {
	              momentST = moment.tz(shift.timeInterval.startTime, timeZone);
	              //momentST = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId);
	            }
	
	            totalMinutes = momentET.diff(momentST, "minutes");
	
	            if (overallShift.unpaidBreak > totalMinutes) {
	              shift.totalMinutes = totalMinutes;
	            } else {
	              shift.totalMinutes = totalMinutes - overallShift.unpaidBreak;
	            }
	          } else if (shift.manualCheckInTime !== null) {
	            momentST = manualCheckInTimeMoment;
	
	            if (shift.manualCheckOutTime !== null) {
	              momentET = manualCheckOutTimeMoment;
	            } else if (shift.checkOutTime !== null) {
	              momentET = checkOutTimeMoment;
	            } else {
	              momentET = moment.tz(shift.timeInterval.endTime, timeZone);
	            }
	
	            totalMinutes = moment(momentET).diff(moment(momentST), "minutes");
	
	            if (overallShift.unpaidBreak > totalMinutes) {
	              shift.totalMinutes = totalMinutes;
	            } else {
	              shift.totalMinutes = totalMinutes - overallShift.unpaidBreak;
	            }
	          } else if (checkInTime !== null && checkOutTime !== null) {
	
	            momentET = checkOutTimeMoment.tz(shift.contactInfo.place.timeZoneId);
	            momentST = checkInTimeMoment.tz(shift.contactInfo.place.timeZoneId);
	            totalMinutes = moment(checkOutTime).diff(moment(checkInTime), "minutes");
	
	            if (overallShift.unpaidBreak > totalMinutes) {
	              shift.totalMinutes = totalMinutes;
	            } else {
	              shift.totalMinutes = totalMinutes - overallShift.unpaidBreak;
	            }
	          } else {
	            totalMinutes = 0;
	            shift.totalMinutes = 0;
	            shift.originalTotalMinutes = 0;
	          }
	
	          hoursRounded = Math.floor(shift.totalMinutes / 60);
	          minutesMod = shift.totalMinutes % 60;
	
	          shift.timeInterval.timeInHours = hoursRounded;
	          shift.timeInterval.timeInMinutes = minutesMod;
	
	          if (shift.paymentStats.amountRecievedByJobber === null) {
	            payment = (Math.round(shift.totalMinutes * payPerHour / 100 / 60 * 100) / 100).toFixed(2);
	            paymentJobbler = (Math.round(shift.totalMinutes * payPerHourJobbler / 100 / 60 * 100) / 100).toFixed(2);
	          } else {
	            //payment = (Math.round((shift.paymentStats.amountRecievedByJobber / 100) * 100) / 100).toFixed(2);
	            //paymentJobbler = (Math.round((shift.paymentStats.amountRecievedByJobber / 100) * 100) / 100).toFixed(2);
	            payment = (shift.paymentStats.amountCompany / 100).toFixed(2);
	            paymentJobbler = (shift.paymentStats.amountRecievedByJobber / 100).toFixed(2);
	
	            var a = shift.paymentStats.amountRecievedByJobber;
	            var h = a / _this12.event.subEvents[0].deduppedJobbles[0].payPerHour;
	            var a2 = h * payPerHourJobbler;
	            paymentJobblerNoFee = (Math.round(a2 / 100 * 100) / 100).toFixed(2);
	          }
	
	          //console.log("user.payment", payment);
	          //console.log("user.paymentJobbler", paymentJobbler);
	
	          var paymentHours = Math.round(paymentJobbler / (_this12.event.subEvents[0].deduppedJobbles[0].payPerHour / 100) * 100) / 100;
	          var tooltip = void 0;
	
	          var ppr = Math.round(_this12.event.subEvents[0].deduppedJobbles[0].jobblerRate / 100).toFixed(2);
	
	          if (shift.paymentStats.number === 1) {
	            tooltip = "Paid $" + paymentJobbler + " at $" + ppr + "/hr";
	          } else if (shift.paymentStats.number > 1) {
	            tooltip = "This user was paid " + shift.paymentStats.number + " times for this shift for a total of $" + paymentJobbler;
	          } else {
	            tooltip = "This users payment is still processing";
	          }
	          //console.log("tooltip", tooltip);
	
	          jobblerScheduleManagementStatus = _this12.calculateJobblerScheduleManagementStatus(shift);
	
	          _this12.$timeout(function () {
	            _this12.shiftConfirmationData = _this12.shiftConfirmationData || {};
	            _this12.shiftConfirmationData[shiftPosition] = _this12.shiftConfirmationData[shiftPosition] || {};
	            _this12.shiftConfirmationData[shiftPosition][applicantId] = {
	              shiftId: shift.id,
	              shiftPosition: shiftPosition,
	              applicantId: applicantId,
	              paymentHours: paymentHours,
	              checkInTime: checkInTime,
	              checkOutTime: checkOutTime,
	              checkInTimeOnly: checkInTimeOnly,
	              checkOutTimeOnly: checkOutTimeOnly,
	              checkInTimeMoment: checkInTimeMoment,
	              checkOutTimeMoment: checkOutTimeMoment,
	              manualCheckInTime: manualCheckInTime,
	              manualCheckOutTime: manualCheckOutTime,
	              manualCheckInTimeOnly: manualCheckInTimeOnly,
	              manualCheckOutTimeOnly: manualCheckOutTimeOnly,
	              manualCheckInTimeMoment: manualCheckInTimeMoment,
	              manualCheckOutTimeMoment: manualCheckOutTimeMoment,
	              confirmationResponse: confirmationResponse,
	              jobblerScheduleManagementStatus: jobblerScheduleManagementStatus,
	              confirmationResponseExists: confirmationResponseExists,
	              jobblerNote: jobblerNote,
	              status: status,
	              tooltip: tooltip,
	              statusNumber: statusNumber,
	              TZ: shift.TZ,
	              groupNumber: groupNumber,
	              checkInCoord: shift.checkInCoord || shift.autoCheckInCoord,
	              checkOutCoord: shift.checkOutCoord || shift.autoCheckOutCoord,
	              actualMinutesWorked: shift.actualMinutesWorked,
	              noShow: shift.noShow,
	              paymentStats: shift.paymentStats,
	              shiftPaid: shiftPaid,
	              totalMinutes: shift.totalMinutes,
	              originalTotalMinutes: shift.originalTotalMinutes,
	              timeInterval: shift.timeInterval,
	              payment: payment,
	              paymentJobbler: paymentJobbler,
	              paymentJobblerNoFee: paymentJobblerNoFee,
	              unpaidBreak: overallShift.unpaidBreak,
	              paymentScore: shift.paymentScore
	            };
	
	            //console.log("EACH SHIFT AFTER CONFIRMATION PROCESSING");
	            //console.dir
	
	            _this12.reSortHired();
	            _this12.setConfirmationNumbers();
	            _this12.processWhoCanBePaid();
	
	            _this12.$timeout(function () {
	              _this12.unSetLoader();
	            }, 500);
	          });
	        });
	
	        _this12.enableToolTips();
	      });
	    }
	  }, {
	    key: "calculateJobblerScheduleManagementStatus",
	    value: function calculateJobblerScheduleManagementStatus(shift) {
	      var result = void 0;
	
	      if (shift) {
	        if (shift.confirmationResponse === true) {
	          result = "Confirmed";
	        } else if (shift.confirmationResponse === false) {
	          result = "Declined";
	        }
	
	        if (shift.leavingEarly === true) {
	          result = "Leaving " + shift.leavingEarlyTime + " mins early";
	        }
	
	        if (shift.stayingLate === true) {
	          result = "Staying late";
	        }
	
	        if (shift.runningLate === true) {
	          result = "Running " + shift.runningLateTime + " mins late";
	        }
	
	        if (shift.calledOut === true) {
	          result = "Called out";
	        }
	      } else {
	        result = "--";
	      }
	
	      return result;
	    }
	  }, {
	    key: "checkForUnconfirmedList",
	    value: function checkForUnconfirmedList() {
	      var unconfirmed = [];
	
	      try {
	        if (this.hiredApplicants) {
	          if (this.hiredApplicants.length > 0) {
	            /*
	                      this.hiredApplicants.forEach((a) => {
	                          let confirmResp = a.shiftData.confirmationResponse;
	                          let confirmExist = a.shiftData.confirmationResponseExists;
	                          if (confirmResp != true || confirmExist != true) {
	                              unconfirmed.push(s.id);
	                          }
	                      });
	                       */
	          }
	        } else {
	          this.unconfirmed = [];
	        }
	      } catch (err) {
	        console.log("error looping");
	        console.dir(err);
	      } finally {
	        if (unconfirmed.length > 0) {
	          this.hasShowMoreApplicants = true;
	        }
	      }
	    }
	  }, {
	    key: "formatCheckOutTime",
	    value: function formatCheckOutTime(checkOutTime, shift) {
	      var checkOut = moment(checkOutTime);
	      var time = void 0;
	      var remainder = void 0;
	
	      remainder = 15 - checkOut.minute() % 15;
	
	      if (remainder < 15) {
	        time = moment(checkOut).add(remainder, "minutes");
	      } else {
	        time = checkOut;
	      }
	
	      return time;
	    }
	  }, {
	    key: "formatCheckInTime",
	    value: function formatCheckInTime(checkInTime, shiftStartTime, shift) {
	      var checkIn = moment(checkInTime);
	      var startTime = moment(shiftStartTime);
	      var time = void 0;
	      var remainder = void 0;
	
	      if (checkIn.isBefore(startTime)) {
	        time = startTime;
	      } else {
	        remainder = 15 - checkIn.minute() % 15;
	        time = moment(checkIn).add(remainder, "minutes");
	      }
	
	      return time;
	    }
	  }, {
	    key: "enableToolTips",
	    value: function enableToolTips() {
	      this.$timeout(function () {
	        $(".link-tool-tip").tooltip({}); //.tooltip('dispose');
	        $(".payment-tool-tip").tooltip({}).tooltip("fixTitle");
	      }, 200);
	
	      this.$timeout(function () {
	        $(".bg-check-status-image").tooltip({});
	        $(".bg-check-status").tooltip({});
	        $(".application-reason").tooltip({});
	        $(".overlapp-msg").tooltip({});
	        $(".quit-reason").tooltip({});
	      }, 300);
	    }
	  }, {
	    key: "returnToolTip",
	    value: function returnToolTip(t) {
	      return t;
	    }
	  }, {
	    key: "returnToolTipAdv",
	    value: function returnToolTipAdv(applicant) {
	      var message = applicant.applicationErrors[0].errorText;
	
	      if (message.indexOf("jobbleapp.com") !== -1) {}
	
	      return "Why did this user not get hired for job? Because: " + applicant.applicationErrors[0].errorText;
	    }
	  }, {
	    key: "loadShiftConfirmationData",
	    value: function loadShiftConfirmationData(subEventId) {
	      var _this13 = this;
	
	      console.log("loadShiftConfirmationData");
	
	      this.$timeout(function () {
	        _this13.loadingShiftConfirmationData = true;
	      });
	
	      this.$events.getAcceptedApplicationsRosterManagement(subEventId).then(function (data) {
	        _this13.$timeout(function () {
	          _this13.loadingShiftConfirmationData = false;
	        });
	
	        var applicationData = data.data;
	        var payPerHourJobbler = _this13.event.subEvents[0].deduppedJobbles[0].jobblerRate;
	        //const payPerHour = this.event.subEvents[0].deduppedJobbles[0].payPerHour;
	        // const payPerHour = payPerHourJobbler / (1 - this.currentUser.company.defaultPlan.jobblerFeePct);
	        var payPerHour = payPerHourJobbler * (1 + _this13.currentUser.company.defaultPlan.companyFeePct);
	
	        applicationData.forEach(function (applicationDataObject) {
	          var applicant = applicationDataObject.applicant,
	              shifts = applicationDataObject.jobble.shifts;
	
	
	          var applicantId = applicant.id;
	
	          shifts.forEach(function (shift) {
	            console.log("shifts look");
	            console.dir(shift.id);
	
	            var confirmationResponse = shift.confirmationResponse || null;
	            var confirmationResponseExists = shift.confirmationResponse !== null;
	            var shiftPosition = shift.shiftPosition;
	            var jobblerNote = shift.jobblerNote;
	            var shiftId = shift.id || null;
	            var checkInTime = shift.checkInTime || null;
	            var checkOutTime = shift.checkOutTime || null;
	            var checkInTimeOnly = null;
	            var checkOutTimeOnly = null;
	
	            var shiftPaid = !!(shift.paymentStats && shift.paymentStats.amountRecievedByJobber);
	
	            var checkInTimeMoment = void 0;
	            var checkOutTimeMoment = void 0;
	            var payment = void 0;
	            var paymentJobbler = void 0;
	            var paymentJobblerNoFee = void 0;
	            var hoursRounded = null;
	            var momentET = null;
	            var momentST = null;
	            var totalMinutes = null;
	            var minutesMod = null;
	
	            if (checkInTime) {
	              checkInTimeMoment = moment(checkInTime);
	              checkInTime = checkInTimeMoment.format("MMM DD, h:mm a").toUpperCase();
	              checkInTimeOnly = checkInTimeMoment.format("h:mm A");
	            }
	
	            if (checkOutTime) {
	              checkOutTimeMoment = moment(checkOutTime);
	              checkOutTime = checkOutTimeMoment.format("MMM DD, h:mm a").toUpperCase();
	              checkOutTimeOnly = checkOutTimeMoment.format("h:mm A");
	            }
	
	            var _setApplicantStatus2 = _this13.setApplicantStatus(shift, shiftPaid, checkInTime, checkOutTime, confirmationResponse),
	                status = _setApplicantStatus2.status,
	                statusNumber = _setApplicantStatus2.statusNumber,
	                groupNumber = _setApplicantStatus2.groupNumber;
	
	            if (shift.actualMinutesWorked !== null) {
	              console.log("We have actualMinutes worked data");
	
	              totalMinutes = shift.actualMinutesWorked;
	            } else {
	              //console.log("no we have actualMinutes worked data");
	              //console.dir(shift);
	              momentET = moment(shift.timeInterval.endTime).tz("America/New_York");
	              momentST = moment(shift.timeInterval.startTime).tz("America/New_York");
	
	              totalMinutes = moment(momentET).diff(moment(momentST), "minutes");
	              shift.totalMinutes = totalMinutes;
	            }
	
	            hoursRounded = Math.floor(totalMinutes / 60);
	            minutesMod = totalMinutes % 60;
	
	            if (shift.paymentStats.amountRecievedByJobber === null) {
	              payment = (Math.round(totalMinutes * payPerHour / 100 / 60 * 100) / 100).toFixed(2);
	              paymentJobbler = (Math.round(totalMinutes * payPerHourJobbler / 100 / 60 * 100) / 100).toFixed(2);
	            } else {
	              //payment = (Math.round((shift.paymentStats.amountRecievedByJobber / 100) * 100) / 100).toFixed(2);
	              //paymentJobbler = (Math.round((shift.paymentStats.amountRecievedByJobber / 100) * 100) / 100).toFixed(2);
	              payment = (shift.paymentStats.amountCompany / 100).toFixed(2);
	              paymentJobbler = (shift.paymentStats.amountRecievedByJobber / 100).toFixed(2);
	
	              var a = shift.paymentStats.amountRecievedByJobber;
	              var h = a / _this13.event.subEvents[0].deduppedJobbles[0].payPerHour;
	              var a2 = h * payPerHourJobbler;
	              paymentJobblerNoFee = (Math.round(a2 / 100 * 100) / 100).toFixed(2);
	            }
	
	            console.log("user.payment", payment);
	            console.log("user.paymentJobbler", paymentJobbler);
	            console.dir(totalMinutes * payPerHour / 100 / 60);
	
	            shift.totalMinutes = totalMinutes;
	            shift.timeInterval.timeInHours = hoursRounded;
	            shift.timeInterval.timeInMinutes = minutesMod;
	
	            var paymentHours = Math.round(paymentJobbler / (_this13.event.subEvents[0].deduppedJobbles[0].payPerHour / 100) * 100) / 100;
	            var tooltip = void 0;
	            var ppr = Math.round(_this13.event.subEvents[0].deduppedJobbles[0].jobblerRate / 100).toFixed(2);
	
	            if (shift.paymentStats.number === 1) {
	              tooltip = "Paid $" + paymentJobbler + " at $" + ppr + "/hr";
	            } else if (shift.paymentStats.number > 1) {
	              tooltip = "This user was paid " + shift.paymentStats.number + " times for this shift for a total of $" + paymentJobbler;
	            } else {
	              tooltip = "This users payment is still processing";
	            }
	            //console.log("tooltip", tooltip);
	
	            _this13.$timeout(function () {
	              _this13.shiftConfirmationData = _this13.shiftConfirmationData || {};
	              _this13.shiftConfirmationData[shiftPosition] = _this13.shiftConfirmationData[shiftPosition] || {};
	              _this13.shiftConfirmationData[shiftPosition][applicantId] = {
	                shiftId: shiftId,
	                shiftPosition: shiftPosition,
	                paymentHours: paymentHours,
	                applicantId: applicantId,
	                checkInTime: checkInTime,
	                checkOutTime: checkOutTime,
	                checkInTimeOnly: checkInTimeOnly,
	                checkOutTimeOnly: checkOutTimeOnly,
	                checkInTimeMoment: checkInTimeMoment,
	                checkOutTimeMoment: checkOutTimeMoment,
	                confirmationResponse: confirmationResponse,
	                confirmationResponseExists: confirmationResponseExists,
	                jobblerNote: jobblerNote,
	                status: status,
	                tooltip: tooltip,
	                statusNumber: statusNumber,
	                groupNumber: groupNumber,
	                checkInCoord: shift.checkInCoord || shift.autoCheckInCoord,
	                checkOutCoord: shift.checkOutCoord || shift.autoCheckOutCoord,
	                actualMinutesWorked: shift.actualMinutesWorked,
	                noShow: shift.noShow,
	                paymentStats: shift.paymentStats,
	                shiftPaid: shiftPaid,
	                totalMinutes: totalMinutes,
	                timeInterval: shift.timeInterval,
	                payment: payment,
	                paymentJobbler: paymentJobbler,
	                paymentJobblerNoFee: paymentJobblerNoFee
	              };
	
	              _this13.reSortHired();
	              _this13.setConfirmationNumbers();
	              _this13.processWhoCanBePaid();
	            });
	          });
	        });
	
	        _this13.$timeout(function () {
	          _this13.initializeMap();
	          console.log("this.shiftConfirmationData", _this13.shiftConfirmationData);
	        }, 200);
	
	        _this13.enableToolTips();
	      });
	    }
	  }, {
	    key: "updateCheckInOutData",
	    value: function updateCheckInOutData(shiftPosition, applicantId, checkInTime, checkOutTime, rawMoment) {
	      var _this14 = this;
	
	      this.$timeout(function () {
	        _this14.shiftConfirmationData = _this14.shiftConfirmationData || {};
	        _this14.shiftConfirmationData[shiftPosition] = _this14.shiftConfirmationData[shiftPosition] || {};
	        _this14.shiftConfirmationData[shiftPosition][applicantId] = _this14.shiftConfirmationData[shiftPosition][applicantId] || {};
	
	        if (checkInTime) {
	          _this14.shiftConfirmationData[shiftPosition][applicantId].checkInTime = checkInTime;
	          _this14.shiftConfirmationData[shiftPosition][applicantId].checkInTimeOnly = rawMoment.format("h:mm A");
	          _this14.shiftConfirmationData[shiftPosition][applicantId].checkInTimeMoment = rawMoment;
	        }
	
	        if (checkOutTime) {
	          _this14.shiftConfirmationData[shiftPosition][applicantId].checkOutTime = checkOutTime;
	          _this14.shiftConfirmationData[shiftPosition][applicantId].checkOutTimeOnly = rawMoment.format("h:mm A");
	          _this14.shiftConfirmationData[shiftPosition][applicantId].checkOutTimeMoment = rawMoment;
	        }
	
	        var shiftPaid = _this14.shiftConfirmationData[shiftPosition][applicantId].shiftPaid;
	
	        var _setApplicantStatus3 = _this14.setApplicantStatus(_this14.shiftConfirmationData[shiftPosition][applicantId], shiftPaid, _this14.shiftConfirmationData[shiftPosition][applicantId].checkInTime, _this14.shiftConfirmationData[shiftPosition][applicantId].checkOutTime, _this14.shiftConfirmationData[shiftPosition][applicantId].confirmationResponse),
	            status = _setApplicantStatus3.status,
	            statusNumber = _setApplicantStatus3.statusNumber,
	            groupNumber = _setApplicantStatus3.groupNumber;
	
	        _this14.shiftConfirmationData[shiftPosition][applicantId].status = status;
	        _this14.shiftConfirmationData[shiftPosition][applicantId].statusNumber = statusNumber;
	        _this14.shiftConfirmationData[shiftPosition][applicantId].groupNumber = groupNumber;
	
	        console.log(_this14.shiftConfirmationData[shiftPosition][applicantId]);
	      });
	    }
	  }, {
	    key: "updateNoShowValue",
	    value: function updateNoShowValue(shiftPosition, applicantId, noShow, actualMinutesWorked) {
	      var _this15 = this;
	
	      this.$timeout(function () {
	        _this15.shiftConfirmationData = _this15.shiftConfirmationData || {};
	        _this15.shiftConfirmationData[shiftPosition] = _this15.shiftConfirmationData[shiftPosition] || {};
	        _this15.shiftConfirmationData[shiftPosition][applicantId] = _this15.shiftConfirmationData[shiftPosition][applicantId] || {};
	        _this15.shiftConfirmationData[shiftPosition][applicantId].noShow = noShow;
	
	        if (noShow) {
	          _this15.shiftConfirmationData[shiftPosition][applicantId].actualMinutesWorked = actualMinutesWorked;
	        }
	
	        var _shiftConfirmationDat = _this15.shiftConfirmationData[shiftPosition][applicantId],
	            shiftPaid = _shiftConfirmationDat.shiftPaid,
	            checkInTime = _shiftConfirmationDat.checkInTime,
	            checkOutTime = _shiftConfirmationDat.checkOutTime,
	            confirmationResponse = _shiftConfirmationDat.confirmationResponse;
	
	        var _setApplicantStatus4 = _this15.setApplicantStatus(_this15.shiftConfirmationData[shiftPosition][applicantId], shiftPaid, checkInTime, checkOutTime, confirmationResponse),
	            status = _setApplicantStatus4.status,
	            statusNumber = _setApplicantStatus4.statusNumber,
	            groupNumber = _setApplicantStatus4.groupNumber;
	
	        _this15.shiftConfirmationData[shiftPosition][applicantId].status = status;
	        _this15.shiftConfirmationData[shiftPosition][applicantId].statusNumber = statusNumber;
	        _this15.shiftConfirmationData[shiftPosition][applicantId].groupNumber = groupNumber;
	
	        _this15.processWhoCanBePaid();
	        _this15.reSortHired();
	      });
	    }
	  }, {
	    key: "uncheckPaymentInfo",
	    value: function uncheckPaymentInfo(card) {
	      this.paymentInfos.forEach(function (info) {
	        if (card && card.cardToken === info.cardToken) return;
	
	        info.isChecked = false;
	      });
	    }
	  }, {
	    key: "setCardToPayment",
	    value: function setCardToPayment(data) {
	      console.log("setCardToPayment");
	      console.dir(data);
	
	      var req = {};
	
	      this.uncheckPaymentInfo(data);
	
	      if (data.isChecked === true) {
	        data.isChecked = false;
	        req.card = null;
	        this.selectedCard = null;
	      } else {
	        data.isChecked = true;
	        if (!data.cardToken) {
	          req.bank = data.stripeId;
	          this.selectedCard = data.stripeId;
	        } else {
	          req.card = data.cardToken;
	          this.selectedCard = data.cardToken;
	        }
	      }
	
	      this.transferData = req;
	    }
	  }, {
	    key: "populateCardImage",
	    value: function populateCardImage(info) {
	      if (info.cardBrand === "American Express") {
	        info.image = "fa fa-cc-amex";
	      }
	      if (info.cardBrand === "Visa") {
	        info.image = "fa fa-cc-visa";
	      }
	      if (info.cardBrand === "Discover") {
	        info.image = "fa fa-cc-discover";
	      }
	      if (info.cardBrand === "MasterCard") {
	        info.image = "fa fa-cc-mastercard";
	      }
	
	      if (info.bankName) {
	        info.image = "fas fa-university";
	      }
	
	      return info.image;
	    }
	  }, {
	    key: "organizePaymentOptions",
	    value: function organizePaymentOptions(user) {
	      var _this16 = this;
	
	      var _this = this;
	
	      var paymentOptions = [];
	      var paymentOptionsUnverified = [];
	
	      if (this.currentUser.company.payByInvoice === true || this.currentUser.company.defaultPlan.requiresSubscription === true) {
	        this.paymentInfos = [];
	        this.unverifedPaymentInfos = [];
	        this.banks = [];
	        this.invoice = true;
	      } else {
	        this.invoice = false;
	
	        try {
	          if (user.company.undeletedPaymentInfos) {
	            user.company.undeletedPaymentInfos.forEach(function (info) {
	              info.image = _this16.populateCardImage(info);
	
	              if (info.bankName === null) {
	                console.log("here is the card... card: ", info);
	
	                paymentOptions.push(info);
	              } else {
	                console.log("here is the bank... bank: ", info);
	
	                if (info.validated === true) {
	                  info.cardBrand = info.bankName;
	                  paymentOptions.push(info);
	                } else {
	                  info.cardBrand = info.bankName;
	                  paymentOptionsUnverified.push(info);
	                }
	              }
	            });
	          }
	        } catch (err) {
	          console.error("SDD", err);
	        } finally {
	          console.log("this.paymentInfos after. this.paymentInfos:", paymentOptions);
	          console.log("this.paymentInfos after. this.paymentOptionsUnverified:", paymentOptionsUnverified);
	          _this.paymentInfos = paymentOptions;
	          _this.unverifedPaymentInfos = paymentOptionsUnverified;
	          console.log("this.paymentInfos after. this.paymentInfos:", _this.paymentInfos);
	        }
	      }
	    }
	  }, {
	    key: "sendAdditionalPayment",
	    value: function sendAdditionalPayment() {
	      var _this17 = this;
	
	      if (!(this.additionalPaymentAmountJobbler > 0.5 && this.atLeastOneReadyToAdditionalPayChecked && (!this.invoice && this.selectedCard || this.invoice))) return;
	
	      var transferArray = [];
	      var applicantArray = [];
	
	      if (this.submittingAdditionalPayment) return;
	
	      this.submittingAdditionalPayment = true;
	
	      this.$tracking.reportRosterPageSubmit("payment - submit additional payment");
	
	      jQuery("#modal-additional-payment .modal-header button.close").trigger("click");
	      jQuery("#modal-additional-payment-done").modal();
	
	      if (!this.invoice && (!this.transferData || !this.transferData.card || !this.transferData.bank)) {
	        alert("Please select a payment method");
	        return;
	      }
	
	      var transferData = this.transferData || {};
	
	      console.log("New additional data:", transferData);
	
	      try {
	        this.readyToAdditionalPaySelected.forEach(function (applicant) {
	          var shift = _this17.shiftConfirmationData[_this17.singleShiftViewShiftPosition][applicant.applicantId];
	
	          var data = {};
	          // let amount = Math.round(parseFloat(this.additionalPaymentAmount) * 100);
	          var amount = Math.round(parseFloat(_this17.additionalPaymentAmountJobbler) * 100);
	
	          data.recipient = applicant.applicantEmail;
	
	          data.amount = amount;
	
	          if (_this17.additionalPaymentMemo) {
	            data.note = "Additional Payment: " + _this17.additionalPaymentMemo;
	          } else {
	            data.note = "Additional Payment";
	          }
	
	          data.isAdditionalPayment = true;
	          data.shift = shift.shiftId;
	
	          if (!amount) return;
	
	          transferArray.push(data);
	          applicantArray.push({
	            applicant: applicant,
	            data: data
	          });
	        });
	      } finally {
	        console.log("what is the transfer for additional payment array: transferArray", transferArray);
	
	        transferData.transfers = transferArray;
	
	        console.log("final transfer data: transferData", transferData);
	
	        this.$tracking.reportRosterPageSubmit("payment - submit additional payment - " + transferArray.length);
	
	        this.postAdditionalPayment(transferData, applicantArray);
	      }
	    }
	  }, {
	    key: "sendPayment",
	    value: function sendPayment() {
	      var _this18 = this;
	
	      console.log("sendPayment");
	      console.dir(this.readyToPay.length);
	      console.dir(this.invoice);
	      console.dir(this.selectedCard);
	
	      if (!(this.readyToPay.length && !this.updatingHoursWorked && (!this.invoice && this.selectedCard || this.invoice))) return;
	
	      var transferArray = [];
	      var applicantArray = [];
	      var hoursUpdateList = [];
	
	      this.confirmAllHaveHours();
	
	      if (this.submittingPayment || !this.allHaveHours) return;
	
	      this.submittingPayment = true;
	
	      console.log("submit");
	
	      this.$tracking.reportRosterPageSubmit("payment - submit payment");
	
	      if (!this.invoice && (!this.transferData || !this.transferData.card || !this.transferData.bank)) {
	        alert("Please select a payment method");
	      }
	
	      var transferData = this.transferData || {};
	
	      console.log("new transget data:", transferData);
	
	      try {
	        this.readyToPay.forEach(function (applicant) {
	          var shift = _this18.shiftConfirmationData[_this18.singleShiftViewShiftPosition][applicant.applicantId];
	
	          if (shift.totalMinutes && !shift.actualMinutesWorked) {
	            console.warn("Need to update shift.actualMinutesWorked for shift id =", shift.shiftId);
	            hoursUpdateList.push(shift);
	            //this.updateHoursWorked(shift, true);
	          }
	
	          var data = {};
	          // let amount = Math.round(shift.payment * 100);
	          var amount = Math.round(shift.paymentJobbler * 100);
	
	          data.recipient = applicant.applicantEmail;
	
	          data.amount = amount;
	
	          data.note = "Payment";
	          data.shift = shift.shiftId;
	
	          if (!amount) return;
	
	          transferArray.push(data);
	          applicantArray.push({
	            applicant: applicant,
	            data: data
	          });
	        });
	      } finally {
	        console.log("what is the transfer array: transferArray", transferArray);
	
	        this.transferArray = transferArray;
	
	        transferData.transfers = transferArray;
	
	        console.log("final transfer data: transferData", transferData);
	
	        this.$tracking.reportRosterPageSubmit("payment - submit payment - " + transferArray.length);
	
	        this.postPayment(transferData, applicantArray, null, hoursUpdateList);
	      }
	    }
	  }, {
	    key: "sendRejectionPayment",
	    value: function sendRejectionPayment() {
	      var _this19 = this;
	
	      if (!(!this.invoice && this.selectedCard || this.invoice)) return;
	
	      var transferArray = [];
	      var applicantArray = [];
	
	      this.confirmAllRejectionsHaveHours();
	
	      if (this.submittingPayment || !this.allRejectionsHaveHours) return;
	
	      this.submittingPayment = true;
	
	      console.log("submitting rejection payment");
	
	      this.$tracking.reportRosterPageSubmit("payment - submit payment");
	
	      if (!this.invoice && (!this.transferData || !this.transferData.card || !this.transferData.bank)) {
	        alert("Please select a payment method");
	      }
	
	      var transferData = this.transferData || {};
	
	      console.log("new transfer data:", transferData);
	
	      try {
	        this.paymentContingenciesShiftPositions.forEach(function (shiftPosition) {
	          _this19.paymentContingenciesMap[shiftPosition].forEach(function (applicant) {
	            var shift = _this19.shiftConfirmationData[shiftPosition][applicant.applicantId];
	
	            var data = {};
	            var amount = Math.round(shift.paymentJobbler * 100);
	
	            data.recipient = applicant.applicantEmail;
	
	            data.amount = amount;
	
	            data.note = "Payment";
	            data.shift = shift.shiftId;
	
	            if (!amount) return;
	
	            transferArray.push(data);
	            applicantArray.push({
	              applicant: applicant,
	              data: data,
	              shiftPosition: shiftPosition
	            });
	          });
	        });
	      } finally {
	        console.log("what is the transfer array: transferArray", transferArray);
	
	        this.transferArray = transferArray;
	
	        transferData.transfers = transferArray;
	
	        console.log("final transfer data: transferData", transferData);
	
	        this.$tracking.reportRosterPageSubmit("payment - submit payment - " + transferArray.length);
	
	        this.postPayment(transferData, applicantArray, true);
	      }
	    }
	  }, {
	    key: "postPayment",
	    value: function postPayment(transferData, applicantArray, rejectionFlow, hoursUpdateList) {
	      var _this20 = this;
	
	      // this.$timeout(() => { this.loadingShiftConfirmationData = true; });
	
	      this.$events.payUsersByShift(transferData).then(function (response) {
	        _this20.submittingPayment = false;
	
	        if (rejectionFlow) {
	          jQuery("#modal-rejection-shift-payment .modal-header button.close").trigger("click");
	          _this20.$timeout(function () {
	            jQuery("#modal-rejection-confirm").modal({
	              backdrop: true
	            });
	          }, 100);
	        } else {
	          jQuery("#modal-shift-payment .modal-header button.close").trigger("click");
	          jQuery("#modal-shift-payment-done").modal();
	        }
	
	        console.log("response from payUsersByShift", response);
	
	        if (response.data && response.data.status && response.data.status === "error" || response.data[0].status === "error") {
	          _this20.paymentError = true;
	          if (response.data[0]) {
	            if (response.data[0].message) {
	              _this20.paymentErrorText = response.data[0].message;
	            }
	          } else {
	            _this20.paymentErrorText = response.data.message;
	          }
	        } else {
	          _this20.paymentError = false;
	
	          _this20.findUsersInTransferAndUpdateUI(applicantArray, rejectionFlow);
	          _this20.reSortHired(true, true);
	
	          _this20.$timeout(function () {
	            _this20.processWhoCanBePaid();
	          });
	        }
	
	        _this20.transferData = {};
	        _this20.paymentList = [];
	
	        _this20.totalPayment = 0;
	        _this20.totalMinutesWorkedForEntireJob = 0;
	        _this20.additionalMonies = 0;
	        _this20.postPaymentAddHours(hoursUpdateList);
	        _this20.totalPaymentDisplay = 0;
	      }, function (error) {
	        if (rejectionFlow) {
	          jQuery("#modal-rejection-shift-payment .modal-header button.close").trigger("click");
	          _this20.$timeout(function () {
	            jQuery("#modal-rejection-confirm").modal({
	              backdrop: true
	            });
	          }, 100);
	        } else {
	          jQuery("#modal-shift-payment .modal-header button.close").trigger("click");
	        }
	
	        _this20.submittingPayment = false;
	
	        console.log("what is the error");
	        console.dir(error);
	
	        if (error.status === 500) {
	          alert("Our payment system is currently down. No payment was processed. Please contact an admin.");
	        } else {
	          alert("There was a problem with our payment service. Please contact support.");
	        }
	      });
	    }
	  }, {
	    key: "postPaymentAddHours",
	    value: function postPaymentAddHours(hoursUpdateList) {
	      var _this21 = this;
	
	      if (hoursUpdateList && hoursUpdateList.length > 0) {
	        this.$timeout(function () {
	          hoursUpdateList.forEach(function (shift) {
	            _this21.updateHoursWorked(shift, true);
	          });
	        }, 2000);
	      }
	    }
	  }, {
	    key: "postAdditionalPayment",
	    value: function postAdditionalPayment(transferData, applicantArray) {
	      var _this22 = this;
	
	      this.$events.payUsersByShift(transferData).then(function (response) {
	        _this22.submittingAdditionalPayment = false;
	        _this22.additionalPaymentMemo = "";
	        console.log("response from payUsersByShift", response);
	
	        _this22.transferData = {};
	
	        _this22.additionalPaymentAmount = 0;
	        _this22.additionalPaymentAmountJobbler = 0;
	      }, function (error) {
	        _this22.submittingAdditionalPayment = false;
	        _this22.additionalPaymentMemo = "";
	
	        console.log("what is the error");
	        console.dir(error);
	
	        console.log("transfer error, error:", error);
	        alert("Error : " + error);
	      });
	    }
	  }, {
	    key: "findUsersInTransferAndUpdateUI",
	    value: function findUsersInTransferAndUpdateUI(applicants, rejectionFlow) {
	      var _this23 = this;
	
	      applicants.forEach(function (obj) {
	        var data = obj.data,
	            applicant = obj.applicant,
	            shiftPosition = obj.shiftPosition;
	
	        var realShiftPosition = rejectionFlow ? shiftPosition : _this23.singleShiftViewShiftPosition;
	        var shift = _this23.shiftConfirmationData[realShiftPosition][applicant.applicantId];
	
	        shift.status = "Paid";
	        shift.statusNumber = 4;
	        shift.paymentStats = data;
	        shift.shiftPaid = true;
	
	        _this23.shiftConfirmationData[realShiftPosition][applicant.applicantId] = shift;
	      });
	    }
	  }, {
	    key: "loadAllApplicants",
	    value: function loadAllApplicants(jobblePoolId, loading, eventResp, subEventId) {
	      var _this24 = this;
	
	      this.lastJobQuery = this.jobQuery + "";
	
	      if (loading) {
	        this.setLoader();
	      }
	
	      this.$events.getAllApplicants(jobblePoolId, 20, 0, this.sortField, this.sortOrder, this.jobQuery).then(function (allApplications) {
	        if (loading) {
	          _this24.$timeout(function () {
	            _this24.initialLoadingApplicants = false;
	            console.log("DONE LOADING APPS");
	          });
	        }
	
	        console.log("allApplications");
	        console.dir(allApplications);
	
	        _this24.allApplicantsDoneLoading = true;
	
	        if (allApplications.data.applicants.length !== 0) {
	          var applications = [];
	
	          if (allApplications.data.status === "error") {
	            alert("Error loading all Applications.");
	          } else {
	            try {
	              applications = allApplications.data.applicants.map(function (application, i) {
	                application.applicant = application;
	                application.whyWasJobblerRemovedFromJob = _this24.processRejectionReason(application.applicant.applicationStatusReasons);
	                application.humanReadableStatus = _this24.setStatus(application.applicationStatus);
	                application.humanReadableQuitReason = _this24.formatQuitReason(application.applicant.quitReason);
	                application.hasBeenSelected = false;
	                application.isHireSelected = false;
	                application.isHireSelectedLast = false;
	                application.renderPhoto = application.applicant.filePROFILE_IMAGE1IMG_75x75;
	                application.renderPhotoThumb = application.applicant.filePROFILE_IMAGE1IMG_75x75;
	                application = _this24.setJobblerRatingNew(application);
	                application = _this24.getPaymentInfoPendingNew(application);
	                application = _this24.fixApplicantPhoneNew(application);
	                application = _this24.fixApplicantNameNew(application);
	                return application;
	              });
	            } catch (err) {
	              console.log("error looping applicants");
	              console.log(err);
	            } finally {
	              _this24.busy = false;
	              var len = allApplications.data.length;
	              //this.setLoader();
	              if (len === 20) {} else {
	                _this24.busy = false;
	                _this24.pendingApplicants = applications;
	                _this24.allApplicants = applications;
	                _this24.hiredApplicants = _this24.filterHired(applications);
	                _this24.removedApplicants = _this24.filterRemoved(applications);
	                _this24.hiredApplicants = _this24.sortHired(_this24.hiredApplicants);
	                _this24.setCounts(applications);
	                _this24.setConfirmationNumbers();
	                _this24.prepareAllApplicantsCSV(applications);
	                _this24.checkForOverLaps();
	                _this24.checkForAtleastOneCheckedApplicant();
	                _this24.processShifts(eventResp);
	              }
	            }
	          }
	        } else {
	          _this24.pendingApplicants = [];
	          _this24.allApplicants = [];
	          _this24.hiredApplicants = [];
	          _this24.processShifts(eventResp);
	          _this24.$timeout(function () {
	            _this24.unSetLoader();
	          }, 5000);
	        }
	      }, function (data) {
	        _this24.allApplicantsDoneLoading = true;
	
	        if (loading) {
	          _this24.remain_loading_count--;
	        }
	
	        _this24.pendingApplicants = [];
	        _this24.allApplicants = [];
	        _this24.hiredApplicants = [];
	        _this24.busy = false;
	        _this24.unSetLoader();
	      });
	    }
	  }, {
	    key: "formatQuitReason",
	    value: function formatQuitReason(quitReason) {
	      var result = void 0;
	
	      if (quitReason) {
	        result = QUIT_REASONS.find(function (o) {
	          return o.name === quitReason;
	        });
	        if (result) {
	          result = result.description;
	        }
	      } else {
	        //result = "Work was a bad fit.";
	      }
	
	      return result;
	    }
	  }, {
	    key: "processRejectionReason",
	    value: function processRejectionReason(rejectionReason) {
	      var result = void 0;
	
	      if (rejectionReason.length > 0) {
	        rejectionReason.forEach(function (reason, index) {
	          //console.log("each reason");
	          //console.dir(reason);
	          if (index === 0) {
	            if (reason[0] === "MANAGER_REJECTED") {
	              result = "This user was manually removed from the job after they were hired by an account manager.";
	            } else if (reason[0] === "AUTO_REJECTED") {
	              result = "This user was automatically removed after they were hired for failure to comply with our Confirmation, Checkin and Checkout requirements.";
	            } else if (reason[0] === "AUTO_REJECTED_PRE_HIRE") {
	              result = "This user was automatically removed before they were hired for failure to comply with our Confirmation, Checkin and Checkout requirements.";
	            } else if (reason[0] === "MANAGER_REJECTED_PRE_HIRE") {
	              result = "This user was manually removed from the job before they were hired by an account manager.";
	            } else {
	              result = "The reason is unknown. Please contact support.";
	            }
	          }
	        });
	      } else {
	        result = "The reason is unknown. Please contact support.";
	      }
	
	      return result;
	    }
	  }, {
	    key: "setTabFilter",
	    value: function setTabFilter(status) {
	      var _this25 = this;
	
	      console.log("setTabFilter");
	      console.dir(status);
	
	      if (this.statusNumbers[status] === 0) return;
	
	      this.tabFilter = status;
	      this.checkOrUncheckAll(false);
	
	      if (this.tabFilter === 1) {
	        this.reSortHired(true);
	        this.$timeout(function () {
	          _this25.initializeMap();
	        });
	      }
	
	      if (this.tabFilter === 2) {
	        this.enableToolTips();
	      }
	
	      if (this.tabFilter === 3) {
	        this.enableToolTips();
	      }
	
	      if (this.tabFilter === 4) {
	        this.enableToolTips();
	      }
	
	      this.activateDropdownCSS();
	    }
	  }, {
	    key: "activateDropdownCSS",
	    value: function activateDropdownCSS() {
	      $(".checkbox-menu").on("change", "input[type='checkbox']", function () {
	        $(this).closest("li").toggleClass("active", this.checked);
	      });
	
	      $(document).on("click", ".allow-focus", function (e) {
	        e.stopPropagation();
	      });
	    }
	  }, {
	    key: "setCounts",
	    value: function setCounts(applications) {
	      var _this26 = this;
	
	      this.statusNumbers = {
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0
	      };
	
	      if (!applications || !applications.length) return;
	
	      applications.forEach(function (application) {
	        var status = application.applicationStatusRoster.id;
	        _this26.statusNumbers[status] = _this26.statusNumbers[status] + 1;
	      });
	
	      if (this.statusNumbers[this.tabFilter] === 0) {
	        if (this.statusNumbers[1] !== 0) {
	          this.tabFilter = 1;
	          this.reSortHired(true);
	          this.$timeout(function () {
	            _this26.initializeMap();
	          });
	          this.$timeout(function () {
	            _this26.activateDropdownCSS();
	          });
	        } else if (this.statusNumbers[3] !== 0) {
	          this.tabFilter = 3;
	        } else if (this.statusNumbers[2] !== 0) {
	          this.tabFilter = 2;
	        } else if (this.statusNumbers[4] !== 0) {
	          this.tabFilter = 4;
	        } else if (this.statusNumbers[5] !== 0) {
	          this.tabFilter = 5;
	        } else if (this.statusNumbers[7] !== 0) {
	          this.tabFilter = 7;
	        } else {
	          this.tabFilter = 3;
	        }
	      }
	    }
	  }, {
	    key: "filterHired",
	    value: function filterHired(applications) {
	      return _.filter(applications, function (application) {
	        //return application.applicationStatus === 1;
	        return application.applicationStatusRoster.id === 1;
	      });
	    }
	  }, {
	    key: "filterRemoved",
	    value: function filterRemoved(applications) {
	      return _.filter(applications, function (application) {
	        //return application.applicationStatus === 1;
	        return application.applicationStatusRoster.id === 4;
	      });
	    }
	  }, {
	    key: "reSortHired",
	    value: function reSortHired(force, map) {
	      if (force && !map) {
	        this.sortOrder = "asc";
	        this.sortField = "confirmation";
	      }
	
	      if (force && map) {
	        this.sortOrder = "asc";
	        this.sortField = "status-number";
	      }
	
	      this.hiredApplicants = this.sortHired(this.hiredApplicants);
	
	      this.enableToolTips();
	    }
	  }, {
	    key: "bulkChangeShiftNoShowValue",
	    value: function bulkChangeShiftNoShowValue(value) {
	      var _this27 = this;
	
	      var applicants = [];
	
	      this.hiredApplicants.forEach(function (applicant) {
	        if (applicant.isChecked) {
	          applicants.push(applicant);
	        }
	      });
	
	      if (value) {
	        this.$tracking.reportRosterPageSubmit("bulk mark as no show");
	      } else {
	        this.$tracking.reportRosterPageSubmit("bulk unmark as no show");
	      }
	
	      if (!applicants.length) {
	        this.checkOrUncheckAll(false);
	        return;
	      }
	
	      _async2.default.mapSeries(applicants, function (applicant, cb) {
	        var shift = _this27.shiftConfirmationData[_this27.singleShiftViewShiftPosition][applicant.applicantId];
	        _this27.changeShiftNoShowValue(shift, value, cb);
	      }, function (err) {
	        _this27.checkOrUncheckAll(false, true);
	      });
	    }
	  }, {
	    key: "changeShiftNoShowValue",
	    value: function changeShiftNoShowValue(shift, value, cb) {
	      var _this28 = this;
	
	      //console.log("shift no", shift);
	
	      var shiftId = shift.shiftId;
	
	
	      this.$timeout(function () {
	        _this28.setLoader();
	      });
	
	      if (value) {
	        this.$tracking.reportRosterPageSubmit("mark as no show");
	      } else {
	        this.$tracking.reportRosterPageSubmit("unmark as no show");
	      }
	
	      this.$events.markUserAsNowShowForShiftNew(shiftId, value).then(function (response) {
	        console.log("response");
	        console.dir(response);
	
	        _this28.$timeout(function () {
	          _this28.unSetLoader();
	          _this28.checkOrUncheckAll(false);
	        });
	
	        _this28.updateNoShowValue(shift.shiftPosition, shift.applicantId, value, value ? 0 : null);
	
	        if (cb) cb(null);
	      }, function (error) {
	        console.log("in error");
	        console.dir(error);
	
	        _this28.$timeout(function () {
	          _this28.unSetLoader();
	          _this28.checkOrUncheckAll(false);
	        });
	
	        if (cb) cb(null);
	      });
	    }
	  }, {
	    key: "sortHired",
	    value: function sortHired(applications) {
	      var _this29 = this;
	
	      if (applications.length === 0) {
	        this.unSetLoader();
	      }
	
	      if (!applications || !applications.length) return applications;
	
	      if (this.sortField === "confirmation" && this.shiftConfirmationData && this.shiftConfirmationData[this.singleShiftViewShiftPosition]) {
	        var newHired = applications.sort(function (a, b) {
	          var responseA = _this29.shiftConfirmationData[_this29.singleShiftViewShiftPosition][a.applicantId]; //.confirmationResponse
	          var responseB = _this29.shiftConfirmationData[_this29.singleShiftViewShiftPosition][b.applicantId]; //.confirmationResponse
	
	          var nameA = (responseA && responseA.confirmationResponseExists ? responseA.confirmationResponse ? 0 : 2 : 1) + a.applicantLastName;
	          var nameB = (responseB && responseB.confirmationResponseExists ? responseB.confirmationResponse ? 0 : 2 : 1) + b.applicantLastName;
	
	          var response = 0;
	          if (nameA < nameB) response = -1;
	          if (nameA > nameB) response = 1;
	
	          if (_this29.sortOrder === "desc") response = response * -1;
	
	          return response;
	        });
	
	        return newHired;
	      } else if (this.sortField === "check-in" && this.shiftConfirmationData && this.shiftConfirmationData[this.singleShiftViewShiftPosition]) {
	        var _newHired = applications.sort(function (a, b) {
	          var responseA = _this29.shiftConfirmationData[_this29.singleShiftViewShiftPosition][a.applicantId]; //.confirmationResponse
	          var responseB = _this29.shiftConfirmationData[_this29.singleShiftViewShiftPosition][b.applicantId]; //.confirmationResponse
	
	          var checkInTimeA = (responseA.checkInTime ? moment(responseA.checkInTime) : moment("10/10/9999")).valueOf();
	          var checkInTimeB = (responseB.checkInTime ? moment(responseB.checkInTime) : moment("10/10/9999")).valueOf();
	
	          var response = 0;
	          if (checkInTimeA < checkInTimeB) response = -1;
	          if (checkInTimeA > checkInTimeB) response = 1;
	
	          if (_this29.sortOrder === "desc") response = response * -1;
	
	          return response;
	        });
	
	        return _newHired;
	      } else if (this.sortField === "check-out" && this.shiftConfirmationData && this.shiftConfirmationData[this.singleShiftViewShiftPosition]) {
	        var _newHired2 = applications.sort(function (a, b) {
	          var responseA = _this29.shiftConfirmationData[_this29.singleShiftViewShiftPosition][a.applicantId];
	          var responseB = _this29.shiftConfirmationData[_this29.singleShiftViewShiftPosition][b.applicantId];
	
	          var checkOutTimeA = (responseA.checkOutTime ? moment(responseA.checkOutTime) : moment("10/10/9999")).valueOf();
	          var checkOutTimeB = (responseB.checkOutTime ? moment(responseB.checkOutTime) : moment("10/10/9999")).valueOf();
	
	          var response = 0;
	          if (checkOutTimeA < checkOutTimeB) response = -1;
	          if (checkOutTimeA > checkOutTimeB) response = 1;
	
	          if (_this29.sortOrder === "desc") response = response * -1;
	
	          return response;
	        });
	
	        return _newHired2;
	      } else if (this.sortField === "status-number" && this.shiftConfirmationData && this.shiftConfirmationData[this.singleShiftViewShiftPosition]) {
	        var _newHired3 = applications.sort(function (a, b) {
	          var responseA = _this29.shiftConfirmationData[_this29.singleShiftViewShiftPosition][a.applicantId];
	          var responseB = _this29.shiftConfirmationData[_this29.singleShiftViewShiftPosition][b.applicantId];
	
	          responseA = responseA ? responseA.statusNumber : 999;
	          responseB = responseB ? responseB.statusNumber : 999;
	
	          var response = 0;
	          if (responseA < responseB) response = -1;
	          if (responseA > responseB) response = 1;
	
	          if (_this29.sortOrder === "desc") response = response * -1;
	
	          return response;
	        });
	
	        return _newHired3;
	      } else {
	        return applications;
	      }
	    }
	  }, {
	    key: "filterByStatus",
	    value: function filterByStatus(applications, status) {
	      return _.filter(applications, function (application) {
	        return application.applicationStatus === status;
	      });
	    }
	  }, {
	    key: "closeActionMenu",
	    value: function closeActionMenu(index) {
	      var i = index + 1;
	
	      this.$timeout(function () {
	        $("table.jobble-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").hide();
	        $("table.jobble-table tbody tr:nth-child(" + i + ") td").removeClass("row-focus");
	      }, 150);
	    }
	  }, {
	    key: "paginate",
	    value: function paginate(pageNumber, list) {
	      this.currentPageNumber = pageNumber;
	      var _this = this;
	      if (list === "pending") {
	        _this.pendingApplicants = [];
	        var offset = pageNumber * 12 - 12;
	        _this.remain_loading_count++;
	        _this.$events.getPendingApplications(_this.event.subEvents[0].id, 12, offset).then(function (pendingApplications) {
	          pendingApplications.data.forEach(function (pendingApplication) {
	            if (_this.approvedApplicants.length > 0) {
	              _this.approvedApplicants.forEach(function (approvedApplicant) {
	                if (approvedApplicant.applicant.id === pendingApplication.applicant.id) {
	                  pendingApplication.isHireSelected = true;
	                }
	              });
	            }
	            pendingApplication.hasBeenSelected = false;
	            pendingApplication.renderPhoto = pendingApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
	            pendingApplication.renderPhotoThumb = pendingApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
	            _this.setJobblerRatingPending(pendingApplication);
	          });
	          for (var i = _this.pendingApplicants.length - 1; i >= 0; i--) {
	            if (_this.pendingApplicants[i].isHireSelected) {
	              _this.pendingApplicants[i].isHireSelectedLast = true;
	              break;
	            }
	          }
	          _this.remain_loading_count--;
	        }, function (data) {
	          _this.remain_loading_count--;
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	        });
	      } else {
	        var offset = pageNumber * 10 - 10;
	        _this.acceptedApplicants = [];
	        _this.remain_loading_count++;
	        _this.$events.getAcceptedApplications(_this.event.subEvents[0].id, 10, offset).then(function (acceptedApplications) {
	          if (acceptedApplications.data.length !== 0) {
	            acceptedApplications.data.forEach(function (acceptedApplication) {
	              acceptedApplication.renderPhoto = acceptedApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
	              acceptedApplication.renderPhotoBig = acceptedApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
	              acceptedApplication.renderPhotoThumb = acceptedApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
	              if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 0) {
	                acceptedApplication.applicant.displayRating = 1;
	              }
	              if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 1) {
	                acceptedApplication.applicant.displayRating = 1;
	              }
	              if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 2) {
	                acceptedApplication.applicant.displayRating = 2;
	              }
	              if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 3) {
	                acceptedApplication.applicant.displayRating = 3;
	              }
	              if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 4) {
	                acceptedApplication.applicant.displayRating = 4;
	              }
	              if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 5) {
	                //console.log('THIS SHOULD SHOW');
	                acceptedApplication.applicant.displayRating = 5;
	              }
	              _this.noOneAcceptedYet = false;
	              _this.acceptedApplicants.push(acceptedApplication);
	              _this.combineApplicants();
	            });
	          }
	          _this.remain_loading_count--;
	        }, function (data) {
	          _this.remain_loading_count--;
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	        });
	      }
	    }
	  }, {
	    key: "combineApplicants",
	    value: function combineApplicants() {
	      this.allApplicants = _.concat(this.pendingApplicants, this.acceptedApplicants);
	    }
	  }, {
	    key: "mapProfileForReject",
	    value: function mapProfileForReject(data) {
	      var _this = this;
	
	      console.log("mapping profile");
	      console.dir(data);
	
	      var a = {};
	
	      a.applicant = {};
	      a.jobble = {};
	      a.applicant.homeContactInfo = {};
	      a.applicant.username = data.email;
	      a.applicant.homeContactInfo.phoneMobile = data.number;
	      a.applicant.id = data.jobblerId;
	      a.applicant.displayRating = data.average;
	      a.applicant.numberOfCompletedJobbles = data.completed;
	      a.applicant.firstName = data.firstName;
	      a.applicant.isVerified = true;
	      a.applicant.lastName = data.lastName;
	      a.jobble.id = data.jobbleId;
	
	      console.log("mapProfileForReject");
	      console.dir(a);
	
	      return a;
	    }
	  }, {
	    key: "confirmRemoveJobbler",
	    value: function confirmRemoveJobbler(type, data) {
	      var _this = this;
	      _this.remain_loading_count++;
	
	      console.log("confirmRemoveJobbler");
	      console.dir(type);
	      console.dir(data);
	      console.dir(_this.applicantStatus);
	
	      if (_this.applicantStatus === 2 || data) {
	        console.log("confirmRemoveJobbler");
	        console.dir(type);
	        console.dir(data);
	        if (data) {
	          _this.applicationForReject = _this.mapProfileForReject(data);
	          console.log("_this.applicationForReject");
	          console.dir(_this.applicationForReject);
	        }
	        var rejectJobblerReq = {
	          method: "POST",
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.applicationForReject.applicant.id + "/jobbles/" + _this.applicationForReject.jobble.id + "/reject?format=json&conf=web",
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + _this.currentUser.access_token
	          },
	          data: {}
	        };
	        _this.$http(rejectJobblerReq).then(function (response) {
	          _this.remain_loading_count--;
	          if (response.data.status === "error") {
	            _this.applicationForReject = null;
	            alert("Error: " + response.data.message);
	          } else {
	            for (var i = _this.pendingApplicants.length - 1; i >= 0; i--) {
	              if (_this.pendingApplicants[i].applicant.id === _this.applicationForReject.applicant.id) {
	                _this.setRejectedApplicantToDirective(_this.applicationForReject);
	                _this.pendingApplicants.splice(i, 1);
	                _this.event.numberOfPendingApplications = _this.event.numberOfPendingApplications - 1;
	                _this.applicationForReject = null;
	                break;
	              }
	            }
	          }
	          if (!data) {
	            _this.$timeout(function () {
	              jQuery("#modal-fire-jobbler-new").modal("toggle");
	            }, 100);
	          } else {
	            _this.$timeout(function () {
	              jQuery("#modal-view-jobble").modal("toggle");
	            }, 100);
	          }
	        });
	      } else {
	        console.log("we are in the else");
	        console.dir(_this.applicationForReject);
	
	        if (_this.applicationForReject) {
	          _this.selectedApplicant = _this.applicationForReject;
	        }
	
	        var rejectJobblerReq = {
	          method: "POST",
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.selectedApplicant.applicant.id + "/jobbles/" + _this.selectedApplicant.jobble.id + "/reject?format=json&conf=web",
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + _this.currentUser.access_token
	          },
	          data: {}
	        };
	
	        _this.$http(rejectJobblerReq).then(function (response) {
	          _this.remain_loading_count--;
	          _this.$timeout(function () {
	            jQuery("#modal-fire-jobbler-new").modal("toggle");
	          });
	
	          if (response.data.status === "error") {
	            _this.applicationForReject = null;
	            _this.selectedApplicant = null;
	            _this.$timeout(function () {
	              alert("Error : " + response.data.message);
	            }, 300);
	          } else {
	            for (var i = _this.acceptedApplicants.length - 1; i >= 0; i--) {
	              if (_this.acceptedApplicants[i].applicant.id === _this.selectedApplicant.applicant.id) {
	                _this.setRejectedApplicantToDirective(_this.selectedApplicant);
	                _this.acceptedApplicants.splice(i, 1);
	                _this.selectedApplicant = null;
	                _this.event.numberOfApprovedApplications = _this.event.numberOfApprovedApplications - 1;
	                _this.event.numberOfOpenings = _this.event.numberOfOpenings + 1;
	                break;
	              }
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: "rejectApplicant",
	    value: function rejectApplicant(pendingApplicant) {
	      var _this = this;
	      _this.applicationForReject = pendingApplicant;
	      _this.$timeout(function () {
	        jQuery("#modal-fire-link-clicker").trigger("click");
	      });
	    }
	  }, {
	    key: "removeHireApplicant",
	    value: function removeHireApplicant(pendingApplicant) {
	      console.log("removeHireApplicant");
	      console.dir(pendingApplicant);
	
	      if (pendingApplicant.isChecked) {
	        console.log("does he pass this...");
	        pendingApplicant.isHireSelected = false;
	        pendingApplicant.isHiredClass = "";
	        this.showAppWarning = false;
	        pendingApplicant.isChecked = false;
	        /*
	              if (pendingApplicant.hasPaymentProblem) {
	                  pendingApplicant.showPayInfoWarning = true;
	              }
	               */
	        var index = -1;
	
	        for (var i = this.allApplicants.length - 1; i >= 0; i--) {
	          if (this.allApplicants[i].id == pendingApplicant.id) {
	            index = i;
	            break;
	          }
	        }
	        if (index != -1) {
	          this.allApplicants.splice(index, 1);
	        }
	      }
	    }
	  }, {
	    key: "acceptHireApplicant",
	    value: function acceptHireApplicant(pendingApplicant) {
	      if (!pendingApplicant.isHireSelected) {
	        var totalApprovedCount = this.approvedApplicants.length;
	        if (totalApprovedCount >= this.event.numberOfOpenings) {
	          return;
	        }
	        pendingApplicant.isHireSelected = true;
	        pendingApplicant.isHiredClass = "green-accept";
	        var selectedHireApplicant = 0;
	        this.approvedApplicants.push(pendingApplicant);
	      }
	    }
	  }, {
	    key: "goToMessages",
	    value: function goToMessages(applicantId) {}
	  }, {
	    key: "toggleConfirmScreen",
	    value: function toggleConfirmScreen(pendingApplicant) {
	      var _this = this;
	      _this.approvedApplicants = [];
	      _this.approvedApplicants.push(pendingApplicant);
	    }
	  }, {
	    key: "hireAll",
	    value: function hireAll() {
	      var _this = this;
	
	      _this.pendingApplicants.forEach(function (pendingApplicant) {
	        if (pendingApplicant.showPayInfoWarning) {
	          pendingApplicant.showPayInfoWarning = false;
	        }
	        pendingApplicant.isHiredClass = "green-accept";
	        pendingApplicant.isHireSelected = !pendingApplicant.isHireSelected;
	        _this.approvedApplicants.push(pendingApplicant);
	      });
	    }
	  }, {
	    key: "toggleHireApplicant",
	    value: function toggleHireApplicant(pendingApplicant) {
	      var _this = this;
	
	      if (_this.currentUser.company.undeletedPaymentInfos.length === 0 && _this.currentUser.company.payByInvoice !== true) {
	        alert("Please go to your account settings and enter a payment method. " + "You cannot hire until you have entered some form of payment method.");
	        return;
	      }
	
	      if (this.approvedApplicants.length === this.event.numberOfOpenings) {
	        $("#reached-openings-limit").modal();
	        return;
	      }
	
	      if (pendingApplicant.showPayInfoWarning) {
	        pendingApplicant.hasPaymentProblem = true;
	      }
	
	      var selectedHireApplicant = 0;
	
	      pendingApplicant.isHiredClass = "green-accept";
	      pendingApplicant.isHireSelected = !pendingApplicant.isHireSelected;
	
	      var index = -1;
	
	      if (pendingApplicant.isHireSelected) {
	        console.log("we get pushed into here");
	        this.approvedApplicants.push(pendingApplicant);
	      } else {
	        for (var i = this.approvedApplicants.length - 1; i >= 0; i--) {
	          if (this.approvedApplicants[i].id == pendingApplicant.id) {
	            this.approvedApplicants[i].isHiredClass = "";
	            index = i;
	            break;
	          }
	        }
	        if (index != -1) this.approvedApplicants.splice(index, 1);
	      }
	      this.pendingApplicants.forEach(function (applicant) {
	        applicant.isHireSelectedLast = false;
	        if (applicant.isHireSelected) {
	          selectedHireApplicant++;
	        }
	      });
	      this.selectedHireApplicant = selectedHireApplicant;
	    }
	  }, {
	    key: "setModalViewJobble",
	    value: function setModalViewJobble() {
	      this.applicant_name = "Scarlett Jr.";
	    }
	  }, {
	    key: "formatPhoneNumber",
	    value: function formatPhoneNumber(phoneNumberString) {
	      console.log("formatPhoneNumber");
	      console.dir(phoneNumberString);
	
	      var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
	
	      var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
	
	      if (match) {
	        return "+1 (" + match[1] + ") " + match[2] + "-" + match[3];
	      }
	
	      return null;
	    }
	  }, {
	    key: "displayDetails",
	    value: function displayDetails(application, type, action, index, isLink, wantsToMessage) {
	      var _this = this;
	
	      console.log("displayDetails");
	      console.dir(application);
	
	      application.applicantPhoneNumber = this.formatPhoneNumber(application.applicantPhoneNumber);
	
	      var applicationIndexInArray = index;
	      var typeOfApplication = type;
	      var typeOfAction = action;
	      var heightOfModal = this.$window.innerHeight - 73;
	
	      _this.setLoader();
	
	      _this.$rootScope.$emit("GetJobblerDataCached", { application: application });
	
	      _this.$security.getApplicationInfoTrimmedv2(application).then(function (response) {
	        if (type === "default" || type === "hired") {
	          if (!application.direction && !isLink) {
	            _this.$timeout(function () {
	              //jQuery("#modal-view-jobble-new").modal();
	              $("#modal-view-jobble").modal();
	            });
	          } else {
	            _this.$timeout(function () {
	              $("#modal-view-jobble").modal();
	            });
	          }
	        }
	
	        var jobblerData = _this.$security.getJobblerData(response.data, type, action, application.renderPhotoBig, applicationIndexInArray, _this.pendingApplicants.length, _this.acceptedApplicants.length, application);
	
	        jobblerData.index = applicationIndexInArray;
	        jobblerData.type = typeOfApplication;
	        jobblerData.action = typeOfAction;
	
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("GetJobblerDataFromService", {
	            event: _this.event,
	            jobblerData: jobblerData,
	            messaging: wantsToMessage,
	            application: application,
	            type: type,
	            heightOfModal: heightOfModal
	          });
	
	          $("#modal-view-jobble").focus();
	        });
	
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "sendPublishForView",
	    value: function sendPublishForView(applicant) {
	      var _this = this;
	
	      var msg = "Your application has been reviewed by " + _this.currentUser.firstName + " " + _this.currentUser.lastName + " for the job: " + _this.event.name;
	      _this.$messagingv2.publishMessagev1(msg, null, null, applicant, null);
	    }
	  }, {
	    key: "selectApplicantReject",
	    value: function selectApplicantReject(selectedApplicant, status) {
	      this.applicationForReject = selectedApplicant;
	      this.applicantStatus = status;
	
	      this.$timeout(function () {
	        jQuery("#modal-fire-jobbler-new").modal();
	      });
	    }
	  }, {
	    key: "selectApplicant",
	    value: function selectApplicant(selectedApplicant) {
	      this.selectedApplicant = selectedApplicant;
	      this.hireJobblerResult.status = "";
	      this.hireJobblerResult.message = "";
	      this.removeJobblerResult.status = "";
	      this.removeJobblerResult.message = "";
	    }
	  }, {
	    key: "cancelRemoveJobbler",
	    value: function cancelRemoveJobbler() {
	      _this.$timeout(function () {
	        jQuery("#modal-remove-jobbler .modal-header button.close").trigger("click");
	      });
	    }
	  }, {
	    key: "cancelHireJobblers",
	    value: function cancelHireJobblers() {
	      _this.$timeout(function () {
	        jQuery("#modal-hire-jobbler .modal-header button.close").trigger("click");
	      });
	    }
	  }, {
	    key: "cancelFireJobblers",
	    value: function cancelFireJobblers() {
	      _this.$timeout(function () {
	        jQuery("#modal-fire-jobbler .modal-header button.close").trigger("click");
	      });
	    }
	  }, {
	    key: "triggeredHireJobbler",
	    value: function triggeredHireJobbler() {
	      var _this = this;
	
	      console.log("triggeredHireJobbler");
	    }
	  }, {
	    key: "checkForExistingChannelForThisEvent",
	    value: function checkForExistingChannelForThisEvent() {
	      var _this30 = this;
	
	      var res = false;
	      try {
	        if (this.$rootScope.channels) {
	          var channels_and_event = this.$rootScope.channels.find(function (o) {
	            return o.eventId === _this30.event.id;
	          });
	
	          if (channels_and_event) {
	            var default_channel_inddex = channels_and_event.channelArrayHolder.findIndex(function (o) {
	              return o.isDefault === true;
	            });
	
	            if (default_channel_inddex > -1) {
	              res = true;
	            }
	          }
	        }
	      } catch (err) {
	        console.log("error looking for defualt chat");
	        console.dir(err);
	      }
	
	      return res;
	    }
	  }, {
	    key: "hireJobblers",
	    value: function hireJobblers(arg) {
	      var _this = this;
	
	      var jobblesAndApplicants = [];
	      var trackingData = [];
	      var putApplicationId = null;
	      var isPut = false;
	
	      var first_chat_or_default_chat = _this.checkForExistingChannelForThisEvent();
	
	      try {
	        if (!_this.event.isSourcingPost) {
	          if (!first_chat_or_default_chat) {
	            _this.$timeout(function () {
	              _this.$rootScope.$emit("JobblerIsBeingHired", {});
	            });
	          }
	          for (var i = this.pendingApplicants.length - 1; i >= 0; i--) {
	            if (this.pendingApplicants[i].isHireSelected) {
	              trackingData.push(this.pendingApplicants[i]);
	              if (!_this.event.isSourcingPost) {
	                var jobbleObjForApplication = {};
	                jobbleObjForApplication.applicant = this.pendingApplicants[i].applicant.id;
	                jobbleObjForApplication.jobble = this.pendingApplicants[i].jobble.id;
	                jobbleObjForApplication.index = i;
	                jobbleObjForApplication.eventId = _this.event.id;
	                if (_this.event.orderNumber) {
	                  jobbleObjForApplication.is_order = true;
	                } else {
	                  jobbleObjForApplication.is_order = false;
	                }
	                jobblesAndApplicants.push(jobbleObjForApplication);
	              } else {
	                isPut = true;
	                putApplicationId = this.pendingApplicants[i].id;
	              }
	            }
	          }
	        } else {
	          isPut = true;
	          for (var i = this.approvedApplicants.length - 1; i >= 0; i--) {
	            putApplicationId = this.approvedApplicants[i].id;
	          }
	        }
	      } finally {
	        var hireJobblersData = {};
	        if (!_this.event.isSourcingPost) {
	          hireJobblersData = {
	            method: "POST",
	            url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-accept?format=json&conf=web",
	            headers: {
	              "Content-Type": "application/json",
	              Authorization: "Bearer " + _this.currentUser.access_token
	            },
	            data: {
	              jobblesAndApplicants: jobblesAndApplicants,
	              verified: true
	            }
	          };
	        } else {
	          hireJobblersData = {
	            method: "PUT",
	            url: _this.$env.getAPIEndPoint() + "jbl/v1/applications/" + putApplicationId + "?format=json&fields=id,applicationStatus.id,applicationStatus.name,applicant.firstName,applicant.lastName,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,jobble.id,applicant.id,applicant.homeContactInfo.city,applicant.homeContactInfo.state,applicant.username,applicant.numberOfCompletedJobbles",
	            headers: {
	              "Content-Type": "application/json",
	              Authorization: "Bearer " + _this.currentUser.access_token
	            },
	            data: { applicationStatus: { id: 1, name: "ACCEPTED" } }
	          };
	        }
	
	        _this.remain_loading_count++;
	        _this.$http(hireJobblersData).then(function (response) {
	          console.log("response");
	          console.dir(response);
	
	          _this.remain_loading_count--;
	
	          if (response) {
	            if (isPut) {
	              _this.handlePut(putApplicationId, response, trackingData, arg);
	              return;
	            }
	            if (response.data[0].status === "error") {
	              _this.hireJobblerResult.status = "error";
	              _this.hireJobblerResult.message = response.data[0].message;
	              if (arg && arg.action === "close") {
	                alert("Error with this user looking to handle this");
	              }
	              return;
	            }
	
	            if (first_chat_or_default_chat === false) {
	              var data = {};
	              data.event = _this.event;
	              data.response = response;
	              _this.$timeout(function () {
	                _this.$rootScope.$emit("AddChannelToList", data);
	              });
	            }
	            _this.pendingApplicants.forEach(function (applicant) {
	              if (applicant.isHireSelected) {
	                _this.acceptedApplicants.push(applicant);
	              }
	            });
	            jobblesAndApplicants.forEach(function (applicant) {
	              _this.pendingApplicants.splice(applicant.index, 1);
	            });
	            _this.event.numberOfApprovedApplications = _this.event.numberOfApprovedApplications + jobblesAndApplicants.length;
	            _this.event.numberOfOpenings = _this.event.numberOfOpenings - jobblesAndApplicants.length;
	            _this.event.numberOfPendingApplications = _this.event.numberOfPendingApplications - jobblesAndApplicants.length;
	            _this.$tracking.reportApplicationAcceptance(_this.event, _this.currentUser, trackingData);
	            if (arg && arg.action === "close") {
	              _this.$timeout(function () {
	                jQuery("#modal-view-jobble .public-profile-content .close-out-button button.close").trigger("click");
	              });
	            } else {
	              _this.$timeout(function () {
	                jQuery("#modal-hire-jobbler .modal-header button.close").trigger("click");
	              });
	            }
	            _this.fancyLoad("#review-accepted-applicants tbody tr", _this.acceptedApplicants.length);
	            _this.resetApprovedApplicants();
	          } else {
	            if (arg && arg.action === "close") {
	              _this.$timeout(function () {
	                jQuery("#modal-view-jobble .public-profile-content .close-out-button button.close").trigger("click");
	              });
	            } else {
	              _this.$timeout(function () {
	                jQuery("#modal-hire-jobbler .modal-header button.close").trigger("click");
	              });
	            }
	
	            _this.$timeout(function () {
	              alert("The server has timed out. There was an issue with the page. Please notify support.");
	            }, 1000);
	          }
	        }, function (response) {
	          _this.remain_loading_count--;
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	        });
	      }
	    }
	  }, {
	    key: "bulkHireApplicants",
	    value: function bulkHireApplicants() {
	      var applicants = [];
	
	      this.allApplicants.forEach(function (applicant) {
	        if (applicant.isChecked) {
	          applicants.push(applicant);
	        }
	      });
	
	      this.$tracking.reportRosterPageSubmit("bulk hire");
	
	      if (!applicants.length) {
	        this.checkOrUncheckAll(false);
	        return;
	      }
	
	      if (this.isThereRoomForHire === false) {
	        alert("Our system is reporting that there are no more openings to fill in this job. Please contact an admin to help create more openings so that more users can be hired to this job.");
	        return;
	      }
	
	      this.hireJobblersNew(applicants);
	    }
	  }, {
	    key: "bulkRejectApplicants",
	    value: function bulkRejectApplicants() {
	      var applicants = [];
	      this.allApplicants.forEach(function (applicant) {
	        if (applicant.isChecked) {
	          applicants.push(applicant);
	        }
	      });
	
	      this.$tracking.reportRosterPageSubmit("bulk reject");
	
	      if (!applicants.length) {
	        this.checkOrUncheckAll(false);
	        return;
	      }
	
	      this.rejectJobblersNew(applicants);
	    }
	  }, {
	    key: "getApplicantUniqueShiftId",
	    value: function getApplicantUniqueShiftId(shiftPosition, applicantId) {
	      if (!this.shiftConfirmationData || !this.shiftConfirmationData[shiftPosition]) {
	        console.error("Shift confirmation data has not loaded yet", applicantId);
	        return null;
	      }
	
	      if (!this.shiftConfirmationData[shiftPosition][applicantId]) {
	        console.error("Shift confirmation data has not loaded yet for this applicant", applicantId);
	        return null;
	      }
	
	      return this.shiftConfirmationData[shiftPosition][applicantId].shiftId;
	    }
	  }, {
	    key: "bulkCheckInOrOutJobblers",
	    value: function bulkCheckInOrOutJobblers(checkOut) {
	      var applicants = [];
	
	      this.allApplicants.forEach(function (applicant) {
	        if (applicant.isChecked) {
	          applicants.push(applicant);
	        }
	      });
	
	      this.$tracking.reportRosterPageSubmit("bulk check " + (checkOut ? "out" : "in"));
	
	      this.checkInOrOutJobblers(applicants, checkOut);
	    }
	  }, {
	    key: "checkInOrOutJobblers",
	    value: function checkInOrOutJobblers(applicants, checkOut, formatted_date, dateforDB, shift) {
	      var _this31 = this;
	
	      this.$tracking.reportRosterPageSubmit("check " + (checkOut ? "out" : "in"));
	
	      shift = shift || this.singleShiftViewShift;
	
	      if (!shift) return console.error("No single shift is selected");
	
	      var payLoad = { jobblesAndApplicants: [] };
	
	      var coordsForCheckIn = {
	        lat: shift.contactInfo.lat,
	        lng: shift.contactInfo.lng
	      };
	
	      applicants.forEach(function (applicant) {
	        var jobbleAndApplicant = {};
	
	        var shiftPosition = shift.shiftPosition;
	
	        var shiftId = _this31.getApplicantUniqueShiftId(shiftPosition, applicant.applicantId);
	
	        jobbleAndApplicant.jobble = applicant.jobbleId;
	        jobbleAndApplicant.applicant = applicant.applicantId;
	        jobbleAndApplicant.coord = coordsForCheckIn;
	        jobbleAndApplicant.shift = shiftId;
	        jobbleAndApplicant.isManager = true;
	
	        if (dateforDB) {
	          jobbleAndApplicant.date = dateforDB;
	        }
	
	        var exists = false;
	
	        console.log(applicant.applicantId, _this31.shiftConfirmationData[shiftPosition], _this31.shiftConfirmationData[shiftPosition][applicant.applicantId]);
	
	        if (_this31.shiftConfirmationData && _this31.shiftConfirmationData[shiftPosition] && _this31.shiftConfirmationData[shiftPosition][applicant.applicantId]) {
	          if (checkOut) {
	            exists = _this31.shiftConfirmationData[shiftPosition][applicant.applicantId].checkOutTime;
	          } else {
	            exists = _this31.shiftConfirmationData[shiftPosition][applicant.applicantId].checkInTime;
	          }
	        }
	
	        console.log(applicant.applicantId, exists, dateforDB);
	
	        if (!exists || dateforDB) {
	          payLoad.jobblesAndApplicants.push(jobbleAndApplicant);
	        }
	      });
	
	      if (payLoad.jobblesAndApplicants.length) {
	        this.remain_loading_count++;
	
	        this.$events.checkJobblerInOrOut(payLoad, checkOut ? 2 : 1).then(function (response) {
	          _this31.remain_loading_count--;
	
	          console.log("check in/out response", response.data);
	
	          var now = dateforDB ? moment(dateforDB) : moment();
	          var time = now.format("MMM DD, h:mm a").toUpperCase();
	
	          payLoad.jobblesAndApplicants.forEach(function (applicant) {
	            var applicantId = applicant.applicant;
	            var shiftPosition = shift.shiftPosition;
	
	            if (checkOut) {
	              _this31.updateCheckInOutData(shiftPosition, applicantId, null, time, now);
	            } else {
	              _this31.updateCheckInOutData(shiftPosition, applicantId, time, null, now);
	            }
	          });
	
	          _this31.reloadApplicants();
	        }, function (data) {
	          _this31.remain_loading_count--;
	
	          console.error(data);
	
	          _this31.reloadApplicants();
	        });
	      } else {
	        this.checkOrUncheckAll(false);
	      }
	    }
	  }, {
	    key: "rejectJobblersNew",
	    value: function rejectJobblersNew(applicants) {
	      var _this32 = this;
	
	      var applicantsData = [];
	      var paymentContingencies = false;
	      var paymentContingenciesMap = {};
	
	      applicants.forEach(function (applicant) {
	        applicantsData.push({
	          applicantId: applicant.applicantId,
	          jobbleId: applicant.jobbleId
	        });
	      });
	
	      applicants.forEach(function (applicant) {
	        Object.keys(_this32.shiftConfirmationData || []).forEach(function (singleShiftViewShiftPosition) {
	          var confirmationData = _this32.shiftConfirmationData[singleShiftViewShiftPosition][applicant.applicantId];
	          var shift = _this32.convertedShiftsMap[singleShiftViewShiftPosition];
	
	          if (!confirmationData) return;
	
	          if (shift.shiftEnded && confirmationData.statusNumber !== 4 && confirmationData.statusNumber !== 5) {
	            paymentContingencies = true;
	            paymentContingenciesMap[singleShiftViewShiftPosition] = paymentContingenciesMap[singleShiftViewShiftPosition] || [];
	            paymentContingenciesMap[singleShiftViewShiftPosition].push(applicant);
	          }
	        });
	      });
	
	      console.log("paymentContingencies", paymentContingencies);
	      console.log("paymentContingenciesMap", paymentContingenciesMap);
	
	      this.paymentContingenciesMap = paymentContingenciesMap;
	      this.paymentContingenciesShiftPositions = Object.keys(paymentContingenciesMap);
	
	      this.rejectionApplicationData = applicantsData;
	      this.rejectionApplicants = applicants;
	
	      this.calculateTotalPaymentOnRejectionEdit();
	
	      if (this.tabFilter === 1) {
	        if (paymentContingencies) {
	          this.$timeout(function () {
	            jQuery("#modal-rejection-shift-payment").modal({
	              backdrop: true
	            });
	          }, 100);
	        } else {
	          this.$timeout(function () {
	            jQuery("#modal-rejection-confirm").modal({
	              backdrop: true
	            });
	          }, 100);
	        }
	      } else {
	        this.runRejection(applicantsData);
	      }
	    }
	  }, {
	    key: "submitModalRejection",
	    value: function submitModalRejection() {
	      var _this33 = this;
	
	      this.$timeout(function () {
	        jQuery("#modal-rejection-confirm .modal-header button.close").trigger("click");
	        _this33.runRejection(_this33.rejectionApplicationData);
	      });
	    }
	  }, {
	    key: "runRejection",
	    value: function runRejection(applicantsData) {
	      var _this34 = this;
	
	      console.log("SENDING DATE", applicantsData);
	
	      this.$tracking.reportRosterPageSubmit("reject");
	
	      var rejectJobblersData = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-reject?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.currentUser.access_token
	        },
	        data: {
	          applicants: applicantsData
	        }
	      };
	
	      this.remain_loading_count++;
	
	      this.$http(rejectJobblersData).then(function (response) {
	        _this34.remain_loading_count--;
	        //this.unSetLoader();
	
	        console.log("Reject response", response.data);
	
	        _this34.$timeout(function () {
	          _this34.reloadApplicants();
	        }, 0);
	
	        if (response.data && response.data.applicants) {
	          var notificationApplicants = response.data.applicants.map(function (applicant) {
	            if (applicant.status === "OK") {
	              var id = applicant.id,
	                  jobbleId = applicant.jobbleId,
	                  rejectingPreviouslyAcceptedUser = applicant.rejectingPreviouslyAcceptedUser;
	
	
	              return {
	                applicantId: id,
	                jobbleId: jobbleId,
	                rejectingPreviouslyAcceptedUser: rejectingPreviouslyAcceptedUser
	              };
	            } else {
	              return null;
	            }
	          });
	
	          notificationApplicants = _.without(notificationApplicants, null);
	
	          console.log("notificationApplicants", notificationApplicants);
	
	          if (notificationApplicants.length) {
	            var rejectJobblersNotificationsData = {
	              method: "POST",
	              url: _this34.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-reject-notifications?format=json&conf=web",
	              headers: {
	                "Content-Type": "application/json",
	                Authorization: "Bearer " + _this34.currentUser.access_token
	              },
	              data: {
	                applicants: notificationApplicants
	              }
	            };
	
	            _this34.notifyJobblersOfRejection(rejectJobblersNotificationsData);
	          }
	
	          if (response.data.status === "error") {
	            _this34.handleRejectionError(response.data);
	          }
	        }
	      }, function (response) {
	        _this34.remain_loading_count--;
	        console.error(response);
	        _this34.reloadApplicants();
	        //this.unSetLoader();
	      });
	    }
	  }, {
	    key: "handleRejectionError",
	    value: function handleRejectionError(data) {
	      var _this35 = this;
	
	      console.log("handleRejectionError");
	      console.dir(data);
	      console.dir(this.remain_loading_count);
	      var emailOfErrors = [];
	      var errorMessage = "There was a back end error removing ";
	
	      if (data) {
	        if (data.applicants) {
	          data.applicants.forEach(function (applicant) {
	            if (applicant.status === "error") {
	              emailOfErrors.push(applicant.message.checkResult.applicant.email);
	              var email = applicant.message.checkResult.applicant.email;
	              errorMessage = errorMessage + email + " ";
	            }
	          });
	        }
	      }
	
	      errorMessage = errorMessage + " from the job. Please contact support.";
	
	      console.log("emailOfErrors");
	      console.dir(emailOfErrors);
	
	      alert(errorMessage);
	
	      this.$timeout(function () {
	        _this35.unSetLoader();
	      }, 1000);
	    }
	  }, {
	    key: "notifyJobblersOfRejection",
	    value: function notifyJobblersOfRejection(rejectJobblersNotificationsData) {
	      var _this36 = this;
	
	      this.$timeout(function () {
	        _this36.$http(rejectJobblersNotificationsData).then(function (response) {
	          console.log("Reject notifications response", response.data);
	        }, function (response) {
	          console.error(response);
	        });
	      }, 2000);
	    }
	  }, {
	    key: "hireJobblersNew",
	    value: function hireJobblersNew(applicants) {
	      var _this37 = this;
	
	      var jobblesAndApplicants = [];
	      var trackingData = [];
	
	      this.$tracking.reportRosterPageSubmit("hire");
	
	      console.log("this.allApplicants");
	      console.dir(this.allApplicants);
	
	      try {
	        applicants.forEach(function (applicant, i) {
	          console.log(applicant);
	          console.dir(_this37.approvedApplicants);
	
	          trackingData.push(applicant);
	
	          var jobbleObjForApplication = {};
	
	          jobbleObjForApplication.applicant = applicant.applicantId;
	          jobbleObjForApplication.jobble = applicant.jobbleId;
	          jobbleObjForApplication.index = i;
	          jobbleObjForApplication.eventId = _this37.event.id;
	          jobbleObjForApplication.is_order = !!_this37.event.orderNumber;
	
	          jobblesAndApplicants.push(jobbleObjForApplication);
	        });
	      } finally {
	        console.log("jobblesAndApplicants", jobblesAndApplicants);
	
	        var hireJobblersData = {
	          method: "POST",
	          url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-accept?format=json&conf=web",
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + this.currentUser.access_token
	          },
	          data: {
	            jobblesAndApplicants: jobblesAndApplicants,
	            verified: true
	          }
	        };
	
	        this.remain_loading_count++;
	
	        this.$http(hireJobblersData).then(function (response) {
	          console.log("do we even have a response");
	          console.dir(response);
	
	          if (response.data.length === 0) {
	            _this37.remain_loading_count--;
	            _this37.$timeout(function () {
	              alert("There was an issue with one or more of the users being hired. Please contact support");
	            }, 100);
	            return;
	          }
	
	          if (response.data.status === "error") {
	            console.error("bulk hire error", response.data);
	
	            var message = response.data.message.message;
	
	
	            if (message && message.toLowerCase() === "could not find a jobble to accept") {
	              alert("There aren't enough openings available to hire this applicant. Please add more openings and try hiring again.");
	            } else if (message && (message.toLowerCase().indexOf("already booked for this time frame") !== -1 || message.toLowerCase().indexOf("already accepted for a position") !== -1)) {
	              alert("This jobbler has already been hired for another job that is at the same as this shift");
	            } else if (message && message.toLowerCase() === "no application for this jobble by the user was found") {
	              alert("This jobbler could not be hired for this job because their application has been cancelled");
	            } else {
	              alert("An unknown server error occurred:\n\nAPI Error: " + message);
	            }
	
	            _this37.remain_loading_count--;
	
	            _this37.hireJobblerResult.status = "error";
	            _this37.hireJobblerResult.message = response.data.message;
	            _this37.reloadApplicants();
	            _this37.ui.allChecked = false;
	
	            return;
	          }
	
	          _this37.$timeout(function () {
	            _this37.remain_loading_count--;
	            _this37.event.numberOfApprovedApplications = _this37.event.numberOfApprovedApplications + jobblesAndApplicants.length;
	            _this37.event.numberOfOpenings = _this37.event.numberOfOpenings - jobblesAndApplicants.length;
	            _this37.event.numberOfPendingApplications = _this37.event.numberOfPendingApplications - jobblesAndApplicants.length;
	            _this37.$tracking.reportApplicationAcceptance(_this37.event, _this37.currentUser, trackingData);
	            _this37.resetApprovedApplicants();
	            _this37.ui.allChecked = false;
	            _this37.removeHiredApplicantsFromPendingPool(jobblesAndApplicants, response);
	            _this37.reloadApplicants();
	          }, 2000);
	        }, function (response) {
	          console.log("was it a total failure");
	          console.dir(response);
	          _this37.remain_loading_count--;
	          _this37.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	          _this37.reloadApplicants();
	        });
	      }
	    }
	  }, {
	    key: "removeHiredApplicantsFromPendingPool",
	    value: function removeHiredApplicantsFromPendingPool(jobblesAndApplicant, response) {
	      var _this38 = this;
	
	      var removeArray = [];
	
	      try {
	        this.allApplicants.forEach(function (app) {
	          if (app.applicationStatus === 3 || app.applicationStatus === null) {
	            jobblesAndApplicant.forEach(function (a) {
	              if (a.applicant === app.applicantId) {
	                app.isChecked = true;
	                removeArray.push(app);
	              }
	            });
	          }
	        });
	      } catch (e) {
	        console.log("error : " + e);
	      } finally {
	        console.log("we have them in the remove array");
	        console.dir(removeArray);
	
	        removeArray.forEach(function (app) {
	          _this38.removeHireApplicant(app);
	          _this38.hiredApplicants.push(app);
	        });
	
	        console.log("hired apps..");
	        console.dir(this.hiredApplicants);
	
	        this.confirmJobblersHiredModal(jobblesAndApplicant, response);
	      }
	    }
	  }, {
	    key: "confirmJobblersHiredModal",
	    value: function confirmJobblersHiredModal(jaa, response) {
	      var _this39 = this;
	
	      var hireMessage = void 0;
	
	      if (jaa.length > 1) {
	        hireMessage = "Congratulations on your new the hires!";
	      } else {
	        hireMessage = "Congratulations on your new the hire!";
	      }
	
	      this.$timeout(function () {
	        $("#modal-congrats-hire").modal();
	        _this39.statusNumbers[1] = _this39.statusNumbers[1] + jaa.length;
	      }, 150);
	
	      this.$timeout(function () {
	        _this39.unSetLoader();
	      }, 1000);
	    }
	  }, {
	    key: "sendToHires",
	    value: function sendToHires() {
	      this.setTabFilter(1);
	      this.$timeout(function () {
	        $("#modal-congrats-hire").modal("toggle");
	      }, 150);
	    }
	  }, {
	    key: "closeCongratsMessage",
	    value: function closeCongratsMessage() {
	      var _this40 = this;
	
	      this.$timeout(function () {
	        $("#modal-congrats-hire").modal("toggle");
	      }, 150);
	
	      this.$timeout(function () {
	        _this40.$state.go("jobsdashboard");
	      }, 700);
	    }
	  }, {
	    key: "resetApprovedApplicants",
	    value: function resetApprovedApplicants() {
	      var _this = this;
	      _this.approvedApplicants = [];
	    }
	  }, {
	    key: "handlePut",
	    value: function handlePut(id, response, trackingData, arg) {
	      var _this = this;
	      var application = response.data;
	
	      _this.pendingApplicants.forEach(function (applicant, i) {
	        if (applicant.id === id) {
	          _this.pendingApplicants.splice(i, 1);
	          _this.acceptedApplicants.push(applicant);
	        }
	      });
	      if (arg) {
	        if (arg.action === "close") {
	          _this.$timeout(function () {
	            jQuery("#modal-view-jobble .public-profile-content .close-out-button button.close").trigger("click");
	          });
	        }
	      } else {
	        _this.$timeout(function () {
	          jQuery("#modal-hire-jobbler .modal-header button.close").trigger("click");
	        });
	      }
	      _this.fancyLoad("#review-accepted-applicants tbody tr", _this.acceptedApplicants.length);
	      _this.resetApprovedApplicants();
	      _this.event.numberOfApprovedApplications = _this.event.numberOfApprovedApplications + 1;
	      _this.event.numberOfPendingApplications = _this.event.numberOfPendingApplications - 1;
	    }
	  }, {
	    key: "adjustJobblers",
	    value: function adjustJobblers(jobbler) {
	      var _this = this;
	      _this.pendingApplicants.forEach(function (applicant, i) {
	        if (applicant.applicant.id === jobbler.jobblerId) {
	          _this.acceptedApplicants.push(applicant);
	          _this.pendingApplicants.splice(i, 1);
	        }
	      });
	      _this.event.numberOfApprovedApplications = _this.event.numberOfApprovedApplications + 1;
	      _this.event.numberOfPendingApplications = _this.event.numberOfPendingApplications - 1;
	    }
	  }, {
	    key: "removeJobbler",
	    value: function removeJobbler() {
	      var _this = this;
	      var removeJobblerData = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.selectedApplicant.applicant.id + "/jobbles/" + _this.selectedApplicant.jobbleId + "/reject?format=json",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.currentUser.access_token
	        },
	        data: {}
	      };
	      _this.remain_loading_count++;
	      _this.$http(removeJobblerData).then(function (response) {
	        _this.remain_loading_count--;
	        if (response.data.status === "OK") {
	          var index = null;
	          for (var i = 0; i < _this.acceptedApplicants.length; i++) {
	            if (_this.acceptedApplicants[i].id === _this.selectedApplicant.id) index = i;
	          }
	          if (!_this.$security.isUndefinedOrNull(index)) _this.acceptedApplicants.splice(index, 1);
	        }
	        _this.$timeout(function () {
	          jQuery("#modal-remove-jobbler .modal-header button.close").trigger("click");
	        }, 100);
	      }, function (response) {
	        _this.remain_loading_count--;
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "connectJobblerFromApplicantsPage",
	    value: function connectJobblerFromApplicantsPage(application) {
	      var _this = this;
	      var eventForParam = _this.event;
	      _this.remain_loading_count++;
	      if (_this.paymentInfos.length == 0) {
	        _this.$timeout(function () {
	          jQuery("#link-modal-add-card").trigger("click");
	          if (_this.isSourcingPost) {
	            _this.$rootScope.isSourcingJobForPayment = true;
	          }
	          _this.remain_loading_count--;
	        });
	        return;
	      }
	      _this.$security.getApplicationInfoTrimmed(application).then(function (response) {
	        var jobblerData = _this.$security.getJobblerData(response.data, "default", "open", application.renderPhotoThumb);
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("GetJobblerDataFromService", {
	            event: _this.event,
	            jobblerData: jobblerData
	          });
	          _this.$rootScope.$emit("CollectCardsForConnect", {});
	          jQuery("#modal-connect-jobbler-click").trigger("click");
	        });
	        _this.$timeout(function () {
	          _this.remain_loading_count--;
	        }, 700);
	      });
	    }
	  }, {
	    key: "setJobblerRating",
	    value: function setJobblerRating(acceptedApplication) {
	      var _this = this;
	      if (!_this.$security.isUndefinedOrNull(acceptedApplication.renderPhoto)) {
	        acceptedApplication.renderPhotoThumb = acceptedApplication.renderPhoto;
	      } else {
	        acceptedApplication.renderPhotoThumb = acceptedApplication.renderPhotoBig;
	      }
	      if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 0) {
	        acceptedApplication.applicant.displayRating = 1;
	      }
	      if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 1) {
	        acceptedApplication.applicant.displayRating = 1;
	      }
	      if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 2) {
	        acceptedApplication.applicant.displayRating = 2;
	      }
	      if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 3) {
	        acceptedApplication.applicant.displayRating = 3;
	      }
	      if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 4) {
	        acceptedApplication.applicant.displayRating = 4;
	      }
	      if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 5) {
	        acceptedApplication.applicant.displayRating = 5;
	      }
	      _this.noOneAcceptedYet = false;
	      _this.getPaymentInfoAccepted(acceptedApplication);
	    }
	  }, {
	    key: "setJobblerRatingNew",
	    value: function setJobblerRatingNew(application) {
	      if (!this.$security.isUndefinedOrNull(application.renderPhoto)) {
	        application.renderPhotoThumb = application.renderPhoto;
	      } else {
	        application.renderPhotoThumb = application.renderPhotoBig;
	      }
	
	      if (Math.round(application.applicant.averageRatingReceived) === 0) {
	        application.applicant.displayRating = 1;
	      }
	      if (Math.round(application.applicant.averageRatingReceived) === 1) {
	        application.applicant.displayRating = 1;
	      }
	      if (Math.round(application.applicant.averageRatingReceived) === 2) {
	        application.applicant.displayRating = 2;
	      }
	      if (Math.round(application.applicant.averageRatingReceived) === 3) {
	        application.applicant.displayRating = 3;
	      }
	      if (Math.round(application.applicant.averageRatingReceived) === 4) {
	        application.applicant.displayRating = 4;
	      }
	      if (Math.round(application.applicant.averageRatingReceived) === 5) {
	        application.applicant.displayRating = 5;
	      }
	
	      return application;
	    }
	  }, {
	    key: "setJobblerRatingPending",
	    value: function setJobblerRatingPending(pendingApplication) {
	      var _this = this;
	      if (!_this.$security.isUndefinedOrNull(pendingApplication.renderPhoto)) {
	        pendingApplication.renderPhotoThumb = pendingApplication.renderPhoto;
	      } else {
	        pendingApplication.renderPhotoThumb = pendingApplication.renderPhotoBig;
	      }
	      if (Math.round(pendingApplication.applicant.averageRatingReceived) === 0) {
	        pendingApplication.applicant.displayRating = 1;
	      }
	      if (Math.round(pendingApplication.applicant.averageRatingReceived) === 1) {
	        pendingApplication.applicant.displayRating = 1;
	      }
	      if (Math.round(pendingApplication.applicant.averageRatingReceived) === 2) {
	        pendingApplication.applicant.displayRating = 2;
	      }
	      if (Math.round(pendingApplication.applicant.averageRatingReceived) === 3) {
	        pendingApplication.applicant.displayRating = 3;
	      }
	      if (Math.round(pendingApplication.applicant.averageRatingReceived) === 4) {
	        pendingApplication.applicant.displayRating = 4;
	      }
	      if (Math.round(pendingApplication.applicant.averageRatingReceived) === 5) {
	        pendingApplication.applicant.displayRating = 5;
	      }
	      pendingApplication.isHireSelected = false;
	      pendingApplication.isHireSelectedLast = false;
	      _this.getPaymentInfoPending(pendingApplication);
	    }
	  }, {
	    key: "scrollPendingApplicants",
	    value: function scrollPendingApplicants() {
	      var _this = this;
	      if (_this.pendingApplicants.length !== _this.event.numberOfPendingApplications && _this.thereArePendingApplicant) {
	        _this.busy = true;
	        _this.$scroll.loadMoreApplicationsReviewPage(_this.event.subEvents[0].id, _this.pendingApplicants.length, 8, _this.$env, 3).then(function (pendingApplications) {
	          if (pendingApplications.data) {
	            try {
	              if (pendingApplications.data.length === 0) {
	                _this.thereArePendingApplicant = false;
	              }
	              if (pendingApplications.data.length !== 0) {
	                pendingApplications.data.forEach(function (pendingApplication) {
	                  pendingApplication.hasBeenSelected = false;
	                  pendingApplication.renderPhoto = pendingApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
	                  pendingApplication.renderPhotoThumb = pendingApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
	                  _this.setJobblerRatingPending(pendingApplication);
	                  _this.fancyLoad(".reviewing-applicants-table tbody tr", _this.pendingApplicants.length);
	                });
	              }
	            } catch (err) {
	              console.log("error scrolling applicants");
	              console.dir(err);
	            } finally {
	              var len = pendingApplications.data.length;
	              if (len < 8) {
	                _this.busy = false;
	                _this.sortPendingApplicants();
	              } else {
	                _this.scrollPendingApplicants();
	              }
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: "scrollAcceptedApplicants",
	    value: function scrollAcceptedApplicants() {
	      var _this = this;
	      if (_this.acceptedApplicants.length !== _this.event.numberOfApprovedApplications && _this.thereAreAcceptedApplicant) {
	        _this.busyAccepted = true;
	        _this.$scroll.loadMoreApplicationsReviewPage(_this.event.subEvents[0].id, _this.acceptedApplicants.length, 8, _this.$env, 1).then(function (acceptedApplications) {
	          try {
	            if (acceptedApplications.data.length === 0) {
	              _this.thereAreAcceptedApplicant = false;
	            }
	            if (acceptedApplications.data.length !== 0) {
	              acceptedApplications.data.forEach(function (acceptedApplication) {
	                acceptedApplication.renderPhoto = acceptedApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
	                acceptedApplication.renderPhotoThumb = acceptedApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
	                _this.setJobblerRating(acceptedApplication);
	                _this.fancyLoad("#review-accepted-applicants tbody tr", _this.acceptedApplicants.length);
	              });
	            }
	          } catch (err) {} finally {
	            var len = acceptedApplications.data.length;
	            if (len < 8) {
	              _this.busyAccepted = false;
	              _this.sortAcceptedApplicants();
	            } else {
	              _this.scrollAcceptedApplicants();
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: "sortSet",
	    value: function sortSet(x) {
	      var _this = this;
	      var list = _this.pendingApplicants;
	      var header = x;
	      var prop = x.prop;
	      if (header.order === 1) {
	        header.order = 2;
	      } else {
	        header.order = 1;
	      }
	      switch (prop) {
	        case 1:
	          _this.pendingApplicants = _this.$scroll.sortSet(list, prop, header);
	          break;
	        case 2:
	          _this.pendingApplicants = _this.$scroll.sortSet(list, prop, header);
	          break;
	        case 3:
	          _this.pendingApplicants = _this.$scroll.sortSet(list, prop, header);
	          break;
	        case 4:
	          _this.pendingApplicants = _this.$scroll.sortSet(list, prop, header);
	          break;
	        case 5:
	          _this.pendingApplicants = _this.$scroll.sortSet(list, prop, header);
	          break;
	      }
	    }
	  }, {
	    key: "displayStatusText",
	    value: function displayStatusText(data) {
	      return data.jobblerScheduleManagementStatus;
	    }
	  }, {
	    key: "getBirthDate",
	    value: function getBirthDate(application, date) {
	      application.applicant.age = moment().diff(moment(date), "years");
	      return application.applicant.age;
	    }
	  }, {
	    key: "scrollToBottomOfPage",
	    value: function scrollToBottomOfPage() {
	      var _this = this;
	      _this.$location.hash("anchor-for-top-link");
	      _this.$anchor();
	    }
	  }, {
	    key: "generateApprovedApplicantList",
	    value: function generateApprovedApplicantList() {
	      var _this = this;
	    }
	  }, {
	    key: "sortSurveyQuestions",
	    value: function sortSurveyQuestions(questions) {
	      var _this = this;
	      questions.sort(function (a, b) {
	        if (a.id < b.id) return -1;
	        if (a.id > b.id) return 1;
	        return 0;
	      });
	    }
	  }, {
	    key: "handleProfilePagination",
	    value: function handleProfilePagination(params) {
	      var _this = this;
	      var nextIndex = null;
	      var app = {};
	      app.direction = params.data.direction;
	      if (params.data.type === "default") {
	        if (params.data.direction === "next") {
	          nextIndex = params.data.index + 1;
	          app.id = _this.pendingApplicants[params.data.index + 1].id;
	        } else {
	          nextIndex = params.data.index - 1;
	          app.id = _this.pendingApplicants[params.data.index - 1].id;
	        }
	      } else {
	        if (params.data.direction === "next") {
	          nextIndex = params.data.index + 1;
	          app.id = _this.acceptedApplicants[params.data.index + 1].id;
	        } else {
	          nextIndex = params.data.index - 1;
	          app.id = _this.acceptedApplicants[params.data.index - 1].id;
	        }
	      }
	      _this.displayDetails(app, params.data.type, params.data.action, nextIndex);
	    }
	  }, {
	    key: "setTableHeaders",
	    value: function setTableHeaders() {
	      var _this = this;
	      if (!_this.event.isSourcingPost) {
	        this.tableHeaders = [{ value: "" }, {
	          value: "Name",
	          imageUrl: "/app/vendor/images/sortingall.png",
	          order: 2,
	          prop: 1
	        }, {
	          value: "Job Exp.",
	          imageUrl: "/app/vendor/images/sortingall.png",
	          order: 2,
	          prop: 2,
	          title: "Jobs Completed"
	        }, { value: "City", title: "City" }, {
	          value: "Rating",
	          imageUrl: "/app/vendor/images/sortingall.png",
	          order: 2,
	          prop: 4,
	          title: "Average Rating Received"
	        }, { value: "" }, { value: "" }];
	      } else {
	        this.tableHeaders = [{ value: "" }, {
	          value: "Name",
	          imageUrl: "/app/vendor/images/sortingall.png",
	          order: 2,
	          prop: 1
	        }, {
	          value: "Rating",
	          imageUrl: "/app/vendor/images/sortingall.png",
	          order: 2,
	          prop: 4
	        }, { value: "Message" }, { value: "No" }, { value: "Yes" }];
	      }
	    }
	  }, {
	    key: "handleConnect",
	    value: function handleConnect(usersAndApplications) {
	      var _this = this;
	      _this.$events.connect(usersAndApplications).then(function (response) {
	        console.log("response");
	        console.dir(response);
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "toggleActionMenu",
	    value: function toggleActionMenu(job, index, call) {
	      var i = index + 1;
	
	      if (this.tabFilter === 1 && $("table.jobble-table").length > 1) {
	        if (call === 2) {
	          this.$timeout(function () {
	            $("table.jobble-table:first-child tbody tr:nth-child(" + i + ") td:last-child .action-menu").slideToggle({ duration: 100 });
	          });
	          this.$timeout(function () {
	            $("table.jobble-table:first-child tbody tr:nth-child(" + i + ") td").toggleClass("row-focus");
	          }, 150);
	          this.$timeout(function () {
	            $("table.jobble-table:first-child tbody tr:nth-child(" + i + ") td:last-child .action-menu").focus();
	          }, 300);
	        } else if (call === 3) {
	          if ($("table.jobble-table tbody tr.confirmation-red").length > 0) {
	            this.$timeout(function () {
	              $("table.jobble-table tbody tr.confirmation-red:nth-child(" + i + ") td:last-child .action-menu").slideToggle({ duration: 100 });
	            });
	            this.$timeout(function () {
	              $("table.jobble-table tbody tr.confirmation-red:nth-child(" + i + ") td").toggleClass("row-focus");
	            }, 150);
	            this.$timeout(function () {
	              $("table.jobble-table tbody tr.confirmation-red:nth-child(" + i + ") td:last-child .action-menu").focus();
	            }, 300);
	          } else if ($("table.jobble-table tbody tr.no-confirm").length > 0) {
	            this.$timeout(function () {
	              $("table.jobble-table tbody tr.no-confirm:nth-child(" + i + ") td:last-child .action-menu").slideToggle({ duration: 100 });
	            });
	            this.$timeout(function () {
	              $("table.jobble-table tbody tr.no-confirm:nth-child(" + i + ") td").toggleClass("row-focus");
	            }, 150);
	            this.$timeout(function () {
	              $("table.jobble-table tbody tr.no-confirm:nth-child(" + i + ") td:last-child .action-menu").focus();
	            }, 300);
	          }
	        }
	      } else {
	        this.$timeout(function () {
	          $("table.jobble-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").slideToggle({ duration: 100 });
	        });
	        this.$timeout(function () {
	          $("table.jobble-table tbody tr:nth-child(" + i + ") td").toggleClass("row-focus");
	        }, 150);
	        this.$timeout(function () {
	          $("table.jobble-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").focus();
	        }, 300);
	      }
	    }
	  }, {
	    key: "getPaymentInfoPending",
	    value: function getPaymentInfoPending(application) {
	      var _this = this;
	      if (_this.currentUser.isAdmin && application.applicant.undeletedPaymentInfos && application.applicant.undeletedPaymentInfos.length === 0) {
	        application.showPayInfoWarning = true;
	      }
	      _this.pendingApplicants.push(application);
	    }
	  }, {
	    key: "getPaymentInfoPendingNew",
	    value: function getPaymentInfoPendingNew(application) {
	      if (this.currentUser.isAdmin && application.applicant.undeletedPaymentInfos && application.applicant.undeletedPaymentInfos.length === 0) {
	        application.showPayInfoWarning = true;
	      }
	
	      return application;
	    }
	  }, {
	    key: "getPaymentInfoAccepted",
	    value: function getPaymentInfoAccepted(application) {
	      var _this = this;
	      if (_this.currentUser.isAdmin && application.applicant.undeletedPaymentInfos.length === 0) {
	        application.showPayInfoWarning = true;
	      }
	      _this.acceptedApplicants.push(application);
	    }
	  }, {
	    key: "fixApplicantPhone",
	    value: function fixApplicantPhone(application) {
	      var _this = this;
	      if (application.applicant.homeContactInfo) {
	        if (application.applicant.homeContactInfo.phoneMobile) {
	          var num = application.applicant.homeContactInfo.phoneMobile;
	          if (num.charAt(0) === "1") {
	            num = num.slice(1, num.length);
	          }
	          var cleaned = ("" + num).replace(/\D/g, "");
	          var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
	          if (match) {
	            application.applicant.homeContactInfo.phoneMobile = "(" + match[1] + ") " + match[2] + "-" + match[3];
	          } else {
	            application.applicant.homeContactInfo.phoneMobile = num;
	          }
	        } else {
	          application.applicant.homeContactInfo = {};
	          application.applicant.homeContactInfo.phoneMobile = "--";
	        }
	      }
	    }
	  }, {
	    key: "fixApplicantPhoneNew",
	    value: function fixApplicantPhoneNew(application) {
	      if (application.applicantHomeContactInfo) {
	        if (application.applicantHomeContactInfo.phoneMobile) {
	          var num = application.applicantHomeContactInfo.phoneMobile;
	          if (num.charAt(0) === "1") {
	            num = num.slice(1, num.length);
	          }
	          var cleaned = ("" + num).replace(/\D/g, "");
	          var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
	          if (match) {
	            application.applicantHomeContactInfo.phoneMobile = "(" + match[1] + ") " + match[2] + "-" + match[3];
	          } else {
	            application.applicantHomeContactInfo.phoneMobile = num;
	          }
	        } else {
	          application.applicantHomeContactInfo = {};
	          application.applicantHomeContactInfo.phoneMobile = "--";
	        }
	      }
	
	      return application;
	    }
	  }, {
	    key: "fixApplicantNameNew",
	    value: function fixApplicantNameNew(application) {
	      if (!application) return application;
	
	      var last_name = application.applicantLastName ? application.applicantLastName.toLowerCase() : "--";
	      var first_name = application.applicantFirstName ? application.applicantFirstName.toLowerCase() : "--";
	
	      application.applicantLastName = last_name.charAt(0).toUpperCase() + last_name.slice(1);
	      application.applicantFirstName = first_name.charAt(0).toUpperCase() + first_name.slice(1);
	
	      application.applicantEmail = application.applicantEmail ? application.applicantEmail.toLowerCase() : "--";
	
	      return application;
	    }
	  }, {
	    key: "fixApplicantName",
	    value: function fixApplicantName(application) {
	      var _this = this;
	      var last_name = application.applicant.lastName.toLowerCase();
	      var first_name = application.applicant.firstName.toLowerCase();
	      var test_length = last_name + first_name;
	      application.applicant.lastName = last_name.charAt(0).toUpperCase() + last_name.slice(1);
	      application.applicant.firstName = first_name.charAt(0).toUpperCase() + first_name.slice(1);
	      application.applicant.username = application.applicant.username.toLowerCase();
	    }
	  }, {
	    key: "triggerOpeningsModal",
	    value: function triggerOpeningsModal() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("#reached-openings-limit").modal("toggle");
	      });
	      _this.$timeout(function () {
	        $("#modal-add-openings").modal();
	      }, 300);
	    }
	  }, {
	    key: "sortApplicationsByField",
	    value: function sortApplicationsByField(field, applications) {
	      if (!applications || !applications.length) return applications;
	
	      applications.sort(function (a, b) {
	        if (a.applicant.firstName < b.applicant.firstName) return -1;
	        if (a.applicant.firstName > b.applicant.firstName) return 1;
	        return 0;
	      });
	
	      return applications;
	    }
	  }, {
	    key: "sortPendingApplicants",
	    value: function sortPendingApplicants() {
	      var _this = this;
	      _this.pendingApplicants.sort(function (a, b) {
	        if (a.applicant.firstName < b.applicant.firstName) return -1;
	        if (a.applicant.firstName > b.applicant.firstName) return 1;
	        return 0;
	      });
	      _this.$timeout(function () {
	        _this.checkForOverLaps();
	      }, 500);
	    }
	  }, {
	    key: "sortAcceptedApplicants",
	    value: function sortAcceptedApplicants() {
	      var _this = this;
	      _this.acceptedApplicants.sort(function (a, b) {
	        if (a.applicant.lastName < b.applicant.lastName) return -1;
	        if (a.applicant.lastName > b.applicant.lastName) return 1;
	        return 0;
	      });
	      //loading applicants -- latest code
	    }
	  }, {
	    key: "loadRejectedApplicants",
	    value: function loadRejectedApplicants() {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("LoadRejectedApplicants", _this.event);
	      }, 300);
	    }
	  }, {
	    key: "setRejectedApplicantToDirective",
	    value: function setRejectedApplicantToDirective(applicant) {
	      var _this = this;
	      console.log("setRejectedApplicantToDirective");
	      console.dir(applicant);
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("setRejectedApplicantToDirective", applicant);
	      });
	    }
	  }, {
	    key: "mapRejectedApplicantToPendingApplicants",
	    value: function mapRejectedApplicantToPendingApplicants(app) {
	      var _this = this;
	
	      var application = {};
	
	      application.applicant = {};
	      application.applicant.homeContactInfo = {};
	      application.jobble = {};
	      application.applicant.email = app.applicantEmail;
	      application.applicant.username = app.applicantEmail;
	      application.applicant.homeContactInfo.phoneMobile = app.applicantPhoneNumber;
	      application.applicant.homeContactInfo.city = app.applicantHomeContactInfo.city;
	      application.applicant.homeContactInfo.state = app.applicantHomeContactInfo.state;
	      application.applicant.id = app.applicantId;
	      application.applicant.displayRating = Math.round(app.averageRatingReceived);
	      application.applicant.isVerified = app.isApplicantVerified;
	      application.applicant.numberOfCompletedJobbles = app.numberOfCompletedJobbles;
	      application.applicant.firstName = app.applicantFirstName;
	      application.applicant.lastName = app.applicantLastName;
	      application.applicant.filePROFILE_IMAGE1IMG_75x75 = app.filePROFILE_IMAGE1IMG_75x75;
	      application.jobble.id = app.jobbleId;
	      application.id = app.id;
	      _this.event.numberOfPendingApplications = _this.event.numberOfPendingApplications + 1;
	      _this.pendingApplicants.unshift(application);
	      _this.fancyLoad(".reviewing-applicants-table tbody tr", _this.pendingApplicants.length);
	    }
	  }, {
	    key: "launchPendingModal",
	    value: function launchPendingModal() {
	      var _this = this;
	      console.log("launchPendingModal");
	    }
	  }, {
	    key: "fancyLoad",
	    value: function fancyLoad(cls, length) {
	      var _this = this;
	      _this.$auth.fancyLoad(cls, length);
	    }
	  }, {
	    key: "calcAccepted",
	    value: function calcAccepted(actual, api) {
	      var _this = this;
	      if (actual > api) {
	        _this.event.numberOfApprovedApplications = actual;
	      }
	      return actual;
	    }
	  }, {
	    key: "calcPending",
	    value: function calcPending(actual, api) {
	      var _this = this;
	      if (actual > api) {
	        _this.event.numberOfPendingApplications = actual;
	      }
	      return actual;
	    }
	  }, {
	    key: "checkForOverLaps",
	    value: function checkForOverLaps() {
	      var _this41 = this;
	
	      var apps = this.allApplicants;
	      var array = [];
	
	      try {
	        this.allApplicants.forEach(function (app) {
	          var newApp = {};
	          if (app.applicationStatus && app.applicationStatus !== 3) return;
	          newApp.jobbleId = app.jobbleId;
	          newApp.userId = app.applicantId;
	          newApp.appId = app.id;
	          array.push(newApp);
	        });
	      } catch (err) {
	        console.log("Error Looping applicants");
	        console.dir(err);
	      } finally {
	
	        if (array.length > 0) {
	          this.$events.checkForOverlaps(array).then(function (response) {
	            _this41.$timeout(function () {
	              _this41.markPendingApplicationAsOverlapped(apps, response.data);
	            });
	
	            _this41.overlaps = response.data;
	
	            _this41.$timeout(function () {
	              //this.unSetLoader();
	            }, 300);
	          }, function (error) {
	            _this41.unSetLoader();
	          });
	        }
	      }
	    }
	  }, {
	    key: "setEventOpenings",
	    value: function setEventOpenings(event) {
	      var _this42 = this;
	
	      this.$timeout(function () {
	        _this42.$rootScope.$emit("SetEventToEventDialog", {
	          event: _this42.event
	        });
	      });
	    }
	  }, {
	    key: "markPendingApplicationAsOverlapped",
	    value: function markPendingApplicationAsOverlapped(apps, applicationIds) {
	      var _this43 = this;
	
	      var _this = this;
	
	      var tempApp = null;
	
	      console.log("markPendingApplicationAsOverlapped");
	      console.log(apps, applicationIds);
	
	      try {
	        applicationIds.forEach(function (idObj) {
	          console.log(idObj);
	
	          var applicantId = idObj.id;
	
	          console.log("applicantId", applicantId);
	
	          var temp = _this43.allApplicants.find(function (o) {
	            return o.id === idObj.id;
	          });
	
	          if (temp) {
	            temp.hasOverlapNew = true;
	            temp.hasOverlappingJob = true;
	            temp.hasOverlappingJobAndHired = false;
	
	            idObj.conflictingJobbles.forEach(function (jobble) {
	              if (jobble.applicationStatus === 1) {
	                temp.hasOverlappingJobAndHired = true;
	              }
	            });
	
	            temp.conflictingJobbles = idObj.conflictingJobbles;
	          } else {
	            temp.hasOverlapNew = temp.hasOverlapNew || false;
	            temp.hasOverlappingJob = temp.hasOverlappingJob || false;
	            temp.hasOverlappingJobAndHired = temp.hasOverlappingJobAndHired || false;
	            temp.conflictingJobbles = temp.conflictingJobbles || [];
	          }
	
	          console.log(temp);
	        });
	      } finally {
	        this.enableToolTips();
	      }
	    }
	  }, {
	    key: "displayOverlappingJobbles",
	    value: function displayOverlappingJobbles(app, index) {
	      var _this = this;
	
	      _this.setLoader();
	      try {
	        _this.pendingApplicants.forEach(function (a) {
	          if (a.isOpen === true) {
	            console.log("we have one that  is open..");
	            a.isOpen = false;
	          }
	        });
	      } finally {
	        _this.$timeout(function () {
	          if (app.isOpen) {
	            app.isOpen = false;
	            _this.$timeout(function () {
	              $("#overlapping-jobbles-modal-wrapper-" + index + ".overlapping-jobbles-modal").removeClass("display-overlap-modal");
	            });
	          } else {
	            app.isOpen = true;
	            _this.$timeout(function () {
	              $("#overlapping-jobbles-modal-wrapper-" + index + ".overlapping-jobbles-modal").addClass("display-overlap-modal");
	            });
	            _this.$timeout(function () {
	              $("#overlapping-jobbles-modal-wrapper-" + index + ".overlapping-jobbles-modal").focus();
	            }, 200);
	          }
	          var overlapsToShow = _this.overlaps.find(function (o) {
	            return o.id === app.id;
	          });
	          _this.o = overlapsToShow;
	          _this.unSetLoader();
	        }, 300);
	      }
	    }
	  }, {
	    key: "findLinks",
	    value: function findLinks(ol) {
	      var _this = this;
	      ol.conflictingJobbles.forEach(function (lap) {
	        if (lap.companyName === _this.currentUser.company.name) {}
	      });
	    }
	  }, {
	    key: "closeOverlaps",
	    value: function closeOverlaps(app, index) {
	      var _this = this;
	
	      app.isOpen = false;
	      _this.$timeout(function () {
	        $("#overlapping-jobbles-modal-wrapper-" + index + ".overlapping-jobbles-modal").removeClass("display-overlap-modal");
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "checkApplicant",
	    value: function checkApplicant(applicant) {
	      applicant.isChecked = applicant.isChecked !== true;
	      this.checkForAtleastOneCheckedApplicant();
	    }
	  }, {
	    key: "checkAll",
	    value: function checkAll(onlyHired) {
	      console.log("check all");
	      console.dir(onlyHired);
	      if (this.ui.allChecked === false) {
	        console.log("we need to check.");
	        this.ui.allChecked = true;
	        this.checkOrUncheckAll(true, onlyHired);
	      } else {
	        this.ui.allChecked = false;
	        this.checkOrUncheckAll(false, onlyHired);
	      }
	
	      this.checkForAtleastOneCheckedApplicant();
	    }
	  }, {
	    key: "checkForAtleastOneCheckedApplicant",
	    value: function checkForAtleastOneCheckedApplicant() {
	      var _this44 = this;
	
	      this.weHaveOneCheckedJob = false;
	
	      if (!this.allApplicants || !this.allApplicants.length) {
	        this.ui.allChecked = false;
	        return;
	      }
	
	      this.allApplicants.forEach(function (applicant) {
	        if (applicant.isChecked === true) {
	          _this44.weHaveOneCheckedJob = true;
	        }
	      });
	
	      if (this.weHaveOneCheckedJob === false) {
	        this.ui.allChecked = false;
	      }
	    }
	  }, {
	    key: "checkOrUncheckAll",
	    value: function checkOrUncheckAll(checked, onlyHired) {
	      var _this45 = this;
	
	      if (!this.allApplicants || !this.allApplicants.length) {
	        this.checkForAtleastOneCheckedApplicant();
	        return;
	      }
	
	      var checkedUsers = [];
	
	      try {
	        this.allApplicants.forEach(function (applicant) {
	          if (onlyHired) {
	            if (applicant.applicationStatusRoster.id === 1) {
	              applicant.isChecked = false;
	
	              if (_this45.confirmationFilters.all) applicant.isChecked = checked;
	
	              var confirmationResponseExists = false;
	              var confirmationResponse = false;
	
	              if (_this45.shiftConfirmationData && _this45.shiftConfirmationData[_this45.singleShiftViewShiftPosition] && _this45.shiftConfirmationData[_this45.singleShiftViewShiftPosition][applicant.applicantId]) {
	
	                confirmationResponseExists = _this45.shiftConfirmationData[_this45.singleShiftViewShiftPosition][applicant.applicantId].confirmationResponseExists;
	                confirmationResponse = _this45.shiftConfirmationData[_this45.singleShiftViewShiftPosition][applicant.applicantId].confirmationResponse;
	              }
	
	              if (_this45.confirmationFilters.confirmed && confirmationResponseExists && confirmationResponse) applicant.isChecked = checked;
	
	              if (_this45.confirmationFilters.declined && confirmationResponseExists && !confirmationResponse) applicant.isChecked = checked;
	
	              if (_this45.confirmationFilters.no_response && !confirmationResponseExists) applicant.isChecked = checked;
	            } else {
	              applicant.isChecked = false;
	            }
	          } else {
	            if ((applicant.applicationStatusRoster.id || 3) === _this45.tabFilter) {
	              applicant.isChecked = checked;
	              checkedUsers.push(applicant);
	            } else {
	              applicant.isChecked = false;
	            }
	          }
	        });
	      } catch (err) {
	        console.error(err);
	      } finally {
	        console.log("all checked users");
	        console.dir(checkedUsers);
	      }
	
	      this.checkForAtleastOneCheckedApplicant();
	    }
	  }, {
	    key: "enterCheckInOutTime",
	    value: function enterCheckInOutTime(applicant, status, index, removedUser) {
	      var _this46 = this;
	
	      console.log("enterCheckInOutTime");
	      console.dir(applicant);
	      console.dir(status);
	      console.dir(index);
	      console.dir(removedUser);
	      //console.dir(this.shiftOptions[0]);
	      console.dir(this.shiftConfirmationData[this.singleShiftViewShiftPosition]);
	
	      if (removedUser) {
	        var randomShift = this.shiftOptions[0];
	        this.setSingleShiftView(randomShift, 0);
	      }
	
	      this.$tracking.reportRosterPageView("check in/out modal");
	
	      this.selectedstatus = status;
	
	      this.$timeout(function () {
	        _this46.editCheckInTime = false;
	        _this46.editCheckOutTime = false;
	
	        _this46.editCheckInTimes = {};
	        _this46.editCheckOutTimes = {};
	
	        jQuery("#timepicker-rosterstamp-1").timepicker({
	          step: 15,
	          timeFormat: "h:i A"
	        });
	        jQuery("#timepicker-rosterstamp-1").on("showTimepicker", function () {
	          jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker-rosterstamp-1").width() + 10 + "px");
	        });
	
	        jQuery("#timepicker-rosterstamp-2").timepicker({
	          step: 15,
	          timeFormat: "h:i A"
	        });
	        jQuery("#timepicker-rosterstamp-2").on("showTimepicker", function () {
	          jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker-rosterstamp-2").width() + 10 + "px");
	        });
	
	        _this46.check_in_data = {};
	        _this46.check_in_data.application = applicant;
	        _this46.check_in_data.status = status;
	        _this46.check_in_data.index = index;
	
	        _this46.selectedjobbler = applicant;
	
	        console.log("time", _this46.shiftConfirmationData[_this46.singleShiftViewShiftPosition][applicant.applicantId]);
	        console.log("time", _this46.shiftConfirmationData[_this46.singleShiftViewShiftPosition]);
	        console.log("time", _this46.shiftConfirmationData);
	
	        var checkInTimeMoment = _this46.shiftConfirmationData[_this46.singleShiftViewShiftPosition][applicant.applicantId].checkInTimeMoment;
	        var checkOutTimeMoment = _this46.shiftConfirmationData[_this46.singleShiftViewShiftPosition][applicant.applicantId].checkOutTimeMoment;
	
	        _this46.selectedjobbler.checkInTimeFormatted = checkInTimeMoment ? checkInTimeMoment.format("hh:mm A") : null;
	        _this46.selectedjobbler.checkOutTimeFormatted = checkOutTimeMoment ? checkOutTimeMoment.format("hh:mm A") : null;
	
	        _this46.selectedjobbler.jobblerNote = _this46.shiftConfirmationData[_this46.singleShiftViewShiftPosition][applicant.applicantId].jobblerNote || null;
	        _this46.selectedjobbler.confirmationResponse = _this46.shiftConfirmationData[_this46.singleShiftViewShiftPosition][applicant.applicantId].confirmationResponse || null;
	        _this46.selectedjobbler.confirmationResponseExists = _this46.shiftConfirmationData[_this46.singleShiftViewShiftPosition][applicant.applicantId].confirmationResponseExists;
	
	        jQuery("#modal-check-user-in-link").modal({
	          backdrop: true
	        });
	
	        var shift = _this46.singleShiftViewShift;
	        _this46.setModalSingleShiftView(shift, _this46.singleShiftViewOriginalIndex, applicant, true);
	
	        _this46.enableToolTips();
	      }, 100);
	    }
	  }, {
	    key: "determineTimeToDisplay",
	    value: function determineTimeToDisplay(shiftData) {
	      console.log("determineTimeToDisplay");
	      console.dir(shiftData);
	      console.dir(this.selectedjobbler);
	      //console.dir(this.shiftConfirmationData[shift.shiftPosition][applicant.applicantId]);
	      console.dir(this.shiftOptions);
	    }
	  }, {
	    key: "setModalSingleShiftView",
	    value: function setModalSingleShiftView(shift, index, applicant, init) {
	      console.log("setModalSingleShiftView");
	      console.dir(shift);
	      console.dir(applicant);
	      console.dir(init);
	      console.dir(this.shiftOptions);
	      //console.dir(this.shiftConfirmationData[shift.shiftPosition][applicant.applicantId]);
	      applicant = applicant || this.selectedjobbler;
	      this.modalSingleShiftViewId = shift.id;
	      this.modalSingleShiftViewShift = shift;
	      this.modalSingleShiftViewShiftPosition = shift.shiftPosition;
	      this.modalSingleShiftViewFormatted = "Shift " + (index + 1) + ": " + shift.shiftDateFormatted + " " + shift.shiftTZ;
	
	      this.selectedjobbler.jobblerNote = this.shiftConfirmationData[shift.shiftPosition][applicant.applicantId].jobblerNote || null;
	
	      var coordsForCheckIn = {
	        lat: shift.contactInfo.lat,
	        lng: shift.contactInfo.lng
	      };
	      this.loadMap(coordsForCheckIn.lat, coordsForCheckIn.lng, this.shiftConfirmationData[shift.shiftPosition][applicant.applicantId], shift.contactInfo, applicant, init);
	
	      this.$tracking.reportRosterPageClick("confirmation modal shift view");
	    }
	  }, {
	    key: "showOverlappingJobbles",
	    value: function showOverlappingJobbles(applicant) {
	      var _this47 = this;
	
	      this.$tracking.reportRosterPageView("overlapping jobbles");
	
	      this.$timeout(function () {
	        _this47.selectedjobblerOverlapping = applicant;
	
	        jQuery("#modal-overlapping").modal();
	      }, 100);
	    }
	  }, {
	    key: "openMakeShiftPayment",
	    value: function openMakeShiftPayment() {
	      var _this48 = this;
	
	      console.log("openMakeShiftPayment");
	      console.dir(this.singleShiftViewShift);
	
	      this.processWhoCanBePaid();
	      this.clearAllCards();
	
	      /*
	      if (!this.readyToPay.length) {
	        alert("There are no more users that need to be paid for this shift.");
	        return;
	      }
	      */
	
	      if (this.weHaveOneCheckedJob) return;
	
	      this.confirmAllHaveHours();
	
	      this.$timeout(function () {
	        jQuery("#modal-shift-payment").modal({
	          backdrop: true
	        });
	      }, 100);
	
	      this.enableToolTips();
	
	      this.$timeout(function () {
	        $(".remove-from-p-list").tooltip({});
	      }, 200);
	
	      jQuery("#modal-shift-payment").unbind("hidden.bs.modal").on("hidden.bs.modal", function () {
	        console.log("Modal CLOSED");
	
	        _this48.$timeout(function () {
	          _this48.processWhoCanBePaid();
	        });
	      });
	
	      console.log("ready to pay");
	      console.dir(this.readyToPay);
	    }
	  }, {
	    key: "openMakeAdditionalPayment",
	    value: function openMakeAdditionalPayment(jobbler) {
	      var _this49 = this;
	
	      this.clearAllCards();
	
	      this.readyToAdditionalPay = [];
	      this.additionalPaymentAmount = 0;
	      this.additionalPaymentAmountJobbler = 0;
	
	      if (!this.shiftConfirmationData || !this.shiftConfirmationData[this.singleShiftViewShiftPosition]) return;
	
	      this.hiredApplicants.forEach(function (applicant, i) {
	        var applicantId = applicant.applicantId;
	
	        var shiftData = _this49.shiftConfirmationData[_this49.singleShiftViewShiftPosition][applicantId];
	
	        if (!shiftData) return;
	
	        if (shiftData.statusNumber === 4) {
	          applicant.originalIndex = i;
	
	          if (jobbler.applicantId === applicantId) {
	            applicant.isReadyToAdditionalPayChecked = true;
	          } else {
	            applicant.isReadyToAdditionalPayChecked = false;
	          }
	
	          _this49.readyToAdditionalPay.push(applicant);
	        }
	      });
	
	      this.verifyAtLeastOneReadyToAdditionalPayChecked();
	      this.calculateAdditionalPaymentAmount();
	
	      this.$timeout(function () {
	        jQuery("#modal-additional-payment").modal();
	      }, 100);
	
	      this.enableToolTips();
	    }
	  }, {
	    key: "closeDoneAdditionalModal",
	    value: function closeDoneAdditionalModal(re) {
	      jQuery("#modal-additional-payment-done .modal-header button.close").trigger("click");
	
	      if (re) {
	        window.location.href = "/receipts";
	      }
	    }
	  }, {
	    key: "closeDoneModal",
	    value: function closeDoneModal(re) {
	      jQuery("#modal-shift-payment-done .modal-header button.close").trigger("click");
	
	      if (re) {
	        window.location.href = "/receipts";
	      }
	    }
	  }, {
	    key: "goToReceipts",
	    value: function goToReceipts() {
	      window.location.href = "/receipts";
	    }
	  }, {
	    key: "clearAllCards",
	    value: function clearAllCards() {
	      this.uncheckPaymentInfo();
	      this.selectedCard = null;
	    }
	  }, {
	    key: "verifyAtLeastOneReadyToPayChecked",
	    value: function verifyAtLeastOneReadyToPayChecked() {
	      var _this50 = this;
	
	      this.atLeastOneReadyToPayChecked = false;
	
	      this.readyToPay.forEach(function (applicant) {
	        if (applicant.isReadyToPayChecked) _this50.atLeastOneReadyToPayChecked = true;
	      });
	    }
	  }, {
	    key: "verifyAtLeastOneReadyToAdditionalPayChecked",
	    value: function verifyAtLeastOneReadyToAdditionalPayChecked() {
	      var _this51 = this;
	
	      this.atLeastOneReadyToAdditionalPayChecked = false;
	
	      this.readyToAdditionalPaySelected = [];
	      this.readyToAdditionalPay.forEach(function (applicant) {
	        if (applicant.isReadyToAdditionalPayChecked) {
	          _this51.readyToAdditionalPaySelected.push(applicant);
	          _this51.atLeastOneReadyToAdditionalPayChecked = true;
	        }
	      });
	    }
	  }, {
	    key: "closeRemoveFromPayment",
	    value: function closeRemoveFromPayment() {
	      jQuery("#modal-remove-from-payment .modal-header button.close").trigger("click");
	    }
	  }, {
	    key: "removeFromPayment",
	    value: function removeFromPayment(inApplicant) {
	      this.applicantToRemoveFromPayment = inApplicant;
	
	      this.$timeout(function () {
	        jQuery("#modal-remove-from-payment").modal();
	      }, 100);
	    }
	  }, {
	    key: "removeFromPaymentConfirmed",
	    value: function removeFromPaymentConfirmed() {
	      var inApplicant = this.applicantToRemoveFromPayment;
	
	      this.readyToPayNew = this.readyToPay;
	
	      this.$tracking.reportRosterPageSubmit("payment - remove from payment");
	
	      this.readyToPay = this.readyToPay.map(function (applicant) {
	        if (applicant.applicantId === inApplicant.applicantId) {
	          applicant.isReadyToPayChecked = false;
	          return null;
	        }
	
	        return applicant;
	      });
	
	      this.readyToPay = _.without(this.readyToPay, null);
	      this.closeRemoveFromPayment();
	      this.verifyAtLeastOneReadyToPayChecked();
	      this.calculateTotalPaymentOnEdit();
	    }
	  }, {
	    key: "processWhoCanBePaid",
	    value: function processWhoCanBePaid() {
	      var _this52 = this;
	
	      this.selectedCard = null;
	      this.readyToPay = [];
	
	      this.hasShowMoreApplicants = false;
	      this.allUnconfirmedApplicants = true;
	      this.allUsersHaveBeenPaidForThisShift = false;
	      var paidUsers = [];
	
	      if (!this.hiredApplicants || !this.hiredApplicants.length || !this.shiftConfirmationData || !this.shiftConfirmationData[this.singleShiftViewShiftPosition]) return;
	
	      if (this.removedApplicants) {
	        try {
	          this.removedApplicants.forEach(function (applicant, i) {
	
	            if (applicant.bgCheckStatus === "Pending") {
	              return;
	            }
	
	            var applicantId = applicant.applicantId;
	
	            var shiftData = _this52.shiftConfirmationData[_this52.singleShiftViewShiftPosition][applicantId];
	
	            applicant.shiftData = shiftData;
	
	            if (!shiftData) return;
	          });
	        } catch (err) {
	          console.log("error processing removed users");
	          console.dir(err);
	        } finally {
	          console.log("finshed processing removed users");
	        }
	      }
	
	      try {
	        this.hiredApplicants.forEach(function (applicant, i) {
	
	          if (applicant.bgCheckStatus === "Pending") {
	            return;
	          }
	
	          var applicantId = applicant.applicantId;
	
	          var shiftData = _this52.shiftConfirmationData[_this52.singleShiftViewShiftPosition][applicantId];
	
	          applicant.shiftData = shiftData;
	
	          if (!shiftData) return;
	
	          if (shiftData.groupNumber !== 1) {
	            _this52.hasShowMoreApplicants = true;
	          } else {
	            _this52.allUnconfirmedApplicants = false;
	          }
	
	          if (shiftData.statusNumber === 1 || shiftData.statusNumber === 2 || shiftData.statusNumber === 3) {
	            applicant.originalIndex = i;
	            _this52.readyToPay.push(applicant);
	          } else if (shiftData.statusNumber === 4) {
	            paidUsers.push(applicant);
	          } else if (shiftData.statusNumber === 5) {
	            paidUsers.push(applicant);
	          }
	        });
	      } catch (err) {
	        console.log("error processing paid users");
	        console.dir(err);
	      } finally {
	        if (this.hiredApplicants.length == paidUsers.length) {
	          this.allUsersHaveBeenPaidForThisShift = true;
	        }
	
	        this.calculateTotalPayment();
	      }
	    }
	  }, {
	    key: "determineHoursBasedOffCheckinAndCheckOut",
	    value: function determineHoursBasedOffCheckinAndCheckOut(applicant) {
	      var checkInTime = applicant.shiftData.checkInTimeMoment;
	      var checkOutTime = applicant.shiftData.checkOutTimeMoment;
	      var diffInMinutes = checkOutTime.diff(checkInTime, "minutes");
	      var minutes = diffInMinutes % 60;
	      var hours = Math.floor(diffInMinutes / 60);
	
	      applicant.shiftData.paymentHours = hours;
	      applicant.shiftData.totalMinutes = diffInMinutes;
	      applicant.hours = hours;
	      applicant.minutes = minutes;
	    }
	  }, {
	    key: "blurTimeEdit",
	    value: function blurTimeEdit(fromHTML, data, num) {
	      var _this53 = this;
	
	      this.$timeout(function () {
	        if (fromHTML) {
	          if (document.activeElement.className.includes("hours-edit-")) {
	            console.log("do nothing.");
	          } else {
	            _this53.blurHoursUpdated(data);
	          }
	        }
	      }, 100);
	    }
	  }, {
	    key: "setFocusOnInput",
	    value: function setFocusOnInput(num) {
	      console.log("setFocusOnInput");
	      if (num === 1) {
	        this.$timeout(function () {
	          $("input.hours-edit-1").focus();
	        });
	      } else if (num === 2) {
	        this.$timeout(function () {
	          $("input.hours-edit-2").focus();
	        });
	      } else if (num === 3) {
	        this.$timeout(function () {
	          $("input.hours-edit-3").focus();
	        });
	      } else if (num === 4) {
	        this.$timeout(function () {
	          $("input.hours-edit-4").focus();
	        });
	      }
	
	      this.$timeout(function () {
	        console.log("active element after focus");
	        console.dir(document.activeElement);
	      });
	    }
	  }, {
	    key: "showMeData",
	    value: function showMeData(data) {
	      console.log("show me");
	      console.dir(data);
	    }
	  }, {
	    key: "setEditing",
	    value: function setEditing(data, fromHTML) {
	      var _this54 = this;
	
	      console.log("set-editing-k");
	      this.$timeout(function () {
	        data.isEditingHours = true;
	        data.isEditingMinutes = true;
	        _this54.updatingHoursWorked = true;
	      });
	
	      if (fromHTML === 1 || fromHTML === 2 || fromHTML === 5) {
	        this.$timeout(function () {
	          $("input.hours-edit-1").focus();
	        });
	      } else if (fromHTML === 3 || fromHTML === 4) {
	        this.$timeout(function () {
	          $("input.hours-edit-2").focus();
	        });
	      } else if (fromHTML === 6 || fromHTML === 7 || fromHTML === 10) {
	        this.$timeout(function () {
	          $("input.hours-edit-3").focus();
	        });
	      } else if (fromHTML === 8 || fromHTML === 9) {
	        this.$timeout(function () {
	          $("input.hours-edit-4").focus();
	        });
	      }
	    }
	  }, {
	    key: "calculateTotalPayment",
	    value: function calculateTotalPayment() {
	      var _this55 = this;
	
	      //console.log("calculateTotalPayment");
	      //console.dir(this.readyToPay);
	
	      if (!this.shiftConfirmationData || !this.shiftConfirmationData[this.singleShiftViewShiftPosition]) return;
	
	      this.totalPaymentAmount = 0;
	      this.totalPaymentAmountJobbler = 0;
	
	      this.jobblersReadyForPayment = 0;
	      this.jobblersReadyForPaymentContigency = 0;
	
	      this.readyToPay.forEach(function (applicant, i) {
	        //console.log("ready to pay applicants");
	        //console.dir(applicant);
	
	        if (applicant.bgCheckStatus === "Pending") {
	          return;
	        }
	
	        var applicantId = applicant.applicantId;
	
	        var shiftData = _this55.shiftConfirmationData[_this55.singleShiftViewShiftPosition][applicantId];
	
	        //console.log("shift data");
	        //console.dir(shiftData);
	
	        if (!shiftData) return;
	
	        _this55.shiftConfirmationData[_this55.singleShiftViewShiftPosition][applicantId].isEditingMinutes = false;
	        _this55.shiftConfirmationData[_this55.singleShiftViewShiftPosition][applicantId].isEditingHours = false;
	
	        if (shiftData.statusNumber === 1 || shiftData.statusNumber === 2 || shiftData.statusNumber === 3) {
	          if (shiftData.statusNumber === 3 && shiftData.actualMinutesWorked === null) {
	            _this55.jobblersReadyForPaymentContigency += 1;
	
	            // Toggle Setting Total Minutes to Zero
	            _this55.shiftConfirmationData[_this55.singleShiftViewShiftPosition][applicantId].totalMinutes = 0;
	            _this55.shiftConfirmationData[_this55.singleShiftViewShiftPosition][applicantId].timeInterval.timeInHours = 0;
	            _this55.shiftConfirmationData[_this55.singleShiftViewShiftPosition][applicantId].timeInterval.timeInMinutes = 0;
	            _this55.shiftConfirmationData[_this55.singleShiftViewShiftPosition][applicantId].payment = 0;
	            _this55.shiftConfirmationData[_this55.singleShiftViewShiftPosition][applicantId].paymentJobbler = 0;
	          } else {
	            if (shiftData.statusNumber === 1) {
	              _this55.jobblersReadyForPayment += 1;
	            } else {
	              _this55.jobblersReadyForPaymentContigency += 1;
	            }
	
	            //console.log("this.totalPaymentAmount", this.totalPaymentAmount);
	            _this55.totalPaymentAmount = parseFloat(_this55.totalPaymentAmount) + parseFloat(_this55.shiftConfirmationData[_this55.singleShiftViewShiftPosition][applicant.applicantId].payment);
	            _this55.totalPaymentAmount = parseFloat(_this55.totalPaymentAmount);
	            //console.log("this.totalPaymentAmount", this.totalPaymentAmount);
	
	            //console.log("this.totalPaymentAmountJobbler", this.totalPaymentAmountJobbler);
	            _this55.totalPaymentAmountJobbler = parseFloat(_this55.totalPaymentAmountJobbler) + parseFloat(_this55.shiftConfirmationData[_this55.singleShiftViewShiftPosition][applicant.applicantId].paymentJobbler);
	            _this55.totalPaymentAmountJobbler = parseFloat(_this55.totalPaymentAmountJobbler);
	            //console.log("this.totalPaymentAmountJobbler", this.totalPaymentAmountJobbler);
	          }
	        }
	      });
	
	      this.confirmAllHaveHours();
	    }
	  }, {
	    key: "calculateAdditionalPaymentAmount",
	    value: function calculateAdditionalPaymentAmount() {
	      // this.additionalPaymentAmount = this.additionalPaymentAmountJobbler / (1 - this.currentUser.company.defaultPlan.jobblerFeePct);
	      this.additionalPaymentAmount = this.additionalPaymentAmountJobbler * (1 + this.currentUser.company.defaultPlan.companyFeePct);
	
	      this.totalAdditionalPaymentAmountJobbler = this.additionalPaymentAmountJobbler * this.readyToAdditionalPaySelected.length;
	      this.totalAdditionalPaymentAmount = this.additionalPaymentAmount * this.readyToAdditionalPaySelected.length;
	    }
	  }, {
	    key: "calculateTotalPaymentOnEdit",
	    value: function calculateTotalPaymentOnEdit() {
	      var _this56 = this;
	
	      if (!this.shiftConfirmationData || !this.shiftConfirmationData[this.singleShiftViewShiftPosition]) return;
	
	      this.totalPaymentAmount = 0;
	      this.totalPaymentAmountJobbler = 0;
	
	      this.jobblersReadyForPaymentContigency = 0;
	
	      var payPerHourJobbler = this.event.subEvents[0].deduppedJobbles[0].jobblerRate;
	      var payPerHour = payPerHourJobbler * (1 + this.currentUser.company.defaultPlan.companyFeePct);
	
	      this.readyToPay.forEach(function (applicant, i) {
	        var applicantId = applicant.applicantId;
	
	        var shiftData = _this56.shiftConfirmationData[_this56.singleShiftViewShiftPosition][applicantId];
	
	        if (!shiftData) return;
	
	        if (shiftData.statusNumber === 3 && shiftData.actualMinutesWorked === null) {
	          _this56.jobblersReadyForPaymentContigency += 1;
	        } else if (shiftData.statusNumber !== 1) {
	          _this56.jobblersReadyForPaymentContigency += 1;
	        }
	
	        if (shiftData.statusNumber === 1 || shiftData.statusNumber === 2 || shiftData.statusNumber === 3) {
	          var totalMinutes = parseFloat(shiftData.timeInterval.timeInHours) * 60 + parseFloat(shiftData.timeInterval.timeInMinutes);
	          var payment = (Math.round(totalMinutes * payPerHour / 100 / 60 * 100) / 100).toFixed(2);
	          var paymentJobbler = (Math.round(totalMinutes * payPerHourJobbler / 100 / 60 * 100) / 100).toFixed(2);
	
	          //console.log("user.payment", payment);
	          //console.log("user.paymentJobbler", paymentJobbler);
	          //console.dir((totalMinutes * payPerHour) / 100 / 60);
	
	          shiftData.totalMinutes = totalMinutes;
	          shiftData.payment = payment;
	          shiftData.paymentJobbler = paymentJobbler;
	
	          //console.log("this.totalPaymentAmount", this.totalPaymentAmount);
	          //console.log("shiftData.payment", shiftData.payment, parseFloat(shiftData.payment));
	          _this56.totalPaymentAmount = parseFloat(_this56.totalPaymentAmount) + parseFloat(shiftData.payment);
	          _this56.totalPaymentAmount = parseFloat(_this56.totalPaymentAmount);
	          //console.log("this.totalPaymentAmount", this.totalPaymentAmount);
	
	          //console.log("this.totalPaymentAmountJobbler", this.totalPaymentAmountJobbler);
	          _this56.totalPaymentAmountJobbler = parseFloat(_this56.totalPaymentAmountJobbler) + parseFloat(shiftData.paymentJobbler);
	          _this56.totalPaymentAmountJobbler = parseFloat(_this56.totalPaymentAmountJobbler);
	          //console.log("this.totalPaymentAmountJobbler", this.totalPaymentAmountJobbler);
	        }
	      });
	
	      this.confirmAllHaveHours();
	
	      this.enableToolTips();
	    }
	  }, {
	    key: "calculateTotalPaymentOnRejectionEdit",
	    value: function calculateTotalPaymentOnRejectionEdit() {
	      var _this57 = this;
	
	      if (!this.shiftConfirmationData || !this.shiftConfirmationData[this.singleShiftViewShiftPosition]) return;
	
	      this.totalRejectionPaymentAmount = 0;
	      this.totalRejectionPaymentAmountJobbler = 0;
	
	      var payPerHourJobbler = this.event.subEvents[0].deduppedJobbles[0].jobblerRate;
	      var payPerHour = payPerHourJobbler * (1 + this.currentUser.company.defaultPlan.companyFeePct);
	
	      this.paymentContingenciesShiftPositions.forEach(function (shiftPosition) {
	        _this57.paymentContingenciesMap[shiftPosition].forEach(function (applicant) {
	          var applicantId = applicant.applicantId;
	
	          var shiftData = _this57.shiftConfirmationData[shiftPosition][applicantId];
	
	          if (!shiftData) return;
	
	          if (shiftData.statusNumber === 1 || shiftData.statusNumber === 2 || shiftData.statusNumber === 3) {
	            var totalMinutes = parseFloat(shiftData.timeInterval.timeInHours) * 60 + parseFloat(shiftData.timeInterval.timeInMinutes);
	            var payment = (Math.round(totalMinutes * payPerHour / 100 / 60 * 100) / 100).toFixed(2);
	            var paymentJobbler = (Math.round(totalMinutes * payPerHourJobbler / 100 / 60 * 100) / 100).toFixed(2);
	
	            console.log("user.payment", payment);
	            console.log("user.paymentJobbler", paymentJobbler);
	            console.dir(totalMinutes * payPerHour / 100 / 60);
	
	            shiftData.totalMinutes = totalMinutes;
	            shiftData.payment = payment;
	            shiftData.paymentJobbler = paymentJobbler;
	
	            console.log("this.totalRejectionPaymentAmount", _this57.totalRejectionPaymentAmount);
	            console.log("shiftData.payment", shiftData.payment, parseFloat(shiftData.payment));
	
	            _this57.totalRejectionPaymentAmount = parseFloat(_this57.totalRejectionPaymentAmount) + parseFloat(shiftData.payment);
	            _this57.totalRejectionPaymentAmount = parseFloat(_this57.totalRejectionPaymentAmount);
	            console.log("this.totalRejectionPaymentAmount", _this57.totalRejectionPaymentAmount);
	
	            console.log("this.totalRejectionPaymentAmountJobbler", _this57.totalRejectionPaymentAmountJobbler);
	            _this57.totalRejectionPaymentAmountJobbler = parseFloat(_this57.totalRejectionPaymentAmountJobbler) + parseFloat(shiftData.paymentJobbler);
	            _this57.totalRejectionPaymentAmountJobbler = parseFloat(_this57.totalRejectionPaymentAmountJobbler);
	            console.log("this.totalRejectionPaymentAmountJobbler", _this57.totalRejectionPaymentAmountJobbler);
	          }
	        });
	      });
	
	      this.confirmAllRejectionsHaveHours();
	
	      this.enableToolTips();
	    }
	  }, {
	    key: "blurHoursUpdated",
	    value: function blurHoursUpdated(shiftData) {
	      console.log("SUBMITTING EDIITNF DATA", shiftData);
	      this.updatingHoursWorked = true;
	      this.updateHoursWorked(shiftData);
	      this.$timeout(function () {
	        shiftData.isEditingHours = false;
	        shiftData.isEditingMinutes = false;
	      }, 300);
	    }
	  }, {
	    key: "confirmAllHaveHours",
	    value: function confirmAllHaveHours() {
	      var _this58 = this;
	
	      this.allHaveHours = true;
	
	      try {
	        this.readyToPay.forEach(function (applicant, i) {
	          var applicantId = applicant.applicantId;
	
	          var shiftData = _this58.shiftConfirmationData[_this58.singleShiftViewShiftPosition][applicantId];
	
	          if (!shiftData) return;
	
	          //console.log("TIMEESS", shiftData.timeInterval.timeInHours, shiftData.timeInterval.timeInMinutes);
	          if (!shiftData.timeInterval.timeInHours && !shiftData.timeInterval.timeInMinutes) _this58.allHaveHours = false;
	
	          if (shiftData.timeInterval.timeInHours || shiftData.timeInterval.timeInMinutes) {
	            var payPerHourJobbler = _this58.event.subEvents[0].deduppedJobbles[0].jobblerRate;
	            // const payPerHour = payPerHourJobbler / (1 - this.currentUser.company.defaultPlan.jobblerFeePct);
	            var payPerHour = payPerHourJobbler * (1 + _this58.currentUser.company.defaultPlan.companyFeePct);
	
	            var totalMinutes = parseFloat(shiftData.timeInterval.timeInHours) * 60 + parseFloat(shiftData.timeInterval.timeInMinutes);
	            var payment = (Math.round(totalMinutes * payPerHour / 100 / 60 * 100) / 100).toFixed(2);
	            var paymentJobbler = (Math.round(totalMinutes * payPerHourJobbler / 100 / 60 * 100) / 100).toFixed(2);
	
	            //console.log("on change", payment, paymentJobbler);
	
	            if (payment < 0.5) _this58.allHaveHours = false;
	          }
	        });
	      } catch (err) {} finally {
	        //console.log("ALL HAVE HOURS?", this.allHaveHours);
	        this.prepareAllApplicantsCSV(this.allApplicants);
	      }
	    }
	  }, {
	    key: "confirmAllRejectionsHaveHours",
	    value: function confirmAllRejectionsHaveHours() {
	      var _this59 = this;
	
	      this.allRejectionsHaveHours = true;
	
	      this.paymentContingenciesShiftPositions.forEach(function (shiftPosition) {
	        _this59.paymentContingenciesMap[shiftPosition].forEach(function (applicant) {
	          var applicantId = applicant.applicantId;
	
	          var shiftData = _this59.shiftConfirmationData[shiftPosition][applicantId];
	
	          if (!shiftData) return;
	
	          if (!shiftData.timeInterval.timeInHours && !shiftData.timeInterval.timeInMinutes) _this59.allRejectionsHaveHours = false;
	
	          if (shiftData.timeInterval.timeInHours || shiftData.timeInterval.timeInMinutes) {
	            var payPerHourJobbler = _this59.event.subEvents[0].deduppedJobbles[0].jobblerRate;
	            // const payPerHour = payPerHourJobbler / (1 - this.currentUser.company.defaultPlan.jobblerFeePct);
	            var payPerHour = payPerHourJobbler * (1 + _this59.currentUser.company.defaultPlan.companyFeePct);
	
	            var totalMinutes = parseFloat(shiftData.timeInterval.timeInHours) * 60 + parseFloat(shiftData.timeInterval.timeInMinutes);
	            var payment = (Math.round(totalMinutes * payPerHour / 100 / 60 * 100) / 100).toFixed(2);
	            var paymentJobbler = (Math.round(totalMinutes * payPerHourJobbler / 100 / 60 * 100) / 100).toFixed(2);
	
	            console.log("on change", payment, paymentJobbler);
	
	            if (payment < 0.5) _this59.allRejectionsHaveHours = false;
	          }
	        });
	      });
	
	      console.log("ALL RJECTIONS HAVE HOURS?", this.allRejectionsHaveHours);
	    }
	  }, {
	    key: "updateHoursWorked",
	    value: function updateHoursWorked(data, silent) {
	      var _this60 = this;
	
	      if (this.updatingHoursWorkedBackend === true) {
	        return;
	      }
	
	      this.updatingHoursWorkedBackend = true;
	      var minutes = data.totalMinutes;
	      var shiftId = data.shiftId;
	
	      console.log("total minutes");
	      console.dir(minutes);
	
	      this.setLoader();
	
	      data.actualMinutesWorked = minutes;
	
	      this.$events.updateActualMinutesWorkedForShift(shiftId, minutes).then(function (response) {
	        var shiftPaid = data.shiftPaid,
	            checkInTime = data.checkInTime,
	            checkOutTime = data.checkOutTime,
	            confirmationResponse = data.confirmationResponse;
	
	        var _setApplicantStatus5 = _this60.setApplicantStatus(data, shiftPaid, checkInTime, checkOutTime, confirmationResponse),
	            status = _setApplicantStatus5.status,
	            statusNumber = _setApplicantStatus5.statusNumber,
	            groupNumber = _setApplicantStatus5.groupNumber;
	
	        data.status = status;
	        data.statusNumber = statusNumber;
	        data.groupNumber = groupNumber;
	
	        _this60.calculateTotalPaymentOnEdit();
	
	        _this60.confirmAllHaveHours();
	
	        _this60.$timeout(function () {
	          _this60.updatingHoursWorked = false;
	          _this60.updatingHoursWorkedBackend = false;
	          if (!silent) {
	            _this60.unSetLoader();
	          } else {
	            _this60.unSetLoader();
	          }
	        }, 1000);
	      }, function (error) {
	        var shiftPaid = data.shiftPaid,
	            checkInTime = data.checkInTime,
	            checkOutTime = data.checkOutTime,
	            confirmationResponse = data.confirmationResponse;
	
	        var _setApplicantStatus6 = _this60.setApplicantStatus(data, shiftPaid, checkInTime, checkOutTime, confirmationResponse),
	            status = _setApplicantStatus6.status,
	            statusNumber = _setApplicantStatus6.statusNumber,
	            groupNumber = _setApplicantStatus6.groupNumber;
	
	        data.status = status;
	        data.statusNumber = statusNumber;
	        data.groupNumber = groupNumber;
	
	        _this60.calculateTotalPaymentOnEdit();
	
	        _this60.confirmAllHaveHours();
	
	        _this60.$timeout(function () {
	          _this60.updatingHoursWorked = false;
	          _this60.updatingHoursWorkedBackend = false;
	          if (!silent) {
	            _this60.unSetLoader();
	          } else {
	            _this60.unSetLoader();
	          }
	        }, 1000);
	      });
	    }
	  }, {
	    key: "toggleCheckInOrOutEdit",
	    value: function toggleCheckInOrOutEdit(edit, checkOut) {
	      if (checkOut) {
	        this.editCheckOutTime = edit;
	      } else {
	        this.editCheckInTime = edit;
	      }
	
	      this.$timeout(function () {
	        jQuery("#timepicker-rosterstamp-1").timepicker({
	          step: 15,
	          timeFormat: "h:i A"
	        });
	        jQuery("#timepicker-rosterstamp-1").on("showTimepicker", function () {
	          jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker-rosterstamp-1").width() + 10 + "px");
	        });
	
	        jQuery("#timepicker-rosterstamp-2").timepicker({
	          step: 15,
	          timeFormat: "h:i A"
	        });
	        jQuery("#timepicker-rosterstamp-2").on("showTimepicker", function () {
	          jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker-rosterstamp-2").width() + 10 + "px");
	        });
	      });
	    }
	  }, {
	    key: "toggleCheckInOrOutEditNew",
	    value: function toggleCheckInOrOutEditNew(edit, checkOut, index) {
	      var _this61 = this;
	
	      this.$timeout(function () {
	        if (checkOut) {
	          _this61.editCheckOutTimes[index + ""] = edit;
	        } else {
	          _this61.editCheckInTimes[index + ""] = edit;
	        }
	      });
	
	      this.$timeout(function () {
	        jQuery("#timepicker-rosterstamp-in-" + index).timepicker({
	          step: 15,
	          timeFormat: "h:i A"
	        });
	        jQuery("#timepicker-rosterstamp-in-" + index).on("showTimepicker", function () {
	          jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker-rosterstamp-in-" + index).width() + 10 + "px");
	        });
	
	        jQuery("#timepicker-rosterstamp-out-" + index).timepicker({
	          step: 15,
	          timeFormat: "h:i A"
	        });
	        jQuery("#timepicker-rosterstamp-out-" + index).on("showTimepicker", function () {
	          jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker-rosterstamp-out-" + index).width() + 10 + "px");
	        });
	      }, 100);
	    }
	  }, {
	    key: "submitNewTimeForCheckInOrOut",
	    value: function submitNewTimeForCheckInOrOut(checkOut, shift, timefull) {
	      this.calcTimeZone(checkOut, shift, timefull);
	    }
	  }, {
	    key: "calcTimeZone",
	    value: function calcTimeZone(checkOut, shift, timefull) {
	      var date = null;
	      var userTimeZoneName = moment.tz.guess();
	      var now = moment.tz(userTimeZoneName);
	      var dayfull = moment().format("MMM DD YYYY");
	
	      if (!timefull) return;
	
	      var nowThere = moment.tz(shift.contactInfo.place.timeZoneId);
	      var timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
	      var zone = moment.tz.zone(moment.tz.guess());
	      var eventMangerOffsets = -zone.offsets[zone.offsets.length - 1];
	      var eventOffsets = shift.contactInfo.place.rawOffset / 60000;
	      var fulldate = dayfull + " " + timefull;
	      var dateconverted = new Date(fulldate);
	
	      var dateforDB = moment(dateconverted).add(eventMangerOffsets - eventOffsets, "minutes").format();
	
	      var formatted_date = moment(dateconverted).add(eventMangerOffsets - eventOffsets, "minutes").format("hh:mm A");
	
	      this.checkInOrOutJobblers([this.selectedjobbler], checkOut, formatted_date, dateforDB, shift);
	    }
	  }, {
	    key: "closeAllOverLapsModals",
	    value: function closeAllOverLapsModals() {
	      var _this = this;
	
	      if (_this.pendingApplicants.length > 0) {
	        _this.pendingApplicants.forEach(function (a, index) {
	          if (a.isOpen === true) {
	            a.isOpen = false;
	            _this.$timeout(function () {
	              $("#overlapping-jobbles-modal-wrapper-" + index + ".overlapping-jobbles-modal").removeClass("display-overlap-modal");
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: "checkEventOpenings",
	    value: function checkEventOpenings(eventId) {
	      var _this62 = this;
	
	      this.$events.getOpenings(eventId).then(function (response) {
	        var openingsData = response.data;
	
	        if (openingsData.numberOfOpenings === 0) {
	          //disable hire button, show warning
	          _this62.isThereRoomForHire = false;
	        } else {
	          //leave alone
	          _this62.isThereRoomForHire = true;
	        }
	
	        _this62.$timeout(function () {
	          //this.unSetLoader();
	        }, 1000);
	      }, function (response) {
	        console.log("we have an error getting openings");
	        console.dir(response);
	      });
	    }
	  }, {
	    key: "getUserTimeZone",
	    value: function getUserTimeZone() {
	      console.log("get user timezone");
	      console.dir(Intl.DateTimeFormat().resolvedOptions().timeZone);
	      var userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	      if (userTimeZone) {
	        this.timeZoneInfo = "Please be aware all times displayed below are in your local timezone (" + userTimeZone + ")";
	      } else {
	        this.timeZoneInfo = "Please be aware all times displayed below are in your local timezone";
	      }
	    }
	  }, {
	    key: "reloadRosterPage",
	    value: function reloadRosterPage() {
	      //checkInOrOutJobblerswindow.location.reload();
	    }
	  }]);
	
	  return EventreviewapplicantsController;
	}();
	
	EventreviewapplicantsController.$inject = ["$http", "$localStorage", "$state", "auth", "events", "$stateParams", "security", "common", "scroll", "$rootScope", "$scope", "$window", "env", "$timeout", "messagingv2", "tracking", "$anchorScroll", "$location"];
	
	exports.default = EventreviewapplicantsController;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ScrollService = function () {
	  function ScrollService($http, $localStorage, $state, $q, SecurityService, AuthService, $rootScope, $timeout, EnvService) {
	    _classCallCheck(this, ScrollService);
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$q = $q;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$rootScope = $rootScope;
	    this.galleryPictures = [];
	    this.$env = EnvService;
	    this.$timeout = $timeout;
	    this.after = "";
	  }
	
	  _createClass(ScrollService, [{
	    key: "loadMoreApplicationsReviewPage",
	    value: function loadMoreApplicationsReviewPage(id, offset, max, env, status) {
	      console.log("loadMoreApplicationsReviewPage");
	      console.log(id);
	      console.log(offset);
	      console.log(max);
	      console.log(env);
	      console.log(status);
	
	      var _this = this;
	
	      var url = env.getAPIEndPoint() + "jbl/v1/subevents/" + id + "/applications?format=json&offset=" + offset + "&max=" + max + "&status=" + status + "&fields=id,applicant.dateBirth,applicant.numberOfCompletedJobbles,applicant.firstName,applicant.lastName,applicant.undeletedPaymentInfos,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,jobble.id,applicant.id,applicant.homeContactInfo.city,applicant.homeContactInfo.state,applicant.isVerified,applicant.username,applicant.paymentInfos.id";
	
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + _this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "sortSet",
	    value: function sortSet(list, x, header) {
	      var _this = this;
	
	      console.log("in side sort set");
	      console.dir(list);
	      console.dir(x);
	      console.dir(header);
	      console.dir(header.order);
	      var order = header.order;
	
	      switch (x) {
	        case 1:
	          if (order === 1) {
	            list.sort(function (a, b) {
	              if (a.applicant.firstName < b.applicant.firstName) return -1;
	              if (a.applicant.firstName > b.applicant.firstName) return 1;
	              return list;
	            });
	          } else {
	            list.sort(function (a, b) {
	              if (a.applicant.firstName > b.applicant.firstName) return -1;
	              if (a.applicant.firstName < b.applicant.firstName) return 1;
	              return list;
	            });
	          }
	
	          return list;
	          break;
	
	        case 2:
	          if (order === 1) {
	            list.sort(function (a, b) {
	              if (a.applicant.numberOfCompletedJobbles < b.applicant.numberOfCompletedJobbles) return -1;
	              if (a.applicant.numberOfCompletedJobbles > b.applicant.numberOfCompletedJobbles) return 1;
	              return list;
	            });
	          } else {
	            list.sort(function (a, b) {
	              if (a.applicant.numberOfCompletedJobbles > b.applicant.numberOfCompletedJobbles) return -1;
	              if (a.applicant.numberOfCompletedJobbles < b.applicant.numberOfCompletedJobbles) return 1;
	              return list;
	            });
	          }
	
	          return list;
	          break;
	        case 3:
	          if (order === 1) {
	            list.sort(function (a, b) {
	              if (a.applicant.firstName < b.applicant.firstName) return -1;
	              if (a.applicant.firstName > b.applicant.firstName) return 1;
	              return list;
	            });
	          } else {
	            list.sort(function (a, b) {
	              if (a.applicant.firstName > b.applicant.firstName) return -1;
	              if (a.applicant.firstName < b.applicant.firstName) return 1;
	              return list;
	            });
	          }
	
	          return list;
	          break;
	
	        case 4:
	          if (order === 1) {
	            list.sort(function (a, b) {
	              if (a.applicant.averageRatingReceived < b.applicant.averageRatingReceived) return -1;
	              if (a.applicant.averageRatingReceived > b.applicant.averageRatingReceived) return 1;
	              return list;
	            });
	          } else {
	            list.sort(function (a, b) {
	              if (a.applicant.averageRatingReceived > b.applicant.averageRatingReceived) return -1;
	              if (a.applicant.averageRatingReceived < b.applicant.averageRatingReceived) return 1;
	              return list;
	            });
	          }
	
	          return list;
	          break;
	
	        default:
	          console.log("something went very wrong");
	          return list;
	      }
	    }
	
	    //_this.currentUser.company.id, _this.events.length, 3, _this.$rootScope.sessionParams.page, _this.$rootScope.sessionParams.sort,  _this.$rootScope.sessionParams.order,  _this.$rootScope.sessionParams.isCancelled,  _this.$rootScope.sessionParams.isCompleted, _this.$env, 1
	
	  }, {
	    key: "loadMoreEvents",
	    value: function loadMoreEvents(id, offset, max, page, sort, order, isCancelled, isCompleted, env, status, dates) {
	      var _this = this;
	      /*
	      let url = env.getAPIEndPoint() + 'jbl/v1/companies/' + id + '/events?sort=' + sort +  '&order=' + order + '&max=' + max + '&offset=' + offset + '&conf=web&format=json&isCompleted='+ isCompleted +'&isCancelled=' + isCancelled + '&fields=id,name,orderNumber,isPublished,isClosed,isCompleted,isCancelled,contactInfo.place.timeZoneId,contactInfo.state,contactInfo.city,isChannelDeleted,contactInfo.streetLine1,contactInfo.zipCode,startTime,endTime,isSourcingPost,numberOfApprovedApplications,numberOfPendingApplications,numberOfOpenings,subEvents.id,subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.isPublished,subEvents.deduppedJobbles.jobbleType.name,subEvents.deduppedJobbles.jobbleType.fileJOBBLE_TYPE_FILE01IMG_600x600,subEvents.deduppedJobbles.jobbleType.id,subEvents.deduppedJobbles.applications.id,subEvents.deduppedJobbles.applications.applicationStatus,subEvents.deduppedJobbles.applications.applicant.firstName,subEvents.deduppedJobbles.applications.applicant.lastName';
	      if (_.isEmpty(dates)===false){
	      url = url + "&startTime="+dates.start+"&endTime="+dates.end;
	      }
	      //let url = env.getAPIEndPoint()+'jbl/v1/companies/'+id+'/listEvents?max='+max+'&offset='+offset;
	      */
	      var url = env.getAPIEndPoint() + "jbl/v1/companies/" + id + "/listEvents?sort=" + sort + "&order=" + order + "&max=" + max + "&offset=" + offset + "&isCompleted=" + isCompleted + "&isCancelled=" + isCancelled;
	      if (_.isEmpty(dates) === false) {
	        url = url + "&startTime=" + dates.start + "&endTime=" + dates.end;
	      }
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + this.$auth.getAccessToken()
	        },
	        data: {}
	      };
	      return this.$http(req);
	    }
	  }]);
	
	  return ScrollService;
	}();
	
	exports.default = ScrollService;
	
	
	ScrollService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "$timeout", "env"];

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(464);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventreviewapplicants.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventreviewapplicants.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "eventreviewapplicants #wrapper{min-height:calc(100% - 62px)}", ""]);
	
	// exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _rejectedapplicants = __webpack_require__(466);
	
	var _rejectedapplicants2 = _interopRequireDefault(_rejectedapplicants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rejectedapplicantsModule = _angular2.default.module("rejectedapplicants", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("rejectedapplicants", {
	    //url: '/event/:eventId/review',
	    template: "<rejectedapplicants></rejectedapplicants>"
	  });
	}).component("rejectedapplicants", _rejectedapplicants2.default);
	
	exports.default = rejectedapplicantsModule;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rejectedapplicants = __webpack_require__(467);
	
	var _rejectedapplicants2 = _interopRequireDefault(_rejectedapplicants);
	
	var _rejectedapplicants3 = __webpack_require__(468);
	
	var _rejectedapplicants4 = _interopRequireDefault(_rejectedapplicants3);
	
	__webpack_require__(469);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rejectedapplicantsComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _rejectedapplicants2.default,
	  controller: _rejectedapplicants4.default,
	  controllerAs: "vm"
	};
	
	exports.default = rejectedapplicantsComponent;

/***/ }),
/* 467 */
/***/ (function(module, exports) {

	module.exports = "<!--  -->\n<div class=\"jobs-review-hire-bottom\" ng-show=\"vm.show_tables\">\n  <hr />\n  <ul class=\"nav nav-pills jobs-review-hire-tablist-nav\" role=\"tablist\" ng-if=\"!vm.event.isSourcingPost\">\n    <li\n      role=\"presentation\"\n      ng-class=\"{ 'underline-apps' : vm.page == 1, 'disabled-apps' : vm.page != 1 }\"\n      ng-click=\"vm.setPage(1)\"\n      title=\"A user has been removed from the application pool\"\n    >\n      REJECTED\n    </li>\n    <li\n      ng-class=\"{ 'underline-apps' : vm.page == 2, 'disabled-apps' : vm.page != 2 }\"\n      role=\"presentation\"\n      ng-click=\"vm.setPage(2)\"\n      title=\"A user from the accepted pool has quit the job.\"\n    >\n      QUIT\n    </li>\n    <li\n      ng-class=\"{ 'underline-apps' : vm.page == 3, 'disabled-apps' : vm.page != 3 }\"\n      role=\"presentation\"\n      ng-click=\"vm.setPage(3)\"\n      title=\"A user from the pending pool has withdrawn their application.\"\n    >\n      WITHDRAWN\n    </li>\n  </ul>\n  <div class=\"reviewing-hired-wrapper-container rejects\">\n    <table id=\"review-accepted-applicants-rejects\">\n      <thead>\n        <tr>\n          <th></th>\n          <th>Name</th>\n          <th>Email</th>\n          <th>Phone</th>\n          <th></th>\n        </tr>\n      </thead>\n      <tbody ng-show=\"vm.page==1\">\n        <tr ng-repeat=\"reject in vm.rejects\" ng-class=\"{ 'highlight-red-reject' : reject.applicantIsDeleted===true }\">\n          <td>\n            <img src=\"{{reject.filePROFILE_IMAGE1IMG_75x75}}\" style=\"width: 20px\" />\n          </td>\n          <td>{{reject.applicantLastName}}, {{reject.applicantFirstName}}</td>\n          <td>{{reject.applicantEmail}}</td>\n          <td ng-show=\"reject.applicantIsDeleted===true\" style=\"border-right: none\">Deleted</td>\n          <td ng-show=\"reject.applicantIsDeleted===false || !reject.applicantIsDeleted\">\n            {{reject.applicantPhoneNumber?reject.applicantPhoneNumber:\"N/A\"}}\n          </td>\n          <td ng-click=\"vm.reverse(reject)\" ng-show=\"reject.applicantIsDeleted===false || !reject.applicantIsDeleted\">\n            <i class=\"fa fa-history\" title=\"Reverse Rejection\"> </i>\n          </td>\n          <td ng-click=\"vm.reverse(reject)\" ng-show=\"reject.applicantIsDeleted===true\"></td>\n        </tr>\n      </tbody>\n\n      <tbody ng-show=\"vm.page==3\">\n        <tr ng-repeat=\"reject in vm.withdraws\" ng-class=\"{ 'highlight-red-reject' : reject.applicantIsDeleted===true }\">\n          <td>\n            <img src=\"{{reject.filePROFILE_IMAGE1IMG_75x75}}\" style=\"width: 20px\" />\n          </td>\n          <td>{{reject.applicantLastName}}, {{reject.applicantFirstName}}</td>\n          <td>{{reject.applicantEmail}}</td>\n          <td ng-show=\"reject.applicantIsDeleted===true\" style=\"border-right: none\">Deleted</td>\n          <td ng-show=\"reject.applicantIsDeleted===false || !reject.applicantIsDeleted\">\n            {{reject.applicantPhoneNumber?reject.applicantPhoneNumber:\"N/A\"}}\n          </td>\n          <td ng-click=\"vm.reverse(reject)\" ng-show=\"reject.applicantIsDeleted===false || !reject.applicantIsDeleted\">\n            <i class=\"fa fa-history\" title=\"Reverse Rejection\"> </i>\n          </td>\n          <td ng-click=\"vm.reverse(reject)\" ng-show=\"reject.applicantIsDeleted===true\"></td>\n        </tr>\n      </tbody>\n\n      <tbody ng-show=\"vm.page==2\">\n        <tr ng-repeat=\"reject in vm.quitters\" ng-class=\"{ 'highlight-red-reject' : reject.applicantIsDeleted===true }\">\n          <td>\n            <img src=\"{{reject.filePROFILE_IMAGE1IMG_75x75}}\" style=\"width: 20px\" />\n          </td>\n          <td>{{reject.applicantLastName}}, {{reject.applicantFirstName}}</td>\n          <td>{{reject.applicantEmail}}</td>\n          <td ng-show=\"reject.applicantIsDeleted===true\" style=\"border-right: none\">Deleted</td>\n          <td ng-show=\"reject.applicantIsDeleted===false || !reject.applicantIsDeleted\">\n            {{reject.applicantPhoneNumber?reject.applicantPhoneNumber:\"N/A\"}}\n          </td>\n          <td ng-click=\"vm.reverse(reject)\" ng-show=\"reject.applicantIsDeleted===false || !reject.applicantIsDeleted\">\n            <i class=\"fa fa-history\" title=\"Reverse Rejection\"> </i>\n          </td>\n          <td ng-click=\"vm.reverse(reject)\" ng-show=\"reject.applicantIsDeleted===true\"></td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _common = __webpack_require__(112);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _scroll = __webpack_require__(462);
	
	var _scroll2 = _interopRequireDefault(_scroll);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _messagingv = __webpack_require__(30);
	
	var _messagingv2 = _interopRequireDefault(_messagingv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RejectedapplicantsController = function () {
	  function RejectedapplicantsController($http, $localStorage, $state, AuthService, EventsService, $stateParams, SecurityService, CommonService, ScrollService, $rootScope, $scope, EnvService, $timeout, Messagingv2Service, TrackingService, $anchorScroll, $location) {
	    _classCallCheck(this, RejectedapplicantsController);
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    $localStorage.activeStateName = "events";
	    this.name = "rejectedapplicants";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$events = EventsService;
	    this.$stateParams = $stateParams;
	    this.$security = SecurityService;
	    this.$common = CommonService;
	    this.$scroll = ScrollService;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$messagingv2 = Messagingv2Service;
	    this.$anchor = $anchorScroll;
	    //this.rejects = [];
	    //this.quitters = [];
	    //this.withdraws = [];
	    this.page = 1;
	    this.$env = EnvService;
	    this.$location = $location;
	    this.$timeout = $timeout;
	    var _this = this;
	
	    _this.LoadRejectedApplicantsListener = _this.$rootScope.$on("LoadRejectedApplicants", function ($event, params) {
	      _this.setRejectedApplicants(params, 100, 0);
	    });
	
	    _this.setRejectedApplicantToDirectiveListener = _this.$rootScope.$on("setRejectedApplicantToDirective", function ($event, params) {
	      _this.mapRejectedApplicant(params);
	    });
	
	    _this.$scope.$on("$destroy", _this.LoadRejectedApplicantsListener);
	    _this.$scope.$on("$destroy", _this.setRejectedApplicantToDirectiveListener);
	  }
	
	  _createClass(RejectedapplicantsController, [{
	    key: "mapRejectedApplicant",
	    value: function mapRejectedApplicant(a) {
	      var _this = this;
	
	      var reject = {};
	      console.log("we are def missing some data");
	      console.dir(a);
	      reject.applicantFirstName = a.applicant.firstName;
	      reject.applicantLastName = a.applicant.lastName;
	      reject.applicantEmail = a.applicant.username;
	      reject.applicantPhoneNumber = a.applicant.homeContactInfo.phoneMobile;
	      reject.filePROFILE_IMAGE1IMG_75x75 = a.applicant.filePROFILE_IMAGE1IMG_75x75 ? a.applicant.filePROFILE_IMAGE1IMG_75x75 : "/app/vendor/images/brax.png";
	      reject.applicantHomeContactInfo = {};
	      reject.applicantHomeContactInfo.city = a.applicant.homeContactInfo.city;
	      reject.applicantHomeContactInfo.state = a.applicant.homeContactInfo.state;
	      reject.averageRatingReceived = a.applicant.displayRating;
	      reject.numberOfCompletedJobbles = a.applicant.numberOfCompletedJobbles;
	      reject.isApplicantVerified = a.applicant.isVerified;
	      reject.id = a.id;
	      reject.applicantId = a.applicant.id;
	
	      _this.rejects.unshift(reject);
	      _this.figure_out_which_table();
	    }
	  }, {
	    key: "setRejectedApplicants",
	    value: function setRejectedApplicants(params, max, offset) {
	      var _this = this;
	      var jpid = params.subEvents[0].deduppedJobbles[0].jobblePoolId;
	      _this.$events.getRejectingApplicationsTrimmedReview(jpid, max).then(function (response) {
	        console.log("response");
	        console.dir(response);
	        var rejects = response.data;
	        console.log("rejects response");
	        console.dir(rejects);
	        try {
	          rejects.forEach(function (r) {
	            console.log("iteration?");
	            _this.fixApplicantPhone(r);
	            _this.findDeletedApplicants(r);
	          });
	        } catch (err) {
	          console.log("error with rejects");
	          console.dir(err);
	        } finally {
	          console.log("in the finally..");
	          console.dir(rejects);
	          _this.getQuitApplicants(jpid);
	          _this.getWithdrawnApplicants(jpid);
	          _this.rejects = rejects;
	        }
	      }, function (error) {
	        //alert()
	      });
	    }
	  }, {
	    key: "fixApplicantPhone",
	    value: function fixApplicantPhone(applicant) {
	      var _this = this;
	      var num = applicant.applicantPhoneNumber;
	      if (num) {
	        if (num.charAt(0) === "1") {
	          num = num.slice(1, num.length);
	        }
	        var cleaned = ("" + num).replace(/\D/g, "");
	        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
	        if (match) {
	          applicant.applicantPhoneNumber = "(" + match[1] + ") " + match[2] + "-" + match[3];
	        } else {
	          applicant.applicantPhoneNumber = num;
	        }
	      }
	    }
	  }, {
	    key: "reverse",
	    value: function reverse(app) {
	      var _this = this;
	      var aid = app.id;
	      console.log("reverse");
	      console.dir(app);
	      _this.setLoader();
	      _this.$events.reverseReject(aid).then(function (response) {
	        console.log("response");
	        console.dir(response);
	        _this.splice_application(app, response.data.jobble.id);
	        _this.unSetLoader();
	      }, function (error) {
	        alert("Error : " + error);
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "splice_application",
	    value: function splice_application(app, jid) {
	      var _this = this;
	      var app_to_splice = null;
	      var index_to_splice = null;
	      if (_this.page === 1) {
	        app_to_splice = _this.rejects.find(function (o) {
	          return o.id === app.id;
	        });
	        index_to_splice = _this.rejects.findIndex(function (x) {
	          return x.id === app.id;
	        });
	        _this.rejects.splice(index_to_splice, 1);
	        _this.check_for_more(1);
	      } else if (_this.page === 3) {
	        app_to_splice = _this.withdraws.find(function (o) {
	          return o.id === app.id;
	        });
	        index_to_splice = _this.withdraws.findIndex(function (x) {
	          return x.id === app.id;
	        });
	        _this.withdraws.splice(index_to_splice, 1);
	        _this.check_for_more(3);
	      } else {
	        app_to_splice = _this.quitters.find(function (o) {
	          return o.id === app.id;
	        });
	        index_to_splice = _this.quitters.findIndex(function (x) {
	          return x.id === app.id;
	        });
	        _this.quitters.splice(index_to_splice, 1);
	        _this.check_for_more(2);
	      }
	      _this.set_application_to_pending(app_to_splice, jid);
	    }
	  }, {
	    key: "check_for_more",
	    value: function check_for_more(p) {
	      var _this = this;
	      switch (p) {
	        case 1:
	          console.log("case 1");
	          break;
	        case 2:
	          console.log("case 2");
	          break;
	        case 3:
	          console.log("case 3");
	          break;
	      }
	    }
	  }, {
	    key: "set_application_to_pending",
	    value: function set_application_to_pending(app, jid) {
	      var _this = this;
	      if (!app.jobbleId) {
	        app.jobbleId = jid;
	      }
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetApplicationToPending", app);
	      });
	    }
	  }, {
	    key: "findDeletedApplicants",
	    value: function findDeletedApplicants(app) {
	      var _this = this;
	      if (app.applicantIsDeleted === true) {
	        console.log("we found one");
	      }
	    }
	  }, {
	    key: "getWithdrawnApplicants",
	    value: function getWithdrawnApplicants(poolId) {
	      var _this = this;
	      _this.$events.getWithdrawnApplicationsTrimmedReview(poolId, 100).then(function (response) {
	        var w = response.data;
	        try {
	          w.forEach(function (withd) {
	            _this.fixApplicantPhone(withd);
	            _this.findDeletedApplicants(withd);
	          });
	        } catch (err) {} finally {
	          _this.withdraws = w;
	          _this.$timeout(function () {
	            _this.figure_out_which_table();
	          }, 300);
	        }
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "getQuitApplicants",
	    value: function getQuitApplicants(poolId) {
	      var _this = this;
	      _this.$events.getQuitedApplicationsTrimmedReview(poolId, 100).then(function (response) {
	        var q = response.data;
	        try {
	          q.forEach(function (quitter) {
	            _this.fixApplicantPhone(quitter);
	            _this.findDeletedApplicants(quitter);
	          });
	        } catch (err) {} finally {
	          _this.quitters = q;
	          console.log("_this.quitters");
	          console.dir(_this.quitters);
	        }
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "setPage",
	    value: function setPage(p) {
	      var _this = this;
	
	      _this.page = p;
	    }
	  }, {
	    key: "figure_out_which_table",
	    value: function figure_out_which_table() {
	      var _this = this;
	
	      if (_this.rejects.length > 0 || _this.quitters.length > 0 || _this.withdraws.length > 0) {
	        _this.show_tables = true;
	        if (_this.rejects.length > 0) {
	          _this.page = 1;
	          return;
	        } else if (_this.quitters.length > 0) {
	          _this.page = 2;
	          return;
	        } else {
	          _this.page = 3;
	        }
	      }
	    }
	  }]);
	
	  return RejectedapplicantsController;
	}();
	
	RejectedapplicantsController.$inject = ["$http", "$localStorage", "$state", "auth", "events", "$stateParams", "security", "common", "scroll", "$rootScope", "$scope", "env", "$timeout", "messagingv2", "tracking", "$anchorScroll", "$location"];
	
	exports.default = RejectedapplicantsController;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(470);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./rejectedapplicants.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./rejectedapplicants.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _messaging = __webpack_require__(472);
	
	var _messaging2 = _interopRequireDefault(_messaging);
	
	__webpack_require__(477);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messagingModule = _angular2.default.module("messaging", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("messaging", {
	    url: "/messages/event/:eventId",
	    template: "<messaging></messaging>"
	  });
	}).component("messaging", _messaging2.default);
	
	exports.default = messagingModule;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _messaging = __webpack_require__(473);
	
	var _messaging2 = _interopRequireDefault(_messaging);
	
	var _messaging3 = __webpack_require__(474);
	
	var _messaging4 = _interopRequireDefault(_messaging3);
	
	__webpack_require__(475);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messagingComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _messaging2.default,
	  controller: _messaging4.default,
	  controllerAs: "vm"
	};
	
	exports.default = messagingComponent;

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	module.exports = "<h1>Not Found</h1>\n"

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _common = __webpack_require__(112);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _messagingv = __webpack_require__(30);
	
	var _messagingv2 = _interopRequireDefault(_messagingv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MessagingController = function MessagingController($http, $localStorage, $scope, $state, AuthService, EventsService, $stateParams, SecurityService, CommonService, $rootScope, EnvService, $timeout, $location, Messagingv2Service) {
	  _classCallCheck(this, MessagingController);
	
	  this.name = "messaging";
	  $localStorage.activeStateName = "messaging";
	
	  if (!AuthService.isLoggedIn()) {
	    $state.go("signin");
	    return;
	  }
	
	  this.$http = $http;
	  this.$localStorage = $localStorage;
	  this.$state = $state;
	  this.$location = $location;
	  this.$auth = AuthService;
	  this.$events = EventsService;
	  this.$stateParams = $stateParams;
	  this.$scope = $scope;
	  this.$security = SecurityService;
	  this.showGalleryForChat = false;
	  this.defaultText = "Write your message...";
	  this.$common = CommonService;
	  this.$rootScope = $rootScope;
	  this.setEnterCtrl = false;
	  this.$env = EnvService;
	  this.$timeout = $timeout;
	  this.$messagingv2 = Messagingv2Service;
	  this.getChatFirst = false;
	  this.disable_send = false;
	  this.composingNewChat = false;
	  this.selection = [];
	  this.currentUser = this.$auth.getUserData();
	  this.remain_loading_count = 1;
	  this.thereAreChatsForThisEvent = true;
	  this.jobblersInDefaultChat = [];
	  this.eventLocation = null;
	  this.jobblersForNewChatFromChosen = [];
	  this.checkAdminStatus();
	  this.textareaText = this.defaultText;
	  this.disablePostButton = false;
	
	  var _this = this;
	};
	
	MessagingController.$inject = ["$http", "$localStorage", "$scope", "$state", "auth", "events", "$stateParams", "security", "common", "$rootScope", "env", "$timeout", "$location", "messagingv2"];
	
	exports.default = MessagingController;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(476);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./messaging.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./messaging.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "messaging #wrapper{min-height:calc(100% - 62px)}", ""]);
	
	// exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(478);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".jobs-complete-container .back-to-inbox{font-family:Poppins,sans-serif;font-size:11px;font-weight:500;letter-spacing:.3px;line-height:11px;margin-bottom:16px;margin-top:16px}.jobs-complete-container .back-to-inbox a{color:#33373a}.jobs-complete-container .event-details{background:#fff;margin:16px 0;padding:10px;border:1px solid #adbcc2;box-shadow:0 2px 4px 0 rgba(0,0,0,.2);border-radius:6px}.jobs-complete-container .shifts-container{height:45px;overflow-y:scroll}.jobs-complete-container .shifts-container::-webkit-scrollbar{width:0;background:transparent}.jobs-complete-container .event-name{color:#33373a;font-family:Poppins,sans-serif;font-size:14px;font-weight:600;line-height:21px}.jobs-complete-container .event-info-container{color:#33373a;font-family:Poppins,sans-serif;font-size:11px;font-weight:500;letter-spacing:.3px;line-height:11px;margin-bottom:8px}.jobs-complete-container .event-info-container i{width:15px}.jobs-complete-container .header-titles{color:#33373a;font-family:Poppins,sans-serif;font-size:11px;font-weight:500;letter-spacing:.3px;text-transform:uppercase}.messages-container{margin:0;margin-bottom:50px;box-shadow:0 2px 4px 0 rgba(0,0,0,.2);border-radius:6px}.chat-name{flex:1;color:#33373a;font-size:14px;font-weight:600}.chat-last-message,.chat-name{font-family:Poppins,sans-serif;line-height:14px}.chat-last-message{font-size:12px;opacity:.75;margin-top:8px}.chat-last-message-time{font-family:Poppins,sans-serif;font-size:11px;font-weight:400;letter-spacing:.3px;line-height:11px;margin-top:8px;opacity:.5}.groupmessages-sidebar{overflow-x:hidden}.groupmessages-sidebar-right.select-teams ul li a{border-bottom:1px solid #adbcc261}.groupmessages-sidebar-right::-webkit-scrollbar,.groupmessages-sidebar::-webkit-scrollbar{width:0;background:transparent}.message-list::-webkit-scrollbar{width:0;background:transparent}.chat-group{padding:8px;padding-left:16px;min-height:100px;padding-top:20px;cursor:pointer}.new-message-highlight-new-container{border-left:2px solid red}.chat-name-header{display:flex}.chat-missed-message{flex:0 0 20px;text-align:center;background:red;border-radius:100%;color:#fff;height:20px;font-size:12px;line-height:20px}.message-header{display:flex}.message-header .message-profile{flex:0 0 42px;margin-right:8px}.message-header .message-profile img{border-radius:100%;border:1px solid #62c046}.groupmessages{margin:0}.received-text{margin-left:0}.send-text{background:#74cf59;margin-top:0}.received-text,.send-text{font-weight:400;line-height:18px;padding:8px 12px}.chat-username,.received-text,.send-text{font-family:Poppins,sans-serif;font-size:12px;letter-spacing:.3px}.chat-username{color:#33373a;font-weight:500;text-transform:uppercase}.message-text-time{font-family:Poppins,sans-serif;font-size:11px;font-weight:400;letter-spacing:.3px;line-height:11px;margin-bottom:4px;opacity:.45}.send-textmessage .message-text-time{text-align:right}.group-messages-header,.groupmessages,.groupmessages-sidebar-right{border-left:none}.group-messages-header,.groupmessages,.groupmessages-sidebar,.groupmessages-sidebar-right,.messages-title{border-color:#adbcc2}.groupmessages-sidebar-right{border-radius:0 6px 6px 0}.groupmessages-sidebar{border-radius:6px 0 0 6px}.loading-container{height:30px;background:none!important;padding:6px 20px!important}.loading-box{width:100%;height:10px;margin-top:4px;background:linear-gradient(270deg,#f3f3f2,#e2e3e2);background-position:0;animation-timing-function:ease-in-out;background-size:200%;animation:myfirst 1s;-moz-animation:myfirst 1s infinite;-webkit-animation:myfirst 1s infinite}.chat-group-loader{background:linear-gradient(270deg,#f3f3f2,#e2e3e2);background-position:0;animation-timing-function:ease-in-out;background-size:200%;animation:myfirst 1s;-moz-animation:myfirst 1s infinite;-webkit-animation:myfirst 1s infinite;height:15px;width:70%}", ""]);
	
	// exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _eventroster = __webpack_require__(480);
	
	var _eventroster2 = _interopRequireDefault(_eventroster);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventrosterModule = _angular2.default.module("eventroster", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("eventroster", {
	    url: "/event/:eventId/roster",
	    template: "<eventroster></eventroster>"
	  }).state("eventroster-shift", {
	    url: "/event/:eventId/roster/:shiftId",
	    template: "<eventroster></eventroster>"
	  });
	}).component("eventroster", _eventroster2.default);
	
	exports.default = eventrosterModule;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventroster = __webpack_require__(481);
	
	var _eventroster2 = _interopRequireDefault(_eventroster);
	
	var _eventroster3 = __webpack_require__(482);
	
	var _eventroster4 = _interopRequireDefault(_eventroster3);
	
	__webpack_require__(486);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventrosterComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _eventroster2.default,
	  controller: _eventroster4.default,
	  controllerAs: "vm"
	};
	
	exports.default = eventrosterComponent;

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<!------------------- Banner-Status --------------------->\n<div class=\"jobs-complete-banner\"></div>\n<!------------------- Banner-Status --------------------->\n\n<!--------------------- Container --------------------->\n<div class=\"jobs-complete-container\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\">\n        <div class=\"back-to-jobs\">\n          <a href=\"jobs-dashboard\">Back to Jobs</a>\n        </div>\n\n        <!--Sidebar-->\n        <eventsidebar></eventsidebar>\n        <!--Sidebar-->\n      </div>\n\n      <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\">\n        <div class=\"jobs-overview-content\">\n          <div class=\"jobs-overview-content-inner\">\n            <div class=\"overview-image-large\">\n              <img\n                src=\"{{ vm.event.subEvents[0].deduppedJobbles[0].jobbleType.picture1 ? vm.event.subEvents[0].deduppedJobbles[0].jobbleType.picture1 : '/app/vendor/images/default-jobble-image.jpeg' }}\"\n                alt=\"Jobble Biz\"\n                title=\"Jobble Biz\"\n              />\n\n              <div class=\"jobs-overview-top-all\">\n                <nav class=\"jobs-overview-nav\"></nav>\n\n                <h1>{{vm.event.name}}</h1>\n              </div>\n            </div>\n\n            <div class=\"jobble-tip clearfix spacing-for-jobble-tip\">\n              <h5>Jobble Tip</h5>\n              <p>\n                Below is a list of all the shifts that were created for this job. To view the roster of a particular shift, click on the \"Roster\"\n                button.\n              </p>\n\n              <button ng-click=\"vm.printRoster()\" ng-if=\"vm.pagestatus === 2\" class=\"btn btn-success button\">\n                <i class=\"fa fa-print\"></i> Print Roster\n              </button>\n\n              <button\n                ng-csv=\"vm.csv\"\n                csv-header=\"vm.getHeader()\"\n                filename=\"{{ vm.csvName }}\"\n                field-separator=\",\"\n                decimal-separator=\".\"\n                ng-click=\"vm.downloadRoster()\"\n                class=\"btn btn-success button\"\n                ng-if=\"vm.pagestatus === 2\"\n              >\n                <i class=\"fa fa-table\"></i> Download CSV\n              </button>\n            </div>\n\n            <div class=\"jobblers-rating\" ng-if=\"vm.pagestatus === 1\">\n              <div class=\"roster-badge clearfix\">\n                <ul class=\"nav nav-pills\" role=\"tablist\">\n                  <li role=\"presentation\">\n                    SHIFTS\n                    <span class=\"badge jobs-roster-badge\">{{ vm.shiftss.length }}</span>\n                  </li>\n                </ul>\n              </div>\n\n              <div class=\"jobblers-rating-area\">\n                <div class=\"jobblers-rating-box\" ng-repeat=\"shift in vm.shiftss track by $index\">\n                  <div class=\"jobblers-rating-box-lt\" style=\"width: 69%\">\n                    <h4>{{ vm.showAddress(shift.contactInfo) }}</h4>\n                    <span>Date <strong>{{ vm.showStartTime(shift.timeInterval.startTime) }}</strong></span>\n                    <span>Start <strong>{{ vm.showTime(shift, shift.timeInterval.startTime) }}</strong></span>\n                    <span>End <strong>{{ vm.showTime(shift, shift.timeInterval.endTime) }}</strong></span>\n                  </div>\n\n                  <div class=\"jobblers-rating-box-rt\" style=\"width: 30%\">\n                    <a href=\"#\" class=\"btn btn-default button\" ng-click=\"vm.viewShiftRoster(shift, $index)\">Roster</a>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"jobblers-rating\" ng-if=\"vm.pagestatus === 2\">\n              <div class=\"roster-badge clearfix\">\n                <ul class=\"nav nav-pills\" role=\"tablist\">\n                  <li role=\"presentation\" ng-if=\"!vm.event.isSourcingPost\">\n                    ROSTER\n                    <span class=\"badge jobs-roster-badge\">{{ jobblers.length }}</span>\n                  </li>\n                  <li role=\"presentation\" ng-if=\"vm.event.isSourcingPost\">\n                    Candidates\n                    <span class=\"badge jobs-roster-badge\">{{ jobblers.length }}</span>\n                  </li>\n                </ul>\n\n                <p>\n                  If you have any issues please\n                  <a href=\"mailto:high-five@jobbleapp.com\">contact us</a>\n                </p>\n              </div>\n\n              <div class=\"jobblers-rating-area\" ng-if=\"vm.jobblers.length == 0\">\n                <div class=\"panel overview-review-bottom-box\">\n                  <div class=\"panel-heading overview-review-heading white-bg\">Whoops!</div>\n                  <div class=\"panel-body overview-review-body text-center white-bg\">\n                    <p ng-if=\"!vm.event.isSourcingPost\">No roster yet.</p>\n                    <p ng-if=\"vm.event.isSourcingPost\">No candidates yet.</p>\n                    <a href=\"/event/{{vm.event.id}}/review\" class=\"btn btn-success button\" ng-if=\"!vm.event.isSourcingPost\">Review applicants</a>\n                    <a href=\"/event/{{vm.event.id}}/review\" class=\"btn btn-success button\" ng-if=\"vm.event.isSourcingPost\">Review candidates</a>\n                  </div>\n                </div>\n              </div>\n\n              <table class=\"table table-border line-item-table table-responsive checkin-table\" ng-if=\"vm.jobblers.length > 0\">\n                <thead>\n                  <tr>\n                    <!--<th></th>-->\n                    <th>Name</th>\n                    <th>Phone</th>\n                    <th>Checked in</th>\n                    <th>Checked out</th>\n                    <th>Checkin</th>\n                    <th>Confirmations &nbsp;<i class=\"fas fa-info-circle\" title=\"View / Edit Applicant Confirmations\"></i></th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr\n                    ng-repeat=\"jobbler in vm.jobblers\"\n                    ng-class=\"{'user-has-declined' : jobbler.currentShift.confirmationResponse === false, 'user-has-confirmed' : jobbler.currentShift.confirmationResponse === true}\"\n                  >\n                    <!--\n\t                                \t\t\t<td>\n\t                                \t\t\t\t<img style=\"width:20px;border-radius:50%;\" src=\"{{ jobbler.applicant.filePROFILE_IMAGE1IMG_75x75 ? jobbler.applicant.filePROFILE_IMAGE1IMG_75x75 : '/app/vendor/images/defaultimg.jpeg' }}\" alt=\"\">\n\t                                \t\t\t</td>\n\t                                \t\t\t-->\n                    <td>\n                      <a href=\"\" ng-click=\"vm.displayDetails(jobbler)\"> {{ jobbler.applicant.lastName }}, {{ jobbler.applicant.firstName }} </a>\n                    </td>\n\n                    <td>{{ jobbler.applicant.homeContactInfo.phoneMobile ? jobbler.applicant.homeContactInfo.phoneMobile : '--' }}</td>\n                    <td ng-click=\"vm.enterCheckInOutTime(jobbler, 1, $index)\">\n                      <i class=\"fa fa-pencil\" ng-if=\"jobbler.table_data.icon_flags.showedit_starttime\" title=\"Edit Checkin Time\"></i>\n                      <i class=\"fa fa-plus\" ng-if=\"!jobbler.table_data.icon_flags.showedit_starttime\" title=\"Add A Checkin Time\"></i>\n\n                      <span class=\"time-for-roster\"> {{ jobbler.currentShift.checkInAndOutForDisplay.start_time }} </span>\n                    </td>\n                    <td ng-click=\"vm.enterCheckInOutTime(jobbler, 2, $index)\">\n                      <i class=\"fa fa-pencil\" ng-if=\"jobbler.table_data.icon_flags.showedit_endtime\" title=\"Edit Checkout Time\"> </i>\n                      <i class=\"fa fa-plus\" ng-if=\"!jobbler.table_data.icon_flags.showedit_endtime\" title=\"Add A Checkout Time\"> </i>\n\n                      <span class=\"time-for-roster\"> {{ jobbler.currentShift.checkInAndOutForDisplay.end_time }} </span>\n                    </td>\n\n                    <td ng-if=\"!jobbler.table_data.disable_actions\">\n                      <!-- class=\"btn btn-success button checkin\" -->\n                      <a\n                        href=\"#\"\n                        ng-if=\"jobbler.table_data.buttons.show_checkin\"\n                        ng-click=\"vm.checkInForShift(jobbler, $index)\"\n                        title=\"Check User in with Current Time\"\n                        class=\"btn btn-success button checkin\"\n                      >\n                        Checkin\n                      </a>\n                      <!-- class=\"btn btn-success button checkout\" -->\n                      <a\n                        href=\"#\"\n                        ng-if=\"jobbler.table_data.buttons.show_checkout\"\n                        ng-click=\"vm.checkOutForShift(jobbler, $index)\"\n                        title=\"Check User out with Current Time\"\n                        class=\"btn btn-success button checkout\"\n                      >\n                        Checkout\n                      </a>\n                    </td>\n\n                    <td ng-if=\"jobbler.table_data.disable_actions\">--</td>\n\n                    <td>\n                      <!--\n\t                                \t\t\t\t<a \n\t                                \t\t\t\t\tng-click=\"vm.triggerConfirmationModal(jobbler)\" \n\t                                \t\t\t\t\tng-if=\"jobbler.currentShift.confirmationDateTime\"\n\t                                \t\t\t\t\thref=\"\"\n\t                                \t\t\t\t\tclass=\"btn btn-success button edit-confirmation\">\n\t                                \t\t\t\t\tView\n\t                                \t\t\t\t</a>\n\t                                \t\t\t\t-->\n\n                      <a ng-click=\"vm.triggerConfirmationModal(jobbler)\" href=\"\" class=\"btn btn-success button checkin\"> View </a>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n\n              <!--\n\t                                <div class=\"jobblers-rating-area\" ng-repeat=\"jobbler in vm.jobblers\" ng-if=\"vm.jobblers.length > 0\">\n\t                                    <div class=\"jobblers-rating-box\">\n\t                                        <div class=\"jobblers-rating-box-lt\" style=\"width:68%;\">\n\t                                            <img src=\"{{ jobbler.applicant.filePROFILE_IMAGE1IMG_75x75 ? jobbler.applicant.filePROFILE_IMAGE1IMG_75x75 : '/app/vendor/images/defaultimg.jpeg' }}\" alt=\"\">\n\t                                            <h4>{{ jobbler.applicant.firstName }} {{ jobbler.applicant.lastName }}</h4>\n\t                                            <span>Email <strong><a href=\"mailto:{{jobbler.applicant.email}}\">{{ jobbler.applicant.email }}</a></strong></span>\n\t                                            <span>Phone <strong>{{ jobbler.applicant.homeContactInfo.phoneMobile ? jobbler.applicant.homeContactInfo.phoneMobile : '--' }}</strong></span>\n\t                                            <div class=\"row\" ng-if=\"!vm.event.isSourcingPost\">\n\t                                            \t<div class=\"col-sm-12\">\n\t                                            \t\t<div class=\"col-sm-6 checkin-labels\" ng-click=\"vm.enterCheckInOutTime(jobbler, 1)\">\n\t                                            \t\t\t<label>Checked in</label>\n\t                                            \t\t\t<span class=\"time-for-roster\">{{ vm.showCheckInTime(jobbler.currentShift.checkInAndOutForDisplay.start_time) }}</span>\n\t                                            \t\t</div>\n\t                                            \t\t<div class=\"col-sm-6 checkin-labels\" ng-click=\"vm.enterCheckInOutTime(jobbler, 2)\">\n\t                                            \t\t\t<label>Checked out</label>\n\t                                            \t\t\t<span class=\"time-for-roster\">{{ vm.showCheckInTime(jobbler.currentShift.checkInAndOutForDisplay.end_time) }}</span>\n\t                                            \t\t</div>\n\t                                            \t</div>\n\t                                            </div>\n\t                                        </div>\n\t                                        \n\t                                        <div class=\"jobblers-rating-box-rt\" style=\"width:26%;\">\n\t                                            <div class=\"row\" ng-if=\"!vm.event.isSourcingPost\">\n\t                                            \n\t                                            \t<div class=\"col-sm-12\"  ng-if=\"!jobbler.currentShift.checkInTime\" style=\"margin-top:15px;\">\n\t                                            \t\t<a href=\"#\" class=\"btn btn-success button\" ng-click=\"vm.checkInForShift(jobbler, $index)\">Checkin</a>\n\t                                            \t</div>\n\t                                            \t\n\t                                            \t<div class=\"col-sm-12\" ng-if=\"jobbler.currentShift.checkInTime\" style=\"margin-top:15px;\">\n\t                                            \t\t<a href=\"#\" class=\"btn btn-success button\" ng-click=\"vm.checkOutForShift(jobbler, $index)\">Checkout</a>\n\t                                            \t</div>\n\t                                            \t\n\t                                            </div>\n\t                                        </div>\n\t                                    </div>\n\t                                </div>\n\t                                -->\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<jobblefooter></jobblefooter>\n\n<jobblerprofile></jobblerprofile>\n<eventdialog></eventdialog>\n<globalalert></globalalert>\n\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n\n<!--\n<a href=\"#modal-check-user-in-link\"  data-toggle=\"modal\" id=\"modal-check-user-in\"></a>\n-->\n<div class=\"modal fade\" id=\"modal-check-user-in-link\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n            </button>\n            <h4 class=\"modal-title\">Edit check in time</h4>\n          </div>\n          <div class=\"modal-body\">\n            <p ng-if=\"vm.selectedstatus == 1\">\n              Update the time {{ vm.selectedjobbler.applicant.firstName }} {{ vm.selectedjobbler.applicant.lastName }} checked in\n            </p>\n            <p ng-if=\"vm.selectedstatus == 2\">\n              Update the time {{ vm.selectedjobbler.applicant.firstName }} {{ vm.selectedjobbler.applicant.lastName }} checked out\n            </p>\n            <div class=\"check-in-input-wrapper\">\n              <input\n                type=\"text\"\n                id=\"timepicker-rosterstamp\"\n                class=\"timepicker\"\n                name=\"time\"\n                placeholder=\"Select\"\n                ng-model=\"vm.selectedjobbler.checkInTimeFormatted\"\n              />\n            </div>\n            <div class=\"clearfix modal-bottom-of-body\">\n              <a class=\"btn btn-success button\" href=\"\" ng-click=\"vm.submitNewTimeForCheckInOrOut()\" style=\"margin-right: 0px\">Save</a>\n            </div>\n\n            <!--\n            {{ vm.selectedjobbler.currentShift.id }}\n            <div class=\"clearfix\">\n              <a class=\"btn\" href=\"#modal-post-your-event\" data-toggle=\"modal\" class=\"select-team\" ng-if=\"vm.currentUser.company.totalNumberOfCircles > 0\" ng-click=\"vm.collectCloudsFromBackEnd()\">Select Teams</a>\n              <a class=\"btn\" href=\"\">Save</a>\n            </div>\n            -->\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	__webpack_require__(483);
	
	__webpack_require__(485);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventrosterController = function () {
	  function EventrosterController($http, $localStorage, $scope, $state, JobsService, AuthService, EventsService, $stateParams, SecurityService, $rootScope, EnvService, $timeout, $location) {
	    _classCallCheck(this, EventrosterController);
	
	    this.name = "eventroster";
	    $localStorage.activeStateName = "events";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$events = EventsService;
	    this.$security = SecurityService;
	    this.$stateParams = $stateParams;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$jobs = JobsService;
	    this.$env = EnvService;
	    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
	    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;
	    this.$timeout = $timeout;
	    this.bulkCheckInArray = [];
	    this.bulkCheckOutArray = [];
	    this.currentUser = this.$auth.getUserData();
	    this.remain_loading_count = 1;
	    this.jobblers = [];
	    this.ratingsMap = [];
	    this.$location = $location;
	    this.showRatingsWarningToUser = false;
	    this.csvName = "jobblers" + moment().format() + ".csv";
	    $localStorage.activeStateName = "events";
	
	    var _this = this;
	
	    _this.$timeout(function () {
	      _this.$rootScope.$emit("SetLoaderDialog", { type: 7, total: 1 });
	    });
	
	    _this.UpdateRosterPageWithConfirmationDataListener = _this.$rootScope.$on("UpdateRosterPageWithConfirmationData", function ($rootScope, params) {
	      console.log("UpdateRosterPageWithConfirmationDataListener");
	      console.dir(params);
	      var data = {};
	      data.userId = params.user_to_update.id;
	      data.timestamp = params.timestamp;
	      data.type = params.type;
	      _this.updateConfirmationUI(data);
	    });
	
	    _this.$scope.$on("$destroy", _this.UpdateRosterPageWithConfirmationDataListener);
	
	    console.log("what is ngCsv");
	    //console.dir(ngCsv);
	
	    console.log("what are the state params");
	    console.dir(_this.$stateParams.eventId);
	    var id = parseInt(_this.$stateParams.eventId, 10);
	
	    _this.$events.getEventByIdTrimmedRoster(id).then(function (event) {
	      console.log("what is the event");
	      console.dir(event.data);
	
	      _this.event = event.data;
	
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetEventToEventDialog", {
	          event: _this.event
	        });
	        _this.$rootScope.$emit("SetEventToEventSidebar", {
	          event: _this.event
	        });
	      });
	
	      if (_this.event.isClosed === true) {
	        $timeout(function () {
	          $("eventsidebar .jobs-complete-sidebar li:nth-child(3)").removeClass().addClass("active");
	        }, 1000);
	      } else {
	        $timeout(function () {
	          $("eventsidebar .jobs-complete-sidebar li:nth-child(4)").removeClass().addClass("active");
	        }, 1000);
	      }
	
	      _this.subEventId = _this.event.subEvents[0].id;
	
	      $timeout(function () {
	        _this.formatAddressForMaps();
	      }, 3000);
	
	      if (_this.event.isSourcingPost) {
	        _this.pagestatus = 2;
	        _this.loadApplicantsForRosterPage();
	      } else {
	        if (_this.$stateParams.shiftId) {
	          _this.pagestatus = 2;
	
	          _this.loadApplicantsForRosterPage();
	
	          _this.$timeout(function () {
	            _this.getCoordinatesForCheckingJobblersInAndOut(_this.event.contactInfo, _this.$stateParams.shiftId);
	          }, 100);
	
	          _this.name = "eventroster1";
	        } else {
	          _this.pagestatus = 1;
	          _this.remain_loading_count = 0;
	          _this.name = "eventroster";
	
	          try {
	            event.data.subEvents[0].deduppedJobbles[0].shifts.sort(function (a, b) {
	              return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
	            });
	          } finally {
	            _this.shiftss = event.data.subEvents[0].deduppedJobbles[0].shifts;
	
	            console.log("here are the shiftss");
	            console.dir(_this.shiftss);
	          }
	        }
	      }
	    });
	  }
	
	  _createClass(EventrosterController, [{
	    key: "printRoster",
	    value: function printRoster() {
	      var _this = this;
	      //if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
	      //console.log('we have chrome');
	      var popupWin = window.open("", "_blank", "width=800,height=800,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no");
	      popupWin.window.focus();
	      popupWin.document.write("<!DOCTYPE html><html><head>" + '<link rel="stylesheet" type="text/css" href="/app/vendor/css/style-print.css" />' + '</head><body onload="window.print()"><div class="print-body">' + _this.printFriendlyTemplate + "</div></html>");
	      popupWin.onbeforeunload = function (event) {
	        popupWin.close();
	        return ".\n";
	      };
	      popupWin.onabort = function (event) {
	        popupWin.document.close();
	        popupWin.close();
	      };
	      //}
	    }
	  }, {
	    key: "getLatAndLngOfCurrentShiftForCheckIn",
	    value: function getLatAndLngOfCurrentShiftForCheckIn(shift) {
	      var _this = this;
	
	      var geocoder = new google.maps.Geocoder();
	      var address = shift.contactInfo.streetLine1 + " " + shift.contactInfo.city + ", " + shift.contactInfo.state + " " + shift.contactInfo.zipCode;
	
	      geocoder.geocode({ address: address }, function (results, status) {
	        if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
	          var location = results[0].geometry.location;
	          var myLatLngEv = { lat: location.lat(), lng: location.lng() };
	          _this.coords = myLatLngEv;
	        }
	      });
	    }
	  }, {
	    key: "findOutIfEventHaveALiveShift",
	    value: function findOutIfEventHaveALiveShift(applications) {
	      var _this = this;
	
	      try {
	        applications.forEach(function (application) {
	          console.log("here we go");
	          console.dir(application);
	
	          var liveShift = _this.$security.isThisEventLive(application.jobble.shifts);
	
	          if (liveShift.eventIsLive === true) {
	            application.liveShift = liveShift;
	            application.hasLiveShift = true;
	          } else {
	            application.liveShift = undefined;
	            application.hasLiveShift = undefined;
	          }
	
	          _this.getLatAndLngOfCurrentShiftForCheckIn(liveShift);
	        });
	      } finally {
	        _this.jobblers = applications;
	      }
	    }
	  }, {
	    key: "toggleCheckin",
	    value: function toggleCheckin(jobbler) {
	      var _this = this;
	
	      if (_this.bulkCheckOutArray.length > 0) {
	        alert("You cannot check jobblers in while you are currently checking out. Please first finish checking your jobblers in before taking this action.");
	      } else {
	        if (jobbler.isSelected) {
	          jobbler.isSelected = undefined;
	          jobbler.isSelectedRow = undefined;
	          var index = -1;
	          for (var i = _this.bulkCheckInArray.length - 1; i >= 0; i--) {
	            if (_this.bulkCheckInArray[i].applicantId == jobbler.applicantId) {
	              index = i;
	              break;
	            }
	          }
	          if (index != -1) _this.bulkCheckInArray.splice(index, 1);
	        } else {
	          jobbler.isSelected = "checkin-toggle";
	          jobbler.isSelectedRow = "check-in-toggle-row";
	          _this.bulkCheckInArray.push(jobbler);
	        }
	      }
	    }
	  }, {
	    key: "toggleCheckout",
	    value: function toggleCheckout(jobbler) {
	      var _this = this;
	      if (_this.bulkCheckInArray.length > 0) {
	        alert("You cannot check jobblers out while you are currently checking in. Please first finish checking your jobblers out before taking this action.");
	      } else {
	        if (jobbler.isSelected) {
	          jobbler.isSelected = undefined;
	          jobbler.isSelectedRow = undefined;
	          var index = -1;
	          for (var i = _this.bulkCheckOutArray.length - 1; i >= 0; i--) {
	            if (_this.bulkCheckOutArray[i].applicantId == jobbler.applicantId) {
	              index = i;
	              break;
	            }
	          }
	
	          if (index != -1) _this.bulkCheckOutArray.splice(index, 1);
	        } else {
	          jobbler.isSelected = "checkout-toggle";
	          jobbler.isSelectedRow = "check-out-toggle-row";
	          _this.bulkCheckOutArray.push(jobbler);
	        }
	      }
	    }
	  }, {
	    key: "checkJobblersInOrOut",
	    value: function checkJobblersInOrOut(type) {
	      console.log("type");
	      console.dir(type);
	
	      var _this = this;
	      var arrayTemp;
	      _this.remain_loading_count = 1;
	
	      var arrayOfJobblesAndApplicants = [];
	
	      var payLoad = { jobblesAndApplicants: [] };
	
	      try {
	        if (type === "checkin") {
	          arrayTemp = _this.bulkCheckInArray;
	        }
	        if (type === "checkout") {
	          arrayTemp = _this.bulkCheckOutArray;
	        }
	
	        arrayTemp.forEach(function (application) {
	          console.log("each application");
	          console.dir(application);
	
	          try {
	            application.jobble.shifts.forEach(function (s, i) {
	              var index = i + 1;
	              var st = moment(s.timeInterval.startTime).subtract(15, "minutes");
	              var et = void 0;
	
	              if (index === application.jobble.shifts.length) {
	                var indexLast = index - 1;
	                et = moment(application.jobble.shifts[indexLast].timeInterval.endTime).add(500, "hours");
	              } else {
	                et = moment(application.jobble.shifts[index].timeInterval.startTime).subtract(15, "minutes");
	              }
	              if (moment().isAfter(st) && moment().isBefore(et)) {
	                application.currentShiftId = s.id;
	              }
	            });
	          } finally {
	            var jobbleAndApplicant = {};
	
	            jobbleAndApplicant.jobble = application.jobble.id;
	            jobbleAndApplicant.applicant = application.applicantId;
	            jobbleAndApplicant.coord = _this.coords;
	            jobbleAndApplicant.shift = application.currentShiftId;
	            payLoad.jobblesAndApplicants.push(jobbleAndApplicant);
	          }
	        });
	      } finally {
	        _this.$events.checkJobblerIn(payLoad, type).then(function (response) {
	          _this.handleResponse(response);
	        }, function (data) {
	          _this.remain_loading_count = 0;
	          _this.$timeout(function () {
	            alert("failure: contact support");
	          }, 400);
	        });
	      }
	    }
	  }, {
	    key: "handleResponse",
	    value: function handleResponse(response) {
	      console.log("in handle response");
	      console.dir(response);
	
	      var _this = this;
	
	      if (response.status === 200) {
	        /*
	        _this.$events.getAcceptedApplicationsTrimmedRoster(_this.event.subEvents[0].id, 200).then(function(acceptedApplications) {
	        console.log('reloading the accepted applicants2');
	        console.dir(acceptedApplications);
	        var applications = acceptedApplications.data;
	        _this.findOutIfEventHaveALiveShift(applications);
	        try {
	        applications.forEach(function(application, i){
	         application.smallPic = _this.$security.getJobblersPicture('75x75', application.applicant);
	         application.mediumPic = _this.$security.getJobblersPicture('160x160', application.applicant);
	        });
	        } finally {
	        applications.sort(function(a,b) {
	         if(a.applicant.lastName < b.applicant.lastName) return -1;
	         if(a.applicant.lastName > b.applicant.lastName) return 1;
	         return 0;
	        })
	         _this.$timeout(function() {
	         _this.bulkCheckInArray = [];
	         _this.bulkCheckOutArray = [];
	         _this.remain_loading_count = 0;
	         _this.$rootScope.globalModalType = { "type" : 5 };
	         jQuery('#show-application-global-modal').trigger('click');
	        }, 300);
	        }
	        })
	        */
	      } else {
	        alert("error contact admin");
	      }
	    }
	  }, {
	    key: "formatAddressForMaps",
	    value: function formatAddressForMaps() {
	      var _this = this;
	
	      //console.log('what are we actually getting here?');
	
	      var city = _this.event.contactInfo.city;
	      var street = _this.event.contactInfo.streetLine1;
	      var state = _this.event.contactInfo.state;
	      //var zipCode = _this.event.contactInfo.zipCode;
	      var address = street + ", " + city + ", " + state;
	
	      _this.address = address;
	    }
	  }, {
	    key: "showAddress",
	    value: function showAddress(contactinfo) {
	      var _this = this;
	
	      var city = _this.event.contactInfo.city;
	      var street = _this.event.contactInfo.streetLine1;
	      var state = _this.event.contactInfo.state;
	      var address = street + ", " + city + ", " + state;
	
	      return address;
	    }
	  }, {
	    key: "viewShiftRoster",
	    value: function viewShiftRoster(shift, index) {
	      var _this = this;
	      _this.$location.path("/event/" + _this.event.id + "/roster/" + shift.id).search({ i: index });
	    }
	  }, {
	    key: "showStartTime",
	    value: function showStartTime(time) {
	      return moment(time).format("dddd, MMM DD");
	    }
	  }, {
	    key: "showTimeShift",
	    value: function showTimeShift(time) {
	      return moment(time).format("dddd, MMM DD");
	    }
	  }, {
	    key: "showmanagerCheckInTime",
	    value: function showmanagerCheckInTime(time) {
	      /*
	      var x = null;
	      if (!time) {
	      x = "--";
	      } else {
	      x = moment(time).format("hh:mm A");
	      }
	      return x;
	      */
	
	      return time;
	    }
	  }, {
	    key: "showmanagerCheckOutTime",
	    value: function showmanagerCheckOutTime(time) {
	      /*
	      var x = null;
	      if (!time) {
	      x = "--";
	      } else {
	      x = moment(time).format("hh:mm A");
	      }
	      return x;
	      */
	
	      return time;
	    }
	  }, {
	    key: "viewShiftRoster",
	    value: function viewShiftRoster(shift, index) {
	      var _this = this;
	      _this.$location.path("/event/" + _this.event.id + "/roster/" + shift.id).search({ i: index });
	    }
	  }, {
	    key: "launchConfirmModal",
	    value: function launchConfirmModal(app) {
	      var _this = this;
	      console.log("launchConfirmModal");
	      console.dir(app);
	
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetShiftToModal", app);
	      });
	    }
	  }, {
	    key: "launchEditModal",
	    value: function launchEditModal(app) {
	      var _this = this;
	
	      console.log("launchEditModal");
	      console.dir(app);
	      app.isEdit = true;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetShiftToModal", app);
	      });
	    }
	  }, {
	    key: "loadApplicantsForRosterPage",
	    value: function loadApplicantsForRosterPage(max, offset) {
	      var _this = this;
	      var csv = [];
	      if (!max) {
	        max = 100;
	      }
	      if (!offset) {
	        offset = 0;
	      }
	      _this.jobblers = [];
	      _this.$events.getAcceptedApplicationsTrimmedRoster(_this.event.subEvents[0].id, max, offset).then(function (acceptedApplications) {
	        var applications = acceptedApplications.data;
	        try {
	          try {
	            applications.forEach(function (application, i) {
	              var csvObj = {
	                last_name: application.applicant.lastName,
	                first_name: application.applicant.firstName,
	                number: application.applicant.homeContactInfo.phoneMobile,
	                email: application.applicant.email,
	                post_title: _this.event.name,
	                job_type: _this.event.subEvents[0].deduppedJobbles[0].jobbleType.name,
	                city: _this.event.contactInfo.city,
	                state: _this.event.contactInfo.state,
	                zip: _this.event.contactInfo.zipCode,
	                apply_date: application.dateCreated
	              };
	              csv.push(csvObj);
	              application.smallPic = application.applicant.filePROFILE_IMAGE1IMG_75x75;
	              application.mediumPic = application.applicant.filePROFILE_IMAGE1IMG_75x75;
	              application.jobble.shifts.sort(function (a, b) {
	                return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
	              });
	
	              _this.fixApplicantPhone(application);
	            });
	          } finally {
	            applications.sort(function (a, b) {
	              if (a.applicant.lastName < b.applicant.lastName) return -1;
	              if (a.applicant.lastName > b.applicant.lastName) return 1;
	              return 0;
	            });
	            csv.sort(function (a, b) {
	              if (a.last_name < b.last_name) return -1;
	              if (a.last_name > b.last_name) return 1;
	              return 0;
	            });
	            _this.findCurrentShift(applications);
	            _this.setTimeZones(applications);
	          }
	        } finally {
	          _this.csv = csv;
	          _this.$timeout(function () {
	            _this.setPrintFriendlyVersion(applications);
	          }, 500);
	        }
	      });
	    }
	  }, {
	    key: "setPrintFriendlyVersion",
	    value: function setPrintFriendlyVersion(applications) {
	      var _this = this;
	      _this.printFriendlyTemplate = "<table><thead><th>Last Name</th><th>First Name</th><th>Email</th><th>Number</th></thead>";
	      var endOfTable = "</tbody></table>";
	      var arrayOfRows = [];
	      var stringOfHtml = "";
	      if (applications) {
	        try {
	          for (var i = 0; i < applications.length; i++) {
	            arrayOfRows.push("<tr><td>" + applications[i].applicant.lastName + "</td><td>" + applications[i].applicant.firstName + "</td><td>" + applications[i].applicant.email + "</td><td>" + applications[i].applicant.homeContactInfo.phoneMobile + "</td></tr>");
	            _this.printFriendlyTemplate = _this.printFriendlyTemplate + "<tr><td>" + applications[i].applicant.lastName + "</td><td>" + applications[i].applicant.firstName + "</td><td>" + applications[i].applicant.email + "</td><td>" + applications[i].applicant.homeContactInfo.phoneMobile + "</td></tr>";
	          }
	        } finally {
	          _this.printFriendlyTemplate = _this.printFriendlyTemplate + endOfTable;
	          _this.remain_loading_count = 0;
	        }
	      }
	    }
	  }, {
	    key: "fixApplicantPhone",
	    value: function fixApplicantPhone(application) {
	      var _this = this;
	
	      if (application.applicant.homeContactInfo) {
	        if (application.applicant.homeContactInfo.phoneMobile) {
	          var num = application.applicant.homeContactInfo.phoneMobile;
	          if (num.charAt(0) === "1") {
	            num = num.slice(1, num.length);
	          }
	          var cleaned = ("" + num).replace(/\D/g, "");
	          var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
	          if (match) {
	            application.applicant.homeContactInfo.phoneMobile = "(" + match[1] + ") " + match[2] + "-" + match[3];
	          } else {
	            application.applicant.homeContactInfo.phoneMobile = num;
	          }
	        } else {
	          application.applicant.homeContactInfo = {};
	          application.applicant.homeContactInfo.phoneMobile = "--";
	        }
	      }
	    }
	  }, {
	    key: "getCoordinatesForCheckingJobblersInAndOut",
	    value: function getCoordinatesForCheckingJobblersInAndOut(loc, shiftId) {
	      var _this = this;
	
	      var shiftid = parseInt(shiftId, 10);
	
	      _this.$events.getShiftRoster(shiftid).then(function (response) {
	        var myLatLngEv = {
	          lat: response.data.contactInfo.lat,
	          lng: response.data.contactInfo.lng
	        };
	        _this.coordsForCheckIn = myLatLngEv;
	      });
	    }
	  }, {
	    key: "findCurrentShift",
	    value: function findCurrentShift(applications) {
	      var _this = this;
	
	      var id = parseInt(_this.$stateParams.shiftId, 10);
	      var sid = parseInt(_this.$location.$$search.i);
	
	      console.log("ktrak1 what is the id...");
	      console.dir(sid);
	
	      try {
	        applications.forEach(function (application) {
	          for (var i = 0; i < application.jobble.shifts.length; i++) {
	            console.log("ktrak2 comparing");
	            console.dir(sid);
	            console.dir(i);
	
	            if (sid === i) {
	              console.log("ktrak3 found one");
	              console.dir(application.jobble.shifts[i]);
	
	              application.table_data = {};
	              application.table_data.buttons = {};
	              application.table_data.icon_flags = {};
	
	              var cs = application.jobble.shifts[i];
	
	              console.log("we found the shift lets take a peak");
	              console.dir(cs);
	
	              if (!cs.managerCheckInTime && !cs.managerCheckOutTime) {
	                console.log("nested if statement 1");
	                application.table_data.buttons.show_checkout = false;
	                application.table_data.buttons.show_checkin = true;
	                application.table_data.icon_flags.showedit_starttime = false;
	                application.table_data.icon_flags.showedit_endtime = false;
	              } else if (cs.managerCheckInTime && !cs.managerCheckOutTime) {
	                console.log("nested if statement 2");
	                application.table_data.buttons.show_checkout = true;
	                application.table_data.buttons.show_checkin = false;
	                application.table_data.icon_flags.showedit_starttime = true;
	                application.table_data.icon_flags.showedit_endtime = false;
	              } else if (!cs.managerCheckInTime && cs.managerCheckOutTime) {
	                console.log("nested if statement 3");
	                application.table_data.buttons.show_checkout = false;
	                application.table_data.buttons.show_checkin = false;
	                application.table_data.icon_flags.showedit_starttime = false;
	                application.table_data.icon_flags.showedit_endtime = true;
	                application.table_data.disable_actions = true;
	              } else {
	                console.log("nested if statement 4");
	                application.table_data.buttons.show_checkout = false;
	                application.table_data.buttons.show_checkin = false;
	                application.table_data.icon_flags.showedit_starttime = true;
	                application.table_data.icon_flags.showedit_endtime = true;
	                application.table_data.disable_actions = true;
	              }
	
	              console.log("each application");
	              console.dir(application);
	              application.currentShift = cs;
	
	              break;
	            }
	          }
	        });
	      } finally {
	        _this.$timeout(function () {
	          //_this.$scope.$apply();
	          console.log("applications lets see the current shifts");
	          console.dir(applications);
	          //_this.jobblers = applications;
	          console.log("_this.jobblers");
	          console.dir(_this.jobblers);
	        }, 500);
	      }
	    }
	  }, {
	    key: "setTimeZones",
	    value: function setTimeZones(applications) {
	      var _this = this;
	
	      console.log("setting the time zones");
	      console.dir(applications);
	
	      var applications_tz = _this.$security.getTimesFromZone(applications, true);
	
	      _this.$timeout(function () {
	        _this.jobblers = applications_tz;
	      }, 300);
	    }
	  }, {
	    key: "enterCheckInOutTime",
	    value: function enterCheckInOutTime(jobbler, status, index) {
	      var _this = this;
	
	      _this.selectedstatus = status;
	
	      _this.$timeout(function () {
	        jQuery("#timepicker-rosterstamp").timepicker({
	          step: 15,
	          timeFormat: "h:i A"
	        });
	        jQuery("#timepicker-rosterstamp").on("showTimepicker", function () {
	          jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker-rosterstamp").width() + 10 + "px");
	        });
	
	        _this.check_in_data = {};
	        _this.check_in_data.application = jobbler;
	        _this.check_in_data.status = status;
	        _this.check_in_data.index = index;
	
	        _this.selectedjobbler = jobbler;
	
	        if (status === 1) {
	          _this.selectedjobbler.checkInTimeFormatted = _this.showmanagerCheckInTime(jobbler.currentShift.checkInAndOutForDisplay.start_time);
	        }
	
	        if (status === 2) {
	          _this.selectedjobbler.checkInTimeFormatted = _this.showmanagerCheckInTime(jobbler.currentShift.checkInAndOutForDisplay.end_time);
	        }
	
	        jQuery("#modal-check-user-in-link").modal();
	      }, 100);
	    }
	  }, {
	    key: "submitNewTimeForCheckInOrOut",
	    value: function submitNewTimeForCheckInOrOut() {
	      var _this = this;
	
	      if (_this.selectedstatus === 1) {
	        _this.calcTimeZone();
	      }
	
	      if (_this.selectedstatus === 2) {
	        _this.calcTimeZone();
	      }
	
	      _this.$timeout(function () {
	        jQuery("#modal-check-user-in").trigger("click");
	      });
	    }
	  }, {
	    key: "calcTimeZone",
	    value: function calcTimeZone() {
	      var _this = this;
	
	      console.log("calcTimeZone");
	      console.dir(_this.selectedjobbler);
	
	      var date = null;
	      var userTimeZoneName = moment.tz.guess();
	      var now = moment.tz(userTimeZoneName);
	      var dayfull = moment().format("MMM DD YYYY");
	      //this represents both check in and check out times
	      var timefull = _this.selectedjobbler.checkInTimeFormatted;
	
	      console.log("timefull");
	      console.dir(timefull);
	      console.dir(_this.selectedjobbler);
	
	      var nowThere = moment.tz(_this.selectedjobbler.currentShift.contactInfo.place.timeZoneId);
	      var timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
	      var zone = moment.tz.zone(moment.tz.guess());
	      var eventMangerOffsets = -zone.offsets[zone.offsets.length - 1];
	      var eventOffsets = _this.selectedjobbler.currentShift.contactInfo.place.rawOffset / 60000;
	      var fulldate = dayfull + " " + timefull;
	      var dateconverted = new Date(fulldate);
	
	      console.log("dateconverted");
	      console.dir(dateconverted);
	
	      var dateforDB = moment(dateconverted).add(eventMangerOffsets - eventOffsets, "minutes").format();
	
	      var formatted_date = moment(dateconverted).add(eventMangerOffsets - eventOffsets, "minutes").format("hh:mm A");
	
	      console.log("dates");
	      console.dir(dateforDB);
	      console.dir(formatted_date);
	
	      if (_this.selectedstatus === 1) {
	        _this.checkInForShift(_this.check_in_data.application, _this.check_in_data.index, formatted_date, dateforDB);
	      }
	
	      if (_this.selectedstatus === 2) {
	        _this.checkOutForShift(_this.check_in_data.application, _this.check_in_data.index, formatted_date, dateforDB);
	      }
	
	      _this.$timeout(function () {
	        $("#modal-check-user-in-link").modal("toggle");
	      }, 300);
	    }
	  }, {
	    key: "storeNewmanagerCheckInTime",
	    value: function storeNewmanagerCheckInTime(date, formatted_date) {
	      var _this = this;
	
	      _this.$events.updateShiftCheckInTime(date, _this.selectedjobbler).then(function (response) {
	        console.log("selectedjobblerselectedjobblerselectedjobbler");
	        console.dir(_this.selectedjobbler);
	
	        if (response.statusText === "OK") {
	          _this.jobblers.some(function (elem) {
	            if (elem.id === _this.selectedjobbler.id) {
	              elem.currentShift.checkInAndOutForDisplay.start_time = formatted_date;
	              return elem;
	            }
	          });
	        } else {
	          alert("There was an issue saving timestamp");
	        }
	      });
	    }
	  }, {
	    key: "storeNewmanagerCheckOutTime",
	    value: function storeNewmanagerCheckOutTime(date, formatted_date) {
	      var _this = this;
	
	      _this.$events.updateShiftCheckOutTime(date, _this.selectedjobbler).then(function (response) {
	        if (response.statusText === "OK") {
	          _this.jobblers.some(function (elem) {
	            if (elem.id === _this.selectedjobbler.id) {
	              elem.currentShift.checkInAndOutForDisplay.end_time = formatted_date;
	              return elem;
	            }
	          });
	        } else {
	          alert("There was an issue saving timestamp");
	        }
	      });
	    }
	  }, {
	    key: "checkInForShift",
	    value: function checkInForShift(application, index, date, date_for_db) {
	      var _this = this;
	
	      var jobbleAndApplicant = {};
	      var payLoad = { jobblesAndApplicants: [] };
	      var now = null;
	
	      if (!date) {
	        now = moment().format("hh:mm A");
	      } else {
	        now = date;
	        jobbleAndApplicant.date = date_for_db;
	      }
	
	      jobbleAndApplicant.jobble = application.jobble.id;
	      jobbleAndApplicant.applicant = application.applicant.id;
	      jobbleAndApplicant.coord = _this.coordsForCheckIn;
	      jobbleAndApplicant.shift = application.currentShift.id;
	      jobbleAndApplicant.isManager = true;
	
	      payLoad.jobblesAndApplicants.push(jobbleAndApplicant);
	
	      application.currentShift.managerCheckInTime = now;
	      application.currentShift.checkInAndOutForDisplay.start_time = now;
	
	      application.table_data.buttons.show_checkin = false;
	      application.table_data.icon_flags.showedit_starttime = true;
	
	      _this.$events.checkJobblerInOrOut(payLoad, 1).then(function (response) {
	        _this.handleResponse(response, application, 1);
	
	        _this.$timeout(function () {
	          application.table_data.buttons.show_checkout = true;
	        }, 500);
	      }, function (data) {
	        _this.remain_loading_count = 0;
	
	        /*
	        _this.$timeout(function(){
	        alert('failure: contact support');
	        }, 400);
	        */
	      });
	    }
	  }, {
	    key: "checkOutForShift",
	    value: function checkOutForShift(application, index, date, date_for_db) {
	      var _this = this;
	
	      var jobbleAndApplicant = {};
	      var payLoad = { jobblesAndApplicants: [] };
	      var now = null;
	
	      if (!date) {
	        now = moment().format("hh:mm A");
	      } else {
	        now = date;
	        jobbleAndApplicant.date = date_for_db;
	      }
	
	      jobbleAndApplicant.jobble = application.jobble.id;
	      jobbleAndApplicant.applicant = application.applicant.id;
	      jobbleAndApplicant.coord = _this.coordsForCheckIn;
	      jobbleAndApplicant.shift = application.currentShift.id;
	      jobbleAndApplicant.isManager = true;
	
	      payLoad.jobblesAndApplicants.push(jobbleAndApplicant);
	
	      application.currentShift.managerCheckOutTime = now;
	      application.currentShift.checkInAndOutForDisplay.end_time = now;
	      application.table_data.disable_actions = true;
	
	      _this.$events.checkJobblerInOrOut(payLoad, 2).then(function (response) {
	        _this.handleResponse(response, application, 2);
	      }, function (data) {
	        _this.remain_loading_count = 0;
	
	        /*
	        _this.$timeout(function(){
	        alert('failure: contact support');
	        }, 400)
	        */
	      });
	    }
	  }, {
	    key: "getHeader",
	    value: function getHeader() {
	      return ["Last Name", "First Name", "Number", "Email", "Post Title", "Job Type", "City", "State", "Zip", "Apply Date"];
	    }
	  }, {
	    key: "downloadRoster",
	    value: function downloadRoster() {
	      console.log("downloadRoster");
	      console.dir(this.csv);
	    }
	  }, {
	    key: "showTime",
	    value: function showTime(shift, time) {
	      var _this = this;
	
	      console.log("show time");
	      console.dir(shift);
	      console.dir(time);
	
	      return _this.$security.displayTimeWithZone(time, shift.contactInfo.place.timeZoneId);
	    }
	  }, {
	    key: "sortSurveyQuestions",
	    value: function sortSurveyQuestions(questions) {
	      var _this = this;
	      questions.sort(function (a, b) {
	        if (a.id < b.id) return -1;
	        if (a.id > b.id) return 1;
	        return 0;
	      });
	    }
	  }, {
	    key: "displayDetails",
	    value: function displayDetails(application) {
	      var _this = this;
	
	      console.log("display");
	      console.dir(application);
	
	      _this.setLoader();
	      _this.$timeout(function () {
	        jQuery("#modal-view-jobble").modal();
	      });
	
	      _this.$security.getApplicationInfoTrimmed(application).then(function (response) {
	        var jobblerData = _this.$security.getJobblerData(response.data, "hired", "open", application.renderPhotoBig, null, null, null);
	        _this.sortSurveyQuestions(jobblerData.surveyQuestions);
	        //jobblerData.index = applicationIndexInArray;
	        jobblerData.type = "hired";
	        jobblerData.action = "open";
	
	        /*
	        if (isLink) {
	        _this.$location.search('id', jobblerData.jobblerId);
	        }
	        */
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("GetJobblerDataFromService", {
	            event: _this.event,
	            jobblerData: jobblerData,
	            messaging: false,
	            application: application,
	            type: "hired"
	          });
	
	          $("#modal-view-jobble").focus();
	        });
	
	        _this.$timeout(function () {
	          _this.unSetLoader();
	        }, 500);
	      });
	    }
	  }, {
	    key: "updateConfirmationUI",
	    value: function updateConfirmationUI(data) {
	      var _this = this;
	
	      console.log("updateConfirmationUI");
	      console.dir(data);
	      console.dir(_this.jobblers);
	
	      var app = _this.jobblers.find(function (o) {
	        return o.applicant.id === data.userId;
	      });
	
	      app.currentShift.confirmationDateTime = data.timestamp;
	
	      if (data.type) {
	        app.currentShift.confirmationResponse = false;
	      } else {
	        app.currentShift.confirmationResponse = true;
	      }
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "triggerConfirmationModal",
	    value: function triggerConfirmationModal(application) {
	      var _this = this;
	
	      _this.setLoader();
	
	      console.log("triggerConfirmationModal");
	      console.dir(application);
	
	      _this.getJobblesAndShifts(application);
	
	      /*
	      _this.$timeout(function(){
	      $("#modal-view-jobble").modal("toggle");
	      });
	      */
	
	      /*
	      _this.$timeout(function(){
	      $("#modal-confirm-jobbler").modal();
	      },300);
	      */
	      _this.$timeout(function () {
	        $("#modal-confirm-jobbler").modal();
	      }, 300);
	    }
	  }, {
	    key: "getJobblesAndShifts",
	    value: function getJobblesAndShifts(app) {
	      var _this = this;
	
	      console.log("getJobblesAndShifts");
	      console.dir(app);
	      app.jobbleId = app.jobble.id;
	      _this.$jobs.getJobbleWithShifts(app.jobbleId).then(function (response) {
	        console.log("get jobble with shifts");
	        console.dir(response);
	        _this.format_time_zones(response.data.shifts, app);
	
	        _this.unSetLoader();
	      }, function (error) {
	        console.log("in error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "format_time_zones",
	    value: function format_time_zones(shifts, app) {
	      var _this = this;
	
	      try {
	        shifts.forEach(function (shift) {
	          console.log("-------------each shift");
	          console.dir(shift.timeInterval.startTime);
	          shift.startTimeFormatted = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("MM/DD/YYYY hh:mm A");
	          shift.endTimeFormatted = moment(shift.timeInterval.endTime).tz(shift.contactInfo.place.timeZoneId).format("MM/DD/YYYY hh:mm A");
	          if (shift.confirmationDateTime) {
	            shift.confirmationDateTimeFormatted = moment(shift.confirmationDateTime).tz(shift.contactInfo.place.timeZoneId).format("MM/DD/YYYY hh:mm A");
	          }
	          if (shift.confirmationResponse === true) {
	            shift.confirmationResponseDisplay = "Yes";
	          } else {
	            shift.confirmationResponseDisplay = "No";
	          }
	        });
	      } catch (err) {} finally {
	        shifts.sort(function (a, b) {
	          return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
	        });
	
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetShiftsToModal", { shifts: shifts, app: app });
	        });
	
	        //_this.shifts_for_confirm = shifts;
	        console.log("shifts_for_confirm");
	        console.dir(_this.shifts_for_confirm);
	      }
	    }
	  }]);
	
	  return EventrosterController;
	}();
	
	EventrosterController.$inject = ["$http", "$localStorage", "$scope", "$state", "jobs", "auth", "events", "$stateParams", "security", "$rootScope", "env", "$timeout", "$location"];
	
	exports.default = EventrosterController;

/***/ }),
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(487);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventroster.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventroster.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "eventroster #wrapper{min-height:calc(100% - 62px)}", ""]);
	
	// exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _jobsdashboard = __webpack_require__(489);
	
	var _jobsdashboard2 = _interopRequireDefault(_jobsdashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobsdashboardModule = _angular2.default.module("jobsdashboard", [_angularUiRouter2.default, "ngStorage"]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("jobsdashboard", {
	    url: "/jobs-dashboard?filter&longTerm&dashboardType&action",
	    template: "<jobsdashboard></jobsdashboard>",
	    title: "Jobs",
	    params: {
	      filter: null,
	      longTerm: null,
	      dashboardType: null,
	      action: null
	    }
	  });
	}).component("jobsdashboard", _jobsdashboard2.default);
	
	exports.default = jobsdashboardModule;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobsdashboard = __webpack_require__(490);
	
	var _jobsdashboard2 = _interopRequireDefault(_jobsdashboard);
	
	var _jobsdashboard3 = __webpack_require__(491);
	
	var _jobsdashboard4 = _interopRequireDefault(_jobsdashboard3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobsdashboardComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _jobsdashboard2.default,
	  controller: _jobsdashboard4.default,
	  controllerAs: "vm"
	};
	
	exports.default = jobsdashboardComponent;

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<leftnavigation></leftnavigation>\n\n<div class=\"jobs-dashboard-container\">\n  <div id=\"in-app-notification-wrapper\" ng-if=\"vm.displayInAppNotification\">\n    <div class=\"in-app-notification\" ng-repeat=\"alert in vm.alerts track by $index\"\n      ng-class=\"{ 'sub-margin' : $index != 0 }\">\n      <div class=\"left-side-notification\">\n        <i class=\"fas fa-info-circle\"></i>\n        <h4>Attention -\n          <span class=\"timestamp-alert\">{{alert.dateCreatedFormatted}}</span>\n        </h4>\n        <p>{{alert.message}}</p>\n      </div>\n      <div class=\"right-side-notification\">\n        <ul>\n          <li ng-click=\"vm.closeNotification($index, alert)\"><a href=\"\">Close</a></li>\n          <li ng-click=\"vm.viewNotification($index, alert)\"><a href=\"\">View</a></li>\n        </ul>\n      </div>\n    </div>\n  </div>\n  <div class=\"jobs-dashboard-container-header\">\n    <h1 class=\"jobs-header\">Jobs</h1>\n  </div>\n  <div class=\"jobs-dashboard-container-header-actions\"\n    ng-if=\"vm.currentUser.company.isVerified == true && vm.currentUser.isVerified == true\">\n\n    <div class=\"tabbed-header-wrapper\">\n      <ul class=\"tabbed-header\">\n        <li ng-click=\"vm.hideJobs();vm.getJobs('published', true)\">Published\n          ({{ vm.currentUser.company.totalNumberOfPublishedEvents ?\n          vm.currentUser.company.totalNumberOfPublishedEvents : 0\n          }})\n        </li>\n        <li ng-click=\"vm.hideJobs();vm.getJobs('draft')\">Draft\n          ({{ vm.currentUser.company.totalNumberOfDraftEvents ?\n          vm.currentUser.company.totalNumberOfDraftEvents : 0\n          }})\n        </li>\n        <li ng-click=\"vm.hideJobs();vm.getJobs('completed', true);\">Completed\n          ({{ vm.currentUser.company.totalNumberOfCloseEvents }})\n        </li>\n        <li ng-click=\"vm.hideJobs();vm.getJobs('archived', true)\">Archived\n          ({{ vm.currentUser.company.totalNumberOfEvents - (vm.currentUser.company.totalNumberOfNonCloseEvents\n          + vm.currentUser.company.totalNumberOfCloseEvents)}})\n        </li>\n      </ul>\n    </div>\n\n    <!--\n    <div class=\"filter-params-wrapper\">\n        <div class=\"filter-params\">\n            <ul>\n                <li><i class=\"fas fa-filter\"></i> Filter: Published</li>\n                <li><i class=\"fas fa-sort-amount-up-alt\"></i> Sort: Date Created</li>\n            </ul>\n        </div>\n    </div>-->\n    <div class=\"jobs-dashboard-actions-list-container\">\n      <!--ng-if=\"(vm.uiViews.is_company_verified==true && (vm.jobs.length > 0 && vm.weHaveOneCheckedJob))-->\n      <ul class=\"jobs-dashboard-actions-list\" ng-class=\"{ 'job-has-been-checked' : vm.weHaveOneCheckedJob }\">\n        <li ng-click=\"vm.archiveJobs()\" ng-if=\"vm.requestParams.list != 'archived'\">\n          <i class=\"fas fa-archive\"></i> Archive\n        </li>\n        <li ng-click=\"vm.publishJobs()\"\n          ng-if=\"vm.requestParams.list != 'archived' && vm.requestParams.list != 'published' && vm.requestParams.list != 'completed'\">\n          <i class=\"fas fa-upload\"></i> Publish\n        </li>\n        <li ng-click=\"vm.unpublishJobs()\"\n          ng-if=\"vm.requestParams.list != 'archived' && vm.requestParams.list != 'draft' && vm.requestParams.list != 'completed'\">\n          <i class=\"fas fa-minus-square\"></i> Unpublish\n        </li>\n        <li ng-click=\"vm.completeJobs()\"\n          ng-if=\"vm.requestParams.list != 'archived' && vm.requestParams.list != 'draft' && vm.requestParams.list != 'completed'\">\n          <i class=\"fas fa-minus-square\"></i> Complete\n        </li>\n        <li ng-click=\"vm.restoreJobs()\" ng-if=\"vm.requestParams.list === 'archived'\">\n          <i class=\"fas fa-trash-restore\"></i> Restore\n        </li>\n        <li ng-click=\"vm.reopenJobs()\" ng-if=\"vm.requestParams.list === 'completed'\">\n          <i class=\"fas fa-trash-restore\"></i> Reopen\n        </li>\n      </ul>\n    </div>\n\n    <div class=\"jobs-csv-holder\" ng-if=\"vm.uiViews.is_company_verified==true\">\n\n      <i class=\"fas fa-file-export\" ng-csv=\"vm.csv\" csv-header=\"vm.getHeader()\" filename=\"{{ vm.csvName }}\"\n        field-separator=\",\" decimal-separator=\".\" title=\"Download Job Table to CSV\">\n      </i>\n\n    </div>\n\n    <div class=\"jobs-dashboard-clear-search\" ng-click=\"vm.clearSearch()\" ng-show=\"vm.uiViews.is_search==true\">\n      <div>\n        <i class=\"fas fa-times clear-search\">\n        </i>\n      </div>\n    </div>\n\n    <div class=\"jobs-dashboard-search\">\n      <form ng-submit=\"vm.jobSearchSubmit()\" ng-if=\"vm.uiViews.is_company_verified==true\">\n        <input type=\"text\" class=\"jobs-dashboard-search\" placeholder=\"Search by keyword, location or job ID\"\n          ng-model=\"vm.jobQuery\" ng-change=\"vm.jobSearchChange()\" />\n        <i class=\"fas fa-search search-icon\"></i>\n      </form>\n    </div>\n\n  </div>\n\n  <div class=\"verifications-container\" ng-if=\"!vm.currentUser.company.isVerified && vm.displayVerificationSteps\">\n    <div class=\"verification-wrapper\">\n      <span class=\"verification-header\" ng-if=\"!vm.companyVerificationData.isVerified\">\n        There are a few additional steps needed in order for your account to be approved\n        <br/>\n      </span>\n      <span class=\"verification-sub-header\" ng-if=\"!vm.companyVerificationData.isVerified\">\n        For account approval, and for your jobs to be published, please:\n      </span>\n      <span class=\"verification-header\" ng-if=\"vm.companyVerificationData.isVerified\">\n        Thank you for completing all the required steps. <br/>\n        Your account is currently under review.<br/>\n        For questions about account verification, please reach out to sales@jobble.com.\n      </span>\n        <ol>\n          <li ng-class=\"{'verification-completed' : vm.companyVerificationData.isUserVerified}\">\n            <a href=\"#\" ng-click=\"vm.viewVerificationModal()\">Confirm your email address</a> by clicking the link in the verification email that was sent.\n          </li>\n          <li ng-class=\"{'verification-completed' : vm.companyVerificationData.logo}\">\n            Upload a company logo in <a href=\"/account-profile\">your account settings</a>.\n          </li>\n          <li ng-class=\"{'verification-completed' : vm.companyVerificationData.paymentInfo.length > 0}\">\n            Add a payment method to  <a href=\"/account-profile/{{vm.currentUser.company.id}}/payment-information\">your billing settings</a>.\n          </li>\n        </ol>\n      </div>\n  </div>\n\n  <!--\n  <div class=\"verifications-container\">\n    <div class=\"verification-warning\" ng-if=\"vm.uiViews.company_has_unverified_bank==true\">\n      Bank account on file pending verification. In order to make payments you will need to <a\n        href=\"/account-profile/1771185/payment-information?verifyBank={{vm.unverifiedBankId}}\">verify your bank\n        account</a>.\n    </div>\n    \n    <div\n        class=\"verification-warning\"\n        ng-if=\"!vm.$localStorage.logged_user.company.companyLogoUri\">\n        Company logo is missing. In order to post jobs you will need to <a href=\"/account-profile\">add a company logo</a>.\n    </div>\n\n    <div\n        class=\"verification-warning\"\n        ng-if=\"!vm.$localStorage.logged_user.company.ein\">\n        Company EIN is missing. In order to post jobs you will need to <a href=\"/account-profile\">add an EIN</a>.\n    </div>\n    \n    <div class=\"verification-warning\" ng-if=\"vm.uiViews.is_company_verified==false\">\n      Your company is under review. Please reach out to success@jobble.com for more information.\n    </div>\n\n    <div class=\"verification-warning\" ng-if=\"vm.uiViews.is_user_email_verified==false\">\n      Your email address has not been verified. <a href=\"#\" ng-click=\"vm.viewVerificationModal()\">Please confirm\n        your email address</a>.\n\n    </div>\n\n  </div>\n-->\n  <div class=\"jobs-dashboard-jobs-listing\">\n\n    <table class=\"jobs-dashboard-jobs-table\">\n      <thead>\n        <tr>\n          <th>\n            <input type=\"checkbox\" ng-checked=\"vm.ui.allChecked\" ng-click=\"vm.checkAll()\"\n              ng-if=\"vm.uiViews.is_company_verified==true && vm.uiViews.is_user_email_verified && vm.jobs.length != 0\" />\n          </th>\n          <th ng-click=\"vm.sortTable('job-title', 2)\">\n            Job Title\n            <i class=\"fas fa-sort\" ng-if=\"vm.requestParams.sort!='name'\"></i>\n            <i class=\"fas fa-sort-down\" ng-if=\"vm.requestParams.sort=='name' && vm.requestParams.order=='desc'\"></i>\n            <i class=\"fas fa-sort-up\" ng-if=\"vm.requestParams.sort=='name' && vm.requestParams.order=='asc'\"></i>\n          </th>\n          <th ng-click=\"vm.sortTable('location')\">\n            Location\n          </th>\n          <th ng-click=\"vm.sortTable('status')\">\n            Status\n          </th>\n          <th ng-click=\"vm.sortTable('start-date', 5)\" style=\"width:160px;min-width:160px;\">\n            Start Date\n            <i class=\"fas fa-sort\" ng-if=\"vm.requestParams.sort!='start_time'\"></i>\n            <i class=\"fas fa-sort-down\"\n              ng-if=\"vm.requestParams.sort=='start_time' && vm.requestParams.order=='desc'\"></i>\n            <i class=\"fas fa-sort-up\" ng-if=\"vm.requestParams.sort=='start_time' && vm.requestParams.order=='asc'\"></i>\n          </th>\n          <th ng-click=\"vm.sortTable('end-date', 6)\" style=\"width:160px;min-width:160px;\">\n            End Date\n            <i class=\"fas fa-sort\" ng-if=\"vm.requestParams.sort!='end_time'\"></i>\n            <i class=\"fas fa-sort-down\" ng-if=\"vm.requestParams.sort=='end_time' && vm.requestParams.order=='desc'\"></i>\n            <i class=\"fas fa-sort-up\" ng-if=\"vm.requestParams.sort=='end_time' && vm.requestParams.order=='asc'\"></i>\n          </th>\n          <th ng-click=\"vm.sortTable('rate', 7)\">\n            Rate\n            <i class=\"fas fa-sort\" ng-if=\"vm.requestParams.sort!='payPerHour'\"></i>\n            <i class=\"fas fa-sort-down\"\n              ng-if=\"vm.requestParams.sort=='payPerHour' && vm.requestParams.order=='desc'\"></i>\n            <i class=\"fas fa-sort-up\" ng-if=\"vm.requestParams.sort=='payPerHour' && vm.requestParams.order=='asc'\"></i>\n          </th>\n          <th ng-click=\"vm.sortTable('openings', 8)\">\n            Openings\n            <i class=\"fas fa-sort\" ng-if=\"vm.requestParams.sort!='openings'\"></i>\n            <i class=\"fas fa-sort-down\" ng-if=\"vm.requestParams.sort=='openings' && vm.requestParams.order=='desc'\"></i>\n            <i class=\"fas fa-sort-up\" ng-if=\"vm.requestParams.sort=='openings' && vm.requestParams.order=='asc'\"></i>\n          </th>\n          <th ng-show=\"vm.currentUser.isAdmin == true\" style=\"min-width:108px;\" class=\"fill-score\">\n            <!--ng-click=\"vm.sortTable('pending-applications', 8)\"-->\n            Fill Score\n            <i class=\"fill-score fa fa-question-circle\" aria-hidden=\"true\" data-toggle=\"tooltip\"\n              ng-attr-title=\"The fill score indicates the probability of the jobs success.\" data-placement=\"bottom\"\n              data-html=\"true\"></i>\n            <!--\n          <i class=\"fas fa-sort\" ng-if=\"vm.requestParams.sort!='pendingApplications'\"></i>\n          <i class=\"fas fa-sort-down\"\n             ng-if=\"vm.requestParams.sort=='pendingApplications' && vm.requestParams.order=='desc'\"></i>\n          <i class=\"fas fa-sort-up\"\n             ng-if=\"vm.requestParams.sort=='pendingApplications' && vm.requestParams.order=='asc'\"></i>\n             -->\n          </th>\n          <th>\n            Confirms\n            <!--ng-click=\"vm.sortTable('accepted-applications', 10)\"-->\n            <!--\n          <i class=\"fas fa-sort\" ng-if=\"vm.requestParams.sort!='acceptedApplications'\"></i>\n          <i class=\"fas fa-sort-down\"\n             ng-if=\"vm.requestParams.sort=='acceptedApplications' && vm.requestParams.order=='desc'\"></i>\n          <i class=\"fas fa-sort-up\"\n             ng-if=\"vm.requestParams.sort=='acceptedApplications' && vm.requestParams.order=='asc'\"></i>\n             -->\n          </th>\n          <th></th>\n        </tr>\n      </thead>\n      <tbody ng-if=\"vm.jobs.length == 0 && vm.uiViews.is_loading_jobs==true\" class=\"not-real-jobs-body\">\n        <tr ng-repeat=\"fakeJob in vm.fakeJobs\" class=\"fake-jobs\">\n          <td colspan=\"10\"></td>\n        </tr>\n      </tbody>\n      <tbody ng-if=\"vm.jobs.length > 0 && vm.uiViews.is_loading_jobs==false\">\n        <tr ng-repeat=\"job in vm.jobs track by $index\"\n          ng-class=\"{ 'highlighted' : job.isChecked, 'payment-pending' : job.status == 'Payment Pending', 'live-job' :  job.status == 'Live' }\">\n          <td>\n            <input type=\"checkbox\" ng-checked=\"job.isChecked\" ng-click=\"vm.checkJob(job)\"\n              ng-if=\"vm.uiViews.is_company_verified==true && vm.uiViews.is_user_email_verified\" />\n          </td>\n          <td title=\"{{job.name}}\">\n            <i class=\"far fa-eye-slash display-icon\" data-toggle=\"tooltip\"\n              ng-if=\"job.isDisplayed.value==false && job.subEvents[0].deduppedJobbles[0].isPublished==true\"\n              ng-attr-title=\"{{job.isDisplayed.message}}\" data-placement=\"bottom\" data-html=\"true\"></i>\n              <span ng-click=\"vm.goToRoster(job.id)\">\n                <i \n                  class=\"fas fa-star display-icon w2-job\" \n                  data-toggle=\"tooltip\" \n                  ng-if=\"job.isW2==true\"\n                  ng-attr-title=\"W2 Job\" \n                  data-placement=\"bottom\" \n                  data-html=\"true\">\n              </i>\n                {{ job.nameShort }}\n            </span>    \n            <span class=\"event-id\" title=\"Event ID\" ng-click=\"vm.copyingEventId();\">\n              {{ job.id }}\n            </span>\n          </td>\n          <td ng-if=\"job.jobbleTypeName != 'Remote Job'\">\n            {{ job.contactInfo.city }}, {{ job.contactInfo.state }}\n          </td>\n          <td ng-if=\"job.jobbleTypeName == 'Remote Job'\" ng-click=\"vm.goToRoster(job.id)\">\n            Remote Job\n          </td>\n          <td ng-click=\"vm.goToRoster(job.id)\">\n            <i class=\"fas fa-circle\" ng-if=\"job.status=='Payment Pending'\"></i>\n            <a href=\"\" ng-click=\"vm.sendToPaymentPage(job)\" ng-if=\"job.status=='Payment Pending'\">{{ job.statusNew }}\n            </a>\n            <i class=\"fas fa-circle\" ng-if=\"job.status=='Live'\"></i>\n            <a href=\"\" ng-click=\"vm.sendToLivePage(job)\" ng-if=\"job.status=='Live'\">\n              {{ job.statusNew }}\n            </a>\n            <a href=\"\" ng-click=\"vm.sendToOverviewPage(job)\" ng-if=\"job.statusNew=='Published'\" class=\"published-link\">\n              {{ job.statusNew }}\n            </a>\n            <span ng-if=\"job.status!='Live' && job.status!='Payment Pending' && job.status != 'Published'\">\n              {{ job.statusNew }}\n            </span>\n            <span ng-if=\"job.isLongTerm == true\" style=\"font-size:10px;\">\n              <br />\n              <span class=\"ltg-tag\" ng-if=\"job.currentWeek!=false\">Recurring <span ng-if=\"job.totalWeeks != 0\">- [Week\n                  {{job.currentWeek}} of {{job.totalWeeks}}]</span></span>\n              <span class=\"ltg-tag\" ng-if=\"job.currentWeek==false\">Recurring Job</span>\n            </span>\n          </td>\n          <td ng-click=\"vm.goToRoster(job.id)\">{{ vm.getEventDate(job.startTime, job.contactInfo.timeZoneId, job) }}\n          </td>\n          <td ng-click=\"vm.goToRoster(job.id)\">{{ vm.getEventDate(job.endTime, job.contactInfo.timeZoneId, job) }}</td>\n          <td ng-click=\"vm.goToRoster(job.id)\">${{ vm.getPayRate(job) }}</td>\n          <td ng-click=\"vm.goToRoster(job.id)\">{{ job.originalOpenings }}</td>\n          <td ng-click=\"vm.goToRoster(job.id)\" ng-show=\"vm.currentUser.isAdmin == true\" class=\"fill-score\"\n            ng-class=\"{ 'fill-score-green' : job.fillScoreClass == 'green', 'fill-score-red' : job.fillScoreClass == 'red' }\">\n            {{ job.shiftFillScore ? job.shiftFillScore : \"0\" }}%\n          </td>\n          <td ng-click=\"vm.goToRoster(job.id)\">{{ job.confirmedShifts }}</td>\n          <td>\n            <!--ng-if=\"vm.uiViews.is_company_verified==true && vm.uiViews.is_user_email_verified\"-->\n            <i class=\"fas fa-ellipsis-h\" ng-click=\"vm.toggleActionMenu(job,$index)\">\n            </i>\n\n            <div class=\"action-menu\" ng-blur=\"vm.closeActionMenu(job,$index)\" tabindex=\"{{$index}}\">\n              <ul>\n                <li ng-repeat=\"actions in job.menu track by $index\">\n                  <a href=\"#\" ng-click=\"vm.setOverviewModal(job)\"\n                    ng-if=\"$index==0 && (job.status != 'Draft' && job.status != 'Scheduled' && job.companyIsNotVerified != true)\">\n                    <i class=\"{{actions.iconClass}}\"></i>\n                    {{actions.name}}\n                  </a>\n                  <a href=\"#\" ng-click=\"vm.setOverviewModal(job)\"\n                    ng-if=\"$index==0 && (job.status == 'Draft' || job.status == 'Scheduled' && job.companyIsNotVerified != true)\">\n                    <i class=\"{{actions.iconClass}}\"></i>\n                    {{actions.name}}\n                  </a>\n                  <!--\n                <a\n                  href=\"{{actions.link}}\"\n                  ng-if=\"$index== 1 && (job.status == 'Draft' || job.status == 'Scheduled' || job.companyIsNotVerified == true)\">\n                  <i class=\"{{actions.iconClass}}\"></i>\n                  {{actions.name}}\n                </a>\n                -->\n                  <a href=\"{{actions.link}}\"\n                    ng-if=\"$index!= 0 && $index!=5 && $index!=6 && $index!=7 && $index!=8 && $index!=9\">\n\n                    <i class=\"{{actions.iconClass}}\"></i>\n                    {{actions.name}}\n                    <i class=\"fas fa-circle alerts\" ng-if=\"job.status=='Payment Pending' && $index==4\"></i>\n                    <i class=\"fas fa-circle alerts-live\" ng-if=\"job.status=='Live' && $index==3\"></i>\n                  </a>\n                  <a href=\"#modal-add-openings\" data-toggle=\"modal\" ng-click=\"vm.setEventOpenings(job)\"\n                    ng-if=\"$index==5\">\n                    <i class=\"{{actions.iconClass}}\"></i>\n                    {{actions.name}}\n                  </a>\n                  <a href=\"{{actions.link}}\" ng-click=\"vm.triggerCloningModal(job)\" ng-if=\"$index==6\">\n                    <i class=\"{{actions.iconClass}}\"></i>\n                    {{actions.name}}\n                  </a>\n                  <a href=\"#\" ng-click=\"vm.copyJobbleID(job)\" ng-if=\"$index==7\">\n                    <i class=\"{{actions.iconClass}}\"></i>\n                    {{actions.name}}\n                  </a>\n                  <a href=\"#\" ng-click=\"vm.copyEventID(job)\" ng-if=\"$index==8\">\n                    <i class=\"{{actions.iconClass}}\"></i>\n                    {{actions.name}}\n                  </a>\n                  <a href=\"#\" ng-click=\"vm.extendJob(job)\" ng-if=\"$index==9 && job.canExtend == true\">\n                    <i class=\"{{actions.iconClass}}\"></i>\n                    {{actions.name}}\n                  </a>\n                </li>\n              </ul>\n            </div>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n\n    <div class=\"no-jobs-available\" ng-if=\"vm.jobs.length == 0 && vm.uiViews.is_loading==false\">\n      No jobs in the result set, Please try another search.\n    </div>\n  </div>\n\n</div>\n\n<div class=\"jobs-counter\" ng-if=\"vm.uiViews.is_company_verified==true\">\n</div>\n\n<div class=\"jobs-dashboard-footer\" ng-if=\"vm.uiViews.is_company_verified==true\">\n  <a class=\"pagination-for-jobs\" href=\"\" ng-click=\"vm.paginateJobs()\"\n    ng-class=\"{'pagination-disabled' : vm.checkForMoreJobs() }\">\n    SHOW MORE <i class=\"fas fa-chevron-down\"></i>\n  </a>\n</div>\n\n\n<jobblefooter></jobblefooter>\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n<globalmodal></globalmodal>\n<eventdialog></eventdialog>\n\n\n<div class=\"confirm-roster-download\">\n  <div class=\"modal\" id=\"confirm-roster-download\" tabindex=\"-1\" role=\"dialog\" style=\"position:fixed;\">\n\n    <div class=\"modal-dialog modal-m regi-form-board partner\" role=\"document\">\n      <div class=\"modal-gradient-banner\"></div>\n      <div class=\"modal-content\">\n        <div class=\"modal-fixed-bar\">\n          <div class=\"save-exit\" ng-click=\"vm.exit(1)\">\n            <i class=\"fas fa-times\"></i>\n          </div>\n        </div>\n        <div class=\"modal-content-container\">\n          <div>\n            <h3>Download Roster</h3>\n            <p>\n              Please confirm you would like to\n              download the roster from this job into a CSV file.\n            </p>\n          </div>\n          <div>\n            <div ng-if=\"vm.rosterDownloadIsDisable==true\">\n              <p>Loading Roster...</p>\n            </div>\n            <div ng-if=\"vm.rosterDownloadIsDisable==false\" class=\"continue-button\" ng-csv=\"vm.csvRoster\"\n              csv-header=\"vm.getHeaderRoster()\" filename=\"{{vm.csvNameRoster}}\" field-separator=\",\"\n              decimal-separator=\".\" ng-disabled=\"vm.rosterDownloadIsDisable\" ng-click=\"vm.downloadRosterCSV()\">\n              Download Roster\n            </div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n</div>\n\n<div class=\"confirm-roster-download\">\n  <div class=\"modal\" id=\"verify-email-warning\" tabindex=\"-1\" role=\"dialog\" style=\"position:fixed;\">\n\n    <div class=\"modal-dialog modal-m regi-form-board partner\" role=\"document\">\n      <div class=\"modal-gradient-banner\"></div>\n      <div class=\"modal-content\">\n        <div class=\"modal-fixed-bar\">\n          <div class=\"save-exit\" ng-click=\"vm.exit(2)\">\n            <i class=\"fas fa-times\"></i>\n          </div>\n        </div>\n        <div class=\"modal-content-container\">\n          <div>\n            <h3>Verify Your Email</h3>\n            <p>\n              Please verify your email address by clicking the link in the verification email we sent after registration.\n            </p>\n            <p>\n              Upon completion of email verification, our internal team will review your company for approval. Once your\n              account is verified and approved, your account will become active and job posts will be\n              published.\n            </p>\n          </div>\n          <div>\n            <div class=\"continue-button\" ng-click=\"vm.pullLatestUserData(true)\">\n              I have verified my email address.\n            </div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n</div>\n\n<div class=\"confirm-roster-download\">\n  <div class=\"modal\" id=\"promote-job\" tabindex=\"-1\" role=\"dialog\">\n\n    <div class=\"modal-dialog modal-m regi-form-board partner\" role=\"document\">\n      <div class=\"modal-gradient-banner\"></div>\n      <div class=\"modal-content\">\n        <div class=\"modal-fixed-bar\">\n          <div class=\"save-exit\" ng-click=\"vm.exit(3)\">\n            <i class=\"fas fa-times\"></i>\n          </div>\n        </div>\n        <div class=\"modal-content-container\">\n          <div>\n            <h3>Promote Job</h3>\n            <p>\n              Are you sure you want to promote this job?\n            </p>\n          </div>\n          <div>\n            <div class=\"continue-button\" ng-click=\"vm.confirmPromote()\">\n              Promote\n            </div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n</div>\n\n\n<div class=\"confirm-roster-download\">\n  <div class=\"modal\" id=\"job-overview-modal\" tabindex=\"-1\" role=\"dialog\">\n\n    <div class=\"modal-dialog modal-m regi-form-board partner\" role=\"document\">\n      <div class=\"modal-gradient-banner\"></div>\n      <!--min-height: 738px;-->\n      <div class=\"modal-content\" style=\"overflow-y: scroll;\" ng-style=\"{height: vm.heightOfModal + 'px;'}\">\n        <div class=\"modal-fixed-bar\">\n          <div class=\"save-exit\" ng-click=\"vm.exit(4)\">\n            <i class=\"fas fa-times\"></i>\n          </div>\n        </div>\n        <div class=\"modal-content-container\">\n          <div>\n            <h5 ng-show=\"vm.overviewJob.name\" style=\"margin-top:5px;\">{{vm.currentUser.company.name}} -\n              {{vm.overviewJob.name}}</h5>\n            <img style=\"width: 75px;margin-top: 10px;\" src=\"/app/vendor/images/exclusive.png\"\n              ng-if=\"vm.overviewJob.subEvents[0].deduppedJobbles[0].forCircleOnly == true\" />\n            <div ng-if=\"vm.overviewJob.subEvents[0].deduppedJobbles[0].forCircleOnly == true\">\n              <h4 style=\"text-decoration: underline;margin-top: 3px;margin-bottom: 0px;\">Available\n                teams</h4>\n              <ol style=\"margin-top: 0px;font-size: 12px;\">\n                <li ng-repeat=\"team in vm.teamsPostedTo\">\n                  {{team}}\n                </li>\n              </ol>\n            </div>\n          </div>\n          <div style=\"padding-bottom: 10px;\">\n            <table>\n              <tbody>\n                <tr>\n                  <td>\n                    <span>Openings</span>\n                    <span>{{vm.overviewJob.originalOpenings}}</span>\n                  </td>\n                  <td>\n                    <span>Hired</span>\n                    <span>{{vm.overviewJob.numberOfApprovedApplications}}</span>\n                  </td>\n                  <td>\n                    <span>Applied</span>\n                    <span>{{vm.overviewJob.numberOfPendingApplications}}</span>\n                  </td>\n                </tr>\n                <tr>\n                  <td>\n                    <span>Rejected</span>\n                    <span>{{vm.overviewJob.numberOfRejectedApplications}}</span>\n                  </td>\n                  <td>\n                    <span>Quit</span>\n                    <span>{{vm.overviewJob.numberOfQuitApplications}}</span>\n                  </td>\n                  <td>\n                    <span>Withdrawn</span>\n                    <span>{{vm.overviewJob.numberOfWithdrawnApplications}}</span>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n          <div>\n            <a href=\"#\" class=\"overview-text\" ng-click=\"vm.goToManageRoster()\">\n              Manage Roster\n            </a>\n          </div>\n          <div>\n            <h4>Location</h4>\n            <span class=\"overview-text\"\n              ng-if=\"vm.overviewJob.subEvents[0].deduppedJobbles[0].jobbleType.name != 'Remote Job'\">\n              {{ vm.getShiftLocation(vm.overviewJob.subEvents[0].deduppedJobbles[0].shifts[0]) }}\n            </span>\n            <span class=\"overview-text\"\n              ng-if=\"vm.overviewJob.subEvents[0].deduppedJobbles[0].jobbleType.name == 'Remote Job'\">\n              Remote Job\n            </span>\n          </div>\n\n          <div>\n            <h4>Date & Time</h4>\n            <ul>\n              <li ng-repeat=\"shift in vm.overviewJob.subEvents[0].deduppedJobbles[0].shifts track by $index\">\n                {{ shift.startDateFormatted }} {{ shift.startTimeFormatted }} -\n                {{ shift.endTimeFormatted }} {{ shift.TZ }}\n              </li>\n            </ul>\n          </div>\n\n          <div>\n            <h4>About this job</h4>\n            <span class=\"overview-text\">{{vm.overviewJob.description}}</span>\n          </div>\n\n          <div>\n            <h4>Job Type</h4>\n            <span class=\"overview-text\">{{vm.overviewJob.subEvents[0].deduppedJobbles[0].jobbleType.name}}</span>\n          </div>\n\n          <div>\n            <h4>Hiring Manager</h4>\n            <span class=\"overview-text\">{{vm.overviewJob.onsiteManagerName}}</span>\n          </div>\n\n          <div>\n            <h4>Suggested Attire</h4>\n            <span class=\"overview-text\">{{vm.overviewJob.subEvents[0].deduppedJobbles[0].dressCode}}</span>\n          </div>\n\n          <div ng-if=\"vm.overviewJob.surveyQuestions && vm.overviewJob.surveyQuestions.length > 0\">\n            <h4>Questionnaire</h4>\n            <ul class=\"req-list\">\n              <li ng-repeat=\"q in vm.overviewJob.surveyQuestions\">\n                {{q.question}}\n              </li>\n            </ul>\n          </div>\n\n          <div ng-if=vm.requirements>\n            <h4>Requirements</h4>\n            <ul class=\"req-list\">\n              <li ng-repeat=\"req in vm.requirements\">\n                {{req.name}}\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n</div>\n\n\n<div class=\"confirm-roster-download\">\n  <div class=\"modal\" id=\"job-scheduled\" tabindex=\"-1\">\n    <div class=\"modal-dialog modal-m regi-form-board partner\" role=\"document\" style=\"width:445px;\">\n      <div class=\"modal-gradient-banner\"></div>\n      <div class=\"modal-content\">\n        <div class=\"modal-fixed-bar\">\n          <div class=\"save-exit\" ng-click=\"vm.exit(5)\">\n            <i class=\"fas fa-times\"></i>\n          </div>\n        </div>\n        <div class=\"modal-content-container\">\n          <div>\n            <h3>Your Recurring Job has been scheduled</h3>\n\n            <p>\n              Please allow our system 10-15 minutes to generate the jobs you have created.\n            </p>\n\n            <p style=\"font-size:16px;font-weight:800;text-decoration:underline;\">{{vm.schedulingMsg}}</p>\n\n            <p>\n              Jobs that have been scheduled to recur for more than two weeks out will be stored under your\n              Draft section in the Jobs Dashboard.\n              These future jobs will automatically be published to our job board for the Jobblers to apply\n              once the start date of the job is is\n              one week away.\n            </p>\n          </div>\n          <div>\n            <div ng-click=\"vm.exit(5)\" class=\"continue-button\">\n              Close\n            </div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"confirm-roster-download\">\n  <div class=\"modal fade\" id=\"job-extended\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n    data-backdrop=\"static\">\n    <div class=\"modal-dialog modal-m regi-form-board partner\" role=\"document\" style=\"width:300px;\">\n      <div class=\"modal-gradient-banner\"></div>\n      <div class=\"modal-content\">\n        <div class=\"modal-fixed-bar\">\n          <div class=\"save-exit\" ng-click=\"vm.exit(6)\">\n            <i class=\"fas fa-times\"></i>\n          </div>\n        </div>\n        <div class=\"modal-content-container\">\n            <div>\n              <h3>How many weeks would you like to add to this job?</h3>\n            </div>\n            <div>\n              <p>This job is currently scheduled to run for a total of {{vm.extendPayload.totalWeeks}} weeks. Please select how \n                many additional weeks you would like to add below:</p>\n            </div>\n            <div style=\"margin-top:15px;\"\">\n              <select \n              style=\"padding-left: 10px;\"\n              ng-model=\"vm.tempWeek\" \n              ng-options=\"week for week in vm.tempWeeks\">\n              </select>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div ng-click=\"vm.extendJobConfirm()\" class=\"continue-button\">\n                  Extend Job\n                </div>\n              </div>\n              <!--\n              <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                <div ng-click=\"vm.exit(6)\" class=\"continue-button\">\n                  Cancel\n                </div>\n              </div>\n              -->\n            </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"confirm-roster-download\">\n  <div class=\"modal fade\" id=\"job-extended-confirm\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n    data-backdrop=\"static\">\n    <div class=\"modal-dialog modal-m regi-form-board partner\" role=\"document\" style=\"width:300px;\">\n      <div class=\"modal-gradient-banner\"></div>\n      <div class=\"modal-content\">\n        <div class=\"modal-fixed-bar\">\n          <div class=\"save-exit\" ng-click=\"vm.exit(7)\">\n            <i class=\"fas fa-times\"></i>\n          </div>\n        </div>\n        <div class=\"modal-content-container\">\n            <div>\n              <h3>Your job has been successfully extended!</h3>\n            </div>\n            <div>\n              <p>\n                Please give our system a few moments to generate the new jobs.\n              </p>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div ng-click=\"vm.exit(7)\" class=\"continue-button\">\n                  Sounds good\n                </div>\n              </div>\n            </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	__webpack_require__(276);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobsdashboardController = function () {
	  function JobsdashboardController($http, $localStorage, $state, $q, $window, $stateParams, $location, CommonService, AuthService, EnvService, CompaniesService, JobsService, EventsService, $timeout, SecurityService, $rootScope, $scope, TrackingService, ngProgressFactory, $cookies, $social, validation, branchio) {
	    _classCallCheck(this, JobsdashboardController);
	
	    this.name = "jobsdashboard";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$common = CommonService;
	    this.currentUser = this.$auth.getUserData();
	    this.$env = EnvService;
	    this.$window = $window;
	    this.$location = $location;
	    this.$branchio = branchio;
	    this.$stateParams = $stateParams;
	    this.$events = EventsService;
	    this.$timeout = $timeout;
	    this.$jobs = JobsService;
	    this.$security = SecurityService;
	    this.$rootScope = $rootScope;
	    this.fakeJobs = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25];
	    this.tempWeeks = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	    this.tempWeek = 1;
	    this.$q = $q;
	    this.$companies = CompaniesService;
	    this.$social = $social;
	    this.$tracking = TrackingService;
	    this.displayVerificationSteps = false;
	    this.alreadyInitialized = false;
	    this.$scope = $scope;
	    this.jobStatus = "Published";
	    this.remain_loading_count = 0;
	    this.companyVerificationData = {
	      isVerified: true
	    };
	    this.pageNumber = 1;
	    this.$progress = ngProgressFactory.createInstance();
	    this.teamsPostedTo = [];
	    this.weHaveOneCheckedJob = false;
	    this.events_for_header = [];
	    this.csvName = "Jobs " + moment().format() + ".csv";
	    this.csvNameRoster = "Jobblers " + moment().format() + ".csv";
	    this.setJobPostingLoadingStatus();
	    this.uiViews = {
	      is_company_verified: null,
	      is_user_email_verified: null,
	      is_search: null,
	      is_loading: true,
	      is_loading_jobs: false,
	      no_jobs: null,
	      company_has_logo: null,
	      company_has_ein: null,
	      completed: this.$auth.hasCompletedPaymentInformation()
	    };
	
	    this.ui = {
	      allChecked: false
	    };
	
	    this.jobs = [];
	
	    var _this = this;
	
	    _this.SetEventToEventPagesListener = _this.$rootScope.$on("SetEventToEventPages", function ($event, params) {
	      _this.jobs.forEach(function (job) {
	        if (job.id === params.event.id) {
	          job.cost = params.event.cost;
	          if (params.action === "Add") {
	            job.numberOfOpenings = params.event.numberOfOpenings + params.numberOfOpenings;
	          } else {
	            job.numberOfOpenings = params.event.numberOfOpenings - params.numberOfOpenings;
	          }
	          job.totalNumberOfJobbles = params.event.totalNumberOfJobbles;
	        }
	      });
	
	      _this.getJobs();
	    });
	
	    _this.InitJobsDashboardLoaderListener = _this.$rootScope.$on("InitJobsDashboardLoader", function ($event, params) {
	      _this.jobs.length = 0;
	      _this.uiViews.is_loading = true;
	    });
	
	    _this.JobHasBeenScheduledListener = _this.$rootScope.$on("JobHasBeenScheduled", function ($event, params) {
	      if (params.numberOfWeeksToScheduleJob > 0) {
	        _this.displaySchedulingModal(params);
	      }
	    });
	
	    _this.UnverifiedBankWarningListener = _this.$rootScope.$on("UnverifiedBankWarning", function ($event, banks) {
	      _this.setUnverifiedWarning(banks);
	    });
	
	    _this.RecentUserUpdatedTrimmedListener = _this.$rootScope.$on("RecentUserUpdatedTrimmed", function ($event, data) {
	      _this.currentUser = data;
	      if (_this.currentUser) {
	        _this.checkAdmin();
	      }
	      if (_this.$state.current === "jobsdashboard" && this.alreadyInitialized === false) {
	        this.alreadyInitialized = true;
	        _this.init();
	      }
	    });
	
	    _this.$scope.$on("$destroy", _this.UserUpdateTriggerListener);
	    _this.$scope.$on("$destroy", _this.UnverifiedBankWarningListener);
	    _this.$scope.$on("$destroy", _this.JobHasBeenScheduledListener);
	    _this.$scope.$on("$destroy", _this.InitJobsDashboardLoaderListener);
	    _this.$scope.$on("$destroy", _this.SetEventToEventPagesListener);
	
	    _this.initializeOnRefresh();
	  }
	
	  _createClass(JobsdashboardController, [{
	    key: "calculatePublishedJobs",
	    value: function calculatePublishedJobs() {
	      return this.currentUser.company.totalNumberOfPublishedEvents ? this.currentUser.company.totalNumberOfPublishedEvents : 0;
	    }
	  }, {
	    key: "$onInit",
	    value: function $onInit() {
	      this.pullLatestUserData();
	    }
	  }, {
	    key: "initializeOnRefresh",
	    value: function initializeOnRefresh() {
	      if (this.alreadyInitialized === false) {
	        this.alreadyInitialized = true;
	        this.init();
	      } else {
	        if (this.$location.$$search) {
	          if (this.$location.$$search.action) {
	            if (this.$location.$$search.action === "login") {} else {}
	            //this.init();
	
	            //this.init();
	          }
	        }
	      }
	    }
	  }, {
	    key: "determineQueryParametersInUrl",
	    value: function determineQueryParametersInUrl(queryParameter) {
	      var result = {};
	
	      if (!queryParameter) {
	        if (Object.keys(this.$location.$$search).length > 0) {
	          this.$state.transitionTo("jobsdashboard", {
	            filter: this.$location.$$search.filter,
	            dashboardType: this.$location.$$search.dashboardType
	          }, { notify: false });
	
	          if (this.$location.$$search.filter === "published") {
	            this.tab(1);
	          } else if (this.$location.$$search.filter === "draft") {
	            this.tab(2);
	          } else if (this.$location.$$search.filter === "completed") {
	            this.tab(3);
	          } else if (this.$location.$$search.filter === "archived") {
	            this.tab(4);
	          }
	
	          return this.$location.$$search.filter;
	        } else {
	          this.$state.transitionTo("jobsdashboard", {
	            filter: "published",
	            dashboardType: this.$location.$$search.dashboardType
	          }, { notify: false });
	          this.tab(0);
	          return "published";
	        }
	      } else {
	
	        if (queryParameter != "search") {
	          this.$state.transitionTo("jobsdashboard", {
	            filter: queryParameter,
	            dashboardType: this.$location.$$search.dashboardType
	          }, { notify: false });
	
	          if (queryParameter === "published") {
	            this.tab(1);
	          } else if (queryParameter === "draft") {
	            this.tab(2);
	          } else if (queryParameter === "completed") {
	            this.tab(3);
	          } else if (queryParameter === "archived") {
	            this.tab(4);
	          }
	
	          return queryParameter;
	        }
	
	        return queryParameter;
	      }
	    }
	
	    /*
	      TODO:
	          we need to set the active list item based on what the url is, not the other way around
	       */
	
	  }, {
	    key: "tab",
	    value: function tab(index) {
	      if (this.uiViews.is_loading_jobs === true && this.jobs.length !== 0) {
	        return;
	      }
	
	      if (index === 0) {
	        index = index + 1;
	      }
	
	      this.$timeout(function () {
	        $(".tabbed-header-wrapper ul.tabbed-header li.active").removeClass("active");
	        $(".tabbed-header-wrapper ul.tabbed-header li:nth-child(" + index + ")").addClass("active");
	      }, 200);
	    }
	  }, {
	    key: "figureOutParams",
	    value: function figureOutParams(info) {
	      var data = this.determineQueryParametersInUrl(info);
	
	      if (data === "archived") {
	        this.requestParams.cancelledStatus = true;
	        this.requestParams.completedStatus = false;
	        this.requestParams.isDraftStatus = null;
	        this.requestParams.sort = "lastUpdated";
	        this.requestParams.order = "desc";
	        this.jobStatus = "Archived";
	        //this.requestParams.offset = 0;
	        //this.requestParams.max = 10;
	        this.requestParams.list = "archived";
	
	        this.jobQuery = null;
	        this.uiViews.is_search = false;
	        this.requestParams.multiSearch = null;
	      } else if (data === "draft") {
	        this.requestParams.cancelledStatus = null;
	        this.requestParams.completedStatus = null;
	        this.requestParams.isDraftStatus = true;
	        this.requestParams.sort = "startTime";
	        this.requestParams.order = "asc";
	        this.jobStatus = "Draft";
	        //this.requestParams.offset = 0;
	        //this.requestParams.max = 10;
	        this.requestParams.list = "draft";
	
	        this.jobQuery = null;
	        this.uiViews.is_search = false;
	        this.requestParams.multiSearch = null;
	      } else if (data === "published") {
	
	        this.requestParams.cancelledStatus = null;
	        this.requestParams.completedStatus = null;
	        this.requestParams.isDraftStatus = false;
	        this.requestParams.sort = "startTime";
	        this.requestParams.order = "asc";
	        this.jobStatus = "Published";
	        //this.requestParams.offset = 0;
	        //this.requestParams.max = 10;
	        this.requestParams.list = "published";
	
	        this.jobQuery = null;
	        this.uiViews.is_search = false;
	        this.requestParams.multiSearch = null;
	      } else if (data === "completed") {
	        this.requestParams.cancelledStatus = false;
	        this.requestParams.completedStatus = true;
	        this.requestParams.isDraftStatus = null;
	        this.requestParams.sort = "endTime";
	        this.requestParams.order = "desc";
	        this.jobStatus = "Completed";
	        //this.requestParams.offset = 0;
	        //this.requestParams.max = 10;
	        this.requestParams.list = "completed";
	        this.jobQuery = null;
	        this.uiViews.is_search = false;
	        this.requestParams.multiSearch = null;
	      } else if (data === "openings") {
	        if (this.requestParams.sort === "numberOfOpenings") {
	          if (this.requestParams.order === "asc") {
	            this.requestParams.order = "desc";
	          } else {
	            this.requestParams.order = "asc";
	          }
	        }
	        this.requestParams.sort = "numberOfOpenings";
	      } else if (data === "accepted-applications") {
	        if (this.requestParams.sort === "acceptedApplications") {
	          if (this.requestParams.order === "asc") {
	            this.requestParams.order = "desc";
	          } else {
	            this.requestParams.order = "asc";
	          }
	        }
	        this.requestParams.sort = "acceptedApplications";
	      } else if (data === "pending-applications") {
	        if (this.requestParams.sort === "pendingApplications") {
	          if (this.requestParams.order === "asc") {
	            this.requestParams.order = "desc";
	          } else {
	            this.requestParams.order = "asc";
	          }
	        }
	        this.requestParams.sort = "pendingApplications";
	      } else if (data === "rate") {
	        if (this.requestParams.sort === "payPerHour") {
	          if (this.requestParams.order === "asc") {
	            this.requestParams.order = "desc";
	          } else {
	            this.requestParams.order = "asc";
	          }
	        }
	        this.requestParams.sort = "payPerHour";
	      } else if (data === "job-title") {
	        if (this.requestParams.sort === "name") {
	          if (this.requestParams.order === "asc") {
	            this.requestParams.order = "desc";
	          } else {
	            this.requestParams.order = "asc";
	          }
	        }
	        this.requestParams.sort = "name";
	      } else if (data === "start-date") {
	        if (this.requestParams.sort === "startTime") {
	          if (this.requestParams.order === "asc") {
	            this.requestParams.order = "desc";
	          } else {
	            this.requestParams.order = "asc";
	          }
	        }
	        this.requestParams.sort = "startTime";
	      } else if (data === "end-date") {
	        if (this.requestParams.sort === "endTime") {
	          if (this.requestParams.order === "asc") {
	            this.requestParams.order = "desc";
	          } else {
	            this.requestParams.order = "asc";
	          }
	        }
	        this.requestParams.sort = "endTime";
	      } else if (data === "search") {
	
	        this.requestParams.cancelledStatus = null;
	        this.requestParams.completedStatus = null;
	        this.requestParams.isDraftStatus = null;
	        this.requestParams.multiSearch = this.jobQuery;
	        this.requestParams.sort = "lastUpdated";
	        this.requestParams.order = "desc";
	        this.requestParams.list = "search";
	
	        if (this.$location.$$search.filter === "published") {
	          this.requestParams.cancelledStatus = null;
	          this.requestParams.completedStatus = null;
	          this.requestParams.isDraftStatus = null;
	          this.requestParams.multiSearch = this.jobQuery;
	          this.requestParams.sort = "lastUpdated";
	          this.requestParams.order = "desc";
	          this.requestParams.list = "search";
	        } else if (this.$location.$$search.filter === "draft") {
	          this.requestParams.cancelledStatus = null;
	          this.requestParams.completedStatus = null;
	          this.requestParams.isDraftStatus = true;
	          this.requestParams.multiSearch = this.jobQuery;
	          this.requestParams.sort = "lastUpdated";
	          this.requestParams.order = "desc";
	          this.requestParams.list = "search";
	        } else if (this.$location.$$search.filter === "completed") {
	          this.requestParams.cancelledStatus = null;
	          this.requestParams.completedStatus = true;
	          this.requestParams.isDraftStatus = null;
	          this.requestParams.multiSearch = this.jobQuery;
	          this.requestParams.sort = "lastUpdated";
	          this.requestParams.order = "desc";
	          this.requestParams.list = "search";
	        } else if (this.$location.$$search.filter === "archived") {
	          this.requestParams.cancelledStatus = true;
	          this.requestParams.completedStatus = null;
	          this.requestParams.isDraftStatus = null;
	          this.requestParams.multiSearch = this.jobQuery;
	          this.requestParams.sort = "lastUpdated";
	          this.requestParams.order = "desc";
	          this.requestParams.list = "search";
	        }
	      }
	    }
	  }, {
	    key: "copyingEventId",
	    value: function copyingEventId() {}
	  }, {
	    key: "getJobs",
	    value: function getJobs(data, clearPagination, paginating, sortIndex) {
	      var _this = this;
	      var paging = paginating;
	      if (_this.uiViews.is_loading_jobs === true) {
	        return;
	      }
	
	      _this.uiViews.is_loading = true;
	      _this.ui.allChecked = false;
	      _this.weHaveOneCheckedJob = false;
	
	      if (paging !== true) {
	        _this.uiViews.is_loading_jobs = true;
	        _this.jobs.length = 0;
	        _this.jobs = [];
	      }
	
	      this.figureOutParams(data);
	      this.setLoader();
	
	      var payload = this.requestParams;
	
	      if (clearPagination) {
	        this.pageNumber = 1;
	        this.requestParams.offset = 0;
	      }
	
	      _this.$companies.getJobs(payload).then(function (response) {
	        _this.processJobs(response.data, paging, sortIndex);
	        _this.$timeout(function () {
	          _this.unSetLoader();
	        }, 1000);
	      }, function (error) {
	        _this.unSetLoader();
	      });
	
	      /*
	          let dbType = this.determineDashboardType();
	           console.log("dbType");
	          console.dir(dbType);
	           if (dbType === "OD") {
	              _this.$companies.getJobs(payload).then(
	                  function (response) {
	                      console.log("get jobs response");
	                      console.dir(response);
	                      _this.processJobs(response.data.hits.hits, paging, sortIndex);
	                      _this.unSetLoader();
	                  },
	                  function (error) {
	                      console.log("whats the error");
	                      console.dir(error);
	                      _this.unSetLoader();
	                  }
	              );
	          } else {
	              _this.$companies.getJobs(payload).then(
	                  function (response) {
	                      _this.processJobs(response.data, paging, sortIndex);
	                      _this.unSetLoader();
	                  },
	                  function (error) {
	                      console.dir("whats the error");
	                      console.dir(error);
	                      _this.unSetLoader();
	                  }
	              );
	          }*/
	    }
	  }, {
	    key: "setName",
	    value: function setName(job) {
	      if (job.name.length > 64) {
	        job.nameShort = job.name.substring(0, 65) + "...";
	      } else {
	        job.nameShort = job.name;
	      }
	    }
	  }, {
	    key: "setJobbleType",
	    value: function setJobbleType(job) {
	      if (job.subEvents[0].deduppedJobbles[0]) {
	        job.jobbleTypeId = job.subEvents[0].deduppedJobbles[0].jobbleType.id;
	        job.jobbleTypeName = job.subEvents[0].deduppedJobbles[0].jobbleType.name;
	      }
	    }
	  }, {
	    key: "processJobs",
	    value: function processJobs(jobs, paginating, sortIndex) {
	      var _this = this;
	
	      try {
	        jobs.forEach(function (job) {
	          //job = job._source;
	          job.isChecked = false;
	          _this.setJobbleType(job);
	          _this.setName(job);
	          _this.addExtraAttributesToEvent(job);
	          _this.isLongTerm(job);
	          _this.setMenuForJob(job);
	          job.canExtend = _this.setExtensionPermissions(job);
	          _this.jobs.push(job);
	        });
	      } catch (err) {
	        console.log("what is the error");
	        console.dir(err);
	      } finally {
	        if (!paginating) {
	          _this.weHaveOneCheckedJob = false;
	        }
	
	        this.prepJobsForCSV(this.jobs);
	        this.uiViews.is_loading = false;
	        this.uiViews.is_loading_jobs = false;
	        this.$localStorage.events = this.jobs;
	        this.enableToolTips();
	        this.fancyLoad(this.jobs.length);
	        this.showActionMenu();
	        if (sortIndex) {
	          _this.setSortHighlights(sortIndex);
	        }
	      }
	    }
	  }, {
	    key: "setExtensionPermissions",
	    value: function setExtensionPermissions(job) {
	      var result = void 0;
	      if (job.isLongTerm === true && moment(job.endTime).isAfter(moment()) && this.$location.$$search.filter === "published") {
	        console.log("we have an extension....");
	        result = true;
	      } else {
	        result = false;
	      }
	      return result;
	    }
	  }, {
	    key: "getStartAndEndDate",
	    value: function getStartAndEndDate(job) {
	      return "Start date";
	    }
	  }, {
	    key: "showActionMenu",
	    value: function showActionMenu() {
	      this.$timeout(function () {
	        $(".jobs-dashboard-container-header-actions .jobs-dashboard-actions-list-container").show();
	        $(".jobs-dashboard-footer a").show();
	      }, 1000);
	    }
	  }, {
	    key: "hideJobs",
	    value: function hideJobs() {
	      this.$timeout(function () {
	        $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table tbody tr").addClass("hide-jobs");
	      });
	    }
	  }, {
	    key: "fancyLoad",
	    value: function fancyLoad() {
	      this.$timeout(function () {
	        $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table tbody tr").each(function (index) {
	          $(this).delay(index * 10).show(50);
	        });
	      }, 200);
	    }
	  }, {
	    key: "enableToolTips",
	    value: function enableToolTips() {
	      this.$timeout(function () {
	        $(".display-icon").tooltip({});
	        //$(".status-icon").tooltip({});
	        $(".fill-score").tooltip({});
	      }, 200);
	    }
	  }, {
	    key: "setSortHighlights",
	    value: function setSortHighlights(index) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        //$('table.jobs-dashboard-jobs-table tbody tr td:nth-child(' + index + ')').addClass('high-light-column');
	      }, 300);
	    }
	  }, {
	    key: "getEventDate",
	    value: function getEventDate(raw_date, tz, job) {
	      var _this = this;
	
	      var date = new Date(raw_date);
	      var user_time_zone = moment.tz.guess();
	      var now = moment.tz(user_time_zone);
	
	      if (tz) {
	        var nowThere = moment.tz(tz);
	        var timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
	        var startTimeAsMoment = moment(raw_date);
	        var st = job.startTime;
	        var tzid = tz;
	        // h:mm a
	        return moment(date).tz(tz).format("MMM DD, YYYY");
	      }
	    }
	  }, {
	    key: "addExtraAttributesToEvent",
	    value: function addExtraAttributesToEvent(event) {
	      event.status = "Live";
	
	      var startTimeOfJob = null;
	      var endTimeOfJob = null;
	      var paymentPending = null;
	      var startTimeCheck = null;
	      var endTimeCheck = null;
	
	      startTimeOfJob = moment(event.startTime).format();
	      endTimeOfJob = moment(event.endTime).format();
	      startTimeCheck = moment().diff(startTimeOfJob, "minutes") >= -10;
	      endTimeCheck = moment().diff(endTimeOfJob, "minutes") <= 10;
	      paymentPending = moment().diff(endTimeOfJob, "minutes") >= 10;
	
	      event.isDisplayed = this.determineDisplayLogic(event, event.subEvents[0].deduppedJobbles[0].isDisplayed);
	
	      this.setEventsToHeader(event);
	
	      if (event.shiftFillScore >= 90) {
	        event.fillScoreClass = "green";
	      } else if (event.shiftFillScore <= 98 && event.shiftFillScore >= 50) {
	        event.fillScoreClass = "orange";
	      } else {
	        event.fillScoreClass = "red";
	      }
	
	      if (!this.currentUser.company.isVerified) {
	        event.companyIsNotVerified = true;
	        event.status = "Company Under Review";
	        event.statusNew = "Company Under Review";
	        event.listColor = "event-listing-color-red";
	        return;
	      } else {
	        event.companyIsNotVerified = false;
	      }
	      if (!event.subEvents[0].deduppedJobbles[0]) {
	        return;
	      }
	      if (event.isCancelled) {
	        event.status = "Archived";
	        event.statusNew = "Archived";
	        event.listColor = "event-listing-color-black";
	        return;
	      }
	      if (event.isCompleted) {
	        event.status = "Completed";
	        event.statusNew = "Completed";
	        event.listColor = "event-listing-color-black";
	        return;
	      }
	      if (!event.subEvents[0].deduppedJobbles[0].isPublished) {
	        if (!this.currentUser.company.isVerified) {
	          event.status = "Pending Approval";
	          event.listColor = "event-listing-color-red";
	          event.notpublished = true;
	          return;
	        } else {
	          if (event.autoPost === true) {
	            event.status = "Scheduled";
	            event.statusNew = "Scheduled";
	          } else {
	            event.status = "Draft";
	            event.statusNew = "Draft";
	          }
	          event.listColor = "event-listing-color-blue";
	          event.notpublished = true;
	          if (event.isCancelled) {
	            event.status = "Archived";
	            event.listColor = "event-listing-color-black";
	            return;
	          }
	          return;
	        }
	      } else if (!event.subEvents[0].deduppedJobbles[0].isPublished && event.numberOfApprovedApplications === 1) {
	        if (event.hired_driver) {
	          event.status = "Filled - " + event.hired_driver;
	        } else {
	          event.status = "Published - Filled";
	          event.statusNew = "Published - Filled";
	        }
	        event.listColor = "event-listing-color-orange";
	        if (paymentPending === true) {
	          if (event.hired_driver) {
	            //console.log("coming right herelol");
	            event.status = "Payment Pending - " + event.hired_driver;
	          } else {
	            event.status = "Payment Pending";
	            event.statusNew = "Published";
	            //_this.check_hired_numbers(event);
	          }
	          event.listColor = "event-listing-color-red";
	          return;
	        }
	        return;
	      } else if (!event.subEvents[0].deduppedJobbles[0].isPublished && event.orderNumber && event.numberOfApprovedApplications === 0) {
	        event.status = "Removed from board";
	        event.listColor = "event-listing-color-red";
	        return;
	      }
	      if (event.subEvents[0].deduppedJobbles[0].isPublished) {
	        if (event.isCompleted || event.isClosed) {
	          event.status = "Completed";
	          event.listColor = "event-listing-color-black";
	          return;
	        }
	        if (event.isCancelled) {
	          event.status = "Archived";
	          event.listColor = "event-listing-color-black";
	          return;
	        }
	        if (startTimeCheck === true && endTimeCheck === true) {
	          event.status = "Live";
	          event.statusNew = "Live";
	          event.listColor = "event-listing-color-green";
	          return;
	        }
	        if (paymentPending === true) {
	          if (event.isSourcingPost) {
	            event.status = "Removed - 30 Days Expired";
	          } else {
	            event.status = "Payment Pending";
	            event.statusNew = "Payment Pending";
	          }
	          event.listColor = "event-listing-color-red";
	          return;
	        } else {
	          event.status = "Published";
	          event.statusNew = "Published";
	          event.listColor = "event-listing-color-orange";
	        }
	      }
	    }
	  }, {
	    key: "setEventsToHeader",
	    value: function setEventsToHeader(event) {
	      var _this = this;
	
	      this.events_for_header.push(event);
	
	      if (_this.events_for_header.length === _this.jobs.length) {
	        var events = _this.events_for_header;
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetEventsToScroller", { events: events });
	        });
	      }
	    }
	  }, {
	    key: "determineDisplayLogic",
	    value: function determineDisplayLogic(event, isDisplayed) {
	      var startTimeMoment = moment(event.startTime);
	      var endTimeMoment = moment(event.endTime);
	      var dateCreatedMoment = moment(event.dateCreated);
	      var now = moment();
	      var differenceInDays = startTimeMoment.diff(now, "days");
	      var differenceToEndTime = endTimeMoment.diff(now, "hours");
	      var differenceToCreationTime = dateCreatedMoment.diff(now, "minutes");
	      var result = {};
	
	      if (isDisplayed === false) {
	        if (differenceToCreationTime >= -10) {
	          result.value = false;
	          result.message = "Thank you for creating a new job! Please give our system a few minutes to propagate this job to the appropriate jobblers.";
	        } else if (differenceInDays >= 21) {
	          result.value = false;
	          result.message = "This job is not displayed on the job board because the start time of the first shift is more than three weeks in the future.";
	        } else if (differenceInDays < 21) {
	          if (differenceToEndTime < 48 && differenceToEndTime > 0) {
	            result.value = false;
	            result.message = "This job has been removed from the board because the last shift is less than 48 hours away.";
	          } else if (differenceToEndTime < 48 && differenceToEndTime <= 0) {
	            result.value = false;
	            result.message = "This job has been removed from the job board because it has ended.";
	          } else {
	            if (event.shiftFillScore > 100) {
	              result.value = false;
	              result.message = "This job is not displayed on the board because the applicant fill score is greater than 100. No more jobblers are needed.";
	            } else {
	              result.value = false;
	              result.message = "This job has been removed from the job board.";
	            }
	          }
	        } else {
	          result.value = false;
	          result.message = "This job has met the threshold of applicants.";
	        }
	      } else {
	        result.value = true;
	        result.message = "Job is displaying";
	      }
	
	      return result;
	    }
	  }, {
	    key: "checkAll",
	    value: function checkAll() {
	      if (this.ui.allChecked === false) {
	        this.ui.allChecked = true;
	        this.checkOrUncheckAll(true);
	      } else {
	        this.ui.allChecked = false;
	        this.checkOrUncheckAll(false);
	      }
	
	      this.checkForAtleastOneCheckedJob();
	    }
	  }, {
	    key: "checkForAtleastOneCheckedJob",
	    value: function checkForAtleastOneCheckedJob() {
	      var _this = this;
	
	      _this.jobs.forEach(function (job) {
	        if (job.isChecked !== true) {
	          _this.weHaveOneCheckedJob = false;
	        }
	      });
	
	      _this.jobs.forEach(function (job) {
	        if (job.isChecked === true) {
	          _this.weHaveOneCheckedJob = true;
	        }
	      });
	    }
	  }, {
	    key: "checkOrUncheckAll",
	    value: function checkOrUncheckAll(checked) {
	      this.jobs.forEach(function (job) {
	        job.isChecked = checked;
	      });
	    }
	  }, {
	    key: "toggleActionMenu",
	    value: function toggleActionMenu(job, index) {
	      var _this = this;
	
	      var i = index + 1;
	
	      _this.$timeout(function () {
	        $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").slideToggle({ duration: 100 });
	      });
	
	      _this.$timeout(function () {
	        $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td").addClass("row-focus");
	      }, 150);
	
	      _this.$timeout(function () {
	        $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").focus();
	      }, 300);
	    }
	  }, {
	    key: "sendToLivePage",
	    value: function sendToLivePage(job) {
	      this.$state.go("eventreviewapplicants", { eventId: job.id });
	    }
	  }, {
	    key: "sendToPaymentPage",
	    value: function sendToPaymentPage(job) {
	      this.$state.go("eventreviewapplicants", { eventId: job.id });
	    }
	  }, {
	    key: "sendToOverviewPage",
	    value: function sendToOverviewPage(job) {
	      this.$state.go("eventeditdetails", { eventId: job.id });
	    }
	  }, {
	    key: "closeActionMenu",
	    value: function closeActionMenu(job, index) {
	
	      var i = index + 1;
	
	      this.$timeout(function () {
	        $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").hide();
	        $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td").removeClass("row-focus");
	      }, 300);
	    }
	  }, {
	    key: "init",
	    value: function init() {
	      var _this = this;
	
	      if (_this.currentUser) {
	        var admin = _this.checkAdmin();
	        _this.setActionMenu(admin);
	        _this.checkVerification();
	        _this.checkForVerifiedBankAccount(_this.currentUser.company.undeletedPaymentInfos);
	        _this.getLatestUserData();
	        _this.requestParams = {
	          sort: null,
	          max: 25,
	          offset: 0,
	          companyId: this.currentUser.company.id,
	          completedStatus: null,
	          cancelledStatus: null,
	          dates: null,
	          order: "asc",
	          list: null
	        };
	        this.getJobs();
	      } else {
	        _this.$state.go("signin");
	      }
	    }
	  }, {
	    key: "viewVerificationModal",
	    value: function viewVerificationModal() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("#verify-email-warning").modal();
	      });
	    }
	  }, {
	    key: "getSettingsCTA",
	    value: function getSettingsCTA() {
	      var completed = this.$auth.hasCompletedPaymentInformation();
	
	      if (!completed.payment_added) {
	        return "your payment information";
	      } else if (!completed.ein_complete) {
	        return "your company EIN";
	      } else {
	        return "your company address";
	      }
	    }
	  }, {
	    key: "goToSettings",
	    value: function goToSettings() {
	      var _this2 = this;
	
	      var completed = this.$auth.hasCompletedPaymentInformation();
	
	      this.$timeout(function () {
	        if (!completed.payment_added) {
	          _this2.$location.path("/account-profile/" + _this2.currentUser.company.id + "/payment-information");
	        } else {
	          _this2.$location.path("/account-profile");
	        }
	      });
	    }
	  }, {
	    key: "checkVerification",
	    value: function checkVerification() {
	      if (this.currentUser.company.isVerified === false || this.currentUser.company.isVerified === null) {
	        this.uiViews.is_company_verified = false;
	      } else {
	        this.uiViews.is_company_verified = true;
	      }
	
	      if (this.currentUser.isVerified === false || this.currentUser.isVerified === null) {
	        this.uiViews.is_user_email_verified = false;
	      } else {
	        this.uiViews.is_user_email_verified = true;
	      }
	    }
	  }, {
	    key: "inboxLink",
	    value: function inboxLink(id) {
	      var _this = this;
	
	      if (_this.$rootScope.channelsHaveLoaded && !_this.$rootScope.channels) {
	        alert("This account has no active messages. If you think there are active messages please refresh the page.");
	      } else {
	        _this.$timeout(function () {
	          _this.$location.path("/messages/event/" + id);
	        });
	      }
	    }
	  }, {
	    key: "setMenuForJob",
	    value: function setMenuForJob(job) {
	      var _this = this;
	
	      if (job.status === "Draft" || job.status === "Scheduled" || job.companyIsNotVerified === true) {
	        job.menu = [{
	          name: "Overview",
	          link: "/event/" + job.id + "/overview",
	          ngClick: null,
	          iconClass: "fas fa-info-circle"
	        }, {
	          name: "Edit",
	          link: "/event/" + job.id + "/edit",
	          ngClick: null,
	          iconClass: "fas fa-edit"
	        }, {
	          name: "Publish",
	          link: "/post-a-shift/walkthrough?eid=" + job.id,
	          ngClick: null,
	          iconClass: "fas fa-upload"
	        }, {
	          name: "Manage Roster",
	          link: "/event/" + job.id + "/review",
	          ngClick: null,
	          iconClass: "fas fa-users"
	        }];
	      } else if (job.status === "Published" || job.status === "Payment Pending" || job.status === "Live" || job.status === "Completed" || job.statusNew === "Archived") {
	        if (job.status === "Completed") {
	          if (job.firstInvoices.length > 0) {
	            job.invoice = job.firstInvoices[0].payment;
	          } else {
	            job.invoice = "";
	          }
	
	          job.menu = [{
	            name: "Job overview",
	            link: "/event/" + job.id + "/overview",
	            ngClick: null,
	            iconClass: "fas fa-info-circle"
	          }, {
	            name: "Recap",
	            link: "/event/" + job.id + "/review",
	            ngClick: null,
	            iconClass: "fas fa-file-invoice"
	          }, {
	            name: "Edit",
	            link: "/event/" + job.id + "/edit",
	            ngClick: null,
	            iconClass: "fas fa-edit"
	          }, {
	            name: "Manage Roster",
	            link: "/event/" + job.id + "/review",
	            ngClick: null,
	            iconClass: "fas fa-users"
	          },
	          // {
	          //  name: "Download Roster",
	          //  link : "",
	          //  ngClick : null,
	          //  iconClass : "fas fa-download"
	          // },
	          // {
	          //  name: "View Roster",
	          //  link : "/event/" + job.id + "/roster",
	          //  ngClick : null,
	          //  iconClass : "fas fa-eye"
	          // },
	
	          {
	            name: "Make Payments",
	            link: "/event/" + job.id + "/review",
	            ngClick: null,
	            iconClass: "fas fa-hand-holding-usd"
	          }, {
	            name: "Add/Remove Openings",
	            link: "",
	            ngClick: "vm.setEventOpenings(job)",
	            iconClass: "fas fa-user-plus"
	          }, {
	            name: "Clone",
	            link: "/post-a-shift/walkthrough?cid=" + job.id,
	            ngClick: null,
	            iconClass: "far fa-clone"
	          }, {
	            name: "Copy Share Link",
	            link: "",
	            ngClick: null,
	            iconClass: "fas fa-copy"
	          }, {
	            name: "Copy Event & Jobble ID",
	            link: "",
	            ngClick: null,
	            iconClass: "fas fa-copy"
	          },
	          /*{
	                        name: "Promote Job",
	                        link: "",
	                        ngClick: null,
	                        iconClass: "fas fa-ad",
	                    },*/
	          {
	            name: "Invoice",
	            link: "/invoice/" + job.invoice + "?eventId=" + job.id,
	            ngClick: null,
	            iconClass: "fas fa-file-invoice"
	          }];
	        } else {
	          job.menu = [{
	            name: "Overview",
	            link: "/event/" + job.id + "/overview",
	            ngClick: null,
	            iconClass: "fas fa-info-circle"
	          }, {
	            name: "Manage Roster",
	            link: "/event/" + job.id + "/review",
	            ngClick: null,
	            iconClass: "fas fa-users"
	          },
	          // {
	          //  name: "Download Roster",
	          //  link : "",
	          //  ngClick : null,
	          //  iconClass : "fas fa-download"
	          // },
	          // {
	          //  name: "View Roster",
	          //  link : "/event/" + job.id + "/roster",
	          //  ngClick : null,
	          //  iconClass : "fas fa-eye"
	          // },
	          {
	            name: "Edit",
	            link: "/event/" + job.id + "/edit",
	            ngClick: null,
	            iconClass: "fas fa-edit"
	          }, {
	            name: "Live",
	            link: "/event/" + job.id + "/live",
	            ngClick: null,
	            iconClass: "fas fa-concierge-bell"
	          }, {
	            name: "Make Payments",
	            link: "/event/" + job.id + "/review",
	            ngClick: null,
	            iconClass: "fas fa-hand-holding-usd"
	          }, {
	            name: "Add/Remove Openings",
	            link: "",
	            ngClick: "vm.setEventOpenings(job)",
	            iconClass: "fas fa-user-plus"
	          }, {
	            name: "Clone",
	            link: "/post-a-shift/walkthrough?cid=" + job.id,
	            ngClick: null,
	            iconClass: "far fa-clone"
	          }, {
	            name: "Copy Share Link",
	            link: "",
	            ngClick: null,
	            iconClass: "fas fa-copy"
	          }, {
	            name: "Copy Event & Jobble ID",
	            link: "",
	            ngClick: null,
	            iconClass: "fas fa-copy"
	          }, {
	            name: "Extend Job",
	            link: "",
	            ngClick: null,
	            iconClass: "fas fa-plus"
	          }];
	        }
	      }
	    }
	  }, {
	    key: "openCloseExtendModal",
	    value: function openCloseExtendModal(toggle) {
	      if (toggle === true) {
	        this.$timeout(function () {
	          $("#job-extended").modal("toggle");
	        });
	      } else {
	        this.$timeout(function () {
	          $("#job-extended").modal();
	        });
	      }
	    }
	  }, {
	    key: "extendJob",
	    value: function extendJob(job) {
	      var extendPayload = {};
	      extendPayload.jobbleIdExtend = job.subEvents[0].deduppedJobbles[0].id;
	      extendPayload.totalWeeks = job.totalWeeks;
	      this.extendPayload = extendPayload;
	      this.openCloseExtendModal();
	    }
	  }, {
	    key: "openExtendConfirmationModal",
	    value: function openExtendConfirmationModal() {
	      this.$timeout(function () {
	        $("#job-extended-confirm").modal();
	      });
	    }
	  }, {
	    key: "extendJobConfirm",
	    value: function extendJobConfirm() {
	      var _this3 = this;
	
	      //only extend jobs that are currently live
	      //end time is > now
	      this.setLoader();
	
	      var weeks = parseInt(this.tempWeek);
	      this.extendPayload.weeks = this.extendPayload.totalWeeks + weeks - 1;
	
	      this.$events.extendJob(this.extendPayload).then(function (r) {
	        _this3.openCloseExtendModal(true);
	        _this3.$timeout(function () {
	          _this3.unSetLoader();
	          _this3.tempWeek = 1;
	          _this3.openExtendConfirmationModal();
	        }, 1000);
	      }, function (error) {
	        _this3.unSetLoader();
	        _this3.tempWeek = 1;
	        _this3.$timeout(function () {
	          _this3.openCloseExtendModal(true);
	        }, 1000);
	      });
	    }
	  }, {
	    key: "setActionMenu",
	    value: function setActionMenu(admin) {
	      var menu = null;
	
	      if (admin) {
	        menu = [{
	          name: "Overview",
	          link: "/event/{{event.id}}/overview"
	        }, {
	          name: "Review & Hire Applicants",
	          link: "http://"
	        }, {
	          name: "Message",
	          link: "http://"
	        }, {
	          name: "Roster",
	          link: "http://"
	        }, {
	          name: "Edit Details",
	          link: "http://"
	        }, {
	          name: "Live",
	          link: "http://"
	        }, {
	          name: "Make Payments",
	          link: "http://"
	        }, {
	          name: "Add/Remove Openings",
	          link: "http://"
	        }, {
	          name: "Clone",
	          link: "http://"
	        }, {
	          name: "Copy Job Link",
	          link: "http://"
	        }, {
	          name: "Copy Event ID",
	          link: "http://"
	        }, {
	          name: "Unpublish",
	          link: "http://"
	        }, {
	          name: "Delete",
	          link: "http://"
	        }];
	      } else {
	        menu = [];
	      }
	
	      this.actionMenu = menu;
	    }
	  }, {
	    key: "checkAdmin",
	    value: function checkAdmin() {
	      var res = null;
	
	      if (this.currentUser.username.indexOf("jobble.com") !== -1 || this.currentUser.username.indexOf("jobbleapp.com") !== -1) {
	        this.currentUser.isAdmin = true;
	        res = true;
	      } else {
	        this.currentUser.isAdmin = false;
	        res = false;
	      }
	
	      return res;
	    }
	  }, {
	    key: "setEventOpenings",
	    value: function setEventOpenings(event) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetEventToEventDialog", { event: event });
	      });
	    }
	  }, {
	    key: "closeJob",
	    value: function closeJob(job) {
	      this.$timeout(function () {
	        $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table tbody.real-jobs tr.real-jobs-row-anchor-" + job.index + "  td .nested-event-pool-data").slideUp(250);
	        job.index = null;
	        job.isShowingAllWeeks = false;
	      });
	    }
	  }, {
	    key: "findAndDisappearShowingModals",
	    value: function findAndDisappearShowingModals() {
	      var jobThatsShowing = this.jobs.find(function (obj) {
	        return obj.isShowingAllWeeks === true;
	      });
	
	      return jobThatsShowing;
	    }
	  }, {
	    key: "getPoolData",
	    value: function getPoolData(d) {
	      this.$companies.getEventPoolData(d).then(function (response) {
	        if (response) {}
	      }, function (error) {});
	    }
	  }, {
	    key: "showEventPoolData",
	    value: function showEventPoolData(job, i) {
	
	      var payload = {
	        eventPoolId: job.eventPoolId,
	        offset: 0,
	        direction: "asc",
	        max: 25,
	        sort: "startTime"
	      };
	
	      this.getPoolData(payload);
	
	      var showingJob = this.findAndDisappearShowingModals();
	
	      if (showingJob) {
	        this.closeJob(showingJob);
	        if (job.id === showingJob.id) {
	          return;
	        }
	      }
	
	      job.isShowingAllWeeks = true;
	      job.index = i;
	
	      this.$timeout(function () {
	        $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table tbody.real-jobs tr.real-jobs-row-anchor-" + i + "  td .nested-event-pool-data").slideDown(250);
	      });
	    }
	  }, {
	    key: "copyJobbleID",
	    value: function copyJobbleID(event) {
	      var _this4 = this;
	
	      var company = "Test Company Name";
	      var title = event.name;
	      var jobbleId = event.subEvents[0].deduppedJobbles[0].id;
	      var url = "";
	
	      this.$branchio.createLinks(jobbleId, title, company, url).then(function (links) {
	        _this4.$timeout(function () {
	          var text_to_share = links.email;
	          //var text_to_share = origin + "/job/" + event.subEvents[0].deduppedJobbles[0].id;
	          // create temp element
	          var copyElement = document.createElement("span");
	          copyElement.appendChild(document.createTextNode(text_to_share));
	          copyElement.id = "tempCopyToClipboard";
	          _angular2.default.element(document.body.append(copyElement));
	          // select the text
	          var range = document.createRange();
	          range.selectNode(copyElement);
	          window.getSelection().removeAllRanges();
	          window.getSelection().addRange(range);
	          // copy & cleanup
	          document.execCommand("copy");
	          window.getSelection().removeAllRanges();
	          copyElement.remove();
	        });
	      });
	    }
	  }, {
	    key: "copyEventID",
	    value: function copyEventID(event) {
	
	      var eventId = event.id;
	      var jobbleId = event.subEvents[0].deduppedJobbles[0].id;
	
	      var text_to_share = "Event ID: " + eventId + ", Jobble ID: " + jobbleId;
	      // create temp element
	      var copyElement = document.createElement("span");
	      copyElement.appendChild(document.createTextNode(text_to_share));
	      copyElement.id = "tempCopyToClipboard";
	      _angular2.default.element(document.body.append(copyElement));
	      // select the text
	      var range = document.createRange();
	      range.selectNode(copyElement);
	      window.getSelection().removeAllRanges();
	      window.getSelection().addRange(range);
	      // copy & cleanup
	      document.execCommand("copy");
	      window.getSelection().removeAllRanges();
	      copyElement.remove();
	    }
	  }, {
	    key: "checkJob",
	    value: function checkJob(job) {
	      if (job.isChecked === true) {
	        job.isChecked = false;
	      } else {
	        job.isChecked = true;
	      }
	
	      this.checkForAtleastOneCheckedJob();
	    }
	  }, {
	    key: "sortTable",
	    value: function sortTable(value, index) {
	      var _this = this;
	
	      if (_this.uiViews.is_company_verified === false) {
	        alert("Please wait for your company to be verified");
	        return;
	      }
	
	      _this.ui.allChecked = false;
	
	      if (value === "location" || value === "status") {
	        return;
	      }
	
	      _this.getJobs(value, null, null, index);
	    }
	  }, {
	    key: "updateJobStatus",
	    value: function updateJobStatus(job, status) {
	      var _this = this;
	    }
	  }, {
	    key: "updateJobsList",
	    value: function updateJobsList(data, list, status, hasError) {
	      var _this = this;
	
	      var errors = [];
	      var success = [];
	
	      if (status === "unpublished") {
	        if (hasError === true) {
	          data.events.forEach(function (event) {
	            if (event.status !== "OK") {
	              var error = {};
	              error.message = event.message;
	              error.eventId = event.id;
	              errors.push(error);
	            } else {
	              success.push(event);
	            }
	          });
	          _this.updateNumbersOfOtherLists(success, status);
	        } else {
	          _this.jobs.forEach(function (job, i) {
	            list.forEach(function (item, x) {
	              if (item.id === job.id) {
	                job.statusNew = "Draft";
	              }
	            });
	          });
	          _this.updateNumbersOfOtherLists(list, status);
	        }
	      } else if (status === "published") {
	        if (hasError === true) {
	          data.events.forEach(function (event) {
	            if (event.status !== "OK") {
	              var error = {};
	              error.message = event.message;
	              error.eventId = event.id;
	              errors.push(error);
	            } else {
	              success.push(event);
	            }
	          });
	
	          try {
	            if (errors.length > 0) {
	              errors.forEach(function (error) {
	                //console.log("each error");
	                //alert("Event ID " + error.eventId + " was not published.\nERROR: " + error.message);
	              });
	            }
	          } catch (err) {
	            console.log("error loopings errors array");
	          } finally {
	            if (success.length > 0) {
	              _this.updateNumbersOfOtherLists(success, status);
	            }
	          }
	        } else {
	          _this.jobs.forEach(function (job) {
	            list.forEach(function (item) {
	              if (item.id === job.id) {
	                job.statusNew = "Published";
	              }
	            });
	          });
	          _this.updateNumbersOfOtherLists(list, status);
	        }
	      } else if (status === "archived") {
	        if (hasError === "true") {
	          _this.jobs.forEach(function (job) {
	            list.forEach(function (item) {
	              if (item.id === job.id) {
	                job.statusNew = "Archived";
	                job.status = "Archived";
	              }
	            });
	          });
	          _this.updateNumbersOfOtherLists(list, status);
	        } else {
	          _this.updateNumbersOfOtherLists(list, status);
	        }
	      } else if (status === "restored") {
	        if (hasError === true) {
	          data.events.forEach(function (event) {
	            if (event.status !== "OK") {
	              var error = {};
	              error.message = event.message;
	              error.eventId = event.id;
	              errors.push(error);
	            } else {
	              success.push(event);
	            }
	          });
	
	          try {
	            if (errors.length > 0) {
	              errors.forEach(function (error) {
	                console.log("each error");
	                alert("Event ID " + error.eventId + " was not published.\nERROR: " + error.message);
	              });
	            }
	          } catch (err) {
	            console.log("error loopings errors array");
	          } finally {
	            if (success.length > 0) {
	              _this.updateNumbersOfOtherLists(success, status);
	            }
	          }
	        } else {
	          _this.updateNumbersOfOtherLists(list, status);
	        }
	      } else if (status === "complete") {
	        if (hasError === "true") {
	          _this.jobs.forEach(function (job) {
	            list.forEach(function (item) {
	              if (item.id === job.id) {
	                job.statusNew = "Complete";
	                job.status = "Complete";
	              }
	            });
	          });
	          _this.updateNumbersOfOtherLists(list, status);
	        } else {
	          _this.updateNumbersOfOtherLists(list, status);
	        }
	      }
	
	      this.getJobs();
	
	      if (errors.length > 1) {
	        _this.alertErrors(errors, data.events, success);
	      } else {
	        _this.findCheckedToUnCheck();
	      }
	    }
	  }, {
	    key: "alertErrors",
	    value: function alertErrors(errors, all, success) {
	      var _this = this;
	
	      alert("Looks like " + errors.length + " out of the " + all.length + " jobs had an error with this process. Please make sure the pay rate is high enough. The other jobs were published");
	
	      _this.uncheckJobsWithError(errors);
	    }
	  }, {
	    key: "uncheckJobsWithError",
	    value: function uncheckJobsWithError(errors) {
	      var _this = this;
	
	      try {
	        errors.forEach(function (error) {
	          _this.jobs.forEach(function (job) {
	            if (error.eventId === job.id) {
	              job.isChecked = false;
	            }
	          });
	        });
	      } finally {
	        _this.findCheckedToUnCheck();
	      }
	    }
	  }, {
	    key: "processJobsThatAreBeingClosed",
	    value: function processJobsThatAreBeingClosed(jobs) {
	      var _this = this;
	
	      var listOfBadJobs = [];
	
	      try {
	        jobs.forEach(function (oneJob) {
	          var endTimeMoment = moment(oneJob.job.endTime);
	
	          if (currentTime.isBefore(endTimeMoment)) {
	            listOfBadJobs.push(oneJob.job);
	          }
	        });
	      } catch (err) {} finally {
	        return listOfBadJobs;
	      }
	    }
	  }, {
	    key: "handleCompletionError",
	    value: function handleCompletionError(jobs) {
	      var jobIds = "";
	
	      try {
	        jobs.forEach(function (job) {
	          jobIds = jobIds + job.id + ", ";
	        });
	      } finally {
	        var jobIdsSubStr = jobIds.substring(0, jobIds.length - 2);
	
	        alert("You are attempting to complete " + jobs.length + " jobs that are " + "still currently live. Please remove them from the list before proceeding " + "with the completion process. \nThe job identification numbers to remove are: \n" + jobIdsSubStr);
	      }
	    }
	  }, {
	    key: "completeJobs",
	    value: function completeJobs() {
	      var _this = this;
	
	      if (_this.weHaveOneCheckedJob === false) {
	        return false;
	      }
	
	      var list = _this.findChecked();
	      var listOfFullJobs = _this.findCheckedFullJob();
	      var listOfBadJobs = _this.processJobsThatAreBeingClosed(listOfFullJobs);
	
	      if (listOfBadJobs.length > 0) {
	        _this.handleCompletionError(listOfBadJobs);
	        return;
	      }
	
	      _this.setLoader();
	
	      _this.$events.bulkCloseEvent(list).then(function (response) {
	        if (response.status === 200) {
	          _this.updateJobsList(response.data, list, "complete", false);
	        } else {
	          _this.updateJobsList(response.data, list, "complete", true);
	        }
	
	        _this.unSetLoader();
	      }, function (error) {
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "publishJobs",
	    value: function publishJobs() {
	      var _this = this;
	
	      if (_this.weHaveOneCheckedJob === false) {
	        return false;
	      }
	
	      _this.setLoader();
	
	      var list = _this.findChecked();
	
	      _this.$events.bulkPublish(list).then(function (response) {
	        if (response.data.message === "Events published without errors") {
	          _this.updateJobsList(response.data, list, "published", false);
	        } else if (response.data.message === "Events published with errors") {
	          _this.updateJobsList(response.data, list, "published", true);
	        }
	        _this.unSetLoader();
	      }, function (error) {
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "unpublishJobs",
	    value: function unpublishJobs() {
	      var _this = this;
	
	      if (_this.weHaveOneCheckedJob === false) {
	        return false;
	      }
	
	      var list = _this.findChecked();
	
	      _this.setLoader();
	
	      _this.$events.bulkUnpublish(list).then(function (response) {
	        if (response.data.message === "Events unpublished without errors") {
	          _this.updateJobsList(response.data, list, "unpublished", false);
	        } else if (response.data.message === "Events unpublished with errors") {
	          _this.updateJobsList(response.data, list, "unpublished", true);
	        }
	
	        _this.unSetLoader();
	      }, function (error) {
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "restoreJobs",
	    value: function restoreJobs() {
	      var _this = this;
	      if (_this.weHaveOneCheckedJob === false) {
	        return false;
	      }
	      var list = _this.findChecked();
	      _this.setLoader();
	      _this.$events.bulkRestore(list).then(function (response) {
	        if (response.data.message === "Events restored without errors") {
	          _this.updateJobsList(response.data, list, "restored", false);
	        }
	
	        _this.unSetLoader();
	      }, function (error) {
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "reopenJobs",
	    value: function reopenJobs() {
	      var _this = this;
	
	      if (_this.weHaveOneCheckedJob === false) {
	        return false;
	      }
	
	      var choice = confirm("Are you sure you want to complete this job?");
	
	      if (choice === true) {
	        var list = _this.findChecked();
	
	        _this.setLoader();
	        _this.$events.bulkReopen(list).then(function (response) {
	          if (response.data[0].status === "OK") {
	            _this.updateJobsList(response.data, list, "restored", false);
	          }
	
	          _this.unSetLoader();
	        }, function (error) {
	          _this.unSetLoader();
	        });
	      } else {
	        return;
	      }
	    }
	  }, {
	    key: "archiveJobs",
	    value: function archiveJobs() {
	      var _this = this;
	
	      if (_this.weHaveOneCheckedJob === false) {
	        return false;
	      }
	
	      var choice = confirm("Warning: Once the selected job(s) are " + "archived all applicants will be lost and the job will be cancelled.  " + "\nIf you would like to continue please press OK.");
	
	      if (choice === true) {
	        var list = _this.findChecked();
	
	        _this.setLoader();
	
	        _this.$events.bulkArchive(list).then(function (response) {
	          if (response.data.message === "Events archived without errors") {
	            _this.updateJobsList(response.data, list, "archived", false);
	          }
	
	          _this.unSetLoader();
	        }, function (error) {
	          _this.unSetLoader();
	        });
	      } else {
	        return;
	      }
	    }
	  }, {
	    key: "updateNumbersOfOtherLists",
	    value: function updateNumbersOfOtherLists(list, type) {
	      var _this = this;
	
	      if (type === "unpublished") {
	        _this.currentUser.company.totalNumberOfDraftEvents = _this.currentUser.company.totalNumberOfDraftEvents + list.length;
	        if (_this.requestParams.list === "published") {
	          _this.currentUser.company.totalNumberOfPublishedEvents = _this.currentUser.company.totalNumberOfPublishedEvents - list.length;
	        }
	      } else if (type === "published") {
	        _this.currentUser.company.totalNumberOfPublishedEvents = _this.currentUser.company.totalNumberOfPublishedEvents + list.length;
	        if (_this.requestParams.list === "draft") {
	          _this.currentUser.company.totalNumberOfDraftEvents = _this.currentUser.company.totalNumberOfDraftEvents - list.length;
	        }
	      } else if (type === "restored") {
	        //vm.currentUser.company.totalNumberOfEvents - vm.currentUser.company.totalNumberOfNonCloseEvents + vm.currentUser.company.totalNumberOfCloseEvents
	        _this.currentUser.company.totalNumberOfPublishedEvents = _this.currentUser.company.totalNumberOfPublishedEvents + list.length;
	        _this.currentUser.company.totalNumberOfEvents = _this.currentUser.company.totalNumberOfEvents - list.length;
	        //if (_this.requestParams.list === "archived") {
	        //_this.currentUser.company.totalNumberOfPublishedEvents = _this.currentUser.company.totalNumberOfPublishedEvents + list.length;
	        //}
	      } else if (type === "archived") {
	        _this.currentUser.company.totalNumberOfEvents = _this.currentUser.company.totalNumberOfEvents + list.length;
	        if (_this.requestParams.list === "published") {
	          _this.currentUser.company.totalNumberOfPublishedEvents = _this.currentUser.company.totalNumberOfPublishedEvents - list.length;
	        } else if (_this.requestParams.list === "draft") {
	          _this.currentUser.company.totalNumberOfDraftEvents = _this.currentUser.company.totalNumberOfDraftEvents - list.length;
	        } else if (_this.requestParams.list === "completed") {
	          _this.currentUser.company.totalNumberOfCloseEvents = _this.currentUser.company.totalNumberOfCloseEvents - list.length;
	        }
	      } else if (type === "complete") {
	        _this.currentUser.company.totalNumberOfCloseEvents = _this.currentUser.company.totalNumberOfCloseEvents + list.length;
	        if (_this.requestParams.list === "published") {
	          _this.currentUser.company.totalNumberOfPublishedEvents = _this.currentUser.company.totalNumberOfPublishedEvents - list.length;
	        }
	      }
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "findCheckedToUnCheck",
	    value: function findCheckedToUnCheck() {
	      var _this = this;
	
	      var list = [];
	
	      try {
	        _this.jobs.forEach(function (job, i) {
	          if (job.isChecked === true) {
	            list.push(i);
	          }
	        });
	      } finally {
	        for (var i = list.length - 1; i >= 0; i--) {
	          _this.jobs.splice(list[i], 1);
	        }
	
	        _this.ui.allChecked = false;
	      }
	    }
	  }, {
	    key: "findCheckedFullJob",
	    value: function findCheckedFullJob() {
	      var _this = this;
	
	      var list = [];
	
	      try {
	        _this.jobs.forEach(function (job) {
	          if (job.isChecked === true) {
	            list.push({ job: job });
	          }
	        });
	      } finally {
	        return list;
	      }
	    }
	  }, {
	    key: "findChecked",
	    value: function findChecked() {
	      var _this = this;
	
	      var list = [];
	
	      try {
	        _this.jobs.forEach(function (job) {
	          if (job.isChecked === true) {
	            list.push({ id: job.id });
	          }
	        });
	      } finally {
	        return list;
	      }
	    }
	  }, {
	    key: "clearSearch",
	    value: function clearSearch() {
	      this.jobQuery = null;
	      this.uiViews.is_search = false;
	      this.requestParams.multiSearch = null;
	      this.getJobs("published");
	    }
	  }, {
	    key: "jobSearchSubmit",
	    value: function jobSearchSubmit() {
	      var _this = this;
	
	      _this.uiViews.is_search = true;
	      _this.getJobs("search");
	    }
	  }, {
	    key: "jobSearchChange",
	    value: function jobSearchChange() {
	      var _this = this;
	    }
	  }, {
	    key: "getHeader",
	    value: function getHeader() {
	      return ["Job Title", "Location", "Status", "Start Date", "End Date", "Rate", "Openings", "Fill Score", "Confirms"];
	    }
	  }, {
	    key: "getHeaderRoster",
	    value: function getHeaderRoster() {
	      return ["Last Name", "First Name", "Number", "Email", "Post Title", "Job Type", "City", "State", "Zip", "Date Application Was Submitted"];
	    }
	  }, {
	    key: "getPayRate",
	    value: function getPayRate(job) {
	      job.payRate = (job.subEvents[0].deduppedJobbles[0].jobblerRate / 100).toFixed(2);
	
	      return job.payRate;
	    }
	  }, {
	    key: "prepJobsForCSV",
	    value: function prepJobsForCSV(jobs) {
	      var _this = this;
	
	      var csv = [];
	
	      _this.csv = [];
	
	      try {
	        jobs.forEach(function (job, i) {
	          var start = _this.getEventDate(job.startTime, job.contactInfo.timeZoneId, job);
	          var end = _this.getEventDate(job.endTime, job.contactInfo.timeZoneId, job);
	          var rate = _this.getPayRate(job);
	
	          var csvObj = {
	            job_title: job.name,
	            location: job.contactInfo.city,
	            status: job.statusNew,
	            start_date: start,
	            end_date: end,
	            rate: job.payRate,
	            openings: job.numberOfOpenings,
	            fill_score: job.shiftFillScore,
	            confirms: job.confirmedShifts
	          };
	
	          csv.push(csvObj);
	        });
	      } catch (err) {} finally {
	        _this.csv = csv;
	      }
	    }
	  }, {
	    key: "exit",
	    value: function exit(x) {
	      if (x === 2) {
	        this.$timeout(function () {
	          $("#verify-email-warning").modal("hide");
	        });
	      } else if (x === 1) {
	        this.$timeout(function () {
	          $("#confirm-roster-download").modal("hide");
	        });
	      } else if (x === 3) {
	        this.$timeout(function () {
	          $("#promote-job").modal("hide");
	        });
	      } else if (x === 4) {
	        this.$timeout(function () {
	          $("#job-overview-modal").modal("hide");
	          //$("#job-overview-modal").animate({width: 'toggle'}, 150);
	        });
	      } else if (x === 5) {
	        this.$timeout(function () {
	          $("#job-scheduled").modal("hide");
	          $(".modal-backdrop.fade.in").removeClass();
	        });
	      } else if (x === 6) {
	        this.$timeout(function () {
	          $("#job-extended").modal("toggle");
	        });
	      } else if (x === 7) {
	        this.$timeout(function () {
	          $("#job-extended-confirm").modal("toggle");
	        });
	      }
	    }
	  }, {
	    key: "loadRoster",
	    value: function loadRoster(job) {
	      var _this = this;
	
	      var csv = [];
	
	      var roster = [];
	
	      _this.setLoader();
	      _this.csvRoster = null;
	      _this.rosterDownloadIsDisable = true;
	
	      _this.$timeout(function () {
	        $("#confirm-roster-download").modal();
	      }, 300);
	      _this.$timeout(function () {
	        $("#confirm-roster-download").modal();
	      }, 300);
	
	      _this.$events.getAcceptedApplicationsTrimmedRoster(job.subEvents[0].deduppedJobbles[0].subEventId, 100, 0).then(function (acceptedApplications) {
	        var applications = acceptedApplications.data;
	
	        try {
	          try {
	            applications.forEach(function (application, i) {
	              var csvObj = {
	                last_name: application.applicant.lastName,
	                first_name: application.applicant.firstName,
	                number: application.applicant.homeContactInfo.phoneMobile,
	                email: application.applicant.email,
	                post_title: job.name,
	                job_type: "--",
	                city: job.contactInfo.city,
	                state: job.contactInfo.state,
	                zip: job.contactInfo.zipCode,
	                apply_date: job.dateCreated
	              };
	              csv.push(csvObj);
	
	              application.smallPic = application.applicant.filePROFILE_IMAGE1IMG_75x75;
	              application.mediumPic = application.applicant.filePROFILE_IMAGE1IMG_75x75;
	            });
	          } catch (err) {} finally {
	            csv.sort(function (a, b) {
	              if (a.last_name < b.last_name) return -1;
	              if (a.last_name > b.last_name) return 1;
	              return 0;
	            });
	          }
	        } finally {
	          _this.unSetLoader();
	          _this.csvRoster = csv;
	          _this.rosterDownloadIsDisable = false;
	        }
	      }, function (error) {
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "downloadRosterCSV",
	    value: function downloadRosterCSV() {
	      var _this = this;
	
	      if (_this.rosterDownloadIsDisable === true) {
	        alert("Please let the roster download before clicking.");
	        return;
	      }
	
	      _this.setLoader();
	
	      _this.$timeout(function () {
	        _this.exit(1);
	      }, 200);
	
	      _this.$timeout(function () {
	        _this.unSetLoader();
	      }, 500);
	    }
	  }, {
	    key: "fixPhone",
	    value: function fixPhone(application) {
	
	      if (application.applicant.homeContactInfo) {
	        if (application.applicant.homeContactInfo.phoneMobile) {
	          var num = application.applicant.homeContactInfo.phoneMobile;
	          if (num.charAt(0) === "1") {
	            num = num.slice(1, num.length);
	          }
	          var cleaned = ("" + num).replace(/\D/g, "");
	          var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
	          if (match) {
	            application.applicant.homeContactInfo.phoneMobile = "(" + match[1] + ") " + match[2] + "-" + match[3];
	          } else {
	            application.applicant.homeContactInfo.phoneMobile = num;
	          }
	        } else {
	          application.applicant.homeContactInfo = {};
	          application.applicant.homeContactInfo.phoneMobile = "--";
	        }
	      }
	    }
	  }, {
	    key: "paginateJobs",
	    value: function paginateJobs() {
	      this.pageNumber = this.pageNumber + 1;
	
	      if (this.checkForMoreJobs() === true) {
	        return;
	      }
	
	      this.requestParams.offset = this.jobs.length;
	
	      this.getJobs(this.requestParams.list, null, true);
	    }
	  }, {
	    key: "checkForMoreJobs",
	    value: function checkForMoreJobs() {
	      var _this = this;
	
	      var result = null;
	
	      if (_this.requestParams.list === "published") {
	        if (_this.jobs.length < _this.currentUser.company.totalNumberOfPublishedEvents) {
	          result = false;
	        } else {
	          result = true;
	        }
	      } else if (_this.requestParams.list === "archived") {
	        if (_this.jobs.length < _this.currentUser.company.totalNumberOfEvents - (_this.currentUser.company.totalNumberOfNonCloseEvents + _this.currentUser.company.totalNumberOfCloseEvents)) {
	          result = false;
	        } else {
	          result = true;
	        }
	      } else if (_this.requestParams.list === "draft") {
	        if (_this.jobs.length < _this.currentUser.company.totalNumberOfDraftEvents) {
	          result = false;
	        } else {
	          result = true;
	        }
	      } else if (_this.requestParams.list === "completed") {
	        if (_this.jobs.length < _this.currentUser.company.totalNumberOfCloseEvents) {
	          result = false;
	        } else {
	          result = true;
	        }
	      } else if (_this.requestParams.list === "search") {
	        result = false;
	      }
	
	      return result;
	    }
	  }, {
	    key: "checkVerificationStatus",
	    value: function checkVerificationStatus() {
	      var _this = this;
	
	      _this.setLoader();
	
	      _this.$auth.reloadCurrentUser();
	
	      _this.$timeout(function () {
	        _this.currentUser = _this.$auth.getUserData();
	        _this.unSetLoader();
	        $("#verify-email-warning").modal("hide");
	      }, 1500);
	
	      _this.$timeout(function () {
	        if (_this.currentUser.isVerified === false || _this.currentUser.isVerified === null) {
	          alert("Your email is still not verified. Please contact support.");
	        } else {
	          _this.uiViews.is_user_email_verified = true;
	        }
	      }, 1700);
	    }
	  }, {
	    key: "promoteJob",
	    value: function promoteJob(event) {
	      var _this = this;
	
	      _this.promote_job = event;
	      _this.$timeout(function () {
	        $("#promote-job").modal();
	      });
	    }
	  }, {
	    key: "closePromoteModal",
	    value: function closePromoteModal() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("#promote-job").modal("toggle");
	      });
	    }
	  }, {
	    key: "confirmPromote",
	    value: function confirmPromote() {
	      var _this = this;
	
	      _this.setLoader();
	
	      _this.$events.promote_event(_this.promote_job.jobblePoolId).then(function (response) {
	        _this.unSetLoader();
	
	        if (response.data.status === "OK") {
	          _this.exit(3);
	          _this.$timeout(function () {
	            alert("Your job was successfully promoted.");
	          }, 500);
	        } else {
	          _this.exit(3);
	          _this.$timeout(function () {
	            alert(response.data.message);
	          }, 500);
	        }
	      }, function (error) {
	        _this.unSetLoader();
	        _this.exit(3);
	        _this.$timeout(function () {
	          alert("There was an error promoting your job. Please contact customer support.");
	        }, 500);
	      });
	    }
	  }, {
	    key: "displayBulkActionItems",
	    value: function displayBulkActionItems(inOrOut) {
	      if (inOrOut === true) {
	        this.weHaveOneCheckedJob = inOrOut;
	      } else {
	        this.checkForAtleastOneCheckedJob();
	      }
	    }
	  }, {
	    key: "hidebulkActionItems",
	    value: function hidebulkActionItems() {
	      this.weHaveOneCheckedJob = false;
	    }
	  }, {
	    key: "setUrl",
	    value: function setUrl(index) {
	      if (index === 1) {} else if (index === 2) {} else if (index === 3) {} else if (index === 4) {}
	    }
	  }, {
	    key: "setOverviewModal",
	    value: function setOverviewModal(job) {
	
	      this.getJob(job);
	      this.overviewJob = null;
	
	      this.heightOfModal = this.$window.innerHeight - 73;
	
	      this.$timeout(function () {
	        $("#job-overview-modal").modal();
	        //$("#job-overview-modal").animate({width: 'toggle'}, 300);
	      }, 200);
	    }
	  }, {
	    key: "getJob",
	    value: function getJob(job) {
	      var _this = this;
	
	      _this.setLoader();
	
	      _this.$events.getEventByIdTrimmedv2(job.id).then(function (response) {
	        _this.setShifts(response.data);
	        _this.unSetLoader();
	      }, function (error) {
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "getRequirements",
	    value: function getRequirements(job) {
	      var _this = this;
	
	      _this.setLoader();
	
	      _this.$events.getEventByIdTrimmed(job.id).then(function (response) {
	        _this.setShifts(response.data);
	        _this.unSetLoader();
	      }, function (error) {
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "setShifts",
	    value: function setShifts(event) {
	      var _this = this;
	
	      _this.teamsPostedTo = [];
	
	      if (event.subEvents[0].deduppedJobbles[0].circles) {
	        if (Object.keys(event.subEvents[0].deduppedJobbles[0].circles).length !== 0) {
	          try {
	            if (event.subEvents[0].deduppedJobbles[0]) {
	              if (event.subEvents[0].deduppedJobbles[0].forCircleOnly === true) {
	                _this.isPrivate = true;
	              }
	            }
	          } finally {
	            if (event.subEvents[0].deduppedJobbles[0].circles.length > 0) {
	              event.subEvents[0].deduppedJobbles[0].circles.forEach(function (team) {
	                _this.teamsPostedTo.push(team);
	              });
	            }
	          }
	        }
	      }
	
	      var minutes = event.subEvents[0].deduppedJobbles[0].jobbleDuration * 60;
	      var minRounder = minutes % 60;
	
	      var hours = Math.floor(minutes / 60);
	      event.subEvents[0].deduppedJobbles[0].hours = hours;
	      event.subEvents[0].deduppedJobbles[0].minutes = minRounder;
	
	      var shifts = event.subEvents[0].deduppedJobbles[0].shifts;
	
	      var userTimeZoneName = moment.tz.guess();
	
	      var jobSiteInDST = void 0;
	      var browserUserDST = moment().tz(userTimeZoneName).isDST();
	
	      try {
	        for (var x = 0; x < shifts.length; x++) {
	
	          var jobSiteTimeZoneName = shifts[x].contactInfo.place.timeZoneId;
	          var start = new Date(moment(shifts[x].timeInterval.startTime).format(""));
	          var end = new Date(moment(shifts[x].timeInterval.endTime).format());
	
	          jobSiteInDST = moment(start).tz(jobSiteTimeZoneName).isDST();
	
	          var startMoment = moment.tz(start, "UTC");
	          var endMoment = moment.tz(end, "UTC");
	
	          var timeZone = shifts[x].contactInfo.place.timeZoneId;
	
	          var jobDST = moment().tz(timeZone).isDST();
	
	          //console.dir(moment((startMoment).tz(timeZone).isDST()));
	
	          shifts[x].startTimeFullFormat = startMoment.tz(timeZone).format();
	          shifts[x].endTimeFullFormat = endMoment.tz(timeZone).format();
	
	          shifts[x].startDateFormatted = startMoment.tz(timeZone).format("MMM DD, YYYY");
	          shifts[x].startTimeFormatted = startMoment.tz(timeZone).format("h:mmA");
	          shifts[x].endTimeFormatted = endMoment.tz(timeZone).format("h:mmA");
	          shifts[x].TZ = startMoment.tz(timeZone).zoneAbbr();
	        }
	      } finally {
	        this.sortShiftsByStartTime(event);
	      }
	    }
	  }, {
	    key: "sortShiftsByStartTime",
	    value: function sortShiftsByStartTime(event) {
	      var _this = this;
	      event.subEvents[0].deduppedJobbles[0].shifts.sort(function (a, b) {
	        return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
	      });
	      _this.overviewJob = event;
	      _this.getRequirements();
	      _this.setQuestions(event, event.id);
	      _this.setPayRate(event);
	    }
	  }, {
	    key: "setPayRate",
	    value: function setPayRate(job) {
	      var company = this.currentUser.company;
	      var payRateObj = {};
	
	      job.shifts = job.subEvents[0].deduppedJobbles[0].shifts;
	      payRateObj.payPerHour = job.subEvents[0].deduppedJobbles[0].payPerHour;
	      payRateObj.jobblerRate = job.subEvents[0].deduppedJobbles[0].jobblerRate;
	      payRateObj.openings = job.numberOfOpenings + job.numberOfApprovedApplications;
	
	      var rate = company.defaultPlan.jobblerFeePct;
	      var pay = parseFloat(payRateObj.payPerHour);
	      var epi = 0.00001;
	      var p = 100 - rate * 100;
	      var x = parseFloat(pay) * 100;
	      var z = x / p;
	      var cost = Math.round((z + epi) * 100) / 100;
	      var hours = null;
	
	      job.shifts.forEach(function (shift) {
	        if (!shift) return;
	
	        var startDate = new Date(shift.timeInterval.startTime);
	        var endDate = new Date(shift.timeInterval.endTime);
	
	        hours += (endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60;
	      });
	
	      payRateObj.platform_hourly_cost = cost;
	      payRateObj.platform_rate = Math.round(100 * (rate + epi) * 100) / 100;
	      payRateObj.platform_fee = Math.round((cost - pay) * 100) / 100;
	
	      payRateObj.estimated_cost = Math.round((cost + epi) * 100 * hours * parseFloat(payRateObj.openings)) / 100;
	
	      this.payRateObj = payRateObj;
	    }
	  }, {
	    key: "setQuestions",
	    value: function setQuestions(event, eventId) {
	      var _this = this;
	
	      var order = void 0;
	
	      _this.$jobs.getQuestions(eventId).then(function (response) {
	        var questions = response.data.surveyQuestions;
	
	        if (questions && questions.length > 0) {
	          questions.sort(function (a, b) {
	            var order = null;
	
	            if (a.displayOrder) {
	              order = a.displayOrder - b.displayOrder;
	            } else {
	              order = a.id - b.id;
	            }
	          });
	
	          event.surveyQuestions = questions;
	        } else {
	          event.surveyQuestions = [];
	        }
	      }, function (error) {
	        event.surveyQuestions = [];
	      });
	    }
	  }, {
	    key: "getRequirements",
	    value: function getRequirements() {
	      var _this = this;
	
	      var data = {};
	      data.eventId = _this.overviewJob.id;
	
	      _this.$jobs.getRequirements(data).then(function (response) {
	        _this.handleRequirements(response.data);
	      }, function (error) {});
	    }
	  }, {
	    key: "handleRequirements",
	    value: function handleRequirements(data) {
	      var _this = this;
	
	      var requirements = null;
	
	      if (data.length > 0) {
	        _this.showReqs = true;
	        requirements = data.sort(function (a, b) {
	          return a.position - b.position;
	        });
	
	        _this.requirements = requirements;
	        _this.reqsLoaded = true;
	      }
	    }
	  }, {
	    key: "getShiftLocation",
	    value: function getShiftLocation(shift) {
	      if (shift) {
	        if (this.$security.isUndefinedOrNull(shift.contactInfo)) {
	          return "";
	        }
	        var location = shift.contactInfo.streetLine1;
	        if (!this.$security.isUndefinedOrNull(shift.contactInfo.city)) {
	          location += " " + shift.contactInfo.city;
	        }
	        if (!this.$security.isUndefinedOrNull(shift.contactInfo.state)) {
	          location += ", " + shift.contactInfo.state;
	        }
	
	        if (!this.$security.isUndefinedOrNull(shift.contactInfo.zipCode)) {
	          location += " " + shift.contactInfo.zipCode;
	        }
	
	        return location;
	      }
	    }
	  }, {
	    key: "getDurationWithHoursAndMinutes",
	    value: function getDurationWithHoursAndMinutes(totalMinutes) {
	      var hours = Math.floor(totalMinutes / 60);
	      var minutes = totalMinutes % 60;
	      return hours + "h " + minutes + "min";
	    }
	  }, {
	    key: "getHoursAndMintuesFromStartToEnd",
	    value: function getHoursAndMintuesFromStartToEnd(startTime, endTime) {
	      var startMomentTime = moment(startTime);
	      var endMomentTime = moment(endTime);
	      var durationMinutes = endMomentTime.diff(startMomentTime, "minutes");
	
	      return this.getDurationWithHoursAndMinutes(durationMinutes);
	    }
	  }, {
	    key: "displayTimeZone",
	    value: function displayTimeZone(tz) {
	      if (tz === "Eastern Standard Time") {
	        return "EST";
	      }
	      if (tz === "Central Standard Time") {
	        return "CST";
	      }
	      if (tz === "Mountain Standard Time") {
	        return "MST";
	      }
	      if (tz === "Pacific Standard Time") {
	        return "PST";
	      }
	      if (tz === "Alaska Standard Time") {
	        return "AST";
	      }
	      if (tz === "Hawaii Standard Time") {
	        return "HST";
	      }
	    }
	  }, {
	    key: "goToRoster",
	    value: function goToRoster(id) {
	      var _this5 = this;
	
	      this.$timeout(function () {
	        _this5.$location.path("event/" + id + "/review");
	      }, 100);
	    }
	  }, {
	    key: "goToManageRoster",
	    value: function goToManageRoster() {
	      var _this6 = this;
	
	      this.exit(4);
	
	      this.$timeout(function () {
	        _this6.$location.path("event/" + _this6.overviewJob.id + "/review");
	      }, 300);
	    }
	  }, {
	    key: "displaySchedulingModal",
	    value: function displaySchedulingModal(event) {
	
	      var numberOfWeeks = parseFloat(event.numberOfWeeksToScheduleJob) + 1;
	
	      this.schedulingMsg = "You have scheduled this job to run for " + numberOfWeeks + " weeks.";
	
	      this.$timeout(function () {
	        $("#job-scheduled").modal();
	      }, 300);
	    }
	  }, {
	    key: "setUnverifiedWarning",
	    value: function setUnverifiedWarning(banks) {
	      this.unverifiedBankId = banks[0].id;
	      this.uiViews.company_has_unverified_bank = true;
	    }
	  }, {
	    key: "checkForVerifiedBankAccount",
	    value: function checkForVerifiedBankAccount(info) {
	      var _this7 = this;
	
	      var unverifiedBanks = [];
	      var verifiedBanks = [];
	      var cards = [];
	
	      try {
	        if (info.length > 0) {
	          info.forEach(function (x) {
	            if (x.bankName && x.validated === null) {
	              unverifiedBanks.push(x);
	            } else if (x.bankName && x.validated === true) {
	              verifiedBanks.push(x);
	            } else if (x.cardBrand) {
	              cards.push(x);
	            }
	          });
	        }
	      } catch (err) {
	        console.log("we have an error finding bank accounts");
	        console.dir(err);
	      } finally {
	        if (unverifiedBanks.length > 0) {
	          this.$timeout(function () {
	            _this7.$rootScope.$emit("UnverifiedBankWarning", unverifiedBanks);
	          }, 2000);
	        }
	      }
	    }
	  }, {
	    key: "isLongTerm",
	    value: function isLongTerm(job) {
	      var isLongTerm = job.isLongTerm;
	      var admin = this.currentUser.isAdmin;
	      if (isLongTerm === true) {
	        if (job.weeks === null) {
	          job.currentWeek = false;
	        } else {
	          job.currentWeek = job.totalWeeks - job.weeks;
	        }
	      }
	    }
	  }, {
	    key: "getLatestUserData",
	    value: function getLatestUserData() {
	      var _this8 = this;
	
	      this.$timeout(function () {
	        if (_this8.currentUser) {
	          _this8.$auth.refreshCurrentUserDashboard().then(function (result) {
	            _this8.currentUser.company.totalNumberOfCloseEvents = result.company.totalNumberOfCloseEvents;
	            _this8.currentUser.company.totalNumberOfDraftEvents = result.company.totalNumberOfDraftEvents;
	            _this8.currentUser.company.totalNumberOfEvents = result.company.totalNumberOfEvents;
	            _this8.currentUser.company.totalNumberOfNonCloseEvents = result.company.totalNumberOfNonCloseEvents;
	            _this8.currentUser.company.totalNumberOfPublishedEvents = result.company.totalNumberOfPublishedEvents;
	            if (!_this8.currentUser.company.companyLogoUri) {
	              _this8.$rootScope.$emit("GetLogo", _this8.currentUser);
	            }
	            if (_this8.currentUser.isAdmin) {
	              _this8.getApplicationErrors();
	            }
	          });
	        }
	      }, 300);
	    }
	  }, {
	    key: "getApplicationErrors",
	    value: function getApplicationErrors() {
	      var _this9 = this;
	
	      this.displayInAppNotification = false;
	      this.$companies.getApplicationErrors().then(function (response) {
	        if (response) {
	          if (response.data) {
	            if (response.data.length > 0) {
	              _this9.displayInAppNotification = true;
	              if (_this9.currentUser.isAdmin) {
	                _this9.alerts = _this9.$companies.createInAppNotifications(response.data);
	                _this9.showAlerts();
	              }
	            }
	          }
	        }
	      }, function (error) {
	        console.log("application errors - error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "closeNotification",
	    value: function closeNotification(index, alert) {
	      var indexPlus = index + 1;
	      this.$timeout(function () {
	        $(".in-app-notification:nth-child(" + indexPlus + ")").removeClass("show-alerts");
	        $(".in-app-notification:nth-child(" + indexPlus + ")").addClass("hide-alerts");
	      });
	
	      this.achknowledgeApplicationError(alert.rawAlert.id);
	    }
	  }, {
	    key: "viewNotification",
	    value: function viewNotification(index, alert) {
	      var indexPlus = index + 1;
	
	      this.$timeout(function () {
	        $(".in-app-notification:nth-child(" + indexPlus + ")").removeClass("show-alerts");
	        $(".in-app-notification:nth-child(" + indexPlus + ")").addClass("hide-alerts");
	      });
	
	      this.achknowledgeApplicationError(alert.rawAlert.id);
	      this.$state.go("eventreviewapplicants", { eventId: alert.eventId, userId: alert.rawAlert.applicantUser.id });
	    }
	  }, {
	    key: "achknowledgeApplicationError",
	    value: function achknowledgeApplicationError(id) {
	      this.$companies.achknowledgeApplicationError(id).then(function (response) {
	        if (response) {}
	      }, function (error) {
	        console.log("achknowledgeApplicationError - error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "showAlerts",
	    value: function showAlerts() {
	      this.$timeout(function () {
	        $(".in-app-notification").addClass("show-alerts");
	      }, 300);
	    }
	  }, {
	    key: "setJobPostingLoadingStatus",
	    value: function setJobPostingLoadingStatus() {
	      this.$timeout(function () {
	        //this.$rootScope.postingLoadingStatus = 0;
	      }, 300);
	    }
	  }, {
	    key: "triggerCloningModal",
	    value: function triggerCloningModal(job) {
	      this.$progress.start();
	      this.$rootScope.progress = this.$progress;
	    }
	  }, {
	    key: "determineDashboardType",
	    value: function determineDashboardType() {
	      return "OD";
	    }
	  }, {
	    key: "pullLatestUserData",
	    value: function pullLatestUserData(checkingForUserEmailVerification) {
	      var _this10 = this;
	
	      var companyVerificationData = {};
	      if (this.currentUser) {
	        var token = this.currentUser.access_token;
	        if (this.currentUser.company.isVerified !== true) {
	          this.setLoader();
	          this.$auth.validateCompanyByTokenWeb(token).then(function (response) {
	            var user = response.data;
	            companyVerificationData.logo = user.company.companyLogoUri;
	            companyVerificationData.isUserVerified = user.isVerified;
	            companyVerificationData.paymentInfo = user.company.undeletedPaymentInfos;
	            if (companyVerificationData.logo && companyVerificationData.isUserVerified && companyVerificationData.paymentInfo.length > 0) {
	              companyVerificationData.isVerified = true;
	            }
	            _this10.companyVerificationData = companyVerificationData;
	            if (checkingForUserEmailVerification) {
	              _this10.$timeout(function () {
	                $("#verify-email-warning").modal("hide");
	              });
	              _this10.$timeout(function () {
	                if (!companyVerificationData.isUserVerifed) {
	                  alert("We do not have your email as verified. Please give our system another minute and try again. " + "If the problem persists please contact support at sales@jobble.com.");
	                }
	              }, 200);
	            }
	            _this10.displayVerificationSteps = true;
	            _this10.unSetLoader();
	          }, function (error) {
	            this.unSetLoader();
	            this.displayVerificationSteps = true;
	          });
	        }
	      }
	    }
	  }]);
	
	  return JobsdashboardController;
	}();
	
	JobsdashboardController.$inject = ["$http", "$localStorage", "$state", "$q", "$window", "$stateParams", "$location", "common", "auth", "env", "companies", "jobs", "events", "$timeout", "security", "$rootScope", "$scope", "tracking", "ngProgressFactory", "$cookies", "social", "validation", "branchio"];
	
	exports.default = JobsdashboardController;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _eventlive = __webpack_require__(493);
	
	var _eventlive2 = _interopRequireDefault(_eventlive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventliveModule = _angular2.default.module("eventlive", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("eventlive", {
	    url: "/event/:eventId/live",
	    template: "<eventlive></eventlive>",
	    title: "Job Live"
	  });
	}).component("eventlive", _eventlive2.default);
	
	exports.default = eventliveModule;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventlive = __webpack_require__(494);
	
	var _eventlive2 = _interopRequireDefault(_eventlive);
	
	var _eventlive3 = __webpack_require__(495);
	
	var _eventlive4 = _interopRequireDefault(_eventlive3);
	
	__webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventliveComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _eventlive2.default,
	  controller: _eventlive4.default,
	  controllerAs: "vm"
	};
	
	exports.default = eventliveComponent;

/***/ }),
/* 494 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<!------------------- Banner-Status --------------------->\n<div class=\"jobs-complete-banner\"></div>\n<!------------------- Banner-Status --------------------->\n\n<div class=\"jobs-complete-container\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\">\n        <div class=\"back-to-jobs\">\n          <a href=\"/jobs-dashboard\">Back to Jobs</a>\n        </div>\n\n        <!--Sidebar-->\n        <eventsidebar></eventsidebar>\n        <!--Sidebar-->\n      </div>\n\n      <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\">\n        <div class=\"jobs-live-content\">\n          <div class=\"jobs-live-map\">\n            <div map-lazy-load=\"https://maps.google.com/maps/api/js\" ng-if=\"vm.mapHasLoaded\">\n              <ng-map id=\"mapId\" center=\"{{vm.centerLat}}, {{vm.centerLng}}\" zoom=\"{{vm.zoom}}\" style=\"height: 550px\"></ng-map>\n            </div>\n            <div class=\"jobs-live-nav\">\n              <a href=\"#\">\n                <!--<span class=\"jobs-live-color-green\"></span>-->\n                <img src=\"/app/vendor/images/icon-location.png\" style=\"margin-right: 12px; margin-top: 3px\" />\n                JOB LOCATION\n              </a>\n              <a href=\"#\">\n                <img src=\"/app/vendor/images/icon-location-jobbler.png\" style=\"margin-right: 12px; margin-top: 3px\" />\n                JOBBLER(S) LOCATION\n              </a>\n            </div>\n          </div>\n          <div class=\"jobs-live-bottom-content\">\n            <ul class=\"nav nav-pills jobs-live-tablist-nav\" role=\"tablist\">\n              <li role=\"presentation\">\n                ALL\n                <span class=\"badge jobs-live-badge\">{{ vm.applications.length }}</span>\n              </li>\n              <li role=\"presentation\">\n                CHECKED IN\n                <span class=\"badge jobs-live-badge\">{{ vm.checkedInArray.length }}</span>\n              </li>\n              <li role=\"presentation\">\n                CHECKED OUT\n                <span class=\"badge jobs-live-badge\">{{ vm.checkedOutArray.length }}</span>\n              </li>\n            </ul>\n            <div class=\"progress jobs-live-progress\">\n              <div\n                class=\"progress-bar jobs-live-progress-bar\"\n                role=\"progressbar\"\n                aria-valuenow=\"10\"\n                aria-valuemin=\"0\"\n                aria-valuemax=\"100\"\n                style=\"width: 10%\"\n              >\n                <span class=\"sr-only\">40% Complete (success)</span>\n              </div>\n            </div>\n            <div class=\"jobs-live-members row\">\n              <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-repeat=\"application in vm.applications track by $index\">\n                <div class=\"jobs-live-member-box\">\n                  <div class=\"media\">\n                    <div class=\"media-left jobs-live-media-pad\">\n                      <a href=\"#\">\n                        <img class=\"media-object img-circle\" src=\"{{ application.applicant.filePROFILE_IMAGE1IMG_75x75 }}\" alt=\"\" />\n                      </a>\n                    </div>\n                    <div class=\"media-body jobs-live-member-top\">\n                      <h4 class=\"media-heading\">{{ application.applicant.firstName }} {{ application.applicant.lastName }}</h4>\n\n                      <div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\">\n                        <p class=\"timechecks-title\">\n                          <a class=\"jobs-live-checked-in\" href=\"#\">Checked in</a>\n                        </p>\n                        <p ng-if=\"application.locationInfo.checkInTime && !application.locationInfo.checkInAddress\">\n                          Address not captured @ {{ application.locationInfo.checkInTime | date : 'hh:mm a' }}\n                        </p>\n                        <p ng-if=\"application.locationInfo.checkInTime && application.locationInfo.checkInAddress\">\n                          {{ application.locationInfo.checkInAddress }} @ {{ application.locationInfo.checkInTime | date : 'hh:mm a' }}\n                        </p>\n                        <p style=\"text-align: center\" ng-if=\"!application.locationInfo.checkInTime && !application.locationInfo.checkInAddress\">\n                          &#x2014;\n                        </p>\n                      </div>\n                      <div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\">\n                        <p class=\"timechecks-title\">\n                          <a class=\"jobs-live-checked-in\" href=\"#\">Checked out</a>\n                        </p>\n                        <p ng-if=\"application.locationInfo.checkOutTime && !application.locationInfo.checkOutAddress\">\n                          Address not captured @ {{ application.locationInfo.checkOutTime | date : 'hh:mm a'}}\n                        </p>\n                        <p ng-if=\"application.locationInfo.checkOutTime && application.locationInfo.checkOutAddress\">\n                          {{ application.locationInfo.checkOutAddress }} @ {{ application.locationInfo.checkOutTime | date : 'hh:mm a' }}\n                        </p>\n                        <p style=\"text-align: center\" ng-if=\"!application.locationInfo.checkOutTime && !application.locationInfo.checkOutAddress\">\n                          &#x2014;\n                        </p>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<jobblefooter></jobblefooter>\n<eventdialog></eventdialog>\n<globalalert></globalalert>\n\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	__webpack_require__(496);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventliveController = function () {
	  function EventliveController($http, $localStorage, $state, AuthService, EventsService, SecurityService, $stateParams, $timeout, NgMap, $rootScope, $scope) {
	    _classCallCheck(this, EventliveController);
	
	    this.name = "eventlive";
	    $localStorage.activeStateName = "events";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$events = EventsService;
	    this.$security = SecurityService;
	    this.$stateParams = $stateParams;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.remain_loading_count = 0;
	    this.acceptedApplicants = [];
	    this.pagesAccepted = [];
	    this.checkedInArray = [];
	    this.checkedOutArray = [];
	    this.queryLimitCounter = 0;
	    this.zoom = 7;
	    this.applications = [];
	    this.liveObj = {};
	    this.$maps = NgMap;
	    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
	    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;
	    this.mapHasLoaded = false;
	    var _this = this;
	
	    _this.remain_loading_count++;
	
	    _this.$timeout(function () {
	      _this.mapHasLoaded = true;
	    }, 3000);
	
	    _this.$timeout(function () {
	      _this.$rootScope.$emit("SetLoaderDialog", { type: 3, total: 2 });
	    });
	
	    _this.remain_loading_count++;
	
	    this.$events.getEventByIdTrimmedLive(this.$stateParams.eventId).then(function (data) {
	      var response = data.data;
	
	      _this.event = response;
	
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetEventToEventSidebar", {
	          event: _this.event
	        });
	        _this.$rootScope.$emit("SetLoaderDialog", {
	          type: 9,
	          total: 2
	        });
	      });
	
	      console.log(_this.event);
	      if (_this.event.status === "error") {
	        _this.remain_loading_count--;
	        return;
	      }
	
	      _this.$rootScope.$emit("SetEventToEventDialog", {
	        event: _this.event
	      });
	      _this.currentSubEvent = response.subEvents[0];
	
	      var pageArrayAccepted = [];
	      var numberOfApprovedApplications = Math.ceil(response.numberOfApprovedApplications / 5);
	
	      for (var i = 0; i < numberOfApprovedApplications; i++) {
	        pageArrayAccepted.push(i + 1);
	        _this.pagesAccepted = pageArrayAccepted;
	      }
	
	      var city = response.contactInfo.city;
	      var street = response.contactInfo.streetLine1;
	      var state = response.contactInfo.state;
	      var zipCode = response.contactInfo.zipCode;
	      var address = street + ", " + city + ", " + state;
	      var startTimeMomentJsObj = moment(response.startTime).format();
	      var endTimeMomentJsObj = moment(response.endTime).format();
	
	      _this.event = response;
	
	      if (response.subEvents[0].deduppedJobbles[0].shifts) {
	        _this.liveObj = _this.$security.isThisEventLive(response.subEvents[0].deduppedJobbles[0].shifts);
	      } else {
	        _this.liveObj.eventIsLive = false;
	      }
	
	      console.log("_this.liveObj");
	      console.dir(_this.liveObj);
	
	      if (_this.liveObj.eventIsLive === true) {
	        _this.eventIsLive = true;
	        _this.displayLiveLoader = false;
	      } else {
	        _this.eventIsLive = false;
	      }
	
	      _this.$timeout(function () {
	        var geocoder = new google.maps.Geocoder();
	        geocoder.geocode({ address: address }, function (results, status) {
	          console.log("geocoder");
	          console.dir(results);
	          console.dir(status);
	          if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
	            var location = results[0].geometry.location;
	            _this.centerLat = location.lat();
	            _this.centerLng = location.lng();
	            var myLatLngEv = {
	              lat: location.lat(),
	              lng: location.lng()
	            };
	            var image = "/app/vendor/images/icon-location.png";
	            var marker = new google.maps.Marker({
	              title: _this.event.name,
	              icon: image,
	              position: myLatLngEv
	            });
	            _this.setCenterOfMap(marker);
	            _this.getApplicantsOnMap(0);
	          } else {
	            _this.remain_loading_count--;
	          }
	        });
	      }, 2000);
	    }, function (data) {
	      console.log(data);
	      _this.remain_loading_count--;
	      $state.go("events");
	    });
	
	    _this.SetEventToEventPagesListener = _this.$rootScope.$on("SetEventToEventPages", function ($event, params) {
	      if (_this.event.id === params.event.id) {
	        _this.event.cost = params.event.cost;
	        _this.event.numberOfOpenings = params.event.numberOfOpenings;
	        _this.event.totalNumberOfJobbles = params.event.totalNumberOfJobbles;
	      }
	    });
	
	    _this.SuccessToDeleteEventListener = _this.$rootScope.$on("SuccessToDeleteEvent", function () {
	      _this.$state.go("jobsdashboard");
	    });
	
	    _this.$scope.$on("$destroy", _this.SuccessToDeleteEventListener);
	    _this.$scope.$on("$destroy", _this.SetEventToEventPagesListener);
	
	    $timeout(function () {
	      $("eventsidebar .jobs-complete-sidebar li:nth-child(6)").removeClass().addClass("active");
	    }, 2000);
	  }
	
	  _createClass(EventliveController, [{
	    key: "setCenterOfMap",
	    value: function setCenterOfMap(marker) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        _this.$maps.getMap({ id: "mapId" }).then(function (map) {
	          //console.log('success find map-------------------------------------------');
	          //console.dir(map);
	          _this.map = map;
	          _this.zoom = 12;
	          _this.remain_loading_count = 0;
	          marker.setMap(_this.map);
	        }, function (data) {
	          _this.remain_loading_count = 0;
	          //console.log('error');
	          //console.dir(data);
	        });
	      }, 1000);
	    }
	  }, {
	    key: "getApplicantsOnMap",
	    value: function getApplicantsOnMap(offset) {
	      var _this = this;
	      this.applications = [];
	      var applicationsReadyForLocationLoop = [];
	      if (offset !== 0) {
	        offset = offset * 5 - 5;
	      }
	      var _this = this;
	      console.log("getApplicantsOnMap");
	      this.$events.getAcceptedApplicationsTrimmedLive(this.event.subEvents[0].id, _this.event.totalNumberOfApplications).then(function (applications) {
	        var numberOfApps = applications.data.length;
	        var apps = applications.data;
	        _this.totalApplicationsCount = apps.length;
	        if (_this.liveObj.eventIsLive === true) {
	          if (apps.length !== 0) {
	            try {
	              apps.forEach(function (application, index) {
	                var checkInAndOutObj = _this.$security.isThisEventLive(application.jobble.shifts);
	                application.locationInfo = checkInAndOutObj;
	                applicationsReadyForLocationLoop.push(application);
	                if (application.locationInfo.checkInLat) {
	                  _this.setJobblersToTheMap(application);
	                }
	              });
	            } finally {
	              _this.geocoderPerApp = new google.maps.Geocoder();
	              _this.getCheckInLocationData(applicationsReadyForLocationLoop);
	            }
	          } else {
	            _this.applications = apps;
	          }
	        } else {}
	      }, function (data) {
	        _this.remain_loading_count--;
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "setJobblersToTheMap",
	    value: function setJobblersToTheMap(application) {
	      var _this = this;
	
	      console.log("setJobblersToTheMap");
	      console.dir(application);
	
	      var jobblerName = application.applicant.firstName + " " + application.applicant.lastName;
	      var image = "/app/vendor/images/icon-location-jobbler.png";
	      var myLatLng = {
	        lat: application.locationInfo.checkInLat,
	        lng: application.locationInfo.checkInLng
	      };
	
	      var marker = new google.maps.Marker({
	        title: jobblerName,
	        icon: image,
	        position: myLatLng
	      });
	      marker.setMap(_this.map);
	    }
	  }, {
	    key: "getCheckInLocationData",
	    value: function getCheckInLocationData(applications) {
	      var _this = this;
	
	      applications.forEach(function (application, i) {
	        if (application.locationInfo.checkInLat !== null) {
	          (function (application) {
	            _this.$timeout(function () {
	              _this.checkedInArray.push(application);
	
	              var myLatLng = {
	                lat: application.locationInfo.checkInLat,
	                lng: application.locationInfo.checkInLng
	              };
	
	              _this.geocoderPerApp.geocode({ latLng: myLatLng }, function (results, status) {
	                if (status === google.maps.GeocoderStatus.OK) {
	                  if (results[1]) {
	                    application.locationInfo.checkInAddress = results[0].formatted_address;
	                  } else {
	                    application.locationInfo.checkInAddress = "Address not captured";
	                  }
	                } else {
	                  application.locationInfo.checkInAddress = "Address not captured";
	                }
	              });
	            }, i * 1000);
	          })(application);
	        }
	      });
	
	      /*
	      _this.$timeout(function(){
	      _this.applications = applications;
	      })
	      */
	
	      this.$timeout(function () {
	        _this.getCheckOutLocationData(applications);
	      }, 2000);
	    }
	  }, {
	    key: "getCheckOutLocationData",
	    value: function getCheckOutLocationData(applications) {
	      var _this = this;
	
	      applications.forEach(function (application, i) {
	        if (application.locationInfo.checkOutTime !== null) {
	          _this.checkedOutArray.push(application);
	
	          _this.$timeout(function () {
	            var geocoderPerAppCheckout = new google.maps.Geocoder();
	            var myLatLngCheckout = {
	              lat: application.locationInfo.checkOutLat,
	              lng: application.locationInfo.checkOutLng
	            };
	
	            console.log("check it here********************************************");
	            console.dir(myLatLngCheckout);
	
	            if (myLatLngCheckout.lat !== null && myLatLngCheckout.lng !== null) {
	              geocoderPerAppCheckout.geocode({ latLng: myLatLngCheckout }, function (results, status) {
	                console.log("------------------");
	                console.log("------------------");
	                console.log("------------------");
	
	                console.dir(application);
	                console.dir(results);
	                console.dir(status);
	
	                if (status === google.maps.GeocoderStatus.OK) {
	                  if (results[1]) {
	                    application.locationInfo.checkOutAddress = results[0].formatted_address;
	                  } else {
	                    application.locationInfo.checkOutAddress = "Address not recognized by google";
	                  }
	                } else {
	                  application.locationInfo.checkOutAddress = "Address not recognized by google";
	                }
	              });
	            } else {
	              console.log("check out it null");
	            }
	          }, i * 2000);
	        }
	      });
	
	      this.$timeout(function () {
	        _this.applications = applications;
	
	        console.log("HOW MUCH LONGER TIL THIS GETS LOADED?");
	      }, 1000);
	
	      this.$timeout(function () {
	        _this.applications = applications;
	      }, 5000);
	    }
	  }]);
	
	  return EventliveController;
	}();
	
	EventliveController.$inject = ["$http", "$localStorage", "$state", "auth", "events", "security", "$stateParams", "$timeout", "NgMap", "$rootScope", "$scope"];
	
	exports.default = EventliveController;

/***/ }),
/* 496 */,
/* 497 */,
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(499);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventlive.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventlive.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "eventlive #wrapper{min-height:calc(100% - 62px)}", ""]);
	
	// exports


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _eventcomplete = __webpack_require__(501);
	
	var _eventcomplete2 = _interopRequireDefault(_eventcomplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventcompleteModule = _angular2.default.module("eventcomplete", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("eventcomplete", {
	    url: "/event/:eventId/complete",
	    template: "<eventcomplete></eventcomplete>"
	  });
	}).component("eventcomplete", _eventcomplete2.default);
	
	exports.default = eventcompleteModule;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventcomplete = __webpack_require__(502);
	
	var _eventcomplete2 = _interopRequireDefault(_eventcomplete);
	
	var _eventcomplete3 = __webpack_require__(503);
	
	var _eventcomplete4 = _interopRequireDefault(_eventcomplete3);
	
	__webpack_require__(504);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventcompleteComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _eventcomplete2.default,
	  controller: _eventcomplete4.default,
	  controllerAs: "vm"
	};
	
	exports.default = eventcompleteComponent;

/***/ }),
/* 502 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n<!------------------- Banner-Status --------------------->\n\t<div class=\"jobs-complete-banner\"></div>\n<!------------------- Banner-Status --------------------->\n\n<!--------------------- Container --------------------->\n    <div class=\"jobs-complete-container\">\n        <div class=\"container\">\n            <div class=\"row\">\n                <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12 side-bar-complete\">\n                    <div class=\"back-to-jobs\">\n                        <a href=\"/jobs-dashboard\">Back to Jobs</a>\n                    </div>\n                    <!--Sidebar-->\n                   <eventsidebar></eventsidebar>\n                   <eventdialog></eventdialog>\n                    <!--Sidebar-->\n                </div>\n                \n                <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12 main-page-complete\">\n                    <div class=\"jobs-complete-content-wrap\">\n                        <div class=\"jobs-complete-content\">\n                        \t<div class=\"overview-image-large\">\n\t                   \t\t\t<img \n\t                   \t\t\t\tsrc=\"{{ vm.event.subEvents[0].deduppedJobbles[0].jobbleType.picture1 ? vm.event.subEvents[0].deduppedJobbles[0].jobbleType.picture1 : '/app/vendor/images/default-jobble-image.jpeg' }}\" \n\t                   \t\t\t\talt=\"Jobble Biz\" \n\t                   \t\t\t\ttitle=\"Jobble Biz\"\n\t                   \t\t\t/>\n\t                   \t\t\t<div class=\"jobs-overview-top-all\">\n\t\t\t\t\t\t\t\t\t<h1>{{vm.event.name}}</h1>\n\t                            </div>\n\t                   \t\t</div>\n\t                   \t\t\n                            <div class=\"jobble-tip spacing-for-jobble-tip\">\n                                <h5>Jobble Tip</h5>\n                                <p>Ratings and reviews are only visable to employers. Your feedback is helpful in building a high quality, reliable workforce. Please add written reviews by clicking <i class=\"fa fa-pencil-square-o\" title=\"Write a review\"></i> icon at the end of each Jobblers' row.</p>\n\t\t\t\t\t\t\t\t<p ng-hide=\"vm.delivery\">Need to edit a Jobblers shift? Click on the <i class=\"fa fa-clock-o\" title=\"Edit shift hours\"></i> icon to see their check in/check out times, make edits, or mark them as a no-show.</p>\n                            </div>\n                            \n                            <div class=\"table-responsive table-responsive-payments\">\n                            \t<div \n\t                          \t\tclass=\"overview-review-table-box clearfix\" \n\t                          \t\tng-if=\"vm.loading_jobblers\" \n\t                          \t\tstyle=\"text-align:center;\">\n\t                               \t<i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i>\n\t                          \t</div>\n                            \t<i \n                            \t\tclass=\"fa fa-plus-square expand-full-screen\" \n                            \t\tng-hide=\"vm.loading_jobblers || vm.table_expanded\"\n                            \t\ttitle=\"Expand Payment Table\"\n                            \t\tng-click=\"vm.expandPaymentTable()\">\n                            \t</i>\n                            \t<i \n                            \t\tclass=\"fa fa-minus-square expand-full-screen\" \n                            \t\tng-hide=\"vm.loading_jobblers || !vm.table_expanded\"\n                            \t\ttitle=\"Expand Payment Table\"\n                            \t\tng-click=\"vm.expandPaymentTable()\">\n                            \t</i>\n                                <h5>Payment Overview</h5>\n                                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding-left: 0px;padding-bottom: 15px;border-bottom: 1px solid #eee;\">\n                                \t<!-- ng-if=\"vm.bulkCheck || vm.applicationsForBulkUpdate.length > 0\" -->\n\t                                <ul class=\"icon-action-holders\">\n\t                                \t<li ng-click=\"vm.triggerBulkModal()\" ng-class=\"{ 'disabled' : vm.applicationsForBulkUpdate.length === 0 }\">\n\t                                \t\tRating\n\t                                \t</li>\n\t                                \t<li ng-click=\"vm.triggerBulkReview()\" ng-class=\"{ 'disabled' : vm.applicationsForBulkUpdate.length === 0 }\">\n\t                                \t\tReview\n\t                                \t</li>\n\t                                \t<li ng-click=\"vm.triggerBulkPay()\" ng-class=\"{ 'disabled' : vm.applicationsForBulkUpdate.length === 0 }\">\n\t                                \t\tPayout\n\t                                \t</li>\t                                \t\n\t                                </ul>\n                                </div>\n                                \n                                \n                                <table class=\"table table-striped\">\n                                \t<thead>\n                                \t\t<tr>\n                                \t\t\t<th style=\"width:55px;\"></th>\n                                \t\t\t<th>\n                                \t\t\t\t<input \n                                \t\t\t\t\ttype=\"checkbox\" \n                                \t\t\t\t\tng-checked=\"vm.bulkCheck\" \n                                \t\t\t\t\tng-click=\"vm.bulkSelector()\" \n                                \t\t\t\t\tTitle=\"Select all\" \n                                \t\t\t\t/>\n                                \t\t\t</th>\n                                \t\t\t<th></th>\n                                \t\t\t<th>Name</th>\n                                \t\t\t<th>\n                                \t\t\t\t<span ng-hide=\"vm.delivery\">Hrs.</span>\n                                \t\t\t</th>\n                                \t\t\t<th>\n                                \t\t\t\t<span ng-hide=\"vm.delivery\">Mins.</span>\n                                \t\t\t</th>\n                                \t\t\t<th>\n                                \t\t\t\t<span ng-hide=\"vm.delivery\">$/HR</span>\n                                \t\t\t</th>\n                                \t\t\t<th>\n                                \t\t\t\t<span ng-hide=\"vm.delivery\">Payouts</span>\n                                \t\t\t\t<span ng-show=\"vm.delivery\">Payment</span>\n                                \t\t\t</th>\n                                \t\t\t<th>Rating</th>                                \t\t\t\n                                \t\t\t<th>Paid</th>\n                                \t\t\t<th></th>\n                                \t\t\t<th></th>\n                                \t\t\t<th></th>\n                                \t\t\t<th></th>\n                                \t\t</tr>\n                                \t</thead>\n                                \t<tbody ng-repeat=\"jobbler in vm.jobblers track by $index\">\n                                \t\n                                \t\t<tr class=\"main-screen-data\" ng-class=\"{ 'no-show-jobbler' : jobbler.jobble.noShow == true, 'has-been-paid' : jobbler.paymentToshiftHasBeenMade, 'selected-for-bulk' : jobbler.isCheckedForAction, 'has-no-info' : jobbler.showPayInfoWarning }\">\n                                \t\t\n                                \t\t\t<td scope=\"row\" style=\"font-size:11px;\">\n                                \t\t\t\t\n                                \t\t\t\t<i \n                                \t\t\t\t\tclass=\"fa fa-exclamation-triangle\" \n                                \t\t\t\t\ttitle=\"User has not entered payment information\" \n                                \t\t\t\t\tng-if=\"jobbler.showPayInfoWarning\">\n                                \t\t\t\t</i>\n                                \t\t\t\t\n                                \t\t\t\t<i \n                                \t\t\t\t\tclass=\"fa fa-copy\"\n                                \t\t\t\t\tng-class=\"{ 'dupe-icon' : jobbler.showPayInfoWarning }\" \n                                \t\t\t\t\ttitle=\"Multiple users in same jobble\" \n                                \t\t\t\t\tng-if=\"jobbler.has_dupe && jobbler.showPayInfoWarning\">\n                                \t\t\t\t</i>\n                                \t\t\t\t\n                                \t\t\t\t<i \n                                \t\t\t\t\tclass=\"fa fa-copy dupe-icon-padding\"\n                                \t\t\t\t\ttitle=\"Multiple users in same jobble\" \n                                \t\t\t\t\tng-if=\"jobbler.has_dupe && !jobbler.showPayInfoWarning\">\n                                \t\t\t\t</i>\n                                \t\t\t\t\n                                \t\t\t\t<!--\n                                \t\t\t\t<i \n                                \t\t\t\t\tclass=\"fa fa-map-marker dupe-icon-padding-location-left\"\n                                \t\t\t\t\ttitle=\"Location Data Available\" \n                                \t\t\t\t\tng-if=\"!jobbler.has_dupe && !jobbler.showPayInfoWarning && !jobbler.hasLocationData\">\n                                \t\t\t\t</i>\n                                \t\t\t\t-->\n                                \t\t\t\t\n                                \t\t\t\t<i \n                                \t\t\t\t\tclass=\"fa fa-map-marker dupe-icon-padding-location\"\n                                \t\t\t\t\ttitle=\"Location Data Available\" \n                                \t\t\t\t\tng-if=\"!jobbler.has_dupe && jobbler.hasLocationData\">\n                                \t\t\t\t</i>\n                                \t\t\t\t\n                                \t\t\t\t<i \n                                \t\t\t\t\tclass=\"fa fa-sticky-note dupe-icon-padding-note\"\n                                \t\t\t\t\ttitle=\"Notes Available\"\n                                \t\t\t\t\tng-if=\"!jobbler.has_dupe && jobbler.hasNote\">\n                                \t\t\t\t</i>\n                                \t\t\t\t\n                                \t\t\t\t\n                                \t\t\t</td>\n                                \t\t\t\n                                \t\t\t<td>\n                                \t\t\t\t<input \n                                \t\t\t\t\ttype=\"checkbox\" \n                                \t\t\t\t\tng-checked=\"jobbler.isCheckedForAction\" \n                                \t\t\t\t\tng-hide=\"jobbler.jobble.noShow || jobbler.paymentToshiftHasBeenMade\" \n                                \t\t\t\t\tng-click=\"vm.checkForAction(jobbler)\"\n                                \t\t\t\t/>\n                                \t\t\t</td>\n                                \t\t\t\n                                \t\t\t<td>\n                                \t\t\t\t<img \n                                \t\t\t\t\tng-src=\"{{jobbler.smallPic ? jobbler.smallPic : '/app/vendor/images/defaultimg.jpeg'}}\" \n                                \t\t\t\t\talt=\"\" \n                                \t\t\t\t\tstyle=\"width:20px;border-radius:50%;\"\n                                \t\t\t\t/>\n                                \t\t\t</td>\n                                \t\t\t\n                                \t\t\t<td title=\"{{jobbler.applicant.email}}\">\n                                \t\t\t\t{{jobbler.applicant.lastName}}, {{jobbler.applicant.firstName}}\n                                \t\t\t</td>\n                                \t\t\t\n                                \t\t\t<td>\n                                \t\t\t\t<div class=\"warning-for-payments\" ng-if=\"jobbler.paymentToshiftHasBeenMade\">\n                                \t\t\t\t\t<a href=\"#\" ng-click=\"vm.markJobbleAsReadyForAdditionalPayments(jobbler)\">Make another payment</a>\n                                \t\t\t\t</div>\n                                \t\t\t\t\n                                \t\t\t\t<span \n                                \t\t\t\t\tng-if=\"!jobbler.isEditingHours && !vm.delivery\" \n                                \t\t\t\t\tng-click=\"vm.editAJobblersHours(jobbler)\" \n                                \t\t\t\t\ttitle=\"Edit total hours\">\n                                \t\t\t\t\t{{ jobbler.jobbleDurationData.hours }}\n                                \t\t\t\t\t<span>\n                                \t\t\t\t\t\t<i class=\"fa fa-pencil\"></i>\n                                \t\t\t\t\t</span>\n                                \t\t\t\t</span>\n                                \t\t\t\t\n                                \t\t\t\t<span class=\"editing-rating-of-jobbler\" ng-if=\"jobbler.isEditingHours\">\n                                \t\t\t\t\t<input \n                                \t\t\t\t\t\ttype=\"number\" min=\"0\" step=\"1\"  \n                                \t\t\t\t\t\tng-enter=\"vm.enterHoursUpdated(jobbler)\" \n                                \t\t\t\t\t\tng-blur=\"vm.blurHoursUpdated(jobbler)\" \n                                \t\t\t\t\t\tng-model=\"jobbler.jobbleDurationData.hours\"\n                                \t\t\t\t\t\tonkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"\n                                \t\t\t\t\t\ttitle=\"Whole Numbers Only\"\n                                \t\t\t\t\t/>\n                                \t\t\t\t</span>\n                                \t\t\t\n                                \t\t\t</td>\n                                \t\t\t<td>\n                                \t\t\t\n                                \t\t\t\t<span \n                                \t\t\t\t\tng-if=\"!jobbler.isEditingMin && !vm.delivery\" \n                                \t\t\t\t\tng-click=\"vm.editAJobblersMinutes(jobbler)\" \n                                \t\t\t\t\ttitle=\"Edit total minutes\">\n                                \t\t\t\t\t{{ jobbler.jobbleDurationData.minutes }}\n                                \t\t\t\t\t<span>\n                                \t\t\t\t\t\t<i class=\"fa fa-pencil\"></i>\n                                \t\t\t\t\t</span>\n                                \t\t\t\t</span>\n                                \t\t\t\t\n                                \t\t\t\t<span class=\"editing-rating-of-jobbler\" ng-if=\"jobbler.isEditingMin\">\n                                \t\t\t\t\t<input \n                                \t\t\t\t\t\ttype=\"number\" \n                                \t\t\t\t\t\tmin=\"0\"\n                                \t\t\t\t\t\tmax=\"59\"\n                                \t\t\t\t\t\tstep=\"15\"\n                                \t\t\t\t\t\tng-enter=\"vm.enterMinsUpdated(jobbler)\" \n                                \t\t\t\t\t\tng-blur=\"vm.blurMinsUpdated(jobbler)\" \n                                \t\t\t\t\t\tng-model=\"jobbler.jobbleDurationData.minutes\"\n                                \t\t\t\t\t\tonkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"\n                                \t\t\t\t\t\ttitle=\"Whole Numbers Only\"\n                                \t\t\t\t\t/>\n                                \t\t\t\t</span>\n                                \t\t\t\n                                \t\t\t</td>\n                                \t\t\t\n                                \t\t\t<td>\n                                \t\t\t\t<span ng-hide=\"vm.delivery\">\n                                \t\t\t\t\t${{ (jobbler.jobble.payPerHour / 100) | number : 2 }}\n                                \t\t\t\t</span>\n                                \t\t\t</td>\n                                \t\t\t\n                                \t\t\t<td>\n                                \t\t\t\t\n                                \t\t\t\t<span ng-if=\"!jobbler.isEditingPay\" ng-click=\"vm.editJobblerPay(jobbler)\" ng-show=\"vm.delivery\">\n                                \t\t\t\t\t${{ jobbler.jobble.payPerHour / 100 | number : 2 }}\n                                \t\t\t\t</span>\n                                \t\t\t\t\n                                \t\t\t\t<span class=\"editing-rating-of-jobbler\" ng-if=\"jobbler.isEditingPay\" ng-show=\"vm.delivery\">\n                                \t\t\t\t\t<input \n                                \t\t\t\t\t\ttype=\"text\" \n                                \t\t\t\t\t\tng-enter=\"vm.enterPayUpdated(jobbler)\" \n                                \t\t\t\t\t\tng-blur=\"vm.blurPayUpdated(jobbler)\" \n                                \t\t\t\t\t\tsmart-float\n                                \t\t\t\t\t\tng-model=\"jobbler.jobble.totalCalculated\" />\n                                \t\t\t\t</span>\n                                \t\t\t\t\n                                \t\t\t\t<span ng-if=\"!jobbler.isEditingPay\" ng-click=\"vm.editJobblerPay(jobbler)\" ng-hide=\"vm.delivery\">\n                                \t\t\t\t\t${{ jobbler.jobble.totalCalculated | number : 2 }}\n                                \t\t\t\t\t<span>\n                                \t\t\t\t\t\t<i class=\"fa fa-pencil\"></i>\n                                \t\t\t\t\t</span>\n                                \t\t\t\t</span>\n                                \t\t\t\t\n                                \t\t\t\t<span class=\"editing-rating-of-jobbler\" ng-if=\"jobbler.isEditingPay\" ng-hide=\"vm.delivery\">\n                                \t\t\t\t\t<input \n                                \t\t\t\t\t\ttype=\"text\" \n                                \t\t\t\t\t\tng-enter=\"vm.enterPayUpdated(jobbler)\" \n                                \t\t\t\t\t\tng-blur=\"vm.blurPayUpdated(jobbler)\" \n                                \t\t\t\t\t\tsmart-float \n                                \t\t\t\t\t\tng-model=\"jobbler.jobble.totalCalculated\" />\n                                \t\t\t\t</span>\n                                \t\t\t\n                                \t\t\t<td>\n\n                                \t\t\t\t<span ng-if=\"!jobbler.isEditingRating\" ng-click=\"vm.editAJobblersRatings(jobbler)\">\n                                \t\t\t\t\t{{ jobbler.ratingValue }}\n                                \t\t\t\t\t<span>\n                                \t\t\t\t\t\t<i class=\"fa fa-pencil\"></i>\n                                \t\t\t\t\t</span>\n                                \t\t\t\t</span>\n                                \t\t\t\t\n                                \t\t\t\t<span class=\"editing-rating-of-jobbler\" ng-if=\"jobbler.isEditingRating\">\n                                \t\t\t\t\t<select \n                                \t\t\t\t\t\tng-model=\"vm.optionsRating.value\" \n                                \t\t\t\t\t\tng-options=\"or for or in vm.optionsRating.values\" \n                                \t\t\t\t\t\tng-change=\"vm.changeRatingEdit(jobbler)\" \n                                \t\t\t\t\t\tng-blur=\"vm.blurRatingEdit(jobbler)\">\n                                \t\t\t\t\t</select>\n                                \t\t\t\t</span>\n                                \t\t\t\t\n                                \t\t\t</td>\n                                \t\n                                \t\n                                \t\t\t<td style=\"text-align:center;\">\n                                \t\t\t\n                                \t\t\t\t<a href=\"#\" ng-if=\"jobbler.paymentTotalTransactions > 0\" ng-click=\"vm.slidePayments(jobbler, $index)\">\n                                \t\t\t\t\t<span ng-if=\"jobbler.paymentTotalTransactions > 0\">\n                                \t\t\t\t\t\n                                \t\t\t\t\t\t({{ jobbler.paymentTotalTransactions }}) Payments\n                                \t\t\t\t\t\t \n                                \t\t\t\t\t\t<i class=\"fa fa-sort-down\" ng-if=\"jobbler.show\"></i>\n                                \t\t\t\t\t\t<i class=\"fa fa-sort-up\" ng-if=\"!jobbler.show\"></i>\n                                \t\t\t\t\t\t\n                                \t\t\t\t\t</span>\n                                \t\t\t\t</a>\n                                \t\t\t\t\n                                \t\t\t\t<span ng-if=\"jobbler.paymentTotalTransactions == 0\" style=\"color:#000;\">\n                                \t\t\t\t\t0\n                                \t\t\t\t</span>\n                                \t\t\t\t\n                                \t\t\t</td>\n                                \t\n                                \t\t\t<td>\n                                \t\t\t\t<i class=\"fa fa-pencil-square-o\" title=\"Write a review\" ng-click=\"vm.displayApplicantInfo(jobbler, 1)\" ng-if=\"!jobbler.ratingReview\"></i>\n                                \t\t\t\t<i class=\"fa fa-check\" title=\"Edit review\" ng-click=\"vm.displayApplicantInfo(jobbler, 1)\" ng-if=\"jobbler.ratingReview\"></i>\n                                \t\t\t</td>\n                                \t\t\t\n                                \t\t\t<td>\n                                \t\t\t\t<i data-target=\"#modal-edit-shifts\" data-toggle=\"modal\"  class=\"fa fa-clock-o\" title=\"Edit shift hours\" ng-click=\"vm.displayApplicantInfo(jobbler, 2, $index)\"></i>\n                                \t\t\t</td>\n                                \t\t\t\n                                \t\t\t<td>\n                                \t\t\t\t<i class=\"fa fa-times-circle\" title=\"Mark as no show for all shifts\" ng-click=\"vm.confirmJobblerNoShow(jobbler)\" ng-if=\"!jobbler.jobble.noShow\"></i>\n                                \t\t\t\t<i class=\"fa fa-undo\" title=\"Cancel no show\" ng-click=\"vm.confirmJobblerNoShowCancel(jobbler)\" ng-if=\"jobbler.jobble.noShow\"></i>\n                                \t\t\t</td>\n                                \t\t\t\n                                \t\t\t<td>\n                                \t\t\t\t<i class=\"fa fa-plus-square\" title=\"\" ng-click=\"vm.addUserToTeamModal(jobbler)\" ng-show=\"vm.teams_for_modal.length>0\"></i>\n                                \t\t\t</td>\n                                \t\t\t\n                                \t\t</tr>\n                                \t\t<tr id=\"slide-toggle-for-complete-{{$index+1}}\" class=\"hide-row-that-has-pay-info\">\n                                \t\t\t<td colspan=\"13\" style=\"padding-left: 0px;padding-right: 0px;\">\n                                \t\t\t<table class=\"table table-striped\">\n                                \t\t\t\t<thead>\n                                \t\t\t\t\t\n                                \t\t\t\t\t<tr>\n                                \t\t\t\t\t\t<th>Scheduled start time</th>\n                                \t\t\t\t\t\t<th>Secheduled end time</th>\n                                \t\t\t\t\t\t<th># Payments issued</th>\n                                \t\t\t\t\t\t<th>Total amount</th>\n                                \t\t\t\t\t</tr>\n                                \t\t\t\t\t\n                                \t\t\t\t</thead>\n                                \t\t\t\t<tbody>\n                                \t\t\t\t\n                                \t\t\t\t\t<tr ng-repeat=\"shift in jobbler.jobble.shifts\">\n                                \t\t\t\t\t\t<td>\n                                \t\t\t\t\t\t\t{{ shift.timeInterval.startTime | date : \"short\" }} \n                                \t\t\t\t\t\t</td>\n                                \t\t\t\t\t\t<td>\n                                \t\t\t\t\t\t\t{{ shift.timeInterval.endTime | date : \"short\" }}\n                                \t\t\t\t\t\t</td>\n                                \t\t\t\t\t\t<td>\n                                \t\t\t\t\t\t\t{{ shift.paymentStats.number }}\n                                \t\t\t\t\t\t</td>\n                                \t\t\t\t\t\t<td>\n                                \t\t\t\t\t\t\t${{ shift.paymentStats.amount / 100 | number : 2 }}\n                                \t\t\t\t\t\t</td>\n                                \t\t\t\t\t</tr>\n                                \t\t\t\t\n                                \t\t\t\t</tbody>\n                                \t\t\t\t\n                                \t\t\t</table>\n                                \t\t\t</td>\n                                \t\t\t\n                                \t\t</tr>\n                                \t</tbody>\n                                </table>\n                                \n                              \t<div class=\"total-jobblers-details\" ng-hide=\"vm.event.isCompleted || vm.delivery\">\n                                    <span style=\"font-size:17px;\">TOTALS <strong>{{vm.totalHoursWorkedForEvent()}} HOURS {{vm.totalMinutesWorkedForEvent()}} MINUTES WORKED</strong></span>\n                                    <span style=\"font-size:17px;\">YOU PAY <strong>{{vm.totalAmountToBePaidOut()}}</strong></span>\n                                </div>\n                                \n                                <div class=\"row\" ng-if=\"vm.currentUser.isAdmin\">\n                                \t<div class=\"col-lg-12 col-md-21 col-sm-12 col-xs-12\">\n                                \t\t<a href=\"#\" class=\"refresh-button\" ng-click=\"vm.refreshList()\">Refresh List</a>\n                                \t</div>\n                                </div>\n                                \n                                <div class=\"row\" ng-if=\"vm.currentUser.isAdmin && vm.event.isCompleted\">\n                                \t<div class=\"col-lg-12 col-md-21 col-sm-12 col-xs-12\">\n                                \t\t<a href=\"#\" class=\"refresh-button\" ng-click=\"vm.openJob()\">Open Job</a>\n                                \t</div>\n                                </div>\n                                \n                            </div>\n                        </div>\n                        \n                        \n                        <div \n                        \tclass=\"payment-mode-wrap\" \n                        \tng-if=\"vm.showPayment\" \n                        \tid=\"credit-card-selection\" \n                        \tng-hide=\"vm.paymentMethodsFormatted.length==0 || vm.currentUser.company.payByInvoice == true\">\n                       \n\t                        <div class=\"job-container\">\n\t                        \n\t\t\t\t\t\t\t\t<div \n\t\t\t\t\t\t\t\t\tclass=\"job-table table-responsive respons-job\" \n\t\t\t\t\t\t\t\t\tng-hide=\"vm.currentUser.company.payByInvoice\">\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<div class=\"alert-box alert\" ng-if=\"vm.noCardSelectedError\">\n\t\t\t\t\t\t\t\t\t\tPlease select a payment type before submitting payment.\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\n\t\t\t                \t\t<h5>Select payment method</h5>\n\t\t\t                \t\t\n\t\t\t                    \t<table class=\"table\">\n\t\t\t                    \t\n\t\t\t                        \t<thead>\n\t\t\t                            \t<tr>\n\t\t\t                            \t\t<th></th>\n\t\t\t                            \t\t<th>Name</th>\n\t\t\t                            \t\t<th>Account</th>\n\t\t\t                            \t\t<th>Expiration</th>\n\t\t\t                            \t\t<th>Nickname</th>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t\t<tr \n\t\t\t\t\t\t\t\t\t\t\t\tng-repeat=\"paymentMethod in vm.paymentMethodsFormatted\" \n\t\t\t\t\t\t\t\t\t\t\t\tng-class=\"{ 'payment-method-selected' : paymentMethod.isChecked }\">\n\t\t\t\t\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<input \n\t\t\t\t\t\t\t\t\t\t\t\t\t\ttype=\"checkbox\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-checked=\"paymentMethod.isChecked\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"vm.selectPaymentMethod(paymentMethod)\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t<td>{{ paymentMethod.displayName }}</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td>{{ paymentMethod.displayLast4 }}</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td>{{ paymentMethod.displayExpires }}</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td>{{ paymentMethod.displayNickName }}</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<div class=\"row\" style=\"text-align:center;\">\n\t\t\t\t\t\t\t\t<a \n\t\t\t\t\t\t\t\t\tclass=\"btn btn-success button\" \n\t\t\t\t\t\t\t\t\tstyle=\"width: 239px;\" \n\t\t\t\t\t\t\t\t\tng-click=\"vm.submitPaymentModal(1)\">\n\t\t\t\t\t\t\t\t\t\tPayout and Close Job\t\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n                        </div>\n                        \n                        <div \n                        \tclass=\"payment-mode-wrap\"\n                        \tid=\"credit-card-selection\"\n                        \tng-show=\"vm.currentUser.company.payByInvoice == true\">\n                        \t<div class=\"row\" style=\"text-align:center;\">\n\t\t\t\t\t\t\t\t<a \n\t\t\t\t\t\t\t\t\tclass=\"btn btn-success button\" \n\t\t\t\t\t\t\t\t\tstyle=\"width: 239px;\" \n\t\t\t\t\t\t\t\t\tng-click=\"vm.submitPaymentModal(1)\">\n\t\t\t\t\t\t\t\t\t\tPayout and Close Job\t\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n                        </div>\n                        \n                        <div \n                        \tclass=\"payment-mode-wrap\" \n                        \tng-if=\"vm.showPayment\" \n                        \tid=\"credit-card-selection\" \n                        \tng-show=\"vm.paymentMethodsFormatted.length==0 && vm.currentUser.company.payByInvoice !== true\">\n\t\t                        <div class=\"job-container\">\n\t\t                       \t\t<div class=\"job-table table-responsive respons-job\">\n\t\t                       \t\t\t<h5>Add a payment method</h5>\n\t\t                       \t\t\t<p>\n\t\t                       \t\t\t\t<a \n\t\t                       \t\t\t\t\thref=\"#\" \n\t\t                       \t\t\t\t\tng-click=\"vm.displayCreditCardModal()\">\n\t\t                       \t\t\t\t\tAdd Credit Card\n\t\t                       \t\t\t\t</a>\n\t\t                       \t\t\t</p>\n                       \t\t\t\t</div>\n                       \t\t\t</div>\n                       \t</div>\n                       \t\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n<!--------------------- Container --------------------->\n\n<jobblefooter></jobblefooter>\n\n<div class=\"modal fade\" id=\"modal-bulk-rating\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content popup-content\">\n                \n                    <div class=\"modal-header popup-header text-center\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button>\n                        <h3 class=\"modal-title\">Bulk Rate and Review</h3>\n                    </div>\n                    \n                    <div class=\"modal-body popup-body\">\n                    \t<div class=\"row\">\n\t\t\t\t\t\t\t<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"margin-bottom:30px;text-align:center;\">\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<form>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>How many stars would you like to give all the jobblers?</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<select \n\t\t\t\t\t\t\t\t\t\tng-model=\"vm.optionsRatingModal.value\" \n\t\t\t\t\t\t\t\t\t\tng-options=\"or for or in vm.optionsRatingModal.values\"\n\t\t\t\t\t\t\t\t\t\tng-change=\"vm.changeRatingEditBulk()\" \n\t\t\t\t\t\t\t\t\t\tstyle=\"width: 44px;padding-left: 8px;\">\n\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<a href=\"#\" ng-click=\"vm.submitRatingsBulkUpdate()\" class=\"btn button btn-success\" ng-class=\"{ 'disabled' : vm.loadingRatings }\">\n\t\t\t\t\t\t\t\t\t\tUpdate \n\n\t\t\t\t\t\t\t\t\t\t<span ng-if=\"vm.loadingRatings\">\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i>\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<!--\n\t                    \t<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    \t\t\t\n                    \t\t\t<form ng-submit=\"vm.submitRatingsBulkUpdate\">\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>What written review would you like to give all the jobblers?</p>\n\t\t\t\t\t\t\t\t\t<textarea rows=\"6\" ng-model=\"vm.textForModal\" style=\"width:100%;\"></textarea>\n\t\t\t\t\t\t\t\t\t<input type=\"submit\" value=\"Update\" class=\"btn button btn-default\"  />\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</form>\t\t\n\t\t\t\t\t\t\t\t\n\t                    \t</div>\n\t                    \t-->\n\t                    \t\n\t                    </div>\n                    </div>\n                    \n                    <div class=\"modal-footer popup-body\">\n                    \t<!--\n                    \t<a class=\"btn button btn-default\" data-dismiss=\"modal\">Close</a>\n                    \t\n                    \t-->\n                    </div>\n                    \n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n<!-- \n<footer class=\"footer-section\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"copyright text-center\">&copy; 2017 Jobble. All Rights Reserved</div>\n            </div>\n        </div>\n    </div>\n</footer>\n-->\n    <div class=\"modal fade\" id=\"modal-del-job\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n        <div class=\"vertical-alignment-helper\">\n            <div class=\"modal-dialog vertical-align-center\">\n                <div class=\"modal-dialog popup\">\n                    <div class=\"modal-content popup-content\">\n                        <div class=\"modal-header popup-header text-center\">\n                            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button>\n                            <h3 class=\"modal-title\">Are you sure you want to <br> cancel this job?</h3>\n                        </div>\n                        <div class=\"modal-body popup-body text-center\">\n                        \t<a href=\"jobs-overview.html\" class=\"btn btn-success button\">Keep Job</a>\n                            <a href=\"jobs-overview.html\" class=\"btn btn-danger button\">Delete Job</a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n    <div class=\"modal fade\" id=\"modal-add-opening\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n        <div class=\"vertical-alignment-helper\">\n            <div class=\"modal-dialog vertical-align-center\">\n                <div class=\"modal-dialog popup\">\n                    <div class=\"modal-content popup-content\">\n                        <div class=\"modal-header popup-header text-center\">\n                            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button>\n                            <h3 class=\"modal-title\">Office Admin for large retail chain</h3>\n                            <p>This job currently has <span>0</span> openings left</p>\n                        </div>\n                        <div class=\"modal-body popup-body text-center\">\n                        \t<form action=\"jobs-overview.html\"> \n                            <div class=\"select-opening\">\n                            \t<span>I would like to</span>\n                                <div class=\"select-box\">\n                                    <select class=\"form-control form-input\">\n                                        <option>Add</option>\n                                        <option>Remove</option>\n                                    </select>\n                                </div>\n                                <div class=\"select-box\">\n                                    <select class=\"form-control form-input\">\n                                        <option>1</option>\n                                        <option>2</option>\n                                        <option>3</option>\n                                        <option>4</option>\n                                        <option>5</option>\n                                        <option>6</option>\n                                    </select>\n                                </div>\n                                <span>Opening</span>\n                            </div>\n                        \t<input type=\"submit\" class=\"btn btn-success button\" value=\"Make Change\">\n                            </form>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    \n    \n    \n    \n\n    <!--Edit Shifts -->    \n<div class=\"modal fade\" id=\"modal-edit-shifts\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content popup-content\">\n                    <div class=\"modal-header popup-header text-center\">\n                        \n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                        \t<i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n                        </button>\n                        \n                    </div>\n                    \n                    <div class=\"modal-body popup-body\">\n                    \t<div class=\"row\">\n                    \t\t<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    \t\t\t<div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                    \t\t\t</div>\n                    \t\t\t<div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                    \t\t\t\t<div class=\"jobblers-rating-box-rt\" style=\"float:right;\">\n\t\t\t\t\t\t\t\t\t\t<a href=\"\" class=\"no-show-btn\" ng-if=\"!vm.infoForDisplay.jobble.noShow\" ng-click=\"vm.markJobblerAsNoShowForJob()\">Mark as a no show</a>\t\t\t\n\t\t\t\t\t\t\t\t\t\t<a href=\"\" class=\"no-show-btn\" ng-if=\"vm.infoForDisplay.jobble.noShow\" ng-click=\"vm.markJobblerAsNoShowForJobCancel()\">Cancel No show</a>\n\t\t                            </div>\n                    \t\t\t</div>\n                    \t\t</div>\n                    \t</div>\n                    \t\n                    \t\n                    \t<div class=\"row\">\n                    \t\t<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    \t\t\t<div class=\"profile-image-name-holder\">\n                    \t\t\t\t<img src=\"{{ vm.infoForDisplay.largePic }}\" alt=\"\" style=\"float:none;\">\n                    \t\t\t\t<h4>{{ vm.infoForDisplay.applicant.firstName }} {{ vm.infoForDisplay.applicant.lastName }}</h4>\n                    \t\t\t</div>\n                    \t\t</div>\n                    \t</div>\n                    \t\n                    \t<div class=\"row\">\n                    \t\t<div class=\"total-jobblers-details\" ng-hide=\"vm.delivery\">\n                    \t\t\n\t\t\t\t\t\t\t\t<span>TOTAL HOURS OUTSTANDING <strong> {{ vm.infoForDisplay.outstandingTotalsData.hours }} HOURS {{ vm.infoForDisplay.outstandingTotalsData.minutes }} MINUTES</strong></span>\n                                \n                                <span>OUTSTANDING PAYMENTS <strong>$ {{ vm.infoForDisplay.outstandingTotalsData.monies | number : 2 }}</strong></span>\n                                \n                                <span ng-if=\"vm.infoForDisplay.paymentTotalTransactions > 0\">\n                                \t<a href=\"#\" ng-click=\"vm.showHiddenTable()\" class=\"payments-link-modal\">\n                                \t\t({{ vm.infoForDisplay.paymentTotalTransactions }}) PAYMENTS \n                                \t\t<i class=\"fa fa-sort-up\" ng-if=\"!vm.showingPayments\"></i>\n                                \t\t<i class=\"fa fa-sort-down\" ng-if=\"vm.showingPayments\"></i>\n                                \t</a>\n                                </span>\n                            </div>\n                    \t</div>\n                    \t\n                    </div>\n                    \n                    <div class=\"modal-body popup-body shifts-details\">\n                    \t\n                    \t<h3 class=\"shift-title hidden-table\">Previous Payments</h3>\n                    \t\n                    \t<table width=\"100%\" style=\"margin-bottom:20px;\" class=\"hidden-table\">\n                        \t<thead>\n                            \t<tr>\n                            \t\t<th>DATE</th>\n                            \t\t<th>\n                            \t\t\t<span ng-hide=\"vm.delivery\">\n                            \t\t\t\tSTART TIME\n                            \t\t\t</span>\n                            \t\t\t\n                            \t\t\t<span ng-show=\"vm.delivery\">\n                            \t\t\t\tARRIVE\n                            \t\t\t</span>\n                            \t\t</th>\n                            \t\t<th>\n                            \t\t\t<span ng-hide=\"vm.delivery\">\n                            \t\t\t\tEND TIME\n                            \t\t\t</span>\n                            \t\t\t<span ng-show=\"vm.delivery\">\n                            \t\t\t\tDEPART\n                            \t\t\t</span>\n                            \t\t</th>\n                            \t\t<th># OF PAYMENTS</th>\n                            \t\t<th style=\"text-align:left;\">AMOUNT PAID</th>\n                            \t</tr>\n                            </thead>\n                            <tbody>\n                            \t<tr ng-repeat=\"shiftWithPay in vm.shiftsWithPayments track by $index\">\n                            \t\t<td>{{ shiftWithPay.timeInterval.startDateFormattedTZ }}</td>\n                            \t\t<td>{{ shiftWithPay.timeInterval.startTimeFormattedTZ }}</td>\n                            \t\t<td>{{ shiftWithPay.timeInterval.endTimeFormattedTZ }}</td>\n                            \t\t<td>{{ shiftWithPay.paymentStats.number }}</td>\n                            \t\t<td>${{ shiftWithPay.paymentStats.amount / 100 | number : 2 }}</td>\n                            \t</tr>\n                            </tbody>\n                        </table>\n                    \t\n                    \t<h3 class=\"shift-title\" ng-hide=\"vm.delivery\">Shifts</h3>\n                    \t<h3 class=\"shift-title\" ng-show=\"vm.delivery\">Locations</h3>\n                    \t\n                    \t<div class=\"row\" ng-if=\"vm.infoForDisplay.displayTimeEditingWardning\">\n                    \t\t<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n\t                    \t\t<div class=\"alert-box alert\">\n\t                    \t\t\tThe total hours for this job were edited and may not reflect the hours listed for each individual shift.\n\t                    \t\t</div>\n                    \t\t</div>\n                    \t</div>\n                    \t\n                    \t<table width=\"100%\">\n                        \t<thead>\n                            \t<tr>\n                            \t\t<th>DATE</th>\n                            \t\t<th>\n                            \t\t\t<span ng-hide=\"vm.delivery\">\n                            \t\t\t\tSTART TIME\n                            \t\t\t</span>\n                            \t\t\t\n                            \t\t\t<span ng-show=\"vm.delivery\">\n                            \t\t\t\tARRIVE\n                            \t\t\t</span>\n                            \t\t</th>\n                            \t\t<th>\n                            \t\t\t<span ng-hide=\"vm.delivery\">\n                            \t\t\t\tEND TIME\n                            \t\t\t</span>\n                            \t\t\t<span ng-show=\"vm.delivery\">\n                            \t\t\t\tDEPART\n                            \t\t\t</span>\n                            \t\t</th>\n                            \t\t<th>\n                            \t\t\t<span ng-hide=\"vm.delivery\">\n                            \t\t\t\tHOURS\n                            \t\t\t</span>\n                            \t\t</th>\n                            \t\t<th>\n                            \t\t\t<span ng-hide=\"vm.delivery\">\n                            \t\t\t\tMINUTES\n                            \t\t\t</span>\n                            \t\t</th>\n                            \t\t<th>\n                            \t\t\t<span ng-hide=\"vm.delivery\">\n                            \t\t\t\tAMOUNT\n                            \t\t\t</span>\n                            \t\t</th>\n                            \t\t<th></th>\n                            \t\t<th>CHECK IN</th>\n                            \t\t<th>OUT</th>\n                            \t\t<th>\n                            \t\t\t<span ng-hide=\"vm.delivery\">\n                            \t\t\t\tSHIFT PAY\n                            \t\t\t</span>\n                            \t\t\t<span ng-show=\"vm.delivery\">\n                            \t\t\t\t\n                            \t\t\t</span>\n                            \t\t</th>\n                            \t\t<th>NO SHOW</th>\n                                </tr>\n                            </thead>\n                            \n                            <tbody>\n                            \n                            \t<tr\n                            \t \tng-repeat=\"shift in vm.infoForDisplay.jobble.shifts track by $index\" \n                            \t \tng-class=\"{ 'no-show-back' : shift.noShow, 'shift-payment-sent' : shift.paymentStats.number > 0 && !shift.noShow  }\">\n                            \t\t\n                            \t\t<td \n                            \t\t\tng-class=\"{ 'no-show-class' : shift.noShow, 'paid-by-shit' : shift.paymentStats.number > 0 && !shift.noShow }\"> \n                            \t\t\t{{ shift.timeInterval.startDateFormattedTZ }}\n                            \t\t</td>\n                            \t\t\n                                \t<td \n                                \t\tng-class=\"{ 'no-show-class' : shift.noShow, 'paid-by-shit' : shift.paymentStats.number > 0 && !shift.noShow }\">\n                                \t\t{{ shift.timeInterval.startTimeFormattedTZ }}\n                                \t</td>\n                                \t\n                                    <td \n                                    \tng-class=\"{ 'no-show-class' : shift.noShow, 'paid-by-shit' : shift.paymentStats.number > 0 && !shift.noShow  }\">\n                                    \t{{ shift.timeInterval.endTimeFormattedTZ }}\n                                    </td>\n                                    \n                                    <td ng-if=\"!shift.isBeingEdited && vm.delivery\">\n                                    \t\n                                    </td>\n                                \t<td \n                                \t\t\n                                \t\tng-class=\"{ 'no-show-class' : shift.noShow, 'paid-by-shit' : shift.paymentStats.number > 0 && !shift.noShow }\" \n                                \t\tclass=\"center-align date-edit\" \n                                \t\tng-click=\"vm.inlineEditShift('hours', shift, vm.infoForDisplay.jobble.shifts)\" \n                                \t\tng-if=\"!shift.isBeingEdited && !vm.delivery\" >\n         \t\t\t\t\t\t\t\t<span ng-if=\"((!shift.noShow) && (!shift.paymentStats.number > 0))\">\n\t           \t\t\t\t\t\t\t\t{{ shift.shiftDurationInHours }}\n    \t      \t\t\t\t\t\t\t</span>\n    \t      \t\t\t\t\t\t\t<span ng-if=\"((shift.noShow) || (shift.paymentStats.number > 0 && !shift.noShow))\" class=\"static-font\">\n\t           \t\t\t\t\t\t\t\t{{ shift.shiftDurationInHours }}\n    \t      \t\t\t\t\t\t\t</span>\n        \t \t\t\t\t\t\t</td>\n         \t\t\t\t\t\t\n         \t\t\t\t\t\t\t<td ng-class=\"{ 'no-show-class' : shift.noShow, 'paid-by-shit' : shift.paymentStats.number > 0 && !shift.noShow }\" \n         \t\t\t\t\t\t\t\twidth=\"\" \n         \t\t\t\t\t\t\t\talign=\"center\" \n         \t\t\t\t\t\t\t\tng-if=\"shift.isBeingEdited && !vm.delivery\">\n         \t\t\t\t\t\t\t\n                                    \t<input \n                                    \t\ttype=\"number\" \n         \t\t\t\t\t\t\t\t\tmin=\"0\" \n         \t\t\t\t\t\t\t\t\tmax=\"24\" \n         \t\t\t\t\t\t\t\t\tng-model=\"vm.hoursValueForEditedShift\" \n         \t\t\t\t\t\t\t\t\tng-enter=\"vm.enterPressedHours(shift)\"\n         \t\t\t\t\t\t\t\t\tng-focus=\"vm.shiftFocus(shift, 'hours')\"\n         \t\t\t\t\t\t\t\t\tng-blur=\"vm.shiftBlur(shift, 'hours')\"\n         \t\t\t\t\t\t\t\t\tclass=\"{{ shift.focusClass }}\" \n         \t\t\t\t\t\t\t\t/>\n         \t\t\t\t\t\t\t\t\n                                    </td>\n                                   \n                                   <td ng-if=\"!shift.isBeingEditedMinutes && vm.delivery\">\n                                   \t\t\n                                   </td> \n                                   \n\t         \t\t\t\t\t\t<td \n\t         \t\t\t\t\t\t\tng-class=\"{ 'no-show-class' : shift.noShow, 'paid-by-shit' : shift.paymentStats.number > 0 && !shift.noShow }\" \n\t         \t\t\t\t\t\t\tclass=\"center-align date-edit\" \n\t         \t\t\t\t\t\t\tng-click=\"vm.inlineEditShift('minutes', shift, vm.infoForDisplay.jobble.shifts)\"\n\t         \t\t\t\t\t\t\tng-if=\"!shift.isBeingEditedMinutes && !vm.delivery\">\n\t         \t\t\t\t\t\t\t\t\n\t         \t\t\t\t\t\t\t<span ng-if=\"((!shift.noShow) && (!shift.paymentStats.number > 0))\">\n\t         \t\t\t\t\t\t\t\t{{ shift.shiftDurationInMinutes }}\n\t         \t\t\t\t\t\t\t</span>\n\t         \t\t\t\t\t\t\t\n\t         \t\t\t\t\t\t\t<span ng-if=\"((shift.noShow) || (shift.paymentStats.number > 0 && !shift.noShow))\" class=\"static-font\">\n\t         \t\t\t\t\t\t\t\t{{ shift.shiftDurationInMinutes }}\n\t         \t\t\t\t\t\t\t</span>\n\t         \t\t\t\t\t\t\t\n\t         \t\t\t\t\t\t</td>\n         \t\t\t\t\t\t\n                                    <td ng-class=\"{ 'no-show-class' : shift.noShow, 'paid-by-shit' : shift.paymentStats.number > 0 && !shift.noShow  }\" \n                                    \twidth=\"\" \n                                    \talign=\"center\" \n                                    \tng-if=\"shift.isBeingEditedMinutes\">\n                                    \t\n\t                                    \t<input \n\t                                    \t\ttype=\"number\" \n\t            \t\t\t\t\t\t\t\tmin=\"0\" \n\t            \t\t\t\t\t\t\t\tmax=\"59\"\n\t            \t\t\t\t\t\t\t\tstep=\"1\"\n\t            \t\t\t\t\t\t\t\tng-model=\"vm.minValueForEditedShift\" \n\t            \t\t\t\t\t\t\t\tng-enter=\"vm.enterPressedMin(shift)\"\n\t            \t\t\t\t\t\t\t\tng-focus=\"vm.shiftFocus(shift, 'mins')\"\n\t            \t\t\t\t\t\t\t\tng-blur=\"vm.shiftBlur(shift, 'mins')\"\n\t            \t\t\t\t\t\t\t\tclass=\"{{ shift.focusClass }}\"\n\t            \t\t\t\t\t\t\t/>\n\t            \t\t\t\t\t\t\t\n                                    </td>\n                                    \n                                    <td ng-if=\"vm.delivery\">\n                                    \n                                    </td>\n                                    \n                                    \n                                    \n                                    <td \n                                    \tng-if=\"!vm.delivery\"\n                                    \tng-class=\"{ 'no-show-class' : shift.noShow, 'paid-by-shit' : shift.paymentStats.number > 0 && !shift.noShow }\" \n                                    \twidth=\"\" align=\"center\">$\n                                    \t{{ shift.amountOwed | number : 2 }}\n                                    </td>\n                                    \n                                    <td ng-class=\"{ 'no-show-class' : shift.noShow, 'paid-by-shit' : shift.paymentStats.number > 0 && !shift.noShow }\"\n                                    \t\n                                    \twidth=\"\" \n                                    \talign=\"center\" \n                                    \tng-mouseenter=\"vm.toggleTip(vm.infoForDisplay, shift, $index)\"  \n                                    \tng-mouseleave=\"vm.toggleTipOff(vm.infoForDisplay, shift, $index)\" \n                                    \tclass=\"note-holder\">\n                                    \t\n                                    \t<div class=\"hide-me-for-tool-tip-wrapper\">\n\t            \t\t\t\t\n\t\t\t\t            \t\t\t\t<i\n\t\t\t\t            \t\t\t\t\tclass=\"fa fa-clipboard note-for-shift\" \n\t\t\t\t            \t\t\t\t\tng-if=\"shift.jobblerNote\" \n\t\t\t\t            \t\t\t\t\taria-hidden=\"true\" \n\t\t\t\t            \t\t\t\t\ttitle=\"Note for shift\" \n\t\t\t\t            \t\t\t\t\tng-click=\"vm.keepNoteActive()\">\n\t\t\t\t            \t\t\t\t\t\n\t\t\t\t            \t\t\t\t</i>\n\t            \t\t\t\t\n\t\t\t\t            \t\t\t\t<div id=\"hide-me-for-tool-tip-{{$index+1}}\" class=\"hide-me-shifts\">\n\t\t\t\t            \t\t\t\t\n\t\t\t\t            \t\t\t\t\t<p>{{ shift.jobblerNote }}</p>\n\t\t\t\t            \t\t\t\t\t\t\t\t            \t\t\t\t\t\n\t\t\t\t            \t\t\t\t</div>\n\t\t\t\t            \t\t\t\t\n\t\t\t           \t\t\t\t\t</div>\n                                    \t\n                                    </td>\n                                    \n                                  <td class=\"center-align\" ng-click=\"vm.toggleMarkers(shift, 1)\" ng-class=\"{ 'toggle-selected' : shift.toggleHasBeenSelectedCheckIn, 'no-show-class' : shift.noShow, 'paid-by-shit' : shift.paymentStats.amount && !shift.noShow, 'toggle-shifts-for-map' : shift.checkInTime  }\"> \n               \t\t\t\t\t\t\n\t               \t\t\t\t\t\t<span class=\"check-in-span\" ng-if=\"!shift.checkInTimeForView && !shift.autoCheckInTimeForView\">\n\t               \t\t\t\t\t\t\t---\n\t               \t\t\t\t\t\t</span>\n\t               \t\t\t\t\t\t\n\t               \t\t\t\t\t\t<span class=\"check-in-span\" ng-if=\"shift.checkInTimeForView\">\n\t               \t\t\t\t\t\t\t<strong>M</strong> : {{ shift.checkInTimeForView }}\n\t               \t\t\t\t\t\t</span>\n\t               \t\t\t\t\t\t\n\t               \t\t\t\t\t\t<p ng-if=\"!shift.checkInCoord.lat && shift.checkInTimeForView\" class=\"map-warning\">\n\t               \t\t\t\t\t\t\tThis shifts <i>manual</i> checkin coordinates did not save. The marker will not appear on the map.\n\t               \t\t\t\t\t\t</p>\n\t               \t\t\t\t\t\t\n               \t\t\t\t\t\t\n\t               \t\t\t\t\t\t<span class=\"check-in-span\" ng-if=\"shift.autoCheckInTimeForView\">\n\t               \t\t\t\t\t\t\t<strong>A</strong> : {{ shift.autoCheckInTimeForView }}\n\t               \t\t\t\t\t\t</span>\n               \t\t\t\t\t\t\n               \t\t\t\t\t\t<p ng-if=\"!shift.autoCheckInCoord.lat && shift.autoCheckInTimeForView\" \n               \t\t\t\t\t\t\tclass=\"map-warning\">This shifts <i>auto</i> checkin coordinates did not save. The marker will not appear on the map.\n               \t\t\t\t\t\t</p>\n               \t\t\t\t\t\t\n               \t\t\t\t\t</td>\n               \t\t\t\n               \t\t\t\t\t<td class=\"center-align\" ng-click=\"vm.toggleMarkers(shift, 2)\" ng-class=\"{ 'toggle-selected' : shift.toggleHasBeenSelectedCheckOut, 'no-show-class' : shift.noShow, 'paid-by-shit' : shift.paymentStats.amount && !shift.noShow, 'toggle-shifts-for-map' : shift.checkOutTime }\">\n               \t\t\t\t\t\t\n               \t\t\t\t\t\t<span class=\"check-in-span\" ng-if=\"!shift.checkOutTimeForView && !shift.autoCheckOutTimeForView\">\n               \t\t\t\t\t\t\t---\n               \t\t\t\t\t\t</span>\n               \t\t\t\t\t\t\n               \t\t\t\t\t\t<span class=\"check-in-span\" ng-if=\"shift.checkOutTimeForView\">\n               \t\t\t\t\t\t\t<strong>M</strong> : {{ shift.checkOutTimeForView }}\n               \t\t\t\t\t\t</span>\n               \t\t\t\t\t\t\n               \t\t\t\t\t\t<p ng-if=\"!shift.checkOutCoord.lat && shift.checkOutTimeForView\" class=\"map-warning\">\n               \t\t\t\t\t\t\tThis shifts <i>manual</i> check out coordinates did not save. The marker will not appear on the map.\n               \t\t\t\t\t\t</p>\n               \t\t\t\t\t\t\n               \t\t\t\t\t\t<span class=\"check-in-span\" ng-if=\"shift.autoCheckOutTimeForView\">\n               \t\t\t\t\t\t\t<strong>A</strong> : {{ shift.autoCheckOutTimeForView }}\n               \t\t\t\t\t\t</span>\n               \t\t\t\t\t\t\n               \t\t\t\t\t\t<p ng-if=\"!shift.autoCheckOutCoord.lat && shift.autoCheckOutTimeForView\" class=\"map-warning\">\n               \t\t\t\t\t\t\tThis shifts <i>auto</i> check out coordinates did not save. The marker will not appear on the map.\n               \t\t\t\t\t\t</p>\n               \t\t\t\t\t\t\n         \t\t\t\t\t\t</td>\n                                    \n                                <td \n                                \tng-if=\"shift.paymentStats.number == 0\" \n                                \talign=\"center\" \n                                \tng-class=\"{ 'no-show-class-opacity' : shift.noShow, 'paid-by-shit' : shift.paymentStats.number > 0 && !shift.noShow }\" >\n                                \t<a \n                                \t\tng-hide=\"vm.delivery\"\n                                \t\tclass=\"play-btn\" \n                                \t\tdata-toggle=\"modal\" \n                                \t\tdata-target=\"#direct-pay-on-complete\"  \n                                \t\tng-if=\"!shift.noShow\" \n                                \t\tng-click=\"vm.directPayJobbler(shift, vm.infoForDisplay)\">\n                                \t\t\tPay\n                                \t\t</a>\n                                </td>\n                                \n                                <td \n                                \tng-if=\"shift.paymentStats.number !== 0\" \n                                \talign=\"center\" \n                                \tng-hide=\"vm.delivery\"\n                                \tng-class=\"{ 'no-show-class-opacity' : shift.noShow, 'paid-by-shit' : shift.paymentStats.number > 0 && !shift.noShow }\" \n                                \tclass=\"shift-has-been-paid\" \n                                \tcolspan=\"2\">\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<span class=\"paid-class\">\n\t\t\t\t\t\t\t\t\t\tPaid\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\n                                </td>\n                                \n                                <td  ng-if=\"shift.paymentStats.number == 0\">\n                                \t<a \n                                \t\tclass=\"no-show-btn\" \n                                \t\tng-if=\"!shift.noShow\" \n                                \t\tng-click=\"vm.markJobblerShowShowForShift(shift, true, true, false)\"  \n                                \t\thref=\"#\">\n                                \t\tNo Show\n                                \t</a>                                    \n                                    <a \n                                    \ttitle=\"Cancel No Show\" \n                                    \tclass=\"no-show-btn\" \n                                    \tng-if=\"shift.noShow\" \n                                    \tng-click=\"vm.markJobblerShowShowForShift(shift, false, true, false)\" \n                                    \thref=\"#\">\n                                    \tCancel No Show\n                                    </a>\n                                </td>\n                               \n                            </tr>\n                                                              \n                        </tbody>\n                     </table>\n                        \n                        \n                </div>\n                <div class=\"row\">\n           \t\t<div class=\"col-lg-12 col-md-12 col-sm-6 col-xs-6\">\n           \t\t\t\t\n           \t\t\t<div id=\"map-holder-for-shifts\">\n            \t\t\t<div map-lazy-load=\"https://maps.google.com/maps/api/js\" style=\"border:1px solid #eee;border-radius:0px;\" ng-if=\"vm.mapHasLoaded\">\n          \t\t\t\t\t<ng-map id=\"mapIdd\" center=\"{{vm.centerLat}}, {{vm.centerLng}}\" zoom=\"{{vm.zoom}}\" style=\"height:400px;\">\n          \t\t\t\t\t\t<marker ng-repeat=\"pos in vm.positions\" position=\"{{pos.position.lat()}}, {{pos.position.lng()}}\" icon=\"{{pos.icon}}\" title=\"{{pos.title}}\" ng-if=\"pos.showMe\"></marker>\n          \t\t\t\t\t</ng-map>\n          \t\t\t\t</div>\n         \t\t\t</div>\n         \t\t\t\t\n           \t\t</div>\n           \t\n           \t\n           \t</div>\n             \t<div class=\"modal-body popup-body\" ng-hide=\"vm.delivery\">\n                   <div class=\"shifts-total clearfix\">\n                    <div class=\"key-wrapper\">\n            \t\t<div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\">\n            \t\t\t<div class=\"key-for-shifts\">\n            \t\t\t\t<table>\n            \t\t\t\t\t<thead>\n            \t\t\t\t\t\t<tr>\n            \t\t\t\t\t\t\t<th>Key</th>\n            \t\t\t\t\t\t\t<th></th>\n            \t\t\t\t\t\t</tr>\n            \t\t\t\t\t</thead>\n            \t\t\t\t\t<tbody>\n            \t\t\t\t\t\t<tr>\n            \t\t\t\t\t\t\t<td>\n            \t\t\t\t\t\t\t\t<i class=\"fa fa-clipboard note-for-shift\" title=\"Note for shift\"></i>\n            \t\t\t\t\t\t\t</td>\n            \t\t\t\t\t\t\t<td>Jobbler left a note for the shift</td>\n            \t\t\t\t\t\t</tr>\n            \t\t\t\t\t\t<tr>\n            \t\t\t\t\t\t\t<td></td>\n            \t\t\t\t\t\t\t<td>Shift has been paid at least once</td>\n            \t\t\t\t\t\t</tr>\n            \t\t\t\t\t\t<tr>\n            \t\t\t\t\t\t\t<td></td>\n            \t\t\t\t\t\t\t<td>Jobbler was a no-show</td>\n            \t\t\t\t\t\t</tr>\n            \t\t\t\t\t\t<tr>\n            \t\t\t\t\t\t\t<td></td>\n            \t\t\t\t\t\t\t<td>No action has taken place</td>\n            \t\t\t\t\t\t</tr>\n            \t\t\t\t\t</tbody>\n            \t\t\t\t</table>\t\t            \t\t\n\t            \t\t</div>\n            \t\t</div>\n            \t\t<div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5\">\n            \t\t\t<div class=\"directions-for-shifts\">\n            \t\t\t\t<!--\n            \t\t\t\t<div class=\"alert alert-info\" role=\"alert\">\n            \t\t\t\t\tIt is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.\n            \t\t\t\t</div>\n            \t\t\t\t-->\n            \t\t\t\t<ul>\n            \t\t\t\t\t<li><strong><u>Start time:</u></strong> The <i>scheduled</i> start time of the shift</li>\n            \t\t\t\t\t<li><strong><u>End time:</u></strong> The <i>scheduled</i> end  time of the shift</li>\n            \t\t\t\t\t<li><strong><u>Hours:</u></strong> The actual amount of hours the jobbler worked -- defaults to scheduled time</li>\n            \t\t\t\t\t<li><strong><u>Minutes:</u></strong> The actual amount of minutes the jobbler worked -- defaults to scheduled time</li>\n            \t\t\t\t</ul>\n            \t\t\t\t\n            \t\t\t</div>\n            \t\t</div>\n            \t\t<div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\">\n            \t\t\t<div class=\"directions-for-shifts\">\n            \t\t\t\t<!--\n            \t\t\t\t<div class=\"alert alert-info\" role=\"alert\">\n            \t\t\t\t\tIt is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.\n            \t\t\t\t</div>\n            \t\t\t\t-->\n            \t\t\t\t<ul>\n            \t\t\t\t\t<li><strong><u>Amount paid:</u></strong> The total dollar amount that has been paid to the jobbler for that shift</li>\n            \t\t\t\t\t<li><strong><u>Check-in:</u></strong> The time and location where the jobbler checked in</li>\n            \t\t\t\t\t<li><strong><u>Check-out:</u></strong> The time and location where the jobbler checked out</li>\n            \t\t\t\t</ul>\n            \t\t\t\t\n            \t\t\t</div>\n            \t\t</div>\n           \t\t</div>\n                        \t<!-- \n                            <span>TOTALS <strong>4 shifts works</strong></span>\n                            <span>HOURS <strong>20</strong> Minutes <strong>88</strong></span>\n                            <span>AMOUNT PAID <strong>$500.00</strong></span>\n                            <span><a class=\"update\" href=\"#\">Update</a></span>\n                            -->\n                        </div>\n                        </div>\n                    </div>\n                    \n                </div>\n            </div>\n        </div>\n    </div>\n    \n    <!--Edit Shifts\t-->\n    \n    \n<!--\ndata-toggle=\"modal\" data-target=\"#direct-pay-on-complete\"\n<a href=\"#direct-pay-on-complete\" data-toggle=\"modal\" id=\"direct-pay-on-complete-click\"></a>\n-->\n\n<div class=\"modal fade\" id=\"direct-pay-on-complete\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\" style=\"padding: 25px 75px;\">\n          <div class=\"modal-header popup-header text-center\">\n            \n             <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              \t<i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n             </button>\n              \n            <h2 style=\"margin-bottom:0px;\">Pay jobbler</h2>\n            \n          </div>\n          <div class=\"modal-body popup-body text-center\">\n          \t<div class=\"connect-payment-loader\" ng-if=\"vm.showLoader\">\n            \t\n            \t<p ng-if=\"vm.showCompleteMessage\" style=\"color: #494949;\">Thank you. Your payment has been sent</p>\n            \t<p ng-if=\"vm.showMissingInfoMessage\" style=\"color: #fff;background-color:#961106;padding:10px;border-radius:5px;\">The jobbler you are trying to pay is missing their payment information. We will contact you when this has been resolved.</p>\n            \t<p ng-if=\"vm.showPaymentError\" style=\"color: #fff;background-color:#961106;padding:10px;border-radius:5px;\">{{ vm.showPaymentErrorMessage }}. Please contact support for further assistance.</p>\n            \t\n            \t\n            \t\n            \t\n            \t<button \n            \t\tng-if=\"vm.showCompleteMessage\" \n            \t\tdata-dismiss=\"modal\" \n            \t\tclass=\"btn btn-success button\"\n            \t\tstyle=\"width:210px;\">\n            \t\tBack to Payment Overview\n            \t</button>\n            \t\t\n\t          \t<img src=\"/app/vendor/images/loading-for-connect.gif\" style=\"width: 200px;\" class=\"image-to-hide\" />\n\t          \t\n            </div>\n          \t\n          \t<div class=\"pay-jobbler-on-compelete\">\n          \t\t<div class=\"complete-direct-pay-helper\" ng-if=\"vm.directPayErrorMessage\">\n          \t\t\t<p>{{vm.directPayErrorMessage}}</p>\n          \t\t</div>\n          \t\t<form ng-submit=\"vm.payJobblerValidation(directPayFormComplete.$valid)\" name=\"directPayFormComplete\" novalidate>\n\t          \t\t<div class=\"row\" ng-if=\"vm.payRate > 0\">\n\t          \t\t\t\n\t          \t\t</div>\n\t          \t\t<div class=\"row\" ng-if=\"vm.payRate > 0\">\n\t          \t\t\t<div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n\t          \t\t\t\t\n\t          \t\t\t\t<label>Hours</label>\n\t          \t\t\t\t\n\t          \t\t\t\t<input \n\t          \t\t\t\t\ttype=\"number\" \n\t          \t\t\t\t\tmin=\"0\" \n\t          \t\t\t\t\tng-model=\"vm.directPayHours\" \n\t          \t\t\t\t\tng-change=\"vm.amountChange()\" \n\t          \t\t\t\t\tstyle=\"width:100%;line-height:35px;font-size:25px;\"\n\t          \t\t\t\t/>\n                  \n\t          \t\t\t</div>\n\t          \t\t\t<div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n\t          \t\t\t\t<label>Minutes</label>\n\t          \t\t\t\t\n\t          \t\t\t\t<input \n\t          \t\t\t\t\ttype=\"number\" \n\t          \t\t\t\t\tmin=\"0\" max=\"59\" \n\t          \t\t\t\t\tng-model=\"vm.directPayMinutes\" \n\t          \t\t\t\t\tng-change=\"vm.amountChange()\" \n\t          \t\t\t\t\tstyle=\"width:100%;line-height:35px;font-size:25px;\"\n\t          \t\t\t\t/>\n\t          \t\t\t\t\n\t          \t\t\t</div>\n\t          \t\t</div>\n\t          \t\t<div class=\"row\" ng-if=\"vm.payRate > 0\">\n\t          \t\t\t<div class=\"editing-shift-table\" style=\"margin-top:10px;\">\n\t\t                \t<div class=\"editing-shift-table-left\">\n\t\t                \t\t<p><strong>Total to be charged :</strong></p>\n\t\t                \t\t<p><strong>The jobbler will receive :</strong></p>\n\t\t                \t</div>\n\t\t          \t\t\t<div class=\"editing-shift-table-right\">\n\t\t                \t\t<p>{{ (((((vm.directPayHours * 60) + vm.directPayMinutes) * (vm.infoForDisplay.jobble.payPerHour / 100)) / 60) * (1 + vm.currentUser.company.defaultPlan.companyFeePct)).toFixed(2) }}</p>\n\t\t                \t\t<p>{{ (((((vm.directPayHours * 60) + vm.directPayMinutes) * (vm.infoForDisplay.jobble.payPerHour / 100)) / 60) * (1 - vm.currentUser.company.defaultPlan.jobblerFeePct)).toFixed(2) }}</p>\n\t\t                \t</div>\n\t                \t</div>\n\t          \t\t</div>\n\t          \t\t\n\t          \t\t<div class=\"row\" style=\"margin-top:25px;\" ng-hide=\"vm.currentUser.company.payByInvoice\">\n\t          \t\t\t<div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\" style=\"padding-left: 0px;\">\n\t\t          \t\t\t<p style=\"margin-top: 5px;\"><strong>Choose payment method :</strong></p>\n\t\t          \t\t</div>\n\t\t          \t\t\n\t\t          \t\t<!-- item as item.name for item in items -->\n\t\t          \t\t<div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n\t\t          \t\t\t<select \n\t\t          \t\t\t\tng-model=\"vm.creditCardsForCompany.value\" \n\t\t          \t\t\t\tng-options=\"card as card.last4edited for card in vm.creditCardsForCompany.values\" \n\t\t          \t\t\t\tclass=\"card-select-strong\" \n\t\t          \t\t\t\tng-change=\"vm.amountChange()\" \n\t\t          \t\t\t\tname=\"cardSelect\">\n\t\t          \t\t\t</select>\n\t\t          \t\t</div>\n\t          \t\t</div>\n\t          \t\t\n          \t\t\t<div class=\"row\">\n\t\t          \t\t<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n\t          \t\t\t\t<input \n\t          \t\t\t\t\ttype=\"submit\" \n\t          \t\t\t\t\tclass=\"btn button btn-success\" \n\t          \t\t\t\t\tvalue=\"Send Payment\" \n\t          \t\t\t\t\tng-disabled=\"vm.isDirectPayDisabledNew\" \n\t          \t\t\t\t/>\n\t          \t\t\t</div>\n          \t\t\t</div>\n          \t\t\n          \t</form>\n          \n          \t</div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n\n\n<div class=\"modal fade\" id=\"payment-error-when-closing\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n        \n          <div class=\"modal-header popup-header text-center\">\n          \t<div class=\"modal-header popup-header text-center\">\n                <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                \t<i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n                </button>\n                \n                <h3 class=\"modal-title\">\n                \tThere was an error\n                </h3>\n            </div>\n          </div>\n          \n          <div class=\"modal-body\">\n               <div class=\"alert-box alert\" style=\"font-size:14px;\">\n            \t\tThere was an issuing with the the payment method ending in {{ _this.selectedPaymentMethod.last4 }} \n               </div>\n               \n               <p>{{ vm.error_reason }}</p>\n          </div>\n          \n          <div class=\"modal-footer\" style=\"text-align:center;\">\n               <a class=\"btn btn-success button\" href=\"\" data-dismiss=\"modal\" ng-click=\"vm.goToHistory()\" style=\"margin:0px;float:none;\">View jobs</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n\n\n<a href=\"#modal-complete-last-event-confirm-modal\" data-toggle=\"modal\" id=\"modal-complete-last-event-confirm\"></a>\n<div class=\"modal fade\" id=\"modal-complete-last-event-confirm-modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n          \t<!--\n          \t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n          \t<span aria-hidden=\"true\">&times;</span></button>\n          \t-->\n          \t\n          \t<div class=\"modal-header popup-header text-center\">\n                <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button>\n                <h3 class=\"modal-title\">Your account was charged {{ vm.totalAmountToBePaidOut() }}</h3>\n            </div>\n          \t\n          \t<p ng-if=\"vm.arrayOfCardErrors.length > 0\">\n          \t\tThere were {{ vm.arrayOfCardErrors.length }} errors while transferring money. Please contact high-five@jobbleapp.com for more information\n          \t</p>\n          \t\n          \t<p ng-if=\"vm.arrayOfCardErrors.length === 0\" style=\"text-align:left;margin-bottom: 10px;color: #000;\">\n          \t\tThank you for completing your job. The jobblers will receive their payment in two business days.\n          \t</p>\n          \t\n          \t<p style=\"background:#9c1006;color:#fff;text-align:center;border-radius:5px;margin-bottom:5px;\" ng-if=\"vm.arrayOfEmptyAccounts.length > 0\">Attention</p>\n          \t<p style=\"color:#9c1006;margin-bottom:5px;\" ng-if=\"vm.arrayOfEmptyAccounts.length > 0\">Please note: the following Jobblers have not yet set up their bank account and have been prompted to do so in order to receive payment.</p>\n          \t<ul style=\"list-style:none;padding-left: 0px;margin-bottom:5px;\" ng-if=\"vm.arrayOfEmptyAccounts.length > 0\">\n          \t\t<li ng-repeat=\"account in vm.arrayOfEmptyAccounts\">\n          \t\t\t{{ account.recipient }}\n          \t\t</li>\n          \t</ul>\n          \t<p style=\"color:#9c1006;margin-bottom:10px;\" ng-if=\"vm.arrayOfEmptyAccounts.length > 0\">These transfers will be reprocessed automatically. Please be aware this may result in a delay of the transaction posting to your bank statement.</p>\n          </div>\n          <div class=\"modal-body\">\n            <a class=\"btn btn-success button\" href=\"\" data-dismiss=\"modal\" ng-click=\"vm.goToHistory()\" style=\"margin:0px;\">View jobs</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<a href=\"#modal-complete-loader-event-confirm-modal\" data-toggle=\"modal\" id=\"modal-complete-loader-event-confirm\"></a>\n<div class=\"modal fade\" id=\"modal-complete-loader-event-confirm-modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n          \t<button style=\"color:#fff;\" type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n          \t<span aria-hidden=\"true\" style=\"color:#fff;\">&times;</span></button>\n          \t<h5>Please hold while your payment is processed</h5>\n\t\t\t<h5>This may take up to two minutes</h5>\n\t\t\t<p id=\"loader-text\">{{ vm.$rootScope.loadingWalkThrough.message }}</p>\n          </div>\n          <div class=\"modal-body\">\n          \t<!--\n            <a class=\"btn\" href=\"\" data-dismiss=\"modal\" ng-click=\"vm.goToHistory()\" style=\"margin:0px;\">History</a>\n            -->\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n\n\n<a href=\"#modal-complete-event-confirm-modal\" data-toggle=\"modal\" id=\"modal-complete-event-confirm\"></a>\n<div class=\"modal fade\" id=\"modal-complete-event-confirm-modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\" style=\"width:715px;\">\n        <div class=\"modal-content popup-content\">\n         <div class=\"modal-header popup-header text-center\" style=\"padding-bottom: 5px;margin-bottom: 30px;border-bottom: 1px solid #eee;\">\n               \n               <button \n            \ttype=\"button\" \n            \tclass=\"close popup-close\" \n            \tdata-dismiss=\"modal\" \n            \taria-label=\"Close\" >\n            \t<i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n               </button>\n               \n            \t<strong>{{ vm.completeModalMessage }}</strong>\n            \t\n          </div>\n           \n          <div class=\"modal-body\" style=\"padding-top:0px;\">\n\t          \t<div class=\"row\" ng-if=\"vm.not_checked_array.length > 0\" style=\"border-bottom: 1px solid #eee;margin-bottom: 25px;padding-bottom: 15px;\">\n\t\t            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n\t\t            \t<div class=\"alert-box alert\" style=\"font-size:12px;margin-bottom:10px;margin-top:10px;text-align:left;\">\n\t\t            \t\t<strong style=\"color:#fff;display:inline;font-weight:bold;\">Warning:</strong> \n\t\t            \t\tThe following users were not marked for payment. If you choose to continue the event will be closed and they will not get paid.\n\t\t            \t</div>\n\t\t            \t\n\t\t\t            <ul class=\"list-of-unchecked\">\n\t\t\t            \t<li ng-repeat=\"user in vm.not_checked_array\">\n\t\t\t            \t\t{{ user.applicant.firstName }} {{ user.applicant.lastName }}\n\t\t\t            \t</li>\n\t\t\t            </ul>\n\t\t              </div>\n\t             </div>\n\t             \n\t             <div class=\"row\">\n\t\t            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n\t\t            \t\n\t\t            \t<h5 style=\"text-align: -webkit-left;margin-top: -10px;\">Payment Overview</h5>\n\t\t            \t\n\t\t            \t<table class=\"table table-border line-item-table\">\n\t\t            \t\t<thead>\n\t\t            \t\t\t<tr>\n\t\t            \t\t\t\t<th>Line item</th>\n\t\t            \t\t\t\t<th>Amount</th>\n\t\t            \t\t\t</tr>\n\t\t            \t\t</thead>\n\t\t            \t\t\n\t\t            \t\t<tbody>\n\t\t            \t\t\t<tr>\n\t\t            \t\t\t\t<td>Jobblers ({{vm.applicationsForBulkUpdate.length}})</td>\n\t\t            \t\t\t\t<td>{{ vm.totalAmountToBePaidOut() }}</td>\n\t\t            \t\t\t</tr>\n\t\t            \t\t\t<tr>\n\t\t            \t\t\t\t<td>Processing Fee</td>\n\t\t            \t\t\t\t<td>${{ vm.companyFeePct | number : 2 }}</td>\n\t\t            \t\t\t</tr>\n\t\t            \t\t\t<tr>\n\t\t            \t\t\t\t<td><strong>Total</strong></td>\n\t\t            \t\t\t\t<td><strong>{{ vm.totalsCombinedNew }}</strong></td>\n\t\t            \t\t\t</tr>\n\t\t            \t\t</tbody>\n\t\t            \t</table>\n\t\t            </div>\n\t\t         </div>\n\t\t         \n\t\t         <div class=\"row\" ng-hide=\"vm.currentUser.company.payByInvoice==true\">\n\t\t         \t<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n\t\t        \t\t <div class=\"jobble-tip spacing-for-jobble-tip\" style=\"background-color:#f2f6f8;border: 1px solid #eee;font-size:12px;text-align:left;margin-top:0px;\">\n                                <h5>Payment schedule</h5>\n                            \t<p ng-if=\"vm.paying_with_bank\">By selecting to pay via ACH bank account, you can expect the funds to be deposited into the jobbler's bank account within 5-7 business days.</p>\n                            \t<p ng-if=\"vm.paying_with_card\">By selecting to pay via credit card, you can expect the funds to be deposited into the jobbler's bank account in 1-2 business days.</p>\n                         </div>\n\t\t         \t</div>\n\t\t         </div>\n          \n             </div>\n        \n             <div class=\"modal-footer\">\n             \t<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n             \t\t<div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\" style=\"text-align:left;\">\n\t             \t\t<a \n\t\t             \t\tclass=\"btn btn-danger button\" \n\t\t             \t\thref=\"\" \n\t\t             \t\tstyle=\"background-color: #d9534f;\"\n\t\t             \t\tdata-dismiss=\"modal\">\n\t\t             \t\t\tCancel\n\t\t             \t</a>\n             \t\t</div>\n             \t\t\n             \t\t<div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\" style=\"text-align:right;\">\n             \t\t\t <a \n\t\t        \t      \tclass=\"btn btn-success button\" \n\t\t        \t      \thref=\"\" data-dismiss=\"modal\" \n\t\t        \t      \tng-if=\"vm.completeButton === 'OK'\" \">\n\t\t        \t      \t\t{{ vm.completeButton }}\n\t\t        \t      </a>\n\t\t        \t      \n\t\t                  <a \n\t\t                  \tclass=\"btn btn-success button\" \n\t\t                  \thref=\"\" \n\t\t                  \tdata-dismiss=\"modal\" \n\t\t                  \tng-if=\"vm.completeButton !== 'OK'\"\n\t\t                  \tng-click=\"vm.submitPayment()\">\n\t\t                  \t\t{{vm.completeButton}}\n\t\t                  </a>\n             \t\t</div>\n             \t</div>\n\t             \t\n           \n             </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n\n\n<div class=\"modal fade\" id=\"modal-add-to-team-jobbler\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content popup-content\">\n                    <div class=\"modal-header popup-header text-center\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                        \t<i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n                        </button>\n                        <h3 class=\"modal-title\">Add Jobbler to Team</h3>\n                    </div>\n                    <div class=\"modal-body popup-body\">\n\t\t\t\t\t\t<div ng-show=\"vm.add_users_to_team_ui.loading_teams\">\n\t\t\t\t\t\t\t<i class=\"fa fa-cog fa-spin fa-1x fa-fw\">\n\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t\t...Retrieving Teams\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div ng-hide=\"vm.add_users_to_team_ui.loading_teams\">\n\t\t\t\t\t\t\t<img \n\t\t\t\t\t\t\t\tsrc=\"{{vm.user_to_add.filePROFILE_IMAGE1IMG_75x75}}\" \n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<p class=\"user-to-add-name\">\n\t\t\t\t\t\t\t\t{{vm.user_to_add.firstName}} {{vm.user_to_add.lastName}}\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<div\n\t\t\t\t\t\t\tclass=\"alert-box alert\" \n\t\t\t\t\t\t\tng-show=\"vm.add_user_to_team_error\">\n\t\t\t\t\t\t\t{{vm.add_user_to_team_error}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\n                        <form ng-submit=\"vm.submitTeamAdd()\" ng-hide=\"vm.add_users_to_team_ui.loading_teams\">\n                        \t<label>Please select the team you would like to add this user too.</label>\n                        \t<select \n                        \t\tclass=\"form-control form-input\"\n\t\t\t\t\t\t\t\tng-model=\"vm.add_users_to_team_ui.dropdown_placeholder\"\n\t\t\t\t\t\t\t\tng-options=\"team.id as team.name for team in vm.teams_for_modal\"\n\t\t\t\t\t\t\t\tng-change=\"vm.teamsChanged()\">\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<div class=\"btn btn-success\" ng-show=\"vm.success\" ng-click=\"vm.closeTeamAdd()\">\n\t\t\t\t\t\t\t\t{{vm.success}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\n                            <input \n                            \tclass=\"btn btn-success button\" \n                            \tvalue=\"Add to team\" \n                            \ttype=\"submit\" \n                            \tng-hide=\"vm.submitting\"\n                            />\n                        </form>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal fade\" id=\"modal-add-review-jobbler\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content popup-content\">\n                    <div class=\"modal-header popup-header text-center\">\n                    \t\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                        \t<i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n                        </button>\n                        \n                        <h3 class=\"modal-title\">Write Review</h3>\n                        \n                        <h4 class=\"modal-sub\">{{ vm.infoForDisplay.applicant.firstName }} {{ vm.infoForDisplay.applicant.lastName }}</h4>\n                        \n                    </div>\n                    <div class=\"modal-body popup-body\">\n                    \n                    \t<div class=\"alert-box alert\" ng-show=\"vm.isAddNewJobblersError\">{{vm.addNewJobblersErrorMessage}}</div>\n                    \t\n                        <form ng-submit=\"vm.submitReview()\">\n                        \t<label>Please write a review. These reviews help the rest of the community to make hiring decisions.</label>\n                        \t<textarea class=\"form-control form-input edit-margin\" ng-model=\"vm.reviewForBulk\" ng-change=\"vm.countChars()\" maxlength=\"250\"></textarea>\n\n                            <span class=\"char-counter\">\n                                {{vm.count}}/250\n                            </span>\n\n                            <input \n                                class=\"btn btn-success button\" \n                                value=\"Submit review\" \n                                type=\"submit\"\n                            />\n                        </form>\n                        \n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div \n    class=\"modal fade\" \n    id=\"modal-add-review-jobble-all\" \n    tabindex=\"-1\" \n    role=\"dialog\" \n    aria-labelledby=\"modal-add-projectLabel\" \n    data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content popup-content\">\n                    \n                    <div class=\"modal-header popup-header text-center\">\n                        \n                        <button \n                            type=\"button\" \n                            class=\"close popup-close\" \n                            data-dismiss=\"modal\" \n                            aria-label=\"Close\">\n                            <i \n                                class=\"fa fa-times-circle\" \n                                aria-hidden=\"true\">\n                            </i>\n                        </button>\n                        <h3 class=\"modal-title\">Write a bulk review</h3>\n                    </div>\n                    \n                    <div class=\"modal-body popup-body\">\n                        \n                        <div \n                            class=\"alert-box alert\" \n                            ng-show=\"vm.isAddNewJobblersError\">\n                            {{vm.addNewJobblersErrorMessage}}\n                        </div>\n                        \n                <form ng-submit=\"vm.submitReviewBulkUpdate()\">\n                    <label>\n                        Please write a review. These reviews help the rest of the community to make hiring  decisions.\n                    </label>\n                    <textarea class=\"form-control form-input edit-margin\" ng-model=\"vm.reviewForBulk\" ng-change=\"vm.countChars()\"></textarea>\n                    \n                    <span class=\"char-counter\">\n                        {{vm.count}}/250\n                    </span>\n\n                    <input \n                        class=\"btn btn-success button\" \n                        value=\"Submit review\" \n                        type=\"submit\" \n                        ng-class=\"{ 'disabled' : vm.loadingReviews }\" \n                    />\n                </form>\n                        \n                    </div>\n                    \n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n<div class=\"modal fade\" id=\"modal-mark-as-now-show\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content popup-content\">\n                    <div class=\"modal-header popup-header text-center\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                        \t<i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n                        </button>\n                        <h3 class=\"modal-title\">Confirm no show</h3>\n                    </div>\n                    <div class=\"modal-body popup-body\">\n                    \t\n                    \t<p>Are you sure you want to mark <strong>{{ vm.dataModelForNoShow.applicant.firstName }} {{ vm.dataModelForNoShow.applicant.lastName }}</strong> as a no show for ALL shifts?</p>\n                    \t<a class=\"btn btn-success button\" ng-click=\"vm.markJobblerAsANoShowFromMainPage()\" ng-class=\"{ 'disabled' : vm.noShowButtonDiabled }\">Confirm</a>\n                    \t\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal fade\" id=\"modal-mark-as-now-show-cancel\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content popup-content\">\n                    <div class=\"modal-header popup-header text-center\">\n                    \t\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                        \t<i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n                        </button>\n                        <h3 class=\"modal-title\">Cancel no show</h3>\n                    </div>\n                    <div class=\"modal-body popup-body\">\n                    \t<p>Are you sure you want to cancel <strong>{{ vm.dataModelForNoShow.applicant.firstName }} {{ vm.dataModelForNoShow.applicant.lastName }}</strong>'s no show?</p>\n                    \t<a class=\"btn btn-success button\" ng-click=\"vm.markJobblerAsANoShowFromMainPageCancel()\" ng-class=\"{ 'disabled' : vm.noShowButtonDiabled }\">Confirm</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal fade\" id=\"re-open-job\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content popup-content\">\n                    <div class=\"modal-header popup-header text-center\">\n                    \t\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                        \t<i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n                        </button>\n                        \n                        <h3 class=\"modal-title\">Re-open Completed Job</h3>\n                        \n                    </div>\n                    <div class=\"modal-body popup-body\">\n                    \t<p>Are you sure you want to re-open this job?</p>\n                    \t\n                    \t<a class=\"btn btn-success button\" ng-click=\"vm.openJob()\">Confirm</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<paymentdialog></paymentdialog>\n\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>"

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventcompleteController = function () {
	  function EventcompleteController($http, $localStorage, $scope, $state, AuthService, CompaniesService, EventsService, $stateParams, SecurityService, $rootScope, EnvService, $timeout, $location, ngProgressFactory, CommonService, NgMap, TrackingService) {
	    _classCallCheck(this, EventcompleteController);
	
	    this.name = "eventcomplete";
	    $localStorage.activeStateName = "events";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$events = EventsService;
	    this.$security = SecurityService;
	    this.$scope = $scope;
	    this.$location = $location;
	    this.$companies = CompaniesService;
	    this.$progress = ngProgressFactory.createInstance();
	    this.$stateParams = $stateParams;
	    this.$rootScope = $rootScope;
	    this.arrayOfCardErrors = [];
	    this.dupe_error_prevent_payment = false;
	    this.positions = [];
	    this.calcData = 0;
	    this.arrayOfCardSuccess = [];
	    this.totalMinutesWorkedForEntireJob = 0;
	    this.arrayOfEmptyAccounts = null;
	    this.$common = CommonService;
	    this.bulkCheck = false;
	    this.$env = EnvService;
	    this.$maps = NgMap;
	    this.delivery = false;
	    this.sourcingPostTotal = 0;
	    this.previousJobblerBeingRated = null;
	    this.isTheEventOpen = null;
	    this.$timeout = $timeout;
	    this.printFriendlyTemplate = null;
	    this.$tracking = TrackingService;
	    this.checkInMarkers = [];
	    this.checkOutMarkers = [];
	    this.currentUser = this.$auth.getUserData();
	    this.creditCards = this.$auth.getUserData().company.undeletedPaymentInfos;
	    this.remain_loading_count = 0;
	    this.totalHoursForAllJobblers = 0;
	    this.totalForEvent = 0;
	    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
	    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;
	    this.jobblers = [];
	    this.directPayErrorMessage = null;
	    this.isDirectPayDisabled = true;
	    this.ratingsMap = [];
	    this.showRatingsWarningToUser = false;
	    this.paymentInfos = this.currentUser.company.undeletedPaymentInfos;
	    this.formatPaymentInfoForPage(this.paymentInfos);
	    this.ratingsArray = [];
	    this.errorWithCard = { status: false, message: "" };
	    this.isSuccessJobblerPayment = false;
	    this.optionsRating = { value: 5, values: [1, 2, 3, 4, 5] };
	    this.optionsRatingModal = { value: 5, values: [1, 2, 3, 4, 5] };
	    this.cardsArray = [];
	    this.banksArray = [];
	    this.getLatestInfo();
	    this.add_users_to_team_ui = {
	      loading_teams: false
	    };
	    this.organizePaymentInfo();
	    this.applicationsForBulkUpdate = [];
	    this.applicationsForRatingUpdate = [];
	    this.do_we_have_teams();
	
	    var _this = this;
	
	    console.log("************COMPLETE");
	    console.log("************COMPLETE");
	    console.log("************COMPLETE");
	    console.dir(_this.$rootScope);
	    console.dir(_this.$rootScope.$$listenerCount);
	
	    this.remain_loading_count++;
	
	    this.CollectCardsForConnectListener = this.$rootScope.$on("CollectCardsForConnect", function ($rootscope, event) {
	      _this.generateCardsArray();
	    });
	    this.UpdatedCreditCardConnectionCompletePageListener = this.$rootScope.$on("UpdatedCreditCardConnectionCompletePage", function ($rootscope, event) {
	      _this.cardsArray = [];
	      _this.currentUser = _this.$auth.getUserData();
	      _this.paymentInfos = _this.currentUser.company.paymentInfos;
	      _this.generateCardsArray();
	      _this.organizePaymentInfo();
	    });
	    this.$scope.$on("$destroy", this.CollectCardsForConnectListener);
	    this.$scope.$on("$destroy", this.UpdatedCreditCardConnectionCompletePageListener);
	    if (_this.currentUser.username.indexOf("jobble.com") !== -1 || _this.currentUser.username.indexOf("jobbleapp.com") !== -1) {
	      _this.currentUser.isAdmin = true;
	    }
	    this.$events.getEventByIdTrimmedComplete(this.$stateParams.eventId).then(function (data) {
	      var response = data.data;
	      _this.event = response;
	      _this.alignSideBar();
	      if (_this.event.isSourcingPost) {
	        _this.postType = "source";
	      } else {
	        _this.postType = "regular";
	      }
	      _this.payRate = _this.event.subEvents[0].deduppedJobbles[0].payPerHour;
	      if (_this.event.isClosed === true || _this.event.isCancelled === true || _this.event.isCompleted === true) {
	        _this.isTheEventOpen = false;
	      } else {
	        _this.isTheEventOpen = true;
	      }
	      _this.remain_loading_count--;
	      if (_this.event.status === "error") {
	        return;
	      }
	      $timeout(function () {
	        if (_this.event.isClosed === true) {
	          //$('eventsidebar .sidebar-nav li:nth-child(5)').removeClass().addClass('active');
	          $("eventsidebar .jobs-complete-sidebar ul li:nth-child(5)").removeClass().addClass("active");
	        } else {
	          $("eventsidebar .sidebar-nav li:nth-child(9)").removeClass().addClass("active");
	        }
	      }, 2000);
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetEventToEventDialog", {
	          event: _this.event
	        });
	        _this.$rootScope.$emit("SetEventToEventSidebar", {
	          event: _this.event
	        });
	      });
	      _this.remain_loading_count++;
	      $timeout(function () {
	        _this.formatAddressForMaps();
	      }, 3000);
	      _this.getAcceptedJobblers();
	      _this.checkForDelivery();
	    }, function (data) {
	      _this.remain_loading_count--;
	      _this.$timeout(function () {
	        jQuery("#show-application-alert").trigger("click");
	      }, 100);
	    });
	
	    $timeout(function () {
	      _this.printFriendlyTemplate = "<table><thead><th>Name</th><th>Email</th><th>Number</th></thead>";
	      var endOfTable = "</tbody></table>";
	      var arrayOfRows = [];
	      var stringOfHtml = "";
	      if (_this.jobblers) {
	        try {
	          for (var i = 0; i < _this.jobblers.length; i++) {
	            arrayOfRows.push("<tr><td>" + _this.jobblers[i].applicant.firstName + " " + _this.jobblers[i].applicant.lastName + "</td><td>" + _this.jobblers[i].applicant.email + "</td><td>" + _this.jobblers[i].applicant.homeContactInfo.phoneMobile + "</td></tr>");
	            _this.printFriendlyTemplate = _this.printFriendlyTemplate + "<tr><td>" + _this.jobblers[i].applicant.firstName + " " + _this.jobblers[i].applicant.lastName + "</td><td>" + _this.jobblers[i].applicant.email + "</td><td>" + _this.jobblers[i].applicant.homeContactInfo.phoneMobile + "</td></tr>";
	          }
	        } finally {
	          _this.printFriendlyTemplate = _this.printFriendlyTemplate + endOfTable;
	        }
	      }
	    }, 4000);
	
	    _this.SuccessToDeleteEventListener = _this.$rootScope.$on("SuccessToDeleteEvent", function () {
	      _this.$state.go("jobsdashboard");
	    });
	
	    _this.UpdatedCreditCardListener = _this.$rootScope.$on("UpdatedCreditCard", function ($rootscope, params) {
	      _this.$auth.reloadCurrentUser();
	
	      if (params) {
	        _this.formatPaymentInfoForPage(params.user.company.undeletedPaymentInfos);
	      } else {
	        _this.$timeout(function () {
	          _this.currentUser = _this.$auth.getUserData();
	          _this.creditCards = _this.currentUser.company.undeletedPaymentInfos;
	          _this.generateCardsArray();
	        }, 4000);
	      }
	    });
	
	    _this.$scope.$on("$destroy", _this.SuccessToDeleteEventListener);
	    _this.$scope.$on("$destroy", _this.UpdatedCreditCardListener);
	  }
	
	  _createClass(EventcompleteController, [{
	    key: "getCheckInLocationData",
	    value: function getCheckInLocationData(applications) {
	      var _this = this;
	      var arrayOfAllShiftsThatHaveCheckInCoords = [];
	      applications.forEach(function (app) {
	        app.jobble.shifts.forEach(function (shift) {
	          if (!_this.$security.isUndefinedOrNull(shift.checkInCoord)) {
	            shift.checkInCoord.jobbleId = app.jobble.id;
	            shift.checkInCoord.shiftId = shift.id;
	            arrayOfAllShiftsThatHaveCheckInCoords.push(shift);
	          } else {
	            arrayOfAllShiftsThatHaveCheckInCoords.push(shift);
	          }
	        });
	      });
	      if (arrayOfAllShiftsThatHaveCheckInCoords.length != 0) {
	        _this.loopShiftsWithCheckinCordsSlowly(arrayOfAllShiftsThatHaveCheckInCoords);
	      }
	    }
	  }, {
	    key: "loopShiftsWithCheckinCordsSlowly",
	    value: function loopShiftsWithCheckinCordsSlowly(shifts) {
	      var _this = this;
	      shifts.forEach(function (shift, i) {
	        (function () {
	          setTimeout(function () {
	            if (shift.checkInCoord) {
	              var myLatLng = {
	                lat: shift.checkInCoord.lat,
	                lng: shift.checkInCoord.lng
	              };
	              var geocoderPerApp = new google.maps.Geocoder();
	              geocoderPerApp.geocode({ latLng: myLatLng }, function (results, status) {
	                if (status === google.maps.GeocoderStatus.OK) {
	                  if (results[1]) {
	                    shift.checkInAddress = results[0].formatted_address;
	                  } else {
	                    shift.checkInAddress = "Address not recognized by google";
	                  }
	                } else {
	                  shift.checkInAddress = "Address not recognized by google";
	                }
	              });
	            }
	            if (i + 1 === shifts.length) {
	              _this.loopShiftsWithCheckoutCordsSlowly(shifts);
	            }
	          }, i * 300);
	        })(shift);
	      });
	    }
	  }, {
	    key: "loopShiftsWithCheckoutCordsSlowly",
	    value: function loopShiftsWithCheckoutCordsSlowly(shifts) {
	      var _this = this;
	      shifts.forEach(function (shift, i) {
	        (function () {
	          setTimeout(function () {
	            if (shift.checkOutCoord) {
	              var myLatLng = {
	                lat: shift.checkOutCoord.lat,
	                lng: shift.checkOutCoord.lng
	              };
	              var geocoderPerApp = new google.maps.Geocoder();
	              geocoderPerApp.geocode({ latLng: myLatLng }, function (results, status) {
	                if (status === google.maps.GeocoderStatus.OK) {
	                  if (results[1]) {
	                    shift.checkOutAddress = results[0].formatted_address;
	                  } else {
	                    shift.checkOutAddress = "Address not recognized by google";
	                  }
	                } else {
	                  shift.checkOutAddress = "Address not recognized by google";
	                }
	              });
	            }
	            if (i + 1 === shifts.length) {
	              _this.putTheCordsBackInTheirShifts(shifts);
	            }
	          }, i * 300);
	        })(shift);
	      });
	    }
	  }, {
	    key: "putTheCordsBackInTheirShifts",
	    value: function putTheCordsBackInTheirShifts(shifts) {
	      var _this = this;
	      _this.jobblers.forEach(function (application, i) {
	        application.jobble.shifts.forEach(function (existingShift) {
	          shifts.forEach(function (newShift) {
	            if (newShift.id === existingShift.id) {
	              existingShift.checkInAddress = newShift.checkInAddress;
	              existingShift.checkOutAddress = newShift.checkOutAddress;
	            }
	          });
	        });
	        if (i + 1 === _this.jobblers.length) {
	          _this.$timeout(function () {
	            _this.jobblers = _this.jobblers;
	            _this.tableLoader = false;
	          }, 1000);
	        }
	      });
	    }
	  }, {
	    key: "setEditStatus",
	    value: function setEditStatus() {
	      var _this = this;
	      _this.infoForDisplay.isEditStatus = true;
	    }
	  }, {
	    key: "figureOutTheTime",
	    value: function figureOutTheTime(minutes) {
	      var _this = this;
	      var timeObj = {};
	      var hours = Math.floor(minutes / 60);
	      var mins = minutes % 60;
	      timeObj.hours = hours;
	      timeObj.minutes = mins;
	      return timeObj;
	    }
	  }, {
	    key: "timeForTable",
	    value: function timeForTable(minutes) {
	      var _this = this;
	      var hours = Math.floor(minutes / 60);
	      var mins = _this.showLeadingZero(minutes % 60);
	      return hours + ":" + mins;
	    }
	  }, {
	    key: "countChars",
	    value: function countChars() {
	      var _this = this;
	
	      if (_this.reviewForBulk) {
	        _this.count = _this.reviewForBulk.length;
	      } else {
	        _this.count = 0;
	      }
	    }
	  }, {
	    key: "countCharsBulk",
	    value: function countCharsBulk() {
	      var _this = this;
	    }
	  }, {
	    key: "displayApplicantInfo",
	    value: function displayApplicantInfo(application, status, index) {
	      var _this = this;
	
	      _this.reviewForBulk = null;
	      _this.count = 0;
	
	      if (status === 1) {
	        if (application.ratingReview) {
	          _this.reviewForBulk = application.ratingReview;
	        }
	        _this.$timeout(function () {
	          jQuery("#modal-add-review-jobbler").modal();
	        });
	      }
	
	      if (application.show) {
	        _this.slidePayments(application, index);
	      }
	
	      _this.remain_loading_count = 1;
	
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetLoaderDialog", { type: 1, total: 1 });
	      });
	
	      this.displayDetails = true;
	      this.userWantsShifts = false;
	      this.ratingOption = application.rating.rate;
	      this.editByShift = false;
	
	      if (_this.positions) {
	        _this.positions = [];
	      }
	
	      if (application.shift_count > 1 && application.jobble.actualMinutesWorked) {
	        application.displayTimeEditingWardning = true;
	      }
	
	      this.$events.getShiftInformationComplete(_this.event.subEvents[0].id, application).then(function (response) {
	        application.jobble.shifts = response.data.jobble.shifts;
	
	        if (_this.$security.isUndefinedOrNull(application.jobble.actualMinutesWorked)) {
	          ////console.log('just want to make sure');
	
	          if (application.jobble.jobbleDurationInMinutes / 60 % 1 !== 0) {
	            var timeObj = _this.figureOutTheTime(application.jobble.jobbleDurationInMinutes);
	
	            _this.hourPreview = timeObj.hours;
	            _this.minutePreview = timeObj.minutes;
	          } else {
	            _this.hourPreview = application.jobble.jobbleDurationInMinutes / 60;
	            _this.minutePreview = 0;
	          }
	        } else {
	          timeObj = _this.figureOutTheTime(application.jobble.actualMinutesWorked);
	          _this.hourPreview = timeObj.hours;
	          _this.minutePreview = timeObj.minutes;
	        }
	
	        try {
	          application.totalPaymentsForJobble = 0;
	          application.totalNumberOfPaymentsForJobble = 0;
	
	          _this.shiftsWithPayments = [];
	          _this.shiftsWithOutPayments = [];
	
	          application.jobble.shifts.forEach(function (shift) {
	            if (shift.paymentStats.number > 0) {
	              _this.shiftsWithPayments.push(shift);
	            } else {
	              _this.shiftsWithOutPayments.push(shift);
	            }
	
	            if (shift.paymentStats) {
	              application.totalPaymentsForJobble = application.totalPaymentsForJobble + shift.paymentStats.amount;
	            }
	
	            if (shift.paymentStats.number) {
	              application.totalNumberOfPaymentsForJobble = application.totalNumberOfPaymentsForJobble + shift.paymentStats.number;
	            }
	
	            shift.timeInterval.startTimeFormattedTZ = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
	            shift.timeInterval.startDateFormattedTZ = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("MM/DD/YYYY");
	            shift.timeInterval.endTimeFormattedTZ = moment(shift.timeInterval.endTime).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
	
	            var momentET = moment(shift.timeInterval.endTime).tz(shift.contactInfo.place.timeZoneId);
	            var momentST = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId);
	
	            var totalMinutes = null;
	            var hoursRounded = null;
	
	            if (shift.actualMinutesWorked || shift.actualMinutesWorked === 0) {
	              totalMinutes = shift.actualMinutesWorked;
	              hoursRounded = Math.floor(totalMinutes / 60);
	            } else {
	              totalMinutes = shift.shiftDurationInMinutes = momentET.diff(momentST, "minutes");
	              hoursRounded = Math.floor(totalMinutes / 60);
	            }
	
	            shift.shiftDurationInHours = hoursRounded;
	            shift.shiftDurationInMinutes = totalMinutes % 60;
	
	            if (!shift.paymentStats.amount) {
	              shift.amountPaid = 0;
	            } else {
	              if (!shift.noShow) {
	                shift.paidOutClass = "success-payment-shifts";
	                shift.amountPaid = shift.paymentStats.amount;
	              }
	            }
	
	            if (!_this.$security.isUndefinedOrNull(shift.checkInTime)) {
	              //shift.checkInTimeForView = moment(shift.checkInTime).tz(shift.contactInfo.place.timeZoneId).format("MM/DD/YYYY") + " at " + moment(shift.checkInTime).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
	              shift.checkInTimeForView = moment(shift.checkInTime).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
	            } else {
	              // shift.checkInTimeForView = "---";
	              shift.checkInTimeForView = null;
	            }
	            if (!_this.$security.isUndefinedOrNull(shift.checkOutTime)) {
	              //shift.checkOutTimeForView = moment(shift.checkOutTime).tz(shift.contactInfo.place.timeZoneId).format("MM/DD/YYYY") + " at " + moment(shift.checkOutTime).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
	              shift.checkOutTimeForView = moment(shift.checkOutTime).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
	            } else {
	              shift.checkOutTimeForView = null;
	            }
	
	            if (!_this.$security.isUndefinedOrNull(shift.autoCheckInCoord.dateCreated)) {
	              //shift.autoCheckInTimeForView = moment(shift.autoCheckInCoord.dateCreated).tz(shift.contactInfo.place.timeZoneId).format("MMM DD, YYYY") + " at " + moment(shift.autoCheckInCoord.dateCreated).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
	              shift.autoCheckInTimeForView = moment(shift.autoCheckInCoord.dateCreated).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
	            } else {
	              shift.autoCheckInTimeForView = null;
	            }
	
	            if (!_this.$security.isUndefinedOrNull(shift.autoCheckOutCoord.dateCreated)) {
	              //shift.autoCheckOutTimeForView = moment(shift.autoCheckOutCoord.dateCreated).tz(shift.contactInfo.place.timeZoneId).format("MMM DD, YYYY") + " at " + moment(shift.autoCheckOutCoord.dateCreated).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
	              shift.autoCheckOutTimeForView = moment(shift.autoCheckOutCoord.dateCreated).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
	            } else {
	              shift.autoCheckOutTimeForView = null;
	            }
	          });
	        } finally {
	          application.hoursEdited = 0;
	          application.minutesEdited = 0;
	
	          _this.infoForDisplay = application;
	          _this.setMarkerToMap(application);
	
	          application.jobble.shifts.sort(function (a, b) {
	            return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
	          });
	
	          if (_this.infoForDisplay.noShowClass) {
	            _this.infoForDisplay.jobble.paidOutClass = "jobbler-is-no-show";
	            _this.minutePreview = 0;
	            _this.hourPreview = 0;
	          }
	
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("SetLoaderDialog", {
	              type: 0,
	              total: 1
	            });
	          });
	
	          _this.remain_loading_count = 0;
	          _this.calculateTotalsForDisplay();
	          _this.setShiftStartTimesAndAmounts(application);
	
	          if (application.jobble.noShow && application.jobble.shifts.length === 1 && !application.jobble.shifts.noShow) {
	            _this.markJobblerShowShowForShift(application.jobble.shifts[0], true, true);
	          }
	        }
	      });
	    }
	  }, {
	    key: "displayShiftInfo",
	    value: function displayShiftInfo(application) {
	      this.infoForDisplay = application;
	    }
	  }, {
	    key: "printRoster",
	    value: function printRoster() {
	      var _this = this;
	
	      if (navigator.userAgent.toLowerCase().indexOf("chrome") > -1) {
	        var popupWin = window.open("", "_blank", "width=800,height=800,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no");
	        popupWin.window.focus();
	        popupWin.document.write("<!DOCTYPE html><html><head>" + '<link rel="stylesheet" type="text/css" href="/app/vendor/css/style-print.css" />' + '</head><body onload="window.print()"><div class="print-body">' + _this.printFriendlyTemplate + "</div></html>");
	        popupWin.onbeforeunload = function (event) {
	          popupWin.close();
	          return ".\n";
	        };
	        popupWin.onabort = function (event) {
	          popupWin.document.close();
	          popupWin.close();
	        };
	      }
	    }
	  }, {
	    key: "selectedCardInfo",
	    value: function selectedCardInfo(card, event) {
	      this.payType = "card";
	      this.errorWithCard.status = false;
	      this.cardHasBeenSelected = true;
	      this.token = card.cardToken;
	    }
	  }, {
	    key: "selectedBankInfo",
	    value: function selectedBankInfo(bank, event) {
	      ////.log('selectedBankInfo');
	      ////.dir(bank);
	      this.payType = "bank";
	      this.cardHasBeenSelected = true;
	      this.token = bank.stripeId;
	    }
	  }, {
	    key: "manageRatings",
	    value: function manageRatings(userApp) {
	      var _this = this;
	      _this.showRatingError = false;
	
	      this.ratingOption = userApp.ratingValue;
	
	      if (!this.$security.isUndefinedOrNull(this.ratingOption) && this.ratingOption !== 0) {
	        this.jobblers.forEach(function (jobblerLoop) {
	          if (jobblerLoop.applicant.id === userApp.applicant.id) {
	            jobblerLoop.ratingValue = _this.ratingOption;
	            jobblerLoop.displaySticky = true;
	            var ratingsArray = [];
	            var ratingsObjForDB = {};
	            ratingsObjForDB.ratingUser = _this.currentUser.id;
	            ratingsObjForDB.ratedUser = userApp.applicant.id;
	            ratingsObjForDB.rate = _this.ratingOption;
	            ratingsObjForDB.noteRateGiver = _this.review;
	            ratingsObjForDB.ratingType = 1;
	            ratingsObjForDB.subEvent = _this.event.subEvents[0].id;
	            ratingsObjForDB.ratingCompany = _this.currentUser.company.id;
	            ratingsArray.push(ratingsObjForDB);
	            _this.ratingsMap.push(userApp);
	
	            var submitRating = {
	              method: "POST",
	              url: _this.$env.getAPIEndPoint() + "jbl/v1/ratings/upsert?format=json&conf=web&fields=rate",
	              headers: {
	                "Content-Type": "application/json",
	                Authorization: "Bearer " + _this.currentUser.access_token
	              },
	              data: { ratings: ratingsArray }
	            };
	
	            _this.remain_loading_count++;
	            _this.$http(submitRating).then(function (response) {
	              if (response.status === "error") {
	                _this.displayDetails = false;
	                _this.ratingOption = null;
	                _this.review = null;
	                _this.remain_loading_count--;
	              } else {
	                userApp.ratingValue = response.data[0].rate;
	                _this.displayDetails = false;
	                _this.ratingOption = null;
	                _this.review = null;
	                if (_this.ratingsMap.length >= _this.jobblers.length) {
	                  _this.showRatingsWarningToUser = false;
	                  if (!_this.$security.isUndefinedOrNull(_this.token)) {
	                    _this.cardHasBeenSelected = true;
	                  }
	                }
	
	                for (var i = 0; i < _this.ratingsArray.length; i++) {
	                  if (userApp.applicant.id === _this.ratingsArray[i].ratedUser) {
	                    _this.ratingsArray[i].rate = ratingsObjForDB.rate;
	                  }
	                }
	
	                _this.remain_loading_count--;
	
	                _this.$timeout(function () {
	                  jQuery("#modal-add-review-jobbler .modal-header button.close").trigger("click");
	                });
	              }
	            }, function (response) {
	              _this.remain_loading_count--;
	              //////.log(response.data);
	              _this.$timeout(function () {
	                jQuery("#show-application-alert").trigger("click");
	              }, 100);
	            });
	          }
	        });
	      } else {
	        this.showRatingError = true;
	      }
	    }
	  }, {
	    key: "noShow",
	    value: function noShow(jobbler) {
	      //////.log('no show');
	      //////.dir(jobbler);
	      this.jobblerForNoShowPopUp = jobbler;
	      this.displayNoShowModal = true;
	      this.displayShiftDetails = false;
	
	      var _this = this;
	      jobbler.jobble.noShow = true;
	      _this.remain_loading_count++;
	
	      jQuery("#modal-jobble-shift .modal-header button.close").trigger("click");
	
	      var putNowShow = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobbler.jobble.id + "?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.currentUser.access_token
	        },
	        data: { noShow: true }
	      };
	
	      _this.$http(putNowShow).then(function (response) {
	        _this.remain_loading_count--;
	        if (response.status === "error") {
	          //////.log('no show not put');
	          _this.displayNoShowModal = false;
	          //////.dir(response);
	        } else {
	          //////.log('no show put');
	          //////.dir(response);
	          _this.displayNoShowModal = false;
	          jobbler.ratingValue = 1;
	          jobbler.noShowClass = "no-show-jobbler";
	
	          if (jobbler.jobble.actualMinutesWorked === null || jobbler.jobble.actualMinutesWorked === 0) {
	            if (jobbler.jobble.jobbleDuration === 0) {
	              _this.totalHoursForAllJobblers = _this.totalHoursForAllJobblers - jobbler.jobble.jobbleLength;
	              _this.totalForEvent -= jobbler.jobble.payPerHour * jobbler.jobble.jobbleLength;
	            } else {
	              _this.totalHoursForAllJobblers = _this.totalHoursForAllJobblers - jobbler.jobble.jobbleDuration;
	              _this.totalForEvent -= jobbler.jobble.payPerHour * jobbler.jobble.jobbleDuration;
	            }
	          } else {
	            _this.totalHoursForAllJobblers = _this.totalHoursForAllJobblers - jobbler.jobble.actualMinutesWorked / 60;
	            _this.totalForEvent -= jobbler.jobble.payPerHour * (jobbler.jobble.actualMinutesWorked / 60);
	          }
	
	          // jobbler.jobble.actualMinutesWorked = 0;
	
	          _this.ratingsMap.push(jobbler);
	          var ratingsArrayForNoShow = [];
	          var ratingsObjForDBForNoShow = {};
	          ratingsObjForDBForNoShow.ratingUser = _this.currentUser.id;
	          ratingsObjForDBForNoShow.ratedUser = jobbler.applicant.id;
	          ratingsObjForDBForNoShow.rate = 1;
	          ratingsObjForDBForNoShow.noteRateGiver = "Did not show up for work.";
	          ratingsObjForDBForNoShow.ratingType = 1;
	          ratingsObjForDBForNoShow.subEvent = jobbler.jobble.subEventId;
	          ratingsObjForDBForNoShow.ratingCompany = _this.currentUser.company.id;
	          ratingsArrayForNoShow.push(ratingsObjForDBForNoShow);
	
	          var submitRatingForNoShow = {
	            method: "POST",
	            url: _this.$env.getAPIEndPoint() + "jbl/v1/ratings/upsert?format=json&conf=web",
	            headers: {
	              "Content-Type": "application/json",
	              Authorization: "Bearer " + _this.currentUser.access_token
	            },
	            data: { ratings: ratingsArrayForNoShow }
	          };
	
	          _this.remain_loading_count++;
	
	          _this.$http(submitRatingForNoShow).then(function (response) {
	            _this.remain_loading_count--;
	            if (response.status === "error") {
	              //////.log('rating not upserted');
	              //////.dir(response);
	            } else {
	              //////.log('rating upserted');
	              //////.dir(response);
	              if (_this.ratingsMap.length >= _this.jobblers.length) {
	                _this.showRatingsWarningToUser = false;
	              }
	            }
	          }, function (data) {
	            _this.remain_loading_count--;
	            _this.$timeout(function () {
	              jQuery("#show-application-alert").trigger("click");
	            }, 100);
	          });
	        }
	      }, function (data) {
	        _this.remain_loading_count--;
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "noShowCancel",
	    value: function noShowCancel(jobbler) {
	      var _this = this;
	
	      _this.displayNoShowCancelModal = true;
	      _this.jobblerForNoShowPopUpCancel = jobbler;
	      _this.displayShiftDetails = true;
	      _this.displayShiftDetails = false;
	
	      //////.log('before...');
	      //////.dir(jobbler);
	      jobbler.ratingValue = 5;
	      jobbler.noShowClass = undefined;
	      //////.log('after...');
	      //////.dir(jobbler);
	      jQuery("#modal-jobble-shift .modal-header button.close").trigger("click");
	      var putNowShowCancel = {
	        method: "PUT",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobbler.jobble.id + "?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.currentUser.access_token
	        },
	        data: { noShow: false }
	      };
	
	      _this.remain_loading_count++;
	      _this.$http(putNowShowCancel).then(function (response) {
	        if (response.status === "error") {
	          //////.log('no show not put');
	          _this.displayNoShowCancelModal = false;
	          //////.dir(response);
	        } else {
	          _this.displayNoShowCancelModal = false;
	
	          jobbler.jobble.noShow = false;
	          if (_this.$security.isUndefinedOrNull(jobbler.jobble.jobbleLength)) {
	            jobbler.jobble.jobbleLength = jobbler.jobble.jobbleDuration;
	            _this.totalHoursForAllJobblers = _this.totalHoursForAllJobblers + jobbler.jobble.jobbleDuration;
	            _this.totalForEvent += jobbler.jobble.payPerHour * jobbler.jobble.jobbleDuration;
	          } else {
	            _this.totalHoursForAllJobblers = _this.totalHoursForAllJobblers + jobbler.jobble.jobbleLength;
	            _this.totalForEvent += jobbler.jobble.payPerHour * jobbler.jobble.jobbleLength;
	          }
	
	          var ratingsArrayForNoShow = [];
	          var ratingsObjForDBForNoShow = {};
	          ratingsObjForDBForNoShow.ratingUser = _this.currentUser.id;
	          ratingsObjForDBForNoShow.ratedUser = jobbler.applicant.id;
	          ratingsObjForDBForNoShow.rate = 5;
	          ratingsObjForDBForNoShow.noteRateGiver = "";
	          ratingsObjForDBForNoShow.ratingType = 1;
	          ratingsObjForDBForNoShow.subEvent = jobbler.jobble.subEventId;
	          ratingsObjForDBForNoShow.ratingCompany = _this.currentUser.company.id;
	          ratingsArrayForNoShow.push(ratingsObjForDBForNoShow);
	
	          var submitRatingForNoShowCancel = {
	            method: "POST",
	            url: _this.$env.getAPIEndPoint() + "jbl/v1/ratings/upsert?format=json&conf=web",
	            headers: {
	              "Content-Type": "application/json",
	              Authorization: "Bearer " + _this.currentUser.access_token
	            },
	            data: { ratings: ratingsArrayForNoShow }
	          };
	
	          _this.remain_loading_count++;
	
	          _this.$http(submitRatingForNoShowCancel).then(function (response) {
	            _this.remain_loading_count--;
	            if (response.status === "error") {
	              //////.log('rating not upserted');
	              //////.dir(response);
	            } else {
	              //////.log('rating upserted');
	              //////.dir(response);
	              if (_this.ratingsMap.length >= _this.jobblers.length) {
	                _this.showRatingsWarningToUser = false;
	                _this.remain_loading_count = 0;
	              }
	            }
	          }, function (data) {
	            _this.remain_loading_count--;
	            _this.$timeout(function () {
	              jQuery("#show-application-alert").trigger("click");
	            }, 100);
	          });
	        }
	
	        _this.remain_loading_count--;
	      }, function (data) {
	        _this.remain_loading_count--;
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "updateJobblerInfo",
	    value: function updateJobblerInfo(application) {
	      //////.dir(application);
	      var _this = this;
	      if (!_this.$security.isUndefinedOrNull(application.hoursEdited)) {
	        var hoursToMinutes = application.hoursEdited * 60;
	        //////.log('hours converted');
	        //////.dir(hoursToMinutes);
	
	        if (!_this.$security.isUndefinedOrNull(application.minutesEdited)) {
	          //////.log('were the minutes edited?');
	          //////.dir(hoursToMinutes);
	          //////.dir(application.minutesEdited);
	
	          hoursToMinutes = hoursToMinutes + application.minutesEdited;
	          //////.log('minutes converted');
	          //////.dir(hoursToMinutes);
	        }
	
	        application.jobble.actualMinutesWorked = hoursToMinutes;
	
	        //////.log('right before the put');
	        //////.dir(hoursToMinutes);
	        //////.dir(application.jobble.actualMinutesWorked);
	
	        var putActualHoursWorked = {
	          method: "PUT",
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + application.jobble.id + "?format=json&conf=web",
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + _this.currentUser.access_token
	          },
	          data: { actualMinutesWorked: hoursToMinutes }
	        };
	
	        _this.remain_loading_count++;
	        _this.$http(putActualHoursWorked).then(function (response) {
	          _this.remain_loading_count--;
	          if (response.data.status === "error") {
	            application.hoursEdited = 0;
	            application.minutesEdited = 0;
	            application.isEditStatus = false;
	          } else {
	            application.displayShiftDetails = false;
	            application.hoursEdited = 0;
	            application.minutesEdited = 0;
	            try {
	              _this.jobblers.forEach(function (jblr) {
	                if (jblr.applicant.id === application.applicant.id) {
	                  jblr.jobble.actualMinutesWorked = hoursToMinutes;
	                  jblr.jobble.jobbleDurationInMinutes = hoursToMinutes;
	                  jblr.jobble.actualRevenue = hoursToMinutes / 60 * jblr.jobble.payPerHour;
	                  jblr.jobble.costOfJobble = hoursToMinutes / 60 * jblr.jobble.payPerHour;
	                }
	              });
	            } finally {
	              _this.calculateCostOfEventAfterEdit();
	              jQuery("#modal-jobble-shift .modal-header button.close").trigger("click");
	            }
	          }
	        }, function (response) {
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	        });
	      }
	    }
	  }, {
	    key: "calculateCostOfEventAfterEdit",
	    value: function calculateCostOfEventAfterEdit() {
	      var _this = this;
	      _this.totalForEvent = 0;
	      var tempTotal = 0;
	      var tempHours = 0;
	      _this.jobblers.forEach(function (jobbler) {
	        tempHours = 0;
	        if (jobbler.jobble.noShow !== true) {
	          if (jobbler.jobble.actualMinutesWorked !== null) {
	            tempHours = jobbler.jobble.actualMinutesWorked / 60;
	          } else {
	            if (jobbler.jobble.jobbleLength % 1 !== 0) {
	              tempHours = parseFloat(jobbler.jobble.jobbleLength);
	            } else {
	              tempHours = parseFloat(jobbler.jobble.jobbleLength);
	            }
	          }
	        }
	        tempTotal = tempTotal + tempHours;
	
	        _this.totalForEvent += tempHours * jobbler.jobble.payPerHour;
	      });
	
	      _this.totalHoursForAllJobblers = tempTotal;
	    }
	  }, {
	    key: "submitPaymentModal",
	    value: function submitPaymentModal(status, reTriggerModal) {
	      var _this = this;
	
	      var not_checked_array = [];
	
	      if (_this.paymentMethodsFormatted.length === 0 && _this.currentUser.company.payByInvoice !== true) {
	        _this.displayPaymentInfoModal();
	        return;
	      }
	
	      try {
	        _this.jobblers.forEach(function (jobbler) {
	          if (!jobbler.isCheckedForAction && !jobbler.jobble.noShow && !jobbler.paymentToshiftHasBeenMade) {
	            not_checked_array.push(jobbler);
	          }
	        });
	      } finally {
	        _this.not_checked_array = not_checked_array;
	      }
	      _this.paymentAttempted = true;
	
	      console.log("_this.cardHasBeenSelected");
	      console.dir(_this.paymentAttempted);
	      console.dir(_this.cardHasBeenSelected);
	
	      if (_this.cardHasBeenSelected && _this.paymentAttempted) {
	        _this.noCardSelectedError = false;
	
	        if (reTriggerModal !== false) {
	          //_this.checkForDuplicatePayments();
	        }
	
	        if (status === 1) {
	          _this.$timeout(function () {
	            jQuery("#modal-complete-event-confirm-modal").modal();
	            _this.completeModalMessage = "Please confirm that you want to pay out this job";
	            _this.completeButton = "Confirm";
	          }, 100);
	        }
	        if (status === 2) {
	          _this.$timeout(function () {
	            jQuery("#modal-complete-event-confirm-modal").modal();
	            _this.completeModalMessage = "There seems to have been an error processing your request. Please contact support for further assitance at high-five@jobbleapp.com.";
	            _this.completeButton = "OK";
	          }, 100);
	        }
	      } else {
	        if (_this.currentUser.company.payByInvoice === true) {
	          console.log("what about here");
	          if (reTriggerModal !== false) {
	            //_this.checkForDuplicatePayments();
	          }
	          _this.$timeout(function () {
	            jQuery("#modal-complete-event-confirm-modal").modal();
	            _this.completeModalMessage = "Please confirm that you want to pay out this job";
	            _this.completeButton = "Confirm";
	          }, 100);
	        } else {
	          _this.noCardSelectedError = true;
	        }
	      }
	    }
	  }, {
	    key: "checkForDuplicatePayments",
	    value: function checkForDuplicatePayments() {
	      var _this = this;
	
	      console.log("_this.checkForDuplicatePayments();");
	      console.dir(_this.jobblers);
	
	      var jobblersForWarning = [];
	
	      try {
	        _this.jobblers.forEach(function (item, index) {
	          if (item.isCheckedForAction === true) {
	            console.log("checked jobblers");
	            console.dir(item);
	            jobblersForWarning.push(item);
	          }
	        });
	      } catch (err) {
	        console.log("in error catch");
	        console.dir(err);
	      } finally {
	        console.log("in the finally");
	        console.dir(jobblersForWarning);
	        _this.checkForPaymentStats(jobblersForWarning);
	      }
	    }
	  }, {
	    key: "checkForPaymentStats",
	    value: function checkForPaymentStats(jobblers) {
	      var _this = this;
	
	      console.log("checkForPaymentStats");
	      console.dir(jobblers);
	
	      var usersForWarning = [];
	
	      try {
	        jobblers.forEach(function (app) {
	          app.jobble.shifts.forEach(function (shift) {
	            console.log("each shift shift");
	            console.dir(shift);
	            if (shift.paymentStats.amount !== null) {
	              console.log("we have payment stats");
	              console.dir(shift);
	              usersForWarning.push(app);
	            }
	          });
	        });
	      } catch (err) {
	        console.log("error");
	        console.dir(err);
	      } finally {
	        console.log("in the finally");
	        console.dir(usersForWarning.length);
	        console.dir(usersForWarning);
	
	        if (usersForWarning.length > 0) {
	          console.log("in the if statement....");
	
	          _this.$timeout(function () {
	            jQuery("#modal-complete-event-confirm-modal").modal("toggle");
	          }, 800);
	
	          _this.$timeout(function () {
	            _this.usersForWarning = usersForWarning;
	            jQuery("#modal-complete-event-attention-modal").modal();
	          }, 1200);
	        }
	      }
	    }
	  }, {
	    key: "triggerPaymentModal",
	    value: function triggerPaymentModal() {
	      var _this = this;
	
	      _this.submitPaymentModal(1, false);
	    }
	  }, {
	    key: "submitPayment",
	    value: function submitPayment() {
	      this.showPaymentLoaderButton = undefined;
	      this.errorWithCard = {};
	      this.errorWithCard.status = false;
	      this.isSuccessJobblerPayment = false;
	
	      var _this = this;
	
	      _this.$timeout(function () {
	        jQuery("#modal-complete-loader-event-confirm").trigger("click");
	      }, 100);
	
	      _this.$rootScope.loadingWalkThrough = {};
	      _this.$progress.start();
	
	      if (!_this.creditCards && _this.currentUser.company.payByInvoice !== true) {
	        _this.errorWithCard.status = true;
	        _this.errorWithCard.message = "Can't pay the jobbler because there is no any credit card.";
	        _this.$progress.complete();
	        alert("There is no payment menthod on file.");
	        return;
	      }
	
	      if (_this.creditCards.length === 0 && _this.currentUser.company.payByInvoice !== true) {
	        _this.errorWithCard.status = true;
	        _this.errorWithCard.message = "Can't pay the jobbler because there is no any credit card.";
	        _this.$progress.complete();
	        alert("There is no payment menthod on file.");
	        return;
	      }
	
	      if (!_this.cardHasBeenSelected && _this.currentUser.company.payByInvoice !== true) {
	        _this.errorWithCard.status = true;
	        _this.errorWithCard.message = "Please select a credit card to pay the jobbler.";
	        _this.$progress.complete();
	        alert("There was no payment menthod selected.");
	        return;
	      }
	
	      if (_this.$security.isUndefinedOrNull(this.token) && _this.currentUser.company.payByInvoice !== true) {
	        _this.errorWithCard.status = true;
	        _this.errorWithCard.message = "There is no token for this card. Please select or register another card";
	        _this.$progress.complete();
	        alert("There is no token for this card. Please select or register another card");
	        return;
	      }
	
	      _this.remain_loading_count++;
	      _this.$rootScope.loadingWalkThrough.status = true;
	      _this.$rootScope.loadingWalkThrough.message = "Paying jobblers...Do not refresh page.";
	
	      var u = _this.currentUser;
	
	      console.log("what is the user");
	      console.dir(u);
	
	      var paymentRequst = _this.$events.payJobblersAndCloseEvent(_this.jobblers, _this.subeventIdForClosure, _this.token, _this.$stateParams.eventId, _this.payType, _this.delivery, u);
	
	      console.log("paymentRequst");
	      console.dir(paymentRequst);
	
	      paymentRequst.then(function (paymentResponse) {
	        console.log("paymentResponse");
	        console.dir(paymentResponse);
	
	        if (paymentResponse.status !== 200) {
	          _this.$timeout(function () {
	            _this.remain_loading_count--;
	            $("#modal-complete-loader-event-confirm .modal-header button.close").trigger("click");
	            _this.$progress.complete();
	            $("#ngProgress-container").remove();
	            _this.displayTextMessage = false;
	            _this.$rootScope.loadingWalkThrough = undefined;
	            _this.submitPaymentModal(2);
	            return;
	          });
	        }
	
	        var closeRequest = _this.$events.closeEvent(_this.event.id);
	
	        _this.$timeout(function () {
	          closeRequest.then(function (response) {
	            console.log("what is the response");
	            console.dir(response);
	            if (response.data[0].status === "error") {
	              _this.$timeout(function () {
	                _this.remain_loading_count--;
	                _this.$progress.complete();
	                $("#modal-complete-loader-event-confirm .modal-header button.close").trigger("click");
	                $("#modal-complete-loader-event-confirm-modal").modal("toggle");
	                $("#ngProgress-container").remove();
	                _this.displayTextMessage = false;
	                _this.$rootScope.loadingWalkThrough = undefined;
	                //_this.submitPaymentModal(2);
	                _this.setAlert();
	                return;
	              });
	            } else {
	              _this.event.isClosed = true;
	              _this.event.isComplete = true;
	              _this.$timeout(function () {
	                $("#modal-complete-loader-event-confirm-modal .modal-header button.close").trigger("click");
	                _this.$progress.complete();
	                $("#ngProgress-container").remove();
	              });
	              _this.showPaymentLoaderButton = true;
	              _this.totalChargeForModal = 0;
	              try {
	                for (var i = 0; i < paymentResponse.data.length; i++) {
	                  if (paymentResponse.data[i].missinPaymentnfo) {
	                    _this.arrayOfEmptyAccounts = paymentResponse.data[i].missinPaymentnfo;
	                  } else {
	                    if (paymentResponse.data[i].status === "error") {
	                      _this.errorWithCard.status = true;
	                      _this.arrayOfCardErrors.push(paymentResponse.data[i]);
	                    } else {
	                      _this.arrayOfCardSuccess.push(paymentResponse.data[i]);
	                      if (paymentResponse.data[i].charge) {
	                        _this.totalChargeForModal = _this.totalChargeForModal + paymentResponse.data[i].charge.amount;
	                      }
	                    }
	                  }
	                }
	              } finally {
	                _this.handleErrorsFromPayments();
	                var temp_event = _this.event;
	                _this.$tracking.reportNoShows(_this.jobblers, temp_event);
	                _this.saveShiftDataForLocalytics({
	                  event: _this.event,
	                  jobblers: _this.jobblers
	                });
	                _this.$events.trackEventCompletion(_this.jobblers, _this.event, _this.totalChargeForModal, _this.currentUser);
	              }
	            }
	          }, function (error) {
	            alert("Please contact support");
	          });
	        }, 2000);
	      }, function (response) {
	        _this.remain_loading_count--;
	        _this.showPaymentLoaderButton = true;
	        $("#ngProgress-container").remove();
	        _this.$progress.complete();
	        _this.errorWithCard.status = true;
	        _this.errorWithCard.message = "Error to pay the jobblers.";
	      });
	    }
	  }, {
	    key: "setAlert",
	    value: function setAlert() {
	      var _this = this;
	      _this.$timeout(function () {
	        alert("The work force was paid, but there seems to be an issue closing the job. Please contact support.");
	      }, 300);
	    }
	  }, {
	    key: "handleErrorsFromPayments",
	    value: function handleErrorsFromPayments() {
	      var _this = this;
	
	      /*
	      ////console.log('arrayOfCardErrors');
	      ////console.dir(_this.arrayOfCardErrors);
	      */
	
	      if (_this.arrayOfCardErrors.length === 0) {
	        _this.$timeout(function () {
	          $("#modal-complete-last-event-confirm-modal").modal();
	        }, 300);
	      } else {
	        _this.error_reason = _this.arrayOfCardErrors[0].message;
	        _this.$timeout(function () {
	          $("#payment-error-when-closing").modal();
	        }, 300);
	      }
	    }
	  }, {
	    key: "sendRatings",
	    value: function sendRatings() {
	      var _this = this;
	
	      ////.log('what are the jobblers at this point --');
	      ////.dir(_this.jobblers);
	
	      var ratingsArrayForAll = [];
	
	      try {
	        _this.jobblers.forEach(function (jobbler) {
	          var ratingsObjForDB = {};
	          ////.log('each application during payment');
	          ////.dir(jobbler);
	          if (!jobbler.ratingId) {
	            if (jobbler.jobble.noShow) {
	              //.log('we have a no show');
	              ratingsObjForDB.ratingUser = _this.currentUser.id;
	              ratingsObjForDB.ratedUser = jobbler.applicant.id;
	              ratingsObjForDB.noteRateGiver = "Did not show up for work.";
	              ratingsObjForDB.ratingType = 1;
	              ratingsObjForDB.rate = 1;
	              ratingsObjForDB.subEvent = _this.event.subEvents[0].id;
	              ratingsObjForDB.ratingCompany = _this.currentUser.company.id;
	              ratingsArrayForAll.push(ratingsObjForDB);
	            } else {
	              ////.log('we have a no show');
	              if (!jobbler.ratingValue) {
	                //.log('no rating value..');
	                ratingsObjForDB.ratingUser = _this.currentUser.id;
	                ratingsObjForDB.ratedUser = jobbler.applicant.id;
	                ratingsObjForDB.noteRateGiver = "No written review by employer.";
	                ratingsObjForDB.ratingType = 1;
	                ratingsObjForDB.rate = 5;
	                ratingsObjForDB.subEvent = _this.event.subEvents[0].id;
	                ratingsObjForDB.ratingCompany = _this.currentUser.company.id;
	                ratingsArrayForAll.push(ratingsObjForDB);
	              }
	            }
	          }
	        });
	      } finally {
	        var submitRating = {
	          method: "POST",
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/ratings/upsert?format=json&conf=web",
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + _this.currentUser.access_token
	          },
	          data: { ratings: ratingsArrayForAll }
	        };
	        _this.$http(submitRating).then(function (response) {});
	        _this.$timeout(function () {
	          _this.$rootScope.loadingWalkThrough = undefined;
	          _this.$progress.complete();
	
	          _this.showPaymentLoaderButton = true;
	          jQuery("#modal-complete-last-event-confirm").trigger("click");
	          $("#ngProgress-container").remove();
	          _this.remain_loading_count--;
	        }, 500);
	      }
	    }
	  }, {
	    key: "saveShiftDataForLocalytics",
	    value: function saveShiftDataForLocalytics(params) {
	      var _this = this;
	      _this.$events.getAcceptedApplicationsTrimmedCompleteTracking(_this.event.subEvents[0].id, 200).then(function (response) {
	        var applications = response.data;
	        _this.processApplicationsForTracking(applications);
	      });
	    }
	  }, {
	    key: "processApplicationsForTracking",
	    value: function processApplicationsForTracking(applications) {
	      var _this = this;
	      applications.forEach(function (application) {
	        //console.log('each application');
	        //console.dir(application);
	        application.jobble.shifts.forEach(function (shift) {
	          //console.log("processApplicationsForTrackingprocessApplicationsForTrackingprocessApplicationsForTrackingprocessApplicationsForTrackingprocessApplicationsForTracking");
	          _this.$tracking.handleShiftData(application, shift);
	        });
	      });
	    }
	  }, {
	    key: "directPayJobbler",
	    value: function directPayJobbler(shift, application) {
	      console.log("directPayJobbler");
	      console.dir(shift);
	      console.dir(application);
	      console.dir(this.currentUser);
	      var invoice = this.currentUser.company.payByInvoice;
	
	      this.generateCardsArray();
	      this.directPayHours = 0;
	      this.directPayMinutes = 0;
	      this.directPayAmount = 0;
	      this.showCompleteMessage = false;
	      this.showMissingInfoMessage = false;
	      this.showPaymentError = false;
	      this.showPaymentErrorMessage = null;
	      this.showLoader = false;
	      this.directPayErrorMessage = null;
	      this.isDirectPayDisabled = true;
	      this.infoForDisplay = application;
	      this.shift_for_payment = shift;
	
	      if (invoice !== true) {
	        if (this.creditCardsForCompany.values.length === 0) {
	          this.$timeout(function () {
	            jQuery("#modal-edit-shifts .modal-header button.close").trigger("click");
	          });
	          this.$timeout(function () {
	            jQuery("#direct-pay-on-complete").modal("toggle");
	          }, 500);
	          this.$timeout(function () {
	            jQuery("#modal-add-card").modal();
	          }, 900);
	          return;
	        }
	      }
	
	      if (shift) {
	        this.shiftForPayment = shift;
	        this.directPayHours = shift.shiftDurationInHours;
	        this.directPayMinutes = shift.shiftDurationInMinutes;
	        this.$timeout(function () {
	          jQuery("#modal-edit-shifts .modal-header button.close").trigger("click");
	        });
	        this.$timeout(function () {
	          jQuery("#direct-pay-on-complete-click").trigger("click");
	          jQuery("#direct-pay-on-complete .pay-jobbler-on-compelete").show("fast");
	        }, 500);
	      } else {
	        if (this.postType === "regular") {
	          this.$timeout(function () {
	            jQuery("#modal-edit-shifts .modal-header button.close").trigger("click");
	          });
	          this.$timeout(function () {
	            jQuery("#direct-pay-on-complete-click").trigger("click");
	            jQuery("#direct-pay-on-complete .pay-jobbler-on-compelete").show("fast");
	          }, 500);
	        } else {
	          this.$timeout(function () {
	            jQuery("#modal-edit-shifts .modal-header button.close").trigger("click");
	          });
	          this.$timeout(function () {
	            jQuery("#direct-pay-on-complete .pay-jobbler-on-compelete").show("fast");
	          }, 500);
	        }
	      }
	    }
	  }, {
	    key: "payJobblerValidation",
	    value: function payJobblerValidation(isValid) {
	      var _this = this;
	
	      var invoice = _this.currentUser.company.payByInvoice;
	
	      console.log("payJobblerValidation");
	      console.dir(invoice);
	      console.dir(_this.shiftForPayment);
	
	      try {
	        _this.$rootScope.defaultCard = _this.creditCardsForCompany.value;
	        _this.updateShiftHoursAndBeDone(_this.shift_for_payment, _this.directPayHours, _this.directPayMinutes);
	      } finally {
	        var paymentTotal = null;
	
	        if (_this.directPayHours || _this.directPayMinutes) {
	          paymentTotal = ((_this.directPayHours * 60 + _this.directPayMinutes) * (_this.infoForDisplay.jobble.payPerHour / 100) / 60).toFixed(2);
	          paymentTotal = paymentTotal * 100;
	        } else {
	          paymentTotal = (_this.directPayAmount * (1 + _this.currentUser.company.defaultPlan.companyFeePct)).toFixed(2);
	          paymentTotal = paymentTotal * 100;
	        }
	
	        _this.$timeout(function () {
	          jQuery("#direct-pay-on-complete .pay-jobbler-on-compelete").hide("slow");
	        }, 300);
	        _this.$timeout(function () {
	          _this.showLoader = true;
	          jQuery("#direct-pay-on-complete .image-to-hide").show("slow");
	        }, 400);
	
	        var transferArray = null;
	
	        if (_this.shiftForPayment) {
	          transferArray = [{
	            recipient: _this.infoForDisplay.applicant.email,
	            amount: paymentTotal,
	            note: "Payment",
	            shift: _this.shiftForPayment.id
	          }];
	        } else {
	          transferArray = [{
	            recipient: _this.infoForDisplay.applicant.email,
	            amount: paymentTotal,
	            note: "Payment",
	            jobble: _this.infoForDisplay.jobble.id
	          }];
	        }
	
	        var data = {};
	        data.transfers = transferArray;
	
	        if (invoice === true) {} else {
	          if (_this.creditCardsForCompany.value.is_bank) {
	            data.bank = _this.$rootScope.defaultCard.token;
	          } else {
	            data.card = _this.$rootScope.defaultCard.token;
	          }
	        }
	
	        var reqPayJobbler = {
	          method: "POST",
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + _this.currentUser.access_token
	          },
	          data: data
	        };
	
	        _this.$http(reqPayJobbler).then(function (response) {
	          if (_this.shiftForPayment) {
	            _this.handleResponseFromPayment(response, paymentTotal);
	          } else {
	            _this.handleResponseFromPayment(response, paymentTotal);
	          }
	        }, function (response) {
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	        });
	      }
	    }
	  }, {
	    key: "updateShiftHoursAndBeDone",
	    value: function updateShiftHoursAndBeDone(shift, hours, minutes) {
	      var _this = this;
	
	      ////console.log('updateShiftHoursAndBeDone');
	      ////console.dir(shift);
	      ////console.dir(hours);
	      ////console.dir(minutes);
	
	      var totalMinutes = hours * 60 + minutes;
	      shift.actualMinutesWorked = totalMinutes;
	
	      _this.$security.putActualMinutesWorkedForShiftTrimmed(shift.id, totalMinutes).then(function (response) {
	        ////console.log('putActualMinutesWorkedForShiftTrimmed');
	        ////console.dir(response);
	        _this.updateJobHoursAndBeDone(totalMinutes);
	      }, function (error) {
	        ////console.log('error storing updated shift minutes');
	        ////console.dir(error)
	      });
	    }
	  }, {
	    key: "updateJobHoursAndBeDone",
	    value: function updateJobHoursAndBeDone(minutes) {
	      var _this = this;
	
	      ////console.log('updateJobHoursAndBeDone');
	      ////console.dir(minutes);
	      ////console.dir(_this.infoForDisplay);
	      var application = _this.infoForDisplay;
	      var jobble_minutes = application.jobbleDurationData.hours * 60 + application.jobbleDurationData.minutes;
	      var job = {};
	      job.id = application.jobble.id;
	
	      if (application.jobble.actualMinutesWorked && application.jobble.actualMinutesWorked > 0) {
	        jobble_minutes = application.jobble.actualMinutesWorked;
	      }
	
	      if (jobble_minutes > minutes) {
	        job.actualMinutesWorked = jobble_minutes - minutes;
	      } else {
	        job.actualMinutesWorked = 0;
	      }
	
	      if (job.actualMinutesWorked < 0) {
	        ////console.log('some how were negative');
	        job.actualMinutesWorked = 0;
	      }
	
	      job.actualRevenue = job.actualMinutesWorked * _this.infoForDisplay.jobble.payPerHour / 60;
	
	      _this.$security.putActualMinutesWorkedTrimmed(job.id, job.actualMinutesWorked).then(function (response) {
	        ////console.log('putActualMinutesWorkedTrimmed resonpse');
	        ////console.dir(response);
	
	        _this.jobblers.some(function (elem) {
	          if (elem.jobble.id === job.id) {
	            elem.jobble.actualMinutesWorked = job.actualMinutesWorked;
	            elem.jobbleDurationData.minutes = job.actualMinutesWorked % 60;
	            elem.jobbleDurationData.hours = Math.floor(job.actualMinutesWorked / 60);
	            elem.jobble.totalCalculated = job.actualRevenue / 100;
	            elem.showActualMinutesWorked = true;
	          }
	        });
	      }, function (error) {
	        ////console.log('error putting the minutes on the job');
	        ////console.dir(error);
	      });
	    }
	  }, {
	    key: "handleResponseFromPayment",
	    value: function handleResponseFromPayment(response, paymentTotal) {
	      var _this = this;
	
	      ////console.log('handleResponseFromPayment');
	      ////console.dir(response);
	      ////console.dir(paymentTotal);
	
	      if (response.data[0].status === "error") {
	        _this.$timeout(function () {
	          _this.showPaymentError = true;
	          _this.showPaymentErrorMessage = response.data[0].message;
	          jQuery("#direct-pay-on-complete .image-to-hide").hide("slow");
	        }, 1500);
	
	        return;
	      }
	
	      if (response.data[0].missinPaymentnfo) {
	        var missingInfo = response.data[0].missinPaymentnfo[0];
	        ////.log('missing info');
	        ////.dir(missingInfo);
	        _this.$timeout(function () {
	          jQuery("#direct-pay-on-complete .image-to-hide").hide("slow");
	          //_this.calculateNumbersForTableAfterUpdate(paymentTotal);
	          _this.showMissingInfoMessage = true;
	        }, 1000);
	      } else {
	        _this.$timeout(function () {
	          jQuery("#direct-pay-on-complete .image-to-hide").hide("slow");
	          _this.calculateNumbersForTableAfterUpdate(paymentTotal);
	          _this.showCompleteMessage = true;
	        }, 1000);
	      }
	    }
	  }, {
	    key: "calculateNumbersForTableAfterUpdate",
	    value: function calculateNumbersForTableAfterUpdate(totalCharge, application) {
	      var _this = this;
	
	      ////console.log('do we have this?');
	      ////console.dir(application);
	
	      try {
	        for (var i = 0; i < _this.jobblers.length; i++) {
	          if (_this.infoForDisplay.applicant.id === _this.jobblers[i].applicant.id) {
	            ////console.log('we have a match lets update the shifts pay info');
	            ////console.dir(_this.jobblers[i]);
	            ////console.dir(_this.shift_for_payment);
	
	            _this.jobblers[i].jobble.numberOfPayment = _this.jobblers[i].jobble.numberOfPayment + 1;
	            _this.jobblers[i].jobble.amountPaid = _this.jobblers[i].jobble.amountPaid + totalCharge;
	            _this.jobblers[i].jobble.averageAmount = _this.jobblers[i].jobble.amountPaid / _this.jobblers[i].jobble.numberOfPayment;
	            _this.jobblers[i].paymentToshiftHasBeenMade = true;
	            _this.markJobbleAsReadyForAdditionalPaymentsCancel(_this.jobblers[i]);
	            _this.jobblers[i].paymentTotalTransactions = _this.jobblers[i].paymentTotalTransactions + 1;
	
	            for (var x = 0; x < _this.jobblers[i].jobble.shifts.length; x++) {
	              ////console.log('each shift?');
	              ////console.dir(_this.jobblers[i].jobble.shifts[x]);
	              ////console.dir(_this.shift_for_payment);
	
	              if (_this.jobblers[i].jobble.shifts[x].id === _this.shift_for_payment.id) {
	                ////console.log('we match shifts');
	                ////console.dir(totalCharge);
	                ////console.dir(_this.jobblers[i].jobble.shifts[x].paymentStats.number + 1);
	                _this.jobblers[i].jobble.shifts[x].paymentStats.number = _this.jobblers[i].jobble.shifts[x].paymentStats.number + 1;
	                _this.jobblers[i].jobble.shifts[x].paymentStats.amount = totalCharge;
	                break;
	              }
	            }
	          }
	        }
	      } finally {
	        _this.sourcingPostTotals(_this.jobblers);
	      }
	    }
	  }, {
	    key: "payJobblerValidationAmount",
	    value: function payJobblerValidationAmount(isValid) {
	      var _this = this;
	      ////.log('payJobblerValidationAmount');
	      ////.dir(isValid);
	    }
	  }, {
	    key: "goToHistory",
	    value: function goToHistory() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        _this.$state.go("jobsdashboard", {});
	      }, 300);
	    }
	  }, {
	    key: "amountChange",
	    value: function amountChange() {
	      var _this = this;
	
	      ////console.log('amount change???');
	      ////console.dir(_this.isDirectPayDisabled);
	
	      if ((_this.directPayHours > 0 || _this.directPayMinutes > 0) && (_this.directPayAmount === null || _this.directPayAmount === 0)) {
	        if (_this.creditCardsForCompany.value !== "Payment Method") {
	          _this.isDirectPayDisabled = false;
	          _this.directPayErrorMessage = null;
	        }
	      } else {
	        if ((_this.directPayHours > 0 || _this.directPayMinutes > 0) && _this.directPayAmount > 0) {
	          _this.isDirectPayDisabled = true;
	          _this.directPayErrorMessage = "You have attempted to pay by shift information and also by amount. Please choose between either paying between shift or by amount.";
	        } else {
	          if (_this.directPayAmount > 0) {
	            _this.directPayErrorMessage = null;
	            if (_this.creditCardsForCompany.value !== "Payment Method") {
	              _this.isDirectPayDisabled = false;
	              _this.directPayErrorMessage = null;
	            } else {}
	          } else {
	            if (_this.directPayAmount !== 0 && _this.directPayAmount !== null && !_angular2.default.isUndefined(_this.directPayAmount)) {
	              _this.isDirectPayDisabled = true;
	              _this.directPayErrorMessage = "Please enter an amount that is more than $10.00";
	            } else {
	              _this.directPayAmount = null;
	              _this.directPayErrorMessage = null;
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: "generateCardsArray",
	    value: function generateCardsArray() {
	      var _this = this;
	      var credCardArray = [];
	      var pay_obj_array = [];
	
	      if (!_this.creditCards) {
	        _this.creditCards = [];
	      }
	
	      if (_this.creditCards.length === 0 && _this.currentUser.company.payByInvoice !== true) {
	        _this.isDirectPayDisabledNew = true;
	      } else {
	        _this.isDirectPayDisabledNew = false;
	      }
	      try {
	        _this.creditCards.forEach(function (card) {
	          var card_obj = {};
	          if (card.bankName) {
	            card_obj.is_bank = true;
	            card_obj.token = card.stripeId;
	          } else {
	            card_obj.is_bank = false;
	            card_obj.token = card.cardToken;
	          }
	          card_obj.id = card.id;
	          card_obj.last4edited = "************-" + card.last4;
	          pay_obj_array.push(card_obj);
	        });
	      } finally {
	        if (!_this.$rootScope.defaultCard) {
	          _this.$rootScope.defaultCard = {};
	          _this.$rootScope.defaultCard = pay_obj_array[0];
	        }
	        _this.creditCardsForCompany = {
	          value: _this.$rootScope.defaultCard,
	          values: pay_obj_array
	        };
	      }
	    }
	  }, {
	    key: "goToTransHist",
	    value: function goToTransHist() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        jQuery("#direct-pay-on-complete .modal-header button.close").trigger("click");
	      });
	
	      _this.$timeout(function () {
	        _this.$state.go("transactionhistory");
	      }, 300);
	    }
	  }, {
	    key: "sourcingPostTotals",
	    value: function sourcingPostTotals(applications) {
	      var _this = this;
	
	      _this.totalsForSourcingPostNumberOfPayment = 0;
	      _this.totalsForSourcingPostAmountPaid = 0;
	      _this.totalsForSourcingPostAverageAmount = 0;
	
	      try {
	        applications.forEach(function (application) {
	          _this.totalsForSourcingPostNumberOfPayment = _this.totalsForSourcingPostNumberOfPayment + application.jobble.numberOfPayment;
	          _this.totalsForSourcingPostAmountPaid = _this.totalsForSourcingPostAmountPaid + application.jobble.amountPaid;
	        });
	      } finally {
	        if (_this.totalsForSourcingPostAmountPaid === 0 && _this.totalsForSourcingPostNumberOfPayment === 0) {
	          _this.totalsForSourcingPostAverageAmount = 0;
	        } else {
	          _this.totalsForSourcingPostAverageAmount = _this.totalsForSourcingPostAmountPaid / _this.totalsForSourcingPostNumberOfPayment;
	        }
	      }
	    }
	  }, {
	    key: "enterPressedHours",
	    value: function enterPressedHours(shift) {
	      var _this = this;
	
	      shift.isBeingEdited = undefined;
	      shift.isBeingEditedMinutes = undefined;
	
	      _this.updateActualMinutesWorked("hours", _this.hoursValueForEditedShift, shift.shiftDurationInHours, shift);
	    }
	  }, {
	    key: "enterPressedMin",
	    value: function enterPressedMin(shift) {
	      var _this = this;
	
	      shift.isBeingEdited = undefined;
	      shift.isBeingEditedMinutes = undefined;
	      ////////console.log('enterPressedMin');
	      ////////console.dir(_this.minValueForEditedShift);
	      if (_angular2.default.isUndefined(_this.minValueForEditedShift)) {
	        alert("Please enter minutes in intervals of 15");
	        return;
	      }
	
	      _this.remain_loading_count++;
	
	      _this.updateActualMinutesWorked("mins", _this.minValueForEditedShift, shift.shiftDurationInMinutes, shift);
	    }
	  }, {
	    key: "inlineEditShift",
	    value: function inlineEditShift(type, shift, shifts) {
	      var _this = this;
	
	      if (!shift.noShow) {
	        if (shift.paymentStats.number === 0) {
	          shifts.forEach(function (sh) {
	            if (sh.id !== shift.id) {
	              sh.isBeingEditedMinutes = undefined;
	              sh.isBeingEdited = undefined;
	              shift.autofocusminutes = undefined;
	              shift.autofocushours = undefined;
	              shift.focusClass = undefined;
	            }
	          });
	
	          if (type === "hours") {
	            shift.isBeingEdited = true;
	            shift.isBeingEditedMinutes = undefined;
	            _this.hoursValueForEditedShift = shift.shiftDurationInHours;
	            shift.focusClass = "has-focus";
	            _this.$timeout(function () {
	              jQuery("#modal-edit-shifts .modal-body .has-focus").focus();
	            });
	          } else {
	            shift.isBeingEdited = undefined;
	            shift.isBeingEditedMinutes = true;
	            _this.minValueForEditedShift = shift.shiftDurationInMinutes;
	            shift.focusClass = "has-focus";
	            _this.$timeout(function () {
	              jQuery("#modal-edit-shifts .modal-body .has-focus").focus();
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: "inlineEditShiftJob",
	    value: function inlineEditShiftJob(type, job) {
	      var _this = this;
	
	      if (type === "minutes") {
	        job.isBeingEditedMinutes = true;
	        job.isBeingEdited = undefined;
	        job.focusClass = "has-focus-job";
	
	        _this.$timeout(function () {
	          jQuery("#modal-edit-shifts .modal-body .has-focus-job").focus();
	        });
	      } else {
	        job.isBeingEditedMinutes = undefined;
	        job.isBeingEdited = true;
	        job.focusClass = "has-focus-job";
	
	        _this.$timeout(function () {
	          jQuery("#modal-edit-shifts .modal-body .has-focus-job").focus();
	        });
	      }
	    }
	  }, {
	    key: "jobFocus",
	    value: function jobFocus(job) {
	      var _this = this;
	    }
	  }, {
	    key: "hourChange",
	    value: function hourChange() {
	      var _this = this;
	    }
	  }, {
	    key: "minuteChange",
	    value: function minuteChange() {
	      var _this = this;
	    }
	  }, {
	    key: "jobBlur",
	    value: function jobBlur(job, type) {
	      var _this = this;
	
	      if (type === "mins") {
	        job.isBeingEditedMinutes = undefined;
	        _this.storeMinutesForDBCall(job);
	        job.durationInMinutesForJob = _this.minutePreview;
	      } else {
	        job.isBeingEdited = undefined;
	        _this.storeHoursForDBCall(job);
	        job.durationInHoursForJob = _this.hourPreview;
	      }
	    }
	  }, {
	    key: "shiftFocus",
	    value: function shiftFocus(shift, type) {
	      var _this = this;
	    }
	  }, {
	    key: "shiftBlur",
	    value: function shiftBlur(shift, type) {
	      var _this = this;
	
	      if (type === "mins") {
	        ////////console.log('in mins');
	
	        shift.isBeingEditedMinutes = undefined;
	        _this.updateActualMinutesWorked(type, _this.minValueForEditedShift, shift.durationInMinutes, shift);
	        shift.durationInMinutes = _this.minValueForEditedShift;
	      } else {
	        shift.isBeingEdited = undefined;
	        _this.updateActualMinutesWorked(type, _this.hoursValueForEditedShift, shift.shiftDurationInHours, shift);
	        shift.shiftDurationInHours = _this.hoursValueForEditedShift;
	      }
	    }
	  }, {
	    key: "toggleKey",
	    value: function toggleKey() {
	      var _this = this;
	      if (_this.userHasQuestions) {
	        _this.userHasQuestions = false;
	        _this.$timeout(function () {
	          jQuery("#modal-jobble-shift .modal-body .jobble-shift .key-wrapper").hide("slow");
	        });
	      } else {
	        _this.userHasQuestions = true;
	        _this.$timeout(function () {
	          jQuery("#modal-jobble-shift .modal-body .jobble-shift .key-wrapper").show("slow");
	        });
	      }
	    }
	  }, {
	    key: "markJobblerAsNoShowForJob",
	    value: function markJobblerAsNoShowForJob() {
	      //////////console.log('how many times am i getting called');
	      //////////console.log('markJobblerAsNoShowForJob');
	
	      var _this = this;
	
	      _this.remain_loading_count = 1;
	
	      _this.$timeout(function () {
	        ////////console.log('right before setting loader');
	        _this.$rootScope.$emit("SetLoaderDialog", { type: 1, total: 1 });
	      });
	
	      _this.$security.markJobblerAsNoShowTrimmed(_this.infoForDisplay).then(function (response) {
	        _this.remain_loading_count--;
	
	        _this.jobblers.some(function (elem) {
	          if (elem.jobble.id === response.data.id) {
	            elem.noShowClass = "no-show-jobbler";
	            elem.jobble.paidOutClass = "jobbler-is-no-show";
	            elem.jobble.hoursForShow = 0;
	            elem.jobble.minutesForShow = 0;
	            elem.ratingValue = 1;
	            _this.minutePreview = 0;
	            _this.hourPreview = 0;
	            elem.jobble.noShow = true;
	
	            ////////console.log('what is the elem after we match?');
	            ////////console.dir(elem);
	          }
	        });
	      }, function (data) {
	        _this.remain_loading_count--;
	
	        alert("There appears to be an error marking this jobbler as a no show. Please refresh your page to view updated information.");
	      });
	    }
	  }, {
	    key: "markJobblerAsNoShowForJobCancel",
	    value: function markJobblerAsNoShowForJobCancel() {
	      var _this = this;
	
	      var momentETT = moment(_this.infoForDisplay.jobble.endTime);
	      var momentSTT = moment(_this.infoForDisplay.jobble.startTime);
	
	      _this.remain_loading_count++;
	      _this.infoForDisplay.jobble.actualMinutesWorked = _this.infoForDisplay.jobble.jobbleDurationInMinutes;
	      _this.infoForDisplay.jobble.actualRevenue = _this.infoForDisplay.jobble.actualMinutesWorked * _this.infoForDisplay.jobble.payPerHour / 60;
	      _this.$security.markJobblerAsNoShowCancel(_this.infoForDisplay).then(function (response) {
	        _this.jobblers.some(function (elem) {
	          if (elem.jobble.id === response.data.id) {
	            elem.jobble.paidOutClass = "";
	            elem.jobble.noShow = null;
	            elem.noShowClass = null;
	            elem.ratingValue = 5;
	            var momentET = moment(response.data.endTime);
	            var momentST = moment(response.data.startTime);
	            elem.jobble.actualMinutesWorked = response.data.jobbleDurationInMinutes;
	            elem.jobble.actualRevenue = elem.jobble.actualMinutesWorked * elem.jobble.payPerHour / 60;
	            //elem.jobble.no_show_cancelled = true;
	            var timeObj = _this.figureOutTheTime(response.data.jobbleDurationInMinutes);
	            _this.minutePreview = timeObj.minutes;
	            _this.hourPreview = timeObj.hours;
	          }
	          _this.$timeout(function () {
	            _this.remain_loading_count = 0;
	          }, 300);
	        });
	      }, function (data) {
	        _this.remain_loading_count--;
	
	        alert("There appears to be an error marking this jobbler as a no show. Please refresh your page to view updated information.");
	      });
	    }
	  }, {
	    key: "markJobblerShowShowForShift",
	    value: function markJobblerShowShowForShift(shift, value, aligningJobbleAndShift, fromMainPage, jobble) {
	      var _this = this;
	
	      _this.remain_loading_count++;
	
	      console.log("markJobblerShowShowForShift");
	      console.dir(_this.infoForDisplay);
	      console.dir(shift);
	      console.dir(value);
	      console.log("aligningJobbleAndShift");
	      console.dir(aligningJobbleAndShift);
	      console.dir(jobble);
	      console.log("from Main page");
	      console.dir(fromMainPage);
	
	      if (_this.infoForDisplay.jobble.shifts.length === 1) {
	        aligningJobbleAndShift = true;
	      } else {
	        aligningJobbleAndShift = false;
	      }
	
	      if (value) {
	        shift.noShow = true;
	        shift.paidOutClass = "jobbler-is-no-show";
	        shift.shiftDurationInHours = 0;
	        shift.shiftDurationInMinutes = 0;
	
	        if (shift.actualMinutesWorked && shift.actualMinutesWorked !== 0) {
	          //_this.infoForDisplay.jobble.jobbleDurationInMinutes = _this.infoForDisplay.jobble.jobbleDurationInMinutes - shift.actualMinutesWorked;
	          _this.infoForDisplay.jobble.actualMinutesWorked = _this.infoForDisplay.jobble.actualMinutesWorked - shift.actualMinutesWorked;
	          _this.hourPreview = Math.floor(_this.infoForDisplay.jobble.actualMinutesWorked / 60);
	          _this.minutePreview = _this.infoForDisplay.jobble.actualMinutesWorked % 60;
	
	          if (!aligningJobbleAndShift) {
	            ////console.log('aligningJobbleAndShift should NOT BE HERE');
	            //_this.storeMinutesForDBCall(_this.infoForDisplay.jobble);
	          }
	
	          _this.$timeout(function () {
	            //_this.storeMinutesForDBCallShift(shift, 0);
	          }, 300);
	        } else {
	          var momentET = moment(shift.timeInterval.endTime);
	          var momentST = moment(shift.timeInterval.startTime);
	          var totalMinutes = momentET.diff(momentST, "minutes");
	          var hoursRounded = Math.floor(totalMinutes / 60);
	          var minutesRounded = totalMinutes % 60;
	          _this.infoForDisplay.jobble.jobbleDurationInMinutes = _this.infoForDisplay.jobble.jobbleDurationInMinutes - totalMinutes;
	          _this.infoForDisplay.jobble.actualMinutesWorked = _this.infoForDisplay.jobble.jobbleDurationInMinutes;
	          _this.hourPreview = Math.floor(_this.infoForDisplay.jobble.actualMinutesWorked / 60);
	          _this.minutePreview = _this.infoForDisplay.jobble.actualMinutesWorked % 60;
	
	          if (!aligningJobbleAndShift) {
	            ////console.log('aligningJobbleAndShift should NOT BE HERE 2');
	            //_this.storeMinutesForDBCall(_this.infoForDisplay.jobble);
	          }
	
	          _this.$timeout(function () {
	            //_this.storeMinutesForDBCallShift(shift, 0);
	          }, 1000);
	        }
	      } else {
	        //k0 here
	        shift.noShow = null;
	        var _momentET = moment(shift.timeInterval.endTime);
	        var _momentST = moment(shift.timeInterval.startTime);
	        var _totalMinutes = shift.shiftDurationInMinutes = _momentET.diff(_momentST, "minutes");
	        var _hoursRounded = Math.floor(_totalMinutes / 60);
	        //console.log("why are we adding these");
	        //console.dir(_this.infoForDisplay.jobble.jobbleDurationInMinutes);
	        //console.dir(totalMinutes);
	        if (_this.infoForDisplay.jobble.jobbleDurationInMinutes === 0) {
	          _this.infoForDisplay.jobble.jobbleDurationInMinutes = _this.infoForDisplay.jobble.jobbleDurationInMinutes + _totalMinutes;
	        }
	        _this.infoForDisplay.jobble.actualMinutesWorked = _this.infoForDisplay.jobble.actualMinutesWorked + _totalMinutes;
	        _this.hourPreview = _this.hourPreview + shift.shiftDurationInHours;
	        _this.minutePreview = _this.minutePreview % 60;
	        var fromFunc = true;
	        if (!fromMainPage) {
	          //_this.storeMinutesForDBCall(_this.infoForDisplay.jobble);
	        }
	        _this.$timeout(function () {
	          //_this.storeMinutesForDBCallShift(shift, totalMinutes, fromFunc);
	        }, 300);
	        if (shift.amountPaid) {
	          shift.paidOutClass = "success-payment-shifts";
	        } else {
	          shift.paidOutClass = "undefined";
	        }
	      }
	
	      _this.$timeout(function () {
	        var putNowShow = {
	          method: "PUT",
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + shift.id + "?format=json&conf=web&fields=id",
	
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + _this.currentUser.access_token
	          },
	
	          data: {
	            noShow: value,
	            actualMinutesWorked: 0
	          }
	        };
	
	        _this.$http(putNowShow).then(function (response) {
	          if (response.status === "error") {
	            alert("Error saving information");
	          } else {
	            if (_this.infoForDisplay.jobble.shifts.length === 1) {
	              _this.dataModelForNoShow = _this.infoForDisplay;
	              if (value && !aligningJobbleAndShift) {
	                _this.markJobblerAsANoShowFromMainPageCancel();
	              } else {
	                if (!fromMainPage) {
	                  _this.markJobblerAsANoShowFromMainPage();
	                  _this.infoForDisplay.outstandingTotalsData.hours = 0;
	                  _this.infoForDisplay.outstandingTotalsData.minutes = 0;
	                  _this.infoForDisplay.outstandingTotalsData.monies = 0;
	                }
	              }
	            }
	          }
	
	          _this.$timeout(function () {
	            _this.remain_loading_count = 0;
	          }, 500);
	        }, function (data) {
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	        });
	      }, 1300);
	    }
	  }, {
	    key: "addUpShiftHours",
	    value: function addUpShiftHours() {
	      var _this = this;
	      var minuteHolder = 0;
	
	      try {
	        _this.infoForDisplay.jobble.shifts.forEach(function (s) {
	          ////.log('if they are no show?');
	          ////.dir(s);
	          if (!s.noShow) {
	            if (s.actualMinutesWorked) {
	              minuteHolder = minuteHolder + s.actualMinutesWorked;
	              ////.log('what is the minute holder');
	              ////.dir(minuteHolder);
	              s.shiftDurationInHours = Math.floor(s.actualMinutesWorked / 60);
	              s.shiftDurationInMinutes = s.actualMinutesWorked % 60;
	            } else {
	              ////.log('what is s');
	              ////.dir(s);
	              var momentET = moment(s.timeInterval.endTime);
	              var momentST = moment(s.timeInterval.startTime);
	              var totalMinutes = momentET.diff(momentST, "minutes");
	              ////.log('total minutes?');
	              ////.dir(totalMinutes);
	              minuteHolder = minuteHolder + totalMinutes;
	            }
	          }
	        });
	      } finally {
	        //var hoursRounded = Math.floor(minuteHolder / 60);
	        //_this.hourPreview = hoursRounded;
	        //_this.minutePreview = minuteHolder % 60;
	      }
	    }
	  }, {
	    key: "toggleShiftTable",
	    value: function toggleShiftTable() {
	      var _this = this;
	
	      _this.addUpShiftHours();
	
	      if (_this.userWantsShifts) {
	        _this.userWantsShifts = false;
	        _this.editByShift = false;
	        _this.$timeout(function () {
	          jQuery("#modal-jobble-shift .modal-body .jobble-shift .shift-table-rows").hide("slow");
	        });
	      } else {
	        _this.userWantsShifts = true;
	        _this.editByShift = true;
	        _this.$timeout(function () {
	          jQuery("#modal-jobble-shift .modal-body .jobble-shift .shift-table-rows").show("slow");
	        });
	      }
	    }
	  }, {
	    key: "storeMinutesForDBCall",
	    value: function storeMinutesForDBCall(job) {
	      var _this = this;
	
	      job.isBeingEditedMinutes = undefined;
	
	      if (_this.minutePreview > 59 || _angular2.default.isUndefined(_this.minutePreview)) {
	        alert("Please enter minutes in intervals of 15");
	        //_this.minutePreview = 0;
	        return;
	      }
	
	      job.actualMinutesWorked = _this.minutePreview + _this.hourPreview * 60;
	      job.actualRevenue = job.actualMinutesWorked * job.payPerHour / 60;
	
	      _this.showLoaderFunc(2);
	
	      ////console.log('right before putting the actual minutes worked trimmed');
	      ////console.dir(job);
	
	      _this.$security.putActualMinutesWorkedTrimmed(job.id, job.actualMinutesWorked, job.actualRevenue).then(function (response) {
	        try {
	          _this.jobblers.some(function (elem) {
	            if (elem.jobble.id === job.id) {
	              ////console.log('do we ever get a match?');
	              ////console.dir(response.data);
	              ////console.dir(response.data.actualMinutesWorked);
	              ////console.dir(response.data.actualMinutesWorked % 60);
	              ////console.dir(Math.floor(response.data.actualMinutesWorked / 60));
	
	              elem.jobble.actualMinutesWorked = response.data.actualMinutesWorked;
	              elem.jobbleDurationData.minutes = response.data.actualMinutesWorked % 60;
	              elem.jobbleDurationData.hours = Math.floor(response.data.actualMinutesWorked / 60);
	
	              if (_this.infoForDisplay.outstandingTotalsData) {
	                _this.infoForDisplay.outstandingTotalsData.hours = elem.jobbleDurationData.hours;
	                _this.infoForDisplay.outstandingTotalsData.minutes = elem.jobbleDurationData.minutes;
	              }
	
	              elem.jobble.totalCalculated = job.actualRevenue / 100;
	              elem.showActualMinutesWorked = true;
	            }
	          });
	        } finally {
	          _this.showLoaderFunc(2);
	        }
	      });
	    }
	  }, {
	    key: "storeHoursForDBCall",
	    value: function storeHoursForDBCall(job, fromMainPage) {
	      var _this = this;
	
	      _this.showLoaderFunc(1);
	
	      var jobArg = {};
	
	      if (fromMainPage) {
	        job.jobble.durationInHoursForJob = job.jobbleDurationData.hours;
	        job.jobble.actualMinutesWorked = job.jobbleDurationData.minutes + job.jobbleDurationData.hours * 60;
	        job.actualMinutesWorked = job.jobbleDurationData.minutes + job.jobbleDurationData.hours * 60;
	        job.actualRevenue = job.jobble.actualMinutesWorked * job.jobble.payPerHour / 60;
	        job.jobble.actualRevenue = job.jobble.actualMinutesWorked * job.jobble.payPerHour / 60;
	        job.jobble.totalCalculated = job.jobble.actualMinutesWorked * job.jobble.payPerHour / 60 / 100;
	        jobArg.id = job.jobble.id;
	        jobArg.actualMinutesWorked = job.jobble.actualMinutesWorked;
	      } else {
	        job.isBeingEdited = undefined;
	        job.durationInHoursForJob = _this.hourPreview;
	        job.actualMinutesWorked = _this.minutePreview + _this.hourPreview * 60;
	        job.actualRevenue = job.actualMinutesWorked * job.payPerHour / 60;
	        jobArg.id = job.id;
	        jobArg.actualMinutesWorked = job.actualMinutesWorked;
	      }
	
	      _this.$security.putActualMinutesWorkedTrimmed(jobArg.id, jobArg.actualMinutesWorked).then(function (response) {
	        ////console.log('what is the job');
	        ////console.dir(job);
	        ////console.dir(fromMainPage);
	
	        if (!fromMainPage) {
	          ////console.log('so we come here')
	
	          _this.jobblers.some(function (elem) {
	            ////////console.dir('what is this number');
	            ////////console.dir(job.actualRevenue);
	            if (elem.jobble.id === job.id) {
	              ////console.log('we have a match here');
	              ////console.dir(elem);
	
	              elem.jobbleDurationData.minutes = response.data.actualMinutesWorked % 60;
	              elem.jobbleDurationData.hours = Math.floor(response.data.actualMinutesWorked / 60);
	              elem.jobble.actualMinutesWorked = response.data.actualMinutesWorked;
	              elem.jobble.totalCalculated = job.actualRevenue / 100;
	              elem.showActualMinutesWorked = true;
	
	              _this.calcOutstandingHours(elem);
	              _this.showLoaderFunc(1);
	            }
	          });
	        } else {
	          if (job.shift_count === 1) {
	            ////console.log('whats the shift count?');
	            _this.updateSingleShift(job);
	          }
	        }
	      }, function (error) {
	        //////console.log('handle error on storing minutes from jobble');
	        //////console.dir(error);
	      });
	    }
	  }, {
	    key: "storeMinutesForDBCallShift",
	    value: function storeMinutesForDBCallShift(shift, newMinutes, fromFunc) {
	      var _this = this;
	
	      ////console.log('-----------------storeMinutesForDBCallShift----------------------');
	      ////console.dir(shift);
	      ////console.dir(newMinutes);
	      ////console.dir(fromFunc);
	
	      if (!fromFunc) {
	        ////////console.log('from func');
	        if (newMinutes > 59 || _angular2.default.isUndefined(newMinutes)) {
	          //////////console.log('in if');
	          alert("Please enter minutes in intervals of 15");
	          //shift.durationInMinutes = 0;
	          return;
	        }
	      }
	
	      var totalMinutes = shift.shiftDurationInHours * 60 + newMinutes;
	
	      shift.actualMinutesWorked = totalMinutes;
	
	      _this.$security.putActualMinutesWorkedForShiftTrimmed(shift.id, totalMinutes).then(function (response) {
	        _this.infoForDisplay.jobble.shifts.some(function (elem) {
	          if (elem.id === shift.id) {
	            ////console.log('putActualMinutesWorkedForShiftTrimmed we found a match');
	
	            elem.actualMinutesWorked = response.data.actualMinutesWorked;
	            elem.shiftDurationInMinutes = response.data.actualMinutesWorked % 60;
	            elem.shiftDurationInHours = Math.floor(response.data.actualMinutesWorked / 60);
	
	            _this.addUpMinutesAndHours(_this.infoForDisplay);
	          }
	        });
	      });
	    }
	  }, {
	    key: "addUpMinutesAndHours",
	    value: function addUpMinutesAndHours(info) {
	      var _this = this;
	
	      info.jobble.actualMinutesWorked = 0;
	
	      ////console.log('do we do this?');
	
	      try {
	        info.jobble.shifts.some(function (elem) {
	          if (elem.actualMinutesWorked === null) {
	            var hoursToMin = elem.shiftDurationInHours * 60;
	            var mins = elem.shiftDurationInMinutes;
	            var totalMins = hoursToMin + mins;
	
	            info.jobble.actualMinutesWorked = info.jobble.actualMinutesWorked + totalMins;
	          } else {
	            info.jobble.actualMinutesWorked = info.jobble.actualMinutesWorked + elem.actualMinutesWorked;
	          }
	        });
	      } finally {
	        ////console.log('whats going here...');
	        ////console.dir(_this.infoForDisplay.jobble.actualMinutesWorked);
	        ////console.dir(_this.infoForDisplay.jobble.actualMinutesWorked / 60);
	
	        _this.hourPreview = Math.floor(_this.infoForDisplay.jobble.actualMinutesWorked / 60);
	        _this.minutePreview = _this.infoForDisplay.jobble.actualMinutesWorked % 60;
	
	        _this.$timeout(function () {
	          _this.remain_loading_count = 0;
	        }, 300);
	      }
	    }
	  }, {
	    key: "updateSingleShift",
	    value: function updateSingleShift(application) {
	      var _this = this;
	
	      ////console.log('updating single shift');
	      ////console.dir(application);
	
	      var newActualMinutesWorked = application.jobble.actualMinutesWorked;
	
	      _this.storeHoursForDBCallShift(application.jobble.shifts[0], newActualMinutesWorked, true);
	
	      //_this.storeHoursForDBCallShift()
	      //storeHoursForDBCallShift(shift, newHours, updatingFromMainPage)
	    }
	  }, {
	    key: "storeHoursForDBCallShift",
	    value: function storeHoursForDBCallShift(shift, newHours, updatingFromMainPage) {
	      var _this = this;
	
	      var totalMinutes = 0;
	
	      if (updatingFromMainPage) {
	        totalMinutes = newHours;
	      } else {
	        totalMinutes = newHours * 60 + shift.shiftDurationInMinutes;
	      }
	
	      shift.actualMinutesWorked = totalMinutes;
	
	      _this.$security.putActualMinutesWorkedForShiftTrimmed(shift.id, totalMinutes).then(function (response) {
	        if (!updatingFromMainPage) {
	          _this.infoForDisplay.jobble.shifts.some(function (elem) {
	            if (elem.id === shift.id) {
	              elem.actualMinutesWorked = response.data.actualMinutesWorked;
	              elem.shiftDurationInHours = Math.floor(response.data.actualMinutesWorked / 60);
	              elem.shiftDurationInMinutes = response.data.actualMinutesWorked % 60;
	
	              _this.calculateTotalsForDisplay();
	              _this.remain_loading_count = 0;
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: "updateActualMinutesWorked",
	    value: function updateActualMinutesWorked(type, newVal, oldVal, shift) {
	      var _this = this;
	
	      var total = 0;
	
	      _this.remain_loading_count = 1;
	
	      if (type === "hours") {
	        try {
	          _this.infoForDisplay.jobble.shifts.forEach(function (s) {
	            var hoursToMin = null;
	
	            if (s.id === shift.id) {
	              hoursToMin = newVal * 60;
	            } else {
	              hoursToMin = s.shiftDurationInHours * 60;
	            }
	
	            var min = s.shiftDurationInMinutes;
	            var totalMinutes = hoursToMin + min;
	
	            total = total + totalMinutes;
	          });
	        } finally {
	          _this.hourPreview = Math.floor(total / 60);
	          _this.minutePreview = total % 60;
	
	          _this.storeHoursForDBCall(_this.infoForDisplay.jobble);
	
	          _this.storeHoursForDBCallShift(shift, newVal);
	
	          /*
	          _this.$timeout(function(){
	          _this.remain_loading_count--;
	          },100)
	          */
	        }
	      }
	
	      if (type === "mins") {
	        try {
	          _this.infoForDisplay.jobble.shifts.forEach(function (s) {
	            var min = null;
	
	            if (s.id === shift.id) {
	              min = newVal;
	            } else {
	              min = s.shiftDurationInMinutes;
	            }
	
	            var hoursToMin = s.shiftDurationInHours * 60;
	            var totalMinutes = hoursToMin + min;
	
	            total = total + totalMinutes;
	          });
	        } finally {
	          ////////console.log('total minutes');
	          ////////console.dir(total);
	
	          _this.hourPreview = Math.floor(total / 60);
	          _this.minutePreview = total % 60;
	          _this.storeMinutesForDBCall(_this.infoForDisplay.jobble);
	          _this.storeMinutesForDBCallShift(shift, newVal);
	
	          /*
	          _this.$timeout(function(){
	          _this.remain_loading_count=1;
	          },500)
	          */
	        }
	      }
	
	      _this.$timeout(function () {
	        jQuery("#modal-jobble-shift table tbody .top-level").addClass("flash-success");
	      });
	
	      _this.$timeout(function () {
	        jQuery("#modal-jobble-shift table tbody .top-level").removeClass("flash-success");
	      }, 1000);
	    }
	  }, {
	    key: "organizePaymentInfo",
	    value: function organizePaymentInfo() {
	      var _this = this;
	
	      if (_this.paymentInfos) {
	        try {
	          ////////console.log('what is the payment info at this point');
	          ////////console.dir(_this.paymentInfos);
	
	          _this.paymentInfos.forEach(function (paymentInfo) {
	            if (paymentInfo.bankName) {
	              _this.banksArray.push(paymentInfo);
	            } else {
	              _this.cardsArray.push(paymentInfo);
	            }
	          });
	        } finally {
	          _this.cardsArray.forEach(function (paymentInfo) {
	            paymentInfo.cardExpirationDate = moment().month(parseInt(paymentInfo.cardExpirationMonth)).format("MM") + "/" + paymentInfo.cardExpirationYear;
	          });
	        }
	      }
	    }
	  }, {
	    key: "toggleCheckBox",
	    value: function toggleCheckBox() {
	      var _this = this;
	      ////.log('toggleCheckBox');
	      ////.dir(_this.editByShift);
	      /*
	      if (_this.editByShift) {
	      _this.userWantsShifts = false;
	      _this.$timeout(function(){
	      jQuery('#modal-jobble-shift .modal-body .jobble-shift .shift-table-rows').hide('slow');
	      })
	      } else {
	      _this.userWantsShifts = true;
	      _this.$timeout(function(){
	      jQuery('#modal-jobble-shift .modal-body .jobble-shift .shift-table-rows').show('slow');
	      })
	      }
	      */
	      /*
	      if (_this.userWantsShifts) {
	      _this.userWantsShifts = false;
	      _this.$timeout(function(){
	        jQuery('#modal-jobble-shift .modal-body .jobble-shift .shift-table-rows').hide('slow');
	       })
	      } else {
	      _this.userWantsShifts = true;
	      _this.$timeout(function(){
	      jQuery('#modal-jobble-shift .modal-body .jobble-shift .shift-table-rows').show('slow');
	      })
	      }
	      */
	    }
	  }, {
	    key: "totalAmountToBePaidOut",
	    value: function totalAmountToBePaidOut() {
	      //////console.log('totalAmountToBePaidOut');
	      ////console.log("totalAmountToBePaidOuttotalAmountToBePaidOuttotalAmountToBePaidOuttotalAmountToBePaidOut");
	      var _this = this;
	      var total = 0;
	      var totalMinutes = 0;
	      try {
	        _this.jobblers.forEach(function (application) {
	          ////console.dir(application);
	          ////console.dir(application.paymentToshiftHasBeenMade);
	          ////console.dir(application.isCheckedForAction);
	          if (!application.paymentToshiftHasBeenMade && application.isCheckedForAction) {
	            ////console.log("checkking no show");
	            if (!application.jobble.noShow) {
	              ////console.log("checking strike out class");
	              if (!application.strikeOutClass) {
	                ////console.log("one more check...");
	                if (_this.delivery) {
	                  ////console.log("whats the application in the delivery");
	                  ////console.dir(application);
	                  total = application.jobble.payPerHour;
	                } else {
	                  if (application.jobble.actualRevenue || application.jobble.actualRevenue === 0) {
	                    //console.log("in the first if........");
	                    //console.dir(application);
	                    totalMinutes = totalMinutes + application.jobble.actualMinutesWorked;
	                    total = total + application.jobble.actualRevenue;
	                  } else {
	                    //console.log("in the else....");
	                    //console.dir(application);
	                    total = total + application.jobble.costOfJobble;
	                    totalMinutes = totalMinutes + application.jobble.jobbleDurationInMinutes;
	                  }
	                }
	              }
	            }
	          }
	        });
	      } finally {
	        _this.totalMinutesWorkedForEntireJob = totalMinutes;
	        _this.totalHoursWorkedForEvent();
	        _this.totalMinutesWorkedForEvent();
	        _this.companyFeePct = total / 100 * _this.currentUser.company.defaultPlan.companyFeePct.toFixed(2);
	        _this.totalFromJobblers = (total / 100).toFixed(2);
	        _this.totalsCombined = total / 100 + _this.companyFeePct;
	        _this.totalsCombinedNew = numeral(_this.totalsCombined).format("$0,0.00");
	        var final_num = numeral(total / 100).format("$0,0.00");
	        return final_num;
	      }
	    }
	  }, {
	    key: "removeFromPayment",
	    value: function removeFromPayment(application) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        application.strikeOutClass = "strike-out-jobbler";
	      });
	
	      _this.totalAmountToBePaidOut();
	    }
	  }, {
	    key: "addTooPayment",
	    value: function addTooPayment(application) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        application.strikeOutClass = undefined;
	      });
	
	      _this.totalAmountToBePaidOut();
	    }
	  }, {
	    key: "dollarFocus",
	    value: function dollarFocus() {
	      var _this = this;
	      //.log('dollar focus');
	      //.dir(_this.directPayAmount);
	      if (_this.directPayAmount === 0) {
	        _this.directPayAmount = null;
	      }
	    }
	  }, {
	    key: "totalHours",
	    value: function totalHours() {
	      var _this = this;
	
	      var total = 0;
	
	      try {
	        _this.infoForDisplay.jobble.shifts.forEach(function (shift) {
	          if (shift.actualMinutesWorked !== null) {
	            ////.log('we have been edited');
	            ////.dir(jobble.actualMinutesWorked);
	            ////.dir(Math.floor(jobble.actualMinutesWorked / 60));
	
	            total = total + shift.actualMinutesWorked;
	            //var min = jobble.actualMinutesWorked % 60;
	          } else {
	            ////.log('we have NOT been edited');
	            var diffinmin = moment(shift.timeInterval.endTime).diff(moment(shift.timeInterval.startTime), "minutes");
	            ////.dir(diffinmin);
	            total = total + diffinmin;
	
	            //var min = diffinmin & 60;
	          }
	        });
	      } finally {
	        ////.log('do we make it to finally 1');
	        ////.dir(total);
	        var hrs = Math.floor(total / 60);
	        ////.dir(hrs);
	
	        return hrs;
	      }
	    }
	  }, {
	    key: "totalMinutes",
	    value: function totalMinutes() {
	      var _this = this;
	
	      var total = 0;
	
	      try {
	        _this.infoForDisplay.jobble.shifts.forEach(function (shift) {
	          ////.log('shift');
	          ////.dir(shift);
	
	          if (shift.actualMinutesWorked !== null) {
	            ////.log('we have been edited');
	            ////.dir(jobble.actualMinutesWorked);
	            ////.dir(Math.floor(jobble.actualMinutesWorked / 60));
	
	            total = total + shift.actualMinutesWorked;
	            //var min = jobble.actualMinutesWorked % 60;
	          } else {
	            ////.log('we have NOT been edited');
	            var diffinmin = moment(shift.timeInterval.endTime).diff(moment(shift.timeInterval.startTime), "minutes");
	            //.dir(diffinmin);
	            total = total + diffinmin;
	
	            //var min = diffinmin & 60;
	          }
	        });
	      } finally {
	        ////.log('do we make it to finally 2');
	
	        var hourstotal = Math.floor(total / 60);
	
	        var minforsub = hourstotal * 60;
	        var mins = total - minforsub;
	        ////.dir(hourstotal);
	        ////.dir(minforsub);
	        ////.dir(total);
	        ////.dir(mins);
	        return mins;
	      }
	    }
	  }, {
	    key: "showLoaderFunc",
	    value: function showLoaderFunc(type) {
	      var _this = this;
	
	      if (type === 1) {
	        //////////console.log('total hour loader');
	        //////////console.dir(_this.totalHourLoader);
	        if (_this.totalHourLoader) {
	          //////////console.log('total hour loader 1');
	          _this.totalHourLoader = false;
	        } else {
	          //////////console.log('total hour loader 3');
	          _this.totalHourLoader = true;
	        }
	      }
	
	      if (type === 2) {
	        //////////console.log('total min loader');
	        //////////console.dir(_this.totalMinLoader);
	
	        if (_this.totalMinLoader) {
	          //////////console.log('total min loader1');
	          _this.totalMinLoader = false;
	        } else {
	          //////////console.log('total min loader2');
	          _this.totalMinLoader = true;
	        }
	      }
	    }
	  }, {
	    key: "showLeadingZero",
	    value: function showLeadingZero(n) {
	      return n < 10 ? "0" + n : n;
	    }
	  }, {
	    key: "formatCheckInAddress",
	    value: function formatCheckInAddress(address, time) {
	      if ((address === null || !address) && (time === null || !time)) {
	        return "User did not check in";
	      } else {
	        if ((address === null || !address) && (time !== null || time)) {
	          return "The user checked in at an address that was not recognized";
	        } else {
	          return address;
	        }
	      }
	    }
	  }, {
	    key: "formatCheckOutAddress",
	    value: function formatCheckOutAddress(address, time) {
	      if ((address === null || !address) && (time === null || !time)) {
	        return "User did not check out";
	      } else {
	        if ((address === null || !address) && (time !== null || time)) {
	          return "The user checked in at an address that was not recognized";
	        } else {
	          return address;
	        }
	      }
	    }
	  }, {
	    key: "formatCheckInTime",
	    value: function formatCheckInTime(input) {
	      if (input === null || !input) {
	        return "--";
	      } else {
	        return input;
	      }
	    }
	  }, {
	    key: "formatCheckOutTime",
	    value: function formatCheckOutTime(input) {
	      if (input === null || !input) {
	        return "--";
	      } else {
	        return input;
	      }
	    }
	  }, {
	    key: "differenceInHours",
	    value: function differenceInHours(start, end) {
	      return this.$common.differenceInHours(start, end);
	    }
	  }, {
	    key: "differenceInMinutes",
	    value: function differenceInMinutes(start, end) {
	      return this.$common.differenceInMinutes(start, end);
	    }
	  }, {
	    key: "calcTimeWorked",
	    value: function calcTimeWorked(application) {
	      var _this = this;
	      if (application.jobble.actualMinutesWorked || application.jobble.actualMinutesWorked === 0) {
	        _this.setMinutesWorked(application);
	        _this.totalMinutesWorkedForEntireJob = _this.totalMinutesWorkedForEntireJob + application.jobble.actualMinutesWorked;
	      } else {
	        _this.setJobbleDuration(application);
	        _this.totalMinutesWorkedForEntireJob = _this.totalMinutesWorkedForEntireJob + application.jobble.jobbleDurationInMinutes;
	      }
	      _this.calculateActualData(application);
	    }
	  }, {
	    key: "calculateActualData",
	    value: function calculateActualData(application) {
	      var _this = this;
	
	      application.jobbleDurationData = {};
	
	      if (application.paymentToshiftHasBeenMade) {
	        application.jobble.actualMinutesWorked = 0;
	        application.jobbleDurationData.hours = 0;
	        application.jobbleDurationData.minutes = 0;
	        application.jobble.totalCalculated = 0;
	      } else if (application.jobble.noShow) {
	        application.jobbleDurationData.hours = 0;
	        application.jobbleDurationData.minutes = 0;
	        application.jobble.totalCalculated = 0;
	      } else if (application.jobble.actualMinutesWorked) {
	        var div = application.jobble.actualMinutesWorked / 60;
	        application.jobbleDurationData.hours = Math.floor(div);
	        application.jobbleDurationData.minutes = application.jobble.actualMinutesWorked % 60;
	        _this.calcData = _this.calcData + application.jobble.actualMinutesWorked;
	      } else {
	        ////console.log('***dimitry here');
	        ////console.dir(application.jobble.jobbleDurationInMinutes);
	        var _div = application.jobble.jobbleDurationInMinutes / 60;
	        application.jobbleDurationData.hours = Math.floor(_div);
	        application.jobbleDurationData.minutes = application.jobble.jobbleDurationInMinutes % 60;
	        _this.calcData = _this.calcData + application.jobble.jobbleDurationInMinutes;
	      }
	
	      ////console.log('what is calc data');
	      ////console.dir(_this.calcData);
	    }
	  }, {
	    key: "setMinutesWorked",
	    value: function setMinutesWorked(application) {
	      var _this = this;
	
	      var div = null;
	
	      if (application.jobble.actualMinutesWorked) {
	        div = application.jobble.actualMinutesWorked / 60;
	        application.jobble.hoursForShow = Math.floor(div);
	        application.jobble.minutesForShow = application.jobble.actualMinutesWorked % 60;
	      } else {
	        div = application.jobble.jobbleDurationInMinutes / 60;
	        application.jobble.hoursForShow = Math.floor(div);
	        application.jobble.minutesForShow = application.jobble.jobbleDurationInMinutes % 60;
	      }
	
	      _this.totalForIndividual(application, 1);
	    }
	  }, {
	    key: "setJobbleDuration",
	    value: function setJobbleDuration(application) {
	      var _this = this;
	      var div = null;
	
	      if (application.jobble.actualMinutesWorked) {
	        div = application.jobble.actualMinutesWorked / 60;
	        application.jobble.hoursForShow = Math.floor(div);
	        application.jobble.minutesForShow = application.jobble.actualMinutesWorked % 60;
	      } else {
	        div = application.jobble.jobbleDurationInMinutes / 60;
	        application.jobble.hoursForShow = Math.floor(div);
	        application.jobble.minutesForShow = application.jobble.jobbleDurationInMinutes % 60;
	      }
	
	      ////////console.log('application.jobble.minutesForShow');
	      ////////console.dir(application.jobble.minutesForShow);
	
	      _this.totalForIndividual(application, 2);
	    }
	  }, {
	    key: "totalForIndividual",
	    value: function totalForIndividual(application, status) {
	      var _this = this;
	
	      switch (status) {
	        case 1:
	          _this.setTotalForActualMinutesWorked(application);
	          break;
	        case 2:
	          _this.setTotalForJobbleDuration(application);
	          break;
	      }
	    }
	  }, {
	    key: "setTotalForActualMinutesWorked",
	    value: function setTotalForActualMinutesWorked(application) {
	      var _this = this;
	
	      ////////console.log('setTotalForActualMinutesWorkedsetTotalForActualMinutesWorked');
	      application.jobble.totalCalculated = application.jobble.actualRevenue / 100;
	    }
	  }, {
	    key: "setTotalForJobbleDuration",
	    value: function setTotalForJobbleDuration(application) {
	      var _this = this;
	
	      application.jobble.totalCalculated = application.jobble.costOfJobble / 100;
	    }
	  }, {
	    key: "totalHoursWorkedForEvent",
	    value: function totalHoursWorkedForEvent() {
	      var _this = this;
	
	      var div = _this.totalMinutesWorkedForEntireJob / 60;
	
	      return Math.floor(div);
	    }
	  }, {
	    key: "totalMinutesWorkedForEvent",
	    value: function totalMinutesWorkedForEvent() {
	      var _this = this;
	      //console.log("where is this set......");
	      //console.dir(_this.totalMinutesWorkedForEntireJob);
	
	      return _this.totalMinutesWorkedForEntireJob % 60;
	    }
	  }, {
	    key: "setRatingsToUI",
	    value: function setRatingsToUI(application, status) {
	      var _this = this;
	      //////////console.log('setRatingsToUI');
	      //////////console.dir(status);
	      application.ratingValue = status;
	    }
	  }, {
	    key: "writeReviewForJobbler",
	    value: function writeReviewForJobbler(application) {
	      var _this = this;
	      //////////console.log('writeReviewForJobbler');
	      //////////console.dir(application);
	
	      _this.$timeout(function () {
	        jQuery("#modal-add-review-jobbler-click").trigger("click");
	      }, 100);
	    }
	  }, {
	    key: "viewJobblerNote",
	    value: function viewJobblerNote() {
	      var _this = this;
	      //////////console.log('view jobbler note');
	    }
	  }, {
	    key: "loopShiftsForNote",
	    value: function loopShiftsForNote(application) {
	      var _this = this;
	      application.shift_count = 0;
	      application.noteCount = 0;
	
	      application.jobble.shifts.forEach(function (shift) {
	        application.shift_count = application.shift_count + 1;
	
	        if (shift.jobblerNote) {
	          application.noteCount = application.noteCount + 1;
	          application.hasNote = true;
	        }
	
	        if (shift.checkInTime || shift.checkOutTime || shift.autoCheckInTime || shift.autoCheckOutTime) {
	          application.hasLocationData = true;
	        }
	      });
	    }
	  }, {
	    key: "showMeTheNote",
	    value: function showMeTheNote(data, shift) {
	      var _this = this;
	      //////////console.log('showMeTheNote');
	      //////////console.dir(data);
	      //////////console.dir(shift);
	    }
	  }, {
	    key: "toggleTip",
	    value: function toggleTip(data, shift, index) {
	      //////////console.log('toggleTipOn');
	      var _this = this;
	
	      var id_index = index + 1;
	      var selector = "#hide-me-for-tool-tip-" + id_index + ".hide-me-shifts";
	
	      //////////console.log('what is the selector?');
	      //////////console.dir(selector)
	      //////////console.log('whats our jquery choices');
	      //////////console.dir(jQuery(selector));
	
	      if (shift.jobblerNote) {
	        _this.$timeout(function () {
	          jQuery(selector).show("slide", "fast");
	        }, 100);
	      }
	    }
	  }, {
	    key: "toggleTipOff",
	    value: function toggleTipOff(data, shift, index) {
	      //////////console.log('toggleTipOff');
	      var _this = this;
	      var _this = this;
	      var id_index = index + 1;
	
	      var selector = "#hide-me-for-tool-tip-" + id_index + ".hide-me-shifts";
	
	      _this.$timeout(function () {
	        jQuery(selector).hide("slide", "slide");
	      }, 100);
	    }
	  }, {
	    key: "formatAddressForMaps",
	    value: function formatAddressForMaps() {
	      var _this = this;
	
	      var city = _this.event.contactInfo.city;
	      var street = _this.event.contactInfo.streetLine1;
	      var state = _this.event.contactInfo.state;
	      //var zipCode = _this.event.contactInfo.zipCode;
	      var address = street + ", " + city + ", " + state;
	
	      _this.address = address;
	    }
	  }, {
	    key: "keepNoteActive",
	    value: function keepNoteActive() {
	      var _this = this;
	      //////////console.log('keepNoteActive');
	    }
	  }, {
	    key: "clearMarkers",
	    value: function clearMarkers() {
	      var _this = this;
	
	      for (var i = 0; i < _this.map.markers.length; i++) {
	        _this.map.markers[i].setMap(null);
	      }
	    }
	  }, {
	    key: "setMarkerToMap",
	    value: function setMarkerToMap(application) {
	      var _this = this;
	
	      try {
	        _this.$timeout(function () {
	          _this.mapHasLoaded = true;
	        }, 1000);
	
	        _this.$timeout(function () {
	          _this.$maps.getMap({ id: "mapIdd" }).then(function (map) {
	            ////////console.log('what is the map at this point...........');
	            ////////console.dir(map);
	            ////////console.dir(map.markers);
	
	            _this.map = map;
	
	            if (map.markers) {
	              _this.clearMarkers();
	            }
	          }, function (data) {
	            ////////console.log('error');
	            ////////console.dir(data);
	          });
	        }, 2000);
	      } finally {
	        ////////console.log('what is google at this point? -- this should happen after the marker');
	        ////////console.dir(google);
	
	        _this.$timeout(function () {
	          _this.geocoder = new google.maps.Geocoder();
	
	          _this.geocoder.geocode({ address: _this.address }, function (results, status) {
	            if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
	              var locmrker = {};
	              var location = results[0].geometry.location;
	              var myLatLngEv = {
	                lat: location.lat(),
	                lng: location.lng()
	              };
	              var image = "/app/vendor/images/icon-location.png";
	
	              _this.centerLat = location.lat();
	              _this.centerLng = location.lng();
	
	              var marker = new google.maps.Marker({
	                title: _this.event.name,
	                icon: "/app/vendor/images/icon-location.png",
	                position: myLatLngEv,
	                id: null,
	                showMe: true,
	                checkin: null
	              });
	
	              _this.positions.push(marker);
	              _this.setCenterOfMap(marker, application);
	            }
	          });
	        }, 3500);
	      }
	    }
	  }, {
	    key: "setCenterOfMap",
	    value: function setCenterOfMap(marker, application) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        _this.zoom = 11;
	        marker.setMap(_this.map);
	        _this.setShiftMarkersOntoMap(application);
	      }, 300);
	    }
	  }, {
	    key: "toggleMarkers",
	    value: function toggleMarkers(shift, type) {
	      var _this = this;
	
	      if (type === 1) {
	        ////////console.log('this is the shift...');
	        ////////console.dir(shift);
	
	        if (shift.toggleHasBeenSelectedCheckIn) {
	          shift.toggleHasBeenSelectedCheckIn = false;
	          _this.turnOffaGivenShiftsCheckIn(shift);
	        } else {
	          if (shift.checkInCoord.lat && shift.checkInCoord.lat !== 0) {
	            shift.toggleHasBeenSelectedCheckIn = true;
	            _this.turnOnaGivenShiftsCheckIn(shift);
	          }
	        }
	      }
	
	      if (type === 2) {
	        ////////console.log('this is the shift...');
	        ////////console.dir(shift);
	
	        if (shift.toggleHasBeenSelectedCheckOut) {
	          shift.toggleHasBeenSelectedCheckOut = false;
	          _this.turnOffaGivenShiftsCheckOut(shift);
	        } else {
	          if (shift.checkOutCoord.lat) {
	            shift.toggleHasBeenSelectedCheckOut = true;
	            _this.turnOnaGivenShiftsCheckOut(shift);
	          }
	        }
	      }
	    }
	  }, {
	    key: "turnOnaGivenShiftsCheckOut",
	    value: function turnOnaGivenShiftsCheckOut(shift) {
	      var _this = this;
	
	      _this.positions.some(function (elem, index) {
	        if (elem.id !== shift.id) {
	          if (!elem.isSelected) {
	            elem.showMe = false;
	          }
	        } else {
	          if (elem.checkin) {
	            /*elem.showMe = false;*/
	            if (!elem.isSelected) {
	              elem.showMe = false;
	            }
	          } else {
	            elem.isSelected = true;
	            elem.showMe = true;
	          }
	        }
	      });
	    }
	  }, {
	    key: "turnOnaGivenShiftsCheckIn",
	    value: function turnOnaGivenShiftsCheckIn(shift) {
	      var _this = this;
	
	      _this.positions.some(function (elem, index) {
	        if (elem.id !== shift.id) {
	          if (!elem.isSelected) {
	            elem.showMe = false;
	          }
	        } else {
	          if (!elem.checkin) {
	            if (!elem.isSelected) {
	              elem.showMe = false;
	            }
	          } else {
	            elem.isSelected = true;
	            elem.showMe = true;
	          }
	        }
	      });
	    }
	  }, {
	    key: "turnOffaGivenShiftsCheckOut",
	    value: function turnOffaGivenShiftsCheckOut(shift) {
	      var _this = this;
	
	      _this.positions.some(function (elem, index) {
	        if (elem.id !== shift.id) {
	          ////////console.log('not equal.....');
	          /*
	          if (!elem.isSelected) {
	          elem.showMe = false;
	          }
	          */
	        } else {
	          if (elem.checkin) {
	            /*elem.showMe = false;*/
	          } else {
	            elem.isSelected = false;
	            elem.showMe = false;
	          }
	        }
	      });
	    }
	  }, {
	    key: "turnOffaGivenShiftsCheckIn",
	    value: function turnOffaGivenShiftsCheckIn(shift) {
	      var _this = this;
	
	      _this.positions.some(function (elem, index) {
	        if (elem.id !== shift.id) {
	          ////////console.log('not equal.....');
	          /*
	          if (!elem.isSelected) {
	          elem.showMe = false;
	          }
	          */
	        } else {
	          if (!elem.checkin) {
	            /*elem.showMe = false;*/
	          } else {
	            elem.isSelected = false;
	            elem.showMe = false;
	          }
	        }
	      });
	    }
	  }, {
	    key: "formatPaymentInfoForPage",
	    value: function formatPaymentInfoForPage(info) {
	      var _this = this;
	      _this.paymentMethodsFormatted = _this.$auth.formatPaymentMethods(info);
	      _this.$timeout(function () {
	        _this.paymentMethodsFormatted = _this.paymentMethodsFormatted;
	      });
	    }
	  }, {
	    key: "selectPaymentMethod",
	    value: function selectPaymentMethod(paymentMethod) {
	      var _this = this;
	
	      var paymentMethodFiltered = _this.paymentMethodsFormatted.filter(function (p) {
	        return p.isChecked === true;
	      });
	
	      if (paymentMethodFiltered === true) {
	        paymentMethodFiltered = false;
	      }
	
	      _this.cardHasBeenSelected = true;
	      _this.selectedPaymentMethod = paymentMethod;
	
	      if (_this.selectedPaymentMethod.stripeId) {
	        _this.token = _this.selectedPaymentMethod.stripeId;
	      } else if (_this.selectedPaymentMethod.cardToken) {
	        _this.token = _this.selectedPaymentMethod.cardToken;
	      }
	
	      if (_this.selectedPaymentMethod.bankName) {
	        _this.paying_with_bank = true;
	        _this.paying_with_card = false;
	      } else {
	        _this.paying_with_bank = false;
	        _this.paying_with_card = true;
	      }
	
	      _this.paymentMethods = _this.$auth.selectPaymentMethod(_this.paymentInfos, paymentMethod);
	    }
	  }, {
	    key: "setShiftMarkersOntoMap",
	    value: function setShiftMarkersOntoMap(application) {
	      ////////console.log('setShiftMarkersOntoMap');
	      ////////console.dir(application);
	      var _this = this;
	
	      try {
	        application.jobble.shifts.forEach(function (shift, index) {
	          var mrker = {};
	          var automrker = {};
	          var markerOut = null;
	          var marker = null;
	          var automarkerin = null;
	
	          var shiftCounter = index + 1;
	
	          if (shift.checkInCoord) {
	            if (shift.checkInCoord.lat) {
	              mrker.jobbler = application.applicant.firstName + " " + application.applicant.lastName + " -- Manual Check In -- Shift #" + shiftCounter;
	              mrker.checkInLat = shift.checkInCoord.lat;
	              mrker.checkInLng = shift.checkInCoord.lng;
	              mrker.manualCheckinImage = "/app/vendor/images/darkgreen_MarkerI.png";
	              mrker.myLatLng = {
	                lat: shift.checkInCoord.lat,
	                lng: shift.checkInCoord.lng
	              };
	              mrker.shiftId = shift.id;
	              //////////console.log('mrker.myLatLngmrker.myLatLngmrker.myLatLngmrker.myLatLngmrker.myLatLng');
	              //////////console.dir(mrker.myLatLng);
	              marker = new google.maps.Marker({
	                title: mrker.jobbler,
	                icon: mrker.manualCheckinImage,
	                position: mrker.myLatLng,
	                id: mrker.shiftId,
	                showMe: true,
	                checkin: true
	              });
	              _this.positions.push(marker);
	              //marker.setMap(_this.map);
	            }
	          }
	
	          if (shift.checkOutCoord) {
	            if (shift.checkOutCoord.lat) {
	              mrker.checkOutLat = shift.checkOutCoord.lat;
	              mrker.jobblerOut = application.applicant.firstName + " " + application.applicant.lastName + " -- Manual Check Out -- Shift #" + shiftCounter;
	              mrker.checkOutLng = shift.checkOutCoord.lng;
	              mrker.shiftId = shift.id;
	              mrker.manualCheckoutImage = "/app/vendor/images/red_MarkerO.png";
	              mrker.myOutLatLng = {
	                lat: shift.checkOutCoord.lat,
	                lng: shift.checkOutCoord.lng
	              };
	              markerOut = new google.maps.Marker({
	                title: mrker.jobblerOut,
	                icon: mrker.manualCheckoutImage,
	                position: mrker.myOutLatLng,
	                id: mrker.shiftId,
	                showMe: true,
	                checkin: false
	              });
	              _this.positions.push(markerOut);
	              //markerOut.setMap(_this.map);
	            }
	          }
	        });
	      } finally {
	        ////////console.log('what are the poisitons');
	        ////////console.dir(_this.positions);
	      }
	    }
	  }, {
	    key: "alignSideBar",
	    value: function alignSideBar() {
	      var _this = this;
	      _this.$timeout(function () {
	        if (_this.event.isCompleted || _this.event.isClosed || _this.event.isCancelled) {
	          _this.showPayment = false;
	          $("eventsidebar .jobs-complete-sidebar li:nth-child(5)").removeClass().addClass("active");
	        } else {
	          _this.showPayment = true;
	          _this.$timeout(function () {
	            $("eventsidebar .jobs-complete-sidebar li:nth-child(9)").removeClass().addClass("active");
	          }, 500);
	        }
	      });
	    }
	  }, {
	    key: "bulkSelector",
	    value: function bulkSelector() {
	      var _this = this;
	      if (!_this.bulkCheck) {
	        _this.checkAllJobblers();
	        _this.bulkCheck = true;
	      } else {
	        _this.unCheckAllJobblers();
	        _this.bulkCheck = false;
	      }
	    }
	  }, {
	    key: "checkAllJobblers",
	    value: function checkAllJobblers() {
	      var _this = this;
	      _this.jobblers.forEach(function (j) {
	        if (j.jobble.noShow || j.paymentToshiftHasBeenMade) {} else {
	          if (!j.isCheckedForAction) {
	            _this.applicationsForBulkUpdate.push(j);
	            _this.applicationsForRatingUpdate.push(j);
	          }
	
	          j.isCheckedForAction = true;
	        }
	      });
	    }
	  }, {
	    key: "unCheckAllJobblers",
	    value: function unCheckAllJobblers() {
	      var _this = this;
	      _this.jobblers.forEach(function (j) {
	        if (j.isCheckedForAction) {
	          _this.applicationsForBulkUpdate.splice(0, 1);
	          _this.applicationsForRatingUpdate.splice(0, 1);
	        }
	        j.isCheckedForAction = false;
	      });
	    }
	  }, {
	    key: "editAJobblersRatings",
	    value: function editAJobblersRatings(jobbler) {
	      var _this = this;
	
	      if (jobbler.jobble.noShow || jobbler.paymentToshiftHasBeenMade) {
	        return;
	      }
	
	      try {
	        var x = _this.jobblers.findIndex(function (obj) {
	          return obj.isEditingRating == true;
	        });
	
	        if (x > -1) {
	          _this.jobblers[x].isEditingRating = false;
	        }
	      } finally {
	        _this.optionsRating.value = jobbler.ratingValue;
	        jobbler.isEditingRating = true;
	
	        _this.$timeout(function () {
	          $(".table-responsive.table-responsive-payments table tbody tr td span.editing-rating-of-jobbler select").focus();
	        }, 100);
	      }
	    }
	  }, {
	    key: "blurRatingEdit",
	    value: function blurRatingEdit(jobbler) {
	      var _this = this;
	
	      jobbler.isEditingRating = false;
	    }
	  }, {
	    key: "changeRatingEdit",
	    value: function changeRatingEdit(jobbler) {
	      var _this = this;
	
	      jobbler.isEditingRating = false;
	      jobbler.ratingValue = _this.optionsRating.value;
	      _this.optionsRating.value = 5;
	
	      _this.handleRatingsAndReview(jobbler, true);
	    }
	  }, {
	    key: "triggerBulkModal",
	    value: function triggerBulkModal() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("#modal-bulk-rating").modal();
	      }, 100);
	      //_this.$timeout(function(){
	      //_this.unCheckAllJobblers();
	      //_this.bulkCheck = false;
	      //}, 400)
	    }
	  }, {
	    key: "submitReviewBulkUpdate",
	    value: function submitReviewBulkUpdate() {
	      var _this = this;
	
	      _this.loadingReviews = true;
	
	      var r = _this.reviewForBulk;
	
	      try {
	        _this.jobblers.forEach(function (j) {
	          if (j.isCheckedForAction) {
	            j.ratingReview = r;
	          }
	        });
	      } finally {
	        _this.handleRatingsAndReview();
	      }
	    }
	  }, {
	    key: "submitRatingsBulkUpdate",
	    value: function submitRatingsBulkUpdate() {
	      var _this = this;
	
	      _this.loadingRatings = true;
	
	      var r = _this.optionsRatingModal.value;
	
	      try {
	        _this.jobblers.forEach(function (j) {
	          //////console.log('each bro');
	          //////console.dir(j.isCheckedForAction);
	          if (j.isCheckedForAction) {
	            j.ratingValue = r;
	          }
	        });
	      } finally {
	        _this.handleRatingsAndReview();
	        /*
	        */
	      }
	    }
	  }, {
	    key: "checkForAction",
	    value: function checkForAction(jobbler) {
	      var _this = this;
	
	      ////console.log('what is this');
	      ////console.dir(jobbler.jobble.noShow);
	      ////console.dir(jobbler.paymentToshiftHasBeenMade);
	
	      if (jobbler.jobble.noShow || jobbler.paymentToshiftHasBeenMade) {
	        return;
	      }
	
	      _this.bulkCheck = false;
	
	      if (jobbler.isCheckedForAction) {
	        jobbler.isCheckedForAction = false;
	        _this.applicationsForBulkUpdate.splice(0, 1);
	      } else {
	        jobbler.isCheckedForAction = true;
	        _this.applicationsForBulkUpdate.push(jobbler);
	      }
	
	      ////console.log('_this.applicationsForBulkUpdate');
	      ////console.dir(_this.applicationsForBulkUpdate);
	    }
	  }, {
	    key: "editAJobblersMinutes",
	    value: function editAJobblersMinutes(application) {
	      var _this = this;
	
	      if (application.jobble.noShow || application.paymentToshiftHasBeenMade) {
	        return;
	      }
	
	      application.isEditingMin = true;
	
	      var initJobbleDurationVals = {};
	      initJobbleDurationVals.hours = application.jobbleDurationData.hours;
	      initJobbleDurationVals.minutes = application.jobbleDurationData.minutes;
	      application.jobbleDurationDataInitVals = initJobbleDurationVals;
	
	      _this.$timeout(function () {
	        $(".table-responsive.table-responsive-payments table tbody tr td span.editing-rating-of-jobbler input").focus();
	      }, 100);
	    }
	  }, {
	    key: "editAJobblersHours",
	    value: function editAJobblersHours(application) {
	      var _this = this;
	
	      if (application.jobble.noShow || application.paymentToshiftHasBeenMade) {
	        return;
	      }
	
	      ////console.log('about to edit hours');
	      ////console.dir(application);
	      var initJobbleDurationVals = {};
	      initJobbleDurationVals.hours = application.jobbleDurationData.hours;
	      initJobbleDurationVals.minutes = application.jobbleDurationData.minutes;
	      application.jobbleDurationDataInitVals = initJobbleDurationVals;
	      //let initJobbleDurationVals = application.jobbleDurationData;
	      //application.jobbleDurationDataInitVals = initJobbleDurationVals;
	
	      application.isEditingHours = true;
	
	      _this.$timeout(function () {
	        $(".table-responsive.table-responsive-payments table tbody tr td span.editing-rating-of-jobbler input").focus();
	      }, 100);
	
	      return;
	    }
	  }, {
	    key: "editAJobblersMin",
	    value: function editAJobblersMin(application) {
	      var _this = this;
	      if (application.jobble.noShow || application.paymentToshiftHasBeenMade) {
	        return;
	      }
	
	      application.isEditingMin = true;
	    }
	  }, {
	    key: "enterMinsUpdated",
	    value: function enterMinsUpdated(application) {
	      var _this = this;
	
	      ////console.log('enterMinsUpdated');
	      ////console.dir(application.jobbleDurationData.minutes);
	
	      if (application.jobbleDurationData.minutes === null || _angular2.default.isUndefined(application.jobbleDurationData.minutes)) {
	        application.jobbleDurationData.minutes = application.jobbleDurationDataInitVals.minutes;
	        return;
	      }
	
	      if (application.jobbleDurationData.minutes > 59) {
	        application.jobbleDurationData.minutes = 59;
	      }
	
	      var x = _this.jobblers.findIndex(function (obj) {
	        return obj.isEditingMin == true;
	      });
	
	      if (x > -1) {
	        _this.jobblers[x].isEditingMin = false;
	      }
	
	      _this.storeHoursForDBCall(application, true);
	    }
	  }, {
	    key: "blurMinsUpdated",
	    value: function blurMinsUpdated(application) {
	      var _this = this;
	
	      if (application.jobbleDurationData.minutes === null || _angular2.default.isUndefined(application.jobbleDurationData.minutes)) {
	        application.jobbleDurationData.minutes = application.jobbleDurationDataInitVals.minutes;
	        return;
	      }
	
	      if (application.jobbleDurationData.minutes > 59) {
	        application.jobbleDurationData.minutes = 59;
	      }
	
	      var x = _this.jobblers.findIndex(function (obj) {
	        return obj.isEditingMin == true;
	      });
	
	      if (x > -1) {
	        _this.jobblers[x].isEditingMin = false;
	      }
	
	      _this.storeHoursForDBCall(application, true);
	    }
	  }, {
	    key: "enterHoursUpdated",
	    value: function enterHoursUpdated(application) {
	      var _this = this;
	
	      ////console.log('application');
	      ////console.dir(application);
	      ////console.dir(application.jobbleDurationData.hours);
	
	      if (application.jobbleDurationData.hours === null || _angular2.default.isUndefined(application.jobbleDurationData.hours)) {
	        //alert('no decimals are allowed');
	        application.jobbleDurationData.hours = application.jobbleDurationDataInitVals.hours;
	        return;
	      }
	
	      var x = _this.jobblers.findIndex(function (obj) {
	        return obj.isEditingHours == true;
	      });
	
	      if (x > -1) {
	        if (_this.jobblers[x].paymentToshiftHasBeenMade) {
	          _this.jobblers[x].paymentToshiftHasBeenMade = false;
	        }
	
	        _this.jobblers[x].isEditingHours = false;
	      }
	
	      _this.storeHoursForDBCall(application, true);
	    }
	  }, {
	    key: "blurHoursUpdated",
	    value: function blurHoursUpdated(application) {
	      var _this = this;
	
	      if (application.jobbleDurationData.hours === null || _angular2.default.isUndefined(application.jobbleDurationData.hours)) {
	        //alert('no decimals are allowed');
	        application.jobbleDurationData.hours = application.jobbleDurationDataInitVals.hours;
	        return;
	      }
	
	      var x = _this.jobblers.findIndex(function (obj) {
	        return obj.isEditingHours == true;
	      });
	
	      if (x > -1) {
	        _this.jobblers[x].isEditingHours = false;
	      }
	
	      _this.storeHoursForDBCall(application, true);
	    }
	  }, {
	    key: "editJobblerPay",
	    value: function editJobblerPay(application) {
	      var _this = this;
	
	      if (application.jobble.noShow || application.paymentToshiftHasBeenMade) {
	        return;
	      }
	
	      application.isEditingPay = true;
	
	      //////console.log('what do we have here');
	      //////console.dir(application.jobble.totalCalculated);
	      //console.log("do we have delivery");
	      //console.dir(_this.delivery);
	
	      if (_this.delivery) {
	        application.jobble.totalCalculated = (application.jobble.payPerHour / 100).toFixed(2);
	      } else {
	        application.jobble.totalCalculated = application.jobble.totalCalculated.toFixed(2);
	      }
	
	      _this.$timeout(function () {
	        $(".table-responsive.table-responsive-payments table tbody tr td span.editing-rating-of-jobbler input").focus();
	      }, 100);
	    }
	  }, {
	    key: "enterPayUpdated",
	    value: function enterPayUpdated(application) {
	      var _this = this;
	
	      var x = _this.jobblers.findIndex(function (obj) {
	        return obj.isEditingPay == true;
	      });
	
	      if (x > -1) {
	        _this.jobblers[x].isEditingPay = false;
	      }
	
	      if (!_this.delivery) {
	        var a = application.jobble.totalCalculated * 100;
	        var y = application.jobble.payPerHour * 100;
	        var min = a / y * 100 * 60;
	        application.jobbleDurationData.minutes = Math.round(min % 60);
	        application.jobbleDurationData.hours = Math.floor(min / 60);
	        _this.storeHoursForDBCall(application, true);
	      } else {
	        application.jobble.payPerHour = application.jobble.totalCalculated * 100;
	        _this.storePayPerHourForDelivery(application);
	      }
	    }
	  }, {
	    key: "storePayPerHourForDelivery",
	    value: function storePayPerHourForDelivery(application) {
	      var _this = this;
	      //console.log("whats the data to store");
	      var amount = application.jobble.payPerHour;
	      var jobble_id = application.jobble.id;
	      //console.log("what do we ahve here");
	      //console.dir(amount);
	      //console.dir(jobble_id);
	      _this.$security.putPayPerHourUpdateForDelivery(jobble_id, amount).then(function (response) {
	        //console.log("response from updating the pay per hour");
	        //console.dir(response);
	      }, function (error) {
	        //console.log("error");
	        //console.dir(error);
	      });
	    }
	  }, {
	    key: "blurPayUpdated",
	    value: function blurPayUpdated(application) {
	      var _this = this;
	
	      ////////console.log('blurHoursUpdated');
	
	      var x = _this.jobblers.findIndex(function (obj) {
	        return obj.isEditingPay == true;
	      });
	
	      if (x > -1) {
	        _this.jobblers[x].isEditingPay = false;
	      }
	
	      var a = application.jobble.totalCalculated * 100;
	      var y = application.jobble.payPerHour * 100;
	      var min = a / y * 100 * 60;
	
	      application.jobbleDurationData.minutes = Math.round(min % 60);
	      application.jobbleDurationData.hours = Math.floor(min / 60);
	      _this.storeHoursForDBCall(application, true);
	
	      //_this.totalAmountToBePaidOut();
	    }
	  }, {
	    key: "setPaymentHistoryForCompletePage",
	    value: function setPaymentHistoryForCompletePage(application) {
	      var _this = this;
	
	      //////console.log('setPaymentHistoryForCompletePage');
	      //////console.dir(application);
	      application.paymentTotalAmount = 0;
	      application.paymentTotalTransactions = 0;
	
	      try {
	        application.jobble.shifts.forEach(function (shift) {
	          if (shift.paymentStats.number > 0) {
	            ////console.log('we have payment stats here...');
	            ////console.dir(application.applicant.firstName);
	            ////console.dir(application.jobble.makeAdditionalPayment);
	
	            if (!application.jobble.makeAdditionalPayment) {
	              application.paymentToshiftHasBeenMade = true;
	            }
	
	            application.paymentTotalAmount = application.paymentTotalAmount + shift.paymentStats.amount;
	            application.paymentTotalTransactions = application.paymentTotalTransactions + shift.paymentStats.number;
	          }
	        });
	      } finally {
	        _this.calcTimeWorked(application);
	      }
	    }
	  }, {
	    key: "slidePayments",
	    value: function slidePayments(jobbler, index) {
	      var _this = this;
	
	      if (jobbler.jobble.noShow || jobbler.paymentToshiftHasBeenMade) {
	        return;
	      }
	
	      var id_index = index + 1;
	      var selector = "#slide-toggle-for-complete-" + id_index + ".hide-row-that-has-pay-info";
	
	      ////console.log('what is the jobbler');
	      ////console.dir(jobbler);
	
	      jobbler.jobble.shifts.sort(function (a, b) {
	        return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
	      });
	
	      if (!jobbler.show) {
	        jobbler.show = true;
	        _this.$timeout(function () {
	          jQuery(selector).show("fast");
	        }, 100);
	      } else {
	        jobbler.show = false;
	        _this.$timeout(function () {
	          jQuery(selector).hide("fast");
	        }, 100);
	      }
	    }
	  }, {
	    key: "confirmJobblerNoShow",
	    value: function confirmJobblerNoShow(application) {
	      var _this = this;
	      //////console.log('confirmJobblerNoShow');
	      _this.$timeout(function () {
	        $("#modal-mark-as-now-show").modal();
	      });
	      _this.dataModelForNoShow = application;
	    }
	  }, {
	    key: "confirmJobblerNoShowCancel",
	    value: function confirmJobblerNoShowCancel(application) {
	      var _this = this;
	      //////console.log('confirmJobblerNoShow');
	      //console.log("confirmJobblerNoShowCancel");
	      //console.dir(application.jobble);
	      _this.$timeout(function () {
	        $("#modal-mark-as-now-show-cancel").modal();
	        _this.dataModelForNoShow = application;
	      });
	    }
	  }, {
	    key: "markJobblerAsANoShowFromMainPage",
	    value: function markJobblerAsANoShowFromMainPage() {
	      var _this = this;
	      _this.noShowButtonDiabled = true;
	      _this.$security.markJobblerAsNoShowTrimmed(_this.dataModelForNoShow).then(function (response) {
	        _this.noShowButtonDiabled = false;
	        _this.jobblers.some(function (elem) {
	          if (elem.jobble.id === response.data.id) {
	            elem.noShowClass = "no-show-jobbler";
	            elem.jobble.paidOutClass = "jobbler-is-no-show";
	            elem.jobble.hoursForShow = 0;
	            elem.jobble.minutesForShow = 0;
	            elem.jobbleDurationData.hours = 0;
	            elem.jobbleDurationData.minutes = 0;
	            elem.jobble.totalCalculated = 0;
	            elem.ratingValue = 1;
	            //_this.minutePreview = 0;
	            //_this.hourPreview = 0;
	            elem.jobble.noShow = true;
	            //console.log("ok jobble duration in minutes here");
	            //console.dir(elem.jobble);
	          }
	        });
	        _this.$timeout(function () {
	          $("#modal-mark-as-now-show").modal("hide");
	        });
	      }, function (data) {
	        //_this.remain_loading_count--;
	        _this.noShowButtonDiabled = false;
	        _this.$timeout(function () {
	          $("#modal-mark-as-now-show").modal("hide");
	        });
	        _this.$timeout(function () {
	          alert("There appears to be an error marking this jobbler as a no show. Please refresh your page to view updated information.");
	        }, 500);
	      });
	    }
	  }, {
	    key: "markJobblerAsANoShowFromMainPageCancel",
	    value: function markJobblerAsANoShowFromMainPageCancel() {
	      var _this = this;
	      _this.noShowButtonDiabled = true;
	      //console.log("_this.dataModelForNoShow.jobble");
	      //console.dir(_this.dataModelForNoShow.jobble);
	      _this.dataModelForNoShow.jobble.actualMinutesWorked = _this.dataModelForNoShow.jobble.jobbleDurationInMinutes;
	      _this.dataModelForNoShow.jobble.actualRevenue = _this.dataModelForNoShow.jobble.actualMinutesWorked * _this.dataModelForNoShow.jobble.payPerHour / 60;
	      var app = _this.dataModelForNoShow;
	      _this.$security.markJobblerAsNoShowCancel(_this.dataModelForNoShow).then(function (response) {
	        _this.jobblers.some(function (elem) {
	          _this.noShowButtonDiabled = false;
	          if (elem.jobble.id === response.data.id) {
	            //console.log("what is the element here");
	            //console.dir(elem.jobble);
	            elem.jobble.paidOutClass = "";
	            elem.jobble.noShow = null;
	            elem.noShowClass = null;
	            elem.ratingValue = 5;
	            elem.jobble.no_show_cancelled = true;
	            if (elem.jobble.actualMinutesWorked && elem.jobble.actualMinutesWorked !== 0) {
	              elem.jobbleDurationData.minutes = Math.round(elem.jobble.actualMinutesWorked % 60);
	              elem.jobbleDurationData.hours = Math.floor(elem.jobble.actualMinutesWorked / 60);
	              elem.jobble.totalCalculated = elem.jobble.actualMinutesWorked * elem.jobble.payPerHour / 60 / 100;
	            } else {
	              elem.jobbleDurationData.minutes = Math.round(elem.jobble.jobbleDurationInMinutes % 60);
	              elem.jobbleDurationData.hours = Math.floor(elem.jobble.jobbleDurationInMinutes / 60);
	              elem.jobble.totalCalculated = elem.jobble.jobbleDurationInMinutes * elem.jobble.payPerHour / 60 / 100;
	            }
	
	            elem.jobble.actualRevenue = null;
	
	            //console.log("elem.jobble");
	            //console.dir(elem.jobble);
	
	            if (app.jobble.shifts.length === 1) {
	              //console.log("do we have one shift?");
	
	              _this.infoForDisplay = app;
	              _this.markJobblerShowShowForShift(app.jobble.shifts[0], false, true, true, elem);
	            }
	          }
	        });
	        _this.$timeout(function () {
	          $("#modal-mark-as-now-show-cancel").modal("hide");
	        });
	      }, function (data) {
	        _this.noShowButtonDiabled = false;
	        alert("There appears to be an error marking this jobbler as a no show. Please refresh your page to view updated information.");
	      });
	    }
	  }, {
	    key: "triggerBulkReview",
	    value: function triggerBulkReview() {
	      var _this = this;
	
	      _this.reviewForBulk = null;
	      _this.count = 0;
	
	      _this.$timeout(function () {
	        $("#modal-add-review-jobble-all").modal();
	      });
	    }
	  }, {
	    key: "submitReview",
	    value: function submitReview() {
	      var _this = this;
	
	      ////console.log('subit review single');
	      ////console.dir(_this.infoForDisplay);
	      ////console.dir(_this.reviewForBulk);
	
	      var x = _this.jobblers.findIndex(function (obj) {
	        return obj.id == _this.infoForDisplay.id;
	      });
	
	      ////console.log('what is the review index');
	      ////console.dir(x);
	
	      if (x > -1) {
	        _this.jobblers[x].ratingReview = _this.reviewForBulk;
	      }
	
	      _this.handleRatingsAndReview(_this.infoForDisplay, true);
	
	      _this.$timeout(function () {
	        $("#modal-add-review-jobbler .modal-header button.close").trigger("click");
	      }, 1000);
	    }
	  }, {
	    key: "calculateTotalsForDisplay",
	    value: function calculateTotalsForDisplay() {
	      var _this = this;
	
	      _this.infoForDisplay.outstandingTotalsData = {};
	
	      var hours = 0;
	      var minutes = 0;
	      var monies = 0;
	      var minutes_being_totalled = 0;
	
	      if (_this.shiftsWithOutPayments.length > 0) {
	        try {
	          _this.shiftsWithOutPayments.forEach(function (shift) {
	            if (shift.noShow !== true) {
	              if (shift.actualMinutesWorked || shift.actualMinutesWorked === 0) {
	                minutes_being_totalled = minutes_being_totalled + shift.actualMinutesWorked;
	              } else {
	                var et = moment(shift.timeInterval.endTime);
	                var st = moment(shift.timeInterval.startTime);
	                var duration = moment.duration(et.diff(st));
	                minutes_being_totalled = minutes_being_totalled + duration.asMinutes();
	              }
	            }
	          });
	        } finally {
	          _this.infoForDisplay.outstandingTotalsData.hours = Math.floor(minutes_being_totalled / 60);
	          _this.infoForDisplay.outstandingTotalsData.minutes = minutes_being_totalled % 60;
	          var pay = _this.infoForDisplay.jobble.payPerHour;
	          _this.infoForDisplay.outstandingTotalsData.monies = pay * minutes_being_totalled / 60 / 100;
	        }
	      } else {
	        _this.infoForDisplay.outstandingTotalsData.hours = 0;
	        _this.infoForDisplay.outstandingTotalsData.minutes = 0;
	        _this.infoForDisplay.outstandingTotalsData.monies = 0.0;
	      }
	    }
	  }, {
	    key: "showHiddenTable",
	    value: function showHiddenTable() {
	      var _this = this;
	
	      ////console.log('showHiddenTable');
	
	      if (_this.showingPayments) {
	        _this.showingPayments = false;
	        $("#modal-edit-shifts h3.shift-title.hidden-table").hide("fast");
	        $("#modal-edit-shifts table.hidden-table").hide("fast");
	      } else {
	        _this.showingPayments = true;
	        $("#modal-edit-shifts h3.shift-title.hidden-table").show("fast");
	        $("#modal-edit-shifts table.hidden-table").show("fast");
	      }
	    }
	  }, {
	    key: "makeAnotherPayment",
	    value: function makeAnotherPayment(jobbler) {
	      var _this = this;
	      ////console.log('makeAnotherPayment');
	      ////console.dir(jobbler);
	    }
	  }, {
	    key: "markJobbleAsReadyForAdditionalPayments",
	    value: function markJobbleAsReadyForAdditionalPayments(application) {
	      var _this = this;
	
	      //////console.log('scanApplicantsAndMarkAsPaid');
	      //////console.dir(application);
	      application.paymentToshiftHasBeenMade = false;
	      application.jobble.makeAdditionalPayment = true;
	      //////console.dir(application);
	
	      _this.$security.markJobblerAsPaidByShiftTrimmed(application).then(function (response) {
	        ////console.log('markJobblerAsPaidByShiftTrimmed');
	        ////console.dir(response.data);
	        ////console.dir(application);
	
	        if (response.data.actualMinutesWorked) {
	          application.jobbleDurationData.minutes = response.data.actualMinutesWorked % 60;
	          application.jobbleDurationData.hours = Math.floor(response.data.actualMinutesWorked / 60);
	          application.jobble.totalCalculated = response.data.actualRevenue / 100;
	        } else {
	          application.jobbleDurationData.minutes = response.data.jobbleDurationInMinutes % 60;
	          application.jobbleDurationData.hours = Math.floor(response.data.jobbleDurationInMinutes / 60);
	          application.jobble.totalCalculated = response.data.costOfJobble / 100;
	        }
	      }, function (error) {
	        ////console.log('in error saving payment information');
	      });
	    }
	  }, {
	    key: "markJobbleAsReadyForAdditionalPaymentsCancel",
	    value: function markJobbleAsReadyForAdditionalPaymentsCancel(application) {
	      var _this = this;
	
	      //application.paymentToshiftHasBeenMade = true;
	      application.jobble.makeAdditionalPayment = false;
	
	      _this.$security.markJobblerAsPaidByShiftTrimmedCancel(application).then(function (response) {
	        ////console.log('markJobblerAsPaidByShiftTrimmed');
	        ////console.dir(response.data);
	        ////console.dir(application);
	
	        if (response.data.actualMinutesWorked) {
	          application.jobbleDurationData.minutes = response.data.actualMinutesWorked % 60;
	          application.jobbleDurationData.hours = Math.floor(response.data.actualMinutesWorked / 60);
	          application.jobble.totalCalculated = response.data.actualRevenue / 100;
	        } else {
	          application.jobbleDurationData.minutes = response.data.jobbleDurationInMinutes % 60;
	          application.jobbleDurationData.hours = Math.floor(response.data.jobbleDurationInMinutes / 60);
	          application.jobble.totalCalculated = response.data.costOfJobble / 100;
	        }
	      }, function (error) {
	        ////console.log('in error saving payment information');
	      });
	    }
	  }, {
	    key: "checkForPaymentInfo",
	    value: function checkForPaymentInfo(application) {
	      var _this = this;
	
	      ////console.log('what do we have here');
	      ////console.dir(application.applicant.undeletedPaymentInfos);
	
	      if (!application.applicant.undeletedPaymentInfos) {
	        //application.doesNotHavePaymentInfo = true;
	      }
	    }
	  }, {
	    key: "handleRatingsAndReview",
	    value: function handleRatingsAndReview(data, singleUpdate) {
	      var _this = this;
	      var ratingsArray = [];
	      try {
	        if (!singleUpdate) {
	          _this.jobblers.forEach(function (application) {
	            if (application.isCheckedForAction) {
	              ////console.log('we have the application ready to role.');
	              ////console.dir(application);
	              var ratingsObjForDB = {};
	              ratingsObjForDB.ratingUser = _this.currentUser.id;
	              ratingsObjForDB.ratedUser = application.applicant.id;
	              ratingsObjForDB.rate = application.ratingValue;
	              ratingsObjForDB.noteRateGiver = application.ratingReview;
	              ratingsObjForDB.ratingType = 1;
	              ratingsObjForDB.subEvent = _this.event.subEvents[0].id;
	              ratingsObjForDB.ratingCompany = _this.currentUser.company.id;
	              ratingsArray.push(ratingsObjForDB);
	            }
	          });
	        } else {
	          var ratingsObjForDB = {};
	          ratingsObjForDB.ratingUser = _this.currentUser.id;
	          ratingsObjForDB.ratedUser = data.applicant.id;
	          ratingsObjForDB.rate = data.ratingValue;
	          ratingsObjForDB.noteRateGiver = _this.reviewForBulk;
	          ratingsObjForDB.ratingType = 1;
	          ratingsObjForDB.subEvent = _this.event.subEvents[0].id;
	          ratingsObjForDB.ratingCompany = _this.currentUser.company.id;
	          ratingsArray.push(ratingsObjForDB);
	        }
	      } finally {
	        _this.$events.rateOrReview(ratingsArray).then(function (response) {
	          _this.$timeout(function () {
	            _this.loadingRatings = false;
	            _this.bulkRatingSuccess = true;
	            //_this.unCheckAllJobblers();
	            _this.bulkCheck = false;
	            _this.bulkRatingSuccess = false;
	            $("#modal-bulk-rating .modal-header button.close").trigger("click");
	            $("#modal-add-review-jobble-all").modal("hide");
	          }, 300);
	        }, function (error) {
	          alert("There was an error submitting your review. Please try again later");
	        });
	      }
	    }
	  }, {
	    key: "getPaymentInfo",
	    value: function getPaymentInfo(application) {
	      var _this = this;
	      if (application.applicant.undeletedPaymentInfos) {
	        if (_this.currentUser.isAdmin && application.applicant.undeletedPaymentInfos.length === 0) {
	          application.showPayInfoWarning = true;
	        }
	        if (_this.currentUser.isAdmin) {
	          _this.findDuplicateJobbles();
	        }
	      }
	    }
	  }, {
	    key: "findDuplicateJobbles",
	    value: function findDuplicateJobbles() {
	      var _this = this;
	
	      //let arr = [9, 9, 111, 2, 3, 4, 4, 5, 7];
	
	      var id_arr = [];
	
	      try {
	        _this.jobblers.forEach(function (application) {
	          id_arr.push(application.jobble.id);
	        });
	      } catch (err) {} finally {
	        var sorted_arr = id_arr.slice().sort();
	        var results = [];
	
	        for (var i = 0; i < sorted_arr.length - 1; i++) {
	          if (sorted_arr[i + 1] == sorted_arr[i]) {
	            results.push(sorted_arr[i]);
	          }
	        }
	
	        _this.jobblers.forEach(function (application) {
	          if (results.indexOf(application.jobble.id) > -1) {
	            application.has_dupe = true;
	            _this.dupe_error_prevent_payment = true;
	          }
	        });
	      }
	    }
	  }, {
	    key: "prepareShiftHours",
	    value: function prepareShiftHours(application) {
	      application.jobble.shifts.forEach(function (shift) {});
	    }
	  }, {
	    key: "triggerBulkPay",
	    value: function triggerBulkPay() {
	      var _this = this;
	      if (_this.cardHasBeenSelected) {
	        _this.submitPaymentModal(1);
	      } else {
	        _this.noCardSelectedError = true;
	        _this.$timeout(function () {
	          var elementOffset = $("#credit-card-selection").offset().top;
	          $("html,body").animate({ scrollTop: elementOffset }, "slow");
	        }, 300);
	      }
	    }
	  }, {
	    key: "setShiftStartTimesAndAmounts",
	    value: function setShiftStartTimesAndAmounts(application) {
	      var _this = this;
	
	      var pay_per_hour = application.jobble.payPerHour;
	      var total_mins = 0;
	
	      try {
	        application.jobble.shifts.forEach(function (shift) {
	          if (shift.noShow) {
	            shift.shiftDurationInMinutes = 0;
	            shift.shiftDurationInHours = 0;
	          } else if (shift.paymentStats.number === 0) {
	            if (shift.actualMinutesWorked || shift.actualMinutesWorked === 0) {
	              total_mins = total_mins + shift.acutalMinutesWorked;
	              shift.shiftDurationInMinutes = Math.round(shift.actualMinutesWorked % 60);
	              shift.shiftDurationInHours = Math.floor(shift.actualMinutesWorked / 60);
	              //shift.paymentStats.amountPaid = (((shift.actualMinutesWorked * pay_per_hour) / 60) / 100);
	              shift.amountOwed = shift.actualMinutesWorked * pay_per_hour / 60 / 100;
	            } else {
	              var mins = shift.shiftDurationInMinutes;
	              mins = shift.shiftDurationInHours * 60 + mins;
	              shift.amountOwed = mins * pay_per_hour / 60 / 100;
	              total_mins = total_mins + mins;
	            }
	          } else {
	            var minutes = shift.paymentStats.amount / pay_per_hour * 60;
	            shift.shiftDurationInMinutes = Math.round(minutes % 60);
	            shift.shiftDurationInHours = Math.floor(minutes / 60);
	            total_mins = total_mins + minutes;
	            shift.amountOwed = shift.paymentStats.amount / 100;
	          }
	        });
	      } finally {
	        if (application.jobble.shifts.length === 1) {}
	      }
	    }
	  }, {
	    key: "setJobbleDurationsAndAmounts",
	    value: function setJobbleDurationsAndAmounts(application) {}
	  }, {
	    key: "calcOutstandingHours",
	    value: function calcOutstandingHours(application) {
	      var _this = this;
	      _this.setShiftStartTimesAndAmounts(application);
	    }
	  }, {
	    key: "refreshList",
	    value: function refreshList() {
	      var _this = this;
	      _this.remain_loading_count = 1;
	      _this.jobblers = [];
	      _this.getAcceptedJobblers();
	    }
	  }, {
	    key: "fancyLoad",
	    value: function fancyLoad(cls, length) {
	      var _this = this;
	      _this.$auth.fancyLoad(cls, length);
	    }
	  }, {
	    key: "getAcceptedJobblers",
	    value: function getAcceptedJobblers(offset) {
	      var _this = this;
	      _this.loading_jobblers = true;
	      if (!offset) {
	        offset = 0;
	        _this.remain_loading_count--;
	      }
	      _this.$events.getAcceptedApplicationsTrimmedComplete(_this.event.subEvents[0].id, 10, offset).then(function (acceptedApplications) {
	        var applicationsForLoc = [];
	        _this.ratingsMap = [];
	        if (acceptedApplications.data.length !== 0) {
	          try {
	            acceptedApplications.data.forEach(function (application, i) {
	              application.displaySticky = true;
	              var ratingsObjForDB = {};
	              ratingsObjForDB.ratingUser = _this.currentUser.id;
	              ratingsObjForDB.ratedUser = application.applicant.id;
	              ratingsObjForDB.noteRateGiver = "";
	              ratingsObjForDB.ratingType = 1;
	              ratingsObjForDB.subEvent = _this.event.subEvents[0].id;
	              ratingsObjForDB.ratingCompany = _this.currentUser.company.id;
	              _this.ratingsArray.push(ratingsObjForDB);
	              _this.sourcingPostTotal = _this.sourcingPostTotal + application.jobble.paymentStats.amount;
	
	              if (application.jobble.paymentStats) {
	                application.jobble.amountPaid = application.jobble.paymentStats.amount;
	                application.jobble.averageAmount = application.jobble.paymentStats.amount / application.jobble.paymentStats.number;
	              } else {
	                application.jobble.amountPaid = 0;
	                application.jobble.averageAmount = 0;
	              }
	
	              if (_this.$security.isUndefinedOrNull(application.rating.id)) {
	                application.displaySticky = false;
	                ratingsObjForDB.rate = 5;
	                ratingsObjForDB.ratingValue = 5;
	                application.ratingValue = 5;
	              } else {
	                application.displaySticky = true;
	                ratingsObjForDB.ratingValue = application.rating.rate;
	                application.ratingValue = application.rating.rate;
	                _this.ratingsMap.push(application);
	              }
	
	              if (application.jobble.noShow !== true) {
	                if (application.jobble.actualMinutesWorked === null) {
	                  application.showActualMinutesWorked = false;
	                } else {
	                  application.jobble.jobbleDurationInMinutes = application.jobble.actualMinutesWorked;
	                  application.showActualMinutesWorked = true;
	                }
	              } else {
	                application.noShowClass = "no-show-jobbler";
	                application.ratingValue = 1;
	              }
	
	              application.smallPic = application.applicant.filePROFILE_IMAGE1IMG_75x75;
	              application.mediumPic = application.applicant.filePROFILE_IMAGE1IMG_75x75;
	              application.largePic = application.applicant.filePROFILE_IMAGE1IMG_600x600;
	
	              if (_this.$security.isUndefinedOrNull(application.smallPic)) {
	                application.smallPic = application.mediumPic;
	              }
	
	              if (_this.$security.isUndefinedOrNull(application.applicant.lastName)) {
	                application.applicant.lastShortName = "D.";
	              } else {
	                application.applicant.lastShortName = application.applicant.lastName.substring(0, 1) + ".";
	              }
	              applicationsForLoc.push(application);
	              _this.format_names(application);
	              _this.jobblers.push(application);
	              _this.setPaymentHistoryForCompletePage(application);
	              _this.loopShiftsForNote(application);
	              _this.getPaymentInfo(application);
	              _this.setJobbleDurationsAndAmounts(application);
	              _this.fancyLoad(".table-responsive.table-responsive-payments table tbody tr.main-screen-data", _this.jobblers.length);
	            });
	          } finally {
	            _this.sourcingPostTotals(_this.jobblers);
	            _this.getAcceptedJobblers(_this.jobblers.length);
	          }
	        } else {
	          _this.loading_jobblers = false;
	          _this.sortJobblers();
	        }
	      }, function (data) {
	        _this.remain_loading_count--;
	      });
	    }
	  }, {
	    key: "sortJobblers",
	    value: function sortJobblers() {
	      var _this = this;
	      _this.jobblers.sort(function (a, b) {
	        if (a.applicant.lastName < b.applicant.lastName) return -1;
	        if (a.applicant.lastName > b.applicant.lastName) return 1;
	        return 0;
	      });
	    }
	  }, {
	    key: "format_names",
	    value: function format_names(application) {
	      var _this = this;
	      application.applicant.firstName = application.applicant.firstName.toLowerCase();
	      application.applicant.lastName = application.applicant.lastName.toLowerCase();
	      var first_name_second_half = application.applicant.firstName.substring(1, application.applicant.firstName.length);
	      var last_name_second_half = application.applicant.lastName.substring(1, application.applicant.lastName.length);
	      application.applicant.firstName = application.applicant.firstName.charAt(0).toUpperCase() + first_name_second_half;
	      application.applicant.lastName = application.applicant.lastName.charAt(0).toUpperCase() + last_name_second_half;
	    }
	  }, {
	    key: "openJobModal",
	    value: function openJobModal() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("#re-open-job").modal();
	      });
	    }
	  }, {
	    key: "openJob",
	    value: function openJob() {
	      var _this = this;
	
	      var id = _this.$stateParams.eventId;
	
	      _this.$events.reOpenEvent(id).then(function (response) {
	        if (response.status === 200) {
	          _this.event.isCompleted = false;
	          _this.event.isClosed = false;
	        } else {
	          _this.$timeout(function () {
	            $("#re-open-job").modal("toggle");
	          });
	        }
	        _this.$timeout(function () {
	          $("#re-open-job").modal("toggle");
	        }, 300);
	      }, function (error) {});
	    }
	  }, {
	    key: "checkForDelivery",
	    value: function checkForDelivery() {
	      var _this = this;
	      if (_this.event.orderNumber) {
	        _this.delivery = true;
	      }
	    }
	  }, {
	    key: "displayCreditCardModal",
	    value: function displayCreditCardModal() {
	      var _this = this;
	      var id = _this.event.id;
	      _this.$timeout(function () {
	        $("#modal-add-card").modal();
	      });
	    }
	  }, {
	    key: "displayBankModal",
	    value: function displayBankModal() {
	      var _this = this;
	      var id = _this.event.id;
	      _this.$timeout(function () {
	        $("#modal-add-account").modal();
	      });
	    }
	  }, {
	    key: "getLatestInfo",
	    value: function getLatestInfo() {
	      var _this = this;
	      console.log("what is the user");
	      console.dir(_this.currentUser.access_token);
	      var t = _this.currentUser.access_token;
	      _this.$auth.validateUserByToken(t).then(function (resp) {
	        console.log("new user");
	        console.dir(resp.data);
	        _this.currentUser = resp.data;
	        if (_this.currentUser.username.indexOf("jobble.com") !== -1 || _this.currentUser.username.indexOf("jobbleapp.com") !== -1) {
	          _this.currentUser.isAdmin = true;
	        }
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "expandPaymentTable",
	    value: function expandPaymentTable() {
	      var _this = this;
	
	      if (!_this.table_expanded) {
	        _this.table_expanded = true;
	        _this.$timeout(function () {
	          $(".side-bar-complete").addClass("side-bar-complete-hide");
	          $(".main-page-complete").addClass("main-page-complete-expanded");
	        }, 100);
	      } else {
	        _this.table_expanded = false;
	        _this.$timeout(function () {
	          $(".side-bar-complete").removeClass("side-bar-complete-hide");
	          $(".main-page-complete").removeClass("main-page-complete-expanded");
	        }, 100);
	      }
	    }
	  }, {
	    key: "addUserToTeamModal",
	    value: function addUserToTeamModal(application) {
	      var _this = this;
	      console.log("addUserToTeamModal");
	      console.dir(application);
	      _this.user_to_add = application.applicant;
	      console.log("_this.user_to_add");
	      console.dir(_this.user_to_add);
	      _this.submitting = false;
	      _this.$timeout(function () {
	        $("#modal-add-to-team-jobbler").modal();
	      }, 300);
	      _this.loadTeams();
	    }
	  }, {
	    key: "loadTeams",
	    value: function loadTeams() {
	      var _this = this;
	      var teamsSimple = [];
	
	      _this.add_users_to_team_ui.loading_teams = true;
	      _this.$companies.getTeamsSimple().then(function (response) {
	        console.log("getTeamsSimple");
	        console.dir(response);
	        if (response.data.length > 0) {
	          try {
	            response.data.forEach(function (team, index) {
	              var teamsObj = {};
	              teamsObj.name = team.name;
	              teamsObj.id = team.id;
	              teamsSimple.push(teamsObj);
	            });
	          } finally {
	            console.log("what are the teams");
	            console.dir(teamsSimple);
	            _this.teams_for_modal = teamsSimple;
	            _this.add_users_to_team_ui.dropdown_placeholder = teamsSimple[0].id;
	            _this.$timeout(function () {
	              _this.add_users_to_team_ui.loading_teams = false;
	            }, 500);
	          }
	        } else {
	          _this.add_users_to_team_ui.loading_teams = false;
	        }
	      }, function (data) {
	        _this.add_user_to_team_error = "There was an error";
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "teamsChanged",
	    value: function teamsChanged() {
	      var _this = this;
	      console.log("teamsChanged");
	      console.dir(_this.add_users_to_team_ui.dropdown_placeholder);
	    }
	  }, {
	    key: "submitTeamAdd",
	    value: function submitTeamAdd() {
	      var _this = this;
	      console.log("submitTeamAdd");
	      console.dir(_this.user_to_add);
	      console.dir(_this.add_users_to_team_ui.dropdown_placeholder);
	      _this.submitting = true;
	      var circle = parseInt(_this.add_users_to_team_ui.dropdown_placeholder, 10);
	      var email = _this.user_to_add.email;
	      _this.$companies.updateCloudWithNewUser(circle, email).then(function (response) {
	        if (response.data.status === "error") {
	          alert("error adding user to team");
	        } else {
	          console.log("update cloud resp");
	          console.dir(response);
	          _this.success = "Jobbler was successfully added to team!";
	          _this.$timeout(function () {
	            $("#modal-add-to-team-jobbler").modal("toggle");
	          }, 1500);
	        }
	      }, function (error) {
	        console.log("adding user error");
	        console.dir(error);
	        _this.submitting = false;
	      });
	    }
	  }, {
	    key: "closeTeamAdd",
	    value: function closeTeamAdd() {
	      var _this = this;
	      console.log("closeTeamAdd");
	    }
	  }, {
	    key: "do_we_have_teams",
	    value: function do_we_have_teams() {
	      var _this = this;
	      console.log("have the teams loaded");
	      console.dir(this.$rootScope.teamsSimple);
	      _this.loadTeams();
	    }
	  }]);
	
	  return EventcompleteController;
	}();
	
	EventcompleteController.$inject = ["$http", "$localStorage", "$scope", "$state", "auth", "companies", "events", "$stateParams", "security", "$rootScope", "env", "$timeout", "$location", "ngProgressFactory", "common", "NgMap", "tracking"];
	
	exports.default = EventcompleteController;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(505);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventcomplete.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventcomplete.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "eventcomplete #wrapper{min-height:calc(100% - 62px)}", ""]);
	
	// exports


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _eventshistory = __webpack_require__(507);
	
	var _eventshistory2 = _interopRequireDefault(_eventshistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventshistoryModule = _angular2.default.module("eventshistory", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("eventshistory", {
	    url: "/events-history",
	    template: "<eventshistory></eventshistory>"
	  });
	}).component("eventshistory", _eventshistory2.default);
	
	exports.default = eventshistoryModule;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventshistory = __webpack_require__(508);
	
	var _eventshistory2 = _interopRequireDefault(_eventshistory);
	
	var _eventshistory3 = __webpack_require__(509);
	
	var _eventshistory4 = _interopRequireDefault(_eventshistory3);
	
	__webpack_require__(510);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventshistoryComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _eventshistory2.default,
	  controller: _eventshistory4.default,
	  controllerAs: "vm"
	};
	
	exports.default = eventshistoryComponent;

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n<div id=\"wrapper\">\n  <section class=\"content\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\" ng-if=\"vm.events.length == 0\">\n          <div class=\"event-table-container odd history\">\n            <h1>Job History</h1>\n            <div class=\"alert alert-info\" role=\"alert\"><strong>Jobble tip:</strong> You currently do not have any closed jobs.</div>\n          </div>\n        </div>\n\n        <div class=\"col-xs-12\" ng-if=\"vm.events.length > 0\">\n          <div class=\"event-table-container odd history\">\n            <h1>History</h1>\n            <div class=\"search-option clearfix\">\n              <span>See your past jobs and related invoices.</span>\n              <form class=\"pull-right\">\n                <div class=\"search-container clearfix\">\n                  <a href=\"#\" class=\"magnify\" ng-click=\"vm.clickMagnify()\"></a>\n                  <input type=\"search\" ng-model=\"vm.query\" />\n                  <a href=\"#\" class=\"close-search\" ng-click=\"vm.closeSearch()\"> <img src=\"/app/vendor/images/search-close.png\" alt=\"\" /></a>\n                </div>\n              </form>\n            </div>\n\n            <a class=\"profile-menu-small\" href=\"#\" ng-click=\"vm.slideToggle()\">Menu</a>\n            <ul class=\"profile-menu\">\n              <li ng-repeat=\"option in vm.navOptions\" class=\"{{ option.isActive }}\" ng-click=\"vm.navigateProfilePage(option.type)\">\n                {{ option.value }}\n              </li>\n            </ul>\n            <table cellpadding=\"0\" cellspacing=\"0\">\n              <tr>\n                <th>Job</th>\n                <th>Location</th>\n                <th>Job Date</th>\n                <th>Hired Jobblers</th>\n                <th>&nbsp;</th>\n              </tr>\n              <tr ng-repeat=\"event in vm.events | filter: vm.query\">\n                <td>{{event.name}}</td>\n                <td>{{event.contactInfo.streetLine1}}</td>\n                <td>{{vm.getEventDate(event.startTime)}}</td>\n                <td>{{event.numberOfApprovedApplications - event.totalNumberOfNoShows }}</td>\n                <td class=\"dropdown\" ng-click=\"vm.setEvent(event)\">\n                  <a href=\"#\" class=\"btn dropdown-toggle pro-btn\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\"\n                    >Actions</a\n                  >\n                  <ul class=\"dropdown-menu\">\n                    <!--<li ng-if=\"event.firstInvoices[0].url\">\n                    \t<a href=\"{{ event.firstInvoices[0].url }}\" target=\"_blank\">View invoice</a>\n                    </li>-->\n                    <li ng-if=\"event.firstInvoices[0].payment.id\">\n                      <a href=\"/invoice/{{ event.firstInvoices[0].payment.id }}?eventId={{event.id}}\" target=\"_blank\">View invoice</a>\n                    </li>\n                    <li ng-if=\"event.firstInvoices[0].cdnUrl\">\n                      <a href=\"{{ event.firstInvoices[0].cdnUrl }}\" target=\"_blank\">View PDF</a>\n                    </li>\n                    <li>\n                      <a href=\"/event/{{ event.id }}/overview\">Overview</a>\n                    </li>\n                    <li>\n                      <a href=\"/messages/event/{{ event.id }}\">Messages</a>\n                    </li>\n                    <li>\n                      <a href=\"/event/{{ event.id }}/roster\">Roster</a>\n                    </li>\n                    <li>\n                      <a href=\"/post-a-shift/walkthrough?cid={{ event.id }}\">Clone</a>\n                    </li>\n                    <li>\n                      <a href=\"/event/{{ event.id }}/complete\">Recap</a>\n                    </li>\n                  </ul>\n                </td>\n              </tr>\n            </table>\n\n            <ul ng-if=\"vm.pages.length > 1 && vm.activeTab == 'complete'\" class=\"pagination event-pagination\" style=\"width: 500px\">\n              <li class=\"arrow unavailable\" ng-disabled=\"vm.currentPageNumber == 1\" ng-click=\"vm.paginate(vm.currentPageNumber - 1)\">\n                <a href=\"\">«</a>\n              </li>\n              <li ng-repeat=\"page in vm.pages\" ng-click=\"vm.paginate(page)\" ng-class=\"{'active': vm.currentPageNumber == page}\">\n                <a href=\"\">{{page}}</a>\n              </li>\n              <li class=\"arrow\" ng-disabled=\"vm.currentPageNumber == vm.pages.length\" ng-click=\"vm.paginate(vm.currentPageNumber + 1)\">\n                <a href=\"\">»</a>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n<jobblefooter></jobblefooter>\n\n<script type=\"text/javascript\">\n  jQuery(window).on(function (e) {\n    jQuery(\".search-option a.magnify\").click(function () {\n      jQuery(this).parent().addClass(\"s-open\");\n      return false;\n    });\n\n    jQuery(\".search-option a.close-search\").click(function () {\n      jQuery(this).parent().removeClass(\"s-open\");\n    });\n  });\n</script>\n\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventshistoryController = function () {
	  function EventshistoryController($http, $localStorage, $state, AuthService, EventsService, $location, $timeout) {
	    _classCallCheck(this, EventshistoryController);
	
	    this.name = "eventshistory";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$timeout = $timeout;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$events = EventsService;
	    this.activeTab = "complete";
	    this.$location = $location;
	    this.currentUser = this.$auth.getUserData();
	    this.remain_loading_count = 1;
	    this.currentPageNumber = 1;
	    this.events = [];
	    this.query = "";
	    this.navOptions = [{
	      type: "complete",
	      isActive: "profile-menu-active",
	      value: "Completed jobs"
	    }, { type: "cancelled", isActive: "", value: "Cancelled jobs" }];
	
	    var _this = this;
	
	    console.log("what is this");
	    console.dir(_this.$state);
	    console.log("what is the current user");
	    console.dir(_this.currentUser);
	
	    this.remain_loading_count--;
	
	    this.$events.get_history("isCompleted", this.$localStorage.logged_user.companyId, 0, 10, "isCompleted", "lastUpdated", "desc").then(function (data) {
	      _this.events = data.data;
	      _this.remain_loading_count = 0;
	      _this.calculatePagination();
	    }, function (data) {
	      _this.events = [];
	      _this.remain_loading_count++;
	      if (data.status === 401) {
	        _this.$state.go("signin");
	      } else {
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      }
	    });
	
	    $("jobbleheader .main-menu ul li:nth-child(3)").removeClass().addClass("active");
	
	    if (_this.$location.$$hash === "modal-complete-last-event-confirm-modal") {
	      jQuery(".modal-backdrop").remove();
	      jQuery("body").removeClass("modal-open");
	    }
	  }
	
	  _createClass(EventshistoryController, [{
	    key: "navigateProfilePage",
	    value: function navigateProfilePage(type) {
	      var _this = this;
	
	      _this.remain_loading_count++;
	      this.navOptions.forEach(function (option) {
	        if (option.type === type) {
	          option.isActive = "profile-menu-active";
	        } else {
	          option.isActive = "";
	        }
	      });
	
	      if (type === "complete") {
	        console.log("in complete");
	        this.activeTab = "complete";
	        this.$events.get_history("isCompleted", this.$localStorage.logged_user.companyId, 0, 20, "isCompleted", "lastUpdated", "desc").then(function (data) {
	          _this.events = data.data;
	          _this.remain_loading_count--;
	        }, function (data) {
	          _this.events = [];
	        });
	      }
	
	      if (type === "cancelled") {
	        this.activeTab = "cancelled";
	        this.$events.get_history("isCancelled", this.$localStorage.logged_user.companyId, 0, 20, "isCompleted", "lastUpdated", "desc").then(function (data) {
	          _this.events = data.data;
	          _this.remain_loading_count--;
	        }, function (data) {
	          console.log(data);
	          _this.events = [];
	        });
	      }
	    }
	  }, {
	    key: "getEventDate",
	    value: function getEventDate(raw_date) {
	      var date = new Date(raw_date);
	      return moment(date).format("MMM DD, YYYY");
	    }
	  }, {
	    key: "clickMagnify",
	    value: function clickMagnify() {
	      jQuery(".search-container").addClass("s-open");
	      jQuery(".search-container").find('input[type="search"]').focus();
	    }
	  }, {
	    key: "closeSearch",
	    value: function closeSearch() {
	      jQuery(".search-container").removeClass("s-open");
	      this.query = "";
	    }
	  }, {
	    key: "calculatePagination",
	    value: function calculatePagination() {
	      this.pages = [];
	      console.log("calc page");
	      console.dir(this.$localStorage);
	
	      if (!this.$localStorage.logged_user.company) {
	        this.pages.push(1);
	      } else {
	        var numberOfEvents = Math.ceil(this.$localStorage.logged_user.company.totalNumberOfCloseEvents / 10);
	        for (var i = 0; i < numberOfEvents; i++) {
	          this.pages.push(i + 1);
	        }
	      }
	    }
	  }, {
	    key: "paginate",
	    value: function paginate(pageNumber) {
	      console.log("go to this page");
	
	      if (pageNumber < 1 || pageNumber > this.pages.length) {
	        return;
	      }
	
	      this.currentPageNumber = pageNumber;
	      this.remain_loading_count = 1;
	      this.events = [];
	
	      var companyId = this.$localStorage.logged_user.companyId;
	      var offsetParam = pageNumber * 10 - 10,
	          maxParam = 10,
	          page = "live",
	          sort = "lastUpdated",
	          order = "desc";
	
	      var _this = this;
	
	      this.$events.get_history("isCompleted", companyId, offsetParam, maxParam, page, sort, order).then(function (data) {
	        _this.events = data.data;
	        console.log(_this.events);
	        _this.remain_loading_count--;
	      }, function (data) {
	        console.log(data);
	        _this.events = [];
	        _this.remain_loading_count--;
	      });
	    }
	  }]);
	
	  return EventshistoryController;
	}();
	
	EventshistoryController.$inject = ["$http", "$localStorage", "$state", "auth", "events", "$location", "$timeout"];
	
	exports.default = EventshistoryController;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(511);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventshistory.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./eventshistory.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "eventshistory #wrapper{min-height:calc(100% - 62px)}", ""]);
	
	// exports


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _invoice = __webpack_require__(513);
	
	var _invoice2 = _interopRequireDefault(_invoice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var invoiceModule = _angular2.default.module("invoice", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("invoice", {
	    url: "/invoice/:invoiceId",
	    template: "<invoice></invoice>"
	  });
	}).component("invoice", _invoice2.default);
	
	exports.default = invoiceModule;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _invoice = __webpack_require__(514);
	
	var _invoice2 = _interopRequireDefault(_invoice);
	
	var _invoice3 = __webpack_require__(515);
	
	var _invoice4 = _interopRequireDefault(_invoice3);
	
	__webpack_require__(516);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var invoiceComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _invoice2.default,
	  controller: _invoice4.default,
	  controllerAs: "vm"
	};
	
	exports.default = invoiceComponent;

/***/ }),
/* 514 */
/***/ (function(module, exports) {

	module.exports = "<!-- pdf-save-content=\"save-pdf-receipt\" -->\n\n<div id=\"wrapper\">\n  <section class=\"content-receipt\" id=\"receipt-data\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-xs-6\">\n          <div class=\"invoice-top-left\">\n            <img src=\"/app/vendor/images/jobble-logo-invoice.png\" />\n            <p><i>Staffing for business in the modern era</i></p>\n          </div>\n        </div>\n        <div class=\"col-xs-6\" style=\"text-align: right\" ng-if=\"vm.isdp\">\n          <div class=\"invoice-top-right\">\n            <h2>Receipt</h2>\n            <span class=\"invoice-header\">DATE:</span> {{ vm.invoice.dateCreated | date : 'shortDate' }}</span>\n            <p><strong>Invoice #:</strong> {{ vm.invoice.id }}</p>\n            <p><strong>Customer ID:</strong> {{ vm.invoice.payingUser.id }}</p>\n            <p><strong>Paying Customer Name:</strong> {{ vm.invoice.payingUser.firstName }} {{ vm.invoice.payingUser.lastName }}</p>\n            <p><strong>Paying Company Name:</strong> {{ vm.invoice.payingCompany.name }}</p>\n            <p ng-if=\"vm.currentUser.company.mainContactInfo.streetLine1\">{{ vm.currentUser.company.mainContactInfo.streetLine1 }}</p>\n            <p ng-if=\"vm.currentUser.company.mainContactInfo.state && vm.currentUser.company.mainContactInfo.zipCode\">\n              {{ vm.currentUser.company.mainContactInfo.city }} {{ vm.currentUser.company.mainContactInfo.state }}, {{\n              vm.currentUser.company.mainContactInfo.zipCode }}\n            </p>\n            <p ng-if=\"vm.currentUser.company.mainContactInfo.state && !vm.currentUser.company.mainContactInfo.zipCode\">\n              {{ vm.currentUser.company.mainContactInfo.city }} {{ vm.currentUser.company.mainContactInfo.state }}\n            </p>\n            <p>{{ vm.currentUser.company.mainContactInfo.phoneMobile }}</p>\n          </div>\n        </div>\n        <div class=\"col-xs-6\" style=\"text-align: right\" ng-if=\"!vm.isdp\">\n          <div class=\"invoice-top-right\">\n            <h2>Receipt</h2>\n            <p><strong>Date:</strong> {{ vm.invoice[0].dateCreated | date : 'shortDate' }}</p>\n            <p><strong>Invoice #:</strong> {{ vm.invoice[0].confirmation }}</p>\n            <p><strong>Customer ID:</strong> {{ vm.invoice[0].payingUser.id }}</p>\n            <br />\n            <p>{{ vm.invoice[0].payingUser.firstName }} {{ vm.invoice[0].payingUser.lastName }}</p>\n            <p>{{ vm.invoice[0].payingCompany.name }}</p>\n            <p ng-if=\"vm.currentUser.company.mainContactInfo.streetLine1\">{{ vm.currentUser.company.mainContactInfo.streetLine1 }}</p>\n            <p ng-if=\"vm.currentUser.company.mainContactInfo.state\">\n              {{ vm.currentUser.company.mainContactInfo.city }} {{ vm.currentUser.company.mainContactInfo.state }}, {{\n              vm.currentUser.company.mainContactInfo.zipCode }}\n            </p>\n            <p>{{ vm.currentUser.company.mainContactInfo.phoneMobile }}</p>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\" ng-if=\"!vm.isdp\">\n        <div class=\"col-xs-12\">\n          <div class=\"invoice-middle-top\">\n            <h3 style=\"padding-left: 0px; margin-bottom: 4px\">{{ vm.invoice[0].event[0].name }}</h3>\n            <p><strong>Start date:</strong> {{ vm.event.startTime | date : 'fullDate' }}</p>\n            <p><strong>End date:</strong> {{ vm.event.endTime | date : 'fullDate' }}</p>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\" ng-if=\"vm.isdp\">\n        <div class=\"col-xs-12\">\n          <div class=\"invoice-middle-top\">\n            <h3 style=\"padding-left: 7px; margin-bottom: 4px; font-size: 18px\">Direct Pay</h3>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\" ng-if=\"vm.isdp\">\n        <div class=\"col-xs-12\">\n          <div class=\"invoice-table\">\n            <table class=\"table\">\n              <thead>\n                <tr>\n                  <th>Date</th>\n                  <th>Recepient's Name</th>\n                  <th>Note</th>\n                  <th>Amount</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr>\n                  <td>{{ vm.invoice.dateCreated | date : 'shortDate' }}</td>\n                  <td>{{ vm.invoice.payedUser.firstName }} {{ vm.invoice.payedUser.lastName }}</td>\n                  <td>{{ vm.invoice.notePayer }}</td>\n                  <td>${{ vm.invoice.amountCompany / 100 | number : 2 }}</td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n          <div class=\"invoice-table-totals\">\n            <p><strong>Total:</strong>&nbsp;&nbsp;${{ vm.totals.total / 100 | number : 2 }}</p>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"row\" ng-if=\"!vm.isdp\">\n        <div class=\"col-xs-12\">\n          <div class=\"invoice-table\">\n            <table class=\"table\">\n              <thead>\n                <tr>\n                  <th>Date</th>\n                  <th>Recepient's Name</th>\n                  <th>Note</th>\n                  <th>Details</th>\n                  <th>Rate</th>\n                  <th>Hrs.</th>\n                  <th>Mins.</th>\n                  <th>Amount</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"i in vm.invoice\">\n                  <td>{{ i.dateCreated | date : 'shortDate' }}</td>\n                  <td>{{ i.payedUser.firstName }} {{ i.payedUser.lastName }}</td>\n                  <td>{{ i.notePayer }}</td>\n                  <td style=\"width: 436px\">{{ i.detailTransactionCompany }}</td>\n                  <td>${{ i.jobble.payPerHour / 100 | number : 2 }}</td>\n                  <td style=\"text-align: center\">{{ vm.displayHours(i.jobble) }}</td>\n                  <td style=\"text-align: center\">{{ vm.displayMins(i.jobble) }}</td>\n                  <td>${{ i.amountCompany / 100 | number : 2 }}</td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n          <div class=\"invoice-table-totals\">\n            <p><strong>Total:</strong>&nbsp;&nbsp;${{ vm.totals.total / 100 | number : 2 }}</p>\n          </div>\n        </div>\n\n        <!--\n\t\t    \t<div class=\"col-xs-12\">\n\t\t    \t\t<a class=\"pdf-button\" href=\"#\" ng-click=\"vm.pdf()\">Download PDF</a>\n\t\t    \t</div>\n\t\t    \t-->\n        <!--\n\t\t    \t<div class=\"col-xs-12\">\n\t\t    \t\t<a class=\"pdf-button\" href=\"#\" onclick=\"HTMLtoPDF()\">Download PDF</a>\n\t\t    \t</div>\n\t\t    \t-->\n        <!--\n\t\t    \t<div class=\"col-xs-12\">\n\t\t    \t\t<screenshot target=\"{{::'#receipt-data'}}\" is-open=\"vm.target1Open\" toolbox-options=\"vm.target1Options\"></screenshot>\n\t\t    \t</div>\n\t\t    \t-->\n        <!-- pdf-save-button=\"save-pdf-receipt\" pdf-name=\"receipt.pdf\" -->\n      </div>\n    </div>\n  </section>\n</div>\n\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var InvoiceController = function () {
	  function InvoiceController($http, $localStorage, $state, $stateParams, AuthService, EventsService, CompaniesService, SecurityService, $rootScope, CommonService, EnvService, $timeout, $location, $scope) {
	    _classCallCheck(this, InvoiceController);
	
	    this.name = "invoice";
	    $localStorage.activeStateName = "invoice";
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$auth = AuthService;
	    this.$companies = CompaniesService;
	    this.$events = EventsService;
	    this.$stateParams = $stateParams;
	    this.$location = $location;
	    this.$security = SecurityService;
	    this.$rootScope = $rootScope;
	    this.query = "";
	    this.$common = CommonService;
	    this.$env = EnvService;
	    this.$timeout = $timeout;
	    this.isPrivate = false;
	    this.isPreferred = false;
	    this.remain_loading_count = 1;
	    this.event = {};
	    this.teamsPostedTo = [];
	    this.acceptedApplicants = [];
	    this.currentUser = this.$auth.getUserData();
	    this.events = [];
	    this.isdp = false;
	    this.target1Options = {
	      filename: "target1.png",
	      downloadText: "Download me",
	      cancelText: "Close it!"
	    };
	
	    var _this = this;
	
	    _this.isDirectPayReceipt();
	
	    if (this.$location.$$search.eventId) {
	      this.$events.getEventByIdTrimmedInvoice(this.$location.$$search.eventId).then(function (data) {
	        _this.event = data.data;
	        _this.jobbleDuration = data.data.subEvents[0].deduppedJobbles[0].jobbleDurationInMinutes;
	        _this.$security.getInvoice(_this.$stateParams.invoiceId, _this.$location.$$search.eventId).then(function (response) {
	          console.log("invoice response");
	          console.dir(response);
	          _this.remain_loading_count--;
	          response.data.sort(function (a, b) {
	            if (a.payedUser.lastName < b.payedUser.lastName) return -1;
	            if (a.payedUser.lastName > b.payedUser.lastName) return 1;
	            return 0;
	          });
	          _this.invoice = response.data;
	          _this.displayTotals();
	        });
	      });
	    } else {
	      _this.$security.getInvoice(_this.$stateParams.invoiceId, _this.$location.$$search.eventId).then(function (response) {
	        _this.remain_loading_count--;
	        _this.invoice = response.data;
	        _this.displayTotalsDP();
	      });
	    }
	
	    _this.formatNumber();
	  }
	
	  _createClass(InvoiceController, [{
	    key: "isDirectPayReceipt",
	    value: function isDirectPayReceipt() {
	      var _this = this;
	      if (this.$location.$$search.dp) {
	        _this.isdp = true;
	      }
	    }
	  }, {
	    key: "formatNumber",
	    value: function formatNumber() {
	      var _this = this;
	    }
	  }, {
	    key: "displayHours",
	    value: function displayHours(jobble) {
	      var _this = this;
	      if (jobble.actualMinutesWorked !== null) {
	        var hours = Math.floor(jobble.actualMinutesWorked / 60);
	        return hours;
	      } else {
	        //var diffinmin = moment(jobble.endTime).diff(moment(jobble.startTime), 'minutes');
	        var hours = Math.floor(_this.jobbleDuration / 60);
	
	        //console.dir(hours);
	        return hours;
	      }
	    }
	  }, {
	    key: "displayMins",
	    value: function displayMins(jobble) {
	      var _this = this;
	      if (jobble.actualMinutesWorked !== null) {
	        var hours = Math.floor(jobble.actualMinutesWorked / 60);
	        var leftovers = jobble.actualMinutesWorked - hours * 60;
	        var min = leftovers % 60;
	        return min;
	      } else {
	        var hours = Math.floor(_this.jobbleDuration / 60);
	        var leftovers = _this.jobbleDuration - hours * 60;
	        var min = leftovers % 60;
	        return min;
	      }
	    }
	  }, {
	    key: "displayTotals",
	    value: function displayTotals() {
	      var _this = this;
	
	      _this.totals = {};
	
	      var subtotal = 0;
	      var total = 0;
	
	      try {
	        _this.invoice.forEach(function (iv) {
	          subtotal = subtotal + iv.amount;
	          total = total + iv.amountCompany;
	        });
	      } finally {
	        _this.totals.subtotal = subtotal;
	        _this.totals.total = total;
	
	        return _this.totals;
	      }
	    }
	  }, {
	    key: "displayTotalsDP",
	    value: function displayTotalsDP() {
	      var _this = this;
	
	      _this.totals = {};
	
	      var subtotal = 0;
	      var total = 0;
	
	      console.log("invoice");
	      console.dir(_this.invoice);
	
	      _this.totals.subtotal = _this.invoice.amount;
	      _this.totals.total = _this.invoice.amountCompany;
	
	      return _this.totals;
	    }
	  }, {
	    key: "pdf",
	    value: function pdf() {
	      var _this = this;
	      html2canvas(document.getElementById("receipt-data")).then(function (canvas) {
	        var imgData = canvas.toDataURL("image/png");
	        var doc = new jsPDF("p", "mm");
	        doc.addImage(imgData, "PNG", 10, 10, 180, 150);
	        doc.save("sample-file.pdf");
	      });
	    }
	  }, {
	    key: "specialElementHandlers",
	    value: function specialElementHandlers() {
	      var _this = this;
	    }
	  }]);
	
	  return InvoiceController;
	}();
	
	InvoiceController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "events", "companies", "security", "$rootScope", "common", "env", "$timeout", "$location", "$scope"];
	
	exports.default = InvoiceController;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(517);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./invoice.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./invoice.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "eventoverview #wrapper{min-height:calc(100% - 62px)}", ""]);
	
	// exports


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _jobbler = __webpack_require__(519);
	
	var _jobbler2 = _interopRequireDefault(_jobbler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobblerModule = _angular2.default.module("jobbler", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("jobbler", {
	    url: "/jobbler/:jobblerId",
	    template: "<jobbler></jobbler>",
	    title: "Your Profile",
	    params: { job: null, check_user: null }
	  });
	}).component("jobbler", _jobbler2.default);
	
	exports.default = jobblerModule;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobbler = __webpack_require__(520);
	
	var _jobbler2 = _interopRequireDefault(_jobbler);
	
	var _jobbler3 = __webpack_require__(521);
	
	var _jobbler4 = _interopRequireDefault(_jobbler3);
	
	__webpack_require__(522);
	
	__webpack_require__(524);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobblerComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _jobbler2.default,
	  controller: _jobbler4.default,
	  controllerAs: "vm"
	};
	
	exports.default = jobblerComponent;

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<!--------------------- Container --------------------->\n<div class=\"content-wrapper\" style=\"margin-top: 30px\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12\">\n        <div class=\"profile-select-container\">\n          <div class=\"profile-image-holder\">\n            <div class=\"image-container\"\n              style=\"background-image: url({{($root.imgFromProfilePage || (vm.currentUser.profilePictureUri))}})\">\n              <div class=\"edit-wrapper\" ng-if=\"$root.imgFromProfilePage || vm.currentUser.profilePictureUri\">\n                <div class=\"upload-btn-wrapper\">\n                  <button class=\"btn\"><i class=\"fas fa-pen\"></i> Edit</button>\n                  <input id=\"profile-photo-upload\" type=\"file\" accept=\"image/*\"\n                    onchange=\"angular.element(this).scope().vm.uploadProfilePhoto()\" name=\"myfile\" />\n                </div>\n              </div>\n              <div class=\"upload-wrapper\" ng-if=\"!$root.imgFromProfilePage && !vm.currentUser.profilePictureUri\">\n                <div class=\"upload-btn-wrapper\">\n                  <button class=\"btn\">Upload photo</button>\n                  <input id=\"profile-photo-upload\" type=\"file\" accept=\"image/*\"\n                    onchange=\"angular.element(this).scope().vm.uploadProfilePhoto()\" name=\"myfile\" />\n                </div>\n              </div>\n            </div>\n\n            <h2>{{vm.jobbler_data.first_name}} {{vm.jobbler_data.last_name}}</h2>\n          </div>\n          <div class=\"\">\n            <div class=\"desktop-choices\">\n              <div ng-click=\"vm.setMobileActiveTab(1)\" class=\"profile-card\" ng-class=\"{'selected':vm.page==1}\">\n                <a>PERSONAL DETAILS\n                  <div ng-if=\"vm.userProfileStatus <= 3\" class=\"indicator\"></div>\n                </a>\n              </div>\n              <div ng-click=\"vm.setMobileActiveTab(5)\" class=\"profile-card\" ng-class=\"{'selected':vm.page==5}\">\n                <a>PREFERENCES\n                  <div ng-if=\"!vm.jobTypesCompleted\" class=\"indicator\"></div>\n                </a>\n              </div>\n              <!--\n              <div\n                ng-click=\"vm.setMobileActiveTab(4)\"\n                class=\"profile-card\"\n                ng-class=\"{'selected':vm.page==4, 'disabled-tab': vm.profile_not_complete==true}\"\n              >\n                <a>PAYMENT SETTINGS</a>\n              </div>\n            -->\n            </div>\n            <div class=\"mobile-choices\">\n              <div class=\"profile-card\" ng-class=\"{'selected':vm.page==1}\"\n                ng-click=\"vm.setMobileActiveTab(1); vm.toggleModal()\">\n                <a>PERSONAL DETAILS\n                  <div ng-if=\"vm.userProfileStatus <= 3\" class=\"indicator\"></div>\n                </a>\n              </div>\n              <div class=\"profile-card\" ng-class=\"{'selected':vm.page==5}\"\n                ng-click=\"vm.setMobileActiveTab(5); vm.toggleModal()\">\n                <a>PREFERENCES\n                  <div ng-if=\"!vm.jobTypesCompleted\" class=\"indicator\"></div>\n                </a>\n              </div>\n              <!--\n              <div class=\"profile-card\"\n                ng-class=\"{'selected':vm.page==4, 'disabled-tab': vm.profile_not_complete==true}\"\n                ng-click=\"vm.setMobileActiveTab(4); vm.toggleModal()\">\n                <a>PAYMENT SETTINGS</a>\n              </div>\n            -->\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"col-lg-9 col-md-9 col-sm-9 col-xs-12 jobbler-desktop-screen\">\n        <basicprofile ng-if=\"vm.page==1\"></basicprofile>\n        <preferences ng-if=\"vm.page==5\"></preferences>\n        <banking ng-if=\"vm.page==4\"></banking>\n      </div>\n\n      <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12 jobbler-mobile-screen\" ng-if=\"vm.showModal\">\n        <div class=\"mobile-header\">\n          <i ng-click=\"vm.toggleModal()\" class=\"fas fa-chevron-left\"></i>\n          <h1>Edit Profile</h1>\n        </div>\n        <div class=\"mobile-container\">\n          <basicprofile ng-if=\"vm.page==1\" toggle-modal=\"vm.toggleModal\"></basicprofile>\n          <preferences ng-if=\"vm.page==5\" toggle-modal=\"vm.toggleModal\"></preferences>\n          <banking ng-if=\"vm.page==4\"></banking>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<globalalert></globalalert>\n<verification></verification>\n\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>"

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobblerController = function () {
	  function JobblerController($http, $localStorage, $state, $stateParams, AuthService, ProfileService, EventsService, CompaniesService, SecurityService, $rootScope, CommonService, EnvService, $timeout, $location, $scope, JobsService) {
	    var _this2 = this;
	
	    _classCallCheck(this, JobblerController);
	
	    this.name = "jobbler";
	    $localStorage.activeStateName = "jobbler";
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$auth = AuthService;
	    this.$companies = CompaniesService;
	    this.$events = EventsService;
	    this.$stateParams = $stateParams;
	    this.$location = $location;
	    this.$security = SecurityService;
	    this.$rootScope = $rootScope;
	    this.$profile = ProfileService;
	    this.$common = CommonService;
	    this.$env = EnvService;
	    this.$timeout = $timeout;
	    this.$jobs = JobsService;
	    this.remain_loading_count = 0;
	    this.currentUser = this.$auth.getUserData();
	    this.jobbler_data = {};
	    this.profile_not_complete = true;
	    this.jobbler_data.first_name = this.currentUser.firstName;
	    this.jobbler_data.last_name = this.currentUser.lastName;
	    var _this = this;
	
	    _this.setActiveTab();
	    this.userProfileStatus = this.$profile.getUserProfileStatus(this.currentUser);
	    this.jobTypesCompleted = this.currentUser && this.currentUser.notifPref && this.currentUser.notifPref.jobbleTypes && this.currentUser.notifPref.jobbleTypes.length !== 0;
	
	    if (!_this.$localStorage.logged_user.prof_image) {
	      _this.getProfilePicture();
	    }
	
	    this.SetProfileImageForJobblerListener = this.$rootScope.$on("SetProfileImageForJobbler", function ($event, params) {
	      _this.jobbler_data = params.user;
	      _this.getProfilePicture();
	    });
	
	    this.SetCoverImageForJobblerListener = this.$rootScope.$on("SetCoverImageForJobbler", function ($event, params) {
	      _this.cover_photo = params.image;
	      _this.getProfilePicture();
	    });
	
	    this.SettingNewUserDataToParentListener = this.$rootScope.$on("SettingNewUserDataToParent", function ($event, params) {
	      _this.currentUser = params;
	    });
	
	    this.ProfileStatusCheckListener = this.$rootScope.$on("ProfileStatusCheck", function ($event, params) {
	      console.log("ProfileStatusCheckListener");
	      console.dir(params);
	      _this2.check_status_for_banking_tab(params);
	
	      _this2.$jobs.canUserApplyToShiftBasedJobs().then(function (response) {
	        console.log("Most recent user");
	        console.dir(response.data);
	
	        _this2.currentUser = response.data;
	        _this2.userProfileStatus = _this2.$profile.getUserProfileStatus(_this2.currentUser);
	        _this2.jobTypesCompleted = _this2.currentUser && _this2.currentUser.notifPref && _this2.currentUser.notifPref.jobbleTypes && _this2.currentUser.notifPref.jobbleTypes.length !== 0;
	      });
	    });
	
	    _this.$scope.$on("$destroy", _this.SettingNewUserDataToParentListener);
	    _this.$scope.$on("$destroy", _this.SetProfileImageForJobblerListener);
	    _this.$scope.$on("$destroy", _this.SetCoverImageForJobblerListener);
	    //console.log("state params");
	    //console.dir(_this.$stateParams);
	    if (_this.$stateParams.job && _this.$stateParams.check_user === true) {
	      _this.checkUserForFields();
	    }
	
	    this.toggleModal = this.toggleModal.bind(this);
	  }
	
	  _createClass(JobblerController, [{
	    key: "toggleModal",
	    value: function toggleModal() {
	      this.showModal = !this.showModal;
	    }
	  }, {
	    key: "getProfilePicture",
	    value: function getProfilePicture() {
	      var _this3 = this;
	
	      this.$profile.getProfilePicture(this.currentUser.access_token).then(function (response) {
	        console.log("get profile picture response");
	        console.dir(response);
	
	        _this3.unSetLoader();
	
	        _this3.$timeout(function () {
	          if (response.data.picture1) {
	            _this3.jobbler_data.image = response.data.picture1;
	            _this3.$localStorage.logged_user.prof_image = response.data.picture1;
	          } else {
	            _this3.jobbler_data.image = "/app/vendor/images/defaultimg.jpeg";
	            _this3.$localStorage.logged_user.prof_image = "/app/vendor/images/defaultimg.jpeg";
	          }
	          if (response.data.resumeLink) {
	            _this3.resume_url = response.data.resumeLink;
	          } else if (response.data.resumeLink2) {
	            _this3.resume_url = response.data.resumeLink2;
	            _this3.$localStorage.logged_user.resumeLink = response.data.resumeLink2;
	          }
	          if (response.data.picture2) {
	            _this3.jobbler_data.cover_photo = response.data.picture2;
	            _this3.$localStorage.logged_user.cover_photo = response.data.picture2;
	          } else {
	            _this3.jobbler_data.cover_photo = "/app/vendor/images/default-cover-photo.jpg";
	            _this3.$localStorage.logged_user.cover_photo = "/app/vendor/images/default-cover-photo.jpg";
	          }
	        });
	      }, function (error) {
	        //console.log("in error");
	        //console.dir(error);
	      });
	    }
	  }, {
	    key: "findPage",
	    value: function findPage() {
	      var _this = this;
	      var path = _this.$location.$$path;
	      var page = null;
	      if (path.indexOf("gallery") > -1) {
	        page = 2;
	      } else if (path.indexOf("banking") > -1) {
	        page = 4;
	      } else if (path.indexOf("social") > -1) {
	        page = 3;
	      } else {
	        page = 1;
	      }
	      _this.setActiveTab(page);
	    }
	  }, {
	    key: "validate_basic_prof",
	    value: function validate_basic_prof() {
	      var _this = this;
	
	      console.log("validate_basic_prof");
	      console.dir(_this.currentUser);
	    }
	  }, {
	    key: "setMobileActiveTab",
	    value: function setMobileActiveTab(page) {
	      if (page === 4 && this.profile_not_complete === true) {
	        alert("Before you can add your payment settings, make sure to input your personal details first.");
	        return;
	      }
	
	      this.page = page;
	    }
	  }, {
	    key: "setActiveTab",
	    value: function setActiveTab(page) {
	      var _this = this;
	
	      var path = this.$location.$$path;
	
	      if (path.indexOf("gallery") > -1) {
	        this.page = 2;
	      } else if (path.indexOf("banking") > -1) {
	        this.page = 4;
	      } else if (path.indexOf("social") > -1) {
	        this.page = 3;
	      } else if (path.indexOf("preferences") > -1) {
	        this.page = 5;
	      } else {
	        if (page === 4 && this.profile_not_complete) {
	          // alert("Before you add your banking information please fill in your : " + _this.error_string);
	        } else {
	          this.page = 1;
	        }
	      }
	    }
	  }, {
	    key: "uploadProfilePhoto",
	    value: function uploadProfilePhoto() {
	      var _this4 = this;
	
	      console.log("Uploading photo");
	
	      var file = $("#profile-photo-upload")[0].files[0];
	      console.log(file);
	      var fd = new FormData();
	      fd.append("file", file);
	      console.log(fd);
	
	      this.setLoader();
	
	      this.$profile.uploadProfilePicture(fd).then(function (res) {
	        console.log("photo rest", res);
	        if (res.status === 200) {
	          _this4.getPhotos(true);
	        }
	      });
	    }
	  }, {
	    key: "getPhotos",
	    value: function getPhotos(is_profile_picture, init, is_cover_photo, is_edit) {
	      var _this5 = this;
	
	      this.$profile.getMultiMediaDataWithFormats().then(function (response) {
	        _this5.setMultiMediaData(response.data, is_profile_picture, init, is_cover_photo, is_edit);
	      }, function (error) {
	        alert("Error grabbing multimedia");
	      });
	    }
	  }, {
	    key: "setMultiMediaData",
	    value: function setMultiMediaData(user, is_profile_picture, init, is_cover_photo, is_edit) {
	      var _this6 = this;
	
	      var data_model = {};
	      data_model.picture_data = this.$profile.getJobblerPictures(user, is_edit, this.model);
	      this.model = data_model;
	
	      var left_rail_data = {};
	
	      left_rail_data.image = this.model.picture_data.main_picture;
	      left_rail_data.image_only = true;
	      left_rail_data.first_name = this.currentUser.firstName;
	      left_rail_data.last_name = this.currentUser.lastName;
	
	      this.$auth.refreshCurrentUser().then(function () {
	        _this6.$timeout(function () {
	          _this6.currentUser = _this6.$auth.getUserData();
	          _this6.$rootScope.imgFromProfilePage = _this6.model.picture_data.main_picture;
	          _this6.$rootScope.$emit("SetProfileImageForJobbler", {
	            user: left_rail_data
	          });
	          _this6.getProfilePicture();
	        });
	      });
	    }
	  }, {
	    key: "resumeModal",
	    value: function resumeModal() {
	      var _this = this;
	      console.log("in resume modal");
	      var user = _this.currentUser;
	      _this.$timeout(function () {
	        $("#resume-upload-modal").modal();
	        _this.$rootScope.$emit("SetResumeData", { user: user });
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "checkUserForFields",
	    value: function checkUserForFields() {
	      var _this = this;
	      var job = _this.$stateParams.job;
	      var user = _this.currentUser;
	
	      //console.log("checkUserforFields");
	      //console.dir(job);
	      //console.dir(user);
	      if (user.dateBirth && user.homeContactInfo.phoneMobile && user.ssn && user.homeContactInfo.zipCode && user.homeContactInfo.city && user.homeContactInfo.streetLine1 && user.homeContactInfo.state) {
	        if (!user.profilePictureUri) {
	          _this.$state.go("jobblergallery", {
	            job: job,
	            user: user,
	            display_warning: true
	          });
	        } else {
	          //console.log("this means we have all the data and can go to the job page....");
	        }
	      } else {
	        //console.log("set the job for basic");
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetJobForApplicationAfterBasicFilled", {
	            job: job
	          });
	        });
	      }
	    }
	  }, {
	    key: "check_status_for_banking_tab",
	    value: function check_status_for_banking_tab(data) {
	      var _this = this;
	
	      var x = data.error_model;
	
	      console.log("check_status_for_banking_tab");
	      console.dir(x);
	
	      if (x.phone === true || x.ssn === true || x.address1 === true || x.city === true || x.state === true || x.month === true) {
	        _this.error_string = "";
	        _this.profile_not_complete = true;
	        if (x.phone === true) {
	          _this.error_string = _this.error_string + "Phone, ";
	        }
	        if (x.ssn === true) {
	          _this.error_string = _this.error_string + "Social Security Number, ";
	        }
	        if (x.address1 === true) {
	          _this.error_string = _this.error_string + "Address, ";
	        }
	        if (x.month === true) {
	          _this.error_string = _this.error_string + "Date of birth, ";
	        }
	
	        var len = _this.error_string.length;
	        var len2 = len - 2;
	        _this.error_string = _this.error_string.substring(0, len2);
	      } else {
	        _this.profile_not_complete = false;
	      }
	    }
	  }]);
	
	  return JobblerController;
	}();
	
	JobblerController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "profile", "events", "companies", "security", "$rootScope", "common", "env", "$timeout", "$location", "$scope", "jobs"];
	
	exports.default = JobblerController;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(523);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobbler.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobbler.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(525);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".profile-select-container{border:1px solid #adbcc2;border-radius:6px;background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.2)}.profile-select-container .profile-image-holder h2{color:#33373a;font-family:Poppins,sans-serif;font-size:14px;font-weight:600;text-align:center;margin-bottom:16px}.profile-select-container .image-container{border:1px solid #adbcc2;background-color:#f7f7f7;border-radius:100%;width:128px;height:128px;margin:auto;margin-top:24px;position:relative;background-size:cover;background-position:50% 50%;background-repeat:no-repeat}.profile-select-container .image-container img{height:100%;border-radius:100%}.profile-select-container .edit-wrapper{position:absolute;bottom:-5px;right:-30px}.profile-select-container .upload-wrapper{position:absolute;top:46px;left:22px}.profile-select-container .upload-wrapper .btn{color:#ff8609;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;letter-spacing:0;line-height:18px}@media only screen and (min-width:768px) and (max-width:991px){.profile-select-container .edit-wrapper{bottom:-20px;right:-8px}}.profile-select-container .upload-btn-wrapper{position:relative;overflow:hidden;display:inline-block;cursor:pointer}.profile-select-container .btn{border-radius:6px;font-family:Poppins,sans-serif;font-size:14px;font-weight:600;text-align:center;padding:0;cursor:pointer;background:none;color:#5e666d;height:fit-content;line-height:normal;width:fit-content}.profile-select-container .upload-btn-wrapper input[type=file]{font-size:100px;position:absolute;left:0;top:0;opacity:0;cursor:pointer}.profile-select-container .image-container img{width:100%}.profile-card{cursor:pointer}.profile-card,.profile-card.disabled-tab{height:49px;border-top:1px solid #adbcc2;padding:0 16px;position:relative}.profile-card.disabled-tab{cursor:default;color:#eee;opacity:.7}.profile-card a{color:#33373a;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;letter-spacing:.3px;line-height:49px;text-transform:uppercase}.profile-card .indicator{height:5px;width:5px;background-color:#ff8609;top:22px;position:absolute;right:16px;border-radius:100%}.profile-card.selected{background:#fff;border:1px solid #5e666d}.jobbler-mobile-screen{display:none;position:fixed;width:100vw;height:100vh;top:0;left:0;background:#f7f7f7;z-index:1000;padding:0;padding-top:52px;overflow-y:scroll}.jobbler-mobile-screen::-webkit-scrollbar{width:0!important}.jobbler-mobile-screen .banking-info-container,.jobbler-mobile-screen .profile-info-container{border:none;box-shadow:none;background:#f7f7f7;border-radius:0}.jobbler-mobile-screen .banking-info-container .jobble-tip-container,.jobbler-mobile-screen .profile-info-container .jobble-tip-container{background:#f7f7f7}.jobbler-mobile-screen .banking-info-container .save-button,.jobbler-mobile-screen .profile-info-container .button{position:fixed;bottom:0;width:100vw;left:0;height:40px;z-index:1001;border-radius:0}.jobbler-mobile-screen .mobile-header{height:52px;background:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.1);position:fixed;top:0;left:0;width:100vw;z-index:1001;text-align:center}.jobbler-mobile-screen .mobile-header i{position:absolute;left:0;top:0;font-size:14px;color:#929799;padding-top:19px;padding-left:24px;width:100px;text-align:left;height:52px}.jobbler-mobile-screen .mobile-header h1{color:#6a7178;font-family:Poppins,sans-serif;font-size:14px;font-weight:600;letter-spacing:.3px;line-height:52px;text-transform:uppercase}.mobile-choices{display:none}@media only screen and (max-width:768px){.jobbler-desktop-screen{display:none}.jobbler-mobile-screen{display:block}.profile-card.selected{background:#fff;border:none;border-top:1px solid #adbcc2}.desktop-choices{display:none}.mobile-choices{display:block}}", ""]);
	
	// exports


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _ordersmasterlist = __webpack_require__(527);
	
	var _ordersmasterlist2 = _interopRequireDefault(_ordersmasterlist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ordersmasterlistModule = _angular2.default.module("ordersmasterlist", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("ordersmasterlist", {
	    url: "/allorders",
	    template: "<ordersmasterlist></ordersmasterlist>"
	  });
	}).component("ordersmasterlist", _ordersmasterlist2.default);
	
	exports.default = ordersmasterlistModule;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ordersmasterlist = __webpack_require__(528);
	
	var _ordersmasterlist2 = _interopRequireDefault(_ordersmasterlist);
	
	var _ordersmasterlist3 = __webpack_require__(529);
	
	var _ordersmasterlist4 = _interopRequireDefault(_ordersmasterlist3);
	
	__webpack_require__(531);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ordersmasterlistComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _ordersmasterlist2.default,
	  controller: _ordersmasterlist4.default,
	  controllerAs: "vm"
	};
	
	exports.default = ordersmasterlistComponent;

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<div id=\"wrapper\">\n  <section class=\"page-head\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n          <div class=\"page-meta\">\n            <strong>ORDERS</strong> Use the 'actions' button on the right hand side of the page to edit your jobs, approve applicants, message and\n            more\n          </div>\n          <div class=\"search-sec\">\n            <form>\n              <input type=\"search\" placeholder=\"\" class=\"search-field-top\" ng-model=\"vm.query\" />\n              <button type=\"submit\" class=\"search-btn\">\n                <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n              </button>\n            </form>\n          </div>\n        </div>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"job-container\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\">\n          <div class=\"job-sidebar\">\n            <h3>Options</h3>\n\n            <p><span>Select</span></p>\n            <ul class=\"list-group list-job\">\n              <li class=\"list-group-item list-job-item job-active\">\n                <a href=\"#\" ng-click=\"vm.changeEventListing(1)\">\n                  Open\n                  <span class=\"badge job-badge\">10</span></a\n                >\n              </li>\n              <li class=\"list-group-item list-job-item\">\n                <a href=\"#\" ng-click=\"vm.changeEventListing(2)\">\n                  Completed\n                  <span class=\"badge job-badge\"> 15 </span>\n                </a>\n              </li>\n              <li class=\"list-group-item list-job-item\">\n                <a href=\"#\" ng-click=\"vm.changeEventListing(3)\">\n                  Cancelled\n                  <span class=\"badge job-badge\"> 7 </span>\n                </a>\n              </li>\n            </ul>\n\n            <p><span>Sort By</span></p>\n            <div class=\"select-box\">\n              <select\n                class=\"form-control form-input\"\n                ng-model=\"vm.selectedParam\"\n                ng-init=\"vm.selectedParam = vm.queryParams[vm.indexOfselectedParam].id\"\n                ng-options=\"option.id as option.name for option in vm.queryParams\"\n                ng-change=\"vm.queryChanged()\"\n              ></select>\n            </div>\n\n            <p><span>Results Size</span></p>\n            <div class=\"select-box\">\n              <select\n                class=\"form-control form-input\"\n                ng-model=\"vm.jobListResultSetLimit.value\"\n                ng-options=\"openings for openings in vm.jobListResultSetLimit.values\"\n                ng-change=\"vm.limitChanged()\"\n              ></select>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\" ng-if=\"vm.view === 2\">\n          <div class=\"job-content-wrapper-list\">\n            <div class=\"jobble-tip clearfix spacing-for-jobble-tip\" ng-if=\"vm.events.length == 0\">\n              <h5>Jobble Tip</h5>\n              <p>There are currently no {{ vm.pageStatus }} jobs for this account.</p>\n            </div>\n\n            <div\n              class=\"job-content\"\n              infinite-scroll-immediate-check=\"false\"\n              infinite-scroll-parent=\"true\"\n              infinite-scroll=\"vm.scrollEvents()\"\n              infinite-scroll-disabled=\"vm.busy\"\n              infinite-scroll-use-document-bottom=\"false\"\n              infinite-scroll-distance=\".2\"\n              ng-if=\"vm.events.length > 0\"\n            >\n              <div class=\"job-table table-responsive respons-job\">\n                <table class=\"table\" style=\"width: 99%\">\n                  <thead>\n                    <tr>\n                      <th style=\"width: 270px\">Order</th>\n                      <th style=\"width: 248px\">Pick Up</th>\n                      <th>Dropoff</th>\n                      <th>User</th>\n                      <th>Time</th>\n                      <th></th>\n                    </tr>\n                  </thead>\n                  <tbody></tbody>\n                </table>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\" ng-if=\"vm.currentUser.company.totalNumberOfNonCloseEvents > 9\">\n        <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"></div>\n        <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\">\n          <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n            <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"></div>\n            <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\">\n              <div class=\"load-more-loader\" style=\"height: 30px\">\n                <img src=\"/app/vendor/images/spinner-loading.gif\" ng-if=\"vm.busy\" />\n              </div>\n            </div>\n            <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\">\n              <div class=\"sorting-counter\" style=\"margin-top: 30px\" ng-if=\"vm.page == 'events'\">\n                {{vm.events.length}} / {{ vm.currentUser.company.totalNumberOfNonCloseEvents }}\n              </div>\n              <div class=\"sorting-counter\" style=\"margin-top: 30px\" ng-if=\"vm.page == 'history'\">\n                {{vm.events.length}} / {{ vm.currentUser.company.totalNumberOfCloseEvents }}\n              </div>\n              <div class=\"sorting-counter\" style=\"margin-top: 30px\" ng-if=\"vm.page == 'cancelled'\">\n                {{vm.events.length}} / {{ vm.currentUser.company.totalNumberOfEvents - (vm.currentUser.company.totalNumberOfNonCloseEvents +\n                vm.currentUser.company.totalNumberOfCloseEvents) }}\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n\n<jobblefooter></jobblefooter>\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n<globalmodal></globalmodal>\n<eventdialog></eventdialog>\n"

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _orders = __webpack_require__(530);
	
	var _orders2 = _interopRequireDefault(_orders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OrdersmasterlistController = function () {
	  function OrdersmasterlistController($http, $localStorage, $state, $stateParams, AuthService, OrdersService, EventsService, CompaniesService, SecurityService, $rootScope, CommonService, EnvService, $timeout, $base64) {
	    _classCallCheck(this, OrdersmasterlistController);
	
	    this.name = "ordersmasterlist";
	    $localStorage.activeStateName = "ordersmasterlist";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$companies = CompaniesService;
	    this.$events = EventsService;
	    this.$stateParams = $stateParams;
	    this.$security = SecurityService;
	    this.$orders = OrdersService;
	    this.$rootScope = $rootScope;
	    this.currentPageNumber = 1;
	    this.$base64 = $base64;
	    this.$common = CommonService;
	    this.$env = EnvService;
	    this.$timeout = $timeout;
	    this.remain_loading_count = 0;
	    this.currentUser = this.$auth.getUserData();
	    this.data = {};
	    var _this = this;
	
	    console.log("what are the env variables");
	    console.dir(this.$env);
	    console.dir(this.$base64);
	    _this.encodeBasicAuthData();
	  }
	
	  _createClass(OrdersmasterlistController, [{
	    key: "encodeBasicAuthData",
	    value: function encodeBasicAuthData() {
	      var _this = this;
	      var user = _this.$env.EnvironmentConfig.ezcaterKey.username;
	      var password = _this.$env.EnvironmentConfig.ezcaterKey.password;
	      var auth = user + ":" + password;
	      var encode = _this.$base64.encode(auth);
	      this.data.auth = encode;
	      _this.getOrders();
	    }
	  }, {
	    key: "getOrders",
	    value: function getOrders() {
	      var _this = this;
	      var data = this.data;
	      /*
	      _this.$http.get('https://delivery.ezcater.com/api/partner/v1/actionable_deliveries', {
	      headers: { 'Content-Type': undefined, 'Authorization': 'Basic ' + data.auth }
	      }).then(function(response){
	      console.log("response");
	      console.dir(response);
	      }, function(error){
	      console.log("error");
	      console.dir(error);
	      });
	      */
	
	      _this.$orders.getOrders(data).then(function (response) {
	        console.log("response");
	        console.dir(response);
	      }, function (error) {
	        console.log("in error");
	        console.dir(error);
	      });
	    }
	  }]);
	
	  return OrdersmasterlistController;
	}();
	
	OrdersmasterlistController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "orders", "events", "companies", "security", "$rootScope", "common", "env", "$timeout", "$base64"];
	
	exports.default = OrdersmasterlistController;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OrdersService = function () {
	  function OrdersService($http, $localStorage, $state, $q, SecurityService, AuthService, EnvService, $rootScope, $timeout) {
	    _classCallCheck(this, OrdersService);
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$q = $q;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$env = EnvService;
	    this.$rootScope = $rootScope;
	    this.$timeout = $timeout;
	    this.PubNub = null;
	    this.unsortedChannelList = [];
	    this.nestedChannelList = [];
	    this.arrayOfImageUrlsForGallery = [];
	    this.controlChannelVal = null;
	
	    //URLS
	    this.get_actionable_deliveries = "actionable_deliveries";
	  }
	
	  _createClass(OrdersService, [{
	    key: "getOrders",
	    value: function getOrders(data) {
	      console.log("what is the env");
	      console.dir(this.$env);
	      console.dir(data);
	      var url = this.$env.EnvironmentConfig.ezcaterKey.url + this.get_actionable_deliveries;
	      var req = {
	        method: "JSONP",
	        url: url,
	        headers: {
	          "Content-Type": "application/json",
	          "Access-Control-Allow-Origin": "*",
	          Authorization: "Basic " + data.auth
	        },
	        data: {}
	      };
	
	      console.log("what is the request");
	      console.dir(req);
	      return this.$http(req);
	    }
	  }]);
	
	  return OrdersService;
	}();
	
	exports.default = OrdersService;
	
	
	OrdersService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "env", "$rootScope", "$timeout"];

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(532);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./ordersmasterlist.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./ordersmasterlist.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _basicprofile = __webpack_require__(534);
	
	var _basicprofile2 = _interopRequireDefault(_basicprofile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var basicprofileModule = _angular2.default.module("basicprofile", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("basicprofile", {
	    url: "/basicprofile/:jobblerId",
	    template: "<basicprofile></basicprofile>"
	  });
	}).component("basicprofile", _basicprofile2.default);
	
	exports.default = basicprofileModule;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _basicprofile = __webpack_require__(535);
	
	var _basicprofile2 = _interopRequireDefault(_basicprofile);
	
	var _basicprofile3 = __webpack_require__(536);
	
	var _basicprofile4 = _interopRequireDefault(_basicprofile3);
	
	__webpack_require__(537);
	
	__webpack_require__(539);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var basicprofileComponent = {
	  restrict: "E",
	  bindings: {
	    toggleModal: "<"
	  },
	  template: _basicprofile2.default,
	  controller: _basicprofile4.default,
	  controllerAs: "vm"
	};
	
	exports.default = basicprofileComponent;

/***/ }),
/* 535 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"profile-info-container\">\n  <div>\n    <h2>Your Profile</h2>\n\n    <div class=\"jobble-tip-super-container\">\n      <div class=\"jobble-tip-container\">\n        <div>Jobble tip: completing your profile ensures that you have access to all job types.</div>\n      </div>\n    </div>\n  </div>\n\n  <!--  PERSONAL DETAILS -->\n  <div class=\"loading-details\" ng-show=\"vm.loading\">\n    <i class=\"fas fa-spin fa-spinner fa-1x fa-fw\"></i>\n  </div>\n\n  <div class=\"\" ng-hide=\"vm.loading\">\n    <h3>Personal Details</h3>\n    <div class=\"\">\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <label>Preferred name (optional)</label>\n          <input\n            ng-model=\"vm.basicprofile_info.basic.personal_details.preferred_name\"\n            ng-change=\"vm.formChange('preferredName', 1)\"\n            autocomplete=\"off\"\n            ng-class=\"{ 'input-error': vm.errors['preferredName'] }\"\n            type=\"text\"\n            class=\"form-control\"\n          />\n          <div class=\"input-error-text\" ng-show=\"vm.errors['preferredName']\">\n            <i class=\"fas fa-exclamation-circle\"></i> Please enter a valid preferred name\n          </div>\n        </div>\n        <div class=\"col-sm-6\">\n          <label>Legal first Name</label>\n          <input\n            ng-model=\"vm.basicprofile_info.basic.personal_details.first_name\"\n            ng-change=\"vm.formChange('firstName', 1)\"\n            autocomplete=\"off\"\n            ng-class=\"{ 'input-error': vm.errors['firstName'] }\"\n            type=\"text\"\n            class=\"form-control\"\n          />\n          <div class=\"input-error-text\" ng-show=\"vm.errors['firstName']\">\n            <i class=\"fas fa-exclamation-circle\"></i> Please enter a valid first name\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <label>Legal last Name</label>\n          <input\n            ng-model=\"vm.basicprofile_info.basic.personal_details.last_name\"\n            ng-change=\"vm.formChange('lastName', 1)\"\n            autocomplete=\"off\"\n            ng-class=\"{ 'input-error': vm.errors['lastName'] }\"\n            class=\"form-control\"\n            type=\"text\"\n          />\n          <div class=\"input-error-text\" ng-show=\"vm.errors['lastName']\"><i class=\"fas fa-exclamation-circle\"></i> Please enter a valid last name</div>\n        </div>\n        <div class=\"col-sm-6\">\n          <label>Date of birth</label>\n          <input\n            ng-model=\"vm.basicprofile_info.basic.personal_details.dateBirth\"\n            ng-change=\"vm.formChange('dateBirth', 1)\"\n            ng-class=\"{'input-error': vm.errors['dateBirth']}\"\n            class=\"form-control\"\n            id=\"datepicker\"\n          />\n          <div class=\"input-error-text\" ng-show=\"vm.errors['dateBirth']\">\n            <i class=\"fas fa-exclamation-circle\"></i> Please enter a valid date of birth. You must be over 18.\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <label>Mobile Number</label>\n          <input\n            ng-model=\"vm.basicprofile_info.basic.personal_details.phone\"\n            ng-change=\"vm.formChange('phoneMobile', 1)\"\n            ng-class=\"{'input-error': vm.errors['phoneMobile']}\"\n            class=\"form-control\"\n            type=\"text\"\n          />\n          <div class=\"input-error-text\" ng-show=\"vm.errors['phoneMobile']\">\n            <i class=\"fas fa-exclamation-circle\"></i> Please enter a valid phone number\n          </div>\n        </div>\n        <div class=\"col-sm-6\">\n          <!--\n                    <label>SSN</label>\n                    <input\n                        ng-model=\"vm.basicprofile_info.basic.personal_details.ssn_display\"\n                        ng-change=\"vm.formChange('ssn', 1)\"\n                        ng-class=\"{'input-error': vm.errors['ssn']}\"\n                        class=\"form-control\"\n                        type=\"text\"\n                    />\n                    <div class=\"input-error-text\" ng-show=\"vm.errors['ssn']\"><i class=\"fas fa-exclamation-circle\"></i> 9 digit SSN required</div>\n                    -->\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <label>Email Address</label>\n          <input\n            ng-model=\"vm.basicprofile_info.basic.personal_details.email\"\n            ng-change=\"vm.formChange('email', 1)\"\n            ng-class=\"{'error' : vm.ui_model.error_model.email}\"\n            class=\"form-control\"\n            type=\"email\"\n          />\n\n          <p class=\"error-text\" ng-show=\"vm.ui_model.warning_model.email\" style=\"margin-bottom: 0px; margin-top: 8px\">\n            <i class=\"fas fa-exclamation-circle\"></i> Upon saving, you will be logged out and forced to log back in with your new email address.\n          </p>\n        </div>\n      </div>\n    </div>\n    <h3>Location</h3>\n    <div class=\"\">\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <label>Street Address</label>\n          <input\n            ng-model=\"vm.basicprofile_info.basic.address.street\"\n            ng-change=\"vm.formChange('streetLine1', 2)\"\n            ng-class=\"{'input-error': vm.errors['streetLine1']}\"\n            class=\"form-control\"\n            type=\"text\"\n          />\n          <div class=\"input-error-text\" ng-show=\"vm.errors['streetLine1']\">\n            <i class=\"fas fa-exclamation-circle\"></i> Please enter a valid street address\n          </div>\n        </div>\n        <div class=\"col-sm-6\">\n          <label>Apt. Unit. Building.</label>\n          <input ng-model=\"vm.basicprofile_info.basic.address.apt\" ng-change=\"vm.formChange('address2',2)\" class=\"form-control\" type=\"text\" />\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <label>City</label>\n          <input\n            ng-model=\"vm.basicprofile_info.basic.address.city\"\n            ng-change=\"vm.formChange('city', 2)\"\n            ng-class=\"{'input-error': vm.errors['city']}\"\n            class=\"form-control\"\n            type=\"text\"\n          />\n          <div class=\"input-error-text\" ng-show=\"vm.errors['city']\"><i class=\"fas fa-exclamation-circle\"></i> Please enter a valid city</div>\n        </div>\n        <div class=\"col-sm-4\">\n          <label>State</label>\n          <select\n            class=\"form-control\"\n            ng-model=\"vm.states.value\"\n            ng-options=\"state for state in vm.states.values\"\n            ng-change=\"vm.formChange('state', 2)\"\n            ng-class=\"{'select-error': vm.errors['state']}\"\n          ></select>\n          <div class=\"input-error-text\" ng-show=\"vm.errors['state']\"><i class=\"fas fa-exclamation-circle\"></i> Please enter a valid state</div>\n        </div>\n        <div class=\"col-sm-2\">\n          <label>Zip</label>\n          <input\n            ng-model=\"vm.basicprofile_info.basic.address.zip_code\"\n            ng-change=\"vm.formChange('zipCode', 2)\"\n            ng-class=\"{'input-error': vm.errors['zipCode']}\"\n            min=\"5\"\n            max=\"5\"\n            class=\"form-control\"\n            type=\"text\"\n          />\n          <div class=\"input-error-text\" ng-show=\"vm.errors['zipCode']\"><i class=\"fas fa-exclamation-circle\"></i> Please enter a valid zip code</div>\n        </div>\n      </div>\n    </div>\n\n    <h3>About Me</h3>\n    <div>\n      <div class=\"row\">\n        <div class=\"col-sm-12\">\n          <label>Provide a short bio to be displayed on your profile, briefly describing your personality, strengths and background</label>\n          <textarea\n            ng-model=\"vm.basicprofile_info.basic.personal_details.bio\"\n            ng-change=\"vm.formChange('bio', 3)\"\n            ng-class=\"{'input-error': vm.errors['bio']}\"\n            class=\"form-control\"\n            style=\"width: 100%\"\n            rows=\"10\"\n            maxlength=\"500\"\n          ></textarea>\n          <div class=\"input-error-text\" ng-show=\"vm.errors['bio']\"><i class=\"fas fa-exclamation-circle\"></i> Please enter a bio</div>\n          <div class=\"character-limit\">\n            {{vm.basicprofile_info.basic.personal_details.bio ? vm.basicprofile_info.basic.personal_details.bio.length : 0}}/500\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"btn button btn-success\" ng-click=\"vm.saveUser()\" ng-disabled=\"vm.profileSaving==true\">Save</div>\n  </div>\n</div>\n"

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BasicprofileController = function () {
	  function BasicprofileController($http, $localStorage, $state, $stateParams, AuthService, EventsService, ProfileService, CompaniesService, SecurityService, $rootScope, CommonService, EnvService, $timeout, $location, $scope) {
	    var _this2 = this;
	
	    _classCallCheck(this, BasicprofileController);
	
	    this.name = "basicprofile";
	    $localStorage.activeStateName = "basicprofile";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$profile = ProfileService;
	    this.$auth = AuthService;
	    this.$companies = CompaniesService;
	    this.$events = EventsService;
	    this.$stateParams = $stateParams;
	    this.$location = $location;
	    this.$security = SecurityService;
	    this.$rootScope = $rootScope;
	    this.$common = CommonService;
	    this.pref_jobble_types = [];
	    this.$env = EnvService;
	    this.$timeout = $timeout;
	    this.remain_loading_count = 0;
	    this.sections = {
	      section_1: { is_clear: false },
	      section_2: { is_clear: false },
	      section_3: { is_clear: false }
	    };
	    //ssn: false,
	    this.ui_model = {
	      error_model: {
	        preferred_name: false,
	        first_name: false,
	        last_name: false,
	        email: false,
	        phone: false,
	        ssn_display: null,
	        address1: false,
	        address2: false,
	        city: false,
	        state: false,
	        zip_code: false,
	        bio: false
	      },
	      warning_model: { email: false },
	      submit_model: {
	        form1: { is_disabled: true },
	        form2: { is_disabled: true },
	        form3: { is_disabled: true }
	      }
	    };
	    //ssn: null,
	    this.loading = true;
	    this.currentUser = this.$auth.getUserData();
	    this.basicprofile_info = {
	      basic: {
	        personal_details: {
	          preferred_name: null,
	          first_name: null,
	          last_name: null,
	          email: null,
	          phone: null,
	          bio: null,
	          dateBirth: null
	        },
	        address: {
	          street: null,
	          apt: null,
	          city: null,
	          state: null,
	          zip_code: null
	        },
	        options: {
	          preferred_jobble_types: []
	        },
	        image: {
	          url: null
	        }
	      },
	      extended: {}
	    };
	
	    window.toastr.options.preventDuplicates = true;
	
	    //INIT FUNCTIONS
	    this.states = {
	      value: "--",
	      values: ["--", "AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"]
	    };
	    this.getLatestUserData(this.$stateParams.basicprofileId);
	
	    this.SetJobForApplicationAfterBasicFilledListener = this.$rootScope.$on("SetJobForApplicationAfterBasicFilled", function ($event, params) {
	      _this2.job_from_board_during_apply_attempt = params.job;
	    });
	
	    this.$scope.$on("$destroy", this.TriggerIndicatorDataListener);
	    this.$scope.$on("$destroy", this.SetJobForApplicationAfterBasicFilledListener);
	  }
	
	  _createClass(BasicprofileController, [{
	    key: "getLatestUserData",
	    value: function getLatestUserData(id) {
	      var _this = this;
	      if (_this.currentUser) {
	        _this.$profile.validateUserByToken(_this.currentUser.access_token).then(function (response) {
	          _this.setUserDataToView(response.data);
	        }, function (error) {});
	      } else {
	        alert("we have no user....");
	      }
	    }
	  }, {
	    key: "getJobbleTypes",
	    value: function getJobbleTypes(jobbleTypesParam, user) {
	      var _this3 = this;
	
	      var user_obj = user;
	
	      console.log("jobbleTypesParam");
	      console.dir(jobbleTypesParam);
	
	      this.$auth.getJobbleTypes().then(function (data) {
	        _this3.jobble_types = data.data;
	        _this3.$rootScope.jobble_types = data.data;
	        _this3.setNotiJobbleTypes(jobbleTypesParam, user_obj);
	      });
	    }
	  }, {
	    key: "setUserDataToView",
	    value: function setUserDataToView(user) {
	      var _this4 = this;
	
	      console.log("setUserDataToView");
	      console.dir(user);
	
	      this.basicprofile_info.basic.personal_details.preferred_name = user.nickname;
	      this.basicprofile_info.basic.personal_details.first_name = user.firstName;
	      this.basicprofile_info.basic.personal_details.last_name = user.lastName;
	      this.basicprofile_info.basic.personal_details.email = user.email;
	      this.basicprofile_info.basic.personal_details.dateBirth = user.dateBirth ? this.convertDateToString(user.dateBirth) : null;
	      //user.ssn &&
	      if (user.homeContactInfo.phoneMobile && user.bio && user.dateBirth) {
	        this.sections.section_1.is_clear = true;
	      }
	
	      if (user.homeContactInfo.phoneMobile) {
	        this.basicprofile_info.basic.personal_details.phone = user.homeContactInfo.phoneMobile;
	      } else {
	        this.ui_model.error_model.phone = true;
	      }
	
	      /*
	          if (user.ssn) {
	              this.basicprofile_info.basic.personal_details.ssn_display = this.formatSsn(user.ssn);
	              this.basicprofile_info.basic.personal_details.ssn = user.ssn;
	          } else {
	              this.ui_model.error_model.ssn = true;
	          }
	          */
	
	      if (user.bio) {
	        this.basicprofile_info.basic.personal_details.bio = user.bio;
	      } else {
	        this.ui_model.error_model.bio = true;
	      }
	
	      this.basicprofile_info.basic.image.url = user.filePROFILE_IMAGE1IMG_160x160;
	      this.basicprofile_info.basic.address.zip_code = user.homeContactInfo.zipCode;
	
	      if (user.homeContactInfo.streetLine1) {
	        this.basicprofile_info.basic.address.street = user.homeContactInfo.streetLine1;
	      } else {
	        this.ui_model.error_model.address1 = true;
	      }
	
	      if (user.homeContactInfo.city) {
	        this.basicprofile_info.basic.address.city = user.homeContactInfo.city;
	      } else {
	        this.ui_model.error_model.city = true;
	      }
	
	      this.basicprofile_info.basic.address.apt = user.homeContactInfo.streetLine2;
	
	      if (user.homeContactInfo.state) {
	        this.states.value = user.homeContactInfo.state;
	      } else {
	        this.ui_model.error_model.state = true;
	      }
	
	      if (user.homeContactInfo.streetLine1 && user.homeContactInfo.city && user.homeContactInfo.state) {
	        this.sections.section_2.is_clear = true;
	      }
	
	      var left_rail_data = {};
	      left_rail_data.image = user.filePROFILE_IMAGE1IMG_160x160;
	      left_rail_data.first_name = user.firstName;
	      left_rail_data.last_name = user.lastName;
	
	      this.$timeout(function () {
	        _this4.$rootScope.$emit("SetProfileImageForJobbler", {
	          user: left_rail_data
	        });
	      });
	
	      console.log("before getJobbleTypes");
	      console.dir(user);
	
	      this.getJobbleTypes(user.notifPref.jobbleTypes, user);
	
	      console.log("this might be the last thing?");
	      console.dir(this.ui_model);
	
	      this.sendProfileData();
	      this.currentUser = user;
	
	      this.$timeout(function () {
	        $("#datepicker").datepicker({
	          changeMonth: true,
	          changeYear: true,
	          minDate: "-100Y",
	          maxDate: "-18Y",
	          yearRange: "-100:-18"
	        });
	      });
	    }
	  }, {
	    key: "sendProfileData",
	    value: function sendProfileData() {
	      var _this5 = this;
	
	      console.log("sendProfileData");
	      this.$timeout(function () {
	        _this5.$rootScope.$emit("ProfileStatusCheck", _this5.ui_model);
	      });
	    }
	  }, {
	    key: "formatSsn",
	    value: function formatSsn(ssn) {
	      var tempSsn = ssn.substring(5, 9);
	      tempSsn = "*****" + tempSsn;
	      return tempSsn;
	    }
	  }, {
	    key: "setNotiJobbleTypes",
	    value: function setNotiJobbleTypes(jobble_types, user) {
	      var _this = this;
	
	      var user_obj = user;
	
	      if (jobble_types) {
	        _this.display_pref_jt_warning = false;
	        _this.sections.section_3.is_clear = true;
	        try {
	          jobble_types.forEach(function (j) {
	            var jt = _this.jobble_types.find(function (o) {
	              return o.id === j.id;
	            });
	
	            if (jt) {
	              jt.selected = true;
	              _this.pref_jobble_types.push(jt.id);
	            }
	          });
	        } catch (err) {
	          console.log("in error");
	          console.dir(err);
	        } finally {
	          _this.checkToMakeSureAllFieldsAreFilledOut(user_obj);
	          _this.$timeout(function () {
	            _this.loading = undefined;
	          }, 100);
	        }
	      } else {
	        _this.display_pref_jt_warning = true;
	        _this.checkToMakeSureAllFieldsAreFilledOut(user_obj);
	        _this.$timeout(function () {
	          _this.loading = undefined;
	        }, 100);
	      }
	    }
	  }, {
	    key: "setEmailWarning",
	    value: function setEmailWarning() {
	      this.ui_model.warning_model.email = this.compareEmails();
	    }
	  }, {
	    key: "formChange",
	    value: function formChange(field, page) {
	      var _this6 = this;
	
	      var user = this.mapFields();
	      this.errors = this.errors || {};
	
	      if (field === "email") {
	        this.setEmailWarning();
	      }
	
	      this.$timeout(function () {
	        _this6.errors = _this6.$profile.validateProfile(user, field, _this6.errors);
	
	        console.log("what are the errors");
	        console.dir(_this6.errors);
	      });
	    }
	  }, {
	    key: "isValidMultiple",
	    value: function isValidMultiple(fields) {
	      var _this7 = this;
	
	      var valid = true;
	      var user = this.mapFields();
	
	      if (!fields) return valid;
	
	      fields.forEach(function (field) {
	        _this7.errors = _this7.$profile.validateProfile(user, field, _this7.errors);
	        if (_this7.errors[field]) valid = false;
	      });
	
	      return valid;
	    }
	  }, {
	    key: "formChangeOld",
	    value: function formChangeOld(field, form_id) {
	      var _this = this;
	      if (form_id === 1) {
	        if (field === "first_name") {
	          this.ui_model.error_model.first_name = this.basicprofile_info.basic.personal_details.first_name.length <= 0;
	        }
	        if (field === "last_name") {
	          this.ui_model.error_model.last_name = this.basicprofile_info.basic.personal_details.last_name.length <= 0;
	        }
	        /*
	        if (field === "ssn") {
	          if (this.basicprofile_info.basic.personal_details.ssn) {
	            this.ui_model.error_model.ssn = false;
	          } else if (_this.basicprofile_info.basic.personal_details.ssn === "") {
	            this.ui_model.error_model.ssn = true;
	          }
	        }
	        */
	        if (field === "phone") {
	          if (this.basicprofile_info.basic.personal_details.phone) {
	            var is_phone = this.$profile.isPhone(this.basicprofile_info.basic.personal_details.phone);
	            this.ui_model.error_model.phone = !is_phone;
	          } else {
	            this.ui_model.error_model.phone = true;
	          }
	        }
	        if (field === "email") {
	          this.setEmailWarning();
	          if (this.basicprofile_info.basic.personal_details.email) {
	            var is_email = this.$profile.isEmail(this.basicprofile_info.basic.personal_details.email);
	            this.ui_model.error_model.email = !is_email;
	          } else {
	            this.ui_model.error_model.email = true;
	          }
	        }
	        if (field === "bio") {
	          if (this.basicprofile_info.basic.personal_details.bio) {
	            this.ui_model.error_model.bio = false;
	          }
	        }
	        //this.basicprofile_info.basic.personal_details.ssn &&
	        if (this.ui_model.error_model.phone === false && this.ui_model.error_model.bio === false && this.ui_model.error_model.first_name === false && this.ui_model.error_model.last_name === false && this.ui_model.error_model.email === false && this.ui_model.error_model.year === false) {
	          this.ui_model.submit_model.form1.is_disabled = false;
	        } else {
	          this.ui_model.submit_model.form1.is_disabled = true;
	        }
	      } else if (form_id === 2) {
	        if (field === "address1") {
	          this.ui_model.error_model.address1 = !this.basicprofile_info.basic.address.street;
	        }
	        if (field === "city") {
	          this.ui_model.error_model.city = !this.basicprofile_info.basic.address.city;
	        }
	        if (field === "state") {
	          this.ui_model.error_model.state = !(this.states.value && this.states.value !== "--");
	        }
	        if (field === "zip_code") {
	          this.ui_model.error_model.zip_code = !(this.basicprofile_info.basic.address.zip_code && this.basicprofile_info.basic.address.zip_code.length === 5);
	        }
	        if (this.ui_model.error_model.zip_code === false && this.ui_model.error_model.state === false && this.ui_model.error_model.city === false && this.ui_model.error_model.address1 === false) {
	          this.ui_model.submit_model.form2.is_disabled = false;
	        } else {
	          this.ui_model.submit_model.form2.is_disabled = true;
	        }
	      } else {
	        this.ui_model.submit_model.form3.is_disabled = false;
	      }
	    }
	  }, {
	    key: "validate_years",
	    value: function validate_years(days, months, years) {
	      var result = {};
	      var current_year = moment().format("YYYY");
	      var current_year_less_18 = moment().subtract(18, "years").format("YYYY");
	      var year_input = parseInt(years, 10);
	      var cyl18 = parseInt(current_year_less_18, 10);
	      if (year_input === cyl18) {
	        var current_month = parseInt(moment().format("MM"), 10);
	        var month_input = parseInt(months, 10);
	        if (month_input === current_month) {
	          var day = parseInt(moment().format("DD"), 10);
	          var day_input = parseInt(days, 10);
	          if (day_input < day) {
	            console.log("first one");
	            result.bool = false;
	            result.msg = "You need to be over the age of 18 to finish your basic profile.";
	          } else {
	            console.log("first second");
	            result.bool = true;
	          }
	        } else if (current_month > month_input) {
	          result.bool = false;
	          result.msg = "You need to be over the age of 18 to finish your basic profile.";
	        } else if (current_month < month_input) {
	          result.bool = true;
	        }
	      } else {
	        result.bool = true;
	      }
	      return result;
	    }
	  }, {
	    key: "compareEmails",
	    value: function compareEmails() {
	      var _this = this;
	      var ans = null;
	      if (_this.currentUser.email === _this.basicprofile_info.basic.personal_details.email) {
	        ans = false;
	      } else {
	        ans = true;
	      }
	      return ans;
	    }
	  }, {
	    key: "saveUser",
	    value: function saveUser() {
	      var _this8 = this;
	
	      if (this.profileSaving === true) {
	        return;
	      }
	
	      var user = this.mapFields();
	
	      if (user.preferredName) {
	        user.nickname = user.preferredName;
	      }
	      //"ssn",
	      var pageValid = this.isValidMultiple(["preferredName", "firstName", "lastName", "phoneMobile", "dateBirth", "streetLine1", "zipCode", "city", "state", "bio"]);
	
	      if (!pageValid) return;
	
	      this.setLoader();
	      this.profileSaving = true;
	
	      var was_email_changed = this.compareEmails();
	
	      this.$profile.saveUser(user).then(function (response) {
	        _this8.$timeout(function () {
	          _this8.profileSaving = false;
	        }, 3000);
	
	        if (_this8.toggleModal) {
	          _this8.toggleModal();
	        }
	
	        if (response.data.status === "error") {
	          console.error(response);
	          if (response.data.message.indexOf("Duplicate entry") > -1) {
	            window.toastr.error("<i class=\"fas fa-times\" style='margin-right: 8px'></i>This email has already been registered in our system. Please try another or contact support.");
	          } else if (response.data.message.indexOf("ssn is already used") > -1) {
	            window.toastr.error("<i class=\"fas fa-times\" style='margin-right: 8px'></i>This ssn already exists. Please contact support.");
	          } else {
	            window.toastr.error("<i class=\"fas fa-times\" style='margin-right: 8px'></i>There was an issue saving your profile. Please try again");
	          }
	        } else {
	          _this8.profile_updated_successfully = true;
	          _this8.sections.section_1.is_clear = true;
	
	          if (window.toastr) {
	            window.toastr.options.preventDuplicates = true;
	            window.toastr.success("<i class=\"fas fa-check-circle\" style='margin-right: 8px'></i>Success! Your profile was updated");
	          }
	
	          _this8.$timeout(function () {
	            _this8.profile_updated_successfully = false;
	          }, 3500);
	
	          if (was_email_changed) {
	            _this8.$timeout(function () {
	              _this8.$rootScope.$emit("SignUserOut", {});
	            });
	          } else {
	            _this8.handleResponse(response.data);
	          }
	        }
	
	        _this8.unSetLoader();
	      }, function (error) {
	        _this8.$timeout(function () {
	          _this8.profileSaving = false;
	        }, 1000);
	
	        if (_this8.toggleModal) {
	          _this8.toggleModal();
	        }
	        _this8.unSetLoader();
	
	        if (error.data.message.indexOf("ssn is already used") > -1) {
	          window.toastr.error("<i class=\"fas fa-times\" style='margin-right: 8px'></i>This ssn already exists. Please contact support.");
	        } else if (error.data.code === 3200) {
	          alert("The phone number you are trying to save is in an invalid format. Please enter only 10 digits.");
	        } else if (error.data.code === 3201) {
	          alert("The phone number you are trying to save is already in use by another user.");
	        } else {
	          alert("There was a fatal backend error. Please contact support.");
	        }
	      });
	    }
	  }, {
	    key: "checkToMakeSureAllFieldsAreFilledOut",
	    value: function checkToMakeSureAllFieldsAreFilledOut(user) {
	      var _this = this;
	      if (_this.sections.section_1.is_clear === true && _this.sections.section_2.is_clear === true && _this.sections.section_3.is_clear === true && _this.job_from_board_during_apply_attempt) {
	        var job = _this.job_from_board_during_apply_attempt;
	        _this.$timeout(function () {
	          _this.$state.go("jobblergallery", {
	            job: job,
	            display_warning: true
	          });
	        }, 500);
	      }
	      if (_this.sections.section_1.is_clear && _this.sections.section_2.is_clear && _this.sections.section_3.is_clear && user.filePROFILE_IMAGE1IMG_160x160) {
	        _this.status_clear = true;
	      } else {
	        _this.status_clear = false;
	      }
	    }
	  }, {
	    key: "handleResponse",
	    value: function handleResponse(response) {
	      var _this = this;
	      console.log("handleResponse response");
	      console.dir(response);
	      _this.$auth.validateUserByToken(_this.currentUser.access_token).then(function (r) {
	        _this.$localStorage.logged_user = r.data;
	        _this.currentUser = r.data;
	        _this.set_current_user_to_parent(r.data);
	        if (_this.job_from_board_during_apply_attempt) {
	          _this.checkToMakeSureAllFieldsAreFilledOut(r.data);
	        }
	      }, function (error) {
	        console.log("error validating user");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "set_current_user_to_parent",
	    value: function set_current_user_to_parent(user) {
	      var _this = this;
	      console.log("set_current_user_to_parent");
	      console.dir(user);
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SettingNewUserDataToParent", user);
	        _this.$rootScope.$emit("ProfileStatusCheck", _this.ui_model);
	      });
	    }
	  }, {
	    key: "mapFields",
	    value: function mapFields() {
	      //ssn: this.basicprofile_info.basic.personal_details.ssn,
	      var user = {
	        preferredName: this.basicprofile_info.basic.personal_details.preferred_name,
	        firstName: this.basicprofile_info.basic.personal_details.first_name,
	        lastName: this.basicprofile_info.basic.personal_details.last_name,
	        email: this.basicprofile_info.basic.personal_details.email,
	        username: this.basicprofile_info.basic.personal_details.email,
	        bio: this.basicprofile_info.basic.personal_details.bio,
	        homeContactInfo: {
	          phoneMobile: this.basicprofile_info.basic.personal_details.phone,
	          streetLine1: this.basicprofile_info.basic.address.street,
	          streetLine2: this.basicprofile_info.basic.address.apt,
	          city: this.basicprofile_info.basic.address.city,
	          state: this.states.value,
	          zipCode: this.basicprofile_info.basic.address.zip_code
	        }
	      };
	
	      if (this.basicprofile_info.basic.personal_details.dateBirth) {
	        var date = new Date(this.basicprofile_info.basic.personal_details.dateBirth);
	        var year = date.getFullYear();
	        var month = date.getMonth() + 1;
	        var day = date.getDate();
	        user.dateBirth = year + "-" + ((month + "").length === 1 ? "0" + month : month) + "-" + ((day + "").length === 1 ? "0" + day : day) + "T00:00:00Z";
	      }
	
	      /*
	          if (this.basicprofile_info.basic.personal_details.ssn_display) {
	              if (this.basicprofile_info.basic.personal_details.ssn_display.startsWith("*****")) {
	                  user.ssn = this.basicprofile_info.basic.personal_details.ssn;
	              } else {
	                  user.ssn = this.basicprofile_info.basic.personal_details.ssn_display;
	              }
	          }*/
	
	      return user;
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "convertDateToString",
	    value: function convertDateToString(indate) {
	      var date = new Date(indate);
	      var year = date.getFullYear();
	      var month = date.getMonth() + 1;
	      var day = date.getDate() + 1;
	      return ((month + "").length === 1 ? "0" + month : month) + "/" + ((day + "").length === 1 ? "0" + day : day) + "/" + year;
	    }
	  }]);
	
	  return BasicprofileController;
	}();
	
	BasicprofileController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "events", "profile", "companies", "security", "$rootScope", "common", "env", "$timeout", "$location", "$scope"];
	
	exports.default = BasicprofileController;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(538);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./basicprofile.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./basicprofile.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(540);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".profile-info-container{border:1px solid #adbcc2;border-radius:6px;background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.2);padding:24px;margin-bottom:100px}.loading-details{font-size:24px;color:#62c046;text-align:center;margin-top:16px}.profile-info-container h2{color:#585c61;font-family:Poppins,sans-serif;font-size:18px;font-weight:700;line-height:20px;margin:0}.profile-info-container h3{color:#44484c;font-family:Poppins,sans-serif;font-size:14px;font-weight:600;line-height:21px;margin:0;margin-top:16px}.profile-info-container .jobble-tip-super-container{border-radius:6px;background:linear-gradient(116.57deg,#62c046,#5498b4);padding:2px;height:fit-content;cursor:pointer;margin-top:16px;width:fit-content}.profile-info-container .jobble-tip-container{background:#fff;border-radius:4px;padding:0 6px;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;width:fit-content;height:fit-content;line-height:25px;color:#5e666d;letter-spacing:0}.profile-info-container label{color:#33373a;font-family:Poppins,sans-serif;font-size:14px;line-height:21px;margin:0;font-weight:400;margin-top:16px}.profile-info-container input,.profile-info-container select{height:40px;width:100%;border:1px solid #33373a;border-radius:2px;background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.1);margin-top:8px;padding:0 16px}.profile-info-container textarea{height:156px;border:1px solid #767676;border-radius:2px;background-color:#fff;color:#33373a;font-family:Poppins,sans-serif;font-size:14px;padding:16px;line-height:21px;margin-top:8px}.profile-info-container input.input-error,.profile-info-container select.select-error,.profile-info-container textarea.input-error{border-color:#d8000c}.profile-info-container .character-limit{text-align:right;color:#33373a;font-family:Poppins,sans-serif;font-size:12px;letter-spacing:0;line-height:18px;margin-top:8px}.profile-info-container .pill-container{margin-top:16px}.profile-info-container .pill{display:inline-block;color:#5e666d;height:25px;padding:0 10px;line-height:24px;border:1px solid #5e666d;border-radius:13.5px;font-size:11px;font-family:Poppins,sans-serif;font-weight:500;margin-right:8px;cursor:pointer;margin-bottom:8px;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.profile-info-container .selected-pill{background:#5e666d;color:#fff}.profile-info-container .button{height:40px;width:100px;border-radius:2px;background-color:#62c046;color:#fff;font-family:Poppins,sans-serif;font-size:14px;font-weight:700;line-height:40px;padding:0}.profile-info-container .error-text,.profile-info-container .input-error-text{color:#d8000c;font-family:Poppins,sans-serif;margin-top:16px;font-size:11px;letter-spacing:0;line-height:14px}.profile-info-container .input-error-text{margin-top:8px}", ""]);
	
	// exports


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _preferences = __webpack_require__(542);
	
	var _preferences2 = _interopRequireDefault(_preferences);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var preferencesModule = _angular2.default.module("preferences", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("preferences", {
	    url: "/preferences/:jobblerId",
	    template: "<jobbler></jobbler>"
	  });
	}).component("preferences", _preferences2.default);
	
	exports.default = preferencesModule;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _preferences = __webpack_require__(543);
	
	var _preferences2 = _interopRequireDefault(_preferences);
	
	var _preferences3 = __webpack_require__(544);
	
	var _preferences4 = _interopRequireDefault(_preferences3);
	
	__webpack_require__(545);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var preferencesComponent = {
	  restrict: "E",
	  bindings: {
	    toggleModal: "<"
	  },
	  template: _preferences2.default,
	  controller: _preferences4.default,
	  controllerAs: "vm"
	};
	
	exports.default = preferencesComponent;

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"profile-info-container\">\n\n\t<div>\n\t\t<h2>Your Profile</h2>\n\t\t<div class=\"jobble-tip-super-container\">\n\t\t\t<div class=\"jobble-tip-container\">\n\t\t\t\t<div>Jobble tip: completing your profile ensures that you have access to all job types.</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t\t<div class=\"loading-details\" ng-show=\"vm.loading\">\n\t\t\t<i class=\"fas fa-spin fa-spinner fa-1x fa-fw\"></i>\n\t\t</div>\n\n      \t<div class=\"\" ng-hide=\"vm.loading\">\n\t\t\t<h3>Job search preferences</h3>\n\t\t\t<div>\n\t\t\t\t<label>Tell us what kind of work you’re looking for and we’ll alert you as those jobs become available (select at least one)</label>\n\t\t\t\t<div class=\"pill-container\" ng-class=\"{'expanded': true}\">\n\t\t\t\t\t<div class=\"pill\"\n\t\t\t\t\t\t\tng-repeat=\"type in vm.jobble_types track by $index\"\n\t\t\t\t\t\t\tng-class=\"{ 'selected-pill' : type.selected }\"\n\t\t\t\t\t\t\tng-click=\"vm.changePrefJobbleTypes(type, $index)\">\n\t\t\t\t\t\t{{type.name}}</i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n<!--\t\t\t\t<div class=\"pill-load-more\" ng-click=\"vm.togglePreferences()\">Show {{vm.expandPreferences ? \"Less\" : \"More\"}}</div>-->\n\t\t\t\t<div class=\"btn button btn-success\"\n\t\t\t\t\t ng-click=\"vm.saveNotifPrefs();\"\n\t\t\t\t>\n\t\t\t\t\tSave\n\t\t\t\t</div>\n\t\t\t\t\n\t\t\t\t<div ng-if=\"vm.show_opt_out==true\">\n\t\t\t\t\t<h3>Privacy Policy</h3>\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<label>Opt out of sharing your personal data</label>\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<a \n\t\t\t\t\t\t\t\tng-click=\"vm.optOut()\" \n\t\t\t\t\t\t\t\thref=\"\" >\n\t\t\t\t\t\t\t\t\tOpt out\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t\n\t\t\t\t<div ng-if=\"vm.show_opt_out==false\">\n\t\t\t\t\t<h3>Privacy Policy</h3>\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<label>If you would like to opt into of Jobbles' Pivacy Policy and Cookie policy, please do so here.</label>\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<a \n\t\t\t\t\t\t\t\tng-click=\"vm.optIn()\" \n\t\t\t\t\t\t\t\thref=\"\" >\n\t\t\t\t\t\t\t\tOpt in\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n      \t</div>\n\n </div>\n \n "

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PreferencesController = function () {
	  function PreferencesController($http, $localStorage, $state, $stateParams, AuthService, EventsService, ProfileService, CompaniesService, SecurityService, $rootScope, CommonService, EnvService, $timeout, $location, $scope) {
	    var _this2 = this;
	
	    _classCallCheck(this, PreferencesController);
	
	    this.name = "preferences";
	    $localStorage.activeStateName = "preferences";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$profile = ProfileService;
	    this.$auth = AuthService;
	    this.$companies = CompaniesService;
	    this.$events = EventsService;
	    this.$stateParams = $stateParams;
	    this.$location = $location;
	    this.$security = SecurityService;
	    this.$rootScope = $rootScope;
	    this.$common = CommonService;
	    this.pref_jobble_types = [];
	    this.$env = EnvService;
	    this.$timeout = $timeout;
	    this.remain_loading_count = 0;
	    this.sections = {
	      section_1: { is_clear: false },
	      section_2: { is_clear: false },
	      section_3: { is_clear: false }
	    };
	    this.ui_model = {
	      error_model: {
	        first_name: false,
	        last_name: false,
	        email: false,
	        phone: false,
	        ssn: false,
	        address1: false,
	        address2: false,
	        city: false,
	        state: false,
	        zip_code: false,
	        bio: false,
	        dob: false,
	        month: false,
	        day: false,
	        year: false
	      },
	      warning_model: { email: false },
	      submit_model: {
	        form1: { is_disabled: true },
	        form2: { is_disabled: true },
	        form3: { is_disabled: true }
	      }
	    };
	    this.loading = true;
	    this.currentUser = this.$auth.getUserData();
	    this.basicprofile_info = {
	      basic: {
	        personal_details: {
	          first_name: null,
	          last_name: null,
	          email: null,
	          phone: null,
	          ssn: null,
	          date_birth: { day: null, month: null, year: null },
	          bio: null
	        },
	        address: {
	          street: null,
	          apt: null,
	          city: null,
	          state: null,
	          zip_code: null
	        },
	        options: {
	          preferred_jobble_types: []
	        },
	        image: {
	          url: null
	        }
	      },
	      extended: {}
	    };
	
	    //INIT FUNCTIONS
	    this.getLatestUserData(this.$stateParams.basicprofileId);
	
	    this.SetJobForApplicationAfterBasicFilledListener = this.$rootScope.$on("SetJobForApplicationAfterBasicFilled", function ($event, params) {
	      _this2.job_from_board_during_apply_attempt = params.job;
	    });
	
	    this.UpdatePrefenceUIListener = this.$rootScope.$on("UpdatePrefenceUI", function ($event, params) {
	      _this2.show_opt_out = params;
	    });
	
	    this.$scope.$on("$destroy", this.UpdatePrefenceUIListener);
	    this.$scope.$on("$destroy", this.TriggerIndicatorDataListener);
	    this.$scope.$on("$destroy", this.SetJobForApplicationAfterBasicFilledListener);
	  }
	
	  _createClass(PreferencesController, [{
	    key: "getLatestUserData",
	    value: function getLatestUserData(id) {
	      var _this = this;
	      if (_this.currentUser) {
	        _this.$profile.validateUserByToken(_this.currentUser.access_token).then(function (response) {
	          _this.setUserDataToView(response.data);
	        }, function (error) {});
	      } else {
	        alert("we have no user....");
	      }
	    }
	  }, {
	    key: "getJobbleTypes",
	    value: function getJobbleTypes(jobbleTypesParam, user) {
	      var _this3 = this;
	
	      var user_obj = user;
	
	      var newFilters = ["Logistics", "Retail", "Warehouse", "Light Industrial", "Cashier", "Delivery", "Driver", "Stocking", "Facility Staff", "Restaurant", "Hospitality", "Housekeeping", "Landscaper", "Agriculture", "Caregiving", "Security", "Customer Service", "Event Staff"];
	
	      this.$auth.getJobbleTypes(200).then(function (data) {
	        _this3.jobbleTypes = data.data;
	
	        if (data.data) {
	          _this3.jobbleTypes = data.data.filter(function (type) {
	            return newFilters.indexOf(type.name) !== -1;
	          });
	
	          _this3.jobbleTypes = _this3.jobbleTypes.sort(function (a, b) {
	            return newFilters.indexOf(a.name) - newFilters.indexOf(b.name);
	          });
	        }
	
	        _this3.jobble_types = _this3.jobbleTypes;
	        _this3.$rootScope.jobble_types = _this3.jobbleTypes;
	        _this3.setNotiJobbleTypes(jobbleTypesParam, user_obj);
	      });
	    }
	  }, {
	    key: "setUserDataToView",
	    value: function setUserDataToView(user) {
	      this.getJobbleTypes(user.notifPref.jobbleTypes, user);
	      this.currentUser = user;
	      this.checkPolicy(user);
	    }
	  }, {
	    key: "setNotiJobbleTypes",
	    value: function setNotiJobbleTypes(jobble_types, user) {
	      var _this = this;
	
	      var user_obj = user;
	
	      if (jobble_types) {
	        _this.display_pref_jt_warning = false;
	        _this.sections.section_3.is_clear = true;
	        try {
	          jobble_types.forEach(function (j) {
	            var jt = _this.jobble_types.find(function (o) {
	              return o.id === j.id;
	            });
	            if (jt) {
	              jt.selected = true;
	              _this.pref_jobble_types.push(jt.id);
	            }
	          });
	        } catch (err) {
	          console.log("in error");
	          console.dir(err);
	        } finally {
	          _this.checkToMakeSureAllFieldsAreFilledOut(user_obj);
	          _this.$timeout(function () {
	            _this.loading = undefined;
	          }, 100);
	        }
	      } else {
	        _this.display_pref_jt_warning = true;
	        _this.checkToMakeSureAllFieldsAreFilledOut(user_obj);
	        _this.$timeout(function () {
	          _this.loading = undefined;
	        }, 100);
	      }
	    }
	  }, {
	    key: "checkToMakeSureAllFieldsAreFilledOut",
	    value: function checkToMakeSureAllFieldsAreFilledOut(user) {
	      var _this = this;
	      if (_this.sections.section_1.is_clear === true && _this.sections.section_2.is_clear === true && _this.sections.section_3.is_clear === true && _this.job_from_board_during_apply_attempt) {
	        var job = _this.job_from_board_during_apply_attempt;
	        _this.$timeout(function () {
	          _this.$state.go("jobblergallery", {
	            job: job,
	            display_warning: true
	          });
	        }, 500);
	      }
	      if (_this.sections.section_1.is_clear && _this.sections.section_2.is_clear && _this.sections.section_3.is_clear && user.filePROFILE_IMAGE1IMG_160x160) {
	        _this.status_clear = true;
	      } else {
	        _this.status_clear = false;
	      }
	    }
	  }, {
	    key: "handleResponse",
	    value: function handleResponse(response) {
	      var _this = this;
	      console.log("handleResponse response");
	      console.dir(response);
	      _this.$auth.validateUserByToken(_this.currentUser.access_token).then(function (r) {
	        _this.$localStorage.logged_user = r.data;
	        _this.currentUser = r.data;
	        _this.set_current_user_to_parent(r.data);
	        if (_this.job_from_board_during_apply_attempt) {
	          _this.checkToMakeSureAllFieldsAreFilledOut(r.data);
	        }
	      }, function (error) {
	        console.log("error validating user");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "set_current_user_to_parent",
	    value: function set_current_user_to_parent(user) {
	      var _this = this;
	      console.log("set_current_user_to_parent");
	      console.dir(user);
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SettingNewUserDataToParent", user);
	        _this.$rootScope.$emit("ProfileStatusCheck", _this.ui_model);
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "togglePreferences",
	    value: function togglePreferences() {
	      this.expandPreferences = !this.expandPreferences;
	    }
	  }, {
	    key: "changePrefJobbleTypes",
	    value: function changePrefJobbleTypes(type, index) {
	      var _this = this;
	      try {
	        if (_this.pref_jobble_types.indexOf(type.id) > -1) {
	          var i = _this.pref_jobble_types.indexOf(type.id);
	          if (_this.pref_jobble_types.length > 1) {
	            type.selected = false;
	            _this.pref_jobble_types.splice(i, 1);
	            _this.ui_model.submit_model.form3.is_disabled = false;
	          } else {
	            alert("You need atleast one preferred jobble type");
	          }
	        } else {
	          _this.pref_jobble_types.push(type.id);
	          _this.ui_model.submit_model.form3.is_disabled = false;
	          type.selected = true;
	        }
	      } catch (err) {
	        console.log("in error");
	        console.dir(err);
	      }
	    }
	  }, {
	    key: "saveNotifPrefs",
	    value: function saveNotifPrefs() {
	      var _this = this;
	
	      if (_this.toggleModal) {
	        _this.toggleModal();
	      }
	
	      if (_this.ui_model.submit_model.form3.is_disabled === false) {
	        _this.setLoader();
	      } else {
	        return;
	      }
	
	      _this.display_pref_jt_warning = false;
	      _this.$profile.updatePrefJobbleTypes(_this.pref_jobble_types).then(function (response) {
	        if (window.toastr) {
	          window.toastr.options.preventDuplicates = true;
	          window.toastr.success("<i class=\"fas fa-check-circle\" style='margin-right: 8px'></i>Success! Your profile was updated");
	        }
	
	        _this.handleResponse(response.data);
	        _this.ui_model.submit_model.form3.is_disabled = true;
	        _this.jts_updated_successfully = true;
	        _this.sections.section_3.is_clear = true;
	        _this.$timeout(function () {
	          _this.unSetLoader();
	        }, 100);
	        _this.$timeout(function () {
	          _this.jts_updated_successfully = false;
	        }, 4000);
	      }, function (error) {
	        console.log("in error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "optOut",
	    value: function optOut() {
	      console.log("opt out");
	
	      this.$timeout(function () {
	        $("#opt-out").modal();
	      }, 100);
	    }
	  }, {
	    key: "checkPolicy",
	    value: function checkPolicy(user) {
	      console.log("checkPolicy");
	      console.dir(user);
	      if (user.acceptedPrivacyPolicy === true) {
	        this.show_opt_out = true;
	      } else {
	        this.show_opt_out = false;
	      }
	    }
	  }, {
	    key: "optOut",
	    value: function optOut() {
	      console.log("opt out");
	
	      this.$timeout(function () {
	        $("#opt-out").modal();
	      }, 100);
	    }
	  }, {
	    key: "optIn",
	    value: function optIn() {
	      this.$timeout(function () {
	        $("#opt-in").modal();
	      }, 100);
	    }
	  }]);
	
	  return PreferencesController;
	}();
	
	PreferencesController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "events", "profile", "companies", "security", "$rootScope", "common", "env", "$timeout", "$location", "$scope"];
	
	exports.default = PreferencesController;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(546);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".profile-info-container{border:1px solid #adbcc2;border-radius:6px;background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.2);padding:24px}.profile-info-container h2{color:#585c61;font-family:Poppins,sans-serif;font-size:18px;font-weight:700;line-height:20px;margin:0}.profile-info-container h3{color:#44484c;font-weight:600}.profile-info-container h3,.profile-info-container label{font-family:Poppins,sans-serif;font-size:14px;line-height:21px;margin:0;margin-top:16px}.profile-info-container label{color:#33373a;font-weight:400}.profile-info-container input,.profile-info-container select{height:40px;width:100%;border:1px solid #33373a;border-radius:2px;background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.1);margin-top:8px;padding:0 16px}.profile-info-container textarea{height:156px;border:1px solid #767676;border-radius:2px;background-color:#fff;color:#33373a;font-family:Poppins,sans-serif;font-size:14px;padding:16px;line-height:21px;margin-top:8px}.profile-info-container .pill-container{margin-top:16px;height:94px;overflow:hidden}.profile-info-container .pill-load-more{margin:16px 0;color:#62c046;font-family:Poppins,sans-serif;font-size:12px;font-weight:700;letter-spacing:0;line-height:11px;cursor:pointer}.profile-info-container .pill-container.expanded{height:fit-content;overflow:visible}.profile-info-container .pill{display:inline-block;color:#5e666d;height:25px;padding:0 10px;line-height:24px;border:1px solid #5e666d;border-radius:13.5px;font-size:11px;font-family:Poppins,sans-serif;font-weight:500;margin-right:8px;cursor:pointer;margin-bottom:8px;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.profile-info-container .selected-pill{background:#5e666d;color:#fff}.profile-info-container .button{height:40px;width:100px;border-radius:2px;background-color:#62c046;color:#fff;font-family:Poppins,sans-serif;font-size:14px;font-weight:700;line-height:40px;padding:0}", ""]);
	
	// exports


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _banking = __webpack_require__(548);
	
	var _banking2 = _interopRequireDefault(_banking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bankingModule = _angular2.default.module("banking", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("banking", {
	    url: "/banking/:jobblerId",
	    template: "<jobbler></jobbler>"
	  });
	}).component("banking", _banking2.default);
	
	exports.default = bankingModule;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _banking = __webpack_require__(549);
	
	var _banking2 = _interopRequireDefault(_banking);
	
	var _banking3 = __webpack_require__(550);
	
	var _banking4 = _interopRequireDefault(_banking3);
	
	__webpack_require__(551);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bankingComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _banking2.default,
	  controller: _banking4.default,
	  controllerAs: "vm"
	};
	
	exports.default = bankingComponent;

/***/ }),
/* 549 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"banking-info-container\">\n  <h2>Payments</h2>\n  <label\n    >In order to receive payments from Jobble, you must link either a debit card or bank account to your profile. Learn more about payments\n    here.</label\n  >\n\n  <div class=\"loading-details\" ng-show=\"vm.loading\">\n    <i class=\"fas fa-spin fa-spinner fa-1x fa-fw\"></i>\n  </div>\n\n  <div>\n    <div ng-repeat=\"bank in vm.banks track by $index\" class=\"payment-card-container\">\n      <div>Bank Account</div>\n      <div class=\"card-number\">**** **** **** {{bank.last4}}</div>\n    </div>\n    <div ng-repeat=\"card in vm.cards track by $index\" class=\"payment-card-container\">\n      <div>Debit Card</div>\n      <div class=\"card-number\">**** **** **** {{card.last4}}</div>\n    </div>\n  </div>\n\n  <div ng-click=\"vm.toggleAddPayment()\" class=\"choose-a-new-payment\">\n    <span ng-if=\"!vm.addingPayment\">Choose a new payment method</span><span ng-if=\"vm.addingPayment\">Cancel</span>\n  </div>\n\n  <div class=\"\" ng-if=\"vm.addingPayment\">\n    <div>\n      <select ng-model=\"vm.cardType\">\n        <option value=\"bank\">Link bank account</option>\n        <option value=\"card\">Link debit card</option>\n      </select>\n    </div>\n    <div ng-if=\"vm.cardType === 'bank'\">\n      <label>Account Holder Name</label>\n      <input ng-model=\"vm.accountHolderName\" />\n      <label>Routing Number</label>\n      <input ng-model=\"vm.routingNumber\" />\n      <label>Account Number</label>\n      <input ng-model=\"vm.accountNumber\" />\n      <div class=\"error-text\" ng-show=\"vm.bankTokenError\"><i class=\"fas fa-exclamation-circle\"></i> {{vm.bankTokenError}}</div>\n      <div class=\"save-transactions\">\n        Safe transactions through\n        <img src=\"/app/vendor/images/stripe-logo.png\" alt=\"Stripe Logo\" />\n      </div>\n      <div class=\"save-button\" ng-click=\"vm.addBankAccount()\">Save</div>\n    </div>\n    <div ng-if=\"vm.cardType === 'card'\">\n      <div class=\"row\">\n        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n          <label>Name on Card</label>\n          <input name=\"\" type=\"text\" placeholder=\"John Doe\" ng-model=\"vm.credit_card_name\" />\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n          <label>Street Address</label>\n          <input name=\"\" type=\"text\" placeholder=\"123, Main St.\" ng-model=\"vm.street\" />\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n          <label>City</label>\n          <input name=\"\" type=\"text\" placeholder=\"Boston\" ng-model=\"vm.city\" />\n        </div>\n\n        <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\" style=\"text-align: left\">\n          <label>State</label>\n          <select ng-model=\"vm.state\" ng-options=\"state for state in vm.stateList\"></select>\n        </div>\n\n        <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\">\n          <label>Zipcode</label>\n          <input name=\"\" type=\"text\" placeholder=\"01234\" ng-model=\"vm.zipCode\" />\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\">\n          <label>Card Number</label>\n          <input\n            name=\"\"\n            type=\"text\"\n            placeholder=\"XXXX-XXXX-XXXX-XXXX\"\n            class=\"form-control form-input\"\n            ng-model=\"vm.displayCardNumber\"\n            cleave=\"vm.cardNumberFormatting\"\n          />\n        </div>\n        <div class=\"col-lg-3 col-md-2 col-sm-12 col-xs-12\">\n          <label>CVC</label>\n          <input name=\"\" type=\"password\" placeholder=\"XXX\" ng-model=\"vm.cvc\" />\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\" style=\"text-align: left\">\n          <label>Exp. Month</label>\n          <select class=\"form-control form-input\" ng-model=\"vm.expMonths.value\" ng-options=\"type for type in vm.expMonths.values\" />\n        </div>\n        <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\" style=\"text-align: left\">\n          <label>Exp. Year</label>\n          <select class=\"form-control form-input\" ng-model=\"vm.expYears.value\" ng-options=\"type for type in vm.expYears.values\" />\n        </div>\n      </div>\n\n      <!--\t\t\t<div class=\"row\">-->\n      <!--\t\t\t\t<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">-->\n      <!--\t\t\t\t\t<label>Card Nickname (optional)</label>-->\n      <!--\t\t\t\t\t<input-->\n      <!--\t\t\t\t\t\t\ttype=\"text\"-->\n      <!--\t\t\t\t\t\t\tng-model=\"vm.nickname\"-->\n      <!--\t\t\t\t\t\t\tplaceholder=\"Kevins card\"-->\n      <!--\t\t\t\t\t/>-->\n      <!--\t\t\t\t</div>-->\n      <!--\t\t\t</div>-->\n      <div class=\"error-text\" ng-show=\"vm.bankTokenError\"><i class=\"fas fa-exclamation-circle\"></i> {{vm.bankTokenError}}</div>\n      <div class=\"save-transactions\">\n        Safe transactions through\n        <img src=\"/app/vendor/images/stripe-logo.png\" alt=\"Stripe Logo\" />\n      </div>\n      <div>\n        <div class=\"save-button\" ng-click=\"vm.addCreditCard()\">Save</div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<paymentdialog></paymentdialog>\n\n<div class=\"modal fade\" id=\"explain-payment-info-new\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <span aria-hidden=\"true\">&times;</span>\n            </button>\n            <h3 class=\"modal-title\">Payment Method Confirmation</h3>\n          </div>\n          <div class=\"modal-body\">\n            <p>\n              {{vm.explaination_text}}\n              <a href=\"https://intercom.help/jobble/en/articles/2065572-is-direct-deposit-the-only-option\" target=\"_blank\">here</a>.\n            </p>\n          </div>\n          <div class=\"modal-footer text-center\" style=\"text-align: center\">\n            <a class=\"btn button btn-success\" href=\"\" data-dismiss=\"modal\">Sounds good</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BankingController = function () {
	  function BankingController($http, $localStorage, $state, $stateParams, ProfileService, AuthService, EventsService, CompaniesService, SecurityService, $rootScope, CommonService, EnvService, $timeout, $location, $scope) {
	    var _this2 = this;
	
	    _classCallCheck(this, BankingController);
	
	    this.name = "banking";
	    $localStorage.activeStateName = "banking";
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$auth = AuthService;
	    this.$companies = CompaniesService;
	    this.$events = EventsService;
	    this.$stateParams = $stateParams;
	    this.loading = true;
	    this.$location = $location;
	    this.$security = SecurityService;
	    this.$profile = ProfileService;
	    this.$rootScope = $rootScope;
	    this.$common = CommonService;
	    this.$env = EnvService;
	    this.banks = [];
	    this.cards = [];
	    this.$timeout = $timeout;
	    this.remain_loading_count = 0;
	    this.currentUser = this.$auth.getUserData();
	
	    if (this.currentUser) {
	      this.accountHolderName = this.currentUser.firstName + " " + this.currentUser.lastName;
	      this.credit_card_name = this.currentUser.firstName + " " + this.currentUser.lastName;
	      this.street = this.currentUser.homeContactInfo.streetLine1;
	      this.city = this.currentUser.homeContactInfo.city;
	      this.state = this.currentUser.homeContactInfo.state;
	      this.zipCode = this.currentUser.homeContactInfo.zipCode;
	    }
	
	    this.cardType = "bank";
	
	    var thisYear = new Date().getFullYear();
	    var allYears = [thisYear.toString()];
	
	    for (var i = 1; i < 15; i++) {
	      allYears.push((thisYear + i).toString());
	    }
	    //thisMonth = thisMonth + 1;
	    this.stateList = ["AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"];
	    this.expYears = { value: thisYear.toString(), values: allYears };
	    //this.expMonths = { "value" : thisMonth.toString(), "values" : monthsForDropDrown };
	    this.expMonths = {
	      value: "01",
	      values: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
	    };
	
	    var _this = this;
	    _this.getPaymentInfo();
	    _this.GetNewPaymentInfoListener = _this.$rootScope.$on("GetNewPaymentInfo", function ($event, params) {
	      console.log("params");
	      console.dir(params);
	      if (params.data.error) {
	        _this.handleError(params.data.response);
	      } else {
	        _this.getPaymentInfo(params, true);
	      }
	    });
	    _this.$scope.$on("$destroy", _this.GetNewPaymentInfoListener);
	
	    this.cardNumberFormatting = {
	      creditCard: true,
	      delimiter: "-",
	      onValueChanged: function onValueChanged(e) {
	        _this2.cardNumber = e.target.rawValue.trim();
	      }
	    };
	  }
	
	  _createClass(BankingController, [{
	    key: "handleError",
	    value: function handleError(error) {
	      var _this = this;
	      var message = error.data.message;
	      _this.$timeout(function () {
	        _this.loading = false;
	        _this.unSetLoader();
	      }, 300);
	      _this.$timeout(function () {
	        alert(message);
	      }, 500);
	    }
	  }, {
	    key: "getPaymentInfo",
	    value: function getPaymentInfo(data, payment_info_just_created) {
	      var _this = this;
	      _this.$profile.getPaymentInfo().then(function (response) {
	        _this.handleResponse(response.data, payment_info_just_created, data);
	      }, function (error) {
	        console.log("error getting payment info");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "handleResponse",
	    value: function handleResponse(payment_infos, payment_info_just_created, data) {
	      var _this3 = this;
	
	      var _this = this;
	      this.banks = [];
	      this.cards = [];
	      if (payment_infos && payment_infos.undeletedPaymentInfos && payment_infos.undeletedPaymentInfos.length > 0) {
	        var pay_infos_array = payment_infos.undeletedPaymentInfos;
	        try {
	          try {
	            var sorted_array = pay_infos_array.sort(function (a, b) {
	              return new Date(b.lastUpdated).getTime() - new Date(a.lastUpdated).getTime();
	            });
	          } finally {
	            sorted_array.forEach(function (payment_info, index) {
	              if (index === 0) {
	                if (payment_info.bankName) {
	                  _this3.banks.push(payment_info);
	                } else {
	                  _this3.cards.push(payment_info);
	                }
	              }
	            });
	          }
	        } catch (err) {
	          console.log("error");
	          console.dir(err);
	        } finally {
	          console.log(this.banks);
	
	          if (payment_info_just_created) {
	            this.closePaymentDialog(data);
	          }
	          this.$timeout(function () {
	            _this3.loading = false;
	          });
	        }
	      } else {
	        this.$timeout(function () {
	          _this3.loading = false;
	        });
	      }
	    }
	  }, {
	    key: "closePaymentDialog",
	    value: function closePaymentDialog(data) {
	      var _this = this;
	      if (data.data.card) {
	        _this.$timeout(function () {
	          _this.unSetLoader();
	          $("#modal-add-card").modal("hide");
	        }, 1000);
	      } else {
	        _this.$timeout(function () {
	          _this.unSetLoader();
	          $("#modal-add-account").modal("hide");
	        }, 1000);
	      }
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "toggleAddPayment",
	    value: function toggleAddPayment() {
	      var _this4 = this;
	
	      if (!this.addingPayment && (this.banks.length || this.cards.length)) {
	        var c = confirm("If you save a new payment method, then it will replace your existing " + (this.banks.length ? "bank account" : "debit card") + ".");
	        if (!c) return;
	      }
	
	      this.$timeout(function () {
	        _this4.addingPayment = !_this4.addingPayment;
	      });
	    }
	  }, {
	    key: "triggerPaymentInfoModal",
	    value: function triggerPaymentInfoModal(payment_info, type, is_replace) {
	      var _this = this;
	      var data = {};
	      data.info = payment_info;
	      data.type = type;
	      data.is_replace = is_replace;
	      data.jobbler = _this.currentUser;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SettingBankForJobbler", { data: data });
	      });
	    }
	  }, {
	    key: "addCreditCard",
	    value: function addCreditCard() {
	      if (!this.cardNumber || !this.cvc || !this.street || !this.city || !this.state || !this.zipCode || !this.expMonths || !this.expMonths.value || !this.expYears || !this.expYears.value) return console.error("Missing fields");
	
	      var data = {};
	
	      data.type = "card";
	      data.is_replace = !!(this.cards && this.cards.length);
	      data.jobbler = this.currentUser;
	
	      console.log("createCreditCard");
	      this.setLoader();
	      this.isSaveCreditCardDisabled = true;
	
	      console.log("what is the new credit card");
	      console.dir(data);
	
	      this.createRecipient(data);
	    }
	  }, {
	    key: "addBankAccount",
	    value: function addBankAccount() {
	      console.log("addBankAccount");
	      console.dir(this.isSaveBankAccountDisabled);
	
	      var bank_name = this.accountHolderName;
	      var bank_routing = this.routingNumber;
	      var bank_account = this.accountNumber;
	
	      if (this.isSaveBankAccountDisabled === true) {
	        console.log("were already saving data");
	        return;
	      }
	
	      if (!bank_name || !bank_routing || !bank_account) {
	        return console.error("Missing fields");
	      }
	
	      var data = {};
	
	      data.type = "bank";
	      data.is_replace = !!(this.banks && this.banks.length);
	      data.jobbler = this.currentUser;
	
	      console.log("createBankAccount");
	      this.setLoader();
	      this.isSaveBankAccountDisabled = true;
	
	      console.log("what is the new bank account");
	      console.dir(data);
	
	      this.createRecipient(data);
	    }
	  }, {
	    key: "createRecipient",
	    value: function createRecipient(data) {
	      var _this5 = this;
	
	      var pl = null;
	
	      this.bankTokenError = null;
	      if (data.type === "card") {
	        pl = {
	          card: {
	            number: this.cardNumber,
	            exp_month: this.expMonths.value,
	            exp_year: this.expYears.value,
	            cvc: this.cvc,
	            address_line1: this.street,
	            address_city: this.city,
	            address_state: this.state,
	            address_zip: this.zipCode,
	            currency: "usd"
	          }
	        };
	      } else {
	        pl = {
	          bank_account: {
	            country: "us",
	            currency: "usd",
	            account_holder_name: this.accountHolderName,
	            account_holder_type: "individual",
	            routing_number: this.routingNumber,
	            account_number: this.accountNumber
	          }
	        };
	      }
	
	      this.$security.getToken(pl).then(function (response) {
	        console.log("in response from get token");
	        console.dir(response);
	        _this5.saveRecipient(response.data, pl, data.type);
	      }, function (error) {
	        console.log("in error");
	        console.dir(error);
	        _this5.handleRecipientError(error);
	        _this5.unSetLoader();
	      });
	    }
	  }, {
	    key: "handleRecipientError",
	    value: function handleRecipientError(response) {
	      if (response.data.error) {
	        this.bankTokenError = response.data.error.message;
	        this.isSaveBankAccountDisabled = false;
	      } else {
	        this.bankTokenError = "There was an issue saving your payment information. Please contact an administrator.";
	      }
	    }
	  }, {
	    key: "saveRecipient",
	    value: function saveRecipient(data, payment_info, type) {
	      var _this6 = this;
	
	      var pl = {};
	
	      if (type === "card") {
	        pl.username = this.currentUser.username;
	        pl.stripeToken = data.id;
	        pl.paymentMethod = "card";
	        pl.country = "us";
	        pl.currency = "usd";
	      } else {
	        pl.username = this.currentUser.username;
	        pl.stripeToken = data.id;
	        pl.paymentMethod = "bank_account";
	      }
	
	      this.$security.saveRecipient(pl).then(function (response) {
	        var data = {};
	
	        if (response.data.status === "error") {
	          console.error(response);
	          data.response = response;
	          data.error = true;
	          _this6.unSetLoader();
	          _this6.$timeout(function () {
	            _this6.$rootScope.$emit("GetNewPaymentInfo", { data: data });
	          });
	        } else {
	          data.response = response.data;
	          _this6.unSetLoader();
	
	          data.card = type === "card";
	
	          _this6.$timeout(function () {
	            _this6.$rootScope.$emit("GetNewPaymentInfo", { data: data });
	          });
	          _this6.displayInformativeModal(type, response);
	        }
	
	        _this6.isSaveBankAccountDisabled = false;
	      }, function (error) {
	        console.log("in error for saving recipient");
	        console.dir(error);
	        _this6.unSetLoader();
	        _this6.isSaveBankAccountDisabled = false;
	        alert("There was a fatal error. Please contact an administrator.");
	      });
	    }
	  }, {
	    key: "displayInformativeModal",
	    value: function displayInformativeModal(type, resp) {
	      var _this7 = this;
	
	      console.log("display modal");
	      console.dir(type);
	      console.dir(this.currentUser);
	      console.dir(resp);
	      this.$timeout(function () {
	        _this7.unSetLoader();
	      });
	      var text = null;
	      //https://intercom.help/jobble/en/articles/2065572-is-direct-deposit-the-only-option
	      if (type === "bank") {
	        text = "We have added your bank account as your primary method for receiving funds. Please learn more about the different types of payment methods ";
	      } else {
	        text = "We have added your debit card as your primary method for receiving funds. Please learn more about the different types of payment methods ";
	      }
	      this.explaination_text = text;
	      this.$timeout(function () {
	        _this7.$timeout(function () {
	          _this7.addingPayment = false;
	        });
	        $("#explain-payment-info-new").modal();
	      });
	    }
	  }]);
	
	  return BankingController;
	}();
	
	BankingController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "profile", "auth", "events", "companies", "security", "$rootScope", "common", "env", "$timeout", "$location", "$scope"];
	
	exports.default = BankingController;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(552);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".payment-card-container{height:74px;width:288px;border:1px solid #979797;border-radius:6px;background-color:#fff;padding:16px;color:#33373a;font-size:12px;font-weight:500;line-height:18px}.choose-a-new-payment,.payment-card-container{font-family:Poppins,sans-serif;letter-spacing:0;margin-top:24px}.choose-a-new-payment{color:#62c046;font-size:14px;font-weight:600;line-height:21px;margin-bottom:24px;cursor:pointer}.payment-card-container .card-number{color:#5e666d;margin-top:8px}.banking-info-container{border:1px solid #adbcc2;border-radius:6px;background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.2);padding:24px}.banking-info-container h2{color:#585c61;font-family:Poppins,sans-serif;font-size:18px;font-weight:700;line-height:20px;margin:0}.banking-info-container h3{color:#44484c;font-family:Poppins,sans-serif;font-size:14px;font-weight:600;line-height:21px;margin:0;margin-top:16px}.banking-info-container .jobble-tip-container{border-radius:6px;border:2px solid green;padding:8px;color:#5e666d;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;margin-top:16px;width:fit-content;line-height:18px}.banking-info-container select{color:#33373a;font-family:Poppins,sans-serif;font-size:14px;line-height:40px}.banking-info-container input,.banking-info-container select{border:1px solid #767676;border-radius:2px;background-color:#fff;width:100%;height:40px}.banking-info-container input{box-shadow:0 2px 4px 0 rgba(0,0,0,.1);display:block;padding:0 16px}.banking-info-container input:placeholder-shown{color:initial;opacity:1}.banking-info-container label{color:#33373a;font-family:Poppins,sans-serif;font-size:14px;line-height:21px;font-weight:400;margin-top:16px}.banking-info-container .save-button{color:#fff;font-family:Poppins,sans-serif;font-size:14px;font-weight:700;line-height:40px;height:40px;width:100px;border-radius:6px;background-color:#62c046;text-align:center;margin-top:16px;cursor:pointer}.save-transactions{color:#5e666d;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;line-height:18px;margin:24px 0}.save-transactions img{display:inline-block;height:17.2px;margin-left:2px}.banking-info-container .error-text{color:#d8000c;font-family:Poppins,sans-serif;margin-top:16px;font-size:11px;letter-spacing:0;line-height:14px}", ""]);
	
	// exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _teams = __webpack_require__(554);
	
	var _teams2 = _interopRequireDefault(_teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamsModule = _angular2.default.module("teams", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("teams", {
	    url: "/teams",
	    template: "<teams></teams>",
	    title: "Teams"
	  });
	}).component("teams", _teams2.default);
	
	exports.default = teamsModule;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teams = __webpack_require__(555);
	
	var _teams2 = _interopRequireDefault(_teams);
	
	var _teams3 = __webpack_require__(556);
	
	var _teams4 = _interopRequireDefault(_teams3);
	
	__webpack_require__(557);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamsComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _teams2.default,
	  controller: _teams4.default,
	  controllerAs: "vm"
	};
	
	exports.default = teamsComponent;

/***/ }),
/* 555 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<leftnavigation></leftnavigation>\n\n<div class=\"jobs-dashboard-container teams\">\n    <div class=\"jobs-dashboard-container-header\" style=\"margin-bottom: 40px;\">\n        <h1 class=\"jobs-header\">Teams</h1>\n    </div>\n\n    <div ng-click=\"vm.createTeamModal()\" class=\"create-new-team\">Create new team</div>\n\n    <div class=\"no-jobs-available\" ng-if=\"vm.teams.length == 0 && vm.uiViews.is_loading==false\" style=\"margin-top: 15px\">\n        No teams have been created yet.\n        <a href=\"#modal-create-team\" data-toggle=\"modal\">Create a team here.</a>\n    </div>\n    <div ng-if=\"vm.teams.length > 0\">\n        <table class=\"jobble-table teams\">\n            <thead>\n                <tr>\n                    <th>Name</th>\n                    <th style=\"width:132px;\"># of Jobblers</th>\n                    <th></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat=\"team in vm.teams | filter: vm.query track by $index\">\n                    <td>{{team.name}}</td>\n                    <td>{{ team.numberOfUsers }} Jobblers</td>\n                    <td>\n                        <a ng-repeat=\"user in team.users\">\n                            <img src=\"{{user.pictureAvatarUrl}}\" />\n                        </a>\n                    </td>\n                    <td>\n                        <i class=\"fas fa-ellipsis-h\" ng-click=\"vm.toggleActionMenu(team,$index)\" ng-if=\"vm.currentUser.company.isVerified==true\"> </i>\n\n                        <div class=\"action-menu\" ng-blur=\"vm.closeActionMenu(team,$index)\" tabindex=\"{{$index}}\">\n                            <ul>\n                                <li>\n                                    <a href=\"#\" ng-click=\"vm.addUser(team)\"> <i class=\"fas fa-plus\"></i> Add User </a>\n                                </li>\n                                <li>\n                                    <a href=\"#\" ng-click=\"vm.setTeamNameForDetailsPage(team)\"> <i class=\"fas fa-list\"></i> View Team Details </a>\n                                </li>\n                                <li>\n                                    <a href=\"#\" ng-click=\"vm.editTeam(team)\"> <i class=\"fas fa-edit\"></i> Edit Team </a>\n                                </li>\n                                <li>\n                                    <a href=\"#\" ng-click=\"vm.deleteTeam(team)\"> <i class=\"far fa-trash-alt\"></i> Delete Team </a>\n                                </li>\n                            </ul>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n\n<globalalert></globalalert>\n<jobblefooter></jobblefooter>\n<jobblerprofile></jobblerprofile>\n\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n\n<div class=\"modal fade jobble-modal\" id=\"modal-del-team\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content popup-content\">\n                    <div\n                        style=\"\n                            position: absolute;\n                            left: 0;\n                            top: 0;\n                            height: 6px;\n                            width: 100%;\n                            margin-bottom: 16px;\n                            border-radius: 6px 6px 0 0;\n                            background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n                        \"\n                    ></div>\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fas fa-times\" aria-hidden=\"true\"></i>\n                        </button>\n                        <h4 class=\"modal-title\">{{ vm.currentTeam.name }}</h4>\n                    </div>\n                    <div class=\"modal-body\">\n                        Are you sure you want to delete this team?\n\n                        <a href=\"#\" ng-click=\"vm.keepTeam($event)\" class=\"btn btn-success button\">Keep Team</a>\n                        <a href=\"#\" ng-click=\"vm.deleteCloud()\" class=\"btn btn-danger button\">Delete Team</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<!--\n<div class=\"modal fade\" id=\"modal-del-team\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content popup-content\">\n                    <div class=\"modal-header popup-header text-center\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\"><i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i></button>\n                        <h4>{{ vm.currentTeam.name }}</h4>\n                        <h3 class=\"modal-title\">will be permanently deleted. <br> Are you sure?</h3>\n                    </div>\n                    <div class=\"modal-body popup-body text-center\">\n                        <a href=\"#\"  ng-click=\"vm.keepTeam($event)\" class=\"btn btn-success button\">Keep Team</a>\n                        <a href=\"#\" ng-click=\"vm.deleteCloud()\" class=\"btn btn-danger button\">Delete Team</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n-->\n\n\n\n<div class=\"modal fade jobble-modal\" id=\"modal-edit-team\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content popup-content\">\n                    <div\n                        style=\"\n                            position: absolute;\n                            left: 0;\n                            top: 0;\n                            height: 6px;\n                            width: 100%;\n                            margin-bottom: 16px;\n                            border-radius: 6px 6px 0 0;\n                            background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n                        \"\n                    ></div>\n                    <div class=\"modal-header popup-header text-center\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fas fa-times\" aria-hidden=\"true\"></i>\n                        </button>\n                        <h4 class=\"modal-title\">Edit Team</h4>\n                        <div class=\"col-xs-6 d-flex center-block\">\n                            <input type=\"text\" value='{{vm.currentTeam.name}}' class=\"form-control form-input\" ng-model=\"vm.currentTeam.name\" />\n                            <input\n                                class=\"btn btn-success button\"\n                                value=\"Save\"\n                                type=\"button\"\n                                data-toggle=\"modal\"\n                                ng-click=\"vm.updateTeam()\"\n                            />\n                        </div>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"row\">\n                            <div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\" ng-repeat=\"user in vm.userProfilesForPagination\">\n                                <div class=\"jobs-review-hire-member-box\">\n                                    <div class=\"media\">\n                                        <div class=\"media-left jobs-review-hire-media-pad\">\n                                            <a href=\"#\">\n                                                <img\n                                                    class=\"media-object img-circle\"\n                                                    ng-src=\"{{ user.filePROFILE_IMAGE1IMG_75x75 ? user.filePROFILE_IMAGE1IMG_75x75 : '/app/vendor/images/defaultimg.jpeg' }}\"\n                                                    style=\"width: 60px\"\n                                                    alt=\"\"\n                                                />\n                                            </a>\n                                        </div>\n                                        <div class=\"media-body jobs-review-hire-member-top-pad\" style=\"text-align: left\">\n                                            <h4 class=\"media-heading\">{{ user.firstName ? user.firstName : \"N/A\" | limitTo : 12 }}</h4>\n                                            <a\n                                                class=\"jobs-review-hire-option fa fa-trash\"\n                                                href=\"#\"\n                                                ng-click=\"vm.removeJobblerFromCloud($index, $event, user)\"\n                                            ></a>\n                                            <div class=\"jobs-review-hire-star\">\n                                                <a href=\"#\" class=\"fa fa-star\"></a>\n                                                <a href=\"#\" class=\"fa fa-star\"></a>\n                                                <a href=\"#\" class=\"fa fa-star\"></a>\n                                                <a href=\"#\" class=\"fa fa-star\"></a>\n                                                <a href=\"#\" class=\"fa fa-star-half-o\"></a>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <!--<div class=\"row\">\n                            <div class=\"text-center\">\n                                <a class=\"btn btn-success button\" ng-click=\"vm.updateTeamMembers()\" ng-if=\"vm.removeJobblersList.length > 0\"\n                                    >Save Changes</a\n                                >\n                            </div>-->\n                        </div>\n                        <div class=\"row\">\n                            <ul ng-if=\"vm.pages.length > 1\" class=\"pagination event-pagination\" style=\"width: 80%\">\n                                <li\n                                    class=\"arrow unavailable\"\n                                    ng-disabled=\"vm.currentPageNumber == 1\"\n                                    ng-click=\"vm.paginateUsers(vm.currentPageNumber - 1)\"\n                                >\n                                    <a href=\"\">&#xab;</a>\n                                </li>\n                                <li\n                                    ng-repeat=\"page in vm.pages\"\n                                    ng-click=\"vm.paginateUsers(page)\"\n                                    ng-class=\"{'active': vm.currentPageNumber == page}\"\n                                >\n                                    <a href=\"\">{{page}}</a>\n                                </li>\n                                <li\n                                    class=\"arrow\"\n                                    ng-disabled=\"vm.currentPageNumber == vm.pages.length\"\n                                    ng-click=\"vm.paginateUsers(vm.currentPageNumber + 1)\"\n                                >\n                                    <a href=\"\">&#xbb;</a>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div\n    class=\"modal fade jobble-modal\"\n    id=\"modal-add-jobbler\"\n    tabindex=\"-1\"\n    role=\"dialog\"\n    aria-labelledby=\"modal-add-projectLabel\"\n    data-backdrop=\"static\"\n>\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content popup-content\">\n                    <div\n                        style=\"\n                            position: absolute;\n                            left: 0;\n                            top: 0;\n                            height: 6px;\n                            width: 100%;\n                            margin-bottom: 16px;\n                            border-radius: 6px 6px 0 0;\n                            background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n                        \"\n                    ></div>\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fas fa-times\" aria-hidden=\"true\"></i>\n                        </button>\n                        <h4 class=\"modal-title\">Add Jobblers to team \"{{ vm.selectedTeam.name }}\"</h4>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"alert-box alert\" ng-show=\"vm.isAddNewJobblersError\">{{vm.addNewJobblersErrorMessage}}</div>\n                        <form ng-submit=\"vm.submitNewJobblers()\">\n                            <label>Enter emails of Jobblers you want to add to this team separated by commas.</label>\n                            <textarea class=\"form-control form-input\" rows=\"5\" ng-model=\"vm.emailsToAdd\" style=\"height: none\"></textarea>\n                            <input class=\"btn btn-success button\" value=\"Add Jobblers\" type=\"submit\" id=\"modal-submit-button\" />\n                        </form>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div\n    class=\"modal fade jobble-modal\"\n    id=\"modal-create-team\"\n    tabindex=\"-1\"\n    role=\"dialog\"\n    aria-labelledby=\"modal-add-projectLabel\"\n    data-backdrop=\"static\"\n>\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content popup-content\">\n                    <div\n                        style=\"\n                            position: absolute;\n                            left: 0;\n                            top: 0;\n                            height: 6px;\n                            width: 100%;\n                            margin-bottom: 16px;\n                            border-radius: 6px 6px 0 0;\n                            background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n                        \"\n                    ></div>\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fas fa-times\" aria-hidden=\"true\"></i>\n                        </button>\n                        <h4 class=\"modal-title\">Create new team</h4>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"alert-box alert\" ng-show=\"vm.isCreateTeamError\">{{vm.createTeamErrorMessage}}</div>\n                        <form>\n                            <label>Team Name</label>\n                            <input \n                                type=\"text\" \n                                placeholder=\"My New Team Name\" \n                                class=\"form-control form-input\" \n                                ng-model=\"vm.cloudName\"\n                                ng-change=\"vm.validateTeamForm();\"\n                            />\n                            <label>\n                                In a comma separated list, add the emails of the users you would like to be on this team\n                            </label>\n                            <textarea \n                                class=\"form-control form-input\" \n                                rows=\"5\" \n                                ng-model=\"vm.cloudParticipants\"\n                                ng-change=\"vm.validateTeamForm();\">\n                            </textarea>\n                            <input\n                                class=\"btn btn-success button\"\n                                value=\"Create Team\"\n                                type=\"button\"\n                                data-toggle=\"modal\"\n                                data-target=\"#modal-jobbler-info\"\n                                ng-click=\"vm.submitNewCloud()\"\n                                ng-disabled=\"vm.disableTeamCreationForm\"\n                                id=\"modal-submit-button\"\n                            />\n                        </form>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<a id=\"show-added-jobblers\" href=\"#modal-added-jobblers\" data-toggle=\"modal\" ng-hide=\"true\"></a>\n<div class=\"modal fade\" id=\"modal-added-jobblers\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"vm.loadTeams()\">\n                            <span aria-hidden=\"true\">&times;</span>\n                        </button>\n                        <h4 class=\"modal-title\">Jobblers Added</h4>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"job-content\">\n                            <div class=\"job-table table-responsive\">\n                                <table class=\"table\">\n                                    <thead>\n                                        <tr>\n                                            <th style=\"width: 33%; text-align: center\">Jobbler(s) added</th>\n                                            <th style=\"width: 33%; text-align: center\">Jobbler(s) already</th>\n                                            <th style=\"width: 33%; text-align: center\">Jobbler(s) not added - invalid email</th>\n                                        </tr>\n                                    </thead>\n                                    <tbody>\n                                        <tr>\n                                            <td style=\"vertical-align: top\">\n                                                <ul style=\"list-style: none\">\n                                                    <li ng-repeat=\"jobblerAdded in vm.jobblersAdded\">{{jobblerAdded}}</li>\n                                                </ul>\n                                            </td>\n                                            <td style=\"vertical-align: top\">\n                                                <ul style=\"list-style: none\">\n                                                    <li ng-repeat=\"jobblerAlready in vm.jobblersAlready\">{{jobblerAlready}}</li>\n                                                </ul>\n                                            </td>\n                                            <td style=\"vertical-align: top\">\n                                                <ul style=\"list-style: none\">\n                                                    <li ng-repeat=\"jobblerNotAdded in vm.jobblersNotAdded\">{{jobblerNotAdded}}</li>\n                                                </ul>\n                                            </td>\n                                        </tr>\n                                    </tbody>\n                                </table>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TeamsController = function () {
	  function TeamsController($http, $localStorage, $state, AuthService, TeamsService, CompaniesService, SecurityService, $stateParams, CommonService, $rootScope, EnvService, $timeout, $location) {
	    _classCallCheck(this, TeamsController);
	
	    this.name = "teams";
	    $localStorage.activeStateName = "teams";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$teams = TeamsService;
	    this.$companies = CompaniesService;
	    this.$security = SecurityService;
	    this.$stateParams = $stateParams;
	    this.$common = CommonService;
	    this.$rootScope = $rootScope;
	    this.$env = EnvService;
	    this.$timeout = $timeout;
	    this.pages = [];
	    this.currentUser = this.$auth.getUserData();
	    this.currentPageNumber = 1;
	    this.pagesForTeams = [];
	    this.query = "";
	    this.uiViews = {};
	    this.uiViews.is_loading = true;
	    this.currentTeam = {}; // for update or delete the team
	    this.cloudName = "";
	    this.cloudParticipants = "";
	    this.cloudDescription = "description";
	    this.removeJobblersList = [];
	    this.$location = $location;
	    this.disableTeamCreationForm = true;
	    this.jobblersNotAdded = [];
	    this.jobblersAdded = [];
	    this.jobblersAlready = [];
	    this.calculatePagination();
	    this.create_team = {
	      name: "",
	      jobbler_emails: ""
	    };
	
	    this.remain_loading_count = 1;
	
	    var _this = this;
	
	    if (_this.$rootScope.teams) {
	      _this.teams = _this.$rootScope.teams;
	      this.remain_loading_count = 0;
	    }
	
	    /*
	    _this.$timeout(function() {
	    	jQuery('#show-added-jobblers').trigger('click');
	    }, 100);
	    */
	
	    _this.$rootScope.$on("TeamsHaveLoaded", function ($event, params) {
	      _this.remain_loading_count = 0;
	      _this.teams = params.teams;
	    });
	
	    _this.$timeout(function () {
	      $("jobbleheader .main-menu ul li:nth-child(4)").removeClass().addClass("active");
	    });
	
	    _this.loadTeams();
	  }
	
	  _createClass(TeamsController, [{
	    key: "clickMagnify",
	    value: function clickMagnify() {
	      _this.$timeout(function () {
	        jQuery(".search-container").addClass("s-open");
	        jQuery(".search-container").find('input[type="search"]').focus();
	      });
	    }
	  }, {
	    key: "closeSearch",
	    value: function closeSearch() {
	      _this.$timeout(function () {
	        jQuery(".search-container").removeClass("s-open");
	        this.query = "";
	      });
	    }
	  }, {
	    key: "calculatePagination",
	    value: function calculatePagination() {
	      this.pagesForTeams = [];
	      if (this.$security.isUndefinedOrNull(this.currentUser.company)) {
	        this.pagesForTeams.push(1);
	      } else {
	        var numberOfTeams = Math.ceil(this.currentUser.company.totalNumberOfCircles / 10);
	        if (numberOfTeams > 1) {
	          for (var i = 0; i < numberOfTeams; i++) {
	            this.pagesForTeams.push(i + 1);
	          }
	        }
	      }
	    }
	  }, {
	    key: "setAvatarImageToUsersOfTeam",
	    value: function setAvatarImageToUsersOfTeam(team) {
	      var _this = this;
	      team.users.forEach(function (userProfile) {
	        userProfile.pictureAvatarUrl = userProfile.filePROFILE_IMAGE1IMG_75x75;
	        if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
	          userProfile.pictureAvatarUrl = "/app/vendor/images/defaultimg.jpeg";
	        }
	      });
	    }
	  }, {
	    key: "clickViewMore",
	    value: function clickViewMore($event, team) {
	      var _this = this;
	      if (team.isAllUsersLoaded) {
	        _this.$timeout(function () {
	          jQuery($event.currentTarget).hide();
	          jQuery($event.currentTarget).closest(".team-row").find(".hide-item").css("display", "inline-block");
	        });
	        return;
	      }
	
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/circles/" + team.id + "/users?format=json&fields=id,firstName,lastName,filePROFILE_IMAGE1IMG_75x75&offset=0&sort=email&order=asc&max=" + team.numberOfUsers;
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + _this.currentUser.access_token
	        },
	        data: {}
	      };
	
	      _this.remain_loading_count++;
	      _this.$http(req).then(function (response) {
	        _this.remain_loading_count--;
	        if (response.data.status === "error") {
	          console.log("error to get the team users");
	        }
	        team.userProfiles = response.data;
	        _this.setAvatarImageToUsersOfTeam(team);
	        team.isAllUsersLoaded = true;
	        _this.$timeout(function () {
	          jQuery($event.currentTarget).hide();
	          jQuery($event.currentTarget).closest(".team-row").find(".hide-item").css("display", "inline-block");
	        });
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "clickUpBtn",
	    value: function clickUpBtn($event) {
	      // jQuery('.hide-item').hide();
	      // jQuery('.view-more').css('display','inline-block');
	
	      jQuery($event.currentTarget).closest(".team-row").find(".hide-item").hide();
	      jQuery($event.currentTarget).closest(".team-row").find(".view-more").css("display", "inline-block");
	    }
	  }, {
	    key: "setCurrentTeam",
	    value: function setCurrentTeam(team) {
	      // this.currentTeam = team;
	
	      this.isAddNewJobblersError = undefined;
	      this.emailsToAdd = undefined;
	
	      this.currentTeam = jQuery.extend(true, {}, team);
	      this.selectedTeam = team;
	      this.removeJobblersList = [];
	      console.log(this.currentTeam);
	    }
	  }, {
	    key: "paginateUsers",
	    value: function paginateUsers(offset) {
	      var _this = this;
	      console.log("paginate");
	      console.dir(_this.currentTeam);
	      console.dir(offset);
	      _this.currentPageNumber = offset;
	
	      if (offset !== 0) {
	        offset = offset * 12 - 12;
	      }
	
	      var url = _this.$env.getAPIEndPoint() + "jbl/v1/circles/" + _this.currentTeam.id + "/users?format=json&fields=id,firstName,lastName,filePROFILE_IMAGE1IMG_75x75&sort=email&order=asc&max=12&offset=" + offset;
	      var req = {
	        method: "GET",
	        url: url,
	        headers: {
	          authorization: "Bearer " + _this.currentUser.access_token
	        },
	        data: {}
	      };
	
	      _this.remain_loading_count++;
	      _this.$http(req).then(function (response) {
	        _this.remain_loading_count--;
	        if (response.data.status === "error") {
	          console.log("error to get the team users");
	        }
	
	        console.log("here is the user data...");
	        console.dir(response.data);
	        try {
	          response.data.forEach(function (userProfile) {
	            if (!_this.$security.isUndefinedOrNull(userProfile.picture1s)) {
	              userProfile.picture1s.forEach(function (pic) {
	                if (pic.indexOf("75x75") > -1) {
	                  userProfile.pictureAvatarUrl = pic;
	                }
	                if (pic.indexOf("160x160") > -1) {
	                  userProfile.pictureAvatarUrlBig = pic;
	                }
	              });
	            }
	
	            if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
	              userProfile.pictureAvatarUrl = userProfile.pictureAvatarUrlBig;
	            }
	            if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
	              userProfile.pictureAvatarUrl = "/app/vendor/images/defaultimg.jpeg";
	            }
	          });
	        } finally {
	          _this.userProfilesForPagination = response.data;
	        }
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "loadJobblers",
	    value: function loadJobblers(team, index) {
	      console.log("load jobblers");
	      console.dir(team);
	      console.dir(index);
	      var offset = index;
	      var _this = this;
	      console.log("whats the team");
	      _this.currentTeam = team;
	      console.dir(_this.currentTeam);
	
	      try {
	        var pageArray = [];
	        for (var i = 0; i < Math.ceil(team.numberOfUsers / 12); i++) {
	          pageArray.push(i + 1);
	          _this.pages = pageArray;
	        }
	      } finally {
	        if (offset !== 0) {
	          offset = offset * 12 - 12;
	        }
	
	        _this.currentPageNumber = 1;
	
	        var url = _this.$env.getAPIEndPoint() + "jbl/v1/circles/" + team.id + "/users?format=json&fields=id,firstName,lastName,email,filePROFILE_IMAGE1IMG_75x75&sort=email&order=asc&max=12&offset=" + offset;
	
	        var req = {
	          method: "GET",
	          url: url,
	          headers: {
	            authorization: "Bearer " + _this.currentUser.access_token
	          },
	          data: {}
	        };
	
	        _this.remain_loading_count++;
	        _this.$http(req).then(function (response) {
	          if (response.data.status === "error") {
	            alert("Error retrieving jobblers.");
	          }
	
	          console.log("here is the user data...");
	          console.dir(response.data);
	
	          try {
	            response.data.forEach(function (userProfile) {
	              if (!_this.$security.isUndefinedOrNull(userProfile.picture1s)) {
	                userProfile.picture1s.forEach(function (pic) {
	                  if (pic.indexOf("75x75") > -1) {
	                    userProfile.pictureAvatarUrl = pic;
	                  }
	                  if (pic.indexOf("160x160") > -1) {
	                    userProfile.pictureAvatarUrlBig = pic;
	                  }
	                });
	              }
	
	              if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
	                userProfile.pictureAvatarUrl = userProfile.pictureAvatarUrlBig;
	              }
	              if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
	                userProfile.pictureAvatarUrl = "/app/vendor/images/defaultimg.jpeg";
	              }
	            });
	          } finally {
	            _this.$timeout(function () {
	              _this.userProfilesForPagination = response.data;
	              jQuery("#modal-team-edit-anchor").trigger("click");
	            });
	
	            _this.$timeout(function () {
	              _this.remain_loading_count--;
	            }, 200);
	          }
	        }, function (response) {
	          _this.remain_loading_count--;
	          console.log(response.data);
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	        });
	      }
	    }
	  }, {
	    key: "createTeamModal",
	    value: function createTeamModal() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        jQuery("#modal-create-team").modal();
	      }, 100);
	    }
	  }, {
	    key: "createTeam",
	    value: function createTeam() {
	      this.$teams.createTeam(this.create_team).then(function (data) {
	        console.log("success");
	      }, function (data) {
	        console.log("error");
	      });
	    }
	  }, {
	    key: "keepTeam",
	    value: function keepTeam($event) {
	      jQuery($event.currentTarget).closest("#modal-del-team").find("button.close").trigger("click");
	    }
	  }, {
	    key: "addJobblersToTeam",
	    value: function addJobblersToTeam($event) {
	      jQuery($event.currentTarget).closest("#modal-add-jobbler").find("button.close").trigger("click");
	    }
	  }, {
	    key: "removeJobblerFromTeam",
	    value: function removeJobblerFromTeam($index, $event) {
	      // jQuery($event.currentTarget).parent().remove();
	      this.currentTeam.userProfiles.splice($index, 1);
	    }
	  }, {
	    key: "createCloud",
	    value: function createCloud() {
	      var _this = this;
	      _this.addNewCloud = true;
	      _this.isCreateTeamError = false;
	    }
	  }, {
	    key: "validateTeamForm",
	    value: function validateTeamForm() {
	      if (this.cloudName.length > 2) {
	        this.disableTeamCreationForm = false;
	      } else {
	        this.disableTeamCreationForm = true;
	      }
	    }
	  }, {
	    key: "submitNewCloud",
	    value: function submitNewCloud(emails, id) {
	      var _this = this;
	      _this.isCreateTeamError = false;
	      var cloudObj = {};
	      cloudObj.name = _this.cloudName;
	      cloudObj.description = _this.cloudDescription;
	      var pl = {};
	      if (emails) {
	        cloudObj.id = id;
	        pl.users = emails;
	        pl.circle = cloudObj;
	      } else {
	        pl.users = "";
	        pl.circle = cloudObj;
	      }
	      if (_this.$security.isUndefinedOrNull(_this.cloudName) || _this.$security.isUndefinedOrNull(_this.cloudDescription)) {
	        _this.isCreateTeamError = true;
	        _this.createTeamErrorMessage = "Please fill out all fields.";
	      } else {
	        _this.showFillOutAllFieldsWarning = false;
	        var str = _this.cloudParticipants.replace(/[\s,]+/g, ", ");
	        var commaSeparatedListTest = /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*,{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4})[\W]*$/.test(str);
	
	        if (commaSeparatedListTest || str.length === 0) {
	          var saveCloud = {
	            method: "POST",
	            url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.currentUser.company.id + "/add-to-circle?format=json&conf=web&verbosity=4",
	            headers: {
	              "Content-Type": "application/json",
	              Authorization: "Bearer " + _this.currentUser.access_token
	            },
	            data: pl
	          };
	          _this.remain_loading_count++;
	          _this.$http(saveCloud).then(function (response) {
	            _this.isCreateTeamError = false;
	            if (response.status === 200 && response.data.status === "OK") {
	              _this.$auth.reloadCurrentUser();
	              if (emails || str.length === 0) {
	                //_this.remain_loading_count--;
	                _this.handleModal(response);
	              } else {
	                _this.$timeout(function () {
	                  var id = response.data.result.circle.id;
	                  _this.submitNewCloud(str, id);
	                }, 2000);
	              }
	            } else {
	              _this.cloudName = null;
	              _this.cloudDescription = null;
	              _this.cloudParticipants = null;
	              _this.subview = false;
	              _this.submitNewCloudLoader = false;
	              _this.remain_loading_count--;
	              _this.$timeout(function () {
	                alert("There was an issue creating this team. Please contact support.");
	              }, 300);
	            }
	          }, function (response) {
	            _this.remain_loading_count--;
	            _this.$timeout(function () {
	              jQuery("#show-application-alert").trigger("click");
	            }, 100);
	          });
	        } else {
	          _this.isCreateTeamError = true;
	          _this.createTeamErrorMessage = "Please make sure your emails are in a comma separated list, and that your emails are formatted properly.";
	        }
	      }
	    }
	  }, {
	    key: "handleModal",
	    value: function handleModal(response) {
	      var _this = this;
	      console.log("handling response");
	      _this.remain_loading_count = 0;
	      _this.jobblersAdded = response.data.result.added;
	      _this.jobblersNotAdded = response.data.result.notAdded;
	      _this.jobblersAlready = response.data.result.already;
	      _this.setNewTeamToList(response);
	      _this.cloudName = "";
	      _this.cloudParticipants = "";
	      _this.$timeout(function () {
	        jQuery("#modal-create-team .modal-header button.close").trigger("click");
	      }, 100);
	      _this.$timeout(function () {
	        jQuery("#show-added-jobblers").trigger("click");
	      }, 300);
	    }
	  }, {
	    key: "submitNewJobblers",
	    value: function submitNewJobblers() {
	      var _this = this;
	
	      _this.isAddNewJobblersError = false;
	
	      if (!_this.$security.isUndefinedOrNull(_this.emailsToAdd)) {
	        var str = _this.emailsToAdd.replace(/[\s,]+/g, ", ");
	
	        var commaSeparatedListTest = /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*,{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4})[\W]*$/.test(str);
	
	        if (commaSeparatedListTest) {
	          var updateCloud = {
	            method: "POST",
	            url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.currentUser.company.id + "/add-to-circle?format=json&conf=web",
	            headers: {
	              "Content-Type": "application/json",
	              Authorization: "Bearer " + _this.currentUser.access_token
	            },
	            data: {
	              users: str,
	              circle: _this.currentTeam.id
	            }
	          };
	
	          _this.remain_loading_count++;
	
	          _this.$http(updateCloud).then(function (response) {
	            if (response.status === 200) {
	              if (response.data.status == "OK") {
	                _this.isAddNewJobblersError = false;
	                _this.emailsToAdd = null;
	
	                _this.jobblersAdded = response.data.result.added;
	                _this.jobblersNotAdded = response.data.result.notAdded;
	                _this.jobblersAlready = response.data.result.already;
	
	                jQuery("#modal-add-jobbler .modal-header button.close").trigger("click");
	
	                _this.$timeout(function () {
	                  jQuery("#show-added-jobblers").trigger("click");
	                }, 100);
	              } else {
	                alert("There was an error. Please contact support to solve the issue.");
	                // _this.isAddNewJobblersError = true;
	                // _this.addNewJobblersErrorMessage = "The emails is not valid or already added.";
	              }
	            } else {
	              console.log("in error");
	              console.dir(response);
	            }
	
	            _this.remain_loading_count--;
	          }, function (response) {
	            _this.remain_loading_count--;
	            _this.$timeout(function () {
	              jQuery("#show-application-alert").trigger("click");
	            }, 100);
	          });
	        } else {
	          _this.isAddNewJobblersError = true;
	          _this.addNewJobblersErrorMessage = "Please make sure your emails are in a comma separated list, and that your emails are formatted properly.";
	        }
	      } else {
	        _this.isAddNewJobblersError = true;
	        _this.addNewJobblersErrorMessage = "Please fill out the emails field.";
	      }
	    }
	  }, {
	    key: "removeJobblerFromCloud",
	    value: function removeJobblerFromCloud($index, $event, user) {
	      var _this = this;
	      console.log("what is the user");
	      console.dir(user);
	      _this.removeJobblersList.push(_this.userProfilesForPagination[$index].email);
	      _this.userProfilesForPagination.splice($index, 1);
	      console.dir(_this.userProfilesForPagination);
	      //_this.removeJobblersList.push(_this.currentTeam.userProfiles[$index].email);
	      console.dir("what is the curren tteam");
	      console.dir(_this.currentTeam.id);
	      var removeFromCloud = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.currentUser.company.id + "/remove-from-circle?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.currentUser.access_token
	        },
	        data: {
	          users: user.email,
	          circle: _this.currentTeam.id
	        }
	      };
	
	      _this.$http(removeFromCloud).then(function (response) {
	        console.log("response");
	        console.dir(response);
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	      });
	
	      return;
	    }
	  }, {
	    key: "paginate",
	    value: function paginate(pageNumber) {
	
	      if (pageNumber < 1 || pageNumber > this.pagesForTeams.length) {
	        return;
	      }
	
	      this.currentPageNumber = pageNumber;
	      this.remain_loading_count = 1;
	
	      var companyId = this.currentUser.company.id;
	      var offsetParam = pageNumber * 10 - 10,
	          maxParam = 10,
	          sort = "lastUpdated",
	          order = "desc";
	
	      var _this = this;
	      this.$companies.paginateThroughTeams(companyId, offsetParam, maxParam, sort, order).then(function (data) {
	        console.log("what is the response form pagination");
	        console.dir(data);
	
	        _this.teams = data.data;
	        _this.teams.forEach(function (team, index) {
	          _this.setAvatarImageToUsersOfTeam(team);
	          team.firstLoadUsersCount = Math.min(team.users.length, 6);
	          if (team.firstLoadUsersCount == 6) {
	            team.firstLoadUsersCount = 5;
	          }
	        });
	
	        _this.remain_loading_count--;
	      }, function (data) {
	        console.log(data);
	        _this.remain_loading_count--;
	      });
	    }
	  }, {
	    key: "updateTeamMembers",
	    value: function updateTeamMembers() {
	      var _this = this;
	
	      if (_this.removeJobblersList.length > 0) {
	        var removeFromCloud = {
	          method: "POST",
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.currentUser.company.id + "/remove-from-circle?format=json&conf=web",
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + _this.currentUser.access_token
	          },
	          data: {
	            users: _this.removeJobblersList.join(),
	            circle: _this.currentTeam.id
	          }
	        };
	        _this.remain_loading_count++;
	        _this.$http(removeFromCloud).then(function (response) {
	          _this.remain_loading_count--;
	          if (response.status === 200) {
	            if (response.data.status == "OK" && response.data.result.removed.length > 0) {
	              _this.loadTeams();
	            }
	          }
	
	          jQuery("#modal-edit-team .modal-header button.close").trigger("click");
	        }, function (response) {
	          _this.remain_loading_count--;
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	        });
	      }
	    }
	  }, {
	    key: "deleteCloud",
	    value: function deleteCloud() {
	      var _this = this;
	
	      _this.remain_loading_count++;
	      var deletingCloud = {
	        method: "DELETE",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/circles/" + _this.currentTeam.id + "?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.currentUser.access_token
	        }
	      };
	
	      _this.$http(deletingCloud).then(function (response) {
	        if (response.status = 200) {
	          var delIndex;
	          _this.teams.forEach(function (team, index) {
	            if (_this.currentTeam.id === team.id) {
	              delIndex = index;
	            }
	          });
	          _this.teams.splice(delIndex, 1);
	          _this.$auth.reloadCurrentUser();
	        } else {}
	        _this.remain_loading_count--;
	        jQuery("#modal-del-team .modal-header button.close").trigger("click");
	      }, function (response) {
	        _this.remain_loading_count--;
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "displayDetails",
	    value: function displayDetails(userProfile, type, action) {
	      var applicant = {
	        applicant: userProfile,
	        jobble: {
	          eventId: this.$stateParams.eventId
	        }
	      };
	      this.$common.displayDetails(applicant, type, action);
	      this.$rootScope.$emit("GetJobblerDataFromService", {});
	    }
	  }, {
	    key: "goToProfile",
	    value: function goToProfile(jobbler) {
	
	      var _this = this;
	
	      _this.$timeout(function () {
	        _this.$location.path("/profiles/").search({ id: jobbler.id });
	        //_this.$state.go('profiles');
	        //_this.$rootScope.$emit("SetJobblerProfile", { jobbler : jobbler });
	      }, 300);
	    }
	  }, {
	    key: "loadTeams",
	    value: function loadTeams() {
	      var _this = this;
	      var teamsSimple = [];
	      var teams = [];
	      _this.$companies.getTeamsTrim().then(function (data) {
	        console.log("what is returned from get Teams");
	        console.dir(data);
	        try {
	          data.data.forEach(function (team, index) {
	            _this.setAvatarImageToUsersOfTeam(team);
	            team.firstLoadUsersCount = Math.min(team.users.length, 6);
	            if (team.firstLoadUsersCount == 6) {
	              team.firstLoadUsersCount = 5;
	            }
	            teams.push(team);
	            var teamsObj = {};
	            teamsObj.name = team.name;
	            teamsObj.id = team.id;
	            teamsSimple.push(teamsObj);
	          });
	        } finally {
	          _this.teams = teams;
	          _this.remain_loading_count = 0;
	          _this.uiViews.is_loading = false;
	        }
	      }, function (data) {
	        _this.$rootScope.teams = [];
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "setNewTeamToList",
	    value: function setNewTeamToList(response) {
	      var _this = this;
	      var team = {};
	      team.id = response.data.result.circle.id;
	      team.name = response.data.result.circle.name;
	      team.numberOfUsers = response.data.result.added.length;
	
	      var id_to_add = team.id;
	      //call function by date created to get the new circle and add in the thumbnails
	
	      _this.teams.push(team);
	    }
	  }, {
	    key: "updateTeam",
	    value: function updateTeam() {
	      var _this = this;
	      console.log("saving team");
	      var circle = {
	        id: _this.currentTeam.id,
	        name: _this.currentTeam.name
	      };
	
	      var editFromCloud = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.currentUser.company.id + "/circles/" + _this.currentTeam.id + "?name=" + circle.name,
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.currentUser.access_token
	        }
	      };
	      _this.remain_loading_count++;
	      _this.$http(editFromCloud).then(function (response) {
	        _this.remain_loading_count--;
	        if (response.status === 200) {
	          _this.loadTeams();
	          jQuery("#modal-edit-team .modal-header button.close").trigger("click");
	        } else {
	          _this.remain_loading_count--;
	          _this.$timeout(function () {
	            alert("There was an issue creating this team. Please contact support.");
	          }, 300);
	        }
	      }, function (response) {
	        _this.remain_loading_count--;
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	      this.updateTeamMembers();
	    }
	  }, {
	    key: "setTeamNameForDetailsPage",
	    value: function setTeamNameForDetailsPage(team) {
	      var _this = this;
	      _this.$location.path("/teams/" + team.id).search({ name: team.name, numberOfUsers: team.numberOfUsers });
	    }
	  }, {
	    key: "toggleActionMenu",
	    value: function toggleActionMenu(job, index) {
	      var _this = this;
	
	      var i = index + 1;
	
	      _this.$timeout(function () {
	        $("table.jobble-table.teams tbody tr:nth-child(" + i + ") td:last-child .action-menu").slideToggle({ duration: 100 });
	      });
	
	      _this.$timeout(function () {
	        $("table.jobble-table.teams tbody tr:nth-child(" + i + ") td").addClass("row-focus");
	      }, 150);
	
	      _this.$timeout(function () {
	        $("table.jobble-table.teams tbody tr:nth-child(" + i + ") td:last-child .action-menu").focus();
	      }, 300);
	    }
	  }, {
	    key: "closeActionMenu",
	    value: function closeActionMenu(job, index) {
	      var _this = this;
	
	      var i = index + 1;
	
	      _this.$timeout(function () {
	        $("table.jobble-table.teams tbody tr:nth-child(" + i + ") td:last-child .action-menu").hide();
	        $("table.jobble-table.teams tbody tr:nth-child(" + i + ") td").removeClass("row-focus");
	      }, 150);
	    }
	  }, {
	    key: "addUser",
	    value: function addUser(team, index) {
	      this.setCurrentTeam(team);
	      this.$timeout(function () {
	        $("#modal-add-jobbler").modal();
	      });
	    }
	  }, {
	    key: "editTeam",
	    value: function editTeam(team, index) {
	      this.setCurrentTeam(team);
	      this.loadJobblers(team, 0);
	      this.$timeout(function () {
	        $("#modal-edit-team").modal();
	      });
	    }
	  }, {
	    key: "deleteTeam",
	    value: function deleteTeam(team, index) {
	      this.setCurrentTeam(team);
	      this.$timeout(function () {
	        $("#modal-del-team").modal();
	      });
	    }
	  }]);
	
	  return TeamsController;
	}();
	
	TeamsController.$inject = ["$http", "$localStorage", "$state", "auth", "teams", "companies", "security", "$stateParams", "common", "$rootScope", "env", "$timeout", "$location"];
	
	exports.default = TeamsController;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(558);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./teams.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./teams.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".jobs-dashboard-container.teams{height:140vh}table.jobble-table.teams tbody tr td:first-child{min-width:300px}table.jobble-table.teams tbody tr td:last-child{width:50px}table.jobble-table.teams tbody tr td:nth-child(3){min-width:450px}table.jobble-table.teams tbody tr td:nth-child(3) img{float:left;border-radius:50%;width:26px;margin-right:15px;margin-bottom:10px}.create-new-team{width:300px;height:50px;line-height:50px;border-radius:6px;background:linear-gradient(270deg,#62c046,#5498b4);color:#fff;font-size:17px;font-weight:700;text-align:center;cursor:pointer}.create-new-team:hover{background:#74cf59;box-shadow:inset 0 30px 60px -12px rgba(50,50,93,.25),inset 0 18px 36px -18px rgba(0,0,0,.3)}#modal-create-team .modal-body input[type=text]{border-radius:5px;margin-bottom:10px}#modal-create-team .modal-body textarea{border-radius:5px}", ""]);
	
	// exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _teamdetails = __webpack_require__(560);
	
	var _teamdetails2 = _interopRequireDefault(_teamdetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamdetailsModule = _angular2.default.module("teamdetails", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("teamdetails", {
	    url: "/teams/:teamId",
	    template: "<teamdetails></teamdetails>",
	    title: "Team"
	  });
	}).component("teamdetails", _teamdetails2.default);
	
	exports.default = teamdetailsModule;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamdetails = __webpack_require__(561);
	
	var _teamdetails2 = _interopRequireDefault(_teamdetails);
	
	var _teamdetails3 = __webpack_require__(562);
	
	var _teamdetails4 = _interopRequireDefault(_teamdetails3);
	
	__webpack_require__(564);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamdetailsComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _teamdetails2.default,
	  controller: _teamdetails4.default,
	  controllerAs: "vm"
	};
	
	exports.default = teamdetailsComponent;

/***/ }),
/* 561 */
/***/ (function(module, exports) {

	module.exports = "<style>\n  .team-jobbler-list table.line-item-table-jobblers tbody tr td:nth-child(8) {\n    text-align: center;\n  }\n</style>\n\n<jobbleheader></jobbleheader>\n\n<div class=\"jobs-dashboard-container\" style=\"padding: 20px 100px\">\n  <div>\n    <div class=\"jobble-bread-crumbs\">\n      <span><a href=\"/teams\">All Teams</a></span>\n      <span><i class=\"fas fa-chevron-left\"></i></span>\n      <span><a href=\"#\">{{vm.team_name || \"Loading . . .\"}}</a></span>\n    </div>\n  </div>\n  <div>\n    <h1>{{vm.team_name}}</h1>\n    <div class=\"page-meta\" style=\"margin-bottom: 15px\">View the on-boarding status each jobble on team</div>\n  </div>\n  <div class=\"jobs-dashboard-jobs-listing\">\n    <table class=\"jobs-dashboard-jobs-table\">\n      <thead>\n        <tr>\n          <th style=\"width: 20%\" title=\"Users Full Name\">Name</th>\n          <th title=\"Users Phone Number\">Phone</th>\n          <th title=\"Users Email\">Email</th>\n          <th title=\"User Has Registered with Jobble\">Registered</th>\n          <th title=\"User Has Filled Out Their Basic Profile\" style=\"min-width:100px;\">Profile</th>\n          <th title=\"User Has Entered Their Payment Details\" style=\"min-width:130px;\">Pay Details</th>\n          <th title=\"User Has Verified Their Email Address\">Verified</th>\n          <th></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"jobbler in vm.jobblers | filter: vm.query track by $index\">\n          <td>{{jobbler.firstName ? jobbler.firstName:\"John\" }} {{ jobbler.lastName ? jobbler.lastName : \"Doe\" }}</td>\n          <td>{{ vm.formatNumber(jobbler.homeContactInfo.phoneMobile) }}</td>\n          <td>{{jobbler.email}}</td>\n          <td>Yes</td>\n          <td ng-class=\"{ 'pass' : jobbler.ssn, 'fail' : !jobbler.ssn }\">{{jobbler.profile_pass}}</td>\n          <td ng-class=\"{'pass':jobbler.pay_pass,'fail':!jobbler.pay_pass}\">{{jobbler.pay_info}}</td>\n          <td ng-class=\"{'pass':jobbler.veri_pass,'fail':!jobbler.veri_pass}\">{{jobbler.verified}}</td>\n          <td>\n            <i class=\"fas fa-ellipsis-h\" ng-click=\"vm.toggleActionMenu($index)\"></i>\n            <div class=\"action-menu\" ng-blur=\"vm.closeActionMenu($index)\" tabindex=\"{{$index}}\">\n              <ul>\n                <li>\n                  <a href=\"#\" ng-click=\"vm.toggleRemoveUser(jobbler, $index)\"> <i class=\"far fa-trash-alt\"></i> Remove\n                    User </a>\n                </li>\n              </ul>\n            </div>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n    <div ng-if=\"vm.pages && vm.pages.length > 0 && vm.jobblers && vm.jobblers.length > 0\">\n      <ol>\n        <li ng-repeat=\"page in vm.pages track by $index\" style=\"display: inline;\" ng-click=\"vm.paginate($index + 1)\"\n          class=\"teams-pagination-details\">\n          {{$index + 1}}\n        </li>\n      </ol>\n    </div>\n  </div>\n</div>\n\n<globalalert></globalalert>\n<jobblefooter></jobblefooter>\n<jobblerprofile></jobblerprofile>\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n\n<div class=\"modal fade jobble-modal\" id=\"modal-del-user-team\" tabindex=\"-1\" role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div style=\"\n              position: absolute;\n              left: 0;\n              top: 0;\n              height: 6px;\n              width: 100%;\n              margin-bottom: 16px;\n              border-radius: 6px 6px 0 0;\n              background: linear-gradient(116.57deg, #62c046 0%, #5498b4 100%);\n            \"></div>\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fas fa-times\" aria-hidden=\"true\"></i>\n            </button>\n            <h3 class=\"modal-title\">{{vm.team_name}}</h3>\n          </div>\n          <div class=\"modal-body popup-body text-center\">\n            Are you sure you want to remove {{vm.popup_jobbler.firstName }} {{vm.popup_jobbler.lastName }} ?\n            <div class=\"row\">\n              <a href=\"#\" ng-click=\"vm.keepUser()\" class=\"btn btn-success button\">Keep</a>\n              <a href=\"#\" ng-click=\"vm.removeUser()\" class=\"btn btn-danger button\">Remove</a>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _teams = __webpack_require__(563);
	
	var _teams2 = _interopRequireDefault(_teams);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TeamdetailsController = function () {
	  function TeamdetailsController($http, $localStorage, $state, AuthService, TeamsService, CompaniesService, SecurityService, $stateParams, CommonService, $rootScope, EnvService, $timeout, $location) {
	    _classCallCheck(this, TeamdetailsController);
	
	    this.name = "teamdetails";
	    $localStorage.activeStateName = "teamdetails";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$teams = TeamsService;
	    this.$companies = CompaniesService;
	    this.$security = SecurityService;
	    this.$stateParams = $stateParams;
	    this.$common = CommonService;
	    this.$rootScope = $rootScope;
	    this.$env = EnvService;
	    this.$timeout = $timeout;
	    this.currentPageNumber = 1;
	    this.pages = [];
	    this.currentUser = this.$auth.getUserData();
	    this.currentPageNumber = 1;
	    this.$location = $location;
	    this.userDetailsAreLoading = false;
	    this.user_query = {
	      max: 20,
	      offset: 0,
	      sort: "firstName",
	      order: "desc"
	    };
	    var _this = this;
	    _this.loadJobblers(0, 100);
	    _this.team_name = _this.$location.$$search.name;
	    _this.remain_loading_count = 0;
	    _this.setPagination(_this.$location.$$search.numberOfUsers);
	    _this.setDisabledArrows();
	  }
	
	  _createClass(TeamdetailsController, [{
	    key: "loadJobblers",
	    value: function loadJobblers() {
	      var _this = this;
	
	      if (this.userDetailsAreLoading === true) {
	        return;
	      }
	
	      this.userDetailsAreLoading = true;
	
	      var id = _this.$stateParams.teamId;
	      _this.setLoader();
	
	      console.log("queary params");
	      console.dir(_this.user_query);
	
	      _this.$companies.loadJobblersFromTeam(id, _this.user_query).then(function (response) {
	        _this.userDetailsAreLoading = false;
	        _this.jobblers = response.data;
	        try {
	          _this.jobblers.forEach(function (jobbler) {
	            _this.addAttributes(jobbler);
	          });
	        } catch (err) {
	          console.log("in looping error");
	          console.dir(err);
	        } finally {
	          console.log("in the finally");
	          console.dir(_this.jobblers);
	          _this.unSetLoader();
	          _this.fancyLoad();
	        }
	      }, function (error) {
	        _this.userDetailsAreLoading = false;
	        _this.unSetLoader();
	        _this.$timeout(function () {
	          alert("Error loading team details. Please try again. If the problem persists please contact support.");
	        }, 300);
	      });
	    }
	  }, {
	    key: "fancyLoad",
	    value: function fancyLoad() {
	      this.$timeout(function () {
	        $(".jobs-dashboard-container .jobs-dashboard-jobs-listing table.jobs-dashboard-jobs-table tbody tr").each(function (index) {
	          $(this).delay(index * 10).show(50);
	        });
	      }, 200);
	    }
	  }, {
	    key: "clickMagnify",
	    value: function clickMagnify() {
	      jQuery(".search-container").addClass("s-open");
	      jQuery(".search-container").find('input[type="search"]').focus();
	    }
	  }, {
	    key: "closeSearch",
	    value: function closeSearch() {
	      jQuery(".search-container").removeClass("s-open");
	      this.query = "";
	    }
	  }, {
	    key: "addAttributes",
	    value: function addAttributes(jobbler) {
	      var _this = this;
	      try {
	        if (jobbler.ssn) {
	          jobbler.profile_pass = "Yes";
	        } else {
	          jobbler.profile_pass = "No";
	        }
	        if (jobbler.paymentInfos[0] && jobbler.paymentInfos[0].id) {
	          jobbler.pay_pass = true;
	          jobbler.pay_info = "Yes";
	        } else {
	          jobbler.pay_pass = false;
	          jobbler.pay_info = "No";
	        }
	        if (jobbler.isVerified) {
	          jobbler.veri_pass = true;
	          jobbler.verified = "Yes";
	        } else {
	          jobbler.veri_pass = false;
	          jobbler.verified = "No";
	        }
	      } catch (err) {
	        console.log("addAttributes error");
	        console.dir(err);
	      }
	    }
	  }, {
	    key: "setPagination",
	    value: function setPagination(total) {
	      var _this = this;
	      var page_array = [];
	      if (total) {
	        for (var i = 0; i < Math.ceil(total / _this.user_query.max); i++) {
	          page_array.push(i + 1);
	        }
	        _this.pages = page_array;
	      }
	    }
	  }, {
	    key: "paginate",
	    value: function paginate(page) {
	
	      console.log("paginate");
	      console.dir(page);
	
	      var _this = this;
	      if (_this.currentPageNumber === 1 && page === 0) {
	        return;
	      }
	      if (_this.currentPageNumber === _this.pages.length && page === _this.pages.length + 1) {
	        return;
	      }
	      _this.currentPageNumber = page;
	      var max = _this.user_query.max;
	      _this.user_query.offset = page * max - max;
	      _this.loadJobblers();
	    }
	  }, {
	    key: "setDisabledArrows",
	    value: function setDisabledArrows() {
	      var _this = this;
	    }
	  }, {
	    key: "confirmRemoval",
	    value: function confirmRemoval(jobbler) {
	      var _this = this;
	      console.log("confirm removal");
	      console.dir(jobbler);
	      _this.$timeout(function () {
	        $("#confirm-team-removal").modal();
	      });
	    }
	  }, {
	    key: "toggleRemoveUser",
	    value: function toggleRemoveUser(jobbler, index) {
	      var _this = this;
	      _this.popup_jobbler = jobbler;
	      _this.index = index;
	      _this.$timeout(function () {
	        $("#modal-del-user-team").modal();
	      });
	    }
	  }, {
	    key: "keepUser",
	    value: function keepUser() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("#modal-del-user-team").modal("toggle");
	      });
	    }
	  }, {
	    key: "toggleActionMenu",
	    value: function toggleActionMenu(index) {
	      var _this = this;
	      var i = index + 1;
	
	      _this.$timeout(function () {
	        $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").slideToggle({ duration: 100 });
	      });
	
	      _this.$timeout(function () {
	        $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td").addClass("row-focus");
	      }, 150);
	
	      _this.$timeout(function () {
	        $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").focus();
	      }, 300);
	    }
	  }, {
	    key: "closeActionMenu",
	    value: function closeActionMenu(index) {
	      var _this = this;
	      var i = index + 1;
	
	      _this.$timeout(function () {
	        $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").hide();
	        $("table.jobs-dashboard-jobs-table tbody tr:nth-child(" + i + ") td").removeClass("row-focus");
	      }, 150);
	    }
	  }, {
	    key: "removeUser",
	    value: function removeUser() {
	      var _this = this;
	      var users_array = [];
	      var data = {};
	      data.users = _this.popup_jobbler.email;
	      data.circle = parseInt(_this.$stateParams.teamId, 10);
	      _this.setLoader();
	      _this.$companies.deleteUserFromTeam(data).then(function (response) {
	        //console.log("response");
	        //console.dir(response);
	        _this.unSetLoader();
	        _this.jobblers.splice(_this.index, 1);
	        var total = _this.$location.$$search.numberOfUsers - 1;
	        _this.setPagination(total);
	        _this.$timeout(function () {
	          $("#modal-del-user-team").modal("toggle");
	        });
	      }, function (error) {
	        alert("There was an issue removing the jobbler from the team. Please try again. If the problem persists please contact support.");
	      });
	    }
	  }, {
	    key: "formatNumber",
	    value: function formatNumber(number) {
	      console.log("format number");
	      var num = number;
	      if (num) {
	        if (num.charAt(0) === "1") {
	          num = num.slice(1, num.length);
	        }
	        var cleaned = ("" + num).replace(/\D/g, "");
	        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
	        if (match) {
	          num = "(" + match[1] + ") " + match[2] + "-" + match[3];
	        } else {
	          num = num;
	        }
	      } else {
	        num = "--";
	      }
	      return num;
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }]);
	
	  return TeamdetailsController;
	}();
	
	TeamdetailsController.$inject = ["$http", "$localStorage", "$state", "auth", "teams", "companies", "security", "$stateParams", "common", "$rootScope", "env", "$timeout", "$location"];
	
	exports.default = TeamdetailsController;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TeamsService = function () {
	  function TeamsService($http, $localStorage, $state) {
	    _classCallCheck(this, TeamsService);
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	  }
	
	  _createClass(TeamsService, [{
	    key: "index",
	    value: function index(token) {
	      var req = {
	        method: "GET",
	        url: base_back_endpoint + "teams.json",
	        async: false,
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getTeams",
	    value: function getTeams(token) {
	      var req = {
	        method: "GET",
	        url: base_back_endpoint + "teams.json",
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "createTeam",
	    value: function createTeam() {
	      var req = {};
	      return this.$http(req);
	    }
	  }]);
	
	  return TeamsService;
	}();
	
	exports.default = TeamsService;
	
	
	TeamsService.$inject = ["$http", "$localStorage", "$state"];

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(565);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./teamdetails.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./teamdetails.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "ol li.teams-pagination-details{border:1px solid #33373a;padding:5px 10px;font-size:14px;font-weight:400}ol li.teams-pagination-details:first-child{border-top-left-radius:4px;border-bottom-left-radius:4px}ol li.teams-pagination-details:last-child{border-top-right-radius:4px;border-bottom-right-radius:4px}ol li.teams-pagination-details:hover{cursor:pointer;font-weight:800;background-color:#eee}", ""]);
	
	// exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _connections = __webpack_require__(567);
	
	var _connections2 = _interopRequireDefault(_connections);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var connectionsModule = _angular2.default.module("connections", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("connections", {
	    url: "/connections",
	    template: "<connections></connections>"
	  });
	}).component("connections", _connections2.default);
	
	exports.default = connectionsModule;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _connections = __webpack_require__(568);
	
	var _connections2 = _interopRequireDefault(_connections);
	
	var _connections3 = __webpack_require__(569);
	
	var _connections4 = _interopRequireDefault(_connections3);
	
	__webpack_require__(570);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var connectionsComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _connections2.default,
	  controller: _connections4.default,
	  controllerAs: "vm"
	};
	
	exports.default = connectionsComponent;

/***/ }),
/* 568 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n<div id=\"wrapper\">\n  <section class=\"content\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <div class=\"connection-header-left\">\n            <h1>Connections</h1>\n            <p>View and message jobblers you have connected with</p>\n          </div>\n          <div class=\"connection-header-right\">\n            <div class=\"search-option clearfix\">\n              <form class=\"pull-right\">\n                <div class=\"search-container clearfix\">\n                  <a href=\"#\" class=\"magnify\" ng-click=\"vm.clickMagnify()\"></a>\n                  <input type=\"search\" ng-model=\"vm.query\" />\n                  <a href=\"#\" class=\"close-search\" ng-click=\"vm.closeSearch()\"><img src=\"/app/vendor/images/search-close.png\" alt=\"\" /></a>\n                </div>\n              </form>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\" ng-if=\"!vm.jobblers\">\n        <div class=\"col-xs-12\">\n          <div class=\"alert alert-info\" role=\"alert\">\n            <strong>Jobble tip:</strong> You currently do not have any connections. Create a connections job post to make some connections.\n          </div>\n        </div>\n      </div>\n      <div class=\"row\" ng-if=\"vm.jobblers.length > 0\">\n        <div class=\"col-xs-12\">\n          <table class=\"connections-table\">\n            <thead>\n              <tr>\n                <th></th>\n                <th>First name</th>\n                <th>Last Name</th>\n                <th>Email</th>\n                <th>Number</th>\n                <th>Rating</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr ng-repeat=\"jobbler in vm.jobblers | filter: vm.query track by $index\" ng-click=\"vm.goToProfile(jobbler)\">\n                <td>\n                  <img src=\"{{ vm.displayPicture(jobbler.picture1s) }}\" />\n                </td>\n                <td>{{ jobbler.firstName }}</td>\n                <td>{{ jobbler.lastName }}</td>\n                <td>{{ jobbler.email }}</td>\n                <td>{{ vm.formatPhoneNumber(jobbler.homeContactInfo.phoneMobile) }}</td>\n                <td>{{ jobbler.averageRatingReceived | number : 1 }}/5</td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n\n<globalalert></globalalert>\n\n<jobblefooter></jobblefooter>\n\n<jobblerprofile></jobblerprofile>\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ConnectionsController = function () {
	  function ConnectionsController($http, $localStorage, $state, $timeout, $rootScope, $location, AuthService, SecurityService) {
	    _classCallCheck(this, ConnectionsController);
	
	    this.name = "profiles";
	
	    $localStorage.activeStateName = "profiles";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.$auth = AuthService;
	    this.remain_loading_count = 1;
	    this.query = "";
	    this.$location = $location;
	    this.$security = SecurityService;
	    this.currentUser = this.$auth.getUserData();
	
	    var _this = this;
	
	    console.log("what is the current user");
	    console.dir(this.currentUser);
	
	    if (this.currentUser.company.circleOfConnectedJobblers.length !== 0) {
	      this.$security.getConnections(this.currentUser.company.circleOfConnectedJobblers[0].id).then(function (response) {
	        _this.jobblers = response.data;
	        _this.remain_loading_count = 0;
	      });
	    } else {
	      _this.remain_loading_count = 0;
	    }
	  }
	
	  _createClass(ConnectionsController, [{
	    key: "clickMagnify",
	    value: function clickMagnify() {
	      jQuery(".search-container").addClass("s-open");
	      jQuery(".search-container").find('input[type="search"]').focus();
	    }
	  }, {
	    key: "closeSearch",
	    value: function closeSearch() {
	      jQuery(".search-container").removeClass("s-open");
	      this.query = "";
	    }
	  }, {
	    key: "displayPicture",
	    value: function displayPicture(pictures) {
	      var _this = this;
	
	      for (var i = 0; i < pictures.length; i++) {
	        if (pictures[i].indexOf("160x160") > -1) {
	          return pictures[i];
	          break;
	        }
	      }
	    }
	  }, {
	    key: "formatPhoneNumber",
	    value: function formatPhoneNumber(number) {
	      if (number.length === 11) {
	        number = number.substr(1);
	        number = number.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
	      } else {
	        if (number.length === 10) {
	          number = number.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
	        } else {
	          number = number;
	        }
	      }
	
	      return number;
	    }
	  }, {
	    key: "goToProfile",
	    value: function goToProfile(jobbler) {
	      console.log("go to profile");
	      console.dir(jobbler);
	      var _this = this;
	
	      _this.$timeout(function () {
	        _this.$location.path("/profiles/").search({ id: jobbler.id });
	        //_this.$state.go('profiles');
	        //_this.$rootScope.$emit("SetJobblerProfile", { jobbler : jobbler });
	      }, 300);
	    }
	  }]);
	
	  return ConnectionsController;
	}();
	
	ConnectionsController.$inject = ["$http", "$localStorage", "$state", "$timeout", "$rootScope", "$location", "auth", "security"];
	
	exports.default = ConnectionsController;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(571);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./connections.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./connections.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _uber = __webpack_require__(573);
	
	var _uber2 = _interopRequireDefault(_uber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uberModule = _angular2.default.module("uber", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("uber", {
	    url: "/deals/uber",
	    template: "<uber></uber>"
	    //params: { FirstName : null, LastName : null, CompanyName : null, Phone : null, Email : null, Password : null }
	  });
	}).component("uber", _uber2.default);
	
	exports.default = uberModule;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _uber = __webpack_require__(574);
	
	var _uber2 = _interopRequireDefault(_uber);
	
	var _uber3 = __webpack_require__(575);
	
	var _uber4 = _interopRequireDefault(_uber3);
	
	__webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uberComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _uber2.default,
	  controller: _uber4.default,
	  controllerAs: "vm"
	};
	
	exports.default = uberComponent;

/***/ }),
/* 574 */
/***/ (function(module, exports) {

	module.exports = "<style>\n  body {\n    background-color: #6d1111;\n  }\n\n  @font-face {\n    /*\n  font-family: Montserrat-Regular;\n  src: local(\"/app/vendor/fonts/Montserrat-Regular.ttf\");\n  */\n  }\n\n  .full-page-take-over {\n    width: 100%;\n    background-color: #6d1111;\n    position: relative;\n    /*\n\twidth:100%;\n\theight: 100%;\n\ttext-align: center;\n\tbackground-image: url('/app/vendor/images/uber-page-take.jpg');\n\tbackground-repeat: no-repeat;\n    background-attachment: fixed;\n    background-size: 100% 100%;\n    background-position: center;\n    height:1136px;\n    width:640px;\n    background-color: #000;\n    */\n  }\n\n  .full-page-take-over:hover {\n    cursor: pointer;\n  }\n\n  .full-page-take-over .full-page-take-over-nested {\n    width: 293px;\n    height: 440px;\n    background-image: url(\"/app/vendor/images/without-text.png\");\n    background-repeat: no-repeat;\n    background-position: center top;\n    position: absolute;\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n  }\n\n  .full-page-take-over h3 {\n    text-transform: uppercase;\n    color: #fff;\n    position: absolute;\n    top: 136px;\n    left: 34px;\n    font-size: 14px;\n    font-weight: 700;\n    color: #494949;\n    margin: 0 0 10px;\n    text-transform: uppercase;\n    padding: 20px 14px 0;\n    color: #fff;\n  }\n\n  .full-page-take-over h4 {\n    text-transform: uppercase;\n    color: #fff;\n    position: absolute;\n    bottom: 0px;\n    left: 10px;\n    font-size: 10px;\n  }\n\n  .become-driver-button {\n    text-transform: uppercase;\n    position: absolute;\n    color: #fff;\n    background-color: #4fb7d3;\n\n    padding: 7px 15px 7px 15px;\n    top: 203px;\n    left: 48px;\n    border-radius: 2px;\n  }\n\n  .become-driver-button:hover {\n    color: #fff;\n  }\n\n  .full-page-take-over-nested img {\n    width: 53px;\n    position: absolute;\n    bottom: 3px;\n    font-size: 10px;\n    left: 146px;\n  }\n</style>\n\n<div class=\"full-page-take-over\" style=\"text-align: center\">\n  <img src=\"/app/vendor/images/happy-holidays-1080.png\" />\n</div>\n\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UberController = function () {
	  function UberController($http, $state, $stateParams, $location, $timeout, AuthService, $rootScope, $cookies, TrackingService, $window) {
	    _classCallCheck(this, UberController);
	
	    this.name = "uber";
	    this.$http = $http;
	    this.$state = $state;
	    this.$cookies = $cookies;
	    this.$stateParams = $stateParams;
	    this.$location = $location;
	    this.$window = $window;
	    this.$auth = AuthService;
	    this.$rootScope = $rootScope;
	    this.currentUser = this.$auth.getUserData();
	    this.$tracking = TrackingService;
	    this.$timeout = $timeout;
	    this.remain_loading_count = 0;
	    //https://click.appcast.io/track/feeddh?cs=52f
	    console.log("what are the params");
	    console.dir(this.$location.$$search);
	  }
	
	  _createClass(UberController, [{
	    key: "goToAd",
	    value: function goToAd() {
	      var _this = this;
	
	      if (_this.$location.$$search.url) {
	        _this.$timeout(function () {
	          _this.remain_loading_count = 1;
	          //_this.$rootScope.$emit("SetLoaderDialog", { type : 14, total : 1 });
	        });
	
	        _this.$timeout(function () {
	          //console.log('going here....');
	          //console.dir(_this.$location.$$search.url);
	          _this.$window.location.href = _this.$location.$$search.url;
	        }, 500);
	      } else {
	        console.log("no url");
	      }
	    }
	  }]);
	
	  return UberController;
	}();
	
	UberController.$inject = ["$http", "$state", "$stateParams", "$location", "$timeout", "auth", "$rootScope", "$cookies", "tracking", "$window"];
	
	exports.default = UberController;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(577);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./uber.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./uber.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _ubercampaign = __webpack_require__(579);
	
	var _ubercampaign2 = _interopRequireDefault(_ubercampaign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ubercampaignModule = _angular2.default.module("ubercampaign", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("ubercampaign", {
	    url: "/campaigns/ubercampaign",
	    template: "<ubercampaign></ubercampaign>"
	  }).state("ubercampaign2", {
	    url: "/campaigns/direct",
	    template: "<ubercampaign></ubercampaign>"
	  });
	}).component("ubercampaign", _ubercampaign2.default);
	
	exports.default = ubercampaignModule;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ubercampaign = __webpack_require__(580);
	
	var _ubercampaign2 = _interopRequireDefault(_ubercampaign);
	
	var _ubercampaign3 = __webpack_require__(581);
	
	var _ubercampaign4 = _interopRequireDefault(_ubercampaign3);
	
	__webpack_require__(582);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ubercampaignComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _ubercampaign2.default,
	  controller: _ubercampaign4.default,
	  controllerAs: "vm"
	};
	
	exports.default = ubercampaignComponent;

/***/ }),
/* 580 */
/***/ (function(module, exports) {

	module.exports = "<style>\n  /*\n\t.container {\n\t\t\n\t\twidth: 100%;\n\t\tposition: fixed;\n  \t\ttop: 50%;\n  \t\tleft: 50%;\n\t\t\n\t}\n\t\n\t.row {\n\t\t\n\t\twidth:100%;\n\t\tmargin-top: 30px;\n\t\ttext-align:center;\n\t\t\n\t}\n\t\n\ta {\n\t\t\n\t\tpadding: 15px 15px 15px 15px;\n\t\tbackground-color: green;\n\t\tborder-radius: 3px;\n\t\tcolor: #fff;\n\t\n\t}\n\t\n\ta:hover {\n\t\n\t\tcolor: #fff;\n\t\t\n\t}\n\t*/\n\n  body {\n  }\n\n  a {\n  }\n\n  .full-page-takeover {\n    width: 100%;\n    background-color: #fff;\n    height: 100%;\n  }\n\n  .big-one-custom {\n    padding: 20px 20px 20px 20px;\n    background-color: #74cf59;\n    display: inline-block;\n    color: #fff;\n    font-size: 20px;\n    font-weight: 600;\n    width: 80%;\n    border-radius: 4px;\n  }\n\n  .big-one-custom:hover {\n    color: #fff;\n  }\n\n  .row {\n    margin-bottom: 30x;\n    text-align: center;\n  }\n</style>\n<!--\n<html>\n\t<head>\n\t\t<link href=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css\" rel=\"stylesheet\" type=\"text/css\" />\n\t</head>\n-->\n\n<div class=\"full-page-takeover\" ng-if=\"vm.user.phone_type !== 'none'\">\n  <div class=\"row\" style=\"padding-top: 100px\">\n    <img src=\"app/vendor/images/logo-red.png\" alt=\"Jobble Biz\" title=\"Jobble Biz\" />\n  </div>\n\n  <div class=\"row\" style=\"padding-top: 50px\">\n    <a class=\"big-one-custom\" ng-click=\"vm.open()\" href=\"\"> Launch Jobble app </a>\n  </div>\n\n  <div class=\"row\" style=\"padding-top: 50px\" ng-if=\"vm.user.phone_type == 'ios'\">\n    <a class=\"big-one-custom\" ng-click=\"vm.forward()\" href=\"\"> Download from App Store </a>\n  </div>\n\n  <div class=\"row\" style=\"padding-top: 25px\" ng-if=\"vm.user.phone_type == 'android'\">\n    <a class=\"big-one-custom\" ng-if=\"vm.user.phone_type == 'android'\" ng-click=\"vm.forward()\" href=\"\"> Download from Google Play Store </a>\n  </div>\n</div>\n\n<div class=\"full-page-takeover\" ng-if=\"vm.user.phone_type == 'none'\">\n  <div class=\"row\" style=\"padding-top: 100px\">\n    <img src=\"app/vendor/images/logo-red.png\" alt=\"Jobble Biz\" title=\"Jobble Biz\" />\n  </div>\n\n  <div class=\"row\" style=\"padding-top: 50px\">\n    <a class=\"big-one-custom\" ng-click=\"vm.forwardIos()\" href=\"\"> Download from App Store </a>\n  </div>\n\n  <div class=\"row\" style=\"padding-top: 25px\">\n    <a class=\"big-one-custom\" ng-click=\"vm.forwardAndroid()\" href=\"\"> Download from Google Play Store </a>\n  </div>\n</div>\n\n<!--\n</html>\n-->\n"

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UbercampaignController = function () {
	  function UbercampaignController($http, $state, $stateParams, $location, $timeout, AuthService, $rootScope, $cookies, TrackingService, $window) {
	    _classCallCheck(this, UbercampaignController);
	
	    this.name = "ubercampaign";
	    this.$http = $http;
	    this.$state = $state;
	    this.$cookies = $cookies;
	    this.$stateParams = $stateParams;
	    this.$location = $location;
	    this.$window = $window;
	    this.$auth = AuthService;
	    this.$rootScope = $rootScope;
	    this.currentUser = this.$auth.getUserData();
	    this.$tracking = TrackingService;
	    this.$timeout = $timeout;
	    this.remain_loading_count = 0;
	    this.user = { phone_type: null };
	    //this.forward();
	    //jobble://jobble.html
	
	    console.log("check into the location");
	    console.dir(this.$location);
	    console.dir(this.$location.$$path.indexOf("/ubercampaign") > -1);
	
	    if (this.$location.$$path.indexOf("/ubercampaign") > -1) {
	      console.log("what is this");
	
	      this.$location.path("/campaigns/direct");
	    } else {
	      this.discover();
	    }
	  }
	
	  _createClass(UbercampaignController, [{
	    key: "open",
	    value: function open() {
	      var _this = this;
	
	      _this.$window.location.href = "jobble://jobble.html";
	    }
	  }, {
	    key: "forward",
	    value: function forward() {
	      var _this = this;
	
	      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	
	      if (/android/i.test(userAgent)) {
	        _this.$window.location.href = "https://play.google.com/store/apps/details?id=com.jobble.jobble";
	      }
	
	      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	        _this.$window.location.href = "https://itunes.apple.com/us/app/jobble/id961838757";
	      }
	
	      /*
	      _this.$window.location.href = 'jobble://jobble.html';
	      _this.$timeout(function(){
	      }, 1000)
	      */
	    }
	  }, {
	    key: "forwardAndroid",
	    value: function forwardAndroid() {
	      var _this = this;
	
	      _this.$window.location.href = "https://play.google.com/store/apps/details?id=com.jobble.jobble";
	    }
	  }, {
	    key: "forwardIos",
	    value: function forwardIos() {
	      var _this = this;
	
	      _this.$window.location.href = "https://itunes.apple.com/us/app/jobble/id961838757";
	    }
	  }, {
	    key: "discover",
	    value: function discover() {
	      var _this = this;
	
	      console.log("discover");
	
	      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	
	      console.log("user Agent");
	      console.dir(userAgent);
	
	      if (/android/i.test(userAgent)) {
	        _this.$timeout(function () {
	          _this.user.phone_type = "android";
	        });
	      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	        _this.$timeout(function () {
	          _this.user.phone_type = "ios";
	        });
	      } else {
	        _this.$timeout(function () {
	          _this.user.phone_type = "none";
	        });
	      }
	    }
	  }]);
	
	  return UbercampaignController;
	}();
	
	UbercampaignController.$inject = ["$http", "$state", "$stateParams", "$location", "$timeout", "auth", "$rootScope", "$cookies", "tracking", "$window"];
	
	exports.default = UbercampaignController;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(583);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./ubercampaign.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./ubercampaign.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _profiles = __webpack_require__(585);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var profilesModule = _angular2.default.module("profiles", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("profiles", {
	    url: "/profiles/:profileId",
	    template: "<profiles></profiles>"
	  });
	}).component("profiles", _profiles2.default);
	
	exports.default = profilesModule;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _profiles = __webpack_require__(586);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	var _profiles3 = __webpack_require__(587);
	
	var _profiles4 = _interopRequireDefault(_profiles3);
	
	__webpack_require__(588);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var profilesComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _profiles2.default,
	  controller: _profiles4.default,
	  controllerAs: "vm"
	};
	
	exports.default = profilesComponent;

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n<div id=\"wrapper\">\n  <section class=\"content\">\n    <div class=\"container\">\n      <div class=\"row\">\n      \t<div class=\"col-xs-12\">\n      \t\t<div class=\"jobbler-profile-public\">\n      \t\t\t<div class=\"jobbler-profile-public-top\">\n      \t\t\t\t<img src=\"{{ vm.randomPicture() }}\" />\n      \t\t\t</div>\n      \t\t\t<div class=\"jobbler-overlay\">\n      \t\t\t\n      \t\t\t\t<div class=\"jobbler-overlay-top\">\n      \t\t\t\t\t<div class=\"row\">\n\t      \t\t\t\t\t<div class=\"jobbler-overlay-top-left\">\n\t      \t\t\t\t\t\t<img src=\"{{ vm.displayPicture(vm.jobbler) }}\" ng-click=\"vm.gallery()\"/>\n\t      \t\t\t\t\t</div>\n\t      \t\t\t\t\t<div class=\"jobbler-overlay-top-right\">\n\t      \t\t\t\t\t\t<h3>{{ vm.jobbler.firstName }} {{ vm.jobbler.lastName }}</h3>\n\t      \t\t\t\t\t\t<p>{{ vm.jobbler.homeContactInfo.streetLine1 }} {{ vm.jobbler.homeContactInfo.city }} {{ vm.jobbler.homeContactInfo.state }}, {{ vm.jobbler.homeContactInfo.zipCode }}</p>\n\t      \t\t\t\t\t\t<img src=\"/app/vendor/images/rating-{{vm.rating}}.png\" alt=\"\">\n\t      \t\t\t\t\t\t<p style=\"margin: 0 auto; width:80%;margin-bottom: 20px;margin-top:10px;\">{{ vm.jobbler.bio }}</p>\n\t      \t\t\t\t\t\t<div class=\"row\">\n\t      \t\t\t\t\t\t\t<a class=\"resume-button\" ng-if=\"vm.jobbler.resumeLink\" href=\"{{ vm.jobbler.resumeLink }}\" target=\"_blank\">View Resume</a>\n\t      \t\t\t\t\t\t</div>\n\t      \t\t\t\t\t</div>\n      \t\t\t\t\t</div>\n      \t\t\t\t</div>\n      \t\t\t\t<div class=\"jobbler-overlay-middle\">\n      \t\t\t\t\t<div class=\"jobbler-overlay-middle-top\" ng-if=\"vm.showIcons\">\n      \t\t\t\t\t\t<ul>\n      \t\t\t\t\t\t\t<li ng-if=\"vm.socials.facebook\"><a href=\"http://www.facebook.com/{{vm.socials.facebook}}\" target=\"_blank\"><img src=\"/app/vendor/images/facebook-profile.png\" alt=\"\"></a></li>\n      \t\t\t\t\t\t\t<li ng-if=\"vm.socials.instagram\"><a href=\"http://www.instagram.com/{{vm.socials.instagram}}\" target=\"_blank\"><img src=\"/app/vendor/images/instagram-profile.png\" alt=\"\"></a></li>\n      \t\t\t\t\t\t\t<li ng-if=\"vm.socials.twitter\"><a href=\"http://www.twitter.com/{{vm.socials.twitter}}\" target=\"_blank\"><img src=\"/app/vendor/images/twitter-profile.png\" alt=\"\"></a></li>\n      \t\t\t\t\t\t\t<li ng-if=\"vm.socials.googlePlus\"><a href=\"{{vm.socials.googlePlus}}\" target=\"_blank\"><img src=\"/app/vendor/images/google-profile64.png\" alt=\"\"></a></li>\n      \t\t\t\t\t\t\t<li ng-if=\"vm.socials.linkedIn\"><a href=\"{{vm.socials.linkedIn}}\" target=\"_blank\"><img src=\"/app/vendor/images/linked-profile2.png\" style=\"width:59px;\"alt=\"\"></a></li>\n      \t\t\t\t\t\t</ul>\n      \t\t\t\t\t</div>\n      \t\t\t\t</div>\n      \t\t\t\t<div class=\"jobbler-overlay-bottom\">\n      \t\t\t\t\t<div class=\"row\" style=\"border-bottom: 1px solid #e1e1e1;\">\n\t      \t\t\t\t\t<div class=\"jobbler-overlay-bottom-left\">\n\t      \t\t\t\t\t\t<h3>Age</h3>\n\t      \t\t\t\t\t\t<ul>\n\t      \t\t\t\t\t\t\t<li>{{ vm.jobbler.age }}</li>\n\t      \t\t\t\t\t\t</ul>\n\t      \t\t\t\t\t\t\n\t      \t\t\t\t\t</div>\n\t      \t\t\t\t\t<div class=\"jobbler-overlay-bottom-right\">\n\t      \t\t\t\t\t\t<h3>Education</h3>\n\t      \t\t\t\t\t\t<ul>\n\t      \t\t\t\t\t\t\t<li>{{ vm.jobbler.education ? vm.jobbler.education  : \"Not provided\" }}</li>      \t\t\t\t\t\t\t\n\t      \t\t\t\t\t\t</ul>\n\t      \t\t\t\t\t</div>\n\t      \t\t\t\t\t<div class=\"jobbler-overlay-bottom-right\">\n\t      \t\t\t\t\t\t<h3>Primary language</h3>\n\t      \t\t\t\t\t\t<ul>\n\t      \t\t\t\t\t\t\t<li>{{ vm.jobbler.primaryLanguage ? vm.jobbler.primaryLanguage  : \"Not provided\" }}</li>      \t\t\t\t\t\t\t\n\t      \t\t\t\t\t\t</ul>\n\t      \t\t\t\t\t</div>\n\t      \t\t\t\t\t\n\t      \t\t\t\t</div>\n      \t\t\t\t</div>\n      \t\t\t\t<div class=\"jobbler-overlay-bottom\">\n      \t\t\t\t\t<div class=\"row\" style=\"border-bottom: 1px solid #e1e1e1;\">\n\t      \t\t\t\t\t\n\t      \t\t\t\t\t<div class=\"jobbler-overlay-bottom-left\">\n\t      \t\t\t\t\t\t<h3>Driver license</h3>\n\t      \t\t\t\t\t\t<ul>\n\t      \t\t\t\t\t\t\t<li ng-if=\"vm.jobbler.hasDriverLicense\">Yes</li>\n\t      \t\t\t\t\t\t\t<li ng-if=\"!vm.jobbler.hasDriverLicense\">No</li>\n\t      \t\t\t\t\t\t</ul>\n\t      \t\t\t\t\t</div>\n\t      \t\t\t\t\t<div class=\"jobbler-overlay-bottom-middle\">\n\t      \t\t\t\t\t\t<h3>Has car</h3>\n\t      \t\t\t\t\t\t<ul>\n\t      \t\t\t\t\t\t\t<li ng-if=\"vm.jobbler.hasCar\">Yes</li>\n\t      \t\t\t\t\t\t\t<li ng-if=\"!vm.jobbler.hasCar\">No</li>\n\t      \t\t\t\t\t\t</ul>\n\t      \t\t\t\t\t</div>\n\t      \t\t\t\t\t<div class=\"jobbler-overlay-bottom-left\">\n\t      \t\t\t\t\t\t<h3>Veteran</h3>\n\t      \t\t\t\t\t\t<ul>\n\t      \t\t\t\t\t\t\t<li ng-if=\"vm.jobbler.isVeteran\">Yes</li>\n\t      \t\t\t\t\t\t\t<li ng-if=\"!vm.jobbler.isVeteran\">No</li>\n\t      \t\t\t\t\t\t</ul>\n\t      \t\t\t\t\t</div>\n\t      \t\t\t\t\t\n\t      \t\t\t\t</div>\n      \t\t\t\t</div>\n      \t\t\t\t<div class=\"row\" style=\"border-bottom: 1px solid #e1e1e1;\">\n\t      \t\t\t\t<div class=\"jobbler-overlay-bottom\">\n\t      \t\t\t\t\t\n\t      \t\t\t\t\t<div class=\"jobbler-overlay-bottom-middle\">\n\t      \t\t\t\t\t\t<h3>Other Languages</h3>\n\t      \t\t\t\t\t\t<ul>\n\t      \t\t\t\t\t\t\t<li>{{ vm.jobbler.otherLanguages ? vm.jobbler.otherLanguages  : \"Not provided\" }}</li>\n\t      \t\t\t\t\t\t</ul>\n\t      \t\t\t\t\t</div>\n\t      \t\t\t\t\t<div class=\"jobbler-overlay-bottom-middle\">\n\t      \t\t\t\t\t\t<h3>Certificates</h3>\n\t      \t\t\t\t\t\t<ul>\n\t      \t\t\t\t\t\t\t<li>{{ vm.jobbler.certifications ? vm.jobbler.certifications  : \"Not provided\" }}</li>\n\t      \t\t\t\t\t\t</ul>\n\t      \t\t\t\t\t</div>\n\t      \t\t\t\t\t<div class=\"jobbler-overlay-bottom-right\">\n\t      \t\t\t\t\t\t<h3>Shirt size</h3>\n\t      \t\t\t\t\t\t<ul>\n\t      \t\t\t\t\t\t\t<li>{{ vm.jobbler.shiftSize ? vm.jobbler.shirtSize  : \"Not provided\" }}</li>  \t\t\t\t\t\t\t\n\t      \t\t\t\t\t\t</ul>\n\t      \t\t\t\t\t</div>\n\t      \t\t\t\t</div>\n      \t\t\t\t</div>\n      \t\t\t\t<div class=\"row\">\n\t      \t\t\t\t<div class=\"jobbler-overlay-bottom\">\n\t      \t\t\t\t\t<div class=\"jobbler-overlay-bottom-left\">\n\t      \t\t\t\t\t\t<h3>Preferred Job Types</h3>\n\t      \t\t\t\t\t\t<ul>\n\t      \t\t\t\t\t\t\t<li ng-repeat=\"type in vm.jobbler.workTypes\" ng-if=\"vm.jobbler.workTypes.length > 0\">{{ type.name }}</li>\n\t      \t\t\t\t\t\t\t<li ng-if=\"vm.jobbler.workTypes.length == 0\">Not provided</li>\n\t      \t\t\t\t\t\t</ul>\n\t      \t\t\t\t\t</div>\n\t      \t\t\t\t\t\n\t      \t\t\t\t\t<div class=\"jobbler-overlay-bottom-middle\">\n\t      \t\t\t\t\t\t<h3>Honors and Awards</h3>\n\t      \t\t\t\t\t\t<ul>\n\t      \t\t\t\t\t\t\t<li>{{ vm.jobbler.honorsAndAwards ? vm.jobbler.honorsAndAwards  : \"Not provided\" }}</li>\n\t      \t\t\t\t\t\t</ul>\n\t      \t\t\t\t\t</div>\n\t      \t\t\t\t\t<div class=\"jobbler-overlay-bottom-right\">\n\t      \t\t\t\t\t\t<h3>Brands</h3>\n\t      \t\t\t\t\t\t<ul>\n\t      \t\t\t\t\t\t\t<li>{{ vm.jobbler.brands ? vm.jobbler.brands  : \"Not provided\" }}</li>      \t\t\t\t\t\t\t\n\t      \t\t\t\t\t\t</ul>\n\t      \t\t\t\t\t</div>\n\t      \t\t\t\t\t\n\t      \t\t\t\t</div>\n      \t\t\t\t</div>\n      \t\t\t\t\n      \t\t\t\t<div class=\"jobbler-overlay-reviews\">\n      \t\t\t\t\t\n      \t\t\t\t\t<div class=\"review-container\">\n      \t\t\t\t\t\t<div class=\"review\" ng-repeat=\"rating in vm.ratings\">\n      \t\t\t\t\t\t\t<div class=\"review-left\">\n      \t\t\t\t\t\t\t\t<h3>{{ rating.ratingCompanyName }}</h3>\n      \t\t\t\t\t\t\t</div>\t\n      \t\t\t\t\t\t\t<div class=\"review-right\">\n      \t\t\t\t\t\t\t\t<!--{{ rating.rate }}-->\n      \t\t\t\t\t\t\t\t{{ rating.dateCreated | date : \"MM/dd hh:mm a\" }}<br/>\n      \t\t\t\t\t\t\t\t<img src=\"/app/vendor/images/rating-{{ vm.calcRating(rating) }}.png\" alt=\"\">\n      \t\t\t\t\t\t\t</div>\n      \t\t\t\t\t\t\t<div class=\"rating-desc\">\n      \t\t\t\t\t\t\t\t<p style=\"margin-left:14px;\">{{ rating.noteRateGiver ? rating.noteRateGiver : \"No written review\" }}</p>\n      \t\t\t\t\t\t\t\t<!--<p style=\"margin-left:14px;font-size:12px;\"><i>-{{ rating.ratingUserName }}</i></p>-->\n      \t\t\t\t\t\t\t</div>\n      \t\t\t\t\t\t</div>\n      \t\t\t\t\t\t<ul ng-if=\"vm.pages.length > 1\" class=\"pagination event-pagination\">\n\t\t\t\t            \t<li class=\"arrow unavailable\" ng-disabled=\"vm.currentPageNumber == 1\" ng-click=\"vm.paginateRatings(vm.currentPageNumber - 1)\"><a href=\"\">«</a></li>\n\t\t\t\t            \t<li ng-repeat=\"page in vm.pages\" ng-click=\"vm.paginateRatings(page)\">\n\t\t\t\t              \t\t<a href=\"\">{{page}}</a>\n\t\t\t\t            \t</li>\n\t\t\t\t            \t<li class=\"arrow\" ng-disabled=\"vm.currentPageNumber == vm.pages.length\" ng-click=\"vm.paginateRatings(vm.currentPageNumber + 1)\"><a href=\"\">»</a></li>\n\t\t\t\t            </ul>\n      \t\t\t\t\t</div>\n      \t\t\t\t\t\n      \t\t\t\t</div>\n      \t\t\t\t\n      \t\t\t</div>\n      \t\t</div>\n      \t\t\n      \t\t\n      \t\t<!--\n      \t\t<table class=\"connections-table\">\n      \t\t\t<thead>\n      \t\t\t\t<tr>\n\t      \t\t\t\t<th></th>\n\t      \t\t\t\t<th>First name</th>\n\t      \t\t\t\t<th>Last Name</th>\n\t      \t\t\t\t<th>Email</th>\n\t      \t\t\t\t<th>Number</th>\n\t      \t\t\t\t<th>Rating</th>\n      \t\t\t\t</tr>\n      \t\t\t</thead>\n      \t\t\t<tbody>\n      \t\t\t\t<tr ng-repeat=\"jobbler in vm.jobblers\" ng-click=\"vm.goToProfile(jobbler)\">\n\t      \t\t\t\t<td><img src=\"{{ vm.displayPicture(jobbler.picture1s) }}\" /></td>\n\t      \t\t\t\t<td>{{ jobbler.firstName }}</td>\n\t      \t\t\t\t<td>{{ jobbler.lastName }}</td>\n\t      \t\t\t\t<td>{{ jobbler.email }}</td>\n\t      \t\t\t\t<td>{{ vm.formatPhoneNumber(jobbler.homeContactInfo.phoneMobile) }}</td>\n\t      \t\t\t\t<td>{{ jobbler.averageRatingReceived | number : 1 }}/5</td>\n      \t\t\t\t</tr>\n      \t\t\t</tbody>\n      \t\t</table>\n        \t-->\n      </div>\n    </div>\n  </section>\n\n</div>\n\n<globalalert></globalalert>\n<messaginggallery ng-if=\"vm.showGallery\"></messaginggallery>\n<jobblefooter></jobblefooter>\n\n<jobblerprofile></jobblerprofile>\n<loader ng-if=\"vm.remain_loading_count != 0\"></loader>\n\n"

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProfilesController = function () {
	  function ProfilesController($http, $localStorage, $timeout, $rootScope, $location, $state, AuthService, SecurityService, $stateParams) {
	    _classCallCheck(this, ProfilesController);
	
	    this.name = "profiles";
	
	    $localStorage.activeStateName = "profiles";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$location = $location;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$stateParams = $stateParams;
	    this.$rootScope = $rootScope;
	    this.arrayForGallery = [];
	    this.$auth = AuthService;
	    this.remain_loading_count = 0;
	    this.$security = SecurityService;
	    this.currentUser = this.$auth.getUserData();
	    this.showGallery = false;
	    this.rand = Math.floor(Math.random() * (2 - 0 + 1)) + 0;
	    this.pages = [];
	    var _this = this;
	    this.currentPageNumber = 1;
	
	    console.log("state paraams?");
	    console.dir(_this.$state);
	    console.dir(_this.$stateParams);
	
	    _this.$security.getJobbler(_this.$stateParams.profileId).then(function (response) {
	      console.log("response");
	      console.dir(response);
	      _this.jobbler = response.data;
	      _this.calculatePagination();
	      _this.getSocialLinks();
	      _this.rating = _this.$security.getJobblerStars(_this.jobbler);
	      _this.collectPhotosForGallery();
	      _this.getAge();
	      _this.$security.getRatings(_this.jobbler.id, 0).then(function (response) {
	        console.log("get ratings response");
	        console.dir(response);
	
	        _this.ratings = response.data.ratings;
	      });
	    });
	
	    this.$rootScope.$on("CloseGallery", function ($event, params) {
	      _this.gallery();
	    });
	  }
	
	  _createClass(ProfilesController, [{
	    key: "randomPicture",
	    value: function randomPicture() {
	      var arrayOfPix = ["/app/vendor/images/background-prof-pic.jpg", "/app/vendor/images/background-prof-pic2.png", "/app/vendor/images/background-prof-pic3.png"];
	
	      console.log("whta is the random number...");
	      console.dir(this.rand);
	
	      return arrayOfPix[this.rand];
	
	      //return "/app/vendor/images/background-prof-pic3.png";
	    }
	  }, {
	    key: "handleJobblerProfile",
	    value: function handleJobblerProfile(params) {
	      var _this = this;
	
	      _this.jobbler = params.jobbler;
	    }
	  }, {
	    key: "displayPicture",
	    value: function displayPicture(jobbler) {
	      var _this = this;
	
	      if (jobbler) {
	        for (var i = 0; i < jobbler.picture1s.length; i++) {
	          if (jobbler.picture1s[i].indexOf("160x160") > -1) {
	            return jobbler.picture1s[i];
	            break;
	          }
	        }
	      }
	    }
	  }, {
	    key: "getSocialLinks",
	    value: function getSocialLinks() {
	      var _this = this;
	
	      var socials = {};
	      var notNullVals = 0;
	      var nullVals = 0;
	      socials.instagram = _this.jobbler.instagram;
	      socials.googlePlus = _this.jobbler.googlePlus;
	      socials.twitter = _this.jobbler.twitter;
	      socials.facebook = _this.jobbler.facebook;
	      socials.linkdedIn = _this.jobbler.linkdedIn;
	
	      var keys = Object.keys(socials);
	      var values = keys.map(function (v) {
	        return socials[v];
	      });
	      try {
	        for (var x = 0; x < keys.length; x++) {
	          if (socials[keys[x]] === null) {
	            nullVals = nullVals + 1;
	          } else {
	            notNullVals = notNullVals + 1;
	          }
	        }
	      } finally {
	        if (notNullVals === 0) {
	          _this.showIcons = false;
	        } else {
	          _this.showIcons = true;
	          _this.socials = socials;
	        }
	      }
	    }
	  }, {
	    key: "calcRating",
	    value: function calcRating(r) {
	      var _this = this;
	
	      var rating = "";
	
	      if (r.rate === 0) {
	        rating = "one";
	      }
	      if (r.rate === 1) {
	        rating = "one";
	      }
	      if (r.rate === 2) {
	        rating = "two";
	      }
	      if (r.rate === 3) {
	        rating = "three";
	      }
	      if (r.rate === 4) {
	        rating = "four";
	      }
	      if (r.rate === 5) {
	        rating = "five";
	      }
	
	      return rating;
	    }
	  }, {
	    key: "paginateRatings",
	    value: function paginateRatings(page) {
	      var _this = this;
	
	      var offset = page * 5 - 5;
	
	      _this.$security.getRatings(_this.jobbler.id, offset).then(function (response) {
	        _this.ratings = response.data.ratings;
	      });
	    }
	  }, {
	    key: "calculatePagination",
	    value: function calculatePagination() {
	      var _this = this;
	
	      var numberOfReviews = Math.ceil(_this.jobbler.numberOfCompletedJobbles / 5);
	
	      for (var i = 0; i < numberOfReviews; i++) {
	        _this.pages.push(i + 1);
	      }
	    }
	  }, {
	    key: "gallery",
	    value: function gallery() {
	      var _this = this;
	
	      if (_this.showGallery) {
	        _this.showGallery = false;
	      } else {
	        _this.showGallery = true;
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("CollectPhotos", {
	            dataprof: _this.arrayForGallery
	          });
	        });
	      }
	    }
	  }, {
	    key: "collectPhotosForGallery",
	    value: function collectPhotosForGallery() {
	      var _this = this;
	
	      console.log("collectPhotosForGallery");
	      console.dir(_this.jobbler);
	
	      var arrayOfPhotos = [];
	
	      if (_this.jobbler.picture1s) {
	        arrayOfPhotos.push(_this.jobbler.picture1s);
	      }
	      if (_this.jobbler.picture2s) {
	        arrayOfPhotos.push(_this.jobbler.picture2s);
	      }
	      if (_this.jobbler.picture3s) {
	        arrayOfPhotos.push(_this.jobbler.picture3s);
	      }
	      if (_this.jobbler.picture4s) {
	        arrayOfPhotos.push(_this.jobbler.picture4s);
	      }
	      if (_this.jobbler.picture5s) {
	        arrayOfPhotos.push(_this.jobbler.picture5s);
	      }
	      if (_this.jobbler.picture6s) {
	        arrayOfPhotos.push(_this.jobbler.picture6s);
	      }
	
	      var count = arrayOfPhotos.length;
	
	      try {
	        for (var i = 0; i < count; i++) {
	          for (var x = 0; x < arrayOfPhotos[i].length; x++) {
	            if (arrayOfPhotos[i][x].indexOf("800x800") > -1) {
	              _this.arrayForGallery.push(arrayOfPhotos[i][x]);
	            }
	          }
	        }
	      } finally {}
	    }
	  }, {
	    key: "getAge",
	    value: function getAge() {
	      var _this = this;
	      _this.jobbler.age = moment().diff(moment(_this.jobbler.dateBirth), "years");
	    }
	  }]);
	
	  return ProfilesController;
	}();
	
	ProfilesController.$inject = ["$http", "$localStorage", "$timeout", "$rootScope", "$location", "$state", "auth", "security", "$stateParams"];
	
	exports.default = ProfilesController;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(589);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./profiles.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./profiles.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _jobs = __webpack_require__(591);
	
	var _jobs2 = _interopRequireDefault(_jobs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobsModule = _angular2.default.module("jobs", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("jobs", {
	    url: "/jobs",
	    template: "<jobs></jobs>",
	    title: "Jobs",
	    params: {
	      jobble_types: null,
	      zipcode: null,
	      query: null,
	      query_zip: null
	    }
	  });
	}).component("jobs", _jobs2.default);
	
	exports.default = jobsModule;
	/*?lat&lng&zipcode&ref&jts*/

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobs = __webpack_require__(592);
	
	var _jobs2 = _interopRequireDefault(_jobs);
	
	var _jobs3 = __webpack_require__(593);
	
	var _jobs4 = _interopRequireDefault(_jobs3);
	
	__webpack_require__(595);
	
	__webpack_require__(597);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobsComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _jobs2.default,
	  controller: _jobs4.default,
	  controllerAs: "vm"
	};
	
	exports.default = jobsComponent;

/***/ }),
/* 592 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"jobs-container\">\n  <div class=\"jobs-container-nav\">\n    <jobbleheader></jobbleheader>\n  </div>\n  <div class=\"job-mobile\">\n    <div class=\"jobble-tip-super-container\">\n      <a\n        href=\"https://info.jobble.com/workplace-safety-guidelines-infographic\"\n        target=\"_blank\"\n        ng-click=\"vm.$tracking.reportClickCovidBanner('job board')\"\n      >\n        <div class=\"jobble-tip-container\"><i class=\"fas fa-exclamation-triangle\"></i> COVID-19 Workplace Health & Safety Guidelines</div>\n      </a>\n    </div>\n  </div>\n\n  <!--\n\t<div class=\"indi-jobble-holder\">\n\t\t<div class=\"indi-jobble-inside-holder\">\n\t\t\t<img src=\"app/vendor/images/jobble-mobile-logo.png\" class=\"mobile-indi\" />\n\t\t\t<div style=\"position:relative;\">\n\t\t\t\t<h4 class=\"mobile-indi-header\">Banking that puts you first: <br/>Meet indi for Jobblers.\n\t\t\t\t\t<br/>\n\t\t\t\t\t<span>LEARN MORE <i class=\"fas fa-angle-double-right\"></i></span>\n\t\t\t\t</h4>\n\t\t\t</div>\n\n\t\t\t<img src=\"app/vendor/images/indi_jobble.png\" class=\"full\" />\n\t\t\t<h4 class=\"full-screen\">Banking that puts you first: Meet indi for Jobblers.</h4>\n\t\t\t<a class=\"learn-more-indi\">Learn More <i class=\"fas fa-chevron-right\"></i></a>\n\t\t\t<i class=\"fas fa-times-circle close-indi\" ng-click=\"vm.closeIndiBanner()\"></i>\n\t\t</div>\n\t</div>\n\t-->\n\n  <div class=\"jobs-container-filters\">\n    <jobsearch set-jobble-types=\"vm.setJobbleTypes\"></jobsearch>\n  </div>\n  <div class=\"jobs-container-content\">\n    <div ng-if=\"!vm.system_error\" class=\"job-panel-container\">\n      <div class=\"job-panel-menu\" ng-if=\"vm.no_zip_code && !vm.hasInitialSelectedJob\" style=\"flex: 1\">\n        <div class=\"no-zip-container\">\n          <h1>We’ll need to access your location in order to show you which jobs are available in your area</h1>\n          <div>\n            <img src=\"app/vendor/images/zip-compass.png\" />\n          </div>\n          <h2>Please enter your location in the search bar above</h2>\n        </div>\n      </div>\n\n      <div class=\"job-panel-menu\" ng-if=\"!(vm.no_zip_code && !vm.hasInitialSelectedJob) && (!vm.jobs || vm.jobs.length === 0)\">\n        <div class=\"sort-container\">\n          <div class=\"result-count\" style=\"margin-top: 6px\">Loading Results...</div>\n          <div class=\"sort-selector-container\">\n            <div class=\"sort-label\">Sort by:</div>\n            <div class=\"sort-select-container\">\n              <select ng-model=\"vm.sort\" ng-change=\"vm.setSort()\">\n                <option value=\"payPerHour\">Pay (high to low)</option>\n                <option value=\"startTime\">Job date</option>\n                <option value=\"dateCreated\">Date posted</option>\n              </select>\n              <i class=\"fas fa-chevron-down\"></i>\n            </div>\n          </div>\n        </div>\n        <div\n          class=\"search-cards-seperator loading-seperator\"\n          style=\"text-align: center; padding: 0\"\n          ng-if=\"(!vm.filteredRelevantJobs || !vm.filteredRelevantJobs.length) && vm.jobs_loading\"\n        >\n          <div ng-repeat=\"dummy in [1,2,3,4,5,6,7,8,9,10]\" class=\"loading-card\">\n            <div style=\"display: flex\">\n              <div class=\"animated-loading-background\" style=\"flex: 0 0 40px; margin-right: 12px; height: 40px\"></div>\n              <div class=\"animated-loading-background\" style=\"flex: 1; height: 20px\"></div>\n            </div>\n            <div class=\"animated-loading-background\" style=\"flex: 1; height: 12px; width: 100%; margin-top: 12px\"></div>\n            <div class=\"animated-loading-background\" style=\"flex: 1; height: 12px; width: 100%; margin-top: 8px\"></div>\n          </div>\n        </div>\n        <div class=\"search-cards-seperator\" ng-if=\"(!vm.filteredRelevantJobs || !vm.filteredRelevantJobs.length) && !vm.jobs_loading\">\n          <div ng-if=\"!vm.filteredRelevantJobs || !vm.filteredRelevantJobs.length\">\n            We couldn’t find any jobs that matched your search criteria. Please try expanding your filters or using a different keyword.\n          </div>\n        </div>\n      </div>\n\n      <div class=\"job-panel-menu\" ng-if=\"(vm.filteredJobs.length === 0 && vm.jobs.length !== 0)\">\n        <div class=\"sort-container\">\n          <div class=\"result-count\" ng-if=\"!vm.jobs_loading\">\n            {{vm.filteredRelevantJobs.length}} result{{vm.filteredRelevantJobs.length === 1 ? \"\" : \"s\"}}\n            <span ng-if=\"vm.boardParams.search\">for {{vm.boardParams.search}}</span><span ng-if=\"!vm.boardParams.search\">found</span\n            ><span ng-if=\"vm.searchLocation\"> near {{vm.searchLocation}}</span>\n          </div>\n          <div class=\"result-count\" ng-if=\"vm.jobs_loading\">Loading Results</div>\n          <div class=\"sort-selector-container\">\n            <div class=\"sort-label\">Sort by:</div>\n            <div class=\"sort-select-container\">\n              <select ng-model=\"vm.sort\" ng-change=\"vm.setSort()\">\n                <option value=\"payPerHour\">Pay (high to low)</option>\n                <option value=\"startTime\">Job date</option>\n                <option value=\"dateCreated\">Date posted</option>\n              </select>\n              <i class=\"fas fa-chevron-down\"></i>\n            </div>\n          </div>\n        </div>\n        <div class=\"search-cards-seperator\">\n          <div ng-if=\"!vm.filteredRelevantJobs || !vm.filteredRelevantJobs.length\">\n            We couldn’t find any jobs that matched your search criteria. Please try expanding your filters or using a different keyword.\n          </div>\n        </div>\n      </div>\n\n      <div id=\"job-scroll\" class=\"job-panel-menu\" ng-if=\"vm.filteredJobs.length > 0\">\n        <div id=\"job-inner-scroll\">\n          <div class=\"sort-container\">\n            <div class=\"result-count\" ng-if=\"!vm.jobs_loading\">\n              {{vm.filteredRelevantJobs.length}} result{{vm.filteredRelevantJobs.length === 1 ? \"\" : \"s\"}}\n              <span ng-if=\"vm.boardParams.search\">for {{vm.boardParams.search}}</span><span ng-if=\"!vm.boardParams.search\">found</span\n              ><span ng-if=\"vm.searchLocation\"> near {{vm.searchLocation}}</span>\n            </div>\n            <div class=\"result-count\" ng-if=\"vm.jobs_loading\">Loading Results</div>\n\n            <div class=\"sort-selector-container\">\n              <div class=\"sort-label\">Sort by:</div>\n              <div class=\"sort-select-container\">\n                <select ng-model=\"vm.sort\" ng-change=\"vm.setSort()\">\n                  <option value=\"payPerHour\">Pay (high to low)</option>\n                  <option value=\"startTime\">Job date</option>\n                  <option value=\"dateCreated\">Date posted</option>\n                </select>\n                <i class=\"fas fa-chevron-down\"></i>\n              </div>\n            </div>\n          </div>\n          <div class=\"job-search-cards\">\n            <div class=\"search-cards-seperator\" style=\"text-align: center\" ng-if=\"vm.jobs_loading\">\n              <i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i>\n            </div>\n          </div>\n          <div class=\"job-search-cards\">\n            <div\n              class=\"mobile-cards\"\n              ng-repeat=\"job in vm.filteredRelevantJobs track by $index\"\n              ng-class=\"{'first-card': $index === 0, 'last-card': $index === (vm.filteredRelevantJobs.length - 1) }\"\n              ng-if=\"vm.filteredRelevantJobs.length > 0\"\n            >\n              <jobsearchcard ng-click=\"vm.setSelectedMobileJob(job)\" jobble=\"job\" selected-jobble=\"vm.selectedJobMobile\" />\n            </div>\n            <div\n              class=\"desktop-cards\"\n              ng-repeat=\"job in vm.filteredRelevantJobs track by $index\"\n              ng-class=\"{'first-card': $index === 0, 'last-card': $index === (vm.filteredRelevantJobs.length - 1) }\"\n              ng-if=\"vm.filteredRelevantJobs.length > 0\"\n            >\n              <jobsearchcard ng-click=\"vm.setSelectedJob(job)\" jobble=\"job\" selected-jobble=\"vm.selectedJob\" />\n            </div>\n          </div>\n          <div class=\"search-cards-seperator\" ng-if=\"vm.filteredFillInJobs && vm.filteredFillInJobs.length\">\n            <div ng-if=\"vm.filteredRelevantJobs && vm.filteredRelevantJobs.length\">\n              We’re busy adding more jobs in your area. In the meantime, we think you might like these options:\n            </div>\n            <div ng-if=\"!vm.filteredRelevantJobs || !vm.filteredRelevantJobs.length\">\n              We couldn’t find any jobs that matched your search criteria. Please try expanding your filters or using a different keyword.\n            </div>\n          </div>\n          <div\n            class=\"search-cards-seperator\"\n            ng-if=\"vm.filteredFillInJobs && vm.filteredFillInJobs.length && (!vm.filteredRelevantJobs || !vm.filteredRelevantJobs.length)\"\n          >\n            <div>In the meantime, we think you might like these options:</div>\n          </div>\n          <div class=\"job-search-cards\">\n            <div\n              class=\"mobile-cards\"\n              ng-repeat=\"job in vm.filteredFillInJobs track by $index\"\n              ng-class=\"{'first-card': $index === 0, 'last-card': $index === (vm.filteredFillInJobs.length - 1) }\"\n              ng-if=\"vm.filteredFillInJobs.length > 0\"\n            >\n              <jobsearchcard ng-click=\"vm.setSelectedMobileJob(job)\" jobble=\"job\" selected-jobble=\"vm.selectedJobMobile\" />\n            </div>\n            <div\n              class=\"desktop-cards\"\n              ng-repeat=\"job in vm.filteredFillInJobs track by $index\"\n              ng-class=\"{'first-card': $index === 0, 'last-card': $index === (vm.filteredFillInJobs.length - 1) }\"\n              ng-if=\"vm.filteredFillInJobs.length > 0\"\n            >\n              <jobsearchcard ng-click=\"vm.setSelectedJob(job)\" jobble=\"job\" selected-jobble=\"vm.selectedJob\" />\n            </div>\n          </div>\n          <div class=\"job-search-cards\">\n            <div class=\"search-cards-seperator\" style=\"text-align: center\" ng-if=\"vm.jobs_loading && vm.bottom_loading\">\n              <i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i>\n            </div>\n          </div>\n          <div class=\"job-search-cards\">\n            <div class=\"search-cards-seperator\" ng-if=\"vm.no_more_jobs_with_this_search\">\n              <div>\n                We couldn’t find any more jobs that matched your search criteria. Please try expanding your filters or using a different keyword.\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"job-panel-selected\" ng-if=\"!(vm.no_zip_code && !vm.hasInitialSelectedJob)\">\n        <a href=\"/jobbler/{{vm.currentUser.id}}\" ng-if=\"vm.currentUser && vm.profileStatus <= 5\">\n          <div class=\"job-panel-banner\">\n            <div>\n              Complete a one-time profile set-up to quickly apply to any job on our platform\n              <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n        </a>\n        <div\n          class=\"search-cards-seperator\"\n          style=\"text-align: center; padding: 0; max-width: 100%\"\n          ng-if=\"(!vm.jobs || !vm.jobs.length) && vm.jobs_loading && !vm.selectedJob && (vm.currentUser && vm.profileStatus <= 5)\"\n        >\n          <div class=\"animated-loading-background\" style=\"height: 189px\"></div>\n          <div style=\"height: 117px; color: white; border-bottom: 1px solid #adbcc2; border-top: 1px solid #adbcc2\"></div>\n          <div class=\"animated-loading-background\" style=\"height: 200px\"></div>\n          <div style=\"height: 212px; color: white; border-bottom: 1px solid #adbcc2; border-top: 1px solid #adbcc2\"></div>\n          <div class=\"animated-loading-background\" style=\"height: 333px\"></div>\n        </div>\n        <div\n          class=\"search-cards-seperator\"\n          style=\"text-align: center; padding: 0; max-width: 100%; margin-top: 0\"\n          ng-if=\"(!vm.jobs || !vm.jobs.length) && vm.jobs_loading && !vm.selectedJob && (!vm.currentUser || vm.profileStatus > 5)\"\n        >\n          <div class=\"animated-loading-background\" style=\"height: 189px\"></div>\n          <div style=\"height: 117px; color: white; border-bottom: 1px solid #adbcc2; border-top: 1px solid #adbcc2\"></div>\n          <div class=\"animated-loading-background\" style=\"height: 200px\"></div>\n          <div style=\"height: 212px; color: white; border-bottom: 1px solid #adbcc2; border-top: 1px solid #adbcc2\"></div>\n          <div class=\"animated-loading-background\" style=\"height: 333px\"></div>\n        </div>\n        <jobdescription\n          jobble=\"vm.selectedJob\"\n          set-job-for-back-button=\"vm.setJobForBackButton\"\n          track-apply-to-job-from-board=\"vm.trackApplyToJobFromBoard\"\n          apply-to-jobble=\"vm.applyToJobble\"\n        />\n      </div>\n\n      <div class=\"job-panel-selected-mobile\" ng-if=\"!(vm.no_zip_code && !vm.hasInitialSelectedJob) && vm.selectedJobMobile\">\n        <div class=\"mobile-panel-container\">\n          <div class=\"mobile-description-holder\">\n            <jobdescription\n              jobble=\"vm.selectedJobMobile\"\n              set-job-for-back-button=\"vm.setJobForBackButton\"\n              track-apply-to-job-from-board=\"vm.trackApplyToJobFromBoard\"\n              apply-to-jobble=\"vm.applyToJobble\"\n            />\n          </div>\n          <div class=\"mobile-close\" ng-click=\"vm.setSelectedMobileJob(null)\">\n            <i class=\"fas fa-times\"></i>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"jobs-complete-container public-listing\" ng-if=\"!vm.system_error\">\n      <div class=\"container\" style=\"padding-top: 20px\">\n        <div class=\"panel overview-review-bottom-box\" ng-if=\"vm.userDeniedLocationAccess\" ng-class=\"{ 'is-loading' : vm.jobs_loading }\">\n          <div class=\"panel-heading overview-review-heading white-bg\">Enter Zip Code</div>\n          <div class=\"panel-body overview-review-body text-center white-bg\">\n            <p>Please enter your zip code to search for jobs.</p>\n          </div>\n        </div>\n\n        <div\n          class=\"panel overview-review-bottom-box\"\n          ng-if=\"vm.filteredJobs.length == 0 && !vm.jobs_loading\"\n          ng-class=\"{ 'is-loading' : vm.jobs_loading }\"\n        >\n          <div class=\"panel-heading overview-review-heading white-bg\">Whoops!</div>\n          <div class=\"panel-body overview-review-body text-center white-bg\">\n            <p>No jobs available with those parameters.</p>\n          </div>\n        </div>\n\n        <div\n          class=\"panel overview-review-bottom-box\"\n          ng-if=\"((vm.filteredJobs.length == 0 || !vm.filteredJobs) && (vm.jobs_loading))\"\n          ng-class=\"{ 'is-loading' : vm.jobs_loading }\"\n        >\n          <div class=\"panel-body overview-review-body text-center white-bg\" style=\"text-align: center\">\n            <i class=\"fa fa-cog fa-spin fa-1x fa-fw\" style=\"font-size: 20px\"> </i>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"col-lg-12 col-md-12 col-sm-12\">\n            <div class=\"load-more-loader-jobs-scroll\">\n              Loading more jobs..\n              <i class=\"fa fa-cog fa-spin fa-1x fa-fw\" style=\"font-size: 20px\"></i>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"jobs-complete-container public-listing\" ng-if=\"vm.system_error\">\n      <div class=\"container\" style=\"padding-top: 20px\">\n        <div class=\"row\" style=\"margin-bottom: 50px\">\n          <div class=\"alert-box alert\" style=\"text-align: center; padding-bottom: 23px; font-size: 20px\">\n            The system is currently down, please come back later.\n            <i style=\"margin-left: 20px; font-size: 36px\" class=\"fa fa-user-md\"></i>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<apply-profile-modal></apply-profile-modal>\n\n<eventdialog></eventdialog>\n<globalalert></globalalert>\n\n<a href=\"#\" data-toggle=\"modal\" data-target=\"#funnel-user-to-zipcode\" id=\"funnel-user-to-zipcode-click2\"></a>\n<div class=\"modal fade\" id=\"funnel-user-to-zipcode\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header popup-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\"></i>\n            </button>\n\n            <h3 class=\"modal-title\">Please download our app</h3>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                <p>In order to apply to a shift based job you will need to download our phone app and fill out your Basic Profile.</p>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12\">\n                <div class=\"col-lg-6 col-md-6 col-sm-6\">\n                  <h4>App Store</h4>\n                  <a href=\"https://itunes.apple.com/us/app/jobble/id961838757?mt=8\" target=\"_blank\" rel=\"noopener\">\n                    <img src=\"/app/vendor/images/itunes-store.png\" />\n                  </a>\n                </div>\n                <div class=\"col-lg-6 col-md-6 col-sm-6\">\n                  <h4>Google Play</h4>\n                  <a href=\"https://play.google.com/store/apps/details?id=com.jobble.jobble&hl=en\" target=\"_blank\" rel=\"noopener\">\n                    <img src=\"/app/vendor/images/google-play-store.png\" />\n                  </a>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer\" style=\"text-align: center\">\n            <a class=\"btn button btn-success\" data-dismiss=\"modal\">Continue</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<verification></verification>\n"

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(25);
	
	__webpack_require__(496);
	
	var _iterable = __webpack_require__(159);
	
	var _iterable2 = _interopRequireDefault(_iterable);
	
	var _zip = __webpack_require__(594);
	
	var _zip2 = _interopRequireDefault(_zip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobsController = function () {
	  function JobsController($window, $location, $http, $localStorage, $state, AuthService, EventsService, SecurityService, $stateParams, $timeout, $interval, $rootScope, $scope, JobService, $anchorScroll, TrackingService, ProfileService, IterableService, analytics) {
	    var _this2 = this;
	
	    _classCallCheck(this, JobsController);
	
	    this.name = "jobs";
	    $localStorage.activeStateName = "jobs";
	
	    this.$window = $window;
	    this.$location = $location;
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$events = EventsService;
	    this.$jobs = JobService;
	    this.$security = SecurityService;
	    this.$stateParams = $stateParams;
	    this.$tracking = TrackingService;
	    this.$iterable = IterableService;
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.$profile = ProfileService;
	    this.$analytics = analytics;
	    this.$interval = $interval;
	    this.$scope = $scope;
	
	    this.currentUser = this.$auth.getUserData();
	    this.bottom_loading = false;
	    this.jobs_loading = true;
	    this.userReady = false;
	    this.boardParams = {
	      sort: {
	        name: "startTime",
	        value: "asc"
	      },
	      max: 10
	    };
	
	    this.filter = {
	      zip_change: false,
	      radius_change: false,
	      sort_change: false
	    };
	
	    this.filters = {
	      companies: []
	    };
	
	    this.sort = "startTime";
	
	    this.no_more_jobs_with_this_search = false;
	    this.no_zip_code = false;
	
	    if (!this.$rootScope.jobsSeenOnce) {
	      this.$timeout(function () {
	        _this2.$rootScope.$emit("SetLoaderDialog", {
	          type: 15,
	          total: 1
	        });
	      });
	    }
	
	    // Checks if the user is able to apply to jobs
	    if (this.currentUser) {
	      if (this.currentUser.company && this.currentUser.company.id) {
	        this.$state.go("jobsdashboard");
	      }
	      this.canUserApplyToShiftBasedJobs();
	    }
	
	    this.SetSearchRadiusListener = this.$rootScope.$on("SetSearchRadius", function ($event, params) {
	      _this2.$timeout(function () {
	        var queryParams = _this2.boardParams;
	
	        queryParams.offset = 0;
	        queryParams.geoFenceRadius = _this2.$jobs.milesToKilometers(parseFloat(params));
	
	        _this2.formatAndSyncQueryParams(queryParams);
	
	        if (queryParams.zipcode) _this2.loadJobsPOST(queryParams);
	      });
	    });
	
	    this.SetCompanyFiltersListener = this.$rootScope.$on("SetCompanyFilters", function ($event, params) {
	      _this2.$timeout(function () {
	        _this2.filters.companies = params;
	        _this2.applyFilters(_this2.jobs);
	
	        if (_this2.selectedJob && _this2.filteredJobs) {
	          var found = false;
	          _this2.filteredJobs.forEach(function (job) {
	            if (job.id === _this2.selectedJob.id) found = true;
	          });
	
	          if (!found) _this2.setSelectedJob(_this2.filteredJobs[0]);
	        }
	      });
	    });
	
	    this.SetLocationFiltersListener = this.$rootScope.$on("SetLocationFilters", function ($event, params) {
	      _this2.$timeout(function () {
	        _this2.filters.locations = params;
	        _this2.applyFilters(_this2.jobs);
	
	        if (_this2.selectedJob && _this2.filteredJobs) {
	          var found = false;
	          _this2.filteredJobs.forEach(function (job) {
	            if (job.id === _this2.selectedJob.id) found = true;
	          });
	
	          if (!found) _this2.setSelectedJob(_this2.filteredJobs[0]);
	        }
	      });
	    });
	
	    this.CityStateSearchListener = this.$rootScope.$on("CityStateSearch", function ($event, params) {
	      _this2.$timeout(function () {
	        _this2.searchLocation = params.city + ", " + params.state;
	      });
	    });
	
	    this.UserHasConfirmedTheirEmailListener = this.$rootScope.$on("UserHasConfirmedTheirEmail", function ($event, params) {
	      _this2.closeVerificationModal();
	    });
	
	    this.SetNewUserForJobBoardListener = this.$rootScope.$on("SetNewUserForJobBoard", function ($event, params) {
	      _this2.currentUser = params.user;
	      _this2.$timeout(function () {
	        _this2.canUserApplyToShiftBasedJobs();
	      }, 100);
	    });
	
	    this.SendSearchParcelListener = this.$rootScope.$on("SendSearchParcel", function ($event, params) {
	      if (params) {
	        var queryParams = _this2.boardParams;
	
	        queryParams.offset = 0;
	
	        if (params.zipcode) {
	          queryParams.zipcode = params.zipcode;
	        }
	
	        queryParams.search = params.query;
	
	        if (params.type) {
	          queryParams.type = params.type;
	        }
	
	        console.log("from new parcel", queryParams);
	
	        _this2.$timeout(function () {
	          _this2.loadJobs(queryParams).then(function (queryParams) {
	            _this2.loadJobsPOST(queryParams);
	          });
	        });
	      }
	    });
	
	    this.$scope.$on("$destroy", this.UserHasConfirmedTheirEmailListener);
	    this.$scope.$on("$destroy", this.SetNewUserForJobBoardListener);
	    this.$scope.$on("$destroy", this.SendSearchParcelListener);
	    this.$scope.$on("$destroy", this.SetSearchRadiusListener);
	    this.$scope.$on("$destroy", this.SetCompanyFiltersListener);
	    this.$scope.$on("$destroy", this.SetLocationFiltersListener);
	    this.$scope.$on("$destroy", this.CityStateSearchListener);
	
	    this.setJobbleTypes = this.setJobbleTypes.bind(this);
	    this.setJobForBackButton = this.setJobForBackButton.bind(this);
	    this.applyToJobble = this.applyToJobble.bind(this);
	    this.trackApplyToJobFromBoard = this.trackApplyToJobFromBoard.bind(this);
	  }
	
	  _createClass(JobsController, [{
	    key: "handleNoJobble",
	    value: function handleNoJobble(error) {
	      if (error.data.codeDescription === "openingDeletedButJobStillOpen") {
	        this.$location.search("rjid", error.data.details[0].availableJob);
	        this.$onInit();
	      }
	    }
	  }, {
	    key: "getCurrentUserData",
	    value: function getCurrentUserData() {
	      var _this3 = this;
	
	      if (this.currentUser) {
	        this.$auth.refreshCurrentUser().then(function () {
	          _this3.getMostRecentUser(function (user) {
	            _this3.$timeout(function () {
	              _this3.currentUser = user || _this3.currentUser;
	            });
	          });
	        });
	      }
	    }
	  }, {
	    key: "getMostRecentUser",
	    value: function getMostRecentUser() {
	      var _this4 = this;
	
	      return new Promise(function (resolve, reject) {
	        resolve(_this4.$auth.getUserData());
	      });
	    }
	  }, {
	    key: "$onInit",
	    value: function $onInit() {
	      var _this5 = this;
	
	      console.log("$onInit");
	      console.dir(this.$location);
	      console.dir(this.currentUser);
	      this.getCurrentUserData();
	
	      if (this.$location.$$search.rjid) {
	        this.$timeout(function () {
	          _this5.hasInitialSelectedJob = true;
	        });
	
	        console.time("Loading single job");
	        var jobble_id = this.$location.$$search.rjid;
	        this.$location.search("rjid", undefined);
	
	        console.log("Loading jobble id:", jobble_id);
	
	        this.$jobs.getJob(jobble_id).then(function (response) {
	          console.timeEnd("Loading single job");
	          console.dir(response.data);
	
	          var temp = response.data;
	
	          if (_.isEmpty(response.data) || response.data.status === "error") {
	            _this5.hasInitialSelectedJob = false;
	            _this5.setInitialParams().then(function (params) {
	              if (params && params.zipcode) {
	                _this5.loadJobs(params).then(function (queryParams) {
	                  _this5.loadJobsPOST(queryParams);
	                });
	              }
	            });
	            return console.error("EMPTY JOB");
	          }
	
	          _this5.$timeout(function () {
	            _this5.setSelectedJob(_this5.$jobs.processJob(response.data).job);
	            _this5.setSelectedMobileJob(_this5.$jobs.processJob(response.data).job);
	
	            if (_this5.$location.$$search.o && parseFloat(_this5.$location.$$search.o) === 1 && _this5.currentUser && !_this5.selectedJob.is_partner_post) {
	              _this5.$location.search("o", undefined);
	              _this5.applyToJobble(_this5.selectedJob);
	            }
	
	            var params = {
	              zipcode: _this5.selectedJob.subEvent.contactInfo.zipCode
	            };
	
	            _this5.loadJobs(params).then(function (queryParams) {
	              _this5.loadJobsPOST(queryParams);
	            });
	          });
	        }, function (error) {
	          _this5.handleNoJobble(error);
	        });
	      } else {
	        if (this.$location.$$search.jid) {
	          this.hasInitialSelectedJob = true;
	
	          console.time("Loading single job");
	          var _jobble_id = this.$location.$$search.jid;
	
	          console.log("Loading jobble id:", _jobble_id);
	
	          this.$jobs.getJob(_jobble_id).then(function (response) {
	            console.timeEnd("Loading single job");
	
	            if (_.isEmpty(response.data) || response.data.status === "error") {
	              _this5.hasInitialSelectedJob = false;
	              return;
	            }
	
	            console.log(response.data);
	
	            _this5.setSelectedJob(_this5.$jobs.processJob(response.data).job);
	
	            if (!_this5.boardParams.zipcode && !_this5.$location.$$search.z) {
	              var params = {
	                zipcode: _this5.selectedJob.subEvent.contactInfo.zipCode
	              };
	
	              _this5.loadJobs(params).then(function (queryParams) {
	                _this5.loadJobsPOST(queryParams);
	              });
	            } else {
	              var _params = {
	                zipcode: _this5.$location.$$search.z
	              };
	
	              _this5.loadJobs(_params).then(function (queryParams) {
	                _this5.loadJobsPOST(queryParams);
	              });
	            }
	          });
	        } else {
	          this.setInitialParams().then(function (params) {
	            if (params && params.zipcode) {
	              _this5.loadJobs(params).then(function (queryParams) {
	                _this5.loadJobsPOST(queryParams);
	              });
	            }
	          });
	        }
	      }
	    }
	  }, {
	    key: "setScrollListener",
	    value: function setScrollListener() {
	      var _this6 = this;
	
	      var scroller = document.getElementById("job-scroll");
	      var scrollContent = document.getElementById("job-inner-scroll");
	
	      if (!scroller) return this.$timeout(function () {
	        _this6.setScrollListener();
	      }, 500);
	
	      scroller.onscroll = function () {
	        var position = scroller.clientHeight + scroller.scrollTop;
	        var buffer = 0.2;
	
	        var distance = (scrollContent.clientHeight - position) / scrollContent.clientHeight;
	        // console.log("SCROLL DISTANCE:", distance);
	
	        if (distance < buffer) {
	          _this6.loadMoreJobs();
	        }
	      };
	    }
	  }, {
	    key: "setSelectedMobileJob",
	    value: function setSelectedMobileJob(job) {
	      if (!job) {
	        this.selectedJobMobile = null;
	        document.body.style.position = "";
	        document.body.style.top = "";
	        this.$location.search("mjid", null);
	      } else {
	        this.selectedJobMobile = job;
	        this.selectedJob = job;
	        document.body.style.position = "fixed";
	        document.body.style.top = "-" + window.scrollY + "px";
	        this.$location.search("mjid", job.id);
	      }
	    }
	  }, {
	    key: "setSelectedJob",
	    value: function setSelectedJob(job) {
	      if (!job) {
	        this.selectedJob = null;
	        this.$location.search("jid", null);
	      } else {
	        this.selectedJob = job;
	        this.$location.search("jid", job.id);
	      }
	    }
	  }, {
	    key: "setJobbleTypes",
	    value: function setJobbleTypes(jobbleTypeNames) {
	      this.jobs_loading = true;
	      var queryParams = this.boardParams;
	
	      queryParams.offset = 0;
	
	      queryParams.jobbleTypeNames = jobbleTypeNames;
	
	      this.formatAndSyncQueryParams(queryParams);
	
	      if (queryParams.zipcode) this.loadJobsPOST(queryParams);
	    }
	  }, {
	    key: "applyFilters",
	    value: function applyFilters(jobs) {
	      var _this7 = this;
	
	      this.filteredJobs = jobs;
	
	      if (this.filters) {
	        if (this.filters && this.filters.companies && this.filters.companies.length) {
	          this.filteredJobs = this.filteredJobs.filter(function (job) {
	            return _this7.filters.companies.indexOf(job.companyName) !== -1;
	          });
	        }
	        if (this.filters && this.filters.locations && this.filters.locations.length) {
	          this.filteredJobs = this.filteredJobs.filter(function (job) {
	            var l = "";
	
	            if (job.is_partner_post) {
	              l = job.city + ", " + job.state;
	            } else {
	              l = job.subEvent.contactInfo.city + ", " + job.subEvent.contactInfo.state;
	            }
	
	            return _this7.filters.locations.indexOf(l) !== -1;
	          });
	        }
	      } else {}
	
	      this.filteredRelevantJobs = this.filteredJobs.filter(function (job) {
	        return !job.isFillInPost;
	      });
	      this.filteredFillInJobs = this.filteredJobs.filter(function (job) {
	        return job.isFillInPost;
	      });
	
	      this.setScrollListener();
	    }
	  }, {
	    key: "processJobs",
	    value: function processJobs(jobs, loadingMore) {
	      var _this8 = this;
	
	      console.log("processJobs");
	      console.dir(jobs);
	
	      return new Promise(function (resolve) {
	        //console.log("process jobs");
	        //console.dir(jobs);
	
	        if (!_this8.jobs || !loadingMore) {
	          //console.log("are we starting fresh");
	          _this8.jobs = [];
	          _this8.relevantJobs = [];
	          _this8.fillInJobs = [];
	          _this8.filteredJobs = [];
	          _this8.filteredRelevantJobs = [];
	          _this8.filteredFillInJobs = [];
	          _this8.$rootScope.jobs = [];
	          _this8.jobs_loading = false;
	        }
	
	        try {
	          jobs.map(function (job) {
	            _this8.jobs.push(_this8.$jobs.processJob(job).job);
	          });
	
	          _this8.relevantJobs = _this8.jobs.filter(function (job) {
	            return !job.isFillInPost;
	          });
	          _this8.fillInJobs = _this8.jobs.filter(function (job) {
	            return job.isFillInPost;
	          });
	        } catch (err) {
	          console.log("error in process jobs");
	          console.dir(err);
	        } finally {
	          _this8.jobs_loading = false;
	
	          var c = {};
	          var l = {};
	          _this8.jobs.forEach(function (job) {
	            c[job.companyName] = 1;
	
	            if (job.is_partner_post) {
	              l[job.city + ", " + job.state] = 1;
	            } else {
	              l[job.contactInfo.city + ", " + job.contactInfo.state] = 1;
	            }
	
	            job.overnight = _this8.checkForOvernight(job);
	
	            job.shifts.forEach(function (s) {
	              var start = new Date(s.timeInterval.startTime);
	              var end = new Date(s.timeInterval.endTime);
	
	              var startMoment = moment(start);
	              var endMoment = moment(end);
	
	              if (startMoment.isDST() === false && moment().isDST() === true) {
	                startMoment.add(1, "hours");
	                endMoment.add(1, "hours");
	              } else if (startMoment.isDST() === true && moment().isDST() === false) {
	                startMoment.subtract(1, "hours");
	                endMoment.subtract(1, "hours");
	              }
	
	              var timeZone = s.contactInfo.place.timeZoneId;
	              //let timeZone = "America/New_York";
	              var startDay = startMoment.tz(timeZone).format("M/DD");
	
	              var diffTime = endMoment.tz(timeZone).diff(startMoment.tz(timeZone));
	              var durTime = moment.duration(diffTime);
	
	              var durHours = durTime.hours();
	              var durMin = durTime.minutes();
	
	              var unpaidBreaks = s.unpaidBreak;
	
	              var durationInMinutes = durHours * 60 + durMin;
	              var payableMinutes = durationInMinutes - unpaidBreaks;
	
	              s.payableHours = Math.floor(payableMinutes / 60);
	              s.payableMins = payableMinutes % 60;
	            });
	
	            _this8.setTotalHoursToJob(job);
	          });
	
	          var companies = Object.keys(c);
	          var locations = Object.keys(l);
	
	          _this8.$rootScope.$emit("SetJobSearchCompanies", companies);
	          _this8.$rootScope.$emit("SetJobSearchLocations", locations);
	
	          console.log("this.jobs");
	          console.dir(_this8.jobs);
	
	          resolve(_this8.jobs);
	
	          _this8.isCurrentUser();
	        }
	      });
	    }
	  }, {
	    key: "setTotalHoursToJob",
	    value: function setTotalHoursToJob(job) {
	      var shifts = job.shifts;
	      var totalHours = 0;
	      var totalMinutes = 0;
	
	      shifts.forEach(function (shift) {
	        totalHours = shift.payableHours + totalHours;
	        totalMinutes = shift.payableMins + totalMinutes;
	      });
	
	      totalHours = totalHours + totalMinutes / 60;
	      job.totalPayableHours = totalHours;
	      job.estimatedTotalPayables = job.jobblerRate * job.totalPayableHours;
	    }
	  }, {
	    key: "checkForOvernight",
	    value: function checkForOvernight(job) {
	      var result = void 0;
	
	      var s = job.shifts.find(function (o) {
	        return o.overnight === true;
	      });
	
	      if (s) {
	        result = true;
	      } else {
	        result = false;
	      }
	
	      return result;
	    }
	  }, {
	    key: "getCoordinates",
	    value: function getCoordinates() {
	      var _this9 = this;
	
	      var coords = {};
	      this.setLoader();
	
	      return new Promise(function (resolve, reject) {
	        _this9.$window.navigator.geolocation.getCurrentPosition(function (position) {
	          coords.lat = position.coords.latitude;
	          coords.lng = position.coords.longitude;
	          _this9.unSetLoader();
	          return resolve(coords);
	        }, function (error) {
	          console.error(error);
	          _this9.unSetLoader();
	          reject(error);
	        });
	      });
	    }
	  }, {
	    key: "getZipFromGeocoder",
	    value: function getZipFromGeocoder(coords) {
	      if (!window.google) {
	        alert("Google never loaded");
	        return;
	      }
	      var geocoder = new window.google.maps.Geocoder();
	
	      console.log("getZipFromGeocoder");
	
	      var zipCode = void 0;
	
	      return new Promise(function (resolve, reject) {
	        geocoder.geocode({ latLng: coords }, function (results, status) {
	          if (status == window.google.maps.GeocoderStatus.OK) {
	            if (results[0]) {
	              for (var j = 0; j < results[0].address_components.length; j++) {
	                if (results[0].address_components[j].types[0] == "postal_code") {
	                  zipCode = results[0].address_components[j].short_name;
	                }
	              }
	
	              resolve(zipCode);
	            }
	          } else {}
	        }, function (error) {});
	      });
	    }
	  }, {
	    key: "placeParamsInURL",
	    value: function placeParamsInURL(params) {
	      this.$location.search("ref", params.placeRef);
	      this.$location.search("z", params.zip || params.zipcode || params.zip_code);
	      this.$location.search("q", params.search);
	      this.$location.search("t", params.type);
	    }
	  }, {
	    key: "setInitialParams",
	    value: function setInitialParams() {
	      var _this10 = this;
	
	      return new Promise(function (resolve, reject) {
	        var queryParams = _this10.setJobParamsForSearch();
	
	        _this10.$timeout(function () {
	          _this10.formatAndSyncQueryParams(queryParams);
	        });
	
	        if (queryParams.zipcode) {
	          return resolve(queryParams);
	        } else {
	          try {
	            _this10.$timeout(function () {
	              _this10.getCoordinates().then(function (coords) {
	                _this10.setLoader();
	                _this10.$jobs.awaitForGoogleToLoad(coords).then(function () {
	                  _this10.getZipFromGeocoder(coords).then(function (zipCode) {
	                    console.log("zipCode rectired from thing", zipCode);
	                    queryParams.zipcode = zipCode;
	                    resolve(queryParams);
	                  });
	                });
	              }).catch(function (err) {
	                resolve(queryParams, {});
	                _this10.$timeout(function () {
	                  _this10.no_zip_code = true;
	                });
	              });
	            });
	          } catch (err) {
	            console.error(err);
	          } finally {
	            if (!queryParams.zipcode) {
	              _this10.no_zip_code = true;
	            }
	          }
	          _this10.$rootScope.jobsSeenOnce = true;
	        }
	      });
	    }
	  }, {
	    key: "loadJobs",
	    value: function loadJobs(queryParams) {
	      var _this11 = this;
	
	      if (queryParams.zipcode) {
	        this.$localStorage.zipCode = queryParams.zipcode;
	      }
	
	      return new Promise(function (resolve, reject) {
	        _this11.$jobs.getPlaceRef(queryParams).then(function (response) {
	          if (response.data.length === 0) {
	            alert("This zipcode does not exist");
	            return reject();
	          }
	
	          queryParams.lat = response.data[0].lat;
	          queryParams.lng = response.data[0].lng;
	          queryParams.placeRef = response.data[0].id;
	
	          resolve(queryParams);
	        }, function (error) {
	          console.error(error);
	          _this11.system_error = true;
	          reject();
	        });
	      });
	    }
	  }, {
	    key: "applyToJobble",
	    value: function applyToJobble(job, x, type) {
	      var _this12 = this;
	
	      console.log("Applying to job");
	      console.log(job, x, type);
	
	      this.$rootScope.$emit("SetApplyProfileJob", { job: job });
	
	      if (x) {
	        this.trackViewJobFromBoard(job);
	      } else {
	        this.trackApplyToJobFromBoard(job);
	      }
	
	      console.log("Determining type");
	
	      if (job.is_partner_post || job.isSourcingPost && !this.currentUser || job.isSourcingPost && this.currentUser || !job.isSourcingPost && this.userReady && !job.urlToApply || job.is_partner_post && !this.currentUser) {
	        if (job.companyName === "Uber" || job.is_partner_post) {
	          console.log("Send to partner post url");
	          this.sendToPartnerPostUrl(job, type);
	        } else {
	          console.log("Get ready to apply");
	          this.getQuestionsReadyForApply(job);
	        }
	      } else if (!job.isSourcingPost && !this.userReady && !job.urlToApply) {
	        this.$timeout(function () {
	          _this12.displayMessageForJobbler(job, type);
	        });
	      }
	    }
	  }, {
	    key: "sendToPartnerPostUrl",
	    value: function sendToPartnerPostUrl(job, type) {
	      console.log("sendToPartnerPostUrl");
	      console.dir(job);
	      console.dir(type);
	
	      if (this.currentUser || this.$localStorage.partnerEmail) {
	        this.setPartnersPostsInteraction(job);
	        var url = job.url || job.partnerPostContent.url || job.partnerPostContent.cm_url || "/jobs";
	        this.$window.open(url);
	      } else {
	        this.$rootScope.$emit("SetApplyProfileJob", { job: job });
	        $("#apply-profile-modal").modal("toggle");
	      }
	    }
	  }, {
	    key: "getQuestionsReadyForApply",
	    value: function getQuestionsReadyForApply(job) {
	      var _this13 = this;
	
	      this.$timeout(function () {
	        _this13.$rootScope.$emit("ClearApplicationQuestions", { data: job });
	      });
	
	      this.$timeout(function () {
	        $("#apply-profile-modal").modal();
	      }, 100);
	
	      this.$timeout(function () {
	        _this13.$rootScope.$emit("SetApplicationQuestions", { data: job });
	      }, 500);
	    }
	  }, {
	    key: "closeVerificationModal",
	    value: function closeVerificationModal() {
	      this.$timeout(function () {
	        $("#user-not-verified").modal("hide");
	      });
	      this.$timeout(function () {
	        $("#apply-profile-modal").modal();
	      }, 500);
	    }
	  }, {
	    key: "displayMessageForJobbler",
	    value: function displayMessageForJobbler(job, type) {
	      var _this14 = this;
	
	      var user = this.currentUser;
	
	      if (user) {
	        if (!user.isVerified) {
	          this.setLoader();
	          this.$profile.checkValidationStatus().then(function (response) {
	            _this14.unSetLoader();
	            if (response.data.isVerified === false) {
	              _this14.$timeout(function () {
	                $("#apply-profile-modal").modal();
	                _this14.$rootScope.$emit("SetDataForVerification", { job: job, user: user });
	              });
	            } else {
	              _this14.currentUser.isVerified = true;
	              _this14.checkBasicProfileStatus(user);
	            }
	          }, function (error) {
	            _this14.unSetLoader();
	          });
	        } else {
	          this.checkBasicProfileStatus(user, job);
	        }
	      } else {
	        this.$timeout(function () {
	          $("#apply-profile-modal").modal();
	          _this14.$rootScope.$emit("SetApplicationQuestions", {
	            data: job,
	            user_ready: false,
	            button_type: type
	          });
	        });
	      }
	    }
	  }, {
	    key: "checkBasicProfileStatus",
	    value: function checkBasicProfileStatus(user, job) {
	      var _this15 = this;
	
	      if (!this.userReady) {
	        this.$timeout(function () {
	          _this15.$rootScope.$emit("SetDataForVerification", { user: user, job: job });
	          $("#apply-profile-modal").modal();
	        });
	      }
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      this.waiting_for_last = false;
	      this.bottom_loading = false;
	      this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "loadMore",
	    value: function loadMore() {
	      var max = 10;
	      var offset = this.jobs.length;
	
	      var queryParams = this.boardParams;
	      queryParams.max = max;
	      queryParams.offset = offset;
	
	      this.loadJobsPOST(queryParams, true);
	    }
	  }, {
	    key: "canUserApplyToShiftBasedJobs",
	    value: function canUserApplyToShiftBasedJobs() {
	      var currentUser = this.$auth.getUserData();
	      this.userReady = this.validateUserPrefs(currentUser);
	      this.profileStatus = this.$profile.getUserProfileStatus(currentUser);
	    }
	  }, {
	    key: "validateUserPrefs",
	    value: function validateUserPrefs(user) {
	      this.userReady = !(!user.dateBirth || !user.homeContactInfo.phoneMobile || !user.ssn || !user.profilePictureUri || !user.homeContactInfo.zipCode || !user.homeContactInfo.city || !user.homeContactInfo.streetLine1 || !user.homeContactInfo.state);
	
	      return this.userReady;
	    }
	  }, {
	    key: "setJobForBackButton",
	    value: function setJobForBackButton(job, index) {
	      var _this = this;
	
	      this.trackViewJobFromBoard(job);
	      this.$rootScope.anchor = "job-label-" + index;
	
	      var url_data = {};
	      url_data.src = "internal";
	      url_data.job_listings = "true";
	
	      if (_this.currentUser) {
	        var data = _this.$iterable.set_data(_this.boardParams, job, _this.currentUser, "view");
	        _this.track_jobble_view(data);
	      }
	      if (_this.boardParams.company || _this.boardParams.search) {
	        url_data.company_ph = _this.boardParams.company;
	        url_data.search_ph = _this.boardParams.search;
	        url_data.zipcode_ph = _this.boardParams.zipcode;
	      } else {
	        url_data.zipcode_ph = _this.boardParams.zipcode;
	      }
	      _this.$location.path("/job/" + job.id).search(url_data);
	    }
	  }, {
	    key: "track_jobble_view",
	    value: function track_jobble_view(data) {
	      var _this = this;
	      _this.$iterable.track_jobble_view(data).then(function (response) {}, function (error) {});
	    }
	  }, {
	    key: "trackBoardLoad",
	    value: function trackBoardLoad() {
	      var _this = this;
	      var data = {};
	
	      if (!_this.currentUser) {
	        data.username = "Unregistered";
	      } else {
	        data.username = _this.currentUser.username;
	      }
	      if (_this.boardParams && _this.boardParams.zipcode) {
	        data.zipcode = _this.boardParams.zipcode;
	      }
	      if (_this.boardParams && _this.boardParams.placeRef) {
	        data.placeRef = _this.boardParams.placeRef;
	      }
	      _this.$tracking.reportJobBoardLoad(data);
	    }
	  }, {
	    key: "formatAndSyncQueryParams",
	    value: function formatAndSyncQueryParams(queryParams) {
	      var _this16 = this;
	
	      if (_angular2.default.isUndefined(queryParams.geoFenceRadius)) {
	        queryParams.geoFenceRadius = 40;
	      }
	
	      if (this.filter.radius_change) {
	        queryParams.geoFenceRadius = this.$jobs.milesToKilometers(queryParams.geoFenceRadius);
	      }
	
	      this.boardParams = queryParams;
	      this.placeParamsInURL(queryParams);
	      this.$rootScope.boardParameters = queryParams;
	      console.log("EMITTING", queryParams);
	
	      this.$rootScope.$emit("JobSearchQueryParams", queryParams);
	
	      this.$timeout(function () {
	        _this16.unSetLoader();
	      }, 3000);
	
	      return queryParams;
	    }
	  }, {
	    key: "loadJobsPOST",
	    value: function loadJobsPOST(queryParams, loadingMore) {
	      var _this17 = this;
	
	      if (!loadingMore) {
	        this.jobs = [];
	        this.filteredJobs = [];
	        this.filteredRelevantJobs = [];
	        this.filteredFillInJobs = [];
	      }
	
	      queryParams = this.formatAndSyncQueryParams(queryParams);
	
	      if (queryParams.zipcode) {
	        this.$localStorage.zipCode = queryParams.zipcode;
	      }
	
	      console.log(this.boardParams);
	
	      this.setLoader();
	      this.jobs_loading = true;
	      this.no_more_jobs_with_this_search = false;
	      this.no_zip_code = false;
	
	      console.time("Load Jobs Time End:");
	
	      var params = _.cloneDeep(queryParams);
	
	      params.jobbleTypes = [];
	      params.search = params.search || "";
	
	      if (params.jobbleTypeNames && params.jobbleTypeNames.length) {
	        var query = params.search ? [params.search.toLowerCase()] : [];
	        params.search = [].concat(query, _toConsumableArray(params.jobbleTypeNames));
	        params.search = params.search.join(",");
	        params.jobbleTypeNames = undefined;
	      }
	
	      console.log(params);
	
	      clearTimeout(this.searchTimeout);
	
	      this.searchTimeout = setTimeout(function () {
	        _this17.$jobs.getJobsPOST(params).then(function (response) {
	          _this17.unSetLoader();
	
	          console.log("jobs response");
	          console.dir(response);
	
	          if (response.data.status === "error") {
	            _this17.jobs_loading = false;
	            _this17.handleError(response, loadingMore);
	            return;
	          } else {
	            _this17.system_error = false;
	          }
	
	          if (loadingMore) {
	            _this17.hideLoadingMoreBanner();
	          }
	
	          var results = response.data.data;
	          var suggestionFilters = response.data.suggestions && response.data.suggestions.length ? response.data.suggestions : [];
	
	          _this17.$rootScope.$emit("DynamicSuggestedFilters", suggestionFilters);
	
	          if (loadingMore && results.length === 0) {
	            console.warn("No more jobs with this search is: true");
	            _this17.no_more_jobs_with_this_search = true;
	            return;
	          }
	
	          _this17.processJobs(results, loadingMore, queryParams).then(function (jobs) {
	            _this17.applyFilters(jobs);
	
	            var search = _this17.$location.search();
	
	            console.log(_this17.selectedJob, _this17.hasInitialSelectedJob);
	
	            if (_this17.selectedJob && _this17.hasInitialSelectedJob) {
	              _this17.hasInitialSelectedJob = false;
	            } else if (!_this17.selectedJob && _this17.filteredJobs && _this17.filteredJobs.length) {
	              if (search.jid) {
	                _this17.filteredJobs.forEach(function (job) {
	                  if (job.id + "" === search.jid + "") {
	                    _this17.setSelectedJob(job);
	                  }
	                });
	
	                if (!_this17.selectedJob) {
	                  _this17.setSelectedJob(_this17.filteredRelevantJobs && _this17.filteredRelevantJobs.length ? _this17.filteredRelevantJobs[0] : _this17.filteredJobs[0]);
	                }
	              } else {
	                _this17.setSelectedJob(_this17.filteredRelevantJobs && _this17.filteredRelevantJobs.length ? _this17.filteredRelevantJobs[0] : _this17.filteredJobs[0]);
	              }
	            } else if (_this17.selectedJob && !loadingMore && _this17.filteredJobs) {
	              var searchArray = _this17.filteredJobs;
	              if (_this17.filteredRelevantJobs && _this17.filteredRelevantJobs.length) searchArray = _this17.filteredRelevantJobs;
	
	              var found = false;
	              searchArray.forEach(function (job) {
	                if (job.id === _this17.selectedJob.id) found = true;
	              });
	
	              if (!found) {
	                _this17.setSelectedJob(_this17.filteredRelevantJobs && _this17.filteredRelevantJobs.length ? _this17.filteredRelevantJobs[0] : _this17.filteredJobs[0]);
	              }
	            }
	          });
	
	          _this17.trackBoardLoad();
	        }, function (error) {
	          console.error(error);
	          _this17.unSetLoader();
	          if (loadingMore) {
	            _this17.hideLoadingMoreBanner();
	          }
	          var errorStr = error.toString();
	          if (errorStr.indexOf("Data must be a valid JSON") > -1) {
	            _this17.handleBadJson(error, null);
	          } else {
	            _this17.jobs_loading = false;
	            _this17.system_error = true;
	          }
	        });
	      }, 1000);
	    }
	  }, {
	    key: "handleError",
	    value: function handleError(response, loadingMore) {
	      console.error(response);
	      this.system_error = true;
	      if (loadingMore) {
	        this.hideLoadingMoreBanner();
	      }
	    }
	  }, {
	    key: "trackViewJobFromBoard",
	    value: function trackViewJobFromBoard(job) {
	      var _this = this;
	      var data = {};
	      if (!_this.currentUser) {
	        data.username = "Unregistered";
	      } else {
	        data.username = _this.currentUser.username;
	      }
	      _this.$tracking.reportViewJobFromJobBoard(data);
	
	      if (job && job.is_partner_post) {
	        _this.$analytics.trackClickCMJob();
	      }
	    }
	  }, {
	    key: "trackApplyToJobFromBoard",
	    value: function trackApplyToJobFromBoard(job) {
	      var _this = this;
	      var data = {};
	      if (!_this.currentUser) {
	        data.username = "Unregistered";
	      } else {
	        data.username = _this.currentUser.username;
	        if (job.partnerPostContent) {
	          _this.setPartnersPostsInteraction(job);
	        }
	      }
	      _this.$tracking.reportApplyToJobFromBoard(data);
	
	      if (job && job.is_partner_post) {
	        _this.$analytics.trackClickCMJob(job);
	      }
	    }
	  }, {
	    key: "setPartnersPostsInteraction",
	    value: function setPartnersPostsInteraction(job) {
	      this.$jobs.setPartnersPostsInteraction(job).then(function (response) {}, function (error) {});
	    }
	  }, {
	    key: "handleBadJson",
	    value: function handleBadJson(error, job) {
	      this.jobs_loading = false;
	      this.jobs = [];
	      this.relevantJobs = [];
	      this.fillInJobs = [];
	      this.filteredJobs = [];
	      this.filteredRelevantJobs = [];
	      this.filteredFillInJobs = [];
	      var params = {};
	      params.zipcode = this.boardParams.zipcode;
	      params.geoFenceRadius = this.boardParams.geoFenceRadius;
	      params.offset = this.boardParams.offset;
	      this.$tracking.reportJobbleBoardFailedJson(params);
	    }
	  }, {
	    key: "setSort",
	    value: function setSort() {
	      var queryParams = this.boardParams;
	      queryParams.offset = 0;
	
	      if (this.sort === "relevance") {
	        queryParams.sort = undefined;
	      } else {
	        queryParams.sort = {
	          name: this.sort,
	          value: this.sort === "startTime" ? "asc" : "desc"
	        };
	      }
	
	      this.$tracking.reportClickJobSort("job board", this.sort);
	
	      this.loadJobsPOST(queryParams);
	    }
	  }, {
	    key: "setJobParamsForSearch",
	    value: function setJobParamsForSearch() {
	      var queryParams = {
	        max: 10,
	        type: "text_search",
	        sort: {
	          name: "startTime",
	          value: "asc"
	        },
	        geoFenceRadius: 40
	      };
	
	      queryParams.search = this.$location.$$search.q || undefined;
	      queryParams.zipcode = this.$location.$$search.z || this.$stateParams.zipcode || this.$localStorage.zipCode || undefined;
	
	      console.log("Local storage zip code:", this.$localStorage.zipCode);
	      return queryParams;
	    }
	  }, {
	    key: "loadMoreJobs",
	    value: function loadMoreJobs() {
	      // TODO: Get Infinite scrolling working . . .
	      console.log("LOAD MORE");
	
	      if (this.waiting_for_last) return;
	
	      console.error("Loading New Jobs");
	
	      this.waiting_for_last = true;
	
	      if (!this.no_more_jobs_with_this_search) this.loadMoreJobsFromBottom();
	    }
	  }, {
	    key: "loadMoreJobsFromBottom",
	    value: function loadMoreJobsFromBottom() {
	      if (!this.jobs_loading) {
	        this.bottom_loading = true;
	      } else {
	        this.waiting_for_last = false;
	        return;
	      }
	
	      if (this.jobs && this.jobs.length > 0 && this.bottom_loading) {
	        this.displayLoadingMoreBanner();
	        this.loadMore();
	      } else {
	        this.bottom_loading = false;
	        console.error("OPther case");
	        this.waiting_for_last = false;
	      }
	    }
	  }, {
	    key: "displayLoadingMoreBanner",
	    value: function displayLoadingMoreBanner() {
	      this.$timeout(function () {
	        $(".jobs-complete-container .container .load-more-loader-jobs-scroll").show("slide", { direction: "down" }, 100);
	      });
	    }
	  }, {
	    key: "hideLoadingMoreBanner",
	    value: function hideLoadingMoreBanner(no_more_jobs) {
	      var _this18 = this;
	
	      this.$timeout(function () {
	        $(".jobs-complete-container .container .load-more-loader-jobs-scroll").hide("slide", { direction: "up" }, 100);
	      });
	
	      this.$timeout(function () {
	        _this18.jobs_loading = false;
	      });
	    }
	  }, {
	    key: "closeIndiBanner",
	    value: function closeIndiBanner() {
	      this.$timeout(function () {
	        $(".indi-jobble-holder").hide("slide", { direction: "up" }, 100);
	      });
	    }
	  }, {
	    key: "isCurrentUser",
	    value: function isCurrentUser() {
	      if (this.currentUser) {
	        this.$window.Intercom("boot", {
	          app_id: "och30e8r",
	          email: this.currentUser.email,
	          user_id: this.currentUser.id,
	          created_at: 1234567890
	        });
	      }
	    }
	  }]);
	
	  return JobsController;
	}();
	
	JobsController.$inject = ["$window", "$location", "$http", "$localStorage", "$state", "auth", "events", "security", "$stateParams", "$timeout", "$interval", "$rootScope", "$scope", "jobs", "$anchorScroll", "tracking", "profile", "iterable", "analytics"];
	
	exports.default = JobsController;

/***/ }),
/* 594 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ZIP_ERROR_MESSAGES;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Define Error Prefix
	var ZIP_PREFIX = 1054;
	
	// Define Error Codes
	var MISSING_ZIP = ZIP_PREFIX + 1;
	var SHORT_ZIP = ZIP_PREFIX + 2;
	var INVALID_ZIP = ZIP_PREFIX + 3;
	
	// Public Error Codes
	var ZIP_ERRORS = exports.ZIP_ERRORS = {
	  MISSING_ZIP: MISSING_ZIP,
	  SHORT_ZIP: SHORT_ZIP,
	  INVALID_ZIP: INVALID_ZIP
	};
	
	// Corresponding Error Messages
	var ZIP_ERROR_MESSAGES = exports.ZIP_ERROR_MESSAGES = (_ZIP_ERROR_MESSAGES = {}, _defineProperty(_ZIP_ERROR_MESSAGES, MISSING_ZIP, "Zip Required."), _defineProperty(_ZIP_ERROR_MESSAGES, SHORT_ZIP, "Zip code must be 5 digits."), _defineProperty(_ZIP_ERROR_MESSAGES, INVALID_ZIP, "Please enter a 5 digit zip code."), _ZIP_ERROR_MESSAGES);
	
	var ZipValidator = function () {
	  function ZipValidator() {
	    _classCallCheck(this, ZipValidator);
	  }
	
	  _createClass(ZipValidator, null, [{
	    key: "validateZip",
	    value: function validateZip(zip_code) {
	      var errors = [];
	
	      // Short Phone
	      if (!zip_code) {
	        errors.push(MISSING_ZIP);
	      }
	
	      // Validate PHone By Regex
	      if (!ZIPREGEX.test(zip_code)) {
	        errors.push(INVALID_ZIP);
	      }
	
	      return {
	        isValid: !errors.length,
	        errors: errors
	      };
	    }
	  }, {
	    key: "constructErrorMessage",
	    value: function constructErrorMessage(errors) {
	      var message = [];
	
	      errors.forEach(function (error) {
	        message.push(ZIP_ERROR_MESSAGES[error]);
	      });
	
	      return message.join(" ");
	    }
	  }]);
	
	  return ZipValidator;
	}();
	
	exports.default = ZipValidator;
	
	
	var ZIPREGEX = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(596);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobs.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobs.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(598);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".jobs-container{display:flex;flex-direction:column;height:100vh;overflow:hidden}.jobs-container .jobs-container-nav{flex:0 0 78px;overflow:hidden}.jobs-container .jobs-container-filters{flex:0}@media only screen and (max-width:768px){.jobs-container .jobs-container-filters{flex:0 0 42px;overflow:hidden}}.jobs-container .jobs-container-content{flex:1;overflow:hidden;width:100vw}@media only screen and (max-width:768px){.jobs-container .jobs-container-content{padding:0}}.job-panel-container{display:flex;flex-direction:row;height:100%;overflow:hidden;max-width:900px;margin:auto}.job-panel-menu{flex:0.67;height:100%;overflow-y:scroll;padding:16px 24px 25px 0}.job-panel-container .no-zip-container{margin-top:83px;text-align:center;padding:0 16px}.job-panel-container .no-zip-container h1{font-size:16px;line-height:25px}.job-panel-container .no-zip-container h1,.job-panel-container .no-zip-container h2{color:#33373a;font-family:Poppins,sans-serif;font-weight:600;letter-spacing:0;text-align:center}.job-panel-container .no-zip-container h2{font-size:14px;line-height:21px}.job-panel-container .no-zip-container img{width:79px;margin:16px 0}@media only screen and (max-width:768px){.job-panel-menu{margin:0;flex:1;padding:16px 0 0}}.sort-container{height:28px;margin-bottom:16px;display:flex;max-width:352px;margin-left:auto;margin-right:0}@media only screen and (max-width:768px){.sort-container{padding:0 16px;max-width:none}}.result-count{flex:1;color:#33373a;font-family:Poppins,sans-serif;font-size:11px;font-weight:500;line-height:17px}.sort-selector-container{flex:0 0 205px;text-align:right}.sort-label{display:inline-block;color:#5e666d;font-family:Poppins,sans-serif;font-size:11px;font-weight:600;line-height:28px;margin-right:8px}.sort-select-container{display:inline-block;position:relative}.sort-select-container select{margin:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0 8px;cursor:pointer;height:28px;width:136px;border:1px solid #5e666d;border-radius:13.5px;-webkit-border-radius:13.5px;background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.2);color:#6a7178;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;line-height:28px}.sort-select-container i{color:#6a7178;position:absolute;right:8px;top:9px;font-size:12px;pointer-events:none}.job-search-cards{margin-left:auto;margin-right:0;border-radius:6px}.job-search-cards,.search-cards-seperator{max-width:352px;box-shadow:0 2px 4px 0 rgba(0,0,0,.2)}.search-cards-seperator{border:1px solid #adbcc2;border-radius:6px;color:#6a7178;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;line-height:16px;padding:16px;margin:16px 0;margin-left:auto;overflow:hidden}.search-cards-seperator .loading-card{height:151px;border-bottom:1px solid #adbcc2;background:#fff;padding:16px}.animated-loading-background{background:linear-gradient(270deg,#f3f3f2,#e2e3e2);background-position:0;animation-timing-function:ease-in-out;background-size:200%;animation:myfirst 1s;-moz-animation:myfirst 1s infinite;-webkit-animation:myfirst 1s infinite}.mobile-cards{display:none}@media only screen and (max-width:768px){.mobile-cards{display:block}.desktop-cards{display:none}.search-cards-seperator{margin:16px;max-width:none}.search-cards-seperator.loading-seperator{margin:0}.job-search-cards{max-width:none;box-shadow:none}}.selected-job-container .apply-button.already-applied{cursor:default;border-radius:6px;height:34px;line-height:34px;width:82px;text-align:center;font-size:14px;background-color:#fff;color:#3b3f43;font-family:Poppins,sans-serif;font-weight:600}.selected-job-container .apply-button.already-applied a{color:#3b3f43;cursor:default}.job-panel-selected{flex:1;height:100%;overflow-y:scroll;padding:60px 0 25px;position:relative}.job-panel-banner{height:34px;width:100%;max-width:524px;border-radius:6px;background:linear-gradient(90deg,#62c046,#5498b4);margin-top:-47px;margin-bottom:13px;padding:0 8px;color:#fff;font-family:Poppins,sans-serif;font-size:12px;font-weight:700;letter-spacing:0;line-height:34px;cursor:pointer}.job-panel-banner i{font-size:18px;line-height:34px;float:right}@media only screen and (max-width:768px){.job-panel-banner,.job-panel-selected{display:none}}.job-panel-selected-mobile{position:fixed;bottom:0;height:100%;padding-top:32px;background:rgba(0,0,0,.5);z-index:1049;width:100%;display:none}@media only screen and (max-width:768px){.job-panel-selected-mobile{display:block}}.mobile-panel-container{overflow:hidden;border-radius:16px 16px 0 0;flex-direction:row;background:#fff;padding:16px 0 40px;height:100%;display:flex}.mobile-panel-container .mobile-description-holder{flex:1;overflow-y:scroll;overflow-x:hidden}.mobile-panel-container .mobile-close{flex:0 0 16px;font-size:14px;position:absolute;right:16px;cursor:pointer;top:75px}.job-panel-menu::-webkit-scrollbar,.job-panel-selected-mobile::-webkit-scrollbar,.job-panel-selected::-webkit-scrollbar,.mobile-description-holder::-webkit-scrollbar{width:0!important}.job-panel-menu,.job-panel-selected,.mobile-description-holder{overflow:-moz-scrollbars-none;scrollbar-width:none;-ms-overflow-style:none}.indi-jobble-holder{height:70px;width:100%;background:linear-gradient(116.57deg,#3e5099,#549cb4);display:block}.indi-jobble-inside-holder{width:895px;display:block;height:70px;margin:0 auto}.indi-jobble-holder h4.full-screen{color:#fff;font-family:Poppins,sans-serif;margin:23px 0 0 75px;padding:0;float:left;font-weight:900}.indi-jobble-holder img.full{margin-top:12px;float:left}.indi-jobble-holder img.mobile-indi{display:none}.indi-jobble-holder i.close-indi{color:#fff;float:right;margin-top:15px;margin-right:15px}.indi-jobble-holder i.close-indi:hover{cursor:pointer}.indi-jobble-holder a.mobile-indi-link,.indi-jobble-holder h4.mobile-indi-header{display:none}a.learn-more-indi{border:2px solid #fff;border-radius:6px;margin-left:46px;padding:7px 20px 7px 16px;margin-top:14px;color:#fff;float:left;font-family:Poppins,sans-serif;font-size:15px;font-weight:900}a.learn-more-indi i{font-size:12px}.job-mobile .jobble-tip-super-container{border-radius:6px;background:linear-gradient(116.57deg,#ff8609,#d8000c);padding:2px;height:29px;cursor:pointer;margin-top:10px;width:100%;display:none}.job-mobile .jobble-tip-container{background:#fff;border-radius:4px;padding:0 6px;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;width:100%;height:25px;line-height:25px;color:#5e666d;letter-spacing:0}.job-mobile .jobble-tip-container i{margin-right:5px}@media only screen and (max-width:768px){.job-mobile .jobble-tip-super-container{display:block}.indi-jobble-holder{margin-top:7px}}@media only screen and (max-width:957px){.indi-jobble-holder h4.full-screen{margin-left:30px}a.learn-more-indi{margin-left:20px}}@media only screen and (max-width:889px){.indi-jobble-holder img.full{margin-left:40px}}@media only screen and (max-width:789px){a.learn-more-indi{display:none}}@media only screen and (max-width:636px){.indi-jobble-holder img{margin-left:5px}}@media only screen and (max-width:630px){.indi-jobble-holder h4.full-screen{font-size:14px;margin-left:14px;display:none}.indi-jobble-holder img.full{display:none}.indi-jobble-holder{height:150px}.indi-jobble-holder img.mobile-indi{display:block;margin-top:-15px;float:left}.indi-jobble-holder h4.mobile-indi-header{display:block;float:left;font-size:14px;color:#fff;font-family:Poppins,sans-serif;font-weight:900;margin-left:-42px;padding-top:10px}.indi-jobble-holder h4.mobile-indi-header span{font-size:20px;text-decoration:underline}.indi-jobble-holder h4.mobile-indi-header span:hover{cursor:pointer}.indi-jobble-holder a.mobile-indi-link{color:#fff;font-family:Poppins,sans-serif;text-decoration:underline;display:block;float:left;position:absolute;bottom:61px}}", ""]);
	
	// exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _postevent = __webpack_require__(600);
	
	var _postevent2 = _interopRequireDefault(_postevent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var posteventModule = _angular2.default.module("postevent", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("postevent", {
	    url: "/post-event?is_load_tutorial",
	    template: "<postevent></postevent>",
	    params: {
	      jobType: null,
	      pay: null,
	      openings: null,
	      pt: null,
	      job_posting_type: null,
	      job_title: null,
	      jobble_type: null,
	      hourly_rate: null,
	      pay_rate: null,
	      pay_rate_jblr: null,
	      dress_code: null,
	      job_description: null,
	      preserve: null,
	      t: null,
	      date_time: null,
	      instructions: null,
	      location: null,
	      street_line_1: null
	    },
	    onExit: ["$rootScope", function ($rootScope) {}]
	  });
	}).component("postevent", _postevent2.default);
	
	exports.default = posteventModule;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _postevent = __webpack_require__(601);
	
	var _postevent2 = _interopRequireDefault(_postevent);
	
	var _postevent3 = __webpack_require__(602);
	
	var _postevent4 = _interopRequireDefault(_postevent3);
	
	__webpack_require__(603);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var posteventComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _postevent2.default,
	  controller: _postevent4.default,
	  controllerAs: "vm"
	};
	
	exports.default = posteventComponent;

/***/ }),
/* 601 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<!--------------------- Application-Status Start --------------------->\n<div class=\"banner-application-status\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 center-block\">\n        <div class=\"application-bar clearfix\">\n          <div class=\"app-status select\">\n            <small ng-click=\"vm.updateTracker(0)\"></small>\n            <span>Job Details</span>\n          </div>\n          <div class=\"app-status-bar\" ng-class=\"{ 'app-progress-bar' : vm.statusBarStatus.step_2.visited == true }\"></div>\n          <div class=\"app-status\" ng-class=\"{ 'select' : vm.statusBarStatus.step_2.visited == true }\">\n            <small ng-click=\"vm.updateTracker(1)\"></small>\n            <span ng-if=\"vm.isSourcingPost\">Location</span>\n            <span ng-if=\"!vm.isSourcingPost\">Shifts</span>\n          </div>\n\n          <div class=\"app-status-bar\" ng-class=\"{ 'app-progress-bar' : vm.statusBarStatus.step_3.visited == true }\"></div>\n          <div class=\"app-status\" ng-class=\"{ 'select' : vm.statusBarStatus.step_3.visited == true }\">\n            <small ng-click=\"vm.updateTracker(6)\"></small>\n            <span>Questionnaire</span>\n          </div>\n          <div class=\"app-status-bar\" ng-class=\"{ 'app-progress-bar' : vm.statusBarStatus.step_4.visited == true }\"></div>\n          <div class=\"app-status\" ng-class=\"{ 'select' : vm.statusBarStatus.step_4.visited == true }\">\n            <small ng-click=\"vm.updateTracker(3)\"></small>\n            <span>Review and Post</span>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<!------------------- Application-Status End --------------------->\n<div class=\"content\">\n  <div class=\"container\">\n    <questionnaire ng-if=\"vm.step == 6\"></questionnaire>\n\n    <div class=\"row\" ng-if=\"vm.step == 0\">\n      <!--------------------- Process Description Start --------------------->\n      <form>\n        <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12 process-description-outer\">\n          <div class=\"process-description\">\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"title-section\">\n                  <div class=\"row\">\n                    <div class=\"col-lg-8 col-md-8 col-sm-12 col-xs-12\">\n                      <h3 ng-if=\"vm.postType=='regular'\">\n                        <span class=\"job-title-reminder\">On-Demand</span>\n                        - Job Details\n                      </h3>\n                      <h3 ng-if=\"vm.postType=='source'\">\n                        <span class=\"job-title-reminder\">Recruit</span>\n                        - Job Details\n                      </h3>\n                    </div>\n                    <div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\">\n                      <button ng-if=\"vm.currentUser.isAdmin\" class=\"btn btn-primary\" ng-click=\"vm.go_to_bulk_upload_jobs_page()\" style=\"float: right\">\n                        Bulk Upload Jobs\n                      </button>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"form-section clearfix\">\n                <h3 ng-if=\"vm.isClone\" class=\"clone-banner\">\n                  <span ng-if=\"vm.$location.$$search.jid\">Draft</span>\n                  <span ng-if=\"!vm.$location.$$search.jid\">Clone</span>\n                </h3>\n\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                  <label>Job Title</label>\n                  <input\n                    type=\"text\"\n                    class=\"form-control form-input\"\n                    placeholder=\"Enter Job Title\"\n                    ng-model=\"vm.event.name\"\n                    ng-change=\"vm.detailsChanged(1)\"\n                  />\n                </div>\n                <div class=\"row\" style=\"margin-left: 0px; margin-right: 0px\">\n                  <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                    <label>Position Type</label>\n                    <div class=\"select-box\">\n                      <!--\n\t                                     <select \n\t                                     \tchosen\n\t                                     \tplaceholder-text-single=\"'Choose a job type'\"\n\t                                     \tclass=\"form-control form-input\"\n\t                                     \tng-if=\"((vm.isClone && !vm.$stateParams.jobType && !vm.isEdit) || (vm.ismarketing))\" \n\t                                     \tng-model=\"vm.event.jobble_type\"  \n\t                                     \tng-change=\"vm.changed_clone_jobble_type()\"\n\t                                     \tng-options=\"jobble_type.id as jobble_type.name for jobble_type in vm.jobble_types\">\n\t\t\t                  \t\t\t </select>\n\t\t\t                  \t\t\t ng-options=\"jobbleType.id as jobbleType.name for jobbleType in vm.jobbleTypes\"\n\t\t\t                  \t\t\t-->\n\n                      <select\n                        ng-if=\"((vm.isClone && !vm.$stateParams.jobType && !vm.isEdit) || (vm.ismarketing))\"\n                        class=\"form-control form-input\"\n                        ng-model=\"vm.event.jobble_type\"\n                        ng-options=\"jobble_type.id as jobble_type.name for jobble_type in vm.jobble_types\"\n                        ng-change=\"vm.changed_clone_jobble_type()\"\n                      ></select>\n\n                      <select\n                        chosen\n                        placeholder-text-single=\"'Choose a job type'\"\n                        ng-if=\"!vm.isClone && vm.$stateParams.jobType && !vm.isEdit && !vm.ismarketing\"\n                        ng-model=\"vm.event.jobble_type\"\n                        ng-change=\"vm.detailsChanged(2)\"\n                        class=\"form-control form-input\"\n                        style=\"width: 100%\"\n                        ng-options=\"jobble_type.id as jobble_type.name for jobble_type in vm.jobble_types\"\n                      ></select>\n                      <!-- style=\"width:299px;\" -->\n                      <!-- style=\"width:299px;\" -->\n                      <select\n                        chosen\n                        placeholder-text-single=\"'Choose a job type'\"\n                        class=\"form-control form-input\"\n                        ng-model=\"vm.event.jobble_type\"\n                        style=\"width: 100%\"\n                        ng-options=\"jobble_type.id as jobble_type.name for jobble_type in vm.jobble_types\"\n                        ng-if=\"!vm.isClone && !vm.$stateParams.jobType && !vm.isEdit  && !vm.ismarketing\"\n                        ng-change=\"vm.detailsChanged(2)\"\n                      >\n                        <option value=\"\"></option>\n                      </select>\n                    </div>\n                  </div>\n\n                  <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" ng-if=\"vm.isSourcingPost\">\n                    <label class=\"field\">Hourly Rate (Optional)</label>\n                    <div class=\"input-rate\">\n                      <input\n                        type=\"text\"\n                        class=\"form-control form-input\"\n                        placeholder=\"20\"\n                        ng-model=\"vm.event.hourly_rate\"\n                        ng-change=\"vm.calcNumbers()\"\n                      />\n                    </div>\n                  </div>\n\n                  <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" ng-if=\"!vm.isSourcingPost\">\n                    <label>Number of Openings</label>\n                    <div class=\"select-box\">\n                      <select\n                        class=\"form-control form-input\"\n                        ng-if=\"!vm.isClone\"\n                        ng-model=\"vm.openingsList.value\"\n                        ng-options=\"openings for openings in vm.openingsList.values\"\n                        ng-change=\"vm.detailsChanged(3)\"\n                      ></select>\n                      <!--\n\t                                    <select \n\t\t\t                  \t\t\t\tng-if=\"((vm.isClone && !vm.$stateParams.jobType && !vm.isEdit) || (vm.ismarketing))\"\n\t\t\t\t\t\t\t\t\t\t\tclass=\"form-control form-input\" \n\t\t\t\t\t\t\t\t\t\t\tng-model=\"vm.event.jobble_type\"   \n\t\t\t\t\t\t\t\t\t\t\tng-options=\"jobble_type.id as jobble_type.name for jobble_type in vm.jobble_types\"\n\t\t\t\t\t\t\t\t\t\t\tng-change=\"vm.changed_clone_jobble_type()\">\n\t\t\t\t\t\t\t\t\t\t</select>\n\t                                    -->\n                      <select\n                        class=\"form-control form-input\"\n                        ng-if=\"vm.isClone\"\n                        ng-model=\"vm.openings_for_clone.value\"\n                        ng-options=\"openings.value as openings.value for openings in vm.openings_for_clone.values\"\n                        ng-change=\"vm.changeOpeningsOnClone(3,false)\"\n                      ></select>\n                    </div>\n                  </div>\n                </div>\n\n                <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" ng-if=\"!vm.isSourcingPost\">\n                  <label class=\"field\">Hourly Rate</label>\n                  <div class=\"input-rate\">\n                    <input\n                      type=\"text\"\n                      class=\"form-control form-input\"\n                      placeholder=\"20\"\n                      ng-model=\"vm.event.hourly_rate\"\n                      ng-change=\"vm.calcNumbers()\"\n                    />\n                  </div>\n                </div>\n                <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" ng-if=\"!vm.isSourcingPost\">\n                  <label class=\"field\">Jobbler Makes</label>\n                  <div class=\"input-rate\">\n                    <input\n                      type=\"text\"\n                      class=\"form-control form-input\"\n                      placeholder=\"\"\n                      ng-model=\"vm.event.hourly_rate_adj\"\n                      ng-change=\"vm.calcNumbersAdj()\"\n                    />\n                  </div>\n                </div>\n\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-if=\"!vm.isSourcingPost\">\n                  <label>Dress Code</label>\n                  <textarea\n                    class=\"form-control form-input\"\n                    rows=\"3\"\n                    placeholder=\"Dress code description\"\n                    style=\"height: inherit\"\n                    ng-model=\"vm.event.dress_code\"\n                    ng-change=\"vm.detailsChanged(2)\"\n                  ></textarea>\n                </div>\n\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                  <label>Hiring Manager</label>\n                  <jobcontact></jobcontact>\n                </div>\n\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                  <label>Job Description</label>\n                  <textarea\n                    class=\"form-control form-input\"\n                    rows=\"6\"\n                    placeholder=\"Enter Job Description\"\n                    ng-model=\"vm.event.jobble_details\"\n                    ng-change=\"vm.detailsChanged(2)\"\n                  ></textarea>\n                </div>\n\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding-top: 20px\">\n                  <div class=\"alert-box alert\" ng-show=\"vm.displayFirstPageErrorMessage\">{{ vm.message }}</div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n              <!--\n                        <div class=\"leftbtn\">\n                            \t<input type=\"button\" value=\"Back: Posting Type\" class=\"btn button btn-default\" onclick=\"location.href='index.html'\">\n                         </div>\n                         -->\n              <div class=\"rightbtn\">\n                <input\n                  ng-if=\"!vm.isSourcingPost\"\n                  type=\"button\"\n                  value=\"Next: Add Shifts\"\n                  class=\"btn button btn-success no-margin-for-button\"\n                  ng-click=\"vm.submitEventDetail(3)\"\n                />\n                <input\n                  ng-if=\"vm.isSourcingPost\"\n                  type=\"button\"\n                  value=\"Next: Add Location\"\n                  class=\"btn button btn-success no-margin-for-button\"\n                  ng-click=\"vm.submitEventDetail(3)\"\n                />\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n      <!--------------------- Process Status Start --------------------->\n      <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\">\n        <div class=\"process-status\">\n          <img class=\"creation-img-sml\" src=\"/app/vendor/images/connect.png\" ng-if=\"vm.isSourcingPost\" />\n          <img class=\"creation-img-sml\" src=\"/app/vendor/images/ondemand.png\" ng-if=\"!vm.isSourcingPost\" />\n\n          <h3 ng-if=\"vm.currentUser\">{{ vm.currentUser.firstName }}, the details are important</h3>\n          <h3 ng-if=\"!vm.currentUser\">The details are important</h3>\n          <p>Be sure to describe the responsibilities of the job, required work experience, skills, or education.</p>\n        </div>\n\n        <!--\n                <div class=\"process-status\" ng-if=\"vm.postOptions.value == 'Sourcing' && !vm.isClone\">\n                \t<label style=\"margin: 18px 0 5px;color: #3b3f43;font-weight: 400;font-family: 'montserratregular';\">Looking to fill a shift?</label>\n                \t<p style=\"margin-top:0px;margin-bottom: 20px;\">Post an On-Demand Shift.</p>\n                \t<a href=\"#\" ng-click=\"vm.setPostType('Ondemand')\" class=\"btn button btn-success\">Switch Posting Type</a>\n                </div>\n                <div class=\"process-status\" ng-if=\"vm.postOptions.value !== 'Sourcing' && !vm.isClone\">\n                \t<label style=\"margin: 18px 0 5px;color: #3b3f43;font-weight: 400;font-family: 'montserratregular';\">Looking to recruit?</label>\n                \t<p style=\"margin-top:0px;margin-bottom: 20px;\">Post your jobs to the Jobble board.</p>\n                \t<a href=\"#\" ng-click=\"vm.setPostType('Sourcing')\" class=\"btn button btn-success\">Switch Posting Type</a>\n                </div>\n                -->\n      </div>\n    </div>\n\n    <div class=\"row\" ng-if=\"vm.step == 3\">\n      <!--------------------- Process Description Start --------------------->\n      <form action=\"\" method=\"post\">\n        <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12 process-description-outer\">\n          <div class=\"process-description\">\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"title-section\">\n                  <h3>{{ vm.event.name}}</h3>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"job-description\" ng-if=\"vm.isSourcingPost\">\n              <div class=\"row\">\n                <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\">\n                  <div class=\"description-heading\">Job Type</div>\n                </div>\n                <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-7\">{{vm.getJobbleTypeName(vm.event.jobble_type)}}</div>\n                <div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-2\">\n                  <!--<a href=\"ondemand-jobdetails.html\"><i class=\"fa fa-pencil-square-o\"></i></a>-->\n                </div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\">\n                  <div class=\"description-heading\">Hourly Rate</div>\n                </div>\n                <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">${{ vm.calcHourlyRate() }}</div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\">\n                  <div class=\"description-heading\">Description</div>\n                </div>\n                <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n                  <span style=\"white-space: pre-wrap\">{{ vm.event.jobble_details }}</span>\n                </div>\n              </div>\n\n              <!--\n                        <div class=\"row\" style=\"margin-top:15px;\">\n                            <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\">\n                            \t<div class=\"description-heading\">Charge</div>\n                            </div>\n                            <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n                            \t<span style=\"white-space:pre-wrap;\">$50.00</span>\n                            </div>\n                        </div>\n                         -->\n            </div>\n\n            <div class=\"job-description\" ng-if=\"!vm.isSourcingPost\">\n              <div class=\"row\">\n                <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\">\n                  <div class=\"description-heading\">Job Type</div>\n                </div>\n                <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-7\">{{vm.getJobbleTypeName(vm.event.jobble_type)}}</div>\n                <div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-2\">\n                  <!--<a href=\"ondemand-jobdetails.html\"><i class=\"fa fa-pencil-square-o\"></i></a>-->\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\">\n                  <div class=\"description-heading\">Dress Code</div>\n                </div>\n                <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">{{vm.event.dress_code}}</div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\">\n                  <div class=\"description-heading\">Hourly Rate</div>\n                </div>\n                <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">${{ vm.calcHourlyRate() }}</div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\">\n                  <div class=\"description-heading\">Openings</div>\n                </div>\n                <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">{{ vm.event.openings }}</div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\">\n                  <div class=\"description-heading\">Description</div>\n                </div>\n                <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n                  <span style=\"white-space: pre-wrap\">{{ vm.event.jobble_details }}</span>\n                </div>\n              </div>\n            </div>\n            <div class=\"border-section\">\n              <div class=\"table-box\">\n                <div class=\"row\">\n                  <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    <div class=\"table-responsive\">\n                      <table class=\"table\">\n                        <thead>\n                          <tr>\n                            <th>Questions</th>\n                            <th></th>\n                          </tr>\n                        </thead>\n                        <tbody>\n                          <tr ng-repeat=\"q in vm.questions track by $index\">\n                            <td>{{ $index+1 }}. {{ q.question }}</td>\n                            <td>\n                              <!--\n\t                                        \t<a href=\"#\">\n\t                                        \t\t<i class=\"fa fa-pencil-square-o\"></i>\n\t                                        \t</a>\n\t                                        \t-->\n                            </td>\n                          </tr>\n                        </tbody>\n                      </table>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"table-box\">\n              <div class=\"row\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                  <div class=\"table-responsive\">\n                    <table class=\"table\">\n                      <thead ng-if=\"!vm.isSourcingPost\">\n                        <tr>\n                          <th>Address</th>\n                          <th>Start date</th>\n                          <th>Start time</th>\n                          <th>Duration</th>\n                        </tr>\n                      </thead>\n                      <thead ng-if=\"vm.isSourcingPost\">\n                        <tr>\n                          <th>Address</th>\n                        </tr>\n                      </thead>\n                      <tbody ng-if=\"vm.isSourcingPost\">\n                        <tr ng-repeat=\"timeInterval in vm.event.timeIntervalsArray\">\n                          <td>{{timeInterval.address}}</td>\n                        </tr>\n                      </tbody>\n\n                      <tbody ng-if=\"!vm.isSourcingPost\">\n                        <tr ng-repeat=\"timeInterval in vm.event.timeIntervalsArray\">\n                          <td>{{timeInterval.address}}</td>\n                          <!--<td ng-if=\"vm.postType == 'source'\">{{timeInterval.posting_duration}} days</td>-->\n                          <td>{{timeInterval.start_date}}</td>\n                          <td>{{timeInterval.start_time}}</td>\n                          <td>{{timeInterval.hours}}h {{timeInterval.minutes}} min</td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"job-description\" ng-if=\"vm.isSourcingPost\">\n              <div class=\"row\" style=\"margin-top: 15px\">\n                <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\">\n                  <div class=\"description-heading\">Charge</div>\n                </div>\n                <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n                  <span style=\"white-space: pre-wrap\">$50.00</span>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n              <div class=\"leftbtn\">\n                <input\n                  type=\"button\"\n                  value=\"Back: Questionnaire\"\n                  class=\"btn button btn-default no-margin-for-button\"\n                  ng-click=\"vm.backToQuestions()\"\n                />\n              </div>\n              <div class=\"rightbtn postbtn\">\n                <a class=\"btn button btn-success\" ng-click=\"vm.postEventLink()\" style=\"margin-top: 0px\" ng-if=\"!vm.isSourcingPost\"> Post </a>\n                <a class=\"btn button btn-success\" ng-click=\"vm.postEventLink()\" ng-if=\"vm.isSourcingPost\" style=\"margin-top: 0px\">\n                  <span ng-if=\"vm.currentUser.company.payByInvoice == true\">Post Job</span>\n                  <span ng-if=\"vm.currentUser.company.undeletedPaymentInfos.length > 0 && vm.currentUser.company.payByInvoice !== true\"\n                    >Post Job</span\n                  >\n                  <span ng-if=\"vm.currentUser.company.undeletedPaymentInfos.length == 0 && vm.currentUser.company.payByInvoice !== true\"\n                    >Payment Info</span\n                  >\n                </a>\n              </div>\n            </div>\n          </div>\n        </div>\n        <!--------------------- Process Status Start --------------------->\n        <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\">\n          <div class=\"process-status\">\n            <img class=\"creation-img-sml\" src=\"/app/vendor/images/connect.png\" ng-if=\"vm.isSourcingPost\" />\n            <img class=\"creation-img-sml\" src=\"/app/vendor/images/ondemand.png\" ng-if=\"!vm.isSourcingPost\" />\n            <h3>Almost done!</h3>\n            <p>Please review all details before publishing your job post.</p>\n          </div>\n          <div class=\"event-team-selection-box\" ng-if=\"$root.teamsSimple.length > 0\" set-class-when-at-top=\"fix-to-top\">\n            <h4>Select team(s)</h4>\n            <p>Post privately to your team(s)</p>\n            <select\n              chosen\n              multiple\n              style=\"width: 95%\"\n              placeholder-text-multiple=\"'Choose teams'\"\n              ng-model=\"vm.event.cloudsForJobblePost\"\n              ng-options=\"team.id as team.name for team in $root.teamsSimple\"\n            >\n              <option value=\"\"></option>\n            </select>\n          </div>\n        </div>\n      </form>\n    </div>\n\n    <div class=\"row\" ng-if=\"vm.step == 5\">\n      <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12 process-description-outer\" ng-if=\"vm.event.isSourcingPost\">\n        <div class=\"process-description\">\n          <div class=\"row\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n              <div class=\"title-section\">\n                <h3>Location</h3>\n                <p>Enter the street address where this Job is located</p>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"form-details form-section clearfix\" ng-repeat=\"timeInterval in vm.event.timeIntervalsArray track by $index\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <label>Address</label>\n                <input\n                  type=\"text\"\n                  class=\"form-control form-input\"\n                  placeholder=\"123 Main Street, Anytown, MA \"\n                  ng-keypress=\"vm.locationKeyPress()\"\n                  ng-model=\"timeInterval.address\"\n                  googleplace\n                />\n              </div>\n            </div>\n\n            <div class=\"add-btn\">\n              <div\n                ng-show=\"vm.displayErrorMessageSecondPage\"\n                style=\"width: 100%; background-color: #f04124; margin-bottom: 10px\"\n                class=\"alert-box alert\"\n              >\n                {{vm.message}}\n              </div>\n              <div ng-show=\"vm.displayErrorMessageThirdPage\" style=\"width: 100%; margin-bottom: 10px\" class=\"alert-box alert\">{{vm.message}}</div>\n              <a href=\"#\" class=\"btn-default\" ng-click=\"vm.submitDateAndLocationLoop(vm.event.timeIntervalsArray)\"> Confirm Location </a>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding-top: 20px\">\n              <div class=\"alert-box alert\" ng-show=\"vm.displayErrorMessageThirdPage\">{{ vm.message }}</div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n            <div class=\"leftbtn\">\n              <input\n                type=\"button\"\n                value=\"Back: Job Details\"\n                class=\"btn button btn-default no-margin-for-button\"\n                ng-click=\"vm.goToEventDetailOther()\"\n              />\n            </div>\n            <div class=\"rightbtn\" ng-if=\"vm.event.timeIntervalsArray.length > 0\">\n              <!--<input type=\"button\" value=\"Next: Add Questions\" class=\"btn button btn-success\" ng-click=\"vm.completeDateAndLocation()\">-->\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12 process-description-outer\" ng-if=\"!vm.event.isSourcingPost\">\n        <div class=\"process-description\">\n          <div class=\"row\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n              <div class=\"title-section\">\n                <h3>Shifts</h3>\n                <p>After you enter your first shift, you have the option to enter more if needed</p>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"form-details form-section clearfix\" ng-repeat=\"timeInterval in vm.event.timeIntervalsArray track by $index\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <label class=\"cloning-label\">\n                  Address\n                  <i\n                    class=\"fa fa-trash cloning-can\"\n                    ng-click=\"vm.removeShiftEdit(timeInterval, $index)\"\n                    ng-hide=\"vm.event.timeIntervalsArray.length == 1\"\n                  ></i>\n                  <i class=\"fa fa-plus cloning-can first-can\" ng-click=\"vm.addShiftEdit(timeInterval, $index)\"></i>\n                </label>\n                <input\n                  type=\"text\"\n                  class=\"form-control form-input\"\n                  placeholder=\"123 Main Street, Anytown, MA\"\n                  ng-model=\"timeInterval.address\"\n                  googleplace\n                />\n              </div>\n              <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12\" ng-if=\"!vm.event.isSourcingPost\">\n                <label>Start date</label>\n                <input\n                  type=\"text\"\n                  class=\"form-control form-input\"\n                  placeholder=\"Select\"\n                  id=\"datepicker{{$index}}\"\n                  name=\"date\"\n                  ng-model=\"timeInterval.start_date\"\n                />\n              </div>\n              <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12\" ng-if=\"!vm.event.isSourcingPost\">\n                <label>Start time</label>\n                <input\n                  type=\"text\"\n                  class=\"form-control form-input timepickerinput\"\n                  placeholder=\"Select\"\n                  id=\"timepicker{{$index}}\"\n                  name=\"time\"\n                  ng-model=\"timeInterval.start_time\"\n                />\n              </div>\n              <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\" ng-if=\"!vm.event.isSourcingPost\">\n                <label>Shift duration</label>\n                <div class=\"row\">\n                  <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                    <div class=\"select-box\">\n                      <select ng-model=\"timeInterval.hours\" ng-options=\"n for n in [] | rangeFilter: 24\" class=\"form-control form-input\"></select>\n                    </div>\n                  </div>\n                  <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                    <!-- \n\t\t\t\t\t\t\t\t\t\t\t<select ng-model=\"vm.currentTimeInterval.minutes\" class=\"form-control form-input\">\n\t\t\t\t\t\t\t\t\t\t\t\t<option value=\"\">Minutes</option>\n\t\t\t\t\t\t\t\t\t\t\t\t<option ng-repeat=\"n in [] | rangeFilterFifteen: 60\" value=\"{{n}}\">{{n}}</option>\n\t\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t\t\t-->\n                    <div class=\"select-box\">\n                      <select\n                        ng-model=\"timeInterval.minutes\"\n                        ng-options=\"n for n in [] | rangeFilterFifteen: 60\"\n                        class=\"form-control form-input\"\n                      ></select>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"add-btn\">\n              <div ng-show=\"vm.displayErrorMessageSecondPageNew\" class=\"alert-box alert\">{{vm.err_result.message}}</div>\n              <div\n                ng-show=\"vm.displayErrorMessageSecondPage\"\n                style=\"width: 100%; background-color: #f04124; margin-bottom: 10px\"\n                class=\"alert-box alert\"\n              >\n                {{vm.message}}\n              </div>\n              <div ng-show=\"vm.displayErrorMessageThirdPage\" style=\"width: 100%; margin-bottom: 10px\" class=\"alert-box alert\">{{vm.message}}</div>\n              <a href=\"\" class=\"btn-default\" ng-click=\"vm.submitDateAndLocationLoop(vm.event.timeIntervalsArray)\"> Save Shift(s) </a>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding-top: 20px\">\n              <div class=\"alert-box alert\" ng-show=\"vm.displayErrorMessageThirdPage\">{{ vm.message }}</div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n            <div class=\"leftbtn\">\n              <input\n                type=\"button\"\n                value=\"Back: Job Details\"\n                class=\"btn button btn-default no-margin-for-button\"\n                ng-click=\"vm.goToEventDetailOther()\"\n              />\n            </div>\n            <div class=\"rightbtn\" ng-if=\"vm.event.timeIntervalsArray.length > 0\">\n              <!--<input type=\"button\" value=\"Next: Add Questions\" class=\"btn button btn-success\" ng-click=\"vm.completeDateAndLocation()\">-->\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\">\n        <div class=\"process-status\">\n          <img class=\"creation-img-sml\" src=\"/app/vendor/images/connect.png\" ng-if=\"vm.isSourcingPost\" />\n          <img class=\"creation-img-sml\" src=\"/app/vendor/images/ondemand.png\" ng-if=\"!vm.isSourcingPost\" />\n          <h3 ng-if=\"vm.isSourcingPost\">Location</h3>\n          <p ng-if=\"vm.isSourcingPost\">Jobblers are nationwide. Enter an address to attract local job seekers</p>\n\n          <h3 ng-if=\"!vm.isSourcingPost\">Date and locations</h3>\n          <p ng-if=\"!vm.isSourcingPost\">Be sure to describe the responsibilities of the job, required work experience, skills, or education.</p>\n        </div>\n      </div>\n    </div>\n\n    <!--\n\t\t  <section class=\"content event\" >\n\t\t    <div class=\"container\">\n\t\t      <div class=\"row\">\n\t\t        <div class=\"col-lg-8 col-md-8 col-sm-7 col-xs-12\">\n\t\t          <div class=\"event-detail odd\">\n\t\t            <h1 style=\"margin-bottom:10px\">Shifts</h1>\n\t\t            <p>Enter details for each shift. Jobs with more than one shift indicate to applicants that they are required to work all shifts associated with the post.</p>\n\t\t            <h3 ng-if=\"vm.isClone\" class=\"clone-banner\">Clone</h3>\n\t\t            <div ng-show=\"vm.displayErrorMessageThirdPage\" style=\"width:100%;\" class=\"alert-box alert\">\n\t\t              {{vm.message}}\n\t\t            </div>\n\t\t            <form ng-submit=\"vm.submitDateAndLocation()\">\n\t\t              <div ng-show=\"vm.displayErrorMessageSecondPage\" style=\"width:100%;background-color:#f04124;\" class=\"alert-box alert\">\n\t\t                {{vm.message}}\n\t\t              </div>\n\t\t              <div class=\"event-form clearfix\" ng-repeat=\"timeInterval in vm.event.timeIntervalsArray track by $index\">\n\t\t                <label>Address</label>\n\t\t                <input type=\"text\" placeholder=\"Enter shift address here\" ng-model=\"timeInterval.address\" googleplace />\n\t\t                <div class=\"event-form clearfix\" ng-if=\"vm.postType == 'source'\" style=\"margin-bottom: 20px;\">\n\t\t                \t<div class=\"col-lg-10 col-md-10 col-sm-10 col-xs-10\" style=\"padding-left: 0px;padding-top:17px;\">\n\t\t                \t\t<label>How many days would you like this posting live on our jobble board? </label>\n\t\t                \t</div>\n\t\t                \t<div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2\" style=\"padding-left:0px;\">\n\t\t\t                \t<label class=\"select-option\" style=\"width:100%;border-bottom:none;\">\n\t\t\t\t                     <select ng-model=\"vm.currentTimeInterval.posting_duration\" ng-options=\"n for n in [] | dayFilter: 61\" style=\"width: 100%;border: 1px solid rgb(225, 225, 225);margin-bottom: 4px;line-height: 32px;padding-left: 18px;\">\n\t\t\t\t                     </select>\n\t\t\t\t                </label>\n\t\t\t\t             </div>\n\t\t                </div>\n\t\t                <div class=\"event-form-column pull-left\" style=\"margin-bottom: 20px;\" ng-if=\"vm.postType == 'regular'\" >\n\t\t                  <div class=\"group clearfix\">\n\t\t                    <div class=\"group-grid pull-left\">\n\t\t                      <label>Start Date</label>\n\t\t                      <input type=\"text\" id=\"datepicker{{$index}}\" name=\"date\" placeholder=\"Select\" ng-model=\"timeInterval.start_date\">\n\t\t                    </div>\n\t\t                    <div class=\"group-grid pull-right\">\n\t\t                      <label>Start Time</label>\n\t\t                      <input type=\"text\" id=\"timepicker{{$index}}\" class=\"timepicker\" name=\"time\" placeholder=\"Select\" ng-model=\"timeInterval.start_time\">\n\t\t                    </div>\n\t\t                  </div>\n\t\t                </div>\n\t\t                <div class=\"event-form-column pull-right\" ng-if=\"vm.postType == 'regular'\">\n\t\t                  <div class=\"group clearfix\">\n\t\t                    <div class=\"group-grid pull-left\">\n\t\t                      <label>Shift Duration</label> \n\t\t                      <label class=\"select-option\">\n\t\t                      \t<select ng-model=\"timeInterval.hours\" ng-options=\"n for n in [] | rangeFilter: 24\"></select>\n\t\t                      </label>\n\t\t                    </div>\n\t\t                    <div class=\"group-grid pull-right\">\n\t\t                      <label>&nbsp;</label>\n\t\t                      <label class=\"select-option\">\n\t\t                      \t<select ng-model=\"timeInterval.minutes\" ng-options=\"n for n in [] | rangeFilter: 60\"></select>\n\t\t                      </label>\n\t\t                    </div>\n\t\t                  </div>\n\t\t                </div>\n\t\t                \n\t\t              </div>\n\t\t              \n\t\t            </form>\n\t\t              \n\t\t             \n\t\t              \t<div class=\"row\" style=\"height: 85px;\">\n\t\t           \t\t\t<div class=\"left-side-button\" ng-if=\"vm.postType == 'regular'\">\n\t\t\t\t            \t<a href=\"\" ng-click=\"vm.goToEventDetailOther()\">&#xab; Back: Job Details</a>\n\t\t        \t    \t</div>\n\t\t        \t   \t \t<div class=\"left-side-button\" ng-if=\"vm.postType == 'source'\">\n\t\t\t\t            \t<a href=\"\" ng-click=\"vm.goToEventDetailOther()\">&#xab; Back: Job Details</a>\n\t\t        \t    \t</div>\n\t\t        \t    \t<div class=\"right-side-button\">\n\t\t        \t    \t\t<input type=\"button\" value=\"Save shift(s)\" ng-click=\"vm.submitDateAndLocationLoop(vm.event.timeIntervalsArray)\" ng-if=\"vm.postType == 'regular'\">\n\t\t        \t    \t\t<input type=\"button\"  value=\"Save Location\" ng-click=\"vm.submitDateAndLocationLoop(vm.event.timeIntervalsArray)\" ng-if=\"vm.postType == 'source'\">    \n\t\t        \t    \t</div>\n\t\t          \t\t</div>\n\t\t              \n\t\t              \n\t\t          </div>\n\t\t        </div>\n\t\t        <div class=\"col-lg-4 col-md-4 col-sm-5 col-xs-12\">\n\t\t          <div class=\"event-detail-box\" ng-if=\"vm.postType == 'regular'\">\n\t\t            <img src=\"/app/vendor/images/connect.png\" style=\"width:72px\" ng-if=\"vm.postType == 'source'\"/>\n\t\t\t\t    <img src=\"/app/vendor/images/ondemand.png\" style=\"width:72px\" ng-if=\"vm.postType == 'regular'\"/>\n\t\t            <h2>Date and <br> locations</h2>\n\t\t            <em></em>\n\t\t            <p>Edit, delete or add more dates and locations for your job</p>\n\t\t          </div>\n\t\t          <div class=\"event-detail-box\" ng-if=\"vm.postType == 'source'\">\n\t\t            <img src=\"/app/vendor/images/connect.png\" style=\"width:72px\" ng-if=\"vm.postType == 'source'\"/>\n\t\t\t\t    <img src=\"/app/vendor/images/ondemand.png\" style=\"width:72px\" ng-if=\"vm.postType == 'regular'\"/>\n\t\t            <h2>Location</h2>\n\t\t            <em></em>\n\t\t            <p>Your posting will be visible to Jobblers within a 50 mile radius of the address you've selected.</p>\n\t\t          </div>\n\t\t        </div>\n\t\t      </div>\n\t\t    </div>\n\t\t  </section>\n\t\t  -->\n\n    <div class=\"row\" ng-if=\"vm.step == 1\">\n      <!--------------------- Process Description Start --------------------->\n      <form ng-submit=\"vm.submitLocation()\">\n        <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12 process-description-outer\" ng-if=\"vm.isSourcingPost\">\n          <div class=\"process-description\">\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"title-section\">\n                  <h3>Location</h3>\n                  <p>Enter the street address where this Job is located</p>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"form-details form-section clearfix\">\n                <div ng-show=\"vm.displayErrorMessageSecondPage\" class=\"alert-box alert\">{{vm.message}}</div>\n\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                  <label>Address</label>\n                  <input\n                    type=\"text\"\n                    class=\"form-control form-input\"\n                    placeholder=\"123 Main Street, Anytown, MA\"\n                    ng-model=\"vm.currentTimeInterval.address\"\n                    googleplace\n                  />\n                </div>\n              </div>\n\n              <div class=\"add-btn\">\n                <a href=\"#\" class=\"btn-default\" ng-click=\"vm.submitDateAndLocation()\"> Confirm Location </a>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n              <div class=\"leftbtn\">\n                <input\n                  type=\"button\"\n                  value=\"Back: Job Details\"\n                  class=\"btn button btn-default no-margin-for-button\"\n                  ng-click=\"vm.gotoEventDetailStep()\"\n                />\n              </div>\n\n              <div class=\"rightbtn\" ng-if=\"vm.timeIntervalsArray.length > 0\">\n                <input type=\"button\" value=\"Next: Teams\" class=\"btn button btn-success\" onclick=\"location.href='ondemand-team.html'\" />\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12 process-description-outer\" ng-if=\"!vm.isSourcingPost\">\n          <div class=\"process-description\">\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"title-section\">\n                  <h3>Shifts</h3>\n                  <p>After you enter your first shift, you have the option to enter more if needed</p>\n                </div>\n              </div>\n            </div>\n            <div class=\"row\" ng-if=\"vm.showAllShifts\">\n              <div class=\"table-box\">\n                <div class=\"table-responsive\" style=\"padding-left: 9px; padding-top: 15px\">\n                  <table class=\"table\">\n                    <thead class=\"shift-list-header-creation\">\n                      <tr>\n                        <th>Address</th>\n                        <th>Start date</th>\n                        <th>Start time</th>\n                        <th>Duration</th>\n                        <th style=\"width: 41px\"></th>\n                        <th style=\"width: 41px\"></th>\n                        <th style=\"width: 41px\"></th>\n                      </tr>\n                    </thead>\n                    <tbody>\n                      <tr\n                        ng-repeat=\"timeInterval in vm.event.timeIntervalsArray track by $index\"\n                        ng-class=\"{ 'time-interval-overlapping' : timeInterval.isOverlapping == true, 'active-shift-editing' : timeInterval.isBeingEdited == true }\"\n                      >\n                        <td>{{timeInterval.address}}</td>\n                        <td>{{timeInterval.start_date}}</td>\n                        <td>{{timeInterval.start_time}}</td>\n                        <td>{{timeInterval.hours}}hr {{timeInterval.minutes}} min</td>\n                        <td>\n                          <a href=\"\" ng-if=\"vm.event.timeIntervalsArray.length > 1\" ng-click=\"vm.removeInterval(timeInterval, $index)\">\n                            <i class=\"fa fa-trash\"></i>\n                          </a>\n                        </td>\n                        <td>\n                          <a ng-click=\"vm.editInterval(timeInterval, $index)\">\n                            <i class=\"fa fa-pencil-square-o\" title=\"Edit shift\"> </i>\n                          </a>\n                        </td>\n                        <td>\n                          <a ng-click=\"vm.cloneInterval(timeInterval)\">\n                            <i class=\"fa fa-clone\" title=\"Clone shift\"> </i>\n                          </a>\n                        </td>\n                      </tr>\n                    </tbody>\n                  </table>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"form-details form-section clearfix\" ng-class=\"{ 'editing-on-creation' : vm.shiftIsBeingEdited ==  true }\">\n                  <div ng-show=\"vm.displayErrorMessageSecondPage\" class=\"alert-box alert\">{{vm.message}}</div>\n\n                  <!--\n\t\t\t\t\t\t\t\t\t<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n\t\t\t\t\t\t\t\t\t\t<p \n\t\t\t\t\t\t\t\t\t\t\tng-if=\"vm.shiftIsBeingEdited\" \n\t\t\t\t\t\t\t\t\t\t\tclass=\"\tediting-shifts-wording\">Editing Highlighted Shift</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t-->\n\n                  <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    <label style=\"margin-top: 5px\">Address</label>\n                    <input\n                      type=\"text\"\n                      ng-if=\"vm.googleIsDoneLoading\"\n                      class=\"form-control form-input\"\n                      placeholder=\"123 Main Street, Anytown, MA \"\n                      ng-model=\"vm.currentTimeInterval.address_temp\"\n                      ng-change=\"vm.addressChanging()\"\n                      googleplace\n                    />\n                  </div>\n                  <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12\">\n                    <label>Start date</label>\n                    <input\n                      type=\"text\"\n                      class=\"form-control form-input\"\n                      placeholder=\"Select\"\n                      id=\"datepicker\"\n                      name=\"date\"\n                      ng-model=\"vm.currentTimeInterval.start_date\"\n                    />\n                  </div>\n                  <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12\">\n                    <label>Start time</label>\n                    <input\n                      type=\"text\"\n                      class=\"form-control form-input timepickerinput\"\n                      placeholder=\"Select\"\n                      id=\"timepicker\"\n                      name=\"time\"\n                      ng-model=\"vm.currentTimeInterval.start_time\"\n                    />\n                  </div>\n                  <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\">\n                    <label>Shift duration</label>\n                    <div class=\"row\">\n                      <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                        <div class=\"select-box\">\n                          <select ng-model=\"vm.currentTimeInterval.hours\" class=\"form-control form-input\">\n                            <option value=\"\">Hours</option>\n                            <option ng-repeat=\"n in [] | rangeFilter: 24\" value=\"{{n}}\">{{n}}</option>\n                          </select>\n                        </div>\n                      </div>\n                      <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                        <div class=\"select-box\">\n                          <select ng-model=\"vm.currentTimeInterval.minutes\" class=\"form-control form-input\">\n                            <option value=\"\">Minutes</option>\n                            <option ng-repeat=\"n in [] | rangeFilterFifteen: 60\" value=\"{{n}}\">{{n}}</option>\n                          </select>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                <div class=\"add-btn\" ng-if=\"vm.showAllShifts\">\n                  <a href=\"#\" class=\"btn-danger\" ng-click=\"vm.cancelAddShift()\"> Cancel </a>\n                </div>\n              </div>\n              <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                <div class=\"add-btn\">\n                  <a href=\"#\" class=\"btn-default\" ng-click=\"vm.submitDateAndLocation()\"> Save Shift </a>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n              <div class=\"leftbtn\">\n                <input\n                  type=\"button\"\n                  value=\"Back: Job Details\"\n                  class=\"btn button btn-default no-margin-for-button\"\n                  ng-click=\"vm.gotoEventDetailStep()\"\n                />\n              </div>\n\n              <div class=\"rightbtn\" ng-if=\"vm.timeIntervalsArray.length > 0\">\n                <input type=\"button\" value=\"Next: Teams\" class=\"btn button btn-success\" onclick=\"location.href='ondemand-team.html'\" />\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <!--------------------- Process Status Start --------------------->\n        <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\">\n          <div class=\"process-status\">\n            <img class=\"creation-img-sml\" src=\"/app/vendor/images/connect.png\" ng-if=\"vm.isSourcingPost\" />\n            <img class=\"creation-img-sml\" src=\"/app/vendor/images/ondemand.png\" ng-if=\"!vm.isSourcingPost\" />\n            <h3 ng-if=\"vm.isSourcingPost\">Location</h3>\n            <p ng-if=\"vm.isSourcingPost\">Jobblers are nationwide. Enter an address to attract local job seekers</p>\n\n            <h3 ng-if=\"!vm.isSourcingPost\">Date and locations</h3>\n            <p ng-if=\"!vm.isSourcingPost\">Be sure to describe the responsibilities of the job, required work experience, skills, or education.</p>\n          </div>\n        </div>\n      </form>\n    </div>\n\n    <div class=\"row\" ng-if=\"vm.step == 2\">\n      <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12 process-description-outer\">\n        <div class=\"process-description\">\n          <div class=\"row\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n              <div class=\"title-section\" ng-if=\"!vm.isSourcingPost\">\n                <h3>Shifts</h3>\n                <p>After you enter your first shift, you have the option to enter more if needed</p>\n              </div>\n\n              <div class=\"title-section\" ng-if=\"vm.isSourcingPost\">\n                <h3>Location</h3>\n                <p>Enter the street address where this Job is located</p>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"table-box\">\n              <div class=\"table-responsive\" style=\"padding-left: 9px; padding-top: 15px\">\n                <table class=\"table\">\n                  <thead ng-if=\"vm.isSourcingPost\">\n                    <tr>\n                      <th>Address</th>\n                      <th></th>\n                    </tr>\n                  </thead>\n\n                  <tbody ng-if=\"vm.isSourcingPost\">\n                    <tr\n                      ng-repeat=\"timeInterval in vm.event.timeIntervalsArray track by $index\"\n                      ng-class=\"{ 'time-interval-overlapping' : timeInterval.isOverlapping == true }\"\n                    >\n                      <td>{{timeInterval.address}}</td>\n\n                      <td>\n                        <a ng-click=\"vm.editInterval(timeInterval)\">\n                          <i class=\"fa fa-pencil-square-o\"></i>\n                        </a>\n                      </td>\n                    </tr>\n                  </tbody>\n\n                  <thead ng-if=\"!vm.isSourcingPost\" class=\"shift-list-header-creation\">\n                    <tr>\n                      <th>Address</th>\n                      <th>Start date</th>\n                      <th>Start time</th>\n                      <th>Duration</th>\n                      <th style=\"width: 41px\"></th>\n                      <th style=\"width: 41px\"></th>\n                      <th style=\"width: 41px\"></th>\n                    </tr>\n                  </thead>\n\n                  <tbody ng-if=\"!vm.isSourcingPost\">\n                    <tr\n                      ng-repeat=\"timeInterval in vm.event.timeIntervalsArray track by $index\"\n                      ng-class=\"{ 'time-interval-overlapping' : timeInterval.isOverlapping == true }\"\n                    >\n                      <td>{{timeInterval.address}}</td>\n                      <td>{{timeInterval.start_date}}</td>\n                      <td>{{timeInterval.start_time}}</td>\n                      <td>{{timeInterval.hours}}hr {{timeInterval.minutes}} min</td>\n                      <td>\n                        <a href=\"\" ng-if=\"vm.event.timeIntervalsArray.length > 1\" ng-click=\"vm.removeInterval(timeInterval, $index)\">\n                          <i class=\"fa fa-trash\"></i>\n                        </a>\n                      </td>\n                      <td>\n                        <a ng-click=\"vm.editInterval(timeInterval, $index)\">\n                          <i class=\"fa fa-pencil-square-o\" title=\"Edit shift\"> </i>\n                        </a>\n                      </td>\n                      <td>\n                        <a ng-click=\"vm.cloneInterval(timeInterval)\">\n                          <i class=\"fa fa-clone\" title=\"Clone shift\"> </i>\n                        </a>\n                      </td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div>\n            <div class=\"add-btn\" style=\"margin-top: 35px\">\n              <a href=\"#\" class=\"btn-default\" ng-click=\"vm.addInterval()\" ng-if=\"!vm.isSourcingPost\"> Add Shift </a>\n              <!--<a href=\"#\" class=\"btn-default\" ng-click=\"vm.addInterval()\" ng-if=\"vm.isSourcingPost\">Edit Location</a>-->\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding-top: 20px\">\n              <div class=\"alert-box alert\" ng-show=\"vm.displayErrorMessageThirdPage\">{{ vm.message }}</div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n            <div class=\"leftbtn\">\n              <input\n                type=\"button\"\n                value=\"Back: Job Details\"\n                class=\"btn button btn-default no-margin-for-button\"\n                ng-click=\"vm.gotoEventDetailStep()\"\n              />\n            </div>\n            <div class=\"rightbtn\" ng-if=\"vm.event.timeIntervalsArray.length > 0\">\n              <input\n                type=\"button\"\n                value=\"Next: Questionnaire\"\n                class=\"btn button btn-success no-margin-for-button\"\n                ng-click=\"vm.completeDateAndLocation()\"\n              />\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\">\n        <div class=\"process-status\">\n          <img class=\"creation-img-sml\" src=\"/app/vendor/images/connect.png\" ng-if=\"vm.isSourcingPost\" />\n          <img class=\"creation-img-sml\" src=\"/app/vendor/images/ondemand.png\" ng-if=\"!vm.isSourcingPost\" />\n          <h3 ng-if=\"vm.isSourcingPost\">Location</h3>\n          <p ng-if=\"vm.isSourcingPost\">Jobblers are nationwide. Enter an address to attract local job seekers</p>\n\n          <h3 ng-if=\"!vm.isSourcingPost\">Date and locations</h3>\n          <p ng-if=\"!vm.isSourcingPost\">Be sure to describe the responsibilities of the job, required work experience, skills, or education.</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div\n  class=\"modal fade in\"\n  id=\"choose-post-type\"\n  tabindex=\"-1\"\n  role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\"\n  data-backdrop=\"static\"\n  style=\"display: none\"\n>\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header popup-header\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" style=\"color: #fff\"></i>\n            </button>\n\n            <h3 class=\"modal-title\">\n              Please select a preferred posting type\n              <!--Most people start by selecting a preferred posting type-->\n            </h3>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\">\n                <div class=\"post-type-options left\" ng-click=\"vm.selectPostType(2)\">\n                  <div class=\"image-wrapper-choice\">\n                    <h5 class=\"modal-listing-title\">On-demand</h5>\n                    <img src=\"/app/vendor/images/ondemand.png\" style=\"width: 72px; margin-bottom: 10px\" />\n                  </div>\n                  <ul class=\"modal-listing\">\n                    <li>A flexible hiring tool for gigs, shifts or temporary work</li>\n                    <li>Hire, pay and manage qualified workers ALL in one place</li>\n                    <li>Set your hourly rate (fees are built in)</li>\n                    <li>Pay your staff directly though Jobble after a job well done</li>\n                  </ul>\n                  <div class=\"bottom-holder\">\n                    <a href=\"\" class=\"btn button btn-success\" style=\"background-color: #337ab7\">Pay Per Shift</a>\n                  </div>\n                </div>\n              </div>\n              <!--\n          \t\t<div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\">\n          \t\t\t<div class=\"post-type-options right\" ng-click=\"vm.selectPostType(1)\">\n          \t\t\t\t<div class=\"image-wrapper-choice\">\n          \t\t\t\t\t<h5 class=\"modal-listing-title\">Recruit</h5>\n          \t\t\t\t\t<img src=\"/app/vendor/images/connect.png\" style=\"width:72px;margin-bottom: 10px;\" />\n          \t\t\t\t</div>\n          \t\t\t\t<ul class=\"modal-listing\">\n          \t\t\t\t\t<li>A simple recruiting tool for part-time or full-time jobs</li>\n\t\t\t\t\t\t\t<li>30 Day Listing - Unlimited Applicants</li>\n\t\t\t\t\t\t\t<li>$50/post</li>\n\t\t\t\t\t\t\t<li>Pay for quality candidates interested in working for you</li>\n          \t\t\t\t</ul>\n          \t\t\t\t<div class=\"bottom-holder\">\n\t\t\t\t\t\t\t<a href=\"\" class=\"btn button btn-success\" style=\"background-color:#FF6910;\">Pay Per Post</a>\n\t\t\t\t\t\t</div>\n          \t\t\t</div>\n          \t\t</div>\n          \t\t-->\n              <div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\">\n                <div class=\"post-type-options right\" ng-click=\"vm.selectPostType(3)\">\n                  <div class=\"image-wrapper-choice\">\n                    <h5 class=\"modal-listing-title\">Delivery</h5>\n                    <img src=\"/app/vendor/images/delivery_icon.png\" style=\"width: 72px; margin-bottom: 10px\" />\n                  </div>\n                  <ul class=\"modal-listing\">\n                    <li>Simple posts catered to delivery services</li>\n                    <li>Organize, manage and execute delivery jobs</li>\n                    <li>Leverage our pool of thousands of qualified drivers</li>\n                    <li>Pay as deliveries are completed</li>\n                  </ul>\n                  <div class=\"bottom-holder\">\n                    <a href=\"\" class=\"btn button btn-success\" style=\"background-color: #74cf59\">Delivery</a>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <!--\n          \t<div class=\"row hide-at-resp\">\n          \t\t<div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n          \t\t\t<a href=\"\" class=\"btn button btn-success\" ng-click=\"vm.selectPostType(2)\">Pay Per Shift</a>\n          \t\t</div>\n          \t\t\n          \t\t<div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" ng-click=\"vm.selectPostType(1)\">\n          \t\t\t<a href=\"\" class=\"btn button btn-success\" style=\"background-color:#FF6910;\">Pay Per Post</a>\n          \t\t</div>\n          \t</div>\n          \t-->\n          </div>\n          <!--\n          <div class=\"modal-footer\">\n          \t<p>footer</p>\n          </div>\n          -->\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<jobblefooter></jobblefooter>\n\n<a href=\"#modal-post-event\" data-toggle=\"modal\" id=\"modal-post-event-link\"></a>\n<div class=\"modal fade\" id=\"modal-post-event\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <span aria-hidden=\"true\">&times;</span>\n            </button>\n            <h4 class=\"modal-title\">Post Your Job</h4>\n          </div>\n          <div class=\"modal-body\">\n            <p ng-if=\"vm.isSourcingPost==true && vm.currentUser.company.payByInvoice==true\">\n              You are attempting to post a sourcing post as an \"Invoice\" customer. By publishing this job you will be charged $50.00 USD.\n            </p>\n            <!--\n          \t<p ng-if=\"vm.event.cloudsForJobblePost.length > 0\">Once your job is posted, only the jobblers in your selected teams will be able to apply.</p>\n            <p ng-if=\"vm.event.cloudsForJobblePost.length == 0\">By posting this job, all the jobblers in that area will be able to apply.</p>\n            -->\n            <!--\n            <p ng-if=\"vm.teams.length > 0\">You can post this job to all available Jobblers, or post directly to your Teams.</p>\n            <p ng-if=\"vm.teams.length == 0\">By posting this job, all the jobblers in that area will be able to apply.</p>\n            -->\n            <div class=\"clearfix\">\n              <a class=\"btn button btn-success\" href=\"\" ng-if=\"vm.isSourcingPost\" ng-click=\"vm.charge()\" style=\"font-size: 20px; text-align: center\">\n                Post Job\n              </a>\n              <a class=\"btn button btn-success go-to-dashboard\" href=\"\" ng-if=\"!vm.isSourcingPost\" ng-click=\"vm.postCreateEvent(1,false)\">\n                Post Job And Return to Dashboard\n              </a>\n\n              <a class=\"btn button btn-success go-to-dashboard\" href=\"\" ng-if=\"!vm.isSourcingPost\" ng-click=\"vm.postCreateEvent(1,true)\">\n                Post Job And View Job Details\n              </a>\n              <!--\n              <a \n              \tclass=\"btn button btn-success go-to-dashboard-bottom\" \n              \thref=\"\"\n              \tng-if=\"!vm.isSourcingPost\"\n              \tng-click=\"vm.postCreateEvent(2)\" >\n              \t\tPost Job -> Go To Job Page\n              </a>\n              -->\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"global-modal-confirmation\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <span aria-hidden=\"true\">&times;</span>\n            </button>\n            <h4 class=\"modal-title\">Post Your Job</h4>\n          </div>\n          <div class=\"modal-body\">\n            <p ng-if=\"vm.teams.length > 0\">You can post this job to all available Jobblers, or post directly to your Teams.</p>\n            <p ng-if=\"vm.teams.length == 0\">By posting this job, all the jobblers in that area will be able to apply.</p>\n            <div class=\"clearfix\">\n              <a class=\"btn\" href=\"#modal-post-your-event\" data-toggle=\"modal\" class=\"select-team\" ng-if=\"vm.teams.length > 0\">Select Teams</a>\n              <a class=\"btn button btn-success\" href=\"\" ng-click=\"vm.postCreateEvent()\">Post Job</a>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"modal-post-your-event\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <span aria-hidden=\"true\">&times;</span>\n            </button>\n            <h4 class=\"modal-title\">Post Your Job</h4>\n          </div>\n          <div class=\"modal-body\">\n            <p>Choose team (s) to post your job to.</p>\n            <p>\n              Make sure to select the \"Make job private to your selected teams only\" button at the bottom. If that button is not selected, your\n              posting will be viewable to the public.\n            </p>\n            <div ng-show=\"vm.displaySelectACloudError\" style=\"width: 100%\" class=\"alert-box alert\">\n              You have selected to make this job private. Please select a cloud(s).\n            </div>\n            <div class=\"select-item\" ng-repeat=\"team in vm.teams\">\n              <input type=\"checkbox\" ng-model=\"team.checked\" ng-click=\"vm.collectClouds()\" />\n              <label ng-if=\"team.numberOfUsers > 1\">{{team.name}} ({{team.numberOfUsers}} Jobblers)</label>\n              <label ng-if=\"team.numberOfUsers <= 1\">{{team.name}} ({{team.numberOfUsers}} Jobbler)</label>\n              <span ng-if=\"team.numberOfUsers > 1\">{{team.name}} ({{team.numberOfUsers}} Jobblers)</span>\n              <span ng-if=\"team.numberOfUsers <= 1\">{{team.name}} ({{team.numberOfUsers}} Jobbler)</span>\n            </div>\n            <hr />\n            <div class=\"select-item\">\n              <input type=\"checkbox\" ng-model=\"vm.event.postIsPrivate\" />\n              <label>Make job private to your selected teams only</label>\n              <span>Make job private to your selected teams only</span>\n            </div>\n            <a class=\"btn button btn-success\" href=\"\" ng-click=\"vm.postCreateEvent()\">Post to Teams</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<globalalert></globalalert>\n<paymentdialog></paymentdialog>\n<globalmodal></globalmodal>\n\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _teams = __webpack_require__(563);
	
	var _teams2 = _interopRequireDefault(_teams);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PosteventController = function () {
	  function PosteventController($http, $localStorage, $state, $stateParams, AuthService, EnvService, TeamsService, CompaniesService, SecurityService, $filter, EventsService, $timeout, $location, $rootScope, $scope, TrackingService) {
	    _classCallCheck(this, PosteventController);
	
	    this.name = "postevent";
	
	    $localStorage.activeStateName = "postevent";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$scope = $scope;
	    this.$env = EnvService;
	    this.$location = $location;
	    this.$rootScope = $rootScope;
	    this.$teams = TeamsService;
	    this.$companies = CompaniesService;
	    this.$security = SecurityService;
	    this.$filter = $filter;
	    this.$stateParams = $stateParams;
	    this.$events = EventsService;
	    this.shiftIsBeingEdited = false;
	    this.$timeout = $timeout;
	    this.showAllShifts = false;
	    this.currentUser = this.$auth.getUserData();
	    this.timeIntervalsArrayTemp = [];
	    this.isClone = null;
	    this.logo = null;
	    this.ismarketing = false;
	    this.googleIsDoneLoading = false;
	    this.gtmData = null;
	    this.arrayOfStatus = [];
	    this.postType = "regular";
	    this.isSourcingPost = false;
	    this.saving = false;
	    this.step = 0;
	    this.sessionObj = {};
	    this.tempEventHolderForSwitchingDuringClones = [];
	    this.event_types = [];
	    this.blockShiftClone = false;
	    this.event_type = "";
	    this.draftHasBeenCreated = false;
	    this.jobble_types = [];
	    this.teams = [];
	    this.openingsList = { value: 1, values: [] };
	    this.postOptions = {
	      value: "On-demand",
	      values: ["On-demand", "Sourcing"]
	    };
	    this.mapsKey = null;
	    this.postingLink = false;
	    this.displaySelectACloudError = false;
	    this.$tracking = TrackingService;
	    this.currentAction = "";
	    this.setPaymentPlan();
	    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
	    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;
	    this.remain_loading_count = 1;
	    this.displayFirstPageErrorMessage = false;
	    this.tracker = {
	      currentStep: 0,
	      previousStep: null,
	      nextStep: null,
	      arrayOfVistedSteps: [0]
	    };
	    this.hasbeenvisited = [0];
	    this.prevStep = 0;
	    this.state = ["California", "Arizona"];
	    this.states = ["Alaska", "Arizona", "Arkansas", "California"];
	    this.setPostTypeInit();
	    this.checkForAdmin();
	    this.checkGoogle();
	    this.statusBarStatus = {
	      step_2: {
	        visited: false,
	        bar_class: "app-progress-bar",
	        dot_class: "select"
	      },
	      step_3: {
	        visited: false,
	        bar_class: "app-progress-bar",
	        dot_class: "select"
	      },
	      step_4: {
	        visited: false,
	        bar_class: "app-progress-bar",
	        dot_class: "select"
	      },
	      step_5: {
	        visited: false,
	        bar_class: "app-progress-bar",
	        dot_class: "select"
	      }
	    };
	
	    this.check_for_state_params();
	
	    //this.postEventLink();
	
	    this.event = {
	      name: "",
	      event_type: 1,
	      jobble_type: "",
	      jobble_type_name: "",
	      dress_code: null,
	      hourly_rate: "",
	      openings: 1,
	      manager: null,
	      jobble_details: null,
	      postIsPrivate: false,
	      cloudsForJobblePost: [],
	      timeIntervalsArray: [{
	        address: "",
	        start_date: "",
	        start_time: "",
	        hours: "",
	        minutes: "",
	        posting_duration: ""
	      }]
	    };
	
	    //this.event={"name":"Test","event_type":1,"jobble_type":4,"jobble_type_name":"","dress_code":"Casual","hourly_rate":"25","openings":1,"manager":4519,"jobble_details":"Test","postIsPrivate":false,"cloudsForJobblePost":[],"timeIntervalsArray":[{"address":"","start_date":"","start_time":"","hours":"","minutes":"","posting_duration":""}],"hourly_rate_adj":"20.00"}
	
	    console.log("current user");
	    console.dir(this.currentUser);
	
	    this.currentTimeInterval = this.event.timeIntervalsArray[0];
	
	    var _this = this;
	
	    for (var i = 0; i < 500; i++) {
	      _this.openingsList.values.push(i + 1);
	    }
	
	    _this.$timeout(function () {
	      jQuery("#modal-post-your-event").trigger("click");
	    });
	
	    if (this.$rootScope.jobble_types) {
	      _this.jobble_types = this.$rootScope.jobble_types;
	      _this.$auth.getJobbleTypes().then(function (data) {
	        _this.jobble_types = data.data;
	      });
	      if (_this.$location.$$search.eid) {
	        var tempTimeArray = [];
	        _this.isClone = true;
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetLoaderDialog", {
	            type: 12,
	            total: 1
	          });
	        });
	        _this.remain_loading_count = 1;
	        _this.$events.getEventByIdTrimmed(_this.$location.$$search.eid, 1).then(function (eventResp) {
	          _this.eventResponse = eventResp.data;
	          _this.event.isClone = true;
	          if (_this.eventResponse.isSourcingPost) {
	            _this.postType = "source";
	            _this.event.isSourcingPost = true;
	            _this.isSourcingPost = true;
	          } else {
	            _this.postType = "regular";
	            _this.event.isSourcingPost = false;
	            _this.isSourcingPost = false;
	          }
	          try {
	            eventResp.data.subEvents[0].deduppedJobbles[0].shifts.forEach(function (shift) {
	              var tempTimeObj = {};
	              tempTimeObj.contactInfo = {};
	              tempTimeObj.address = shift.contactInfo.streetLine1 + " " + shift.contactInfo.city + " " + shift.contactInfo.state + " " + shift.contactInfo.zipCode;
	              tempTimeObj.start_time = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
	              tempTimeObj.start_date = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("MMM DD, YYYY");
	              tempTimeObj.contactInfo.streetLine1 = shift.contactInfo.streetLine1;
	              tempTimeObj.contactInfo.state = shift.contactInfo.state;
	              tempTimeObj.contactInfo.city = shift.contactInfo.city;
	              tempTimeObj.contactInfo.zipCode = shift.contactInfo.zipCode;
	              tempTimeObj.contactInfo.lat = shift.contactInfo.lat;
	              tempTimeObj.contactInfo.lng = shift.contactInfo.lng;
	              var diffmin = moment(shift.timeInterval.endTime).diff(shift.timeInterval.startTime, "minutes");
	              var diffhour = Math.floor(diffmin / 60);
	              tempTimeObj.hours = diffhour;
	              tempTimeObj.minutes = diffmin % 60;
	              tempTimeArray.push(tempTimeObj);
	            });
	          } finally {
	            _this.event.timeIntervalsArray = tempTimeArray;
	            _this.event.name = eventResp.data.name;
	            _this.event.dress_code = eventResp.data.subEvents[0].deduppedJobbles[0].dressCode;
	            _this.event.hourly_rate = (eventResp.data.subEvents[0].deduppedJobbles[0].payPerHour / 100).toString();
	            _this.calcNumbers();
	            _this.openingsList.value = eventResp.data.numberOfOpenings + eventResp.data.numberOfApprovedApplications;
	            _this.event.openings = _this.openingsList.value;
	            _this.event.jobble_details = eventResp.data.description;
	            _this.event.event_type = eventResp.data.eventTypeId;
	            _this.event.jobble_type = eventResp.data.subEvents[0].deduppedJobbles[0].jobbleType.id;
	            _this.event.postIsPrivate = false;
	            _this.step = 0;
	            _this.event.cloudsForJobblePost = [];
	            _this.remain_loading_count = 0;
	            _this.determineIfPublished(eventResp);
	            _this.determineIfPrivate(eventResp);
	            _this.determineJobbleType();
	            if (eventResp.data.subEvents[0].deduppedJobbles[0].manager) {
	              var manager_id = eventResp.data.subEvents[0].deduppedJobbles[0].manager.id;
	              _this.event.manager = manager_id;
	              _this.$timeout(function () {
	                _this.$rootScope.$emit("SetManagerFromBack", {
	                  id: _this.event.manager
	                });
	              });
	            }
	            _this.$timeout(function () {
	              _this.$rootScope.$emit("SetLoaderDialog", {
	                type: 0,
	                total: 1
	              });
	            });
	          }
	        });
	      } else {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetLoaderDialog", {
	            type: 0,
	            total: 1
	          });
	        });
	        _this.$timeout(function () {
	          _this.remain_loading_count = 0;
	        }, 300);
	      }
	      if (_this.$stateParams.jobType && _this.$stateParams.openings && _this.$stateParams.pay) {
	        _this.event.hourly_rate = _this.$stateParams.pay;
	        _this.event.openings = _this.$stateParams.openings;
	        _this.openingsList.value = parseInt(_this.$stateParams.openings, 10);
	        for (var i = 0; i < data.data.length; i++) {
	          if (data.data[i].name === _this.$stateParams.jobType) {
	            _this.event.jobble_type = data.data[i].id;
	            break;
	          }
	        }
	      }
	      if (_this.$stateParams.t) {
	        _this.map_state_params_to_fields();
	      }
	    } else {
	      _this.remain_loading_count = 1;
	      var loadingCount = 0;
	      if (_this.$location.$$search.eid) {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetLoaderDialog", {
	            type: 13,
	            total: 2
	          });
	        });
	      } else {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetLoaderDialog", {
	            type: 13,
	            total: 1
	          });
	        });
	      }
	      _this.$auth.getJobbleTypes().then(function (data) {
	        _this.$rootScope.jobble_types = data.data;
	        _this.jobble_types = data.data;
	        if (_this.$location.$$search.eid) {
	          var tempTimeArray = [];
	          _this.isClone = true;
	          _this.$events.getEventByIdTrimmed(_this.$location.$$search.eid, 1).then(function (eventResp) {
	            _this.eventResponse = eventResp.data;
	            if (_this.eventResponse.isSourcingPost) {
	              _this.postType = "source";
	              _this.event.isSourcingPost = true;
	              _this.isSourcingPost = true;
	            } else {
	              _this.postType = "regular";
	              _this.event.isSourcingPost = false;
	              _this.isSourcingPost = false;
	            }
	            _this.event.isClone = true;
	            try {
	              eventResp.data.subEvents[0].deduppedJobbles[0].shifts.forEach(function (shift) {
	                var tempTimeObj = {};
	                tempTimeObj.contactInfo = {};
	                tempTimeObj.address = shift.contactInfo.streetLine1 + " " + shift.contactInfo.city + " " + shift.contactInfo.state + " " + shift.contactInfo.zipCode;
	                tempTimeObj.start_time = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
	                tempTimeObj.start_date = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("MMM DD, YYYY");
	                tempTimeObj.contactInfo.streetLine1 = shift.contactInfo.streetLine1;
	                tempTimeObj.contactInfo.state = shift.contactInfo.state;
	                tempTimeObj.contactInfo.city = shift.contactInfo.city;
	                tempTimeObj.contactInfo.zipCode = shift.contactInfo.zipCode;
	                tempTimeObj.contactInfo.lat = shift.contactInfo.lat;
	                tempTimeObj.contactInfo.lng = shift.contactInfo.lng;
	                var diffmin = moment(shift.timeInterval.endTime).diff(shift.timeInterval.startTime, "minutes");
	                var diffhour = Math.floor(diffmin / 60);
	                tempTimeObj.hours = diffhour;
	                tempTimeObj.minutes = diffmin % 60;
	                tempTimeArray.push(tempTimeObj);
	              });
	            } finally {
	              _this.event.timeIntervalsArray = tempTimeArray;
	              _this.event.name = eventResp.data.name;
	              _this.event.dress_code = eventResp.data.subEvents[0].deduppedJobbles[0].dressCode;
	              _this.event.hourly_rate = (eventResp.data.subEvents[0].deduppedJobbles[0].payPerHour / 100).toString();
	              _this.openingsList.value = eventResp.data.numberOfOpenings + eventResp.data.numberOfApprovedApplications;
	              _this.event.openings = _this.openingsList.value;
	              _this.calcNumbers();
	              _this.event.jobble_details = eventResp.data.description;
	              _this.event.event_type = eventResp.data.eventTypeId;
	              _this.event.jobble_type = eventResp.data.subEvents[0].deduppedJobbles[0].jobbleType.id;
	              _this.event.postIsPrivate = false;
	              _this.step = 0;
	              _this.event.cloudsForJobblePost = [];
	              _this.remain_loading_count = 0;
	              _this.determineIfPublished(eventResp);
	              _this.determineIfPrivate(eventResp);
	              _this.determineJobbleType();
	              console.log("eventResp.data");
	              console.dir(eventResp.data);
	              console.dir(eventResp.data.subEvents[0].deduppedJobbles[0]);
	              if (eventResp.data.subEvents[0].deduppedJobbles[0].manager) {
	                var manager_id = eventResp.data.subEvents[0].deduppedJobbles[0].manager.id;
	                _this.event.manager = manager_id;
	                _this.$timeout(function () {
	                  _this.$rootScope.$emit("SetManagerFromBack", {
	                    id: _this.event.manager
	                  });
	                });
	              }
	              _this.$timeout(function () {
	                _this.$rootScope.$emit("SetLoaderDialog", {
	                  type: 0,
	                  total: 1
	                });
	              });
	            }
	          });
	        } else {
	          _this.$timeout(function () {
	            _this.remain_loading_count = 0;
	            _this.$rootScope.$emit("SetLoaderDialog", {
	              type: 0,
	              total: 1
	            });
	          });
	        }
	        if (_this.$stateParams.jobType && _this.$stateParams.openings && _this.$stateParams.pay) {
	          _this.event.hourly_rate = _this.$stateParams.pay;
	          _this.event.openings = _this.$stateParams.openings;
	          _this.openingsList.value = parseInt(_this.$stateParams.openings, 10);
	          for (var i = 0; i < data.data.length; i++) {
	            if (data.data[i].name === _this.$stateParams.jobType) {
	              _this.event.jobble_type = data.data[i].id;
	              break;
	            }
	          }
	        }
	        _this.check_for_marketing_site_params();
	      }, function (data) {
	        _this.jobble_types = [];
	        _this.remain_loading_count--;
	        if (data.status === 401) {
	          _this.$state.go("signin");
	        } else {
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	        }
	      });
	    }
	
	    if (this.currentUser) {
	      if (SecurityService.isUndefinedOrNull(this.currentUser.company.companyLogoUri)) {
	        var _this = this;
	        var photoLoop = function photoLoop(value) {
	          if (value < 0) {
	            return;
	          } else {
	            _this.$timeout(function () {
	              var reloadedUser = _this.$auth.reloadCurrentUser();
	              if (reloadedUser) {
	                if (reloadedUser.$$state.value.company.companyLogoUri) {
	                  _this.currentUser = reloadedUser.$$state.value;
	                  _this.currentUser.companyProfilePictureUrl = _this.currentUser.company.companyLogoUri;
	                } else {
	                  return photoLoop(value - 1);
	                }
	              } else {
	                return photoLoop(value - 1);
	              }
	            }, 2000);
	          }
	        };
	        photoLoop(3);
	      }
	
	      _this.checkForTeams();
	    }
	
	    _this.UpdateCurrentUserListener = _this.$rootScope.$on("UpdateCurrentUserPost", function ($event, params) {
	      _this.updateCurrentUser(params);
	    });
	
	    _this.ShowPostModalCCListener = _this.$rootScope.$on("ShowPostModalCC", function ($event, params) {
	      _this.showPostModalCC(params.user);
	    });
	
	    _this.ShowPostModalListener = _this.$rootScope.$on("ShowPostModal", function ($event, params) {
	      _this.showPostModal(params.user);
	    });
	
	    _this.SetQuestionsToEventListener = _this.$rootScope.$on("SetQuestionsToEvent", function ($event, params) {
	      _this.navigateTheWizard(params);
	    });
	
	    _this.setEventIdForDraftingListener = _this.$rootScope.$on("SetEventIdForDrafting", function (event, params) {
	      _this.setEventIdForDrafting(params);
	    });
	
	    _this.SetProfilePictureListener = _this.$rootScope.$on("SetProfilePicture", function ($event, params) {
	      _this.currentUser.company.companyLogoUri = params.picture;
	    });
	
	    _this.setJobbleTypesListenerScope = _this.$rootScope.$on("SetJobbleTypes", function (event, params) {
	      console.log("_this.setJobbleTypesListenerScope");
	      console.log("_this.setJobbleTypesListenerScope");
	      console.log("_this.setJobbleTypesListenerScope");
	      _this.setJobbleTypesListener(params);
	    });
	
	    _this.QuestionsTriggerListener = _this.$rootScope.$on("QuestionsTrigger", function ($event, params) {
	      _this.questions = params.questions;
	    });
	
	    _this.SetOnSiteManagerListener = _this.$rootScope.$on("SetOnSiteManager", function ($event, params) {
	      _this.event.manager = params.data;
	    });
	
	    _this.SetPostingTypeChangeListener = _this.$rootScope.$on("SetPostingTypeChange", function ($event, params) {
	      _this.remain_loading_count = 1;
	      _this.set_new_posting_type(params);
	    });
	
	    _this.PostEventFromModalListener = _this.$rootScope.$on("PostEventFromModal", function ($event, params) {
	      if (!_this.isSourcingPost) {
	        _this.postCreateEvent();
	      } else {
	        _this.handleSourcingPost();
	      }
	    });
	
	    _this.CloseCreditCardModalListener = _this.$rootScope.$on("CloseCreditCardModal", function ($event, params) {
	      _this.closeCreditCardModal(params);
	    });
	
	    if (this.$location.$$search.s) {
	      _this.startRegPost("source");
	    }
	
	    if (_this.$location.$$search.tut) {
	      _this.triggerPostTypeModal();
	    }
	
	    _this.$scope.$on("$destroy", _this.ShowPostModalListener);
	    _this.$scope.$on("$destroy", _this.ShowPostModalCCListener);
	    _this.$scope.$on("$destroy", _this.SetPostingTypeChangeListener);
	    _this.$scope.$on("$destroy", _this.SetOnSiteManagerListener);
	    _this.$scope.$on("$destroy", _this.CloseCreditCardModalListener);
	    _this.$scope.$on("$destroy", _this.SetProfilePictureListener);
	    _this.$scope.$on("$destroy", _this.setEventIdForDraftingListener);
	    _this.$scope.$on("$destroy", _this.QuestionsTriggerListener);
	    _this.$scope.$on("$destroy", _this.PostEventFromModalListener);
	    _this.$scope.$on("$destroy", _this.SetQuestionsToEventListener);
	    _this.$scope.$on("$destroy", _this.UpdateCurrentUserListener);
	    _this.$scope.$on("$destroy", _this.setJobbleTypesListenerScope);
	
	    if (_this.$location.$$search.edit) {
	      var tempTimeArray = [];
	      _this.step = 0;
	      _this.isEdit = true;
	      _this.remain_loading_count = 1;
	      _this.$events.getEventById(parseInt(_this.$location.$$search.edit, 10)).then(function (eventResp) {
	        _this.eventResponse = eventResp.data;
	        _this.remain_loading_count = 0;
	        if (_this.eventResponse.isSourcingPost) {
	          _this.postType = "source";
	        } else {
	          _this.postType = "regular";
	        }
	        try {
	          eventResp.data.subEvents[0].nonDuplicatedJobbles[0].shifts.forEach(function (shift) {
	            var tempTimeObj = {};
	            tempTimeObj.contactInfo = {};
	            tempTimeObj.address = shift.contactInfo.streetLine1 + " " + shift.contactInfo.city + " " + shift.contactInfo.state + " " + shift.contactInfo.zipCode;
	            tempTimeObj.start_time = moment(shift.timeInterval.startTime).tz(shift.contactInfo.timeZoneId).format("hh:mm A");
	            tempTimeObj.start_date = moment(shift.timeInterval.startTime).tz(shift.contactInfo.timeZoneId).format("MMM DD, YYYY");
	            tempTimeObj.contactInfo.streetLine1 = shift.contactInfo.streetLine1;
	            tempTimeObj.contactInfo.state = shift.contactInfo.state;
	            tempTimeObj.contactInfo.city = shift.contactInfo.city;
	            tempTimeObj.contactInfo.zipCode = shift.contactInfo.zipCode;
	            var diffmin = moment(shift.timeInterval.endTime).diff(shift.timeInterval.startTime, "minutes");
	            var diffhour = Math.floor(diffmin / 60);
	            tempTimeObj.hours = diffhour;
	            tempTimeObj.minutes = diffmin % 60;
	            tempTimeArray.push(tempTimeObj);
	          });
	        } finally {
	          _this.event.timeIntervalsArray = tempTimeArray;
	          _this.event.name = eventResp.data.name;
	          _this.event.dress_code = eventResp.data.subEvents[0].nonDuplicatedJobbles[0].dressCode;
	          _this.event.hourly_rate = (eventResp.data.subEvents[0].nonDuplicatedJobbles[0].payPerHour / 100).toString();
	          _this.openingsList.value = eventResp.data.numberOfOpenings + eventResp.data.numberOfApprovedApplications;
	          _this.event.openings = _this.openingsList.value;
	          _this.event.jobble_details = eventResp.data.description;
	          _this.event.event_type = eventResp.data.eventTypeId;
	          _this.event.jobble_type = eventResp.data.subEvents[0].nonDuplicatedJobbles[0].jobbleTypeId;
	          _this.event.postIsPrivate = false;
	          _this.event.cloudsForJobblePost = [];
	        }
	      });
	    }
	
	    _this.getLatestCompanyPackage();
	  }
	
	  _createClass(PosteventController, [{
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "showDateAndTimeUI",
	    value: function showDateAndTimeUI(isLoop) {
	      // for date and time picker UI
	      console.log("showDateAndTimeUI");
	      console.dir(isLoop);
	      console.dir(this.event);
	
	      if (!isLoop) {
	        setTimeout(function () {
	          jQuery("#datepicker").datepicker({
	            showOn: "both",
	            buttonImage: "/app/vendor/images/calender.png",
	            buttonImageOnly: true,
	            buttonText: "Select date",
	            dateFormat: "M dd, yy"
	          });
	          jQuery("#timepicker").timepicker({
	            step: 15,
	            timeFormat: "h:i A"
	          });
	          jQuery("#timepicker").on("showTimepicker", function () {
	            jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker").width() + 10 + "px");
	          });
	        }, 100);
	      } else {
	        var dateLoop = function dateLoop(value) {
	          if (value < 0) {
	            return;
	          } else {
	            setTimeout(function () {
	              jQuery("#datepicker" + value).datepicker({
	                showOn: "both",
	                buttonImage: "/app/vendor/images/calender.png",
	                buttonImageOnly: true,
	                buttonText: "Select date",
	                dateFormat: "M dd, yy"
	              });
	              jQuery("#timepicker" + value).timepicker({
	                step: 15,
	                timeFormat: "h:i A"
	              });
	              jQuery("#timepicker" + value).on("showTimepicker", function () {
	                jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker" + value).width() + 10 + "px");
	              });
	            }, 100);
	            dateLoop(value - 1);
	          }
	        };
	        dateLoop(this.event.timeIntervalsArray.length);
	      }
	    }
	  }, {
	    key: "updateCurrentUser",
	    value: function updateCurrentUser(params) {
	      //console.log('in the controller');
	      //console.dir(params);
	      var _this = this;
	      _this.$timeout(function () {
	        _this.currentUser = params.user;
	        _this.$localStorage.logged_user = params.user;
	      }, 1000);
	    }
	  }, {
	    key: "updateStartTimeModel",
	    value: function updateStartTimeModel() {
	      var start_time = jQuery("#timepicker").val();
	      if (start_time != undefined && start_time != null) {
	        this.currentTimeInterval.start_time = start_time;
	      }
	    }
	  }, {
	    key: "validateEventForm",
	    value: function validateEventForm(eventObj) {
	      eventObj.openings = this.openingsList.value;
	
	      var keys = Object.keys(eventObj);
	      var values = keys.map(function (v) {
	        return eventObj[v];
	      });
	      var retObj = {};
	
	      retObj.status = true;
	      retObj.message = "";
	
	      for (var x = 0; x < keys.length; x++) {
	        var val = eventObj[keys[x]];
	        if (keys[x] == "event_type") {
	          val = 1;
	        }
	        if (this.$security.isUndefinedOrNull(val) && keys[x] !== "jobble_type_name") {
	          console.log("each key val");
	          console.dir(val);
	          console.dir(keys[x]);
	          if (keys[x] === "manager") {
	            retObj.status = false;
	            retObj.message = "Please select a hiring manager before continuing.";
	          }
	          if (keys[x] === "name") {
	            retObj.status = false;
	            retObj.message = "Please provide a name for your job before continuing.";
	          }
	          if (keys[x] === "jobble_type") {
	            retObj.status = false;
	            retObj.message = "Please select a jobble type for your job before continuing.";
	          }
	          if (keys[x] === "dress_code") {
	            if (this.postType === "source") {} else {
	              retObj.status = false;
	              retObj.message = "Please provide a dress code for your job before continuing.";
	            }
	          }
	          if (keys[x] === "hourly_rate") {
	            if (this.postType === "source") {} else {
	              retObj.status = false;
	              retObj.message = "Please provide an hourly rate for your job before continuing.";
	            }
	          }
	          if (keys[x] === "openings") {
	            retObj.status = false;
	            retObj.message = "Please provide the number of openings for your job before continuing.";
	          }
	          if (keys[x] === "jobble_details") {
	            retObj.status = false;
	            retObj.message = "Please provide some job details for your job before continuing.";
	          }
	          return retObj;
	        }
	        if (keys[x] === "openings") {
	          eventObj[keys[x]] = this.openingsList.value;
	          if (eventObj[keys[x]] === "0") {
	            retObj.status = false;
	            retObj.message = "Please provide more than 0 openings";
	            return retObj;
	          }
	        }
	        if (keys[x] === "dress_code") {
	          var dc = eventObj[keys[x]];
	          if (dc.length >= 254) {
	            retObj.status = false;
	            retObj.message = "The Dress Code is too long. Please shorten the length and add what ever addition details in the Job Description.";
	            return retObj;
	          }
	        }
	        if (keys[x] === "hourly_rate") {
	          if (this.postType === "source") {
	            if (this.event.hourly_rate) {
	              if (this.event.hourly_rate.indexOf("$") > -1) {
	                retObj.status = false;
	                retObj.message = "Please do not include the '$' sign when inputting an hourly rate.";
	                return retObj;
	              } else {
	                var decimal_check = /^\d*\.?\d{0,2}$/.test(this.event.hourly_rate);
	                if (!decimal_check) {
	                  retObj.status = false;
	                  retObj.message = "Please provide a pay rate of that has only two decimal places.";
	                  return retObj;
	                }
	              }
	            } else {
	              this.event.hourly_rate = 0;
	            }
	          } else {
	            if (this.event.hourly_rate < this.hourly_rate_based_on_admin) {
	              retObj.status = false;
	              retObj.message = "Please provide a pay rate of at least $14.00 an hour.";
	              return retObj;
	            } else {
	              if (this.event.hourly_rate.indexOf("$") > -1) {
	                retObj.status = false;
	                retObj.message = "Please do not include the '$' sign when inputting an hourly rate.";
	                return retObj;
	              } else {
	                var decimal_check = /^\d*\.?\d{0,2}$/.test(this.event.hourly_rate);
	                if (!decimal_check) {
	                  retObj.status = false;
	                  retObj.message = "Please provide a pay rate of that has only two decimals.";
	                  return retObj;
	                }
	              }
	            }
	          }
	        }
	        if (keys[x] === "timeToHire") {
	          //console.log('WE HAVE TIME TO HIRE IN VALIDATING');
	          //console.dir(this.event.timeToHire);
	          if (this.event.timeToHire) {
	            if (moment(this.event.timeToHire).isBefore(moment())) {
	              retObj.status = false;
	              retObj.message = "Please provide a hiring date that is a day in the future.";
	              return retObj;
	            }
	          }
	        }
	        if (x + 1 === keys.length) {
	          retObj.status = true;
	          return retObj;
	        }
	      }
	    }
	  }, {
	    key: "goToEventDetailOther",
	    value: function goToEventDetailOther() {
	      this.step = 0;
	      setTimeout(function () {
	        jQuery("#datepicker").datepicker({
	          showOn: "both",
	          buttonImage: "/app/vendor/images/calender.png",
	          buttonImageOnly: true,
	          buttonText: "Select date",
	          dateFormat: "M dd, yy"
	        });
	      }, 100);
	    }
	  }, {
	    key: "gotoEventDetailStep",
	    value: function gotoEventDetailStep() {
	      var _this = this;
	      setTimeout(function () {
	        jQuery("#datepicker").datepicker({
	          showOn: "both",
	          buttonImage: "/app/vendor/images/calender.png",
	          buttonImageOnly: true,
	          buttonText: "Select date",
	          dateFormat: "M dd, yy"
	        });
	      }, 100);
	      if (_this.currentTimeInterval.address.adr_address) {
	        if (_this.currentTimeInterval.address.adr_address === "" || _this.currentTimeInterval.hours === "" || _this.currentTimeInterval.minutes === "" || _this.currentTimeInterval.start_date === "" || _this.currentTimeInterval.start_time === "") {
	          _this.currentTimeInterval.address.adr_address = "";
	          _this.currentTimeInterval.hours = "";
	          _this.currentTimeInterval.minutes = "";
	          _this.currentTimeInterval.start_date = "";
	          _this.currentTimeInterval.start_time = "";
	        }
	      } else {
	        if (_this.currentTimeInterval.address === "" || _this.currentTimeInterval.hours === "" || _this.currentTimeInterval.minutes === "" || _this.currentTimeInterval.start_date === "" || _this.currentTimeInterval.start_time === "") {
	          _this.currentTimeInterval.address = "";
	          _this.currentTimeInterval.hours = "";
	          _this.currentTimeInterval.minutes = "";
	          _this.currentTimeInterval.start_date = "";
	          _this.currentTimeInterval.start_time = "";
	        }
	      }
	      _this.updateStartTimeModel();
	      _this.step = 0;
	      _this.displayErrorMessageThirdPage = false;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetManagerFromBack", {
	          id: _this.event.manager
	        });
	      });
	    }
	  }, {
	    key: "gotoJobDetailStep",
	    value: function gotoJobDetailStep(fromEdit) {
	      this.updateStartTimeModel();
	      if (this.event.timeIntervalsArray.length > 0 && !fromEdit) {
	        this.step = 2;
	      } else {
	        this.step = 1;
	      }
	      this.showDateAndTimeUI();
	    }
	  }, {
	    key: "goToRegi",
	    value: function goToRegi(type) {
	      var _this = this;
	      this.step = 3;
	      this.postingLink = true;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetRegistrationLazy", { type: type });
	      });
	      _this.$timeout(function () {
	        jQuery("#show-application-global-modal").trigger("click");
	      }, 300);
	    }
	  }, {
	    key: "removeShiftEdit",
	    value: function removeShiftEdit(ti, index) {
	      var _this = this;
	      _this.event.timeIntervalsArray.splice(index, 1);
	    }
	  }, {
	    key: "addShiftEdit",
	    value: function addShiftEdit(ti, index) {
	      var _this = this;
	      var ins = {
	        address: null,
	        contactInfo: {
	          city: null,
	          lat: null,
	          lng: null,
	          state: null,
	          streetLine1: null,
	          zipCode: null
	        },
	        hours: 1,
	        minnutes: 0,
	        start_date: null,
	        start_time: null
	      };
	      var p1 = index + 1;
	      _this.event.timeIntervalsArray.splice(p1, 0, ins);
	      _this.showDateAndTimeUI(true);
	    }
	  }, {
	    key: "editCurrentInterval",
	    value: function editCurrentInterval() {
	      this.gotoJobDetailStep(true);
	      ////console.log(this.currentTimeInterval);
	      ////console.log(this.event.timeIntervalsArray);
	    }
	  }, {
	    key: "editInterval",
	    value: function editInterval(timeInterval, index) {
	      console.log("timeInterval");
	      console.dir(timeInterval);
	
	      timeInterval.temp_holder = timeInterval.address_temp;
	      timeInterval.address_temp = timeInterval.address;
	
	      this.currentTimeInterval = timeInterval;
	      this.currentAction = "edit";
	
	      var randomArray = [];
	      randomArray = this.event.timeIntervalsArray;
	      this.markAllShiftsAsNotBeingEdited();
	      this.timeIntervalsArrayTemp = randomArray;
	      this.showAllShifts = true;
	
	      this.event.timeIntervalsArray.forEach(function (ti) {
	        ti.isOverlapping = false;
	      });
	
	      this.currentTimeIntervalBackup = {
	        address: this.currentTimeInterval.address.adr_address,
	        start_date: this.currentTimeInterval.start_date,
	        start_time: this.currentTimeInterval.start_time,
	        hours: this.currentTimeInterval.hours,
	        minutes: this.currentTimeInterval.minutes
	      };
	
	      this.gotoJobDetailStep(true);
	      this.shiftIsBeingEdited = true;
	      this.setActiveClassToTimeIntervalTable(index);
	
	      console.log("timeInterval after editing...");
	      console.dir(timeInterval);
	    }
	  }, {
	    key: "setActiveClassToTimeIntervalTable",
	    value: function setActiveClassToTimeIntervalTable(index) {
	      var _this = this;
	      console.log("setActiveClassToTimeIntervalTable");
	      console.dir(index);
	      console.dir(_this.event.timeIntervalsArray);
	      _this.event.timeIntervalsArray[index].isBeingEdited = true;
	    }
	  }, {
	    key: "removeCurrentInterval",
	    value: function removeCurrentInterval() {
	      var lenIntevals = this.event.timeIntervalsArray.length;
	      if (lenIntevals > 1) {
	        this.event.timeIntervalsArray.splice(lenIntevals - 1, 1);
	        this.currentTimeInterval = this.event.timeIntervalsArray[this.event.timeIntervalsArray.length - 1];
	      }
	    }
	  }, {
	    key: "removeInterval",
	    value: function removeInterval(timeInterval, index) {
	      var lenIntevals = this.event.timeIntervalsArray.length;
	
	      if (lenIntevals > 1) {
	        var shift_to_delete = this.event.timeIntervalsArray[index];
	        this.event.timeIntervalsArray.splice(index, 1);
	        this.currentTimeInterval = this.event.timeIntervalsArray[this.event.timeIntervalsArray.length - 1];
	        if (!this.isClone) {
	          this.setLoader();
	          this.updateEventOnBackEnd(shift_to_delete, this.event.timeIntervalsArray);
	        }
	      }
	    }
	  }, {
	    key: "updateEventOnBackEnd",
	    value: function updateEventOnBackEnd(shift_to_delete, shifts_left_over) {
	      var _this = this;
	      var shifts = [];
	      try {
	        shifts_left_over.forEach(function (shift) {
	          var s = {};
	          s.contactInfo = shift.contactInfo;
	          s.timeInterval = {};
	          s.timeInterval.startTime = shift.startDateAndTimeForDB;
	          s.timeInterval.endTime = shift.endDateAndTimeForDB;
	          shifts.push(s);
	        });
	      } catch (err) {
	        alert("Error :" + err);
	      } finally {
	        _this.updateAfterRemove(shifts, shift_to_delete);
	      }
	    }
	  }, {
	    key: "updateAfterRemove",
	    value: function updateAfterRemove(shifts, shift_to_delete) {
	      var _this = this;
	      var jid = null;
	      try {
	        if (_this.eventResponse) {
	          jid = _this.eventResponse.subEvents[0].deduppedJobbles[0].id;
	        } else {
	          if (_this.eventForDraftingData) {
	            if (_this.eventForDraftingData.draftData) {
	              if (_this.eventForDraftingData.draftData.data) {
	                jid = _this.eventForDraftingData.draftData.data.jobblePool.jobbles[0].id;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        alert("Unable to find jobble id please contact support");
	      }
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("AutoSave", {
	          event: _this.event,
	          questions: _this.questions,
	          update: true
	        });
	      });
	
	      console.log("shift_to_delete");
	      console.dir(shift_to_delete);
	
	      _this.$events.deleteShift(shift_to_delete).then(function (response) {
	        console.log("response from edit shift");
	        console.dir(response);
	        _this.saving = false;
	        _this.displayErrorMessageThirdPage = false;
	        _this.unSetLoader();
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	        _this.unSetLoader();
	        alert("Error :" + error);
	      });
	
	      /*
	      _this.$events.updateExistingDraft(jid, shifts, _this.event).then(function(response){
	      _this.saving = false;
	      _this.displayErrorMessageThirdPage = false;
	      _this.unSetLoader();
	      }, function(error){
	      _this.unSetLoader();
	      alert("Error :" +error);
	      });
	      */
	    }
	  }, {
	    key: "addInterval",
	    value: function addInterval() {
	      console.log("addInterval");
	      console.dir(this.event);
	      console.dir(this.currentTimeInterval);
	      console.dir(this.currentTimeInterval.address);
	      if (this.sessionObj.isSaving) {
	        this.displayErrorMessageThirdPage = true;
	        this.message = "Please wait until job has been saved before proceeding.";
	      } else {
	        var newAddress = this.currentTimeInterval.address;
	
	        var newInterval = {
	          address: "",
	          start_date: "",
	          start_time: "",
	          hours: "",
	          minutes: ""
	        };
	        console.log("newInterval");
	        console.dir(newInterval);
	        this.showAllShifts = true;
	        var randomArray = [];
	        randomArray = this.event.timeIntervalsArray;
	        this.timeIntervalsArrayTemp = randomArray;
	        this.currentAction = "add";
	        //this.event.timeIntervalsArray.push(newInterval);
	        //this.currentTimeInterval = this.event.timeIntervalsArray[this.event.timeIntervalsArray.length - 1];
	        this.currentTimeInterval = newInterval;
	        this.editCurrentInterval();
	      }
	    }
	  }, {
	    key: "gotoJobReviewStep",
	    value: function gotoJobReviewStep() {
	      this.updateStartTimeModel();
	      this.step = 3;
	    }
	  }, {
	    key: "updateEventDuringCreation",
	    value: function updateEventDuringCreation(jobblePool, event, status) {
	      var _this = this;
	      _this.$events.updateEventData(jobblePool, event).then(function (response) {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("AutoSaveTrigger", { pop: "off" });
	        });
	      }, function (response) {
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "getLatestCompanyPackage",
	    value: function getLatestCompanyPackage() {
	      var _this = this;
	      if (_this.currentUser) {
	        _this.$timeout(function () {
	          _this.$auth.getCompanyPlan().then(function (response) {
	            _this.currentUser.company.defaultPlan = response.data.company.defaultPlan;
	            _this.currentUser.company.payByInvoice = response.data.company.payByInvoice;
	            console.log("current user and plan");
	            console.dir(_this.currentUser);
	          }, function (error) {
	            console.log("error");
	            console.dir(error);
	          });
	        }, 1000);
	      }
	    }
	  }, {
	    key: "updateJobbleDuringCreation",
	    value: function updateJobbleDuringCreation(jobblePool, event, status) {
	      var _this = this;
	      _this.$events.updateJobblePoolData(jobblePool, event).then(function (resp) {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("AutoSaveTrigger", { pop: "off" });
	        });
	      }, function (resp) {
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "updateEventDetailsFromFirstPage",
	    value: function updateEventDetailsFromFirstPage(data, event, status) {
	      var _this = this;
	      var jobblePool = data.draftData.data.jobblePool;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("AutoSaveTrigger", { pop: "on" });
	      });
	      if (_this.arrayOfStatus.indexOf(2) > -1) {
	        _this.updateJobbleDuringCreation(jobblePool, event, status);
	      }
	      if (_this.arrayOfStatus.indexOf(1) > -1) {
	        _this.updateEventDuringCreation(jobblePool, event, status);
	      }
	      if (_this.arrayOfStatus.indexOf(3) > -1) {
	        _this.addOrRemoveOpenings(data, event);
	      }
	    }
	  }, {
	    key: "addOrRemoveOpenings",
	    value: function addOrRemoveOpenings(data, event) {
	      var _this = this;
	      var y = 0;
	      var x = 0;
	      if (data.draftData.data.jobblePool.jobbles.length > event.openings) {
	        y = data.draftData.data.jobblePool.jobbles.length - event.openings;
	        _this.$events.removeOpeningsToEvent(data, event, y).then(function (response) {
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("AutoSaveTrigger", {
	              pop: "off"
	            });
	          });
	        });
	      } else {
	        if (data.draftData.data.jobblePool.jobbles.length < event.openings) {
	          y = event.openings - data.draftData.data.jobblePool.jobbles.length;
	          //x = data.draftData.data.jobblePool.jobbles.length + y;
	          _this.$events.addOpeningsToEvent(data, event, y).then(function (response) {
	            _this.$timeout(function () {
	              _this.$rootScope.$emit("AutoSaveTrigger", {
	                pop: "off"
	              });
	            });
	          });
	        }
	      }
	    }
	  }, {
	    key: "submitEventDetail",
	    value: function submitEventDetail(arg) {
	      var _this = this;
	      console.log("submitEventDetail");
	      console.dir(_this.event);
	      console.log(JSON.stringify(_this.event));
	      if (this.openings_for_clone) {
	        var o = this.openings_for_clone.value;
	        _this.event.openings = null;
	        _this.event.openings = o;
	      }
	      if (_this.sessionObj.isSaving) {
	        _this.displayFirstPageErrorMessage = true;
	        _this.message = "Please wait until job has been saved before proceeding.";
	      } else {
	        var isFirstPageValid = _this.validateEventForm(_this.event);
	        if (isFirstPageValid.status) {
	          _this.displayFirstPageErrorMessage = false;
	          _this.message = "";
	          _this.step = 1;
	          try {
	            _this.timeIntervalsArrayTemp.forEach(function (interval, index) {
	              if (interval.address === "" || interval.hours === "" || interval.minutes === "" || interval.start_date === "" || interval.start_time === "") {
	                _this.timeIntervalsArrayTemp.splice(index, 1);
	              }
	            });
	          } finally {
	            if (_this.$location.$$search.eid || _this.$location.$$search.edit) {
	              _this.showDateAndTimeUI(true);
	              _this.statusBarStatus.step_2.visited = true;
	              _this.populateTracker(2);
	              _this.step = 5;
	            } else {
	              if (_this.event.timeIntervalsArray.length > 0 && !_this.$security.isUndefinedOrNull(_this.event.timeIntervalsArray[0].address)) {
	                if (_this.postType === "regular" || _this.postType === "source") {
	                  if (!_this.$security.isUndefinedOrNull(_this.event.timeIntervalsArray[0].address.adr_address) || _this.event.timeIntervalsArray[0].address.adr_address === "") {
	                    _this.step = 1;
	                    _this.populateTracker(1);
	                    _this.event.timeIntervalsArray[0].address = null;
	                    _this.statusBarStatus.step_2.visited = true;
	                  } else {
	                    _this.step = 2;
	                    _this.populateTracker(2);
	                    _this.statusBarStatus.step_2.visited = true;
	                    _this.updateEventWithLatestData();
	                    _this.displayErrorMessageThirdPage = false;
	                  }
	                } else {
	                  _this.step = 22;
	                  _this.populateTracker(22);
	                }
	              } else {
	                _this.step = 1;
	                _this.populateTracker(1);
	                _this.statusBarStatus.step_2.visited = true;
	              }
	              _this.showDateAndTimeUI();
	            }
	          }
	        } else {
	          _this.displayFirstPageErrorMessage = true;
	          _this.message = isFirstPageValid.message;
	        }
	      }
	    }
	  }, {
	    key: "cancelShift",
	    value: function cancelShift() {
	      if ((this.currentTimeInterval.address.adr_address === "" || this.currentTimeInterval.hours === "" || this.currentTimeInterval.minutes === "" || this.currentTimeInterval.start_date === "" || this.currentTimeInterval.start_time === "") && this.currentAction !== "add") {
	        this.currentTimeInterval.address = "";
	        this.currentTimeInterval.hours = "";
	        this.currentTimeInterval.minutes = "";
	        this.currentTimeInterval.start_date = "";
	        this.currentTimeInterval.start_time = "";
	        this.step = 0;
	      } else {
	        if (this.currentAction == "add") {
	          this.event.timeIntervalsArray.splice(this.event.timeIntervalsArray.length - 1, 1);
	          this.currentTimeInterval = this.event.timeIntervalsArray[this.event.timeIntervalsArray.length - 1];
	          this.step = 2;
	        } else {
	          this.currentTimeInterval.address = this.currentTimeIntervalBackup.address;
	          this.currentTimeInterval.start_date = this.currentTimeIntervalBackup.start_date;
	          this.currentTimeInterval.start_time = this.currentTimeIntervalBackup.start_time;
	          this.currentTimeInterval.hours = this.currentTimeIntervalBackup.hours;
	          this.currentTimeInterval.minutes = this.currentTimeIntervalBackup.minutes;
	          this.step = 2;
	        }
	        this.currentAction = "";
	      }
	    }
	  }, {
	    key: "check_shifts",
	    value: function check_shifts(shifts) {
	      var _this = this;
	      console.log("check_shifts");
	      console.log(shifts);
	      var error_found = false;
	      var result = {};
	      var i1 = null;
	      try {
	        if (shifts) {
	          shifts.forEach(function (shift, i) {
	            if (!shift.hours) {
	              result.error = true;
	              i1 = i + 1;
	              result.message = "The shift in position #" + i1 + " is missing the hours of the duration.";
	              shift.has_error = true;
	              result.shift = shift;
	              error_found = true;
	            }
	            if (shift.minutes === null || _angular2.default.isUndefined(shift.minutes)) {
	              //console.log("empty minutes...");
	              //result.error=false;
	              shift.minutes = 0;
	              //result.set_mins_to_zero=true;
	              /*
	              result.error=true;
	              i1=i+1;
	              result.message="The shift in position #"+i1+" is missing the minutes of the duration.";
	              shift.has_error=true;
	              result.shift=shift;
	              error_found=true;
	              */
	            }
	            if (!shift.start_date) {
	              result.error = true;
	              i1 = i + 1;
	              result.message = "The shift in position #" + i1 + " is missing a start date.";
	              shift.has_error = true;
	              result.shift = shift;
	              error_found = true;
	            }
	            if (!shift.start_time) {
	              result.error = true;
	              i1 = i + 1;
	              result.message = "The shift in position #" + i1 + " is missing a start time.";
	              shift.has_error = true;
	              result.shift = shift;
	              error_found = true;
	            }
	            if (!shift.address) {
	              result.error = true;
	              i1 = i + 1;
	              result.message = "The shift in position #" + i1 + " is missing an address.";
	              shift.has_error = true;
	              result.shift = shift;
	              error_found = true;
	            }
	          });
	        } else {}
	      } catch (err) {
	        console.log("error");
	        console.dir(err);
	      }
	      if (error_found === false) {
	        result.error = false;
	        _this.displayErrorMessageSecondPageNew = false;
	      }
	      return result;
	    }
	  }, {
	    key: "submitDateAndLocationLoop",
	    value: function submitDateAndLocationLoop(shifts) {
	      var _this = this;
	
	      _this.remain_loading_count = 1;
	
	      this.shiftIsBeingEdited = false;
	
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetLoaderDialog", { type: 11, total: 1 });
	      });
	
	      var check_shifts = _this.check_shifts(shifts);
	
	      if (check_shifts.error === false) {
	        var shiftsLoop = function shiftsLoop(value) {
	          if (value > 0) {
	            try {
	              if (shifts[value - 1].address.adr_address) {
	                try {
	                  shifts[value - 1].contactInfo = {};
	                  shifts[value - 1].contactInfo.lat = shifts[value - 1].address.lat;
	                  shifts[value - 1].contactInfo.lng = shifts[value - 1].address.lng;
	                  var addressSplit = shifts[value - 1].address.adr_address.split(",");
	                  addressSplit.forEach(function (part, index) {
	                    if (part.indexOf("street-address") > -1) {
	                      var streetArray = /<span[^>]*>(.*?)<\/span>/.exec(part);
	                      shifts[value - 1].contactInfo.streetLine1 = streetArray[1];
	                    }
	                    if (part.indexOf("locality") > -1) {
	                      var cityArray = /<span[^>]*>(.*?)<\/span>/.exec(part);
	                      shifts[value - 1].contactInfo.city = cityArray[1];
	                    }
	                    if (part.indexOf("region") > -1) {
	                      var regionAndZipArray = part.split("> <");
	
	                      regionAndZipArray.forEach(function (p) {
	                        if (p.indexOf("region") > -1) {
	                          var stateArray = /\s<span[^>]*>(.*?)<\/span/.exec(p);
	                          shifts[value - 1].contactInfo.state = stateArray[1];
	                        }
	                        if (p.indexOf("postal-code") > -1) {
	                          var zipArray = /span[^>]*>(.*?)<\/span>/.exec(p);
	                          shifts[value - 1].contactInfo.zipCode = zipArray[1];
	                        }
	                      });
	                    }
	                    if (index + 1 === addressSplit.length) {
	                      shifts[value - 1].address = shifts[value - 1].contactInfo.streetLine1 + " " + shifts[value - 1].contactInfo.city + " " + shifts[value - 1].contactInfo.state + " " + shifts[value - 1].contactInfo.zipCode;
	                    }
	                  });
	                } finally {
	                  _this.$security.getEventShiftTimezoneInfo(shifts[value - 1]).then(function (response) {
	                    if (response.data.length == 0) {
	                      _this.remain_loading_count--;
	                      _this.displayErrorMessageSecondPage = true;
	                      _this.message = "Please return a more specific address.";
	                      return;
	                    }
	
	                    var userTimeZoneName = moment.tz.guess();
	                    var now = moment.tz(userTimeZoneName);
	                    var nowThere = moment.tz(response.data[0].timeZoneId);
	                    var timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
	                    var zone = moment.tz.zone(moment.tz.guess());
	                    var eventMangerOffsets = -zone.offsets[zone.offsets.length - 1];
	                    var eventOffsets = response.data[0].rawOffset / 60000;
	                    var tempEndDate = moment(shifts[value - 1].start_date + " " + shifts[value - 1].start_time).add(shifts[value - 1].hours, "hours").add(eventMangerOffsets - eventOffsets, "minutes");
	
	                    shifts[value - 1].endDateAndTimeMomentObj = moment(tempEndDate).add(shifts[value - 1].minutes, "minutes");
	                    shifts[value - 1].startDateAndTimeMomentObj = moment(shifts[value - 1].start_date + " " + shifts[value - 1].start_time).add(eventMangerOffsets - eventOffsets, "minutes");
	
	                    shifts[value - 1].durationInMinutes = shifts[value - 1].endDateAndTimeMomentObj.diff(shifts[value - 1].startDateAndTimeMomentObj, "minutes");
	                    shifts[value - 1].durationInHours = parseFloat((shifts[value - 1].durationInMinutes / 60).toFixed(2));
	                    shifts[value - 1].startDateAndTimeForDB = shifts[value - 1].startDateAndTimeMomentObj.format();
	                    shifts[value - 1].endDateAndTimeForDB = shifts[value - 1].endDateAndTimeMomentObj.format();
	
	                    var dst_test = shifts[value - 1].startDateAndTimeForDB;
	                    var dst_result = moment(dst_test).isDST();
	
	                    console.log("dst_result");
	                    console.dir(dst_result);
	
	                    if (response.data[0].timeZoneId === "America/Phoenix" && dst_result === true) {
	                      shifts[value - 1].startDateAndTimeForDB = moment(shifts[value - 1].startDateAndTimeForDB).add(1, "hours").format();
	                      shifts[value - 1].endDateAndTimeForDB = moment(shifts[value - 1].endDateAndTimeForDB).add(1, "hours").format();
	                    }
	
	                    shifts[value - 1].cost = parseFloat(shifts[value - 1].durationInHours * (_this.event.hourly_rate * _this.event.openings));
	
	                    if (shifts.length - value + 1 === shifts.length) {
	                      _this.$timeout(function () {
	                        _this.wereDoneWithLoop(shifts);
	                      }, 1000);
	                    }
	                  }, function (response) {
	                    _this.remain_loading_count--;
	                    _this.$timeout(function () {
	                      jQuery("#show-application-alert").trigger("click");
	                    }, 100);
	                  });
	                }
	              } else {
	                if (_this.postType === "regular") {
	                  console.log("regular post type...");
	
	                  _this.$security.getEventShiftTimezoneInfo(shifts[value - 1]).then(function (response) {
	                    if (response.data.length == 0) {
	                      _this.remain_loading_count--;
	                      _this.displayErrorMessageSecondPage = true;
	                      _this.message = "Please return a more specific address.";
	                      return;
	                    }
	                    var userTimeZoneName = moment.tz.guess();
	                    var now = moment.tz(userTimeZoneName);
	                    var nowThere = moment.tz(response.data[0].timeZoneId);
	                    var timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
	                    var zone = moment.tz.zone(moment.tz.guess());
	                    var eventMangerOffsets = -zone.offsets[zone.offsets.length - 1];
	                    var eventOffsets = response.data[0].rawOffset / 60000;
	                    var tempEndDate = moment(shifts[value - 1].start_date + " " + shifts[value - 1].start_time).add(shifts[value - 1].hours, "hours").add(eventMangerOffsets - eventOffsets, "minutes");
	                    shifts[value - 1].endDateAndTimeMomentObj = moment(tempEndDate).add(shifts[value - 1].minutes, "minutes");
	                    shifts[value - 1].startDateAndTimeMomentObj = moment(shifts[value - 1].start_date + " " + shifts[value - 1].start_time).add(eventMangerOffsets - eventOffsets, "minutes");
	                    shifts[value - 1].durationInMinutes = shifts[value - 1].endDateAndTimeMomentObj.diff(shifts[value - 1].startDateAndTimeMomentObj, "minutes");
	                    shifts[value - 1].durationInHours = parseFloat((shifts[value - 1].durationInMinutes / 60).toFixed(2));
	
	                    shifts[value - 1].startDateAndTimeForDB = shifts[value - 1].startDateAndTimeMomentObj.format();
	                    shifts[value - 1].endDateAndTimeForDB = shifts[value - 1].endDateAndTimeMomentObj.format();
	
	                    var dst_test = shifts[value - 1].startDateAndTimeForDB;
	                    var dst_result = moment(dst_test).isDST();
	
	                    console.log("dst_result");
	                    console.dir(dst_result);
	
	                    if (response.data[0].timeZoneId === "America/Phoenix" && dst_result === true) {
	                      shifts[value - 1].startDateAndTimeForDB = moment(shifts[value - 1].startDateAndTimeForDB).add(1, "hours").format();
	                      shifts[value - 1].endDateAndTimeForDB = moment(shifts[value - 1].endDateAndTimeForDB).add(1, "hours").format();
	                    }
	
	                    shifts[value - 1].cost = parseFloat(shifts[value - 1].durationInHours * (_this.event.hourly_rate * _this.event.openings));
	                    if (shifts.length - value + 1 === shifts.length) {
	                      _this.$timeout(function () {
	                        _this.wereDoneWithLoop(shifts);
	                        _this.remain_loading_count = 0;
	                        _this.$timeout(function () {
	                          _this.$rootScope.$emit("SetLoaderDialog", {
	                            type: 0,
	                            total: 1
	                          });
	                        });
	                      }, 1000);
	                    }
	                  }, function (response) {
	                    _this.remain_loading_count--;
	                    _this.$timeout(function () {
	                      jQuery("#show-application-alert").trigger("click");
	                    }, 100);
	                  });
	                } else {
	                  shifts[value - 1].startDateAndTimeForDB = moment().format();
	                  shifts[value - 1].endDateAndTimeForDB = moment(shifts[value - 1].startDateAndTimeForDB).add(30, "days").format();
	                  shifts[value - 1].posting_duration = _this.currentTimeInterval.posting_duration;
	                  if (shifts.length - value + 1 === shifts.length) {
	                    _this.wereDoneWithLoop(shifts);
	                    _this.remain_loading_count = 0;
	                    _this.$timeout(function () {
	                      _this.$rootScope.$emit("SetLoaderDialog", {
	                        type: 0,
	                        total: 1
	                      });
	                    });
	                  }
	                }
	              }
	            } finally {
	              return shiftsLoop(value - 1);
	            }
	          } else {}
	        };
	        shiftsLoop(shifts.length);
	      } else {
	        _this.set_errors(check_shifts);
	      }
	    }
	  }, {
	    key: "set_errors",
	    value: function set_errors(error, idx) {
	      var _this = this;
	      _this.displayErrorMessageSecondPageNew = true;
	      console.log("setting erros");
	      console.dir(idx);
	      _this.err_result = error;
	      _this.remain_loading_count--;
	    }
	  }, {
	    key: "wereDoneWithLoop",
	    value: function wereDoneWithLoop(shifts) {
	      var _this = this;
	
	      try {
	        for (var i = 0; i < shifts.length; i++) {
	          if (_this.postType === "regular") {
	            shifts[i].durationInMinutes = shifts[i].endDateAndTimeMomentObj.diff(shifts[i].startDateAndTimeMomentObj, "minutes");
	            shifts[i].durationInHours = parseFloat((shifts[i].durationInMinutes / 60).toFixed(2));
	            shifts[i].cost = parseFloat(shifts[i].durationInHours * (_this.event.hourly_rate * _this.event.openings));
	            if (_this.$security.isUndefinedOrNull(shifts[i].hours)) {
	              shifts[i].hours = "0";
	            }
	            if (_this.$security.isUndefinedOrNull(shifts[i].minutes)) {
	              shifts[i].minutes = "0";
	            }
	          }
	        }
	      } finally {
	        for (var i = 0; i < shifts.length; i++) {
	          var isSecondPageValid = _this.validateDateAndLocationValue(shifts[i]);
	          if (!isSecondPageValid.status) {
	            _this.displayErrorMessageSecondPage = true;
	            _this.remain_loading_count--;
	            _this.message = isSecondPageValid.message;
	            break;
	          }
	        }
	      }
	      try {
	        if (isSecondPageValid.status) {
	          var errorWithShifts = _this.compareShiftsToEachOther(_this.event.timeIntervalsArray);
	          if (!errorWithShifts.status) {
	            _this.displayErrorMessageThirdPage = false;
	            if (_this.postType === "source") {
	              console.log("i really hope we make it here");
	              _this.step = 2;
	            } else {
	              _this.step = 2;
	            }
	
	            _this.remain_loading_count--;
	          } else {
	            _this.displayErrorMessageThirdPage = true;
	            _this.message = errorWithShifts.message;
	            _this.remain_loading_count--;
	          }
	        } else {
	          _this.displayErrorMessageSecondPage = true;
	          _this.message = isSecondPageValid.message;
	        }
	      } finally {
	        //console.log('what is this going into the final page');
	        //console.dir(_this.event);
	      }
	    }
	  }, {
	    key: "saveDraftListener",
	    value: function saveDraftListener() {
	      var _this = this;
	
	      if (_this.currentUser) {
	        _this.$timeout(function () {
	          _this.sessionObj.isSaving = true;
	          _this.event.typeOfJobPosting = _this.postType;
	          _this.$rootScope.$emit("AutoSave", {
	            event: _this.event,
	            questions: _this.questions
	          });
	        });
	      }
	    }
	  }, {
	    key: "submitDateAndLocation",
	    value: function submitDateAndLocation() {
	      this.setLoader();
	      this.updateStartTimeModel();
	      this.displayErrorMessageSecondPage = false;
	      this.displayErrorMessageThirdPage = false;
	
	      this.saving = true;
	
	      var isSecondPageValid = this.validateSecondPage(this.currentTimeInterval);
	
	      if (isSecondPageValid.status) {
	        var _this = this;
	
	        //_this.remain_loading_count++;
	
	        if (_this.postType === "source") {
	          console.log("getting the time zone info..");
	          console.dir(_this.currentTimeInterval);
	
	          _this.currentTimeInterval.contactInfo.lat = _this.currentTimeInterval.lat;
	          _this.currentTimeInterval.contactInfo.lng = _this.currentTimeInterval.lng;
	
	          this.$security.getEventShiftTimezoneInfo(_this.currentTimeInterval).then(function (response) {
	            _this.remain_loading_count--;
	
	            console.log("getEventShiftTimezoneInfo");
	            console.dir(response);
	            console.dir(response.data.length);
	
	            if (response.data.length == 0) {
	              _this.displayErrorMessageSecondPage = true;
	              _this.message = "Please return a more specific address because the selected address has wrong zip code.";
	              return;
	            }
	
	            _this.currentTimeInterval.startDateAndTimeMomentObj = moment();
	            _this.currentTimeInterval.endDateAndTimeMomentObj = moment(_this.currentTimeInterval.startDateAndTimeMomentObj).add(30, "days");
	            _this.currentTimeInterval.startDateAndTimeForDB = _this.currentTimeInterval.startDateAndTimeMomentObj.format();
	            _this.currentTimeInterval.start_time = _this.currentTimeInterval.startDateAndTimeForDB;
	            _this.currentTimeInterval.start_date = _this.currentTimeInterval.startDateAndTimeForDB;
	            _this.currentTimeInterval.endDateAndTimeForDB = _this.currentTimeInterval.endDateAndTimeMomentObj.format();
	            _this.currentTimeInterval.cost = 0;
	
	            isSecondPageValid = _this.validateDateAndLocationValue(_this.currentTimeInterval);
	
	            if (isSecondPageValid.status) {
	              _this.step = 2;
	              _this.currentTimeInterval.isError = undefined;
	              if (_this.$security.isUndefinedOrNull(_this.currentTimeInterval.hours)) {
	                _this.currentTimeInterval.hours = "0";
	              }
	              if (_this.$security.isUndefinedOrNull(_this.currentTimeInterval.minutes)) {
	                _this.currentTimeInterval.minutes = "0";
	              }
	              _this.event.timeIntervalsArray.sort(function (a, b) {
	                return new Date(a.startDateAndTimeForDB).getTime() - new Date(b.startDateAndTimeForDB).getTime();
	              });
	              console.log("_this.eventForDraftingData2222");
	              console.dir(_this.eventForDraftingData);
	              console.dir(_this.isEdit);
	
	              if (_this.eventForDraftingData || _this.isEdit) {
	                _this.event.jid = _this.$location.$$search.jid;
	                _this.event.eid = _this.$location.$$search.edit;
	                _this.addAdditionalShiftToAlreadyCreatedEvent(_this.eventForDraftingData, _this.event);
	              } else {
	                console.log("coming here...");
	                _this.saveDraftListener();
	                _this.unSetLoader();
	                _this.saving = false;
	              }
	            } else {
	              _this.currentTimeInterval.isError = "error-row";
	              _this.displayErrorMessageSecondPage = true;
	              _this.message = isSecondPageValid.message;
	              _this.unSetLoader();
	              _this.saving = false;
	            }
	          }, function (response) {
	            _this.remain_loading_count--;
	            _this.$timeout(function () {
	              jQuery("#show-application-alert").trigger("click");
	            }, 100);
	          });
	        } else {
	          console.log("trak1");
	          console.dir(_this.currentTimeInterval);
	          console.dir(_this.event.timeIntervalsArray);
	          _this.currentTimeInterval.contactInfo.lat = _this.currentTimeInterval.lat;
	          _this.currentTimeInterval.contactInfo.lng = _this.currentTimeInterval.lng;
	
	          this.$security.getEventShiftTimezoneInfo(_this.currentTimeInterval).then(function (response) {
	            console.log("returned from places end point");
	            console.dir(response);
	            //_this.remain_loading_count--;
	            if (response.data.length == 0) {
	              _this.unSetLoader();
	              _this.displayErrorMessageSecondPage = true;
	              _this.message = "Please return a more specific address because the selected address has wrong zip code.";
	              return;
	            }
	
	            var userTimeZoneName = moment.tz.guess();
	            var now = moment.tz(userTimeZoneName);
	            var nowThere = moment.tz(response.data[0].timeZoneId);
	            var timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
	            var zone = moment.tz.zone(moment.tz.guess());
	            var eventMangerOffsets = -zone.offsets[zone.offsets.length - 1];
	            var eventOffsets = response.data[0].rawOffset / 60000;
	            var tempEndDate = moment(_this.currentTimeInterval.start_date + " " + _this.currentTimeInterval.start_time).add(_this.currentTimeInterval.hours, "hours").add(eventMangerOffsets - eventOffsets, "minutes");
	
	            _this.currentTimeInterval.endDateAndTimeMomentObj = moment(tempEndDate).add(_this.currentTimeInterval.minutes, "minutes");
	            _this.currentTimeInterval.startDateAndTimeMomentObj = moment(_this.currentTimeInterval.start_date + " " + _this.currentTimeInterval.start_time).add(eventMangerOffsets - eventOffsets, "minutes");
	            _this.currentTimeInterval.durationInMinutes = _this.currentTimeInterval.endDateAndTimeMomentObj.diff(_this.currentTimeInterval.startDateAndTimeMomentObj, "minutes");
	            _this.currentTimeInterval.durationInHours = parseFloat((_this.currentTimeInterval.durationInMinutes / 60).toFixed(2));
	            _this.currentTimeInterval.startDateAndTimeForDB = _this.currentTimeInterval.startDateAndTimeMomentObj.format();
	            _this.currentTimeInterval.endDateAndTimeForDB = _this.currentTimeInterval.endDateAndTimeMomentObj.format();
	            _this.currentTimeInterval.cost = parseFloat(_this.currentTimeInterval.durationInHours * (_this.event.hourly_rate * _this.event.openings));
	
	            var dst_test = _this.currentTimeInterval.startDateAndTimeForDB;
	            var dst_result = moment(dst_test).isDST();
	
	            if (response.data[0].timeZoneId === "America/Phoenix" && dst_result === true) {
	              _this.currentTimeInterval.startDateAndTimeForDB = moment(_this.currentTimeInterval.startDateAndTimeForDB).add(1, "hours").format();
	              _this.currentTimeInterval.endDateAndTimeForDB = moment(_this.currentTimeInterval.endDateAndTimeForDB).add(1, "hours").format();
	            }
	
	            isSecondPageValid = _this.validateDateAndLocationValue(_this.currentTimeInterval);
	
	            console.log("isSecondPageValid");
	            console.dir(isSecondPageValid);
	
	            if (isSecondPageValid.status) {
	              _this.step = 2;
	              _this.saving = true;
	              _this.currentTimeInterval.isError = undefined;
	              if (_this.$security.isUndefinedOrNull(_this.currentTimeInterval.hours)) {
	                _this.currentTimeInterval.hours = "0";
	              }
	
	              if (_this.$security.isUndefinedOrNull(_this.currentTimeInterval.minutes)) {
	                _this.currentTimeInterval.minutes = "0";
	              }
	
	              console.log("right before sort");
	              console.dir(_this.event.timeIntervalsArray);
	
	              _this.event.timeIntervalsArray.sort(function (a, b) {
	                return new Date(a.startDateAndTimeForDB).getTime() - new Date(b.startDateAndTimeForDB).getTime();
	              });
	
	              console.log("_this.currentTimeInterval1111");
	              console.dir(_this.eventForDraftingData);
	              console.dir(_this.isEdit);
	              console.dir(_this.event);
	              console.dir(_this.currentTimeInterval);
	              console.dir(_this.event.timeIntervalsArray);
	
	              if (_this.eventForDraftingData || _this.isEdit) {
	                _this.event.jid = _this.$location.$$search.jid;
	                _this.event.eid = _this.$location.$$search.edit;
	
	                var lat_lng = {
	                  lat: _this.currentTimeInterval.contactInfo.lat,
	                  lng: _this.currentTimeInterval.contactInfo.lng
	                };
	
	                _this.currentTimeInterval.contactInfo.lat = response.data[0].lat;
	                _this.currentTimeInterval.contactInfo.lng = response.data[0].lng;
	
	                console.log("before addAdditionalShiftToAlreadyCreatedEvent");
	                console.dir(_this.event.timeIntervalsArray);
	                //kkkkkkkkkkkkk
	
	                console.log("zzzzzzzzzzz");
	                console.dir(_this.shiftIsBeingEdited);
	                _this.addAdditionalShiftToAlreadyCreatedEvent(_this.eventForDraftingData, _this.event);
	              } else {
	                console.log("we are down here..");
	                console.dir(_this.event);
	                console.dir(_this.isClone);
	
	                if (_this.isClone) {
	                  _this.currentTimeInterval.contactInfo.lat = response.data[0].lat;
	                  _this.currentTimeInterval.contactInfo.lng = response.data[0].lng;
	                  _this.addAdditionalShiftToAlreadyCreatedEvent(_this.eventForDraftingData, _this.event);
	                } else {
	                  _this.event.timeIntervalsArray[0].contactInfo.lat = response.data[0].lat;
	                  _this.event.timeIntervalsArray[0].contactInfo.lng = response.data[0].lng;
	
	                  _this.saveDraftListener();
	                  _this.unSetLoader();
	                  _this.saving = false;
	                }
	              }
	            } else {
	              _this.currentTimeInterval.isError = "error-row";
	              _this.displayErrorMessageSecondPage = true;
	              _this.message = isSecondPageValid.message;
	              _this.unSetLoader();
	              _this.saving = false;
	            }
	          }, function (response) {
	            _this.remain_loading_count--;
	            _this.$timeout(function () {
	              jQuery("#show-application-alert").trigger("click");
	              _this.unSetLoader();
	              _this.saving = false;
	            }, 100);
	          });
	        }
	      } else {
	        this.displayErrorMessageSecondPage = true;
	        this.message = isSecondPageValid.message;
	      }
	    }
	  }, {
	    key: "addAdditionalShiftToAlreadyCreatedEvent",
	    value: function addAdditionalShiftToAlreadyCreatedEvent(response, event) {
	      var _this = this;
	
	      var shifts = [];
	
	      console.log("addAdditionalShiftToAlreadyCreatedEvent");
	      console.dir(response);
	      console.dir(event);
	      console.dir(_this.timeIntervalsArrayTemp);
	      console.log("_this.event.timeIntervalsArray -- lets look at these");
	      console.dir(_this.event.timeIntervalsArray);
	      console.dir(_this.currentTimeInterval);
	      var tempShift = null;
	      var shiftHolder = [];
	
	      shiftHolder.push(_this.currentTimeInterval);
	
	      console.log("zzzzzzzzzz3");
	      console.dir(_this.shiftIsBeingEdited);
	
	      if (_this.shiftIsBeingEdited) {} else {
	        _this.event.timeIntervalsArray.push(_this.currentTimeInterval);
	      }
	
	      try {
	        shiftHolder.forEach(function (shift) {
	          console.log("_this.event.timeIntervalsArray each shift");
	          console.dir(shift);
	          tempShift = {
	            contactInfo: {
	              city: shift.contactInfo.city,
	              state: shift.contactInfo.state,
	              streetLine1: shift.contactInfo.streetLine1,
	              zipCode: shift.contactInfo.zipCode,
	              lat: shift.contactInfo.lat,
	              lng: shift.contactInfo.lng
	            },
	            timeInterval: {
	              startTime: shift.startDateAndTimeForDB,
	              endTime: shift.endDateAndTimeForDB
	            }
	          };
	
	          if (shift.id) {
	            tempShift.id = shift.id;
	          }
	          //shifts.push(tempShift);
	        });
	      } finally {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("AutoSave", {
	            event: _this.event,
	            questions: _this.questions,
	            update: true
	          });
	        });
	
	        console.log("how is it saving?");
	
	        console.log("in the finally of shifts");
	        console.dir(tempShift);
	        console.dir(_this.isClone);
	
	        if (!_this.isClone) {
	          if (response) {
	            var d = null;
	            if (response.draftData) {
	              d = response.draftData.data.jobblePool.jobbles[0].id;
	            } else {
	              d = response.data.subEvents[0].deduppedJobbles[0].id;
	            }
	
	            if (_this.shiftIsBeingEdited) {
	              _this.$events.updateExistingShift(tempShift).then(function (response) {
	                _this.findShiftPlaceId(response);
	                _this.displayErrorMessageThirdPage = false;
	                _this.$timeout(function () {
	                  _this.unSetLoader();
	                  _this.saving = false;
	                  _this.shiftIsBeingEdited = false;
	                }, 1500);
	              }, function (error) {
	                console.log("in error");
	                console.dir(error);
	                _this.$timeout(function () {
	                  _this.unSetLoader();
	                  _this.shiftIsBeingEdited = false;
	                }, 1500);
	              });
	            } else {
	              _this.$events.createNewShiftForExistingEvent(d, shifts, _this.event, tempShift).then(function (response) {
	                _this.findShiftPlaceId(response);
	                _this.displayErrorMessageThirdPage = false;
	                _this.$timeout(function () {
	                  _this.unSetLoader();
	                  _this.saving = false;
	                  _this.shiftIsBeingEdited = false;
	                }, 1500);
	              }, function (error) {
	                console.log("in error");
	                console.dir(error);
	                _this.$timeout(function () {
	                  _this.unSetLoader();
	                  _this.shiftIsBeingEdited = false;
	                }, 1500);
	              });
	            }
	          } else {
	            _this.$events.updateExistingDraft(null, shifts, _this.event).then(function (response) {
	              console.log("response");
	              console.dir(response);
	              _this.displayErrorMessageThirdPage = false;
	              _this.$timeout(function () {
	                _this.unSetLoader();
	                _this.saving = false;
	                _this.shiftIsBeingEdited = false;
	              }, 1500);
	            }, function (error) {
	              console.log("in error");
	              _this.$timeout(function () {
	                _this.unSetLoader();
	                _this.saving = false;
	                _this.shiftIsBeingEdited = false;
	              }, 1500);
	              console.dir(error);
	            });
	          }
	        } else {
	          console.log("lets update the  ui  the way we know");
	          _this.$timeout(function () {
	            _this.unSetLoader();
	            _this.saving = false;
	            _this.shiftIsBeingEdited = false;
	          }, 1500);
	        }
	      }
	    }
	  }, {
	    key: "setIdToFirstShift",
	    value: function setIdToFirstShift(response) {
	      var _this = this;
	
	      console.log("setIdToFirstShift");
	      console.dir(response);
	      console.dir(_this.event);
	      _this.event.timeIntervalsArray[0].id = response.draftData.data.jobblePool.jobbles[0].shifts[0].id;
	    }
	  }, {
	    key: "findShiftPlaceId",
	    value: function findShiftPlaceId(response) {
	      var _this = this;
	
	      console.log("findShiftPlaceId");
	      console.dir(response);
	      console.dir(_this.event.timeIntervalsArray);
	      _this.event.timeIntervalsArray.forEach(function (shift) {
	        if (!shift.id) {
	          shift.id = response.data.shiftId;
	        }
	      });
	    }
	  }, {
	    key: "validateSecondPage",
	    value: function validateSecondPage(eventObj) {
	      var keys = Object.keys(eventObj);
	      var values = keys.map(function (v) {
	        return eventObj[v];
	      });
	
	      var retObj = {};
	      retObj.status = true;
	
	      for (var x = 0; x < keys.length; x++) {
	        var val = eventObj[keys[x]];
	        if (this.$security.isUndefinedOrNull(val)) {
	          if (keys[x] === "address_temp") {
	            retObj.status = false;
	            retObj.message = "Please provide an address for a shift.";
	            return retObj;
	          }
	
	          /*
	           if (keys[x] === 'posting_duration' && this.postType === 'source') {
	               retObj.status = false;
	               retObj.message = "Please provide a duration for how long you would like this job posting to be listed.";
	               return retObj;
	             }
	          */
	          if (keys[x] === "start_date" && this.postType === "regular") {
	            retObj.status = false;
	            retObj.message = "Please provide a date and time for a shift.";
	            return retObj;
	          }
	          if (keys[x] === "start_time" && this.postType === "regular") {
	            retObj.status = false;
	            retObj.message = "Please provide a date and time for a shift.";
	            return retObj;
	          }
	        }
	      }
	      if (this.postType === "regular") {
	        if ((eventObj.hours === "0" || this.$security.isUndefinedOrNull(eventObj.hours)) && (eventObj.minutes === "0" || this.$security.isUndefinedOrNull(eventObj.minutes))) {
	          retObj.status = false;
	          retObj.message = "Please provide a duration for a shift.";
	          return retObj;
	        }
	      }
	
	      eventObj.lat = eventObj.address.lat;
	      eventObj.lng = eventObj.address.lng;
	
	      console.log("check eventObj");
	      console.dir(eventObj);
	
	      if (!eventObj.address_temp) {
	        eventObj.address_temp = {};
	        eventObj.address_temp.adr_address = eventObj.address.adr_address;
	      }
	
	      if (eventObj.address_temp) {
	        if (eventObj.address_temp.adr_address) {
	          if (eventObj.address_temp.adr_address.indexOf("span") > -1) {
	            eventObj.contactInfo = {};
	            var addressSplit = eventObj.address_temp.adr_address.split(",");
	            addressSplit.forEach(function (part, index) {
	              if (part.indexOf("street-address") > -1) {
	                var streetArray = /<span[^>]*>(.*?)<\/span>/.exec(part);
	                eventObj.contactInfo.streetLine1 = streetArray[1];
	              }
	              if (part.indexOf("locality") > -1) {
	                var cityArray = /<span[^>]*>(.*?)<\/span>/.exec(part);
	                eventObj.contactInfo.city = cityArray[1];
	              }
	              if (part.indexOf("region") > -1) {
	                var regionAndZipArray = part.split("> <");
	                regionAndZipArray.forEach(function (p) {
	                  if (p.indexOf("region") > -1) {
	                    var stateArray = /\s<span[^>]*>(.*?)<\/span/.exec(p);
	                    eventObj.contactInfo.state = stateArray[1];
	                  }
	                  if (p.indexOf("postal-code") > -1) {
	                    var zipArray = /span[^>]*>(.*?)<\/span>/.exec(p);
	                    eventObj.contactInfo.zipCode = zipArray[1];
	                  }
	                });
	              }
	              if (index + 1 === addressSplit.length) {
	                eventObj.address = eventObj.contactInfo.streetLine1 + " " + eventObj.contactInfo.city + " " + eventObj.contactInfo.state + " " + eventObj.contactInfo.zipCode;
	              }
	            });
	          }
	        }
	      }
	
	      if (this.$security.isUndefinedOrNull(eventObj.contactInfo)) {
	        retObj.status = false;
	        retObj.message = "Please make sure to select an address from the drop down before proceeding. Please do not copy and paste.";
	        return retObj;
	      } else {
	        if (this.$security.isUndefinedOrNull(eventObj.contactInfo.city) || this.$security.isUndefinedOrNull(eventObj.contactInfo.streetLine1) || this.$security.isUndefinedOrNull(eventObj.contactInfo.state) || this.$security.isUndefinedOrNull(eventObj.contactInfo.zipCode)) {
	          retObj.status = false;
	          retObj.message = "Please return a more specific address. For best results use a street address. (100 Main St. Boston, MA 02125).";
	          return retObj;
	        }
	      }
	
	      return retObj;
	    }
	  }, {
	    key: "validateDateAndLocationValue",
	    value: function validateDateAndLocationValue(eventObj) {
	      var r = {};
	      r.status = true;
	      if (this.postType === "source") {
	        r.status = true;
	      } else {
	        if (eventObj.startDateAndTimeMomentObj.isBefore(moment())) {
	          r.status = false;
	          r.message = "The date and time you have selected has already passed.";
	          return r;
	        }
	      }
	
	      return r;
	    }
	  }, {
	    key: "displayTotalCostOfJob",
	    value: function displayTotalCostOfJob() {
	      var _this = this;
	      _this.event.totalCostOfEvent = 0;
	      try {
	        _this.event.timeIntervalsArray.forEach(function (shift, i) {
	          _this.event.totalCostOfEvent = _this.event.totalCostOfEvent + shift.cost;
	        });
	      } finally {
	        return _this.event.totalCostOfEvent * (1 + _this.currentUser.company.defaultPlan.companyFeePct).toFixed(2);
	      }
	    }
	  }, {
	    key: "compareShiftsToEachOther",
	    value: function compareShiftsToEachOther(shifts) {
	      //kkkkkkkkkk
	
	      console.log("compare shifts to each other");
	      console.dir(shifts);
	
	      if (shifts) {
	        try {
	          shifts.forEach(function (shift, i) {
	            shift.isOverlapping = false;
	          });
	        } catch (err) {
	          console.log("ERROR SETTING OVERLAP BACK");
	          console.log(err);
	        }
	      }
	
	      var shiftsForCompare = shifts;
	
	      var r = {};
	
	      r.status = false;
	
	      this.event.totalCostOfEvent = 0;
	      this.event.totalMinutesWorked = 0;
	      this.event.hoursForDisplay = 0;
	
	      var _this = this;
	      try {
	        shifts.sort(function (a, b) {
	          return new Date(a.startDateAndTimeForDB).getTime() - new Date(b.startDateAndTimeForDB).getTime();
	        });
	      } finally {
	        try {
	          shifts.forEach(function (shift, i) {
	            var indexPlusOne = i + 1;
	            if (i + 1 < shifts.length) {
	              var shiftEndTime = shift.endDateAndTimeMomentObj;
	              var startTimeOfNextShift = shiftsForCompare[indexPlusOne].startDateAndTimeMomentObj;
	              if (startTimeOfNextShift.isBefore(shiftEndTime)) {
	                shift.isOverlapping = true;
	                shiftsForCompare[indexPlusOne].isOverlapping = true;
	                r.status = true;
	                r.message = "You have selected overlapping shifts. Please fix before proceeding.";
	                return r;
	              }
	            }
	            _this.event.totalCostOfEvent = _this.event.totalCostOfEvent + shift.cost;
	            _this.event.totalMinutesWorked = _this.event.totalMinutesWorked + shift.durationInMinutes;
	            _this.event.hoursForDisplay = _this.event.hoursForDisplay + shift.durationInHours;
	            if (shifts.length === i + 1) {
	              _this.event.totalMinutesWorked = Math.floor(_this.event.totalMinutesWorked / 60 * 100) / 100;
	            }
	          });
	        } finally {
	          return r;
	        }
	      }
	    }
	  }, {
	    key: "loopThroughShiftsAndDoShit",
	    value: function loopThroughShiftsAndDoShit() {
	      //console.log('loopThroughShiftsAndDoShit');
	      //console.dir(this.event);
	    }
	  }, {
	    key: "doesJobHaveClonedShift",
	    value: function doesJobHaveClonedShift(shifts) {
	      var _this = this;
	
	      var result = false;
	
	      console.log("does job have clone");
	      console.dir(shifts);
	
	      var clonedShift = shifts.find(function (o) {
	        return o.isClone === true;
	      });
	
	      console.log("clonedShift");
	      console.dir(clonedShift);
	
	      if (clonedShift) {
	        result = true;
	      }
	
	      console.log("result");
	      console.dir(result);
	
	      return result;
	    }
	  }, {
	    key: "completeDateAndLocation",
	    value: function completeDateAndLocation() {
	      var _this = this;
	
	      console.log("whats the event now");
	      console.dir(_this.event);
	
	      var findClone = _this.doesJobHaveClonedShift(_this.event.timeIntervalsArray);
	
	      console.log("findClone");
	      console.dir(findClone);
	
	      if (_this.event.openings_new) {
	        _this.event.openings = _this.event.openings_new;
	      }
	
	      if (this.sessionObj.isSaving) {
	        this.displayErrorMessageThirdPage = true;
	        this.message = "Please wait until job has been saved before proceeding.";
	      } else {
	        _this.$timeout(function () {
	          _this.$rootScope.$apply(function () {
	            _this.$rootScope.$broadcast("setJobType", {
	              postType: _this.postType,
	              currentUser: _this.currentUser,
	              sourcing: _this.isSourcingPost
	            });
	          });
	        });
	
	        if (_this.isClone) {
	          if (_this.eventResponse.surveyQuestions) {
	            if (_this.eventResponse.surveyQuestions.length > 0) {
	              _this.questions = _this.eventResponse.surveyQuestions;
	            }
	          }
	        }
	
	        if (_this.questions) {
	          _this.$timeout(function () {
	            _this.$rootScope.$apply(function () {
	              _this.$rootScope.$broadcast("checkQuestions", {
	                questions: _this.questions,
	                clone: _this.isClone,
	                postType: _this.postType,
	                sourcing: _this.isSourcingPost
	              });
	            });
	          });
	        }
	
	        var errorWithShifts = _this.compareShiftsToEachOther(_this.event.timeIntervalsArray);
	
	        if (!errorWithShifts.status) {
	          _this.displayErrorMessageThirdPage = false;
	          _this.statusBarStatus.step_3.visited = true;
	          _this.populateTracker(6);
	          _this.step = 6;
	        } else {
	          _this.displayErrorMessageThirdPage = true;
	          _this.message = errorWithShifts.message;
	        }
	      }
	    }
	  }, {
	    key: "closePostModalAndGoToEvents",
	    value: function closePostModalAndGoToEvents(goToOverviewPage) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        _this.remain_loading_count = 0;
	        _this.unSetLoader();
	        _this.saving = false;
	        _this.$tracking.reportJobPost(_this.event, _this.jobble_types, _this.currentUser);
	        jQuery("#modal-post-your-event .modal-header button.close").trigger("click");
	        jQuery("#modal-post-event .modal-header button.close").trigger("click");
	        jQuery(".modal-backdrop").remove();
	      }, 1000);
	
	      console.log("what do we have for information");
	      console.dir(_this.eventForDraftingData);
	      console.dir(_this.event);
	      console.dir(goToOverviewPage);
	      console.dir(_this.isClone);
	      console.dir(_this.eventIdForOverview);
	
	      _this.$timeout(function () {
	        if (goToOverviewPage === true) {
	          console.log("were true");
	
	          var id = null;
	
	          if (_this.eventIdForOverview) {
	            id = _this.eventIdForOverview;
	          } else {
	            id = _this.eventForDraftingData.draftData.data.jobblePool.jobbles[0].event.id;
	          }
	
	          _this.$state.go("eventoverview", { eventId: id });
	        } else {
	          _this.$state.go("jobsdashboard", { clearQuery: true });
	        }
	      }, 1200);
	    }
	  }, {
	    key: "collectCloudsFromBackEnd",
	    value: function collectCloudsFromBackEnd() {
	      var _this = this;
	      _this.remain_loading_count++;
	      _this.$companies.getTeams().then(function (data) {
	        _this.remain_loading_count--;
	        for (var i = 0; i < data.data.length; i++) {
	          var team = {
	            name: data.data[i].name,
	            id: data.data[i].id,
	            numberOfUsers: data.data[i].numberOfUsers,
	            checked: false
	          };
	          _this.teams.push(team);
	        }
	      }, function (data) {
	        _this.remain_loading_count--;
	        _this.teams = [];
	        alert("There was a fatal error retrieving your teams. Please try again later");
	      });
	    }
	  }, {
	    key: "collectClouds",
	    value: function collectClouds() {
	      var _this = this;
	      _this.event.cloudsForJobblePost = [];
	      for (var i = 0; i < _this.teams.length; i++) {
	        if (_this.teams[i].checked) {
	          _this.event.cloudsForJobblePost.push(_this.teams[i].id);
	        }
	      }
	    }
	  }, {
	    key: "postCreateEvent",
	    value: function postCreateEvent(num, goToJobOverview) {
	      var _this = this;
	      _this.displaySelectACloudError = false;
	      _this.remain_loading_count++;
	      _this.setLoader();
	
	      if (!_this.$location.$$search.eid) {
	        if (_this.event.postIsPrivate && _this.event.cloudsForJobblePost.length === 0) {
	          _this.displaySelectACloudError = true;
	          _this.unSetLoader();
	          return;
	        }
	      }
	      if (_this.event.cloudsForJobblePost.length > 0) {
	        if (_this.isPref) {
	          _this.event.postIsPrivate = false;
	        } else {
	          _this.event.postIsPrivate = true;
	        }
	      }
	      if (this.sessionObj.isSaving) {
	        alert("Please wait until your job has finished updating before trying to publish");
	      } else {
	        if (_this.isEdit) {
	          var eid = _this.$location.$$search.edit;
	          var jid = _this.$location.$$search.jid;
	          _this.unSetLoader();
	          _this.mapDataAndSave(eid, jid);
	        } else {
	          if (_this.eventForDraftingData) {
	            console.log("ktrack1");
	            var info = {};
	
	            if (_this.event.cloudsForJobblePost.length > 0) {
	              console.log("ktrack3");
	              if (_this.eventForDraftingData.draftData) {
	                console.log("ktrack4");
	                _this.$events.pushTeamsOntoEvent(_this.eventForDraftingData.draftData.data.jobblePool, _this.event.cloudsForJobblePost, true).then(function (r) {
	                  _this.$events.markJobAsPublished(_this.eventForDraftingData.draftData.data.jobblePool, _this.event, _this.questions).then(function (response) {
	                    _this.$events.markJobblesAsPublished(_this.eventForDraftingData.draftData.data.jobblePool, _this.event).then(function (bulkresp) {
	                      console.log("_this.eventForDraftingData.draftData.data.jobblePool");
	                      console.dir(_this.eventForDraftingData.draftData.data.jobblePool);
	                      _this.closePostModalAndGoToEvents(goToJobOverview);
	                      info.id = _this.eventForDraftingData.draftData.data.jobblePool.id;
	                      info.visibility = "EXCLUSIVE";
	                      _this.notifyUsers(info);
	                    });
	                  });
	                });
	              } else {
	                console.log("ktrack5");
	                _this.$events.markJobAsPublished(_this.eventForDraftingData, _this.event, _this.questions).then(function (response) {
	                  _this.$events.markJobblesAsPublished(_this.eventForDraftingData, _this.event).then(function (bulkresp) {
	                    console.log("_this.eventForDraftingData 2");
	                    console.dir(_this.eventForDraftingData);
	                    _this.closePostModalAndGoToEvents(goToJobOverview);
	                    info.id = _this.eventForDraftingData.data.subEvents[0].deduppedJobbles[0].jobblePoolId;
	                    info.visibility = "EXCLUSIVE";
	                    _this.notifyUsers(info);
	                  });
	                });
	              }
	            } else {
	              if (_this.eventForDraftingData.draftData) {
	                console.log("ktrack6");
	                _this.$events.markJobAsPublished(_this.eventForDraftingData.draftData.data.jobblePool, _this.event, _this.questions).then(function (response) {
	                  _this.$events.markJobblesAsPublished(_this.eventForDraftingData.draftData.data.jobblePool, _this.event).then(function (bulkresp) {
	                    console.log("notify here");
	                    console.dir(_this.eventForDraftingData.draftData.data.jobblePool);
	                    info.id = _this.eventForDraftingData.draftData.data.jobblePool.id;
	                    info.visibility = "PUBLIC";
	                    _this.closePostModalAndGoToEvents(goToJobOverview);
	                    _this.notifyUsers(info);
	                  });
	                });
	              } else {
	                console.log("ktrack7");
	                _this.$events.markJobAsPublished(_this.eventForDraftingData, _this.event, _this.questions).then(function (response) {
	                  _this.$events.markJobblesAsPublished(_this.eventForDraftingData, _this.event).then(function (bulkresp) {
	                    console.log("_this.eventForDraftingData");
	                    console.dir(_this.eventForDraftingData);
	                    _this.closePostModalAndGoToEvents(goToJobOverview);
	                    info.id = _this.eventForDraftingData.data.subEvents[0].deduppedJobbles[0].jobblePoolId;
	                    info.visibility = "PUBLIC";
	                    _this.notifyUsers(info);
	                  });
	                });
	              }
	            }
	          } else {
	            console.log("ktrack2");
	            console.dir(_this.event);
	            _this.$events.createEvent(_this.event).then(function (resp) {
	              console.log("response from create event...");
	              console.dir(resp.data);
	              console.dir(_this.event.cloudsForJobblePost);
	
	              var info = {};
	              var event_id = resp.data.jobblePool.subEvent.event.id;
	
	              _this.eventIdForOverview = resp.data.jobblePool.subEvent.event.id;
	              var team_ids = _this.event.cloudsForJobblePost;
	              console.log("team ids");
	              console.dir(team_ids);
	              if (team_ids.length > 0) {
	                _this.$events.pushTeamsOntoEvent(event_id, team_ids, null, true).then(function (response) {
	                  console.log("pushTeamsOntoEvent resp");
	                  console.dir(resp);
	                  _this.closePostModalAndGoToEvents(goToJobOverview);
	                  if (resp.data.notifyForNew === true) {
	                    info.id = resp.data.jobblePool.id;
	                    info.visibility = "EXCLUSIVE";
	                    _this.notifyUsers(info);
	                  }
	                }, function (error) {
	                  console.log("in error");
	                  console.dir(error);
	                  _this.closePostModalAndGoToEvents(goToJobOverview);
	                });
	              } else {
	                //kkkk
	                //were going to at notify users end point here
	                _this.closePostModalAndGoToEvents(goToJobOverview);
	                if (resp.data.notifyForNew === true) {
	                  info.id = resp.data.jobblePool.id;
	                  info.visibility = "PUBLIC";
	                  console.log("info");
	                  console.dir(info);
	                  _this.notifyUsers(info);
	                }
	              }
	            }, function (data) {
	              _this.$timeout(function () {
	                _this.unSetLoader();
	                jQuery("#show-application-alert").trigger("click");
	              }, 100);
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: "notifyUsers",
	    value: function notifyUsers(info) {
	      var _this = this;
	      console.log("what is the info");
	      console.dir(info);
	      _this.$events.notifyJobblers(info).then(function (r) {
	        console.log("notify response...");
	        console.dir(r);
	      }, function (error) {
	        console.log("in notify error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "charge",
	    value: function charge() {
	      var _this = this;
	      var data = {};
	      if (_this.currentUser.company.defaultPlan.name) {
	        if (_this.currentUser.company.defaultPlan.name.indexOf("No_Recruit_Charge") > -1) {
	          _this.postCreateEvent();
	          return;
	        }
	      }
	      var invoice = _this.currentUser.company.payByInvoice;
	
	      if (_this.currentUser.company.payByInvoice !== true) {
	        data.token = _this.tokenToCharge;
	      }
	      data.amount = 5000;
	      data.user = "accounting@jobble.com";
	      data.note = "Payment for job posting.";
	      _this.remain_loading_count++;
	      _this.$companies.chargeForPost(data, invoice).then(function (response) {
	        _this.$timeout(function () {
	          _this.postCreateEvent();
	        }, 500);
	      }, function (error) {
	        alert("There was an error charging your card. Please contact support");
	      });
	    }
	  }, {
	    key: "getJobbleTypeName",
	    value: function getJobbleTypeName() {
	      var _this = this;
	      var jobbleTypeName;
	      for (var i = 0; i < this.jobble_types.length; i++) {
	        if (this.jobble_types[i].id === parseInt(this.event.jobble_type)) {
	          jobbleTypeName = this.jobble_types[i].name;
	        }
	      }
	      return jobbleTypeName;
	    }
	  }, {
	    key: "uploadLogo",
	    value: function uploadLogo() {
	      var _this = this;
	      _this.$timeout(function () {
	        jQuery("#upload-logo").trigger("click");
	      });
	    }
	  }, {
	    key: "uploadFiles",
	    value: function uploadFiles(file, invalidFiles) {
	      //console.log('uploadFiles');
	      //console.dir(file);
	      //console.dir(invalidFiles);
	      //var uploadUrlCompany = _this.$env.getAPIEndPoint() + 'jbl/v1/companies/' + _this.currentUser.companyId + '/files?format=json&fileType=9&replace=true';
	    }
	  }, {
	    key: "submitNewUserTest",
	    value: function submitNewUserTest() {
	      //console.log('auto submit...');
	    }
	  }, {
	    key: "startRegPost",
	    value: function startRegPost(type) {
	      this.step = 0;
	      this.postType = type;
	      setTimeout(function () {
	        jQuery("#datepicker").datepicker({
	          showOn: "both",
	          buttonImage: "/app/vendor/images/calender.png",
	          buttonImageOnly: true,
	          buttonText: "Select date",
	          dateFormat: "M dd, yy"
	        });
	      }, 100);
	      this.reportJobTypeSelection(type);
	    }
	  }, {
	    key: "reportJobTypeSelection",
	    value: function reportJobTypeSelection(type) {
	      var _this = this;
	      if (_this.currentUser) {
	        if (_this.currentUser.username.indexOf("jobble.com") === -1 || _this.currentUser.username.indexOf("jobbleapp.com") === -1) {
	          if (type === "regular") {
	            _this.$tracking.reportJobTypeSelectionOnDemand();
	          } else {
	            _this.$tracking.reportJobTypeSelectionSourcing();
	          }
	        }
	      } else {
	        if (type === "regular") {
	          _this.$tracking.reportJobTypeSelectionOnDemand();
	        } else {
	          _this.$tracking.reportJobTypeSelectionSourcing();
	        }
	      }
	    }
	  }, {
	    key: "backToPostType",
	    value: function backToPostType() {
	      this.step = 10;
	      this.displayFirstPageErrorMessage = false;
	    }
	  }, {
	    key: "navigateTheWizard",
	    value: function navigateTheWizard(params) {
	      var _this = this;
	
	      _this.event.questions = params.questions;
	      _this.questions = params.questions;
	
	      if (params.type === "forward") {
	        if (_this.payWasChanged) {
	          _this.recalculatePay();
	        }
	
	        _this.statusBarStatus.step_4.visited = true;
	        _this.populateTracker(3);
	        _this.step = 3;
	      } else {
	        if (_this.postType === "regular") {
	          _this.step = 2;
	        } else {
	          _this.step = 2;
	        }
	      }
	    }
	  }, {
	    key: "backToQuestions",
	    value: function backToQuestions() {
	      var _this = this;
	
	      _this.step = 6;
	
	      console.log("bbbbbbbbbb2");
	      _this.$timeout(function () {
	        _this.$rootScope.$apply(function () {
	          _this.$rootScope.$broadcast("checkQuestions", {
	            questions: _this.questions,
	            clone: _this.isClone,
	            postType: _this.postType
	          });
	        });
	      });
	    }
	  }, {
	    key: "calcHourlyRate",
	    value: function calcHourlyRate() {
	      var _this = this;
	
	      var str = "";
	
	      if (_this.event.hourly_rate) {
	        str = _this.event.hourly_rate;
	        if (str.indexOf(".") > -1) {
	          str = parseFloat(str).toFixed(2);
	        } else {
	          //console.log('no decimal');
	          str = parseInt(str).toFixed(2);
	        }
	      } else {
	        str = "N/A";
	      }
	
	      return str;
	    }
	  }, {
	    key: "updateTracker",
	    value: function updateTracker(pageAttemptingToGoTo) {
	      var _this = this;
	
	      if (_this.step === 6) {
	        _this.$timeout(function () {
	          _this.$rootScope.$apply(function () {
	            _this.$rootScope.$broadcast("triggerQuestionsGetter", {});
	          });
	        });
	      }
	
	      console.log("update tracker");
	      console.dir(pageAttemptingToGoTo);
	
	      if (pageAttemptingToGoTo !== 0) {
	        _this.updateEventWithLatestData();
	      }
	
	      if (_this.tracker.arrayOfVistedSteps.indexOf(pageAttemptingToGoTo) > -1) {
	        if (pageAttemptingToGoTo === 1) {
	          if (_this.event.timeIntervalsArray.length > 0 && !_this.$security.isUndefinedOrNull(_this.event.timeIntervalsArray[0].address)) {
	            if (_this.postType === "regular") {
	              _this.updateEventWithLatestData();
	              _this.tracker.previousStep = _this.step;
	              _this.tracker.currentStep = 2;
	              _this.step = 2;
	              _this.showDateAndTimeUI();
	            } else {
	              _this.tracker.previousStep = _this.step;
	              _this.tracker.currentStep = 22;
	              _this.step = 22;
	              _this.showDateAndTimeUI();
	            }
	          } else {
	            _this.tracker.previousStep = _this.step;
	            _this.tracker.currentStep = pageAttemptingToGoTo;
	            _this.step = pageAttemptingToGoTo;
	            _this.showDateAndTimeUI();
	          }
	        } else {
	          if (pageAttemptingToGoTo === 6) {
	            _this.$timeout(function () {
	              _this.$rootScope.$apply(function () {
	                _this.$rootScope.$broadcast("checkQuestions", {
	                  questions: _this.questions,
	                  clone: _this.isClone,
	                  postType: _this.postType
	                });
	              });
	            });
	            _this.tracker.previousStep = _this.step;
	            _this.tracker.currentStep = pageAttemptingToGoTo;
	            _this.step = pageAttemptingToGoTo;
	            _this.showDateAndTimeUI();
	          } else {
	            _this.tracker.previousStep = _this.step;
	            _this.tracker.currentStep = pageAttemptingToGoTo;
	            _this.step = pageAttemptingToGoTo;
	            _this.showDateAndTimeUI();
	            _this.$timeout(function () {
	              _this.$rootScope.$emit("SetManagerFromBack", {
	                id: _this.event.manager
	              });
	            });
	          }
	        }
	      } else {
	        console.log("we dont have a match and so we cant go");
	      }
	    }
	  }, {
	    key: "updateEventWithLatestData",
	    value: function updateEventWithLatestData() {
	      if (this.eventForDraftingData && this.eventDetailsHaveChangedAfterCreation) {
	        this.eventDetailsHaveChangedAfterCreation = false;
	        this.updateEventDetailsFromFirstPage(this.eventForDraftingData, this.event, this.detailsChangedStatus);
	      }
	    }
	  }, {
	    key: "populateTracker",
	    value: function populateTracker(page) {
	      var _this = this;
	
	      if (_this.tracker.arrayOfVistedSteps.indexOf(page) > -1) {
	        //console.log('we already have it so no needed to add it');
	      } else {
	        _this.tracker.arrayOfVistedSteps.push(page);
	      }
	    }
	  }, {
	    key: "checkForTeams",
	    value: function checkForTeams() {
	      var _this = this;
	
	      if (!_this.$rootScope.teams) {
	        _this.loadTeamsSimple();
	      }
	    }
	  }, {
	    key: "loadTeamsSimple",
	    value: function loadTeamsSimple() {
	      var _this = this;
	
	      var teamsSimple = [];
	
	      _this.$companies.getTeamsSimple().then(function (data) {
	        try {
	          data.data.forEach(function (team, index) {
	            var teamsObj = {};
	            teamsObj.name = team.name;
	            teamsObj.id = team.id;
	            teamsSimple.push(teamsObj);
	          });
	        } finally {
	          _this.$timeout(function () {
	            _this.$rootScope.teamsSimple = teamsSimple;
	          });
	        }
	      }, function (data) {
	        _this.$rootScope.teamsSimple = [];
	
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "setAvatarImageToUsersOfTeam",
	    value: function setAvatarImageToUsersOfTeam(team) {
	      var _this = this;
	
	      team.users.forEach(function (userProfile) {
	        if (!_this.$security.isUndefinedOrNull(userProfile.picture1s)) {
	          userProfile.picture1s.forEach(function (pic) {
	            if (pic.indexOf("75x75") > -1) {
	              userProfile.pictureAvatarUrl = pic;
	            }
	            if (pic.indexOf("160x160") > -1) {
	              userProfile.pictureAvatarUrlBig = pic;
	            }
	          });
	        }
	
	        if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
	          userProfile.pictureAvatarUrl = userProfile.pictureAvatarUrlBig;
	        }
	        if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
	          userProfile.pictureAvatarUrl = "/app/vendor/images/defaultimg.jpeg";
	        }
	      });
	    }
	  }, {
	    key: "postEventLink",
	    value: function postEventLink() {
	      var _this = this;
	
	      console.log("postEventLink");
	      console.dir(_this.event);
	      console.dir(_this.currentUser);
	
	      var freePlan = null;
	
	      _this.postingLink = true;
	
	      if (_this.currentUser) {
	        freePlan = _this.currentUser.company.defaultPlan.name.indexOf("No_Recruit_Charge") > -1;
	      }
	
	      if (!_this.isSourcingPost || freePlan) {
	        _this.$timeout(function () {
	          jQuery("#modal-post-event-link").trigger("click");
	        });
	      } else {
	        if (_this.currentUser) {
	          if (_this.currentUser.company.payByInvoice === true) {
	            //alert("Hello");
	
	            _this.$timeout(function () {
	              jQuery("#modal-post-event-link").trigger("click");
	            });
	          } else {
	            if (_this.currentUser.company.undeletedPaymentInfos.length > 0) {
	              _this.$timeout(function () {
	                _this.$rootScope.$emit("SetPayForPostData", {
	                  cards: true
	                });
	                jQuery("#link-modal-pick-card").trigger("click");
	              });
	            } else {
	              _this.$timeout(function () {
	                _this.$rootScope.$emit("SetPayForPostData", {});
	                jQuery("#link-modal-add-card").trigger("click");
	              });
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: "showPostModalCC",
	    value: function showPostModalCC(user) {
	      var _this = this;
	
	      console.log("showPostModal");
	      console.dir(user);
	
	      if (user) {
	        _this.tokenToCharge = user.company.paymentInfos[0].cardToken;
	      }
	      _this.$timeout(function () {
	        jQuery("#modal-post-event-link").trigger("click");
	      }, 500);
	    }
	  }, {
	    key: "showPostModalCC",
	    value: function showPostModalCC(user) {
	      var _this = this;
	
	      console.log("showPostModal");
	      console.dir(user);
	
	      if (user) {
	        _this.tokenToCharge = user.company.paymentInfos[0].cardToken;
	      }
	      _this.$timeout(function () {
	        jQuery("#modal-post-event-link").trigger("click");
	      }, 500);
	    }
	  }, {
	    key: "jobblerRateOnBoard",
	    value: function jobblerRateOnBoard(rate) {
	      var _this = this;
	
	      if (rate) {
	        rate = parseFloat(rate);
	        rate = rate * (1 - _this.currentUser.company.defaultPlan.jobblerFeePct);
	        return rate;
	      }
	    }
	  }, {
	    key: "calcNumbers",
	    value: function calcNumbers() {
	      var _this = this;
	      _this.detailsChanged(2, true);
	      if (isNaN(_this.event.hourly_rate_adj)) {
	        _this.event.hourly_rate_adj = "";
	        if (_this.isClone || _this.ismarketing) {
	          _this.event.hourly_rate_adj = (parseFloat(_this.event.hourly_rate) * (1 - _this.currentUser.company.defaultPlan.jobblerFeePct)).toFixed(2);
	        }
	      } else {
	        if (!_this.currentUser) {
	          _this.event.hourly_rate_adj = (parseFloat(_this.event.hourly_rate) * 0.75).toFixed(2);
	        } else {
	          _this.event.hourly_rate_adj = (parseFloat(_this.event.hourly_rate) * (1 - _this.currentUser.company.defaultPlan.jobblerFeePct)).toFixed(2);
	        }
	        if (isNaN(_this.event.hourly_rate_adj)) {
	          _this.event.hourly_rate_adj = "";
	        }
	      }
	    }
	  }, {
	    key: "calcNumbersAdj",
	    value: function calcNumbersAdj() {
	      var _this = this;
	      _this.detailsChanged(2, true);
	      if (isNaN(_this.event.hourly_rate)) {
	        _this.event.hourly_rate = "";
	      } else {
	        if (!_this.currentUser) {
	          var p = 100 - 0.25 * 100;
	          var x = parseFloat(_this.event.hourly_rate_adj) * 100;
	          var z = x / p;
	          _this.event.hourly_rate = z.toFixed(2);
	        } else {
	          var _p = 100 - _this.currentUser.company.defaultPlan.jobblerFeePct * 100;
	          var _x = parseFloat(_this.event.hourly_rate_adj) * 100;
	          var _z = _x / _p;
	          _this.event.hourly_rate = _z.toFixed(2);
	        }
	        if (isNaN(_this.event.hourly_rate)) {
	          _this.event.hourly_rate = "";
	        }
	      }
	    }
	  }, {
	    key: "setEventIdForDrafting",
	    value: function setEventIdForDrafting(data) {
	      var _this = this;
	      console.log("SetEventIdForDrafting");
	      console.dir(data);
	      _this.eventForDraftingData = data;
	      _this.saving = false;
	      _this.sessionObj.isSaving = false;
	      _this.displayErrorMessageThirdPage = false;
	      _this.remain_loading_count = 0;
	      _this.setIdToFirstShift(data);
	    }
	  }, {
	    key: "populateDetails",
	    value: function populateDetails(status) {
	      var _this = this;
	      if (_this.arrayOfStatus.indexOf(status) > -1) {} else {
	        _this.arrayOfStatus.push(status);
	      }
	    }
	  }, {
	    key: "detailsChanged",
	    value: function detailsChanged(status, payWasChanged) {
	      var _this = this;
	      if (_this.eventForDraftingData) {
	        _this.populateDetails(status);
	        _this.eventDetailsHaveChangedAfterCreation = true;
	        if (payWasChanged) {
	          _this.payWasChanged = true;
	        }
	      }
	    }
	  }, {
	    key: "changeOpeningsOnClone",
	    value: function changeOpeningsOnClone() {
	      var _this = this;
	
	      var openings_int = parseInt(_this.openings_for_clone.value, 10);
	      _this.event.openings_new = openings_int;
	      console.dir(_this.event);
	    }
	  }, {
	    key: "recalculatePay",
	    value: function recalculatePay() {
	      var _this = this;
	      _this.event.totalCostOfEvent = parseFloat(_this.event.hourly_rate) * _this.event.hoursForDisplay * _this.event.openings;
	    }
	  }, {
	    key: "setJobbleTypesListener",
	    value: function setJobbleTypesListener(params) {
	      var _this = this;
	      console.log("setJobbleTypesListener");
	      console.dir(params);
	
	      _this.jobble_types = params.jobbleTypes;
	    }
	  }, {
	    key: "displayTotalCostOfJob",
	    value: function displayTotalCostOfJob() {
	      var _this = this;
	      _this.event.totalCostOfEvent = 0;
	      try {
	        _this.event.timeIntervalsArray.forEach(function (shift, i) {
	          _this.event.totalCostOfEvent = _this.event.totalCostOfEvent + shift.cost;
	        });
	      } finally {
	        return _this.event.totalCostOfEvent * (1 + _this.currentUser.company.defaultPlan.companyFeePct).toFixed(2);
	      }
	    }
	  }, {
	    key: "setPostType",
	    value: function setPostType(arg) {
	      var _this = this;
	
	      console.log("postOptions.value");
	      console.dir(_this.postOptions.value);
	      console.dir(arg);
	      console.dir(_this.event);
	      console.dir(_this.eventForDraftingData);
	
	      if (arg === "Sourcing") {
	        _this.isSourcingPost = true;
	        _this.postType = "source";
	        _this.postOptions.value = "Sourcing";
	        if (_this.currentUser) {
	          _this.storePreferredPostType(1);
	          if (_this.isClone) {
	            _this.tempEventHolderForSwitchingDuringClones.push(_this.event);
	            _this.mapEvent(1);
	            console.log("console.dir(_this.tempEventHolderForSwitchingDuringClones)");
	            console.dir(_this.tempEventHolderForSwitchingDuringClones);
	          } else {
	            console.log("not a clone....");
	            if (_this.eventForDraftingData) {
	              _this.updatePostTypeOnBackEnd(arg);
	            }
	          }
	        }
	      } else {
	        _this.isSourcingPost = false;
	        _this.postType = "regular";
	        _this.postOptions.value = "Ondemand";
	        if (_this.currentUser) {
	          _this.storePreferredPostType(2);
	          if (_this.isClone) {
	            _this.tempEventHolderForSwitchingDuringClones.push(_this.event);
	            _this.mapEvent(2);
	            console.log("tempEventHolderForSwitchingDuringClones");
	            console.dir(_this.tempEventHolderForSwitchingDuringClones);
	          }
	        }
	      }
	    }
	  }, {
	    key: "updatePostTypeOnBackEnd",
	    value: function updatePostTypeOnBackEnd(arg) {
	      var _this = this;
	      var is_connect = null;
	      if (arg === "Sourcing") {
	        is_connect = true;
	      } else {
	        is_connect = false;
	      }
	      var event_id = _this.eventForDraftingData.draftData.data.jobblePool.jobbles[0].eventId;
	      if (event_id) {
	        var payload = {};
	        payload.event_id = event_id;
	        payload.isSourcingPost = is_connect;
	        _this.$events.updatePostType(payload).then(function (response) {
	          console.log("response");
	          console.dir(response);
	        }, function (error) {
	          console.log("error");
	          console.dir(error);
	        });
	      }
	    }
	  }, {
	    key: "mapEvent",
	    value: function mapEvent(type) {
	      var _this = this;
	
	      if (type === 1) {
	        console.log("type 1");
	        console.dir(_this.event);
	      } else {
	        console.log("type 2");
	        console.dir(_this.event);
	      }
	    }
	  }, {
	    key: "triggerPostTypeModal",
	    value: function triggerPostTypeModal() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        jQuery("#choose-post-type").modal();
	      }, 500);
	
	      _this.$timeout(function () {
	        _this.$location.search("tut", null);
	        _this.$location.replace();
	      }, 1000);
	    }
	  }, {
	    key: "selectPostType",
	    value: function selectPostType(x) {
	      var _this = this;
	
	      //do the loader here
	      console.log("selectPostType");
	      _this.$timeout(function () {
	        jQuery("#choose-post-type").modal("toggle");
	      }, 300);
	
	      if (x === 1) {
	        _this.postOptions.value = "Sourcing";
	        _this.isSourcingPost = true;
	        _this.postType = "source";
	      } else if (x === 2) {
	        _this.postOptions.value = "On-demand";
	        _this.postType = "regular";
	        _this.isSourcingPost = false;
	      } else if (x === 3) {
	        _this.postOptions.value = "On-demand";
	        _this.postType = "regular";
	        _this.isSourcingPost = false;
	      }
	      if (x === 3) {
	        if (_this.currentUser) {
	          _this.$companies.update_post_type(0).then(function (response) {
	            _this.$localStorage.logged_user.company.postingTypesAllowed = response.data.postingTypesAllowed;
	            _this.currentUser.company.postingTypesAllowed = response.data.postingTypesAllowed;
	            _this.set_new_post_types_to_header(response.data.postingTypesAllowed);
	            _this.$timeout(function () {
	              _this.$state.go("postorder");
	            }, 500);
	          }, function (error) {
	            console.log("error");
	            console.dir(error);
	          });
	        }
	      } else {
	        if (_this.currentUser) {
	          _this.storePreferredPostType(x);
	        }
	      }
	    }
	  }, {
	    key: "set_new_post_types_to_header",
	    value: function set_new_post_types_to_header(types) {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetNewPostTypesToHeader", types);
	      });
	    }
	  }, {
	    key: "storePreferredPostType",
	    value: function storePreferredPostType(type) {
	      var _this = this;
	      if (type === 3) {
	        console.log("store this on the backend");
	        console.dir(type);
	      } else {
	        _this.$companies.storePreferredPostType(type).then(function (response) {
	          _this.$auth.reloadNewPostingType().then(function (success) {
	            _this.currentUser.company.payPerConnect = success.data.company.payPerConnect;
	          }, function (error) {});
	        }, function (error) {
	          alert("Error storing preferred posting types");
	        });
	      }
	    }
	  }, {
	    key: "setPostTypeInit",
	    value: function setPostTypeInit() {
	      var _this = this;
	      if (_this.currentUser) {
	        if (_this.$stateParams.pt) {
	          if (_this.$stateParams.pt === "ondemand") {
	            _this.postOptions.value = "On-demand";
	            _this.isSourcingPost = false;
	            _this.postType = "regular";
	          } else {
	            _this.postOptions.value = "Sourcing";
	            _this.isSourcingPost = true;
	            _this.postType = "source";
	          }
	          return;
	        }
	        if (_this.currentUser.company.payPerConnect === 1) {
	          _this.postOptions.value = "Sourcing";
	          _this.isSourcingPost = true;
	          _this.postType = "source";
	        } else {
	          _this.postOptions.value = "On-demand";
	          _this.isSourcingPost = false;
	          _this.postType = "regular";
	        }
	      }
	    }
	  }, {
	    key: "closeCreditCardModal",
	    value: function closeCreditCardModal(data) {
	      var _this = this;
	      _this.tokenToCharge = data.card.cardToken;
	      _this.$timeout(function () {
	        jQuery("#modal-pick-card .modal-header button.close").trigger("click");
	      });
	
	      _this.$timeout(function () {
	        jQuery("#modal-post-event-link").trigger("click");
	      }, 500);
	    }
	  }, {
	    key: "handleSourcingPost",
	    value: function handleSourcingPost() {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetPayForPostData", {});
	        jQuery("#link-modal-add-card").trigger("click");
	      }, 600);
	    }
	  }, {
	    key: "locationKeyPress",
	    value: function locationKeyPress(event) {
	      console.log("locationKeyPress");
	      console.dir(event);
	      console.dir(timeInterval.address);
	    }
	  }, {
	    key: "submitLocation",
	    value: function submitLocation() {
	      var _this = this;
	    }
	  }, {
	    key: "setPaymentPlan",
	    value: function setPaymentPlan() {
	      var _this = this;
	    }
	  }, {
	    key: "checkForAdmin",
	    value: function checkForAdmin() {
	      var _this = this;
	      if (_this.currentUser) {
	        if (_this.currentUser.username.indexOf("jobble.com") > -1 || _this.currentUser.username.indexOf("jobbleapp.com") > -1) {
	          _this.hourly_rate_based_on_admin = 1;
	        } else {
	          _this.hourly_rate_based_on_admin = 14;
	        }
	      }
	    }
	  }, {
	    key: "determineIfPrivate",
	    value: function determineIfPrivate(event) {
	      var _this = this;
	      if (event.data.orderNumber) {
	        _this.event.orderNumber = event.data.orderNumber;
	      }
	    }
	  }, {
	    key: "determineIfPublished",
	    value: function determineIfPublished(event) {
	      var _this = this;
	      if (!event.data.subEvents[0].deduppedJobbles[0].isPublished) {
	        _this.eventForDraftingData = event;
	      }
	    }
	  }, {
	    key: "check_for_state_params",
	    value: function check_for_state_params() {
	      var _this = this;
	      console.log("_this.$stateParams");
	      console.dir(_this.$stateParams);
	
	      if (_this.$stateParams.job_posting_type === "sourcing") {
	        _this.postType = "source";
	        _this.isSourcingPost = true;
	      } else if (_this.$stateParams.job_posting_type === "ondemand") {
	        _this.postType = "regular";
	        _this.isSourcingPost = false;
	      } else {
	        console.log("deal with delivery tonight");
	      }
	    }
	  }, {
	    key: "set_new_posting_type",
	    value: function set_new_posting_type(params) {
	      var _this = this;
	      if (params.posting_type_set === "ondemand") {
	        _this.postType = "regular";
	        _this.isSourcingPost = false;
	      } else {
	        _this.postType = "source";
	        _this.isSourcingPost = true;
	      }
	      _this.$timeout(function () {
	        _this.remain_loading_count = 0;
	      }, 300);
	    }
	  }, {
	    key: "map_state_params_to_fields",
	    value: function map_state_params_to_fields() {
	      var _this = this;
	      var data = {};
	      _this.ismarketing = true;
	      if (_this.$stateParams.job_posting_type === "ondemand") {
	        data.dress_code = _this.$stateParams.dress_code;
	        data.job_description = _this.$stateParams.job_description;
	        data.job_posting_type = _this.$stateParams.job_posting_type;
	        data.job_title = _this.$stateParams.job_title;
	        data.jobble_type = _this.$stateParams.jobble_type;
	        data.pay_rate = _this.$stateParams.pay_rate;
	        data.pay_rate_jblr = _this.$stateParams.pay_rate_jblr;
	      } else if (_this.$stateParams.job_posting_type === "sourcing") {
	        data.job_description = _this.$stateParams.job_description;
	        data.job_posting_type = _this.$stateParams.job_posting_type;
	        data.job_title = _this.$stateParams.job_title;
	        data.jobble_type = _this.$stateParams.jobble_type;
	        data.pay_rate = _this.$stateParams.hourly_rate;
	      }
	      data.token = _this.$stateParams.t;
	      var promise = _this.$auth.validate_from_marketing_site(data.token);
	      promise.then(function (response) {
	        _this.handle_marketing_user_response(response.data, data);
	        _this.currentUser = response.data;
	      }, function (error) {
	        _this.handle_marketing_user_error(error);
	      });
	    }
	  }, {
	    key: "handle_marketing_user_response",
	    value: function handle_marketing_user_response(response, data) {
	      var _this = this;
	      if (data.job_posting_type === "ondemand") {
	        _this.map_marketing_event(data, 1);
	      } else if (data.job_posting_type === "sourcing") {
	        _this.map_marketing_event(data, 2);
	      } else if (data.job_posting_type === "delivery") {
	        _this.map_marketing_event(data, 3);
	      }
	    }
	  }, {
	    key: "check_for_marketing_site_params",
	    value: function check_for_marketing_site_params() {
	      var _this = this;
	      var data = {};
	      console.log("***check_for_marketing_site_params**");
	      console.dir(_this.$location.$$search);
	      console.dir(_this.$stateParams);
	      if (_this.$stateParams) {
	        if (_this.$stateParams.job_posting_type) {
	          _this.map_state_params_to_fields();
	          return;
	        }
	      }
	      if (_this.currentUser) {
	        _this.$location.$$search.t = _this.currentUser.access_token;
	      }
	      if (_this.$location.$$search.t && _this.$location.$$search.job_posting_type) {
	        _this.ismarketing = true;
	        data.dress_code = _this.$location.$$search.dress_code;
	        data.job_description = _this.$location.$$search.job_description;
	        data.job_posting_type = _this.$location.$$search.job_posting_type;
	        data.job_title = _this.$location.$$search.job_title;
	        data.jobble_type = _this.$location.$$search.jobble_type;
	        data.pay_rate = _this.$location.$$search.pay_rate;
	        data.pay_rate_jblr = _this.$location.$$search.pay_rate_jblr;
	        data.token = _this.$location.$$search.t;
	        var promise = _this.$auth.validate_from_marketing_site(data.token);
	        promise.then(function (response) {
	          _this.handle_marketing_user_response(response.data, data);
	          _this.currentUser = response.data;
	        }, function (error) {
	          _this.handle_marketing_user_error(error);
	        });
	      } else if (!_this.$location.$$search.t && !_this.currentUser) {
	        data = _this.$location.$$search;
	        data.preserve = true;
	        _this.$state.go("signin", data);
	      }
	    }
	  }, {
	    key: "map_marketing_event",
	    value: function map_marketing_event(data, type) {
	      var _this = this;
	      var event = {};
	      if (type === 1) {
	        var jt_obj = this.find_jobble_type(data.jobble_type);
	        _this.$timeout(function () {
	          _this.event.hourly_rate = data.pay_rate;
	          _this.event.name = data.job_title;
	          _this.event.jobble_type_name = jt_obj.name;
	          _this.event.dress_code = data.dress_code;
	          _this.event.jobble_details = data.job_description;
	          _this.calcNumbers();
	        }, 100);
	      } else if (type === 2) {
	        var _jt_obj = this.find_jobble_type(data.jobble_type);
	        _this.$timeout(function () {
	          _this.event.hourly_rate = data.pay_rate;
	          _this.event.name = data.job_title;
	          _this.event.jobble_type_name = _jt_obj.name;
	          //_this.event.dress_code=data.dress_code;
	          _this.event.jobble_details = data.job_description;
	          _this.calcNumbers();
	        }, 100);
	      } else if (type === 3) {
	        console.log("map delivery");
	      }
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("UpdateCurrentUser", {
	          user: _this.currentUser
	        });
	      }, 300);
	    }
	  }, {
	    key: "handle_marketing_user_error",
	    value: function handle_marketing_user_error(error) {
	      var _this = this;
	      console.log("handle_marketing_user_error");
	      console.dir(error);
	    }
	  }, {
	    key: "find_jobble_type",
	    value: function find_jobble_type(jt_name) {
	      var _this = this;
	      var jt_find = _this.jobble_types.find(function (o) {
	        return o.name === jt_name;
	      });
	      var ret = {};
	      ret.id = jt_find.id;
	      ret.name = jt_find.name;
	      _this.event.jobble_type = jt_find.id;
	      return ret;
	    }
	  }, {
	    key: "determineJobbleType",
	    value: function determineJobbleType() {
	      var _this = this;
	      var jt_find = _this.jobble_types.find(function (o) {
	        return o.id === _this.event.jobble_type;
	      });
	      _this.set_openings();
	      _this.$timeout(function () {
	        _this.event.jobble_type = jt_find.id;
	        _this.event.jobble_type_name = jt_find.name;
	        _this.openingsList.value = _this.event.openings;
	      }, 500);
	    }
	  }, {
	    key: "set_openings",
	    value: function set_openings() {
	      var _this = this;
	      var data = [];
	      var openings_string = _this.event.openings.toString();
	      var parent = { value: openings_string, values: [] };
	      try {
	        for (var i = 0; i < 500; i++) {
	          var new_data = {};
	          new_data.value = (i + 1).toString();
	          new_data.name = "opening-" + new_data.value;
	          data.push(new_data);
	        }
	      } catch (err) {
	        console.dir(err);
	      }
	      parent.values = data;
	      _this.$timeout(function () {
	        _this.openings_for_clone = parent;
	      }, 300);
	    }
	  }, {
	    key: "changed_clone_jobble_type",
	    value: function changed_clone_jobble_type() {
	      var _this = this;
	    }
	  }, {
	    key: "cloneInterval",
	    value: function cloneInterval(ti) {
	      var _this = this;
	      console.log("cloneInterval");
	      console.dir(ti);
	      console.dir(_this.saving);
	
	      if (_this.saving === false) {
	        _this.saving = true;
	        var newInterval = {};
	        newInterval.contactInfo = {};
	        newInterval.contactInfo.streetLine1 = ti.contactInfo.streetLine1;
	        newInterval.contactInfo.state = ti.contactInfo.state;
	        newInterval.contactInfo.city = ti.contactInfo.city;
	        newInterval.contactInfo.zipCode = ti.contactInfo.zipCode;
	        newInterval.contactInfo.lat = ti.contactInfo.lat;
	        newInterval.contactInfo.lng = ti.contactInfo.lng;
	        newInterval.address = ti.address;
	        var add24hours = ti.startDateAndTimeMomentObj.add(24, "hours");
	        newInterval.start_time = add24hours.format("hh:mm A");
	        //newInterval.start_date = "Mar 25, 2020";
	        newInterval.start_date = add24hours.format("MMM DD, YYYY");
	        newInterval.hours = ti.hours;
	        newInterval.minutes = ti.minutes;
	        newInterval.endDateAndTimeMomentObj = ti.endDateAndTimeMomentObj;
	        newInterval.startDateAndTimeMomentObj = ti.startDateAndTimeMomentObj;
	        newInterval.durationInMinutes = ti.durationInMinutes;
	        newInterval.durationInHours = ti.durationInHours;
	        newInterval.startDateAndTimeForDB = "2020-03-25T21:30:00-04:00";
	        newInterval.endDateAndTimeForDB = "2020-03-25T22:30:00-04:00";
	        newInterval.cost = null;
	        newInterval.isOverlapping = false;
	        newInterval.isClone = true;
	        //_this.event.timeIntervalsArray.push(newInterval)
	        _this.currentTimeInterval = newInterval;
	        _this.submitDateAndLocation();
	      }
	    }
	  }, {
	    key: "markAllShiftsAsNotBeingEdited",
	    value: function markAllShiftsAsNotBeingEdited() {
	      var _this = this;
	      _this.event.timeIntervalsArray.forEach(function (ti) {
	        ti.isBeingEdited = false;
	      });
	    }
	  }, {
	    key: "cancelAddShift",
	    value: function cancelAddShift() {
	      var _this = this;
	
	      _this.step = 2;
	      _this.markAllShiftsAsNotBeingEdited();
	      _this.shiftIsBeingEdited = false;
	    }
	  }, {
	    key: "checkGoogle",
	    value: function checkGoogle() {
	      var _this = this;
	      console.log("check google");
	      _this.$timeout(function () {
	        _this.googleIsDoneLoading = true;
	        _this.showDateAndTimeUI();
	      }, 2000);
	    }
	  }, {
	    key: "addressChanging",
	    value: function addressChanging() {
	      var _this = this;
	      console.log("addressChanging");
	      console.dir(_this.currentTimeInterval.address);
	      console.dir(_this.currentTimeInterval.address_temp);
	      //.currentTimeInterval
	    }
	  }, {
	    key: "go_to_bulk_upload_jobs_page",
	    value: function go_to_bulk_upload_jobs_page() {
	      this.$state.go("postjobbulk");
	    }
	  }, {
	    key: "checkForAdmin",
	    value: function checkForAdmin() {
	      console.log("checkForAdmin");
	
	      var _this = this;
	
	      if (_this.currentUser.username.indexOf("jobble.com") !== -1 || _this.currentUser.username.indexOf("jobbleapp.com") !== -1) {
	        _this.currentUser.isAdmin = true;
	      } else {
	        _this.currentUser.isAdmin = false;
	      }
	    }
	  }]);
	
	  return PosteventController;
	}();
	
	PosteventController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "env", "teams", "companies", "security", "$filter", "events", "$timeout", "$location", "$rootScope", "$scope", "tracking"];
	
	exports.default = PosteventController;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(604);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./postevent.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./postevent.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".postevent{color:red}", ""]);
	
	// exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _postjobbulk = __webpack_require__(606);
	
	var _postjobbulk2 = _interopRequireDefault(_postjobbulk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postjobbulkModule = _angular2.default.module("postjobbulk", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("postjobbulk", {
	    url: "/bulk-upload-jobs",
	    template: "<postjobbulk></postjobbulk>"
	  });
	}).component("postjobbulk", _postjobbulk2.default);
	
	exports.default = postjobbulkModule;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _postjobbulk = __webpack_require__(607);
	
	var _postjobbulk2 = _interopRequireDefault(_postjobbulk);
	
	var _postjobbulk3 = __webpack_require__(608);
	
	var _postjobbulk4 = _interopRequireDefault(_postjobbulk3);
	
	__webpack_require__(609);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postjobbulkComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _postjobbulk2.default,
	  controller: _postjobbulk4.default,
	  controllerAs: "vm"
	};
	
	exports.default = postjobbulkComponent;

/***/ }),
/* 607 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<section class=\"page-head\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n        <div class=\"page-meta\"><strong>BULK UPLOAD JOBS</strong> Upload a CSV with the with all the jobs you would like to be posted.</div>\n      </div>\n    </div>\n  </div>\n</section>\n\n<section class=\"job-container\" style=\"min-height: 600px\">\n  <div class=\"container\" ng-class=\"{'wide-container' : vm.sheet} \">\n    <div class=\"row\">\n      <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n        <div class=\"process-description\">\n          <div class=\"job-content\">\n            <!--\n                        <label class=\"bulk-job-label\"> Bulk Upload Jobs </label>\n\n                        <p class=\"bulk-job-p\">Upload a CSV with the with all the jobs you would like to be posted.</p>\n                        -->\n            <!--\n\t\t\t\t\t\t<a \n\t\t\t\t\t\t\thref=\"#\" \n\t\t\t\t\t\t\tng-click=\"vm.showExampleCSV(1)\" \n\t\t\t\t\t\t\tng-show=\"vm.showCSV\" \n\t\t\t\t\t\t\tclass=\"example-csv-link\">\n\t\t\t\t\t\t\tView Example CSV\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a \n\t\t\t\t\t\t\thref=\"#\" \n\t\t\t\t\t\t\tng-click=\"vm.showExampleCSV(2)\" \n\t\t\t\t\t\t\tng-show=\"!vm.showCSV\" \n\t\t\t\t\t\t\tclass=\"example-csv-link\">\n\t\t\t\t\t\t\tHide Example CSV\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<img \n\t\t\t\t\t\t\tsrc=\"/app/vendor/images/example-csv.png\" \n\t\t\t\t\t\t\tng-show=\"!vm.showCSV\" \n\t\t\t\t\t\t\tclass=\"example-csv\"\n\t\t\t\t\t\t/>\n          -->\n\t\t\t\t\t\t\n\n            <form class=\"bulk-users-form\" ng-if=\"!vm.sheet || vm.csv_error\">\n              <input\n                class=\"hidden-inputfile\"\n                type=\"file\"\n                name=\"bulk-file\"\n                id=\"bulk-file\"\n                import-sheet-js=\"\"\n                on-sheet-load=\"vm.loadWorksheet(e)\"\n                multiple=\"false\"\n              />\n              <label for=\"bulk-file\">Upload file</label>\n              <!--<input type=\"file\" file-reader=\"fileContent\"/>-->\n\n              <input type=\"submit\" class=\"bulk-up-jobs\" value=\"Upload\" ng-if=\"vm.sheet\" />\n            </form>\n\n            <form class=\"bulk-users-form\" ng-if=\"vm.sheet\" ng-submit=\"vm.submitJobs()\">\n              <input type=\"submit\" class=\"bulk-up-jobs\" value=\"Upload\" />\n            </form>\n\n            <label class=\"bulk-job-label\" ng-if=\"vm.sheet\">\n              <a href=\"#\" ng-click=\"vm.clearBulkPay()\" ng-if=\"vm.sheet\" class=\"clear-upload-data\" style=\"float: none\"> Clear [x] </a>\n            </label>\n\n            <p class=\"possible-managers\" style=\"font-family: 'Poppins'; font-size: 14px; font-weight: 700\">Possible Manager(s) For Upload</p>\n\n            <ul class=\"possible-managers-list\" style=\"margin-bottom: 10px; font-family: 'Poppins'; font-size: 12px\">\n              <li ng-repeat=\"manager in vm.companyUsers track by $index\" ng-if=\"manager.firstName && manager.lastName\">\n                {{manager.id}} - {{manager.firstName}} {{manager.lastName}}\n              </li>\n            </ul>\n\n            <div ng-if=\"vm.showLoader==true\">Processing Spreadsheet...</div>\n\n            <div class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.spread_sheet_error\">\n              The spreadsheet you uploaded has issues. Please try again.\n            </div>\n\n            <div class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.jobsWithShiftsBeforeNow.length > 0\">\n              There are {{vm.jobsWithShiftsBeforeNow.length}} job(s) that have start times in the past. They will not successfully import until\n              edited.\n            </div>\n\n            <div class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.jobsWithWrongManagers.length > 0\">\n              There are {{vm.jobsWithWrongManagers.length}} job(s) that do not have a manager id that matches anyone in the company. They will not\n              successfully import until edited.\n            </div>\n\n            <div class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.jobsWithWrongJT.length > 0\">\n              There are {{vm.jobsWithWrongJT.length}} job(s) that have an incorrect JobbleType. They will not successfully import until edited.\n            </div>\n\n            <div class=\"job-table table-responsive respons-job bulk-padding\">\n              <div class=\"bulk-pay-table-holder\" ng-if=\"vm.jobArrayHolder.length>0\" ng-hide=\"vm.csv_error\">\n                <table class=\"table table-striped report-list bulk-job-post-table\">\n                  <thead class=\"thead-dark\">\n                    <tr>\n                      <th>ID</th>\n                      <th style=\"width: 500px\">Job Title</th>\n                      <th style=\"width: 500px\">Address</th>\n                      <th>Start Date</th>\n                      <th>Hourly Rate</th>\n                      <th style=\"width: 500px\">Description</th>\n                      <th style=\"width: 500px\">Dress Code</th>\n                      <th>Job Type</th>\n                      <th>Hiring Manager</th>\n                      <th style=\"width: 50px\">Openings</th>\n                      <!--<th>Requirement</th>-->\n                      <!--<th></th>-->\n                    </tr>\n                  </thead>\n                  <tbody>\n                    <tr ng-repeat=\"row in vm.sheet track by $index\" ng-class=\"{ 'starts-before' : row.isBefore==true }\">\n                      <td>{{$index + 1}}</td>\n                      <td>{{row.EventName}}</td>\n                      <td>{{row.Address}} {{row.City}} {{row.State}} {{row.Zip}}</td>\n                      <td>{{row.StartDay}} {{row.StartTime}}</td>\n                      <td>${{row.PayPerHour | number : 2}}</td>\n                      <td>{{row.Description}}...</td>\n                      <td>{{row.DressCode}}</td>\n                      <td>{{row.JobType}}</td>\n                      <td>{{row.HiringManager}}</td>\n                      <td>{{row.Openings}}</td>\n                      <!--<td>\n                                                {{row.Req1}}\n                                            </td>-->\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div>\n\n            <form class=\"bulk-users-form\" ng-if=\"vm.sheet\" ng-submit=\"vm.submitJobs()\">\n              <input type=\"submit\" class=\"bulk-up-jobs\" value=\"Upload\" />\n            </form>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n\n<jobblefooter></jobblefooter>\n\n<div class=\"modal fade\" id=\"bulk-jobs-processing\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" ng-click=\"vm.closeProcessingModal()\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"> </i>\n            </button>\n            <h3 class=\"modal-title\">Your spreadsheet is processing!</h3>\n          </div>\n          <div class=\"modal-body popup-body\">\n            <p>You jobs are processing. Please check back in a few minutes as we get them posted to our platform.</p>\n            <a class=\"btn btn-success button\" ng-click=\"vm.closeProcessingModal()\"> Sounds good </a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PostjobbulkController = function () {
	  function PostjobbulkController($http, $localStorage, $state, $stateParams, AuthService, SecurityService, CompaniesService, $timeout, $rootScope, EnvService, ngProgressFactory, $scope, $location) {
	    _classCallCheck(this, PostjobbulkController);
	
	    this.name = "postjobbulk";
	    $localStorage.activeStateName = "postjobbulk";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.$auth = AuthService;
	    this.showCSV = true;
	    this.$companies = CompaniesService;
	    this.sheet = null;
	    this.ui_components = {};
	    this.jobArrayHolder = [];
	    this.currentUser = this.$auth.getUserData();
	    this.showLoader = false;
	    this.loadUsers();
	    this.jobsWithShiftsBeforeNow = [];
	    this.getJobbleTypes();
	    this.jobsWithWrongManagers = [];
	    this.jobsWithWrongJT = [];
	    console.log("postjobbulk");
	  }
	
	  _createClass(PostjobbulkController, [{
	    key: "showExampleCSV",
	    value: function showExampleCSV() {
	      if (this.showCSV) {
	        this.showCSV = false;
	      } else {
	        this.showCSV = true;
	      }
	    }
	  }, {
	    key: "setSpinner",
	    value: function setSpinner() {
	      var _this = this;
	
	      console.log("setSpinner");
	
	      _this.showLoader = true;
	    }
	  }, {
	    key: "loadWorksheet",
	    value: function loadWorksheet(sheet) {
	      var _this = this;
	
	      _this.setLoader();
	      _this.setSpinner();
	      _this.spread_sheet_error = false;
	
	      _this.$timeout(function () {
	        var file = sheet.target.result;
	        var workbook = XLSX.read(file, {
	          type: "binary",
	          cellText: false,
	          cellDates: true
	        });
	
	        var sheetName = workbook.SheetNames[0];
	
	        if (!sheetName) {
	          alert("The file format is not correct.");
	          return;
	        }
	        sheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
	          header: 1,
	          raw: false,
	          dateNF: "mm/dd/yyyy"
	        });
	
	        _this.validateAllFieldsAreNotEmpty(sheet);
	      }, 300);
	    }
	  }, {
	    key: "validateAllFieldsAreNotEmpty",
	    value: function validateAllFieldsAreNotEmpty(sheet) {
	      var _this = this;
	      var sheet_after_cleanse = [];
	      var errored_rows = [];
	
	      try {
	        sheet.forEach(function (row, i) {
	          var row_build = {};
	          var keys = Object.keys(row);
	          var values = keys.map(function (v) {
	            return row[v];
	          });
	          var pay = null;
	          var questions = [];
	          var process = true;
	
	          if (i > 0) {
	            var keysLength = keys.length;
	            keys.forEach(function (key, x) {
	              key = key.trim();
	
	              switch (x) {
	                case 0:
	                  row_build.EventName = values[0];
	                case 1:
	                  row_build.Address = values[1];
	                case 2:
	                  row_build.City = values[2];
	                case 3:
	                  row_build.State = values[3];
	                case 4:
	                  row_build.Zip = _this.testZipCode(values[4]);
	                case 5:
	                  row_build.StartDay = values[5];
	                case 6:
	                  row_build.StartTime = values[6];
	                case 7:
	                  row_build.EndTime = values[7];
	                case 8:
	                  row_build.Sunday = values[8];
	                case 9:
	                  row_build.Monday = values[9];
	                case 10:
	                  row_build.Tuesday = values[10];
	                case 11:
	                  row_build.Wendesday = values[11];
	                case 12:
	                  row_build.Thursday = values[12];
	                case 13:
	                  row_build.Friday = values[13];
	                case 14:
	                  row_build.Saturday = values[14];
	                case 15:
	                  row_build.Weeks = parseInt(values[15]);
	                case 16:
	                  row_build.UnpaidBreak = parseInt(values[16]);
	                case 17:
	                  row_build.Openings = parseInt(values[17]);
	                case 18:
	                  row_build.DescriptionFull = values[18];
	                  row_build.Description = values[18].substring(0, 40) + "...";
	                case 19:
	                  row_build.DressCodeFull = values[19];
	                  row_build.DressCode = values[19].substring(0, 40) + "...";
	                case 20:
	                  row_build.PayPerHour = parseInt(values[20]);
	                case 21:
	                  row_build.JobType = values[21];
	                case 22:
	                  row_build.HiringManager = parseInt(values[22]);
	                case 23:
	                  row_build.ArrivalInstructions = values[23];
	                case 24:
	                  row_build.OnSiteName = values[24];
	                case 25:
	                  row_build.OnSiteNumber = values[25];
	                case 26:
	                  row_build.Req1 = values[26];
	                case 27:
	                  row_build.Req2 = values[27];
	                case 28:
	                  row_build.Req3 = values[28];
	                case 29:
	                  row_build.Req4 = values[29];
	                case 30:
	                  row_build.Req5 = values[30];
	                case 31:
	                //row_build.W2 = values[31]?.trim().toUpperCase();
	              }
	
	              if (x + 1 === keysLength) {
	                console.log("we are at the end");
	                _this.formatDatesForEachRow(row_build);
	              }
	            });
	            sheet_after_cleanse.push(row_build);
	          }
	        });
	      } catch (err) {
	        console.log("catch error");
	        console.dir(err);
	      } finally {
	        _this.sheet = sheet_after_cleanse;
	        this.$scope.$apply(); // Need this to update angular with the changes
	        this.mapSheetToJSON();
	        //_this.groupJobs(sheet_after_cleanse);
	      }
	    }
	  }, {
	    key: "formatDatesForEachRow",
	    value: function formatDatesForEachRow(job) {
	      var _this = this;
	
	      console.log("formatDatesForEachRow");
	      console.dir(job);
	
	      var shifts = [];
	      var daysInWeek = [];
	      var start_date = job.StartDay;
	      var start_time = job.StartTime;
	      //let end_date = job.EndDay;
	      var end_time = job.EndTime;
	      var startDateTime = new Date(start_date + " " + start_time);
	      //let endDateTime = new Date(end_date + " " + end_time);
	      var shiftDuration = void 0;
	      var shiftEndTimeMoment = moment(new Date(start_date + " " + end_time));
	      var startTimeMoment = moment(start_date + " " + start_time, "MM/DD/YYYY HH:mm A");
	      shiftDuration = shiftEndTimeMoment.diff(startTimeMoment, "minutes", true);
	      var dayOfWeek = startTimeMoment.day();
	      console.log("Day of week");
	      console.dir(dayOfWeek);
	      console.log("shiftDuration");
	      console.dir(shiftDuration);
	
	      /* TODO: need shift duration */
	      //calculate shift duration
	
	      var beginningOfDayMoment = moment(start_date + " " + start_time, "MM/DD/YYYY HH:mm A");
	      var beginningOfWeekMoment = moment(start_date + " " + start_time, "MM/DD/YYYY HH:mm A");
	      var beginningOfDayMomentConversion = beginningOfDayMoment.startOf("day");
	      var differenceInMinutesFromStartOfDayToStartOfShift = startTimeMoment.diff(beginningOfDayMomentConversion, "minutes", true);
	      var startOfWeek = beginningOfWeekMoment.startOf("week");
	      var startDayOfTheWeekForJob = void 0;
	
	      var timeData = {};
	      timeData.startOfWeek = startOfWeek;
	      timeData.shiftDuration = shiftDuration;
	      timeData.differenceInMinutesFromStartOfDayToStartOfShift = differenceInMinutesFromStartOfDayToStartOfShift;
	      timeData.beginningOfDayMomentConversion = beginningOfDayMomentConversion;
	      timeData.beginningOfWeekMoment = beginningOfWeekMoment;
	      timeData.beginningOfDayMoment = beginningOfDayMoment;
	      timeData.startTimeMoment = startTimeMoment;
	      timeData.shiftEndTimeMoment = shiftEndTimeMoment;
	      console.log("dayOfWeek");
	      //console.dir(startOfWeek);
	      console.dir(dayOfWeek);
	      console.dir(typeof dayOfWeek === "undefined" ? "undefined" : _typeof(dayOfWeek));
	
	      if (dayOfWeek === 0) {
	        startDayOfTheWeekForJob = "Sunday";
	      } else if (dayOfWeek === 1) {
	        startDayOfTheWeekForJob = "Monday";
	      } else if (dayOfWeek === 2) {
	        startDayOfTheWeekForJob = "Tuesday";
	      } else if (dayOfWeek === 3) {
	        startDayOfTheWeekForJob = "Wendesday";
	      } else if (dayOfWeek === 4) {
	        startDayOfTheWeekForJob = "Thursday";
	      } else if (dayOfWeek === 5) {
	        startDayOfTheWeekForJob = "Friday";
	      } else if (dayOfWeek === 6) {
	        startDayOfTheWeekForJob = "Saturday";
	      } else if (dayOfWeek === 7) {
	        startDayOfTheWeekForJob = "Sunday1";
	      }
	
	      console.log("startDayOfTheWeekForJob");
	      console.dir(startDayOfTheWeekForJob);
	
	      //
	      //the amount of minutes needed to be added to the start of each day
	      //
	
	      console.dir(differenceInMinutesFromStartOfDayToStartOfShift);
	      timeData.startDayOfTheWeekForJob = startDayOfTheWeekForJob;
	      timeData.startDayOfTheWeekForJob = startDayOfTheWeekForJob;
	
	      job.shifts = this.constructShifts(job, timeData);
	
	      console.log("shifts in job?");
	      console.dir(job);
	    }
	  }, {
	    key: "testZipCode",
	    value: function testZipCode(code) {
	      if (typeof code === 'string' || code instanceof String) {
	        if (code.length === 4) {
	          code = "0" + code;
	        }
	      }
	
	      return code;
	    }
	  }, {
	    key: "constructShifts",
	    value: function constructShifts(job, timeData) {
	      console.log("constructShifts");
	      console.dir(this);
	      console.dir(job);
	      console.dir(timeData);
	      console.dir(timeData.differenceInMinutesFromStartOfDayToStartOfShift);
	      console.dir(timeData.startDayOfTheWeekForJob);
	
	      var shifts = void 0;
	
	      if (timeData.startDayOfTheWeekForJob === "Sunday") {
	        shifts = this.addWorkDays("Sunday", job, timeData);
	      } else if (timeData.startDayOfTheWeekForJob === "Monday") {
	        shifts = this.addWorkDays("Monday", job, timeData);
	      } else if (timeData.startDayOfTheWeekForJob === "Tuesday") {
	        shifts = this.addWorkDays("Tuesday", job, timeData);
	      } else if (timeData.startDayOfTheWeekForJob === "Wendesday") {
	        shifts = this.addWorkDays("Wendesday", job, timeData);
	      } else if (timeData.startDayOfTheWeekForJob === "Thursday") {
	        shifts = this.addWorkDays("Thursday", job, timeData);
	      } else if (timeData.startDayOfTheWeekForJob === "Friday") {
	        shifts = this.addWorkDays("Friday", job, timeData);
	      } else if (timeData.startDayOfTheWeekForJob === "Saturday") {
	        shifts = this.addWorkDays("Saturday", job, timeData);
	      }
	
	      return shifts;
	    }
	  }, {
	    key: "addDays",
	    value: function addDays(job, start, end, days) {
	      console.log("addDays");
	      console.dir(job);
	
	      var shift = {};
	
	      shift.timeInterval = {};
	      shift.contactInfo = {};
	
	      shift.unpaidBreak = job.UnpaidBreak;
	      shift.overnight = false;
	      shift.timeInterval.startTime = moment(start).add(days, "day").format();
	      shift.timeInterval.endTime = moment(end).add(days, "day").format();
	      shift.contactInfo.city = job.City;
	      shift.contactInfo.state = job.State;
	      shift.contactInfo.streetLine1 = job.Address;
	      shift.contactInfo.zipCode = job.Zip;
	
	      console.log("shift being returned from add days");
	      console.dir(shift);
	
	      return shift;
	    }
	  }, {
	    key: "addWorkDays",
	    value: function addWorkDays(startDay, job, timeData) {
	      var shifts = [];
	      var shift = {};
	      var startOfFirstShift = timeData.startTimeMoment.format();
	      var endOfFirstShift = timeData.shiftEndTimeMoment.format();
	      try {
	        if (startDay === "Monday") {
	          shift.timeInterval = {};
	          shift.timeInterval.startTime = timeData.startTimeMoment.format();
	          shift.timeInterval.endTime = timeData.shiftEndTimeMoment.format();
	          shift.contactInfo = {};
	          shift.contactInfo.city = job.City;
	          shift.contactInfo.state = job.State;
	          shift.contactInfo.streetLine1 = job.Address;
	          shift.contactInfo.zipCode = job.Zip;
	          shift.unpaidBreak = job.UnpaidBreak;
	          shift.overnight = false;
	
	          shifts.push(shift);
	          shift = {};
	
	          if (job.Tuesday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 1);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Wendesday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 2);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Thursday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 3);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Friday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 4);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          //Weekend logic
	          if (job.Saturday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 5);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Sunday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 6);
	            shifts.push(shift);
	            shift = {};
	          }
	        } else if (startDay === "Tuesday") {
	          shift.timeInterval = {};
	          shift.timeInterval.startTime = timeData.startTimeMoment.format();
	          shift.timeInterval.endTime = timeData.shiftEndTimeMoment.format();
	          shift.contactInfo = {};
	          shift.contactInfo.city = job.City;
	          shift.contactInfo.state = job.State;
	          shift.contactInfo.streetLine1 = job.Address;
	          shift.contactInfo.zipCode = job.Zip;
	          shift.unpaidBreak = job.UnpaidBreak;
	          shift.overnight = false;
	
	          shifts.push(shift);
	          shift = {};
	
	          if (job.Wendesday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 1);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Thursday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 2);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Friday.toUpperCase() === "YES") {
	            shift = this.addDays(startOfFirstShift, endOfFirstShift, 3);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          //Weekend logic
	          if (job.Saturday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 4);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Sunday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 5);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Monday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 6);
	            shifts.push(shift);
	            shift = {};
	          }
	        } else if (startDay === "Wendesday") {
	          shift.timeInterval = {};
	          shift.timeInterval.startTime = timeData.startTimeMoment.format();
	          shift.timeInterval.endTime = timeData.shiftEndTimeMoment.format();
	          shift.contactInfo = {};
	          shift.contactInfo.city = job.City;
	          shift.contactInfo.state = job.State;
	          shift.contactInfo.streetLine1 = job.Address;
	          shift.contactInfo.zipCode = job.Zip;
	          shift.unpaidBreak = job.UnpaidBreak;
	          shift.overnight = false;
	
	          shifts.push(shift);
	          shift = {};
	
	          if (job.Thursday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 1);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Friday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 2);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          //Weekend logic
	          if (job.Saturday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 3);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Sunday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 4);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Monday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 5);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Tuesday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 6);
	            shifts.push(shift);
	            shift = {};
	          }
	        } else if (startDay === "Thursday") {
	          shift.timeInterval = {};
	          shift.timeInterval.startTime = timeData.startTimeMoment.format();
	          shift.timeInterval.endTime = timeData.shiftEndTimeMoment.format();
	          shift.contactInfo = {};
	          shift.contactInfo.city = job.City;
	          shift.contactInfo.state = job.State;
	          shift.contactInfo.streetLine1 = job.Address;
	          shift.contactInfo.zipCode = job.Zip;
	          shift.unpaidBreak = job.UnpaidBreak;
	          shift.overnight = false;
	
	          shifts.push(shift);
	          shift = {};
	
	          if (job.Friday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 1);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          //Weekend logic
	          if (job.Saturday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 2);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Sunday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 3);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Monday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 4);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Tuesday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 5);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Wendesday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 6);
	            shifts.push(shift);
	            shift = {};
	          }
	        } else if (startDay === "Friday") {
	          shift.timeInterval = {};
	          shift.timeInterval.startTime = timeData.startTimeMoment.format();
	          shift.timeInterval.endTime = timeData.shiftEndTimeMoment.format();
	          shift.contactInfo = {};
	          shift.contactInfo.city = job.City;
	          shift.contactInfo.state = job.State;
	          shift.contactInfo.streetLine1 = job.Address;
	          shift.contactInfo.zipCode = job.Zip;
	          shift.unpaidBreak = job.UnpaidBreak;
	          shift.overnight = false;
	
	          shifts.push(shift);
	          shift = {};
	
	          //Weekend logic
	          if (job.Saturday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 1);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Sunday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 2);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Monday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 3);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Tuesday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 4);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Wendesday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 5);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Thursday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 6);
	            shifts.push(shift);
	            shift = {};
	          }
	        } else if (startDay === "Saturday") {
	          shift.timeInterval = {};
	          shift.timeInterval.startTime = timeData.startTimeMoment.format();
	          shift.timeInterval.endTime = timeData.shiftEndTimeMoment.format();
	          shift.contactInfo = {};
	          shift.contactInfo.city = job.City;
	          shift.contactInfo.state = job.State;
	          shift.contactInfo.streetLine1 = job.Address;
	          shift.contactInfo.zipCode = job.Zip;
	          shift.unpaidBreak = job.UnpaidBreak;
	          shift.overnight = false;
	
	          shifts.push(shift);
	          shift = {};
	
	          //Weekend logic
	          if (job.Sunday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 1);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Monday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 2);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Tuesday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 3);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Wendesday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 4);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Thursday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 5);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Friday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 6);
	            shifts.push(shift);
	            shift = {};
	          }
	        } else if (startDay === "Sunday") {
	          shift.timeInterval = {};
	          shift.timeInterval.startTime = timeData.startTimeMoment.format();
	          shift.timeInterval.endTime = timeData.shiftEndTimeMoment.format();
	          shift.contactInfo = {};
	          shift.contactInfo.city = job.City;
	          shift.contactInfo.state = job.State;
	          shift.contactInfo.streetLine1 = job.Address;
	          shift.contactInfo.zipCode = job.Zip;
	          shift.unpaidBreak = job.UnpaidBreak;
	          shift.overnight = false;
	
	          shifts.push(shift);
	          shift = {};
	
	          //Weekend logic
	          if (job.Monday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 1);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Tuesday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 2);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Wendesday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 3);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Thursday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 4);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Friday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 5);
	            shifts.push(shift);
	            shift = {};
	          }
	
	          if (job.Saturday.toUpperCase() === "YES") {
	            shift = this.addDays(job, startOfFirstShift, endOfFirstShift, 6);
	            shifts.push(shift);
	            shift = {};
	          }
	        }
	      } catch (err) {
	        console.log("error caught");
	        console.dir(err);
	      } finally {
	        console.log("what do we have for shifts");
	        console.dir(shifts);
	        return shifts;
	      }
	    }
	  }, {
	    key: "loadUsers",
	    value: function loadUsers() {
	      var _this = this;
	      _this.$companies.loadUsers().then(function (response) {
	        console.log("who are the  users..");
	        console.dir(response.data);
	        _this.companyUsers = response.data;
	      }, function (error) {
	        alert("error getting company users");
	      });
	    }
	  }, {
	    key: "getHiringManager",
	    value: function getHiringManager(managerId) {
	      var _this = this;
	
	      return parseInt(managerId);
	    }
	  }, {
	    key: "checkForHiringManager",
	    value: function checkForHiringManager() {
	      var _this = this;
	
	      _this.sheet.forEach(function (row, index) {
	        _this.findHiringManager(row.HiringManager, row);
	      });
	    }
	  }, {
	    key: "findHiringManager",
	    value: function findHiringManager(managerId, job) {
	      var _this = this;
	
	      console.log("findHiringManager");
	      console.dir(managerId);
	
	      var m_id = null;
	
	      var m = _.find(_this.companyUsers, function (o) {
	        return o.id === managerId;
	      });
	
	      console.log("what is m?");
	      console.dir(m);
	
	      if (!m) {
	        job.isBefore = true;
	        _this.jobsWithWrongManagers.push(job);
	      }
	    }
	  }, {
	    key: "getJobbleType",
	    value: function getJobbleType(jt, job) {
	      var _this = this;
	
	      console.log("what are the jobbble types");
	      console.dir(_this.jobbleTypes);
	      console.dir(jt);
	
	      var j_id = null;
	
	      var j = _.find(_this.jobbleTypes, function (o) {
	        return o.name === jt;
	      });
	
	      console.log("missing jobble type...");
	      console.dir(jt);
	      console.dir(j);
	
	      if (!j) {
	        //alert("Invalid Missing Job Type for job " + job.EventName + ". Adding placeholder JobbleType. Please edit after upload. ");
	        console.log("what are we pushing here");
	        job.isBefore = true;
	        _this.jobsWithWrongJT.push(job);
	        console.dir(_this.jobsWithWrongJT);
	        j_id = 1;
	      } else {
	        j_id = j.id;
	      }
	
	      console.log("what is j?");
	      console.dir(j);
	
	      return j_id;
	    }
	  }, {
	    key: "formatPayRate",
	    value: function formatPayRate(pay) {
	      var _this = this;
	
	      var cents = pay * 100;
	
	      return cents;
	    }
	  }, {
	    key: "createNewParentJob",
	    value: function createNewParentJob(job) {
	      var _this = this;
	
	      var freshJob = {};
	      console.log("createNewParentJob");
	      console.dir(job);
	      console.log("what is the current user");
	      console.dir(_this.currentUser);
	      freshJob.jobble = {};
	      freshJob.jobble.numberOfOpenings = parseInt(job.Openings);
	      //freshJob.identifier = job.JobID;
	      freshJob.jobble.name = job.EventName;
	      freshJob.jobble.description = job.DescriptionFull;
	      freshJob.jobble.dressCode = job.DressCodeFull;
	      freshJob.jobble.jobbleType = _this.getJobbleType(job.JobType, job);
	      freshJob.jobble.isPublished = true;
	      freshJob.jobble.payPerHour = _this.formatPayRate(job.PayPerHour);
	      freshJob.jobble.manager = _this.getHiringManager(job.HiringManager);
	      freshJob.jobble.subEvent = {};
	      freshJob.jobble.subEvent.name = job.EventName;
	      freshJob.jobble.subEvent.contactInfo = {};
	      freshJob.jobble.subEvent.contactInfo.streetLine1 = job.Address;
	      freshJob.jobble.subEvent.contactInfo.city = job.City;
	      freshJob.jobble.subEvent.contactInfo.state = job.State;
	      freshJob.jobble.subEvent.contactInfo.zipCode = job.Zip;
	      freshJob.jobble.subEvent.event = {};
	      freshJob.jobble.subEvent.event.name = job.EventName;
	      if (job.W2 === "YES") {
	        freshJob.jobble.subEvent.event.isW2 = true;
	      } else {
	        freshJob.jobble.subEvent.event.isW2 = false;
	      }
	      freshJob.jobble.subEvent.event.description = job.DescriptionFull;
	      freshJob.jobble.subEvent.event.eventType = 1;
	      freshJob.jobble.subEvent.event.isPublished = true;
	      freshJob.jobble.subEvent.event.company = _this.currentUser.company.id;
	      freshJob.jobble.subEvent.event.isSourcingPost = false;
	      freshJob.jobble.subEvent.event.weeks = parseInt(job.Weeks);
	      freshJob.jobble.subEvent.event.arrivalInstructions = job.ArrivalInstructions;
	      freshJob.jobble.subEvent.event.onsiteManagerName = job.OnSiteName;
	      freshJob.jobble.subEvent.event.onsiteManagerNumber = job.OnSiteNumber;
	      freshJob.jobble.subEvent.event.requirements = _this.buildRequirements(job);
	      freshJob.jobble.shifts = job.shifts;
	
	      _this.jobArrayHolder.push(freshJob);
	    }
	  }, {
	    key: "buildRequirements",
	    value: function buildRequirements(job) {
	      console.log("buildRequirements");
	      console.dir(job);
	
	      var requirements = [];
	      var requirement = {};
	
	      if (job.Req1) {
	        requirements.push({ position: 1, name: job.Req1 });
	      }
	
	      if (job.Req2) {
	        requirements.push({ position: 2, name: job.Req2 });
	      }
	
	      if (job.Req3) {
	        requirements.push({ position: 3, name: job.Req3 });
	      }
	
	      if (job.Req4) {
	        requirements.push({ position: 4, name: job.Req3 });
	      }
	
	      if (job.Req5) {
	        requirements.push({ position: 5, name: job.Req3 });
	      }
	
	      return requirements;
	    }
	  }, {
	    key: "getQuestions",
	    value: function getQuestions(questions) {
	      var _this = this;
	
	      var questionArray = [];
	
	      questions.forEach(function (q, i) {
	        var index = i + 1;
	        var next_question = {};
	        next_question.name = "Question " + index;
	        next_question.question = q;
	        next_question.questionType = 1;
	        questionArray.push(next_question);
	      });
	
	      return questionArray;
	    }
	  }, {
	    key: "mapSheetToJSON",
	    value: function mapSheetToJSON() {
	      console.log("mapSheetToJSON");
	      console.dir(this.sheet);
	
	      var _this = this;
	
	      var index = void 0;
	
	      try {
	        _this.sheet.forEach(function (row, i) {
	          index = i + 1;
	          _this.createNewParentJob(row);
	        });
	      } catch (err) {
	        console.log("error");
	        console.dir(err);
	      } finally {
	        //_this.checkShiftsForTimes();
	        _this.checkForHiringManager();
	        console.log("_this.jobArrayHolder");
	        console.dir(_this.jobArrayHolder);
	
	        if (_this.jobArrayHolder.length === 0) {
	          _this.displayLoadingError();
	        }
	
	        _this.unSetLoader();
	      }
	    }
	  }, {
	    key: "checkShiftsForTimes",
	    value: function checkShiftsForTimes() {
	      var _this = this;
	
	      try {
	        _this.sheet.forEach(function (job, index) {
	          _this.testStartTime(job);
	        });
	      } catch (err) {
	        console.log("error");
	        console.dir(err);
	      } finally {
	        _this.unSetLoader();
	        _this.showLoader = false;
	      }
	    }
	  }, {
	    key: "testStartTime",
	    value: function testStartTime(job) {
	      var _this = this;
	
	      var isBefore = moment(job.startTimeFormatted).isBefore(moment());
	
	      if (isBefore) {
	        job.isBefore = true;
	        _this.jobsWithShiftsBeforeNow.push(job);
	      }
	    }
	  }, {
	    key: "displayLoadingError",
	    value: function displayLoadingError() {
	      var _this = this;
	
	      _this.spread_sheet_error = true;
	    }
	  }, {
	    key: "nestShiftIntoExistingJob",
	    value: function nestShiftIntoExistingJob(job, id) {
	      var _this = this;
	
	      var existingJob = _.find(_this.jobArrayHolder, function (o) {
	        return o.identifier === id;
	      });
	
	      var newShift = {};
	
	      newShift.timeInterval = {};
	      newShift.contactInfo = {};
	      newShift.timeInterval.startTime = job.startTimeFormatted;
	      newShift.timeInterval.endTime = job.endTimeFormatted;
	      newShift.contactInfo.streetLine1 = job.Address;
	      newShift.contactInfo.city = job.City;
	      newShift.contactInfo.state = job.State;
	      newShift.contactInfo.zipCode = job.Zip;
	
	      existingJob.jobble.shifts.push(newShift);
	    }
	  }, {
	    key: "submitJobs",
	    value: function submitJobs() {
	      var _this = this;
	
	      _this.setLoader();
	
	      var data = _this.jobArrayHolder;
	
	      _this.$companies.bulkPostJobs(data).then(function (response) {
	        _this.unSetLoader();
	        _this.$timeout(function () {
	          _this.unSetLoader();
	          $("#bulk-jobs-processing").modal();
	        }, 1000);
	      }, function (error) {
	        console.log("API Error");
	        _this.unSetLoader();
	        _this.jobsWithShiftsBeforeNow = [];
	        _this.jobsWithWrongManagers = [];
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "coupleShiftsTogether",
	    value: function coupleShiftsTogether(jobs) {
	      var _this = this;
	
	      console.log("coupleShiftsTogether");
	      console.dir(jobs);
	    }
	  }, {
	    key: "handleDate",
	    value: function handleDate(date) {
	      var _this = this;
	      //console.log("handleDate");
	      //console.dir(date);
	      return date;
	    }
	  }, {
	    key: "clearBulkPay",
	    value: function clearBulkPay() {
	      this.sheet = null;
	      this.jobsWithShiftsBeforeNow = [];
	      this.jobsWithWrongManagers = [];
	      this.jobArrayHolder = [];
	      this.jobsWithWrongJT = [];
	    }
	  }, {
	    key: "capitalizeFirstLetter",
	    value: function capitalizeFirstLetter(string) {
	      return string.charAt(0).toUpperCase() + string.slice(1);
	    }
	  }, {
	    key: "getJobbleTypes",
	    value: function getJobbleTypes() {
	      var _this = this;
	
	      _this.$auth.getJobbleTypes().then(function (data) {
	        _this.jobbleTypes = data.data;
	      }, function (data) {
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "closeProcessingModal",
	    value: function closeProcessingModal() {
	      var _this = this;
	
	      _this.clearBulkPay();
	      _this.$timeout(function () {
	        $("#bulk-jobs-processing").modal("toggle");
	      });
	    }
	  }]);
	
	  return PostjobbulkController;
	}();
	
	PostjobbulkController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "security", "companies", "$timeout", "$rootScope", "env", "ngProgressFactory", "$scope", "$location"];
	
	exports.default = PostjobbulkController;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(610);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./postjobbulk.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./postjobbulk.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _postorder = __webpack_require__(612);
	
	var _postorder2 = _interopRequireDefault(_postorder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postorderModule = _angular2.default.module("postorder", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("postorder", {
	    url: "/postorder",
	    template: "<postorder></postorder>",
	    params: {
	      jobType: null,
	      pay: null,
	      openings: null,
	      pt: null,
	      job_posting_type: null,
	      job_title: null,
	      jobble_type: null,
	      hourly_rate: null,
	      pay_rate: null,
	      pay_rate_jblr: null,
	      dress_code: null,
	      job_description: null,
	      preserve: null,
	      t: null,
	      date_time: null,
	      instructions: null,
	      location: null,
	      street_line_1: null
	    },
	    onExit: ["$rootScope", function ($rootScope) {}]
	  });
	}).component("postorder", _postorder2.default);
	
	exports.default = postorderModule;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _postorder = __webpack_require__(613);
	
	var _postorder2 = _interopRequireDefault(_postorder);
	
	var _postorder3 = __webpack_require__(614);
	
	var _postorder4 = _interopRequireDefault(_postorder3);
	
	__webpack_require__(615);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postorderComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _postorder2.default,
	  controller: _postorder4.default,
	  controllerAs: "vm"
	};
	
	exports.default = postorderComponent;

/***/ }),
/* 613 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<!--------------------- Application-Status Start --------------------->\n<div class=\"banner-application-status\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 center-block\">\n        <div class=\"application-bar clearfix\">\n          <div class=\"app-status select\">\n            <small ng-click=\"vm.updateTracker(1)\"></small>\n            <span>Drop-off</span>\n          </div>\n\n          <div class=\"app-status-bar\" ng-class=\"{ 'app-progress-bar' : vm.statusBarStatus.step_2.visited == true }\"></div>\n          <div class=\"app-status\" ng-class=\"{ 'select' : vm.statusBarStatus.step_2.visited == true }\">\n            <small ng-click=\"vm.updateTracker(2)\"></small>\n            <span>Pick-up</span>\n          </div>\n\n          <div class=\"app-status-bar\" ng-class=\"{ 'app-progress-bar' : vm.statusBarStatus.step_3.visited == true }\"></div>\n          <div class=\"app-status\" ng-class=\"{ 'select' : vm.statusBarStatus.step_3.visited == true }\">\n            <small ng-click=\"vm.updateTracker(3)\"></small>\n            <span>General</span>\n          </div>\n          <div class=\"app-status-bar\" ng-class=\"{ 'app-progress-bar' : vm.statusBarStatus.step_4.visited == true }\"></div>\n          <div class=\"app-status\" ng-class=\"{ 'select' : vm.statusBarStatus.step_4.visited == true }\">\n            <small ng-click=\"vm.updateTracker(4)\"></small>\n            <span>Review and Post</span>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<!------------------- Application-Status End --------------------->\n<div class=\"content\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12 process-description-outer\">\n        <div class=\"process-description\" ng-show=\"vm.page==1\">\n          <div class=\"row\">\n            <div class=\"title-section\">\n              <h3><span class=\"job-title-reminder\">Order</span> - Drop-off Details</h3>\n            </div>\n\n            <googleplaces ng-if=\"vm.page_loading==false && vm.page==1\"></googleplaces>\n\n            <form ng-submit=\"vm.validate_first_page()\" class=\"order-creation-first-page\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <label\n                  >Location*\n                  <span class=\"order-error-text\" ng-show=\"vm.order_creation_ui.first_page.is_error_location\"\n                    >- {{vm.order_creation_ui.first_page.is_error_location_msg}}</span\n                  ></label\n                >\n                <input\n                  type=\"text\"\n                  class=\"form-control form-input\"\n                  placeholder=\"Ex. Thai Siam Bistro\"\n                  ng-model=\"vm.order.dropoff.location\"\n                  ng-class=\"{'order-error':vm.order_creation_ui.first_page.is_error_location}\"\n                  ng-change=\"vm.dropoff_location_change()\"\n                />\n              </div>\n              <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                <label\n                  >Date*\n                  <span class=\"order-error-text\" ng-show=\"vm.order_creation_ui.first_page.is_error_date\"\n                    >- {{vm.order_creation_ui.first_page.is_error_date_msg}}</span\n                  ></label\n                >\n                <input\n                  type=\"text\"\n                  class=\"form-control form-input\"\n                  placeholder=\"Select\"\n                  id=\"datepicker-dropoff\"\n                  name=\"date\"\n                  ng-model=\"vm.order.dropoff.date_formatted\"\n                  ng-class=\"{'order-error':vm.order_creation_ui.first_page.is_error_date}\"\n                  ng-change=\"vm.dropoff_date_change()\"\n                />\n              </div>\n              <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                <label\n                  >Est. Drop-off Time*\n                  <span class=\"order-error-text\" ng-show=\"vm.order_creation_ui.first_page.is_error_time\"\n                    >- {{vm.order_creation_ui.first_page.is_error_time_msg}}</span\n                  ></label\n                >\n                <select\n                  class=\"industry-type-selector\"\n                  ng-options=\"times.id as times.name for times in vm.times.values\"\n                  ng-model=\"vm.times.value.id\"\n                  ng-change=\"vm.time_change(1)\"\n                  ng-class=\"{'order-error':vm.order_creation_ui.first_page.is_error_time}\"\n                ></select>\n              </div>\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <label\n                  >Special Instructions (Optional)\n                  <span class=\"order-error-text\" ng-show=\"vm.order_creation_ui.first_page.is_error_instructions\"\n                    >- {{vm.order_creation_ui.first_page.is_error_instructions_msg}}</span\n                  ></label\n                >\n                <textarea\n                  class=\"form-control form-input special-instructions\"\n                  rows=\"4\"\n                  placeholder=\"Ex. Please call Sharon at the front desk upon arrival\"\n                  ng-model=\"vm.order.dropoff.instructions\"\n                  ng-change=\"vm.changing_dropoff_instructions()\"\n                  ng-class=\"{'order-error':vm.order_creation_ui.first_page.is_error_instructions}\"\n                ></textarea>\n              </div>\n              <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                <label>Point of Contact (Optional)</label>\n                <input\n                  type=\"text\"\n                  class=\"form-control form-input\"\n                  placeholder=\"Ex. Kimbery Jones (555)-555-5555\"\n                  ng-model=\"vm.order.dropoff.contact\"\n                />\n                <span class=\"required-blurb\">* = Required</span>\n              </div>\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"order-navigator-wrapper\">\n                  <input type=\"submit\" value=\"Next: Pick up location\" class=\"btn button btn-success\" />\n                </div>\n              </div>\n            </form>\n          </div>\n        </div>\n\n        <div class=\"process-description\" ng-show=\"vm.page==2\">\n          <div class=\"row\">\n            <div class=\"title-section\">\n              <h3><span class=\"job-title-reminder\">Order</span> - Pick-up Details</h3>\n            </div>\n\n            <googleplaces ng-if=\"vm.page_loading==false && vm.page==2\"></googleplaces>\n\n            <form ng-submit=\"vm.validate_second_page()\" class=\"order-creation-first-page\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <label\n                  >Location*\n                  <span class=\"order-error-text\" ng-show=\"vm.order_creation_ui.second_page.is_error_location\"\n                    >- {{vm.order_creation_ui.second_page.is_error_location_msg}}</span\n                  ></label\n                >\n                <input\n                  type=\"text\"\n                  class=\"form-control form-input\"\n                  placeholder=\"Ex. Thai Siam Bistro, Ph. (555)-641-6361\"\n                  ng-model=\"vm.order.pickup.location\"\n                  ng-class=\"{'order-error':vm.order_creation_ui.second_page.is_error_location}\"\n                  ng-change=\"vm.pickup_location_change()\"\n                />\n              </div>\n              <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" style=\"height: 79px\">\n                <label\n                  >Date*\n                  <span class=\"order-error-text\" ng-show=\"vm.order_creation_ui.second_page.is_error_date\"\n                    >- {{vm.order_creation_ui.second_page.is_error_date_msg}}</span\n                  ></label\n                >\n                <input\n                  type=\"text\"\n                  class=\"form-control form-input\"\n                  placeholder=\"Select\"\n                  id=\"datepicker-pickup\"\n                  name=\"date\"\n                  ng-model=\"vm.order.pickup.date_formatted\"\n                  ng-class=\"{'order-error':vm.order_creation_ui.second_page.is_error_date}\"\n                  ng-change=\"vm.pickup_date_change()\"\n                />\n              </div>\n              <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                <label\n                  >Est. Pick-up Time*\n                  <span class=\"order-error-text\" ng-show=\"vm.order_creation_ui.second_page.is_error_time\"\n                    >- {{vm.order_creation_ui.second_page.is_error_time_msg}}</span\n                  ></label\n                >\n                <select\n                  class=\"industry-type-selector\"\n                  ng-options=\"times.id as times.name for times in vm.times.values\"\n                  ng-model=\"vm.times.value.id\"\n                  ng-change=\"vm.time_change(2)\"\n                  ng-class=\"{'order-error':vm.order_creation_ui.second_page.is_error_time}\"\n                ></select>\n              </div>\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <label\n                  >Special Instructions (Optional)\n                  <span class=\"order-error-text\" ng-show=\"vm.order_creation_ui.second_page.is_error_instructions\"\n                    >- {{vm.order_creation_ui.second_page.is_error_instructions_msg}}</span\n                  ></label\n                >\n                <textarea\n                  class=\"form-control form-input special-instructions\"\n                  rows=\"4\"\n                  placeholder=\"Ex. Please call Sharon at the front desk upon arrival\"\n                  ng-model=\"vm.order.pickup.instructions\"\n                  ng-change=\"vm.changing_pickup_instructions()\"\n                  ng-class=\"{'order-error':vm.order_creation_ui.second_page.is_error_instructions}\"\n                ></textarea>\n              </div>\n              <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                <label>Point of Contact (Optional)</label>\n                <input\n                  type=\"text\"\n                  class=\"form-control form-input\"\n                  placeholder=\"Ex. Kimbery Jones (555)-555-5555\"\n                  ng-model=\"vm.order.pickup.contact\"\n                />\n                <span class=\"required-blurb\">* = Required</span>\n              </div>\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"order-navigator-wrapper\">\n                  <input type=\"button\" value=\"Back: Drop-off Details\" class=\"btn button btn-success back-button\" ng-click=\"vm.back_to_step_one()\" />\n                  <input type=\"submit\" value=\"Next: Additional Details\" class=\"btn button btn-success\" />\n                </div>\n              </div>\n            </form>\n          </div>\n        </div>\n\n        <div class=\"process-description\" ng-show=\"vm.page==3\">\n          <div class=\"row\">\n            <div class=\"title-section\">\n              <h3>General</h3>\n            </div>\n            <form ng-submit=\"vm.validate_third_page()\" class=\"order-creation-first-page\">\n              <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                <label\n                  >Order Title*\n                  <span class=\"order-error-text\" ng-show=\"vm.order_creation_ui.third_page.is_error_order_name\"\n                    >- {{vm.order_creation_ui.third_page.is_error_order_name_msg}}</span\n                  ></label\n                >\n                <input\n                  type=\"text\"\n                  class=\"form-control form-input\"\n                  placeholder=\"Ex. Food Delivery - Boston\"\n                  ng-model=\"vm.order.name\"\n                  ng-change=\"vm.order_name_change()\"\n                  ng-class=\"{'order-error':vm.order_creation_ui.third_page.is_error_order_name}\"\n                />\n              </div>\n              <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                <label>Order Number(Optional)</label>\n                <input type=\"text\" class=\"form-control form-input\" placeholder=\"Ex. ODR-10001\" ng-model=\"vm.order.number\" />\n              </div>\n              <div class=\"row\"></div>\n              <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                <label\n                  >Payment (Optional)\n                  <span class=\"order-error-text\" ng-show=\"vm.order_creation_ui.third_page.is_error_payment\"\n                    >- {{vm.order_creation_ui.third_page.is_error_payment_msg}}</span\n                  ></label\n                >\n                <input\n                  type=\"text\"\n                  class=\"form-control form-input\"\n                  placeholder=\"--\"\n                  ng-model=\"vm.order.payment\"\n                  ng-change=\"vm.calc_numbers()\"\n                  ng-class=\"{'order-error':vm.order_creation_ui.third_page.is_error_payment}\"\n                />\n              </div>\n              <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                <label\n                  >Jobbler Receives (Optional)<span class=\"order-error-text\" ng-show=\"vm.order_creation_ui.third_page.is_error_payment\"\n                    >- {{vm.order_creation_ui.third_page.is_error_payment_msg}}</span\n                  ></label\n                >\n                <input\n                  type=\"text\"\n                  class=\"form-control form-input\"\n                  placeholder=\"--\"\n                  ng-model=\"vm.order.payment_adj\"\n                  ng-change=\"vm.calc_numbers_adj()\"\n                  ng-class=\"{'order-error':vm.order_creation_ui.third_page.is_error_payment}\"\n                />\n              </div>\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <label>Specfic Instructions (Optional)</label>\n                <textarea\n                  class=\"form-control form-input special-instructions\"\n                  rows=\"4\"\n                  placeholder=\"ex. Be sure to call John Smith upon arrival\"\n                  ng-model=\"vm.order.description\"\n                ></textarea>\n                <div class=\"order-navigator-wrapper\">\n                  <input type=\"button\" value=\"Back: Pick-up Details\" class=\"btn button btn-success back-button\" ng-click=\"vm.back_to_step_two()\" />\n                  <input type=\"submit\" value=\"Next: Review & Post\" class=\"btn button btn-success\" />\n                </div>\n              </div>\n            </form>\n          </div>\n        </div>\n\n        <div class=\"process-description\" ng-show=\"vm.page==4\">\n          <div class=\"row\">\n            <div class=\"title-section\">\n              <h3>Review & Post</h3>\n            </div>\n            <form ng-submit=\"vm.validate_fourth_page()\" class=\"order-creation-first-page\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <table class=\"table table-border line-item-table\">\n                  <thead>\n                    <tr>\n                      <th>Pick-up Details</th>\n                      <th></th>\n                    </tr>\n                  </thead>\n\n                  <tbody>\n                    <tr>\n                      <!-- Tues. January 10th, 2019 -->\n                      <td><strong>Date</strong></td>\n                      <td>{{ vm.order.pickup.date_time | date : 'EEE LLLL d, yyyy' }}</td>\n                    </tr>\n                    <tr>\n                      <td>\n                        <strong>Est. Pick-up Time</strong>\n                      </td>\n                      <td>{{ vm.order.pickup.date_time | date : 'hh:mm a' }}</td>\n                    </tr>\n                    <tr>\n                      <td><strong>Address</strong></td>\n                      <td>{{ vm.order.pickup.address }}</td>\n                    </tr>\n                    <tr>\n                      <td><strong>Location</strong></td>\n                      <td>{{ vm.order.pickup.location }}</td>\n                    </tr>\n                    <tr>\n                      <td><strong>Contact</strong></td>\n                      <td>{{ vm.order.pickup.contact ? vm.order.pickup.contact : \"---\" }}</td>\n                    </tr>\n                    <tr>\n                      <td>\n                        <strong>Special Instructions</strong>\n                      </td>\n                      <td>{{ vm.order.pickup.instructions ? vm.order.pickup.instructions : \"--\" }}</td>\n                    </tr>\n                  </tbody>\n                </table>\n\n                <table class=\"table table-border line-item-table\">\n                  <thead>\n                    <tr>\n                      <th>Drop-off Details</th>\n                      <th></th>\n                    </tr>\n                  </thead>\n\n                  <tbody>\n                    <tr>\n                      <td><strong>Date</strong></td>\n                      <td>{{ vm.order.dropoff.date_time | date : 'EEE LLLL d, yyyy' }}</td>\n                    </tr>\n                    <tr>\n                      <td>\n                        <strong>Est. Drop-off Time</strong>\n                      </td>\n                      <td>{{ vm.order.dropoff.date_time | date : 'hh:mm a' }}</td>\n                    </tr>\n                    <tr>\n                      <td><strong>Address</strong></td>\n                      <td>{{ vm.order.dropoff.address }}</td>\n                    </tr>\n                    <tr>\n                      <td><strong>Location</strong></td>\n                      <td>{{ vm.order.dropoff.location }}</td>\n                    </tr>\n                    <tr>\n                      <td><strong>Contact</strong></td>\n                      <td>{{ vm.order.dropoff.contact ? vm.order.dropoff.contact : \"---\" }}</td>\n                    </tr>\n                    <tr>\n                      <td>\n                        <strong>Special Instructions</strong>\n                      </td>\n                      <td>{{ vm.order.dropoff.instructions ? vm.order.dropoff.instructions : \"--\" }}</td>\n                    </tr>\n                  </tbody>\n                </table>\n\n                <table class=\"table table-border line-item-table\">\n                  <thead>\n                    <tr>\n                      <th>General</th>\n                      <th></th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                    <tr>\n                      <td><strong>Order Name</strong></td>\n                      <td>{{ vm.order.name }}</td>\n                    </tr>\n                    <tr>\n                      <td>\n                        <strong>Order Number</strong>\n                      </td>\n                      <td>{{ vm.order.number ? vm.order.number : \"--\" }}</td>\n                    </tr>\n                    <tr>\n                      <td>\n                        <strong>Additional Instructions</strong>\n                      </td>\n                      <td>{{ vm.order.description ? vm.order.description : \"--\" }}</td>\n                    </tr>\n                    <tr>\n                      <td><strong>Payment</strong></td>\n                      <td><span ng-show=\"vm.order.payment_display\">$</span>{{ vm.order.payment_display | number : 2 }}</td>\n                    </tr>\n                  </tbody>\n                </table>\n\n                <div class=\"order-navigator-wrapper\">\n                  <input\n                    type=\"button\"\n                    value=\"Back: Additional Details\"\n                    class=\"btn button btn-success back-button\"\n                    ng-click=\"vm.back_to_step_three()\"\n                  />\n                  <input type=\"submit\" value=\"Post Order\" class=\"btn button btn-success\" />\n                </div>\n              </div>\n            </form>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\">\n        <div class=\"process-status\">\n          <img class=\"creation-img-sml\" src=\"/app/vendor/images/delivery_icon.png\" />\n          <h3>Reach out to our driver pool..</h3>\n          <p>We have a workforce of reliable drivers looking for more deliveries to complete!</p>\n        </div>\n        <div class=\"event-team-selection-box\" ng-if=\"vm.teams.length > 0\" set-class-when-at-top=\"fix-to-top\">\n          <h4>Select team(s)</h4>\n          <p>Post privately to your team(s)</p>\n          <select\n            chosen\n            multiple\n            style=\"width: 95%\"\n            placeholder-text-multiple=\"'Choose teams'\"\n            ng-model=\"vm.order.teams_for_order\"\n            ng-options=\"team.id as team.name for team in vm.teams\"\n          >\n            <option value=\"\"></option>\n          </select>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<jobblefooter></jobblefooter>\n<globalalert></globalalert>\n<paymentdialog></paymentdialog>\n<globalmodal></globalmodal>\n\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n\n<div class=\"modal fade\" id=\"modal-post-event\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <span aria-hidden=\"true\">&times;</span>\n            </button>\n            <h4 class=\"modal-title\">Post Your Order</h4>\n          </div>\n          <div class=\"modal-body\">\n            <p>Once your order is posted, only the jobblers in your selected teams will be able to apply.</p>\n            <div class=\"clearfix\">\n              <a class=\"btn button btn-success\" href=\"\" ng-click=\"vm.post_order()\" style=\"font-size: 20px; text-align: center\"> Post Job </a>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PostorderController = function () {
	  function PostorderController($http, $localStorage, $state, $stateParams, AuthService, EnvService, TeamsService, CompaniesService, SecurityService, $filter, EventsService, $timeout, $location, $rootScope, $scope, TrackingService) {
	    _classCallCheck(this, PostorderController);
	
	    this.name = "postorder";
	    $localStorage.activeStateName = "postorder";
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$scope = $scope;
	    this.$env = EnvService;
	    this.$location = $location;
	    this.$rootScope = $rootScope;
	    this.currentUser = this.$auth.getUserData();
	    this.tracking = TrackingService;
	    this.$teams = TeamsService;
	    this.$companies = CompaniesService;
	    this.$security = SecurityService;
	    this.$filter = $filter;
	    this.$stateParams = $stateParams;
	    this.$events = EventsService;
	    this.$timeout = $timeout;
	    this.page = 1;
	    this.minutes_to_add_to_start_of_day = null;
	    this.remain_loading_count = 1;
	    this.page_loading = true;
	    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
	    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;
	    this.tracker = {
	      currentStep: 0,
	      previousStep: null,
	      nextStep: null,
	      visited_steps: [0]
	    };
	    this.statusBarStatus = {
	      step_2: {
	        visited: false,
	        bar_class: "app-progress-bar",
	        dot_class: "select"
	      },
	      step_3: {
	        visited: false,
	        bar_class: "app-progress-bar",
	        dot_class: "select"
	      },
	      step_4: {
	        visited: false,
	        bar_class: "app-progress-bar",
	        dot_class: "select"
	      },
	      step_5: {
	        visited: false,
	        bar_class: "app-progress-bar",
	        dot_class: "select"
	      }
	    };
	
	    this.order_creation_ui = {
	      first_page: {
	        is_error: false,
	        is_error_location: false,
	        is_error_location_msg: null,
	        is_error_address: false,
	        is_error_address_msg: null,
	        is_error_date: false,
	        is_error_date_msg: null,
	        is_error_time: false,
	        is_error_time_msg: null,
	        is_error_instructions: false,
	        is_error_instructions_msg: null
	      },
	      second_page: {
	        is_error: false,
	        is_error_location: false,
	        is_error_location_msg: null,
	        is_error_address: false,
	        is_error_address_msg: null,
	        is_error_date: false,
	        is_error_date_msg: null,
	        is_error_time: false,
	        is_error_time_msg: null,
	        is_error_instructions: false,
	        is_error_instructions_msg: null
	      },
	      third_page: {
	        is_error: false,
	        is_error_order_name: false,
	        is_error_order_name_msg: null
	      },
	      fourth_page: {
	        is_error: false
	      }
	    };
	
	    this.order = {
	      name: null,
	      openings: 1,
	      hourly_rate: 0,
	      dress_code: null,
	      payment: null,
	      description: null,
	      number: null,
	      jobble_type_id_for_backend: null,
	      user_time_zone: null,
	      teams_for_order: [],
	      pickup: {
	        address: null,
	        time_zone: null,
	        raw_offset: null,
	        date: null,
	        date_formatted: null,
	        location: null,
	        instructions: null,
	        contactInfo: null,
	        time: null,
	        contact: null
	      },
	      dropoff: {
	        address: null,
	        time_zone: null,
	        raw_offset: null,
	        date: null,
	        date_formatted: null,
	        location: null,
	        instructions: null,
	        contactInfo: null,
	        time: null,
	        contact: null
	      }
	    };
	
	    this.check_params();
	    this.load_page();
	    this.set_date_picker();
	    this.set_times();
	    this.set_padding();
	    this.check_teams();
	    this.check_for_clone();
	    this.check_root();
	
	    var _this = this;
	
	    _this.SetAddressListener = _this.$rootScope.$on("SetAddress", function ($event, params) {
	      _this.set_address(params);
	    });
	    _this.SetJobbleTypesListener = _this.$rootScope.$on("SetJobbleTypes", function ($event, params) {
	      _this.check_root(params);
	    });
	
	    _this.$scope.$on("$destroy", _this.SetAddressListener);
	    _this.$scope.$on("$destroy", _this.SetJobbleTypesListener);
	  }
	
	  _createClass(PostorderController, [{
	    key: "validate_first_page",
	    value: function validate_first_page() {
	      var _this = this;
	      _this.setLoader();
	      _this.remain_loading_count = 1;
	      var validation_array = _this.validate_fields_on_first_page();
	      if (validation_array === true) {
	        _this.remain_loading_count = 0;
	        _this.unSetLoader();
	      } else if (_this.order_creation_ui.first_page.is_error) {
	        _this.set_errors_to_page(validation_array);
	        _this.remain_loading_count = 0;
	        _this.unSetLoader();
	      } else {
	        _this.times.value.id = 1;
	        _this.setNextDay();
	        _this.page = 2;
	        _this.statusBarStatus.step_2.visited = true;
	        _this.tracker.visited_steps.push(2);
	        _this.some_date_moment = null;
	        _this.minutes_to_add_to_start_of_day = null;
	        if (_this.cloned_event) {
	          _this.set_second_page_to_clone(_this.cloned_event);
	        }
	        _this.$timeout(function () {
	          _this.unSetLoader();
	          _this.remain_loading_count = 0;
	        }, 1000);
	      }
	    }
	  }, {
	    key: "validate_second_page",
	    value: function validate_second_page() {
	      var _this = this;
	      var validation_array = _this.validate_fields_on_second_page();
	      if (validation_array === true) {
	        _this.remain_loading_count = 0;
	        _this.unSetLoader();
	      } else if (_this.order_creation_ui.second_page.is_error) {
	        _this.set_errors_to_second_page(validation_array);
	        _this.remain_loading_count = 0;
	        _this.unSetLoader();
	      } else {
	        _this.page = 3;
	        _this.statusBarStatus.step_3.visited = true;
	        _this.tracker.visited_steps.push(3);
	        if (_this.cloned_event) {
	          _this.set_third_page_to_clone();
	        }
	      }
	    }
	  }, {
	    key: "validate_third_page",
	    value: function validate_third_page() {
	      var _this = this;
	      var validation_array = _this.validate_fields_on_third_page();
	      if (_this.order_creation_ui.third_page.is_error) {
	        _this.set_errors_to_third_page(validation_array);
	        _this.remain_loading_count = 0;
	        _this.unSetLoader();
	      } else {
	        _this.set_dates_for_display();
	        _this.page = 4;
	        _this.statusBarStatus.step_4.visited = true;
	        _this.setPayment();
	        _this.tracker.visited_steps.push(4);
	      }
	    }
	  }, {
	    key: "set_dates_for_display",
	    value: function set_dates_for_display() {
	      var _this = this;
	      var pud = _this.order.pickup.date_time;
	      var dod = _this.order.dropoff.date_time;
	
	      console.log("whats the pick up date");
	      console.dir(pud);
	
	      if (!pud) {
	        if (_this.order.pickup.date_moment) {
	          _this.order.pickup.date_time = _this.order.pickup.date_moment.format();
	        } else if (_this.order.pickup.date) {
	          _this.order.pickup.date_time = _this.order.pickup.date.format();
	        }
	      }
	      if (!dod) {
	        if (_this.order.dropoff.date_moment) {
	          _this.order.dropoff.date_time = _this.order.dropoff.date_moment.format();
	        } else if (_this.order.dropoff.date) {
	          _this.order.dropoff.date_time.format();
	        }
	      }
	    }
	  }, {
	    key: "setPayment",
	    value: function setPayment() {
	      var _this = this;
	      _this.order.payment_display = _this.order.payment_formatted / 100;
	    }
	  }, {
	    key: "validate_fourth_page",
	    value: function validate_fourth_page() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("#modal-post-event").modal();
	      });
	    }
	  }, {
	    key: "validate_fields_on_third_page",
	    value: function validate_fields_on_third_page() {
	      var _this = this;
	      var third_page_errors = [];
	      var order_name_check = null;
	      var order_payment_check = null;
	      order_name_check = _this.validate_order_name();
	      if (order_name_check.error) {
	        third_page_errors.push(order_name_check);
	      }
	      order_payment_check = _this.validate_order_payment();
	      if (order_payment_check.error) {
	        third_page_errors.push(order_payment_check);
	      }
	      if (third_page_errors.length > 0) {
	        _this.order_creation_ui.third_page.is_error = true;
	      } else {
	        _this.order_creation_ui.third_page.is_error = false;
	      }
	      _this.format_payment();
	      return third_page_errors;
	    }
	  }, {
	    key: "format_payment",
	    value: function format_payment() {
	      var _this = this;
	      var payment_parsed = null;
	      var p = _this.order.payment;
	      if (p) {
	        if (p.includes(".")) {
	          payment_parsed = parseFloat(p) * 100;
	          _this.order.payment_formatted = payment_parsed;
	        } else {
	          payment_parsed = parseInt(p, 10) * 100;
	          _this.order.payment_formatted = payment_parsed;
	        }
	      }
	    }
	  }, {
	    key: "validate_fields_on_second_page",
	    value: function validate_fields_on_second_page() {
	      var _this = this;
	
	      if (_this.order_creation_ui.second_page.is_error) {
	        return true;
	      }
	      var second_page_errors = [];
	      var pickup_address_check = null;
	      var pickup_location_check = null;
	      var pickup_date = null;
	      var pickup_time = null;
	      var pickup_instructions = null;
	      pickup_address_check = _this.validate_pickup_address();
	      if (pickup_address_check.error) {
	        second_page_errors.push(pickup_address_check);
	      }
	      pickup_location_check = _this.validate_pickup_location();
	      if (pickup_location_check.error) {
	        second_page_errors.push(pickup_location_check);
	      }
	      pickup_date = _this.validate_pickup_date();
	      if (pickup_date.error) {
	        second_page_errors.push(pickup_date);
	      }
	      pickup_time = _this.validate_pickup_time();
	      if (pickup_time.error) {
	        second_page_errors.push(pickup_time);
	      }
	      if (second_page_errors.length > 0) {
	        _this.order_creation_ui.second_page.is_error = true;
	      } else {
	        _this.order_creation_ui.second_page.is_error = false;
	      }
	      return second_page_errors;
	    }
	  }, {
	    key: "set_errors_to_third_page",
	    value: function set_errors_to_third_page(errors_array) {
	      var _this = this;
	      errors_array.forEach(function (error_array) {
	        var id = error_array.id;
	        switch (id) {
	          case 1:
	            _this.order_creation_ui.third_page.is_error_order_name = true;
	            _this.order_creation_ui.third_page.is_error_order_name_msg = error_array.message;
	            break;
	          case 2:
	            _this.order_creation_ui.third_page.is_error_payment = true;
	            _this.order_creation_ui.third_page.is_error_payment_msg = error_array.message;
	            break;
	        }
	      });
	    }
	  }, {
	    key: "set_errors_to_second_page",
	    value: function set_errors_to_second_page(errors_array) {
	      var _this = this;
	      errors_array.forEach(function (error_array) {
	        var id = error_array.id;
	        switch (id) {
	          case 1:
	            _this.set_address_error_to_google_places(2);
	            break;
	          case 2:
	            _this.order_creation_ui.second_page.is_error_location = true;
	            _this.order_creation_ui.second_page.is_error_location_msg = error_array.message;
	            break;
	          case 3:
	            _this.order_creation_ui.second_page.is_error_date = true;
	            _this.order_creation_ui.second_page.is_error_date_msg = error_array.message;
	            break;
	          case 4:
	            _this.order_creation_ui.second_page.is_error_time = true;
	            _this.order_creation_ui.second_page.is_error_time_msg = error_array.message;
	            break;
	          case 5:
	            _this.order_creation_ui.second_page.is_error_instructions = true;
	            _this.order_creation_ui.second_page.is_error_instructions_msg = error_array.message;
	            break;
	        }
	      });
	    }
	  }, {
	    key: "set_errors_to_page",
	    value: function set_errors_to_page(errors_array) {
	      var _this = this;
	      errors_array.forEach(function (error_array) {
	        var id = error_array.id;
	        switch (id) {
	          case 1:
	            _this.set_address_error_to_google_places(1);
	            break;
	          case 2:
	            _this.order_creation_ui.first_page.is_error_location = true;
	            _this.order_creation_ui.first_page.is_error_location_msg = error_array.message;
	            break;
	          case 3:
	            _this.order_creation_ui.first_page.is_error_date = true;
	            _this.order_creation_ui.first_page.is_error_date_msg = error_array.message;
	            break;
	          case 4:
	            _this.order_creation_ui.first_page.is_error_time = true;
	            _this.order_creation_ui.first_page.is_error_time_msg = error_array.message;
	            break;
	          case 5:
	            _this.order_creation_ui.first_page.is_error_instructions = true;
	            _this.order_creation_ui.first_page.is_error_instructions_msg = error_array.message;
	            break;
	        }
	      });
	    }
	  }, {
	    key: "set_address_error_to_google_places",
	    value: function set_address_error_to_google_places(page) {
	      var _this = this;
	      if (_this.page === 1) {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetAddressError", {
	            page: page
	          });
	        });
	      } else if (_this.page === 2) {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetAddressErrorPickup", {
	            page: page
	          });
	        });
	      }
	    }
	  }, {
	    key: "validate_fields_on_first_page",
	    value: function validate_fields_on_first_page() {
	      var _this = this;
	
	      if (_this.order_creation_ui.first_page.is_error) {
	        return true;
	      }
	
	      var first_page_errors = [];
	      var drop_off_address_check = null;
	      var drop_off_location_check = null;
	      var drop_off_date = null;
	      var drop_off_time = null;
	      var drop_off_instructions = null;
	
	      drop_off_address_check = _this.validate_dropoff_address();
	      if (drop_off_address_check.error) {
	        first_page_errors.push(drop_off_address_check);
	      }
	
	      drop_off_location_check = _this.validate_dropoff_location();
	      if (drop_off_location_check.error) {
	        first_page_errors.push(drop_off_location_check);
	      }
	
	      drop_off_date = _this.validate_drop_off_date();
	      if (drop_off_date.error) {
	        first_page_errors.push(drop_off_date);
	      }
	
	      drop_off_time = _this.validate_drop_off_time();
	      if (drop_off_time.error) {
	        first_page_errors.push(drop_off_time);
	      }
	
	      if (first_page_errors.length > 0) {
	        _this.order_creation_ui.first_page.is_error = true;
	      } else {
	        _this.order_creation_ui.first_page.is_error = false;
	      }
	
	      console.log("what are the errors on the first page");
	      console.dir(first_page_errors);
	
	      return first_page_errors;
	    }
	  }, {
	    key: "validate_drop_off_instructions",
	    value: function validate_drop_off_instructions() {
	      var _this = this;
	      var err = {};
	
	      if (!_this.order.dropoff.instructions) {
	        err.error = true;
	        err.message = "Dropoff instructions are required.";
	        err.id = 5;
	      } else {
	        err.error = false;
	      }
	
	      return err;
	    }
	  }, {
	    key: "validate_drop_off_time",
	    value: function validate_drop_off_time() {
	      var _this = this;
	      var err = {};
	
	      if (_this.times.value.id === 1) {
	        err.error = true;
	        err.message = "A dropoff time is required.";
	        err.id = 4;
	      } else {
	        err.error = false;
	      }
	
	      return err;
	    }
	  }, {
	    key: "validate_pickup_time",
	    value: function validate_pickup_time() {
	      var _this = this;
	      var err = {};
	
	      if (_this.times.value.id === 1) {
	        err.error = true;
	        err.message = "A pickup time is required.";
	        err.id = 4;
	      } else {
	        err.error = false;
	      }
	
	      return err;
	    }
	  }, {
	    key: "validate_pickup_date",
	    value: function validate_pickup_date() {
	      var _this = this;
	      var err = {};
	
	      if (!_this.order.pickup.date_formatted) {
	        err.error = true;
	        err.message = "A pickup date is required.";
	        err.id = 3;
	      } else {
	        err.error = false;
	      }
	
	      return err;
	    }
	  }, {
	    key: "validate_drop_off_date",
	    value: function validate_drop_off_date() {
	      var _this = this;
	      var err = {};
	
	      if (!_this.order.dropoff.date_formatted) {
	        err.error = true;
	        err.message = "A dropoff date is required.";
	        err.id = 3;
	      } else {
	        err.error = false;
	      }
	
	      return err;
	    }
	  }, {
	    key: "validate_order_name",
	    value: function validate_order_name() {
	      var _this = this;
	
	      var err = {};
	
	      if (!_this.order.name) {
	        err.error = true;
	        err.message = "An order name is required.";
	        err.id = 1;
	      } else {
	        err.error = false;
	      }
	
	      return err;
	    }
	  }, {
	    key: "validate_order_payment",
	    value: function validate_order_payment() {
	      var _this = this;
	      var err = {};
	
	      if (_this.order.payment) {
	        var passes_regex = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/.test(_this.order.payment);
	        if (!passes_regex) {
	          err.error = true;
	          err.message = "The payment is formatted incorrectly.";
	          err.id = 2;
	        } else {
	          err.error = false;
	        }
	      } else {
	        err.error = false;
	      }
	
	      return err;
	    }
	  }, {
	    key: "validate_pickup_address",
	    value: function validate_pickup_address() {
	      var _this = this;
	      var err = {};
	      if (!_this.order.pickup.address) {
	        err.error = true;
	        err.message = "A pickup address is required.";
	        err.id = 1;
	      } else {
	        err.error = false;
	      }
	      return err;
	    }
	  }, {
	    key: "validate_dropoff_address",
	    value: function validate_dropoff_address() {
	      var _this = this;
	      var err = {};
	
	      if (!_this.order.dropoff.address) {
	        err.error = true;
	        err.message = "A dropoff address is required.";
	        err.id = 1;
	        //_this.order_creation_ui.first_page.is_error_address=true;
	      } else {
	        err.error = false;
	      }
	      return err;
	    }
	  }, {
	    key: "validate_pickup_location",
	    value: function validate_pickup_location() {
	      var _this = this;
	      var err = {};
	      if (!_this.order.pickup.location) {
	        err.error = true;
	        err.message = "A pickup location is required.";
	        err.id = 2;
	        //_this.order_creation_ui.first_page.is_error_location=true;
	      } else {
	        err.error = false;
	      }
	      return err;
	    }
	  }, {
	    key: "validate_dropoff_location",
	    value: function validate_dropoff_location() {
	      var _this = this;
	      var err = {};
	      if (!_this.order.dropoff.location) {
	        err.error = true;
	        err.message = "A dropoff location is required.";
	        err.id = 2;
	        //_this.order_creation_ui.first_page.is_error_location=true;
	      } else {
	        err.error = false;
	      }
	      return err;
	    }
	  }, {
	    key: "back_to_step_one",
	    value: function back_to_step_one() {
	      var _this = this;
	      _this.page = 1;
	      _this.setLoader();
	      _this.remain_loading_count = 1;
	      var index = _this.times.values.findIndex(function (p) {
	        return p.id == _this.order.dropoff.time.id;
	      });
	      var time_selector = _this.times.values[index];
	      _this.$timeout(function () {
	        _this.times.value.id = time_selector.id;
	        _this.order.dropoff.time = time_selector;
	      });
	      _this.set_address_to_google_places(_this.order.dropoff.address);
	      _this.$timeout(function () {
	        _this.remain_loading_count = 0;
	        _this.unSetLoader();
	      }, 1000);
	    }
	  }, {
	    key: "back_to_step_two",
	    value: function back_to_step_two() {
	      var _this = this;
	      _this.page = 2;
	      _this.setLoader();
	      _this.remain_loading_count = 1;
	      var index = _this.times.values.findIndex(function (p) {
	        return p.id == _this.order.pickup.time.id;
	      });
	      var time_selector = _this.times.values[index];
	      _this.$timeout(function () {
	        _this.times.value.id = time_selector.id;
	        _this.order.pickup.time = time_selector;
	      });
	      _this.set_address_to_google_places(_this.order.pickup.address);
	      _this.$timeout(function () {
	        _this.remain_loading_count = 0;
	        _this.unSetLoader();
	      }, 1000);
	    }
	  }, {
	    key: "back_to_step_three",
	    value: function back_to_step_three() {
	      var _this = this;
	      _this.page = 3;
	    }
	  }, {
	    key: "load_page",
	    value: function load_page() {
	      var _this = this;
	      _this.$timeout(function () {
	        //_this.remain_loading_count = 0;
	        _this.page_loading = false;
	      }, 1000);
	    }
	  }, {
	    key: "set_address",
	    value: function set_address(params) {
	      var _this = this;
	      var google_response = params.address.adr_address;
	      var coords = params.address;
	      var shift_data = {};
	      shift_data.contactInfo = {};
	      shift_data.contactInfo.lat = coords.lat;
	      shift_data.contactInfo.lng = coords.lng;
	      var address_array = google_response.split(",");
	      try {
	        address_array.forEach(function (part, index) {
	          if (part.indexOf("street-address") > -1) {
	            var street_array = /<span[^>]*>(.*?)<\/span>/.exec(part);
	            shift_data.contactInfo.streetLine1 = street_array[1];
	          }
	          if (part.indexOf("locality") > -1) {
	            var city_array = /<span[^>]*>(.*?)<\/span>/.exec(part);
	            shift_data.contactInfo.city = city_array[1];
	          }
	          if (part.indexOf("region") > -1) {
	            var regionAndZipArray = part.split("> <");
	
	            regionAndZipArray.forEach(function (p) {
	              if (p.indexOf("region") > -1) {
	                var state_array = /\s<span[^>]*>(.*?)<\/span/.exec(p);
	                shift_data.contactInfo.state = state_array[1];
	              }
	              if (p.indexOf("postal-code") > -1) {
	                var zip_array = /span[^>]*>(.*?)<\/span>/.exec(p);
	                shift_data.contactInfo.zipCode = zip_array[1];
	              }
	            });
	          }
	        });
	      } catch (err) {
	        console.log("error looping googleplaces");
	        console.dir(err);
	      }
	      _this.getTimeZones(shift_data);
	    }
	  }, {
	    key: "getTimeZones",
	    value: function getTimeZones(shift_data) {
	      var _this = this;
	      _this.$security.getEventShiftTimezoneInfo(shift_data).then(function (response) {
	        console.log("response");
	        console.dir(response);
	        if (response.status === 200) {
	          var places_data = response.data[0];
	          _this.compareTimeZones(places_data, shift_data);
	        }
	      }, function (error) {
	        console.log("error getting zipcodes");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "compareTimeZones",
	    value: function compareTimeZones(places_data, shift_data) {
	      var _this = this;
	      var client_time_zone = moment.tz.guess();
	      var shift_time_zone = places_data.timeZoneId;
	      if (_this.page === 1) {
	        _this.order.user_time_zone = client_time_zone;
	        _this.order.dropoff.address = shift_data.contactInfo.streetLine1 + " " + shift_data.contactInfo.city + " " + shift_data.contactInfo.state + " " + shift_data.contactInfo.zipCode;
	        _this.order.dropoff.contactInfo = shift_data.contactInfo;
	        _this.order.dropoff.time_zone_id = shift_time_zone;
	        _this.order.dropoff.raw_offset = places_data.rawOffset;
	        _this.order_creation_ui.first_page.is_error = false;
	      } else if (_this.page === 2) {
	        _this.order.pickup.address = shift_data.contactInfo.streetLine1 + " " + shift_data.contactInfo.city + " " + shift_data.contactInfo.state + " " + shift_data.contactInfo.zipCode;
	        _this.order.pickup.contactInfo = shift_data.contactInfo;
	        _this.order.pickup.time_zone_id = shift_time_zone;
	        _this.order.pickup.raw_offset = places_data.rawOffset;
	        _this.order_creation_ui.second_page.is_error = false;
	      }
	    }
	  }, {
	    key: "set_date_picker",
	    value: function set_date_picker() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("#datepicker-dropoff").datepicker({
	          showOn: "both",
	          buttonImage: "/app/vendor/images/calender.png",
	          buttonImageOnly: true,
	          buttonText: "Select date",
	          dateFormat: "M dd, yy"
	        });
	      }, 100);
	
	      _this.$timeout(function () {
	        $("#datepicker-pickup").datepicker({
	          showOn: "both",
	          buttonImage: "/app/vendor/images/calender.png",
	          buttonImageOnly: true,
	          buttonText: "Select date",
	          dateFormat: "M dd, yy"
	        });
	      }, 100);
	    }
	  }, {
	    key: "set_padding",
	    value: function set_padding() {
	      var _this = this;
	      //{id:6,name:"1:00 AM"},{id:7,name:"1:15 AM"},{id:8,name:"1:30 AM"},{id:9,name:"1:45 AM"}
	      var padding_times = {
	        value: {
	          id: 1,
	          name: "Select Padding"
	        },
	        values: [{
	          id: 1,
	          name: "Select Padding"
	        }, {
	          id: 2,
	          name: "15 Min"
	        }, {
	          id: 3,
	          name: "30 Min"
	        }, {
	          id: 4,
	          name: "45 Min"
	        }, {
	          id: 5,
	          name: "1 Hour"
	        }]
	      };
	
	      _this.padding_times = padding_times;
	    }
	  }, {
	    key: "changing_times",
	    value: function changing_times() {
	      var _this = this;
	      console.log("changing times");
	      console.dir(_this.times.value.id);
	    }
	  }, {
	    key: "changing_padding",
	    value: function changing_padding() {
	      var _this = this;
	      console.log("chaning padding");
	      console.dir(_this.padding_time.id);
	    }
	  }, {
	    key: "pickup_location_change",
	    value: function pickup_location_change() {
	      var _this = this;
	      console.log("pickup_location_change");
	    }
	  }, {
	    key: "order_name_change",
	    value: function order_name_change() {
	      var _this = this;
	      if (_this.order_creation_ui.third_page.is_error_order_name) {
	        _this.order_creation_ui.third_page.is_error_order_name = false;
	      }
	    }
	  }, {
	    key: "dropoff_location_change",
	    value: function dropoff_location_change() {
	      var _this = this;
	      if (_this.order_creation_ui.first_page.is_error_location) {
	        _this.order_creation_ui.first_page.is_error_location = false;
	        _this.order_creation_ui.first_page.is_error = false;
	      }
	    }
	  }, {
	    key: "pickup_location_change",
	    value: function pickup_location_change() {
	      var _this = this;
	      if (_this.order_creation_ui.second_page.is_error_location) {
	        _this.order_creation_ui.second_page.is_error_location = false;
	        _this.order_creation_ui.second_page.is_error = false;
	      }
	    }
	  }, {
	    key: "changing_dropoff_instructions",
	    value: function changing_dropoff_instructions() {
	      var _this = this;
	      if (_this.order.dropoff.instructions) {
	        _this.order_creation_ui.first_page.is_error_instructions = false;
	      }
	    }
	  }, {
	    key: "changing_pickup_instructions",
	    value: function changing_pickup_instructions() {
	      var _this = this;
	      if (_this.order.pickup.instructions) {
	        _this.order_creation_ui.second_page.is_error_instructions = false;
	      }
	    }
	  }, {
	    key: "updateTracker",
	    value: function updateTracker(page) {
	      var _this = this;
	      if (_this.tracker.visited_steps.indexOf(page) > -1) {
	        _this.page = page;
	      } else {
	        console.log("nothing");
	      }
	    }
	  }, {
	    key: "calc_numbers",
	    value: function calc_numbers() {
	      var _this = this;
	      var passes_regex = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/.test(_this.order.payment);
	      console.log("passes_regex");
	      console.dir(passes_regex);
	      console.dir(_this.order.payment);
	      console.dir(_this.order.payment_adj);
	      if (_this.order.payment && passes_regex === false && _this.order.payment !== "") {
	        _this.order_creation_ui.third_page.is_error_payment = true;
	        _this.order_creation_ui.third_page.is_error_payment_msg = "Correct format Ex. (50.00)";
	      } else {
	        _this.order_creation_ui.third_page.is_error_payment = false;
	        _this.order_creation_ui.third_page.is_error_payment_msg = null;
	      }
	      //_this.event.hourly_rate_adj = "";
	      if (isNaN(_this.order.payment_adj)) {
	        _this.order.payment_adj = "";
	        // || _this.ismarketing
	        if (_this.order.is_clone) {
	          _this.order.payment_adj = (parseFloat(_this.order.payment) * (1 - _this.currentUser.company.defaultPlan.jobblerFeePct)).toFixed(2);
	        }
	      } else {
	        if (!_this.currentUser) {
	          _this.order.payment_adj = (parseFloat(_this.order.payment) * 0.75).toFixed(2);
	        } else {
	          _this.order.payment_adj = (parseFloat(_this.order.payment) * (1 - _this.currentUser.company.defaultPlan.jobblerFeePct)).toFixed(2);
	        }
	        if (isNaN(_this.order.payment_adj)) {
	          _this.order.payment_adj = "";
	        }
	      }
	    }
	  }, {
	    key: "calc_numbers_adj",
	    value: function calc_numbers_adj() {
	      var _this = this;
	      var passes_regex = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/.test(_this.order.payment);
	      console.log("passes_regex");
	      console.dir(passes_regex);
	      console.dir(_this.order.payment);
	      console.dir(_this.order.payment_adj);
	      if (_this.order.payment_adj && passes_regex === false && _this.order.payment_adj !== "") {
	        _this.order_creation_ui.third_page.is_error_payment = true;
	        _this.order_creation_ui.third_page.is_error_payment_msg = "Correct format Ex. (50.00)";
	      } else {
	        _this.order_creation_ui.third_page.is_error_payment = false;
	        _this.order_creation_ui.third_page.is_error_payment_msg = null;
	      }
	      if (isNaN(_this.order.payment)) {
	        _this.event.hourly_rate = "";
	      } else {
	        if (!_this.currentUser) {
	          var p = 100 - 0.25 * 100;
	          var x = parseFloat(_this.order.payment_adj) * 100;
	          var z = x / p;
	          _this.order.payment = z.toFixed(2);
	        } else {
	          var _p = 100 - _this.currentUser.company.defaultPlan.jobblerFeePct * 100;
	          var _x = parseFloat(_this.order.payment_adj) * 100;
	          var _z = _x / _p;
	          _this.order.payment = _z.toFixed(2);
	        }
	        if (isNaN(_this.order.payment)) {
	          _this.order.payment = "";
	        }
	      }
	    }
	
	    /*
	      calcNumbers(){
	    var _this=this;
	    console.log('calcNumberscalcNumberscalcNumberscalcNumberscalcNumberscalcNumbers');
	    console.dir(_this.event.hourly_rate);
	    console.dir(_this.event.hourly_rate_adj);
	    console.dir(_this.currentUser);
	    console.dir(isNaN(_this.event.hourly_rate_adj));
	    _this.detailsChanged(2, true);
	    if (isNaN(_this.event.hourly_rate_adj)){
	    	_this.event.hourly_rate_adj = "";
	    	if (_this.isClone || _this.ismarketing) {
	    		_this.event.hourly_rate_adj = (parseFloat(_this.event.hourly_rate) * (1 - _this.currentUser.company.defaultPlan.jobblerFeePct)).toFixed(2);
	    	}
	    } else {
	    	if (!_this.currentUser) {
	    		_this.event.hourly_rate_adj = (parseFloat(_this.event.hourly_rate) * (.75)).toFixed(2);
	    	} else {
	    		_this.event.hourly_rate_adj = (parseFloat(_this.event.hourly_rate) * (1 - _this.currentUser.company.defaultPlan.jobblerFeePct)).toFixed(2);
	    	}
	    	if (isNaN(_this.event.hourly_rate_adj)) {
	    		_this.event.hourly_rate_adj = "";
	    	}
	    }
	    }
	    calcNumbersAdj(){
	    var _this=this;
	    _this.detailsChanged(2, true);
	    if (isNaN(_this.event.hourly_rate)){
	    	_this.event.hourly_rate = "";
	    }else{
	    	if (!_this.currentUser){
	    		let p = (100 - (.25 * 100));
	    		let x = parseFloat(_this.event.hourly_rate_adj) * 100;
	    		let z = x / p;
	    		_this.event.hourly_rate = z.toFixed(2);
	    	}else{
	    		let p = (100 - (_this.currentUser.company.defaultPlan.jobblerFeePct * 100));
	    		let x = parseFloat(_this.event.hourly_rate_adj) * 100;
	    		let z = x / p;
	    		_this.event.hourly_rate = z.toFixed(2);
	    	}
	    	if(isNaN(_this.event.hourly_rate)){
	    		_this.event.hourly_rate = "";
	    	}
	    }
	    }
	      */
	
	  }, {
	    key: "pickup_date_change",
	    value: function pickup_date_change(is_clone, skip) {
	      var _this = this;
	
	      var d = null;
	
	      if (is_clone) {
	        d = _this.order.pickup.date.format();
	      } else {
	        d = _this.order.pickup.date_formatted;
	      }
	
	      if (d) {
	        var moment_start_of_date = moment(d).startOf("day");
	        var moment_current_day = moment();
	        var date_test = null;
	        if (_this.times.value.id === 1) {
	          date_test = moment_start_of_date.isBefore(moment_current_day);
	        } else {
	          var id = _this.times.value.id;
	          var index = _this.times.values.findIndex(function (p) {
	            return p.id == id;
	          });
	          var time_selector = _this.times.values[index];
	          var time_to_parse = time_selector.name;
	          var time_parts_array = time_to_parse.split(/[ :]+/);
	          var additional_minutes = 0;
	          var ampm = time_parts_array[2];
	          var num = time_parts_array[0];
	
	          if (ampm === "PM") {
	            console.log("---1");
	            if (time_parts_array[0] !== "12") {
	              console.log("---3");
	              additional_minutes = 720;
	            }
	          }
	          if (num === "12" && ampm === "AM") {
	            console.log("---3");
	            num = "0";
	          }
	          var hours_to_minutes = parseInt(num, 10) * 60;
	          var minutes_to_minutes = parseInt(time_parts_array[1], 10);
	          var minutes_to_add_to_start_of_day = hours_to_minutes + minutes_to_minutes + additional_minutes;
	          var date_test_moment = moment_start_of_date.add(minutes_to_add_to_start_of_day, "minutes");
	          date_test = date_test_moment.isBefore(moment());
	          if (date_test) {
	            _this.order_creation_ui.second_page.is_error_date = true;
	            _this.order_creation_ui.second_page.is_error = true;
	            _this.order_creation_ui.second_page.is_error_time = true;
	            _this.order_creation_ui.second_page.is_error_date_msg = "Please select a date the future.";
	            _this.order_creation_ui.second_page.is_error_time_msg = "Please select a time in the future.";
	          } else {
	            _this.order_creation_ui.second_page.is_error_date = false;
	            _this.order_creation_ui.second_page.is_error_time = false;
	            _this.order_creation_ui.second_page.is_error = false;
	            var date_for_order = d;
	            _this.format_date_for_order(d);
	          }
	        }
	      }
	    }
	  }, {
	    key: "dropoff_date_change",
	    value: function dropoff_date_change(is_clone) {
	      var _this = this;
	
	      var d = null;
	      if (is_clone) {
	        d = _this.order.dropoff.date.format();
	      } else {
	        d = _this.order.dropoff.date_formatted;
	      }
	      if (d) {
	        var moment_start_of_date = moment(d).startOf("day");
	        var moment_current_day = moment();
	        var date_test = null;
	        if (_this.times.value.id === 1) {
	          date_test = moment_start_of_date.isBefore(moment_current_day);
	        } else {
	          var id = _this.times.value.id;
	          var index = _this.times.values.findIndex(function (p) {
	            return p.id == id;
	          });
	          var time_selector = _this.times.values[index];
	          var time_to_parse = time_selector.name;
	          var time_parts_array = time_to_parse.split(/[ :]+/);
	          var additional_minutes = 0;
	          var ampm = time_parts_array[2];
	          var num = time_parts_array[0];
	          if (ampm === "PM") {
	            if (time_parts_array[0] !== "12") {
	              additional_minutes = 720;
	            }
	          }
	          if (num === "12" && ampm === "AM") {
	            num = "0";
	          }
	          var hours_to_minutes = parseInt(time_parts_array[0], 10) * 60;
	          var minutes_to_minutes = parseInt(time_parts_array[1], 10);
	          var minutes_to_add_to_start_of_day = hours_to_minutes + minutes_to_minutes + additional_minutes;
	          var date_test_moment = moment_start_of_date.add(minutes_to_add_to_start_of_day, "minutes");
	          date_test = date_test_moment.isBefore(moment());
	          if (date_test) {
	            _this.order_creation_ui.first_page.is_error_date = true;
	            _this.order_creation_ui.first_page.is_error = true;
	            _this.order_creation_ui.first_page.is_error_time = true;
	            _this.order_creation_ui.first_page.is_error_date_msg = "Please select a date the future.";
	            _this.order_creation_ui.first_page.is_error_time_msg = "Please select a time in the future.";
	          } else {
	            _this.order_creation_ui.first_page.is_error_date = false;
	            _this.order_creation_ui.first_page.is_error_time = false;
	            _this.order_creation_ui.first_page.is_error = false;
	            var date_for_order = d;
	            _this.order.dropoff.date_moment = date_test_moment;
	            _this.format_date_for_order(d);
	          }
	        }
	      }
	    }
	  }, {
	    key: "format_date_for_order",
	    value: function format_date_for_order(date) {
	      var _this = this;
	
	      var some_date = new Date(date);
	      var some_date_moment = moment(some_date).startOf("day");
	      _this.some_date_moment = some_date_moment;
	      _this.check_for_date_time();
	    }
	  }, {
	    key: "check_for_date_time",
	    value: function check_for_date_time() {
	      var _this = this;
	
	      if (!_this.some_date_moment && _this.page === 2) {
	        var some_date = new Date(_this.order.pickup.date_formatted);
	        var some_date_moment = moment(some_date).startOf("day");
	        _this.some_date_moment = some_date_moment;
	      }
	
	      var date_time = null;
	
	      if (!_this.minutes_to_add_to_start_of_day) {
	        var id = _this.times.value.id;
	        var index = _this.times.values.findIndex(function (p) {
	          return p.id == id;
	        });
	        var time_selector = _this.times.values[index];
	        var time_to_parse = time_selector.name;
	        var time_parts_array = time_to_parse.split(/[ :]+/);
	        var additional_minutes = 0;
	        var ampm = time_parts_array[2];
	        var num = time_parts_array[0];
	        if (ampm === "PM") {
	          if (time_parts_array[0] !== "12") {
	            additional_minutes = 720;
	          }
	        }
	        if (num === "12" && ampm === "AM") {
	          num = "0";
	        }
	        var hours_to_minutes = parseInt(num, 10) * 60;
	        var minutes_to_minutes = parseInt(time_parts_array[1], 10);
	        var minutes_to_add_to_start_of_day = hours_to_minutes + minutes_to_minutes + additional_minutes;
	        _this.minutes_to_add_to_start_of_day = minutes_to_add_to_start_of_day;
	      }
	      if (_this.some_date_moment && _this.minutes_to_add_to_start_of_day) {
	        console.log("_this.some_date_moment");
	        console.dir(_this.some_date_moment);
	        console.dir(_this.minutes_to_add_to_start_of_day);
	
	        date_time = _this.some_date_moment.startOf("day").add(_this.minutes_to_add_to_start_of_day, "minutes");
	
	        console.log("date_time before validate");
	        console.dir(date_time);
	
	        _this.validate_date_time(date_time);
	      } else {
	        console.log("we dont have both");
	      }
	    }
	  }, {
	    key: "validate_date_time",
	    value: function validate_date_time(date_time) {
	      var _this = this;
	
	      if (_this.order_creation_ui.first_page.is_error) {
	        return;
	      }
	      if (_this.page === 1) {
	        _this.order_creation_ui.first_page.is_error_date = false;
	        _this.order_creation_ui.first_page.is_error_date_msg = null;
	        _this.order.dropoff.date_time = date_time.format();
	        _this.set_time_interval(_this.order.dropoff.date_time, "dropoff");
	        /*
	              if(date_time.isBefore(moment())){
	              	console.log("we are not here...");
	                  _this.order_creation_ui.first_page.is_error_date = true;
	                  _this.order_creation_ui.first_page.is_error_date_msg = "Please select a date and time in the future.";
	                  _this.order_creation_ui.first_page.is_error_time = true;
	              }else{
	              	console.log("we come here");
	              	_this.order_creation_ui.first_page.is_error_date = false;
	                  _this.order_creation_ui.first_page.is_error_date_msg = null;
	                  _this.order.dropoff.date_time = date_time.format();
	                  _this.set_time_interval(_this.order.dropoff.date_time, "dropoff");
	              }
	              */
	      } else if (_this.page === 2) {
	        _this.order_creation_ui.second_page.is_error_date = false;
	        _this.order_creation_ui.second_page.is_error_date_msg = null;
	        _this.order.pickup.date_time = date_time.format();
	        _this.set_time_interval(_this.order.pickup.date_time, "pickup");
	        /*
	              if (date_time.isBefore(moment())){
	                  _this.order_creation_ui.second_page.is_error_date = true;
	                  _this.order_creation_ui.second_page.is_error_date_msg = "Please select a date and time in the future.";
	              } else {
	                  _this.order_creation_ui.second_page.is_error_date = false;
	                  _this.order_creation_ui.second_page.is_error_date_msg = null;
	                  _this.order.pickup.date_time = date_time.format();
	              }
	              */
	      }
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "set_time_interval",
	    value: function set_time_interval(date_time, type) {
	      var _this = this;
	
	      console.log("what is the date_time");
	      console.dir(date_time);
	
	      if (type === "dropoff") {
	        if (date_time.toString() === "Invalid date") {
	          console.log("we have an invalid date...");
	        } else {
	          _this.order.dropoff.timeInterval = {};
	          _this.order.dropoff.timeInterval.startTime = date_time;
	          _this.order.dropoff.date_moment = moment(date_time);
	          _this.order.dropoff.timeInterval.endTime = moment(date_time).add(15, "minutes").format();
	          if (!_this.order.pickup.timeInterval) {
	            _this.order.pickup.date_time = moment(date_time).subtract(60, "minutes").format();
	            _this.order.pickup.timeInterval = {};
	            _this.order.pickup.timeInterval.startTime = moment(date_time).subtract(60, "minutes").format();
	            _this.order.pickup.timeInterval.endTime = moment(date_time).subtract(45, "minutes").format();
	            _this.order.pickup.date_moment = moment(date_time).subtract(60, "minutes");
	            _this.order.pickup.date_time = _this.order.pickup.date_moment.format();
	            if (_this.order.pickup.timeInterval.startTime && _this.order.pickup.time_zone) {
	              var pickup_time = moment(_this.order.pickup.timeInterval.startTime).tz(_this.order.pickup.time_zone).format("h:mm A");
	              var pickup_time_obj = _this.find_time(pickup_time);
	              _this.order.pickup.time = pickup_time_obj;
	            }
	          } else {
	            if (_this.order.pickup.date) {
	              console.dir(_this.order.pickup.date.format());
	            }
	            var pd = null;
	            if (_this.order.pickup.date_moment) {
	              pd = _this.order.pickup.date_moment;
	            } else if (_this.order.pickup.date) {
	              console.log("2");
	              pd = _this.order.pickup.date;
	            }
	            if (_this.order.dropoff.date_moment.isBefore(pd) || _this.order.dropoff.date_moment.diff(pd) === 0) {
	              if (!_this.order.is_clone) {
	                _this.order_creation_ui.first_page.is_error_date = true;
	                _this.order_creation_ui.first_page.is_error_time = true;
	                _this.order_creation_ui.first_page.is_error_date_msg = "Must be after pick-up.";
	                _this.order_creation_ui.first_page.is_error_time_msg = "Must be after pick-up.";
	                _this.order_creation_ui.first_page.is_error = true;
	              }
	            } else {
	              _this.order_creation_ui.first_page.is_error_date = false;
	              _this.order_creation_ui.first_page.is_error_time = false;
	              _this.order_creation_ui.first_page.is_error_date_msg = null;
	              _this.order_creation_ui.first_page.is_error_time_msg = null;
	              _this.order_creation_ui.first_page.is_error = false;
	            }
	          }
	        }
	      } else if (type === "pickup") {
	        if (date_time.toString() === "Invalid date") {
	          console.log("we have an invalid date...");
	        }
	        if (!_this.order.pickup.timeInterval) {
	          _this.order.pickup.timeInterval = {};
	          _this.order.pickup.timeInterval.startTime = date_time;
	          _this.order.pickup.date_moment = moment(date_time);
	          _this.order.pickup.timeInterval.endTime = moment(date_time).add(15, "minutes").format();
	        } else {
	          _this.order.pickup.timeInterval.startTime = date_time;
	          _this.order.pickup.date_moment = moment(date_time);
	          _this.order.pickup.timeInterval.endTime = moment(date_time).add(15, "minutes").format();
	          _this.order.pickup.date_time = moment(date_time).format();
	        }
	        if (!_this.order.dropoff.timeInterval) {
	          _this.order.dropoff.timeInterval = {};
	          _this.order.dropoff.timeInterval.startTime = _this.order.dropoff.date_moment.format();
	          _this.order.dropoff.timeInterval.endTime = _this.order.dropoff.date_moment.add(15, "minutes").format();
	        }
	        var dropoff_starttime = moment(_this.order.dropoff.timeInterval.startTime);
	        var pickup_starttime = moment(_this.order.pickup.timeInterval.startTime);
	        var difference = dropoff_starttime.diff(pickup_starttime);
	        if (dropoff_starttime.isBefore(pickup_starttime) || difference === 0) {
	          _this.order_creation_ui.second_page.is_error_date = true;
	          _this.order_creation_ui.second_page.is_error_time = true;
	          _this.order_creation_ui.second_page.is_error_date_msg = "Must be before drop-off.";
	          _this.order_creation_ui.second_page.is_error_time_msg = "Must be before drop-off.";
	          _this.order_creation_ui.second_page.is_error = true;
	        } else {
	          _this.order_creation_ui.second_page.is_error_date = false;
	          _this.order_creation_ui.second_page.is_error_time = false;
	          _this.order_creation_ui.second_page.is_error_date_msg = null;
	          _this.order_creation_ui.second_page.is_error_time_msg = null;
	          _this.order_creation_ui.second_page.is_error = false;
	        }
	      }
	    }
	  }, {
	    key: "time_change",
	    value: function time_change(send) {
	      var _this = this;
	      var id = _this.times.value.id;
	      var index = _this.times.values.findIndex(function (p) {
	        return p.id == id;
	      });
	      var time_selector = _this.times.values[index];
	      if (send === 1) {
	        _this.order.dropoff.time = time_selector;
	      } else if (send === 2) {
	        _this.order.pickup.time = time_selector;
	      }
	      var time_to_parse = time_selector.name;
	      var time_parts_array = time_to_parse.split(/[ :]+/);
	      var additional_minutes = 0;
	      var ampm = time_parts_array[2];
	      var num = time_parts_array[0];
	      if (ampm === "PM") {
	        if (time_parts_array[0] !== "12") {
	          additional_minutes = 720;
	        }
	      }
	      if (num === "12" && ampm === "AM") {
	        num = "0";
	      }
	      var hours_to_minutes = parseInt(num, 10) * 60;
	      var minutes_to_minutes = parseInt(time_parts_array[1], 10);
	      var minutes_to_add_to_start_of_day = hours_to_minutes + minutes_to_minutes + additional_minutes;
	      _this.minutes_to_add_to_start_of_day = minutes_to_add_to_start_of_day;
	      if (_this.times.value.id !== 1) {
	        if (_this.page === 1) {
	          if (_this.order.dropoff.date_formatted) {
	            var date_selected_and_time = null;
	            var date_selected_and_time_formatted = null;
	            var now = moment().format();
	            var min_to_add = _this.minutes_to_add_to_start_of_day;
	
	            if (_this.order.is_clone) {
	              date_selected_and_time = moment(_this.order.dropoff.date).startOf("day").add(_this.minutes_to_add_to_start_of_day, "minutes");
	              date_selected_and_time_formatted = moment(_this.order.dropoff.date_formatted).startOf("day").add(_this.minutes_to_add_to_start_of_day, "minutes").format();
	            } else {
	              date_selected_and_time = moment(_this.order.dropoff.date_formatted).startOf("day").add(_this.minutes_to_add_to_start_of_day, "minutes");
	              date_selected_and_time_formatted = moment(_this.order.dropoff.date_formatted).startOf("day").add(_this.minutes_to_add_to_start_of_day, "minutes").format();
	            }
	            var now_conv = moment(now);
	            var conv = moment(date_selected_and_time_formatted);
	            _this.order.dropoff.date_moment = moment(date_selected_and_time_formatted);
	            _this.some_date_moment = moment(date_selected_and_time_formatted);
	            _this.check_for_date_time();
	            /*
	               	if(now_conv.isBefore(conv, 'minute')){
	               		_this.order_creation_ui.first_page.is_error_time = false;
	               		_this.order_creation_ui.first_page.is_error = false;
	               		_this.order_creation_ui.first_page.is_error_time_msg = "";
	               		_this.check_for_date_time();
	               	}else{
	               		_this.order_creation_ui.first_page.is_error_time = true;
	               		_this.order_creation_ui.first_page.is_error_time_msg = "Please select a time in the future.";
	               		_this.order_creation_ui.first_page.is_error = true
	               	}
	               	*/
	          } else {
	            console.log("no date");
	          }
	        } else if (_this.page === 2) {
	          if (_this.order.pickup.date_formatted) {
	            var _min_to_add = _this.minutes_to_add_to_start_of_day;
	            var _date_selected_and_time = null;
	            var _date_selected_and_time_formatted = null;
	            var _now = moment().format();
	
	            if (_this.order.is_clone) {
	              _date_selected_and_time = moment(_this.order.pickup.date).startOf("day").add(_min_to_add, "minutes");
	              _date_selected_and_time_formatted = moment(_this.order.pickup.date_formatted).startOf("day").add(_this.minutes_to_add_to_start_of_day, "minutes").format();
	            } else {
	              _date_selected_and_time = moment(_this.order.pickup.date_formatted).startOf("day").add(_min_to_add, "minutes");
	              _date_selected_and_time_formatted = moment(_this.order.pickup.date_formatted).startOf("day").add(_this.minutes_to_add_to_start_of_day, "minutes").format();
	              //date_selected_and_time_formatted = moment(_this.order.dropoff.date_formatted).startOf('day').add(_this.minutes_to_add_to_start_of_day, 'minutes').format();
	            }
	
	            var _now_conv = moment(_now);
	            var _conv = moment(_date_selected_and_time_formatted);
	            _this.order.pickup.date_moment = moment(_date_selected_and_time_formatted);
	            _this.some_date_moment = moment(_date_selected_and_time_formatted);
	            if (_now_conv.isBefore(_conv, "minute")) {
	              _this.order_creation_ui.second_page.is_error_time = false;
	              _this.order_creation_ui.second_page.is_error = false;
	              _this.order_creation_ui.second_page.is_error_time_msg = "";
	              _this.check_for_date_time();
	            } else {
	              _this.order_creation_ui.second_page.is_error_time = true;
	              _this.order_creation_ui.second_page.is_error_time_msg = "Please select a time in the future.";
	              _this.order_creation_ui.second_page.is_error = true;
	            }
	          } else {
	            console.log("no date");
	          }
	        }
	      }
	    }
	  }, {
	    key: "post_order",
	    value: function post_order() {
	      var _this = this;
	      var created_pool = _this.create_pool();
	    }
	  }, {
	    key: "create_pool",
	    value: function create_pool() {
	      var _this = this;
	      var order = _this.order;
	      _this.setLoader();
	      var jts = _this.$rootScope.jobble_types;
	      _this.$events.create_jobble_pool(order, jts).then(function (response) {
	        if (response.status === 200 && response.data.jobblePool) {
	          _this.push_jobbles_to_team(response.data.jobblePool, order);
	        } else {
	          _this.unSetLoader();
	          _this.handle_jobble_pool_creation_error(response);
	        }
	        _this.$timeout(function () {
	          $("#modal-post-event").modal("toggle");
	        });
	      }, function (error) {
	        _this.$timeout(function () {
	          $("#modal-post-event").modal("toggle");
	          _this.unSetLoader();
	        });
	        _this.handle_jobble_pool_creation_error(error);
	      });
	    }
	  }, {
	    key: "mark_order_as_published",
	    value: function mark_order_as_published(jobble_pool) {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$events.mark_order_as_published(jobble_pool);
	        _this.notifyUsers(jobble_pool);
	      }, 300);
	      _this.$timeout(function () {
	        _this.unSetLoader();
	        _this.$state.go("events");
	      }, 1000);
	    }
	  }, {
	    key: "handle_jobble_pool_creation_error",
	    value: function handle_jobble_pool_creation_error(error) {
	      var _this = this;
	    }
	  }, {
	    key: "push_jobbles_to_team",
	    value: function push_jobbles_to_team(jobble_pool, order) {
	      var _this = this;
	      _this.$events.push_to_teams(jobble_pool, order).then(function (response) {
	        _this.mark_order_as_published(jobble_pool);
	      }, function (error) {});
	    }
	  }, {
	    key: "check_teams",
	    value: function check_teams() {
	      var _this = this;
	      if (_this.currentUser) {
	        if (!_this.teams) {
	          _this.load_teams();
	        }
	      }
	    }
	  }, {
	    key: "load_teams",
	    value: function load_teams() {
	      var _this = this;
	      var teams = [];
	
	      _this.$companies.getTeamsSimple().then(function (response) {
	        try {
	          response.data.forEach(function (team, index) {
	            var teamsObj = {};
	            teamsObj.name = team.name;
	            teamsObj.id = team.id;
	            teams.push(teamsObj);
	          });
	        } catch (err) {
	          console.log("teams error");
	        }
	        _this.teams = teams;
	      }, function (data) {
	        _this.$timeout(function () {
	          $("#show-application-alert").modal("toggle");
	        }, 100);
	      });
	    }
	  }, {
	    key: "check_for_clone",
	    value: function check_for_clone() {
	      var _this = this;
	      var event_id = _this.$location.$$search.eid;
	      if (event_id) {
	        _this.$events.getEventByIdTrimmed(event_id, 1).then(function (response) {
	          if (response.status === 200) {
	            _this.sort_shifts(response.data);
	          }
	          _this.$timeout(function () {
	            _this.remain_loading_count = 0;
	          }, 500);
	        }, function (error) {
	          _this.$timeout(function () {
	            _this.remain_loading_count = 0;
	          }, 500);
	        });
	      } else {
	        _this.$timeout(function () {
	          _this.remain_loading_count = 0;
	        }, 500);
	      }
	    }
	  }, {
	    key: "sort_shifts",
	    value: function sort_shifts(event) {
	      var _this = this;
	      event.subEvents[0].deduppedJobbles[0].shifts.sort(function (a, b) {
	        return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
	      });
	      _this.map_clone_to_order(event);
	      _this.cloned_event = event;
	    }
	  }, {
	    key: "set_address_to_google_places",
	    value: function set_address_to_google_places(address, x) {
	      var _this = this;
	      console.log("set_address_to_google_places");
	      console.dir(address);
	      if (x) {
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetPickUpAddressClone", address);
	        }, 500);
	      } else {
	        console.log("do we get to the drop off?");
	        console.dir(address);
	        console.dir(_this.page_loading);
	        if (_this.page_loading === false) {
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("SetDropOffAddressClone", address);
	          }, 1500);
	        } else {
	          _this.$timeout(function () {
	            _this.$rootScope.$emit("SetDropOffAddressClone", address);
	          }, 500);
	        }
	      }
	    }
	  }, {
	    key: "map_clone_to_order",
	    value: function map_clone_to_order(event) {
	      var _this = this;
	      _this.order.name = event.name;
	      _this.order.is_clone = true;
	      _this.order.number = event.orderNumber;
	      _this.order.dropoff.time_zone = event.subEvents[0].deduppedJobbles[0].shifts[1].contactInfo.place.timeZoneId;
	      _this.order.dropoff.raw_offset = event.subEvents[0].deduppedJobbles[0].shifts[1].contactInfo.place.rawOffset;
	      var dropoff_city = event.subEvents[0].deduppedJobbles[0].shifts[1].contactInfo.city;
	      var dropoff_state = event.subEvents[0].deduppedJobbles[0].shifts[1].contactInfo.state;
	      var dropoff_zip_code = event.subEvents[0].deduppedJobbles[0].shifts[1].contactInfo.zipCode;
	      var dropoff_street_line_1 = event.subEvents[0].deduppedJobbles[0].shifts[1].contactInfo.streetLine1;
	      var drop_off_shift = event.subEvents[0].deduppedJobbles[0].shifts[1];
	      _this.order.dropoff.address = dropoff_street_line_1 + " " + dropoff_city + " " + dropoff_state + " " + dropoff_zip_code;
	      _this.order.dropoff.location = event.subEvents[0].deduppedJobbles[0].shifts[1].location;
	      _this.order.description = event.subEvents[0].deduppedJobbles[0].description;
	      _this.set_address_to_google_places(_this.order.dropoff.address);
	      _this.order.dropoff.date = moment(drop_off_shift.timeInterval.startTime).startOf("day");
	      _this.order.dropoff.date_formatted = moment(drop_off_shift.timeInterval.startTime).startOf("day").format("MMM Do, YYYY");
	      _this.order.dropoff.date_moment = moment(drop_off_shift.timeInterval.startTime);
	      _this.order.dropoff.date_time = _this.order.dropoff.date_moment.format();
	      _this.order.dropoff.contactInfo = event.subEvents[0].deduppedJobbles[0].shifts[1].contactInfo;
	      var drop_off_time = moment(drop_off_shift.timeInterval.startTime).tz(_this.order.dropoff.time_zone).format("h:mm A");
	      var drof_off_time_obj = _this.find_time(drop_off_time);
	      _this.times.value.id = drof_off_time_obj.id;
	      _this.order.dropoff.time = drof_off_time_obj;
	      _this.order.payment = (event.subEvents[0].deduppedJobbles[0].payPerHour / 100).toFixed(2);
	      _this.calc_numbers();
	      //_this.calc_numbers_adj();
	      //_this.order.payment_adj = _this.calc_numbers_adj();
	      _this.order.hourly_rate = event.subEvents[0].deduppedJobbles[0].payPerHour;
	      _this.order.dropoff.instructions = event.subEvents[0].deduppedJobbles[0].shifts[1].description;
	      _this.order.dropoff.contact = event.subEvents[0].deduppedJobbles[0].dropoffContactInfo;
	      _this.dropoff_date_change(true);
	      _this.check_dropoff_date_time_for_clone(1);
	      _this.calc_numbers_adj();
	      //_this.set_second_page_to_clone(event);
	    }
	  }, {
	    key: "check_dropoff_date_time_for_clone",
	    value: function check_dropoff_date_time_for_clone() {
	      var _this = this;
	      _this.$timeout(function () {
	        var order = _this.order;
	        if (order.dropoff.date_time) {
	          if (order.dropoff.date_time.toString() === "Invalid date") {
	            console.log("well we need to fix the invalid date");
	          }
	        }
	      }, 1500);
	    }
	  }, {
	    key: "set_second_page_to_clone",
	    value: function set_second_page_to_clone(event) {
	      var _this = this;
	      //let event = _this.event;
	      var pickup_city = event.subEvents[0].deduppedJobbles[0].shifts[0].contactInfo.city;
	      var pickup_state = event.subEvents[0].deduppedJobbles[0].shifts[0].contactInfo.state;
	      var pickup_zip_code = event.subEvents[0].deduppedJobbles[0].shifts[0].contactInfo.zipCode;
	      var pickup_street_line_1 = event.subEvents[0].deduppedJobbles[0].shifts[0].contactInfo.streetLine1;
	      _this.order.pickup.time_zone = event.subEvents[0].deduppedJobbles[0].shifts[0].contactInfo.place.timeZoneId;
	      _this.order.pickup.raw_offset = event.subEvents[0].deduppedJobbles[0].shifts[0].contactInfo.place.rawOffset;
	      var pickup_shift = event.subEvents[0].deduppedJobbles[0].shifts[0];
	      _this.order.pickup.address = pickup_street_line_1 + " " + pickup_city + " " + pickup_state + " " + pickup_zip_code;
	      _this.order.pickup.location = event.subEvents[0].deduppedJobbles[0].shifts[0].location;
	      _this.order.pickup.contactInfo = event.subEvents[0].deduppedJobbles[0].shifts[0].contactInfo;
	      _this.set_address_to_google_places(_this.order.pickup.address, 1);
	      _this.order.pickup.date = moment(pickup_shift.timeInterval.startTime).startOf("day");
	      _this.order.pickup.date_formatted = moment(pickup_shift.timeInterval.startTime).startOf("day").format("MMM Do, YYYY");
	      _this.order.pickup.date_moment = moment(pickup_shift.timeInterval.startTime);
	      _this.order.pickup.date_time = _this.order.dropoff.date_moment.format();
	      var pickup_time = moment(pickup_shift.timeInterval.startTime).format("h:mm A");
	      var pickup_time2 = moment(_this.order.pickup.date_time).subtract(60, "minutes").format("h:mm A");
	      var pickup_time_obj = _this.find_time(pickup_time2);
	      _this.order.pickup.time = pickup_time_obj;
	      _this.order.pickup.instructions = event.subEvents[0].deduppedJobbles[0].shifts[0].description;
	      _this.order.pickup.contact = event.subEvents[0].deduppedJobbles[0].pickupContactInfo;
	      _this.$timeout(function () {
	        _this.times.value.id = pickup_time_obj.id;
	        _this.pickup_date_change(true);
	        _this.check_pickup_date_time_for_clone();
	      });
	    }
	  }, {
	    key: "check_pickup_date_time_for_clone",
	    value: function check_pickup_date_time_for_clone() {
	      var _this = this;
	      /*
	          _this.$timeout(function(){
	              console.log("order lets get a date time for the clone");
	              console.dir(_this.order);
	              let order = _this.order;
	              if(order.pickup.date_time){
	                  if(order.pickup.date_time.toString()==="Invalid date"){
	                      console.log("well we need to fix the invalid date");
	                  }
	              }
	          },2000);
	          */
	    }
	  }, {
	    key: "find_time",
	    value: function find_time(time) {
	      var _this = this;
	      var t = null;
	      try {
	        for (var i = 0; i < _this.times.values.length; i++) {
	          if (time === _this.times.values[i].name) {
	            t = _this.times.values[i];
	            break;
	          }
	        }
	      } catch (err) {
	        console.log("error");
	        console.dir(err);
	      }
	      return t;
	    }
	  }, {
	    key: "set_third_page_to_clone",
	    value: function set_third_page_to_clone() {
	      var _this = this;
	      var event = _this.cloned_event;
	    }
	  }, {
	    key: "setNextDay",
	    value: function setNextDay() {
	      var _this = this;
	      if (!_this.order.pickup.date_formatted) {
	        _this.order.pickup.date_formatted = _this.order.dropoff.date_formatted;
	        _this.order.pickup.date = moment(_this.order.dropoff.date_formatted).startOf("day");
	      }
	      if (!_this.order.pickup.time) {
	        var time_temp = _this.order.dropoff.time.id;
	        time_temp = time_temp - 4;
	        var index = _this.times.values.findIndex(function (p) {
	          return p.id == time_temp;
	        });
	        var time_holder = _this.times.values[index];
	        _this.order.pickup.time = time_holder;
	        _this.$timeout(function () {
	          _this.times.value.id = time_holder.id;
	        }, 500);
	      } else {
	        if (_this.order.pickup.time) {
	          var id = _this.order.pickup.time.id;
	          var i = _this.times.values.findIndex(function (p) {
	            return p.id == id;
	          });
	          var time_holders = _this.times.values[i];
	          _this.$timeout(function () {
	            _this.times.value.id = time_holders.id;
	          }, 500);
	        }
	      }
	      if (_this.order.pickup.address) {
	        _this.set_address_to_google_places(_this.order.pickup.address);
	      }
	    }
	  }, {
	    key: "check_root",
	    value: function check_root(jts) {
	      var _this = this;
	      var jt = _this.$rootScope.jobble_types;
	      var types = null;
	      if (jt) {
	        if (Array.isArray(jt)) {
	          types = jt;
	        } else {
	          types = jt.jobbleTypes;
	        }
	        _this.find_jt(types);
	      } else {
	        _this.get_jobble_types();
	      }
	    }
	  }, {
	    key: "get_jobble_types",
	    value: function get_jobble_types() {
	      var _this = this;
	      _this.$auth.getJobbleTypes().then(function (data) {
	        _this.find_jt(data.data);
	      }, function (error) {
	        console.log("error getting jobble types");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "find_jt",
	    value: function find_jt(jobble_types) {
	      var _this = this;
	      if (jobble_types) {
	        var index = jobble_types.findIndex(function (p) {
	          return p.name == "Delivery";
	        });
	        _this.order.jobble_type_id_for_backend = jobble_types[index].id;
	      }
	    }
	  }, {
	    key: "set_times",
	    value: function set_times() {
	      var _this = this;
	      var times = {
	        value: {
	          id: 1,
	          name: "Select Time"
	        },
	        values: [{
	          id: 1,
	          name: "Select Time"
	        }, {
	          id: 2,
	          name: "12:00 AM"
	        }, {
	          id: 3,
	          name: "12:15 AM"
	        }, {
	          id: 4,
	          name: "12:30 AM"
	        }, {
	          id: 5,
	          name: "12:45 AM"
	        }, {
	          id: 6,
	          name: "1:00 AM"
	        }, {
	          id: 7,
	          name: "1:15 AM"
	        }, {
	          id: 8,
	          name: "1:30 AM"
	        }, {
	          id: 9,
	          name: "1:45 AM"
	        }, {
	          id: 10,
	          name: "2:00 AM"
	        }, {
	          id: 11,
	          name: "2:15 AM"
	        }, {
	          id: 12,
	          name: "2:30 AM"
	        }, {
	          id: 13,
	          name: "2:45 AM"
	        }, {
	          id: 14,
	          name: "3:00 AM"
	        }, {
	          id: 15,
	          name: "3:15 AM"
	        }, {
	          id: 16,
	          name: "3:30 AM"
	        }, {
	          id: 17,
	          name: "3:45 AM"
	        }, {
	          id: 18,
	          name: "4:00 AM"
	        }, {
	          id: 19,
	          name: "4:15 AM"
	        }, {
	          id: 20,
	          name: "4:30 AM"
	        }, {
	          id: 21,
	          name: "4:45 AM"
	        }, {
	          id: 22,
	          name: "5:00 AM"
	        }, {
	          id: 23,
	          name: "5:15 AM"
	        }, {
	          id: 24,
	          name: "5:30 AM"
	        }, {
	          id: 25,
	          name: "5:45 AM"
	        }, {
	          id: 26,
	          name: "6:00 AM"
	        }, {
	          id: 27,
	          name: "6:15 AM"
	        }, {
	          id: 28,
	          name: "6:30 AM"
	        }, {
	          id: 29,
	          name: "6:45 AM"
	        }, {
	          id: 30,
	          name: "7:00 AM"
	        }, {
	          id: 31,
	          name: "7:15 AM"
	        }, {
	          id: 32,
	          name: "7:30 AM"
	        }, {
	          id: 33,
	          name: "7:45 AM"
	        }, {
	          id: 34,
	          name: "8:00 AM"
	        }, {
	          id: 34,
	          name: "8:15 AM"
	        }, {
	          id: 35,
	          name: "8:30 AM"
	        }, {
	          id: 36,
	          name: "8:45 AM"
	        }, {
	          id: 37,
	          name: "9:00 AM"
	        }, {
	          id: 38,
	          name: "9:15 AM"
	        }, {
	          id: 39,
	          name: "9:30 AM"
	        }, {
	          id: 40,
	          name: "9:45 AM"
	        }, {
	          id: 41,
	          name: "10:00 AM"
	        }, {
	          id: 42,
	          name: "10:15 AM"
	        }, {
	          id: 43,
	          name: "10:30 AM"
	        }, {
	          id: 44,
	          name: "10:45 AM"
	        }, {
	          id: 45,
	          name: "11:00 AM"
	        }, {
	          id: 46,
	          name: "11:15 AM"
	        }, {
	          id: 47,
	          name: "11:30 AM"
	        }, {
	          id: 48,
	          name: "11:45 AM"
	        }, {
	          id: 49,
	          name: "12:00 PM"
	        }, {
	          id: 50,
	          name: "12:15 PM"
	        }, {
	          id: 51,
	          name: "12:30 PM"
	        }, {
	          id: 52,
	          name: "12:45 PM"
	        }, {
	          id: 53,
	          name: "1:00 PM"
	        }, {
	          id: 54,
	          name: "1:15 PM"
	        }, {
	          id: 55,
	          name: "1:30 PM"
	        }, {
	          id: 56,
	          name: "1:45 PM"
	        }, {
	          id: 57,
	          name: "2:00 PM"
	        }, {
	          id: 58,
	          name: "2:15 PM"
	        }, {
	          id: 59,
	          name: "2:30 PM"
	        }, {
	          id: 60,
	          name: "2:45 PM"
	        }, {
	          id: 61,
	          name: "3:00 PM"
	        }, {
	          id: 62,
	          name: "3:15 PM"
	        }, {
	          id: 63,
	          name: "3:30 PM"
	        }, {
	          id: 64,
	          name: "3:45 PM"
	        }, {
	          id: 65,
	          name: "4:00 PM"
	        }, {
	          id: 66,
	          name: "4:15 PM"
	        }, {
	          id: 67,
	          name: "4:30 PM"
	        }, {
	          id: 68,
	          name: "4:45 PM"
	        }, {
	          id: 69,
	          name: "5:00 PM"
	        }, {
	          id: 70,
	          name: "5:15 PM"
	        }, {
	          id: 71,
	          name: "5:30 PM"
	        }, {
	          id: 72,
	          name: "5:45 PM"
	        }, {
	          id: 73,
	          name: "6:00 PM"
	        }, {
	          id: 74,
	          name: "6:15 PM"
	        }, {
	          id: 75,
	          name: "6:30 PM"
	        }, {
	          id: 76,
	          name: "6:45 PM"
	        }, {
	          id: 77,
	          name: "7:00 PM"
	        }, {
	          id: 78,
	          name: "7:15 PM"
	        }, {
	          id: 79,
	          name: "7:30 PM"
	        }, {
	          id: 80,
	          name: "7:45 PM"
	        }, {
	          id: 81,
	          name: "8:00 PM"
	        }, {
	          id: 82,
	          name: "8:15 PM"
	        }, {
	          id: 83,
	          name: "8:30 PM"
	        }, {
	          id: 84,
	          name: "8:45 PM"
	        }, {
	          id: 85,
	          name: "9:00 PM"
	        }, {
	          id: 86,
	          name: "9:15 PM"
	        }, {
	          id: 87,
	          name: "9:30 PM"
	        }, {
	          id: 88,
	          name: "9:45 PM"
	        }, {
	          id: 89,
	          name: "10:00 PM"
	        }, {
	          id: 90,
	          name: "10:15 PM"
	        }, {
	          id: 91,
	          name: "10:30 PM"
	        }, {
	          id: 92,
	          name: "10:45 PM"
	        }, {
	          id: 93,
	          name: "11:00 PM"
	        }, {
	          id: 94,
	          name: "11:15 PM"
	        }, {
	          id: 95,
	          name: "11:30 PM"
	        }, {
	          id: 96,
	          name: "11:45 PM"
	        }]
	      };
	
	      var pickup_times = {
	        value: {
	          id: 1,
	          name: "Select Time"
	        },
	        values: [{
	          id: 1,
	          name: "Select Time"
	        }, {
	          id: 2,
	          name: "12:00 AM"
	        }, {
	          id: 3,
	          name: "12:15 AM"
	        }, {
	          id: 4,
	          name: "12:30 AM"
	        }, {
	          id: 5,
	          name: "12:45 AM"
	        }, {
	          id: 6,
	          name: "1:00 AM"
	        }, {
	          id: 7,
	          name: "1:15 AM"
	        }, {
	          id: 8,
	          name: "1:30 AM"
	        }, {
	          id: 9,
	          name: "1:45 AM"
	        }, {
	          id: 10,
	          name: "2:00 AM"
	        }, {
	          id: 11,
	          name: "2:15 AM"
	        }, {
	          id: 12,
	          name: "2:30 AM"
	        }, {
	          id: 13,
	          name: "2:45 AM"
	        }, {
	          id: 14,
	          name: "3:00 AM"
	        }, {
	          id: 15,
	          name: "3:15 AM"
	        }, {
	          id: 16,
	          name: "3:30 AM"
	        }, {
	          id: 17,
	          name: "3:45 AM"
	        }, {
	          id: 18,
	          name: "4:00 AM"
	        }, {
	          id: 19,
	          name: "4:15 AM"
	        }, {
	          id: 20,
	          name: "4:30 AM"
	        }, {
	          id: 21,
	          name: "4:45 AM"
	        }, {
	          id: 22,
	          name: "5:00 AM"
	        }, {
	          id: 23,
	          name: "5:15 AM"
	        }, {
	          id: 24,
	          name: "5:30 AM"
	        }, {
	          id: 25,
	          name: "5:45 AM"
	        }, {
	          id: 26,
	          name: "6:00 AM"
	        }, {
	          id: 27,
	          name: "6:15 AM"
	        }, {
	          id: 28,
	          name: "6:30 AM"
	        }, {
	          id: 29,
	          name: "6:45 AM"
	        }, {
	          id: 30,
	          name: "7:00 AM"
	        }, {
	          id: 31,
	          name: "7:15 AM"
	        }, {
	          id: 32,
	          name: "7:30 AM"
	        }, {
	          id: 33,
	          name: "7:45 AM"
	        }, {
	          id: 34,
	          name: "8:00 AM"
	        }, {
	          id: 34,
	          name: "8:15 AM"
	        }, {
	          id: 35,
	          name: "8:30 AM"
	        }, {
	          id: 36,
	          name: "8:45 AM"
	        }, {
	          id: 37,
	          name: "9:00 AM"
	        }, {
	          id: 38,
	          name: "9:15 AM"
	        }, {
	          id: 39,
	          name: "9:30 AM"
	        }, {
	          id: 40,
	          name: "9:45 AM"
	        }, {
	          id: 41,
	          name: "10:00 AM"
	        }, {
	          id: 42,
	          name: "10:15 AM"
	        }, {
	          id: 43,
	          name: "10:30 AM"
	        }, {
	          id: 44,
	          name: "10:45 AM"
	        }, {
	          id: 45,
	          name: "11:00 AM"
	        }, {
	          id: 46,
	          name: "11:15 AM"
	        }, {
	          id: 47,
	          name: "11:30 AM"
	        }, {
	          id: 48,
	          name: "11:45 AM"
	        }, {
	          id: 49,
	          name: "12:00 PM"
	        }, {
	          id: 50,
	          name: "12:15 PM"
	        }, {
	          id: 51,
	          name: "12:30 PM"
	        }, {
	          id: 52,
	          name: "12:45 PM"
	        }, {
	          id: 53,
	          name: "1:00 PM"
	        }, {
	          id: 54,
	          name: "1:15 PM"
	        }, {
	          id: 55,
	          name: "1:30 PM"
	        }, {
	          id: 56,
	          name: "1:45 PM"
	        }, {
	          id: 57,
	          name: "2:00 PM"
	        }, {
	          id: 58,
	          name: "2:15 PM"
	        }, {
	          id: 59,
	          name: "2:30 PM"
	        }, {
	          id: 60,
	          name: "2:45 PM"
	        }, {
	          id: 61,
	          name: "3:00 PM"
	        }, {
	          id: 62,
	          name: "3:15 PM"
	        }, {
	          id: 63,
	          name: "3:30 PM"
	        }, {
	          id: 64,
	          name: "3:45 PM"
	        }, {
	          id: 65,
	          name: "4:00 PM"
	        }, {
	          id: 66,
	          name: "4:15 PM"
	        }, {
	          id: 67,
	          name: "4:30 PM"
	        }, {
	          id: 68,
	          name: "4:45 PM"
	        }, {
	          id: 69,
	          name: "5:00 PM"
	        }, {
	          id: 70,
	          name: "5:15 PM"
	        }, {
	          id: 71,
	          name: "5:30 PM"
	        }, {
	          id: 72,
	          name: "5:45 PM"
	        }, {
	          id: 73,
	          name: "6:00 PM"
	        }, {
	          id: 74,
	          name: "6:15 PM"
	        }, {
	          id: 75,
	          name: "6:30 PM"
	        }, {
	          id: 76,
	          name: "6:45 PM"
	        }, {
	          id: 77,
	          name: "7:00 PM"
	        }, {
	          id: 78,
	          name: "7:15 PM"
	        }, {
	          id: 79,
	          name: "7:30 PM"
	        }, {
	          id: 80,
	          name: "7:45 PM"
	        }, {
	          id: 81,
	          name: "8:00 PM"
	        }, {
	          id: 82,
	          name: "8:15 PM"
	        }, {
	          id: 83,
	          name: "8:30 PM"
	        }, {
	          id: 84,
	          name: "8:45 PM"
	        }, {
	          id: 85,
	          name: "9:00 PM"
	        }, {
	          id: 86,
	          name: "9:15 PM"
	        }, {
	          id: 87,
	          name: "9:30 PM"
	        }, {
	          id: 88,
	          name: "9:45 PM"
	        }, {
	          id: 89,
	          name: "10:00 PM"
	        }, {
	          id: 90,
	          name: "10:15 PM"
	        }, {
	          id: 91,
	          name: "10:30 PM"
	        }, {
	          id: 92,
	          name: "10:45 PM"
	        }, {
	          id: 93,
	          name: "11:00 PM"
	        }, {
	          id: 94,
	          name: "11:15 PM"
	        }, {
	          id: 95,
	          name: "11:30 PM"
	        }, {
	          id: 96,
	          name: "11:45 PM"
	        }]
	      };
	      _this.times = times;
	      _this.pickup_times = pickup_times;
	    }
	  }, {
	    key: "map_order_data",
	    value: function map_order_data(x) {
	      var _this = this;
	      var data = {};
	
	      if (x === 1) {
	        data.date_time = _this.$stateParams.date_time;
	        data.instructions = _this.$stateParams.instructions;
	        data.job_posting_type = _this.$stateParams.job_posting_type;
	        data.location = _this.$stateParams.location;
	        data.street_line_1 = _this.$stateParams.street_line_1;
	        data.token = _this.$stateParams.t;
	      } else {
	        data.date_time = _this.$location.$$search.date_time;
	        data.instructions = _this.$location.$$search.instructions;
	        data.job_posting_type = _this.$location.$$search.job_posting_type;
	        data.location = _this.$location.$$search.location;
	        data.street_line_1 = _this.$location.$$search.street_line_1;
	        data.token = _this.$location.$$search.t;
	      }
	      return data;
	    }
	  }, {
	    key: "check_params",
	    value: function check_params() {
	      var _this = this;
	      console.log("what are the start params");
	      console.dir(_this.$stateParams);
	      console.dir(_this.$location.$$search);
	      var data = {};
	      if (_this.$location.$$search.job_posting_type) {
	        data = _this.map_order_data();
	
	        if (_this.$location.$$search.t) {
	          console.log("lets create some data....");
	          var promise = _this.$auth.validate_from_marketing_site(data.token);
	          promise.then(function (response) {
	            _this.handle_marketing_user_response(response.data, data);
	            _this.currentUser = response.data;
	            _this.$localStorage.logged_user = response.data;
	            _this.check_teams();
	          }, function (error) {
	            _this.handle_marketing_user_error(error);
	          });
	        } else {
	          data.preserve = true;
	          _this.$state.go("signin", data);
	        }
	      } else {
	        console.log("in the else");
	        console.dir(_this.$stateParams);
	        if (_this.$stateParams.job_posting_type) {
	          data = _this.map_order_data(1);
	          console.log("we have some job posting types");
	          console.dir(_this.$stateParams);
	          console.dir(data);
	
	          if (_this.$stateParams.t) {
	            var _promise = _this.$auth.validate_from_marketing_site(data.token);
	            _promise.then(function (response) {
	              var job = _this.$stateParams;
	              _this.handle_marketing_user_response(response.data, job);
	              _this.currentUser = response.data;
	              _this.$localStorage.logged_user = response.data;
	              _this.check_teams();
	            }, function (error) {
	              _this.handle_marketing_user_error(error);
	            });
	          }
	        } else {
	          if (!_this.currentUser) {
	            _this.$state.go("signin", data);
	          }
	        }
	      }
	    }
	  }, {
	    key: "handle_marketing_user_response",
	    value: function handle_marketing_user_response(user, job_data) {
	      var _this = this;
	      _this.set_address_to_google_places(job_data.street_line_1);
	      _this.order.dropoff.address = job_data.street_line_1;
	      _this.order.dropoff.location = job_data.location;
	      _this.order.dropoff.date_formatted = job_data.date_time;
	      _this.order.dropoff.instructions = job_data.instructions;
	    }
	  }, {
	    key: "handle_marketing_user_error",
	    value: function handle_marketing_user_error(error) {
	      var _this = this;
	      console.log("handle_marketing_user_error");
	      console.dir(error);
	    }
	  }, {
	    key: "notifyUsers",
	    value: function notifyUsers(info) {
	      var _this = this;
	      console.log("notifyUsers");
	      console.dir(info);
	      var data = {};
	      data.id = info.jobbles[0].jobblePoolId;
	      if (info.jobbles[0].forCircleOnly === true) {
	        data.visibility = "EXCLUSIVE";
	      } else {
	        data.visibility = "PUBLIC";
	      }
	      _this.$events.notifyJobblers(data).then(function (r) {
	        console.log("notify response...");
	        console.dir(r);
	      }, function (error) {
	        console.log("in notify error");
	        console.dir(error);
	      });
	    }
	  }]);
	
	  return PostorderController;
	}();
	
	PostorderController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "env", "teams", "companies", "security", "$filter", "events", "$timeout", "$location", "$rootScope", "$scope", "tracking"];
	
	exports.default = PostorderController;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(616);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./postorder.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./postorder.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _posttypes = __webpack_require__(618);
	
	var _posttypes2 = _interopRequireDefault(_posttypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var posttypesModule = _angular2.default.module("posttypes", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("posttypes", {
	    template: "<posttypes></posttypes>"
	  });
	}).component("posttypes", _posttypes2.default);
	
	exports.default = posttypesModule;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _posttypes = __webpack_require__(619);
	
	var _posttypes2 = _interopRequireDefault(_posttypes);
	
	var _posttypes3 = __webpack_require__(620);
	
	var _posttypes4 = _interopRequireDefault(_posttypes3);
	
	__webpack_require__(621);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var posttypesComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _posttypes2.default,
	  controller: _posttypes4.default,
	  controllerAs: "vm"
	};
	
	exports.default = posttypesComponent;

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	module.exports = "<!--<div style=\"display: flex;\" xmlns=\"http://www.w3.org/1999/html\">\n    <div style=\"flex: 1;\">\n        <div class=\"text-subheader\" style=\"margin-top: 0\">Automation settings</div>\n    </div>\n    <div class=\"on-column\">\n        ON\n    </div>\n    <div class=\"off-column\">\n        OFF\n    </div>\n</div>\n\n\n<div>\n    <div style=\"display: flex; margin-top: 16px\">\n        <div style=\"flex: 1;\">\n            <div>Auto Hire</div>\n        </div>\n        <div class=\"on-column\">\n            <input\n                    type=\"checkbox\"\n                    ng-checked=\"vm.posting_settings_ui.settings.auto_hire.is_checked\"\n                    ng-click=\"vm.setAutoAcccept()\"\n            />\n        </div>\n        <div class=\"off-column\">\n            <input\n                    type=\"checkbox\"\n                    ng-checked=\"!vm.posting_settings_ui.settings.auto_hire.is_checked\"\n                    ng-click=\"vm.setAutoAcccept()\"\n            />\n        </div>\n    </div>\n    <div style=\"display: flex;\" ng-if=\"vm.posting_settings_ui.settings.auto_hire.is_checked\">\n        <div style=\"flex: 1;\">\n            <div>Auto Hire Configuration</div>\n        </div>\n        <div style=\"flex: 1;\">\n            <input\n                    type=\"number\"\n                    class=\"auto-hire-configuration form-control form-input\"\n                    ng-model=\"vm.currentUser.company.autoAcceptLimitTimeMark\"\n                    ng-blur=\"vm.blurAutoHirePreference(vm.currentUser.company.autoAcceptLimitTimeMark)\"\n                    ng-change=\"vm.autoHirePreferenceChanging(vm.currentUser.company.autoAcceptLimitTimeMark)\"\n                    style=\"width: 70px;float: right;\"\n            />\n        </div>\n    </div>\n</div>-->\n\n<table class=\"account-profile-settings-table\" style=\"display: none\">\n  <tbody>\n    <!--        <tr>-->\n    <!--            <td><strong>Auto Hire</strong></td>-->\n    <!--            <td></td>-->\n    <!--            <td>-->\n    <!--                <input type=\"checkbox\" ng-click=\"vm.setAutoAcccept()\" ng-checked=\"vm.posting_settings_ui.settings.auto_hire.is_checked\" />-->\n    <!--            </td>-->\n    <!--        </tr>-->\n\n    <!--\n    <tr>\n        <td><strong>Auto Manage</strong></td>\n        <td></td>\n        <td>\n            <input\n                    type=\"checkbox\"\n                    ng-click=\"vm.setAutoManage()\"\n                    ng-checked=\"vm.posting_settings_ui.settings.auto_manage.is_checked\"\n            />\n        </td>\n    </tr>\n    -->\n\n    <!--\n    <tr>\n        <td><strong>Auto Post</strong></td>\n        <td></td>\n        <td>\n            <input\n                    type=\"checkbox\"\n                    ng-click=\"vm.setAutoPost()\"\n                    ng-checked=\"vm.posting_settings_ui.settings.auto_post.is_checked\"\n            />\n        </td>\n    </tr>\n    -->\n  </tbody>\n</table>\n\n<div class=\"account-profile-success-save\" ng-if=\"vm.save_posting_success\">\n  <span>Your posting settings were successfully updated!</span>\n</div>\n\n<div class=\"text-subheader\" style=\"margin-top: 20px\">Do not re-hire list</div>\n<div class=\"do-not-hire-form-wrapper\">\n  <div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n      <table class=\"do-not-hire-table\">\n        <thead>\n          <tr>\n            <th>First Name</th>\n            <th>Last Name</th>\n            <th>Email</th>\n            <th></th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr ng-repeat=\"user in vm.dnhJobblers\">\n            <td>{{user.jobblerFirstName}}</td>\n            <td>{{user.jobblerLastName}}</td>\n            <td>{{user.jobblerUsername}}</td>\n            <td>\n              <i class=\"fas fa-trash-alt\" title=\"Remove user from Do Not Hire List\" ng-click=\"vm.removeDNH(user)\"></i>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n</div>\n\n<div class=\"add-do-not-hire\" ng-click=\"vm.openDNHModal()\"><i class=\"fas fa-plus\"></i>Add User</div>\n\n<a href=\"#modal-add-user-to-do-no-hire\" data-toggle=\"modal\" id=\"modal-add-user-to-do-no-hire\"></a>\n<div\n  class=\"modal fade\"\n  id=\"modal-add-user-to-do-no-hire-modal\"\n  tabindex=\"-1\"\n  role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\"\n  data-backdrop=\"static\"\n>\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\" style=\"width: 456px\">\n        <div class=\"modal-content account-modal-content\">\n          <div class=\"modal-gradient-bar\"></div>\n          <div class=\"modal-header popup-header text-center\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fas fa-times\"></i>\n            </button>\n\n            <div class=\"modal-title\">Do not re-hire</div>\n          </div>\n          <div class=\"modal-body\">\n            <div>\n              <div class=\"input-label\">Email Address</div>\n              <input type=\"text\" placeholder=\"\" ng-model=\"vm.userForDNHList\" class=\"form-control form-input\" />\n            </div>\n\n            <div class=\"account-gradient-button\" style=\"width: 100%; text-align: center\" ng-click=\"vm.addUserToDNHList()\">Add user to list</div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PosttypesController = function () {
	  function PosttypesController($http, $localStorage, $state, $stateParams, AuthService, SecurityService, SignupValidator, CompaniesService, $timeout, $rootScope, EnvService, ngProgressFactory, $scope, $location) {
	    _classCallCheck(this, PosttypesController);
	
	    this.name = "posttypes";
	    $localStorage.activeStateName = "posttypes";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$scope = $scope;
	    this.$auth = AuthService;
	    this.$companies = CompaniesService;
	    this.$security = SecurityService;
	    this.$progress = ngProgressFactory.createInstance();
	    this.disableDNH = true;
	    this.$rootScope = $rootScope;
	    this.dnhJobblers = [];
	    this.validator = SignupValidator;
	    this.$location = $location;
	    this.currentUser = this.$auth.getUserData();
	    this.currentUser.company.posting_types = [{ id: 1, name: "On-Demand" }, { id: 2, name: "Delivery" }, { id: 3, name: "Pay For Post" }];
	    //this.check_posting_settings(this.currentUser.company.postingTypesAllowed);
	    this.posting_settings_ui = {
	      settings: {
	        auto_hire: {
	          is_checked: false
	        },
	        auto_manage: {
	          is_checked: false
	        },
	        auto_post: {
	          is_checked: false
	        }
	      }
	    };
	
	    this.default_posting_settings = {
	      value: { name: "On-Demand", id: 1 },
	      values: [{ name: "On-Demand", id: 1 }, { name: "Delivery", id: 2 }, { name: "Pay For Post", id: 3 }]
	    };
	
	    var _this = this;
	
	    _this.SetPostingTypesListener = _this.$rootScope.$on("SetPostingTypes", function ($event, params) {
	      _this.determine_check_boxes(params);
	      _this.getDoNotHireList();
	    });
	
	    _this.$scope.$on("$destroy", _this.SetPostingTypesListener);
	  }
	
	  _createClass(PosttypesController, [{
	    key: "post_type_saved",
	    value: function post_type_saved(num) {
	      var _this = this;
	
	      _this.save_posting_success = true;
	      _this.update_post_type(num);
	      _this.$timeout(function () {
	        _this.save_posting_success = false;
	      }, 2000);
	    }
	  }, {
	    key: "update_post_type",
	    value: function update_post_type(num) {
	      var _this = this;
	
	      var type_allowed = num;
	      _this.$companies.update_post_type(type_allowed).then(function (response) {
	        console.log("response");
	        console.dir(response);
	        _this.$localStorage.logged_user.company.postingTypesAllowed = response.data.postingTypesAllowed;
	        _this.set_new_post_types_to_header(response.data.postingTypesAllowed);
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "set_new_post_types_to_header",
	    value: function set_new_post_types_to_header(types) {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetNewPostTypesToHeader", types);
	      });
	    }
	  }, {
	    key: "on_demand_clicked",
	    value: function on_demand_clicked() {
	      var _this = this;
	
	      if (_this.posting_settings_ui.settings.on_demand.is_checked) {
	        _this.posting_settings_ui.settings.on_demand.is_checked = false;
	      } else {
	        _this.posting_settings_ui.settings.on_demand.is_checked = true;
	      }
	
	      var num = _this.determine_number();
	      _this.post_type_saved(num);
	    }
	  }, {
	    key: "pay_for_post_clicked",
	    value: function pay_for_post_clicked() {
	      var _this = this;
	
	      if (_this.posting_settings_ui.settings.pay_for_post.is_checked) {
	        _this.posting_settings_ui.settings.pay_for_post.is_checked = false;
	      } else {
	        _this.posting_settings_ui.settings.pay_for_post.is_checked = true;
	      }
	
	      var num = _this.determine_number();
	
	      _this.post_type_saved(num);
	    }
	  }, {
	    key: "delivery_clicked",
	    value: function delivery_clicked() {
	      var _this = this;
	
	      if (_this.posting_settings_ui.settings.delivery.is_checked) {
	        _this.posting_settings_ui.settings.delivery.is_checked = false;
	      } else {
	        _this.posting_settings_ui.settings.delivery.is_checked = true;
	      }
	
	      var num = _this.determine_number();
	
	      _this.post_type_saved(num);
	    }
	  }, {
	    key: "determine_number",
	    value: function determine_number() {
	      var _this = this;
	
	      var num = null;
	
	      if (_this.posting_settings_ui.settings.on_demand.is_checked && _this.posting_settings_ui.settings.pay_for_post.is_checked && _this.posting_settings_ui.settings.delivery.is_checked) {
	        num = 0;
	      } else if (_this.posting_settings_ui.settings.on_demand.is_checked && _this.posting_settings_ui.settings.pay_for_post.is_checked && !_this.posting_settings_ui.settings.delivery.is_checked) {
	        num = 1;
	      } else if (_this.posting_settings_ui.settings.on_demand.is_checked && !_this.posting_settings_ui.settings.pay_for_post.is_checked && !_this.posting_settings_ui.settings.delivery.is_checked) {
	        num = 2;
	      } else if (!_this.posting_settings_ui.settings.on_demand.is_checked && _this.posting_settings_ui.settings.pay_for_post.is_checked && !_this.posting_settings_ui.settings.delivery.is_checked) {
	        num = 3;
	      } else if (!_this.posting_settings_ui.settings.on_demand.is_checked && !_this.posting_settings_ui.settings.pay_for_post.is_checked && _this.posting_settings_ui.settings.delivery.is_checked) {
	        num = 4;
	      } else if (!_this.posting_settings_ui.settings.on_demand.is_checked && _this.posting_settings_ui.settings.pay_for_post.is_checked && _this.posting_settings_ui.settings.delivery.is_checked) {
	        num = 5;
	      } else if (_this.posting_settings_ui.settings.on_demand.is_checked && !_this.posting_settings_ui.settings.pay_for_post.is_checked && _this.posting_settings_ui.settings.delivery.is_checked) {
	        num = 6;
	      } else {
	        num = 3;
	      }
	
	      return num;
	    }
	  }, {
	    key: "check_back",
	    value: function check_back(t) {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.determine_check_boxes(t);
	      }, 1000);
	    }
	  }, {
	    key: "determine_check_boxes",
	    value: function determine_check_boxes(user) {
	      var _this = this;
	
	      if (user) {
	        if (user.company.autoAccept === true) {
	          _this.posting_settings_ui.settings.auto_hire.is_checked = true;
	        } else {
	          _this.posting_settings_ui.settings.auto_hire.is_checked = false;
	        }
	
	        if (user.company.autoManage === true) {
	          _this.posting_settings_ui.settings.auto_manage.is_checked = true;
	        } else {
	          _this.posting_settings_ui.settings.auto_manage.is_checked = false;
	        }
	
	        if (user.company.autoPost === true) {
	          _this.posting_settings_ui.settings.auto_post.is_checked = true;
	        } else {
	          _this.posting_settings_ui.settings.auto_post.is_checked = true;
	        }
	      }
	    }
	  }, {
	    key: "update_default_posting_type",
	    value: function update_default_posting_type() {
	      var _this = this;
	      _this.post_type_saved();
	    }
	  }, {
	    key: "check_posting_settings",
	    value: function check_posting_settings(post_settings) {
	      var _this = this;
	      _this.determine_check_boxes(post_settings);
	    }
	  }, {
	    key: "setAutoManage",
	    value: function setAutoManage() {
	      var _this = this;
	
	      _this.setLoader();
	
	      var val = _this.posting_settings_ui.settings.auto_manage.is_checked;
	
	      if (val === true) {
	        _this.posting_settings_ui.settings.auto_manage.is_checked = false;
	      } else {
	        _this.posting_settings_ui.settings.auto_manage.is_checked = true;
	      }
	
	      var data = {
	        autoManage: _this.posting_settings_ui.settings.auto_manage.is_checked
	      };
	
	      _this.$companies.updateCompanyAutoManage(data).then(function (response) {
	        _this.unSetLoader();
	        _this.handleAutoManageResponse(response);
	      }, function (error) {
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "handleAutoManageResponse",
	    value: function handleAutoManageResponse(response) {
	      if (response.data.autoManage === true) {
	        alert("Auto Manage feature has been turned on. Every job post from now on will automatically manage applicants.");
	        this.setCurrentUser();
	      } else {
	        alert("Auto Manage feature has been turned off.");
	        this.setCurrentUser();
	      }
	    }
	  }, {
	    key: "setAutoAcccept",
	    value: function setAutoAcccept() {
	      var _this = this;
	
	      _this.setLoader();
	
	      var val = _this.posting_settings_ui.settings.auto_hire.is_checked;
	
	      if (val === true) {
	        _this.posting_settings_ui.settings.auto_hire.is_checked = false;
	      } else {
	        _this.posting_settings_ui.settings.auto_hire.is_checked = true;
	      }
	
	      var data = {
	        autoAccept: _this.posting_settings_ui.settings.auto_hire.is_checked
	      };
	
	      /*
	          _this.$companies.updateCompanyAutoAccept(data).then(
	              function (response) {
	                  _this.unSetLoader();
	                  _this.handleAutoAcceptResponse(response);
	              },
	              function (error) {
	                  _this.unSetLoader();
	              }
	          );
	           */
	    }
	  }, {
	    key: "handleAutoAcceptResponse",
	    value: function handleAutoAcceptResponse(response) {
	      console.log("handleAutoAcceptResponse");
	      console.dir(response);
	      if (response.data.autoAccept === true) {
	        alert("Auto Hire feature has been turned on. Every job post from now on with automatically hire applicants.");
	        this.setCurrentUser();
	      } else {
	        alert("Auto Hire feature has been turned off.");
	        this.setCurrentUser();
	      }
	    }
	  }, {
	    key: "setCurrentUser",
	    value: function setCurrentUser() {
	      var _this = this;
	      _this.$auth.validateUserByTokenWeb(_this.currentUser.access_token).then(function (response) {
	        _this.currentUser = response.data;
	        _this.currentUser.company.paymentInfos = response.data.company.undeletedPaymentInfos;
	        _this.$localStorage.logged_user = _this.currentUser;
	      }, function (error) {});
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "getDoNotHireList",
	    value: function getDoNotHireList() {
	      var _this2 = this;
	
	      this.$companies.getDoNotHireList().then(function (response) {
	        _this2.dnhJobblers = response.data;
	        _this2.eachJobblerOnDNHList(response.data);
	        _this2.getListOfAvailableDNH();
	      }, function (error) {});
	    }
	  }, {
	    key: "eachJobblerOnDNHList",
	    value: function eachJobblerOnDNHList(jobblers) {
	      jobblers.forEach(function (jobbler) {
	        console.dir(jobbler.jobblerLastName);
	      });
	    }
	  }, {
	    key: "autoHirePreferenceChanging",
	    value: function autoHirePreferenceChanging(data) {
	      var _this3 = this;
	
	      this.autoHireIsChanging = true;
	      this.$timeout(function () {
	        _this3.autoHireIsChanging = false;
	      }, 1000);
	    }
	  }, {
	    key: "blurAutoHirePreference",
	    value: function blurAutoHirePreference(d) {
	      this.setLoader();
	
	      var data = {
	        autoAcceptLimitTimeMark: d
	      };
	
	      /*
	          this.$companies.updateCompanyAutoAccept(data).then(
	              (response) => {
	                  this.unSetLoader();
	                  this.setCurrentUser();
	              },
	              (error) => {
	                  this.unSetLoader();
	              }
	          );
	           */
	    }
	  }, {
	    key: "addUserToDNHList",
	    value: function addUserToDNHList() {
	      var _this4 = this;
	
	      this.setLoader();
	
	      var jobbler = this.findJobblerInList();
	
	      if (!jobbler) {
	        alert("This user has never worked for this company. Was not added to list");
	        this.unSetLoader();
	        return;
	      }
	
	      var data = {};
	      var list = [];
	
	      data.jobblerId = jobbler.id;
	      data.description = "Test.";
	      list.push(data);
	
	      this.$companies.addToDNHList(list).then(function (response) {
	        alert("User " + jobbler.username + " was added to the Do Not Hire List.");
	        _this4.closeDNHModal();
	        _this4.handleUI(response, jobbler);
	        _this4.unSetLoader();
	      }, function (error) {
	        alert("There was an error adding this user to the do not hire list.");
	      });
	    }
	  }, {
	    key: "handleUI",
	    value: function handleUI(response, jobbler) {
	      var _this5 = this;
	
	      var user = {};
	
	      user.jobblerFirstName = jobbler.firstName;
	      user.jobblerLastName = jobbler.lastName;
	      user.jobblerUsername = jobbler.username;
	
	      this.$timeout(function () {
	        _this5.dnhJobblers.push(user);
	        _this5.userForDNHList = "Email";
	        _this5.disableDNH = true;
	      });
	    }
	  }, {
	    key: "findJobblerInList",
	    value: function findJobblerInList() {
	      var _this6 = this;
	
	      var user = this.availableDNHList.find(function (o) {
	        return o.username === _this6.userForDNHList;
	      });
	      return user;
	    }
	  }, {
	    key: "getListOfAvailableDNH",
	    value: function getListOfAvailableDNH() {
	      var _this7 = this;
	
	      this.$companies.getAvailableDNHList().then(function (response) {
	        _this7.availableDNHList = response.data;
	      }, function (error) {
	        console.log("in error...");
	      });
	    }
	  }, {
	    key: "openDNHModal",
	    value: function openDNHModal() {
	      jQuery("#modal-add-user-to-do-no-hire-modal").modal();
	    }
	  }, {
	    key: "closeDNHModal",
	    value: function closeDNHModal() {
	      jQuery("#modal-add-user-to-do-no-hire-modal .modal-header button.close").trigger("click");
	    }
	  }, {
	    key: "validateEmail",
	    value: function validateEmail() {
	      var EMAILREGEX = /^([!#$%&*+-\/=?^`'|{}~\w_.]{1,64}?)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	      if (this.userForDNHList) {
	        if (this.userForDNHList.length > 0) {
	          this.dnhEmailHasError = true;
	        } else {
	          this.dnhEmailHasError = false;
	        }
	      }
	
	      if (EMAILREGEX.test(this.userForDNHList)) {
	        this.dnhEmailHasError = false;
	        this.disableDNH = false;
	      }
	    }
	  }, {
	    key: "removeDNH",
	    value: function removeDNH(user) {
	      var _this8 = this;
	
	      var data = {};
	
	      data.jobblerId = user.jobblerId;
	
	      this.setLoader();
	
	      this.$companies.removeDoNotHireList(data).then(function (response) {
	        _this8.unSetLoader();
	        _this8.findUserRemoveFromList(user);
	      }, function (error) {
	        _this8.unSetLoader();
	      });
	    }
	  }, {
	    key: "findUserRemoveFromList",
	    value: function findUserRemoveFromList(user) {
	      var userIndex = this.dnhJobblers.findIndex(function (o) {
	        return o.jobblerId === user.jobblerId;
	      });
	
	      this.dnhJobblers.splice(userIndex, 1);
	
	      alert("User was successfully removed from the Do Not Hire List.");
	    }
	  }]);
	
	  return PosttypesController;
	}();
	
	PosttypesController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "security", "signup.validator", "companies", "$timeout", "$rootScope", "env", "ngProgressFactory", "$scope", "$location"];
	
	exports.default = PosttypesController;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(622);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./posttypes.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./posttypes.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".do-not-hire-form-wrapper,.do-not-hire-form-wrapper form{width:100%}.do-not-hire-form-wrapper form input[type=text]{width:100%;height:35px;border:1px solid #c9d5da;border-radius:6px;margin-top:17px;padding-left:15px}.do-not-hire-form-wrapper form input[type=text].email-has-error{border:1px solid red}.dnh-users-list{font-weight:900}table.do-not-hire-table{width:100%;margin-top:20px}table.do-not-hire-table thead tr th{border-bottom:1px solid #c9d5da;font-weight:400;font-size:14px;padding-bottom:2px;margin-bottom:12px}table.do-not-hire-table tbody tr td{padding-top:5px;padding-bottom:5px}table.do-not-hire-table tbody tr td:last-child i:hover{cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _charges = __webpack_require__(624);
	
	var _charges2 = _interopRequireDefault(_charges);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var chargesModule = _angular2.default.module("charges", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("charges", {
	    template: "<charges></charges>"
	  });
	}).component("charges", _charges2.default);
	
	exports.default = chargesModule;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _charges = __webpack_require__(625);
	
	var _charges2 = _interopRequireDefault(_charges);
	
	var _charges3 = __webpack_require__(626);
	
	var _charges4 = _interopRequireDefault(_charges3);
	
	__webpack_require__(627);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var chargesComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _charges2.default,
	  controller: _charges4.default,
	  controllerAs: "vm"
	};
	
	exports.default = chargesComponent;

/***/ }),
/* 625 */
/***/ (function(module, exports) {

	module.exports = "<h5>Charges</h5>\n<table class=\"table table-border line-item-table table-responsive\">\n  <thead>\n    <tr>\n      <th>1</th>\n      <th>2</th>\n      <th>3</th>\n      <th>4</th>\n      <th>5</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td></td>\n      <td></td>\n    </tr>\n  </tbody>\n</table>\n"

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ChargesController = function () {
	  function ChargesController($http, $localStorage, $state, $stateParams, AuthService, SecurityService, CompaniesService, $timeout, $rootScope, EnvService, ngProgressFactory, $scope, $location) {
	    _classCallCheck(this, ChargesController);
	
	    this.name = "charges";
	    $localStorage.activeStateName = "charges";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$scope = $scope;
	    this.$auth = AuthService;
	    this.$companies = CompaniesService;
	    this.$security = SecurityService;
	    this.$progress = ngProgressFactory.createInstance();
	    this.$rootScope = $rootScope;
	    this.$location = $location;
	    this.currentUser = this.$auth.getUserData();
	    this.currentUser.company.posting_types = [{ id: 1, name: "On-Demand" }, { id: 2, name: "Delivery" }, { id: 3, name: "Pay For Post" }];
	    this.getCharges();
	
	    var _this = this;
	  }
	
	  _createClass(ChargesController, [{
	    key: "getCharges",
	    value: function getCharges() {
	      var _this = this;
	      console.log("getCharges");
	      _this.$companies.getCharges().then(function (resp) {
	        console.log("response");
	        console.dir(resp);
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	      });
	    }
	  }]);
	
	  return ChargesController;
	}();
	
	ChargesController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "security", "companies", "$timeout", "$rootScope", "env", "ngProgressFactory", "$scope", "$location"];
	
	exports.default = ChargesController;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(628);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./charges.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./charges.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _transfers = __webpack_require__(630);
	
	var _transfers2 = _interopRequireDefault(_transfers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transfersModule = _angular2.default.module("transfers", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("transfers", {
	    template: "<transfers></transfers>"
	  });
	}).component("transfers", _transfers2.default);
	
	exports.default = transfersModule;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _transfers = __webpack_require__(631);
	
	var _transfers2 = _interopRequireDefault(_transfers);
	
	var _transfers3 = __webpack_require__(632);
	
	var _transfers4 = _interopRequireDefault(_transfers3);
	
	__webpack_require__(633);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transfersComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _transfers2.default,
	  controller: _transfers4.default,
	  controllerAs: "vm"
	};
	
	exports.default = transfersComponent;

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	module.exports = "<h5>Transfers</h5>\n"

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TransfersController = function TransfersController($http, $localStorage, $state, $stateParams, AuthService, SecurityService, CompaniesService, $timeout, $rootScope, EnvService, ngProgressFactory, $scope, $location) {
	  _classCallCheck(this, TransfersController);
	
	  this.name = "transfers";
	  $localStorage.activeStateName = "transfers";
	
	  if (!AuthService.isLoggedIn()) {
	    $state.go("signin");
	    return;
	  }
	
	  this.$http = $http;
	  this.$localStorage = $localStorage;
	  this.$state = $state;
	  this.$timeout = $timeout;
	  this.$scope = $scope;
	  this.$auth = AuthService;
	  this.$companies = CompaniesService;
	  this.$security = SecurityService;
	  this.$progress = ngProgressFactory.createInstance();
	  this.$rootScope = $rootScope;
	  this.$location = $location;
	  this.currentUser = this.$auth.getUserData();
	  this.currentUser.company.posting_types = [{ id: 1, name: "On-Demand" }, { id: 2, name: "Delivery" }, { id: 3, name: "Pay For Post" }];
	  this.check_posting_settings(this.currentUser.company.postingTypesAllowed);
	};
	
	TransfersController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "security", "companies", "$timeout", "$rootScope", "env", "ngProgressFactory", "$scope", "$location"];
	
	exports.default = TransfersController;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(634);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./transfers.styl", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/stylus-loader/index.js!./transfers.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _accountprofile = __webpack_require__(636);
	
	var _accountprofile2 = _interopRequireDefault(_accountprofile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accountprofileModule = _angular2.default.module("accountprofile", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("accountprofile", {
	    url: "/account-profile",
	    template: "<accountprofile></accountprofile>",
	    title: "Account Profile",
	    params: {
	      validation: null,
	      payment: null,
	      event_for_back: null
	    }
	  }).state("accountprofile-company-users", {
	    url: "/account-profile/:companyId/company-users",
	    template: "<accountprofile></accountprofile>",
	    title: "Account Users"
	  }).state("accountprofile-payment-information", {
	    url: "/account-profile/:companyId/payment-information?eid",
	    template: "<accountprofile></accountprofile>",
	    title: "Account Billing",
	    params: {
	      validation: null,
	      payment: null,
	      event_for_back: null,
	      event_for_back_payment: null
	    }
	  }).state("accountprofile-settings", {
	    url: "/account-profile/:companyId/settings",
	    template: "<accountprofile></accountprofile>",
	    title: "Admin Tools"
	  }).state("accountprofile-subscription-plans", {
	    url: "/account-profile/:companyId/subscription-plans",
	    template: "<accountprofile></accountprofile>",
	    title: "Subscription Plans"
	  }).state("accountprofile-payment-history", {
	    url: "/account-profile/:companyId/payment-history",
	    template: "<accountprofile></accountprofile>",
	    title: "Payment History"
	  }).state("accountprofile-notification-center", {
	    url: "/account-profile/:companyId/notification-center",
	    template: "<accountprofile></accountprofile>",
	    title: "Notification Center"
	  });
	}).component("accountprofile", _accountprofile2.default);
	
	exports.default = accountprofileModule;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _accountprofile = __webpack_require__(637);
	
	var _accountprofile2 = _interopRequireDefault(_accountprofile);
	
	var _accountprofile3 = __webpack_require__(638);
	
	var _accountprofile4 = _interopRequireDefault(_accountprofile3);
	
	__webpack_require__(639);
	
	__webpack_require__(641);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accountprofileComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _accountprofile2.default,
	  controller: _accountprofile4.default,
	  controllerAs: "vm"
	};
	
	exports.default = accountprofileComponent;

/***/ }),
/* 637 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<!------------------- Banner-Status --------------------->\n<div style=\"display: none\" class=\"jobs-complete-banner\"></div>\n<!------------------- Banner-Status --------------------->\n\n<div class=\"profile-edits-container\" style=\"min-height:100vh;\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\">\n                <div class=\"account-profile-sidebar\">\n                    <aside>\n                        <ul>\n                            <li ng-class=\"{'selected-sidebar': vm.page == 1}\">\n                                <a href=\"/account-profile\" ng-click=\"vm.setLinkActive(1)\">\n                                    <i class=\"fas fa-user\"></i>Profile\n                                </a>\n                            </li>\n                            <li ng-class=\"{'selected-sidebar': vm.page == 7}\">\n                                <a href=\"/account-profile/{{vm.currentUser.company.id}}/notification-center\"\n                                    ng-click=\"vm.setLinkActive(7)\">\n                                    <i class=\"fas fa-sms\"></i>Notification Center\n                                </a>\n                            </li>\n                            <li ng-class=\"{'selected-sidebar': vm.page == 2}\">\n                                <a href=\"/account-profile/{{vm.currentUser.company.id}}/payment-information\"\n                                    ng-click=\"vm.setLinkActive(2)\">\n                                    <i class=\"fas fa-dollar-sign\"></i>Billing\n                                </a>\n                            </li>\n                            <li ng-class=\"{'selected-sidebar': vm.page == 4}\">\n                                <a href=\"/account-profile/{{vm.currentUser.company.id}}/company-users\"\n                                    ng-click=\"vm.setLinkActive(4)\">\n                                    <i class=\"fas fa-users\"></i>Account users\n                                </a>\n                            </li>\n                            <li ng-class=\"{'selected-sidebar': vm.page == 3}\">\n                                <a href=\"/account-profile/{{vm.currentUser.company.id}}/settings\"\n                                    ng-click=\"vm.setLinkActive(3)\">\n                                    <i class=\"fas fa-sliders-h\"></i>Admin Tools\n                                </a>\n                            </li>\n                        </ul>\n                    </aside>\n                </div>\n            </div>\n\n            <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\">\n                <div class=\"\">\n                    <div class=\"account-profile-container\" ng-if=\"vm.page == 1\">\n                        <div class=\"text-header\">Company Profile</div>\n                        <div class=\"\">\n                            <div class=\"text-subheader\">Company logo</div>\n\n                            <div class=\"row\">\n                                <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                                    <!--style=\"background-image: url('{{ vm.currentUser.companyProfilePictureUrl }}')\"-->\n                                    <div class=\"company-logo account-page\">\n                                        <img id=\"company-logo-account-profile\"\n                                            src=\"{{vm.currentUser.companyProfilePictureUrl}}\" />\n                                        <div style=\"flex: 1;\" class=\"company-logo-edit\"><a href=\"\" type=\"file\"\n                                                ngf-select=\"vm.uploadFilesNew($file, $invalidFiles)\"\n                                                accept=\"image/*,video/mp4,video/x-m4v,video/*\" ngf-max-height=\"2000\"\n                                                ngf-max-size=\"20MB\"><i class=\"fas fa-pencil-alt\"></i>Edit</a></div>\n                                    </div>\n                                </div>\n                                <div class=\"col-lg-2 col-md-2 col-sm-6 col-xs-6\">\n\n                                </div>\n                            </div>\n                        </div>\n\n                        <div>\n\n                            <div class=\"text-subheader\" style=\"margin-top:0px;\">Company information</div>\n\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1; margin-right: 16px\">\n                                    <div class=\"input-label\">Legal company name</div>\n                                    <input type=\"text\" class=\"form-control form-input\"\n                                        ng-model=\"vm.companyDisplayData.legal_company_name\" />\n                                </div>\n                                <div style=\"flex: 1\">\n                                    <div class=\"input-label\">Display name <i data-toggle=\"tooltip\"\n                                            ng-attr-title=\"The company name that will appear on your job postings\"\n                                            data-placement=\"bottom\" class=\"fas fa-question-circle account-tool-tip\"></i>\n                                    </div>\n                                    <input type=\"text\" class=\"form-control form-input\"\n                                        ng-model=\"vm.companyDisplayData.company_name\" />\n                                </div>\n                            </div>\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1; margin-right: 16px\">\n                                    <div class=\"input-label\">Street Address</div>\n                                    <input type=\"text\" class=\"form-control form-input\"\n                                        ng-model=\"vm.companyDisplayData.company_street_address\" />\n                                </div>\n                                <div style=\"flex: 1\">\n                                    <div class=\"input-label\">City</div>\n                                    <input type=\"text\" class=\"form-control form-input\"\n                                        ng-model=\"vm.companyDisplayData.company_city\" />\n                                </div>\n                            </div>\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1; margin-right: 16px\">\n                                    <div class=\"input-label\">State</div>\n                                    <input type=\"text\" class=\"form-control form-input\"\n                                        ng-model=\"vm.companyDisplayData.company_state\" />\n                                </div>\n                                <div style=\"flex: 1\">\n                                    <div class=\"input-label\">Zip code</div>\n                                    <input type=\"text\" class=\"form-control form-input\"\n                                        ng-model=\"vm.companyDisplayData.company_zip_code\" />\n                                </div>\n                            </div>\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1; margin-right: 16px\">\n                                    <div class=\"input-label\">Company Phone Number</div>\n                                    <input type=\"text\" class=\"form-control form-input\"\n                                        ng-model=\"vm.companyDisplayData.company_phone\" />\n                                </div>\n                                <div style=\"flex: 1;\">\n                                    <div class=\"input-label\">EIN (employer identification number) <i\n                                            data-toggle=\"tooltip\"\n                                            ng-attr-title=\"Jobble uses your EIN, or employer identification number, to verify your company\"\n                                            data-placement=\"bottom\" class=\"fas fa-question-circle account-tool-tip\"></i>\n                                    </div>\n                                    <input type=\"text\" class=\"form-control form-input\"\n                                        ng-model=\"vm.companyDisplayData.ein\" />\n                                    <!--\n                                    <div class=\"error-message-for-direct-pay\" ng-if=\"vm.invalidEIN\">\n                                        Invalid EIN.\n                                    </div>\n                                    -->\n                                </div>\n                            </div>\n\n                            <div class=\"input-label\">Company bio</div>\n                            <div class=\"text\">Provide a brief description of your company. This information will be\n                                visible to applicants when they apply to jobs you post:\n                            </div>\n                            <!--\n                            <div class=\"text-subheader\">Company Billing Contact Information</div>\n                            -->\n                            <textarea class=\"form-input\" maxlength=\"500\" rows=\"4\"\n                                ng-model=\"vm.companyDisplayData.company_bio\"></textarea>\n                            <div class=\"main-text-area-length\">\n                                {{vm.companyDisplayData.company_bio && vm.companyDisplayData.company_bio.length ?\n                                vm.companyDisplayData.company_bio.length : 0\n                                }}/500\n                            </div>\n\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1;\">\n                                    <div class=\"input-label\">Billing Contact Email (for invoices)</div>\n                                    <input type=\"text\" class=\"form-control form-input\"\n                                        ng-change=\"vm.validator.email(vm.currentUser.company.billingContactInfo.email, vm); vm.setBillingEmail(vm.currentUser.company.billingContactInfo.email, true)\"\n                                        ng-style=\"vm.validation.email.style\"\n                                        ng-model=\"vm.currentUser.company.billingContactInfo.email\" />\n                                </div>\n                                <div style=\"flex: 1;\">\n                                </div>\n                            </div>\n\n                            <div class=\"text-subheader\">Personal information</div>\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1; margin-right: 16px\">\n                                    <div class=\"input-label\">First Name</div>\n                                    <input type=\"text\" class=\"form-control form-input\"\n                                        ng-model=\"vm.userDisplayData.firstName\" />\n                                </div>\n                                <div style=\"flex: 1\">\n                                    <div class=\"input-label\">Last Name</div>\n                                    <input type=\"text\" class=\"form-control form-input\"\n                                        ng-model=\"vm.userDisplayData.lastName\" />\n                                </div>\n                            </div>\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1; margin-right: 16px\">\n                                    <div class=\"input-label\">Street Address</div>\n                                    <input type=\"text\" class=\"form-control form-input\"\n                                        ng-model=\"vm.userDisplayData.homeContactInfo_streetLine1\" />\n                                </div>\n                                <div style=\"flex: 1\">\n                                    <div class=\"input-label\">City</div>\n                                    <input type=\"text\" class=\"form-control form-input\"\n                                        ng-model=\"vm.userDisplayData.homeContactInfo_city\" />\n                                </div>\n                            </div>\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1; margin-right: 16px\">\n                                    <div class=\"input-label\">State</div>\n                                    <input type=\"text\" class=\"form-control form-input\"\n                                        ng-model=\"vm.userDisplayData.homeContactInfo_state\" />\n                                </div>\n                                <div style=\"flex: 1\">\n                                    <div class=\"input-label\">Zip code</div>\n                                    <input type=\"text\" class=\"form-control form-input\"\n                                        ng-model=\"vm.userDisplayData.homeContactInfo_zipCode\" />\n                                </div>\n                            </div>\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1; margin-right: 16px\">\n                                    <div class=\"input-label\">Personal Phone Number</div>\n                                    <!--ng-change=\"vm.validatePhone(vm.userDisplayData.homeContactInfo_phoneMobile)\"-->\n                                    <input type=\"text\" class=\"form-control form-input\"                                        \n                                        ng-model=\"vm.userDisplayData.homeContactInfo_phoneMobile\" />\n                                </div>\n                                <div style=\"flex: 1;\">\n                                    <div class=\"input-label\">Email</div>\n                                    <div class=\"form-control form-input\" style=\"padding-top: 8px;border: none;padding-left:0px;\">\n                                        {{vm.currentUser.email}}\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div style=\"display: flex\"></div>\n                                <div style=\"flex: 1; margin-right: 16px\">\n                                    <div class=\"input-label\">Password</div>\n                                    <a href=\"#\" style=\"text-decoration: underline;font-weight:bold;\" ng-click=\"vm.updatePasswordModal(true);\">Update</a>\n                                    <!--\n                                    <input type=\"text\" class=\"form-control form-input\"                                        \n                                    ng-model=\"vm.userDisplayData.homeContactInfo_phoneMobile\" />\n                                    -->\n                                </div>\n                                <div style=\"flex: 1;\">\n                                    \n                                </div>\n                            </div>\n\n                            <button ng-disabled=\"vm.savingCompany\" ng-class=\"{'disabled': vm.savingCompany}\"\n                                class=\"account-gradient-button\" ng-click=\"vm.saveCompanyProfileInformation()\">\n                                {{vm.savingCompany ? 'Saving . . .' : 'Save'}}\n                            </button>\n\n                        </div>\n\n                    </div>\n\n\n                    <!-- payment information -->\n                    <div class=\"account-profile-container\" ng-if=\"vm.page == 2\">\n\n                        <div class=\"text-header\">Billing</div>\n                        <div class=\"text\">\n                            Listed below are your available payment methods. At least one valid payment method must be\n                            on file before your job is posted.\n                        </div>\n\n                        <div ng-if=\"vm.showPaymentInfo\">\n                            <div class=\"\" style=\"margin-top: 20px; display:none;\">\n                                <h5>\n                                    <strong>Credit Cards / Debit Cards</strong>\n                                    <span style=\"font-size:14px;\" ng-if=\"vm.currentUser.company.partner\">: Deposits\n                                        within 2 business days / 2.8% processing fee</span>\n                                    <span style=\"font-size:14px;\" ng-if=\"!vm.currentUser.company.partner\">: Deposits\n                                        within 2 business days</span>\n                                </h5>\n                            </div>\n\n                            <div class=\"text-subheader\">Credit cards <span style=\"font-weight: 400\"></span>\n                            </div>\n\n                            <div class=\"\" ng-if=\"vm.cardsArray.length > 0\">\n\n                                <div ng-repeat=\"paymentInfo in vm.cardsArray track by $index\">\n\n                                    <div class=\"credit-card\">\n                                        <div style=\"display: flex\">\n                                            <div class=\"credit-card-logo\">\n                                                <i class=\"{{ paymentInfo.image }}\"></i>\n                                            </div>\n                                            <div class=\"credit-card-number\">**** **** **** {{paymentInfo.last4}}</div>\n                                            <div class=\"credit-card-exp\">\n                                                Exp.{{\n                                                paymentInfo.cardExpirationMonth}}/{{paymentInfo.cardExpirationYear }}\n                                            </div>\n                                            <div class=\"credit-card-delete-container\">\n                                                <a href=\"#\" data-target=\"#modal-del-card\" data-toggle=\"modal\"\n                                                    ng-click=\"vm.setDeleteCreditCard($index)\" class=\"credit-card-delete\"\n                                                    ng-if=\"vm.getArrayLength() > 1\">\n                                                    <i class=\"fas fa-trash-alt\" style=\"color:#5498B4;\"></i>\n                                                </a>\n\n                                                <a href=\"#\" data-target=\"#minimum-card\" data-toggle=\"modal\"\n                                                    class=\"credit-card-delete\" ng-if=\"vm.getArrayLength() <= 1\">\n                                                    <i class=\"fas fa-trash-alt\" style=\"color:#5498B4;\"></i>\n                                                </a>\n                                            </div>\n                                        </div>\n                                    </div>\n\n                                </div>\n                            </div>\n\n                            <div ng-if=\"vm.cardsArray.length !== 0\">\n                                <hr />\n                                <a class=\"add-another-card\" data-target=\"#modal-add-card\" data-toggle=\"modal\" href=\"#\"\n                                    ng-click=\"vm.clearPayInfo()\">\n                                    <i class=\"fas fa-plus-circle\"></i>\n                                    Add another credit card\n                                </a>\n                            </div>\n\n                            <div class=\"row\" ng-if=\"vm.cardsArray.length == 0\">\n                                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                    <a class=\"add-another-card\" data-target=\"#modal-add-card\" data-toggle=\"modal\"\n                                        href=\"#\" ng-click=\"vm.clearPayInfo()\">\n                                        <i class=\"fas fa-plus-circle\"></i>\n                                        Add credit card\n                                    </a>\n                                    <!--\n                                    <a class=\"btn button btn-success\"\n                                       data-target=\"#modal-add-card\"\n                                       data-toggle=\"modal\"\n                                       href=\"#\" ng-click=\"vm.clearPayInfo()\"\n                                       style=\"background: linear-gradient(270deg, #74cf59 0%, #5498B4 100%);border-radius: 5px;\">Add\n                                        Credit Card</a>\n                                        -->\n                                </div>\n                            </div>\n\n                            <div class=\"text-subheader\">Bank accounts <span style=\"font-weight: 400\"></span>\n                            </div>\n\n                            <div ng-repeat=\"paymentInfo in vm.banksArray track by $index\">\n\n                                <div class=\"bank-account\">\n                                    <div style=\"display: flex\">\n                                        <div class=\"bank-name\" style=\"flex: 1\">\n                                            <div>{{ paymentInfo.bankName }}</div>\n                                            <div>********{{ paymentInfo.last4 }}</div>\n                                        </div>\n\n                                        <div class=\"bank-verify\">\n                                            <a href=\"#modal-verify-bank\" data-toggle=\"modal\"\n                                                ng-click=\"vm.setVerifyBankAccount($index)\"\n                                                ng-if=\"!paymentInfo.validated\" style=\"margin-right:25px;\">Verify\n                                            </a>\n                                        </div>\n\n                                        <div class=\"bank-delete-container\">\n                                            <a href=\"#\" data-target=\"#modal-del-bank\" data-toggle=\"modal\"\n                                                ng-if=\"((vm.getArrayLength() > 1) || (vm.getArrayLength() == 1 && !paymentInfo.validated)) \"\n                                                ng-click=\"vm.setDeleteBankAccount($index)\" class=\"bank-delete\">\n                                                <i class=\"fas fa-trash-alt\" style=\"color:#5498B4;\"></i>\n                                            </a>\n\n                                            <a href=\"#\" data-target=\"#minimum-card\" data-toggle=\"modal\"\n                                                ng-if=\"vm.getArrayLength() <= 1 && paymentInfo.validated\"\n                                                ng-click=\"vm.setDeleteBankAccount($index)\" class=\"bank-delete\">\n                                                <i class=\"fas fa-trash-alt\" style=\"color:#5498B4;\"></i>\n                                            </a>\n                                        </div>\n\n                                    </div>\n                                </div>\n\n                            </div>\n\n                            <div ng-if=\"vm.banksArray.length !== 0\">\n                                <hr />\n                                <a class=\"add-another-card\" ng-click=\"vm.initAccounts()\" href=\"#\">\n                                    <i class=\"fas fa-plus-circle\"></i>\n                                    Add another bank account</a>\n                            </div>\n\n                            <div class=\"row\" ng-if=\"vm.banksArray.length == 0\">\n                                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                    <a class=\"add-another-card\" ng-click=\"vm.initAccounts()\" href=\"#\">\n                                        <i class=\"fas fa-plus-circle\"></i>\n                                        Add bank account\n                                    </a>\n                                    <!--\n                                    <a class=\"btn button btn-success\"\n                                       style=\"background: linear-gradient(270deg, #74cf59 0%, #5498B4 100%);border-radius: 5px;\"\n                                       ng-click=\"vm.initAccounts()\">Add Bank Account</a>\n                                       -->\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n\n                    <div class=\"account-profile-container\" ng-if=\"vm.page == 3\">\n                        <div class=\"\" ng-if=\"vm.currentUser.isAdmin\">\n                            <div class=\"text-header\">Admin Tools</div>\n                        </div>\n\n                        <div class=\"\" style=\"margin-top: 20px\" ng-show=\"vm.currentUser.isAdmin\">\n                            <posttypes></posttypes>\n                        </div>\n                    </div>\n\n                    <!-- company users -->\n                    <div class=\"account-profile-container\" ng-if=\"vm.page == 4\">\n                        <div class=\"text-header\">Account users</div>\n                        <div class=\"text\" style=\"margin-bottom: 8px\">Add users to your account to help manage shifts,\n                            hire Jobblers, or make payments\n                        </div>\n                        <div ng-repeat=\"user in vm.companyUsers track by $index\"\n                            ng-if=\"user.firstName !== 'Jobble' && user.firstName !== 'hiring'\">\n                            <div class=\"row\" style=\"background-color:#d0dbe066;border-radius:5px;margin-bottom:20px;\">\n                                <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                                    <h4 style=\"margin-top: 10px;\">{{ user.firstName }} {{ user.lastName }}</h4>\n                                    <div class=\"form-group\">\n                                        <ul>\n                                            <label>Email</label>\n                                            <li>{{user.email}}</li>\n\n                                            <label style=\"margin-top: 10px;\">Phone number</label>\n                                            <li ng-if=\"!user.numberFormatted\">N/A</li>\n                                            <li ng-if=\"user.numberFormatted\">{{user.numberFormatted}}\n                                                <span\n                                                    ng-if=\"((user.email == vm.currentUser.email) && !user.homeContactInfo.isMobilePhoneVerified)\"\n                                                    class=\"verify-number-small\"\n                                                    ng-click=\"vm.triggerPhoneVerificationModal(user.numberFormatted)\">Verify\n                                                    Number with SMS text</span>\n                                                <span ng-if=\"user.homeContactInfo.isMobilePhoneVerified\"\n                                                    class=\"verify-number-small-disabled\">Verified <i\n                                                        class=\"fas fa-check\"></i></span>\n                                            </li>\n                                        </ul>\n                                    </div>\n                                </div>\n                                <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" style=\"position: relative;\">\n                                    <div\n                                        ng-if=\"vm.currentUser.authorities[0].name == 'GROUP_ADMIN'  || vm.currentUser.authorities[0].name == 'GROUP_COMPANY_ADMIN' || vm.currentUser.isAdmin\">\n                                        <div class=\"input-label\">User role</div>\n                                        <p style=\"margin-bottom: 0px;\">Based on the user role selected, the individual\n                                            will\n                                            have access to only certain parts of the platform.</p>\n                                        <div class=\"row\">\n                                            <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                                                <select class=\"main-icon-select\"\n                                                    style=\"padding-left: 7px; height: 35px; font-weight: 600; width: 170px;margin-top: 12px;\"\n                                                    ng-model=\"user.defaultUserRole\"\n                                                    ng-options=\"role for role in vm.userRoles\"\n                                                    ng-change=\"vm.updateRoleButton(user, $index)\"></select>\n                                            </div>\n                                            <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\">\n                                                <div class=\"account-gradient-button show-hide item-number-{{$index}}\"\n                                                    ng-click=\"vm.updateRole(user, $index)\" style=\"margin-top: 8px;\">\n                                                    Change\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div \n                            class=\"text-header\" \n                            style=\"margin-bottom: 10px;padding-top: 10px;\"\n                            ng-if=\"vm.pendingInvites.length > 0\">\n                                Pending invitations\n                        </div>\n                        <div class=\"row\" style=\"opacity:.7;\" ng-repeat=\"pi in vm.pendingInvites track by $index\">\n                            <div class=\"col-lg-5\">\n                                {{pi.email}}\n                            </div>\n                            <div class=\"col-lg-3\">\n                                Invited {{pi.invitationDateFormatted}}\n                            </div>\n                            <div class=\"col-lg-2\">\n                                <a href=\"#\" ng-click=\"vm.resendInvite(pi)\" style=\"font-weight: 600;text-decoration: underline;\">\n                                    Resend\n                                </a>\n                            </div>\n                            <div class=\"col-lg-2\">\n                                <a href=\"#\" ng-click=\"vm.cancelInvite(pi)\" style=\"font-weight: 600;text-decoration: underline;\">\n                                    Cancel\n                                </a>\n                            </div>\n                        </div>\n\n                        <div class=\"text-header\" style=\"margin-top: 15px;\" ng-if=\"vm.cancelledInvites.length > 0\">Cancelled invitations</div>\n                        <div class=\"row\" style=\"opacity:.7;\" ng-repeat=\"pi in vm.cancelledInvites track by $index\">\n                            <div class=\"col-lg-4\">\n                                {{ci.email}}\n                            </div>\n                            <div class=\"col-lg-4\">\n                                Invited - {{ci.invitationDateFormatted}}\n                            </div>\n                            <div class=\"col-lg-2\">\n                                <a href=\"#\" ng-click=\"vm.resendInvite(pi)\">\n                                    Resend\n                                </a>\n                            </div>\n                            <div class=\"col-lg-2\">\n                                <a href=\"#\">\n                                </a>\n                            </div>\n                        </div>\n\n\n                        <div class=\"account-gradient-button\" ng-click=\"vm.addUserModal()\"\n                            ng-if=\"vm.currentUser.authorities[0].name == 'GROUP_ADMIN' || vm.currentUser.authorities[0].name == 'GROUP_COMPANY_ADMIN' || vm.currentUser.isAdmin\" \">Invite additional users\n                    </div>\n\n                </div>\n\n\n            <!-- plans -->\n            <div class=\" account-profile-container\" ng-if=\"vm.page == 5\">\n                            <div class=\"jobblers-rating\">\n                                <ul id=\"two-columns-custom\">\n                                    <li ng-repeat=\"plan in vm.plans track by $index\">\n                                        <div class=\"pn-wrapper\">\n                                            <div class=\"pn-wrapper-left\">{{plan.name}}</div>\n                                            <div class=\"pn-wrapper-right\">\n                                                <input type=\"checkbox\" ng-checked=\"plan.isChecked\"\n                                                    ng-click=\"vm.displaySubChangeModal(plan)\" />\n                                            </div>\n                                        </div>\n                                    </li>\n                                </ul>\n\n                                <div class=\"account-profile-success-save\" ng-if=\"vm.save_home_success\">\n                                    <span>Your profile was successfully updated!</span>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"account-profile-container\" ng-if=\"vm.page == 6\">\n                            <div class=\"\">\n                                <charges></charges>\n                            </div>\n                        </div>\n\n                        <div class=\"account-profile-container\" ng-if=\"vm.page == 7\">\n                            <div class=\"text-header\">Notification Center</div>\n                            <div class=\"text\">\n                                Please note: It’s not possible to unsubscribe from essential account communications or notifications.\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"\n                                    ng-repeat=\"nc in vm.notificationCenter\">\n                                    <div class=\"notification-wrapper\">\n                                        <div class=\"notificiation-header\">\n                                            <input type=\"checkbox\" ng-checked=\"nc.activated\"\n                                                ng-click=\"vm.setAllAsClickedAndUpdate(nc)\" />{{nc.title}}\n                                        </div>\n                                        <div class=\"notificiation-body\">\n                                            <div class=\"notification-item\" ng-repeat=\"item in nc.sub_fields\">\n                                                <!--ng-click=\"vm.createNotificationPreferences()\"-->\n                                                <!--<input type=\"checkbox\" />-->\n                                                <i class=\"far fa-circle noti-off\" ng-if=\"nc.activated == false\"></i>\n                                                <i class=\"fas fa-circle noti-on\" ng-if=\"nc.activated == true\"></i>\n                                                <span class=\"notification-item-title\">{{item.title}}</span> <br />\n                                                <span class=\"notification-item-desc\">{{item.description}}</span>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <jobblefooter></jobblefooter>\n    <loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n\n    <paymentdialog></paymentdialog>\n    <globalalert></globalalert>\n\n    <div class=\"modal fade\" id=\"modal-save-profile-confirm-modal\" tabindex=\"-1\" role=\"dialog\"\n        aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n        <div class=\"vertical-alignment-helper\">\n            <div class=\"modal-dialog vertical-align-center\">\n                <div class=\"modal-dialog popup\" style=\"width: 456px;\">\n                    <div class=\"modal-content account-modal-content\">\n                        <div class=\"modal-gradient-bar\"></div>\n                        <div class=\"modal-header\">\n                            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                                <i class=\"fa fa-times\"></i>\n                            </button>\n                            <div class=\"modal-title\">Your profile has been successfully updated</div>\n                        </div>\n                        <div class=\"modal-body\">\n                            <div class=\"account-gradient-button\" style=\"width: 100%; text-align: center\"\n                                data-dismiss=\"modal\">Close\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"modal fade\" id=\"modal-successful-role-add\" tabindex=\"-1\" role=\"dialog\"\n        aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n        <div class=\"vertical-alignment-helper\">\n            <div class=\"modal-dialog vertical-align-center\">\n                <div class=\"modal-dialog popup\" style=\"width: 456px;\">\n                    <div class=\"modal-content account-modal-content\">\n                        <div class=\"modal-gradient-bar\"></div>\n                        <div class=\"modal-header\">\n                            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                                <i class=\"fa fa-times\"></i>\n                            </button>\n                            <div class=\"modal-title\">User role was successfully saved</div>\n                        </div>\n                        <div class=\"modal-body\">\n                            <div class=\"account-gradient-button\" style=\"width: 100%; text-align: center\"\n                                data-dismiss=\"modal\">Close\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"modal fade\" id=\"modal-invite-user-confirm-modal\" tabindex=\"-1\" role=\"dialog\"\n        aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n        <div class=\"vertical-alignment-helper\">\n            <div class=\"modal-dialog vertical-align-center\">\n                <div class=\"modal-dialog popup\" style=\"width: 456px;\">\n                    <div class=\"modal-content account-modal-content\">\n                        <div class=\"modal-gradient-bar\"></div>\n                        <div class=\"modal-header\">\n                            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                                <i class=\"fa fa-times\"></i>\n                            </button>\n                            <div class=\"modal-title\">User has been invited successfully.</div>\n                        </div>\n                        <div class=\"modal-body\">\n                            <div class=\"account-gradient-button\" style=\"width: 100%; text-align: center\"\n                                data-dismiss=\"modal\">Close\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"modal fade\" id=\"stripe-mandate-display\" tabindex=\"-1\" role=\"dialog\"\n        aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n        <div class=\"vertical-alignment-helper\">\n            <div class=\"modal-dialog vertical-align-center\">\n                <div class=\"modal-dialog popup\" style=\"width: 456px;\">\n                    <div class=\"modal-content account-modal-content\">\n                        <div class=\"modal-gradient-bar\"></div>\n                        <div class=\"modal-header\">\n                            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\"\n                                ng-click=\"vm.userCancelsMandate();\">\n                                <i class=\"fa fa-times\"></i>\n                            </button>\n                            <div class=\"modal-title\" style=\"text-align: center;margin-top: 20px;\">\n                                Confirm Bank Account Authorization\n                            </div>\n                        </div>\n                        <div class=\"modal-body\"\n                            style=\"padding-top: 0px;margin-top: -10px;font-size:12px;line-height:29px;\">\n                            <br />\n                            <p>By clicking \"Accept\", you authorize Jobble to debit the bank account specified above\n                                for any amount owed for charges arising from your use of Jobbles’ services and/or\n                                purchase of products from Jobble, pursuant to Jobbles’ website and terms, until\n                                this authorization is revoked. You may amend or cancel this authorization at any time by\n                                providing notice to Jobble with 30 (thirty) days notice.</p>\n                            <p>If you use Jobbles’ services or purchase additional products periodically pursuant to\n                                Jobbles’ terms, you authorize Jobbles to debit your bank account periodically.\n                                Payments that fall outside of the regular debits authorized above will only be debited\n                                after\n                                your authorization is obtained.</p>\n                            <div class=\"modal-footer\" style=\"text-align:center;\">\n                                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                    <a class=\"button btn btn-success\" style=\"border-radius: 10px;\"\n                                        ng-click=\"vm.confirmMandate()\" ng-disable=\"vm.disableMandateButton\">\n                                        Accept\n                                    </a>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"modal fade\" id=\"modal-save-plan-confirm-modal\" tabindex=\"-1\" role=\"dialog\"\n        aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n        <div class=\"vertical-alignment-helper\">\n            <div class=\"modal-dialog vertical-align-center\">\n                <div class=\"modal-dialog popup\">\n                    <div class=\"modal-content popup-content\" style=\"padding: 25px 35px\">\n                        <div class=\"modal-header\">\n                            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                                <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n                            </button>\n                            <strong ng-hide=\"vm.plansError\">Are you sure you want to change your companies subscription\n                                plan?</strong>\n                            <strong ng-show=\"vm.plansError\">{{vm.plansError}}</strong>\n                        </div>\n\n                        <div class=\"modal-body\">\n                            <a class=\"btn btn-success button\" ng-hide=\"vm.plansError\" href=\"\"\n                                ng-click=\"vm.updatePlan()\">Confirm</a>\n                            <a class=\"btn btn-success button\" ng-show=\"vm.plansError\" href=\"\"\n                                ng-click=\"vm.closePlansModal()\" style=\"width: 275px\">Try again</a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <a href=\"#modal-add-user-confirm-modal\" data-toggle=\"modal\" id=\"modal-add-user-confirm\"></a>\n    <div class=\"modal fade\" id=\"modal-add-user-confirm-modal\" tabindex=\"-1\" role=\"dialog\"\n        aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n        <div class=\"vertical-alignment-helper\">\n            <div class=\"modal-dialog vertical-align-center\">\n                <div class=\"modal-dialog popup\" style=\"width: 456px;\">\n                    <div class=\"modal-content account-modal-content\">\n                        <div class=\"modal-gradient-bar\"></div>\n                        <div class=\"modal-header popup-header text-center\">\n                            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                                <i class=\"fas fa-times\"></i>\n                            </button>\n\n                            <div class=\"modal-title\">Invite user</div>\n                            <div class=\"modal-text\">Please provide the email of the user you would like to invite.\n                            </div>\n                            <div class=\"modal-text\">\n                                <div class=\"input-label\">User role</div>\n                                <p style=\"margin-bottom: 0px;\">Based on the user role selected, the individual will have\n                                    access to only certain parts of the platform.</p>\n                                <select class=\"main-icon-select\"\n                                    style=\"padding-left: 7px; height: 35px; font-weight: 600; width: 170px;\"\n                                    ng-model=\"vm.defaultUserRole\" ng-options=\"role for role in vm.userRoles\"\n                                    ng-change=\"vm.updateRoleModal()\"></select>\n                            </div>\n                        </div>\n                        <div class=\"modal-body\">\n                            <form autocomplete=\"off\">\n                                <div ng-if=\"vm.validationErrorObj.status == false\" class=\"alert-box alert\">{{\n                                    vm.validationErrorObj.message }}\n                                </div>\n                                <div>\n                                    <div class=\"input-label\">Email Address</div>\n                                    <input\n                                        required type=\"email\" \n                                        placeholder=\"\" \n                                        ng-model=\"vm.newUserObj.email\"\n                                        class=\"form-control form-input\" \n                                    />\n                                </div>\n                            </form>\n\n                            <button \n                                class=\"account-gradient-button\" \n                                style=\"width: 100%; text-align: center\"  \n                                ng-click=\"vm.inviteUser()\"\n                                ng-disabled=\"!vm.newUserObj.email ||\">Send invite\n                            </button>\n\n                            <div class=\"row\" style=\"margin-top: 20px\">\n                                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                    <div class=\"alert-box alert\" ng-show=\"vm.errorMessageRegi\">{{ vm.errorMessageRegi }}\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n\n    <div class=\"confirm-roster-download apply-profile-modal\">\n        <div class=\"modal fade\" id=\"verify-company-user\" tabindex=\"-1\" role=\"dialog\" data-keyboard=\"false\"\n            data-backdrop=\"static\">\n            <div class=\"modal-dialog modal-m regi-form-board partner\" role=\"document\">\n                <div class=\"modal-gradient-banner\"></div>\n                <div class=\"modal-content\">\n                    <div class=\"modal-fixed-bar\"></div>\n                    <div class=\"save-exit\" ng-click=\"vm.exitPhoneVerification()\"\n                        style=\"margin-top: 15px;margin-right: 30px;\">\n                        <i class=\"fas fa-times\"></i>\n                    </div>\n                    <div class=\"modal-content-container\">\n                        <div>\n                            <h3>Let us know its you</h3>\n                            <p>We just sent a 6 digit verification code to {{vm.numberToVerify}}. Please enter this code\n                                below to\n                                ensure we have the correct mobile number:</p>\n                        </div>\n                        <div>\n                            <div class=\"sms-code-container\">\n                                <input class=\"\" id=\"sms-code-1\" ng-model=\"vm.smsCode_1\" ng-change=\"vm.codeEntered(1)\"\n                                    ng-keydown=\"vm.smsCodeBackSpace($event,1)\" required autofocus maxlength=\"1\" />\n                                <input class=\"\" id=\"sms-code-2\" ng-model=\"vm.smsCode_2\" ng-change=\"vm.codeEntered(2)\"\n                                    ng-keydown=\"vm.smsCodeBackSpace($event,2)\" required autofocus maxlength=\"1\" />\n                                <input class=\"\" id=\"sms-code-3\" ng-model=\"vm.smsCode_3\" ng-change=\"vm.codeEntered(3)\"\n                                    ng-keydown=\"vm.smsCodeBackSpace($event,3)\" required autofocus maxlength=\"1\" />\n                                <input class=\"\" id=\"sms-code-4\" ng-model=\"vm.smsCode_4\" ng-change=\"vm.codeEntered(4)\"\n                                    ng-keydown=\"vm.smsCodeBackSpace($event,4)\" required autofocus maxlength=\"1\" />\n                                <input class=\"\" id=\"sms-code-5\" ng-model=\"vm.smsCode_5\" ng-change=\"vm.codeEntered(5)\"\n                                    ng-keydown=\"vm.smsCodeBackSpace($event,5)\" required autofocus maxlength=\"1\" />\n                                <input class=\"\" id=\"sms-code-6\" ng-model=\"vm.smsCode_6\" ng-change=\"vm.codeEntered(6)\"\n                                    ng-keydown=\"vm.smsCodeBackSpace($event,6)\" required autofocus maxlength=\"1\" />\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"modal fade\" id=\"notification-center-modal\" tabindex=\"-1\" role=\"dialog\"\n        aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n        <div class=\"vertical-alignment-helper\">\n            <div class=\"modal-dialog vertical-align-center\">\n                <div class=\"modal-dialog popup\" style=\"width: 456px;\">\n                    <div class=\"modal-content account-modal-content\">\n                        <div class=\"modal-gradient-bar\"></div>\n                        <div class=\"modal-header popup-header text-center\">\n                            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                                <i class=\"fas fa-times\"></i>\n                            </button>\n\n                            <div class=\"modal-title\">Notification Center Updated</div>\n\n                            <div class=\"modal-text\">\n                                {{vm.notificationMessage}}\n                            </div>\n                        </div>\n                        <div class=\"modal-body\">\n                            <div class=\"modal-text\">\n                                {{vm.notificationBodyText}}\n                            </div>\n                            <div class=\"modal-text\">\n                                <ul>\n                                    <li ng-repeat=\"m in vm.specificMessage\">\n                                        {{m}}\n                                    </li>\n                                </ul>\n                            </div>\n                            \n                        </div>\n                        <div class=\"modal-footer\">\n                            <div class=\"modal-text\">\n                                <div class=\"account-gradient-button\" style=\"width: 100%; text-align: center\"\n                                ng-click=\"vm.closeNotificationModal()\">Sounds good\n                            </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n\n    <div class=\"modal fade\" id=\"update-password\" tabindex=\"-1\" role=\"dialog\"\n        aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n        <div class=\"vertical-alignment-helper\">\n            <div class=\"modal-dialog vertical-align-center\">\n                <div class=\"modal-dialog popup\" style=\"width: 456px;\">\n                    <div class=\"modal-content account-modal-content\">\n                        <div class=\"modal-gradient-bar\"></div>\n                        <div class=\"modal-header popup-header text-center\">\n                            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                                <i class=\"fas fa-times\"></i>\n                            </button>\n\n                            <div class=\"modal-title\">\n                                Update password\n                            </div>\n                        </div>\n                        <div class=\"modal-body\">\n                            <div class=\"modal-text\">\n                                Once your password is updated, you will be logged out. Please login with your new password.\n                            </div>\n                            <form>\n                                <div class=\"input-label\">Current password</div>\n                                <input \n                                    type=\"password\" \n                                    class=\"form-control current-password\"\n                                    ng-model=\"vm.passwordData.currentPassword\"\n                                    />\n                                <div class=\"input-label\">New password</div>\n                                <input \n                                    type=\"password\" \n                                    class=\"form-control\" \n                                    ng-model=\"vm.passwordData.newPassword\"\n                                    ng-change=\"vm.validateNewPassword();\"\n                                    />\n                                    <ul class=\"password-requirements-list\">\n                                        <li ng-class=\"{'success-password' : vm.passwordData.newPassword.length > 7}\">Minimum 8 characters</li>\n                                        <li ng-class=\"{'success-password' : vm.validateNewPassword()}\">At least 1 number</li>\n                                    </ul>\n                                <div class=\"input-label\" style=\"margin-top:10px;\">Confirm new password</div>\n                                <input \n                                    type=\"password\" \n                                    class=\"form-control\" \n                                    ng-model=\"vm.passwordData.confirmNewPassword\"\n                                    ng-change=\"vm.validateNewPasswordConfirmation();\"\n                                    />\n                                    <div style=\"color: red;margin-top: 6px;text-align: center;font-weight: 600;\" ng-show=\"vm.passNotMatching\">\n                                        Passwords must match\n                                    </div>\n                            </form>\n                        </div>\n                        <div class=\"modal-footer\">\n                            <div class=\"modal-text\">\n                                <button \n                                    class=\"account-gradient-button\" \n                                    style=\"width: 100%; text-align: center\"\n                                    ng-click=\"vm.updatePassword()\"\n                                    ng-disabled=\"vm.updatePasswordFormInvalid\">Update\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"modal fade\" id=\"update-password-confirm\" tabindex=\"-1\" role=\"dialog\"\n        aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n        <div class=\"vertical-alignment-helper\">\n            <div class=\"modal-dialog vertical-align-center\">\n                <div class=\"modal-dialog popup\" style=\"width: 456px;\">\n                    <div class=\"modal-content account-modal-content\">\n                        <div class=\"modal-gradient-bar\"></div>\n                        <div class=\"modal-header popup-header text-center\">\n                            <button \n                                type=\"button\" \n                                class=\"close popup-close\" \n                                data-dismiss=\"modal\" \n                                aria-label=\"Close\"\n                                ng-click=\"vm.logUserOut();\">\n                                    <i class=\"fas fa-times\"></i>\n                            </button>\n                            <div class=\"modal-title\">\n                                Password has been updated!\n                            </div>\n                        </div>\n                        <div class=\"modal-body\">\n                            Thank you for updating your password. You will be logged out. Please log back in with your new password.\n                        </div>\n                        <div class=\"modal-footer\" style=\"padding-top:0px;\">\n                            <div class=\"modal-text\">\n                                <div \n                                    class=\"account-gradient-button\" \n                                    style=\"width: 100%; text-align: center\"\n                                    data-dismiss=\"modal\"\n                                    ng-click=\"vm.logUserOut();\">Sounds good\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>"

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EINREGEX = /^\d{2}\-?\d{7}$/;
	
	var AccountprofileController = function () {
	  function AccountprofileController($http, $localStorage, $state, $stateParams, AuthService, CompaniesService, SignupValidator, SecurityService, $timeout, $rootScope, EnvService, ngProgressFactory, $scope, $location, ProfilesService) {
	    var _this2 = this;
	
	    _classCallCheck(this, AccountprofileController);
	
	    this.name = "accountprofile";
	    $localStorage.activeStateName = "accountprofile";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$scope = $scope;
	    this.$auth = AuthService;
	    this.validation = {};
	    this.validator = SignupValidator;
	    this.canValidate = false;
	    this.$timeout(function () {
	      return _this2.canValidate = true;
	    }, 1000);
	    this.$companies = CompaniesService;
	    this.$security = SecurityService;
	    this.$progress = ngProgressFactory.createInstance();
	    this.$rootScope = $rootScope;
	    this.passNotMatching = false;
	    this.$location = $location;
	    this.editing_percentage = false;
	    this.showRoleButton = false;
	    this.activeTab = "profile";
	    this.updatePasswordFormInvalid = true;
	    this.$env = EnvService;
	    this.stripe = window.Stripe(this.$env.EnvironmentConfig.stripeKey);
	    this.showPaymentInfo = false;
	    this.$profiles = ProfilesService;
	    this.passwordData = {};
	    this.newUserObj = {
	      firstName: null,
	      lastName: null,
	      email: null,
	      // email2: null,
	      password: null,
	      // password2: null,
	      phoneMobile: null
	    };
	    this.showPictureSaveButton = 1;
	    this.currentUser = this.$auth.getUserData();
	    this.localData = { showHomeInfo: false, showCompanyInfo: false };
	    this.notiFormDisabled = true;
	    this.bounds = {};
	    this.phoneChange = undefined;
	    this.phone_class = "";
	    this.invitingUser = false;
	    this.disableMandateButton = false;
	    this.bounds.left = 0;
	    this.bounds.right = 0;
	    this.prev_plan = null;
	    this.bounds.top = 0;
	    this.$stateParams = $stateParams;
	    this.bounds.bottom = 0;
	    this.currentUser.company.dateCreatedConvert = this.$security.getClientDate(this.currentUser.company.dateCreated);
	    //this.loadSettings();
	    this.setActivePageOnLeft();
	    //this.invalidEIN = false;
	    this.paymentInfos = this.currentUser.company.undeletedPaymentInfos;
	    this.remain_loading_count = 0;
	
	    if (this.$security.isUndefinedOrNull(this.currentUser.company.undeletedPaymentInfos)) {
	      this.currentUser.company.paymentInfos = [];
	    }
	
	    this.plans = [];
	    this.planId = this.currentUser.company.defaultPlan.id;
	    this.updatedPlan = false;
	    this.updateStatus = 0;
	    this.setNotificationData();
	
	    if (this.$security.isUndefinedOrNull(this.currentUser.company) || this.$security.isUndefinedOrNull(this.currentUser.company.companyLogoUri)) {
	      this.currentUser.companyProfilePictureUrl = "/app/vendor/images/user-more.png";
	    } else {
	      this.currentUser.companyProfilePictureUrl = this.currentUser.company.companyLogoUri;
	    }
	
	    var _this = this;
	
	    _this.myImage = "";
	    _this.myCroppedImage = "";
	
	    this.cardsArray = [];
	    this.banksArray = [];
	
	    this.stateList = ["AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"];
	
	    if (_this.currentUser.username.indexOf("jobble.com") !== -1 || _this.currentUser.username.indexOf("jobbleapp.com") !== -1) {
	      _this.navOptions = [{
	        type: "profile",
	        isActive: "profile-menu-active",
	        value: "Profile"
	      }, { type: "logo", isActive: "", value: "Company logo" }, { type: "plans", isActive: "", value: "Subscription Plans" }, { type: "payments", isActive: "", value: "Payment Options" }, { type: "notifications", isActive: "", value: "Notifications" }];
	      _this.currentUser.isAdmin = true;
	    } else {
	      _this.navOptions = [{
	        type: "profile",
	        isActive: "profile-menu-active",
	        value: "Profile"
	      }, { type: "logo", isActive: "", value: "Company logo" }, { type: "payments", isActive: "", value: "Payment Options" }, { type: "notifications", isActive: "", value: "Notifications" }];
	      _this.currentUser.isAdmin = false;
	    }
	
	    //_this.checkForRDS();
	
	    if (!this.currentUser.homeContactInfo) {
	      this.currentUser.homeContactInfo = {
	        phoneMobile: null,
	        streetLine1: null,
	        city: null,
	        state: null,
	        zipCode: null
	      };
	    }
	
	    this.notificationCenter = [{
	      title: "Roster",
	      activated: false,
	      sub_fields: [{
	        title: "Daily Roster Updates",
	        description: "Receive emails with daily updates regarding rosters for upcoming jobs"
	      }, {
	        title: "Job Filled Update",
	        description: "Receive an email when all job openings have been filled"
	      }, {
	        title: "Pre-Shift Roster",
	        description: "Receive an email with a link to the roster before the job is scheduled to start"
	      }]
	    }, {
	      title: "Job Status",
	      activated: false,
	      sub_fields: [{
	        title: "Application Updates",
	        description: "Receive emails when job receives applicants"
	      }, {
	        title: "Payment Updates",
	        description: "Receive reminders to submit payments and updates when payments have been submitted"
	      }, {
	        title: "Job closure Updates",
	        description: "Receive emails when jobs have been completed"
	      }]
	    }, {
	      title: "Live Job Updates",
	      activated: false,
	      sub_fields: [{
	        title: "Shift start / end notifications",
	        description: "Receive emails when shifts are starting and ending"
	      }, {
	        title: "Jobbler Schedule Updates",
	        description: "Receive emails when jobblers update their availability for a job (calling out, running late, or a change in schedule)"
	      }]
	    }, {
	      title: "Billing",
	      activated: false,
	      sub_fields: [{
	        title: "Billing Updates",
	        description: "Receive billing statements and notifications"
	      }, {
	        title: "Linked Accounts Updates",
	        description: "Receive notifications when payment methods are added"
	      }, {
	        title: "Post Due Notifications",
	        description: "Receive notifications about payments that are past due"
	      }]
	    }];
	
	    this.userTableRows = [{
	      prop: 1,
	      name: "First Name",
	      value: this.currentUser.firstName,
	      status: 1,
	      type: 1
	    }, {
	      prop: 2,
	      name: "Last Name",
	      value: this.currentUser.lastName,
	      status: 1,
	      type: 1
	    }, {
	      prop: 3,
	      name: "Phone (personal)",
	      value: this.currentUser.homeContactInfo.phoneMobile ? this.currentUser.homeContactInfo.phoneMobile : "---",
	      status: 1,
	      type: 1
	    }, {
	      prop: 4,
	      name: "Street Address",
	      value: this.currentUser.homeContactInfo.streetLine1 ? this.currentUser.homeContactInfo.streetLine1 : "---",
	      status: 1,
	      type: 1
	    }, {
	      prop: 5,
	      name: "City",
	      value: this.currentUser.homeContactInfo.city ? this.currentUser.homeContactInfo.city : "---",
	      status: 1,
	      type: 1
	    }, {
	      prop: 6,
	      name: "State",
	      value: this.currentUser.homeContactInfo.state ? this.currentUser.homeContactInfo.state : "---",
	      status: 1,
	      type: 1,
	      is_state: true
	    }, {
	      prop: 7,
	      name: "Zipcode",
	      value: this.currentUser.homeContactInfo.zipCode ? this.currentUser.homeContactInfo.zipCode : "---",
	      status: 1,
	      type: 1
	    }];
	
	    this.companyDisplayData = {
	      company_name: this.currentUser.company.name,
	      ein: this.currentUser.company.ein,
	      legal_company_name: this.currentUser.company.legalCompanyName,
	      company_phone: this.currentUser.company.mainContactInfo.phoneMobile || "",
	      company_street_address: this.currentUser.company.mainContactInfo.streetLine1 || "",
	      company_city: this.currentUser.company.mainContactInfo.city || "",
	      company_state: this.currentUser.company.mainContactInfo.state || "",
	      company_zip_code: this.currentUser.company.mainContactInfo.zipCode || "",
	      company_bio: this.currentUser.company.description || "",
	      billing_contact: this.currentUser.company.billingContactInfo.email
	    };
	
	    this.userDisplayData = {
	      firstName: this.currentUser.firstName,
	      lastName: this.currentUser.lastName,
	      homeContactInfo_phoneMobile: this.currentUser.homeContactInfo.phoneMobile,
	      homeContactInfo_streetLine1: this.currentUser.homeContactInfo.streetLine1,
	      homeContactInfo_city: this.currentUser.homeContactInfo.city,
	      homeContactInfo_state: this.currentUser.homeContactInfo.state,
	      homeContactInfo_zipCode: this.currentUser.homeContactInfo.zipCode
	    };
	
	    this.initialCompanyData = Object.assign({}, this.companyDisplayData);
	    this.initialUserData = Object.assign({}, this.userDisplayData);
	
	    this.companyTableRows = [{
	      prop: 8,
	      name: "Company Name",
	      value: this.currentUser.company.name,
	      status: 1
	    }, {
	      prop: 11,
	      name: "Phone (company)",
	      value: this.currentUser.company.mainContactInfo.phoneMobile ? this.currentUser.company.mainContactInfo.phoneMobile : "---",
	      status: 1,
	      type: 2
	    }, {
	      prop: 12,
	      name: "Street Address",
	      value: this.currentUser.company.mainContactInfo.streetLine1 ? this.currentUser.company.mainContactInfo.streetLine1 : "---",
	      status: 1,
	      type: 2
	    }, {
	      prop: 13,
	      name: "City",
	      value: this.currentUser.company.mainContactInfo.city ? this.currentUser.company.mainContactInfo.city : "---",
	      status: 1,
	      type: 2
	    }, {
	      prop: 14,
	      name: "State",
	      value: this.currentUser.company.mainContactInfo.state ? this.currentUser.company.mainContactInfo.state : "---",
	      status: 1,
	      type: 2,
	      is_state: true
	    }, {
	      prop: 15,
	      name: "Zipcode",
	      value: this.currentUser.company.mainContactInfo.zipCode ? this.currentUser.company.mainContactInfo.zipCode : "---",
	      status: 1,
	      type: 2
	    }];
	
	    _this.UpdatedCreditCardListener = _this.$rootScope.$on("UpdatedCreditCard", function ($event, params) {
	      _this.cardsArray = [];
	
	      if (params.user) {
	        _this.currentUser = params.user;
	        _this.paymentInfos = _this.currentUser.company.paymentInfos;
	      }
	
	      _this.$timeout(function () {
	        try {
	          _this.currentUser.company.paymentInfos.forEach(function (paymentInfo) {
	            if (!paymentInfo.bankName) {
	              paymentInfo.cardExpirationDate = moment().month(parseInt(paymentInfo.cardExpirationMonth)).format("MM") + "/" + paymentInfo.cardExpirationYear;
	            }
	          });
	        } finally {
	          _this.organizePaymentInfo(true, null);
	        }
	      }, 100);
	    });
	
	    _this.UpdatedBankAccountsListener = _this.$rootScope.$on("UpdatedBankAccounts", function ($event, params) {
	      _this.setLoader();
	      _this.pullLatestPaymentInfo(params.bankToRemove);
	    });
	
	    _this.$scope.$on("$destroy", _this.UpdatedCreditCardListener);
	    _this.$scope.$on("$destroy", _this.UpdatedBankAccountsListener);
	
	    _this.lookForPaymentFlag();
	
	    this.enableToolTips();
	  }
	
	  _createClass(AccountprofileController, [{
	    key: "enableToolTips",
	    value: function enableToolTips() {
	      this.$timeout(function () {
	        $(".account-tool-tip").tooltip({}).tooltip("fixTitle");
	      }, 200);
	    }
	  }, {
	    key: "lookForPaymentFlag",
	    value: function lookForPaymentFlag() {}
	  }, {
	    key: "setValidation",
	    value: function setValidation(_ref) {
	      var _this3 = this;
	
	      var field = _ref.field,
	          valid = _ref.valid,
	          message = _ref.message;
	
	      if (this.canValidate) this.$timeout(function () {
	        _this3.validation[field] = {
	          valid: valid,
	          style: { borderColor: valid ? "green" : "red" },
	          message: message
	        };
	      });
	      this.validation;
	    }
	  }, {
	    key: "loadAllJobblePlans",
	    value: function loadAllJobblePlans() {
	      var _this = this;
	
	      _this.remain_loading_count++;
	
	      var req = {
	        method: "GET",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/plans?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.currentUser.access_token
	        },
	        data: {}
	      };
	
	      _this.$http(req).then(function (res) {
	        _this.remain_loading_count--;
	        //console.log(res.data);
	      }, function (res) {
	        //console.log(res.data);
	        _this.remain_loading_count--;
	      });
	    }
	  }, {
	    key: "openFileDialog",
	    value: function openFileDialog() {
	      var _this = this;
	      _this.$timeout(function () {
	        jQuery("#fileCompanyLogo").trigger("click");
	      });
	    }
	  }, {
	    key: "fileToUploadCompany",
	    value: function fileToUploadCompany(file, uploadUrlCompany) {
	      var _this = this;
	
	      var fd = new FormData();
	
	      fd.append("file", file);
	
	      _this.remain_loading_count++;
	
	      _this.$http.post(uploadUrlCompany, fd, {
	        transformRequest: _angular2.default.identity,
	        headers: {
	          "Content-Type": undefined,
	          Authorization: "Bearer " + _this.currentUser.access_token
	        }
	      }).then(function (response) {
	        console.log("response?");
	        console.dir(response);
	      });
	    }
	  }, {
	    key: "saveUserProfile",
	    value: function saveUserProfile(row) {
	      var _this = this;
	
	      row.status = 1;
	
	      _this.$timeout(function () {
	        _this.timer(row);
	      }, 300);
	
	      _this.$companies.updateUser(row).then(function (response) {
	        _this.$timeout(function () {
	          _this.$auth.reloadCurrentUser();
	        }, 100);
	      }, function (error) {
	        alert("error saving user information");
	      });
	    }
	  }, {
	    key: "validatePhone",
	    value: function validatePhone(p) {
	
	      console.log("validatePhone");
	      console.dir(p);
	
	      var phoneError = false;
	
	      if (p.length === 1 && p === "1") {
	        p = "";
	      }
	      var phonePattern = /^(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/;
	
	      phoneError = !(p && phonePattern.test(p));
	    }
	  }, {
	    key: "saveCompanyProfileInformation",
	    value: function saveCompanyProfileInformation() {
	      var _this4 = this;
	
	      this.savingCompany = true;
	      this.setLoader();
	
	      if (!this.currentUser.company.billingContactInfo.email) {
	        alert("Please add a billing contact to your profile. This email will receive invoices from Jobble.");
	        this.savingCompany = false;
	        this.unSetLoader();
	        return;
	      }
	
	      this.setLoader();
	      var diffPayloadCompany = this.findDiff("company");
	      var diffPayloadUser = this.findDiff("user");
	      var payload = {};
	      payload = this.mapPayLoadToUserObj(diffPayloadUser.new);
	      payload.company = this.mapPayloadToCompanyObj(diffPayloadCompany.new);
	
	      this.$companies.saveCompanyProfileInformationNew(payload).then(function (response) {
	        console.log("Save Company Response:", response.data);
	        _this4.savingCompany = false;
	        _this4.unSetLoader();
	        if (payload.company.billingContactInfo.email) {
	          _this4.updateUsersBillingEmail();
	        }
	      }).catch(function (err) {
	        console.log("error with saving user info");
	        console.dir(err);
	        _this4.savingCompany = false;
	        _this4.unSetLoader();
	        _this4.handleSavingUserError(err);
	      });
	    }
	  }, {
	    key: "handleSavingUserError",
	    value: function handleSavingUserError(response) {
	      alert("There was an error saving your information: " + response.data.message);
	    }
	  }, {
	    key: "mapPayloadToCompanyObj",
	    value: function mapPayloadToCompanyObj(data) {
	      var company = {};
	
	      console.log("mapPayloadToCompanyObj");
	      console.dir(data);
	
	      company.description = data.company_bio;
	      company.name = data.company_name;
	      company.legalCompanyName = data.legal_company_name;
	      company.ein = data.ein;
	      company.numberOfLocations = data.number_of_locations;
	      company.mainContactInfo = {};
	      company.billingContactInfo = {};
	      company.billingContactInfo.email = data.billing_contact;
	      company.mainContactInfo.phoneMobile = data.company_phone;
	      company.mainContactInfo.streetLine1 = data.company_street_address;
	      company.mainContactInfo.city = data.company_city;
	      company.mainContactInfo.state = data.company_state;
	      company.mainContactInfo.zipCode = data.company_zip_code;
	
	      return company;
	    }
	  }, {
	    key: "mapPayLoadToUserObj",
	    value: function mapPayLoadToUserObj(malFormedObj) {
	      var user = {};
	      user.homeContactInfo = {};
	
	      console.log("mapPayLoadToUserObj");
	      console.dir(malFormedObj);
	
	      if (malFormedObj.homeContactInfo_city) {
	        user.homeContactInfo.city = malFormedObj.homeContactInfo_city;
	      }
	      if (malFormedObj.homeContactInfo_phoneMobile) {
	        user.homeContactInfo.phoneMobile = malFormedObj.homeContactInfo_phoneMobile;
	      }
	      if (malFormedObj.homeContactInfo_state) {
	        user.homeContactInfo.state = malFormedObj.homeContactInfo_state;
	      }
	      if (malFormedObj.homeContactInfo_streetLine1) {
	        user.homeContactInfo.streetLine1 = malFormedObj.homeContactInfo_streetLine1;
	      }
	      if (malFormedObj.homeContactInfo_zipCode) {
	        user.homeContactInfo.zipCode = malFormedObj.homeContactInfo_zipCode;
	      }
	      if (malFormedObj.firstName) {
	        user.firstName = malFormedObj.firstName;
	      }
	      if (malFormedObj.lastName) {
	        user.lastName = malFormedObj.lastName;
	      }
	
	      return user;
	    }
	  }, {
	    key: "findDiff",
	    value: function findDiff(type) {
	      var diff = void 0;
	      var old = void 0;
	      var newObj = void 0;
	
	      if (type === "company") {
	        old = this.initialCompanyData;
	        newObj = this.companyDisplayData;
	
	        diff = {
	          old: _.pickBy(old, function (value, key) {
	            return !_.isEqual(value, newObj[key]);
	          }),
	          new: _.pickBy(newObj, function (value, key) {
	            return !_.isEqual(old[key], value);
	          })
	        };
	      } else {
	        old = this.initialUserData;
	        newObj = this.userDisplayData;
	
	        diff = {
	          old: _.pickBy(old, function (value, key) {
	            return !_.isEqual(value, newObj[key]);
	          }),
	          new: _.pickBy(newObj, function (value, key) {
	            return !_.isEqual(old[key], value);
	          })
	        };
	      }
	
	      return diff;
	    }
	  }, {
	    key: "timer",
	    value: function timer(row) {
	      var _this = this;
	
	      if (row.type === 1) {
	        _this.save_home_success = true;
	        _this.$timeout(function () {
	          _this.save_home_success = false;
	        }, 8000);
	      } else {
	        _this.save_company_success = true;
	        _this.$timeout(function () {
	          _this.save_company_success = false;
	        }, 8000);
	      }
	    }
	  }, {
	    key: "setDeleteCreditCard",
	    value: function setDeleteCreditCard($index) {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetCreditCard", { index: $index });
	      });
	    }
	  }, {
	    key: "setDeleteBankAccount",
	    value: function setDeleteBankAccount($index) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetBankAccount", { index: $index, banks: _this.banksArray });
	      });
	    }
	  }, {
	    key: "setVerifyBankAccount",
	    value: function setVerifyBankAccount($index) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetBankAccount", { index: $index, banks: _this.banksArray });
	      });
	    }
	  }, {
	    key: "updatePlan",
	    value: function updatePlan() {
	      var _this = this;
	      _this.updatedPlan = false;
	      _this.planId = _this.planForModal.id;
	      var plan_id = _this.planForModal.id;
	      _this.remain_loading_count++;
	      _this.$auth.changePlans(plan_id).then(function (response) {
	        console.log("what is the new plan");
	        console.dir(response);
	        console.dir(Array.isArray(response.data));
	        if (Array.isArray(response.data)) {
	          if (response.data[0].status === "error") {
	            _this.handlePlansError(response.data[0]);
	            return;
	          }
	        }
	        _this.updatedPlan = true;
	        _this.$timeout(function () {
	          jQuery("#modal-save-profile-confirm").modal();
	        });
	        _this.$timeout(function () {
	          _this.$auth.reloadCurrentUser();
	        }, 100);
	        _this.$timeout(function () {
	          _this.remain_loading_count--;
	        }, 300);
	        _this.$timeout(function () {
	          _this.getLatestCompanyPackage();
	        }, 300);
	        _this.findPlan(plan_id);
	      }, function (response) {
	        _this.remain_loading_count--;
	        log.info("in the error");
	      });
	    }
	  }, {
	    key: "closePlansModal",
	    value: function closePlansModal() {
	      var _this = this;
	      _this.displaySubChangeModal(_this.prev_plan);
	      _this.$timeout(function () {
	        jQuery("#modal-save-plan-confirm-modal").modal("toggle");
	      }, 300);
	    }
	  }, {
	    key: "handlePlansError",
	    value: function handlePlansError(error) {
	      var _this = this;
	      console.log("handle plans error");
	      console.dir(error);
	      if (error.message === "No such customer: null") {
	        _this.plansError = "Before you can change your subscription plan, you must add payment information.";
	      } else if (error.message.indexOf("No such plan:") > -1) {
	        _this.plansError = "This plan no longer exists. Please contact support.";
	      } else {
	        _this.plansError = "There was an issue contact support.";
	      }
	
	      _this.$timeout(function () {
	        _this.remain_loading_count--;
	      }, 500);
	    }
	  }, {
	    key: "findPlan",
	    value: function findPlan(plan_id) {
	      var _this = this;
	      try {
	        _this.plans.forEach(function (plan) {
	          if (plan.id === plan_id) {
	            plan.isActive = "active-plan";
	            _this.previousPlan = plan;
	          } else {
	            plan.isActive = undefined;
	          }
	        });
	      } catch (err) {
	        console.log("error looking plans");
	      } finally {
	        console.log("in the finally");
	        _this.$timeout(function () {
	          $("#modal-save-plan-confirm-modal").modal("toggle");
	        });
	
	        _this.$timeout(function () {
	          $("#modal-save-profile-confirm-modal").modal();
	        }, 500);
	      }
	    }
	  }, {
	    key: "addPaymentInfo",
	    value: function addPaymentInfo() {
	      var _this = this;
	      console.log("add payment info");
	      _this.$timeout(function () {
	        $("#modal-save-plan-confirm-modal").modal("toggle");
	      });
	
	      _this.$timeout(function () {
	        _this.$state.go("accountprofile-payment-information", {
	          companyId: _this.currentUser.company.id
	        });
	      }, 300);
	    }
	  }, {
	    key: "navigateProfilePage",
	    value: function navigateProfilePage(type) {
	      //console.log('what about here?');
	      this.navOptions.forEach(function (option) {
	        if (option.type === type) {
	          option.isActive = "profile-menu-active";
	        } else {
	          option.isActive = "";
	        }
	      });
	
	      if (type === "profile") {
	        this.activeTab = "profile";
	      }
	
	      if (type === "logo") {
	        this.activeTab = "logo";
	      }
	
	      if (type === "plans") {
	        this.activeTab = "plans";
	      }
	
	      if (type === "payments") {
	        //console.log('we have some payments');
	        this.activeTab = "payments";
	      }
	
	      if (type === "notifications") {
	        //console.log('we have some payments');
	        this.activeTab = "notifications";
	      }
	    }
	  }, {
	    key: "addUserModal",
	    value: function addUserModal() {
	      var _this = this;
	      _this.newUserObj = {
	        firstName: null,
	        lastName: null,
	        email: null,
	        // email2: null,
	        password: null,
	        // password2: null,
	        phoneMobile: null
	      };
	      _this.$timeout(function () {
	        jQuery("#modal-add-user-confirm-modal").modal();
	      }, 100);
	    }
	  }, {
	    key: "validateNewUser",
	    value: function validateNewUser(user) {
	      var _this = this;
	
	      var keys = Object.keys(user);
	      var values = keys.map(function (v) {
	        return user[v];
	      });
	      var retObj = {};
	
	      retObj.status = true;
	      retObj.message = "";
	
	      try {
	        for (var x = 0; x < keys.length; x++) {
	          var val = user[keys[x]];
	          if (this.$security.isUndefinedOrNull(val)) {
	            if (keys[x] === "firstName") {
	              retObj.message = "Please provide a first name before continuing.";
	            }
	            if (keys[x] === "lastName") {
	              retObj.message = "Please provide a last name before continuing.";
	            }
	            if (keys[x] === "email") {
	              retObj.message = "Please provide a valid email address before continuing.";
	            }
	            // if (keys[x] === "email2") {
	            //     retObj.message = "Please provide a valid matching email address before continuing.";
	            // }
	            if (keys[x] === "password") {
	              retObj.message = "Please provide a password before continuing.";
	            }
	            // if (keys[x] === "password2") {
	            //     retObj.message = "Please provide a valid matching password before continuing.";
	            // }
	            if (keys[x] === "phoneMobile") {
	              retObj.message = "Please provide a valid phone number.";
	            }
	            retObj.status = false;
	            return retObj;
	          }
	        }
	      } finally {
	        try {
	          // if (user.email !== user.email2) {
	          //                 //     retObj.status = false;
	          //                 //     retObj.message = "Please provide a matching email address.";
	          //                 // }
	          //                 // if (user.password !== user.password2) {
	          //                 //     retObj.status = false;
	          //                 //     retObj.message = "Please provide a matching passwords.";
	          //                 // }
	          return retObj;
	        } finally {
	          return retObj;
	        }
	      }
	    }
	  }, {
	    key: "managerChecked",
	    value: function managerChecked() {}
	  }, {
	    key: "displaySubChangeModal",
	    value: function displaySubChangeModal(plan) {
	      var _this = this;
	
	      if (plan.isChecked) {
	        plan.isChecked = false;
	        return;
	      }
	
	      if (_this.currentUser.company.paymentInfos.length === 0 && !_this.currentUser.isAdmin) {
	        _this.plans.forEach(function (plan) {
	          plan.isChecked = false;
	        });
	
	        _this.$timeout(function () {
	          jQuery("#modal-add-card").modal();
	        }, 100);
	
	        return;
	      }
	      try {
	        var planFiltered = _this.plans.filter(function (p) {
	          return p.isChecked === true;
	        });
	      } finally {
	        if (planFiltered.length > 0) {
	          planFiltered[0].isChecked = false;
	          _this.prev_plan = planFiltered[0];
	        }
	
	        plan.isChecked = true;
	
	        _this.$timeout(function () {
	          jQuery("#modal-save-plan-confirm-modal").modal();
	          _this.planForModal = plan;
	        }, 100);
	      }
	    }
	  }, {
	    key: "change",
	    value: function change() {
	      this.showSaveButton = true;
	    }
	  }, {
	    key: "parsePhone",
	    value: function parsePhone(phoneNum) {
	      var phoneNumber = "1" + phoneNum;
	
	      return phoneNumber.replace(/\D/g, "");
	    }
	  }, {
	    key: "isPhone",
	    value: function isPhone(val) {
	      return (/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(val)
	      );
	    }
	  }, {
	    key: "updateProfilePicture",
	    value: function updateProfilePicture() {
	      var _this = this;
	      var uploadUrl = _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.currentUser.id + "/files?format=json&fileType=4&replace=true";
	      var uploadUrlCompany = _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.currentUser.company.id + "/files?format=json&fileType=9&replace=true";
	
	      if (!_this.$security.isUndefinedOrNull(_this.currentUser.companyPicture)) {
	        _this.fileToUploadCompany(_this.currentUser.companyPicture, uploadUrlCompany);
	      }
	    }
	  }, {
	    key: "picChange",
	    value: function picChange() {
	      this.showPictureSaveButton = true;
	    }
	  }, {
	    key: "populateCardImage",
	    value: function populateCardImage(info) {
	      var _this = this;
	
	      if (info.cardBrand === "American Express") {
	        info.image = "fa fa-cc-amex";
	      }
	      if (info.cardBrand === "Visa") {
	        info.image = "fa fa-cc-visa";
	      }
	      if (info.cardBrand === "Discover") {
	        info.image = "fa fa-cc-discover";
	      }
	      if (info.cardBrand === "MasterCard") {
	        info.image = "fa fa-cc-mastercard";
	      }
	
	      return info.image;
	    }
	  }, {
	    key: "organizePaymentInfo",
	    value: function organizePaymentInfo(justCards, bankToRemove) {
	      var _this = this;
	
	      console.log("organizePaymentInfo");
	      console.dir(_this.paymentInfos);
	      var banksArrayTemp = [];
	      var cardsArrayTemp = [];
	
	      if (_this.paymentInfos && _this.paymentInfos.length > 0) {
	        try {
	          _this.paymentInfos.forEach(function (paymentInfo) {
	            if (paymentInfo.bankName) {
	              if (!justCards) {
	                if (!paymentInfo.validated) {
	                  console.log("we need to display warning");
	                  _this.thereIsAtleastOneBankWithoutValidation = true;
	                }
	                banksArrayTemp.push(paymentInfo);
	              }
	            } else {
	              paymentInfo.image = _this.populateCardImage(paymentInfo);
	              cardsArrayTemp.push(paymentInfo);
	            }
	          });
	        } finally {
	          cardsArrayTemp.forEach(function (paymentInfo) {
	            paymentInfo.cardExpirationDate = moment().month(parseInt(paymentInfo.cardExpirationMonth)).format("MM") + "/" + paymentInfo.cardExpirationYear;
	          });
	
	          _this.cardsArray = cardsArrayTemp;
	          _this.banksArray = banksArrayTemp;
	        }
	      }
	    }
	  }, {
	    key: "getArrayLength",
	    value: function getArrayLength() {
	      if (!this.cardsArray && !this.banksArray) {
	        return 0;
	      }
	
	      return this.cardsArray.length + this.banksArray.length || 0;
	    }
	  }, {
	    key: "organizeBankAccounts",
	    value: function organizeBankAccounts() {
	      var _this = this;
	
	      if (_this.paymentInfos) {
	        _this.paymentInfos.forEach(function (paymentInfo) {
	          if (paymentInfo.bankName) {
	            _this.banksArray.push(paymentInfo);
	          }
	        });
	      }
	    }
	  }, {
	    key: "handleFileSelect",
	    value: function handleFileSelect(evt) {
	      var _this = this;
	    }
	  }, {
	    key: "onUpdate",
	    value: function onUpdate(data) {
	      console.log("onUpdate");
	      console.dir(data);
	      console.dir(this.outputImage);
	    }
	  }, {
	    key: "uploadFilesNew",
	    value: function uploadFilesNew(file, errors) {
	      var _this = this;
	
	      _this.setLoader();
	
	      var fd = new FormData();
	
	      fd.append("file", file);
	
	      if (errors.length > 0) {
	        console.log("errors");
	        console.dir(errors);
	        _this.unSetLoader();
	
	        if (errors[0].$error === "maxHeight") {
	          alert("The logo you are attempting to upload is too large. Please choose another.");
	        } else {
	          alert("There is an issue with that image. Please choose a different one.");
	        }
	
	        _this.$timeout(function () {
	          _this.$progress.complete();
	        });
	
	        return;
	      }
	
	      if (file) {
	        console.log("in the file block");
	        console.dir(file);
	        _this.$progress.start();
	        var uploadUrlCompany = _this.$auth.getUploadUrl(_this.currentUser.company.id, file);
	        console.log("uploadUrlCompany");
	        console.dir(uploadUrlCompany);
	        _this.$http.post(uploadUrlCompany, fd, {
	          headers: {
	            "Content-Type": undefined,
	            Authorization: "Bearer " + _this.currentUser.access_token
	          }
	        }).then(function (response) {
	          var callback = response.data;
	          _this.$timeout(function () {
	            console.log("call back from file upload...");
	            console.dir(response);
	            _this.unSetLoader();
	            _this.cropInput = callback.mainFile.url;
	            _this.currentUser.company.companyLogoUri = callback.mainFile.url;
	            _this.$rootScope.companyLogoUri = callback.mainFile.url;
	            _this.$rootScope.imgFromProfilePage = callback.mainFile.url;
	            _this.currentUser.companyProfilePictureUrl = callback.mainFile.url;
	            _this.$progress.complete();
	            _this.$auth.reloadCurrentUser();
	            _this.determineImageDimensions(callback.mainFile.url);
	            _this.$rootScope.$emit("SetProfilePicture", {
	              picture: callback.mainFile.url
	            });
	          }, 100);
	        }, function (error) {
	          _this.$timeout(function () {
	            jQuery("#application-global-modal .modal-header button.close").trigger("click");
	            _this.$progress.complete();
	          }, 100);
	          _this.$timeout(function () {
	            alert("There is an issue with that image. Please choose a different one.");
	          }, 1000);
	        });
	      }
	    }
	  }, {
	    key: "userCancelsMandate",
	    value: function userCancelsMandate() {
	      console.log("userCancelsMandate");
	    }
	  }, {
	    key: "determineImageDimensions",
	    value: function determineImageDimensions(url) {
	      var myImg = document.querySelector("#company-logo-account-profile");
	
	      if (myImg) {
	        var imageClassForDisplay = this.$profiles.dimensionsCalc(myImg.clientHeight, myImg.clientWidth);
	
	        this.$timeout(function () {
	          $("#company-logo-account-profile").addClass(imageClassForDisplay);
	        });
	      }
	    }
	  }, {
	    key: "setNotificationData",
	    value: function setNotificationData() {
	      var _this = this;
	
	      _this.smsNoti = _this.currentUser.smsChatNotificationOn;
	      _this.emailNoti = _this.currentUser.emailChatNotificationOn;
	
	      _this.notiObj = {
	        smsYes: null,
	        smsNo: null,
	        emailYes: null,
	        emailNo: null
	      };
	
	      if (_this.smsNoti || _this.smsNoti === null) {
	        _this.smsNoti = true;
	        _this.notiObj.smsYes = true;
	        _this.notiObj.smsNo = false;
	      } else {
	        _this.smsNoti = false;
	        _this.notiObj.smsYes = false;
	        _this.notiObj.smsNo = true;
	      }
	
	      if (_this.emailNoti || _this.emailNoti === null) {
	        _this.emailNoti = true;
	        _this.notiObj.emailYes = true;
	        _this.notiObj.emailNo = false;
	      } else {
	        _this.emailNoti = false;
	        _this.notiObj.emailYes = false;
	        _this.notiObj.emailNo = true;
	      }
	    }
	  }, {
	    key: "changeNotiStatus",
	    value: function changeNotiStatus(status) {
	      var _this = this;
	
	      switch (status) {
	        case 1:
	          _this.notiObj.smsYes = true;
	          _this.notiObj.smsNo = false;
	          _this.notiFormDisabled = false;
	          break;
	        case 2:
	          _this.notiObj.smsYes = false;
	          _this.notiObj.smsNo = true;
	          _this.notiFormDisabled = false;
	          break;
	        case 3:
	          _this.notiObj.emailYes = true;
	          _this.notiObj.emailNo = false;
	          _this.notiFormDisabled = false;
	          break;
	        case 4:
	          _this.notiObj.emailYes = false;
	          _this.notiObj.emailNo = true;
	          _this.notiFormDisabled = false;
	          break;
	      }
	    }
	  }, {
	    key: "submitNotifications",
	    value: function submitNotifications() {
	      var _this = this;
	
	      if (_this.notiObj.smsYes) {
	        _this.currentUser.smsChatNotificationOn = true;
	      } else {
	        _this.currentUser.smsChatNotificationOn = false;
	      }
	
	      if (_this.notiObj.emailYes) {
	        _this.currentUser.emailChatNotificationOn = true;
	      } else {
	        _this.currentUser.emailChatNotificationOn = false;
	      }
	
	      var req = {
	        method: "PUT",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.currentUser.id + "?conf=web&format=json&fields=id",
	        headers: {
	          "Content-Type": "application/json;charset=UTF-8",
	          Authorization: "Bearer " + _this.currentUser.access_token
	        },
	        data: {
	          smsChatNotificationOn: _this.currentUser.smsChatNotificationOn,
	          emailChatNotificationOn: _this.currentUser.emailChatNotificationOn
	        }
	      };
	
	      _this.remain_loading_count = 1;
	
	      _this.$http(req).then(function (res) {
	        _this.remain_loading_count = 0;
	      }, function (res) {
	        _this.remain_loading_count = 0;
	      });
	    }
	  }, {
	    key: "phoneChangeFunc",
	    value: function phoneChangeFunc() {
	      var _this = this;
	
	      if (_this.newUserObj.phoneMobile) {
	        var isPhoneNumber = _this.isPhone(_this.newUserObj.phoneMobile);
	
	        if (!isPhoneNumber) {
	          _this.phone_class = "error-with-phone";
	        } else {
	          _this.phone_class = "";
	        }
	      }
	    }
	  }, {
	    key: "isPhone",
	    value: function isPhone(val) {
	      return (/^[1][(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(val)
	      );
	    }
	  }, {
	    key: "toggleEditButtonOn",
	    value: function toggleEditButtonOn(x) {
	      var _this = this;
	
	      if (x === 1) _this.$timeout(function () {
	        jQuery(".profile-edits-container .form-for-profile-wrapper .hidden-edit-homeinfo").show("fast");
	      });
	    }
	  }, {
	    key: "toggleEdit",
	    value: function toggleEdit(x) {
	      var _this = this;
	      if (x === 1) _this.localData.is_home_info_being_edited = true;
	    }
	  }, {
	    key: "toggleEditButtonOff",
	    value: function toggleEditButtonOff(x) {
	      var _this = this;
	
	      if (x === 1) _this.$timeout(function () {
	        jQuery(".profile-edits-container .form-for-profile-wrapper .hidden-edit-homeinfo").hide("fast");
	      });
	    }
	  }, {
	    key: "cancelEdit",
	    value: function cancelEdit(row) {
	      var _this = this;
	
	      row.status = 1;
	    }
	  }, {
	    key: "loadUsers",
	    value: function loadUsers() {
	      var _this = this;
	      _this.setLoader();
	      _this.$companies.loadUsers().then(function (response) {
	        _this.formatUsersNumbersAndAuth(response.data);
	        _this.unSetLoader();
	      }, function (error) {
	        alert("error getting company users");
	      });
	    }
	  }, {
	    key: "triggerPhoneVerificationModal",
	    value: function triggerPhoneVerificationModal(number) {
	      var _this5 = this;
	
	      this.setLoader();
	      this.$timeout(function () {
	        _this5.numberToVerify = number;
	        $("#verify-company-user").modal();
	      });
	      this.$timeout(function () {
	        _this5.$profiles.sendSMSCode().then(function (response) {
	          _this5.unSetLoader();
	        }).catch(function (err) {
	          _this5.unSetLoader();
	        });
	      }, 1000);
	    }
	  }, {
	    key: "formatUsersNumbersAndAuth",
	    value: function formatUsersNumbersAndAuth(users) {
	      var _this6 = this;
	
	      try {
	        users.forEach(function (u) {
	          if (u.homeContactInfo.phoneMobile) {
	            var firstNum = Array.from(u.homeContactInfo.phoneMobile)[0];
	
	            if (firstNum === "1") {
	              u.homeContactInfo.phoneMobile = u.homeContactInfo.phoneMobile.slice(1);
	            }
	
	            u.numberFormatted = _this6.formatPhoneNumber(u.homeContactInfo.phoneMobile);
	          }
	
	          if (u.authorities && u.authorities.length > 0) {
	            u.defaultUserRole = _this6.mapRole(u.authorities[0].name);
	          } else {
	            u.defaultUserRole = "None";
	          }
	        });
	      } catch (err) {
	        console.log("issue with number..");
	        console.dir(err);
	      } finally {
	        //this.formatUserAuths(users);
	        this.companyUsers = users;
	        this.getPendingInvitations();
	      }
	    }
	  }, {
	    key: "getPendingInvitations",
	    value: function getPendingInvitations() {
	      var _this7 = this;
	
	      this.pendingInvites = [];
	      this.$companies.getPendingInvitations().then(function (response) {
	        _this7.processPendingInvites(response.data);
	        //this.processCancelledInvites(response.data);
	      }, function (error) {
	        console.log("getPendingInvitations error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "formatInviteDate",
	    value: function formatInviteDate(date) {
	      return moment(date).format("MM/DD/YYYY");
	    }
	  }, {
	    key: "resendInvite",
	    value: function resendInvite(data) {
	      this.inviteUser(data);
	    }
	  }, {
	    key: "cancelInvite",
	    value: function cancelInvite(data) {
	      var _this8 = this;
	
	      this.setLoader();
	      this.$companies.cancelPendingInvitation(data.invitationToken).then(function (response) {
	        _this8.removeCancelledInviteFromPendingList(data);
	      }, function (error) {
	        _this8.unSetLoader();
	        console.error(error);
	      });
	    }
	  }, {
	    key: "removeCancelledInviteFromPendingList",
	    value: function removeCancelledInviteFromPendingList(data) {
	      var _this9 = this;
	
	      this.pendingInvites = this.pendingInvites.filter(function (obj) {
	        return obj.email !== data.email;
	      });
	      this.$timeout(function () {
	        _this9.unSetLoader();
	      }, 300);
	    }
	  }, {
	    key: "processCancelledInvites",
	    value: function processCancelledInvites(canceledInvites) {
	      var _this10 = this;
	
	      this.cancelledInvites = [];
	      try {
	        canceledInvites.forEach(function (ci) {
	          if (ci.invitationStatus && ci.invitationStatus === "CANCELLED") {
	            ci.invitationDateFormatted = _this10.formatInviteDate(ci.invitationDate);
	            _this10.cancelledInvites.push(ci);
	          }
	        });
	      } catch (err) {
	        console.error(err);
	      } finally {
	        console.log("in the finally");
	        console.dir(this.cancelledInvites);
	      }
	    }
	  }, {
	    key: "processPendingInvites",
	    value: function processPendingInvites(pendingInvites) {
	      var _this11 = this;
	
	      try {
	        pendingInvites.forEach(function (pi) {
	          if (pi.invitationStatus && pi.invitationStatus === "PENDING") {
	            console.log("we have a pending invite");
	            console.dir(pi);
	            pi.invitationDateFormatted = _this11.formatInviteDate(pi.invitationDate);
	            _this11.pendingInvites.push(pi);
	          }
	        });
	      } catch (err) {
	        console.error(err);
	      } finally {
	        console.log("in the finally");
	        console.dir(this.pendingInvites);
	      }
	    }
	  }, {
	    key: "formatUserAuths",
	    value: function formatUserAuths(users) {}
	  }, {
	    key: "isLetter",
	    value: function isLetter(char) {
	      var c = char.toString().toUpperCase();
	
	      return c.toUpperCase().match("[A-ZÀ-ÚÄ-Ü]+") !== null;
	    }
	  }, {
	    key: "codeEntered",
	    value: function codeEntered(num) {
	      var isLetter = this.isLetter(this["smsCode_" + num]);
	
	      if (isLetter === true) {
	        this["smsCode_" + num] = null;
	        return;
	      }
	
	      if (num <= 5 && this["smsCode_" + num]) {
	        var el = document.getElementById("sms-code-" + (num + 1));
	        el.focus();
	        el.select();
	      }
	
	      var code = "" + this.smsCode_1 + this.smsCode_2 + this.smsCode_3 + this.smsCode_4 + this.smsCode_5 + this.smsCode_6;
	
	      if (code.length === 6) {
	        this.validateSMSCode();
	      }
	    }
	  }, {
	    key: "smsCodeBackSpace",
	    value: function smsCodeBackSpace(event, inputSequence) {
	      if (event.keyCode === 8) {
	        if (inputSequence !== 1) {
	          var activeValue = $(".apply-profile-modal .modal-content .sms-code-container input#sms-code-" + inputSequence).val();
	          if (activeValue === "") {
	            this.$timeout(function () {
	              $(".apply-profile-modal .modal-content .sms-code-container input#sms-code-" + (inputSequence - 1)).focus();
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: "clearInputNumbers",
	    value: function clearInputNumbers() {
	      this.smsCode_1 = "";
	      this.smsCode_2 = "";
	      this.smsCode_3 = "";
	      this.smsCode_4 = "";
	      this.smsCode_5 = "";
	      this.smsCode_6 = "";
	      this.smsVerificationError = null;
	    }
	  }, {
	    key: "resendAppLink",
	    value: function resendAppLink() {
	      var _this12 = this;
	
	      this.$timeout(function () {
	        _this12.smsLinkSending = true;
	        _this12.smsLinkSennt = false;
	      });
	      this.sendAppLink().then(function () {
	        _this12.$timeout(function () {
	          _this12.smsLinkSending = false;
	          _this12.smsLinkSennt = true;
	        });
	      });
	    }
	  }, {
	    key: "validateSMSCode",
	    value: function validateSMSCode() {
	      var _this13 = this;
	
	      var code = "" + this.smsCode_1 + this.smsCode_2 + this.smsCode_3 + this.smsCode_4 + this.smsCode_5 + this.smsCode_6;
	
	      this.setLoader();
	
	      this.$profiles.validateSMSCode(code).then(function (response) {
	        _this13.$timeout(function () {
	          _this13.smsVerified = true;
	          _this13.submitAndSaveUser();
	          _this13.unSetLoader();
	        });
	      }).catch(function (err) {
	        _this13.$timeout(function () {
	          _this13.smsVerificationError = true;
	          _this13.smsVerificationErrorText = "Code invalid or expired";
	          _this13.unSetLoader();
	          alert("There was an error validating your SMS code. Please try again or contact support.");
	        }, 1000);
	      });
	    }
	  }, {
	    key: "exitPhoneVerification",
	    value: function exitPhoneVerification() {
	      this.$timeout(function () {
	        $("#verify-company-user").modal("toggle");
	      });
	    }
	  }, {
	    key: "submitAndSaveUser",
	    value: function submitAndSaveUser() {
	      var _this14 = this;
	
	      this.$timeout(function () {
	        _this14.$auth.refreshCurrentUser().then(function (user) {
	          $("#verify-company-user").modal("toggle");
	          _this14.organizeUsersWithVerifiedPhones(_this14.companyUsers, user);
	          _this14.unSetLoader();
	        });
	      }, 1000);
	    }
	  }, {
	    key: "organizeUsersWithVerifiedPhones",
	    value: function organizeUsersWithVerifiedPhones(users, user) {
	      var _this15 = this;
	
	      console.log("organizeUsersWithVerifiedPhones");
	      console.dir(users);
	      console.dir(user);
	      try {
	        users.forEach(function (u) {
	          if (u.email === user.email) {
	            if (u.homeContactInfo) {
	              u.homeContactInfo.isMobilePhoneVerified = true;
	              user.homeContactInfo.isMobilePhoneVerified = true;
	              _this15.currentUser.homeContactInfo.isMobilePhoneVerified = true;
	            }
	          }
	        });
	      } catch (err) {
	        console.log("in error");
	        console.dir(err);
	      } finally {
	        console.log("in the finally");
	        console.dir(users);
	        console.dir(this.companyUsers);
	        console.dir(user);
	      }
	    }
	  }, {
	    key: "formatPhoneNumber",
	    value: function formatPhoneNumber(phoneNumberString) {
	      var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
	
	      var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
	
	      if (match) {
	        return "+1 (" + match[1] + ") " + match[2] + "-" + match[3];
	      }
	
	      return null;
	    }
	  }, {
	    key: "setLinkActive",
	    value: function setLinkActive(link) {
	
	      var _this = this;
	
	      if (link === 1) {
	        _this.$timeout(function () {
	          $(".profile-edits-container .jobs-complete-sidebar li:nth-child(1)").removeClass().addClass("active");
	          _this.getLogo(_this.currentUser.access_token);
	        }, 500);
	        _this.$timeout(function () {
	          _this.unSetLoader();
	        }, 700);
	      }
	      if (link === 2) {
	        if (_this.currentUser.company.payByInvoice === true) {
	          _this.unSetLoader();
	          _this.pullLatestPaymentInfo();
	          return;
	        }
	        _this.showPaymentInfo = false;
	        _this.pullLatestPaymentInfo();
	        _this.$timeout(function () {
	          $(".profile-edits-container .jobs-complete-sidebar li:nth-child(2)").removeClass().addClass("active");
	        }, 300);
	      }
	      if (link === 3) {
	        _this.$timeout(function () {
	          $(".profile-edits-container .jobs-complete-sidebar li:nth-child(3)").removeClass().addClass("active");
	        }, 300);
	        _this.$timeout(function () {
	          _this.unSetLoader();
	        }, 450);
	      }
	      if (link === 4) {
	        _this.page = link;
	        _this.getUserRoles();
	      }
	      if (link === 5) {
	        if (_this.currentUser.company.payByInvoice === true) {
	          return;
	        }
	        _this.$timeout(function () {
	          $(".profile-edits-container .jobs-complete-sidebar li:nth-child(5)").removeClass().addClass("active");
	        }, 300);
	        _this.$timeout(function () {
	          _this.unSetLoader();
	        }, 450);
	      }
	      if (link === 6) {
	        _this.$timeout(function () {
	          $(".profile-edits-container .jobs-complete-sidebar li:nth-child(6)").removeClass().addClass("active");
	        }, 300);
	        _this.$timeout(function () {
	          _this.unSetLoader();
	        }, 450);
	      }
	      if (link === 7) {
	        _this.$timeout(function () {
	          $(".profile-edits-container .jobs-complete-sidebar li:nth-child(5)").removeClass().addClass("active");
	        }, 300);
	        _this.$timeout(function () {
	          _this.unSetLoader();
	        }, 450);
	      }
	    }
	  }, {
	    key: "loadPaymentData",
	    value: function loadPaymentData() {
	      var _this = this;
	      _this.remain_loading_count = 0;
	    }
	  }, {
	    key: "should_we_disable_some_links",
	    value: function should_we_disable_some_links(user) {
	      var _this = this;
	
	      if (user) {
	        if (user.company) {
	          if (user.company.payByInvoice === true) {
	            _this.disable_left_links(true);
	          } else {
	            _this.disable_left_links(false);
	          }
	        }
	      }
	
	      _this.displayBankModal();
	    }
	  }, {
	    key: "displayBankModal",
	    value: function displayBankModal() {
	      var _this16 = this;
	
	      var verifyBank = parseInt(this.$location.$$search.verifyBank);
	      if (verifyBank) {
	        try {
	          var selectedBank = this.currentUser.company.undeletedPaymentInfos.find(function (o) {
	            return o.id === verifyBank;
	          });
	        } catch (err) {
	          console.log("err");
	          console.dir(err);
	        } finally {
	          this.$timeout(function () {
	            _this16.$rootScope.$emit("SetBankAccount", { index: null, selectedBank: selectedBank });
	          });
	        }
	      } else {
	        console.log("dont display modal");
	      }
	    }
	  }, {
	    key: "disable_left_links",
	    value: function disable_left_links(disable) {
	      var _this = this;
	
	      if (disable === true) {
	        _this.$timeout(function () {
	          $(".profile-edits-container .jobs-complete-sidebar li:nth-child(2)").addClass("fade-link");
	        }, 100);
	        _this.$timeout(function () {
	          $(".profile-edits-container .jobs-complete-sidebar li:nth-child(5)").addClass("fade-link");
	        }, 100);
	      } else {
	        _this.$timeout(function () {
	          $(".profile-edits-container .jobs-complete-sidebar li:nth-child(2)").removeClass("fade-link");
	        }, 100);
	        _this.$timeout(function () {
	          $(".profile-edits-container .jobs-complete-sidebar li:nth-child(5)").removeClass("fade-link");
	        }, 100);
	      }
	    }
	  }, {
	    key: "loadSettings",
	    value: function loadSettings() {
	      var _this = this;
	      var sms = null;
	      var email = null;
	
	      _this.setLoader();
	      _this.$companies.getSettings().then(function (response) {
	        console.log("get settings...");
	        console.dir(response);
	
	        if (response.data.smsChatNotificationOn === null) {
	          response.data.smsChatNotificationOn = true;
	        }
	        if (response.data.emailChatNotificationOn === null) {
	          response.data.emailChatNotificationOn = true;
	        }
	
	        _this.settings = [{
	          prop: 1,
	          name: "SMS Notifications",
	          value: response.data.smsChatNotificationOn,
	          status: 1,
	          statusText: response.data.smsChatNotificationOn ? "On" : "Off"
	        }, {
	          prop: 2,
	          name: "Email Notifications",
	          value: response.data.emailChatNotificationOn,
	          status: 1,
	          statusText: response.data.emailChatNotificationOn ? "On" : "Off"
	        }];
	        _this.privacy_settings = [{
	          prop: 3,
	          name: "Privacy Policy",
	          value: response.data.acceptedPrivacyPolicy,
	          status: 1,
	          statusText: response.data.acceptedPrivacyPolicy ? "Agreed" : "Disagreed"
	        }];
	
	        _this.currentUser.company.payByInvoice = response.data.company.payByInvoice;
	
	        _this.setAccountTypes(response.data);
	        _this.setInvoiceSettings(response.data);
	        _this.should_we_disable_some_links(response.data);
	
	        _this.$timeout(function () {
	          _this.unSetLoader();
	        }, 300);
	      }, function (error) {
	        alert("Error getting settings");
	      });
	    }
	  }, {
	    key: "setInvoiceSettings",
	    value: function setInvoiceSettings(data) {
	      var _this = this;
	
	      _this.invoice_settings = {};
	
	      console.log("setInvoiceSettings");
	      console.dir(data);
	
	      var markup = null;
	      if (data.company.invoiceMarkup) {
	        markup = Math.round(data.company.invoiceMarkup * 100);
	      }
	
	      _this.invoice_settings.pays_by_invoice = data.company.payByInvoice;
	      _this.invoice_settings.send_invoice = data.company.sendInvoice;
	      _this.invoice_settings.weekly_billing = data.company.enableSubscription;
	      _this.invoice_settings.markup = markup;
	
	      _this.determineCheckBoxes(data.company);
	    }
	  }, {
	    key: "determineCheckBoxes",
	    value: function determineCheckBoxes(company) {
	      console.log("determine check boxes");
	      console.dir(company);
	
	      if (company.enableSubscription === true && company.sendInvoice === true) {
	        this.invoice_settings.weekly_billing = false;
	      } else {
	        //this.invoice_settings.weekly_billing = true;
	      }
	
	      if (!company.enableSubscription && !company.payByInvoice) {
	        this.invoice_settings.instant_charge = true;
	      } else {
	        this.invoice_settings.instant_charge = false;
	      }
	
	      if (company.payByInvoice === true) {
	        this.invoice_settings.instant_charge = false;
	      }
	
	      if (company.enableSubscription === true) {
	        this.invoice_settings.instant_charge = false;
	      }
	    }
	  }, {
	    key: "editBillingEmail",
	    value: function editBillingEmail() {
	      if (!this.editingBusinessContact) {
	        this.editingBusinessContact = true;
	      } else {
	        this.editingBusinessContact = false;
	      }
	    }
	  }, {
	    key: "update_invoice_settings",
	    value: function update_invoice_settings(setting) {
	      var _this = this;
	
	      var value = null;
	      var data = {};
	
	      if (setting === 3) {
	        if (_this.invoice_settings.send_invoice === true) {
	          data.sendInvoice = false;
	          data.enableSubscription = false;
	          //data.enableSubscription = false;
	          data.payByInvoice = false;
	        } else {
	          data.sendInvoice = true;
	          data.enableSubscription = true;
	          data.payByInvoice = false;
	        }
	      }
	
	      if (setting === 1) {
	        if (_this.invoice_settings.weekly_billing === true) {
	          data.enableSubscription = false;
	          data.sendInvoice = false;
	        } else {
	          data.enableSubscription = true;
	          data.sendInvoice = false;
	          data.payByInvoice = false;
	        }
	      }
	
	      if (setting === 2) {
	        if (_this.invoice_settings.pays_by_invoice === true) {
	          data.payByInvoice = false;
	        } else {
	          data.payByInvoice = true;
	          data.invoiceMarkup = (_this.invoice_settings.markup / 100).toFixed(2);
	          data.enableSubscription = false;
	          data.sendInvoice = false;
	        }
	      }
	
	      if (setting === 4) {
	        if (_this.invoice_settings.instant_charge === true) {
	          alert("There must be one payment setting set to true. Please select from the other options.");
	          return;
	        } else {
	          data.payByInvoice = false;
	          data.enableSubscription = false;
	          data.sendInvoice = false;
	        }
	      }
	
	      _this.updateInvoiceSettings(data);
	    }
	  }, {
	    key: "autoHirePreferenceChanging",
	    value: function autoHirePreferenceChanging(preferenceNumber) {
	      console.log("autoHirePreferenceChanging");
	      console.dir(preferenceNumber);
	    }
	  }, {
	    key: "updateInvoiceSettings",
	    value: function updateInvoiceSettings(data) {
	      var _this = this;
	
	      _this.setLoader();
	
	      console.log("updateInvoiceSettings");
	      console.dir(data);
	
	      _this.$companies.updateInvoiceSettings(data).then(function (response) {
	        if (response.data.company.payByInvoice === true) {
	          _this.invoice_settings.pays_by_invoice = true;
	          _this.disable_left_links(true);
	        } else {
	          _this.invoice_settings.pays_by_invoice = false;
	          _this.disable_left_links(false);
	        }
	
	        if (response.data.company.enableSubscription === true) {
	          _this.invoice_settings.weekly_billing = true;
	        } else {
	          _this.invoice_settings.weekly_billing = false;
	        }
	
	        if (response.data.company.sendInvoice === true) {
	          _this.invoice_settings.send_invoice = true;
	        } else {
	          _this.invoice_settings.send_invoice = false;
	        }
	
	        _this.save_invoice_success = true;
	        _this.$timeout(function () {
	          _this.save_invoice_success = false;
	          _this.unSetLoader();
	        }, 1000);
	
	        _this.determineCheckBoxes(response.data.company);
	        _this.getLatestCompanyPackage();
	      }, function (error) {
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "enterSave",
	    value: function enterSave() {
	      var _this = this;
	
	      var data = {};
	      data.invoiceMarkup = (_this.invoice_settings.markup / 100).toFixed(2);
	      data.payByInvoice = true;
	      _this.editing_percentage = false;
	
	      _this.updateInvoiceSettings(data);
	    }
	  }, {
	    key: "getLatestCompanyPackage",
	    value: function getLatestCompanyPackage() {
	      var _this = this;
	      if (_this.currentUser) {
	        _this.$timeout(function () {
	          _this.$auth.getCompanyPlan().then(function (response) {
	            _this.currentUser.company.defaultPlan = response.data.company.defaultPlan;
	          }, function (error) {});
	        }, 1000);
	      }
	    }
	  }, {
	    key: "editPercentage",
	    value: function editPercentage() {
	      var _this = this;
	      console.log("editPercentage");
	      if (_this.editing_percentage) {
	        _this.editing_percentage = false;
	      } else {
	        _this.editing_percentage = true;
	        _this.$timeout(function () {
	          $("table.account-profile-settings-table.invoice-edits tr td input.save-invoice-input").focus();
	        });
	      }
	    }
	  }, {
	    key: "cancelInvoiceUpdate",
	    value: function cancelInvoiceUpdate() {
	      this.editing_percentage = false;
	    }
	  }, {
	    key: "updateInvoiceMargins",
	    value: function updateInvoiceMargins() {
	      var _this = this;
	
	      var data = {};
	      data.invoiceMarkup = (_this.invoice_settings.markup / 100).toFixed(2);
	      data.payByInvoice = true;
	      _this.editing_percentage = false;
	      _this.updateInvoiceSettings(data);
	    }
	  }, {
	    key: "toggleSettings",
	    value: function toggleSettings(row, x) {
	      var _this = this;
	
	      console.log("toggleSettings");
	      console.dir(row);
	      console.dir(x);
	
	      var data = {};
	
	      if (row.prop === 3) {
	        console.log("in porop 3");
	        //data.acceptedPrivacyPolicy;
	        if (row.statusText === "Disagreed") {
	          data.acceptedPrivacyPolicy = true;
	          row.statusText = "Agreed";
	        } else {
	          data.acceptedPrivacyPolicy = false;
	          row.statusText = "Disagreed";
	        }
	      } else if (row.prop === 2) {
	        if (row.statusText === "On") {
	          data.emailChatNotificationOn = false;
	          row.statusText = "Off";
	        } else {
	          data.emailChatNotificationOn = true;
	          row.statusText = "On";
	        }
	      } else {
	        if (row.statusText === "On") {
	          data.smsChatNotificationOn = false;
	          row.statusText = "Off";
	        } else {
	          data.smsChatNotificationOn = true;
	          row.statusText = "On";
	        }
	      }
	
	      row.status = 1;
	
	      _this.$timeout(function () {
	        if (row.prop === 3) {
	          _this.save_priv_success = true;
	          _this.timerNotifications(row);
	        } else {
	          _this.save_noti_success = true;
	          _this.timerNotifications(row);
	        }
	      }, 300);
	
	      _this.$companies.updateNotifications(data).then(function (response) {
	        console.log("resonse form noti update");
	        console.dir(response);
	      }, function (error) {
	        alert("error updating settings");
	      });
	    }
	  }, {
	    key: "timerNotifications",
	    value: function timerNotifications(row) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        _this.save_noti_success = false;
	        _this.save_priv_success = false;
	      }, 6000);
	    }
	  }, {
	    key: "getPlans",
	    value: function getPlans(m, o) {
	      var _this = this;
	
	      console.log("get plans?");
	
	      this.$auth.getPlans(m, o).then(function (response) {
	        var t = [];
	
	        try {
	          if (response.data.status !== "error") {
	            response.data.forEach(function (plan, index) {
	              if (_this.currentUser.company.defaultPlan.id === plan.id) {
	                plan.isChecked = true;
	                plan.isActive = "active-plan";
	              } else {
	                plan.isChecked = false;
	              }
	
	              t.push(plan);
	            });
	          } else {}
	        } finally {
	          _this.plans = t;
	          console.log("what are the plans");
	          console.dir(_this.plans);
	        }
	      }, function (response) {
	        if (data.status === 401) {
	          _this.$state.go("signin");
	        } else {
	          _this.$timeout(function () {
	            jQuery("#show-application-alert").trigger("click");
	          }, 100);
	        }
	      });
	    }
	  }, {
	    key: "handleAddingUserError",
	    value: function handleAddingUserError(data) {
	      var _this = this;
	      if (data.data.message) {
	        _this.errorMessageRegi = data.data.message;
	      } else {
	        _this.$timeout(function () {
	          jQuery("#modal-add-user-confirm-modal .modal-header button.close").trigger("click");
	        }, 100);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 300);
	      }
	    }
	  }, {
	    key: "setActivePageOnLeft",
	    value: function setActivePageOnLeft() {
	      var _this = this;
	
	      _this.setLoader();
	
	      if (!this.$stateParams) {
	        console.log("state params are empty");
	      }
	
	      if (this.$location.$$path.indexOf("company-users") > -1) {
	        _this.page = 4;
	        _this.$timeout(function () {
	          _this.getUserRoles();
	          _this.loadUsers();
	        }, 300);
	        //this.setLinkActive(4);
	        //this.loadUsers();
	      }
	
	      if (this.$location.$$path.indexOf("payment-information") > -1) {
	        this.page = 2;
	        this.setLinkActive(2);
	        this.loadPaymentData();
	      }
	
	      if (this.$location.$$path.indexOf("subscription-plans") > -1) {
	        this.page = 5;
	        this.setLinkActive(5);
	        this.getPlans();
	      }
	
	      if (this.$location.$$path.indexOf("settings") > -1) {
	        this.page = 3;
	        this.setLinkActive(3);
	        this.loadSettings();
	      }
	
	      if (this.$location.$$path.indexOf("payment-history") > -1) {
	        this.page = 6;
	        this.setLinkActive(6);
	        //this.loadSettings();
	      }
	
	      if (this.$location.$$path.indexOf("notification-center") > -1) {
	        this.page = 7;
	        this.setLinkActive(7);
	        this.getUserNotficationPreferences();
	      }
	
	      if (!this.$stateParams.companyId) {
	        this.page = 1;
	        this.remain_loading_count = 0;
	        this.setLinkActive(1, true);
	      }
	
	      _this.should_we_disable_some_links(_this.currentUser);
	    }
	  }, {
	    key: "checkForRDS",
	    value: function checkForRDS() {
	      var _this = this;
	
	      var user = _this.currentUser;
	      var on_payment_page = _this.$location.$$path.indexOf("payment-information") > -1;
	
	      if (user.company.undeletedPaymentInfos) {
	        user.company.paymentInfos = user.company.undeletedPaymentInfos;
	      } else {
	        user.company.paymentInfos = [];
	      }
	
	      if (user.company.partner && user.company.paymentInfos.length === 0 && on_payment_page) {
	        //console.log('we have a partner with no payment information');
	        _this.$timeout(function () {
	          _this.$rootScope.$emit("SetWarningForRDSCustomer", {});
	        }, 1000);
	      }
	    }
	  }, {
	    key: "clearPayInfo",
	    value: function clearPayInfo() {
	      var _this = this;
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("ClearPayInfo", {});
	      });
	    }
	  }, {
	    key: "initAccounts",
	    value: function initAccounts() {
	      var _this17 = this;
	
	      var _this = this;
	
	      _this.setLoader();
	
	      var data = {};
	
	      var clientSecret = void 0;
	
	      data.confirm = true;
	      data.usage = "off_session";
	
	      var contactEmail = void 0;
	
	      if (this.currentUser.company.billingContactInfo.email) {
	        contactEmail = this.currentUser.company.billingContactInfo.email;
	      } else {
	        contactEmail = this.currentUser.username;
	      }
	
	      this.$companies.getIntentKey(data).then(function (response) {
	        console.log("what is the response");
	        console.dir(response.data);
	        clientSecret = response.data.clientSecret;
	
	        _this17.stripe.collectBankAccountForSetup({
	          clientSecret: response.data.clientSecret,
	          params: {
	            payment_method_type: "us_bank_account",
	            payment_method_data: {
	              billing_details: { name: "Jobble Admin", email: contactEmail }
	            }
	          }
	        }).then(function (result) {
	          console.log("collectBankAccountForSetup");
	          console.dir(result);
	
	          if (result.error) {
	            // Inform the customer that there was an error.
	            console.log(result.error.message);
	            alert(result.error.message);
	            // Handle next step based on length of accounts
	          } else if (!result.setupIntent) {
	            console.log("No setupIntent created....");
	            alert("No setupIntent created....");
	          } else if (result.setupIntent.next_action && result.setupIntent.next_action.type === "verify_with_microdeposits") {
	            alert("we need micro deposits");
	          } else {
	            _this.handleSetupIntent(result.setupIntent, clientSecret);
	          }
	        });
	      }, function (error) {
	        alert("Error getting intent: " + error);
	      });
	    }
	  }, {
	    key: "handleSetupIntent",
	    value: function handleSetupIntent(setupIntent, clientSecret) {
	      if (!setupIntent.payment_method) {
	        console.error("User exited modal.");
	        this.unSetLoader();
	        return;
	      }
	
	      console.log("handle setup intent");
	      console.dir(setupIntent);
	      if (setupIntent.status === "requires_confirmation") {
	        console.log("display mandate...");
	        console.dir(setupIntent);
	        this.mandateData = {
	          setupIntent: setupIntent,
	          clientSecret: clientSecret
	        };
	        this.triggerMandate(setupIntent);
	        //this.updateSetupIntent(setupIntent);
	        //this.confirmBankAccountSetup(setupIntent, clientSecret);
	      } else {
	        this.confirmBankAccountSetup(setupIntent, clientSecret);
	      }
	    }
	  }, {
	    key: "confirmMandate",
	    value: function confirmMandate() {
	      if (this.disableMandateButton === true) {
	        return;
	      }
	      this.disableMandateButton = true;
	      this.setLoader();
	      var setupIntent = this.mandateData.setupIntent;
	      var clientSecret = this.mandateData.clientSecret;
	      this.confirmBankAccountSetup(setupIntent, clientSecret);
	      delete this.mandateData.setupIntent;
	      delete this.mandateData.clientSecret;
	      this.$timeout(function () {
	        $("#stripe-mandate-display").modal("toggle");
	      }, 500);
	    }
	  }, {
	    key: "triggerMandate",
	    value: function triggerMandate(setupIntent) {
	      var _this18 = this;
	
	      this.disableMandateButton = false;
	      this.$timeout(function () {
	        _this18.unSetLoader();
	        $("#stripe-mandate-display").modal();
	      }, 1000);
	    }
	  }, {
	    key: "confirmBankAccountSetup",
	    value: function confirmBankAccountSetup(intent, clientSecret) {
	      var _this19 = this;
	
	      this.stripe.confirmUsBankAccountSetup(clientSecret).then(function (_ref2) {
	        var setupIntent = _ref2.setupIntent,
	            error = _ref2.error;
	
	        console.log("confirmBankAccountSetup response...");
	        console.dir(setupIntent);
	        if (error) {
	          console.error(error.message);
	          _this19.unSetLoader();
	          // The payment failed for some reason.
	        } else if (setupIntent.status === "requires_payment_method") {
	          _this19.unSetLoader();
	          // Confirmation failed. Attempt again with a different payment method.
	        } else if (setupIntent.status === "succeeded") {
	          // Confirmation succeeded! The account is now saved.
	          // Display a message to customer.
	          _this19.updateSetupIntent(setupIntent, false);
	        } else if (setupIntent.status === "requires_action" && setupIntent.next_action.type === "verify_with_microdeposits") {
	          // The account needs to be verified via microdeposits.
	          // Display a message to consumer with next steps (consumer waits for
	          // microdeposits, then enters a statement descriptor code on a page sent to them via email).
	          _this19.unSetLoader();
	          _this19.updateSetupIntent(setupIntent, true);
	          //this.updateSetupIntent(setupIntent);
	          //this.actionRequired(setupIntent);
	        }
	      });
	    }
	  }, {
	    key: "actionRequired",
	    value: function actionRequired(setupIntent) {
	      console.log("actionRequired");
	      alert("We need to verify this account with micro deposits");
	    }
	  }, {
	    key: "updateSetupIntent",
	    value: function updateSetupIntent(setupIntent, requiresMicroDepositConfirmation) {
	      var _this20 = this;
	
	      console.log("updateSetupIntent");
	      console.dir(setupIntent);
	
	      var payload = {};
	
	      payload.setupId = setupIntent.id;
	      payload.paymentMethodId = setupIntent.payment_method;
	
	      if (requiresMicroDepositConfirmation) {
	        payload.requiresMicroDepositConfirmation = true;
	      }
	
	      console.log("-------------------payload----------------------");
	      console.dir(payload);
	
	      this.$companies.updateIntentKey(payload).then(function (response) {
	        console.log("updateIntentKey");
	        console.dir(response);
	        _this20.handleUpdateIntent(response.data);
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	        _this20.unSetLoader();
	        alert("Error from handleSetupIntent error status : " + error.status);
	      });
	    }
	  }, {
	    key: "handleUpdateIntent",
	    value: function handleUpdateIntent(bankAccount) {
	      console.log("handleUpdateIntent");
	      console.dir(bankAccount);
	
	      if (!bankAccount.paymentInfoId) {
	        console.error("User exited modal.");
	        this.unSetLoader();
	        return;
	      }
	
	      bankAccount.id = bankAccount.paymentInfoId;
	      bankAccount.validated = bankAccount.paymentInfoValidated;
	
	      this.banksArray.push(bankAccount);
	
	      this.unSetLoader();
	    }
	  }, {
	    key: "initConnections",
	    value: function initConnections() {
	      var _this = this;
	
	      var stripe = window.Stripe(_this.$env.EnvironmentConfig.stripeKey);
	
	      _this.setLoader();
	
	      this.$companies.getFcaKey().then(function (response) {
	        console.log("what is the response");
	        console.dir(response.data);
	        stripe.collectFinancialConnectionsAccounts({
	          clientSecret: response.data.clientSecret
	        }).then(function (result) {
	          if (result.error) {
	            // Inform the customer that there was an error.
	            console.log(result.error.message);
	
	            // Handle next step based on length of accounts array
	          } else if (result.financialConnectionsSession.accounts.length === 0) {
	            console.log("No accounts were linked");
	          } else {
	            console.log("response from collectFinancialConnectionsAccounts");
	            console.log(result);
	          }
	        });
	      }, function (error) {
	        alert("Error getting user roles - contact admin : " + error);
	      });
	    }
	  }, {
	    key: "setAccountTypes",
	    value: function setAccountTypes(user) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetPostingTypes", user);
	      });
	    }
	  }, {
	    key: "updateIndustryTypeOfCompany",
	    value: function updateIndustryTypeOfCompany() {
	      var _this = this;
	
	      var latest_id = _this.account_type_settings.value.id;
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "submitOnEnter",
	    value: function submitOnEnter(e) {
	      if (e.keyCode === 13) {
	        this.updateUsersBillingEmail();
	      }
	    }
	  }, {
	    key: "updateUsersBillingEmail",
	    value: function updateUsersBillingEmail() {
	      var _this21 = this;
	
	      if (this.validation.email && this.validation.email.valid === false) {
	        alert("Error validating billing contact: " + this.validation.email.message);
	        return;
	      }
	
	      if (!this.validation.email) {
	        this.editingBusinessContact = false;
	        return;
	      }
	
	      var data = {};
	      data.company = {};
	      data.company.billingContactInfo = {};
	      data.company.billingContactInfo.email = this.currentUser.company.billingContactInfo.email;
	      this.editingBusinessContact = false;
	      this.setLoader();
	      this.$timeout(function () {
	        _this21.$companies.updateCompanyBillingEmail(data).then(function (response) {
	          _this21.unSetLoader();
	          _this21.$auth.reloadCurrentUser();
	        }, function (error) {
	          _this21.unSetLoader();
	          console.log("transfer error, error:", error);
	          // alert("Error : " + error);
	          alert("There was an error updating the billing contact. Please try again.");
	        });
	      }, 1500);
	    }
	  }, {
	    key: "cancelUsersBillingEmail",
	    value: function cancelUsersBillingEmail() {
	      this.editingBusinessContact = false;
	    }
	  }, {
	    key: "getUserRoles",
	    value: function getUserRoles() {
	      var _this22 = this;
	
	      this.$companies.getAuth().then(function (response) {
	        _this22.$companies.getUserRoles().then(function (response) {
	          _this22.userRollsAPI = response.data;
	          _this22.formatUserRoles(response.data);
	        }, function (error) {
	          alert("Error getting user roles - contact admin : " + error);
	        });
	      }, function (error) {
	        alert("Error getting user roles - contact admin : " + error);
	      });
	    }
	  }, {
	    key: "formatUserRoles",
	    value: function formatUserRoles(roles) {
	
	      var userRoles = [];
	
	      this.defaultUserRole = "HR Manager";
	
	      try {
	        roles.forEach(function (role) {
	          if (role.name === "GROUP_COMPANY_ADMIN") {
	            userRoles.push("HR Manager");
	          } else if (role.name === "GROUP_FINANCE") {
	            userRoles.push("Finance");
	          } else if (role.name === "GROUP_ONSITE_MANAGER") {
	            userRoles.push("On Site Manager");
	          }
	        });
	      } catch (err) {
	        console.log("error with roles");
	        console.dir(err);
	      } finally {
	        //userRoles.unshift("None");
	        this.userRoles = userRoles;
	      }
	    }
	  }, {
	    key: "removeUpdateButton",
	    value: function removeUpdateButton(index) {
	      this.$timeout(function () {
	        $(".account-gradient-button.show-hide.item-number-" + index).removeClass("show-hide-show");
	      });
	    }
	  }, {
	    key: "updateRoleButton",
	    value: function updateRoleButton(user, index) {
	      console.log("updateRoleButton");
	      console.dir(user);
	
	      if (user.homeContactInfo.isMobilePhoneVerified !== true && user.defaultUserRole === "On Site Manager") {
	        user.defaultUserRole = "None";
	        alert("This user does not have a verified phone number and cannot be an On Site Manager.");
	        return;
	      }
	
	      if (user.defaultUserRole === "None") {
	        this.removeUpdateButton(index);
	        return;
	      }
	
	      this.$timeout(function () {
	        $(".account-gradient-button.show-hide.item-number-" + index).addClass("show-hide-show");
	      });
	    }
	  }, {
	    key: "updateRoleModal",
	    value: function updateRoleModal() {}
	  }, {
	    key: "updateRole",
	    value: function updateRole(user, i) {
	      var _this23 = this;
	
	      this.setLoader();
	      var data = {};
	      var groupId = this.mapRoles(user.defaultUserRole);
	
	      data.userId = user.id;
	      data.groupId = groupId;
	
	      this.$companies.updateUserRoles(data).then(function (response) {
	        _this23.unSetLoader();
	        _this23.removeUpdateButton(i);
	        _this23.displaySuccessMessage(user);
	      }, function (error) {
	        alert("Error getting user roles - contact admin : " + error);
	        _this23.removeUpdateButton(i);
	        _this23.$timeout(function () {
	          _this23.unSetLoader();
	        }, 1000);
	      });
	    }
	  }, {
	    key: "displaySuccessMessage",
	    value: function displaySuccessMessage(user) {
	      this.$timeout(function () {
	        $("#modal-successful-role-add").modal();
	      });
	    }
	  }, {
	    key: "mapRoles",
	    value: function mapRoles(role) {
	      var id = void 0;
	
	      if (role === "Finance") {
	        this.userRollsAPI.forEach(function (r) {
	          //if (r.)
	          if (r.name === "GROUP_FINANCE") {
	            id = r.id;
	          }
	        });
	      } else if (role === "HR Manager") {
	        this.userRollsAPI.forEach(function (r) {
	          if (r.name === "GROUP_COMPANY_ADMIN") {
	            id = r.id;
	          }
	        });
	      } else if (role === "On Site Manager") {
	        this.userRollsAPI.forEach(function (r) {
	          if (r.name === "GROUP_ONSITE_MANAGER") {
	            id = r.id;
	          }
	        });
	      }
	
	      return id;
	    }
	  }, {
	    key: "mapRole",
	    value: function mapRole(role) {
	      var answer = void 0;
	
	      if (role === "GROUP_FINANCE") {
	        answer = "Finance";
	      } else if (role === "GROUP_COMPANY_ADMIN") {
	        answer = "HR Manager";
	      } else if (role === "GROUP_ONSITE_MANAGER") {
	        answer = "On Site Manager";
	      }
	
	      return answer;
	    }
	  }, {
	    key: "inviteUser",
	    value: function inviteUser(d) {
	
	      var _this = this;
	      var email = _this.newUserObj.email;
	
	      if (this.invitingUser === true) {
	        return;
	      }
	
	      this.invitingUser = true;
	
	      if (!email && !d) {
	        alert("Please provide an email to invite.");
	        return;
	      }
	
	      this.setLoader();
	
	      var data = {};
	      if (d) {
	        data.username = d.email;
	        data.group = {};
	        data.allowDifferentDomain = true;
	        data.group.id = d.invitationGroupId;
	      } else {
	        if (email) {
	          data.username = email;
	          data.group = {};
	          data.allowDifferentDomain = true;
	          if (this.defaultUserRole) {
	            if (this.defaultUserRole === "Finance") {
	              data.group.id = this.mapRoles("Finance");
	            } else if (this.defaultUserRole === "HR Manager") {
	              data.group.id = this.mapRoles("HR Manager");
	            } else if (this.defaultUserRole === "On Site Manager") {
	              data.group.id = this.mapRoles("On Site Manager");
	            }
	          }
	        } else {
	          console.err("Missing an email for invite");
	        }
	      }
	
	      console.log("invitation payload");
	      console.dir(data);
	
	      var req = {
	        method: "POST",
	        url: _this.$env.getAPIEndPoint() + "register/invite-user?format=json&conf=web?action=inviteUser",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.currentUser.access_token
	        },
	        data: data
	      };
	
	      this.$http(req).then(function (data) {
	        _this.unSetLoader();
	        _this.$timeout(function () {
	          _this.invitingUser = false;
	        }, 1000);
	        if (data.data.status === "success") {
	          _this.getPendingInvitations();
	          _this.$timeout(function () {
	            jQuery("#modal-add-user-confirm-modal .modal-header button.close").trigger("click");
	          }, 100);
	          _this.$timeout(function () {
	            jQuery("#modal-invite-user-confirm-modal").modal();
	          }, 500);
	        } else {
	          _this.handleAddingUserError(data);
	        }
	      }).catch(function (err) {
	        _this.$timeout(function () {
	          _this.invitingUser = false;
	        }, 1000);
	        _this.unSetLoader();
	        _this.handleAddingUserError(err);
	      });
	    }
	  }, {
	    key: "setBillingEmail",
	    value: function setBillingEmail(email, fromHtml) {
	      console.log("setBillingEmail");
	      console.dir(email);
	      console.dir(fromHtml);
	      if (fromHtml) {
	        this.companyDisplayData.billing_contact = email;
	      }
	    }
	  }, {
	    key: "getLogo",
	    value: function getLogo(token) {
	      var _this = this;
	
	      _this.setLoader();
	
	      if (token) {
	        _this.$auth.grab_company_logo(token).then(function (response) {
	          console.log("response from logo");
	          console.dir(response);
	          var logo = response.data.company.companyLogoUri;
	          if (logo) {
	            _this.currentUser.companyProfilePictureUrl = logo;
	            _this.determineImageDimensions(logo);
	          } else {
	            _this.currentUser.companyProfilePictureUrl = "/app/vendor/images/user-more.png";
	          }
	
	          _this.$timeout(function () {
	            _this.unSetLoader();
	          }, 300);
	        }, function (error) {
	          alert("There was an error getting company logo");
	          _this.unSetLoader();
	        });
	      }
	    }
	  }, {
	    key: "pullLatestPaymentInfo",
	    value: function pullLatestPaymentInfo(bankToRemove) {
	      var _this24 = this;
	
	      this.$profiles.getPaymentInfo().then(function (response) {
	        _this24.currentUser.company.undeletedPaymentInfos = response.data.company.undeletedPaymentInfos;
	        _this24.paymentInfos = response.data.company.undeletedPaymentInfos;
	        _this24.organizePaymentInfo(false, bankToRemove);
	        _this24.showPaymentInfo = true;
	        _this24.$timeout(function () {
	          _this24.unSetLoader();
	        }, 1500);
	      }, function (error) {
	        _this24.showPaymentInfo = true;
	        _this24.unSetLoader();
	        alert("Error loading users payment information : " + error.status);
	      });
	    }
	  }, {
	    key: "getUserNotficationPreferences",
	    value: function getUserNotficationPreferences() {
	      var _this25 = this;
	
	      this.setLoader();
	      this.$companies.getNotificationPreferences().then(function (response) {
	        _this25.unSetLoader();
	        console.log("response");
	        console.dir(response);
	        _this25.setNotificationSettings(response);
	      }, function (error) {
	        console.log("what is error");
	        console.dir(error);
	        _this25.unSetLoader();
	        alert("Error loading users payment information : " + error.status);
	      });
	    }
	  }, {
	    key: "createNotificationPreferences",
	    value: function createNotificationPreferences(data) {
	      var _this26 = this;
	
	      this.setLoader();
	      console.log("createNotificationPreferences");
	      console.dir(data);
	
	      this.$companies.createNotificationPreferences(data).then(function (response) {
	        _this26.unSetLoader();
	        console.log("response");
	        console.dir(response);
	      }, function (error) {
	        console.log("what is error");
	        console.dir(error);
	        _this26.unSetLoader();
	        alert("Error loading users payment information : " + error.status);
	      });
	    }
	  }, {
	    key: "createOrUpdateNotificationPreferences",
	    value: function createOrUpdateNotificationPreferences(data, item, displayMessageType) {
	      var _this27 = this;
	
	      this.setLoader();
	      this.notificationMessage = null;
	      this.specificMessage = null;
	
	      this.$companies.createOrUpdateNotificationPreferences(data).then(function (response) {
	        _this27.unSetLoader();
	        _this27.displayModalNotificationCenter("success", data, item, displayMessageType);
	        //console.log("response");
	        //console.dir(response);
	      }, function (error) {
	        //console.log("what is error");
	        //console.dir(error);
	        _this27.displayModalNotificationCenter("error", data, item, displayMessageType);
	        _this27.unSetLoader();
	        alert("Error loading users payment information : " + error.status);
	      });
	    }
	  }, {
	    key: "displayModalNotificationCenter",
	    value: function displayModalNotificationCenter(type, data, item, displayMessageType) {
	
	      var message = void 0;
	      var specificMessage = void 0;
	      var bodyText = void 0;
	
	      if (type === "success") {
	        specificMessage = this.determineSpecificMessage("success", item);
	        if (displayMessageType) {
	          message = "Your notification settings were successfully updated";
	          bodyText = "The following notifications have been activated for your account:";
	        } else {
	          message = "Your notification settings were successfully updated";
	          bodyText = "The following notifications have been deactivated for your account:";
	        }
	      } else {
	        message = "There was an issue with saving your notification settings";
	        specificMessage = this.determineSpecificMessage("error", item);
	      }
	
	      this.$timeout(function () {
	        $("#notification-center-modal").modal();
	      }, 200);
	
	      this.specificMessage = specificMessage;
	      this.notificationMessage = message;
	      this.notificationBodyText = bodyText;
	    }
	  }, {
	    key: "determineSpecificMessage",
	    value: function determineSpecificMessage(type, item, _determineSpecificMessage) {
	      console.log("determineSpecificMessage");
	      console.dir(item);
	      var n = [];
	
	      if (type === "success") {
	        item.sub_fields.forEach(function (x) {
	          n.push(x.description);
	        });
	      } else {
	        n.push("There was an error");
	      }
	
	      return n;
	    }
	  }, {
	    key: "closeNotificationModal",
	    value: function closeNotificationModal() {
	      this.$timeout(function () {
	        $("#notification-center-modal").modal("toggle");
	      });
	    }
	  }, {
	    key: "setNotificationSettings",
	    value: function setNotificationSettings(settings) {
	      console.log("setNotificationSettings");
	      console.dir(settings);
	      var s = settings.data;
	      try {
	        this.notificationCenter.forEach(function (item) {
	          console.log("each item");
	          console.dir(item);
	          if (item.title === "Roster") {
	            if (s.roster === true) {
	              item.activated = true;
	            }
	          }
	          if (item.title === "Job Status") {
	            if (s.jobStatus === true) {
	              item.activated = true;
	            }
	          }
	          if (item.title === "Live Job Updates") {
	            if (s.liveJob === true) {
	              item.activated = true;
	            }
	          }
	          if (item.title === "Billing") {
	            if (s.billing === true) {
	              item.activated = true;
	            }
	          }
	        });
	      } catch (err) {
	        console.log("looping error");
	        console.dir(err);
	      } finally {
	        console.log("in the finally");
	        console.dir(this.notificationCenter);
	      }
	    }
	  }, {
	    key: "setAllAsClickedAndUpdate",
	    value: function setAllAsClickedAndUpdate(item) {
	
	      if (item.activated === true) {
	        item.activated = false;
	      } else {
	        item.activated = true;
	      }
	
	      var displayMessageType = item.activated;
	
	      var data = {};
	
	      this.notificationCenter.forEach(function (item) {
	        if (item.activated) {
	          if (item.title === "Roster") {
	            data.roster = true;
	          }
	          if (item.title === "Job Status") {
	            data.jobStatus = true;
	          }
	          if (item.title === "Live Job Updates") {
	            data.liveJob = true;
	          }
	          if (item.title === "Billing") {
	            data.billing = true;
	          }
	        } else {
	          if (item.title === "Roster") {
	            data.roster = false;
	          }
	          if (item.title === "Job Status") {
	            data.jobStatus = false;
	          }
	          if (item.title === "Live Job Updates") {
	            data.liveJob = false;
	          }
	          if (item.title === "Billing") {
	            data.billing = false;
	          }
	        }
	      });
	
	      this.createOrUpdateNotificationPreferences(data, item, displayMessageType);
	    }
	  }, {
	    key: "companyProfileText",
	    value: function companyProfileText() {
	
	      var text = void 0;
	
	      if (!this.currentUser) {
	        return;
	      }
	
	      if (this.currentUser.firstName) {
	        text = this.currentUser.firstName;
	      }
	
	      if (this.currentUser.lastName) {
	        text += " " + this.currentUser.lastName + ",";
	      }
	
	      text = text + " " + this.currentUser.username;
	
	      return text;
	    }
	  }, {
	    key: "updatePassword",
	    value: function updatePassword() {
	      var _this28 = this;
	
	      var _this = this;
	      this.setLoader();
	      var payload = {};
	      var userId = this.currentUser.id;
	      payload.currentPassword = this.passwordData.currentPassword;
	      payload.newPassword = this.passwordData.newPassword;
	      payload.confirmNewPassword = this.passwordData.confirmNewPassword;
	      this.updatePasswordFormInvalid = true;
	      this.$profiles.updatePassword(payload, userId).then(function (response) {
	        _this28.updatePasswordModal(false);
	        _this28.handleUpdatePasswordResponse(response);
	        _this28.unSetLoader();
	      }, function (error) {
	        _this.unSetLoader();
	        _this.passNotMatching = false;
	        alert(error.data.message);
	      });
	    }
	  }, {
	    key: "handleUpdatePasswordResponse",
	    value: function handleUpdatePasswordResponse(response) {
	      this.$timeout(function () {
	        $("#update-password-confirm").modal();
	      }, 500);
	    }
	  }, {
	    key: "validateNewPassword",
	    value: function validateNewPassword() {
	      var result = false;
	      if (this.passwordData && this.passwordData.newPassword) {
	        if (/\d/.test(this.passwordData.newPassword)) {
	          result = true;
	        } else {
	          result = false;
	        }
	      }
	      return result;
	    }
	  }, {
	    key: "updatePasswordModal",
	    value: function updatePasswordModal(open) {
	      this.passwordData = {};
	      if (open === true) {
	        this.passNotMatching = false;
	        this.setFocusOnFirstInput();
	        this.updatePasswordFormInvalid = true;
	        this.$timeout(function () {
	          $("#update-password").modal();
	        }, 100);
	      } else {
	        this.$timeout(function () {
	          $("#update-password").modal("toggle");
	        });
	      }
	    }
	  }, {
	    key: "setFocusOnFirstInput",
	    value: function setFocusOnFirstInput() {
	      this.$timeout(function () {
	        $(".popup input[type='password'].current-password").focus();
	      }, 600);
	    }
	  }, {
	    key: "validateNewPasswordConfirmation",
	    value: function validateNewPasswordConfirmation() {
	      if (this.passwordData && this.passwordData.newPassword && this.passwordData.confirmNewPassword) {
	        if (this.passwordData.newPassword.length > 7 && /\d/.test(this.passwordData.newPassword)) {
	          if (this.passwordData.newPassword === this.passwordData.confirmNewPassword) {
	            this.passNotMatching = false;
	            this.updatePasswordFormInvalid = false;
	          } else {
	            if (this.passwordData.confirmNewPassword.length > 6) {
	              this.passNotMatching = true;
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: "logUserOut",
	    value: function logUserOut() {
	      var _this29 = this;
	
	      this.$timeout(function () {
	        _this29.$state.go("signin", { onRefresh: true });
	      }, 300);
	    }
	  }]);
	
	  return AccountprofileController;
	}();
	
	AccountprofileController.$inject = ["$http", "$localStorage", "$state", "$stateParams", "auth", "companies", "signup.validator", "security", "$timeout", "$rootScope", "env", "ngProgressFactory", "$scope", "$location", "profile"];
	
	exports.default = AccountprofileController;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(640);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./accountprofile.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./accountprofile.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".accountprofile{color:red}", ""]);
	
	// exports


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(642);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".account-profile-container{padding:24px;margin-bottom:15px;font-size:14px}.account-profile-container,.account-profile-sidebar{background-color:#fff;border:1px solid #adbcc2;border-radius:6px;font-family:Poppins,sans-serif}.account-profile-sidebar{padding:0;font-weight:600;font-size:12px;text-transform:uppercase;overflow:hidden;margin-bottom:24px}.account-profile-sidebar li{height:50px;line-height:50px;padding-left:16px;border-bottom:1px solid #adbcc2}.account-profile-sidebar li:last-child{border-bottom:none}.account-profile-sidebar li a{color:#5e666d;width:100%;display:block}.account-profile-sidebar li i{margin-right:14px;font-size:16px}.account-profile-sidebar li.selected-sidebar{border-left:4px solid #62c046}.account-modal-content input,.account-modal-content select,.account-profile-container input{height:40px;line-height:40px;border:1px solid #767676;box-shadow:0 2px 4px 0 rgba(0,0,0,.1);border-radius:2px;font-family:Poppins,sans-serif;font-size:14px}.account-modal-content input,.account-modal-content select{margin-top:8px}.account-profile-container input[type=checkbox]{box-shadow:none;width:16px;line-height:18px;height:18px}.account-profile-container textarea{box-shadow:0 2px 4px 0 rgba(0,0,0,.1);width:100%;height:156px;border:1px solid #767676;border-radius:2px;background-color:#fff;font-size:14px;padding:16px;line-height:21px;margin-top:16px;resize:none}.account-profile-container .main-text-area-length{text-align:right;font-size:12px;line-height:18px;margin-top:8px}.text-header{font-size:18px;font-weight:600;margin-bottom:16px}.text-subheader{background-color:#d0dbe066;padding:5px;margin-bottom:15px;font-size:15.5px;font-weight:700;margin-top:24px;border-radius:5px}.text{font-size:14px;line-height:21px}.company-logo-edit{padding-top:0;margin-top:16px}.company-logo-edit a{color:#33373a;font-size:12px;font-weight:600}.company-logo-edit a i{margin-right:2px}.input-label{font-size:14px;margin-top:16px;font-weight:600}.account-gradient-button{background:linear-gradient(225deg,#5498b4,#62c046);border-radius:6px;height:46px;line-height:46px;padding:0 24px;width:fit-content;font-size:14px;font-weight:600;color:#fff;cursor:pointer;letter-spacing:.25px;margin-top:24px;border:none}.account-gradient-button.disabled,.account-gradient-button:disabled{background:linear-gradient(270deg,#bbe9ad,#b0ddee)}.account-gradient-button:disabled{opacity:.5}.account-outline-button{background:#fff;border-radius:6px;height:46px;line-height:46px;padding:0 24px;width:fit-content;font-size:14px;font-weight:600;color:#767676;cursor:pointer;letter-spacing:.25px;margin-top:24px;border:1px solid #767676}.credit-card{height:70px;line-height:70px;padding:0 16px;border:1px solid #979797;border-radius:6px;background-color:#fff;width:298px;font-size:12px;margin-top:16px;margin-bottom:16px}.credit-card-logo{font-size:22px;flex:0 0 38px}.credit-card-number{flex:0 0 132px}.credit-card-exp{flex:0 0 84px}.add-another-card{color:#5498b4;padding:5px 10px;border-radius:5px;font-size:14px;font-weight:200;border:1px solid #5498b4}.add-another-card:hover{border:1px solid #5498b4;color:#fff;background-color:#5498b4}.bank-account{height:70px;padding:0 16px;background-color:#fff;font-size:12px;margin-top:16px;margin-bottom:16px}.bank-account,.payment-table-users-to-pay{border:1px solid #979797;border-radius:6px}.payment-table-users-to-pay{max-height:200px;overflow-y:scroll}.payment-height-2{max-height:300px}.payment-height-3{max-height:500px}.bank-name{margin-top:14px}.bank-verify{margin-top:23px;text-align:right;padding-right:22px}.bank-delete-container{line-height:70px}.account-modal-content{font-family:Poppins,sans-serif;color:#33373a;text-align:left}.modal-gradient-bar{left:0;top:0;height:6px;width:100%;margin-bottom:24px;border-radius:6px 6px 0 0;background:linear-gradient(116.57deg,#62c046,#5498b4)}.account-modal-content .modal-body,.account-modal-content .modal-header{padding:0 24px;border-bottom:none}.account-modal-content .modal-body{padding-bottom:24px}.account-modal-content .modal-title{text-align:left;font-size:18px;font-weight:700;color:#33373a}.account-modal-content .modal-text{text-align:left;font-size:14px;line-height:21px;margin-top:8px}.account-modal-content .close{top:22px;right:16px;color:#33373a;font-size:18px}.on-column{flex:0 0 36px;padding-right:16px}.off-column{flex:0 0 21px}.add-do-not-hire{color:#62c046;font-size:14px;font-weight:600;margin-top:24px;cursor:pointer}.add-do-not-hire i{margin-right:7px}.notification-wrapper{width:100%;border:1px solid #eee;font-family:Poppins;border-top-left-radius:5px;border-top-right-radius:5px;margin-bottom:15px}.account-profile-container .notification-wrapper input[type=checkbox]{box-shadow:none;line-height:0;height:15px;position:absolute;left:13px;top:12px}.account-profile-container .notification-wrapper input[type=checkbox]:hover{cursor:pointer}.notification-wrapper .notificiation-header{width:100%;background-color:#d0dbe066;padding:10px 5px 10px 45px;margin-bottom:7px;font-size:15.5px;border-top-left-radius:5px;border-top-right-radius:5px;font-weight:700;position:relative}.notification-wrapper .notificiation-body{width:100%;border:1px solid #eee;border-top:none;border-bottom:none;padding-bottom:10px}.notification-wrapper .notificiation-body .notification-item{border-bottom:1px solid #eee;padding-top:5px;padding-bottom:5px;padding-left:45px;position:relative}.notification-wrapper .notificiation-body .notification-item .noti-off{position:absolute;left:11px;top:21px;opacity:.2;font-size:17px}.notification-wrapper .notificiation-body .notification-item .noti-on{position:absolute;left:16px;top:23px;opacity:1;font-size:12px;color:#85dc00;text-shadow:0 0 10px #3acb0091,0 0 20px #fff}.notification-wrapper .notificiation-body .notification-item:last-child{border-bottom:none}.notification-item-title{font-weight:800}.notification-item-desc{padding-left:0;font-size:13px}#notification-center-modal ul li{list-style-type:disc;margin-left:30px;font-weight:800}", ""]);
	
	// exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _directpay = __webpack_require__(644);
	
	var _directpay2 = _interopRequireDefault(_directpay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var directpayModule = _angular2.default.module("directpay", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("directpay", {
	    url: "/direct-pay",
	    template: "<directpay></directpay>",
	    title: "Direct Pay"
	  }).state("bulkpay", {
	    url: "/bulk-pay",
	    template: "<directpay></directpay>",
	    title: "Bulk Pay"
	  });
	}).component("directpay", _directpay2.default);
	
	exports.default = directpayModule;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directpay = __webpack_require__(645);
	
	var _directpay2 = _interopRequireDefault(_directpay);
	
	var _directpay3 = __webpack_require__(646);
	
	var _directpay4 = _interopRequireDefault(_directpay3);
	
	__webpack_require__(647);
	
	__webpack_require__(649);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var directpayComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _directpay2.default,
	  controller: _directpay4.default,
	  controllerAs: "vm"
	};
	
	exports.default = directpayComponent;

/***/ }),
/* 645 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n<div id=\"wrapper\">\n    <section class=\"job-container\">\n        <div class=\"container\">\n            <div class=\"row\">\n                <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\">\n                    <div class=\"payment-sidebar\">\n                        <ul>\n                            <li\n                                    ng-repeat=\"option in vm.navOptions\"\n                                    class=\"{{ option.isActive }}\"\n                                    ng-click=\"vm.navigateDirectPay(option.type)\">\n                                <a href=\"\">\n                                    <i class=\"{{option.icon}}\"></i> {{option.value}}\n                                </a>\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n                <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\" ng-if=\"!vm.currentUser.company.isVerified\">\n                    <div class=\"job-content\">\n                        <div class=\"alert-box alert\">\n                            Your company is currently under review.\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\" ng-if=\"vm.currentUser.company.isVerified\">\n\n                    <div class=\"payment-pay-container\" ng-if=\"vm.page=='directpay'\">\n                        <div class=\"\">\n\n\n                            <div class=\"text-header\">Direct Pay</div>\n                            <div class=\"text\">Pay any Jobbler using their email address.</div>\n\n\n                            <!-- class=\"dp-form\" -->\n                            <div class=\"\">\n                                <div class=\"\">\n                                    <form name=\"directPayForm\" ng-submit=\"vm.directPayJobbler(directPayForm)\"\n                                          novalidate>\n                                        <div class=\"\">\n                                            <div class=\"\">\n\n                                                <div class=\"input-label\">Jobbler email address</div>\n                                                <input\n                                                        type=\"email\"\n                                                        class=\"form-input\"\n                                                        ng-model=\"vm.payJobblerInfo.email\"\n                                                        name=\"email\"\n                                                        required\n                                                        ng-change=\"vm.validateDirectPayEmail()\"\n                                                        ng-class=\"{ 'has-error' : vm.error_with_email == true, 'correct-email-input' : vm.successfulEmail == true  }\"\n                                                        ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }\"\n                                                />\n                                                <div class=\"error-message-for-direct-pay\" ng-if=\"vm.error_with_email\">\n                                                    This user does not have a Jobble account.\n                                                </div>\n\n                                            </div>\n                                        </div>\n                                        <div class=\"\">\n\n                                            <div class=\"\">\n                                                <div class=\"input-label\">Payment Amount</div>\n                                                <input\n                                                        type=\"number\"\n                                                        class=\"form-input\"\n                                                        ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\"\n                                                        ng-model=\"vm.payJobblerInfo.amount\"\n                                                        min=\"0\"\n                                                        step=\"0.01\"\n                                                        required\n                                                        ng-focus=\"vm.checkUserPaymentInfo()\"\n                                                        ng-change=\"vm.setCompanyCharge()\"\n                                                        name=\"amount\"\n                                                        ng-class=\"{ 'has-error' : directPayForm.amount.$invalid && !directPayForm.amount.$pristine, 'correct-email-input' : directPayForm.amount.$valid }\"\n                                                        ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }\"\n                                                />\n                                            </div>\n\n                                            <div class=\"\">\n                                                <div class=\"\">\n                                                    <div class=\"input-label\">Payment Memo</div>\n                                                    <input ng-class=\"{ 'has-error' : vm.error_with_note == true }\"\n                                                           ng-change=\"vm.validateDirectPayNotes()\" class=\"form-input\"\n                                                           ng-model=\"vm.payJobblerInfo.noteForReceipt\"/>\n                                                    <div class=\"error-message-for-direct-pay\"\n                                                         ng-if=\"vm.error_with_note\">\n                                                        The note can be no longer than 100 characters.\n                                                    </div>\n                                                </div>\n                                            </div>\n                                            <div class=\"\" style=\"display: none\">\n                                                <div class=\"amount-preview\">\n                                                    <p ng-if=\"!vm.payJobblerInfo.amount\" style=\"margin-bottom: 6px;\">\n                                                        <strong>You will be charged:</strong> $0.00\n                                                    </p>\n\n                                                    <p ng-if=\"!vm.payJobblerInfo.amount\">\n                                                        <strong>The jobbler will receive:</strong> $0.00\n                                                    </p>\n\n                                                    <p ng-if=\"vm.payJobblerInfo.amount\" style=\"margin-bottom: 6px;\">\n                                                        <strong>You will be charged:</strong> ${{\n                                                        vm.payJobblerInfo.amount * (1 +\n                                                        vm.currentUser.company.defaultPlan.companyFeePct)| number : 2 }}\n                                                    </p>\n\n                                                    <p ng-if=\"vm.payJobblerInfo.amount\">\n                                                        <strong>The jobbler will receive:</strong> ${{\n                                                        vm.payJobblerInfo.amount * (1 -\n                                                        vm.currentUser.company.defaultPlan.jobblerFeePct) | number : 2\n                                                        }}\n                                                    </p>\n                                                </div>\n                                                <div class=\"alert alert-info\" role=\"alert\"\n                                                     ng-show=\"vm.directPayForm.amount.$invalid\">\n                                                    <strong>Heads up!</strong> Make sure your payment is no more than\n                                                    two decimal places!\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"table-responsive respons-job\"\n                                             ng-show=\"!vm.currentUser.company.payByInvoice && !vm.currentUser.company.enableSubscription\">\n                                            <div class=\"input-label\" style=\"margin-bottom: 8px\">Payment method</div>\n\n                                            <div ng-hide=\"vm.currentUser.company.payByInvoice\">\n                                                <div ng-repeat=\"paymentMethod in vm.paymentMethodsFormatted\"\n                                                     style=\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-bottom: 8px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding: 12px 10px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tborder: 1px solid #979797;\"\n                                                >\n                                                    <div style=\"flex: 0 0 25px\">\n                                                        <input type=\"checkbox\"\n                                                               ng-click=\"vm.selectPaymentMethod(paymentMethod)\"\n                                                               ng-model=\"paymentMethod.isChecked\"/>\n                                                    </div>\n                                                    <div style=\"flex: 0.75\">{{paymentMethod.displayName ?\n                                                        paymentMethod.displayName : \"--\"}}\n                                                    </div>\n                                                    <div style=\"flex: 0.75\" ng-if=\"paymentMethod.bankName == null\">Exp.\n                                                        {{paymentMethod.displayExpires}}\n                                                    </div>\n                                                    <div style=\"flex: 1\">xxxx xxxx xxxx {{paymentMethod.displayLast4}}\n                                                    </div>\n                                                    <div style=\"flex: 0 0 60px; text-align: right\">\n                                                        <i class=\"{{ paymentMethod.image }}\"\n                                                           style=\"font-size: 24px\"></i>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                        <div\n                                                style=\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-top: 12px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding: 14px 24px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding-bottom: 24px;\n\t\t\t\t\t\t\t\t\t\t\t\t\tborder: 1px solid #979797;\n\t\t\t\t\t\t\t\t\t\t\t\t\"\n                                        >\n                                            <div style=\"display: flex\">\n                                                <div style=\"font-size: 16px; font-weight: 600; margin-left: -9px; flex: 0 0 26px\">\n                                                    <i class=\"fas fa-receipt\"></i>\n                                                </div>\n                                                <div style=\"font-size: 16px; font-weight: 600; flex: 1\">Payment\n                                                    summary\n                                                </div>\n                                            </div>\n\n                                            <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\"/>\n\n                                            <div style=\"display: flex\">\n                                                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600\">\n                                                    Jobbler payments\n                                                </div>\n\n                                                <div style=\"flex: 1; text-align: right\">${{vm.payJobblerInfo.amount || 0\n                                                    | number : 2}}\n                                                </div>\n                                            </div>\n\n                                            <div style=\"display: flex\">\n                                                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600; margin-top: 8px\">\n                                                    + Platform fee\n                                                </div>\n\n                                                <div style=\"flex: 1; text-align: right; margin-top: 8px\">\n                                                    ${{ vm.payJobblerInfo.platformFee || 0 | number: 2}}\n                                                </div>\n                                            </div>\n\n                                            <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\"/>\n\n                                            <div style=\"display: flex\">\n                                                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600\">\n                                                    Total billed to your account\n                                                </div>\n                                                <div style=\"flex: 1; text-align: right; font-weight: 600\">\n                                                    ${{vm.payJobblerInfo.companyAmount || 0 | number : 2 }}\n                                                </div>\n                                            </div>\n                                        </div>\n\n\n                                        <div class=\"\">\n                                            <div class=\"\">\n                                                <input\n                                                        type=\"submit\"\n                                                        ng-disabled=\"directPayForm.$invalid || !vm.successfulEmail || !vm.selectedPaymentMethod || vm.error_with_note == true\"\n                                                        class=\"gradient-button\"\n                                                        value=\"Submit Payment\"\n                                                />\n                                                <p\n                                                        ng-if=\"vm.paymentError\"\n                                                        class=\"payment-error-new\">\n                                                    {{ vm.paymentMessage }}\n                                                </p>\n                                            </div>\n                                        </div>\n\n\n                                    </form>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n\n                    <div class=\"payment-pay-container\" ng-if=\"vm.page=='bulkpay'\">\n                        <div class=\"\">\n                            <div class=\"table-responsive respons-job\">\n\n\n                                <div class=\"text-header\">Bulk Payment</div>\n                                <div class=\"text\">\n                                    Bulk pay a list of jobblers from a spreadsheet. Upload a CSV with the appropriate\n                                    column headers (\"Email\", \"Note\", \"Amount\") to pay in bulk.\n                                </div>\n\n                                <div href=\"#\" ng-click=\"vm.showExampleCSV(1)\" ng-show=\"vm.show\"\n                                     class=\"example-csv-link\">View Example CSV\n                                </div>\n                                <div href=\"#\" ng-click=\"vm.showExampleCSV(2)\" ng-show=\"!vm.show\"\n                                     class=\"example-csv-link\">Hide Example CSV\n                                </div>\n\n                                <img src=\"/app/vendor/images/example-csv.png\" ng-show=\"!vm.show\" class=\"example-csv\"/>\n\n                                <div class=\"alert-box alert\" ng-show=\"vm.csv_error\"\n                                     style=\"margin-bottom:0px;margin-top: 15px;opacity: .4;\">{{ vm.csv_error.text }}\n                                </div>\n\n                                <form class=\"bulk-users-form\" ng-if=\"!vm.sheet || vm.csv_error\" style=\"margin-top:0px;\">\n                                    <input class=\"hidden-inputfile\" type=\"file\" name=\"bulk-file\" id=\"bulk-file\"\n                                           import-sheet-js=\"\" on-sheet-load=\"vm.loadWorksheet(e)\" multiple=\"false\"/>\n                                    <label class=\"gradient-button\" for=\"bulk-file\"\n                                           style=\"color: #fff;padding-top: 12px;padding-left: 14px;\">Choose a\n                                        file</label>\n                                </form>\n\n                                <div style=\"text-align: right\">\n                                    <div ng-click=\"vm.clearBulkPay()\" ng-if=\"vm.sheet\" class=\"account-outline-button\"\n                                         style=\"display: inline-block;margin-top: 8px;padding: 0 16px;margin-bottom: 8px;\">\n                                        Clear\n                                    </div>\n                                </div>\n\n                                <div ng-if=\"vm.sheet\" ng-hide=\"vm.csv_error\">\n                                    <div style=\"padding: 0 16px; padding-left: 8px\">\n                                        <div style=\"margin-bottom: 0px\">\n                                            <div style=\"display: flex; font-weight: 500; font-size: 15px; margin-bottom: 8px; text-transform: uppercase\">\n                                                <div style=\"flex: 1\">Email</div>\n                                                <!--\n                                                <div style=\"flex: 0.5\">Note</div>\n                                                -->\n                                                <div style=\"flex: 0.5\">Amount</div>\n                                            </div>\n                                        </div>\n                                    </div>\n\n                                    <div style=\"border: 1px solid #979797; border-radius: 6px; max-height: 200px; overflow-y: scroll\">\n                                        <div ng-repeat=\"row in vm.sheet track by $index\">\n                                            <div style=\"display: flex; height: 50px; line-height: 50px; font-weight: 500; font-size: 13px; padding: 0 8px; border-bottom: {{$index === vm.sheet.length - 1 ? 'none' : '1px solid rgba(151,151,151,0.5)'}}\">\n                                                <div style=\"flex: 1\">{{row.Email}}</div>\n                                                <!--\n                                                <div style=\"flex: 0.5\">{{row.Note ? row.Note : \"---\"}}</div>\n                                                -->\n                                                <div style=\"flex: 0.5\">${{row.Amount | number : 2}}</div>\n                                            </div>\n\n                                        </div>\n                                    </div>\n\n                                </div>\n\n\n                                <div class=\"input-label\" ng-show=\"!vm.currentUser.company.payByInvoice\"\n                                     style=\"margin-bottom: 8px\">Payment method\n                                </div>\n\n                                <div ng-hide=\"vm.currentUser.company.payByInvoice\">\n                                    <div ng-repeat=\"paymentMethod in vm.paymentMethodsFormatted\"\n                                         style=\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-bottom: 8px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tpadding: 12px 10px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tborder: 1px solid #979797;\"\n                                    >\n                                        <div style=\"flex: 0 0 25px\">\n                                            <input type=\"checkbox\" ng-click=\"vm.selectPaymentMethod(paymentMethod)\"\n                                                   ng-model=\"paymentMethod.isChecked\"/>\n                                        </div>\n                                        <div style=\"flex: 0.75\">{{paymentMethod.displayName ? paymentMethod.displayName\n                                            : \"--\"}}\n                                        </div>\n                                        <div style=\"flex: 0.75\" ng-if=\"paymentMethod.bankName == null\">Exp.\n                                            {{paymentMethod.displayExpires}}\n                                        </div>\n                                        <div style=\"flex: 1\">xxxx xxxx xxxx {{paymentMethod.displayLast4}}</div>\n                                        <div style=\"flex: 0 0 60px; text-align: right\">\n                                            <i class=\"{{ paymentMethod.image }}\" style=\"font-size: 24px\"></i>\n                                        </div>\n                                    </div>\n                                </div>\n\n                                <div\n                                        style=\"\n\t\t\t\t\t\tmargin-top: 12px;\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\t\tpadding: 14px 24px;\n\t\t\t\t\t\tpadding-bottom: 24px;\n\t\t\t\t\t\tborder: 1px solid #979797;\n\t\t\t\t\t\"\n                                        ng-if=\"vm.sheet\" ng-hide=\"vm.csv_error\"\n                                >\n                                    <div style=\"display: flex\">\n                                        <div style=\"font-size: 16px; font-weight: 600; margin-left: -9px; flex: 0 0 26px\">\n                                            <i class=\"fas fa-receipt\"></i>\n                                        </div>\n                                        <div style=\"font-size: 16px; font-weight: 600; flex: 1\">Payment summary</div>\n                                    </div>\n\n                                    <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\"/>\n\n                                    <div style=\"display: flex\">\n                                        <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600\">\n                                            Jobblers ( {{vm.sheet.length}} )\n                                        </div>\n\n                                        <div style=\"flex: 1; text-align: right\">\n                                            {{ vm.bulk_pay_data.total }}\n                                        </div>\n                                    </div>\n\n                                    <div style=\"display: flex\">\n                                        <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600; margin-top: 8px\">\n                                            + Platform fee\n                                        </div>\n\n                                        <div style=\"flex: 1; text-align: right; margin-top: 8px\">\n                                            ${{ vm.bulk_pay_data.fee }}\n                                        </div>\n                                    </div>\n\n                                    <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\"/>\n\n                                    <div style=\"display: flex\">\n                                        <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600\">\n                                            Total billed to your account\n                                        </div>\n                                        <div style=\"flex: 0.5; text-align: right; font-weight: 600\">\n                                            {{ vm.showBulkPayTotal() }}\n                                        </div>\n                                    </div>\n                                </div>\n\n\n                                <div class=\"bulk-pay-table-holder-totals\" ng-if=\"vm.sheet\" ng-hide=\"vm.csv_error\">\n                                    <div class=\"gradient-button\" ng-click=\"vm.submitBulkPayToggle()\">\n                                        Make Bulk Payment\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n\n            </div>\n\n            <div class=\"row\" style=\"padding-top: 20px;\" ng-if=\"vm.currentUser.company.isVerified\">\n\n                <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"></div>\n\n                <div class=\"col-lg-9 col-md-12 col-sm-9 col-xs-9\" ng-if=\"vm.loading_invoices\"\n                     style=\"text-align:center;\">\n\n                    <div class=\"job-content\">\n                        <div class=\"job-table table-responsive respons-job\"\n                             style=\"background-color:#fff;border:1px solid #d5dcde;padding-bottom: 15px;\">\n\n                            <p style=\"margin-bottom:10px;margin-top:15px;font-size:18px;text-decoration:underline;\">\n                                Loading Payment Feed\n                            </p>\n\n                            <i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i>\n\n                        </div>\n                    </div>\n\n                </div>\n\n                <div class=\"col-lg-9 col-md-9 col-sm-9 col-xs-9\" ng-if=\"!vm.loading_invoices\">\n\n\n                    <div class=\"payment-pay-container\">\n                        <div class=\"table-responsive respons-job direct-pay-receipt-table\">\n\n                            <div class=\"text-header\">Payment Feed</div>\n\n                            <table class=\"table table-border line-item-table table-responsive\">\n                                <thead>\n                                <tr>\n                                    <th>Date</th>\n                                    <th>Jobbler</th>\n                                    <th>Email</th>\n                                    <th>Details</th>\n                                    <th>Charge</th>\n                                    <th>Invoice</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr ng-repeat=\"paymentReceipt in vm.directPaymentReceiptList\">\n                                    <td>{{ vm.formatRecDate(paymentReceipt.dateCreated) }}</td>\n                                    <td>{{ paymentReceipt.payedUser[0].firstName }} {{\n                                        paymentReceipt.payedUser[0].lastName }}\n                                    </td>\n                                    <td>{{ paymentReceipt.payedUser[0].email }}</td>\n                                    <td>{{ paymentReceipt.payment[0].detailTransactionCompany }}</td>\n                                    <td>${{ paymentReceipt.payment[0].amountCompany / 100 | number : 2 }}</td>\n\n                                    <td>\n                                        <a href=\"/invoice/{{paymentReceipt.payment[0].id}}?dp=t\" target=\"_blank\">\n                                            View Receipt\n                                        </a>\n\n                                    </td>\n                                </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n\n                    <div>\n                        <ul ng-if=\"vm.pages.length > 1\" class=\"pagination event-pagination\"\n                            style=\"width: 100%;display:inline-block;margin-top:-10px;\">\n                            <li\n                                    style=\"margin-top:20px;\"\n                                    class=\"arrow unavailable\"\n                                    ng-disabled=\"vm.currentPageNumber == 1\"\n                                    ng-click=\"vm.paginate(vm.currentPageNumber - 1)\">\n                                <a href=\"\">&#xab;</a>\n                            </li>\n                            <li\n                                    style=\"margin-top:20px;\"\n                                    ng-repeat=\"page in vm.pages\"\n                                    ng-click=\"vm.paginate(page)\" ng-class=\"{'active': vm.currentPageNumber == page}\">\n                                <a href=\"\">{{page}}</a>\n                            </li>\n                            <li\n                                    style=\"margin-top:20px;\"\n                                    class=\"arrow\"\n                                    ng-disabled=\"vm.currentPageNumber == vm.pages.length\"\n                                    ng-click=\"vm.paginate(vm.currentPageNumber + 1)\">\n                                <a href=\"\">&#xbb;</a>\n                            </li>\n                        </ul>\n\n\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-if=\"vm.paginating\"\n                             style=\"text-align:center;\">\n                            <i class=\"fa fa-cog fa-spin fa-1x fa-fw\"></i>\n                        </div>\n\n\n                    </div>\n\n                </div>\n            </div>\n\n        </div>\n    </section>\n</div>\n\n\n<jobblefooter></jobblefooter>\n<globalalert></globalalert>\n\n\n<loader ng-if=\"vm.remain_loading_count == 5\"></loader>\n\n<paymentdialog></paymentdialog>\n\n<div class=\"modal fade\" id=\"modal-pay-jobbler\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span\n                                aria-hidden=\"true\">&times;</span></button>\n                        <strong>Continue with direct payment?</strong>\n                        <div class=\"alert-box alert\" ng-if=\"vm.hireJobblerResult.status === 'error'\">\n                            {{vm.hireJobblerResult.message}}\n                        </div>\n                    </div>\n                    <div class=\"modal-body\">\n                        <a class=\"btn\" href=\"\" ng-click=\"vm.directPayJobbler()\">Confirm</a>\n                        <a class=\"btn\" href=\"\" ng-click=\"vm.cancelFireJobblers()\">No</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<a href=\"#modal-card-error-modal\" data-toggle=\"modal\" id=\"modal-card-error\"></a>\n<div class=\"modal fade\" id=\"modal-card-error-modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\" style=\"width: 456px;\">\n                <div class=\"modal-content account-modal-content\">\n                    <div class=\"modal-gradient-bar\"></div>\n                    <div class=\"modal-header\" ng-if=\"!vm.isInvalidUser\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fas fa-times\"></i>\n                        </button>\n                        <div class=\"modal-title\">{{ vm.paymentMessage }}</div>\n                    </div>\n                    <div class=\"modal-header\" ng-if=\"vm.isInvalidUser\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fas fa-times\"></i>\n                        </button>\n                        <div class=\"modal-title\" ng-if=\"vm.isInvalidUser\"\n                             style=\"background-color:#961106;border-radius: 5px;padding: 10px;color: #fff;\">{{\n                            vm.paymentMessage }}\n                        </div>\n                        <div class=\"modal-title\" ng-if=\"!vm.isInvalidUser\"\n                             style=\"background-color:#6ED053;border-radius: 5px;padding: 10px;color: #fff;\">{{\n                            vm.paymentMessage }}\n                        </div>\n                    </div>\n                    <div class=\"modal-body\" ng-if=\"!vm.isInvalidUser\">\n                        <p>{{ vm.messageForModal }}</p>\n                        <div class=\"account-gradient-button\" href=\"\" data-dismiss=\"modal\"\n                             style=\"width: 100%; text-align: center\">Close\n                        </div>\n                    </div>\n                    <div class=\"modal-body\" ng-if=\"vm.isInvalidUser\">\n                        <div class=\"account-gradient-button\" href=\"\" data-dismiss=\"modal\"\n                             style=\"width: 100%; text-align: center\">Close\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n<a href=\"#modal-card-declined-modal\" data-toggle=\"modal\" id=\"modal-card-declined\"></a>\n<div class=\"modal fade\" id=\"modal-card-declined-modal\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\">\n                <div class=\"modal-content popup-content\" style=\"padding: 25px 36px;\">\n                    <div class=\"modal-header popup-header text-center\">\n                        <button\n                                type=\"button\"\n                                class=\"close popup-close\"\n                                data-dismiss=\"modal\"\n                                aria-label=\"Close\">\n                            <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n                        </button>\n                        <h3>There was an error</h3>\n                    </div>\n                    <div class=\"modal-body\">\n\n                        <div class=\"alert-box alert\" style=\"font-size:14px;\">\n                            There was an issuing with the payment method ending in {{ vm.pay_data.last4 }}\n                        </div>\n\n                        {{ vm.paymentMessage }}</p>\n\n                    </div>\n                    <div class=\"modal-footer\">\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"text-align:center;\">\n                            <a class=\"btn button btn-success\" data-dismiss=\"modal\" style=\"float:none;\" href=\"\">Close</a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n<div class=\"modal fade\" id=\"direct-pay-completed-bulk\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"modal-add-projectLabel\" data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\" style=\"width:456px;\">\n                <div class=\"modal-content account-modal-content\">\n                    <div class=\"modal-gradient-bar\"></div>\n\n                    <div class=\"modal-header\">\n\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times\"></i>\n                        </button>\n                        <div class=\"modal-title\">Make Bulk Payment</div>\n                        <div class=\"modal-text\">\n                            <div ng-if=\"vm.bulk_pay_data.token_type == 'bank'\">By selecting to pay via ACH bank account,\n                                you can\n                                expect the funds to be deposited into the jobbler's bank account within 5-7 business\n                                days.\n                            </div>\n                            <div ng-if=\"vm.bulk_pay_data.token_type == 'card'\">By selecting to pay via credit card, you\n                                can\n                                expect the funds to be deposited into the jobbler's bank account in 1-2 business days.\n                            </div>\n                        </div>\n\n                    </div>\n\n                    <div class=\"modal-body\">\n\n                        <div class=\"row\" ng-show=\"vm.show_invalid_users\">\n                            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                <table style=\"margin-top: 16px\" class=\"table table-border line-item-table\"\n                                       ng-class=\"{'error' : vm.show_invalid_users}\">\n                                    <thead>\n                                    <tr>\n                                        <th>User(s) Removed</th>\n                                        <th>Amount Deducted</th>\n                                    </tr>\n                                    </thead>\n                                    <tbody>\n                                    <tr ng-repeat=\"u in vm.invalid_users\">\n                                        <td>{{u.Email}}</td>\n                                        <td>{{u.Amount}}</td>\n                                    </tr>\n                                    </tbody>\n                                </table>\n\n                                <p class=\"bulk-pay-error-text\">\n                                    There were issues paying the users in the above table.\n                                    They have been removed from the payment and the new total is displayed below.\n                                </p>\n\n                            </div>\n                        </div>\n\n                        <div\n                                style=\"\n\t\t\t\t\t\tmargin-top: 12px;\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\t\tpadding: 14px 24px;\n\t\t\t\t\t\tpadding-bottom: 24px;\n\t\t\t\t\t\tborder: 1px solid #979797;\n\t\t\t\t\t\"\n                        >\n                            <div style=\"display: flex\">\n                                <div style=\"font-size: 16px; font-weight: 600; margin-left: -9px; flex: 0 0 26px\">\n                                    <i class=\"fas fa-receipt\"></i>\n                                </div>\n                                <div style=\"font-size: 16px; font-weight: 600; flex: 1\">Payment summary</div>\n                            </div>\n\n                            <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\"/>\n\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600\">\n                                    Jobblers ( {{vm.sheet.length}} )\n                                </div>\n\n                                <div style=\"flex: 1; text-align: right\">\n                                    {{ vm.bulk_pay_data.total }}\n                                </div>\n                            </div>\n\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600; margin-top: 8px\">\n                                    + Platform fee\n                                </div>\n\n                                <div style=\"flex: 1; text-align: right; margin-top: 8px\">\n                                    ${{ vm.bulk_pay_data.fee }}\n                                </div>\n                            </div>\n\n                            <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\"/>\n\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600\">Total\n                                    billed to your account\n                                </div>\n                                <div style=\"flex: 0.5; text-align: right; font-weight: 600\">\n                                    {{ vm.bulk_pay_data.display_amount }}\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"account-gradient-button\" style=\"width: 100%; text-align: center\"\n                             ng-disabled=\"vm.making_bulk_pay\" ng-click=\"vm.submitBulkPay()\">\n                            {{ vm.bulk_pay_link_value }} <img src=\"/app/vendor/images/spinner.gif\"\n                                                              style=\"width:14px;margin-left:5px;margin-top:17px; display: inline-block\"\n                                                              ng-if=\"vm.making_bulk_pay\"/>\n                        </div>\n\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<!--<a href=\"#modal-complete-event-confirm-modal\" data-toggle=\"modal\" id=\"modal-complete-event-confirm\"></a>-->\n<div class=\"modal fade\" id=\"direct-pay-completed\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\" style=\"width:456px;\">\n                <div class=\"modal-content account-modal-content\">\n                    <div class=\"modal-gradient-bar\"></div>\n                    <div class=\"modal-header\">\n\n                        <button\n                                type=\"button\"\n                                class=\"close popup-close\"\n                                data-dismiss=\"modal\"\n                                aria-label=\"Close\">\n                            <i class=\"fa fa-times\"></i>\n                        </button>\n\n                        <div class=\"modal-title\">Make Direct Pay</div>\n                        <div class=\"modal-text\">\n                            <div ng-if=\"vm.pay_data.token_type == 'bank'\">By selecting to pay via ACH bank account, you\n                                can expect the funds to be deposited into the jobbler's bank account within 5-7 business\n                                days.\n                            </div>\n                            <div ng-if=\"vm.pay_data.token_type == 'card'\">By selecting to pay via credit card, you can\n                                expect the funds to be deposited into the jobbler's bank account in 1-2 business days.\n                            </div>\n                        </div>\n\n                    </div>\n\n                    <div class=\"modal-body\">\n\n                        <div\n                                style=\"\n\t\t\t\t\t\tmargin-top: 12px;\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\t\tpadding: 14px 24px;\n\t\t\t\t\t\tpadding-bottom: 24px;\n\t\t\t\t\t\tborder: 1px solid #979797;\n\t\t\t\t\t\"\n                        >\n                            <div style=\"display: flex\">\n                                <div style=\"font-size: 16px; font-weight: 600; margin-left: -9px; flex: 0 0 26px\">\n                                    <i class=\"fas fa-receipt\"></i>\n                                </div>\n                                <div style=\"font-size: 16px; font-weight: 600; flex: 1\">Payment summary</div>\n                            </div>\n\n                            <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\"/>\n\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600\">\n                                    Jobbler\n                                    payments\n                                </div>\n\n                                <div style=\"flex: 1; text-align: right\">\n                                    ${{vm.payJobblerInfo.amount || 0 | number: 2}}\n                                </div>\n                            </div>\n\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600; margin-top: 8px\">\n                                    + Platform fee\n                                </div>\n\n\n                                <div style=\"flex: 1; text-align: right; margin-top: 8px\">\n                                    ${{ vm.payJobblerInfo.platformFee || 0 | number: 2}}\n                                </div>\n                            </div>\n\n                            <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\"/>\n\n                            <div style=\"display: flex\">\n                                <div style=\"flex: 1; font-size: 12px; text-transform: uppercase; font-weight: 600\">Total\n                                    billed to\n                                    your account\n                                </div>\n                                <div style=\"flex: 0.5; text-align: right; font-weight: 600\">\n                                    ${{vm.payJobblerInfo.companyAmount || 0 | number: 2 }}\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"account-gradient-button\" style=\"width: 100%; text-align: center\"\n                             ng-click=\"vm.directPayJobbler()\">Make Payment\n                        </div>\n\n\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal fade\" id=\"bulk-pay-error\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\" style=\"width:715px;\">\n                <div class=\"modal-content popup-content\">\n                    <div class=\"modal-header popup-header text-center\">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n                        </button>\n                        <h3>There was an issue...</h3>\n                    </div>\n                    <div class=\"modal-body\" style=\"padding-top:0px;margin-bottom:0px;\">\n                        <div class=\"alert-box alert\">\n                            <strong>Oops!</strong> {{ vm.bulk_error }}\n                        </div>\n\n                    </div>\n                    <div class=\"modal-footer\">\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"text-align:center;\">\n                            <a class=\"btn button btn-success\" style=\"float:none;\" href=\"\" data-dismiss=\"modal\">Done</a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal fade\" id=\"bulk-pay-success\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-add-projectLabel\"\n     data-backdrop=\"static\">\n    <div class=\"vertical-alignment-helper\">\n        <div class=\"modal-dialog vertical-align-center\">\n            <div class=\"modal-dialog popup\" style=\"width:456px;\">\n                <div class=\"modal-content account-modal-content\">\n                    <div class=\"modal-gradient-bar\"></div>\n\n                    <div class=\"modal-header \">\n                        <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                            <i class=\"fa fa-times\"></i>\n                        </button>\n                        <div class=\"modal-title\">Bulk Payment Successful</div>\n                        <div class=\"modal-text\">\n                            <div>\n                                <div>{{ vm.confirmation_modal_amount }} was successfully paid out.</div>\n                            </div>\n                            <div>\n                                The receipts can be found in the \"Payment Feed\" at the bottom of the page. Please note\n                                it may take up to 5 minutes for the receipts to generate.\n\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"modal-body\">\n\n                        <div class=\"account-gradient-button\" style=\"width: 100%; text-align: center\"\n                             data-dismiss=\"modal\">Done\n                        </div>\n\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DirectpayController = function () {
	    function DirectpayController($http, $localStorage, $state, AuthService, EventsService, SecurityService, EnvService, CompaniesService, $timeout, $rootScope, $scope, $stateParams, ProfilesService) {
	        _classCallCheck(this, DirectpayController);
	
	        this.name = "directpay";
	        $localStorage.activeStateName = "directpay";
	
	        if (!AuthService.isLoggedIn()) {
	            $state.go("signin");
	            return;
	        }
	
	        this.$http = $http;
	        this.$profiles = ProfilesService;
	        this.$localStorage = $localStorage;
	        this.$state = $state;
	        this.$rootScope = $rootScope;
	        this.$auth = AuthService;
	        this.$events = EventsService;
	        this.$security = SecurityService;
	        this.$env = EnvService;
	        this.$companies = CompaniesService;
	        this.$timeout = $timeout;
	        this.bulk_pay_link_value = "Confirm";
	        this.currentPageNumber = 1;
	        this.payReceiptsArray = [];
	        this.paymentMethodSelected = false;
	        this.pages = [];
	        this.$stateParams = $stateParams;
	        this.fid = null;
	        this.making_bulk_pay = false;
	        this.bulk_pay_data = {};
	        this.currentUser = this.$auth.getUserData();
	        this.creditCards = this.$auth.getUserData().company.undeletedPaymentInfos;
	        this.paymentInfos = this.$auth.getUserData().company.undeletedPaymentInfos;
	        this.paymentMethods = this.$auth.getUserData().company.undeletedPaymentInfos;
	        this.selectedCard = null;
	        this.directPaymentReceiptList = [];
	        this.paymentStatus = 0;
	        this.paymentMessage = "";
	        this.$scope = $scope;
	        this.offsetForPagination = 20;
	        this.cardsArray = [];
	        this.banksArray = [];
	        this.getLatestInfo();
	        this.pullLatestPaymentInfo();
	        //this.organizePaymentInfo();
	        this.payments_loaded = false;
	        this.show = true;
	        this.remain_loading_count = 0;
	        this.navOptions = [];
	
	        if (this.$state.current.name === "directpay") {
	            this.page = "directpay";
	            this.navOptions = [{ type: "direct-pay", isActive: "active", value: "Direct Pay", icon: "fas fa-comment-dollar" }, { type: "bulk-pay", isActive: "", value: "Bulk Pay", icon: "fas fa-users" }];
	        } else {
	            this.navOptions = [{ type: "direct-pay", isActive: "", value: "Direct Pay", icon: "fas fa-comment-dollar" }, { type: "bulk-pay", isActive: "active", value: "Bulk Pay", icon: "fas fa-users" }];
	            this.page = "bulkpay";
	        }
	
	        this.payJobblerInfo = {
	            email: "",
	            amount: null,
	            noteForReceipt: null
	        };
	
	        this.totalPayments = this.currentUser.company.totalNumberOfInvoiceFiles;
	
	        var _this = this;
	
	        if (_this.currentUser.company.totalNumberOfInvoiceFiles) {
	            var pageArray = [];
	            for (var i = 0; i < Math.ceil(_this.currentUser.company.totalNumberOfInvoiceFiles / 20); i++) {
	                pageArray.push(i + 1);
	                _this.pages = pageArray;
	            }
	        }
	
	        _this.UpdatedCreditCardListener = _this.$rootScope.$on("UpdatedCreditCard", function () {
	            _this.$auth.reloadCurrentUser();
	            _this.$timeout(function () {
	                _this.currentUser = _this.$auth.getUserData();
	                _this.creditCards = _this.currentUser.company.paymentInfos;
	                _this.paymentInfos = _this.currentUser.company.paymentInfos;
	                _this.cardsArray = [];
	                _this.banksArray = [];
	                //_this.organizePaymentInfo();
	            }, 3000);
	        });
	
	        _this.$scope.$on("$destroy", _this.UpdatedCreditCardListener);
	        _this.getDirectPayReceipts();
	
	        //_this.formatPaymentInfoForPage(this.paymentMethods);
	
	        _this.$timeout(function () {
	            _this.remain_loading_count = 0;
	        }, 1000);
	
	        console.log("current user");
	        console.dir(_this.currentUser);
	    }
	
	    _createClass(DirectpayController, [{
	        key: "selectCardInfo",
	        value: function selectCardInfo(selectedCard, $event) {
	            this.selectedCard = selectedCard;
	            this.payType = "card";
	        }
	    }, {
	        key: "selectBankInfo",
	        value: function selectBankInfo(selectedBank, $event) {
	            this.selectedBank = selectedBank;
	            this.payType = "bank";
	        }
	    }, {
	        key: "cancelPay",
	        value: function cancelPay() {
	            var _this = this;
	            _this.$timeout(function () {
	                jQuery("#modal-pay-jobbler .modal-header button.close").trigger("click");
	            });
	        }
	    }, {
	        key: "formatPaymentCost",
	        value: function formatPaymentCost(receipts) {
	            var _this = this;
	            receipts.forEach(function (receipt, index) {
	                if (receipt.payment) {
	                    receipt.adjustedAmount = receipt.payment[0].amount * (1 + _this.currentUser.company.defaultPlan.companyFeePct) / 100;
	                    if (index === 0) {
	                        _this.formatMessageForConfirmation(receipt);
	                    }
	                } else {
	                    receipts.splice(index, 1);
	                }
	            });
	            _this.loading_invoices = false;
	        }
	    }, {
	        key: "directPayJobblerNew",
	        value: function directPayJobblerNew(isValid) {
	            if (isValid) {
	                alert("our program is mad lit");
	            } else {
	                alert("we have an error!");
	            }
	        }
	    }, {
	        key: "setCompanyCharge",
	        value: function setCompanyCharge() {
	            if (this.payJobblerInfo.amount) {
	                var fee = this.payJobblerInfo.amount * (1 + this.currentUser.company.defaultPlan.companyFeePct) - this.payJobblerInfo.amount;
	                this.payJobblerInfo.companyAmount = this.payJobblerInfo.amount * (1 + this.currentUser.company.defaultPlan.companyFeePct);
	                this.payJobblerInfo.platformFee = fee;
	            } else {
	                this.payJobblerInfo.companyAmount = 0;
	            }
	        }
	    }, {
	        key: "setListItemData",
	        value: function setListItemData() {
	            var _this = this;
	
	            var pay_data = {};
	            pay_data.jobbler = _this.payJobblerInfo.email;
	            pay_data.amount = _this.payJobblerInfo.companyAmount;
	            pay_data.display_amount = _this.payJobblerInfo.amount * (1 + _this.currentUser.company.defaultPlan.companyFeePct);
	            if (!_this.currentUser.company.payByInvoice) {
	                pay_data.token = _this.selectedPaymentMethod.stripeId;
	                if (_this.selectedPaymentMethod.bankName) {
	                    pay_data.token_type = "bank";
	                    //_this.bulk_pay_data.token_type = "bank";
	                } else {
	                    pay_data.token_type = "card";
	                    //_this.bulk_pay_data.token_type = "card";
	                }
	                pay_data.last4 = _this.selectedPaymentMethod.last4;
	            }
	            pay_data.fee = _this.currentUser.company.defaultPlan.companyFeePct * _this.payJobblerInfo.amount / 100;
	
	            _this.pay_data = pay_data;
	        }
	    }, {
	        key: "directPayJobbler",
	        value: function directPayJobbler(formData) {
	
	            this.paymentStatus = 0;
	            this.paymentMessage = "";
	            this.paymentError = false;
	
	            var status = this.validatePayJobbler();
	            var _this = this;
	
	            if (formData && status.status) {
	                _this.setListItemData();
	                jQuery("#direct-pay-completed").modal();
	                return;
	            }
	
	            _this.$timeout(function () {
	                jQuery("#direct-pay-completed .modal-header button.close").trigger("click");
	            }, 100);
	
	            _this.remain_loading_count = 5;
	
	            if (status.status) {
	                var reqPayJobbler = null;
	
	                if (_this.currentUser.company.payByInvoice) {
	                    reqPayJobbler = {
	                        method: "POST",
	                        url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
	                        headers: {
	                            "Content-Type": "application/json",
	                            Authorization: "Bearer " + _this.currentUser.access_token
	                        },
	                        data: {
	                            transfers: [{
	                                recipient: _this.payJobblerInfo.email,
	                                amount: parseInt(_this.payJobblerInfo.amount * 100),
	                                note: _this.payJobblerInfo.noteForReceipt
	                            }]
	                        }
	                    };
	                } else {
	                    if (_this.selectedPaymentMethod.payType === "bank") {
	                        reqPayJobbler = {
	                            method: "POST",
	                            url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
	                            headers: {
	                                "Content-Type": "application/json",
	                                Authorization: "Bearer " + _this.currentUser.access_token
	                            },
	                            data: {
	                                bank: _this.selectedPaymentMethod.stripeId,
	                                transfers: [{
	                                    recipient: _this.payJobblerInfo.email,
	                                    amount: parseInt(_this.payJobblerInfo.amount * 100),
	                                    note: _this.payJobblerInfo.noteForReceipt
	                                }]
	                            }
	                        };
	                    } else {
	                        reqPayJobbler = {
	                            method: "POST",
	                            url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
	                            headers: {
	                                "Content-Type": "application/json",
	                                Authorization: "Bearer " + _this.currentUser.access_token
	                            },
	                            data: {
	                                card: _this.selectedPaymentMethod.cardToken,
	                                transfers: [{
	                                    recipient: _this.payJobblerInfo.email,
	                                    amount: parseInt(_this.payJobblerInfo.amount * 100),
	                                    note: _this.payJobblerInfo.noteForReceipt
	                                }]
	                            }
	                        };
	                    }
	                }
	
	                _this.$http(reqPayJobbler).then(function (response) {
	
	                    var resp = response;
	
	                    if (response.data.status === "error" || response.data[0].status === "error") {
	                        _this.$timeout(function () {
	                            jQuery("#modal-card-declined-modal").modal();
	                            _this.remain_loading_count = 1;
	                            _this.paymentMessage = response.data[0].message;
	                        }, 100);
	
	                        return;
	                    } else {
	                        if (response.data[0].invalidUsers) {
	                            _this.$timeout(function () {
	                                _this.paymentMessage = "The user " + response.data[0].invalidUsers[0].recipient + " does not exist";
	                                _this.paymentStatus = 2;
	                                _this.isInvalidUser = true;
	                                _this.remain_loading_count = 5;
	                                jQuery("#modal-card-error").trigger("click");
	                            });
	                        } else if (response.data[0].missinPaymentnfo) {
	                            var invalidUser = response.data[0].missinPaymentnfo[0].recipient;
	
	                            _this.$timeout(function () {
	                                _this.paymentMessage = "The user " + invalidUser + " has not setup their bank account. Transaction can not be completed.";
	                                _this.paymentStatus = 2;
	                                _this.isInvalidUser = true;
	                                _this.remain_loading_count = 1;
	                                jQuery("#modal-card-error").trigger("click");
	                            });
	                        } else {
	                            try {
	                                var user = null;
	
	                                var payloop = function payloop(value) {
	                                    _this.$timeout(function () {
	                                        user = _this.$auth.reloadCurrentUser();
	
	                                        if (value === 0) {
	                                            _this.$companies.getDirectPaymentReceipts(20, _this.fid).then(function (response) {
	                                                _this.formatPaymentCost(response.data, resp);
	                                                _this.directPaymentReceiptList = response.data;
	                                                _this.remain_loading_count = 1;
	
	                                                _this.$timeout(function () {
	                                                    _this.paymentMessage = "Your payment was successful.";
	                                                    _this.paymentStatus = 10;
	                                                    _this.payJobblerInfo.email = null;
	                                                    _this.validEmail = false;
	                                                    _this.error_with_email = null;
	                                                    _this.successfulEmail = null;
	                                                    _this.payJobblerInfo.amount = null;
	                                                    _this.payJobblerInfo.companyAmount = null;
	                                                    _this.payJobblerInfo.platformFee = null;
	                                                    _this.payJobblerInfo.noteForReceipt = null;
	                                                    _this.isInvalidUser = false;
	                                                    _this.paymentStatus = 1;
	                                                    $("#modal-card-error-modal").modal();
	                                                });
	                                            }, function (response) {
	                                                _this.remain_loading_count = 1;
	                                                return;
	                                                _this.$timeout(function () {
	                                                    jQuery("#show-application-alert").trigger("click");
	                                                }, 100);
	                                            });
	                                        } else {
	                                            return payloop(value - 1);
	                                        }
	                                    }, 2000);
	                                };
	
	                                payloop(2);
	                            } finally {
	                                _this.paymentStatus = 1;
	                                _this.paymentMessage = "The jobbler was successfully paid.";
	                                _this.$timeout(function () {
	                                    jQuery("#modal-pay-jobbler .modal-header button.close").trigger("click");
	                                });
	                            }
	                        }
	                    }
	                }, function (response) {
	                    _this.$timeout(function () {
	                        _this.remain_loading_count = 1;
	                        jQuery("#modal-pay-jobbler .modal-header button.close").trigger("click");
	                        jQuery("#show-application-alert").trigger("click");
	                    }, 100);
	                });
	            } else {
	                _this.$timeout(function () {
	                    _this.paymentError = status.message;
	                    _this.paymentStatus = 2;
	                    _this.paymentMessage = status.message;
	                    //jQuery('#modal-card-error').trigger('click');
	                });
	            }
	        }
	    }, {
	        key: "validatePayJobbler",
	        value: function validatePayJobbler() {
	
	            var retObj = {};
	
	            retObj.status = true;
	
	            if (this.currentUser.company.payByInvoice === true || this.currentUser.company.enableSubscription === true) {
	                retObj.status = true;
	            } else {
	                if (this.$security.isUndefinedOrNull(this.selectedPaymentMethod)) {
	                    retObj.status = false;
	                    if (this.creditCards.length == 0) {
	                        retObj.message = "Please add a credit card to your account.";
	                    } else {
	                        retObj.message = "Please select a payment method to pay the jobbler.";
	                    }
	                }
	            }
	
	            return retObj;
	        }
	    }, {
	        key: "paginate",
	        value: function paginate(offset) {
	            var _this = this;
	
	            _this.remain_loading_count++;
	
	            if (offset < 1 || offset > _this.pages.length) {
	                return;
	            }
	
	            _this.paginating = true;
	
	            _this.currentPageNumber = offset;
	
	            if (offset !== 0) {
	                offset = offset * 20 - 20;
	            }
	
	            var getInvoices = {
	                method: "GET",
	                url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.currentUser.company.id + "/files?format=json&conf=web&sort=id&order=desc&max=20&type=" + _this.fid + "&offset=" + offset,
	                headers: {
	                    "Content-Type": "application/json",
	                    Authorization: "Bearer " + _this.currentUser.access_token
	                },
	                data: {}
	            };
	
	            _this.$http(getInvoices).then(function (directPayArray) {
	                var a = [];
	                try {
	                    directPayArray.data.forEach(function (r) {
	                        console.log("each payment");
	                        console.dir(r);
	                        console.dir(r.payedUser[0].email);
	                        if (r.payment) {
	                            a.push(r);
	                        }
	                    });
	                } catch (err) {
	                    console.error("we have an error");
	                    console.dir(err);
	                } finally {
	                    _this.formatPaymentCost(a);
	                    _this.directPaymentReceiptList = a;
	                    _this.remain_loading_count--;
	
	                    _this.$timeout(function () {
	                        _this.paginating = false;
	                    });
	                }
	            });
	        }
	    }, {
	        key: "keepTwoDecimals",
	        value: function keepTwoDecimals() {
	            var _this = this;
	        }
	    }, {
	        key: "organizePaymentInfo",
	        value: function organizePaymentInfo() {
	
	            var _this = this;
	
	            console.log("organize payment info");
	            console.dir(_this.paymentInfos);
	
	            if (_this.paymentInfos) {
	                if (_this.paymentInfos.length > 0) {
	                    try {
	                        _this.paymentInfos.forEach(function (paymentInfo) {
	                            if (paymentInfo.bankName && paymentInfo.validated) {
	                                _this.banksArray.push(paymentInfo);
	                            } else {
	                                if (paymentInfo.bankName) {} else {
	                                    _this.cardsArray.push(paymentInfo);
	                                }
	                            }
	                        });
	                    } finally {
	                        _this.cardsArray.forEach(function (paymentInfo) {
	                            paymentInfo.cardExpirationDate = moment().month(parseInt(paymentInfo.cardExpirationMonth)).format("MM") + "/" + paymentInfo.cardExpirationYear;
	                        });
	                    }
	                }
	            }
	        }
	    }, {
	        key: "formatRecDate",
	        value: function formatRecDate(date) {
	            return moment(date).format("MM/DD/YY");
	        }
	    }, {
	        key: "formatPaymentInfoForPage",
	        value: function formatPaymentInfoForPage(info) {
	            var _this = this;
	
	            console.log("formatPaymentInfoForPage");
	            console.dir(info);
	            _this.paymentMethodsFormatted = _this.$auth.formatPaymentMethods(info);
	        }
	    }, {
	        key: "selectPaymentMethod",
	        value: function selectPaymentMethod(paymentMethod) {
	            var _this = this;
	
	            console.log("selectPaymentMethod");
	            console.dir(paymentMethod);
	            console.dir(_this.currentUser.company);
	
	            if (paymentMethod.isChecked === true) {
	                paymentMethod.isChecked = false;
	            } else {
	                paymentMethod.isChecked = true;
	            }
	
	            var foundPaymentMethod = false;
	
	            try {
	                this.paymentMethodsFormatted.forEach(function (method) {
	                    if (method.isChecked === true) {
	                        foundPaymentMethod = true;
	                    }
	                });
	            } finally {
	
	                if (foundPaymentMethod === false) {
	                    _this.selectedPaymentMethod = null;
	                } else {
	                    _this.selectedPaymentMethod = paymentMethod;
	
	                    _this.paymentMethods = _this.$auth.selectPaymentMethod(_this.paymentMethods, paymentMethod);
	                }
	            }
	        }
	    }, {
	        key: "formatMessageForConfirmation",
	        value: function formatMessageForConfirmation(receiptForDisplay, resp) {
	            var _this = this;
	            if (receiptForDisplay) {
	                var amount = (receiptForDisplay.payment[0].amountCompany / 100).toFixed(2);
	                _this.messageForModal = "$" + _this.payJobblerInfo.amount + " was transferred to " + _this.payJobblerInfo.email;
	            }
	        }
	    }, {
	        key: "validateDirectPayNotes",
	        value: function validateDirectPayNotes() {
	            if (this.payJobblerInfo.noteForReceipt.length > 100) {
	                this.error_with_note = true;
	            } else {
	                this.error_with_note = false;
	            }
	        }
	    }, {
	        key: "validateDirectPayEmail",
	        value: function validateDirectPayEmail() {
	            var _this = this;
	
	            ///^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	            var email = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(_this.payJobblerInfo.email);
	            //let email = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(_this.payJobblerInfo.email);
	            _this.validEmail = email;
	            if (email === true) {
	                _this.$timeout(function () {
	                    _this.checkUserPaymentInfo();
	                }, 500);
	            } else {
	                _this.$timeout(function () {
	                    _this.error_with_email = true;
	                }, 1500);
	            }
	
	            if (_this.currentUser.company.payByInvoice === true || _this.currentUser.company.enableSubscription === true) {
	                _this.selectedPaymentMethod = true;
	            }
	        }
	    }, {
	        key: "checkUserPaymentInfo",
	        value: function checkUserPaymentInfo() {
	            var _this = this;
	
	            if (_this.validEmail) {
	                _this.$auth.getUserByEmail(_this.payJobblerInfo.email).then(function (response) {
	                    if (response.data.status === "error") {
	                        _this.error_with_email = true;
	                        _this.successfulEmail = false;
	                    } else {
	                        _this.successfulEmail = true;
	                        _this.error_with_email = false;
	                    }
	                }, function (error) {
	                    console.log("error");
	                    console.dir(error);
	                });
	            }
	        }
	    }, {
	        key: "getDirectPayReceipts",
	        value: function getDirectPayReceipts() {
	            var _this = this;
	
	            _this.loading_invoices = true;
	
	            _this.$companies.fileTypesReq().then(function (fileTypes) {
	                try {
	                    for (var i = 0; i < fileTypes.data.length; i++) {
	                        if (fileTypes.data[i].name === "COMPANY_INVOICE_PDF") {
	                            _this.fid = fileTypes.data[i].id;
	                        }
	                    }
	                } finally {
	                    _this.$companies.getDirectPaymentReceipts(20, _this.fid).then(function (response) {
	                        var a = [];
	
	                        try {
	                            response.data.forEach(function (r) {
	                                if (r.payment) {
	                                    if (r.payment[0].notePayer === "Connection") {
	                                        r.payedUser = [];
	                                        var payedUserObj = {};
	                                        payedUserObj.firstName = "Jobble";
	                                        payedUserObj.email = "high-five@jobble.com";
	                                        r.payedUser.push(payedUserObj);
	                                    }
	
	                                    a.push(r);
	                                }
	                            });
	                        } finally {
	                            _this.formatPaymentCost(a);
	                            _this.directPaymentReceiptList = a;
	                            _this.loading_invoices = false;
	                            _this.remain_loading_count--;
	                        }
	                    }, function (response) {
	                        _this.remain_loading_count--;
	                        _this.$timeout(function () {
	                            jQuery("#show-application-alert").trigger("click");
	                        }, 100);
	                    });
	                }
	            });
	        }
	    }, {
	        key: "bulkPayments",
	        value: function bulkPayments(file, invalidFiles) {
	            var _this = this;
	            var reader = new FileReader();
	            var file_as_text = reader.readAsText(file);
	            reader.onload = _this.loadHandler(file_as_text);
	        }
	    }, {
	        key: "loadHandler",
	        value: function loadHandler(text) {
	            var _this = this;
	        }
	    }, {
	        key: "handleContent",
	        value: function handleContent(content) {
	            var _this = this;
	        }
	    }, {
	        key: "loadWorksheet",
	        value: function loadWorksheet(e) {
	            var file = e.target.result;
	            var workbook = XLSX.read(file, { type: "binary" });
	            var sheetName = workbook.SheetNames[0];
	            this.sheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
	            this.sheet = this.cleanseKeys();
	            this.validateSheet();
	            this.showBulkPayTotal();
	            this.$scope.$apply(); // Need this to update angular with the changes
	        }
	    }, {
	        key: "cleanseKeys",
	        value: function cleanseKeys() {
	            var _this = this;
	            var sheet_after_cleanse = [];
	            try {
	
	                this.sheet.forEach(function (row, i) {
	                    var row_build = {};
	                    var keys = Object.keys(row);
	                    var values = keys.map(function (v) {
	                        return row[v];
	                    });
	
	                    keys.forEach(function (key, x) {
	                        var lower_case_key = key.toLowerCase();
	                        var lower_case_key_trimmed = lower_case_key.trim();
	                        var lower_case_key_trimmed_capitalized = _this.capitalizeFirstLetter(lower_case_key_trimmed);
	
	                        key = lower_case_key_trimmed_capitalized;
	
	                        switch (x) {
	                            case 0:
	                                row_build.Email = key;
	                                row_build.Email = values[0].trim();
	                            case 1:
	                                row_build.Note = key;
	                                row_build.Note = values[1];
	                            case 2:
	                                row_build.Amount = key;
	                                row_build.Amount = values[2];
	                        }
	                    });
	
	                    sheet_after_cleanse.push(row_build);
	                });
	            } catch (err) {
	                console.log("catch error");
	                console.dir(err);
	            }
	            return sheet_after_cleanse;
	        }
	    }, {
	        key: "capitalizeFirstLetter",
	        value: function capitalizeFirstLetter(string) {
	            return string.charAt(0).toUpperCase() + string.slice(1);
	        }
	    }, {
	        key: "validateSheet",
	        value: function validateSheet(sheet) {
	            var _this = this;
	
	            this.sheet.forEach(function (row, i) {
	                var keys = Object.keys(row);
	                var values = keys.map(function (v) {
	                    return row[v];
	                });
	
	                if (keys.length < 3) {
	                    var validate_obj = _this.checkForEmptyCells(keys, row);
	                    if (validate_obj.status === false) {
	                        _this.handleCsvError(null, validate_obj);
	                        return;
	                    }
	                }
	                try {
	                    for (var x = 0; x < keys.length; x++) {
	                        var key = keys[x];
	                        var val = row[keys[x]];
	                        var parent_counter = i + 1;
	                        var counter = x + 1;
	                        var msg = null;
	                        if (val) {
	                            if (key === "Email") {} else if (key === "Note") {} else if (key === "Amount") {} else {
	                                _this.handleCsvError(key);
	                                break;
	                            }
	                        } else {
	                            if (key === "Email" || key === "Amount") {
	                                if (key === "Amount") {
	                                    if (val === 0) {
	                                        msg = "One or more of the users in your spreadsheet have the 'Amount' column set to 0. We do not process payments less than .05 cents";
	                                        _this.handleCsvError(key, null, msg);
	                                    } else {
	                                        _this.handleCsvError(key, null, null);
	                                    }
	                                } else {
	                                    _this.handleCsvError(key, null, null);
	                                }
	                                //_this.handleCsvError(key,null,msg);
	                                break;
	                            }
	                        }
	                    }
	                } catch (err) {
	                    console.log("caught an error");
	                    console.dir(err);
	                } finally {
	                    console.log("in the finally of the validate");
	                }
	            });
	        }
	    }, {
	        key: "checkForEmptyCells",
	        value: function checkForEmptyCells(keys, row) {
	            var _this = this;
	            var ret_obj = {};
	            if (keys.indexOf("Amount") < 0) {
	                ret_obj.status = false;
	                ret_obj.text = "Every cell under the 'Amount' is required. Your CSV does not meet this requirement. Please click the 'View Example CSV' above to see a working sheet.";
	            } else if (keys.indexOf("Email") < 0) {
	                ret_obj.status = false;
	                ret_obj.text = "Every cell under the 'Email' is required. Your CSV does not meet this requirement. Please click the 'View Example CSV' above to see a working sheet.";
	            } else {}
	            return ret_obj;
	        }
	    }, {
	        key: "handleCsvError",
	        value: function handleCsvError(key, validation_obj, msg) {
	            var _this = this;
	            var csv_error = {};
	            if (validation_obj) {
	                csv_error.text = validation_obj.text;
	                _this.csv_error = csv_error;
	            } else {
	                if (msg) {
	                    csv_error.text = msg;
	                    _this.csv_error = csv_error;
	                } else {
	                    csv_error.text = "The column header '" + key + "' does not fit the accepted format. Please click 'View Example CSV' to see how the CSV file should be organized.";
	                    _this.csv_error = csv_error;
	                }
	            }
	        }
	    }, {
	        key: "trimSheet",
	        value: function trimSheet() {
	            var _this = this;
	            try {
	                _this.sheet.forEach(function (item) {
	                    if (item.Email) {
	                        item.Email = item.Email.trim();
	                    }
	                    if (item.Amount) {
	                        item.Amount = item.Amount.toString();
	                        item.Amount = item.Amount.trim();
	                    }
	                });
	            } catch (err) {
	                console.dir(err);
	            } finally {}
	        }
	    }, {
	        key: "submitBulkPayToggle",
	        value: function submitBulkPayToggle() {
	            var _this = this;
	            _this.show_invalid_users = false;
	            console.log("submitBulkPayTogglesubmitBulkPayTogglesubmitBulkPayTogglesubmitBulkPayTogglesubmitBulkPayToggle");
	            console.dir(_this.currentUser.company);
	            console.dir(_this.selectedPaymentMethod);
	            if (!_this.currentUser.company.payByInvoice) {
	                if (!_this.selectedPaymentMethod && !_this.currentUser.company.enableSubscription && !_this.currentUser.company.sendInvoice) {
	                    alert("Please select a payment method at the top of the page.");
	                    return;
	                }
	            }
	            if (_this.selectedPaymentMethod) {
	                if (_this.selectedPaymentMethod.bankName) {
	                    _this.bulk_pay_data.token_type = "bank";
	                } else {
	                    _this.bulk_pay_data.token_type = "card";
	                }
	            }
	            _this.$timeout(function () {
	                $("#direct-pay-completed-bulk").modal();
	            }, 300);
	        }
	    }, {
	        key: "submitBulkPay",
	        value: function submitBulkPay() {
	
	            var _this = this;
	
	            var data = {};
	
	            data.transfers = [];
	
	            console.log("submitBulkPay");
	            console.dir(_this.bulk_pay_data);
	            console.dir(_this.selectedPaymentMethod);
	            console.dir(_this.currentUser.company);
	
	            if (!_this.currentUser.company.payByInvoice && !_this.currentUser.company.enableSubscription && !_this.currentUser.company.sendInvoice) {
	                if (!_this.selectedPaymentMethod) {
	                    alert("Please select a payment method");
	                    return;
	                } else {
	                    if (_this.selectedPaymentMethod.payType === "bank") {
	                        data.bank = _this.selectedPaymentMethod.stripeId;
	                    } else {
	                        if (_this.selectedPaymentMethod.stripeId) {
	                            data.card = _this.selectedPaymentMethod.stripeId;
	                        } else {
	                            data.card = _this.selectedPaymentMethod.cardToken;
	                        }
	                    }
	                }
	            } else if (_this.currentUser.company.payByInvoice === true) {
	                //do nothing
	            } else {
	                if (_this.selectedPaymentMethod) {
	
	                    if (_this.selectedPaymentMethod.payType === "bank") {
	                        data.bank = _this.selectedPaymentMethod.stripeId;
	                    } else {
	                        if (_this.selectedPaymentMethod.stripeId) {
	                            data.card = _this.selectedPaymentMethod.stripeId;
	                        } else {
	                            data.card = _this.selectedPaymentMethod.cardToken;
	                        }
	                    }
	                }
	            }
	            _this.making_bulk_pay = true;
	            _this.bulk_pay_link_value = "Making Payment";
	
	            try {
	                _this.sheet.forEach(function (item) {
	                    var jobbler = {};
	                    jobbler.recipient = item.Email;
	                    var pay_amount = null;
	                    if (typeof item.Amount === "string") {
	                        if (item.Amount.indexOf(".") == -1) {
	                            pay_amount = parseInt(item.Amount, 10);
	                        } else {
	                            pay_amount = parseFloat(item.Amount);
	                        }
	                    } else if (typeof item.Amount === "number") {
	                        pay_amount = item.Amount;
	                    }
	                    jobbler.amount = Math.round(pay_amount * 100);
	                    jobbler.note = item.Note;
	                    data.transfers.push(jobbler);
	                });
	            } catch (err) {
	                console.log("error");
	                console.dir(err);
	            }
	
	            var u = _this.currentUser;
	
	            _this.$companies.makePayment(data, u).then(function (response) {
	                _this.handleBulkPayResponse(response);
	                _this.$timeout(function () {
	                    _this.bulk_pay_link_value = "Confirm";
	                    _this.making_bulk_pay = false;
	                }, 300);
	            }, function (error) {
	                _this.making_bulk_pay = false;
	            });
	        }
	    }, {
	        key: "showBulkPayTotal",
	        value: function showBulkPayTotal() {
	
	            var _this = this;
	
	            var total = 0;
	
	            try {
	                _this.sheet.forEach(function (item) {
	
	                    if (typeof item.Amount === "number") {
	                        total = total + item.Amount;
	                    } else {
	                        if (item.Amount.indexOf("$") > -1) {
	                            var index = item.Amount.indexOf("$");
	                            item.Amount = item.Amount.substring(index + 1, item.Amount.length);
	                        }
	                        if (item.Amount.indexOf(".") == -1) {
	                            total = total + parseInt(item.Amount, 10);
	                        } else {
	                            total = total + parseFloat(item.Amount);
	                        }
	                    }
	                });
	            } catch (err) {
	                console.log("we know there is an error");
	                console.dir(err);
	            } finally {
	                _this.bulk_pay_data.display_amount = total * (1 + _this.currentUser.company.defaultPlan.companyFeePct);
	                var bulk_pay_data_display_amount_temp = total * (1 + _this.currentUser.company.defaultPlan.companyFeePct);
	                _this.bulk_pay_data.display_amount = numeral(_this.bulk_pay_data.display_amount).format("$0,0.00");
	                _this.confirmation_modal_amount = _this.bulk_pay_data.display_amount;
	                _this.bulk_pay_data.total = numeral(total).format("$0,0.00");
	                _this.bulk_pay_data.fee = (bulk_pay_data_display_amount_temp - total).toFixed(2);
	                if (_this.selectedPaymentMethod) {
	                    console.dir(_this.selectedPaymentMethod);
	                    console.dir(_this.selectedPaymentMethod.stripeId);
	                }
	
	                return _this.bulk_pay_data.display_amount;
	            }
	        }
	    }, {
	        key: "clearBulkPay",
	        value: function clearBulkPay() {
	            var _this = this;
	
	            _this.sheet = null;
	        }
	    }, {
	        key: "handleBulkPayResponse",
	        value: function handleBulkPayResponse(response) {
	            var _this = this;
	            if (response.status === 200) {
	                if (response.data.status === "error") {
	                    _this.handleBulkPaymentError(response.data.message);
	                } else {
	                    _this.$timeout(function () {
	                        $("#direct-pay-completed-bulk").modal("toggle");
	                    });
	                    _this.$timeout(function () {
	                        _this.sheet = null;
	                        $("#bulk-pay-success").modal();
	                        _this.getNewReceipts();
	                    }, 300);
	                }
	            } else {
	                console.log("do some other error handling");
	                _this.handleBulkPaymentError(response.data.message);
	            }
	        }
	    }, {
	        key: "handleBulkPaymentError",
	        value: function handleBulkPaymentError(error) {
	            var _this = this;
	
	            if (error.indexOf("Cannot find user(s)") > -1) {
	                var len = "Cannot find user(s)".length;
	                var users = error.substring(len, error.length);
	                var array_of_users = users.split(",");
	                _this.cleanseInvalidUsers(array_of_users);
	            } else {
	                console.log("down here");
	                _this.$timeout(function () {
	                    $("#direct-pay-completed-bulk").modal("toggle");
	                });
	                _this.$timeout(function () {
	                    $("#bulk-pay-error").modal();
	                    _this.bulk_error = error;
	                }, 300);
	            }
	        }
	    }, {
	        key: "cleanseInvalidUsers",
	        value: function cleanseInvalidUsers(array_of_invalid_users) {
	            var _this = this;
	            var cleansed_list = [];
	            try {
	                array_of_invalid_users.forEach(function (user) {
	                    var user_trimmed = null;
	                    if (user) {
	                        user_trimmed = user.trim();
	                        if (user_trimmed.length > 0) {
	                            cleansed_list.push(user_trimmed);
	                        }
	                    }
	                });
	            } catch (err) {
	                console.log("error");
	                console.dir(err);
	            }
	
	            _this.removeInvalidUsersFromSheet(cleansed_list);
	        }
	    }, {
	        key: "removeInvalidUsersFromSheet",
	        value: function removeInvalidUsersFromSheet(invalid_users) {
	            var _this = this;
	
	            var sheet_without_invalid_user = [];
	            var sheet_with_invalid_user = [];
	            try {
	                _this.sheet.forEach(function (row) {
	                    console.dir(row);
	                    console.dir(invalid_users.indexOf(row.Email));
	                    if (invalid_users.indexOf(row.Email) < 0) {
	                        sheet_without_invalid_user.push(row);
	                    } else {
	                        sheet_with_invalid_user.push(row);
	                    }
	                });
	            } catch (err) {
	                console.log("error looping the sheet");
	                console.dir(err);
	            }
	            _this.invalid_users = sheet_with_invalid_user;
	            _this.sheet = sheet_without_invalid_user;
	            _this.show_invalid_users = true;
	        }
	    }, {
	        key: "getNewReceipts",
	        value: function getNewReceipts() {
	            var _this = this;
	            _this.loading_invoices = true;
	            _this.$timeout(function () {
	                _this.$auth.validateUserByTokenWeb(_this.currentUser.access_token).then(function (r) {
	                    _this.$companies.getDirectPaymentReceipts(20, _this.fid).then(function (response) {
	                        if (response.statusText === "OK") {
	                            _this.formatPaymentCost(response.data, response);
	                            _this.directPaymentReceiptList = response.data;
	                            _this.$timeout(function () {
	                                _this.loading_invoices = false;
	                            }, 300);
	                        } else {
	                            _this.loading_invoices = false;
	                        }
	                    }, function (error) {
	                        _this.loading_invoices = false;
	                    });
	                }, function (error) {
	                    console.log("error validating token");
	                    console.dir(error);
	                });
	            }, 8000);
	        }
	    }, {
	        key: "navigateDirectPay",
	        value: function navigateDirectPay(page) {
	            var _this = this;
	            if (page === "bulk-pay") {
	                _this.navOptions[0].isActive = "";
	                _this.navOptions[1].isActive = "active";
	                _this.$state.go("bulkpay");
	            } else {
	                _this.navOptions[0].isActive = "active";
	                _this.navOptions[1].isActive = "";
	                _this.$state.go("directpay");
	            }
	        }
	    }, {
	        key: "showExampleCSV",
	        value: function showExampleCSV() {
	            var _this = this;
	
	            if (_this.show) {
	                _this.show = false;
	            } else {
	                _this.show = true;
	            }
	        }
	    }, {
	        key: "getLatestInfo",
	        value: function getLatestInfo() {
	            var _this = this;
	
	            var t = _this.currentUser.access_token;
	            _this.$auth.validateUserByTokenWeb(t).then(function (resp) {
	                _this.currentUser = resp.data;
	                if (_this.currentUser.company.totalNumberOfInvoiceFiles) {
	                    var pageArray = [];
	                    for (var i = 0; i < Math.ceil(_this.currentUser.company.totalNumberOfInvoiceFiles / 20); i++) {
	                        pageArray.push(i + 1);
	                        _this.pages = pageArray;
	                    }
	                }
	            }, function (error) {
	                console.log("error");
	                console.dir(error);
	            });
	        }
	    }, {
	        key: "pullLatestPaymentInfo",
	        value: function pullLatestPaymentInfo() {
	            var _this2 = this;
	
	            this.setLoader();
	            this.$profiles.getPaymentInfo().then(function (response) {
	                console.log("latest payment info?");
	                console.dir(response);
	                console.dir(response.data.company.undeletedPaymentInfos.length);
	                _this2.currentUser.company.undeletedPaymentInfos = response.data.company.undeletedPaymentInfos;
	                _this2.paymentInfos = response.data.company.undeletedPaymentInfos;
	                _this2.formatPaymentInfoForPage(response.data.company.undeletedPaymentInfos);
	                //this.organizePaymentInfo();
	                _this2.showPaymentInfo = true;
	                _this2.$timeout(function () {
	                    _this2.unSetLoader();
	                }, 750);
	            }, function (error) {
	                console.log("what is error");
	                console.dir(error);
	                _this2.showPaymentInfo = true;
	                _this2.unSetLoader();
	                alert("Error loading users payment information : " + error.status);
	            });
	        }
	    }, {
	        key: "setLoader",
	        value: function setLoader() {
	            var _this = this;
	            _this.$timeout(function () {
	                $("html").addClass("wait");
	            });
	        }
	    }, {
	        key: "unSetLoader",
	        value: function unSetLoader() {
	            var _this = this;
	
	            _this.$timeout(function () {
	                $("html").removeClass("wait");
	            });
	        }
	    }]);
	
	    return DirectpayController;
	}();
	
	DirectpayController.$inject = ["$http", "$localStorage", "$state", "auth", "events", "security", "env", "companies", "$timeout", "$rootScope", "$scope", "$stateParams", "profile"];
	
	exports.default = DirectpayController;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(648);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./directpay.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./directpay.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".directpay{color:red}", ""]);
	
	// exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(650);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".payment-sidebar{background-color:#fff;padding:0;border:1px solid #adbcc2;border-radius:6px;font-family:Poppins,sans-serif;font-weight:600;font-size:12px;text-transform:uppercase;overflow:hidden;margin-bottom:24px}.payment-sidebar li{height:50px;line-height:50px;padding-left:16px;border-bottom:1px solid #adbcc2}.payment-sidebar li:last-child{border-bottom:none}.payment-sidebar li a{color:#5e666d;width:100%;display:block}.payment-sidebar li i{margin-right:14px;font-size:16px}.payment-sidebar li.active{border-left:4px solid #62c046}.payment-pay-container{background-color:#fff;padding:24px;border:1px solid #adbcc2;margin-bottom:15px;border-radius:6px;font-family:Poppins,sans-serif;font-size:14px}.payment-pay-container input{height:40px;line-height:40px;border:1px solid #767676;box-shadow:0 2px 4px 0 rgba(0,0,0,.1);border-radius:2px;font-family:Poppins,sans-serif;font-size:14px;width:100%}.payment-pay-container input[type=checkbox]{box-shadow:none;width:16px;line-height:18px;height:18px}.gradient-button,input.gradient-button{background:linear-gradient(225deg,#5498b4,#62c046);border-radius:6px;height:46px;line-height:46px;padding:0 24px;width:fit-content;font-size:14px;font-weight:600;color:#fff;cursor:pointer;letter-spacing:.25px;margin-top:24px;border:none}.gradient-button.disabled{background:linear-gradient(270deg,#bbe9ad,#b0ddee)}input.gradient-button[disabled]{opacity:.4}", ""]);
	
	// exports


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _payshifts = __webpack_require__(652);
	
	var _payshifts2 = _interopRequireDefault(_payshifts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var payshiftsModule = _angular2.default.module("payshifts", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("payshifts", {
	    url: "/event/:eventId/payshifts",
	    template: "<payshifts></payshifts>"
	  });
	}).component("payshifts", _payshifts2.default);
	
	exports.default = payshiftsModule;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _payshifts = __webpack_require__(653);
	
	var _payshifts2 = _interopRequireDefault(_payshifts);
	
	var _payshifts3 = __webpack_require__(654);
	
	var _payshifts4 = _interopRequireDefault(_payshifts3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var payshiftsComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _payshifts2.default,
	  controller: _payshifts4.default,
	  controllerAs: "vm"
	};
	
	exports.default = payshiftsComponent;

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n<div class=\"jobs-complete-banner\"></div>\n<div class=\"jobs-complete-container\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12 side-bar-complete\">\n        <div class=\"back-to-jobs\">\n          <a href=\"/jobs-dashboard\">Back to Jobs</a>\n        </div>\n        <!--Sidebar-->\n        <eventsidebar></eventsidebar>\n        <eventdialog></eventdialog>\n        <!--Sidebar-->\n      </div>\n      <div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12 main-page-complete\">\n        <div class=\"jobs-complete-content-wrap\">\n          <div class=\"jobs-complete-content\" style=\"min-height: 700px\">\n            <div class=\"overview-image-large\">\n              <img src=\"app/vendor/images/jobblepay.png\" alt=\"Jobble Biz\" title=\"Jobble Biz\" />\n              <div class=\"jobs-overview-top-all\">\n                <h1>{{vm.event.name}}</h1>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"shift-dates-holder-wrapper\" ng-if=\"vm.shifts\">\n                  <div class=\"shift-dates-holder\">\n                    <h4 class=\"shifts-headers\">Select A Shift For Payment Details</h4>\n                    <ul>\n                      <li ng-repeat=\"shift in vm.shifts track by $index\" ng-click=\"vm.loadDifferentShifts(shift,$index)\">\n                        <a href=\"#\"> {{shift.startTimeFormatted}} </a>\n                        <i class=\"fas fa-bell\" ng-if=\"shift.callToAction==true\" title=\"Additional Actions Need To Be Taken\"> </i>\n                      </li>\n                    </ul>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"jobble-tip spacing-for-jobble-tip shift-payments-tip\">\n                  <h5>Payment Instructions</h5>\n                  <p>Select the Jobblers you are ready to pay and a payment method, then click \"Submit Payment\"</p>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <table class=\"table table-bordered shiftpayments\">\n                  <thead>\n                    <tr>\n                      <th>\n                        <input type=\"checkbox\" ng-click=\"vm.checkAll()\" ng-checked=\"vm.allChecked\" />\n                      </th>\n                      <th>Name</th>\n                      <th>Hours</th>\n                      <th>Mins.</th>\n                      <th>$/HR</th>\n                      <th>Checkin</th>\n                      <th>Checkout</th>\n                      <th>Total</th>\n                      <th></th>\n                    </tr>\n                  </thead>\n\n                  <tbody>\n                    <tr\n                      ng-repeat=\"data in vm.shiftsWithUsers track by $index\"\n                      ng-class=\"{ 'selected-for-bulk' : data.isCheckedForPayment, 'user-has-been-paid' : data.hasBeenPaid == true && data.hasNoPaymentInfo != true, 'payment-warning-no-info' : data.hasNoPaymentInfo == true && !data.isCheckedForPayment }\"\n                    >\n                      <td>\n                        <input\n                          ng-if=\"data.noShow!==true && data.hasBeenPaid != true && data.actualMinutesWorked != 0\"\n                          type=\"checkbox\"\n                          ng-checked=\"data.isCheckedForPayment\"\n                          ng-click=\"vm.checkUserForPayment(data)\"\n                        />\n                      </td>\n                      <td ng-class=\"{ 'mark-user-no-show-line-through' : data.noShow==true }\">\n                        <i class=\"fa fa-exclamation-triangle\" ng-if=\"data.hasNoPaymentInfo==true\" title=\"No Payment Infomation On File\"> </i>\n                        <i\n                          class=\"fas fa-clipboard-check confirmed\"\n                          title=\"User has accepted shift confirmation\"\n                          ng-if=\"data.confirmationResponse==true\"\n                        >\n                        </i>\n                        <i\n                          class=\"fas fa-calendar-times confirmed\"\n                          title=\"User has declined shift confirmation\"\n                          ng-if=\"data.confirmationResponse==false\"\n                        >\n                        </i>\n\n                        <label>\n                          <span style=\"font-size: 12px; color: #5e666d\" data-toggle=\"tooltip\" data-placement=\"bottom\" title=\"{{data.jobblerNote}}\">\n                            <i class=\"fas fa-clipboard notes\" ng-if=\"data.jobblerNote\"> </i>\n                          </span>\n                        </label>\n\n                        {{ data.applicant.lastName}}, {{ data.applicant.firstName}}\n                      </td>\n\n                      <td ng-if=\"data.isEditingHours==false\" ng-click=\"vm.setEditing(data,'hours',$index)\">\n                        <span class=\"editable\" ng-if=\"data.hasBeenPaid != true && data.noShow != true && !data.isCheckedForPayment\">\n                          {{ data.timeInterval.timeInHours }}\n                        </span>\n                        <span class=\"not-editable\" ng-if=\"data.hasBeenPaid == true || data.noShow == true || data.isCheckedForPayment == true\">\n                          {{ data.timeInterval.timeInHours }}\n                        </span>\n                      </td>\n\n                      <td ng-if=\"data.isEditingHours==true\">\n                        <input\n                          style=\"max-width: 50px\"\n                          type=\"number\"\n                          min=\"0\"\n                          step=\"1\"\n                          ng-enter=\"vm.enterHoursUpdated(data)\"\n                          ng-blur=\"vm.blurHoursUpdated(data)\"\n                          ng-model=\"data.timeInterval.timeInHours\"\n                          onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"\n                          title=\"Whole Numbers Only\"\n                        />\n                      </td>\n\n                      <td ng-if=\"data.isEditingMinutes==false\" ng-click=\"vm.setEditing(data,'mins',$index)\">\n                        <span class=\"editable\" ng-if=\"data.hasBeenPaid != true && data.noShow != true && !data.isCheckedForPayment\">\n                          {{ data.timeInterval.timeInMinutes }}\n                        </span>\n                        <span class=\"not-editable\" ng-if=\"data.hasBeenPaid == true || data.noShow == true || data.isCheckedForPayment == true\">\n                          {{ data.timeInterval.timeInMinutes }}\n                        </span>\n                      </td>\n\n                      <td ng-if=\"data.isEditingMinutes==true\">\n                        <input\n                          style=\"max-width: 50px\"\n                          type=\"number\"\n                          min=\"0\"\n                          step=\"1\"\n                          ng-enter=\"vm.enterHoursUpdated(data)\"\n                          ng-blur=\"vm.blurHoursUpdated(data)\"\n                          ng-model=\"data.timeInterval.timeInMinutes\"\n                          onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"\n                          title=\"Whole Numbers Only\"\n                        />\n                      </td>\n                      <td>${{ vm.event.subEvents[0].deduppedJobbles[0].payPerHour / 100 | number : 2}}</td>\n                      <td ng-click=\"vm.clearMarkersForCheckIn(data)\">\n                        {{ data.checkInTimeFormat ? data.checkInTimeFormat : \"--\" }}\n                        <i class=\"fas fa-eye\" ng-if=\"data.checkInMarkerSelected\"></i>\n                      </td>\n                      <td ng-click=\"vm.clearMarkersForCheckOut(data)\">\n                        {{ data.checkOutTimeFormat ? data.checkOutTimeFormat : \"--\" }}\n                        <i class=\"fas fa-eye\" ng-if=\"data.checkOutMarkerSelected\"></i>\n                      </td>\n                      <td>${{ data.payment }}</td>\n                      <td>\n                        <!--\n                   \t\t\t\t\t\t\t<div class=\"user-was-paid\" ng-if=\"data.hasBeenPaid == true\">\n                   \t\t\t\t\t\t\t\t<i class=\"far fa-check-circle\"></i>\n                   \t\t\t\t\t\t\t</div>\n                   \t\t\t\t\t\t\t-->\n\n                        <div class=\"btn-group\" ng-if=\"data.isCheckedForPayment!==true\" style=\"padding-left: 5px\">\n                          <button\n                            type=\"button\"\n                            class=\"dropdown-toggle shift-actions\"\n                            data-toggle=\"dropdown\"\n                            aria-haspopup=\"true\"\n                            aria-expanded=\"false\"\n                          >\n                            <i class=\"fa fa-cog\"></i>\n                          </button>\n                          <div class=\"dropdown-menu shifts-actions-button\">\n                            <a ng-if=\"data.hasBeenPaid==true\" class=\"dropdown-item\" href=\"#\" ng-click=\"vm.displayAdditionalPaymentModal(data)\">\n                              <span> Make Additional Payment </span>\n                            </a>\n\n                            <span class=\"italics-pay\" ng-if=\"data.hasBeenPaid!=true\"> Make Additional Payment </span>\n\n                            <a ng-if=\"data.noShow==true\" class=\"dropdown-item\" href=\"#\" ng-click=\"vm.markUserForNoShowForShift(data,false)\">\n                              Cancel No Show\n                            </a>\n                            <a ng-if=\"data.noShow!=true\" class=\"dropdown-item\" href=\"#\" ng-click=\"vm.markUserForNoShowForShift(data,true)\">\n                              Mark As No Show\n                            </a>\n                            <!--\n  \t\t\t\t\t\t\t\t\t\t\t       \t<a class=\"dropdown-item\" href=\"#\">\n  \t\t\t\t\t\t\t\t\t\t\t        \tWrite Review\n  \t\t\t\t\t\t\t\t\t\t\t       \t</a>\n  \t\t\t\t\t\t\t\t\t\t\t       \t<a class=\"dropdown-item\" href=\"#\">\n  \t\t\t\t\t\t\t\t\t\t\t        \tGive Ratiing\n  \t\t\t\t\t\t\t\t\t\t\t       \t</a>\n  \t\t\t\t\t\t\t\t\t\t\t        -->\n\n                            <div class=\"dropdown-divider\"></div>\n                            <a class=\"dropdown-item\" href=\"#\"> Cancel </a>\n                          </div>\n                        </div>\n                      </td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"total-jobblers-details\">\n                  <span style=\"font-size: 17px\">\n                    TOTALS\n                    <strong>{{vm.totalHoursWorkedForEvent()}} HOURS {{vm.totalMinutesWorkedForEvent()}} MINUTES WORKED</strong></span\n                  >\n                  <span style=\"font-size: 17px\">\n                    YOU PAY\n                    <strong>{{vm.totalAmountToBePaidOut()}}</strong></span\n                  >\n                </div>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"map-holder-checkin\">\n                  <div id=\"mapbox\"></div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"row\" ng-if=\"vm.paymentInfos.length > 0\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"shift-dates-holder\">\n                  <h4 class=\"shifts-headers\">Select Payment Method</h4>\n\n                  <table class=\"table table-bordered shiftpayments\">\n                    <tbody>\n                      <tr ng-repeat=\"info in vm.paymentInfos\">\n                        <td>\n                          <input type=\"checkbox\" ng-click=\"vm.setCardToPayment(info)\" ng-checked=\"info.isChecked\" />\n                        </td>\n                        <td>{{info.nickname ? info.nickname : \"--\"}}</td>\n                        <td>{{info.cardBrand}}</td>\n                        <td ng-if=\"info.bankName == null\">{{info.cardExpirationMonth}}/{{info.cardExpirationYear}}</td>\n                        <td ng-if=\"info.bankName != null\">N/A</td>\n                        <td>****{{info.last4}}</td>\n                      </tr>\n                    </tbody>\n                  </table>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <button class=\"btn button btn-success\" ng-click=\"vm.sendPaymentModal()\" ng-disabled=\"vm.disablePaymentButton\">Submit Payment</button>\n              </div>\n            </div>\n\n            <div class=\"row\" ng-if=\"vm.showCloseButton\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <button class=\"btn button btn-success\" ng-click=\"vm.closeEventModal()\" ng-disabled=\"vm.disableCloseButton\">Close Job</button>\n              </div>\n            </div>\n\n            <div class=\"row\" ng-if=\"vm.showReopenButton\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <button class=\"btn button btn-success\" ng-click=\"vm.reOpenJob()\" ng-disabled=\"vm.disableOpenButton\">Reopen Job</button>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<jobblefooter></jobblefooter>\n\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n\n<paymentdialog></paymentdialog>\n\n<div\n  class=\"modal fade\"\n  id=\"modal-complete-event-confirm-modal-shifts\"\n  tabindex=\"-1\"\n  role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\"\n  data-backdrop=\"static\"\n>\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\" style=\"width: 715px\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\" style=\"padding-bottom: 5px; margin-bottom: 30px; border-bottom: 1px solid #eee\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n            </button>\n\n            <strong> Payment Review And Confirmation </strong>\n          </div>\n\n          <div class=\"modal-body\" style=\"padding-top: 0px\">\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <table class=\"table table-bordered shiftpayments\">\n                  <thead>\n                    <tr>\n                      <th>Line item</th>\n                      <th>Amount</th>\n                    </tr>\n                  </thead>\n\n                  <tbody>\n                    <tr>\n                      <td style=\"padding-top: 13px; font-size: 14px; text-align: left\">Jobblers ({{vm.paymentList.length}})</td>\n                      <td style=\"padding-top: 13px; font-size: 14px; text-align: left\">{{ vm.totalAmountToBePaidOut() }}</td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n              <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\" style=\"text-align: left\">\n                <a class=\"btn btn-danger button\" href=\"\" style=\"background-color: #d9534f\" data-dismiss=\"modal\"> Cancel </a>\n              </div>\n\n              <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\" style=\"text-align: right\">\n                <a class=\"btn btn-success button\" href=\"\" data-dismiss=\"modal\" ng-if=\"vm.completeButton !== 'OK'\" ng-click=\"vm.sendPayment()\">\n                  Confirm\n                </a>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div\n  class=\"modal fade\"\n  id=\"modal-complete-event-close-job\"\n  tabindex=\"-1\"\n  role=\"dialog\"\n  aria-labelledby=\"modal-add-projectLabel\"\n  data-backdrop=\"static\"\n>\n  <div class=\"vertical-alignment-helper\">\n    <div class=\"modal-dialog vertical-align-center\">\n      <div class=\"modal-dialog popup\" style=\"width: 715px\">\n        <div class=\"modal-content popup-content\">\n          <div class=\"modal-header popup-header text-center\" style=\"padding-bottom: 5px; margin-bottom: 30px; border-bottom: 1px solid #eee\">\n            <button type=\"button\" class=\"close popup-close\" data-dismiss=\"modal\" aria-label=\"Close\">\n              <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n            </button>\n\n            <h4>Complete and Close Job</h4>\n          </div>\n\n          <div class=\"modal-body\" style=\"padding-top: 0px\">\n            <div class=\"row\">\n              <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <p>\n                  Please ensure all users have either been paid or marked as a no-show. Once a job is closed out, you will no longer be able to make\n                  edits.\n                </p>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"modal-footer\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n              <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\" style=\"text-align: left\">\n                <a class=\"btn btn-danger button\" href=\"\" style=\"background-color: #d9534f\" data-dismiss=\"modal\"> Cancel </a>\n              </div>\n\n              <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\" style=\"text-align: right\">\n                <a class=\"btn btn-success button\" href=\"\" data-dismiss=\"modal\" ng-if=\"vm.completeButton !== 'OK'\" ng-click=\"vm.closeJob()\">\n                  Confirm\n                </a>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"apply-profile-modal\">\n  <div class=\"modal\" id=\"additional-shift-payment\" tabindex=\"-1\" role=\"dialog\" style=\"position: fixed\">\n    <div class=\"modal-dialog modal-m regi-form-board partner\" role=\"document\" style=\"width: 385px\">\n      <div class=\"modal-gradient-banner\"></div>\n\n      <div class=\"modal-content\">\n        <div class=\"modal-fixed-bar\">\n          <div class=\"save-exit\" ng-click=\"vm.exit()\">\n            <i class=\"fas fa-times\"></i>\n          </div>\n        </div>\n        <div class=\"modal-content-container\">\n          <p ng-if=\"vm.company.payByInvoice !== true\">Please select a payment method and than input the additional amount owed.</p>\n\n          <p ng-if=\"vm.company.payByInvoice === true\">Please input the additional amount owed. You will be invoiced this payment at a later time.</p>\n\n          <table class=\"table table-bordered shiftpayments\" ng-if=\"vm.company.payByInvoice !== true\">\n            <tbody>\n              <tr ng-repeat=\"info in vm.paymentInfos\">\n                <td>\n                  <input type=\"checkbox\" ng-click=\"vm.setCardToPayment(info,true)\" ng-checked=\"info.isChecked\" style=\"height: auto\" />\n                </td>\n                <td ng-if=\"info.bankName == null\">{{info.cardExpirationMonth}}/{{info.cardExpirationYear}}</td>\n                <td ng-if=\"info.bankName != null\">N/A</td>\n                <td>****-{{info.last4}}</td>\n              </tr>\n            </tbody>\n          </table>\n\n          <form class=\"additional-payment-form\">\n            <label>Amount</label>\n            <div class=\"holder\">\n              <!--\n                    \t\t<i class=\"fas fa-dollar-sign\"></i>\n                    \t\t-->\n              <input type=\"number\" class=\"form-control form-input\" ng-model=\"vm.additionalMonies\" ng-change=\"vm.moniesChanging()\" />\n            </div>\n\n            <div\n              style=\"\n                font-size: 12px;\n                font-weight: 600;\n                letter-spacing: 0.4px;\n                padding: 16px;\n                margin: auto;\n                margin-top: 32px;\n                width: 100%;\n                max-width: 276px;\n                border-radius: 6px;\n                border: 1px solid #979797;\n                box-shadow: 0 25px 50px 0 rgba(78, 81, 144, 0.07);\n              \"\n            >\n              <div style=\"font-size: 16px\"><i style=\"margin-right: 8px\" class=\"fas fa-receipt\"></i>Estimated cost summary</div>\n              <div style=\"width: 100%; height: 1px; background: #979797; margin: 16px 0\"></div>\n              <div>\n                <div style=\"display: flex; margin-bottom: 8px\">\n                  <div style=\"flex: 1\">\n                    <em>YOU WILL BE CHARGED</em>\n                  </div>\n                  <div style=\"flex: 0 0 30px; text-align: right\" class=\"ng-binding\">\n                    ${{ vm.additionalMonies * (1 + vm.currentUser.company.defaultPlan.companyFeePct) | number : 2 }}\n                  </div>\n                </div>\n                <div style=\"display: flex; margin-bottom: 8px\">\n                  <div style=\"flex: 1\">\n                    <em>PLATFORM FEE</em>\n                  </div>\n                  <div style=\"flex: 0 0 30px; text-align: right\" class=\"ng-binding\">\n                    ${{ (vm.additionalMonies * (1 + vm.currentUser.company.defaultPlan.companyFeePct)) - (vm.additionalMonies * (1 -\n                    vm.currentUser.company.defaultPlan.jobblerFeePct)) | number : 2 }}\n                  </div>\n                </div>\n                <div style=\"display: flex; margin-bottom: 8px\">\n                  <div style=\"flex: 1\">\n                    <em>THE JOBBLER WILL RECEIVE</em>\n                  </div>\n                  <div style=\"flex: 0 0 30px; text-align: right\" class=\"ng-binding\">\n                    ${{ vm.additionalMonies * (1 - vm.currentUser.company.defaultPlan.jobblerFeePct) | number : 2 }}\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"main-next-button-additional-payment\" ng-class=\"{'disabled': vm.disablePaymentButton }\" ng-click=\"vm.sendAdditionalPayment()\">\n              Submit Payment\n            </div>\n          </form>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _teams = __webpack_require__(563);
	
	var _teams2 = _interopRequireDefault(_teams);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PayshiftsController = function () {
	  function PayshiftsController($http, $localStorage, $state, AuthService, EventService, TeamsService, CompaniesService, SecurityService, $stateParams, CommonService, $rootScope, EnvService, $timeout, $location, ngProgressFactory) {
	    _classCallCheck(this, PayshiftsController);
	
	    this.name = "payshifts";
	    $localStorage.activeStateName = "payshifts";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$teams = TeamsService;
	    this.$stateParams = $stateParams;
	    this.$companies = CompaniesService;
	    this.$security = SecurityService;
	    this.$stateParams = $stateParams;
	    this.$common = CommonService;
	    this.$rootScope = $rootScope;
	    this.$events = EventService;
	    this.$progress = ngProgressFactory.createInstance();
	    this.$env = EnvService;
	    this.remain_loading_count = 1;
	    this.totalPayment = 0;
	    this.$timeout = $timeout;
	    this.totalMinutesWorkedForEntireJob = 0;
	    this.totalPaymentDisplay = 0;
	    this.allChecked = false;
	    this.currentUser = this.$auth.getUserData();
	    this.currentPageNumber = 1;
	    this.disablePaymentButton = true;
	    this.currentMarkers = [];
	    this.paymentList = [];
	    this.bulkCheck = false;
	    this.$location = $location;
	    this.invoice = false;
	
	    var _this = this;
	
	    this.getEvent();
	
	    _this.organizePaymentOptions(_this.currentUser);
	  }
	
	  _createClass(PayshiftsController, [{
	    key: "getEvent",
	    value: function getEvent() {
	      var _this = this;
	
	      var eventId = this.$stateParams.eventId;
	
	      _this.setLoader();
	
	      _this.$events.getEventByIdTrimmedRoster(eventId).then(function (response) {
	        _this.event = response.data;
	        _this.setEventToSideBar();
	        _this.sortShifts();
	      }, function (error) {
	        alert("Something has gone wrong. Please contact support.");
	      });
	    }
	  }, {
	    key: "setEventToSideBar",
	    value: function setEventToSideBar() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        _this.$rootScope.$emit("SetEventToEventDialog", {
	          event: _this.event
	        });
	        _this.$rootScope.$emit("SetEventToEventSidebar", {
	          event: _this.event
	        });
	      }, 100);
	
	      if (_this.event.isCompleted === true) {
	        _this.$timeout(function () {
	          $("eventsidebar .jobs-complete-sidebar  aside li:nth-child(6)").removeClass().addClass("active");
	        }, 1500);
	      } else {
	        _this.$timeout(function () {
	          $("eventsidebar .jobs-complete-sidebar  aside li:nth-child(9)").removeClass().addClass("active");
	        }, 1500);
	      }
	    }
	  }, {
	    key: "sortShifts",
	    value: function sortShifts() {
	      var _this = this;
	
	      var shifts = _this.event.subEvents[0].deduppedJobbles[0].shifts;
	
	      try {
	        shifts.forEach(function (shift, index) {
	          shift.startTimeFormatted = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("ddd MMM DD hh:mm A");
	          shift.endTimeFormatted = moment(shift.timeInterval.endTime).tz(shift.contactInfo.place.timeZoneId).format("ddd MMM DD hh:mm A");
	        });
	      } catch (err) {
	        console.log("error processing shifts");
	        console.dir(err);
	      } finally {
	        shifts.sort(function (a, b) {
	          return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
	        });
	
	        shifts[0].isActive = true;
	
	        _this.findCallToActions(shifts);
	
	        if (shifts.length === 1 && _this.event.isCompleted !== true) {
	          _this.showCloseButton = true;
	        } else if (shifts.length === 1 && _this.event.isCompleted === true) {
	          _this.showReopenButton = true;
	        }
	
	        _this.shifts = shifts;
	
	        if (_this.$location.$$search.shiftPosition) {
	          _this.setActiveShift(_this.$location.$$search.shiftPosition);
	        } else {
	          _this.setActiveShift();
	        }
	
	        if (_this.$location.$$search.shiftId) {
	          var s = {};
	          s.id = _this.$location.$$search.shiftId;
	          _this.getRosterForFirstShift(s);
	        } else {
	          _this.getRosterForFirstShift();
	        }
	      }
	    }
	  }, {
	    key: "getRosterForFirstShift",
	    value: function getRosterForFirstShift(shift) {
	      var _this = this;
	
	      var shiftId = null;
	
	      if (shift) {
	        shiftId = shift.id;
	      } else {
	        shiftId = _this.shifts[0].id;
	      }
	
	      _this.$events.getShiftsInSamePosition(shiftId).then(function (response) {
	        var shiftsAndUsers = response.data;
	
	        _this.sortByLastName(shiftsAndUsers);
	      }, function (error) {
	        console.log("in error");
	        console.dir(error);
	      });
	    }
	  }, {
	    key: "sortByLastName",
	    value: function sortByLastName(shiftsAndUsers) {
	      var _this = this;
	
	      var users = [];
	      var emptyShifts = [];
	
	      shiftsAndUsers.forEach(function (shift) {
	        if (shift.applicant) {
	          shift.isCheckedForPayment = false;
	          users.push(shift);
	        } else {
	          emptyShifts.push(shift);
	        }
	
	        shift.checkInMarkerSelected = false;
	        shift.checkOutMarkerSelected = false;
	      });
	
	      users.sort(function (a, b) {
	        if (a.applicant && b.applicant) {
	          if (a.applicant.lastName < b.applicant.lastName) return -1;
	          if (a.applicant.lastName > b.applicant.lastName) return 1;
	          return 0;
	        }
	      });
	
	      _this.emptyShifts = emptyShifts;
	      _this.calculateTimeWorked(users);
	    }
	  }, {
	    key: "checkUserForPayment",
	    value: function checkUserForPayment(data) {
	      var _this = this;
	
	      if (data.isCheckedForPayment === true) {
	        data.isCheckedForPayment = false;
	        _this.removeUserFromPaymentList(data);
	      } else {
	        data.isCheckedForPayment = true;
	        _this.addUserToPaymentList(data);
	      }
	    }
	  }, {
	    key: "removeUserFromPaymentList",
	    value: function removeUserFromPaymentList(data) {
	      var _this = this;
	
	      var x = _this.paymentList.findIndex(function (obj) {
	        return obj.id == data.id;
	      });
	
	      _this.paymentList.splice(x, 1);
	      _this.removeMinutesToTotal(data);
	      _this.removeMoneyToTotal(data);
	      _this.disablePaymentButtonFunc();
	    }
	  }, {
	    key: "addUserToPaymentList",
	    value: function addUserToPaymentList(data) {
	      var _this = this;
	
	      _this.paymentList.push(data);
	      _this.addMinutesToTotal(data);
	      _this.addMoneyToTotal(data);
	      _this.disablePaymentButtonFunc();
	    }
	  }, {
	    key: "sendPaymentModal",
	    value: function sendPaymentModal() {
	      var _this = this;
	
	      if (!_this.transferData && _this.invoice === true) {
	        var req = {};
	        req.card = null;
	        _this.transferData = req;
	      }
	
	      _this.$timeout(function () {
	        $("#modal-complete-event-confirm-modal-shifts").modal();
	      });
	    }
	  }, {
	    key: "closeEventModal",
	    value: function closeEventModal() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("#modal-complete-event-close-job").modal();
	      });
	    }
	  }, {
	    key: "closeJob",
	    value: function closeJob() {
	      var _this = this;
	
	      _this.setLoader();
	
	      _this.$events.closeEvent(_this.event.id).then(function (response) {
	        _this.unSetLoader();
	        _this.$timeout(function () {
	          _this.$state.go("jobsdashboard");
	        }, 300);
	      }, function (error) {
	        console.log("error");
	        console.dir(error);
	        _this.unSetLoader();
	        alert("Error: " + error);
	      });
	    }
	  }, {
	    key: "sendPayment",
	    value: function sendPayment() {
	      var _this = this;
	
	      var transferArray = [];
	
	      _this.setLoader();
	      _this.$progress.start();
	
	      try {
	        _this.paymentList.forEach(function (shift) {
	          var data = {};
	          var amount = shift.payment * 100;
	
	          data.recipient = shift.applicant.username;
	          if (_this.isModalPayment) {
	            data.amount = _this.additionalMonies * 100;
	          } else {
	            data.amount = amount;
	          }
	
	          data.note = "Payment";
	          data.shift = shift.id;
	
	          transferArray.push(data);
	        });
	      } finally {
	        console.log("what is the transfer array");
	        console.dir(transferArray);
	
	        if (!_this.transferData) {
	          //invoice payment from modal
	          _this.transferData = {};
	        }
	
	        _this.transferData.transfers = transferArray;
	
	        console.log("transferData");
	        console.dir(_this.transferData);
	
	        _this.postPayment();
	      }
	    }
	  }, {
	    key: "postPayment",
	    value: function postPayment() {
	      var _this = this;
	
	      _this.$events.payUsersByShift(_this.transferData).then(function (response) {
	        console.log("response");
	        console.dir(response);
	        _this.$progress.complete();
	        _this.findUsersInTransferAndUpdateUI();
	        _this.allChecked = false;
	        _this.transferData = {};
	        _this.paymentList = [];
	        _this.totalPayment = 0;
	        _this.totalMinutesWorkedForEntireJob = 0;
	        _this.disablePaymentButton = true;
	        _this.additionalMonies = 0;
	        //_this.isModalPayment = false;
	        _this.totalPaymentDisplay = 0;
	        _this.unSetLoader();
	        _this.uncheckPaymentInfo();
	      }, function (error) {
	        _this.$progress.complete();
	        _this.unSetLoader();
	        console.log("transfer error");
	        console.dir(error);
	        alert("Error : " + error);
	      });
	    }
	  }, {
	    key: "findUsersInTransferAndUpdateUI",
	    value: function findUsersInTransferAndUpdateUI() {
	      var _this = this;
	
	      console.log("findUsersInTransferAndUpdateUI");
	      console.log("_this.transferData_this.transferData_this.transferData_this.transferData");
	      console.dir(_this.transferData);
	      console.dir(_this.shiftsWithUsers);
	
	      try {
	        _this.transferData.transfers.forEach(function (item, i) {
	          console.log("each transfer");
	          console.dir(item);
	
	          var x = _this.shiftsWithUsers.findIndex(function (obj) {
	            return obj.applicant.username == item.recipient;
	          });
	
	          console.log("_this.shiftsWithUsers[x]");
	          console.dir(_this.shiftsWithUsers[x]);
	          console.dir(_this.isModalPayment);
	
	          _this.shiftsWithUsers[x].hasBeenPaid = true;
	          _this.shiftsWithUsers[x].hasNoPaymentInfo = false;
	
	          if (_this.isModalPayment) {
	            console.log("we should be here");
	
	            _this.shiftsWithUsers[x].payment = ((_this.shiftsWithUsers[x].payment * 100 + item.amount) / 100).toFixed(2);
	          }
	
	          _this.shiftsWithUsers[x].isCheckedForPayment = false;
	        });
	      } finally {
	        console.log("what is the shift with users after some processing");
	        console.dir(_this.shiftsWithUsers);
	        if (_this.isModalPayment) {
	          _this.isModalPayment = false;
	          _this.exit();
	        }
	      }
	    }
	  }, {
	    key: "uncheckPaymentInfo",
	    value: function uncheckPaymentInfo() {
	      var _this = this;
	
	      _this.paymentInfos.forEach(function (info) {
	        info.isChecked = false;
	      });
	    }
	  }, {
	    key: "setCardToPayment",
	    value: function setCardToPayment(data, isModalPayment) {
	      var _this = this;
	
	      console.log("setCardToPayment");
	      console.dir(data);
	
	      if (isModalPayment) {
	        _this.isModalPayment = true;
	      }
	
	      var req = {};
	
	      _this.uncheckPaymentInfo();
	
	      if (data.isChecked === true) {
	        data.isChecked = false;
	        req.card = null;
	      } else {
	        data.isChecked = true;
	        req.card = data.cardToken;
	      }
	
	      _this.transferData = req;
	
	      console.log("transfer data");
	      console.dir(_this.transferData);
	      console.dir(_this.paymentList);
	
	      if (isModalPayment) {
	        if (_this.transferData.card !== null && _this.additionalMonies > 4) {
	          console.log("additionmondies");
	          console.dir(_this.additionalMonies);
	          _this.disablePaymentButton = false;
	        } else {
	          _this.disablePaymentButton = true;
	        }
	      } else {
	        if (_this.transferData.card !== null && _this.paymentList.length > 0) {
	          _this.disablePaymentButton = false;
	        } else {
	          _this.disablePaymentButton = true;
	        }
	      }
	    }
	  }, {
	    key: "addMinutesToTotal",
	    value: function addMinutesToTotal(data) {
	      var _this = this;
	
	      var mins = null;
	
	      if (data.actualMinutesWorked === null) {
	        mins = data.totalMinutes;
	      } else {
	        mins = data.actualMinutesWorked;
	      }
	
	      _this.totalMinutesWorkedForEntireJob = _this.totalMinutesWorkedForEntireJob + mins;
	    }
	  }, {
	    key: "removeMinutesToTotal",
	    value: function removeMinutesToTotal(data) {
	      var _this = this;
	
	      var mins = null;
	
	      console.log("removeMinutesToTotal");
	      console.dir(data);
	      console.dir(_this.totalMinutesWorkedForEntireJob);
	
	      if (data.actualMinutesWorked === null) {
	        mins = data.totalMinutes;
	      } else {
	        mins = data.actualMinutesWorked;
	      }
	
	      _this.totalMinutesWorkedForEntireJob = _this.totalMinutesWorkedForEntireJob - mins;
	
	      console.log("at the end...");
	      console.dir(_this.totalMinutesWorkedForEntireJob);
	    }
	  }, {
	    key: "setEditing",
	    value: function setEditing(data, val, index) {
	      var _this = this;
	
	      var i = index + 1;
	
	      console.log("what is the value");
	      console.dir(val);
	
	      if (data.hasBeenPaid === true) {
	        return;
	      }
	
	      if (data.noShow === true) {
	        return;
	      }
	
	      if (data.isCheckedForPayment === true) {
	        return;
	      }
	
	      if (val === "hours") {
	        data.isEditingHours = true;
	      } else {
	        data.isEditingMinutes = true;
	      }
	
	      //data.isEditing = true;
	
	      console.log("check jquery");
	      console.dir(val);
	      console.dir($("table.table.table-bordered.shiftpayments:first-child tbody tr td input"));
	      console.log("what is the data after all this");
	      console.dir(data);
	      /*
	      _this.$timeout(function(){
	      $('table.table.table-bordered.shiftpayments:first-child tbody tr td input').get(i).focus();
	      },50);
	      */
	    }
	  }, {
	    key: "calculateTimeWorked",
	    value: function calculateTimeWorked(users) {
	      var _this = this;
	
	      try {
	        users.forEach(function (user) {
	          var hours = null;
	          var minutes = null;
	          var hoursRounded = null;
	          var momentET = null;
	          var momentST = null;
	          var totalMinutes = null;
	          var minutesMod = null;
	
	          user.isEditingHours = false;
	          user.isEditingMinutes = false;
	
	          if (user.actualMinutesWorked !== null) {
	            console.log("we have actualMinutes worked data");
	
	            totalMinutes = user.actualMinutesWorked;
	            hoursRounded = Math.floor(totalMinutes / 60);
	            minutesMod = totalMinutes % 60;
	
	            console.log("final times");
	            console.dir(hoursRounded);
	            console.dir(minutesMod);
	
	            if (user.paymentStats.amount === null) {
	              user.payment = (totalMinutes * _this.event.subEvents[0].deduppedJobbles[0].payPerHour / 100 / 60).toFixed(2);
	            } else {
	              user.payment = (user.paymentStats.amount / 100).toFixed(2);
	            }
	
	            console.log("user.payment");
	            console.dir(totalMinutes * _this.event.subEvents[0].deduppedJobbles[0].payPerHour / 100 / 60);
	            console.dir(user.payment);
	            user.totalMinutes = totalMinutes;
	            user.timeInterval.timeInHours = hoursRounded;
	            user.timeInterval.timeInMinutes = minutesMod;
	          } else {
	            console.log("no we have actualMinutes worked data");
	            console.dir(user);
	
	            momentET = moment(user.timeInterval.endTime).tz("America/New_York");
	            momentST = moment(user.timeInterval.startTime).tz("America/New_York");
	
	            totalMinutes = moment(momentET).diff(moment(momentST), "minutes");
	            user.totalMinutes = totalMinutes;
	            hoursRounded = Math.floor(totalMinutes / 60);
	            minutesMod = totalMinutes % 60;
	
	            console.log("final times");
	            console.dir(hoursRounded);
	            console.dir(minutesMod);
	
	            if (user.paymentStats.amount === null) {
	              user.payment = (totalMinutes * _this.event.subEvents[0].deduppedJobbles[0].payPerHour / 100 / 60).toFixed(2);
	            } else {
	              user.payment = (user.paymentStats.amount / 100).toFixed(2);
	            }
	
	            console.log("user.payment");
	            console.dir(totalMinutes * _this.event.subEvents[0].deduppedJobbles[0].payPerHour / 100 / 60);
	            console.dir(user.payment);
	
	            user.timeInterval.timeInHours = hoursRounded;
	            user.timeInterval.timeInMinutes = minutesMod;
	          }
	
	          if (user.paymentStats.amount !== null) {
	            user.hasBeenPaid = true;
	          }
	
	          if (user.hasBeenPaid !== true) {
	            if (user.applicant.undeletedPaymentInfos) {
	              console.log("what are the undeleted payment infos");
	              console.dir(user.applicant.undeletedPaymentInfos);
	              if (user.applicant.undeletedPaymentInfos.length === 0 && user.applicant.currentPaymentMethod === null) {
	                user.hasNoPaymentInfo = true;
	              }
	            }
	          }
	
	          if (user.checkInTime) {
	            user.checkInTimeFormat = moment(user.checkInTime).tz(user.contactInfo.place.timeZoneId).format("hh:mm A");
	          }
	
	          if (user.checkOutTime) {
	            user.checkOutTimeFormat = moment(user.checkOutTime).tz(user.contactInfo.place.timeZoneId).format("hh:mm A");
	          }
	        });
	      } catch (err) {
	        console.log("in loop error");
	        console.dir(err);
	      } finally {
	        _this.$timeout(function () {
	          _this.shiftsWithUsers = users;
	          _this.initializeMap();
	          _this.initializeToolTip();
	        }, 300);
	
	        _this.$timeout(function () {
	          _this.unSetLoader();
	        }, 300);
	      }
	    }
	  }, {
	    key: "initializeToolTip",
	    value: function initializeToolTip() {
	      this.$timeout(function () {
	        $(function () {
	          $('[data-toggle="tooltip"]').tooltip();
	        });
	      }, 500);
	    }
	  }, {
	    key: "initializeMap",
	    value: function initializeMap() {
	      var _this = this;
	
	      var mapBoxKey = _this.$env.EnvironmentConfig.mapbox;
	
	      mapboxgl.accessToken = mapBoxKey;
	
	      console.log("lets take a look at contact info");
	      console.dir(_this.event.contactInfo);
	
	      var zip = _this.event.contactInfo.zipCode;
	      var street = _this.event.contactInfo.streetLine1;
	      var city = _this.event.contactInfo.city;
	      var state = _this.event.contactInfo.state;
	
	      var location = street + " " + city + ", " + state + " " + zip;
	      //_this.event
	
	      console.log("final location");
	      console.dir(location);
	
	      var mapboxClient = mapboxSdk({ accessToken: mapboxgl.accessToken });
	
	      mapboxClient.geocoding.forwardGeocode({
	        query: location,
	        autocomplete: false,
	        limit: 1
	      }).send().then(function (response) {
	        if (response && response.body && response.body.features && response.body.features.length) {
	          var feature = response.body.features[0];
	
	          console.log("feature", feature);
	
	          var options = {};
	
	          options.color = "#000";
	          options.scale = 2;
	          options.anchor = "bottom";
	
	          var map = new mapboxgl.Map({
	            container: "mapbox",
	            style: "mapbox://styles/mapbox/streets-v11",
	            center: feature.center,
	            zoom: 11
	          });
	
	          new mapboxgl.Marker(options).setLngLat(feature.center).addTo(map);
	
	          _this.map = map;
	          _this.plotUsers(map);
	        } else {
	          alert("There was an issue finding the location of the job.");
	        }
	      });
	    }
	  }, {
	    key: "plotUsers",
	    value: function plotUsers(map) {
	      var _this = this;
	
	      console.log("plot users");
	      console.dir(map);
	      console.dir(_this.shiftsWithUsers);
	
	      var arrayOfUsersAndCoords = [];
	
	      /*
	      let geoJson = {
	      'type': 'geojson',
	      'data': {
	      'type': 'FeatureCollection',
	      'features': []
	      }
	      }
	      */
	
	      _this.shiftsWithUsers.forEach(function (data) {
	        if (data.checkInCoord) {
	          if (data.checkInCoord.lat && data.checkInCoord.lng) {
	            arrayOfUsersAndCoords.push(data);
	
	            var options = {};
	
	            var note = null;
	
	            if (data.jobblerNote) {
	              note = data.jobblerNote;
	            } else {
	              note = "--";
	            }
	
	            options.color = "#74cf59";
	            var popUpText = "<div id='mapPopup'><h4>" + data.applicant.firstName + " " + data.applicant.lastName + "</h4></div><div class='note-holder'> <strong>Note:</strong> " + note + "</div>";
	            var currentMarker = new mapboxgl.Marker(options).setLngLat([data.checkInCoord.lng, data.checkInCoord.lat]).setPopup(new mapboxgl.Popup().setHTML(popUpText)).addTo(_this.map);
	
	            _this.currentMarkers.push(currentMarker);
	          }
	        }
	
	        if (data.checkOutCoord) {
	          if (data.checkOutCoord.lat && data.checkOutCoord.lng) {
	            arrayOfUsersAndCoords.push(data);
	
	            var _options = {};
	
	            var _note = null;
	
	            if (data.jobblerNote) {
	              _note = data.jobblerNote;
	            } else {
	              _note = "--";
	            }
	
	            _options.color = "#dc3545";
	            var _popUpText = "<div id='mapPopup'><h4>" + data.applicant.firstName + " " + data.applicant.lastName + "</h4></div><div class='note-holder'> <strong>Note:</strong> " + _note + "</div>";
	            var _currentMarker = new mapboxgl.Marker(_options).setLngLat([data.checkOutCoord.lng, data.checkOutCoord.lat]).setPopup(new mapboxgl.Popup().setHTML(_popUpText)).addTo(_this.map);
	
	            _this.currentMarkers.push(_currentMarker);
	          }
	        }
	      });
	    }
	  }, {
	    key: "clearIconForRest",
	    value: function clearIconForRest(data) {
	      var _this = this;
	
	      console.log("clearIconForRest");
	      console.dir(data);
	
	      _this.shiftsWithUsers.forEach(function (item) {
	        console.log("each item");
	        console.dir(item);
	        if (item.id !== data.id) {
	          item.checkOutMarkerSelected = false;
	          item.checkInMarkerSelected = false;
	        }
	      });
	    }
	  }, {
	    key: "determineEyeIconCheckIn",
	    value: function determineEyeIconCheckIn(data) {
	      var _this = this;
	
	      console.log("determineEyeIconCheckIn");
	      console.dir(data);
	
	      if (data.checkInMarkerSelected === false) {
	        data.checkOutMarkerSelected = false;
	        data.checkInMarkerSelected = true;
	
	        _this.clearIconForRest(data);
	      } else {
	        data.checkInMarkerSelected = false;
	        data.checkOutMarkerSelected = false;
	        _this.clearMarkers();
	      }
	    }
	  }, {
	    key: "determineEyeIconCheckOut",
	    value: function determineEyeIconCheckOut(data) {
	      var _this = this;
	
	      console.log("determineEyeIconCheckOut");
	      console.dir(data);
	
	      if (data.checkOutMarkerSelected === false) {
	        data.checkOutMarkerSelected = true;
	        data.checkInMarkerSelected = false;
	        _this.clearIconForRest(data);
	      } else {
	        data.checkOutMarkerSelected = false;
	        data.checkInMarkerSelected = false;
	        _this.clearMarkers();
	      }
	    }
	  }, {
	    key: "clearMarkers",
	    value: function clearMarkers() {
	      var _this = this;
	
	      console.log("clearMarkersForCheckOut");
	      console.dir(_this.currentMarkers);
	
	      if (_this.currentMarkers.length > 0) {
	        try {
	          _this.currentMarkers.forEach(function (marker) {
	            console.log("each marker");
	            console.dir(marker);
	            marker.remove();
	          });
	        } catch (err) {
	          console.log("error removing markerings");
	          console.dir(err);
	        }
	      }
	    }
	  }, {
	    key: "clearMarkersForCheckIn",
	    value: function clearMarkersForCheckIn(data) {
	      var _this = this;
	
	      console.log("clearMarkersForCheckOut");
	      console.dir(data);
	      console.dir(_this.currentMarkers);
	
	      if (_this.currentMarkers.length > 0) {
	        try {
	          _this.currentMarkers.forEach(function (marker) {
	            console.log("each marker");
	            console.dir(marker);
	            marker.remove();
	          });
	        } catch (err) {
	          console.log("error removing markerings");
	          console.dir(err);
	        } finally {
	          _this.placeSingleCheckinMarker(data);
	        }
	      }
	    }
	  }, {
	    key: "placeSingleCheckinMarker",
	    value: function placeSingleCheckinMarker(data) {
	      var _this = this;
	
	      console.log("placeSingleCheckinMarker");
	      console.dir(data);
	      if (data.checkInCoord) {
	        if (data.checkInCoord.lat && data.checkInCoord.lng) {
	          var options = {};
	
	          var note = null;
	
	          if (data.jobblerNote) {
	            note = data.jobblerNote;
	          } else {
	            note = "--";
	          }
	
	          options.color = "#74cf59";
	          var popUpText = "<div id='mapPopup'><h4>" + data.applicant.firstName + " " + data.applicant.lastName + "</h4></div><div class='note-holder'> <strong>Note:</strong> " + note + "</div>";
	          var currentMarker = new mapboxgl.Marker(options).setLngLat([data.checkInCoord.lng, data.checkInCoord.lat]).setPopup(new mapboxgl.Popup().setHTML(popUpText)).addTo(_this.map);
	
	          _this.currentMarkers.push(currentMarker);
	          _this.determineEyeIconCheckIn(data);
	        } else {
	          alert("This user does not have any check in coordinates");
	        }
	      } else {
	        alert("This user does not have any checkin coordinates");
	      }
	    }
	  }, {
	    key: "placeSingleCheckOutMarker",
	    value: function placeSingleCheckOutMarker(data) {
	      var _this = this;
	
	      console.log("placeSingleCheckOutMarker");
	      console.dir(data);
	      if (data.checkOutCoord) {
	        if (data.checkOutCoord.lat && data.checkOutCoord.lng) {
	          var options = {};
	
	          var note = null;
	
	          if (data.jobblerNote) {
	            note = data.jobblerNote;
	          } else {
	            note = "--";
	          }
	
	          options.color = "#dc3545";
	          var popUpText = "<div id='mapPopup'><h4>" + data.applicant.firstName + " " + data.applicant.lastName + "</h4></div><div class='note-holder'> <strong>Note:</strong> " + note + "</div>";
	          var currentMarker = new mapboxgl.Marker(options).setLngLat([data.checkOutCoord.lng, data.checkOutCoord.lat]).setPopup(new mapboxgl.Popup().setHTML(popUpText)).addTo(_this.map);
	
	          _this.currentMarkers.push(currentMarker);
	          _this.determineEyeIconCheckOut(data);
	        } else {
	          alert("This user does not have any checkout coordinates");
	        }
	      } else {
	        alert("This user does not have any checkout coordinates");
	      }
	    }
	  }, {
	    key: "clearMarkersForCheckOut",
	    value: function clearMarkersForCheckOut(data) {
	      var _this = this;
	
	      console.log("clearMarkersForCheckOut");
	      console.dir(data);
	      console.dir(_this.currentMarkers);
	
	      if (_this.currentMarkers.length > 0) {
	        try {
	          _this.currentMarkers.forEach(function (marker) {
	            console.log("each marker");
	            console.dir(marker);
	            marker.remove();
	          });
	        } catch (err) {
	          console.log("error removing markerings");
	          console.dir(err);
	        } finally {
	          _this.placeSingleCheckOutMarker(data);
	        }
	      }
	    }
	  }, {
	    key: "updateHoursWorked",
	    value: function updateHoursWorked(data) {
	      var _this = this;
	
	      //after this is called we can calculate what they are owed with the below funnction
	
	      console.log("updateHoursWorked");
	      console.dir(data);
	
	      var minutes = data.timeInterval.timeInHours * 60;
	      var shiftId = data.id;
	
	      minutes = minutes + data.timeInterval.timeInMinutes;
	
	      console.log("total minutes");
	      console.dir(minutes);
	
	      _this.setLoader();
	
	      data.actualMinutesWorked = minutes;
	
	      _this.$events.updateActualMinutesWorkedForShift(shiftId, minutes).then(function (response) {
	        console.log("response");
	        console.dir(response);
	        _this.unSetLoader();
	
	        _this.updateCostOfWork(data);
	      }, function (error) {
	        console.log("in error");
	        console.dir(error);
	        _this.unSetLoader();
	      });
	    }
	  }, {
	    key: "updateCostOfWork",
	    value: function updateCostOfWork(data) {
	      var _this = this;
	
	      console.dir("updateCostOfWork");
	      console.dir(data);
	
	      data.payment = (data.actualMinutesWorked * _this.event.subEvents[0].deduppedJobbles[0].payPerHour / 100 / 60).toFixed(2);
	    }
	  }, {
	    key: "enterHoursUpdated",
	    value: function enterHoursUpdated(data) {
	      var _this = this;
	
	      console.log("enterHoursUpdated");
	      console.dir(data);
	
	      data.isEditingHours = false;
	      data.isEditingMinutes = false;
	
	      _this.updateHoursWorked(data);
	      /*
	      _this.$timeout(function(){
	      $('#modal-edit-shifts .modal-body .has-focus-job').focus();
	      });
	      */
	    }
	  }, {
	    key: "blurHoursUpdated",
	    value: function blurHoursUpdated(data) {
	      var _this = this;
	
	      console.log("blurHoursUpdated");
	      console.dir(data);
	
	      data.isEditingHours = false;
	      data.isEditingMinutes = false;
	
	      _this.updateHoursWorked(data);
	    }
	  }, {
	    key: "checkForCallToActionFunc",
	    value: function checkForCallToActionFunc(list) {
	      var _this = this;
	
	      console.log("checkForCallToActionFunc");
	      console.dir(list);
	    }
	  }, {
	    key: "loadDifferentShifts",
	    value: function loadDifferentShifts(shift, index) {
	      var _this = this;
	
	      var checkForCallToActionArray = _this.shiftsWithUsers;
	
	      var plusOne = index + 1;
	
	      console.log("compare");
	      console.dir(_this.shifts.length);
	      console.dir(index);
	      console.dir(plusOne);
	      if (_this.shifts.length === plusOne && _this.event.isCompleted !== true) {
	        _this.showCloseButton = true;
	      } else {
	        _this.showCloseButton = false;
	      }
	      if (_this.shifts.length === plusOne && _this.event.isCompleted === true) {
	        _this.showReopenButton = true;
	      } else {
	        _this.showReopenButton = false;
	      }
	      _this.checkForCallToActionFunc(checkForCallToActionArray);
	      _this.paymentList = [];
	
	      console.log("loadDifferentShifts");
	      console.dir(shift);
	      console.dir(index);
	      console.dir($(".shift-dates-holder ul li.active"));
	
	      _this.setLoader();
	
	      _this.totalMinutesWorkedForEntireJob = 0;
	      _this.totalPaymentDisplay = 0;
	      _this.totalPayment = 0;
	      _this.allChecked = false;
	      _this.disablePaymentButton = true;
	      _this.bulkCheck = false;
	
	      if (shift.isActive) {
	        return;
	      } else {
	        try {
	          _this.shifts.forEach(function (s) {
	            s.isActive = false;
	          });
	        } finally {
	          shift.isActive = true;
	        }
	      }
	
	      var child = index + 1;
	
	      _this.getRosterForFirstShift(shift);
	
	      _this.$timeout(function () {
	        $(".shift-dates-holder ul li.active").removeClass("active");
	      });
	
	      _this.$timeout(function () {
	        $(".shift-dates-holder ul li:nth-child(" + child + "").addClass("active");
	      }, 100);
	
	      _this.switchTablesToNewShift(shift);
	    }
	  }, {
	    key: "switchTablesToNewShift",
	    value: function switchTablesToNewShift(shift) {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("table.table.table-bordered.shiftpayments:first-child").hide("slide", { direction: "left" }, 200);
	      }, 100);
	
	      _this.$timeout(function () {
	        _this.shiftsWithUsers = [];
	      }, 300);
	
	      _this.$timeout(function () {
	        $("table.table.table-bordered.shiftpayments:first-child").show("slide", { direction: "right" }, 500);
	      }, 900);
	    }
	  }, {
	    key: "setActiveShift",
	    value: function setActiveShift(position) {
	      var _this = this;
	
	      console.log("setActiveShift");
	      console.dir(_this.$state);
	      console.dir(_this.$location);
	      console.log("url params");
	      console.dir(position);
	
	      if (position) {
	        _this.$timeout(function () {
	          $(".shift-dates-holder ul li:nth-child(" + position + ")").addClass("active");
	        });
	      } else {
	        _this.$timeout(function () {
	          $(".shift-dates-holder ul li:first-child").addClass("active");
	        });
	      }
	
	      _this.remain_loading_count = 0;
	    }
	  }, {
	    key: "organizePaymentOptions",
	    value: function organizePaymentOptions(user) {
	      var _this = this;
	
	      console.log("organizePaymentOptions");
	      console.dir(user);
	
	      var paymentOptions = [];
	      var banks = [];
	
	      if (_this.currentUser.company.payByInvoice === true) {
	        _this.paymentInfos = [];
	        _this.banks = [];
	        _this.invoice = true;
	      } else {
	        _this.invoice = false;
	
	        try {
	          if (user.company.undeletedPaymentInfos) {
	            user.company.undeletedPaymentInfos.forEach(function (info) {
	              if (info.bankName === null) {
	                paymentOptions.push(info);
	              } else {
	                console.log("here is the bank...");
	                console.dir(info);
	                if (info.validated === true) {
	                  info.cardBrand = info.bankName;
	                  paymentOptions.push(info);
	                }
	              }
	            });
	          }
	        } catch (err) {} finally {
	          _this.paymentInfos = paymentOptions;
	          _this.banks = banks;
	        }
	      }
	    }
	  }, {
	    key: "totalHoursWorkedForEvent",
	    value: function totalHoursWorkedForEvent() {
	      var _this = this;
	
	      var div = _this.totalMinutesWorkedForEntireJob / 60;
	
	      return Math.floor(div);
	    }
	  }, {
	    key: "totalMinutesWorkedForEvent",
	    value: function totalMinutesWorkedForEvent() {
	      var _this = this;
	      //console.log("where is this set......");
	      //console.dir(_this.totalMinutesWorkedForEntireJob);
	      return _this.totalMinutesWorkedForEntireJob % 60;
	    }
	  }, {
	    key: "checkAll",
	    value: function checkAll() {
	      var _this = this;
	
	      if (_this.bulkCheck === false) {
	        _this.bulkCheck = true;
	        _this.checkAllJobblers(true);
	        _this.allChecked = true;
	      } else {
	        _this.bulkCheck = false;
	        _this.checkAllJobblers(false);
	        _this.allChecked = false;
	      }
	    }
	  }, {
	    key: "checkAllJobblers",
	    value: function checkAllJobblers(val) {
	      var _this = this;
	
	      console.log("check all jobblers");
	      console.dir(val);
	      console.dir(_this.bulkCheck);
	      console.dir(_this.shiftsWithUsers);
	
	      try {
	        if (val === true) {
	          _this.shiftsWithUsers.forEach(function (user) {
	            if (user.noShow !== true && user.hasBeenPaid !== true && user.isCheckedForPayment) {
	              user.isCheckedForPayment = false;
	              _this.removeMinutesToTotal(user);
	              _this.removeMoneyToTotal(user);
	              _this.removeAllUsersFromPaymentList();
	            }
	          });
	        }
	      } catch (err) {
	        console.log("in error");
	        console.dir(err);
	      } finally {
	        _this.shiftsWithUsers.forEach(function (user) {
	          if (user.noShow !== true && user.hasBeenPaid !== true) {
	            user.isCheckedForPayment = val;
	
	            if (val === false) {
	              _this.removeMinutesToTotal(user);
	              _this.removeMoneyToTotal(user);
	              _this.removeAllUsersFromPaymentList();
	            } else {
	              _this.paymentList.push(user);
	              _this.addMinutesToTotal(user);
	              _this.addMoneyToTotal(user);
	
	              console.log("kkkkk in the else right now");
	              console.dir(_this.totalMinutesWorkedForEntireJob);
	              console.dir(_this.totalPaymentDisplay);
	              console.dir(_this.totalPayment);
	              console.dir(_this.paymentList);
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: "removeAllUsersFromPaymentList",
	    value: function removeAllUsersFromPaymentList() {
	      var _this = this;
	
	      _this.paymentList.splice(0, _this.paymentList.length);
	      _this.disablePaymentButtonFunc();
	    }
	  }, {
	    key: "disablePaymentButtonFunc",
	    value: function disablePaymentButtonFunc() {
	      var _this = this;
	
	      console.log("disablePaymentButtonFunc");
	      console.dir(_this.paymentList);
	      console.dir(_this.invoice);
	      console.dir(_this.transferData);
	
	      if (_this.paymentList.length > 0 && _this.invoice === true) {
	        _this.disablePaymentButton = false;
	      } else if (_this.invoice !== true && _this.transferData && _this.paymentList.length > 0) {
	        _this.disablePaymentButton = false;
	      } else if (_this.paymentList.length == 0) {
	        _this.disablePaymentButton = true;
	      }
	    }
	  }, {
	    key: "removeMoneyToTotal",
	    value: function removeMoneyToTotal(data) {
	      var _this = this;
	
	      console.log("remove money");
	      console.dir(data);
	
	      var pay = parseFloat(data.payment);
	
	      console.dir(numeral(_this.totalPayment + pay).format("$0,0.00"));
	
	      _this.totalPayment = _this.totalPayment - pay;
	
	      _this.totalPaymentDisplay = numeral(_this.totalPayment).format("$0,0.00");
	    }
	  }, {
	    key: "addMoneyToTotal",
	    value: function addMoneyToTotal(data) {
	      var _this = this;
	
	      console.log("add money kkkk");
	      console.dir(data);
	
	      var pay = parseFloat(data.payment);
	
	      console.dir(numeral(_this.totalPayment + pay).format("$0,0.00"));
	
	      _this.totalPayment = _this.totalPayment + pay;
	
	      _this.totalPaymentDisplay = numeral(_this.totalPayment).format("$0,0.00");
	
	      _this.disablePaymentButtonFunc();
	    }
	  }, {
	    key: "totalAmountToBePaidOut",
	    value: function totalAmountToBePaidOut() {
	      var _this = this;
	
	      //console.log("_this.currentUser.company.defaultPlan.companyFeePct");
	      //console.dir(_this.currentUser.company.defaultPlan.companyFeePct);
	
	      return _this.totalPaymentDisplay;
	    }
	  }, {
	    key: "setLoader",
	    value: function setLoader() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("html").addClass("wait");
	      });
	    }
	  }, {
	    key: "unSetLoader",
	    value: function unSetLoader() {
	      var _this = this;
	
	      _this.$timeout(function () {
	        $("html").removeClass("wait");
	      });
	    }
	  }, {
	    key: "markUserForNoShowForShift",
	    value: function markUserForNoShowForShift(data, value) {
	      var _this = this;
	
	      console.log("markUserForNoShowForShift");
	      console.log("hello marisa");
	      console.dir(data);
	
	      var shiftId = data.id;
	      //let value = null;
	
	      if (data.noShow === true) {
	        //value = false;
	        data.noShow = false;
	      } else {
	        //value = true;
	        data.noShow = true;
	        data.actualMinutesWorked = 0;
	        data.timeInterval.timeInHours = 0;
	        data.timeInterval.timeInMinutes = 0;
	        data.payment = 0;
	      }
	
	      _this.setLoader();
	
	      _this.$events.markUserAsNowShowForShift(shiftId, value).then(function (response) {
	        console.log("response");
	        console.dir(response);
	
	        _this.$timeout(function () {
	          _this.unSetLoader();
	        }, 1000);
	      }, function (error) {
	        console.log("in error");
	        console.dir(error);
	        _this.$timeout(function () {
	          _this.unSetLoader();
	        }, 1000);
	      });
	    }
	  }, {
	    key: "exit",
	    value: function exit() {
	      this.$timeout(function () {
	        $("#additional-shift-payment").modal("hide");
	      });
	    }
	  }, {
	    key: "displayAdditionalPaymentModal",
	    value: function displayAdditionalPaymentModal(data) {
	      console.log("displayAdditionalPaymentModal");
	      console.dir(data);
	      this.paymentList = [];
	      this.additionalMonies = 0.0;
	      this.payUser = data;
	      this.collectPaymentMethods();
	      this.paymentList.push(data);
	      this.isModalPayment = true;
	      this.$timeout(function () {
	        $("#additional-shift-payment").modal();
	      });
	    }
	  }, {
	    key: "sendAdditionalPayment",
	    value: function sendAdditionalPayment() {
	      this.sendPayment();
	    }
	  }, {
	    key: "findCallToActions",
	    value: function findCallToActions(shifts) {
	      var _this = this;
	    }
	  }, {
	    key: "formComplete",
	    value: function formComplete() {
	      console.log("formComplete");
	    }
	  }, {
	    key: "moniesChanging",
	    value: function moniesChanging() {
	      if (_angular2.default.isUndefined(this.moniesChanging)) {
	        this.moniesChanging = 0;
	      }
	
	      if (this.company.payByInvoice === true) {
	        if (this.additionalMonies > 4) {
	          this.disablePaymentButton = false;
	        } else {
	          this.disablePaymentButton = true;
	        }
	      } else {
	        if (this.transferData.card !== null && this.additionalMonies > 4) {
	          this.disablePaymentButton = false;
	        } else {
	          this.disablePaymentButton = true;
	        }
	      }
	
	      console.log("moniesChanging");
	      console.dir(this.additionalMonies);
	    }
	  }, {
	    key: "collectPaymentMethods",
	    value: function collectPaymentMethods() {
	      var _this = this;
	      console.log("collectPaymentMethods");
	      console.dir(_this.currentUser);
	
	      _this.$auth.getCompanyPayInfo().then(function (response) {
	        var company = response.data.company;
	
	        console.log("company");
	        console.dir(company);
	
	        _this.company = company;
	      }, function (error) {
	        alert("Error getting company payment information " + error);
	      });
	    }
	  }, {
	    key: "reOpenJob",
	    value: function reOpenJob() {
	      var _this = this;
	
	      var id = _this.event.id;
	
	      _this.setLoader();
	      _this.$events.reOpenEvent(id).then(function (response) {
	        console.log("what is the response");
	        console.dir(response);
	        if (response.status === 200) {
	          _this.event.isCompleted = false;
	          _this.event.isClosed = false;
	          alert("Your job has been re-opened.");
	          _this.$timeout(function () {
	            _this.$state.go("jobsdashboard");
	          }, 300);
	        } else {
	          console.log("there was an issue..");
	        }
	        _this.unSetLoader();
	      }, function (error) {
	        console.log("what is the error");
	        console.dir(error);
	        _this.unSetLoader();
	      });
	    }
	  }]);
	
	  return PayshiftsController;
	}();
	
	PayshiftsController.$inject = ["$http", "$localStorage", "$state", "auth", "events", "teams", "companies", "security", "$stateParams", "common", "$rootScope", "env", "$timeout", "$location", "ngProgressFactory"];
	
	exports.default = PayshiftsController;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _admindash = __webpack_require__(656);
	
	var _admindash2 = _interopRequireDefault(_admindash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var admindashModule = _angular2.default.module("admindash", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("admindash", {
	    url: "/admin-dash",
	    template: "<admindash></admindash>"
	  });
	}).component("admindash", _admindash2.default);
	
	exports.default = admindashModule;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _admindash = __webpack_require__(657);
	
	var _admindash2 = _interopRequireDefault(_admindash);
	
	var _admindash3 = __webpack_require__(658);
	
	var _admindash4 = _interopRequireDefault(_admindash3);
	
	__webpack_require__(659);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var admindashComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _admindash2.default,
	  controller: _admindash4.default,
	  controllerAs: "vm"
	};
	
	exports.default = admindashComponent;

/***/ }),
/* 657 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n<div id=\"wrapper\">\n  <section class=\"content\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-lg-3 col-md-3 col-sm-4 col-xs-12\">\n          <adminsidebar></adminsidebar>\n        </div>\n\n        <div class=\"col-lg-9 col-md-9 col-sm-8 col-xs-12\">\n          <!--admin-dash-->\n          <div class=\"admin-dash\">\n            <h1>Jobble, Inc. Dashboard</h1>\n            <div class=\"status\">Live Jobble Board</div>\n\n            <!--post-admindash-->\n            <div class=\"post-admindash clearfix\" ng-repeat=\"jobble in vm.jobbles\">\n              <!--post-admindash-left-->\n              <div class=\"post-admindash-left\">\n                <!--date-box-->\n                <div class=\"date-box\">\n                  <span>{{jobble.startMonth}}</span>\n                  <span>{{jobble.startDay}}</span>\n                </div>\n                <!--date-box-->\n\n                <!--post-logo-->\n                <div class=\"post-logo\">\n                  <img ng-src=\"{{jobble.companySmallLogoUri}}\" alt=\"\" />\n                </div>\n                <!--post-logo-->\n              </div>\n              <!--post-admindash-left-->\n\n              <!--post-admindash-main-->\n              <div class=\"post-admindash-main\">\n                <h3><a href=\"\">{{jobble.eventName}}</a></h3>\n                <p style=\"color: #000\">{{jobble.location.streetLine1}} {{jobble.location.state}} {{jobble.location.zipCode}}</p>\n                <p>{{jobble.description}}</p>\n                <table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">\n                  <thead>\n                    <tr>\n                      <th>Pending</th>\n                      <th>Approved</th>\n                      <th>Openings</th>\n                      <th>Hourly/$</th>\n                    </tr>\n                  </thead>\n\n                  <tbody>\n                    <tr>\n                      <td>{{jobble.numberOfPendingApplications}}</td>\n                      <td>{{jobble.numberOfApprovedApplications}}</td>\n                      <td>{{jobble.numberOfOpenings}}</td>\n                      <td>${{jobble.payPerHour / 100 | number: 0}}</td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n              <!--post-admindash-main-->\n            </div>\n            <!--post-admindash-->\n\n            <!--post-pager-->\n            <div class=\"post-pager clearfix\">\n              <ul>\n                <li ng-disabled=\"vm.currentPageNumber == 1\" ng-click=\"vm.paginate(vm.currentPageNumber - 1)\">\n                  <a href=\"\">Prev</a>\n                </li>\n                <li ng-class=\"{'active': vm.currentPageNumber == page}\" ng-repeat=\"page in vm.pages\" ng-click=\"vm.paginate(page)\">\n                  <a href=\"\">{{page}}</a>\n                </li>\n                <li ng-disabled=\"vm.currentPageNumber == vm.pages.length\" ng-click=\"vm.paginate(vm.currentPageNumber + 1)\">\n                  <a href=\"\">next</a>\n                </li>\n              </ul>\n            </div>\n            <!--post-pager-->\n          </div>\n          <!--admin-dash-->\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n<jobblefooter></jobblefooter>\n<globalalert></globalalert>\n\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdmindashController = function () {
	  function AdmindashController($http, $localStorage, $state, AuthService, SecurityService, $timeout) {
	    _classCallCheck(this, AdmindashController);
	
	    this.name = "admindash";
	    $localStorage.activeStateName = "admindash";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	
	    this.currentPageNumber = 1;
	    this.jobbles = [];
	    this.pages = [];
	
	    this.remain_loading_count = 0;
	    this.currentUser = this.$auth.getUserData();
	
	    this.calculatePagination();
	
	    var _this = this;
	    // _this.remain_loading_count++;
	    // _this.$auth.getAllJobbles(20).then(function(response) {
	    //   _this.remain_loading_count--;
	    //   console.log(response.data);
	    //   _this.jobbles = response.data;
	    // }, function(response) {
	    //   _this.remain_loading_count--;
	    //   console.log(response.data);
	    // })
	
	    _this.paginate(_this.currentPageNumber);
	
	    $("adminsidebar .sidebar-nav li:nth-child(1)").removeClass().addClass("active");
	  }
	
	  _createClass(AdmindashController, [{
	    key: "calculatePagination",
	    value: function calculatePagination() {
	      // var numberOfEvents = Math.ceil(this.$auth.getUserData().company.totalNumberOfNonCloseEvents / 20);
	      for (var i = 0; i < 3; i++) {
	        this.pages.push(i + 1);
	      }
	    }
	  }, {
	    key: "paginate",
	    value: function paginate(pageNumber) {
	      console.log("go to this page");
	
	      if (pageNumber < 1 || pageNumber > this.pages.length) {
	        return;
	      }
	
	      this.currentPageNumber = pageNumber;
	      this.remain_loading_count++;
	      this.jobbles = [];
	
	      var companyId = this.currentUser.company.id;
	      var offsetParam = pageNumber * 20 - 20,
	          maxParam = 20,
	          page = "live",
	          sort = "lastUpdated",
	          order = "desc";
	
	      var _this = this;
	      this.$auth.getAllJobbles(maxParam, offsetParam).then(function (data) {
	        _this.jobbles = data.data;
	        _this.jobbles.forEach(function (jobble) {
	          jobble.startMonth = moment(jobble.dateCreated).format("MMM");
	          jobble.startDay = moment(jobble.dateCreated).format("DD");
	          for (var i = 0; i < jobble.companyLogoOtherUri.length; i++) {
	            if (jobble.companyLogoOtherUri[i].indexOf("75x75") > -1) {
	              jobble.companySmallLogoUri = jobble.companyLogoOtherUri[i];
	              break;
	            }
	            if (jobble.companyLogoOtherUri[i].indexOf("160x160") > -1) {
	              jobble.companyLargeLogoUri = jobble.companyLogoOtherUri[i];
	            }
	          }
	          if (_this.$security.isUndefinedOrNull(jobble.companySmallLogoUri)) {
	            jobble.companySmallLogoUri = jobble.companyLargeLogoUri;
	          }
	        });
	
	        console.log(_this.jobbles);
	        _this.remain_loading_count--;
	      }, function (data) {
	        console.log(data);
	        _this.jobbles = [];
	        _this.remain_loading_count--;
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }]);
	
	  return AdmindashController;
	}();
	
	AdmindashController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "$timeout"];
	
	exports.default = AdmindashController;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(660);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./admindash.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./admindash.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".admindash{color:red}", ""]);
	
	// exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _admintransactions = __webpack_require__(662);
	
	var _admintransactions2 = _interopRequireDefault(_admintransactions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var admintransactionsModule = _angular2.default.module("admintransactions", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("admintransactions", {
	    url: "/admin-transactions",
	    template: "<admintransactions></admintransactions>"
	  });
	}).component("admintransactions", _admintransactions2.default);
	
	exports.default = admintransactionsModule;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _admintransactions = __webpack_require__(663);
	
	var _admintransactions2 = _interopRequireDefault(_admintransactions);
	
	var _admintransactions3 = __webpack_require__(664);
	
	var _admintransactions4 = _interopRequireDefault(_admintransactions3);
	
	__webpack_require__(665);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var admintransactionsComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _admintransactions2.default,
	  controller: _admintransactions4.default,
	  controllerAs: "vm"
	};
	
	exports.default = admintransactionsComponent;

/***/ }),
/* 663 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n<div id=\"wrapper\">\n  <section class=\"content\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-lg-3 col-md-3 col-sm-4 col-xs-12\">\n          <adminsidebar></adminsidebar>\n        </div>\n\n        <div class=\"col-lg-9 col-md-9 col-sm-8 col-xs-12\">\n          <!--admin-transactions-->\n          <div class=\"admin-transactions\">\n            <h1>Jobble, Inc. Dashboard</h1>\n            <div class=\"status\">Statistics Overview</div>\n            <!--chart-tab-->\n            <div class=\"chart-tab clearfix\">\n              <ul>\n                <li class=\"chart-tab1\" ng-class=\"{'active': vm.chartType == 'line'}\">\n                  <a href=\"\" ng-click=\"vm.drawChart()\"></a>\n                </li>\n                <li class=\"chart-tab2\" ng-class=\"{'active': vm.chartType !== 'line'}\">\n                  <a href=\"\" ng-click=\"vm.drawChart('bar')\"></a>\n                </li>\n              </ul>\n            </div>\n            <!--chart-tab-->\n\n            <!--admin-transactions-main-->\n            <div class=\"admin-transactions-main\">\n              <div class=\"admin-transactions-head clearfix\">\n                <h2>Global transactions</h2>\n                <div class=\"time-shorting\">\n                  <a href=\"\" ng-class=\"{'active': vm.transactionType == 0}\" ng-click=\"vm.weeklyView()\">Days</a>|\n                  <a href=\"\" ng-class=\"{'active': vm.transactionType == 1}\" ng-click=\"vm.monthlyView()\">Weeks</a>|\n                  <a href=\"\" ng-class=\"{'active': vm.transactionType == 2}\" ng-click=\"vm.yearlyView()\">Months</a>\n                </div>\n              </div>\n              <div style=\"width: 100%; height: 100px; display: block\">\n                <form ng-submit=\"vm.customDate()\">\n                  <div style=\"float: left\">\n                    <input type=\"date\" ng-model=\"vm.customStartDate\" />\n                    <label>&nbsp;To&nbsp;</label>\n                  </div>\n                  <div style=\"float: left\">\n                    <input type=\"date\" ng-model=\"vm.customEndDate\" />\n                    <input type=\"submit\" />\n                  </div>\n                </form>\n              </div>\n\n              <div id=\"transactions-graph\"></div>\n\n              <!--transactions-table-->\n              <div class=\"transactions-table\">\n                <table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">\n                  <thead>\n                    <tr>\n                      <th>Date</th>\n                      <th>Total</th>\n                    </tr>\n                  </thead>\n\n                  <tbody>\n                    <tr ng-repeat=\"dayTransaction in vm.weeklyTransactions\" ng-if=\"vm.transactionType == 0\">\n                      <td>{{dayTransaction.date}}</td>\n                      <td>{{dayTransaction.amount}}</td>\n                    </tr>\n\n                    <tr ng-repeat=\"weekTransaction in vm.monthlyTransactions\" ng-if=\"vm.transactionType == 1\">\n                      <td>{{weekTransaction.date}}</td>\n                      <td>{{weekTransaction.amount}}</td>\n                    </tr>\n\n                    <tr ng-repeat=\"monthTransaction in vm.yearlyTransactions\" ng-if=\"vm.transactionType == 2\">\n                      <td>{{monthTransaction.date}}</td>\n                      <td>{{monthTransaction.amount}}</td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n              <!--transactions-table-->\n            </div>\n            <!--admin-transactions-main-->\n          </div>\n          <!--admin-transactions-->\n        </div>\n      </div>\n    </div>\n  </section>\n\n  <!--\n  <section class=\"content\">\n    <div class=\"container\">\n      <div class=\"row\">\n\n        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n  \t\t\t<div class=\"event-detail odd\">\n\t       <form ng-submit=\"vm.submitDateAndLocation()\">\n\t\t\t         <div ng-show=\"vm.displayErrorMessageSecondPage\" style=\"width:100%;background-color:#f04124;\" class=\"alert-box alert\">\n\t\t\t           {{vm.message}}\n\t\t\t         </div>\n\t\t\t         <div class=\"event-form clearfix\">\n\t\t\t           <div class=\"event-form-column pull-left\" style=\"margin-bottom: 20px;\">\n\t\t\t             <div class=\"group clearfix\">\n\t\t\t               <div class=\"group-grid pull-left\">\n\t\t\t                 <label>Start Date</label>\n\t\t\t                 <input type=\"text\" id=\"datepicker\" name=\"date\" placeholder=\"Select\" ng-model=\"vm.currentTimeInterval.start_date\">\n\t\t\t               </div>\n\t\t\t               <div class=\"group-grid pull-right\">\n\t\t\t                 <label>Start Time</label>\n\t\t\t                 <input type=\"text\" id=\"timepicker\" class=\"timepicker\" name=\"time\" placeholder=\"Select\" ng-model=\"vm.currentTimeInterval.start_time\">\n\t\t\t               </div>\n\t\t\t             </div>\n\t\t\t           </div>\n\t\t\t           \n\t\t\t         </div>\n\t\t       </form>\n\t     </div>\n\t     </div>\n\t     </div>\n     </div>\n     </section>\n     -->\n</div>\n<jobblefooter></jobblefooter>\n<globalalert></globalalert>\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdmintransactionsController = function () {
	  function AdmintransactionsController($http, $localStorage, $state, AuthService, SecurityService, $timeout) {
	    _classCallCheck(this, AdmintransactionsController);
	
	    this.name = "admintransactions";
	    $localStorage.activeStateName = "admintransactions";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	
	    this.weeklyTransactions = [];
	    this.monthlyTransactions = [];
	    this.yearlyTransactions = [];
	    this.graphCategories = [];
	    this.graphData = [];
	
	    this.remain_loading_count = 0;
	    this.currentUser = this.$auth.getUserData();
	
	    var _this = this;
	
	    // weekly transactions: 0, monthly transaction: 1, yearly transactions: 2
	    _this.chartType = "bar";
	    _this.transactionType = 0;
	    _this.yearlyView();
	
	    $("adminsidebar .sidebar-nav li:nth-child(2)").removeClass().addClass("active");
	  }
	
	  _createClass(AdmintransactionsController, [{
	    key: "drawChart",
	    value: function drawChart() {
	      var chartType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "line";
	
	      var type = "area";
	      this.chartType = "line";
	      if (chartType !== "line") {
	        type = "column";
	        this.chartType = "bar";
	      }
	      $("#transactions-graph").highcharts({
	        chart: {
	          type: type
	        },
	        title: {
	          text: "",
	          align: "left"
	        },
	        legend: {
	          enabled: false
	        },
	        xAxis: {
	          categories: this.graphCategories
	        },
	        yAxis: {
	          title: {
	            text: ""
	          },
	          labels: {
	            formatter: function formatter() {
	              return this.value;
	            }
	          }
	        },
	        tooltip: {
	          backgroundColor: "#69b747",
	          headerFormat: "",
	          pointFormat: "$ {point.y}",
	          borderRadius: 20,
	          style: {
	            color: "#ffffff"
	          }
	        },
	        plotOptions: {
	          area: {
	            fillOpacity: 0
	          }
	        },
	        credits: {
	          enabled: false
	        },
	        series: [{
	          name: "null",
	          data: this.graphData
	        }]
	      });
	    }
	  }, {
	    key: "weeklyView",
	    value: function weeklyView() {
	      var _this = this;
	      _this.transactionType = 0;
	      _this.weeklyTransactions = [];
	      var startDate = moment().utcOffset("-0400").startOf("week").format();
	      var endDate = moment().utcOffset("-0400").endOf("week").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getTransactions(startDate, endDate, "1d").then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        var amount;
	        var dayTransaction;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          amount = response.data[Object.keys(response.data)[i]];
	          dayTransaction = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	
	          dayTransaction.date = tempStartDate.format("MMM DD, YYYY");
	          dayTransaction.amount = numeral(amount / 100).format("$0,0.00");
	          dayTransaction.graphDate = tempStartDate.format("MMM DD");
	          dayTransaction.graphData = amount / 100;
	          _this.weeklyTransactions.push(dayTransaction);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.weeklyTransactions.forEach(function (dayTransaction) {
	          _this.graphCategories.push(dayTransaction.graphDate);
	          _this.graphData.push(dayTransaction.graphData);
	        });
	        _this.drawChart(_this.chartType);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "monthlyView",
	    value: function monthlyView() {
	      var _this = this;
	      _this.transactionType = 1;
	      _this.monthlyTransactions = [];
	      var startDate = moment().utcOffset("-0400").startOf("month").format();
	      var endDate = moment().utcOffset("-0400").endOf("month").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getTransactions(startDate, endDate, "1w").then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        console.log(response.data);
	        if (response.data.status === "error") {
	          return;
	        }
	
	        var amount;
	        var weekTransaction;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          amount = response.data[Object.keys(response.data)[i]];
	          weekTransaction = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	          weekTransaction.date = tempStartDate.format("MMM DD, YYYY") + " - " + tempEndDate.format("MMM DD, YYYY");
	          weekTransaction.amount = numeral(amount / 100).format("$0,0.00");
	          weekTransaction.graphDate = tempStartDate.format("MMM DD");
	          weekTransaction.graphData = amount / 100;
	          _this.monthlyTransactions.push(weekTransaction);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.monthlyTransactions.forEach(function (weekTransaction) {
	          _this.graphCategories.push(weekTransaction.graphDate);
	          _this.graphData.push(weekTransaction.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.monthlyTransactions);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "yearlyView",
	    value: function yearlyView() {
	      var _this = this;
	      _this.transactionType = 2;
	      _this.yearlyTransactions = [];
	      var startDate = moment().utcOffset("-0400").startOf("year").format();
	      var endDate = moment().utcOffset("-0400").endOf("year").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getTransactions(startDate, endDate, "1m").then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        if (response.data.status === "error") {
	          return;
	        }
	        var amount;
	        var monthTransaction;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          amount = response.data[Object.keys(response.data)[i]];
	          monthTransaction = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	          monthTransaction.date = tempStartDate.format("MMM DD, YYYY") + " - " + tempEndDate.format("MMM DD, YYYY");
	          monthTransaction.amount = numeral(amount / 100).format("$0,0.00");
	          monthTransaction.graphDate = tempStartDate.format("MMM DD");
	          monthTransaction.graphData = amount / 100;
	          _this.yearlyTransactions.push(monthTransaction);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.yearlyTransactions.forEach(function (monthTransaction) {
	          _this.graphCategories.push(monthTransaction.graphDate);
	          _this.graphData.push(monthTransaction.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.yearlyTransactions);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "customDate",
	    value: function customDate() {
	      console.log("customDate");
	      console.dir(this.customStartDate);
	      console.dir(this.customEndDate);
	    }
	  }]);
	
	  return AdmintransactionsController;
	}();
	
	AdmintransactionsController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "$timeout"];
	
	exports.default = AdmintransactionsController;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(666);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./admintransactions.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./admintransactions.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".admintransactions{color:red}", ""]);
	
	// exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _adminevents = __webpack_require__(668);
	
	var _adminevents2 = _interopRequireDefault(_adminevents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var admineventsModule = _angular2.default.module("adminevents", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("adminevents", {
	    url: "/admin-events",
	    template: "<adminevents></adminevents>"
	  });
	}).component("adminevents", _adminevents2.default);
	
	exports.default = admineventsModule;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _adminevents = __webpack_require__(669);
	
	var _adminevents2 = _interopRequireDefault(_adminevents);
	
	var _adminevents3 = __webpack_require__(670);
	
	var _adminevents4 = _interopRequireDefault(_adminevents3);
	
	__webpack_require__(671);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var admineventsComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _adminevents2.default,
	  controller: _adminevents4.default,
	  controllerAs: "vm"
	};
	
	exports.default = admineventsComponent;

/***/ }),
/* 669 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n<div id=\"wrapper\">\n  <section class=\"content\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-lg-3 col-md-3 col-sm-4 col-xs-12\">\n          <adminsidebar></adminsidebar>\n        </div>\n\n        <div class=\"col-lg-9 col-md-9 col-sm-8 col-xs-12\">\n          <!--admin-transactions-->\n          <div class=\"admin-transactions\">\n            <h1>Jobble, Inc. Dashboard</h1>\n            <div class=\"status\">Statistics Overview</div>\n            <!--chart-tab-->\n            <div class=\"chart-tab clearfix\">\n              <ul>\n                <li class=\"chart-tab1\" ng-class=\"{'active': vm.chartType == 'line'}\">\n                  <a href=\"\" ng-click=\"vm.drawChart()\"></a>\n                </li>\n                <li class=\"chart-tab2\" ng-class=\"{'active': vm.chartType !== 'line'}\">\n                  <a href=\"\" ng-click=\"vm.drawChart('bar')\"></a>\n                </li>\n              </ul>\n            </div>\n            <!--chart-tab-->\n\n            <!--admin-transactions-main-->\n            <div class=\"admin-transactions-main\">\n              <div class=\"admin-transactions-head clearfix\">\n                <h2>Global events</h2>\n\n                <div class=\"time-shorting\">\n                  <a href=\"\" ng-class=\"{'active': vm.eventType == 0}\" ng-click=\"vm.weeklyView()\">Days</a>|\n                  <a href=\"\" ng-class=\"{'active': vm.eventType == 1}\" ng-click=\"vm.monthlyView()\">Weeks</a>|\n                  <a href=\"\" ng-class=\"{'active': vm.eventType == 2}\" ng-click=\"vm.yearlyView()\">Months</a>\n                </div>\n              </div>\n\n              <div id=\"transactions-graph\"></div>\n\n              <!--transactions-table-->\n              <div class=\"transactions-table\">\n                <table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">\n                  <thead>\n                    <tr>\n                      <th>Date</th>\n                      <th>Total</th>\n                    </tr>\n                  </thead>\n\n                  <tbody>\n                    <tr ng-repeat=\"dayEvent in vm.weeklyEvents\" ng-if=\"vm.eventType == 0\">\n                      <td>{{dayEvent.date}}</td>\n                      <td>{{dayEvent.count}}</td>\n                    </tr>\n\n                    <tr ng-repeat=\"weekEvent in vm.monthlyEvents\" ng-if=\"vm.eventType == 1\">\n                      <td>{{weekEvent.date}}</td>\n                      <td>{{weekEvent.count}}</td>\n                    </tr>\n\n                    <tr ng-repeat=\"monthEvent in vm.yearlyEvents\" ng-if=\"vm.eventType == 2\">\n                      <td>{{monthEvent.date}}</td>\n                      <td>{{monthEvent.count}}</td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n              <!--transactions-table-->\n            </div>\n            <!--admin-transactions-main-->\n          </div>\n          <!--admin-transactions-->\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n<jobblefooter></jobblefooter>\n<globalalert></globalalert>\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdmineventsController = function () {
	  function AdmineventsController($http, $localStorage, $state, AuthService, SecurityService, $timeout) {
	    _classCallCheck(this, AdmineventsController);
	
	    this.name = "adminevents";
	    $localStorage.activeStateName = "adminevents";
	
	    if (!AuthService.isLoggedIn()) {
	      $state.go("signin");
	      return;
	    }
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	
	    this.weeklyEvents = [];
	    this.monthlyEvents = [];
	    this.yearlyEvents = [];
	    this.graphCategories = [];
	    this.graphData = [];
	
	    this.remain_loading_count = 0;
	    this.currentUser = this.$auth.getUserData();
	
	    var _this = this;
	
	    // weekly events: 0, monthly events: 1, yearly events: 2
	    _this.chartType = "line";
	    _this.eventType = 0;
	    _this.weeklyView();
	
	    $("adminsidebar .sidebar-nav li:nth-child(3)").removeClass().addClass("active");
	  }
	
	  _createClass(AdmineventsController, [{
	    key: "drawChart",
	    value: function drawChart() {
	      var chartType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "line";
	
	      var type = "area";
	      this.chartType = "line";
	      if (chartType !== "line") {
	        type = "column";
	        this.chartType = "bar";
	      }
	      $("#transactions-graph").highcharts({
	        chart: {
	          type: type
	        },
	        title: {
	          text: "",
	          align: "left"
	        },
	        legend: {
	          enabled: false
	        },
	        xAxis: {
	          categories: this.graphCategories
	        },
	        yAxis: {
	          title: {
	            text: ""
	          },
	          labels: {
	            formatter: function formatter() {
	              return this.value;
	            }
	          }
	        },
	        tooltip: {
	          backgroundColor: "#69b747",
	          headerFormat: "",
	          pointFormat: "{point.y}",
	          borderRadius: 20,
	          style: {
	            color: "#ffffff"
	          }
	        },
	        plotOptions: {
	          area: {
	            fillOpacity: 0
	          }
	        },
	        credits: {
	          enabled: false
	        },
	        series: [{
	          name: "null",
	          data: this.graphData
	        }]
	      });
	    }
	  }, {
	    key: "weeklyView",
	    value: function weeklyView() {
	      var _this = this;
	      _this.eventType = 0;
	      _this.weeklyEvents = [];
	      var startDate = moment().utcOffset("-0400").startOf("week").format();
	      var endDate = moment().utcOffset("-0400").endOf("week").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getEvents(startDate, endDate, "1d").then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        var count;
	        var dayEvent;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          count = response.data[Object.keys(response.data)[i]];
	          dayEvent = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	
	          dayEvent.date = tempStartDate.format("MMM DD, YYYY");
	          dayEvent.count = count;
	          dayEvent.graphDate = tempStartDate.format("MMM DD");
	          dayEvent.graphData = count;
	          _this.weeklyEvents.push(dayEvent);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.weeklyEvents.forEach(function (dayEvent) {
	          _this.graphCategories.push(dayEvent.graphDate);
	          _this.graphData.push(dayEvent.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.weeklyEvents);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "monthlyView",
	    value: function monthlyView() {
	      var _this = this;
	      _this.eventType = 1;
	      _this.monthlyEvents = [];
	      var startDate = moment().utcOffset("-0400").startOf("month").format();
	      var endDate = moment().utcOffset("-0400").endOf("month").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getEvents(startDate, endDate, "1w").then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        var count;
	        var weekEvent;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          count = response.data[Object.keys(response.data)[i]];
	          weekEvent = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	
	          weekEvent.date = tempStartDate.format("MMM DD, YYYY") + " - " + tempEndDate.format("MMM DD, YYYY");
	          weekEvent.count = count;
	          weekEvent.graphDate = tempStartDate.format("MMM DD");
	          weekEvent.graphData = count;
	          _this.monthlyEvents.push(weekEvent);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.monthlyEvents.forEach(function (weekEvent) {
	          _this.graphCategories.push(weekEvent.graphDate);
	          _this.graphData.push(weekEvent.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.monthlyEvents);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "yearlyView",
	    value: function yearlyView() {
	      var _this = this;
	      _this.eventType = 2;
	      _this.yearlyEvents = [];
	      var startDate = moment().utcOffset("-0400").startOf("year").format();
	      var endDate = moment().utcOffset("-0400").endOf("year").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getEvents(startDate, endDate, "1m").then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        var count;
	        var monthEvent;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          count = response.data[Object.keys(response.data)[i]];
	          monthEvent = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	
	          monthEvent.date = tempStartDate.format("MMM DD, YYYY") + " - " + tempEndDate.format("MMM DD, YYYY");
	          monthEvent.count = count;
	          monthEvent.graphDate = tempStartDate.format("MMM DD");
	          monthEvent.graphData = count;
	          _this.yearlyEvents.push(monthEvent);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.yearlyEvents.forEach(function (monthEvent) {
	          _this.graphCategories.push(monthEvent.graphDate);
	          _this.graphData.push(monthEvent.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.yearlyEvents);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }]);
	
	  return AdmineventsController;
	}();
	
	AdmineventsController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "$timeout"];
	
	exports.default = AdmineventsController;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(672);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./adminevents.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./adminevents.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".adminevents{color:red}", ""]);
	
	// exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _adminapplicants = __webpack_require__(674);
	
	var _adminapplicants2 = _interopRequireDefault(_adminapplicants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminapplicantsModule = _angular2.default.module("adminapplicants", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("adminapplicants", {
	    url: "/admin-applicants",
	    template: "<adminapplicants></adminapplicants>"
	  });
	}).component("adminapplicants", _adminapplicants2.default);
	
	exports.default = adminapplicantsModule;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _adminapplicants = __webpack_require__(675);
	
	var _adminapplicants2 = _interopRequireDefault(_adminapplicants);
	
	var _adminapplicants3 = __webpack_require__(676);
	
	var _adminapplicants4 = _interopRequireDefault(_adminapplicants3);
	
	__webpack_require__(677);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminapplicantsComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _adminapplicants2.default,
	  controller: _adminapplicants4.default,
	  controllerAs: "vm"
	};
	
	exports.default = adminapplicantsComponent;

/***/ }),
/* 675 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n<div id=\"wrapper\">\n  <section class=\"content\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-lg-3 col-md-3 col-sm-4 col-xs-12\">\n          <adminsidebar></adminsidebar>\n        </div>\n\n        <div class=\"col-lg-9 col-md-9 col-sm-8 col-xs-12\">\n          <!--admin-transactions-->\n          <div class=\"admin-transactions\">\n            <h1>Jobble, Inc. Dashboard</h1>\n            <div class=\"status\">Statistics Overview</div>\n            <!--chart-tab-->\n            <div class=\"chart-tab clearfix\">\n              <ul>\n                <li class=\"chart-tab1\" ng-class=\"{'active': vm.chartType == 'line'}\">\n                  <a href=\"\" ng-click=\"vm.drawChart()\"></a>\n                </li>\n                <li class=\"chart-tab2\" ng-class=\"{'active': vm.chartType !== 'line'}\">\n                  <a href=\"\" ng-click=\"vm.drawChart('bar')\"></a>\n                </li>\n              </ul>\n            </div>\n            <!--chart-tab-->\n\n            <!--admin-transactions-main-->\n            <div class=\"admin-transactions-main\">\n              <div class=\"admin-transactions-head clearfix\">\n                <h2>Global applicants</h2>\n\n                <div class=\"time-shorting\">\n                  <a href=\"\" ng-class=\"{'active': vm.applicantType == 0}\" ng-click=\"vm.weeklyView()\">Days</a>|\n                  <a href=\"\" ng-class=\"{'active': vm.applicantType == 1}\" ng-click=\"vm.monthlyView()\">Weeks</a>|\n                  <a href=\"\" ng-class=\"{'active': vm.applicantType == 2}\" ng-click=\"vm.yearlyView()\">Months</a>\n                </div>\n              </div>\n\n              <div id=\"transactions-graph\"></div>\n\n              <!--transactions-table-->\n              <div class=\"transactions-table\">\n                <table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">\n                  <thead>\n                    <tr>\n                      <th>Date</th>\n                      <th>Total</th>\n                    </tr>\n                  </thead>\n\n                  <tbody>\n                    <tr ng-repeat=\"dayApplicant in vm.weeklyApplicants\" ng-if=\"vm.applicantType == 0\">\n                      <td>{{dayApplicant.date}}</td>\n                      <td>{{dayApplicant.count}}</td>\n                    </tr>\n\n                    <tr ng-repeat=\"weekApplicant in vm.monthlyApplicants\" ng-if=\"vm.applicantType == 1\">\n                      <td>{{weekApplicant.date}}</td>\n                      <td>{{weekApplicant.count}}</td>\n                    </tr>\n\n                    <tr ng-repeat=\"monthApplicant in vm.yearlyApplicants\" ng-if=\"vm.applicantType == 2\">\n                      <td>{{monthApplicant.date}}</td>\n                      <td>{{monthApplicant.count}}</td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n              <!--transactions-table-->\n            </div>\n            <!--admin-transactions-main-->\n          </div>\n          <!--admin-transactions-->\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n<jobblefooter></jobblefooter>\n<globalalert></globalalert>\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminapplicantsController = function () {
	  function AdminapplicantsController($http, $localStorage, $state, AuthService, SecurityService, $timeout) {
	    _classCallCheck(this, AdminapplicantsController);
	
	    this.name = "adminapplicants";
	    $localStorage.activeStateName = "adminapplicants";
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	
	    this.weeklyApplicants = [];
	    this.monthlyApplicants = [];
	    this.yearlyApplicants = [];
	    this.graphCategories = [];
	    this.graphData = [];
	
	    this.remain_loading_count = 0;
	    this.currentUser = this.$auth.getUserData();
	
	    var _this = this;
	
	    // weekly applicants: 0, monthly applicants: 1, yearly applicants: 2
	    _this.chartType = "line";
	    _this.applicantType = 0;
	    _this.weeklyView();
	    $("adminsidebar .sidebar-nav li:nth-child(4)").removeClass().addClass("active");
	  }
	
	  _createClass(AdminapplicantsController, [{
	    key: "drawChart",
	    value: function drawChart() {
	      var chartType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "line";
	
	      var type = "area";
	      this.chartType = "line";
	      if (chartType !== "line") {
	        type = "column";
	        this.chartType = "bar";
	      }
	      $("#transactions-graph").highcharts({
	        chart: {
	          type: type
	        },
	        title: {
	          text: "",
	          align: "left"
	        },
	        legend: {
	          enabled: false
	        },
	        xAxis: {
	          categories: this.graphCategories
	        },
	        yAxis: {
	          title: {
	            text: ""
	          },
	          labels: {
	            formatter: function formatter() {
	              return this.value;
	            }
	          }
	        },
	        tooltip: {
	          backgroundColor: "#69b747",
	          headerFormat: "",
	          pointFormat: "{point.y}",
	          borderRadius: 20,
	          style: {
	            color: "#ffffff"
	          }
	        },
	        plotOptions: {
	          area: {
	            fillOpacity: 0
	          }
	        },
	        credits: {
	          enabled: false
	        },
	        series: [{
	          name: "null",
	          data: this.graphData
	        }]
	      });
	    }
	  }, {
	    key: "weeklyView",
	    value: function weeklyView() {
	      var _this = this;
	      _this.applicantType = 0;
	      _this.weeklyApplicants = [];
	      var startDate = moment().utcOffset("-0400").startOf("week").format();
	      var endDate = moment().utcOffset("-0400").endOf("week").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getApplicants(startDate, endDate, "1d").then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        var count;
	        var dayApplicant;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          count = response.data[Object.keys(response.data)[i]];
	          dayApplicant = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	
	          dayApplicant.date = tempStartDate.format("MMM DD, YYYY");
	          dayApplicant.count = count;
	          dayApplicant.graphDate = tempStartDate.format("MMM DD");
	          dayApplicant.graphData = count;
	          _this.weeklyApplicants.push(dayApplicant);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.weeklyApplicants.forEach(function (dayApplicant) {
	          _this.graphCategories.push(dayApplicant.graphDate);
	          _this.graphData.push(dayApplicant.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.weeklyApplicants);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "monthlyView",
	    value: function monthlyView() {
	      var _this = this;
	      _this.applicantType = 1;
	      _this.monthlyApplicants = [];
	      var startDate = moment().utcOffset("-0400").startOf("month").format();
	      var endDate = moment().utcOffset("-0400").endOf("month").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getApplicants(startDate, endDate, "1w").then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        var count;
	        var weekApplicant;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          count = response.data[Object.keys(response.data)[i]];
	          weekApplicant = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	
	          weekApplicant.date = tempStartDate.format("MMM DD, YYYY") + " - " + tempEndDate.format("MMM DD, YYYY");
	          weekApplicant.count = count;
	          weekApplicant.graphDate = tempStartDate.format("MMM DD");
	          weekApplicant.graphData = count;
	          _this.monthlyApplicants.push(weekApplicant);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.monthlyApplicants.forEach(function (weekApplicant) {
	          _this.graphCategories.push(weekApplicant.graphDate);
	          _this.graphData.push(weekApplicant.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.monthlyApplicants);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "yearlyView",
	    value: function yearlyView() {
	      var _this = this;
	      _this.applicantType = 2;
	      _this.yearlyApplicants = [];
	      var startDate = moment().utcOffset("-0400").startOf("year").format();
	      var endDate = moment().utcOffset("-0400").endOf("year").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getApplicants(startDate, endDate, "1m").then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        var count;
	        var monthApplicant;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          count = response.data[Object.keys(response.data)[i]];
	          monthApplicant = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	
	          monthApplicant.date = tempStartDate.format("MMM DD, YYYY") + " - " + tempEndDate.format("MMM DD, YYYY");
	          monthApplicant.count = count;
	          monthApplicant.graphDate = tempStartDate.format("MMM DD");
	          monthApplicant.graphData = count;
	          _this.yearlyApplicants.push(monthApplicant);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.yearlyApplicants.forEach(function (monthApplicant) {
	          _this.graphCategories.push(monthApplicant.graphDate);
	          _this.graphData.push(monthApplicant.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.yearlyApplicants);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }]);
	
	  return AdminapplicantsController;
	}();
	
	AdminapplicantsController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "$timeout"];
	
	exports.default = AdminapplicantsController;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(678);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./adminapplicants.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./adminapplicants.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".adminapplicants{color:red}", ""]);
	
	// exports


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _adminopenings = __webpack_require__(680);
	
	var _adminopenings2 = _interopRequireDefault(_adminopenings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminopeningsModule = _angular2.default.module("adminopenings", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("adminopenings", {
	    url: "/admin-openings",
	    template: "<adminopenings></adminopenings>"
	  });
	}).component("adminopenings", _adminopenings2.default);
	
	exports.default = adminopeningsModule;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _adminopenings = __webpack_require__(681);
	
	var _adminopenings2 = _interopRequireDefault(_adminopenings);
	
	var _adminopenings3 = __webpack_require__(682);
	
	var _adminopenings4 = _interopRequireDefault(_adminopenings3);
	
	__webpack_require__(683);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminopeningsComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _adminopenings2.default,
	  controller: _adminopenings4.default,
	  controllerAs: "vm"
	};
	
	exports.default = adminopeningsComponent;

/***/ }),
/* 681 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n<div id=\"wrapper\">\n  <section class=\"content\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-lg-3 col-md-3 col-sm-4 col-xs-12\">\n          <adminsidebar></adminsidebar>\n        </div>\n\n        <div class=\"col-lg-9 col-md-9 col-sm-8 col-xs-12\">\n          <!--admin-transactions-->\n          <div class=\"admin-transactions\">\n            <h1>Jobble, Inc. Dashboard</h1>\n            <div class=\"status\">Statistics Overview</div>\n            <!--chart-tab-->\n            <div class=\"chart-tab clearfix\">\n              <ul>\n                <li class=\"chart-tab1\" ng-class=\"{'active': vm.chartType == 'line'}\">\n                  <a href=\"\" ng-click=\"vm.drawChart()\"></a>\n                </li>\n                <li class=\"chart-tab2\" ng-class=\"{'active': vm.chartType !== 'line'}\">\n                  <a href=\"\" ng-click=\"vm.drawChart('bar')\"></a>\n                </li>\n              </ul>\n            </div>\n            <!--chart-tab-->\n\n            <!--admin-transactions-main-->\n            <div class=\"admin-transactions-main\">\n              <div class=\"admin-transactions-head clearfix\">\n                <h2>Global applicants</h2>\n\n                <div class=\"time-shorting\">\n                  <a href=\"\" ng-class=\"{'active': vm.openingType == 0}\" ng-click=\"vm.weeklyView()\">Days</a>|\n                  <a href=\"\" ng-class=\"{'active': vm.openingType == 1}\" ng-click=\"vm.monthlyView()\">Weeks</a>|\n                  <a href=\"\" ng-class=\"{'active': vm.openingType == 2}\" ng-click=\"vm.yearlyView()\">Months</a>\n                </div>\n              </div>\n\n              <div id=\"transactions-graph\"></div>\n\n              <!--transactions-table-->\n              <div class=\"transactions-table\">\n                <table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">\n                  <thead>\n                    <tr>\n                      <th>Date</th>\n                      <th>Total</th>\n                    </tr>\n                  </thead>\n\n                  <tbody>\n                    <tr ng-repeat=\"dayOpening in vm.weeklyOpenings\" ng-if=\"vm.openingType == 0\">\n                      <td>{{dayOpening.date}}</td>\n                      <td>{{dayOpening.count}}</td>\n                    </tr>\n\n                    <tr ng-repeat=\"weekOpening in vm.monthlyOpenings\" ng-if=\"vm.openingType == 1\">\n                      <td>{{weekOpening.date}}</td>\n                      <td>{{weekOpening.count}}</td>\n                    </tr>\n\n                    <tr ng-repeat=\"monthOpening in vm.yearlyOpenings\" ng-if=\"vm.openingType == 2\">\n                      <td>{{monthOpening.date}}</td>\n                      <td>{{monthOpening.count}}</td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n              <!--transactions-table-->\n            </div>\n            <!--admin-transactions-main-->\n          </div>\n          <!--admin-transactions-->\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n<jobblefooter></jobblefooter>\n<globalalert></globalalert>\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminopeningsController = function () {
	  function AdminopeningsController($http, $localStorage, $state, AuthService, SecurityService, $timeout) {
	    _classCallCheck(this, AdminopeningsController);
	
	    this.name = "adminopenings";
	    $localStorage.activeStateName = "adminopenings";
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	
	    this.weeklyOpenings = [];
	    this.monthlyOpenings = [];
	    this.yearlyOpenings = [];
	    this.graphCategories = [];
	    this.graphData = [];
	
	    this.remain_loading_count = 0;
	    this.currentUser = this.$auth.getUserData();
	
	    var _this = this;
	
	    // weekly openings: 0, monthly openings: 1, yearly openings: 2
	    _this.chartType = "line";
	    _this.openingType = 0;
	    _this.weeklyView();
	    $("adminsidebar .sidebar-nav li:nth-child(5)").removeClass().addClass("active");
	  }
	
	  _createClass(AdminopeningsController, [{
	    key: "drawChart",
	    value: function drawChart() {
	      var chartType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "line";
	
	      var type = "area";
	      this.chartType = "line";
	      if (chartType !== "line") {
	        type = "column";
	        this.chartType = "bar";
	      }
	      $("#transactions-graph").highcharts({
	        chart: {
	          type: type
	        },
	        title: {
	          text: "",
	          align: "left"
	        },
	        legend: {
	          enabled: false
	        },
	        xAxis: {
	          categories: this.graphCategories
	        },
	        yAxis: {
	          title: {
	            text: ""
	          },
	          labels: {
	            formatter: function formatter() {
	              return this.value;
	            }
	          }
	        },
	        tooltip: {
	          backgroundColor: "#69b747",
	          headerFormat: "",
	          pointFormat: "{point.y}",
	          borderRadius: 20,
	          style: {
	            color: "#ffffff"
	          }
	        },
	        plotOptions: {
	          area: {
	            fillOpacity: 0
	          }
	        },
	        credits: {
	          enabled: false
	        },
	        series: [{
	          name: "null",
	          data: this.graphData
	        }]
	      });
	    }
	  }, {
	    key: "weeklyView",
	    value: function weeklyView() {
	      var _this = this;
	      _this.openingType = 0;
	      _this.weeklyOpenings = [];
	      var startDate = moment().utcOffset("-0400").startOf("week").format();
	      var endDate = moment().utcOffset("-0400").endOf("week").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getOpenings(startDate, endDate, "1d").then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        var count;
	        var dayOpening;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          count = response.data[Object.keys(response.data)[i]];
	          dayOpening = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	
	          dayOpening.date = tempStartDate.format("MMM DD, YYYY");
	          dayOpening.count = count;
	          dayOpening.graphDate = tempStartDate.format("MMM DD");
	          dayOpening.graphData = count;
	          _this.weeklyOpenings.push(dayOpening);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.weeklyOpenings.forEach(function (dayOpening) {
	          _this.graphCategories.push(dayOpening.graphDate);
	          _this.graphData.push(dayOpening.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.weeklyOpenings);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "monthlyView",
	    value: function monthlyView() {
	      var _this = this;
	      _this.openingType = 1;
	      _this.monthlyOpenings = [];
	      var startDate = moment().utcOffset("-0400").startOf("month").format();
	      var endDate = moment().utcOffset("-0400").endOf("month").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getOpenings(startDate, endDate, "1w").then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        var count;
	        var weekOpening;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          count = response.data[Object.keys(response.data)[i]];
	          weekOpening = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	
	          weekOpening.date = tempStartDate.format("MMM DD, YYYY") + " - " + tempEndDate.format("MMM DD, YYYY");
	          weekOpening.count = count;
	          weekOpening.graphDate = tempStartDate.format("MMM DD");
	          weekOpening.graphData = count;
	          _this.monthlyOpenings.push(weekOpening);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.monthlyOpenings.forEach(function (weekOpening) {
	          _this.graphCategories.push(weekOpening.graphDate);
	          _this.graphData.push(weekOpening.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.monthlyOpenings);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "yearlyView",
	    value: function yearlyView() {
	      var _this = this;
	      _this.openingType = 2;
	      _this.yearlyOpenings = [];
	      var startDate = moment().utcOffset("-0400").startOf("year").format();
	      var endDate = moment().utcOffset("-0400").endOf("year").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getOpenings(startDate, endDate, "1m").then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        var count;
	        var monthOpening;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          count = response.data[Object.keys(response.data)[i]];
	          monthOpening = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	
	          monthOpening.date = tempStartDate.format("MMM DD, YYYY") + " - " + tempEndDate.format("MMM DD, YYYY");
	          monthOpening.count = count;
	          monthOpening.graphDate = tempStartDate.format("MMM DD");
	          monthOpening.graphData = count;
	          _this.yearlyOpenings.push(monthOpening);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.yearlyOpenings.forEach(function (monthOpening) {
	          _this.graphCategories.push(monthOpening.graphDate);
	          _this.graphData.push(monthOpening.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.yearlyOpenings);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }]);
	
	  return AdminopeningsController;
	}();
	
	AdminopeningsController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "$timeout"];
	
	exports.default = AdminopeningsController;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(684);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./adminopenings.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./adminopenings.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".adminopenings{color:red}", ""]);
	
	// exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _adminhires = __webpack_require__(686);
	
	var _adminhires2 = _interopRequireDefault(_adminhires);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminhiresModule = _angular2.default.module("adminhires", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("adminhires", {
	    url: "/admin-hires",
	    template: "<adminhires></adminhires>"
	  });
	}).component("adminhires", _adminhires2.default);
	
	exports.default = adminhiresModule;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _adminhires = __webpack_require__(687);
	
	var _adminhires2 = _interopRequireDefault(_adminhires);
	
	var _adminhires3 = __webpack_require__(688);
	
	var _adminhires4 = _interopRequireDefault(_adminhires3);
	
	__webpack_require__(689);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminhiresComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _adminhires2.default,
	  controller: _adminhires4.default,
	  controllerAs: "vm"
	};
	
	exports.default = adminhiresComponent;

/***/ }),
/* 687 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n<div id=\"wrapper\">\n  <section class=\"content\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-lg-3 col-md-3 col-sm-4 col-xs-12\">\n          <adminsidebar></adminsidebar>\n        </div>\n\n        <div class=\"col-lg-9 col-md-9 col-sm-8 col-xs-12\">\n          <!--admin-transactions-->\n          <div class=\"admin-transactions\">\n            <h1>Jobble, Inc. Dashboard</h1>\n            <div class=\"status\">Statistics Overview</div>\n            <!--chart-tab-->\n            <div class=\"chart-tab clearfix\">\n              <ul>\n                <li class=\"chart-tab1\" ng-class=\"{'active': vm.chartType == 'line'}\">\n                  <a href=\"\" ng-click=\"vm.drawChart()\"></a>\n                </li>\n                <li class=\"chart-tab2\" ng-class=\"{'active': vm.chartType !== 'line'}\">\n                  <a href=\"\" ng-click=\"vm.drawChart('bar')\"></a>\n                </li>\n              </ul>\n            </div>\n            <!--chart-tab-->\n\n            <!--admin-transactions-main-->\n            <div class=\"admin-transactions-main\">\n              <div class=\"admin-transactions-head clearfix\">\n                <h2>Global hires</h2>\n\n                <div class=\"time-shorting\">\n                  <a href=\"\" ng-class=\"{'active': vm.hireType == 0}\" ng-click=\"vm.weeklyView()\">Days</a>|\n                  <a href=\"\" ng-class=\"{'active': vm.hireType == 1}\" ng-click=\"vm.monthlyView()\">Weeks</a>|\n                  <a href=\"\" ng-class=\"{'active': vm.hireType == 2}\" ng-click=\"vm.yearlyView()\">Months</a>\n                </div>\n              </div>\n\n              <div id=\"transactions-graph\"></div>\n\n              <!--transactions-table-->\n              <div class=\"transactions-table\">\n                <table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">\n                  <thead>\n                    <tr>\n                      <th>Date</th>\n                      <th>Total</th>\n                    </tr>\n                  </thead>\n\n                  <tbody>\n                    <tr ng-repeat=\"dayOpening in vm.weeklyHires\" ng-if=\"vm.hireType == 0\">\n                      <td>{{dayOpening.date}}</td>\n                      <td>{{dayOpening.count}}</td>\n                    </tr>\n\n                    <tr ng-repeat=\"weekOpening in vm.monthlyHires\" ng-if=\"vm.hireType == 1\">\n                      <td>{{weekOpening.date}}</td>\n                      <td>{{weekOpening.count}}</td>\n                    </tr>\n\n                    <tr ng-repeat=\"monthOpening in vm.yearlyHires\" ng-if=\"vm.hireType == 2\">\n                      <td>{{monthOpening.date}}</td>\n                      <td>{{monthOpening.count}}</td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n              <!--transactions-table-->\n            </div>\n            <!--admin-transactions-main-->\n          </div>\n          <!--admin-transactions-->\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n<jobblefooter></jobblefooter>\n<globalalert></globalalert>\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminhiresController = function () {
	  function AdminhiresController($http, $localStorage, $state, AuthService, SecurityService, EnvService, $timeout) {
	    _classCallCheck(this, AdminhiresController);
	
	    this.name = "adminhires";
	    $localStorage.activeStateName = "adminhires";
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	
	    this.weeklyHires = [];
	    this.monthlyHires = [];
	    this.yearlyHires = [];
	    this.graphCategories = [];
	    this.graphData = [];
	
	    this.remain_loading_count = 0;
	    this.currentUser = this.$auth.getUserData();
	
	    var _this = this;
	
	    // weekly hires: 0, monthly hires: 1, yearly hires: 2
	    _this.chartType = "line";
	    _this.hireType = 0;
	    _this.weeklyView();
	    $("adminsidebar .sidebar-nav li:nth-child(6)").removeClass().addClass("active");
	  }
	
	  _createClass(AdminhiresController, [{
	    key: "drawChart",
	    value: function drawChart() {
	      var chartType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "line";
	
	      var type = "area";
	      this.chartType = "line";
	      if (chartType !== "line") {
	        type = "column";
	        this.chartType = "bar";
	      }
	      $("#transactions-graph").highcharts({
	        chart: {
	          type: type
	        },
	        title: {
	          text: "",
	          align: "left"
	        },
	        legend: {
	          enabled: false
	        },
	        xAxis: {
	          categories: this.graphCategories
	        },
	        yAxis: {
	          title: {
	            text: ""
	          },
	          labels: {
	            formatter: function formatter() {
	              return this.value;
	            }
	          }
	        },
	        tooltip: {
	          backgroundColor: "#69b747",
	          headerFormat: "",
	          pointFormat: "{point.y}",
	          borderRadius: 20,
	          style: {
	            color: "#ffffff"
	          }
	        },
	        plotOptions: {
	          area: {
	            fillOpacity: 0
	          }
	        },
	        credits: {
	          enabled: false
	        },
	        series: [{
	          name: "null",
	          data: this.graphData
	        }]
	      });
	    }
	  }, {
	    key: "weeklyView",
	    value: function weeklyView() {
	      var _this = this;
	      _this.hireType = 0;
	      _this.weeklyHires = [];
	      var startDate = moment().utcOffset("-0400").startOf("week").format();
	      var endDate = moment().utcOffset("-0400").endOf("week").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getHires(startDate, endDate, "1d").then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        var count;
	        var dayHire;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          count = response.data[Object.keys(response.data)[i]];
	          dayHire = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	
	          dayHire.date = tempStartDate.format("MMM DD, YYYY");
	          dayHire.count = count;
	          dayHire.graphDate = tempStartDate.format("MMM DD");
	          dayHire.graphData = count;
	          _this.weeklyHires.push(dayHire);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.weeklyHires.forEach(function (dayHire) {
	          _this.graphCategories.push(dayHire.graphDate);
	          _this.graphData.push(dayHire.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.weeklyHires);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "monthlyView",
	    value: function monthlyView() {
	      var _this = this;
	      _this.hireType = 1;
	      _this.monthlyHires = [];
	      var startDate = moment().utcOffset("-0400").startOf("month").format();
	      var endDate = moment().utcOffset("-0400").endOf("month").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getHires(startDate, endDate, "1w").then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        var count;
	        var weekHire;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          count = response.data[Object.keys(response.data)[i]];
	          weekHire = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	
	          weekHire.date = tempStartDate.format("MMM DD, YYYY") + " - " + tempEndDate.format("MMM DD, YYYY");
	          weekHire.count = count;
	          weekHire.graphDate = tempStartDate.format("MMM DD");
	          weekHire.graphData = count;
	          _this.monthlyHires.push(weekHire);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.monthlyHires.forEach(function (weekHire) {
	          _this.graphCategories.push(weekHire.graphDate);
	          _this.graphData.push(weekHire.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.monthlyHires);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "yearlyView",
	    value: function yearlyView() {
	      var _this = this;
	      _this.hireType = 2;
	      _this.yearlyHires = [];
	      var startDate = moment().utcOffset("-0400").startOf("year").format();
	      var endDate = moment().utcOffset("-0400").endOf("year").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getHires(startDate, endDate, "1m").then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        var count;
	        var monthHire;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          count = response.data[Object.keys(response.data)[i]];
	          monthHire = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	
	          monthHire.date = tempStartDate.format("MMM DD, YYYY") + " - " + tempEndDate.format("MMM DD, YYYY");
	          monthHire.count = count;
	          monthHire.graphDate = tempStartDate.format("MMM DD");
	          monthHire.graphData = count;
	          _this.yearlyHires.push(monthHire);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.yearlyHires.forEach(function (monthHire) {
	          _this.graphCategories.push(monthHire.graphDate);
	          _this.graphData.push(monthHire.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.yearlyHires);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }]);
	
	  return AdminhiresController;
	}();
	
	AdminhiresController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "env", "$timeout"];
	
	exports.default = AdminhiresController;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(690);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./adminhires.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./adminhires.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".adminhires{color:red}", ""]);
	
	// exports


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _adminwithdrawals = __webpack_require__(692);
	
	var _adminwithdrawals2 = _interopRequireDefault(_adminwithdrawals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminwithdrawalsModule = _angular2.default.module("adminwithdrawals", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("adminwithdrawals", {
	    url: "/admin-withdrawals",
	    template: "<adminwithdrawals></adminwithdrawals>"
	  });
	}).component("adminwithdrawals", _adminwithdrawals2.default);
	
	exports.default = adminwithdrawalsModule;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _adminwithdrawals = __webpack_require__(693);
	
	var _adminwithdrawals2 = _interopRequireDefault(_adminwithdrawals);
	
	var _adminwithdrawals3 = __webpack_require__(694);
	
	var _adminwithdrawals4 = _interopRequireDefault(_adminwithdrawals3);
	
	__webpack_require__(695);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adminwithdrawalsComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _adminwithdrawals2.default,
	  controller: _adminwithdrawals4.default,
	  controllerAs: "vm"
	};
	
	exports.default = adminwithdrawalsComponent;

/***/ }),
/* 693 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n<div id=\"wrapper\">\n  <section class=\"content\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-lg-3 col-md-3 col-sm-4 col-xs-12\">\n          <adminsidebar></adminsidebar>\n        </div>\n\n        <div class=\"col-lg-9 col-md-9 col-sm-8 col-xs-12\">\n          <!--admin-transactions-->\n          <div class=\"admin-transactions\">\n            <h1>Jobble, Inc. Dashboard</h1>\n            <div class=\"status\">Statistics Overview</div>\n            <!--chart-tab-->\n            <div class=\"chart-tab clearfix\">\n              <ul>\n                <li class=\"chart-tab1\" ng-class=\"{'active': vm.chartType == 'line'}\">\n                  <a href=\"\" ng-click=\"vm.drawChart()\"></a>\n                </li>\n                <li class=\"chart-tab2\" ng-class=\"{'active': vm.chartType !== 'line'}\">\n                  <a href=\"\" ng-click=\"vm.drawChart('bar')\"></a>\n                </li>\n              </ul>\n            </div>\n            <!--chart-tab-->\n\n            <!--admin-transactions-main-->\n            <div class=\"admin-transactions-main\">\n              <div class=\"admin-transactions-head clearfix\">\n                <h2>Global events</h2>\n\n                <div class=\"time-shorting\">\n                  <a href=\"\" ng-class=\"{'active': vm.eventType == 0}\" ng-click=\"vm.weeklyView()\">Days</a>|\n                  <a href=\"\" ng-class=\"{'active': vm.eventType == 1}\" ng-click=\"vm.monthlyView()\">Weeks</a>|\n                  <a href=\"\" ng-class=\"{'active': vm.eventType == 2}\" ng-click=\"vm.yearlyView()\">Months</a>\n                </div>\n              </div>\n\n              <div id=\"transactions-graph\"></div>\n\n              <!--transactions-table-->\n              <div class=\"transactions-table\">\n                <table width=\"100%\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\">\n                  <thead>\n                    <tr>\n                      <th>Date</th>\n                      <th>Total</th>\n                    </tr>\n                  </thead>\n\n                  <tbody>\n                    <tr ng-repeat=\"dayEvent in vm.weeklyEvents\" ng-if=\"vm.eventType == 0\">\n                      <td>{{dayEvent.date}}</td>\n                      <td>{{dayEvent.count}}</td>\n                    </tr>\n\n                    <tr ng-repeat=\"weekEvent in vm.monthlyEvents\" ng-if=\"vm.eventType == 1\">\n                      <td>{{weekEvent.date}}</td>\n                      <td>{{weekEvent.count}}</td>\n                    </tr>\n\n                    <tr ng-repeat=\"monthEvent in vm.yearlyEvents\" ng-if=\"vm.eventType == 2\">\n                      <td>{{monthEvent.date}}</td>\n                      <td>{{monthEvent.count}}</td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n              <!--transactions-table-->\n            </div>\n            <!--admin-transactions-main-->\n          </div>\n          <!--admin-transactions-->\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n<jobblefooter></jobblefooter>\n<globalalert></globalalert>\n<loader ng-show=\"vm.remain_loading_count != 0\"></loader>\n"

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminwithdrawalsController = function () {
	  function AdminwithdrawalsController($http, $localStorage, $state, AuthService, SecurityService, $timeout) {
	    _classCallCheck(this, AdminwithdrawalsController);
	
	    this.name = "adminwithdrawals";
	    $localStorage.activeStateName = "adminwithdrawals";
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$timeout = $timeout;
	
	    this.weeklyEvents = [];
	    this.monthlyEvents = [];
	    this.yearlyEvents = [];
	    this.graphCategories = [];
	    this.graphData = [];
	
	    this.remain_loading_count = 0;
	    this.currentUser = this.$auth.getUserData();
	
	    var _this = this;
	
	    // weekly events: 0, monthly events: 1, yearly events: 2
	    _this.chartType = "line";
	    _this.eventType = 0;
	    _this.weeklyView();
	
	    $("adminsidebar .sidebar-nav li:nth-child(7)").removeClass().addClass("active");
	  }
	
	  _createClass(AdminwithdrawalsController, [{
	    key: "drawChart",
	    value: function drawChart() {
	      var chartType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "line";
	
	      var type = "area";
	      this.chartType = "line";
	      if (chartType !== "line") {
	        type = "column";
	        this.chartType = "bar";
	      }
	      $("#transactions-graph").highcharts({
	        chart: {
	          type: type
	        },
	        title: {
	          text: "",
	          align: "left"
	        },
	        legend: {
	          enabled: false
	        },
	        xAxis: {
	          categories: this.graphCategories
	        },
	        yAxis: {
	          title: {
	            text: ""
	          },
	          labels: {
	            formatter: function formatter() {
	              return this.value;
	            }
	          }
	        },
	        tooltip: {
	          backgroundColor: "#69b747",
	          headerFormat: "",
	          pointFormat: "{point.y}",
	          borderRadius: 20,
	          style: {
	            color: "#ffffff"
	          }
	        },
	        plotOptions: {
	          area: {
	            fillOpacity: 0
	          }
	        },
	        credits: {
	          enabled: false
	        },
	        series: [{
	          name: "null",
	          data: this.graphData
	        }]
	      });
	    }
	  }, {
	    key: "weeklyView",
	    value: function weeklyView() {
	      var _this = this;
	      _this.eventType = 0;
	      _this.weeklyEvents = [];
	      var startDate = moment().utcOffset("-0400").startOf("week").format();
	      var endDate = moment().utcOffset("-0400").endOf("week").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getEvents(startDate, endDate, "1d", true).then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        var count;
	        var dayEvent;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          count = response.data[Object.keys(response.data)[i]];
	          dayEvent = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	
	          dayEvent.date = tempStartDate.format("MMM DD, YYYY");
	          dayEvent.count = count;
	          dayEvent.graphDate = tempStartDate.format("MMM DD");
	          dayEvent.graphData = count;
	          _this.weeklyEvents.push(dayEvent);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.weeklyEvents.forEach(function (dayEvent) {
	          _this.graphCategories.push(dayEvent.graphDate);
	          _this.graphData.push(dayEvent.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.weeklyEvents);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "monthlyView",
	    value: function monthlyView() {
	      var _this = this;
	      _this.eventType = 1;
	      _this.monthlyEvents = [];
	      var startDate = moment().utcOffset("-0400").startOf("month").format();
	      var endDate = moment().utcOffset("-0400").endOf("month").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getEvents(startDate, endDate, "1w", true).then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        var count;
	        var weekEvent;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          count = response.data[Object.keys(response.data)[i]];
	          weekEvent = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	
	          weekEvent.date = tempStartDate.format("MMM DD, YYYY") + " - " + tempEndDate.format("MMM DD, YYYY");
	          weekEvent.count = count;
	          weekEvent.graphDate = tempStartDate.format("MMM DD");
	          weekEvent.graphData = count;
	          _this.monthlyEvents.push(weekEvent);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.monthlyEvents.forEach(function (weekEvent) {
	          _this.graphCategories.push(weekEvent.graphDate);
	          _this.graphData.push(weekEvent.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.monthlyEvents);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }, {
	    key: "yearlyView",
	    value: function yearlyView() {
	      var _this = this;
	      _this.eventType = 2;
	      _this.yearlyEvents = [];
	      var startDate = moment().utcOffset("-0400").startOf("year").format();
	      var endDate = moment().utcOffset("-0400").endOf("year").format();
	      _this.remain_loading_count++;
	
	      _this.$auth.getEvents(startDate, endDate, "1m", true).then(function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        var count;
	        var monthEvent;
	        var indexSplit;
	        for (var i = 0; i < Object.keys(response.data).length; i++) {
	          count = response.data[Object.keys(response.data)[i]];
	          monthEvent = {};
	          indexSplit = Object.keys(response.data)[i].indexOf("--");
	          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
	          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));
	
	          monthEvent.date = tempStartDate.format("MMM DD, YYYY") + " - " + tempEndDate.format("MMM DD, YYYY");
	          monthEvent.count = count;
	          monthEvent.graphDate = tempStartDate.format("MMM DD");
	          monthEvent.graphData = count;
	          _this.yearlyEvents.push(monthEvent);
	        }
	
	        _this.graphCategories = [];
	        _this.graphData = [];
	        _this.yearlyEvents.forEach(function (monthEvent) {
	          _this.graphCategories.push(monthEvent.graphDate);
	          _this.graphData.push(monthEvent.graphData);
	        });
	        _this.drawChart(_this.chartType);
	
	        console.log(_this.yearlyEvents);
	      }, function (response) {
	        _this.remain_loading_count--;
	        console.log(response.data);
	        _this.$timeout(function () {
	          jQuery("#show-application-alert").trigger("click");
	        }, 100);
	      });
	    }
	  }]);
	
	  return AdminwithdrawalsController;
	}();
	
	AdminwithdrawalsController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "$timeout"];
	
	exports.default = AdminwithdrawalsController;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(696);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./adminwithdrawals.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./adminwithdrawals.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".adminwithdrawals{color:red}", ""]);
	
	// exports


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _jobdetails = __webpack_require__(698);
	
	var _jobdetails2 = _interopRequireDefault(_jobdetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobdetailsModule = _angular2.default.module("jobdetails", [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state("jobdetails", {
	    url: "/job/:jobId",
	    template: "<jobdetails></jobdetails>"
	  });
	}).component("jobdetails", _jobdetails2.default);
	
	exports.default = jobdetailsModule;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jobdetails = __webpack_require__(699);
	
	var _jobdetails2 = _interopRequireDefault(_jobdetails);
	
	var _jobdetails3 = __webpack_require__(700);
	
	var _jobdetails4 = _interopRequireDefault(_jobdetails3);
	
	__webpack_require__(701);
	
	__webpack_require__(703);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jobdetailsComponent = {
	  restrict: "E",
	  bindings: {},
	  template: _jobdetails2.default,
	  controller: _jobdetails4.default,
	  controllerAs: "vm"
	};
	
	exports.default = jobdetailsComponent;

/***/ }),
/* 699 */
/***/ (function(module, exports) {

	module.exports = "<jobbleheader></jobbleheader>\n\n<div style=\"text-align: center; margin-top: 100px\">Redirecting</div>\n"

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(25);
	
	__webpack_require__(496);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobdetailsController = function JobdetailsController($http, $localStorage, $state, AuthService, EventsService, ProfileService, SecurityService, $stateParams, $timeout, NgMap, $rootScope, $scope, JobService, $location, $window, TrackingService, IterableService, analytics) {
	  _classCallCheck(this, JobdetailsController);
	
	  this.name = "jobdetails";
	  $localStorage.activeStateName = "jobdetails";
	  this.$http = $http;
	  this.$localStorage = $localStorage;
	  this.$state = $state;
	  this.$auth = AuthService;
	  this.$profile = ProfileService;
	  this.$events = EventsService;
	  this.$window = $window;
	  this.$location = $location;
	  this.$tracking = TrackingService;
	  this.$iterable = IterableService;
	  this.$jobs = JobService;
	  this.$security = SecurityService;
	  this.$stateParams = $stateParams;
	  this.$timeout = $timeout;
	  this.$rootScope = $rootScope;
	  this.$scope = $scope;
	  this.$analytics = analytics;
	  this.currentUser = this.$auth.getUserData();
	  this.ad_origin = this.$location.$$search.src;
	  this.delivery = false;
	
	  var jobble_id = this.$stateParams.jobId;
	
	  var source = this.$location.$$search.utm_source || this.$location.$$search.ondmd_jsrc || this.$location.$$search.jsrc;
	  var campaign = this.$location.$$search.utm_campaign || this.$location.$$search.ondmd_jcam || this.$location.$$search.jcam;
	
	  this.$location.path("/jobs").search({
	    rjid: jobble_id,
	    o: this.$location.$$search.o ? 1 : undefined,
	    utm_source: source || undefined,
	    utm_campaign: campaign || undefined
	  });
	};
	
	JobdetailsController.$inject = ["$http", "$localStorage", "$state", "auth", "events", "profile", "security", "$stateParams", "$timeout", "NgMap", "$rootScope", "$scope", "jobs", "$location", "$window", "tracking", "iterable", "analytics"];
	
	exports.default = JobdetailsController;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(702);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobdetails.styl", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./jobdetails.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(704);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".job-details-header-block{display:flex}.job-details-image-container{flex:0 0 110px;margin-right:16px}.job-details-header-container{flex:1}", ""]);
	
	// exports


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(706);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(707);
	
	__webpack_require__(709);
	
	var _app3 = __webpack_require__(711);
	
	var _app4 = _interopRequireDefault(_app3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default,
	  restrict: "E",
	  controller: _app4.default,
	  controllerAs: "vm"
	};
	
	exports.default = appComponent;

/***/ }),
/* 706 */
/***/ (function(module, exports) {

	module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\">\n  <div ng-if=\"vm.systemUp\">\n    <div ui-view style=\"height: 100%\" autoscroll=\"true\" class=\"ng-view\"></div>\n  </div>\n  <div ng-if=\"!vm.systemUp\" class=\"maintenance-container\">\n    <div class=\"maintenance-error-code\">404 Error</div>\n    <div class=\"maintenance-header\">Our site is currently down for maintenance, but don’t worry, we’ll be back online shortly.</div>\n    <div class=\"maintenance-text\">Questions or urgent issues? Check out our <a href=\"www.jobble.com/help/\" target=\"_blank\">resource center.</a></div>\n    <img class=\"maintenance-img\" src=\"app/vendor/images/maintenance.png\" />\n  </div>\n</div>\n"

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(708);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/stylus-loader/index.js!./app.styl", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/stylus-loader/index.js!./app.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".app{height:100%;background-color:$lightBgColor}", ""]);
	
	// exports


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(710);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(12)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(11)();
	// imports
	
	
	// module
	exports.push([module.id, ".maintenance-container{text-align:center!important;position:absolute;width:100%;min-height:100%;background:#fff;color:#33373a}.maintenance-error-code{height:45px;padding-top:51px;color:#62c046;font-family:Poppins;font-size:32px;font-weight:600;letter-spacing:0;line-height:48px;text-align:center}.maintenance-header{margin-top:60px;font-size:24px;line-height:35px;font-weight:600}.maintenance-header,.maintenance-text{text-align:center!important;padding:0 10px;font-family:Poppins,sans-serif}.maintenance-text{margin-top:8px;line-height:25px;font-size:16px}.maintenance-img{width:100%;margin-top:64px;max-width:600px;padding:0 5px}@media only screen and (max-width:768px){.maintenance-header{margin-top:40px;font-size:16px;line-height:25px;text-align:left}.maintenance-text{line-height:18px;font-size:12px;text-align:left}.maintenance-img{margin-top:37px}}.toast-top-right{top:0;margin:auto;left:0;right:0}#toast-container>div{opacity:1;height:32px;border-radius:0 0 6px 6px;padding:0;text-align:center;line-height:32px}#toast-container>.toast-error,#toast-container>.toast-success{background-image:none!important;background-color:#9ab6c2;margin:auto;color:#fff;font-family:Poppins,sans-serif;font-size:12px;font-weight:600;letter-spacing:0}#toast-container>.toast-error{background-color:red;width:fit-content;padding:0 8px}.ui-datepicker{background:#fff;color:#33373a;font-family:Poppins,sans-serif;font-size:12px;font-weight:500;letter-spacing:0;padding:16px;min-width:300px}.ui-datepicker table td{text-align:center}.ui-datepicker a{cursor:pointer;text-decoration:none}a.ui-state-default:hover{border:none;background:#5e666d;opacity:.7;font-weight:700;border-radius:4px;color:#fff}.ui-state-default,.ui-widget-content .ui-state-default,.ui-widget-header .ui-state-default{border:none;background:none;color:#33373a;font-family:Poppins,sans-serif;font-size:12px;font-weight:500;text-align:center}.ui-widget-header{border:none;background:none;color:#33373a}.ui-state-active,.ui-widget-content .ui-state-active,.ui-widget-header .ui-state-active{border:none;font-weight:700;color:#fff;border-radius:4px;background-color:#5e666d}.ui-widget.ui-widget-content{border:1px solid #5e666d;border-radius:6px}.ui-datepicker select.ui-datepicker-month,.ui-datepicker select.ui-datepicker-year{border:none;width:25%;margin-right:15px}.ui-datepicker select.ui-datepicker-year{margin-right:0;margin-left:15px}", ""]);
	
	// exports


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _common = __webpack_require__(112);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AppController = function () {
	  function AppController($timeout, common) {
	    _classCallCheck(this, AppController);
	
	    this.$timeout = $timeout;
	    this.$common = common;
	    this.systemUp = true;
	    this.checkSystemStatus();
	  }
	
	  _createClass(AppController, [{
	    key: "checkSystemStatus",
	    value: function checkSystemStatus() {
	      var _this = this;
	
	      this.$common.checkSystem().then(function (_ref) {
	        var systemUp = _ref.systemUp;
	
	
	        console.log("system check");
	        console.dir(systemUp);
	
	        _this.$timeout(function () {
	          if (systemUp === true) {
	            _this.systemUp = true;
	          } else {
	            _this.systemUp = false;
	          }
	        });
	      });
	    }
	  }]);
	
	  return AppController;
	}();
	
	AppController.$inject = ["$timeout", "common"];
	
	exports.default = AppController;

/***/ }),
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */
/***/ (function(module, exports) {

	"use strict";
	
	//
	// angular-file-model
	// ==================
	//
	// Directive that makes the inputs with type `file` to be
	// available in the `$scope` and be assigned to a model.
	//
	(function () {
	  "use strict";
	
	  angular.module("file-model", []).directive("fileModel", ["$parse", function ($parse) {
	    return {
	      restrict: "A",
	      link: function link(scope, element, attrs) {
	        var model = $parse(attrs.fileModel);
	        var modelSetter = model.assign;
	
	        element.bind("change", function () {
	          scope.$apply(function () {
	            if (attrs.multiple) {
	              modelSetter(scope, element[0].files);
	            } else {
	              modelSetter(scope, element[0].files[0]);
	            }
	          });
	        });
	      }
	    };
	  }]);
	})();

/***/ }),
/* 722 */,
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(25);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _events = __webpack_require__(49);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _teams = __webpack_require__(563);
	
	var _teams2 = _interopRequireDefault(_teams);
	
	var _companies = __webpack_require__(393);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _signon = __webpack_require__(724);
	
	var _signon2 = _interopRequireDefault(_signon);
	
	var _profile = __webpack_require__(113);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _common = __webpack_require__(112);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _messagingv = __webpack_require__(30);
	
	var _messagingv2 = _interopRequireDefault(_messagingv);
	
	var _iterable = __webpack_require__(159);
	
	var _iterable2 = _interopRequireDefault(_iterable);
	
	var _social = __webpack_require__(725);
	
	var _social2 = _interopRequireDefault(_social);
	
	var _jobs = __webpack_require__(726);
	
	var _jobs2 = _interopRequireDefault(_jobs);
	
	var _tracking = __webpack_require__(290);
	
	var _tracking2 = _interopRequireDefault(_tracking);
	
	var _scroll = __webpack_require__(462);
	
	var _scroll2 = _interopRequireDefault(_scroll);
	
	var _orders = __webpack_require__(530);
	
	var _orders2 = _interopRequireDefault(_orders);
	
	var _validation = __webpack_require__(727);
	
	var _validation2 = _interopRequireDefault(_validation);
	
	var _branchio = __webpack_require__(731);
	
	var _branchio2 = _interopRequireDefault(_branchio);
	
	var _analytics = __webpack_require__(732);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module("app.services", []).service({
	  env: _env2.default,
	  security: _security2.default,
	  auth: _auth2.default,
	  events: _events2.default,
	  teams: _teams2.default,
	  social: _social2.default,
	  iterable: _iterable2.default,
	  signon: _signon2.default,
	  jobs: _jobs2.default,
	  companies: _companies2.default,
	  profile: _profile2.default,
	  common: _common2.default,
	  orders: _orders2.default,
	  messagingv2: _messagingv2.default,
	  tracking: _tracking2.default,
	  scroll: _scroll2.default,
	  validation: _validation2.default,
	  branchio: _branchio2.default,
	  analytics: _analytics2.default
	});

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignonService = function () {
	  function SignonService($http, $localStorage, $state, $q, SecurityService, AuthService, EnvService, $rootScope, $timeout, $analytics) {
	    _classCallCheck(this, SignonService);
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$q = $q;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$env = EnvService;
	    this.$rootScope = $rootScope;
	    this.$timeout = $timeout;
	
	    this.signOnLoginUrl = "jbl/v1/login?format=json";
	    this.signOnRegisterUrl = "register/register?format=json";
	    this.connectUrl = "jbl/v1/connectedAccounts";
	  }
	
	  _createClass(SignonService, [{
	    key: "login",
	    value: function login(data, dataForLogin) {
	      console.log("signon js");
	      console.dir(data);
	      console.dir(dataForLogin);
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + this.signOnLoginUrl,
	        data: {
	          connectedAccountType: dataForLogin.connectedAccountType,
	          connectedAccountToken: dataForLogin.connectedAccountToken
	        }
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "register",
	    value: function register(data, dataForLogin) {
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + this.signOnRegisterUrl,
	        data: data
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "connect",
	    value: function connect(data, user) {
	      var req = {
	        method: "POST",
	        headers: {
	          Authorization: "Bearer " + user.access_token
	        },
	        url: this.$env.getAPIEndPoint() + this.connectUrl,
	        data: data
	      };
	
	      return this.$http(req);
	    }
	  }]);
	
	  return SignonService;
	}();
	
	exports.default = SignonService;
	
	
	SignonService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "env", "$rootScope", "$timeout", "$analytics"];

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	var _security = __webpack_require__(27);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _auth = __webpack_require__(26);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _env = __webpack_require__(28);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SocialService = function () {
	  function SocialService($http, $localStorage, $state, $q, SecurityService, $window, AuthService, EnvService, $rootScope, $timeout) {
	    _classCallCheck(this, SocialService);
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$q = $q;
	    this.$window = $window;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$env = EnvService;
	    this.$rootScope = $rootScope;
	    this.$timeout = $timeout;
	    this.PubNub = null;
	    this.unsortedChannelList = [];
	    this.nestedChannelList = [];
	    this.arrayOfImageUrlsForGallery = [];
	    this.controlChannelVal = null;
	  }
	
	  _createClass(SocialService, [{
	    key: "initFB",
	    value: function initFB() {
	      var _this = this;
	      var facebook_app_id = _this.$env.EnvironmentConfig.fb_app_id;
	      var fb = _this.$window.FB;
	      if (fb) {
	        fb.init({
	          appId: facebook_app_id,
	          status: true,
	          cookie: true,
	          xfbml: true,
	          version: "v2.8"
	        });
	      }
	    }
	  }, {
	    key: "fbTrackRegistration",
	    value: function fbTrackRegistration(data) {
	      var _this = this;
	      var fb = _this.$window.FB;
	      if (fb) {
	        console.log("dbging -- tracking registration...");
	        fb.AppEvents.logEvent("jbl_registered", null, data);
	      }
	    }
	  }, {
	    key: "fbTrackLogin",
	    value: function fbTrackLogin(data) {
	      var _this = this;
	      var fb = _this.$window.FB;
	      console.log("fbTrackLogin");
	      console.dir(data);
	      console.dir(fb);
	      if (fb) {
	        console.log("dbging -- tracking login...");
	        fb.AppEvents.logEvent("jbl_logged_in", null, data);
	      }
	    }
	  }]);
	
	  return SocialService;
	}();
	
	exports.default = SocialService;
	
	
	SocialService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "$window", "auth", "env", "$rootScope", "$timeout"];

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(25);
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobService = function () {
	  function JobService($http, $localStorage, $state, $q, SecurityService, AuthService, EnvService, $rootScope, $timeout, $interval, $location) {
	    _classCallCheck(this, JobService);
	
	    this.$http = $http;
	    this.$localStorage = $localStorage;
	    this.$state = $state;
	    this.$q = $q;
	    this.$auth = AuthService;
	    this.$security = SecurityService;
	    this.$env = EnvService;
	    this.$rootScope = $rootScope;
	    this.$timeout = $timeout;
	    this.$interval = $interval;
	    this.$location = $location;
	    this.PubNub = null;
	    this.unsortedChannelList = [];
	    this.nestedChannelList = [];
	    this.arrayOfImageUrlsForGallery = [];
	    this.controlChannelVal = null;
	
	    // TODO: DELETE THIS CODE - eke
	    // let data = {
	    //     "id": 4027943,
	    //     "jobbler": 249259,
	    //     "confirmationNote": "shift.note",
	    //     "confirmationResponse" : true,
	    //     "confirmationSource" : "mobile"
	    // }
	    //
	    // let req = {
	    //     method: "POST",
	    //     data: data,
	    //     headers: {
	    //         "Content-Type": "application/json",
	    //         Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
	    //     },
	    //     url: this.$env.getAPIEndPoint() + "jbl/v1/shifts/confirmation?format=json&conf=web",
	    // };
	    //
	    // this.$http(req).then((data) => {
	    //     console.log("CONSIMRE SPOND", data);
	    // })
	  }
	
	  _createClass(JobService, [{
	    key: "getPlaceRef",
	    value: function getPlaceRef(data) {
	      var _this = this;
	
	      var req = { method: "GET", data: {} };
	
	      var zipcode = null;
	      if (data.zipcode) {
	        zipcode = data.zipcode;
	      } else {
	        zipcode = data;
	      }
	
	      if (!_this.$localStorage.logged_user) {
	        req.url = _this.$env.getAPIEndPoint() + "public/places?format=json&conf=web&type=Zipcode&zipCode=" + zipcode + "&countryIsoCode=US&max=1";
	        req.headers = { "Content-Type": "application/json" };
	      } else {
	        req.url = _this.$env.getAPIEndPoint() + "jbl/v1/places?format=json&conf=web&type=Zipcode&zipCode=" + zipcode + "&countryIsoCode=US&max=1";
	        req.headers = {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        };
	      }
	      return _this.$http(req);
	    }
	  }, {
	    key: "getJobsPOST",
	    value: function getJobsPOST(data, max) {
	      if (!data.geoFenceRadius) {
	        data.geoFenceRadius = 25;
	      }
	
	      if (!data.sort || _.isEmpty(data.sort)) {
	        data.sort = undefined;
	      }
	
	      if (!data.offset) {
	        data.offset = 0;
	      }
	
	      if (!data.company) {
	        data.company = null;
	      }
	
	      if (!data.search) {
	        data.search = null;
	      }
	
	      max = max || data.max || 10;
	
	      console.log("whats in the job search data object");
	      console.dir(data);
	
	      //https://jobs.alpha.jobble.it/api/v1/jobbles?User-Agent=iPhone&zipcode=02111&geoFenceRadius=50&offset=0&limit=10
	
	      var url = this.$env.getJobsAPIEndPoint() + "jobbles?geoFenceRadius=" + data.geoFenceRadius + "&offset=" + data.offset + "&limit=" + max + "&zipcode=" + data.zipcode;
	
	      if (data.company) {
	        url = url + "&company=" + data.company;
	      }
	
	      if (data.search) {
	        var searchDelim = data.search.replace(",", "%7C%7C");
	
	        url = url + "&search=" + searchDelim;
	      }
	
	      if (data.sort) {
	        url = url + "&sort=" + data.sort.name + "&direction=" + data.sort.value;
	      }
	
	      var req = { method: "GET" };
	      req.url = url;
	
	      /*
	      let req = { method: 'POST' };
	      req.data = {
	      "queryPref": {
	      	"name": "querypreference",
	      	"jobbleTypes": data.jobbleTypes,
	      	"eventTypes": [],
	      	"companies": [],
	      	"company": data.company,
	      	"search": data.search,
	      	"geoFenceRadius": data.geoFenceRadius,
	      	"geoFenceRef":
	      		{
	      			"lat": data.lat,
	      			"lng": data.lng
	      		},
	      	"placeRef": data.placeRef,
	      }
	      }
	      req.url = this.$env.getAPIEndPoint() + "jbl/v1/jobbles/suggestionFilter?format=json&max=" + max + "&offset=" + data.offset + (data.sort ? ("&sort=" + data.sort.name + "&order=" + data.sort.value) : "") + "&conf=web&isPublished=true&isPayed=false&excludeChainAndPoolDupe=true&excludeEndTimePassed=true&isClosed=false&isCompleted=false&isCancelled=false&diffUTC=-4&fields=id,dateCreated,isFillInPost,isSourcingPost,pickupLocation,dressCode,jobbleType.picture1,isClickcastPost,dropoffLocation,pickupTime,dropoffTime,partnerPostContent,description,startTimeFormattedLoc,endTimeFormattedLoc,shifts.id,shifts.timeInterval.startTime,shifts.timeInterval.endTime,numberOfShifts,jobbleType.name,jobbleType.id,subEvent.event.numberOfOpenings,subEvent.event.company.name,subEvent.event.name,subEvent.event.company.id,subEvent.event.company.autoAccept,subEvent.contactInfo.place.timeZoneId,subEvent.contactInfo.streetLine1,subEvent.contactInfo.streetLine2,subEvent.contactInfo.city,subEvent.contactInfo.state,subEvent.contactInfo.zipCode,jobblerRate,numberOfOpenings,inCircle,forCircleOnly,isSourcingPost,applyByTime,name,payPerHour,subEvent.event.company.companyLogoUriFree";
	      */
	
	      req.headers = {
	        "Content-Type": "application/json"
	      };
	
	      if (this.$localStorage.logged_user) {
	        req.headers["Authorization"] = "Bearer " + this.$localStorage.logged_user.access_token;
	      }
	
	      console.log("what is the request");
	      console.dir(req);
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getRequirements",
	    value: function getRequirements(data) {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/event/" + data.eventId + "/requirement?format=json",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getQuestions",
	    value: function getQuestions(eventId) {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + eventId + "?format=json&fields=id,surveyQuestions.id,surveyQuestions.name,surveyQuestions.question,surveyQuestions.questionType,surveyQuestions.displayOrder",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getJobs",
	    value: function getJobs(data) {
	      var _this = this;
	      var req = {
	        method: "GET",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles?format=json&max=10&offset=0&sort=dateCreated&order=desc&conf=web&isPublished=true&isPayed=false&excludeChainAndPoolDupe=true&excludeEndTimePassed=true&isClosed=false&isCompleted=false&isCancelled=false&diffUTC=-4&fields=id,description,startTimeFormattedLoc,endTimeFormattedLoc,numberOfShifts,jobbleType.name,subEvent.event.company.fileCOMPANY_LOGO1IMG_160x160,subEvent.event.company.name,subEvent.event.name,subEvent.event.orderNumber,subEvent.contactInfo.place.timeZoneId,subEvent.contactInfo.streetLine1,subEvent.contactInfo.streetLine2,subEvent.contactInfo.city,subEvent.contactInfo.state,subEvent.contactInfo.zipCode,jobblerRate,numberOfOpenings,inCircle,forCircleOnly,isSourcingPost,applyByTime,name,subEvent.event.company.companyLogoOtherUri,payPerHour",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	      return _this.$http(req);
	    }
	
	    /*
	    "jobbleId": 48348648,
	    "jobbler": 3934,
	      "confirmationResponse": false,
	      "confirmationSource": "sms/John Smith - 123",
	      "confirmationNote": "Nothing 123"
	      */
	
	  }, {
	    key: "updateShiftWithUnConfirmationData",
	    value: function updateShiftWithUnConfirmationData(shift) {
	      var _this = this;
	
	      console.log("updateShiftWithConfirmationData");
	      console.dir(shift);
	
	      var data = {};
	
	      data = {
	        id: shift.id,
	        jobbler: shift.userId,
	        confirmationResponse: false,
	        confirmationSource: _this.$localStorage.logged_user.username,
	        confirmationNote: shift.note
	      };
	      /*
	      if(shift.confirmationResponse === true && shift.confirmationSource === "mobile"){
	      console.log("here 1");
	      data = {
	      "id": shift.id,
	      "jobbler": shift.userId,
	      "confirmationNote": shift.note,
	      "confirmationResponse" : true,
	      "confirmationSource" : "mobile"
	      }
	      }else{
	      console.log("here 2");
	      data = {
	      	"id": shift.id,
	      	"jobbler": shift.userId,
	      	"confirmationResponse": true,
	      	"confirmationSource": _this.$localStorage.logged_user.username,
	      	"confirmationNote": shift.note
	      }
	      }
	      */
	
	      var req = {
	        method: "POST",
	        data: data,
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/confirmation?format=json&conf=web"
	      };
	
	      console.log("what is the request");
	      console.dir(req);
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "updateShiftWithConfirmationData",
	    value: function updateShiftWithConfirmationData(shift) {
	      var _this = this;
	
	      var data = {};
	
	      if (shift.confirmationResponse === true && shift.confirmationSource === "mobile") {
	        data = {
	          id: shift.id,
	          jobbler: shift.userId,
	          confirmationNote: shift.note,
	          confirmationResponse: true,
	          confirmationSource: "mobile"
	        };
	      } else {
	        data = {
	          id: shift.id,
	          jobbler: shift.userId,
	          confirmationResponse: true,
	          confirmationSource: _this.$localStorage.logged_user.username,
	          confirmationNote: shift.note
	        };
	      }
	
	      var req = {
	        method: "POST",
	        data: data,
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/confirmation?format=json&conf=web"
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getShift",
	    value: function getShift(id) {
	      var _this = this;
	
	      console.log("getShift");
	      console.dir(id);
	
	      var req = {
	        method: "GET",
	        data: {}
	      };
	
	      req.url = _this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + id + "?format=json&fields=id,timeInterval.startTime,timeInterval.endTime,contactInfo.streetLine1,contactInfo.state,contactInfo.city,contactInfo.zipCode,contactInfo.place.timeZoneId,confirmationSource,confirmationResponse,confirmationNote,confirmationDateTime";
	      req.headers = {
	        "Content-Type": "application/json",
	        Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getJobbleWithShifts",
	    value: function getJobbleWithShifts(id) {
	      var _this = this;
	
	      console.log("getJobbleWithShifts");
	      console.dir(id);
	
	      var req = {
	        method: "GET",
	        data: {}
	      };
	
	      req.url = _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + id + "?format=json&fields=id,shifts.id,shifts.timeInterval.startTime,shifts.timeInterval.endTime,shifts.contactInfo.streetLine1,shifts.contactInfo.state,shifts.contactInfo.city,shifts.contactInfo.zipCode,shifts.contactInfo.place.timeZoneId,shifts.confirmationSource,shifts.confirmationResponse,shifts.confirmationNote,shifts.confirmationDateTime";
	      req.headers = {
	        "Content-Type": "application/json",
	        Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getJob",
	    value: function getJob(id) {
	      var _this = this;
	
	      var req = {
	        method: "GET",
	        data: {}
	      };
	
	      console.log("getJob");
	      console.dir(_this.$localStorage.logged_user);
	
	      if (!_this.$localStorage.logged_user) {
	        console.log("getJob 2");
	        req.url = _this.$env.getAPIEndPoint() + "public/jobbles/" + id + "?format=json&excludeChainAndPoolDupe=true&excludeEndTimePassed=true&isClosed=false&isCompleted=false&isCancelled=false&diffUTC=-4&fields=id,partnerPostContent,description,pickupLocation,dressCode,dropoffLocation,pickupAddress,dropoffAddress,pickupTime,dropoffTime,deliveryContactInfo,pickupContactInfo,dropoffContactInfo,startTimeFormattedLoc,endTimeFormattedLoc,numberOfShifts,jobbleType.id,jobbleType.name,subEvent.event.orderNumber,subEvent.event.numberOfOpenings,,subEvent.event.company.name,subEvent.event.name,subEvent.event.id,subEvent.contactInfo.streetLine1,subEvent.contactInfo.streetLine2,subEvent.contactInfo.city,subEvent.contactInfo.state,subEvent.contactInfo.zipCode,subEvent.contactInfo.place.timeZoneId,jobblerRate,numberOfOpenings,inCircle,forCircleOnly,isSourcingPost,applyByTime,name,payPerHour,shifts.padding,shifts.description,shifts.location,shifts.id,shifts.timeInterval.startTime,shifts.overnight,shifts.unpaidBreak,shifts.timeInterval.endTime,shifts.contactInfo.id,shifts.contactInfo.streetLine1,shifts.contactInfo.place.timeZoneId,shifts.contactInfo.city,shifts.contactInfo.state,shifts.contactInfo.zipCode,jobbleType.picture1,subEvent.event.company.companyLogoUriFree";
	        req.headers = { "Content-Type": "application/json" };
	      } else {
	        console.log("getJob 3");
	
	        req.url = _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + id + "?format=json&excludeChainAndPoolDupe=true&excludeEndTimePassed=true&isClosed=false&isCompleted=false&isCancelled=false&diffUTC=-4&fields=id,applicationStatus,partnerPostContent,description,pickupLocation,dressCode,dropoffLocation,pickupAddress,dropoffAddress,pickupTime,dropoffTime,deliveryContactInfo,pickupContactInfo,dropoffContactInfo,startTimeFormattedLoc,endTimeFormattedLoc,numberOfShifts,jobbleType.id,jobbleType.name,subEvent.event.numberOfOpenings,subEvent.event.company.name,subEvent.event.name,subEvent.event.id,subEvent.event.orderNumber,subEvent.contactInfo.streetLine1,subEvent.contactInfo.streetLine2,subEvent.contactInfo.city,subEvent.contactInfo.state,subEvent.contactInfo.zipCode,subEvent.contactInfo.place.timeZoneId,jobblerRate,numberOfOpenings,inCircle,forCircleOnly,isSourcingPost,applyByTime,name,payPerHour,shifts.id,shifts.timeInterval.startTime,shifts.padding,shifts.description,shifts.location,shifts.unpaidBreak,shifts.overnight,shifts.timeInterval.endTime,shifts.contactInfo.id,shifts.contactInfo.streetLine1,shifts.contactInfo.place.timeZoneId,shifts.contactInfo.city,shifts.contactInfo.state,shifts.contactInfo.zipCode,jobbleType.picture1,subEvent.event.company.companyLogoUriFree";
	
	        //req.url = _this.$env.getAPIEndPoint() + "jbl/v1/jobbles-details/" + id;
	
	        req.headers = {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + this.$localStorage.logged_user.access_token
	        };
	      }
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "getJobCompanyDesc",
	    value: function getJobCompanyDesc(id) {
	      var req = {
	        method: "GET",
	        data: {}
	      };
	
	      req.url = this.$env.getAPIEndPoint() + "public/jobbles/" + id + "?format=json&excludeChainAndPoolDupe=true&excludeEndTimePassed=true&isClosed=false&isCompleted=false&isCancelled=false&diffUTC=-4&fields=id,description,subEvent.event.company.description,subEvent.event.company.name,subEvent.event.company.fileCOMPANY_LOGO1IMG_160x160";
	      req.headers = { "Content-Type": "application/json" };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "getApplyTimeFrame",
	    value: function getApplyTimeFrame(jobble) {
	      var _this = this;
	      var applyTimeFrame = "";
	      if (jobble.endTimeFormattedLoc) {
	        var start = new Date(jobble.endTimeFormattedLoc);
	        var now = new Date();
	        var diff = start - now;
	
	        var diffInDays = diff / 1000 / 3600 / 24;
	        var daysLeft = Math.floor(diffInDays);
	        var remainderHours = Math.floor(diffInDays % 1 * 24);
	        if (diff > 0) {
	          if (daysLeft == 0) {
	            applyTimeFrame = remainderHours + " hours left to apply";
	          } else {
	            applyTimeFrame = daysLeft + " days, " + remainderHours + " hours left to apply";
	          }
	        } else {
	          daysLeft = daysLeft * -1;
	          remainderHours = remainderHours * -1;
	          if (daysLeft == 0) {
	            applyTimeFrame = "Was " + remainderHours + " hours ago";
	          } else {
	            applyTimeFrame = "Was " + daysLeft + " days, " + remainderHours + " hours ago";
	          }
	        }
	      }
	
	      return applyTimeFrame;
	    }
	  }, {
	    key: "getJobbleTimeFrameWithTimeZoneForBoard",
	    value: function getJobbleTimeFrameWithTimeZoneForBoard(job) {
	      var ret = "";
	      var time_object = {};
	
	      var timeZone = null;
	
	      if (job.contactInfo) {
	        timeZone = job.contactInfo.place.timeZoneId;
	      } else {
	        timeZone = job.subEvent.contactInfo.place.timeZoneId;
	      }
	
	      var start = void 0;
	      var end = void 0;
	
	      if (timeZone === "Pacific/Honolulu" || timeZone === "America/Anchorage") {
	        start = new Date(job.startTime);
	        end = new Date(job.endTime);
	      } else {
	        start = new Date(job.startTimeFormattedLoc);
	        end = new Date(job.endTimeFormattedLoc);
	      }
	
	      var startMoment = moment(start);
	      var endMoment = moment(end);
	
	      var diff = endMoment.diff(startMoment, "hours");
	      var same_day = false;
	      var startDay = startMoment.tz(timeZone).format("DD");
	      var endDay = endMoment.tz(timeZone).format("DD");
	
	      if (startDay === endDay) {
	        same_day = true;
	      }
	
	      if (diff > 24 || same_day === false) {
	        time_object.startTime = startMoment.tz(timeZone).format("MMM DD");
	        time_object.endTime = endMoment.tz(timeZone).format("MMM DD");
	        ret = time_object.startTime + " - " + time_object.endTime;
	      } else {
	        time_object.startTime = startMoment.tz(timeZone).format("MMM DD");
	        ret = time_object.startTime; //+ ' - ' + time_object.endTime;
	      }
	
	      return ret;
	    }
	  }, {
	    key: "getJobbleFullTimeFrameWithTimeZoneForBoard",
	    value: function getJobbleFullTimeFrameWithTimeZoneForBoard(job) {
	      var ret = "";
	      var time = "";
	      var duration = "";
	      var rawDuration = 0;
	
	      var time_object = {};
	      var start = new Date(job.startTimeFormattedLoc);
	      var end = new Date(job.endTimeFormattedLoc);
	
	      var startMoment = moment(start);
	      var endMoment = moment(end);
	
	      var timeZone = null;
	
	      if (job.contactInfo) {
	        timeZone = job.contactInfo.place.timeZoneId;
	      } else {
	        timeZone = job.subEvent.contactInfo.place.timeZoneId;
	      }
	
	      var diff = endMoment.diff(startMoment, "hours");
	      var same_day = false;
	      var startDay = startMoment.tz(timeZone).format("DD");
	      var endDay = endMoment.tz(timeZone).format("DD");
	
	      if (startDay === endDay) {
	        same_day = true;
	      }
	
	      if (diff > 24 || same_day === false) {
	        time_object.startTime = startMoment.tz(timeZone).format("ddd, MMM DD h:mmA");
	        time_object.endTime = endMoment.tz(timeZone).format("h:mmA");
	        ret = time_object.startTime + " - " + time_object.endTime;
	
	        time = startMoment.tz(timeZone).format("h:mmA") + " - " + endMoment.tz(timeZone).format("h:mmA");
	
	        var diffTime = endMoment.tz(timeZone).diff(startMoment.tz(timeZone));
	        var durTime = moment.duration(diffTime);
	
	        var durHours = durTime.hours();
	        var durMin = durTime.minutes();
	
	        duration = "" + (durHours ? durHours + " HR" : "") + (durHours > 1 ? "S" : "") + (durMin && durMin ? " " : "") + (durMin ? durMin + "MIN" : "");
	      } else {
	        time_object.startTime = startMoment.tz(timeZone).format("ddd, MMM DD h:mmA");
	        ret = time_object.startTime;
	
	        time = startMoment.tz(timeZone).format("h:mmA") + " - " + endMoment.tz(timeZone).format("h:mmA");
	
	        var _diffTime = endMoment.tz(timeZone).diff(startMoment.tz(timeZone));
	        var _durTime = moment.duration(_diffTime);
	
	        var _durHours = _durTime.hours();
	        var _durMin = _durTime.minutes();
	
	        duration = "" + (_durHours ? _durHours + " HR" : "") + (_durHours > 1 ? "S" : "") + (_durMin && _durMin ? " " : "") + (_durMin ? _durMin + "MIN" : "");
	        rawDuration = _durHours + _durMin / 60;
	      }
	
	      return {
	        date: ret,
	        time: time,
	        duration: duration,
	        rawDuration: rawDuration
	      };
	    }
	  }, {
	    key: "getJobbleTimeFrameWithTimeZone",
	    value: function getJobbleTimeFrameWithTimeZone(timeInterval, timeZoneId) {
	      var _this = this;
	
	      console.log("getJobbleTimeFrameWithTimeZonegetJobbleTimeFrameWithTimeZonegetJobbleTimeFrameWithTimeZonegetJobbleTimeFrameWithTimeZone");
	      console.dir(timeInterval);
	      var ret = "";
	      var time_object = {};
	      var start = new Date(timeInterval.startTime);
	      var end = new Date(timeInterval.endTime);
	      time_object.startTime = moment(start).tz(timeZoneId).format("MMM DD, hh:mm A");
	      time_object.endTime = moment(end).tz(timeZoneId).format("hh:mm A");
	      ret = time_object.startTime + " - " + time_object.endTime;
	      return ret;
	    }
	  }, {
	    key: "getJobbleTimeFrame",
	    value: function getJobbleTimeFrame(jobble, shift) {
	      console.log("get jobble time frame");
	      console.dir(jobble);
	      console.dir(shift);
	
	      var timeFrame = "";
	
	      if (jobble.startTime) {
	        var start = new Date(jobble.startTime);
	
	        //console.log("this should be seatle time");
	        //console.dir(moment(start).tz(shift.contactInfo.place.timeZoneId).format('YYYY-MM-DD HH:mm'));
	
	        timeFrame = start.toLocaleString("en-us", {
	          month: "short",
	          day: "numeric",
	          hour: "numeric",
	          minute: "numeric"
	        });
	        if (jobble.endTime) {
	          var end = new Date(jobble.endTime);
	          timeFrame += " - ";
	
	          var isSameDay = start.getDate() == end.getDate() && start.getMonth() == end.getMonth() && start.getFullYear() == end.getFullYear();
	
	          if (isSameDay) {
	            timeFrame += end.toLocaleString("en-us", {
	              hour: "numeric",
	              minute: "numeric"
	            });
	          } else {
	            timeFrame += end.toLocaleString("en-us", {
	              month: "short",
	              day: "numeric",
	              hour: "numeric",
	              minute: "numeric"
	            });
	          }
	        }
	      } else {
	        if (jobble.startTimeFormattedLoc) {
	          var _start = new Date(jobble.startTimeFormattedLoc);
	          timeFrame = _start.toLocaleString("en-us", {
	            month: "short",
	            day: "numeric",
	            hour: "numeric",
	            minute: "numeric"
	          });
	          if (jobble.endTimeFormattedLoc) {
	            var _end = new Date(jobble.endTimeFormattedLoc);
	            timeFrame += " - ";
	
	            var _isSameDay = _start.getDate() == _end.getDate() && _start.getMonth() == _end.getMonth() && _start.getFullYear() == _end.getFullYear();
	
	            if (_isSameDay) {
	              timeFrame += _end.toLocaleString("en-us", {
	                hour: "numeric",
	                minute: "numeric"
	              });
	            } else {
	              timeFrame += _end.toLocaleString("en-us", {
	                month: "short",
	                day: "numeric",
	                hour: "numeric",
	                minute: "numeric"
	              });
	            }
	          }
	        }
	      }
	      return timeFrame;
	    }
	  }, {
	    key: "getSurveyQuestions",
	    value: function getSurveyQuestions(id, user) {
	      var _this = this;
	
	      console.log("what is  _this.$localStorage");
	      console.dir(_this.$localStorage);
	
	      if (user) {
	        _this.$localStorage.logged_user = user;
	      }
	
	      var req = {
	        method: "GET",
	        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + id + "?format=json&fields=id,subEvent.event.surveyQuestions.id,subEvent.event.surveyQuestions.name,subEvent.event.surveyQuestions.question,subEvent.event.surveyQuestions.displayOrder",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	        },
	        data: {}
	      };
	
	      return _this.$http(req);
	    }
	  }, {
	    key: "applyToJob",
	    value: function applyToJob(questions, id, user_not_verified, user) {
	      var _this = this;
	
	      _this.$localStorage.logged_user = user;
	
	      var array = [];
	      var application = { spiel: "I am a good worker." };
	      var not_verified = false;
	
	      if (user_not_verified) {
	        not_verified = true;
	      }
	
	      application.surveyResponses = [];
	
	      try {
	        if (questions[0].isStandard) {
	          console.log("we have broken questions");
	        } else {
	          questions.forEach(function (question) {
	            var object = {};
	
	            object.response = "I am a good fit.";
	            object.surveyQuestion = question.id;
	
	            application.surveyResponses.push(object);
	          });
	        }
	      } finally {
	        var req = {
	          method: "POST",
	          data: {
	            application: application,
	            verified: not_verified
	          },
	          url: _this.$env.getAPIEndPoint() + "jbl/v1/users/" + _this.$localStorage.logged_user.id + "/jobbles/" + id + "/apply?format=json&conf=web&fields=id",
	          headers: {
	            "Content-Type": "application/json",
	            Authorization: "Bearer " + _this.$localStorage.logged_user.access_token
	          }
	        };
	
	        return _this.$http(req);
	      }
	    }
	  }, {
	    key: "canUserApplyToShiftBasedJobs",
	    value: function canUserApplyToShiftBasedJobs() {
	      console.log("Checking is user is validated");
	
	      var req = {
	        method: "GET",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&conf=web",
	        headers: {
	          Authorization: "Bearer " + (this.$localStorage.logged_user ? this.$localStorage.logged_user.access_token : "")
	        },
	        data: {}
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "organizeTypes",
	    value: function organizeTypes(jobble_type_parents, jobble_types) {
	      var _this = this;
	      var events_array = [];
	      var industrial_array = [];
	      var rh_array = [];
	      var retail_array = [];
	      var trans_array = [];
	      var other_array = [];
	      var categories = {
	        events: null,
	        light_industrial: null,
	        restaurant: null,
	        retail: null,
	        transportation: null,
	        other: null
	      };
	      try {
	        jobble_types.forEach(function (type, i) {
	          var name = type.name;
	          if (name === "Promotional Model") {
	            events_array.push(type);
	          } else if (name === "Brand Ambassador") {
	            events_array.push(type);
	          } else if (name === "Audio/Video Support") {
	            events_array.push(type);
	          } else if (name === "College Ambassador") {
	            events_array.push(type);
	          } else if (name === "Demo Specialist") {
	            events_array.push(type);
	          } else if (name === "Event Staff") {
	            events_array.push(type);
	          } else if (name === "Field Sales") {
	            events_array.push(type);
	          } else if (name === "Focus Group Participant") {
	            events_array.push(type);
	          } else if (name === "Greeter") {
	            events_array.push(type);
	            rh_array.push(type);
	            retail_array.push(type);
	          } else if (name === "Hair/Makeup Artist") {
	            events_array.push(type);
	          } else if (name === "Merchandising") {
	            events_array.push(type);
	            retail_array.push(type);
	          } else if (name === "Nightlife Promotor") {
	            events_array.push(type);
	          } else if (name === "Parking Attendant") {
	            events_array.push(type);
	            rh_array.push(type);
	            other_array.push(type);
	          } else if (name === "Photographer") {
	            events_array.push(type);
	          } else if (name === "Product Demonstrator") {
	            events_array.push(type);
	          } else if (name === "Product Sampler") {
	            events_array.push(type);
	          } else if (name === "Referee") {
	            events_array.push(type);
	          } else if (name === "Registration") {
	            events_array.push(type);
	          } else if (name === "Setup and Breakdown Staff") {
	            events_array.push(type);
	          } else if (name === "Street Teamer") {
	            events_array.push(type);
	          } else if (name === "Surveyor") {
	            events_array.push(type);
	          } else if (name === "Tradeshow Staff") {
	            events_array.push(type);
	          } else if (name === "Usher") {
	            events_array.push(type);
	          } else if (name === "Assembler") {
	            events_array.push(type);
	          } else if (name === "Usher") {
	            events_array.push(type);
	          } else if (name === "Assembler") {
	            industrial_array.push(type);
	          } else if (name === "Fork Lift Operator") {
	            industrial_array.push(type);
	          } else if (name === "Laborer") {
	            industrial_array.push(type);
	            events_array.push(type);
	          } else if (name === "Landscaper") {
	            industrial_array.push(type);
	          } else if (name === "Light Industrial") {
	            industrial_array.push(type);
	          } else if (name === "Material Handler") {
	            industrial_array.push(type);
	          } else if (name === "Mover/Packer") {
	            industrial_array.push(type);
	          } else if (name === "Night Shift") {
	            other_array.push(type);
	            industrial_array.push(type);
	          } else if (name === "Picker/Packer") {
	            industrial_array.push(type);
	          } else if (name === "Shipping/Receiving") {
	            industrial_array.push(type);
	          } else if (name === "Skilled Trade") {
	            industrial_array.push(type);
	          } else if (name === "Stocker") {
	            industrial_array.push(type);
	            retail_array.push(type);
	          } else if (name === "Warehouse") {
	            events_array.push(type);
	          } else if (name === "Admin/Clerical") {
	            other_array.push(type);
	          } else if (name === "Beta Tester") {
	            other_array.push(type);
	          } else if (name === "Call Center") {
	            other_array.push(type);
	          } else if (name === "Contractor") {
	            other_array.push(type);
	          } else if (name === "Customer Service") {
	            other_array.push(type);
	          } else if (name === "Interview session") {
	            other_array.push(type);
	          } else if (name === "Life Guard") {
	            other_array.push(type);
	          } else if (name === "Medical") {
	            other_array.push(type);
	          } else if (name === "Other") {
	            other_array.push(type);
	          } else if (name === "Part Time") {
	            other_array.push(type);
	          } else if (name === "Technical") {
	            other_array.push(type);
	          } else if (name === "Training") {
	            other_array.push(type);
	          } else if (name === "Videographer") {
	            other_array.push(type);
	          } else if (name === "Bartender") {
	            rh_array.push(type);
	          } else if (name === "Catering/Service Staff") {
	            rh_array.push(type);
	            events_array.push(type);
	          } else if (name === "Dishwasher") {
	            rh_array.push(type);
	          } else if (name === "Facility Staff") {
	            rh_array.push(type);
	            industrial_array.push(type);
	          } else if (name === "Food Service Staff") {
	            rh_array.push(type);
	          } else if (name === "Hospitality") {
	            rh_array.push(type);
	          } else if (name === "Host/Hostesses") {
	            rh_array.push(type);
	          } else if (name === "Housekeeping") {
	            rh_array.push(type);
	          } else if (name === "Janitorial Staff") {
	            rh_array.push(type);
	          } else if (name === "Line Cooks") {
	            rh_array.push(type);
	          } else if (name === "Restaurant Staff") {
	            rh_array.push(type);
	          } else if (name === "Runner") {
	            rh_array.push(type);
	          } else if (name === "Security") {
	            rh_array.push(type);
	            events_array.push(type);
	            retail_array.push(type);
	          } else if (name === "Servers") {
	            rh_array.push(type);
	          } else if (name === "Waiter/Waitress") {
	            rh_array.push(type);
	            events_array.push(type);
	          } else if (name === "Cashier") {
	            retail_array.push(type);
	          } else if (name === "Retail Staff") {
	            retail_array.push(type);
	          } else if (name === "Seasonal Staff") {
	            retail_array.push(type);
	          } else if (name === "Trucking") {
	            trans_array.push(type);
	          } else if (name === "Delivery") {
	            trans_array.push(type);
	          } else if (name === "Driver") {
	            trans_array.push(type);
	          } else {
	            if (name !== "Transportation" && name !== "Other" && name !== "Retail") {
	              other_array.push(type);
	            }
	          }
	        });
	      } catch (err) {
	        console.log("error processing jobs");
	        //console.dir(err);
	      } finally {
	        categories.events = events_array;
	        categories.light_industrial = industrial_array;
	        categories.restaurant = rh_array;
	        categories.retail = retail_array;
	        categories.transportation = trans_array;
	        categories.other = other_array;
	        return categories;
	      }
	    }
	  }, {
	    key: "setPartnersPostsInteraction",
	    value: function setPartnersPostsInteraction(job) {
	      var payload = {};
	      payload.interactionType = "CLICK_APPLY";
	      payload.postId = job.id;
	      payload.postUrl = job.partnerPostContent.url;
	      payload.feedName = job.partnerPostContent.nameOfFeed;
	      if (job.partnerPostContent.cpa) {
	        payload.cpa = job.partnerPostContent.cpa;
	      }
	      if (job.partnerPostContent.cpc) {
	        payload.cpc = job.partnerPostContent.cpc;
	      }
	      payload.jobCompany = job.partnerPostContent.company;
	      payload.jobTitle = job.partnerPostContent.title;
	      payload.jobCategory = job.partnerPostContent.category;
	      payload.zipCode = job.partnerPostContent.zip;
	
	      var logged_user = this.$localStorage.logged_user || {};
	
	      var req = {
	        method: "POST",
	        url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + logged_user.id + "/partners-posts/interaction?format=json&conf=web",
	        headers: {
	          "Content-Type": "application/json",
	          Authorization: "Bearer " + logged_user.access_token
	        },
	        data: payload
	      };
	
	      return this.$http(req);
	    }
	  }, {
	    key: "milesToKilometers",
	    value: function milesToKilometers(miles) {
	      console.log("milesToKilometers");
	      console.dir(miles);
	      console.dir(miles * 1.60934);
	      return miles * 1.60934;
	    }
	  }, {
	    key: "kilometersToMiles",
	    value: function kilometersToMiles(kilometers) {
	      return kilometers * 0.621371;
	    }
	  }, {
	    key: "processJob",
	    value: function processJob(job) {
	      if (!job) return { error: null, job: job };
	
	      if (job.partnerPostContent) {
	        return this.processPartnerJob(job);
	      } else {
	        if (job.company) {
	          job.companyName = job.company.name;
	
	          if (_.isEmpty(job.company.fileCOMPANY_LOGO1IMG_160x160)) {
	            job.companyLogo = "/app/vendor/images/events_placeholder_jobble.png";
	          } else {
	            job.companyLogo = job.company.fileCOMPANY_LOGO1IMG_160x160;
	          }
	        } else {
	          if (job.subEvent.event.companyName) {
	            job.companyName = job.subEvent.event.companyName;
	          } else {
	            job.companyName = job.subEvent.event.company.name;
	            if (_.isEmpty(job.subEvent.event.company.companyLogoUriFree)) {
	              job.companyLogo = "/app/vendor/images/events_placeholder_jobble.png";
	            } else {
	              job.companyLogo = job.subEvent.event.company.companyLogoUriFree;
	            }
	          }
	        }
	
	        job.jobbleTimeFrame = this.getJobbleTimeFrameWithTimeZoneForBoard(job);
	        job.jobbleFullTimeFrame = this.getJobbleFullTimeFrameWithTimeZoneForBoard(job).date;
	        job.jobbleHours = this.getJobbleFullTimeFrameWithTimeZoneForBoard(job).time;
	        job.jobbleDuration = this.getJobbleFullTimeFrameWithTimeZoneForBoard(job).duration;
	        job.rawDuration = this.getJobbleFullTimeFrameWithTimeZoneForBoard(job).rawDuration;
	
	        job.applyTimeFrame = this.getApplyTimeFrame(job);
	
	        var timeZone = void 0;
	        if (job.contactInfo) {
	          timeZone = job.contactInfo.place.timeZoneId;
	        } else {
	          timeZone = job.subEvent.contactInfo.place.timeZoneId;
	        }
	
	        if (timeZone === "Pacific/Honolulu") {
	          job.startDate = new Date(job.startTime);
	          job.endDate = new Date(job.endTime);
	        } else {
	          job.startDate = new Date(job.startTimeFormattedLoc);
	          job.endDate = new Date(job.endTimeFormattedLoc);
	        }
	
	        var momentDateCreated = moment(job.dateCreated).format();
	        //job.isHiredOrApplied = this.checkForApplicationStatus(job.applicationStatus);
	
	        job.daysAgoPosted = Math.round((new Date() - new Date(momentDateCreated)) / (1000 * 60 * 60 * 24));
	        job.numberofDays = Math.round((job.endDate - job.startDate) / (1000 * 60 * 60 * 24));
	
	        job.daysAgoPostedText = job.daysAgoPosted === 0 ? "Today" : job.daysAgoPosted === 1 ? "Yesterday" : job.daysAgoPosted + " days Ago";
	
	        return { error: null, job: job };
	      }
	    }
	  }, {
	    key: "checkForApplicationStatus",
	    value: function checkForApplicationStatus(applicationStatus) {
	      var status = "";
	
	      if (applicationStatus === "PENDING") {
	        status = "Applied";
	      } else if (applicationStatus === "ACCEPTED") {
	        status = "Hired";
	      } else {
	        status = null;
	      }
	
	      return status;
	    }
	  }, {
	    key: "processPartnerJob",
	    value: function processPartnerJob(job) {
	      if (!job) return { error: null, job: job };
	
	      var regex = /^\s*(?:<br\s*\/?\s*>)+|(?:<br\s*\/?\s*>)+\s*$/gi;
	
	      try {
	        var partner_post_data = job.partnerPostContent;
	        job.is_partner_post = true;
	        job.companyName = partner_post_data.company;
	        if (partner_post_data.companyLogo) {
	          job.companyLogo = partner_post_data.companyLogo;
	        } else {
	          job.companyLogo = "/app/vendor/images/events_placeholder_jobble.png";
	        }
	
	        job.jobbleTypeName = job.jobbleType.name;
	
	        job.eventName = partner_post_data.title;
	        job.city = partner_post_data.city;
	        job.state = partner_post_data.state;
	        if (partner_post_data.posted_at) {
	          job.date = partner_post_data.posted_at;
	        } else if (partner_post_data.posted_date) {
	          job.date = partner_post_data.posted_date;
	        } else {
	          job.date = moment().format();
	        }
	
	        job.url = partner_post_data.cm_url || partner_post_data.url;
	
	        if (job.url && this.$location && this.$location.$$search) {
	          var externalJPub = this.$location.$$search.jpub;
	
	          var prefix = job.url.indexOf("?") !== -1 ? "&" : "?";
	
	          if (externalJPub) {
	            job.url = "" + job.url + prefix + "&jparent=2";
	          } else {
	            job.url = "" + job.url + prefix;
	          }
	        }
	
	        job.daysAgoPosted = Math.round((new Date() - new Date(job.date)) / (1000 * 60 * 60 * 24));
	
	        job.daysAgoPostedText = job.daysAgoPosted === 0 ? "Today" : job.daysAgoPosted === 1 ? "Yesterday" : job.daysAgoPosted + " days Ago";
	
	        // Check to see if there is HTML in the partner post description by matching tags
	        if (/<[a-z][\s\S]*>/i.test(partner_post_data.body) === false) {
	          job.job_details_no_html = partner_post_data.body;
	          job.no_html_desc = true;
	        } else {
	          partner_post_data.body = partner_post_data.body.replace(regex, "");
	          job.job_parsed_html = partner_post_data.body;
	        }
	
	        return { error: null, job: job };
	      } catch (err) {
	        return { error: err, job: job };
	      }
	    }
	  }, {
	    key: "awaitForGoogleToLoad",
	    value: function awaitForGoogleToLoad() {
	      var _this2 = this;
	
	      var count = 0;
	      return new Promise(function (resolve, reject) {
	        if (!_angular2.default.isUndefined(window.google)) return resolve();
	
	        _this2.googleLoad = _this2.$interval(function () {
	          count = count = 1;
	          console.warn("Trying to load google", count);
	          if (!_angular2.default.isUndefined(window.google) || count > 5) {
	            resolve();
	            _this2.$interval.cancel(_this2.googleLoad);
	            _this2.googleLoad = undefined;
	          }
	        }, 500);
	      });
	    }
	  }]);
	
	  return JobService;
	}();
	
	exports.default = JobService;
	
	
	JobService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "env", "$rootScope", "$timeout", "$interval", "$location"];

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _email = __webpack_require__(728);
	
	var _email2 = _interopRequireDefault(_email);
	
	var _password = __webpack_require__(729);
	
	var _password2 = _interopRequireDefault(_password);
	
	var _phone = __webpack_require__(730);
	
	var _phone2 = _interopRequireDefault(_phone);
	
	var _common = __webpack_require__(128);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _creditCard = __webpack_require__(126);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	var _zip = __webpack_require__(594);
	
	var _zip2 = _interopRequireDefault(_zip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Index = function Index() {
	  _classCallCheck(this, Index);
	
	  this.EmailValidator = _email2.default;
	  this.PasswordValidator = _password2.default;
	  this.PhoneValidator = _phone2.default;
	  this.CommonValidator = _common2.default;
	  this.CreditCardValidator = _creditCard2.default;
	  this.ZipValidator = _zip2.default;
	
	  this.Errors = {
	    EMAIL_ERRORS: _email.EMAIL_ERRORS,
	    PASSWORD_ERRORS: _password.PASSWORD_ERRORS,
	    PHONE_ERRORS: _phone.PHONE_ERRORS,
	    COMMON_ERRORS: _common.COMMON_ERRORS,
	    CREDIT_CARD_MESSAGES: _creditCard.CREDIT_CARD_MESSAGES,
	    ZIP_ERROR_MESSAGES: _zip.ZIP_ERROR_MESSAGES
	  };
	};
	
	exports.default = Index;

/***/ }),
/* 728 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _EMAIL_ERROR_MESSAGES;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Define Error Prefix
	var EMAIL_PREFIX = 1010;
	
	// Define Error Codes
	var MISSING_EMAIL = EMAIL_PREFIX + 1;
	var BAD_EMAIL = EMAIL_PREFIX + 2;
	
	// Public Error Codes
	var EMAIL_ERRORS = exports.EMAIL_ERRORS = {
	  MISSING_EMAIL: MISSING_EMAIL,
	  BAD_EMAIL: BAD_EMAIL
	};
	
	// Corresponding Error Messages
	var EMAIL_ERROR_MESSAGES = exports.EMAIL_ERROR_MESSAGES = (_EMAIL_ERROR_MESSAGES = {}, _defineProperty(_EMAIL_ERROR_MESSAGES, MISSING_EMAIL, "Email is required."), _defineProperty(_EMAIL_ERROR_MESSAGES, BAD_EMAIL, "Invalid Email."), _EMAIL_ERROR_MESSAGES);
	
	var EmailValidator = function () {
	  function EmailValidator() {
	    _classCallCheck(this, EmailValidator);
	  }
	
	  _createClass(EmailValidator, null, [{
	    key: "validateEmail",
	    value: function validateEmail(email) {
	      var errors = [];
	
	      // Missing Email
	      if (!email || !(email.length > 0)) {
	        errors.push(MISSING_EMAIL);
	        return {
	          isValid: !errors.length,
	          errors: errors
	        };
	      }
	
	      // Valid Email By Regex (See Below)
	      if (!EMAILREGEX.test(email)) {
	        errors.push(BAD_EMAIL);
	      }
	
	      return {
	        isValid: !errors.length,
	        errors: errors
	      };
	    }
	  }, {
	    key: "constructErrorMessage",
	    value: function constructErrorMessage(errors) {
	      var message = [];
	
	      errors.forEach(function (error) {
	        message.push(EMAIL_ERROR_MESSAGES[error]);
	      });
	
	      return message.join(" ");
	    }
	  }]);
	
	  return EmailValidator;
	}();
	
	exports.default = EmailValidator;
	
	
	var EMAILREGEX = /^([!#$%&*+-\/=?^`'|{}~\w_.]{1,64}?)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _PASSWORD_ERROR_MESSA;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Define Error Prefix
	var PASSWORD_PREFIX = 1000;
	
	// Define Error Codes
	var MISSING_PASSWORD = PASSWORD_PREFIX + 1;
	var SHORT_PASSWORD = PASSWORD_PREFIX + 2;
	var MISSING_NUMBER = PASSWORD_PREFIX + 3;
	var MISSING_LETTER = PASSWORD_PREFIX + 4;
	
	// Public Error Codes
	var PASSWORD_ERRORS = exports.PASSWORD_ERRORS = {
	  MISSING_PASSWORD: MISSING_PASSWORD,
	  SHORT_PASSWORD: SHORT_PASSWORD,
	  MISSING_NUMBER: MISSING_NUMBER,
	  MISSING_LETTER: MISSING_LETTER
	};
	
	// Corresponding Error Messages
	var PASSWORD_ERROR_MESSAGES = exports.PASSWORD_ERROR_MESSAGES = (_PASSWORD_ERROR_MESSA = {}, _defineProperty(_PASSWORD_ERROR_MESSA, MISSING_PASSWORD, "Password Required."), _defineProperty(_PASSWORD_ERROR_MESSA, SHORT_PASSWORD, "At least 8 characters are required."), _defineProperty(_PASSWORD_ERROR_MESSA, MISSING_NUMBER, "You must include at least 1 number."), _defineProperty(_PASSWORD_ERROR_MESSA, MISSING_LETTER, "You must include at least 1 letter."), _PASSWORD_ERROR_MESSA);
	
	var MIN_LENGTH = 8;
	
	var PasswordValidator = function () {
	  function PasswordValidator() {
	    _classCallCheck(this, PasswordValidator);
	  }
	
	  _createClass(PasswordValidator, null, [{
	    key: "validatePassword",
	    value: function validatePassword(password) {
	      var errors = [];
	
	      // Password Length
	      if (!password || !(password.length >= MIN_LENGTH)) {
	        errors.push(SHORT_PASSWORD);
	      }
	
	      // Contains digits
	      if (!/\d/.test(password)) {
	        errors.push(MISSING_NUMBER);
	      }
	
	      // Contains letter
	      if (!/[A-Za-z]+/.test(password)) {
	        errors.push(MISSING_LETTER);
	      }
	
	      return {
	        isValid: !errors.length,
	        errors: errors
	      };
	    }
	  }, {
	    key: "constructErrorMessage",
	    value: function constructErrorMessage(errors) {
	      var message = [];
	
	      errors.forEach(function (error) {
	        message.push(PASSWORD_ERROR_MESSAGES[error]);
	      });
	
	      return message.join(" ");
	    }
	  }, {
	    key: "getErrorMessage",
	    value: function getErrorMessage(error) {
	      return PASSWORD_ERROR_MESSAGES[error];
	    }
	  }]);
	
	  return PasswordValidator;
	}();
	
	exports.default = PasswordValidator;

/***/ }),
/* 730 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _PHONE_ERROR_MESSAGES;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Define Error Prefix
	var PHONE_PREFIX = 1020;
	
	// Define Error Codes
	var MISSING_PHONE = PHONE_PREFIX + 1;
	var SHORT_PHONE = PHONE_PREFIX + 2;
	var INVALID_PHONE = PHONE_PREFIX + 3;
	
	// Public Error Codes
	var PHONE_ERRORS = exports.PHONE_ERRORS = {
	  MISSING_PHONE: MISSING_PHONE,
	  SHORT_PHONE: SHORT_PHONE,
	  INVALID_PHONE: INVALID_PHONE
	};
	
	// Corresponding Error Messages
	var PHONE_ERROR_MESSAGES = exports.PHONE_ERROR_MESSAGES = (_PHONE_ERROR_MESSAGES = {}, _defineProperty(_PHONE_ERROR_MESSAGES, MISSING_PHONE, "Phone Required."), _defineProperty(_PHONE_ERROR_MESSAGES, SHORT_PHONE, "Phone number must be 10 digits."), _defineProperty(_PHONE_ERROR_MESSAGES, INVALID_PHONE, "Please enter a 10 digit phone number."), _PHONE_ERROR_MESSAGES);
	
	var PhoneValidator = function () {
	  function PhoneValidator() {
	    _classCallCheck(this, PhoneValidator);
	  }
	
	  _createClass(PhoneValidator, null, [{
	    key: "validatePhone",
	    value: function validatePhone(phone) {
	      var errors = [];
	
	      // Short Phone
	      if (!phone) {
	        errors.push(MISSING_PHONE);
	      }
	
	      // Validate PHone By Regex
	      if (!PHONEREGEX.test(phone)) {
	        errors.push(INVALID_PHONE);
	      }
	
	      return {
	        isValid: !errors.length,
	        errors: errors
	      };
	    }
	  }, {
	    key: "constructErrorMessage",
	    value: function constructErrorMessage(errors) {
	      var message = [];
	
	      errors.forEach(function (error) {
	        message.push(PHONE_ERROR_MESSAGES[error]);
	      });
	
	      return message.join(" ");
	    }
	  }]);
	
	  return PhoneValidator;
	}();
	
	exports.default = PhoneValidator;
	
	
	var PHONEREGEX = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;

/***/ }),
/* 731 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BranchIoService = function () {
	  function BranchIoService($http, env, AuthService, $timeout, $window) {
	    var _this = this;
	
	    _classCallCheck(this, BranchIoService);
	
	    this.$http = $http;
	    this.$env = env;
	    this.$auth = AuthService;
	    this.$timeout = $timeout;
	    this.$window = $window;
	
	    var key = this.$env.EnvironmentConfig.branchio_api_key;
	
	    this.init = false;
	
	    branch.init(key, function (err, data) {
	      console.log("branch", err, data);
	      _this.init = true;
	    });
	  }
	
	  _createClass(BranchIoService, [{
	    key: "createLink",
	    value: function createLink(jobbleId, title) {
	      var origin = this.getOrigin();
	      console.log("Branch IO Origin: " + origin);
	
	      var linkData = {
	        title: title,
	        channel: "email",
	        feature: "web_job_share",
	        data: {
	          jobbleId: jobbleId,
	          $desktop_url: origin + "/job/" + jobbleId,
	          $og_title: title
	        }
	      };
	
	      return new Promise(function (resolve, reject) {
	        branch.link(linkData, function (err, link) {
	          console.log("branch link generated", link);
	          resolve(link);
	        });
	      });
	    }
	  }, {
	    key: "getOrigin",
	    value: function getOrigin() {
	      var origin = this.$window.location.origin;
	
	      if (origin.indexOf("localhost") !== -1) {
	        if (this.$env.EnvironmentConfig.api.indexOf("api-qa") !== -1) {
	          origin = "https://app-qa.int.jobbleapp.com";
	        } else if (this.$env.EnvironmentConfig.api.indexOf("api-eb") !== -1) {
	          origin = "https://app.jobble.com";
	        } else if (this.$env.EnvironmentConfig.api.indexOf("api.alef.") !== -1) {
	          origin = "https://app.alef.jobbleapp.com";
	        } else {
	          origin = "https://app.jobble.com";
	        }
	      }
	
	      return origin;
	    }
	  }, {
	    key: "createLinks",
	    value: function createLinks(jobbleId, title, company, partner_url) {
	      var origin = this.getOrigin();
	      console.log("Branch IO Origin: " + origin);
	
	      var linkData = {
	        title: title,
	        channel: "email",
	        feature: "web_job_share",
	        data: {
	          jobbleId: jobbleId,
	          partner_url: partner_url,
	          $deeplink_path: "job?id=" + jobbleId,
	          $desktop_url: origin + "/job/" + jobbleId,
	          $og_title: title,
	          $og_description: company
	        }
	      };
	
	      var channels = ["email", "facebook", "twitter", "linkedin"];
	
	      var promises = channels.map(function (channel) {
	        return new Promise(function (resolve, reject) {
	          var data = JSON.parse(JSON.stringify(linkData));
	          data.channel = channel;
	          branch.link(data, function (err, link) {
	            console.log("branch link generated", link, data);
	            resolve(link);
	          });
	        });
	      });
	
	      return Promise.all(promises).then(function (links) {
	        var data = {};
	
	        for (var i = 0; i < channels.length; i++) {
	          data[channels[i]] = links[i];
	        }
	
	        return data;
	      });
	    }
	  }]);
	
	  return BranchIoService;
	}();
	
	exports.default = BranchIoService;
	
	
	BranchIoService.$inject = ["$http", "env", "auth", "$timeout", "$window"];

/***/ }),
/* 732 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AnalyticsService = function () {
	  function AnalyticsService($http) {
	    _classCallCheck(this, AnalyticsService);
	
	    this.$http = $http;
	
	    this.propel_cm_click_link = "https://tracking.propelmedia.com/?id=1GAEF0G9B26G4E79CF4F&value=0&token={token}";
	    this.propel_view_job_details_link = "https://tracking.propelmedia.com/?id=1GAEF0G9B04G104FB3D7&value=0&token={token}";
	    this.propel_token = this.getUrlParameter("token") || localStorage["propel_token"] || null;
	
	    if (this.propel_token) {
	      this.propel_token = this.propel_token.replace("{", "");
	      this.propel_token = this.propel_token.replace("}", "");
	
	      localStorage["propel_token"] = this.propel_token;
	    }
	
	    console.log("Loaded Propel Token:", this.propel_token);
	  }
	
	  _createClass(AnalyticsService, [{
	    key: "trackViewJobDetailsPage",
	    value: function trackViewJobDetailsPage(job) {
	      var link = this.propel_view_job_details_link;
	      console.log("Propel: Tracking Job Details Page");
	      this.submitPropelLink(link);
	    }
	  }, {
	    key: "trackClickCMJob",
	    value: function trackClickCMJob(job) {
	      var link = this.propel_cm_click_link;
	      console.log("Propel: Tracking CM job Click");
	      this.submitPropelLink(link);
	    }
	  }, {
	    key: "submitPropelLink",
	    value: function submitPropelLink(link) {
	      if (!this.propel_token) return;
	
	      var url = link.replace("{token}", this.propel_token);
	
	      return this.$http({ method: "GET", url: url }).then(function () {}).catch(function () {});
	    }
	  }, {
	    key: "getUrlParameter",
	    value: function getUrlParameter(name) {
	      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
	      var results = regex.exec(location.search);
	      return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	    }
	  }]);
	
	  return AnalyticsService;
	}();
	
	exports.default = AnalyticsService;
	
	
	AnalyticsService.$inject = ["$http"];

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import range from './range';
	
	exports.default = _angular2.default.module("app.filters", []).filter("dayFilter", function () {
	  return function (input, total) {
	    total = parseInt(total);
	
	    for (var i = 0; i < total; i++) {
	      if (i !== 0 && i % 10 === 0) {
	        input.push(i);
	      }
	    }
	
	    return input;
	  };
	}).filter("rangeFilter", function () {
	  return function (input, total) {
	    total = parseInt(total);
	
	    for (var i = 0; i < total; i++) {
	      input.push(i);
	    }
	    return input;
	  };
	}).filter("rangeFilterFifteen", function () {
	  return function (input, total) {
	    total = parseInt(total);
	
	    for (var i = 0; i < total; i++) {
	      if (i % 15 === 0) {
	        input.push(i);
	      }
	    }
	
	    return input;
	  };
	}).filter("escapeFilter", function () {
	  return function (input) {
	    if (input) {
	      var amp_count = (input.match(/&amp;/g) || []).length;
	      //console.log('input');
	      //console.dir(input);
	      //console.dir(amp_count);
	      try {
	        for (var i = 0; i < amp_count; i++) {
	          input = input.replace(/&amp;/g, "&");
	        }
	      } finally {
	        return input;
	      }
	    }
	  };
	}).filter("parseLink", function ($sce) {
	  var url = /(\b(https?|http):\/\/[A-Z0-9+&@#\/%?=~_|!:,.;-]*[-A-Z0-9+&@#\/%=~_|])/gim;
	  var www = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
	  var email = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
	  var phone = /(^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$)/gim;
	
	  return function (text) {
	    if (text.match(url)) {
	      text = text.replace(url, '<a href="$1">$1</a>');
	    }
	    if (text.match(www)) {
	      text = text.replace(www, '$1<a href="http://$2" target="_blank">$2</a>');
	    }
	    if (text.match(email)) {
	      text = text.replace(email, '<a href="mailto:$1">$1</a>');
	    }
	    if (text.match(phone)) {
	      text = text.replace(phone, '<a href="tel:$1">$1</a>');
	    }
	    return $sce.trustAsHtml(text);
	  };
	});

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(3);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module("app.directives", []).directive("googleplace", function () {
	  return {
	    require: "ngModel",
	    scope: {
	      ngModel: "=",
	      details: "=?"
	    },
	    link: function link(scope, element, attrs, model) {
	      var options = {
	        types: ["establishment", "geocode"],
	        componentRestrictions: { country: "USA" }
	      };
	      if (google) {
	        scope.gPlace = new google.maps.places.Autocomplete(element[0], options);
	        google.maps.event.addListener(scope.gPlace, "place_changed", function () {
	          scope.$apply(function () {
	            scope.details = scope.gPlace.getPlace();
	            var addr = scope.details.adr_address;
	            var addr_final = null;
	            if (addr.includes("&#39;")) {
	              addr_final = addr.replace("&#39;", "'");
	            } else {
	              addr_final = addr;
	            }
	            var adrData = {};
	            adrData.adr_address = addr_final;
	            adrData.lat = scope.details.geometry.location.lat();
	            adrData.lng = scope.details.geometry.location.lng();
	            model.$setViewValue(adrData);
	          });
	        });
	      }
	    }
	  };
	}).directive("ngEsc", function () {
	  return function (scope, element, attrs) {
	    element.bind("keydown keypress keyup", function (event) {
	      if (event.which === 27) {
	        scope.$apply(function () {
	          scope.$eval(attrs.ngEsc);
	        });
	        event.preventDefault();
	      }
	    });
	  };
	}).directive("ngPrev", function () {
	  return function (scope, element, attrs) {
	    element.bind("keydown", function (event) {
	      if (event.which === 37) {
	        scope.$apply(function () {
	          scope.$eval(attrs.ngArrow);
	        });
	        event.preventDefault();
	      }
	    });
	  };
	}).directive("ngNext", function () {
	  return function (scope, element, attrs) {
	    element.bind("keydown", function (event) {
	      if (event.which === 37) {
	        scope.$apply(function () {
	          scope.$eval(attrs.ngArrow);
	        });
	        event.preventDefault();
	      }
	    });
	  };
	}).directive("contenteditable", function () {
	  return {
	    require: "ngModel",
	    link: function link(scope, element, attrs, ngModel) {
	      function read() {
	        ngModel.$setViewValue(element.html());
	      }
	
	      ngModel.$render = function () {
	        element.html(ngModel.$viewValue || "");
	      };
	      element.bind("blur keyup change", function () {
	        scope.$apply(read);
	      });
	    }
	  };
	}).directive("ngEnter", function () {
	  return function (scope, element, attrs) {
	    element.bind("keydown keypress", function (event) {
	      if (event.which === 13) {
	        scope.$apply(function () {
	          scope.$eval(attrs.ngEnter);
	        });
	        event.preventDefault();
	      }
	    });
	  };
	}).directive("file", function () {
	  return {
	    require: "ngModel",
	    restrict: "A",
	    link: function link(scope, el, attrs, ngModel) {
	      el.bind("change", function (event) {
	        var files = event.target.files;
	        var file = files[0];
	        ngModel.$setViewValue(file);
	        scope.$apply();
	      });
	    }
	  };
	}).directive("loadscript", function () {
	  return function (scope, element, attrs) {
	    _angular2.default.element('<script src="' + scope.vm.fullGoogleUrl + '"></script>').appendTo(element);
	  };
	}).directive("loadtrack", function () {
	  return function (scope, element, attrs) {
	    // REMOVE LOCALYTICS
	    // var val = "<script>+function(l, y, t, i, c, s) { l['LocalyticsGlobal'] = i;l[i] = function() { (l[i].q = l[i].q || []).push(arguments) }; l[i].t = +new Date; (s = y.createElement(t)).type = 'text/javascript';s.src = '//web.localytics.com/v3/localytics.min.js';(c = y.getElementsByTagName(t)[0]).parentNode.insertBefore(s, c);ll( 'init', '" + scope.vm.llkey + "', {} );}(window, document, 'script', 'll');</script>";
	    // angular.element(val).appendTo(element);
	  };
	}).directive("setClassWhenAtTop", function ($window) {
	  var $win = _angular2.default.element($window); // wrap window object as jQuery object
	  return {
	    restrict: "A",
	    link: function link(scope, element, attrs) {
	      var topClass = attrs.setClassWhenAtTop,
	          // get CSS class from directive's attribute value
	      offsetTop = element.offset().top; // get element's offset top relative to document
	      $win.on("scroll", function (e) {
	        var height = Math.max(document.body.scrollHeight, document.body.offsetHeight);
	        if (window.innerHeight + window.pageYOffset >= height) {
	          var path = scope.$parent.vm.$location.$$path;
	          //console.log(window.innerHeight);
	          //console.log(window.pageYOffset);
	          //console.log(height);
	          if (path.includes("jobs")) {
	            //we only want to load more jobs on the jobs page...
	            if (scope.$parent.vm.no_more_jobs_with_this_search === false) {
	              scope.$parent.vm.loadMoreJobsFromBottom();
	            }
	          } else {
	            //were not going to load more jobs on the profile page or
	            //the job details page
	          }
	        }
	        if (topClass === "fix-to-top") {
	          if ($win.scrollTop() >= 556) {
	            element.addClass(topClass);
	          } else {
	            element.removeClass(topClass);
	          }
	        } else if (topClass === "fix-to-top-jobs") {
	          if ($win.scrollTop() >= 217) {
	            element.addClass(topClass);
	          } else {
	            element.removeClass(topClass);
	          }
	        }
	      });
	    }
	  };
	}).directive("preventscroll", function () {
	  return {
	    restrict: "A",
	    link: function link(scope, element, attrs) {
	      element.bind("mousewheel DOMMouseScroll", function (e) {
	        console.log(e);
	        var e0 = e;
	        //var delta = e0.wheelDelta || -e0.detail;
	        var delta = e0.originalEvent.wheelDelta || -e0.detail;
	        scope.scrollTop += (delta < 0 ? 1 : -1) * 30;
	        e.preventDefault();
	      });
	    }
	  };
	}).directive("fileReader", function () {
	  return {
	    scope: {
	      fileReader: "="
	    },
	    link: function link(scope, element) {
	      $(element).on("change", function (changeEvent) {
	        var files = changeEvent.target.files;
	        if (files.length) {
	          var r = new FileReader();
	          r.onload = function (e) {
	            var contents = e.target.result;
	            scope.$apply(function () {
	              console.log("in the apply");
	              console.dir(contents);
	              scope.fileReader = contents;
	            });
	          };
	
	          r.readAsText(files[0]);
	        }
	      });
	    }
	  };
	}).directive("importSheetJs", function ($parse) {
	  return {
	    link: function link($scope, $elm, $attrs) {
	      // Parse callback function from attribute
	      var expressionHandler = $parse($attrs.onSheetLoad);
	
	      // Pass upload event to callback
	      $elm.on("change", function (changeEvent) {
	        var reader = new FileReader();
	        reader.onload = function (e) {
	          expressionHandler($scope, { e: e });
	        };
	        reader.readAsBinaryString(changeEvent.target.files[0]);
	      });
	    }
	  };
	}).directive("fbLogin", function ($rootScope) {
	  return function (scope, iElement, iAttrs) {
	    if (FB) {
	      FB.XFBML.parse(iElement[0]);
	    }
	  };
	}).directive("scroll", function () {
	  return {
	    link: function link(scope, element, attrs) {
	      element.bind("wheel", function () {
	        if (document.activeElement.type === "number" && document.activeElement.classList.contains("noscroll")) {
	          if (document.activeElement.classList.contains("hours-edit-1") || document.activeElement.classList.contains("hours-edit-2") || document.activeElement.classList.contains("hours-edit-3") || document.activeElement.classList.contains("hours-edit-4")) {
	            document.activeElement.blur();
	          } else {
	            document.activeElement.blur();
	          }
	        }
	      });
	    }
	  };
	});

/***/ })
]);


// WEBPACK FOOTER //
// app.bundle.js